
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequirec59a"];
var parcelRegister = parcelRequire.register;
parcelRegister("aZknp", function(module, exports) {

$parcel$export(module.exports, "AppModule", () => $4a9924163b406409$export$1a1a0c518124e6e0);

var $deWeK = parcelRequire("deWeK");
parcelRequire("1uLK9");

var $hgMvT = parcelRequire("hgMvT");

var $anJpe = parcelRequire("anJpe");

var $hlfBx = parcelRequire("hlfBx");

var $gul0M = parcelRequire("gul0M");

var $eWpqu = parcelRequire("eWpqu");

var $gNtKD = parcelRequire("gNtKD");

var $4pri5 = parcelRequire("4pri5");

var $liGXl = parcelRequire("liGXl");

var $72Fza = parcelRequire("72Fza");

var $7KrUD = parcelRequire("7KrUD");

var $6SRrK = parcelRequire("6SRrK");

var $lTT35 = parcelRequire("lTT35");

var $1t8Wn = parcelRequire("1t8Wn");

var $9tLTP = parcelRequire("9tLTP");

var $8kgMp = parcelRequire("8kgMp");

var $gW3jp = parcelRequire("gW3jp");

var $7qDsr = parcelRequire("7qDsr");

var $kawlb = parcelRequire("kawlb");

var $1tJTL = parcelRequire("1tJTL");

var $jh8ya = parcelRequire("jh8ya");
class $4a9924163b406409$export$1a1a0c518124e6e0 {
}

















$4a9924163b406409$export$1a1a0c518124e6e0 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Module)({
        components: [
            (0, $liGXl.NavbarComponent),
            (0, $eWpqu.HomeComponent),
            (0, $gul0M.FooterComponent),
            (0, $gNtKD.LoginComponent),
            (0, $4pri5.SocialComponent),
            (0, $lTT35.SignUpComponent),
            (0, $72Fza.ResetPasswordComponent),
            (0, $7qDsr.LoadingComponent)
        ],
        imports: [
            (0, $9tLTP.HotkeyModule).forRoot(),
            (0, $gW3jp.ReactiveUiModule).forRoot({
                palettes: $6SRrK.palettes
            }),
            (0, $kawlb.SharedModule),
            (0, $hlfBx.CoreModule),
            (0, $8kgMp.RouterModule).forRoot([
                {
                    path: '/',
                    component: (0, $7KrUD.RootComponent),
                    animate: true
                },
                {
                    path: '/about',
                    component: (0, $eWpqu.HomeComponent),
                    animate: true
                },
                {
                    path: '/admin',
                    animate: true,
                    children: ()=>(parcelRequire("etIhS")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/login',
                    component: (0, $gNtKD.LoginComponent)
                },
                {
                    path: '/signup',
                    component: (0, $lTT35.SignUpComponent)
                },
                {
                    path: '/signup/success/:email',
                    component: (0, $jh8ya.SuccessMagicLinkComponent)
                },
                {
                    path: '/ui-components',
                    children: ()=>(parcelRequire("f5zfy"))
                },
                {
                    path: '/roadmap',
                    children: ()=>(parcelRequire("hEGse"))
                },
                {
                    path: '/documentation',
                    children: ()=>(parcelRequire("aCPL8"))
                },
                {
                    path: '/release-notes',
                    children: ()=>(parcelRequire("7o6LG"))
                },
                {
                    path: '/reset-password',
                    component: (0, $72Fza.ResetPasswordComponent)
                },
                {
                    path: '/projects',
                    children: ()=>(parcelRequire("8dAaL")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/profile',
                    children: ()=>(parcelRequire("kaBGH")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/pricing',
                    animate: true,
                    children: ()=>(parcelRequire("cN8SV"))
                },
                {
                    path: '/teams',
                    children: ()=>(parcelRequire("6tvht")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/apps',
                    children: ()=>(parcelRequire("7f9MX")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/auth',
                    children: ()=>(parcelRequire("7IlWR"))
                },
                {
                    path: '/instances',
                    children: ()=>(parcelRequire("fWRpU")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/cards',
                    children: ()=>(parcelRequire("cJHQj")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/iot',
                    children: ()=>(parcelRequire("cEgAf")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/image-view',
                    children: ()=>(parcelRequire("6ydSN")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '/payments',
                    children: ()=>(parcelRequire("3WPCw")),
                    canActivate: (0, $hgMvT.LoggedInGuard)
                },
                {
                    path: '(.*)',
                    animate: true,
                    component: 'not-found-component',
                    action: ()=>(parcelRequire("9VDgZ"))
                }
            ], {
                log: false
            })
        ],
        providers: [
            (0, $anJpe.AppState)
        ],
        bootstrap: [
            (0, $1tJTL.AppComponent)
        ]
    })
], $4a9924163b406409$export$1a1a0c518124e6e0);

});
parcelRegister("1uLK9", function(module, exports) {
"use strict";
var $116da0a0e10dc018$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $116da0a0e10dc018$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $116da0a0e10dc018$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("glP0k");

$116da0a0e10dc018$var$__exportStar((parcelRequire("4kQzY")), module.exports);

$116da0a0e10dc018$var$__exportStar((parcelRequire("bseuG")), module.exports);

$116da0a0e10dc018$var$__exportStar((parcelRequire("l02PL")), module.exports);

});
parcelRegister("glP0k", function(module, exports) {
"use strict";
var $be762bdfda91d7dd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $be762bdfda91d7dd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $be762bdfda91d7dd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$be762bdfda91d7dd$var$__exportStar((parcelRequire("fvunc")), module.exports);

});
parcelRegister("fvunc", function(module, exports) {
"use strict";
var $b4a14fba4053c57f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b4a14fba4053c57f$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $b4a14fba4053c57f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Renderer = void 0;

var $4TeKW = parcelRequire("4TeKW");
function $b4a14fba4053c57f$var$Render(config) {
    return function(cls) {
        if (!window.customElements.get(config.selector)) return (0, $4TeKW.Component)(config)(cls);
    };
}
/**
 * @customElement r-renderer
 */ let $b4a14fba4053c57f$var$Renderer = class Renderer extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.options = {
            state: {},
            render: (res, setState, shadowRoot)=>(0, $4TeKW.html)` ${res} `,
            style: (0, $4TeKW.css)``,
            deepCloneState: false,
            loading: ()=>(0, $4TeKW.html)``,
            error: (e)=>(0, $4TeKW.html)``
        };
        this.loading = true;
        this.error = '';
        this.state = {};
    }
    OnUpdateFirst() {
        return $b4a14fba4053c57f$var$__awaiter(this, void 0, void 0, function*() {
            this.options.state = yield this.options.state;
            if (this.options.state) {
                if (this.isObservable(this.options.state)) this.subscription = this.options.state['subscribe']((detail)=>{
                    this.state = detail;
                    this.loading = false;
                    this.dispatchEvent(new CustomEvent('onData', {
                        detail: detail
                    }));
                }, (error)=>{
                    this.state = null;
                    this.error = error;
                    this.loading = false;
                    this.dispatchEvent(new CustomEvent('onError', {
                        detail: error
                    }));
                });
                else {
                    this.loading = false;
                    this.state = this.options.state;
                }
                yield this.updateComplete;
                yield new Promise(requestAnimationFrame);
                this.dispatchEvent(new CustomEvent('loaded'));
            }
        });
    }
    isObservable(value) {
        return this.isFunction(value.lift) && this.isFunction(value.subscribe);
    }
    isFunction(value) {
        return typeof value === 'function';
    }
    OnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }
    renderContent() {
        if (!this.error && this.options.render) {
            const template = this.options.render(this.options.deepCloneState ? JSON.parse(JSON.stringify(this.state)) : this.state, (state)=>this.state = Object.assign({}, state), this.shadowRoot);
            if (template === null || template === void 0 ? void 0 : template.strings) return template;
            return (0, $4TeKW.html)``;
        }
        return this.state;
    }
};
module.exports.Renderer = $b4a14fba4053c57f$var$Renderer;
$b4a14fba4053c57f$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $b4a14fba4053c57f$var$__metadata("design:type", Object)
], $b4a14fba4053c57f$var$Renderer.prototype, "options", void 0);
$b4a14fba4053c57f$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $b4a14fba4053c57f$var$__metadata("design:type", Object)
], $b4a14fba4053c57f$var$Renderer.prototype, "loading", void 0);
$b4a14fba4053c57f$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $b4a14fba4053c57f$var$__metadata("design:type", Object)
], $b4a14fba4053c57f$var$Renderer.prototype, "error", void 0);
$b4a14fba4053c57f$var$__decorate([
    (0, $4TeKW.property)(),
    $b4a14fba4053c57f$var$__metadata("design:type", Object)
], $b4a14fba4053c57f$var$Renderer.prototype, "state", void 0);
module.exports.Renderer = $b4a14fba4053c57f$var$Renderer = $b4a14fba4053c57f$var$__decorate([
    $b4a14fba4053c57f$var$Render({
        selector: 'r-renderer',
        template () {
            var _a;
            return (0, $4TeKW.html)`
      ${((_a = this.options) === null || _a === void 0 ? void 0 : _a.style) ? (0, $4TeKW.html)`
            <style>
              ${this.options.style}
            </style>
          ` : (0, $4TeKW.html)``}
      ${!this.loading ? this.renderContent() : ''}
      ${this.loading ? (0, $4TeKW.html)`
            ${this.isFunction(this.options.loading) ? this.options.loading() : (0, $4TeKW.html)``}
          ` : ''}
      ${this.error ? (0, $4TeKW.html)`
            ${this.isFunction(this.options.error) ? this.options.error(this.error) : (0, $4TeKW.html)` ${this.error} `}
          ` : ''}
    `;
        }
    })
], $b4a14fba4053c57f$var$Renderer);

});


parcelRegister("4kQzY", function(module, exports) {
"use strict";
var $3281d0d5a15c2de8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3281d0d5a15c2de8$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ForOperator = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement r-for
 */ let $3281d0d5a15c2de8$var$ForOperator = class ForOperator extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.of = [];
    }
    OnUpdate() {
        const slotNodes = this.shadowRoot.querySelector('slot').assignedNodes();
        if (slotNodes.length) {
            const slotNode = slotNodes[0];
            const letOperator = slotNode.nextSibling;
            if (letOperator) letOperator.data = this.of;
        }
    }
};
module.exports.ForOperator = $3281d0d5a15c2de8$var$ForOperator;
$3281d0d5a15c2de8$var$__decorate([
    (0, $4TeKW.property)({
        type: Array
    }),
    $3281d0d5a15c2de8$var$__metadata("design:type", Object)
], $3281d0d5a15c2de8$var$ForOperator.prototype, "of", void 0);
module.exports.ForOperator = $3281d0d5a15c2de8$var$ForOperator = $3281d0d5a15c2de8$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'r-for',
        styles: [
            (0, $4TeKW.css)`
      :host {
        display: none;
      }
    `
        ],
        template () {
            return (0, $4TeKW.html)` <slot></slot> `;
        }
    })
], $3281d0d5a15c2de8$var$ForOperator);

});

parcelRegister("bseuG", function(module, exports) {
"use strict";
var $856d8d6c4c2fccd0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $856d8d6c4c2fccd0$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LetOperator = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement r-let
 */ let $856d8d6c4c2fccd0$var$LetOperator = class LetOperator extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.data = [];
        this.item = (v)=>(0, $4TeKW.html)` ${v} `;
    }
    OnUpdateFirst() {
        if (!this.isObservable(this.data)) this.parentElement.parentNode.insertBefore(this.shadowRoot, this.parentElement.nextSibling);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    normalizeArray(state) {
        if (!state || typeof state === 'string') return [];
        if (typeof state === 'number') return Array.from(Array(state), (v, i)=>i);
        /* https://javascript.info/map-set */ if (state instanceof Map || state instanceof Set) return [
            ...state.entries()
        ];
        if (!Array.isArray(state)) return Object.entries(state);
        return state;
    }
    isObservable(value) {
        return value && this.isFunction(value.lift) && this.isFunction(value.subscribe);
    }
    isFunction(value) {
        return typeof value === 'function';
    }
};
module.exports.LetOperator = $856d8d6c4c2fccd0$var$LetOperator;
$856d8d6c4c2fccd0$var$__decorate([
    (0, $4TeKW.property)({
        type: Array
    }),
    $856d8d6c4c2fccd0$var$__metadata("design:type", Object)
], $856d8d6c4c2fccd0$var$LetOperator.prototype, "data", void 0);
$856d8d6c4c2fccd0$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $856d8d6c4c2fccd0$var$__metadata("design:type", Object)
], $856d8d6c4c2fccd0$var$LetOperator.prototype, "item", void 0);
module.exports.LetOperator = $856d8d6c4c2fccd0$var$LetOperator = $856d8d6c4c2fccd0$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'r-let',
        template () {
            return (0, $4TeKW.html)`
      ${this.isObservable(this.data) ? (0, $4TeKW.html)`
            <r-renderer
              .options=${{
                state: this.data,
                render: (state, set, shadowRoot)=>{
                    this.parentElement.parentNode.insertBefore(shadowRoot, this.parentElement.nextSibling);
                    return (0, $4TeKW.html)`${this.normalizeArray(state).map(this.item)}`;
                }
            }}
            ></r-renderer>
          ` : this.normalizeArray(this.data).map(this.item)}
    `;
        }
    })
], $856d8d6c4c2fccd0$var$LetOperator);

});

parcelRegister("l02PL", function(module, exports) {
"use strict";
var $f49bcbd19cdce23a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f49bcbd19cdce23a$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IfOperator = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement r-if
 */ let $f49bcbd19cdce23a$var$IfOperator = class IfOperator extends $4TeKW.LitElement {
    OnUpdateFirst() {
    // this.parentNode.insertBefore(this.shadowRoot, this.nextSibling);
    }
};
module.exports.IfOperator = $f49bcbd19cdce23a$var$IfOperator;
$f49bcbd19cdce23a$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $f49bcbd19cdce23a$var$__metadata("design:type", Boolean)
], $f49bcbd19cdce23a$var$IfOperator.prototype, "exp", void 0);
module.exports.IfOperator = $f49bcbd19cdce23a$var$IfOperator = $f49bcbd19cdce23a$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'r-if',
        template () {
            return (0, $4TeKW.html)` ${this.exp ? (0, $4TeKW.html)` <slot></slot> ` : ''} `;
        }
    })
], $f49bcbd19cdce23a$var$IfOperator);

});


parcelRegister("hgMvT", function(module, exports) {

$parcel$export(module.exports, "LoggedInGuard", () => $8f699eb9a76712d7$export$ca09e700166a1389);
$parcel$export(module.exports, "IsAdminGuard", () => $8f699eb9a76712d7$export$b73bde6f7a00ee75);

var $deWeK = parcelRequire("deWeK");

var $jM6nT = parcelRequire("jM6nT");

var $be29e = parcelRequire("be29e");

var $1t8Wn = parcelRequire("1t8Wn");

var $cDzby = parcelRequire("cDzby");

var $gawXH = parcelRequire("gawXH");
class $8f699eb9a76712d7$export$ca09e700166a1389 {
    canActivate(context, commands) {
        return this.socialService.checkLoggedIn().pipe((0, $gawXH.map)((e)=>{
            if (!e) return commands.redirect('/unauthorized');
            return true;
        }));
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $8f699eb9a76712d7$export$ca09e700166a1389.prototype, "socialService", void 0);
$8f699eb9a76712d7$export$ca09e700166a1389 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $8f699eb9a76712d7$export$ca09e700166a1389);
class $8f699eb9a76712d7$export$df2084e9c7b71e63 {
    canActivate(context, commands) {
        const params = context['params'] || {};
        return this.projectsService.getProject(params).pipe((0, $gawXH.map)((p)=>{
            if (!p) return commands.redirect('/projects');
            return true;
        }));
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $jM6nT.ProjectsService))
], $8f699eb9a76712d7$export$df2084e9c7b71e63.prototype, "projectsService", void 0);
$8f699eb9a76712d7$export$df2084e9c7b71e63 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $8f699eb9a76712d7$export$df2084e9c7b71e63);
class $8f699eb9a76712d7$export$b73bde6f7a00ee75 {
    canActivate(context, commands) {
        return this.userService.canViewProfileSession().pipe((0, $gawXH.map)((p)=>{
            if (!p) return commands.redirect('/');
            return true;
        }));
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $be29e.UserService))
], $8f699eb9a76712d7$export$b73bde6f7a00ee75.prototype, "userService", void 0);
$8f699eb9a76712d7$export$b73bde6f7a00ee75 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $8f699eb9a76712d7$export$b73bde6f7a00ee75);

});
parcelRegister("jM6nT", function(module, exports) {

$parcel$export(module.exports, "ProjectsService", () => $e3fd5ee03521bcc0$export$52e15361974fd6ce);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $gawXH = parcelRequire("gawXH");

var $7X6iT = parcelRequire("7X6iT");

var $a2ZAi = parcelRequire("a2ZAi");
class $e3fd5ee03521bcc0$export$52e15361974fd6ce extends (0, $7X6iT.BaseGraphqlService) {
    getProject({ id: id }) {
        return this.query({
            query: 'get-project.query.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getProject));
    }
    updateAgentPurpose({ id: id }, agentPurpose) {
        return this.mutate({
            mutation: 'update-agent-purpose.graphql',
            variables: {
                projectId: id,
                agentPurpose: agentPurpose
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.updateAgentPurpose));
    }
    getProjectStatistics({ id: id }) {
        return this.query({
            query: 'get-project.query.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getProjectStatistics));
    }
    getProjectBoards({ id: id }) {
        return this.query({
            query: 'get-project-boards.query.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getProjectBoards));
    }
    getProjectBoardsSimple({ id: id }) {
        return this.query({
            query: 'get-project-boards-simple.query.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getProjectBoards));
    }
    watchProject({ id: id }) {
        return this.watchQuery({
            query: 'get-project.query.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getProject));
    }
    listProjects() {
        return this.watchQuery({
            query: 'list-projects.query.graphql'
        }).pipe((0, $gawXH.map)(({ data: data })=>data.listProjects));
    }
    createProject(variables) {
        return this.mutate({
            mutation: 'create-project.mutation.graphql',
            variables: variables,
            update (proxy, { data: { createProject: createProject } }) {
                const query = (0, $2O1GU.importQuery)('list-projects.query.graphql');
                const cache = (0, $2O1GU.deepCopy)(proxy.readQuery({
                    variables: variables,
                    query: query
                }));
                cache.listProjects = cache.listProjects || [];
                proxy.writeQuery({
                    query: query,
                    data: {
                        listProjects: cache.listProjects.concat([
                            createProject
                        ])
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createProject));
    }
    assignMachineToProject(variables) {
        return this.mutate({
            mutation: 'assign-project-machine.mutation.graphql',
            variables: variables,
            update: (proxy, { data: { assignMachineToProject: assignMachineToProject } })=>(0, $a2ZAi._writeProjectState)(assignMachineToProject)(proxy)
        }).pipe((0, $gawXH.map)((res)=>res.data.assignMachineToProject));
    }
    removeMachineFromProject(variables) {
        return this.mutate({
            mutation: 'remove-project-machine.mutation.graphql',
            variables: variables,
            update: (proxy, { data: { removeMachineFromProject: removeMachineFromProject } })=>(0, $a2ZAi._writeProjectState)(removeMachineFromProject)(proxy)
        }).pipe((0, $gawXH.map)((res)=>res.data.removeMachineFromProject));
    }
    deleteProject({ id: id }) {
        return this.mutate({
            mutation: 'delete-project.mutation.graphql',
            variables: {
                id: id
            },
            update (proxy) {
                const query = (0, $2O1GU.importQuery)('list-projects.query.graphql');
                const cache = (0, $2O1GU.deepCopy)(proxy.readQuery({
                    query: query
                }));
                const listProjects = cache.listProjects.filter((p)=>p.id !== id);
                proxy.writeQuery({
                    query: query,
                    data: {
                        listProjects: listProjects
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteProject));
    }
    subscribeToProjectCreation() {
        return this.subscribe({
            query: 'create-project.subscription.graphql'
        }).pipe((0, $gawXH.map)((res)=>res.data.subscribeToCreateProject));
    }
    listTokens(projectId) {
        return this.query({
            query: 'list-tokens.query.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.listTokens));
    }
    createToken(name, projectId) {
        return this.mutate({
            mutation: 'create-token.mutation.graphql',
            variables: {
                name: name,
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.createToken));
    }
    blackListToken(id, projectId, blacklisted) {
        return this.mutate({
            mutation: 'blacklist-token.mutation.graphql',
            variables: {
                id: id,
                blacklisted: blacklisted,
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.blackListToken));
    }
    deleteToken(id, projectId) {
        return this.mutate({
            mutation: 'delete-token.mutation.graphql',
            variables: {
                id: id,
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.deleteToken));
    }
}
$e3fd5ee03521bcc0$export$52e15361974fd6ce = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $e3fd5ee03521bcc0$export$52e15361974fd6ce);

});
parcelRegister("a2ZAi", function(module, exports) {

$parcel$export(module.exports, "_writeProjectState", () => $a4d6aa2a14e421cd$export$13da96c937795e2e);

var $2O1GU = parcelRequire("2O1GU");
const $a4d6aa2a14e421cd$var$_getProjectQuery = ()=>(0, $2O1GU.importQuery)('get-project.query.graphql');
const $a4d6aa2a14e421cd$export$bdff3ebf79cc7d81 = (id)=>(proxy)=>(0, $2O1GU.deepCopy)(proxy.readQuery({
            query: $a4d6aa2a14e421cd$var$_getProjectQuery(),
            variables: {
                id: id
            }
        }).getProject);
const $a4d6aa2a14e421cd$export$13da96c937795e2e = (getProject)=>(proxy)=>proxy.writeQuery({
            query: $a4d6aa2a14e421cd$var$_getProjectQuery(),
            data: {
                getProject: getProject
            },
            variables: {
                id: getProject.id
            }
        });

});


parcelRegister("be29e", function(module, exports) {

$parcel$export(module.exports, "UserService", () => $e45a6bca6041d1d2$export$a81c579a392aa9d2);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $cDzby = parcelRequire("cDzby");

var $bq6Hs = parcelRequire("bq6Hs");
var $g5fNy = parcelRequire("g5fNy");

var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");
var $lNnaw = parcelRequire("lNnaw");
var $d5Aat = parcelRequire("d5Aat");
var $3dOhR = parcelRequire("3dOhR");

var $7X6iT = parcelRequire("7X6iT");

class $e45a6bca6041d1d2$export$a81c579a392aa9d2 extends (0, $7X6iT.BaseGraphqlService) {
    OnInit() {
        this.userOptions = new (0, $bq6Hs.BehaviorSubject)(this.localStorage.get('user-settings'));
        this.getUserOptions().pipe((0, $6Rz6W.filter)((options)=>!!options?.marmaid), (0, $lNnaw.switchMap)(()=>(parcelRequire("FI3uN")))).subscribe();
    }
    getUserOptions() {
        return this.userOptions.asObservable();
    }
    setUserOptions(options) {
        this.userOptions.next(options);
        this.localStorage.update('user-settings', options);
    }
    canViewProfileSession() {
        return this.getUserOnce().pipe((0, $d5Aat.take)(1), (0, $gawXH.map)((u)=>!!u.scopes?.includes('CAN_VIEW_PROFILE_SESSIONS')));
    }
    setCache(cache) {
        this.cache = cache;
    }
    getUser() {
        return this.socialService.getUser().pipe((0, $gawXH.map)((res)=>res), (0, $3dOhR.tap)((res)=>this.user_id = res.uid), (0, $lNnaw.switchMap)((res)=>this.getUserQuery(res.uid)));
    }
    updateProfile(payload) {
        return this.mutate({
            mutation: 'update-profile.mutation.graphql',
            variables: {
                payload: payload
            }
        });
    }
    generateCustomToken() {
        if (this.customToken) return (0, $g5fNy.of)(this.customToken);
        return this.mutate({
            mutation: 'generate-custom-token.graphql'
        }).pipe((0, $gawXH.map)(({ data: data })=>data.generateCustomToken.token), (0, $3dOhR.tap)((token)=>this.customToken = token));
    }
    getUserById(id) {
        return this.query({
            query: 'get-user-by-id.query.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.getUserById));
    }
    getUserOnce() {
        return this.socialService.getUser().pipe((0, $gawXH.map)((res)=>res.uid), (0, $3dOhR.tap)((id)=>this.user_id = id), (0, $lNnaw.switchMap)(()=>this.query({
                query: 'get-user.query.graphql',
                variables: {
                    user_id: this.user_id
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.me))));
    }
    getUserQuery(user_id) {
        return this.watchQuery({
            query: 'get-user.query.graphql',
            errorPolicy: 'all',
            fetchPolicy: this.cache ? null : 'network-only',
            variables: {
                user_id: user_id
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.me));
    }
    listUsers() {
        return this.query({
            query: 'list-users.graphql'
        }).pipe((0, $gawXH.map)(({ data: data })=>data.listUsers));
    }
    constructor(...args){
        super(...args), this.cache = true;
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $e45a6bca6041d1d2$export$a81c579a392aa9d2.prototype, "socialService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.LocalStorageService))
], $e45a6bca6041d1d2$export$a81c579a392aa9d2.prototype, "localStorage", void 0);
$e45a6bca6041d1d2$export$a81c579a392aa9d2 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $e45a6bca6041d1d2$export$a81c579a392aa9d2);

});
parcelRegister("FI3uN", function(module, exports) {
module.exports = import("OqXvI").then(()=>parcelRequire('lshvg'));

});



parcelRegister("anJpe", function(module, exports) {

$parcel$export(module.exports, "AppState", () => $05174d295835151a$export$a0e153c73743701a);

var $deWeK = parcelRequire("deWeK");

var $9VPSw = parcelRequire("9VPSw");

var $1t8Wn = parcelRequire("1t8Wn");

var $g5fNy = parcelRequire("g5fNy");
var $f16OP = parcelRequire("f16OP");

var $gawXH = parcelRequire("gawXH");

var $6DGJB = parcelRequire("6DGJB");

var $4wABm = parcelRequire("4wABm");

var $f1tXV = parcelRequire("f1tXV");
class $05174d295835151a$export$a0e153c73743701a extends (0, $9VPSw.Store) {
    static{
        this.initialState = (0, $6DGJB.initialState);
    }
    static{
        this.reducer = (0, $4wABm.reducerFn);
    }
    static{
        this.middleware = [
            (0, $f1tXV.history),
            (0, $f1tXV.dbUpdates)
        ];
    }
    static{
        this.destroy$ = new (0, $f16OP.Subject)();
    }
    constructor(){
        super({
            initialState$: (0, $g5fNy.of)($05174d295835151a$export$a0e153c73743701a.initialState),
            reducer$: (0, $g5fNy.of)($05174d295835151a$export$a0e153c73743701a.reducer),
            middleware$: (0, $g5fNy.of)($05174d295835151a$export$a0e153c73743701a.middleware),
            destroy$: $05174d295835151a$export$a0e153c73743701a.destroy$.asObservable()
        });
    }
    destroy() {
        $05174d295835151a$export$a0e153c73743701a.destroy$.next(true);
    }
    select(mapFn) {
        return this.state$.pipe((0, $gawXH.map)(mapFn));
    }
}
$05174d295835151a$export$a0e153c73743701a = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $05174d295835151a$export$a0e153c73743701a);

});
parcelRegister("9VPSw", function(module, exports) {

$parcel$export(module.exports, "Store", () => $73b1adea1614607d$export$390f32400eaf98c9);
$parcel$export(module.exports, "reduceNS", () => $73b1adea1614607d$export$b107054f0adc6183);

var $cdTWx = parcelRequire("cdTWx");
var $7xymH = parcelRequire("7xymH");
var $5JMLH = parcelRequire("5JMLH");
var $8MKp4 = parcelRequire("8MKp4");
var $3N38d = parcelRequire("3N38d");
var $aT99L = parcelRequire("aT99L");
var $g5fNy = parcelRequire("g5fNy");
var $hPrdq = parcelRequire("hPrdq");
var $f16OP = parcelRequire("f16OP");

var $j7eyO = parcelRequire("j7eyO");
var $jMd8a = parcelRequire("jMd8a");
var $1WlcV = parcelRequire("1WlcV");
var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");
var $gD6ig = parcelRequire("gD6ig");
var $lFNui = parcelRequire("lFNui");
var $iUebj = parcelRequire("iUebj");
var $bFKOt = parcelRequire("bFKOt");
var $9wU3T = parcelRequire("9wU3T");
var $lNnaw = parcelRequire("lNnaw");
var $8ZyYf = parcelRequire("8ZyYf");
var $3dOhR = parcelRequire("3dOhR");
var $73b1adea1614607d$export$a2aa3e797def3632;
(function(FlattenOperator) {
    FlattenOperator["switchMap"] = "switchMap";
    FlattenOperator["mergeMap"] = "mergeMap";
    FlattenOperator["concatMap"] = "concatMap";
    FlattenOperator["exhaustMap"] = "exhaustMap";
})($73b1adea1614607d$export$a2aa3e797def3632 || ($73b1adea1614607d$export$a2aa3e797def3632 = {}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function $73b1adea1614607d$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $73b1adea1614607d$var$__spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($73b1adea1614607d$var$__read(arguments[i]));
    return ar;
}
var $73b1adea1614607d$var$isObject = function(value) {
    return value !== null && typeof value === 'object';
};
var $73b1adea1614607d$var$compose = function(fns) {
    return fns.reduce(function(f, g) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return f(g.apply(void 0, $73b1adea1614607d$var$__spread(args)));
        };
    });
};
var $73b1adea1614607d$export$7cc2a9afec49ab22 = (0, $hPrdq.pipe)((0, $j7eyO.catchError)(function(e) {
    return (0, $g5fNy.of)(e);
}));
var $73b1adea1614607d$export$71e6601eaaed0e38 = function(o) {
    return o.pipe($73b1adea1614607d$export$7cc2a9afec49ab22);
};
var $73b1adea1614607d$export$cd0a0b1924c3dead = function(value) {
    if ((0, $8MKp4.isObservable)(value)) return value;
    if (value instanceof Promise) return (0, $5JMLH.from)(value);
    return (0, $g5fNy.of)(value);
};
function $73b1adea1614607d$var$reducerFactory$(_a) {
    var _b = $73b1adea1614607d$var$__read(_a, 3), initialState = _b[0], reducer = _b[1], middleware = _b[2];
    function _reducer(state, action) {
        return middleware.length > 0 ? $73b1adea1614607d$var$compose(middleware)(reducer)(state, action) : reducer(state, action);
    }
    return (0, $lFNui.scan)(_reducer, initialState);
}
var $73b1adea1614607d$var$fop = {
    switchMap: (0, $lNnaw.switchMap),
    mergeMap: (0, $gD6ig.mergeMap),
    concatMap: (0, $jMd8a.concatMap),
    exhaustMap: (0, $1WlcV.exhaustMap)
};
function $73b1adea1614607d$var$getDefaults(config, options, dispatchSubject) {
    if (config === void 0) config = {};
    if (options === void 0) options = {};
    var reducer$ = config && config.reducer$ && config.reducer$.pipe($73b1adea1614607d$export$7cc2a9afec49ab22) || (0, $g5fNy.of)(function(state, action) {
        return state;
    });
    var actions$ = new (0, $f16OP.Subject)();
    var actionStream$ = function(reducer$) {
        return (0, $3N38d.merge)(config && config.actionStream$ && config.actionStream$.pipe($73b1adea1614607d$export$7cc2a9afec49ab22) || (0, $7xymH.EMPTY), dispatchSubject).pipe((0, $6Rz6W.filter)($73b1adea1614607d$var$isObject), (0, $gawXH.map)($73b1adea1614607d$export$cd0a0b1924c3dead), actionFlatten($73b1adea1614607d$export$71e6601eaaed0e38), (0, $3dOhR.tap)(actions$), reducer$, (0, $gawXH.map)($73b1adea1614607d$export$cd0a0b1924c3dead));
    };
    var initialState$ = (config && config.initialState$ && config.initialState$.pipe($73b1adea1614607d$export$7cc2a9afec49ab22) || (0, $g5fNy.of)({})).pipe((0, $iUebj.share)());
    var middleware$ = config && config.middleware$ && config.middleware$.pipe($73b1adea1614607d$export$7cc2a9afec49ab22) || (0, $g5fNy.of)([]);
    var destroy$ = config && config.destroy$ && config.destroy$.pipe($73b1adea1614607d$export$7cc2a9afec49ab22) || (0, $aT99L.NEVER);
    var actionFlatten = $73b1adea1614607d$var$fop[options && options.actionFlatOp || $73b1adea1614607d$export$a2aa3e797def3632.concatMap];
    var stateFlatten = $73b1adea1614607d$var$fop[options && options.stateFlatOp || $73b1adea1614607d$export$a2aa3e797def3632.switchMap];
    var flattenState$ = function(source) {
        return source.pipe(stateFlatten($73b1adea1614607d$export$71e6601eaaed0e38), (0, $gawXH.map)($73b1adea1614607d$export$cd0a0b1924c3dead), stateFlatten($73b1adea1614607d$export$71e6601eaaed0e38));
    };
    var bufferSize = options && options.bufferSize || 1;
    var windowTime = options && options.windowTime;
    var shareReplayConfig = {
        refCount: false,
        bufferSize: bufferSize,
        windowTime: windowTime
    };
    return {
        reducer$: reducer$,
        actions$: actions$,
        actionStream$: actionStream$,
        initialState$: initialState$,
        middleware$: middleware$,
        destroy$: destroy$,
        flattenState$: flattenState$,
        shareReplayConfig: shareReplayConfig
    };
}
/**
 * Reactive state container based on RxJS (https://rxjs.dev/)
 *
 * @class AsyncStore<State, ActionsUnion>
 *
 * @type State - application state interface
 * @type ActionsUnion - type union of all the actions
 */ var $73b1adea1614607d$export$390f32400eaf98c9 = /** @class */ function() {
    /**
     * Default configuration
     *
     * @param {Object} config
     *  {
     *     reducer$: of(reducer({})),
     *     actionStream$: EMPTY, // if not defined, no actions will be dispatched in the store
     *     initialState$: of({}),
     *     middleware$: of([]),
     *     destroy$: NEVER // if not defined, the state subscription will live forever
     *  }
     *
     * @param {Object} options
     *  {
     *     actionFop: FlattenOps.concatMap, // Flatten operator for actions's stream.
     *     stateFop: FlattenOps.switchMap // Flatten operator for state's stream.
     *     windowTime: undefined //Maximum time length of the replay buffer in milliseconds.
     *     bufferSize: 1 //Maximum element count of the replay buffer.
     *  }
     */ function Store(config, options) {
        var _this = this;
        this.config = config;
        this.options = options;
        this._dispatch$ = new (0, $f16OP.Subject)();
        this.dispatch = function(action) {
            _this._dispatch$.next(action);
        };
        var _a = $73b1adea1614607d$var$getDefaults(this.config, this.options, this._dispatch$), reducer$ = _a.reducer$, actions$ = _a.actions$, actionStream$ = _a.actionStream$, middleware$ = _a.middleware$, initialState$ = _a.initialState$, destroy$ = _a.destroy$, flattenState$ = _a.flattenState$, shareReplayConfig = _a.shareReplayConfig;
        this.state$ = (0, $cdTWx.combineLatest)(initialState$, reducer$, middleware$).pipe((0, $gawXH.map)($73b1adea1614607d$var$reducerFactory$), (0, $jMd8a.concatMap)(actionStream$), (0, $9wU3T.startWith)(initialState$), flattenState$, (0, $8ZyYf.takeUntil)(destroy$), (0, $bFKOt.shareReplay)(shareReplayConfig));
        this.state$.subscribe();
        this.actions$ = actions$.pipe((0, $bFKOt.shareReplay)(shareReplayConfig));
    }
    return Store;
}();
function $73b1adea1614607d$export$f51a9068ac82ea43(config, opts) {
    if (config === void 0) config = {};
    if (opts === void 0) opts = {};
    return new $73b1adea1614607d$export$390f32400eaf98c9(config, opts);
}
/**
 *
 * @param mapFn - a function to map a state with
 * @returns {MiddlewareFn} MiddlewareFn<State>
 *
 * PS - previous state
 * NS - next state
 */ var $73b1adea1614607d$export$44fbd99967c9a37a = function(mapFn) {
    return function(reducer) {
        return function(state, Action) {
            return reducer(mapFn(state), Action);
        };
    };
};
var $73b1adea1614607d$export$a84effca781198c = function(mapFn) {
    return function(reducer) {
        return function(state, Action) {
            return mapFn(reducer(state, Action));
        };
    };
};
/**
 *
 * @param mapFn - a function to map an Action with
 * @returns {MiddlewareFn} MiddlewareFn<State, IActionsUnion>
 */ var $73b1adea1614607d$export$b876a215b1634849 = function(mapFn) {
    return function(reducer) {
        return function(state, Action) {
            return reducer(state, mapFn(Action));
        };
    };
};
/**
 *
 * @param filterFn - a function to filter a state with
 * @returns {MiddlewareFn} MiddlewareFn<State>
 *
 * PS - previous state
 * NS - next state
 */ var $73b1adea1614607d$export$2ac9213ba942c0a3 = function(filterFn) {
    return function(reducer) {
        return function(state, Action) {
            return filterFn(state) ? reducer(state, Action) : state;
        };
    };
};
var $73b1adea1614607d$export$29e55cd93f936905 = function(filterFn) {
    return function(reducer) {
        return function(state, Action) {
            var nextState = reducer(state, Action);
            return filterFn(nextState) ? nextState : state;
        };
    };
};
/**
 *
 * @param filterFn - a function to filter an Action with
 * @returns {MiddlewareFn} MiddlewareFn<State, IActionsUnion>
 */ var $73b1adea1614607d$export$e6e803076c284bc5 = function(filterFn) {
    return function(reducer) {
        return function(state, Action) {
            return filterFn(Action) ? reducer(state, Action) : state;
        };
    };
};
/**
 * Reduce into state
 * @param reduceFn - a function to reduce the state and Action together
 * @returns {MiddlewareFn} MiddlewareFn<State, IActionsUnion>
 *
 * PS - previous state
 * NS - next state
 */ var $73b1adea1614607d$export$18b6e7dee03760 = function(reducerFn) {
    return function(reducer) {
        return function(state, Action) {
            return reducer(reducerFn(state, Action), Action);
        };
    };
};
var $73b1adea1614607d$export$b107054f0adc6183 = function(reducerFn) {
    return function(reducer) {
        return function(state, Action) {
            return reducerFn(reducer(state, Action), Action);
        };
    };
};
/**
 *
 * Reduce into Action
 * @param reduceFn - a function to reduce the state and Action together
 * @returns {MiddlewareFn} MiddlewareFn<State, IActionsUnion>
 */ var $73b1adea1614607d$export$854336d4678c17fd = function(reducerFn) {
    return function(reducer) {
        return function(state, Action) {
            return reducer(state, reducerFn(state, Action));
        };
    };
};

});
parcelRegister("3N38d", function(module, exports) {

$parcel$export(module.exports, "merge", () => $2c28608e58db6bf6$export$4950aa0f605343fb);

var $S8ZgO = parcelRequire("S8ZgO");

var $1wVYm = parcelRequire("1wVYm");

var $7xymH = parcelRequire("7xymH");

var $9Rm6G = parcelRequire("9Rm6G");

var $5JMLH = parcelRequire("5JMLH");
function $2c28608e58db6bf6$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $9Rm6G.popScheduler)(args);
    var concurrent = (0, $9Rm6G.popNumber)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $7xymH.EMPTY) : sources.length === 1 ? (0, $1wVYm.innerFrom)(sources[0]) : (0, $S8ZgO.mergeAll)(concurrent)((0, $5JMLH.from)(sources, scheduler));
}

});

parcelRegister("aT99L", function(module, exports) {

$parcel$export(module.exports, "NEVER", () => $7ed624bc5aefbdd8$export$96c94437c95d7862);

var $8id0M = parcelRequire("8id0M");

var $a5qXo = parcelRequire("a5qXo");
var $7ed624bc5aefbdd8$export$96c94437c95d7862 = new (0, $8id0M.Observable)((0, $a5qXo.noop));
function $7ed624bc5aefbdd8$export$b3e22bcfd64c1022() {
    return $7ed624bc5aefbdd8$export$96c94437c95d7862;
}

});

parcelRegister("jMd8a", function(module, exports) {

$parcel$export(module.exports, "concatMap", () => $e65caf7cb69ee908$export$c28c8388be0ab31a);

var $gD6ig = parcelRequire("gD6ig");

var $ePlbj = parcelRequire("ePlbj");
function $e65caf7cb69ee908$export$c28c8388be0ab31a(project, resultSelector) {
    return (0, $ePlbj.isFunction)(resultSelector) ? (0, $gD6ig.mergeMap)(project, resultSelector, 1) : (0, $gD6ig.mergeMap)(project, 1);
}

});

parcelRegister("1WlcV", function(module, exports) {

$parcel$export(module.exports, "exhaustMap", () => $169ba890a66bf70c$export$d70d492cd31004c0);

var $gawXH = parcelRequire("gawXH");

var $1wVYm = parcelRequire("1wVYm");

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $169ba890a66bf70c$export$d70d492cd31004c0(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe($169ba890a66bf70c$export$d70d492cd31004c0(function(a, i) {
            return (0, $1wVYm.innerFrom)(project(a, i)).pipe((0, $gawXH.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var index = 0;
        var innerSub = null;
        var isComplete = false;
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(outerValue) {
            if (!innerSub) {
                innerSub = (0, $iIZUt.createOperatorSubscriber)(subscriber, undefined, function() {
                    innerSub = null;
                    isComplete && subscriber.complete();
                });
                (0, $1wVYm.innerFrom)(project(outerValue, index++)).subscribe(innerSub);
            }
        }, function() {
            isComplete = true;
            !innerSub && subscriber.complete();
        }));
    });
}

});

parcelRegister("9wU3T", function(module, exports) {

$parcel$export(module.exports, "startWith", () => $6f0296e5cda35e8b$export$a4fe86229b0e9bdd);

var $lDqfI = parcelRequire("lDqfI");

var $9Rm6G = parcelRequire("9Rm6G");

var $5CoSH = parcelRequire("5CoSH");
function $6f0296e5cda35e8b$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $9Rm6G.popScheduler)(values);
    return (0, $5CoSH.operate)(function(source, subscriber) {
        (scheduler ? (0, $lDqfI.concat)(values, source, scheduler) : (0, $lDqfI.concat)(values, source)).subscribe(subscriber);
    });
}

});

parcelRegister("8ZyYf", function(module, exports) {

$parcel$export(module.exports, "takeUntil", () => $68bf25b5d4b27625$export$ac8dfd3a7ad06e80);

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");

var $1wVYm = parcelRequire("1wVYm");

var $a5qXo = parcelRequire("a5qXo");
function $68bf25b5d4b27625$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $5CoSH.operate)(function(source, subscriber) {
        (0, $1wVYm.innerFrom)(notifier).subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function() {
            return subscriber.complete();
        }, (0, $a5qXo.noop)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

});


parcelRegister("6DGJB", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $edf843ad4d2e4dcd$export$d4c72bab9d6cc13a);

var $fIPZc = parcelRequire("fIPZc");
const $edf843ad4d2e4dcd$export$d4c72bab9d6cc13a = {
    log: {},
    projects: [],
    // projects: {
    //   entities: {
    //     [id]: project
    //   },
    //   ids: []
    // },
    teams: [],
    templates: [],
    sessions: [],
    components: (0, $fIPZc.COMPONENTS_DATA)
};

});
parcelRegister("fIPZc", function(module, exports) {

$parcel$export(module.exports, "COMPONENTS_DATA", () => $473e21d995533b0d$export$cbe9d67591f8073e);
const $473e21d995533b0d$export$cbe9d67591f8073e = [
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '1',
        owner: 'HTMLELements'
    },
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '2',
        owner: 'HTMLELements'
    },
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '3',
        owner: 'HTMLELements'
    },
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '4',
        owner: 'HTMLELements'
    },
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '5',
        owner: 'HTMLELements'
    },
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '6',
        owner: 'HTMLELements'
    },
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '7',
        owner: 'HTMLELements'
    },
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '8',
        owner: 'HTMLELements'
    },
    {
        description: `
An evolving set of free, open source web components for building mobile and desktop web
applications in modern browsers.
`,
        id: '1',
        items: 51,
        namespace: '9',
        owner: 'HTMLELements'
    }
];

});


parcelRegister("4wABm", function(module, exports) {

$parcel$export(module.exports, "reducerFn", () => $cd89199991d4805d$export$633b1573158b09a1);

var $6yanA = parcelRequire("6yanA");

var $26mow = parcelRequire("26mow");

var $6OCAO = parcelRequire("6OCAO");

var $6DGJB = parcelRequire("6DGJB");
const $cd89199991d4805d$export$633b1573158b09a1 = (0, $26mow.reducer)((0, $6DGJB.initialState), (0, $26mow.on)((0, $6OCAO.addProject), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        const { id: id } = payload;
        draft.projects = state.projects.filter((p)=>p.id !== id);
        draft.projects.push(payload);
    })), (0, $26mow.on)((0, $6OCAO.removeProject), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        const { id: id } = payload;
        draft.projects = draft.projects.filter((p)=>p.id !== id);
    })), (0, $26mow.on)((0, $6OCAO.loadProjects), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        draft.projects = payload;
    })), (0, $26mow.on)((0, $6OCAO.addTeam), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        const { id: id } = payload;
        draft.teams = state.teams.filter((p)=>p.id !== id);
        draft.teams.push(payload);
    })), (0, $26mow.on)((0, $6OCAO.removeTeam), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        const { id: id } = payload;
        draft.teams = draft.teams.filter((p)=>p.id !== id);
    })), (0, $26mow.on)((0, $6OCAO.loadTeams), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        draft.teams = payload;
    })), (0, $26mow.on)((0, $6OCAO.addComponent), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        const { id: id } = payload;
        draft.components = state.components.filter((p)=>p.id !== id);
        draft.components.push(payload);
    })), (0, $26mow.on)((0, $6OCAO.removeComponent), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        const { id: id } = payload;
        draft.components = draft.components.filter((p)=>p.id !== id);
    })), (0, $26mow.on)((0, $6OCAO.loadComponents), (state, { payload: payload })=>(0, $6yanA.produce)(state, (draft)=>{
        draft.components = payload;
    })));

});
parcelRegister("6yanA", function(module, exports) {

$parcel$export(module.exports, "produce", () => produce);
var obj;
var NOTHING = typeof Symbol !== "undefined" ? Symbol("immer-nothing") : (obj = {}, obj["immer-nothing"] = true, obj);
var DRAFTABLE = typeof Symbol !== "undefined" && Symbol.for ? Symbol.for("immer-draftable") : "__$immer_draftable";
var DRAFT_STATE = typeof Symbol !== "undefined" && Symbol.for ? Symbol.for("immer-state") : "__$immer_state";
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    if (!value) return false;
    return isPlainObject(value) || !!value[DRAFTABLE] || !!value.constructor[DRAFTABLE];
}
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    if (Array.isArray(value)) return true;
    var proto = Object.getPrototypeOf(value);
    return !proto || proto === Object.prototype;
}
function original(value) {
    if (value && value[DRAFT_STATE]) return value[DRAFT_STATE].base;
     // otherwise return undefined
}
var assign = Object.assign || function assign(target, value) {
    for(var key in value)if (has(value, key)) target[key] = value[key];
    return target;
};
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : typeof Object.getOwnPropertySymbols !== "undefined" ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : Object.getOwnPropertyNames;
function shallowCopy(base, invokeGetters) {
    if (invokeGetters === void 0) invokeGetters = false;
    if (Array.isArray(base)) return base.slice();
    var clone = Object.create(Object.getPrototypeOf(base));
    ownKeys(base).forEach(function(key) {
        if (key === DRAFT_STATE) return; // Never copy over draft state.
        var desc = Object.getOwnPropertyDescriptor(base, key);
        var value = desc.value;
        if (desc.get) {
            if (!invokeGetters) throw new Error("Immer drafts cannot have computed properties");
            value = desc.get.call(base);
        }
        if (desc.enumerable) clone[key] = value;
        else Object.defineProperty(clone, key, {
            value: value,
            writable: true,
            configurable: true
        });
    });
    return clone;
}
function each(value, cb) {
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)cb(i, value[i], value);
    else ownKeys(value).forEach(function(key) {
        return cb(key, value[key], value);
    });
}
function isEnumerable(base, prop) {
    var desc = Object.getOwnPropertyDescriptor(base, prop);
    return !!desc && desc.enumerable;
}
function has(thing, prop) {
    return Object.prototype.hasOwnProperty.call(thing, prop);
}
function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function clone(obj) {
    if (!isDraftable(obj)) return obj;
    if (Array.isArray(obj)) return obj.map(clone);
    var cloned = Object.create(Object.getPrototypeOf(obj));
    for(var key in obj)cloned[key] = clone(obj[key]);
    return cloned;
}
function deepFreeze(obj) {
    if (!isDraftable(obj) || isDraft(obj) || Object.isFrozen(obj)) return;
    Object.freeze(obj);
    if (Array.isArray(obj)) obj.forEach(deepFreeze);
    else for(var key in obj)deepFreeze(obj[key]);
}
/** Each scope represents a `produce` call. */ var ImmerScope = function ImmerScope(parent) {
    this.drafts = [];
    this.parent = parent; // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    this.canAutoFreeze = true; // To avoid prototype lookups:
    this.patches = null;
};
ImmerScope.prototype.usePatches = function usePatches(patchListener) {
    if (patchListener) {
        this.patches = [];
        this.inversePatches = [];
        this.patchListener = patchListener;
    }
};
ImmerScope.prototype.revoke = function revoke$1() {
    this.leave();
    this.drafts.forEach(revoke);
    this.drafts = null; // Make draft-related methods throw.
};
ImmerScope.prototype.leave = function leave() {
    if (this === ImmerScope.current) ImmerScope.current = this.parent;
};
ImmerScope.current = null;
ImmerScope.enter = function() {
    return this.current = new ImmerScope(this.current);
};
function revoke(draft) {
    draft[DRAFT_STATE].revoke();
}
// but share them all instead
var descriptors = {};
function willFinalize(scope, result, isReplaced) {
    scope.drafts.forEach(function(draft) {
        draft[DRAFT_STATE].finalizing = true;
    });
    if (!isReplaced) {
        if (scope.patches) markChangesRecursively(scope.drafts[0]);
         // This is faster when we don't care about which attributes changed.
        markChangesSweep(scope.drafts);
    } else if (isDraft(result) && result[DRAFT_STATE].scope === scope) markChangesSweep(scope.drafts);
}
function createProxy(base, parent) {
    var isArray = Array.isArray(base);
    var draft = clonePotentialDraft(base);
    each(draft, function(prop) {
        proxyProperty(draft, prop, isArray || isEnumerable(base, prop));
    }); // See "proxy.js" for property documentation.
    var scope = parent ? parent.scope : ImmerScope.current;
    var state = {
        scope: scope,
        modified: false,
        finalizing: false,
        // es5 only
        finalized: false,
        assigned: {},
        parent: parent,
        base: base,
        draft: draft,
        copy: null,
        revoke: revoke$1,
        revoked: false // es5 only
    };
    createHiddenProperty(draft, DRAFT_STATE, state);
    scope.drafts.push(draft);
    return draft;
}
function revoke$1() {
    this.revoked = true;
}
function source(state) {
    return state.copy || state.base;
} // Access a property without creating an Immer draft.
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    if (state && !state.finalizing) {
        state.finalizing = true;
        var value = draft[prop];
        state.finalizing = false;
        return value;
    }
    return draft[prop];
}
function get(state, prop) {
    assertUnrevoked(state);
    var value = peek(source(state), prop);
    if (state.finalizing) return value;
     // Create a draft if the value is unmodified.
    if (value === peek(state.base, prop) && isDraftable(value)) {
        prepareCopy(state);
        return state.copy[prop] = createProxy(value, state);
    }
    return value;
}
function set(state, prop, value) {
    assertUnrevoked(state);
    state.assigned[prop] = true;
    if (!state.modified) {
        if (is(value, peek(source(state), prop))) return;
        markChanged(state);
        prepareCopy(state);
    }
    state.copy[prop] = value;
}
function markChanged(state) {
    if (!state.modified) {
        state.modified = true;
        if (state.parent) markChanged(state.parent);
    }
}
function prepareCopy(state) {
    if (!state.copy) state.copy = clonePotentialDraft(state.base);
}
function clonePotentialDraft(base) {
    var state = base && base[DRAFT_STATE];
    if (state) {
        state.finalizing = true;
        var draft = shallowCopy(state.draft, true);
        state.finalizing = false;
        return draft;
    }
    return shallowCopy(base);
}
function proxyProperty(draft, prop, enumerable) {
    var desc = descriptors[prop];
    if (desc) desc.enumerable = enumerable;
    else descriptors[prop] = desc = {
        configurable: true,
        enumerable: enumerable,
        get: function get$1() {
            return get(this[DRAFT_STATE], prop);
        },
        set: function set$1(value) {
            set(this[DRAFT_STATE], prop, value);
        }
    };
    Object.defineProperty(draft, prop, desc);
}
function assertUnrevoked(state) {
    if (state.revoked === true) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(source(state)));
} // This looks expensive, but only proxies are visited, and only objects without known changes are scanned.
function markChangesSweep(drafts) {
    // The natural order of drafts in the `scope` array is based on when they
    // were accessed. By processing drafts in reverse natural order, we have a
    // better chance of processing leaf nodes first. When a leaf node is known to
    // have changed, we can avoid any traversal of its ancestor nodes.
    for(var i = drafts.length - 1; i >= 0; i--){
        var state = drafts[i][DRAFT_STATE];
        if (!state.modified) {
            if (Array.isArray(state.base)) {
                if (hasArrayChanges(state)) markChanged(state);
            } else if (hasObjectChanges(state)) markChanged(state);
        }
    }
}
function markChangesRecursively(object) {
    if (!object || typeof object !== "object") return;
    var state = object[DRAFT_STATE];
    if (!state) return;
    var base = state.base;
    var draft = state.draft;
    var assigned = state.assigned;
    if (!Array.isArray(object)) {
        // Look for added keys.
        Object.keys(draft).forEach(function(key) {
            // The `undefined` check is a fast path for pre-existing keys.
            if (base[key] === undefined && !has(base, key)) {
                assigned[key] = true;
                markChanged(state);
            } else if (!assigned[key]) // Only untouched properties trigger recursion.
            markChangesRecursively(draft[key]);
        }); // Look for removed keys.
        Object.keys(base).forEach(function(key) {
            // The `undefined` check is a fast path for pre-existing keys.
            if (draft[key] === undefined && !has(draft, key)) {
                assigned[key] = false;
                markChanged(state);
            }
        });
    } else if (hasArrayChanges(state)) {
        markChanged(state);
        assigned.length = true;
        if (draft.length < base.length) for(var i = draft.length; i < base.length; i++)assigned[i] = false;
        else for(var i$1 = base.length; i$1 < draft.length; i$1++)assigned[i$1] = true;
        for(var i$2 = 0; i$2 < draft.length; i$2++)// Only untouched indices trigger recursion.
        if (assigned[i$2] === undefined) markChangesRecursively(draft[i$2]);
    }
}
function hasObjectChanges(state) {
    var base = state.base;
    var draft = state.draft; // Search for added keys and changed keys. Start at the back, because
    // non-numeric keys are ordered by time of definition on the object.
    var keys = Object.keys(draft);
    for(var i = keys.length - 1; i >= 0; i--){
        var key = keys[i];
        var baseValue = base[key]; // The `undefined` check is a fast path for pre-existing keys.
        if (baseValue === undefined && !has(base, key)) return true;
        else {
            var value = draft[key];
            var state$1 = value && value[DRAFT_STATE];
            if (state$1 ? state$1.base !== baseValue : !is(value, baseValue)) return true;
        }
    } // At this point, no keys were added or changed.
    // Compare key count to determine if keys were deleted.
    return keys.length !== Object.keys(base).length;
}
function hasArrayChanges(state) {
    var draft = state.draft;
    if (draft.length !== state.base.length) return true;
     // See #116
    // If we first shorten the length, our array interceptors will be removed.
    // If after that new items are added, result in the same original length,
    // those last items will have no intercepting property.
    // So if there is no own descriptor on the last position, we know that items were removed and added
    // N.B.: splice, unshift, etc only shift values around, but not prop descriptors, so we only have to check
    // the last one
    var descriptor = Object.getOwnPropertyDescriptor(draft, draft.length - 1); // descriptor can be null, but only for newly created sparse arrays, eg. new Array(10)
    if (descriptor && !descriptor.get) return true;
     // For all other cases, we don't have to compare, as they would have been picked up by the index setters
    return false;
}
function createHiddenProperty(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        enumerable: false,
        writable: true
    });
}
var legacyProxy = /*#__PURE__*/ Object.freeze({
    willFinalize: willFinalize,
    createProxy: createProxy
});
function willFinalize$1() {}
function createProxy$1(base, parent) {
    var scope = parent ? parent.scope : ImmerScope.current;
    var state = {
        // Track which produce call this is associated with.
        scope: scope,
        // True for both shallow and deep changes.
        modified: false,
        // Used during finalization.
        finalized: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned: {},
        // The parent draft state.
        parent: parent,
        // The base state.
        base: base,
        // The base proxy.
        draft: null,
        // Any property proxies.
        drafts: {},
        // The base copy with any updated values.
        copy: null,
        // Called by the `produce` function.
        revoke: null
    };
    var ref = Array.isArray(base) ? // although state itself is an object
    Proxy.revocable([
        state
    ], arrayTraps) : Proxy.revocable(state, objectTraps);
    var revoke = ref.revoke;
    var proxy = ref.proxy;
    state.draft = proxy;
    state.revoke = revoke;
    scope.drafts.push(proxy);
    return proxy;
}
var objectTraps = {
    get: get$1,
    has: function has(target, prop) {
        return prop in source$1(target);
    },
    ownKeys: function ownKeys(target) {
        return Reflect.ownKeys(source$1(target));
    },
    set: set$1,
    deleteProperty: deleteProperty,
    getOwnPropertyDescriptor: getOwnPropertyDescriptor,
    defineProperty: function defineProperty() {
        throw new Error("Object.defineProperty() cannot be used on an Immer draft"); // prettier-ignore
    },
    getPrototypeOf: function getPrototypeOf(target) {
        return Object.getPrototypeOf(target.base);
    },
    setPrototypeOf: function setPrototypeOf() {
        throw new Error("Object.setPrototypeOf() cannot be used on an Immer draft"); // prettier-ignore
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    if (isNaN(parseInt(prop))) throw new Error("Immer only supports deleting array indices"); // prettier-ignore
    return objectTraps.deleteProperty.call(this, state[0], prop);
};
arrayTraps.set = function(state, prop, value) {
    if (prop !== "length" && isNaN(parseInt(prop))) throw new Error("Immer only supports setting array indices and the 'length' property"); // prettier-ignore
    return objectTraps.set.call(this, state[0], prop, value);
}; // returns the object we should be reading the current value from, which is base, until some change has been made
function source$1(state) {
    return state.copy || state.base;
} // Access a property without creating an Immer draft.
function peek$1(draft, prop) {
    var state = draft[DRAFT_STATE];
    var desc = Reflect.getOwnPropertyDescriptor(state ? source$1(state) : draft, prop);
    return desc && desc.value;
}
function get$1(state, prop) {
    if (prop === DRAFT_STATE) return state;
    var drafts = state.drafts; // Check for existing draft in unmodified state.
    if (!state.modified && has(drafts, prop)) return drafts[prop];
    var value = source$1(state)[prop];
    if (state.finalized || !isDraftable(value)) return value;
     // Check for existing draft in modified state.
    if (state.modified) {
        // Assigned values are never drafted. This catches any drafts we created, too.
        if (value !== peek$1(state.base, prop)) return value;
         // Store drafts on the copy (when one exists).
        drafts = state.copy;
    }
    return drafts[prop] = createProxy$1(value, state);
}
function set$1(state, prop, value) {
    if (!state.modified) {
        var baseValue = peek$1(state.base, prop); // Optimize based on value's truthiness. Truthy values are guaranteed to
        // never be undefined, so we can avoid the `in` operator. Lastly, truthy
        // values may be drafts, but falsy values are never drafts.
        var isUnchanged = value ? is(baseValue, value) || value === state.drafts[prop] : is(baseValue, value) && prop in state.base;
        if (isUnchanged) return true;
        markChanged$1(state);
    }
    state.assigned[prop] = true;
    state.copy[prop] = value;
    return true;
}
function deleteProperty(state, prop) {
    // The `undefined` check is a fast path for pre-existing keys.
    if (peek$1(state.base, prop) !== undefined || prop in state.base) {
        state.assigned[prop] = false;
        markChanged$1(state);
    } else if (state.assigned[prop]) // if an originally not assigned property was deleted
    delete state.assigned[prop];
    if (state.copy) delete state.copy[prop];
    return true;
} // Note: We never coerce `desc.value` into an Immer draft, because we can't make
// the same guarantee in ES5 mode.
function getOwnPropertyDescriptor(state, prop) {
    var owner = source$1(state);
    var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (desc) {
        desc.writable = true;
        desc.configurable = !Array.isArray(owner) || prop !== "length";
    }
    return desc;
}
function markChanged$1(state) {
    if (!state.modified) {
        state.modified = true;
        state.copy = assign(shallowCopy(state.base), state.drafts);
        state.drafts = null;
        if (state.parent) markChanged$1(state.parent);
    }
}
var modernProxy = /*#__PURE__*/ Object.freeze({
    willFinalize: willFinalize$1,
    createProxy: createProxy$1
});
function generatePatches(state, basePath, patches, inversePatches) {
    Array.isArray(state.base) ? generateArrayPatches(state, basePath, patches, inversePatches) : generateObjectPatches(state, basePath, patches, inversePatches);
}
function generateArrayPatches(state, basePath, patches, inversePatches) {
    var assign, assign$1;
    var base = state.base;
    var copy = state.copy;
    var assigned = state.assigned; // Reduce complexity by ensuring `base` is never longer.
    if (copy.length < base.length) {
        assign = [
            copy,
            base
        ], base = assign[0], copy = assign[1];
        assign$1 = [
            inversePatches,
            patches
        ], patches = assign$1[0], inversePatches = assign$1[1];
    }
    var delta = copy.length - base.length; // Find the first replaced index.
    var start = 0;
    while(base[start] === copy[start] && start < base.length)++start;
     // Find the last replaced index. Search from the end to optimize splice patches.
    var end = base.length;
    while(end > start && base[end - 1] === copy[end + delta - 1])--end;
     // Process replaced indices.
    for(var i = start; i < end; ++i)if (assigned[i] && copy[i] !== base[i]) {
        var path = basePath.concat([
            i
        ]);
        patches.push({
            op: "replace",
            path: path,
            value: copy[i]
        });
        inversePatches.push({
            op: "replace",
            path: path,
            value: base[i]
        });
    }
    var replaceCount = patches.length; // Process added indices.
    for(var i$1 = end + delta - 1; i$1 >= end; --i$1){
        var path$1 = basePath.concat([
            i$1
        ]);
        patches[replaceCount + i$1 - end] = {
            op: "add",
            path: path$1,
            value: copy[i$1]
        };
        inversePatches.push({
            op: "remove",
            path: path$1
        });
    }
}
function generateObjectPatches(state, basePath, patches, inversePatches) {
    var base = state.base;
    var copy = state.copy;
    each(state.assigned, function(key, assignedValue) {
        var origValue = base[key];
        var value = copy[key];
        var op = !assignedValue ? "remove" : key in base ? "replace" : "add";
        if (origValue === value && op === "replace") return;
        var path = basePath.concat(key);
        patches.push(op === "remove" ? {
            op: op,
            path: path
        } : {
            op: op,
            path: path,
            value: value
        });
        inversePatches.push(op === "add" ? {
            op: "remove",
            path: path
        } : op === "remove" ? {
            op: "add",
            path: path,
            value: origValue
        } : {
            op: "replace",
            path: path,
            value: origValue
        });
    });
}
var applyPatches = function(draft, patches) {
    for(var i$1 = 0, list = patches; i$1 < list.length; i$1 += 1){
        var patch = list[i$1];
        var path = patch.path;
        var op = patch.op;
        var value = clone(patch.value); // used to clone patch to ensure original patch is not modified, see #411
        if (!path.length) throw new Error("Illegal state");
        var base = draft;
        for(var i = 0; i < path.length - 1; i++){
            base = base[path[i]];
            if (!base || typeof base !== "object") throw new Error("Cannot apply patch, path doesn't resolve: " + path.join("/"));
             // prettier-ignore
        }
        var key = path[path.length - 1];
        switch(op){
            case "replace":
                // if value is an object, then it's assigned by reference
                // in the following add or remove ops, the value field inside the patch will also be modifyed
                // so we use value from the cloned patch
                base[key] = value;
                break;
            case "add":
                if (Array.isArray(base)) // TODO: support "foo/-" paths for appending to an array
                base.splice(key, 0, value);
                else base[key] = value;
                break;
            case "remove":
                if (Array.isArray(base)) base.splice(key, 1);
                else delete base[key];
                break;
            default:
                throw new Error("Unsupported patch operation: " + op);
        }
    }
    return draft;
};
function verifyMinified() {}
var configDefaults = {
    useProxies: typeof Proxy !== "undefined" && typeof Proxy.revocable !== "undefined" && typeof Reflect !== "undefined",
    autoFreeze: verifyMinified.name === "verifyMinified",
    onAssign: null,
    onDelete: null,
    onCopy: null
};
var Immer = function Immer(config) {
    assign(this, configDefaults, config);
    this.setUseProxies(this.useProxies);
    this.produce = this.produce.bind(this);
};
Immer.prototype.produce = function produce(base, recipe, patchListener) {
    var this$1 = this;
    // curried invocation
    if (typeof base === "function" && typeof recipe !== "function") {
        var defaultBase = recipe;
        recipe = base;
        var self = this;
        return function curriedProduce(base) {
            var this$1 = this;
            if (base === void 0) base = defaultBase;
            var args = [], len = arguments.length - 1;
            while(len-- > 0)args[len] = arguments[len + 1];
            return self.produce(base, function(draft) {
                return recipe.call.apply(recipe, [
                    this$1,
                    draft
                ].concat(args));
            }); // prettier-ignore
        };
    } // prettier-ignore
    if (typeof recipe !== "function") throw new Error("The first or second argument to `produce` must be a function");
    if (patchListener !== undefined && typeof patchListener !== "function") throw new Error("The third argument to `produce` must be a function or undefined");
    var result; // Only plain objects, arrays, and "immerable classes" are drafted.
    if (isDraftable(base)) {
        var scope = ImmerScope.enter();
        var proxy = this.createProxy(base);
        var hasError = true;
        try {
            result = recipe(proxy);
            hasError = false;
        } finally{
            // finally instead of catch + rethrow better preserves original stack
            if (hasError) scope.revoke();
            else scope.leave();
        }
        if (result instanceof Promise) return result.then(function(result) {
            scope.usePatches(patchListener);
            return this$1.processResult(result, scope);
        }, function(error) {
            scope.revoke();
            throw error;
        });
        scope.usePatches(patchListener);
        return this.processResult(result, scope);
    } else {
        result = recipe(base);
        if (result === NOTHING) return undefined;
        if (result === undefined) result = base;
        this.maybeFreeze(result, true);
        return result;
    }
};
Immer.prototype.produceWithPatches = function produceWithPatches(arg1, arg2, arg3) {
    var this$1 = this;
    if (typeof arg1 === "function") return function(state) {
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        return this$1.produceWithPatches(state, function(draft) {
            return arg1.apply(void 0, [
                draft
            ].concat(args));
        });
    };
     // non-curried form
    if (arg3) throw new Error("A patch listener cannot be passed to produceWithPatches");
    var patches, inversePatches;
    var nextState = this.produce(arg1, arg2, function(p, ip) {
        patches = p;
        inversePatches = ip;
    });
    return [
        nextState,
        patches,
        inversePatches
    ];
};
Immer.prototype.createDraft = function createDraft(base) {
    if (!isDraftable(base)) throw new Error("First argument to `createDraft` must be a plain object, an array, or an immerable object"); // prettier-ignore
    var scope = ImmerScope.enter();
    var proxy = this.createProxy(base);
    proxy[DRAFT_STATE].isManual = true;
    scope.leave();
    return proxy;
};
Immer.prototype.finishDraft = function finishDraft(draft, patchListener) {
    var state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual) throw new Error("First argument to `finishDraft` must be a draft returned by `createDraft`"); // prettier-ignore
    if (state.finalized) throw new Error("The given draft is already finalized"); // prettier-ignore
    var scope = state.scope;
    scope.usePatches(patchListener);
    return this.processResult(undefined, scope);
};
Immer.prototype.setAutoFreeze = function setAutoFreeze(value) {
    this.autoFreeze = value;
};
Immer.prototype.setUseProxies = function setUseProxies(value) {
    this.useProxies = value;
    assign(this, value ? modernProxy : legacyProxy);
};
Immer.prototype.applyPatches = function applyPatches$1(base, patches) {
    // If a patch replaces the entire state, take that replacement as base
    // before applying patches
    var i;
    for(i = patches.length - 1; i >= 0; i--){
        var patch = patches[i];
        if (patch.path.length === 0 && patch.op === "replace") {
            base = patch.value;
            break;
        }
    }
    if (isDraft(base)) // N.B: never hits if some patch a replacement, patches are never drafts
    return applyPatches(base, patches);
     // Otherwise, produce a copy of the base state.
    return this.produce(base, function(draft) {
        return applyPatches(draft, patches.slice(i + 1));
    });
};
/** @internal */ Immer.prototype.processResult = function processResult(result, scope) {
    var baseDraft = scope.drafts[0];
    var isReplaced = result !== undefined && result !== baseDraft;
    this.willFinalize(scope, result, isReplaced);
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified) {
            scope.revoke();
            throw new Error("An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft."); // prettier-ignore
        }
        if (isDraftable(result)) {
            // Finalize the result in case it contains (or is) a subset of the draft.
            result = this.finalize(result, null, scope);
            this.maybeFreeze(result);
        }
        if (scope.patches) {
            scope.patches.push({
                op: "replace",
                path: [],
                value: result
            });
            scope.inversePatches.push({
                op: "replace",
                path: [],
                value: baseDraft[DRAFT_STATE].base
            });
        }
    } else // Finalize the base draft.
    result = this.finalize(baseDraft, [], scope);
    scope.revoke();
    if (scope.patches) scope.patchListener(scope.patches, scope.inversePatches);
    return result !== NOTHING ? result : undefined;
};
/**
 * @internal
 * Finalize a draft, returning either the unmodified base state or a modified
 * copy of the base state.
 */ Immer.prototype.finalize = function finalize(draft, path, scope) {
    var this$1 = this;
    var state = draft[DRAFT_STATE];
    if (!state) {
        if (Object.isFrozen(draft)) return draft;
        return this.finalizeTree(draft, null, scope);
    } // Never finalize drafts owned by another scope.
    if (state.scope !== scope) return draft;
    if (!state.modified) {
        this.maybeFreeze(state.base, true);
        return state.base;
    }
    if (!state.finalized) {
        state.finalized = true;
        this.finalizeTree(state.draft, path, scope);
        if (this.onDelete) {
            // The `assigned` object is unreliable with ES5 drafts.
            if (this.useProxies) {
                var assigned = state.assigned;
                for(var prop in assigned)if (!assigned[prop]) this.onDelete(state, prop);
            } else {
                var base = state.base;
                var copy = state.copy;
                each(base, function(prop) {
                    if (!has(copy, prop)) this$1.onDelete(state, prop);
                });
            }
        }
        if (this.onCopy) this.onCopy(state);
         // At this point, all descendants of `state.copy` have been finalized,
        // so we can be sure that `scope.canAutoFreeze` is accurate.
        if (this.autoFreeze && scope.canAutoFreeze) Object.freeze(state.copy);
        if (path && scope.patches) generatePatches(state, path, scope.patches, scope.inversePatches);
    }
    return state.copy;
};
/**
 * @internal
 * Finalize all drafts in the given state tree.
 */ Immer.prototype.finalizeTree = function finalizeTree(root, rootPath, scope) {
    var this$1 = this;
    var state = root[DRAFT_STATE];
    if (state) {
        if (!this.useProxies) // Create the final copy, with added keys and without deleted keys.
        state.copy = shallowCopy(state.draft, true);
        root = state.copy;
    }
    var needPatches = !!rootPath && !!scope.patches;
    var finalizeProperty = function(prop, value, parent) {
        if (value === parent) throw Error("Immer forbids circular references");
         // In the `finalizeTree` method, only the `root` object may be a draft.
        var isDraftProp = !!state && parent === root;
        if (isDraft(value)) {
            var path = isDraftProp && needPatches && !state.assigned[prop] ? rootPath.concat(prop) : null; // Drafts owned by `scope` are finalized here.
            value = this$1.finalize(value, path, scope); // Drafts from another scope must prevent auto-freezing.
            if (isDraft(value)) scope.canAutoFreeze = false;
             // Preserve non-enumerable properties.
            if (Array.isArray(parent) || isEnumerable(parent, prop)) parent[prop] = value;
            else Object.defineProperty(parent, prop, {
                value: value
            });
             // Unchanged drafts are never passed to the `onAssign` hook.
            if (isDraftProp && value === state.base[prop]) return;
        } else if (isDraftProp && is(value, state.base[prop])) return;
        else if (isDraftable(value) && !Object.isFrozen(value)) {
            each(value, finalizeProperty);
            this$1.maybeFreeze(value);
        }
        if (isDraftProp && this$1.onAssign) this$1.onAssign(state, prop, value);
    };
    each(root, finalizeProperty);
    return root;
};
Immer.prototype.maybeFreeze = function maybeFreeze(value, deep) {
    if (deep === void 0) deep = false;
    if (this.autoFreeze && !isDraft(value)) {
        if (deep) deepFreeze(value);
        else Object.freeze(value);
    }
};
var immer = new Immer();
/**
 * The `produce` function takes a value and a "recipe function" (whose
 * return value often depends on the base state). The recipe function is
 * free to mutate its first argument however it wants. All mutations are
 * only ever applied to a __copy__ of the base state.
 *
 * Pass only a function to create a "curried producer" which relieves you
 * from passing the recipe function every time.
 *
 * Only plain objects and arrays are made mutable. All other objects are
 * considered uncopyable.
 *
 * Note: This function is __bound__ to its `Immer` instance.
 *
 * @param {any} base - the initial state
 * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
 * @param {Function} patchListener - optional function that will be called with all the patches produced here
 * @returns {any} a new state, or the initial state if nothing was modified
 */ var produce = immer.produce;
/**
 * Like `produce`, but `produceWithPatches` always returns a tuple
 * [nextState, patches, inversePatches] (instead of just the next state)
 */ var produceWithPatches = immer.produceWithPatches.bind(immer);
/**
 * Pass true to automatically freeze all copies created by Immer.
 *
 * By default, auto-freezing is disabled in production.
 */ var setAutoFreeze = immer.setAutoFreeze.bind(immer);
/**
 * Pass true to use the ES2015 `Proxy` class when creating drafts, which is
 * always faster than using ES5 proxies.
 *
 * By default, feature detection is used, so calling this is rarely necessary.
 */ var setUseProxies = immer.setUseProxies.bind(immer);
/**
 * Apply an array of Immer patches to the first argument.
 *
 * This function is a producer, which means copy-on-write is in effect.
 */ var applyPatches$1 = immer.applyPatches.bind(immer);
/**
 * Create an Immer draft from the given base state, which may be a draft itself.
 * The draft can be modified until you finalize it with the `finishDraft` function.
 */ var createDraft = immer.createDraft.bind(immer);
/**
 * Finalize an Immer draft from a `createDraft` call, returning the base state
 * (if no changes were made) or a modified copy. The draft must *not* be
 * mutated afterwards.
 *
 * Pass a function as the 2nd argument to generate Immer patches based on the
 * changes that were made.
 */ var finishDraft = immer.finishDraft.bind(immer);
var $4c4df83270b1f9c3$export$2e2bcd8739ae039 = produce;

});

parcelRegister("26mow", function(module, exports) {

$parcel$export(module.exports, "on", () => $187d83627dd03e03$export$af631764ddc44097);
$parcel$export(module.exports, "reducer", () => $187d83627dd03e03$export$1650419e431d3ba3);
var $187d83627dd03e03$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
function $187d83627dd03e03$export$af631764ddc44097() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var reducer = args.pop();
    var types = args.reduce(function(result, creator) {
        return $187d83627dd03e03$var$__spreadArrays(result, [
            creator.type
        ]);
    }, []);
    return {
        reducer: reducer,
        types: types
    };
}
function $187d83627dd03e03$export$1650419e431d3ba3(initialState) {
    var ons = [];
    for(var _i = 1; _i < arguments.length; _i++)ons[_i - 1] = arguments[_i];
    var map = new Map();
    for(var _a = 0, ons_1 = ons; _a < ons_1.length; _a++){
        var on_1 = ons_1[_a];
        for(var _b = 0, _c = on_1.types; _b < _c.length; _b++){
            var type = _c[_b];
            if (!map.has(type)) map.set(type, on_1.reducer);
            else console.warn(type + " already specified in an 'on' call.");
        }
    }
    return function(state, action) {
        if (state === void 0) state = initialState;
        var reducer = map.get(action.type);
        return reducer ? reducer(state, action) : state;
    };
}

});

parcelRegister("6OCAO", function(module, exports) {

$parcel$export(module.exports, "loadProjects", () => $1071cc1c48b93dc9$export$14ec9adb679a31a1);
$parcel$export(module.exports, "addProject", () => $1071cc1c48b93dc9$export$bc335a505269e1cb);
$parcel$export(module.exports, "removeProject", () => $1071cc1c48b93dc9$export$18f1240e66c47da4);
$parcel$export(module.exports, "loadTeams", () => $1071cc1c48b93dc9$export$79e2c9b6a8cec01c);
$parcel$export(module.exports, "addTeam", () => $1071cc1c48b93dc9$export$e44b0fb90766dd97);
$parcel$export(module.exports, "removeTeam", () => $1071cc1c48b93dc9$export$145ef76c8fe6723f);
$parcel$export(module.exports, "loadSessions", () => $1071cc1c48b93dc9$export$7e124d219bd82700);
$parcel$export(module.exports, "addSession", () => $1071cc1c48b93dc9$export$b68d438cdd633c85);
$parcel$export(module.exports, "removeSession", () => $1071cc1c48b93dc9$export$f66bc3d755e0fe90);
$parcel$export(module.exports, "loadComponents", () => $1071cc1c48b93dc9$export$14ad8300a096c747);
$parcel$export(module.exports, "addComponent", () => $1071cc1c48b93dc9$export$17578421efdb3356);
$parcel$export(module.exports, "removeComponent", () => $1071cc1c48b93dc9$export$b74ee93795195fce);

var $1FvT2 = parcelRequire("1FvT2");
var $1071cc1c48b93dc9$export$7f68bfd3564d5c6f = /*#__PURE__*/ function(ProjectActions) {
    ProjectActions["ADD_PROJECT"] = "[Todo] Add project item";
    ProjectActions["REMOVE_PROJECT"] = "[Todo] Remove project item";
    ProjectActions["LOAD_PROJECTS"] = "[Todo] Load project items";
    return ProjectActions;
}({});
var $1071cc1c48b93dc9$export$4af45cafad4b35a7 = /*#__PURE__*/ function(TeamActions) {
    TeamActions["ADD_TEAM"] = "[Backend] Add team item";
    TeamActions["REMOVE_TEAM"] = "[Backend] Remove team item";
    TeamActions["LOAD_TEAMS"] = "[Backend] Load team items";
    return TeamActions;
}({});
var $1071cc1c48b93dc9$export$a2c983ef7c131971 = /*#__PURE__*/ function(ComponentActions) {
    ComponentActions["ADD_COMPONENT"] = "[Backend] Add component item";
    ComponentActions["REMOVE_COMPONENT"] = "[Backend] Remove component item";
    ComponentActions["LOAD_COMPONENTS"] = "[Backend] Load component items";
    return ComponentActions;
}({});
var $1071cc1c48b93dc9$export$eb3ff8ec01727309 = /*#__PURE__*/ function(SessionActions) {
    SessionActions["ADD_SESSION"] = "[Backend] Add session item";
    SessionActions["REMOVE_SESSION"] = "[Backend] Remove session item";
    SessionActions["LOAD_SESSIONS"] = "[Backend] Load session items";
    return SessionActions;
}({});
const $1071cc1c48b93dc9$export$14ec9adb679a31a1 = (0, $1FvT2.action)("[Todo] Load project items", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$bc335a505269e1cb = (0, $1FvT2.action)("[Todo] Add project item", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$18f1240e66c47da4 = (0, $1FvT2.action)("[Todo] Remove project item", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$79e2c9b6a8cec01c = (0, $1FvT2.action)("[Backend] Load team items", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$e44b0fb90766dd97 = (0, $1FvT2.action)("[Backend] Add team item", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$145ef76c8fe6723f = (0, $1FvT2.action)("[Backend] Remove team item", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$7e124d219bd82700 = (0, $1FvT2.action)("[Backend] Load session items", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$b68d438cdd633c85 = (0, $1FvT2.action)("[Backend] Add session item", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$f66bc3d755e0fe90 = (0, $1FvT2.action)("[Backend] Remove session item", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$14ad8300a096c747 = (0, $1FvT2.action)("[Backend] Load component items", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$17578421efdb3356 = (0, $1FvT2.action)("[Backend] Add component item", (0, $1FvT2.fsa)());
const $1071cc1c48b93dc9$export$b74ee93795195fce = (0, $1FvT2.action)("[Backend] Remove component item", (0, $1FvT2.fsa)());

});
parcelRegister("1FvT2", function(module, exports) {

$parcel$export(module.exports, "action", () => $13725ad67f6bd302$export$31eb53bd5b582a97);
$parcel$export(module.exports, "fsa", () => $13725ad67f6bd302$export$fb971ecb744e6dc9);
var $13725ad67f6bd302$var$__assign = undefined && undefined.__assign || function() {
    $13725ad67f6bd302$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13725ad67f6bd302$var$__assign.apply(this, arguments);
};
function $13725ad67f6bd302$export$31eb53bd5b582a97(type, config) {
    if (typeof config === "function") return $13725ad67f6bd302$var$defineType(type, function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $13725ad67f6bd302$var$__assign($13725ad67f6bd302$var$__assign({}, config.apply(void 0, args)), {
            type: type
        });
    });
    var as = config ? config._as : "empty";
    switch(as){
        case "empty":
            return $13725ad67f6bd302$var$defineType(type, function() {
                return {
                    type: type
                };
            });
        case "fsa":
            return $13725ad67f6bd302$var$defineType(type, function(payload, meta) {
                return payload instanceof Error ? {
                    error: true,
                    meta: meta,
                    payload: payload,
                    type: type
                } : {
                    error: false,
                    meta: meta,
                    payload: payload,
                    type: type
                };
            });
        case "payload":
            return $13725ad67f6bd302$var$defineType(type, function(payload) {
                return {
                    payload: payload,
                    type: type
                };
            });
        case "props":
            return $13725ad67f6bd302$var$defineType(type, function(props) {
                return $13725ad67f6bd302$var$__assign($13725ad67f6bd302$var$__assign({}, props), {
                    type: type
                });
            });
        default:
            throw new Error("Unexpected config.");
    }
}
function $13725ad67f6bd302$export$6e22c362a0406a2c() {
    return {
        _as: "empty"
    };
}
function $13725ad67f6bd302$export$fb971ecb744e6dc9() {
    return {
        _as: "fsa",
        _m: undefined,
        _p: undefined
    };
}
function $13725ad67f6bd302$export$5e805c3762185b4c() {
    return {
        _as: "payload",
        _p: undefined
    };
}
function $13725ad67f6bd302$export$8128bb6492cf3de7() {
    return {
        _as: "props",
        _p: undefined
    };
}
function $13725ad67f6bd302$export$bf9fb029d174d554(type, rest) {
    return $13725ad67f6bd302$var$__assign($13725ad67f6bd302$var$__assign({}, rest), {
        type: type
    });
}
function $13725ad67f6bd302$export$971dd5b0dfd021b6() {
    var creators = [];
    for(var _i = 0; _i < arguments.length; _i++)creators[_i] = arguments[_i];
    var descriptor = {
        get: function() {
            throw new Error("Pseudo property not readable.");
        },
        set: function() {
            throw new Error("Pseudo property not writable.");
        }
    };
    var result = creators.map(function(_a) {
        var type = _a.type;
        return Object.defineProperty({
            type: type
        }, "action", descriptor);
    });
    Object.defineProperties(result, {
        actions: descriptor,
        types: descriptor
    });
    return result;
}
function $13725ad67f6bd302$var$defineType(type, creator) {
    return Object.defineProperty(creator, "type", {
        value: type,
        writable: false
    });
}

});



parcelRegister("f1tXV", function(module, exports) {

$parcel$export(module.exports, "history", () => $f2578a94ee760ebb$export$55abd4691b317664);
$parcel$export(module.exports, "dbUpdates", () => $f2578a94ee760ebb$export$19f41d053d8c4f28);

var $9VPSw = parcelRequire("9VPSw");

var $6yanA = parcelRequire("6yanA");

var $2M7S3 = parcelRequire("2M7S3");

var $6OCAO = parcelRequire("6OCAO");
const $f2578a94ee760ebb$export$55abd4691b317664 = (0, $9VPSw.reduceNS)((state, action)=>(0, $6yanA.produce)(state, (draft)=>{
        if ((0, $2M7S3.isType)(action, (0, $6OCAO.addTeam))) return;
        const timestamp = new Date().getTime();
        draft.log[timestamp] = {
            action: action,
            timestamp: timestamp,
            visible: true
        };
    }));
const $f2578a94ee760ebb$export$19f41d053d8c4f28 = (0, $9VPSw.reduceNS)((state, action)=>{
    action.type.includes('[Backend]');
    return state;
});

});
parcelRegister("2M7S3", function(module, exports) {

$parcel$export(module.exports, "isType", () => $20562b7341550600$export$26b9f946b448f23e);
function $20562b7341550600$export$26b9f946b448f23e(action) {
    var creators = [];
    for(var _i = 1; _i < arguments.length; _i++)creators[_i - 1] = arguments[_i];
    return creators.some(function(_a) {
        var type = _a.type;
        return action.type === type;
    });
}

});



parcelRegister("hlfBx", function(module, exports) {

$parcel$export(module.exports, "CoreModule", () => $e3cf2c0347b34b15$export$d5dc740503fb3d20);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $bXHxa = parcelRequire("bXHxa");

var $2d0B8 = parcelRequire("2d0B8");

var $aE3Y2 = parcelRequire("aE3Y2");

var $giRuk = parcelRequire("giRuk");

var $83JTn = parcelRequire("83JTn");

var $eaQMh = parcelRequire("eaQMh");

var $kk9so = parcelRequire("kk9so");

var $iEbjM = parcelRequire("iEbjM");

var $2ZFzp = parcelRequire("2ZFzp");

var $3Cgae = parcelRequire("3Cgae");

var $5ELu3 = parcelRequire("5ELu3");

var $54CK2 = parcelRequire("54CK2");

var $cLKMa = parcelRequire("cLKMa");

var $1V3pW = parcelRequire("1V3pW");

var $c7gF1 = parcelRequire("c7gF1");

var $djGtt = parcelRequire("djGtt");

var $fissc = parcelRequire("fissc");

var $5V3kE = parcelRequire("5V3kE");

var $dMqWf = parcelRequire("dMqWf");

var $iCFDc = parcelRequire("iCFDc");

var $c7W4b = parcelRequire("c7W4b");

var $4cteG = parcelRequire("4cteG");

var $7HQg9 = parcelRequire("7HQg9");

var $d8h3d = parcelRequire("d8h3d");

var $c6XAH = parcelRequire("c6XAH");

var $fzOpg = parcelRequire("fzOpg");

var $iQhj9 = parcelRequire("iQhj9");

var $285ah = parcelRequire("285ah");

var $aW6Ya = parcelRequire("aW6Ya");

var $7vJSu = parcelRequire("7vJSu");

var $fG5CU = parcelRequire("fG5CU");

var $ikIwA = parcelRequire("ikIwA");
parcelRequire("cflMN");
var $38rxE = parcelRequire("38rxE");
var $185cP = parcelRequire("185cP");

var $9mzCZ = parcelRequire("9mzCZ");

var $htpni = parcelRequire("htpni");

var $jM6nT = parcelRequire("jM6nT");

var $4JfJ1 = parcelRequire("4JfJ1");

var $adRKk = parcelRequire("adRKk");

var $kOwTj = parcelRequire("kOwTj");

var $4Xutv = parcelRequire("4Xutv");

var $be29e = parcelRequire("be29e");

var $3qX4y = parcelRequire("3qX4y");
parcelRequire("6ppqI");
var $2EHKy = parcelRequire("2EHKy");

var $fpZJA = parcelRequire("fpZJA");

var $cyGfX = parcelRequire("cyGfX");
class $e3cf2c0347b34b15$export$d5dc740503fb3d20 {
}
$e3cf2c0347b34b15$export$d5dc740503fb3d20 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Module)({
        imports: [
            (0, $aE3Y2.MarkdownReaderModule),
            (0, $fzOpg.HttpModule).forRoot({
                url: 'http://localhost:9000/graphql'
            }),
            (0, $bXHxa.HttpModule).forRoot({
                url: 'https://api.github.com/graphql'
            }),
            (0, $cyGfX.VerticalTimelineModule),
            (0, $2EHKy.TranslationsModule).forRoot({
                translations: {
                    EN: (/*@__PURE__*/$parcel$interopDefault($iEbjM)),
                    BG: (/*@__PURE__*/$parcel$interopDefault($eaQMh)),
                    AR: (/*@__PURE__*/$parcel$interopDefault($83JTn)),
                    DE: (/*@__PURE__*/$parcel$interopDefault($kk9so)),
                    FR: (/*@__PURE__*/$parcel$interopDefault($3Cgae)),
                    NL: (/*@__PURE__*/$parcel$interopDefault($5ELu3)),
                    SR: (/*@__PURE__*/$parcel$interopDefault($54CK2)),
                    TR: (/*@__PURE__*/$parcel$interopDefault($cLKMa)),
                    ES: (/*@__PURE__*/$parcel$interopDefault($2ZFzp))
                }
            })
        ],
        providers: [
            (0, $2d0B8.ResponsiveService),
            (0, $jM6nT.ProjectsService),
            (0, $adRKk.TeamsService),
            (0, $be29e.UserService),
            (0, $dMqWf.CLIService),
            (0, $kOwTj.UIComponentsService),
            (0, $c7W4b.FooterService),
            (0, $djGtt.PrefetchService),
            (0, $fpZJA.VersionService),
            (0, $iCFDc.DateTimeProvider),
            (0, $ikIwA.NotificationsService),
            (0, $d8h3d.GraphEnumsProvider),
            (0, $7vJSu.NavMenuProvider),
            (0, $c6XAH.HotKeysProvider),
            (0, $aW6Ya.ModalProvider),
            (0, $285ah.LocalStorageService),
            (0, $4cteG.GithubService),
            (0, $3qX4y.VSCodeService),
            (0, $5V3kE.CardService),
            (0, $fissc.BoardService),
            (0, $giRuk.AppsService),
            (0, $4Xutv.UserScopeService),
            (0, $7HQg9.GlobalProjectsMenuService),
            (0, $fG5CU.NavbarItemsProvider),
            (0, $4JfJ1.StorageProvider),
            (0, $1V3pW.OnlineStatusService),
            (0, $c7gF1.PortalProvider),
            (0, $iQhj9.LambdaService)
        ],
        plugins: [],
        components: [
            (0, $9mzCZ.ProjectInviteTemplateComponent),
            (0, $htpni.ProjectRemoveTemplateComponent),
            (0, $38rxE.MachineStartedTemplateComponent),
            (0, $185cP.MachineStoppedTemplateComponent)
        ]
    })
], $e3cf2c0347b34b15$export$d5dc740503fb3d20);

});
parcelRegister("bXHxa", function(module, exports) {
"use strict";
var $8b56f956cd1a02b9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8b56f956cd1a02b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8b56f956cd1a02b9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8b56f956cd1a02b9$var$__createBinding(exports1, m, p);
};
var $8b56f956cd1a02b9$var$HttpModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpModule = void 0;

var $1t8Wn = parcelRequire("1t8Wn");


let $8b56f956cd1a02b9$var$HttpModule = $8b56f956cd1a02b9$var$HttpModule_1 = class HttpModule {
    static forRoot(config) {
        return {
            module: $8b56f956cd1a02b9$var$HttpModule_1,
            providers: [
                {
                    provide: (parcelRequire("7YbaL")).GraphqClientConfig,
                    useValue: config
                }
            ]
        };
    }
};
module.exports.HttpModule = $8b56f956cd1a02b9$var$HttpModule;
module.exports.HttpModule = $8b56f956cd1a02b9$var$HttpModule = $8b56f956cd1a02b9$var$HttpModule_1 = $8b56f956cd1a02b9$var$__decorate([
    (0, $1t8Wn.Module)({
        providers: [
            (parcelRequire("f8e0r")).HttpClient
        ]
    })
], $8b56f956cd1a02b9$var$HttpModule);

$8b56f956cd1a02b9$var$__exportStar((parcelRequire("f8e0r")), module.exports);

$8b56f956cd1a02b9$var$__exportStar((parcelRequire("7YbaL")), module.exports);

});
parcelRegister("f8e0r", function(module, exports) {
"use strict";
var $b04277acaf49144c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b04277acaf49144c$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpClient = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $5JMLH = parcelRequire("5JMLH");

var $7YbaL = parcelRequire("7YbaL");
let $b04277acaf49144c$var$HttpClient = class HttpClient {
    query(query, variables, options) {
        return this.getInternalJson(this.graphqlConfig.url, JSON.stringify({
            query: query,
            variables: variables
        }), Object.assign(Object.assign({}, options), {
            method: 'POST'
        }));
    }
    mutation(mutation, variables, options) {
        return this.getInternalJson(this.graphqlConfig.url, JSON.stringify({
            mutation: mutation,
            variables: variables
        }), Object.assign(Object.assign({}, options), {
            method: 'POST'
        }));
    }
    getInternalJson(url, body, options = {
        method: 'GET'
    }) {
        const params = this.encodeQueryData(options.params);
        const defaultHeaders = Object.assign({
            'Content-Type': 'application/json'
        }, options.headers);
        return (0, $5JMLH.from)(fetch(url + params, {
            method: options.method,
            headers: this.appendHeaders(defaultHeaders),
            body: body
        }).then((res)=>res.json()));
    }
    appendHeaders(h) {
        const headers = new Headers(h);
        Object.entries(h).forEach(([key, value])=>{
            headers.set(key, value);
        });
        return headers;
    }
    get(url, body, options = {
        method: 'GET'
    }) {
        return this.getInternalJson(url, body, options);
    }
    post(url, body, options = {
        method: 'POST'
    }) {
        return this.getInternalJson(url, body, options);
    }
    update(url, body, options = {
        method: 'UPDATE'
    }) {
        return this.getInternalJson(url, body, options);
    }
    delete(url, body, options = {
        method: 'DELETE'
    }) {
        return this.getInternalJson(url, body, options);
    }
    encodeQueryData(data = {}) {
        return Object.entries(data).map((pair)=>pair.map(encodeURIComponent).join('=')).join('&');
    }
};
module.exports.HttpClient = $b04277acaf49144c$var$HttpClient;
$b04277acaf49144c$var$__decorate([
    (0, $1t8Wn.Injector)($7YbaL.GraphqClientConfig),
    $b04277acaf49144c$var$__metadata("design:type", Object)
], $b04277acaf49144c$var$HttpClient.prototype, "graphqlConfig", void 0);
module.exports.HttpClient = $b04277acaf49144c$var$HttpClient = $b04277acaf49144c$var$__decorate([
    (0, $1t8Wn.Injectable)()
], $b04277acaf49144c$var$HttpClient);

});
parcelRegister("7YbaL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphqClientConfig = void 0;
module.exports.gql = $5cd6cda9c331cf0f$var$gql;

var $1t8Wn = parcelRequire("1t8Wn");
module.exports.GraphqClientConfig = new $1t8Wn.InjectionToken();
function $5cd6cda9c331cf0f$var$gql(...args) {
    const literals = args[0];
    let result = typeof literals === 'string' ? literals : literals[0];
    for(let i = 1; i < args.length; i++){
        if (args[i] && args[i].kind && args[i].kind === 'Document') result += args[i].loc.source.body;
        else result += args[i];
        result += literals[i];
    }
    return result;
}

});



parcelRegister("2d0B8", function(module, exports) {
"use strict";
function $19bd4265a978a380$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$19bd4265a978a380$var$__export((parcelRequire("3bcOg")));

});
parcelRegister("3bcOg", function(module, exports) {
"use strict";
var $250c55e6e9748f65$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $250c55e6e9748f65$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
var $jIao5 = parcelRequire("jIao5");
var $g5fNy = parcelRequire("g5fNy");

var $8Obdr = parcelRequire("8Obdr");
var $7LRrZ = parcelRequire("7LRrZ");
var $gawXH = parcelRequire("gawXH");
let $250c55e6e9748f65$var$ResponsiveService = class ResponsiveService {
    constructor(){
        this.width = new $bq6Hs.BehaviorSubject(document.body.clientWidth);
        this.height = new $bq6Hs.BehaviorSubject(document.body.clientHeight);
        this.scrollDebounceTime = 10;
        this.scrollSubscription = $jIao5.fromEvent(window, 'scroll').pipe($7LRrZ.debounceTime(this.scrollDebounceTime));
        this.isPositionFixed = true;
        window.addEventListener('resize', ()=>this.setWindowSize());
    }
    setWindowSize() {
        this.height.next(document.body.clientHeight);
        this.width.next(document.body.clientWidth);
    }
    getBoth() {
        return {
            width: this.width.getValue(),
            height: this.height.getValue()
        };
    }
    combineBoth() {
        return $g5fNy.of(this.getBoth()).pipe($8Obdr.combineLatest(this.height, this.width), $gawXH.map(()=>this.getBoth()));
    }
};
$250c55e6e9748f65$var$ResponsiveService = $250c55e6e9748f65$var$__decorate([
    $1t8Wn.Injectable({
        init: true
    }),
    $250c55e6e9748f65$var$__metadata("design:paramtypes", [])
], $250c55e6e9748f65$var$ResponsiveService);
module.exports.ResponsiveService = $250c55e6e9748f65$var$ResponsiveService;

});
parcelRegister("jIao5", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $e59a2f259a3f7750$export$a36e16046ae8f1bb);

var $deWeK = parcelRequire("deWeK");

var $1wVYm = parcelRequire("1wVYm");

var $8id0M = parcelRequire("8id0M");

var $gD6ig = parcelRequire("gD6ig");

var $g2lVS = parcelRequire("g2lVS");

var $ePlbj = parcelRequire("ePlbj");

var $7hC7G = parcelRequire("7hC7G");
var $e59a2f259a3f7750$var$nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var $e59a2f259a3f7750$var$eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var $e59a2f259a3f7750$var$jqueryMethods = [
    'on',
    'off'
];
function $e59a2f259a3f7750$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $ePlbj.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $e59a2f259a3f7750$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $7hC7G.mapOneOrManyArgs)(resultSelector));
    var _a = (0, $deWeK.__read)($e59a2f259a3f7750$var$isEventTarget(target) ? $e59a2f259a3f7750$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $e59a2f259a3f7750$var$isNodeStyleEventEmitter(target) ? $e59a2f259a3f7750$var$nodeEventEmitterMethods.map($e59a2f259a3f7750$var$toCommonHandlerRegistry(target, eventName)) : $e59a2f259a3f7750$var$isJQueryStyleEventEmitter(target) ? $e59a2f259a3f7750$var$jqueryMethods.map($e59a2f259a3f7750$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $g2lVS.isArrayLike)(target)) return (0, $gD6ig.mergeMap)(function(subTarget) {
            return $e59a2f259a3f7750$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $1wVYm.innerFrom)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, $8id0M.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $e59a2f259a3f7750$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $e59a2f259a3f7750$var$isNodeStyleEventEmitter(target) {
    return (0, $ePlbj.isFunction)(target.addListener) && (0, $ePlbj.isFunction)(target.removeListener);
}
function $e59a2f259a3f7750$var$isJQueryStyleEventEmitter(target) {
    return (0, $ePlbj.isFunction)(target.on) && (0, $ePlbj.isFunction)(target.off);
}
function $e59a2f259a3f7750$var$isEventTarget(target) {
    return (0, $ePlbj.isFunction)(target.addEventListener) && (0, $ePlbj.isFunction)(target.removeEventListener);
}

});

parcelRegister("8Obdr", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $669bb1799802f767$export$77fa7d86f5204e8a);

var $deWeK = parcelRequire("deWeK");

var $cdTWx = parcelRequire("cdTWx");

var $5CoSH = parcelRequire("5CoSH");

var $efHd4 = parcelRequire("efHd4");

var $7hC7G = parcelRequire("7hC7G");

var $hPrdq = parcelRequire("hPrdq");

var $9Rm6G = parcelRequire("9Rm6G");
function $669bb1799802f767$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, $9Rm6G.popResultSelector)(args);
    return resultSelector ? (0, $hPrdq.pipe)($669bb1799802f767$export$77fa7d86f5204e8a.apply(void 0, (0, $deWeK.__spreadArray)([], (0, $deWeK.__read)(args))), (0, $7hC7G.mapOneOrManyArgs)(resultSelector)) : (0, $5CoSH.operate)(function(source, subscriber) {
        (0, $cdTWx.combineLatestInit)((0, $deWeK.__spreadArray)([
            source
        ], (0, $deWeK.__read)((0, $efHd4.argsOrArgArray)(args))))(subscriber);
    });
}

});
parcelRegister("efHd4", function(module, exports) {

$parcel$export(module.exports, "argsOrArgArray", () => $a603fbfa3c05b049$export$24e1bb79414042be);
var $a603fbfa3c05b049$var$isArray = Array.isArray;
function $a603fbfa3c05b049$export$24e1bb79414042be(args) {
    return args.length === 1 && $a603fbfa3c05b049$var$isArray(args[0]) ? args[0] : args;
}

});


parcelRegister("7LRrZ", function(module, exports) {

$parcel$export(module.exports, "debounceTime", () => $5a86625a7584cbf0$export$7843a4469d64c07e);

var $8fD1K = parcelRequire("8fD1K");

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $5a86625a7584cbf0$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $8fD1K.asyncScheduler);
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

});



parcelRegister("aE3Y2", function(module, exports) {
var $7c00b7a988459033$var$__defProp = Object.defineProperty;
var $7c00b7a988459033$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $7c00b7a988459033$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $7c00b7a988459033$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7c00b7a988459033$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $7c00b7a988459033$var$__getOwnPropNames(from))if (!$7c00b7a988459033$var$__hasOwnProp.call(to, key) && key !== except) $7c00b7a988459033$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $7c00b7a988459033$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $7c00b7a988459033$var$__reExport = (target, mod, secondTarget)=>($7c00b7a988459033$var$__copyProps(target, mod, "default"), secondTarget && $7c00b7a988459033$var$__copyProps(secondTarget, mod, "default"));
var $7c00b7a988459033$var$__toCommonJS = (mod)=>$7c00b7a988459033$var$__copyProps($7c00b7a988459033$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $7c00b7a988459033$var$src_exports = {};
module.exports = $7c00b7a988459033$var$__toCommonJS($7c00b7a988459033$var$src_exports);

$7c00b7a988459033$var$__reExport($7c00b7a988459033$var$src_exports, (parcelRequire("7MjDn")), module.exports);

$7c00b7a988459033$var$__reExport($7c00b7a988459033$var$src_exports, (parcelRequire("gJGUt")), module.exports);

$7c00b7a988459033$var$__reExport($7c00b7a988459033$var$src_exports, (parcelRequire("gBKdM")), module.exports);

$7c00b7a988459033$var$__reExport($7c00b7a988459033$var$src_exports, (parcelRequire("jTXuk")), module.exports);

});
parcelRegister("7MjDn", function(module, exports) {
var $5a9c3f099293187e$var$__defProp = Object.defineProperty;
var $5a9c3f099293187e$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $5a9c3f099293187e$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $5a9c3f099293187e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5a9c3f099293187e$var$__export = (target, all)=>{
    for(var name in all)$5a9c3f099293187e$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $5a9c3f099293187e$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $5a9c3f099293187e$var$__getOwnPropNames(from))if (!$5a9c3f099293187e$var$__hasOwnProp.call(to, key) && key !== except) $5a9c3f099293187e$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $5a9c3f099293187e$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $5a9c3f099293187e$var$__toCommonJS = (mod)=>$5a9c3f099293187e$var$__copyProps($5a9c3f099293187e$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $5a9c3f099293187e$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5a9c3f099293187e$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5a9c3f099293187e$var$__defProp(target, key, result);
    return result;
};
var $5a9c3f099293187e$var$markdown_reader_module_exports = {};
$5a9c3f099293187e$var$__export($5a9c3f099293187e$var$markdown_reader_module_exports, {
    MarkdownReaderModule: ()=>$5a9c3f099293187e$var$MarkdownReaderModule
});
module.exports = $5a9c3f099293187e$var$__toCommonJS($5a9c3f099293187e$var$markdown_reader_module_exports);

var $1t8Wn = parcelRequire("1t8Wn");

var $gJGUt = parcelRequire("gJGUt");

var $gBKdM = parcelRequire("gBKdM");

var $Y0HZk = parcelRequire("Y0HZk");

var $i07Qn = parcelRequire("i07Qn");
let $5a9c3f099293187e$var$MarkdownReaderModule = class {
};
$5a9c3f099293187e$var$MarkdownReaderModule = $5a9c3f099293187e$var$__decorateClass([
    (0, $1t8Wn.Module)({
        components: [
            $i07Qn.TocComponent,
            $Y0HZk.MarkdownReaderComponent
        ],
        providers: [
            $gBKdM.MarkdownParserService,
            $gJGUt.MarkdownParserMenuProvider
        ]
    })
], $5a9c3f099293187e$var$MarkdownReaderModule);

});
parcelRegister("gJGUt", function(module, exports) {
var $c2f222553e9af03a$var$__defProp = Object.defineProperty;
var $c2f222553e9af03a$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $c2f222553e9af03a$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $c2f222553e9af03a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c2f222553e9af03a$var$__export = (target, all)=>{
    for(var name in all)$c2f222553e9af03a$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $c2f222553e9af03a$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $c2f222553e9af03a$var$__getOwnPropNames(from))if (!$c2f222553e9af03a$var$__hasOwnProp.call(to, key) && key !== except) $c2f222553e9af03a$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $c2f222553e9af03a$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $c2f222553e9af03a$var$__toCommonJS = (mod)=>$c2f222553e9af03a$var$__copyProps($c2f222553e9af03a$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $c2f222553e9af03a$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $c2f222553e9af03a$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $c2f222553e9af03a$var$__defProp(target, key, result);
    return result;
};
var $c2f222553e9af03a$var$markdown_reader_menu_provider_exports = {};
$c2f222553e9af03a$var$__export($c2f222553e9af03a$var$markdown_reader_menu_provider_exports, {
    MarkdownParserMenuProvider: ()=>$c2f222553e9af03a$var$MarkdownParserMenuProvider
});
module.exports = $c2f222553e9af03a$var$__toCommonJS($c2f222553e9af03a$var$markdown_reader_menu_provider_exports);

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
let $c2f222553e9af03a$var$MarkdownParserMenuProvider = class {
    constructor(){
        this.menu = new $bq6Hs.BehaviorSubject([]);
        this.scrollTopOffset = 100;
    }
    setItems(items) {
        this.menu.next(items);
    }
    clearMenu() {
        this.menu.next([]);
    }
    addItem(item) {
        this.menu.next([
            ...this.menu.getValue(),
            item
        ]);
    }
    lookupHeadings(contentReference) {
        if (!contentReference) return;
        const headings = contentReference.querySelectorAll("h3, h4");
        const removeAnchor = (text)=>{
            const anchorId = text && text.indexOf("#");
            return anchorId >= 0 ? text.slice(0, anchorId) : text;
        };
        const heads = Array.from(headings).map((item)=>({
                offsetTop: item.offsetTop,
                textContent: removeAnchor(item.textContent),
                elementRef: item
            }));
        if (heads && heads.length) {
            const index = this.findCurrentHeading(headings);
            this.setItems([
                ...heads.map((e)=>({
                        elementRef: e.elementRef,
                        title: e.textContent
                    }))
            ]);
            if (index > 0) this.navigateToAnchor(heads[index].elementRef);
        }
    }
    findCurrentHeading(headings) {
        const marginOffset = 15;
        for(let i = 0; i < headings.length; i++){
            if (headings.length - 1 === i) return this.activeId = i;
            else if (headings[i + 1].offsetTop >= window.pageYOffset + this.scrollTopOffset + marginOffset) return this.activeId = i;
        }
    }
    navigateToAnchor(elementRef) {
        if (elementRef) window.scroll({
            top: elementRef.offsetTop - 100,
            behavior: "smooth"
        });
    }
};
$c2f222553e9af03a$var$MarkdownParserMenuProvider = $c2f222553e9af03a$var$__decorateClass([
    (0, $1t8Wn.Injectable)()
], $c2f222553e9af03a$var$MarkdownParserMenuProvider);

});

parcelRegister("gBKdM", function(module, exports) {
var $c173f4a15e8228cf$var$__create = Object.create;
var $c173f4a15e8228cf$var$__defProp = Object.defineProperty;
var $c173f4a15e8228cf$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $c173f4a15e8228cf$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $c173f4a15e8228cf$var$__getProtoOf = Object.getPrototypeOf;
var $c173f4a15e8228cf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c173f4a15e8228cf$var$__export = (target, all)=>{
    for(var name in all)$c173f4a15e8228cf$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $c173f4a15e8228cf$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $c173f4a15e8228cf$var$__getOwnPropNames(from))if (!$c173f4a15e8228cf$var$__hasOwnProp.call(to, key) && key !== except) $c173f4a15e8228cf$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $c173f4a15e8228cf$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $c173f4a15e8228cf$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $c173f4a15e8228cf$var$__create($c173f4a15e8228cf$var$__getProtoOf(mod)) : {}, $c173f4a15e8228cf$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $c173f4a15e8228cf$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $c173f4a15e8228cf$var$__toCommonJS = (mod)=>$c173f4a15e8228cf$var$__copyProps($c173f4a15e8228cf$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $c173f4a15e8228cf$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $c173f4a15e8228cf$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $c173f4a15e8228cf$var$__defProp(target, key, result);
    return result;
};
var $c173f4a15e8228cf$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $c173f4a15e8228cf$var$markdown_reader_service_exports = {};
$c173f4a15e8228cf$var$__export($c173f4a15e8228cf$var$markdown_reader_service_exports, {
    MarkdownParserService: ()=>$c173f4a15e8228cf$var$MarkdownParserService
});
module.exports = $c173f4a15e8228cf$var$__toCommonJS($c173f4a15e8228cf$var$markdown_reader_service_exports);
parcelRequire("9jlVS");

var $1t8Wn = parcelRequire("1t8Wn");

var $c173f4a15e8228cf$var$import_marked = $c173f4a15e8228cf$var$__toESM((parcelRequire("cTSxh")));
let $c173f4a15e8228cf$var$MarkdownParserService = class {
    constructor(){
        this.renderer = new $c173f4a15e8228cf$var$import_marked.default.Renderer();
        this.cache = /* @__PURE__ */ new Map();
        this.initParser();
    }
    highlightElements(tags) {
        return [].forEach.call(tags, (code)=>{
            if (code.className) Prism.highlightElement(code);
        });
    }
    flushCache() {
        this.cache.clear();
    }
    readAndCompile(text) {
        const html = `<div class="content" #contentReference>
      ${(0, $c173f4a15e8228cf$var$import_marked.default)(text, {
            renderer: this.renderer,
            breaks: true
        })}
    </div>`;
        return html + "\n";
    }
    fetchMarkdown(link) {
        return $c173f4a15e8228cf$var$__async(this, null, function*() {
            if (this.cache.has(link)) return this.cache.get(link);
            const res = yield fetch(link);
            if (res.status !== 200) throw new Error(`Unable to load markdown status is ${res.status}`);
            const down = yield res.text();
            const result = this.readAndCompile(down);
            this.cache.set(link, result);
            return this.cache.get(link);
        });
    }
    // async fetchDefinitions(link: string) {
    //   if (this.cache.has(link)) {
    //     return this.cache.get(link);
    //   }
    //   const res = await fetch(link);
    //   if (res.status !== 200) {
    //     // location.href = '/not-found';
    //     throw new Error(`Unable to load config status is ${res.status}`);
    //   }
    //   const result = await res.text();
    //   const doc = yaml.load(result);
    //   this.cache.set(link, doc);
    //   return result;
    // }
    crypto(length) {
        let result = "";
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const charactersLength = characters.length;
        for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
        return result;
    }
    escapeBrackets(text) {
        text = text.replace(new RegExp("{", "g"), "&#123;");
        text = text.replace(new RegExp("}", "g"), "&#125;");
        return text;
    }
    appendEmptyLine(text) {
        const codeEscape = '">';
        const codeEscId = text.indexOf(codeEscape);
        return text.slice(0, codeEscId + codeEscape.length) + "\n" + text.slice(codeEscId + codeEscape.length, text.length);
    }
    replaceFilename(renderer, text, filenameKey, filenameIndex) {
        const startIndex = filenameIndex + filenameKey.length;
        const endIndex = text.indexOf(")");
        const directiveRef = `app` + this.crypto(20);
        const filename = text.slice(startIndex + 1, endIndex);
        return `
<span class="filename">` + (filename.length > 0 ? `
  {{ '${filename}' | extension: ${directiveRef}.isJsActive }}` : "") + `
<app-tabs #${directiveRef}></app-tabs>
</span>` + renderer(text.slice(endIndex + 1), directiveRef).trim();
    }
    parseSwitcher(renderer, text, switchKey, switchIndex, elementKey) {
        const tsCode = text.slice(0, switchIndex).trim();
        const jsCode = text.slice(switchIndex + switchKey.length, text.length).trim();
        const wrapCondition = (snippet, lang)=>elementKey ? snippet.slice(0, 4) + ` [class.hide]="${lang === "js" ? "!" : ""}${elementKey}.isJsActive"` + snippet.slice(4, snippet.length) : snippet;
        return wrapCondition(renderer(tsCode, "typescript"), "ts") + wrapCondition(renderer(jsCode, "typescript"), "js");
    }
    insertText(text, index, textToAdd) {
        return text.slice(0, index) + textToAdd + text.slice(index);
    }
    initParser() {
        const originalTableRenderer = this.renderer.table;
        this.renderer.table = (header, body)=>header.includes("<th></th>") ? originalTableRenderer.call(this.renderer, "", body) : originalTableRenderer.call(this.renderer, header, body);
        const originalCodeRenderer = this.renderer.code;
        this.renderer.code = (code, language, isEscaped, switcherKey)=>{
            const filenameKey = "@@filename";
            const filenameIndex = code.indexOf(filenameKey);
            if (filenameIndex >= 0) return this.replaceFilename((text)=>this.renderer.code(text, language, isEscaped), code, filenameKey, filenameIndex);
            const switchKey = "@@switch";
            const switchIndex = code.indexOf(switchKey);
            if (switchIndex >= 0) {
                const result = this.parseSwitcher((text, lang)=>this.renderer.code(text, lang, isEscaped), code, switchKey, switchIndex, switcherKey);
                return this.escapeBrackets(result);
            }
            let output = originalCodeRenderer.call(this.renderer, code, language, isEscaped);
            output = switcherKey ? output : this.appendEmptyLine(output);
            if (output.includes("language-graphql")) output = output.replace("<pre>", '<h6>GraphQL</h6><pre class="graphql">');
            if (output.includes("language-mermaid")) {
                if (window.customElements.get("g-diagram")) output = `<g-diagram>${output.replace('<pre><code class="language-mermaid">', "").replace("</code></pre>", "")}</g-diagram>`;
                else output = output.replace("<pre>", `<h6 style="display:flex">
              <div>Mermaid Diagram</div>
              <span style="flex: 1 3 auto;"></span>
              <div title="Enable Mermaid parser from profile settings">\u24D8</div>
             </h6><pre class="graphql">`);
            }
            return this.escapeBrackets(output);
        };
        const originalLinkRenderer = this.renderer.link;
        this.renderer.link = (href, title, text)=>{
            if (!href.includes("http") && !href.includes("mailto")) return originalLinkRenderer.call(this.renderer, href, title, text);
            return `<a target="_blank" href="${href}" title="${href}">URL <svg style="fill: rgb(8, 148, 226)" width="12" height="12" preserveAspectRatio="xMidYMid meet" aria-hidden="true" viewBox="0 0 16 16"><!----><!--?lit$5916814465$--><g><path d="M14 16v-11l-1 1v9h-12v-12h9l1-1h-11v14z"></path><path d="M16 0h-5l1.8 1.8-6.8 6.8 1.4 1.4 6.8-6.8 1.8 1.8z"></path></g><!--?--></svg></a>`;
        };
        const originalHeadingRenderer = this.renderer.heading.bind(this.renderer);
        this.renderer.heading = (...args)=>{
            let text = originalHeadingRenderer(...args);
            if (!text.includes("h4")) return text;
            const startIndex = text.indexOf("<h") + 3;
            text = this.insertText(text, startIndex, ` appAnchor`);
            text = this.insertText(text, text.indexOf('">') + 2, "<span>");
            return this.insertText(text, text.length - 6, "</span>");
        };
        const originalBlockquoteRenderer = this.renderer.blockquote.bind(this.renderer);
        this.renderer.blockquote = (quote)=>{
            let text = originalBlockquoteRenderer(quote);
            text = text.replace("<p>", "");
            text = text.replace("</p>", "");
            text = text.replace("<blockquote>", '<blockquote class="warning">');
            return text;
        };
        const original = this.renderer.list.bind(this.renderer);
        this.renderer.list = (body, ordered, start)=>{
            const data = original(body, ordered, start);
            return data;
        };
    }
};
$c173f4a15e8228cf$var$MarkdownParserService = $c173f4a15e8228cf$var$__decorateClass([
    (0, $1t8Wn.Injectable)()
], $c173f4a15e8228cf$var$MarkdownParserService);

});
parcelRegister("9jlVS", function(module, exports) {
const $6c76e6bcf00af394$var$_self = typeof window !== "undefined" ? window : typeof self["WorkerGlobalScope"] !== "undefined" ? self : {};
const $6c76e6bcf00af394$var$Prism = function() {
    const lang = /\blang(?:uage)?-(\w+)\b/i;
    let uniqueId = 0;
    var _ = $6c76e6bcf00af394$var$_self["Prism"] = {
        util: {
            encode: function(tokens) {
                if (tokens instanceof Token) return new Token(tokens["type"], _.util.encode(tokens["content"]), tokens["alias"]);
                else if (_.util.type(tokens) === "Array") return tokens.map(_.util.encode);
                else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            type: function(o) {
                return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
            },
            objId: function(obj) {
                if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                    value: ++uniqueId
                });
                return obj["__id"];
            },
            // Deep clone a language definition (e.g. to extend it)
            clone: function(o) {
                const type = _.util.type(o);
                switch(type){
                    case "Object":
                        var clone = {};
                        for(const key in o)if (o.hasOwnProperty(key)) clone[key] = _.util.clone(o[key]);
                        return clone;
                    case "Array":
                        return o.map && o.map(function(v) {
                            return _.util.clone(v);
                        });
                }
                return o;
            }
        },
        languages: {
            extend: function(id, redef) {
                const lang2 = _.util.clone(_.languages[id]);
                for(const key in redef)lang2[key] = redef[key];
                return lang2;
            },
            /**
       * Insert a token before another token in a language literal
       * As this needs to recreate the object (we cannot actually insert before keys in object literals),
       * we cannot just provide an object, we need anobject and a key.
       * @param inside The key (or language id) of the parent
       * @param before The key to insert before. If not provided, the function appends instead.
       * @param insert Object with the key/value pairs to insert
       * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
       */ insertBefore: function(inside, before, insert, root) {
                root = root || _.languages;
                const grammar = root[inside];
                if (arguments.length == 2) {
                    insert = arguments[1];
                    for(var newToken in insert)if (insert.hasOwnProperty(newToken)) grammar[newToken] = insert[newToken];
                    return grammar;
                }
                const ret = {};
                for(const token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    ret[token] = grammar[token];
                }
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === root[inside] && key != inside) this[key] = ret;
                });
                return root[inside] = ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function(o, callback, type, visited) {
                visited = visited || {};
                for(const i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    if (_.util.type(o[i]) === "Object" && !visited[_.util.objId(o[i])]) {
                        visited[_.util.objId(o[i])] = true;
                        _.languages.DFS(o[i], callback, null, visited);
                    } else if (_.util.type(o[i]) === "Array" && !visited[_.util.objId(o[i])]) {
                        visited[_.util.objId(o[i])] = true;
                        _.languages.DFS(o[i], callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        highlightAll: function(async, callback) {
            _.highlightAllUnder(async, callback);
        },
        highlightAllUnder: function(async, callback) {
            const env = {
                callback: callback,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run("before-highlightall", env);
            const elements = env["elements"] || document.querySelectorAll(env.selector);
            for(var i = 0, element; element = elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        highlightElement: function(element, async, callback) {
            let language, grammar, parent = element;
            while(parent && !lang.test(parent.className))parent = parent.parentNode;
            if (parent) {
                language = (parent.className.match(lang) || [
                    ,
                    ""
                ])[1].toLowerCase();
                grammar = _.languages[language];
            }
            element.className = element.className.replace(lang, "").replace(/\s+/g, " ") + " language-" + language;
            parent = element.parentNode;
            if (/pre/i.test(parent.nodeName)) parent.className = parent.className.replace(lang, "").replace(/\s+/g, " ") + " language-" + language;
            const code = element.textContent;
            const env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            _.hooks.run("before-sanity-check", env);
            if (!env.code || !env.grammar) {
                _.hooks.run("complete", env);
                return;
            }
            _.hooks.run("before-highlight", env);
            if (async && $6c76e6bcf00af394$var$_self["Worker"]) {
                const worker = new Worker(_["filename"]);
                worker.onmessage = function(evt) {
                    env["highlightedCode"] = evt.data;
                    _.hooks.run("before-insert", env);
                    env.element.innerHTML = env["highlightedCode"];
                    callback && callback.call(env.element);
                    _.hooks.run("after-highlight", env);
                    _.hooks.run("complete", env);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else {
                env["highlightedCode"] = _.highlight(env.code, env.grammar, env.language);
                _.hooks.run("before-insert", env);
                env.element.innerHTML = env["highlightedCode"];
                callback && callback.call(element);
                _.hooks.run("after-highlight", env);
                _.hooks.run("complete", env);
            }
        },
        highlight: function(text, grammar, language) {
            const tokens = _.tokenize(text, grammar);
            return Token["stringify"](_.util.encode(tokens), language);
        },
        tokenize: function(text, grammar) {
            const Token2 = _["Token"];
            const strarr = [
                text
            ];
            const rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            tokenloop: for(var token in grammar){
                if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                let patterns = grammar[token];
                patterns = _.util.type(patterns) === "Array" ? patterns : [
                    patterns
                ];
                for(let j = 0; j < patterns.length; ++j){
                    let pattern = patterns[j];
                    let lookbehindLength = 0;
                    const inside = pattern.inside, lookbehind = !!pattern.lookbehind, greedy = !!pattern.greedy, alias = pattern.alias;
                    if (greedy && !pattern.pattern.global) {
                        const flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
                        pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
                    }
                    pattern = pattern.pattern || pattern;
                    for(let i = 0, pos = 0; i < strarr.length; pos += strarr[i].length, ++i){
                        let str = strarr[i];
                        if (strarr.length > text.length) break tokenloop;
                        if (str instanceof Token2) continue;
                        pattern.lastIndex = 0;
                        var match = pattern.exec(str), delNum = 1;
                        if (!match && greedy && i != strarr.length - 1) {
                            pattern.lastIndex = pos;
                            match = pattern.exec(text);
                            if (!match) break;
                            var from = match.index + (lookbehind ? match[1].length : 0), to = match.index + match[0].length, k = i, p = pos;
                            for(let len = strarr.length; k < len && p < to; ++k){
                                p += strarr[k].length;
                                if (from >= p) {
                                    ++i;
                                    pos = p;
                                }
                            }
                            if (strarr[i] instanceof Token2 || strarr[k - 1].greedy) continue;
                            delNum = k - i;
                            str = text.slice(pos, p);
                            match.index -= pos;
                        }
                        if (!match) continue;
                        if (lookbehind) lookbehindLength = match[1].length;
                        var from = match.index + lookbehindLength, match = match[0].slice(lookbehindLength), to = from + match.length, before = str.slice(0, from), after = str.slice(to);
                        const args = [
                            i,
                            delNum
                        ];
                        if (before) args.push(before);
                        const wrapped = new Token2(token, inside ? _.tokenize(match, inside) : match, alias, match, greedy);
                        args.push(wrapped);
                        if (after) args.push(after);
                        Array.prototype.splice.apply(strarr, args);
                    }
                }
            }
            return strarr;
        },
        hooks: {
            all: {},
            add: function(name, callback) {
                const hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            run: function(name, env) {
                const callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        }
    };
    var Token = _["Token"] = function(type, content, alias, matchedStr, greedy) {
        this.type = type;
        this.content = content;
        this.alias = alias;
        this.length = (matchedStr || "").length | 0;
        this.greedy = !!greedy;
    };
    Token["stringify"] = function(o, language, parent) {
        if (typeof o == "string") return o;
        if (_.util.type(o) === "Array") return o.map(function(element) {
            return Token["stringify"](element, language, o);
        }).join("");
        const env = {
            type: o.type,
            content: Token["stringify"](o.content, language, parent),
            tag: "span",
            classes: [
                "token",
                o.type
            ],
            attributes: {},
            language: language,
            parent: parent
        };
        if (env.type == "comment") env.attributes["spellcheck"] = "true";
        if (o.alias) {
            const aliases = _.util.type(o.alias) === "Array" ? o.alias : [
                o.alias
            ];
            Array.prototype.push.apply(env.classes, aliases);
        }
        _.hooks.run("wrap", env);
        let attributes = "";
        for(const name in env.attributes)attributes += (attributes ? " " : "") + name + '="' + (env.attributes[name] || "") + '"';
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + (attributes ? " " + attributes : "") + ">" + env.content + "</" + env.tag + ">";
    };
    if (!$6c76e6bcf00af394$var$_self["document"]) {
        if (!$6c76e6bcf00af394$var$_self["addEventListener"]) return $6c76e6bcf00af394$var$_self["Prism"];
        $6c76e6bcf00af394$var$_self["addEventListener"]("message", function(evt) {
            const message = JSON.parse(evt.data), lang2 = message.language, code = message.code, immediateClose = message.immediateClose;
            $6c76e6bcf00af394$var$_self["postMessage"](_.highlight(code, _.languages[lang2], lang2));
            if (immediateClose) $6c76e6bcf00af394$var$_self["close"]();
        }, false);
        return $6c76e6bcf00af394$var$_self["Prism"];
    }
    const script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();
    if (script) {
        _["filename"] = script.src;
        if (document.addEventListener && !script.hasAttribute("data-manual")) {
            if (document.readyState !== "loading") {
                if (window.requestAnimationFrame) window.requestAnimationFrame(_.highlightAll);
                else window.setTimeout(_.highlightAll, 16);
            } else document.addEventListener("DOMContentLoaded", _.highlightAll);
        }
    }
    return $6c76e6bcf00af394$var$_self["Prism"];
}();
if (module.exports) module.exports = $6c76e6bcf00af394$var$Prism;
if (typeof $parcel$global !== "undefined") $parcel$global["Prism"] = $6c76e6bcf00af394$var$Prism;
$6c76e6bcf00af394$var$Prism.languages.markup = {
    comment: /<!--[\w\W]*?-->/,
    prolog: /<\?[\w\W]+?\?>/,
    doctype: /<!DOCTYPE[\w\W]+?>/i,
    cdata: /<!\[CDATA\[[\w\W]*?]]>/i,
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\\1|\\?(?!\1)[\w\W])*\1|[^\s'">=]+))?)*\s*\/?>/i,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/i,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "attr-value": {
                pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/i,
                inside: {
                    punctuation: /[=>"']/
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: /&#?[\da-z]{1,8};/i
};
$6c76e6bcf00af394$var$Prism.hooks.add("wrap", function(env) {
    if (env.type === "entity") env.attributes["title"] = env.content.replace(/&amp;/, "&");
});
$6c76e6bcf00af394$var$Prism.languages.xml = $6c76e6bcf00af394$var$Prism.languages.markup;
$6c76e6bcf00af394$var$Prism.languages.html = $6c76e6bcf00af394$var$Prism.languages.markup;
$6c76e6bcf00af394$var$Prism.languages.mathml = $6c76e6bcf00af394$var$Prism.languages.markup;
$6c76e6bcf00af394$var$Prism.languages.svg = $6c76e6bcf00af394$var$Prism.languages.markup;
$6c76e6bcf00af394$var$Prism.languages.css = {
    comment: /\/\*[\w\W]*?\*\//,
    atrule: {
        pattern: /@[\w-]+?.*?(;|(?=\s*\{))/i,
        inside: {
            rule: /@[\w-]+/
        }
    },
    url: /url\((?:(["'])(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
    selector: /[^\{\}\s][^\{\};]*?(?=\s*\{)/,
    string: {
        pattern: /("|')(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    property: /(\b|\B)[\w-]+(?=\s*:)/i,
    important: /\B!important\b/i,
    function: /[-a-z0-9]+(?=\()/i,
    punctuation: /[(){};:]/
};
$6c76e6bcf00af394$var$Prism.languages.css["atrule"].inside.rest = $6c76e6bcf00af394$var$Prism.util.clone($6c76e6bcf00af394$var$Prism.languages.css);
if ($6c76e6bcf00af394$var$Prism.languages.markup) {
    $6c76e6bcf00af394$var$Prism.languages.insertBefore("markup", "tag", {
        style: {
            pattern: /(<style[\w\W]*?>)[\w\W]*?(?=<\/style>)/i,
            lookbehind: true,
            inside: $6c76e6bcf00af394$var$Prism.languages.css,
            alias: "language-css"
        }
    });
    $6c76e6bcf00af394$var$Prism.languages.insertBefore("inside", "attr-value", {
        "style-attr": {
            pattern: /\s*style=("|').*?\1/i,
            inside: {
                "attr-name": {
                    pattern: /^\s*style/i,
                    inside: $6c76e6bcf00af394$var$Prism.languages.markup.tag.inside
                },
                punctuation: /^\s*=\s*['"]|['"]\s*$/,
                "attr-value": {
                    pattern: /.+/i,
                    inside: $6c76e6bcf00af394$var$Prism.languages.css
                }
            },
            alias: "language-css"
        }
    }, $6c76e6bcf00af394$var$Prism.languages.markup.tag);
}
$6c76e6bcf00af394$var$Prism.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\w\W]*?\*\//,
            lookbehind: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true
        }
    ],
    string: {
        pattern: /(["'])(\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[a-z0-9_\.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /(\.|\\)/
        }
    },
    keyword: /\b(if|else|async|await|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
    boolean: /\b(true|false)\b/,
    function: /[a-z0-9_]+(?=\()/i,
    number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
    punctuation: /[{}[\];(),.:]/
};
$6c76e6bcf00af394$var$Prism.languages.javascript = $6c76e6bcf00af394$var$Prism.languages.extend("clike", {
    keyword: /\b(as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
    number: /\b-?(0x[\dA-Fa-f]+|0b[01]+|0o[0-7]+|\d*\.?\d+([Ee][+-]?\d+)?|NaN|Infinity)\b/,
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*(?=\()/i,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*\*?|\/|~|\^|%|\.{3}/
});
$6c76e6bcf00af394$var$Prism.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\\\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
        lookbehind: true,
        greedy: true
    }
});
$6c76e6bcf00af394$var$Prism.languages.insertBefore("javascript", "string", {
    "template-string": {
        pattern: /`(?:\\\\|\\?[^\\])*?`/,
        greedy: true,
        inside: {
            interpolation: {
                pattern: /\$\{[^}]+\}/,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $6c76e6bcf00af394$var$Prism.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    }
});
if ($6c76e6bcf00af394$var$Prism.languages.markup) $6c76e6bcf00af394$var$Prism.languages.insertBefore("markup", "tag", {
    script: {
        pattern: /(<script[\w\W]*?>)[\w\W]*?(?=<\/script>)/i,
        lookbehind: true,
        inside: $6c76e6bcf00af394$var$Prism.languages.javascript,
        alias: "language-javascript"
    }
});
$6c76e6bcf00af394$var$Prism.languages.js = $6c76e6bcf00af394$var$Prism.languages.javascript;
$6c76e6bcf00af394$var$Prism.languages.c = $6c76e6bcf00af394$var$Prism.languages.extend("clike", {
    keyword: /\b(asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,
    operator: /\-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*\/]/,
    number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)[ful]*\b/i
});
$6c76e6bcf00af394$var$Prism.languages.insertBefore("c", "string", {
    macro: {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^\s*)#\s*[a-z]+([^\r\n\\]|\\.|\\(?:\r\n?|\n))*/im,
        lookbehind: true,
        alias: "property",
        inside: {
            // highlight the path of the include statement as a string
            string: {
                pattern: /(#\s*include\s*)(<.+?>|("|')(\\?.)+?\3)/,
                lookbehind: true
            },
            // highlight macro directives as keywords
            directive: {
                pattern: /(#\s*)\b(define|elif|else|endif|error|ifdef|ifndef|if|import|include|line|pragma|undef|using)\b/,
                lookbehind: true,
                alias: "keyword"
            }
        }
    },
    // highlight predefined macros as constants
    constant: /\b(__FILE__|__LINE__|__DATE__|__TIME__|__TIMESTAMP__|__func__|EOF|NULL|stdin|stdout|stderr)\b/
});
delete $6c76e6bcf00af394$var$Prism.languages.c["class-name"];
delete $6c76e6bcf00af394$var$Prism.languages.c["boolean"];
$6c76e6bcf00af394$var$Prism.languages.csharp = $6c76e6bcf00af394$var$Prism.languages.extend("clike", {
    keyword: /\b(abstract|as|async|await|base|bool|break|byte|case|catch|char|checked|class|const|continue|decimal|default|delegate|do|double|else|enum|event|explicit|extern|false|finally|fixed|float|for|foreach|goto|if|implicit|in|int|interface|internal|is|lock|long|namespace|new|null|object|operator|out|override|params|private|protected|public|readonly|ref|return|sbyte|sealed|short|sizeof|stackalloc|static|string|struct|switch|this|throw|true|try|typeof|uint|ulong|unchecked|unsafe|ushort|using|virtual|void|volatile|while|add|alias|ascending|async|await|descending|dynamic|from|get|global|group|into|join|let|orderby|partial|remove|select|set|value|var|where|yield)\b/,
    string: [
        /@("|')(\1\1|\\\1|\\?(?!\1)[\s\S])*\1/,
        /("|')(\\?.)*?\1/
    ],
    number: /\b-?(0x[\da-f]+|\d*\.?\d+f?)\b/i
});
$6c76e6bcf00af394$var$Prism.languages.insertBefore("csharp", "keyword", {
    "generic-method": {
        pattern: /[a-z0-9_]+\s*<[^>\r\n]+?>\s*(?=\()/i,
        alias: "function",
        inside: {
            keyword: $6c76e6bcf00af394$var$Prism.languages.csharp.keyword,
            punctuation: /[<>(),.:]/
        }
    },
    preprocessor: {
        pattern: /(^\s*)#.*/m,
        lookbehind: true,
        alias: "property",
        inside: {
            // highlight preprocessor directives as keywords
            directive: {
                pattern: /(\s*#)\b(define|elif|else|endif|endregion|error|if|line|pragma|region|undef|warning)\b/,
                lookbehind: true,
                alias: "keyword"
            }
        }
    }
});
$6c76e6bcf00af394$var$Prism.languages.cpp = $6c76e6bcf00af394$var$Prism.languages.extend("c", {
    keyword: /\b(alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|class|compl|const|constexpr|const_cast|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|float|for|friend|goto|if|inline|int|long|mutable|namespace|new|noexcept|nullptr|operator|private|protected|public|register|reinterpret_cast|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/,
    boolean: /\b(true|false)\b/,
    operator: /[-+]{1,2}|!=?|<{1,2}=?|>{1,2}=?|\->|:{1,2}|={1,2}|\^|~|%|&{1,2}|\|?\||\?|\*|\/|\b(and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/
});
$6c76e6bcf00af394$var$Prism.languages.insertBefore("cpp", "keyword", {
    "class-name": {
        pattern: /(class\s+)[a-z0-9_]+/i,
        lookbehind: true
    }
});
$6c76e6bcf00af394$var$Prism.languages.java = $6c76e6bcf00af394$var$Prism.languages.extend("clike", {
    keyword: /\b(abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while)\b/,
    number: /\b0b[01]+\b|\b0x[\da-f]*\.?[\da-fp\-]+\b|\b\d*\.?\d+(?:e[+-]?\d+)?[df]?\b/i,
    operator: {
        pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|!=?|<<?=?|>>?>?=?|==?|&[&=]?|\|[|=]?|\*=?|\/=?|%=?|\^=?|[?:~])/m,
        lookbehind: true
    }
});
$6c76e6bcf00af394$var$Prism.languages.insertBefore("java", "function", {
    annotation: {
        alias: "punctuation",
        pattern: /(^|[^.])@\w+/,
        lookbehind: true
    }
});
$6c76e6bcf00af394$var$Prism.languages.json = {
    property: /"(?:\\.|[^|"])*"(?=\s*:)/gi,
    string: /"(?!:)(?:\\.|[^|"])*"(?!:)/g,
    number: /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee][+-]?\d+)?)\b/g,
    punctuation: /[{}[\]);,]/g,
    operator: /:/g,
    boolean: /\b(true|false)\b/gi,
    null: /\bnull\b/gi
};
$6c76e6bcf00af394$var$Prism.languages.jsonp = $6c76e6bcf00af394$var$Prism.languages.json;
(function(Prism2) {
    const javascript = Prism2.util.clone(Prism2.languages.javascript);
    Prism2.languages.jsx = Prism2.languages.extend("markup", javascript);
    Prism2.languages.jsx.tag.pattern = /<\/?[\w\.:-]+\s*(?:\s+[\w\.:-]+(?:=(?:("|')(\\?[\w\W])*?\1|[^\s'">=]+|(\{[\w\W]*?\})))?\s*)*\/?>/i;
    Prism2.languages.jsx.tag.inside["attr-value"].pattern = /=[^\{](?:('|")[\w\W]*?(\1)|[^\s>]+)/i;
    let jsxExpression = Prism2.util.clone(Prism2.languages.jsx);
    delete jsxExpression.punctuation;
    jsxExpression = Prism2.languages.insertBefore("jsx", "operator", {
        punctuation: /=(?={)|[{}[\];(),.:]/
    }, {
        jsx: jsxExpression
    });
    Prism2.languages.insertBefore("inside", "attr-value", {
        script: {
            // Allow for one level of nesting
            pattern: /=(\{(?:\{[^}]*\}|[^}])+\})/i,
            inside: jsxExpression,
            alias: "language-javascript"
        }
    }, Prism2.languages.jsx.tag);
})($6c76e6bcf00af394$var$Prism);
$6c76e6bcf00af394$var$Prism.languages.scss = $6c76e6bcf00af394$var$Prism.languages.extend("css", {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\w\W]*?\*\/|\/\/.*)/,
        lookbehind: true
    },
    atrule: {
        pattern: /@[\w-]+(?:\([^()]+\)|[^(])*?(?=\s+[{;])/,
        inside: {
            rule: /@[\w-]+/
        }
    },
    // url, compassified
    url: /(?:[-a-z]+-)*url(?=\()/i,
    // CSS selector regex is not appropriate for Sass
    // since there can be lot more things (var, @ directive, nesting..)
    // a selector must start at the end of a property or after a brace (end of other rules or nesting)
    // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
    // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
    // can "pass" as a selector- e.g: proper#{$erty})
    // this one was hard to do, so please be careful if you edit this one :)
    selector: {
        // Initial look-ahead is used to prevent matching of blank selectors
        pattern: /(?=\S)[^@;\{\}\(\)]?([^@;\{\}\(\)]|&|#\{\$[-_\w]+\})+(?=\s*\{(\}|\s|[^\}]+(:|\{)[^\}]+))/m,
        inside: {
            parent: {
                pattern: /&/,
                alias: "important"
            },
            placeholder: /%[-_\w]+/,
            variable: /\$[-_\w]+|#\{\$[-_\w]+\}/
        }
    }
});
$6c76e6bcf00af394$var$Prism.languages.insertBefore("scss", "atrule", {
    keyword: [
        /@(?:if|else(?: if)?|for|each|while|import|extend|debug|warn|mixin|include|function|return|content)/i,
        {
            pattern: /( +)(?:from|through)(?= )/,
            lookbehind: true
        }
    ]
});
$6c76e6bcf00af394$var$Prism.languages.scss.property = {
    pattern: /(?:[\w-]|\$[-_\w]+|#\{\$[-_\w]+\})+(?=\s*:)/i,
    inside: {
        variable: /\$[-_\w]+|#\{\$[-_\w]+\}/
    }
};
$6c76e6bcf00af394$var$Prism.languages.insertBefore("scss", "important", {
    // var and interpolated vars
    variable: /\$[-_\w]+|#\{\$[-_\w]+\}/
});
$6c76e6bcf00af394$var$Prism.languages.insertBefore("scss", "function", {
    placeholder: {
        pattern: /%[-_\w]+/,
        alias: "selector"
    },
    statement: {
        pattern: /\B!(?:default|optional)\b/i,
        alias: "keyword"
    },
    boolean: /\b(?:true|false)\b/,
    null: /\bnull\b/,
    operator: {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|or|not)(?=\s)/,
        lookbehind: true
    }
});
$6c76e6bcf00af394$var$Prism.languages.scss["atrule"].inside.rest = $6c76e6bcf00af394$var$Prism.util.clone($6c76e6bcf00af394$var$Prism.languages.scss);
$6c76e6bcf00af394$var$Prism.languages.typescript = $6c76e6bcf00af394$var$Prism.languages.extend("javascript", {
    keyword: /\b(break|case|async|await|readonly|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|false|finally|for|function|get|if|implements|import|in|instanceof|interface|let|new|null|package|private|protected|public|return|set|static|super|switch|this|throw|true|try|typeof|var|void|while|with|yield|module|declare|constructor|string|Function|any|number|boolean|Array|enum)\b/
});
(function() {
    if (typeof self === "undefined" || !self["Prism"] || !self.document) return;
    const Languages = /*languages_placeholder[*/ {
        html: "HTML",
        xml: "XML",
        svg: "SVG",
        mathml: "MathML",
        css: "CSS",
        clike: "C-like",
        javascript: "JavaScript",
        abap: "ABAP",
        actionscript: "ActionScript",
        apacheconf: "Apache Configuration",
        apl: "APL",
        applescript: "AppleScript",
        asciidoc: "AsciiDoc",
        aspnet: "ASP.NET (C#)",
        autoit: "AutoIt",
        autohotkey: "AutoHotkey",
        basic: "BASIC",
        csharp: "C#",
        cpp: "C++",
        coffeescript: "CoffeeScript",
        "css-extras": "CSS Extras",
        fsharp: "F#",
        glsl: "GLSL",
        graphql: "GraphQL",
        http: "HTTP",
        inform7: "Inform 7",
        json: "JSON",
        latex: "LaTeX",
        livescript: "LiveScript",
        lolcode: "LOLCODE",
        matlab: "MATLAB",
        mel: "MEL",
        nasm: "NASM",
        nginx: "nginx",
        nsis: "NSIS",
        objectivec: "Objective-C",
        ocaml: "OCaml",
        parigp: "PARI/GP",
        php: "PHP",
        "php-extras": "PHP Extras",
        powershell: "PowerShell",
        properties: ".properties",
        protobuf: "Protocol Buffers",
        jsx: "React JSX",
        rest: "reST (reStructuredText)",
        sas: "SAS",
        sass: "Sass (Sass)",
        scss: "Sass (Scss)",
        sql: "SQL",
        typescript: "TypeScript",
        vhdl: "VHDL",
        vim: "vim",
        wiki: "Wiki markup",
        xojo: "Xojo (REALbasic)",
        yaml: "YAML"
    };
    $6c76e6bcf00af394$var$Prism.hooks.add("before-highlight", function(env) {
        const pre = env.element.parentNode;
        if (!pre || !/pre/i.test(pre.nodeName)) return;
        const language = pre.getAttribute("data-language") || Languages[env.language] || env.language.substring(0, 1).toUpperCase() + env.language.substring(1);
        const sib = pre.previousSibling;
        let div, div2;
        if (sib && /\s*\bprism-show-language\b\s*/.test(sib.className) && sib.firstChild && /\s*\bprism-show-language-label\b\s*/.test(sib.firstChild.className)) div2 = sib.firstChild;
        else {
            div = document.createElement("div");
            div2 = document.createElement("div");
            div2.className = "prism-show-language-label";
            div.className = "prism-show-language";
            div.appendChild(div2);
            pre.parentNode.insertBefore(div, pre);
        }
        div2.innerHTML = language;
    });
})();

});

parcelRegister("cTSxh", function(module, exports) {
/**
 * marked - a markdown parser
 * Copyright (c) 2011-2021, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var defaults$5 = {
        exports: {}
    };
    function getDefaults$1() {
        return {
            baseUrl: null,
            breaks: false,
            extensions: null,
            gfm: true,
            headerIds: true,
            headerPrefix: '',
            highlight: null,
            langPrefix: 'language-',
            mangle: true,
            pedantic: false,
            renderer: null,
            sanitize: false,
            sanitizer: null,
            silent: false,
            smartLists: false,
            smartypants: false,
            tokenizer: null,
            walkTokens: null,
            xhtml: false
        };
    }
    function changeDefaults$1(newDefaults) {
        defaults$5.exports.defaults = newDefaults;
    }
    defaults$5.exports = {
        defaults: getDefaults$1(),
        getDefaults: getDefaults$1,
        changeDefaults: changeDefaults$1
    };
    /**
   * Helpers
   */ var escapeTest = /[&<>"']/;
    var escapeReplace = /[&<>"']/g;
    var escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
    var escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
    var escapeReplacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    var getEscapeReplacement = function getEscapeReplacement(ch) {
        return escapeReplacements[ch];
    };
    function escape$2(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    function unescape$1(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, function(_, n) {
            n = n.toLowerCase();
            if (n === 'colon') return ':';
            if (n.charAt(0) === '#') return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return '';
        });
    }
    var caret = /(^|[^\[])\^/g;
    function edit$1(regex, opt) {
        regex = regex.source || regex;
        opt = opt || '';
        var obj = {
            replace: function replace(name, val) {
                val = val.source || val;
                val = val.replace(caret, '$1');
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: function getRegex() {
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    var nonWordAndColonTest = /[^\w:]/g;
    var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    function cleanUrl$1(sanitize, base, href) {
        if (sanitize) {
            var prot;
            try {
                prot = decodeURIComponent(unescape$1(href)).replace(nonWordAndColonTest, '').toLowerCase();
            } catch (e) {
                return null;
            }
            if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) return null;
        }
        if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
        try {
            href = encodeURI(href).replace(/%25/g, '%');
        } catch (e) {
            return null;
        }
        return href;
    }
    var baseUrls = {};
    var justDomain = /^[^:]+:\/*[^/]*$/;
    var protocol = /^([^:]+:)[\s\S]*$/;
    var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    function resolveUrl(base, href) {
        if (!baseUrls[' ' + base]) {
            // we can ignore everything in base after the last slash of its path component,
            // but we might need to add _that_
            // https://tools.ietf.org/html/rfc3986#section-3
            if (justDomain.test(base)) baseUrls[' ' + base] = base + '/';
            else baseUrls[' ' + base] = rtrim$1(base, '/', true);
        }
        base = baseUrls[' ' + base];
        var relativeBase = base.indexOf(':') === -1;
        if (href.substring(0, 2) === '//') {
            if (relativeBase) return href;
            return base.replace(protocol, '$1') + href;
        } else if (href.charAt(0) === '/') {
            if (relativeBase) return href;
            return base.replace(domain, '$1') + href;
        } else return base + href;
    }
    var noopTest$1 = {
        exec: function noopTest() {}
    };
    function merge$2(obj) {
        var i = 1, target, key;
        for(; i < arguments.length; i++){
            target = arguments[i];
            for(key in target)if (Object.prototype.hasOwnProperty.call(target, key)) obj[key] = target[key];
        }
        return obj;
    }
    function splitCells$1(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function(match, offset, str) {
            var escaped = false, curr = offset;
            while(--curr >= 0 && str[curr] === '\\')escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return '|';
            else // add space before unescaped |
            return ' |';
        }), cells = row.split(/ \|/);
        var i = 0;
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push('');
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, '|');
        return cells;
    } // Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
    // /c*$/ is vulnerable to REDOS.
    // invert: Remove suffix of non-c chars instead. Default falsey.
    function rtrim$1(str, c, invert) {
        var l = str.length;
        if (l === 0) return '';
         // Length of suffix matching the invert condition.
        var suffLen = 0; // Step left until we fail to match the invert condition.
        while(suffLen < l){
            var currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.substr(0, l - suffLen);
    }
    function findClosingBracket$1(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        var l = str.length;
        var level = 0, i = 0;
        for(; i < l; i++){
            if (str[i] === '\\') i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function checkSanitizeDeprecation$1(opt) {
        if (opt && opt.sanitize && !opt.silent) console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    } // copied from https://stackoverflow.com/a/5450113/806777
    function repeatString$1(pattern, count) {
        if (count < 1) return '';
        var result = '';
        while(count > 1){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result + pattern;
    }
    var helpers = {
        escape: escape$2,
        unescape: unescape$1,
        edit: edit$1,
        cleanUrl: cleanUrl$1,
        resolveUrl: resolveUrl,
        noopTest: noopTest$1,
        merge: merge$2,
        splitCells: splitCells$1,
        rtrim: rtrim$1,
        findClosingBracket: findClosingBracket$1,
        checkSanitizeDeprecation: checkSanitizeDeprecation$1,
        repeatString: repeatString$1
    };
    var defaults$4 = defaults$5.exports.defaults;
    var rtrim = helpers.rtrim, splitCells = helpers.splitCells, _escape = helpers.escape, findClosingBracket = helpers.findClosingBracket;
    function outputLink(cap, link, raw) {
        var href = link.href;
        var title = link.title ? _escape(link.title) : null;
        var text = cap[1].replace(/\\([\[\]])/g, '$1');
        if (cap[0].charAt(0) !== '!') return {
            type: 'link',
            raw: raw,
            href: href,
            title: title,
            text: text
        };
        else return {
            type: 'image',
            raw: raw,
            href: href,
            title: title,
            text: _escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        var indentToCode = matchIndentToCode[1];
        return text.split('\n').map(function(node) {
            var matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            var indentInNode = matchIndentInNode[0];
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join('\n');
    }
    /**
   * Tokenizer
   */ var Tokenizer_1 = /*#__PURE__*/ function() {
        function Tokenizer(options) {
            this.options = options || defaults$4;
        }
        var _proto = Tokenizer.prototype;
        _proto.space = function space(src) {
            var cap = this.rules.block.newline.exec(src);
            if (cap) {
                if (cap[0].length > 1) return {
                    type: 'space',
                    raw: cap[0]
                };
                return {
                    raw: '\n'
                };
            }
        };
        _proto.code = function code(src) {
            var cap = this.rules.block.code.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ {1,4}/gm, '');
                return {
                    type: 'code',
                    raw: cap[0],
                    codeBlockStyle: 'indented',
                    text: !this.options.pedantic ? rtrim(text, '\n') : text
                };
            }
        };
        _proto.fences = function fences(src) {
            var cap = this.rules.block.fences.exec(src);
            if (cap) {
                var raw = cap[0];
                var text = indentCodeCompensation(raw, cap[3] || '');
                return {
                    type: 'code',
                    raw: raw,
                    lang: cap[2] ? cap[2].trim() : cap[2],
                    text: text
                };
            }
        };
        _proto.heading = function heading(src) {
            var cap = this.rules.block.heading.exec(src);
            if (cap) {
                var text = cap[2].trim(); // remove trailing #s
                if (/#$/.test(text)) {
                    var trimmed = rtrim(text, '#');
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text
                };
            }
        };
        _proto.nptable = function nptable(src) {
            var cap = this.rules.block.nptable.exec(src);
            if (cap) {
                var item = {
                    type: 'table',
                    header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
                    align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
                    cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : [],
                    raw: cap[0]
                };
                if (item.header.length === item.align.length) {
                    var l = item.align.length;
                    var i;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = 'right';
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = 'center';
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = 'left';
                        else item.align[i] = null;
                    }
                    l = item.cells.length;
                    for(i = 0; i < l; i++)item.cells[i] = splitCells(item.cells[i], item.header.length);
                    return item;
                }
            }
        };
        _proto.hr = function hr(src) {
            var cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: 'hr',
                raw: cap[0]
            };
        };
        _proto.blockquote = function blockquote(src) {
            var cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ *> ?/gm, '');
                return {
                    type: 'blockquote',
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.list = function list(src) {
            var cap = this.rules.block.list.exec(src);
            if (cap) {
                var raw = cap[0];
                var bull = cap[2];
                var isordered = bull.length > 1;
                var list = {
                    type: 'list',
                    raw: raw,
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : '',
                    loose: false,
                    items: []
                }; // Get each top-level item.
                var itemMatch = cap[0].match(this.rules.block.item);
                var next = false, item, space, bcurr, bnext, addBack, loose, istask, ischecked, endMatch;
                var l = itemMatch.length;
                bcurr = this.rules.block.listItemStart.exec(itemMatch[0]);
                for(var i = 0; i < l; i++){
                    item = itemMatch[i];
                    raw = item;
                    if (!this.options.pedantic) {
                        // Determine if current item contains the end of the list
                        endMatch = item.match(new RegExp('\\n\\s*\\n {0,' + (bcurr[0].length - 1) + '}\\S'));
                        if (endMatch) {
                            addBack = item.length - endMatch.index + itemMatch.slice(i + 1).join('\n').length;
                            list.raw = list.raw.substring(0, list.raw.length - addBack);
                            item = item.substring(0, endMatch.index);
                            raw = item;
                            l = i + 1;
                        }
                    } // Determine whether the next list item belongs here.
                    // Backpedal if it does not belong in this list.
                    if (i !== l - 1) {
                        bnext = this.rules.block.listItemStart.exec(itemMatch[i + 1]);
                        if (!this.options.pedantic ? bnext[1].length >= bcurr[0].length || bnext[1].length > 3 : bnext[1].length > bcurr[1].length) {
                            // nested list or continuation
                            itemMatch.splice(i, 2, itemMatch[i] + (!this.options.pedantic && bnext[1].length < bcurr[0].length && !itemMatch[i].match(/\n$/) ? '' : '\n') + itemMatch[i + 1]);
                            i--;
                            l--;
                            continue;
                        } else if (!this.options.pedantic || this.options.smartLists ? bnext[2][bnext[2].length - 1] !== bull[bull.length - 1] : isordered === (bnext[2].length === 1)) {
                            addBack = itemMatch.slice(i + 1).join('\n').length;
                            list.raw = list.raw.substring(0, list.raw.length - addBack);
                            i = l - 1;
                        }
                        bcurr = bnext;
                    } // Remove the list item's bullet
                    // so it is seen as the next token.
                    space = item.length;
                    item = item.replace(/^ *([*+-]|\d+[.)]) ?/, ''); // Outdent whatever the
                    // list item contains. Hacky.
                    if (~item.indexOf('\n ')) {
                        space -= item.length;
                        item = !this.options.pedantic ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '') : item.replace(/^ {1,4}/gm, '');
                    } // trim item newlines at end
                    item = rtrim(item, '\n');
                    if (i !== l - 1) raw = raw + '\n';
                     // Determine whether item is loose or not.
                    // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
                    // for discount behavior.
                    loose = next || /\n\n(?!\s*$)/.test(raw);
                    if (i !== l - 1) {
                        next = raw.slice(-2) === '\n\n';
                        if (!loose) loose = next;
                    }
                    if (loose) list.loose = true;
                     // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.test(item);
                        ischecked = undefined;
                        if (istask) {
                            ischecked = item[1] !== ' ';
                            item = item.replace(/^\[[ xX]\] +/, '');
                        }
                    }
                    list.items.push({
                        type: 'list_item',
                        raw: raw,
                        task: istask,
                        checked: ischecked,
                        loose: loose,
                        text: item
                    });
                }
                return list;
            }
        };
        _proto.html = function html(src) {
            var cap = this.rules.block.html.exec(src);
            if (cap) return {
                type: this.options.sanitize ? 'paragraph' : 'html',
                raw: cap[0],
                pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
                text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0]
            };
        };
        _proto.def = function def(src) {
            var cap = this.rules.block.def.exec(src);
            if (cap) {
                if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
                var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
                return {
                    type: 'def',
                    tag: tag,
                    raw: cap[0],
                    href: cap[2],
                    title: cap[3]
                };
            }
        };
        _proto.table = function table(src) {
            var cap = this.rules.block.table.exec(src);
            if (cap) {
                var item = {
                    type: 'table',
                    header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
                    align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
                    cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
                };
                if (item.header.length === item.align.length) {
                    item.raw = cap[0];
                    var l = item.align.length;
                    var i;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = 'right';
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = 'center';
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = 'left';
                        else item.align[i] = null;
                    }
                    l = item.cells.length;
                    for(i = 0; i < l; i++)item.cells[i] = splitCells(item.cells[i].replace(/^ *\| *| *\| *$/g, ''), item.header.length);
                    return item;
                }
            }
        };
        _proto.lheading = function lheading(src) {
            var cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: 'heading',
                raw: cap[0],
                depth: cap[2].charAt(0) === '=' ? 1 : 2,
                text: cap[1]
            };
        };
        _proto.paragraph = function paragraph(src) {
            var cap = this.rules.block.paragraph.exec(src);
            if (cap) return {
                type: 'paragraph',
                raw: cap[0],
                text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1]
            };
        };
        _proto.text = function text(src) {
            var cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: 'text',
                raw: cap[0],
                text: cap[0]
            };
        };
        _proto.escape = function escape(src) {
            var cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: 'escape',
                raw: cap[0],
                text: _escape(cap[1])
            };
        };
        _proto.tag = function tag(src, inLink, inRawBlock) {
            var cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!inLink && /^<a /i.test(cap[0])) inLink = true;
                else if (inLink && /^<\/a>/i.test(cap[0])) inLink = false;
                if (!inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) inRawBlock = true;
                else if (inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) inRawBlock = false;
                return {
                    type: this.options.sanitize ? 'text' : 'html',
                    raw: cap[0],
                    inLink: inLink,
                    inRawBlock: inRawBlock,
                    text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0]
                };
            }
        };
        _proto.link = function link(src) {
            var cap = this.rules.inline.link.exec(src);
            if (cap) {
                var trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                     // ending angle bracket cannot be escaped
                    var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    var lastParenIndex = findClosingBracket(cap[2], '()');
                    if (lastParenIndex > -1) {
                        var start = cap[0].indexOf('!') === 0 ? 5 : 4;
                        var linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = '';
                    }
                }
                var href = cap[2];
                var title = '';
                if (this.options.pedantic) {
                    // split pedantic href and title
                    var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : '';
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
                    title: title ? title.replace(this.rules.inline._escapes, '$1') : title
                }, cap[0]);
            }
        };
        _proto.reflink = function reflink(src, links) {
            var cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
                link = links[link.toLowerCase()];
                if (!link || !link.href) {
                    var text = cap[0].charAt(0);
                    return {
                        type: 'text',
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0]);
            }
        };
        _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
            if (prevChar === void 0) prevChar = '';
            var match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return; // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD1E\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var nextChar = match[1] || match[2] || '';
            if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
                var lLength = match[0].length - 1;
                var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0; // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = rDelim.length;
                    if (match[3] || match[4]) {
                        // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) // either Left or Right Delim
                    {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal); // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) return {
                        type: 'em',
                        raw: src.slice(0, lLength + match.index + rLength + 1),
                        text: src.slice(1, lLength + match.index + rLength)
                    };
                     // Create 'strong' if smallest delimiter has even char count. **a***
                    return {
                        type: 'strong',
                        raw: src.slice(0, lLength + match.index + rLength + 1),
                        text: src.slice(2, lLength + match.index + rLength - 1)
                    };
                }
            }
        };
        _proto.codespan = function codespan(src) {
            var cap = this.rules.inline.code.exec(src);
            if (cap) {
                var text = cap[2].replace(/\n/g, ' ');
                var hasNonSpaceChars = /[^ ]/.test(text);
                var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = _escape(text, true);
                return {
                    type: 'codespan',
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.br = function br(src) {
            var cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: 'br',
                raw: cap[0]
            };
        };
        _proto.del = function del(src) {
            var cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: 'del',
                raw: cap[0],
                text: cap[2]
            };
        };
        _proto.autolink = function autolink(src, mangle) {
            var cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                var text, href;
                if (cap[2] === '@') {
                    text = _escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
                    href = 'mailto:' + text;
                } else {
                    text = _escape(cap[1]);
                    href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.url = function url(src, mangle) {
            var cap;
            if (cap = this.rules.inline.url.exec(src)) {
                var text, href;
                if (cap[2] === '@') {
                    text = _escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
                    href = 'mailto:' + text;
                } else {
                    // do extended autolink path validation
                    var prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = _escape(cap[0]);
                    if (cap[1] === 'www.') href = 'http://' + text;
                    else href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.inlineText = function inlineText(src, inRawBlock, smartypants) {
            var cap = this.rules.inline.text.exec(src);
            if (cap) {
                var text;
                if (inRawBlock) text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0];
                else text = _escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
                return {
                    type: 'text',
                    raw: cap[0],
                    text: text
                };
            }
        };
        return Tokenizer;
    }();
    var noopTest = helpers.noopTest, edit = helpers.edit, merge$1 = helpers.merge;
    /**
   * Block-Level Grammar
   */ var block$1 = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
        hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?! {0,3}bull )\n*|\s*$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
        nptable: noopTest,
        table: noopTest,
        lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block$1._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
    block$1._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block$1.def = edit(block$1.def).replace('label', block$1._label).replace('title', block$1._title).getRegex();
    block$1.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block$1.item = /^( *)(bull) ?[^\n]*(?:\n(?! *bull ?)[^\n]*)*/;
    block$1.item = edit(block$1.item, 'gm').replace(/bull/g, block$1.bullet).getRegex();
    block$1.listItemStart = edit(/^( *)(bull) */).replace('bull', block$1.bullet).getRegex();
    block$1.list = edit(block$1.list).replace(/bull/g, block$1.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block$1.def.source + ')').getRegex();
    block$1._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block$1._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block$1.html = edit(block$1.html, 'i').replace('comment', block$1._comment).replace('tag', block$1._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block$1.paragraph = edit(block$1._paragraph).replace('hr', block$1.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
    .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block$1._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block$1.blockquote = edit(block$1.blockquote).replace('paragraph', block$1.paragraph).getRegex();
    /**
   * Normal Block Grammar
   */ block$1.normal = merge$1({}, block$1);
    /**
   * GFM Block Grammar
   */ block$1.gfm = merge$1({}, block$1.normal, {
        nptable: "^ *([^|\\n ].*\\|.*)\\n {0,3}([-:]+ *\\|[-| :]*)(?:\\n((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)",
        // Cells
        table: "^ *\\|(.+)\\n {0,3}\\|?( *[-:]+[-| :]*)(?:\\n *((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    });
    block$1.gfm.nptable = edit(block$1.gfm.nptable).replace('hr', block$1.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block$1._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block$1.gfm.table = edit(block$1.gfm.table).replace('hr', block$1.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block$1._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */ block$1.pedantic = merge$1({}, block$1.normal, {
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace('comment', block$1._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        paragraph: edit(block$1.normal._paragraph).replace('hr', block$1.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block$1.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
    });
    /**
   * Inline-Level Grammar
   */ var inline$1 = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
        nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
        reflinkSearch: 'reflink|nolink(?!\\()',
        emStrong: {
            lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
            //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //        () Skip other delimiter (1) #***                   (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
            rDelimAst: /\_\_[^_*]*?\*[^_*]*?\_\_|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
            rDelimUnd: /\*\*[^_*]*?\_[^_*]*?\*\*|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
    }; // list of punctuation marks from CommonMark spec
    // without * and _ to handle the different emphasis markers * and _
    inline$1._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
    inline$1.punctuation = edit(inline$1.punctuation).replace(/punctuation/g, inline$1._punctuation).getRegex(); // sequences em should skip over [title](link), `code`, <html>
    inline$1.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    inline$1.escapedEmSt = /\\\*|\\_/g;
    inline$1._comment = edit(block$1._comment).replace('(?:-->|$)', '-->').getRegex();
    inline$1.emStrong.lDelim = edit(inline$1.emStrong.lDelim).replace(/punct/g, inline$1._punctuation).getRegex();
    inline$1.emStrong.rDelimAst = edit(inline$1.emStrong.rDelimAst, 'g').replace(/punct/g, inline$1._punctuation).getRegex();
    inline$1.emStrong.rDelimUnd = edit(inline$1.emStrong.rDelimUnd, 'g').replace(/punct/g, inline$1._punctuation).getRegex();
    inline$1._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline$1._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline$1._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline$1.autolink = edit(inline$1.autolink).replace('scheme', inline$1._scheme).replace('email', inline$1._email).getRegex();
    inline$1._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline$1.tag = edit(inline$1.tag).replace('comment', inline$1._comment).replace('attribute', inline$1._attribute).getRegex();
    inline$1._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline$1._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline$1._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline$1.link = edit(inline$1.link).replace('label', inline$1._label).replace('href', inline$1._href).replace('title', inline$1._title).getRegex();
    inline$1.reflink = edit(inline$1.reflink).replace('label', inline$1._label).getRegex();
    inline$1.reflinkSearch = edit(inline$1.reflinkSearch, 'g').replace('reflink', inline$1.reflink).replace('nolink', inline$1.nolink).getRegex();
    /**
   * Normal Inline Grammar
   */ inline$1.normal = merge$1({}, inline$1);
    /**
   * Pedantic Inline Grammar
   */ inline$1.pedantic = merge$1({}, inline$1.normal, {
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline$1._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline$1._label).getRegex()
    });
    /**
   * GFM Inline Grammar
   */ inline$1.gfm = merge$1({}, inline$1.normal, {
        escape: edit(inline$1.escape).replace('])', '~|])').getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline$1.gfm.url = edit(inline$1.gfm.url, 'i').replace('email', inline$1.gfm._extended_email).getRegex();
    /**
   * GFM + Line Breaks Inline Grammar
   */ inline$1.breaks = merge$1({}, inline$1.gfm, {
        br: edit(inline$1.br).replace('{2,}', '*').getRegex(),
        text: edit(inline$1.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
    });
    var rules = {
        block: block$1,
        inline: inline$1
    };
    var Tokenizer$1 = Tokenizer_1;
    var defaults$3 = defaults$5.exports.defaults;
    var block = rules.block, inline = rules.inline;
    var repeatString = helpers.repeatString;
    /**
   * smartypants text replacement
   */ function smartypants(text) {
        return text // em-dashes
        .replace(/---/g, "\u2014") // en-dashes
        .replace(/--/g, "\u2013") // opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018") // closing singles & apostrophes
        .replace(/'/g, "\u2019") // opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C") // closing doubles
        .replace(/"/g, "\u201D") // ellipses
        .replace(/\.{3}/g, "\u2026");
    }
    /**
   * mangle email addresses
   */ function mangle(text) {
        var out = '', i, ch;
        var l = text.length;
        for(i = 0; i < l; i++){
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) ch = 'x' + ch.toString(16);
            out += '&#' + ch + ';';
        }
        return out;
    }
    /**
   * Block Lexer
   */ var Lexer_1 = /*#__PURE__*/ function() {
        function Lexer(options) {
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || defaults$3;
            this.options.tokenizer = this.options.tokenizer || new Tokenizer$1();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            var rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
     * Expose Rules
     */ /**
     * Static Lex Method
     */ Lexer.lex = function lex(src, options) {
            var lexer = new Lexer(options);
            return lexer.lex(src);
        };
        Lexer.lexInline = function lexInline(src, options) {
            var lexer = new Lexer(options);
            return lexer.inlineTokens(src);
        };
        var _proto = Lexer.prototype;
        _proto.lex = function lex(src) {
            src = src.replace(/\r\n|\r/g, '\n').replace(/\t/g, '    ');
            this.blockTokens(src, this.tokens, true);
            this.inline(this.tokens);
            return this.tokens;
        };
        _proto.blockTokens = function blockTokens(src, tokens, top) {
            var _this = this;
            if (tokens === void 0) tokens = [];
            if (top === void 0) top = true;
            if (this.options.pedantic) src = src.replace(/^ +$/gm, '');
            var token, i, l, lastToken, cutSrc, lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(extTokenizer) {
                    if (token = extTokenizer.call(_this, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                 // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.type) tokens.push(token);
                    continue;
                } // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1]; // An indented code block cannot interrupt a paragraph.
                    if (lastToken && lastToken.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                    } else tokens.push(token);
                    continue;
                } // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // table no leading pipe (gfm)
                if (token = this.tokenizer.nptable(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    token.tokens = this.blockTokens(token.text, [], top);
                    tokens.push(token);
                    continue;
                } // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    l = token.items.length;
                    for(i = 0; i < l; i++)token.items[i].tokens = this.blockTokens(token.items[i].text, [], false);
                    tokens.push(token);
                    continue;
                } // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // def
                if (top && (token = this.tokenizer.def(src))) {
                    src = src.substring(token.raw.length);
                    if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                } // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call(this, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                } // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _proto.inline = function inline(tokens) {
            var i, j, k, l2, row, token;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                switch(token.type){
                    case 'paragraph':
                    case 'text':
                    case 'heading':
                        token.tokens = [];
                        this.inlineTokens(token.text, token.tokens);
                        break;
                    case 'table':
                        token.tokens = {
                            header: [],
                            cells: []
                        }; // header
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++){
                            token.tokens.header[j] = [];
                            this.inlineTokens(token.header[j], token.tokens.header[j]);
                        } // cells
                        l2 = token.cells.length;
                        for(j = 0; j < l2; j++){
                            row = token.cells[j];
                            token.tokens.cells[j] = [];
                            for(k = 0; k < row.length; k++){
                                token.tokens.cells[j][k] = [];
                                this.inlineTokens(row[k], token.tokens.cells[j][k]);
                            }
                        }
                        break;
                    case 'blockquote':
                        this.inline(token.tokens);
                        break;
                    case 'list':
                        l2 = token.items.length;
                        for(j = 0; j < l2; j++)this.inline(token.items[j].tokens);
                        break;
                }
            }
            return tokens;
        };
        _proto.inlineTokens = function inlineTokens(src, tokens, inLink, inRawBlock) {
            var _this2 = this;
            if (tokens === void 0) tokens = [];
            if (inLink === void 0) inLink = false;
            if (inRawBlock === void 0) inRawBlock = false;
            var token, lastToken, cutSrc; // String with links masked to avoid interference with em and strong
            var maskedSrc = src;
            var match;
            var keepPrevChar, prevChar; // Mask out reflinks
            if (this.tokens.links) {
                var links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            } // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
             // Mask out escaped em & strong delimiters
            while((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
            while(src){
                if (!keepPrevChar) prevChar = '';
                keepPrevChar = false; // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(extTokenizer) {
                    if (token = extTokenizer.call(_this2, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                 // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // tag
                if (token = this.tokenizer.tag(src, inLink, inRawBlock)) {
                    src = src.substring(token.raw.length);
                    inLink = token.inLink;
                    inRawBlock = token.inRawBlock;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                } // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    if (token.type === 'link') token.tokens = this.inlineTokens(token.text, [], true, inRawBlock);
                    tokens.push(token);
                    continue;
                } // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (token.type === 'link') {
                        token.tokens = this.inlineTokens(token.text, [], true, inRawBlock);
                        tokens.push(token);
                    } else if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                } // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    token.tokens = this.inlineTokens(token.text, [], inLink, inRawBlock);
                    tokens.push(token);
                    continue;
                } // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    token.tokens = this.inlineTokens(token.text, [], inLink, inRawBlock);
                    tokens.push(token);
                    continue;
                } // autolink
                if (token = this.tokenizer.autolink(src, mangle)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // url (gfm)
                if (!inLink && (token = this.tokenizer.url(src, mangle))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this2.options.extensions.startInline.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call(this, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (token = this.tokenizer.inlineText(cutSrc, inRawBlock, smartypants)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== '_') // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _createClass(Lexer, null, [
            {
                key: "rules",
                get: function get() {
                    return {
                        block: block,
                        inline: inline
                    };
                }
            }
        ]);
        return Lexer;
    }();
    var defaults$2 = defaults$5.exports.defaults;
    var cleanUrl = helpers.cleanUrl, escape$1 = helpers.escape;
    /**
   * Renderer
   */ var Renderer_1 = /*#__PURE__*/ function() {
        function Renderer(options) {
            this.options = options || defaults$2;
        }
        var _proto = Renderer.prototype;
        _proto.code = function code(_code, infostring, escaped) {
            var lang = (infostring || '').match(/\S*/)[0];
            if (this.options.highlight) {
                var out = this.options.highlight(_code, lang);
                if (out != null && out !== _code) {
                    escaped = true;
                    _code = out;
                }
            }
            _code = _code.replace(/\n$/, '') + '\n';
            if (!lang) return '<pre><code>' + (escaped ? _code : escape$1(_code, true)) + '</code></pre>\n';
            return '<pre><code class="' + this.options.langPrefix + escape$1(lang, true) + '">' + (escaped ? _code : escape$1(_code, true)) + '</code></pre>\n';
        };
        _proto.blockquote = function blockquote(quote) {
            return '<blockquote>\n' + quote + '</blockquote>\n';
        };
        _proto.html = function html(_html) {
            return _html;
        };
        _proto.heading = function heading(text, level, raw, slugger) {
            if (this.options.headerIds) return '<h' + level + ' id="' + this.options.headerPrefix + slugger.slug(raw) + '">' + text + '</h' + level + '>\n';
             // ignore IDs
            return '<h' + level + '>' + text + '</h' + level + '>\n';
        };
        _proto.hr = function hr() {
            return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
        };
        _proto.list = function list(body, ordered, start) {
            var type = ordered ? 'ol' : 'ul', startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
            return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
        };
        _proto.listitem = function listitem(text) {
            return '<li>' + text + '</li>\n';
        };
        _proto.checkbox = function checkbox(checked) {
            return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
        };
        _proto.paragraph = function paragraph(text) {
            return '<p>' + text + '</p>\n';
        };
        _proto.table = function table(header, body) {
            if (body) body = '<tbody>' + body + '</tbody>';
            return "<table>\n<thead>\n" + header + '</thead>\n' + body + '</table>\n';
        };
        _proto.tablerow = function tablerow(content) {
            return '<tr>\n' + content + '</tr>\n';
        };
        _proto.tablecell = function tablecell(content, flags) {
            var type = flags.header ? 'th' : 'td';
            var tag = flags.align ? '<' + type + ' align="' + flags.align + '">' : '<' + type + '>';
            return tag + content + '</' + type + '>\n';
        } // span level renderer
        ;
        _proto.strong = function strong(text) {
            return '<strong>' + text + '</strong>';
        };
        _proto.em = function em(text) {
            return '<em>' + text + '</em>';
        };
        _proto.codespan = function codespan(text) {
            return '<code>' + text + '</code>';
        };
        _proto.br = function br() {
            return this.options.xhtml ? '<br/>' : '<br>';
        };
        _proto.del = function del(text) {
            return '<del>' + text + '</del>';
        };
        _proto.link = function link(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<a href="' + escape$1(href) + '"';
            if (title) out += ' title="' + title + '"';
            out += '>' + text + '</a>';
            return out;
        };
        _proto.image = function image(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<img src="' + href + '" alt="' + text + '"';
            if (title) out += ' title="' + title + '"';
            out += this.options.xhtml ? '/>' : '>';
            return out;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        return Renderer;
    }();
    /**
   * TextRenderer
   * returns only the textual part of the token
   */ var TextRenderer_1 = /*#__PURE__*/ function() {
        function TextRenderer() {}
        var _proto = TextRenderer.prototype;
        // no need for block level renderers
        _proto.strong = function strong(text) {
            return text;
        };
        _proto.em = function em(text) {
            return text;
        };
        _proto.codespan = function codespan(text) {
            return text;
        };
        _proto.del = function del(text) {
            return text;
        };
        _proto.html = function html(text) {
            return text;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        _proto.link = function link(href, title, text) {
            return '' + text;
        };
        _proto.image = function image(href, title, text) {
            return '' + text;
        };
        _proto.br = function br() {
            return '';
        };
        return TextRenderer;
    }();
    /**
   * Slugger generates header id
   */ var Slugger_1 = /*#__PURE__*/ function() {
        function Slugger() {
            this.seen = {};
        }
        var _proto = Slugger.prototype;
        _proto.serialize = function serialize(value) {
            return value.toLowerCase().trim() // remove html tags
            .replace(/<[!\/a-z].*?>/ig, '') // remove unwanted chars
            .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
        };
        _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
            var slug = originalSlug;
            var occurenceAccumulator = 0;
            if (this.seen.hasOwnProperty(slug)) {
                occurenceAccumulator = this.seen[originalSlug];
                do {
                    occurenceAccumulator++;
                    slug = originalSlug + '-' + occurenceAccumulator;
                }while (this.seen.hasOwnProperty(slug));
            }
            if (!isDryRun) {
                this.seen[originalSlug] = occurenceAccumulator;
                this.seen[slug] = 0;
            }
            return slug;
        };
        _proto.slug = function slug(value, options) {
            if (options === void 0) options = {};
            var slug = this.serialize(value);
            return this.getNextSafeSlug(slug, options.dryrun);
        };
        return Slugger;
    }();
    var Renderer$1 = Renderer_1;
    var TextRenderer$1 = TextRenderer_1;
    var Slugger$1 = Slugger_1;
    var defaults$1 = defaults$5.exports.defaults;
    var unescape = helpers.unescape;
    /**
   * Parsing & Compiling
   */ var Parser_1 = /*#__PURE__*/ function() {
        function Parser(options) {
            this.options = options || defaults$1;
            this.options.renderer = this.options.renderer || new Renderer$1();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new TextRenderer$1();
            this.slugger = new Slugger$1();
        }
        /**
     * Static Parse Method
     */ Parser.parse = function parse(tokens, options) {
            var parser = new Parser(options);
            return parser.parse(tokens);
        };
        Parser.parseInline = function parseInline(tokens, options) {
            var parser = new Parser(options);
            return parser.parseInline(tokens);
        };
        var _proto = Parser.prototype;
        _proto.parse = function parse(tokens, top) {
            if (top === void 0) top = true;
            var out = '', i, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i]; // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call(this, token);
                    if (ret !== false || ![
                        'space',
                        'hr',
                        'heading',
                        'code',
                        'table',
                        'blockquote',
                        'list',
                        'html',
                        'paragraph',
                        'text'
                    ].includes(token.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                switch(token.type){
                    case 'space':
                        continue;
                    case 'hr':
                        out += this.renderer.hr();
                        continue;
                    case 'heading':
                        out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
                        continue;
                    case 'code':
                        out += this.renderer.code(token.text, token.lang, token.escaped);
                        continue;
                    case 'table':
                        header = ''; // header
                        cell = '';
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++)cell += this.renderer.tablecell(this.parseInline(token.tokens.header[j]), {
                            header: true,
                            align: token.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        body = '';
                        l2 = token.cells.length;
                        for(j = 0; j < l2; j++){
                            row = token.tokens.cells[j];
                            cell = '';
                            l3 = row.length;
                            for(k = 0; k < l3; k++)cell += this.renderer.tablecell(this.parseInline(row[k]), {
                                header: false,
                                align: token.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    case 'blockquote':
                        body = this.parse(token.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    case 'list':
                        ordered = token.ordered;
                        start = token.start;
                        loose = token.loose;
                        l2 = token.items.length;
                        body = '';
                        for(j = 0; j < l2; j++){
                            item = token.items[j];
                            checked = item.checked;
                            task = item.task;
                            itemBody = '';
                            if (item.task) {
                                checkbox = this.renderer.checkbox(checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === 'text') {
                                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: 'text',
                                        text: checkbox
                                    });
                                } else itemBody += checkbox;
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    case 'html':
                        // TODO parse inline content if parameter markdown=1
                        out += this.renderer.html(token.text);
                        continue;
                    case 'paragraph':
                        out += this.renderer.paragraph(this.parseInline(token.tokens));
                        continue;
                    case 'text':
                        body = token.tokens ? this.parseInline(token.tokens) : token.text;
                        while(i + 1 < l && tokens[i + 1].type === 'text'){
                            token = tokens[++i];
                            body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        _proto.parseInline = function parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            var out = '', i, token, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i]; // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call(this, token);
                    if (ret !== false || ![
                        'escape',
                        'html',
                        'link',
                        'image',
                        'strong',
                        'em',
                        'codespan',
                        'br',
                        'del',
                        'text'
                    ].includes(token.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                switch(token.type){
                    case 'escape':
                        out += renderer.text(token.text);
                        break;
                    case 'html':
                        out += renderer.html(token.text);
                        break;
                    case 'link':
                        out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
                        break;
                    case 'image':
                        out += renderer.image(token.href, token.title, token.text);
                        break;
                    case 'strong':
                        out += renderer.strong(this.parseInline(token.tokens, renderer));
                        break;
                    case 'em':
                        out += renderer.em(this.parseInline(token.tokens, renderer));
                        break;
                    case 'codespan':
                        out += renderer.codespan(token.text);
                        break;
                    case 'br':
                        out += renderer.br();
                        break;
                    case 'del':
                        out += renderer.del(this.parseInline(token.tokens, renderer));
                        break;
                    case 'text':
                        out += renderer.text(token.text);
                        break;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        return Parser;
    }();
    var Lexer = Lexer_1;
    var Parser = Parser_1;
    var Tokenizer = Tokenizer_1;
    var Renderer = Renderer_1;
    var TextRenderer = TextRenderer_1;
    var Slugger = Slugger_1;
    var merge = helpers.merge, checkSanitizeDeprecation = helpers.checkSanitizeDeprecation, escape = helpers.escape;
    var getDefaults = defaults$5.exports.getDefaults, changeDefaults = defaults$5.exports.changeDefaults, defaults = defaults$5.exports.defaults;
    /**
   * Marked
   */ function marked(src, opt, callback) {
        // throw error in case of non string input
        if (typeof src === 'undefined' || src === null) throw new Error('marked(): input parameter is undefined or null');
        if (typeof src !== 'string') throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
        if (typeof opt === 'function') {
            callback = opt;
            opt = null;
        }
        opt = merge({}, marked.defaults, opt || {});
        checkSanitizeDeprecation(opt);
        if (callback) {
            var highlight = opt.highlight;
            var tokens;
            try {
                tokens = Lexer.lex(src, opt);
            } catch (e) {
                return callback(e);
            }
            var done = function done(err) {
                var out;
                if (!err) try {
                    if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
                    out = Parser.parse(tokens, opt);
                } catch (e) {
                    err = e;
                }
                opt.highlight = highlight;
                return err ? callback(err) : callback(null, out);
            };
            if (!highlight || highlight.length < 3) return done();
            delete opt.highlight;
            if (!tokens.length) return done();
            var pending = 0;
            marked.walkTokens(tokens, function(token) {
                if (token.type === 'code') {
                    pending++;
                    setTimeout(function() {
                        highlight(token.text, token.lang, function(err, code) {
                            if (err) return done(err);
                            if (code != null && code !== token.text) {
                                token.text = code;
                                token.escaped = true;
                            }
                            pending--;
                            if (pending === 0) done();
                        });
                    }, 0);
                }
            });
            if (pending === 0) done();
            return;
        }
        try {
            var _tokens = Lexer.lex(src, opt);
            if (opt.walkTokens) marked.walkTokens(_tokens, opt.walkTokens);
            return Parser.parse(_tokens, opt);
        } catch (e) {
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (opt.silent) return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
            throw e;
        }
    }
    /**
   * Options
   */ marked.options = marked.setOptions = function(opt) {
        merge(marked.defaults, opt);
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = defaults;
    /**
   * Use Extension
   */ marked.use = function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var opts = merge.apply(void 0, [
            {}
        ].concat(args));
        var extensions = marked.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        var hasExtensions;
        args.forEach(function(pack) {
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                hasExtensions = true;
                pack.extensions.forEach(function(ext) {
                    if (!ext.name) throw new Error('extension name required');
                    if (ext.renderer) {
                        // Renderer extensions
                        var prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            var ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if (ext.tokenizer) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') throw new Error("extension level must be 'block' or 'inline'");
                        if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === 'block') {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === 'inline') {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if (ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
            } // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) (function() {
                var renderer = marked.defaults.renderer || new Renderer();
                var _loop = function _loop(prop) {
                    var prevRenderer = renderer[prop]; // Replace renderer with func to run extension, but fall back if false
                    renderer[prop] = function() {
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        var ret = pack.renderer[prop].apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret;
                    };
                };
                for(var prop in pack.renderer)_loop(prop);
                opts.renderer = renderer;
            })();
            if (pack.tokenizer) (function() {
                var tokenizer = marked.defaults.tokenizer || new Tokenizer();
                var _loop2 = function _loop2(prop) {
                    var prevTokenizer = tokenizer[prop]; // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[prop] = function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = pack.tokenizer[prop].apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                };
                for(var prop in pack.tokenizer)_loop2(prop);
                opts.tokenizer = tokenizer;
            })();
             // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                var walkTokens = marked.defaults.walkTokens;
                opts.walkTokens = function(token) {
                    pack.walkTokens.call(_this, token);
                    if (walkTokens) walkTokens(token);
                };
            }
            if (hasExtensions) opts.extensions = extensions;
            marked.setOptions(opts);
        });
    };
    /**
   * Run callback for every token
   */ marked.walkTokens = function(tokens, callback) {
        var _loop3 = function _loop3() {
            var token = _step.value;
            callback(token);
            switch(token.type){
                case 'table':
                    for(var _iterator2 = _createForOfIteratorHelperLoose(token.tokens.header), _step2; !(_step2 = _iterator2()).done;){
                        var cell = _step2.value;
                        marked.walkTokens(cell, callback);
                    }
                    for(var _iterator3 = _createForOfIteratorHelperLoose(token.tokens.cells), _step3; !(_step3 = _iterator3()).done;){
                        var row = _step3.value;
                        for(var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;){
                            var _cell = _step4.value;
                            marked.walkTokens(_cell, callback);
                        }
                    }
                    break;
                case 'list':
                    marked.walkTokens(token.items, callback);
                    break;
                default:
                    if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) // Walk any extensions
                    marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                        marked.walkTokens(token[childTokens], callback);
                    });
                    else if (token.tokens) marked.walkTokens(token.tokens, callback);
            }
        };
        for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;)_loop3();
    };
    /**
   * Parse Inline
   */ marked.parseInline = function(src, opt) {
        // throw error in case of non string input
        if (typeof src === 'undefined' || src === null) throw new Error('marked.parseInline(): input parameter is undefined or null');
        if (typeof src !== 'string') throw new Error('marked.parseInline(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
        opt = merge({}, marked.defaults, opt || {});
        checkSanitizeDeprecation(opt);
        try {
            var tokens = Lexer.lexInline(src, opt);
            if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
            return Parser.parseInline(tokens, opt);
        } catch (e) {
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (opt.silent) return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
            throw e;
        }
    };
    /**
   * Expose
   */ marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.parse = marked;
    var marked_1 = marked;
    return marked_1;
});

});


parcelRegister("Y0HZk", function(module, exports) {
var $0b462766feade7c4$var$__defProp = Object.defineProperty;
var $0b462766feade7c4$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $0b462766feade7c4$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $0b462766feade7c4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0b462766feade7c4$var$__export = (target, all)=>{
    for(var name in all)$0b462766feade7c4$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $0b462766feade7c4$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $0b462766feade7c4$var$__getOwnPropNames(from))if (!$0b462766feade7c4$var$__hasOwnProp.call(to, key) && key !== except) $0b462766feade7c4$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $0b462766feade7c4$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $0b462766feade7c4$var$__toCommonJS = (mod)=>$0b462766feade7c4$var$__copyProps($0b462766feade7c4$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $0b462766feade7c4$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $0b462766feade7c4$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $0b462766feade7c4$var$__defProp(target, key, result);
    return result;
};
var $0b462766feade7c4$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $0b462766feade7c4$var$markdown_reader_component_exports = {};
$0b462766feade7c4$var$__export($0b462766feade7c4$var$markdown_reader_component_exports, {
    MarkdownReaderComponent: ()=>$0b462766feade7c4$var$MarkdownReaderComponent
});
module.exports = $0b462766feade7c4$var$__toCommonJS($0b462766feade7c4$var$markdown_reader_component_exports);

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $gJGUt = parcelRequire("gJGUt");

var $gBKdM = parcelRequire("gBKdM");

var $a5JWF = parcelRequire("a5JWF");
let $0b462766feade7c4$var$MarkdownReaderComponent = class extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.html = "";
    }
    //  private widthHeight = this.responsive.combineBoth();
    OnInit() {}
    OnUpdate() {
        const params = this.getRouteParams();
        if (!this.template && !this.disableRequest) this.fetch(params.namespace, params.repo, params.filePath);
        this.mdParser.highlightElements(this.tags);
        this.mdParserMenu.lookupHeadings(this.shadowRoot);
    }
    getRouteParams() {
        let params = {};
        if (this["location"]) params = this["location"].params;
        return {
            namespace: params.namespace || this.namespace,
            repo: params.repo || this.repo,
            filePath: params.filePath || this.filePath
        };
    }
    fetch(namespace = "rxdi", repo = "starter-client-lit-html", filePath = "README.md") {
        return $0b462766feade7c4$var$__async(this, null, function*() {
            try {
                this.html = yield this.mdParser.fetchMarkdown(this.link || `https://raw.githubusercontent.com/${namespace}/${repo}/master/${filePath}`);
            } catch (e) {
                this.dispatchEvent(new CustomEvent("onError", {
                    detail: e
                }));
            }
        });
    }
    compileMarkdown(template) {
        return this.mdParser.readAndCompile(template);
    }
};
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)()
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "html", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)()
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "template", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "disableTocComponent", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)()
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "link", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)()
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "namespace", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)()
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "repo", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)()
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "filePath", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "disableRequest", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.property)(),
    (0, $4TeKW.property)()
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "markdownReaderJSON", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $1t8Wn.Inject)($gBKdM.MarkdownParserService)
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "mdParser", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $1t8Wn.Inject)($gJGUt.MarkdownParserMenuProvider)
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "mdParserMenu", 2);
$0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.queryAll)("code")
], $0b462766feade7c4$var$MarkdownReaderComponent.prototype, "tags", 2);
$0b462766feade7c4$var$MarkdownReaderComponent = $0b462766feade7c4$var$__decorateClass([
    (0, $4TeKW.Component)({
        selector: "markdown-reader",
        style: $a5JWF.style,
        template () {
            return $4TeKW.html`
      ${!this.disableTocComponent ? $4TeKW.html` <toc-component></toc-component> ` : ""}
      <!-- ${!this.template || !this.html ? $4TeKW.html` <loading-screen-component></loading-screen-component> ` : ""} -->
      ${this.template ? (0, $4TeKW.unsafeHTML)(this.compileMarkdown(this.template)) : $4TeKW.html`
            <div class="container">${(0, $4TeKW.unsafeHTML)(this.html || "&nbsp;")}</div>
          `}
    `;
        }
    })
], $0b462766feade7c4$var$MarkdownReaderComponent);

});
parcelRegister("a5JWF", function(module, exports) {
var $758e02c3a2e5de00$var$__defProp = Object.defineProperty;
var $758e02c3a2e5de00$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $758e02c3a2e5de00$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $758e02c3a2e5de00$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $758e02c3a2e5de00$var$__export = (target, all)=>{
    for(var name in all)$758e02c3a2e5de00$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $758e02c3a2e5de00$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $758e02c3a2e5de00$var$__getOwnPropNames(from))if (!$758e02c3a2e5de00$var$__hasOwnProp.call(to, key) && key !== except) $758e02c3a2e5de00$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $758e02c3a2e5de00$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $758e02c3a2e5de00$var$__toCommonJS = (mod)=>$758e02c3a2e5de00$var$__copyProps($758e02c3a2e5de00$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $758e02c3a2e5de00$var$markdown_reader_component_css_exports = {};
$758e02c3a2e5de00$var$__export($758e02c3a2e5de00$var$markdown_reader_component_css_exports, {
    style: ()=>$758e02c3a2e5de00$var$style
});
module.exports = $758e02c3a2e5de00$var$__toCommonJS($758e02c3a2e5de00$var$markdown_reader_component_css_exports);

var $4TeKW = parcelRequire("4TeKW");
const $758e02c3a2e5de00$var$style = $4TeKW.css`
  .content h1 {
    font-size: 35px;
    font-weight: bold;
    margin-top: 30px;
  }
  .content h2 {
    font-size: 30px;
    font-weight: 500;
    margin-top: 25px;
  }
  .content h3 {
    font-size: 25px;
    font-weight: 500;
    margin-top: 20px;
  }
  p code {
    color: #2c3e5c !important;
  }
  .container {
    margin: 50px auto;
    width: 80%;
  }

  .filename {
    background: #151515;
    color: #fff;
    padding: 12px 30px;
    margin: 35px 0 -35px;
    display: block;
    min-height: 25px;
    position: relative;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
    font-size: 15px;
  }
  .language-yml {
    color: #930404 !important;
  }
  .filename + pre[class*='language-'],
  .hide + pre[class*='language-'],
  .filename + div + pre[class*='language-'],
  .hide + div + pre[class*='language-'] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  code {
    font-family: Inconsolata, Consolas, 'Courier New', monospace;
    padding: 2px 6px;
    color: #2876d2;
    border-radius: 4px;
    font-size: 15px;
    white-space: pre-wrap;
    background: #f0f2f3;
  }
  /* pre {
  box-shadow: 0 5px 55px rgba(162, 162, 162, 0.25),
   0 10px 10px rgba(0, 0, 0, 0.22);
 } */
  pre {
    box-shadow: 0px 0px 3px rgba(162, 162, 162, 0.55);
  }
  pre code[class*='language-sh'] {
    color: #24292e;
  }
  .code-label {
    position: relative;

    margin-bottom: -24px;
    padding: 12px 24px;
    border-radius: 10px 10px 0px 0px;
    background-color: var(--primary-color);
    color: rgb(255, 255, 255);
    font-size: 16px;
    text-transform: capitalize;
    display: flex;
    place-content: stretch space-between;
  }
  .language-graphql {
    color: var(--parser-language-graphql, #444573) !important;
    font-size: 16px !important;
    line-height: 24px !important;
    user-select: text;
  }

  .language-graphql::selection {
    color: white;
    background: var(--parser-language-graphql, #444573);
  }
  .graphql {
    background: #f4f7fa !important;
    border-radius: 30px !important;
    margin: 0 !important;
    padding: 15px 30px 26px !important;
  }
  h6 {
    position: relative;
    z-index: 3;
    margin-bottom: -24px;
    padding: 12px 24px;
    border-radius: 10px 10px 0 0;
    background-color: #2a2b56;
    color: #fff;
    font-size: 16px;
  }

  pre[class*='language-sh'] {
    background: #f6f8fa;
  }
  code[class*='language-'],
  pre[class*='language-'] {
    letter-spacing: normal;
    color: #060607;
    background: none;
    font-family: Inconsolata, Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 25px;
    font-size: 16px;
    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;
    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }
  @media print {
    code[class*='language-'],
    pre[class*='language-'] {
      text-shadow: none;
    }
  }
  pre[class*='language-'],
  :not(pre) > code[class*='language-'] {
    background: rgb(255 255 255);
    border-radius: 6px;
  }
  /* Code blocks */
  pre[class*='language-'] {
    padding: 30px;
    margin-bottom: 30px;
    margin-top: 20px;
    overflow: auto;
    border: 0;
  }
  /* Inline code */
  :not(pre) > code[class*='language-'] {
    padding: 0.15em 0.2em 0.05em;
    border-radius: 0.3em;
    border: 0.13em solid #7a6652;
    white-space: normal;
  }
  .token.comment,
  .token.prolog,
  .token.doctype,
  .token.cdata {
    color: #7a8186;
  }
  .token.punctuation {
    opacity: 0.7;
  }
  .namespace {
    opacity: 0.7;
  }
  .token.property,
  .token.tag,
  .token.boolean,
  .token.number,
  .token.constant,
  .token.symbol {
    color: #ffc093;
  }
  .language-html .tag {
    color: #2f74d0;
  }
  .language-html .punctuation {
    color: black;
  }
  .token.selector,
  .token.attr-name,
  .token.string,
  .token.char,
  .token.builtin,
  .token.inserted {
    color: #3594e2;
  }
  .token.entity,
  .token.url,
  .language-css .token.string,
  .style .token.string,
  .token.variable {
    color: #caffa8;
  }
  .token.function,
  .token.operator {
    color: #36a3b9;
  }
  .token.atrule,
  .token.attr-value,
  .token.keyword {
    color: #b32f82;
  }
  .token.regex,
  .token.important {
    color: #e90;
  }
  .token.important,
  .token.bold {
    font-weight: bold;
  }
  .token.italic {
    font-style: italic;
  }
  .token.entity {
    cursor: help;
  }
  .token.deleted {
    color: red;
  }
  div.prism-show-language {
    position: relative;
  }
  div.prism-show-language > div.prism-show-language-label {
    background: var(--primary-color);
    color: white;
    font-weight: 500;
  }
  .copy-icon {
    display: grid;
    align-content: center;
    cursor: pointer;
  }
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .transition {
    -webkit-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-fast {
    -webkit-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-slow {
    -webkit-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  /* CLEARFIX */
  .clearfix {
    *zoom: 1;
  }
  .clearfix:before,
  .clearfix:after {
    content: ' ';
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
  .center-left {
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  .center-top {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .box-sizing {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  html,
  body {
    width: 100%;
  }
  a {
    text-decoration: none;
  }
  *:focus {
    outline: none;
  }
  /* Main Layout */
  .bg {
    background-image: linear-gradient(#1c1f24, #24292f);
  }
  .bg.context {
    background-color: #21262c;
  }
  .version-labels {
    background-color: #6f42be;
  }
  .version-labels.new {
    background-color: #33a743;
  }
  .version-labels.new {
    background-color: #2767d7;
  }
  .version-labels .sha {
    background-color: #554888;
  }
  ul {
    /* border-left: 1px solid #303539;
  list-style-type: none; */
    border-left: 8px solid rgb(55 188 152);
    list-style-type: none;
    background: white;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 30px;
    /* padding-left: 10px; */
  }

  ul li {
    list-style-type: disc;
  }
  ol > li::marker {
    font-weight: bold;
  }

  ol {
    margin-left: 16px;
  }

  /* Hack */
  /*  ol > li {
  margin: 0;
  padding: 0 0 0 2em;
  text-indent: -2em;
  list-style-type: none;
  counter-increment: item;
 }
 ol > li:before {
  display: inline-block;
  width: 1.5em;
  padding-right: 0.5em;
  font-weight: bold;
  text-align: right;
  content: counter(item) '.';
 } */
  /* Hack */
  li {
    padding-bottom: 5px;
    list-style-type: decimal;
  }
  li p {
    margin: 10px;
  }
  .suggestion-label {
    background-color: #2766d6;
  }
  .flex {
    display: flex;
  }
  .spacer {
    flex: 1 3 auto;
  }
  .pointer {
    cursor: pointer;
  }
  .center {
    text-align: center;
  }
  a {
    text-decoration: none;
    color: #0894e2;
  }
  strong {
    font-weight: 600;
  }
  hr {
    width: 100%;
    height: 4px;
    background: #37a5bc;
    border: 0;
    margin: 50px 0;
  }
  h4 {
    font-size: 20px;
  }
  blockquote {
    line-height: 1.6;
    position: relative;
    margin: 35px 0;
    background: #f9eff1;
    padding: 20px;
  }
  blockquote::before {
    height: 100%;
    width: 5px;
    content: '';
    background: #37a5bc;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
  }
  blockquote strong {
    color: #37a5bc;
  }
  blockquote strong:first-of-type {
    display: block;
    text-transform: uppercase;
    font-size: 15px;
    font-weight: bold;
  }
  blockquote.warning {
    background: rgb(255 255 255);
  }
  /* blockquote.warning::before { */
  /* background: #ffb36f; */
  /* } */
  blockquote.warning strong,
  blockquote.warning a {
    color: #ed8529;
  }
  blockquote.info {
    background: rgba(8, 148, 226, 0.038);
  }
  blockquote.info::before {
    background: #0894e2;
  }
  blockquote.info strong,
  blockquote.info a {
    color: #0894e2;
  }
  figure {
    margin: 60px 30px;
    text-align: center;
  }
  @media only screen and (max-width: 767px) {
    figure {
      margin: 60px 0;
    }
  }
  figure img {
    max-width: 100%;
    height: auto;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.08);
  }
  figcaption {
    color: rgba(243, 245, 247, 0.9);
    font-size: 16px;
    margin: 20px 0;
  }
  figcaption p {
    font-size: 16px;
  }
  table {
    width: 100%;
    margin: 40px 0;
  }
  @media only screen and (max-width: 767px) {
    tr {
      margin-bottom: 20px;
      /* display: block; */
    }
    tr:last-of-type {
      margin-bottom: 0;
    }
  }
  th {
    padding: 20px;
    background: #efefef;
  }
  tr:nth-of-type(even) td {
    background: rgb(64 113 191 / 5%);
  }
  tr:nth-of-type(odd) td:first-of-type {
    border-right: 1px solid #f0f2f3;
  }
  @media only screen and (max-width: 767px) {
    tr:nth-of-type(odd) td:first-of-type {
      border-right: 0;
      border-bottom: 1px solid #f0f2f3;
    }
  }
  tr:nth-of-type(even) td:first-of-type {
    border-right: 1px solid #fff;
  }
  @media only screen and (max-width: 767px) {
    tr:nth-of-type(even) td:first-of-type {
      border-right: 0;
      border-bottom: 1px solid #fff;
    }
  }
  tr td {
    padding: 20px 30px;
    vertical-align: top;
  }
  @media only screen and (max-width: 767px) {
    tr td {
      padding: 20px;
    }
  }
  .file-tree {
    background: #f9f9f9;
    border: 4px solid #f5f5f5;
    margin: 40px 0;
    padding: 16px 32px;
  }
  .file-tree .item {
    display: block;
    line-height: 32px;
    font-size: 15px;
    color: #5a5a5a;
  }
  .file-tree .children {
    padding-left: 30px;
    position: relative;
    overflow: hidden;
  }
  .file-tree .children .item {
    position: relative;
  }
  .file-tree .children .item:before {
    content: '';
    left: -18px;
    bottom: 16px;
    width: 16px;
    height: 9999px;
    position: absolute;
    border-width: 0 0 1px 1px;
    border-style: solid;
    border-color: #dbdbdb;
    border-radius: 0 0 0 3px;
  }
  .external {
    background: #f7f7f7;
  }
  .external::before {
    background: #e8e8e8;
  }
  .ps > .ps__scrollbar-y-rail {
    width: 10px;
  }
  .ps:hover > .ps__scrollbar-y-rail > .ps__scrollbar-y,
  .ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y,
  .ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y {
    width: 6px !important;
    background: #151515;
  }
  .ps > .ps__scrollbar-y-rail > .ps__scrollbar-y {
    border-radius: 0;
    -webkit-border-radius: 0;
  }
  .hide {
    display: none !important;
  }
  /*
   * Container style
   */
  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
  }
  /*
   * Scrollbar rail styles
   */
  .ps__rail-x {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    height: 15px;
    /* there must be 'bottom' or 'top' for ps__rail-x */
    bottom: 0px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__rail-y {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    width: 15px;
    /* there must be 'right' or 'left' for ps__rail-y */
    right: 0;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps--active-x > .ps__rail-x,
  .ps--active-y > .ps__rail-y {
    display: block;
    background-color: transparent;
  }
  .ps:hover > .ps__rail-x,
  .ps:hover > .ps__rail-y,
  .ps--focus > .ps__rail-x,
  .ps--focus > .ps__rail-y,
  .ps--scrolling-x > .ps__rail-x,
  .ps--scrolling-y > .ps__rail-y {
    opacity: 0.6;
  }
  .ps__rail-x:hover,
  .ps__rail-y:hover,
  .ps__rail-x:focus,
  .ps__rail-y:focus {
    background-color: #eee;
    opacity: 0.9;
  }
  /*
   * Scrollbar thumb styles
   */
  .ps__thumb-x {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, height 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
    height: 6px;
    /* there must be 'bottom' for ps__thumb-x */
    bottom: 2px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__thumb-y {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, width 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
    width: 6px;
    /* there must be 'right' for ps__thumb-y */
    right: 2px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__rail-x:hover > .ps__thumb-x,
  .ps__rail-x:focus > .ps__thumb-x {
    background-color: #999;
    height: 11px;
  }
  .ps__rail-y:hover > .ps__thumb-y,
  .ps__rail-y:focus > .ps__thumb-y {
    background-color: #999;
    width: 11px;
  }
  /* MS supports */
  @supports (-ms-overflow-style: none) {
    .ps {
      overflow: auto !important;
    }
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .ps {
      overflow: auto !important;
    }
  }
  /*
   TODO: Remove important flags after this bug if fixed:
   https://github.com/angular/flex-layout/issues/381
   */
  perfect-scrollbar {
    position: relative;
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    /* stylelint-disable */
    /* stylelint-enable */
  }
  perfect-scrollbar[hidden] {
    display: none;
  }
  perfect-scrollbar[fxflex] {
    display: flex;
    flex-direction: column;
    -webkit-box-orient: column;
    -webkit-box-direction: column;
    height: auto;
    min-width: 0;
    min-height: 0;
  }
  perfect-scrollbar[fxflex] > .ps {
    flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    -webkit-box-flex: 1;
    width: auto;
    height: auto;
    min-width: 0;
    min-height: 0;
  }
  perfect-scrollbar[fxlayout] > .ps,
  perfect-scrollbar[fxlayout] > .ps > .ps-content {
    display: flex;
    flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    -webkit-box-flex: 1;
    /* align-item: inherit; */
    place-content: inherit;
    -webkit-box-pack: inherit;
    -webkit-box-align: inherit;
    flex-direction: inherit;
    -webkit-box-orient: inherit;
    -webkit-box-direction: inherit;
    width: 100%;
    height: 100%;
  }
  perfect-scrollbar[fxlayout='row'] > .ps,
  perfect-scrollbar[fxlayout='row'] > .ps > .ps-content {
    flex-direction: row !important;
    -webkit-box-orient: row !important;
    -webkit-box-direction: row !important;
  }
  perfect-scrollbar[fxlayout='column'] > .ps,
  perfect-scrollbar[fxlayout='column'] > .ps > .ps-content {
    flex-direction: column !important;
    -webkit-box-orient: column !important;
    -webkit-box-direction: column !important;
  }
  perfect-scrollbar > .ps {
    position: static;
    display: block;
    width: inherit;
    height: inherit;
    max-width: inherit;
    max-height: inherit;
  }
  perfect-scrollbar > .ps > .ps-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    overflow: hidden;
    pointer-events: none;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    position: absolute;
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    left: 0;
    min-width: 100%;
    min-height: 24px;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right {
    top: 0;
    min-width: 24px;
    min-height: 100%;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top {
    top: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left {
    left: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right {
    right: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    bottom: 0;
  }
  perfect-scrollbar > .ps.ps--active-y > .ps__rail-y {
    top: 0 !important;
    right: 0 !important;
    width: 10px;
    cursor: default;
    transition: width 200ms linear, opacity 200ms linear, background-color 200ms linear;
  }
  perfect-scrollbar > .ps.ps--active-y > .ps__rail-y:hover {
    width: 15px;
  }
  perfect-scrollbar > .ps.ps--active-x > .ps__rail-x {
    bottom: 0 !important;
    left: 0 !important;
    height: 10px;
    cursor: default;
    transition: height 200ms linear, opacity 200ms linear, background-color 200ms linear;
  }
  perfect-scrollbar > .ps.ps--active-x > .ps__rail-x:hover {
    height: 15px;
  }
  perfect-scrollbar > .ps.ps--active-x.ps--active-y > .ps__rail-y {
    margin: 0 0 10px;
  }
  perfect-scrollbar > .ps.ps--active-x.ps--active-y > .ps__rail-x {
    margin: 0 10px 0 0;
  }
  perfect-scrollbar > .ps.ps--scrolling-y > .ps__rail-y {
    opacity: 0.9;
    background-color: #eee;
  }
  perfect-scrollbar > .ps.ps--scrolling-x > .ps__rail-x {
    opacity: 0.9;
    background-color: #eee;
  }
  perfect-scrollbar.ps-show-always > .ps.ps--active-y > .ps__rail-y {
    opacity: 0.6;
  }
  perfect-scrollbar.ps-show-always > .ps.ps--active-x > .ps__rail-x {
    opacity: 0.6;
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-y > .ps-overlay:not(.ps-at-top) .ps-indicator-top {
    opacity: 1;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-y > .ps-overlay:not(.ps-at-bottom) .ps-indicator-bottom {
    opacity: 1;
    background: linear-gradient(to top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-x > .ps-overlay:not(.ps-at-left) .ps-indicator-left {
    opacity: 1;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-x > .ps-overlay:not(.ps-at-right) .ps-indicator-right {
    opacity: 1;
    background: linear-gradient(to left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-y > .ps-overlay.ps-at-top .ps-indicator-top {
    background: linear-gradient(to bottom, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-y
    > .ps-overlay.ps-at-top
    .ps-indicator-top.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-y > .ps-overlay.ps-at-bottom .ps-indicator-bottom {
    background: linear-gradient(to top, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-y
    > .ps-overlay.ps-at-bottom
    .ps-indicator-bottom.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-x > .ps-overlay.ps-at-left .ps-indicator-left {
    background: linear-gradient(to right, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-x
    > .ps-overlay.ps-at-left
    .ps-indicator-left.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-x > .ps-overlay.ps-at-right .ps-indicator-right {
    background: linear-gradient(to left, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-x
    > .ps-overlay.ps-at-right
    .ps-indicator-right.ps-indicator-show {
    opacity: 1;
  }
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 27px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 6px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 6px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 26px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 45px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(19px, 0);
    }
  }

  @media screen and (max-width: 600px) {
    .container {
      width: 100%;
    }
    /* .content {
      padding-left: 10px;
      padding-right: 10px;
    } */

    code[class*='language-'] {
      font-size: 11px;
    }
  }
  table {
    width: 100%;
    border-collapse: collapse;
    overflow-x: auto;
    display: block; /* allows horizontal scroll */
  }

  th,
  td {
    padding: 10px;
    /* border: 1px solid #ddd; */
    text-align: left;
  }

  th {
    background: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 20px 30px;
    vertical-align: top;
  }

  tr:nth-child(even) {
    background: #fafafa;
  }

  ul > li > ul {
    border-left: none;
  }

  ul > li > ul > li {
    list-style-type: circle;
  }
  /* table thead tr th strong {
    margin-left: 20px;
  } */

   
`;

});


parcelRegister("i07Qn", function(module, exports) {
var $d1ae4fb805f19a40$var$__defProp = Object.defineProperty;
var $d1ae4fb805f19a40$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d1ae4fb805f19a40$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d1ae4fb805f19a40$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d1ae4fb805f19a40$var$__export = (target, all)=>{
    for(var name in all)$d1ae4fb805f19a40$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d1ae4fb805f19a40$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $d1ae4fb805f19a40$var$__getOwnPropNames(from))if (!$d1ae4fb805f19a40$var$__hasOwnProp.call(to, key) && key !== except) $d1ae4fb805f19a40$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $d1ae4fb805f19a40$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $d1ae4fb805f19a40$var$__toCommonJS = (mod)=>$d1ae4fb805f19a40$var$__copyProps($d1ae4fb805f19a40$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $d1ae4fb805f19a40$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $d1ae4fb805f19a40$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $d1ae4fb805f19a40$var$__defProp(target, key, result);
    return result;
};
var $d1ae4fb805f19a40$var$toc_component_exports = {};
$d1ae4fb805f19a40$var$__export($d1ae4fb805f19a40$var$toc_component_exports, {
    TocComponent: ()=>$d1ae4fb805f19a40$var$TocComponent
});
module.exports = $d1ae4fb805f19a40$var$__toCommonJS($d1ae4fb805f19a40$var$toc_component_exports);

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");

var $gJGUt = parcelRequire("gJGUt");

var $5LjEv = parcelRequire("5LjEv");
let $d1ae4fb805f19a40$var$TocComponent = class extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.opened = true;
    }
    OnInit() {
        this.menus = this.menuProvider.menu.pipe((0, $6Rz6W.filter)(()=>!!this.opened), (0, $gawXH.map)((menus)=>this.createMenusTemplate(menus)));
    }
    clickAnchor(element) {
        this.menuProvider.navigateToAnchor(element);
    }
    createMenusTemplate(menus) {
        return $4TeKW.html` ${menus.map((i)=>this.createSingleItem(i))} `;
    }
    createSingleItem(item) {
        return $4TeKW.html`
      <li @click=${()=>this.clickAnchor(item.elementRef)}>${item.title}</li>
    `;
    }
};
$d1ae4fb805f19a40$var$__decorateClass([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $d1ae4fb805f19a40$var$TocComponent.prototype, "opened", 2);
$d1ae4fb805f19a40$var$__decorateClass([
    (0, $1t8Wn.Inject)($gJGUt.MarkdownParserMenuProvider)
], $d1ae4fb805f19a40$var$TocComponent.prototype, "menuProvider", 2);
$d1ae4fb805f19a40$var$TocComponent = $d1ae4fb805f19a40$var$__decorateClass([
    (0, $4TeKW.Component)({
        selector: "toc-component",
        style: $5LjEv.style,
        template () {
            return $4TeKW.html`
      <div class="toc-wrapper">
        <ul>
          ${(0, $4TeKW.async)(this.menus)}
        </ul>
      </div>
    `;
        }
    })
], $d1ae4fb805f19a40$var$TocComponent);

});
parcelRegister("5LjEv", function(module, exports) {
var $432096177e070f6b$var$__defProp = Object.defineProperty;
var $432096177e070f6b$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $432096177e070f6b$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $432096177e070f6b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $432096177e070f6b$var$__export = (target, all)=>{
    for(var name in all)$432096177e070f6b$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $432096177e070f6b$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $432096177e070f6b$var$__getOwnPropNames(from))if (!$432096177e070f6b$var$__hasOwnProp.call(to, key) && key !== except) $432096177e070f6b$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $432096177e070f6b$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $432096177e070f6b$var$__toCommonJS = (mod)=>$432096177e070f6b$var$__copyProps($432096177e070f6b$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $432096177e070f6b$var$toc_component_css_exports = {};
$432096177e070f6b$var$__export($432096177e070f6b$var$toc_component_css_exports, {
    style: ()=>$432096177e070f6b$var$style
});
module.exports = $432096177e070f6b$var$__toCommonJS($432096177e070f6b$var$toc_component_css_exports);

var $4TeKW = parcelRequire("4TeKW");
const $432096177e070f6b$var$style = $4TeKW.css`
  .transition {
    -webkit-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-fast {
    -webkit-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-slow {
    -webkit-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  /* CLEARFIX */
  .clearfix {
    *zoom: 1;
  }
  .clearfix:before,
  .clearfix:after {
    content: ' ';
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
  .center-left {
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  .center-top {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .box-sizing {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .toc-wrapper {
    width: 250px;
    padding-left: 32px;
    box-sizing: border-box;
    position: fixed;
    top: 65px;
    right: 0px;
    background-color: rgba(34, 39, 44, 0.9);
    border-radius: 10px;
    z-index: 1001;
  }
  .toc-wrapper ul {
    position: relative;
    padding: 0;
  }
  .toc-wrapper ul::before {
    content: '';
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 10px;
    width: 2px;
    background: #efefef;
  }
  .toc-wrapper li {
    display: block;
    position: relative;
    padding-left: 30px;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 6px;
    cursor: pointer;
  }
  .toc-wrapper li:hover {
    color: #37a5bc;
  }
  .toc-wrapper .current {
    color: #37a5bc;
    font-weight: 600;
  }
  .toc-wrapper .current::before {
    background: #37a5bc;
    border-color: #37a5bc;
    border-width: 1px;
    left: -3px;
  }
  .toc-wrapper li::before {
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -moz-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    content: '';
    background: #fdfdfd;
    border: 2px solid #efefef;
    left: -4px;
    width: 6px;
    height: 6px;
    top: 50%;
    display: inline-block;
    position: absolute;
  }
  .toc-wrapper li:last-of-type::before {
    top: auto;
    bottom: 0;
  }
`;

});



parcelRegister("jTXuk", function(module, exports) {
var $e7d14c7f38b8e413$var$__defProp = Object.defineProperty;
var $e7d14c7f38b8e413$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $e7d14c7f38b8e413$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $e7d14c7f38b8e413$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e7d14c7f38b8e413$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $e7d14c7f38b8e413$var$__getOwnPropNames(from))if (!$e7d14c7f38b8e413$var$__hasOwnProp.call(to, key) && key !== except) $e7d14c7f38b8e413$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $e7d14c7f38b8e413$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $e7d14c7f38b8e413$var$__reExport = (target, mod, secondTarget)=>($e7d14c7f38b8e413$var$__copyProps(target, mod, "default"), secondTarget && $e7d14c7f38b8e413$var$__copyProps(secondTarget, mod, "default"));
var $e7d14c7f38b8e413$var$__toCommonJS = (mod)=>$e7d14c7f38b8e413$var$__copyProps($e7d14c7f38b8e413$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $e7d14c7f38b8e413$var$markdown_reader_exports = {};
module.exports = $e7d14c7f38b8e413$var$__toCommonJS($e7d14c7f38b8e413$var$markdown_reader_exports);

$e7d14c7f38b8e413$var$__reExport($e7d14c7f38b8e413$var$markdown_reader_exports, (parcelRequire("Y0HZk")), module.exports);

$e7d14c7f38b8e413$var$__reExport($e7d14c7f38b8e413$var$markdown_reader_exports, (parcelRequire("a5JWF")), module.exports);

$e7d14c7f38b8e413$var$__reExport($e7d14c7f38b8e413$var$markdown_reader_exports, (parcelRequire("oVrHT")), module.exports);

});
parcelRegister("oVrHT", function(module, exports) {
var $04aecd8ffaa82cb7$var$__defProp = Object.defineProperty;
var $04aecd8ffaa82cb7$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $04aecd8ffaa82cb7$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $04aecd8ffaa82cb7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $04aecd8ffaa82cb7$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $04aecd8ffaa82cb7$var$__getOwnPropNames(from))if (!$04aecd8ffaa82cb7$var$__hasOwnProp.call(to, key) && key !== except) $04aecd8ffaa82cb7$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $04aecd8ffaa82cb7$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $04aecd8ffaa82cb7$var$__toCommonJS = (mod)=>$04aecd8ffaa82cb7$var$__copyProps($04aecd8ffaa82cb7$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $04aecd8ffaa82cb7$var$markdown_reader_component_interface_exports = {};
module.exports = $04aecd8ffaa82cb7$var$__toCommonJS($04aecd8ffaa82cb7$var$markdown_reader_component_interface_exports);

});



parcelRegister("giRuk", function(module, exports) {
var $bde7d16a418b6b76$var$__defProp = Object.defineProperty;
var $bde7d16a418b6b76$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $bde7d16a418b6b76$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $bde7d16a418b6b76$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bde7d16a418b6b76$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $bde7d16a418b6b76$var$__getOwnPropNames(from))if (!$bde7d16a418b6b76$var$__hasOwnProp.call(to, key) && key !== except) $bde7d16a418b6b76$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $bde7d16a418b6b76$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $bde7d16a418b6b76$var$__reExport = (target, mod, secondTarget)=>($bde7d16a418b6b76$var$__copyProps(target, mod, "default"), secondTarget && $bde7d16a418b6b76$var$__copyProps(secondTarget, mod, "default"));
var $bde7d16a418b6b76$var$__toCommonJS = (mod)=>$bde7d16a418b6b76$var$__copyProps($bde7d16a418b6b76$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $bde7d16a418b6b76$var$src_exports = {};
module.exports = $bde7d16a418b6b76$var$__toCommonJS($bde7d16a418b6b76$var$src_exports);

$bde7d16a418b6b76$var$__reExport($bde7d16a418b6b76$var$src_exports, (parcelRequire("2rBwi")), module.exports);

$bde7d16a418b6b76$var$__reExport($bde7d16a418b6b76$var$src_exports, (parcelRequire("6L3Th")), module.exports);

$bde7d16a418b6b76$var$__reExport($bde7d16a418b6b76$var$src_exports, (parcelRequire("4XFmu")), module.exports);

$bde7d16a418b6b76$var$__reExport($bde7d16a418b6b76$var$src_exports, (parcelRequire("l1oGi")), module.exports);

});
parcelRegister("2rBwi", function(module, exports) {
var $1c7b3512978bbe00$var$__defProp = Object.defineProperty;
var $1c7b3512978bbe00$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $1c7b3512978bbe00$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $1c7b3512978bbe00$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1c7b3512978bbe00$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $1c7b3512978bbe00$var$__getOwnPropNames(from))if (!$1c7b3512978bbe00$var$__hasOwnProp.call(to, key) && key !== except) $1c7b3512978bbe00$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $1c7b3512978bbe00$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $1c7b3512978bbe00$var$__reExport = (target, mod, secondTarget)=>($1c7b3512978bbe00$var$__copyProps(target, mod, "default"), secondTarget && $1c7b3512978bbe00$var$__copyProps(secondTarget, mod, "default"));
var $1c7b3512978bbe00$var$__toCommonJS = (mod)=>$1c7b3512978bbe00$var$__copyProps($1c7b3512978bbe00$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $1c7b3512978bbe00$var$modals_exports = {};
module.exports = $1c7b3512978bbe00$var$__toCommonJS($1c7b3512978bbe00$var$modals_exports);

$1c7b3512978bbe00$var$__reExport($1c7b3512978bbe00$var$modals_exports, (parcelRequire("eh7Ut")), module.exports);

$1c7b3512978bbe00$var$__reExport($1c7b3512978bbe00$var$modals_exports, (parcelRequire("aBMMZ")), module.exports);

$1c7b3512978bbe00$var$__reExport($1c7b3512978bbe00$var$modals_exports, (parcelRequire("b22ca")), module.exports);

$1c7b3512978bbe00$var$__reExport($1c7b3512978bbe00$var$modals_exports, (parcelRequire("e6J6o")), module.exports);

});
parcelRegister("eh7Ut", function(module, exports) {
var $a648c9f2a263cddb$var$__create = Object.create;
var $a648c9f2a263cddb$var$__defProp = Object.defineProperty;
var $a648c9f2a263cddb$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $a648c9f2a263cddb$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $a648c9f2a263cddb$var$__getProtoOf = Object.getPrototypeOf;
var $a648c9f2a263cddb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a648c9f2a263cddb$var$__export = (target, all)=>{
    for(var name in all)$a648c9f2a263cddb$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $a648c9f2a263cddb$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $a648c9f2a263cddb$var$__getOwnPropNames(from))if (!$a648c9f2a263cddb$var$__hasOwnProp.call(to, key) && key !== except) $a648c9f2a263cddb$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $a648c9f2a263cddb$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $a648c9f2a263cddb$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $a648c9f2a263cddb$var$__create($a648c9f2a263cddb$var$__getProtoOf(mod)) : {}, $a648c9f2a263cddb$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $a648c9f2a263cddb$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $a648c9f2a263cddb$var$__toCommonJS = (mod)=>$a648c9f2a263cddb$var$__copyProps($a648c9f2a263cddb$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $a648c9f2a263cddb$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $a648c9f2a263cddb$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $a648c9f2a263cddb$var$__defProp(target, key, result);
    return result;
};
var $a648c9f2a263cddb$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $a648c9f2a263cddb$var$generic_apps_modal_exports = {};
$a648c9f2a263cddb$var$__export($a648c9f2a263cddb$var$generic_apps_modal_exports, {
    GenericModal: ()=>$a648c9f2a263cddb$var$GenericModal
});
module.exports = $a648c9f2a263cddb$var$__toCommonJS($a648c9f2a263cddb$var$generic_apps_modal_exports);

var $613YX = parcelRequire("613YX");

var $1t8Wn = parcelRequire("1t8Wn");

var $9tLTP = parcelRequire("9tLTP");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $ihXbv = parcelRequire("ihXbv");

var $20e62 = parcelRequire("20e62");

var $iWHsw = parcelRequire("iWHsw");

var $frkuW = parcelRequire("frkuW");

var $cdTWx = parcelRequire("cdTWx");
var $g5fNy = parcelRequire("g5fNy");

var $gawXH = parcelRequire("gawXH");
var $3dOhR = parcelRequire("3dOhR");

var $aBMMZ = parcelRequire("aBMMZ");

var $lzXjJ = parcelRequire("lzXjJ");

var $a648c9f2a263cddb$var$import_swiper2 = $a648c9f2a263cddb$var$__toESM((parcelRequire("cGmSK")));
const $a648c9f2a263cddb$var$style = $4TeKW.css`
  .swiper-container {
    width: 100%;
    height: 90%;
  }

  .swiper-pagination {
    position: absolute;
    bottom: 0;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .append-buttons {
    text-align: center;
    margin-top: 20px;
  }
  .append-buttons a {
    display: inline-block;
    border: 1px solid #007aff;
    color: #007aff;
    text-decoration: none;
    padding: 4px 10px;
    border-radius: 4px;
    margin: 0 10px;
    font-size: 13px;
  }

  .back-button {
    display: none;
    cursor: pointer;
    text-align: center;
    padding: 32px;
    background-color: rgba(0, 0, 0, 0.1);
    height: 100%;
  }

  .back-button:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }

  @supports (-webkit-touch-callout: none) {
    .back-button {
      display: block;
    }
  }

  a {
    cursor: pointer;
  }
  .filter {
    filter: drop-shadow(0px 0px 35px rgba(0, 0, 0, 0.7));
  }
`;
let $a648c9f2a263cddb$var$GenericModal = class extends $4TeKW.LitElement {
    unsubscribe() {
        if (this.leftKey) this.leftKey.unsubscribe();
        if (this.rightKey) this.rightKey.unsubscribe();
        if (this.enterKey) this.enterKey.unsubscribe();
        if (this.backKey) this.backKey.unsubscribe();
    }
    OnDestroy() {
        this.unsubscribe();
    }
    goToPage(index) {
        return ([cards, options])=>{
            var _a, _b;
            const card = cards[index];
            debugger;
            if (card.path) {
                const slideOutUpOptions = (_b = (_a = options.animations) == null ? void 0 : _a.speed) == null ? void 0 : _b.slideOutUp;
                if (options.disableAnimations) this.router.go(card.path);
                else (0, $frkuW.animateElement)(this.swiper.slides[index], "slideOutUp", `duration-${slideOutUpOptions ? slideOutUpOptions : 200}`).subscribe(()=>this.router.go(card.path));
            }
        };
    }
    onBackSpace() {
        return (_0)=>$a648c9f2a263cddb$var$__async(this, [
                _0
            ], function*([cards, options]) {
                var _a, _b;
                const card = cards[this.swiper.activeIndex];
                if (card.backPath) {
                    const zoomOutOptions = (_b = (_a = options.animations) == null ? void 0 : _a.speed) == null ? void 0 : _b.zoomOut;
                    yield Promise.all([
                        ...Array.from(this.swiper.slides)
                    ].map((e)=>!options.disableAnimations && (0, $frkuW.animateElement)(e, "zoomOut", `duration-${zoomOutOptions ? zoomOutOptions : 200}`).toPromise()));
                    this.router.go(card.backPath);
                    this.genericAppsService.popTrace();
                }
            });
    }
    initSwiper(dom) {
        return (options)=>{
            return new $a648c9f2a263cddb$var$import_swiper2.default(dom.container, Object.assign({
                slidesPerView: 3,
                coverflowEffect: {
                    rotate: 50,
                    stretch: 50,
                    depth: 100,
                    modifier: 1,
                    slideShadows: false
                },
                effect: "coverflow",
                breakpoints: {
                    640: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: 2
                    },
                    1024: {
                        slidesPerView: 3
                    }
                },
                centeredSlides: true,
                spaceBetween: 30,
                pagination: {
                    el: dom.pagination,
                    type: "fraction"
                },
                navigation: {
                    nextEl: dom.next,
                    prevEl: dom.prev
                }
            }, options ? options.swiper : {}));
        };
    }
    setShadowToActivePage() {
        const activeSlideElement = this.swiper.slides[this.swiper.activeIndex];
        [
            ...Array.from(this.swiper.slides)
        ].map((slide)=>slide.classList.remove("filter"));
        activeSlideElement.classList.add("filter");
    }
};
$a648c9f2a263cddb$var$__decorateClass([
    (0, $1t8Wn.Injector)($20e62.MODAL_DIALOG_DATA)
], $a648c9f2a263cddb$var$GenericModal.prototype, "data", 2);
$a648c9f2a263cddb$var$__decorateClass([
    (0, $1t8Wn.Inject)($ihXbv.ModalService)
], $a648c9f2a263cddb$var$GenericModal.prototype, "modalService", 2);
$a648c9f2a263cddb$var$__decorateClass([
    (0, $1t8Wn.Inject)($9tLTP.HotKeysService)
], $a648c9f2a263cddb$var$GenericModal.prototype, "hotkeys", 2);
$a648c9f2a263cddb$var$__decorateClass([
    (0, $1t8Wn.Inject)($iWHsw.ResponsiveService)
], $a648c9f2a263cddb$var$GenericModal.prototype, "responsive", 2);
$a648c9f2a263cddb$var$__decorateClass([
    (0, $8kgMp.Router)()
], $a648c9f2a263cddb$var$GenericModal.prototype, "router", 2);
$a648c9f2a263cddb$var$__decorateClass([
    (0, $1t8Wn.Inject)($aBMMZ.GenericAppsService)
], $a648c9f2a263cddb$var$GenericModal.prototype, "genericAppsService", 2);
$a648c9f2a263cddb$var$GenericModal = $a648c9f2a263cddb$var$__decorateClass([
    (0, $613YX.Component)({
        Settings: {
            selector: "rx-generic-modal",
            style: $4TeKW.css`
      .close {
        position: absolute;
        z-index: 1010;
        padding: 5px;
        top: 10px;
        right: 10px;
        border: none;
        cursor: pointer;
        text-transform: none;
        outline: none;
        background-color: transparent;
      }
      svg:hover line {
        stroke: white;
      }
    `
        },
        State: function() {
            return (0, $cdTWx.combineLatest)([
                this.data.cards.asObservable(),
                this.data.options && this.data.options.asObservable() || (0, $g5fNy.of)({})
            ]).pipe((0, $gawXH.map)(([cards, options])=>({
                    _monad: {
                        isMobile: this.responsive.getBoth().width <= 600
                    },
                    options: options,
                    cards: cards
                })));
        },
        Render: ()=>function(s) {
                var _a, _b;
                if (!s.cards.length) return $4TeKW.html``;
                const Select = (selector)=>(this.shadowRoot || this).querySelector(selector);
                const container = Select(".swiper-container");
                if (!container) this.requestUpdate();
                let selectedSlide;
                const { _monad: _monad, cards: cards, options: options } = s;
                if (container) {
                    if (this.swiper) this.swiper.destroy(true, true);
                    this.swiper = this.initSwiper({
                        pagination: Select(".swiper-pagination"),
                        prev: Select(".swiper-button-prev"),
                        next: Select(".swiper-button-next"),
                        container: container
                    })(options);
                    const path = window.location.href.replace(window.location.origin, "");
                    const trace = this.genericAppsService.getLastTrace();
                    if (path === (trace == null ? void 0 : trace.path)) this.swiper.slideTo(trace.activeIndex, 0);
                    const handler = ()=>this.goToPage(this.swiper.activeIndex)([
                            cards,
                            options
                        ]);
                    this.swiper.on("slideChange", ()=>{
                        if (selectedSlide) selectedSlide.removeEventListener("click", handler);
                        this.genericAppsService.addTrace({
                            activeIndex: this.swiper.activeIndex,
                            path: path
                        });
                        setTimeout(()=>{
                            this.setShadowToActivePage();
                            selectedSlide = Select(".swiper-slide-active");
                            selectedSlide.addEventListener("click", handler);
                        });
                    });
                    selectedSlide = Select(".swiper-slide-active");
                    selectedSlide.addEventListener("click", handler);
                    this.setShadowToActivePage();
                    this.genericAppsService.addTrace({
                        activeIndex: this.swiper.activeIndex,
                        path: path
                    });
                    if (!this.rendered && !options.disableAnimations) {
                        const zoomInOptions = (_b = (_a = options.animations) == null ? void 0 : _a.speed) == null ? void 0 : _b.zoomIn;
                        (0, $frkuW.animateElement)(container, "zoomIn", `duration-${zoomInOptions ? zoomInOptions : 300}`).subscribe();
                    }
                    this.unsubscribe();
                    this.enterKey = this.hotkeys.bind("enter").pipe((0, $3dOhR.tap)(()=>console.log("ENTER"))).subscribe(()=>this.goToPage(this.swiper.activeIndex)([
                            cards,
                            options
                        ]));
                    this.backKey = this.hotkeys.bind("backspace").subscribe(()=>this.onBackSpace()([
                            cards,
                            options
                        ]));
                    this.leftKey = this.hotkeys.bind("left").subscribe(()=>this.swiper.slidePrev());
                    this.rightKey = this.hotkeys.bind("right").subscribe(()=>this.swiper.slideNext());
                    this.rendered = true;
                }
                return $4TeKW.html`
        <button
          class="close"
          @click=${()=>{
                    var _a2;
                    this.router.go((_a2 = options.routerBackUrl) != null ? _a2 : "/");
                    this.modalService.close();
                    this.genericAppsService.clearTraces();
                }}
        >
          ${$4TeKW.svg`
 <svg width="30" height="30" viewBox="0 0 14 14">
 <line fill="none" stroke="#666" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line>
 <line fill="none" stroke="#666" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line>
 </svg>
 `}
        </button>
        <style>
          ${$frkuW.Animations} ${$lzXjJ.SwiperCss} ${$a648c9f2a263cddb$var$style}
        </style>

        <div
          @contextmenu=${(e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    this.onBackSpace()([
                        cards,
                        options
                    ]);
                }}
          class="swiper-container"
        >
          <div class="swiper-wrapper">
            ${cards.map((c, i)=>$4TeKW.html`
                <div
                  @click=${()=>{
                        if (this.swiper.activeIndex === i + 1) this.swiper.slidePrev();
                        else if (this.swiper.activeIndex === i - 1) this.swiper.slideNext();
                    }}
                  class="swiper-slide swiper-slide-${i}"
                  data-history=${i}
                >
                  <div>${c.template}</div>
                </div>
              `)}
          </div>
          <p class="swiper-pagination"></p>
        </div>

        <r-if .exp=${!_monad.isMobile}>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </r-if>
        <div
          class="back-button"
          @click=${()=>this.onBackSpace()([
                        cards,
                        options
                    ])}
        >
          BACK
        </div>
      `;
            }
    })
], $a648c9f2a263cddb$var$GenericModal);

});
parcelRegister("613YX", function(module, exports) {
"use strict";
var $4615ecd9774a2f80$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Component = module.exports.Partial = module.exports.DefineDependencies = void 0;
parcelRequire("glP0k");

var $4TeKW = parcelRequire("4TeKW");
const $4615ecd9774a2f80$var$DefineDependencies = (...deps)=>(injection)=>{
        for (const [index, dep] of deps.entries())Object.defineProperty(deps, index, {
            get: ()=>injection && injection.has(dep) ? injection.get(dep) : dep
        });
        return deps;
    };
module.exports.DefineDependencies = $4615ecd9774a2f80$var$DefineDependencies;
/**
 * This method waits for the parent component to finish loading and then triggers event
 * OnRendererLoaded is a specially designed hook to wait for the last dom rerender
 * before calling the callback
 */ function $4615ecd9774a2f80$var$waitBeforeTrigger() {
    var _a;
    return $4615ecd9774a2f80$var$__awaiter(this, void 0, void 0, function*() {
        yield this.updateComplete;
        yield new Promise(requestAnimationFrame);
        (_a = this.OnRendererLoaded) === null || _a === void 0 || _a.call(this);
    });
}
const $4615ecd9774a2f80$var$Partial = (options)=>(deps = [])=>(state = ()=>({}))=>(loading = ()=>null)=>(error = ()=>null)=>(render = ()=>state)=>(0, $4TeKW.Component)(Object.assign(Object.assign({}, options), {
                            template () {
                                return (0, $4TeKW.html)`
          <r-renderer
            @loaded=${$4615ecd9774a2f80$var$waitBeforeTrigger.bind(this)}
            .options=${{
                                    state: state.bind(this).call(this, deps),
                                    loading: loading.bind(this),
                                    error: error.bind(this),
                                    deepCloneState: options.deepCloneState,
                                    render: (state, setState, shadowRoot)=>{
                                        this.shadowRoot.append(shadowRoot);
                                        return render(deps).bind(this).call(this, state, setState, shadowRoot);
                                    }
                                }}
          ></r-renderer>
        `;
                            }
                        }));
module.exports.Partial = $4615ecd9774a2f80$var$Partial;
function $4615ecd9774a2f80$var$Component({ Settings: Settings, Providers: Providers, State: State, Render: Render, Loading: Loading, Error: Error }) {
    return (0, module.exports.Partial)(Settings)(Providers)(State)(Loading)(Error)(Render);
}
module.exports.Component = $4615ecd9774a2f80$var$Component;

});

parcelRegister("9tLTP", function(module, exports) {
"use strict";
var $6e6bfa54ed0cf133$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6e6bfa54ed0cf133$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6e6bfa54ed0cf133$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6e6bfa54ed0cf133$var$__exportStar((parcelRequire("3KaAt")), module.exports);

$6e6bfa54ed0cf133$var$__exportStar((parcelRequire("gH1S5")), module.exports);

$6e6bfa54ed0cf133$var$__exportStar((parcelRequire("hssI1")), module.exports);

});
parcelRegister("3KaAt", function(module, exports) {
"use strict";
var $2b9de1636e1d9a69$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b9de1636e1d9a69$var$HotkeyModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HotkeyModule = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $hssI1 = parcelRequire("hssI1");

var $gH1S5 = parcelRequire("gH1S5");
let $2b9de1636e1d9a69$var$HotkeyModule = $2b9de1636e1d9a69$var$HotkeyModule_1 = class HotkeyModule {
    static forRoot(config = {}) {
        return {
            module: $2b9de1636e1d9a69$var$HotkeyModule_1,
            providers: [
                $gH1S5.HotKeysService,
                {
                    provide: $hssI1.HotkeysConfig,
                    useValue: config
                }
            ]
        };
    }
};
module.exports.HotkeyModule = $2b9de1636e1d9a69$var$HotkeyModule;
module.exports.HotkeyModule = $2b9de1636e1d9a69$var$HotkeyModule = $2b9de1636e1d9a69$var$HotkeyModule_1 = $2b9de1636e1d9a69$var$__decorate([
    (0, $1t8Wn.Module)()
], $2b9de1636e1d9a69$var$HotkeyModule);

});
parcelRegister("hssI1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HotkeysConfig = void 0;

var $1t8Wn = parcelRequire("1t8Wn");
module.exports.HotkeysConfig = new $1t8Wn.InjectionToken();

});

parcelRegister("gH1S5", function(module, exports) {
"use strict";
var $c2721d1c1d434a3d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c2721d1c1d434a3d$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HotKeysService = void 0;
parcelRequire("5fcMO");

var $1t8Wn = parcelRequire("1t8Wn");

var $8id0M = parcelRequire("8id0M");

var $hssI1 = parcelRequire("hssI1");
let $c2721d1c1d434a3d$var$HotKeysService = class HotKeysService {
    constructor(){
        this.mousetrap = new Mousetrap();
    }
    OnInit() {
        var _a, _b;
        (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.globalBindings) === null || _b === void 0 || _b.forEach(([key, callback])=>this.mousetrap.bind(key, callback));
    }
    bind(key) {
        return new $8id0M.Observable((o)=>{
            this.mousetrap.bind(key, (e)=>o.next(e));
        });
    }
    unbind(key, action) {
        this.mousetrap.unbind(key, action);
    }
    trigger(key, action) {
        this.mousetrap.trigger(key, action);
    }
    reset() {
        this.mousetrap.reset();
    }
    stopCallback(e, element) {
        return new $8id0M.Observable((o)=>{
            this.mousetrap.stopCallback(e, element, o.next.bind(o));
        });
    }
};
module.exports.HotKeysService = $c2721d1c1d434a3d$var$HotKeysService;
$c2721d1c1d434a3d$var$__decorate([
    (0, $1t8Wn.Injector)($hssI1.HotkeysConfig),
    $c2721d1c1d434a3d$var$__metadata("design:type", Object)
], $c2721d1c1d434a3d$var$HotKeysService.prototype, "config", void 0);
module.exports.HotKeysService = $c2721d1c1d434a3d$var$HotKeysService = $c2721d1c1d434a3d$var$__decorate([
    (0, $1t8Wn.Injectable)({
        init: true
    })
], $c2721d1c1d434a3d$var$HotKeysService);

});
parcelRegister("5fcMO", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});




parcelRegister("8kgMp", function(module, exports) {
"use strict";
var $60fd3519cb2148ec$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $60fd3519cb2148ec$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $60fd3519cb2148ec$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $60fd3519cb2148ec$var$__createBinding(exports1, m, p);
};
var $60fd3519cb2148ec$var$RouterModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouterModule = void 0;

var $1t8Wn = parcelRequire("1t8Wn");



let $60fd3519cb2148ec$var$RouterModule = $60fd3519cb2148ec$var$RouterModule_1 = class RouterModule {
    static forRoot(routes, options) {
        return {
            module: $60fd3519cb2148ec$var$RouterModule_1,
            services: [
                {
                    provide: (parcelRequire("53wT2")).RouterOptions,
                    useValue: options || {}
                },
                {
                    provide: (parcelRequire("53wT2")).Routes,
                    useValue: (0, (parcelRequire("fDR7U")).loadRoutes)(routes)
                }
            ],
            components: [
                (parcelRequire("jt58c")).RouterComponent
            ]
        };
    }
    static forChild(routes) {
        (parcelRequire("fDR7U")).ChildRoutesObservable.next((0, (parcelRequire("fDR7U")).loadRoutes)(routes));
        return $60fd3519cb2148ec$var$RouterModule_1;
    }
};
module.exports.RouterModule = $60fd3519cb2148ec$var$RouterModule;
module.exports.RouterModule = $60fd3519cb2148ec$var$RouterModule = $60fd3519cb2148ec$var$RouterModule_1 = $60fd3519cb2148ec$var$__decorate([
    (0, $1t8Wn.Module)()
], $60fd3519cb2148ec$var$RouterModule);

$60fd3519cb2148ec$var$__exportStar((parcelRequire("53wT2")), module.exports);

$60fd3519cb2148ec$var$__exportStar((parcelRequire("diAGB")), module.exports);

$60fd3519cb2148ec$var$__exportStar((parcelRequire("cKnQX")), module.exports);

$60fd3519cb2148ec$var$__exportStar((parcelRequire("jt58c")), module.exports);

$60fd3519cb2148ec$var$__exportStar((parcelRequire("gEqmA")), module.exports);

$60fd3519cb2148ec$var$__exportStar((parcelRequire("fDR7U")), module.exports);

});
parcelRegister("fDR7U", function(module, exports) {
"use strict";
var $b633b5601f730f01$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChildRoutesObservable = void 0;
module.exports.loadRoutes = $b633b5601f730f01$var$loadRoutes;
module.exports.getQueryParams = $b633b5601f730f01$var$getQueryParams;

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
var $8MKp4 = parcelRequire("8MKp4");
var $9cVh7 = parcelRequire("9cVh7");

var $53wT2 = parcelRequire("53wT2");
const $b633b5601f730f01$var$RouteCache = new Map();
module.exports.ChildRoutesObservable = new $bq6Hs.BehaviorSubject(null);
function $b633b5601f730f01$var$assignChildren(route) {
    if (route.children && typeof route.children === 'function') {
        const lazyModule = route.children;
        route.children = function(context, commands) {
            return $b633b5601f730f01$var$__awaiter(this, void 0, void 0, function*() {
                const loadedModule = yield lazyModule(context, commands);
                let routes = module.exports.ChildRoutesObservable.getValue();
                if (loadedModule && Array.isArray(loadedModule.ROUTES)) routes = loadedModule.ROUTES;
                const params = [
                    ...(routes || []).map((r)=>Object.assign({}, r))
                ];
                if (!$b633b5601f730f01$var$RouteCache.has(route.path)) $b633b5601f730f01$var$RouteCache.set(route.path, params);
                return $b633b5601f730f01$var$RouteCache.get(route.path);
            });
        };
    }
    return route;
}
function $b633b5601f730f01$var$activateGuard(result, commands, route) {
    return $b633b5601f730f01$var$__awaiter(this, void 0, void 0, function*() {
        if ((0, $8MKp4.isObservable)(result)) result = (0, $9cVh7.lastValueFrom)(result);
        if (yield result) return result;
        else {
            const routerOptions = $1t8Wn.Container.get($53wT2.RouterOptions);
            let redirect;
            if (route.path === '/') redirect = commands.redirect('/not-found');
            else redirect = commands.redirect(route.parent.path || '/');
            if (routerOptions.log) console.error(`Guard ${route.canActivate['originalName']} activated!`);
            return redirect;
        }
    });
}
function $b633b5601f730f01$var$assignAction(route) {
    if (route.canActivate) {
        const guard = $1t8Wn.Container.get(route.canActivate);
        if (route.action) {
            const originalAction = route.action;
            route.action = function(context, commands) {
                return $b633b5601f730f01$var$__awaiter(this, void 0, void 0, function*() {
                    yield originalAction(context, commands);
                    const result = guard.canActivate.bind(guard)(context, commands);
                    return $b633b5601f730f01$var$activateGuard(result, commands, route);
                });
            };
        } else {
            route.action = guard.canActivate.bind(guard);
            const originalAction = route.action;
            route.action = function(context, commands) {
                return $b633b5601f730f01$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield originalAction(context, commands);
                    return $b633b5601f730f01$var$activateGuard(result, commands, route);
                });
            };
        }
    }
    return route;
}
function $b633b5601f730f01$var$assignStaticIs(route) {
    if (typeof route.component === 'function') route.component = route.component.is();
    if (Array.isArray(route.children)) route.children = route.children.map((child)=>$b633b5601f730f01$var$assignStaticIs($b633b5601f730f01$var$assignAction($b633b5601f730f01$var$assignChildren(child))));
    return route;
}
function $b633b5601f730f01$var$loadRoutes(routes) {
    const notFoundRoute = routes.find((v)=>v.path === '(.*)');
    routes = routes.sort(function(a, b) {
        if (a.path < b.path) return -1;
        if (b.path < a.path) return 1;
        return 0;
    });
    if (notFoundRoute) {
        routes.splice(routes.indexOf(notFoundRoute), 1);
        routes.push(notFoundRoute);
    }
    const loadedRoutes = [
        ...routes
    ].map((route)=>$b633b5601f730f01$var$assignStaticIs($b633b5601f730f01$var$assignAction($b633b5601f730f01$var$assignChildren(route))));
    module.exports.ChildRoutesObservable.next(null);
    return loadedRoutes;
}
function $b633b5601f730f01$var$getQueryParams() {
    return [
        ...new URLSearchParams(location.search)
    ].reduce((prev, [key, value])=>Object.assign(Object.assign({}, prev), {
            [key]: value
        }), {});
}

});
parcelRegister("9cVh7", function(module, exports) {

$parcel$export(module.exports, "lastValueFrom", () => $6b41a9b35670bb59$export$a175cc82f1f2275e);

var $77jL3 = parcelRequire("77jL3");
function $6b41a9b35670bb59$export$a175cc82f1f2275e(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function(value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function() {
                if (_hasValue) resolve(_value);
                else if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $77jL3.EmptyError)());
            }
        });
    });
}

});
parcelRegister("77jL3", function(module, exports) {

$parcel$export(module.exports, "EmptyError", () => $52e883593ea01f0d$export$78f6d1b1dbcda304);

var $iNflj = parcelRequire("iNflj");
var $52e883593ea01f0d$export$78f6d1b1dbcda304 = (0, $iNflj.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});

});


parcelRegister("53wT2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouterOptions = module.exports.Routes = module.exports.RouterRoutlet = void 0;
module.exports.Router = $3ae6be2880ae1d59$var$Router;

var $1t8Wn = parcelRequire("1t8Wn");
function $3ae6be2880ae1d59$var$Router() {
    return (target, propertyKey)=>{
        Object.defineProperty(target, propertyKey, {
            get: ()=>$1t8Wn.Container.get(module.exports.RouterRoutlet)
        });
    };
}
module.exports.RouterRoutlet = 'router-outlet';
module.exports.Routes = 'router-routes';
module.exports.RouterOptions = new $1t8Wn.InjectionToken('router-options');

});


parcelRegister("jt58c", function(module, exports) {
"use strict";
var $e2c4b4bccd5375fd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e2c4b4bccd5375fd$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouterComponent = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $53wT2 = parcelRequire("53wT2");

var $diAGB = parcelRequire("diAGB");
/**
 * @customElement router-outlet
 */ let $e2c4b4bccd5375fd$var$RouterComponent = class RouterComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.id = 'router-identifier';
    }
    OnUpdateFirst() {
        const router = new $diAGB.Outlet(this.shadowRoot.getElementById(this.id), $1t8Wn.Container.get($53wT2.RouterOptions));
        router.setRoutes(this.routes ? this.routes : $1t8Wn.Container.get($53wT2.Routes));
        $1t8Wn.Container.set('router-outlet', router);
        this.dispatchEvent(new CustomEvent('onRouterLoaded', {
            detail: router
        }));
    }
};
module.exports.RouterComponent = $e2c4b4bccd5375fd$var$RouterComponent;
$e2c4b4bccd5375fd$var$__decorate([
    (0, $4TeKW.property)(),
    $e2c4b4bccd5375fd$var$__metadata("design:type", Object)
], $e2c4b4bccd5375fd$var$RouterComponent.prototype, "id", void 0);
$e2c4b4bccd5375fd$var$__decorate([
    (0, $4TeKW.property)({
        type: Array
    }),
    $e2c4b4bccd5375fd$var$__metadata("design:type", Object)
], $e2c4b4bccd5375fd$var$RouterComponent.prototype, "routes", void 0);
module.exports.RouterComponent = $e2c4b4bccd5375fd$var$RouterComponent = $e2c4b4bccd5375fd$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'router-outlet',
        template () {
            return (0, $4TeKW.html)`
      <slot name="header"></slot>
      ${(0, $4TeKW.html)` <main id="${this.id}"></main> `}
      <slot name="footer"></slot>
    `;
        }
    })
], $e2c4b4bccd5375fd$var$RouterComponent);

});
parcelRegister("diAGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Outlet = void 0;

var $jIao5 = parcelRequire("jIao5");

var $3dOhR = parcelRequire("3dOhR");

var $fDR7U = parcelRequire("fDR7U");

var $7zVsc = parcelRequire("7zVsc");
class $9ae969ea4b1bfb15$var$Outlet extends $7zVsc.Router {
    constructor(element, options){
        super(element, options);
        this.options = options;
        this.activePath = '/';
        this.subscription = this.onSnapshotChange().pipe((0, $3dOhR.tap)((event)=>{
            if (this.options.log) console.log(`You are at '${event.detail.location.pathname}'`);
            this.activePath = event.detail.location.pathname;
        })).subscribe();
    }
    onSnapshotChange() {
        return (0, $jIao5.fromEvent)(window, 'router-location-changed');
    }
    freezeRouter() {
        this.freeze = true;
    }
    unfreezeRouter() {
        this.freeze = false;
    }
    getQueryParams() {
        return (0, $fDR7U.getQueryParams)();
    }
    /**
     * Triggers navigation to a new path. Returns a boolean without waiting until the navigation is complete. Returns true if at least one Router has handled the navigation (was subscribed and had baseUrl matching the pathname argument), otherwise returns false.
     * @param pathnamea new in-app path
     * @returns void
     */ go(path) {
        if (this.activePath === path || this.freeze) return false;
        this.activePath = path;
        if (this.options.freeze) this.freezeRouter();
        // window.dispatchEvent(new CustomEvent('router-go', {detail: {pathname: '/to/path'}}));
        return $7zVsc.Router.go(path);
    }
    /**
     * Removes the subscription to navigation events created in the subscribe() method.
     */ unsubscribe() {
        if (this.subscription) this.subscription.unsubscribe();
        super.unsubscribe();
    }
}
module.exports.Outlet = $9ae969ea4b1bfb15$var$Outlet;

});
parcelRegister("7zVsc", function(module, exports) {
"use strict";
var $016c85a6d5cfe45a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $016c85a6d5cfe45a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $016c85a6d5cfe45a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Router = module.exports.Resolver = void 0;

var $gSKBQ = parcelRequire("gSKBQ");
Object.defineProperty(module.exports, "Resolver", {
    enumerable: true,
    get: function() {
        return $gSKBQ.Resolver;
    }
});

var $eqZbC = parcelRequire("eqZbC");
Object.defineProperty(module.exports, "Router", {
    enumerable: true,
    get: function() {
        return $eqZbC.Router;
    }
});

$016c85a6d5cfe45a$var$__exportStar((parcelRequire("ifulk")), module.exports);

});
parcelRegister("gSKBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Resolver = void 0;
module.exports.generateUrls = $c4a5d82a8b450abc$var$generateUrls;

var $6x2ae = parcelRequire("6x2ae");

var $ifulk = parcelRequire("ifulk");

var $b2BJp = parcelRequire("b2BJp");
const { hasOwnProperty: $c4a5d82a8b450abc$var$hasOwnProperty } = Object.prototype;
const $c4a5d82a8b450abc$var$cache = new Map();
$c4a5d82a8b450abc$var$cache.set('|false', {
    keys: [],
    pattern: /(?:)/
});
function $c4a5d82a8b450abc$var$decodeParam(val) {
    try {
        return decodeURIComponent(val);
    } catch (err) {
        return val;
    }
}
function $c4a5d82a8b450abc$var$matchPath(routepath, path, exact, parentKeys, parentParams) {
    exact = !!exact;
    const cacheKey = `${routepath}|${exact}`;
    let regexp = $c4a5d82a8b450abc$var$cache.get(cacheKey);
    if (!regexp) {
        const keys = [];
        regexp = {
            keys: keys,
            pattern: (0, $6x2ae.pathToRegexp)(routepath, keys, {
                end: exact,
                strict: routepath === ''
            })
        };
        $c4a5d82a8b450abc$var$cache.set(cacheKey, regexp);
    }
    const m = regexp.pattern.exec(path);
    if (!m) return null;
    const params = Object.assign({}, parentParams);
    for(let i = 1; i < m.length; i++){
        const key = regexp.keys[i - 1];
        const prop = key.name;
        const value = m[i];
        if (value !== undefined || !$c4a5d82a8b450abc$var$hasOwnProperty.call(params, prop)) {
            if (key.repeat) params[prop] = value ? value.split(key.delimiter).map($c4a5d82a8b450abc$var$decodeParam) : [];
            else params[prop] = value ? $c4a5d82a8b450abc$var$decodeParam(value) : value;
        }
    }
    return {
        path: m[0],
        keys: (parentKeys || []).concat(regexp.keys),
        params: params
    };
}
function $c4a5d82a8b450abc$var$matchRoute(route, pathname, ignoreLeadingSlash, parentKeys, parentParams) {
    let match;
    let childMatches;
    let childIndex = 0;
    let routepath = route.path || '';
    let isAbsolute = false;
    if (Array.isArray(routepath)) routepath = routepath.map((path)=>{
        if (path.charAt(0) === '/') {
            isAbsolute = true;
            return ignoreLeadingSlash ? path.substr(1) : path;
        }
        return path;
    });
    else if (routepath.charAt(0) === '/') {
        isAbsolute = true;
        if (ignoreLeadingSlash) routepath = routepath.substr(1);
    }
    if (isAbsolute) ignoreLeadingSlash = true;
    return {
        next (routeToSkip) {
            if (route === routeToSkip) return {
                done: true,
                value: undefined
            };
            const children = route.__children = route.__children || route.children;
            if (!match) {
                match = $c4a5d82a8b450abc$var$matchPath(routepath, pathname, !children, parentKeys, parentParams);
                if (match) return {
                    done: false,
                    value: {
                        route: route,
                        keys: match.keys,
                        params: match.params,
                        path: match.path
                    }
                };
            }
            if (match && children) while(childIndex < children.length){
                if (!childMatches) {
                    const childRoute = children[childIndex];
                    childRoute.parent = route;
                    let matchedLength = match.path.length;
                    if (matchedLength > 0 && pathname.charAt(matchedLength) === '/') matchedLength += 1;
                    childMatches = $c4a5d82a8b450abc$var$matchRoute(childRoute, pathname.substr(matchedLength), ignoreLeadingSlash, match.keys, match.params);
                }
                const childMatch = childMatches.next(routeToSkip);
                if (!childMatch.done) return {
                    done: false,
                    value: childMatch.value
                };
                childMatches = null;
                childIndex++;
            }
            return {
                done: true,
                value: undefined
            };
        }
    };
}
function $c4a5d82a8b450abc$var$resolveRoute(context) {
    if ((0, $b2BJp.isFunction)(context.route.action)) return context.route.action(context);
    return undefined;
}
function $c4a5d82a8b450abc$var$isChildRoute(parentRoute, childRoute) {
    let route = childRoute;
    while(route){
        route = route.parent;
        if (route === parentRoute) return true;
    }
    return false;
}
function $c4a5d82a8b450abc$var$generateErrorMessage(currentContext) {
    let errorMessage = `Path '${currentContext.pathname}' is not properly resolved due to an error.`;
    const routePath = (currentContext.route || {}).path;
    if (routePath) errorMessage += ` Resolution had failed on route: '${routePath}'`;
    return errorMessage;
}
function $c4a5d82a8b450abc$var$updateChainForRoute(context, match) {
    const { route: route, path: path } = match;
    if (route && !route.__synthetic) {
        const item = {
            path: path,
            route: route
        };
        if (!context.chain) context.chain = [];
        else if (route.parent) {
            let i = context.chain.length;
            while(i-- && context.chain[i].route && context.chain[i].route !== route.parent)context.chain.pop();
        }
        context.chain.push(item);
    }
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ class $c4a5d82a8b450abc$var$Resolver {
    constructor(routes, options = {}){
        if (Object(routes) !== routes) throw new TypeError('Invalid routes');
        this.baseUrl = options.baseUrl || '';
        this.errorHandler = options.errorHandler;
        this.resolveRoute = options.resolveRoute || $c4a5d82a8b450abc$var$resolveRoute;
        this.context = Object.assign({
            resolver: this
        }, options.context);
        this.root = Array.isArray(routes) ? {
            path: '',
            __children: routes,
            parent: null,
            __synthetic: true
        } : routes;
        this.root.parent = null;
    }
    /**
     * Returns the current list of routes (as a shallow copy). Adding / removing
     * routes to / from the returned array does not affect the routing config,
     * but modifying the route objects does.
     *
     * @return
     */ getRoutes() {
        const children = this.root.__children;
        return Array.isArray(children) ? [
            ...children
        ] : [];
    }
    /**
     * Sets the routing config (replacing the existing one).
     *
     * @param routes a single route or an array of those
     *    (the array is shallow copied)
     */ setRoutes(routes) {
        (0, $b2BJp.ensureRoutes)(routes);
        const newRoutes = [
            ...(0, $b2BJp.toArray)(routes)
        ];
        this.root.__children = newRoutes;
    }
    /**
     * Appends one or several routes to the routing config and returns the
     * effective routing config after the operation.
     *
     * @param routes a single route or an array of those
     *    (the array is shallow copied)
     * @return
     * @protected
     */ addRoutes(routes) {
        (0, $b2BJp.ensureRoutes)(routes);
        if (!this.root.__children || !Array.isArray(this.root.__children)) this.root.__children = [];
        this.root.__children.push(...(0, $b2BJp.toArray)(routes));
        return this.getRoutes();
    }
    /**
     * Removes all existing routes from the routing config.
     */ removeRoutes() {
        this.setRoutes([]);
    }
    /**
     * Asynchronously resolves the given pathname, i.e. finds all routes matching
     * the pathname and tries resolving them one after another in the order they
     * are listed in the routes config until the first non-null result.
     *
     * Returns a promise that is fulfilled with the return value of an object that consists of the first
     * route handler result that returns something other than `null` or `undefined` and context used to get this result.
     *
     * If no route handlers return a non-null result, or if no route matches the
     * given pathname the returned promise is rejected with a 'page not found'
     * `Error`.
     *
     * @param pathnameOrContext the pathname to
     *    resolve or a context object with a `pathname` property and other
     *    properties to pass to the route resolver functions.
     * @return
     */ resolve(pathnameOrContext) {
        const context = Object.assign({}, this.context, (0, $b2BJp.isString)(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext);
        const match = $c4a5d82a8b450abc$var$matchRoute(this.root, this.__normalizePathname(context.pathname), !!this.baseUrl);
        const resolve = this.resolveRoute;
        let matches = null;
        let nextMatches = null;
        let currentContext = context;
        function next(resume, parent = matches.value.route, prevResult) {
            const routeToSkip = prevResult === null && matches.value.route;
            matches = nextMatches || match.next(routeToSkip);
            nextMatches = null;
            if (!resume) {
                if (matches.done || !$c4a5d82a8b450abc$var$isChildRoute(parent, matches.value.route)) {
                    nextMatches = matches;
                    return Promise.resolve($ifulk.notFoundResult);
                }
            }
            if (matches.done) return Promise.reject((0, $b2BJp.getNotFoundError)(context));
            currentContext = Object.assign(currentContext ? {
                chain: currentContext.chain ? currentContext.chain.slice(0) : []
            } : {}, context, matches.value);
            $c4a5d82a8b450abc$var$updateChainForRoute(currentContext, matches.value);
            return Promise.resolve(resolve(currentContext)).then((resolution)=>{
                if (resolution !== null && resolution !== undefined && resolution !== $ifulk.notFoundResult) {
                    currentContext.result = resolution.redirect ? resolution : resolution.tagName ? resolution : resolution;
                    return currentContext;
                }
                return next(resume, parent, resolution);
            });
        }
        context.next = next;
        return Promise.resolve().then(()=>next(true, this.root)).then((result)=>{
            if (result === $ifulk.notFoundResult) throw (0, $b2BJp.getNotFoundError)(context);
            return result;
        }).catch((error)=>{
            const errorMessage = $c4a5d82a8b450abc$var$generateErrorMessage(currentContext);
            if (!error) error = new Error(errorMessage);
            else console.warn(errorMessage);
            error.context = error.context || currentContext;
            if (!(error instanceof DOMException)) error.code = error.code || 500;
            if (this.errorHandler) {
                currentContext.result = this.errorHandler(error);
                return currentContext;
            }
            throw error;
        });
    }
    static __createUrl(url, base) {
        return new URL(url, base);
    }
    __getEffectiveBaseUrl() {
        return this.baseUrl ? this.constructor.__createUrl(this.baseUrl, document.baseURI || document.URL).href.replace(/[^\/]*$/, '') : '';
    }
    __normalizePathname(pathname) {
        if (!this.baseUrl) return pathname;
        const base = this.__getEffectiveBaseUrl();
        const normalizedUrl = this.constructor.__createUrl(pathname, base).href;
        if (normalizedUrl.slice(0, base.length) === base) return normalizedUrl.slice(base.length);
        return undefined;
    }
}
module.exports.Resolver = $c4a5d82a8b450abc$var$Resolver;
const $c4a5d82a8b450abc$var$cache$1 = new Map();
function $c4a5d82a8b450abc$var$cacheRoutes(routesByName, route, routes) {
    const name = route.name || route.component;
    if (name) {
        if (routesByName.has(name)) routesByName.get(name).push(route);
        else routesByName.set(name, [
            route
        ]);
    }
    if (Array.isArray(routes)) for(let i = 0; i < routes.length; i++){
        const childRoute = routes[i];
        childRoute.parent = route;
        $c4a5d82a8b450abc$var$cacheRoutes(routesByName, childRoute, childRoute.__children || childRoute.children);
    }
}
function $c4a5d82a8b450abc$var$getRouteByName(routesByName, routeName) {
    const routes = routesByName.get(routeName);
    if (routes && routes.length > 1) throw new Error(`Duplicate route with name "${routeName}".` + ` Try seting unique 'name' route properties.`);
    return routes && routes[0];
}
function $c4a5d82a8b450abc$var$getRoutePath(route) {
    let path = route.path;
    path = Array.isArray(path) ? path[0] : path;
    return path !== undefined ? path : '';
}
function $c4a5d82a8b450abc$var$generateUrls(router, options = {}) {
    if (!(router instanceof $c4a5d82a8b450abc$var$Resolver)) throw new TypeError('An instance of Resolver is expected');
    const routesByName = new Map();
    return (routeName, params)=>{
        let route = $c4a5d82a8b450abc$var$getRouteByName(routesByName, routeName);
        if (!route) {
            routesByName.clear();
            $c4a5d82a8b450abc$var$cacheRoutes(routesByName, router.root, router.root.__children);
            route = $c4a5d82a8b450abc$var$getRouteByName(routesByName, routeName);
            if (!route) throw new Error(`Route "${routeName}" not found`);
        }
        let regexp = $c4a5d82a8b450abc$var$cache$1.get(route.fullPath);
        if (!regexp) {
            let fullPath = $c4a5d82a8b450abc$var$getRoutePath(route);
            let rt = route.parent;
            while(rt){
                const path = $c4a5d82a8b450abc$var$getRoutePath(rt);
                if (path) fullPath = path.replace(/\/$/, '') + '/' + fullPath.replace(/^\//, '');
                rt = rt.parent;
            }
            const tokens = (0, $6x2ae.parse)(fullPath);
            const toPath = (0, $6x2ae.tokensToFunction)(tokens);
            const keys = Object.create(null);
            for(let i = 0; i < tokens.length; i++)if (!(0, $b2BJp.isString)(tokens[i])) keys[tokens[i].name] = true;
            regexp = {
                toPath: toPath,
                keys: keys
            };
            $c4a5d82a8b450abc$var$cache$1.set(fullPath, regexp);
            route.fullPath = fullPath;
        }
        let url = regexp.toPath(params, options) || '/';
        if (options.stringifyQueryParams && params) {
            const queryParams = {};
            const keys = Object.keys(params);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                if (!regexp.keys[key]) queryParams[key] = params[key];
            }
            const query = options.stringifyQueryParams(queryParams);
            if (query) url += query.charAt(0) === '?' ? query : `?${query}`;
        }
        return url;
    };
}

});
parcelRegister("6x2ae", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $4c1780e1d6e7325c$var$parse;
module.exports.compile = $4c1780e1d6e7325c$var$compile;
module.exports.tokensToFunction = $4c1780e1d6e7325c$var$tokensToFunction;
module.exports.tokensToRegExp = $4c1780e1d6e7325c$var$tokensToRegExp;
module.exports.pathToRegexp = $4c1780e1d6e7325c$var$pathToRegexp;
const $4c1780e1d6e7325c$var$DEFAULT_DELIMITER = '/';
const $4c1780e1d6e7325c$var$DEFAULT_DELIMITERS = './';
const $4c1780e1d6e7325c$var$PATH_REGEXP = new RegExp([
    '(\\\\.)',
    '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g');
function $4c1780e1d6e7325c$var$parse(str, options) {
    const tokens = [];
    let key = 0;
    let index = 0;
    let path = '';
    const defaultDelimiter = options && options.delimiter || $4c1780e1d6e7325c$var$DEFAULT_DELIMITER;
    const delimiters = options && options.delimiters || $4c1780e1d6e7325c$var$DEFAULT_DELIMITERS;
    let pathEscaped = false;
    let res;
    while((res = $4c1780e1d6e7325c$var$PATH_REGEXP.exec(str)) !== null){
        const m = res[0];
        const escaped = res[1];
        const offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        let prev = '';
        const next = str[index];
        const name = res[2];
        const capture = res[3];
        const group = res[4];
        const modifier = res[5];
        if (!pathEscaped && path.length) {
            const k = path.length - 1;
            if (delimiters.indexOf(path[k]) > -1) {
                prev = path[k];
                path = path.slice(0, k);
            }
        }
        if (path) {
            tokens.push(path);
            path = '';
            pathEscaped = false;
        }
        const partial = prev !== '' && next !== undefined && next !== prev;
        const repeat = modifier === '+' || modifier === '*';
        const optional = modifier === '?' || modifier === '*';
        const delimiter = prev || defaultDelimiter;
        const pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            pattern: pattern ? $4c1780e1d6e7325c$var$escapeGroup(pattern) : '[^' + $4c1780e1d6e7325c$var$escapeString(delimiter) + ']+?'
        });
    }
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
function $4c1780e1d6e7325c$var$compile(str, options) {
    return $4c1780e1d6e7325c$var$tokensToFunction($4c1780e1d6e7325c$var$parse(str, options));
}
function $4c1780e1d6e7325c$var$tokensToFunction(tokens) {
    const matches = new Array(tokens.length);
    for(let i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    return function(data, options) {
        let path = '';
        const encode = options && options.encode || encodeURIComponent;
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            let segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(let j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                segment = encode(String(value), token);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) {
                if (token.partial) path += token.prefix;
                continue;
            }
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'));
        }
        return path;
    };
}
function $4c1780e1d6e7325c$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
function $4c1780e1d6e7325c$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, '\\$1');
}
function $4c1780e1d6e7325c$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
function $4c1780e1d6e7325c$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groups = path.source.match(/\((?!\?)/g);
    if (groups) for(let i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: '',
        delimiter: '',
        optional: false,
        repeat: false,
        partial: false,
        pattern: ''
    });
    return path;
}
function $4c1780e1d6e7325c$var$arrayToRegexp(path, keys, options) {
    const parts = [];
    for(let i = 0; i < path.length; i++)parts.push($4c1780e1d6e7325c$var$pathToRegexp(path[i], keys, options).source);
    return new RegExp('(?:' + parts.join('|') + ')', $4c1780e1d6e7325c$var$flags(options));
}
function $4c1780e1d6e7325c$var$stringToRegexp(path, keys, options) {
    return $4c1780e1d6e7325c$var$tokensToRegExp($4c1780e1d6e7325c$var$parse(path, options), keys, options);
}
function $4c1780e1d6e7325c$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    const strict = options.strict;
    const start = options.start !== false;
    const end = options.end !== false;
    const delimiter = $4c1780e1d6e7325c$var$escapeString(options.delimiter || $4c1780e1d6e7325c$var$DEFAULT_DELIMITER);
    const delimiters = options.delimiters || $4c1780e1d6e7325c$var$DEFAULT_DELIMITERS;
    const endsWith = [].concat(options.endsWith || []).map($4c1780e1d6e7325c$var$escapeString).concat('$').join('|');
    let route = start ? '^' : '';
    let isEndDelimited = tokens.length === 0;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (typeof token === 'string') {
            route += $4c1780e1d6e7325c$var$escapeString(token);
            isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
        } else {
            const capture = token.repeat ? '(?:' + token.pattern + ')(?:' + $4c1780e1d6e7325c$var$escapeString(token.delimiter) + '(?:' + token.pattern + '))*' : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (token.partial) route += $4c1780e1d6e7325c$var$escapeString(token.prefix) + '(' + capture + ')?';
                else route += '(?:' + $4c1780e1d6e7325c$var$escapeString(token.prefix) + '(' + capture + '))?';
            } else route += $4c1780e1d6e7325c$var$escapeString(token.prefix) + '(' + capture + ')';
        }
    }
    if (end) {
        if (!strict) route += '(?:' + delimiter + ')?';
        route += endsWith === '$' ? '$' : '(?=' + endsWith + ')';
    } else {
        if (!strict) route += '(?:' + delimiter + '(?=' + endsWith + '))?';
        if (!isEndDelimited) route += '(?=' + delimiter + '|' + endsWith + ')';
    }
    return new RegExp(route, $4c1780e1d6e7325c$var$flags(options));
}
function $4c1780e1d6e7325c$var$pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return $4c1780e1d6e7325c$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $4c1780e1d6e7325c$var$arrayToRegexp(path, keys, options);
    return $4c1780e1d6e7325c$var$stringToRegexp(path, keys, options);
} // Attach static methods to pathToRegexp to match original usage if needed,
 // but since we are exporting them individually, consumers can just import them.
 // However, the original code used `pathToRegexp_1` which had static methods attached.
 // We can just export them as named exports.

});

parcelRegister("ifulk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.notFoundResult = void 0;
// TODO: Move this to a better place or import it
module.exports.notFoundResult = new class NotFoundResult {
}();

});

parcelRegister("b2BJp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toArray = $809d2649826cac82$var$toArray;
module.exports.log = $809d2649826cac82$var$log;
module.exports.logValue = $809d2649826cac82$var$logValue;
module.exports.ensureBundle = $809d2649826cac82$var$ensureBundle;
module.exports.isObject = $809d2649826cac82$var$isObject;
module.exports.isFunction = $809d2649826cac82$var$isFunction;
module.exports.isString = $809d2649826cac82$var$isString;
module.exports.ensureRoute = $809d2649826cac82$var$ensureRoute;
module.exports.ensureRoutes = $809d2649826cac82$var$ensureRoutes;
module.exports.loadScript = $809d2649826cac82$var$loadScript;
module.exports.loadBundle = $809d2649826cac82$var$loadBundle;
module.exports.fireRouterEvent = $809d2649826cac82$var$fireRouterEvent;
module.exports.getNotFoundError = $809d2649826cac82$var$getNotFoundError;
module.exports.getAnchorOrigin = $809d2649826cac82$var$getAnchorOrigin;
module.exports.runCallbackIfPossible = $809d2649826cac82$var$runCallbackIfPossible;

var $89wKK = parcelRequire("89wKK");
function $809d2649826cac82$var$toArray(objectOrArray) {
    objectOrArray = objectOrArray || [];
    return Array.isArray(objectOrArray) ? objectOrArray : [
        objectOrArray
    ];
}
function $809d2649826cac82$var$log(msg) {
    return `[Router] ${msg}`;
}
function $809d2649826cac82$var$logValue(value) {
    if (typeof value !== 'object') return String(value);
    const stringType = Object.prototype.toString.call(value).match(/ (.*)\]$/)[1];
    if (stringType === 'Object' || stringType === 'Array') return `${stringType} ${JSON.stringify(value)}`;
    else return stringType;
}
function $809d2649826cac82$var$ensureBundle(src) {
    if (!src.match(/.+\.[m]?js$/)) throw new Error($809d2649826cac82$var$log(`Unsupported type for bundle "${src}": .js or .mjs expected.`));
}
function $809d2649826cac82$var$isObject(o) {
    return typeof o === 'object' && !!o;
}
function $809d2649826cac82$var$isFunction(f) {
    return typeof f === 'function';
}
function $809d2649826cac82$var$isString(s) {
    return typeof s === 'string';
}
function $809d2649826cac82$var$ensureRoute(route) {
    if (!route || !$809d2649826cac82$var$isString(route.path)) throw new Error($809d2649826cac82$var$log(`Expected route config to be an object with a "path" string property, or an array of such objects`));
    const bundle = route.bundle;
    const stringKeys = [
        'component',
        'redirect',
        'bundle'
    ];
    if (!$809d2649826cac82$var$isFunction(route.action) && !Array.isArray(route.children) && !$809d2649826cac82$var$isFunction(route.children) && !$809d2649826cac82$var$isObject(bundle) && !stringKeys.some((key)=>$809d2649826cac82$var$isString(route[key]))) throw new Error($809d2649826cac82$var$log(`Expected route config "${route.path}" to include either "${stringKeys.join('", "')}" ` + `or "action" function but none found.`));
    if (bundle) {
        if ($809d2649826cac82$var$isString(bundle)) $809d2649826cac82$var$ensureBundle(bundle);
        else if (!$89wKK.bundleKeys.some((key)=>key in bundle)) throw new Error($809d2649826cac82$var$log('Expected route bundle to include either "' + $89wKK.NOMODULE + '" or "' + $89wKK.MODULE + '" keys, or both'));
        else $89wKK.bundleKeys.forEach((key)=>key in bundle && $809d2649826cac82$var$ensureBundle(bundle[key]));
    }
    if (route.redirect) [
        'bundle',
        'component'
    ].forEach((overriddenProp)=>{
        if (overriddenProp in route) console.warn($809d2649826cac82$var$log(`Route config "${route.path}" has both "redirect" and "${overriddenProp}" properties, ` + `and "redirect" will always override the latter. Did you mean to only use "${overriddenProp}"?`));
    });
}
function $809d2649826cac82$var$ensureRoutes(routes) {
    $809d2649826cac82$var$toArray(routes).forEach((route)=>$809d2649826cac82$var$ensureRoute(route));
}
function $809d2649826cac82$var$loadScript(src, key) {
    let script = document.head.querySelector('script[src="' + src + '"][async]');
    if (!script) {
        script = document.createElement('script');
        script.setAttribute('src', src);
        if (key === $89wKK.MODULE) script.setAttribute('type', $89wKK.MODULE);
        else if (key === $89wKK.NOMODULE) script.setAttribute($89wKK.NOMODULE, '');
        script.async = true;
    }
    return new Promise((resolve, reject)=>{
        script['onreadystatechange'] = script.onload = (e)=>{
            script.__dynamicImportLoaded = true;
            resolve(e);
        };
        script.onerror = (e)=>{
            if (script.parentNode) script.parentNode.removeChild(script);
            reject(e);
        };
        if (script.parentNode === null) document.head.appendChild(script);
        else if (script.__dynamicImportLoaded) resolve();
    });
}
function $809d2649826cac82$var$loadBundle(bundle) {
    if ($809d2649826cac82$var$isString(bundle)) return $809d2649826cac82$var$loadScript(bundle).then(()=>{
    //
    });
    else return Promise.race($89wKK.bundleKeys.filter((key)=>key in bundle).map((key)=>$809d2649826cac82$var$loadScript(bundle[key], key))).then(()=>{
    //
    });
}
function $809d2649826cac82$var$fireRouterEvent(type, detail) {
    return !window.dispatchEvent(new CustomEvent(`router-${type}`, {
        cancelable: type === 'go',
        detail: detail
    }));
}
function $809d2649826cac82$var$getNotFoundError(context) {
    const error = new Error($809d2649826cac82$var$log(`Page not found (${context.pathname})`));
    error.context = context;
    error.code = 404;
    return error;
}
function $809d2649826cac82$var$getAnchorOrigin(anchor) {
    const port = anchor.port;
    const protocol = anchor.protocol;
    const defaultHttp = protocol === 'http:' && port === '80';
    const defaultHttps = protocol === 'https:' && port === '443';
    const host = defaultHttp || defaultHttps ? anchor.hostname : anchor.host;
    return `${protocol}//${host}`;
}
function $809d2649826cac82$var$runCallbackIfPossible(callback, args, thisArg) {
    if ($809d2649826cac82$var$isFunction(callback)) return callback.apply(thisArg, args);
    return undefined;
}

});
parcelRegister("89wKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bundleKeys = module.exports.NOMODULE = module.exports.MODULE = void 0;
module.exports.MODULE = 'module';
module.exports.NOMODULE = 'nomodule';
module.exports.bundleKeys = [
    module.exports.MODULE,
    module.exports.NOMODULE
];

});



parcelRegister("eqZbC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Router = void 0;

var $6x2ae = parcelRequire("6x2ae");

var $gSKBQ = parcelRequire("gSKBQ");

var $fiXcB = parcelRequire("fiXcB");

var $ifulk = parcelRequire("ifulk");

var $b2BJp = parcelRequire("b2BJp");
const $a822f4bd5dc880f9$var$willAnimate = (elem)=>{
    const name = getComputedStyle(elem).getPropertyValue('animation-name');
    return name && name !== 'none';
};
const $a822f4bd5dc880f9$var$waitForAnimation = (elem, cb)=>{
    const listener = ()=>{
        elem.removeEventListener('animationend', listener);
        cb();
    };
    elem.addEventListener('animationend', listener);
};
function $a822f4bd5dc880f9$var$animate(elem, className) {
    elem.classList.add(className);
    return new Promise((resolve)=>{
        if ($a822f4bd5dc880f9$var$willAnimate(elem)) {
            const rect = elem.getBoundingClientRect();
            const size = `height: ${rect.bottom - rect.top}px; width: ${rect.right - rect.left}px`;
            elem.setAttribute('style', `position: absolute; ${size}`);
            $a822f4bd5dc880f9$var$waitForAnimation(elem, ()=>{
                elem.classList.remove(className);
                elem.removeAttribute('style');
                resolve();
            });
        } else {
            elem.classList.remove(className);
            resolve();
        }
    });
}
const $a822f4bd5dc880f9$var$MAX_REDIRECT_COUNT = 256;
function $a822f4bd5dc880f9$var$isResultNotEmpty(result) {
    return result !== null && result !== undefined;
}
function $a822f4bd5dc880f9$var$copyContextWithoutNext(context) {
    const copy = Object.assign({}, context);
    delete copy.next;
    return copy;
}
function $a822f4bd5dc880f9$var$getPathnameForRouter(pathname, router) {
    const base = router.__getEffectiveBaseUrl();
    return base ? router.constructor.__createUrl(pathname.replace(/^\//, ''), base).pathname : pathname;
}
function $a822f4bd5dc880f9$var$getMatchedPath(chain) {
    return chain.map((item)=>{
        const path = item.path || item.path || '';
        return Array.isArray(path) ? path[0] : path;
    }).reduce((a, b)=>{
        if (b.length) return a.replace(/\/$/, '') + '/' + b.replace(/^\//, '');
        return a;
    }, '');
}
function $a822f4bd5dc880f9$var$createLocation({ pathname: pathname = '', search: search = '', hash: hash = '', chain: chain = [], params: params = {}, redirectFrom: redirectFrom, resolver: resolver }, route) {
    const routes = chain.map((item)=>item.route);
    return {
        baseUrl: resolver && resolver.baseUrl || '',
        pathname: pathname,
        search: search,
        hash: hash,
        routes: routes,
        route: route || routes.length && routes[routes.length - 1] || null,
        params: params,
        redirectFrom: redirectFrom,
        getUrl: (userParams = {})=>$a822f4bd5dc880f9$var$getPathnameForRouter((0, $6x2ae.compile)($a822f4bd5dc880f9$var$getMatchedPath(routes))(Object.assign({}, params, userParams)), resolver)
    };
}
function $a822f4bd5dc880f9$var$createRedirect(context, pathname) {
    const params = Object.assign({}, context.params);
    return {
        redirect: {
            pathname: pathname,
            from: context.pathname,
            params: params
        }
    };
}
function $a822f4bd5dc880f9$var$renderElement(context, element) {
    element.location = $a822f4bd5dc880f9$var$createLocation(context);
    const index = context.chain.map((item)=>item.route).indexOf(context.route);
    context.chain[index].element = element;
    return element;
}
function $a822f4bd5dc880f9$var$amend(amendmentFunction, args, element) {
    return (amendmentResult)=>{
        if (amendmentResult && (amendmentResult.cancel || amendmentResult.redirect)) return amendmentResult;
        if (element) return (0, $b2BJp.runCallbackIfPossible)(element[amendmentFunction], args, element);
        return undefined;
    };
}
function $a822f4bd5dc880f9$var$processNewChildren(newChildren, route) {
    if (!Array.isArray(newChildren) && !(0, $b2BJp.isObject)(newChildren)) throw new Error((0, $b2BJp.log)(`Incorrect "children" value for the route ${route.path}: expected array or object, but got ${newChildren}`));
    route.__children = [];
    const childRoutes = (0, $b2BJp.toArray)(newChildren);
    for(let i = 0; i < childRoutes.length; i++){
        (0, $b2BJp.ensureRoute)(childRoutes[i]);
        route.__children.push(childRoutes[i]);
    }
}
function $a822f4bd5dc880f9$var$removeDomNodes(nodes) {
    if (nodes && nodes.length) {
        const parent = nodes[0].parentNode;
        for(let i = 0; i < nodes.length; i++)parent.removeChild(nodes[i]);
    }
}
/**
 * A simple client-side router for single-page applications. It uses
 * express-style middleware and has a first-class support for Web Components and
 * lazy-loading. Works great in Polymer and non-Polymer apps.
 *
 * Use `new Router(outlet, options)` to create a new Router instance.
 *
 * * The `outlet` parameter is a reference to the DOM node to render
 *   the content into.
 *
 * * The `options` parameter is an optional object with options. The following
 *   keys are supported:
 *   * `baseUrl` — the initial value for [
 *     the `baseUrl` property
 *   ](#/classes/Router#property-baseUrl)
 *
 * The Router instance is automatically subscribed to navigation events
 * on `window`.
 *
 * See [Live Examples](#/classes/Router/demos/demo/index.html) for the detailed usage demo and code snippets.
 *
 * See also detailed API docs for the following methods, for the advanced usage:
 *
 * * [setOutlet](#/classes/Router#method-setOutlet) – should be used to configure the outlet.
 * * [setTriggers](#/classes/Router#method-setTriggers) – should be used to configure the navigation events.
 * * [setRoutes](#/classes/Router#method-setRoutes) – should be used to configure the routes.
 *
 * Only `setRoutes` has to be called manually, others are automatically invoked when creating a new instance.
 *
 * @extends Resolver
 * @demo demo/index.html
 * @summary JavaScript class that renders different DOM content depending on
 *    a given path. It can re-render when triggered or automatically on
 *    'popstate' and / or 'click' events.
 */ class $a822f4bd5dc880f9$var$Router extends $gSKBQ.Resolver {
    /**
     * Creates a new Router instance with a given outlet, and
     * automatically subscribes it to navigation events on the `window`.
     * Using a constructor argument or a setter for outlet is equivalent:
     *
     * ```
     * const router = new Router();
     * router.setOutlet(outlet);
     * ```
     * @param outlet
     * @param options
     */ constructor(outlet, options){
        const baseElement = document.head.querySelector('base');
        const baseHref = baseElement && baseElement.getAttribute('href');
        super([], Object.assign({
            baseUrl: baseHref && $gSKBQ.Resolver.__createUrl(baseHref, document.URL).pathname.replace(/[^\/]*$/, '')
        }, options));
        this.resolveRoute = (context)=>this.__resolveRoute(context);
        (0, $fiXcB.setNavigationTriggers)([
            $fiXcB.POPSTATE,
            $fiXcB.CLICK
        ]);
        this.ready = Promise.resolve(outlet);
        this.location = $a822f4bd5dc880f9$var$createLocation({
            resolver: this
        });
        this.__lastStartedRenderId = 0;
        this.__navigationEventHandler = this.__onNavigationEvent.bind(this);
        this.setOutlet(outlet);
        this.subscribe();
        this.__createdByRouter = new WeakMap();
        this.__addedByRouter = new WeakMap();
    }
    __resolveRoute(context) {
        const route = context.route;
        let callbacks = Promise.resolve();
        if ((0, $b2BJp.isFunction)(route.children)) callbacks = callbacks.then(()=>route.children($a822f4bd5dc880f9$var$copyContextWithoutNext(context))).then((children)=>{
            if (!$a822f4bd5dc880f9$var$isResultNotEmpty(children) && !(0, $b2BJp.isFunction)(route.children)) children = route.children;
            $a822f4bd5dc880f9$var$processNewChildren(children, route);
        });
        const commands = {
            redirect: (path)=>$a822f4bd5dc880f9$var$createRedirect(context, path),
            component: (component)=>{
                const element = document.createElement(component);
                this.__createdByRouter.set(element, true);
                return element;
            }
        };
        return callbacks.then(()=>{
            if (this.__isLatestRender(context)) return (0, $b2BJp.runCallbackIfPossible)(route.action, [
                context,
                commands
            ], route);
            return undefined;
        }).then((result)=>{
            if ($a822f4bd5dc880f9$var$isResultNotEmpty(result)) {
                if (result instanceof HTMLElement || result.redirect || result === $ifulk.notFoundResult) return result;
            }
            if ((0, $b2BJp.isString)(route.redirect)) return commands.redirect(route.redirect);
            if (route.bundle) return (0, $b2BJp.loadBundle)(route.bundle).then(()=>undefined, ()=>{
                throw new Error((0, $b2BJp.log)(`Bundle not found: ${route.bundle}. Check if the file name is correct`));
            });
            return undefined;
        }).then((result)=>{
            if ($a822f4bd5dc880f9$var$isResultNotEmpty(result)) return result;
            if ((0, $b2BJp.isString)(route.component)) return commands.component(route.component);
            return undefined;
        });
    }
    /**
     * Takes current routes and set it
     * @param routes: Route<C>[]
     * @returns void
     */ /**
     * Sets the router outlet (the DOM node where the content for the current
     * route is inserted). Any content pre-existing in the router outlet is
     * removed at the end of each render pass.
     *
     * NOTE: this method is automatically invoked first time when creating a new Router instance.
     *
     * @param outlet the DOM node where the content for the current route
     *     is inserted.
     */ setOutlet(outlet) {
        if (outlet) this.__ensureOutlet(outlet);
        this.__outlet = outlet;
    }
    /**
     * Returns the current router outlet. The initial value is undefined.
     */ /**
     * Returns the current router outlet. The initial value is undefined.
     *
     * @return the current router outlet (or `undefined`)
     */ getOutlet() {
        return this.__outlet;
    }
    /**
     * Takes current routes and set it
     * @param routes: Route | Route[]
     * @returns Route | Route[]
     */ /**
     * Sets the routing config (replacing the existing one) and triggers a
     * navigation event so that the router outlet is refreshed according to the
     * current `window.location` and the new routing config.
     *
     * Each route object may have the following properties, listed here in the processing order:
     * * `path` – the route path (relative to the parent route if any) in the
     * [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
     *
     * * `children` – an array of nested routes or a function that provides this
     * array at the render time. The function can be synchronous or asynchronous:
     * in the latter case the render is delayed until the returned promise is
     * resolved. The `children` function is executed every time when this route is
     * being rendered. This allows for dynamic route structures (e.g. backend-defined),
     * but it might have a performance impact as well. In order to avoid calling
     * the function on subsequent renders, you can override the `children` property
     * of the route object and save the calculated array there
     * (via `context.route.children = [ route1, route2, ...];`).
     * Parent routes are fully resolved before resolving the children. Children
     * 'path' values are relative to the parent ones.
     *
     * * `action` – the action that is executed before the route is resolved.
     * The value for this property should be a function, accepting `context`
     * and `commands` parameters described below. If present, this function is
     * always invoked first, disregarding of the other properties' presence.
     * The action can return a result directly or within a `Promise`, which
     * resolves to the result. If the action result is an `HTMLElement` instance,
     * a `commands.component(name)` result, a `commands.redirect(path)` result,
     * or a `context.next()` result, the current route resolution is finished,
     * and other route config properties are ignored.
     * See also **Route Actions** section in [Live Examples](#/classes/Router/demos/demo/index.html).
     *
     * * `redirect` – other route's path to redirect to. Passes all route parameters to the redirect target.
     * The target route should also be defined.
     * See also **Redirects** section in [Live Examples](#/classes/Router/demos/demo/index.html).
     *
     * * `bundle` – string containing the path to `.js` or `.mjs` bundle to load before resolving the route,
     * or the object with "module" and "nomodule" keys referring to different bundles.
     * Each bundle is only loaded once. If "module" and "nomodule" are set, only one bundle is loaded,
     * depending on whether the browser supports ES modules or not.
     * The property is ignored when either an `action` returns the result or `redirect` property is present.
     * Any error, e.g. 404 while loading bundle will cause route resolution to throw.
     * See also **Code Splitting** section in [Live Examples](#/classes/Router/demos/demo/index.html).
     *
     * * `component` – the tag name of the Web Component to resolve the route to.
     * The property is ignored when either an `action` returns the result or `redirect` property is present.
     * If route contains the `component` property (or an action that return a component)
     * and its child route also contains the `component` property, child route's component
     * will be rendered as a light dom child of a parent component.
     *
     * * `name` – the string name of the route to use in the
     * [`router.urlForName(name, params)`](#/classes/Router#method-urlForName)
     * navigation helper method.
     *
     * For any route function (`action`, `children`) defined, the corresponding `route` object is available inside the callback
     * through the `this` reference. If you need to access it, make sure you define the callback as a non-arrow function
     * because arrow functions do not have their own `this` reference.
     *
     * `context` object that is passed to `action` function holds the following properties:
     * * `context.pathname` – string with the pathname being resolved
     *
     * * `context.search` – search query string
     *
     * * `context.hash` – hash string
     *
     * * `context.params` – object with route parameters
     *
     * * `context.route` – object that holds the route that is currently being rendered.
     *
     * * `context.next()` – function for asynchronously getting the next route
     * contents from the resolution chain (if any)
     *
     * `commands` object that is passed to `action` function has
     * the following methods:
     *
     * * `commands.redirect(path)` – function that creates a redirect data
     * for the path specified.
     *
     * * `commands.component(component)` – function that creates a new HTMLElement
     * with current context. Note: the component created by this function is reused if visiting the same path twice in row.
     *
     *
     * @param routes a single route or an array of those
     * @param skipRender configure the router but skip rendering the
     *     route corresponding to the current `window.location` values
     *
     * @return
     */ setRoutes(routes, skipRender = false) {
        this.__previousContext = undefined;
        this.__urlForName = undefined;
        super.setRoutes(routes);
        if (!skipRender) this.__onNavigationEvent();
        return this.ready;
    }
    /**
     * Asynchronously resolves the given pathname and renders the resolved route component into the router outlet. If no router outlet is set at the time of calling this method, or at the time when the route resolution is completed, a TypeError is thrown.
     * Returns a promise that is fulfilled with the router outlet DOM Node after the route component is created and inserted into the router outlet, or rejected if no route matches the given path.
     * If another render pass is started before the previous one is completed, the result of the previous render pass is ignored.
     * @param pathnameOrContext — the pathname to render or a context object with a pathname property and other properties to pass to the resolver.
     * @param shouldUpdateHistory
     */ /**
     * Asynchronously resolves the given pathname and renders the resolved route
     * component into the router outlet. If no router outlet is set at the time of
     * calling this method, or at the time when the route resolution is completed,
     * a `TypeError` is thrown.
     *
     * Returns a promise that is fulfilled with the router outlet DOM Node after
     * the route component is created and inserted into the router outlet, or
     * rejected if no route matches the given path.
     *
     * If another render pass is started before the previous one is completed, the
     * result of the previous render pass is ignored.
     *
     * @param pathnameOrContext
     *    the pathname to render or a context object with a `pathname` property,
     *    optional `search` and `hash` properties, and other properties
     *    to pass to the resolver.
     * @param shouldUpdateHistory
     *    update browser history with the rendered location
     * @return
     */ render(pathnameOrContext, shouldUpdateHistory) {
        const renderId = ++this.__lastStartedRenderId;
        const context = Object.assign({
            search: '',
            hash: ''
        }, (0, $b2BJp.isString)(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext, {
            __renderId: renderId
        });
        this.ready = this.resolve(context).then((context)=>this.__fullyResolveChain(context)).then((context)=>{
            if (this.__isLatestRender(context)) {
                const previousContext = this.__previousContext;
                if (context === previousContext) {
                    this.__updateBrowserHistory(previousContext, true);
                    return this.location;
                }
                this.location = $a822f4bd5dc880f9$var$createLocation(context);
                if (shouldUpdateHistory) this.__updateBrowserHistory(context, renderId === 1);
                (0, $b2BJp.fireRouterEvent)('location-changed', {
                    location: this.location
                });
                if (context.__skipAttach) {
                    this.__copyUnchangedElements(context, previousContext);
                    this.__previousContext = context;
                    return this.location;
                }
                this.__addAppearingContent(context, previousContext);
                const animationDone = this.__animateIfNeeded(context);
                this.__runOnAfterEnterCallbacks(context);
                this.__runOnAfterLeaveCallbacks(context, previousContext);
                return animationDone.then(()=>{
                    if (this.__isLatestRender(context)) {
                        this.__removeDisappearingContent();
                        this.__previousContext = context;
                        return this.location;
                    }
                    return undefined;
                });
            }
            return undefined;
        }).catch((error)=>{
            if (renderId === this.__lastStartedRenderId) {
                if (shouldUpdateHistory) this.__updateBrowserHistory(context);
                $a822f4bd5dc880f9$var$removeDomNodes(this.__outlet && this.__outlet.children);
                this.location = $a822f4bd5dc880f9$var$createLocation(Object.assign(context, {
                    resolver: this
                }));
                (0, $b2BJp.fireRouterEvent)('error', Object.assign({
                    router: this,
                    error: error
                }, context));
                throw error;
            }
            return undefined;
        });
        return this.ready;
    }
    __fullyResolveChain(topOfTheChainContextBeforeRedirects, contextBeforeRedirects = topOfTheChainContextBeforeRedirects) {
        return this.__findComponentContextAfterAllRedirects(contextBeforeRedirects).then((contextAfterRedirects)=>{
            const redirectsHappened = contextAfterRedirects !== contextBeforeRedirects;
            const topOfTheChainContextAfterRedirects = redirectsHappened ? contextAfterRedirects : topOfTheChainContextBeforeRedirects;
            const matchedPath = $a822f4bd5dc880f9$var$getPathnameForRouter($a822f4bd5dc880f9$var$getMatchedPath(contextAfterRedirects.chain), contextAfterRedirects.resolver);
            const isFound = matchedPath === contextAfterRedirects.pathname;
            const findNextContextIfAny = (context, parent = context.route, prevResult)=>{
                return context.next(undefined, parent, prevResult).then((nextContext)=>{
                    if (nextContext === null || nextContext === $ifulk.notFoundResult) {
                        if (isFound) return context;
                        else if (parent.parent !== null) return findNextContextIfAny(context, parent.parent, nextContext);
                        else return nextContext;
                    }
                    return nextContext;
                });
            };
            return findNextContextIfAny(contextAfterRedirects).then((nextContext)=>{
                if (nextContext === null || nextContext === $ifulk.notFoundResult) throw (0, $b2BJp.getNotFoundError)(topOfTheChainContextAfterRedirects);
                return nextContext && nextContext !== $ifulk.notFoundResult && nextContext !== contextAfterRedirects ? this.__fullyResolveChain(topOfTheChainContextAfterRedirects, nextContext) : this.__amendWithOnBeforeCallbacks(contextAfterRedirects);
            });
        });
    }
    __findComponentContextAfterAllRedirects(context) {
        const result = context.result;
        if (result instanceof HTMLElement) {
            $a822f4bd5dc880f9$var$renderElement(context, result);
            return Promise.resolve(context);
        } else if (result && result.redirect) return this.__redirect(result.redirect, context.__redirectCount, context.__renderId).then((context)=>this.__findComponentContextAfterAllRedirects(context));
        else if (result instanceof Error) return Promise.reject(result);
        else return Promise.reject(new Error((0, $b2BJp.log)(`Invalid route resolution result for path "${context.pathname}". ` + `Expected redirect object or HTML element, but got: "${(0, $b2BJp.logValue)(result)}". ` + `Double check the action return value for the route.`)));
    }
    __amendWithOnBeforeCallbacks(contextWithFullChain) {
        return this.__runOnBeforeCallbacks(contextWithFullChain).then((amendedContext)=>{
            if (amendedContext === this.__previousContext || amendedContext === contextWithFullChain) return amendedContext;
            return this.__fullyResolveChain(amendedContext);
        });
    }
    __runOnBeforeCallbacks(newContext) {
        const previousContext = this.__previousContext || {};
        const previousChain = previousContext.chain || [];
        const newChain = newContext.chain;
        let callbacks = Promise.resolve();
        const prevent = ()=>({
                cancel: true
            });
        const redirect = (pathname)=>$a822f4bd5dc880f9$var$createRedirect(newContext, pathname);
        newContext.__divergedChainIndex = 0;
        newContext.__skipAttach = false;
        if (previousChain.length) {
            for(let i = 0; i < Math.min(previousChain.length, newChain.length); i = ++newContext.__divergedChainIndex){
                if (previousChain[i].route !== newChain[i].route || previousChain[i].path !== newChain[i].path && previousChain[i].element !== newChain[i].element || !this.__isReusableElement(previousChain[i].element, newChain[i].element)) break;
            }
            newContext.__skipAttach = newChain.length === previousChain.length && newContext.__divergedChainIndex == newChain.length && this.__isReusableElement(newContext.result, previousContext.result);
            if (newContext.__skipAttach) {
                for(let i = newChain.length - 1; i >= 0; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                    prevent: prevent
                }, previousChain[i]);
                for(let i = 0; i < newChain.length; i++){
                    callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                        prevent: prevent,
                        redirect: redirect
                    }, newChain[i]);
                    previousChain[i].element.location = $a822f4bd5dc880f9$var$createLocation(newContext, previousChain[i].route);
                }
            } else for(let i = previousChain.length - 1; i >= newContext.__divergedChainIndex; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                prevent: prevent
            }, previousChain[i]);
        }
        if (!newContext.__skipAttach) for(let i = 0; i < newChain.length; i++){
            if (i < newContext.__divergedChainIndex) {
                if (i < previousChain.length && previousChain[i].element) previousChain[i].element.location = $a822f4bd5dc880f9$var$createLocation(newContext, previousChain[i].route);
            } else {
                callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                    prevent: prevent,
                    redirect: redirect
                }, newChain[i]);
                if (newChain[i].element) newChain[i].element.location = $a822f4bd5dc880f9$var$createLocation(newContext, newChain[i].route);
            }
        }
        return callbacks.then((amendmentResult)=>{
            if (amendmentResult) {
                if (amendmentResult.cancel) {
                    this.__previousContext.__renderId = newContext.__renderId;
                    return this.__previousContext;
                }
                if (amendmentResult.redirect) return this.__redirect(amendmentResult.redirect, newContext.__redirectCount, newContext.__renderId);
            }
            return newContext;
        });
    }
    __runOnBeforeLeaveCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $a822f4bd5dc880f9$var$createLocation(newContext);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const afterLeaveFunction = $a822f4bd5dc880f9$var$amend('onBeforeLeave', [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return afterLeaveFunction(result);
            }
            return undefined;
        }).then((result)=>{
            if (!(result || {}).redirect) return result;
            return undefined;
        });
    }
    __runOnBeforeEnterCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $a822f4bd5dc880f9$var$createLocation(newContext, chainElement.route);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const beforeEnterFunction = $a822f4bd5dc880f9$var$amend('onBeforeEnter', [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return beforeEnterFunction(result);
            }
            return undefined;
        });
    }
    __isReusableElement(element, otherElement) {
        if (element && otherElement) return this.__createdByRouter.get(element) && this.__createdByRouter.get(otherElement) ? element.localName === otherElement.localName : element === otherElement;
        return false;
    }
    __isLatestRender(context) {
        return context.__renderId === this.__lastStartedRenderId;
    }
    __redirect(redirectData, counter, renderId) {
        if ((counter || 0) > $a822f4bd5dc880f9$var$MAX_REDIRECT_COUNT) throw new Error((0, $b2BJp.log)(`Too many redirects when rendering ${redirectData.from}`));
        return this.resolve({
            pathname: this.urlForPath(redirectData.pathname, redirectData.params),
            redirectFrom: redirectData.from,
            __redirectCount: (counter || 0) + 1,
            __renderId: renderId
        });
    }
    __ensureOutlet(outlet = this.__outlet) {
        if (!(outlet instanceof Node)) throw new TypeError((0, $b2BJp.log)(`Expected router outlet to be a valid DOM Node (but got ${outlet})`));
    }
    __updateBrowserHistory({ pathname: pathname, search: search = '', hash: hash = '' }, replace) {
        if (window.location.pathname !== pathname || window.location.search !== search || window.location.hash !== hash) {
            const changeState = replace ? 'replaceState' : 'pushState';
            window.history[changeState](null, document.title, pathname + search + hash);
            window.dispatchEvent(new PopStateEvent('popstate', {
                state: 'router-ignore'
            }));
        }
    }
    __copyUnchangedElements(context, previousContext) {
        let deepestCommonParent = this.__outlet;
        for(let i = 0; i < context.__divergedChainIndex; i++){
            const unchangedElement = previousContext && previousContext.chain[i].element;
            if (unchangedElement) {
                if (unchangedElement.parentNode === deepestCommonParent) {
                    context.chain[i].element = unchangedElement;
                    deepestCommonParent = unchangedElement;
                } else break;
            }
        }
        return deepestCommonParent;
    }
    __addAppearingContent(context, previousContext) {
        this.__ensureOutlet();
        this.__removeAppearingContent();
        const deepestCommonParent = this.__copyUnchangedElements(context, previousContext);
        this.__appearingContent = [];
        this.__disappearingContent = Array.from(deepestCommonParent.children).filter((e)=>this.__addedByRouter.get(e) && e !== context.result);
        let parentElement = deepestCommonParent;
        for(let i = context.__divergedChainIndex; i < context.chain.length; i++){
            const elementToAdd = context.chain[i].element;
            if (elementToAdd) {
                parentElement.appendChild(elementToAdd);
                this.__addedByRouter.set(elementToAdd, true);
                if (parentElement === deepestCommonParent) this.__appearingContent.push(elementToAdd);
                parentElement = elementToAdd;
            }
        }
    }
    __removeDisappearingContent() {
        if (this.__disappearingContent) $a822f4bd5dc880f9$var$removeDomNodes(this.__disappearingContent);
        this.__disappearingContent = null;
        this.__appearingContent = null;
    }
    __removeAppearingContent() {
        if (this.__disappearingContent && this.__appearingContent) {
            $a822f4bd5dc880f9$var$removeDomNodes(this.__appearingContent);
            this.__disappearingContent = null;
            this.__appearingContent = null;
        }
    }
    __runOnAfterLeaveCallbacks(currentContext, targetContext) {
        if (!targetContext) return;
        for(let i = targetContext.chain.length - 1; i >= currentContext.__divergedChainIndex; i--){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = targetContext.chain[i].element;
            if (!currentComponent) continue;
            try {
                const location = $a822f4bd5dc880f9$var$createLocation(currentContext);
                (0, $b2BJp.runCallbackIfPossible)(currentComponent.onAfterLeave, [
                    location,
                    {},
                    targetContext.resolver
                ], currentComponent);
            } finally{
                if (this.__disappearingContent.indexOf(currentComponent) > -1) $a822f4bd5dc880f9$var$removeDomNodes(currentComponent.children);
            }
        }
    }
    __runOnAfterEnterCallbacks(currentContext) {
        for(let i = currentContext.__divergedChainIndex; i < currentContext.chain.length; i++){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = currentContext.chain[i].element || {};
            const location = $a822f4bd5dc880f9$var$createLocation(currentContext, currentContext.chain[i].route);
            (0, $b2BJp.runCallbackIfPossible)(currentComponent.onAfterEnter, [
                location,
                {},
                currentContext.resolver
            ], currentComponent);
        }
    }
    __animateIfNeeded(context) {
        const from = (this.__disappearingContent || [])[0];
        const to = (this.__appearingContent || [])[0];
        const promises = [];
        const chain = context.chain;
        let config;
        for(let i = chain.length; i > 0; i--)if (chain[i - 1].route.animate) {
            config = chain[i - 1].route.animate;
            break;
        }
        if (from && to && config) {
            const leave = (0, $b2BJp.isObject)(config) && config.leave || 'leaving';
            const enter = (0, $b2BJp.isObject)(config) && config.enter || 'entering';
            promises.push($a822f4bd5dc880f9$var$animate(from, leave));
            promises.push($a822f4bd5dc880f9$var$animate(to, enter));
        }
        return Promise.all(promises).then(()=>context);
    }
    /**
     * Subscribes this instance to navigation events on the `window`.
     *
     * NOTE: beware of resource leaks. For as long as a router instance is
     * subscribed to navigation events, it won't be garbage collected.
     */ subscribe() {
        window.addEventListener('router-go', this.__navigationEventHandler);
    }
    /**
     * Removes the subscription to navigation events created in the `subscribe()`
     * method.
     */ unsubscribe() {
        window.removeEventListener('router-go', this.__navigationEventHandler);
    }
    __onNavigationEvent(event) {
        const { pathname: pathname, search: search, hash: hash } = event ? event.detail : window.location;
        if ((0, $b2BJp.isString)(this.__normalizePathname(pathname))) {
            if (event && event.preventDefault) event.preventDefault();
            this.render({
                pathname: pathname,
                search: search,
                hash: hash
            }, true);
        }
    }
    /**
     * Generates a URL for the route with the given name, optionally performing
     * substitution of parameters.
     *
     * The route is searched in all the Router instances subscribed to
     * navigation events.
     *
     * **Note:** For child route names, only array children are considered.
     * It is not possible to generate URLs using a name for routes set with
     * a children function.
     *
     * @param name the route name or the route’s `component` name.
     * @param params Optional object with route path parameters.
     * Named parameters are passed by name (`params[name] = value`), unnamed
     * parameters are passed by index (`params[index] = value`).
     *
     * @return
     */ urlForName(name, params) {
        if (!this.__urlForName) this.__urlForName = (0, $gSKBQ.generateUrls)(this);
        return $a822f4bd5dc880f9$var$getPathnameForRouter(this.__urlForName(name, params), this);
    }
    /**
     * Generates a URL for the given route path, optionally performing
     * substitution of parameters.
     *
     * @param path string route path declared in [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
     * @param params Optional object with route path parameters.
     * Named parameters are passed by name (`params[name] = value`), unnamed
     * parameters are passed by index (`params[index] = value`).
     *
     * @return
     */ urlForPath(path, params) {
        return $a822f4bd5dc880f9$var$getPathnameForRouter((0, $6x2ae.compile)(path)(params), this);
    }
    /**
     * Triggers navigation to a new path. Returns a boolean without waiting until
     * the navigation is complete. Returns `true` if at least one `Router`
     * has handled the navigation (was subscribed and had `baseUrl` matching
     * the `path` argument), otherwise returns `false`.
     *
     * @param path
     *   a new in-app path string, or an URL-like object with `pathname`
     *   string property, and optional `search` and `hash` string properties.
     * @return
     */ static go(path) {
        const { pathname: pathname, search: search, hash: hash } = (0, $b2BJp.isString)(path) ? this.__createUrl(path, 'http://a') : path;
        return (0, $b2BJp.fireRouterEvent)('go', {
            pathname: pathname,
            search: search || '',
            hash: hash || ''
        });
    }
}
module.exports.Router = $a822f4bd5dc880f9$var$Router;

});
parcelRegister("fiXcB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.POPSTATE = module.exports.CLICK = void 0;
module.exports.RouterGlobalClickHandler = $b24675c9374816c5$var$RouterGlobalClickHandler;
module.exports.RouterGlobalPopstateHandler = $b24675c9374816c5$var$RouterGlobalPopstateHandler;
module.exports.setNavigationTriggers = $b24675c9374816c5$var$setNavigationTriggers;

var $b2BJp = parcelRequire("b2BJp");
// IE Polyfill for PopStateEvent
const $b24675c9374816c5$var$isIE = /Trident/.test(navigator.userAgent);
if ($b24675c9374816c5$var$isIE && !(0, $b2BJp.isFunction)(window.PopStateEvent)) {
    window.PopStateEvent = function(inType, params) {
        params = params || {};
        const e = document.createEvent('Event');
        e.initEvent(inType, Boolean(params.bubbles), Boolean(params.cancelable));
        e.state = params.state || null;
        return e;
    };
    window.PopStateEvent.prototype = window.Event.prototype;
}
function $b24675c9374816c5$var$RouterGlobalClickHandler(event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) return;
    let anchor = event.target;
    const path = event.composedPath ? event.composedPath() : event.path || [];
    for(let i = 0; i < path.length; i++){
        const target = path[i];
        if (target.nodeName && target.nodeName.toLowerCase() === 'a') {
            anchor = target;
            break;
        }
    }
    while(anchor && anchor.nodeName && anchor.nodeName.toLowerCase() !== 'a')anchor = anchor.parentNode;
    if (!anchor || anchor.nodeName.toLowerCase() !== 'a') return;
    const anchorElement = anchor;
    if (anchorElement.target && anchorElement.target.toLowerCase() !== '_self') return;
    if (anchorElement.hasAttribute('download')) return;
    if (anchorElement.hasAttribute('router-ignore')) return;
    if (anchorElement.pathname === window.location.pathname && anchorElement.hash !== '') return;
    const origin = anchorElement.origin || (0, $b2BJp.getAnchorOrigin)(anchorElement);
    if (origin !== window.location.origin) return;
    const { pathname: pathname, search: search, hash: hash } = anchorElement;
    if ((0, $b2BJp.fireRouterEvent)('go', {
        pathname: pathname,
        search: search,
        hash: hash
    })) event.preventDefault();
}
module.exports.CLICK = {
    activate () {
        window.document.addEventListener('click', $b24675c9374816c5$var$RouterGlobalClickHandler);
    },
    inactivate () {
        window.document.removeEventListener('click', $b24675c9374816c5$var$RouterGlobalClickHandler);
    }
};
function $b24675c9374816c5$var$RouterGlobalPopstateHandler(event) {
    if (event.state === 'router-ignore') return;
    const { pathname: pathname, search: search, hash: hash } = window.location;
    (0, $b2BJp.fireRouterEvent)('go', {
        pathname: pathname,
        search: search,
        hash: hash
    });
}
module.exports.POPSTATE = {
    activate () {
        window.addEventListener('popstate', $b24675c9374816c5$var$RouterGlobalPopstateHandler);
    },
    inactivate () {
        window.removeEventListener('popstate', $b24675c9374816c5$var$RouterGlobalPopstateHandler);
    }
};
let $b24675c9374816c5$var$triggers = [];
function $b24675c9374816c5$var$setNavigationTriggers(newTriggers) {
    $b24675c9374816c5$var$triggers.forEach((trigger)=>trigger.inactivate());
    newTriggers.forEach((trigger)=>trigger.activate());
    $b24675c9374816c5$var$triggers = newTriggers;
}

});





parcelRegister("cKnQX", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouteParams = $947c48ac6fb6c233$var$RouteParams;
/**
 * Define getter to `this.location.params` from component `this` and assign params to decorated property
 *
 * @param target: LitElement | HTMLElement
 * @returns this.location.params as getter (lazy evaluated)
 * Usage:
 *
 *
```
{path: '/profile/:name', component: 'x-user-profile'},

import { customElement, LitElement } from '@rxdi/lit-html';

@customElement('x-user-profile')
export class UserProfile extends LitElement {

  @RouteParams()
  params: { name: string }

  render() {
    return html`${this.params.name}`;
  }
}
```
   */ function $947c48ac6fb6c233$var$RouteParams() {
    return function(target, propertyKey) {
        Object.defineProperty(target, propertyKey, {
            get: function() {
                return this.location.params;
            }
        });
    };
}

});

parcelRegister("gEqmA", function(module, exports) {
"use strict";
var $c1f4d4fa8659d26b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotFoundPathConfig = module.exports.NotFoundComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
let $c1f4d4fa8659d26b$var$NotFoundComponent = class NotFoundComponent extends $4TeKW.LitElement {
};
module.exports.NotFoundComponent = $c1f4d4fa8659d26b$var$NotFoundComponent;
module.exports.NotFoundComponent = $c1f4d4fa8659d26b$var$NotFoundComponent = $c1f4d4fa8659d26b$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'not-found-component-rxdi',
        template: ()=>(0, $4TeKW.html)`
    <h1>Not found component!</h1>
    <p>Please check your URL.2222daad</p>
  `
    })
], $c1f4d4fa8659d26b$var$NotFoundComponent);
module.exports.NotFoundPathConfig = {
    path: '(.*)',
    component: 'not-found-component-rxdi'
};

});


parcelRegister("ihXbv", function(module, exports) {
"use strict";
var $d507b95d3894772d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d507b95d3894772d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d507b95d3894772d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d507b95d3894772d$var$__createBinding(exports1, m, p);
};
var $d507b95d3894772d$var$ModalModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalModule = void 0;

var $1t8Wn = parcelRequire("1t8Wn");


var $g9f1C = parcelRequire("g9f1C");

var $20e62 = parcelRequire("20e62");

var $c9mBx = parcelRequire("c9mBx");
let $d507b95d3894772d$var$ModalModule = $d507b95d3894772d$var$ModalModule_1 = class ModalModule {
    static forRoot(options = {}) {
        if (!options.style) options.style = $c9mBx.defaultModalStyle;
        return {
            module: $d507b95d3894772d$var$ModalModule_1,
            providers: [
                (parcelRequire("3sOsN")).ModalService,
                {
                    provide: $20e62.MODAL_DIALOG_OPTIONS,
                    useValue: options
                }
            ],
            components: [
                $g9f1C.ModalContainerComponent
            ]
        };
    }
};
$d507b95d3894772d$var$ModalModule = $d507b95d3894772d$var$ModalModule_1 = $d507b95d3894772d$var$__decorate([
    (0, $1t8Wn.Module)()
], $d507b95d3894772d$var$ModalModule);
module.exports.ModalModule = $d507b95d3894772d$var$ModalModule;

$d507b95d3894772d$var$__exportStar((parcelRequire("3sOsN")), module.exports);

});
parcelRegister("3sOsN", function(module, exports) {
"use strict";
var $285b21979986ef06$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $285b21979986ef06$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalService = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $8id0M = parcelRequire("8id0M");
var $g5fNy = parcelRequire("g5fNy");
var $h7YIO = parcelRequire("h7YIO");
var $f16OP = parcelRequire("f16OP");

var $20e62 = parcelRequire("20e62");

var $jMd8a = parcelRequire("jMd8a");
var $gawXH = parcelRequire("gawXH");
var $d5Aat = parcelRequire("d5Aat");
var $3dOhR = parcelRequire("3dOhR");

var $jVrCY = parcelRequire("jVrCY");
let $285b21979986ef06$var$ModalService = class ModalService {
    constructor(){
        this.modalTemplate = new $h7YIO.ReplaySubject();
        this.closeSubject$ = new $f16OP.Subject();
        this.$onScroll = new $f16OP.Subject();
        this.originalOptions = Object.assign({}, this.options);
    }
    setScrollWidth(value) {
        this.$onScroll.next(value);
    }
    setContainerRef(element) {
        this.containerRef = element;
    }
    getContainerRef() {
        return this.containerRef;
    }
    scrollTo(value) {
        this.containerRef.scrollTo(0, value);
    }
    onScroll() {
        return this.$onScroll.asObservable();
    }
    open(template, dialogOptions) {
        this.overflow('hidden');
        return new $8id0M.Observable((observer)=>{
            this.createModalPortal();
            if (dialogOptions) this.setSettings(dialogOptions);
            this.closeSubject$.pipe((0, $d5Aat.take)(1)).subscribe((stream)=>{
                if (dialogOptions) this.setSettings(this.originalOptions);
                this.overflow('visible');
                observer.next(stream);
                observer.complete();
            });
            this.modalTemplate.next(template);
        });
    }
    openCustomModal(data, settings = {
        backdropClose: true
    }) {
        this.overflow('hidden');
        return this.openComponent($jVrCY.MainModalComponent, data, {
            backdropClose: settings.backdropClose,
            style: settings.style || (0, $4TeKW.css)`
          .wrapper {
            position: fixed;
            top: 0;
            left: 0;
            align-items: center;
            justify-content: center;
            pointer-events: none;
            width: 100%;
            height: 100%;
            z-index: 200;
          }
          .content {
            width: 100%;
            height: 100%;
            z-index: 201;
            position: fixed;
            pointer-events: all;
          }
        `
        }).pipe((0, $3dOhR.tap)(()=>this.overflow('visible')));
    }
    overflow(type) {
        if (this.options.hideScroll) document.body.style.overflow = type;
    }
    openComponent(component, options = {}, dialogOptions) {
        if (dialogOptions) this.setSettings(dialogOptions);
        this.overflow('hidden');
        return new $8id0M.Observable((observer)=>{
            const tag = component.is;
            if (!tag) throw new Error('Provide static method `is` inside component or if you use regular html`` template use `open` method instead of `openComponent`');
            this.createModalPortal();
            $1t8Wn.Container.remove($20e62.MODAL_DIALOG_DATA);
            $1t8Wn.Container.set($20e62.MODAL_DIALOG_DATA, options);
            this.modalTemplate.next((0, $4TeKW.html)` ${(0, $4TeKW.unsafeHTML)(`<${tag()}></${tag()}>`)} `);
            this.closeSubject$.pipe((0, $d5Aat.take)(1)).subscribe((stream)=>{
                if (dialogOptions) this.setSettings(this.originalOptions);
                observer.next(stream);
                this.overflow('visible');
                observer.complete();
            });
        });
    }
    setSettings(options) {
        $1t8Wn.Container.remove($20e62.MODAL_DIALOG_OPTIONS);
        $1t8Wn.Container.set($20e62.MODAL_DIALOG_OPTIONS, options);
    }
    openSequence(components) {
        const identity = (v)=>v;
        return (0, $g5fNy.of)(components).pipe((0, $gawXH.map)((val)=>val.map((v)=>this.openComponent(v.component, v.data, v.options))), (0, $jMd8a.concatMap)(identity), (0, $jMd8a.concatMap)(identity));
    }
    getTemplate() {
        return this.modalTemplate.asObservable();
    }
    getRef() {
        return this.modalRef;
    }
    close(result) {
        this.removeModalPortal();
        this.closeSubject$.next(result);
    }
    createModalContainer() {
        this.modalRef = document.createElement('modal-container');
    }
    appendReference() {
        document.body.appendChild(this.modalRef);
    }
    createModalPortal() {
        if (this.modalRef) this.removeModalPortal();
        this.createModalContainer();
        this.appendReference();
    }
    removeModalPortal() {
        this.modalRef.remove();
    }
};
$285b21979986ef06$var$__decorate([
    (0, $1t8Wn.Injector)($20e62.MODAL_DIALOG_OPTIONS),
    $285b21979986ef06$var$__metadata("design:type", Object)
], $285b21979986ef06$var$ModalService.prototype, "options", void 0);
$285b21979986ef06$var$ModalService = $285b21979986ef06$var$__decorate([
    (0, $1t8Wn.Injectable)(),
    $285b21979986ef06$var$__metadata("design:paramtypes", [])
], $285b21979986ef06$var$ModalService);
module.exports.ModalService = $285b21979986ef06$var$ModalService;

});
parcelRegister("20e62", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MODAL_DIALOG_OPTIONS = module.exports.MODAL_DIALOG_DATA = void 0;

var $1t8Wn = parcelRequire("1t8Wn");
module.exports.MODAL_DIALOG_DATA = new $1t8Wn.InjectionToken('rxdi-ui-kit-modal-data');
module.exports.MODAL_DIALOG_OPTIONS = new $1t8Wn.InjectionToken('rxdi-ui-kit-modal-options');

});

parcelRegister("jVrCY", function(module, exports) {
"use strict";
var $e818c57994e08e37$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e818c57994e08e37$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MainModalComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $1t8Wn = parcelRequire("1t8Wn");

var $3sOsN = parcelRequire("3sOsN");

var $20e62 = parcelRequire("20e62");

var $b618b = parcelRequire("b618b");
let $e818c57994e08e37$var$MainModalComponent = class MainModalComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.modalService = $1t8Wn.Container.get($3sOsN.ModalService);
    }
    OnUpdateFirst() {
        if (this.options.backdropClose) this.backdrop.addEventListener('click', ()=>this.close());
        this.modalService.setContainerRef(this.container);
    }
    close() {
        this.modalService.close();
    }
};
$e818c57994e08e37$var$__decorate([
    (0, $1t8Wn.Injector)($20e62.MODAL_DIALOG_DATA),
    $e818c57994e08e37$var$__metadata("design:type", Object)
], $e818c57994e08e37$var$MainModalComponent.prototype, "data", void 0);
$e818c57994e08e37$var$__decorate([
    (0, $1t8Wn.Injector)($20e62.MODAL_DIALOG_OPTIONS),
    $e818c57994e08e37$var$__metadata("design:type", Object)
], $e818c57994e08e37$var$MainModalComponent.prototype, "options", void 0);
$e818c57994e08e37$var$__decorate([
    (0, $4TeKW.query)('.backdrop'),
    $e818c57994e08e37$var$__metadata("design:type", HTMLElement)
], $e818c57994e08e37$var$MainModalComponent.prototype, "backdrop", void 0);
$e818c57994e08e37$var$__decorate([
    (0, $4TeKW.query)('.container'),
    $e818c57994e08e37$var$__metadata("design:type", HTMLElement)
], $e818c57994e08e37$var$MainModalComponent.prototype, "container", void 0);
$e818c57994e08e37$var$MainModalComponent = $e818c57994e08e37$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-modal-main',
        styles: [
            $b618b.style,
            $b618b.button
        ],
        template () {
            return (0, $4TeKW.html)`
      <style>
        ${this.data.style}
      </style>
      <div class="container" @scroll=${(e)=>this.modalService.setScrollWidth(e.currentTarget.scrollTop)}>
        <div class="dialog">
          <button @click=${()=>this.close()}>
            ${(0, $4TeKW.svg)`
              <svg width="14" height="14" viewBox="0 0 14 14">
                <line fill="none" stroke="#666" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line>
                <line fill="none" stroke="#666" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line>
              </svg>
            `}
          </button>
          ${this.data.template ? (0, $4TeKW.html)`
                ${this.data.template}
              ` : (0, $4TeKW.html)`
                <h1>${this.data.title}</h1>
                <p>
                  ${this.data.description}
                </p>
              `}
        </div>
      </div>
      <div class="backdrop"></div>
    `;
        }
    })
], $e818c57994e08e37$var$MainModalComponent);
module.exports.MainModalComponent = $e818c57994e08e37$var$MainModalComponent;

});
parcelRegister("b618b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.button = module.exports.style = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.style = (0, $4TeKW.css)`

@keyframes scale {
   from {
    transform: scale(0);
   }
   to {
    transform: scale(1);
   }
  }

  @keyframes blur {
   to {
    backdrop-filter: blur(5px);
   }
  }

  .backdrop {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 10;
    animation: blur 0.3s linear forwards;
  }

  .container {
    padding: 50px 50px;

  }

  .dialog {
    position: relative;
    box-sizing: border-box;
    transform: translateY(0);
    margin: 0 auto;
    background: #fff;
    width: 600px;
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
      0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
    transition: 0.3s linear;
    transition-property: opacity, transform;
    max-width: calc(100% - 0.01px) !important;
    padding: 30px 30px;
    color: #666;
    z-index: 12;
    animation-name: scale;
   animation-duration: 300ms;
  }

  h1 {
    margin-top: 0;
    font-size: 30px;
    line-height: 1.3;
    margin: 0 0 0px 0;
    font-family: ProximaNova, -apple-system, BlinkMacSystemFont, 'Segoe UI',
      Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-weight: 300;
    color: #222;
    text-transform: none;
  }

  button {
    position: absolute;
    z-index: 1010;
    top: 10px;
    right: 10px;
    padding: 5px;
    border: none;
    cursor: pointer;
    text-transform: none;
    outline: none;
    background-color: transparent;
  }
  p {
    font-size: 15px;
    font-weight: normal;
    line-height: 1.5;
    color: #666;
  }
`;
module.exports.button = (0, $4TeKW.css)`
  button {
    opacity: 0.7;
  }

  button:hover {
    opacity: 1;
  }
`;

});



parcelRegister("g9f1C", function(module, exports) {
"use strict";
var $bc19244aeb0088f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bc19244aeb0088f2$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalContainerComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $1t8Wn = parcelRequire("1t8Wn");

var $3sOsN = parcelRequire("3sOsN");

var $20e62 = parcelRequire("20e62");
let $bc19244aeb0088f2$var$ModalContainerComponent = class ModalContainerComponent extends $4TeKW.LitElement {
    OnInit() {
        this.template = this.modalService.getTemplate();
    }
};
$bc19244aeb0088f2$var$__decorate([
    (0, $1t8Wn.Inject)($3sOsN.ModalService),
    $bc19244aeb0088f2$var$__metadata("design:type", $3sOsN.ModalService)
], $bc19244aeb0088f2$var$ModalContainerComponent.prototype, "modalService", void 0);
$bc19244aeb0088f2$var$__decorate([
    (0, $1t8Wn.Injector)($20e62.MODAL_DIALOG_OPTIONS),
    $bc19244aeb0088f2$var$__metadata("design:type", Object)
], $bc19244aeb0088f2$var$ModalContainerComponent.prototype, "options", void 0);
$bc19244aeb0088f2$var$ModalContainerComponent = $bc19244aeb0088f2$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'modal-container',
        template () {
            return (0, $4TeKW.html)`
      <style>
        ${this.options.style}
      </style>
      <div class="wrapper">
        <div class="content">${(0, $4TeKW.async)(this.template)}</div>
        <div
          @click=${()=>this.options.backdropClose && this.modalService.close()}
          class="backdrop"
        ></div>
      </div>
    `;
        }
    })
], $bc19244aeb0088f2$var$ModalContainerComponent);
module.exports.ModalContainerComponent = $bc19244aeb0088f2$var$ModalContainerComponent;

});

parcelRegister("c9mBx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultModalStyle = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.defaultModalStyle = (0, $4TeKW.css)`
  .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }

  .backdrop {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    pointer-events: all;
    z-index: 10;
  }

  .content {
    z-index: 20;
    position: absolute;
    /* width: 100%; */
    /* height: 100%; */
    pointer-events: all;
  }
`;

});


parcelRegister("iWHsw", function(module, exports) {
"use strict";
var $dcaf5ad1eb8264eb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dcaf5ad1eb8264eb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dcaf5ad1eb8264eb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dcaf5ad1eb8264eb$var$__exportStar((parcelRequire("5Bwb3")), module.exports);

$dcaf5ad1eb8264eb$var$__exportStar((parcelRequire("8dUJX")), module.exports);

});
parcelRegister("5Bwb3", function(module, exports) {
"use strict";
var $41495e35cc44b70c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $41495e35cc44b70c$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResponsiveService = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
var $jIao5 = parcelRequire("jIao5");
var $g5fNy = parcelRequire("g5fNy");

var $8Obdr = parcelRequire("8Obdr");
var $7LRrZ = parcelRequire("7LRrZ");
var $gawXH = parcelRequire("gawXH");
let $41495e35cc44b70c$var$ResponsiveService = class ResponsiveService {
    constructor(){
        this.width = new $bq6Hs.BehaviorSubject(document.body.clientWidth);
        this.height = new $bq6Hs.BehaviorSubject(document.body.clientHeight);
        this.scrollDebounceTime = 10;
        this.scrollSubscription = (0, $jIao5.fromEvent)(window, 'scroll').pipe((0, $7LRrZ.debounceTime)(this.scrollDebounceTime));
        this.isPositionFixed = true;
        window.addEventListener('resize', ()=>this.setWindowSize());
    }
    setWindowSize() {
        this.height.next(document.body.clientHeight);
        this.width.next(document.body.clientWidth);
    }
    getBoth() {
        return {
            width: this.width.getValue(),
            height: this.height.getValue()
        };
    }
    combineBoth() {
        return (0, $g5fNy.of)(this.getBoth()).pipe((0, $8Obdr.combineLatest)(this.height, this.width), (0, $gawXH.map)(()=>this.getBoth()));
    }
};
$41495e35cc44b70c$var$ResponsiveService = $41495e35cc44b70c$var$__decorate([
    (0, $1t8Wn.Injectable)({
        init: true
    }),
    $41495e35cc44b70c$var$__metadata("design:paramtypes", [])
], $41495e35cc44b70c$var$ResponsiveService);
module.exports.ResponsiveService = $41495e35cc44b70c$var$ResponsiveService;

});

parcelRegister("8dUJX", function(module, exports) {
"use strict";
var $5fcb8d099366ea43$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DynamicCssService = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $9DBLY = parcelRequire("9DBLY");

var $gawXH = parcelRequire("gawXH");
var $bFKOt = parcelRequire("bFKOt");
let $5fcb8d099366ea43$var$DynamicCssService = class DynamicCssService {
    constructor(){
        this.palletes = $1t8Wn.Container.get($9DBLY.Palettes);
    }
    changeStyle(palettes) {
        this.palletes.next(palettes);
    }
    OnInit() {
        this.palletes.subscribe((stream)=>{
            if (this.style) this.style.remove();
            this.style = document.createElement('style');
            this.style.innerHTML = Object.entries(stream).map(([key, css])=>` /* ${key} pallete */ ${css.cssText}`).join(' ');
            document.head.appendChild(this.style);
        });
    }
    getStyles() {
        return this.palletes.asObservable().pipe((0, $gawXH.map)((res)=>Object.values(res)), (0, $gawXH.map)((styles)=>styles.map((s)=>s.cssText)), (0, $bFKOt.shareReplay)({
            bufferSize: 1,
            refCount: true
        }));
    }
};
$5fcb8d099366ea43$var$DynamicCssService = $5fcb8d099366ea43$var$__decorate([
    (0, $1t8Wn.Injectable)({
        init: true
    })
], $5fcb8d099366ea43$var$DynamicCssService);
module.exports.DynamicCssService = $5fcb8d099366ea43$var$DynamicCssService; // import { Injectable, Inject, Container } from "@rxdi/core";
 // import { Palettes } from "@rxdi/ui-kit/settings";
 // import { BehaviorSubject } from "rxjs";
 // import { map, shareReplay } from "rxjs/operators";
 // import { css } from "@rxdi/lit-html";
 // @Injectable({ init: true })
 // export class DynamicCssService {
 //   private palletes: BehaviorSubject<Palettes>;
 //   private style: HTMLStyleElement;
 //   changeStyle(palettes: Palettes) {
 //     this.palletes.next(palettes);
 //   }
 //   OnInit() {
 //     this.palletes = Container.get<BehaviorSubject<Palettes>>(Palettes);
 //     const styleSheets = document.styleSheets[0] as CSSStyleSheet;
 //     this.palletes.subscribe(palettes => {
 //       this.addRules(styleSheets, palettes);
 //     });
 //     setTimeout(() => {
 //       this.addRules(styleSheets as CSSStyleSheet, {
 //         default: css`
 //           :root {
 //             --default-bg-color: transparent;
 //             --default-color: #222;
 //             --default-border-color: 1px solid #e5e5e5;
 //           }
 //         `,
 //         primary: css`
 //           :root {
 //             --primary-bg-color: #1e87f0;
 //             --primary-color: #fff;
 //             --primary-border-color: 1px solid transparent;
 //           }
 //         `,
 //         secondary: css`
 //           :root {
 //             --secondary-bg-color: #222;
 //             --secondary-color: #fff;
 //             --secondary-border-color: 1px solid transparent;
 //           }
 //         `
 //       })
 //       this.removeRules(styleSheets as CSSStyleSheet)
 //       this.removeRules(styleSheets as CSSStyleSheet)
 //       this.removeRules(styleSheets as CSSStyleSheet)
 //     }, 1000);
 //   }
 //   removeRules(styleSheets: CSSStyleSheet) {
 //     styleSheets.deleteRule(1)
 //   }
 //   addRules(styleSheets: CSSStyleSheet, palettes: Palettes) {
 //     styleSheets.insertRule(palettes.default.cssText, 0);
 //     styleSheets.insertRule(palettes.primary.cssText, 0);
 //     styleSheets.insertRule(palettes.secondary.cssText, 0);
 //   }
 //   getStyles() {
 //     return this.palletes.asObservable().pipe(
 //       map(res => Object.values(res)),
 //       map(styles => styles.map(s => s.cssText)),
 //       shareReplay({ bufferSize: 1, refCount: true })
 //     );
 //   }
 // }

});
parcelRegister("9DBLY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Styles = module.exports.Palettes = module.exports.PalettesUnion = void 0;

var $4oseH = parcelRequire("4oseH");
module.exports.PalettesUnion = (0, $4oseH.strEnum)([
    'root',
    'default',
    'primary',
    'secondary',
    'danger',
    'warning'
]);
module.exports.Palettes = 'palettes';
module.exports.Styles = (0, $4oseH.strEnum)([
    'spacer',
    'pointer',
    'images',
    'flex',
    'center',
    'transitions'
]);

});
parcelRegister("4oseH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.strEnum = void 0;
function $332f4e6c1b7524b1$var$strEnum(o) {
    return o.reduce((res, key)=>{
        res[key] = key;
        return res;
    }, Object.create(null));
}
module.exports.strEnum = $332f4e6c1b7524b1$var$strEnum;

});




parcelRegister("frkuW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.animateChain = module.exports.animateElement = module.exports.Animations = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $5JMLH = parcelRequire("5JMLH");
var $8id0M = parcelRequire("8id0M");

var $jMd8a = parcelRequire("jMd8a");
module.exports.Animations = (0, $4TeKW.css)`
@charset "UTF-8";

/*!
 * animate.css -https://daneden.github.io/animate.css/
 * Version - 3.7.2
 * Licensed under the MIT license - http://opensource.org/licenses/MIT
 *
 * Copyright (c) 2019 Daniel Eden
 */

@-webkit-keyframes bounce {
	0%,
	20%,
	53%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	40%,
	43% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -30px, 0);
		transform: translate3d(0, -30px, 0)
	}
	70% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -15px, 0);
		transform: translate3d(0, -15px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -4px, 0);
		transform: translate3d(0, -4px, 0)
	}
}

@keyframes bounce {
	0%,
	20%,
	53%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	40%,
	43% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -30px, 0);
		transform: translate3d(0, -30px, 0)
	}
	70% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -15px, 0);
		transform: translate3d(0, -15px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -4px, 0);
		transform: translate3d(0, -4px, 0)
	}
}

.bounce {
	-webkit-animation-name: bounce;
	animation-name: bounce;
	-webkit-transform-origin: center bottom;
	transform-origin: center bottom
}

@-webkit-keyframes flash {
	0%,
	50%,
	to {
		opacity: 1
	}
	25%,
	75% {
		opacity: 0
	}
}

@keyframes flash {
	0%,
	50%,
	to {
		opacity: 1
	}
	25%,
	75% {
		opacity: 0
	}
}

.flash {
	-webkit-animation-name: flash;
	animation-name: flash
}

@-webkit-keyframes pulse {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes pulse {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.pulse {
	-webkit-animation-name: pulse;
	animation-name: pulse
}

@-webkit-keyframes rubberBand {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	30% {
		-webkit-transform: scale3d(1.25, .75, 1);
		transform: scale3d(1.25, .75, 1)
	}
	40% {
		-webkit-transform: scale3d(.75, 1.25, 1);
		transform: scale3d(.75, 1.25, 1)
	}
	50% {
		-webkit-transform: scale3d(1.15, .85, 1);
		transform: scale3d(1.15, .85, 1)
	}
	65% {
		-webkit-transform: scale3d(.95, 1.05, 1);
		transform: scale3d(.95, 1.05, 1)
	}
	75% {
		-webkit-transform: scale3d(1.05, .95, 1);
		transform: scale3d(1.05, .95, 1)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes rubberBand {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	30% {
		-webkit-transform: scale3d(1.25, .75, 1);
		transform: scale3d(1.25, .75, 1)
	}
	40% {
		-webkit-transform: scale3d(.75, 1.25, 1);
		transform: scale3d(.75, 1.25, 1)
	}
	50% {
		-webkit-transform: scale3d(1.15, .85, 1);
		transform: scale3d(1.15, .85, 1)
	}
	65% {
		-webkit-transform: scale3d(.95, 1.05, 1);
		transform: scale3d(.95, 1.05, 1)
	}
	75% {
		-webkit-transform: scale3d(1.05, .95, 1);
		transform: scale3d(1.05, .95, 1)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.rubberBand {
	-webkit-animation-name: rubberBand;
	animation-name: rubberBand
}

@-webkit-keyframes shake {
	0%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	20%,
	40%,
	60%,
	80% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
}

@keyframes shake {
	0%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	20%,
	40%,
	60%,
	80% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
}

.shake {
	-webkit-animation-name: shake;
	animation-name: shake
}

@-webkit-keyframes headShake {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
	6.5% {
		-webkit-transform: translateX(-6px) rotateY(-9deg);
		transform: translateX(-6px) rotateY(-9deg)
	}
	18.5% {
		-webkit-transform: translateX(5px) rotateY(7deg);
		transform: translateX(5px) rotateY(7deg)
	}
	31.5% {
		-webkit-transform: translateX(-3px) rotateY(-5deg);
		transform: translateX(-3px) rotateY(-5deg)
	}
	43.5% {
		-webkit-transform: translateX(2px) rotateY(3deg);
		transform: translateX(2px) rotateY(3deg)
	}
	50% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

@keyframes headShake {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
	6.5% {
		-webkit-transform: translateX(-6px) rotateY(-9deg);
		transform: translateX(-6px) rotateY(-9deg)
	}
	18.5% {
		-webkit-transform: translateX(5px) rotateY(7deg);
		transform: translateX(5px) rotateY(7deg)
	}
	31.5% {
		-webkit-transform: translateX(-3px) rotateY(-5deg);
		transform: translateX(-3px) rotateY(-5deg)
	}
	43.5% {
		-webkit-transform: translateX(2px) rotateY(3deg);
		transform: translateX(2px) rotateY(3deg)
	}
	50% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

.headShake {
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out;
	-webkit-animation-name: headShake;
	animation-name: headShake
}

@-webkit-keyframes swing {
	20% {
		-webkit-transform: rotate(15deg);
		transform: rotate(15deg)
	}
	40% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	60% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg)
	}
	80% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg)
	}
	to {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg)
	}
}

@keyframes swing {
	20% {
		-webkit-transform: rotate(15deg);
		transform: rotate(15deg)
	}
	40% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	60% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg)
	}
	80% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg)
	}
	to {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg)
	}
}

.swing {
	-webkit-transform-origin: top center;
	transform-origin: top center;
	-webkit-animation-name: swing;
	animation-name: swing
}

@-webkit-keyframes tada {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	10%,
	20% {
		-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
		transform: scale3d(.9, .9, .9) rotate(-3deg)
	}
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
	}
	40%,
	60%,
	80% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes tada {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	10%,
	20% {
		-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
		transform: scale3d(.9, .9, .9) rotate(-3deg)
	}
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
	}
	40%,
	60%,
	80% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.tada {
	-webkit-animation-name: tada;
	animation-name: tada
}

@-webkit-keyframes wobble {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	15% {
		-webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
		transform: translate3d(-25%, 0, 0) rotate(-5deg)
	}
	30% {
		-webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
		transform: translate3d(20%, 0, 0) rotate(3deg)
	}
	45% {
		-webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
		transform: translate3d(-15%, 0, 0) rotate(-3deg)
	}
	60% {
		-webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
		transform: translate3d(10%, 0, 0) rotate(2deg)
	}
	75% {
		-webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
		transform: translate3d(-5%, 0, 0) rotate(-1deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes wobble {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	15% {
		-webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
		transform: translate3d(-25%, 0, 0) rotate(-5deg)
	}
	30% {
		-webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
		transform: translate3d(20%, 0, 0) rotate(3deg)
	}
	45% {
		-webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
		transform: translate3d(-15%, 0, 0) rotate(-3deg)
	}
	60% {
		-webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
		transform: translate3d(10%, 0, 0) rotate(2deg)
	}
	75% {
		-webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
		transform: translate3d(-5%, 0, 0) rotate(-1deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.wobble {
	-webkit-animation-name: wobble;
	animation-name: wobble
}

@-webkit-keyframes jello {
	0%,
	11.1%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	22.2% {
		-webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
		transform: skewX(-12.5deg) skewY(-12.5deg)
	}
	33.3% {
		-webkit-transform: skewX(6.25deg) skewY(6.25deg);
		transform: skewX(6.25deg) skewY(6.25deg)
	}
	44.4% {
		-webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
		transform: skewX(-3.125deg) skewY(-3.125deg)
	}
	55.5% {
		-webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
		transform: skewX(1.5625deg) skewY(1.5625deg)
	}
	66.6% {
		-webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
		transform: skewX(-.78125deg) skewY(-.78125deg)
	}
	77.7% {
		-webkit-transform: skewX(.390625deg) skewY(.390625deg);
		transform: skewX(.390625deg) skewY(.390625deg)
	}
	88.8% {
		-webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
		transform: skewX(-.1953125deg) skewY(-.1953125deg)
	}
}

@keyframes jello {
	0%,
	11.1%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	22.2% {
		-webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
		transform: skewX(-12.5deg) skewY(-12.5deg)
	}
	33.3% {
		-webkit-transform: skewX(6.25deg) skewY(6.25deg);
		transform: skewX(6.25deg) skewY(6.25deg)
	}
	44.4% {
		-webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
		transform: skewX(-3.125deg) skewY(-3.125deg)
	}
	55.5% {
		-webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
		transform: skewX(1.5625deg) skewY(1.5625deg)
	}
	66.6% {
		-webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
		transform: skewX(-.78125deg) skewY(-.78125deg)
	}
	77.7% {
		-webkit-transform: skewX(.390625deg) skewY(.390625deg);
		transform: skewX(.390625deg) skewY(.390625deg)
	}
	88.8% {
		-webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
		transform: skewX(-.1953125deg) skewY(-.1953125deg)
	}
}

.jello {
	-webkit-animation-name: jello;
	animation-name: jello;
	-webkit-transform-origin: center;
	transform-origin: center
}

@-webkit-keyframes heartBeat {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	14% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	28% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	42% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	70% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes heartBeat {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	14% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	28% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	42% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	70% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

.heartBeat {
	-webkit-animation-name: heartBeat;
	animation-name: heartBeat;
	-webkit-animation-duration: 1.3s;
	animation-duration: 1.3s;
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out
}

@-webkit-keyframes bounceIn {
	0%,
	20%,
	40%,
	60%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03)
	}
	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97)
	}
	to {
		opacity: 1;
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes bounceIn {
	0%,
	20%,
	40%,
	60%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03)
	}
	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97)
	}
	to {
		opacity: 1;
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.bounceIn {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: bounceIn;
	animation-name: bounceIn
}

@-webkit-keyframes bounceInDown {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -3000px, 0);
		transform: translate3d(0, -3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, 25px, 0);
		transform: translate3d(0, 25px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, 5px, 0);
		transform: translate3d(0, 5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInDown {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -3000px, 0);
		transform: translate3d(0, -3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, 25px, 0);
		transform: translate3d(0, 25px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, 5px, 0);
		transform: translate3d(0, 5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInDown {
	-webkit-animation-name: bounceInDown;
	animation-name: bounceInDown
}

@-webkit-keyframes bounceInLeft {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-3000px, 0, 0);
		transform: translate3d(-3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(25px, 0, 0);
		transform: translate3d(25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(5px, 0, 0);
		transform: translate3d(5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInLeft {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-3000px, 0, 0);
		transform: translate3d(-3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(25px, 0, 0);
		transform: translate3d(25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(5px, 0, 0);
		transform: translate3d(5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInLeft {
	-webkit-animation-name: bounceInLeft;
	animation-name: bounceInLeft
}

@-webkit-keyframes bounceInRight {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(3000px, 0, 0);
		transform: translate3d(3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(-25px, 0, 0);
		transform: translate3d(-25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(-5px, 0, 0);
		transform: translate3d(-5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInRight {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(3000px, 0, 0);
		transform: translate3d(3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(-25px, 0, 0);
		transform: translate3d(-25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(-5px, 0, 0);
		transform: translate3d(-5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInRight {
	-webkit-animation-name: bounceInRight;
	animation-name: bounceInRight
}

@-webkit-keyframes bounceInUp {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 3000px, 0);
		transform: translate3d(0, 3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -5px, 0);
		transform: translate3d(0, -5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInUp {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 3000px, 0);
		transform: translate3d(0, 3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -5px, 0);
		transform: translate3d(0, -5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInUp {
	-webkit-animation-name: bounceInUp;
	animation-name: bounceInUp
}

@-webkit-keyframes bounceOut {
	20% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	50%,
	55% {
		opacity: 1;
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
}

@keyframes bounceOut {
	20% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	50%,
	55% {
		opacity: 1;
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
}

.bounceOut {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: bounceOut;
	animation-name: bounceOut
}

@-webkit-keyframes bounceOutDown {
	20% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

@keyframes bounceOutDown {
	20% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

.bounceOutDown {
	-webkit-animation-name: bounceOutDown;
	animation-name: bounceOutDown
}

@-webkit-keyframes bounceOutLeft {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(20px, 0, 0);
		transform: translate3d(20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

@keyframes bounceOutLeft {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(20px, 0, 0);
		transform: translate3d(20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

.bounceOutLeft {
	-webkit-animation-name: bounceOutLeft;
	animation-name: bounceOutLeft
}

@-webkit-keyframes bounceOutRight {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(-20px, 0, 0);
		transform: translate3d(-20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

@keyframes bounceOutRight {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(-20px, 0, 0);
		transform: translate3d(-20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

.bounceOutRight {
	-webkit-animation-name: bounceOutRight;
	animation-name: bounceOutRight
}

@-webkit-keyframes bounceOutUp {
	20% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, 20px, 0);
		transform: translate3d(0, 20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

@keyframes bounceOutUp {
	20% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, 20px, 0);
		transform: translate3d(0, 20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

.bounceOutUp {
	-webkit-animation-name: bounceOutUp;
	animation-name: bounceOutUp
}

@-webkit-keyframes fadeIn {
	0% {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

@keyframes fadeIn {
	0% {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

.fadeIn {
	-webkit-animation-name: fadeIn;
	animation-name: fadeIn
}

@-webkit-keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInDown {
	-webkit-animation-name: fadeInDown;
	animation-name: fadeInDown
}

@-webkit-keyframes fadeInDownBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInDownBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInDownBig {
	-webkit-animation-name: fadeInDownBig;
	animation-name: fadeInDownBig
}

@-webkit-keyframes fadeInLeft {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInLeft {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInLeft {
	-webkit-animation-name: fadeInLeft;
	animation-name: fadeInLeft
}

@-webkit-keyframes fadeInLeftBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInLeftBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInLeftBig {
	-webkit-animation-name: fadeInLeftBig;
	animation-name: fadeInLeftBig
}

@-webkit-keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInRight {
	-webkit-animation-name: fadeInRight;
	animation-name: fadeInRight
}

@-webkit-keyframes fadeInRightBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInRightBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInRightBig {
	-webkit-animation-name: fadeInRightBig;
	animation-name: fadeInRightBig
}

@-webkit-keyframes fadeInUp {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInUp {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInUp {
	-webkit-animation-name: fadeInUp;
	animation-name: fadeInUp
}

@-webkit-keyframes fadeInUpBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInUpBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInUpBig {
	-webkit-animation-name: fadeInUpBig;
	animation-name: fadeInUpBig
}

@-webkit-keyframes fadeOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0
	}
}

@keyframes fadeOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0
	}
}

.fadeOut {
	-webkit-animation-name: fadeOut;
	animation-name: fadeOut
}

@-webkit-keyframes fadeOutDown {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

@keyframes fadeOutDown {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

.fadeOutDown {
	-webkit-animation-name: fadeOutDown;
	animation-name: fadeOutDown
}

@-webkit-keyframes fadeOutDownBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

@keyframes fadeOutDownBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

.fadeOutDownBig {
	-webkit-animation-name: fadeOutDownBig;
	animation-name: fadeOutDownBig
}

@-webkit-keyframes fadeOutLeft {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

@keyframes fadeOutLeft {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

.fadeOutLeft {
	-webkit-animation-name: fadeOutLeft;
	animation-name: fadeOutLeft
}

@-webkit-keyframes fadeOutLeftBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

@keyframes fadeOutLeftBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

.fadeOutLeftBig {
	-webkit-animation-name: fadeOutLeftBig;
	animation-name: fadeOutLeftBig
}

@-webkit-keyframes fadeOutRight {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

@keyframes fadeOutRight {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

.fadeOutRight {
	-webkit-animation-name: fadeOutRight;
	animation-name: fadeOutRight
}

@-webkit-keyframes fadeOutRightBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

@keyframes fadeOutRightBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

.fadeOutRightBig {
	-webkit-animation-name: fadeOutRightBig;
	animation-name: fadeOutRightBig
}

@-webkit-keyframes fadeOutUp {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

@keyframes fadeOutUp {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

.fadeOutUp {
	-webkit-animation-name: fadeOutUp;
	animation-name: fadeOutUp
}

@-webkit-keyframes fadeOutUpBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

@keyframes fadeOutUpBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

.fadeOutUpBig {
	-webkit-animation-name: fadeOutUpBig;
	animation-name: fadeOutUpBig
}

@-webkit-keyframes flip {
	0% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	40% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	50% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	80% {
		-webkit-transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	to {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
}

@keyframes flip {
	0% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	40% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	50% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	80% {
		-webkit-transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	to {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
}

.animated.flip {
	-webkit-backface-visibility: visible;
	backface-visibility: visible;
	-webkit-animation-name: flip;
	animation-name: flip
}

@-webkit-keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInX {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInX;
	animation-name: flipInX
}

@-webkit-keyframes flipInY {
	0% {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateY(-20deg);
		transform: perspective(400px) rotateY(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateY(10deg);
		transform: perspective(400px) rotateY(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateY(-5deg);
		transform: perspective(400px) rotateY(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInY {
	0% {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateY(-20deg);
		transform: perspective(400px) rotateY(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateY(10deg);
		transform: perspective(400px) rotateY(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateY(-5deg);
		transform: perspective(400px) rotateY(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInY {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInY;
	animation-name: flipInY
}

@-webkit-keyframes flipOutX {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}
}

@keyframes flipOutX {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}
}

.flipOutX {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: flipOutX;
	animation-name: flipOutX;
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important
}

@-webkit-keyframes flipOutY {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateY(-15deg);
		transform: perspective(400px) rotateY(-15deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		opacity: 0
	}
}

@keyframes flipOutY {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateY(-15deg);
		transform: perspective(400px) rotateY(-15deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		opacity: 0
	}
}

.flipOutY {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipOutY;
	animation-name: flipOutY
}

@-webkit-keyframes lightSpeedIn {
	0% {
		-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0
	}
	60% {
		-webkit-transform: skewX(20deg);
		transform: skewX(20deg);
		opacity: 1
	}
	80% {
		-webkit-transform: skewX(-5deg);
		transform: skewX(-5deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes lightSpeedIn {
	0% {
		-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0
	}
	60% {
		-webkit-transform: skewX(20deg);
		transform: skewX(20deg);
		opacity: 1
	}
	80% {
		-webkit-transform: skewX(-5deg);
		transform: skewX(-5deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.lightSpeedIn {
	-webkit-animation-name: lightSpeedIn;
	animation-name: lightSpeedIn;
	-webkit-animation-timing-function: ease-out;
	animation-timing-function: ease-out
}

@-webkit-keyframes lightSpeedOut {
	0% {
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
		transform: translate3d(100%, 0, 0) skewX(30deg);
		opacity: 0
	}
}

@keyframes lightSpeedOut {
	0% {
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
		transform: translate3d(100%, 0, 0) skewX(30deg);
		opacity: 0
	}
}

.lightSpeedOut {
	-webkit-animation-name: lightSpeedOut;
	animation-name: lightSpeedOut;
	-webkit-animation-timing-function: ease-in;
	animation-timing-function: ease-in
}

@-webkit-keyframes rotateIn {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(-200deg);
		transform: rotate(-200deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateIn {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(-200deg);
		transform: rotate(-200deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateIn {
	-webkit-animation-name: rotateIn;
	animation-name: rotateIn
}

@-webkit-keyframes rotateInDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInDownLeft {
	-webkit-animation-name: rotateInDownLeft;
	animation-name: rotateInDownLeft
}

@-webkit-keyframes rotateInDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInDownRight {
	-webkit-animation-name: rotateInDownRight;
	animation-name: rotateInDownRight
}

@-webkit-keyframes rotateInUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInUpLeft {
	-webkit-animation-name: rotateInUpLeft;
	animation-name: rotateInUpLeft
}

@-webkit-keyframes rotateInUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInUpRight {
	-webkit-animation-name: rotateInUpRight;
	animation-name: rotateInUpRight
}

@-webkit-keyframes rotateOut {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		opacity: 1
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(200deg);
		transform: rotate(200deg);
		opacity: 0
	}
}

@keyframes rotateOut {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		opacity: 1
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(200deg);
		transform: rotate(200deg);
		opacity: 0
	}
}

.rotateOut {
	-webkit-animation-name: rotateOut;
	animation-name: rotateOut
}

@-webkit-keyframes rotateOutDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
}

@keyframes rotateOutDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
}

.rotateOutDownLeft {
	-webkit-animation-name: rotateOutDownLeft;
	animation-name: rotateOutDownLeft
}

@-webkit-keyframes rotateOutDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

@keyframes rotateOutDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

.rotateOutDownRight {
	-webkit-animation-name: rotateOutDownRight;
	animation-name: rotateOutDownRight
}

@-webkit-keyframes rotateOutUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

@keyframes rotateOutUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

.rotateOutUpLeft {
	-webkit-animation-name: rotateOutUpLeft;
	animation-name: rotateOutUpLeft
}

@-webkit-keyframes rotateOutUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
		opacity: 0
	}
}

@keyframes rotateOutUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
		opacity: 0
	}
}

.rotateOutUpRight {
	-webkit-animation-name: rotateOutUpRight;
	animation-name: rotateOutUpRight
}

@-webkit-keyframes hinge {
	0% {
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	20%,
	60% {
		-webkit-transform: rotate(80deg);
		transform: rotate(80deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	40%,
	80% {
		-webkit-transform: rotate(60deg);
		transform: rotate(60deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(0, 700px, 0);
		transform: translate3d(0, 700px, 0);
		opacity: 0
	}
}

@keyframes hinge {
	0% {
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	20%,
	60% {
		-webkit-transform: rotate(80deg);
		transform: rotate(80deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	40%,
	80% {
		-webkit-transform: rotate(60deg);
		transform: rotate(60deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(0, 700px, 0);
		transform: translate3d(0, 700px, 0);
		opacity: 0
	}
}

.hinge {
	-webkit-animation-duration: 2s;
	animation-duration: 2s;
	-webkit-animation-name: hinge;
	animation-name: hinge
}

@-webkit-keyframes jackInTheBox {
	0% {
		opacity: 0;
		-webkit-transform: scale(.1) rotate(30deg);
		transform: scale(.1) rotate(30deg);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom
	}
	50% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	70% {
		-webkit-transform: rotate(3deg);
		transform: rotate(3deg)
	}
	to {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes jackInTheBox {
	0% {
		opacity: 0;
		-webkit-transform: scale(.1) rotate(30deg);
		transform: scale(.1) rotate(30deg);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom
	}
	50% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	70% {
		-webkit-transform: rotate(3deg);
		transform: rotate(3deg)
	}
	to {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

.jackInTheBox {
	-webkit-animation-name: jackInTheBox;
	animation-name: jackInTheBox
}

@-webkit-keyframes rollIn {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
		transform: translate3d(-100%, 0, 0) rotate(-120deg)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes rollIn {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
		transform: translate3d(-100%, 0, 0) rotate(-120deg)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.rollIn {
	-webkit-animation-name: rollIn;
	animation-name: rollIn
}

@-webkit-keyframes rollOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
		transform: translate3d(100%, 0, 0) rotate(120deg)
	}
}

@keyframes rollOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
		transform: translate3d(100%, 0, 0) rotate(120deg)
	}
}

.rollOut {
	-webkit-animation-name: rollOut;
	animation-name: rollOut
}

@-webkit-keyframes zoomIn {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	50% {
		opacity: 1
	}
}

@keyframes zoomIn {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	50% {
		opacity: 1
	}
}

.zoomIn {
	-webkit-animation-name: zoomIn;
	animation-name: zoomIn
}

@-webkit-keyframes zoomInDown {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInDown {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInDown {
	-webkit-animation-name: zoomInDown;
	animation-name: zoomInDown
}

@-webkit-keyframes zoomInLeft {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInLeft {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInLeft {
	-webkit-animation-name: zoomInLeft;
	animation-name: zoomInLeft
}

@-webkit-keyframes zoomInRight {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInRight {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInRight {
	-webkit-animation-name: zoomInRight;
	animation-name: zoomInRight
}

@-webkit-keyframes zoomInUp {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInUp {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInUp {
	-webkit-animation-name: zoomInUp;
	animation-name: zoomInUp
}

@-webkit-keyframes zoomOut {
	0% {
		opacity: 1
	}
	50% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	to {
		opacity: 0
	}
}

@keyframes zoomOut {
	0% {
		opacity: 1
	}
	50% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	to {
		opacity: 0
	}
}

.zoomOut {
	-webkit-animation-name: zoomOut;
	animation-name: zoomOut
}

@-webkit-keyframes zoomOutDown {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomOutDown {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomOutDown {
	-webkit-animation-name: zoomOutDown;
	animation-name: zoomOutDown
}

@-webkit-keyframes zoomOutLeft {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
		transform: scale(.1) translate3d(-2000px, 0, 0);
		-webkit-transform-origin: left center;
		transform-origin: left center
	}
}

@keyframes zoomOutLeft {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
		transform: scale(.1) translate3d(-2000px, 0, 0);
		-webkit-transform-origin: left center;
		transform-origin: left center
	}
}

.zoomOutLeft {
	-webkit-animation-name: zoomOutLeft;
	animation-name: zoomOutLeft
}

@-webkit-keyframes zoomOutRight {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(2000px, 0, 0);
		transform: scale(.1) translate3d(2000px, 0, 0);
		-webkit-transform-origin: right center;
		transform-origin: right center
	}
}

@keyframes zoomOutRight {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(2000px, 0, 0);
		transform: scale(.1) translate3d(2000px, 0, 0);
		-webkit-transform-origin: right center;
		transform-origin: right center
	}
}

.zoomOutRight {
	-webkit-animation-name: zoomOutRight;
	animation-name: zoomOutRight
}

@-webkit-keyframes zoomOutUp {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomOutUp {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomOutUp {
	-webkit-animation-name: zoomOutUp;
	animation-name: zoomOutUp
}

@-webkit-keyframes slideInDown {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInDown {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInDown {
	-webkit-animation-name: slideInDown;
	animation-name: slideInDown
}

@-webkit-keyframes slideInLeft {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInLeft {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInLeft {
	-webkit-animation-name: slideInLeft;
	animation-name: slideInLeft
}

@-webkit-keyframes slideInRight {
	0% {
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInRight {
	0% {
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInRight {
	-webkit-animation-name: slideInRight;
	animation-name: slideInRight
}

@-webkit-keyframes slideInUp {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInUp {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInUp {
	-webkit-animation-name: slideInUp;
	animation-name: slideInUp
}

@-webkit-keyframes slideOutDown {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

@keyframes slideOutDown {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

.slideOutDown {
	-webkit-animation-name: slideOutDown;
	animation-name: slideOutDown
}

@-webkit-keyframes slideOutLeft {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

@keyframes slideOutLeft {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

.slideOutLeft {
	-webkit-animation-name: slideOutLeft;
	animation-name: slideOutLeft
}

@-webkit-keyframes slideOutRight {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

@keyframes slideOutRight {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

.slideOutRight {
	-webkit-animation-name: slideOutRight;
	animation-name: slideOutRight
}

@-webkit-keyframes slideOutUp {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

@keyframes slideOutUp {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

.slideOutUp {
	-webkit-animation-name: slideOutUp;
	animation-name: slideOutUp
}

.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both
}

.animated.infinite {
	-webkit-animation-iteration-count: infinite;
	animation-iteration-count: infinite
}

.animated.delay-1s {
	-webkit-animation-delay: 1s;
	animation-delay: 1s
}

.animated.delay-2s {
	-webkit-animation-delay: 2s;
	animation-delay: 2s
}

.animated.delay-3s {
	-webkit-animation-delay: 3s;
	animation-delay: 3s
}

.animated.delay-4s {
	-webkit-animation-delay: 4s;
	animation-delay: 4s
}

.animated.delay-5s {
	-webkit-animation-delay: 5s;
	animation-delay: 5s
}

.animated.duration-0 {
	-webkit-animation-duration: 0ms;
	animation-duration: 0ms
}
.animated.duration-100 {
	-webkit-animation-duration: 100ms;
	animation-duration: 100ms
}
.animated.duration-200 {
	-webkit-animation-duration: 200ms;
	animation-duration: 200ms
}
.animated.duration-300 {
	-webkit-animation-duration: 300ms;
	animation-duration: 300ms
}
.animated.duration-400 {
	-webkit-animation-duration: 400ms;
	animation-duration: 400ms
}
.animated.duration-500 {
	-webkit-animation-duration: 500ms;
	animation-duration: 500ms
}

.animated.duration-600 {
	-webkit-animation-duration: 600ms;
	animation-duration: 600ms
}

.animated.duration-700 {
	-webkit-animation-duration: 700ms;
	animation-duration: 700ms
}

.animated.duration-800 {
	-webkit-animation-duration: 800ms;
	animation-duration: 800ms
}

.animated.duration-1000 {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
}

.animated.duration-2000 {
	-webkit-animation-duration: 2s;
	animation-duration: 2s;
}


.animated.duration-3000 {
	-webkit-animation-duration: 3s;
	animation-duration: 3s;
}

.animated.duration-4000 {
	-webkit-animation-duration: 4s;
	animation-duration: 4s;
}

.animated.duration-5000 {
	-webkit-animation-duration: 5s;
	animation-duration: 5s;
}


.animated.stop {
	-webkit-animation-duration: 0s;
	animation-duration: 0s
}

.animated.slow {
	-webkit-animation-duration: 2s;
	animation-duration: 2s
}

.animated.slower {
	-webkit-animation-duration: 3s;
	animation-duration: 3s
}
/*
@media (prefers-reduced-motion:reduce),
(print) {
	.animated {
		-webkit-animation-duration: 1ms!important;
		animation-duration: 1ms!important;
		-webkit-transition-duration: 1ms!important;
		transition-duration: 1ms!important;
		-webkit-animation-iteration-count: 1!important;
		animation-iteration-count: 1!important
	}
} */
`;
function $b3d9471db5ca314a$var$animateElement(node, animationName, duration = 'duration-300') {
    return new $8id0M.Observable((observable)=>{
        if (!node) observable.error('Missing element');
        node.classList.add('animated', animationName);
        node.classList.add(duration);
        function handleAnimationEnd() {
            node.classList.remove('animated', animationName);
            node.classList.remove(duration);
            node.removeEventListener('animationend', handleAnimationEnd);
            observable.next(true);
            observable.complete();
        }
        node.addEventListener('animationend', handleAnimationEnd);
    });
}
module.exports.animateElement = $b3d9471db5ca314a$var$animateElement;
function $b3d9471db5ca314a$var$animateChain(element, animations) {
    return (0, $5JMLH.from)(animations).pipe((0, $jMd8a.concatMap)((a)=>$b3d9471db5ca314a$var$animateElement(element, a)));
}
module.exports.animateChain = $b3d9471db5ca314a$var$animateChain;

});

parcelRegister("aBMMZ", function(module, exports) {
var $7b93349ed450c6bc$var$__defProp = Object.defineProperty;
var $7b93349ed450c6bc$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $7b93349ed450c6bc$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $7b93349ed450c6bc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7b93349ed450c6bc$var$__export = (target, all)=>{
    for(var name in all)$7b93349ed450c6bc$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $7b93349ed450c6bc$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $7b93349ed450c6bc$var$__getOwnPropNames(from))if (!$7b93349ed450c6bc$var$__hasOwnProp.call(to, key) && key !== except) $7b93349ed450c6bc$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $7b93349ed450c6bc$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $7b93349ed450c6bc$var$__toCommonJS = (mod)=>$7b93349ed450c6bc$var$__copyProps($7b93349ed450c6bc$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $7b93349ed450c6bc$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $7b93349ed450c6bc$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $7b93349ed450c6bc$var$__defProp(target, key, result);
    return result;
};
var $7b93349ed450c6bc$var$generic_apps_service_exports = {};
$7b93349ed450c6bc$var$__export($7b93349ed450c6bc$var$generic_apps_service_exports, {
    GenericAppsService: ()=>$7b93349ed450c6bc$var$GenericAppsService
});
module.exports = $7b93349ed450c6bc$var$__toCommonJS($7b93349ed450c6bc$var$generic_apps_service_exports);

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
var $jIao5 = parcelRequire("jIao5");

var $6Rz6W = parcelRequire("6Rz6W");
let $7b93349ed450c6bc$var$GenericAppsService = class {
    constructor(){
        this.trace = new $bq6Hs.BehaviorSubject([]);
    }
    OnInit() {
        const cache = localStorage.getItem("trace");
        if (cache) this.trace.next(JSON.parse(cache));
    }
    listenForEscapeKey() {
        return (0, $jIao5.fromEvent)(document, "keyup").pipe((0, $6Rz6W.filter)((e)=>e["key"] === "Escape"));
    }
    addTrace(trace) {
        let traces = this.trace.getValue();
        const traceExists = traces.find((t)=>t.path === trace.path);
        if (traceExists) {
            if (traceExists.activeIndex !== trace.activeIndex) traces = traces.filter((t)=>t.path !== trace.path);
            else return;
        }
        traces.push(trace);
        this.trace.next(traces);
        localStorage.setItem("trace", JSON.stringify(this.trace.getValue()));
    }
    popTrace() {
        const traces = this.trace.getValue();
        traces.pop();
        this.trace.next(traces);
        localStorage.setItem("trace", JSON.stringify(this.trace.getValue()));
    }
    clearTraces() {
        this.trace.next([]);
        localStorage.removeItem("trace");
    }
    getLastTrace() {
        const traces = this.trace.getValue();
        return traces[traces.length - 1];
    }
    traceAsObservable() {
        return this.trace.asObservable();
    }
};
$7b93349ed450c6bc$var$GenericAppsService = $7b93349ed450c6bc$var$__decorateClass([
    (0, $1t8Wn.Injectable)()
], $7b93349ed450c6bc$var$GenericAppsService);

});

parcelRegister("lzXjJ", function(module, exports) {
var $fb5ae105465552b8$var$__defProp = Object.defineProperty;
var $fb5ae105465552b8$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $fb5ae105465552b8$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $fb5ae105465552b8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fb5ae105465552b8$var$__export = (target, all)=>{
    for(var name in all)$fb5ae105465552b8$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $fb5ae105465552b8$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $fb5ae105465552b8$var$__getOwnPropNames(from))if (!$fb5ae105465552b8$var$__hasOwnProp.call(to, key) && key !== except) $fb5ae105465552b8$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $fb5ae105465552b8$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $fb5ae105465552b8$var$__toCommonJS = (mod)=>$fb5ae105465552b8$var$__copyProps($fb5ae105465552b8$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $fb5ae105465552b8$var$swiper_css_exports = {};
$fb5ae105465552b8$var$__export($fb5ae105465552b8$var$swiper_css_exports, {
    SwiperCss: ()=>$fb5ae105465552b8$var$SwiperCss
});
module.exports = $fb5ae105465552b8$var$__toCommonJS($fb5ae105465552b8$var$swiper_css_exports);

var $4TeKW = parcelRequire("4TeKW");
const $fb5ae105465552b8$var$SwiperCss = $4TeKW.css`
  /**
 * Swiper 4.5.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: October 16, 2019
 */
  .swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    /* Fix of Webkit flickering */
    z-index: 1;
  }
  .swiper-container-no-flexbox .swiper-slide {
    float: left;
  }
  .swiper-container-vertical > .swiper-wrapper {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    -o-transition-property: transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
  }
  .swiper-container-android .swiper-slide,
  .swiper-wrapper {
    -webkit-transform: translate3d(0px, 0, 0);
    transform: translate3d(0px, 0, 0);
  }
  .swiper-container-multirow > .swiper-wrapper {
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: ease-out;
    -o-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
    margin: 0 auto;
  }
  .swiper-slide {
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    -o-transition-property: transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
  /* Auto Height */
  .swiper-container-autoheight,
  .swiper-container-autoheight .swiper-slide {
    height: auto;
  }
  .swiper-container-autoheight .swiper-wrapper {
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-transition-property: height, -webkit-transform;
    transition-property: height, -webkit-transform;
    -o-transition-property: transform, height;
    transition-property: transform, height;
    transition-property: transform, height, -webkit-transform;
  }
  /* 3D Effects */
  .swiper-container-3d {
    -webkit-perspective: 1200px;
    perspective: 1200px;
  }
  .swiper-container-3d .swiper-wrapper,
  .swiper-container-3d .swiper-slide,
  .swiper-container-3d .swiper-slide-shadow-left,
  .swiper-container-3d .swiper-slide-shadow-right,
  .swiper-container-3d .swiper-slide-shadow-top,
  .swiper-container-3d .swiper-slide-shadow-bottom,
  .swiper-container-3d .swiper-cube-shadow {
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
  }
  .swiper-container-3d .swiper-slide-shadow-left,
  .swiper-container-3d .swiper-slide-shadow-right,
  .swiper-container-3d .swiper-slide-shadow-top,
  .swiper-container-3d .swiper-slide-shadow-bottom {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
  }
  .swiper-container-3d .swiper-slide-shadow-left {
    background-image: -webkit-gradient(
      linear,
      right top,
      left top,
      from(rgba(0, 0, 0, 0.5)),
      to(rgba(0, 0, 0, 0))
    );
    background-image: -webkit-linear-gradient(
      right,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    background-image: -o-linear-gradient(
      right,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    background-image: linear-gradient(
      to left,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
  }
  .swiper-container-3d .swiper-slide-shadow-right {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      from(rgba(0, 0, 0, 0.5)),
      to(rgba(0, 0, 0, 0))
    );
    background-image: -webkit-linear-gradient(
      left,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    background-image: -o-linear-gradient(
      left,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
  }
  .swiper-container-3d .swiper-slide-shadow-top {
    background-image: -webkit-gradient(
      linear,
      left bottom,
      left top,
      from(rgba(0, 0, 0, 0.5)),
      to(rgba(0, 0, 0, 0))
    );
    background-image: -webkit-linear-gradient(
      bottom,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    background-image: -o-linear-gradient(
      bottom,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
  }
  .swiper-container-3d .swiper-slide-shadow-bottom {
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(0, 0, 0, 0.5)),
      to(rgba(0, 0, 0, 0))
    );
    background-image: -webkit-linear-gradient(
      top,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    background-image: -o-linear-gradient(
      top,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
  }
  /* IE10 Windows Phone 8 Fixes */
  .swiper-container-wp8-horizontal,
  .swiper-container-wp8-horizontal > .swiper-wrapper {
    -ms-touch-action: pan-y;
    touch-action: pan-y;
  }
  .swiper-container-wp8-vertical,
  .swiper-container-wp8-vertical > .swiper-wrapper {
    -ms-touch-action: pan-x;
    touch-action: pan-x;
  }
  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    width: 27px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-size: 27px 44px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 0.35;
    cursor: auto;
    pointer-events: none;
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E");
    left: 10px;
    right: auto;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E");
    right: 10px;
    left: auto;
  }
  .swiper-button-prev.swiper-button-white,
  .swiper-container-rtl .swiper-button-next.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
  }
  .swiper-button-next.swiper-button-white,
  .swiper-container-rtl .swiper-button-prev.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
  }
  .swiper-button-prev.swiper-button-black,
  .swiper-container-rtl .swiper-button-next.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E");
  }
  .swiper-button-next.swiper-button-black,
  .swiper-container-rtl .swiper-button-prev.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E");
  }
  .swiper-button-lock {
    display: none;
  }
  .swiper-pagination {
    position: absolute;
    text-align: center;
    -webkit-transition: 300ms opacity;
    -o-transition: 300ms opacity;
    transition: 300ms opacity;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    z-index: 10;
  }
  .swiper-pagination.swiper-pagination-hidden {
    opacity: 0;
  }
  /* Common Styles */
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 10px;
    left: 0;
    width: 100%;
  }
  /* Bullets */
  .swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0;
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    -webkit-transform: scale(0.33);
    -ms-transform: scale(0.33);
    transform: scale(0.33);
    position: relative;
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    -webkit-transform: scale(0.66);
    -ms-transform: scale(0.66);
    transform: scale(0.66);
  }
  .swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet-active-prev-prev {
    -webkit-transform: scale(0.33);
    -ms-transform: scale(0.33);
    transform: scale(0.33);
  }
  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    -webkit-transform: scale(0.66);
    -ms-transform: scale(0.66);
    transform: scale(0.66);
  }
  .swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet-active-next-next {
    -webkit-transform: scale(0.33);
    -ms-transform: scale(0.33);
    transform: scale(0.33);
  }
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: 0.2;
  }
  button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  .swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer;
  }
  .swiper-pagination-bullet-active {
    opacity: 1;
    background: #007aff;
  }
  .swiper-container-vertical > .swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    -webkit-transform: translate3d(0px, -50%, 0);
    transform: translate3d(0px, -50%, 0);
  }
  .swiper-container-vertical
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 6px 0;
    display: block;
  }
  .swiper-container-vertical
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 8px;
  }
  .swiper-container-vertical
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    display: inline-block;
    -webkit-transition: 200ms top, 200ms -webkit-transform;
    transition: 200ms top, 200ms -webkit-transform;
    -o-transition: 200ms transform, 200ms top;
    transition: 200ms transform, 200ms top;
    transition: 200ms transform, 200ms top, 200ms -webkit-transform;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    white-space: nowrap;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    -webkit-transition: 200ms left, 200ms -webkit-transform;
    transition: 200ms left, 200ms -webkit-transform;
    -o-transition: 200ms transform, 200ms left;
    transition: 200ms transform, 200ms left;
    transition: 200ms transform, 200ms left, 200ms -webkit-transform;
  }
  .swiper-container-horizontal.swiper-container-rtl
    > .swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    -webkit-transition: 200ms right, 200ms -webkit-transform;
    transition: 200ms right, 200ms -webkit-transform;
    -o-transition: 200ms transform, 200ms right;
    transition: 200ms transform, 200ms right;
    transition: 200ms transform, 200ms right, 200ms -webkit-transform;
  }
  /* Progress */
  .swiper-pagination-progressbar {
    background: rgba(0, 0, 0, 0.25);
    position: absolute;
  }
  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #007aff;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top;
    -ms-transform-origin: left top;
    transform-origin: left top;
  }
  .swiper-container-rtl
    .swiper-pagination-progressbar
    .swiper-pagination-progressbar-fill {
    -webkit-transform-origin: right top;
    -ms-transform-origin: right top;
    transform-origin: right top;
  }
  .swiper-container-horizontal > .swiper-pagination-progressbar,
  .swiper-container-vertical
    > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    width: 100%;
    height: 4px;
    left: 0;
    top: 0;
  }
  .swiper-container-vertical > .swiper-pagination-progressbar,
  .swiper-container-horizontal
    > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    width: 4px;
    height: 100%;
    left: 0;
    top: 0;
  }
  .swiper-pagination-white .swiper-pagination-bullet-active {
    background: #ffffff;
  }
  .swiper-pagination-progressbar.swiper-pagination-white {
    background: rgba(255, 255, 255, 0.25);
  }
  .swiper-pagination-progressbar.swiper-pagination-white
    .swiper-pagination-progressbar-fill {
    background: #ffffff;
  }
  .swiper-pagination-black .swiper-pagination-bullet-active {
    background: #000000;
  }
  .swiper-pagination-progressbar.swiper-pagination-black {
    background: rgba(0, 0, 0, 0.25);
  }
  .swiper-pagination-progressbar.swiper-pagination-black
    .swiper-pagination-progressbar-fill {
    background: #000000;
  }
  .swiper-pagination-lock {
    display: none;
  }
  /* Scrollbar */
  .swiper-scrollbar {
    border-radius: 10px;
    position: relative;
    -ms-touch-action: none;
    background: rgba(0, 0, 0, 0.1);
  }
  .swiper-container-horizontal > .swiper-scrollbar {
    position: absolute;
    left: 1%;
    bottom: 3px;
    z-index: 50;
    height: 5px;
    width: 98%;
  }
  .swiper-container-vertical > .swiper-scrollbar {
    position: absolute;
    right: 3px;
    top: 1%;
    z-index: 50;
    width: 5px;
    height: 98%;
  }
  .swiper-scrollbar-drag {
    height: 100%;
    width: 100%;
    position: relative;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    left: 0;
    top: 0;
  }
  .swiper-scrollbar-cursor-drag {
    cursor: move;
  }
  .swiper-scrollbar-lock {
    display: none;
  }
  .swiper-zoom-container {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
  }
  .swiper-zoom-container > img,
  .swiper-zoom-container > svg,
  .swiper-zoom-container > canvas {
    max-width: 100%;
    max-height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
  }
  .swiper-slide-zoomed {
    cursor: move;
  }
  /* Preloader */
  .swiper-lazy-preloader {
    width: 42px;
    height: 42px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -21px;
    margin-top: -21px;
    z-index: 10;
    -webkit-transform-origin: 50%;
    -ms-transform-origin: 50%;
    transform-origin: 50%;
    -webkit-animation: swiper-preloader-spin 1s steps(12, end) infinite;
    animation: swiper-preloader-spin 1s steps(12, end) infinite;
  }
  .swiper-lazy-preloader:after {
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E");
    background-position: 50%;
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .swiper-lazy-preloader-white:after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E");
  }
  @-webkit-keyframes swiper-preloader-spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes swiper-preloader-spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  /* a11y */
  .swiper-container .swiper-notification {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    z-index: -1000;
  }
  .swiper-container-fade.swiper-container-free-mode .swiper-slide {
    -webkit-transition-timing-function: ease-out;
    -o-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
  }
  .swiper-container-fade .swiper-slide {
    pointer-events: none;
    -webkit-transition-property: opacity;
    -o-transition-property: opacity;
    transition-property: opacity;
  }
  .swiper-container-fade .swiper-slide .swiper-slide {
    pointer-events: none;
  }
  .swiper-container-fade .swiper-slide-active,
  .swiper-container-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto;
  }
  .swiper-container-cube {
    overflow: visible;
  }
  .swiper-container-cube .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1;
    visibility: hidden;
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    width: 100%;
    height: 100%;
  }
  .swiper-container-cube .swiper-slide .swiper-slide {
    pointer-events: none;
  }
  .swiper-container-cube.swiper-container-rtl .swiper-slide {
    -webkit-transform-origin: 100% 0;
    -ms-transform-origin: 100% 0;
    transform-origin: 100% 0;
  }
  .swiper-container-cube .swiper-slide-active,
  .swiper-container-cube .swiper-slide-active .swiper-slide-active {
    pointer-events: auto;
  }
  .swiper-container-cube .swiper-slide-active,
  .swiper-container-cube .swiper-slide-next,
  .swiper-container-cube .swiper-slide-prev,
  .swiper-container-cube .swiper-slide-next + .swiper-slide {
    pointer-events: auto;
    visibility: visible;
  }
  .swiper-container-cube .swiper-slide-shadow-top,
  .swiper-container-cube .swiper-slide-shadow-bottom,
  .swiper-container-cube .swiper-slide-shadow-left,
  .swiper-container-cube .swiper-slide-shadow-right {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .swiper-container-cube .swiper-cube-shadow {
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.6;
    -webkit-filter: blur(50px);
    filter: blur(50px);
    z-index: 0;
  }
  .swiper-container-flip {
    overflow: visible;
  }
  .swiper-container-flip .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1;
  }
  .swiper-container-flip .swiper-slide .swiper-slide {
    pointer-events: none;
  }
  .swiper-container-flip .swiper-slide-active,
  .swiper-container-flip .swiper-slide-active .swiper-slide-active {
    pointer-events: auto;
  }
  .swiper-container-flip .swiper-slide-shadow-top,
  .swiper-container-flip .swiper-slide-shadow-bottom,
  .swiper-container-flip .swiper-slide-shadow-left,
  .swiper-container-flip .swiper-slide-shadow-right {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .swiper-container-coverflow .swiper-wrapper {
    /* Windows 8 IE 10 fix */
    -ms-perspective: 1200px;
  }
`;

});

parcelRegister("cGmSK", function(module, exports) {
/**
 * Swiper 4.5.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: October 16, 2019
 */ !function(e, t) {
    module.exports = t();
}(module.exports, function() {
    'use strict';
    var m = 'undefined' == typeof document ? {
        body: {},
        addEventListener: function() {},
        removeEventListener: function() {},
        activeElement: {
            blur: function() {},
            nodeName: ''
        },
        querySelector: function() {
            return null;
        },
        querySelectorAll: function() {
            return [];
        },
        getElementById: function() {
            return null;
        },
        createEvent: function() {
            return {
                initEvent: function() {}
            };
        },
        createElement: function() {
            return {
                children: [],
                childNodes: [],
                style: {},
                setAttribute: function() {},
                getElementsByTagName: function() {
                    return [];
                }
            };
        },
        location: {
            hash: ''
        }
    } : document, ee = 'undefined' == typeof window ? {
        document: m,
        navigator: {
            userAgent: ''
        },
        location: {},
        history: {},
        CustomEvent: function() {
            return this;
        },
        addEventListener: function() {},
        removeEventListener: function() {},
        getComputedStyle: function() {
            return {
                getPropertyValue: function() {
                    return '';
                }
            };
        },
        Image: function() {},
        Date: function() {},
        screen: {},
        setTimeout: function() {},
        clearTimeout: function() {}
    } : window, l = function(e) {
        for(var t = 0; t < e.length; t += 1)this[t] = e[t];
        return this.length = e.length, this;
    };
    function L(e, t) {
        var a = [], i = 0;
        if (e && !t && e instanceof l) return e;
        if (e) {
            if ('string' == typeof e) {
                var s, r, n = e.trim();
                if (0 <= n.indexOf('<') && 0 <= n.indexOf('>')) {
                    var o = 'div';
                    for(0 === n.indexOf('<li') && (o = 'ul'), 0 === n.indexOf('<tr') && (o = 'tbody'), 0 !== n.indexOf('<td') && 0 !== n.indexOf('<th') || (o = 'tr'), 0 === n.indexOf('<tbody') && (o = 'table'), 0 === n.indexOf('<option') && (o = 'select'), (r = m.createElement(o)).innerHTML = n, i = 0; i < r.childNodes.length; i += 1)a.push(r.childNodes[i]);
                } else for(s = t || '#' !== e[0] || e.match(/[ .<>:~]/) ? (t || m).querySelectorAll(e.trim()) : [
                    m.getElementById(e.trim().split('#')[1])
                ], i = 0; i < s.length; i += 1)s[i] && a.push(s[i]);
            } else if (e.nodeType || e === ee || e === m) a.push(e);
            else if (0 < e.length && e[0].nodeType) for(i = 0; i < e.length; i += 1)a.push(e[i]);
        }
        return new l(a);
    }
    function r(e) {
        for(var t = [], a = 0; a < e.length; a += 1)-1 === t.indexOf(e[a]) && t.push(e[a]);
        return t;
    }
    L.fn = l.prototype, L.Class = l, L.Dom7 = l;
    var t = {
        addClass: function(e) {
            if (void 0 === e) return this;
            for(var t = e.split(' '), a = 0; a < t.length; a += 1)for(var i = 0; i < this.length; i += 1)void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.add(t[a]);
            return this;
        },
        removeClass: function(e) {
            for(var t = e.split(' '), a = 0; a < t.length; a += 1)for(var i = 0; i < this.length; i += 1)void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.remove(t[a]);
            return this;
        },
        hasClass: function(e) {
            return !!this[0] && this[0].classList.contains(e);
        },
        toggleClass: function(e) {
            for(var t = e.split(' '), a = 0; a < t.length; a += 1)for(var i = 0; i < this.length; i += 1)void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.toggle(t[a]);
            return this;
        },
        attr: function(e, t) {
            var a = arguments;
            if (1 === arguments.length && 'string' == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
            for(var i = 0; i < this.length; i += 1)if (2 === a.length) this[i].setAttribute(e, t);
            else for(var s in e)this[i][s] = e[s], this[i].setAttribute(s, e[s]);
            return this;
        },
        removeAttr: function(e) {
            for(var t = 0; t < this.length; t += 1)this[t].removeAttribute(e);
            return this;
        },
        data: function(e, t) {
            var a;
            if (void 0 !== t) {
                for(var i = 0; i < this.length; i += 1)(a = this[i]).dom7ElementDataStorage || (a.dom7ElementDataStorage = {}), a.dom7ElementDataStorage[e] = t;
                return this;
            }
            if (a = this[0]) {
                if (a.dom7ElementDataStorage && e in a.dom7ElementDataStorage) return a.dom7ElementDataStorage[e];
                var s = a.getAttribute('data-' + e);
                return s || void 0;
            }
        },
        transform: function(e) {
            for(var t = 0; t < this.length; t += 1){
                var a = this[t].style;
                a.webkitTransform = e, a.transform = e;
            }
            return this;
        },
        transition: function(e) {
            'string' != typeof e && (e += 'ms');
            for(var t = 0; t < this.length; t += 1){
                var a = this[t].style;
                a.webkitTransitionDuration = e, a.transitionDuration = e;
            }
            return this;
        },
        on: function() {
            for(var e, t = [], a = arguments.length; a--;)t[a] = arguments[a];
            var i = t[0], r = t[1], n = t[2], s = t[3];
            function o(e) {
                var t = e.target;
                if (t) {
                    var a = e.target.dom7EventData || [];
                    if (a.indexOf(e) < 0 && a.unshift(e), L(t).is(r)) n.apply(t, a);
                    else for(var i = L(t).parents(), s = 0; s < i.length; s += 1)L(i[s]).is(r) && n.apply(i[s], a);
                }
            }
            function l(e) {
                var t = e && e.target && e.target.dom7EventData || [];
                t.indexOf(e) < 0 && t.unshift(e), n.apply(this, t);
            }
            'function' == typeof t[1] && (i = (e = t)[0], n = e[1], s = e[2], r = void 0), s = s || !1;
            for(var d, p = i.split(' '), c = 0; c < this.length; c += 1){
                var u = this[c];
                if (r) for(d = 0; d < p.length; d += 1){
                    var h = p[d];
                    u.dom7LiveListeners || (u.dom7LiveListeners = {}), u.dom7LiveListeners[h] || (u.dom7LiveListeners[h] = []), u.dom7LiveListeners[h].push({
                        listener: n,
                        proxyListener: o
                    }), u.addEventListener(h, o, s);
                }
                else for(d = 0; d < p.length; d += 1){
                    var v = p[d];
                    u.dom7Listeners || (u.dom7Listeners = {}), u.dom7Listeners[v] || (u.dom7Listeners[v] = []), u.dom7Listeners[v].push({
                        listener: n,
                        proxyListener: l
                    }), u.addEventListener(v, l, s);
                }
            }
            return this;
        },
        off: function() {
            for(var e, t = [], a = arguments.length; a--;)t[a] = arguments[a];
            var i = t[0], s = t[1], r = t[2], n = t[3];
            'function' == typeof t[1] && (i = (e = t)[0], r = e[1], n = e[2], s = void 0), n = n || !1;
            for(var o = i.split(' '), l = 0; l < o.length; l += 1)for(var d = o[l], p = 0; p < this.length; p += 1){
                var c = this[p], u = void 0;
                if (!s && c.dom7Listeners ? u = c.dom7Listeners[d] : s && c.dom7LiveListeners && (u = c.dom7LiveListeners[d]), u && u.length) for(var h = u.length - 1; 0 <= h; h -= 1){
                    var v = u[h];
                    r && v.listener === r ? (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1)) : r && v.listener && v.listener.dom7proxy && v.listener.dom7proxy === r ? (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1)) : r || (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1));
                }
            }
            return this;
        },
        trigger: function() {
            for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
            for(var a = e[0].split(' '), i = e[1], s = 0; s < a.length; s += 1)for(var r = a[s], n = 0; n < this.length; n += 1){
                var o = this[n], l = void 0;
                try {
                    l = new ee.CustomEvent(r, {
                        detail: i,
                        bubbles: !0,
                        cancelable: !0
                    });
                } catch (e) {
                    (l = m.createEvent('Event')).initEvent(r, !0, !0), l.detail = i;
                }
                o.dom7EventData = e.filter(function(e, t) {
                    return 0 < t;
                }), o.dispatchEvent(l), o.dom7EventData = [], delete o.dom7EventData;
            }
            return this;
        },
        transitionEnd: function(t) {
            var a, i = [
                'webkitTransitionEnd',
                'transitionend'
            ], s = this;
            function r(e) {
                if (e.target === this) for(t.call(this, e), a = 0; a < i.length; a += 1)s.off(i[a], r);
            }
            if (t) for(a = 0; a < i.length; a += 1)s.on(i[a], r);
            return this;
        },
        outerWidth: function(e) {
            if (0 < this.length) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetWidth + parseFloat(t.getPropertyValue('margin-right')) + parseFloat(t.getPropertyValue('margin-left'));
                }
                return this[0].offsetWidth;
            }
            return null;
        },
        outerHeight: function(e) {
            if (0 < this.length) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetHeight + parseFloat(t.getPropertyValue('margin-top')) + parseFloat(t.getPropertyValue('margin-bottom'));
                }
                return this[0].offsetHeight;
            }
            return null;
        },
        offset: function() {
            if (0 < this.length) {
                var e = this[0], t = e.getBoundingClientRect(), a = m.body, i = e.clientTop || a.clientTop || 0, s = e.clientLeft || a.clientLeft || 0, r = e === ee ? ee.scrollY : e.scrollTop, n = e === ee ? ee.scrollX : e.scrollLeft;
                return {
                    top: t.top + r - i,
                    left: t.left + n - s
                };
            }
            return null;
        },
        css: function(e, t) {
            var a;
            if (1 === arguments.length) {
                if ('string' != typeof e) {
                    for(a = 0; a < this.length; a += 1)for(var i in e)this[a].style[i] = e[i];
                    return this;
                }
                if (this[0]) return ee.getComputedStyle(this[0], null).getPropertyValue(e);
            }
            if (2 !== arguments.length || 'string' != typeof e) return this;
            for(a = 0; a < this.length; a += 1)this[a].style[e] = t;
            return this;
        },
        each: function(e) {
            if (!e) return this;
            for(var t = 0; t < this.length; t += 1)if (!1 === e.call(this[t], t, this[t])) return this;
            return this;
        },
        html: function(e) {
            if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
            for(var t = 0; t < this.length; t += 1)this[t].innerHTML = e;
            return this;
        },
        text: function(e) {
            if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
            for(var t = 0; t < this.length; t += 1)this[t].textContent = e;
            return this;
        },
        is: function(e) {
            var t, a, i = this[0];
            if (!i || void 0 === e) return !1;
            if ('string' == typeof e) {
                if (i.matches) return i.matches(e);
                if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
                if (i.msMatchesSelector) return i.msMatchesSelector(e);
                for(t = L(e), a = 0; a < t.length; a += 1)if (t[a] === i) return !0;
                return !1;
            }
            if (e === m) return i === m;
            if (e === ee) return i === ee;
            if (e.nodeType || e instanceof l) {
                for(t = e.nodeType ? [
                    e
                ] : e, a = 0; a < t.length; a += 1)if (t[a] === i) return !0;
                return !1;
            }
            return !1;
        },
        index: function() {
            var e, t = this[0];
            if (t) {
                for(e = 0; null !== (t = t.previousSibling);)1 === t.nodeType && (e += 1);
                return e;
            }
        },
        eq: function(e) {
            if (void 0 === e) return this;
            var t, a = this.length;
            return new l(a - 1 < e ? [] : e < 0 ? (t = a + e) < 0 ? [] : [
                this[t]
            ] : [
                this[e]
            ]);
        },
        append: function() {
            for(var e, t = [], a = arguments.length; a--;)t[a] = arguments[a];
            for(var i = 0; i < t.length; i += 1){
                e = t[i];
                for(var s = 0; s < this.length; s += 1)if ('string' == typeof e) {
                    var r = m.createElement('div');
                    for(r.innerHTML = e; r.firstChild;)this[s].appendChild(r.firstChild);
                } else if (e instanceof l) for(var n = 0; n < e.length; n += 1)this[s].appendChild(e[n]);
                else this[s].appendChild(e);
            }
            return this;
        },
        prepend: function(e) {
            var t, a;
            for(t = 0; t < this.length; t += 1)if ('string' == typeof e) {
                var i = m.createElement('div');
                for(i.innerHTML = e, a = i.childNodes.length - 1; 0 <= a; a -= 1)this[t].insertBefore(i.childNodes[a], this[t].childNodes[0]);
            } else if (e instanceof l) for(a = 0; a < e.length; a += 1)this[t].insertBefore(e[a], this[t].childNodes[0]);
            else this[t].insertBefore(e, this[t].childNodes[0]);
            return this;
        },
        next: function(e) {
            return 0 < this.length ? e ? this[0].nextElementSibling && L(this[0].nextElementSibling).is(e) ? new l([
                this[0].nextElementSibling
            ]) : new l([]) : this[0].nextElementSibling ? new l([
                this[0].nextElementSibling
            ]) : new l([]) : new l([]);
        },
        nextAll: function(e) {
            var t = [], a = this[0];
            if (!a) return new l([]);
            for(; a.nextElementSibling;){
                var i = a.nextElementSibling;
                e ? L(i).is(e) && t.push(i) : t.push(i), a = i;
            }
            return new l(t);
        },
        prev: function(e) {
            if (0 < this.length) {
                var t = this[0];
                return e ? t.previousElementSibling && L(t.previousElementSibling).is(e) ? new l([
                    t.previousElementSibling
                ]) : new l([]) : t.previousElementSibling ? new l([
                    t.previousElementSibling
                ]) : new l([]);
            }
            return new l([]);
        },
        prevAll: function(e) {
            var t = [], a = this[0];
            if (!a) return new l([]);
            for(; a.previousElementSibling;){
                var i = a.previousElementSibling;
                e ? L(i).is(e) && t.push(i) : t.push(i), a = i;
            }
            return new l(t);
        },
        parent: function(e) {
            for(var t = [], a = 0; a < this.length; a += 1)null !== this[a].parentNode && (e ? L(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode));
            return L(r(t));
        },
        parents: function(e) {
            for(var t = [], a = 0; a < this.length; a += 1)for(var i = this[a].parentNode; i;)e ? L(i).is(e) && t.push(i) : t.push(i), i = i.parentNode;
            return L(r(t));
        },
        closest: function(e) {
            var t = this;
            return void 0 === e ? new l([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function(e) {
            for(var t = [], a = 0; a < this.length; a += 1)for(var i = this[a].querySelectorAll(e), s = 0; s < i.length; s += 1)t.push(i[s]);
            return new l(t);
        },
        children: function(e) {
            for(var t = [], a = 0; a < this.length; a += 1)for(var i = this[a].childNodes, s = 0; s < i.length; s += 1)e ? 1 === i[s].nodeType && L(i[s]).is(e) && t.push(i[s]) : 1 === i[s].nodeType && t.push(i[s]);
            return new l(r(t));
        },
        remove: function() {
            for(var e = 0; e < this.length; e += 1)this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            return this;
        },
        add: function() {
            for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
            var a, i;
            for(a = 0; a < e.length; a += 1){
                var s = L(e[a]);
                for(i = 0; i < s.length; i += 1)this[this.length] = s[i], this.length += 1;
            }
            return this;
        },
        styles: function() {
            return this[0] ? ee.getComputedStyle(this[0], null) : {};
        }
    };
    Object.keys(t).forEach(function(e) {
        L.fn[e] = L.fn[e] || t[e];
    });
    function e(e) {
        void 0 === e && (e = {});
        var t = this;
        t.params = e, t.eventsListeners = {}, t.params && t.params.on && Object.keys(t.params.on).forEach(function(e) {
            t.on(e, t.params.on[e]);
        });
    }
    var a, i, s, n, te = {
        deleteProps: function(e) {
            var t = e;
            Object.keys(t).forEach(function(e) {
                try {
                    t[e] = null;
                } catch (e) {}
                try {
                    delete t[e];
                } catch (e) {}
            });
        },
        nextTick: function(e, t) {
            return void 0 === t && (t = 0), setTimeout(e, t);
        },
        now: function() {
            return Date.now();
        },
        getTranslate: function(e, t) {
            var a, i, s;
            void 0 === t && (t = 'x');
            var r = ee.getComputedStyle(e, null);
            return ee.WebKitCSSMatrix ? (6 < (i = r.transform || r.webkitTransform).split(',').length && (i = i.split(', ').map(function(e) {
                return e.replace(',', '.');
            }).join(', ')), s = new ee.WebKitCSSMatrix('none' === i ? '' : i)) : a = (s = r.MozTransform || r.OTransform || r.MsTransform || r.msTransform || r.transform || r.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,')).toString().split(','), 'x' === t && (i = ee.WebKitCSSMatrix ? s.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])), 'y' === t && (i = ee.WebKitCSSMatrix ? s.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])), i || 0;
        },
        parseUrlQuery: function(e) {
            var t, a, i, s, r = {}, n = e || ee.location.href;
            if ('string' == typeof n && n.length) for(s = (a = (n = -1 < n.indexOf('?') ? n.replace(/\S*\?/, '') : '').split('&').filter(function(e) {
                return '' !== e;
            })).length, t = 0; t < s; t += 1)i = a[t].replace(/#\S+/g, '').split('='), r[decodeURIComponent(i[0])] = void 0 === i[1] ? void 0 : decodeURIComponent(i[1]) || '';
            return r;
        },
        isObject: function(e) {
            return 'object' == typeof e && null !== e && e.constructor && e.constructor === Object;
        },
        extend: function() {
            for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
            for(var a = Object(e[0]), i = 1; i < e.length; i += 1){
                var s = e[i];
                if (null != s) for(var r = Object.keys(Object(s)), n = 0, o = r.length; n < o; n += 1){
                    var l = r[n], d = Object.getOwnPropertyDescriptor(s, l);
                    void 0 !== d && d.enumerable && (te.isObject(a[l]) && te.isObject(s[l]) ? te.extend(a[l], s[l]) : !te.isObject(a[l]) && te.isObject(s[l]) ? (a[l] = {}, te.extend(a[l], s[l])) : a[l] = s[l]);
                }
            }
            return a;
        }
    }, ae = (s = m.createElement('div'), {
        touch: ee.Modernizr && !0 === ee.Modernizr.touch || !!(0 < ee.navigator.maxTouchPoints || 'ontouchstart' in ee || ee.DocumentTouch && m instanceof ee.DocumentTouch),
        pointerEvents: !!(ee.navigator.pointerEnabled || ee.PointerEvent || 'maxTouchPoints' in ee.navigator && 0 < ee.navigator.maxTouchPoints),
        prefixedPointerEvents: !!ee.navigator.msPointerEnabled,
        transition: (i = s.style, 'transition' in i || 'webkitTransition' in i || 'MozTransition' in i),
        transforms3d: ee.Modernizr && !0 === ee.Modernizr.csstransforms3d || (a = s.style, 'webkitPerspective' in a || 'MozPerspective' in a || 'OPerspective' in a || 'MsPerspective' in a || 'perspective' in a),
        flexbox: function() {
            for(var e = s.style, t = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' '), a = 0; a < t.length; a += 1)if (t[a] in e) return !0;
            return !1;
        }(),
        observer: 'MutationObserver' in ee || 'WebkitMutationObserver' in ee,
        passiveListener: function() {
            var e = !1;
            try {
                var t = Object.defineProperty({}, 'passive', {
                    get: function() {
                        e = !0;
                    }
                });
                ee.addEventListener('testPassiveListener', null, t);
            } catch (e) {}
            return e;
        }(),
        gestures: 'ongesturestart' in ee
    }), ie = {
        isIE: !!ee.navigator.userAgent.match(/Trident/g) || !!ee.navigator.userAgent.match(/MSIE/g),
        isEdge: !!ee.navigator.userAgent.match(/Edge/g),
        isSafari: (n = ee.navigator.userAgent.toLowerCase(), 0 <= n.indexOf('safari') && n.indexOf('chrome') < 0 && n.indexOf('android') < 0),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ee.navigator.userAgent)
    }, o = {
        components: {
            configurable: !0
        }
    };
    e.prototype.on = function(e, t, a) {
        var i = this;
        if ('function' != typeof t) return i;
        var s = a ? 'unshift' : 'push';
        return e.split(' ').forEach(function(e) {
            i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][s](t);
        }), i;
    }, e.prototype.once = function(a, i, e) {
        var s = this;
        if ('function' != typeof i) return s;
        function r() {
            for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
            i.apply(s, e), s.off(a, r), r.f7proxy && delete r.f7proxy;
        }
        return r.f7proxy = i, s.on(a, r, e);
    }, e.prototype.off = function(e, i) {
        var s = this;
        return s.eventsListeners && e.split(' ').forEach(function(a) {
            void 0 === i ? s.eventsListeners[a] = [] : s.eventsListeners[a] && s.eventsListeners[a].length && s.eventsListeners[a].forEach(function(e, t) {
                (e === i || e.f7proxy && e.f7proxy === i) && s.eventsListeners[a].splice(t, 1);
            });
        }), s;
    }, e.prototype.emit = function() {
        for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
        var a, i, s, r = this;
        return r.eventsListeners && (s = 'string' == typeof e[0] || Array.isArray(e[0]) ? (a = e[0], i = e.slice(1, e.length), r) : (a = e[0].events, i = e[0].data, e[0].context || r), (Array.isArray(a) ? a : a.split(' ')).forEach(function(e) {
            if (r.eventsListeners && r.eventsListeners[e]) {
                var t = [];
                r.eventsListeners[e].forEach(function(e) {
                    t.push(e);
                }), t.forEach(function(e) {
                    e.apply(s, i);
                });
            }
        })), r;
    }, e.prototype.useModulesParams = function(a) {
        var i = this;
        i.modules && Object.keys(i.modules).forEach(function(e) {
            var t = i.modules[e];
            t.params && te.extend(a, t.params);
        });
    }, e.prototype.useModules = function(i) {
        void 0 === i && (i = {});
        var s = this;
        s.modules && Object.keys(s.modules).forEach(function(e) {
            var a = s.modules[e], t = i[e] || {};
            a.instance && Object.keys(a.instance).forEach(function(e) {
                var t = a.instance[e];
                s[e] = 'function' == typeof t ? t.bind(s) : t;
            }), a.on && s.on && Object.keys(a.on).forEach(function(e) {
                s.on(e, a.on[e]);
            }), a.create && a.create.bind(s)(t);
        });
    }, o.components.set = function(e) {
        this.use && this.use(e);
    }, e.installModule = function(t) {
        for(var e = [], a = arguments.length - 1; 0 < a--;)e[a] = arguments[a + 1];
        var i = this;
        i.prototype.modules || (i.prototype.modules = {});
        var s = t.name || Object.keys(i.prototype.modules).length + '_' + te.now();
        return (i.prototype.modules[s] = t).proto && Object.keys(t.proto).forEach(function(e) {
            i.prototype[e] = t.proto[e];
        }), t.static && Object.keys(t.static).forEach(function(e) {
            i[e] = t.static[e];
        }), t.install && t.install.apply(i, e), i;
    }, e.use = function(e) {
        for(var t = [], a = arguments.length - 1; 0 < a--;)t[a] = arguments[a + 1];
        var i = this;
        return Array.isArray(e) ? (e.forEach(function(e) {
            return i.installModule(e);
        }), i) : i.installModule.apply(i, [
            e
        ].concat(t));
    }, Object.defineProperties(e, o);
    var d = {
        updateSize: function() {
            var e, t, a = this, i = a.$el;
            e = void 0 !== a.params.width ? a.params.width : i[0].clientWidth, t = void 0 !== a.params.height ? a.params.height : i[0].clientHeight, 0 === e && a.isHorizontal() || 0 === t && a.isVertical() || (e = e - parseInt(i.css('padding-left'), 10) - parseInt(i.css('padding-right'), 10), t = t - parseInt(i.css('padding-top'), 10) - parseInt(i.css('padding-bottom'), 10), te.extend(a, {
                width: e,
                height: t,
                size: a.isHorizontal() ? e : t
            }));
        },
        updateSlides: function() {
            var e = this, t = e.params, a = e.$wrapperEl, i = e.size, s = e.rtlTranslate, r = e.wrongRTL, n = e.virtual && t.virtual.enabled, o = n ? e.virtual.slides.length : e.slides.length, l = a.children('.' + e.params.slideClass), d = n ? e.virtual.slides.length : l.length, p = [], c = [], u = [], h = t.slidesOffsetBefore;
            'function' == typeof h && (h = t.slidesOffsetBefore.call(e));
            var v = t.slidesOffsetAfter;
            'function' == typeof v && (v = t.slidesOffsetAfter.call(e));
            var f = e.snapGrid.length, m = e.snapGrid.length, g = t.spaceBetween, b = -h, w = 0, y = 0;
            if (void 0 !== i) {
                var x, T;
                'string' == typeof g && 0 <= g.indexOf('%') && (g = parseFloat(g.replace('%', '')) / 100 * i), e.virtualSize = -g, s ? l.css({
                    marginLeft: '',
                    marginTop: ''
                }) : l.css({
                    marginRight: '',
                    marginBottom: ''
                }), 1 < t.slidesPerColumn && (x = Math.floor(d / t.slidesPerColumn) === d / e.params.slidesPerColumn ? d : Math.ceil(d / t.slidesPerColumn) * t.slidesPerColumn, 'auto' !== t.slidesPerView && 'row' === t.slidesPerColumnFill && (x = Math.max(x, t.slidesPerView * t.slidesPerColumn)));
                for(var E, S = t.slidesPerColumn, C = x / S, M = Math.floor(d / t.slidesPerColumn), P = 0; P < d; P += 1){
                    T = 0;
                    var k = l.eq(P);
                    if (1 < t.slidesPerColumn) {
                        var z = void 0, $ = void 0, L = void 0;
                        if ('column' === t.slidesPerColumnFill || 'row' === t.slidesPerColumnFill && 1 < t.slidesPerGroup) {
                            if ('column' === t.slidesPerColumnFill) L = P - ($ = Math.floor(P / S)) * S, (M < $ || $ === M && L === S - 1) && S <= (L += 1) && (L = 0, $ += 1);
                            else {
                                var I = Math.floor(P / t.slidesPerGroup);
                                $ = P - (L = Math.floor(P / t.slidesPerView) - I * t.slidesPerColumn) * t.slidesPerView - I * t.slidesPerView;
                            }
                            z = $ + L * x / S, k.css({
                                '-webkit-box-ordinal-group': z,
                                '-moz-box-ordinal-group': z,
                                '-ms-flex-order': z,
                                '-webkit-order': z,
                                order: z
                            });
                        } else $ = P - (L = Math.floor(P / C)) * C;
                        k.css('margin-' + (e.isHorizontal() ? 'top' : 'left'), 0 !== L && t.spaceBetween && t.spaceBetween + 'px').attr('data-swiper-column', $).attr('data-swiper-row', L);
                    }
                    if ('none' !== k.css('display')) {
                        if ('auto' === t.slidesPerView) {
                            var D = ee.getComputedStyle(k[0], null), O = k[0].style.transform, A = k[0].style.webkitTransform;
                            if (O && (k[0].style.transform = 'none'), A && (k[0].style.webkitTransform = 'none'), t.roundLengths) T = e.isHorizontal() ? k.outerWidth(!0) : k.outerHeight(!0);
                            else if (e.isHorizontal()) {
                                var H = parseFloat(D.getPropertyValue('width')), G = parseFloat(D.getPropertyValue('padding-left')), N = parseFloat(D.getPropertyValue('padding-right')), B = parseFloat(D.getPropertyValue('margin-left')), X = parseFloat(D.getPropertyValue('margin-right')), V = D.getPropertyValue('box-sizing');
                                T = V && 'border-box' === V && !ie.isIE ? H + B + X : H + G + N + B + X;
                            } else {
                                var Y = parseFloat(D.getPropertyValue('height')), F = parseFloat(D.getPropertyValue('padding-top')), R = parseFloat(D.getPropertyValue('padding-bottom')), q = parseFloat(D.getPropertyValue('margin-top')), W = parseFloat(D.getPropertyValue('margin-bottom')), j = D.getPropertyValue('box-sizing');
                                T = j && 'border-box' === j && !ie.isIE ? Y + q + W : Y + F + R + q + W;
                            }
                            O && (k[0].style.transform = O), A && (k[0].style.webkitTransform = A), t.roundLengths && (T = Math.floor(T));
                        } else T = (i - (t.slidesPerView - 1) * g) / t.slidesPerView, t.roundLengths && (T = Math.floor(T)), l[P] && (e.isHorizontal() ? l[P].style.width = T + 'px' : l[P].style.height = T + 'px');
                        l[P] && (l[P].swiperSlideSize = T), u.push(T), t.centeredSlides ? (b = b + T / 2 + w / 2 + g, 0 === w && 0 !== P && (b = b - i / 2 - g), 0 === P && (b = b - i / 2 - g), Math.abs(b) < 0.001 && (b = 0), t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b)) : (t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b), b = b + T + g), e.virtualSize += T + g, w = T, y += 1;
                    }
                }
                if (e.virtualSize = Math.max(e.virtualSize, i) + v, s && r && ('slide' === t.effect || 'coverflow' === t.effect) && a.css({
                    width: e.virtualSize + t.spaceBetween + 'px'
                }), ae.flexbox && !t.setWrapperSize || (e.isHorizontal() ? a.css({
                    width: e.virtualSize + t.spaceBetween + 'px'
                }) : a.css({
                    height: e.virtualSize + t.spaceBetween + 'px'
                })), 1 < t.slidesPerColumn && (e.virtualSize = (T + t.spaceBetween) * x, e.virtualSize = Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween, e.isHorizontal() ? a.css({
                    width: e.virtualSize + t.spaceBetween + 'px'
                }) : a.css({
                    height: e.virtualSize + t.spaceBetween + 'px'
                }), t.centeredSlides)) {
                    E = [];
                    for(var U = 0; U < p.length; U += 1){
                        var K = p[U];
                        t.roundLengths && (K = Math.floor(K)), p[U] < e.virtualSize + p[0] && E.push(K);
                    }
                    p = E;
                }
                if (!t.centeredSlides) {
                    E = [];
                    for(var _ = 0; _ < p.length; _ += 1){
                        var Z = p[_];
                        t.roundLengths && (Z = Math.floor(Z)), p[_] <= e.virtualSize - i && E.push(Z);
                    }
                    p = E, 1 < Math.floor(e.virtualSize - i) - Math.floor(p[p.length - 1]) && p.push(e.virtualSize - i);
                }
                if (0 === p.length && (p = [
                    0
                ]), 0 !== t.spaceBetween && (e.isHorizontal() ? s ? l.css({
                    marginLeft: g + 'px'
                }) : l.css({
                    marginRight: g + 'px'
                }) : l.css({
                    marginBottom: g + 'px'
                })), t.centerInsufficientSlides) {
                    var Q = 0;
                    if (u.forEach(function(e) {
                        Q += e + (t.spaceBetween ? t.spaceBetween : 0);
                    }), (Q -= t.spaceBetween) < i) {
                        var J = (i - Q) / 2;
                        p.forEach(function(e, t) {
                            p[t] = e - J;
                        }), c.forEach(function(e, t) {
                            c[t] = e + J;
                        });
                    }
                }
                te.extend(e, {
                    slides: l,
                    snapGrid: p,
                    slidesGrid: c,
                    slidesSizesGrid: u
                }), d !== o && e.emit('slidesLengthChange'), p.length !== f && (e.params.watchOverflow && e.checkOverflow(), e.emit('snapGridLengthChange')), c.length !== m && e.emit('slidesGridLengthChange'), (t.watchSlidesProgress || t.watchSlidesVisibility) && e.updateSlidesOffset();
            }
        },
        updateAutoHeight: function(e) {
            var t, a = this, i = [], s = 0;
            if ('number' == typeof e ? a.setTransition(e) : !0 === e && a.setTransition(a.params.speed), 'auto' !== a.params.slidesPerView && 1 < a.params.slidesPerView) for(t = 0; t < Math.ceil(a.params.slidesPerView); t += 1){
                var r = a.activeIndex + t;
                if (r > a.slides.length) break;
                i.push(a.slides.eq(r)[0]);
            }
            else i.push(a.slides.eq(a.activeIndex)[0]);
            for(t = 0; t < i.length; t += 1)if (void 0 !== i[t]) {
                var n = i[t].offsetHeight;
                s = s < n ? n : s;
            }
            s && a.$wrapperEl.css('height', s + 'px');
        },
        updateSlidesOffset: function() {
            for(var e = this.slides, t = 0; t < e.length; t += 1)e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop;
        },
        updateSlidesProgress: function(e) {
            var t = this, a = t.params;
            void 0 === e && (e = t && t.translate || 0);
            var i = t.slides, s = t.rtlTranslate;
            if (0 !== i.length) {
                void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
                var r = -e;
                s && (r = e), i.removeClass(a.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
                for(var n = 0; n < i.length; n += 1){
                    var o = i[n], l = (r + (a.centeredSlides ? t.minTranslate() : 0) - o.swiperSlideOffset) / (o.swiperSlideSize + a.spaceBetween);
                    if (a.watchSlidesVisibility) {
                        var d = -(r - o.swiperSlideOffset), p = d + t.slidesSizesGrid[n];
                        (0 <= d && d < t.size - 1 || 1 < p && p <= t.size || d <= 0 && p >= t.size) && (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(n), i.eq(n).addClass(a.slideVisibleClass));
                    }
                    o.progress = s ? -l : l;
                }
                t.visibleSlides = L(t.visibleSlides);
            }
        },
        updateProgress: function(e) {
            var t = this, a = t.params;
            if (void 0 === e) {
                var i = t.rtlTranslate ? -1 : 1;
                e = t && t.translate && t.translate * i || 0;
            }
            var s = t.maxTranslate() - t.minTranslate(), r = t.progress, n = t.isBeginning, o = t.isEnd, l = n, d = o;
            o = 0 == s ? n = (r = 0, true) : (n = (r = (e - t.minTranslate()) / s) <= 0, 1 <= r), te.extend(t, {
                progress: r,
                isBeginning: n,
                isEnd: o
            }), (a.watchSlidesProgress || a.watchSlidesVisibility) && t.updateSlidesProgress(e), n && !l && t.emit('reachBeginning toEdge'), o && !d && t.emit('reachEnd toEdge'), (l && !n || d && !o) && t.emit('fromEdge'), t.emit('progress', r);
        },
        updateSlidesClasses: function() {
            var e, t = this, a = t.slides, i = t.params, s = t.$wrapperEl, r = t.activeIndex, n = t.realIndex, o = t.virtual && i.virtual.enabled;
            a.removeClass(i.slideActiveClass + ' ' + i.slideNextClass + ' ' + i.slidePrevClass + ' ' + i.slideDuplicateActiveClass + ' ' + i.slideDuplicateNextClass + ' ' + i.slideDuplicatePrevClass), (e = o ? t.$wrapperEl.find('.' + i.slideClass + '[data-swiper-slide-index="' + r + '"]') : a.eq(r)).addClass(i.slideActiveClass), i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children('.' + i.slideClass + ':not(.' + i.slideDuplicateClass + ')[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass) : s.children('.' + i.slideClass + '.' + i.slideDuplicateClass + '[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass));
            var l = e.nextAll('.' + i.slideClass).eq(0).addClass(i.slideNextClass);
            i.loop && 0 === l.length && (l = a.eq(0)).addClass(i.slideNextClass);
            var d = e.prevAll('.' + i.slideClass).eq(0).addClass(i.slidePrevClass);
            i.loop && 0 === d.length && (d = a.eq(-1)).addClass(i.slidePrevClass), i.loop && (l.hasClass(i.slideDuplicateClass) ? s.children('.' + i.slideClass + ':not(.' + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr('data-swiper-slide-index') + '"]').addClass(i.slideDuplicateNextClass) : s.children('.' + i.slideClass + '.' + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr('data-swiper-slide-index') + '"]').addClass(i.slideDuplicateNextClass), d.hasClass(i.slideDuplicateClass) ? s.children('.' + i.slideClass + ':not(.' + i.slideDuplicateClass + ')[data-swiper-slide-index="' + d.attr('data-swiper-slide-index') + '"]').addClass(i.slideDuplicatePrevClass) : s.children('.' + i.slideClass + '.' + i.slideDuplicateClass + '[data-swiper-slide-index="' + d.attr('data-swiper-slide-index') + '"]').addClass(i.slideDuplicatePrevClass));
        },
        updateActiveIndex: function(e) {
            var t, a = this, i = a.rtlTranslate ? a.translate : -a.translate, s = a.slidesGrid, r = a.snapGrid, n = a.params, o = a.activeIndex, l = a.realIndex, d = a.snapIndex, p = e;
            if (void 0 === p) {
                for(var c = 0; c < s.length; c += 1)void 0 !== s[c + 1] ? i >= s[c] && i < s[c + 1] - (s[c + 1] - s[c]) / 2 ? p = c : i >= s[c] && i < s[c + 1] && (p = c + 1) : i >= s[c] && (p = c);
                n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
            }
            if ((t = 0 <= r.indexOf(i) ? r.indexOf(i) : Math.floor(p / n.slidesPerGroup)) >= r.length && (t = r.length - 1), p !== o) {
                var u = parseInt(a.slides.eq(p).attr('data-swiper-slide-index') || p, 10);
                te.extend(a, {
                    snapIndex: t,
                    realIndex: u,
                    previousIndex: o,
                    activeIndex: p
                }), a.emit('activeIndexChange'), a.emit('snapIndexChange'), l !== u && a.emit('realIndexChange'), (a.initialized || a.runCallbacksOnInit) && a.emit('slideChange');
            } else t !== d && (a.snapIndex = t, a.emit('snapIndexChange'));
        },
        updateClickedSlide: function(e) {
            var t = this, a = t.params, i = L(e.target).closest('.' + a.slideClass)[0], s = !1;
            if (i) for(var r = 0; r < t.slides.length; r += 1)t.slides[r] === i && (s = !0);
            if (!i || !s) return t.clickedSlide = void 0, void (t.clickedIndex = void 0);
            t.clickedSlide = i, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(L(i).attr('data-swiper-slide-index'), 10) : t.clickedIndex = L(i).index(), a.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
        }
    };
    var p = {
        getTranslate: function(e) {
            void 0 === e && (e = this.isHorizontal() ? 'x' : 'y');
            var t = this.params, a = this.rtlTranslate, i = this.translate, s = this.$wrapperEl;
            if (t.virtualTranslate) return a ? -i : i;
            var r = te.getTranslate(s[0], e);
            return a && (r = -r), r || 0;
        },
        setTranslate: function(e, t) {
            var a = this, i = a.rtlTranslate, s = a.params, r = a.$wrapperEl, n = a.progress, o = 0, l = 0;
            a.isHorizontal() ? o = i ? -e : e : l = e, s.roundLengths && (o = Math.floor(o), l = Math.floor(l)), s.virtualTranslate || (ae.transforms3d ? r.transform('translate3d(' + o + 'px, ' + l + 'px, 0px)') : r.transform('translate(' + o + 'px, ' + l + 'px)')), a.previousTranslate = a.translate, a.translate = a.isHorizontal() ? o : l;
            var d = a.maxTranslate() - a.minTranslate();
            (0 == d ? 0 : (e - a.minTranslate()) / d) !== n && a.updateProgress(e), a.emit('setTranslate', a.translate, t);
        },
        minTranslate: function() {
            return -this.snapGrid[0];
        },
        maxTranslate: function() {
            return -this.snapGrid[this.snapGrid.length - 1];
        }
    };
    var c = {
        setTransition: function(e, t) {
            this.$wrapperEl.transition(e), this.emit('setTransition', e, t);
        },
        transitionStart: function(e, t) {
            void 0 === e && (e = !0);
            var a = this, i = a.activeIndex, s = a.params, r = a.previousIndex;
            s.autoHeight && a.updateAutoHeight();
            var n = t;
            if (n = n || (r < i ? 'next' : i < r ? 'prev' : 'reset'), a.emit('transitionStart'), e && i !== r) {
                if ('reset' === n) return void a.emit('slideResetTransitionStart');
                a.emit('slideChangeTransitionStart'), 'next' === n ? a.emit('slideNextTransitionStart') : a.emit('slidePrevTransitionStart');
            }
        },
        transitionEnd: function(e, t) {
            void 0 === e && (e = !0);
            var a = this, i = a.activeIndex, s = a.previousIndex;
            a.animating = !1, a.setTransition(0);
            var r = t;
            if (r = r || (s < i ? 'next' : i < s ? 'prev' : 'reset'), a.emit('transitionEnd'), e && i !== s) {
                if ('reset' === r) return void a.emit('slideResetTransitionEnd');
                a.emit('slideChangeTransitionEnd'), 'next' === r ? a.emit('slideNextTransitionEnd') : a.emit('slidePrevTransitionEnd');
            }
        }
    };
    var u = {
        slideTo: function(e, t, a, i) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
            var s = this, r = e;
            r < 0 && (r = 0);
            var n = s.params, o = s.snapGrid, l = s.slidesGrid, d = s.previousIndex, p = s.activeIndex, c = s.rtlTranslate;
            if (s.animating && n.preventInteractionOnTransition) return !1;
            var u = Math.floor(r / n.slidesPerGroup);
            u >= o.length && (u = o.length - 1), (p || n.initialSlide || 0) === (d || 0) && a && s.emit('beforeSlideChangeStart');
            var h, v = -o[u];
            if (s.updateProgress(v), n.normalizeSlideIndex) for(var f = 0; f < l.length; f += 1)-Math.floor(100 * v) >= Math.floor(100 * l[f]) && (r = f);
            if (s.initialized && r !== p) {
                if (!s.allowSlideNext && v < s.translate && v < s.minTranslate()) return !1;
                if (!s.allowSlidePrev && v > s.translate && v > s.maxTranslate() && (p || 0) !== r) return !1;
            }
            return h = p < r ? 'next' : r < p ? 'prev' : 'reset', c && -v === s.translate || !c && v === s.translate ? (s.updateActiveIndex(r), n.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), 'slide' !== n.effect && s.setTranslate(v), 'reset' !== h && (s.transitionStart(a, h), s.transitionEnd(a, h)), !1) : (0 !== t && ae.transition ? (s.setTransition(t), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit('beforeTransitionStart', t, i), s.transitionStart(a, h), s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function(e) {
                s && !s.destroyed && e.target === this && (s.$wrapperEl[0].removeEventListener('transitionend', s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener('webkitTransitionEnd', s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(a, h));
            }), s.$wrapperEl[0].addEventListener('transitionend', s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener('webkitTransitionEnd', s.onSlideToWrapperTransitionEnd))) : (s.setTransition(0), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit('beforeTransitionStart', t, i), s.transitionStart(a, h), s.transitionEnd(a, h)), !0);
        },
        slideToLoop: function(e, t, a, i) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
            var s = e;
            return this.params.loop && (s += this.loopedSlides), this.slideTo(s, t, a, i);
        },
        slideNext: function(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this, s = i.params, r = i.animating;
            return s.loop ? !r && (i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft, i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a)) : i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a);
        },
        slidePrev: function(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this, s = i.params, r = i.animating, n = i.snapGrid, o = i.slidesGrid, l = i.rtlTranslate;
            if (s.loop) {
                if (r) return !1;
                i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft;
            }
            function d(e) {
                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            var p, c = d(l ? i.translate : -i.translate), u = n.map(function(e) {
                return d(e);
            }), h = (o.map(function(e) {
                return d(e);
            }), n[u.indexOf(c)], n[u.indexOf(c) - 1]);
            return void 0 !== h && (p = o.indexOf(h)) < 0 && (p = i.activeIndex - 1), i.slideTo(p, e, t, a);
        },
        slideReset: function(e, t, a) {
            return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, a);
        },
        slideToClosest: function(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this, s = i.activeIndex, r = Math.floor(s / i.params.slidesPerGroup);
            if (r < i.snapGrid.length - 1) {
                var n = i.rtlTranslate ? i.translate : -i.translate, o = i.snapGrid[r];
                (i.snapGrid[r + 1] - o) / 2 < n - o && (s = i.params.slidesPerGroup);
            }
            return i.slideTo(s, e, t, a);
        },
        slideToClickedSlide: function() {
            var e, t = this, a = t.params, i = t.$wrapperEl, s = 'auto' === a.slidesPerView ? t.slidesPerViewDynamic() : a.slidesPerView, r = t.clickedIndex;
            if (a.loop) {
                if (t.animating) return;
                e = parseInt(L(t.clickedSlide).attr('data-swiper-slide-index'), 10), a.centeredSlides ? r < t.loopedSlides - s / 2 || r > t.slides.length - t.loopedSlides + s / 2 ? (t.loopFix(), r = i.children('.' + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ')').eq(0).index(), te.nextTick(function() {
                    t.slideTo(r);
                })) : t.slideTo(r) : r > t.slides.length - s ? (t.loopFix(), r = i.children('.' + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ')').eq(0).index(), te.nextTick(function() {
                    t.slideTo(r);
                })) : t.slideTo(r);
            } else t.slideTo(r);
        }
    };
    var h = {
        loopCreate: function() {
            var i = this, e = i.params, t = i.$wrapperEl;
            t.children('.' + e.slideClass + '.' + e.slideDuplicateClass).remove();
            var s = t.children('.' + e.slideClass);
            if (e.loopFillGroupWithBlank) {
                var a = e.slidesPerGroup - s.length % e.slidesPerGroup;
                if (a !== e.slidesPerGroup) {
                    for(var r = 0; r < a; r += 1){
                        var n = L(m.createElement('div')).addClass(e.slideClass + ' ' + e.slideBlankClass);
                        t.append(n);
                    }
                    s = t.children('.' + e.slideClass);
                }
            }
            'auto' !== e.slidesPerView || e.loopedSlides || (e.loopedSlides = s.length), i.loopedSlides = parseInt(e.loopedSlides || e.slidesPerView, 10), i.loopedSlides += e.loopAdditionalSlides, i.loopedSlides > s.length && (i.loopedSlides = s.length);
            var o = [], l = [];
            s.each(function(e, t) {
                var a = L(t);
                e < i.loopedSlides && l.push(t), e < s.length && e >= s.length - i.loopedSlides && o.push(t), a.attr('data-swiper-slide-index', e);
            });
            for(var d = 0; d < l.length; d += 1)t.append(L(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));
            for(var p = o.length - 1; 0 <= p; p -= 1)t.prepend(L(o[p].cloneNode(!0)).addClass(e.slideDuplicateClass));
        },
        loopFix: function() {
            var e, t = this, a = t.params, i = t.activeIndex, s = t.slides, r = t.loopedSlides, n = t.allowSlidePrev, o = t.allowSlideNext, l = t.snapGrid, d = t.rtlTranslate;
            t.allowSlidePrev = !0, t.allowSlideNext = !0;
            var p = -l[i] - t.getTranslate();
            if (i < r) e = s.length - 3 * r + i, e += r, t.slideTo(e, 0, !1, !0) && 0 != p && t.setTranslate((d ? -t.translate : t.translate) - p);
            else if ('auto' === a.slidesPerView && 2 * r <= i || i >= s.length - r) e = -s.length + i + r, e += r, t.slideTo(e, 0, !1, !0) && 0 != p && t.setTranslate((d ? -t.translate : t.translate) - p);
            t.allowSlidePrev = n, t.allowSlideNext = o;
        },
        loopDestroy: function() {
            var e = this.$wrapperEl, t = this.params, a = this.slides;
            e.children('.' + t.slideClass + '.' + t.slideDuplicateClass + ',.' + t.slideClass + '.' + t.slideBlankClass).remove(), a.removeAttr('data-swiper-slide-index');
        }
    };
    var v = {
        setGrabCursor: function(e) {
            if (!(ae.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked)) {
                var t = this.el;
                t.style.cursor = 'move', t.style.cursor = e ? '-webkit-grabbing' : '-webkit-grab', t.style.cursor = e ? '-moz-grabbin' : '-moz-grab', t.style.cursor = e ? 'grabbing' : 'grab';
            }
        },
        unsetGrabCursor: function() {
            ae.touch || this.params.watchOverflow && this.isLocked || (this.el.style.cursor = '');
        }
    };
    var f = {
        appendSlide: function(e) {
            var t = this, a = t.$wrapperEl, i = t.params;
            if (i.loop && t.loopDestroy(), 'object' == typeof e && 'length' in e) for(var s = 0; s < e.length; s += 1)e[s] && a.append(e[s]);
            else a.append(e);
            i.loop && t.loopCreate(), i.observer && ae.observer || t.update();
        },
        prependSlide: function(e) {
            var t = this, a = t.params, i = t.$wrapperEl, s = t.activeIndex;
            a.loop && t.loopDestroy();
            var r = s + 1;
            if ('object' == typeof e && 'length' in e) {
                for(var n = 0; n < e.length; n += 1)e[n] && i.prepend(e[n]);
                r = s + e.length;
            } else i.prepend(e);
            a.loop && t.loopCreate(), a.observer && ae.observer || t.update(), t.slideTo(r, 0, !1);
        },
        addSlide: function(e, t) {
            var a = this, i = a.$wrapperEl, s = a.params, r = a.activeIndex;
            s.loop && (r -= a.loopedSlides, a.loopDestroy(), a.slides = i.children('.' + s.slideClass));
            var n = a.slides.length;
            if (e <= 0) a.prependSlide(t);
            else if (n <= e) a.appendSlide(t);
            else {
                for(var o = e < r ? r + 1 : r, l = [], d = n - 1; e <= d; d -= 1){
                    var p = a.slides.eq(d);
                    p.remove(), l.unshift(p);
                }
                if ('object' == typeof t && 'length' in t) {
                    for(var c = 0; c < t.length; c += 1)t[c] && i.append(t[c]);
                    o = e < r ? r + t.length : r;
                } else i.append(t);
                for(var u = 0; u < l.length; u += 1)i.append(l[u]);
                s.loop && a.loopCreate(), s.observer && ae.observer || a.update(), s.loop ? a.slideTo(o + a.loopedSlides, 0, !1) : a.slideTo(o, 0, !1);
            }
        },
        removeSlide: function(e) {
            var t = this, a = t.params, i = t.$wrapperEl, s = t.activeIndex;
            a.loop && (s -= t.loopedSlides, t.loopDestroy(), t.slides = i.children('.' + a.slideClass));
            var r, n = s;
            if ('object' == typeof e && 'length' in e) {
                for(var o = 0; o < e.length; o += 1)r = e[o], t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1);
                n = Math.max(n, 0);
            } else r = e, t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1), n = Math.max(n, 0);
            a.loop && t.loopCreate(), a.observer && ae.observer || t.update(), a.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
        },
        removeAllSlides: function() {
            for(var e = [], t = 0; t < this.slides.length; t += 1)e.push(t);
            this.removeSlide(e);
        }
    }, g = function() {
        var e = ee.navigator.userAgent, t = {
            ios: !1,
            android: !1,
            androidChrome: !1,
            desktop: !1,
            windows: !1,
            iphone: !1,
            ipod: !1,
            ipad: !1,
            cordova: ee.cordova || ee.phonegap,
            phonegap: ee.cordova || ee.phonegap
        }, a = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/), i = e.match(/(Android);?[\s\/]+([\d.]+)?/), s = e.match(/(iPad).*OS\s([\d_]+)/), r = e.match(/(iPod)(.*OS\s([\d_]+))?/), n = !s && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
        if (a && (t.os = 'windows', t.osVersion = a[2], t.windows = !0), i && !a && (t.os = 'android', t.osVersion = i[2], t.android = !0, t.androidChrome = 0 <= e.toLowerCase().indexOf('chrome')), (s || n || r) && (t.os = 'ios', t.ios = !0), n && !r && (t.osVersion = n[2].replace(/_/g, '.'), t.iphone = !0), s && (t.osVersion = s[2].replace(/_/g, '.'), t.ipad = !0), r && (t.osVersion = r[3] ? r[3].replace(/_/g, '.') : null, t.iphone = !0), t.ios && t.osVersion && 0 <= e.indexOf('Version/') && '10' === t.osVersion.split('.')[0] && (t.osVersion = e.toLowerCase().split('version/')[1].split(' ')[0]), t.desktop = !(t.os || t.android || t.webView), t.webView = (n || s || r) && e.match(/.*AppleWebKit(?!.*Safari)/i), t.os && 'ios' === t.os) {
            var o = t.osVersion.split('.'), l = m.querySelector('meta[name="viewport"]');
            t.minimalUi = !t.webView && (r || n) && (1 * o[0] == 7 ? 1 <= 1 * o[1] : 7 < 1 * o[0]) && l && 0 <= l.getAttribute('content').indexOf('minimal-ui');
        }
        return t.pixelRatio = ee.devicePixelRatio || 1, t;
    }();
    function b() {
        var e = this, t = e.params, a = e.el;
        if (!a || 0 !== a.offsetWidth) {
            t.breakpoints && e.setBreakpoint();
            var i = e.allowSlideNext, s = e.allowSlidePrev, r = e.snapGrid;
            if (e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), t.freeMode) {
                var n = Math.min(Math.max(e.translate, e.maxTranslate()), e.minTranslate());
                e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses(), t.autoHeight && e.updateAutoHeight();
            } else e.updateSlidesClasses(), ('auto' === t.slidesPerView || 1 < t.slidesPerView) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0);
            e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = s, e.allowSlideNext = i, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
        }
    }
    var w = !1;
    function y() {}
    var x = {
        init: !0,
        direction: 'horizontal',
        touchEventsTarget: 'container',
        initialSlide: 0,
        speed: 300,
        preventInteractionOnTransition: !1,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: 0.02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: 'slide',
        breakpoints: void 0,
        breakpointsInverse: !1,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: 'column',
        slidesPerGroup: 1,
        centeredSlides: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !0,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: 'swiper-no-swiping',
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: 'swiper-container-',
        slideClass: 'swiper-slide',
        slideBlankClass: 'swiper-slide-invisible-blank',
        slideActiveClass: 'swiper-slide-active',
        slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
        slideVisibleClass: 'swiper-slide-visible',
        slideDuplicateClass: 'swiper-slide-duplicate',
        slideNextClass: 'swiper-slide-next',
        slideDuplicateNextClass: 'swiper-slide-duplicate-next',
        slidePrevClass: 'swiper-slide-prev',
        slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
        wrapperClass: 'swiper-wrapper',
        runCallbacksOnInit: !0
    }, T = {
        update: d,
        translate: p,
        transition: c,
        slide: u,
        loop: h,
        grabCursor: v,
        manipulation: f,
        events: {
            attachEvents: function() {
                var e = this, t = e.params, a = e.touchEvents, i = e.el, s = e.wrapperEl;
                e.onTouchStart = (function(e) {
                    var t = this, a = t.touchEventsData, i = t.params, s = t.touches;
                    if (!t.animating || !i.preventInteractionOnTransition) {
                        var r = e;
                        if (r.originalEvent && (r = r.originalEvent), a.isTouchEvent = 'touchstart' === r.type, (a.isTouchEvent || !('which' in r) || 3 !== r.which) && !(!a.isTouchEvent && 'button' in r && 0 < r.button || a.isTouched && a.isMoved)) {
                            if (i.noSwiping && L(r.target).closest(i.noSwipingSelector ? i.noSwipingSelector : '.' + i.noSwipingClass)[0]) t.allowClick = !0;
                            else if (!i.swipeHandler || L(r).closest(i.swipeHandler)[0]) {
                                s.currentX = 'touchstart' === r.type ? r.targetTouches[0].pageX : r.pageX, s.currentY = 'touchstart' === r.type ? r.targetTouches[0].pageY : r.pageY;
                                var n = s.currentX, o = s.currentY, l = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection, d = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
                                if (!l || !(n <= d || n >= ee.screen.width - d)) {
                                    if (te.extend(a, {
                                        isTouched: !0,
                                        isMoved: !1,
                                        allowTouchCallbacks: !0,
                                        isScrolling: void 0,
                                        startMoving: void 0
                                    }), s.startX = n, s.startY = o, a.touchStartTime = te.now(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, 0 < i.threshold && (a.allowThresholdMove = !1), 'touchstart' !== r.type) {
                                        var p = !0;
                                        L(r.target).is(a.formElements) && (p = !1), m.activeElement && L(m.activeElement).is(a.formElements) && m.activeElement !== r.target && m.activeElement.blur();
                                        var c = p && t.allowTouchMove && i.touchStartPreventDefault;
                                        (i.touchStartForcePreventDefault || c) && r.preventDefault();
                                    }
                                    t.emit('touchStart', r);
                                }
                            }
                        }
                    }
                }).bind(e), e.onTouchMove = (function(e) {
                    var t = this, a = t.touchEventsData, i = t.params, s = t.touches, r = t.rtlTranslate, n = e;
                    if (n.originalEvent && (n = n.originalEvent), a.isTouched) {
                        if (!a.isTouchEvent || 'mousemove' !== n.type) {
                            var o = 'touchmove' === n.type && n.targetTouches && (n.targetTouches[0] || n.changedTouches[0]), l = 'touchmove' === n.type ? o.pageX : n.pageX, d = 'touchmove' === n.type ? o.pageY : n.pageY;
                            if (n.preventedByNestedSwiper) return s.startX = l, void (s.startY = d);
                            if (!t.allowTouchMove) return t.allowClick = !1, void (a.isTouched && (te.extend(s, {
                                startX: l,
                                startY: d,
                                currentX: l,
                                currentY: d
                            }), a.touchStartTime = te.now()));
                            if (a.isTouchEvent && i.touchReleaseOnEdges && !i.loop) {
                                if (t.isVertical()) {
                                    if (d < s.startY && t.translate <= t.maxTranslate() || d > s.startY && t.translate >= t.minTranslate()) return a.isTouched = !1, void (a.isMoved = !1);
                                } else if (l < s.startX && t.translate <= t.maxTranslate() || l > s.startX && t.translate >= t.minTranslate()) return;
                            }
                            if (a.isTouchEvent && m.activeElement && n.target === m.activeElement && L(n.target).is(a.formElements)) return a.isMoved = !0, void (t.allowClick = !1);
                            if (a.allowTouchCallbacks && t.emit('touchMove', n), !(n.targetTouches && 1 < n.targetTouches.length)) {
                                s.currentX = l, s.currentY = d;
                                var p = s.currentX - s.startX, c = s.currentY - s.startY;
                                if (!(t.params.threshold && Math.sqrt(Math.pow(p, 2) + Math.pow(c, 2)) < t.params.threshold)) {
                                    var u;
                                    if (void 0 === a.isScrolling) t.isHorizontal() && s.currentY === s.startY || t.isVertical() && s.currentX === s.startX ? a.isScrolling = !1 : 25 <= p * p + c * c && (u = 180 * Math.atan2(Math.abs(c), Math.abs(p)) / Math.PI, a.isScrolling = t.isHorizontal() ? u > i.touchAngle : 90 - u > i.touchAngle);
                                    if (a.isScrolling && t.emit('touchMoveOpposite', n), void 0 === a.startMoving && (s.currentX === s.startX && s.currentY === s.startY || (a.startMoving = !0)), a.isScrolling) a.isTouched = !1;
                                    else if (a.startMoving) {
                                        t.allowClick = !1, n.preventDefault(), i.touchMoveStopPropagation && !i.nested && n.stopPropagation(), a.isMoved || (i.loop && t.loopFix(), a.startTranslate = t.getTranslate(), t.setTransition(0), t.animating && t.$wrapperEl.trigger('webkitTransitionEnd transitionend'), a.allowMomentumBounce = !1, !i.grabCursor || !0 !== t.allowSlideNext && !0 !== t.allowSlidePrev || t.setGrabCursor(!0), t.emit('sliderFirstMove', n)), t.emit('sliderMove', n), a.isMoved = !0;
                                        var h = t.isHorizontal() ? p : c;
                                        s.diff = h, h *= i.touchRatio, r && (h = -h), t.swipeDirection = 0 < h ? 'prev' : 'next', a.currentTranslate = h + a.startTranslate;
                                        var v = !0, f = i.resistanceRatio;
                                        if (i.touchReleaseOnEdges && (f = 0), 0 < h && a.currentTranslate > t.minTranslate() ? (v = !1, i.resistance && (a.currentTranslate = t.minTranslate() - 1 + Math.pow(-t.minTranslate() + a.startTranslate + h, f))) : h < 0 && a.currentTranslate < t.maxTranslate() && (v = !1, i.resistance && (a.currentTranslate = t.maxTranslate() + 1 - Math.pow(t.maxTranslate() - a.startTranslate - h, f))), v && (n.preventedByNestedSwiper = !0), !t.allowSlideNext && 'next' === t.swipeDirection && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !t.allowSlidePrev && 'prev' === t.swipeDirection && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), 0 < i.threshold) {
                                            if (!(Math.abs(h) > i.threshold || a.allowThresholdMove)) return void (a.currentTranslate = a.startTranslate);
                                            if (!a.allowThresholdMove) return a.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, a.currentTranslate = a.startTranslate, void (s.diff = t.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY);
                                        }
                                        i.followFinger && ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (t.updateActiveIndex(), t.updateSlidesClasses()), i.freeMode && (0 === a.velocities.length && a.velocities.push({
                                            position: s[t.isHorizontal() ? 'startX' : 'startY'],
                                            time: a.touchStartTime
                                        }), a.velocities.push({
                                            position: s[t.isHorizontal() ? 'currentX' : 'currentY'],
                                            time: te.now()
                                        })), t.updateProgress(a.currentTranslate), t.setTranslate(a.currentTranslate));
                                    }
                                }
                            }
                        }
                    } else a.startMoving && a.isScrolling && t.emit('touchMoveOpposite', n);
                }).bind(e), e.onTouchEnd = (function(e) {
                    var t = this, a = t.touchEventsData, i = t.params, s = t.touches, r = t.rtlTranslate, n = t.$wrapperEl, o = t.slidesGrid, l = t.snapGrid, d = e;
                    if (d.originalEvent && (d = d.originalEvent), a.allowTouchCallbacks && t.emit('touchEnd', d), a.allowTouchCallbacks = !1, !a.isTouched) return a.isMoved && i.grabCursor && t.setGrabCursor(!1), a.isMoved = !1, void (a.startMoving = !1);
                    i.grabCursor && a.isMoved && a.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
                    var p, c = te.now(), u = c - a.touchStartTime;
                    if (t.allowClick && (t.updateClickedSlide(d), t.emit('tap', d), u < 300 && 300 < c - a.lastClickTime && (a.clickTimeout && clearTimeout(a.clickTimeout), a.clickTimeout = te.nextTick(function() {
                        t && !t.destroyed && t.emit('click', d);
                    }, 300)), u < 300 && c - a.lastClickTime < 300 && (a.clickTimeout && clearTimeout(a.clickTimeout), t.emit('doubleTap', d))), a.lastClickTime = te.now(), te.nextTick(function() {
                        t.destroyed || (t.allowClick = !0);
                    }), !a.isTouched || !a.isMoved || !t.swipeDirection || 0 === s.diff || a.currentTranslate === a.startTranslate) return a.isTouched = !1, a.isMoved = !1, void (a.startMoving = !1);
                    if (a.isTouched = !1, a.isMoved = !1, a.startMoving = !1, p = i.followFinger ? r ? t.translate : -t.translate : -a.currentTranslate, i.freeMode) {
                        if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
                        if (p > -t.maxTranslate()) return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
                        if (i.freeModeMomentum) {
                            if (1 < a.velocities.length) {
                                var h = a.velocities.pop(), v = a.velocities.pop(), f = h.position - v.position, m = h.time - v.time;
                                t.velocity = f / m, t.velocity /= 2, Math.abs(t.velocity) < i.freeModeMinimumVelocity && (t.velocity = 0), (150 < m || 300 < te.now() - h.time) && (t.velocity = 0);
                            } else t.velocity = 0;
                            t.velocity *= i.freeModeMomentumVelocityRatio, a.velocities.length = 0;
                            var g = 1e3 * i.freeModeMomentumRatio, b = t.velocity * g, w = t.translate + b;
                            r && (w = -w);
                            var y, x, T = !1, E = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;
                            if (w < t.maxTranslate()) i.freeModeMomentumBounce ? (w + t.maxTranslate() < -E && (w = t.maxTranslate() - E), y = t.maxTranslate(), T = !0, a.allowMomentumBounce = !0) : w = t.maxTranslate(), i.loop && i.centeredSlides && (x = !0);
                            else if (w > t.minTranslate()) i.freeModeMomentumBounce ? (w - t.minTranslate() > E && (w = t.minTranslate() + E), y = t.minTranslate(), T = !0, a.allowMomentumBounce = !0) : w = t.minTranslate(), i.loop && i.centeredSlides && (x = !0);
                            else if (i.freeModeSticky) {
                                for(var S, C = 0; C < l.length; C += 1)if (l[C] > -w) {
                                    S = C;
                                    break;
                                }
                                w = -(w = Math.abs(l[S] - w) < Math.abs(l[S - 1] - w) || 'next' === t.swipeDirection ? l[S] : l[S - 1]);
                            }
                            if (x && t.once('transitionEnd', function() {
                                t.loopFix();
                            }), 0 !== t.velocity) g = r ? Math.abs((-w - t.translate) / t.velocity) : Math.abs((w - t.translate) / t.velocity);
                            else if (i.freeModeSticky) return void t.slideToClosest();
                            i.freeModeMomentumBounce && T ? (t.updateProgress(y), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating = !0, n.transitionEnd(function() {
                                t && !t.destroyed && a.allowMomentumBounce && (t.emit('momentumBounce'), t.setTransition(i.speed), t.setTranslate(y), n.transitionEnd(function() {
                                    t && !t.destroyed && t.transitionEnd();
                                }));
                            })) : t.velocity ? (t.updateProgress(w), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, n.transitionEnd(function() {
                                t && !t.destroyed && t.transitionEnd();
                            }))) : t.updateProgress(w), t.updateActiveIndex(), t.updateSlidesClasses();
                        } else if (i.freeModeSticky) return void t.slideToClosest();
                        (!i.freeModeMomentum || u >= i.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                    } else {
                        for(var M = 0, P = t.slidesSizesGrid[0], k = 0; k < o.length; k += i.slidesPerGroup)void 0 !== o[k + i.slidesPerGroup] ? p >= o[k] && p < o[k + i.slidesPerGroup] && (P = o[(M = k) + i.slidesPerGroup] - o[k]) : p >= o[k] && (M = k, P = o[o.length - 1] - o[o.length - 2]);
                        var z = (p - o[M]) / P;
                        if (u > i.longSwipesMs) {
                            if (!i.longSwipes) return void t.slideTo(t.activeIndex);
                            'next' === t.swipeDirection && (z >= i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M)), 'prev' === t.swipeDirection && (z > 1 - i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M));
                        } else {
                            if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
                            'next' === t.swipeDirection && t.slideTo(M + i.slidesPerGroup), 'prev' === t.swipeDirection && t.slideTo(M);
                        }
                    }
                }).bind(e), e.onClick = (function(e) {
                    this.allowClick || (this.params.preventClicks && e.preventDefault(), this.params.preventClicksPropagation && this.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
                }).bind(e);
                var r = 'container' === t.touchEventsTarget ? i : s, n = !!t.nested;
                if (ae.touch || !ae.pointerEvents && !ae.prefixedPointerEvents) {
                    if (ae.touch) {
                        var o = !('touchstart' !== a.start || !ae.passiveListener || !t.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        r.addEventListener(a.start, e.onTouchStart, o), r.addEventListener(a.move, e.onTouchMove, ae.passiveListener ? {
                            passive: !1,
                            capture: n
                        } : n), r.addEventListener(a.end, e.onTouchEnd, o), w || (m.addEventListener('touchstart', y), w = !0);
                    }
                    (t.simulateTouch && !g.ios && !g.android || t.simulateTouch && !ae.touch && g.ios) && (r.addEventListener('mousedown', e.onTouchStart, !1), m.addEventListener('mousemove', e.onTouchMove, n), m.addEventListener('mouseup', e.onTouchEnd, !1));
                } else r.addEventListener(a.start, e.onTouchStart, !1), m.addEventListener(a.move, e.onTouchMove, n), m.addEventListener(a.end, e.onTouchEnd, !1);
                (t.preventClicks || t.preventClicksPropagation) && r.addEventListener('click', e.onClick, !0), e.on(g.ios || g.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', b, !0);
            },
            detachEvents: function() {
                var e = this, t = e.params, a = e.touchEvents, i = e.el, s = e.wrapperEl, r = 'container' === t.touchEventsTarget ? i : s, n = !!t.nested;
                if (ae.touch || !ae.pointerEvents && !ae.prefixedPointerEvents) {
                    if (ae.touch) {
                        var o = !('onTouchStart' !== a.start || !ae.passiveListener || !t.passiveListeners) && {
                            passive: !0,
                            capture: !1
                        };
                        r.removeEventListener(a.start, e.onTouchStart, o), r.removeEventListener(a.move, e.onTouchMove, n), r.removeEventListener(a.end, e.onTouchEnd, o);
                    }
                    (t.simulateTouch && !g.ios && !g.android || t.simulateTouch && !ae.touch && g.ios) && (r.removeEventListener('mousedown', e.onTouchStart, !1), m.removeEventListener('mousemove', e.onTouchMove, n), m.removeEventListener('mouseup', e.onTouchEnd, !1));
                } else r.removeEventListener(a.start, e.onTouchStart, !1), m.removeEventListener(a.move, e.onTouchMove, n), m.removeEventListener(a.end, e.onTouchEnd, !1);
                (t.preventClicks || t.preventClicksPropagation) && r.removeEventListener('click', e.onClick, !0), e.off(g.ios || g.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', b);
            }
        },
        breakpoints: {
            setBreakpoint: function() {
                var e = this, t = e.activeIndex, a = e.initialized, i = e.loopedSlides;
                void 0 === i && (i = 0);
                var s = e.params, r = s.breakpoints;
                if (r && (!r || 0 !== Object.keys(r).length)) {
                    var n = e.getBreakpoint(r);
                    if (n && e.currentBreakpoint !== n) {
                        var o = n in r ? r[n] : void 0;
                        o && [
                            'slidesPerView',
                            'spaceBetween',
                            'slidesPerGroup'
                        ].forEach(function(e) {
                            var t = o[e];
                            void 0 !== t && (o[e] = 'slidesPerView' !== e || 'AUTO' !== t && 'auto' !== t ? 'slidesPerView' === e ? parseFloat(t) : parseInt(t, 10) : 'auto');
                        });
                        var l = o || e.originalParams, d = l.direction && l.direction !== s.direction, p = s.loop && (l.slidesPerView !== s.slidesPerView || d);
                        d && a && e.changeDirection(), te.extend(e.params, l), te.extend(e, {
                            allowTouchMove: e.params.allowTouchMove,
                            allowSlideNext: e.params.allowSlideNext,
                            allowSlidePrev: e.params.allowSlidePrev
                        }), e.currentBreakpoint = n, p && a && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)), e.emit('breakpoint', l);
                    }
                }
            },
            getBreakpoint: function(e) {
                if (e) {
                    var t = !1, a = [];
                    Object.keys(e).forEach(function(e) {
                        a.push(e);
                    }), a.sort(function(e, t) {
                        return parseInt(e, 10) - parseInt(t, 10);
                    });
                    for(var i = 0; i < a.length; i += 1){
                        var s = a[i];
                        this.params.breakpointsInverse ? s <= ee.innerWidth && (t = s) : s >= ee.innerWidth && !t && (t = s);
                    }
                    return t || 'max';
                }
            }
        },
        checkOverflow: {
            checkOverflow: function() {
                var e = this, t = e.isLocked;
                e.isLocked = 1 === e.snapGrid.length, e.allowSlideNext = !e.isLocked, e.allowSlidePrev = !e.isLocked, t !== e.isLocked && e.emit(e.isLocked ? 'lock' : 'unlock'), t && t !== e.isLocked && (e.isEnd = !1, e.navigation.update());
            }
        },
        classes: {
            addClasses: function() {
                var t = this.classNames, a = this.params, e = this.rtl, i = this.$el, s = [];
                s.push('initialized'), s.push(a.direction), a.freeMode && s.push('free-mode'), ae.flexbox || s.push('no-flexbox'), a.autoHeight && s.push('autoheight'), e && s.push('rtl'), 1 < a.slidesPerColumn && s.push('multirow'), g.android && s.push('android'), g.ios && s.push('ios'), (ie.isIE || ie.isEdge) && (ae.pointerEvents || ae.prefixedPointerEvents) && s.push('wp8-' + a.direction), s.forEach(function(e) {
                    t.push(a.containerModifierClass + e);
                }), i.addClass(t.join(' '));
            },
            removeClasses: function() {
                var e = this.$el, t = this.classNames;
                e.removeClass(t.join(' '));
            }
        },
        images: {
            loadImage: function(e, t, a, i, s, r) {
                var n;
                function o() {
                    r && r();
                }
                e.complete && s ? o() : t ? ((n = new ee.Image()).onload = o, n.onerror = o, i && (n.sizes = i), a && (n.srcset = a), t && (n.src = t)) : o();
            },
            preloadImages: function() {
                var e = this;
                function t() {
                    null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit('imagesReady')));
                }
                e.imagesToLoad = e.$el.find('img');
                for(var a = 0; a < e.imagesToLoad.length; a += 1){
                    var i = e.imagesToLoad[a];
                    e.loadImage(i, i.currentSrc || i.getAttribute('src'), i.srcset || i.getAttribute('srcset'), i.sizes || i.getAttribute('sizes'), !0, t);
                }
            }
        }
    }, E = {}, S = function(u) {
        function h() {
            for(var e, t, s, a = [], i = arguments.length; i--;)a[i] = arguments[i];
            s = (s = 1 === a.length && a[0].constructor && a[0].constructor === Object ? a[0] : (t = (e = a)[0], e[1])) || {}, s = te.extend({}, s), t && !s.el && (s.el = t), u.call(this, s), Object.keys(T).forEach(function(t) {
                Object.keys(T[t]).forEach(function(e) {
                    h.prototype[e] || (h.prototype[e] = T[t][e]);
                });
            });
            var r = this;
            void 0 === r.modules && (r.modules = {}), Object.keys(r.modules).forEach(function(e) {
                var t = r.modules[e];
                if (t.params) {
                    var a = Object.keys(t.params)[0], i = t.params[a];
                    if ('object' != typeof i || null === i) return;
                    if (!(a in s && 'enabled' in i)) return;
                    !0 === s[a] && (s[a] = {
                        enabled: !0
                    }), 'object' != typeof s[a] || 'enabled' in s[a] || (s[a].enabled = !0), s[a] || (s[a] = {
                        enabled: !1
                    });
                }
            });
            var n = te.extend({}, x);
            r.useModulesParams(n), r.params = te.extend({}, n, E, s), r.originalParams = te.extend({}, r.params), r.passedParams = te.extend({}, s);
            var o = (r.$ = L)(r.params.el);
            if (t = o[0]) {
                if (1 < o.length) {
                    var l = [];
                    return o.each(function(e, t) {
                        var a = te.extend({}, s, {
                            el: t
                        });
                        l.push(new h(a));
                    }), l;
                }
                t.swiper = r, o.data('swiper', r);
                var d, p, c = o.children('.' + r.params.wrapperClass);
                return te.extend(r, {
                    $el: o,
                    el: t,
                    $wrapperEl: c,
                    wrapperEl: c[0],
                    classNames: [],
                    slides: L(),
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: function() {
                        return 'horizontal' === r.params.direction;
                    },
                    isVertical: function() {
                        return 'vertical' === r.params.direction;
                    },
                    rtl: 'rtl' === t.dir.toLowerCase() || 'rtl' === o.css('direction'),
                    rtlTranslate: 'horizontal' === r.params.direction && ('rtl' === t.dir.toLowerCase() || 'rtl' === o.css('direction')),
                    wrongRTL: '-webkit-box' === c.css('display'),
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    allowSlideNext: r.params.allowSlideNext,
                    allowSlidePrev: r.params.allowSlidePrev,
                    touchEvents: (d = [
                        'touchstart',
                        'touchmove',
                        'touchend'
                    ], p = [
                        'mousedown',
                        'mousemove',
                        'mouseup'
                    ], ae.pointerEvents ? p = [
                        'pointerdown',
                        'pointermove',
                        'pointerup'
                    ] : ae.prefixedPointerEvents && (p = [
                        'MSPointerDown',
                        'MSPointerMove',
                        'MSPointerUp'
                    ]), r.touchEventsTouch = {
                        start: d[0],
                        move: d[1],
                        end: d[2]
                    }, r.touchEventsDesktop = {
                        start: p[0],
                        move: p[1],
                        end: p[2]
                    }, ae.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop),
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        formElements: 'input, select, option, textarea, button, video',
                        lastClickTime: te.now(),
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        isTouchEvent: void 0,
                        startMoving: void 0
                    },
                    allowClick: !0,
                    allowTouchMove: r.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0
                }), r.useModules(), r.params.init && r.init(), r;
            }
        }
        u && (h.__proto__ = u);
        var e = {
            extendedDefaults: {
                configurable: !0
            },
            defaults: {
                configurable: !0
            },
            Class: {
                configurable: !0
            },
            $: {
                configurable: !0
            }
        };
        return ((h.prototype = Object.create(u && u.prototype)).constructor = h).prototype.slidesPerViewDynamic = function() {
            var e = this, t = e.params, a = e.slides, i = e.slidesGrid, s = e.size, r = e.activeIndex, n = 1;
            if (t.centeredSlides) {
                for(var o, l = a[r].swiperSlideSize, d = r + 1; d < a.length; d += 1)a[d] && !o && (n += 1, s < (l += a[d].swiperSlideSize) && (o = !0));
                for(var p = r - 1; 0 <= p; p -= 1)a[p] && !o && (n += 1, s < (l += a[p].swiperSlideSize) && (o = !0));
            } else for(var c = r + 1; c < a.length; c += 1)i[c] - i[r] < s && (n += 1);
            return n;
        }, h.prototype.update = function() {
            var a = this;
            if (a && !a.destroyed) {
                var e = a.snapGrid, t = a.params;
                t.breakpoints && a.setBreakpoint(), a.updateSize(), a.updateSlides(), a.updateProgress(), a.updateSlidesClasses(), a.params.freeMode ? (i(), a.params.autoHeight && a.updateAutoHeight()) : (('auto' === a.params.slidesPerView || 1 < a.params.slidesPerView) && a.isEnd && !a.params.centeredSlides ? a.slideTo(a.slides.length - 1, 0, !1, !0) : a.slideTo(a.activeIndex, 0, !1, !0)) || i(), t.watchOverflow && e !== a.snapGrid && a.checkOverflow(), a.emit('update');
            }
            function i() {
                var e = a.rtlTranslate ? -1 * a.translate : a.translate, t = Math.min(Math.max(e, a.maxTranslate()), a.minTranslate());
                a.setTranslate(t), a.updateActiveIndex(), a.updateSlidesClasses();
            }
        }, h.prototype.changeDirection = function(a, e) {
            void 0 === e && (e = !0);
            var t = this, i = t.params.direction;
            return (a = a || ('horizontal' === i ? 'vertical' : 'horizontal')) === i || 'horizontal' !== a && 'vertical' !== a || (t.$el.removeClass('' + t.params.containerModifierClass + i + ' wp8-' + i).addClass('' + t.params.containerModifierClass + a), (ie.isIE || ie.isEdge) && (ae.pointerEvents || ae.prefixedPointerEvents) && t.$el.addClass(t.params.containerModifierClass + 'wp8-' + a), t.params.direction = a, t.slides.each(function(e, t) {
                'vertical' === a ? t.style.width = '' : t.style.height = '';
            }), t.emit('changeDirection'), e && t.update()), t;
        }, h.prototype.init = function() {
            var e = this;
            e.initialized || (e.emit('beforeInit'), e.params.breakpoints && e.setBreakpoint(), e.addClasses(), e.params.loop && e.loopCreate(), e.updateSize(), e.updateSlides(), e.params.watchOverflow && e.checkOverflow(), e.params.grabCursor && e.setGrabCursor(), e.params.preloadImages && e.preloadImages(), e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit), e.attachEvents(), e.initialized = !0, e.emit('init'));
        }, h.prototype.destroy = function(e, t) {
            void 0 === e && (e = !0), void 0 === t && (t = !0);
            var a = this, i = a.params, s = a.$el, r = a.$wrapperEl, n = a.slides;
            return void 0 === a.params || a.destroyed || (a.emit('beforeDestroy'), a.initialized = !1, a.detachEvents(), i.loop && a.loopDestroy(), t && (a.removeClasses(), s.removeAttr('style'), r.removeAttr('style'), n && n.length && n.removeClass([
                i.slideVisibleClass,
                i.slideActiveClass,
                i.slideNextClass,
                i.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index').removeAttr('data-swiper-column').removeAttr('data-swiper-row')), a.emit('destroy'), Object.keys(a.eventsListeners).forEach(function(e) {
                a.off(e);
            }), !1 !== e && (a.$el[0].swiper = null, a.$el.data('swiper', null), te.deleteProps(a)), a.destroyed = !0), null;
        }, h.extendDefaults = function(e) {
            te.extend(E, e);
        }, e.extendedDefaults.get = function() {
            return E;
        }, e.defaults.get = function() {
            return x;
        }, e.Class.get = function() {
            return u;
        }, e.$.get = function() {
            return L;
        }, Object.defineProperties(h, e), h;
    }(e), C = {
        name: 'device',
        proto: {
            device: g
        },
        static: {
            device: g
        }
    }, M = {
        name: 'support',
        proto: {
            support: ae
        },
        static: {
            support: ae
        }
    }, P = {
        name: 'browser',
        proto: {
            browser: ie
        },
        static: {
            browser: ie
        }
    }, k = {
        name: 'resize',
        create: function() {
            var e = this;
            te.extend(e, {
                resize: {
                    resizeHandler: function() {
                        e && !e.destroyed && e.initialized && (e.emit('beforeResize'), e.emit('resize'));
                    },
                    orientationChangeHandler: function() {
                        e && !e.destroyed && e.initialized && e.emit('orientationchange');
                    }
                }
            });
        },
        on: {
            init: function() {
                ee.addEventListener('resize', this.resize.resizeHandler), ee.addEventListener('orientationchange', this.resize.orientationChangeHandler);
            },
            destroy: function() {
                ee.removeEventListener('resize', this.resize.resizeHandler), ee.removeEventListener('orientationchange', this.resize.orientationChangeHandler);
            }
        }
    }, z = {
        func: ee.MutationObserver || ee.WebkitMutationObserver,
        attach: function(e, t) {
            void 0 === t && (t = {});
            var a = this, i = new z.func(function(e) {
                if (1 !== e.length) {
                    var t = function() {
                        a.emit('observerUpdate', e[0]);
                    };
                    ee.requestAnimationFrame ? ee.requestAnimationFrame(t) : ee.setTimeout(t, 0);
                } else a.emit('observerUpdate', e[0]);
            });
            i.observe(e, {
                attributes: void 0 === t.attributes || t.attributes,
                childList: void 0 === t.childList || t.childList,
                characterData: void 0 === t.characterData || t.characterData
            }), a.observer.observers.push(i);
        },
        init: function() {
            var e = this;
            if (ae.observer && e.params.observer) {
                if (e.params.observeParents) for(var t = e.$el.parents(), a = 0; a < t.length; a += 1)e.observer.attach(t[a]);
                e.observer.attach(e.$el[0], {
                    childList: e.params.observeSlideChildren
                }), e.observer.attach(e.$wrapperEl[0], {
                    attributes: !1
                });
            }
        },
        destroy: function() {
            this.observer.observers.forEach(function(e) {
                e.disconnect();
            }), this.observer.observers = [];
        }
    }, $ = {
        name: 'observer',
        params: {
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1
        },
        create: function() {
            te.extend(this, {
                observer: {
                    init: z.init.bind(this),
                    attach: z.attach.bind(this),
                    destroy: z.destroy.bind(this),
                    observers: []
                }
            });
        },
        on: {
            init: function() {
                this.observer.init();
            },
            destroy: function() {
                this.observer.destroy();
            }
        }
    }, I = {
        update: function(e) {
            var t = this, a = t.params, i = a.slidesPerView, s = a.slidesPerGroup, r = a.centeredSlides, n = t.params.virtual, o = n.addSlidesBefore, l = n.addSlidesAfter, d = t.virtual, p = d.from, c = d.to, u = d.slides, h = d.slidesGrid, v = d.renderSlide, f = d.offset;
            t.updateActiveIndex();
            var m, g, b, w = t.activeIndex || 0;
            m = t.rtlTranslate ? 'right' : t.isHorizontal() ? 'left' : 'top', b = r ? (g = Math.floor(i / 2) + s + o, Math.floor(i / 2) + s + l) : (g = i + (s - 1) + o, s + l);
            var y = Math.max((w || 0) - b, 0), x = Math.min((w || 0) + g, u.length - 1), T = (t.slidesGrid[y] || 0) - (t.slidesGrid[0] || 0);
            function E() {
                t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load();
            }
            if (te.extend(t.virtual, {
                from: y,
                to: x,
                offset: T,
                slidesGrid: t.slidesGrid
            }), p === y && c === x && !e) return t.slidesGrid !== h && T !== f && t.slides.css(m, T + 'px'), void t.updateProgress();
            if (t.params.virtual.renderExternal) return t.params.virtual.renderExternal.call(t, {
                offset: T,
                from: y,
                to: x,
                slides: function() {
                    for(var e = [], t = y; t <= x; t += 1)e.push(u[t]);
                    return e;
                }()
            }), void E();
            var S = [], C = [];
            if (e) t.$wrapperEl.find('.' + t.params.slideClass).remove();
            else for(var M = p; M <= c; M += 1)(M < y || x < M) && t.$wrapperEl.find('.' + t.params.slideClass + '[data-swiper-slide-index="' + M + '"]').remove();
            for(var P = 0; P < u.length; P += 1)y <= P && P <= x && (void 0 === c || e ? C.push(P) : (c < P && C.push(P), P < p && S.push(P)));
            C.forEach(function(e) {
                t.$wrapperEl.append(v(u[e], e));
            }), S.sort(function(e, t) {
                return t - e;
            }).forEach(function(e) {
                t.$wrapperEl.prepend(v(u[e], e));
            }), t.$wrapperEl.children('.swiper-slide').css(m, T + 'px'), E();
        },
        renderSlide: function(e, t) {
            var a = this, i = a.params.virtual;
            if (i.cache && a.virtual.cache[t]) return a.virtual.cache[t];
            var s = i.renderSlide ? L(i.renderSlide.call(a, e, t)) : L('<div class="' + a.params.slideClass + '" data-swiper-slide-index="' + t + '">' + e + '</div>');
            return s.attr('data-swiper-slide-index') || s.attr('data-swiper-slide-index', t), i.cache && (a.virtual.cache[t] = s), s;
        },
        appendSlide: function(e) {
            if ('object' == typeof e && 'length' in e) for(var t = 0; t < e.length; t += 1)e[t] && this.virtual.slides.push(e[t]);
            else this.virtual.slides.push(e);
            this.virtual.update(!0);
        },
        prependSlide: function(e) {
            var t = this, a = t.activeIndex, i = a + 1, s = 1;
            if (Array.isArray(e)) {
                for(var r = 0; r < e.length; r += 1)e[r] && t.virtual.slides.unshift(e[r]);
                i = a + e.length, s = e.length;
            } else t.virtual.slides.unshift(e);
            if (t.params.virtual.cache) {
                var n = t.virtual.cache, o = {};
                Object.keys(n).forEach(function(e) {
                    o[parseInt(e, 10) + s] = n[e];
                }), t.virtual.cache = o;
            }
            t.virtual.update(!0), t.slideTo(i, 0);
        },
        removeSlide: function(e) {
            var t = this;
            if (null != e) {
                var a = t.activeIndex;
                if (Array.isArray(e)) for(var i = e.length - 1; 0 <= i; i -= 1)t.virtual.slides.splice(e[i], 1), t.params.virtual.cache && delete t.virtual.cache[e[i]], e[i] < a && (a -= 1), a = Math.max(a, 0);
                else t.virtual.slides.splice(e, 1), t.params.virtual.cache && delete t.virtual.cache[e], e < a && (a -= 1), a = Math.max(a, 0);
                t.virtual.update(!0), t.slideTo(a, 0);
            }
        },
        removeAllSlides: function() {
            var e = this;
            e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), e.virtual.update(!0), e.slideTo(0, 0);
        }
    }, D = {
        name: 'virtual',
        params: {
            virtual: {
                enabled: !1,
                slides: [],
                cache: !0,
                renderSlide: null,
                renderExternal: null,
                addSlidesBefore: 0,
                addSlidesAfter: 0
            }
        },
        create: function() {
            var e = this;
            te.extend(e, {
                virtual: {
                    update: I.update.bind(e),
                    appendSlide: I.appendSlide.bind(e),
                    prependSlide: I.prependSlide.bind(e),
                    removeSlide: I.removeSlide.bind(e),
                    removeAllSlides: I.removeAllSlides.bind(e),
                    renderSlide: I.renderSlide.bind(e),
                    slides: e.params.virtual.slides,
                    cache: {}
                }
            });
        },
        on: {
            beforeInit: function() {
                var e = this;
                if (e.params.virtual.enabled) {
                    e.classNames.push(e.params.containerModifierClass + 'virtual');
                    var t = {
                        watchSlidesProgress: !0
                    };
                    te.extend(e.params, t), te.extend(e.originalParams, t), e.params.initialSlide || e.virtual.update();
                }
            },
            setTranslate: function() {
                this.params.virtual.enabled && this.virtual.update();
            }
        }
    }, O = {
        handle: function(e) {
            var t = this, a = t.rtlTranslate, i = e;
            i.originalEvent && (i = i.originalEvent);
            var s = i.keyCode || i.charCode;
            if (!t.allowSlideNext && (t.isHorizontal() && 39 === s || t.isVertical() && 40 === s || 34 === s)) return !1;
            if (!t.allowSlidePrev && (t.isHorizontal() && 37 === s || t.isVertical() && 38 === s || 33 === s)) return !1;
            if (!(i.shiftKey || i.altKey || i.ctrlKey || i.metaKey || m.activeElement && m.activeElement.nodeName && ('input' === m.activeElement.nodeName.toLowerCase() || 'textarea' === m.activeElement.nodeName.toLowerCase()))) {
                if (t.params.keyboard.onlyInViewport && (33 === s || 34 === s || 37 === s || 39 === s || 38 === s || 40 === s)) {
                    var r = !1;
                    if (0 < t.$el.parents('.' + t.params.slideClass).length && 0 === t.$el.parents('.' + t.params.slideActiveClass).length) return;
                    var n = ee.innerWidth, o = ee.innerHeight, l = t.$el.offset();
                    a && (l.left -= t.$el[0].scrollLeft);
                    for(var d = [
                        [
                            l.left,
                            l.top
                        ],
                        [
                            l.left + t.width,
                            l.top
                        ],
                        [
                            l.left,
                            l.top + t.height
                        ],
                        [
                            l.left + t.width,
                            l.top + t.height
                        ]
                    ], p = 0; p < d.length; p += 1){
                        var c = d[p];
                        0 <= c[0] && c[0] <= n && 0 <= c[1] && c[1] <= o && (r = !0);
                    }
                    if (!r) return;
                }
                t.isHorizontal() ? (33 !== s && 34 !== s && 37 !== s && 39 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), (34 !== s && 39 !== s || a) && (33 !== s && 37 !== s || !a) || t.slideNext(), (33 !== s && 37 !== s || a) && (34 !== s && 39 !== s || !a) || t.slidePrev()) : (33 !== s && 34 !== s && 38 !== s && 40 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), 34 !== s && 40 !== s || t.slideNext(), 33 !== s && 38 !== s || t.slidePrev()), t.emit('keyPress', s);
            }
        },
        enable: function() {
            this.keyboard.enabled || (L(m).on('keydown', this.keyboard.handle), this.keyboard.enabled = !0);
        },
        disable: function() {
            this.keyboard.enabled && (L(m).off('keydown', this.keyboard.handle), this.keyboard.enabled = !1);
        }
    }, A = {
        name: 'keyboard',
        params: {
            keyboard: {
                enabled: !1,
                onlyInViewport: !0
            }
        },
        create: function() {
            te.extend(this, {
                keyboard: {
                    enabled: !1,
                    enable: O.enable.bind(this),
                    disable: O.disable.bind(this),
                    handle: O.handle.bind(this)
                }
            });
        },
        on: {
            init: function() {
                this.params.keyboard.enabled && this.keyboard.enable();
            },
            destroy: function() {
                this.keyboard.enabled && this.keyboard.disable();
            }
        }
    };
    var H = {
        lastScrollTime: te.now(),
        event: -1 < ee.navigator.userAgent.indexOf('firefox') ? 'DOMMouseScroll' : function() {
            var e = 'onwheel', t = e in m;
            if (!t) {
                var a = m.createElement('div');
                a.setAttribute(e, 'return;'), t = 'function' == typeof a[e];
            }
            return !t && m.implementation && m.implementation.hasFeature && !0 !== m.implementation.hasFeature('', '') && (t = m.implementation.hasFeature('Events.wheel', '3.0')), t;
        }() ? 'wheel' : 'mousewheel',
        normalize: function(e) {
            var t = 0, a = 0, i = 0, s = 0;
            return 'detail' in e && (a = e.detail), 'wheelDelta' in e && (a = -e.wheelDelta / 120), 'wheelDeltaY' in e && (a = -e.wheelDeltaY / 120), 'wheelDeltaX' in e && (t = -e.wheelDeltaX / 120), 'axis' in e && e.axis === e.HORIZONTAL_AXIS && (t = a, a = 0), i = 10 * t, s = 10 * a, 'deltaY' in e && (s = e.deltaY), 'deltaX' in e && (i = e.deltaX), (i || s) && e.deltaMode && (1 === e.deltaMode ? (i *= 40, s *= 40) : (i *= 800, s *= 800)), i && !t && (t = i < 1 ? -1 : 1), s && !a && (a = s < 1 ? -1 : 1), {
                spinX: t,
                spinY: a,
                pixelX: i,
                pixelY: s
            };
        },
        handleMouseEnter: function() {
            this.mouseEntered = !0;
        },
        handleMouseLeave: function() {
            this.mouseEntered = !1;
        },
        handle: function(e) {
            var t = e, a = this, i = a.params.mousewheel;
            if (!a.mouseEntered && !i.releaseOnEdges) return !0;
            t.originalEvent && (t = t.originalEvent);
            var s = 0, r = a.rtlTranslate ? -1 : 1, n = H.normalize(t);
            if (i.forceToAxis) {
                if (a.isHorizontal()) {
                    if (!(Math.abs(n.pixelX) > Math.abs(n.pixelY))) return !0;
                    s = n.pixelX * r;
                } else {
                    if (!(Math.abs(n.pixelY) > Math.abs(n.pixelX))) return !0;
                    s = n.pixelY;
                }
            } else s = Math.abs(n.pixelX) > Math.abs(n.pixelY) ? -n.pixelX * r : -n.pixelY;
            if (0 === s) return !0;
            if (i.invert && (s = -s), a.params.freeMode) {
                a.params.loop && a.loopFix();
                var o = a.getTranslate() + s * i.sensitivity, l = a.isBeginning, d = a.isEnd;
                if (o >= a.minTranslate() && (o = a.minTranslate()), o <= a.maxTranslate() && (o = a.maxTranslate()), a.setTransition(0), a.setTranslate(o), a.updateProgress(), a.updateActiveIndex(), a.updateSlidesClasses(), (!l && a.isBeginning || !d && a.isEnd) && a.updateSlidesClasses(), a.params.freeModeSticky && (clearTimeout(a.mousewheel.timeout), a.mousewheel.timeout = te.nextTick(function() {
                    a.slideToClosest();
                }, 300)), a.emit('scroll', t), a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(), o === a.minTranslate() || o === a.maxTranslate()) return !0;
            } else {
                if (60 < te.now() - a.mousewheel.lastScrollTime) {
                    if (s < 0) {
                        if (a.isEnd && !a.params.loop || a.animating) {
                            if (i.releaseOnEdges) return !0;
                        } else a.slideNext(), a.emit('scroll', t);
                    } else if (a.isBeginning && !a.params.loop || a.animating) {
                        if (i.releaseOnEdges) return !0;
                    } else a.slidePrev(), a.emit('scroll', t);
                }
                a.mousewheel.lastScrollTime = new ee.Date().getTime();
            }
            return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1;
        },
        enable: function() {
            var e = this;
            if (!H.event) return !1;
            if (e.mousewheel.enabled) return !1;
            var t = e.$el;
            return 'container' !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.on('mouseenter', e.mousewheel.handleMouseEnter), t.on('mouseleave', e.mousewheel.handleMouseLeave), t.on(H.event, e.mousewheel.handle), e.mousewheel.enabled = !0;
        },
        disable: function() {
            var e = this;
            if (!H.event) return !1;
            if (!e.mousewheel.enabled) return !1;
            var t = e.$el;
            return 'container' !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.off(H.event, e.mousewheel.handle), e.mousewheel.enabled = !1, true;
        }
    }, G = {
        update: function() {
            var e = this, t = e.params.navigation;
            if (!e.params.loop) {
                var a = e.navigation, i = a.$nextEl, s = a.$prevEl;
                s && 0 < s.length && (e.isBeginning ? s.addClass(t.disabledClass) : s.removeClass(t.disabledClass), s[e.params.watchOverflow && e.isLocked ? 'addClass' : 'removeClass'](t.lockClass)), i && 0 < i.length && (e.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[e.params.watchOverflow && e.isLocked ? 'addClass' : 'removeClass'](t.lockClass));
            }
        },
        onPrevClick: function(e) {
            e.preventDefault(), this.isBeginning && !this.params.loop || this.slidePrev();
        },
        onNextClick: function(e) {
            e.preventDefault(), this.isEnd && !this.params.loop || this.slideNext();
        },
        init: function() {
            var e, t, a = this, i = a.params.navigation;
            (i.nextEl || i.prevEl) && (i.nextEl && (e = L(i.nextEl), a.params.uniqueNavElements && 'string' == typeof i.nextEl && 1 < e.length && 1 === a.$el.find(i.nextEl).length && (e = a.$el.find(i.nextEl))), i.prevEl && (t = L(i.prevEl), a.params.uniqueNavElements && 'string' == typeof i.prevEl && 1 < t.length && 1 === a.$el.find(i.prevEl).length && (t = a.$el.find(i.prevEl))), e && 0 < e.length && e.on('click', a.navigation.onNextClick), t && 0 < t.length && t.on('click', a.navigation.onPrevClick), te.extend(a.navigation, {
                $nextEl: e,
                nextEl: e && e[0],
                $prevEl: t,
                prevEl: t && t[0]
            }));
        },
        destroy: function() {
            var e = this, t = e.navigation, a = t.$nextEl, i = t.$prevEl;
            a && a.length && (a.off('click', e.navigation.onNextClick), a.removeClass(e.params.navigation.disabledClass)), i && i.length && (i.off('click', e.navigation.onPrevClick), i.removeClass(e.params.navigation.disabledClass));
        }
    }, N = {
        update: function() {
            var e = this, t = e.rtl, s = e.params.pagination;
            if (s.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var r, a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, i = e.pagination.$el, n = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                if (e.params.loop ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > a - 1 - 2 * e.loopedSlides && (r -= a - 2 * e.loopedSlides), n - 1 < r && (r -= n), r < 0 && 'bullets' !== e.params.paginationType && (r = n + r)) : r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, 'bullets' === s.type && e.pagination.bullets && 0 < e.pagination.bullets.length) {
                    var o, l, d, p = e.pagination.bullets;
                    if (s.dynamicBullets && (e.pagination.bulletSize = p.eq(0)[e.isHorizontal() ? 'outerWidth' : 'outerHeight'](!0), i.css(e.isHorizontal() ? 'width' : 'height', e.pagination.bulletSize * (s.dynamicMainBullets + 4) + 'px'), 1 < s.dynamicMainBullets && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += r - e.previousIndex, e.pagination.dynamicBulletIndex > s.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = s.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)), o = r - e.pagination.dynamicBulletIndex, d = ((l = o + (Math.min(p.length, s.dynamicMainBullets) - 1)) + o) / 2), p.removeClass(s.bulletActiveClass + ' ' + s.bulletActiveClass + '-next ' + s.bulletActiveClass + '-next-next ' + s.bulletActiveClass + '-prev ' + s.bulletActiveClass + '-prev-prev ' + s.bulletActiveClass + '-main'), 1 < i.length) p.each(function(e, t) {
                        var a = L(t), i = a.index();
                        i === r && a.addClass(s.bulletActiveClass), s.dynamicBullets && (o <= i && i <= l && a.addClass(s.bulletActiveClass + '-main'), i === o && a.prev().addClass(s.bulletActiveClass + '-prev').prev().addClass(s.bulletActiveClass + '-prev-prev'), i === l && a.next().addClass(s.bulletActiveClass + '-next').next().addClass(s.bulletActiveClass + '-next-next'));
                    });
                    else if (p.eq(r).addClass(s.bulletActiveClass), s.dynamicBullets) {
                        for(var c = p.eq(o), u = p.eq(l), h = o; h <= l; h += 1)p.eq(h).addClass(s.bulletActiveClass + '-main');
                        c.prev().addClass(s.bulletActiveClass + '-prev').prev().addClass(s.bulletActiveClass + '-prev-prev'), u.next().addClass(s.bulletActiveClass + '-next').next().addClass(s.bulletActiveClass + '-next-next');
                    }
                    if (s.dynamicBullets) {
                        var v = Math.min(p.length, s.dynamicMainBullets + 4), f = (e.pagination.bulletSize * v - e.pagination.bulletSize) / 2 - d * e.pagination.bulletSize, m = t ? 'right' : 'left';
                        p.css(e.isHorizontal() ? m : 'top', f + 'px');
                    }
                }
                if ('fraction' === s.type && (i.find('.' + s.currentClass).text(s.formatFractionCurrent(r + 1)), i.find('.' + s.totalClass).text(s.formatFractionTotal(n))), 'progressbar' === s.type) {
                    var g;
                    g = s.progressbarOpposite ? e.isHorizontal() ? 'vertical' : 'horizontal' : e.isHorizontal() ? 'horizontal' : 'vertical';
                    var b = (r + 1) / n, w = 1, y = 1;
                    'horizontal' === g ? w = b : y = b, i.find('.' + s.progressbarFillClass).transform('translate3d(0,0,0) scaleX(' + w + ') scaleY(' + y + ')').transition(e.params.speed);
                }
                'custom' === s.type && s.renderCustom ? (i.html(s.renderCustom(e, r + 1, n)), e.emit('paginationRender', e, i[0])) : e.emit('paginationUpdate', e, i[0]), i[e.params.watchOverflow && e.isLocked ? 'addClass' : 'removeClass'](s.lockClass);
            }
        },
        render: function() {
            var e = this, t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, i = e.pagination.$el, s = '';
                if ('bullets' === t.type) {
                    for(var r = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length, n = 0; n < r; n += 1)t.renderBullet ? s += t.renderBullet.call(e, n, t.bulletClass) : s += '<' + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + '>';
                    i.html(s), e.pagination.bullets = i.find('.' + t.bulletClass);
                }
                'fraction' === t.type && (s = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', i.html(s)), 'progressbar' === t.type && (s = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', i.html(s)), 'custom' !== t.type && e.emit('paginationRender', e.pagination.$el[0]);
            }
        },
        init: function() {
            var a = this, e = a.params.pagination;
            if (e.el) {
                var t = L(e.el);
                0 !== t.length && (a.params.uniqueNavElements && 'string' == typeof e.el && 1 < t.length && 1 === a.$el.find(e.el).length && (t = a.$el.find(e.el)), 'bullets' === e.type && e.clickable && t.addClass(e.clickableClass), t.addClass(e.modifierClass + e.type), 'bullets' === e.type && e.dynamicBullets && (t.addClass('' + e.modifierClass + e.type + '-dynamic'), a.pagination.dynamicBulletIndex = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), 'progressbar' === e.type && e.progressbarOpposite && t.addClass(e.progressbarOppositeClass), e.clickable && t.on('click', '.' + e.bulletClass, function(e) {
                    e.preventDefault();
                    var t = L(this).index() * a.params.slidesPerGroup;
                    a.params.loop && (t += a.loopedSlides), a.slideTo(t);
                }), te.extend(a.pagination, {
                    $el: t,
                    el: t[0]
                }));
            }
        },
        destroy: function() {
            var e = this, t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var a = e.pagination.$el;
                a.removeClass(t.hiddenClass), a.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && a.off('click', '.' + t.bulletClass);
            }
        }
    }, B = {
        setTranslate: function() {
            var e = this;
            if (e.params.scrollbar.el && e.scrollbar.el) {
                var t = e.scrollbar, a = e.rtlTranslate, i = e.progress, s = t.dragSize, r = t.trackSize, n = t.$dragEl, o = t.$el, l = e.params.scrollbar, d = s, p = (r - s) * i;
                a ? 0 < (p = -p) ? (d = s - p, p = 0) : r < -p + s && (d = r + p) : p < 0 ? (d = s + p, p = 0) : r < p + s && (d = r - p), e.isHorizontal() ? (ae.transforms3d ? n.transform('translate3d(' + p + 'px, 0, 0)') : n.transform('translateX(' + p + 'px)'), n[0].style.width = d + 'px') : (ae.transforms3d ? n.transform('translate3d(0px, ' + p + 'px, 0)') : n.transform('translateY(' + p + 'px)'), n[0].style.height = d + 'px'), l.hide && (clearTimeout(e.scrollbar.timeout), o[0].style.opacity = 1, e.scrollbar.timeout = setTimeout(function() {
                    o[0].style.opacity = 0, o.transition(400);
                }, 1e3));
            }
        },
        setTransition: function(e) {
            this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e);
        },
        updateSize: function() {
            var e = this;
            if (e.params.scrollbar.el && e.scrollbar.el) {
                var t = e.scrollbar, a = t.$dragEl, i = t.$el;
                a[0].style.width = '', a[0].style.height = '';
                var s, r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight, n = e.size / e.virtualSize, o = n * (r / e.size);
                s = 'auto' === e.params.scrollbar.dragSize ? r * n : parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? a[0].style.width = s + 'px' : a[0].style.height = s + 'px', i[0].style.display = 1 <= n ? 'none' : '', e.params.scrollbar.hide && (i[0].style.opacity = 0), te.extend(t, {
                    trackSize: r,
                    divider: n,
                    moveDivider: o,
                    dragSize: s
                }), t.$el[e.params.watchOverflow && e.isLocked ? 'addClass' : 'removeClass'](e.params.scrollbar.lockClass);
            }
        },
        getPointerPosition: function(e) {
            return this.isHorizontal() ? 'touchstart' === e.type || 'touchmove' === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : 'touchstart' === e.type || 'touchmove' === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY;
        },
        setDragPosition: function(e) {
            var t, a = this, i = a.scrollbar, s = a.rtlTranslate, r = i.$el, n = i.dragSize, o = i.trackSize, l = i.dragStartPos;
            t = (i.getPointerPosition(e) - r.offset()[a.isHorizontal() ? 'left' : 'top'] - (null !== l ? l : n / 2)) / (o - n), t = Math.max(Math.min(t, 1), 0), s && (t = 1 - t);
            var d = a.minTranslate() + (a.maxTranslate() - a.minTranslate()) * t;
            a.updateProgress(d), a.setTranslate(d), a.updateActiveIndex(), a.updateSlidesClasses();
        },
        onDragStart: function(e) {
            var t = this, a = t.params.scrollbar, i = t.scrollbar, s = t.$wrapperEl, r = i.$el, n = i.$dragEl;
            t.scrollbar.isTouched = !0, t.scrollbar.dragStartPos = e.target === n[0] || e.target === n ? i.getPointerPosition(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? 'left' : 'top'] : null, e.preventDefault(), e.stopPropagation(), s.transition(100), n.transition(100), i.setDragPosition(e), clearTimeout(t.scrollbar.dragTimeout), r.transition(0), a.hide && r.css('opacity', 1), t.emit('scrollbarDragStart', e);
        },
        onDragMove: function(e) {
            var t = this.scrollbar, a = this.$wrapperEl, i = t.$el, s = t.$dragEl;
            this.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, t.setDragPosition(e), a.transition(0), i.transition(0), s.transition(0), this.emit('scrollbarDragMove', e));
        },
        onDragEnd: function(e) {
            var t = this, a = t.params.scrollbar, i = t.scrollbar.$el;
            t.scrollbar.isTouched && (t.scrollbar.isTouched = !1, a.hide && (clearTimeout(t.scrollbar.dragTimeout), t.scrollbar.dragTimeout = te.nextTick(function() {
                i.css('opacity', 0), i.transition(400);
            }, 1e3)), t.emit('scrollbarDragEnd', e), a.snapOnRelease && t.slideToClosest());
        },
        enableDraggable: function() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar, a = e.touchEventsTouch, i = e.touchEventsDesktop, s = e.params, r = t.$el[0], n = !(!ae.passiveListener || !s.passiveListeners) && {
                    passive: !1,
                    capture: !1
                }, o = !(!ae.passiveListener || !s.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                ae.touch ? (r.addEventListener(a.start, e.scrollbar.onDragStart, n), r.addEventListener(a.move, e.scrollbar.onDragMove, n), r.addEventListener(a.end, e.scrollbar.onDragEnd, o)) : (r.addEventListener(i.start, e.scrollbar.onDragStart, n), m.addEventListener(i.move, e.scrollbar.onDragMove, n), m.addEventListener(i.end, e.scrollbar.onDragEnd, o));
            }
        },
        disableDraggable: function() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar, a = e.touchEventsTouch, i = e.touchEventsDesktop, s = e.params, r = t.$el[0], n = !(!ae.passiveListener || !s.passiveListeners) && {
                    passive: !1,
                    capture: !1
                }, o = !(!ae.passiveListener || !s.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                ae.touch ? (r.removeEventListener(a.start, e.scrollbar.onDragStart, n), r.removeEventListener(a.move, e.scrollbar.onDragMove, n), r.removeEventListener(a.end, e.scrollbar.onDragEnd, o)) : (r.removeEventListener(i.start, e.scrollbar.onDragStart, n), m.removeEventListener(i.move, e.scrollbar.onDragMove, n), m.removeEventListener(i.end, e.scrollbar.onDragEnd, o));
            }
        },
        init: function() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar, a = e.$el, i = e.params.scrollbar, s = L(i.el);
                e.params.uniqueNavElements && 'string' == typeof i.el && 1 < s.length && 1 === a.find(i.el).length && (s = a.find(i.el));
                var r = s.find('.' + e.params.scrollbar.dragClass);
                0 === r.length && (r = L('<div class="' + e.params.scrollbar.dragClass + '"></div>'), s.append(r)), te.extend(t, {
                    $el: s,
                    el: s[0],
                    $dragEl: r,
                    dragEl: r[0]
                }), i.draggable && t.enableDraggable();
            }
        },
        destroy: function() {
            this.scrollbar.disableDraggable();
        }
    }, X = {
        setTransform: function(e, t) {
            var a = this.rtl, i = L(e), s = a ? -1 : 1, r = i.attr('data-swiper-parallax') || '0', n = i.attr('data-swiper-parallax-x'), o = i.attr('data-swiper-parallax-y'), l = i.attr('data-swiper-parallax-scale'), d = i.attr('data-swiper-parallax-opacity');
            if (n || o ? (n = n || '0', o = o || '0') : this.isHorizontal() ? (n = r, o = '0') : (o = r, n = '0'), n = 0 <= n.indexOf('%') ? parseInt(n, 10) * t * s + '%' : n * t * s + 'px', o = 0 <= o.indexOf('%') ? parseInt(o, 10) * t + '%' : o * t + 'px', null != d) {
                var p = d - (d - 1) * (1 - Math.abs(t));
                i[0].style.opacity = p;
            }
            if (null == l) i.transform('translate3d(' + n + ', ' + o + ', 0px)');
            else {
                var c = l - (l - 1) * (1 - Math.abs(t));
                i.transform('translate3d(' + n + ', ' + o + ', 0px) scale(' + c + ')');
            }
        },
        setTranslate: function() {
            var i = this, e = i.$el, t = i.slides, s = i.progress, r = i.snapGrid;
            e.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(e, t) {
                i.parallax.setTransform(t, s);
            }), t.each(function(e, t) {
                var a = t.progress;
                1 < i.params.slidesPerGroup && 'auto' !== i.params.slidesPerView && (a += Math.ceil(e / 2) - s * (r.length - 1)), a = Math.min(Math.max(a, -1), 1), L(t).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(e, t) {
                    i.parallax.setTransform(t, a);
                });
            });
        },
        setTransition: function(s) {
            void 0 === s && (s = this.params.speed);
            this.$el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(e, t) {
                var a = L(t), i = parseInt(a.attr('data-swiper-parallax-duration'), 10) || s;
                0 === s && (i = 0), a.transition(i);
            });
        }
    }, V = {
        getDistanceBetweenTouches: function(e) {
            if (e.targetTouches.length < 2) return 1;
            var t = e.targetTouches[0].pageX, a = e.targetTouches[0].pageY, i = e.targetTouches[1].pageX, s = e.targetTouches[1].pageY;
            return Math.sqrt(Math.pow(i - t, 2) + Math.pow(s - a, 2));
        },
        onGestureStart: function(e) {
            var t = this, a = t.params.zoom, i = t.zoom, s = i.gesture;
            if (i.fakeGestureTouched = !1, i.fakeGestureMoved = !1, !ae.gestures) {
                if ('touchstart' !== e.type || 'touchstart' === e.type && e.targetTouches.length < 2) return;
                i.fakeGestureTouched = !0, s.scaleStart = V.getDistanceBetweenTouches(e);
            }
            s.$slideEl && s.$slideEl.length || (s.$slideEl = L(e.target).closest('.swiper-slide'), 0 === s.$slideEl.length && (s.$slideEl = t.slides.eq(t.activeIndex)), s.$imageEl = s.$slideEl.find('img, svg, canvas'), s.$imageWrapEl = s.$imageEl.parent('.' + a.containerClass), s.maxRatio = s.$imageWrapEl.attr('data-swiper-zoom') || a.maxRatio, 0 !== s.$imageWrapEl.length) ? (s.$imageEl.transition(0), t.zoom.isScaling = !0) : s.$imageEl = void 0;
        },
        onGestureChange: function(e) {
            var t = this.params.zoom, a = this.zoom, i = a.gesture;
            if (!ae.gestures) {
                if ('touchmove' !== e.type || 'touchmove' === e.type && e.targetTouches.length < 2) return;
                a.fakeGestureMoved = !0, i.scaleMove = V.getDistanceBetweenTouches(e);
            }
            i.$imageEl && 0 !== i.$imageEl.length && (a.scale = ae.gestures ? e.scale * a.currentScale : i.scaleMove / i.scaleStart * a.currentScale, a.scale > i.maxRatio && (a.scale = i.maxRatio - 1 + Math.pow(a.scale - i.maxRatio + 1, 0.5)), a.scale < t.minRatio && (a.scale = t.minRatio + 1 - Math.pow(t.minRatio - a.scale + 1, 0.5)), i.$imageEl.transform('translate3d(0,0,0) scale(' + a.scale + ')'));
        },
        onGestureEnd: function(e) {
            var t = this.params.zoom, a = this.zoom, i = a.gesture;
            if (!ae.gestures) {
                if (!a.fakeGestureTouched || !a.fakeGestureMoved) return;
                if ('touchend' !== e.type || 'touchend' === e.type && e.changedTouches.length < 2 && !g.android) return;
                a.fakeGestureTouched = !1, a.fakeGestureMoved = !1;
            }
            i.$imageEl && 0 !== i.$imageEl.length && (a.scale = Math.max(Math.min(a.scale, i.maxRatio), t.minRatio), i.$imageEl.transition(this.params.speed).transform('translate3d(0,0,0) scale(' + a.scale + ')'), a.currentScale = a.scale, a.isScaling = !1, 1 === a.scale && (i.$slideEl = void 0));
        },
        onTouchStart: function(e) {
            var t = this.zoom, a = t.gesture, i = t.image;
            a.$imageEl && 0 !== a.$imageEl.length && (i.isTouched || (g.android && e.preventDefault(), i.isTouched = !0, i.touchesStart.x = 'touchstart' === e.type ? e.targetTouches[0].pageX : e.pageX, i.touchesStart.y = 'touchstart' === e.type ? e.targetTouches[0].pageY : e.pageY));
        },
        onTouchMove: function(e) {
            var t = this, a = t.zoom, i = a.gesture, s = a.image, r = a.velocity;
            if (i.$imageEl && 0 !== i.$imageEl.length && (t.allowClick = !1, s.isTouched && i.$slideEl)) {
                s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = te.getTranslate(i.$imageWrapEl[0], 'x') || 0, s.startY = te.getTranslate(i.$imageWrapEl[0], 'y') || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), t.rtl && (s.startX = -s.startX, s.startY = -s.startY));
                var n = s.width * a.scale, o = s.height * a.scale;
                if (!(n < i.slideWidth && o < i.slideHeight)) {
                    if (s.minX = Math.min(i.slideWidth / 2 - n / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - o / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = 'touchmove' === e.type ? e.targetTouches[0].pageX : e.pageX, s.touchesCurrent.y = 'touchmove' === e.type ? e.targetTouches[0].pageY : e.pageY, !s.isMoved && !a.isScaling) {
                        if (t.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void (s.isTouched = !1);
                        if (!t.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void (s.isTouched = !1);
                    }
                    e.preventDefault(), e.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, 0.8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, 0.8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, 0.8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, 0.8)), r.prevPositionX || (r.prevPositionX = s.touchesCurrent.x), r.prevPositionY || (r.prevPositionY = s.touchesCurrent.y), r.prevTime || (r.prevTime = Date.now()), r.x = (s.touchesCurrent.x - r.prevPositionX) / (Date.now() - r.prevTime) / 2, r.y = (s.touchesCurrent.y - r.prevPositionY) / (Date.now() - r.prevTime) / 2, Math.abs(s.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0), Math.abs(s.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0), r.prevPositionX = s.touchesCurrent.x, r.prevPositionY = s.touchesCurrent.y, r.prevTime = Date.now(), i.$imageWrapEl.transform('translate3d(' + s.currentX + 'px, ' + s.currentY + 'px,0)');
                }
            }
        },
        onTouchEnd: function() {
            var e = this.zoom, t = e.gesture, a = e.image, i = e.velocity;
            if (t.$imageEl && 0 !== t.$imageEl.length) {
                if (!a.isTouched || !a.isMoved) return a.isTouched = !1, void (a.isMoved = !1);
                a.isTouched = !1, a.isMoved = !1;
                var s = 300, r = 300, n = i.x * s, o = a.currentX + n, l = i.y * r, d = a.currentY + l;
                0 !== i.x && (s = Math.abs((o - a.currentX) / i.x)), 0 !== i.y && (r = Math.abs((d - a.currentY) / i.y));
                var p = Math.max(s, r);
                a.currentX = o, a.currentY = d;
                var c = a.width * e.scale, u = a.height * e.scale;
                a.minX = Math.min(t.slideWidth / 2 - c / 2, 0), a.maxX = -a.minX, a.minY = Math.min(t.slideHeight / 2 - u / 2, 0), a.maxY = -a.minY, a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX), a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY), t.$imageWrapEl.transition(p).transform('translate3d(' + a.currentX + 'px, ' + a.currentY + 'px,0)');
            }
        },
        onTransitionEnd: function() {
            var e = this.zoom, t = e.gesture;
            t.$slideEl && this.previousIndex !== this.activeIndex && (t.$imageEl.transform('translate3d(0,0,0) scale(1)'), t.$imageWrapEl.transform('translate3d(0,0,0)'), e.scale = 1, e.currentScale = 1, t.$slideEl = void 0, t.$imageEl = void 0, t.$imageWrapEl = void 0);
        },
        toggle: function(e) {
            var t = this.zoom;
            t.scale && 1 !== t.scale ? t.out() : t.in(e);
        },
        in: function(e) {
            var t, a, i, s, r, n, o, l, d, p, c, u, h, v, f, m, g = this, b = g.zoom, w = g.params.zoom, y = b.gesture, x = b.image;
            y.$slideEl || (y.$slideEl = g.clickedSlide ? L(g.clickedSlide) : g.slides.eq(g.activeIndex), y.$imageEl = y.$slideEl.find('img, svg, canvas'), y.$imageWrapEl = y.$imageEl.parent('.' + w.containerClass)), y.$imageEl && 0 !== y.$imageEl.length && (y.$slideEl.addClass('' + w.zoomedSlideClass), a = void 0 === x.touchesStart.x && e ? (t = 'touchend' === e.type ? e.changedTouches[0].pageX : e.pageX, 'touchend' === e.type ? e.changedTouches[0].pageY : e.pageY) : (t = x.touchesStart.x, x.touchesStart.y), b.scale = y.$imageWrapEl.attr('data-swiper-zoom') || w.maxRatio, b.currentScale = y.$imageWrapEl.attr('data-swiper-zoom') || w.maxRatio, e ? (f = y.$slideEl[0].offsetWidth, m = y.$slideEl[0].offsetHeight, i = y.$slideEl.offset().left + f / 2 - t, s = y.$slideEl.offset().top + m / 2 - a, o = y.$imageEl[0].offsetWidth, l = y.$imageEl[0].offsetHeight, d = o * b.scale, p = l * b.scale, h = -(c = Math.min(f / 2 - d / 2, 0)), v = -(u = Math.min(m / 2 - p / 2, 0)), (r = i * b.scale) < c && (r = c), h < r && (r = h), (n = s * b.scale) < u && (n = u), v < n && (n = v)) : n = r = 0, y.$imageWrapEl.transition(300).transform('translate3d(' + r + 'px, ' + n + 'px,0)'), y.$imageEl.transition(300).transform('translate3d(0,0,0) scale(' + b.scale + ')'));
        },
        out: function() {
            var e = this, t = e.zoom, a = e.params.zoom, i = t.gesture;
            i.$slideEl || (i.$slideEl = e.clickedSlide ? L(e.clickedSlide) : e.slides.eq(e.activeIndex), i.$imageEl = i.$slideEl.find('img, svg, canvas'), i.$imageWrapEl = i.$imageEl.parent('.' + a.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && (t.scale = 1, t.currentScale = 1, i.$imageWrapEl.transition(300).transform('translate3d(0,0,0)'), i.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)'), i.$slideEl.removeClass('' + a.zoomedSlideClass), i.$slideEl = void 0);
        },
        enable: function() {
            var e = this, t = e.zoom;
            if (!t.enabled) {
                t.enabled = !0;
                var a = !('touchstart' !== e.touchEvents.start || !ae.passiveListener || !e.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                ae.gestures ? (e.$wrapperEl.on('gesturestart', '.swiper-slide', t.onGestureStart, a), e.$wrapperEl.on('gesturechange', '.swiper-slide', t.onGestureChange, a), e.$wrapperEl.on('gestureend', '.swiper-slide', t.onGestureEnd, a)) : 'touchstart' === e.touchEvents.start && (e.$wrapperEl.on(e.touchEvents.start, '.swiper-slide', t.onGestureStart, a), e.$wrapperEl.on(e.touchEvents.move, '.swiper-slide', t.onGestureChange, a), e.$wrapperEl.on(e.touchEvents.end, '.swiper-slide', t.onGestureEnd, a)), e.$wrapperEl.on(e.touchEvents.move, '.' + e.params.zoom.containerClass, t.onTouchMove);
            }
        },
        disable: function() {
            var e = this, t = e.zoom;
            if (t.enabled) {
                e.zoom.enabled = !1;
                var a = !('touchstart' !== e.touchEvents.start || !ae.passiveListener || !e.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                ae.gestures ? (e.$wrapperEl.off('gesturestart', '.swiper-slide', t.onGestureStart, a), e.$wrapperEl.off('gesturechange', '.swiper-slide', t.onGestureChange, a), e.$wrapperEl.off('gestureend', '.swiper-slide', t.onGestureEnd, a)) : 'touchstart' === e.touchEvents.start && (e.$wrapperEl.off(e.touchEvents.start, '.swiper-slide', t.onGestureStart, a), e.$wrapperEl.off(e.touchEvents.move, '.swiper-slide', t.onGestureChange, a), e.$wrapperEl.off(e.touchEvents.end, '.swiper-slide', t.onGestureEnd, a)), e.$wrapperEl.off(e.touchEvents.move, '.' + e.params.zoom.containerClass, t.onTouchMove);
            }
        }
    }, Y = {
        loadInSlide: function(e, l) {
            void 0 === l && (l = !0);
            var d = this, p = d.params.lazy;
            if (void 0 !== e && 0 !== d.slides.length) {
                var c = d.virtual && d.params.virtual.enabled ? d.$wrapperEl.children('.' + d.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : d.slides.eq(e), t = c.find('.' + p.elementClass + ':not(.' + p.loadedClass + '):not(.' + p.loadingClass + ')');
                !c.hasClass(p.elementClass) || c.hasClass(p.loadedClass) || c.hasClass(p.loadingClass) || (t = t.add(c[0])), 0 !== t.length && t.each(function(e, t) {
                    var i = L(t);
                    i.addClass(p.loadingClass);
                    var s = i.attr('data-background'), r = i.attr('data-src'), n = i.attr('data-srcset'), o = i.attr('data-sizes');
                    d.loadImage(i[0], r || s, n, o, !1, function() {
                        if (null != d && d && (!d || d.params) && !d.destroyed) {
                            if (s ? (i.css('background-image', 'url("' + s + '")'), i.removeAttr('data-background')) : (n && (i.attr('srcset', n), i.removeAttr('data-srcset')), o && (i.attr('sizes', o), i.removeAttr('data-sizes')), r && (i.attr('src', r), i.removeAttr('data-src'))), i.addClass(p.loadedClass).removeClass(p.loadingClass), c.find('.' + p.preloaderClass).remove(), d.params.loop && l) {
                                var e = c.attr('data-swiper-slide-index');
                                if (c.hasClass(d.params.slideDuplicateClass)) {
                                    var t = d.$wrapperEl.children('[data-swiper-slide-index="' + e + '"]:not(.' + d.params.slideDuplicateClass + ')');
                                    d.lazy.loadInSlide(t.index(), !1);
                                } else {
                                    var a = d.$wrapperEl.children('.' + d.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');
                                    d.lazy.loadInSlide(a.index(), !1);
                                }
                            }
                            d.emit('lazyImageReady', c[0], i[0]);
                        }
                    }), d.emit('lazyImageLoad', c[0], i[0]);
                });
            }
        },
        load: function() {
            var i = this, t = i.$wrapperEl, a = i.params, s = i.slides, e = i.activeIndex, r = i.virtual && a.virtual.enabled, n = a.lazy, o = a.slidesPerView;
            function l(e) {
                if (r) {
                    if (t.children('.' + a.slideClass + '[data-swiper-slide-index="' + e + '"]').length) return !0;
                } else if (s[e]) return !0;
                return !1;
            }
            function d(e) {
                return r ? L(e).attr('data-swiper-slide-index') : L(e).index();
            }
            if ('auto' === o && (o = 0), i.lazy.initialImageLoaded || (i.lazy.initialImageLoaded = !0), i.params.watchSlidesVisibility) t.children('.' + a.slideVisibleClass).each(function(e, t) {
                var a = r ? L(t).attr('data-swiper-slide-index') : L(t).index();
                i.lazy.loadInSlide(a);
            });
            else if (1 < o) for(var p = e; p < e + o; p += 1)l(p) && i.lazy.loadInSlide(p);
            else i.lazy.loadInSlide(e);
            if (n.loadPrevNext) {
                if (1 < o || n.loadPrevNextAmount && 1 < n.loadPrevNextAmount) {
                    for(var c = n.loadPrevNextAmount, u = o, h = Math.min(e + u + Math.max(c, u), s.length), v = Math.max(e - Math.max(u, c), 0), f = e + o; f < h; f += 1)l(f) && i.lazy.loadInSlide(f);
                    for(var m = v; m < e; m += 1)l(m) && i.lazy.loadInSlide(m);
                } else {
                    var g = t.children('.' + a.slideNextClass);
                    0 < g.length && i.lazy.loadInSlide(d(g));
                    var b = t.children('.' + a.slidePrevClass);
                    0 < b.length && i.lazy.loadInSlide(d(b));
                }
            }
        }
    }, F = {
        LinearSpline: function(e, t) {
            var a, i, s, r, n, o = function(e, t) {
                for(i = -1, a = e.length; 1 < a - i;)e[s = a + i >> 1] <= t ? i = s : a = s;
                return a;
            };
            return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function(e) {
                return e ? (n = o(this.x, e), r = n - 1, (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0;
            }, this;
        },
        getInterpolateFunction: function(e) {
            var t = this;
            t.controller.spline || (t.controller.spline = t.params.loop ? new F.LinearSpline(t.slidesGrid, e.slidesGrid) : new F.LinearSpline(t.snapGrid, e.snapGrid));
        },
        setTranslate: function(e, t) {
            var a, i, s = this, r = s.controller.control;
            function n(e) {
                var t = s.rtlTranslate ? -s.translate : s.translate;
                'slide' === s.params.controller.by && (s.controller.getInterpolateFunction(e), i = -s.controller.spline.interpolate(-t)), i && 'container' !== s.params.controller.by || (a = (e.maxTranslate() - e.minTranslate()) / (s.maxTranslate() - s.minTranslate()), i = (t - s.minTranslate()) * a + e.minTranslate()), s.params.controller.inverse && (i = e.maxTranslate() - i), e.updateProgress(i), e.setTranslate(i, s), e.updateActiveIndex(), e.updateSlidesClasses();
            }
            if (Array.isArray(r)) for(var o = 0; o < r.length; o += 1)r[o] !== t && r[o] instanceof S && n(r[o]);
            else r instanceof S && t !== r && n(r);
        },
        setTransition: function(t, e) {
            var a, i = this, s = i.controller.control;
            function r(e) {
                e.setTransition(t, i), 0 !== t && (e.transitionStart(), e.params.autoHeight && te.nextTick(function() {
                    e.updateAutoHeight();
                }), e.$wrapperEl.transitionEnd(function() {
                    s && (e.params.loop && 'slide' === i.params.controller.by && e.loopFix(), e.transitionEnd());
                }));
            }
            if (Array.isArray(s)) for(a = 0; a < s.length; a += 1)s[a] !== e && s[a] instanceof S && r(s[a]);
            else s instanceof S && e !== s && r(s);
        }
    }, R = {
        makeElFocusable: function(e) {
            return e.attr('tabIndex', '0'), e;
        },
        addElRole: function(e, t) {
            return e.attr('role', t), e;
        },
        addElLabel: function(e, t) {
            return e.attr('aria-label', t), e;
        },
        disableEl: function(e) {
            return e.attr('aria-disabled', !0), e;
        },
        enableEl: function(e) {
            return e.attr('aria-disabled', !1), e;
        },
        onEnterKey: function(e) {
            var t = this, a = t.params.a11y;
            if (13 === e.keyCode) {
                var i = L(e.target);
                t.navigation && t.navigation.$nextEl && i.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? t.a11y.notify(a.lastSlideMessage) : t.a11y.notify(a.nextSlideMessage)), t.navigation && t.navigation.$prevEl && i.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? t.a11y.notify(a.firstSlideMessage) : t.a11y.notify(a.prevSlideMessage)), t.pagination && i.is('.' + t.params.pagination.bulletClass) && i[0].click();
            }
        },
        notify: function(e) {
            var t = this.a11y.liveRegion;
            0 !== t.length && (t.html(''), t.html(e));
        },
        updateNavigation: function() {
            var e = this;
            if (!e.params.loop) {
                var t = e.navigation, a = t.$nextEl, i = t.$prevEl;
                i && 0 < i.length && (e.isBeginning ? e.a11y.disableEl(i) : e.a11y.enableEl(i)), a && 0 < a.length && (e.isEnd ? e.a11y.disableEl(a) : e.a11y.enableEl(a));
            }
        },
        updatePagination: function() {
            var i = this, s = i.params.a11y;
            i.pagination && i.params.pagination.clickable && i.pagination.bullets && i.pagination.bullets.length && i.pagination.bullets.each(function(e, t) {
                var a = L(t);
                i.a11y.makeElFocusable(a), i.a11y.addElRole(a, 'button'), i.a11y.addElLabel(a, s.paginationBulletMessage.replace(/{{index}}/, a.index() + 1));
            });
        },
        init: function() {
            var e = this;
            e.$el.append(e.a11y.liveRegion);
            var t, a, i = e.params.a11y;
            e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl), e.navigation && e.navigation.$prevEl && (a = e.navigation.$prevEl), t && (e.a11y.makeElFocusable(t), e.a11y.addElRole(t, 'button'), e.a11y.addElLabel(t, i.nextSlideMessage), t.on('keydown', e.a11y.onEnterKey)), a && (e.a11y.makeElFocusable(a), e.a11y.addElRole(a, 'button'), e.a11y.addElLabel(a, i.prevSlideMessage), a.on('keydown', e.a11y.onEnterKey)), e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on('keydown', '.' + e.params.pagination.bulletClass, e.a11y.onEnterKey);
        },
        destroy: function() {
            var e, t, a = this;
            a.a11y.liveRegion && 0 < a.a11y.liveRegion.length && a.a11y.liveRegion.remove(), a.navigation && a.navigation.$nextEl && (e = a.navigation.$nextEl), a.navigation && a.navigation.$prevEl && (t = a.navigation.$prevEl), e && e.off('keydown', a.a11y.onEnterKey), t && t.off('keydown', a.a11y.onEnterKey), a.pagination && a.params.pagination.clickable && a.pagination.bullets && a.pagination.bullets.length && a.pagination.$el.off('keydown', '.' + a.params.pagination.bulletClass, a.a11y.onEnterKey);
        }
    }, q = {
        init: function() {
            var e = this;
            if (e.params.history) {
                if (!ee.history || !ee.history.pushState) return e.params.history.enabled = !1, void (e.params.hashNavigation.enabled = !0);
                var t = e.history;
                t.initialized = !0, t.paths = q.getPathValues(), (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit), e.params.history.replaceState || ee.addEventListener('popstate', e.history.setHistoryPopState));
            }
        },
        destroy: function() {
            this.params.history.replaceState || ee.removeEventListener('popstate', this.history.setHistoryPopState);
        },
        setHistoryPopState: function() {
            this.history.paths = q.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1);
        },
        getPathValues: function() {
            var e = ee.location.pathname.slice(1).split('/').filter(function(e) {
                return '' !== e;
            }), t = e.length;
            return {
                key: e[t - 2],
                value: e[t - 1]
            };
        },
        setHistory: function(e, t) {
            if (this.history.initialized && this.params.history.enabled) {
                var a = this.slides.eq(t), i = q.slugify(a.attr('data-history'));
                ee.location.pathname.includes(e) || (i = e + '/' + i);
                var s = ee.history.state;
                s && s.value === i || (this.params.history.replaceState ? ee.history.replaceState({
                    value: i
                }, null, i) : ee.history.pushState({
                    value: i
                }, null, i));
            }
        },
        slugify: function(e) {
            return e.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
        },
        scrollToSlide: function(e, t, a) {
            var i = this;
            if (t) for(var s = 0, r = i.slides.length; s < r; s += 1){
                var n = i.slides.eq(s);
                if (q.slugify(n.attr('data-history')) === t && !n.hasClass(i.params.slideDuplicateClass)) {
                    var o = n.index();
                    i.slideTo(o, e, a);
                }
            }
            else i.slideTo(0, e, a);
        }
    }, W = {
        onHashCange: function() {
            var e = this, t = m.location.hash.replace('#', '');
            if (t !== e.slides.eq(e.activeIndex).attr('data-hash')) {
                var a = e.$wrapperEl.children('.' + e.params.slideClass + '[data-hash="' + t + '"]').index();
                if (void 0 === a) return;
                e.slideTo(a);
            }
        },
        setHash: function() {
            var e = this;
            if (e.hashNavigation.initialized && e.params.hashNavigation.enabled) {
                if (e.params.hashNavigation.replaceState && ee.history && ee.history.replaceState) ee.history.replaceState(null, null, '#' + e.slides.eq(e.activeIndex).attr('data-hash'));
                else {
                    var t = e.slides.eq(e.activeIndex), a = t.attr('data-hash') || t.attr('data-history');
                    m.location.hash = a || '';
                }
            }
        },
        init: function() {
            var e = this;
            if (!(!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)) {
                e.hashNavigation.initialized = !0;
                var t = m.location.hash.replace('#', '');
                if (t) for(var a = 0, i = e.slides.length; a < i; a += 1){
                    var s = e.slides.eq(a);
                    if ((s.attr('data-hash') || s.attr('data-history')) === t && !s.hasClass(e.params.slideDuplicateClass)) {
                        var r = s.index();
                        e.slideTo(r, 0, e.params.runCallbacksOnInit, !0);
                    }
                }
                e.params.hashNavigation.watchState && L(ee).on('hashchange', e.hashNavigation.onHashCange);
            }
        },
        destroy: function() {
            this.params.hashNavigation.watchState && L(ee).off('hashchange', this.hashNavigation.onHashCange);
        }
    }, j = {
        run: function() {
            var e = this, t = e.slides.eq(e.activeIndex), a = e.params.autoplay.delay;
            t.attr('data-swiper-autoplay') && (a = t.attr('data-swiper-autoplay') || e.params.autoplay.delay), clearTimeout(e.autoplay.timeout), e.autoplay.timeout = te.nextTick(function() {
                e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit('autoplay')) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit('autoplay')) : (e.slidePrev(e.params.speed, !0, !0), e.emit('autoplay')) : e.params.loop ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit('autoplay')) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(0, e.params.speed, !0, !0), e.emit('autoplay')) : (e.slideNext(e.params.speed, !0, !0), e.emit('autoplay'));
            }, a);
        },
        start: function() {
            var e = this;
            return void 0 === e.autoplay.timeout && !e.autoplay.running && (e.autoplay.running = !0, e.emit('autoplayStart'), e.autoplay.run(), !0);
        },
        stop: function() {
            var e = this;
            return !!e.autoplay.running && void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), e.autoplay.timeout = void 0), e.autoplay.running = !1, e.emit('autoplayStop'), !0);
        },
        pause: function(e) {
            var t = this;
            t.autoplay.running && (t.autoplay.paused || (t.autoplay.timeout && clearTimeout(t.autoplay.timeout), t.autoplay.paused = !0, 0 !== e && t.params.autoplay.waitForTransition ? (t.$wrapperEl[0].addEventListener('transitionend', t.autoplay.onTransitionEnd), t.$wrapperEl[0].addEventListener('webkitTransitionEnd', t.autoplay.onTransitionEnd)) : (t.autoplay.paused = !1, t.autoplay.run())));
        }
    }, U = {
        setTranslate: function() {
            for(var e = this, t = e.slides, a = 0; a < t.length; a += 1){
                var i = e.slides.eq(a), s = -i[0].swiperSlideOffset;
                e.params.virtualTranslate || (s -= e.translate);
                var r = 0;
                e.isHorizontal() || (r = s, s = 0);
                var n = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
                i.css({
                    opacity: n
                }).transform('translate3d(' + s + 'px, ' + r + 'px, 0px)');
            }
        },
        setTransition: function(e) {
            var a = this, t = a.slides, i = a.$wrapperEl;
            if (t.transition(e), a.params.virtualTranslate && 0 !== e) {
                var s = !1;
                t.transitionEnd(function() {
                    if (!s && a && !a.destroyed) {
                        s = !0, a.animating = !1;
                        for(var e = [
                            'webkitTransitionEnd',
                            'transitionend'
                        ], t = 0; t < e.length; t += 1)i.trigger(e[t]);
                    }
                });
            }
        }
    }, K = {
        setTranslate: function() {
            var e, t = this, a = t.$el, i = t.$wrapperEl, s = t.slides, r = t.width, n = t.height, o = t.rtlTranslate, l = t.size, d = t.params.cubeEffect, p = t.isHorizontal(), c = t.virtual && t.params.virtual.enabled, u = 0;
            d.shadow && (p ? (0 === (e = i.find('.swiper-cube-shadow')).length && (e = L('<div class="swiper-cube-shadow"></div>'), i.append(e)), e.css({
                height: r + 'px'
            })) : 0 === (e = a.find('.swiper-cube-shadow')).length && (e = L('<div class="swiper-cube-shadow"></div>'), a.append(e)));
            for(var h = 0; h < s.length; h += 1){
                var v = s.eq(h), f = h;
                c && (f = parseInt(v.attr('data-swiper-slide-index'), 10));
                var m = 90 * f, g = Math.floor(m / 360);
                o && (m = -m, g = Math.floor(-m / 360));
                var b = Math.max(Math.min(v[0].progress, 1), -1), w = 0, y = 0, x = 0;
                f % 4 == 0 ? (w = 4 * -g * l, x = 0) : (f - 1) % 4 == 0 ? (w = 0, x = 4 * -g * l) : (f - 2) % 4 == 0 ? (w = l + 4 * g * l, x = l) : (f - 3) % 4 == 0 && (w = -l, x = 3 * l + 4 * l * g), o && (w = -w), p || (y = w, w = 0);
                var T = 'rotateX(' + (p ? 0 : -m) + 'deg) rotateY(' + (p ? m : 0) + 'deg) translate3d(' + w + 'px, ' + y + 'px, ' + x + 'px)';
                if (b <= 1 && -1 < b && (u = 90 * f + 90 * b, o && (u = 90 * -f - 90 * b)), v.transform(T), d.slideShadows) {
                    var E = p ? v.find('.swiper-slide-shadow-left') : v.find('.swiper-slide-shadow-top'), S = p ? v.find('.swiper-slide-shadow-right') : v.find('.swiper-slide-shadow-bottom');
                    0 === E.length && (E = L('<div class="swiper-slide-shadow-' + (p ? 'left' : 'top') + '"></div>'), v.append(E)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (p ? 'right' : 'bottom') + '"></div>'), v.append(S)), E.length && (E[0].style.opacity = Math.max(-b, 0)), S.length && (S[0].style.opacity = Math.max(b, 0));
                }
            }
            if (i.css({
                '-webkit-transform-origin': '50% 50% -' + l / 2 + 'px',
                '-moz-transform-origin': '50% 50% -' + l / 2 + 'px',
                '-ms-transform-origin': '50% 50% -' + l / 2 + 'px',
                'transform-origin': '50% 50% -' + l / 2 + 'px'
            }), d.shadow) {
                if (p) e.transform('translate3d(0px, ' + (r / 2 + d.shadowOffset) + 'px, ' + -r / 2 + 'px) rotateX(90deg) rotateZ(0deg) scale(' + d.shadowScale + ')');
                else {
                    var C = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90), M = 1.5 - (Math.sin(2 * C * Math.PI / 360) / 2 + Math.cos(2 * C * Math.PI / 360) / 2), P = d.shadowScale, k = d.shadowScale / M, z = d.shadowOffset;
                    e.transform('scale3d(' + P + ', 1, ' + k + ') translate3d(0px, ' + (n / 2 + z) + 'px, ' + -n / 2 / k + 'px) rotateX(-90deg)');
                }
            }
            var $ = ie.isSafari || ie.isUiWebView ? -l / 2 : 0;
            i.transform('translate3d(0px,0,' + $ + 'px) rotateX(' + (t.isHorizontal() ? 0 : u) + 'deg) rotateY(' + (t.isHorizontal() ? -u : 0) + 'deg)');
        },
        setTransition: function(e) {
            var t = this.$el;
            this.slides.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e), this.params.cubeEffect.shadow && !this.isHorizontal() && t.find('.swiper-cube-shadow').transition(e);
        }
    }, _ = {
        setTranslate: function() {
            for(var e = this, t = e.slides, a = e.rtlTranslate, i = 0; i < t.length; i += 1){
                var s = t.eq(i), r = s[0].progress;
                e.params.flipEffect.limitRotation && (r = Math.max(Math.min(s[0].progress, 1), -1));
                var n = -180 * r, o = 0, l = -s[0].swiperSlideOffset, d = 0;
                if (e.isHorizontal() ? a && (n = -n) : (d = l, o = -n, n = l = 0), s[0].style.zIndex = -Math.abs(Math.round(r)) + t.length, e.params.flipEffect.slideShadows) {
                    var p = e.isHorizontal() ? s.find('.swiper-slide-shadow-left') : s.find('.swiper-slide-shadow-top'), c = e.isHorizontal() ? s.find('.swiper-slide-shadow-right') : s.find('.swiper-slide-shadow-bottom');
                    0 === p.length && (p = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? 'left' : 'top') + '"></div>'), s.append(p)), 0 === c.length && (c = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? 'right' : 'bottom') + '"></div>'), s.append(c)), p.length && (p[0].style.opacity = Math.max(-r, 0)), c.length && (c[0].style.opacity = Math.max(r, 0));
                }
                s.transform('translate3d(' + l + 'px, ' + d + 'px, 0px) rotateX(' + o + 'deg) rotateY(' + n + 'deg)');
            }
        },
        setTransition: function(e) {
            var a = this, t = a.slides, i = a.activeIndex, s = a.$wrapperEl;
            if (t.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e), a.params.virtualTranslate && 0 !== e) {
                var r = !1;
                t.eq(i).transitionEnd(function() {
                    if (!r && a && !a.destroyed) {
                        r = !0, a.animating = !1;
                        for(var e = [
                            'webkitTransitionEnd',
                            'transitionend'
                        ], t = 0; t < e.length; t += 1)s.trigger(e[t]);
                    }
                });
            }
        }
    }, Z = {
        setTranslate: function() {
            for(var e = this, t = e.width, a = e.height, i = e.slides, s = e.$wrapperEl, r = e.slidesSizesGrid, n = e.params.coverflowEffect, o = e.isHorizontal(), l = e.translate, d = o ? t / 2 - l : a / 2 - l, p = o ? n.rotate : -n.rotate, c = n.depth, u = 0, h = i.length; u < h; u += 1){
                var v = i.eq(u), f = r[u], m = (d - v[0].swiperSlideOffset - f / 2) / f * n.modifier, g = o ? p * m : 0, b = o ? 0 : p * m, w = -c * Math.abs(m), y = o ? 0 : n.stretch * m, x = o ? n.stretch * m : 0;
                Math.abs(x) < 0.001 && (x = 0), Math.abs(y) < 0.001 && (y = 0), Math.abs(w) < 0.001 && (w = 0), Math.abs(g) < 0.001 && (g = 0), Math.abs(b) < 0.001 && (b = 0);
                var T = 'translate3d(' + x + 'px,' + y + 'px,' + w + 'px)  rotateX(' + b + 'deg) rotateY(' + g + 'deg)';
                if (v.transform(T), v[0].style.zIndex = 1 - Math.abs(Math.round(m)), n.slideShadows) {
                    var E = o ? v.find('.swiper-slide-shadow-left') : v.find('.swiper-slide-shadow-top'), S = o ? v.find('.swiper-slide-shadow-right') : v.find('.swiper-slide-shadow-bottom');
                    0 === E.length && (E = L('<div class="swiper-slide-shadow-' + (o ? 'left' : 'top') + '"></div>'), v.append(E)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (o ? 'right' : 'bottom') + '"></div>'), v.append(S)), E.length && (E[0].style.opacity = 0 < m ? m : 0), S.length && (S[0].style.opacity = 0 < -m ? -m : 0);
                }
            }
            (ae.pointerEvents || ae.prefixedPointerEvents) && (s[0].style.perspectiveOrigin = d + 'px 50%');
        },
        setTransition: function(e) {
            this.slides.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e);
        }
    }, Q = {
        init: function() {
            var e = this, t = e.params.thumbs, a = e.constructor;
            t.swiper instanceof a ? (e.thumbs.swiper = t.swiper, te.extend(e.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            }), te.extend(e.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })) : te.isObject(t.swiper) && (e.thumbs.swiper = new a(te.extend({}, t.swiper, {
                watchSlidesVisibility: !0,
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })), e.thumbs.swiperCreated = !0), e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on('tap', e.thumbs.onThumbClick);
        },
        onThumbClick: function() {
            var e = this, t = e.thumbs.swiper;
            if (t) {
                var a = t.clickedIndex, i = t.clickedSlide;
                if (!(i && L(i).hasClass(e.params.thumbs.slideThumbActiveClass) || null == a)) {
                    var s;
                    if (s = t.params.loop ? parseInt(L(t.clickedSlide).attr('data-swiper-slide-index'), 10) : a, e.params.loop) {
                        var r = e.activeIndex;
                        e.slides.eq(r).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), e._clientLeft = e.$wrapperEl[0].clientLeft, r = e.activeIndex);
                        var n = e.slides.eq(r).prevAll('[data-swiper-slide-index="' + s + '"]').eq(0).index(), o = e.slides.eq(r).nextAll('[data-swiper-slide-index="' + s + '"]').eq(0).index();
                        s = void 0 === n ? o : void 0 === o ? n : o - r < r - n ? o : n;
                    }
                    e.slideTo(s);
                }
            }
        },
        update: function(e) {
            var t = this, a = t.thumbs.swiper;
            if (a) {
                var i = 'auto' === a.params.slidesPerView ? a.slidesPerViewDynamic() : a.params.slidesPerView;
                if (t.realIndex !== a.realIndex) {
                    var s, r = a.activeIndex;
                    if (a.params.loop) {
                        a.slides.eq(r).hasClass(a.params.slideDuplicateClass) && (a.loopFix(), a._clientLeft = a.$wrapperEl[0].clientLeft, r = a.activeIndex);
                        var n = a.slides.eq(r).prevAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index(), o = a.slides.eq(r).nextAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index();
                        s = void 0 === n ? o : void 0 === o ? n : o - r == r - n ? r : o - r < r - n ? o : n;
                    } else s = t.realIndex;
                    a.visibleSlidesIndexes && a.visibleSlidesIndexes.indexOf(s) < 0 && (a.params.centeredSlides ? s = r < s ? s - Math.floor(i / 2) + 1 : s + Math.floor(i / 2) - 1 : r < s && (s = s - i + 1), a.slideTo(s, e ? 0 : void 0));
                }
                var l = 1, d = t.params.thumbs.slideThumbActiveClass;
                if (1 < t.params.slidesPerView && !t.params.centeredSlides && (l = t.params.slidesPerView), a.slides.removeClass(d), a.params.loop || a.params.virtual) for(var p = 0; p < l; p += 1)a.$wrapperEl.children('[data-swiper-slide-index="' + (t.realIndex + p) + '"]').addClass(d);
                else for(var c = 0; c < l; c += 1)a.slides.eq(t.realIndex + c).addClass(d);
            }
        }
    }, J = [
        C,
        M,
        P,
        k,
        $,
        D,
        A,
        {
            name: 'mousewheel',
            params: {
                mousewheel: {
                    enabled: !1,
                    releaseOnEdges: !1,
                    invert: !1,
                    forceToAxis: !1,
                    sensitivity: 1,
                    eventsTarged: 'container'
                }
            },
            create: function() {
                var e = this;
                te.extend(e, {
                    mousewheel: {
                        enabled: !1,
                        enable: H.enable.bind(e),
                        disable: H.disable.bind(e),
                        handle: H.handle.bind(e),
                        handleMouseEnter: H.handleMouseEnter.bind(e),
                        handleMouseLeave: H.handleMouseLeave.bind(e),
                        lastScrollTime: te.now()
                    }
                });
            },
            on: {
                init: function() {
                    this.params.mousewheel.enabled && this.mousewheel.enable();
                },
                destroy: function() {
                    this.mousewheel.enabled && this.mousewheel.disable();
                }
            }
        },
        {
            name: 'navigation',
            params: {
                navigation: {
                    nextEl: null,
                    prevEl: null,
                    hideOnClick: !1,
                    disabledClass: 'swiper-button-disabled',
                    hiddenClass: 'swiper-button-hidden',
                    lockClass: 'swiper-button-lock'
                }
            },
            create: function() {
                var e = this;
                te.extend(e, {
                    navigation: {
                        init: G.init.bind(e),
                        update: G.update.bind(e),
                        destroy: G.destroy.bind(e),
                        onNextClick: G.onNextClick.bind(e),
                        onPrevClick: G.onPrevClick.bind(e)
                    }
                });
            },
            on: {
                init: function() {
                    this.navigation.init(), this.navigation.update();
                },
                toEdge: function() {
                    this.navigation.update();
                },
                fromEdge: function() {
                    this.navigation.update();
                },
                destroy: function() {
                    this.navigation.destroy();
                },
                click: function(e) {
                    var t, a = this, i = a.navigation, s = i.$nextEl, r = i.$prevEl;
                    !a.params.navigation.hideOnClick || L(e.target).is(r) || L(e.target).is(s) || (s ? t = s.hasClass(a.params.navigation.hiddenClass) : r && (t = r.hasClass(a.params.navigation.hiddenClass)), !0 === t ? a.emit('navigationShow', a) : a.emit('navigationHide', a), s && s.toggleClass(a.params.navigation.hiddenClass), r && r.toggleClass(a.params.navigation.hiddenClass));
                }
            }
        },
        {
            name: 'pagination',
            params: {
                pagination: {
                    el: null,
                    bulletElement: 'span',
                    clickable: !1,
                    hideOnClick: !1,
                    renderBullet: null,
                    renderProgressbar: null,
                    renderFraction: null,
                    renderCustom: null,
                    progressbarOpposite: !1,
                    type: 'bullets',
                    dynamicBullets: !1,
                    dynamicMainBullets: 1,
                    formatFractionCurrent: function(e) {
                        return e;
                    },
                    formatFractionTotal: function(e) {
                        return e;
                    },
                    bulletClass: 'swiper-pagination-bullet',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    modifierClass: 'swiper-pagination-',
                    currentClass: 'swiper-pagination-current',
                    totalClass: 'swiper-pagination-total',
                    hiddenClass: 'swiper-pagination-hidden',
                    progressbarFillClass: 'swiper-pagination-progressbar-fill',
                    progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
                    clickableClass: 'swiper-pagination-clickable',
                    lockClass: 'swiper-pagination-lock'
                }
            },
            create: function() {
                var e = this;
                te.extend(e, {
                    pagination: {
                        init: N.init.bind(e),
                        render: N.render.bind(e),
                        update: N.update.bind(e),
                        destroy: N.destroy.bind(e),
                        dynamicBulletIndex: 0
                    }
                });
            },
            on: {
                init: function() {
                    this.pagination.init(), this.pagination.render(), this.pagination.update();
                },
                activeIndexChange: function() {
                    this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update();
                },
                snapIndexChange: function() {
                    this.params.loop || this.pagination.update();
                },
                slidesLengthChange: function() {
                    this.params.loop && (this.pagination.render(), this.pagination.update());
                },
                snapGridLengthChange: function() {
                    this.params.loop || (this.pagination.render(), this.pagination.update());
                },
                destroy: function() {
                    this.pagination.destroy();
                },
                click: function(e) {
                    var t = this;
                    t.params.pagination.el && t.params.pagination.hideOnClick && 0 < t.pagination.$el.length && !L(e.target).hasClass(t.params.pagination.bulletClass) && (!0 === t.pagination.$el.hasClass(t.params.pagination.hiddenClass) ? t.emit('paginationShow', t) : t.emit('paginationHide', t), t.pagination.$el.toggleClass(t.params.pagination.hiddenClass));
                }
            }
        },
        {
            name: 'scrollbar',
            params: {
                scrollbar: {
                    el: null,
                    dragSize: 'auto',
                    hide: !1,
                    draggable: !1,
                    snapOnRelease: !0,
                    lockClass: 'swiper-scrollbar-lock',
                    dragClass: 'swiper-scrollbar-drag'
                }
            },
            create: function() {
                var e = this;
                te.extend(e, {
                    scrollbar: {
                        init: B.init.bind(e),
                        destroy: B.destroy.bind(e),
                        updateSize: B.updateSize.bind(e),
                        setTranslate: B.setTranslate.bind(e),
                        setTransition: B.setTransition.bind(e),
                        enableDraggable: B.enableDraggable.bind(e),
                        disableDraggable: B.disableDraggable.bind(e),
                        setDragPosition: B.setDragPosition.bind(e),
                        getPointerPosition: B.getPointerPosition.bind(e),
                        onDragStart: B.onDragStart.bind(e),
                        onDragMove: B.onDragMove.bind(e),
                        onDragEnd: B.onDragEnd.bind(e),
                        isTouched: !1,
                        timeout: null,
                        dragTimeout: null
                    }
                });
            },
            on: {
                init: function() {
                    this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate();
                },
                update: function() {
                    this.scrollbar.updateSize();
                },
                resize: function() {
                    this.scrollbar.updateSize();
                },
                observerUpdate: function() {
                    this.scrollbar.updateSize();
                },
                setTranslate: function() {
                    this.scrollbar.setTranslate();
                },
                setTransition: function(e) {
                    this.scrollbar.setTransition(e);
                },
                destroy: function() {
                    this.scrollbar.destroy();
                }
            }
        },
        {
            name: 'parallax',
            params: {
                parallax: {
                    enabled: !1
                }
            },
            create: function() {
                te.extend(this, {
                    parallax: {
                        setTransform: X.setTransform.bind(this),
                        setTranslate: X.setTranslate.bind(this),
                        setTransition: X.setTransition.bind(this)
                    }
                });
            },
            on: {
                beforeInit: function() {
                    this.params.parallax.enabled && (this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0);
                },
                init: function() {
                    this.params.parallax.enabled && this.parallax.setTranslate();
                },
                setTranslate: function() {
                    this.params.parallax.enabled && this.parallax.setTranslate();
                },
                setTransition: function(e) {
                    this.params.parallax.enabled && this.parallax.setTransition(e);
                }
            }
        },
        {
            name: 'zoom',
            params: {
                zoom: {
                    enabled: !1,
                    maxRatio: 3,
                    minRatio: 1,
                    toggle: !0,
                    containerClass: 'swiper-zoom-container',
                    zoomedSlideClass: 'swiper-slide-zoomed'
                }
            },
            create: function() {
                var i = this, t = {
                    enabled: !1,
                    scale: 1,
                    currentScale: 1,
                    isScaling: !1,
                    gesture: {
                        $slideEl: void 0,
                        slideWidth: void 0,
                        slideHeight: void 0,
                        $imageEl: void 0,
                        $imageWrapEl: void 0,
                        maxRatio: 3
                    },
                    image: {
                        isTouched: void 0,
                        isMoved: void 0,
                        currentX: void 0,
                        currentY: void 0,
                        minX: void 0,
                        minY: void 0,
                        maxX: void 0,
                        maxY: void 0,
                        width: void 0,
                        height: void 0,
                        startX: void 0,
                        startY: void 0,
                        touchesStart: {},
                        touchesCurrent: {}
                    },
                    velocity: {
                        x: void 0,
                        y: void 0,
                        prevPositionX: void 0,
                        prevPositionY: void 0,
                        prevTime: void 0
                    }
                };
                'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function(e) {
                    t[e] = V[e].bind(i);
                }), te.extend(i, {
                    zoom: t
                });
                var s = 1;
                Object.defineProperty(i.zoom, 'scale', {
                    get: function() {
                        return s;
                    },
                    set: function(e) {
                        if (s !== e) {
                            var t = i.zoom.gesture.$imageEl ? i.zoom.gesture.$imageEl[0] : void 0, a = i.zoom.gesture.$slideEl ? i.zoom.gesture.$slideEl[0] : void 0;
                            i.emit('zoomChange', e, t, a);
                        }
                        s = e;
                    }
                });
            },
            on: {
                init: function() {
                    this.params.zoom.enabled && this.zoom.enable();
                },
                destroy: function() {
                    this.zoom.disable();
                },
                touchStart: function(e) {
                    this.zoom.enabled && this.zoom.onTouchStart(e);
                },
                touchEnd: function(e) {
                    this.zoom.enabled && this.zoom.onTouchEnd(e);
                },
                doubleTap: function(e) {
                    this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(e);
                },
                transitionEnd: function() {
                    this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd();
                }
            }
        },
        {
            name: 'lazy',
            params: {
                lazy: {
                    enabled: !1,
                    loadPrevNext: !1,
                    loadPrevNextAmount: 1,
                    loadOnTransitionStart: !1,
                    elementClass: 'swiper-lazy',
                    loadingClass: 'swiper-lazy-loading',
                    loadedClass: 'swiper-lazy-loaded',
                    preloaderClass: 'swiper-lazy-preloader'
                }
            },
            create: function() {
                te.extend(this, {
                    lazy: {
                        initialImageLoaded: !1,
                        load: Y.load.bind(this),
                        loadInSlide: Y.loadInSlide.bind(this)
                    }
                });
            },
            on: {
                beforeInit: function() {
                    this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1);
                },
                init: function() {
                    this.params.lazy.enabled && !this.params.loop && 0 === this.params.initialSlide && this.lazy.load();
                },
                scroll: function() {
                    this.params.freeMode && !this.params.freeModeSticky && this.lazy.load();
                },
                resize: function() {
                    this.params.lazy.enabled && this.lazy.load();
                },
                scrollbarDragMove: function() {
                    this.params.lazy.enabled && this.lazy.load();
                },
                transitionStart: function() {
                    var e = this;
                    e.params.lazy.enabled && (!e.params.lazy.loadOnTransitionStart && (e.params.lazy.loadOnTransitionStart || e.lazy.initialImageLoaded) || e.lazy.load());
                },
                transitionEnd: function() {
                    this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load();
                }
            }
        },
        {
            name: 'controller',
            params: {
                controller: {
                    control: void 0,
                    inverse: !1,
                    by: 'slide'
                }
            },
            create: function() {
                var e = this;
                te.extend(e, {
                    controller: {
                        control: e.params.controller.control,
                        getInterpolateFunction: F.getInterpolateFunction.bind(e),
                        setTranslate: F.setTranslate.bind(e),
                        setTransition: F.setTransition.bind(e)
                    }
                });
            },
            on: {
                update: function() {
                    this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
                },
                resize: function() {
                    this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
                },
                observerUpdate: function() {
                    this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
                },
                setTranslate: function(e, t) {
                    this.controller.control && this.controller.setTranslate(e, t);
                },
                setTransition: function(e, t) {
                    this.controller.control && this.controller.setTransition(e, t);
                }
            }
        },
        {
            name: 'a11y',
            params: {
                a11y: {
                    enabled: !0,
                    notificationClass: 'swiper-notification',
                    prevSlideMessage: 'Previous slide',
                    nextSlideMessage: 'Next slide',
                    firstSlideMessage: 'This is the first slide',
                    lastSlideMessage: 'This is the last slide',
                    paginationBulletMessage: 'Go to slide {{index}}'
                }
            },
            create: function() {
                var t = this;
                te.extend(t, {
                    a11y: {
                        liveRegion: L('<span class="' + t.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
                    }
                }), Object.keys(R).forEach(function(e) {
                    t.a11y[e] = R[e].bind(t);
                });
            },
            on: {
                init: function() {
                    this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation());
                },
                toEdge: function() {
                    this.params.a11y.enabled && this.a11y.updateNavigation();
                },
                fromEdge: function() {
                    this.params.a11y.enabled && this.a11y.updateNavigation();
                },
                paginationUpdate: function() {
                    this.params.a11y.enabled && this.a11y.updatePagination();
                },
                destroy: function() {
                    this.params.a11y.enabled && this.a11y.destroy();
                }
            }
        },
        {
            name: 'history',
            params: {
                history: {
                    enabled: !1,
                    replaceState: !1,
                    key: 'slides'
                }
            },
            create: function() {
                var e = this;
                te.extend(e, {
                    history: {
                        init: q.init.bind(e),
                        setHistory: q.setHistory.bind(e),
                        setHistoryPopState: q.setHistoryPopState.bind(e),
                        scrollToSlide: q.scrollToSlide.bind(e),
                        destroy: q.destroy.bind(e)
                    }
                });
            },
            on: {
                init: function() {
                    this.params.history.enabled && this.history.init();
                },
                destroy: function() {
                    this.params.history.enabled && this.history.destroy();
                },
                transitionEnd: function() {
                    this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex);
                }
            }
        },
        {
            name: 'hash-navigation',
            params: {
                hashNavigation: {
                    enabled: !1,
                    replaceState: !1,
                    watchState: !1
                }
            },
            create: function() {
                var e = this;
                te.extend(e, {
                    hashNavigation: {
                        initialized: !1,
                        init: W.init.bind(e),
                        destroy: W.destroy.bind(e),
                        setHash: W.setHash.bind(e),
                        onHashCange: W.onHashCange.bind(e)
                    }
                });
            },
            on: {
                init: function() {
                    this.params.hashNavigation.enabled && this.hashNavigation.init();
                },
                destroy: function() {
                    this.params.hashNavigation.enabled && this.hashNavigation.destroy();
                },
                transitionEnd: function() {
                    this.hashNavigation.initialized && this.hashNavigation.setHash();
                }
            }
        },
        {
            name: 'autoplay',
            params: {
                autoplay: {
                    enabled: !1,
                    delay: 3e3,
                    waitForTransition: !0,
                    disableOnInteraction: !0,
                    stopOnLastSlide: !1,
                    reverseDirection: !1
                }
            },
            create: function() {
                var t = this;
                te.extend(t, {
                    autoplay: {
                        running: !1,
                        paused: !1,
                        run: j.run.bind(t),
                        start: j.start.bind(t),
                        stop: j.stop.bind(t),
                        pause: j.pause.bind(t),
                        onTransitionEnd: function(e) {
                            t && !t.destroyed && t.$wrapperEl && e.target === this && (t.$wrapperEl[0].removeEventListener('transitionend', t.autoplay.onTransitionEnd), t.$wrapperEl[0].removeEventListener('webkitTransitionEnd', t.autoplay.onTransitionEnd), t.autoplay.paused = !1, t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
                        }
                    }
                });
            },
            on: {
                init: function() {
                    this.params.autoplay.enabled && this.autoplay.start();
                },
                beforeTransitionStart: function(e, t) {
                    this.autoplay.running && (t || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(e) : this.autoplay.stop());
                },
                sliderFirstMove: function() {
                    this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause());
                },
                destroy: function() {
                    this.autoplay.running && this.autoplay.stop();
                }
            }
        },
        {
            name: 'effect-fade',
            params: {
                fadeEffect: {
                    crossFade: !1
                }
            },
            create: function() {
                te.extend(this, {
                    fadeEffect: {
                        setTranslate: U.setTranslate.bind(this),
                        setTransition: U.setTransition.bind(this)
                    }
                });
            },
            on: {
                beforeInit: function() {
                    var e = this;
                    if ('fade' === e.params.effect) {
                        e.classNames.push(e.params.containerModifierClass + 'fade');
                        var t = {
                            slidesPerView: 1,
                            slidesPerColumn: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            spaceBetween: 0,
                            virtualTranslate: !0
                        };
                        te.extend(e.params, t), te.extend(e.originalParams, t);
                    }
                },
                setTranslate: function() {
                    'fade' === this.params.effect && this.fadeEffect.setTranslate();
                },
                setTransition: function(e) {
                    'fade' === this.params.effect && this.fadeEffect.setTransition(e);
                }
            }
        },
        {
            name: 'effect-cube',
            params: {
                cubeEffect: {
                    slideShadows: !0,
                    shadow: !0,
                    shadowOffset: 20,
                    shadowScale: 0.94
                }
            },
            create: function() {
                te.extend(this, {
                    cubeEffect: {
                        setTranslate: K.setTranslate.bind(this),
                        setTransition: K.setTransition.bind(this)
                    }
                });
            },
            on: {
                beforeInit: function() {
                    var e = this;
                    if ('cube' === e.params.effect) {
                        e.classNames.push(e.params.containerModifierClass + 'cube'), e.classNames.push(e.params.containerModifierClass + '3d');
                        var t = {
                            slidesPerView: 1,
                            slidesPerColumn: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            resistanceRatio: 0,
                            spaceBetween: 0,
                            centeredSlides: !1,
                            virtualTranslate: !0
                        };
                        te.extend(e.params, t), te.extend(e.originalParams, t);
                    }
                },
                setTranslate: function() {
                    'cube' === this.params.effect && this.cubeEffect.setTranslate();
                },
                setTransition: function(e) {
                    'cube' === this.params.effect && this.cubeEffect.setTransition(e);
                }
            }
        },
        {
            name: 'effect-flip',
            params: {
                flipEffect: {
                    slideShadows: !0,
                    limitRotation: !0
                }
            },
            create: function() {
                te.extend(this, {
                    flipEffect: {
                        setTranslate: _.setTranslate.bind(this),
                        setTransition: _.setTransition.bind(this)
                    }
                });
            },
            on: {
                beforeInit: function() {
                    var e = this;
                    if ('flip' === e.params.effect) {
                        e.classNames.push(e.params.containerModifierClass + 'flip'), e.classNames.push(e.params.containerModifierClass + '3d');
                        var t = {
                            slidesPerView: 1,
                            slidesPerColumn: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            spaceBetween: 0,
                            virtualTranslate: !0
                        };
                        te.extend(e.params, t), te.extend(e.originalParams, t);
                    }
                },
                setTranslate: function() {
                    'flip' === this.params.effect && this.flipEffect.setTranslate();
                },
                setTransition: function(e) {
                    'flip' === this.params.effect && this.flipEffect.setTransition(e);
                }
            }
        },
        {
            name: 'effect-coverflow',
            params: {
                coverflowEffect: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: !0
                }
            },
            create: function() {
                te.extend(this, {
                    coverflowEffect: {
                        setTranslate: Z.setTranslate.bind(this),
                        setTransition: Z.setTransition.bind(this)
                    }
                });
            },
            on: {
                beforeInit: function() {
                    var e = this;
                    'coverflow' === e.params.effect && (e.classNames.push(e.params.containerModifierClass + 'coverflow'), e.classNames.push(e.params.containerModifierClass + '3d'), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
                },
                setTranslate: function() {
                    'coverflow' === this.params.effect && this.coverflowEffect.setTranslate();
                },
                setTransition: function(e) {
                    'coverflow' === this.params.effect && this.coverflowEffect.setTransition(e);
                }
            }
        },
        {
            name: 'thumbs',
            params: {
                thumbs: {
                    swiper: null,
                    slideThumbActiveClass: 'swiper-slide-thumb-active',
                    thumbsContainerClass: 'swiper-container-thumbs'
                }
            },
            create: function() {
                te.extend(this, {
                    thumbs: {
                        swiper: null,
                        init: Q.init.bind(this),
                        update: Q.update.bind(this),
                        onThumbClick: Q.onThumbClick.bind(this)
                    }
                });
            },
            on: {
                beforeInit: function() {
                    var e = this.params.thumbs;
                    e && e.swiper && (this.thumbs.init(), this.thumbs.update(!0));
                },
                slideChange: function() {
                    this.thumbs.swiper && this.thumbs.update();
                },
                update: function() {
                    this.thumbs.swiper && this.thumbs.update();
                },
                resize: function() {
                    this.thumbs.swiper && this.thumbs.update();
                },
                observerUpdate: function() {
                    this.thumbs.swiper && this.thumbs.update();
                },
                setTransition: function(e) {
                    var t = this.thumbs.swiper;
                    t && t.setTransition(e);
                },
                beforeDestroy: function() {
                    var e = this.thumbs.swiper;
                    e && this.thumbs.swiperCreated && e && e.destroy();
                }
            }
        }
    ];
    return void 0 === S.use && (S.use = S.Class.use, S.installModule = S.Class.installModule), S.use(J), S;
}); //# sourceMappingURL=swiper.min.js.map

});


parcelRegister("b22ca", function(module, exports) {
var $80819585fec4be1c$var$__defProp = Object.defineProperty;
var $80819585fec4be1c$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $80819585fec4be1c$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $80819585fec4be1c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $80819585fec4be1c$var$__export = (target, all)=>{
    for(var name in all)$80819585fec4be1c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $80819585fec4be1c$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $80819585fec4be1c$var$__getOwnPropNames(from))if (!$80819585fec4be1c$var$__hasOwnProp.call(to, key) && key !== except) $80819585fec4be1c$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $80819585fec4be1c$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $80819585fec4be1c$var$__toCommonJS = (mod)=>$80819585fec4be1c$var$__copyProps($80819585fec4be1c$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $80819585fec4be1c$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $80819585fec4be1c$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $80819585fec4be1c$var$__defProp(target, key, result);
    return result;
};
var $80819585fec4be1c$var$generic_menu_exports = {};
$80819585fec4be1c$var$__export($80819585fec4be1c$var$generic_menu_exports, {
    GenericMenuComponent: ()=>$80819585fec4be1c$var$GenericMenuComponent
});
module.exports = $80819585fec4be1c$var$__toCommonJS($80819585fec4be1c$var$generic_menu_exports);

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $ihXbv = parcelRequire("ihXbv");

var $bq6Hs = parcelRequire("bq6Hs");

var $eh7Ut = parcelRequire("eh7Ut");
class $80819585fec4be1c$var$GenericMenuComponent extends $4TeKW.LitElement {
    constructor(template, cards = new $bq6Hs.BehaviorSubject([]), options = new $bq6Hs.BehaviorSubject({})){
        super();
        this.template = template;
        this.cards = cards;
        this.options = options;
    }
    render() {
        if (this.template) return this.template;
        throw new Error("Please specifiy generic template");
    }
    OnInit() {
        this.openDialog().subscribe();
    }
    openDialog() {
        return this.modalProvider.openComponent($eh7Ut.GenericModal, {
            cards: this.cards,
            options: this.options
        }, {
            backdropClose: true,
            style: $4TeKW.css`
          .wrapper {
            position: fixed;
            top: 0;
            left: 0;
            align-items: center;
            justify-content: center;
            pointer-events: none;
            width: 100%;
            height: 100%;
            z-index: 1000;
          }

          @keyframes scale {
            from {
              transform: scale(0.4);
            }
            to {
              transform: scale(1);
            }
          }

          @keyframes blur {
            to {
              backdrop-filter: blur(20px);
            }
          }

          .backdrop {
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            position: absolute;
            pointer-events: all;
            z-index: 10;
            backdrop-filter: blur(25px);
            /* animation: blur 1s linear forwards; */
          }

          .content {
            z-index: 20;
            position: absolute;
            width: 100%;
            height: 100%;
            pointer-events: all;
          }
        `
        });
    }
}
$80819585fec4be1c$var$__decorateClass([
    (0, $1t8Wn.Inject)($ihXbv.ModalService)
], $80819585fec4be1c$var$GenericMenuComponent.prototype, "modalProvider", 2);

});

parcelRegister("e6J6o", function(module, exports) {
var $a4549c93693d2558$var$__defProp = Object.defineProperty;
var $a4549c93693d2558$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $a4549c93693d2558$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $a4549c93693d2558$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a4549c93693d2558$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $a4549c93693d2558$var$__getOwnPropNames(from))if (!$a4549c93693d2558$var$__hasOwnProp.call(to, key) && key !== except) $a4549c93693d2558$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $a4549c93693d2558$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $a4549c93693d2558$var$__toCommonJS = (mod)=>$a4549c93693d2558$var$__copyProps($a4549c93693d2558$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $a4549c93693d2558$var$menu_interface_exports = {};
module.exports = $a4549c93693d2558$var$__toCommonJS($a4549c93693d2558$var$menu_interface_exports);

});


parcelRegister("6L3Th", function(module, exports) {
var $4eba2671413041f2$var$__defProp = Object.defineProperty;
var $4eba2671413041f2$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $4eba2671413041f2$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $4eba2671413041f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4eba2671413041f2$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $4eba2671413041f2$var$__getOwnPropNames(from))if (!$4eba2671413041f2$var$__hasOwnProp.call(to, key) && key !== except) $4eba2671413041f2$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $4eba2671413041f2$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $4eba2671413041f2$var$__reExport = (target, mod, secondTarget)=>($4eba2671413041f2$var$__copyProps(target, mod, "default"), secondTarget && $4eba2671413041f2$var$__copyProps(secondTarget, mod, "default"));
var $4eba2671413041f2$var$__toCommonJS = (mod)=>$4eba2671413041f2$var$__copyProps($4eba2671413041f2$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $4eba2671413041f2$var$decorators_exports = {};
module.exports = $4eba2671413041f2$var$__toCommonJS($4eba2671413041f2$var$decorators_exports);

$4eba2671413041f2$var$__reExport($4eba2671413041f2$var$decorators_exports, (parcelRequire("8d4zd")), module.exports);

});
parcelRegister("8d4zd", function(module, exports) {
var $5fa3148943e4fd9b$var$__defProp = Object.defineProperty;
var $5fa3148943e4fd9b$var$__defProps = Object.defineProperties;
var $5fa3148943e4fd9b$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $5fa3148943e4fd9b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5fa3148943e4fd9b$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $5fa3148943e4fd9b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5fa3148943e4fd9b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5fa3148943e4fd9b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5fa3148943e4fd9b$var$__defNormalProp = (obj, key, value)=>key in obj ? $5fa3148943e4fd9b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5fa3148943e4fd9b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5fa3148943e4fd9b$var$__hasOwnProp.call(b, prop)) $5fa3148943e4fd9b$var$__defNormalProp(a, prop, b[prop]);
    if ($5fa3148943e4fd9b$var$__getOwnPropSymbols) {
        for (var prop of $5fa3148943e4fd9b$var$__getOwnPropSymbols(b))if ($5fa3148943e4fd9b$var$__propIsEnum.call(b, prop)) $5fa3148943e4fd9b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5fa3148943e4fd9b$var$__spreadProps = (a, b)=>$5fa3148943e4fd9b$var$__defProps(a, $5fa3148943e4fd9b$var$__getOwnPropDescs(b));
var $5fa3148943e4fd9b$var$__export = (target, all)=>{
    for(var name in all)$5fa3148943e4fd9b$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $5fa3148943e4fd9b$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $5fa3148943e4fd9b$var$__getOwnPropNames(from))if (!$5fa3148943e4fd9b$var$__hasOwnProp.call(to, key) && key !== except) $5fa3148943e4fd9b$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $5fa3148943e4fd9b$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $5fa3148943e4fd9b$var$__toCommonJS = (mod)=>$5fa3148943e4fd9b$var$__copyProps($5fa3148943e4fd9b$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $5fa3148943e4fd9b$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $5fa3148943e4fd9b$var$view_exports = {};
$5fa3148943e4fd9b$var$__export($5fa3148943e4fd9b$var$view_exports, {
    View: ()=>$5fa3148943e4fd9b$var$View
});
module.exports = $5fa3148943e4fd9b$var$__toCommonJS($5fa3148943e4fd9b$var$view_exports);

var $613YX = parcelRequire("613YX");

var $8MKp4 = parcelRequire("8MKp4");
const $5fa3148943e4fd9b$var$hashCode = (s)=>s.split("").reduce((acc, curr)=>{
        acc = (acc << 5) - acc + curr.charCodeAt(0);
        return acc & acc;
    }, 0);
const $5fa3148943e4fd9b$var$generateSelector = (Base, options)=>String.fromCharCode(...Math.abs($5fa3148943e4fd9b$var$hashCode(`${Base}${JSON.stringify(options)}`)).toString().split("").map((x)=>+x + 97));
const $5fa3148943e4fd9b$var$View = (options, config)=>(Base)=>{
        const generator = $5fa3148943e4fd9b$var$generateSelector(Base, options);
        let selector = [
            generator,
            "-",
            generator
        ].join("");
        if (options.selector) selector = options.selector;
        const component = customElements.get(selector);
        if (component) return component;
        return (0, $613YX.Component)({
            Settings: $5fa3148943e4fd9b$var$__spreadProps($5fa3148943e4fd9b$var$__spreadValues({}, config), {
                selector: selector
            })
        })(class extends Base {
            OnUpdateFirst() {
                return $5fa3148943e4fd9b$var$__async(this, null, function*() {
                    let cards = yield options.cards.call(this, options.deps || options.Providers);
                    if ((0, $8MKp4.isObservable)(cards)) cards = yield cards.toPromise();
                    this.cards.next(cards);
                });
            }
        });
    };

});


parcelRegister("4XFmu", function(module, exports) {
var $39ccc1ad58580cf7$var$__defProp = Object.defineProperty;
var $39ccc1ad58580cf7$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $39ccc1ad58580cf7$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $39ccc1ad58580cf7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $39ccc1ad58580cf7$var$__export = (target, all)=>{
    for(var name in all)$39ccc1ad58580cf7$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $39ccc1ad58580cf7$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $39ccc1ad58580cf7$var$__getOwnPropNames(from))if (!$39ccc1ad58580cf7$var$__hasOwnProp.call(to, key) && key !== except) $39ccc1ad58580cf7$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $39ccc1ad58580cf7$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $39ccc1ad58580cf7$var$__toCommonJS = (mod)=>$39ccc1ad58580cf7$var$__copyProps($39ccc1ad58580cf7$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $39ccc1ad58580cf7$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $39ccc1ad58580cf7$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $39ccc1ad58580cf7$var$__defProp(target, key, result);
    return result;
};
var $39ccc1ad58580cf7$var$apps_modal_exports = {};
$39ccc1ad58580cf7$var$__export($39ccc1ad58580cf7$var$apps_modal_exports, {
    AppsModalComponent: ()=>$39ccc1ad58580cf7$var$AppsModalComponent
});
module.exports = $39ccc1ad58580cf7$var$__toCommonJS($39ccc1ad58580cf7$var$apps_modal_exports);

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $l1oGi = parcelRequire("l1oGi");

var $b22ca = parcelRequire("b22ca");
const $39ccc1ad58580cf7$var$_AppsModalComponent = class extends $b22ca.GenericMenuComponent {
    constructor(cards, options){
        super($4TeKW.html`<pages-menu-component></pages-menu-component>`, cards, options || $39ccc1ad58580cf7$var$_AppsModalComponent.appsService.options);
    }
};
let $39ccc1ad58580cf7$var$AppsModalComponent = $39ccc1ad58580cf7$var$_AppsModalComponent;
$39ccc1ad58580cf7$var$__decorateClass([
    (0, $1t8Wn.Inject)($l1oGi.AppsService)
], $39ccc1ad58580cf7$var$AppsModalComponent, "appsService", 2);

});
parcelRegister("l1oGi", function(module, exports) {
var $f4dcd62823b7d8be$var$__defProp = Object.defineProperty;
var $f4dcd62823b7d8be$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $f4dcd62823b7d8be$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $f4dcd62823b7d8be$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f4dcd62823b7d8be$var$__export = (target, all)=>{
    for(var name in all)$f4dcd62823b7d8be$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $f4dcd62823b7d8be$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $f4dcd62823b7d8be$var$__getOwnPropNames(from))if (!$f4dcd62823b7d8be$var$__hasOwnProp.call(to, key) && key !== except) $f4dcd62823b7d8be$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $f4dcd62823b7d8be$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $f4dcd62823b7d8be$var$__toCommonJS = (mod)=>$f4dcd62823b7d8be$var$__copyProps($f4dcd62823b7d8be$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $f4dcd62823b7d8be$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $f4dcd62823b7d8be$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $f4dcd62823b7d8be$var$__defProp(target, key, result);
    return result;
};
var $f4dcd62823b7d8be$var$apps_service_exports = {};
$f4dcd62823b7d8be$var$__export($f4dcd62823b7d8be$var$apps_service_exports, {
    AppsService: ()=>$f4dcd62823b7d8be$var$AppsService
});
module.exports = $f4dcd62823b7d8be$var$__toCommonJS($f4dcd62823b7d8be$var$apps_service_exports);

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
let $f4dcd62823b7d8be$var$AppsService = class {
    constructor(){
        this.selectedIndex = new $bq6Hs.BehaviorSubject(0);
        this.options = new $bq6Hs.BehaviorSubject({
            swiper: {
                effect: "coverflow"
            },
            disableAnimations: false,
            animations: {
                speed: {
                    slideOutUp: 300,
                    zoomIn: 300,
                    zoomOut: 300
                }
            }
        });
    }
    OnInit() {
        const exists = this.getLocalStorage();
        if (exists) this.options.next(JSON.parse(exists));
        else this.updateLocalStorage();
    }
    getOptionsAsObservable() {
        return this.options.asObservable();
    }
    setOptions(options) {
        this.options.next(options);
        this.updateLocalStorage();
    }
    toggleAnimations() {
        const options = this.options.getValue();
        options.disableAnimations = !options.disableAnimations;
        this.options.next(options);
        this.updateLocalStorage();
    }
    toggleBlur() {
        const options = this.options.getValue();
        options.backgroundBlur = !options.backgroundBlur;
        this.options.next(options);
        this.updateLocalStorage();
    }
    setBlur(value) {
        const options = this.options.getValue();
        options.backgroundBlur = value;
        this.options.next(options);
        this.updateLocalStorage();
    }
    setAnimations(value) {
        const options = this.options.getValue();
        options.disableAnimations = !value;
        this.options.next(options);
        this.updateLocalStorage();
    }
    setBackUrl(value) {
        const options = this.options.getValue();
        options.routerBackUrl = value;
        this.options.next(options);
        this.updateLocalStorage();
    }
    getLocalStorage() {
        return localStorage.getItem("apps-options");
    }
    updateLocalStorage() {
        localStorage.setItem("apps-options", JSON.stringify(this.options.getValue()));
    }
};
$f4dcd62823b7d8be$var$AppsService = $f4dcd62823b7d8be$var$__decorateClass([
    (0, $1t8Wn.Injectable)()
], $f4dcd62823b7d8be$var$AppsService);

});



parcelRegister("83JTn", function(module, exports) {
module.exports = JSON.parse('{"Can i translate this ?":"\u0647\u0644 \u064A\u0645\u0643\u0646\u0646\u064A \u062A\u0631\u062C\u0645\u0629 \u0647\u0630\u0627\u061F","Accounts":"\u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0645\u062A\u0635\u0644\u0629","Site settings":"\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0645\u0648\u0642\u0639","Language":"\u0644\u063A\u0629","Enable Marmaid":"\u062A\u0645\u0643\u064A\u0646 \u062D\u0648\u0631\u064A\u0629 \u0627\u0644\u0628\u062D\u0631","Enable Blur":"\u062A\u0645\u0643\u064A\u0646 \u0627\u0644\u062A\u0639\u062A\u064A\u0645","Enable Animations":"\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u0645\u062A\u062D\u0631\u0643\u0629","Personal information":"\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0634\u062E\u0635\u064A\u0629","NO":"\u0644\u0627","YES":"\u0646\u0639\u0645","General":"\u0639\u0627\u0645","Profile":"\u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0634\u062E\u0635\u064A","Notifications":"\u0625\u0634\u0639\u0627\u0631\u0627\u062A","Identity":"\u0647\u0648\u064A\u0629","Tokens":"\u0627\u0644\u0631\u0645\u0648\u0632","Instances":"\u0645\u062B\u064A\u0644\u0627\u062A","Domains":"\u0627\u0644\u0645\u062C\u0627\u0644\u0627\u062A","Sessions":"\u0627\u0644\u062C\u0644\u0633\u0627\u062A","My Sessions":"\u062C\u0644\u0633\u0627\u062A\u064A","No projects":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0634\u0627\u0631\u064A\u0639","Create project":"\u0623\u0646\u0634\u0626 \u0645\u0634\u0631\u0648\u0639\u064B\u0627","Projects":"\u0627\u0644\u0645\u0634\u0627\u0631\u064A\u0639","Project name":"\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u0631\u0648\u0639","Project description":"\u0648\u0635\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639","Select team":"\u0627\u062E\u062A\u0631 \u0641\u0631\u064A\u0642","Set unique description for project":"\u062D\u062F\u062F \u0648\u0635\u0641\u064B\u0627 \u0641\u0631\u064A\u062F\u064B\u0627 \u0644\u0644\u0645\u0634\u0631\u0648\u0639","Please fill out this field.":"\u0627\u0644\u0631\u062C\u0627\u0621 \u0645\u0644\u0621 \u0647\u0630\u0647 \u0627\u0644\u062E\u0627\u0646\u0629.","Create":"\u062E\u0644\u0642","OwnedBy":"\u0645\u0645\u0644\u0648\u0643\u0629 \u0628\u0648\u0627\u0633\u0637\u0629","Open":"\u0641\u062A\u062D","Settings":"\u0625\u0639\u062F\u0627\u062F\u0627\u062A","Apps":"\u062A\u0637\u0628\u064A\u0642\u0627\u062A","Logout":"\u062A\u0633\u062C\u064A\u0644 \u062E\u0631\u0648\u062C","Admin":"\u0645\u0633\u0624\u0644","Iot":"Iot","Name":"\u0627\u0633\u0645","Email":"\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","You have being mentioned inside":"\u0644\u0642\u062F \u062A\u0645 \u0630\u0643\u0631\u0643 \u0641\u064A \u0627\u0644\u062F\u0627\u062E\u0644","from project":"\u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0648\u0639","by":"\u0628\u0648\u0627\u0633\u0637\u0629","You have being invited as member inside project":"\u0644\u0642\u062F \u062A\u0645\u062A \u062F\u0639\u0648\u062A\u0643 \u0643\u0639\u0636\u0648 \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639","to build awesome things":"\u0644\u0628\u0646\u0627\u0621 \u0623\u0634\u064A\u0627\u0621 \u0631\u0627\u0626\u0639\u0629"}');

});

parcelRegister("eaQMh", function(module, exports) {
module.exports = JSON.parse('{"Can i translate this ?":"\u041C\u043E\u0433\u0430 \u043B\u0438 \u0434\u0430 \u043F\u0440\u0435\u0432\u0435\u0434\u0430 \u0442\u043E\u0432\u0430 ?","Accounts":"\u0421\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0430\u043A\u0430\u0443\u043D\u0442\u0438","Site settings":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442\u0430","Language":"\u0415\u0437\u0438\u043A","Enable Marmaid":"\u0412\u043A\u043B\u044E\u0447\u0438 Marmaid","Enable Blur":"\u0412\u043A\u043B\u044E\u0447\u0438 \u0437\u0430\u043C\u0430\u0433\u043B\u044F\u0432\u0430\u043D\u0435","Enable Animations":"\u0412\u043A\u043B\u044E\u0447\u0438 \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u0439","Personal information":"\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u043D\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F","NO":"\u041D\u0435","YES":"\u0414\u0430","General":"\u0413\u0435\u043D\u0435\u0440\u0430\u043B\u043D\u0438","Profile":"\u041F\u0440\u043E\u0444\u0438\u043B","Notifications":"\u041D\u043E\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438","Identity":"\u0418\u0434\u0435\u043D\u0442\u0438\u0447\u043D\u043E\u0441\u0442","Tokens":"\u0422\u043E\u043A\u0435\u043D\u0438","Instances":"\u0418\u043D\u0441\u0442\u0430\u043D\u0446\u0438\u0438","Domains":"\u0414\u043E\u043C\u0435\u0439\u043D\u0438","Sessions":"\u0421\u0435\u0441\u0438\u0438","My Sessions":"\u041C\u043E\u0439\u0442\u0435 \u0441\u0435\u0441\u0438\u0438","No projects":"\u041D\u044F\u043C\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0438","Create project":"\u0421\u044A\u0437\u0434\u0430\u0439 \u043F\u0440\u043E\u0435\u043A\u0442","Projects":"\u041F\u0440\u043E\u0435\u043A\u0442\u0438","Project name":"\u0418\u043C\u0435 \u043D\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","Project description":"\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043D\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","Select team":"\u0418\u0437\u0431\u0435\u0440\u0438 \u0435\u043A\u0438\u043F","Set unique description for project":"\u0414\u043E\u0431\u0430\u0432\u0438 \u0443\u043D\u0438\u043A\u0430\u043B\u043D\u043E \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u044A\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u0430","Please fill out this field.":"\u041C\u043E\u043B\u044F \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u0442\u0435 \u043F\u043E\u043B\u0435\u0442\u043E.","Create":"\u0421\u044A\u0437\u0434\u0430\u0439","OwnedBy":"\u0421\u044A\u0437\u0434\u0430\u0442\u0435\u043B","Open":"\u0412\u043B\u0435\u0437","Settings":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","Apps":"\u0410\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0438","Logout":"\u0418\u0437\u043B\u0435\u0437","Admin":"\u0410\u0434\u043C\u0438\u043D","Iot":"\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u043A\u0430","Name":"\u0418\u043C\u0435","Email":"\u0418\u043C\u0435\u0439\u043B","You have being mentioned inside":"\u0411\u044F\u0445\u0442\u0435 \u0441\u043F\u043E\u043C\u0435\u043D\u0430\u0442 \u0442\u0443\u043A","from project":"\u043A\u044A\u043C \u043F\u0440\u043E\u0435\u043A\u0442","by":"\u043E\u0442","You have being invited as member inside project":"\u0411\u044F\u0445\u0442\u0435 \u043F\u043E\u043A\u0430\u043D\u0435\u043D\u0438 \u043A\u0430\u0442\u043E \u0447\u043B\u0435\u043D \u043D\u0430 \u043F\u0440\u043E\u0435\u043A\u0442","to build awesome things":"\u0434\u0430 \u0438\u0437\u0433\u0440\u0430\u0436\u0434\u0430\u0442\u0435 \u043D\u0435\u0432\u0435\u0440\u043E\u044F\u0442\u043D\u0438 \u043D\u0435\u0449\u0430"}');

});

parcelRegister("kk9so", function(module, exports) {
module.exports = JSON.parse('{"Can i translate this ?":"Kann ich das \xfcbersetzen?","Accounts":"Verbundene Konten","Site settings":"Seiteneinstellungen","Language":"Sprache","Enable Marmaid":"Meerjungfrau aktivieren","Enable Blur":"Weichzeichnen aktivieren","Enable Animations":"Animationen aktivieren","Personal information":"Pers\xf6nliche Informationen","NO":"Nein","YES":"JA","General":"Allgemein","Profile":"Profil","Notifications":"Benachrichtigungen","Identity":"Identit\xe4t","Tokens":"Token","Instances":"Instanzen","Domains":"Dom\xe4nen","Sessions":"Sitzungen","My Sessions":"Meine Sitzungen","No projects":"Keine Projekte","Create project":"Projekt erstellen","Projects":"Projekte","Project name":"Projektname","Project description":"Projektbeschreibung","Select team":"Team ausw\xe4hlen","Set unique description for project":"Legen Sie eine eindeutige Beschreibung f\xfcr das Projekt fest","Please fill out this field.":"Bitte f\xfcllen Sie dieses Feld aus.","Create":"Schaffen","OwnedBy":"Geh\xf6rt","Open":"Offen","Settings":"Einstellungen","Apps":"Anwendungen","Logout":"Ausloggen","Admin":"Administrator","Iot":"Iot","Name":"Name","Email":"Email","You have being mentioned inside":"Du wurdest drinnen erw\xe4hnt","from project":"aus Projekt","by":"von","You have being invited as member inside project":"Sie wurden als Mitglied innerhalb des Projekts eingeladen","to build awesome things":"tolle Dinge zu bauen"}');

});

parcelRegister("iEbjM", function(module, exports) {
module.exports = JSON.parse("{\"Can i translate this ?\":\"Can i translate this ?\",\"Accounts\":\"Accounts\",\"Site settings\":\"Site settings\",\"Language\":\"Language\",\"Enable Marmaid\":\"Enable Marmaid\",\"Enable Blur\":\"Enable Blur\",\"Enable Animations\":\"Enable Animations\",\"Personal information\":\"Personal information\",\"NO\":\"NO\",\"YES\":\"YES\",\"General\":\"General\",\"Profile\":\"Profile\",\"Notifications\":\"Notifications\",\"Identity\":\"Identity\",\"Tokens\":\"Tokens\",\"Instances\":\"Instances\",\"Domains\":\"Domains\",\"Sessions\":\"Sessions\",\"My Sessions\":\"My Sessions\",\"No projects\":\"No projects\",\"Create project\":\"Create project\",\"Projects\":\"Projects\",\"Project name\":\"Project name\",\"Project description\":\"Project description\",\"Select team\":\"Select team\",\"Set unique description for project\":\"Set unique description for project\",\"Please fill out this field.\":\"Please fill out this field.\",\"Create\":\"Create\",\"OwnedBy\":\"OwnedBy\",\"Open\":\"Open\",\"Settings\":\"Settings\",\"Apps\":\"Apps\",\"Logout\":\"Logout\",\"Admin\":\"Admin\",\"Iot\":\"Iot\",\"Name\":\"Name\",\"Email\":\"Email\",\"You have being mentioned inside\":\"You have being mentioned inside\",\"from project\":\"from project\",\"by\":\"by\",\"You have being invited as member inside project\":\"You have being invited as member inside project\",\"to build awesome things\":\"to build awesome things\"}");

});

parcelRegister("2ZFzp", function(module, exports) {
module.exports = JSON.parse('{"Can i translate this ?":"\xbfPuedo traducir esto?","Accounts":"Cuentas conectadas","Site settings":"Ajustes del sitio","Language":"Idioma","Enable Marmaid":"Enable Marmaid","Enable Blur":"Enable Blur","Enable Animations":"Animaciones habilitadas","Personal information":"Informaci\xf3n personal","NO":"NO","YES":"S\xed.","General":"General","Profile":"Perfil","Notifications":"Notificaciones","Identity":"Identidad","Tokens":"Tokens","Instances":"Instances","Domains":"Dominios","Sessions":"Per\xedodos de sesiones","My Sessions":"Mis sesiones","No projects":"No hay proyectos","Create project":"Crear proyecto","Projects":"Proyectos","Project name":"Nombre del proyecto","Project description":"Descripci\xf3n del proyecto","Select team":"Seleccionar equipo","Set unique description for project":"Establecer descripci\xf3n \xfanica para el proyecto","Please fill out this field.":"Por favor, llena este campo.","Create":"Crear","OwnedBy":"OwnedBy","Open":"Abierto","Settings":"Ajustes","Apps":"Aplicaciones","Logout":"Cerrar sesi\xf3n","Admin":"Admin","Iot":"Iot","Name":"Nombre","Email":"Email","You have being mentioned inside":"Has sido mencionado dentro","from project":"del proyecto","by":"por","You have being invited as member inside project":"Usted ha sido invitado como miembro dentro del proyecto","to build awesome things":"para construir cosas impresionantes"}');

});

parcelRegister("3Cgae", function(module, exports) {
module.exports = JSON.parse('{"Can i translate this ?":"Puis-je traduire cela ?","Accounts":"Comptes connect\xe9s","Site settings":"Param\xe8tres du site","Language":"Langue","Enable Marmaid":"Activer la sir\xe8ne","Enable Blur":"Activer le flou","Enable Animations":"Activer les animations","Personal information":"Informations personnelles","NO":"Non","YES":"OUI","General":"G\xe9n\xe9ral","Profile":"Le profil","Notifications":"Avis","Identity":"Identit\xe9","Tokens":"Jetons","Instances":"Instances","Domains":"Domaines","Sessions":"S\xe9ances","My Sessions":"Mes s\xe9ances","No projects":"Aucun projet","Create project":"Cr\xe9er un projet","Projects":"Projets","Project name":"Nom du projet","Project description":"Description du projet","Select team":"Choisis une \xe9quipe","Set unique description for project":"D\xe9finir une description unique pour le projet","Please fill out this field.":"Veuillez remplir ce champ.","Create":"Cr\xe9er","OwnedBy":"Propri\xe9t\xe9 de","Open":"Ouvrir","Settings":"R\xe9glages","Apps":"applications","Logout":"Se d\xe9connecter","Admin":"Administrateur","Iot":"Pas","Name":"Nom","Email":"E-mail","You have being mentioned inside":"Vous avez \xe9t\xe9 mentionn\xe9 \xe0 l\'int\xe9rieur","from project":"du projet","by":"par","You have being invited as member inside project":"Vous avez \xe9t\xe9 invit\xe9 en tant que membre au sein du projet","to build awesome things":"pour construire des choses g\xe9niales"}');

});

parcelRegister("5ELu3", function(module, exports) {
module.exports = JSON.parse('{"Can i translate this ?":"Kan ik dit vertalen?","Accounts":"Verbonden rekeningen","Site settings":"Site-instellingen","Language":"Taal","Enable Marmaid":"Zeemeermin inschakelen","Enable Blur":"Vervagen inschakelen","Enable Animations":"Animaties inschakelen","Personal information":"Persoonlijke informatie","NO":"Nee","YES":"JA","General":"Algemeen","Profile":"Profiel","Notifications":"Meldingen","Identity":"Identiteit","Tokens":"Munten","Instances":"Instanties","Domains":"Domeinen","Sessions":"Sessies","My Sessions":"Mijn sessies","No projects":"Geen projecten","Create project":"Project aanmaken","Projects":"Projecten","Project name":"Naam van het project","Project description":"Projectbeschrijving","Select team":"Selecteer team","Set unique description for project":"Stel een unieke beschrijving in voor het project","Please fill out this field.":"Vul alstublieft dit veld in.","Create":"Cre\xebren","OwnedBy":"Eigendom van","Open":"Open","Settings":"Instellingen","Apps":"Apps","Logout":"Uitloggen","Admin":"beheerder","Iot":"veel","Name":"Naam","Email":"E-mail","You have being mentioned inside":"Je bent binnen genoemd","from project":"van project","by":"door","You have being invited as member inside project":"Je bent uitgenodigd als lid binnen het project","to build awesome things":"geweldige dingen bouwen"}');

});

parcelRegister("54CK2", function(module, exports) {
module.exports = JSON.parse('{"Can i translate this ?":"\u041C\u043E\u0433\u0443 \u043B\u0438 \u0434\u0430 \u043F\u0440\u0435\u0432\u0435\u0434\u0435\u043C \u043E\u0432\u043E?","Accounts":"\u041F\u043E\u0432\u0435\u0437\u0430\u043D\u0438 \u043D\u0430\u043B\u043E\u0437\u0438","Site settings":"\u041F\u043E\u0434\u0435\u0448\u0430\u0432\u0430\u045A\u0430 \u0441\u0430\u0458\u0442\u0430","Language":"\u0408\u0435\u0437\u0438\u043A","Enable Marmaid":"\u041E\u043C\u043E\u0433\u0443\u045B\u0438 \u041C\u0435\u0440\u043C\u0430\u0438\u0434","Enable Blur":"\u041E\u043C\u043E\u0433\u0443\u045B\u0438 \u0437\u0430\u043C\u0443\u045B\u0435\u045A\u0435","Enable Animations":"\u041E\u043C\u043E\u0433\u0443\u045B\u0438 \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u0458\u0435","Personal information":"\u041B\u0438\u0447\u043D\u0430 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430","NO":"\u041D\u0435","YES":"\u0414\u0410","General":"\u0413\u0435\u043D\u0435\u0440\u0430\u043B","Profile":"\u041F\u0440\u043E\u0444\u0438\u043B","Notifications":"\u041E\u0431\u0430\u0432\u0435\u0448\u0442\u0435\u045A\u0430","Identity":"\u0418\u0434\u0435\u043D\u0442\u0438\u0442\u0435\u0442","Tokens":"\u0422\u043E\u043A\u0435\u043D\u0441","Instances":"\u0418\u043D\u0441\u0442\u0430\u043D\u0446\u0435","Domains":"\u0414\u043E\u043C\u0430\u0438\u043D\u0441","Sessions":"\u0421\u0435\u0441\u0438\u0458\u0435","My Sessions":"\u041C\u043E\u0458\u0435 \u0441\u0435\u0441\u0438\u0458\u0435","No projects":"\u041D\u0435\u043C\u0430 \u043F\u0440\u043E\u0458\u0435\u043A\u0430\u0442\u0430","Create project":"\u041A\u0440\u0435\u0438\u0440\u0430\u0458\u0442\u0435 \u043F\u0440\u043E\u0458\u0435\u043A\u0430\u0442","Projects":"\u041F\u0440\u043E\u0458\u0435\u043A\u0442\u0438","Project name":"\u0418\u043C\u0435 \u043F\u0440\u043E\u0458\u0435\u043A\u0442\u0430","Project description":"\u041E\u043F\u0438\u0441 \u043F\u0440\u043E\u0458\u0435\u043A\u0442\u0430","Select team":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043C","Set unique description for project":"\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u0435 \u0458\u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u0438 \u043E\u043F\u0438\u0441 \u0437\u0430 \u043F\u0440\u043E\u0458\u0435\u043A\u0430\u0442","Please fill out this field.":"\u041C\u043E\u043B\u0438\u043C \u0432\u0430\u0441 \u043F\u043E\u043F\u0443\u043D\u0438\u0442\u0435 \u043E\u0432\u043E \u043F\u043E\u0459\u0435.","Create":"\u041A\u0440\u0435\u0438\u0440\u0430\u0458","OwnedBy":"\u0423 \u0432\u043B\u0430\u0441\u043D\u0438\u0448\u0442\u0432\u0443","Open":"\u041E\u0442\u0432\u043E\u0440\u0438","Settings":"\u041F\u043E\u0434\u0435\u0448\u0430\u0432\u0430\u045A\u0430","Apps":"\u0410\u043F\u043F\u0441","Logout":"\u041E\u0434\u0458\u0430\u0432\u0438\u0442\u0438 \u0441\u0435","Admin":"\u0410\u0434\u043C\u0438\u043D","Iot":"\u0418\u043E\u0442","Name":"\u0418\u043C\u0435","Email":"\u0415\u043C\u0430\u0438\u043B","You have being mentioned inside":"\u0421\u043F\u043E\u043C\u0435\u043D\u0443\u0442\u0438 \u0441\u0442\u0435 \u0443\u043D\u0443\u0442\u0440\u0430","from project":"\u0438\u0437 \u043F\u0440\u043E\u0458\u0435\u043A\u0442\u0430","by":"\u043E\u0434 \u0441\u0442\u0440\u0430\u043D\u0435","You have being invited as member inside project":"\u041F\u043E\u0437\u0432\u0430\u043D\u0438 \u0441\u0442\u0435 \u043A\u0430\u043E \u0447\u043B\u0430\u043D \u0443\u043D\u0443\u0442\u0430\u0440 \u043F\u0440\u043E\u0458\u0435\u043A\u0442\u0430","to build awesome things":"\u0434\u0430 \u0438\u0437\u0433\u0440\u0430\u0434\u0438\u043C\u043E \u0441\u0458\u0430\u0458\u043D\u0435 \u0441\u0442\u0432\u0430\u0440\u0438"}');

});

parcelRegister("cLKMa", function(module, exports) {
module.exports = JSON.parse('{"Can i translate this ?":"Bunu \xe7evirebilir miyim?","Accounts":"ba\u011Fl\u0131 hesaplar","Site settings":"Site ayarlar\u0131","Language":"Dil","Enable Marmaid":"Deniz K\u0131z\u0131n\u0131 Etkinle\u015Ftir","Enable Blur":"Bulan\u0131kla\u015Ft\u0131rmay\u0131 Etkinle\u015Ftir","Enable Animations":"Animasyonlar\u0131 Etkinle\u015Ftir","Personal information":"Ki\u015Fisel bilgi","NO":"Numara","YES":"EVET","General":"Genel","Profile":"Profil","Notifications":"Bildirimler","Identity":"Kimlik","Tokens":"Jetonlar","Instances":"\xd6rnekler","Domains":"Etki alanlar\u0131","Sessions":"oturumlar","My Sessions":"Seanslar\u0131m","No projects":"proje yok","Create project":"proje olu\u015Ftur","Projects":"Projeler","Project name":"Proje Ad\u0131","Project description":"Proje A\xe7\u0131klamas\u0131","Select team":"tak\u0131m se\xe7","Set unique description for project":"Proje i\xe7in benzersiz bir a\xe7\u0131klama belirleyin","Please fill out this field.":"L\xfctfen bu alan\u0131 doldurunuz.","Create":"Yaratmak","OwnedBy":"Taraf\u0131ndan sahip olunan","Open":"A\xe7\u0131k","Settings":"Ayarlar","Apps":"Uygulamalar","Logout":"\xc7\u0131k\u0131\u015F Yap","Admin":"y\xf6netici","Iot":"\xe7ok \u015Fey","Name":"\u0130sim","Email":"E-posta","You have being mentioned inside":"\u0130\xe7eride senden bahsedildi","from project":"projeden","by":"taraf\u0131ndan","You have being invited as member inside project":"Proje i\xe7erisine \xfcye olarak davet edildiniz.","to build awesome things":"harika \u015Feyler in\u015Fa etmek"}');

});

parcelRegister("1V3pW", function(module, exports) {

$parcel$export(module.exports, "OnlineStatusService", () => $8c99f1da6531f8c1$export$ab941ec7e2fb0626);

var $deWeK = parcelRequire("deWeK");

var $7X6iT = parcelRequire("7X6iT");

var $1t8Wn = parcelRequire("1t8Wn");

var $cDzby = parcelRequire("cDzby");
class $8c99f1da6531f8c1$export$ab941ec7e2fb0626 extends (0, $7X6iT.BaseGraphqlService) {
    OnInit() {
    // this.socialService.isLoggedIn
    //   .pipe(filter((i) => !!i))
    //   .pipe(
    //     take(1),
    //     delay(3000),
    //     switchMap(() => this.setOnlineStatus(true))
    //     // tap(
    //     //   () =>
    //     //     (window.onbeforeunload = async (e) => {
    //     //       e.preventDefault();
    //     //       firstValueFrom(this.setOnlineStatus(false));
    //     //       return undefined;
    //     //     })
    //     // )
    //   )
    //   .subscribe();
    }
    setOnlineStatus(active) {
        return this.mutate({
            mutation: 'set-online-status.graphql',
            variables: {
                active: active
            }
        });
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $8c99f1da6531f8c1$export$ab941ec7e2fb0626.prototype, "socialService", void 0);
$8c99f1da6531f8c1$export$ab941ec7e2fb0626 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)({
        init: true
    })
], $8c99f1da6531f8c1$export$ab941ec7e2fb0626);

});

parcelRegister("c7gF1", function(module, exports) {

$parcel$export(module.exports, "PortalProvider", () => $174ef967467976e0$export$6df4068a17305b10);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");
class $174ef967467976e0$export$6df4068a17305b10 {
    attach(template, rect) {
        this.dettach();
        this.div = document.createElement('div');
        this.div.style.position = 'absolute';
        this.div.style.top = `${rect.top || 0}px`;
        this.div.style.left = `${rect.left || 0}px`;
        this.div.style.zIndex = '100000';
        (0, $4TeKW.render)(template, this.div);
        document.body.appendChild(this.div);
    }
    dettach() {
        this.div?.remove();
    }
}
$174ef967467976e0$export$6df4068a17305b10 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $174ef967467976e0$export$6df4068a17305b10);

});

parcelRegister("djGtt", function(module, exports) {

$parcel$export(module.exports, "PrefetchService", () => $e42421f26d75cd78$export$7cd578b3f64517d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unused-vars */ 
var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");
class $e42421f26d75cd78$export$7cd578b3f64517d {
    async fetch(m) {
    //  m: Promise<any>
    // await m;
    }
}
$e42421f26d75cd78$export$7cd578b3f64517d = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $e42421f26d75cd78$export$7cd578b3f64517d);

});

parcelRegister("fissc", function(module, exports) {

$parcel$export(module.exports, "BoardService", () => $0183099fd87d5566$export$816942394369b5b4);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $gawXH = parcelRequire("gawXH");

var $7X6iT = parcelRequire("7X6iT");

var $ie8oP = parcelRequire("ie8oP");
class $0183099fd87d5566$export$816942394369b5b4 extends (0, $7X6iT.BaseGraphqlService) {
    createBoard({ projectId: projectId, payload: payload }) {
        return this.mutate({
            mutation: 'create-board.graphql',
            variables: {
                projectId: projectId,
                payload: payload
            },
            update: (proxy, { data: { createBoard: createBoard } })=>{
                const data = this._getProjectState(proxy, projectId);
                data.getProject.boards.push(createBoard);
                this._writeProjectState(data)(proxy, projectId);
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createBoard));
    }
    updateBoard({ id: id, payload: payload }) {
        return this.mutate({
            mutation: 'update-board.graphql',
            variables: {
                id: id,
                payload: payload
            },
            update: (proxy, { data: { updateBoard: updateBoard } })=>{
            // const data = this._getProjectState(proxy, projectId);
            // data.getProject.boards.push(createBoard);
            // this._writeProjectState(data)(proxy, projectId);
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.updateBoard));
    }
    getBoard(id) {
        return this.watchQuery({
            query: 'get-board.query.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.getBoard));
    }
    boardChanged(boardId) {
        return this.subscribe({
            query: 'board-changed.graphql',
            variables: {
                boardId: boardId
            }
        });
    }
    deleteBoard(projectId, id) {
        return this.mutate({
            mutation: 'delete-board.graphql',
            variables: {
                id: id
            },
            update: (proxy)=>{
                const data = this._getProjectState(proxy, projectId);
                data.getProject.boards = data.getProject.boards.filter((board)=>board.id !== id);
                this._writeProjectState(data)(proxy, projectId);
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteBoard));
    }
    createColumn(boardId, projectId, payload) {
        return this.mutate({
            mutation: 'create-board-column.graphql',
            variables: {
                boardId: boardId,
                payload: payload
            },
            update: (proxy, { data: { createBoardColumn: createBoardColumn } })=>{
                const state = this._getState(proxy, boardId);
                state.getBoard = (0, $ie8oP.addColumnToState)()(createBoardColumn)(state.getBoard);
                this._writeState(state)(proxy, boardId);
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createBoardColumn));
    }
    updateColumn(id, boardId, payload) {
        return this.mutate({
            mutation: 'update-board-column.graphql',
            variables: {
                id: id,
                payload: payload
            },
            update: (proxy, { data: { updateBoardColumn: updateBoardColumn } })=>{
                const state = this._getState(proxy, boardId);
                state.getBoard = (0, $ie8oP.updateColumnToState)()(updateBoardColumn)(state.getBoard);
                this._writeState(state)(proxy, boardId);
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.updateBoardColumn));
    }
    deleteColumn(id) {
        return this.mutate({
            mutation: 'delete-board-column.graphql',
            variables: {
                id: id
            },
            update: (proxy, { data: { deleteBoardColumn: deleteBoardColumn } })=>{
                const state = this._getState(proxy, deleteBoardColumn.boardId);
                state.getBoard = (0, $ie8oP.removeColumnFromState)()(deleteBoardColumn)(state.getBoard);
                this._writeState(state)(proxy, deleteBoardColumn.boardId);
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteBoardColumn));
    }
    listProjectBacklog(projectId) {
        return this.query({
            query: 'list-boards-per-project.query.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.listProjectBacklog));
    }
    _getQuery() {
        return (0, $2O1GU.importQuery)('get-board.query.graphql');
    }
    _getProjectQuery() {
        return (0, $2O1GU.importQuery)('get-project.query.graphql');
    }
    constructor(...args){
        super(...args), this._getState = (proxy, boardId)=>(0, $2O1GU.deepCopy)(proxy.readQuery({
                query: this._getQuery(),
                variables: {
                    id: boardId
                }
            })), this._writeState = (data)=>(proxy, boardId)=>proxy.writeQuery({
                    query: this._getQuery(),
                    variables: {
                        id: boardId
                    },
                    data: data
                }), this._getProjectState = (proxy, projectId)=>(0, $2O1GU.deepCopy)(proxy.readQuery({
                query: this._getProjectQuery(),
                variables: {
                    id: projectId
                }
            })), this._writeProjectState = (data)=>(proxy, boardId)=>proxy.writeQuery({
                    query: this._getProjectQuery(),
                    variables: {
                        id: boardId
                    },
                    data: data
                });
    }
}
$0183099fd87d5566$export$816942394369b5b4 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $0183099fd87d5566$export$816942394369b5b4);

});
parcelRegister("ie8oP", function(module, exports) {

$parcel$export(module.exports, "addColumnToState", () => $fb78c27095a37830$export$ee467d7460ed0758);
$parcel$export(module.exports, "updateColumnToState", () => $fb78c27095a37830$export$342c82a90638ca44);
$parcel$export(module.exports, "removeColumnFromState", () => $fb78c27095a37830$export$d7465404d9b8b435);

var $gOO6w = parcelRequire("gOO6w");
const $fb78c27095a37830$export$e7e7fc049972ad03 = (id)=>(0, $gOO6w.matching)({
        id: id
    });
const $fb78c27095a37830$export$167cfa69ea4b26fd = ()=>(callback)=>(0, $gOO6w.mod)('columns')(callback);
const $fb78c27095a37830$export$ee467d7460ed0758 = ()=>(column)=>$fb78c27095a37830$export$167cfa69ea4b26fd()((columns)=>[
                ...columns,
                column
            ]);
const $fb78c27095a37830$export$342c82a90638ca44 = ()=>(column)=>$fb78c27095a37830$export$167cfa69ea4b26fd()((columns)=>{
            const index = columns.findIndex((c)=>c.id === column.id);
            columns[index] = column;
            return [
                ...columns
            ];
        });
const $fb78c27095a37830$export$d7465404d9b8b435 = ()=>(column)=>$fb78c27095a37830$export$167cfa69ea4b26fd()((columns)=>columns.filter((c)=>c.id !== column.id));
const $fb78c27095a37830$export$cc660b3c8d352b39 = ()=>(callback)=>(0, $gOO6w.mod)('boards')(callback);
const $fb78c27095a37830$export$1598c120a7083144 = ()=>(board)=>$fb78c27095a37830$export$cc660b3c8d352b39()((boards)=>[
                ...boards,
                board
            ]);
const $fb78c27095a37830$export$b43b85d851f8edad = ()=>(board)=>$fb78c27095a37830$export$cc660b3c8d352b39()((boards)=>boards.filter((b)=>b.id !== board.id));

});


parcelRegister("5V3kE", function(module, exports) {

$parcel$export(module.exports, "CardService", () => $107485308fa6faee$export$1926ec33ea263be2);

var $deWeK = parcelRequire("deWeK");

var $7lFX5 = parcelRequire("7lFX5");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $1MQ4j = parcelRequire("1MQ4j");

var $5JMLH = parcelRequire("5JMLH");
var $4DDzB = parcelRequire("4DDzB");
var $g5fNy = parcelRequire("g5fNy");

var $gawXH = parcelRequire("gawXH");
var $lNnaw = parcelRequire("lNnaw");

var $7X6iT = parcelRequire("7X6iT");

var $be29e = parcelRequire("be29e");

var $gEK7k = parcelRequire("gEK7k");
class $107485308fa6faee$export$1926ec33ea263be2 extends (0, $7X6iT.BaseGraphqlService) {
    shouldUpdate() {
        return this.$updating;
    }
    set updating(value) {
        this.$updating = value;
    }
    moveCard({ prevBoardId: prevBoardId, columnId: columnId, boardId: boardId, cardId: cardId, prevColumnId: prevColumnId, order: order }) {
        return this.mutate({
            mutation: 'move-card.graphql',
            variables: {
                id: cardId,
                columnId: columnId,
                order: order
            },
            context: {
                requestTrackerId: 1
            },
            update: (proxy, { data: { moveCard: moveCard } })=>{
                const newBoard = this._getState(proxy, boardId);
                if (newBoard) this._writeState({
                    ...newBoard,
                    getBoard: (0, $gEK7k.addCardToState)(boardId, columnId)(moveCard)((0, $gEK7k.removeCardFromState)(boardId, prevColumnId === columnId ? columnId : prevColumnId)(moveCard)(newBoard.getBoard))
                })(proxy, boardId);
                const prevBoard = this._getState(proxy, prevBoardId);
                if (prevBoard) this._writeState({
                    ...prevBoard,
                    getBoard: (0, $gEK7k.removeCardFromState)(prevBoardId, prevColumnId)(moveCard)(prevBoard.getBoard)
                })(proxy, prevBoardId);
            }
        }).pipe((0, $gawXH.map)((v)=>v.data.moveCard));
    }
    addMeToMembers(card, event) {
        return this.userService.getUser().pipe((0, $lNnaw.switchMap)((u)=>this.updateCard(card.id, {
                ...card,
                members: [
                    ...card.members,
                    u
                ].map((m)=>({
                        id: m.id
                    }))
            }, event)));
    }
    removeMefromMembers(card, event) {
        return this.userService.getUser().pipe((0, $lNnaw.switchMap)((u)=>this.updateCard(card.id, {
                ...card,
                members: card.members.filter((m)=>m.id !== u.id).map((m)=>({
                        id: m.id
                    }))
            }, event)));
    }
    isCardMember(userId) {
        return (card)=>!!card.members.find((m)=>m.id === userId);
    }
    onAddMeToCardMembers(card, event) {
        return this.userService.getUser().pipe((0, $lNnaw.switchMap)((user)=>(0, $4DDzB.iif)(()=>!!this.isCardMember(user.id)(card), this.removeMefromMembers(card, event), this.addMeToMembers(card, event))));
    }
    addCardMembers(card, members, event) {
        return this.updateCard(card.id, {
            ...card,
            members: members
        }, event);
    }
    removeCardAttachment(id) {
        return (cardId)=>this.getCard(cardId).pipe((0, $lNnaw.switchMap)((card)=>this.mutate({
                    mutation: 'remove-card-attachment.graphql',
                    variables: {
                        id: id
                    },
                    update: (proxy)=>{
                        const data = this._getState(proxy, card.board.id);
                        const getBoard = (0, $gEK7k.modCard)(card.board.id, card.column.id, card.id)((card)=>{
                            return {
                                ...card,
                                files: card.files?.filter((file)=>file.id !== id)
                            };
                        })(data.getBoard);
                        this._writeState({
                            ...data,
                            getBoard: getBoard
                        })(proxy, card.board.id);
                    }
                }).pipe((0, $gawXH.map)((res)=>res.data.removeCardAttachment))));
    }
    uploadAttachment(cardId, files) {
        if (!files.length) return (0, $g5fNy.of)([]);
        const body = new FormData();
        for (const file of files)body.append('file[]', file);
        return this.getCard(cardId).pipe((0, $lNnaw.switchMap)((card)=>{
            return (0, $5JMLH.from)((0, (/*@__PURE__*/$parcel$interopDefault($1MQ4j))).auth().currentUser.getIdToken()).pipe((0, $lNnaw.switchMap)((Authorization)=>fetch((0, $7lFX5.isDevelopment)() ? 'http://localhost:9000/upload' : 'https://pubsub.graphql-server.com/upload', {
                    method: 'POST',
                    body: body,
                    headers: {
                        Authorization: Authorization,
                        cardId: cardId
                    }
                })), (0, $lNnaw.switchMap)((file)=>file.json()), (0, $gawXH.map)((data)=>{
                if (data.error) {
                    console.error(data);
                    return [];
                }
                try {
                    const state = (0, $2O1GU.deepCopy)(this.graphql.readQuery({
                        query: this._getQuery(),
                        variables: {
                            id: card.board.id
                        }
                    }));
                    const getBoard = (0, $gEK7k.modCard)(card.board.id, card.column.id, card.id)((card)=>({
                            ...card,
                            files: [
                                ...card.files || [],
                                ...data
                            ]
                        }))(state.getBoard);
                    this.graphql.writeQuery({
                        query: this._getQuery(),
                        variables: {
                            id: card.board.id
                        },
                        data: {
                            ...state,
                            getBoard: getBoard
                        }
                    });
                } catch (e) {
                    console.log(e);
                    console.error('State not updated for uploading attachment');
                }
                return data;
            }));
        }));
    }
    getCard(id) {
        return this.query({
            query: 'get-card.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.getCard));
    }
    watchCard(id) {
        return this.watchQuery({
            query: 'get-card.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.getCard));
    }
    cardChanged(cardId) {
        return this.subscribe({
            query: 'card-changed.subscription.graphql',
            variables: {
                cardId: cardId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.cardChanged));
    }
    updateCard(id, data, event) {
        return this.mutate({
            mutation: 'update-card.graphql',
            variables: {
                id: id,
                payload: {
                    members: data.members?.map(({ id: id })=>({
                            id: id
                        })),
                    title: data.title,
                    description: data.description,
                    dueDate: data.dueDate,
                    order: data.order,
                    dueDateComplete: data.dueDateComplete,
                    labels: data.labels,
                    pullRequest: data.pullRequest
                },
                event: event
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.updateCard));
    }
    addCard(boardId, columnId, payload) {
        return this.mutate({
            mutation: 'add-card.graphql',
            variables: {
                boardId: boardId,
                columnId: columnId,
                payload: payload
            },
            update: (proxy, { data: { addCard: addCard } })=>{
                const data = this._getState(proxy, boardId);
                this._writeState({
                    ...data,
                    getBoard: (0, $gEK7k.addCardToState)(boardId, columnId)(addCard)(data.getBoard)
                })(proxy, boardId);
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.addCard));
    }
    addComment(cardId, value, mentions) {
        return this.mutate({
            mutation: 'add-card-comment.graphql',
            variables: {
                cardId: cardId,
                value: value,
                mentions: mentions
            },
            update: (proxy, { data: { addCardComment: addCardComment } })=>{
                const state = (0, $2O1GU.deepCopy)(this.graphql.readQuery({
                    query: this._getQuery(),
                    variables: {
                        id: addCardComment.boardId
                    }
                }));
                if (!state) return;
                const getBoard = (0, $gEK7k.modCard)(addCardComment.boardId, addCardComment.column.id, addCardComment.id)(()=>addCardComment)(state.getBoard);
                this.graphql.writeQuery({
                    query: this._getQuery(),
                    variables: {
                        id: addCardComment.boardId
                    },
                    data: {
                        ...state,
                        getBoard: getBoard
                    }
                });
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.addCard));
    }
    deleteComment(cardId, commentId) {
        return this.mutate({
            mutation: 'delete-card-comment.graphql',
            variables: {
                cardId: cardId,
                commentId: commentId
            },
            update: (proxy, { data: { deleteCardComment: deleteCardComment } })=>{
                const state = (0, $2O1GU.deepCopy)(this.graphql.readQuery({
                    query: this._getQuery(),
                    variables: {
                        id: deleteCardComment.boardId
                    }
                }));
                if (!state) return;
                this.graphql.writeQuery({
                    query: this._getQuery(),
                    variables: {
                        id: deleteCardComment.boardId
                    },
                    data: {
                        ...state,
                        getBoard: (0, $gEK7k.addCardToState)(deleteCardComment.boardId, deleteCardComment.column.id)(deleteCardComment)((0, $gEK7k.removeCardFromState)(deleteCardComment.boardId, deleteCardComment.column.id)(deleteCardComment)(state.getBoard))
                    }
                });
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.addCard));
    }
    updateComment(cardId, commentId, value) {
        return this.mutate({
            mutation: 'update-card-comment.graphql',
            variables: {
                cardId: cardId,
                commentId: commentId,
                value: value
            },
            update: (proxy, { data: { updateCardComment: updateCardComment } })=>{
                const state = this.graphql.readQuery({
                    query: this._getQuery(),
                    variables: {
                        id: updateCardComment.boardId
                    }
                });
                if (!state) return;
                this.graphql.writeQuery({
                    query: this._getQuery(),
                    variables: {
                        id: updateCardComment.boardId
                    },
                    data: {
                        ...state,
                        getBoard: (0, $gEK7k.addCardToState)(updateCardComment.boardId, updateCardComment.column.id)(updateCardComment)((0, $gEK7k.removeCardFromState)(updateCardComment.boardId, updateCardComment.column.id)(updateCardComment)(state.getBoard))
                    }
                });
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.updateCardComment));
    }
    createCompletion(payload) {
        return this.mutate({
            mutation: 'create-completion.graphql',
            variables: {
                payload: payload
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createCompletion));
    }
    createCompletionGemini(payload) {
        return this.mutate({
            mutation: 'create-completion-gemini.graphql',
            variables: {
                payload: payload
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createCompletionGemini));
    }
    _getQuery() {
        return (0, $2O1GU.importQuery)('get-board.query.graphql');
    }
    constructor(...args){
        super(...args), this._getState = (proxy, id)=>(0, $2O1GU.deepCopy)(proxy.readQuery({
                query: this._getQuery(),
                variables: {
                    id: id
                }
            })), this._writeState = (data)=>(proxy, id)=>proxy.writeQuery({
                    query: this._getQuery(),
                    variables: {
                        id: id
                    },
                    data: data
                });
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $be29e.UserService))
], $107485308fa6faee$export$1926ec33ea263be2.prototype, "userService", void 0);
$107485308fa6faee$export$1926ec33ea263be2 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $107485308fa6faee$export$1926ec33ea263be2);

});
parcelRegister("4DDzB", function(module, exports) {

$parcel$export(module.exports, "iif", () => $3609805a1746cd5a$export$906815c308550252);

var $cPJlL = parcelRequire("cPJlL");
function $3609805a1746cd5a$export$906815c308550252(condition, trueResult, falseResult) {
    return (0, $cPJlL.defer)(function() {
        return condition() ? trueResult : falseResult;
    });
}

});
parcelRegister("cPJlL", function(module, exports) {

$parcel$export(module.exports, "defer", () => $957d6d0391205fc0$export$260e5c0943f31606);

var $8id0M = parcelRequire("8id0M");

var $1wVYm = parcelRequire("1wVYm");
function $957d6d0391205fc0$export$260e5c0943f31606(observableFactory) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        (0, $1wVYm.innerFrom)(observableFactory()).subscribe(subscriber);
    });
}

});


parcelRegister("gEK7k", function(module, exports) {

$parcel$export(module.exports, "matchingId", () => $e7cd135f88fd1a02$export$e7e7fc049972ad03);
$parcel$export(module.exports, "modCards", () => $e7cd135f88fd1a02$export$c15624e42fa3d99a);
$parcel$export(module.exports, "modCard", () => $e7cd135f88fd1a02$export$89c98b992a4a9387);
$parcel$export(module.exports, "addCardToState", () => $e7cd135f88fd1a02$export$5be619801afbecab);
$parcel$export(module.exports, "removeCardFromState", () => $e7cd135f88fd1a02$export$dab06f424e86d79c);

var $gOO6w = parcelRequire("gOO6w");
const $e7cd135f88fd1a02$export$e7e7fc049972ad03 = (id)=>(0, $gOO6w.matching)({
        id: id
    });
const $e7cd135f88fd1a02$var$insertionSort = (arr)=>{
    for(let i = 1; i < arr.length; i++){
        const key = arr[i];
        let j = i - 1;
        while(j >= 0 && arr[j].order > key.order){
            arr[j + 1] = arr[j];
            j--;
        }
        arr[j + 1] = key;
    }
    return arr;
};
const $e7cd135f88fd1a02$export$c15624e42fa3d99a = (boardId, columnId)=>(callback)=>(0, $gOO6w.mod)('columns', $e7cd135f88fd1a02$export$e7e7fc049972ad03(columnId), 'cards')(callback);
const $e7cd135f88fd1a02$export$574ca6466190d4b4 = (columnId, cardId)=>(0, $gOO6w.get)('columns', $e7cd135f88fd1a02$export$e7e7fc049972ad03(columnId), 'cards', $e7cd135f88fd1a02$export$e7e7fc049972ad03(cardId));
const $e7cd135f88fd1a02$export$89c98b992a4a9387 = (boardId, columnId, cardId)=>(callback)=>(0, $gOO6w.mod)('columns', $e7cd135f88fd1a02$export$e7e7fc049972ad03(columnId), 'cards', $e7cd135f88fd1a02$export$e7e7fc049972ad03(cardId))(callback);
const $e7cd135f88fd1a02$export$5be619801afbecab = (boardId, columnId)=>(card)=>$e7cd135f88fd1a02$export$c15624e42fa3d99a(boardId, columnId)((cards)=>$e7cd135f88fd1a02$var$insertionSort([
                ...cards,
                card
            ]));
const $e7cd135f88fd1a02$export$dab06f424e86d79c = (boardId, columnId)=>(card)=>$e7cd135f88fd1a02$export$c15624e42fa3d99a(boardId, columnId)((cards)=>$e7cd135f88fd1a02$var$insertionSort(cards.filter((c)=>c.id !== card.id)));

});


parcelRegister("dMqWf", function(module, exports) {

$parcel$export(module.exports, "CLIService", () => $2088b3a40fd30e5f$export$e07e0a18c4e044fc);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $gawXH = parcelRequire("gawXH");

var $7X6iT = parcelRequire("7X6iT");
class $2088b3a40fd30e5f$export$e07e0a18c4e044fc extends (0, $7X6iT.BaseGraphqlService) {
    generateCLIToken() {
        return this.mutate({
            mutation: 'generate-cli-token.graphql'
        }).pipe((0, $gawXH.map)(({ data: data })=>data.generateCLIToken));
    }
    revokeCLIToken() {
        return this.mutate({
            mutation: 'revoke-cli-token.graphql'
        }).pipe((0, $gawXH.map)(({ data: data })=>data.revokeCLIToken));
    }
}
$2088b3a40fd30e5f$export$e07e0a18c4e044fc = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $2088b3a40fd30e5f$export$e07e0a18c4e044fc);

});

parcelRegister("iCFDc", function(module, exports) {

$parcel$export(module.exports, "DateTimeProvider", () => $9c3274719f57628d$export$761b8f8bbc165703);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");
class $9c3274719f57628d$export$761b8f8bbc165703 {
    getDate(dateString) {
        const date = new Date(dateString || Date.now());
        const year = new Intl.DateTimeFormat('en', {
            year: 'numeric'
        }).format(date);
        const month = new Intl.DateTimeFormat('en', {
            month: 'short'
        }).format(date);
        const day = new Intl.DateTimeFormat('en', {
            day: '2-digit'
        }).format(date);
        return `${day}-${month}-${year}`;
    }
    getCommentDate(dateString) {
        const date = new Date(dateString || Date.now());
        const year = new Intl.DateTimeFormat('en', {
            year: 'numeric'
        }).format(date);
        const month = new Intl.DateTimeFormat('en', {
            month: 'short'
        }).format(date);
        const day = new Intl.DateTimeFormat('en', {
            day: '2-digit'
        }).format(date);
        const time = new Intl.DateTimeFormat('en', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
        return `${month} ${day}, ${year} at ${time}`;
    }
    getDueDate(dateString = Date.now().toString()) {
        const date = new Date(dateString || Date.now());
        const year = new Intl.DateTimeFormat('en', {
            year: 'numeric'
        }).format(date);
        const month = new Intl.DateTimeFormat('en', {
            month: '2-digit'
        }).format(date);
        const day = new Intl.DateTimeFormat('en', {
            day: '2-digit'
        }).format(date);
        return `${month}/${day}/${year}`;
    }
    getHours(dateString) {
        return `${new Date(dateString).toLocaleTimeString(navigator.language, {
            hour: '2-digit',
            minute: '2-digit'
        })}`;
    }
    timeSince(time) {
        switch(typeof time){
            case 'number':
                break;
            case 'string':
                time = +new Date(time);
                break;
            case 'object':
                if (time.constructor === Date) time = time.getTime();
                break;
            default:
                time = +new Date();
        }
        const time_formats = [
            [
                60,
                'seconds',
                1
            ],
            [
                120,
                '1 minute ago',
                '1 minute from now'
            ],
            [
                3600,
                'minutes',
                60
            ],
            [
                7200,
                '1 hour ago',
                '1 hour from now'
            ],
            [
                86400,
                'hours',
                3600
            ],
            [
                172800,
                'Yesterday',
                'Tomorrow'
            ],
            [
                604800,
                'days',
                86400
            ],
            [
                1209600,
                'Last week',
                'Next week'
            ],
            [
                2419200,
                'weeks',
                604800
            ],
            [
                4838400,
                'Last month',
                'Next month'
            ],
            [
                29030400,
                'months',
                2419200
            ],
            [
                58060800,
                'Last year',
                'Next year'
            ],
            [
                2903040000,
                'years',
                29030400
            ],
            [
                5806080000,
                'Last century',
                'Next century'
            ],
            [
                58060800000,
                'centuries',
                2903040000
            ]
        ];
        let seconds = (+new Date() - time) / 1000, token = 'ago', list_choice = 1;
        if (seconds == 0) return 'Just now';
        if (seconds < 0) {
            seconds = Math.abs(seconds);
            token = 'from now';
            list_choice = 2;
        }
        let i = 0;
        let format;
        while(format = time_formats[i++])if (seconds < format[0]) {
            if (typeof format[2] == 'string') return format[list_choice];
            else return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
        }
        return time;
    }
}
$9c3274719f57628d$export$761b8f8bbc165703 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $9c3274719f57628d$export$761b8f8bbc165703);

});

parcelRegister("c7W4b", function(module, exports) {

$parcel$export(module.exports, "FooterService", () => $fbe30045ffe8e7e8$export$425d1982370d1899);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");
class $fbe30045ffe8e7e8$export$425d1982370d1899 {
}
$fbe30045ffe8e7e8$export$425d1982370d1899 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $fbe30045ffe8e7e8$export$425d1982370d1899);

});

parcelRegister("4cteG", function(module, exports) {

$parcel$export(module.exports, "GithubService", () => $8e9c9aca259544a8$export$ee34ff66b259de44);

var $deWeK = parcelRequire("deWeK");

var $8bxx1 = parcelRequire("8bxx1");

var $1t8Wn = parcelRequire("1t8Wn");

var $bXHxa = parcelRequire("bXHxa");

var $gawXH = parcelRequire("gawXH");

var $285ah = parcelRequire("285ah");
const $8e9c9aca259544a8$var$REPOSITORY_FRAGMENT = (0, $bXHxa.gql)`
  name
  url
  sshUrl
  description
  owner {
    id
    login
    avatarUrl
    url
  }
`;
const $8e9c9aca259544a8$var$RATE_LIMIT_FRAGMENT = (0, $bXHxa.gql)`
  cost
  limit
  nodeCount
  remaining
  resetAt
  used
`;
const $8e9c9aca259544a8$var$VIEWER_FRAGMENT = (0, $bXHxa.gql)`
  id
  avatarUrl
  login
  url
`;
class $8e9c9aca259544a8$export$ee34ff66b259de44 {
    getAccessToken() {
        return this.localStorage.get('github-accessToken');
    }
    setAccessToken(token) {
        return this.localStorage.update('github-accessToken', token);
    }
    setGithubUserName(name) {
        return this.localStorage.update('github-username', name);
    }
    getGithubUserName() {
        return this.localStorage.get('github-username');
    }
    findRepository(name) {
        return this.query((0, $bXHxa.gql)`
    query findRepository {
      viewer {
        repository(name:"${name}") {
          ${$8e9c9aca259544a8$var$REPOSITORY_FRAGMENT}
        }
      }
      rateLimit {
        ${$8e9c9aca259544a8$var$RATE_LIMIT_FRAGMENT}
      }
    }
    `).pipe((0, $gawXH.map)((res)=>res.data.viewer.repository));
    }
    query(query, variables) {
        return this.http.query(query, variables, {
            headers: this.getHeaders(),
            method: 'POST'
        });
    }
    getHeaders() {
        return {
            Authorization: [
                'bearer',
                this.getAccessToken()
            ].join(' ')
        };
    }
    deleteProject(repo, owner) {
        return new (0, $8bxx1.Octokit)({
            auth: this.getAccessToken()
        }).request('DELETE /repos/{owner}/{repo}', {
            owner: owner || this.getGithubUserName(),
            repo: repo
        });
    }
    createRepository({ description: description, name: name }) {
        return this.query((0, $bXHxa.gql)`
   mutation createRepository {
    createRepository(input: { name: "${name}", visibility: PRIVATE, description: "${description}" }) {
     clientMutationId
     repository {
      ${$8e9c9aca259544a8$var$REPOSITORY_FRAGMENT}
     }
    }
   }
  `).pipe((0, $gawXH.map)((res)=>res.data.createRepository.repository));
    }
    getViewer() {
        return this.query((0, $bXHxa.gql)`
   query getViewer {
    viewer {
     ${$8e9c9aca259544a8$var$VIEWER_FRAGMENT}
    }
    rateLimit {
     ${$8e9c9aca259544a8$var$RATE_LIMIT_FRAGMENT}
    }
   }
  `).pipe((0, $gawXH.map)((res)=>res.data.viewer));
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $285ah.LocalStorageService))
], $8e9c9aca259544a8$export$ee34ff66b259de44.prototype, "localStorage", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $bXHxa.HttpClient))
], $8e9c9aca259544a8$export$ee34ff66b259de44.prototype, "http", void 0);
$8e9c9aca259544a8$export$ee34ff66b259de44 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $8e9c9aca259544a8$export$ee34ff66b259de44);

});
parcelRegister("8bxx1", function(module, exports) {

$parcel$export(module.exports, "Octokit", () => $5f595c7c2749fe5f$export$d19f1ac68c042717);

var $iQEkD = parcelRequire("iQEkD");

var $2pPvG = parcelRequire("2pPvG");

var $lFcLN = parcelRequire("lFcLN");

var $jjQok = parcelRequire("jjQok");

var $giAk4 = parcelRequire("giAk4");
const $5f595c7c2749fe5f$var$VERSION = "3.6.0";
class $5f595c7c2749fe5f$export$d19f1ac68c042717 {
    constructor(options = {}){
        const hook = new (0, $2pPvG.Collection)();
        const requestDefaults = {
            baseUrl: (0, $lFcLN.request).endpoint.DEFAULTS.baseUrl,
            headers: {},
            request: Object.assign({}, options.request, {
                // @ts-ignore internal usage only, no need to type
                hook: hook.bind(null, "request")
            }),
            mediaType: {
                previews: [],
                format: ""
            }
        };
        // prepend default user agent with `options.userAgent` if set
        requestDefaults.headers["user-agent"] = [
            options.userAgent,
            `octokit-core.js/${$5f595c7c2749fe5f$var$VERSION} ${(0, $iQEkD.getUserAgent)()}`
        ].filter(Boolean).join(" ");
        if (options.baseUrl) requestDefaults.baseUrl = options.baseUrl;
        if (options.previews) requestDefaults.mediaType.previews = options.previews;
        if (options.timeZone) requestDefaults.headers["time-zone"] = options.timeZone;
        this.request = (0, $lFcLN.request).defaults(requestDefaults);
        this.graphql = (0, $jjQok.withCustomRequest)(this.request).defaults(requestDefaults);
        this.log = Object.assign({
            debug: ()=>{},
            info: ()=>{},
            warn: console.warn.bind(console),
            error: console.error.bind(console)
        }, options.log);
        this.hook = hook;
        // (1) If neither `options.authStrategy` nor `options.auth` are set, the `octokit` instance
        //     is unauthenticated. The `this.auth()` method is a no-op and no request hook is registered.
        // (2) If only `options.auth` is set, use the default token authentication strategy.
        // (3) If `options.authStrategy` is set then use it and pass in `options.auth`. Always pass own request as many strategies accept a custom request instance.
        // TODO: type `options.auth` based on `options.authStrategy`.
        if (!options.authStrategy) {
            if (!options.auth) // (1)
            this.auth = async ()=>({
                    type: "unauthenticated"
                });
            else {
                // (2)
                const auth = (0, $giAk4.createTokenAuth)(options.auth);
                // @ts-ignore  ¯\_(ツ)_/¯
                hook.wrap("request", auth.hook);
                this.auth = auth;
            }
        } else {
            const { authStrategy: authStrategy, ...otherOptions } = options;
            const auth = authStrategy(Object.assign({
                request: this.request,
                log: this.log,
                // we pass the current octokit instance as well as its constructor options
                // to allow for authentication strategies that return a new octokit instance
                // that shares the same internal state as the current one. The original
                // requirement for this was the "event-octokit" authentication strategy
                // of https://github.com/probot/octokit-auth-probot.
                octokit: this,
                octokitOptions: otherOptions
            }, options.auth));
            // @ts-ignore  ¯\_(ツ)_/¯
            hook.wrap("request", auth.hook);
            this.auth = auth;
        }
        // apply plugins
        // https://stackoverflow.com/a/16345172
        const classConstructor = this.constructor;
        classConstructor.plugins.forEach((plugin)=>{
            Object.assign(this, plugin(this, options));
        });
    }
    static defaults(defaults) {
        const OctokitWithDefaults = class extends this {
            constructor(...args){
                const options = args[0] || {};
                if (typeof defaults === "function") {
                    super(defaults(options));
                    return;
                }
                super(Object.assign({}, defaults, options, options.userAgent && defaults.userAgent ? {
                    userAgent: `${options.userAgent} ${defaults.userAgent}`
                } : null));
            }
        };
        return OctokitWithDefaults;
    }
    /**
     * Attach a plugin (or many) to your Octokit instance.
     *
     * @example
     * const API = Octokit.plugin(plugin1, plugin2, plugin3, ...)
     */ static plugin(...newPlugins) {
        var _a;
        const currentPlugins = this.plugins;
        const NewOctokit = (_a = class extends this {
        }, _a.plugins = currentPlugins.concat(newPlugins.filter((plugin)=>!currentPlugins.includes(plugin))), _a);
        return NewOctokit;
    }
}
$5f595c7c2749fe5f$export$d19f1ac68c042717.VERSION = $5f595c7c2749fe5f$var$VERSION;
$5f595c7c2749fe5f$export$d19f1ac68c042717.plugins = [];

});
parcelRegister("iQEkD", function(module, exports) {

$parcel$export(module.exports, "getUserAgent", () => $db8c5e6365f36417$export$7935961ef7719cb0);
function $db8c5e6365f36417$export$7935961ef7719cb0() {
    if (typeof navigator === "object" && "userAgent" in navigator) return navigator.userAgent;
    return "<environment undetectable>";
}

});

parcelRegister("2pPvG", function(module, exports) {

var $4PjlF = parcelRequire("4PjlF");

var $dEWwk = parcelRequire("dEWwk");

var $e75RO = parcelRequire("e75RO");
// bind with array of arguments: https://stackoverflow.com/a/21792913
var $1c25df6404705c68$var$bind = Function.bind;
var $1c25df6404705c68$var$bindable = $1c25df6404705c68$var$bind.bind($1c25df6404705c68$var$bind);
function $1c25df6404705c68$var$bindApi(hook, state, name) {
    var removeHookRef = $1c25df6404705c68$var$bindable($e75RO, null).apply(null, name ? [
        state,
        name
    ] : [
        state
    ]);
    hook.api = {
        remove: removeHookRef
    };
    hook.remove = removeHookRef;
    [
        "before",
        "error",
        "after",
        "wrap"
    ].forEach(function(kind) {
        var args = name ? [
            state,
            kind,
            name
        ] : [
            state,
            kind
        ];
        hook[kind] = hook.api[kind] = $1c25df6404705c68$var$bindable($dEWwk, null).apply(null, args);
    });
}
function $1c25df6404705c68$var$HookSingular() {
    var singularHookName = "h";
    var singularHookState = {
        registry: {}
    };
    var singularHook = $4PjlF.bind(null, singularHookState, singularHookName);
    $1c25df6404705c68$var$bindApi(singularHook, singularHookState, singularHookName);
    return singularHook;
}
function $1c25df6404705c68$var$HookCollection() {
    var state = {
        registry: {}
    };
    var hook = $4PjlF.bind(null, state);
    $1c25df6404705c68$var$bindApi(hook, state);
    return hook;
}
var $1c25df6404705c68$var$collectionHookDeprecationMessageDisplayed = false;
function $1c25df6404705c68$var$Hook() {
    if (!$1c25df6404705c68$var$collectionHookDeprecationMessageDisplayed) {
        console.warn('[before-after-hook]: "Hook()" repurposing warning, use "Hook.Collection()". Read more: https://git.io/upgrade-before-after-hook-to-1.4');
        $1c25df6404705c68$var$collectionHookDeprecationMessageDisplayed = true;
    }
    return $1c25df6404705c68$var$HookCollection();
}
$1c25df6404705c68$var$Hook.Singular = $1c25df6404705c68$var$HookSingular.bind();
$1c25df6404705c68$var$Hook.Collection = $1c25df6404705c68$var$HookCollection.bind();
module.exports = $1c25df6404705c68$var$Hook;
// expose constructors as a named property for TypeScript
module.exports.Hook = $1c25df6404705c68$var$Hook;
module.exports.Singular = $1c25df6404705c68$var$Hook.Singular;
module.exports.Collection = $1c25df6404705c68$var$Hook.Collection;

});
parcelRegister("4PjlF", function(module, exports) {
module.exports = $383aef0a7b0d885e$var$register;
function $383aef0a7b0d885e$var$register(state, name, method, options) {
    if (typeof method !== "function") throw new Error("method for before hook must be a function");
    if (!options) options = {};
    if (Array.isArray(name)) return name.reverse().reduce(function(callback, name) {
        return $383aef0a7b0d885e$var$register.bind(null, state, name, callback, options);
    }, method)();
    return Promise.resolve().then(function() {
        if (!state.registry[name]) return method(options);
        return state.registry[name].reduce(function(method, registered) {
            return registered.hook.bind(null, method, options);
        }, method)();
    });
}

});

parcelRegister("dEWwk", function(module, exports) {
module.exports = $9f1c67bc04829fc8$var$addHook;
function $9f1c67bc04829fc8$var$addHook(state, kind, name, hook) {
    var orig = hook;
    if (!state.registry[name]) state.registry[name] = [];
    if (kind === "before") hook = function(method, options) {
        return Promise.resolve().then(orig.bind(null, options)).then(method.bind(null, options));
    };
    if (kind === "after") hook = function(method, options) {
        var result;
        return Promise.resolve().then(method.bind(null, options)).then(function(result_) {
            result = result_;
            return orig(result, options);
        }).then(function() {
            return result;
        });
    };
    if (kind === "error") hook = function(method, options) {
        return Promise.resolve().then(method.bind(null, options)).catch(function(error) {
            return orig(error, options);
        });
    };
    state.registry[name].push({
        hook: hook,
        orig: orig
    });
}

});

parcelRegister("e75RO", function(module, exports) {
module.exports = $a4664532ae2822a1$var$removeHook;
function $a4664532ae2822a1$var$removeHook(state, name, method) {
    if (!state.registry[name]) return;
    var index = state.registry[name].map(function(registered) {
        return registered.orig;
    }).indexOf(method);
    if (index === -1) return;
    state.registry[name].splice(index, 1);
}

});


parcelRegister("lFcLN", function(module, exports) {

$parcel$export(module.exports, "request", () => $fc575526edad0a23$export$b5fe3f66a567bec0);

var $g7yWe = parcelRequire("g7yWe");

var $iQEkD = parcelRequire("iQEkD");

var $hRsyH = parcelRequire("hRsyH");

var $5ac5o = parcelRequire("5ac5o");

var $biK3Z = parcelRequire("biK3Z");
const $fc575526edad0a23$var$VERSION = "5.6.3";
function $fc575526edad0a23$var$getBufferResponse(response) {
    return response.arrayBuffer();
}
function $fc575526edad0a23$var$fetchWrapper(requestOptions) {
    const log = requestOptions.request && requestOptions.request.log ? requestOptions.request.log : console;
    if ((0, $hRsyH.isPlainObject)(requestOptions.body) || Array.isArray(requestOptions.body)) requestOptions.body = JSON.stringify(requestOptions.body);
    let headers = {};
    let status;
    let url;
    const fetch = requestOptions.request && requestOptions.request.fetch || (0, (/*@__PURE__*/$parcel$interopDefault($5ac5o)));
    return fetch(requestOptions.url, Object.assign({
        method: requestOptions.method,
        body: requestOptions.body,
        headers: requestOptions.headers,
        redirect: requestOptions.redirect
    }, // `requestOptions.request.agent` type is incompatible
    // see https://github.com/octokit/types.ts/pull/264
    requestOptions.request)).then(async (response)=>{
        url = response.url;
        status = response.status;
        for (const keyAndValue of response.headers)headers[keyAndValue[0]] = keyAndValue[1];
        if ("deprecation" in headers) {
            const matches = headers.link && headers.link.match(/<([^>]+)>; rel="deprecation"/);
            const deprecationLink = matches && matches.pop();
            log.warn(`[@octokit/request] "${requestOptions.method} ${requestOptions.url}" is deprecated. It is scheduled to be removed on ${headers.sunset}${deprecationLink ? `. See ${deprecationLink}` : ""}`);
        }
        if (status === 204 || status === 205) return;
        // GitHub API returns 200 for HEAD requests
        if (requestOptions.method === "HEAD") {
            if (status < 400) return;
            throw new (0, $biK3Z.RequestError)(response.statusText, status, {
                response: {
                    url: url,
                    status: status,
                    headers: headers,
                    data: undefined
                },
                request: requestOptions
            });
        }
        if (status === 304) throw new (0, $biK3Z.RequestError)("Not modified", status, {
            response: {
                url: url,
                status: status,
                headers: headers,
                data: await $fc575526edad0a23$var$getResponseData(response)
            },
            request: requestOptions
        });
        if (status >= 400) {
            const data = await $fc575526edad0a23$var$getResponseData(response);
            const error = new (0, $biK3Z.RequestError)($fc575526edad0a23$var$toErrorMessage(data), status, {
                response: {
                    url: url,
                    status: status,
                    headers: headers,
                    data: data
                },
                request: requestOptions
            });
            throw error;
        }
        return $fc575526edad0a23$var$getResponseData(response);
    }).then((data)=>{
        return {
            status: status,
            url: url,
            headers: headers,
            data: data
        };
    }).catch((error)=>{
        if (error instanceof (0, $biK3Z.RequestError)) throw error;
        throw new (0, $biK3Z.RequestError)(error.message, 500, {
            request: requestOptions
        });
    });
}
async function $fc575526edad0a23$var$getResponseData(response) {
    const contentType = response.headers.get("content-type");
    if (/application\/json/.test(contentType)) return response.json();
    if (!contentType || /^text\/|charset=utf-8$/.test(contentType)) return response.text();
    return $fc575526edad0a23$var$getBufferResponse(response);
}
function $fc575526edad0a23$var$toErrorMessage(data) {
    if (typeof data === "string") return data;
    // istanbul ignore else - just in case
    if ("message" in data) {
        if (Array.isArray(data.errors)) return `${data.message}: ${data.errors.map(JSON.stringify).join(", ")}`;
        return data.message;
    }
    // istanbul ignore next - just in case
    return `Unknown error: ${JSON.stringify(data)}`;
}
function $fc575526edad0a23$var$withDefaults(oldEndpoint, newDefaults) {
    const endpoint = oldEndpoint.defaults(newDefaults);
    const newApi = function(route, parameters) {
        const endpointOptions = endpoint.merge(route, parameters);
        if (!endpointOptions.request || !endpointOptions.request.hook) return $fc575526edad0a23$var$fetchWrapper(endpoint.parse(endpointOptions));
        const request = (route, parameters)=>{
            return $fc575526edad0a23$var$fetchWrapper(endpoint.parse(endpoint.merge(route, parameters)));
        };
        Object.assign(request, {
            endpoint: endpoint,
            defaults: $fc575526edad0a23$var$withDefaults.bind(null, endpoint)
        });
        return endpointOptions.request.hook(request, endpointOptions);
    };
    return Object.assign(newApi, {
        endpoint: endpoint,
        defaults: $fc575526edad0a23$var$withDefaults.bind(null, endpoint)
    });
}
const $fc575526edad0a23$export$b5fe3f66a567bec0 = $fc575526edad0a23$var$withDefaults((0, $g7yWe.endpoint), {
    headers: {
        "user-agent": `octokit-request.js/${$fc575526edad0a23$var$VERSION} ${(0, $iQEkD.getUserAgent)()}`
    }
});

});
parcelRegister("g7yWe", function(module, exports) {

$parcel$export(module.exports, "endpoint", () => $bbc866d105e9f621$export$125e2b775860041f);

var $hRsyH = parcelRequire("hRsyH");

var $iQEkD = parcelRequire("iQEkD");
function $bbc866d105e9f621$var$lowercaseKeys(object) {
    if (!object) return {};
    return Object.keys(object).reduce((newObj, key)=>{
        newObj[key.toLowerCase()] = object[key];
        return newObj;
    }, {});
}
function $bbc866d105e9f621$var$mergeDeep(defaults, options) {
    const result = Object.assign({}, defaults);
    Object.keys(options).forEach((key)=>{
        if ((0, $hRsyH.isPlainObject)(options[key])) {
            if (!(key in defaults)) Object.assign(result, {
                [key]: options[key]
            });
            else result[key] = $bbc866d105e9f621$var$mergeDeep(defaults[key], options[key]);
        } else Object.assign(result, {
            [key]: options[key]
        });
    });
    return result;
}
function $bbc866d105e9f621$var$removeUndefinedProperties(obj) {
    for(const key in obj)if (obj[key] === undefined) delete obj[key];
    return obj;
}
function $bbc866d105e9f621$var$merge(defaults, route, options) {
    if (typeof route === "string") {
        let [method, url] = route.split(" ");
        options = Object.assign(url ? {
            method: method,
            url: url
        } : {
            url: method
        }, options);
    } else options = Object.assign({}, route);
    // lowercase header names before merging with defaults to avoid duplicates
    options.headers = $bbc866d105e9f621$var$lowercaseKeys(options.headers);
    // remove properties with undefined values before merging
    $bbc866d105e9f621$var$removeUndefinedProperties(options);
    $bbc866d105e9f621$var$removeUndefinedProperties(options.headers);
    const mergedOptions = $bbc866d105e9f621$var$mergeDeep(defaults || {}, options);
    // mediaType.previews arrays are merged, instead of overwritten
    if (defaults && defaults.mediaType.previews.length) mergedOptions.mediaType.previews = defaults.mediaType.previews.filter((preview)=>!mergedOptions.mediaType.previews.includes(preview)).concat(mergedOptions.mediaType.previews);
    mergedOptions.mediaType.previews = mergedOptions.mediaType.previews.map((preview)=>preview.replace(/-preview/, ""));
    return mergedOptions;
}
function $bbc866d105e9f621$var$addQueryParameters(url, parameters) {
    const separator = /\?/.test(url) ? "&" : "?";
    const names = Object.keys(parameters);
    if (names.length === 0) return url;
    return url + separator + names.map((name)=>{
        if (name === "q") return "q=" + parameters.q.split("+").map(encodeURIComponent).join("+");
        return `${name}=${encodeURIComponent(parameters[name])}`;
    }).join("&");
}
const $bbc866d105e9f621$var$urlVariableRegex = /\{[^}]+\}/g;
function $bbc866d105e9f621$var$removeNonChars(variableName) {
    return variableName.replace(/^\W+|\W+$/g, "").split(/,/);
}
function $bbc866d105e9f621$var$extractUrlVariableNames(url) {
    const matches = url.match($bbc866d105e9f621$var$urlVariableRegex);
    if (!matches) return [];
    return matches.map($bbc866d105e9f621$var$removeNonChars).reduce((a, b)=>a.concat(b), []);
}
function $bbc866d105e9f621$var$omit(object, keysToOmit) {
    return Object.keys(object).filter((option)=>!keysToOmit.includes(option)).reduce((obj, key)=>{
        obj[key] = object[key];
        return obj;
    }, {});
}
// Based on https://github.com/bramstein/url-template, licensed under BSD
// TODO: create separate package.
//
// Copyright (c) 2012-2014, Bram Stein
// All rights reserved.
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions
// are met:
//  1. Redistributions of source code must retain the above copyright
//     notice, this list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright
//     notice, this list of conditions and the following disclaimer in the
//     documentation and/or other materials provided with the distribution.
//  3. The name of the author may not be used to endorse or promote products
//     derived from this software without specific prior written permission.
// THIS SOFTWARE IS PROVIDED BY THE AUTHOR "AS IS" AND ANY EXPRESS OR IMPLIED
// WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO
// EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
// INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
// BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
// NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
// EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
/* istanbul ignore file */ function $bbc866d105e9f621$var$encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part) {
        if (!/%[0-9A-Fa-f]/.test(part)) part = encodeURI(part).replace(/%5B/g, "[").replace(/%5D/g, "]");
        return part;
    }).join("");
}
function $bbc866d105e9f621$var$encodeUnreserved(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
function $bbc866d105e9f621$var$encodeValue(operator, value, key) {
    value = operator === "+" || operator === "#" ? $bbc866d105e9f621$var$encodeReserved(value) : $bbc866d105e9f621$var$encodeUnreserved(value);
    if (key) return $bbc866d105e9f621$var$encodeUnreserved(key) + "=" + value;
    else return value;
}
function $bbc866d105e9f621$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $bbc866d105e9f621$var$isKeyOperator(operator) {
    return operator === ";" || operator === "&" || operator === "?";
}
function $bbc866d105e9f621$var$getValues(context, operator, key, modifier) {
    var value = context[key], result = [];
    if ($bbc866d105e9f621$var$isDefined(value) && value !== "") {
        if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
            value = value.toString();
            if (modifier && modifier !== "*") value = value.substring(0, parseInt(modifier, 10));
            result.push($bbc866d105e9f621$var$encodeValue(operator, value, $bbc866d105e9f621$var$isKeyOperator(operator) ? key : ""));
        } else if (modifier === "*") {
            if (Array.isArray(value)) value.filter($bbc866d105e9f621$var$isDefined).forEach(function(value) {
                result.push($bbc866d105e9f621$var$encodeValue(operator, value, $bbc866d105e9f621$var$isKeyOperator(operator) ? key : ""));
            });
            else Object.keys(value).forEach(function(k) {
                if ($bbc866d105e9f621$var$isDefined(value[k])) result.push($bbc866d105e9f621$var$encodeValue(operator, value[k], k));
            });
        } else {
            const tmp = [];
            if (Array.isArray(value)) value.filter($bbc866d105e9f621$var$isDefined).forEach(function(value) {
                tmp.push($bbc866d105e9f621$var$encodeValue(operator, value));
            });
            else Object.keys(value).forEach(function(k) {
                if ($bbc866d105e9f621$var$isDefined(value[k])) {
                    tmp.push($bbc866d105e9f621$var$encodeUnreserved(k));
                    tmp.push($bbc866d105e9f621$var$encodeValue(operator, value[k].toString()));
                }
            });
            if ($bbc866d105e9f621$var$isKeyOperator(operator)) result.push($bbc866d105e9f621$var$encodeUnreserved(key) + "=" + tmp.join(","));
            else if (tmp.length !== 0) result.push(tmp.join(","));
        }
    } else {
        if (operator === ";") {
            if ($bbc866d105e9f621$var$isDefined(value)) result.push($bbc866d105e9f621$var$encodeUnreserved(key));
        } else if (value === "" && (operator === "&" || operator === "?")) result.push($bbc866d105e9f621$var$encodeUnreserved(key) + "=");
        else if (value === "") result.push("");
    }
    return result;
}
function $bbc866d105e9f621$var$parseUrl(template) {
    return {
        expand: $bbc866d105e9f621$var$expand.bind(null, template)
    };
}
function $bbc866d105e9f621$var$expand(template, context) {
    var operators = [
        "+",
        "#",
        ".",
        "/",
        ";",
        "?",
        "&"
    ];
    return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression, literal) {
        if (expression) {
            let operator = "";
            const values = [];
            if (operators.indexOf(expression.charAt(0)) !== -1) {
                operator = expression.charAt(0);
                expression = expression.substr(1);
            }
            expression.split(/,/g).forEach(function(variable) {
                var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                values.push($bbc866d105e9f621$var$getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
            });
            if (operator && operator !== "+") {
                var separator = ",";
                if (operator === "?") separator = "&";
                else if (operator !== "#") separator = operator;
                return (values.length !== 0 ? operator : "") + values.join(separator);
            } else return values.join(",");
        } else return $bbc866d105e9f621$var$encodeReserved(literal);
    });
}
function $bbc866d105e9f621$var$parse(options) {
    // https://fetch.spec.whatwg.org/#methods
    let method = options.method.toUpperCase();
    // replace :varname with {varname} to make it RFC 6570 compatible
    let url = (options.url || "/").replace(/:([a-z]\w+)/g, "{$1}");
    let headers = Object.assign({}, options.headers);
    let body;
    let parameters = $bbc866d105e9f621$var$omit(options, [
        "method",
        "baseUrl",
        "url",
        "headers",
        "request",
        "mediaType"
    ]);
    // extract variable names from URL to calculate remaining variables later
    const urlVariableNames = $bbc866d105e9f621$var$extractUrlVariableNames(url);
    url = $bbc866d105e9f621$var$parseUrl(url).expand(parameters);
    if (!/^http/.test(url)) url = options.baseUrl + url;
    const omittedParameters = Object.keys(options).filter((option)=>urlVariableNames.includes(option)).concat("baseUrl");
    const remainingParameters = $bbc866d105e9f621$var$omit(parameters, omittedParameters);
    const isBinaryRequest = /application\/octet-stream/i.test(headers.accept);
    if (!isBinaryRequest) {
        if (options.mediaType.format) // e.g. application/vnd.github.v3+json => application/vnd.github.v3.raw
        headers.accept = headers.accept.split(/,/).map((preview)=>preview.replace(/application\/vnd(\.\w+)(\.v3)?(\.\w+)?(\+json)?$/, `application/vnd$1$2.${options.mediaType.format}`)).join(",");
        if (options.mediaType.previews.length) {
            const previewsFromAcceptHeader = headers.accept.match(/[\w-]+(?=-preview)/g) || [];
            headers.accept = previewsFromAcceptHeader.concat(options.mediaType.previews).map((preview)=>{
                const format = options.mediaType.format ? `.${options.mediaType.format}` : "+json";
                return `application/vnd.github.${preview}-preview${format}`;
            }).join(",");
        }
    }
    // for GET/HEAD requests, set URL query parameters from remaining parameters
    // for PATCH/POST/PUT/DELETE requests, set request body from remaining parameters
    if ([
        "GET",
        "HEAD"
    ].includes(method)) url = $bbc866d105e9f621$var$addQueryParameters(url, remainingParameters);
    else {
        if ("data" in remainingParameters) body = remainingParameters.data;
        else if (Object.keys(remainingParameters).length) body = remainingParameters;
        else headers["content-length"] = 0;
    }
    // default content-type for JSON if body is set
    if (!headers["content-type"] && typeof body !== "undefined") headers["content-type"] = "application/json; charset=utf-8";
    // GitHub expects 'content-length: 0' header for PUT/PATCH requests without body.
    // fetch does not allow to set `content-length` header, but we can set body to an empty string
    if ([
        "PATCH",
        "PUT"
    ].includes(method) && typeof body === "undefined") body = "";
    // Only return body/request keys if present
    return Object.assign({
        method: method,
        url: url,
        headers: headers
    }, typeof body !== "undefined" ? {
        body: body
    } : null, options.request ? {
        request: options.request
    } : null);
}
function $bbc866d105e9f621$var$endpointWithDefaults(defaults, route, options) {
    return $bbc866d105e9f621$var$parse($bbc866d105e9f621$var$merge(defaults, route, options));
}
function $bbc866d105e9f621$var$withDefaults(oldDefaults, newDefaults) {
    const DEFAULTS = $bbc866d105e9f621$var$merge(oldDefaults, newDefaults);
    const endpoint = $bbc866d105e9f621$var$endpointWithDefaults.bind(null, DEFAULTS);
    return Object.assign(endpoint, {
        DEFAULTS: DEFAULTS,
        defaults: $bbc866d105e9f621$var$withDefaults.bind(null, DEFAULTS),
        merge: $bbc866d105e9f621$var$merge.bind(null, DEFAULTS),
        parse: $bbc866d105e9f621$var$parse
    });
}
const $bbc866d105e9f621$var$VERSION = "6.0.12";
const $bbc866d105e9f621$var$userAgent = `octokit-endpoint.js/${$bbc866d105e9f621$var$VERSION} ${(0, $iQEkD.getUserAgent)()}`;
// DEFAULTS has all properties set that EndpointOptions has, except url.
// So we use RequestParameters and add method as additional required property.
const $bbc866d105e9f621$var$DEFAULTS = {
    method: "GET",
    baseUrl: "https://api.github.com",
    headers: {
        accept: "application/vnd.github.v3+json",
        "user-agent": $bbc866d105e9f621$var$userAgent
    },
    mediaType: {
        format: "",
        previews: []
    }
};
const $bbc866d105e9f621$export$125e2b775860041f = $bbc866d105e9f621$var$withDefaults(null, $bbc866d105e9f621$var$DEFAULTS);

});
parcelRegister("hRsyH", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $b83dc53bc93fa4e6$export$53b83ca8eaab0383);
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $b83dc53bc93fa4e6$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $b83dc53bc93fa4e6$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($b83dc53bc93fa4e6$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($b83dc53bc93fa4e6$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("5ac5o", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var globalObject = getGlobal();
module.exports = exports = globalObject.fetch;
// Needed for TypeScript and Webpack.
if (globalObject.fetch) exports.default = globalObject.fetch.bind(globalObject);
exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

});

parcelRegister("biK3Z", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $83a51b5971c09339$export$43ee7d0e4f429743);

var $lFmVl = parcelRequire("lFmVl");

var $9Y5hh = parcelRequire("9Y5hh");
const $83a51b5971c09339$var$logOnceCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Y5hh)))((deprecation)=>console.warn(deprecation));
const $83a51b5971c09339$var$logOnceHeaders = (0, (/*@__PURE__*/$parcel$interopDefault($9Y5hh)))((deprecation)=>console.warn(deprecation));
/**
 * Error with extra properties to help with debugging
 */ class $83a51b5971c09339$export$43ee7d0e4f429743 extends Error {
    constructor(message, statusCode, options){
        super(message);
        // Maintains proper stack trace (only available on V8)
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        this.name = "HttpError";
        this.status = statusCode;
        let headers;
        if ("headers" in options && typeof options.headers !== "undefined") headers = options.headers;
        if ("response" in options) {
            this.response = options.response;
            headers = options.response.headers;
        }
        // redact request credentials without mutating original request options
        const requestCopy = Object.assign({}, options.request);
        if (options.request.headers.authorization) requestCopy.headers = Object.assign({}, options.request.headers, {
            authorization: options.request.headers.authorization.replace(/ .*$/, " [REDACTED]")
        });
        requestCopy.url = requestCopy.url// client_id & client_secret can be passed as URL query parameters to increase rate limit
        // see https://developer.github.com/v3/#increasing-the-unauthenticated-rate-limit-for-oauth-applications
        .replace(/\bclient_secret=\w+/g, "client_secret=[REDACTED]")// OAuth tokens can be passed as URL query parameters, although it is not recommended
        // see https://developer.github.com/v3/#oauth2-token-sent-in-a-header
        .replace(/\baccess_token=\w+/g, "access_token=[REDACTED]");
        this.request = requestCopy;
        // deprecations
        Object.defineProperty(this, "code", {
            get () {
                $83a51b5971c09339$var$logOnceCode(new (0, $lFmVl.Deprecation)("[@octokit/request-error] `error.code` is deprecated, use `error.status`."));
                return statusCode;
            }
        });
        Object.defineProperty(this, "headers", {
            get () {
                $83a51b5971c09339$var$logOnceHeaders(new (0, $lFmVl.Deprecation)("[@octokit/request-error] `error.headers` is deprecated, use `error.response.headers`."));
                return headers || {};
            }
        });
    }
}

});
parcelRegister("lFmVl", function(module, exports) {

$parcel$export(module.exports, "Deprecation", () => $fc5f358262a4ff49$export$d5e40bdbb672dd52);
class $fc5f358262a4ff49$export$d5e40bdbb672dd52 extends Error {
    constructor(message){
        super(message); // Maintains proper stack trace (only available on V8)
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        this.name = 'Deprecation';
    }
}

});

parcelRegister("9Y5hh", function(module, exports) {

var $Bic4X = parcelRequire("Bic4X");
module.exports = $Bic4X($741dcfae98cfc9a0$var$once);
module.exports.strict = $Bic4X($741dcfae98cfc9a0$var$onceStrict);
$741dcfae98cfc9a0$var$once.proto = $741dcfae98cfc9a0$var$once(function() {
    Object.defineProperty(Function.prototype, 'once', {
        value: function() {
            return $741dcfae98cfc9a0$var$once(this);
        },
        configurable: true
    });
    Object.defineProperty(Function.prototype, 'onceStrict', {
        value: function() {
            return $741dcfae98cfc9a0$var$onceStrict(this);
        },
        configurable: true
    });
});
function $741dcfae98cfc9a0$var$once(fn) {
    var f = function() {
        if (f.called) return f.value;
        f.called = true;
        return f.value = fn.apply(this, arguments);
    };
    f.called = false;
    return f;
}
function $741dcfae98cfc9a0$var$onceStrict(fn) {
    var f = function() {
        if (f.called) throw new Error(f.onceError);
        f.called = true;
        return f.value = fn.apply(this, arguments);
    };
    var name = fn.name || 'Function wrapped with `once`';
    f.onceError = name + " shouldn't be called more than once";
    f.called = false;
    return f;
}

});
parcelRegister("Bic4X", function(module, exports) {
// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = $070191baf018bed9$var$wrappy;
function $070191baf018bed9$var$wrappy(fn, cb) {
    if (fn && cb) return $070191baf018bed9$var$wrappy(fn)(cb);
    if (typeof fn !== 'function') throw new TypeError('need wrapper function');
    Object.keys(fn).forEach(function(k) {
        wrapper[k] = fn[k];
    });
    return wrapper;
    function wrapper() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        var ret = fn.apply(this, args);
        var cb = args[args.length - 1];
        if (typeof ret === 'function' && ret !== cb) Object.keys(cb).forEach(function(k) {
            ret[k] = cb[k];
        });
        return ret;
    }
}

});




parcelRegister("jjQok", function(module, exports) {

$parcel$export(module.exports, "withCustomRequest", () => $e1086e829b8a5b58$export$9eb07bf38af78249);

var $lFcLN = parcelRequire("lFcLN");

var $iQEkD = parcelRequire("iQEkD");
const $e1086e829b8a5b58$var$VERSION = "4.8.0";
function $e1086e829b8a5b58$var$_buildMessageForResponseErrors(data) {
    return `Request failed due to following response errors:\n` + data.errors.map((e)=>` - ${e.message}`).join("\n");
}
class $e1086e829b8a5b58$export$d19deff0ec585725 extends Error {
    constructor(request, headers, response){
        super($e1086e829b8a5b58$var$_buildMessageForResponseErrors(response));
        this.request = request;
        this.headers = headers;
        this.response = response;
        this.name = "GraphqlResponseError";
        // Expose the errors and response data in their shorthand properties.
        this.errors = response.errors;
        this.data = response.data;
        // Maintains proper stack trace (only available on V8)
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    }
}
const $e1086e829b8a5b58$var$NON_VARIABLE_OPTIONS = [
    "method",
    "baseUrl",
    "url",
    "headers",
    "request",
    "query",
    "mediaType"
];
const $e1086e829b8a5b58$var$FORBIDDEN_VARIABLE_OPTIONS = [
    "query",
    "method",
    "url"
];
const $e1086e829b8a5b58$var$GHES_V3_SUFFIX_REGEX = /\/api\/v3\/?$/;
function $e1086e829b8a5b58$var$graphql(request, query, options) {
    if (options) {
        if (typeof query === "string" && "query" in options) return Promise.reject(new Error(`[@octokit/graphql] "query" cannot be used as variable name`));
        for(const key in options){
            if (!$e1086e829b8a5b58$var$FORBIDDEN_VARIABLE_OPTIONS.includes(key)) continue;
            return Promise.reject(new Error(`[@octokit/graphql] "${key}" cannot be used as variable name`));
        }
    }
    const parsedOptions = typeof query === "string" ? Object.assign({
        query: query
    }, options) : query;
    const requestOptions = Object.keys(parsedOptions).reduce((result, key)=>{
        if ($e1086e829b8a5b58$var$NON_VARIABLE_OPTIONS.includes(key)) {
            result[key] = parsedOptions[key];
            return result;
        }
        if (!result.variables) result.variables = {};
        result.variables[key] = parsedOptions[key];
        return result;
    }, {});
    // workaround for GitHub Enterprise baseUrl set with /api/v3 suffix
    // https://github.com/octokit/auth-app.js/issues/111#issuecomment-657610451
    const baseUrl = parsedOptions.baseUrl || request.endpoint.DEFAULTS.baseUrl;
    if ($e1086e829b8a5b58$var$GHES_V3_SUFFIX_REGEX.test(baseUrl)) requestOptions.url = baseUrl.replace($e1086e829b8a5b58$var$GHES_V3_SUFFIX_REGEX, "/api/graphql");
    return request(requestOptions).then((response)=>{
        if (response.data.errors) {
            const headers = {};
            for (const key of Object.keys(response.headers))headers[key] = response.headers[key];
            throw new $e1086e829b8a5b58$export$d19deff0ec585725(requestOptions, headers, response.data);
        }
        return response.data.data;
    });
}
function $e1086e829b8a5b58$var$withDefaults(request$1, newDefaults) {
    const newRequest = request$1.defaults(newDefaults);
    const newApi = (query, options)=>{
        return $e1086e829b8a5b58$var$graphql(newRequest, query, options);
    };
    return Object.assign(newApi, {
        defaults: $e1086e829b8a5b58$var$withDefaults.bind(null, newRequest),
        endpoint: (0, $lFcLN.request).endpoint
    });
}
const $e1086e829b8a5b58$export$1eb4e7c0ed67b035 = $e1086e829b8a5b58$var$withDefaults((0, $lFcLN.request), {
    headers: {
        "user-agent": `octokit-graphql.js/${$e1086e829b8a5b58$var$VERSION} ${(0, $iQEkD.getUserAgent)()}`
    },
    method: "POST",
    url: "/graphql"
});
function $e1086e829b8a5b58$export$9eb07bf38af78249(customRequest) {
    return $e1086e829b8a5b58$var$withDefaults(customRequest, {
        method: "POST",
        url: "/graphql"
    });
}

});

parcelRegister("giAk4", function(module, exports) {

$parcel$export(module.exports, "createTokenAuth", () => $bdda80b56ad29119$export$acf0006d85231cb6);
const $bdda80b56ad29119$var$REGEX_IS_INSTALLATION_LEGACY = /^v1\./;
const $bdda80b56ad29119$var$REGEX_IS_INSTALLATION = /^ghs_/;
const $bdda80b56ad29119$var$REGEX_IS_USER_TO_SERVER = /^ghu_/;
async function $bdda80b56ad29119$var$auth(token) {
    const isApp = token.split(/\./).length === 3;
    const isInstallation = $bdda80b56ad29119$var$REGEX_IS_INSTALLATION_LEGACY.test(token) || $bdda80b56ad29119$var$REGEX_IS_INSTALLATION.test(token);
    const isUserToServer = $bdda80b56ad29119$var$REGEX_IS_USER_TO_SERVER.test(token);
    const tokenType = isApp ? "app" : isInstallation ? "installation" : isUserToServer ? "user-to-server" : "oauth";
    return {
        type: "token",
        token: token,
        tokenType: tokenType
    };
}
/**
 * Prefix token for usage in the Authorization header
 *
 * @param token OAuth token or JSON Web Token
 */ function $bdda80b56ad29119$var$withAuthorizationPrefix(token) {
    if (token.split(/\./).length === 3) return `bearer ${token}`;
    return `token ${token}`;
}
async function $bdda80b56ad29119$var$hook(token, request, route, parameters) {
    const endpoint = request.endpoint.merge(route, parameters);
    endpoint.headers.authorization = $bdda80b56ad29119$var$withAuthorizationPrefix(token);
    return request(endpoint);
}
const $bdda80b56ad29119$export$acf0006d85231cb6 = function createTokenAuth(token) {
    if (!token) throw new Error("[@octokit/auth-token] No token passed to createTokenAuth");
    if (typeof token !== "string") throw new Error("[@octokit/auth-token] Token passed to createTokenAuth is not a string");
    token = token.replace(/^(token|bearer) +/i, "");
    return Object.assign($bdda80b56ad29119$var$auth.bind(null, token), {
        hook: $bdda80b56ad29119$var$hook.bind(null, token)
    });
};

});


parcelRegister("285ah", function(module, exports) {

$parcel$export(module.exports, "LocalStorageService", () => $65fcdab4d64a7d04$export$fda5b86bc4921cb9);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $deWeK = parcelRequire("deWeK");
parcelRequire("gLrIK");
var $8h5AV = parcelRequire("8h5AV");

var $1t8Wn = parcelRequire("1t8Wn");

var $f16OP = parcelRequire("f16OP");

var $6Rz6W = parcelRequire("6Rz6W");
class $65fcdab4d64a7d04$export$fda5b86bc4921cb9 {
    get(name) {
        const item = localStorage.getItem(name);
        try {
            return JSON.parse(item);
        } catch (e) {
            return item;
        }
    }
    update(name, payload) {
        const data = (0, $8h5AV.isPrimitive)(payload) ? payload : JSON.stringify(payload);
        localStorage.setItem(name, data);
        this.updateQueue.next({
            name: name,
            data: data
        });
    }
    onUpdated(name) {
        return this.updateQueue.pipe((0, $6Rz6W.filter)((data)=>data.name === name));
    }
    clear() {
        localStorage.clear();
    }
    remove(name) {
        localStorage.removeItem(name);
    }
    constructor(){
        this.updateQueue = new (0, $f16OP.Subject)();
    }
}
$65fcdab4d64a7d04$export$fda5b86bc4921cb9 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $65fcdab4d64a7d04$export$fda5b86bc4921cb9);

});
parcelRegister("gLrIK", function(module, exports) {
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("8h5AV")).isPrimitive);
$parcel$export(module.exports, "ParsersProvider", () => (parcelRequire("h70g9")).ParsersProvider);
parcelRequire("8h5AV");
parcelRequire("h70g9");

});
parcelRegister("8h5AV", function(module, exports) {

$parcel$export(module.exports, "isPrimitive", () => $00c07c14addcbcac$export$c3825b437cbdea5c);
const $00c07c14addcbcac$export$c3825b437cbdea5c = (value)=>value !== Object(value);

});

parcelRegister("h70g9", function(module, exports) {

$parcel$export(module.exports, "ParsersProvider", () => $bc4edad2105e140d$export$9dc1a8d4c28857d5);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");
class $bc4edad2105e140d$export$9dc1a8d4c28857d5 {
    parseUniqueId(uniqueLabel = '') {
        return uniqueLabel.split('_')[0];
    }
    parseUserId(uniqueLabel = '') {
        return uniqueLabel.split('_')[1];
    }
    parseLabel(uniqueLabel = '') {
        return uniqueLabel.split('_')[2];
    }
}
$bc4edad2105e140d$export$9dc1a8d4c28857d5 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $bc4edad2105e140d$export$9dc1a8d4c28857d5);

});




parcelRegister("7HQg9", function(module, exports) {

$parcel$export(module.exports, "GlobalProjectsMenuService", () => $92a4688d01604976$export$ccf70960e74036e6);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
class $92a4688d01604976$export$ccf70960e74036e6 {
    isMenuOpenedSubject() {
        return this.isMenuOpened.asObservable();
    }
    openMenu() {
        this.isMenuOpened.next(true);
    }
    closeMenu() {
        this.isMenuOpened.next(false);
    }
    toggle() {
        this.isMenuOpened.next(!this.isMenuOpened.getValue());
    }
    constructor(){
        this.isMenuOpened = new (0, $bq6Hs.BehaviorSubject)(false);
    }
}
$92a4688d01604976$export$ccf70960e74036e6 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $92a4688d01604976$export$ccf70960e74036e6);

});

parcelRegister("d8h3d", function(module, exports) {

$parcel$export(module.exports, "GraphEnumsProvider", () => $ad995594c88ccfcd$export$fb70875c2128890e);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $gawXH = parcelRequire("gawXH");

var $izlFR = parcelRequire("izlFR");

var $7cokz = parcelRequire("7cokz");
class $ad995594c88ccfcd$export$fb70875c2128890e {
    getEnums() {
        return this.http.query((0, $7cokz.gql)`
          query {
            worker_commands: __type(name: "WorkerCommands") {
              name
              enumValues {
                name
                description
                isDeprecated
              }
            }
            instance_commands: __type(name: "InstanceCommands") {
              name
              enumValues {
                name
                description
                isDeprecated
              }
            }
          }
        `).pipe((0, $gawXH.map)(({ data: data })=>data));
    }
    getLinodeRegions() {
        return this.http.get('https://api.linode.com/v4/regions');
    }
    getLinodeRegionsKeys() {
        return this.getLinodeRegions().pipe((0, $gawXH.map)((i)=>i.data.map((r)=>r.id)));
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $izlFR.HttpClient))
], $ad995594c88ccfcd$export$fb70875c2128890e.prototype, "http", void 0);
$ad995594c88ccfcd$export$fb70875c2128890e = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $ad995594c88ccfcd$export$fb70875c2128890e);

});
parcelRegister("izlFR", function(module, exports) {

$parcel$export(module.exports, "HttpClient", () => $f228f8f3d620ba43$export$8c6ee871e681f0f4);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $5JMLH = parcelRequire("5JMLH");

var $7cokz = parcelRequire("7cokz");
class $f228f8f3d620ba43$export$8c6ee871e681f0f4 {
    constructor(graphqlConfig){
        this.graphqlConfig = graphqlConfig;
        this.graphqlConfig = graphqlConfig || (0, $1t8Wn.Container).get((0, $7cokz.GraphqClientConfig));
    }
    query(query, variables, options) {
        return this.getInternalJson(this.graphqlConfig.url, JSON.stringify({
            query: query,
            variables: variables
        }), {
            ...options,
            method: 'POST'
        });
    }
    mutation(mutation, variables, options) {
        return this.getInternalJson(this.graphqlConfig.url, JSON.stringify({
            mutation: mutation,
            variables: variables
        }), {
            ...options,
            method: 'POST'
        });
    }
    getInternalJson(url, body, options = {
        method: 'GET'
    }) {
        const params = this.encodeQueryData(options.params);
        const defaultHeaders = Object.assign({
            'Content-Type': 'application/json'
        }, options.headers);
        return (0, $5JMLH.from)(fetch(url + params, {
            method: options.method,
            headers: this.appendHeaders(defaultHeaders),
            body: body
        }).then((res)=>res.json()));
    }
    appendHeaders(h) {
        const headers = new Headers(h);
        Object.entries(h).forEach(([key, value])=>{
            headers.set(key, value);
        });
        return headers;
    }
    get(url, body, options = {
        method: 'GET'
    }) {
        return this.getInternalJson(url, body, options);
    }
    post(url, body, options = {
        method: 'POST'
    }) {
        return this.getInternalJson(url, body, options);
    }
    update(url, body, options = {
        method: 'UPDATE'
    }) {
        return this.getInternalJson(url, body, options);
    }
    delete(url, body, options = {
        method: 'DELETE'
    }) {
        return this.getInternalJson(url, body, options);
    }
    encodeQueryData(data = {}) {
        return Object.entries(data).map((pair)=>pair.map(encodeURIComponent).join('=')).join('&');
    }
}
$f228f8f3d620ba43$export$8c6ee871e681f0f4 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $f228f8f3d620ba43$export$8c6ee871e681f0f4);

});
parcelRegister("7cokz", function(module, exports) {

$parcel$export(module.exports, "GraphqClientConfig", () => $b900651f10488e56$export$32b3ca542949c29f);
$parcel$export(module.exports, "gql", () => $b900651f10488e56$export$72e4926bf8358653);

var $1t8Wn = parcelRequire("1t8Wn");
const $b900651f10488e56$export$32b3ca542949c29f = new (0, $1t8Wn.InjectionToken)();
function $b900651f10488e56$export$72e4926bf8358653(...args) {
    const literals = args[0];
    let result = typeof literals === 'string' ? literals : literals[0];
    for(let i = 1; i < args.length; i++){
        if (args[i] && args[i].kind && args[i].kind === 'Document') result += args[i].loc.source.body;
        else result += args[i];
        result += literals[i];
    }
    return result;
}

});



parcelRegister("c6XAH", function(module, exports) {

$parcel$export(module.exports, "HotKeysProvider", () => $889140149e447b86$export$1aa3cf621cbf0ef);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $9tLTP = parcelRequire("9tLTP");

var $4TeKW = parcelRequire("4TeKW");

var $8Esaf = parcelRequire("8Esaf");
const $889140149e447b86$var$style = (0, $4TeKW.css)`
  .container {
    color: black;
    margin-top: 100px;
  }
  .recent {
    padding: 20px;
  }
`;
const $889140149e447b86$var$template = (0, $4TeKW.html)`<style>
    ${$889140149e447b86$var$style}
  </style>
  <div class="container">
    <div class="recent">Recently used</div>
    <div class="recent">Recently used</div>
  </div> `;
class $889140149e447b86$export$1aa3cf621cbf0ef {
    get rightKey() {
        return this.hotkeys.bind('right');
    }
    get upKey() {
        return this.hotkeys.bind('up');
    }
    get downKey() {
        return this.hotkeys.bind('down');
    }
    get shiftKeyPlusDown() {
        return this.hotkeys.bind('shift+down');
    }
    get shiftKeyPlusUp() {
        return this.hotkeys.bind('shift+up');
    }
    get leftKey() {
        return this.hotkeys.bind('left');
    }
    get enterKey() {
        return this.hotkeys.bind('enter');
    }
    get spaceKey() {
        return this.hotkeys.bind('space');
    }
    get backKey() {
        return this.hotkeys.bind('backspace');
    }
    get ctrlEnter() {
        return this.hotkeys.bind('shift+enter');
    }
    get ctrlMention() {
        return this.hotkeys.bind('shift+2');
    }
    get escapeKey() {
        return this.hotkeys.bind('escape');
    }
    OnInit() {
        this.gloablMenuService.getOpenSubject().subscribe((menuOpened)=>this.menuOpened = menuOpened);
        this.hotkeys.bind('tab').subscribe((event)=>{
            event.preventDefault();
            event.stopPropagation();
            if (this.menuOpened) this.gloablMenuService.close();
            else this.gloablMenuService.open($889140149e447b86$var$template);
        });
    }
    bind() {
        return this.hotkeys.bind('space');
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $9tLTP.HotKeysService))
], $889140149e447b86$export$1aa3cf621cbf0ef.prototype, "hotkeys", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $8Esaf.GlobalMenuService))
], $889140149e447b86$export$1aa3cf621cbf0ef.prototype, "gloablMenuService", void 0);
$889140149e447b86$export$1aa3cf621cbf0ef = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)({
        init: true
    })
], $889140149e447b86$export$1aa3cf621cbf0ef);

});
parcelRegister("8Esaf", function(module, exports) {
"use strict";
var $64c7e7f903feda9f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $64c7e7f903feda9f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $64c7e7f903feda9f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$64c7e7f903feda9f$var$__exportStar((parcelRequire("bvKF0")), module.exports);

$64c7e7f903feda9f$var$__exportStar((parcelRequire("dHfiX")), module.exports);

});
parcelRegister("bvKF0", function(module, exports) {
"use strict";
var $8616c8ba8b4beab2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8616c8ba8b4beab2$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $8616c8ba8b4beab2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GlobalMenuComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $cGyk6 = parcelRequire("cGyk6");

var $1t8Wn = parcelRequire("1t8Wn");

var $dHfiX = parcelRequire("dHfiX");
/**
 * @customElement global-menu
 */ let $8616c8ba8b4beab2$var$GlobalMenuComponent = class GlobalMenuComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.menu = $1t8Wn.Container.get($dHfiX.GlobalMenuService);
    }
    OnUpdateFirst() {
        return $8616c8ba8b4beab2$var$__awaiter(this, void 0, void 0, function*() {
            document.onkeyup = (e)=>{
                if (e.key === 'Escape') this.cancel();
            };
        });
    }
    open(template) {
        this.template = template;
        this.menu.setOpenSubject(true);
    }
    cancel() {
        this.remove();
        this.menu.setOpenSubject(false);
    }
};
$8616c8ba8b4beab2$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $8616c8ba8b4beab2$var$__metadata("design:type", Object)
], $8616c8ba8b4beab2$var$GlobalMenuComponent.prototype, "template", void 0);
$8616c8ba8b4beab2$var$GlobalMenuComponent = $8616c8ba8b4beab2$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'global-menu',
        style: $cGyk6.style,
        template () {
            return (0, $4TeKW.html)`
      <div id="background" @click="${()=>this.cancel()}"></div>
      <button id="closeButton" @click="${()=>this.cancel()}">
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.33"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.11932 0.357981C1.59693 -0.119327 2.37129 -0.119327 2.8489 0.357981L11.7681 9.27152L20.6873 0.357981C21.165 -0.119327 21.9393 -0.119327 22.4169 0.357981C22.8945 0.835288 22.8945 1.60916 22.4169 2.08646L13.4977 11L22.4169 19.9135C22.8945 20.3908 22.8945 21.1647 22.4169 21.642C21.9393 22.1193 21.165 22.1193 20.6873 21.642L11.7681 12.7285L2.8489 21.642C2.37129 22.1193 1.59693 22.1193 1.11932 21.642C0.641705 21.1647 0.641705 20.3908 1.11932 19.9135L10.0385 11L1.11932 2.08646C0.641705 1.60916 0.641705 0.835288 1.11932 0.357981Z"
            fill="#60656D"
          />
        </svg>
      </button>
      <div id="installModal">
        ${this.template ? this.template : (0, $4TeKW.html)`<slot></slot>`}
        <div id="buttonsContainer">
          <button @click="${()=>this.cancel()}" id="installButton">
            Close
          </button>
        </div>
      </div>
    `;
        }
    })
], $8616c8ba8b4beab2$var$GlobalMenuComponent);
module.exports.GlobalMenuComponent = $8616c8ba8b4beab2$var$GlobalMenuComponent;

});
parcelRegister("cGyk6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.style = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.style = (0, $4TeKW.css)`
:host {
  --install-button-color: linear-gradient(
    90deg,
    #1fc2c8 0%,
    #9337d8 169.8%
  );
  --modal-z-index: auto;
}
button {
  outline: none;
}
#installModal {
  background: white;
  position: fixed;
  bottom: 3em;
  top: 3em;
  left: 14em;
  right: 14em;
  font-family: sans-serif;
  box-shadow: 0px 25px 26px rgba(32, 36, 50, 0.25),
    0px 5px 9px rgba(51, 58, 83, 0.53);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 0;
  animation-name: opened;
  animation-duration: 150ms;
  z-index: 100000;
}
@keyframes opened {
  from {
    transform: scale(0.8, 0.8);
    opacity: 0.4;
  }
  to {
    transform: scale(1, 1);
    opacity: 1;
  }
}
@keyframes mobile {
  from {
    opacity: 0.6;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadein {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}

@keyframes scale {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
#background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  right: 0;
  backdrop-filter: blur(25px);
  animation-name: fadein;
  animation-duration: 250ms;
}
#headerContainer {
  display: flex;
  align-items: flex-start;
  margin: 40px;
  margin-bottom: 32px;
}
#headerContainer h1 {
  font-size: 34px;
  color: #3c3c3c;
  margin-top: 20px;
  margin-bottom: 7px;
}
#headerContainer img {
  height: 122px;
  width: 122px;
  background: lightgrey;
  border-radius: 10px;
  padding: 12px;
  border-radius: 24px;
  margin-right: 24px;
}
#buttonsContainer {
  display: flex;
  justify-content: flex-end;
  position: relative;
  bottom: -4em;
  height: 100px;
  background: #dedede75;
  margin-top: auto;
  margin-bottom: 63px;
  width: 100%;
  right: 0em;
  border-radius: 0px 0px 12px 12px;
}
#openButton,
#installButton {
  text-align: center;
  align-content: center;
  align-self: center;
  vertical-align: middle;
  justify-self: flex-end;
  line-height: 200%;
  flex: 0 0 auto;
  display: inline-block;
  background: #0078d4;
  color: #ffffff;
  cursor: pointer;
  border: solid 1px rgba(0, 0, 0, 0);
  outline: none;
}
#installButton {
  min-width: 130px;
  margin-right: 30px;
  background: hsl(214, 27%, 26%);
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  padding-top: 10px;
  padding-bottom: 9px;
  padding-left: 20px;
  padding-right: 20px;
  outline: none;
}
#closeButton {
  position: fixed;
  top: 5em;
  right: 18em;
  background: transparent;
  border: none;
  color: black;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 20px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  z-index: 100001;
  animation-name: scale;
  animation-duration: 450ms;
}
#contentContainer {
  margin-left: 40px;
  margin-right: 40px;
}
#contentContainer h3 {
  font-size: 22px;
  color: #3c3c3c;
  margin-bottom: 12px;
}
#contentContainer p {
  font-size: 14px;
  color: #3c3c3c;
}
#featuresScreenDiv {
  display: flex;
  justify-content: space-between;
  margin-right: 20px;
}
#featuresScreenDiv h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 225%;
  margin-top: 0px;
}
#keyFeatures {
  max-height: 220px;
  overflow: hidden;
}
#keyFeatures ul {
  padding-inline-start: 22px;
  margin-block-start: 12px;
}
#featuresScreenDiv #keyFeatures li {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 29px;
  color: rgba(51, 51, 51, 0.72);
}
#screenshots {
  display: flex;
  justify-content: flex-end;
}
#screenshots img {
  height: 200px;
  margin-right: 12px;
}
#tagsDiv {
  margin-top: 1em;
  margin-bottom: 1em;
}
#desc {
  width: 40em;
  font-size: 14px;
  color: #7e7e7e;
  text-overflow: ellipsis;
  overflow: hidden;
}
infinite-carousel-wc {
  background: #f0f0f0;
  padding-top: 14px;
  padding-bottom: 14px;
  border-radius: 22px;
  max-width: 27em;
  min-height: 180px;
}
infinite-carousel-wc > div {
  display: flex;
  justify-content: center;
  align-items: center;
}
infinite-carousel-wc > div > img {
  max-width: 20em;
  object-fit: contain;
}
#tagsDiv span {
  background: grey;
  color: white;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 4px;
  font-weight: bold;
  border-radius: 24px;
  margin-right: 12px;
  padding-top: 1px;
}
@media (min-width: 1445px) {
  #installModal {
    left: 22em;
    right: 22em;
  }
  #closeButton {
    right: 28em;
  }
}
@media (min-width: 1800px) {
  #installModal {
    left: 26em;
    right: 26em;
  }
  #closeButton {
    right: 32em;
  }
}
@media (min-width: 2000px) {
  #installModal {
    left: 38em;
    right: 38em;
  }
  #closeButton {
    right: 47em;
  }
}
@media (max-width: 1200px) {
  #installModal {
    bottom: 0em;
    top: 0em;
    left: 0em;
    right: 0em;
    border-radius: 0px;
    animation-name: mobile;
    animation-duration: 250ms;
  }
  #closeButton {
    top: 20px;
    right: 20px;
  }
  #screenshots {
    justify-content: center;
  }
}
@media (max-width: 962px) {
  #desc {
    display: none;
  }
  #headerContainer {
    margin-bottom: 24px;
  }
  #headerContainer img {
    height: 42px;
    width: 42px;
  }
}
@media (max-width: 800px) {
  #background {
    display: none;
  }
  #installModal {
    overflow: scroll;
    box-shadow: none;
  }
  infinite-carousel-wc {
    width: 100%;
  }
  #screenshotsContainer {
    width: 100%;
  }
  #screenshots img {
    height: 180px;
  }
  #buttonsContainer {
    display: flex;
    justify-content: center;
    bottom: 0;
    margin-bottom: 0;
    border-radius: 0;
    padding-top: 1em;
    padding-bottom: 1em;
  }
  #buttonsContainer #installButton {
    margin-right: 0px;
  }
  #featuresScreenDiv {
    flex-direction: column;
    align-items: flex-start;
    margin-right: 0px;
  }
  #headerContainer {
    margin: 20px;
  }
  #desc {
    display: none;
  }
  #contentContainer {
    margin-left: 20px;
    margin-right: 20px;
  }
  #headerContainer img {
    height: 60px;
    width: 60px;
    margin-right: 12px;
  }
}
`;

});

parcelRegister("dHfiX", function(module, exports) {
"use strict";
var $9f8b29be9cde4f36$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GlobalMenuService = void 0;

var $1t8Wn = parcelRequire("1t8Wn");
parcelRequire("bvKF0");

var $f16OP = parcelRequire("f16OP");
let $9f8b29be9cde4f36$var$GlobalMenuService = class GlobalMenuService {
    constructor(){
        this.menuOpened = new $f16OP.Subject();
    }
    open(template) {
        if (this.element) this.close();
        this.element = document.createElement('global-menu');
        this.element.open(template);
        document.body.appendChild(this.element);
    }
    close() {
        this.element.cancel();
        this.element.remove();
    }
    getOpenSubject() {
        return this.menuOpened.asObservable();
    }
    setOpenSubject(opened) {
        this.menuOpened.next(opened);
    }
};
$9f8b29be9cde4f36$var$GlobalMenuService = $9f8b29be9cde4f36$var$__decorate([
    (0, $1t8Wn.Injectable)()
], $9f8b29be9cde4f36$var$GlobalMenuService);
module.exports.GlobalMenuService = $9f8b29be9cde4f36$var$GlobalMenuService;

});




parcelRegister("fzOpg", function(module, exports) {

$parcel$export(module.exports, "HttpModule", () => $448ee777cb33df08$export$c7f2fd2eb2e5cdc);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $izlFR = parcelRequire("izlFR");

var $7cokz = parcelRequire("7cokz");
class $448ee777cb33df08$export$c7f2fd2eb2e5cdc {
    static forRoot(config) {
        return {
            module: $448ee777cb33df08$export$c7f2fd2eb2e5cdc,
            providers: [
                {
                    provide: (0, $7cokz.GraphqClientConfig),
                    useValue: config
                }
            ]
        };
    }
}
$448ee777cb33df08$export$c7f2fd2eb2e5cdc = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Module)({
        providers: [
            (0, $izlFR.HttpClient)
        ]
    })
], $448ee777cb33df08$export$c7f2fd2eb2e5cdc);

});

parcelRegister("iQhj9", function(module, exports) {

$parcel$export(module.exports, "LambdaService", () => $d9e14de53278a7a5$export$c4086c54dc0aa774);

var $deWeK = parcelRequire("deWeK");

var $7X6iT = parcelRequire("7X6iT");

var $6LnE2 = parcelRequire("6LnE2");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $gawXH = parcelRequire("gawXH");
class $d9e14de53278a7a5$export$c4086c54dc0aa774 extends (0, $7X6iT.BaseGraphqlService) {
    createLambda(payload, options) {
        return this.mutate({
            mutation: 'create-lambda.graphql',
            variables: {
                payload: payload,
                recreate: options?.recreate
            },
            update: (proxy, res)=>{
                const query = (0, $2O1GU.importQuery)('list-project-lambdas.graphql');
                const variables = {
                    projectId: payload.projectId
                };
                const data = (0, $2O1GU.deepCopy)(proxy.readQuery({
                    query: query,
                    variables: variables
                }));
                if (data) proxy.writeQuery({
                    data: {
                        listProjectLambdas: [
                            ...data.listProjectLambdas,
                            res.data.createLambda
                        ]
                    },
                    query: query,
                    variables: variables
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createLambda));
    }
    openLambda(lambdaId) {
        return this.mutate({
            mutation: 'open-lambda.graphql',
            errorPolicy: 'ignore',
            variables: {
                lambdaId: lambdaId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.openLambda));
    }
    closeLambda(lambdaId) {
        return this.mutate({
            mutation: 'close-lambda.graphql',
            errorPolicy: 'ignore',
            variables: {
                lambdaId: lambdaId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.closeLambda));
    }
    lambdaSubscription(lambdaId) {
        return this.subscribe({
            query: 'lambda.subscription.graphql',
            variables: {
                lambdaId: lambdaId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.lambdaSubscription));
    }
    deleteLambda(payload) {
        return this.mutate({
            mutation: 'delete-lambda.graphql',
            variables: {
                payload: payload
            },
            update: (proxy, { data: { deleteLambda: deleteLambda } })=>{
                const query = (0, $2O1GU.importQuery)('list-project-lambdas.graphql');
                const variables = {
                    projectId: payload.projectId
                };
                const data = (0, $2O1GU.deepCopy)(proxy.readQuery({
                    query: query,
                    variables: variables
                }));
                if (data) proxy.writeQuery({
                    data: {
                        listProjectLambdas: data.listProjectLambdas.filter((lambda)=>lambda.id !== deleteLambda.id)
                    },
                    query: query,
                    variables: variables
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteLambda));
    }
    updateLambda(payload) {
        delete payload.scaleOptions['__typename'];
        return this.mutate({
            mutation: 'update-lambda.graphql',
            variables: {
                payload: payload
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.updateLambda));
    }
    createTimeTrigger(payload) {
        return this.mutate({
            mutation: 'create-lambda-time-trigger.graphql',
            variables: {
                payload: payload
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createLambdaTimeTrigger));
    }
    deleteTimeTrigger(lambdaId) {
        return this.mutate({
            mutation: 'delete-lambda-time-trigger.graphql',
            variables: {
                lambdaId: lambdaId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteLambdaTimeTrigger));
    }
    listProjectTimeTriggers(projectId) {
        return this.query({
            query: 'list-project-time-triggers.graphql',
            fetchPolicy: 'network-only',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.listProjectTimeTriggers));
    }
    listProjectLambdas(projectId, refresh) {
        return this.watchQuery({
            query: 'list-project-lambdas.graphql',
            fetchPolicy: refresh ? 'network-only' : 'cache-first',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.listProjectLambdas));
    }
    getLambda(lambdaId, refresh) {
        return this.query({
            query: 'get-lambda.graphql',
            fetchPolicy: refresh ? 'network-only' : 'cache-first',
            errorPolicy: 'ignore',
            variables: {
                lambdaId: lambdaId
            }
        }).pipe((0, $gawXH.map)((res)=>({
                getLambdaEditors: res.data.getLambdaEditors,
                getLambda: res.data.getLambda
            })));
    }
    getLambdaLogs(lambdaId) {
        return this.query({
            query: 'get-lambda-logs.graphql',
            fetchPolicy: 'network-only',
            variables: {
                lambdaId: lambdaId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getLambdaLogs), (0, $gawXH.map)((logs)=>{
            return {
                ...logs,
                data: (0, $6LnE2.LZWService).decompress(logs.data)
            };
        }));
    }
    getLambdaBuilderLogs(lambdaId) {
        return this.query({
            query: 'get-builder-logs.graphql',
            fetchPolicy: 'network-only',
            variables: {
                lambdaId: lambdaId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getLambdaBuilderLogs), (0, $gawXH.map)((logs)=>{
            return {
                ...logs,
                data: (0, $6LnE2.LZWService).decompress(logs.data)
            };
        }));
    }
    deleteEnvironment(id, projectId, force) {
        return this.mutate({
            mutation: 'delete-environment.graphql',
            variables: {
                id: id,
                projectId: projectId,
                force: force
            },
            update (proxy, { data: { deleteEnvironment: deleteEnvironment } }) {
                const query = (0, $2O1GU.importQuery)('list-project-environments.graphql');
                const data = proxy.readQuery({
                    query: query,
                    variables: {
                        projectId: projectId
                    }
                });
                proxy.writeQuery({
                    query: query,
                    variables: {
                        projectId: projectId
                    },
                    data: {
                        listEnvironmentsByProjectId: data.listEnvironmentsByProjectId.filter((env)=>env.id !== deleteEnvironment.id)
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteEnvironment));
    }
    deleteAllEnvironments(projectId) {
        return this.mutate({
            mutation: 'delete-all-environment.graphql',
            variables: {
                projectId: projectId
            },
            update (proxy) {
                const query = (0, $2O1GU.importQuery)('list-project-environments.graphql');
                proxy.writeQuery({
                    query: query,
                    variables: {
                        projectId: projectId
                    },
                    data: {
                        listEnvironmentsByProjectId: []
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteEnvironment));
    }
    createEnvironment(projectId, payload) {
        return this.mutate({
            mutation: 'create-environment.graphql',
            variables: {
                projectId: projectId,
                payload: payload
            },
            update (proxy, { data: { createEnvironment: createEnvironment } }) {
                const query = (0, $2O1GU.importQuery)('list-project-environments.graphql');
                const data = proxy.readQuery({
                    query: query,
                    variables: {
                        projectId: projectId
                    }
                });
                proxy.writeQuery({
                    query: query,
                    variables: {
                        projectId: projectId
                    },
                    data: {
                        listEnvironmentsByProjectId: [
                            ...data.listEnvironmentsByProjectId,
                            createEnvironment
                        ]
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createEnvironment));
    }
    updateEnvironment(id, projectId, payload) {
        return this.mutate({
            mutation: 'update-environment.graphql',
            variables: {
                id: id,
                projectId: projectId,
                payload: payload
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.updateEnvironment));
    }
    listEnvironmentsByProjectId(projectId) {
        return this.query({
            query: 'list-project-environments.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.listEnvironmentsByProjectId));
    }
    installRabbitMq(projectId, payload) {
        return this.mutate({
            mutation: 'install-rabbitmq.graphql',
            variables: {
                projectId: projectId,
                payload: payload
            },
            update: (proxy, { data: { installRabbitMq: installRabbitMq } })=>{
                const query = (0, $2O1GU.importQuery)('get-project.query.graphql');
                const rabbitMqListQuery = (0, $2O1GU.importQuery)('list-rabbitmq-instances.graphql');
                const rabbitMq = proxy.readQuery({
                    query: rabbitMqListQuery,
                    variables: {
                        projectId: projectId
                    }
                });
                const data = proxy.readQuery({
                    query: query,
                    variables: {
                        id: projectId
                    }
                });
                proxy.writeQuery({
                    query: query,
                    variables: {
                        id: projectId
                    },
                    data: {
                        ...data,
                        getProject: {
                            ...data.getProject,
                            rabbitMqCreated: true
                        }
                    }
                });
                proxy.writeQuery({
                    query: rabbitMqListQuery,
                    variables: {
                        projectId: projectId
                    },
                    data: {
                        ...data,
                        listRabbitMqInstances: [
                            ...rabbitMq.listRabbitMqInstances,
                            installRabbitMq
                        ]
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.installRabbitMq));
    }
    uninstallRabbitMq(id, projectId) {
        return this.mutate({
            mutation: 'remove-rabbitmq.graphql',
            variables: {
                id: id,
                projectId: projectId
            },
            update: (proxy, { data: { uninstallRabbitMq: uninstallRabbitMq } })=>{
                const query = (0, $2O1GU.importQuery)('get-project.query.graphql');
                const rabbitMqListQuery = (0, $2O1GU.importQuery)('list-rabbitmq-instances.graphql');
                const rabbitMq = proxy.readQuery({
                    query: rabbitMqListQuery,
                    variables: {
                        projectId: projectId
                    }
                });
                const data = proxy.readQuery({
                    query: query,
                    variables: {
                        id: projectId
                    }
                });
                proxy.writeQuery({
                    query: query,
                    variables: {
                        id: projectId
                    },
                    data: {
                        ...data,
                        getProject: {
                            ...data.getProject,
                            rabbitMqCreated: false
                        }
                    }
                });
                proxy.writeQuery({
                    query: rabbitMqListQuery,
                    variables: {
                        projectId: projectId
                    },
                    data: {
                        ...data,
                        listRabbitMqInstances: rabbitMq.listRabbitMqInstances.filter((v)=>v.id !== uninstallRabbitMq.id)
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.uninstallRabbitMq));
    }
    declareQueue(id, projectId, payload) {
        return this.mutate({
            mutation: 'declare-queue.graphql',
            variables: {
                id: id,
                projectId: projectId,
                payload: payload
            },
            update: (proxy, { data: { declareQueue: declareQueue } })=>{
                const query = (0, $2O1GU.importQuery)('list-rabbitmq-queues.graphql');
                const queryInstances = (0, $2O1GU.importQuery)('list-rabbitmq-instances.graphql');
                const data = proxy.readQuery({
                    query: query,
                    variables: {
                        id: id,
                        projectId: projectId
                    }
                });
                const state = proxy.readQuery({
                    query: queryInstances,
                    variables: {
                        id: id,
                        projectId: projectId
                    }
                });
                if (state?.listRabbitMqInstances) {
                    const currentRabbitMqInstance = state?.listRabbitMqInstances?.find((i)=>i.id === declareQueue.rabbitMqId);
                    proxy.writeQuery({
                        query: queryInstances,
                        variables: {
                            id: id,
                            projectId: projectId
                        },
                        data: {
                            listRabbitMqInstances: [
                                ...state.listRabbitMqInstances?.filter((v)=>v.id !== declareQueue.rabbitMqId),
                                {
                                    ...currentRabbitMqInstance,
                                    queues: [
                                        ...currentRabbitMqInstance.queues,
                                        declareQueue
                                    ]
                                }
                            ]
                        }
                    });
                }
                if (data?.listQueuesPerProject) proxy.writeQuery({
                    query: query,
                    variables: {
                        id: id,
                        projectId: projectId
                    },
                    data: {
                        listQueuesPerProject: [
                            ...data.listQueuesPerProject,
                            declareQueue
                        ]
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.declareQueue));
    }
    deleteQueue(id, projectId, queueName) {
        return this.mutate({
            mutation: 'delete-queue.graphql',
            variables: {
                id: id,
                projectId: projectId,
                queueName: queueName
            },
            update: (proxy, { data: { deleteQueue: deleteQueue } })=>{
                const query = (0, $2O1GU.importQuery)('list-rabbitmq-queues.graphql');
                const data = proxy.readQuery({
                    query: query,
                    variables: {
                        id: id,
                        projectId: projectId
                    }
                });
                proxy.writeQuery({
                    query: query,
                    variables: {
                        id: id,
                        projectId: projectId
                    },
                    data: {
                        listQueuesPerProject: data?.listQueuesPerProject?.filter((v)=>v.name !== deleteQueue.name) ?? []
                    }
                });
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.declareQueue));
    }
    findRabbitMqInstance(id, projectId) {
        return this.query({
            query: 'find-rabbitmq-instance.graphql',
            variables: {
                id: id,
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.findRabbitMqInstance));
    }
    listRabbitMqInstances(projectId) {
        return this.watchQuery({
            query: 'list-rabbitmq-instances.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.listRabbitMqInstances));
    }
    listQueuesPerProject(projectId, id) {
        return this.query({
            query: 'list-rabbitmq-queues.graphql',
            variables: {
                id: id,
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.listQueuesPerProject));
    }
    listMessageQueueTriggers(projectId) {
        return this.query({
            query: 'list-message-queue-triggers.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.listMessageQueueTriggers));
    }
    createMessageQueueTrigger(projectId, payload) {
        return this.mutate({
            mutation: 'create-message-queue-trigger.graphql',
            variables: {
                projectId: projectId,
                payload: payload
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createMessageQueueTrigger));
    }
    updateMessageQueueTrigger(projectId, payload) {
        return this.mutate({
            mutation: 'update-message-queue-trigger.graphql',
            variables: {
                projectId: projectId,
                payload: payload
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.updateMessageQueueTrigger));
    }
    deleteMessageQueueTrigger(projectId, name) {
        return this.mutate({
            mutation: 'delete-message-queue-trigger.graphql',
            variables: {
                projectId: projectId,
                name: name
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteMessageQueueTrigger));
    }
    getLimitRange(projectId) {
        return this.query({
            query: 'get-limit-range.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getLimitRange));
    }
    getResourceQuota(projectId) {
        return this.query({
            query: 'get-resource-quota.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getResourceQuota));
    }
    getPodsCapacityPerNamespace(projectId) {
        return this.query({
            query: 'get-pod-capacity.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.getPodsCapacityPerNamespace));
    }
    getAllMetrics(projectId, fetchPolicy) {
        return this.query({
            query: 'metrics-all.graphql',
            errorPolicy: 'ignore',
            fetchPolicy: fetchPolicy,
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>({
                podsCapacity: data.getPodsCapacityPerNamespace,
                resourceQuota: data.getResourceQuota,
                limitRange: data.getLimitRange,
                environments: data.listEnvironmentsByProjectId,
                projectStatistics: data.getProjectStatistics,
                listProjectLambdas: data.listProjectLambdas,
                listProjectTimeTriggers: data.listProjectTimeTriggers,
                listQueuesPerProject: data.listQueuesPerProject,
                getPersistentVolumes: data.getPersistentVolumes,
                getFunctionStatistics: data.getFunctionStatistics,
                listMessageQueueTriggers: data.listMessageQueueTriggers,
                getAccumulatedPricing: data.getAccumulatedPricing
            })));
    }
    getAccumulatedPricingPod(projectId, fetchPolicy) {
        return this.query({
            query: 'pricing-per-pod.graphql',
            fetchPolicy: fetchPolicy,
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.getAccumulatedPricing));
    }
    connectAtlasMongo(projectId, payload) {
        return this.mutate({
            mutation: 'connect-mongo-atlas.graphql',
            variables: {
                projectId: projectId,
                payload: payload
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.connectAtlasMongo));
    }
    updateAtlasMongo(id, projectId, allowedIps) {
        return this.mutate({
            mutation: 'update-mongo-atlas.graphql',
            variables: {
                id: id,
                projectId: projectId,
                allowedIps: allowedIps
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.connectAtlasMongo));
    }
    disconnectAtlasMongo(id, projectId) {
        return this.mutate({
            mutation: 'disconnect-mongo-atlas.graphql',
            variables: {
                id: id,
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.disconnectAtlasMongo));
    }
    listAtlasConnectors(projectId) {
        return this.query({
            query: 'list-atlas-connectors.graphql',
            variables: {
                projectId: projectId
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>({
                listAtlasConnectors: data.listAtlasConnectors,
                form: data.getFormByName
            })));
    }
}
$d9e14de53278a7a5$export$c4086c54dc0aa774 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $d9e14de53278a7a5$export$c4086c54dc0aa774);

});

parcelRegister("aW6Ya", function(module, exports) {

$parcel$export(module.exports, "ModalProvider", () => $100bf681d67ebeb5$export$178405afcd8c5eb);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $ihXbv = parcelRequire("ihXbv");

var $d5Aat = parcelRequire("d5Aat");

var $wpqO8 = parcelRequire("wpqO8");
class $100bf681d67ebeb5$export$178405afcd8c5eb {
    open(template, dialogOptions = (0, $wpqO8.options)) {
        return this.modalService.open(template, dialogOptions);
    }
    openComponent(component, params = null, dialogOptions = (0, $wpqO8.options)) {
        return this.modalService.openComponent(component, params, dialogOptions);
    }
    openCustomModal(data, dialogOptions) {
        return this.modalService.openCustomModal(data, dialogOptions);
    }
    openConfirmDialog(data) {
        return this.modalService.openCustomModal(data, {
            backdropClose: false
        }).pipe((0, $d5Aat.take)(1));
    }
    close(res) {
        this.modalService.close(res);
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $ihXbv.ModalService))
], $100bf681d67ebeb5$export$178405afcd8c5eb.prototype, "modalService", void 0);
$100bf681d67ebeb5$export$178405afcd8c5eb = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $100bf681d67ebeb5$export$178405afcd8c5eb);

});
parcelRegister("wpqO8", function(module, exports) {

$parcel$export(module.exports, "options", () => $daa81947bcc879c8$export$41c562ebe57d11e2);

var $4TeKW = parcelRequire("4TeKW");
const $daa81947bcc879c8$export$41c562ebe57d11e2 = {
    backdropClose: true,
    style: (0, $4TeKW.css)`
    .wrapper {
      position: absolute;
      top: 0;
      left: 0;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      width: 100%;
      height: 100%;
      z-index: 1000;
    }

    @keyframes scale {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    @keyframes blur {
      to {
        backdrop-filter: blur(5px);
      }
    }

    .backdrop {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: absolute;
      pointer-events: all;
      z-index: 10;
      animation: blur 0.3s linear forwards;
    }

    .content {
      z-index: 20;
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: all;
      animation-name: scale;
      animation-duration: 300ms;
    }
  `
};

});


parcelRegister("7vJSu", function(module, exports) {

$parcel$export(module.exports, "NavMenuProvider", () => $98dcffd7f5075bdd$export$c58787d58751a419);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $89nwV = parcelRequire("89nwV");
class $98dcffd7f5075bdd$export$c58787d58751a419 {
    getSubject() {
        return this.nav.getOpenSubject();
    }
    openNavigation() {
        this.nav.open({
            navOptions: {
                left: 0,
                delay: 0
            },
            template: (0, $4TeKW.html)`
        <div>
          <p>daadad</p>
        </div>
      `,
            styles: (0, $4TeKW.css)`
        p {
          color: black;
        }
        :host {
          position: fixed;
          top: 0;
          transition: left 0.3s ease-out;
          bottom: 0;
          left: -250px;
          box-sizing: border-box;
          min-width: 250px;
          background: #fff;
          overflow-y: auto;
        }
      `
        });
    }
    closeNavigation() {
        this.nav.close({
            delay: 300,
            left: -250
        });
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $89nwV.Nav))
], $98dcffd7f5075bdd$export$c58787d58751a419.prototype, "nav", void 0);
$98dcffd7f5075bdd$export$c58787d58751a419 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $98dcffd7f5075bdd$export$c58787d58751a419);

});
parcelRegister("89nwV", function(module, exports) {
"use strict";
var $5ef16a94c8a432b2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5ef16a94c8a432b2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5ef16a94c8a432b2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5ef16a94c8a432b2$var$__createBinding(exports1, m, p);
};
var $5ef16a94c8a432b2$var$NavModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NavModule = void 0;

var $1t8Wn = parcelRequire("1t8Wn");


let $5ef16a94c8a432b2$var$NavModule = $5ef16a94c8a432b2$var$NavModule_1 = class NavModule {
    static forRoot() {
        return {
            module: $5ef16a94c8a432b2$var$NavModule_1,
            providers: [
                (parcelRequire("3L072")).Nav
            ],
            components: [
                (parcelRequire("kfrxA")).NavComponent
            ]
        };
    }
};
$5ef16a94c8a432b2$var$NavModule = $5ef16a94c8a432b2$var$NavModule_1 = $5ef16a94c8a432b2$var$__decorate([
    (0, $1t8Wn.Module)()
], $5ef16a94c8a432b2$var$NavModule);
module.exports.NavModule = $5ef16a94c8a432b2$var$NavModule;

$5ef16a94c8a432b2$var$__exportStar((parcelRequire("kfrxA")), module.exports);

$5ef16a94c8a432b2$var$__exportStar((parcelRequire("3L072")), module.exports);

});
parcelRegister("3L072", function(module, exports) {
"use strict";
var $2bc5d939519239b4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Nav = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
var $h7YIO = parcelRequire("h7YIO");

var $29pK2 = parcelRequire("29pK2");
var $d5Aat = parcelRequire("d5Aat");

var $4TeKW = parcelRequire("4TeKW");
let $2bc5d939519239b4$var$Nav = class Nav {
    constructor(){
        this.openSubject = new $bq6Hs.BehaviorSubject({
            left: -270
        });
        this.template = new $h7YIO.ReplaySubject();
        this.stylesSubject = new $bq6Hs.BehaviorSubject((0, $4TeKW.css)`
    :host {
      position: absolute;
      top: 0;
      transition: left 0.3s ease-out;
      bottom: 0;
      left: -270px;
      box-sizing: border-box;
      min-width: 270px;
      background: #fff;
      overflow-y: auto;
    }
  `);
    }
    getOpenSubject() {
        return this.openSubject.asObservable();
    }
    getTemplateSubject() {
        return this.template.asObservable();
    }
    getStylesSubject() {
        return this.stylesSubject.asObservable();
    }
    setStylesSubject(style) {
        this.stylesSubject.next(style);
    }
    open(options = {
        navOptions: {
            left: 0,
            delay: 20
        }
    }) {
        this.removeRef();
        this.createRef();
        this.attachRef(options.ref);
        if (options.styles) this.stylesSubject.next(options.styles);
        this.template.next(options.template || (0, $4TeKW.html)``);
        this.openSubject.next(options.navOptions);
    }
    getNavRef() {
        return this.navRef;
    }
    close(options = {
        left: -270,
        delay: 300
    }) {
        this.openSubject.pipe((0, $d5Aat.take)(1), (0, $29pK2.delay)(options.delay)).subscribe(()=>this.removeRef());
        this.openSubject.next(options);
    }
    removeRef() {
        if (this.navRef) {
            this.navRef.remove();
            this.navRef = null;
        }
    }
    createRef() {
        this.navRef = document.createElement('rx-nav');
    }
    attachRef(ref) {
        if (ref) return ref.appendChild(this.navRef);
        return document.body.appendChild(this.navRef);
    }
};
$2bc5d939519239b4$var$Nav = $2bc5d939519239b4$var$__decorate([
    (0, $1t8Wn.Injectable)({
        init: true
    })
], $2bc5d939519239b4$var$Nav);
module.exports.Nav = $2bc5d939519239b4$var$Nav;

});

parcelRegister("kfrxA", function(module, exports) {
"use strict";
var $ebda926362170a38$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ebda926362170a38$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NavComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $1t8Wn = parcelRequire("1t8Wn");

var $3L072 = parcelRequire("3L072");

var $29pK2 = parcelRequire("29pK2");
var $gawXH = parcelRequire("gawXH");
var $gD6ig = parcelRequire("gD6ig");
var $3dOhR = parcelRequire("3dOhR");

var $g5fNy = parcelRequire("g5fNy");
let $ebda926362170a38$var$NavComponent = class NavComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.defaultDelay = 30;
    }
    OnInit() {
        this.styles = this.nav.getStylesSubject();
        this.template = this.nav.getTemplateSubject();
        this.openSubject = this.nav.getOpenSubject().pipe((0, $gD6ig.mergeMap)((i)=>(0, $g5fNy.of)(i).pipe((0, $29pK2.delay)(this.initDelaySet ? this.defaultDelay : i.delay || this.defaultDelay), (0, $3dOhR.tap)(()=>this.initDelaySet = true))), (0, $gawXH.map)((options)=>(0, $4TeKW.html)`
          <style>
            :host {
              left: ${options.left}px;
            }
          </style>
        `));
    }
    close() {
        this.nav.close();
    }
};
$ebda926362170a38$var$__decorate([
    (0, $1t8Wn.Inject)($3L072.Nav),
    $ebda926362170a38$var$__metadata("design:type", $3L072.Nav)
], $ebda926362170a38$var$NavComponent.prototype, "nav", void 0);
$ebda926362170a38$var$NavComponent = $ebda926362170a38$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-nav',
        template () {
            return (0, $4TeKW.html)`
      <style>
          :host {
          z-index: 1000;
        }
          ${(0, $4TeKW.async)(this.styles)}
      </style>
      ${(0, $4TeKW.async)(this.openSubject)} ${(0, $4TeKW.async)(this.template)}
    `;
        }
    })
], $ebda926362170a38$var$NavComponent);
module.exports.NavComponent = $ebda926362170a38$var$NavComponent;

});



parcelRegister("fG5CU", function(module, exports) {

$parcel$export(module.exports, "NavbarItemsProvider", () => $99bb6bb6f1db172c$export$b2f1fd8612f74d9a);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
class $99bb6bb6f1db172c$export$b2f1fd8612f74d9a {
    getMenus() {
        return this.$menus.asObservable();
    }
    setMenus(menus) {
        this.$menus.next(menus);
    }
    constructor(){
        this.$menus = new (0, $bq6Hs.BehaviorSubject)([]);
    }
}
$99bb6bb6f1db172c$export$b2f1fd8612f74d9a = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $99bb6bb6f1db172c$export$b2f1fd8612f74d9a);

});

parcelRegister("ikIwA", function(module, exports) {

$parcel$export(module.exports, "NotificationsService", () => $2e1eacf145837d2d$export$cc9c9ff0007bc3f8);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $cDzby = parcelRequire("cDzby");

var $bq6Hs = parcelRequire("bq6Hs");
var $5JMLH = parcelRequire("5JMLH");

var $29pK2 = parcelRequire("29pK2");
var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");
var $lNnaw = parcelRequire("lNnaw");
var $3dOhR = parcelRequire("3dOhR");

var $2nhTq = parcelRequire("2nhTq");

var $7X6iT = parcelRequire("7X6iT");
class $2e1eacf145837d2d$export$cc9c9ff0007bc3f8 extends (0, $7X6iT.BaseGraphqlService) {
    OnInit() {
        this.subscription = this.socialService.checkLoggedIn().pipe((0, $6Rz6W.filter)((i)=>!!i), (0, $29pK2.delay)(500), (0, $lNnaw.switchMap)(()=>this.getNotifications()), (0, $3dOhR.tap)((notifications)=>{
            this.count = notifications.count;
            this.list.next((0, $2O1GU.deepCopy)(notifications.data));
        }), (0, $lNnaw.switchMap)(()=>this.listenForNotifications().pipe((0, $3dOhR.tap)((res)=>{
                (0, $2nhTq.info)('Notification received', 'Project', {
                    positionClass: 'toast-bottom-left'
                });
                this.list.next([
                    ...this.list.getValue(),
                    res.data.notifications
                ]);
            })))).subscribe();
    }
    unsubscribe() {
        if (this.subscription) this.subscription.unsubscribe();
    }
    subscribeToNotifications() {
        return this.list.asObservable();
    }
    listenForNotifications() {
        return (0, $5JMLH.from)(this.subscribe({
            query: 'listen-for-notifications.graphql'
        }));
    }
    getPagesCount() {
        return this.count;
    }
    getInvitesCount() {
        return this.invitesCount;
    }
    getNotifications(limit = 1000, offset = 0) {
        return (0, $5JMLH.from)(this.query({
            query: 'get-notifications.type.graphql',
            variables: {
                sort: 'ASC',
                limit: limit,
                offset: offset
            }
        })).pipe((0, $gawXH.map)((res)=>res.data.getNotifications));
    }
    readNotification(id) {
        return (0, $5JMLH.from)(this.mutate({
            mutation: 'read-notification.graphql',
            variables: {
                id: id
            }
        })).pipe((0, $gawXH.map)(({ data: data })=>data.readNotification), (0, $3dOhR.tap)(()=>{
            const notifications = this.list.getValue();
            const notification = notifications.find((n)=>n.id === id);
            notification.read = true;
            this.list.next(notifications);
        }));
    }
    constructor(...args){
        super(...args), this.list = new (0, $bq6Hs.BehaviorSubject)([]);
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Injector)((0, $2O1GU.ApolloClient))
], $2e1eacf145837d2d$export$cc9c9ff0007bc3f8.prototype, "graphql", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $2e1eacf145837d2d$export$cc9c9ff0007bc3f8.prototype, "socialService", void 0);
$2e1eacf145837d2d$export$cc9c9ff0007bc3f8 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $2e1eacf145837d2d$export$cc9c9ff0007bc3f8);

});
parcelRegister("2nhTq", function(module, exports) {

/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */ /* global define */ (function(define1) {
    define1([
        'jquery'
    ], function($) {
        return function() {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };
            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.4',
                warning: warning
            };
            var previousToast;
            return toastr;
            ////////////////
            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }
            function getContainer(options, create) {
                if (!options) options = getOptions();
                $container = $('#' + options.containerId);
                if ($container.length) return $container;
                if (create) $container = createContainer(options);
                return $container;
            }
            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }
            function subscribe(callback) {
                listener = callback;
            }
            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }
            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }
            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) getContainer(options);
                if (!clearToast($toastElement, options, clearOptions)) clearContainer(options);
            }
            function remove($toastElement) {
                var options = getOptions();
                if (!$container) getContainer(options);
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) $container.remove();
            }
            // internal functions
            function clearContainer(options) {
                var toastsToClear = $container.children();
                for(var i = toastsToClear.length - 1; i >= 0; i--)clearToast($(toastsToClear[i]), options);
            }
            function clearToast($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function() {
                            removeToast($toastElement);
                        }
                    });
                    return true;
                }
                return false;
            }
            function createContainer(options) {
                $container = $('<div/>').attr('id', options.containerId).addClass(options.positionClass);
                $container.appendTo($(options.target));
                return $container;
            }
            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,
                    showMethod: 'fadeIn',
                    showDuration: 300,
                    showEasing: 'swing',
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,
                    closeOnHover: true,
                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000,
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    closeClass: 'toast-close-button',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false,
                    progressClass: 'toast-progress',
                    rtl: false
                };
            }
            function publish(args) {
                if (!listener) return;
                listener(args);
            }
            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;
                if (typeof map.optionsOverride !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }
                if (shouldExit(options, map)) return;
                toastId++;
                $container = getContainer(options, true);
                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };
                personalizeToast();
                displayToast();
                handleEvents();
                publish(response);
                if (options.debug && console) console.log(response);
                return $toastElement;
                function escapeHtml(source) {
                    if (source == null) source = '';
                    return source.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                }
                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setRTL();
                    setSequence();
                    setAria();
                }
                function setAria() {
                    var ariaValue = '';
                    switch(map.iconClass){
                        case 'toast-success':
                        case 'toast-info':
                            ariaValue = 'polite';
                            break;
                        default:
                            ariaValue = 'assertive';
                    }
                    $toastElement.attr('aria-live', ariaValue);
                }
                function handleEvents() {
                    if (options.closeOnHover) $toastElement.hover(stickAround, delayedHideToast);
                    if (!options.onclick && options.tapToDismiss) $toastElement.click(hideToast);
                    if (options.closeButton && $closeElement) $closeElement.click(function(event) {
                        if (event.stopPropagation) event.stopPropagation();
                        else if (event.cancelBubble !== undefined && event.cancelBubble !== true) event.cancelBubble = true;
                        if (options.onCloseClick) options.onCloseClick(event);
                        hideToast(true);
                    });
                    if (options.onclick) $toastElement.click(function(event) {
                        options.onclick(event);
                        hideToast();
                    });
                }
                function displayToast() {
                    $toastElement.hide();
                    $toastElement[options.showMethod]({
                        duration: options.showDuration,
                        easing: options.showEasing,
                        complete: options.onShown
                    });
                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) progressBar.intervalId = setInterval(updateProgress, 10);
                    }
                }
                function setIcon() {
                    if (map.iconClass) $toastElement.addClass(options.toastClass).addClass(iconClass);
                }
                function setSequence() {
                    if (options.newestOnTop) $container.prepend($toastElement);
                    else $container.append($toastElement);
                }
                function setTitle() {
                    if (map.title) {
                        var suffix = map.title;
                        if (options.escapeHtml) suffix = escapeHtml(map.title);
                        $titleElement.append(suffix).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }
                function setMessage() {
                    if (map.message) {
                        var suffix = map.message;
                        if (options.escapeHtml) suffix = escapeHtml(map.message);
                        $messageElement.append(suffix).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }
                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass(options.closeClass).attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }
                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass(options.progressClass);
                        $toastElement.prepend($progressElement);
                    }
                }
                function setRTL() {
                    if (options.rtl) $toastElement.addClass('rtl');
                }
                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) return true;
                        else previousToast = map.message;
                    }
                    return false;
                }
                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ? options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) return;
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function() {
                            removeToast($toastElement);
                            clearTimeout(intervalId);
                            if (options.onHidden && response.state !== 'hidden') options.onHidden();
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }
                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }
                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod]({
                        duration: options.showDuration,
                        easing: options.showEasing
                    });
                }
                function updateProgress() {
                    var percentage = (progressBar.hideEta - new Date().getTime()) / progressBar.maxHideTime * 100;
                    $progressElement.width(percentage + '%');
                }
            }
            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }
            function removeToast($toastElement) {
                if (!$container) $container = getContainer();
                if ($toastElement.is(':visible')) return;
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }
        }();
    });
})(typeof define === 'function' && define.amd ? define : function(deps, factory) {
    if (module.exports) module.exports = factory((parcelRequire("1wgba")));
    else window.toastr = factory(window.jQuery);
});

});
parcelRegister("1wgba", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.6.4
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-03-08T15:28Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.6.4", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
        // or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
            nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\0") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    pushNative.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            if (newContext !== context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Support: IE <=8
            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
            // https://bugs.jquery.com/ticket/4833
            return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
            // IE/Edge & older browsers don't support the :scope pseudo-class.
            // Support: Safari 6.0 only
            // Safari 6.0 supports :scope but it's an alias of :root there.
            support.scope = assert(function(el) {
                docElem.appendChild(el).appendChild(document.createElement("div"));
                return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
            });
            // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Make sure the the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    var input;
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                // Support: IE <9 only
                // IE doesn't have `contains` on `document` so we need to check for
                // `documentElement` presence.
                // We need to fall back to `a` when `documentElement` is missing
                // as `ownerDocument` of elements within `<template/>` may have
                // a null one - a default behavior of all modern browsers.
                var adown = a.nodeType === 9 && a.documentElement || a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    /* eslint-enable max-len */ };
                },
                "CHILD": function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument > length ? length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, _name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 - 11+
    // focus() and blur() are asynchronous, except when they are no-op.
    // So expect focus to be synchronous when the element is already active,
    // and blur to be synchronous when the element is not already active.
    // (focus and blur are always synchronous in other supported browsers,
    // this just defines when we can count on it).
    function expectSync(elem, type) {
        return elem === safeActiveElement() === (type === "focus");
    }
    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, expectSync) {
        // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
        if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var notAsync, result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    // Saved data should be false in such cases, but might be a leftover capture object
                    // from an async native handler (gh-4350)
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        // Support: IE <=9 - 11+
                        // focus() and blur() are asynchronous
                        notAsync = expectSync(this, type);
                        this[type]();
                        result = dataPriv.get(this, type);
                        if (saved !== result || notAsync) dataPriv.set(this, type, false);
                        else result = {};
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is blurred by
                            // clicking outside of it, it invokes the handler synchronously. If
                            // that handler calls `.remove()` on the element, the data is cleared,
                            // leaving `result` undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(// Support: IE <=9 - 11+
                        // Extend with the prototype to reset the above stopImmediatePropagation()
                        jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                    });
                    // Abort handling of the native event
                    event.stopImmediatePropagation();
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);
                // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "gridArea": true,
            "gridColumn": true,
            "gridColumnEnd": true,
            "gridColumnStart": true,
            "gridRow": true,
            "gridRowEnd": true,
            "gridRowStart": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    support.focusin = "onfocusin" in window1;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});



parcelRegister("cflMN", function(module, exports) {
$parcel$export(module.exports, "InviteNotificationTemplate", () => (parcelRequire("9mzCZ")).InviteNotificationTemplate);
$parcel$export(module.exports, "isProjectInviteNotification", () => (parcelRequire("9mzCZ")).isProjectInviteNotification);
$parcel$export(module.exports, "isProjectRemoveNotification", () => (parcelRequire("htpni")).isProjectRemoveNotification);
$parcel$export(module.exports, "isMachineStartedNotification", () => (parcelRequire("38rxE")).isMachineStartedNotification);
$parcel$export(module.exports, "MachineStartedTemplateComponent", () => (parcelRequire("38rxE")).MachineStartedTemplateComponent);
$parcel$export(module.exports, "isMachineStoppedNotification", () => (parcelRequire("185cP")).isMachineStoppedNotification);
$parcel$export(module.exports, "MachineStoppedTemplateComponent", () => (parcelRequire("185cP")).MachineStoppedTemplateComponent);
$parcel$export(module.exports, "isProjectMentionNotification", () => (parcelRequire("5xHv4")).isProjectMentionNotification);
parcelRequire("9mzCZ");
parcelRequire("htpni");
parcelRequire("38rxE");
parcelRequire("185cP");
parcelRequire("5xHv4");

});
parcelRegister("9mzCZ", function(module, exports) {

$parcel$export(module.exports, "isProjectInviteNotification", () => $990a74e68c95e9ef$export$1c4d5fba1fcfc754);
$parcel$export(module.exports, "InviteNotificationTemplate", () => $990a74e68c95e9ef$export$d7527e9b79d0b88a);
$parcel$export(module.exports, "ProjectInviteTemplateComponent", () => $990a74e68c95e9ef$export$1322d7d46bc20178);

var $deWeK = parcelRequire("deWeK");

var $iCFDc = parcelRequire("iCFDc");

var $6ppqI = parcelRequire("6ppqI");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("Zh3jt");
var $4bJcr = parcelRequire("4bJcr");
const $990a74e68c95e9ef$export$1c4d5fba1fcfc754 = (n)=>n.data.__typename === 'ProjectNotifications' && n.data.message.__typename === 'ProjectNotificationsInvite';
const $990a74e68c95e9ef$export$d7527e9b79d0b88a = (n)=>([notificationService, router])=>({
            read: n.read,
            html: (0, $4TeKW.html)`
      <div style="width: 355px">
        <project-invite-template-notifications
          @click=${()=>{
                if (!n.read) notificationService.readNotification(n.id).subscribe();
                router.go(`/projects/${n.data['projectId']}`);
            }}
          .notification=${n}
        ></project-invite-template-notifications>
      </div>
    `
        });
class $990a74e68c95e9ef$export$1322d7d46bc20178 extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $iCFDc.DateTimeProvider))
], $990a74e68c95e9ef$export$1322d7d46bc20178.prototype, "dateTimeProvider", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $990a74e68c95e9ef$export$1322d7d46bc20178.prototype, "notification", void 0);
$990a74e68c95e9ef$export$1322d7d46bc20178 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'project-invite-template-notifications',
        styles: [
            (0, $4TeKW.css)`
      .spacer {
        flex: 1 3 auto;
      }
    `
        ],
        template () {
            const data = this.notification.data;
            const message = data.message;
            return (0, $4TeKW.html)`
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 10px;">${0, $4bJcr.Invitation}</div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            <span>${(0, $6ppqI.translate)('You have being invited as member inside project')}</span>
            <a href=${`/projects/${data.projectId}`} style="color: blue">${data.projectName}</a>
            <span>${(0, $6ppqI.translate)('by')}</span>
            <a style="color: blue">${message.from.name}</a>
            <span>${(0, $6ppqI.translate)('to build awesome things')}</span>
          </div>

          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
        }
    })
], $990a74e68c95e9ef$export$1322d7d46bc20178);

});
parcelRegister("6ppqI", function(module, exports) {
$parcel$export(module.exports, "TranslationsModule", () => (parcelRequire("2EHKy")).TranslationsModule);

$parcel$export(module.exports, "TranslateModifiers", () => $e8a92e64fec45659$export$99e87bf9f08e5b97);
$parcel$export(module.exports, "translate", () => $e8a92e64fec45659$export$d73ee8ef04f5226a);

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $dm1CV = parcelRequire("dm1CV");

var $3WmLz = parcelRequire("3WmLz");

var $6kGb2 = parcelRequire("6kGb2");
parcelRequire("2EHKy");
const $e8a92e64fec45659$export$99e87bf9f08e5b97 = [
    (0, $dm1CV.Registry),
    (0, $3WmLz.TranslateModifier)
];
const $e8a92e64fec45659$export$d73ee8ef04f5226a = (v)=>(0, $4TeKW.async)((0, $1t8Wn.Container).get((0, $6kGb2.TranslateService)).get(v));
const $e8a92e64fec45659$export$625550452a3fa3ec = (v)=>(0, $1t8Wn.Container).get((0, $6kGb2.TranslateService)).get(v);
const $e8a92e64fec45659$export$a7357cdd1f0b0168 = (v)=>(0, $1t8Wn.Container).get((0, $6kGb2.TranslateService)).get(v);
const $e8a92e64fec45659$export$604ba5624273df44 = ()=>(0, $1t8Wn.Container).get((0, $6kGb2.TranslateService)).currentLanguage;
const $e8a92e64fec45659$export$dfa53f09c51fc5fd = ()=>(0, $1t8Wn.Container).get((0, $6kGb2.TranslateService));

});
parcelRegister("dm1CV", function(module, exports) {

$parcel$export(module.exports, "Registry", () => $d51dc574e873ab06$export$4d9facee29974f3);

var $deWeK = parcelRequire("deWeK");

var $5kDLo = parcelRequire("5kDLo");
class $d51dc574e873ab06$export$4d9facee29974f3 extends (0, $5kDLo.Attribute) {
}
$d51dc574e873ab06$export$4d9facee29974f3 = (0, $deWeK.__decorate)([
    (0, $5kDLo.Modifier)({
        selector: 'translate-registry',
        registry () {
            return new (0, $5kDLo.CustomAttributeRegistry)(this);
        }
    })
], $d51dc574e873ab06$export$4d9facee29974f3);

});
parcelRegister("5kDLo", function(module, exports) {
"use strict";
var $3e1daa2a9c041656$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3e1daa2a9c041656$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3e1daa2a9c041656$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3e1daa2a9c041656$var$__exportStar((parcelRequire("ln7Xa")), module.exports);

$3e1daa2a9c041656$var$__exportStar((parcelRequire("fRkR8")), module.exports);

$3e1daa2a9c041656$var$__exportStar((parcelRequire("iDCoi")), module.exports);

$3e1daa2a9c041656$var$__exportStar((parcelRequire("2CkIV")), module.exports);

$3e1daa2a9c041656$var$__exportStar((parcelRequire("lJJSL")), module.exports);

$3e1daa2a9c041656$var$__exportStar((parcelRequire("emDlX")), module.exports);

});
parcelRegister("ln7Xa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Attribute = void 0;
/*  */ class $f8f1ea4e62ffbfee$var$Attribute {
    setStyles(keys) {
        return (div)=>{
            for (const [key, value] of Object.entries(keys))div['style'][key] = value;
        };
    }
    OnInit() {
    /* */ }
    OnDestroy() {
    /* */ }
    OnUpdate(_oldValue, _newValue) {
    /* */ }
    OnUpdateAttribute(_name, _value) {
    /* */ }
    OnChange(_records) {
    /* */ }
}
module.exports.Attribute = $f8f1ea4e62ffbfee$var$Attribute;

});

parcelRegister("fRkR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomAttributeRegistry = void 0;

var $2CkIV = parcelRequire("2CkIV");
class $b8bbfbd18b043155$var$CustomAttributeRegistry {
    constructor(parent){
        this.parent = parent;
        this._attrMap = new Map();
        this._elementMap = new Map();
        if (!parent) throw new Error('Must be given a parent element');
        this.observe();
    }
    define(attrName, Constructor) {
        this._attrMap.set(attrName.toLowerCase(), Constructor);
        this.upgradeAttribute(attrName);
    }
    get(element, attrName) {
        const map = this._elementMap.get(element);
        if (!map) return;
        return map.get(attrName.toLowerCase());
    }
    getConstructor(attrName) {
        return this._attrMap.get(attrName.toLowerCase());
    }
    observe() {
        var _a, _b;
        this.observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.type === 'attributes') {
                const attr = this.getConstructor(mutation.attributeName);
                if (attr) this.found(mutation.attributeName, mutation.target, mutation.oldValue);
            } else {
                for (const node of mutation.removedNodes)this.downgrade(node);
                for (const node of mutation.addedNodes)this.upgradeElement(node);
            }
        });
        this.observer.observe((_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a['shadowRoot']) !== null && _b !== void 0 ? _b : this.parent, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeOldValue: true
        });
    }
    unsubscribe(force) {
        var _a;
        if (force) (_a = this.observer) === null || _a === void 0 || _a.disconnect();
        const values = [
            ...this._elementMap.values()
        ];
        for (const elModifiers of values){
            const modifiers = [
                ...elModifiers.values()
            ];
            for (const modifier of modifiers){
                modifier.OnDestroy();
                if (modifier.observer) modifier.observer.disconnect();
            }
            elModifiers.clear();
        }
        this._elementMap.clear();
    }
    upgradeAttribute(attrName, doc) {
        const parent = doc || this.parent;
        const matches = parent.querySelectorAll('[' + attrName + ']');
        for (const match of [
            ...matches
        ])this.found(attrName, match);
    }
    upgradeElement(element) {
        if (element.nodeType !== 1) return;
        for (const attr of element.attributes)if (this.getConstructor(attr.name)) this.found(attr.name, element);
        for (const [attr] of this._attrMap)this.upgradeAttribute(attr, element);
    }
    downgrade(element) {
        const map = this._elementMap.get(element);
        if (!map) return;
        for (const [, instance] of map)if (instance.OnDestroy) instance.OnDestroy();
        this._elementMap.delete(element);
    }
    found(attributeName, el, oldVal) {
        var _a, _b;
        let map = this._elementMap.get(el);
        if (!map) {
            map = new Map();
            this._elementMap.set(el, map);
        }
        let modifier = map.get(attributeName);
        const attribute = el.getAttribute(attributeName);
        if (!modifier) {
            const Modifier = this.getConstructor(attributeName);
            modifier = new Modifier();
            if ((_b = (_a = Modifier.options) === null || _a === void 0 ? void 0 : _a.observedAttributes) === null || _b === void 0 ? void 0 : _b.length) for (const observedAttribute of Modifier.options.observedAttributes)(0, $2CkIV.observe)(modifier, observedAttribute);
            modifier.element = el;
            modifier.selector = attributeName;
            modifier.value = attribute || modifier.value;
            modifier.parent = this.parent;
            if (modifier.OnInit) modifier.OnInit();
            if (Modifier.options.observe) {
                modifier.observer = new MutationObserver((records)=>modifier.OnChange(records));
                modifier.observer.observe(modifier.element, Modifier.options.observe);
            }
            map.set(attributeName, modifier);
            return;
        }
        if (attribute == null && !!modifier.value) {
            modifier.value = attribute;
            if (modifier.OnDestroy) modifier.OnDestroy();
            if (modifier.observer) modifier.observer.disconnect();
            map.delete(attributeName);
            return;
        }
        if (attribute !== modifier.value) {
            modifier.value = attribute;
            if (modifier.OnUpdate) modifier.OnUpdate(oldVal, attribute);
            return;
        }
    }
}
module.exports.CustomAttributeRegistry = $b8bbfbd18b043155$var$CustomAttributeRegistry;

});
parcelRegister("2CkIV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.observe = module.exports.noop = void 0;
const $1e7f34ab65be2f16$var$noop = function() {
/*  */ };
module.exports.noop = $1e7f34ab65be2f16$var$noop;
const $1e7f34ab65be2f16$var$observe = (target, memberName)=>{
    const prototype = target.constructor.prototype;
    const OnInit = prototype.OnInit || module.exports.noop;
    const OnDestroy = prototype.OnDestroy || module.exports.noop;
    const OnUpdateAttribute = prototype.OnUpdateAttribute || module.exports.noop;
    let observer;
    prototype.OnInit = function() {
        var _a;
        const element = (_a = this.element) !== null && _a !== void 0 ? _a : this;
        if (observer) observer.disconnect();
        observer = new MutationObserver(()=>{
            OnUpdateAttribute.call(this, memberName, element.getAttribute(memberName));
            target[memberName] = element.getAttribute(memberName);
        });
        observer.observe(element, {
            attributeFilter: [
                memberName
            ],
            attributes: true
        });
        return OnInit.call(this);
    };
    prototype.OnDestroy = function() {
        observer.disconnect();
        return OnDestroy.call(this);
    };
};
module.exports.observe = $1e7f34ab65be2f16$var$observe;

});


parcelRegister("iDCoi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Directive = module.exports.CustomAttribute = module.exports.Modifier = module.exports.Input = void 0;

var $2CkIV = parcelRequire("2CkIV");
/**
 * Decorator @Input
 * Used to get attribute from element
 */ const $d919a624d6f31df3$var$Input = (options)=>(target, memberName)=>{
        const OnInit = target.OnInit || $2CkIV.noop;
        Object.defineProperty(target, 'OnInit', {
            value () {
                var _a;
                let originalValue = this[memberName];
                const element = (_a = this.element) !== null && _a !== void 0 ? _a : this;
                Object.defineProperty(this, memberName, {
                    get: function() {
                        originalValue = element.getAttribute(memberName.toLowerCase());
                        return originalValue;
                    },
                    set (value) {
                        element.setAttribute(memberName.toLowerCase(), value);
                        originalValue = value;
                    },
                    configurable: true
                });
                return OnInit.call(this);
            },
            configurable: true
        });
        if (options === null || options === void 0 ? void 0 : options.observe) (0, $2CkIV.observe)(target, memberName);
    };
module.exports.Input = $d919a624d6f31df3$var$Input;
/**
 * Decorator @Modifier
 * Accepts parameter options with selector and registry
 */ const $d919a624d6f31df3$var$Modifier = (options)=>{
    return (target)=>{
        target['options'] = options;
    };
};
module.exports.Modifier = $d919a624d6f31df3$var$Modifier;
/**
 * Decorator @CustomAttribute
 * Accepts parameter options with selector and registry
 */ module.exports.CustomAttribute = module.exports.Modifier;
/**
 * Decorator @Directive
 * Accepts parameter options with selector and registry
 */ module.exports.Directive = module.exports.Modifier;

});

parcelRegister("lJJSL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediaQueryAttribute = module.exports.createFiltersFromSelector = module.exports.Breakpoints = module.exports.MediaMatchers = void 0;

var $ln7Xa = parcelRequire("ln7Xa");
/**
 * Media query Attribute
 * for performance reasons it is key value pair
 */ module.exports.MediaMatchers = new Map([
    [
        'screen and (max-width: 599px)',
        'xs'
    ],
    [
        'screen and (min-width: 600px) and (max-width: 959px)',
        'sm'
    ],
    [
        'screen and (min-width: 960px) and (max-width: 1279px)',
        'md'
    ],
    [
        'screen and (min-width: 1280px) and (max-width: 1919px)',
        'lg'
    ],
    [
        'screen and (min-width: 1920px) and (max-width: 5000px)',
        'xl'
    ],
    [
        'screen and (max-width: 959px)',
        'lt-md'
    ],
    [
        'screen and (max-width: 1279px)',
        'lt-lg'
    ],
    [
        'screen and (max-width: 1919px)',
        'lt-xl'
    ],
    [
        'screen and (min-width: 600px)',
        'gt-xs'
    ],
    [
        'screen and (min-width: 960px)',
        'gt-sm'
    ],
    [
        'screen and (min-width: 1280px)',
        'gt-md'
    ],
    [
        'screen and (min-width: 1920px)',
        'gt-lg'
    ]
]);
module.exports.Breakpoints = [
    ...module.exports.MediaMatchers.values()
];
const $fd31643be014d859$var$createFiltersFromSelector = (selector)=>[
        ...module.exports.Breakpoints.map((breakpoint)=>`${selector}.${breakpoint}`),
        selector
    ];
module.exports.createFiltersFromSelector = $fd31643be014d859$var$createFiltersFromSelector;
class $fd31643be014d859$var$MediaQueryAttribute extends $ln7Xa.Attribute {
    constructor(){
        super(...arguments);
        this.matchers = new Map();
        this.cachedAttributes = new Map();
        this.listener = (event)=>{
            const key = `${this.selector.toLowerCase()}.${module.exports.MediaMatchers.get(event.media)}`;
            const attribute = this.cachedAttributes.get(key);
            if (event.matches && attribute) return this.OnEnterMediaQuery([
                event,
                attribute
            ]);
            return this.OnExitMediaQuery([
                event,
                attribute
            ]);
        };
    }
    OnInit() {
        if (this.OnEnterMediaQuery || this.OnExitMediaQuery) for (const query of module.exports.MediaMatchers.keys()){
            const matcher = window.matchMedia(query);
            const attr = Object.values(this.element.attributes).find((v)=>v.name === `${this.selector.toLowerCase()}.${module.exports.MediaMatchers.get(query)}`);
            if (attr) {
                this.cachedAttributes.set(attr.name, attr);
                matcher.addEventListener('change', this.listener);
            }
            if (attr && matcher.matches) this.listener(matcher);
            this.matchers.set(matcher, matcher);
        }
    }
    OnDestroy() {
        for (const matcher of this.matchers.values())matcher.removeEventListener('change', this.listener);
        this.cachedAttributes.clear();
        this.matchers.clear();
    }
}
module.exports.MediaQueryAttribute = $fd31643be014d859$var$MediaQueryAttribute;

});

parcelRegister("emDlX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("3WmLz", function(module, exports) {

$parcel$export(module.exports, "TranslateModifier", () => $2b86e93a2d940276$export$8d03266bb73d7f3b);

var $deWeK = parcelRequire("deWeK");

var $5kDLo = parcelRequire("5kDLo");

var $1t8Wn = parcelRequire("1t8Wn");

var $f16OP = parcelRequire("f16OP");

var $lNnaw = parcelRequire("lNnaw");
var $8ZyYf = parcelRequire("8ZyYf");

var $6kGb2 = parcelRequire("6kGb2");
class $2b86e93a2d940276$export$8d03266bb73d7f3b extends (0, $5kDLo.Attribute) {
    OnInit() {
        this.originalText = this.element.innerText;
        this.translate.currentLanguage.pipe((0, $8ZyYf.takeUntil)(this.destroy$), (0, $lNnaw.switchMap)(()=>this.translate.get(this.originalText))).subscribe((text)=>this.element.innerText = text);
    }
    OnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    constructor(...args){
        super(...args), this.destroy$ = new (0, $f16OP.Subject)();
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $6kGb2.TranslateService))
], $2b86e93a2d940276$export$8d03266bb73d7f3b.prototype, "translate", void 0);
$2b86e93a2d940276$export$8d03266bb73d7f3b = (0, $deWeK.__decorate)([
    (0, $5kDLo.Modifier)({
        selector: 'translate'
    })
], $2b86e93a2d940276$export$8d03266bb73d7f3b);

});
parcelRegister("6kGb2", function(module, exports) {

$parcel$export(module.exports, "TranslateService", () => $dec22298154ec7f3$export$e18830063cd047ea);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $bq6Hs = parcelRequire("bq6Hs");
var $5JMLH = parcelRequire("5JMLH");
var $8MKp4 = parcelRequire("8MKp4");
var $g5fNy = parcelRequire("g5fNy");

var $j7eyO = parcelRequire("j7eyO");
var $gawXH = parcelRequire("gawXH");

var $bTLPo = parcelRequire("bTLPo");
class $dec22298154ec7f3$export$e18830063cd047ea {
    get(value) {
        const translations = this.config.translations || {};
        const record = translations[this.currentLanguage.getValue()];
        return ((0, $8MKp4.isObservable)(record) || record instanceof Promise ? (0, $5JMLH.from)(record) : (0, $g5fNy.of)(record)).pipe((0, $gawXH.map)((record)=>record[value]), (0, $gawXH.map)((key)=>key ?? value), (0, $j7eyO.catchError)(()=>value));
    }
    changeLanguage(language) {
        this.currentLanguage.next(language);
        localStorage.setItem('lang', language);
    }
    constructor(){
        this.currentLanguage = new (0, $bq6Hs.BehaviorSubject)(localStorage.getItem('lang') || 'EN');
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $bTLPo.TranslationsConfig))
], $dec22298154ec7f3$export$e18830063cd047ea.prototype, "config", void 0);
$dec22298154ec7f3$export$e18830063cd047ea = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $dec22298154ec7f3$export$e18830063cd047ea);

});
parcelRegister("bTLPo", function(module, exports) {

$parcel$export(module.exports, "TranslationsConfig", () => $9303d653d041a918$export$1419828bfa0cc483);

var $1t8Wn = parcelRequire("1t8Wn");
const $9303d653d041a918$export$1419828bfa0cc483 = new (0, $1t8Wn.InjectionToken)('translations-config');

});



parcelRegister("2EHKy", function(module, exports) {

$parcel$export(module.exports, "TranslationsModule", () => $75d5b116a11aa6ad$export$b6025cb57b093d99);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $bTLPo = parcelRequire("bTLPo");

var $6kGb2 = parcelRequire("6kGb2");

var $iI10m = parcelRequire("iI10m");
class $75d5b116a11aa6ad$export$b6025cb57b093d99 {
    static forRoot(config) {
        return {
            module: $75d5b116a11aa6ad$export$b6025cb57b093d99,
            providers: [
                {
                    provide: (0, $bTLPo.TranslationsConfig),
                    useFactory: ()=>({
                            ...config,
                            languages: config.languages || Object.keys(config.translations)
                        })
                }
            ]
        };
    }
}
$75d5b116a11aa6ad$export$b6025cb57b093d99 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Module)({
        components: [
            (0, $iI10m.TranslateComponent)
        ],
        providers: [
            (0, $6kGb2.TranslateService),
            {
                provide: (0, $bTLPo.TranslationsConfig),
                useValue: {}
            }
        ]
    })
], $75d5b116a11aa6ad$export$b6025cb57b093d99);

});
parcelRegister("iI10m", function(module, exports) {

$parcel$export(module.exports, "TranslateComponent", () => $4a83f67d0849b817$export$2b08036c58113df);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $6kGb2 = parcelRequire("6kGb2");
class $4a83f67d0849b817$export$2b08036c58113df extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.refreshPage = false;
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $6kGb2.TranslateService))
], $4a83f67d0849b817$export$2b08036c58113df.prototype, "translateService", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $4a83f67d0849b817$export$2b08036c58113df.prototype, "refreshPage", void 0);
$4a83f67d0849b817$export$2b08036c58113df = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'translate-dropdown',
        template () {
            const template = this.translateService.config.languages.map((language)=>(0, $4TeKW.html)`<bx-dropdown-item value=${language}>${language}</bx-dropdown-item> `);
            return (0, $4TeKW.html)`
      <bx-dropdown
        @bx-dropdown-selected=${(e)=>{
                this.translateService.changeLanguage(e.detail.item.value);
                if (this.refreshPage) location.reload();
            }}
        trigger-content=${this.translateService.currentLanguage.getValue()}
      >
        ${template}
      </bx-dropdown>
    `;
        }
    })
], $4a83f67d0849b817$export$2b08036c58113df);

});



parcelRegister("Zh3jt", function(module, exports) {
$parcel$export(module.exports, "Invitation", () => (parcelRequire("4bJcr")).Invitation);
$parcel$export(module.exports, "ManRemoved", () => (parcelRequire("aaCC1")).ManRemoved);
$parcel$export(module.exports, "ComputerIcon", () => (parcelRequire("eIgCY")).ComputerIcon);
$parcel$export(module.exports, "MessageNotification", () => (parcelRequire("fBgUq")).MessageNotification);
parcelRequire("ch2ue");
parcelRequire("igWT2");
parcelRequire("4bJcr");
parcelRequire("aaCC1");
parcelRequire("eIgCY");
parcelRequire("dvdhf");
parcelRequire("iaOAP");
parcelRequire("fBgUq");

});
parcelRegister("ch2ue", function(module, exports) {

var $4TeKW = parcelRequire("4TeKW");
const $32d7b32895bde423$export$b1778e7c62739fdb = (0, $4TeKW.svg)`
<svg height="25" viewBox="0 0 60 60" width="25" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" fill="none" fill-rule="evenodd">
        <g id="061---Invite" fill-rule="nonzero">
            <path id="Shape" d="m59 13v6h-58v-6c0-3.3137085 2.6862915-6 6-6h46c3.3137085 0 6 2.6862915 6 6z" fill="#f44335" />
            <path id="Shape" d="m53 7h-3c3.3137085 0 6 2.6862915 6 6v6h3v-6c0-3.3137085-2.6862915-6-6-6z" fill="#c81e1e" />
            <path id="Shape" d="m59 19v34c0 3.3137085-2.6862915 6-6 6h-46c-3.3137085 0-6-2.6862915-6-6v-34z" fill="#f5f5f5" />
            <path id="Shape" d="m56 19v34c0 3.3137085-2.6862915 6-6 6h3c3.3137085 0 6-2.6862915 6-6v-34z" fill="#cfd8dc" />
            <path id="Shape" d="m41.548 32-12.708 18.687c-.4851541.7140072-1.2543656 1.184425-2.111 1.291-.1227558.01513-.2463154.0228107-.37.023-.7347408-.0000852-1.4439037-.269802-1.993-.758l-8.28-7.36c-1.2114603-1.10703-1.3085829-2.982032-.2179845-4.2083055 1.0905983-1.2262735 2.9641207-1.3486631 4.2049845-.2746945l5.727 5.089 13.72-20.175c.9358729-1.3582841 2.7927658-1.7062313 4.1569151-.7789286 1.3641494.9273026 1.7237806 2.781968.8050849 4.1519286z" fill="#60a917" />
            <path id="Shape" d="m17.073 39.4 5.727 5.089 1.131-1.662-3.858-3.427c-.9643155-.8535313-2.3668005-.9937396-3.481-.348.1711891.100204.332274.2167478.481.348z" fill="#549414" />
            <path id="Shape" d="m43.687 23.52c-.955685-.646104-2.1977461-.6850157-3.192-.1.063.037.13.062.192.1 1.369706.9315834 1.7251515 2.7970003.794 4.167l-2.933 4.313-12.708 18.687c-.2550204.3721148-.5911176.681543-.983.905.4551863.2662192.9726819.407323 1.5.409.1236846-.0001893.2472442-.00787.37-.023.8566344-.106575 1.6258459-.5769928 2.111-1.291l12.71-18.687 2.933-4.313c.9311515-1.3699997.575706-3.2354166-.794-4.167z" fill="#549414" />
            <path id="Shape" d="m48 56h-7c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h7c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z" fill="#9e9e9e" />
            <path id="Shape" d="m54 56h-2c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h2c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z" fill="#9e9e9e" />
            <g fill="#000">
                <path id="Shape" d="m7 60h46c3.8641657-.0044086 6.9955914-3.1358343 7-7v-40c-.0044086-3.86416566-3.1358343-6.99559136-7-7h-3v-5c0-.55228475-.4477153-1-1-1s-1 .44771525-1 1v5h-36v-5c0-.55228475-.4477153-1-1-1s-1 .44771525-1 1v5h-3c-3.86416566.00440864-6.99559136 3.13583434-7 7v40c.00440864 3.8641657 3.13583434 6.9955914 7 7zm-5-40h2c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1h-2v-5c.00330612-2.7600532 2.23994685-4.99669388 5-5h3c0 .55228475.4477153 1 1 1s1-.44771525 1-1h36c0 .55228475.4477153 1 1 1s1-.44771525 1-1h3c2.7600532.00330612 4.9966939 2.2399468 5 5v5h-49c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h49v33c-.0033061 2.7600532-2.2399468 4.9966939-5 5h-46c-2.76005315-.0033061-4.99669388-2.2399468-5-5z" />
                <path id="Shape" d="m11 14c.5522847 0 1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1z" />
                <path id="Shape" d="m49 14c.5522847 0 1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1z" />
                <path id="Shape" d="m23.7 51.99c.7322123.6518019 1.6787047 1.0113195 2.659 1.01.1651145-.0002391.33007-.0102567.494-.03 1.1418798-.1422032 2.167209-.7692791 2.814-1.721l12.708-18.686c.2009619-.2954586.229033-.6756856.0736393-.997453-.1553938-.3217674-.4706444-.5361912-.827-.5625s-.6996774.1394944-.9006393.434953l-12.708 18.687c-.3212937.4746413-.8313812.7879808-1.4.86-.5723892.0707497-1.1476448-.1072883-1.58-.489l-8.28-7.36c-.6050236-.5373024-.8266789-1.3862284-.5615565-2.1507266.2651224-.7644983.9647786-1.2939202 1.7725565-1.3412734.5289453-.0295991 1.0483165.1499898 1.446.5l5.727 5.09c.2148897.19116.5016821.2805416.7871271.2453156.2854451-.0352259.5419035-.1916485.7038729-.4293156l13.72-20.175c.3931427-.6110549 1.0867634-.9608212 1.811831-.9136369.7250675.0471844 1.3675075.483896 1.67814 1.1407496.3106326.6568537.240586 1.4305071-.182971 2.0208873-.2009619.2956373-.2289377.6760293-.0733893.997886.1555485.3218568.4709897.5362806.8275.5625.3565103.0262195.6999274-.1397487.9008893-.435386.8038476-1.1820132.9160368-2.703086.2943072-3.990245-.6217297-1.2871591-1.8829228-2.1448542-3.3085-2.25-1.4255773-.1051459-2.7989596.5582318-3.6028072 1.740245l-13.08 19.237-4.876-4.334c-1.0665898-.9597327-2.5655153-1.2746768-3.9281652-.8253597-1.3626499.4493172-2.3802619 1.5940588-2.6668089 2.9999718-.286547 1.4059131.2018708 2.8576071 1.2799741 3.8043879z" />
            </g>
        </g>
    </g>
</svg>
`;

});

parcelRegister("igWT2", function(module, exports) {

$parcel$export(module.exports, "BackArrow", () => $b7faaab6b02a4779$export$4930a69c53a0063);

var $4TeKW = parcelRequire("4TeKW");
const $b7faaab6b02a4779$export$4930a69c53a0063 = (0, $4TeKW.html)`
  <div style="color: rgb(107, 120, 115);">
    ${(0, $4TeKW.svg)`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill="#627773"
width="25px" height="25px" viewBox="0 0 459 459" style="enable-background:new 0 0 25 25;" xml:space="preserve">
<g>
<g id="reply">
 <path d="M178.5,140.25v-102L0,216.75l178.5,178.5V290.7c127.5,0,216.75,40.8,280.5,130.05C433.5,293.25,357,165.75,178.5,140.25z"
   />
</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>`}
  </div>
`;

});

parcelRegister("4bJcr", function(module, exports) {

$parcel$export(module.exports, "Invitation", () => $a77e28178b3b9272$export$d899bafc7f84ca89);

var $4TeKW = parcelRequire("4TeKW");
const $a77e28178b3b9272$export$d899bafc7f84ca89 = (0, $4TeKW.svg)`
<?xml version="1.0" encoding="iso-8859-1" ?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg width="45" height="45" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
	<path style="fill:#96C8EF;" d="M279.948,7.379c-14.45-9.838-33.448-9.838-47.897,0L22.785,149.858
	c-9.864,6.716-15.767,17.877-15.767,29.809v307.231c-0.001,13.863,11.237,25.101,25.1,25.101h447.763
	c13.863,0,25.1-11.238,25.1-25.1V179.668c0-11.934-5.903-23.094-15.767-29.809L279.948,7.379z" />
	<path style="fill:#78B9EB;" d="M479.88,511.999c13.863,0,25.1-11.238,25.1-25.1V179.668c0-11.933-5.903-23.094-15.767-29.81
	l-42.065-28.64L269.174,228.934c-3.975,2.4-8.532,3.671-13.176,3.671c-4.601,0-9.114-1.245-13.064-3.603L65.809,120.565
	l-43.024,29.293c-9.864,6.716-15.767,17.877-15.767,29.81v307.231c-0.001,13.862,11.237,25.1,25.1,25.1H479.88z" />
	<path style="fill:#FFF5CC;" d="M441.582,430.859H70.416V101.983c0-23.355,18.934-42.289,42.289-42.289h286.588
	c23.355,0,42.289,18.934,42.289,42.289L441.582,430.859L441.582,430.859z" />
	<path style="fill:#FFEB99;" d="M269.175,228.935c-3.975,2.4-8.532,3.671-13.176,3.671c-4.601,0-9.114-1.245-13.064-3.603
	L70.416,123.385v307.474h371.165V124.588L269.175,228.935z" />
	<path style="fill:#B9D8F4;" d="M210.871,281.846L12.579,160.451c-3.575,5.675-5.561,12.314-5.561,19.217v307.231
	c-0.001,13.862,11.237,25.1,25.1,25.1h447.763c13.863,0,25.1-11.238,25.1-25.1V179.668c0-6.498-1.762-12.76-4.949-18.207
	L301.127,281.846C273.375,298.605,238.623,298.605,210.871,281.846z" />
	<path style="fill:#D1E7F8;" d="M213.301,283.365L17.908,507.719c4.004,2.702,8.83,4.28,14.023,4.28h447.763
	c5.358,0,10.319-1.684,14.396-4.544L299.044,282.947C272.492,298.088,239.96,298.233,213.301,283.365z" />
	<g>
		<path style="fill:#57565C;" d="M369.614,120.204H142.385c-4.267,0-7.726-3.458-7.726-7.726c0-4.268,3.459-7.726,7.726-7.726
		h227.228c4.267,0,7.726,3.458,7.726,7.726C377.339,116.746,373.881,120.204,369.614,120.204z" />
		<path style="fill:#57565C;" d="M369.614,160.304H142.385c-4.267,0-7.726-3.458-7.726-7.726c0-4.268,3.459-7.726,7.726-7.726
		h227.228c4.267,0,7.726,3.458,7.726,7.726C377.339,156.846,373.881,160.304,369.614,160.304z" />
		<path style="fill:#57565C;" d="M249.002,200.402H142.385c-4.267,0-7.726-3.458-7.726-7.726c0-4.268,3.459-7.726,7.726-7.726
		h106.618c4.267,0,7.726,3.458,7.726,7.726C256.729,196.943,253.269,200.402,249.002,200.402z" />
	</g>
	<path style="fill:#3E3D42;" d="M142.385,200.402h53.834l-25.242-15.453h-28.593c-4.267,0-7.726,3.458-7.726,7.726
	C134.658,196.943,138.118,200.402,142.385,200.402z" />
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
</svg>
`;

});

parcelRegister("aaCC1", function(module, exports) {

$parcel$export(module.exports, "ManRemoved", () => $2e9da5503f64de20$export$85eeedbb6f82751);

var $4TeKW = parcelRequire("4TeKW");
const $2e9da5503f64de20$export$85eeedbb6f82751 = (0, $4TeKW.svg)`
<svg height="45" viewBox="0 0 58 58" width="45" xmlns="http://www.w3.org/2000/svg">
    <g id="027---Male-User-Remove-Account" fill="none">
        <circle id="Oval" cx="29" cy="29" fill="#3d324c" r="29" />
        <path id="Shape" d="m15.32 24c-.8435909-2.273544-1.2900922-4.6751797-1.32-7.1 0-6.6 6.2-12.9 13.71-12.9s10.44 5.1 10.44 5.1h.32s6.53.3 6.53 8.7c-.0100465 2.2100266-.5629177 4.3837377-1.61 6.33l-2.39 1.87h-24z" fill="#805333" />
        <path id="Shape" d="m18.06 24c-.6832416-2.3055355-1.0400441-4.6954388-1.06-7.1 0-6.6 5-12.9 11.06-12.9 3.5366363.0021108 6.7799829 1.96660817 8.42 5.1h.25s5.27.3 5.27 8.7c-.0008023 2.1762021-.4430535 4.3296253-1.3 6.33l-1.93 1.87h-19.35z" fill="#a56a43" />
        <path id="Shape" d="m35 40 3 12-3 1.27c-6.2072344 1.5400752-12.7693018.626687-18.32-2.55 1.5106912-1.1554591 2.953112-2.3975437 4.32-3.72v-8z" fill="#fdd7ad" />
        <path id="Shape" d="m35 40v3.88l-3 4.71c-.71.26-1 .21-4.73.21-3.23 0-3.4-2.76-6.3-5.68v-4.12z" fill="#f9c795" />
        <path id="Shape" d="m42.56 32.23c.7228076-.9172105 1.1732697-2.0191101 1.3-3.18.36-1.75.59-5.33-1.18-5.06-1.1298259-.1296538-2.1543248.672128-2.3 1.8 0 .1.48 0-22.91-.23 0 0-.09-1.57-2.15-1.57-1.78-.27-1.53 3.32-1.18 5.06.1963891 2.220622 1.6337162 4.1383496 3.71 4.95h24.15z" fill="#f9c795" />
        <path id="Shape" d="m40.12 33c-.1776761-1.6722605-.0728816-3.3624941.31-5 0-1.13 0-2.15-.09-2.93-.6-9.07-3.82-10.87-3.82-10.87-2.94 4.8-9.79 5.4-9.79 5.4h-5.22c-2.35 0-4 .94-4.12 3.09-.11 2 .44 7.06.35 6.22.74 4.45-1.33 7.26 2.75 10.92 3.28 3 3.37 6.17 6.81 6.17 3.12 0 3.92.09 4.73-.21z" fill="#fdd7ad" />
        <circle id="Oval" cx="45" cy="45" fill="#e64c3c" r="13" />
        <path id="Shape" d="m47.83 45 3.53-3.54c.5707523-.4887798.8193639-1.2562368.6436203-1.9868379-.1757436-.7306012-.7461812-1.3010388-1.4767824-1.4767824-.7306011-.1757436-1.4980581.072868-1.9868379.6436203l-3.54 3.53-3.54-3.53c-.4887798-.5707523-1.2562368-.8193639-1.9868379-.6436203-.7306012.1757436-1.3010388.7461812-1.4767824 1.4767824-.1757436.7306011.072868 1.4980581.6436203 1.9868379l3.53 3.54-3.53 3.54c-.5707523.4887798-.8193639 1.2562368-.6436203 1.9868379.1757436.7306012.7461812 1.3010388 1.4767824 1.4767824.7306011.1757436 1.4980581-.072868 1.9868379-.6436203l3.54-3.53 3.54 3.53c.4887798.5707523 1.2562368.8193639 1.9868379.6436203.7306012-.1757436 1.3010388-.7461812 1.4767824-1.4767824.1757436-.7306011-.072868-1.4980581-.6436203-1.9868379z" fill="#fff" />
    </g>
</svg>
`;

});

parcelRegister("eIgCY", function(module, exports) {

$parcel$export(module.exports, "ComputerIcon", () => $cd3c58a6f06e9e56$export$dda76c5d61ce6547);

var $4TeKW = parcelRequire("4TeKW");
const $cd3c58a6f06e9e56$export$dda76c5d61ce6547 = (0, $4TeKW.svg)`
<svg id="Capa_1" enable-background="new 0 0 497 497" viewBox="0 0 497 497"  xmlns="http://www.w3.org/2000/svg">
    <g>
        <path d="m275.57 401-84.14 30-3.19 11.15c-4.53 15.87-21.74 28.85-38.24 28.85v7.5h174.5z" fill="#adaca7" />
        <path d="m308.76 442.15-11.76-41.15-48.5-30-48.5 30-8.57 30h84.14l3.19 11.15c4.53 15.87 21.74 28.85 38.24 28.85l15 7.5 15-7.5c-16.5 0-33.71-12.98-38.24-28.85z" fill="#8f8f8b" />
        <path d="m437 401h30c16.5 0 30-13.5 30-30v-60l-60-60z" fill="#adaca7" />
        <path d="m0 371c0 16.5 13.5 30 30 30h407c16.5 0 30-13.5 30-30v-180l-467 120z" fill="#cbc9c2" />
        <path d="m467 11h-30l30 300h30v-270c0-16.5-13.5-30-30-30z" fill="#404242" />
        <path d="m467 41c0-16.5-13.5-30-30-30h-407c-16.5 0-30 13.5-30 30v270h467v-30l-218.5-120.013z" fill="#565959" />
        <path d="m467 40.995-29.994-.021c0 .005-188.506 120.013-188.506 120.013s188.502 120.011 188.5 120.013c0 0 29.999-.02 29.999-.02.001 0-.002-239.981.001-239.985z" fill="#4b88d5" />
        <path d="m437 40.995-406.912-.022c-.025.012-.046 240.022-.088 240.027 0 0 406.98-.02 406.99-.02.005 0-.032-239.981.01-239.985z" fill="#69a7ff" />
        <circle cx="248.5" cy="356" fill="#fff" r="15" />
        <path d="m403.5 486h-310c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h310c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z" fill="#8f8f8b" />
    </g>
</svg>
`;

});

parcelRegister("dvdhf", function(module, exports) {

var $4TeKW = parcelRequire("4TeKW");
const $8e5e0da7d83fc0d6$export$7807f5bbd02c545b = (0, $4TeKW.svg)`
<svg
 id="Capa_1"
 enable-background="new 0 0 512 512"
 viewBox="0 0 512 512"
 xmlns="http://www.w3.org/2000/svg"
>
 <g>
  <path
   d="m436 432h-300c-8.284 0-15-6.716-15-15v-402c0-8.284 6.716-15 15-15h300c8.284 0 15 6.716 15 15v402c0 8.284-6.716 15-15 15z"
   fill="#ffe278"
  />
  <path
   d="m436 432c8.284 0 15-6.716 15-15v-402c0-8.284-6.716-15-15-15h-180v432z"
   fill="#ffd845"
  />
  <path
   d="m451 497h-335c-22.091 0-40-17.909-40-40 0-22.091 17.909-40 40-40h335c-22.091 22.091-22.091 57.909 0 80z"
   fill="#fffbf4"
  />
  <path
   d="m116 0c-30.327 0-55 24.673-55 55v402c0 8.284 6.716 15 15 15s15-6.716 15-15c0-13.785 11.215-25 25-25h20v-432z"
   fill="#6ba7ff"
  />
  <path
   d="m376 212h-180c-8.284 0-15-6.716-15-15v-120c0-8.284 6.716-15 15-15h180c8.284 0 15 6.716 15 15v120c0 8.284-6.716 15-15 15z"
   fill="#fffbf4"
  />
  <path
   d="m256 497h195c-22.091-22.091-22.091-57.909 0-80h-195z"
   fill="#f9f4c8"
  />
  <path
   d="m376 62h-120v150h120c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15z"
   fill="#f9f4c8"
  />
  <path
   d="m316 152h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
   fill="#556e82"
  />
  <path
   d="m316 152c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60v30z"
   fill="#3c4655"
  />
  <path
   d="m376 312h-180c-8.284 0-15-6.716-15-15s6.716-15 15-15h180c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
   fill="#556e82"
  />
  <path
   d="m376 372h-180c-8.284 0-15-6.716-15-15s6.716-15 15-15h180c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
   fill="#556e82"
  />
  <path
   d="m376 282h-120v30h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
   fill="#3c4655"
  />
  <path
   d="m376 342h-120v30h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
   fill="#3c4655"
  />
  <path
   d="m436 512h-320c-30.327 0-55-24.673-55-55s24.673-55 55-55h320c8.284 0 15 6.716 15 15s-6.716 15-15 15h-320c-13.785 0-25 11.215-25 25s11.215 25 25 25h320c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
   fill="#93c6ec"
  />
  <g fill="#6ba7ff">
   <path d="m256 402v30h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
   <path
    d="m451 497c0-8.284-6.716-15-15-15h-180v30h180c8.284 0 15-6.716 15-15z"
   />
  </g>
 </g>
</svg>
`;

});

parcelRegister("iaOAP", function(module, exports) {

var $4TeKW = parcelRequire("4TeKW");
const $4af33f1691d40260$export$d42dd7944ff4de70 = (0, $4TeKW.svg)`
<svg
 version="1.1"
 id="Capa_1"
 xmlns="http://www.w3.org/2000/svg"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 x="0px"
 y="0px"
 viewBox="0 0 306.094 306.094"
 style="enable-background: new 0 0 306.094 306.094;"
 xml:space="preserve"
>
 <g>
  <g id="Layer_5_27_">
   <g>
    <path
     d="M274.254,131.297h-40.095c-3.3,0-6,2.7-6,6v31.502c0,3.3,2.7,6,6,6h39.72c0,0,4.366,0,4.366-4.373
				c0-9.782,0-26.406,0-35.208C278.245,131.297,274.254,131.297,274.254,131.297z"
    />
    <path
     d="M212.154,109.291c0,0,43.575-0.079,58.101,0c2.695,0.015,7.991,0.088,7.991-7.239c0-24.138,0-87.052,0-87.052
				c0-8.25-6.75-15-15-15H42.848c-8.25,0-15,6.75-15,15v276.094c0,8.25,6.75,15,15,15h220.397c8.25,0,15-6.75,15-15
				c0,0,0-61.026,0-85.287c0-7.5-3.616-9.002-8.742-9.002c-14.337,0-57.35,0-57.35,0c-3.3,0-6-2.7-6-6v-75.514
				C206.154,111.991,208.853,109.291,212.154,109.291z M141.553,144.005c0,4.95-4.05,9-9,9h-50.5c-4.95,0-9-4.05-9-9v-6
				c0-4.95,4.05-9,9-9h50.5c4.95,0,9,4.05,9,9V144.005z M182.053,86.492c0,4.95-4.05,9-9,9h-91c-4.95,0-9-4.05-9-9v-6
				c0-4.95,4.05-9,9-9h91c4.95,0,9,4.05,9,9V86.492z"
    />
   </g>
  </g>
 </g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
</svg>

`;

});

parcelRegister("fBgUq", function(module, exports) {

$parcel$export(module.exports, "MessageNotification", () => $51e8b5d9cc71b515$export$d849a3cb48bfb673);

var $4TeKW = parcelRequire("4TeKW");
const $51e8b5d9cc71b515$export$d849a3cb48bfb673 = (0, $4TeKW.svg)`

<svg
 enable-background="new 0 0 24 24"
 height="45"
 viewBox="0 0 24 24"
 width="45"
 xmlns="http://www.w3.org/2000/svg"
>
 <path
  d="m21 2.75c0-1.519-1.231-2.75-2.75-2.75h-12.5c-1.519 0-2.75 1.231-2.75 2.75v17c0 .199.079.39.22.53.141.141.332.22.53.22h16.5c.414 0 .75-.336.75-.75z"
  fill="#eceff1"
 />
 <g fill="#2196f3">
  <path
   d="m16.25 11.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  />
  <path
   d="m16.25 8.5h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  />
  <path
   d="m22.25 14h-2.756c-.778 0-1.452.501-1.676 1.247l-.859 2.862c-.16.533-.641.891-1.197.891h-7.524c-.556 0-1.037-.358-1.197-.891l-.859-2.861c-.224-.747-.897-1.248-1.676-1.248h-2.756c-.965 0-1.75.785-1.75 1.75v5.5c0 1.517 1.233 2.75 2.75 2.75h18.5c1.517 0 2.75-1.233 2.75-2.75v-5.5c0-.965-.785-1.75-1.75-1.75z"
  />
 </g>
 <path
  d="m12 0h-6.25c-1.519 0-2.75 1.231-2.75 2.75v11.25h1.506c.779 0 1.452.501 1.676 1.248l.859 2.861c.16.533.641.891 1.197.891h3.762v-7.5h-4.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.25v-1.5h-4.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.25z"
  fill="#cdd0d2"
 />
 <g fill="#1d83d4">
  <path d="m12 10h-4.25c-.414 0-.75.336-.75.75s.336.75.75.75h4.25z" />
  <path d="m12 7h-4.25c-.414 0-.75.336-.75.75s.336.75.75.75h4.25z" />
  <path
   d="m4.506 14h-1.506-1.25c-.965 0-1.75.785-1.75 1.75v5.5c0 1.517 1.233 2.75 2.75 2.75h9.25v-5h-3.762c-.556 0-1.037-.358-1.197-.891l-.859-2.861c-.224-.747-.897-1.248-1.676-1.248z"
  />
 </g>
 <path
  d="m12.25 5.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  fill="#2196f3"
 />
 <path d="m10 4h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25z" fill="#1d83d4" />
</svg>


`;

});



parcelRegister("htpni", function(module, exports) {

$parcel$export(module.exports, "isProjectRemoveNotification", () => $91839d02a59bd908$export$8114f9ffb6303719);
$parcel$export(module.exports, "ProjectRemoveTemplateComponent", () => $91839d02a59bd908$export$bfd1d5c832bd8ed1);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("Zh3jt");
var $aaCC1 = parcelRequire("aaCC1");

var $iCFDc = parcelRequire("iCFDc");
const $91839d02a59bd908$export$8114f9ffb6303719 = (n)=>n.data.__typename === 'ProjectNotifications' && n.data.message.__typename === 'ProjectNotificationsRemove';
class $91839d02a59bd908$export$bfd1d5c832bd8ed1 extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $iCFDc.DateTimeProvider))
], $91839d02a59bd908$export$bfd1d5c832bd8ed1.prototype, "dateTimeProvider", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $91839d02a59bd908$export$bfd1d5c832bd8ed1.prototype, "notification", void 0);
$91839d02a59bd908$export$bfd1d5c832bd8ed1 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'project-remove-template-notifications',
        template () {
            const data = this.notification.data;
            const message = data.message;
            return (0, $4TeKW.html)`
      <style>
        .spacer {
          flex: 1 3 auto;
        }
      </style>
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 10px;">${0, $aaCC1.ManRemoved}</div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            You have being removed from
            <a style="color: blue">${data.projectName}</a>
            by
            <a style="color: blue">${message.by.name}</a>
            reason ${message?.reason}
          </div>
          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
        }
    })
], $91839d02a59bd908$export$bfd1d5c832bd8ed1);

});

parcelRegister("38rxE", function(module, exports) {

$parcel$export(module.exports, "isMachineStartedNotification", () => $8a22573b331eae8a$export$2a106439207765a2);
$parcel$export(module.exports, "MachineStartedTemplateComponent", () => $8a22573b331eae8a$export$6fcc9031e1ddb82e);

var $deWeK = parcelRequire("deWeK");
parcelRequire("Zh3jt");
var $eIgCY = parcelRequire("eIgCY");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $iCFDc = parcelRequire("iCFDc");
const $8a22573b331eae8a$export$2a106439207765a2 = (n)=>n.data.__typename === 'MachineNotifications' && n.data.message.__typename === 'MachineNotificationsStarted';
class $8a22573b331eae8a$export$6fcc9031e1ddb82e extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $iCFDc.DateTimeProvider))
], $8a22573b331eae8a$export$6fcc9031e1ddb82e.prototype, "dateTimeProvider", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $8a22573b331eae8a$export$6fcc9031e1ddb82e.prototype, "notification", void 0);
$8a22573b331eae8a$export$6fcc9031e1ddb82e = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'machine-started-template-notifications',
        template () {
            const data = this.notification.data;
            const message = data.message;
            return (0, $4TeKW.html)`
      <style>
        .spacer {
          flex: 1 3 auto;
        }
      </style>
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 13px; font-size: 22px;width: 45px">
          <!-- &#128187 -->
          ${0, $eIgCY.ComputerIcon}
        </div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            <span style="color: green; font-weight: 500">Started</span> Linode
            <a style="color: blue">${message.ip}</a>
            type
            <a style="color: blue">${message.worker_type}</a>
          </div>
          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
        }
    })
], $8a22573b331eae8a$export$6fcc9031e1ddb82e);

});

parcelRegister("185cP", function(module, exports) {

$parcel$export(module.exports, "isMachineStoppedNotification", () => $f1e5ff2a32d0bd90$export$789f0f574ec26530);
$parcel$export(module.exports, "MachineStoppedTemplateComponent", () => $f1e5ff2a32d0bd90$export$6fab3a50ed1354f6);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("Zh3jt");
var $eIgCY = parcelRequire("eIgCY");

var $iCFDc = parcelRequire("iCFDc");
const $f1e5ff2a32d0bd90$export$789f0f574ec26530 = (n)=>n.data.__typename === 'MachineNotifications' && n.data.message.__typename === 'MachineNotificationsStopped';
class $f1e5ff2a32d0bd90$export$6fab3a50ed1354f6 extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $iCFDc.DateTimeProvider))
], $f1e5ff2a32d0bd90$export$6fab3a50ed1354f6.prototype, "dateTimeProvider", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $f1e5ff2a32d0bd90$export$6fab3a50ed1354f6.prototype, "notification", void 0);
$f1e5ff2a32d0bd90$export$6fab3a50ed1354f6 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'machine-stopped-template-notifications',
        template () {
            const data = this.notification.data;
            const message = data.message;
            return (0, $4TeKW.html)`
      <style>
        .spacer {
          flex: 1 3 auto;
        }
      </style>
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 13px; font-size: 22px; width: 45px">
          <!-- &#128187 -->
          ${0, $eIgCY.ComputerIcon}
        </div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            <span style="color: red; font-weight: 500">Stopped</span> Linode
            <a style="color: blue">${message.ip}</a>
            type
            <a style="color: blue">${message.worker_type}</a>
          </div>

          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
        }
    })
], $f1e5ff2a32d0bd90$export$6fab3a50ed1354f6);

});

parcelRegister("5xHv4", function(module, exports) {

$parcel$export(module.exports, "isProjectMentionNotification", () => $984e6124122f0aba$export$ba3eb363fe90e74c);

var $deWeK = parcelRequire("deWeK");

var $6ppqI = parcelRequire("6ppqI");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("Zh3jt");
var $fBgUq = parcelRequire("fBgUq");

var $iCFDc = parcelRequire("iCFDc");
const $984e6124122f0aba$export$ba3eb363fe90e74c = (n)=>n.data.__typename === 'ProjectNotifications' && n.data.message.__typename === 'ProjectNotificationsMention';
class $984e6124122f0aba$export$73291faeb5c9c522 extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $iCFDc.DateTimeProvider))
], $984e6124122f0aba$export$73291faeb5c9c522.prototype, "dateTimeProvider", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $984e6124122f0aba$export$73291faeb5c9c522.prototype, "notification", void 0);
$984e6124122f0aba$export$73291faeb5c9c522 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'project-card-mention-template',
        styles: [
            (0, $4TeKW.css)`
      .spacer {
        flex: 1 3 auto;
      }
    `
        ],
        template () {
            const data = this.notification.data;
            const message = data.message;
            return (0, $4TeKW.html)`
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 10px;">${0, $fBgUq.MessageNotification}</div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            <span>${(0, $6ppqI.translate)('You have being mentioned inside')}</span>
            <a style="color: blue">${message.comment.card.title}</a> <span>${(0, $6ppqI.translate)('from project')}</span>
            <a style="color: blue">${data.projectName}</a>
            ${(0, $6ppqI.translate)('by')} <a style="color: blue">${message.by.name}</a>
            <p>"${message?.comment.value}"</p>
          </div>
          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
        }
    })
], $984e6124122f0aba$export$73291faeb5c9c522);

});


parcelRegister("4JfJ1", function(module, exports) {

$parcel$export(module.exports, "StorageProvider", () => $a8d96bb1ccf090ad$export$465a18018f692373);

var $deWeK = parcelRequire("deWeK");
parcelRequire("awsiu");

var $1t8Wn = parcelRequire("1t8Wn");

var $1MQ4j = parcelRequire("1MQ4j");

var $5JMLH = parcelRequire("5JMLH");

var $lNnaw = parcelRequire("lNnaw");
class $a8d96bb1ccf090ad$export$465a18018f692373 {
    uploadFile(cardId, file) {
        const uniqueHash = this.generateHash();
        const metadata = {
            customMetadata: {
                cardId: cardId,
                uniqueHash: uniqueHash,
                fileName: file.name
            }
        };
        return (0, $5JMLH.from)(this.storageRef.child([
            cardId,
            uniqueHash
        ].join('/')).put(file, metadata)).pipe((0, $lNnaw.switchMap)(async (snapshot)=>({
                snapshot: snapshot,
                url: await snapshot.ref.getDownloadURL()
            })));
    }
    generateHash() {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for(let i = 0; i < 30; i++)result += characters.charAt(Math.floor(Math.random() * charactersLength));
        return result;
    }
    readCardFiles(cardId) {
        return (0, $5JMLH.from)(this.storageRef.child(cardId).list()).pipe((0, $lNnaw.switchMap)(({ items: items })=>Promise.all(items.map(async (snapshot)=>({
                    snapshot: snapshot,
                    url: await snapshot.getDownloadURL()
                })))));
    }
    deleteFile(cardId, uniqueHash) {
        return (0, $5JMLH.from)(this.storageRef.child([
            cardId,
            uniqueHash
        ].join('/')).delete());
    }
    constructor(){
        this.storageRef = $1MQ4j.storage().ref();
    }
}
$a8d96bb1ccf090ad$export$465a18018f692373 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $a8d96bb1ccf090ad$export$465a18018f692373);

});
parcelRegister("awsiu", function(module, exports) {
parcelRequire("JleOl");

});
parcelRegister("JleOl", function(module, exports) {

var $jJO2d = parcelRequire("jJO2d");

var $lEepN = parcelRequire("lEepN");

var $9Cwol = parcelRequire("9Cwol");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ var $0884ad7c76a0e4e2$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ var $0884ad7c76a0e4e2$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ var $0884ad7c76a0e4e2$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ var $0884ad7c76a0e4e2$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
 * enough for us to use it directly.
 */ var $0884ad7c76a0e4e2$var$MIN_SAFE_INTEGER = -9007199254740991;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0884ad7c76a0e4e2$var$FirebaseStorageError = /** @class */ function() {
    function FirebaseStorageError(code, message) {
        this.code_ = $0884ad7c76a0e4e2$var$prependCode(code);
        this.message_ = 'Firebase Storage: ' + message;
        this.serverResponse_ = null;
        this.name_ = 'FirebaseError';
    }
    FirebaseStorageError.prototype.codeProp = function() {
        return this.code;
    };
    FirebaseStorageError.prototype.codeEquals = function(code) {
        return $0884ad7c76a0e4e2$var$prependCode(code) === this.codeProp();
    };
    FirebaseStorageError.prototype.serverResponseProp = function() {
        return this.serverResponse_;
    };
    FirebaseStorageError.prototype.setServerResponseProp = function(serverResponse) {
        this.serverResponse_ = serverResponse;
    };
    Object.defineProperty(FirebaseStorageError.prototype, "name", {
        get: function() {
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "code", {
        get: function() {
            return this.code_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "message", {
        get: function() {
            return this.message_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
        get: function() {
            return this.serverResponse_;
        },
        enumerable: true,
        configurable: true
    });
    return FirebaseStorageError;
}();
var $0884ad7c76a0e4e2$var$Code = {
    // Shared between all platforms
    UNKNOWN: 'unknown',
    OBJECT_NOT_FOUND: 'object-not-found',
    BUCKET_NOT_FOUND: 'bucket-not-found',
    PROJECT_NOT_FOUND: 'project-not-found',
    QUOTA_EXCEEDED: 'quota-exceeded',
    UNAUTHENTICATED: 'unauthenticated',
    UNAUTHORIZED: 'unauthorized',
    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
    INVALID_CHECKSUM: 'invalid-checksum',
    CANCELED: 'canceled',
    // JS specific
    INVALID_EVENT_NAME: 'invalid-event-name',
    INVALID_URL: 'invalid-url',
    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
    NO_DEFAULT_BUCKET: 'no-default-bucket',
    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
    NO_DOWNLOAD_URL: 'no-download-url',
    INVALID_ARGUMENT: 'invalid-argument',
    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
    APP_DELETED: 'app-deleted',
    INVALID_ROOT_OPERATION: 'invalid-root-operation',
    INVALID_FORMAT: 'invalid-format',
    INTERNAL_ERROR: 'internal-error'
};
function $0884ad7c76a0e4e2$var$prependCode(code) {
    return 'storage/' + code;
}
function $0884ad7c76a0e4e2$var$unknown() {
    var message = "An unknown error occurred, please check the error payload for server response.";
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.UNKNOWN, message);
}
function $0884ad7c76a0e4e2$var$objectNotFound(path) {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $0884ad7c76a0e4e2$var$quotaExceeded(bucket) {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $0884ad7c76a0e4e2$var$unauthenticated() {
    var message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.UNAUTHENTICATED, message);
}
function $0884ad7c76a0e4e2$var$unauthorized(path) {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $0884ad7c76a0e4e2$var$retryLimitExceeded() {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $0884ad7c76a0e4e2$var$canceled() {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.CANCELED, 'User canceled the upload/download.');
}
function $0884ad7c76a0e4e2$var$invalidUrl(url) {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $0884ad7c76a0e4e2$var$invalidDefaultBucket(bucket) {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $0884ad7c76a0e4e2$var$cannotSliceBlob() {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $0884ad7c76a0e4e2$var$serverFileWrongSize() {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $0884ad7c76a0e4e2$var$noDownloadURL() {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $0884ad7c76a0e4e2$var$invalidArgument(index, fnName, message) {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
}
function $0884ad7c76a0e4e2$var$invalidArgumentCount(argMin, argMax, fnName, real) {
    var countPart;
    var plural;
    if (argMin === argMax) {
        countPart = argMin;
        plural = argMin === 1 ? 'argument' : 'arguments';
    } else {
        countPart = 'between ' + argMin + ' and ' + argMax;
        plural = 'arguments';
    }
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' + fnName + '`: Expected ' + countPart + ' ' + plural + ', received ' + real + '.');
}
function $0884ad7c76a0e4e2$var$appDeleted() {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name The name of the operation that was invalid.
 */ function $0884ad7c76a0e4e2$var$invalidRootOperation(name) {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format The format that was not valid.
 * @param message A message describing the format violation.
 */ function $0884ad7c76a0e4e2$var$invalidFormat(format, message) {
    return new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message A message describing the internal error.
 */ function $0884ad7c76a0e4e2$var$internalError(message) {
    throw new $0884ad7c76a0e4e2$var$FirebaseStorageError($0884ad7c76a0e4e2$var$Code.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0884ad7c76a0e4e2$var$StringFormat = {
    RAW: 'raw',
    BASE64: 'base64',
    BASE64URL: 'base64url',
    DATA_URL: 'data_url'
};
function $0884ad7c76a0e4e2$var$formatValidator(stringFormat) {
    switch(stringFormat){
        case $0884ad7c76a0e4e2$var$StringFormat.RAW:
        case $0884ad7c76a0e4e2$var$StringFormat.BASE64:
        case $0884ad7c76a0e4e2$var$StringFormat.BASE64URL:
        case $0884ad7c76a0e4e2$var$StringFormat.DATA_URL:
            return;
        default:
            throw 'Expected one of the event types: [' + $0884ad7c76a0e4e2$var$StringFormat.RAW + ', ' + $0884ad7c76a0e4e2$var$StringFormat.BASE64 + ', ' + $0884ad7c76a0e4e2$var$StringFormat.BASE64URL + ', ' + $0884ad7c76a0e4e2$var$StringFormat.DATA_URL + '].';
    }
}
/**
 * @struct
 */ var $0884ad7c76a0e4e2$var$StringData = /** @class */ function() {
    function StringData(data, contentType) {
        this.data = data;
        this.contentType = contentType || null;
    }
    return StringData;
}();
function $0884ad7c76a0e4e2$var$dataFromString(format, stringData) {
    switch(format){
        case $0884ad7c76a0e4e2$var$StringFormat.RAW:
            return new $0884ad7c76a0e4e2$var$StringData($0884ad7c76a0e4e2$var$utf8Bytes_(stringData));
        case $0884ad7c76a0e4e2$var$StringFormat.BASE64:
        case $0884ad7c76a0e4e2$var$StringFormat.BASE64URL:
            return new $0884ad7c76a0e4e2$var$StringData($0884ad7c76a0e4e2$var$base64Bytes_(format, stringData));
        case $0884ad7c76a0e4e2$var$StringFormat.DATA_URL:
            return new $0884ad7c76a0e4e2$var$StringData($0884ad7c76a0e4e2$var$dataURLBytes_(stringData), $0884ad7c76a0e4e2$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $0884ad7c76a0e4e2$var$unknown();
}
function $0884ad7c76a0e4e2$var$utf8Bytes_(value) {
    var b = [];
    for(var i = 0; i < value.length; i++){
        var c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    var hi = c;
                    var lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $0884ad7c76a0e4e2$var$percentEncodedBytes_(value) {
    var decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $0884ad7c76a0e4e2$var$invalidFormat($0884ad7c76a0e4e2$var$StringFormat.DATA_URL, 'Malformed data URL.');
    }
    return $0884ad7c76a0e4e2$var$utf8Bytes_(decoded);
}
function $0884ad7c76a0e4e2$var$base64Bytes_(format, value) {
    switch(format){
        case $0884ad7c76a0e4e2$var$StringFormat.BASE64:
            var hasMinus = value.indexOf('-') !== -1;
            var hasUnder = value.indexOf('_') !== -1;
            if (hasMinus || hasUnder) {
                var invalidChar = hasMinus ? '-' : '_';
                throw $0884ad7c76a0e4e2$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
            }
            break;
        case $0884ad7c76a0e4e2$var$StringFormat.BASE64URL:
            var hasPlus = value.indexOf('+') !== -1;
            var hasSlash = value.indexOf('/') !== -1;
            if (hasPlus || hasSlash) {
                var invalidChar = hasPlus ? '+' : '/';
                throw $0884ad7c76a0e4e2$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
            }
            value = value.replace(/-/g, '+').replace(/_/g, '/');
            break;
    }
    var bytes;
    try {
        bytes = atob(value);
    } catch (e) {
        throw $0884ad7c76a0e4e2$var$invalidFormat(format, 'Invalid character found');
    }
    var array = new Uint8Array(bytes.length);
    for(var i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
/**
 * @struct
 */ var $0884ad7c76a0e4e2$var$DataURLParts = /** @class */ function() {
    function DataURLParts(dataURL) {
        this.base64 = false;
        this.contentType = null;
        var matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $0884ad7c76a0e4e2$var$invalidFormat($0884ad7c76a0e4e2$var$StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        var middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $0884ad7c76a0e4e2$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
    return DataURLParts;
}();
function $0884ad7c76a0e4e2$var$dataURLBytes_(dataUrl) {
    var parts = new $0884ad7c76a0e4e2$var$DataURLParts(dataUrl);
    if (parts.base64) return $0884ad7c76a0e4e2$var$base64Bytes_($0884ad7c76a0e4e2$var$StringFormat.BASE64, parts.rest);
    else return $0884ad7c76a0e4e2$var$percentEncodedBytes_(parts.rest);
}
function $0884ad7c76a0e4e2$var$dataURLContentType_(dataUrl) {
    var parts = new $0884ad7c76a0e4e2$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $0884ad7c76a0e4e2$var$endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0884ad7c76a0e4e2$var$TaskEvent = {
    /** Triggered whenever the task changes or progress is updated. */ STATE_CHANGED: 'state_changed'
};
var $0884ad7c76a0e4e2$var$InternalTaskState = {
    RUNNING: 'running',
    PAUSING: 'pausing',
    PAUSED: 'paused',
    SUCCESS: 'success',
    CANCELING: 'canceling',
    CANCELED: 'canceled',
    ERROR: 'error'
};
var $0884ad7c76a0e4e2$var$TaskState = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $0884ad7c76a0e4e2$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case $0884ad7c76a0e4e2$var$InternalTaskState.RUNNING:
        case $0884ad7c76a0e4e2$var$InternalTaskState.PAUSING:
        case $0884ad7c76a0e4e2$var$InternalTaskState.CANCELING:
            return $0884ad7c76a0e4e2$var$TaskState.RUNNING;
        case $0884ad7c76a0e4e2$var$InternalTaskState.PAUSED:
            return $0884ad7c76a0e4e2$var$TaskState.PAUSED;
        case $0884ad7c76a0e4e2$var$InternalTaskState.SUCCESS:
            return $0884ad7c76a0e4e2$var$TaskState.SUCCESS;
        case $0884ad7c76a0e4e2$var$InternalTaskState.CANCELED:
            return $0884ad7c76a0e4e2$var$TaskState.CANCELED;
        case $0884ad7c76a0e4e2$var$InternalTaskState.ERROR:
            return $0884ad7c76a0e4e2$var$TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $0884ad7c76a0e4e2$var$TaskState.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @return False if the object is undefined or null, true otherwise.
 */ function $0884ad7c76a0e4e2$var$isDef(p) {
    return p != null;
}
function $0884ad7c76a0e4e2$var$isJustDef(p) {
    return p !== void 0;
}
function $0884ad7c76a0e4e2$var$isFunction(p) {
    return typeof p === 'function';
}
function $0884ad7c76a0e4e2$var$isObject(p) {
    return typeof p === 'object';
}
function $0884ad7c76a0e4e2$var$isNonNullObject(p) {
    return $0884ad7c76a0e4e2$var$isObject(p) && p !== null;
}
function $0884ad7c76a0e4e2$var$isNonArrayObject(p) {
    return $0884ad7c76a0e4e2$var$isObject(p) && !Array.isArray(p);
}
function $0884ad7c76a0e4e2$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $0884ad7c76a0e4e2$var$isInteger(p) {
    return $0884ad7c76a0e4e2$var$isNumber(p) && Number.isInteger(p);
}
function $0884ad7c76a0e4e2$var$isNumber(p) {
    return typeof p === 'number' || p instanceof Number;
}
function $0884ad7c76a0e4e2$var$isNativeBlob(p) {
    return $0884ad7c76a0e4e2$var$isNativeBlobDefined() && p instanceof Blob;
}
function $0884ad7c76a0e4e2$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @enum{number}
 */ var $0884ad7c76a0e4e2$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($0884ad7c76a0e4e2$var$ErrorCode || ($0884ad7c76a0e4e2$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */ var $0884ad7c76a0e4e2$var$NetworkXhrIo = /** @class */ function() {
    function NetworkXhrIo() {
        var _this = this;
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.errorCode_ = $0884ad7c76a0e4e2$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise(function(resolve) {
            _this.xhr_.addEventListener('abort', function() {
                _this.errorCode_ = $0884ad7c76a0e4e2$var$ErrorCode.ABORT;
                resolve(_this);
            });
            _this.xhr_.addEventListener('error', function() {
                _this.errorCode_ = $0884ad7c76a0e4e2$var$ErrorCode.NETWORK_ERROR;
                resolve(_this);
            });
            _this.xhr_.addEventListener('load', function() {
                resolve(_this);
            });
        });
    }
    /**
     * @override
     */ NetworkXhrIo.prototype.send = function(url, method, body, headers) {
        if (this.sent_) throw $0884ad7c76a0e4e2$var$internalError('cannot .send() more than once');
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if ($0884ad7c76a0e4e2$var$isDef(headers)) {
            for(var key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if ($0884ad7c76a0e4e2$var$isDef(body)) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.getErrorCode = function() {
        if (!this.sent_) throw $0884ad7c76a0e4e2$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.getStatus = function() {
        if (!this.sent_) throw $0884ad7c76a0e4e2$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.getResponseText = function() {
        if (!this.sent_) throw $0884ad7c76a0e4e2$var$internalError('cannot .getResponseText() before sending');
        return this.xhr_.responseText;
    };
    /**
     * Aborts the request.
     * @override
     */ NetworkXhrIo.prototype.abort = function() {
        this.xhr_.abort();
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.getResponseHeader = function(header) {
        return this.xhr_.getResponseHeader(header);
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.addUploadProgressListener = function(listener) {
        if ($0884ad7c76a0e4e2$var$isDef(this.xhr_.upload)) this.xhr_.upload.addEventListener('progress', listener);
    };
    /**
     * @override
     */ NetworkXhrIo.prototype.removeUploadProgressListener = function(listener) {
        if ($0884ad7c76a0e4e2$var$isDef(this.xhr_.upload)) this.xhr_.upload.removeEventListener('progress', listener);
    };
    return NetworkXhrIo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Factory-like class for creating XhrIo instances.
 */ var $0884ad7c76a0e4e2$var$XhrIoPool = /** @class */ function() {
    function XhrIoPool() {}
    XhrIoPool.prototype.createXhrIo = function() {
        return new $0884ad7c76a0e4e2$var$NetworkXhrIo();
    };
    return XhrIoPool;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0884ad7c76a0e4e2$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $0884ad7c76a0e4e2$var$getBlob() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var BlobBuilder1 = $0884ad7c76a0e4e2$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        var bb = new BlobBuilder1();
        for(var i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($0884ad7c76a0e4e2$var$isNativeBlobDefined()) return new Blob(args);
        else throw Error("This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $0884ad7c76a0e4e2$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 */ var $0884ad7c76a0e4e2$var$FbsBlob = /** @class */ function() {
    function FbsBlob(data, elideCopy) {
        var size = 0;
        var blobType = '';
        if ($0884ad7c76a0e4e2$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    FbsBlob.prototype.size = function() {
        return this.size_;
    };
    FbsBlob.prototype.type = function() {
        return this.type_;
    };
    FbsBlob.prototype.slice = function(startByte, endByte) {
        if ($0884ad7c76a0e4e2$var$isNativeBlob(this.data_)) {
            var realBlob = this.data_;
            var sliced = $0884ad7c76a0e4e2$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new FbsBlob(sliced);
        } else {
            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    };
    FbsBlob.getBlob = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if ($0884ad7c76a0e4e2$var$isNativeBlobDefined()) {
            var blobby = args.map(function(val) {
                if (val instanceof FbsBlob) return val.data_;
                else return val;
            });
            return new FbsBlob($0884ad7c76a0e4e2$var$getBlob.apply(null, blobby));
        } else {
            var uint8Arrays = args.map(function(val) {
                if ($0884ad7c76a0e4e2$var$isString(val)) return $0884ad7c76a0e4e2$var$dataFromString($0884ad7c76a0e4e2$var$StringFormat.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            var finalLength_1 = 0;
            uint8Arrays.forEach(function(array) {
                finalLength_1 += array.byteLength;
            });
            var merged_1 = new Uint8Array(finalLength_1);
            var index_1 = 0;
            uint8Arrays.forEach(function(array) {
                for(var i = 0; i < array.length; i++)merged_1[index_1++] = array[i];
            });
            return new FbsBlob(merged_1, true);
        }
    };
    FbsBlob.prototype.uploadData = function() {
        return this.data_;
    };
    return FbsBlob;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @struct
 */ var $0884ad7c76a0e4e2$var$Location = /** @class */ function() {
    function Location(bucket, path) {
        this.bucket = bucket;
        this.path_ = path;
    }
    Object.defineProperty(Location.prototype, "path", {
        get: function() {
            return this.path_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "isRoot", {
        get: function() {
            return this.path.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Location.prototype.fullServerUrl = function() {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    };
    Location.prototype.bucketOnlyServerUrl = function() {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    };
    Location.makeFromBucketSpec = function(bucketString) {
        var bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $0884ad7c76a0e4e2$var$invalidDefaultBucket(bucketString);
    };
    Location.makeFromUrl = function(url) {
        var location = null;
        var bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        var gsPath = '(/(.*))?$';
        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        var gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        var version = 'v[A-Za-z0-9_]+';
        var firebaseStorageHost = $0884ad7c76a0e4e2$var$DEFAULT_HOST.replace(/[.]/g, '\\.');
        var firebaseStoragePath = '(/([^?#]*).*)?$';
        var firebaseStorageRegExp = new RegExp("^https?://" + firebaseStorageHost + "/" + version + "/b/" + bucketDomain + "/o" + firebaseStoragePath, 'i');
        var firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        var cloudStorageHost = '(?:storage.googleapis.com|storage.cloud.google.com)';
        var cloudStoragePath = '([^?#]*)';
        var cloudStorageRegExp = new RegExp("^https?://" + cloudStorageHost + "/" + bucketDomain + "/" + cloudStoragePath, 'i');
        var cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        var groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(var i = 0; i < groups.length; i++){
            var group = groups[i];
            var captures = group.regex.exec(url);
            if (captures) {
                var bucketValue = captures[group.indices.bucket];
                var pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $0884ad7c76a0e4e2$var$invalidUrl(url);
        return location;
    };
    return Location;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $0884ad7c76a0e4e2$var$jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($0884ad7c76a0e4e2$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $0884ad7c76a0e4e2$var$parent(path) {
    if (path.length === 0) return null;
    var index = path.lastIndexOf('/');
    if (index === -1) return '';
    var newPath = path.slice(0, index);
    return newPath;
}
function $0884ad7c76a0e4e2$var$child(path, childPath) {
    var canonicalChildPath = childPath.split('/').filter(function(component) {
        return component.length > 0;
    }).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $0884ad7c76a0e4e2$var$lastComponent(path) {
    var index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0884ad7c76a0e4e2$var$makeUrl(urlPart) {
    return "https://" + $0884ad7c76a0e4e2$var$DEFAULT_HOST + "/v0" + urlPart;
}
function $0884ad7c76a0e4e2$var$makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = '?';
    for(var key in params)if (params.hasOwnProperty(key)) {
        // @ts-ignore TODO: remove once typescript is upgraded to 3.5.x
        var nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0884ad7c76a0e4e2$var$noXform_(metadata, value) {
    return value;
}
/**
 * @struct
 */ var $0884ad7c76a0e4e2$var$Mapping = /** @class */ function() {
    function Mapping(server, local, writable, xform) {
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $0884ad7c76a0e4e2$var$noXform_;
    }
    return Mapping;
}();
var $0884ad7c76a0e4e2$var$mappings_ = null;
function $0884ad7c76a0e4e2$var$xformPath(fullPath) {
    if (!$0884ad7c76a0e4e2$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $0884ad7c76a0e4e2$var$lastComponent(fullPath);
}
function $0884ad7c76a0e4e2$var$getMappings() {
    if ($0884ad7c76a0e4e2$var$mappings_) return $0884ad7c76a0e4e2$var$mappings_;
    var mappings = [];
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('bucket'));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('generation'));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('metageneration'));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $0884ad7c76a0e4e2$var$xformPath(fullPath);
    }
    var nameMapping = new $0884ad7c76a0e4e2$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if ($0884ad7c76a0e4e2$var$isDef(size)) return Number(size);
        else return size;
    }
    var sizeMapping = new $0884ad7c76a0e4e2$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('timeCreated'));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('updated'));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('md5Hash', null, true));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('cacheControl', null, true));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('contentDisposition', null, true));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('contentEncoding', null, true));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('contentLanguage', null, true));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('contentType', null, true));
    mappings.push(new $0884ad7c76a0e4e2$var$Mapping('metadata', 'customMetadata', true));
    $0884ad7c76a0e4e2$var$mappings_ = mappings;
    return $0884ad7c76a0e4e2$var$mappings_;
}
function $0884ad7c76a0e4e2$var$addRef(metadata, authWrapper) {
    function generateRef() {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var loc = new $0884ad7c76a0e4e2$var$Location(bucket, path);
        return authWrapper.makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $0884ad7c76a0e4e2$var$fromResource(authWrapper, resource, mappings) {
    var metadata = {};
    metadata['type'] = 'file';
    var len = mappings.length;
    for(var i = 0; i < len; i++){
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $0884ad7c76a0e4e2$var$addRef(metadata, authWrapper);
    return metadata;
}
function $0884ad7c76a0e4e2$var$fromResourceString(authWrapper, resourceString, mappings) {
    var obj = $0884ad7c76a0e4e2$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    var resource = obj;
    return $0884ad7c76a0e4e2$var$fromResource(authWrapper, resource, mappings);
}
function $0884ad7c76a0e4e2$var$downloadUrlFromResourceString(metadata, resourceString) {
    var obj = $0884ad7c76a0e4e2$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$0884ad7c76a0e4e2$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    var tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    var encode = encodeURIComponent;
    var tokensList = tokens.split(',');
    var urls = tokensList.map(function(token) {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        var base = $0884ad7c76a0e4e2$var$makeUrl(urlPart);
        var queryString = $0884ad7c76a0e4e2$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $0884ad7c76a0e4e2$var$toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for(var i = 0; i < len; i++){
        var mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
function $0884ad7c76a0e4e2$var$metadataValidator(p) {
    if (!$0884ad7c76a0e4e2$var$isObject(p) || !p) throw 'Expected Metadata object.';
    for(var key in p)if (p.hasOwnProperty(key)) {
        var val = p[key];
        if (key === 'customMetadata') {
            if (!$0884ad7c76a0e4e2$var$isObject(val)) throw 'Expected object for \'customMetadata\' mapping.';
        } else {
            if ($0884ad7c76a0e4e2$var$isNonNullObject(val)) throw "Mapping for '" + key + "' cannot be an object.";
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0884ad7c76a0e4e2$var$MAX_RESULTS_KEY = 'maxResults';
var $0884ad7c76a0e4e2$var$MAX_MAX_RESULTS = 1000;
var $0884ad7c76a0e4e2$var$PAGE_TOKEN_KEY = 'pageToken';
var $0884ad7c76a0e4e2$var$PREFIXES_KEY = 'prefixes';
var $0884ad7c76a0e4e2$var$ITEMS_KEY = 'items';
function $0884ad7c76a0e4e2$var$fromBackendResponse(authWrapper, bucket, resource) {
    var listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$0884ad7c76a0e4e2$var$PREFIXES_KEY]) for(var _i = 0, _a = resource[$0884ad7c76a0e4e2$var$PREFIXES_KEY]; _i < _a.length; _i++){
        var path = _a[_i];
        var pathWithoutTrailingSlash = path.replace(/\/$/, '');
        var reference = authWrapper.makeStorageReference(new $0884ad7c76a0e4e2$var$Location(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$0884ad7c76a0e4e2$var$ITEMS_KEY]) for(var _b = 0, _c = resource[$0884ad7c76a0e4e2$var$ITEMS_KEY]; _b < _c.length; _b++){
        var item = _c[_b];
        var reference = authWrapper.makeStorageReference(new $0884ad7c76a0e4e2$var$Location(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $0884ad7c76a0e4e2$var$fromResponseString(authWrapper, bucket, resourceString) {
    var obj = $0884ad7c76a0e4e2$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    var resource = obj;
    return $0884ad7c76a0e4e2$var$fromBackendResponse(authWrapper, bucket, resource);
}
function $0884ad7c76a0e4e2$var$listOptionsValidator(p) {
    if (!$0884ad7c76a0e4e2$var$isObject(p) || !p) throw 'Expected ListOptions object.';
    for(var key in p){
        if (key === $0884ad7c76a0e4e2$var$MAX_RESULTS_KEY) {
            if (!$0884ad7c76a0e4e2$var$isInteger(p[$0884ad7c76a0e4e2$var$MAX_RESULTS_KEY]) || p[$0884ad7c76a0e4e2$var$MAX_RESULTS_KEY] <= 0) throw 'Expected maxResults to be a positive number.';
            if (p[$0884ad7c76a0e4e2$var$MAX_RESULTS_KEY] > 1000) throw "Expected maxResults to be less than or equal to " + $0884ad7c76a0e4e2$var$MAX_MAX_RESULTS + ".";
        } else if (key === $0884ad7c76a0e4e2$var$PAGE_TOKEN_KEY) {
            if (p[$0884ad7c76a0e4e2$var$PAGE_TOKEN_KEY] && !$0884ad7c76a0e4e2$var$isString(p[$0884ad7c76a0e4e2$var$PAGE_TOKEN_KEY])) throw 'Expected pageToken to be string.';
        } else throw 'Unknown option: ' + key;
    }
}
var $0884ad7c76a0e4e2$var$RequestInfo = /** @class */ function() {
    function RequestInfo(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout) {
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
    return RequestInfo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */ function $0884ad7c76a0e4e2$var$handlerCheck(cndn) {
    if (!cndn) throw $0884ad7c76a0e4e2$var$unknown();
}
function $0884ad7c76a0e4e2$var$metadataHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = $0884ad7c76a0e4e2$var$fromResourceString(authWrapper, text, mappings);
        $0884ad7c76a0e4e2$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $0884ad7c76a0e4e2$var$listHandler(authWrapper, bucket) {
    function handler(xhr, text) {
        var listResult = $0884ad7c76a0e4e2$var$fromResponseString(authWrapper, bucket, text);
        $0884ad7c76a0e4e2$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $0884ad7c76a0e4e2$var$downloadUrlHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = $0884ad7c76a0e4e2$var$fromResourceString(authWrapper, text, mappings);
        $0884ad7c76a0e4e2$var$handlerCheck(metadata !== null);
        return $0884ad7c76a0e4e2$var$downloadUrlFromResourceString(metadata, text);
    }
    return handler;
}
function $0884ad7c76a0e4e2$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) newErr = $0884ad7c76a0e4e2$var$unauthenticated();
        else {
            if (xhr.getStatus() === 402) newErr = $0884ad7c76a0e4e2$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $0884ad7c76a0e4e2$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function $0884ad7c76a0e4e2$var$objectErrorHandler(location) {
    var shared = $0884ad7c76a0e4e2$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $0884ad7c76a0e4e2$var$objectNotFound(location.path);
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function $0884ad7c76a0e4e2$var$getMetadata(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $0884ad7c76a0e4e2$var$makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, $0884ad7c76a0e4e2$var$metadataHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$objectErrorHandler(location);
    return requestInfo;
}
function $0884ad7c76a0e4e2$var$list(authWrapper, location, delimiter, pageToken, maxResults) {
    var urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    var urlPart = location.bucketOnlyServerUrl();
    var url = $0884ad7c76a0e4e2$var$makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, $0884ad7c76a0e4e2$var$listHandler(authWrapper, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$sharedErrorHandler(location);
    return requestInfo;
}
function $0884ad7c76a0e4e2$var$getDownloadUrl(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $0884ad7c76a0e4e2$var$makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, $0884ad7c76a0e4e2$var$downloadUrlHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$objectErrorHandler(location);
    return requestInfo;
}
function $0884ad7c76a0e4e2$var$updateMetadata(authWrapper, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = $0884ad7c76a0e4e2$var$makeUrl(urlPart);
    var method = 'PATCH';
    var body = $0884ad7c76a0e4e2$var$toResourceString(metadata, mappings);
    var headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, $0884ad7c76a0e4e2$var$metadataHandler(authWrapper, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$objectErrorHandler(location);
    return requestInfo;
}
function $0884ad7c76a0e4e2$var$deleteObject(authWrapper, location) {
    var urlPart = location.fullServerUrl();
    var url = $0884ad7c76a0e4e2$var$makeUrl(urlPart);
    var method = 'DELETE';
    var timeout = authWrapper.maxOperationRetryTime();
    function handler(_xhr, _text) {}
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$objectErrorHandler(location);
    return requestInfo;
}
function $0884ad7c76a0e4e2$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $0884ad7c76a0e4e2$var$metadataForUpload_(location, blob, metadata) {
    var metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $0884ad7c76a0e4e2$var$determineContentType_(null, blob);
    return metadataClone;
}
function $0884ad7c76a0e4e2$var$multipartUpload(authWrapper, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        var str = '';
        for(var i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    var boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    var metadata_ = $0884ad7c76a0e4e2$var$metadataForUpload_(location, blob, metadata);
    var metadataString = $0884ad7c76a0e4e2$var$toResourceString(metadata_, mappings);
    var preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    var postBlobPart = '\r\n--' + boundary + '--';
    var body = $0884ad7c76a0e4e2$var$FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $0884ad7c76a0e4e2$var$cannotSliceBlob();
    var urlParams = {
        name: metadata_['fullPath']
    };
    var url = $0884ad7c76a0e4e2$var$makeUrl(urlPart);
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, $0884ad7c76a0e4e2$var$metadataHandler(authWrapper, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 * @struct
 */ var $0884ad7c76a0e4e2$var$ResumableUploadStatus = /** @class */ function() {
    function ResumableUploadStatus(current, total, finalized, metadata) {
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
    return ResumableUploadStatus;
}();
function $0884ad7c76a0e4e2$var$checkResumeHeader_(xhr, allowed) {
    var status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $0884ad7c76a0e4e2$var$handlerCheck(false);
    }
    var allowedStatus = allowed || [
        'active'
    ];
    $0884ad7c76a0e4e2$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $0884ad7c76a0e4e2$var$createResumableUpload(authWrapper, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadataForUpload = $0884ad7c76a0e4e2$var$metadataForUpload_(location, blob, metadata);
    var urlParams = {
        name: metadataForUpload['fullPath']
    };
    var url = $0884ad7c76a0e4e2$var$makeUrl(urlPart);
    var method = 'POST';
    var headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': blob.size(),
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    var body = $0884ad7c76a0e4e2$var$toResourceString(metadataForUpload, mappings);
    var timeout = authWrapper.maxUploadRetryTime();
    function handler(xhr) {
        $0884ad7c76a0e4e2$var$checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $0884ad7c76a0e4e2$var$handlerCheck(false);
        }
        $0884ad7c76a0e4e2$var$handlerCheck($0884ad7c76a0e4e2$var$isString(url));
        return url;
    }
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $0884ad7c76a0e4e2$var$getResumableUploadStatus(authWrapper, location, url, blob) {
    var headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        var status = $0884ad7c76a0e4e2$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        var sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $0884ad7c76a0e4e2$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $0884ad7c76a0e4e2$var$handlerCheck(false);
        var size = Number(sizeString);
        $0884ad7c76a0e4e2$var$handlerCheck(!isNaN(size));
        return new $0884ad7c76a0e4e2$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ var $0884ad7c76a0e4e2$var$resumableUploadChunkSize = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $0884ad7c76a0e4e2$var$continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status_ = new $0884ad7c76a0e4e2$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $0884ad7c76a0e4e2$var$serverFileWrongSize();
    var bytesLeft = status_.total - status_.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    var startByte = status_.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
    var headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': status_.current
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) throw $0884ad7c76a0e4e2$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = $0884ad7c76a0e4e2$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        var newCurrent = status_.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === 'final') metadata = $0884ad7c76a0e4e2$var$metadataHandler(authWrapper, mappings)(xhr, text);
        else metadata = null;
        return new $0884ad7c76a0e4e2$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new $0884ad7c76a0e4e2$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $0884ad7c76a0e4e2$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @struct
 */ var $0884ad7c76a0e4e2$var$Observer = /** @class */ function() {
    function Observer(nextOrObserver, error, complete) {
        var asFunctions = $0884ad7c76a0e4e2$var$isFunction(nextOrObserver) || $0884ad7c76a0e4e2$var$isDef(error) || $0884ad7c76a0e4e2$var$isDef(complete);
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error || null;
            this.complete = complete || null;
        } else {
            var observer = nextOrObserver;
            this.next = observer.next || null;
            this.error = observer.error || null;
            this.complete = observer.complete || null;
        }
    }
    return Observer;
}();
var $0884ad7c76a0e4e2$var$UploadTaskSnapshot = /** @class */ function() {
    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
        this.bytesTransferred = bytesTransferred;
        this.totalBytes = totalBytes;
        this.state = state;
        this.metadata = metadata;
        this.task = task;
        this.ref = ref;
    }
    return UploadTaskSnapshot;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param name Name of the function.
 * @param specs Argument specs.
 * @param passed The actual arguments passed to the function.
 * @throws {fbs.Error} If the arguments are invalid.
 */ function $0884ad7c76a0e4e2$var$validate(name, specs, passed) {
    var minArgs = specs.length;
    var maxArgs = specs.length;
    for(var i = 0; i < specs.length; i++)if (specs[i].optional) {
        minArgs = i;
        break;
    }
    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
    if (!validLength) throw $0884ad7c76a0e4e2$var$invalidArgumentCount(minArgs, maxArgs, name, passed.length);
    for(var i = 0; i < passed.length; i++)try {
        specs[i].validator(passed[i]);
    } catch (e) {
        if (e instanceof Error) throw $0884ad7c76a0e4e2$var$invalidArgument(i, name, e.message);
        else throw $0884ad7c76a0e4e2$var$invalidArgument(i, name, e);
    }
}
/**
 * @struct
 */ var $0884ad7c76a0e4e2$var$ArgSpec = /** @class */ function() {
    function ArgSpec(validator, optional) {
        var self = this;
        this.validator = function(p) {
            if (self.optional && !$0884ad7c76a0e4e2$var$isJustDef(p)) return;
            validator(p);
        };
        this.optional = !!optional;
    }
    return ArgSpec;
}();
function $0884ad7c76a0e4e2$var$and_(v1, v2) {
    return function(p) {
        v1(p);
        v2(p);
    };
}
function $0884ad7c76a0e4e2$var$stringSpec(validator, optional) {
    function stringValidator(p) {
        if (!$0884ad7c76a0e4e2$var$isString(p)) throw 'Expected string.';
    }
    var chainedValidator;
    if (validator) chainedValidator = $0884ad7c76a0e4e2$var$and_(stringValidator, validator);
    else chainedValidator = stringValidator;
    return new $0884ad7c76a0e4e2$var$ArgSpec(chainedValidator, optional);
}
function $0884ad7c76a0e4e2$var$uploadDataSpec() {
    function validator(p) {
        var valid = p instanceof Uint8Array || p instanceof ArrayBuffer || $0884ad7c76a0e4e2$var$isNativeBlobDefined() && p instanceof Blob;
        if (!valid) throw 'Expected Blob or File.';
    }
    return new $0884ad7c76a0e4e2$var$ArgSpec(validator);
}
function $0884ad7c76a0e4e2$var$metadataSpec(optional) {
    return new $0884ad7c76a0e4e2$var$ArgSpec($0884ad7c76a0e4e2$var$metadataValidator, optional);
}
function $0884ad7c76a0e4e2$var$listOptionSpec(optional) {
    return new $0884ad7c76a0e4e2$var$ArgSpec($0884ad7c76a0e4e2$var$listOptionsValidator, optional);
}
function $0884ad7c76a0e4e2$var$nonNegativeNumberSpec() {
    function validator(p) {
        var valid = $0884ad7c76a0e4e2$var$isNumber(p) && p >= 0;
        if (!valid) throw 'Expected a number 0 or greater.';
    }
    return new $0884ad7c76a0e4e2$var$ArgSpec(validator);
}
function $0884ad7c76a0e4e2$var$looseObjectSpec(validator, optional) {
    function isLooseObjectValidator(p) {
        var isLooseObject = p === null || $0884ad7c76a0e4e2$var$isDef(p) && p instanceof Object;
        if (!isLooseObject) throw 'Expected an Object.';
        if (validator !== undefined && validator !== null) validator(p);
    }
    return new $0884ad7c76a0e4e2$var$ArgSpec(isLooseObjectValidator, optional);
}
function $0884ad7c76a0e4e2$var$nullFunctionSpec(optional) {
    function validator(p) {
        var valid = p === null || $0884ad7c76a0e4e2$var$isFunction(p);
        if (!valid) throw 'Expected a Function.';
    }
    return new $0884ad7c76a0e4e2$var$ArgSpec(validator, optional);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ function $0884ad7c76a0e4e2$var$async(f) {
    return function() {
        var argsToForward = [];
        for(var _i = 0; _i < arguments.length; _i++)argsToForward[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(function() {
            return f.apply(void 0, argsToForward);
        });
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 */ var $0884ad7c76a0e4e2$var$UploadTask = /** @class */ function() {
    /**
     * @param ref The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob The blob to upload.
     */ function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
        var _this = this;
        if (metadata === void 0) metadata = null;
        this.transferred_ = 0;
        this.needToFetchStatus_ = false;
        this.needToFetchMetadata_ = false;
        this.observers_ = [];
        this.error_ = null;
        this.uploadUrl_ = null;
        this.request_ = null;
        this.chunkMultiplier_ = 1;
        this.resolve_ = null;
        this.reject_ = null;
        this.ref_ = ref;
        this.authWrapper_ = authWrapper;
        this.location_ = location;
        this.blob_ = blob;
        this.metadata_ = metadata;
        this.mappings_ = mappings;
        this.resumable_ = this.shouldDoResumable_(this.blob_);
        this.state_ = $0884ad7c76a0e4e2$var$InternalTaskState.RUNNING;
        this.errorHandler_ = function(error) {
            _this.request_ = null;
            _this.chunkMultiplier_ = 1;
            if (error.codeEquals($0884ad7c76a0e4e2$var$Code.CANCELED)) {
                _this.needToFetchStatus_ = true;
                _this.completeTransitions_();
            } else {
                _this.error_ = error;
                _this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.ERROR);
            }
        };
        this.metadataErrorHandler_ = function(error) {
            _this.request_ = null;
            if (error.codeEquals($0884ad7c76a0e4e2$var$Code.CANCELED)) _this.completeTransitions_();
            else {
                _this.error_ = error;
                _this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.ERROR);
            }
        };
        this.promise_ = new Promise(function(resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this.promise_.then(null, function() {});
    }
    UploadTask.prototype.makeProgressCallback_ = function() {
        var _this = this;
        var sizeBefore = this.transferred_;
        return function(loaded) {
            return _this.updateProgress_(sizeBefore + loaded);
        };
    };
    UploadTask.prototype.shouldDoResumable_ = function(blob) {
        return blob.size() > 262144;
    };
    UploadTask.prototype.start_ = function() {
        if (this.state_ !== $0884ad7c76a0e4e2$var$InternalTaskState.RUNNING) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this.request_ !== null) return;
        if (this.resumable_) {
            if (this.uploadUrl_ === null) this.createResumable_();
            else {
                if (this.needToFetchStatus_) this.fetchStatus_();
                else if (this.needToFetchMetadata_) // Happens if we miss the metadata on upload completion.
                this.fetchMetadata_();
                else this.continueUpload_();
            }
        } else this.oneShotUpload_();
    };
    UploadTask.prototype.resolveToken_ = function(callback) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.authWrapper_.getAuthToken().then(function(authToken) {
            switch(_this.state_){
                case $0884ad7c76a0e4e2$var$InternalTaskState.RUNNING:
                    callback(authToken);
                    break;
                case $0884ad7c76a0e4e2$var$InternalTaskState.CANCELING:
                    _this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.CANCELED);
                    break;
                case $0884ad7c76a0e4e2$var$InternalTaskState.PAUSING:
                    _this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.PAUSED);
                    break;
            }
        });
    };
    // TODO(andysoto): assert false
    UploadTask.prototype.createResumable_ = function() {
        var _this = this;
        this.resolveToken_(function(authToken) {
            var requestInfo = $0884ad7c76a0e4e2$var$createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = createRequest;
            createRequest.getPromise().then(function(url) {
                _this.request_ = null;
                _this.uploadUrl_ = url;
                _this.needToFetchStatus_ = false;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.fetchStatus_ = function() {
        var _this = this;
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function(authToken) {
            var requestInfo = $0884ad7c76a0e4e2$var$getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = statusRequest;
            statusRequest.getPromise().then(function(status) {
                status;
                _this.request_ = null;
                _this.updateProgress_(status.current);
                _this.needToFetchStatus_ = false;
                if (status.finalized) _this.needToFetchMetadata_ = true;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.continueUpload_ = function() {
        var _this = this;
        var chunkSize = $0884ad7c76a0e4e2$var$resumableUploadChunkSize * this.chunkMultiplier_;
        var status = new $0884ad7c76a0e4e2$var$ResumableUploadStatus(this.transferred_, this.blob_.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function(authToken) {
            var requestInfo;
            try {
                requestInfo = $0884ad7c76a0e4e2$var$continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
            } catch (e) {
                _this.error_ = e;
                _this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.ERROR);
                return;
            }
            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = uploadRequest;
            uploadRequest.getPromise().then(function(newStatus) {
                _this.increaseMultiplier_();
                _this.request_ = null;
                _this.updateProgress_(newStatus.current);
                if (newStatus.finalized) {
                    _this.metadata_ = newStatus.metadata;
                    _this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.SUCCESS);
                } else _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.increaseMultiplier_ = function() {
        var currentSize = $0884ad7c76a0e4e2$var$resumableUploadChunkSize * this.chunkMultiplier_;
        // Max chunk size is 32M.
        if (currentSize < 33554432) this.chunkMultiplier_ *= 2;
    };
    UploadTask.prototype.fetchMetadata_ = function() {
        var _this = this;
        this.resolveToken_(function(authToken) {
            var requestInfo = $0884ad7c76a0e4e2$var$getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = metadataRequest;
            metadataRequest.getPromise().then(function(metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.SUCCESS);
            }, _this.metadataErrorHandler_);
        });
    };
    UploadTask.prototype.oneShotUpload_ = function() {
        var _this = this;
        this.resolveToken_(function(authToken) {
            var requestInfo = $0884ad7c76a0e4e2$var$multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = multipartRequest;
            multipartRequest.getPromise().then(function(metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.updateProgress_(_this.blob_.size());
                _this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.SUCCESS);
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.updateProgress_ = function(transferred) {
        var old = this.transferred_;
        this.transferred_ = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this.transferred_ !== old) this.notifyObservers_();
    };
    UploadTask.prototype.transition_ = function(state) {
        if (this.state_ === state) return;
        switch(state){
            case $0884ad7c76a0e4e2$var$InternalTaskState.CANCELING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                if (this.request_ !== null) this.request_.cancel();
                break;
            case $0884ad7c76a0e4e2$var$InternalTaskState.PAUSING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this.state_ = state;
                if (this.request_ !== null) this.request_.cancel();
                break;
            case $0884ad7c76a0e4e2$var$InternalTaskState.RUNNING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                var wasPaused = this.state_ === $0884ad7c76a0e4e2$var$InternalTaskState.PAUSED;
                this.state_ = state;
                if (wasPaused) {
                    this.notifyObservers_();
                    this.start_();
                }
                break;
            case $0884ad7c76a0e4e2$var$InternalTaskState.PAUSED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case $0884ad7c76a0e4e2$var$InternalTaskState.CANCELED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.error_ = $0884ad7c76a0e4e2$var$canceled();
                this.state_ = state;
                this.notifyObservers_();
                break;
            case $0884ad7c76a0e4e2$var$InternalTaskState.ERROR:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case $0884ad7c76a0e4e2$var$InternalTaskState.SUCCESS:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
        }
    };
    UploadTask.prototype.completeTransitions_ = function() {
        switch(this.state_){
            case $0884ad7c76a0e4e2$var$InternalTaskState.PAUSING:
                this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.PAUSED);
                break;
            case $0884ad7c76a0e4e2$var$InternalTaskState.CANCELING:
                this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.CANCELED);
                break;
            case $0884ad7c76a0e4e2$var$InternalTaskState.RUNNING:
                this.start_();
                break;
        }
    };
    Object.defineProperty(UploadTask.prototype, "snapshot", {
        get: function() {
            var externalState = $0884ad7c76a0e4e2$var$taskStateFromInternalTaskState(this.state_);
            return new $0884ad7c76a0e4e2$var$UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a callback for an event.
     * @param type The type of event to listen for.
     */ UploadTask.prototype.on = function(type, nextOrObserver, error, completed) {
        function typeValidator() {
            if (type !== $0884ad7c76a0e4e2$var$TaskEvent.STATE_CHANGED) throw "Expected one of the event types: [" + $0884ad7c76a0e4e2$var$TaskEvent.STATE_CHANGED + "].";
        }
        var nextOrObserverMessage = "Expected a function or an Object with one of `next`, `error`, `complete` properties.";
        var nextValidator = $0884ad7c76a0e4e2$var$nullFunctionSpec(true).validator;
        var observerValidator = $0884ad7c76a0e4e2$var$looseObjectSpec(null, true).validator;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function nextOrObserverValidator(p) {
            try {
                nextValidator(p);
                return;
            } catch (e) {}
            try {
                observerValidator(p);
                var anyDefined = $0884ad7c76a0e4e2$var$isJustDef(p['next']) || $0884ad7c76a0e4e2$var$isJustDef(p['error']) || $0884ad7c76a0e4e2$var$isJustDef(p['complete']);
                if (!anyDefined) throw '';
                return;
            } catch (e) {
                throw nextOrObserverMessage;
            }
        }
        var specs = [
            $0884ad7c76a0e4e2$var$stringSpec(typeValidator),
            $0884ad7c76a0e4e2$var$looseObjectSpec(nextOrObserverValidator, true),
            $0884ad7c76a0e4e2$var$nullFunctionSpec(true),
            $0884ad7c76a0e4e2$var$nullFunctionSpec(true)
        ];
        $0884ad7c76a0e4e2$var$validate('on', specs, arguments);
        var self = this;
        function makeBinder(specs) {
            function binder(nextOrObserver, error, complete) {
                if (specs !== null) $0884ad7c76a0e4e2$var$validate('on', specs, arguments);
                var observer = new $0884ad7c76a0e4e2$var$Observer(nextOrObserver, error, completed);
                self.addObserver_(observer);
                return function() {
                    self.removeObserver_(observer);
                };
            }
            return binder;
        }
        function binderNextOrObserverValidator(p) {
            if (p === null) throw nextOrObserverMessage;
            nextOrObserverValidator(p);
        }
        var binderSpecs = [
            $0884ad7c76a0e4e2$var$looseObjectSpec(binderNextOrObserverValidator),
            $0884ad7c76a0e4e2$var$nullFunctionSpec(true),
            $0884ad7c76a0e4e2$var$nullFunctionSpec(true)
        ];
        var typeOnly = !($0884ad7c76a0e4e2$var$isJustDef(nextOrObserver) || $0884ad7c76a0e4e2$var$isJustDef(error) || $0884ad7c76a0e4e2$var$isJustDef(completed));
        if (typeOnly) return makeBinder(binderSpecs);
        else return makeBinder(null)(nextOrObserver, error, completed);
    };
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
     * @param onRejected The rejection callback.
     */ UploadTask.prototype.then = function(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this.promise_.then(onFulfilled, onRejected);
    };
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ UploadTask.prototype.catch = function(onRejected) {
        return this.then(null, onRejected);
    };
    /**
     * Adds the given observer.
     */ UploadTask.prototype.addObserver_ = function(observer) {
        this.observers_.push(observer);
        this.notifyObserver_(observer);
    };
    /**
     * Removes the given observer.
     */ UploadTask.prototype.removeObserver_ = function(observer) {
        var i = this.observers_.indexOf(observer);
        if (i !== -1) this.observers_.splice(i, 1);
    };
    UploadTask.prototype.notifyObservers_ = function() {
        var _this = this;
        this.finishPromise_();
        var observers = this.observers_.slice();
        observers.forEach(function(observer) {
            _this.notifyObserver_(observer);
        });
    };
    UploadTask.prototype.finishPromise_ = function() {
        if (this.resolve_ !== null) {
            var triggered = true;
            switch($0884ad7c76a0e4e2$var$taskStateFromInternalTaskState(this.state_)){
                case $0884ad7c76a0e4e2$var$TaskState.SUCCESS:
                    $0884ad7c76a0e4e2$var$async(this.resolve_.bind(null, this.snapshot))();
                    break;
                case $0884ad7c76a0e4e2$var$TaskState.CANCELED:
                case $0884ad7c76a0e4e2$var$TaskState.ERROR:
                    var toCall = this.reject_;
                    $0884ad7c76a0e4e2$var$async(toCall.bind(null, this.error_))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this.resolve_ = null;
                this.reject_ = null;
            }
        }
    };
    UploadTask.prototype.notifyObserver_ = function(observer) {
        var externalState = $0884ad7c76a0e4e2$var$taskStateFromInternalTaskState(this.state_);
        switch(externalState){
            case $0884ad7c76a0e4e2$var$TaskState.RUNNING:
            case $0884ad7c76a0e4e2$var$TaskState.PAUSED:
                if (observer.next) $0884ad7c76a0e4e2$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $0884ad7c76a0e4e2$var$TaskState.SUCCESS:
                if (observer.complete) $0884ad7c76a0e4e2$var$async(observer.complete.bind(observer))();
                break;
            case $0884ad7c76a0e4e2$var$TaskState.CANCELED:
            case $0884ad7c76a0e4e2$var$TaskState.ERROR:
                if (observer.error) $0884ad7c76a0e4e2$var$async(observer.error.bind(observer, this.error_))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $0884ad7c76a0e4e2$var$async(observer.error.bind(observer, this.error_))();
        }
    };
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @return True if the operation took effect, false if ignored.
     */ UploadTask.prototype.resume = function() {
        $0884ad7c76a0e4e2$var$validate('resume', [], arguments);
        var valid = this.state_ === $0884ad7c76a0e4e2$var$InternalTaskState.PAUSED || this.state_ === $0884ad7c76a0e4e2$var$InternalTaskState.PAUSING;
        if (valid) this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.RUNNING);
        return valid;
    };
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @return True if the operation took effect, false if ignored.
     */ UploadTask.prototype.pause = function() {
        $0884ad7c76a0e4e2$var$validate('pause', [], arguments);
        var valid = this.state_ === $0884ad7c76a0e4e2$var$InternalTaskState.RUNNING;
        if (valid) this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.PAUSING);
        return valid;
    };
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @return True if the operation took effect, false if ignored.
     */ UploadTask.prototype.cancel = function() {
        $0884ad7c76a0e4e2$var$validate('cancel', [], arguments);
        var valid = this.state_ === $0884ad7c76a0e4e2$var$InternalTaskState.RUNNING || this.state_ === $0884ad7c76a0e4e2$var$InternalTaskState.PAUSING;
        if (valid) this.transition_($0884ad7c76a0e4e2$var$InternalTaskState.CANCELING);
        return valid;
    };
    return UploadTask;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @param location An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ var $0884ad7c76a0e4e2$var$Reference = /** @class */ function() {
    function Reference(authWrapper, location) {
        this.authWrapper = authWrapper;
        if (location instanceof $0884ad7c76a0e4e2$var$Location) this.location = location;
        else this.location = $0884ad7c76a0e4e2$var$Location.makeFromUrl(location);
    }
    /**
     * @return The URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ Reference.prototype.toString = function() {
        $0884ad7c76a0e4e2$var$validate('toString', [], arguments);
        return 'gs://' + this.location.bucket + '/' + this.location.path;
    };
    Reference.prototype.newRef = function(authWrapper, location) {
        return new Reference(authWrapper, location);
    };
    Reference.prototype.mappings = function() {
        return $0884ad7c76a0e4e2$var$getMappings();
    };
    /**
     * @return A reference to the object obtained by
     *     appending childPath, removing any duplicate, beginning, or trailing
     *     slashes.
     */ Reference.prototype.child = function(childPath) {
        $0884ad7c76a0e4e2$var$validate('child', [
            $0884ad7c76a0e4e2$var$stringSpec()
        ], arguments);
        var newPath = $0884ad7c76a0e4e2$var$child(this.location.path, childPath);
        var location = new $0884ad7c76a0e4e2$var$Location(this.location.bucket, newPath);
        return this.newRef(this.authWrapper, location);
    };
    Object.defineProperty(Reference.prototype, "parent", {
        /**
         * @return A reference to the parent of the
         *     current object, or null if the current object is the root.
         */ get: function() {
            var newPath = $0884ad7c76a0e4e2$var$parent(this.location.path);
            if (newPath === null) return null;
            var location = new $0884ad7c76a0e4e2$var$Location(this.location.bucket, newPath);
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        /**
         * @return An reference to the root of this
         *     object's bucket.
         */ get: function() {
            var location = new $0884ad7c76a0e4e2$var$Location(this.location.bucket, '');
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "bucket", {
        get: function() {
            return this.location.bucket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "fullPath", {
        get: function() {
            return this.location.path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "name", {
        get: function() {
            return $0884ad7c76a0e4e2$var$lastComponent(this.location.path);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "storage", {
        get: function() {
            return this.authWrapper.service();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Uploads a blob to this object's location.
     * @param data The blob to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */ Reference.prototype.put = function(data, metadata) {
        if (metadata === void 0) metadata = null;
        $0884ad7c76a0e4e2$var$validate('put', [
            $0884ad7c76a0e4e2$var$uploadDataSpec(),
            $0884ad7c76a0e4e2$var$metadataSpec(true)
        ], arguments);
        this.throwIfRoot_('put');
        return new $0884ad7c76a0e4e2$var$UploadTask(this, this.authWrapper, this.location, this.mappings(), new $0884ad7c76a0e4e2$var$FbsBlob(data), metadata);
    };
    /**
     * Uploads a string to this object's location.
     * @param value The string to upload.
     * @param format The format of the string to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */ Reference.prototype.putString = function(value, format, metadata) {
        if (format === void 0) format = $0884ad7c76a0e4e2$var$StringFormat.RAW;
        $0884ad7c76a0e4e2$var$validate('putString', [
            $0884ad7c76a0e4e2$var$stringSpec(),
            $0884ad7c76a0e4e2$var$stringSpec($0884ad7c76a0e4e2$var$formatValidator, true),
            $0884ad7c76a0e4e2$var$metadataSpec(true)
        ], arguments);
        this.throwIfRoot_('putString');
        var data = $0884ad7c76a0e4e2$var$dataFromString(format, value);
        var metadataClone = Object.assign({}, metadata);
        if (!$0884ad7c76a0e4e2$var$isDef(metadataClone['contentType']) && $0884ad7c76a0e4e2$var$isDef(data.contentType)) metadataClone['contentType'] = data.contentType;
        return new $0884ad7c76a0e4e2$var$UploadTask(this, this.authWrapper, this.location, this.mappings(), new $0884ad7c76a0e4e2$var$FbsBlob(data.data, true), metadataClone);
    };
    /**
     * Deletes the object at this location.
     * @return A promise that resolves if the deletion succeeds.
     */ Reference.prototype.delete = function() {
        var _this = this;
        $0884ad7c76a0e4e2$var$validate('delete', [], arguments);
        this.throwIfRoot_('delete');
        return this.authWrapper.getAuthToken().then(function(authToken) {
            var requestInfo = $0884ad7c76a0e4e2$var$deleteObject(_this.authWrapper, _this.location);
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * List all items (files) and prefixes (folders) under this storage reference.
     *
     * This is a helper method for calling list() repeatedly until there are
     * no more results. The default pagination size is 1000.
     *
     * Note: The results may not be consistent if objects are changed while this
     * operation is running.
     *
     * Warning: listAll may potentially consume too many resources if there are
     * too many results.
     *
     * @return A Promise that resolves with all the items and prefixes under
     *      the current storage reference. `prefixes` contains references to
     *      sub-directories and `items` contains references to objects in this
     *      folder. `nextPageToken` is never returned.
     */ Reference.prototype.listAll = function() {
        $0884ad7c76a0e4e2$var$validate('listAll', [], arguments);
        var accumulator = {
            prefixes: [],
            items: []
        };
        return this.listAllHelper(accumulator).then(function() {
            return accumulator;
        });
    };
    Reference.prototype.listAllHelper = function(accumulator, pageToken) {
        return (0, $lEepN.__awaiter)(this, void 0, void 0, function() {
            var opt, nextPage;
            var _a, _b;
            return (0, $lEepN.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        opt = {
                            // maxResults is 1000 by default.
                            pageToken: pageToken
                        };
                        return [
                            4 /*yield*/ ,
                            this.list(opt)
                        ];
                    case 1:
                        nextPage = _c.sent();
                        (_a = accumulator.prefixes).push.apply(_a, nextPage.prefixes);
                        (_b = accumulator.items).push.apply(_b, nextPage.items);
                        if (!(nextPage.nextPageToken != null)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.listAllHelper(accumulator, nextPage.nextPageToken)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * List items (files) and prefixes (folders) under this storage reference.
     *
     * List API is only available for Firebase Rules Version 2.
     *
     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
     * delimited folder structure.
     * Refer to GCS's List API if you want to learn more.
     *
     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
     * support objects whose paths end with "/" or contain two consecutive
     * "/"s. Firebase Storage List API will filter these unsupported objects.
     * list() may fail if there are too many unsupported objects in the bucket.
     *
     * @param options See ListOptions for details.
     * @return A Promise that resolves with the items and prefixes.
     *      `prefixes` contains references to sub-folders and `items`
     *      contains references to objects in this folder. `nextPageToken`
     *      can be used to get the rest of the results.
     */ Reference.prototype.list = function(options) {
        $0884ad7c76a0e4e2$var$validate('list', [
            $0884ad7c76a0e4e2$var$listOptionSpec(true)
        ], arguments);
        var self = this;
        return this.authWrapper.getAuthToken().then(function(authToken) {
            var op = options || {};
            var requestInfo = $0884ad7c76a0e4e2$var$list(self.authWrapper, self.location, /*delimiter= */ '/', op.pageToken, op.maxResults);
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     *     A promise that resolves with the metadata for this object. If this
     *     object doesn't exist or metadata cannot be retreived, the promise is
     *     rejected.
     */ Reference.prototype.getMetadata = function() {
        var _this = this;
        $0884ad7c76a0e4e2$var$validate('getMetadata', [], arguments);
        this.throwIfRoot_('getMetadata');
        return this.authWrapper.getAuthToken().then(function(authToken) {
            var requestInfo = $0884ad7c76a0e4e2$var$getMetadata(_this.authWrapper, _this.location, _this.mappings());
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * Updates the metadata for this object.
     * @param metadata The new metadata for the object.
     *     Only values that have been explicitly set will be changed. Explicitly
     *     setting a value to null will remove the metadata.
     * @return A promise that resolves
     *     with the new metadata for this object.
     *     @see firebaseStorage.Reference.prototype.getMetadata
     */ Reference.prototype.updateMetadata = function(metadata) {
        var _this = this;
        $0884ad7c76a0e4e2$var$validate('updateMetadata', [
            $0884ad7c76a0e4e2$var$metadataSpec()
        ], arguments);
        this.throwIfRoot_('updateMetadata');
        return this.authWrapper.getAuthToken().then(function(authToken) {
            var requestInfo = $0884ad7c76a0e4e2$var$updateMetadata(_this.authWrapper, _this.location, metadata, _this.mappings());
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * @return A promise that resolves with the download
     *     URL for this object.
     */ Reference.prototype.getDownloadURL = function() {
        var _this = this;
        $0884ad7c76a0e4e2$var$validate('getDownloadURL', [], arguments);
        this.throwIfRoot_('getDownloadURL');
        return this.authWrapper.getAuthToken().then(function(authToken) {
            var requestInfo = $0884ad7c76a0e4e2$var$getDownloadUrl(_this.authWrapper, _this.location, _this.mappings());
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise().then(function(url) {
                if (url === null) throw $0884ad7c76a0e4e2$var$noDownloadURL();
                return url;
            });
        });
    };
    Reference.prototype.throwIfRoot_ = function(name) {
        if (this.location.path === '') throw $0884ad7c76a0e4e2$var$invalidRootOperation(name);
    };
    return Reference;
}();
/**
 * A request whose promise always fails.
 * @struct
 * @template T
 */ var $0884ad7c76a0e4e2$var$FailRequest = /** @class */ function() {
    function FailRequest(error) {
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ FailRequest.prototype.getPromise = function() {
        return this.promise_;
    };
    /** @inheritDoc */ FailRequest.prototype.cancel = function(_appDelete) {};
    return FailRequest;
}();
var $0884ad7c76a0e4e2$var$RequestMap = /** @class */ function() {
    function RequestMap() {
        this.map = new Map();
        this.id = $0884ad7c76a0e4e2$var$MIN_SAFE_INTEGER;
    }
    /**
     * Registers the given request with this map.
     * The request is unregistered when it completes.
     *
     * @param request The request to register.
     */ RequestMap.prototype.addRequest = function(request) {
        var _this = this;
        var id = this.id;
        this.id++;
        this.map.set(id, request);
        request.getPromise().then(function() {
            return _this.map.delete(id);
        }, function() {
            return _this.map.delete(id);
        });
    };
    /**
     * Cancels all registered requests.
     */ RequestMap.prototype.clear = function() {
        this.map.forEach(function(v) {
            v && v.cancel(true);
        });
        this.map.clear();
    };
    return RequestMap;
}();
/**
 * @param app If null, getAuthToken always resolves with null.
 * @param service The storage service associated with this auth wrapper.
 *     Untyped to avoid circular type dependencies.
 * @struct
 */ var $0884ad7c76a0e4e2$var$AuthWrapper = /** @class */ function() {
    function AuthWrapper(app, authProvider, maker, requestMaker, service, pool) {
        var _a;
        this.bucket_ = null;
        this.appId_ = null;
        this.deleted_ = false;
        this.app_ = app;
        if (this.app_ !== null) {
            var options = this.app_.options;
            if ($0884ad7c76a0e4e2$var$isDef(options)) {
                this.bucket_ = AuthWrapper.extractBucket_(options);
                this.appId_ = (_a = options.appId) !== null && _a !== void 0 ? _a : null;
            }
        }
        this.authProvider_ = authProvider;
        this.storageRefMaker_ = maker;
        this.requestMaker_ = requestMaker;
        this.pool_ = pool;
        this.service_ = service;
        this.maxOperationRetryTime_ = $0884ad7c76a0e4e2$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this.maxUploadRetryTime_ = $0884ad7c76a0e4e2$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this.requestMap_ = new $0884ad7c76a0e4e2$var$RequestMap();
    }
    AuthWrapper.extractBucket_ = function(config) {
        var bucketString = config[$0884ad7c76a0e4e2$var$CONFIG_STORAGE_BUCKET_KEY] || null;
        if (bucketString == null) return null;
        var loc = $0884ad7c76a0e4e2$var$Location.makeFromBucketSpec(bucketString);
        return loc.bucket;
    };
    AuthWrapper.prototype.getAuthToken = function() {
        var auth = this.authProvider_.getImmediate({
            optional: true
        });
        if (auth) return auth.getToken().then(function(response) {
            if (response !== null) return response.accessToken;
            else return null;
        }, function() {
            return null;
        });
        else return Promise.resolve(null);
    };
    AuthWrapper.prototype.bucket = function() {
        if (this.deleted_) throw $0884ad7c76a0e4e2$var$appDeleted();
        else return this.bucket_;
    };
    /**
     * The service associated with this auth wrapper. Untyped to avoid circular
     * type dependencies.
     */ AuthWrapper.prototype.service = function() {
        return this.service_;
    };
    /**
     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
     * at the given Location.
     * @param loc The Location.
     * @return Actually a firebaseStorage.Reference, typing not allowed
     *     because of circular dependency problems.
     */ AuthWrapper.prototype.makeStorageReference = function(loc) {
        return this.storageRefMaker_(this, loc);
    };
    AuthWrapper.prototype.makeRequest = function(requestInfo, authToken) {
        if (!this.deleted_) {
            var request = this.requestMaker_(requestInfo, this.appId_, authToken, this.pool_);
            this.requestMap_.addRequest(request);
            return request;
        } else return new $0884ad7c76a0e4e2$var$FailRequest($0884ad7c76a0e4e2$var$appDeleted());
    };
    /**
     * Stop running requests and prevent more from being created.
     */ AuthWrapper.prototype.deleteApp = function() {
        this.deleted_ = true;
        this.app_ = null;
        this.requestMap_.clear();
    };
    AuthWrapper.prototype.maxUploadRetryTime = function() {
        return this.maxUploadRetryTime_;
    };
    AuthWrapper.prototype.setMaxUploadRetryTime = function(time) {
        this.maxUploadRetryTime_ = time;
    };
    AuthWrapper.prototype.maxOperationRetryTime = function() {
        return this.maxOperationRetryTime_;
    };
    AuthWrapper.prototype.setMaxOperationRetryTime = function(time) {
        this.maxOperationRetryTime_ = time;
    };
    return AuthWrapper;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */ function $0884ad7c76a0e4e2$var$start(f, callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var timeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
    // the no-explicit-any rule when ESlint releases it.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function triggerCallback() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        timeoutId = setTimeout(function() {
            timeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
    // the no-explicit-any rule when ESlint releases it.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handler(success) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (triggeredCallback) return;
        if (success) {
            triggerCallback.call.apply(triggerCallback, (0, $lEepN.__spreadArrays)([
                null,
                success
            ], args));
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            triggerCallback.call.apply(triggerCallback, (0, $lEepN.__spreadArrays)([
                null,
                success
            ], args));
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        if (triggeredCallback) return;
        if (timeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(timeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    setTimeout(function() {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $0884ad7c76a0e4e2$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @struct
 * @template T
 */ var $0884ad7c76a0e4e2$var$NetworkRequest = /** @class */ function() {
    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
        var _this = this;
        this.pendingXhr_ = null;
        this.backoffId_ = null;
        this.resolve_ = null;
        this.reject_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.url_ = url;
        this.method_ = method;
        this.headers_ = headers;
        this.body_ = body;
        this.successCodes_ = successCodes.slice();
        this.additionalRetryCodes_ = additionalRetryCodes.slice();
        this.callback_ = callback;
        this.errorCallback_ = errorCallback;
        this.progressCallback_ = progressCallback;
        this.timeout_ = timeout;
        this.pool_ = pool;
        this.promise_ = new Promise(function(resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ NetworkRequest.prototype.start_ = function() {
        var self = this;
        function doTheRequest(backoffCallback, canceled) {
            if (canceled) {
                backoffCallback(false, new $0884ad7c76a0e4e2$var$RequestEndStatus(false, null, true));
                return;
            }
            var xhr = self.pool_.createXhrIo();
            self.pendingXhr_ = xhr;
            function progressListener(progressEvent) {
                var loaded = progressEvent.loaded;
                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (self.progressCallback_ !== null) self.progressCallback_(loaded, total);
            }
            if (self.progressCallback_ !== null) xhr.addUploadProgressListener(progressListener);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            xhr.send(self.url_, self.method_, self.body_, self.headers_).then(function(xhr) {
                if (self.progressCallback_ !== null) xhr.removeUploadProgressListener(progressListener);
                self.pendingXhr_ = null;
                xhr;
                var hitServer = xhr.getErrorCode() === $0884ad7c76a0e4e2$var$ErrorCode.NO_ERROR;
                var status = xhr.getStatus();
                if (!hitServer || self.isRetryStatusCode_(status)) {
                    var wasCanceled = xhr.getErrorCode() === $0884ad7c76a0e4e2$var$ErrorCode.ABORT;
                    backoffCallback(false, new $0884ad7c76a0e4e2$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                var successCode = self.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $0884ad7c76a0e4e2$var$RequestEndStatus(successCode, xhr));
            });
        }
        /**
         * @param requestWentThrough True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ function backoffDone(requestWentThrough, status) {
            var resolve = self.resolve_;
            var reject = self.reject_;
            var xhr = status.xhr;
            if (status.wasSuccessCode) try {
                var result = self.callback_(xhr, xhr.getResponseText());
                if ($0884ad7c76a0e4e2$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (xhr !== null) {
                    var err = $0884ad7c76a0e4e2$var$unknown();
                    err.setServerResponseProp(xhr.getResponseText());
                    if (self.errorCallback_) reject(self.errorCallback_(xhr, err));
                    else reject(err);
                } else if (status.canceled) {
                    var err = self.appDelete_ ? $0884ad7c76a0e4e2$var$appDeleted() : $0884ad7c76a0e4e2$var$canceled();
                    reject(err);
                } else {
                    var err = $0884ad7c76a0e4e2$var$retryLimitExceeded();
                    reject(err);
                }
            }
        }
        if (this.canceled_) backoffDone(false, new $0884ad7c76a0e4e2$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $0884ad7c76a0e4e2$var$start(doTheRequest, backoffDone, this.timeout_);
    };
    /** @inheritDoc */ NetworkRequest.prototype.getPromise = function() {
        return this.promise_;
    };
    /** @inheritDoc */ NetworkRequest.prototype.cancel = function(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $0884ad7c76a0e4e2$var$stop(this.backoffId_);
        if (this.pendingXhr_ !== null) this.pendingXhr_.abort();
    };
    NetworkRequest.prototype.isRetryStatusCode_ = function(status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        var isFiveHundredCode = status >= 500 && status < 600;
        var extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
        var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    };
    return NetworkRequest;
}();
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled Defaults to false.
 * @struct
 */ var $0884ad7c76a0e4e2$var$RequestEndStatus = /** @class */ function() {
    function RequestEndStatus(wasSuccessCode, xhr, canceled) {
        this.wasSuccessCode = wasSuccessCode;
        this.xhr = xhr;
        this.canceled = !!canceled;
    }
    return RequestEndStatus;
}();
function $0884ad7c76a0e4e2$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $0884ad7c76a0e4e2$var$addVersionHeader_(headers) {
    var version = typeof (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))) !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION : 'AppManager';
    headers['X-Firebase-Storage-Version'] = 'webjs/' + version;
}
function $0884ad7c76a0e4e2$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
/**
 * @template T
 */ function $0884ad7c76a0e4e2$var$makeRequest(requestInfo, appId, authToken, pool) {
    var queryPart = $0884ad7c76a0e4e2$var$makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = Object.assign({}, requestInfo.headers);
    $0884ad7c76a0e4e2$var$addGmpidHeader_(headers, appId);
    $0884ad7c76a0e4e2$var$addAuthHeader_(headers, authToken);
    $0884ad7c76a0e4e2$var$addVersionHeader_(headers);
    return new $0884ad7c76a0e4e2$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 *
 * @struct
 */ var $0884ad7c76a0e4e2$var$Service = /** @class */ function() {
    function Service(app, authProvider, pool, url) {
        this.bucket_ = null;
        function maker(authWrapper, loc) {
            return new $0884ad7c76a0e4e2$var$Reference(authWrapper, loc);
        }
        this.authWrapper_ = new $0884ad7c76a0e4e2$var$AuthWrapper(app, authProvider, maker, $0884ad7c76a0e4e2$var$makeRequest, this, pool);
        this.app_ = app;
        if (url != null) this.bucket_ = $0884ad7c76a0e4e2$var$Location.makeFromBucketSpec(url);
        else {
            var authWrapperBucket = this.authWrapper_.bucket();
            if (authWrapperBucket != null) this.bucket_ = new $0884ad7c76a0e4e2$var$Location(authWrapperBucket, '');
        }
        this.internals_ = new $0884ad7c76a0e4e2$var$ServiceInternals(this);
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */ Service.prototype.ref = function(path) {
        function validator(path) {
            if (typeof path !== 'string') throw 'Path is not a string.';
            if (/^[A-Za-z]+:\/\//.test(path)) throw 'Expected child path but got a URL, use refFromURL instead.';
        }
        $0884ad7c76a0e4e2$var$validate('ref', [
            $0884ad7c76a0e4e2$var$stringSpec(validator, true)
        ], arguments);
        if (this.bucket_ == null) throw new Error('No Storage Bucket defined in Firebase Options.');
        var ref = new $0884ad7c76a0e4e2$var$Reference(this.authWrapper_, this.bucket_);
        if (path != null) return ref.child(path);
        else return ref;
    };
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */ Service.prototype.refFromURL = function(url) {
        function validator(p) {
            if (typeof p !== 'string') throw 'Path is not a string.';
            if (!/^[A-Za-z]+:\/\//.test(p)) throw 'Expected full URL but got a child path, use ref instead.';
            try {
                $0884ad7c76a0e4e2$var$Location.makeFromUrl(p);
            } catch (e) {
                throw 'Expected valid full URL but got an invalid one.';
            }
        }
        $0884ad7c76a0e4e2$var$validate('refFromURL', [
            $0884ad7c76a0e4e2$var$stringSpec(validator, false)
        ], arguments);
        return new $0884ad7c76a0e4e2$var$Reference(this.authWrapper_, url);
    };
    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
        get: function() {
            return this.authWrapper_.maxUploadRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxUploadRetryTime = function(time) {
        $0884ad7c76a0e4e2$var$validate('setMaxUploadRetryTime', [
            $0884ad7c76a0e4e2$var$nonNegativeNumberSpec()
        ], arguments);
        this.authWrapper_.setMaxUploadRetryTime(time);
    };
    Service.prototype.setMaxOperationRetryTime = function(time) {
        $0884ad7c76a0e4e2$var$validate('setMaxOperationRetryTime', [
            $0884ad7c76a0e4e2$var$nonNegativeNumberSpec()
        ], arguments);
        this.authWrapper_.setMaxOperationRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "app", {
        get: function() {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "INTERNAL", {
        get: function() {
            return this.internals_;
        },
        enumerable: true,
        configurable: true
    });
    return Service;
}();
/**
 * @struct
 */ var $0884ad7c76a0e4e2$var$ServiceInternals = /** @class */ function() {
    function ServiceInternals(service) {
        this.service_ = service;
    }
    /**
     * Called when the associated app is deleted.
     * @see {!fbs.AuthWrapper.prototype.deleteApp}
     */ ServiceInternals.prototype.delete = function() {
        this.service_.authWrapper_.deleteApp();
        return Promise.resolve();
    };
    return ServiceInternals;
}();
var $0884ad7c76a0e4e2$var$name = "@firebase/storage";
var $0884ad7c76a0e4e2$var$version = "0.3.34";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ var $0884ad7c76a0e4e2$var$STORAGE_TYPE = 'storage';
function $0884ad7c76a0e4e2$var$factory(container, url) {
    // Dependencies
    var app = container.getProvider('app').getImmediate();
    var authProvider = container.getProvider('auth-internal');
    return new $0884ad7c76a0e4e2$var$Service(app, authProvider, new $0884ad7c76a0e4e2$var$XhrIoPool(), url);
}
function $0884ad7c76a0e4e2$export$ba90a1fa1905b39e(instance) {
    var namespaceExports = {
        // no-inline
        TaskState: $0884ad7c76a0e4e2$var$TaskState,
        TaskEvent: $0884ad7c76a0e4e2$var$TaskEvent,
        StringFormat: $0884ad7c76a0e4e2$var$StringFormat,
        Storage: $0884ad7c76a0e4e2$var$Service,
        Reference: $0884ad7c76a0e4e2$var$Reference
    };
    instance.INTERNAL.registerComponent(new (0, $9Cwol.Component)($0884ad7c76a0e4e2$var$STORAGE_TYPE, $0884ad7c76a0e4e2$var$factory, "PUBLIC" /* PUBLIC */ ).setServiceProps(namespaceExports).setMultipleInstances(true));
    instance.registerVersion($0884ad7c76a0e4e2$var$name, $0884ad7c76a0e4e2$var$version);
}
$0884ad7c76a0e4e2$export$ba90a1fa1905b39e((0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))));

});
parcelRegister("lEepN", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $fc2883ef084d3388$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $fc2883ef084d3388$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArrays", () => $fc2883ef084d3388$export$6388937ca91ccae8);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $fc2883ef084d3388$var$extendStatics = function(d, b) {
    $fc2883ef084d3388$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $fc2883ef084d3388$var$extendStatics(d, b);
};
function $fc2883ef084d3388$export$a8ba968b8961cb8a(d, b) {
    $fc2883ef084d3388$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc2883ef084d3388$export$18ce0697a983be9b = function() {
    $fc2883ef084d3388$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc2883ef084d3388$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc2883ef084d3388$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc2883ef084d3388$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc2883ef084d3388$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc2883ef084d3388$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc2883ef084d3388$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc2883ef084d3388$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $fc2883ef084d3388$export$f33643c0debef087(m, exports) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $fc2883ef084d3388$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc2883ef084d3388$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc2883ef084d3388$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc2883ef084d3388$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc2883ef084d3388$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc2883ef084d3388$export$10c90e4f7922046c(v) {
    return this instanceof $fc2883ef084d3388$export$10c90e4f7922046c ? (this.v = v, this) : new $fc2883ef084d3388$export$10c90e4f7922046c(v);
}
function $fc2883ef084d3388$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc2883ef084d3388$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc2883ef084d3388$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc2883ef084d3388$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc2883ef084d3388$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc2883ef084d3388$export$19a8beecd37a4c45 === "function" ? $fc2883ef084d3388$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc2883ef084d3388$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $fc2883ef084d3388$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $fc2883ef084d3388$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc2883ef084d3388$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $fc2883ef084d3388$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});




parcelRegister("adRKk", function(module, exports) {

$parcel$export(module.exports, "TeamsService", () => $aada282a550e91ef$export$2716fc695a86a6b3);

var $deWeK = parcelRequire("deWeK");

var $6OCAO = parcelRequire("6OCAO");

var $anJpe = parcelRequire("anJpe");

var $1t8Wn = parcelRequire("1t8Wn");

var $gawXH = parcelRequire("gawXH");

var $7X6iT = parcelRequire("7X6iT");
class $aada282a550e91ef$export$2716fc695a86a6b3 extends (0, $7X6iT.BaseGraphqlService) {
    updateTeams(team) {
        this.removeTeam(team);
        this.addTeam(team);
    }
    loadTeams(team) {
        this.store.dispatch((0, $6OCAO.loadTeams)(team));
    }
    addTeam(team) {
        this.store.dispatch((0, $6OCAO.addTeam)(team));
    }
    removeTeam(team) {
        this.store.dispatch((0, $6OCAO.removeTeam)({
            id: team.id
        }));
    }
    deleteTeam(id) {
        event.preventDefault();
        event.stopPropagation();
        return this.mutate({
            mutation: 'delete-team.mutation.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.deleteTeam));
    }
    subscribeToTeamCreation() {
        return this.subscribe({
            query: 'create-team.subscription.graphql'
        }).pipe((0, $gawXH.map)((res)=>res.data.subscribeToCreateTeam));
    }
    listTeams() {
        return this.query({
            query: 'list-team.query.graphql'
        }).pipe((0, $gawXH.map)((res)=>res.data.listTeams));
    }
    createTeam() {
        return this.mutate({
            mutation: 'create-team.mutation.graphql',
            variables: {
                name: name
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.createTeam));
    }
    constructor(...args){
        super(...args), this.$teams = this.store.select((state)=>state.teams);
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $anJpe.AppState))
], $aada282a550e91ef$export$2716fc695a86a6b3.prototype, "store", void 0);
$aada282a550e91ef$export$2716fc695a86a6b3 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $aada282a550e91ef$export$2716fc695a86a6b3);

});

parcelRegister("kOwTj", function(module, exports) {

$parcel$export(module.exports, "UIComponentsService", () => $9db1572d3e468016$export$e9955c0c9a1e341e);

var $deWeK = parcelRequire("deWeK");

var $6OCAO = parcelRequire("6OCAO");

var $anJpe = parcelRequire("anJpe");

var $1t8Wn = parcelRequire("1t8Wn");

var $4iuNN = parcelRequire("4iuNN");
class $9db1572d3e468016$export$e9955c0c9a1e341e {
    subscribe() {
        this.unsubscribe();
        this.sub = (0, $4iuNN.interval)(1000).subscribe(()=>{
            this.addComponent({
                description: `
    An evolving set of free, open source web components for building mobile and desktop web
    applications in modern browsers.
    `,
                id: String(this.count++),
                items: 51,
                namespace: '2',
                owner: 'HTMLELements'
            });
        });
    }
    unsubscribe() {
        if (this.sub) this.sub.unsubscribe();
    }
    updateComponents(component) {
        this.removeComponent(component);
        this.addComponent(component);
    }
    loadComponents(components) {
        this.store.dispatch((0, $6OCAO.loadComponents)(components));
    }
    addComponent(component) {
        this.store.dispatch((0, $6OCAO.addComponent)(component));
    }
    removeComponent(component) {
        this.store.dispatch((0, $6OCAO.removeComponent)({
            id: component.id
        }));
    }
    constructor(){
        this.$components = this.store.select((state)=>state.components);
        this.count = 0;
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $anJpe.AppState))
], $9db1572d3e468016$export$e9955c0c9a1e341e.prototype, "store", void 0);
$9db1572d3e468016$export$e9955c0c9a1e341e = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $9db1572d3e468016$export$e9955c0c9a1e341e);

});
parcelRegister("4iuNN", function(module, exports) {

$parcel$export(module.exports, "interval", () => $3210bc88ffddd075$export$3174cdbf0a0cbc84);

var $8fD1K = parcelRequire("8fD1K");

var $gTQqg = parcelRequire("gTQqg");
function $3210bc88ffddd075$export$3174cdbf0a0cbc84(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, $8fD1K.asyncScheduler);
    if (period < 0) period = 0;
    return (0, $gTQqg.timer)(period, period, scheduler);
}

});


parcelRegister("4Xutv", function(module, exports) {

$parcel$export(module.exports, "UserScopeService", () => $970f334824668c34$export$254161f9c6172d5d);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $gawXH = parcelRequire("gawXH");
var $d5Aat = parcelRequire("d5Aat");

var $be29e = parcelRequire("be29e");
class $970f334824668c34$export$254161f9c6172d5d {
    canViewProfileSession() {
        return this.userService.getUserOnce().pipe((0, $gawXH.map)((u)=>!!u.scopes?.includes('CAN_VIEW_PROFILE_SESSIONS')));
    }
    canListAllUsers() {
        return this.userService.getUserOnce().pipe((0, $gawXH.map)((u)=>!!u.scopes?.includes('CAN_LIST_ALL_USERS')));
    }
    canViewApps() {
        return this.userService.getUserOnce().pipe((0, $d5Aat.take)(1), (0, $gawXH.map)((u)=>!!u.scopes?.includes('CAN_VIEW_APPS')));
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $be29e.UserService))
], $970f334824668c34$export$254161f9c6172d5d.prototype, "userService", void 0);
$970f334824668c34$export$254161f9c6172d5d = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $970f334824668c34$export$254161f9c6172d5d);

});

parcelRegister("3qX4y", function(module, exports) {

$parcel$export(module.exports, "VSCodeService", () => $1d61dae28eae7bdd$export$e197cd72def77e30);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $3Hrul = parcelRequire("3Hrul");

var $gawXH = parcelRequire("gawXH");

var $7X6iT = parcelRequire("7X6iT");

var $gEK7k = parcelRequire("gEK7k");

var $5V3kE = parcelRequire("5V3kE");

var $4cteG = parcelRequire("4cteG");
class $1d61dae28eae7bdd$export$e197cd72def77e30 extends (0, $7X6iT.BaseGraphqlService) {
    _getQuery() {
        return (0, $2O1GU.importQuery)('get-project.query.graphql');
    }
    _getVaribales(id) {
        return {
            id: id
        };
    }
    stopSession(session) {
        return (sessions)=>this.mutate({
                mutation: 'stop-session.graphql',
                variables: {
                    id: session.id
                },
                update: (proxy)=>{
                    const data = this._getState(proxy)(session.projectId);
                    const cardState = this._getCardState(session.cardId)(proxy);
                    cardState.getCard.sessions[0].active = false;
                    this._writeCardState(cardState, {
                        id: session.cardId
                    })(proxy);
                    this._writeState({
                        getProject: {
                            ...data.getProject,
                            sessions: [
                                ...sessions.filter((s)=>s.id !== session.id),
                                {
                                    ...session,
                                    active: false
                                }
                            ]
                        }
                    })(proxy);
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.stopSession));
    }
    generateSession(args) {
        return (projectId)=>this.mutate({
                mutation: 'generate-code-session.graphql',
                variables: {
                    projectId: projectId,
                    ...args
                },
                update: async (proxy, { data: { generateCodeSession: generateCodeSession } })=>{
                    const data = this._getState(proxy)(projectId);
                    if (args.cardId) {
                        const card = await (0, $3Hrul.firstValueFrom)(this.cardService.getCard(args.cardId));
                        data.getBoard = (0, $gEK7k.modCard)(card.boardId, card.columnId, card.id)((card)=>{
                            card.sessions.push(generateCodeSession);
                            return card;
                        })(data.getBoard);
                    }
                    try {
                        this._writeState({
                            getBoard: data.getBoard
                        })(proxy);
                    } catch (e) {
                    // console.error(e);
                    }
                }
            }).pipe((0, $gawXH.map)((res)=>res.data.generateCodeSession));
    }
    deleteSession(session) {
        return ()=>this.mutate({
                mutation: 'vs-code-delete-session.graphql',
                variables: {
                    id: session.id
                },
                update: (proxy)=>{
                    const data = this._getState(proxy)(session.projectId);
                    if (session.card) data.getBoard = (0, $gEK7k.modCard)(session.card.boardId, session.card.columnId, session.card.id)((card)=>{
                        card.sessions = card.sessions.filter((s)=>s.id !== session.id);
                        return card;
                    })(data.getBoard);
                    this._writeState({
                        getBoard: data.getBoard
                    })(proxy);
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.deleteSession));
    }
    startSession({ ports: ports, session: session, repoName: repoName, owner: owner }) {
        if (!session) throw new Error('Missing session');
        const token = this.githubservice.getAccessToken();
        if (!token) throw new Error('Missing Github token please try to logout and login again');
        return ()=>this.mutate({
                mutation: 'start-session.graphql',
                variables: {
                    id: session.id,
                    ports: ports || [],
                    repoName: repoName,
                    token: token,
                    owner: owner
                },
                update: (proxy)=>{
                    const data = this._getState(proxy)(session.projectId);
                    const cardState = this._getCardState(session.cardId)(proxy);
                    cardState.getCard.sessions[0].active = true;
                    this._writeCardState(cardState, {
                        id: session.cardId
                    })(proxy);
                    this._writeState({
                        ...cardState,
                        getProject: {
                            ...data.getProject,
                            sessions: [
                                ...data.getProject.sessions.filter((s)=>s.id !== session.id),
                                {
                                    ...session,
                                    active: true
                                }
                            ]
                        }
                    })(proxy);
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.startSession));
    }
    startVsCodeEvent(label, args) {
        return this.mutate({
            mutation: 'start-vs-code-event.graphql',
            variables: {
                label: label,
                args: args
            }
        });
    }
    stopVsCodeEvent(label, specifier) {
        return this.mutate({
            mutation: 'stop-vs-code-event.graphql',
            variables: {
                label: label,
                args: {
                    specifier: specifier
                }
            }
        });
    }
    _writeCardState(data, variables) {
        return (proxy)=>proxy.writeQuery({
                query: (0, $2O1GU.importQuery)('get-card.graphql'),
                data: data,
                variables: variables
            });
    }
    _getCardState(id) {
        return (proxy)=>(0, $2O1GU.deepCopy)(proxy.readQuery({
                query: (0, $2O1GU.importQuery)('get-card.graphql'),
                variables: {
                    id: id
                }
            }));
    }
    constructor(...args){
        super(...args), this._getState = (proxy)=>(projectId)=>(0, $2O1GU.deepCopy)(proxy.readQuery({
                    query: this._getQuery(),
                    variables: this._getVaribales(projectId)
                })), this._writeState = (data)=>(proxy)=>(projectId)=>proxy.writeQuery({
                        query: this._getQuery(),
                        data: data,
                        variables: this._getVaribales(projectId)
                    });
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $5V3kE.CardService))
], $1d61dae28eae7bdd$export$e197cd72def77e30.prototype, "cardService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $4cteG.GithubService))
], $1d61dae28eae7bdd$export$e197cd72def77e30.prototype, "githubservice", void 0);
$1d61dae28eae7bdd$export$e197cd72def77e30 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $1d61dae28eae7bdd$export$e197cd72def77e30);

});
parcelRegister("3Hrul", function(module, exports) {

$parcel$export(module.exports, "firstValueFrom", () => $2b1ab5dd21cce866$export$400f9f949cef996c);

var $77jL3 = parcelRequire("77jL3");

var $1uzAx = parcelRequire("1uzAx");
function $2b1ab5dd21cce866$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $1uzAx.SafeSubscriber)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $77jL3.EmptyError)());
            }
        });
        source.subscribe(subscriber);
    });
}

});


parcelRegister("fpZJA", function(module, exports) {

$parcel$export(module.exports, "VersionService", () => $339ce45da4ddd539$export$176ccfbe3b0e5318);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $cF8NT = parcelRequire("cF8NT");
class $339ce45da4ddd539$export$176ccfbe3b0e5318 {
    getAppVersion() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cF8NT))).version;
    }
    OnInit() {
        console.log(`[APP]: version ${(0, (/*@__PURE__*/$parcel$interopDefault($cF8NT))).version}`);
    }
}
$339ce45da4ddd539$export$176ccfbe3b0e5318 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)({
        init: true
    })
], $339ce45da4ddd539$export$176ccfbe3b0e5318);

});
parcelRegister("cF8NT", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@graphql/frontend\",\"version\":\"1.0.1\",\"scripts\":{\"start\":\"npx parcel ./src/index.html --watch-ignore node_modules\",\"start-11000\":\"parcel ./src/index.html --port 11000 --watch-ignore node_modules --no-scope-hoist\",\"build\":\"parcel build ./src/index.html\",\"build:docker\":\"docker build -t ghcr.io/stradivario/graphql-client:latest .\",\"lint\":\"npx eslint ./src --ext .ts\",\"lint-fix\":\"npx eslint ./src --fix --ext .ts\",\"test\":\"env $(cat .env | xargs) jest\",\"test:ci\":\"jest\",\"introspect\":\"gapi schema introspect --collect-documents --collect-types --with-compressed\"},\"author\":\"Kristiyan Tachev\",\"license\":\"MIT\",\"vaadin\":{\"disableUsageStatistics\":true},\"dependencies\":{\"@google-web-components/google-chart\":\"^4.0.1\",\"@octokit/core\":\"^3.1.2\",\"@reactive-redux/store\":\"6.3.11\",\"@revolut/checkout\":\"^1.0.8\",\"@rhtml/component\":\"^0.0.141\",\"@rhtml/components\":\"^0.0.141\",\"@rhtml/decorators\":\"^0.0.141\",\"@rhtml/di\":\"^0.0.141\",\"@rhtml/modifiers\":\"^0.0.141\",\"@rhtml/operators\":\"^0.0.141\",\"@rxdi/compressor\":\"^0.7.223\",\"@rxdi/core\":\"^0.7.223\",\"@rxdi/credit-card-form\":\"^0.7.223\",\"@rxdi/forms\":\"^0.7.223\",\"@rxdi/graphql-client\":\"^0.7.223\",\"@rxdi/hotkeys\":\"^0.7.223\",\"@rxdi/http\":\"^0.7.223\",\"@rxdi/lit-html\":\"^0.7.223\",\"@rxdi/router\":\"^0.7.223\",\"@rxdi/ui-components\":\"^0.7.37\",\"@rxdi/ui-kit\":\"^0.7.138\",\"@sentry/browser\":\"^7.37.2\",\"@shoelace-style/shoelace\":\"^2.0.0\",\"@stradivario/graphql-server\":\"0.0.11\",\"@stradivario/markdown\":\"0.0.14\",\"@stradivario/swiper\":\"0.0.8\",\"@vaadin/details\":\"^23.3.2\",\"@vaadin/icon\":\"^23.3.2\",\"@vaadin/icons\":\"^23.3.2\",\"@vaadin/multi-select-combo-box\":\"^23.3.2\",\"@vaadin/radio-group\":\"^23.3.2\",\"@vaadin/text-area\":\"^23.3.2\",\"@vaadin/vaadin-lumo-styles\":\"^23.3.2\",\"apollo-link-context\":\"^1.0.20\",\"apollo3-cache-persist\":\"^0.14.1\",\"braintree-web\":\"^3.74.0\",\"carbon-web-components\":\"^1.21.0\",\"codemirror\":\"^5.62.2\",\"diff\":\"^5.1.0\",\"droppable\":\"^2.2.0\",\"firebase\":\"7.14.6\",\"fuse.js\":\"^5.2.3\",\"graphql-tag\":\"^2.12.5\",\"hammerjs\":\"^2.0.8\",\"image-resize\":\"^1.3.2\",\"immer\":\"^4.0.0\",\"jest-environment-jsdom\":\"^29.3.1\",\"jsoneditor\":\"^10.4.2\",\"localforage\":\"^1.10.0\",\"mermaid\":\"^8.9.1\",\"parcel\":\"^2.16.3\",\"rambda\":\"^6.5.3\",\"rxjs\":\"^7.8.2\",\"shades\":\"^2.1.0\",\"svg-pan-zoom\":\"^3.6.1\",\"toastr\":\"^2.1.4\",\"ts-action\":\"^11.0.0\",\"ts-action-operators\":\"^9.1.2\",\"workbox-cacheable-response\":\"^6.5.4\",\"workbox-expiration\":\"^6.5.4\",\"workbox-precaching\":\"^6.5.4\",\"workbox-recipes\":\"^6.5.4\",\"workbox-routing\":\"^6.5.4\",\"workbox-strategies\":\"^6.5.4\"},\"browserslist\":[\"last 1 chrome versions\"],\"devDependencies\":{\"@babel/core\":\"^7.10.2\",\"@parcel/packager-raw-url\":\"^2.16.3\",\"@parcel/transformer-webmanifest\":\"^2.16.3\",\"@types/braintree-web\":\"^3.69.3\",\"@types/codemirror\":\"^5.60.6\",\"@types/diff\":\"^5.0.2\",\"@types/hammerjs\":\"^2.0.41\",\"@types/jest\":\"^29.2.5\",\"@types/marked\":\"^1.2.1\",\"@types/mermaid\":\"^8.2.1\",\"@types/node\":\"^14.14.28\",\"@types/toastr\":\"^2.1.40\",\"@typescript-eslint/eslint-plugin\":\"^5.53.0\",\"@typescript-eslint/parser\":\"^5.53.0\",\"assert\":\"^2.1.0\",\"babel-plugin-module-resolver\":\"^5.0.2\",\"cssnano\":\"^4.1.10\",\"eslint\":\"^8.31.0\",\"eslint-config-prettier\":\"^8.6.0\",\"eslint-plugin-lit\":\"^1.8.2\",\"eslint-plugin-prettier\":\"^4.2.1\",\"eslint-plugin-simple-import-sort\":\"^10.0.0\",\"graphql\":\"^14.6.0\",\"gts\":\"^3.1.1\",\"husky\":\"^4.2.1\",\"jest\":\"29.3.1\",\"jest-cli\":\"29.3.1\",\"jest-environment-jsdom-sixteen\":\"^2.0.0\",\"prettier\":\"^2.8.4\",\"process\":\"^0.11.10\",\"ts-jest\":\"^29.0.3\",\"ts-loader\":\"^9.4.2\",\"ts-toolbelt\":\"^9.6.0\",\"typescript\":\"^4.9.4\",\"util\":\"^0.12.5\"},\"engines\":{\"npm\":\">=10\",\"node\":\">=20\"},\"husky\":{\"hooks\":{\"pre-commit\":\"npm run lint-fix\"}}}");

});


parcelRegister("cyGfX", function(module, exports) {

$parcel$export(module.exports, "VerticalTimelineModule", () => $ffc67ee1d70843c2$export$ec0fb4059cfe3344);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $bQaGF = parcelRequire("bQaGF");

var $atPyV = parcelRequire("atPyV");
class $ffc67ee1d70843c2$export$ec0fb4059cfe3344 {
}
$ffc67ee1d70843c2$export$ec0fb4059cfe3344 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Module)({
        components: [
            (0, $atPyV.VerticalTimelineComponent),
            (0, $bQaGF.CardComponent)
        ]
    })
], $ffc67ee1d70843c2$export$ec0fb4059cfe3344);

});
parcelRegister("bQaGF", function(module, exports) {

$parcel$export(module.exports, "CardComponent", () => $b371ee3ed6db8a78$export$e506ae60b6852702);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $2d0B8 = parcelRequire("2d0B8");

var $kMbrY = parcelRequire("kMbrY");
class $b371ee3ed6db8a78$export$e506ae60b6852702 extends (0, $4TeKW.LitElement) {
    OnInit() {
        this.oldPosition = this.position;
        this.responsive.width.subscribe((width)=>{
            if (width < 600) this.position = 'left';
            else if (width > 600) this.position = this.oldPosition;
        });
        if (this.dateValue === null || this.dateValue === undefined) this.dateValue = new Date();
        if (this.color === null || this.color === undefined) this.color = '#3F51B5';
        if (this.isLight(this.color)) this.textColor = '#FFFFFF';
        else this.textColor = '#FFFFFF';
    }
    isLight(hexColor) {
        const R = Number.parseInt(hexColor.slice(1, 3), 16);
        const G = Number.parseInt(hexColor.slice(3, 5), 16);
        const B = Number.parseInt(hexColor.slice(5, 7), 16);
        const maxBrightness = this.calculateBrightness(255, 255, 255);
        const brightness = this.calculateBrightness(R, G, B);
        const pBrightness = brightness / maxBrightness;
        return pBrightness > 0.5;
    }
    // HSP rule sqrt( .299 R2 + .587 G2 + .114 B2 ), see http://alienryderflex.com/hsp.html
    calculateBrightness(R, G, B) {
        return Math.sqrt(0.299 * Math.pow(R, 2) + 0.587 * Math.pow(G, 2) + 0.114 * Math.pow(B, 2));
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $b371ee3ed6db8a78$export$e506ae60b6852702.prototype, "position", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        attribute: false
    })
], $b371ee3ed6db8a78$export$e506ae60b6852702.prototype, "dateValue", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $b371ee3ed6db8a78$export$e506ae60b6852702.prototype, "dotContent", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $b371ee3ed6db8a78$export$e506ae60b6852702.prototype, "color", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $2d0B8.ResponsiveService))
], $b371ee3ed6db8a78$export$e506ae60b6852702.prototype, "responsive", void 0);
$b371ee3ed6db8a78$export$e506ae60b6852702 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'vertical-timeline-card-component',
        styles: [
            (0, $kMbrY.style)
        ],
        template () {
            return (0, $4TeKW.html)`
      <div class="timeline-img test" style=${(0, $4TeKW.styleMap)({
                background: this.color
            })}>
        <span style=${(0, $4TeKW.styleMap)({
                color: this.textColor
            })}>${this.dotContent}</span>
      </div>
      <div class="timeline-content">
        <div
          style=${(0, $4TeKW.styleMap)({
                background: this.color
            })}
          class=${(0, $4TeKW.classMap)({
                date: true,
                rightRadius: this.position === 'right',
                leftRadius: this.position === 'left'
            })}
        >
          <span style=${(0, $4TeKW.styleMap)({
                color: this.textColor
            })}>${this.dateValue.toDateString()}</span>
        </div>

        <div
          style=${(0, $4TeKW.styleMap)({
                float: 'right',
                'margin-top': '20px',
                'text-align': this.position === 'right' ? 'right' : 'left'
            })}
        >
          <slot></slot>
        </div>
      </div>
    `;
        }
    })
], $b371ee3ed6db8a78$export$e506ae60b6852702);

});
parcelRegister("kMbrY", function(module, exports) {

$parcel$export(module.exports, "style", () => $8b77d67dc0924208$export$1d567c320f4763bc);

var $4TeKW = parcelRequire("4TeKW");
const $8b77d67dc0924208$export$1d567c320f4763bc = (0, $4TeKW.css)`
  .timeline {
    padding: 5%;
    position: relative;
  }
  .timeline::before {
    content: '';
    background: #c5cae9;
    width: 5px;
    height: 95%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .timeline-item {
    width: 100%;
    margin-bottom: 70px;
  }
  .timeline-item:nth-child(even) .timeline-content {
    float: right;
    padding: 40px 34px 10px 30px;
  }
  .timeline-item:nth-child(even) .timeline-content .date {
    right: auto;
    left: 0;
  }
  .timeline-item:nth-child(even) .timeline-content::after {
    content: '';
    position: absolute;
    border-style: solid;
    width: 0;
    display: none;
    height: 0;
    top: 30px;
    left: -15px;
    border-width: 10px 15px 10px 0;
    border-color: transparent #f5f5f5 transparent transparent;
  }
  .timeline-item::after {
    content: '';
    display: block;
    clear: both;
  }
  .timeline-content {
    position: relative;
    width: 40%;
    padding: 30px 43px !important;
    margin-bottom: 50px;
    border-radius: 6px;
    background: transparent;
    box-shadow: none;
    min-height: 10em;
  }
  .timeline-content::after {
    content: '';
    position: absolute;
    border-style: solid;
    width: 0;
    height: 0;
    top: 30px;
    right: -15px;
    display: none;
    border-width: 10px 0 10px 15px;
    border-color: transparent transparent transparent #f5f5f5;
  }
  .timeline-img {
    background: #3f51b5;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    width: 60px;
    height: 60px;
    margin-left: -30px;
    margin-top: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .timeline-img p {
    height: 0;
    line-height: 1;
    color: #fff;
  }
  .timeline-card {
    padding: 0 !important;
  }
  .timeline-card p {
    padding: 0 20px;
  }
  .timeline-card a {
    margin-left: 20px;
  }
  .timeline-item:nth-child(2) .timeline-img-header {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)),
      url('https://hd.unsplash.com/photo-1458530970867-aaa3700e966d') center center no-repeat;
    background-size: cover;
  }
  .timeline-item:nth-child(5) .timeline-img-header {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)),
      url('https://hd.unsplash.com/photo-1444093826349-9ce8c622f4f3') center center no-repeat;
    background-size: cover;
  }
  .timeline-item:nth-child(6) .timeline-img-header {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)),
      url('https://hd.unsplash.com/photo-1471479917193-f00955256257') center center no-repeat;
    background-size: cover;
  }
  .timeline-item:nth-child(8) .timeline-img-header {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)),
      url('https://hd.unsplash.com/photo-1466840787022-48e0ec048c8a') center center no-repeat;
    background-size: cover;
  }
  .timeline-item:nth-child(10) .timeline-img-header {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)),
      url('https://hd.unsplash.com/photo-1447639703758-f525f36456bf') center center no-repeat;
    background-size: cover;
  }
  .timeline-item:nth-child(11) .timeline-img-header {
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)),
      url('https://hd.unsplash.com/photo-1469429978400-082eec725ad5') center center no-repeat;
    background-size: cover;
  }
  .timeline-img-header {
    height: 200px;
    position: relative;
    margin-bottom: 20px;
  }
  .timeline-img-header h2 {
    color: #fff;
    position: absolute;
    bottom: 5px;
    left: 20px;
  }
  blockquote {
    margin-top: 30px;
    color: #757575;
    border-left-color: #3f51b5;
    padding: 0 20px;
  }
  .date {
    background: #3f51b5;
    display: inline-block;
    color: #fff;
    padding: 5px;
    position: absolute;
    top: 0;
    right: 0;
  }
  @media screen and (max-width: 770px) {
    .date {
      right: 0 !important;
      left: 0;
    }
  }
  .leftRadius {
    border-top-left-radius: 6px;
  }
  @media screen and (max-width: 770px) {
    .leftRadius {
      border-radius: 0;
    }
  }
  .rightRadius {
    border-top-right-radius: 6px;
  }
  @media screen and (max-width: 770px) {
    .rightRadius {
      border-radius: 0;
    }
  }
  @media screen and (max-width: 768px) {
    .timeline::before {
      left: 50px;
    }
    .timeline .timeline-img {
      left: 50px;
    }
    .timeline .timeline-content {
      max-width: 100%;
      width: auto;
      margin-left: 70px;
    }
    .timeline .timeline-item:nth-child(even) .timeline-content {
      float: none;
    }
    .timeline .timeline-item:nth-child(odd) .timeline-content::after {
      content: '';
      position: absolute;
      border-style: solid;
      width: 0;
      height: 0;
      top: 30px;
      left: -15px;
      border-width: 10px 15px 10px 0;
      border-color: transparent #f5f5f5 transparent transparent;
    }
  }
  .test {
    background-color: #46bea3;
    border: 0.25rem solid #fff;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 3px 2px 1px rgba(0, 0, 0, 0.2), 0px 5px 20px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0px 3px 2px 1px rgba(0, 0, 0, 0.2), 0px 5px 20px rgba(0, 0, 0, 0.2);
    color: #fff;
    display: inline-block;
    line-height: 4;
    font-weight: bold;
    height: 4rem;
    left: 50%;
    margin-left: -2.25rem;
    text-align: center;
    position: absolute;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
    width: 4rem;
  }
  @media screen and (max-width: 768px) {
    .test {
      left: 50px;
    }
  }
  .timeline-item:nth-child(even) .timeline-content {
    padding: 40px 43px !important;
  }
`;

});


parcelRegister("atPyV", function(module, exports) {

$parcel$export(module.exports, "VerticalTimelineComponent", () => $15a2e4298806abd8$export$15855cab5f4ae2f8);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $kMbrY = parcelRequire("kMbrY");
class $15a2e4298806abd8$export$15855cab5f4ae2f8 extends (0, $4TeKW.LitElement) {
}
$15a2e4298806abd8$export$15855cab5f4ae2f8 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'vertical-timeline-component',
        style: $kMbrY.style,
        template () {
            return (0, $4TeKW.html)`
      <section class="timeline">
        <div>
          <slot></slot>
        </div>
      </section>
    `;
        }
    })
], $15a2e4298806abd8$export$15855cab5f4ae2f8);

});



parcelRegister("gul0M", function(module, exports) {

$parcel$export(module.exports, "FooterComponent", () => $edf4628b22549eaa$export$189e3f0ab56ac948);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");
class $edf4628b22549eaa$export$189e3f0ab56ac948 extends (0, $4TeKW.LitElement) {
}
$edf4628b22549eaa$export$189e3f0ab56ac948 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'footer-component',
        style: (0, $4TeKW.css)`
    .content {
      margin-right: 20px;
      font-size: 12px;
    }

    .container {
      width: 100%;
      height: 60px;
      color: #226e6f;
      padding-top: 40px;
    }

    .flex {
      display: flex;
    }
    .spacer {
      flex: 1 3 auto;
    }

    .pointer {
      cursor: pointer;
    }

    .context {
      color: #4b5055;
      margin-top: 10px;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <div class="container">
        <div class="flex center">
          <span class="spacer"></span>
          <div class="content">Terms</div>
          <div class="content">Privacy Policy</div>
          <div routerLink="/release-notes" class="content pointer">Release notes</div>
          <span class="spacer"></span>
        </div>
        <div class="flex center context">
          <span class="spacer"></span>
          <div class="content">${new Date().getFullYear()} Reactive Solutions LTD. All rights reserved</div>

          <span class="spacer"></span>
        </div>
      </div>
    `;
        }
    })
], $edf4628b22549eaa$export$189e3f0ab56ac948);

});

parcelRegister("eWpqu", function(module, exports) {

$parcel$export(module.exports, "HomeComponent", () => $bb4ebaefe734b002$export$91ab848c4a468602);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $8W1ji = parcelRequire("8W1ji");

var $9o0a6 = parcelRequire("9o0a6");
class $bb4ebaefe734b002$export$91ab848c4a468602 extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $bb4ebaefe734b002$export$91ab848c4a468602.prototype, "showIFrame", void 0);
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $bb4ebaefe734b002$export$91ab848c4a468602.prototype, "router", void 0);
$bb4ebaefe734b002$export$91ab848c4a468602 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'home-component',
        style: $8W1ji.style,
        template: $9o0a6.template
    })
], $bb4ebaefe734b002$export$91ab848c4a468602);

});
parcelRegister("8W1ji", function(module, exports) {

$parcel$export(module.exports, "style", () => $b2eb4bdcbbad0255$export$1d567c320f4763bc);

var $4TeKW = parcelRequire("4TeKW");

var $1472X = parcelRequire("1472X");
const $b2eb4bdcbbad0255$export$1d567c320f4763bc = (0, $4TeKW.css)`
  ${(0, $1472X.MainView)}
  .content {
    text-align: center;
  }
  .ide {
    max-width: 1400px;
    margin: 60px auto;
    margin-top: 0px;
    padding: 50px;
  }
  .container {
    margin: 60px auto;
    margin-bottom: 0px;
  }

  .content {
    margin-top: 60px;
  }

  .box {
    background-color: white;
    color: black;
    padding: 30px;
    width: 300px;
    margin-right: 20px;
    box-shadow: 0 5px 55px rgba(162, 162, 162, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  .iframe {
    box-shadow: 0 5px 55px rgba(162, 162, 162, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    margin: 0 auto;
    max-width: 1400px;
  }
  h1 {
    font-size: 2em;
    font-weight: bold;
  }

  .pointer {
    cursor: pointer;
  }
`;

});
parcelRegister("1472X", function(module, exports) {

$parcel$export(module.exports, "MainView", () => $ae4b2d03fb1f5c71$export$fa32cd27347e212e);

var $4TeKW = parcelRequire("4TeKW");
const $ae4b2d03fb1f5c71$export$7e1d67537fa6671 = 0;
const $ae4b2d03fb1f5c71$export$fa32cd27347e212e = (0, $4TeKW.css)`
  .view {
    margin: ${$ae4b2d03fb1f5c71$export$7e1d67537fa6671}px auto;
  }
  .flex {
    display: flex;
  }
  .spacer {
    flex: 1 3 auto;
  }
  .pointer {
    cursor: pointer;
  }
`;

});


parcelRegister("9o0a6", function(module, exports) {

$parcel$export(module.exports, "template", () => $2d9e754efdc68341$export$ce69bd05624d0c48);
/* eslint-disable lit/binding-positions */ /* eslint-disable lit/attribute-value-entities */ 
var $4TeKW = parcelRequire("4TeKW");
const $2d9e754efdc68341$var$normalStyles = {
    width: '100%',
    height: '500px',
    border: '0px',
    'border-radius': '4px'
};
const $2d9e754efdc68341$var$hiddenStyle = {
    visibility: 'hidden'
};
const $2d9e754efdc68341$var$highlightedStyle = {
    visibility: 'visible'
};
const $2d9e754efdc68341$export$ce69bd05624d0c48 = function() {
    return (0, $4TeKW.html)`
    <div class="view">
      <div class="container content">
        <h1 class="center">
          A rich framework for building applications and services with GraphQL and Apollo inspired by Angular
        </h1>
        <div class="center content">
          <!-- <h2>Start with a simple CLI command</h2> -->

          <img
            style="margin: 0 auto;"
            src="https://raw.githubusercontent.com/Stradivario/gapi-cli-docs/master/src/assets/images/cli-logo.png"
          />
        </div>
        <h1 style="margin-top: 60px;" class="center">Live preview</h1>
        <p class="center">See how your application may potentially look like without leaving your personal browser.</p>
      </div>
      <div style=${(0, $4TeKW.styleMap)(this.showIFrame ? $2d9e754efdc68341$var$hiddenStyle : $2d9e754efdc68341$var$highlightedStyle)} class="center">
        <spinner-default></spinner-default>
      </div>
      <div class="ide">
        <div>
          <iframe
            @load=${()=>this.showIFrame = true}
            style=${(0, $4TeKW.styleMap)(this.showIFrame ? {
        ...$2d9e754efdc68341$var$highlightedStyle,
        ...$2d9e754efdc68341$var$normalStyles
    } : {
        ...$2d9e754efdc68341$var$hiddenStyle,
        ...$2d9e754efdc68341$var$normalStyles
    })}
            src="https://codesandbox.io/embed/gapi-core-graphql-server-forked-pju5j?fontsize=14&hidenavigation=1&theme=dark&module=%2Fsrc%2Fapp%2Fapp.controller.ts"
            sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
          >
          </iframe>
        </div>
      </div>
    </div>

    <!--
    <h1 class="center">
      Web Components
    </h1>
    <div class="container my-12 mx-auto px-4 md:px-12">
      <div class="flex flex-wrap -mx-1 lg:-mx-4">
          <div
          @click=${()=>this.router.go('/ui-components/rxdi/starter-client-lit-html')}
            class="pointer my-1 px-1 w-full md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3"
          >
            <article
              style="background-color: #27798a;"
              class="overflow-hidden rounded-lg shadow-lg"
            >
              <a>
                <img
                  alt="Placeholder"
                  class="block h-auto w-full"
                  src="https://picsum.photos/600/400/?random"
                />
              </a>

              <header
                class="flex items-center justify-between leading-tight p-2 md:p-4"
              >
                <h1 class="text-lg">
                  <a class="no-underline hover:underline text-white" >
                    @rxdi/ui-components
                  </a>
                </h1>
                <p class="text-grey-darker text-sm">
                  14/4/19
                </p>
              </header>

              <footer
                class="flex items-center justify-between leading-none p-2 md:p-4"
              >
                <a
                  class="flex items-center no-underline hover:underline text-white"
                >
                  <img
                    alt="Placeholder"
                    class="block rounded-full"
                    src="https://picsum.photos/32/32/?random"
                  />
                  <p class="ml-2 text-sm">
                    Kristiyan Tachev (@Stradivario)
                  </p>
                </a>
                <a
                  class="no-underline text-grey-darker hover:text-red-dark"
                  href="#"
                >
                  <span class="hidden">Like</span>
                  <i class="fa fa-heart"></i>
                </a>
              </footer>
            </article>
          </div>
      </div>
    </div> -->
  `;
};

});


parcelRegister("gNtKD", function(module, exports) {

$parcel$export(module.exports, "LoginComponent", () => $1a079983c8a35ab3$export$e2a3bd66598046d1);

var $deWeK = parcelRequire("deWeK");

var $7lFX5 = parcelRequire("7lFX5");

var $6icTI = parcelRequire("6icTI");

var $Eh7f5 = parcelRequire("Eh7f5");

var $dIFEA = parcelRequire("dIFEA");

var $djGtt = parcelRequire("djGtt");

var $1t8Wn = parcelRequire("1t8Wn");

var $facKu = parcelRequire("facKu");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $f18Kf = parcelRequire("f18Kf");

var $htU1w = parcelRequire("htU1w");

var $cDzby = parcelRequire("cDzby");

var $8Mkyx = parcelRequire("8Mkyx");
class $1a079983c8a35ab3$export$e2a3bd66598046d1 extends (0, $htU1w.BaseComponentWithLoading) {
    onSubmit() {
        if (this.isLoading()) return;
        this.showLoading();
        this.socialService.signInWithEmailAndPassword(this.form.value.email, this.form.value.password).subscribe(()=>{
            this.hideLoading();
            this.router.go('/projects');
        }, async (e)=>{
            this.hideLoading();
            this.error = e;
            await this.form.updateValueAndValidity();
            this.error = '';
        });
    }
    async hasErrors() {
        return (await this.form.updateValueAndValidity()).length;
    }
    constructor(...args){
        super(...args), this.password = 'none', this.model = new (0, $8Mkyx.LoginFormModel)(), this.form = new (0, $facKu.FormGroup)({
            password: [
                this.model.password,
                [
                    (0, $dIFEA.PasswordValidator),
                    (0, $dIFEA.FirebasePasswordValidator)
                ]
            ],
            email: [
                this.model.email,
                [
                    (0, $dIFEA.NetworkErrorValidator),
                    (0, $dIFEA.EmailValidator),
                    (0, $dIFEA.FirebaseAuthValidator)
                ]
            ]
        }, (0, $Eh7f5.AppErrors));
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $1a079983c8a35ab3$export$e2a3bd66598046d1.prototype, "error", void 0);
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $1a079983c8a35ab3$export$e2a3bd66598046d1.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.state)()
], $1a079983c8a35ab3$export$e2a3bd66598046d1.prototype, "password", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $1a079983c8a35ab3$export$e2a3bd66598046d1.prototype, "socialService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $djGtt.PrefetchService))
], $1a079983c8a35ab3$export$e2a3bd66598046d1.prototype, "prefetch", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $1a079983c8a35ab3$export$e2a3bd66598046d1.prototype, "model", void 0);
(0, $deWeK.__decorate)([
    (0, $facKu.Form)({
        strategy: 'change',
        name: 'login-form',
        strict: true,
        model: 'model'
    })
], $1a079983c8a35ab3$export$e2a3bd66598046d1.prototype, "form", void 0);


$1a079983c8a35ab3$export$e2a3bd66598046d1 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'login-component',
        style: (0, $4TeKW.css)`
    ${(0, $f18Kf.InputStyle)}

    input[type='text'],
  input[type='email'],
  input[type='number'],
  textarea,
  fieldset {
      /* required to properly style form
   elements on WebKit based browsers */
      -webkit-appearance: none;

      width: 100%;
      margin: 0;

      font-family: inherit;
      font-size: 90%;

      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
    textarea,
    select,
    input,
    button {
      outline: none;
    }

    .is-invalid {
      box-shadow: 0 0 1px 1px #c95454;
    }
    /* 
  input:focus {
   box-shadow: 0 0 1px 1px #c78282;
  } */
    .container {
      padding: 50px;
      margin: 0px auto;
      margin-top: 150px;
      margin-bottom: 0px;
      width: 440px;
      background-color: #f8f8f8;
      border-radius: 15px;
      box-shadow: rgb(162 162 162 / 25%) 0px 0px 3px, rgb(0 0 0 / 22%) 0px 0px 3px;
    }
    p {
      color: black;
      padding: 0;
      margin: 0;
    }

    input[type='password']:disabled {
      background: #a9a9a9;
    }
    input[type='password']:disabled::placeholder {
      color: white;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      ${this.getLoadingTemplate()}
      <div class="container">
        <div class="form-group card card-container">
          <div style="text-align: center;margin-bottom: 20px;">
            <p style="font-weight: 400;font-size: 2em">Welcome Back</p>
          </div>
          <div
            @mouseenter=${()=>this.prefetch.fetch((parcelRequire("8dAaL")))}
            style="margin: 0 auto; width: 220px;"
          >
            <social-login-container></social-login-container>
          </div>
          <form
            name="login-form"
            @submit=${async (data)=>{
                console.log(data);
            }}
          >
            <p>Email</p>
            <input
              name="email"
              required
              type="email"
              .value=${this.model.email}
              class=${(0, $4TeKW.classMap)({
                'rx-input': true
            })}
              placeholder="Email address"
            />
            <div style="height:30px;">${(0, $6icTI.InputErrorTemplate)(this.form.get('email'))}</div>
            <p>Password</p>
            <input
              type="password"
              .value=${this.model.password}
              name="password"
              required
              class="rx-input"
              placeholder="Password"
            />
            <div style="height: 30px;">${(0, $6icTI.InputErrorTemplate)(this.form.get('password'))}</div>
            <rx-button
              palette="primary"
              style="width: 100%"
              @mouseenter=${()=>this.prefetch.fetch((parcelRequire("8dAaL")))}
              type="submit"
            >
              Sign in
            </rx-button>
            <rx-button
              style="width:100%; margin-top: 10px;"
              @click=${async ()=>{
                const email = this.form.getValue('email');
                if (!email) {
                    this.form.get('email').disabled = true;
                    return await this.form.updateValueAndValidity();
                }
                const returnUrl = (0, $7lFX5.isDevelopment)() ? `http://localhost:1234/auth/${email}` : `http://${(0, $7lFX5.ENVIRONMENT).DOMAIN_NAME}:1234/auth/${email}`;
                this.socialService.sendSignInLinkToEmail(email, returnUrl).subscribe(()=>{
                    this.router.go(`/signup/success/${email}`);
                }, (e)=>console.error(e));
            }}
              >Send Magic link
            </rx-button>
          </form>
          <a style="color: #359ec0; text-decoration: none;font-size: 13px;" href="/reset-password">
            Forgot the password?
          </a>
        </div>
      </div>
      <div style="text-align: center; margin-bottom: 30px; margin-top: 10px;">
        Need an Account?<a style="cursor: pointer;color: #359ec0" @click=${()=>this.router.go('/signup')}>
          Sign up here.</a
        >
      </div>
    `;
        }
    })
], $1a079983c8a35ab3$export$e2a3bd66598046d1);

});
parcelRegister("6icTI", function(module, exports) {

$parcel$export(module.exports, "InputErrorTemplate", () => $71666d263f046c4b$export$9726f96ae4b32c7c);

var $6ppqI = parcelRequire("6ppqI");

var $4TeKW = parcelRequire("4TeKW");
function $71666d263f046c4b$export$9726f96ae4b32c7c(input) {
    if (input && input.touched && !input.validity.valid) {
        const message = input.validationMessage;
        // const key = Object.keys(InputValidityState).filter(o => input.validity[o])[0];
        // message = translate(key, 'bg_BG');
        input.classList.add('is-invalid');
        return (0, $4TeKW.html)`
      <style>
        .validation-error {
          color: #a94442;
          font-size: 12px;
        }
      </style>
      <span style="padding-top: 5px;color: #a94442" class="validation-error">${(0, $6ppqI.translate)(message)}</span>
    `;
    }
    input && input?.classList?.remove('is-invalid');
    return '';
}

});

parcelRegister("Eh7f5", function(module, exports) {

$parcel$export(module.exports, "AppErrors", () => $1145d724710c84a3$export$17d878265fdde2ed);
function $1145d724710c84a3$var$strEnum(o) {
    return o.reduce((res, key)=>{
        res[key] = key;
        return res;
    }, Object.create(null));
}
const $1145d724710c84a3$export$17d878265fdde2ed = $1145d724710c84a3$var$strEnum([
    'email-validator',
    'network',
    'auth/user-not-found',
    'auth/email-already-in-use',
    'auth/wrong-password'
]);

});

parcelRegister("dIFEA", function(module, exports) {

$parcel$export(module.exports, "EmailValidator", () => $11d53afd8f312398$export$edcb1f412665a7f2);
$parcel$export(module.exports, "NetworkErrorValidator", () => $11d53afd8f312398$export$9c2720883dd76f05);
$parcel$export(module.exports, "FirebaseAuthValidator", () => $11d53afd8f312398$export$a1bb52a11c9aa58b);
$parcel$export(module.exports, "FirebasePasswordValidator", () => $11d53afd8f312398$export$49f0a309e2eb3401);
$parcel$export(module.exports, "PasswordValidator", () => $11d53afd8f312398$export$b1a22a90f851bf53);
function $11d53afd8f312398$export$edcb1f412665a7f2(element) {
    if (!/^([a-zA-Z0-9_\.\-]+)@([a-zA-Z0-9_\.\-]+)\.([a-zA-Z]{2,5})$/.test(element.value)) {
        element.classList.add('is-invalid');
        return {
            key: 'email-validator',
            message: 'Email is not valid'
        };
    }
    element.classList.remove('is-invalid');
}
function $11d53afd8f312398$export$130bd08c4496a238(element) {
    const regex = /^[0-9s]{13,19}$/;
    if (!regex.test(element.value)) {
        element.classList.add('is-invalid');
        return {
            key: 'email-validator',
            message: 'Credit card number is invalid valid example xxxx-xxxx-xxxx-xxxx'
        };
    }
    element.classList.remove('is-invalid');
}
function $11d53afd8f312398$export$9c2720883dd76f05() {
    if (this.error && this.error.message === 'Network error: Failed to fetch') return {
        key: 'network',
        message: 'network-comunication-error'
    };
}
function $11d53afd8f312398$export$a1bb52a11c9aa58b() {
    if (this.error && this.error.code === 'auth/email-already-in-use') return {
        key: this.error.code,
        message: this.error.message
    };
    if (this.error && this.error.code === 'auth/user-not-found') return {
        key: this.error.code,
        message: this.error.message
    };
    if (this.error && this.error.code === 'auth/too-many-requests') return {
        key: this.error.code,
        message: this.error.message
    };
}
function $11d53afd8f312398$export$49f0a309e2eb3401() {
    if (this.error && this.error.code === 'auth/wrong-password') return {
        key: this.error.code,
        message: this.error.message
    };
}
function $11d53afd8f312398$export$b1a22a90f851bf53(element) {
    if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(element.value)) {
        element.classList.add('is-invalid');
        return {
            key: 'password-invalid',
            message: 'Minimum eight characters, at least one letter and one number'
        };
    }
    element.classList.remove('is-invalid');
}
function $11d53afd8f312398$export$dba324c4e07d770c(element) {
    if (!/^(?!.*\/)((?:.*\\.*)|$)/.test(element.value)) return {
        key: 'name-invalid',
        message: 'Invalid project name'
    };
}

});

parcelRegister("facKu", function(module, exports) {
"use strict";
var $b0a1addd2d2379f5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b0a1addd2d2379f5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b0a1addd2d2379f5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b0a1addd2d2379f5$var$__exportStar((parcelRequire("4lbms")), module.exports);

$b0a1addd2d2379f5$var$__exportStar((parcelRequire("5IDK9")), module.exports);

$b0a1addd2d2379f5$var$__exportStar((parcelRequire("7fdhE")), module.exports);

$b0a1addd2d2379f5$var$__exportStar((parcelRequire("6FFYQ")), module.exports);

});
parcelRegister("4lbms", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Form = $3291efb3caf686ed$var$Form;

var $a5qXo = parcelRequire("a5qXo");

var $5IDK9 = parcelRequire("5IDK9");
function $3291efb3caf686ed$var$Form(options = {
    strategy: 'none'
}) {
    return function(clazz, name) {
        if (!options.name) throw new Error('Missing form name');
        const Destroy = clazz.constructor.prototype.disconnectedCallback || $a5qXo.noop;
        const UpdateFirst = clazz.constructor.prototype.firstUpdated || $a5qXo.noop;
        const Connect = clazz.constructor.prototype.connectedCallback || $a5qXo.noop;
        clazz.constructor.prototype.connectedCallback = function() {
            if (!(this[name] instanceof $5IDK9.FormGroup)) throw new Error('Value provided is not an instance of FormGroup!');
            this[name].setParentElement(this).setOptions(options).prepareValues();
            if (options.model && this[options.model]) this[name].patchValue(this[options.model]);
            return Connect.call(this);
        };
        clazz.constructor.prototype.firstUpdated = function() {
            /* Edge case for @rhtml/renderer */ const renderer = this.shadowRoot.querySelector('r-renderer');
            if (renderer) renderer.addEventListener('loaded', ()=>this[name].init());
            else this[name].init();
            return UpdateFirst.call(this);
        };
        clazz.constructor.prototype.disconnectedCallback = function() {
            this[name].unsubscribe();
            return Destroy.call(this);
        };
    };
}

});
parcelRegister("5IDK9", function(module, exports) {
"use strict";
var $429fe4053d866b8e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormGroup = void 0;

var $bq6Hs = parcelRequire("bq6Hs");

var $dXBar = parcelRequire("dXBar");
var $gawXH = parcelRequire("gawXH");

var $7fdhE = parcelRequire("7fdhE");
class $429fe4053d866b8e$var$FormGroup {
    constructor(value, errors){
        this.validators = new Map();
        this.valid = true;
        this.invalid = false;
        this.errors = {};
        this.controls = new Map();
        this.errorMap = new Map();
        this.inputs = new Map();
        this.options = {};
        this.subscriptions = new Map();
        this._valueChanges = new $bq6Hs.BehaviorSubject(value);
        if (value) Object.keys(value).forEach((key)=>{
            if (typeof value[key] === 'object' && value[key] !== null && (value[key]['controls'] || value[key]['push']) && value[key]['valueChanges']) {
                // It's likely a FormGroup or FormArray
                const control = value[key];
                if (control.name === '' || control.name === undefined) control.name = key;
                this.controls.set(key, control);
                if (control.valueChanges) this.subscriptions.set(key, control.valueChanges.subscribe(()=>{
                    this._valueChanges.next(this.value);
                }));
            }
        });
        this.prepareValues();
    }
    init() {
        if (!this.parentElement) return;
        this.setFormElement(this.querySelectForm(this.parentElement.shadowRoot || this.parentElement)).setInputs(this.mapEventToInputs(this.querySelectorAllInputs()));
        this.controls.forEach((c)=>{
            var _a;
            (_a = c.init) === null || _a === void 0 || _a.call(c);
        });
    }
    prepareValues() {
        Object.keys(this.value).forEach((v)=>{
            // Skip nested controls
            if (this.controls.has(v)) return;
            const value = this.value[v];
            this.errors[v] = this.errors[v] || {};
            if (value && value.constructor === Array) {
                if (value[1] && value[1].constructor === Array) value[1].forEach((val)=>{
                    const oldValidators = this.validators.get(v) || [];
                    this.validators.set(v, [
                        ...oldValidators,
                        val
                    ]);
                });
                if (value[0] === undefined || value[0] === null) this.value[v] = '';
                else if (value[0].constructor === String || value[0].constructor === Number || value[0].constructor === Boolean) this.value[v] = value[0];
                else throw new Error(`Input value must be of type 'string', 'boolean' or 'number'`);
            }
        });
        return this;
    }
    setParentElement(parent) {
        this.parentElement = parent;
        this.controls.forEach((c)=>{
            var _a;
            (_a = c.setParentElement) === null || _a === void 0 || _a.call(c, parent);
        });
        return this;
    }
    getParentElement() {
        return this.parentElement;
    }
    setOptions(options) {
        this.options = options;
        this.controls.forEach((c)=>{
            var _a;
            (_a = c.setOptions) === null || _a === void 0 || _a.call(c, Object.assign(Object.assign({}, options), {
                namespace: this.options.namespace ? `${this.options.namespace}.${c.name}` : c.name
            }));
        });
        return this;
    }
    getOptions() {
        return this.options;
    }
    get valueChanges() {
        return this._valueChanges.asObservable();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateValueAndValidity() {
        return $429fe4053d866b8e$var$__awaiter(this, void 0, void 0, function*() {
            this.resetErrors();
            const inputs = yield Promise.all(this.querySelectorAllInputs().map((i)=>$429fe4053d866b8e$var$__awaiter(this, void 0, void 0, function*() {
                    i.setCustomValidity('');
                    this.setElementValidity(i);
                    this.setElementDirty(i);
                    return yield this.validate(i);
                })));
            const inputsWithErrors = inputs.filter((e)=>e.errors.length);
            const nestedErrors = [];
            for (const [key, control] of this.controls.entries())if (control.updateValueAndValidity) {
                const result = yield control.updateValueAndValidity();
                if (control.invalid) {
                    this.invalid = true;
                    this.valid = false;
                    if (Array.isArray(result)) nestedErrors.push(...result);
                }
            }
            this.getParentElement().requestUpdate();
            return [
                ...inputsWithErrors,
                ...nestedErrors
            ];
        });
    }
    updateValueAndValidityOnEvent(method) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        return function(event) {
            return $429fe4053d866b8e$var$__awaiter(this, void 0, void 0, function*() {
                self.setElementDirty(this);
                const selector = `input[name="${this.name}"]`;
                const hasMultipleBindings = [
                    ...self.getFormElement().querySelectorAll(selector).values()
                ].length;
                let value = this.value;
                if (hasMultipleBindings === 1) {
                    if (this.type === 'radio') value = String(this.checked);
                    if (this.type === 'checkbox') value = this.checked;
                }
                if (this.type === 'number') value = Number(value);
                const inputsWithBindings = [
                    ...self.getFormElement().querySelectorAll(`input[name="${this.name}"]:checked`).values()
                ];
                if (hasMultipleBindings > 1) {
                    if (!self.options.multi && this.type === 'checkbox') value = inputsWithBindings.map((e)=>e.value);
                    if (self.options.multi) {
                        inputsWithBindings.forEach((el)=>el.checked = false);
                        this.checked = true;
                    }
                }
                self.resetErrors();
                const isValid = self.applyValidationContext((yield self.validate(this)));
                if (self.options.strict) {
                    if (isValid) {
                        yield self.setElementValidity(this, isValid);
                        self.setValue(self.getModelKeyName(this.name), value);
                    }
                    self.parentElement.requestUpdate();
                    return method.call(self.parentElement, event);
                }
                yield self.setElementValidity(this, isValid);
                self.setValue(self.getModelKeyName(this.name), value);
                self.parentElement.requestUpdate();
                return method.call(self.parentElement, event);
            });
        };
    }
    applyValidationContext({ errors: errors, element: element }) {
        const form = this.getFormElement();
        if (errors.length) {
            this.invalid = form['invalid'] = true;
            this.valid = form['valid'] = false;
            return false;
        } else {
            this.errors[this.getModelKeyName(element.name)] = {};
            this.invalid = form['invalid'] = !form.checkValidity();
            this.valid = form['valid'] = form.checkValidity();
            return true;
        }
    }
    querySelectForm(shadowRoot) {
        if (this.options['form']) return this.options['form'];
        if (!(shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.querySelector)) return null;
        const form = shadowRoot.querySelector(`form[name="${this.options.name}"]`);
        if (!form) throw new Error(`Form element with name "${this.options.name}" not present inside ${this.getParentElement().outerHTML} component`);
        form.addEventListener('submit', (e)=>{
            e.preventDefault();
            e.stopPropagation();
        });
        return form;
    }
    querySelectAll(name) {
        return [
            ...this.form.querySelectorAll(name).values()
        ];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    querySelectorAllInputs() {
        var _a;
        return [
            ...(_a = this.options.customElements) !== null && _a !== void 0 ? _a : [],
            'input',
            'select',
            'textarea'
        ].map((item)=>this.querySelectAll(item)).flat().filter((el)=>this.isInputPresentOnStage(el)).filter((el)=>!!el.name);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapEventToInputs(inputs = []) {
        return inputs.map((el)=>{
            const strategy = `on${this.options.strategy}`;
            if (!el[strategy]) el[strategy] = function() {
            //
            };
            const customAttributes = Object.keys(el.attributes).map((k)=>el.attributes[k].name.startsWith('#') ? el.attributes[k] : null).filter((i)=>!!i);
            if (customAttributes.length) {
                const attr = customAttributes.find((a)=>a.name.startsWith('#'));
                this.parentElement[attr.name.replace('#', '')] = el;
            }
            el.addEventListener('blur', ()=>$429fe4053d866b8e$var$__awaiter(this, void 0, void 0, function*() {
                    this.setElementDirty(el);
                    yield this.parentElement.requestUpdate();
                    yield this.setElementValidity(el);
                }));
            el[strategy] = this.updateValueAndValidityOnEvent(el[strategy]);
            return el;
        });
    }
    setElementValidity(el, validity) {
        return $429fe4053d866b8e$var$__awaiter(this, void 0, void 0, function*() {
            const isValid = validity || this.applyValidationContext((yield this.validate(el)));
            el['valid'] = isValid;
            el['invalid'] = !isValid;
        });
    }
    setElementDirty(input) {
        input['touched'] = true;
        input['dirty'] = true;
    }
    isInputPresentOnStage(input) {
        if (input.outerHTML === '<input type="submit" style="display: none;">') return 0;
        const keyIndex = this.getModelKeyName(input.name);
        const isInputPresent = Object.keys(this.value).filter((v)=>v === keyIndex);
        return isInputPresent.length;
    }
    getModelKeyName(domName) {
        if (this.options['namespace']) {
            // pattern: namespace[key] or namespace.key
            // Example: allowedIps[0].ip -> namespace=allowedIps[0] -> key=ip
            if (domName.startsWith(this.options['namespace'])) {
                const suffix = domName.replace(this.options['namespace'], '');
                // Handle .key or [key]
                if (suffix.startsWith('.')) return suffix.substring(1);
                if (suffix.startsWith('[')) return suffix.substring(1, suffix.length - 1); // Not dealing with that yet
            }
            return domName;
        }
        return domName;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validate(element) {
        return $429fe4053d866b8e$var$__awaiter(this, void 0, void 0, function*() {
            let errors = [];
            element.setCustomValidity('');
            if (!element.checkValidity()) return {
                errors: errors.concat(Object.keys($7fdhE.InputValidityState).map((key)=>element.validity[key] ? {
                        key: key,
                        message: element.validationMessage
                    } : null).filter((i)=>!!i)),
                element: element
            };
            errors = yield this.mapInputErrors(element);
            if (!errors.length) return {
                errors: [],
                element: element
            };
            element.setCustomValidity(errors[0].message);
            return {
                element: element,
                errors: errors
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapInputErrors(element) {
        return $429fe4053d866b8e$var$__awaiter(this, void 0, void 0, function*() {
            const modelKey = this.getModelKeyName(element.name);
            const res = yield Promise.all((this.validators.get(modelKey) || []).map((v)=>$429fe4053d866b8e$var$__awaiter(this, void 0, void 0, function*() {
                    this.errors[modelKey] = this.errors[modelKey] || {};
                    const error = yield v.bind(this.getParentElement())(element);
                    // if (error) {
                    //   element.focus();
                    // }
                    if (error && error.key) {
                        this.errors[modelKey][error.key] = error.message;
                        this.errorMap.set(v, error.key);
                        return {
                            key: error.key,
                            message: error.message
                        };
                    } else if (this.errorMap.has(v)) delete this.errors[modelKey][this.errorMap.get(v)];
                })));
            return res.filter((i)=>!!i);
        });
    }
    get(name) {
        if (this.controls.has(name)) return this.controls.get(name);
        if (String(name).includes('.')) {
            const names = String(name).split('.');
            const key = names.shift();
            const control = this.controls.get(key);
            if (control === null || control === void 0 ? void 0 : control.get) return control.get(names.join('.'));
        }
        const input = this.inputs.get(name);
        if (input) return input;
        /*
          If a user tries to subscribe on a constructor level or before the inputs are inside the DOM
          We create a fake Virtual Input so later on when elements present on stage to get the same subscription
        */ const key = name;
        // Check if key exists in the model value even if not in inputs map
        if (this._valueChanges.getValue() && key in this._valueChanges.getValue()) // Create a "Virtual" AbstractInput to prevent crashes and allow subscription even if no DOM element present
        return {
            valueChanges: this._valueChanges.pipe((0, $gawXH.map)((value)=>value === null || value === void 0 ? void 0 : value[key]), (0, $dXBar.distinctUntilChanged)()),
            value: this.getValue(key),
            name: String(key),
            valid: true,
            invalid: false,
            dirty: false,
            touched: false,
            // Mock HTMLInputElement properties to satisfy interface if needed
            type: 'text',
            checked: false,
            disabled: false
        };
        return undefined;
    }
    getError(inputName, errorKey) {
        return this.errors[inputName][errorKey];
    }
    hasError(inputName, errorKey) {
        return !!this.getError(inputName, errorKey);
    }
    reset() {
        this.form.reset();
        this.resetErrors();
        this.setFormValidity();
        this.inputs.clear();
    }
    setFormValidity(validity = true) {
        this.valid = validity;
        this.invalid = !validity;
        this.getParentElement().requestUpdate();
    }
    resetErrors() {
        this.errors = Object.keys(this.errors).reduce((object, key)=>{
            object[key] = {};
            return object;
        }, {});
        this.errorMap.clear();
    }
    get value() {
        const values = this._valueChanges.getValue();
        this.controls.forEach((control, key)=>{
            values[key] = control.value;
        });
        return values;
    }
    set value(value) {
        this._valueChanges.next(value);
    }
    unsubscribe() {
        this.reset();
        this._valueChanges.unsubscribe();
        this.subscriptions.forEach((s)=>s.unsubscribe());
        this.subscriptions.clear();
        this.controls.forEach((c)=>{
            var _a;
            return (_a = c.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(c);
        });
    }
    getValue(name) {
        return this.value[name];
    }
    patchValue(value) {
        if (!value) return;
        Object.keys(value).forEach((key)=>{
            const control = this.controls.get(key);
            if (control === null || control === void 0 ? void 0 : control.patchValue) control.patchValue(value[key]);
            else this.setValue(key, value[key]);
        });
    }
    setValue(name, value) {
        const input = this.get(name);
        input;
        if (input && input.value !== undefined) input.value = value;
        const values = this.value;
        values[name] = value;
        this.value = values;
    }
    setFormValue(value) {
        this.value = value;
    }
    setFormElement(form) {
        this.form = form;
        this.controls.forEach((c)=>{
            var _a;
            (_a = c.setFormElement) === null || _a === void 0 || _a.call(c, form);
        });
        return this;
    }
    setInputs(inputs) {
        this.inputs = new Map(inputs.map((e)=>{
            const key = this.getModelKeyName(e.name);
            e.value = this.getValue(key);
            e.valueChanges = this._valueChanges.pipe((0, $gawXH.map)((value)=>value === null || value === void 0 ? void 0 : value[key]), (0, $dXBar.distinctUntilChanged)());
            return [
                key,
                e
            ];
        }));
    }
    getFormElement() {
        return this.form;
    }
}
module.exports.FormGroup = $429fe4053d866b8e$var$FormGroup;

});
parcelRegister("dXBar", function(module, exports) {

$parcel$export(module.exports, "distinctUntilChanged", () => $a29d9dbc16b3e968$export$779c5fb865a0172e);

var $6BqGr = parcelRequire("6BqGr");

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $a29d9dbc16b3e968$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $6BqGr.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $a29d9dbc16b3e968$var$defaultCompare;
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $a29d9dbc16b3e968$var$defaultCompare(a, b) {
    return a === b;
}

});

parcelRegister("7fdhE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputValidityState = void 0;
function $54643cf72ee16135$var$strEnum(o) {
    return o.reduce((res, key)=>{
        res[key] = key;
        return res;
    }, Object.create(null));
}
module.exports.InputValidityState = $54643cf72ee16135$var$strEnum([
    'badInput',
    'customError',
    'patternMismatch',
    'rangeOverflow',
    'rangeUnderflow',
    'stepMismatch',
    'tooLong',
    'tooShort',
    'typeMismatch',
    'valid',
    'valueMissing'
]);

});



parcelRegister("6FFYQ", function(module, exports) {
"use strict";
var $4db722d15734a9d4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormArray = void 0;

var $bq6Hs = parcelRequire("bq6Hs");
class $4db722d15734a9d4$var$FormArray {
    constructor(controls = [], nameOrOptions = ''){
        this.controls = [];
        this.valid = true;
        this.invalid = false;
        this.errors = {};
        this.options = {};
        this.subscriptions = new Map();
        this.controls = controls;
        if (typeof nameOrOptions === 'string') this.name = nameOrOptions;
        else if (typeof nameOrOptions === 'function') this.options = {
            itemFactory: nameOrOptions
        };
        else this.options = nameOrOptions;
        this._valueChanges = new $bq6Hs.BehaviorSubject(this.value);
        this.valueChanges = this._valueChanges;
        this.controls.forEach((c)=>this.subscribeToControl(c));
    }
    get value() {
        return this.controls.map((c)=>c.value);
    }
    getOptions() {
        return this.options;
    }
    setOptions(options) {
        this.options = Object.assign(Object.assign({}, this.options), options);
        this.controls.forEach((c, index)=>{
            c.setOptions(Object.assign(Object.assign({}, options), {
                namespace: `${this.name}[${index}]`
            }));
        });
    }
    push(control) {
        return $4db722d15734a9d4$var$__awaiter(this, void 0, void 0, function*() {
            this.controls.push(control);
            this.subscribeToControl(control);
            const index = this.controls.length - 1;
            control.setOptions(Object.assign(Object.assign(Object.assign({}, this.options), control.getOptions()), {
                namespace: `${this.name}[${index}]`
            }));
            this.updateValue();
            this.requestUpdate();
            if (this.parentElement) {
                yield this.parentElement.updateComplete;
                control.setParentElement(this.parentElement);
                if (this.form) {
                    control.setFormElement(this.form);
                    control.init();
                } else if (control.getFormElement()) control.init();
                else if (this.controls[0] && this.controls[0].getFormElement()) {
                    control.setFormElement(this.controls[0].getFormElement());
                    control.init();
                }
            }
        });
    }
    removeAt(index) {
        const control = this.controls[index];
        if (this.subscriptions.has(control)) {
            this.subscriptions.get(control).unsubscribe();
            this.subscriptions.delete(control);
        }
        this.controls.splice(index, 1);
        this.updateValue();
        this.requestUpdate();
    }
    subscribeToControl(control) {
        if (control.valueChanges) this.subscriptions.set(control, control.valueChanges.subscribe(()=>{
            this.updateValue();
        }));
    }
    unsubscribe() {
        this.subscriptions.forEach((sub)=>sub.unsubscribe());
        this.subscriptions.clear();
        this.controls.forEach((c)=>{
            var _a;
            return (_a = c.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(c);
        });
    }
    updateValue() {
        this._valueChanges.next(this.value);
    }
    requestUpdate() {
        var _a;
        (_a = this.parentElement) === null || _a === void 0 || _a.requestUpdate();
    }
    setParentElement(parent) {
        this.parentElement = parent;
        this.controls.forEach((c)=>c.setParentElement(parent));
    }
    setFormElement(form) {
        this.form = form;
        this.controls.forEach((c)=>c.setFormElement(form));
    }
    init() {
        this.controls.forEach((c)=>c.init());
    }
    getParentElement() {
        return this.parentElement;
    }
    // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set value(values) {
        if (!Array.isArray(values)) return;
        values.forEach((v, i)=>{
            this.controls[i] && (this.controls[i].value = v);
        });
        this.updateValue();
    }
    patchValue(values) {
        if (!Array.isArray(values)) return;
        values.forEach((v, i)=>{
            const control = this.controls[i];
            if (control) control.patchValue ? control.patchValue(v) : control.value = v;
            else if (this.options.itemFactory) this.push(this.options.itemFactory(v));
        });
        this.updateValue();
    }
    updateValueAndValidity() {
        return $4db722d15734a9d4$var$__awaiter(this, void 0, void 0, function*() {
            this.valid = true;
            this.invalid = false;
            this.errors = {};
            const errors = [];
            for (const [index, control] of this.controls.entries())if (control.updateValueAndValidity) {
                const result = yield control.updateValueAndValidity();
                if (control.invalid) {
                    this.valid = false;
                    this.invalid = true;
                    this.errors[index] = result;
                    errors.push(...result);
                }
            }
            return errors;
        });
    }
}
module.exports.FormArray = $4db722d15734a9d4$var$FormArray;

});


parcelRegister("f18Kf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputStyle = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.InputStyle = (0, $4TeKW.css)`
  input[type='range'] {
    -webkit-appearance: slider-horizontal;
    color: rgb(157, 150, 142);
    border: initial;
    
  }

  .rx-input,
  .rx-select,
  .rx-textarea {
    max-width: 100%;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    color: #666;
    border: 1px solid #e5e5e5;
    transition: 0.2s ease-in-out;
    transition-property: color, background-color, border;
    outline: none;
  }
  .rx-radio,
  .rx-checkbox {
    display: inline-block;
    height: 16px;
    width: 16px;
    overflow: hidden;
    margin-top: -4px;
    vertical-align: middle;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border: 1px solid #ccc;
    transition: 0.2s ease-in-out;
    transition-property: background-color, border;
    cursor: pointer;
  }
  .rx-range {
    box-sizing: border-box;
    margin: 0;
    vertical-align: middle;
    max-width: 100%;
    width: 100%;
    -webkit-appearance: none;
    background: transparent;
    padding: 0;
  }

  .rx-checkbox:checked {
    background-color: #1e87f0;
    background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2211%22%20viewBox%3D%220%200%2014%2011%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23fff%22%20points%3D%2212%201%205%207.5%202%205%201%205.5%205%2010%2013%201.5%22%20%2F%3E%0A%3C%2Fsvg%3E%0A');
  }
  .rx-radio {
    border-radius: 50%;
  }
  .rx-radio:checked {
    background-color: #1e87f0;
    background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22%23fff%22%20cx%3D%228%22%20cy%3D%228%22%20r%3D%222%22%20%2F%3E%0A%3C%2Fsvg%3E');
  }
  .rx-select {
    height: 40px;
    vertical-align: middle;
    display: inline-block;
    background: #fff;
  }
  .rx-input {
    height: 40px;
    vertical-align: middle;
    display: inline-block;
  }
  .rx-textarea {
    padding-top: 4px;
    padding-bottom: 4px;
    padding: 15px;
    vertical-align: top;
  }
  .rx-danger {
    color: #a94442;
    border-color: #a94442;
  }
  .rx-success {
    color: #32d296;
    border-color: #32d296;
  }
  .rx-outline:focus {
    outline: none;
    /* outline-color: blue; */
  }
  .rx-disabled {
    background-color: #f8f8f8;
    color: #999;
    border-color: #e5e5e5;
  }
  /* Switch */
  .rx-switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .rx-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .rx-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .rx-slider:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .rx-switch input:checked + .rx-slider {
    background-color: #2196f3;
  }

  .rx-switch input:focus + .rx-slider {
    box-shadow: 0 0 1px #2196f3;
  }

  .rx-switch input:checked + .rx-slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .rx-slider {
    border-radius: 34px;
  }

  .rx-slider:before {
    border-radius: 50%;
  }
`; /*
<label class="rx-switch">
  <input type="checkbox" checked />
  <span class="rx-slider"></span>
</label>
*/ 

});

parcelRegister("htU1w", function(module, exports) {

$parcel$export(module.exports, "BaseComponentWithLoading", () => $86d6d90acc30eacf$export$afa793ced97e7b98);

var $4TeKW = parcelRequire("4TeKW");

var $bq6Hs = parcelRequire("bq6Hs");
var $4DDzB = parcelRequire("4DDzB");
var $g5fNy = parcelRequire("g5fNy");

var $gD6ig = parcelRequire("gD6ig");

var $gKw0u = parcelRequire("gKw0u");
class $86d6d90acc30eacf$export$afa793ced97e7b98 extends (0, $gKw0u.BaseComponent) {
    showLoading() {
        this.loading.next(true);
    }
    hideLoading() {
        this.loading.next(false);
    }
    getLoadingTemplate() {
        return (0, $4TeKW.async)(this.loadingTemplate);
    }
    isLoading() {
        return this.loading.getValue();
    }
    constructor(...args){
        super(...args), this.loading = new (0, $bq6Hs.BehaviorSubject)(false), this.loadingTemplate = this.loading.pipe((0, $gD6ig.mergeMap)((v)=>(0, $4DDzB.iif)(()=>v, (0, $g5fNy.of)((0, $4TeKW.html)` <loading-screen-component></loading-screen-component> `), (0, $g5fNy.of)(''))));
    }
}

});
parcelRegister("gKw0u", function(module, exports) {

$parcel$export(module.exports, "BaseComponent", () => $eb2febf21f0ae09b$export$55ae5207ce896a6b);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $4TeKW = parcelRequire("4TeKW");

var $5JMLH = parcelRequire("5JMLH");
class $eb2febf21f0ae09b$export$55ae5207ce896a6b extends (0, $4TeKW.LitElement) {
    // createRenderRoot() {
    //   return this;
    // }
    query(options, raw) {
        if (!raw) options.query = (0, $2O1GU.importQuery)(options.query);
        return (0, $5JMLH.from)(this.graphql.watchQuery(options));
    }
    mutate(options, raw) {
        if (!raw) options.mutation = (0, $2O1GU.importQuery)(options.mutation);
        return (0, $5JMLH.from)(this.graphql.mutate(options));
    }
    subscribe(options, raw) {
        if (!raw) options.query = (0, $2O1GU.importQuery)(options.query);
        return (0, $5JMLH.from)(this.graphql.subscribe(options));
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Injector)((0, $2O1GU.ApolloClient))
], $eb2febf21f0ae09b$export$55ae5207ce896a6b.prototype, "graphql", void 0);

});


parcelRegister("8Mkyx", function(module, exports) {

$parcel$export(module.exports, "LoginFormModel", () => $ce6d45999d5a8085$export$5a221b755e67e623);
class $ce6d45999d5a8085$export$5a221b755e67e623 {
    constructor(){
        this.password = '';
        this.email = '';
        this.rememberMe = false;
    }
}

});

parcelRegister("8dAaL", function(module, exports) {
module.exports = Promise.all([
    import("dS2MF"),
    import("gTTmQ")
]).then(()=>parcelRequire('ftW8f'));

});


parcelRegister("4pri5", function(module, exports) {

$parcel$export(module.exports, "SocialComponent", () => $ee4e14a71c372be5$export$1bcb3bf7d8414375);

var $deWeK = parcelRequire("deWeK");

var $4cteG = parcelRequire("4cteG");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $gKw0u = parcelRequire("gKw0u");

var $cDzby = parcelRequire("cDzby");

var $lNnaw = parcelRequire("lNnaw");
var $3dOhR = parcelRequire("3dOhR");
class $ee4e14a71c372be5$export$1bcb3bf7d8414375 extends (0, $gKw0u.BaseComponent) {
    loginWithGithub() {
        this.socialService.signInWithGithub((provider)=>{
            provider.addScope('repo');
            provider.addScope('delete_repo');
            provider.addScope('aaa');
            provider.setCustomParameters({
                allow_signup: 'false'
            });
            return provider;
        }).pipe((0, $3dOhR.tap)((result)=>this.githubService.setGithubUserName(result.additionalUserInfo.username)), (0, $3dOhR.tap)((result)=>this.githubService.setAccessToken(result.credential['accessToken'])), (0, $lNnaw.switchMap)((data)=>this.mutate({
                mutation: 'create-user-mutation.graphql',
                variables: {
                    githubAccessToken: this.githubService.getAccessToken(),
                    payload: {
                        photoURL: data.user.photoURL
                    }
                }
            })), (0, $3dOhR.tap)(()=>this.goToProjects()), (0, $3dOhR.tap)(()=>this.socialService.userloggedIn())).subscribe();
    }
    signInWithGoogle() {
        this.socialService.signInWithGoogle().pipe((0, $lNnaw.switchMap)((data)=>this.mutate({
                mutation: 'create-user-mutation.graphql',
                variables: {
                    /* TODO: How to get access token here when logging in with google ? Probably another screen ? */ githubAccessToken: this.githubService.getAccessToken() ?? '',
                    payload: {
                        photoURL: data.user.photoURL
                    }
                }
            }))).subscribe(this.goToProjects);
    }
    constructor(...args){
        super(...args), this.goToProjects = ()=>{
            this.router.go('/projects');
        };
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $ee4e14a71c372be5$export$1bcb3bf7d8414375.prototype, "socialService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $4cteG.GithubService))
], $ee4e14a71c372be5$export$1bcb3bf7d8414375.prototype, "githubService", void 0);
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $ee4e14a71c372be5$export$1bcb3bf7d8414375.prototype, "router", void 0);
$ee4e14a71c372be5$export$1bcb3bf7d8414375 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'social-login-container',
        style: (0, $4TeKW.css)`
    .button {
      padding-bottom: 10px;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <div class="button">
        <social-login-button type="github" @click=${this.loginWithGithub}> Login with GitHub </social-login-button>

        <social-login-button type="google" @click=${this.signInWithGoogle}> Signup with Google </social-login-button>
      </div>
    `;
        }
    })
], $ee4e14a71c372be5$export$1bcb3bf7d8414375);

});

parcelRegister("liGXl", function(module, exports) {

$parcel$export(module.exports, "NavbarComponent", () => $bcbfd04b1a721902$export$7a91bf930e5240cd);
/* eslint-disable lit/binding-positions */ 
var $deWeK = parcelRequire("deWeK");
parcelRequire("5VLZn");
parcelRequire("lrK7C");

var $a7yas = parcelRequire("a7yas");

var $djGtt = parcelRequire("djGtt");

var $285ah = parcelRequire("285ah");

var $jM6nT = parcelRequire("jM6nT");

var $6ppqI = parcelRequire("6ppqI");

var $613YX = parcelRequire("613YX");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $2d0B8 = parcelRequire("2d0B8");

var $4FpwJ = parcelRequire("4FpwJ");

var $6SRrK = parcelRequire("6SRrK");

var $1P0iY = parcelRequire("1P0iY");

var $cDzby = parcelRequire("cDzby");

var $cdTWx = parcelRequire("cdTWx");
var $g5fNy = parcelRequire("g5fNy");

var $j7eyO = parcelRequire("j7eyO");
var $gawXH = parcelRequire("gawXH");
var $9wU3T = parcelRequire("9wU3T");
var $lNnaw = parcelRequire("lNnaw");
const $bcbfd04b1a721902$var$style = (0, $4TeKW.css)`
  ${(0, $a7yas.projectSharedCss)}
  .spacer {
    flex: 1 3 auto;
  }
  .center {
    text-align: center;
  }
  .pointer {
    cursor: pointer;
  }
  a {
    text-decoration: none;
  }
  h2 {
    cursor: pointer;
    padding: 10px 20px;
    position: relative;
    font-size: 1.25em;
    cursor: pointer;
    margin: 0px;
    font-weight: 400;
  }

  h2:after {
    background: none repeat scroll 0 0 transparent;
    bottom: 0;
    content: '';
    display: block;
    height: 2px;
    left: 50%;
    position: absolute;
    background: #c1c9d3;
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
  }
  h2:hover:after {
    width: 100%;
    left: 0;
  }
  @media screen and (max-height: 300px) {
    ul {
      margin-top: 40px;
    }
  }

  .container2 {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.22);
  }
  /* .container2 {
  box-shadow: 0 5px 5px rgba(162, 162, 162, 0.25),
    0 5px 5px rgba(0, 0, 0, 0.22);
} */
  .element {
    -webkit-transition: height 2s; /* For Safari 3.1 to 6.0 */
    transition: height 2s;
  }

  .profile-dropdown:hover {
    opacity: 0.7;
  }

  nav {
    box-shadow: rgb(0 0 0 / 8%) 0px 1px 2px, rgb(0 0 0 / 14%) 0px 1px 2px;
  }

  nav:hover {
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s;
  }
`;
const $bcbfd04b1a721902$var$Providers = (0, $613YX.DefineDependencies)((0, $2d0B8.ResponsiveService), (0, $cDzby.SocialService), (0, $jM6nT.ProjectsService), (0, $285ah.LocalStorageService))((0, $1t8Wn.Container));
class $bcbfd04b1a721902$export$7a91bf930e5240cd extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.buttonsClass = {
            block: true,
            'mt-4': true,
            'lg:inline-block': true,
            'lg:mt-0': true,
            'hover:text-white': true,
            'mr-5': true,
            center: true
        };
    }
}
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $bcbfd04b1a721902$export$7a91bf930e5240cd.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $djGtt.PrefetchService))
], $bcbfd04b1a721902$export$7a91bf930e5240cd.prototype, "prefetch", void 0);





$bcbfd04b1a721902$export$7a91bf930e5240cd = (0, $deWeK.__decorate)([
    (0, $613YX.Component)({
        Settings: {
            selector: 'navbar-component',
            style: (0, $4TeKW.css)`
      ${$bcbfd04b1a721902$var$style} .anim-rotate {
        animation: rotate 1s linear infinite;
      }
      nav {
        display: flex;
        padding: 0.7rem;
      }
      @media screen and (max-width: 640px) {
        nav {
          display: block;
        }
      }

      div {
        user-select: none;
      }

      ${(0, $1P0iY.BxDropdownStyle)}

      bx-dropdown::part(trigger-button) {
        width: 160px;
      }
    `,
            modifiers: [
                ...(0, $6ppqI.TranslateModifiers)
            ]
        },
        Providers: $bcbfd04b1a721902$var$Providers,
        State ([responsive, socialService, projectService, localStorage]) {
            return (0, $cdTWx.combineLatest)([
                socialService.checkLoggedIn().pipe((0, $9wU3T.startWith)(false), (0, $lNnaw.switchMap)((loggedIn)=>loggedIn ? projectService.listProjects().pipe((0, $9wU3T.startWith)([]), (0, $j7eyO.catchError)(()=>(0, $g5fNy.of)([]))) : (0, $g5fNy.of)([]))),
                socialService.isLoggedIn.pipe((0, $9wU3T.startWith)(false)),
                responsive.width.pipe((0, $9wU3T.startWith)(window.innerWidth), (0, $gawXH.map)((width)=>width > 600)),
                responsive.width.pipe((0, $9wU3T.startWith)(window.innerWidth), (0, $gawXH.map)((width)=>width < 600)),
                localStorage.onUpdated('selected-project').pipe((0, $9wU3T.startWith)(null))
            ]).pipe((0, $gawXH.map)(([projects, isLoggedIn, isNavbarOpened, isMobile, selectedProject])=>({
                    projects: projects,
                    isLoggedIn: isLoggedIn,
                    isNavbarOpened: isNavbarOpened,
                    isMobile: isMobile,
                    theme: localStorage.get('dark-mode') || 'light',
                    selectedProject: selectedProject
                })));
        },
        Render: ([, , , localStorage])=>function(state, setState) {
                const { projects: projects, isLoggedIn: isLoggedIn, isNavbarOpened: isNavbarOpened, isMobile: isMobile, theme: theme } = state;
                return (0, $4TeKW.html)`
        <!-- <div style="animation: rotate 1s linear infinite">
    ${(0, $4TeKW.svg)`<svg width="20px" height="20px" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path opacity=".5" d="M8 15A7 7 0 108 1a7 7 0 000 14v0z" stroke="#dbab0a" stroke-width="2"></path>
        <path d="M15 8a7 7 0 01-7 7" stroke="#dbab0a" stroke-width="2"></path>
        <path d="M8 12a4 4 0 100-8 4 4 0 000 8z" fill="#dbab0a"></path>
      </svg>`}
   </div> -->

        <nav>
          <div style="display: flex">
            <div @click=${()=>this.router.go(isLoggedIn ? '/projects' : '')} style="cursor: pointer; display: flex">
              <span style="width:40px;">${0, $4FpwJ.Logo}</span>
              <div
                style="white-space: nowrap;position: relative;margin-left: 10px; font-size: 18px; margin-top: 10px; font-weight: bold;"
              >
                Graphql Server
              </div>
            </div>
            <span class="spacer"></span>
            ${isMobile ? (0, $4TeKW.html)`<div>
                  <hamburger-component
                    @click=${()=>{
                    state.isNavbarOpened = !isNavbarOpened;
                    setState({
                        ...state
                    });
                }}
                    .active=${isNavbarOpened}
                  ></hamburger-component>
                </div>` : (0, $4TeKW.html)``}
          </div>
          <span class="spacer"></span>

          ${isNavbarOpened ? (0, $4TeKW.html)`
                ${isLoggedIn ? (0, $4TeKW.html)`
                      <div>
                        <a
                          @click=${()=>{
                    this.router.go('/apps');
                }}
                        >
                          <h2 translate>Apps</h2>
                        </a>
                      </div>

                      <!-- <div>
              <a
               @mouseover=${()=>this.prefetch.fetch((parcelRequire("6tvht")))}
               @click=${()=>{
                    this.router.go('/teams');
                }}
              >
               <h2>Teams</h2>
              </a>
             </div> -->
                      <div style="  margin-right: 15px;">
                        <a
                          @mouseover=${()=>this.prefetch.fetch((parcelRequire("8dAaL")))}
                          @click=${()=>{
                    this.router.go('/projects');
                }}
                        >
                          <h2 translate>Projects</h2>
                        </a>
                      </div>

                      <div style="display: flex">
                        <div style="position: relative; top: 5px;">
                          ${projects.length ? (0, $4TeKW.html)`
                                <div>
                                  <div style="margin-right: 10px;">
                                    <bx-dropdown
                                      @bx-dropdown-selected=${(e)=>{
                    const project = projects.find((p)=>p.id === e.currentTarget.value);
                    localStorage.update('selected-project', project?.name);
                    this.router.go(`/projects/${e.currentTarget.value}`);
                }}
                                      trigger-content=${localStorage.get('selected-project') || projects[0]?.name}
                                    >
                                      ${projects.map((project)=>(0, $4TeKW.html)`<bx-dropdown-item value=${project.id}
                                            >${project.name}</bx-dropdown-item
                                          > `)}
                                    </bx-dropdown>
                                  </div>
                                </div>
                              ` : ''}
                        </div>
                        <div
                          style="top: 6px;position: relative;cursor: pointer; padding-right:10px;"
                          @click=${()=>{
                    state.theme = theme === 'light' ? 'dark' : 'light';
                    setState({
                        ...state
                    });
                    (0, $6SRrK.changeTheme)(state.theme);
                }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 16 16"
                            height="34"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M11.67 8.658a3.661 3.661 0 0 0-.781 1.114 3.28 3.28 0 0 0-.268 1.329v1.6a1.304 1.304 0 0 1-.794 1.197 1.282 1.282 0 0 1-.509.102H7.712a1.285 1.285 0 0 1-.922-.379 1.303 1.303 0 0 1-.38-.92v-1.6c0-.479-.092-.921-.274-1.329a3.556 3.556 0 0 0-.776-1.114 4.689 4.689 0 0 1-1.006-1.437A4.187 4.187 0 0 1 4 5.5a4.432 4.432 0 0 1 .616-2.27c.197-.336.432-.64.705-.914a4.6 4.6 0 0 1 .911-.702c.338-.196.7-.348 1.084-.454a4.45 4.45 0 0 1 1.2-.16 4.476 4.476 0 0 1 2.276.614 4.475 4.475 0 0 1 1.622 1.616 4.438 4.438 0 0 1 .616 2.27c0 .617-.117 1.191-.353 1.721a4.69 4.69 0 0 1-1.006 1.437zM9.623 10.5H7.409v2.201c0 .081.028.15.09.212a.29.29 0 0 0 .213.09h1.606a.289.289 0 0 0 .213-.09.286.286 0 0 0 .09-.212V10.5z"
                            ></path>
                          </svg>
                        </div>
                        <div style="position: relative; top: 5px;">
                          <notifications-feed></notifications-feed>
                        </div>
                        <div style="position: relative;top: 5px;">
                          <user-profile-menu></user-profile-menu>
                        </div>
                      </div>
                      <!-- <div></div> -->
                    ` : (0, $4TeKW.html)`
                      <div>
                        <a
                          style="color: var(--global-color, black);"
                          href="https://github.com/Stradivario/gapi"
                          target="_blank"
                          class=${(0, $4TeKW.classMap)(this.buttonsClass)}
                        >
                          <h2>Github</h2>
                        </a>
                      </div>
                      <div>
                        <a
                          @mouseover=${()=>this.prefetch.fetch((parcelRequire("hEGse")))}
                          @click=${()=>this.router.go('/roadmap/')}
                          class=${(0, $4TeKW.classMap)(this.buttonsClass)}
                        >
                          <h2>Roadmap</h2>
                        </a>
                      </div>
                      <div>
                        <a
                          @mouseover=${()=>this.prefetch.fetch((parcelRequire("cN8SV")))}
                          @click=${()=>this.router.go('/pricing/')}
                          class=${(0, $4TeKW.classMap)(this.buttonsClass)}
                        >
                          <h2>Pricing</h2>
                        </a>
                      </div>
                      <div>
                        <a
                          @mouseover=${()=>this.prefetch.fetch((parcelRequire("iXeFu")))}
                          @click=${()=>this.router.go('/about/')}
                          class=${(0, $4TeKW.classMap)(this.buttonsClass)}
                        >
                          <h2>About</h2>
                        </a>
                      </div>
                      <span class="spacer"></span>
                      <div>
                        <a @click=${()=>this.router.go('/login/')} class=${(0, $4TeKW.classMap)(this.buttonsClass)}>
                          <h2>Login</h2>
                        </a>
                      </div>
                      <div>
                        <a @click=${()=>this.router.go('/signup/')} class=${(0, $4TeKW.classMap)(this.buttonsClass)}>
                          <h2>Signup</h2>
                        </a>
                      </div>
                    `}
              ` : ''}
        </nav>
      `;
            }
    })
], $bcbfd04b1a721902$export$7a91bf930e5240cd);

});
parcelRegister("5VLZn", function(module, exports) {

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");
class $bccdbd1518ef25c3$export$b055129e0c272c94 extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.textColor = 'white';
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $bccdbd1518ef25c3$export$b055129e0c272c94.prototype, "muted", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $bccdbd1518ef25c3$export$b055129e0c272c94.prototype, "text", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $bccdbd1518ef25c3$export$b055129e0c272c94.prototype, "color", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $bccdbd1518ef25c3$export$b055129e0c272c94.prototype, "textColor", void 0);
$bccdbd1518ef25c3$export$b055129e0c272c94 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'app-button',
        style: (0, $4TeKW.css)`
    .container {
      padding: 14px;
      text-align: center;
      min-width: 100px;
      font-weight: 500;
    }

    .button {
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      cursor: pointer;

      transition: background 0.8s;
      user-select: none;
      .active {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      }
    }

    .button:hover {
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
      color: white;
      background: #a6463e;
    }

    .button:active {
      background-color: #c0998d;
      background-size: 100%;
      transition: background 0s;
    }

    .button:focus {
      outline: 0 !important;
    }

    .active {
      background-color: #bc471f;
    }

    .login {
      background-color: #2e8b9f;
    }

    .muted {
      background-color: none;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <div
        class=${(0, $4TeKW.classMap)({
                container: true,
                button: true,
                muted: !this.muted,
                active: this.muted
            })}
        style="color: ${this.textColor}; background-color: ${this.color}"
      >
        ${this.text}
      </div>
    `;
        }
    })
], $bccdbd1518ef25c3$export$b055129e0c272c94);

});

parcelRegister("lrK7C", function(module, exports) {

var $deWeK = parcelRequire("deWeK");

var $djGtt = parcelRequire("djGtt");

var $6ppqI = parcelRequire("6ppqI");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $iWHsw = parcelRequire("iWHsw");

var $cDzby = parcelRequire("cDzby");

var $cdTWx = parcelRequire("cdTWx");

var $gawXH = parcelRequire("gawXH");

const $047a46c86ecc3582$var$profilePicture = new URL((parcelRequire("775dD"))).href;
class $047a46c86ecc3582$export$dedcbb5559e8c44f extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $047a46c86ecc3582$export$dedcbb5559e8c44f.prototype, "socialService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $iWHsw.ResponsiveService))
], $047a46c86ecc3582$export$dedcbb5559e8c44f.prototype, "responsive", void 0);
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $047a46c86ecc3582$export$dedcbb5559e8c44f.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $djGtt.PrefetchService))
], $047a46c86ecc3582$export$dedcbb5559e8c44f.prototype, "prefetch", void 0);

$047a46c86ecc3582$export$dedcbb5559e8c44f = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'user-profile-menu',
        modifiers: [
            ...(0, $6ppqI.TranslateModifiers)
        ],
        template () {
            return (0, $4TeKW.html)`
      <rx-monad>
        <rx-state
          .value=${(0, $cdTWx.combineLatest)([
                this.socialService.getUser(),
                this.responsive.width
            ]).pipe((0, $gawXH.map)(([user, width])=>[
                    user,
                    width < 600
                ]))}
        ></rx-state>
        <rx-style
          .value=${(0, $4TeKW.css)`
            .image {
              border-radius: 50%;
              width: 30px;
              height: 30px;
              border: 2px solid var(--menu-profile-border-color, #949494);
            }
          `}
        ></rx-style>
        <rx-render
          .state=${([user, mobile])=>(0, $4TeKW.html)`
            <dropdown-component
              .marginLeft=${mobile ? '0px' : '-240px'}
              @mouseover=${()=>this.prefetch.fetch((parcelRequire("kaBGH")))}
              @itemClicked=${(event)=>{
                    if (event.detail === 'Settings') this.router.go('/profile/settings');
                    if (event.detail === 'Logout') this.socialService.signOut().subscribe(()=>this.router.go('/'));
                    if (event.detail === 'Admin') this.router.go('/admin');
                    if (event.detail === 'Iot') this.router.go('/iot');
                    if (event.detail === 'Payments') this.router.go('/payments');
                }}
              .menuItems=${user.email === 'kristiqn.tachev@gmail.com' || user.email === 'p.kolevaa@gmail.com' ? [
                    'Iot',
                    'Admin',
                    'Settings',
                    'Logout' /* 'Payments' */ 
                ] : [
                    'Settings',
                    'Logout' /* 'Payments' */ 
                ]}
            >
              <div slot="first-item" style="color: black; padding: 15px;    display: grid;">
                <strong
                  >${user && user.displayName && user.displayName.length > 40 ? user.displayName.match(/\b(\w)/g).join('') : user.displayName}</strong
                >
                <span style="color: gray">${user.email}</span>
              </div>
              ${user.photoURL ? (0, $4TeKW.html)`
                    <div style="display: flex">
                      <div class="profile-dropdown">
                        <span class="flex: 1 3 auto;"></span>
                        <div>
                          <img class="image" src=${user.photoURL} />
                        </div>
                      </div>
                    </div>
                  ` : (0, $4TeKW.html)` <img class="image" src="${$047a46c86ecc3582$var$profilePicture}" /> `}
            </dropdown-component>
          `}
        ></rx-render>
      </rx-monad>
    `;
        }
    })
], $047a46c86ecc3582$export$dedcbb5559e8c44f);

});
parcelRegister("775dD", function(module, exports) {
module.exports = import.meta.resolve("8RQZu");

});

parcelRegister("kaBGH", function(module, exports) {
module.exports = import("5NnNk").then(()=>parcelRequire('8HY0C'));

});


parcelRegister("a7yas", function(module, exports) {

$parcel$export(module.exports, "projectSharedCss", () => $8da7b38244be054e$export$e7b500296dba2c2f);

var $4TeKW = parcelRequire("4TeKW");

var $f18Kf = parcelRequire("f18Kf");

var $1472X = parcelRequire("1472X");
const $8da7b38244be054e$export$e7b500296dba2c2f = (0, $4TeKW.css)`
  ${(0, $1472X.MainView)}
  ${(0, $f18Kf.InputStyle)}
 .container {
    width: 100%;
  }
  .text {
    font-size: 18px;
    line-height: 14px;
    padding: 20px;
  }
  .context-info {
    font-size: 16px;
  }
  .top {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .image-container {
    height: 64px;
    padding-left: 15px;
    padding-top: 5px;
    width: 102.4px;
    margin-top: 10px;
  }
  .project-container {
    margin-top: 20px;
  }
  .project-container:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  .image-container img {
    display: block;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  .spacer {
    flex: 1 3 auto;
  }
  .flex {
    display: flex;
  }
  .pointer {
    cursor: pointer;
  }

  /* .container-box {
  width: 1000px;
 } */

  @media screen and (max-width: 1000px) {
    .container-box {
      width: 90%;
    }
  }
`;

});

parcelRegister("4FpwJ", function(module, exports) {

$parcel$export(module.exports, "Logo", () => $c2862d293cd4ee7a$export$e6ff31bff12b7ff4);

var $4TeKW = parcelRequire("4TeKW");
const $c2862d293cd4ee7a$export$e6ff31bff12b7ff4 = (0, $4TeKW.svg)`
<svg
 viewBox="0 0 485.878 485.878"
 style="enable-background: new 0 0 485.878 485.878;"
 xml:space="preserve"
>
 <g>
  <rect
   x="99.292"
   y="215.26"
   transform="matrix(-0.8321 -0.5547 0.5547 -0.8321 59.9275 561.5178)"
   style="fill: #1185e0;"
   width="31.348"
   height="112.854"
  />

  <rect
   x="184.422"
   y="242.935"
   transform="matrix(-0.7682 -0.6402 0.6402 -0.7682 268.6176 614.4741)"
   style="fill: #1185e0;"
   width="122.252"
   height="31.347"
  />

  <rect
   x="355.789"
   y="158.847"
   transform="matrix(-0.8842 -0.4672 0.4672 -0.8842 593.8322 601.3008)"
   style="fill: #1185e0;"
   width="31.348"
   height="136.365"
  />
 </g>
 <g>
  <path
   style="fill: #4dcfe0;"
   d="M62.694,423.184C28.212,423.184,0,394.971,0,360.49s28.212-62.694,62.694-62.694
		s62.694,28.212,62.694,62.694S97.176,423.184,62.694,423.184z M62.694,329.143c-17.241,0-31.347,14.106-31.347,31.347
		c0,17.241,14.106,31.347,31.347,31.347s31.347-14.106,31.347-31.347C94.041,343.249,79.935,329.143,62.694,329.143z"
  />
  <path
   style="fill: #4dcfe0;"
   d="M167.184,245.551c-34.482,0-62.694-28.212-62.694-62.694s28.212-62.694,62.694-62.694
		s62.694,28.212,62.694,62.694S201.665,245.551,167.184,245.551z M167.184,151.51c-17.241,0-31.347,14.106-31.347,31.347
		s14.106,31.347,31.347,31.347s31.347-14.106,31.347-31.347S184.424,151.51,167.184,151.51z"
  />
  <path
   style="fill: #4dcfe0;"
   d="M323.918,397.061c-34.482,0-62.694-28.212-62.694-62.694s28.212-62.694,62.694-62.694
		s62.694,28.212,62.694,62.694S358.4,397.061,323.918,397.061z M323.918,303.02c-17.241,0-31.347,14.106-31.347,31.347
		c0,17.241,14.106,31.347,31.347,31.347s31.347-14.106,31.347-31.347S341.159,303.02,323.918,303.02z"
  />
  <path
   style="fill: #4dcfe0;"
   d="M423.184,188.082c-34.482,0-62.694-28.212-62.694-62.694s28.212-62.694,62.694-62.694
		s62.694,28.212,62.694,62.694S457.665,188.082,423.184,188.082z M423.184,94.041c-17.241,0-31.347,14.106-31.347,31.347
		s14.106,31.347,31.347,31.347c17.241,0,31.347-14.106,31.347-31.347S440.424,94.041,423.184,94.041z"
  />
 </g>
</svg>
`;

});

parcelRegister("6SRrK", function(module, exports) {

$parcel$export(module.exports, "palettes", () => $65f4997e7f792010$export$9842ff719f7b293);
$parcel$export(module.exports, "changeTheme", () => $65f4997e7f792010$export$e6eb54368342cb84);

var $285ah = parcelRequire("285ah");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $iWHsw = parcelRequire("iWHsw");
const $65f4997e7f792010$export$9e506772df45260a = (0, $4TeKW.css)`
  :root {
    --global-color: white;
    --global-background: #292c30;
    --global-background-image: linear-gradient(#292c30, #24292f);
    --menu-profile-border-color: white;
    --global-dropdown-menu-bg: white;
    --card-list-bg-color: #e2e4e6;
    --card-container-bg-color: #fff;
    --notification-icon-fill: #fff;
    --menu-profile-border-color: #949494;

    --tabs-menu-hover-color: rgba(255, 255, 255, 1);
    --bx-dropdown-text-color: white;
    --avatar-size: 1.7rem;
    --avatar-count: 5;
    --spinner-stroke-color: currentColor;
  }
`;
const $65f4997e7f792010$export$726bfddb3f724821 = (0, $4TeKW.css)`
  :root {
    --global-color: rgb(3, 25, 63);
    --global-background: #f7f7f7;
    --global-background-image: linear-gradient(#ffffff, #e7e7e7);
    --global-dropdown-menu-bg: var(--global-background, white);
    --card-list-bg-color: #fcfcfc;
    --card-container-bg-color: #f0f0f0;
    --notification-icon-fill: #44a7ef;
    --menu-profile-border-color: #949494;

    --tabs-menu-hover-color: rgba(255, 255, 255, 1);
    --bx-dropdown-text-color: white;
    --avatar-size: 1.7rem;
    --avatar-count: 5;

    --spinner-stroke-color: currentColor;

    /* @vaadin components themes */
    --lumo-contrast-10pct: white;
    --lumo-contrast-20pct: #ededed;
  }
`;
const $65f4997e7f792010$export$9842ff719f7b293 = {
    danger: (0, $4TeKW.css)`
    :root {
      --danger-bg-color: #f2492c;
      --danger-color: #fff;
      --danger-border: 1px solid transparent;
      --danger-hover-color: #d64127;
      --danger-active-color: #bb3a24;
      /* Test css */
      --blue: #0e86ca;
      --indigo: #6610f2;
      --purple: #8410ba;
      --pink: #f0f;
      --red: #930304;
      --orange: #e28b00;
      --yellow: #e28b00;
      --green: #18a006;
      --teal: #20c997;
      --cyan: #17a2b8;
      --white: #fff;
      --gray: #6c757d;
      --gray-dark: #343a40;
      --primary: #0e86ca;
      --secondary: #1c2534;
      --success: #18a006;
      --info: #17a2b8;
      --warning: #e28b00;
      --danger: #930304;
      --light: #f8f9fa;
      --dark: #343a40;
      --breakpoint-xs: 0px;
      --breakpoint-sm: 321px;
      --breakpoint-md: 576px;
      --breakpoint-lg: 961px;
      --breakpoint-xl: 1401px;
      --font-family-sans-serif: 'Open Sans', Helvetica, Arial, sans-serif;
      --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
    }
  `,
    default: (0, $4TeKW.css)`
    :root {
      --default-bg-color: white;
      --default-color: #222;
      --default-border: 1px solid #e5e5e5;
      --default-hover-color: #bbbbbb;
      --default-hover-border: 1px solid #bbbbbb;
      --default-active-color: #8a8a8a;
    }
  `,
    primary: (0, $4TeKW.css)`
    :root {
      --primary-bg-color: #359ec0;
      --primary-color: #fff;
      --primary-border: 1px solid transparent;
      --primary-hover-color: #2e86a3;
      --primary-active-color: #29738b;
    }
  `,
    root: (0, $4TeKW.css)`
    :root {
      --bp-s: 640px;
      --bp-m: 960px;
      --bp-l: 1200px;
      --bp-xl: 1600px;
    }
  `,
    secondary: (0, $4TeKW.css)`
    :root {
      --secondary-bg-color: #222;
      --secondary-color: #fff;
      --secondary-border: 1px solid transparent;
      --secondary-hover-color: #333;
      --secondary-active-color: #000;
    }
  `,
    warning: (0, $4TeKW.css)`
    :root {
      --warning-bg-color: #faa05a;
      --warning-color: #fff;
      --warning-border: 1px solid transparent;
      --warning-hover-color: #e19457;
      --warning-active-color: #ef9a56;
    }
  `,
    myPelete: localStorage.getItem('dark-mode') ? $65f4997e7f792010$export$9e506772df45260a : $65f4997e7f792010$export$726bfddb3f724821
};
function $65f4997e7f792010$export$e6eb54368342cb84(value) {
    const themeService = (0, $1t8Wn.Container).get((0, $iWHsw.DynamicCssService));
    const localStorage1 = (0, $1t8Wn.Container).get((0, $285ah.LocalStorageService));
    if (value === 'dark') {
        localStorage1.update('dark-mode', true);
        $65f4997e7f792010$export$9842ff719f7b293.myPelete = $65f4997e7f792010$export$9e506772df45260a;
    } else {
        localStorage1.remove('dark-mode');
        $65f4997e7f792010$export$9842ff719f7b293.myPelete = $65f4997e7f792010$export$726bfddb3f724821;
    }
    themeService.changeStyle($65f4997e7f792010$export$9842ff719f7b293);
} // css`
 /* :root { */  /* NEW THEME */  /* --global-color: rgb(3, 25, 63);
   --global-background: #f7f7f7;
   --global-background-image: linear-gradient(#ffffff, #e7e7e7);
   --global-dropdown-menu-bg: var(--global-background, white);
   --card-list-bg-color: #fcfcfc;
   --card-container-bg-color: #f0f0f0;
   --notification-icon-fill: #44a7ef;
   --menu-profile-border-color: #949494; */  /* --global-background-radial-0: #f7f7f7;
      --global-background-radial-100: #ffffff; */  /* NEW THEME END*/  /* OLD THEME */  /* --global-color: white;
   --global-background: #292c30;
   --global-background-image: linear-gradient(#292c30, #24292f);
   --menu-profile-border-color: white;
   --global-dropdown-menu-bg: white;
   --card-list-bg-color: #e2e4e6;
   --card-container-bg-color: #fff; */  /* OLD THEME END */  /* --tabs-menu-hover-color: rgba(255, 255, 255, 1);
   --bx-dropdown-text-color: white; */  /* --bx-dropdown-background: var(--global-background, 'rgb(36, 41, 47)'); */  /* --cds-text-01: var(--bx-dropdown-text-color); */  /* --avatar-size: 1.7rem;
   --avatar-count: 5; */  /* linear-gradient(#aeb0b3, #ffffff) */  /* } */  //  `

});

parcelRegister("1P0iY", function(module, exports) {

$parcel$export(module.exports, "BxDropdownStyle", () => $dac38ec3e97413d2$export$9b21b34bcf09aba1);

var $4TeKW = parcelRequire("4TeKW");
const $dac38ec3e97413d2$export$9b21b34bcf09aba1 = (0, $4TeKW.css)`
  bx-dropdown::part(trigger-button) {
    background: var(--bx-dropdown-background);
    outline: none;
  }
`;

});

parcelRegister("6tvht", function(module, exports) {
module.exports = import("7Z3YH").then(()=>parcelRequire('590ky'));

});

parcelRegister("hEGse", function(module, exports) {
module.exports = import("728j2").then(()=>parcelRequire('fFvGj'));

});

parcelRegister("cN8SV", function(module, exports) {
module.exports = import("1lBWw").then(()=>parcelRequire('ZcC7d'));

});

parcelRegister("iXeFu", function(module, exports) {
module.exports = import("aWp3e").then(()=>parcelRequire('c3gu1'));

});


parcelRegister("72Fza", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordComponent", () => $ee1ed7566cd38021$export$f1c1b77f017da25);

var $deWeK = parcelRequire("deWeK");

var $6icTI = parcelRequire("6icTI");

var $dIFEA = parcelRequire("dIFEA");

var $1t8Wn = parcelRequire("1t8Wn");

var $facKu = parcelRequire("facKu");

var $4TeKW = parcelRequire("4TeKW");

var $f18Kf = parcelRequire("f18Kf");

var $cDzby = parcelRequire("cDzby");

var $5kVxA = parcelRequire("5kVxA");
class $ee1ed7566cd38021$export$f1c1b77f017da25 extends (0, $4TeKW.LitElement) {
    onSubmit() {
        this.socialService.resetPassword(this.form.value.email).subscribe(()=>{
            this.emailSend = true;
        }, (e)=>{
            this.error = e;
        });
    }
    async hasErrors() {
        return (await this.form.updateValueAndValidity()).length;
    }
    constructor(...args){
        super(...args), this.model = new (0, $5kVxA.ResetPasswordModel)(), this.form = new (0, $facKu.FormGroup)({
            email: [
                this.model.email,
                [
                    (0, $dIFEA.NetworkErrorValidator),
                    (0, $dIFEA.EmailValidator),
                    (0, $dIFEA.FirebaseAuthValidator)
                ]
            ]
        });
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $ee1ed7566cd38021$export$f1c1b77f017da25.prototype, "socialService", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $ee1ed7566cd38021$export$f1c1b77f017da25.prototype, "emailSend", void 0);
(0, $deWeK.__decorate)([
    (0, $facKu.Form)({
        strategy: 'input',
        name: 'register-form',
        strict: true
    })
], $ee1ed7566cd38021$export$f1c1b77f017da25.prototype, "form", void 0);
$ee1ed7566cd38021$export$f1c1b77f017da25 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'reset-password-component',
        styles: [
            (0, $f18Kf.InputStyle),
            (0, $4TeKW.css)`
      .container {
        padding: 50px;
        margin: 0px auto;
        margin-top: 150px;
        width: 600px;
        background-color: var(--global-background, #282d32);
        border: 1px solid #3c3c3c;
        border-radius: 15px;
        box-shadow: rgba(162, 162, 162, 0.25) 0px 0px 3px, rgba(0, 0, 0, 0.22) 0px 0px 3px;
      }

      .is-invalid {
        box-shadow: 0 0 1px 1px #c95454;
      }

      p {
        margin: 0px;
      }
    `
        ],
        template () {
            return (0, $4TeKW.html)`
      <div class="container">
        <div class="form-group card card-container">
          ${this.emailSend ? (0, $4TeKW.html)`
                <div style="text-align: center;">
                  <p>Success send email to address ${this.form.value.email}</p>
                </div>
              ` : (0, $4TeKW.html)`
                <div style="text-align: center;">
                  <p style="font-weight: 400;font-size: 2em;margin-bottom: 20px;">Forgot password ?</p>
                  <p>Enter the email address associated with your account.</p>
                </div>
                <form
                  name="register-form"
                  class="form-signin ${!this.form.valid ? 'has-error' : ''}"
                  novalidate
                  @submit=${()=>!this.hasErrors() && this.onSubmit()}
                >
                  <p>Email</p>
                  <input name="email" type="email" class="rx-input" placeholder="Email address" required autofocus />
                  ${(0, $6icTI.InputErrorTemplate)(this.form.get('email'))}
                  <div style="height:30px"></div>
                  <rx-button
                    style="width:100%"
                    palette="primary"
                    class="btn btn-lg btn-primary btn-block btn-signin"
                    type="submit"
                  >
                    Reset password
                  </rx-button>
                </form>
              `}
        </div>
      </div>
    `;
        }
    })
], $ee1ed7566cd38021$export$f1c1b77f017da25);

});
parcelRegister("5kVxA", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordModel", () => $b7ded698cd976cb0$export$fe7f75bef97556a9);
class $b7ded698cd976cb0$export$fe7f75bef97556a9 {
    constructor(){
        this.email = '';
    }
}

});


parcelRegister("7KrUD", function(module, exports) {

$parcel$export(module.exports, "RootComponent", () => $331848443ee272f1$export$a8cfaa764443b479);

var $deWeK = parcelRequire("deWeK");
parcelRequire("8CNYU");
parcelRequire("f39eu");
parcelRequire("fXtZx");
parcelRequire("l9hXX");

var $4TeKW = parcelRequire("4TeKW");

var $1dyyg = parcelRequire("1dyyg");

const $331848443ee272f1$var$PlanetBackground = new URL((parcelRequire("itGp0"))).href;
class $331848443ee272f1$export$a8cfaa764443b479 extends (0, $4TeKW.LitElement) {
}
$331848443ee272f1$export$a8cfaa764443b479 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'root-component',
        template () {
            return (0, $4TeKW.html)`
      <div style="margin-top:100px;margin-bottom: 20px;">
        <div></div>
      </div>

      <react-reveal .delay=${0}>
        <flex-grid
          .$items=${[
                (0, $4TeKW.html)`
              <style>
                .container {
                  max-width: 560px;
                }
                .title {
                  font-size: 2.75em;
                  font-weight: 700;
                }
                @media (max-width: 640px) {
                  .container {
                    padding: 0px 20px 0px 20px;
                    text-align: center;
                  }
                }
              </style>
              <div class="container">
                <h1 class="title">It's Time To Build, From Cloud To Edge.</h1>
                <p style="font-size: 1.2em;  line-height: 1.7em;">
                  Build faster, real-time applications and APIs on our secure, programmable stateful-serverless Edge
                  Cloud.
                </p>
              </div>
            `,
                (0, $4TeKW.html)`
              <style>
                figure {
                  width: auto; /*container-width*/
                  overflow: hidden; /*hide bounds of image */
                  margin: 0; /*reset margin of figure tag*/
                  margin-left: -140px;
                }
                figure img {
                  display: block; /*remove inline-block spaces*/
                  width: 100%; /*make image streatch*/
                }
                figure img {
                  /*add to other styles*/
                  margin: -14% 0px;
                }
              </style>
              <figure>
                <img src=${$331848443ee272f1$var$PlanetBackground} />
              </figure>
            `
            ]}
        >
        </flex-grid>
      </react-reveal>
      <div style="   background: white; width: 100%">
        <react-reveal .delay=${250}>
          <second-panel></second-panel>
        </react-reveal>
      </div>
      <div style="height: 30px;"></div>
      <react-reveal .delay=${500}>
        <flex-grid
          .$items=${[
                (0, $4TeKW.html)`
              <style>
                .container {
                  max-width: 560px;
                }
                .title {
                  font-size: 2.75em;
                  font-weight: 700;
                }
                @media (max-width: 640px) {
                  .container {
                    padding: 0px 20px 0px 20px;
                    text-align: center;
                  }
                }
              </style>
              <div class="container">
                <h1 class="title">Instant dev environments.</h1>
                <p style="font-size: 1.2em;  line-height: 1.7em;">
                  Graphql Cloud is an open source universal standard that allows projects to define their own
                  development environment, allowing for consistent, reproducible, and instant environments. Contribute
                  sooner and debug faster.
                </p>
              </div>
            `,
                (0, $4TeKW.html)` <div style="text-align: center;">${(0, $1dyyg.VsCodeIcon)(200, 200)}</div> `
            ]}
        >
        </flex-grid>
      </react-reveal>
      <div style="height: 30px;"></div>
      <div style="background: var(--global-background, white); width: 100%;text-align: center; padding-top: 40px;">
        <react-reveal .delay=${500}>
          <divider-component></divider-component>
        </react-reveal>
      </div>

      <div
        style="background: var(--global-background, white); width: 100%; margin:0 auto; text-align: center;     font-size: 32px;"
      >
        <react-reveal .delay=${750}>
          <rx-divider></rx-divider>
          Infrastructure built for <br /><strong>application developers</strong>
          <div style="height: 30px"></div>
          <rx-divider></rx-divider>
        </react-reveal>
      </div>

      <div>
        <react-reveal .delay=${1000}>
          <subscribe-updates></subscribe-updates>
        </react-reveal>
      </div>
    `;
        }
    })
], $331848443ee272f1$export$a8cfaa764443b479);

});
parcelRegister("8CNYU", function(module, exports) {

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");
class $7e9d50d42852e123$export$ee32b3f277dcf2a9 extends (0, $4TeKW.LitElement) {
}
$7e9d50d42852e123$export$ee32b3f277dcf2a9 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'divider-component',
        style: (0, $4TeKW.css)`
    @keyframes react-reveal {
      0% {
        opacity: 0;
        transform: translate3d(0px, 40px, 0px);
      }
      100% {
        opacity: 1;
        transform: none;
      }
    }
    .home-built-divider {
      display: inline-flex;
      align-items: center;
      margin: 0 auto 32px;
    }
    .divider {
      width: 48px;
    }
    .small-divider {
      width: 8px;
    }
    .circle-icon {
      width: 64px;
      height: 64px;
      border-radius: 32px;
      box-shadow: 0 0 8px 0 rgba(23, 25, 23, 0.2);
      border: 2px solid;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .divider,
    .small-divider {
      height: 2px;
      background: currentColor;
    }
    .home-built-divider .small-orb:first-of-type {
      margin-left: 14px;
    }
    .home-built-divider .small-orb:last-of-type {
      margin-right: 14px;
    }
    .home-built-divider .circle-icon {
      margin: 0 14px;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <div
        class="home-built-divider"
        style="animation-fill-mode: both; animation-name: react-reveal;animation-duration: 700ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; "
      >
        <div class="small-divider"></div>
        <div class="divider"></div>
        <svg class="small-orb" viewBox="0 0 18 18" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 17A8 8 0 109 1a8 8 0 000 16zm4-1.072C11.087 17.033 7.745 14.826 5.536 11 3.326 7.174 3.086 3.176 5 2.072"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            fill-rule="evenodd"
            stroke-linejoin="round"
          ></path>
        </svg>
        <div class="circle-icon">
          <svg viewBox="0 0 34 34" width="34" height="34" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M17 13c8.837 0 16-2.686 16-6s-7.163-6-16-6S1 3.686 1 7s7.163 6 16 6zm0 20c8.837 0 16-2.686 16-6s-7.163-6-16-6-16 2.686-16 6 7.163 6 16 6zM33 7v20M1 27V7m7 25V12"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              fill-rule="evenodd"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
        <svg class="small-orb" viewBox="0 0 18 18" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 17A8 8 0 109 1a8 8 0 000 16zm4-1.072C11.087 17.033 7.745 14.826 5.536 11 3.326 7.174 3.086 3.176 5 2.072"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            fill-rule="evenodd"
            stroke-linejoin="round"
          ></path>
        </svg>
        <div class="divider"></div>
        <div class="small-divider"></div>
      </div>
    `;
        }
    })
], $7e9d50d42852e123$export$ee32b3f277dcf2a9);

});

parcelRegister("f39eu", function(module, exports) {

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $1jYF4 = parcelRequire("1jYF4");

var $62X4s = parcelRequire("62X4s");
const $074642ec5191c151$var$style = (0, $4TeKW.css)`
  .features {
    padding-top: 100px;
    padding-bottom: 100px;

    color: #03193f;
    display: flex;
    flex-direction: row;
  }
  * {
    box-sizing: border-box;
  }
  .features ul {
    margin-left: auto;
    margin-bottom: 0;
    list-style: none;
  }
  .features .text {
    max-width: 450px;
    width: 100%;
    margin-right: 0px;
  }
  .features .text h2 {
    margin-top: 15px;
    margin-bottom: 25px;
    letter-spacing: 0.26px;
    font-size: 36px;
    line-height: 41px;
  }
  @media (max-width: 550px) {
    .features {
      flex-direction: column;
    }
  }
  ${(0, $1jYF4.ReactRevealAnimation)}
  .features .text .point {
    font-size: 22px;
    font-weight: 500;
    line-height: 28px;
    font-weight: 400;
  }
  .features ul li {
    color: #677693;
    font-size: 18px;
    letter-spacing: 0.14px;
    line-height: 28px;
    position: relative;
  }
  .content {
    max-width: calc(1110px + 2rem);
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    margin: 0 auto;
  }
  .features ul li {
    margin-bottom: 10px;
  }
  ul {
    margin: 0px;
  }
  .features ul li .check {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    content: ' ';
    position: absolute;
    left: -30px;
    top: 6px;
  }
`;
class $074642ec5191c151$export$b6b95e56023bdfe5 extends (0, $4TeKW.LitElement) {
}
$074642ec5191c151$export$b6b95e56023bdfe5 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'second-panel',
        style: $074642ec5191c151$var$style,
        template () {
            return (0, $4TeKW.html)`
      <div class="content features">
        <div class="text">
          <div class="point">Remove Inconsistencies</div>
          <h2>Improve Your Team's Workflow</h2>
          <p>
            Graphql Cloud provides a consistent, declarative environment for everyone working on the same project.
            <b>Spend less time configuring, and more time coding.</b>
          </p>
        </div>
        <ul>
          <li>
            <div class="check">${0, $62X4s.CheckMarkIcon}</div>
            <div>
              <b>No more "It works on my machine"</b>, everyone working on the same project is working in the same
              environment.
            </div>
          </li>
          <li>
            <div class="check">${0, $62X4s.CheckMarkIcon}</div>
            <div><b>Stop duplicating effort</b>, source-control and collaborate on the environment.</div>
          </li>
          <li>
            <div class="check">${0, $62X4s.CheckMarkIcon}</div>
            <div><b>Instant set-up</b>, open pre-configured environments straight from GitHub or GitLab.</div>
          </li>
          <li>
            <div class="check">${0, $62X4s.CheckMarkIcon}</div>
            <div><b>Feel production in your dev env</b>, deploy with one click</div>
          </li>
        </ul>
      </div>
    `;
        }
    })
], $074642ec5191c151$export$b6b95e56023bdfe5);

});
parcelRegister("1jYF4", function(module, exports) {

$parcel$export(module.exports, "ReactRevealAnimation", () => $25d67fab54993f22$export$11dd3391923285a9);

var $4TeKW = parcelRequire("4TeKW");
const $25d67fab54993f22$export$11dd3391923285a9 = (0, $4TeKW.css)`
  @keyframes react-reveal {
    0% {
      opacity: 0;
      transform: translate3d(0px, 40px, 0px);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }
`;

});

parcelRegister("62X4s", function(module, exports) {

$parcel$export(module.exports, "CheckMarkIcon", () => $fdad02e9f321120b$export$9759fbee3638143b);

var $4TeKW = parcelRequire("4TeKW");
const $fdad02e9f321120b$export$9759fbee3638143b = (0, $4TeKW.svg)`
<svg  viewBox="0 0 512.00005 512"  xmlns="http://www.w3.org/2000/svg">
    <path d="m502.003906 256c0 135.863281-110.140625 246.003906-246.003906 246.003906s-246-110.140625-246-246.003906 110.136719-246 246-246 246.003906 110.136719 246.003906 246zm0 0" fill="#cbe558" />
    <path d="m341.667969 139.847656-119.167969 119.167969-52.164062-52.164063-56.570313 56.570313 52.164063 52.164063 56.570312 56.566406 175.734375-175.734375zm0 0" fill="#fff" />
    <path d="m222.5 382.152344c-2.652344 0-5.195312-1.054688-7.070312-2.929688l-108.734376-108.730468c-3.90625-3.90625-3.90625-10.238282 0-14.144532l56.566407-56.566406c3.90625-3.90625 10.238281-3.90625 14.144531 0l45.09375 45.09375 112.09375-112.097656c1.875-1.875 4.421875-2.929688 7.074219-2.929688 2.648437 0 5.195312 1.054688 7.070312 2.929688l56.566407 56.570312c3.90625 3.902344 3.90625 10.234375 0 14.140625l-175.734376 175.738281c-1.875 1.875-4.417968 2.925782-7.070312 2.925782zm-94.589844-118.730469 94.589844 94.589844 161.59375-161.59375-42.425781-42.429688-112.097657 112.097657c-3.90625 3.90625-10.238281 3.90625-14.140624 0l-45.09375-45.09375zm0 0" />
    <path d="m255.9375 512c-6.53125 0-13.070312-.25-19.621094-.75-60.835937-4.664062-118.132812-31.027344-161.335937-74.226562-48.351563-48.355469-74.980469-112.640626-74.980469-181.023438 0-68.378906 26.628906-132.667969 74.980469-181.019531 48.351562-48.351563 112.640625-74.980469 181.019531-74.980469 68.382812 0 132.667969 26.628906 181.023438 74.980469 43.199218 43.203125 69.5625 100.5 74.226562 161.335937 4.613281 60.175782-12.144531 120.15625-47.183594 168.898438-3.222656 4.484375-9.472656 5.503906-13.957031 2.28125s-5.503906-9.472656-2.28125-13.957032c67.726563-94.207031 57.234375-222.230468-24.949219-304.417968-92.015625-92.015625-241.738281-92.015625-333.753906 0-92.019531 92.019531-92.019531 241.738281 0 333.757812 82.183594 82.179688 210.210938 92.675782 304.417969 24.945313 4.484375-3.222657 10.730469-2.199219 13.957031 2.285156 3.222656 4.484375 2.199219 10.730469-2.285156 13.957031-43.4375 31.226563-95.804688 47.933594-149.277344 47.933594zm0 0" />
    <path d="m429.953125 439.953125c-2.632813 0-5.210937-1.070313-7.070313-2.929687-1.859374-1.863282-2.929687-4.441407-2.929687-7.070313 0-2.632813 1.070313-5.210937 2.929687-7.070313 1.859376-1.859374 4.4375-2.929687 7.070313-2.929687 2.628906 0 5.207031 1.070313 7.070313 2.929687 1.859374 1.859376 2.929687 4.4375 2.929687 7.070313 0 2.628906-1.070313 5.207031-2.929687 7.070313-1.863282 1.859374-4.441407 2.929687-7.070313 2.929687zm0 0" />
</svg>
`;

});


parcelRegister("fXtZx", function(module, exports) {

var $deWeK = parcelRequire("deWeK");

var $6icTI = parcelRequire("6icTI");

var $dIFEA = parcelRequire("dIFEA");

var $bb0dL = parcelRequire("bb0dL");

var $1t8Wn = parcelRequire("1t8Wn");

var $facKu = parcelRequire("facKu");

var $4TeKW = parcelRequire("4TeKW");

var $f18Kf = parcelRequire("f18Kf");
class $840a0195cf96236c$export$e22bf247bb421a1e extends (0, $4TeKW.LitElement) {
    submit() {
        this.newsLetterService.newsLetterSubscription(this.form.value.email).subscribe((stream)=>{
            console.log(stream);
        });
        console.log(this.form.value.email);
    }
    constructor(...args){
        super(...args), this.form = new (0, $facKu.FormGroup)({
            email: [
                '',
                [
                    (0, $dIFEA.EmailValidator)
                ]
            ]
        });
    }
}
(0, $deWeK.__decorate)([
    (0, $facKu.Form)({
        name: 'form',
        strategy: 'input'
    })
], $840a0195cf96236c$export$e22bf247bb421a1e.prototype, "form", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $bb0dL.NewsLetterService))
], $840a0195cf96236c$export$e22bf247bb421a1e.prototype, "newsLetterService", void 0);
$840a0195cf96236c$export$e22bf247bb421a1e = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'subscribe-updates',
        style: (0, $4TeKW.css)`
    ${(0, $f18Kf.InputStyle)}
    .container {
      width: 400px;
      margin: 0 auto;
    }
    h2,
    h1 {
      text-align: center;
    }
  `,
        template () {
            return (0, $4TeKW.html)`<div class="container">
      <h2>Stay up to date with</h2>
      <h1>Graphql Cloud updates</h1>
      <form
        name="form"
        novalidate
        @submit=${async ()=>await this.form.updateValueAndValidity() && this.form.valid && this.submit()}
      >
        <input placeholder="Email" required name="email" type="email" class="rx-input" />
        <div style="height: 30px;">${(0, $6icTI.InputErrorTemplate)(this.form.get('email'))}</div>
        <rx-button style="width: 100%" palette="warning" type="submit">Subscribe to Updates</rx-button>
      </form>
    </div>`;
        }
    })
], $840a0195cf96236c$export$e22bf247bb421a1e);

});
parcelRegister("bb0dL", function(module, exports) {

$parcel$export(module.exports, "NewsLetterService", () => $d54f724b30fde451$export$576f7d8423713b77);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $gawXH = parcelRequire("gawXH");

var $7X6iT = parcelRequire("7X6iT");
class $d54f724b30fde451$export$576f7d8423713b77 extends (0, $7X6iT.BaseGraphqlService) {
    newsLetterSubscription(email) {
        return this.mutate({
            mutation: 'subscribe-newsletter.mutation.graphql',
            variables: {
                email: email
            }
        }).pipe((0, $gawXH.map)((res)=>res.data.newsLetterSubscription));
    }
}
$d54f724b30fde451$export$576f7d8423713b77 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $d54f724b30fde451$export$576f7d8423713b77);

});


parcelRegister("l9hXX", function(module, exports) {
"use strict";
var $f6585feb62be6b23$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f6585feb62be6b23$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f6585feb62be6b23$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f6585feb62be6b23$var$__exportStar((parcelRequire("dZ8NU")), module.exports);

});
parcelRegister("dZ8NU", function(module, exports) {
"use strict";
var $a2e7cd2d79875555$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a2e7cd2d79875555$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DividerComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $eTG8q = parcelRequire("eTG8q");
/**
 * @customElement rx-divider
 */ let $a2e7cd2d79875555$var$DividerComponent = class DividerComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.type = 'default';
    }
};
$a2e7cd2d79875555$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $a2e7cd2d79875555$var$__metadata("design:type", String)
], $a2e7cd2d79875555$var$DividerComponent.prototype, "type", void 0);
$a2e7cd2d79875555$var$DividerComponent = $a2e7cd2d79875555$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-divider',
        style: $eTG8q.style,
        template () {
            if (this.type === 'icon') return (0, $4TeKW.html)`
        <hr class="icon" />
      `;
            return (0, $4TeKW.html)`
      <hr class="default" />
    `;
        }
    })
], $a2e7cd2d79875555$var$DividerComponent);
module.exports.DividerComponent = $a2e7cd2d79875555$var$DividerComponent;

});
parcelRegister("eTG8q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.style = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.style = (0, $4TeKW.css)`
  .icon {
    margin-bottom: 0;
    position: relative;
    height: 20px;
    background-image: url(data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Ccircle%20fill%3D%22none%22%20stroke%3D%22%23e5e5e5%22%20stroke-width%3D%222%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%227%22%20%2F%3E%0A%3C%2Fsvg%3E%0A);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    margin: 20px 0 20px 0;
  }
  hr {
    border: 0;
  }
  .default {
    overflow: visible;
    text-align: inherit;
    margin: 20px 0 20px 0;
    border: 0;
    border-top: 1px solid #e5e5e5;
  }
  .icon::before {
    right: calc(50% + (50px / 2));
    width: 100%;
    content: '';
    position: absolute;
    top: 50%;
    max-width: calc(50% - (50px / 2));
    border-bottom: 1px solid #e5e5e5;
  }
  .icon::after {
    left: calc(50% + (50px / 2));
    width: 100%;
    content: '';
    position: absolute;
    top: 50%;
    max-width: calc(50% - (50px / 2));
    border-bottom: 1px solid #e5e5e5;
  }
`;

});



parcelRegister("1dyyg", function(module, exports) {

$parcel$export(module.exports, "VsCodeIcon", () => $03ffacdc7f73c708$export$5028c008b21ab7a8);

var $4TeKW = parcelRequire("4TeKW");
const $03ffacdc7f73c708$export$5028c008b21ab7a8 = (width = 150, height = 150)=>(0, $4TeKW.svg)`

<svg xmlns="http://www.w3.org/2000/svg" width=${width + 'px'} height=${height + 'px'} viewBox="0 0 256 256" fill="none">
    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="256" height="256">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M181.534 254.252C185.566 255.823 190.164 255.722 194.234 253.764L246.94 228.403C252.478 225.738 256 220.132 256 213.983V42.0181C256 35.8689 252.478 30.2638 246.94 27.5988L194.234 2.23681C188.893 -0.333132 182.642 0.296344 177.955 3.70418C177.285 4.191 176.647 4.73454 176.049 5.33354L75.149 97.3862L31.1992 64.0247C27.1079 60.9191 21.3853 61.1735 17.5855 64.63L3.48936 77.4525C-1.15853 81.6805 -1.16386 88.9926 3.47785 93.2274L41.5926 128L3.47785 162.773C-1.16386 167.008 -1.15853 174.32 3.48936 178.548L17.5855 191.37C21.3853 194.827 27.1079 195.081 31.1992 191.976L75.149 158.614L176.049 250.667C177.645 252.264 179.519 253.467 181.534 254.252ZM192.039 69.8853L115.479 128L192.039 186.115V69.8853Z" fill="white" />
    </mask>
    <g mask="url(#mask0)">
        <path d="M246.94 27.6383L194.193 2.24138C188.088 -0.698302 180.791 0.541721 175.999 5.33332L3.32371 162.773C-1.32082 167.008 -1.31548 174.32 3.33523 178.548L17.4399 191.37C21.2421 194.827 26.9682 195.081 31.0619 191.976L239.003 34.2269C245.979 28.9347 255.999 33.9103 255.999 42.6667V42.0543C255.999 35.9078 252.478 30.3047 246.94 27.6383Z" fill="#0065A9" />
        <g filter="url(#filter0_d)">
            <path d="M246.94 228.362L194.193 253.759C188.088 256.698 180.791 255.458 175.999 250.667L3.32371 93.2272C-1.32082 88.9925 -1.31548 81.6802 3.33523 77.4523L17.4399 64.6298C21.2421 61.1733 26.9682 60.9188 31.0619 64.0245L239.003 221.773C245.979 227.065 255.999 222.09 255.999 213.333V213.946C255.999 220.092 252.478 225.695 246.94 228.362Z" fill="#007ACC" />
        </g>
        <g filter="url(#filter1_d)">
            <path d="M194.196 253.763C188.089 256.7 180.792 255.459 176 250.667C181.904 256.571 192 252.389 192 244.039V11.9606C192 3.61057 181.904 -0.571175 176 5.33321C180.792 0.541166 188.089 -0.700607 194.196 2.23648L246.934 27.5985C252.476 30.2635 256 35.8686 256 42.0178V213.983C256 220.132 252.476 225.737 246.934 228.402L194.196 253.763Z" fill="#1F9CF0" />
        </g>
        <g style="mix-blend-mode:overlay" opacity="0.25">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M181.378 254.252C185.41 255.822 190.008 255.722 194.077 253.764L246.783 228.402C252.322 225.737 255.844 220.132 255.844 213.983V42.0179C255.844 35.8687 252.322 30.2636 246.784 27.5986L194.077 2.23665C188.737 -0.333299 182.486 0.296177 177.798 3.70401C177.129 4.19083 176.491 4.73437 175.892 5.33337L74.9927 97.386L31.0429 64.0245C26.9517 60.9189 21.229 61.1734 17.4292 64.6298L3.33311 77.4523C-1.31478 81.6803 -1.32011 88.9925 3.3216 93.2273L41.4364 128L3.3216 162.773C-1.32011 167.008 -1.31478 174.32 3.33311 178.548L17.4292 191.37C21.229 194.827 26.9517 195.081 31.0429 191.976L74.9927 158.614L175.892 250.667C177.488 252.264 179.363 253.467 181.378 254.252ZM191.883 69.8851L115.323 128L191.883 186.115V69.8851Z" fill="url(#paint0_linear)" />
        </g>
    </g>
    <defs>
        <filter id="filter0_d" x="-21.4896" y="40.5225" width="298.822" height="236.149" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset />
            <feGaussianBlur stdDeviation="10.6667" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="overlay" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter id="filter1_d" x="154.667" y="-20.6735" width="122.667" height="297.347" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset />
            <feGaussianBlur stdDeviation="10.6667" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="overlay" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <linearGradient id="paint0_linear" x1="127.844" y1="0.659988" x2="127.844" y2="255.34" gradientUnits="userSpaceOnUse">
            <stop stop-color="white" />
            <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
    </defs>
</svg>
`;

});

parcelRegister("itGp0", function(module, exports) {
module.exports = import.meta.resolve("lsjHZ");

});


parcelRegister("lTT35", function(module, exports) {

$parcel$export(module.exports, "SignUpComponent", () => $34a2bdcef8a2b5da$export$21a09d1f1fe41988);

var $deWeK = parcelRequire("deWeK");

var $7lFX5 = parcelRequire("7lFX5");

var $6icTI = parcelRequire("6icTI");

var $Eh7f5 = parcelRequire("Eh7f5");

var $dIFEA = parcelRequire("dIFEA");

var $djGtt = parcelRequire("djGtt");

var $4cteG = parcelRequire("4cteG");

var $1t8Wn = parcelRequire("1t8Wn");

var $facKu = parcelRequire("facKu");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $f18Kf = parcelRequire("f18Kf");

var $htU1w = parcelRequire("htU1w");

var $cDzby = parcelRequire("cDzby");

var $lNnaw = parcelRequire("lNnaw");

var $ithpp = parcelRequire("ithpp");
class $34a2bdcef8a2b5da$export$21a09d1f1fe41988 extends (0, $htU1w.BaseComponentWithLoading) {
    onSubmit() {
        if (this.isLoading()) return;
        this.showLoading();
        this.socialService.createUserWithEmailAndPassword(this.form.value.email, this.form.value.password).pipe((0, $lNnaw.switchMap)((data)=>this.mutate({
                mutation: 'create-user-mutation.graphql',
                variables: {
                    githubAccessToken: this.githubService.getAccessToken(),
                    payload: {
                        photoURL: data.user.photoURL
                    }
                }
            }))).subscribe(()=>{
            this.hideLoading();
            this.router.go('/projects');
        }, async (e)=>{
            this.hideLoading();
            this.error = e;
            await this.form.updateValueAndValidity();
            this.error = '';
        });
    }
    async hasErrors() {
        return (await this.form.updateValueAndValidity()).length;
    }
    constructor(...args){
        super(...args), this.model = new (0, $ithpp.RegisterFormModel)(), this.form = new (0, $facKu.FormGroup)({
            password: [
                this.model.password,
                [
                    (0, $dIFEA.PasswordValidator)
                ]
            ],
            email: [
                this.model.email,
                [
                    (0, $dIFEA.NetworkErrorValidator),
                    (0, $dIFEA.EmailValidator),
                    (0, $dIFEA.FirebaseAuthValidator)
                ]
            ]
        }, (0, $Eh7f5.AppErrors));
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $34a2bdcef8a2b5da$export$21a09d1f1fe41988.prototype, "error", void 0);
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $34a2bdcef8a2b5da$export$21a09d1f1fe41988.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $34a2bdcef8a2b5da$export$21a09d1f1fe41988.prototype, "socialService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $4cteG.GithubService))
], $34a2bdcef8a2b5da$export$21a09d1f1fe41988.prototype, "githubService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $djGtt.PrefetchService))
], $34a2bdcef8a2b5da$export$21a09d1f1fe41988.prototype, "prefetch", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $34a2bdcef8a2b5da$export$21a09d1f1fe41988.prototype, "model", void 0);
(0, $deWeK.__decorate)([
    (0, $facKu.Form)({
        strategy: 'input',
        name: 'register-form',
        strict: true
    })
], $34a2bdcef8a2b5da$export$21a09d1f1fe41988.prototype, "form", void 0);

$34a2bdcef8a2b5da$export$21a09d1f1fe41988 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'signin-component',
        style: (0, $4TeKW.css)`
    ${(0, $f18Kf.InputStyle)}

    .input-has-error {
      background-color: white;
    }
    textarea,
    select,
    input,
    button {
      outline: none;
    }
    input[type='text'],
    input[type='email'],
    input[type='number'],
    textarea,
    fieldset {
      /* required to properly style form
   elements on WebKit based browsers */
      -webkit-appearance: none;

      width: 100%;
      margin: 0;

      font-family: inherit;
      font-size: 90%;

      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }

    .is-invalid {
      box-shadow: 0 0 1px 1px #c95454;
    }

    .container {
      padding: 50px;
      margin: 0px auto;
      margin-top: 150px;
      width: 440px;
      background-color: #f8f8f8;
      border-radius: 15px;
      box-shadow: rgba(162, 162, 162, 0.25) 0px 0px 3px, rgba(0, 0, 0, 0.22) 0px 0px 3px;
    }
    h1,
    p {
      color: black;
    }
    p {
      color: black;
      padding: 0;
      margin: 0;
    }
    input[type='password']:disabled {
      background: #a9a9a9;
    }
    input[type='password']:disabled::placeholder {
      color: white;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      ${this.getLoadingTemplate()}
      <div class="container">
        <div class="form-group card card-container">
          <div style="text-align: center;">
            <p style="font-weight: 400;font-size: 2em;margin-bottom: 20px;">Get started with Graphql Cloud</p>
          </div>
          <div
            @mouseenter=${()=>this.prefetch.fetch((parcelRequire("8dAaL")))}
            style="margin: 0 auto; width: 220px;"
          >
            <social-login-container>Signup with GitHub</social-login-container>
          </div>
          <form
            name="register-form"
            class="form-signin ${!this.form.valid ? 'has-error' : ''}"
            novalidate
            @submit=${()=>!this.hasErrors() && this.onSubmit()}
          >
            <p>Email</p>
            <input name="email" type="email" value=${this.model.email} class="rx-input" placeholder="Email address" />
            <div style="height: 20px;">${(0, $6icTI.InputErrorTemplate)(this.form.get('email'))}</div>

            <p style="margin-top: 10px;">Password</p>
            <input
              type="password"
              value=${this.model.password}
              name="password"
              class="rx-input"
              placeholder="Password"
            />
            <div style="height: 20px;">${(0, $6icTI.InputErrorTemplate)(this.form.get('password'))}</div>

            <div style="height:20px"></div>
            <rx-button style="width:100%" palette="primary" type="submit"> Register </rx-button>
            <rx-button
              style="width:100%; margin-top: 10px;"
              @click=${async ()=>{
                const email = this.form.getValue('email');
                if (!email) {
                    this.form.get('password').disabled = true;
                    return await this.form.updateValueAndValidity();
                }
                const returnUrl = (0, $7lFX5.isDevelopment)() ? `http://localhost:1234/auth/${email}` : `https://${(0, $7lFX5.ENVIRONMENT).DOMAIN_NAME}/auth/${email}`;
                this.socialService.sendSignInLinkToEmail(email, returnUrl).subscribe(()=>{
                    this.router.go(`/signup/success/${email}`);
                }, (e)=>console.error(e));
            }}
              >Send Magic link
            </rx-button>
          </form>
        </div>
      </div>

      <div style="text-align: center; margin-bottom: 30px; margin-top: 10px;">
        Already have an account?<a style="cursor: pointer;color: #359ec0" @click=${()=>this.router.go('/login')}>
          Log in</a
        >
      </div>
    `;
        }
    })
], $34a2bdcef8a2b5da$export$21a09d1f1fe41988);

});
parcelRegister("ithpp", function(module, exports) {

$parcel$export(module.exports, "RegisterFormModel", () => $356ff645c2a1d983$export$dd5d8998db9b6d22);
class $356ff645c2a1d983$export$dd5d8998db9b6d22 {
    constructor(){
        this.password = '';
        this.email = '';
    }
}

});


parcelRegister("gW3jp", function(module, exports) {
"use strict";
var $c544a1d31ac6121c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c544a1d31ac6121c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c544a1d31ac6121c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c544a1d31ac6121c$var$__exportStar((parcelRequire("6KO4q")), module.exports);

$c544a1d31ac6121c$var$__exportStar((parcelRequire("br2xx")), module.exports);

$c544a1d31ac6121c$var$__exportStar((parcelRequire("9PQcx")), module.exports);

});
parcelRegister("6KO4q", function(module, exports) {
"use strict";
var $4eade0dffe08ffe7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4eade0dffe08ffe7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4eade0dffe08ffe7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4eade0dffe08ffe7$var$__createBinding(exports1, m, p);
};
var $4eade0dffe08ffe7$var$ReactiveUiModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactiveUiModule = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $9DBLY = parcelRequire("9DBLY");

var $bq6Hs = parcelRequire("bq6Hs");

var $20K3n = parcelRequire("20K3n");

var $eubPc = parcelRequire("eubPc");

var $krAwj = parcelRequire("krAwj");

var $c7prX = parcelRequire("c7prX");

var $8dUJX = parcelRequire("8dUJX");

var $iWHsw = parcelRequire("iWHsw");

var $9Om4T = parcelRequire("9Om4T");

var $lWX99 = parcelRequire("lWX99");
let $4eade0dffe08ffe7$var$ReactiveUiModule = $4eade0dffe08ffe7$var$ReactiveUiModule_1 = class ReactiveUiModule {
    static forRoot(options = {}) {
        return {
            module: $4eade0dffe08ffe7$var$ReactiveUiModule_1,
            providers: [
                $iWHsw.ResponsiveService,
                {
                    provide: $9DBLY.Palettes,
                    useValue: new $bq6Hs.BehaviorSubject(options.palettes || {
                        root: $lWX99.ROOT,
                        default: $20K3n.DEFAULT,
                        primary: $eubPc.PRIMARY,
                        secondary: $c7prX.SECONDARY,
                        danger: $krAwj.DANGER,
                        warning: $9Om4T.WARNING
                    })
                },
                $8dUJX.DynamicCssService
            ]
        };
    }
};
$4eade0dffe08ffe7$var$ReactiveUiModule = $4eade0dffe08ffe7$var$ReactiveUiModule_1 = $4eade0dffe08ffe7$var$__decorate([
    (0, $1t8Wn.Module)()
], $4eade0dffe08ffe7$var$ReactiveUiModule);
module.exports.ReactiveUiModule = $4eade0dffe08ffe7$var$ReactiveUiModule;

$4eade0dffe08ffe7$var$__exportStar((parcelRequire("1Kd4u")), module.exports);

});
parcelRegister("20K3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.DEFAULT = (0, $4TeKW.css)`
  :root {
    --default-bg-color: transparent;
    --default-color: #222;
    --default-border: 1px solid #e5e5e5;
    --default-hover-color: transparent;
    --default-hover-border: 1px solid #999;
  }
`;

});

parcelRegister("eubPc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PRIMARY = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.PRIMARY = (0, $4TeKW.css)`
  :root {
    --primary-bg-color: #1e87f0;
    --primary-color: #fff;
    --primary-border: 1px solid transparent;
    --primary-hover-color: #0f7ae5;
    --primary-active-color: #0e6dcd;
  }
`;

});

parcelRegister("krAwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DANGER = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.DANGER = (0, $4TeKW.css)`
  :root {
    --danger-bg-color: #f0506e;
    --danger-color: #fff;
    --danger-border: 1px solid transparent;
    --danger-hover-color: #ee395b;
    --danger-active-color: #ec2147;
  }
`;

});

parcelRegister("c7prX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SECONDARY = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.SECONDARY = (0, $4TeKW.css)`
  :root {
    --secondary-bg-color: #222;
    --secondary-color: #fff;
    --secondary-border: 1px solid transparent;
    --secondary-hover-color: #333;
    --secondary-active-color: #000;
  }
`;

});

parcelRegister("9Om4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WARNING = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.WARNING = (0, $4TeKW.css)`
  :root {
    --warning-bg-color: #faa05a;
    --warning-color: #fff;
    --warning-border: 1px solid transparent;
    --warning-hover-color: #e19457;
    --warning-active-color: #ef9a56;
  }
`;

});

parcelRegister("lWX99", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ROOT = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.ROOT = (0, $4TeKW.css)`
  :root {
    --bp-s: 640px;
    --bp-m: 960px;
    --bp-l: 1200px;
    --bp-xl: 1600px;
  }
`;

});

parcelRegister("1Kd4u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactiveElement = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $bq6Hs = parcelRequire("bq6Hs");

var $gawXH = parcelRequire("gawXH");
class $14543a07e775a673$var$ReactiveElement extends $4TeKW.LitElement {
    constructor(v){
        super();
        this.select = (mapFn)=>{
            return this.state.pipe((0, $gawXH.map)(mapFn));
        };
        this.setState = (newState)=>{
            this.state.next(Object.assign(Object.assign({}, this.state.getValue()), newState));
        };
        this.getState = ()=>{
            return this.state.getValue();
        };
        this.state = new $bq6Hs.BehaviorSubject(v || {});
    }
    get state$() {
        return this.state.asObservable();
    }
}
module.exports.ReactiveElement = $14543a07e775a673$var$ReactiveElement;

});


parcelRegister("br2xx", function(module, exports) {
"use strict";
var $85342fb41a45db3c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $85342fb41a45db3c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $85342fb41a45db3c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$85342fb41a45db3c$var$__exportStar((parcelRequire("9Q3Sp")), module.exports);

$85342fb41a45db3c$var$__exportStar((parcelRequire("1xjpd")), module.exports);

});
parcelRegister("9Q3Sp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAIN_CSS = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $20K3n = parcelRequire("20K3n");

var $e56vd = parcelRequire("e56vd");

var $cjjq6 = parcelRequire("cjjq6");

var $lb9RB = parcelRequire("lb9RB");

var $e1H76 = parcelRequire("e1H76");

var $eubPc = parcelRequire("eubPc");

var $c7prX = parcelRequire("c7prX");
module.exports.MAIN_CSS = (0, $4TeKW.css)`
  ${$e56vd.FLEX}
  ${$e1H76.SPACER}
  ${$cjjq6.POINTER}
  ${$lb9RB.CENTER}
  ${$20K3n.DEFAULT}
  ${$eubPc.PRIMARY}
  ${$c7prX.SECONDARY}
`;

});
parcelRegister("e56vd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FLEX = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.FLEX = (0, $4TeKW.css)`
  .flex {
    display: flex;
  }
`;

});

parcelRegister("cjjq6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.POINTER = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.POINTER = (0, $4TeKW.css)`
  .pointer {
    cursor: pointer;
  }
`;

});

parcelRegister("lb9RB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CENTER = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.CENTER = (0, $4TeKW.css)`
  .center {
    margin: 0 auto;
  }
`;

});

parcelRegister("e1H76", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SPACER = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.SPACER = (0, $4TeKW.css)`
  .spacer {
    flex: 1 3 auto;
  }
`;

});


parcelRegister("1xjpd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRANSITIONS = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.TRANSITIONS = (0, $4TeKW.css)`
  /* ========================================================================
   Component: Transition
 ========================================================================== */
  /* Toggle (Hover + Focus)
 ========================================================================== */
  /*
 * 1. Prevent tab highlighting on iOS.
 */
  .transition-toggle {
    /* 1 */
    -webkit-tap-highlight-color: transparent;
  }

  .transition-toggle:focus {
    outline: none;
  }
  /* Transitions
 ========================================================================== */
  /*
 * The toggle is triggered on touch devices by two methods:
 * 1. Using :focus and tabindex
 * 2. Using :hover and a touchstart event listener registered on the document
 *    (Doesn't work on Surface touch devices)
 *
 * Note: Transitions don't work with postion-center-* classes because they also use transform,
 *       therefore it's recommended to use an extra div for the transition.
 */
  .transition-fade,
  [class*='transition-scale'],
  [class*='transition-slide'] {
    transition: 0.3s ease-out;
    transition-property: opacity, transform, filter;
    opacity: 0;
  }
  /*
 * Fade
 */
  .transition-toggle:hover .transition-fade,
  .transition-toggle:focus .transition-fade,
  .transition-active.active .transition-fade {
    opacity: 1;
  }
  /*
 * Scale
 */
  .transition-scale-up {
    transform: scale(1, 1);
  }
  .transition-scale-down {
    transform: scale(1.1, 1.1);
  }
  /* Show */
  .transition-toggle:hover .transition-scale-up,
  .transition-toggle:focus .transition-scale-up,
  .transition-active.active .transition-scale-up {
    opacity: 1;
    transform: scale(1.1, 1.1);
  }
  .transition-toggle:hover .transition-scale-down,
  .transition-toggle:focus .transition-scale-down,
  .transition-active.active .transition-scale-down {
    opacity: 1;
    transform: scale(1, 1);
  }
  /*
 * Slide
 */
  .transition-reset {
    transform: translateY(0) translateX(0);
  }
  .transition-slide-top {
    transform: translateY(-100%);
  }
  .transition-slide-bottom {
    transform: translateY(100%);
  }
  .transition-slide-left {
    transform: translateX(-100%);
  }
  .transition-slide-right {
    transform: translateX(100%);
  }
  .transition-slide-top-small {
    transform: translateY(-10px);
  }
  .transition-slide-bottom-small {
    transform: translateY(10px);
  }
  .transition-slide-left-small {
    transform: translateX(-10px);
  }
  .transition-slide-right-small {
    transform: translateX(10px);
  }
  .transition-slide-top-medium {
    transform: translateY(-50px);
  }
  .transition-slide-bottom-medium {
    transform: translateY(50px);
  }
  .transition-slide-left-medium {
    transform: translateX(-50px);
  }
  .transition-slide-right-medium {
    transform: translateX(50px);
  }
  /* Show */
  .transition-toggle:hover
    [class*='transition-slide']
    .transition-toggle:focus
    [class*='transition-slide'],
  .transition-active.active [class*='transition-slide'] {
    opacity: 1;
    transform: translate(0, 0);
  }
  /* Opacity modifier
 ========================================================================== */
  .transition-opaque {
    opacity: 1;
  }
  /* Duration modifiers
 ========================================================================== */
  .transition-slow {
    transition-duration: 0.7s;
  }
`;

});


parcelRegister("9PQcx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Render = module.exports.State = module.exports.Providers = module.exports.Settings = module.exports.Monad = module.exports.Compose = module.exports.DefineDependencies = void 0;

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("hS6oR");
const $72915e88719f2a52$var$DefineDependencies = (...deps)=>(injection)=>{
        for (const [index, dep] of deps.entries())Object.defineProperty(deps, index, {
            get: ()=>injection && injection.has(dep) ? injection.get(dep) : dep
        });
        return deps;
    };
module.exports.DefineDependencies = $72915e88719f2a52$var$DefineDependencies;
const $72915e88719f2a52$var$Compose = (options)=>(deps = [])=>(state)=>(render)=>(0, $4TeKW.Component)(Object.assign(Object.assign({}, options), {
                    template () {
                        return (0, $4TeKW.html)`
    <rx-monad>
     <rx-state .value=${state.bind(this).call(this, deps)}></rx-state>
     <rx-render
      .state=${(state, setState, shadowRoot)=>{
                            this.shadowRoot.append(shadowRoot);
                            return render(deps).bind(this).call(this, state, setState, shadowRoot);
                        }}
     ></rx-render>
    </rx-monad>
   `;
                    }
                }));
module.exports.Compose = $72915e88719f2a52$var$Compose;
const $72915e88719f2a52$var$Monad = ([options, deps, state, render])=>(0, module.exports.Compose)(options)(deps)(state)(render);
module.exports.Monad = $72915e88719f2a52$var$Monad;
const $72915e88719f2a52$var$Settings = (o)=>o;
module.exports.Settings = $72915e88719f2a52$var$Settings;
// export const λettings = (o: Options) => o;
const $72915e88719f2a52$var$Providers = (o)=>o;
module.exports.Providers = $72915e88719f2a52$var$Providers;
// export const ρroviders = <S, D, K>(o: D) => o;
const $72915e88719f2a52$var$State = (o)=>o;
module.exports.State = $72915e88719f2a52$var$State;
// export const ςtate = <S, D, K extends LitElement>(o: StateToRender<S, D, K>) => o;
const $72915e88719f2a52$var$Render = (o)=>o;
module.exports.Render = $72915e88719f2a52$var$Render; // export const πender = <S, D, K extends LitElement>(o: RenderResult<S, D, K>) => o;

});


parcelRegister("7qDsr", function(module, exports) {
"use strict";
var $568991988cef7047$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $568991988cef7047$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $568991988cef7047$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$568991988cef7047$var$__exportStar((parcelRequire("4SSaT")), module.exports);

});
parcelRegister("4SSaT", function(module, exports) {
"use strict";
var $38e63a87d333267c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $38e63a87d333267c$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoadingComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("9DBLY");
/**
 * @customElement rx-loading
 */ let $38e63a87d333267c$var$LoadingComponent = class LoadingComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.color = '#fff';
        this.if = ()=>true;
    }
};
$38e63a87d333267c$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $38e63a87d333267c$var$__metadata("design:type", String)
], $38e63a87d333267c$var$LoadingComponent.prototype, "palette", void 0);
$38e63a87d333267c$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $38e63a87d333267c$var$__metadata("design:type", Object)
], $38e63a87d333267c$var$LoadingComponent.prototype, "color", void 0);
$38e63a87d333267c$var$__decorate([
    (0, $4TeKW.property)({
        attribute: false
    }),
    $38e63a87d333267c$var$__metadata("design:type", Function)
], $38e63a87d333267c$var$LoadingComponent.prototype, "if", void 0);
$38e63a87d333267c$var$LoadingComponent = $38e63a87d333267c$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-loading',
        style: (0, $4TeKW.css)`
    .lds-ellipsis {
      display: inline-block;
      position: relative;
      width: 64px;
      height: 64px;
    }
    .lds-ellipsis div {
      position: absolute;
      top: 27px;
      width: 11px;
      height: 11px;
      border-radius: 50%;

      animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
      left: 6px;
      animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
      left: 6px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
      left: 26px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
      left: 45px;
      animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }
    @keyframes lds-ellipsis3 {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(0);
      }
    }
    @keyframes lds-ellipsis2 {
      0% {
        transform: translate(0, 0);
      }
      100% {
        transform: translate(19px, 0);
      }
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <style>
        .lds-ellipsis div {
          background: ${(0, $4TeKW.unsafeCSS)(this.palette ? `var(--${this.palette}-bg-color)` : this.color)};
        }
      </style>
      ${this.if() ? (0, $4TeKW.html)`
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          ` : ''}
    `;
        }
    })
], $38e63a87d333267c$var$LoadingComponent);
module.exports.LoadingComponent = $38e63a87d333267c$var$LoadingComponent;

});


parcelRegister("kawlb", function(module, exports) {

$parcel$export(module.exports, "SharedModule", () => $a2f8c19b524a1cd0$export$44568afb1bae0bd3);

var $deWeK = parcelRequire("deWeK");
parcelRequire("j6MoY");
parcelRequire("4mXm7");
parcelRequire("c0DJa");
parcelRequire("c9KPE");
parcelRequire("bsGn3");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $lOE5j = parcelRequire("lOE5j");

var $ljRQS = parcelRequire("ljRQS");

var $lx3ty = parcelRequire("lx3ty");

var $jde1E = parcelRequire("jde1E");

var $ihXbv = parcelRequire("ihXbv");

var $89nwV = parcelRequire("89nwV");

var $cw7RH = parcelRequire("cw7RH");

var $gBsDl = parcelRequire("gBsDl");

var $2UPwk = parcelRequire("2UPwk");
parcelRequire("kSI5T");
var $1SiTW = parcelRequire("1SiTW");
parcelRequire("giEjU");
var $jfKYS = parcelRequire("jfKYS");

var $l79he = parcelRequire("l79he");

var $kSPmD = parcelRequire("kSPmD");

var $fnUZ8 = parcelRequire("fnUZ8");
parcelRequire("6Dl1J");
var $b3n0V = parcelRequire("b3n0V");

var $ggpzp = parcelRequire("ggpzp");

var $cwDM8 = parcelRequire("cwDM8");

var $9B4nF = parcelRequire("9B4nF");

var $ibuOs = parcelRequire("ibuOs");

var $qje1A = parcelRequire("qje1A");

var $jpOXL = parcelRequire("jpOXL");

var $ktE4W = parcelRequire("ktE4W");

var $f2F8e = parcelRequire("f2F8e");

var $kTORu = parcelRequire("kTORu");

var $1Vpee = parcelRequire("1Vpee");

var $59th2 = parcelRequire("59th2");

var $3v6ni = parcelRequire("3v6ni");

var $fUVdo = parcelRequire("fUVdo");

var $eJjFv = parcelRequire("eJjFv");

var $K0wwI = parcelRequire("K0wwI");

var $9580H = parcelRequire("9580H");

var $cYJAl = parcelRequire("cYJAl");

var $biEGl = parcelRequire("biEGl");

var $4Dlh5 = parcelRequire("4Dlh5");

var $9s87d = parcelRequire("9s87d");

var $3kgi7 = parcelRequire("3kgi7");

var $2PwCZ = parcelRequire("2PwCZ");

var $eb1lT = parcelRequire("eb1lT");

var $5LvTH = parcelRequire("5LvTH");

var $3PK7V = parcelRequire("3PK7V");

var $imRSa = parcelRequire("imRSa");

var $hU4FT = parcelRequire("hU4FT");
class $a2f8c19b524a1cd0$export$44568afb1bae0bd3 {
}
$a2f8c19b524a1cd0$export$44568afb1bae0bd3 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Module)({
        imports: [
            (0, $89nwV.NavModule).forRoot(),
            (0, $ihXbv.ModalModule).forRoot({
                style: (0, $4TeKW.css)`
        .wrapper {
          position: fixed;
          top: 0;
          left: 0;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          width: 100%;
          height: 100%;
          z-index: 11;
        }

        .backdrop {
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          position: fixed;
          background-color: rgba(0, 0, 0, 0.5);
          pointer-events: all;
          z-index: 10;
        }

        .content {
          z-index: 20;
          position: fixed;
          width: 100%;
          height: 100%;
          pointer-events: all;
        }
      `
            }),
            (0, $4Dlh5.ShoelaceModule)
        ],
        components: [
            (0, $3PK7V.TailWindComponent),
            (0, $3kgi7.DefaultSpinnerComponent),
            (0, $K0wwI.OriginalStyle),
            (0, $fnUZ8.CardComponent),
            (0, $3v6ni.ModalDialogComponent),
            (0, $jpOXL.HamburgerComponent),
            (0, $lOE5j.AccordionItemComponent),
            (0, $ggpzp.DropdownComponent),
            (0, $f2F8e.InfoCardComponent),
            (0, $1Vpee.InfoHeaderCardComponent),
            (0, $ibuOs.GenericNavbarComponent),
            (0, $5LvTH.TabsComponent),
            (0, $kSPmD.BootstrapComponent),
            (0, $9s87d.SpacerComponent),
            (0, $qje1A.GridComponent),
            (0, $cYJAl.RouterLinkComponent),
            (0, $2UPwk.TabsComponent),
            (0, $eJjFv.NotificationIconComponent),
            (0, $cw7RH.PaginationComponent),
            (0, $biEGl.SearchComponent),
            (0, $lx3ty.ButtonComponent),
            (0, $jde1E.CardComponent),
            (0, $l79he.ReactRevealComponent),
            (0, $eb1lT.TableComponent),
            (0, $hU4FT.InputToggleComponent),
            (0, $gBsDl.ProgressComponent),
            (0, $9B4nF.FileUploaderComponent),
            (0, $kTORu.InfoMenuComponent),
            (0, $9580H.ProfileIconComponent),
            (0, $imRSa.WebCli),
            (0, $59th2.InformationComponent),
            (0, $cwDM8.CodeMirrorComponent),
            (0, $ljRQS.AlertComponent),
            (0, $fUVdo.MultiSelectComponent),
            (0, $ktE4W.IconComponent),
            (0, $2PwCZ.SvgRepoComponent),
            (0, $b3n0V.DiffComponent),
            (0, $1SiTW.RadioGroup),
            (0, $jfKYS.RadioButton)
        ]
    })
], $a2f8c19b524a1cd0$export$44568afb1bae0bd3);

});
parcelRegister("j6MoY", function(module, exports) {
"use strict";
var $de941f78b96d0f2e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $de941f78b96d0f2e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $de941f78b96d0f2e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$de941f78b96d0f2e$var$__exportStar((parcelRequire("bFKwy")), module.exports);

$de941f78b96d0f2e$var$__exportStar((parcelRequire("6Ii0J")), module.exports);

$de941f78b96d0f2e$var$__exportStar((parcelRequire("4OIUb")), module.exports);

});
parcelRegister("bFKwy", function(module, exports) {
"use strict";
var $87f79cc251b3f3ee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $87f79cc251b3f3ee$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $87f79cc251b3f3ee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $87f79cc251b3f3ee$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnimationComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");

const $87f79cc251b3f3ee$var$animejs_1 = $87f79cc251b3f3ee$var$__importDefault((parcelRequire("k2qLX")));
/**
 * @customElement rx-animation
 */ let $87f79cc251b3f3ee$var$AnimationComponent = class AnimationComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.loopBeginCount = 0;
        this.loopCompletedCount = 0;
        this.overflow = 'visible';
        this.options = ()=>({
                autoplay: false
            });
    }
    get duration() {
        return this.instance.duration;
    }
    OnUpdate() {
        return $87f79cc251b3f3ee$var$__awaiter(this, void 0, void 0, function*() {
            const slot = this.shadowRoot.querySelector('slot');
            const nodes = slot.assignedNodes();
            let targets = nodes.filter((el)=>el.nodeType === 1 && !(el.getAttribute('animate') === 'false'));
            const forNode = this.findNode(nodes, 'rx-for');
            if (forNode) {
                const forNodeNodes = forNode.querySelector('rx-let');
                yield forNodeNodes.requestUpdate();
                targets = Array.from(forNodeNodes.shadowRoot.children);
            }
            const { bezier: bezier, stagger: stagger, set: set, timeline: timeline, random: random } = $87f79cc251b3f3ee$var$animejs_1.default;
            const options = this.options({
                bezier: bezier,
                stagger: stagger,
                set: set,
                timeline: timeline,
                random: random
            });
            const autoplay = options.trigger && options.trigger === 'load' || !options.trigger;
            this.instance = (0, $87f79cc251b3f3ee$var$animejs_1.default)(Object.assign(Object.assign({
                targets: targets,
                autoplay: autoplay
            }, options), {
                update: this.OnAnimeUpdate.bind(this),
                begin: this.onAnimeBegin.bind(this),
                complete: this.onAnimeCompleted.bind(this),
                loopBegin: this.onAnimeLoopBegin.bind(this),
                loopComplete: this.onAnimeLoopCompleted.bind(this)
            }));
            if (options.trigger && options.trigger !== 'load') {
                this.trigger = options.trigger;
                this.removeListeners();
                this.listeners = targets.map((target)=>{
                    target.addEventListener(options.trigger, this.handleEvent.bind(this));
                    return ()=>target.removeEventListener(options.trigger, this.handleEvent.bind(this));
                });
            }
        });
    }
    findNode(nodes, localName) {
        const node = nodes.find((n)=>n && n.nextSibling && n.nextSibling.localName === localName);
        return node ? node.nextSibling : null;
    }
    play() {
        this.instance.play();
    }
    pause() {
        this.instance.pause();
    }
    restart() {
        this.loopCompletedCount = 0;
        this.loopBeginCount = 0;
        this.instance.restart();
    }
    reverse() {
        this.instance.reverse();
    }
    seek(time) {
        this.instance.seek(time);
    }
    disconnectedCallback() {
        this.instance = null;
        this.removeListeners();
    }
    onAnimeBegin() {
        this.dispatchEvent(new CustomEvent('begin', {
            bubbles: true,
            composed: true,
            cancelable: false
        }));
    }
    onAnimeCompleted() {
        this.dispatchEvent(new CustomEvent('completed', {
            bubbles: true,
            composed: true,
            cancelable: false
        }));
    }
    onAnimeLoopBegin() {
        this.dispatchEvent(new CustomEvent('loop-begin', {
            detail: {
                count: this.loopBeginCount++
            },
            bubbles: true,
            composed: true,
            cancelable: false
        }));
    }
    onAnimeLoopCompleted() {
        this.dispatchEvent(new CustomEvent('loop-completed', {
            detail: {
                count: this.loopCompletedCount++
            },
            bubbles: true,
            composed: true,
            cancelable: false
        }));
    }
    OnAnimeUpdate({ currentTime: currentTime, progress: progress }) {
        this.dispatchEvent(new CustomEvent('progress', {
            detail: {
                currentTime: currentTime,
                progress: Math.round(progress)
            },
            bubbles: true,
            composed: true,
            cancelable: false
        }));
    }
    handleEvent() {
        if (this.instance.completed) this.play();
        else this.restart();
    }
    removeListeners() {
        if (this.listeners) this.listeners.forEach((l)=>l());
    }
};
$87f79cc251b3f3ee$var$__decorate([
    (0, $4TeKW.property)(),
    $87f79cc251b3f3ee$var$__metadata("design:type", String)
], $87f79cc251b3f3ee$var$AnimationComponent.prototype, "overflow", void 0);
$87f79cc251b3f3ee$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $87f79cc251b3f3ee$var$__metadata("design:type", Function)
], $87f79cc251b3f3ee$var$AnimationComponent.prototype, "options", void 0);
$87f79cc251b3f3ee$var$AnimationComponent = $87f79cc251b3f3ee$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-animation',
        style: (0, $4TeKW.css)``,
        template () {
            return (0, $4TeKW.html)`
      <style>
        :host {
          display: block;
          overflow: ${(0, $4TeKW.unsafeCSS)(this.overflow)};
        }
      </style>
      <slot></slot>
    `;
        }
    })
], $87f79cc251b3f3ee$var$AnimationComponent);
module.exports.AnimationComponent = $87f79cc251b3f3ee$var$AnimationComponent;

});
parcelRegister("k2qLX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e968c307c12f6712$export$2e2bcd8739ae039);
/*
 * anime.js v3.2.1
 * (c) 2020 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */ // Defaults
var $e968c307c12f6712$var$defaultInstanceSettings = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: 'normal',
    autoplay: true,
    timelineOffset: 0
};
var $e968c307c12f6712$var$defaultTweenSettings = {
    duration: 1000,
    delay: 0,
    endDelay: 0,
    easing: 'easeOutElastic(1, .5)',
    round: 0
};
var $e968c307c12f6712$var$validTransforms = [
    'translateX',
    'translateY',
    'translateZ',
    'rotate',
    'rotateX',
    'rotateY',
    'rotateZ',
    'scale',
    'scaleX',
    'scaleY',
    'scaleZ',
    'skew',
    'skewX',
    'skewY',
    'perspective',
    'matrix',
    'matrix3d'
];
// Caching
var $e968c307c12f6712$var$cache = {
    CSS: {},
    springs: {}
};
// Utils
function $e968c307c12f6712$var$minMax(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
function $e968c307c12f6712$var$stringContains(str, text) {
    return str.indexOf(text) > -1;
}
function $e968c307c12f6712$var$applyArguments(func, args) {
    return func.apply(null, args);
}
var $e968c307c12f6712$var$is = {
    arr: function(a) {
        return Array.isArray(a);
    },
    obj: function(a) {
        return $e968c307c12f6712$var$stringContains(Object.prototype.toString.call(a), 'Object');
    },
    pth: function(a) {
        return $e968c307c12f6712$var$is.obj(a) && a.hasOwnProperty('totalLength');
    },
    svg: function(a) {
        return a instanceof SVGElement;
    },
    inp: function(a) {
        return a instanceof HTMLInputElement;
    },
    dom: function(a) {
        return a.nodeType || $e968c307c12f6712$var$is.svg(a);
    },
    str: function(a) {
        return typeof a === 'string';
    },
    fnc: function(a) {
        return typeof a === 'function';
    },
    und: function(a) {
        return typeof a === 'undefined';
    },
    nil: function(a) {
        return $e968c307c12f6712$var$is.und(a) || a === null;
    },
    hex: function(a) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
    },
    rgb: function(a) {
        return /^rgb/.test(a);
    },
    hsl: function(a) {
        return /^hsl/.test(a);
    },
    col: function(a) {
        return $e968c307c12f6712$var$is.hex(a) || $e968c307c12f6712$var$is.rgb(a) || $e968c307c12f6712$var$is.hsl(a);
    },
    key: function(a) {
        return !$e968c307c12f6712$var$defaultInstanceSettings.hasOwnProperty(a) && !$e968c307c12f6712$var$defaultTweenSettings.hasOwnProperty(a) && a !== 'targets' && a !== 'keyframes';
    }
};
// Easings
function $e968c307c12f6712$var$parseEasingParameters(string) {
    var match = /\(([^)]+)\)/.exec(string);
    return match ? match[1].split(',').map(function(p) {
        return parseFloat(p);
    }) : [];
}
// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js
function $e968c307c12f6712$var$spring(string, duration) {
    var params = $e968c307c12f6712$var$parseEasingParameters(string);
    var mass = $e968c307c12f6712$var$minMax($e968c307c12f6712$var$is.und(params[0]) ? 1 : params[0], .1, 100);
    var stiffness = $e968c307c12f6712$var$minMax($e968c307c12f6712$var$is.und(params[1]) ? 100 : params[1], .1, 100);
    var damping = $e968c307c12f6712$var$minMax($e968c307c12f6712$var$is.und(params[2]) ? 10 : params[2], .1, 100);
    var velocity = $e968c307c12f6712$var$minMax($e968c307c12f6712$var$is.und(params[3]) ? 0 : params[3], .1, 100);
    var w0 = Math.sqrt(stiffness / mass);
    var zeta = damping / (2 * Math.sqrt(stiffness * mass));
    var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
    var a = 1;
    var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
    function solver(t) {
        var progress = duration ? duration * t / 1000 : t;
        if (zeta < 1) progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
        else progress = (a + b * progress) * Math.exp(-progress * w0);
        if (t === 0 || t === 1) return t;
        return 1 - progress;
    }
    function getDuration() {
        var cached = $e968c307c12f6712$var$cache.springs[string];
        if (cached) return cached;
        var frame = 1 / 6;
        var elapsed = 0;
        var rest = 0;
        while(true){
            elapsed += frame;
            if (solver(elapsed) === 1) {
                rest++;
                if (rest >= 16) break;
            } else rest = 0;
        }
        var duration = elapsed * frame * 1000;
        $e968c307c12f6712$var$cache.springs[string] = duration;
        return duration;
    }
    return duration ? solver : getDuration;
}
// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function
function $e968c307c12f6712$var$steps(steps) {
    if (steps === void 0) steps = 10;
    return function(t) {
        return Math.ceil($e968c307c12f6712$var$minMax(t, 0.000001, 1) * steps) * (1 / steps);
    };
}
// BezierEasing https://github.com/gre/bezier-easing
var $e968c307c12f6712$var$bezier = function() {
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > 0.0000001 && ++i < 10);
        return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for(var i = 0; i < 4; ++i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) return;
        var sampleValues = new Float32Array(kSplineTableSize);
        if (mX1 !== mY1 || mX2 !== mY2) for(var i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        function getTForX(aX) {
            var intervalStart = 0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
            --currentSample;
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= 0.001) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            else if (initialSlope === 0.0) return guessForT;
            else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
        return function(x) {
            if (mX1 === mY1 && mX2 === mY2) return x;
            if (x === 0 || x === 1) return x;
            return calcBezier(getTForX(x), mY1, mY2);
        };
    }
    return bezier;
}();
var $e968c307c12f6712$var$penner = function() {
    // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)
    var eases = {
        linear: function() {
            return function(t) {
                return t;
            };
        }
    };
    var functionEasings = {
        Sine: function() {
            return function(t) {
                return 1 - Math.cos(t * Math.PI / 2);
            };
        },
        Circ: function() {
            return function(t) {
                return 1 - Math.sqrt(1 - t * t);
            };
        },
        Back: function() {
            return function(t) {
                return t * t * (3 * t - 2);
            };
        },
        Bounce: function() {
            return function(t) {
                var pow2, b = 4;
                while(t < ((pow2 = Math.pow(2, --b)) - 1) / 11);
                return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
            };
        },
        Elastic: function(amplitude, period) {
            if (amplitude === void 0) amplitude = 1;
            if (period === void 0) period = .5;
            var a = $e968c307c12f6712$var$minMax(amplitude, 1, 10);
            var p = $e968c307c12f6712$var$minMax(period, .1, 2);
            return function(t) {
                return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
            };
        }
    };
    var baseEasings = [
        'Quad',
        'Cubic',
        'Quart',
        'Quint',
        'Expo'
    ];
    baseEasings.forEach(function(name, i) {
        functionEasings[name] = function() {
            return function(t) {
                return Math.pow(t, i + 2);
            };
        };
    });
    Object.keys(functionEasings).forEach(function(name) {
        var easeIn = functionEasings[name];
        eases['easeIn' + name] = easeIn;
        eases['easeOut' + name] = function(a, b) {
            return function(t) {
                return 1 - easeIn(a, b)(1 - t);
            };
        };
        eases['easeInOut' + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
            };
        };
        eases['easeOutIn' + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
            };
        };
    });
    return eases;
}();
function $e968c307c12f6712$var$parseEasings(easing, duration) {
    if ($e968c307c12f6712$var$is.fnc(easing)) return easing;
    var name = easing.split('(')[0];
    var ease = $e968c307c12f6712$var$penner[name];
    var args = $e968c307c12f6712$var$parseEasingParameters(easing);
    switch(name){
        case 'spring':
            return $e968c307c12f6712$var$spring(easing, duration);
        case 'cubicBezier':
            return $e968c307c12f6712$var$applyArguments($e968c307c12f6712$var$bezier, args);
        case 'steps':
            return $e968c307c12f6712$var$applyArguments($e968c307c12f6712$var$steps, args);
        default:
            return $e968c307c12f6712$var$applyArguments(ease, args);
    }
}
// Strings
function $e968c307c12f6712$var$selectString(str) {
    try {
        var nodes = document.querySelectorAll(str);
        return nodes;
    } catch (e) {
        return;
    }
}
// Arrays
function $e968c307c12f6712$var$filterArray(arr, callback) {
    var len = arr.length;
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    var result = [];
    for(var i = 0; i < len; i++)if (i in arr) {
        var val = arr[i];
        if (callback.call(thisArg, val, i, arr)) result.push(val);
    }
    return result;
}
function $e968c307c12f6712$var$flattenArray(arr) {
    return arr.reduce(function(a, b) {
        return a.concat($e968c307c12f6712$var$is.arr(b) ? $e968c307c12f6712$var$flattenArray(b) : b);
    }, []);
}
function $e968c307c12f6712$var$toArray(o) {
    if ($e968c307c12f6712$var$is.arr(o)) return o;
    if ($e968c307c12f6712$var$is.str(o)) o = $e968c307c12f6712$var$selectString(o) || o;
    if (o instanceof NodeList || o instanceof HTMLCollection) return [].slice.call(o);
    return [
        o
    ];
}
function $e968c307c12f6712$var$arrayContains(arr, val) {
    return arr.some(function(a) {
        return a === val;
    });
}
// Objects
function $e968c307c12f6712$var$cloneObject(o) {
    var clone = {};
    for(var p in o)clone[p] = o[p];
    return clone;
}
function $e968c307c12f6712$var$replaceObjectProps(o1, o2) {
    var o = $e968c307c12f6712$var$cloneObject(o1);
    for(var p in o1)o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
    return o;
}
function $e968c307c12f6712$var$mergeObjects(o1, o2) {
    var o = $e968c307c12f6712$var$cloneObject(o1);
    for(var p in o2)o[p] = $e968c307c12f6712$var$is.und(o1[p]) ? o2[p] : o1[p];
    return o;
}
// Colors
function $e968c307c12f6712$var$rgbToRgba(rgbValue) {
    var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
    return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
}
function $e968c307c12f6712$var$hexToRgba(hexValue) {
    var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hex = hexValue.replace(rgx, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(rgb[1], 16);
    var g = parseInt(rgb[2], 16);
    var b = parseInt(rgb[3], 16);
    return "rgba(" + r + "," + g + "," + b + ",1)";
}
function $e968c307c12f6712$var$hslToRgba(hslValue) {
    var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
    var h = parseInt(hsl[1], 10) / 360;
    var s = parseInt(hsl[2], 10) / 100;
    var l = parseInt(hsl[3], 10) / 100;
    var a = hsl[4] || 1;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var r, g, b;
    if (s == 0) r = g = b = l;
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
}
function $e968c307c12f6712$var$colorToRgb(val) {
    if ($e968c307c12f6712$var$is.rgb(val)) return $e968c307c12f6712$var$rgbToRgba(val);
    if ($e968c307c12f6712$var$is.hex(val)) return $e968c307c12f6712$var$hexToRgba(val);
    if ($e968c307c12f6712$var$is.hsl(val)) return $e968c307c12f6712$var$hslToRgba(val);
}
// Units
function $e968c307c12f6712$var$getUnit(val) {
    var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
    if (split) return split[1];
}
function $e968c307c12f6712$var$getTransformUnit(propName) {
    if ($e968c307c12f6712$var$stringContains(propName, 'translate') || propName === 'perspective') return 'px';
    if ($e968c307c12f6712$var$stringContains(propName, 'rotate') || $e968c307c12f6712$var$stringContains(propName, 'skew')) return 'deg';
}
// Values
function $e968c307c12f6712$var$getFunctionValue(val, animatable) {
    if (!$e968c307c12f6712$var$is.fnc(val)) return val;
    return val(animatable.target, animatable.id, animatable.total);
}
function $e968c307c12f6712$var$getAttribute(el, prop) {
    return el.getAttribute(prop);
}
function $e968c307c12f6712$var$convertPxToUnit(el, value, unit) {
    var valueUnit = $e968c307c12f6712$var$getUnit(value);
    if ($e968c307c12f6712$var$arrayContains([
        unit,
        'deg',
        'rad',
        'turn'
    ], valueUnit)) return value;
    var cached = $e968c307c12f6712$var$cache.CSS[value + unit];
    if (!$e968c307c12f6712$var$is.und(cached)) return cached;
    var baseline = 100;
    var tempEl = document.createElement(el.tagName);
    var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
    parentEl.appendChild(tempEl);
    tempEl.style.position = 'absolute';
    tempEl.style.width = baseline + unit;
    var factor = baseline / tempEl.offsetWidth;
    parentEl.removeChild(tempEl);
    var convertedUnit = factor * parseFloat(value);
    $e968c307c12f6712$var$cache.CSS[value + unit] = convertedUnit;
    return convertedUnit;
}
function $e968c307c12f6712$var$getCSSValue(el, prop, unit) {
    if (prop in el.style) {
        var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || '0';
        return unit ? $e968c307c12f6712$var$convertPxToUnit(el, value, unit) : value;
    }
}
function $e968c307c12f6712$var$getAnimationType(el, prop) {
    if ($e968c307c12f6712$var$is.dom(el) && !$e968c307c12f6712$var$is.inp(el) && (!$e968c307c12f6712$var$is.nil($e968c307c12f6712$var$getAttribute(el, prop)) || $e968c307c12f6712$var$is.svg(el) && el[prop])) return 'attribute';
    if ($e968c307c12f6712$var$is.dom(el) && $e968c307c12f6712$var$arrayContains($e968c307c12f6712$var$validTransforms, prop)) return 'transform';
    if ($e968c307c12f6712$var$is.dom(el) && prop !== 'transform' && $e968c307c12f6712$var$getCSSValue(el, prop)) return 'css';
    if (el[prop] != null) return 'object';
}
function $e968c307c12f6712$var$getElementTransforms(el) {
    if (!$e968c307c12f6712$var$is.dom(el)) return;
    var str = el.style.transform || '';
    var reg = /(\w+)\(([^)]*)\)/g;
    var transforms = new Map();
    var m;
    while(m = reg.exec(str))transforms.set(m[1], m[2]);
    return transforms;
}
function $e968c307c12f6712$var$getTransformValue(el, propName, animatable, unit) {
    var defaultVal = $e968c307c12f6712$var$stringContains(propName, 'scale') ? 1 : 0 + $e968c307c12f6712$var$getTransformUnit(propName);
    var value = $e968c307c12f6712$var$getElementTransforms(el).get(propName) || defaultVal;
    if (animatable) {
        animatable.transforms.list.set(propName, value);
        animatable.transforms['last'] = propName;
    }
    return unit ? $e968c307c12f6712$var$convertPxToUnit(el, value, unit) : value;
}
function $e968c307c12f6712$var$getOriginalTargetValue(target, propName, unit, animatable) {
    switch($e968c307c12f6712$var$getAnimationType(target, propName)){
        case 'transform':
            return $e968c307c12f6712$var$getTransformValue(target, propName, animatable, unit);
        case 'css':
            return $e968c307c12f6712$var$getCSSValue(target, propName, unit);
        case 'attribute':
            return $e968c307c12f6712$var$getAttribute(target, propName);
        default:
            return target[propName] || 0;
    }
}
function $e968c307c12f6712$var$getRelativeValue(to, from) {
    var operator = /^(\*=|\+=|-=)/.exec(to);
    if (!operator) return to;
    var u = $e968c307c12f6712$var$getUnit(to) || 0;
    var x = parseFloat(from);
    var y = parseFloat(to.replace(operator[0], ''));
    switch(operator[0][0]){
        case '+':
            return x + y + u;
        case '-':
            return x - y + u;
        case '*':
            return x * y + u;
    }
}
function $e968c307c12f6712$var$validateValue(val, unit) {
    if ($e968c307c12f6712$var$is.col(val)) return $e968c307c12f6712$var$colorToRgb(val);
    if (/\s/g.test(val)) return val;
    var originalUnit = $e968c307c12f6712$var$getUnit(val);
    var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
    if (unit) return unitLess + unit;
    return unitLess;
}
// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744
function $e968c307c12f6712$var$getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $e968c307c12f6712$var$getCircleLength(el) {
    return Math.PI * 2 * $e968c307c12f6712$var$getAttribute(el, 'r');
}
function $e968c307c12f6712$var$getRectLength(el) {
    return $e968c307c12f6712$var$getAttribute(el, 'width') * 2 + $e968c307c12f6712$var$getAttribute(el, 'height') * 2;
}
function $e968c307c12f6712$var$getLineLength(el) {
    return $e968c307c12f6712$var$getDistance({
        x: $e968c307c12f6712$var$getAttribute(el, 'x1'),
        y: $e968c307c12f6712$var$getAttribute(el, 'y1')
    }, {
        x: $e968c307c12f6712$var$getAttribute(el, 'x2'),
        y: $e968c307c12f6712$var$getAttribute(el, 'y2')
    });
}
function $e968c307c12f6712$var$getPolylineLength(el) {
    var points = el.points;
    var totalLength = 0;
    var previousPos;
    for(var i = 0; i < points.numberOfItems; i++){
        var currentPos = points.getItem(i);
        if (i > 0) totalLength += $e968c307c12f6712$var$getDistance(previousPos, currentPos);
        previousPos = currentPos;
    }
    return totalLength;
}
function $e968c307c12f6712$var$getPolygonLength(el) {
    var points = el.points;
    return $e968c307c12f6712$var$getPolylineLength(el) + $e968c307c12f6712$var$getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}
// Path animation
function $e968c307c12f6712$var$getTotalLength(el) {
    if (el.getTotalLength) return el.getTotalLength();
    switch(el.tagName.toLowerCase()){
        case 'circle':
            return $e968c307c12f6712$var$getCircleLength(el);
        case 'rect':
            return $e968c307c12f6712$var$getRectLength(el);
        case 'line':
            return $e968c307c12f6712$var$getLineLength(el);
        case 'polyline':
            return $e968c307c12f6712$var$getPolylineLength(el);
        case 'polygon':
            return $e968c307c12f6712$var$getPolygonLength(el);
    }
}
function $e968c307c12f6712$var$setDashoffset(el) {
    var pathLength = $e968c307c12f6712$var$getTotalLength(el);
    el.setAttribute('stroke-dasharray', pathLength);
    return pathLength;
}
// Motion path
function $e968c307c12f6712$var$getParentSvgEl(el) {
    var parentEl = el.parentNode;
    while($e968c307c12f6712$var$is.svg(parentEl)){
        if (!$e968c307c12f6712$var$is.svg(parentEl.parentNode)) break;
        parentEl = parentEl.parentNode;
    }
    return parentEl;
}
function $e968c307c12f6712$var$getParentSvg(pathEl, svgData) {
    var svg = svgData || {};
    var parentSvgEl = svg.el || $e968c307c12f6712$var$getParentSvgEl(pathEl);
    var rect = parentSvgEl.getBoundingClientRect();
    var viewBoxAttr = $e968c307c12f6712$var$getAttribute(parentSvgEl, 'viewBox');
    var width = rect.width;
    var height = rect.height;
    var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(' ') : [
        0,
        0,
        width,
        height
    ]);
    return {
        el: parentSvgEl,
        viewBox: viewBox,
        x: viewBox[0] / 1,
        y: viewBox[1] / 1,
        w: width,
        h: height,
        vW: viewBox[2],
        vH: viewBox[3]
    };
}
function $e968c307c12f6712$var$getPath(path, percent) {
    var pathEl = $e968c307c12f6712$var$is.str(path) ? $e968c307c12f6712$var$selectString(path)[0] : path;
    var p = percent || 100;
    return function(property) {
        return {
            property: property,
            el: pathEl,
            svg: $e968c307c12f6712$var$getParentSvg(pathEl),
            totalLength: $e968c307c12f6712$var$getTotalLength(pathEl) * (p / 100)
        };
    };
}
function $e968c307c12f6712$var$getPathProgress(path, progress, isPathTargetInsideSVG) {
    function point(offset) {
        if (offset === void 0) offset = 0;
        var l = progress + offset >= 1 ? progress + offset : 0;
        return path.el.getPointAtLength(l);
    }
    var svg = $e968c307c12f6712$var$getParentSvg(path.el, path.svg);
    var p = point();
    var p0 = point(-1);
    var p1 = point(1);
    var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
    var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
    switch(path.property){
        case 'x':
            return (p.x - svg.x) * scaleX;
        case 'y':
            return (p.y - svg.y) * scaleY;
        case 'angle':
            return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
    }
}
// Decompose value
function $e968c307c12f6712$var$decomposeValue(val, unit) {
    // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
    // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var value = $e968c307c12f6712$var$validateValue($e968c307c12f6712$var$is.pth(val) ? val.totalLength : val, unit) + '';
    return {
        original: value,
        numbers: value.match(rgx) ? value.match(rgx).map(Number) : [
            0
        ],
        strings: $e968c307c12f6712$var$is.str(val) || unit ? value.split(rgx) : []
    };
}
// Animatables
function $e968c307c12f6712$var$parseTargets(targets) {
    var targetsArray = targets ? $e968c307c12f6712$var$flattenArray($e968c307c12f6712$var$is.arr(targets) ? targets.map($e968c307c12f6712$var$toArray) : $e968c307c12f6712$var$toArray(targets)) : [];
    return $e968c307c12f6712$var$filterArray(targetsArray, function(item, pos, self) {
        return self.indexOf(item) === pos;
    });
}
function $e968c307c12f6712$var$getAnimatables(targets) {
    var parsed = $e968c307c12f6712$var$parseTargets(targets);
    return parsed.map(function(t, i) {
        return {
            target: t,
            id: i,
            total: parsed.length,
            transforms: {
                list: $e968c307c12f6712$var$getElementTransforms(t)
            }
        };
    });
}
// Properties
function $e968c307c12f6712$var$normalizePropertyTweens(prop, tweenSettings) {
    var settings = $e968c307c12f6712$var$cloneObject(tweenSettings);
    // Override duration if easing is a spring
    if (/^spring/.test(settings.easing)) settings.duration = $e968c307c12f6712$var$spring(settings.easing);
    if ($e968c307c12f6712$var$is.arr(prop)) {
        var l = prop.length;
        var isFromTo = l === 2 && !$e968c307c12f6712$var$is.obj(prop[0]);
        if (!isFromTo) // Duration divided by the number of tweens
        {
            if (!$e968c307c12f6712$var$is.fnc(tweenSettings.duration)) settings.duration = tweenSettings.duration / l;
        } else // Transform [from, to] values shorthand to a valid tween value
        prop = {
            value: prop
        };
    }
    var propArray = $e968c307c12f6712$var$is.arr(prop) ? prop : [
        prop
    ];
    return propArray.map(function(v, i) {
        var obj = $e968c307c12f6712$var$is.obj(v) && !$e968c307c12f6712$var$is.pth(v) ? v : {
            value: v
        };
        // Default delay value should only be applied to the first tween
        if ($e968c307c12f6712$var$is.und(obj.delay)) obj.delay = !i ? tweenSettings.delay : 0;
        // Default endDelay value should only be applied to the last tween
        if ($e968c307c12f6712$var$is.und(obj.endDelay)) obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
        return obj;
    }).map(function(k) {
        return $e968c307c12f6712$var$mergeObjects(k, settings);
    });
}
function $e968c307c12f6712$var$flattenKeyframes(keyframes) {
    var propertyNames = $e968c307c12f6712$var$filterArray($e968c307c12f6712$var$flattenArray(keyframes.map(function(key) {
        return Object.keys(key);
    })), function(p) {
        return $e968c307c12f6712$var$is.key(p);
    }).reduce(function(a, b) {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
    }, []);
    var properties = {};
    var loop = function(i) {
        var propName = propertyNames[i];
        properties[propName] = keyframes.map(function(key) {
            var newKey = {};
            for(var p in key){
                if ($e968c307c12f6712$var$is.key(p)) {
                    if (p == propName) newKey.value = key[p];
                } else newKey[p] = key[p];
            }
            return newKey;
        });
    };
    for(var i = 0; i < propertyNames.length; i++)loop(i);
    return properties;
}
function $e968c307c12f6712$var$getProperties(tweenSettings, params) {
    var properties = [];
    var keyframes = params.keyframes;
    if (keyframes) params = $e968c307c12f6712$var$mergeObjects($e968c307c12f6712$var$flattenKeyframes(keyframes), params);
    for(var p in params)if ($e968c307c12f6712$var$is.key(p)) properties.push({
        name: p,
        tweens: $e968c307c12f6712$var$normalizePropertyTweens(params[p], tweenSettings)
    });
    return properties;
}
// Tweens
function $e968c307c12f6712$var$normalizeTweenValues(tween, animatable) {
    var t = {};
    for(var p in tween){
        var value = $e968c307c12f6712$var$getFunctionValue(tween[p], animatable);
        if ($e968c307c12f6712$var$is.arr(value)) {
            value = value.map(function(v) {
                return $e968c307c12f6712$var$getFunctionValue(v, animatable);
            });
            if (value.length === 1) value = value[0];
        }
        t[p] = value;
    }
    t.duration = parseFloat(t.duration);
    t.delay = parseFloat(t.delay);
    return t;
}
function $e968c307c12f6712$var$normalizeTweens(prop, animatable) {
    var previousTween;
    return prop.tweens.map(function(t) {
        var tween = $e968c307c12f6712$var$normalizeTweenValues(t, animatable);
        var tweenValue = tween.value;
        var to = $e968c307c12f6712$var$is.arr(tweenValue) ? tweenValue[1] : tweenValue;
        var toUnit = $e968c307c12f6712$var$getUnit(to);
        var originalValue = $e968c307c12f6712$var$getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
        var previousValue = previousTween ? previousTween.to.original : originalValue;
        var from = $e968c307c12f6712$var$is.arr(tweenValue) ? tweenValue[0] : previousValue;
        var fromUnit = $e968c307c12f6712$var$getUnit(from) || $e968c307c12f6712$var$getUnit(originalValue);
        var unit = toUnit || fromUnit;
        if ($e968c307c12f6712$var$is.und(to)) to = previousValue;
        tween.from = $e968c307c12f6712$var$decomposeValue(from, unit);
        tween.to = $e968c307c12f6712$var$decomposeValue($e968c307c12f6712$var$getRelativeValue(to, from), unit);
        tween.start = previousTween ? previousTween.end : 0;
        tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
        tween.easing = $e968c307c12f6712$var$parseEasings(tween.easing, tween.duration);
        tween.isPath = $e968c307c12f6712$var$is.pth(tweenValue);
        tween.isPathTargetInsideSVG = tween.isPath && $e968c307c12f6712$var$is.svg(animatable.target);
        tween.isColor = $e968c307c12f6712$var$is.col(tween.from.original);
        if (tween.isColor) tween.round = 1;
        previousTween = tween;
        return tween;
    });
}
// Tween progress
var $e968c307c12f6712$var$setProgressValue = {
    css: function(t, p, v) {
        return t.style[p] = v;
    },
    attribute: function(t, p, v) {
        return t.setAttribute(p, v);
    },
    object: function(t, p, v) {
        return t[p] = v;
    },
    transform: function(t, p, v, transforms, manual) {
        transforms.list.set(p, v);
        if (p === transforms.last || manual) {
            var str = '';
            transforms.list.forEach(function(value, prop) {
                str += prop + "(" + value + ") ";
            });
            t.style.transform = str;
        }
    }
};
// Set Value helper
function $e968c307c12f6712$var$setTargetsValue(targets, properties) {
    var animatables = $e968c307c12f6712$var$getAnimatables(targets);
    animatables.forEach(function(animatable) {
        for(var property in properties){
            var value = $e968c307c12f6712$var$getFunctionValue(properties[property], animatable);
            var target = animatable.target;
            var valueUnit = $e968c307c12f6712$var$getUnit(value);
            var originalValue = $e968c307c12f6712$var$getOriginalTargetValue(target, property, valueUnit, animatable);
            var unit = valueUnit || $e968c307c12f6712$var$getUnit(originalValue);
            var to = $e968c307c12f6712$var$getRelativeValue($e968c307c12f6712$var$validateValue(value, unit), originalValue);
            var animType = $e968c307c12f6712$var$getAnimationType(target, property);
            $e968c307c12f6712$var$setProgressValue[animType](target, property, to, animatable.transforms, true);
        }
    });
}
// Animations
function $e968c307c12f6712$var$createAnimation(animatable, prop) {
    var animType = $e968c307c12f6712$var$getAnimationType(animatable.target, prop.name);
    if (animType) {
        var tweens = $e968c307c12f6712$var$normalizeTweens(prop, animatable);
        var lastTween = tweens[tweens.length - 1];
        return {
            type: animType,
            property: prop.name,
            animatable: animatable,
            tweens: tweens,
            duration: lastTween.end,
            delay: tweens[0].delay,
            endDelay: lastTween.endDelay
        };
    }
}
function $e968c307c12f6712$var$getAnimations(animatables, properties) {
    return $e968c307c12f6712$var$filterArray($e968c307c12f6712$var$flattenArray(animatables.map(function(animatable) {
        return properties.map(function(prop) {
            return $e968c307c12f6712$var$createAnimation(animatable, prop);
        });
    })), function(a) {
        return !$e968c307c12f6712$var$is.und(a);
    });
}
// Create Instance
function $e968c307c12f6712$var$getInstanceTimings(animations, tweenSettings) {
    var animLength = animations.length;
    var getTlOffset = function(anim) {
        return anim.timelineOffset ? anim.timelineOffset : 0;
    };
    var timings = {};
    timings.duration = animLength ? Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration;
    })) : tweenSettings.duration;
    timings.delay = animLength ? Math.min.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.delay;
    })) : tweenSettings.delay;
    timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration - anim.endDelay;
    })) : tweenSettings.endDelay;
    return timings;
}
var $e968c307c12f6712$var$instanceID = 0;
function $e968c307c12f6712$var$createNewInstance(params) {
    var instanceSettings = $e968c307c12f6712$var$replaceObjectProps($e968c307c12f6712$var$defaultInstanceSettings, params);
    var tweenSettings = $e968c307c12f6712$var$replaceObjectProps($e968c307c12f6712$var$defaultTweenSettings, params);
    var properties = $e968c307c12f6712$var$getProperties(tweenSettings, params);
    var animatables = $e968c307c12f6712$var$getAnimatables(params.targets);
    var animations = $e968c307c12f6712$var$getAnimations(animatables, properties);
    var timings = $e968c307c12f6712$var$getInstanceTimings(animations, tweenSettings);
    var id = $e968c307c12f6712$var$instanceID;
    $e968c307c12f6712$var$instanceID++;
    return $e968c307c12f6712$var$mergeObjects(instanceSettings, {
        id: id,
        children: [],
        animatables: animatables,
        animations: animations,
        duration: timings.duration,
        delay: timings.delay,
        endDelay: timings.endDelay
    });
}
// Core
var $e968c307c12f6712$var$activeInstances = [];
var $e968c307c12f6712$var$engine = function() {
    var raf;
    function play() {
        if (!raf && (!$e968c307c12f6712$var$isDocumentHidden() || !$e968c307c12f6712$var$anime.suspendWhenDocumentHidden) && $e968c307c12f6712$var$activeInstances.length > 0) raf = requestAnimationFrame(step);
    }
    function step(t) {
        // memo on algorithm issue:
        // dangerous iteration over mutable `activeInstances`
        // (that collection may be updated from within callbacks of `tick`-ed animation instances)
        var activeInstancesLength = $e968c307c12f6712$var$activeInstances.length;
        var i = 0;
        while(i < activeInstancesLength){
            var activeInstance = $e968c307c12f6712$var$activeInstances[i];
            if (!activeInstance.paused) {
                activeInstance.tick(t);
                i++;
            } else {
                $e968c307c12f6712$var$activeInstances.splice(i, 1);
                activeInstancesLength--;
            }
        }
        raf = i > 0 ? requestAnimationFrame(step) : undefined;
    }
    function handleVisibilityChange() {
        if (!$e968c307c12f6712$var$anime.suspendWhenDocumentHidden) return;
        if ($e968c307c12f6712$var$isDocumentHidden()) // suspend ticks
        raf = cancelAnimationFrame(raf);
        else {
            // first adjust animations to consider the time that ticks were suspended
            $e968c307c12f6712$var$activeInstances.forEach(function(instance) {
                return instance._onDocumentVisibility();
            });
            $e968c307c12f6712$var$engine();
        }
    }
    if (typeof document !== 'undefined') document.addEventListener('visibilitychange', handleVisibilityChange);
    return play;
}();
function $e968c307c12f6712$var$isDocumentHidden() {
    return !!document && document.hidden;
}
// Public Instance
function $e968c307c12f6712$var$anime(params) {
    if (params === void 0) params = {};
    var startTime = 0, lastTime = 0, now = 0;
    var children, childrenLength = 0;
    var resolve = null;
    function makePromise(instance) {
        var promise = window.Promise && new Promise(function(_resolve) {
            return resolve = _resolve;
        });
        instance.finished = promise;
        return promise;
    }
    var instance = $e968c307c12f6712$var$createNewInstance(params);
    var promise = makePromise(instance);
    function toggleInstanceDirection() {
        var direction = instance.direction;
        if (direction !== 'alternate') instance.direction = direction !== 'normal' ? 'normal' : 'reverse';
        instance.reversed = !instance.reversed;
        children.forEach(function(child) {
            return child.reversed = instance.reversed;
        });
    }
    function adjustTime(time) {
        return instance.reversed ? instance.duration - time : time;
    }
    function resetTime() {
        startTime = 0;
        lastTime = adjustTime(instance.currentTime) * (1 / $e968c307c12f6712$var$anime.speed);
    }
    function seekChild(time, child) {
        if (child) child.seek(time - child.timelineOffset);
    }
    function syncInstanceChildren(time) {
        if (!instance.reversePlayback) for(var i = 0; i < childrenLength; i++)seekChild(time, children[i]);
        else for(var i$1 = childrenLength; i$1--;)seekChild(time, children[i$1]);
    }
    function setAnimationsProgress(insTime) {
        var i = 0;
        var animations = instance.animations;
        var animationsLength = animations.length;
        while(i < animationsLength){
            var anim = animations[i];
            var animatable = anim.animatable;
            var tweens = anim.tweens;
            var tweenLength = tweens.length - 1;
            var tween = tweens[tweenLength];
            // Only check for keyframes if there is more than one tween
            if (tweenLength) tween = $e968c307c12f6712$var$filterArray(tweens, function(t) {
                return insTime < t.end;
            })[0] || tween;
            var elapsed = $e968c307c12f6712$var$minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
            var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
            var strings = tween.to.strings;
            var round = tween.round;
            var numbers = [];
            var toNumbersLength = tween.to.numbers.length;
            var progress = void 0;
            for(var n = 0; n < toNumbersLength; n++){
                var value = void 0;
                var toNumber = tween.to.numbers[n];
                var fromNumber = tween.from.numbers[n] || 0;
                if (!tween.isPath) value = fromNumber + eased * (toNumber - fromNumber);
                else value = $e968c307c12f6712$var$getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
                if (round) {
                    if (!(tween.isColor && n > 2)) value = Math.round(value * round) / round;
                }
                numbers.push(value);
            }
            // Manual Array.reduce for better performances
            var stringsLength = strings.length;
            if (!stringsLength) progress = numbers[0];
            else {
                progress = strings[0];
                for(var s = 0; s < stringsLength; s++){
                    var a = strings[s];
                    var b = strings[s + 1];
                    var n$1 = numbers[s];
                    if (!isNaN(n$1)) {
                        if (!b) progress += n$1 + ' ';
                        else progress += n$1 + b;
                    }
                }
            }
            $e968c307c12f6712$var$setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
            anim.currentValue = progress;
            i++;
        }
    }
    function setCallback(cb) {
        if (instance[cb] && !instance.passThrough) instance[cb](instance);
    }
    function countIteration() {
        if (instance.remaining && instance.remaining !== true) instance.remaining--;
    }
    function setInstanceProgress(engineTime) {
        var insDuration = instance.duration;
        var insDelay = instance.delay;
        var insEndDelay = insDuration - instance.endDelay;
        var insTime = adjustTime(engineTime);
        instance.progress = $e968c307c12f6712$var$minMax(insTime / insDuration * 100, 0, 100);
        instance.reversePlayback = insTime < instance.currentTime;
        if (children) syncInstanceChildren(insTime);
        if (!instance.began && instance.currentTime > 0) {
            instance.began = true;
            setCallback('begin');
        }
        if (!instance.loopBegan && instance.currentTime > 0) {
            instance.loopBegan = true;
            setCallback('loopBegin');
        }
        if (insTime <= insDelay && instance.currentTime !== 0) setAnimationsProgress(0);
        if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) setAnimationsProgress(insDuration);
        if (insTime > insDelay && insTime < insEndDelay) {
            if (!instance.changeBegan) {
                instance.changeBegan = true;
                instance.changeCompleted = false;
                setCallback('changeBegin');
            }
            setCallback('change');
            setAnimationsProgress(insTime);
        } else if (instance.changeBegan) {
            instance.changeCompleted = true;
            instance.changeBegan = false;
            setCallback('changeComplete');
        }
        instance.currentTime = $e968c307c12f6712$var$minMax(insTime, 0, insDuration);
        if (instance.began) setCallback('update');
        if (engineTime >= insDuration) {
            lastTime = 0;
            countIteration();
            if (!instance.remaining) {
                instance.paused = true;
                if (!instance.completed) {
                    instance.completed = true;
                    setCallback('loopComplete');
                    setCallback('complete');
                    if (!instance.passThrough && 'Promise' in window) {
                        resolve();
                        promise = makePromise(instance);
                    }
                }
            } else {
                startTime = now;
                setCallback('loopComplete');
                instance.loopBegan = false;
                if (instance.direction === 'alternate') toggleInstanceDirection();
            }
        }
    }
    instance.reset = function() {
        var direction = instance.direction;
        instance.passThrough = false;
        instance.currentTime = 0;
        instance.progress = 0;
        instance.paused = true;
        instance.began = false;
        instance.loopBegan = false;
        instance.changeBegan = false;
        instance.completed = false;
        instance.changeCompleted = false;
        instance.reversePlayback = false;
        instance.reversed = direction === 'reverse';
        instance.remaining = instance.loop;
        children = instance.children;
        childrenLength = children.length;
        for(var i = childrenLength; i--;)instance.children[i].reset();
        if (instance.reversed && instance.loop !== true || direction === 'alternate' && instance.loop === 1) instance.remaining++;
        setAnimationsProgress(instance.reversed ? instance.duration : 0);
    };
    // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)
    instance._onDocumentVisibility = resetTime;
    // Set Value helper
    instance.set = function(targets, properties) {
        $e968c307c12f6712$var$setTargetsValue(targets, properties);
        return instance;
    };
    instance.tick = function(t) {
        now = t;
        if (!startTime) startTime = now;
        setInstanceProgress((now + (lastTime - startTime)) * $e968c307c12f6712$var$anime.speed);
    };
    instance.seek = function(time) {
        setInstanceProgress(adjustTime(time));
    };
    instance.pause = function() {
        instance.paused = true;
        resetTime();
    };
    instance.play = function() {
        if (!instance.paused) return;
        if (instance.completed) instance.reset();
        instance.paused = false;
        $e968c307c12f6712$var$activeInstances.push(instance);
        resetTime();
        $e968c307c12f6712$var$engine();
    };
    instance.reverse = function() {
        toggleInstanceDirection();
        instance.completed = instance.reversed ? false : true;
        resetTime();
    };
    instance.restart = function() {
        instance.reset();
        instance.play();
    };
    instance.remove = function(targets) {
        var targetsArray = $e968c307c12f6712$var$parseTargets(targets);
        $e968c307c12f6712$var$removeTargetsFromInstance(targetsArray, instance);
    };
    instance.reset();
    if (instance.autoplay) instance.play();
    return instance;
}
// Remove targets from animation
function $e968c307c12f6712$var$removeTargetsFromAnimations(targetsArray, animations) {
    for(var a = animations.length; a--;)if ($e968c307c12f6712$var$arrayContains(targetsArray, animations[a].animatable.target)) animations.splice(a, 1);
}
function $e968c307c12f6712$var$removeTargetsFromInstance(targetsArray, instance) {
    var animations = instance.animations;
    var children = instance.children;
    $e968c307c12f6712$var$removeTargetsFromAnimations(targetsArray, animations);
    for(var c = children.length; c--;){
        var child = children[c];
        var childAnimations = child.animations;
        $e968c307c12f6712$var$removeTargetsFromAnimations(targetsArray, childAnimations);
        if (!childAnimations.length && !child.children.length) children.splice(c, 1);
    }
    if (!animations.length && !children.length) instance.pause();
}
function $e968c307c12f6712$var$removeTargetsFromActiveInstances(targets) {
    var targetsArray = $e968c307c12f6712$var$parseTargets(targets);
    for(var i = $e968c307c12f6712$var$activeInstances.length; i--;){
        var instance = $e968c307c12f6712$var$activeInstances[i];
        $e968c307c12f6712$var$removeTargetsFromInstance(targetsArray, instance);
    }
}
// Stagger helpers
function $e968c307c12f6712$var$stagger(val, params) {
    if (params === void 0) params = {};
    var direction = params.direction || 'normal';
    var easing = params.easing ? $e968c307c12f6712$var$parseEasings(params.easing) : null;
    var grid = params.grid;
    var axis = params.axis;
    var fromIndex = params.from || 0;
    var fromFirst = fromIndex === 'first';
    var fromCenter = fromIndex === 'center';
    var fromLast = fromIndex === 'last';
    var isRange = $e968c307c12f6712$var$is.arr(val);
    var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
    var val2 = isRange ? parseFloat(val[1]) : 0;
    var unit = $e968c307c12f6712$var$getUnit(isRange ? val[1] : val) || 0;
    var start = params.start || 0 + (isRange ? val1 : 0);
    var values = [];
    var maxValue = 0;
    return function(el, i, t) {
        if (fromFirst) fromIndex = 0;
        if (fromCenter) fromIndex = (t - 1) / 2;
        if (fromLast) fromIndex = t - 1;
        if (!values.length) {
            for(var index = 0; index < t; index++){
                if (!grid) values.push(Math.abs(fromIndex - index));
                else {
                    var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
                    var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
                    var toX = index % grid[0];
                    var toY = Math.floor(index / grid[0]);
                    var distanceX = fromX - toX;
                    var distanceY = fromY - toY;
                    var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                    if (axis === 'x') value = -distanceX;
                    if (axis === 'y') value = -distanceY;
                    values.push(value);
                }
                maxValue = Math.max.apply(Math, values);
            }
            if (easing) values = values.map(function(val) {
                return easing(val / maxValue) * maxValue;
            });
            if (direction === 'reverse') values = values.map(function(val) {
                return axis ? val < 0 ? val * -1 : -val : Math.abs(maxValue - val);
            });
        }
        var spacing = isRange ? (val2 - val1) / maxValue : val1;
        return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
    };
}
// Timeline
function $e968c307c12f6712$var$timeline(params) {
    if (params === void 0) params = {};
    var tl = $e968c307c12f6712$var$anime(params);
    tl.duration = 0;
    tl.add = function(instanceParams, timelineOffset) {
        var tlIndex = $e968c307c12f6712$var$activeInstances.indexOf(tl);
        var children = tl.children;
        if (tlIndex > -1) $e968c307c12f6712$var$activeInstances.splice(tlIndex, 1);
        function passThrough(ins) {
            ins.passThrough = true;
        }
        for(var i = 0; i < children.length; i++)passThrough(children[i]);
        var insParams = $e968c307c12f6712$var$mergeObjects(instanceParams, $e968c307c12f6712$var$replaceObjectProps($e968c307c12f6712$var$defaultTweenSettings, params));
        insParams.targets = insParams.targets || params.targets;
        var tlDuration = tl.duration;
        insParams.autoplay = false;
        insParams.direction = tl.direction;
        insParams.timelineOffset = $e968c307c12f6712$var$is.und(timelineOffset) ? tlDuration : $e968c307c12f6712$var$getRelativeValue(timelineOffset, tlDuration);
        passThrough(tl);
        tl.seek(insParams.timelineOffset);
        var ins = $e968c307c12f6712$var$anime(insParams);
        passThrough(ins);
        children.push(ins);
        var timings = $e968c307c12f6712$var$getInstanceTimings(children, params);
        tl.delay = timings.delay;
        tl.endDelay = timings.endDelay;
        tl.duration = timings.duration;
        tl.seek(0);
        tl.reset();
        if (tl.autoplay) tl.play();
        return tl;
    };
    return tl;
}
$e968c307c12f6712$var$anime.version = '3.2.1';
$e968c307c12f6712$var$anime.speed = 1;
// TODO:#review: naming, documentation
$e968c307c12f6712$var$anime.suspendWhenDocumentHidden = true;
$e968c307c12f6712$var$anime.running = $e968c307c12f6712$var$activeInstances;
$e968c307c12f6712$var$anime.remove = $e968c307c12f6712$var$removeTargetsFromActiveInstances;
$e968c307c12f6712$var$anime.get = $e968c307c12f6712$var$getOriginalTargetValue;
$e968c307c12f6712$var$anime.set = $e968c307c12f6712$var$setTargetsValue;
$e968c307c12f6712$var$anime.convertPx = $e968c307c12f6712$var$convertPxToUnit;
$e968c307c12f6712$var$anime.path = $e968c307c12f6712$var$getPath;
$e968c307c12f6712$var$anime.setDashoffset = $e968c307c12f6712$var$setDashoffset;
$e968c307c12f6712$var$anime.stagger = $e968c307c12f6712$var$stagger;
$e968c307c12f6712$var$anime.timeline = $e968c307c12f6712$var$timeline;
$e968c307c12f6712$var$anime.easing = $e968c307c12f6712$var$parseEasings;
$e968c307c12f6712$var$anime.penner = $e968c307c12f6712$var$penner;
$e968c307c12f6712$var$anime.random = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
var $e968c307c12f6712$export$2e2bcd8739ae039 = $e968c307c12f6712$var$anime;

});


parcelRegister("6Ii0J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.animate = void 0;

var $4TeKW = parcelRequire("4TeKW");
function $4e34d2b0a8c4f775$var$animate(template, fn = ({ stagger: stagger })=>({
        delay: stagger(200),
        translateX: 0,
        easing: 'spring(1, 80, 10, 0)'
    })) {
    return (0, $4TeKW.html)`
    <rx-animation .options=${fn}>
      ${template}
    </rx-animation>
  `;
}
module.exports.animate = $4e34d2b0a8c4f775$var$animate;

});

parcelRegister("4OIUb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("4mXm7", function(module, exports) {

$parcel$export(module.exports, "DROPDOWN_SIZE", () => (parcelRequire("5Wl2V")).DROPDOWN_SIZE);

var $ftPDQ = parcelRequire("ftPDQ");

var $kZ0tv = parcelRequire("kZ0tv");

var $jpdgO = parcelRequire("jpdgO");

var $jd9RL = parcelRequire("jd9RL");

var $gg2C2 = parcelRequire("gg2C2");
parcelRequire("3eEWe");
var $2pFDC = parcelRequire("2pFDC");
var $3tvu5 = parcelRequire("3tvu5");
var $3eEWe = parcelRequire("3eEWe");

var $1Va8b = parcelRequire("1Va8b");

var $10Bt3 = parcelRequire("10Bt3");

var $5l5Nb = parcelRequire("5l5Nb");

var $6Ia5q = parcelRequire("6Ia5q");

var $498Lv = parcelRequire("498Lv");

var $01HFT = parcelRequire("01HFT");

var $hfEKd = parcelRequire("hfEKd");

var $gfp9Q = parcelRequire("gfp9Q");
parcelRequire("5Wl2V");
var $e4B20 = parcelRequire("e4B20");
var $5Wl2V = parcelRequire("5Wl2V");

var $7vLeM = parcelRequire("7vLeM");
let $32e742540793ece9$var$_ = (t)=>t, $32e742540793ece9$var$_t, $32e742540793ece9$var$_t2, $32e742540793ece9$var$_t3, $32e742540793ece9$var$_t4, $32e742540793ece9$var$_t5;
const { prefix: $32e742540793ece9$var$prefix } = (0, $jpdgO.default);
/**
 * Dropdown.
 * @element bx-dropdown
 * @csspart label-text The label text.
 * @csspart helper-text The helper text.
 * @csspart trigger-button The trigger button.
 * @csspart menu-body The menu body.
 * @csspart validity-message The validity message.
 * @fires bx-dropdown-beingselected
 *   The custom event fired before a dropdown item is selected upon a user gesture.
 *   Cancellation of this event stops changing the user-initiated selection.
 * @fires bx-dropdown-beingtoggled
 *   The custom event fired before the open state of this dropdown is toggled upon a user gesture.
 *   Cancellation of this event stops the user-initiated toggling.
 * @fires bx-dropdown-selected - The custom event fired after a dropdown item is selected upon a user gesture.
 * @fires bx-dropdown-toggled - The custom event fired after the open state of this dropdown is toggled upon a user gesture.
 */ let $32e742540793ece9$var$BXDropdown = (0, $kZ0tv.default)([
    (0, $2pFDC.customElement)(`${$32e742540793ece9$var$prefix}-dropdown`)
], function(_initialize, _ValidityMixin) {
    class BXDropdown extends _ValidityMixin {
        constructor(...args){
            super(...args);
            _initialize(this);
        }
    }
    return {
        F: BXDropdown,
        d: [
            {
                kind: "field",
                key: "_selectedItemContent",
                value () {
                    return null;
                }
            },
            {
                kind: "field",
                key: "_shouldTriggerBeFocusable",
                value () {
                    return true;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.query)(`.${$32e742540793ece9$var$prefix}--list-box`)
                ],
                key: "_listBoxNode",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.query)('slot[name="helper-text"]')
                ],
                key: "_slotHelperTextNode",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.query)('slot[name="label-text"]')
                ],
                key: "_slotLabelTextNode",
                value: void 0
            },
            {
                kind: "method",
                key: "_selectionShouldChange",
                value: /**
       * The latest status of this dropdown, for screen reader to accounce.
       */ /**
       * The content of the selected item.
       */ /**
       * `true` if the trigger button should be focusable.
       * Derived class can set `false` to this if the trigger button contains another primary focusable element (e.g. `<input>`).
       */ /**
       * The list box `<div>` node.
       */ /**
       * The `<slot>` element for the helper text in the shadow DOM.
       */ /**
       * The `<slot>` element for the label text in the shadow DOM.
       */ /**
       * @param itemToSelect A dropdown item. Absense of this argument means clearing selection.
       * @returns `true` if the selection of this dropdown should change if the given item is selected upon user interaction.
       */ function _selectionShouldChange(itemToSelect) {
                    return !itemToSelect || itemToSelect.value !== this.value;
                }
            },
            {
                kind: "method",
                key: "_selectionDidChange",
                value: function _selectionDidChange(itemToSelect) {
                    if (itemToSelect) {
                        this.value = itemToSelect.value;
                        (0, $gfp9Q.forEach)(this.querySelectorAll(this.constructor.selectorItemSelected), (item)=>{
                            item.selected = false;
                        });
                        itemToSelect.selected = true;
                        this._assistiveStatusText = this.selectedItemAssistiveText;
                        this._handleUserInitiatedToggle(false);
                    }
                }
            },
            {
                kind: "method",
                key: "_handleClickInner",
                value: function _handleClickInner(event) {
                    if (this.shadowRoot.contains(event.target)) this._handleUserInitiatedToggle();
                    else {
                        const item = event.target.closest(this.constructor.selectorItem);
                        if (this.contains(item)) this._handleUserInitiatedSelectItem(item);
                    }
                }
            },
            {
                kind: "method",
                key: "_handleKeydownInner",
                value: function _handleKeydownInner(event) {
                    const { key: key } = event;
                    const action = this.constructor.getAction(key);
                    if (!this.open) switch(action){
                        case (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).NAVIGATING:
                            this._handleUserInitiatedToggle(true); // If this menu gets open with an arrow key, reset the highlight
                            this._clearHighlight();
                            break;
                        default:
                            break;
                    }
                    else switch(action){
                        case (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).CLOSING:
                            this._handleUserInitiatedToggle(false);
                            break;
                        case (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).NAVIGATING:
                            this._navigate((0, $5Wl2V.NAVIGATION_DIRECTION)[key]);
                            break;
                        default:
                            break;
                    }
                }
            },
            {
                kind: "method",
                key: "_handleKeypressInner",
                value: function _handleKeypressInner(event) {
                    const { key: key } = event;
                    const action = this.constructor.getAction(key);
                    if (!this.open) switch(action){
                        case (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).TRIGGERING:
                            this._handleUserInitiatedToggle(true);
                            break;
                        default:
                            break;
                    }
                    else switch(action){
                        case (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).TRIGGERING:
                            {
                                const constructor = this.constructor;
                                const highlightedItem = this.querySelector(constructor.selectorItemHighlighted);
                                if (highlightedItem) this._handleUserInitiatedSelectItem(highlightedItem);
                                else this._handleUserInitiatedToggle(false);
                            }
                            break;
                        default:
                            break;
                    }
                }
            },
            {
                kind: "method",
                decorators: [
                    (0, $hfEKd.default)('focusout')
                ],
                key: "_handleFocusOut",
                value: function _handleFocusOut(event) {
                    if (!this.contains(event.relatedTarget)) this._handleUserInitiatedToggle(false);
                }
            },
            {
                kind: "method",
                key: "_handleSlotchangeHelperText",
                value: function _handleSlotchangeHelperText() {
                    this.requestUpdate();
                }
            },
            {
                kind: "method",
                key: "_handleSlotchangeLabelText",
                value: function _handleSlotchangeLabelText() {
                    this.requestUpdate();
                }
            },
            {
                kind: "method",
                key: "_handleUserInitiatedSelectItem",
                value: function _handleUserInitiatedSelectItem(item) {
                    if (this._selectionShouldChange(item)) {
                        const init = {
                            bubbles: true,
                            composed: true,
                            detail: {
                                item: item
                            }
                        };
                        const constructor = this.constructor;
                        const beforeSelectEvent = new CustomEvent(constructor.eventBeforeSelect, (0, $ftPDQ.default)((0, $ftPDQ.default)({}, init), {}, {
                            cancelable: true
                        }));
                        if (this.dispatchEvent(beforeSelectEvent)) {
                            this._selectionDidChange(item);
                            const afterSelectEvent = new CustomEvent(constructor.eventSelect, init);
                            this.dispatchEvent(afterSelectEvent);
                        }
                    }
                }
            },
            {
                kind: "method",
                key: "_handleUserInitiatedToggle",
                value: function _handleUserInitiatedToggle(force = !this.open) {
                    const { eventBeforeToggle: eventBeforeToggle, eventToggle: eventToggle } = this.constructor;
                    const init = {
                        bubbles: true,
                        cancelable: true,
                        composed: true,
                        detail: {
                            open: force
                        }
                    };
                    if (this.dispatchEvent(new CustomEvent(eventBeforeToggle, init))) {
                        this.open = force;
                        if (this.open) this._assistiveStatusText = this.selectingItemsAssistiveText;
                        else {
                            const { selectedItemAssistiveText: selectedItemAssistiveText, triggerContent: triggerContent, _assistiveStatusText: assistiveStatusText, _selectedItemContent: selectedItemContent } = this;
                            const selectedItemText = selectedItemContent && selectedItemContent.textContent || triggerContent;
                            if (selectedItemText && assistiveStatusText !== selectedItemAssistiveText) this._assistiveStatusText = selectedItemText;
                            (0, $gfp9Q.forEach)(this.querySelectorAll(this.constructor.selectorItemHighlighted), (item)=>{
                                item.highlighted = false;
                            });
                        }
                        this.requestUpdate();
                        this.dispatchEvent(new CustomEvent(eventToggle, init));
                    }
                }
            },
            {
                kind: "method",
                key: "_clearHighlight",
                value: function _clearHighlight() {
                    (0, $gfp9Q.forEach)(this.querySelectorAll(this.constructor.selectorItem), (item)=>{
                        item.highlighted = false;
                    });
                }
            },
            {
                kind: "method",
                key: "_navigate",
                value: function _navigate(direction) {
                    const constructor = this.constructor;
                    const items = this.querySelectorAll(constructor.selectorItem);
                    const highlightedItem = this.querySelector(constructor.selectorItemHighlighted);
                    const highlightedIndex = (0, $gfp9Q.indexOf)(items, highlightedItem);
                    let nextIndex = highlightedIndex + direction;
                    if (nextIndex < 0) nextIndex = items.length - 1;
                    if (nextIndex >= items.length) nextIndex = 0;
                    (0, $gfp9Q.forEach)(items, (item, i)=>{
                        item.highlighted = i === nextIndex;
                    });
                    const nextItem = items[nextIndex]; // Using `{ block: 'nearest' }` to prevent scrolling unless scrolling is absolutely necessary.
                    // `scrollIntoViewOptions` seems to work in latest Safari despite of MDN/caniuse table.
                    // IE falls back to the old behavior.
                    nextItem.scrollIntoView({
                        block: 'nearest'
                    });
                    const nextItemText = nextItem.textContent;
                    if (nextItemText) this._assistiveStatusText = nextItemText;
                    this.requestUpdate();
                }
            },
            {
                kind: "method",
                key: "_renderPrecedingTriggerContent",
                value: function _renderPrecedingTriggerContent() {
                    return undefined;
                }
            },
            {
                kind: "method",
                key: "_renderTriggerContent",
                value: function _renderTriggerContent() {
                    const { triggerContent: triggerContent, _selectedItemContent: selectedItemContent } = this;
                    return (0, $3tvu5.html)($32e742540793ece9$var$_t || ($32e742540793ece9$var$_t = $32e742540793ece9$var$_` <span id="trigger-label" class="${0}--list-box__label">${0}</span> `), $32e742540793ece9$var$prefix, selectedItemContent || triggerContent);
                }
            },
            {
                kind: "method",
                key: "_renderFollowingTriggerContent",
                value: function _renderFollowingTriggerContent() {
                    return undefined;
                }
            },
            {
                kind: "method",
                key: "_handleFormdata",
                value: function _handleFormdata(event) {
                    const { formData: formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
                    const { disabled: disabled, name: name, value: value } = this;
                    if (!disabled) formData.append(name, value);
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'color-scheme',
                        reflect: true
                    })
                ],
                key: "colorScheme",
                value () {
                    return (0, $e4B20.FORM_ELEMENT_COLOR_SCHEME).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "disabled",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'helper-text'
                    })
                ],
                key: "helperText",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "invalid",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'label-text'
                    })
                ],
                key: "labelText",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "name",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "open",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "required",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'required-validity-message'
                    })
                ],
                key: "requiredValidityMessage",
                value () {
                    return 'Please fill out this field.';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'selecting-items-assistive-text'
                    })
                ],
                key: "selectingItemsAssistiveText",
                value () {
                    return 'Selecting items. Use up and down arrow keys to navigate.';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'selected-item-assistive-text'
                    })
                ],
                key: "selectedItemAssistiveText",
                value () {
                    return 'Selected an item.';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "size",
                value () {
                    return (0, $5Wl2V.DROPDOWN_SIZE).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'toggle-label-closed'
                    })
                ],
                key: "toggleLabelClosed",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'toggle-label-open'
                    })
                ],
                key: "toggleLabelOpen",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'trigger-content'
                    })
                ],
                key: "triggerContent",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "type",
                value () {
                    return (0, $5Wl2V.DROPDOWN_TYPE).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'validity-message'
                    })
                ],
                key: "validityMessage",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "value",
                value () {
                    return '';
                }
            },
            {
                kind: "method",
                key: "createRenderRoot",
                value: /**
       * `true` if this dropdown should be disabled.
       */ /**
       * The helper text.
       */ /**
       * `true` to show the UI of the invalid state.
       */ /**
       * The label text.
       */ /**
       * Name for the dropdown in the `FormData`
       */ /**
       * `true` if this dropdown should be open.
       */ /**
       * `true` if the value is required.
       */ /**
       * The special validity message for `required`.
       */ /**
       * An assistive text for screen reader to announce, telling the open state.
       */ /**
       * An assistive text for screen reader to announce, telling that an item is selected.
       */ /**
       * Dropdown size.
       */ /**
       * The `aria-label` attribute for the UI indicating the closed state.
       */ /**
       * The `aria-label` attribute for the UI indicating the open state.
       */ /**
       * The content of the trigger button.
       */ /**
       * `true` if this dropdown should use the inline UI variant.
       */ /**
       * The validity message.
       */ /**
       * The value of the selected item.
       */ function createRenderRoot() {
                    var _$exec;
                    return this.attachShadow({
                        mode: 'open',
                        delegatesFocus: Number(((_$exec = /Safari\/(\d+)/.exec(navigator.userAgent)) !== null && _$exec !== void 0 ? _$exec : [
                            '',
                            0
                        ])[1]) <= 537
                    });
                }
            },
            {
                kind: "method",
                key: "shouldUpdate",
                value: function shouldUpdate(changedProperties) {
                    const { selectorItem: selectorItem } = this.constructor;
                    if (changedProperties.has('size')) (0, $gfp9Q.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
                        elem.size = this.size;
                    });
                    if (changedProperties.has('value')) {
                        // `<bx-multi-select>` updates selection beforehand
                        // because our rendering logic for `<bx-multi-select>` looks for selected items via `qSA()`
                        (0, $gfp9Q.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
                            elem.selected = elem.value === this.value;
                        });
                        const item = (0, $gfp9Q.find)(this.querySelectorAll(selectorItem), (elem)=>elem.value === this.value);
                        if (item) {
                            const range = this.ownerDocument.createRange();
                            range.selectNodeContents(item);
                            this._selectedItemContent = range.cloneContents();
                        } else this._selectedItemContent = null;
                    }
                    return true;
                }
            },
            {
                kind: "method",
                key: "updated",
                value: function updated(changedProperties) {
                    const { helperText: helperText, type: type } = this;
                    const inline = type === (0, $5Wl2V.DROPDOWN_TYPE).INLINE;
                    const { selectorItem: selectorItem } = this.constructor;
                    if (changedProperties.has('disabled')) {
                        const { disabled: disabled } = this; // Propagate `disabled` attribute to descendants until `:host-context()` gets supported in all major browsers
                        (0, $gfp9Q.forEach)(this.querySelectorAll(selectorItem), (elem)=>{
                            elem.disabled = disabled;
                        });
                    }
                    if ((changedProperties.has('helperText') || changedProperties.has('type')) && helperText && inline) // eslint-disable-next-line no-console
                    console.warn('Found `helperText` property/attribute usage in inline mode, that is not supported, at:', this);
                }
            },
            {
                kind: "method",
                key: "render",
                value: function render() {
                    const { colorScheme: colorScheme, disabled: disabled, helperText: helperText, invalid: invalid, labelText: labelText, open: open, toggleLabelClosed: toggleLabelClosed, toggleLabelOpen: toggleLabelOpen, size: size, type: type, validityMessage: validityMessage, _assistiveStatusText: assistiveStatusText, _shouldTriggerBeFocusable: shouldTriggerBeFocusable, _handleClickInner: handleClickInner, _handleKeydownInner: handleKeydownInner, _handleKeypressInner: handleKeypressInner, _handleSlotchangeHelperText: handleSlotchangeHelperText, _handleSlotchangeLabelText: handleSlotchangeLabelText, _slotHelperTextNode: slotHelperTextNode, _slotLabelTextNode: slotLabelTextNode } = this;
                    const inline = type === (0, $5Wl2V.DROPDOWN_TYPE).INLINE;
                    const selectedItemsCount = this.querySelectorAll(this.constructor.selectorItemSelected).length;
                    const classes = (0, $jd9RL.classMap)({
                        [`${$32e742540793ece9$var$prefix}--dropdown`]: true,
                        [`${$32e742540793ece9$var$prefix}--list-box`]: true,
                        [`${$32e742540793ece9$var$prefix}--list-box--${colorScheme}`]: colorScheme,
                        [`${$32e742540793ece9$var$prefix}--list-box--disabled`]: disabled,
                        [`${$32e742540793ece9$var$prefix}--list-box--inline`]: inline,
                        [`${$32e742540793ece9$var$prefix}--list-box--expanded`]: open,
                        [`${$32e742540793ece9$var$prefix}--list-box--${size}`]: size,
                        [`${$32e742540793ece9$var$prefix}--dropdown--invalid`]: invalid,
                        [`${$32e742540793ece9$var$prefix}--dropdown--inline`]: inline,
                        [`${$32e742540793ece9$var$prefix}--dropdown--selected`]: selectedItemsCount > 0
                    });
                    const labelClasses = (0, $jd9RL.classMap)({
                        [`${$32e742540793ece9$var$prefix}--label`]: true,
                        [`${$32e742540793ece9$var$prefix}--label--disabled`]: disabled
                    });
                    const helperClasses = (0, $jd9RL.classMap)({
                        [`${$32e742540793ece9$var$prefix}--form__helper-text`]: true,
                        [`${$32e742540793ece9$var$prefix}--form__helper-text--disabled`]: disabled
                    });
                    const iconContainerClasses = (0, $jd9RL.classMap)({
                        [`${$32e742540793ece9$var$prefix}--list-box__menu-icon`]: true,
                        [`${$32e742540793ece9$var$prefix}--list-box__menu-icon--open`]: open
                    });
                    const toggleLabel = (open ? toggleLabelOpen : toggleLabelClosed) || undefined;
                    const hasHelperText = helperText || slotHelperTextNode && slotHelperTextNode.assignedNodes().length > 0;
                    const hasLabelText = labelText || slotLabelTextNode && slotLabelTextNode.assignedNodes().length > 0;
                    const helper = !invalid ? (0, $3tvu5.html)($32e742540793ece9$var$_t2 || ($32e742540793ece9$var$_t2 = $32e742540793ece9$var$_` <div part="helper-text" class="${0}" ?hidden="${0}"> <slot name="helper-text" @slotchange="${0}">${0}</slot> </div> `), helperClasses, inline || !hasHelperText, handleSlotchangeHelperText, helperText) : (0, $3tvu5.html)($32e742540793ece9$var$_t3 || ($32e742540793ece9$var$_t3 = $32e742540793ece9$var$_` <div part="validity-message" class="${0}"> <slot name="validity-message">${0}</slot> </div> `), `${$32e742540793ece9$var$prefix}--form-requirement`, validityMessage);
                    const validityIcon = !invalid ? undefined : (0, $10Bt3.default)({
                        class: `${$32e742540793ece9$var$prefix}--list-box__invalid-icon`,
                        'aria-label': toggleLabel
                    });
                    const menuBody = !open ? undefined : (0, $3tvu5.html)($32e742540793ece9$var$_t4 || ($32e742540793ece9$var$_t4 = $32e742540793ece9$var$_` <div id="menu-body" part="menu-body" class="${0}--list-box__menu" role="listbox" tabindex="-1"> <slot></slot> </div> `), $32e742540793ece9$var$prefix);
                    return (0, $3tvu5.html)($32e742540793ece9$var$_t5 || ($32e742540793ece9$var$_t5 = $32e742540793ece9$var$_` <label part="label-text" class="${0}" ?hidden="${0}"> <slot name="label-text" @slotchange="${0}">${0}</slot> </label> <div role="listbox" class="${0}" ?data-invalid="${0}" @click="${0}" @keydown="${0}" @keypress="${0}"> ${0} <div part="trigger-button" role="${0}" class="${0}--list-box__field" tabindex="${0}" aria-labelledby="trigger-label" aria-expanded="${0}" aria-haspopup="listbox" aria-owns="menu-body" aria-controls="menu-body"> ${0}${0}${0} <div class="${0}">${0}</div> </div> ${0} </div> ${0} <div class="${0}--assistive-text" role="status" aria-live="assertive" aria-relevant="additions text"> ${0} </div> `), labelClasses, !hasLabelText, handleSlotchangeLabelText, labelText, classes, invalid, handleClickInner, handleKeydownInner, handleKeypressInner, validityIcon, (0, $gg2C2.ifDefined)(!shouldTriggerBeFocusable ? undefined : 'button'), $32e742540793ece9$var$prefix, (0, $gg2C2.ifDefined)(!shouldTriggerBeFocusable ? undefined : '0'), String(open), this._renderPrecedingTriggerContent(), this._renderTriggerContent(), this._renderFollowingTriggerContent(), iconContainerClasses, (0, $1Va8b.default)({
                        'aria-label': toggleLabel
                    }), menuBody, helper, $32e742540793ece9$var$prefix, assistiveStatusText);
                }
            },
            {
                kind: "field",
                static: true,
                key: "TRIGGER_KEYS",
                value () {
                    return new Set([
                        ' ',
                        'Enter'
                    ]);
                }
            },
            {
                kind: "get",
                static: true,
                key: "selectorItemHighlighted",
                value: /**
       * A selector that will return highlighted items.
       */ function selectorItemHighlighted() {
                    return `${$32e742540793ece9$var$prefix}-dropdown-item[highlighted]`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "selectorItem",
                value: function selectorItem() {
                    return `${$32e742540793ece9$var$prefix}-dropdown-item`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "selectorItemSelected",
                value: function selectorItemSelected() {
                    return `${$32e742540793ece9$var$prefix}-dropdown-item[selected]`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "eventBeforeSelect",
                value: function eventBeforeSelect() {
                    return `${$32e742540793ece9$var$prefix}-dropdown-beingselected`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "eventSelect",
                value: function eventSelect() {
                    return `${$32e742540793ece9$var$prefix}-dropdown-selected`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "eventBeforeToggle",
                value: function eventBeforeToggle() {
                    return `${$32e742540793ece9$var$prefix}-dropdown-beingtoggled`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "eventToggle",
                value: function eventToggle() {
                    return `${$32e742540793ece9$var$prefix}-dropdown-toggled`;
                }
            },
            {
                kind: "field",
                static: true,
                key: "styles",
                value () {
                    return 0, $7vLeM.default;
                }
            },
            {
                kind: "method",
                static: true,
                key: "getAction",
                value: /**
       * @returns A action for dropdown for the given key symbol.
       */ function getAction(key) {
                    if (key === 'Escape') return (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).CLOSING;
                    if (key in (0, $5Wl2V.NAVIGATION_DIRECTION)) return (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).NAVIGATING;
                    if (this.TRIGGER_KEYS.has(key)) return (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).TRIGGERING;
                    return (0, $5Wl2V.DROPDOWN_KEYBOARD_ACTION).NONE;
                }
            }
        ]
    };
}, (0, $01HFT.default)((0, $498Lv.default)((0, $6Ia5q.default)((0, $5l5Nb.default)((0, $3eEWe.LitElement))))));
var $32e742540793ece9$export$2e2bcd8739ae039 = $32e742540793ece9$var$BXDropdown;

});
parcelRegister("ftPDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4519f6af474e227$export$2e2bcd8739ae039);

var $gCjvw = parcelRequire("gCjvw");
function $b4519f6af474e227$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b4519f6af474e227$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b4519f6af474e227$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $gCjvw.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b4519f6af474e227$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

});
parcelRegister("gCjvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c18f53b433d477dc$export$2e2bcd8739ae039);

var $cRtON = parcelRequire("cRtON");
function $c18f53b433d477dc$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $cRtON.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("cRtON", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d19091e4c5e168$export$2e2bcd8739ae039);

var $iOM9X = parcelRequire("iOM9X");

var $6kWVR = parcelRequire("6kWVR");
function $95d19091e4c5e168$export$2e2bcd8739ae039(arg) {
    var key = (0, $6kWVR.default)(arg, "string");
    return (0, $iOM9X.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("iOM9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $db324102d1103769$export$2e2bcd8739ae039);
function $db324102d1103769$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $db324102d1103769$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $db324102d1103769$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("6kWVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $49d2530f1b2fe3cc$export$2e2bcd8739ae039);

var $iOM9X = parcelRequire("iOM9X");
function $49d2530f1b2fe3cc$export$2e2bcd8739ae039(input, hint) {
    if ((0, $iOM9X.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $iOM9X.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});




parcelRegister("kZ0tv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f469df7aad36f65d$export$2e2bcd8739ae039);

var $fBBPs = parcelRequire("fBBPs");

var $cRtON = parcelRequire("cRtON");
function $f469df7aad36f65d$export$2e2bcd8739ae039(decorators, factory, superClass, mixins) {
    var api = $f469df7aad36f65d$var$_getDecoratorsApi();
    if (mixins) for(var i = 0; i < mixins.length; i++)api = mixins[i](api);
    var r = factory(function initialize(O) {
        api.initializeInstanceElements(O, decorated.elements);
    }, superClass);
    var decorated = api.decorateClass($f469df7aad36f65d$var$_coalesceClassElements(r.d.map($f469df7aad36f65d$var$_createElementDescriptor)), decorators);
    api.initializeClassElements(r.F, decorated.elements);
    return api.runClassFinishers(r.F, decorated.finishers);
}
function $f469df7aad36f65d$var$_getDecoratorsApi() {
    $f469df7aad36f65d$var$_getDecoratorsApi = function _getDecoratorsApi() {
        return api;
    };
    var api = {
        elementsDefinitionOrder: [
            [
                "method"
            ],
            [
                "field"
            ]
        ],
        initializeInstanceElements: function initializeInstanceElements(O, elements) {
            [
                "method",
                "field"
            ].forEach(function(kind) {
                elements.forEach(function(element) {
                    if (element.kind === kind && element.placement === "own") this.defineClassElement(O, element);
                }, this);
            }, this);
        },
        initializeClassElements: function initializeClassElements(F, elements) {
            var proto = F.prototype;
            [
                "method",
                "field"
            ].forEach(function(kind) {
                elements.forEach(function(element) {
                    var placement = element.placement;
                    if (element.kind === kind && (placement === "static" || placement === "prototype")) {
                        var receiver = placement === "static" ? F : proto;
                        this.defineClassElement(receiver, element);
                    }
                }, this);
            }, this);
        },
        defineClassElement: function defineClassElement(receiver, element) {
            var descriptor = element.descriptor;
            if (element.kind === "field") {
                var initializer = element.initializer;
                descriptor = {
                    enumerable: descriptor.enumerable,
                    writable: descriptor.writable,
                    configurable: descriptor.configurable,
                    value: initializer === void 0 ? void 0 : initializer.call(receiver)
                };
            }
            Object.defineProperty(receiver, element.key, descriptor);
        },
        decorateClass: function decorateClass(elements, decorators) {
            var newElements = [];
            var finishers = [];
            var placements = {
                "static": [],
                prototype: [],
                own: []
            };
            elements.forEach(function(element) {
                this.addElementPlacement(element, placements);
            }, this);
            elements.forEach(function(element) {
                if (!$f469df7aad36f65d$var$_hasDecorators(element)) return newElements.push(element);
                var elementFinishersExtras = this.decorateElement(element, placements);
                newElements.push(elementFinishersExtras.element);
                newElements.push.apply(newElements, elementFinishersExtras.extras);
                finishers.push.apply(finishers, elementFinishersExtras.finishers);
            }, this);
            if (!decorators) return {
                elements: newElements,
                finishers: finishers
            };
            var result = this.decorateConstructor(newElements, decorators);
            finishers.push.apply(finishers, result.finishers);
            result.finishers = finishers;
            return result;
        },
        addElementPlacement: function addElementPlacement(element, placements, silent) {
            var keys = placements[element.placement];
            if (!silent && keys.indexOf(element.key) !== -1) throw new TypeError("Duplicated element (" + element.key + ")");
            keys.push(element.key);
        },
        decorateElement: function decorateElement(element, placements) {
            var extras = [];
            var finishers = [];
            for(var decorators = element.decorators, i = decorators.length - 1; i >= 0; i--){
                var keys = placements[element.placement];
                keys.splice(keys.indexOf(element.key), 1);
                var elementObject = this.fromElementDescriptor(element);
                var elementFinisherExtras = this.toElementFinisherExtras((0, decorators[i])(elementObject) || elementObject);
                element = elementFinisherExtras.element;
                this.addElementPlacement(element, placements);
                if (elementFinisherExtras.finisher) finishers.push(elementFinisherExtras.finisher);
                var newExtras = elementFinisherExtras.extras;
                if (newExtras) {
                    for(var j = 0; j < newExtras.length; j++)this.addElementPlacement(newExtras[j], placements);
                    extras.push.apply(extras, newExtras);
                }
            }
            return {
                element: element,
                finishers: finishers,
                extras: extras
            };
        },
        decorateConstructor: function decorateConstructor(elements, decorators) {
            var finishers = [];
            for(var i = decorators.length - 1; i >= 0; i--){
                var obj = this.fromClassDescriptor(elements);
                var elementsAndFinisher = this.toClassDescriptor((0, decorators[i])(obj) || obj);
                if (elementsAndFinisher.finisher !== undefined) finishers.push(elementsAndFinisher.finisher);
                if (elementsAndFinisher.elements !== undefined) {
                    elements = elementsAndFinisher.elements;
                    for(var j = 0; j < elements.length - 1; j++)for(var k = j + 1; k < elements.length; k++){
                        if (elements[j].key === elements[k].key && elements[j].placement === elements[k].placement) throw new TypeError("Duplicated element (" + elements[j].key + ")");
                    }
                }
            }
            return {
                elements: elements,
                finishers: finishers
            };
        },
        fromElementDescriptor: function fromElementDescriptor(element) {
            var obj = {
                kind: element.kind,
                key: element.key,
                placement: element.placement,
                descriptor: element.descriptor
            };
            var desc = {
                value: "Descriptor",
                configurable: true
            };
            Object.defineProperty(obj, Symbol.toStringTag, desc);
            if (element.kind === "field") obj.initializer = element.initializer;
            return obj;
        },
        toElementDescriptors: function toElementDescriptors(elementObjects) {
            if (elementObjects === undefined) return;
            return (0, $fBBPs.default)(elementObjects).map(function(elementObject) {
                var element = this.toElementDescriptor(elementObject);
                this.disallowProperty(elementObject, "finisher", "An element descriptor");
                this.disallowProperty(elementObject, "extras", "An element descriptor");
                return element;
            }, this);
        },
        toElementDescriptor: function toElementDescriptor(elementObject) {
            var kind = String(elementObject.kind);
            if (kind !== "method" && kind !== "field") throw new TypeError('An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' + kind + '"');
            var key = (0, $cRtON.default)(elementObject.key);
            var placement = String(elementObject.placement);
            if (placement !== "static" && placement !== "prototype" && placement !== "own") throw new TypeError('An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' + placement + '"');
            var descriptor = elementObject.descriptor;
            this.disallowProperty(elementObject, "elements", "An element descriptor");
            var element = {
                kind: kind,
                key: key,
                placement: placement,
                descriptor: Object.assign({}, descriptor)
            };
            if (kind !== "field") this.disallowProperty(elementObject, "initializer", "A method descriptor");
            else {
                this.disallowProperty(descriptor, "get", "The property descriptor of a field descriptor");
                this.disallowProperty(descriptor, "set", "The property descriptor of a field descriptor");
                this.disallowProperty(descriptor, "value", "The property descriptor of a field descriptor");
                element.initializer = elementObject.initializer;
            }
            return element;
        },
        toElementFinisherExtras: function toElementFinisherExtras(elementObject) {
            var element = this.toElementDescriptor(elementObject);
            var finisher = $f469df7aad36f65d$var$_optionalCallableProperty(elementObject, "finisher");
            var extras = this.toElementDescriptors(elementObject.extras);
            return {
                element: element,
                finisher: finisher,
                extras: extras
            };
        },
        fromClassDescriptor: function fromClassDescriptor(elements) {
            var obj = {
                kind: "class",
                elements: elements.map(this.fromElementDescriptor, this)
            };
            var desc = {
                value: "Descriptor",
                configurable: true
            };
            Object.defineProperty(obj, Symbol.toStringTag, desc);
            return obj;
        },
        toClassDescriptor: function toClassDescriptor(obj) {
            var kind = String(obj.kind);
            if (kind !== "class") throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' + kind + '"');
            this.disallowProperty(obj, "key", "A class descriptor");
            this.disallowProperty(obj, "placement", "A class descriptor");
            this.disallowProperty(obj, "descriptor", "A class descriptor");
            this.disallowProperty(obj, "initializer", "A class descriptor");
            this.disallowProperty(obj, "extras", "A class descriptor");
            var finisher = $f469df7aad36f65d$var$_optionalCallableProperty(obj, "finisher");
            var elements = this.toElementDescriptors(obj.elements);
            return {
                elements: elements,
                finisher: finisher
            };
        },
        runClassFinishers: function runClassFinishers(constructor, finishers) {
            for(var i = 0; i < finishers.length; i++){
                var newConstructor = (0, finishers[i])(constructor);
                if (newConstructor !== undefined) {
                    if (typeof newConstructor !== "function") throw new TypeError("Finishers must return a constructor.");
                    constructor = newConstructor;
                }
            }
            return constructor;
        },
        disallowProperty: function disallowProperty(obj, name, objectType) {
            if (obj[name] !== undefined) throw new TypeError(objectType + " can't have a ." + name + " property.");
        }
    };
    return api;
}
function $f469df7aad36f65d$var$_createElementDescriptor(def) {
    var key = (0, $cRtON.default)(def.key);
    var descriptor;
    if (def.kind === "method") descriptor = {
        value: def.value,
        writable: true,
        configurable: true,
        enumerable: false
    };
    else if (def.kind === "get") descriptor = {
        get: def.value,
        configurable: true,
        enumerable: false
    };
    else if (def.kind === "set") descriptor = {
        set: def.value,
        configurable: true,
        enumerable: false
    };
    else if (def.kind === "field") descriptor = {
        configurable: true,
        writable: true,
        enumerable: true
    };
    var element = {
        kind: def.kind === "field" ? "field" : "method",
        key: key,
        placement: def["static"] ? "static" : def.kind === "field" ? "own" : "prototype",
        descriptor: descriptor
    };
    if (def.decorators) element.decorators = def.decorators;
    if (def.kind === "field") element.initializer = def.value;
    return element;
}
function $f469df7aad36f65d$var$_coalesceGetterSetter(element, other) {
    if (element.descriptor.get !== undefined) other.descriptor.get = element.descriptor.get;
    else other.descriptor.set = element.descriptor.set;
}
function $f469df7aad36f65d$var$_coalesceClassElements(elements) {
    var newElements = [];
    var isSameElement = function isSameElement(other) {
        return other.kind === "method" && other.key === element.key && other.placement === element.placement;
    };
    for(var i = 0; i < elements.length; i++){
        var element = elements[i];
        var other;
        if (element.kind === "method" && (other = newElements.find(isSameElement))) {
            if ($f469df7aad36f65d$var$_isDataDescriptor(element.descriptor) || $f469df7aad36f65d$var$_isDataDescriptor(other.descriptor)) {
                if ($f469df7aad36f65d$var$_hasDecorators(element) || $f469df7aad36f65d$var$_hasDecorators(other)) throw new ReferenceError("Duplicated methods (" + element.key + ") can't be decorated.");
                other.descriptor = element.descriptor;
            } else {
                if ($f469df7aad36f65d$var$_hasDecorators(element)) {
                    if ($f469df7aad36f65d$var$_hasDecorators(other)) throw new ReferenceError("Decorators can't be placed on different accessors with for the same property (" + element.key + ").");
                    other.decorators = element.decorators;
                }
                $f469df7aad36f65d$var$_coalesceGetterSetter(element, other);
            }
        } else newElements.push(element);
    }
    return newElements;
}
function $f469df7aad36f65d$var$_hasDecorators(element) {
    return element.decorators && element.decorators.length;
}
function $f469df7aad36f65d$var$_isDataDescriptor(desc) {
    return desc !== undefined && !(desc.value === undefined && desc.writable === undefined);
}
function $f469df7aad36f65d$var$_optionalCallableProperty(obj, name) {
    var value = obj[name];
    if (value !== undefined && typeof value !== "function") throw new TypeError("Expected '" + name + "' to be a function");
    return value;
}

});
parcelRegister("fBBPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5c7a7be32b70e10$export$2e2bcd8739ae039);

var $haEYn = parcelRequire("haEYn");

var $9GGCy = parcelRequire("9GGCy");

var $70VDg = parcelRequire("70VDg");

var $2uFiN = parcelRequire("2uFiN");
function $b5c7a7be32b70e10$export$2e2bcd8739ae039(arr) {
    return (0, $haEYn.default)(arr) || (0, $9GGCy.default)(arr) || (0, $70VDg.default)(arr) || (0, $2uFiN.default)();
}

});
parcelRegister("haEYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c803272f68e06096$export$2e2bcd8739ae039);
function $c803272f68e06096$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("9GGCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d918e769e2bf36$export$2e2bcd8739ae039);
function $70d918e769e2bf36$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("70VDg", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b53d1604ebae28$export$2e2bcd8739ae039);

var $6f0wz = parcelRequire("6f0wz");
function $51b53d1604ebae28$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6f0wz.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6f0wz.default)(o, minLen);
}

});
parcelRegister("6f0wz", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b48ce4f0da329e$export$2e2bcd8739ae039);
function $48b48ce4f0da329e$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("2uFiN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0e6bdaa7ccba5f$export$2e2bcd8739ae039);
function $1d0e6bdaa7ccba5f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("jpdgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20aa550f95fd45b$export$2e2bcd8739ae039);
/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Settings.
 * @exports CarbonComponents.settings
 * @type Object
 * @property {boolean} [disableAutoInit]
 *   Disables automatic instantiation of components.
 *   By default (`CarbonComponents.disableAutoInit` is `false`),
 *   carbon-components attempts to instantiate components automatically
 *   by searching for elements with `data-component-name` (e.g. `data-loading`) attribute
 *   or upon DOM events (e.g. clicking) on such elements.
 *   See each components' static `.init()` methods for details.
 * @property {string} [prefix=bx]
 *   Brand prefix. Should be in sync with `$prefix` Sass variable in carbon-components/src/globals/scss/_vars.scss.
 * // @todo given that the default value is so long, is it appropriate to put in the JSDoc?
 * @property {string} [selectorTabbable]
 *   A selector selecting tabbable/focusable nodes.
 *   By default selectorTabbable references links, areas, inputs, buttons, selects, textareas,
 *   iframes, objects, embeds, or elements explicitly using tabindex or contenteditable attributes
 *   as long as the element is not `disabled` or the `tabindex="-1"`.
 * @property {string} [selectorFocusable]
 *   CSS selector that selects major nodes that are click focusable
 *   This property is identical to selectorTabbable with the exception of
 *   the `:not([tabindex='-1'])` pseudo class
 */ var $e20aa550f95fd45b$var$settings = {
    prefix: 'bx',
    selectorTabbable: "\n    a[href], area[href], input:not([disabled]):not([tabindex='-1']),\n    button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),\n    textarea:not([disabled]):not([tabindex='-1']),\n    iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true]\n  ",
    selectorFocusable: "\n    a[href], area[href], input:not([disabled]),\n    button:not([disabled]),select:not([disabled]),\n    textarea:not([disabled]),\n    iframe, object, embed, *[tabindex], *[contenteditable=true]\n  "
};
var $e20aa550f95fd45b$export$2e2bcd8739ae039 = $e20aa550f95fd45b$var$settings;

});

parcelRegister("jd9RL", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $dfc6e273345d0e5d$export$56cc687933817664);
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ parcelRequire("3tvu5");
var $dxEOU = parcelRequire("dxEOU");
var $lcFGQ = parcelRequire("lcFGQ");
// IE11 doesn't support classList on SVG elements, so we emulate it with a Set
class $dfc6e273345d0e5d$var$ClassList {
    constructor(element){
        this.classes = new Set();
        this.changed = false;
        this.element = element;
        const classList = (element.getAttribute('class') || '').split(/\s+/);
        for (const cls of classList)this.classes.add(cls);
    }
    add(cls) {
        this.classes.add(cls);
        this.changed = true;
    }
    remove(cls) {
        this.classes.delete(cls);
        this.changed = true;
    }
    commit() {
        if (this.changed) {
            let classString = '';
            this.classes.forEach((cls)=>classString += cls + ' ');
            this.element.setAttribute('class', classString);
        }
    }
}
/**
 * Stores the ClassInfo object applied to a given AttributePart.
 * Used to unset existing values when a new ClassInfo object is applied.
 */ const $dfc6e273345d0e5d$var$previousClassesCache = new WeakMap();
const $dfc6e273345d0e5d$export$56cc687933817664 = (0, $lcFGQ.directive)((classInfo)=>(part)=>{
        if (!(part instanceof (0, $dxEOU.AttributePart)) || part instanceof (0, $dxEOU.PropertyPart) || part.committer.name !== 'class' || part.committer.parts.length > 1) throw new Error("The `classMap` directive must be used in the `class` attribute and must be the only part in the attribute.");
        const { committer: committer } = part;
        const { element: element } = committer;
        let previousClasses = $dfc6e273345d0e5d$var$previousClassesCache.get(part);
        if (previousClasses === undefined) {
            // Write static classes once
            // Use setAttribute() because className isn't a string on SVG elements
            element.setAttribute('class', committer.strings.join(' '));
            $dfc6e273345d0e5d$var$previousClassesCache.set(part, previousClasses = new Set());
        }
        const classList = element.classList || new $dfc6e273345d0e5d$var$ClassList(element);
        // Remove old classes that no longer apply
        // We use forEach() instead of for-of so that re don't require down-level
        // iteration.
        previousClasses.forEach((name)=>{
            if (!(name in classInfo)) {
                classList.remove(name);
                previousClasses.delete(name);
            }
        });
        // Add or remove classes based on their classMap value
        for(const name in classInfo){
            const value = classInfo[name];
            if (value != previousClasses.has(name)) {
                // We explicitly want a loose truthy check of `value` because it seems
                // more convenient that '' and 0 are skipped.
                if (value) {
                    classList.add(name);
                    previousClasses.add(name);
                } else {
                    classList.remove(name);
                    previousClasses.delete(name);
                }
            }
        }
        if (typeof classList.commit === 'function') classList.commit();
    });

});
parcelRegister("3tvu5", function(module, exports) {

$parcel$export(module.exports, "html", () => $287c80a8a61486b3$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $287c80a8a61486b3$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "directive", () => (parcelRequire("lcFGQ")).directive);
$parcel$export(module.exports, "AttributePart", () => (parcelRequire("dxEOU")).AttributePart);
$parcel$export(module.exports, "PropertyPart", () => (parcelRequire("dxEOU")).PropertyPart);
$parcel$export(module.exports, "render", () => (parcelRequire("ia8jV")).render);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 *
 * Main lit-html module.
 *
 * Main exports:
 *
 * -  [[html]]
 * -  [[svg]]
 * -  [[render]]
 *
 * @packageDocumentation
 */ /**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */ 
var $5TKEn = parcelRequire("5TKEn");

var $4itFU = parcelRequire("4itFU");

var $lcFGQ = parcelRequire("lcFGQ");

var $gn1Tq = parcelRequire("gn1Tq");

var $eeIHM = parcelRequire("eeIHM");

var $dxEOU = parcelRequire("dxEOU");

var $ia8jV = parcelRequire("ia8jV");

var $8t2wc = parcelRequire("8t2wc");

var $lNzE9 = parcelRequire("lNzE9");

var $dreIb = parcelRequire("dreIb");
// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for lit-html usage.
// TODO(justinfagnani): inject version number at build time
if (typeof window !== 'undefined') (window['litHtmlVersions'] || (window['litHtmlVersions'] = [])).push('1.4.1');
const $287c80a8a61486b3$export$c0bb0b647f701bb5 = (strings, ...values)=>new (0, $4itFU.TemplateResult)(strings, values, 'html', (0, $5TKEn.defaultTemplateProcessor));
const $287c80a8a61486b3$export$7ed1367e7fa1ad68 = (strings, ...values)=>new (0, $4itFU.SVGTemplateResult)(strings, values, 'svg', (0, $5TKEn.defaultTemplateProcessor));

});
parcelRegister("5TKEn", function(module, exports) {

$parcel$export(module.exports, "defaultTemplateProcessor", () => $44b646937e08f580$export$608256e8e6650f65);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $dxEOU = parcelRequire("dxEOU");
class $44b646937e08f580$export$53a556099f0fa088 {
    /**
     * Create parts for an attribute-position binding, given the event, attribute
     * name, and string literals.
     *
     * @param element The element containing the binding
     * @param name  The attribute name
     * @param strings The string literals. There are always at least two strings,
     *   event for fully-controlled bindings with a single expression.
     */ handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === '.') {
            const committer = new (0, $dxEOU.PropertyCommitter)(element, name.slice(1), strings);
            return committer.parts;
        }
        if (prefix === '@') return [
            new (0, $dxEOU.EventPart)(element, name.slice(1), options.eventContext)
        ];
        if (prefix === '?') return [
            new (0, $dxEOU.BooleanAttributePart)(element, name.slice(1), strings)
        ];
        const committer = new (0, $dxEOU.AttributeCommitter)(element, name, strings);
        return committer.parts;
    }
    /**
     * Create parts for a text-position binding.
     * @param templateFactory
     */ handleTextExpression(options) {
        return new (0, $dxEOU.NodePart)(options);
    }
}
const $44b646937e08f580$export$608256e8e6650f65 = new $44b646937e08f580$export$53a556099f0fa088();

});
parcelRegister("dxEOU", function(module, exports) {

$parcel$export(module.exports, "AttributeCommitter", () => $9dbe0579e01f377e$export$9ac9216e336e96d0);
$parcel$export(module.exports, "AttributePart", () => $9dbe0579e01f377e$export$da9b3ca39c846561);
$parcel$export(module.exports, "NodePart", () => $9dbe0579e01f377e$export$a354997aeda6e93);
$parcel$export(module.exports, "BooleanAttributePart", () => $9dbe0579e01f377e$export$b9df278b293d5b48);
$parcel$export(module.exports, "PropertyCommitter", () => $9dbe0579e01f377e$export$2d7935a96ad7cb22);
$parcel$export(module.exports, "PropertyPart", () => $9dbe0579e01f377e$export$b78f5e1c476c794e);
$parcel$export(module.exports, "EventPart", () => $9dbe0579e01f377e$export$b28e368652651bd7);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $lcFGQ = parcelRequire("lcFGQ");

var $gn1Tq = parcelRequire("gn1Tq");

var $eeIHM = parcelRequire("eeIHM");

var $lNzE9 = parcelRequire("lNzE9");

var $4itFU = parcelRequire("4itFU");

var $dreIb = parcelRequire("dreIb");
const $9dbe0579e01f377e$export$c3825b437cbdea5c = (value)=>{
    return value === null || !(typeof value === 'object' || typeof value === 'function');
};
const $9dbe0579e01f377e$export$9652023d9040757 = (value)=>{
    return Array.isArray(value) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !!(value && value[Symbol.iterator]);
};
class $9dbe0579e01f377e$export$9ac9216e336e96d0 {
    constructor(element, name, strings){
        this.dirty = true;
        this.element = element;
        this.name = name;
        this.strings = strings;
        this.parts = [];
        for(let i = 0; i < strings.length - 1; i++)this.parts[i] = this._createPart();
    }
    /**
     * Creates a single part. Override this to create a differnt type of part.
     */ _createPart() {
        return new $9dbe0579e01f377e$export$da9b3ca39c846561(this);
    }
    _getValue() {
        const strings = this.strings;
        const l = strings.length - 1;
        const parts = this.parts;
        // If we're assigning an attribute via syntax like:
        //    attr="${foo}"  or  attr=${foo}
        // but not
        //    attr="${foo} ${bar}" or attr="${foo} baz"
        // then we don't want to coerce the attribute value into one long
        // string. Instead we want to just return the value itself directly,
        // so that sanitizeDOMValue can get the actual value rather than
        // String(value)
        // The exception is if v is an array, in which case we do want to smash
        // it together into a string without calling String() on the array.
        //
        // This also allows trusted values (when using TrustedTypes) being
        // assigned to DOM sinks without being stringified in the process.
        if (l === 1 && strings[0] === '' && strings[1] === '') {
            const v = parts[0].value;
            if (typeof v === 'symbol') return String(v);
            if (typeof v === 'string' || !$9dbe0579e01f377e$export$9652023d9040757(v)) return v;
        }
        let text = '';
        for(let i = 0; i < l; i++){
            text += strings[i];
            const part = parts[i];
            if (part !== undefined) {
                const v = part.value;
                if ($9dbe0579e01f377e$export$c3825b437cbdea5c(v) || !$9dbe0579e01f377e$export$9652023d9040757(v)) text += typeof v === 'string' ? v : String(v);
                else for (const t of v)text += typeof t === 'string' ? t : String(t);
            }
        }
        text += strings[l];
        return text;
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            this.element.setAttribute(this.name, this._getValue());
        }
    }
}
class $9dbe0579e01f377e$export$da9b3ca39c846561 {
    constructor(committer){
        this.value = undefined;
        this.committer = committer;
    }
    setValue(value) {
        if (value !== (0, $eeIHM.noChange) && (!$9dbe0579e01f377e$export$c3825b437cbdea5c(value) || value !== this.value)) {
            this.value = value;
            // If the value is a not a directive, dirty the committer so that it'll
            // call setAttribute. If the value is a directive, it'll dirty the
            // committer if it calls setValue().
            if (!(0, $lcFGQ.isDirective)(value)) this.committer.dirty = true;
        }
    }
    commit() {
        while((0, $lcFGQ.isDirective)(this.value)){
            const directive = this.value;
            this.value = (0, $eeIHM.noChange);
            directive(this);
        }
        if (this.value === (0, $eeIHM.noChange)) return;
        this.committer.commit();
    }
}
class $9dbe0579e01f377e$export$a354997aeda6e93 {
    constructor(options){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.options = options;
    }
    /**
     * Appends this part into a container.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendInto(container) {
        this.startNode = container.appendChild((0, $dreIb.createMarker)());
        this.endNode = container.appendChild((0, $dreIb.createMarker)());
    }
    /**
     * Inserts this part after the `ref` node (between `ref` and `ref`'s next
     * sibling). Both `ref` and its next sibling must be static, unchanging nodes
     * such as those that appear in a literal section of a template.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterNode(ref) {
        this.startNode = ref;
        this.endNode = ref.nextSibling;
    }
    /**
     * Appends this part into a parent part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendIntoPart(part) {
        part.__insert(this.startNode = (0, $dreIb.createMarker)());
        part.__insert(this.endNode = (0, $dreIb.createMarker)());
    }
    /**
     * Inserts this part after the `ref` part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterPart(ref) {
        ref.__insert(this.startNode = (0, $dreIb.createMarker)());
        this.endNode = ref.endNode;
        ref.endNode = this.startNode;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        if (this.startNode.parentNode === null) return;
        while((0, $lcFGQ.isDirective)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $eeIHM.noChange);
            directive(this);
        }
        const value = this.__pendingValue;
        if (value === (0, $eeIHM.noChange)) return;
        if ($9dbe0579e01f377e$export$c3825b437cbdea5c(value)) {
            if (value !== this.value) this.__commitText(value);
        } else if (value instanceof (0, $4itFU.TemplateResult)) this.__commitTemplateResult(value);
        else if (value instanceof Node) this.__commitNode(value);
        else if ($9dbe0579e01f377e$export$9652023d9040757(value)) this.__commitIterable(value);
        else if (value === (0, $eeIHM.nothing)) {
            this.value = (0, $eeIHM.nothing);
            this.clear();
        } else // Fallback, will render the string representation
        this.__commitText(value);
    }
    __insert(node) {
        this.endNode.parentNode.insertBefore(node, this.endNode);
    }
    __commitNode(value) {
        if (this.value === value) return;
        this.clear();
        this.__insert(value);
        this.value = value;
    }
    __commitText(value) {
        const node = this.startNode.nextSibling;
        value = value == null ? '' : value;
        // If `value` isn't already a string, we explicitly convert it here in case
        // it can't be implicitly converted - i.e. it's a symbol.
        const valueAsString = typeof value === 'string' ? value : String(value);
        if (node === this.endNode.previousSibling && node.nodeType === 3 /* Node.TEXT_NODE */ ) // If we only have a single text node between the markers, we can just
        // set its value, rather than replacing it.
        // TODO(justinfagnani): Can we just check if this.value is primitive?
        node.data = valueAsString;
        else this.__commitNode(document.createTextNode(valueAsString));
        this.value = value;
    }
    __commitTemplateResult(value) {
        const template = this.options.templateFactory(value);
        if (this.value instanceof (0, $lNzE9.TemplateInstance) && this.value.template === template) this.value.update(value.values);
        else {
            // Make sure we propagate the template processor from the TemplateResult
            // so that we use its syntax extension, etc. The template factory comes
            // from the render function options so that it can control template
            // caching and preprocessing.
            const instance = new (0, $lNzE9.TemplateInstance)(template, value.processor, this.options);
            const fragment = instance._clone();
            instance.update(value.values);
            this.__commitNode(fragment);
            this.value = instance;
        }
    }
    __commitIterable(value) {
        // For an Iterable, we create a new InstancePart per item, then set its
        // value to the item. This is a little bit of overhead for every item in
        // an Iterable, but it lets us recurse easily and efficiently update Arrays
        // of TemplateResults that will be commonly returned from expressions like:
        // array.map((i) => html`${i}`), by reusing existing TemplateInstances.
        // If _value is an array, then the previous render was of an
        // iterable and _value will contain the NodeParts from the previous
        // render. If _value is not an array, clear this part and make a new
        // array for NodeParts.
        if (!Array.isArray(this.value)) {
            this.value = [];
            this.clear();
        }
        // Lets us keep track of how many items we stamped so we can clear leftover
        // items from a previous render
        const itemParts = this.value;
        let partIndex = 0;
        let itemPart;
        for (const item of value){
            // Try to reuse an existing part
            itemPart = itemParts[partIndex];
            // If no existing part, create a new one
            if (itemPart === undefined) {
                itemPart = new $9dbe0579e01f377e$export$a354997aeda6e93(this.options);
                itemParts.push(itemPart);
                if (partIndex === 0) itemPart.appendIntoPart(this);
                else itemPart.insertAfterPart(itemParts[partIndex - 1]);
            }
            itemPart.setValue(item);
            itemPart.commit();
            partIndex++;
        }
        if (partIndex < itemParts.length) {
            // Truncate the parts array so _value reflects the current state
            itemParts.length = partIndex;
            this.clear(itemPart && itemPart.endNode);
        }
    }
    clear(startNode = this.startNode) {
        (0, $gn1Tq.removeNodes)(this.startNode.parentNode, startNode.nextSibling, this.endNode);
    }
}
class $9dbe0579e01f377e$export$b9df278b293d5b48 {
    constructor(element, name, strings){
        this.value = undefined;
        this.__pendingValue = undefined;
        if (strings.length !== 2 || strings[0] !== '' || strings[1] !== '') throw new Error('Boolean attributes can only contain a single expression');
        this.element = element;
        this.name = name;
        this.strings = strings;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $lcFGQ.isDirective)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $eeIHM.noChange);
            directive(this);
        }
        if (this.__pendingValue === (0, $eeIHM.noChange)) return;
        const value = !!this.__pendingValue;
        if (this.value !== value) {
            if (value) this.element.setAttribute(this.name, '');
            else this.element.removeAttribute(this.name);
            this.value = value;
        }
        this.__pendingValue = (0, $eeIHM.noChange);
    }
}
class $9dbe0579e01f377e$export$2d7935a96ad7cb22 extends $9dbe0579e01f377e$export$9ac9216e336e96d0 {
    constructor(element, name, strings){
        super(element, name, strings);
        this.single = strings.length === 2 && strings[0] === '' && strings[1] === '';
    }
    _createPart() {
        return new $9dbe0579e01f377e$export$b78f5e1c476c794e(this);
    }
    _getValue() {
        if (this.single) return this.parts[0].value;
        return super._getValue();
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.element[this.name] = this._getValue();
        }
    }
}
class $9dbe0579e01f377e$export$b78f5e1c476c794e extends $9dbe0579e01f377e$export$da9b3ca39c846561 {
}
// Detect event listener options support. If the `capture` property is read
// from the options object, then options are supported. If not, then the third
// argument to add/removeEventListener is interpreted as the boolean capture
// value so we should only pass the `capture` property.
let $9dbe0579e01f377e$var$eventOptionsSupported = false;
// Wrap into an IIFE because MS Edge <= v41 does not support having try/catch
// blocks right into the body of a module
(()=>{
    try {
        const options = {
            get capture () {
                $9dbe0579e01f377e$var$eventOptionsSupported = true;
                return false;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.addEventListener('test', options, options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.removeEventListener('test', options, options);
    } catch (_e) {
    // event options not supported
    }
})();
class $9dbe0579e01f377e$export$b28e368652651bd7 {
    constructor(element, eventName, eventContext){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.element = element;
        this.eventName = eventName;
        this.eventContext = eventContext;
        this.__boundHandleEvent = (e)=>this.handleEvent(e);
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $lcFGQ.isDirective)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $eeIHM.noChange);
            directive(this);
        }
        if (this.__pendingValue === (0, $eeIHM.noChange)) return;
        const newListener = this.__pendingValue;
        const oldListener = this.value;
        const shouldRemoveListener = newListener == null || oldListener != null && (newListener.capture !== oldListener.capture || newListener.once !== oldListener.once || newListener.passive !== oldListener.passive);
        const shouldAddListener = newListener != null && (oldListener == null || shouldRemoveListener);
        if (shouldRemoveListener) this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        if (shouldAddListener) {
            this.__options = $9dbe0579e01f377e$var$getOptions(newListener);
            this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        this.value = newListener;
        this.__pendingValue = (0, $eeIHM.noChange);
    }
    handleEvent(event) {
        if (typeof this.value === 'function') this.value.call(this.eventContext || this.element, event);
        else this.value.handleEvent(event);
    }
}
// We copy options because of the inconsistent behavior of browsers when reading
// the third argument of add/removeEventListener. IE11 doesn't support options
// at all. Chrome 41 only reads `capture` if the argument is an object.
const $9dbe0579e01f377e$var$getOptions = (o)=>o && ($9dbe0579e01f377e$var$eventOptionsSupported ? {
        capture: o.capture,
        passive: o.passive,
        once: o.once
    } : o.capture);

});
parcelRegister("lcFGQ", function(module, exports) {

$parcel$export(module.exports, "directive", () => $f6fb0ebba5dd98a0$export$99b43ad1ed32e735);
$parcel$export(module.exports, "isDirective", () => $f6fb0ebba5dd98a0$export$4b5d79f26e0e3ad5);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ const $f6fb0ebba5dd98a0$var$directives = new WeakMap();
const $f6fb0ebba5dd98a0$export$99b43ad1ed32e735 = (f)=>(...args)=>{
        const d = f(...args);
        $f6fb0ebba5dd98a0$var$directives.set(d, true);
        return d;
    };
const $f6fb0ebba5dd98a0$export$4b5d79f26e0e3ad5 = (o)=>{
    return typeof o === 'function' && $f6fb0ebba5dd98a0$var$directives.has(o);
};

});

parcelRegister("gn1Tq", function(module, exports) {

$parcel$export(module.exports, "isCEPolyfill", () => $beb0433591ff518d$export$52a61c3a7415f2b1);
$parcel$export(module.exports, "reparentNodes", () => $beb0433591ff518d$export$4cae3494608af418);
$parcel$export(module.exports, "removeNodes", () => $beb0433591ff518d$export$77f49a256021c8de);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * True if the custom elements polyfill is in use.
 */ const $beb0433591ff518d$export$52a61c3a7415f2b1 = typeof window !== 'undefined' && window.customElements != null && window.customElements.polyfillWrapFlushCallback !== undefined;
const $beb0433591ff518d$export$4cae3494608af418 = (container, start, end = null, before = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.insertBefore(start, before);
        start = n;
    }
};
const $beb0433591ff518d$export$77f49a256021c8de = (container, start, end = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.removeChild(start);
        start = n;
    }
};

});

parcelRegister("eeIHM", function(module, exports) {

$parcel$export(module.exports, "noChange", () => $a5d50d058050f25d$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $a5d50d058050f25d$export$45b790e32b2810ee);
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * A sentinel value that signals that a value was handled by a directive and
 * should not be written to the DOM.
 */ const $a5d50d058050f25d$export$9c068ae9cc5db4e8 = {};
const $a5d50d058050f25d$export$45b790e32b2810ee = {};

});

parcelRegister("lNzE9", function(module, exports) {

$parcel$export(module.exports, "TemplateInstance", () => $fde9d345055cf828$export$6eecef7813f38266);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $gn1Tq = parcelRequire("gn1Tq");

var $dreIb = parcelRequire("dreIb");
class $fde9d345055cf828$export$6eecef7813f38266 {
    constructor(template, processor, options){
        this.__parts = [];
        this.template = template;
        this.processor = processor;
        this.options = options;
    }
    update(values) {
        let i = 0;
        for (const part of this.__parts){
            if (part !== undefined) part.setValue(values[i]);
            i++;
        }
        for (const part of this.__parts)if (part !== undefined) part.commit();
    }
    _clone() {
        // There are a number of steps in the lifecycle of a template instance's
        // DOM fragment:
        //  1. Clone - create the instance fragment
        //  2. Adopt - adopt into the main document
        //  3. Process - find part markers and create parts
        //  4. Upgrade - upgrade custom elements
        //  5. Update - set node, attribute, property, etc., values
        //  6. Connect - connect to the document. Optional and outside of this
        //     method.
        //
        // We have a few constraints on the ordering of these steps:
        //  * We need to upgrade before updating, so that property values will pass
        //    through any property setters.
        //  * We would like to process before upgrading so that we're sure that the
        //    cloned fragment is inert and not disturbed by self-modifying DOM.
        //  * We want custom elements to upgrade even in disconnected fragments.
        //
        // Given these constraints, with full custom elements support we would
        // prefer the order: Clone, Process, Adopt, Upgrade, Update, Connect
        //
        // But Safari does not implement CustomElementRegistry#upgrade, so we
        // can not implement that order and still have upgrade-before-update and
        // upgrade disconnected fragments. So we instead sacrifice the
        // process-before-upgrade constraint, since in Custom Elements v1 elements
        // must not modify their light DOM in the constructor. We still have issues
        // when co-existing with CEv0 elements like Polymer 1, and with polyfills
        // that don't strictly adhere to the no-modification rule because shadow
        // DOM, which may be created in the constructor, is emulated by being placed
        // in the light DOM.
        //
        // The resulting order is on native is: Clone, Adopt, Upgrade, Process,
        // Update, Connect. document.importNode() performs Clone, Adopt, and Upgrade
        // in one step.
        //
        // The Custom Elements v1 polyfill supports upgrade(), so the order when
        // polyfilled is the more ideal: Clone, Process, Adopt, Upgrade, Update,
        // Connect.
        const fragment = (0, $gn1Tq.isCEPolyfill) ? this.template.element.content.cloneNode(true) : document.importNode(this.template.element.content, true);
        const stack = [];
        const parts = this.template.parts;
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(fragment, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        let partIndex = 0;
        let nodeIndex = 0;
        let part;
        let node = walker.nextNode();
        // Loop through all the nodes and parts of a template
        while(partIndex < parts.length){
            part = parts[partIndex];
            if (!(0, $dreIb.isTemplatePartActive)(part)) {
                this.__parts.push(undefined);
                partIndex++;
                continue;
            }
            // Progress the tree walker until we find our next part's node.
            // Note that multiple parts may share the same node (attribute parts
            // on a single element), so this loop may not run at all.
            while(nodeIndex < part.index){
                nodeIndex++;
                if (node.nodeName === 'TEMPLATE') {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
                if ((node = walker.nextNode()) === null) {
                    // We've exhausted the content inside a nested template element.
                    // Because we still have parts (the outer for-loop), we know:
                    // - There is a template in the stack
                    // - The walker will find a nextNode outside the template
                    walker.currentNode = stack.pop();
                    node = walker.nextNode();
                }
            }
            // We've arrived at our part's node.
            if (part.type === 'node') {
                const part = this.processor.handleTextExpression(this.options);
                part.insertAfterNode(node.previousSibling);
                this.__parts.push(part);
            } else this.__parts.push(...this.processor.handleAttributeExpressions(node, part.name, part.strings, this.options));
            partIndex++;
        }
        if (0, $gn1Tq.isCEPolyfill) {
            document.adoptNode(fragment);
            customElements.upgrade(fragment);
        }
        return fragment;
    }
}

});
parcelRegister("dreIb", function(module, exports) {

$parcel$export(module.exports, "marker", () => $9c89356cfc323e11$export$ffc4d0086f1a4c9);
$parcel$export(module.exports, "nodeMarker", () => $9c89356cfc323e11$export$36b8314a2f34ed60);
$parcel$export(module.exports, "boundAttributeSuffix", () => $9c89356cfc323e11$export$552ff45b274cc170);
$parcel$export(module.exports, "Template", () => $9c89356cfc323e11$export$14416b8d99d47caa);
$parcel$export(module.exports, "lastAttributeNameRegex", () => $9c89356cfc323e11$export$a5d53adfffe6a300);
$parcel$export(module.exports, "createMarker", () => $9c89356cfc323e11$export$46b32044f78fe9b1);
$parcel$export(module.exports, "isTemplatePartActive", () => $9c89356cfc323e11$export$93919229d19012c8);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * An expression marker with embedded unique key to avoid collision with
 * possible text in templates.
 */ const $9c89356cfc323e11$export$ffc4d0086f1a4c9 = `{{lit-${String(Math.random()).slice(2)}}}`;
const $9c89356cfc323e11$export$36b8314a2f34ed60 = `<!--${$9c89356cfc323e11$export$ffc4d0086f1a4c9}-->`;
const $9c89356cfc323e11$export$8c751b9db6965af4 = new RegExp(`${$9c89356cfc323e11$export$ffc4d0086f1a4c9}|${$9c89356cfc323e11$export$36b8314a2f34ed60}`);
const $9c89356cfc323e11$export$552ff45b274cc170 = '$lit$';
class $9c89356cfc323e11$export$14416b8d99d47caa {
    constructor(result, element){
        this.parts = [];
        this.element = element;
        const nodesToRemove = [];
        const stack = [];
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(element.content, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        // Keeps track of the last index associated with a part. We try to delete
        // unnecessary nodes, but we never want to associate two different parts
        // to the same index. They must have a constant node between.
        let lastPartIndex = 0;
        let index = -1;
        let partIndex = 0;
        const { strings: strings, values: { length: length } } = result;
        while(partIndex < length){
            const node = walker.nextNode();
            if (node === null) {
                // We've exhausted the content inside a nested template element.
                // Because we still have parts (the outer for-loop), we know:
                // - There is a template in the stack
                // - The walker will find a nextNode outside the template
                walker.currentNode = stack.pop();
                continue;
            }
            index++;
            if (node.nodeType === 1 /* Node.ELEMENT_NODE */ ) {
                if (node.hasAttributes()) {
                    const attributes = node.attributes;
                    const { length: length } = attributes;
                    // Per
                    // https://developer.mozilla.org/en-US/docs/Web/API/NamedNodeMap,
                    // attributes are not guaranteed to be returned in document order.
                    // In particular, Edge/IE can return them out of order, so we cannot
                    // assume a correspondence between part index and attribute index.
                    let count = 0;
                    for(let i = 0; i < length; i++)if ($9c89356cfc323e11$var$endsWith(attributes[i].name, $9c89356cfc323e11$export$552ff45b274cc170)) count++;
                    while(count-- > 0){
                        // Get the template literal section leading up to the first
                        // expression in this attribute
                        const stringForPart = strings[partIndex];
                        // Find the attribute name
                        const name = $9c89356cfc323e11$export$a5d53adfffe6a300.exec(stringForPart)[2];
                        // Find the corresponding attribute
                        // All bound attributes have had a suffix added in
                        // TemplateResult#getHTML to opt out of special attribute
                        // handling. To look up the attribute value we also need to add
                        // the suffix.
                        const attributeLookupName = name.toLowerCase() + $9c89356cfc323e11$export$552ff45b274cc170;
                        const attributeValue = node.getAttribute(attributeLookupName);
                        node.removeAttribute(attributeLookupName);
                        const statics = attributeValue.split($9c89356cfc323e11$export$8c751b9db6965af4);
                        this.parts.push({
                            type: 'attribute',
                            index: index,
                            name: name,
                            strings: statics
                        });
                        partIndex += statics.length - 1;
                    }
                }
                if (node.tagName === 'TEMPLATE') {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
            } else if (node.nodeType === 3 /* Node.TEXT_NODE */ ) {
                const data = node.data;
                if (data.indexOf($9c89356cfc323e11$export$ffc4d0086f1a4c9) >= 0) {
                    const parent = node.parentNode;
                    const strings = data.split($9c89356cfc323e11$export$8c751b9db6965af4);
                    const lastIndex = strings.length - 1;
                    // Generate a new text node for each literal section
                    // These nodes are also used as the markers for node parts
                    for(let i = 0; i < lastIndex; i++){
                        let insert;
                        let s = strings[i];
                        if (s === '') insert = $9c89356cfc323e11$export$46b32044f78fe9b1();
                        else {
                            const match = $9c89356cfc323e11$export$a5d53adfffe6a300.exec(s);
                            if (match !== null && $9c89356cfc323e11$var$endsWith(match[2], $9c89356cfc323e11$export$552ff45b274cc170)) s = s.slice(0, match.index) + match[1] + match[2].slice(0, -$9c89356cfc323e11$export$552ff45b274cc170.length) + match[3];
                            insert = document.createTextNode(s);
                        }
                        parent.insertBefore(insert, node);
                        this.parts.push({
                            type: 'node',
                            index: ++index
                        });
                    }
                    // If there's no text, we must insert a comment to mark our place.
                    // Else, we can trust it will stick around after cloning.
                    if (strings[lastIndex] === '') {
                        parent.insertBefore($9c89356cfc323e11$export$46b32044f78fe9b1(), node);
                        nodesToRemove.push(node);
                    } else node.data = strings[lastIndex];
                    // We have a part for each match found
                    partIndex += lastIndex;
                }
            } else if (node.nodeType === 8 /* Node.COMMENT_NODE */ ) {
                if (node.data === $9c89356cfc323e11$export$ffc4d0086f1a4c9) {
                    const parent = node.parentNode;
                    // Add a new marker node to be the startNode of the Part if any of
                    // the following are true:
                    //  * We don't have a previousSibling
                    //  * The previousSibling is already the start of a previous part
                    if (node.previousSibling === null || index === lastPartIndex) {
                        index++;
                        parent.insertBefore($9c89356cfc323e11$export$46b32044f78fe9b1(), node);
                    }
                    lastPartIndex = index;
                    this.parts.push({
                        type: 'node',
                        index: index
                    });
                    // If we don't have a nextSibling, keep this node so we have an end.
                    // Else, we can remove it to save future costs.
                    if (node.nextSibling === null) node.data = '';
                    else {
                        nodesToRemove.push(node);
                        index--;
                    }
                    partIndex++;
                } else {
                    let i = -1;
                    while((i = node.data.indexOf($9c89356cfc323e11$export$ffc4d0086f1a4c9, i + 1)) !== -1){
                        // Comment node has a binding marker inside, make an inactive part
                        // The binding won't work, but subsequent bindings will
                        // TODO (justinfagnani): consider whether it's even worth it to
                        // make bindings in comments work
                        this.parts.push({
                            type: 'node',
                            index: -1
                        });
                        partIndex++;
                    }
                }
            }
        }
        // Remove text binding nodes after the walk to not disturb the TreeWalker
        for (const n of nodesToRemove)n.parentNode.removeChild(n);
    }
}
const $9c89356cfc323e11$var$endsWith = (str, suffix)=>{
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
};
const $9c89356cfc323e11$export$93919229d19012c8 = (part)=>part.index !== -1;
const $9c89356cfc323e11$export$46b32044f78fe9b1 = ()=>document.createComment('');
const $9c89356cfc323e11$export$a5d53adfffe6a300 = // eslint-disable-next-line no-control-regex
/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;

});


parcelRegister("4itFU", function(module, exports) {

$parcel$export(module.exports, "TemplateResult", () => $320fdcb2a215bf6f$export$ce95ebd39b69fb27);
$parcel$export(module.exports, "SVGTemplateResult", () => $320fdcb2a215bf6f$export$36e852975bbbeae0);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @module lit-html
 */ 
var $gn1Tq = parcelRequire("gn1Tq");

var $dreIb = parcelRequire("dreIb");
/**
 * Our TrustedTypePolicy for HTML which is declared using the html template
 * tag function.
 *
 * That HTML is a developer-authored constant, and is parsed with innerHTML
 * before any untrusted expressions have been mixed in. Therefor it is
 * considered safe by construction.
 */ const $320fdcb2a215bf6f$var$policy = window.trustedTypes && trustedTypes.createPolicy('lit-html', {
    createHTML: (s)=>s
});
const $320fdcb2a215bf6f$var$commentMarker = ` ${(0, $dreIb.marker)} `;
class $320fdcb2a215bf6f$export$ce95ebd39b69fb27 {
    constructor(strings, values, type, processor){
        this.strings = strings;
        this.values = values;
        this.type = type;
        this.processor = processor;
    }
    /**
     * Returns a string of HTML used to create a `<template>` element.
     */ getHTML() {
        const l = this.strings.length - 1;
        let html = '';
        let isCommentBinding = false;
        for(let i = 0; i < l; i++){
            const s = this.strings[i];
            // For each binding we want to determine the kind of marker to insert
            // into the template source before it's parsed by the browser's HTML
            // parser. The marker type is based on whether the expression is in an
            // attribute, text, or comment position.
            //   * For node-position bindings we insert a comment with the marker
            //     sentinel as its text content, like <!--{{lit-guid}}-->.
            //   * For attribute bindings we insert just the marker sentinel for the
            //     first binding, so that we support unquoted attribute bindings.
            //     Subsequent bindings can use a comment marker because multi-binding
            //     attributes must be quoted.
            //   * For comment bindings we insert just the marker sentinel so we don't
            //     close the comment.
            //
            // The following code scans the template source, but is *not* an HTML
            // parser. We don't need to track the tree structure of the HTML, only
            // whether a binding is inside a comment, and if not, if it appears to be
            // the first binding in an attribute.
            const commentOpen = s.lastIndexOf('<!--');
            // We're in comment position if we have a comment open with no following
            // comment close. Because <-- can appear in an attribute value there can
            // be false positives.
            isCommentBinding = (commentOpen > -1 || isCommentBinding) && s.indexOf('-->', commentOpen + 1) === -1;
            // Check to see if we have an attribute-like sequence preceding the
            // expression. This can match "name=value" like structures in text,
            // comments, and attribute values, so there can be false-positives.
            const attributeMatch = (0, $dreIb.lastAttributeNameRegex).exec(s);
            if (attributeMatch === null) // We're only in this branch if we don't have a attribute-like
            // preceding sequence. For comments, this guards against unusual
            // attribute values like <div foo="<!--${'bar'}">. Cases like
            // <!-- foo=${'bar'}--> are handled correctly in the attribute branch
            // below.
            html += s + (isCommentBinding ? $320fdcb2a215bf6f$var$commentMarker : (0, $dreIb.nodeMarker));
            else // For attributes we use just a marker sentinel, and also append a
            // $lit$ suffix to the name to opt-out of attribute-specific parsing
            // that IE and Edge do for style and certain SVG attributes.
            html += s.substr(0, attributeMatch.index) + attributeMatch[1] + attributeMatch[2] + (0, $dreIb.boundAttributeSuffix) + attributeMatch[3] + (0, $dreIb.marker);
        }
        html += this.strings[l];
        return html;
    }
    getTemplateElement() {
        const template = document.createElement('template');
        let value = this.getHTML();
        if ($320fdcb2a215bf6f$var$policy !== undefined) // this is secure because `this.strings` is a TemplateStringsArray.
        // TODO: validate this when
        // https://github.com/tc39/proposal-array-is-template-object is
        // implemented.
        value = $320fdcb2a215bf6f$var$policy.createHTML(value);
        template.innerHTML = value;
        return template;
    }
}
class $320fdcb2a215bf6f$export$36e852975bbbeae0 extends $320fdcb2a215bf6f$export$ce95ebd39b69fb27 {
    getHTML() {
        return `<svg>${super.getHTML()}</svg>`;
    }
    getTemplateElement() {
        const template = super.getTemplateElement();
        const content = template.content;
        const svgElement = content.firstChild;
        content.removeChild(svgElement);
        (0, $gn1Tq.reparentNodes)(content, svgElement.firstChild);
        return template;
    }
}

});



parcelRegister("ia8jV", function(module, exports) {

$parcel$export(module.exports, "parts", () => $d38f9d6f04a94185$export$6e2410c1d27f06e7);
$parcel$export(module.exports, "render", () => $d38f9d6f04a94185$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $gn1Tq = parcelRequire("gn1Tq");

var $dxEOU = parcelRequire("dxEOU");

var $8t2wc = parcelRequire("8t2wc");
const $d38f9d6f04a94185$export$6e2410c1d27f06e7 = new WeakMap();
const $d38f9d6f04a94185$export$b3890eb0ae9dca99 = (result, container, options)=>{
    let part = $d38f9d6f04a94185$export$6e2410c1d27f06e7.get(container);
    if (part === undefined) {
        (0, $gn1Tq.removeNodes)(container, container.firstChild);
        $d38f9d6f04a94185$export$6e2410c1d27f06e7.set(container, part = new (0, $dxEOU.NodePart)(Object.assign({
            templateFactory: $8t2wc.templateFactory
        }, options)));
        part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
};

});
parcelRegister("8t2wc", function(module, exports) {

$parcel$export(module.exports, "templateFactory", () => $62a2fc44bfa142c0$export$ac8809ff023de002);
$parcel$export(module.exports, "templateCaches", () => $62a2fc44bfa142c0$export$f4a9a5e9f571ddee);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $dreIb = parcelRequire("dreIb");
function $62a2fc44bfa142c0$export$ac8809ff023de002(result) {
    let templateCache = $62a2fc44bfa142c0$export$f4a9a5e9f571ddee.get(result.type);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        $62a2fc44bfa142c0$export$f4a9a5e9f571ddee.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) return template;
    // If the TemplateStringsArray is new, generate a key from the strings
    // This key is shared between all templates with identical content
    const key = result.strings.join((0, $dreIb.marker));
    // Check if we already have a Template for this key
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        // If we have not seen this key before, create a new Template
        template = new (0, $dreIb.Template)(result, result.getTemplateElement());
        // Cache the Template for this key
        templateCache.keyString.set(key, template);
    }
    // Cache all future queries for this TemplateStringsArray
    templateCache.stringsArray.set(result.strings, template);
    return template;
}
const $62a2fc44bfa142c0$export$f4a9a5e9f571ddee = new Map();

});




parcelRegister("gg2C2", function(module, exports) {

$parcel$export(module.exports, "ifDefined", () => $bd602abcdd78f028$export$f68dd208b5df064d);
/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ parcelRequire("3tvu5");
var $dxEOU = parcelRequire("dxEOU");
var $lcFGQ = parcelRequire("lcFGQ");
const $bd602abcdd78f028$var$previousValues = new WeakMap();
const $bd602abcdd78f028$export$f68dd208b5df064d = (0, $lcFGQ.directive)((value)=>(part)=>{
        const previousValue = $bd602abcdd78f028$var$previousValues.get(part);
        if (value === undefined && part instanceof (0, $dxEOU.AttributePart)) // If the value is undefined, remove the attribute, but only if the value
        // was previously defined.
        {
            if (previousValue !== undefined || !$bd602abcdd78f028$var$previousValues.has(part)) {
                const name = part.committer.name;
                part.committer.element.removeAttribute(name);
            }
        } else if (value !== previousValue) part.setValue(value);
        $bd602abcdd78f028$var$previousValues.set(part, value);
    });

});

parcelRegister("3eEWe", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("2pFDC")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("2pFDC")).property);
$parcel$export(module.exports, "query", () => (parcelRequire("2pFDC")).query);
$parcel$export(module.exports, "css", () => (parcelRequire("cH4lK")).css);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("cH4lK")).supportsAdoptingStyleSheets);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("cH4lK")).unsafeCSS);

$parcel$export(module.exports, "LitElement", () => $25b26f611b35fcca$export$3f2f9f5909897157);
$parcel$export(module.exports, "html", () => (parcelRequire("3tvu5")).html);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * The main LitElement module, which defines the [[`LitElement`]] base class and
 * related APIs.
 *
 *  LitElement components can define a template and a set of observed
 * properties. Changing an observed property triggers a re-render of the
 * element.
 *
 *  Import [[`LitElement`]] and [[`html`]] from this module to create a
 * component:
 *
 *  ```js
 * import {LitElement, html} from 'lit-element';
 *
 * class MyElement extends LitElement {
 *
 *   // Declare observed properties
 *   static get properties() {
 *     return {
 *       adjective: {}
 *     }
 *   }
 *
 *   constructor() {
 *     this.adjective = 'awesome';
 *   }
 *
 *   // Define the element's template
 *   render() {
 *     return html`<p>your ${adjective} template here</p>`;
 *   }
 * }
 *
 * customElements.define('my-element', MyElement);
 * ```
 *
 * `LitElement` extends [[`UpdatingElement`]] and adds lit-html templating.
 * The `UpdatingElement` class is provided for users that want to build
 * their own custom element base classes that don't use lit-html.
 *
 * @packageDocumentation
 */ 
var $aplBo = parcelRequire("aplBo");

var $kj043 = parcelRequire("kj043");
parcelRequire("2pFDC");

var $3tvu5 = parcelRequire("3tvu5");

var $cH4lK = parcelRequire("cH4lK");
// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for LitElement usage.
// TODO(justinfagnani): inject version number at build time
(window['litElementVersions'] || (window['litElementVersions'] = [])).push('2.5.1');
/**
 * Sentinal value used to avoid calling lit-html's render function when
 * subclasses do not implement `render`
 */ const $25b26f611b35fcca$var$renderNotImplemented = {};
class $25b26f611b35fcca$export$3f2f9f5909897157 extends (0, $kj043.UpdatingElement) {
    /**
     * Return the array of styles to apply to the element.
     * Override this method to integrate into a style management system.
     *
     * @nocollapse
     */ static getStyles() {
        return this.styles;
    }
    /** @nocollapse */ static _getUniqueStyles() {
        // Only gather styles once per class
        if (this.hasOwnProperty(JSCompiler_renameProperty('_styles', this))) return;
        // Take care not to call `this.getStyles()` multiple times since this
        // generates new CSSResults each time.
        // TODO(sorvell): Since we do not cache CSSResults by input, any
        // shared styles will generate new stylesheet objects, which is wasteful.
        // This should be addressed when a browser ships constructable
        // stylesheets.
        const userStyles = this.getStyles();
        if (Array.isArray(userStyles)) {
            // De-duplicate styles preserving the _last_ instance in the set.
            // This is a performance optimization to avoid duplicated styles that can
            // occur especially when composing via subclassing.
            // The last item is kept to try to preserve the cascade order with the
            // assumption that it's most important that last added styles override
            // previous styles.
            const addStyles = (styles, set)=>styles.reduceRight((set, s)=>// Note: On IE set.add() does not return the set
                    Array.isArray(s) ? addStyles(s, set) : (set.add(s), set), set);
            // Array.from does not work on Set in IE, otherwise return
            // Array.from(addStyles(userStyles, new Set<CSSResult>())).reverse()
            const set = addStyles(userStyles, new Set());
            const styles = [];
            set.forEach((v)=>styles.unshift(v));
            this._styles = styles;
        } else this._styles = userStyles === undefined ? [] : [
            userStyles
        ];
        // Ensure that there are no invalid CSSStyleSheet instances here. They are
        // invalid in two conditions.
        // (1) the sheet is non-constructible (`sheet` of a HTMLStyleElement), but
        //     this is impossible to check except via .replaceSync or use
        // (2) the ShadyCSS polyfill is enabled (:. supportsAdoptingStyleSheets is
        //     false)
        this._styles = this._styles.map((s)=>{
            if (s instanceof CSSStyleSheet && !(0, $cH4lK.supportsAdoptingStyleSheets)) {
                // Flatten the cssText from the passed constructible stylesheet (or
                // undetectable non-constructible stylesheet). The user might have
                // expected to update their stylesheets over time, but the alternative
                // is a crash.
                const cssText = Array.prototype.slice.call(s.cssRules).reduce((css, rule)=>css + rule.cssText, '');
                return (0, $cH4lK.unsafeCSS)(cssText);
            }
            return s;
        });
    }
    /**
     * Performs element initialization. By default this calls
     * [[`createRenderRoot`]] to create the element [[`renderRoot`]] node and
     * captures any pre-set values for registered properties.
     */ initialize() {
        super.initialize();
        this.constructor._getUniqueStyles();
        this.renderRoot = this.createRenderRoot();
        // Note, if renderRoot is not a shadowRoot, styles would/could apply to the
        // element's getRootNode(). While this could be done, we're choosing not to
        // support this now since it would require different logic around de-duping.
        if (window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot) this.adoptStyles();
    }
    /**
     * Returns the node into which the element should render and by default
     * creates and returns an open shadowRoot. Implement to customize where the
     * element's DOM is rendered. For example, to render into the element's
     * childNodes, return `this`.
     * @returns {Element|DocumentFragment} Returns a node into which to render.
     */ createRenderRoot() {
        return this.attachShadow(this.constructor.shadowRootOptions);
    }
    /**
     * Applies styling to the element shadowRoot using the [[`styles`]]
     * property. Styling will apply using `shadowRoot.adoptedStyleSheets` where
     * available and will fallback otherwise. When Shadow DOM is polyfilled,
     * ShadyCSS scopes styles and adds them to the document. When Shadow DOM
     * is available but `adoptedStyleSheets` is not, styles are appended to the
     * end of the `shadowRoot` to [mimic spec
     * behavior](https://wicg.github.io/construct-stylesheets/#using-constructed-stylesheets).
     */ adoptStyles() {
        const styles = this.constructor._styles;
        if (styles.length === 0) return;
        // There are three separate cases here based on Shadow DOM support.
        // (1) shadowRoot polyfilled: use ShadyCSS
        // (2) shadowRoot.adoptedStyleSheets available: use it
        // (3) shadowRoot.adoptedStyleSheets polyfilled: append styles after
        // rendering
        if (window.ShadyCSS !== undefined && !window.ShadyCSS.nativeShadow) window.ShadyCSS.ScopingShim.prepareAdoptedCssText(styles.map((s)=>s.cssText), this.localName);
        else if (0, $cH4lK.supportsAdoptingStyleSheets) this.renderRoot.adoptedStyleSheets = styles.map((s)=>s instanceof CSSStyleSheet ? s : s.styleSheet);
        else // This must be done after rendering so the actual style insertion is done
        // in `update`.
        this._needsShimAdoptedStyleSheets = true;
    }
    connectedCallback() {
        super.connectedCallback();
        // Note, first update/render handles styleElement so we only call this if
        // connected after first update.
        if (this.hasUpdated && window.ShadyCSS !== undefined) window.ShadyCSS.styleElement(this);
    }
    /**
     * Updates the element. This method reflects property values to attributes
     * and calls `render` to render DOM via lit-html. Setting properties inside
     * this method will *not* trigger another update.
     * @param _changedProperties Map of changed properties with old values
     */ update(changedProperties) {
        // Setting properties in `render` should not trigger an update. Since
        // updates are allowed after super.update, it's important to call `render`
        // before that.
        const templateResult = this.render();
        super.update(changedProperties);
        // If render is not implemented by the component, don't call lit-html render
        if (templateResult !== $25b26f611b35fcca$var$renderNotImplemented) this.constructor.render(templateResult, this.renderRoot, {
            scopeName: this.localName,
            eventContext: this
        });
        // When native Shadow DOM is used but adoptedStyles are not supported,
        // insert styling after rendering to ensure adoptedStyles have highest
        // priority.
        if (this._needsShimAdoptedStyleSheets) {
            this._needsShimAdoptedStyleSheets = false;
            this.constructor._styles.forEach((s)=>{
                const style = document.createElement('style');
                style.textContent = s.cssText;
                this.renderRoot.appendChild(style);
            });
        }
    }
    /**
     * Invoked on each update to perform rendering tasks. This method may return
     * any value renderable by lit-html's `NodePart` - typically a
     * `TemplateResult`. Setting properties inside this method will *not* trigger
     * the element to update.
     */ render() {
        return $25b26f611b35fcca$var$renderNotImplemented;
    }
}
/**
 * Ensure this class is marked as `finalized` as an optimization ensuring
 * it will not needlessly try to `finalize`.
 *
 * Note this property name is a string to prevent breaking Closure JS Compiler
 * optimizations. See updating-element.ts for more information.
 */ $25b26f611b35fcca$export$3f2f9f5909897157['finalized'] = true;
/**
 * Reference to the underlying library method used to render the element's
 * DOM. By default, points to the `render` method from lit-html's shady-render
 * module.
 *
 * **Most users will never need to touch this property.**
 *
 * This  property should not be confused with the `render` instance method,
 * which should be overridden to define a template for the element.
 *
 * Advanced users creating a new base class based on LitElement can override
 * this property to point to a custom render method with a signature that
 * matches [shady-render's `render`
 * method](https://lit-html.polymer-project.org/api/modules/shady_render.html#render).
 *
 * @nocollapse
 */ $25b26f611b35fcca$export$3f2f9f5909897157.render = (0, $aplBo.render);
/** @nocollapse */ $25b26f611b35fcca$export$3f2f9f5909897157.shadowRootOptions = {
    mode: 'open'
};

});
parcelRegister("aplBo", function(module, exports) {

$parcel$export(module.exports, "render", () => $793cfeedb16e67e7$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * Module to add shady DOM/shady CSS polyfill support to lit-html template
 * rendering. See the [[render]] method for details.
 *
 * @packageDocumentation
 */ /**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */ 
var $gn1Tq = parcelRequire("gn1Tq");

var $doIsc = parcelRequire("doIsc");

var $ia8jV = parcelRequire("ia8jV");

var $8t2wc = parcelRequire("8t2wc");

var $lNzE9 = parcelRequire("lNzE9");

var $dreIb = parcelRequire("dreIb");

var $3tvu5 = parcelRequire("3tvu5");
var $4itFU = parcelRequire("4itFU");
// Get a key to lookup in `templateCaches`.
const $793cfeedb16e67e7$var$getTemplateCacheKey = (type, scopeName)=>`${type}--${scopeName}`;
let $793cfeedb16e67e7$var$compatibleShadyCSSVersion = true;
if (typeof window.ShadyCSS === 'undefined') $793cfeedb16e67e7$var$compatibleShadyCSSVersion = false;
else if (typeof window.ShadyCSS.prepareTemplateDom === 'undefined') {
    console.warn(`Incompatible ShadyCSS version detected. ` + `Please update to at least @webcomponents/webcomponentsjs@2.0.2 and ` + `@webcomponents/shadycss@1.3.1.`);
    $793cfeedb16e67e7$var$compatibleShadyCSSVersion = false;
}
const $793cfeedb16e67e7$export$307df51a48bd0a07 = (scopeName)=>(result)=>{
        const cacheKey = $793cfeedb16e67e7$var$getTemplateCacheKey(result.type, scopeName);
        let templateCache = (0, $8t2wc.templateCaches).get(cacheKey);
        if (templateCache === undefined) {
            templateCache = {
                stringsArray: new WeakMap(),
                keyString: new Map()
            };
            (0, $8t2wc.templateCaches).set(cacheKey, templateCache);
        }
        let template = templateCache.stringsArray.get(result.strings);
        if (template !== undefined) return template;
        const key = result.strings.join((0, $dreIb.marker));
        template = templateCache.keyString.get(key);
        if (template === undefined) {
            const element = result.getTemplateElement();
            if ($793cfeedb16e67e7$var$compatibleShadyCSSVersion) window.ShadyCSS.prepareTemplateDom(element, scopeName);
            template = new (0, $dreIb.Template)(result, element);
            templateCache.keyString.set(key, template);
        }
        templateCache.stringsArray.set(result.strings, template);
        return template;
    };
const $793cfeedb16e67e7$var$TEMPLATE_TYPES = [
    'html',
    'svg'
];
/**
 * Removes all style elements from Templates for the given scopeName.
 */ const $793cfeedb16e67e7$var$removeStylesFromLitTemplates = (scopeName)=>{
    $793cfeedb16e67e7$var$TEMPLATE_TYPES.forEach((type)=>{
        const templates = (0, $8t2wc.templateCaches).get($793cfeedb16e67e7$var$getTemplateCacheKey(type, scopeName));
        if (templates !== undefined) templates.keyString.forEach((template)=>{
            const { element: { content: content } } = template;
            // IE 11 doesn't support the iterable param Set constructor
            const styles = new Set();
            Array.from(content.querySelectorAll('style')).forEach((s)=>{
                styles.add(s);
            });
            (0, $doIsc.removeNodesFromTemplate)(template, styles);
        });
    });
};
const $793cfeedb16e67e7$var$shadyRenderSet = new Set();
/**
 * For the given scope name, ensures that ShadyCSS style scoping is performed.
 * This is done just once per scope name so the fragment and template cannot
 * be modified.
 * (1) extracts styles from the rendered fragment and hands them to ShadyCSS
 * to be scoped and appended to the document
 * (2) removes style elements from all lit-html Templates for this scope name.
 *
 * Note, <style> elements can only be placed into templates for the
 * initial rendering of the scope. If <style> elements are included in templates
 * dynamically rendered to the scope (after the first scope render), they will
 * not be scoped and the <style> will be left in the template and rendered
 * output.
 */ const $793cfeedb16e67e7$var$prepareTemplateStyles = (scopeName, renderedDOM, template)=>{
    $793cfeedb16e67e7$var$shadyRenderSet.add(scopeName);
    // If `renderedDOM` is stamped from a Template, then we need to edit that
    // Template's underlying template element. Otherwise, we create one here
    // to give to ShadyCSS, which still requires one while scoping.
    const templateElement = !!template ? template.element : document.createElement('template');
    // Move styles out of rendered DOM and store.
    const styles = renderedDOM.querySelectorAll('style');
    const { length: length } = styles;
    // If there are no styles, skip unnecessary work
    if (length === 0) {
        // Ensure prepareTemplateStyles is called to support adding
        // styles via `prepareAdoptedCssText` since that requires that
        // `prepareTemplateStyles` is called.
        //
        // ShadyCSS will only update styles containing @apply in the template
        // given to `prepareTemplateStyles`. If no lit Template was given,
        // ShadyCSS will not be able to update uses of @apply in any relevant
        // template. However, this is not a problem because we only create the
        // template for the purpose of supporting `prepareAdoptedCssText`,
        // which doesn't support @apply at all.
        window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
        return;
    }
    const condensedStyle = document.createElement('style');
    // Collect styles into a single style. This helps us make sure ShadyCSS
    // manipulations will not prevent us from being able to fix up template
    // part indices.
    // NOTE: collecting styles is inefficient for browsers but ShadyCSS
    // currently does this anyway. When it does not, this should be changed.
    for(let i = 0; i < length; i++){
        const style = styles[i];
        style.parentNode.removeChild(style);
        condensedStyle.textContent += style.textContent;
    }
    // Remove styles from nested templates in this scope.
    $793cfeedb16e67e7$var$removeStylesFromLitTemplates(scopeName);
    // And then put the condensed style into the "root" template passed in as
    // `template`.
    const content = templateElement.content;
    if (!!template) (0, $doIsc.insertNodeIntoTemplate)(template, condensedStyle, content.firstChild);
    else content.insertBefore(condensedStyle, content.firstChild);
    // Note, it's important that ShadyCSS gets the template that `lit-html`
    // will actually render so that it can update the style inside when
    // needed (e.g. @apply native Shadow DOM case).
    window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
    const style = content.querySelector('style');
    if (window.ShadyCSS.nativeShadow && style !== null) // When in native Shadow DOM, ensure the style created by ShadyCSS is
    // included in initially rendered output (`renderedDOM`).
    renderedDOM.insertBefore(style.cloneNode(true), renderedDOM.firstChild);
    else if (!!template) {
        // When no style is left in the template, parts will be broken as a
        // result. To fix this, we put back the style node ShadyCSS removed
        // and then tell lit to remove that node from the template.
        // There can be no style in the template in 2 cases (1) when Shady DOM
        // is in use, ShadyCSS removes all styles, (2) when native Shadow DOM
        // is in use ShadyCSS removes the style if it contains no content.
        // NOTE, ShadyCSS creates its own style so we can safely add/remove
        // `condensedStyle` here.
        content.insertBefore(condensedStyle, content.firstChild);
        const removes = new Set();
        removes.add(condensedStyle);
        (0, $doIsc.removeNodesFromTemplate)(template, removes);
    }
};
const $793cfeedb16e67e7$export$b3890eb0ae9dca99 = (result, container, options)=>{
    if (!options || typeof options !== 'object' || !options.scopeName) throw new Error('The `scopeName` option is required.');
    const scopeName = options.scopeName;
    const hasRendered = (0, $ia8jV.parts).has(container);
    const needsScoping = $793cfeedb16e67e7$var$compatibleShadyCSSVersion && container.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */  && !!container.host;
    // Handle first render to a scope specially...
    const firstScopeRender = needsScoping && !$793cfeedb16e67e7$var$shadyRenderSet.has(scopeName);
    // On first scope render, render into a fragment; this cannot be a single
    // fragment that is reused since nested renders can occur synchronously.
    const renderContainer = firstScopeRender ? document.createDocumentFragment() : container;
    (0, $ia8jV.render)(result, renderContainer, Object.assign({
        templateFactory: $793cfeedb16e67e7$export$307df51a48bd0a07(scopeName)
    }, options));
    // When performing first scope render,
    // (1) We've rendered into a fragment so that there's a chance to
    // `prepareTemplateStyles` before sub-elements hit the DOM
    // (which might cause them to render based on a common pattern of
    // rendering in a custom element's `connectedCallback`);
    // (2) Scope the template with ShadyCSS one time only for this scope.
    // (3) Render the fragment into the container and make sure the
    // container knows its `part` is the one we just rendered. This ensures
    // DOM will be re-used on subsequent renders.
    if (firstScopeRender) {
        const part = (0, $ia8jV.parts).get(renderContainer);
        (0, $ia8jV.parts).delete(renderContainer);
        // ShadyCSS might have style sheets (e.g. from `prepareAdoptedCssText`)
        // that should apply to `renderContainer` even if the rendered value is
        // not a TemplateInstance. However, it will only insert scoped styles
        // into the document if `prepareTemplateStyles` has already been called
        // for the given scope name.
        const template = part.value instanceof (0, $lNzE9.TemplateInstance) ? part.value.template : undefined;
        $793cfeedb16e67e7$var$prepareTemplateStyles(scopeName, renderContainer, template);
        (0, $gn1Tq.removeNodes)(container, container.firstChild);
        container.appendChild(renderContainer);
        (0, $ia8jV.parts).set(container, part);
    }
    // After elements have hit the DOM, update styling if this is the
    // initial render to this container.
    // This is needed whenever dynamic changes are made so it would be
    // safest to do every render; however, this would regress performance
    // so we leave it up to the user to call `ShadyCSS.styleElement`
    // for dynamic changes.
    if (!hasRendered && needsScoping) window.ShadyCSS.styleElement(container.host);
};

});
parcelRegister("doIsc", function(module, exports) {

$parcel$export(module.exports, "removeNodesFromTemplate", () => $9c0fffe1d140f0d8$export$c372fec9bf14be6e);
$parcel$export(module.exports, "insertNodeIntoTemplate", () => $9c0fffe1d140f0d8$export$7a2b65ea46355476);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
var $dreIb = parcelRequire("dreIb");
const $9c0fffe1d140f0d8$var$walkerNodeFilter = 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ ;
function $9c0fffe1d140f0d8$export$c372fec9bf14be6e(template, nodesToRemove) {
    const { element: { content: content }, parts: parts } = template;
    const walker = document.createTreeWalker(content, $9c0fffe1d140f0d8$var$walkerNodeFilter, null, false);
    let partIndex = $9c0fffe1d140f0d8$var$nextActiveIndexInTemplateParts(parts);
    let part = parts[partIndex];
    let nodeIndex = -1;
    let removeCount = 0;
    const nodesToRemoveInTemplate = [];
    let currentRemovingNode = null;
    while(walker.nextNode()){
        nodeIndex++;
        const node = walker.currentNode;
        // End removal if stepped past the removing node
        if (node.previousSibling === currentRemovingNode) currentRemovingNode = null;
        // A node to remove was found in the template
        if (nodesToRemove.has(node)) {
            nodesToRemoveInTemplate.push(node);
            // Track node we're removing
            if (currentRemovingNode === null) currentRemovingNode = node;
        }
        // When removing, increment count by which to adjust subsequent part indices
        if (currentRemovingNode !== null) removeCount++;
        while(part !== undefined && part.index === nodeIndex){
            // If part is in a removed node deactivate it by setting index to -1 or
            // adjust the index as needed.
            part.index = currentRemovingNode !== null ? -1 : part.index - removeCount;
            // go to the next active part.
            partIndex = $9c0fffe1d140f0d8$var$nextActiveIndexInTemplateParts(parts, partIndex);
            part = parts[partIndex];
        }
    }
    nodesToRemoveInTemplate.forEach((n)=>n.parentNode.removeChild(n));
}
const $9c0fffe1d140f0d8$var$countNodes = (node)=>{
    let count = node.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */  ? 0 : 1;
    const walker = document.createTreeWalker(node, $9c0fffe1d140f0d8$var$walkerNodeFilter, null, false);
    while(walker.nextNode())count++;
    return count;
};
const $9c0fffe1d140f0d8$var$nextActiveIndexInTemplateParts = (parts, startIndex = -1)=>{
    for(let i = startIndex + 1; i < parts.length; i++){
        const part = parts[i];
        if ((0, $dreIb.isTemplatePartActive)(part)) return i;
    }
    return -1;
};
function $9c0fffe1d140f0d8$export$7a2b65ea46355476(template, node, refNode = null) {
    const { element: { content: content }, parts: parts } = template;
    // If there's no refNode, then put node at end of template.
    // No part indices need to be shifted in this case.
    if (refNode === null || refNode === undefined) {
        content.appendChild(node);
        return;
    }
    const walker = document.createTreeWalker(content, $9c0fffe1d140f0d8$var$walkerNodeFilter, null, false);
    let partIndex = $9c0fffe1d140f0d8$var$nextActiveIndexInTemplateParts(parts);
    let insertCount = 0;
    let walkerIndex = -1;
    while(walker.nextNode()){
        walkerIndex++;
        const walkerNode = walker.currentNode;
        if (walkerNode === refNode) {
            insertCount = $9c0fffe1d140f0d8$var$countNodes(node);
            refNode.parentNode.insertBefore(node, refNode);
        }
        while(partIndex !== -1 && parts[partIndex].index === walkerIndex){
            // If we've inserted the node, simply adjust all subsequent parts
            if (insertCount > 0) {
                while(partIndex !== -1){
                    parts[partIndex].index += insertCount;
                    partIndex = $9c0fffe1d140f0d8$var$nextActiveIndexInTemplateParts(parts, partIndex);
                }
                return;
            }
            partIndex = $9c0fffe1d140f0d8$var$nextActiveIndexInTemplateParts(parts, partIndex);
        }
    }
}

});


parcelRegister("kj043", function(module, exports) {

$parcel$export(module.exports, "UpdatingElement", () => $ec85a1c7b8661736$export$8bf27daf9e8907c9);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ var $ec85a1c7b8661736$var$_a;
/**
 * Use this module if you want to create your own base class extending
 * [[UpdatingElement]].
 * @packageDocumentation
 */ /*
 * When using Closure Compiler, JSCompiler_renameProperty(property, object) is
 * replaced at compile time by the munged name for object[property]. We cannot
 * alias this function, so we have to use a small shim that has the same
 * behavior when not compiling.
 */ window.JSCompiler_renameProperty = (prop, _obj)=>prop;
const $ec85a1c7b8661736$export$7312b35fbf521afb = {
    toAttribute (value, type) {
        switch(type){
            case Boolean:
                return value ? '' : null;
            case Object:
            case Array:
                // if the value is `null` or `undefined` pass this through
                // to allow removing/no change behavior.
                return value == null ? value : JSON.stringify(value);
        }
        return value;
    },
    fromAttribute (value, type) {
        switch(type){
            case Boolean:
                return value !== null;
            case Number:
                return value === null ? null : Number(value);
            case Object:
            case Array:
                // Type assert to adhere to Bazel's "must type assert JSON parse" rule.
                return JSON.parse(value);
        }
        return value;
    }
};
const $ec85a1c7b8661736$export$53a6892c50694894 = (value, old)=>{
    // This ensures (old==NaN, value==NaN) always returns false
    return old !== value && (old === old || value === value);
};
const $ec85a1c7b8661736$var$defaultPropertyDeclaration = {
    attribute: true,
    type: String,
    converter: $ec85a1c7b8661736$export$7312b35fbf521afb,
    reflect: false,
    hasChanged: $ec85a1c7b8661736$export$53a6892c50694894
};
const $ec85a1c7b8661736$var$STATE_HAS_UPDATED = 1;
const $ec85a1c7b8661736$var$STATE_UPDATE_REQUESTED = 4;
const $ec85a1c7b8661736$var$STATE_IS_REFLECTING_TO_ATTRIBUTE = 8;
const $ec85a1c7b8661736$var$STATE_IS_REFLECTING_TO_PROPERTY = 16;
/**
 * The Closure JS Compiler doesn't currently have good support for static
 * property semantics where "this" is dynamic (e.g.
 * https://github.com/google/closure-compiler/issues/3177 and others) so we use
 * this hack to bypass any rewriting by the compiler.
 */ const $ec85a1c7b8661736$var$finalized = 'finalized';
class $ec85a1c7b8661736$export$8bf27daf9e8907c9 extends HTMLElement {
    constructor(){
        super();
        this.initialize();
    }
    /**
     * Returns a list of attributes corresponding to the registered properties.
     * @nocollapse
     */ static get observedAttributes() {
        // note: piggy backing on this to ensure we're finalized.
        this.finalize();
        const attributes = [];
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this._classProperties.forEach((v, p)=>{
            const attr = this._attributeNameForProperty(p, v);
            if (attr !== undefined) {
                this._attributeToPropertyMap.set(attr, p);
                attributes.push(attr);
            }
        });
        return attributes;
    }
    /**
     * Ensures the private `_classProperties` property metadata is created.
     * In addition to `finalize` this is also called in `createProperty` to
     * ensure the `@property` decorator can add property metadata.
     */ /** @nocollapse */ static _ensureClassProperties() {
        // ensure private storage for property declarations.
        if (!this.hasOwnProperty(JSCompiler_renameProperty('_classProperties', this))) {
            this._classProperties = new Map();
            // NOTE: Workaround IE11 not supporting Map constructor argument.
            const superProperties = Object.getPrototypeOf(this)._classProperties;
            if (superProperties !== undefined) superProperties.forEach((v, k)=>this._classProperties.set(k, v));
        }
    }
    /**
     * Creates a property accessor on the element prototype if one does not exist
     * and stores a PropertyDeclaration for the property with the given options.
     * The property setter calls the property's `hasChanged` property option
     * or uses a strict identity check to determine whether or not to request
     * an update.
     *
     * This method may be overridden to customize properties; however,
     * when doing so, it's important to call `super.createProperty` to ensure
     * the property is setup correctly. This method calls
     * `getPropertyDescriptor` internally to get a descriptor to install.
     * To customize what properties do when they are get or set, override
     * `getPropertyDescriptor`. To customize the options for a property,
     * implement `createProperty` like this:
     *
     * static createProperty(name, options) {
     *   options = Object.assign(options, {myOption: true});
     *   super.createProperty(name, options);
     * }
     *
     * @nocollapse
     */ static createProperty(name, options = $ec85a1c7b8661736$var$defaultPropertyDeclaration) {
        // Note, since this can be called by the `@property` decorator which
        // is called before `finalize`, we ensure storage exists for property
        // metadata.
        this._ensureClassProperties();
        this._classProperties.set(name, options);
        // Do not generate an accessor if the prototype already has one, since
        // it would be lost otherwise and that would never be the user's intention;
        // Instead, we expect users to call `requestUpdate` themselves from
        // user-defined accessors. Note that if the super has an accessor we will
        // still overwrite it
        if (options.noAccessor || this.prototype.hasOwnProperty(name)) return;
        const key = typeof name === 'symbol' ? Symbol() : `__${name}`;
        const descriptor = this.getPropertyDescriptor(name, key, options);
        if (descriptor !== undefined) Object.defineProperty(this.prototype, name, descriptor);
    }
    /**
     * Returns a property descriptor to be defined on the given named property.
     * If no descriptor is returned, the property will not become an accessor.
     * For example,
     *
     *   class MyElement extends LitElement {
     *     static getPropertyDescriptor(name, key, options) {
     *       const defaultDescriptor =
     *           super.getPropertyDescriptor(name, key, options);
     *       const setter = defaultDescriptor.set;
     *       return {
     *         get: defaultDescriptor.get,
     *         set(value) {
     *           setter.call(this, value);
     *           // custom action.
     *         },
     *         configurable: true,
     *         enumerable: true
     *       }
     *     }
     *   }
     *
     * @nocollapse
     */ static getPropertyDescriptor(name, key, options) {
        return {
            // tslint:disable-next-line:no-any no symbol in index
            get () {
                return this[key];
            },
            set (value) {
                const oldValue = this[name];
                this[key] = value;
                this.requestUpdateInternal(name, oldValue, options);
            },
            configurable: true,
            enumerable: true
        };
    }
    /**
     * Returns the property options associated with the given property.
     * These options are defined with a PropertyDeclaration via the `properties`
     * object or the `@property` decorator and are registered in
     * `createProperty(...)`.
     *
     * Note, this method should be considered "final" and not overridden. To
     * customize the options for a given property, override `createProperty`.
     *
     * @nocollapse
     * @final
     */ static getPropertyOptions(name) {
        return this._classProperties && this._classProperties.get(name) || $ec85a1c7b8661736$var$defaultPropertyDeclaration;
    }
    /**
     * Creates property accessors for registered properties and ensures
     * any superclasses are also finalized.
     * @nocollapse
     */ static finalize() {
        // finalize any superclasses
        const superCtor = Object.getPrototypeOf(this);
        if (!superCtor.hasOwnProperty($ec85a1c7b8661736$var$finalized)) superCtor.finalize();
        this[$ec85a1c7b8661736$var$finalized] = true;
        this._ensureClassProperties();
        // initialize Map populated in observedAttributes
        this._attributeToPropertyMap = new Map();
        // make any properties
        // Note, only process "own" properties since this element will inherit
        // any properties defined on the superClass, and finalization ensures
        // the entire prototype chain is finalized.
        if (this.hasOwnProperty(JSCompiler_renameProperty('properties', this))) {
            const props = this.properties;
            // support symbols in properties (IE11 does not support this)
            const propKeys = [
                ...Object.getOwnPropertyNames(props),
                ...typeof Object.getOwnPropertySymbols === 'function' ? Object.getOwnPropertySymbols(props) : []
            ];
            // This for/of is ok because propKeys is an array
            for (const p of propKeys)// note, use of `any` is due to TypeSript lack of support for symbol in
            // index types
            // tslint:disable-next-line:no-any no symbol in index
            this.createProperty(p, props[p]);
        }
    }
    /**
     * Returns the property name for the given attribute `name`.
     * @nocollapse
     */ static _attributeNameForProperty(name, options) {
        const attribute = options.attribute;
        return attribute === false ? undefined : typeof attribute === 'string' ? attribute : typeof name === 'string' ? name.toLowerCase() : undefined;
    }
    /**
     * Returns true if a property should request an update.
     * Called when a property value is set and uses the `hasChanged`
     * option for the property if present or a strict identity check.
     * @nocollapse
     */ static _valueHasChanged(value, old, hasChanged = $ec85a1c7b8661736$export$53a6892c50694894) {
        return hasChanged(value, old);
    }
    /**
     * Returns the property value for the given attribute value.
     * Called via the `attributeChangedCallback` and uses the property's
     * `converter` or `converter.fromAttribute` property option.
     * @nocollapse
     */ static _propertyValueFromAttribute(value, options) {
        const type = options.type;
        const converter = options.converter || $ec85a1c7b8661736$export$7312b35fbf521afb;
        const fromAttribute = typeof converter === 'function' ? converter : converter.fromAttribute;
        return fromAttribute ? fromAttribute(value, type) : value;
    }
    /**
     * Returns the attribute value for the given property value. If this
     * returns undefined, the property will *not* be reflected to an attribute.
     * If this returns null, the attribute will be removed, otherwise the
     * attribute will be set to the value.
     * This uses the property's `reflect` and `type.toAttribute` property options.
     * @nocollapse
     */ static _propertyValueToAttribute(value, options) {
        if (options.reflect === undefined) return;
        const type = options.type;
        const converter = options.converter;
        const toAttribute = converter && converter.toAttribute || $ec85a1c7b8661736$export$7312b35fbf521afb.toAttribute;
        return toAttribute(value, type);
    }
    /**
     * Performs element initialization. By default captures any pre-set values for
     * registered properties.
     */ initialize() {
        this._updateState = 0;
        this._updatePromise = new Promise((res)=>this._enableUpdatingResolver = res);
        this._changedProperties = new Map();
        this._saveInstanceProperties();
        // ensures first update will be caught by an early access of
        // `updateComplete`
        this.requestUpdateInternal();
    }
    /**
     * Fixes any properties set on the instance before upgrade time.
     * Otherwise these would shadow the accessor and break these properties.
     * The properties are stored in a Map which is played back after the
     * constructor runs. Note, on very old versions of Safari (<=9) or Chrome
     * (<=41), properties created for native platform properties like (`id` or
     * `name`) may not have default values set in the element constructor. On
     * these browsers native properties appear on instances and therefore their
     * default value will overwrite any element default (e.g. if the element sets
     * this.id = 'id' in the constructor, the 'id' will become '' since this is
     * the native platform default).
     */ _saveInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this.constructor._classProperties.forEach((_v, p)=>{
            if (this.hasOwnProperty(p)) {
                const value = this[p];
                delete this[p];
                if (!this._instanceProperties) this._instanceProperties = new Map();
                this._instanceProperties.set(p, value);
            }
        });
    }
    /**
     * Applies previously saved instance properties.
     */ _applyInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        // tslint:disable-next-line:no-any
        this._instanceProperties.forEach((v, p)=>this[p] = v);
        this._instanceProperties = undefined;
    }
    connectedCallback() {
        // Ensure first connection completes an update. Updates cannot complete
        // before connection.
        this.enableUpdating();
    }
    enableUpdating() {
        if (this._enableUpdatingResolver !== undefined) {
            this._enableUpdatingResolver();
            this._enableUpdatingResolver = undefined;
        }
    }
    /**
     * Allows for `super.disconnectedCallback()` in extensions while
     * reserving the possibility of making non-breaking feature additions
     * when disconnecting at some point in the future.
     */ disconnectedCallback() {}
    /**
     * Synchronizes property values when attributes change.
     */ attributeChangedCallback(name, old, value) {
        if (old !== value) this._attributeToProperty(name, value);
    }
    _propertyToAttribute(name, value, options = $ec85a1c7b8661736$var$defaultPropertyDeclaration) {
        const ctor = this.constructor;
        const attr = ctor._attributeNameForProperty(name, options);
        if (attr !== undefined) {
            const attrValue = ctor._propertyValueToAttribute(value, options);
            // an undefined value does not change the attribute.
            if (attrValue === undefined) return;
            // Track if the property is being reflected to avoid
            // setting the property again via `attributeChangedCallback`. Note:
            // 1. this takes advantage of the fact that the callback is synchronous.
            // 2. will behave incorrectly if multiple attributes are in the reaction
            // stack at time of calling. However, since we process attributes
            // in `update` this should not be possible (or an extreme corner case
            // that we'd like to discover).
            // mark state reflecting
            this._updateState = this._updateState | $ec85a1c7b8661736$var$STATE_IS_REFLECTING_TO_ATTRIBUTE;
            if (attrValue == null) this.removeAttribute(attr);
            else this.setAttribute(attr, attrValue);
            // mark state not reflecting
            this._updateState = this._updateState & ~$ec85a1c7b8661736$var$STATE_IS_REFLECTING_TO_ATTRIBUTE;
        }
    }
    _attributeToProperty(name, value) {
        // Use tracking info to avoid deserializing attribute value if it was
        // just set from a property setter.
        if (this._updateState & $ec85a1c7b8661736$var$STATE_IS_REFLECTING_TO_ATTRIBUTE) return;
        const ctor = this.constructor;
        // Note, hint this as an `AttributeMap` so closure clearly understands
        // the type; it has issues with tracking types through statics
        // tslint:disable-next-line:no-unnecessary-type-assertion
        const propName = ctor._attributeToPropertyMap.get(name);
        if (propName !== undefined) {
            const options = ctor.getPropertyOptions(propName);
            // mark state reflecting
            this._updateState = this._updateState | $ec85a1c7b8661736$var$STATE_IS_REFLECTING_TO_PROPERTY;
            this[propName] = // tslint:disable-next-line:no-any
            ctor._propertyValueFromAttribute(value, options);
            // mark state not reflecting
            this._updateState = this._updateState & ~$ec85a1c7b8661736$var$STATE_IS_REFLECTING_TO_PROPERTY;
        }
    }
    /**
     * This protected version of `requestUpdate` does not access or return the
     * `updateComplete` promise. This promise can be overridden and is therefore
     * not free to access.
     */ requestUpdateInternal(name, oldValue, options) {
        let shouldRequestUpdate = true;
        // If we have a property key, perform property update steps.
        if (name !== undefined) {
            const ctor = this.constructor;
            options = options || ctor.getPropertyOptions(name);
            if (ctor._valueHasChanged(this[name], oldValue, options.hasChanged)) {
                if (!this._changedProperties.has(name)) this._changedProperties.set(name, oldValue);
                // Add to reflecting properties set.
                // Note, it's important that every change has a chance to add the
                // property to `_reflectingProperties`. This ensures setting
                // attribute + property reflects correctly.
                if (options.reflect === true && !(this._updateState & $ec85a1c7b8661736$var$STATE_IS_REFLECTING_TO_PROPERTY)) {
                    if (this._reflectingProperties === undefined) this._reflectingProperties = new Map();
                    this._reflectingProperties.set(name, options);
                }
            } else // Abort the request if the property should not be considered changed.
            shouldRequestUpdate = false;
        }
        if (!this._hasRequestedUpdate && shouldRequestUpdate) this._updatePromise = this._enqueueUpdate();
    }
    /**
     * Requests an update which is processed asynchronously. This should
     * be called when an element should update based on some state not triggered
     * by setting a property. In this case, pass no arguments. It should also be
     * called when manually implementing a property setter. In this case, pass the
     * property `name` and `oldValue` to ensure that any configured property
     * options are honored. Returns the `updateComplete` Promise which is resolved
     * when the update completes.
     *
     * @param name {PropertyKey} (optional) name of requesting property
     * @param oldValue {any} (optional) old value of requesting property
     * @returns {Promise} A Promise that is resolved when the update completes.
     */ requestUpdate(name, oldValue) {
        this.requestUpdateInternal(name, oldValue);
        return this.updateComplete;
    }
    /**
     * Sets up the element to asynchronously update.
     */ async _enqueueUpdate() {
        this._updateState = this._updateState | $ec85a1c7b8661736$var$STATE_UPDATE_REQUESTED;
        try {
            // Ensure any previous update has resolved before updating.
            // This `await` also ensures that property changes are batched.
            await this._updatePromise;
        } catch (e) {
        // Ignore any previous errors. We only care that the previous cycle is
        // done. Any error should have been handled in the previous update.
        }
        const result = this.performUpdate();
        // If `performUpdate` returns a Promise, we await it. This is done to
        // enable coordinating updates with a scheduler. Note, the result is
        // checked to avoid delaying an additional microtask unless we need to.
        if (result != null) await result;
        return !this._hasRequestedUpdate;
    }
    get _hasRequestedUpdate() {
        return this._updateState & $ec85a1c7b8661736$var$STATE_UPDATE_REQUESTED;
    }
    get hasUpdated() {
        return this._updateState & $ec85a1c7b8661736$var$STATE_HAS_UPDATED;
    }
    /**
     * Performs an element update. Note, if an exception is thrown during the
     * update, `firstUpdated` and `updated` will not be called.
     *
     * You can override this method to change the timing of updates. If this
     * method is overridden, `super.performUpdate()` must be called.
     *
     * For instance, to schedule updates to occur just before the next frame:
     *
     * ```
     * protected async performUpdate(): Promise<unknown> {
     *   await new Promise((resolve) => requestAnimationFrame(() => resolve()));
     *   super.performUpdate();
     * }
     * ```
     */ performUpdate() {
        // Abort any update if one is not pending when this is called.
        // This can happen if `performUpdate` is called early to "flush"
        // the update.
        if (!this._hasRequestedUpdate) return;
        // Mixin instance properties once, if they exist.
        if (this._instanceProperties) this._applyInstanceProperties();
        let shouldUpdate = false;
        const changedProperties = this._changedProperties;
        try {
            shouldUpdate = this.shouldUpdate(changedProperties);
            if (shouldUpdate) this.update(changedProperties);
            else this._markUpdated();
        } catch (e) {
            // Prevent `firstUpdated` and `updated` from running when there's an
            // update exception.
            shouldUpdate = false;
            // Ensure element can accept additional updates after an exception.
            this._markUpdated();
            throw e;
        }
        if (shouldUpdate) {
            if (!(this._updateState & $ec85a1c7b8661736$var$STATE_HAS_UPDATED)) {
                this._updateState = this._updateState | $ec85a1c7b8661736$var$STATE_HAS_UPDATED;
                this.firstUpdated(changedProperties);
            }
            this.updated(changedProperties);
        }
    }
    _markUpdated() {
        this._changedProperties = new Map();
        this._updateState = this._updateState & ~$ec85a1c7b8661736$var$STATE_UPDATE_REQUESTED;
    }
    /**
     * Returns a Promise that resolves when the element has completed updating.
     * The Promise value is a boolean that is `true` if the element completed the
     * update without triggering another update. The Promise result is `false` if
     * a property was set inside `updated()`. If the Promise is rejected, an
     * exception was thrown during the update.
     *
     * To await additional asynchronous work, override the `_getUpdateComplete`
     * method. For example, it is sometimes useful to await a rendered element
     * before fulfilling this Promise. To do this, first await
     * `super._getUpdateComplete()`, then any subsequent state.
     *
     * @returns {Promise} The Promise returns a boolean that indicates if the
     * update resolved without triggering another update.
     */ get updateComplete() {
        return this._getUpdateComplete();
    }
    /**
     * Override point for the `updateComplete` promise.
     *
     * It is not safe to override the `updateComplete` getter directly due to a
     * limitation in TypeScript which means it is not possible to call a
     * superclass getter (e.g. `super.updateComplete.then(...)`) when the target
     * language is ES5 (https://github.com/microsoft/TypeScript/issues/338).
     * This method should be overridden instead. For example:
     *
     *   class MyElement extends LitElement {
     *     async _getUpdateComplete() {
     *       await super._getUpdateComplete();
     *       await this._myChild.updateComplete;
     *     }
     *   }
     * @deprecated Override `getUpdateComplete()` instead for forward
     *     compatibility with `lit-element` 3.0 / `@lit/reactive-element`.
     */ _getUpdateComplete() {
        return this.getUpdateComplete();
    }
    /**
     * Override point for the `updateComplete` promise.
     *
     * It is not safe to override the `updateComplete` getter directly due to a
     * limitation in TypeScript which means it is not possible to call a
     * superclass getter (e.g. `super.updateComplete.then(...)`) when the target
     * language is ES5 (https://github.com/microsoft/TypeScript/issues/338).
     * This method should be overridden instead. For example:
     *
     *   class MyElement extends LitElement {
     *     async getUpdateComplete() {
     *       await super.getUpdateComplete();
     *       await this._myChild.updateComplete;
     *     }
     *   }
     */ getUpdateComplete() {
        return this._updatePromise;
    }
    /**
     * Controls whether or not `update` should be called when the element requests
     * an update. By default, this method always returns `true`, but this can be
     * customized to control when to update.
     *
     * @param _changedProperties Map of changed properties with old values
     */ shouldUpdate(_changedProperties) {
        return true;
    }
    /**
     * Updates the element. This method reflects property values to attributes.
     * It can be overridden to render and keep updated element DOM.
     * Setting properties inside this method will *not* trigger
     * another update.
     *
     * @param _changedProperties Map of changed properties with old values
     */ update(_changedProperties) {
        if (this._reflectingProperties !== undefined && this._reflectingProperties.size > 0) {
            // Use forEach so this works even if for/of loops are compiled to for
            // loops expecting arrays
            this._reflectingProperties.forEach((v, k)=>this._propertyToAttribute(k, this[k], v));
            this._reflectingProperties = undefined;
        }
        this._markUpdated();
    }
    /**
     * Invoked whenever the element is updated. Implement to perform
     * post-updating tasks via DOM APIs, for example, focusing an element.
     *
     * Setting properties inside this method will trigger the element to update
     * again after this update cycle completes.
     *
     * @param _changedProperties Map of changed properties with old values
     */ updated(_changedProperties) {}
    /**
     * Invoked when the element is first updated. Implement to perform one time
     * work on the element after update.
     *
     * Setting properties inside this method will trigger the element to update
     * again after this update cycle completes.
     *
     * @param _changedProperties Map of changed properties with old values
     */ firstUpdated(_changedProperties) {}
}
$ec85a1c7b8661736$var$_a = $ec85a1c7b8661736$var$finalized;
/**
 * Marks class as having finished creating properties.
 */ $ec85a1c7b8661736$export$8bf27daf9e8907c9[$ec85a1c7b8661736$var$_a] = true;

});

parcelRegister("2pFDC", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $1c1e370728623afa$export$da64fc29f17f9d0e);
$parcel$export(module.exports, "property", () => $1c1e370728623afa$export$d541bacb2bda4494);
$parcel$export(module.exports, "query", () => $1c1e370728623afa$export$2fa187e846a241c4);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ const $1c1e370728623afa$var$legacyCustomElement = (tagName, clazz)=>{
    window.customElements.define(tagName, clazz);
    // Cast as any because TS doesn't recognize the return type as being a
    // subtype of the decorated class when clazz is typed as
    // `Constructor<HTMLElement>` for some reason.
    // `Constructor<HTMLElement>` is helpful to make sure the decorator is
    // applied to elements however.
    // tslint:disable-next-line:no-any
    return clazz;
};
const $1c1e370728623afa$var$standardCustomElement = (tagName, descriptor)=>{
    const { kind: kind, elements: elements } = descriptor;
    return {
        kind: kind,
        elements: elements,
        // This callback is called once the class is otherwise fully defined
        finisher (clazz) {
            window.customElements.define(tagName, clazz);
        }
    };
};
const $1c1e370728623afa$export$da64fc29f17f9d0e = (tagName)=>(classOrDescriptor)=>typeof classOrDescriptor === 'function' ? $1c1e370728623afa$var$legacyCustomElement(tagName, classOrDescriptor) : $1c1e370728623afa$var$standardCustomElement(tagName, classOrDescriptor);
const $1c1e370728623afa$var$standardProperty = (options, element)=>{
    // When decorating an accessor, pass it through and add property metadata.
    // Note, the `hasOwnProperty` check in `createProperty` ensures we don't
    // stomp over the user's accessor.
    if (element.kind === 'method' && element.descriptor && !('value' in element.descriptor)) return Object.assign(Object.assign({}, element), {
        finisher (clazz) {
            clazz.createProperty(element.key, options);
        }
    });
    else // createProperty() takes care of defining the property, but we still
    // must return some kind of descriptor, so return a descriptor for an
    // unused prototype field. The finisher calls createProperty().
    return {
        kind: 'field',
        key: Symbol(),
        placement: 'own',
        descriptor: {},
        // When @babel/plugin-proposal-decorators implements initializers,
        // do this instead of the initializer below. See:
        // https://github.com/babel/babel/issues/9260 extras: [
        //   {
        //     kind: 'initializer',
        //     placement: 'own',
        //     initializer: descriptor.initializer,
        //   }
        // ],
        initializer () {
            if (typeof element.initializer === 'function') this[element.key] = element.initializer.call(this);
        },
        finisher (clazz) {
            clazz.createProperty(element.key, options);
        }
    };
};
const $1c1e370728623afa$var$legacyProperty = (options, proto, name)=>{
    proto.constructor.createProperty(name, options);
};
function $1c1e370728623afa$export$d541bacb2bda4494(options) {
    // tslint:disable-next-line:no-any decorator
    return (protoOrDescriptor, name)=>name !== undefined ? $1c1e370728623afa$var$legacyProperty(options, protoOrDescriptor, name) : $1c1e370728623afa$var$standardProperty(options, protoOrDescriptor);
}
function $1c1e370728623afa$export$442549d4f6093fd6(options) {
    return $1c1e370728623afa$export$d541bacb2bda4494({
        attribute: false,
        hasChanged: options === null || options === void 0 ? void 0 : options.hasChanged
    });
}
const $1c1e370728623afa$export$ca000e230c0caa3e = (options)=>$1c1e370728623afa$export$442549d4f6093fd6(options);
function $1c1e370728623afa$export$2fa187e846a241c4(selector, cache) {
    return (protoOrDescriptor, // tslint:disable-next-line:no-any decorator
    name)=>{
        const descriptor = {
            get () {
                return this.renderRoot.querySelector(selector);
            },
            enumerable: true,
            configurable: true
        };
        if (cache) {
            const prop = name !== undefined ? name : protoOrDescriptor.key;
            const key = typeof prop === 'symbol' ? Symbol() : `__${prop}`;
            descriptor.get = function() {
                if (this[key] === undefined) this[key] = this.renderRoot.querySelector(selector);
                return this[key];
            };
        }
        return name !== undefined ? $1c1e370728623afa$var$legacyQuery(descriptor, protoOrDescriptor, name) : $1c1e370728623afa$var$standardQuery(descriptor, protoOrDescriptor);
    };
}
function $1c1e370728623afa$export$163dfc35cc43f240(selector) {
    return (protoOrDescriptor, // tslint:disable-next-line:no-any decorator
    name)=>{
        const descriptor = {
            async get () {
                await this.updateComplete;
                return this.renderRoot.querySelector(selector);
            },
            enumerable: true,
            configurable: true
        };
        return name !== undefined ? $1c1e370728623afa$var$legacyQuery(descriptor, protoOrDescriptor, name) : $1c1e370728623afa$var$standardQuery(descriptor, protoOrDescriptor);
    };
}
function $1c1e370728623afa$export$dcd0d083aa86c355(selector) {
    return (protoOrDescriptor, // tslint:disable-next-line:no-any decorator
    name)=>{
        const descriptor = {
            get () {
                return this.renderRoot.querySelectorAll(selector);
            },
            enumerable: true,
            configurable: true
        };
        return name !== undefined ? $1c1e370728623afa$var$legacyQuery(descriptor, protoOrDescriptor, name) : $1c1e370728623afa$var$standardQuery(descriptor, protoOrDescriptor);
    };
}
const $1c1e370728623afa$var$legacyQuery = (descriptor, proto, name)=>{
    Object.defineProperty(proto, name, descriptor);
};
const $1c1e370728623afa$var$standardQuery = (descriptor, element)=>({
        kind: 'method',
        placement: 'prototype',
        key: element.key,
        descriptor: descriptor
    });
const $1c1e370728623afa$var$standardEventOptions = (options, element)=>{
    return Object.assign(Object.assign({}, element), {
        finisher (clazz) {
            Object.assign(clazz.prototype[element.key], options);
        }
    });
};
const $1c1e370728623afa$var$legacyEventOptions = // tslint:disable-next-line:no-any legacy decorator
(options, proto, name)=>{
    Object.assign(proto[name], options);
};
function $1c1e370728623afa$export$b2b799818fbabcf3(options) {
    // Return value typed as any to prevent TypeScript from complaining that
    // standard decorator function signature does not match TypeScript decorator
    // signature
    // TODO(kschaaf): unclear why it was only failing on this decorator and not
    // the others
    return (protoOrDescriptor, name)=>name !== undefined ? $1c1e370728623afa$var$legacyEventOptions(options, protoOrDescriptor, name) : $1c1e370728623afa$var$standardEventOptions(options, protoOrDescriptor);
}
// x-browser support for matches
// tslint:disable-next-line:no-any
const $1c1e370728623afa$var$ElementProto = Element.prototype;
const $1c1e370728623afa$var$legacyMatches = $1c1e370728623afa$var$ElementProto.msMatchesSelector || $1c1e370728623afa$var$ElementProto.webkitMatchesSelector;
function $1c1e370728623afa$export$1bdbe53f9df1b8(slotName = '', flatten = false, selector = '') {
    return (protoOrDescriptor, // tslint:disable-next-line:no-any decorator
    name)=>{
        const descriptor = {
            get () {
                const slotSelector = `slot${slotName ? `[name=${slotName}]` : ':not([name])'}`;
                const slot = this.renderRoot.querySelector(slotSelector);
                let nodes = slot && slot.assignedNodes({
                    flatten: flatten
                });
                if (nodes && selector) nodes = nodes.filter((node)=>node.nodeType === Node.ELEMENT_NODE && // tslint:disable-next-line:no-any testing existence on older browsers
                    (node.matches ? node.matches(selector) : $1c1e370728623afa$var$legacyMatches.call(node, selector)));
                return nodes;
            },
            enumerable: true,
            configurable: true
        };
        return name !== undefined ? $1c1e370728623afa$var$legacyQuery(descriptor, protoOrDescriptor, name) : $1c1e370728623afa$var$standardQuery(descriptor, protoOrDescriptor);
    };
}

});

parcelRegister("cH4lK", function(module, exports) {

$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => $93dcdff836ec931f$export$b4d10f6001c083c2);
$parcel$export(module.exports, "unsafeCSS", () => $93dcdff836ec931f$export$8d80f9cac07cdb3);
$parcel$export(module.exports, "css", () => $93dcdff836ec931f$export$dbf350e5966cf602);
/**
@license
Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/ /**
 * Whether the current browser supports `adoptedStyleSheets`.
 */ const $93dcdff836ec931f$export$b4d10f6001c083c2 = window.ShadowRoot && (window.ShadyCSS === undefined || window.ShadyCSS.nativeShadow) && 'adoptedStyleSheets' in Document.prototype && 'replace' in CSSStyleSheet.prototype;
const $93dcdff836ec931f$var$constructionToken = Symbol();
class $93dcdff836ec931f$export$505d1e8739bad805 {
    constructor(cssText, safeToken){
        if (safeToken !== $93dcdff836ec931f$var$constructionToken) throw new Error('CSSResult is not constructable. Use `unsafeCSS` or `css` instead.');
        this.cssText = cssText;
    }
    // Note, this is a getter so that it's lazy. In practice, this means
    // stylesheets are not created until the first element instance is made.
    get styleSheet() {
        if (this._styleSheet === undefined) {
            // Note, if `supportsAdoptingStyleSheets` is true then we assume
            // CSSStyleSheet is constructable.
            if ($93dcdff836ec931f$export$b4d10f6001c083c2) {
                this._styleSheet = new CSSStyleSheet();
                this._styleSheet.replaceSync(this.cssText);
            } else this._styleSheet = null;
        }
        return this._styleSheet;
    }
    toString() {
        return this.cssText;
    }
}
const $93dcdff836ec931f$export$8d80f9cac07cdb3 = (value)=>{
    return new $93dcdff836ec931f$export$505d1e8739bad805(String(value), $93dcdff836ec931f$var$constructionToken);
};
const $93dcdff836ec931f$var$textFromCSSResult = (value)=>{
    if (value instanceof $93dcdff836ec931f$export$505d1e8739bad805) return value.cssText;
    else if (typeof value === 'number') return value;
    else throw new Error(`Value passed to 'css' function must be a 'css' function result: ${value}. Use 'unsafeCSS' to pass non-literal values, but
            take care to ensure page security.`);
};
const $93dcdff836ec931f$export$dbf350e5966cf602 = (strings, ...values)=>{
    const cssText = values.reduce((acc, v, idx)=>acc + $93dcdff836ec931f$var$textFromCSSResult(v) + strings[idx + 1], strings[0]);
    return new $93dcdff836ec931f$export$505d1e8739bad805(cssText, $93dcdff836ec931f$var$constructionToken);
};

});


parcelRegister("1Va8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $1662f91f9127623f$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $3tvu5 = parcelRequire("3tvu5");

var $fxyjq = parcelRequire("fxyjq");
const $1662f91f9127623f$var$svgResultCarbonIcon = ({ children: children, ...attrs } = {})=>(0, $3tvu5.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, $fxyjq.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}${children}${children}<path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"></path></svg>`;
var $1662f91f9127623f$export$2e2bcd8739ae039 = $1662f91f9127623f$var$svgResultCarbonIcon;

});
parcelRegister("fxyjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5048dc754e3d0c1$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ parcelRequire("3tvu5");
var $lcFGQ = parcelRequire("lcFGQ");
var $dxEOU = parcelRequire("dxEOU");
/**
 * Stores the ClassInfo object applied to a given AttributePart.
 * Used to unset existing values when a new ClassInfo object is applied.
 */ const $b5048dc754e3d0c1$var$attributesMapCache = new WeakMap();
/**
 * A directive that applies attributes from a key-value pairs.
 * This must be used in the `...` name and must be the only part used in the attribute.
 * It applies the key-value pairs in the `attributesInfo` argument
 * and sets them as attribute name/value pairs.
 * @param classInfo The key-value pair to be set as the attribute name/value pairs.
 */ const $b5048dc754e3d0c1$var$spread = (0, $lcFGQ.directive)((attributesInfo)=>(part)=>{
        // The first character of `...` is interpreted as one for `PropertyPart`
        if (!(part instanceof (0, $dxEOU.PropertyPart)) || part.committer.name !== '..' || part.committer.parts.length > 1) throw new Error('The `spread` directive must be used in with `...` name and must be the only part in the attribute.');
        const { committer: committer } = part;
        const { element: element } = committer; // Removes old attributes that are no longer there
        const oldAttributesInfo = $b5048dc754e3d0c1$var$attributesMapCache.get(part);
        if (oldAttributesInfo) Object.keys(oldAttributesInfo).forEach((name)=>{
            if (!(name in attributesInfo)) element.removeAttribute(name);
        });
         // Adds new attributes
        Object.keys(attributesInfo).forEach((name)=>{
            const value = attributesInfo[name];
            if ((!oldAttributesInfo || !Object.is(value, oldAttributesInfo[name])) && typeof value !== 'undefined') element.setAttribute(name, value);
        }); // Updates the cache
        $b5048dc754e3d0c1$var$attributesMapCache.set(part, attributesInfo);
    });
var $b5048dc754e3d0c1$export$2e2bcd8739ae039 = $b5048dc754e3d0c1$var$spread;

});


parcelRegister("10Bt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc2dacba9aa02bd$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $3tvu5 = parcelRequire("3tvu5");

var $fxyjq = parcelRequire("fxyjq");
const $0bc2dacba9aa02bd$var$svgResultCarbonIcon = ({ children: children, ...attrs } = {})=>(0, $3tvu5.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, $fxyjq.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}${children}${children}<path d="M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2	c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"></path><path d="M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8	c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z" data-icon-path="inner-path" opacity="0"></path></svg>`;
var $0bc2dacba9aa02bd$export$2e2bcd8739ae039 = $0bc2dacba9aa02bd$var$svgResultCarbonIcon;

});

parcelRegister("5l5Nb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e336823c591ee1a$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $cdbVC = parcelRequire("cdbVC");
/**
 * @param Base The base class.
 * @returns A mix-in implementing `.focus()` method that focuses on the first focusable element in the shadow DOM.
 */ const $3e336823c591ee1a$var$FocusMixin = (Base)=>class extends Base {
        /**
   * Focuses on the first focusable element in the shadow DOM.
   */ focus() {
            // @ts-ignore: Until `delegatesFocus` is added to `ShadowRoot` definition
            if (this.shadowRoot.delegatesFocus) super.focus();
            else {
                const delegateTarget = this.shadowRoot.querySelector((0, $cdbVC.selectorTabbable)) || this.querySelector((0, $cdbVC.selectorTabbable));
                if (delegateTarget) delegateTarget.focus();
                else super.focus();
            }
        }
    };
var $3e336823c591ee1a$export$2e2bcd8739ae039 = $3e336823c591ee1a$var$FocusMixin;

});
parcelRegister("cdbVC", function(module, exports) {

$parcel$export(module.exports, "selectorTabbable", () => $8e3ff3a3dc0dcbca$export$5b0b2519dec6dd25);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $jpdgO = parcelRequire("jpdgO");
const { prefix: $8e3ff3a3dc0dcbca$var$prefix } = (0, $jpdgO.default);
/**
 * A selector selecting tabbable nodes.
 * Borrowed from `carbon-angular`. tabbable === focusable.
 */ const $8e3ff3a3dc0dcbca$export$5b0b2519dec6dd25 = `
  a[href], area[href], input:not([disabled]):not([tabindex='-1']),
  button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),
  textarea:not([disabled]):not([tabindex='-1']),
  iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true],
  ${$8e3ff3a3dc0dcbca$var$prefix}-accordion-item,
  ${$8e3ff3a3dc0dcbca$var$prefix}-btn,
  ${$8e3ff3a3dc0dcbca$var$prefix}-breadcrumb-link,
  ${$8e3ff3a3dc0dcbca$var$prefix}-checkbox,
  ${$8e3ff3a3dc0dcbca$var$prefix}-code-snippet,
  ${$8e3ff3a3dc0dcbca$var$prefix}-combo-box,
  ${$8e3ff3a3dc0dcbca$var$prefix}-content-switcher-item,
  ${$8e3ff3a3dc0dcbca$var$prefix}-copy-button,
  ${$8e3ff3a3dc0dcbca$var$prefix}-table-header-row,
  ${$8e3ff3a3dc0dcbca$var$prefix}-table-row,
  ${$8e3ff3a3dc0dcbca$var$prefix}-table-toolbar-search,
  ${$8e3ff3a3dc0dcbca$var$prefix}-date-picker-input,
  ${$8e3ff3a3dc0dcbca$var$prefix}-dropdown,
  ${$8e3ff3a3dc0dcbca$var$prefix}-input,
  ${$8e3ff3a3dc0dcbca$var$prefix}-link,
  ${$8e3ff3a3dc0dcbca$var$prefix}-number-input,
  ${$8e3ff3a3dc0dcbca$var$prefix}-modal,
  ${$8e3ff3a3dc0dcbca$var$prefix}-modal-close-button,
  ${$8e3ff3a3dc0dcbca$var$prefix}-multi-select,
  ${$8e3ff3a3dc0dcbca$var$prefix}-inline-notification,
  ${$8e3ff3a3dc0dcbca$var$prefix}-toast-notification,
  ${$8e3ff3a3dc0dcbca$var$prefix}-overflow-menu,
  ${$8e3ff3a3dc0dcbca$var$prefix}-overflow-menu-item,
  ${$8e3ff3a3dc0dcbca$var$prefix}-page-sizes-select,
  ${$8e3ff3a3dc0dcbca$var$prefix}-pages-select,
  ${$8e3ff3a3dc0dcbca$var$prefix}-progress-step,
  ${$8e3ff3a3dc0dcbca$var$prefix}-radio-button,
  ${$8e3ff3a3dc0dcbca$var$prefix}-search,
  ${$8e3ff3a3dc0dcbca$var$prefix}-slider,
  ${$8e3ff3a3dc0dcbca$var$prefix}-slider-input,
  ${$8e3ff3a3dc0dcbca$var$prefix}-structured-list,
  ${$8e3ff3a3dc0dcbca$var$prefix}-tab,
  ${$8e3ff3a3dc0dcbca$var$prefix}-filter-tag,
  ${$8e3ff3a3dc0dcbca$var$prefix}-textarea,
  ${$8e3ff3a3dc0dcbca$var$prefix}-clickable-tile,
  ${$8e3ff3a3dc0dcbca$var$prefix}-expandable-tile,
  ${$8e3ff3a3dc0dcbca$var$prefix}-radio-tile,
  ${$8e3ff3a3dc0dcbca$var$prefix}-selectable-tile,
  ${$8e3ff3a3dc0dcbca$var$prefix}-toggle,
  ${$8e3ff3a3dc0dcbca$var$prefix}-tooltip,
  ${$8e3ff3a3dc0dcbca$var$prefix}-tooltip-definition,
  ${$8e3ff3a3dc0dcbca$var$prefix}-tooltip-icon,
  ${$8e3ff3a3dc0dcbca$var$prefix}-header-menu,
  ${$8e3ff3a3dc0dcbca$var$prefix}-header-menu-button,
  ${$8e3ff3a3dc0dcbca$var$prefix}-header-menu-item,
  ${$8e3ff3a3dc0dcbca$var$prefix}-header-name,
  ${$8e3ff3a3dc0dcbca$var$prefix}-header-nav-item,
  ${$8e3ff3a3dc0dcbca$var$prefix}-side-nav-link,
  ${$8e3ff3a3dc0dcbca$var$prefix}-side-nav-menu,
  ${$8e3ff3a3dc0dcbca$var$prefix}-side-nav-menu-item
`; // Because we're going to have a bunch of exports

});


parcelRegister("6Ia5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2ead1ee378bec7$export$2e2bcd8739ae039);

var $gCjvw = parcelRequire("gCjvw");

var $2jTfi = parcelRequire("2jTfi");
/**
 * @param Base The base class.
 * @returns A mix-in to handle `formdata` event on the containing form.
 */ const $4e2ead1ee378bec7$var$FormMixin = (Base)=>{
    /**
   * A mix-in class to handle `formdata` event on the containing form.
   */ class FormMixinImpl extends Base {
        constructor(...args){
            super(...args);
            (0, $gCjvw.default)(this, "_hFormdata", null);
        }
        connectedCallback() {
            // @ts-ignore
            super.connectedCallback();
            const form = this.closest('form');
            if (form) this._hFormdata = (0, $2jTfi.default)(form, 'formdata', this._handleFormdata.bind(this));
        }
        disconnectedCallback() {
            if (this._hFormdata) this._hFormdata = this._hFormdata.release();
             // @ts-ignore
            super.disconnectedCallback();
        }
    }
    return FormMixinImpl;
};
var $4e2ead1ee378bec7$export$2e2bcd8739ae039 = $4e2ead1ee378bec7$var$FormMixin;

});
parcelRegister("2jTfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b0835c414dce9d4$export$2e2bcd8739ae039);
/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $1b0835c414dce9d4$export$2e2bcd8739ae039(element) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    element.addEventListener.apply(element, args);
    return {
        release: function release() {
            element.removeEventListener.apply(element, args);
            return null;
        }
    };
}

});


parcelRegister("498Lv", function(module, exports) {

$parcel$export(module.exports, "default", () => $304ecd42689625b4$export$2e2bcd8739ae039);

var $gCjvw = parcelRequire("gCjvw");

var $2jTfi = parcelRequire("2jTfi");
/**
 * The format for the event name used by `@HostListener` decorator.
 */ const $304ecd42689625b4$var$EVENT_NAME_FORMAT = /^((document|window|parentRoot|shadowRoot):)?([\w-]+)$/;
/**
 * @param Base The base class.
 * @returns A mix-in that sets up and cleans up event listeners defined by `@HostListener` decorator.
 */ const $304ecd42689625b4$var$HostListenerMixin = (Base)=>{
    /**
   * A mix-in class that sets up and cleans up event listeners defined by `@HostListener` decorator.
   */ class HostListenerMixinImpl extends Base {
        constructor(...args){
            super(...args);
            (0, $gCjvw.default)(this, "_handles", new Set());
        }
        // Not using TypeScript `private` due to: microsoft/TypeScript#17744
        connectedCallback() {
            // @ts-ignore: Until `connectedCallback` is added to `HTMLElement` definition
            super.connectedCallback();
            const hostListeners = this.constructor._hostListeners;
            Object.keys(hostListeners).forEach((listenerName)=>{
                Object.keys(hostListeners[listenerName]).forEach((type)=>{
                    var _unprefixedType;
                    // Parses `document:click`/`window:click` format
                    const tokens = $304ecd42689625b4$var$EVENT_NAME_FORMAT.exec(type);
                    if (!tokens) throw new Error(`Could not parse the event name: ${listenerName}`);
                    const [, , targetName, unprefixedType] = tokens;
                    const target = {
                        document: this.ownerDocument,
                        window: this.ownerDocument.defaultView,
                        parentRoot: this.getRootNode(),
                        shadowRoot: this.shadowRoot
                    }[targetName] || this;
                    const { options: options } = hostListeners[listenerName][type];
                    this._handles.add((0, $2jTfi.default)(target, (_unprefixedType = this.constructor[unprefixedType]) !== null && _unprefixedType !== void 0 ? _unprefixedType : unprefixedType, this[listenerName], options));
                });
            });
        }
        disconnectedCallback() {
            this._handles.forEach((handle)=>{
                handle.release();
                this._handles.delete(handle);
            }); // @ts-ignore: Until `disconnectedCallback` is added to `HTMLElement` definition
            super.disconnectedCallback();
        }
    }
    (0, $gCjvw.default)(HostListenerMixinImpl, "_hostListeners", {});
    return HostListenerMixinImpl;
};
var $304ecd42689625b4$export$2e2bcd8739ae039 = $304ecd42689625b4$var$HostListenerMixin;

});

parcelRegister("01HFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0051f8feee68c596$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Form validation status.
 */ let $0051f8feee68c596$export$49618edbbe77ae67;
/**
 * @param Base The base class.
 * @returns A mix-in implementing `.setCustomValidity()` method.
 */ (function(VALIDATION_STATUS) {
    VALIDATION_STATUS["NO_ERROR"] = "";
    VALIDATION_STATUS["ERROR_REQUIRED"] = "required";
})($0051f8feee68c596$export$49618edbbe77ae67 || ($0051f8feee68c596$export$49618edbbe77ae67 = {}));
const $0051f8feee68c596$var$ValidityMixin = (Base)=>{
    class ValidityMixinImpl extends Base {
        // Not using TypeScript `protected` due to: microsoft/TypeScript#17744
        // Using `string` instead of `VALIDATION_STATUS` until we can require TypeScript 3.8
        /**
     * @param state The form validation status.
     * @returns The form validation error messages associated with the given status.
     * @protected
     */ _getValidityMessage(state) {
            return ({
                [$0051f8feee68c596$export$49618edbbe77ae67.NO_ERROR]: '',
                [$0051f8feee68c596$export$49618edbbe77ae67.ERROR_REQUIRED]: this.requiredValidityMessage
            })[state];
        }
        // Using `string` instead of `VALIDATION_STATUS` until we can require TypeScript 3.8
        /**
     * Checks if the value meets the constraints.
     * @returns `VALIDATION_STATUS.NO_ERROR` if the value meets the constraints. Some other values otherwise.
     * @protected
     */ _testValidity() {
            const { required: required, value: value } = this;
            return required && !value ? $0051f8feee68c596$export$49618edbbe77ae67.ERROR_REQUIRED : $0051f8feee68c596$export$49618edbbe77ae67.NO_ERROR;
        }
        /**
     * `true` to show the UI of the invalid state.
     */ /**
     * Checks if the value meets the constraints.
     * Fires cancelable `invalid` event if it doesn't.
     * @returns `true` if the value meets the constraints. `false` otherwise.
     */ checkValidity() {
            const status = this._testValidity();
            if (status !== $0051f8feee68c596$export$49618edbbe77ae67.NO_ERROR) {
                if (this.dispatchEvent(new CustomEvent('invalid', {
                    bubbles: false,
                    cancelable: true,
                    composed: false
                }))) {
                    this.invalid = true;
                    this.validityMessage = this._getValidityMessage(status);
                }
                return false;
            }
            this.invalid = false;
            this.validityMessage = '';
            return true;
        }
        /**
     * Sets the given custom validity message.
     * @param validityMessage The custom validity message
     */ setCustomValidity(validityMessage) {
            this.invalid = Boolean(validityMessage);
            this.validityMessage = validityMessage;
        }
    }
    return ValidityMixinImpl;
};
var $0051f8feee68c596$export$2e2bcd8739ae039 = $0051f8feee68c596$var$ValidityMixin;

});

parcelRegister("hfEKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f3715fad1acafb$export$2e2bcd8739ae039);

var $ftPDQ = parcelRequire("ftPDQ");
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Puts an event listener to an internal table for `@HostListener()`.
 * @param type
 *   The event type. Can be prefixed with `document:` or `window:`.
 *   The event listener is attached to host element's owner document or its default view in such case.
 * @param options The event listener options.
 * @param Clazz The target class.
 * @param name The method name in the given target class that works as the event listener.
 */ const $c8f3715fad1acafb$var$setHostListener = (type, options, Clazz, name)=>{
    const hostListeners = Clazz._hostListeners;
    if (!hostListeners) throw new Error('The method `@HostListener()` is defined on has to be of a class that has `HostListerMixin`.');
    if (!hostListeners[name]) hostListeners[name] = {};
    hostListeners[name][type] = {
        options: options
    };
};
/**
 * @param type
 *   The event type. Can be prefixed with `document:` or `window:`.
 *   The event listener is attached to host element's owner document or its default view in such case.
 * @param options The event listener options.
 * @param descriptor The original class element descriptor of the event listener method.
 * @returns The updated class element descriptor with `@HostListener()` decorator.
 */ const $c8f3715fad1acafb$var$HostListenerStandard = (type, options, descriptor)=>{
    const { kind: kind, key: key, placement: placement } = descriptor;
    if (!(kind === 'method' && placement === 'prototype' || kind === 'field' && placement === 'own')) throw new Error('`@HostListener()` must be defined on instance methods, but you may have defined it on static, field, etc.');
    return (0, $ftPDQ.default)((0, $ftPDQ.default)({}, descriptor), {}, {
        finisher (Clazz) {
            $c8f3715fad1acafb$var$setHostListener(type, options, Clazz, key);
        }
    });
};
/**
 * A decorator to add event listener to the host element, or its `document`/`window`, of a custom element.
 * The `target` must extend `HostListenerMixin`.
 * @param type
 *   The event type. Can be prefixed with `document:` or `window:`.
 *   The event listener is attached to host element's owner document or its default view in such case.
 * @param options The event listener options.
 */ const $c8f3715fad1acafb$var$HostListener = (type, options)=>(targetOrDescriptor, name)=>typeof name !== 'undefined' ? $c8f3715fad1acafb$var$setHostListener(type, options, targetOrDescriptor.constructor, name) : $c8f3715fad1acafb$var$HostListenerStandard(type, options, targetOrDescriptor);
var $c8f3715fad1acafb$export$2e2bcd8739ae039 = $c8f3715fad1acafb$var$HostListener;

});

parcelRegister("gfp9Q", function(module, exports) {

$parcel$export(module.exports, "find", () => $bd418fde054deae2$export$71aa6c912b956294);
$parcel$export(module.exports, "forEach", () => $bd418fde054deae2$export$4b80e395e36b5a56);
$parcel$export(module.exports, "indexOf", () => $bd418fde054deae2$export$305f7d4e9d4624f2);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param a A DOM collection.
 * @param predicate The callback function.
 * @param [thisObject] The context object for the given callback function.
 * @returns A new array with all elements where `predicate` returns truthy.
 */ const $bd418fde054deae2$export$3dea766d36a8935f = (a, predicate, thisObject)=>Array.prototype.filter.call(a, predicate, thisObject);
const $bd418fde054deae2$export$de3a4d4a0d731119 = (a, predicate, thisObject)=>Array.prototype.findIndex.call(a, predicate, thisObject);
const $bd418fde054deae2$export$71aa6c912b956294 = (a, predicate, thisObject)=>Array.prototype.find.call(a, predicate, thisObject);
const $bd418fde054deae2$export$4b80e395e36b5a56 = (a, predicate, thisObject)=>Array.prototype.forEach.call(a, predicate, thisObject);
const $bd418fde054deae2$export$305f7d4e9d4624f2 = (a, item)=>Array.prototype.indexOf.call(a, item);

});

parcelRegister("5Wl2V", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_DIRECTION", () => $4532b1e0e42d6c70$export$6c7d09cdd7edc058);
$parcel$export(module.exports, "DROPDOWN_KEYBOARD_ACTION", () => $4532b1e0e42d6c70$export$23760ea60b9b3f66);
$parcel$export(module.exports, "DROPDOWN_SIZE", () => $4532b1e0e42d6c70$export$911cbe59b5652e2f);
$parcel$export(module.exports, "DROPDOWN_TYPE", () => $4532b1e0e42d6c70$export$653a5b10893c572f);
$parcel$export(module.exports, "DROPDOWN_COLOR_SCHEME", () => (parcelRequire("e4B20")).FORM_ELEMENT_COLOR_SCHEME);
/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $e4B20 = parcelRequire("e4B20");
const $4532b1e0e42d6c70$export$6c7d09cdd7edc058 = {
    Up: -1,
    ArrowUp: -1,
    Down: 1,
    ArrowDown: 1
};
let $4532b1e0e42d6c70$export$23760ea60b9b3f66;
/**
 * Dropdown size.
 */ (function(DROPDOWN_KEYBOARD_ACTION) {
    DROPDOWN_KEYBOARD_ACTION["NONE"] = "none";
    DROPDOWN_KEYBOARD_ACTION["CLOSING"] = "closing";
    DROPDOWN_KEYBOARD_ACTION["NAVIGATING"] = "navigating";
    DROPDOWN_KEYBOARD_ACTION["TRIGGERING"] = "triggering";
})($4532b1e0e42d6c70$export$23760ea60b9b3f66 || ($4532b1e0e42d6c70$export$23760ea60b9b3f66 = {}));
let $4532b1e0e42d6c70$export$911cbe59b5652e2f;
/**
 * Dropdown types.
 */ (function(DROPDOWN_SIZE) {
    DROPDOWN_SIZE["REGULAR"] = "";
    DROPDOWN_SIZE["SMALL"] = "sm";
    DROPDOWN_SIZE["EXTRA_LARGE"] = "xl";
})($4532b1e0e42d6c70$export$911cbe59b5652e2f || ($4532b1e0e42d6c70$export$911cbe59b5652e2f = {}));
let $4532b1e0e42d6c70$export$653a5b10893c572f;
(function(DROPDOWN_TYPE) {
    DROPDOWN_TYPE["REGULAR"] = "";
    DROPDOWN_TYPE["INLINE"] = "inline";
})($4532b1e0e42d6c70$export$653a5b10893c572f || ($4532b1e0e42d6c70$export$653a5b10893c572f = {}));

});
parcelRegister("e4B20", function(module, exports) {

$parcel$export(module.exports, "FORM_ELEMENT_COLOR_SCHEME", () => $a3ee2a0c96df4e0b$export$979e74a6270b0ef9);
/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable import/prefer-default-export */ /**
 * Color scheme for form elements.
 */ let $a3ee2a0c96df4e0b$export$979e74a6270b0ef9;
(function(FORM_ELEMENT_COLOR_SCHEME) {
    FORM_ELEMENT_COLOR_SCHEME["REGULAR"] = "";
    FORM_ELEMENT_COLOR_SCHEME["LIGHT"] = "light";
})($a3ee2a0c96df4e0b$export$979e74a6270b0ef9 || ($a3ee2a0c96df4e0b$export$979e74a6270b0ef9 = {}));

});


parcelRegister("7vLeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $57801203003ff987$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ parcelRequire("3eEWe");
var $cH4lK = parcelRequire("cH4lK");
var $57801203003ff987$export$2e2bcd8739ae039 = (0, $cH4lK.css)([
    "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{padding:0;border:0;margin:0;font:inherit;font-size:100%;vertical-align:baseline}button,input,select,textarea{border-radius:0;font-family:inherit}input[type=text]::-ms-clear{display:none}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}body{line-height:1}sup{vertical-align:super}sub{vertical-align:sub}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote::after,blockquote::before,q::after,q::before{content:\"\"}table{border-collapse:collapse;border-spacing:0}*{box-sizing:border-box}button{margin:0}html{font-size:100%}body{font-weight:400;font-family:'IBM Plex Sans','Helvetica Neue',Arial,sans-serif;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}code{font-family:'IBM Plex Mono',Menlo,'DejaVu Sans Mono','Bitstream Vera Sans Mono',Courier,monospace}strong{font-weight:600}@media screen and (-ms-high-contrast:active){svg{fill:ButtonText}}h1{font-size:var(--cds-productive-heading-06-font-size,2.625rem);font-weight:var(--cds-productive-heading-06-font-weight,300);line-height:var(--cds-productive-heading-06-line-height,1.199);letter-spacing:var(--cds-productive-heading-06-letter-spacing,0)}h2{font-size:var(--cds-productive-heading-05-font-size,2rem);font-weight:var(--cds-productive-heading-05-font-weight,400);line-height:var(--cds-productive-heading-05-line-height,1.25);letter-spacing:var(--cds-productive-heading-05-letter-spacing,0)}h3{font-size:var(--cds-productive-heading-04-font-size,1.75rem);font-weight:var(--cds-productive-heading-04-font-weight,400);line-height:var(--cds-productive-heading-04-line-height,1.28572);letter-spacing:var(--cds-productive-heading-04-letter-spacing,0)}h4{font-size:var(--cds-productive-heading-03-font-size,1.25rem);font-weight:var(--cds-productive-heading-03-font-weight,400);line-height:var(--cds-productive-heading-03-line-height,1.4);letter-spacing:var(--cds-productive-heading-03-letter-spacing,0)}h5{font-size:var(--cds-productive-heading-02-font-size,1rem);font-weight:var(--cds-productive-heading-02-font-weight,600);line-height:var(--cds-productive-heading-02-line-height,1.375);letter-spacing:var(--cds-productive-heading-02-letter-spacing,0)}h6{font-size:var(--cds-productive-heading-01-font-size,.875rem);font-weight:var(--cds-productive-heading-01-font-weight,600);line-height:var(--cds-productive-heading-01-line-height,1.28572);letter-spacing:var(--cds-productive-heading-01-letter-spacing,.16px)}p{font-size:var(--cds-body-long-02-font-size,1rem);font-weight:var(--cds-body-long-02-font-weight,400);line-height:var(--cds-body-long-02-line-height,1.5);letter-spacing:var(--cds-body-long-02-letter-spacing,0)}a{color:#0f62fe}em{font-style:italic}.bx--assistive-text,.bx--visually-hidden{position:absolute;overflow:hidden;width:1px;height:1px;padding:0;border:0;margin:-1px;clip:rect(0,0,0,0);visibility:inherit;white-space:nowrap}.bx--body{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);background-color:var(--cds-ui-background,#fff);color:var(--cds-text-01,#161616);line-height:1}.bx--body *,.bx--body ::after,.bx--body ::before{box-sizing:inherit}@-webkit-keyframes skeleton{0%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}20%{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}28%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}51%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}58%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}82%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}83%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}96%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}100%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}}@keyframes skeleton{0%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}20%{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}28%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}51%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}58%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}82%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}83%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}96%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}100%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}}.bx--text-truncate--end{display:inline-block;overflow:hidden;width:100%;text-overflow:ellipsis;white-space:nowrap}.bx--text-truncate--front{display:inline-block;overflow:hidden;width:100%;direction:rtl;text-overflow:ellipsis;white-space:nowrap}.bx--list-box__wrapper--inline,:host(bx-dropdown[type=inline]){display:inline-grid;align-items:center;grid-gap:.25rem;grid-template:auto auto/auto auto}.bx--list-box__wrapper--inline .bx--label,:host(bx-dropdown[type=inline]) .bx--label{font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px)}.bx--list-box__wrapper--inline .bx--form-requirement,.bx--list-box__wrapper--inline .bx--form__helper-text,.bx--list-box__wrapper--inline .bx--label,:host(bx-dropdown[type=inline]) .bx--form-requirement,:host(bx-dropdown[type=inline]) .bx--form__helper-text,:host(bx-dropdown[type=inline]) .bx--label{margin:0}.bx--list-box__wrapper--inline .bx--form__helper-text,:host(bx-dropdown[type=inline]) .bx--form__helper-text{max-width:none}.bx--list-box__wrapper--inline .bx--form-requirement,:host(bx-dropdown[type=inline]) .bx--form-requirement{grid-column:2}.bx--list-box{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;position:relative;width:100%;height:2.5rem;max-height:2.5rem;border:none;border-bottom:1px solid var(--cds-ui-04,#8d8d8d);background-color:var(--cds-field-01,#f4f4f4);color:var(--cds-text-01,#161616);cursor:pointer;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.bx--list-box *,.bx--list-box ::after,.bx--list-box ::before{box-sizing:inherit}.bx--list-box:hover{background-color:var(--cds-hover-ui,#e5e5e5)}.bx--list-box--lg,.bx--list-box--xl{height:3rem;max-height:3rem}.bx--list-box--sm{height:2rem;max-height:2rem}.bx--list-box--expanded{border-bottom-color:var(--cds-ui-03,#e0e0e0)}.bx--list-box--expanded:hover{background-color:var(--cds-field-01,#f4f4f4)}.bx--list-box--expanded:hover.bx--list-box--light:hover{background-color:var(--cds-field-02,#fff)}.bx--list-box .bx--text-input{min-width:0;height:100%}.bx--list-box__invalid-icon{position:absolute;top:50%;right:2.5rem;fill:var(--cds-support-01,#da1e28);-webkit-transform:translateY(-50%);transform:translateY(-50%)}.bx--list-box__invalid-icon--warning{fill:var(--cds-support-03,#f1c21b)}.bx--list-box__invalid-icon--warning path[fill]{fill:#000;opacity:1}.bx--list-box.bx--list-box--warning .bx--list-box__field,.bx--list-box[data-invalid] .bx--list-box__field{padding-right:4rem;border-bottom:0}.bx--list-box[data-invalid].bx--list-box--inline .bx--list-box__field{padding-right:3.5rem}.bx--list-box--light{background-color:var(--cds-field-02,#fff)}.bx--list-box--light:hover{background-color:var(--cds-hover-light-ui,#e5e5e5)}.bx--list-box--light .bx--list-box__menu{background:var(--cds-field-02,#fff)}.bx--list-box--light .bx--list-box__menu-item__option{border-top-color:var(--cds-decorative-01,#e0e0e0)}.bx--list-box--light.bx--list-box--expanded{border-bottom-color:transparent}.bx--list-box--disabled:hover{background-color:var(--cds-field-01,#f4f4f4)}.bx--list-box--light.bx--list-box--disabled{background-color:var(--cds-field-02,#fff)}.bx--list-box--disabled,.bx--list-box--disabled .bx--list-box__field,.bx--list-box--disabled .bx--list-box__field:focus{border-bottom-color:transparent;outline:0}.bx--list-box--disabled .bx--list-box__label,.bx--list-box--disabled.bx--list-box--inline .bx--list-box__label{color:var(--cds-disabled-02,#c6c6c6)}.bx--list-box--disabled .bx--list-box__menu-icon>svg,.bx--list-box--disabled .bx--list-box__selection>svg{fill:var(--cds-disabled-02,#c6c6c6)}.bx--list-box--disabled,.bx--list-box--disabled .bx--list-box__field,.bx--list-box--disabled .bx--list-box__menu-icon{cursor:not-allowed}.bx--list-box--disabled .bx--list-box__menu-item,.bx--list-box--disabled .bx--list-box__menu-item--highlighted,.bx--list-box--disabled .bx--list-box__menu-item:hover,.bx--list-box--disabled :host(bx-dropdown-item){color:var(--cds-disabled-02,#c6c6c6);text-decoration:none}.bx--list-box--disabled .bx--list-box__selection:hover{cursor:not-allowed}.bx--list-box--disabled.bx--list-box[data-invalid] .bx--list-box__field{padding-right:3rem}.bx--list-box--disabled.bx--list-box[data-invalid].bx--list-box--inline .bx--list-box__field{padding-right:2rem}.bx--list-box.bx--list-box--inline{border-width:0;background-color:transparent}.bx--list-box.bx--list-box--inline:hover{background-color:var(--cds-hover-ui,#e5e5e5)}.bx--list-box.bx--list-box--inline.bx--list-box--expanded{border-bottom-width:0}.bx--list-box.bx--list-box--inline.bx--list-box--expanded .bx--list-box__field[aria-expanded=true]{border-width:0}.bx--list-box.bx--list-box--inline.bx--list-box--disabled:hover{background-color:transparent}.bx--list-box.bx--list-box--inline.bx--list-box--expanded:hover{background-color:var(--cds-field-02,#fff)}.bx--list-box.bx--list-box--inline .bx--list-box__field{padding:0 2rem 0 .5rem}.bx--list-box.bx--list-box--inline .bx--list-box__menu-icon{right:.5rem}.bx--list-box.bx--list-box--inline .bx--list-box__invalid-icon{right:2rem}.bx--list-box--inline .bx--list-box__label{color:var(--cds-text-01,#161616)}.bx--list-box--inline .bx--list-box__field{height:100%}.bx--dropdown--inline .bx--list-box__field{max-width:30rem}.bx--dropdown--inline .bx--list-box__menu{min-width:18rem;max-width:30rem}.bx--list-box__field{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;display:inline-block;padding:0;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;cursor:pointer;width:100%;position:relative;display:inline-flex;overflow:hidden;height:calc(100% + 1px);align-items:center;padding:0 3rem 0 1rem;cursor:pointer;outline:0;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}.bx--list-box__field *,.bx--list-box__field ::after,.bx--list-box__field ::before{box-sizing:inherit}.bx--list-box__field::-moz-focus-inner{border:0}.bx--list-box__field:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.bx--list-box__field:focus{outline-style:dotted}}.bx--list-box__field[disabled]{color:var(--cds-disabled-02,#c6c6c6);outline:0}.bx--list-box__field .bx--text-input{padding-right:4.5rem}.bx--list-box--warning .bx--list-box__field .bx--text-input,.bx--list-box[data-invalid] .bx--list-box__field .bx--text-input{padding-right:6.125rem}.bx--list-box--warning .bx--list-box__field .bx--text-input+.bx--list-box__invalid-icon,.bx--list-box[data-invalid] .bx--list-box__field .bx--text-input+.bx--list-box__invalid-icon{right:4.125rem}.bx--list-box__field .bx--text-input--empty{padding-right:3rem}.bx--list-box--warning .bx--list-box__field .bx--text-input--empty,.bx--list-box[data-invalid] .bx--list-box__field .bx--text-input--empty{padding-right:4.5rem}.bx--list-box--warning .bx--list-box__field .bx--text-input--empty+.bx--list-box__invalid-icon,.bx--list-box[data-invalid] .bx--list-box__field .bx--text-input--empty+.bx--list-box__invalid-icon{right:2.5rem}.bx--list-box__label{font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);overflow:hidden;color:var(--cds-text-01,#161616);text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}.bx--list-box__menu-icon{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;display:inline-block;padding:0;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;cursor:pointer;position:absolute;right:1rem;display:flex;width:1.5rem;height:1.5rem;align-items:center;justify-content:center;cursor:pointer;outline:0;transition:-webkit-transform 70ms cubic-bezier(.2,0,.38,.9);transition:transform 70ms cubic-bezier(.2,0,.38,.9);transition:transform 70ms cubic-bezier(.2,0,.38,.9),-webkit-transform 70ms cubic-bezier(.2,0,.38,.9)}.bx--list-box__menu-icon *,.bx--list-box__menu-icon ::after,.bx--list-box__menu-icon ::before{box-sizing:inherit}.bx--list-box__menu-icon::-moz-focus-inner{border:0}.bx--list-box__menu-icon>svg{fill:var(--cds-icon-01,#161616)}.bx--list-box__menu-icon--open{width:1.5rem;justify-content:center;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.bx--list-box__selection{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;display:inline-block;padding:0;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;cursor:pointer;position:absolute;top:50%;right:2.5rem;display:flex;width:1.5rem;height:1.5rem;align-items:center;justify-content:center;cursor:pointer;-webkit-transform:translateY(-50%);transform:translateY(-50%);transition:background-color 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bx--list-box__selection *,.bx--list-box__selection ::after,.bx--list-box__selection ::before{box-sizing:inherit}.bx--list-box__selection::-moz-focus-inner{border:0}.bx--list-box__selection:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.bx--list-box__selection:focus{outline-style:dotted}}.bx--list-box__selection:focus:hover{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.bx--list-box__selection:focus:hover{outline-style:dotted}}.bx--list-box__selection>svg{fill:var(--cds-icon-01,#161616)}.bx--list-box--disabled .bx--list-box__selection:focus{outline:0}.bx--list-box__selection--multi{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);line-height:var(--cds-label-01-line-height,1.33333);letter-spacing:var(--cds-label-01-letter-spacing,.32px);position:static;top:auto;display:flex;width:auto;height:1.5rem;align-items:center;justify-content:space-between;padding:.5rem;padding-right:.125rem;margin-right:.625rem;background-color:var(--cds-inverse-02,#393939);border-radius:.75rem;color:var(--cds-inverse-01,#fff);line-height:0;-webkit-transform:none;transform:none}.bx--list-box__selection--multi>svg{width:1.25rem;height:1.25rem;padding:.125rem;margin-left:.25rem;fill:var(--cds-inverse-01,#fff)}.bx--list-box__selection--multi>svg:hover{background-color:var(--cds-hover-secondary,#4c4c4c);border-radius:50%}.bx--list-box--disabled .bx--list-box__selection--multi{background-color:var(--cds-disabled-02,#c6c6c6);color:var(--cds-disabled-01,#f4f4f4)}.bx--list-box--disabled .bx--list-box__selection--multi .bx--tag__close-icon:hover,.bx--list-box--disabled .bx--list-box__selection--multi.bx--tag--interactive:hover{background-color:var(--cds-disabled-02,#c6c6c6)}.bx--list-box--disabled .bx--list-box__selection--multi>svg{fill:var(--cds-disabled-01,#f4f4f4)}.bx--list-box--disabled .bx--list-box__selection--multi>svg:hover{background-color:initial}.bx--list-box__selection--multi:hover{outline:0}.bx--list-box__menu{box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));position:absolute;z-index:9100;right:0;left:0;width:100%;background-color:var(--cds-ui-01,#f4f4f4);overflow-y:auto;transition:max-height 110ms cubic-bezier(.2,0,.38,.9)}.bx--list-box__menu:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.bx--list-box__menu:focus{outline-style:dotted}}.bx--list-box .bx--list-box__field[aria-expanded=false]+.bx--list-box__menu{max-height:0}.bx--list-box--expanded .bx--list-box__menu{max-height:13.75rem}.bx--list-box--expanded.bx--list-box--lg .bx--list-box__menu,.bx--list-box--expanded.bx--list-box--xl .bx--list-box__menu{max-height:16.5rem}.bx--list-box--expanded.bx--list-box--sm .bx--list-box__menu{max-height:11rem}.bx--list-box__menu-item,:host(bx-dropdown-item){font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);position:relative;height:2.5rem;color:var(--cds-text-02,#525252);cursor:pointer;transition:background 70ms cubic-bezier(.2,0,.38,.9);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bx--list-box__menu-item:hover,:hover:host(bx-dropdown-item){background-color:var(--cds-hover-ui,#e5e5e5)}.bx--list-box__menu-item:active,:active:host(bx-dropdown-item){background-color:var(--cds-selected-ui,#e0e0e0)}.bx--list-box--light .bx--list-box__menu-item:hover,.bx--list-box--light :hover:host(bx-dropdown-item){background-color:var(--cds-hover-light-ui,#e5e5e5)}.bx--list-box--sm .bx--list-box__menu-item,.bx--list-box--sm :host(bx-dropdown-item){height:2rem}.bx--list-box--lg .bx--list-box__menu-item,.bx--list-box--lg :host(bx-dropdown-item),.bx--list-box--xl .bx--list-box__menu-item,.bx--list-box--xl :host(bx-dropdown-item){height:3rem}.bx--list-box--disabled .bx--list-box__menu-item:hover,.bx--list-box--disabled :hover:host(bx-dropdown-item){background-color:transparent}.bx--list-box--light .bx--list-box__menu-item:active,.bx--list-box--light :active:host(bx-dropdown-item){background-color:var(--cds-selected-light-ui,#e0e0e0)}.bx--list-box--disabled .bx--list-box__menu-item__option:hover{border-top-color:var(--cds-ui-03,#e0e0e0)}.bx--list-box__menu-item:first-of-type .bx--list-box__menu-item__option,:first-of-type:host(bx-dropdown-item) .bx--list-box__menu-item__option{border-top-color:transparent}.bx--list-box__menu-item:hover .bx--list-box__menu-item__option,:hover:host(bx-dropdown-item) .bx--list-box__menu-item__option{color:var(--cds-text-01,#161616)}.bx--list-box__menu-item:hover+.bx--list-box__menu-item .bx--list-box__menu-item__option,.bx--list-box__menu-item:hover+:host(bx-dropdown-item) .bx--list-box__menu-item__option,:hover:host(bx-dropdown-item)+.bx--list-box__menu-item .bx--list-box__menu-item__option,:hover:host(bx-dropdown-item)+:host(bx-dropdown-item) .bx--list-box__menu-item__option{border-top-color:transparent}.bx--list-box--disabled .bx--list-box__menu-item:hover+.bx--list-box__menu-item .bx--list-box__menu-item__option,.bx--list-box--disabled .bx--list-box__menu-item:hover+:host(bx-dropdown-item) .bx--list-box__menu-item__option,.bx--list-box--disabled :hover:host(bx-dropdown-item)+.bx--list-box__menu-item .bx--list-box__menu-item__option,.bx--list-box--disabled :hover:host(bx-dropdown-item)+:host(bx-dropdown-item) .bx--list-box__menu-item__option{border-top-color:var(--cds-ui-03,#e0e0e0)}.bx--list-box__menu-item__option{outline:2px solid transparent;outline-offset:-2px;display:block;overflow:hidden;height:2.5rem;padding:.6875rem 0;padding-right:1.5rem;border-top:1px solid transparent;border-top-color:var(--cds-ui-03,#e0e0e0);border-bottom:1px solid transparent;margin:0 1rem;color:var(--cds-text-02,#525252);font-weight:400;line-height:1rem;text-decoration:none;text-overflow:ellipsis;transition:border-color 70ms cubic-bezier(.2,0,.38,.9),color 70ms cubic-bezier(.2,0,.38,.9);white-space:nowrap}.bx--list-box__menu-item__option:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;padding:.6875rem 1rem;border-color:transparent;margin:0}@media screen and (prefers-contrast){.bx--list-box__menu-item__option:focus{outline-style:dotted}}.bx--list-box__menu-item__option:hover{border-color:transparent;color:var(--cds-text-01,#161616)}.bx--list-box--sm .bx--list-box__menu-item__option{height:2rem;padding-top:.4375rem;padding-bottom:.4375rem}.bx--list-box--lg .bx--list-box__menu-item__option,.bx--list-box--xl .bx--list-box__menu-item__option{height:3rem;padding-top:.9375rem;padding-bottom:.9375rem}.bx--list-box--disabled .bx--list-box__menu-item:hover .bx--list-box__menu-item__option,.bx--list-box--disabled .bx--list-box__menu-item__option{color:var(--cds-disabled-02,#c6c6c6)}.bx--list-box__menu-item[disabled],.bx--list-box__menu-item[disabled] *,.bx--list-box__menu-item[disabled] .bx--list-box__menu-item__option,.bx--list-box__menu-item[disabled]:hover,[disabled]:host(bx-dropdown-item),[disabled]:host(bx-dropdown-item) *,[disabled]:host(bx-dropdown-item) .bx--list-box__menu-item__option{color:var(--cds-disabled-02,#c6c6c6);cursor:not-allowed;outline:0}.bx--list-box__menu-item[disabled]:hover,[disabled]:hover:host(bx-dropdown-item){background-color:revert}.bx--list-box__menu-item[disabled] .bx--checkbox-label::before,[disabled]:host(bx-dropdown-item) .bx--checkbox-label::before{border-color:var(--cds-disabled-02,#c6c6c6)}.bx--list-box__menu-item[disabled] .bx--list-box__menu-item__option,[disabled]:host(bx-dropdown-item) .bx--list-box__menu-item__option{border-top-color:var(--cds-ui-03,#e0e0e0)}.bx--list-box__menu-item[disabled]:hover+.bx--list-box__menu-item .bx--list-box__menu-item__option,.bx--list-box__menu-item[disabled]:hover+:host(bx-dropdown-item) .bx--list-box__menu-item__option,[disabled]:hover:host(bx-dropdown-item)+.bx--list-box__menu-item .bx--list-box__menu-item__option,[disabled]:hover:host(bx-dropdown-item)+:host(bx-dropdown-item) .bx--list-box__menu-item__option{border-top-color:var(--cds-ui-03,#e0e0e0)}.bx--list-box.bx--list-box--inline .bx--list-box__menu-item__option{margin:0 .5rem}.bx--list-box.bx--list-box--inline .bx--list-box__menu-item__option:focus{padding-right:.5rem;padding-left:.5rem;margin:0}.bx--list-box__menu-item--highlighted,:host(bx-dropdown-item[highlighted]),:host(bx-dropdown-item[selected]){border-color:transparent;background-color:var(--cds-hover-ui,#e5e5e5);color:var(--cds-text-01,#161616)}.bx--list-box__menu-item--highlighted .bx--list-box__menu-item__option,.bx--list-box__menu-item--highlighted+.bx--list-box__menu-item .bx--list-box__menu-item__option,.bx--list-box__menu-item--highlighted+:host(bx-dropdown-item) .bx--list-box__menu-item__option,:host(bx-dropdown-item[highlighted]) .bx--list-box__menu-item__option,:host(bx-dropdown-item[highlighted])+.bx--list-box__menu-item .bx--list-box__menu-item__option,:host(bx-dropdown-item[highlighted])+:host(bx-dropdown-item) .bx--list-box__menu-item__option,:host(bx-dropdown-item[selected]) .bx--list-box__menu-item__option,:host(bx-dropdown-item[selected])+.bx--list-box__menu-item .bx--list-box__menu-item__option,:host(bx-dropdown-item[selected])+:host(bx-dropdown-item) .bx--list-box__menu-item__option{border-top-color:transparent}.bx--list-box__menu-item--highlighted .bx--list-box__menu-item__option,:host(bx-dropdown-item[highlighted]) .bx--list-box__menu-item__option,:host(bx-dropdown-item[selected]) .bx--list-box__menu-item__option{color:var(--cds-text-01,#161616)}.bx--list-box__menu-item--active,:host(bx-dropdown-item[selected]){border-bottom-color:var(--cds-selected-ui,#e0e0e0);background-color:var(--cds-selected-ui,#e0e0e0);color:var(--cds-text-01,#161616)}.bx--list-box--light .bx--list-box__menu-item--active,.bx--list-box--light :host(bx-dropdown-item[selected]){border-bottom-color:var(--cds-selected-light-ui,#e0e0e0);background-color:var(--cds-selected-light-ui,#e0e0e0)}.bx--list-box__menu-item--active.bx--list-box__menu-item--highlighted,.bx--list-box__menu-item--active:host(bx-dropdown-item[highlighted]),.bx--list-box__menu-item--active:hover,:host(bx-dropdown-item[selected]){border-bottom-color:var(--cds-hover-selected-ui,#cacaca);background-color:var(--cds-hover-selected-ui,#cacaca)}.bx--list-box__menu-item--active .bx--list-box__menu-item__option,:host(bx-dropdown-item[selected]) .bx--list-box__menu-item__option{color:var(--cds-text-01,#161616)}.bx--list-box__menu-item--active+.bx--list-box__menu-item>.bx--list-box__menu-item__option,.bx--list-box__menu-item--active+:host(bx-dropdown-item)>.bx--list-box__menu-item__option,:host(bx-dropdown-item[selected])+.bx--list-box__menu-item>.bx--list-box__menu-item__option,:host(bx-dropdown-item[selected])+:host(bx-dropdown-item)>.bx--list-box__menu-item__option{border-top-color:transparent}.bx--list-box__menu-item__selected-icon{position:absolute;top:50%;right:1rem;display:none;fill:var(--cds-icon-01,#161616);-webkit-transform:translateY(-50%);transform:translateY(-50%)}.bx--list-box--inline .bx--list-box__menu-item__selected-icon{right:.5rem}.bx--list-box__menu-item--active .bx--list-box__menu-item__selected-icon,:host(bx-dropdown-item[selected]) .bx--list-box__menu-item__selected-icon{display:block}.bx--list-box__menu-item .bx--checkbox-label,:host(bx-dropdown-item) .bx--checkbox-label{width:100%}.bx--list-box__menu-item .bx--checkbox-label-text,:host(bx-dropdown-item) .bx--checkbox-label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bx--list-box--up .bx--list-box__menu{bottom:2.5rem}.bx--list-box--up .bx--list-box--sm .bx--list-box__menu,.bx--list-box--up.bx--dropdown--sm .bx--list-box__menu,.bx--list-box--up.bx--list-box--sm .bx--list-box__menu{bottom:2rem}.bx--list-box--up .bx--list-box--lg .bx--list-box__menu,.bx--list-box--up.bx--dropdown--lg .bx--list-box__menu,.bx--list-box--up.bx--dropdown--xl .bx--list-box__menu,.bx--list-box--up.bx--list-box--lg .bx--list-box__menu,.bx--list-box--up.bx--list-box--xl .bx--list-box__menu{bottom:3rem}.bx--list-box input[role=combobox],.bx--list-box input[type=text]{min-width:0;background-color:inherit}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.bx--list-box__field,.bx--list-box__menu,.bx--multi-select .bx--tag--filter{outline:1px solid transparent}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.bx--list-box__field:focus,.bx--list-box__menu-item--highlighted .bx--list-box__menu-item__option,.bx--multi-select .bx--tag__close-icon:focus,:host(bx-dropdown-item[highlighted]) .bx--list-box__menu-item__option,:host(bx-dropdown-item[selected]) .bx--list-box__menu-item__option{color:Highlight;outline:1px solid Highlight}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.bx--list-box__menu-icon>svg,.bx--list-box__selection--multi>svg,.bx--list-box__selection>svg{fill:ButtonText}}.bx--fieldset{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;margin-bottom:2rem}.bx--fieldset *,.bx--fieldset ::after,.bx--fieldset ::before{box-sizing:inherit}.bx--fieldset--no-margin{margin-bottom:0}.bx--form-item{font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);display:flex;flex:1 1 auto;flex-direction:column;align-items:flex-start}.bx--label{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);line-height:var(--cds-label-01-line-height,1.33333);letter-spacing:var(--cds-label-01-letter-spacing,.32px);display:inline-block;margin-bottom:.5rem;color:var(--cds-text-02,#525252);font-weight:400;line-height:1rem;vertical-align:baseline}.bx--label *,.bx--label ::after,.bx--label ::before{box-sizing:inherit}.bx--label .bx--tooltip__trigger{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);line-height:var(--cds-label-01-line-height,1.33333);letter-spacing:var(--cds-label-01-letter-spacing,.32px)}.bx--label.bx--skeleton{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none;width:4.6875rem;height:.875rem}.bx--label.bx--skeleton:active,.bx--label.bx--skeleton:focus,.bx--label.bx--skeleton:hover{border:none;cursor:default;outline:0}.bx--label.bx--skeleton::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.bx--label.bx--skeleton::before{-webkit-animation:none;animation:none}}input[type=number]{font-family:'IBM Plex Mono',Menlo,'DejaVu Sans Mono','Bitstream Vera Sans Mono',Courier,monospace}.bx--combo-box[data-invalid] .bx--text-input:not(:focus),.bx--list-box[data-invalid]:not(:focus),.bx--number[data-invalid] input[type=number]:not(:focus),.bx--select-input__wrapper[data-invalid] .bx--select-input:not(:focus),.bx--text-area__wrapper[data-invalid]>.bx--text-area--invalid:not(:focus),.bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-01,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.bx--combo-box[data-invalid] .bx--text-input:not(:focus),.bx--list-box[data-invalid]:not(:focus),.bx--number[data-invalid] input[type=number]:not(:focus),.bx--select-input__wrapper[data-invalid] .bx--select-input:not(:focus),.bx--text-area__wrapper[data-invalid]>.bx--text-area--invalid:not(:focus),.bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.bx--date-picker-input__wrapper--invalid~.bx--form-requirement,.bx--date-picker-input__wrapper--warn~.bx--form-requirement,.bx--date-picker-input__wrapper~.bx--form-requirement,.bx--list-box--warning~.bx--form-requirement,.bx--list-box[data-invalid]~.bx--form-requirement,.bx--number[data-invalid] .bx--number__input-wrapper~.bx--form-requirement,.bx--number__input-wrapper--warning~.bx--form-requirement,.bx--select--warning .bx--select-input__wrapper~.bx--form-requirement,.bx--select-input__wrapper[data-invalid]~.bx--form-requirement,.bx--text-area__wrapper[data-invalid]~.bx--form-requirement,.bx--text-input__field-wrapper--warning>.bx--text-input~.bx--form-requirement,.bx--text-input__field-wrapper--warning~.bx--form-requirement,.bx--text-input__field-wrapper[data-invalid]~.bx--form-requirement,.bx--time-picker--invalid~.bx--form-requirement,.bx--time-picker[data-invalid]~.bx--form-requirement,input[data-invalid]~.bx--form-requirement{display:block;overflow:visible;max-height:12.5rem;font-weight:400}.bx--date-picker-input__wrapper--invalid~.bx--form-requirement,.bx--date-picker-input__wrapper~.bx--form-requirement,.bx--list-box[data-invalid]~.bx--form-requirement,.bx--number[data-invalid] .bx--number__input-wrapper~.bx--form-requirement,.bx--select-input__wrapper[data-invalid]~.bx--form-requirement,.bx--text-area__wrapper[data-invalid]~.bx--form-requirement,.bx--text-input__field-wrapper[data-invalid]~.bx--form-requirement,.bx--time-picker--invalid~.bx--form-requirement,.bx--time-picker[data-invalid]~.bx--form-requirement,input[data-invalid]~.bx--form-requirement{color:var(--cds-text-error,#da1e28)}.bx--form--fluid .bx--text-input__field-wrapper--warning,.bx--form--fluid .bx--text-input__field-wrapper[data-invalid]{display:block}.bx--form--fluid .bx--fieldset{margin:0}.bx--form--fluid input[data-invalid]{outline:0}.bx--form--fluid .bx--form-requirement{padding:.5rem 2.5rem .5rem 1rem;margin:0}input:not(output):not([data-invalid]):-moz-ui-invalid{box-shadow:none}.bx--form-requirement{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-caption-01-font-size,.75rem);font-weight:var(--cds-caption-01-font-weight,400);line-height:var(--cds-caption-01-line-height,1.33333);letter-spacing:var(--cds-caption-01-letter-spacing,.32px);display:none;overflow:hidden;max-height:0;margin:.25rem 0 0}.bx--form-requirement *,.bx--form-requirement ::after,.bx--form-requirement ::before{box-sizing:inherit}.bx--select--inline .bx--form__helper-text{margin-top:0}.bx--form__helper-text{font-size:var(--cds-helper-text-01-font-size,.75rem);line-height:var(--cds-helper-text-01-line-height,1.33333);letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);z-index:0;width:100%;margin-top:.25rem;color:var(--cds-text-02,#525252);opacity:1}.bx--form__helper-text--disabled,.bx--label--disabled{color:var(--cds-disabled-02,#c6c6c6)}fieldset[disabled] .bx--form__helper-text,fieldset[disabled] .bx--label{color:var(--cds-disabled-02,#c6c6c6)}.bx--form-item.bx--checkbox-wrapper{position:relative;margin-bottom:.25rem}.bx--form-item.bx--checkbox-wrapper:first-of-type{margin-top:.1875rem}.bx--label+.bx--form-item.bx--checkbox-wrapper{margin-top:-.125rem}.bx--form-item.bx--checkbox-wrapper:last-of-type{margin-bottom:.1875rem}.bx--checkbox{position:absolute;overflow:hidden;width:1px;height:1px;padding:0;border:0;margin:-1px;clip:rect(0,0,0,0);visibility:inherit;white-space:nowrap;top:1.25rem;left:.7rem}.bx--checkbox-label{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);position:relative;display:flex;min-height:1.5rem;padding-top:.1875rem;padding-left:1.25rem;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bx--checkbox-label *,.bx--checkbox-label ::after,.bx--checkbox-label ::before{box-sizing:inherit}.bx--checkbox-label-text{padding-left:.375rem}.bx--checkbox-label::after,.bx--checkbox-label::before{box-sizing:border-box}.bx--checkbox-label::before{position:absolute;top:.125rem;left:0;width:1rem;height:1rem;border:1px solid var(--cds-icon-01,#161616);margin:.125rem .125rem .125rem .1875rem;background-color:transparent;border-radius:1px;content:\"\"}.bx--checkbox-label::after{position:absolute;top:.5rem;left:.4375rem;width:.5625rem;height:.3125rem;border-bottom:2px solid var(--cds-inverse-01,#fff);border-left:2px solid var(--cds-inverse-01,#fff);margin-top:-.1875rem;background:0 0;content:\"\";-webkit-transform:scale(0) rotate(-45deg);transform:scale(0) rotate(-45deg);-webkit-transform-origin:bottom right;transform-origin:bottom right}.bx--checkbox-label[data-contained-checkbox-state=mixed]::before,.bx--checkbox-label[data-contained-checkbox-state=true]::before,.bx--checkbox:checked+.bx--checkbox-label::before,.bx--checkbox:indeterminate+.bx--checkbox-label::before{border-width:1px;border-color:var(--cds-icon-01,#161616);background-color:var(--cds-icon-01,#161616)}.bx--checkbox-label[data-contained-checkbox-state=true]::after,.bx--checkbox:checked+.bx--checkbox-label::after{-webkit-transform:scale(1) rotate(-45deg);transform:scale(1) rotate(-45deg)}.bx--checkbox-label[data-contained-checkbox-state=mixed]::after,.bx--checkbox:indeterminate+.bx--checkbox-label::after{top:.6875rem;width:.5rem;border-bottom:2px solid var(--cds-inverse-01,#fff);border-left:0 solid var(--cds-inverse-01,#fff);-webkit-transform:scale(1) rotate(0);transform:scale(1) rotate(0)}.bx--checkbox-label[data-contained-checkbox-state=mixed].bx--checkbox-label__focus::before,.bx--checkbox-label[data-contained-checkbox-state=true].bx--checkbox-label__focus::before,.bx--checkbox-label__focus::before,.bx--checkbox:checked:focus+.bx--checkbox-label::before,.bx--checkbox:focus+.bx--checkbox-label::before,.bx--checkbox:indeterminate:focus+.bx--checkbox-label::before{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:1px}.bx--checkbox-label[data-contained-checkbox-disabled=true],.bx--checkbox:disabled+.bx--checkbox-label{color:var(--cds-disabled-02,#c6c6c6);cursor:not-allowed}.bx--checkbox-label[data-contained-checkbox-disabled=true]::before,.bx--checkbox:disabled+.bx--checkbox-label::before{border-color:var(--cds-disabled-02,#c6c6c6)}.bx--checkbox-label[data-contained-checkbox-state=mixed][data-contained-checkbox-disabled=true]::before,.bx--checkbox-label[data-contained-checkbox-state=true][data-contained-checkbox-disabled=true]::before,.bx--checkbox:checked:disabled+.bx--checkbox-label::before,.bx--checkbox:indeterminate:disabled+.bx--checkbox-label::before{background-color:var(--cds-disabled-02,#c6c6c6)}.bx--checkbox-label-text.bx--skeleton{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none;width:6.25rem;height:var(--cds-spacing-05,1rem);margin:.0625rem 0 0 .375rem}.bx--checkbox-label-text.bx--skeleton:active,.bx--checkbox-label-text.bx--skeleton:focus,.bx--checkbox-label-text.bx--skeleton:hover{border:none;cursor:default;outline:0}.bx--checkbox-label-text.bx--skeleton::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.bx--checkbox-label-text.bx--skeleton::before{-webkit-animation:none;animation:none}}.bx--checkbox--inline{position:relative}.bx--tag{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;display:inline-block;padding:0;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;cursor:pointer;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);line-height:var(--cds-label-01-line-height,1.33333);letter-spacing:var(--cds-label-01-letter-spacing,.32px);background-color:var(--cds-tag-background-gray,#e0e0e0);color:var(--cds-tag-color-gray,#393939);display:inline-flex;min-width:2rem;max-width:100%;min-height:1.5rem;align-items:center;justify-content:center;padding:.25rem .5rem;margin:.25rem;border-radius:.9375rem;cursor:default;vertical-align:middle;word-break:break-word}.bx--tag *,.bx--tag ::after,.bx--tag ::before{box-sizing:inherit}.bx--tag::-moz-focus-inner{border:0}.bx--tag .bx--tag__close-icon:hover,.bx--tag.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-gray,#c6c6c6)}.bx--tag:not(:first-child){margin-left:0}.bx--tag--red{background-color:var(--cds-tag-background-red,#ffd7d9);color:var(--cds-tag-color-red,#750e13)}.bx--tag--red .bx--tag__close-icon:hover,.bx--tag--red.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-red,#ffb3b8)}.bx--tag--magenta{background-color:var(--cds-tag-background-magenta,#ffd6e8);color:var(--cds-tag-color-magenta,#740937)}.bx--tag--magenta .bx--tag__close-icon:hover,.bx--tag--magenta.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-magenta,#ffafd2)}.bx--tag--purple{background-color:var(--cds-tag-background-purple,#e8daff);color:var(--cds-tag-color-purple,#491d8b)}.bx--tag--purple .bx--tag__close-icon:hover,.bx--tag--purple.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-purple,#d4bbff)}.bx--tag--blue{background-color:var(--cds-tag-background-blue,#d0e2ff);color:var(--cds-tag-color-blue,#002d9c)}.bx--tag--blue .bx--tag__close-icon:hover,.bx--tag--blue.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-blue,#a6c8ff)}.bx--tag--cyan{background-color:var(--cds-tag-background-cyan,#bae6ff);color:var(--cds-tag-color-cyan,#003a6d)}.bx--tag--cyan .bx--tag__close-icon:hover,.bx--tag--cyan.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-cyan,#82cfff)}.bx--tag--teal{background-color:var(--cds-tag-background-teal,#9ef0f0);color:var(--cds-tag-color-teal,#004144)}.bx--tag--teal .bx--tag__close-icon:hover,.bx--tag--teal.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-teal,#3ddbd9)}.bx--tag--green{background-color:var(--cds-tag-background-green,#a7f0ba);color:var(--cds-tag-color-green,#044317)}.bx--tag--green .bx--tag__close-icon:hover,.bx--tag--green.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-green,#6fdc8c)}.bx--tag--gray{background-color:var(--cds-tag-background-gray,#e0e0e0);color:var(--cds-tag-color-gray,#393939)}.bx--tag--gray .bx--tag__close-icon:hover,.bx--tag--gray.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-gray,#c6c6c6)}.bx--tag--cool-gray{background-color:var(--cds-tag-background-cool-gray,#dde1e6);color:var(--cds-tag-color-cool-gray,#343a3f)}.bx--tag--cool-gray .bx--tag__close-icon:hover,.bx--tag--cool-gray.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-cool-gray,#c1c7cd)}.bx--tag--warm-gray{background-color:var(--cds-tag-background-warm-gray,#e5e0df);color:var(--cds-tag-color-warm-gray,#3c3838)}.bx--tag--warm-gray .bx--tag__close-icon:hover,.bx--tag--warm-gray.bx--tag--interactive:hover{background-color:var(--cds-tag-hover-warm-gray,#cac5c4)}.bx--tag--high-contrast{background-color:var(--cds-inverse-02,#393939);color:var(--cds-inverse-01,#fff)}.bx--tag--high-contrast .bx--tag__close-icon:hover,.bx--tag--high-contrast.bx--tag--interactive:hover{background-color:var(--cds-inverse-hover-ui,#4c4c4c)}.bx--tag--outline{background-color:var(--cds-background,#fff);color:var(--cds-text-01,#161616);box-shadow:inset 0 0 0 1px var(--cds-inverse-02,#393939)}.bx--tag--outline .bx--tag__close-icon:hover,.bx--tag--outline.bx--tag--interactive:hover{background-color:var(--cds-hover-ui,#e5e5e5)}.bx--tag--disabled,.bx--tag--filter.bx--tag--disabled,.bx--tag--interactive.bx--tag--disabled{background-color:var(--cds-disabled-01,#f4f4f4);color:var(--cds-disabled-02,#c6c6c6)}.bx--tag--disabled .bx--tag__close-icon:hover,.bx--tag--disabled.bx--tag--interactive:hover,.bx--tag--filter.bx--tag--disabled .bx--tag__close-icon:hover,.bx--tag--filter.bx--tag--disabled.bx--tag--interactive:hover,.bx--tag--interactive.bx--tag--disabled .bx--tag__close-icon:hover,.bx--tag--interactive.bx--tag--disabled.bx--tag--interactive:hover{background-color:var(--cds-disabled-01,#f4f4f4)}.bx--tag--disabled:hover,.bx--tag--filter.bx--tag--disabled:hover,.bx--tag--interactive.bx--tag--disabled:hover{cursor:not-allowed}.bx--tag__label{overflow:hidden;max-width:100%;text-overflow:ellipsis;white-space:nowrap}.bx--tag--interactive:focus{box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe);outline:0}.bx--tag--interactive:hover{cursor:pointer}.bx--tag--filter{padding-top:0;padding-right:0;padding-bottom:0;cursor:pointer}.bx--tag--filter:hover{outline:0}.bx--tag--interactive{transition:background-color 70ms cubic-bezier(0,0,.38,.9)}.bx--tag__close-icon{display:flex;width:1.5rem;height:1.5rem;flex-shrink:0;align-items:center;justify-content:center;padding:0;border:0;margin:0 0 0 .125rem;background-color:transparent;border-radius:50%;color:currentColor;cursor:pointer;transition:background-color 70ms cubic-bezier(.2,0,.38,.9),box-shadow 70ms cubic-bezier(.2,0,.38,.9)}.bx--tag__close-icon svg{fill:currentColor}.bx--tag__custom-icon{width:1rem;height:1rem;flex-shrink:0;padding:0;border:0;margin-right:var(--cds-spacing-02,.25rem);background-color:transparent;color:currentColor;outline:0}.bx--tag__custom-icon svg{fill:currentColor}.bx--tag--disabled .bx--tag__close-icon{cursor:not-allowed}.bx--tag__close-icon:focus{border-radius:50%;box-shadow:inset 0 0 0 1px var(--cds-focus,#0f62fe);outline:0}.bx--tag--high-contrast .bx--tag__close-icon:focus{box-shadow:inset 0 0 0 1px var(--cds-inverse-focus-ui,#fff)}.bx--tag--filter.bx--tag--disabled .bx--tag__close-icon:hover{background-color:transparent}.bx--tag--filter.bx--tag--disabled svg{fill:var(--cds-disabled-02,#c6c6c6)}.bx--tag--sm{min-height:1.125rem;padding:0 .5rem}.bx--tag--sm.bx--tag--filter{padding-right:0}.bx--tag--sm .bx--tag__close-icon{width:1.125rem;height:1.125rem;margin-left:.3125rem}.bx--tag.bx--skeleton{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none;background-color:var(--cds-skeleton-01,#e5e5e5);color:var(--cds-text-01,#161616);overflow:hidden;width:3.75rem}.bx--tag.bx--skeleton:active,.bx--tag.bx--skeleton:focus,.bx--tag.bx--skeleton:hover{border:none;cursor:default;outline:0}.bx--tag.bx--skeleton::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.bx--tag.bx--skeleton::before{-webkit-animation:none;animation:none}}.bx--tag.bx--skeleton .bx--tag__close-icon:hover,.bx--tag.bx--skeleton.bx--tag--interactive:hover{background-color:var(--cds-skeleton-01,#e5e5e5)}@media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){.bx--tag.bx--skeleton{-webkit-transform:translateZ(0);transform:translateZ(0)}}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.bx--tag{outline:1px solid transparent}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.bx--tag__close-icon svg,.bx--tag__custom-icon svg{fill:ButtonText}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.bx--tag__close-icon:focus{color:Highlight;outline:1px solid Highlight}}:host(bx-dropdown){outline:0}:host(bx-dropdown) .bx--assistive-text{left:-100%;top:-100%}:host(bx-dropdown) .bx--label[hidden]{display:none}:host(bx-dropdown) .bx--list-box__menu{top:100%;margin-top:1px}:host(bx-dropdown-item){display:block}:host(bx-dropdown-item) .bx--list-box__menu-item__option{height:100%}:host(bx-dropdown-item[size=sm]){height:2rem}:host(bx-dropdown-item[size=sm]) .bx--list-box__menu-item__option{padding-top:.4375rem;padding-bottom:.4375rem}:host(bx-dropdown-item[size=xl]){height:3rem}:host(bx-dropdown-item[size=xl]) .bx--list-box__menu-item__option{padding-top:.9375rem;padding-bottom:.9375rem}:host(bx-dropdown-item[disabled]) .bx--list-box__menu-item__option{color:var(--cds-disabled-02,#c6c6c6);text-decoration:none}:host(bx-dropdown-item[selected]) .bx--list-box__menu-item__option{color:var(--cds-text-01,#161616)}:host(bx-dropdown-item[selected]) .bx--list-box__menu-item__selected-icon{display:block}:host(bx-dropdown-skeleton) .bx--skeleton{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none}:host(bx-dropdown-skeleton) .bx--skeleton:active,:host(bx-dropdown-skeleton) .bx--skeleton:focus,:host(bx-dropdown-skeleton) .bx--skeleton:hover{border:none;cursor:default;outline:0}:host(bx-dropdown-skeleton) .bx--skeleton::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(bx-dropdown-skeleton) .bx--skeleton::before{-webkit-animation:none;animation:none}}"
]);

});


parcelRegister("c0DJa", function(module, exports) {

var $kZ0tv = parcelRequire("kZ0tv");

var $jpdgO = parcelRequire("jpdgO");
parcelRequire("3eEWe");
var $2pFDC = parcelRequire("2pFDC");
var $3tvu5 = parcelRequire("3tvu5");
var $3eEWe = parcelRequire("3eEWe");

var $fRRNO = parcelRequire("fRRNO");
parcelRequire("4mXm7");
var $5Wl2V = parcelRequire("5Wl2V");

var $7vLeM = parcelRequire("7vLeM");
let $8be44d2baca3bc50$var$_ = (t)=>t, $8be44d2baca3bc50$var$_t;
const { prefix: $8be44d2baca3bc50$var$prefix } = (0, $jpdgO.default);
/**
 * Dropdown item.
 * @element bx-dropdown-item
 * @csspart selected-icon The selected icon.
 */ let $8be44d2baca3bc50$var$BXDropdownItem = (0, $kZ0tv.default)([
    (0, $2pFDC.customElement)(`${$8be44d2baca3bc50$var$prefix}-dropdown-item`)
], function(_initialize, _LitElement) {
    class BXDropdownItem extends _LitElement {
        constructor(...args){
            super(...args);
            _initialize(this);
        }
    }
    return {
        F: BXDropdownItem,
        d: [
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "disabled",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "highlighted",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "selected",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "size",
                value () {
                    return (0, $5Wl2V.DROPDOWN_SIZE).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "value",
                value () {
                    return '';
                }
            },
            {
                kind: "method",
                key: "render",
                value: /**
       * `true` if this dropdown item should be disabled.
       */ /**
       * `true` if this dropdown item should be highlighted.
       * If `true`, parent `<dropdown>` selects/deselects this dropdown item upon keyboard interaction.
       * @private
       */ /**
       * `true` if this dropdown item should be selected.
       * @private
       */ /**
       * Dropdown size.
       */ /**
       * The `value` attribute that is set to the parent `<bx-dropdown>` when this dropdown item is selected.
       */ function render() {
                    const { selected: selected } = this;
                    return (0, $3tvu5.html)($8be44d2baca3bc50$var$_t || ($8be44d2baca3bc50$var$_t = $8be44d2baca3bc50$var$_` <div class="${0}--list-box__menu-item__option"> <slot></slot> ${0} </div> `), $8be44d2baca3bc50$var$prefix, !selected ? undefined : (0, $fRRNO.default)({
                        part: 'selected-icon',
                        class: `${$8be44d2baca3bc50$var$prefix}--list-box__menu-item__selected-icon`
                    }));
                }
            },
            {
                kind: "field",
                static: true,
                key: "styles",
                value () {
                    return 0, $7vLeM.default;
                }
            }
        ]
    };
}, (0, $3eEWe.LitElement));
var $8be44d2baca3bc50$export$2e2bcd8739ae039 = $8be44d2baca3bc50$var$BXDropdownItem;

});
parcelRegister("fRRNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d58a4504820300$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $3tvu5 = parcelRequire("3tvu5");

var $fxyjq = parcelRequire("fxyjq");
const $b8d58a4504820300$var$svgResultCarbonIcon = ({ children: children, ...attrs } = {})=>(0, $3tvu5.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, $fxyjq.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}${children}${children}<path d="M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"></path></svg>`;
var $b8d58a4504820300$export$2e2bcd8739ae039 = $b8d58a4504820300$var$svgResultCarbonIcon;

});


parcelRegister("c9KPE", function(module, exports) {

var $kZ0tv = parcelRequire("kZ0tv");

var $45rw6 = parcelRequire("45rw6");

var $6MXSA = parcelRequire("6MXSA");
parcelRequire("3eEWe");
var $2pFDC = parcelRequire("2pFDC");
var $3tvu5 = parcelRequire("3tvu5");
var $3eEWe = parcelRequire("3eEWe");

var $iEbjw = parcelRequire("iEbjw");

var $jpdgO = parcelRequire("jpdgO");

var $6Ia5q = parcelRequire("6Ia5q");

var $498Lv = parcelRequire("498Lv");

var $hfEKd = parcelRequire("hfEKd");

var $8Oi6a = parcelRequire("8Oi6a");

var $9bapU = parcelRequire("9bapU");

var $eGC8Y = parcelRequire("eGC8Y");

var $2yINf = parcelRequire("2yINf");

var $4v7hI = parcelRequire("4v7hI");

var $xYt50 = parcelRequire("xYt50");

var $gJjga = parcelRequire("gJjga");

var $9fzAO = parcelRequire("9fzAO");

var $bmkho = parcelRequire("bmkho");

var $1nf84 = parcelRequire("1nf84");

var $fzJHB = parcelRequire("fzJHB");
let $8d9aa72fe890d3b4$var$_ = (t)=>t, $8d9aa72fe890d3b4$var$_t;
const { prefix: $8d9aa72fe890d3b4$var$prefix } = (0, $jpdgO.default);
/**
 * Date picker modes.
 */ var $8d9aa72fe890d3b4$var$DATE_PICKER_MODE;
/**
 * Date picker.
 * @element bx-date-picker
 * @fires bx-date-picker-changed - The custom event fired on this element when Flatpickr updates its value.
 */ (function(DATE_PICKER_MODE) {
    DATE_PICKER_MODE["SIMPLE"] = "simple";
    DATE_PICKER_MODE["SINGLE"] = "single";
    DATE_PICKER_MODE["RANGE"] = "range";
})($8d9aa72fe890d3b4$var$DATE_PICKER_MODE || ($8d9aa72fe890d3b4$var$DATE_PICKER_MODE = {}));
let $8d9aa72fe890d3b4$var$BXDatePicker = (0, $kZ0tv.default)([
    (0, $2pFDC.customElement)(`${$8d9aa72fe890d3b4$var$prefix}-date-picker`)
], function(_initialize, _HostListenerMixin) {
    class BXDatePicker extends _HostListenerMixin {
        constructor(...args){
            super(...args);
            _initialize(this);
        }
    }
    return {
        F: BXDatePicker,
        d: [
            {
                kind: "field",
                key: "_dateInteractNode",
                value () {
                    return null;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.query)('#floating-menu-container')
                ],
                key: "_floatingMenuContainerNode",
                value: void 0
            },
            {
                kind: "get",
                key: "_mode",
                value: /**
       * The slotted `<bx-date-input kind="from">`.
       */ /**
       * The element to put calendar dropdown in.
       */ /**
       * @returns The effective date picker mode, determined by the child `<bx-date-picker-input>`.
       */ function _mode() {
                    const { selectorInputFrom: selectorInputFrom, selectorInputTo: selectorInputTo } = this.constructor;
                    if (this.querySelector(selectorInputTo)) return $8d9aa72fe890d3b4$var$DATE_PICKER_MODE.RANGE;
                    if (this.querySelector(selectorInputFrom)) return $8d9aa72fe890d3b4$var$DATE_PICKER_MODE.SINGLE;
                    return $8d9aa72fe890d3b4$var$DATE_PICKER_MODE.SIMPLE;
                }
            },
            {
                kind: "get",
                key: "_datePickerPlugins",
                value: function _datePickerPlugins() {
                    const { classCalendarContainer: classCalendarContainer, classMonth: classMonth, classWeekdays: classWeekdays, classDays: classDays, classWeekday: classWeekday, classDay: classDay, classNoBorder: classNoBorder, selectorInputFrom: selectorInputFrom, selectorInputTo: selectorInputTo, _selectorFlatpickrMonthYearContainer: selectorFlatpickrMonthYearContainer, _selectorFlatpickrYearContainer: selectorFlatpickrYearContainer, _selectorFlatpickrCurrentMonth: selectorFlatpickrCurrentMonth, _selectorFlatpickrMonth: selectorFlatpickrMonth, _selectorFlatpickrWeekdays: selectorFlatpickrWeekdays, _selectorFlatpickrDays: selectorFlatpickrDays, _selectorFlatpickrWeekday: selectorFlatpickrWeekday, _selectorFlatpickrDay: selectorFlatpickrDay, _classFlatpickrCurrentMonth: classFlatpickrCurrentMonth, _classFlatpickrToday: classFlatpickrToday } = this.constructor;
                    const { _floatingMenuContainerNode: floatingMenuContainerNode, _mode: mode } = this;
                    const inputFrom = this.querySelector(selectorInputFrom);
                    const inputTo = this.querySelector(selectorInputTo);
                    const plugins = [
                        (0, $9bapU.default)({
                            appendTo: floatingMenuContainerNode
                        }),
                        (0, $eGC8Y.default)({
                            classCalendarContainer: classCalendarContainer,
                            classMonth: classMonth,
                            classWeekdays: classWeekdays,
                            classDays: classDays,
                            classWeekday: classWeekday,
                            classDay: classDay,
                            classNoBorder: classNoBorder,
                            selectorFlatpickrMonth: selectorFlatpickrMonth,
                            selectorFlatpickrWeekdays: selectorFlatpickrWeekdays,
                            selectorFlatpickrDays: selectorFlatpickrDays,
                            selectorFlatpickrWeekday: selectorFlatpickrWeekday,
                            selectorFlatpickrDay: selectorFlatpickrDay,
                            classFlatpickrToday: classFlatpickrToday
                        }),
                        (0, $2yINf.default)({
                            inputFrom: inputFrom,
                            inputTo: inputTo
                        }),
                        (0, $4v7hI.default)({
                            inputFrom: inputFrom,
                            inputTo: inputTo
                        }),
                        (0, $xYt50.default)(),
                        (0, $gJjga.default)({
                            selectorFlatpickrMonthYearContainer: selectorFlatpickrMonthYearContainer,
                            selectorFlatpickrYearContainer: selectorFlatpickrYearContainer,
                            selectorFlatpickrCurrentMonth: selectorFlatpickrCurrentMonth,
                            classFlatpickrCurrentMonth: classFlatpickrCurrentMonth
                        }),
                        (0, $bmkho.default)(),
                        (0, $1nf84.default)(this)
                    ];
                    if (mode === $8d9aa72fe890d3b4$var$DATE_PICKER_MODE.RANGE) // Flatpickr runs event handlers of last registered plugins first.
                    // Ensures `onValueUpdate` of `rangePlugin` runs first
                    // given Flatpickr puts `01/01/1970 to 01/02/1970` to from date
                    // where `rangePlugin` overrides it to separate them to from/to dates.
                    // We want to ensure our handler of `onValueUpdate` (notably one in `<bx-date-picker-input>`)
                    // gets the `<input>` value set by `rangePlugin` instead of Flatpickr core.
                    plugins.push((0, $9fzAO.default)({
                        input: inputTo
                    }));
                    return plugins;
                }
            },
            {
                kind: "get",
                key: "_datePickerOptions",
                value: function _datePickerOptions() {
                    var _this$dateFormat;
                    const { locale: locale = this.constructor.defaultLocale, enabledRange: enabledRange, _dateInteractNode: dateInteractNode, _datePickerPlugins: plugins, _handleFlatpickrError: handleFlatpickrError } = this; // We use `<bx-date-picker-input>` to communicate values/events with Flatpickr,
                    // but want to use `<input>` in shadow DOM to base the calendar dropdown's position on
                    const { input: positionElement } = dateInteractNode;
                    const [minDate, maxDate] = !enabledRange ? [] : enabledRange.split('/');
                    return {
                        allowInput: true,
                        dateFormat: (_this$dateFormat = this.dateFormat) !== null && _this$dateFormat !== void 0 ? _this$dateFormat : this.constructor.defaultDateFormat,
                        disableMobile: true,
                        errorHandler: handleFlatpickrError,
                        locale: locale,
                        maxDate: maxDate,
                        minDate: minDate,
                        positionElement: positionElement,
                        plugins: plugins
                    };
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $hfEKd.default)('eventChange')
                ],
                key: "_handleChange",
                value () {
                    return ({ detail: detail })=>{
                        this._value = detail.selectedDates.map((date)=>(0, $8Oi6a.getISODateString)(date)).join('/');
                    };
                }
            },
            {
                kind: "method",
                key: "_handleFormdata",
                value: function _handleFormdata(event) {
                    const { formData: formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
                    const { disabled: disabled, name: name, value: value } = this;
                    if (!disabled) formData.append(name, value);
                }
            },
            {
                kind: "method",
                key: "_handleSlotChange",
                value: function _handleSlotChange({ target: target }) {
                    const { _dateInteractNode: oldDateInteractNode } = this;
                    const dateInteractNode = target.assignedNodes().find((node)=>node.nodeType === Node.ELEMENT_NODE && node.matches(this.constructor.selectorInputFrom));
                    if (oldDateInteractNode !== dateInteractNode) {
                        this._dateInteractNode = dateInteractNode;
                        this._instantiateDatePicker();
                    }
                }
            },
            {
                kind: "field",
                key: "_handleFlatpickrError",
                value () {
                    return (error)=>{
                        this.dispatchEvent(new CustomEvent(this.constructor.eventFlatpickrError, {
                            bubbles: true,
                            cancelable: false,
                            composed: true,
                            detail: {
                                error: error
                            }
                        }));
                    };
                }
            },
            {
                kind: "method",
                key: "_instantiateDatePicker",
                value: /**
       * Instantiates Flatpickr.
       * @returns The Flatpickr instance.
       */ function _instantiateDatePicker() {
                    this._releaseDatePicker();
                    const { _dateInteractNode: dateInteractNode } = this; // `this._dateInteractNode` won't be there unless there is a slotted `<bx-date-input type="from">`,
                    // which means Flatpickr will never be instantiated in "simple" mode.
                    if (dateInteractNode && dateInteractNode.input) this.calendar = (0, (/*@__PURE__*/$parcel$interopDefault($iEbjw)))(dateInteractNode, this._datePickerOptions);
                    return this.calendar;
                }
            },
            {
                kind: "method",
                key: "_releaseDatePicker",
                value: function _releaseDatePicker() {
                    if (this.calendar) {
                        this.calendar.destroy();
                        this.calendar = null;
                    }
                    return this.calendar;
                }
            },
            {
                kind: "field",
                key: "calendar",
                value () {
                    return null;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'date-format'
                    })
                ],
                key: "dateFormat",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "disabled",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: false
                    })
                ],
                key: "locale",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'enabled-range'
                    })
                ],
                key: "enabledRange",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "name",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "open",
                value () {
                    return false;
                }
            },
            {
                kind: "get",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "value",
                value: /**
       * The date format to let Flatpickr use.
       */ /**
       * Controls the disabled state of the input
       */ /**
       * The localization data.
       */ /**
       * The date range that a user can pick in calendar dropdown.
       */ /**
       * Name for the input in the `FormData`
       */ /**
       * `true` if the date picker should be open.
       */ /**
       * The date(s) in ISO8601 format (date portion only), for range mode, '/' is used for separate start/end dates.
       */ function value() {
                    return this._value;
                }
            },
            {
                kind: "set",
                key: "value",
                value: function value(_value) {
                    const { _value: oldValue } = this;
                    this._value = _value;
                    this.requestUpdate('value', oldValue);
                }
            },
            {
                kind: "method",
                key: "connectedCallback",
                value: function connectedCallback() {
                    (0, $45rw6.default)((0, $6MXSA.default)(BXDatePicker.prototype), "connectedCallback", this).call(this);
                    this._instantiateDatePicker();
                }
            },
            {
                kind: "method",
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    this._releaseDatePicker();
                    (0, $45rw6.default)((0, $6MXSA.default)(BXDatePicker.prototype), "disconnectedCallback", this).call(this);
                }
            },
            {
                kind: "method",
                key: "updated",
                value: function updated(changedProperties) {
                    const { calendar: calendar, disabled: disabled, open: open } = this;
                    const { selectorInputFrom: selectorInputFrom, selectorInputTo: selectorInputTo } = this.constructor;
                    const inputFrom = this.querySelector(selectorInputFrom);
                    const inputTo = this.querySelector(selectorInputTo);
                    if (calendar && changedProperties.has('dateFormat')) {
                        const { dateFormat: dateFormat } = this;
                        calendar.set({
                            dateFormat: dateFormat
                        });
                    }
                    if (changedProperties.has('enabledRange')) {
                        const { enabledRange: enabledRange } = this;
                        const dates = enabledRange.split('/').map((item)=>!item ? undefined : (0, $8Oi6a.parseISODateString)(item)); // Allows empty start/end
                        if (dates.some((item)=>Boolean(item && isNaN(Number(item))))) // Allows empty start/end
                        throw new Error(`Wrong date format found in \`enabledRange\` property: ${enabledRange}`);
                        const [minDate, maxDate] = dates;
                        if (minDate && maxDate && minDate > maxDate) throw new Error(`In \`enabledRange\` property, the end date shouldn't be smaller than the start date. You have: ${enabledRange}`);
                        if (calendar) calendar.set({
                            minDate: minDate,
                            maxDate: maxDate
                        });
                    }
                    if (changedProperties.has('open') && calendar) {
                        if (open) calendar.open();
                        else calendar.close();
                    }
                    if (changedProperties.has('disabled')) [
                        inputFrom,
                        inputTo
                    ].forEach((input)=>{
                        if (input) input.disabled = disabled;
                    });
                    if (changedProperties.has('value')) {
                        const { value: value } = this;
                        const dates = value.split('/').filter(Boolean).map((item)=>(0, $8Oi6a.parseISODateString)(item));
                        if (dates.some((item)=>isNaN(Number(item)))) throw new Error(`Wrong date format found in \`value\` property: ${value}`);
                        const [startDate, endDate] = dates;
                        if (startDate && endDate && startDate > endDate) throw new Error(`In \`value\` property, the end date shouldn't be smaller than the start date. You have: ${value}`);
                        if (calendar) {
                            calendar.setDate(dates);
                            [
                                inputFrom,
                                inputTo
                            ].forEach((input, i)=>{
                                if (input) input.value = !dates[i] ? '' : calendar.formatDate(new Date(dates[i]), calendar.config.dateFormat);
                            });
                        }
                    }
                }
            },
            {
                kind: "method",
                key: "render",
                value: function render() {
                    const { _handleSlotChange: handleSlotChange } = this;
                    return (0, $3tvu5.html)($8d9aa72fe890d3b4$var$_t || ($8d9aa72fe890d3b4$var$_t = $8d9aa72fe890d3b4$var$_` <a class="${0}--visually-hidden" href="javascript:void 0" role="navigation"></a> <slot @slotchange="${0}"></slot> <div id="floating-menu-container"></div> <a class="${0}--visually-hidden" href="javascript:void 0" role="navigation"></a> `), $8d9aa72fe890d3b4$var$prefix, handleSlotChange, $8d9aa72fe890d3b4$var$prefix);
                }
            },
            {
                kind: "field",
                static: true,
                key: "_selectorFlatpickrMonthYearContainer",
                value () {
                    return '.flatpickr-current-month';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_selectorFlatpickrYearContainer",
                value () {
                    return '.numInputWrapper';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_selectorFlatpickrCurrentMonth",
                value () {
                    return '.cur-month';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_selectorFlatpickrMonth",
                value () {
                    return '.flatpickr-month';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_selectorFlatpickrWeekdays",
                value () {
                    return '.flatpickr-weekdays';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_selectorFlatpickrDays",
                value () {
                    return '.flatpickr-days';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_selectorFlatpickrWeekday",
                value () {
                    return '.flatpickr-weekday';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_selectorFlatpickrDay",
                value () {
                    return '.flatpickr-day';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_classFlatpickrCurrentMonth",
                value () {
                    return 'cur-month';
                }
            },
            {
                kind: "field",
                static: true,
                key: "_classFlatpickrToday",
                value () {
                    return 'today';
                }
            },
            {
                kind: "get",
                static: true,
                key: "classCalendarContainer",
                value: /**
       * The CSS selector for Flatpickr's year portion.
       */ /**
       * The CSS selector for the inner element of Flatpickr's month portion.
       */ /**
       * The CSS selector for Flatpickr's month navigator.
       */ /**
       * The CSS selector for Flatpickr's container of the weekdays.
       */ /**
       * The CSS selector for Flatpickr's container of the days.
       */ /**
       * The CSS selector applied to Flatpickr's each weekdays.
       */ /**
       * The CSS selector applied to Flatpickr's each days.
       */ /**
       * The CSS class for the inner element of Flatpickr's month portion.
       */ /**
       * The CSS class applied to Flatpickr's "today" highlight.
       */ /**
       * The CSS class for the calendar dropdown.
       */ function classCalendarContainer() {
                    return `${$8d9aa72fe890d3b4$var$prefix}--date-picker__calendar`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "classMonth",
                value: function classMonth() {
                    return `${$8d9aa72fe890d3b4$var$prefix}--date-picker__month`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "classWeekdays",
                value: function classWeekdays() {
                    return `${$8d9aa72fe890d3b4$var$prefix}--date-picker__weekdays`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "classDays",
                value: function classDays() {
                    return `${$8d9aa72fe890d3b4$var$prefix}--date-picker__days`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "classWeekday",
                value: function classWeekday() {
                    return `${$8d9aa72fe890d3b4$var$prefix}--date-picker__weekday`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "classDay",
                value: function classDay() {
                    return `${$8d9aa72fe890d3b4$var$prefix}--date-picker__day`;
                }
            },
            {
                kind: "field",
                static: true,
                key: "classNoBorder",
                value () {
                    return 'no-border';
                }
            },
            {
                kind: "field",
                static: true,
                key: "defaultDateFormat",
                value () {
                    return 'm/d/Y';
                }
            },
            {
                kind: "field",
                static: true,
                key: "defaultLocale",
                value () {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($iEbjw))).l10ns.default;
                }
            },
            {
                kind: "get",
                static: true,
                key: "selectorInputFrom",
                value: /**
       * The default date format.
       */ /**
       * The default localization data.
       */ /**
       * A selector that will return the `<input>` to enter starting date.
       */ function selectorInputFrom() {
                    return `${$8d9aa72fe890d3b4$var$prefix}-date-picker-input[kind="single"],${$8d9aa72fe890d3b4$var$prefix}-date-picker-input[kind="from"]`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "selectorInputTo",
                value: function selectorInputTo() {
                    return `${$8d9aa72fe890d3b4$var$prefix}-date-picker-input[kind="to"]`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "eventFlatpickrError",
                value: function eventFlatpickrError() {
                    return `${$8d9aa72fe890d3b4$var$prefix}-date-picker-flatpickr-error`;
                }
            },
            {
                kind: "get",
                static: true,
                key: "eventChange",
                value: function eventChange() {
                    return `${$8d9aa72fe890d3b4$var$prefix}-date-picker-changed`;
                }
            },
            {
                kind: "field",
                static: true,
                key: "styles",
                value () {
                    return 0, $fzJHB.default;
                }
            }
        ]
    };
}, (0, $498Lv.default)((0, $6Ia5q.default)((0, $3eEWe.LitElement))));
var $8d9aa72fe890d3b4$export$2e2bcd8739ae039 = $8d9aa72fe890d3b4$var$BXDatePicker;

});
parcelRegister("45rw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f9cf94c93755b2c$export$2e2bcd8739ae039);

var $gJayy = parcelRequire("gJayy");
function $2f9cf94c93755b2c$export$2e2bcd8739ae039() {
    if (typeof Reflect !== "undefined" && Reflect.get) $2f9cf94c93755b2c$export$2e2bcd8739ae039 = Reflect.get.bind();
    else $2f9cf94c93755b2c$export$2e2bcd8739ae039 = function _get(target, property, receiver) {
        var base = (0, $gJayy.default)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $2f9cf94c93755b2c$export$2e2bcd8739ae039.apply(this, arguments);
}

});
parcelRegister("gJayy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2d90999bc2241fc$export$2e2bcd8739ae039);

var $6MXSA = parcelRequire("6MXSA");
function $c2d90999bc2241fc$export$2e2bcd8739ae039(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $6MXSA.default)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRegister("6MXSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $01468b0a8d8464d6$export$2e2bcd8739ae039);
function $01468b0a8d8464d6$export$2e2bcd8739ae039(o) {
    $01468b0a8d8464d6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $01468b0a8d8464d6$export$2e2bcd8739ae039(o);
}

});



parcelRegister("iEbjw", function(module, exports) {
/* flatpickr v4.6.1, @license MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */ var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var HOOKS = [
        "onChange",
        "onClose",
        "onDayCreate",
        "onDestroy",
        "onKeyDown",
        "onMonthChange",
        "onOpen",
        "onParseConfig",
        "onReady",
        "onValueUpdate",
        "onYearChange",
        "onPreCalendarPosition"
    ];
    var defaults = {
        _disable: [],
        _enable: [],
        allowInput: false,
        altFormat: "F j, Y",
        altInput: false,
        altInputClass: "form-control input",
        animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
        ariaDateFormat: "F j, Y",
        clickOpens: true,
        closeOnSelect: true,
        conjunction: ", ",
        dateFormat: "Y-m-d",
        defaultHour: 12,
        defaultMinute: 0,
        defaultSeconds: 0,
        disable: [],
        disableMobile: false,
        enable: [],
        enableSeconds: false,
        enableTime: false,
        errorHandler: function(err) {
            return typeof console !== "undefined" && console.warn(err);
        },
        getWeek: function(givenDate) {
            var date = new Date(givenDate.getTime());
            date.setHours(0, 0, 0, 0);
            // Thursday in current week decides the year.
            date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
            // January 4 is always in week 1.
            var week1 = new Date(date.getFullYear(), 0, 4);
            // Adjust to Thursday in week 1 and count number of weeks from date to week1.
            return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
        },
        hourIncrement: 1,
        ignoredFocusElements: [],
        inline: false,
        locale: "default",
        minuteIncrement: 5,
        mode: "single",
        nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
        noCalendar: false,
        now: new Date(),
        onChange: [],
        onClose: [],
        onDayCreate: [],
        onDestroy: [],
        onKeyDown: [],
        onMonthChange: [],
        onOpen: [],
        onParseConfig: [],
        onReady: [],
        onValueUpdate: [],
        onYearChange: [],
        onPreCalendarPosition: [],
        plugins: [],
        position: "auto",
        positionElement: undefined,
        prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
        shorthandCurrentMonth: false,
        showMonths: 1,
        static: false,
        time_24hr: false,
        weekNumbers: false,
        wrap: false
    };
    var english = {
        weekdays: {
            shorthand: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            longhand: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            longhand: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ]
        },
        daysInMonth: [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ],
        firstDayOfWeek: 0,
        ordinal: function(nth) {
            var s = nth % 100;
            if (s > 3 && s < 21) return "th";
            switch(s % 10){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        },
        rangeSeparator: " to ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        amPM: [
            "AM",
            "PM"
        ],
        yearAriaLabel: "Year",
        time_24hr: false
    };
    var pad = function(number) {
        return ("0" + number).slice(-2);
    };
    var int = function(bool) {
        return bool === true ? 1 : 0;
    };
    /* istanbul ignore next */ function debounce(func, wait, immediate) {
        if (immediate === void 0) immediate = false;
        var timeout;
        return function() {
            var context = this, args = arguments;
            timeout !== null && clearTimeout(timeout);
            timeout = window.setTimeout(function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            }, wait);
            if (immediate && !timeout) func.apply(context, args);
        };
    }
    var arrayify = function(obj) {
        return obj instanceof Array ? obj : [
            obj
        ];
    };
    function toggleClass(elem, className, bool) {
        if (bool === true) return elem.classList.add(className);
        elem.classList.remove(className);
    }
    function createElement(tag, className, content) {
        var e = window.document.createElement(tag);
        className = className || "";
        content = content || "";
        e.className = className;
        if (content !== undefined) e.textContent = content;
        return e;
    }
    function clearNode(node) {
        while(node.firstChild)node.removeChild(node.firstChild);
    }
    function findParent(node, condition) {
        if (condition(node)) return node;
        else if (node.parentNode) return findParent(node.parentNode, condition);
        return undefined; // nothing found
    }
    function createNumberInput(inputClassName, opts) {
        var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
        if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
        else {
            numInput.type = "text";
            numInput.pattern = "\\d*";
        }
        if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
        wrapper.appendChild(numInput);
        wrapper.appendChild(arrowUp);
        wrapper.appendChild(arrowDown);
        return wrapper;
    }
    function getEventTarget(event) {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    }
    var doNothing = function() {
        return undefined;
    };
    var monthToStr = function(monthNumber, shorthand, locale) {
        return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
    };
    var revFormat = {
        D: doNothing,
        F: function(dateObj, monthName, locale) {
            dateObj.setMonth(locale.months.longhand.indexOf(monthName));
        },
        G: function(dateObj, hour) {
            dateObj.setHours(parseFloat(hour));
        },
        H: function(dateObj, hour) {
            dateObj.setHours(parseFloat(hour));
        },
        J: function(dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        K: function(dateObj, amPM, locale) {
            dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
        },
        M: function(dateObj, shortMonth, locale) {
            dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
        },
        S: function(dateObj, seconds) {
            dateObj.setSeconds(parseFloat(seconds));
        },
        U: function(_, unixSeconds) {
            return new Date(parseFloat(unixSeconds) * 1000);
        },
        W: function(dateObj, weekNum, locale) {
            var weekNumber = parseInt(weekNum);
            var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
            date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
            return date;
        },
        Y: function(dateObj, year) {
            dateObj.setFullYear(parseFloat(year));
        },
        Z: function(_, ISODate) {
            return new Date(ISODate);
        },
        d: function(dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        h: function(dateObj, hour) {
            dateObj.setHours(parseFloat(hour));
        },
        i: function(dateObj, minutes) {
            dateObj.setMinutes(parseFloat(minutes));
        },
        j: function(dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        l: doNothing,
        m: function(dateObj, month) {
            dateObj.setMonth(parseFloat(month) - 1);
        },
        n: function(dateObj, month) {
            dateObj.setMonth(parseFloat(month) - 1);
        },
        s: function(dateObj, seconds) {
            dateObj.setSeconds(parseFloat(seconds));
        },
        u: function(_, unixMillSeconds) {
            return new Date(parseFloat(unixMillSeconds));
        },
        w: doNothing,
        y: function(dateObj, year) {
            dateObj.setFullYear(2000 + parseFloat(year));
        }
    };
    var tokenRegex = {
        D: "(\\w+)",
        F: "(\\w+)",
        G: "(\\d\\d|\\d)",
        H: "(\\d\\d|\\d)",
        J: "(\\d\\d|\\d)\\w+",
        K: "",
        M: "(\\w+)",
        S: "(\\d\\d|\\d)",
        U: "(.+)",
        W: "(\\d\\d|\\d)",
        Y: "(\\d{4})",
        Z: "(.+)",
        d: "(\\d\\d|\\d)",
        h: "(\\d\\d|\\d)",
        i: "(\\d\\d|\\d)",
        j: "(\\d\\d|\\d)",
        l: "(\\w+)",
        m: "(\\d\\d|\\d)",
        n: "(\\d\\d|\\d)",
        s: "(\\d\\d|\\d)",
        u: "(.+)",
        w: "(\\d\\d|\\d)",
        y: "(\\d{2})"
    };
    var formats = {
        // get the date in UTC
        Z: function(date) {
            return date.toISOString();
        },
        // weekday name, short, e.g. Thu
        D: function(date, locale, options) {
            return locale.weekdays.shorthand[formats.w(date, locale, options)];
        },
        // full month name e.g. January
        F: function(date, locale, options) {
            return monthToStr(formats.n(date, locale, options) - 1, false, locale);
        },
        // padded hour 1-12
        G: function(date, locale, options) {
            return pad(formats.h(date, locale, options));
        },
        // hours with leading zero e.g. 03
        H: function(date) {
            return pad(date.getHours());
        },
        // day (1-30) with ordinal suffix e.g. 1st, 2nd
        J: function(date, locale) {
            return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
        },
        // AM/PM
        K: function(date, locale) {
            return locale.amPM[int(date.getHours() > 11)];
        },
        // shorthand month e.g. Jan, Sep, Oct, etc
        M: function(date, locale) {
            return monthToStr(date.getMonth(), true, locale);
        },
        // seconds 00-59
        S: function(date) {
            return pad(date.getSeconds());
        },
        // unix timestamp
        U: function(date) {
            return date.getTime() / 1000;
        },
        W: function(date, _, options) {
            return options.getWeek(date);
        },
        // full year e.g. 2016
        Y: function(date) {
            return date.getFullYear();
        },
        // day in month, padded (01-30)
        d: function(date) {
            return pad(date.getDate());
        },
        // hour from 1-12 (am/pm)
        h: function(date) {
            return date.getHours() % 12 ? date.getHours() % 12 : 12;
        },
        // minutes, padded with leading zero e.g. 09
        i: function(date) {
            return pad(date.getMinutes());
        },
        // day in month (1-30)
        j: function(date) {
            return date.getDate();
        },
        // weekday name, full, e.g. Thursday
        l: function(date, locale) {
            return locale.weekdays.longhand[date.getDay()];
        },
        // padded month number (01-12)
        m: function(date) {
            return pad(date.getMonth() + 1);
        },
        // the month number (1-12)
        n: function(date) {
            return date.getMonth() + 1;
        },
        // seconds 0-59
        s: function(date) {
            return date.getSeconds();
        },
        // Unix Milliseconds
        u: function(date) {
            return date.getTime();
        },
        // number of the day of the week
        w: function(date) {
            return date.getDay();
        },
        // last two digits of year e.g. 16 for 2016
        y: function(date) {
            return String(date.getFullYear()).substring(2);
        }
    };
    var createDateFormatter = function(_a) {
        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
        return function(dateObj, frmt, overrideLocale) {
            var locale = overrideLocale || l10n;
            if (config.formatDate !== undefined) return config.formatDate(dateObj, frmt, locale);
            return frmt.split("").map(function(c, i, arr) {
                return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
            }).join("");
        };
    };
    var createDateParser = function(_a) {
        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
        return function(date, givenFormat, timeless, customLocale) {
            if (date !== 0 && !date) return undefined;
            var locale = customLocale || l10n;
            var parsedDate;
            var dateOrig = date;
            if (date instanceof Date) parsedDate = new Date(date.getTime());
            else if (typeof date !== "string" && date.toFixed !== undefined // timestamp
            ) // create a copy
            parsedDate = new Date(date);
            else if (typeof date === "string") {
                // date string
                var format = givenFormat || (config || defaults).dateFormat;
                var datestr = String(date).trim();
                if (datestr === "today") {
                    parsedDate = new Date();
                    timeless = true;
                } else if (/Z$/.test(datestr) || /GMT$/.test(datestr) // datestrings w/ timezone
                ) parsedDate = new Date(date);
                else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
                else {
                    parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                    var matched = void 0, ops = [];
                    for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                        var token_1 = format[i];
                        var isBackSlash = token_1 === "\\";
                        var escaped = format[i - 1] === "\\" || isBackSlash;
                        if (tokenRegex[token_1] && !escaped) {
                            regexStr += tokenRegex[token_1];
                            var match = new RegExp(regexStr).exec(date);
                            if (match && (matched = true)) ops[token_1 !== "Y" ? "push" : "unshift"]({
                                fn: revFormat[token_1],
                                val: match[++matchIndex]
                            });
                        } else if (!isBackSlash) regexStr += "."; // don't really care
                        ops.forEach(function(_a) {
                            var fn = _a.fn, val = _a.val;
                            return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                        });
                    }
                    parsedDate = matched ? parsedDate : undefined;
                }
            }
            /* istanbul ignore next */ if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
                config.errorHandler(new Error("Invalid date provided: " + dateOrig));
                return undefined;
            }
            if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
            return parsedDate;
        };
    };
    /**
     * Compute the difference in dates, measured in ms
     */ function compareDates(date1, date2, timeless) {
        if (timeless === void 0) timeless = true;
        if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
        return date1.getTime() - date2.getTime();
    }
    var isBetween = function(ts, ts1, ts2) {
        return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
    };
    var duration = {
        DAY: 86400000
    };
    if (typeof Object.assign !== "function") Object.assign = function(target) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!target) throw TypeError("Cannot convert undefined or null to object");
        var _loop_1 = function(source) {
            if (source) Object.keys(source).forEach(function(key) {
                return target[key] = source[key];
            });
        };
        for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
            var source = args_1[_a];
            _loop_1(source);
        }
        return target;
    };
    var DEBOUNCED_CHANGE_MS = 300;
    function FlatpickrInstance(element, instanceConfig) {
        var self = {
            config: __assign({}, defaults, flatpickr.defaultConfig),
            l10n: english
        };
        self.parseDate = createDateParser({
            config: self.config,
            l10n: self.l10n
        });
        self._handlers = [];
        self.pluginElements = [];
        self.loadedPlugins = [];
        self._bind = bind;
        self._setHoursFromDate = setHoursFromDate;
        self._positionCalendar = positionCalendar;
        self.changeMonth = changeMonth;
        self.changeYear = changeYear;
        self.clear = clear;
        self.close = close;
        self._createElement = createElement;
        self.destroy = destroy;
        self.isEnabled = isEnabled;
        self.jumpToDate = jumpToDate;
        self.open = open;
        self.redraw = redraw;
        self.set = set;
        self.setDate = setDate;
        self.toggle = toggle;
        function setupHelperFunctions() {
            self.utils = {
                getDaysInMonth: function(month, yr) {
                    if (month === void 0) month = self.currentMonth;
                    if (yr === void 0) yr = self.currentYear;
                    if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                    return self.l10n.daysInMonth[month];
                }
            };
        }
        function init() {
            self.element = self.input = element;
            self.isOpen = false;
            parseConfig();
            setupLocale();
            setupInputs();
            setupDates();
            setupHelperFunctions();
            if (!self.isMobile) build();
            bindEvents();
            if (self.selectedDates.length || self.config.noCalendar) {
                if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj || self.config.minDate : undefined);
                updateValue(false);
            }
            setCalendarWidth();
            self.showTimeInput = self.selectedDates.length > 0 || self.config.noCalendar;
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            /* TODO: investigate this further
        
              Currently, there is weird positioning behavior in safari causing pages
              to scroll up. https://github.com/chmln/flatpickr/issues/563
        
              However, most browsers are not Safari and positioning is expensive when used
              in scale. https://github.com/chmln/flatpickr/issues/1096
            */ if (!self.isMobile && isSafari) positionCalendar();
            triggerEvent("onReady");
        }
        function bindToInstance(fn) {
            return fn.bind(self);
        }
        function setCalendarWidth() {
            var config = self.config;
            if (config.weekNumbers === false && config.showMonths === 1) return;
            else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
                if (self.calendarContainer !== undefined) {
                    self.calendarContainer.style.visibility = "hidden";
                    self.calendarContainer.style.display = "block";
                }
                if (self.daysContainer !== undefined) {
                    var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                    self.daysContainer.style.width = daysWidth + "px";
                    self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                    self.calendarContainer.style.removeProperty("visibility");
                    self.calendarContainer.style.removeProperty("display");
                }
            });
        }
        /**
         * The handler for all events targeting the time inputs
         */ function updateTime(e) {
            if (self.selectedDates.length === 0) setDefaultTime();
            if (e !== undefined && e.type !== "blur") timeWrapper(e);
            var prevValue = self._input.value;
            setHoursFromInputs();
            updateValue();
            if (self._input.value !== prevValue) self._debouncedChange();
        }
        function ampm2military(hour, amPM) {
            return hour % 12 + 12 * int(amPM === self.l10n.amPM[1]);
        }
        function military2ampm(hour) {
            switch(hour % 24){
                case 0:
                case 12:
                    return 12;
                default:
                    return hour % 12;
            }
        }
        /**
         * Syncs the selected date object time with user's time input
         */ function setHoursFromInputs() {
            if (self.hourElement === undefined || self.minuteElement === undefined) return;
            var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
            if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
            var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0;
            var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours()) minutes = Math.max(minutes, minTime.getMinutes());
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
            setHours(hours, minutes, seconds);
        }
        /**
         * Syncs time input values with a date
         */ function setHoursFromDate(dateObj) {
            var date = dateObj || self.latestSelectedDateObj;
            if (date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
        }
        function setDefaultHours() {
            var hours = self.config.defaultHour;
            var minutes = self.config.defaultMinute;
            var seconds = self.config.defaultSeconds;
            if (self.config.minDate !== undefined) {
                var minHr = self.config.minDate.getHours();
                var minMinutes = self.config.minDate.getMinutes();
                hours = Math.max(hours, minHr);
                if (hours === minHr) minutes = Math.max(minMinutes, minutes);
                if (hours === minHr && minutes === minMinutes) seconds = self.config.minDate.getSeconds();
            }
            if (self.config.maxDate !== undefined) {
                var maxHr = self.config.maxDate.getHours();
                var maxMinutes = self.config.maxDate.getMinutes();
                hours = Math.min(hours, maxHr);
                if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
                if (hours === maxHr && minutes === maxMinutes) seconds = self.config.maxDate.getSeconds();
            }
            setHours(hours, minutes, seconds);
        }
        /**
         * Sets the hours, minutes, and optionally seconds
         * of the latest selected date object and the
         * corresponding time inputs
         * @param {Number} hours the hour. whether its military
         *                 or am-pm gets inferred from config
         * @param {Number} minutes the minutes
         * @param {Number} seconds the seconds (optional)
         */ function setHours(hours, minutes, seconds) {
            if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
            if (!self.hourElement || !self.minuteElement || self.isMobile) return;
            self.hourElement.value = pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
            self.minuteElement.value = pad(minutes);
            if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
            if (self.secondElement !== undefined) self.secondElement.value = pad(seconds);
        }
        /**
         * Handles the year input and incrementing events
         * @param {Event} event the keyup or increment event
         */ function onYearInput(event) {
            var year = parseInt(event.target.value) + (event.delta || 0);
            if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
        }
        /**
         * Essentially addEventListener + tracking
         * @param {Element} element the element to addEventListener to
         * @param {String} event the event name
         * @param {Function} handler the event handler
         */ function bind(element, event, handler, options) {
            if (event instanceof Array) return event.forEach(function(ev) {
                return bind(element, ev, handler, options);
            });
            if (element instanceof Array) return element.forEach(function(el) {
                return bind(el, event, handler, options);
            });
            element.addEventListener(event, handler, options);
            self._handlers.push({
                element: element,
                event: event,
                handler: handler,
                options: options
            });
        }
        /**
         * A mousedown handler which mimics click.
         * Minimizes latency, since we don't need to wait for mouseup in most cases.
         * Also, avoids handling right clicks.
         *
         * @param {Function} handler the event handler
         */ function onClick(handler) {
            return function(evt) {
                evt.which === 1 && handler(evt);
            };
        }
        function triggerChange() {
            triggerEvent("onChange");
        }
        /**
         * Adds all the necessary event listeners
         */ function bindEvents() {
            if (self.config.wrap) [
                "open",
                "close",
                "toggle",
                "clear"
            ].forEach(function(evt) {
                Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                    return bind(el, "click", self[evt]);
                });
            });
            if (self.isMobile) {
                setupMobile();
                return;
            }
            var debouncedResize = debounce(onResize, 50);
            self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
            if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
                if (self.config.mode === "range") onMouseOver(e.target);
            });
            bind(window.document.body, "keydown", onKeyDown);
            if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
            if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
            else bind(window.document, "mousedown", onClick(documentClick));
            bind(window.document, "focus", documentClick, {
                capture: true
            });
            if (self.config.clickOpens === true) {
                bind(self._input, "focus", self.open);
                bind(self._input, "mousedown", onClick(self.open));
            }
            if (self.daysContainer !== undefined) {
                bind(self.monthNav, "mousedown", onClick(onMonthNavClick));
                bind(self.monthNav, [
                    "keyup",
                    "increment"
                ], onYearInput);
                bind(self.daysContainer, "mousedown", onClick(selectDate));
            }
            if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
                var selText = function(e) {
                    return e.target.select();
                };
                bind(self.timeContainer, [
                    "increment"
                ], updateTime);
                bind(self.timeContainer, "blur", updateTime, {
                    capture: true
                });
                bind(self.timeContainer, "mousedown", onClick(timeIncrement));
                bind([
                    self.hourElement,
                    self.minuteElement
                ], [
                    "focus",
                    "click"
                ], selText);
                if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                    return self.secondElement && self.secondElement.select();
                });
                if (self.amPM !== undefined) bind(self.amPM, "mousedown", onClick(function(e) {
                    updateTime(e);
                    triggerChange();
                }));
            }
        }
        /**
         * Set the calendar view to a particular date.
         * @param {Date} jumpDate the date to set the view to
         * @param {boolean} triggerChange if change events should be triggered
         */ function jumpToDate(jumpDate, triggerChange) {
            var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
            var oldYear = self.currentYear;
            var oldMonth = self.currentMonth;
            try {
                if (jumpTo !== undefined) {
                    self.currentYear = jumpTo.getFullYear();
                    self.currentMonth = jumpTo.getMonth();
                }
            } catch (e) {
                /* istanbul ignore next */ e.message = "Invalid date supplied: " + jumpTo;
                self.config.errorHandler(e);
            }
            if (triggerChange && self.currentYear !== oldYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
            self.redraw();
        }
        /**
         * The up/down arrow handler for time inputs
         * @param {Event} e the click event
         */ function timeIncrement(e) {
            if (~e.target.className.indexOf("arrow")) incrementNumInput(e, e.target.classList.contains("arrowUp") ? 1 : -1);
        }
        /**
         * Increments/decrements the value of input associ-
         * ated with the up/down arrow by dispatching an
         * "increment" event on the input.
         *
         * @param {Event} e the click event
         * @param {Number} delta the diff (usually 1 or -1)
         * @param {Element} inputElem the input element
         */ function incrementNumInput(e, delta, inputElem) {
            var target = e && e.target;
            var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
            var event = createEvent("increment");
            event.delta = delta;
            input && input.dispatchEvent(event);
        }
        function build() {
            var fragment = window.document.createDocumentFragment();
            self.calendarContainer = createElement("div", "flatpickr-calendar");
            self.calendarContainer.tabIndex = -1;
            if (!self.config.noCalendar) {
                fragment.appendChild(buildMonthNav());
                self.innerContainer = createElement("div", "flatpickr-innerContainer");
                if (self.config.weekNumbers) {
                    var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                    self.innerContainer.appendChild(weekWrapper);
                    self.weekNumbers = weekNumbers;
                    self.weekWrapper = weekWrapper;
                }
                self.rContainer = createElement("div", "flatpickr-rContainer");
                self.rContainer.appendChild(buildWeekdays());
                if (!self.daysContainer) {
                    self.daysContainer = createElement("div", "flatpickr-days");
                    self.daysContainer.tabIndex = -1;
                }
                buildDays();
                self.rContainer.appendChild(self.daysContainer);
                self.innerContainer.appendChild(self.rContainer);
                fragment.appendChild(self.innerContainer);
            }
            if (self.config.enableTime) fragment.appendChild(buildTime());
            toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
            toggleClass(self.calendarContainer, "animate", self.config.animate === true);
            toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
            self.calendarContainer.appendChild(fragment);
            var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
            if (self.config.inline || self.config.static) {
                self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
                if (self.config.inline) {
                    if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                    else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
                }
                if (self.config.static) {
                    var wrapper = createElement("div", "flatpickr-wrapper");
                    if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                    wrapper.appendChild(self.element);
                    if (self.altInput) wrapper.appendChild(self.altInput);
                    wrapper.appendChild(self.calendarContainer);
                }
            }
            if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
        }
        function createDay(className, date, dayNumber, i) {
            var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
            dayElement.dateObj = date;
            dayElement.$i = i;
            dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
            if (className.indexOf("hidden") === -1 && compareDates(date, self.now) === 0) {
                self.todayDateElem = dayElement;
                dayElement.classList.add("today");
                dayElement.setAttribute("aria-current", "date");
            }
            if (dateIsEnabled) {
                dayElement.tabIndex = -1;
                if (isDateSelected(date)) {
                    dayElement.classList.add("selected");
                    self.selectedDateElem = dayElement;
                    if (self.config.mode === "range") {
                        toggleClass(dayElement, "startRange", self.selectedDates[0] && compareDates(date, self.selectedDates[0], true) === 0);
                        toggleClass(dayElement, "endRange", self.selectedDates[1] && compareDates(date, self.selectedDates[1], true) === 0);
                        if (className === "nextMonthDay") dayElement.classList.add("inRange");
                    }
                }
            } else dayElement.classList.add("flatpickr-disabled");
            if (self.config.mode === "range") {
                if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
            }
            if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && dayNumber % 7 === 1) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
            triggerEvent("onDayCreate", dayElement);
            return dayElement;
        }
        function focusOnDayElem(targetNode) {
            targetNode.focus();
            if (self.config.mode === "range") onMouseOver(targetNode);
        }
        function getFirstAvailableDay(delta) {
            var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
            var endMonth = delta > 0 ? self.config.showMonths : -1;
            for(var m = startMonth; m != endMonth; m += delta){
                var month = self.daysContainer.children[m];
                var startIndex = delta > 0 ? 0 : month.children.length - 1;
                var endIndex = delta > 0 ? month.children.length : -1;
                for(var i = startIndex; i != endIndex; i += delta){
                    var c = month.children[i];
                    if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
                }
            }
            return undefined;
        }
        function getNextAvailableDay(current, delta) {
            var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
            var endMonth = delta > 0 ? self.config.showMonths : -1;
            var loopDelta = delta > 0 ? 1 : -1;
            for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
                var month = self.daysContainer.children[m];
                var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
                var numMonthDays = month.children.length;
                for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                    var c = month.children[i];
                    if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
                }
            }
            self.changeMonth(loopDelta);
            focusOnDay(getFirstAvailableDay(loopDelta), 0);
            return undefined;
        }
        function focusOnDay(current, offset) {
            var dayFocused = isInView(document.activeElement || document.body);
            var startElem = current !== undefined ? current : dayFocused ? document.activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
            if (startElem === undefined) return self._input.focus();
            if (!dayFocused) return focusOnDayElem(startElem);
            getNextAvailableDay(startElem, offset);
        }
        function buildMonthDays(year, month) {
            var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
            var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12);
            var daysInMonth = self.utils.getDaysInMonth(month), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
            var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
            // prepend days from the ending of previous month
            for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
            // Start at 1 since there is no 0th day
            for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
            // append days from the next month
            for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
            //updateNavigationCurrentMonth();
            var dayContainer = createElement("div", "dayContainer");
            dayContainer.appendChild(days);
            return dayContainer;
        }
        function buildDays() {
            if (self.daysContainer === undefined) return;
            clearNode(self.daysContainer);
            // TODO: week numbers for each month
            if (self.weekNumbers) clearNode(self.weekNumbers);
            var frag = document.createDocumentFragment();
            for(var i = 0; i < self.config.showMonths; i++){
                var d = new Date(self.currentYear, self.currentMonth, 1);
                d.setMonth(self.currentMonth + i);
                frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
            }
            self.daysContainer.appendChild(frag);
            self.days = self.daysContainer.firstChild;
            if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
        }
        function buildMonthSwitch() {
            if (self.config.showMonths > 1) return;
            var shouldBuildMonth = function(month) {
                if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
                return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
            };
            self.monthsDropdownContainer.tabIndex = -1;
            self.monthsDropdownContainer.innerHTML = "";
            for(var i = 0; i < 12; i++){
                if (!shouldBuildMonth(i)) continue;
                var month = createElement("option", "flatpickr-monthDropdown-month");
                month.value = new Date(self.currentYear, i).getMonth().toString();
                month.textContent = monthToStr(i, false, self.l10n);
                month.tabIndex = -1;
                if (self.currentMonth === i) month.selected = true;
                self.monthsDropdownContainer.appendChild(month);
            }
        }
        function buildMonth() {
            var container = createElement("div", "flatpickr-month");
            var monthNavFragment = window.document.createDocumentFragment();
            var monthElement;
            if (self.config.showMonths > 1) monthElement = createElement("span", "cur-month");
            else {
                self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
                bind(self.monthsDropdownContainer, "change", function(e) {
                    var target = e.target;
                    var selectedMonth = parseInt(target.value, 10);
                    self.changeMonth(selectedMonth - self.currentMonth);
                    triggerEvent("onMonthChange");
                });
                buildMonthSwitch();
                monthElement = self.monthsDropdownContainer;
            }
            var yearInput = createNumberInput("cur-year", {
                tabindex: "-1"
            });
            var yearElement = yearInput.getElementsByTagName("input")[0];
            yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
            if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
            if (self.config.maxDate) {
                yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
                yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
            }
            var currentMonth = createElement("div", "flatpickr-current-month");
            currentMonth.appendChild(monthElement);
            currentMonth.appendChild(yearInput);
            monthNavFragment.appendChild(currentMonth);
            container.appendChild(monthNavFragment);
            return {
                container: container,
                yearElement: yearElement,
                monthElement: monthElement
            };
        }
        function buildMonths() {
            clearNode(self.monthNav);
            self.monthNav.appendChild(self.prevMonthNav);
            if (self.config.showMonths) {
                self.yearElements = [];
                self.monthElements = [];
            }
            for(var m = self.config.showMonths; m--;){
                var month = buildMonth();
                self.yearElements.push(month.yearElement);
                self.monthElements.push(month.monthElement);
                self.monthNav.appendChild(month.container);
            }
            self.monthNav.appendChild(self.nextMonthNav);
        }
        function buildMonthNav() {
            self.monthNav = createElement("div", "flatpickr-months");
            self.yearElements = [];
            self.monthElements = [];
            self.prevMonthNav = createElement("span", "flatpickr-prev-month");
            self.prevMonthNav.innerHTML = self.config.prevArrow;
            self.nextMonthNav = createElement("span", "flatpickr-next-month");
            self.nextMonthNav.innerHTML = self.config.nextArrow;
            buildMonths();
            Object.defineProperty(self, "_hidePrevMonthArrow", {
                get: function() {
                    return self.__hidePrevMonthArrow;
                },
                set: function(bool) {
                    if (self.__hidePrevMonthArrow !== bool) {
                        toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
                        self.__hidePrevMonthArrow = bool;
                    }
                }
            });
            Object.defineProperty(self, "_hideNextMonthArrow", {
                get: function() {
                    return self.__hideNextMonthArrow;
                },
                set: function(bool) {
                    if (self.__hideNextMonthArrow !== bool) {
                        toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
                        self.__hideNextMonthArrow = bool;
                    }
                }
            });
            self.currentYearElement = self.yearElements[0];
            updateNavigationCurrentMonth();
            return self.monthNav;
        }
        function buildTime() {
            self.calendarContainer.classList.add("hasTime");
            if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
            self.timeContainer = createElement("div", "flatpickr-time");
            self.timeContainer.tabIndex = -1;
            var separator = createElement("span", "flatpickr-time-separator", ":");
            var hourInput = createNumberInput("flatpickr-hour");
            self.hourElement = hourInput.getElementsByTagName("input")[0];
            var minuteInput = createNumberInput("flatpickr-minute");
            self.minuteElement = minuteInput.getElementsByTagName("input")[0];
            self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
            self.hourElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? self.config.defaultHour : military2ampm(self.config.defaultHour));
            self.minuteElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : self.config.defaultMinute);
            self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
            self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
            self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
            self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
            self.minuteElement.setAttribute("min", "0");
            self.minuteElement.setAttribute("max", "59");
            self.timeContainer.appendChild(hourInput);
            self.timeContainer.appendChild(separator);
            self.timeContainer.appendChild(minuteInput);
            if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
            if (self.config.enableSeconds) {
                self.timeContainer.classList.add("hasSeconds");
                var secondInput = createNumberInput("flatpickr-second");
                self.secondElement = secondInput.getElementsByTagName("input")[0];
                self.secondElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : self.config.defaultSeconds);
                self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
                self.secondElement.setAttribute("min", "0");
                self.secondElement.setAttribute("max", "59");
                self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
                self.timeContainer.appendChild(secondInput);
            }
            if (!self.config.time_24hr) {
                // add self.amPM if appropriate
                self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
                self.amPM.title = self.l10n.toggleTitle;
                self.amPM.tabIndex = -1;
                self.timeContainer.appendChild(self.amPM);
            }
            return self.timeContainer;
        }
        function buildWeekdays() {
            if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");
            else clearNode(self.weekdayContainer);
            for(var i = self.config.showMonths; i--;){
                var container = createElement("div", "flatpickr-weekdaycontainer");
                self.weekdayContainer.appendChild(container);
            }
            updateWeekdays();
            return self.weekdayContainer;
        }
        function updateWeekdays() {
            var firstDayOfWeek = self.l10n.firstDayOfWeek;
            var weekdays = self.l10n.weekdays.shorthand.slice();
            if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = weekdays.splice(firstDayOfWeek, weekdays.length).concat(weekdays.splice(0, firstDayOfWeek));
            for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
        }
        /* istanbul ignore next */ function buildWeeks() {
            self.calendarContainer.classList.add("hasWeeks");
            var weekWrapper = createElement("div", "flatpickr-weekwrapper");
            weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
            var weekNumbers = createElement("div", "flatpickr-weeks");
            weekWrapper.appendChild(weekNumbers);
            return {
                weekWrapper: weekWrapper,
                weekNumbers: weekNumbers
            };
        }
        function changeMonth(value, isOffset) {
            if (isOffset === void 0) isOffset = true;
            var delta = isOffset ? value : value - self.currentMonth;
            if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
            self.currentMonth += delta;
            if (self.currentMonth < 0 || self.currentMonth > 11) {
                self.currentYear += self.currentMonth > 11 ? 1 : -1;
                self.currentMonth = (self.currentMonth + 12) % 12;
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            buildDays();
            triggerEvent("onMonthChange");
            updateNavigationCurrentMonth();
        }
        function clear(triggerChangeEvent, toInitial) {
            if (triggerChangeEvent === void 0) triggerChangeEvent = true;
            if (toInitial === void 0) toInitial = true;
            self.input.value = "";
            if (self.altInput !== undefined) self.altInput.value = "";
            if (self.mobileInput !== undefined) self.mobileInput.value = "";
            self.selectedDates = [];
            self.latestSelectedDateObj = undefined;
            if (toInitial === true) {
                self.currentYear = self._initialDate.getFullYear();
                self.currentMonth = self._initialDate.getMonth();
            }
            self.showTimeInput = false;
            if (self.config.enableTime === true) setDefaultHours();
            self.redraw();
            if (triggerChangeEvent) // triggerChangeEvent is true (default) or an Event
            triggerEvent("onChange");
        }
        function close() {
            self.isOpen = false;
            if (!self.isMobile) {
                if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
                if (self._input !== undefined) self._input.classList.remove("active");
            }
            triggerEvent("onClose");
        }
        function destroy() {
            if (self.config !== undefined) triggerEvent("onDestroy");
            for(var i = self._handlers.length; i--;){
                var h = self._handlers[i];
                h.element.removeEventListener(h.event, h.handler, h.options);
            }
            self._handlers = [];
            if (self.mobileInput) {
                if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
                self.mobileInput = undefined;
            } else if (self.calendarContainer && self.calendarContainer.parentNode) {
                if (self.config.static && self.calendarContainer.parentNode) {
                    var wrapper = self.calendarContainer.parentNode;
                    wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                    if (wrapper.parentNode) {
                        while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                        wrapper.parentNode.removeChild(wrapper);
                    }
                } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
            }
            if (self.altInput) {
                self.input.type = "text";
                if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
                delete self.altInput;
            }
            if (self.input) {
                self.input.type = self.input._type;
                self.input.classList.remove("flatpickr-input");
                self.input.removeAttribute("readonly");
                self.input.value = "";
            }
            [
                "_showTimeInput",
                "latestSelectedDateObj",
                "_hideNextMonthArrow",
                "_hidePrevMonthArrow",
                "__hideNextMonthArrow",
                "__hidePrevMonthArrow",
                "isMobile",
                "isOpen",
                "selectedDateElem",
                "minDateHasTime",
                "maxDateHasTime",
                "days",
                "daysContainer",
                "_input",
                "_positionElement",
                "innerContainer",
                "rContainer",
                "monthNav",
                "todayDateElem",
                "calendarContainer",
                "weekdayContainer",
                "prevMonthNav",
                "nextMonthNav",
                "monthsDropdownContainer",
                "currentMonthElement",
                "currentYearElement",
                "navigationCurrentMonth",
                "selectedDateElem",
                "config"
            ].forEach(function(k) {
                try {
                    delete self[k];
                } catch (_) {}
            });
        }
        function isCalendarElem(elem) {
            if (self.config.appendTo && self.config.appendTo.contains(elem)) return true;
            return self.calendarContainer.contains(elem);
        }
        function documentClick(e) {
            if (self.isOpen && !self.config.inline) {
                var eventTarget_1 = getEventTarget(e);
                var isCalendarElement = isCalendarElem(eventTarget_1);
                var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || // web components
                // e.path is not present in all browsers. circumventing typechecks
                e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
                var lostFocus = e.type === "blur" ? isInput && e.relatedTarget && !isCalendarElem(e.relatedTarget) : !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
                var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                    return elem.contains(eventTarget_1);
                });
                if (lostFocus && isIgnored) {
                    self.close();
                    if (self.config.mode === "range" && self.selectedDates.length === 1) {
                        self.clear(false);
                        self.redraw();
                    }
                }
            }
        }
        function changeYear(newYear) {
            if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
            var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
            self.currentYear = newYearNum || self.currentYear;
            if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
            else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
            if (isNewYear) {
                self.redraw();
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
        }
        function isEnabled(date, timeless) {
            if (timeless === void 0) timeless = true;
            var dateToCheck = self.parseDate(date, undefined, timeless); // timeless
            if (self.config.minDate && dateToCheck && compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
            if (self.config.enable.length === 0 && self.config.disable.length === 0) return true;
            if (dateToCheck === undefined) return false;
            var bool = self.config.enable.length > 0, array = bool ? self.config.enable : self.config.disable;
            for(var i = 0, d = void 0; i < array.length; i++){
                d = array[i];
                if (typeof d === "function" && d(dateToCheck) // disabled by function
                ) return bool;
                else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) // disabled by date
                return bool;
                else if (typeof d === "string" && dateToCheck !== undefined) {
                    // disabled by date string
                    var parsed = self.parseDate(d, undefined, true);
                    return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
                } else if (// disabled by range
                typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
            }
            return !bool;
        }
        function isInView(elem) {
            if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && self.daysContainer.contains(elem);
            return false;
        }
        function onKeyDown(e) {
            // e.key                      e.keyCode
            // "Backspace"                        8
            // "Tab"                              9
            // "Enter"                           13
            // "Escape"     (IE "Esc")           27
            // "ArrowLeft"  (IE "Left")          37
            // "ArrowUp"    (IE "Up")            38
            // "ArrowRight" (IE "Right")         39
            // "ArrowDown"  (IE "Down")          40
            // "Delete"     (IE "Del")           46
            var isInput = e.target === self._input;
            var allowInput = self.config.allowInput;
            var allowKeydown = self.isOpen && (!allowInput || !isInput);
            var allowInlineKeydown = self.config.inline && isInput && !allowInput;
            if (e.keyCode === 13 && isInput) {
                if (allowInput) {
                    self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
                    return e.target.blur();
                } else self.open();
            } else if (isCalendarElem(e.target) || allowKeydown || allowInlineKeydown) {
                var isTimeObj = !!self.timeContainer && self.timeContainer.contains(e.target);
                switch(e.keyCode){
                    case 13:
                        if (isTimeObj) {
                            e.preventDefault();
                            updateTime();
                            focusAndClose();
                        } else selectDate(e);
                        break;
                    case 27:
                        e.preventDefault();
                        focusAndClose();
                        break;
                    case 8:
                    case 46:
                        if (isInput && !self.config.allowInput) {
                            e.preventDefault();
                            self.clear();
                        }
                        break;
                    case 37:
                    case 39:
                        if (!isTimeObj && !isInput) {
                            e.preventDefault();
                            if (self.daysContainer !== undefined && (allowInput === false || document.activeElement && isInView(document.activeElement))) {
                                var delta_1 = e.keyCode === 39 ? 1 : -1;
                                if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                                else {
                                    e.stopPropagation();
                                    changeMonth(delta_1);
                                    focusOnDay(getFirstAvailableDay(1), 0);
                                }
                            }
                        } else if (self.hourElement) self.hourElement.focus();
                        break;
                    case 38:
                    case 40:
                        e.preventDefault();
                        var delta = e.keyCode === 40 ? 1 : -1;
                        if (self.daysContainer && e.target.$i !== undefined || e.target === self.input) {
                            if (e.ctrlKey) {
                                e.stopPropagation();
                                changeYear(self.currentYear - delta);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                        } else if (e.target === self.currentYearElement) changeYear(self.currentYear - delta);
                        else if (self.config.enableTime) {
                            if (!isTimeObj && self.hourElement) self.hourElement.focus();
                            updateTime(e);
                            self._debouncedChange();
                        }
                        break;
                    case 9:
                        if (isTimeObj) {
                            var elems = [
                                self.hourElement,
                                self.minuteElement,
                                self.secondElement,
                                self.amPM
                            ].concat(self.pluginElements).filter(function(x) {
                                return x;
                            });
                            var i = elems.indexOf(e.target);
                            if (i !== -1) {
                                var target = elems[i + (e.shiftKey ? -1 : 1)];
                                e.preventDefault();
                                (target || self._input).focus();
                            }
                        } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(e.target) && e.shiftKey) {
                            e.preventDefault();
                            self._input.focus();
                        }
                        break;
                    default:
                        break;
                }
            }
            if (self.amPM !== undefined && e.target === self.amPM) switch(e.key){
                case self.l10n.amPM[0].charAt(0):
                case self.l10n.amPM[0].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[0];
                    setHoursFromInputs();
                    updateValue();
                    break;
                case self.l10n.amPM[1].charAt(0):
                case self.l10n.amPM[1].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[1];
                    setHoursFromInputs();
                    updateValue();
                    break;
            }
            if (isInput || isCalendarElem(e.target)) triggerEvent("onKeyDown", e);
        }
        function onMouseOver(elem) {
            if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains("flatpickr-day") || elem.classList.contains("flatpickr-disabled"))) return;
            var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
            var containsDisabled = false;
            var minRange = 0, maxRange = 0;
            for(var t = rangeStartDate; t < rangeEndDate; t += duration.DAY)if (!isEnabled(new Date(t), true)) {
                containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
                if (t < initialDate && (!minRange || t > minRange)) minRange = t;
                else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
            }
            for(var m = 0; m < self.config.showMonths; m++){
                var month = self.daysContainer.children[m];
                var _loop_1 = function(i, l) {
                    var dayElem = month.children[i], date = dayElem.dateObj;
                    var timestamp = date.getTime();
                    var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
                    if (outOfRange) {
                        dayElem.classList.add("notAllowed");
                        [
                            "inRange",
                            "startRange",
                            "endRange"
                        ].forEach(function(c) {
                            dayElem.classList.remove(c);
                        });
                        return "continue";
                    } else if (containsDisabled && !outOfRange) return "continue";
                    [
                        "startRange",
                        "inRange",
                        "endRange",
                        "notAllowed"
                    ].forEach(function(c) {
                        dayElem.classList.remove(c);
                    });
                    if (elem !== undefined) {
                        elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                        if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                        else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                        if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
                    }
                };
                for(var i = 0, l = month.children.length; i < l; i++)_loop_1(i, l);
            }
        }
        function onResize() {
            if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
        }
        function setDefaultTime() {
            self.setDate(self.config.minDate !== undefined ? new Date(self.config.minDate.getTime()) : new Date(), true);
            setDefaultHours();
            updateValue();
        }
        function open(e, positionElement) {
            if (positionElement === void 0) positionElement = self._positionElement;
            if (self.isMobile === true) {
                if (e) {
                    e.preventDefault();
                    e.target && e.target.blur();
                }
                if (self.mobileInput !== undefined) {
                    self.mobileInput.focus();
                    self.mobileInput.click();
                }
                triggerEvent("onOpen");
                return;
            }
            if (self._input.disabled || self.config.inline) return;
            var wasOpen = self.isOpen;
            self.isOpen = true;
            if (!wasOpen) {
                self.calendarContainer.classList.add("open");
                self._input.classList.add("active");
                triggerEvent("onOpen");
                positionCalendar(positionElement);
            }
            if (self.config.enableTime === true && self.config.noCalendar === true) {
                if (self.selectedDates.length === 0) setDefaultTime();
                if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                    return self.hourElement.select();
                }, 50);
            }
        }
        function minMaxDateSetter(type) {
            return function(date) {
                var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
                var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
                if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
                if (self.selectedDates) {
                    self.selectedDates = self.selectedDates.filter(function(d) {
                        return isEnabled(d);
                    });
                    if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                    updateValue();
                }
                if (self.daysContainer) {
                    redraw();
                    if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                    else self.currentYearElement.removeAttribute(type);
                    self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
                }
            };
        }
        function parseConfig() {
            var boolOpts = [
                "wrap",
                "weekNumbers",
                "allowInput",
                "clickOpens",
                "time_24hr",
                "enableTime",
                "noCalendar",
                "altInput",
                "shorthandCurrentMonth",
                "inline",
                "static",
                "enableSeconds",
                "disableMobile"
            ];
            var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
            var formats = {};
            self.config.parseDate = userConfig.parseDate;
            self.config.formatDate = userConfig.formatDate;
            Object.defineProperty(self.config, "enable", {
                get: function() {
                    return self.config._enable;
                },
                set: function(dates) {
                    self.config._enable = parseDateRules(dates);
                }
            });
            Object.defineProperty(self.config, "disable", {
                get: function() {
                    return self.config._disable;
                },
                set: function(dates) {
                    self.config._disable = parseDateRules(dates);
                }
            });
            var timeMode = userConfig.mode === "time";
            if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
                var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
                formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
            }
            if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
                var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
                formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
            }
            if (!userConfig.altInputClass) self.config.altInputClass = self.input.className + " " + self.config.altInputClass;
            Object.defineProperty(self.config, "minDate", {
                get: function() {
                    return self.config._minDate;
                },
                set: minMaxDateSetter("min")
            });
            Object.defineProperty(self.config, "maxDate", {
                get: function() {
                    return self.config._maxDate;
                },
                set: minMaxDateSetter("max")
            });
            var minMaxTimeSetter = function(type) {
                return function(val) {
                    self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i");
                };
            };
            Object.defineProperty(self.config, "minTime", {
                get: function() {
                    return self.config._minTime;
                },
                set: minMaxTimeSetter("min")
            });
            Object.defineProperty(self.config, "maxTime", {
                get: function() {
                    return self.config._maxTime;
                },
                set: minMaxTimeSetter("max")
            });
            if (userConfig.mode === "time") {
                self.config.noCalendar = true;
                self.config.enableTime = true;
            }
            Object.assign(self.config, formats, userConfig);
            for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
            HOOKS.filter(function(hook) {
                return self.config[hook] !== undefined;
            }).forEach(function(hook) {
                self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
            });
            self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable.length && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            for(var i = 0; i < self.config.plugins.length; i++){
                var pluginConf = self.config.plugins[i](self) || {};
                for(var key in pluginConf){
                    if (HOOKS.indexOf(key) > -1) self.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                    else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
                }
            }
            triggerEvent("onParseConfig");
        }
        function setupLocale() {
            if (typeof self.config.locale !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
            self.l10n = __assign({}, flatpickr.l10ns["default"], typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : undefined);
            tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
            var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
            if (userConfig.time_24hr === undefined && flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
            self.formatDate = createDateFormatter(self);
            self.parseDate = createDateParser({
                config: self.config,
                l10n: self.l10n
            });
        }
        function positionCalendar(customPositionElement) {
            if (self.calendarContainer === undefined) return;
            triggerEvent("onPreCalendarPosition");
            var positionElement = customPositionElement || self._positionElement;
            var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
                return acc + child.offsetHeight;
            }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
            var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
            toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
            toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
            if (self.config.inline) return;
            var left = window.pageXOffset + inputBounds.left - (configPosHorizontal != null && configPosHorizontal === "center" ? (calendarWidth - inputBounds.width) / 2 : 0);
            var right = window.document.body.offsetWidth - inputBounds.right;
            var rightMost = left + calendarWidth > window.document.body.offsetWidth;
            var centerMost = right + calendarWidth > window.document.body.offsetWidth;
            toggleClass(self.calendarContainer, "rightMost", rightMost);
            if (self.config.static) return;
            self.calendarContainer.style.top = top + "px";
            if (!rightMost) {
                self.calendarContainer.style.left = left + "px";
                self.calendarContainer.style.right = "auto";
            } else if (!centerMost) {
                self.calendarContainer.style.left = "auto";
                self.calendarContainer.style.right = right + "px";
            } else {
                var doc = document.styleSheets[0];
                // some testing environments don't have css support
                if (doc === undefined) return;
                var bodyWidth = window.document.body.offsetWidth;
                var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
                var centerBefore = ".flatpickr-calendar.centerMost:before";
                var centerAfter = ".flatpickr-calendar.centerMost:after";
                var centerIndex = doc.cssRules.length;
                var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
                toggleClass(self.calendarContainer, "rightMost", false);
                toggleClass(self.calendarContainer, "centerMost", true);
                doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
                self.calendarContainer.style.left = centerLeft + "px";
                self.calendarContainer.style.right = "auto";
            }
        }
        function redraw() {
            if (self.config.noCalendar || self.isMobile) return;
            updateNavigationCurrentMonth();
            buildDays();
        }
        function focusAndClose() {
            self._input.focus();
            if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) // hack - bugs in the way IE handles focus keeps the calendar open
            setTimeout(self.close, 0);
            else self.close();
        }
        function selectDate(e) {
            e.preventDefault();
            e.stopPropagation();
            var isSelectable = function(day) {
                return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
            };
            var t = findParent(e.target, isSelectable);
            if (t === undefined) return;
            var target = t;
            var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
            var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
            self.selectedDateElem = target;
            if (self.config.mode === "single") self.selectedDates = [
                selectedDate
            ];
            else if (self.config.mode === "multiple") {
                var selectedIndex = isDateSelected(selectedDate);
                if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
                else self.selectedDates.push(selectedDate);
            } else if (self.config.mode === "range") {
                if (self.selectedDates.length === 2) self.clear(false, false);
                self.latestSelectedDateObj = selectedDate;
                self.selectedDates.push(selectedDate);
                // unless selecting same date twice, sort ascendingly
                if (compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                    return a.getTime() - b.getTime();
                });
            }
            setHoursFromInputs();
            if (shouldChangeMonth) {
                var isNewYear = self.currentYear !== selectedDate.getFullYear();
                self.currentYear = selectedDate.getFullYear();
                self.currentMonth = selectedDate.getMonth();
                if (isNewYear) {
                    triggerEvent("onYearChange");
                    buildMonthSwitch();
                }
                triggerEvent("onMonthChange");
            }
            updateNavigationCurrentMonth();
            buildDays();
            updateValue();
            if (self.config.enableTime) setTimeout(function() {
                return self.showTimeInput = true;
            }, 50);
            // maintain focus
            if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
            else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
            if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
            if (self.config.closeOnSelect) {
                var single = self.config.mode === "single" && !self.config.enableTime;
                var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
                if (single || range) focusAndClose();
            }
            triggerChange();
        }
        var CALLBACKS = {
            locale: [
                setupLocale,
                updateWeekdays
            ],
            showMonths: [
                buildMonths,
                setCalendarWidth,
                buildWeekdays
            ],
            minDate: [
                jumpToDate
            ],
            maxDate: [
                jumpToDate
            ]
        };
        function set(option, value) {
            if (option !== null && typeof option === "object") {
                Object.assign(self.config, option);
                for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                    return x();
                });
            } else {
                self.config[option] = value;
                if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                    return x();
                });
                else if (HOOKS.indexOf(option) > -1) self.config[option] = arrayify(value);
            }
            self.redraw();
            updateValue(false);
        }
        function setSelectedDate(inputDate, format) {
            var dates = [];
            if (inputDate instanceof Array) dates = inputDate.map(function(d) {
                return self.parseDate(d, format);
            });
            else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
                self.parseDate(inputDate, format)
            ];
            else if (typeof inputDate === "string") switch(self.config.mode){
                case "single":
                case "time":
                    dates = [
                        self.parseDate(inputDate, format)
                    ];
                    break;
                case "multiple":
                    dates = inputDate.split(self.config.conjunction).map(function(date) {
                        return self.parseDate(date, format);
                    });
                    break;
                case "range":
                    dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                        return self.parseDate(date, format);
                    });
                    break;
                default:
                    break;
            }
            else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
            self.selectedDates = dates.filter(function(d) {
                return d instanceof Date && isEnabled(d, false);
            });
            if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        function setDate(date, triggerChange, format) {
            if (triggerChange === void 0) triggerChange = false;
            if (format === void 0) format = self.config.dateFormat;
            if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
            setSelectedDate(date, format);
            self.showTimeInput = self.selectedDates.length > 0;
            self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
            self.redraw();
            jumpToDate();
            setHoursFromDate();
            if (self.selectedDates.length === 0) self.clear(false);
            updateValue(triggerChange);
            if (triggerChange) triggerEvent("onChange");
        }
        function parseDateRules(arr) {
            return arr.slice().map(function(rule) {
                if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
                else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                    from: self.parseDate(rule.from, undefined),
                    to: self.parseDate(rule.to, undefined)
                };
                return rule;
            }).filter(function(x) {
                return x;
            }); // remove falsy values
        }
        function setupDates() {
            self.selectedDates = [];
            self.now = self.parseDate(self.config.now) || new Date();
            // Workaround IE11 setting placeholder as the input's value
            var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
            if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
            self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
            if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
            if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
            if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
            self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
            self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
            Object.defineProperty(self, "showTimeInput", {
                get: function() {
                    return self._showTimeInput;
                },
                set: function(bool) {
                    self._showTimeInput = bool;
                    if (self.calendarContainer) toggleClass(self.calendarContainer, "showTimeInput", bool);
                    self.isOpen && positionCalendar();
                }
            });
        }
        function setupInputs() {
            self.input = self.config.wrap ? element.querySelector("[data-input]") : element;
            /* istanbul ignore next */ if (!self.input) {
                self.config.errorHandler(new Error("Invalid input element specified"));
                return;
            }
            // hack: store previous type to restore it after destroy()
            self.input._type = self.input.type;
            self.input.type = "text";
            self.input.classList.add("flatpickr-input");
            self._input = self.input;
            if (self.config.altInput) {
                // replicate self.element
                self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
                self._input = self.altInput;
                self.altInput.placeholder = self.input.placeholder;
                self.altInput.disabled = self.input.disabled;
                self.altInput.required = self.input.required;
                self.altInput.tabIndex = self.input.tabIndex;
                self.altInput.type = "text";
                self.input.setAttribute("type", "hidden");
                if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
            }
            if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
            self._positionElement = self.config.positionElement || self._input;
        }
        function setupMobile() {
            var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
            self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
            self.mobileInput.step = self.input.getAttribute("step") || "any";
            self.mobileInput.tabIndex = 1;
            self.mobileInput.type = inputType;
            self.mobileInput.disabled = self.input.disabled;
            self.mobileInput.required = self.input.required;
            self.mobileInput.placeholder = self.input.placeholder;
            self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
            if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
            if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
            if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
            self.input.type = "hidden";
            if (self.altInput !== undefined) self.altInput.type = "hidden";
            try {
                if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
            } catch (_a) {}
            bind(self.mobileInput, "change", function(e) {
                self.setDate(e.target.value, false, self.mobileFormatStr);
                triggerEvent("onChange");
                triggerEvent("onClose");
            });
        }
        function toggle(e) {
            if (self.isOpen === true) return self.close();
            self.open(e);
        }
        function triggerEvent(event, data) {
            // If the instance has been destroyed already, all hooks have been removed
            if (self.config === undefined) return;
            var hooks = self.config[event];
            if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
            if (event === "onChange") {
                self.input.dispatchEvent(createEvent("change"));
                // many front-end frameworks bind to the input event
                self.input.dispatchEvent(createEvent("input"));
            }
        }
        function createEvent(name) {
            var e = document.createEvent("Event");
            e.initEvent(name, true, true);
            return e;
        }
        function isDateSelected(date) {
            for(var i = 0; i < self.selectedDates.length; i++){
                if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
            }
            return false;
        }
        function isDateInRange(date) {
            if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
            return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
        }
        function updateNavigationCurrentMonth() {
            if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
            self.yearElements.forEach(function(yearElement, i) {
                var d = new Date(self.currentYear, self.currentMonth, 1);
                d.setMonth(self.currentMonth + i);
                if (self.config.showMonths > 1) self.monthElements[i].textContent = monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
                else self.monthsDropdownContainer.value = d.getMonth().toString();
                yearElement.value = d.getFullYear().toString();
            });
            self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
            self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
        }
        function getDateStr(format) {
            return self.selectedDates.map(function(dObj) {
                return self.formatDate(dObj, format);
            }).filter(function(d, i, arr) {
                return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
            }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
        }
        /**
         * Updates the values of inputs associated with the calendar
         */ function updateValue(triggerChange) {
            if (triggerChange === void 0) triggerChange = true;
            if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
            self.input.value = getDateStr(self.config.dateFormat);
            if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
            if (triggerChange !== false) triggerEvent("onValueUpdate");
        }
        function onMonthNavClick(e) {
            var isPrevMonth = self.prevMonthNav.contains(e.target);
            var isNextMonth = self.nextMonthNav.contains(e.target);
            if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
            else if (self.yearElements.indexOf(e.target) >= 0) e.target.select();
            else if (e.target.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
            else if (e.target.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
        }
        function timeWrapper(e) {
            e.preventDefault();
            var isKeyDown = e.type === "keydown", input = e.target;
            if (self.amPM !== undefined && e.target === self.amPM) self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
            var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
            var newValue = curValue + step * delta;
            if (typeof input.value !== "undefined" && input.value.length === 2) {
                var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
                if (newValue < min) {
                    newValue = max + newValue + int(!isHourElem) + (int(isHourElem) && int(!self.amPM));
                    if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
                } else if (newValue > max) {
                    newValue = input === self.hourElement ? newValue - max - int(!self.amPM) : min;
                    if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
                }
                if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
                input.value = pad(newValue);
            }
        }
        init();
        return self;
    }
    /* istanbul ignore next */ function _flatpickr(nodeList, config) {
        // static list
        var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
            return x instanceof HTMLElement;
        });
        var instances = [];
        for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            try {
                if (node.getAttribute("data-fp-omit") !== null) continue;
                if (node._flatpickr !== undefined) {
                    node._flatpickr.destroy();
                    node._flatpickr = undefined;
                }
                node._flatpickr = FlatpickrInstance(node, config || {});
                instances.push(node._flatpickr);
            } catch (e) {
                console.error(e);
            }
        }
        return instances.length === 1 ? instances[0] : instances;
    }
    /* istanbul ignore next */ if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
        // browser env
        HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
            return _flatpickr(this, config);
        };
        HTMLElement.prototype.flatpickr = function(config) {
            return _flatpickr([
                this
            ], config);
        };
    }
    /* istanbul ignore next */ var flatpickr = function(selector, config) {
        if (typeof selector === "string") return _flatpickr(window.document.querySelectorAll(selector), config);
        else if (selector instanceof Node) return _flatpickr([
            selector
        ], config);
        else return _flatpickr(selector, config);
    };
    /* istanbul ignore next */ flatpickr.defaultConfig = {};
    flatpickr.l10ns = {
        en: __assign({}, english),
        "default": __assign({}, english)
    };
    flatpickr.localize = function(l10n) {
        flatpickr.l10ns["default"] = __assign({}, flatpickr.l10ns["default"], l10n);
    };
    flatpickr.setDefaults = function(config) {
        flatpickr.defaultConfig = __assign({}, flatpickr.defaultConfig, config);
    };
    flatpickr.parseDate = createDateParser({});
    flatpickr.formatDate = createDateFormatter({});
    flatpickr.compareDates = compareDates;
    /* istanbul ignore next */ if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
        return _flatpickr(this, config);
    };
    // eslint-disable-next-line @typescript-eslint/camelcase
    Date.prototype.fp_incr = function(days) {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
    };
    if (typeof window !== "undefined") window.flatpickr = flatpickr;
    return flatpickr;
});

});

parcelRegister("8Oi6a", function(module, exports) {

$parcel$export(module.exports, "getISODateString", () => $66a10832b1b846aa$export$c54af1f38086d96f);
$parcel$export(module.exports, "parseISODateString", () => $66a10832b1b846aa$export$517688cbd8a363fa);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param date A date.
 * @returns Date portion of the ISO8601 string of the given date, based on the local timezone.
 */ const $66a10832b1b846aa$export$c54af1f38086d96f = (date)=>new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString().split('T')[0];
const $66a10832b1b846aa$export$517688cbd8a363fa = (s)=>{
    const utcDate = new Date(Date.parse(s));
    return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
};

});

parcelRegister("9bapU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aed38b5d33966d8$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * The configuration for the Flatpickr plugin to put the calendar dropdown in shadow DOM.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to put the calendar dropdown in shadow DOM.
 */ var $6aed38b5d33966d8$export$2e2bcd8739ae039 = (config)=>(fp)=>{
        /**
   * Adjusts the floating meun position after Flatpicker sets it.
   */ const handlePreCalendarPosition = async ()=>{
            await Promise.resolve();
            const { calendarContainer: calendarContainer, config: fpConfig, _positionElement: positionElement } = fp;
            const { appendTo: appendTo } = fpConfig;
            const { top: containerTop } = appendTo.getBoundingClientRect();
            const { bottom: refBottom } = positionElement.getBoundingClientRect();
            const isRtl = appendTo.ownerDocument.defaultView.getComputedStyle(appendTo).getPropertyValue('direction') === 'rtl';
            calendarContainer.style.top = `${refBottom - containerTop}px`;
            calendarContainer.style.left = !isRtl ? '0' : 'auto';
            calendarContainer.style.right = !isRtl ? 'auto' : '0';
        };
        /**
   * Registers this Flatpickr plugin.
   * @param calendar The Flatpickr instance.
   */ const register = ()=>{
            fp.loadedPlugins.push('carbonFlatpickrAppendToPlugin');
        };
        return {
            appendTo: config.appendTo,
            onReady: register,
            onPreCalendarPosition: handlePreCalendarPosition
        };
    };

});

parcelRegister("eGC8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab12937ab7408e6d$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gfp9Q = parcelRequire("gfp9Q");
var /**
 * The configuration for the Flatpickr plugin to set CSS classes specific to this design system.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to set CSS classes specific to this design system.
 */ $ab12937ab7408e6d$export$2e2bcd8739ae039 = (config)=>(fp)=>{
        /**
   * Adds class names specific to our design system to calendar dropdown.
   */ const ensureClassesInDatePicker = ()=>{
            const { calendarContainer: calendarContainer, selectedDates: selectedDates } = fp;
            if (calendarContainer) {
                const { classCalendarContainer: classCalendarContainer, classMonth: classMonth, classWeekdays: classWeekdays, classDays: classDays, classWeekday: classWeekday, classDay: classDay, classNoBorder: classNoBorder, selectorFlatpickrMonth: selectorFlatpickrMonth, selectorFlatpickrWeekdays: selectorFlatpickrWeekdays, selectorFlatpickrDays: selectorFlatpickrDays, selectorFlatpickrWeekday: selectorFlatpickrWeekday, selectorFlatpickrDay: selectorFlatpickrDay, classFlatpickrToday: classFlatpickrToday } = config;
                calendarContainer.classList.add(classCalendarContainer);
                const month = calendarContainer.querySelector(selectorFlatpickrMonth);
                if (month) month.classList.add(classMonth);
                const weekdays = calendarContainer.querySelector(selectorFlatpickrWeekdays);
                if (weekdays) weekdays.classList.add(classWeekdays);
                const days = calendarContainer.querySelector(selectorFlatpickrDays);
                if (days) days.classList.add(classDays);
                (0, $gfp9Q.forEach)(calendarContainer.querySelectorAll(selectorFlatpickrWeekday), (item)=>{
                    item.innerHTML = item.innerHTML.replace(/\s+/g, '');
                    item.classList.add(classWeekday);
                });
                (0, $gfp9Q.forEach)(calendarContainer.querySelectorAll(selectorFlatpickrDay), (item)=>{
                    item.classList.add(classDay);
                    if (item.classList.contains(classFlatpickrToday) && selectedDates.length > 0) item.classList.add(classNoBorder);
                    else if (item.classList.contains(classFlatpickrToday) && selectedDates.length === 0) item.classList.remove(classNoBorder);
                });
            }
        };
        /**
   * Registers this Flatpickr plugin.
   */ const register = ()=>{
            fp.loadedPlugins.push('carbonFlatpickrCSSClassPlugin');
        };
        return {
            onMonthChange: ensureClassesInDatePicker,
            onYearChange: ensureClassesInDatePicker,
            onValueUpdate: ensureClassesInDatePicker,
            onOpen: ensureClassesInDatePicker,
            onReady: [
                register
            ]
        };
    };

});

parcelRegister("2yINf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd180c106ade8b2$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2jTfi = parcelRequire("2jTfi");
var /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to fix Flatpickr's behavior of certain events.
 */ $1dd180c106ade8b2$export$2e2bcd8739ae039 = (config)=>(fp)=>{
        /**
   * Handles `keydown` event.
   */ const handleKeydown = (event)=>{
            const { inputFrom: inputFrom, inputTo: inputTo } = config;
            const { key: key, target: target } = event;
            if (inputFrom === target || inputTo === target) switch(key){
                case 'Enter':
                    // Makes sure the hitting enter key picks up pending values of both `<input>`
                    // Workaround for: https://github.com/flatpickr/flatpickr/issues/1942
                    fp.setDate([
                        inputFrom.value,
                        inputTo && inputTo.value
                    ], true, fp.config.dateFormat);
                    event.stopPropagation();
                    break;
                case 'ArrowLeft':
                case 'Left':
                case 'ArrowRight':
                case 'Right':
                    // Prevents Flatpickr code from canceling the event if left/right arrow keys are hit on `<input>`,
                    // so user can move the keyboard cursor for editing dates
                    // Workaround for: https://github.com/flatpickr/flatpickr/issues/1943
                    event.stopPropagation();
                    break;
                default:
                    break;
            }
        };
        /**
   * Releases event listeners used in this Flatpickr plugin.
   */ const release = ()=>{
            if (fp._hBXCEDatePickerFixEventsPluginKeydownTo) fp._hBXCEDatePickerFixEventsPluginKeydownTo = fp._hBXCEDatePickerFixEventsPluginKeydownTo.release();
            if (fp._hBXCEDatePickerFixEventsPluginKeydownFrom) fp._hBXCEDatePickerFixEventsPluginKeydownFrom = fp._hBXCEDatePickerFixEventsPluginKeydownFrom.release();
        };
        /**
   * Sets up event listeners used for this Flatpickr plugin.
   */ const init = ()=>{
            release();
            const { inputFrom: inputFrom, inputTo: inputTo } = config;
            fp._hBXCEDatePickerFixEventsPluginKeydownFrom = (0, $2jTfi.default)(inputFrom, 'keydown', handleKeydown, true);
            if (inputTo) fp._hBXCEDatePickerFixEventsPluginKeydownTo = (0, $2jTfi.default)(inputTo, 'keydown', handleKeydown, true);
        };
        /**
   * Registers this Flatpickr plugin.
   */ const register = ()=>{
            fp.loadedPlugins.push('carbonFlatpickrFixEventsPlugin');
        };
        return {
            onReady: [
                register,
                init
            ],
            onDestroy: [
                release
            ]
        };
    };

});

parcelRegister("4v7hI", function(module, exports) {

$parcel$export(module.exports, "default", () => $346fb54759dcf3ba$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2jTfi = parcelRequire("2jTfi");
var /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to manage focus to align with the UX pattern in our design system.
 */ $346fb54759dcf3ba$export$2e2bcd8739ae039 = (config)=>(fp)=>{
        /**
   * Focuses on calendar dropdown.
   */ const focusCalendar = ()=>{
            const { calendarContainer: calendarContainer, selectedDateElem: selectedDateElem, todayDateElem: todayDateElem } = fp;
            (selectedDateElem || todayDateElem || calendarContainer).focus();
        };
        /**
   * Handles `blur` event to move the focus back to the `<input>`.
   */ const handleBlur = ({ target: target, relatedTarget: relatedTarget })=>{
            // Obtains `beingUpdated` up-front because it'll be flushed out shortly
            const { calendarContainer: calendarContainer, isOpen: isOpen } = fp;
            if (isOpen && calendarContainer.contains(target) && !calendarContainer.contains(relatedTarget)) Promise.resolve().then(()=>{
                const rootNode = target.getRootNode(); // This `blur` event handler can be called from Flatpickr's code cleaning up calenar dropdown's DOM,
                // and changing focus in such condition causes removing an orphaned DOM node,
                // because Flatpickr redraws the calendar dropdown when the `<input>` gets focus.
                if (rootNode.nodeType === Node.DOCUMENT_NODE || rootNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                    if (fp._lastFocusInput === config.inputTo) config.inputTo.focus();
                    else config.inputFrom.focus();
                     // Closing after moving focus. Reversing the order will cause re-opening calendar dropdown upon focusing
                    fp.close();
                }
            });
        };
        /**
   * Handles `keydown` event to move focus on calendar dropdown.
   */ const handleInputKeydown = (event)=>{
            const { key: key } = event;
            if (key === 'ArrowDown' || key === 'Down' || key === 'Enter') {
                event.preventDefault();
                fp.open();
                if (key !== 'Enter') focusCalendar();
                else // Hitting Enter key blurs the `<input>`, causing any element to lose focus
                setTimeout(focusCalendar, 0);
            }
        };
        /**
   * Handles `focus` event on `<input>` for starting/end date to track the lastly focused one.
   */ const handleInputFocus = ({ target: target })=>{
            fp._lastFocusInput = target;
        };
        /**
   * Releases event listeners used in this Flatpickr plugin.
   */ const release = ()=>{
            if (fp._hBXCEDatePickerFocusPluginBlur) fp._hBXCEDatePickerFocusPluginBlur = fp._hBXCEDatePickerFocusPluginBlur.release();
            if (fp._hBXCEDatePickerFocusPluginFocusTo) fp._hBXCEDatePickerFocusPluginFocusTo = fp._hBXCEDatePickerFocusPluginFocusTo.release();
            if (fp._hBXCEDatePickerFocusPluginFocusFrom) fp._hBXCEDatePickerFocusPluginFocusFrom = fp._hBXCEDatePickerFocusPluginFocusFrom.release();
            if (fp._hBXCEDatePickerFocusPluginKeydownTo) fp._hBXCEDatePickerFocusPluginKeydownTo = fp._hBXCEDatePickerFocusPluginKeydownTo.release();
            if (fp._hBXCEDatePickerFocusPluginKeydownFrom) fp._hBXCEDatePickerFocusPluginKeydownFrom = fp._hBXCEDatePickerFocusPluginKeydownFrom.release();
        };
        /**
   * Sets up event listeners used for this Flatpickr plugin.
   */ const init = ()=>{
            release();
            const { inputFrom: inputFrom, inputTo: inputTo } = config;
            fp._hBXCEDatePickerFocusPluginBlur = (0, $2jTfi.default)(fp.calendarContainer, 'blur', handleBlur, true);
            fp._hBXCEDatePickerFocusPluginKeydownFrom = (0, $2jTfi.default)(inputFrom, 'keydown', handleInputKeydown);
            if (inputTo) fp._hBXCEDatePickerFocusPluginKeydownTo = (0, $2jTfi.default)(inputTo, 'keydown', handleInputKeydown);
            fp._hBXCEDatePickerFocusPluginFocusFrom = (0, $2jTfi.default)(inputFrom, 'focus', handleInputFocus);
            if (inputTo) fp._hBXCEDatePickerFocusPluginFocusTo = (0, $2jTfi.default)(inputTo, 'focus', handleInputFocus);
        };
        /**
   * Registers this Flatpickr plugin.
   * @param calendar The Flatpickr instance.
   */ const register = ()=>{
            fp.loadedPlugins.push('carbonFlatpickrFocusPlugin');
        };
        return {
            onReady: [
                register,
                init
            ],
            onDestroy: release
        };
    };

});

parcelRegister("xYt50", function(module, exports) {

$parcel$export(module.exports, "default", () => $0661fcdf8c7de11a$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ parcelRequire("3tvu5");
var $ia8jV = parcelRequire("ia8jV");

var $Wrz5d = parcelRequire("Wrz5d");

var $9VuLY = parcelRequire("9VuLY");
var /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to set the right icons in the design system.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to set the right icons in the design system.
 */ $0661fcdf8c7de11a$export$2e2bcd8739ae039 = ()=>(fp)=>{
        /**
   * Sets the icon in the design system.
   */ const setIcon = ()=>{
            const { prevMonthNav: prevMonthNav, nextMonthNav: nextMonthNav } = fp;
            (0, $ia8jV.render)((0, $Wrz5d.default)(), prevMonthNav);
            (0, $ia8jV.render)((0, $9VuLY.default)(), nextMonthNav);
        };
        /**
   * Sets empty arrow icon contents as we render those icons after initialization.
   */ const parseConfig = ()=>{
            const { config: config } = fp;
            config.prevArrow = '';
            config.nextArrow = '';
        };
        /**
   * Registers this Flatpickr plugin.
   * @param calendar The Flatpickr instance.
   */ const register = ()=>{
            fp.loadedPlugins.push('carbonFlatpickrIconPlugin');
        };
        return {
            onParseConfig: parseConfig,
            onReady: [
                register,
                setIcon
            ]
        };
    };

});
parcelRegister("Wrz5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afaccb363097308$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $3tvu5 = parcelRequire("3tvu5");

var $fxyjq = parcelRequire("fxyjq");
const $0afaccb363097308$var$svgResultCarbonIcon = ({ children: children, ...attrs } = {})=>(0, $3tvu5.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, $fxyjq.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}${children}${children}<path d="M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"></path></svg>`;
var $0afaccb363097308$export$2e2bcd8739ae039 = $0afaccb363097308$var$svgResultCarbonIcon;

});

parcelRegister("9VuLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a14ec5a980f0ec$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $3tvu5 = parcelRequire("3tvu5");

var $fxyjq = parcelRequire("fxyjq");
const $73a14ec5a980f0ec$var$svgResultCarbonIcon = ({ children: children, ...attrs } = {})=>(0, $3tvu5.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, $fxyjq.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">${children}${children}${children}<path d="M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"></path></svg>`;
var $73a14ec5a980f0ec$export$2e2bcd8739ae039 = $73a14ec5a980f0ec$var$svgResultCarbonIcon;

});


parcelRegister("gJjga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2dfc9e35026e124$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gfp9Q = parcelRequire("gfp9Q");
/**
 * @param monthNumber The month number.
 * @param shorthand `true` to use shorthand month.
 * @param locale The Flatpickr locale data.
 * @returns The month string.
 */ const $c2dfc9e35026e124$var$monthToStr = (monthNumber, shorthand, locale)=>locale.months[shorthand ? 'shorthand' : 'longhand'][monthNumber];
var /**
 * The configuration for the Flatpickr plugin to use text instead of `<select>` for month picker.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to use text instead of `<select>` for month picker.
 */ $c2dfc9e35026e124$export$2e2bcd8739ae039 = (config)=>(fp)=>{
        /**
   * Replaces `<select>` for month with text content.
   */ const setupElements = ()=>{
            const { monthElements: monthElements, yearElements: yearElements, currentMonth: currentMonth, l10n: l10n, _createElement: createElement } = fp;
            if (!monthElements) return;
            const { shorthand: shorthand, selectorFlatpickrMonthYearContainer: selectorFlatpickrMonthYearContainer, selectorFlatpickrYearContainer: selectorFlatpickrYearContainer, classFlatpickrCurrentMonth: classFlatpickrCurrentMonth } = config;
            monthElements.forEach((elem)=>{
                if (!elem.parentNode) return;
                elem.parentNode.removeChild(elem);
            });
            monthElements.splice(0, monthElements.length, ...monthElements.map(()=>{
                const monthElement = createElement('span', classFlatpickrCurrentMonth);
                monthElement.textContent = $c2dfc9e35026e124$var$monthToStr(currentMonth, shorthand === true, l10n);
                const monthYearContainer = yearElements[0].closest(selectorFlatpickrMonthYearContainer);
                if (monthYearContainer) monthYearContainer.insertBefore(monthElement, yearElements[0].closest(selectorFlatpickrYearContainer));
                return monthElement;
            }));
        };
        /**
   * Updates the text-based month UI with the latest selected date.
   */ const updateCurrentMonth = ()=>{
            const { yearElements: yearElements, currentMonth: currentMonth, l10n: l10n } = fp;
            const { shorthand: shorthand, selectorFlatpickrMonthYearContainer: selectorFlatpickrMonthYearContainer, selectorFlatpickrCurrentMonth: selectorFlatpickrCurrentMonth } = config;
            const monthStr = $c2dfc9e35026e124$var$monthToStr(currentMonth, shorthand === true, l10n);
            yearElements.forEach((elem)=>{
                const currentMonthContainer = elem.closest(selectorFlatpickrMonthYearContainer);
                if (currentMonthContainer) (0, $gfp9Q.forEach)(currentMonthContainer.querySelectorAll(selectorFlatpickrCurrentMonth), (monthElement)=>{
                    monthElement.textContent = monthStr;
                });
            });
        };
        /**
   * Registers this Flatpickr plugin.
   */ const register = ()=>{
            fp.loadedPlugins.push('carbonFlatpickrMonthSelectPlugin');
        };
        return {
            onMonthChange: updateCurrentMonth,
            onValueUpdate: updateCurrentMonth,
            onOpen: updateCurrentMonth,
            onReady: [
                setupElements,
                updateCurrentMonth,
                register
            ]
        };
    };

});

parcelRegister("9fzAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc11fbc27cdb9bc$export$2e2bcd8739ae039);

var $ftPDQ = parcelRequire("ftPDQ");

var $gXhNO = parcelRequire("gXhNO");
var /**
 * @param config Plugin configuration.
 * @returns
 *   An extension of Flatpickr `rangePlugin` that does the following:
 *
 *   * Better ensures the calendar dropdown is always aligned to the `<input>` for the starting date.
 *     Workaround for: https://github.com/flatpickr/flatpickr/issues/1944
 *   * Disables the logic in Flatpickr `rangePlugin` that calculates the new range with the old selected date
 *     when user selects a date from calendar dropdown.
 *     We'd like to reset the selection when user re-opens calendar dropdown and re-selects a date.
 *     Workaround for: https://github.com/flatpickr/flatpickr/issues/1958
 *   * Disables the logic in Flatpickr `rangePlugin` that closes the calendar dropdown
 *     when it's lauched from the `<input>` for the end date and user selects a date.
 *     Workaround for: https://github.com/flatpickr/flatpickr/issues/1958
 *   * Ensures that the `<input>` in shadow DOM is treated as part of Flatpickr UI,
 *     by ensuring such `<input>` hits `.contains()` search from `fp.config.ignoredFocusElements`.
 *     Without that, Flatpickr clears the `<input>` when end date hasn't been selected yet (which we don't want).
 */ $6bc11fbc27cdb9bc$export$2e2bcd8739ae039 = (config)=>{
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($gXhNO)))((0, $ftPDQ.default)({
        position: 'left'
    }, config));
    return (fp)=>{
        const origRangePlugin = factory(fp);
        const { onReady: origOnReady } = origRangePlugin;
        return Object.assign(origRangePlugin, {
            onChange () {},
            onPreCalendarPosition () {},
            onValueUpdate (selectedDates) {
                const [startDateFormatted, endDateFormatted] = selectedDates.map((item)=>fp.formatDate(item, fp.config.dateFormat));
                if (startDateFormatted) fp._input.value = startDateFormatted;
                if (endDateFormatted) config.input.value = endDateFormatted;
            },
            onReady () {
                origOnReady.call(this);
                const { ignoredFocusElements: ignoredFocusElements } = fp.config;
                ignoredFocusElements.push(...ignoredFocusElements.map((elem)=>elem.shadowRoot).filter(Boolean));
            }
        });
    };
};

});
parcelRegister("gXhNO", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function rangePlugin(config) {
        if (config === void 0) config = {};
        return function(fp) {
            var dateFormat = "", secondInput, _secondInputFocused, _prevDates;
            var createSecondInput = function() {
                if (config.input) {
                    secondInput = config.input instanceof Element ? config.input : window.document.querySelector(config.input);
                    if (!secondInput) {
                        fp.config.errorHandler(new Error("Invalid input element specified"));
                        return;
                    }
                    if (fp.config.wrap) secondInput = secondInput.querySelector("[data-input]");
                } else {
                    secondInput = fp._input.cloneNode();
                    secondInput.removeAttribute("id");
                    secondInput._flatpickr = undefined;
                }
                if (secondInput.value) {
                    var parsedDate = fp.parseDate(secondInput.value);
                    if (parsedDate) fp.selectedDates.push(parsedDate);
                }
                secondInput.setAttribute("data-fp-omit", "");
                fp._bind(secondInput, [
                    "focus",
                    "click"
                ], function() {
                    if (fp.selectedDates[1]) {
                        fp.latestSelectedDateObj = fp.selectedDates[1];
                        fp._setHoursFromDate(fp.selectedDates[1]);
                        fp.jumpToDate(fp.selectedDates[1]);
                    }
                    _secondInputFocused = true;
                    fp.isOpen = false;
                    fp.open(undefined, config.position === "left" ? fp._input : secondInput);
                });
                fp._bind(fp._input, [
                    "focus",
                    "click"
                ], function(e) {
                    e.preventDefault();
                    fp.isOpen = false;
                    fp.open();
                });
                if (fp.config.allowInput) fp._bind(secondInput, "keydown", function(e) {
                    if (e.key === "Enter") {
                        fp.setDate([
                            fp.selectedDates[0],
                            secondInput.value
                        ], true, dateFormat);
                        secondInput.click();
                    }
                });
                if (!config.input) fp._input.parentNode && fp._input.parentNode.insertBefore(secondInput, fp._input.nextSibling);
            };
            var plugin = {
                onParseConfig: function() {
                    fp.config.mode = "range";
                    dateFormat = fp.config.altInput ? fp.config.altFormat : fp.config.dateFormat;
                },
                onReady: function() {
                    createSecondInput();
                    fp.config.ignoredFocusElements.push(secondInput);
                    if (fp.config.allowInput) {
                        fp._input.removeAttribute("readonly");
                        secondInput.removeAttribute("readonly");
                    } else secondInput.setAttribute("readonly", "readonly");
                    fp._bind(fp._input, "focus", function() {
                        fp.latestSelectedDateObj = fp.selectedDates[0];
                        fp._setHoursFromDate(fp.selectedDates[0]);
                        _secondInputFocused = false;
                        fp.jumpToDate(fp.selectedDates[0]);
                    });
                    if (fp.config.allowInput) fp._bind(fp._input, "keydown", function(e) {
                        if (e.key === "Enter") fp.setDate([
                            fp._input.value,
                            fp.selectedDates[1]
                        ], true, dateFormat);
                    });
                    fp.setDate(fp.selectedDates, false);
                    plugin.onValueUpdate(fp.selectedDates);
                    fp.loadedPlugins.push("range");
                },
                onPreCalendarPosition: function() {
                    if (_secondInputFocused) {
                        fp._positionElement = secondInput;
                        setTimeout(function() {
                            fp._positionElement = fp._input;
                        }, 0);
                    }
                },
                onChange: function() {
                    if (!fp.selectedDates.length) setTimeout(function() {
                        if (fp.selectedDates.length) return;
                        secondInput.value = "";
                        _prevDates = [];
                    }, 10);
                    if (_secondInputFocused) setTimeout(function() {
                        secondInput.focus();
                    }, 0);
                },
                onDestroy: function() {
                    if (!config.input) secondInput.parentNode && secondInput.parentNode.removeChild(secondInput);
                },
                onValueUpdate: function(selDates) {
                    var _a, _b, _c;
                    if (!secondInput) return;
                    _prevDates = !_prevDates || selDates.length >= _prevDates.length ? selDates.slice() : _prevDates;
                    if (_prevDates.length > selDates.length) {
                        var newSelectedDate = selDates[0];
                        var newDates = _secondInputFocused ? [
                            _prevDates[0],
                            newSelectedDate
                        ] : [
                            newSelectedDate,
                            _prevDates[1]
                        ];
                        fp.setDate(newDates, false);
                        _prevDates = newDates.slice();
                    }
                    _a = fp.selectedDates.map(function(d) {
                        return fp.formatDate(d, dateFormat);
                    }), _b = _a[0], fp._input.value = _b === void 0 ? "" : _b, _c = _a[1], secondInput.value = _c === void 0 ? "" : _c;
                }
            };
            return plugin;
        };
    }
    return rangePlugin;
});

});


parcelRegister("bmkho", function(module, exports) {

$parcel$export(module.exports, "default", () => $84517ada31ee1dda$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2jTfi = parcelRequire("2jTfi");

var $gfp9Q = parcelRequire("gfp9Q");
/**
 * `FlatpickrInstance` with additional properties used for `carbonFlatpickrShadowDOMEventsPlugin`.
 */ /**
 * The amount of days to adjust, keyed by the key code.
 */ const $84517ada31ee1dda$var$moveDateForKeys = {
    ArrowLeft: -1,
    Left: -1,
    ArrowUp: -7,
    Up: -7,
    ArrowRight: 1,
    Right: 1,
    ArrowDown: 7,
    Down: 7
};
/**
 * The amount of months to adjust, keyed by the key code. Used with Ctrl modifier key.
 */ const $84517ada31ee1dda$var$moveMonthForKeys = {
    ArrowLeft: -1,
    Left: -1,
    ArrowUp: -12,
    Up: -12,
    ArrowRight: 1,
    Right: 1,
    ArrowDown: 12,
    Down: 12
};
/**
 * The number of milliseconds per day.
 */ const $84517ada31ee1dda$var$MILLISECONDS_IN_DAY = 86400000;
/**
 * Adjusts the date with the given amount of days.
 * @param localDate The original date.
 * @param options The options.
 * @param [options.date=0] The amount of days to adjust.
 */ const $84517ada31ee1dda$var$adjustDate = (localDate, { date: moveDate = 0 })=>{
    const utcDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate()) + moveDate * $84517ada31ee1dda$var$MILLISECONDS_IN_DAY);
    return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
};
var /**
 * @param config Plugin configuration.
 * @returns
 *   A Flatpickr plugin to handle events.
 *   Some event handlers in Flatpickr won't work is the calendar dropdown is put in shadow DOM, due to event retargetting.
 */ $84517ada31ee1dda$export$2e2bcd8739ae039 = ()=>(fp)=>{
        const getDateElem = (localDate)=>(0, $gfp9Q.find)(fp.daysContainer.firstElementChild.children, ({ dateObj: dateObj })=>localDate.getTime() === dateObj.getTime());
        /**
   * Handles `keydown` event.
   */ const handleKeydown = (event)=>{
            const { ctrlKey: ctrlKey, key: key, target: target } = event;
            if (key === 'Enter') target.dispatchEvent(Object.assign(new CustomEvent('mousedown', {
                bubbles: true
            }), {
                which: 1
            }));
            else if (!ctrlKey && key in $84517ada31ee1dda$var$moveDateForKeys) {
                const { dateObj: dateObj } = target;
                const movedDate = $84517ada31ee1dda$var$adjustDate(dateObj, {
                    date: $84517ada31ee1dda$var$moveDateForKeys[key]
                });
                const movedDateElem = getDateElem(movedDate);
                if (movedDateElem) movedDateElem.focus();
                else {
                    const innerDaysContainer = fp.daysContainer.firstElementChild;
                    if (movedDate.getTime() < innerDaysContainer.firstElementChild.dateObj.getTime()) {
                        fp.changeMonth(-1); // `fp.daysContainer` is updated by `fp.changeMonth()`
                        fp.daysContainer.firstElementChild.lastElementChild.focus();
                    } else if (movedDate.getTime() > innerDaysContainer.lastElementChild.dateObj.getTime()) {
                        fp.changeMonth(1); // `fp.daysContainer` is updated by `fp.changeMonth()`
                        fp.daysContainer.firstElementChild.firstElementChild.focus();
                    }
                }
                event.preventDefault();
            } else if (ctrlKey && key in $84517ada31ee1dda$var$moveMonthForKeys) {
                fp.changeMonth($84517ada31ee1dda$var$moveMonthForKeys[key]);
                fp.daysContainer.firstElementChild.firstElementChild.focus();
                event.preventDefault();
            }
        };
        /**
   * Releases event listeners used in this Flatpickr plugin.
   */ const release = ()=>{
            if (fp._hBXCEDatePickerShadowDOMEventsPluginKeydown) fp._hBXCEDatePickerShadowDOMEventsPluginKeydown = fp._hBXCEDatePickerShadowDOMEventsPluginKeydown.release();
        };
        /**
   * Sets up event listeners used for this Flatpickr plugin.
   */ const init = ()=>{
            release();
            fp._hBXCEDatePickerShadowDOMEventsPluginKeydown = (0, $2jTfi.default)(fp.calendarContainer, 'keydown', handleKeydown);
        };
        /**
   * Registers this Flatpickr plugin.
   */ const register = ()=>{
            fp.loadedPlugins.push('carbonFlatpickrShadowDOMEventsPlugin');
        };
        return {
            onReady: [
                register,
                init
            ],
            onDestroy: [
                release
            ]
        };
    };

});

parcelRegister("1nf84", function(module, exports) {

$parcel$export(module.exports, "default", () => $1003acc484824e50$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * @param config Plugin configuration.
 * @returns A Flatpickr plugin to handshake states with `<bx-date-picker>`.
 */ var $1003acc484824e50$export$2e2bcd8739ae039 = (datePicker)=>(fp)=>{
        /**
   * Sets open state.
   */ const setOpen = ()=>{
            datePicker.open = true;
        };
        /**
   * Sets closed state.
   */ const setClosed = ()=>{
            datePicker.open = false;
        };
        /**
   * Propagates Flatpickr's `onChange` event to `<bx-date-picker>`.
   * @param selectedDates The latest selected dates.
   */ const handleChange = (selectedDates)=>{
            const { eventChange: eventChange } = datePicker.constructor;
            datePicker.dispatchEvent(new CustomEvent(eventChange, {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: {
                    selectedDates: selectedDates
                }
            }));
        };
        /**
   * Registers this Flatpickr plugin.
   * @param calendar The Flatpickr instance.
   */ const register = (_selectedDates, _value, calendar)=>{
            datePicker.calendar = calendar;
            fp.loadedPlugins.push('carbonFlatpickrStateHandshakePlugin');
        };
        return {
            onOpen: setOpen,
            onClose: setClosed,
            onChange: handleChange,
            onReady: [
                register
            ]
        };
    };

});

parcelRegister("fzJHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b56d936e071d543f$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ parcelRequire("3eEWe");
var $cH4lK = parcelRequire("cH4lK");
var $b56d936e071d543f$export$2e2bcd8739ae039 = (0, $cH4lK.css)([
    "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{padding:0;border:0;margin:0;font:inherit;font-size:100%;vertical-align:baseline}button,input,select,textarea{border-radius:0;font-family:inherit}input[type=text]::-ms-clear{display:none}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}body{line-height:1}sup{vertical-align:super}sub{vertical-align:sub}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote::after,blockquote::before,q::after,q::before{content:\"\"}table{border-collapse:collapse;border-spacing:0}*{box-sizing:border-box}button{margin:0}html{font-size:100%}body{font-weight:400;font-family:'IBM Plex Sans','Helvetica Neue',Arial,sans-serif;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}code{font-family:'IBM Plex Mono',Menlo,'DejaVu Sans Mono','Bitstream Vera Sans Mono',Courier,monospace}strong{font-weight:600}@media screen and (-ms-high-contrast:active){svg{fill:ButtonText}}h1{font-size:var(--cds-productive-heading-06-font-size,2.625rem);font-weight:var(--cds-productive-heading-06-font-weight,300);line-height:var(--cds-productive-heading-06-line-height,1.199);letter-spacing:var(--cds-productive-heading-06-letter-spacing,0)}h2{font-size:var(--cds-productive-heading-05-font-size,2rem);font-weight:var(--cds-productive-heading-05-font-weight,400);line-height:var(--cds-productive-heading-05-line-height,1.25);letter-spacing:var(--cds-productive-heading-05-letter-spacing,0)}h3{font-size:var(--cds-productive-heading-04-font-size,1.75rem);font-weight:var(--cds-productive-heading-04-font-weight,400);line-height:var(--cds-productive-heading-04-line-height,1.28572);letter-spacing:var(--cds-productive-heading-04-letter-spacing,0)}h4{font-size:var(--cds-productive-heading-03-font-size,1.25rem);font-weight:var(--cds-productive-heading-03-font-weight,400);line-height:var(--cds-productive-heading-03-line-height,1.4);letter-spacing:var(--cds-productive-heading-03-letter-spacing,0)}h5{font-size:var(--cds-productive-heading-02-font-size,1rem);font-weight:var(--cds-productive-heading-02-font-weight,600);line-height:var(--cds-productive-heading-02-line-height,1.375);letter-spacing:var(--cds-productive-heading-02-letter-spacing,0)}h6{font-size:var(--cds-productive-heading-01-font-size,.875rem);font-weight:var(--cds-productive-heading-01-font-weight,600);line-height:var(--cds-productive-heading-01-line-height,1.28572);letter-spacing:var(--cds-productive-heading-01-letter-spacing,.16px)}p{font-size:var(--cds-body-long-02-font-size,1rem);font-weight:var(--cds-body-long-02-font-weight,400);line-height:var(--cds-body-long-02-line-height,1.5);letter-spacing:var(--cds-body-long-02-letter-spacing,0)}a{color:#0f62fe}em{font-style:italic}.bx--assistive-text,.bx--visually-hidden{position:absolute;overflow:hidden;width:1px;height:1px;padding:0;border:0;margin:-1px;clip:rect(0,0,0,0);visibility:inherit;white-space:nowrap}.bx--body{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);background-color:var(--cds-ui-background,#fff);color:var(--cds-text-01,#161616);line-height:1}.bx--body *,.bx--body ::after,.bx--body ::before{box-sizing:inherit}@-webkit-keyframes skeleton{0%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}20%{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}28%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}51%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}58%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}82%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}83%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}96%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}100%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}}@keyframes skeleton{0%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}20%{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}28%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}51%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}58%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}82%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}83%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}96%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}100%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}}.bx--fieldset{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;margin-bottom:2rem}.bx--fieldset *,.bx--fieldset ::after,.bx--fieldset ::before{box-sizing:inherit}.bx--fieldset--no-margin{margin-bottom:0}.bx--form-item{font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);display:flex;flex:1 1 auto;flex-direction:column;align-items:flex-start}.bx--label{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);line-height:var(--cds-label-01-line-height,1.33333);letter-spacing:var(--cds-label-01-letter-spacing,.32px);display:inline-block;margin-bottom:.5rem;color:var(--cds-text-02,#525252);font-weight:400;line-height:1rem;vertical-align:baseline}.bx--label *,.bx--label ::after,.bx--label ::before{box-sizing:inherit}.bx--label .bx--tooltip__trigger{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);line-height:var(--cds-label-01-line-height,1.33333);letter-spacing:var(--cds-label-01-letter-spacing,.32px)}.bx--label.bx--skeleton{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none;width:4.6875rem;height:.875rem}.bx--label.bx--skeleton:active,.bx--label.bx--skeleton:focus,.bx--label.bx--skeleton:hover{border:none;cursor:default;outline:0}.bx--label.bx--skeleton::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.bx--label.bx--skeleton::before{-webkit-animation:none;animation:none}}input[type=number]{font-family:'IBM Plex Mono',Menlo,'DejaVu Sans Mono','Bitstream Vera Sans Mono',Courier,monospace}.bx--combo-box[data-invalid] .bx--text-input:not(:focus),.bx--list-box[data-invalid]:not(:focus),.bx--number[data-invalid] input[type=number]:not(:focus),.bx--select-input__wrapper[data-invalid] .bx--select-input:not(:focus),.bx--text-area__wrapper[data-invalid]>.bx--text-area--invalid:not(:focus),.bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-01,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.bx--combo-box[data-invalid] .bx--text-input:not(:focus),.bx--list-box[data-invalid]:not(:focus),.bx--number[data-invalid] input[type=number]:not(:focus),.bx--select-input__wrapper[data-invalid] .bx--select-input:not(:focus),.bx--text-area__wrapper[data-invalid]>.bx--text-area--invalid:not(:focus),.bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.bx--date-picker-input__wrapper--invalid~.bx--form-requirement,.bx--date-picker-input__wrapper--warn~.bx--form-requirement,.bx--date-picker-input__wrapper~.bx--form-requirement,.bx--list-box--warning~.bx--form-requirement,.bx--list-box[data-invalid]~.bx--form-requirement,.bx--number[data-invalid] .bx--number__input-wrapper~.bx--form-requirement,.bx--number__input-wrapper--warning~.bx--form-requirement,.bx--select--warning .bx--select-input__wrapper~.bx--form-requirement,.bx--select-input__wrapper[data-invalid]~.bx--form-requirement,.bx--text-area__wrapper[data-invalid]~.bx--form-requirement,.bx--text-input__field-wrapper--warning>.bx--text-input~.bx--form-requirement,.bx--text-input__field-wrapper--warning~.bx--form-requirement,.bx--text-input__field-wrapper[data-invalid]~.bx--form-requirement,.bx--time-picker--invalid~.bx--form-requirement,.bx--time-picker[data-invalid]~.bx--form-requirement,input[data-invalid]~.bx--form-requirement{display:block;overflow:visible;max-height:12.5rem;font-weight:400}.bx--date-picker-input__wrapper--invalid~.bx--form-requirement,.bx--date-picker-input__wrapper~.bx--form-requirement,.bx--list-box[data-invalid]~.bx--form-requirement,.bx--number[data-invalid] .bx--number__input-wrapper~.bx--form-requirement,.bx--select-input__wrapper[data-invalid]~.bx--form-requirement,.bx--text-area__wrapper[data-invalid]~.bx--form-requirement,.bx--text-input__field-wrapper[data-invalid]~.bx--form-requirement,.bx--time-picker--invalid~.bx--form-requirement,.bx--time-picker[data-invalid]~.bx--form-requirement,input[data-invalid]~.bx--form-requirement{color:var(--cds-text-error,#da1e28)}.bx--form--fluid .bx--text-input__field-wrapper--warning,.bx--form--fluid .bx--text-input__field-wrapper[data-invalid]{display:block}.bx--form--fluid .bx--fieldset{margin:0}.bx--form--fluid input[data-invalid]{outline:0}.bx--form--fluid .bx--form-requirement{padding:.5rem 2.5rem .5rem 1rem;margin:0}input:not(output):not([data-invalid]):-moz-ui-invalid{box-shadow:none}.bx--form-requirement{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-caption-01-font-size,.75rem);font-weight:var(--cds-caption-01-font-weight,400);line-height:var(--cds-caption-01-line-height,1.33333);letter-spacing:var(--cds-caption-01-letter-spacing,.32px);display:none;overflow:hidden;max-height:0;margin:.25rem 0 0}.bx--form-requirement *,.bx--form-requirement ::after,.bx--form-requirement ::before{box-sizing:inherit}.bx--select--inline .bx--form__helper-text{margin-top:0}.bx--form__helper-text{font-size:var(--cds-helper-text-01-font-size,.75rem);line-height:var(--cds-helper-text-01-line-height,1.33333);letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);z-index:0;width:100%;margin-top:.25rem;color:var(--cds-text-02,#525252);opacity:1}.bx--form__helper-text--disabled,.bx--label--disabled{color:var(--cds-disabled-02,#c6c6c6)}fieldset[disabled] .bx--form__helper-text,fieldset[disabled] .bx--label{color:var(--cds-disabled-02,#c6c6c6)}@-webkit-keyframes fpFadeInDown{from{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);opacity:1}}@keyframes fpFadeInDown{from{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);opacity:1}}@-webkit-keyframes fpSlideLeft{from{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes fpSlideLeft{from{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}to{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@-webkit-keyframes fpSlideLeftNew{from{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}@keyframes fpSlideLeftNew{from{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}@-webkit-keyframes fpSlideRight{from{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes fpSlideRight{from{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}to{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@-webkit-keyframes fpSlideRightNew{from{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}@keyframes fpSlideRightNew{from{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}}@-webkit-keyframes fpFadeOut{from{opacity:1}to{opacity:0}}@keyframes fpFadeOut{from{opacity:1}to{opacity:0}}@-webkit-keyframes fpFadeIn{from{opacity:0}to{opacity:1}}@keyframes fpFadeIn{from{opacity:0}to{opacity:1}}.flatpickr-calendar{position:absolute;box-sizing:border-box;width:19.6875rem;max-height:0;padding:0;overflow:hidden;direction:ltr;text-align:center;border:0;border-radius:0;visibility:hidden;opacity:0;-webkit-animation:none;animation:none;touch-action:manipulation}.flatpickr-calendar.inline,.flatpickr-calendar.open{max-height:40rem;overflow:visible;visibility:inherit;opacity:1}.flatpickr-calendar.open{box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;width:18rem;height:21rem;margin-top:-.125rem;padding:.25rem .25rem .5rem .25rem;overflow:hidden;background-color:var(--cds-ui-01,#f4f4f4);border:none}.flatpickr-calendar.open:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.flatpickr-calendar.open:focus{outline-style:dotted}}.flatpickr-calendar.animate.open{-webkit-animation:fpFadeInDown 110ms cubic-bezier(0,0,.38,.9);animation:fpFadeInDown 110ms cubic-bezier(0,0,.38,.9)}.flatpickr-calendar.inline{position:relative;top:.125rem;display:block}.flatpickr-calendar.static{position:absolute;top:calc(100% + 2px)}.flatpickr-calendar.static.open{z-index:999;display:block}.flatpickr-calendar.hasWeeks{width:auto}.dayContainer{display:flex;flex-wrap:wrap;justify-content:space-around;height:15.375rem;padding:0;outline:0}.flatpickr-calendar .hasTime .dayContainer,.flatpickr-calendar .hasWeeks .dayContainer{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.flatpickr-calendar .hasWeeks .dayContainer{border-left:0}.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time{height:2.5rem;border-top:1px solid #e6e6e6}.flatpickr-calendar.noCalendar.hasTime .flatpickr-time{height:auto}.flatpickr-calendar:focus{outline:0}.flatpickr-months{display:flex;justify-content:space-between;width:100%}.flatpickr-month{font-size:var(--cds-productive-heading-01-font-size,.875rem);font-weight:var(--cds-productive-heading-01-font-weight,600);line-height:var(--cds-productive-heading-01-line-height,1.28572);letter-spacing:var(--cds-productive-heading-01-letter-spacing,.16px);display:flex;align-items:center;height:2.5rem;color:var(--cds-text-01,#161616);line-height:1;text-align:center;background-color:transparent}.flatpickr-next-month,.flatpickr-prev-month{z-index:3;display:flex;align-items:center;justify-content:center;width:2.5rem;height:2.5rem;padding:0;line-height:16px;text-decoration:none;-webkit-transform:scale(1,1);transform:scale(1,1);cursor:pointer;transition:background-color 70ms cubic-bezier(.2,0,.38,.9);fill:var(--cds-icon-01,#161616);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.flatpickr-next-month:hover,.flatpickr-prev-month:hover{background-color:var(--cds-hover-ui,#e5e5e5)}.flatpickr-next-month.disabled svg,.flatpickr-prev-month.disabled svg{cursor:not-allowed;fill:var(--cds-ui-05,#161616)}.flatpickr-next-month.disabled:hover svg,.flatpickr-prev-month.disabled:hover svg{fill:var(--cds-ui-05,#161616)}.flatpickr-current-month{font-size:var(--cds-productive-heading-01-font-size,.875rem);font-weight:var(--cds-productive-heading-01-font-weight,600);line-height:var(--cds-productive-heading-01-line-height,1.28572);letter-spacing:var(--cds-productive-heading-01-letter-spacing,.16px);display:flex;align-items:center;justify-content:center;height:1.75rem;text-align:center}.flatpickr-current-month .cur-month{margin-right:.25rem;margin-left:.25rem}.flatpickr-current-month .cur-month:hover{background-color:var(--cds-hover-ui,#e5e5e5)}.numInputWrapper{position:relative;width:3.75rem}.numInputWrapper:hover{background-color:var(--cds-hover-ui,#e5e5e5)}.numInputWrapper .numInput{display:inline-block;width:100%;margin:0;padding:.25rem;color:var(--cds-text-01,#161616);font-weight:600;font-size:inherit;font-family:inherit;background-color:var(--cds-field-01,#f4f4f4);border:none;cursor:default;-moz-appearance:textfield}.numInputWrapper .numInput::-webkit-inner-spin-button,.numInputWrapper .numInput::-webkit-outer-spin-button{margin:0;-webkit-appearance:none}.numInputWrapper .numInput:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.numInputWrapper .numInput:focus{outline-style:dotted}}.numInputWrapper .numInput[disabled],.numInputWrapper .numInput[disabled]:hover{color:var(--cds-disabled-02,#c6c6c6);background-color:var(--cds-ui-01,#f4f4f4);pointer-events:none}.numInputWrapper .arrowUp{top:.25rem;border-bottom:0}.numInputWrapper .arrowUp::after{border-bottom:.25rem solid var(--cds-icon-01,#161616)}.numInputWrapper .arrowDown{top:.6875rem}.numInputWrapper .arrowDown::after{border-top:.25rem solid var(--cds-icon-01,#161616)}.numInputWrapper .arrowDown,.numInputWrapper .arrowUp{position:absolute;left:2.6rem;width:.75rem;height:50%;padding:0 .25rem 0 .125rem;line-height:50%;border:none;cursor:pointer;opacity:0}.numInputWrapper .arrowDown::after,.numInputWrapper .arrowUp::after{position:absolute;top:33%;display:block;border-right:.25rem solid transparent;border-left:.25rem solid transparent;content:\"\"}.numInputWrapper .arrowDown:hover::after,.numInputWrapper .arrowUp:hover::after{border-top-color:var(--cds-interactive-01,#0f62fe);border-bottom-color:var(--cds-interactive-01,#0f62fe)}.numInputWrapper .arrowDown:active::after,.numInputWrapper .arrowUp:active::after{border-top-color:var(--cds-interactive-04,#0f62fe);border-bottom-color:var(--cds-interactive-04,#0f62fe)}.numInput[disabled]~.arrowUp::after{border-bottom-color:var(--cds-disabled-02,#c6c6c6)}.numInput[disabled]~.arrowDown::after{border-top-color:var(--cds-disabled-02,#c6c6c6)}.numInputWrapper:hover .arrowDown,.numInputWrapper:hover .arrowUp{opacity:1}.numInputWrapper:hover .numInput[disabled]~.arrowDown,.numInputWrapper:hover .numInput[disabled]~.arrowUp{opacity:0}.flatpickr-weekdays{display:flex;align-items:center;height:2.5rem}.flatpickr-weekdaycontainer{display:flex;width:100%}.flatpickr-weekday{font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);flex:1;color:var(--cds-text-01,#161616);cursor:default}.flatpickr-days:focus{outline:0}.flatpickr-calendar.animate .dayContainer.slideLeft{-webkit-animation:fpFadeOut .4s cubic-bezier(.23,1,.32,1),fpSlideLeft .4s cubic-bezier(.23,1,.32,1);animation:fpFadeOut .4s cubic-bezier(.23,1,.32,1),fpSlideLeft .4s cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.animate .dayContainer.slideLeft,.flatpickr-calendar.animate .dayContainer.slideLeftNew{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.flatpickr-calendar.animate .dayContainer.slideLeftNew{-webkit-animation:fpFadeIn .4s cubic-bezier(.23,1,.32,1),fpSlideLeft .4s cubic-bezier(.23,1,.32,1);animation:fpFadeIn .4s cubic-bezier(.23,1,.32,1),fpSlideLeft .4s cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.animate .dayContainer.slideRight{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);-webkit-animation:fpFadeOut .4s cubic-bezier(.23,1,.32,1),fpSlideRight .4s cubic-bezier(.23,1,.32,1);animation:fpFadeOut .4s cubic-bezier(.23,1,.32,1),fpSlideRight .4s cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.animate .dayContainer.slideRightNew{-webkit-animation:fpFadeIn .4s cubic-bezier(.23,1,.32,1),fpSlideRightNew .4s cubic-bezier(.23,1,.32,1);animation:fpFadeIn .4s cubic-bezier(.23,1,.32,1),fpSlideRightNew .4s cubic-bezier(.23,1,.32,1)}.flatpickr-day{font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);display:flex;align-items:center;justify-content:center;width:2.5rem;height:2.5rem;color:var(--cds-text-01,#161616);cursor:pointer;transition:all 70ms cubic-bezier(.2,0,.38,.9)}.flatpickr-day:hover{background:var(--cds-hover-ui,#e5e5e5)}.flatpickr-day:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;outline-color:var(--cds-interactive-01,#0f62fe)}@media screen and (prefers-contrast){.flatpickr-day:focus{outline-style:dotted}}.nextMonthDay,.prevMonthDay{color:var(--cds-text-05,#6f6f6f)}.flatpickr-day.today{position:relative;color:var(--cds-link-01,#0f62fe);font-weight:600}.flatpickr-day.today::after{position:absolute;bottom:.4375rem;left:50%;display:block;width:.25rem;height:.25rem;background-color:var(--cds-link-01,#0f62fe);-webkit-transform:translateX(-50%);transform:translateX(-50%);content:\"\"}.flatpickr-day.today.no-border{border:none}.flatpickr-day.today.selected{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.flatpickr-day.today.selected{outline-style:dotted}}.flatpickr-day.today.selected::after{display:none}.flatpickr-day.inRange{color:var(--cds-text-01,#161616);background-color:var(--cds-highlight,#d0e2ff)}.flatpickr-day.selected{color:var(--cds-text-04,#fff);background-color:var(--cds-interactive-01,#0f62fe)}.flatpickr-day.selected:focus{outline:.0625rem solid var(--cds-ui-02,#fff);outline-offset:-.1875rem}.flatpickr-day.startRange.selected{z-index:2;box-shadow:none}.flatpickr-day.endRange.inRange,.flatpickr-day.startRange.inRange:not(.selected){outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;z-index:3;background:var(--cds-ui-01,#f4f4f4)}@media screen and (prefers-contrast){.flatpickr-day.endRange.inRange,.flatpickr-day.startRange.inRange:not(.selected){outline-style:dotted}}.flatpickr-day.endRange:hover{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px;color:var(--cds-text-01,#161616);background:var(--cds-ui-01,#f4f4f4)}@media screen and (prefers-contrast){.flatpickr-day.endRange:hover{outline-style:dotted}}.flatpickr-day.endRange.inRange.selected{color:var(--cds-text-04,#fff);background:var(--cds-interactive-01,#0f62fe)}.flatpickr-day.flatpickr-disabled{color:var(--cds-disabled-02,#c6c6c6);cursor:not-allowed}.flatpickr-day.flatpickr-disabled:hover{background-color:transparent}.flatpickr-input[readonly]{cursor:pointer}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.flatpickr-next-month,.flatpickr-prev-month{fill:ButtonText}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.flatpickr-day.selected{color:Highlight;outline:1px solid Highlight;outline-style:dotted}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.flatpickr-day.inRange,.flatpickr-day.today{color:Highlight}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.flatpickr-calendar{outline:1px solid transparent}}.bx--date-picker,:host(bx-date-picker){display:flex}.bx--date-picker--light .bx--date-picker__input{background:var(--cds-field-02,#fff)}.bx--date-picker~.bx--label,:host(bx-date-picker)~.bx--label{order:1}.bx--date-picker-container,:host(bx-date-picker-input),:host(bx-date-picker-input-skeleton){position:relative;display:flex;flex-direction:column;justify-content:space-between}.bx--date-picker-input__wrapper{position:relative;display:flex;align-items:center}.bx--date-picker--simple:host(bx-date-picker) .bx--date-picker__input,.bx--date-picker--simple:host(bx-date-picker) .bx--label,.bx--date-picker.bx--date-picker--simple .bx--date-picker__input,.bx--date-picker.bx--date-picker--simple .bx--label{width:7.5rem}.bx--date-picker--simple:host(bx-date-picker) .bx--date-picker-input__wrapper--invalid .bx--date-picker__input,.bx--date-picker--simple:host(bx-date-picker) .bx--date-picker-input__wrapper--invalid~.bx--form-requirement,.bx--date-picker--simple:host(bx-date-picker) .bx--date-picker-input__wrapper--warn .bx--date-picker__input,.bx--date-picker--simple:host(bx-date-picker) .bx--date-picker-input__wrapper--warn~.bx--form-requirement,.bx--date-picker.bx--date-picker--simple .bx--date-picker-input__wrapper--invalid .bx--date-picker__input,.bx--date-picker.bx--date-picker--simple .bx--date-picker-input__wrapper--invalid~.bx--form-requirement,.bx--date-picker.bx--date-picker--simple .bx--date-picker-input__wrapper--warn .bx--date-picker__input,.bx--date-picker.bx--date-picker--simple .bx--date-picker-input__wrapper--warn~.bx--form-requirement{width:9.5rem}.bx--date-picker--simple.bx--date-picker--short:host(bx-date-picker) .bx--date-picker__input,.bx--date-picker.bx--date-picker--simple.bx--date-picker--short .bx--date-picker__input{width:5.7rem}.bx--date-picker--single:host(bx-date-picker) .bx--date-picker__input,.bx--date-picker.bx--date-picker--single .bx--date-picker__input{width:18rem}.bx--date-picker .bx--date-picker-input__wrapper--warn~.bx--form-requirement,:host(bx-date-picker) .bx--date-picker-input__wrapper--warn~.bx--form-requirement{color:var(--cds-text-primary,#161616)}.bx--date-picker__input{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-family:var(--cds-code-02-font-family, 'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace);font-size:var(--cds-code-02-font-size,.875rem);font-weight:var(--cds-code-02-font-weight,400);line-height:var(--cds-code-02-line-height,1.42857);letter-spacing:var(--cds-code-02-letter-spacing,.32px);outline:2px solid transparent;outline-offset:-2px;position:relative;display:block;height:2.5rem;padding:0 1rem;border:none;border-bottom:1px solid var(--cds-border-strong,#8d8d8d);background-color:var(--cds-field,#f4f4f4);color:var(--cds-text-primary,#161616);transition:70ms cubic-bezier(.2,0,.38,.9) all}.bx--date-picker__input *,.bx--date-picker__input ::after,.bx--date-picker__input ::before{box-sizing:inherit}.bx--date-picker__input.bx--focused,.bx--date-picker__input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.bx--date-picker__input.bx--focused,.bx--date-picker__input:focus{outline-style:dotted}}.bx--date-picker__input:disabled{border-bottom:1px solid transparent;background-color:var(--cds-field,#f4f4f4);color:var(--cds-text-disabled,#c6c6c6);cursor:not-allowed}.bx--date-picker__input:disabled::-webkit-input-placeholder{color:var(--cds-text-disabled,#c6c6c6)}.bx--date-picker__input:disabled::-moz-placeholder{color:var(--cds-text-disabled,#c6c6c6)}.bx--date-picker__input:disabled:-ms-input-placeholder{color:var(--cds-text-disabled,#c6c6c6)}.bx--date-picker__input:disabled::-ms-input-placeholder{color:var(--cds-text-disabled,#c6c6c6)}.bx--date-picker__input:disabled::placeholder{color:var(--cds-text-disabled,#c6c6c6)}.bx--date-picker__input:disabled:hover{border-bottom:1px solid transparent}.bx--date-picker__input::-webkit-input-placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--date-picker__input::-moz-placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--date-picker__input:-ms-input-placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--date-picker__input::-ms-input-placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--date-picker__input::placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--date-picker__input--lg,.bx--date-picker__input--xl{height:3rem}.bx--date-picker__input--sm{height:2rem}.bx--date-picker__icon{position:absolute;z-index:1;top:50%;right:1rem;fill:var(--cds-icon-primary,#161616);pointer-events:none;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.bx--date-picker__icon--invalid,.bx--date-picker__icon--warn{cursor:auto}.bx--date-picker__icon--warn{fill:var(--cds-support-warning,#f1c21b)}.bx--date-picker__icon--warn path:first-of-type{fill:#000;opacity:1}.bx--date-picker__icon--invalid{fill:var(--cds-support-error,#da1e28)}.bx--date-picker__icon~.bx--date-picker__input{padding-right:3rem}.bx--date-picker__input:disabled~.bx--date-picker__icon{cursor:not-allowed;fill:var(--cds-icon-disabled,#c6c6c6)}.bx--date-picker--range>.bx--date-picker-container:first-child,.bx--date-picker--range>:first-child:host(bx-date-picker-input),.bx--date-picker--range>:first-child:host(bx-date-picker-input-skeleton){margin-right:.0625rem}.bx--date-picker--range .bx--date-picker-container,.bx--date-picker--range .bx--date-picker__input,.bx--date-picker--range :host(bx-date-picker-input),.bx--date-picker--range :host(bx-date-picker-input-skeleton){width:8.96875rem}.bx--date-picker.bx--skeleton input,.bx--date-picker__input.bx--skeleton,.bx--skeleton:host(bx-date-picker) input{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none;width:100%}.bx--date-picker.bx--skeleton input:active,.bx--date-picker.bx--skeleton input:focus,.bx--date-picker.bx--skeleton input:hover,.bx--date-picker__input.bx--skeleton:active,.bx--date-picker__input.bx--skeleton:focus,.bx--date-picker__input.bx--skeleton:hover,.bx--skeleton:host(bx-date-picker) input:active,.bx--skeleton:host(bx-date-picker) input:focus,.bx--skeleton:host(bx-date-picker) input:hover{border:none;cursor:default;outline:0}.bx--date-picker.bx--skeleton input::before,.bx--date-picker__input.bx--skeleton::before,.bx--skeleton:host(bx-date-picker) input::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.bx--date-picker.bx--skeleton input::before,.bx--date-picker__input.bx--skeleton::before,.bx--skeleton:host(bx-date-picker) input::before{-webkit-animation:none;animation:none}}.bx--date-picker.bx--skeleton input::-webkit-input-placeholder,.bx--date-picker__input.bx--skeleton::-webkit-input-placeholder,.bx--skeleton:host(bx-date-picker) input::-webkit-input-placeholder{color:transparent}.bx--date-picker.bx--skeleton input::-moz-placeholder,.bx--date-picker__input.bx--skeleton::-moz-placeholder,.bx--skeleton:host(bx-date-picker) input::-moz-placeholder{color:transparent}.bx--date-picker.bx--skeleton input:-ms-input-placeholder,.bx--date-picker__input.bx--skeleton:-ms-input-placeholder,.bx--skeleton:host(bx-date-picker) input:-ms-input-placeholder{color:transparent}.bx--date-picker.bx--skeleton input::-ms-input-placeholder,.bx--date-picker__input.bx--skeleton::-ms-input-placeholder,.bx--skeleton:host(bx-date-picker) input::-ms-input-placeholder{color:transparent}.bx--date-picker.bx--skeleton input::placeholder,.bx--date-picker__input.bx--skeleton::placeholder,.bx--skeleton:host(bx-date-picker) input::placeholder{color:transparent}.bx--date-picker.bx--skeleton .bx--label,.bx--skeleton:host(bx-date-picker) .bx--label{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none;width:4.6875rem;height:.875rem}.bx--date-picker.bx--skeleton .bx--label:active,.bx--date-picker.bx--skeleton .bx--label:focus,.bx--date-picker.bx--skeleton .bx--label:hover,.bx--skeleton:host(bx-date-picker) .bx--label:active,.bx--skeleton:host(bx-date-picker) .bx--label:focus,.bx--skeleton:host(bx-date-picker) .bx--label:hover{border:none;cursor:default;outline:0}.bx--date-picker.bx--skeleton .bx--label::before,.bx--skeleton:host(bx-date-picker) .bx--label::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.bx--date-picker.bx--skeleton .bx--label::before,.bx--skeleton:host(bx-date-picker) .bx--label::before{-webkit-animation:none;animation:none}}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.bx--date-picker__icon{fill:ButtonText}}:host(bx-date-picker) #floating-menu-container{position:absolute;width:100%}:host(bx-date-picker) .bx--date-picker__calendar.open{margin-top:0}:host(bx-date-picker) .flatpickr-next-month svg,:host(bx-date-picker) .flatpickr-prev-month svg{-webkit-transform:rotate(0);transform:rotate(0)}:host(bx-date-picker) .bx--date-picker__day.flatpickr-disabled,:host(bx-date-picker) .flatpickr-day.flatpickr-disabled{cursor:not-allowed;opacity:.5;color:var(--cds-ui-05,#161616)}:host(bx-date-picker) .bx--date-picker__day.flatpickr-disabled:hover,:host(bx-date-picker) .flatpickr-day.flatpickr-disabled:hover{background:0 0}:host(bx-date-picker) .flatpickr-next-month.flatpickr-disabled svg,:host(bx-date-picker) .flatpickr-prev-month.flatpickr-disabled svg{fill:var(--cds-ui-05,#161616);opacity:.5;cursor:not-allowed}:host(bx-date-picker) .flatpickr-next-month.flatpickr-disabled:hover svg,:host(bx-date-picker) .flatpickr-prev-month.flatpickr-disabled:hover svg{fill:var(--cds-ui-05,#161616)}:host(bx-date-picker-input),:host(bx-date-picker-input-skeleton){outline:0}:host(bx-date-picker-input[color-scheme=light]) .bx--date-picker__input{background:var(--cds-field-02,#fff)}:host(bx-date-picker-input-skeleton[kind=simple]) .bx--date-picker__input,:host(bx-date-picker-input[kind=simple]) .bx--date-picker__input{width:7.5rem}:host(bx-date-picker-input-skeleton[kind=simple][size-horizontal=short]) .bx--date-picker__input,:host(bx-date-picker-input[kind=simple][size-horizontal=short]) .bx--date-picker__input{width:5.625rem}:host(bx-date-picker-input-skeleton[kind=single]),:host(bx-date-picker-input[kind=single]){max-width:18rem}:host(bx-date-picker-input-skeleton[kind=single]) .bx--date-picker__input,:host(bx-date-picker-input[kind=single]) .bx--date-picker__input{width:18rem}:host(bx-date-picker-input-skeleton[kind=from]),:host(bx-date-picker-input[kind=from]){margin-right:.0625rem}:host(bx-date-picker-input-skeleton[kind=from]),:host(bx-date-picker-input-skeleton[kind=to]),:host(bx-date-picker-input[kind=from]),:host(bx-date-picker-input[kind=to]){width:8.96875rem}:host(bx-date-picker-input-skeleton[kind=from]) .bx--date-picker__input,:host(bx-date-picker-input-skeleton[kind=to]) .bx--date-picker__input,:host(bx-date-picker-input[kind=from]) .bx--date-picker__input,:host(bx-date-picker-input[kind=to]) .bx--date-picker__input{width:8.96875rem}:host(bx-date-picker-input) ::slotted(.bx--date-picker__icon){position:absolute;right:1rem;fill:var(--cds-icon-01,#161616);cursor:pointer;z-index:1}:host(bx-date-picker-input-skeleton){display:inline-block}:host(bx-date-picker-input-skeleton) .bx--label{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none;width:4.6875rem;height:.875rem}:host(bx-date-picker-input-skeleton) .bx--label:active,:host(bx-date-picker-input-skeleton) .bx--label:focus,:host(bx-date-picker-input-skeleton) .bx--label:hover{border:none;cursor:default;outline:0}:host(bx-date-picker-input-skeleton) .bx--label::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){:host(bx-date-picker-input-skeleton) .bx--label::before{-webkit-animation:none;animation:none}}"
]);

});


parcelRegister("bsGn3", function(module, exports) {

var $kZ0tv = parcelRequire("kZ0tv");

var $jd9RL = parcelRequire("jd9RL");
parcelRequire("3eEWe");
var $2pFDC = parcelRequire("2pFDC");
var $3tvu5 = parcelRequire("3tvu5");
var $3eEWe = parcelRequire("3eEWe");

var $h38ef = parcelRequire("h38ef");

var $jpdgO = parcelRequire("jpdgO");

var $jT3LQ = parcelRequire("jT3LQ");

var $5l5Nb = parcelRequire("5l5Nb");

var $01HFT = parcelRequire("01HFT");
parcelRequire("lDCYD");
var $hQwho = parcelRequire("hQwho");
parcelRequire("izlGd");
var $e4B20 = parcelRequire("e4B20");
var $izlGd = parcelRequire("izlGd");

var $fzJHB = parcelRequire("fzJHB");
let $85832d2edb0f0b29$var$_ = (t)=>t, $85832d2edb0f0b29$var$_t, $85832d2edb0f0b29$var$_t2, $85832d2edb0f0b29$var$_t3;
const { prefix: $85832d2edb0f0b29$var$prefix } = (0, $jpdgO.default);
/**
 * The input box for date picker.
 * @element bx-date-picker-input
 */ let $85832d2edb0f0b29$var$BXDatePickerInput = (0, $kZ0tv.default)([
    (0, $2pFDC.customElement)(`${$85832d2edb0f0b29$var$prefix}-date-picker-input`)
], function(_initialize, _ValidityMixin) {
    class BXDatePickerInput extends _ValidityMixin {
        constructor(...args){
            super(...args);
            _initialize(this);
        }
    }
    return {
        F: BXDatePickerInput,
        d: [
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.query)(`.${$85832d2edb0f0b29$var$prefix}--date-picker__icon`)
                ],
                key: "_iconNode",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.query)('slot[name="validity-message"]')
                ],
                key: "_slotValidityMessage",
                value: void 0
            },
            {
                kind: "get",
                key: "_hasValidityMessage",
                value: /**
       * The calendar icon.
       */ /**
       * The `<slot>` for the validity message.
       */ /**
       * `true` if validity message is given via `validityMessage` property or via `<slot name="validity-message">`.
       */ function _hasValidityMessage() {
                    const { validityMessage: validityMessage, _slotValidityMessage: slotValidityMessage } = this;
                    return validityMessage || slotValidityMessage && slotValidityMessage.assignedNodes.length > 0;
                }
            },
            {
                kind: "method",
                key: "_handleClickWrapper",
                value: function _handleClickWrapper(event) {
                    if (event.target === this._iconNode) this.input.focus();
                }
            },
            {
                kind: "method",
                key: "_handleSlotChangeValidityMessage",
                value: function _handleSlotChangeValidityMessage() {
                    this.requestUpdate();
                }
            },
            {
                kind: "method",
                key: "_handleInput",
                value: function _handleInput({ target: target }) {
                    const { value: value } = target;
                    this.value = value;
                }
            },
            {
                kind: "method",
                key: "_renderIcon",
                value: function _renderIcon() {
                    return this.kind === (0, $izlGd.DATE_PICKER_INPUT_KIND).SIMPLE ? undefined : (0, $h38ef.default)({
                        class: `${$85832d2edb0f0b29$var$prefix}--date-picker__icon`,
                        role: 'img',
                        children: [
                            (0, $3tvu5.html)($85832d2edb0f0b29$var$_t || ($85832d2edb0f0b29$var$_t = $85832d2edb0f0b29$var$_` <title>Open calendar</title> `))
                        ]
                    });
                }
            },
            {
                kind: "method",
                key: "_renderValidityMessage",
                value: function _renderValidityMessage() {
                    const { validityMessage: validityMessage, _hasValidityMessage: hasValidityMessage, _handleSlotChangeValidityMessage: handleSlotChangeValidityMessage } = this;
                    return (0, $3tvu5.html)($85832d2edb0f0b29$var$_t2 || ($85832d2edb0f0b29$var$_t2 = $85832d2edb0f0b29$var$_` <div ?hidden="${0}" class="${0}--form-requirement"> <slot name="validity-message" @slotchange="${0}">${0}</slot> </div> `), !hasValidityMessage, $85832d2edb0f0b29$var$prefix, handleSlotChangeValidityMessage, validityMessage);
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.query)('input')
                ],
                key: "input",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'color-scheme',
                        reflect: true
                    })
                ],
                key: "colorScheme",
                value () {
                    return (0, $e4B20.FORM_ELEMENT_COLOR_SCHEME).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "disabled",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true,
                        attribute: 'hide-label'
                    })
                ],
                key: "hideLabel",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "invalid",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "kind",
                value () {
                    return (0, $izlGd.DATE_PICKER_INPUT_KIND).SIMPLE;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'label-text'
                    })
                ],
                key: "labelText",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "pattern",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "placeholder",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "required",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'required-validity-message'
                    })
                ],
                key: "requiredValidityMessage",
                value () {
                    return 'Please fill out this field.';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'size',
                        reflect: true
                    })
                ],
                key: "size",
                value () {
                    return (0, $hQwho.INPUT_SIZE).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'size-horizontal',
                        reflect: true
                    })
                ],
                key: "sizeHorizontal",
                value () {
                    return (0, $izlGd.DATE_PICKER_INPUT_SIZE_HORIZONTAL).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "type",
                value: void 0
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'validity-message'
                    })
                ],
                key: "validityMessage",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "value",
                value: void 0
            },
            {
                kind: "method",
                key: "createRenderRoot",
                value: /**
       * The color scheme.
       */ /**
       * `true` if the check box should be disabled.
       */ /**
       * `true` if the label should be hidden.
       */ /**
       * Controls the invalid state and visibility of the `validityMessage`.
       */ /**
       * Date picker input kind.
       */ /**
       * The label text.
       */ /**
       * The `pattern` attribute for the `<input>` in the shadow DOM.
       */ /**
       * The placeholder text.
       */ /**
       * `true` if the value is required.
       */ /**
       * The special validity message for `required`.
       */ /**
       * Vertical size of this date picker input.
       */ /**
       * Horizontal size of this date picker input.
       * Effective only when `kind` property is `DATE_PICKER_INPUT_KIND.SIMPLE`.
       */ /**
       * The `type` attribute for the `<input>` in the shadow DOM.
       */ /**
       * The validity message.
       * If present and non-empty, this date picker input shows the UI of its invalid state.
       */ /**
       * The value.
       */ function createRenderRoot() {
                    var _$exec;
                    return this.attachShadow({
                        mode: 'open',
                        delegatesFocus: Number(((_$exec = /Safari\/(\d+)/.exec(navigator.userAgent)) !== null && _$exec !== void 0 ? _$exec : [
                            '',
                            0
                        ])[1]) <= 537
                    });
                }
            },
            {
                kind: "method",
                key: "render",
                value: function render() {
                    const constructor = this.constructor;
                    const { disabled: disabled, hideLabel: hideLabel, invalid: invalid, labelText: labelText, pattern: pattern = constructor.defaultPattern, placeholder: placeholder, size: size, type: type = constructor.defaultType, value: value, _handleClickWrapper: handleClickWrapper, _handleInput: handleInput } = this;
                    const labelClasses = (0, $jd9RL.classMap)({
                        [`${$85832d2edb0f0b29$var$prefix}--label`]: true,
                        [`${$85832d2edb0f0b29$var$prefix}--visually-hidden`]: hideLabel,
                        [`${$85832d2edb0f0b29$var$prefix}--label--disabled`]: disabled
                    });
                    const inputClasses = (0, $jd9RL.classMap)({
                        [`${$85832d2edb0f0b29$var$prefix}--date-picker__input`]: true,
                        [`${$85832d2edb0f0b29$var$prefix}--date-picker__input--${size}`]: size
                    });
                    return (0, $3tvu5.html)($85832d2edb0f0b29$var$_t3 || ($85832d2edb0f0b29$var$_t3 = $85832d2edb0f0b29$var$_` <label for="input" class="${0}"> <slot name="label-text">${0}</slot> </label> <div class="${0}--date-picker-input__wrapper" @click="${0}"> <input id="input" type="${0}" class="${0}" ?disabled="${0}" pattern="${0}" placeholder="${0}" .value="${0}" ?data-invalid="${0}" @input="${0}"> ${0} </div> ${0} `), labelClasses, labelText, $85832d2edb0f0b29$var$prefix, handleClickWrapper, type, inputClasses, disabled, pattern, (0, $jT3LQ.default)(placeholder), (0, $jT3LQ.default)(value), invalid, handleInput, this._renderIcon(), this._renderValidityMessage());
                }
            },
            {
                kind: "field",
                static: true,
                key: "defaultPattern",
                value () {
                    return '\\d{1,2}\\/\\d{1,2}\\/\\d{4}';
                }
            },
            {
                kind: "field",
                static: true,
                key: "defaultType",
                value () {
                    return 'text';
                }
            },
            {
                kind: "get",
                static: true,
                key: "selectorParent",
                value: /**
       * The default value for `type` property.
       */ /**
       * A selector that will return the parent date picker.
       */ function selectorParent() {
                    return `${$85832d2edb0f0b29$var$prefix}-date-picker`;
                }
            },
            {
                kind: "field",
                static: true,
                key: "styles",
                value () {
                    return 0, $fzJHB.default;
                }
            }
        ]
    };
}, (0, $01HFT.default)((0, $5l5Nb.default)((0, $3eEWe.LitElement))));
var $85832d2edb0f0b29$export$2e2bcd8739ae039 = $85832d2edb0f0b29$var$BXDatePickerInput;

});
parcelRegister("h38ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $c699198f8135b54d$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $3tvu5 = parcelRequire("3tvu5");

var $fxyjq = parcelRequire("fxyjq");
const $c699198f8135b54d$var$svgResultCarbonIcon = ({ children: children, ...attrs } = {})=>(0, $3tvu5.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" ...="${(0, $fxyjq.default)(attrs)}" aria-hidden="true" width="16" height="16" viewBox="0 0 32 32">${children}${children}${children}<path d="M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20	V26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z"></path></svg>`;
var $c699198f8135b54d$export$2e2bcd8739ae039 = $c699198f8135b54d$var$svgResultCarbonIcon;

});

parcelRegister("jT3LQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a6142244579203$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gg2C2 = parcelRequire("gg2C2");
var /**
 * A variant of `lit-html/directives/if-defined` which stops rendering if the given value is `null` in addition to `undefined`.
 * @param The value.
 */ $e7a6142244579203$export$2e2bcd8739ae039 = (value)=>(0, $gg2C2.ifDefined)(value !== null && value !== void 0 ? value : undefined);

});

parcelRegister("lDCYD", function(module, exports) {

$parcel$export(module.exports, "INPUT_SIZE", () => (parcelRequire("hQwho")).INPUT_SIZE);

var $kZ0tv = parcelRequire("kZ0tv");
parcelRequire("3eEWe");
var $2pFDC = parcelRequire("2pFDC");
var $3tvu5 = parcelRequire("3tvu5");
var $3eEWe = parcelRequire("3eEWe");

var $jd9RL = parcelRequire("jd9RL");

var $jpdgO = parcelRequire("jpdgO");

var $10Bt3 = parcelRequire("10Bt3");

var $i414a = parcelRequire("i414a");

var $6Ia5q = parcelRequire("6Ia5q");

var $01HFT = parcelRequire("01HFT");
parcelRequire("hQwho");
var $e4B20 = parcelRequire("e4B20");
var $hQwho = parcelRequire("hQwho");

var $3JHHH = parcelRequire("3JHHH");
let $fc0b7982804534cc$var$_ = (t)=>t, $fc0b7982804534cc$var$_t;
const { prefix: $fc0b7982804534cc$var$prefix } = (0, $jpdgO.default);
/**
 * Input element. Supports all the usual attributes for textual input types
 * @element bx-input
 * @slot helper-text - The helper text.
 * @slot label-text - The label text.
 * @slot validity-message - The validity message. If present and non-empty, this input shows the UI of its invalid state.
 */ let $fc0b7982804534cc$export$2e2bcd8739ae039 = (0, $kZ0tv.default)([
    (0, $2pFDC.customElement)(`${$fc0b7982804534cc$var$prefix}-input`)
], function(_initialize, _ValidityMixin) {
    class BXInput extends _ValidityMixin {
        constructor(...args){
            super(...args);
            _initialize(this);
        }
    }
    return {
        F: BXInput,
        d: [
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.query)('input')
                ],
                key: "_input",
                value: void 0
            },
            {
                kind: "field",
                key: "_value",
                value () {
                    return '';
                }
            },
            {
                kind: "method",
                key: "_handleInput",
                value: /**
       * The underlying input element
       */ /**
       * The internal value.
       */ /**
       * Handles `oninput` event on the `<input>`.
       * @param event The event.
       */ function _handleInput({ target: target }) {
                    this.value = target.value;
                }
            },
            {
                kind: "method",
                key: "_handleFormdata",
                value: function _handleFormdata(event) {
                    const { formData: formData } = event; // TODO: Wait for `FormDataEvent` being available in `lib.dom.d.ts`
                    const { disabled: disabled, name: name, value: value } = this;
                    if (!disabled) formData.append(name, value);
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "autocomplete",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean
                    })
                ],
                key: "autofocus",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'color-scheme',
                        reflect: true
                    })
                ],
                key: "colorScheme",
                value () {
                    return (0, $e4B20.FORM_ELEMENT_COLOR_SCHEME).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "disabled",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'helper-text'
                    })
                ],
                key: "helperText",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "invalid",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'label-text'
                    })
                ],
                key: "labelText",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "name",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)()
                ],
                key: "pattern",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "placeholder",
                value () {
                    return '';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "readonly",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        type: Boolean,
                        reflect: true
                    })
                ],
                key: "required",
                value () {
                    return false;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'required-validity-message'
                    })
                ],
                key: "requiredValidityMessage",
                value () {
                    return 'Please fill out this field.';
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "size",
                value () {
                    return (0, $hQwho.INPUT_SIZE).REGULAR;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "type",
                value () {
                    return (0, $hQwho.INPUT_TYPE).TEXT;
                }
            },
            {
                kind: "field",
                decorators: [
                    (0, $2pFDC.property)({
                        attribute: 'validity-message'
                    })
                ],
                key: "validityMessage",
                value () {
                    return '';
                }
            },
            {
                kind: "get",
                decorators: [
                    (0, $2pFDC.property)({
                        reflect: true
                    })
                ],
                key: "value",
                value: /**
       * Sets the input to be focussed automatically on page load. Defaults to false
       */ /**
       * The color scheme.
       */ /**
       * Controls the disabled state of the input
       */ /**
       * The helper text.
       */ /**
       * Controls the invalid state and visibility of the `validityMessage`
       */ /**
       * The label text.
       */ /**
       * Name for the input in the `FormData`
       */ /**
       * Pattern to validate the input against for HTML validity checking
       */ /**
       * Value to display when the input has an empty `value`
       */ /**
       * Controls the readonly state of the input
       */ /**
       * Boolean property to set the required status
       */ /**
       * The special validity message for `required`.
       */ /**
       * The input box size.
       */ /**
       * The type of the input. Can be one of the types listed in the INPUT_TYPE enum
       */ /**
       * The validity message. If present and non-empty, this input shows the UI of its invalid state.
       */ /**
       * The value of the input.
       */ function value() {
                    // FIXME: Figure out how to deal with TS2611
                    // once we have the input we can directly query for the value
                    if (this._input) return this._input.value;
                     // but before then _value will work fine
                    return this._value;
                }
            },
            {
                kind: "set",
                key: "value",
                value: function value(_value) {
                    const oldValue = this._value;
                    this._value = _value; // make sure that lit-element updates the right properties
                    this.requestUpdate('value', oldValue); // we set the value directly on the input (when available)
                    // so that programatic manipulation updates the UI correctly
                    if (this._input) this._input.value = _value;
                }
            },
            {
                kind: "method",
                key: "createRenderRoot",
                value: function createRenderRoot() {
                    var _$exec;
                    return this.attachShadow({
                        mode: 'open',
                        delegatesFocus: Number(((_$exec = /Safari\/(\d+)/.exec(navigator.userAgent)) !== null && _$exec !== void 0 ? _$exec : [
                            '',
                            0
                        ])[1]) <= 537
                    });
                }
            },
            {
                kind: "method",
                key: "render",
                value: function render() {
                    const { _handleInput: handleInput } = this;
                    const invalidIcon = (0, $10Bt3.default)({
                        class: `${$fc0b7982804534cc$var$prefix}--text-input__invalid-icon`
                    });
                    const inputClasses = (0, $jd9RL.classMap)({
                        [`${$fc0b7982804534cc$var$prefix}--text-input`]: true,
                        [`${$fc0b7982804534cc$var$prefix}--text-input--${this.colorScheme}`]: this.colorScheme,
                        [`${$fc0b7982804534cc$var$prefix}--text-input--invalid`]: this.invalid,
                        [`${$fc0b7982804534cc$var$prefix}--text-input--${this.size}`]: this.size
                    });
                    const labelClasses = (0, $jd9RL.classMap)({
                        [`${$fc0b7982804534cc$var$prefix}--label`]: true,
                        [`${$fc0b7982804534cc$var$prefix}--label--disabled`]: this.disabled
                    });
                    const helperTextClasses = (0, $jd9RL.classMap)({
                        [`${$fc0b7982804534cc$var$prefix}--form__helper-text`]: true,
                        [`${$fc0b7982804534cc$var$prefix}--form__helper-text--disabled`]: this.disabled
                    });
                    return (0, $3tvu5.html)($fc0b7982804534cc$var$_t || ($fc0b7982804534cc$var$_t = $fc0b7982804534cc$var$_` <label class="${0}" for="input"> <slot name="label-text"> ${0} </slot> </label> <div class="${0}--text-input__field-wrapper" ?data-invalid="${0}"> ${0} <input ?autocomplete="${0}" ?autofocus="${0}" class="${0}" ?data-invalid="${0}" ?disabled="${0}" id="input" name="${0}" pattern="${0}" placeholder="${0}" ?readonly="${0}" ?required="${0}" type="${0}" .value="${0}" @input="${0}"> </div> <div class="${0}"> <slot name="helper-text"> ${0} </slot> </div> <div class="${0}--form-requirement"> <slot name="validity-message"> ${0} </slot> </div> `), labelClasses, this.labelText, $fc0b7982804534cc$var$prefix, this.invalid, this.invalid ? invalidIcon : null, this.autocomplete, this.autofocus, inputClasses, this.invalid, this.disabled, (0, $i414a.default)(this.name), (0, $i414a.default)(this.pattern), (0, $i414a.default)(this.placeholder), this.readonly, this.required, (0, $i414a.default)(this.type), this._value, handleInput, helperTextClasses, this.helperText, $fc0b7982804534cc$var$prefix, this.validityMessage);
                }
            },
            {
                kind: "field",
                static: true,
                key: "styles",
                value () {
                    return 0, $3JHHH.default;
                }
            }
        ]
    };
}, (0, $01HFT.default)((0, $6Ia5q.default)((0, $3eEWe.LitElement))));

});
parcelRegister("i414a", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2696d6c9cfa18b4$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gg2C2 = parcelRequire("gg2C2");
var /**
 * A variant of `if-non-null` which stops rendering if the given value is an emptry string in addition to `null`/`undefined`.
 * @param The value.
 */ $d2696d6c9cfa18b4$export$2e2bcd8739ae039 = (value)=>(0, $gg2C2.ifDefined)(value === '' ? undefined : value !== null && value !== void 0 ? value : undefined);

});

parcelRegister("hQwho", function(module, exports) {

$parcel$export(module.exports, "INPUT_SIZE", () => $cfe05507fc750429$export$4bad953e4e2a4518);
$parcel$export(module.exports, "INPUT_TYPE", () => $cfe05507fc750429$export$5049e35dbdee0f46);
$parcel$export(module.exports, "INPUT_COLOR_SCHEME", () => (parcelRequire("e4B20")).FORM_ELEMENT_COLOR_SCHEME);
/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $e4B20 = parcelRequire("e4B20");
let $cfe05507fc750429$export$4bad953e4e2a4518;
/**
 * Supported input types.
 *
 * For this component we only support textual types
 */ (function(INPUT_SIZE) {
    INPUT_SIZE["SMALL"] = "sm";
    INPUT_SIZE["REGULAR"] = "lg";
    INPUT_SIZE["LARGE"] = "lg";
    INPUT_SIZE["EXTRA_LARGE"] = "xl";
})($cfe05507fc750429$export$4bad953e4e2a4518 || ($cfe05507fc750429$export$4bad953e4e2a4518 = {}));
let $cfe05507fc750429$export$5049e35dbdee0f46;
(function(INPUT_TYPE) {
    INPUT_TYPE["EMAIL"] = "email";
    INPUT_TYPE["PASSWORD"] = "password";
    INPUT_TYPE["TEL"] = "tel";
    INPUT_TYPE["TEXT"] = "text";
    INPUT_TYPE["URL"] = "url";
})($cfe05507fc750429$export$5049e35dbdee0f46 || ($cfe05507fc750429$export$5049e35dbdee0f46 = {}));

});

parcelRegister("3JHHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8779becb372fb0$export$2e2bcd8739ae039);
/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ parcelRequire("3eEWe");
var $cH4lK = parcelRequire("cH4lK");
var $2b8779becb372fb0$export$2e2bcd8739ae039 = (0, $cH4lK.css)([
    "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{padding:0;border:0;margin:0;font:inherit;font-size:100%;vertical-align:baseline}button,input,select,textarea{border-radius:0;font-family:inherit}input[type=text]::-ms-clear{display:none}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}body{line-height:1}sup{vertical-align:super}sub{vertical-align:sub}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote::after,blockquote::before,q::after,q::before{content:\"\"}table{border-collapse:collapse;border-spacing:0}*{box-sizing:border-box}button{margin:0}html{font-size:100%}body{font-weight:400;font-family:'IBM Plex Sans','Helvetica Neue',Arial,sans-serif;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility}code{font-family:'IBM Plex Mono',Menlo,'DejaVu Sans Mono','Bitstream Vera Sans Mono',Courier,monospace}strong{font-weight:600}@media screen and (-ms-high-contrast:active){svg{fill:ButtonText}}h1{font-size:var(--cds-productive-heading-06-font-size,2.625rem);font-weight:var(--cds-productive-heading-06-font-weight,300);line-height:var(--cds-productive-heading-06-line-height,1.199);letter-spacing:var(--cds-productive-heading-06-letter-spacing,0)}h2{font-size:var(--cds-productive-heading-05-font-size,2rem);font-weight:var(--cds-productive-heading-05-font-weight,400);line-height:var(--cds-productive-heading-05-line-height,1.25);letter-spacing:var(--cds-productive-heading-05-letter-spacing,0)}h3{font-size:var(--cds-productive-heading-04-font-size,1.75rem);font-weight:var(--cds-productive-heading-04-font-weight,400);line-height:var(--cds-productive-heading-04-line-height,1.28572);letter-spacing:var(--cds-productive-heading-04-letter-spacing,0)}h4{font-size:var(--cds-productive-heading-03-font-size,1.25rem);font-weight:var(--cds-productive-heading-03-font-weight,400);line-height:var(--cds-productive-heading-03-line-height,1.4);letter-spacing:var(--cds-productive-heading-03-letter-spacing,0)}h5{font-size:var(--cds-productive-heading-02-font-size,1rem);font-weight:var(--cds-productive-heading-02-font-weight,600);line-height:var(--cds-productive-heading-02-line-height,1.375);letter-spacing:var(--cds-productive-heading-02-letter-spacing,0)}h6{font-size:var(--cds-productive-heading-01-font-size,.875rem);font-weight:var(--cds-productive-heading-01-font-weight,600);line-height:var(--cds-productive-heading-01-line-height,1.28572);letter-spacing:var(--cds-productive-heading-01-letter-spacing,.16px)}p{font-size:var(--cds-body-long-02-font-size,1rem);font-weight:var(--cds-body-long-02-font-weight,400);line-height:var(--cds-body-long-02-line-height,1.5);letter-spacing:var(--cds-body-long-02-letter-spacing,0)}a{color:#0f62fe}em{font-style:italic}@-webkit-keyframes skeleton{0%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}20%{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}28%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}51%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}58%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}82%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}83%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}96%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}100%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}}@keyframes skeleton{0%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}20%{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}28%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}51%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}58%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:right;transform-origin:right}82%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:right;transform-origin:right}83%{-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transform-origin:left;transform-origin:left}96%{-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}100%{opacity:.3;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transform-origin:left;transform-origin:left}}.bx--assistive-text,.bx--visually-hidden{position:absolute;overflow:hidden;width:1px;height:1px;padding:0;border:0;margin:-1px;clip:rect(0,0,0,0);visibility:inherit;white-space:nowrap}.bx--body{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);background-color:var(--cds-ui-background,#fff);color:var(--cds-text-01,#161616);line-height:1}.bx--body *,.bx--body ::after,.bx--body ::before{box-sizing:inherit}.bx--text-truncate--end{display:inline-block;overflow:hidden;width:100%;text-overflow:ellipsis;white-space:nowrap}.bx--text-truncate--front{display:inline-block;overflow:hidden;width:100%;direction:rtl;text-overflow:ellipsis;white-space:nowrap}.bx--fieldset{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;margin-bottom:2rem}.bx--fieldset *,.bx--fieldset ::after,.bx--fieldset ::before{box-sizing:inherit}.bx--fieldset--no-margin{margin-bottom:0}.bx--form-item{font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);display:flex;flex:1 1 auto;flex-direction:column;align-items:flex-start}.bx--label{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);line-height:var(--cds-label-01-line-height,1.33333);letter-spacing:var(--cds-label-01-letter-spacing,.32px);display:inline-block;margin-bottom:.5rem;color:var(--cds-text-02,#525252);font-weight:400;line-height:1rem;vertical-align:baseline}.bx--label *,.bx--label ::after,.bx--label ::before{box-sizing:inherit}.bx--label .bx--tooltip__trigger{font-size:var(--cds-label-01-font-size,.75rem);font-weight:var(--cds-label-01-font-weight,400);line-height:var(--cds-label-01-line-height,1.33333);letter-spacing:var(--cds-label-01-letter-spacing,.32px)}.bx--label.bx--skeleton{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none;width:4.6875rem;height:.875rem}.bx--label.bx--skeleton:active,.bx--label.bx--skeleton:focus,.bx--label.bx--skeleton:hover{border:none;cursor:default;outline:0}.bx--label.bx--skeleton::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.bx--label.bx--skeleton::before{-webkit-animation:none;animation:none}}input[type=number]{font-family:'IBM Plex Mono',Menlo,'DejaVu Sans Mono','Bitstream Vera Sans Mono',Courier,monospace}.bx--combo-box[data-invalid] .bx--text-input:not(:focus),.bx--list-box[data-invalid]:not(:focus),.bx--number[data-invalid] input[type=number]:not(:focus),.bx--select-input__wrapper[data-invalid] .bx--select-input:not(:focus),.bx--text-area__wrapper[data-invalid]>.bx--text-area--invalid:not(:focus),.bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline:2px solid var(--cds-support-01,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.bx--combo-box[data-invalid] .bx--text-input:not(:focus),.bx--list-box[data-invalid]:not(:focus),.bx--number[data-invalid] input[type=number]:not(:focus),.bx--select-input__wrapper[data-invalid] .bx--select-input:not(:focus),.bx--text-area__wrapper[data-invalid]>.bx--text-area--invalid:not(:focus),.bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid:not(:focus),input[data-invalid]:not(:focus){outline-style:dotted}}.bx--date-picker-input__wrapper--invalid~.bx--form-requirement,.bx--date-picker-input__wrapper--warn~.bx--form-requirement,.bx--date-picker-input__wrapper~.bx--form-requirement,.bx--list-box--warning~.bx--form-requirement,.bx--list-box[data-invalid]~.bx--form-requirement,.bx--number[data-invalid] .bx--number__input-wrapper~.bx--form-requirement,.bx--number__input-wrapper--warning~.bx--form-requirement,.bx--select--warning .bx--select-input__wrapper~.bx--form-requirement,.bx--select-input__wrapper[data-invalid]~.bx--form-requirement,.bx--text-area__wrapper[data-invalid]~.bx--form-requirement,.bx--text-input__field-wrapper--warning>.bx--text-input~.bx--form-requirement,.bx--text-input__field-wrapper--warning~.bx--form-requirement,.bx--text-input__field-wrapper[data-invalid]~.bx--form-requirement,.bx--time-picker--invalid~.bx--form-requirement,.bx--time-picker[data-invalid]~.bx--form-requirement,input[data-invalid]~.bx--form-requirement{display:block;overflow:visible;max-height:12.5rem;font-weight:400}.bx--date-picker-input__wrapper--invalid~.bx--form-requirement,.bx--date-picker-input__wrapper~.bx--form-requirement,.bx--list-box[data-invalid]~.bx--form-requirement,.bx--number[data-invalid] .bx--number__input-wrapper~.bx--form-requirement,.bx--select-input__wrapper[data-invalid]~.bx--form-requirement,.bx--text-area__wrapper[data-invalid]~.bx--form-requirement,.bx--text-input__field-wrapper[data-invalid]~.bx--form-requirement,.bx--time-picker--invalid~.bx--form-requirement,.bx--time-picker[data-invalid]~.bx--form-requirement,input[data-invalid]~.bx--form-requirement{color:var(--cds-text-error,#da1e28)}.bx--form--fluid .bx--text-input__field-wrapper--warning,.bx--form--fluid .bx--text-input__field-wrapper[data-invalid]{display:block}.bx--form--fluid .bx--fieldset{margin:0}.bx--form--fluid input[data-invalid]{outline:0}.bx--form--fluid .bx--form-requirement{padding:.5rem 2.5rem .5rem 1rem;margin:0}input:not(output):not([data-invalid]):-moz-ui-invalid{box-shadow:none}.bx--form-requirement{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-caption-01-font-size,.75rem);font-weight:var(--cds-caption-01-font-weight,400);line-height:var(--cds-caption-01-line-height,1.33333);letter-spacing:var(--cds-caption-01-letter-spacing,.32px);display:none;overflow:hidden;max-height:0;margin:.25rem 0 0}.bx--form-requirement *,.bx--form-requirement ::after,.bx--form-requirement ::before{box-sizing:inherit}.bx--select--inline .bx--form__helper-text{margin-top:0}.bx--form__helper-text{font-size:var(--cds-helper-text-01-font-size,.75rem);line-height:var(--cds-helper-text-01-line-height,1.33333);letter-spacing:var(--cds-helper-text-01-letter-spacing,.32px);z-index:0;width:100%;margin-top:.25rem;color:var(--cds-text-02,#525252);opacity:1}.bx--form__helper-text--disabled,.bx--label--disabled{color:var(--cds-disabled-02,#c6c6c6)}fieldset[disabled] .bx--form__helper-text,fieldset[disabled] .bx--label{color:var(--cds-disabled-02,#c6c6c6)}.bx--text-input{box-sizing:border-box;padding:0;border:0;margin:0;font-family:inherit;font-size:100%;vertical-align:baseline;font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px);outline:2px solid transparent;outline-offset:-2px;width:100%;height:2.5rem;padding:0 1rem;border:none;border-bottom:1px solid var(--cds-ui-04,#8d8d8d);background-color:var(--cds-field-01,#f4f4f4);color:var(--cds-text-01,#161616);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.bx--text-input *,.bx--text-input ::after,.bx--text-input ::before{box-sizing:inherit}.bx--text-input:active,.bx--text-input:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.bx--text-input:active,.bx--text-input:focus{outline-style:dotted}}.bx--text-input-wrapper svg[hidden]{display:none}.bx--text-input--lg,.bx--text-input--xl{height:3rem}.bx--text-input--sm{height:2rem}.bx--password-input{padding-right:2.5rem}.bx--text-input--sm.bx--password-input{padding-right:2rem}.bx--text-input--lg.bx--password-input{padding-right:3rem}.bx--text-input::-webkit-input-placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--text-input::-moz-placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--text-input:-ms-input-placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--text-input::-ms-input-placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--text-input::placeholder{color:var(--cds-text-05,#6f6f6f);opacity:1}.bx--text-input--light{background-color:var(--cds-field-02,#fff)}.bx--text-input__field-wrapper{position:relative;display:flex;width:100%}.bx--text-input__invalid-icon,.bx--text-input__readonly-icon{position:absolute;top:50%;right:1rem;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.bx--text-input__invalid-icon{fill:var(--cds-support-01,#da1e28)}.bx--text-input__invalid-icon--warning{fill:var(--cds-support-03,#f1c21b)}.bx--text-input__invalid-icon--warning path:first-of-type{fill:#000;opacity:1}.bx--text-input--password__visibility{position:relative;display:inline-flex;overflow:visible;align-items:center;cursor:pointer}.bx--text-input--password__visibility:focus{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.bx--text-input--password__visibility:focus{outline-style:dotted}}.bx--text-input--password__visibility:focus{outline:1px solid transparent}.bx--text-input--password__visibility:focus svg{outline:1px solid var(--cds-focus,#0f62fe)}@media screen and (prefers-contrast){.bx--text-input--password__visibility:focus svg{outline-style:dotted}}.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after,.bx--text-input--password__visibility::before{position:absolute;z-index:6000;display:flex;align-items:center;opacity:0;pointer-events:none}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after,.bx--text-input--password__visibility::before{display:inline-block}}.bx--text-input--password__visibility::after,.bx--text-input--password__visibility::before{transition:opacity 70ms cubic-bezier(.2,0,.38,.9)}.bx--text-input--password__visibility.bx--tooltip--a11y::after,.bx--text-input--password__visibility.bx--tooltip--a11y::before{transition:none}.bx--text-input--password__visibility::before{width:0;height:0;border-style:solid;content:\"\"}.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text{box-sizing:content-box;color:inherit;opacity:1;white-space:normal;word-break:break-word}.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after{box-shadow:0 2px 6px var(--cds-shadow,rgba(0,0,0,.3));z-index:6000;width:-webkit-max-content;width:-moz-max-content;width:max-content;min-width:1.5rem;max-width:13rem;height:auto;padding:.1875rem 1rem;background-color:var(--cds-inverse-02,#393939);border-radius:.125rem;color:var(--cds-inverse-01,#fff);font-weight:400;text-align:left;-webkit-transform:translateX(-50%);transform:translateX(-50%);font-size:var(--cds-body-short-01-font-size,.875rem);font-weight:var(--cds-body-short-01-font-weight,400);line-height:var(--cds-body-short-01-line-height,1.28572);letter-spacing:var(--cds-body-short-01-letter-spacing,.16px)}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after{width:auto}}@supports (-ms-accelerator:true){.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after{width:auto}}@supports (-ms-ime-align:auto){.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after{width:auto}}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after{border:1px solid transparent}}.bx--text-input--password__visibility::after{content:attr(aria-label)}.bx--text-input--password__visibility.bx--tooltip--a11y::after{content:none}.bx--text-input--password__visibility.bx--tooltip--visible::after,.bx--text-input--password__visibility.bx--tooltip--visible::before,.bx--text-input--password__visibility:focus::after,.bx--text-input--password__visibility:focus::before,.bx--text-input--password__visibility:hover::after,.bx--text-input--password__visibility:hover::before{opacity:1}@-webkit-keyframes tooltip-fade{from{opacity:0}to{opacity:1}}@keyframes tooltip-fade{from{opacity:0}to{opacity:1}}.bx--text-input--password__visibility.bx--tooltip--visible .bx--assistive-text,.bx--text-input--password__visibility.bx--tooltip--visible+.bx--assistive-text,.bx--text-input--password__visibility:focus .bx--assistive-text,.bx--text-input--password__visibility:focus+.bx--assistive-text,.bx--text-input--password__visibility:hover .bx--assistive-text,.bx--text-input--password__visibility:hover+.bx--assistive-text{overflow:visible;margin:auto;clip:auto}.bx--text-input--password__visibility.bx--tooltip--visible .bx--assistive-text,.bx--text-input--password__visibility.bx--tooltip--visible+.bx--assistive-text,.bx--text-input--password__visibility.bx--tooltip--visible.bx--tooltip--a11y::before,.bx--text-input--password__visibility:focus .bx--assistive-text,.bx--text-input--password__visibility:focus+.bx--assistive-text,.bx--text-input--password__visibility:focus.bx--tooltip--a11y::before,.bx--text-input--password__visibility:hover .bx--assistive-text,.bx--text-input--password__visibility:hover+.bx--assistive-text,.bx--text-input--password__visibility:hover.bx--tooltip--a11y::before{-webkit-animation:tooltip-fade 70ms cubic-bezier(.2,0,.38,.9);animation:tooltip-fade 70ms cubic-bezier(.2,0,.38,.9)}.bx--text-input--password__visibility.bx--tooltip--hidden .bx--assistive-text,.bx--text-input--password__visibility.bx--tooltip--hidden+.bx--assistive-text{overflow:hidden;margin:-1px;clip:rect(0,0,0,0)}.bx--text-input--password__visibility.bx--tooltip--hidden.bx--tooltip--a11y::before{-webkit-animation:none;animation:none;opacity:0}.bx--text-input--password__visibility .bx--assistive-text::after{position:absolute;display:block;content:\"\";left:0;width:100%;height:.75rem;top:-.75rem}.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after,.bx--text-input--password__visibility::before{bottom:0;left:50%}.bx--text-input--password__visibility::before{bottom:-.5rem;border-width:0 .25rem .3125rem .25rem;border-color:transparent transparent var(--cds-inverse-02,#393939) transparent;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.bx--text-input--password__visibility .bx--assistive-text,.bx--text-input--password__visibility+.bx--assistive-text,.bx--text-input--password__visibility::after{bottom:-.8125rem;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger,.bx--text-input--password__visibility{outline:2px solid transparent;outline-offset:-2px;position:absolute;right:0;display:flex;width:2.5rem;height:100%;min-height:auto;align-items:center;justify-content:center;padding:0;border:0;background:0 0;cursor:pointer;transition:outline 70ms cubic-bezier(.2,0,.38,.9)}.bx--text-input--sm+.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger{width:2rem}.bx--text-input--lg+.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger{width:3rem}.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger svg{fill:var(--cds-icon-secondary,#525252);transition:fill 70ms cubic-bezier(.2,0,.38,.9)}@media screen and (-ms-high-contrast:active),screen and (prefers-contrast){.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger svg{fill:ButtonText}}.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger:focus{outline-style:dotted}}.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger:focus svg,.bx--btn.bx--text-input--password__visibility__toggle.bx--tooltip__trigger:hover svg{fill:var(--cds-icon-primary,#161616)}.bx--text-input--invalid,.bx--text-input--warning,.bx--text-input-wrapper--readonly .bx--text-input{padding-right:2.5rem}.bx--text-input--invalid.bx--password-input{padding-right:4rem}.bx--text-input--invalid+.bx--text-input--password__visibility,.bx--text-input--invalid+.bx--text-input--password__visibility__toggle{right:1rem}.bx--password-input-wrapper .bx--text-input__invalid-icon{right:2.5rem}.bx--text-input:disabled+.bx--text-input--password__visibility svg,.bx--text-input:disabled+.bx--text-input--password__visibility__toggle.bx--tooltip__trigger svg{cursor:not-allowed;fill:var(--cds-disabled-02,#c6c6c6)}.bx--text-input:disabled+.bx--text-input--password__visibility svg:hover,.bx--text-input:disabled+.bx--text-input--password__visibility__toggle.bx--tooltip__trigger svg:hover{fill:var(--cds-disabled-02,#c6c6c6)}.bx--text-input:disabled{outline:2px solid transparent;outline-offset:-2px;border-bottom:1px solid transparent;background-color:var(--cds-field,#f4f4f4);color:var(--cds-text-disabled,#c6c6c6);cursor:not-allowed;-webkit-text-fill-color:var(--cds-disabled-02,#c6c6c6)}.bx--text-input--light:disabled{background-color:var(--cds-field-02,#fff)}.bx--text-input:disabled::-webkit-input-placeholder{color:var(--cds-disabled-02,#c6c6c6);opacity:1}.bx--text-input:disabled::-moz-placeholder{color:var(--cds-disabled-02,#c6c6c6);opacity:1}.bx--text-input:disabled:-ms-input-placeholder{color:var(--cds-disabled-02,#c6c6c6);opacity:1}.bx--text-input:disabled::-ms-input-placeholder{color:var(--cds-disabled-02,#c6c6c6);opacity:1}.bx--text-input:disabled::placeholder{color:var(--cds-disabled-02,#c6c6c6);opacity:1}.bx--text-input--invalid{outline:2px solid var(--cds-support-01,#da1e28);outline-offset:-2px;box-shadow:none}@media screen and (prefers-contrast){.bx--text-input--invalid{outline-style:dotted}}.bx--text-input--invalid .bx--text-input--password__visibility,.bx--text-input--invalid .bx--text-input--password__visibility__toggle{right:2.5rem}.bx--skeleton.bx--text-input{position:relative;padding:0;border:none;background:var(--cds-skeleton-01,#e5e5e5);box-shadow:none;pointer-events:none}.bx--skeleton.bx--text-input:active,.bx--skeleton.bx--text-input:focus,.bx--skeleton.bx--text-input:hover{border:none;cursor:default;outline:0}.bx--skeleton.bx--text-input::before{position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:3s ease-in-out skeleton infinite;animation:3s ease-in-out skeleton infinite;background:var(--cds-skeleton-02,#c6c6c6);content:\"\";will-change:transform-origin,transform,opacity}@media (prefers-reduced-motion:reduce){.bx--skeleton.bx--text-input::before{-webkit-animation:none;animation:none}}.bx--form--fluid .bx--text-input-wrapper{position:relative;background:var(--cds-field-01,#f4f4f4);transition:background-color 70ms cubic-bezier(.2,0,.38,.9),outline 70ms cubic-bezier(.2,0,.38,.9)}.bx--form--fluid .bx--label{position:absolute;z-index:1;top:.8125rem;left:1rem;margin:0}.bx--form--fluid .bx--form__helper-text{display:none}.bx--form--fluid .bx--text-input{min-height:4rem;padding:2rem 1rem .8125rem}.bx--form--fluid .bx--text-input__divider,.bx--text-input__divider{display:none}.bx--form--fluid .bx--text-input--invalid,.bx--form--fluid .bx--text-input--warn{border-bottom:none}.bx--form--fluid .bx--text-input--invalid+.bx--text-input__divider,.bx--form--fluid .bx--text-input--warn+.bx--text-input__divider{display:block;border-style:solid;border-color:var(--cds-ui-03,#e0e0e0);border-bottom:none;margin:0 1rem}.bx--form--fluid .bx--text-input__invalid-icon{top:5rem}.bx--form--fluid .bx--text-input-wrapper--light{background:var(--cds-field-02,#fff)}.bx--form--fluid .bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid{outline:2px solid transparent;outline-offset:-2px}.bx--form--fluid .bx--text-input__field-wrapper[data-invalid]:not(:focus){outline:2px solid var(--cds-support-01,#da1e28);outline-offset:-2px}@media screen and (prefers-contrast){.bx--form--fluid .bx--text-input__field-wrapper[data-invalid]:not(:focus){outline-style:dotted}}.bx--form--fluid .bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid:focus{outline:2px solid var(--cds-focus,#0f62fe);outline-offset:-2px}@media screen and (prefers-contrast){.bx--form--fluid .bx--text-input__field-wrapper[data-invalid]>.bx--text-input--invalid:focus{outline-style:dotted}}.bx--text-input-wrapper.bx--text-input-wrapper--inline{flex-flow:row wrap}.bx--text-input-wrapper .bx--label--inline{flex:1;margin:.8125rem 0 0 0;overflow-wrap:break-word;word-break:break-word}.bx--text-input-wrapper .bx--label--inline--sm{margin-top:.5625rem}.bx--text-input-wrapper .bx--label--inline--lg,.bx--text-input-wrapper .bx--label--inline--xl{margin-top:1.0625rem}.bx--text-input__label-helper-wrapper{max-width:8rem;flex:2;flex-direction:column;margin-right:1.5rem;overflow-wrap:break-word}.bx--text-input-wrapper .bx--form__helper-text--inline{margin-top:.125rem}.bx--text-input__field-outer-wrapper{display:flex;width:100%;flex:1 1 auto;flex-direction:column;align-items:flex-start}.bx--text-input__field-outer-wrapper--inline{flex:8;flex-direction:column}.bx--form--fluid .bx--text-input-wrapper--readonly,.bx--text-input-wrapper--readonly .bx--text-input{background:0 0}@media screen and (-ms-high-contrast:active),(forced-colors:active),(prefers-contrast){.bx--btn.bx--btn--icon-only.bx--text-input--password__visibility__toggle.bx--tooltip__trigger svg,.bx--btn.bx--btn--icon-only.bx--text-input--password__visibility__toggle.bx--tooltip__trigger:hover svg,.bx--text-input--password__visibility{fill:ButtonText}}:host(bx-input){width:100%;outline:0}"
]);

});


parcelRegister("izlGd", function(module, exports) {

$parcel$export(module.exports, "DATE_PICKER_INPUT_KIND", () => $d84c5008a38124d4$export$9c69896748fd1929);
$parcel$export(module.exports, "DATE_PICKER_INPUT_SIZE_HORIZONTAL", () => $d84c5008a38124d4$export$66d49e4c38bef3b7);
$parcel$export(module.exports, "DATE_PICKER_INPUT_COLOR_SCHEME", () => (parcelRequire("e4B20")).FORM_ELEMENT_COLOR_SCHEME);
/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $e4B20 = parcelRequire("e4B20");
let $d84c5008a38124d4$export$9c69896748fd1929;
/**
 * Horizontal size, applicable only to the simple variant.
 */ (function(DATE_PICKER_INPUT_KIND) {
    DATE_PICKER_INPUT_KIND["SIMPLE"] = "simple";
    DATE_PICKER_INPUT_KIND["SINGLE"] = "single";
    DATE_PICKER_INPUT_KIND["FROM"] = "from";
    DATE_PICKER_INPUT_KIND["TO"] = "to";
})($d84c5008a38124d4$export$9c69896748fd1929 || ($d84c5008a38124d4$export$9c69896748fd1929 = {}));
let $d84c5008a38124d4$export$66d49e4c38bef3b7;
(function(DATE_PICKER_INPUT_SIZE_HORIZONTAL) {
    DATE_PICKER_INPUT_SIZE_HORIZONTAL["REGULAR"] = "";
    DATE_PICKER_INPUT_SIZE_HORIZONTAL["SHORT"] = "short";
})($d84c5008a38124d4$export$66d49e4c38bef3b7 || ($d84c5008a38124d4$export$66d49e4c38bef3b7 = {}));

});


parcelRegister("lOE5j", function(module, exports) {
"use strict";
var $fe1d5c787372a933$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fe1d5c787372a933$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fe1d5c787372a933$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fe1d5c787372a933$var$__exportStar((parcelRequire("kwNid")), module.exports);

});
parcelRegister("kwNid", function(module, exports) {
"use strict";
var $ef1d08533c74b694$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ef1d08533c74b694$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccordionItemComponent = module.exports.FaqArrow = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.FaqArrow = (0, $4TeKW.svg)`
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
     <path
      fill="currentColor"
      d="M8.222 4.607a.737.737 0 000 1.055l5.944 5.838-5.944 5.838a.737.737 0 000 1.054.77.77 0 001.075 0l6.48-6.365a.737.737 0 000-1.054l-6.48-6.366a.77.77 0 00-1.075 0z"
     ></path>
    </svg>
    `;
/**
 * @customElement rx-accordion-item
 *
 * CSS Variables
 * --accordion-bg-color: rgb(255, 255, 255);
 * --accordion-content-bg-color: rgb(255, 255, 255);
 * --accordion-title-font-size: 20px;
 */ let $ef1d08533c74b694$var$AccordionItemComponent = class AccordionItemComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.opened = false;
        this.maxContentHeight = '1000px';
        this.arrowRotationClosed = '0deg';
        this.arrowRotationOpened = '90deg';
    }
};
$ef1d08533c74b694$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $ef1d08533c74b694$var$__metadata("design:type", Object)
], $ef1d08533c74b694$var$AccordionItemComponent.prototype, "opened", void 0);
$ef1d08533c74b694$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $ef1d08533c74b694$var$__metadata("design:type", Object)
], $ef1d08533c74b694$var$AccordionItemComponent.prototype, "maxContentHeight", void 0);
$ef1d08533c74b694$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $ef1d08533c74b694$var$__metadata("design:type", Object)
], $ef1d08533c74b694$var$AccordionItemComponent.prototype, "arrowRotationClosed", void 0);
$ef1d08533c74b694$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $ef1d08533c74b694$var$__metadata("design:type", Object)
], $ef1d08533c74b694$var$AccordionItemComponent.prototype, "arrowRotationOpened", void 0);
$ef1d08533c74b694$var$AccordionItemComponent = $ef1d08533c74b694$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-accordion-item',
        styles: [
            (0, $4TeKW.css)`
    .container {
     position: relative;
     background: white;
     border-radius: 12px;
    }
    button {
     width: 100%;
     z-index: 2;
     padding: 0px;
     background: var(--accordeon-bg-color, rgb(255, 255, 255));
     box-shadow: rgb(26 66 75 / 3%) 0px 2px 4px, rgb(26 66 75 / 6%) 0px 10px 20px;
     color: rgb(111, 124, 166);
     text-align: left;
     white-space: initial;
     transition: color 250ms ease-in-out 0s;
     position: relative;
     display: inline-block;
     font-size: 14px;
     font-weight: 400;
     line-height: 1.5;
     text-decoration: none;
     border: 0px;
     outline: 0px;
     cursor: pointer;
     border-radius: 12px;
    }
 
    .icon {
     font-size: 50px;
     display: flex;
     -webkit-box-align: center;
     align-items: center;
     -webkit-box-pack: center;
     justify-content: center;
     position: absolute;
     top: 50%;
     margin-top: -0.5em;
     right: 28px;
     background-color: rgba(223, 235, 247, 0.4);
     border-radius: 50px;
     width: 1em;
     height: 1em;
 
     transition: transform 300ms ease-in-out 0s;
    }
 
    svg {
     display: block;
     stroke: currentcolor;
     stroke-width: 1px;
    }
    h4 {
     font-weight: 500;
     font-size: var(--accordion-title-font-size, 20px);
     line-height: 1.2;
     text-align: left;
     padding-left: 30px;
    }
 
    .content {
     border-radius: 12px;
     background-color: var(--accordion-content-bg-color, rgb(253, 254, 254));
     transition: all 500ms ease 0s;
     z-index: 1;
     overflow: hidden;
     margin-top: 10px;
     color: rgb(111, 124, 166);
     font-size: 18px;
     padding-bottom: 10px;
    }
   `
        ],
        template () {
            return (0, $4TeKW.html)`
    <div
     part="container"
     class="container"
     @click=${()=>{
                this.opened = !this.opened;
                this.dispatchEvent(new CustomEvent('clicked', {
                    detail: {
                        el: this,
                        opened: this.opened
                    }
                }));
            }}
    >
     <button part="button" type="button">
      <div
       part="icon"
       class="icon"
       style=${(0, $4TeKW.styleMap)({
                transform: this.opened ? `rotate(${this.arrowRotationOpened})` : `rotate(${this.arrowRotationClosed})`
            })}
      >
       ${module.exports.FaqArrow}
      </div>
      <h4
       part="title"
       style=${(0, $4TeKW.styleMap)({
                color: this.opened ? 'rgb(33, 43, 54)' : 'rgb(111, 124, 166)'
            })}
      >
       <slot name="title"></slot>
      </h4>
     </button>
    </div>
    <div
     style=${(0, $4TeKW.styleMap)({
                'max-height': this.opened ? this.maxContentHeight : '0',
                opacity: this.opened ? '1' : '0',
                padding: this.opened ? '30px 36px 25.6px' : '0px 36px 0px',
                'margin-bottom': this.opened ? '10px' : '0px'
            })}
     part="content"
     class="content"
    >
     <slot name="content"></slot>
    </div>
   `;
        }
    })
], $ef1d08533c74b694$var$AccordionItemComponent);
module.exports.AccordionItemComponent = $ef1d08533c74b694$var$AccordionItemComponent;

});


parcelRegister("ljRQS", function(module, exports) {
"use strict";
var $f855253406b3e1c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f855253406b3e1c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f855253406b3e1c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f855253406b3e1c8$var$__exportStar((parcelRequire("cFV6v")), module.exports);

});
parcelRegister("cFV6v", function(module, exports) {
"use strict";
var $93a59c014a5525b0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $93a59c014a5525b0$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $93a59c014a5525b0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AlertComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement rx-alert
 */ let $93a59c014a5525b0$var$AlertComponent = class AlertComponent extends $4TeKW.LitElement {
    onClose() {
        this.dispatchEvent(new CustomEvent('onClose', {
            detail: this
        }));
        this.remove();
    }
    OnUpdateFirst() {
        if (this.palette === 'primary') this.setPaletteStyle('#d8eafc', '#1e87f0');
        else if (this.palette === 'success') this.setPaletteStyle('#edfbf6', '#32d296');
        else if (this.palette === 'warning') this.setPaletteStyle('#fff6ee', '#faa05a');
        else if (this.palette === 'danger') this.setPaletteStyle('#fef4f6', '#f0506e');
        else if (this.palette === 'default') this.setPaletteStyle('#f8f8f8', '#666');
    }
    setPaletteStyle(backgroundColor, color) {
        this.paletteStyle = (0, $4TeKW.css)`
      :host {
        background: ${(0, $4TeKW.unsafeCSS)(backgroundColor)};
        color: ${(0, $4TeKW.unsafeCSS)(color)};
      }
    `;
    }
};
$93a59c014a5525b0$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $93a59c014a5525b0$var$__metadata("design:type", String)
], $93a59c014a5525b0$var$AlertComponent.prototype, "palette", void 0);
$93a59c014a5525b0$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $93a59c014a5525b0$var$__metadata("design:type", $4TeKW.CSSResult)
], $93a59c014a5525b0$var$AlertComponent.prototype, "paletteStyle", void 0);
$93a59c014a5525b0$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $93a59c014a5525b0$var$__metadata("design:type", Boolean)
], $93a59c014a5525b0$var$AlertComponent.prototype, "transition", void 0);
$93a59c014a5525b0$var$AlertComponent = $93a59c014a5525b0$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-alert',
        style: (0, $4TeKW.css)`
    :host {
      position: relative;
      padding: 15px 29px 15px 15px;
    }

    slot {
      font-size: 15px;
      font-weight: normal;
      line-height: 1.5;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
    }

    a {
      position: absolute;
      top: 15px;
      right: 15px;
      color: inherit;
      opacity: 0.4;
    }
    a:hover {
      cursor: pointer;
      color: inherit;
      opacity: 0.8;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <style>
        ${this.paletteStyle}
      </style>
      <a @click=${()=>$93a59c014a5525b0$var$__awaiter(this, void 0, void 0, function*() {
                    return this.onClose();
                })}>
        ${(0, $4TeKW.svg)`
              <svg width="14" height="14" viewBox="0 0 14 14">
                <line fill="none" stroke="#666" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line>
                <line fill="none" stroke="#666" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line>
              </svg>
            `}</a
      >
      <slot part="text"></slot>
    `;
        }
    })
], $93a59c014a5525b0$var$AlertComponent);
module.exports.AlertComponent = $93a59c014a5525b0$var$AlertComponent;

});


parcelRegister("lx3ty", function(module, exports) {
"use strict";
var $facf60383e3545e6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $facf60383e3545e6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $facf60383e3545e6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$facf60383e3545e6$var$__exportStar((parcelRequire("eosO9")), module.exports);

});
parcelRegister("eosO9", function(module, exports) {
"use strict";
var $a7a9a73a2fd45904$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a7a9a73a2fd45904$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ButtonComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("9DBLY");
/**
 * @customElement rx-button
 */ let $a7a9a73a2fd45904$var$ButtonComponent = class ButtonComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.palette = 'default';
    }
    OnUpdateFirst() {
        if (this.type === 'submit') {
            const form = this.getFormElement();
            if (form) {
                const input = document.createElement('input');
                input.style.display = 'none';
                input.type = this.type;
                form.append(input);
                this.addEventListener('click', ()=>input.click());
            }
        }
    }
    getFormElement() {
        const defaultKey = 'parentElement';
        let selector = '';
        let form;
        for (const k of Array(100).fill(defaultKey)){
            const formElement = this.findForm(selector);
            if (formElement) {
                form = formElement;
                break;
            }
            selector += `.${k}`;
        }
        return form;
    }
    get(obj = {}, path = '') {
        return path.replace(/\[(.+?)\]/g, '.$1').split('.').reduce((o, key)=>!o[key] ? o : o[key], obj);
    }
    findForm(selector) {
        let form;
        if (!selector) form = this.parentElement;
        else form = this.get(this.parentElement, selector);
        if (form && form.tagName !== 'FORM') return null;
        return form;
    }
};
$a7a9a73a2fd45904$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $a7a9a73a2fd45904$var$__metadata("design:type", String)
], $a7a9a73a2fd45904$var$ButtonComponent.prototype, "palette", void 0);
$a7a9a73a2fd45904$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $a7a9a73a2fd45904$var$__metadata("design:type", Boolean)
], $a7a9a73a2fd45904$var$ButtonComponent.prototype, "disabled", void 0);
$a7a9a73a2fd45904$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $a7a9a73a2fd45904$var$__metadata("design:type", String)
], $a7a9a73a2fd45904$var$ButtonComponent.prototype, "type", void 0);
$a7a9a73a2fd45904$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $a7a9a73a2fd45904$var$__metadata("design:type", Boolean)
], $a7a9a73a2fd45904$var$ButtonComponent.prototype, "shadow", void 0);
$a7a9a73a2fd45904$var$ButtonComponent = $a7a9a73a2fd45904$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-button',
        template () {
            return (0, $4TeKW.html)`
      <style>
        :host {
          margin: 0;
          border: none;
          overflow: visible;
          font: inherit;
          color: var(--${this.palette}-color);
          background: var(--${this.palette}-bg-color);
          border: var(--${this.palette}-border);
          color: #222;
          cursor: pointer;
          color: inherit;
          text-transform: none;
          -webkit-appearance: none;
          border-radius: 0;
          display: inline-block;
          box-sizing: border-box;
          padding: 0 30px;
          vertical-align: middle;
          font-size: 14px;
          line-height: 38px;
          text-align: center;
          text-decoration: none;
          text-transform: uppercase;
          transition: 0.1s ease-in-out;
          transition-property: color, background-color, border-color;
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
        }

        slot {
          user-select: none;
          color: var(--${this.palette}-color);
        }
      </style>
      ${this.disabled ? (0, $4TeKW.html)`
            <style>
              :host {
                background: #929a9c;
              }
            </style>
          ` : (0, $4TeKW.html)`
            <style>
              :host(:hover) {
                background-color: var(--${this.palette}-hover-color);
              }
              :host(:active) {
                background-color: var(--${this.palette}-active-color);
              }
            </style>
          `}
      ${this.shadow ? (0, $4TeKW.html)`<style>
            :host {
              box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 3px,
                rgba(0, 0, 0, 0.14) 0px 1px 2px;
            }
          </style>` : ''}
      <slot part="text"></slot>
    `;
        }
    })
], $a7a9a73a2fd45904$var$ButtonComponent);
module.exports.ButtonComponent = $a7a9a73a2fd45904$var$ButtonComponent;

});


parcelRegister("jde1E", function(module, exports) {
"use strict";
var $dfca1c6652a903b2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dfca1c6652a903b2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dfca1c6652a903b2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dfca1c6652a903b2$var$__exportStar((parcelRequire("5jpTE")), module.exports);

});
parcelRegister("5jpTE", function(module, exports) {
"use strict";
var $3de2d0a41430dc1a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3de2d0a41430dc1a$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("9DBLY");
/**
 * @customElement rx-card
 */ let $3de2d0a41430dc1a$var$CardComponent = class CardComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.shadow = '1';
        this.palette = 'default';
    }
};
$3de2d0a41430dc1a$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $3de2d0a41430dc1a$var$__metadata("design:type", String)
], $3de2d0a41430dc1a$var$CardComponent.prototype, "shadow", void 0);
$3de2d0a41430dc1a$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $3de2d0a41430dc1a$var$__metadata("design:type", Boolean)
], $3de2d0a41430dc1a$var$CardComponent.prototype, "invert", void 0);
$3de2d0a41430dc1a$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $3de2d0a41430dc1a$var$__metadata("design:type", String)
], $3de2d0a41430dc1a$var$CardComponent.prototype, "palette", void 0);
$3de2d0a41430dc1a$var$CardComponent = $3de2d0a41430dc1a$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-card',
        style: (0, $4TeKW.css)`
    .card {
      border-radius: 8px;
      margin: 0px;
    }

    .card-1 {
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.14);
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    }

    .card-1:hover {
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.08),
        0 10px 10px rgba(0, 0, 0, 0.08);
    }

    .black {
      box-shadow: 0 14px 28px rgba(233, 233, 233, 0.2),
        0 10px 10px rgba(232, 232, 232, 0.18);
    }

    .card-2 {
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }

    .card-3 {
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    }

    .card-4 {
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25),
        0 10px 10px rgba(0, 0, 0, 0.22);
    }

    .card-5 {
      box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3),
        0 15px 12px rgba(0, 0, 0, 0.22);
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <style>
        .card {
          color: var(--${this.palette}-color);
          background-color:  var(--${this.palette}-bg-color);;
        }
      </style>
      <div part="card" class="card card-${this.shadow}${this.invert ? ' black' : ''}">
        <slot></slot>
      </div>
    `;
        }
    })
], $3de2d0a41430dc1a$var$CardComponent);
module.exports.CardComponent = $3de2d0a41430dc1a$var$CardComponent;

});


parcelRegister("cw7RH", function(module, exports) {
"use strict";
var $91ce930aa2caad05$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $91ce930aa2caad05$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $91ce930aa2caad05$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Paginator = void 0;

$91ce930aa2caad05$var$__exportStar((parcelRequire("6fZbL")), module.exports);
const $91ce930aa2caad05$var$Paginator = (items, page = 1, per_page = 10)=>{
    const offset = (page - 1) * per_page;
    const data = items.slice(offset).slice(0, per_page);
    const total_pages = Math.ceil(items.length / per_page);
    return {
        page: page,
        per_page: per_page,
        pre_page: page - 1 ? page - 1 : null,
        next_page: total_pages > page ? page + 1 : null,
        total: items.length,
        total_pages: total_pages,
        data: data,
        pages: [
            ...Array.from(Array(total_pages).keys()).map((item, index)=>{
                return {
                    active: index + 1 === page
                };
            })
        ]
    };
};
module.exports.Paginator = $91ce930aa2caad05$var$Paginator;

});
parcelRegister("6fZbL", function(module, exports) {
"use strict";
var $48e39b9bb8b5918a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $48e39b9bb8b5918a$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PaginationComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement rx-pagination
 */ let $48e39b9bb8b5918a$var$PaginationComponent = class PaginationComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.pages = [];
    }
    prev() {
        const index = this.pages.findIndex((v)=>v.active);
        if (index === 0) return;
        this.pages = this.pages.filter((p, i)=>{
            if (i === index - 1) {
                this.OnChange(i, p);
                p.active = true;
            } else p.active = false;
            return p;
        });
    }
    next() {
        const index = this.pages.findIndex((v)=>v.active);
        if (index + 1 === this.pages.length) return;
        this.pages = this.pages.filter((p, i)=>{
            if (i === index + 1) {
                this.OnChange(i, p);
                p.active = true;
            } else p.active = false;
            return p;
        });
    }
    OnChange(index, page) {
        this.dispatchEvent(new CustomEvent('change', {
            detail: {
                index: index + 1,
                page: page
            }
        }));
    }
    clicked(index) {
        this.pages = this.pages.map((p, i)=>{
            if (i === index) {
                this.OnChange(i, p);
                p.active = true;
            } else p.active = false;
            return p;
        });
    }
};
$48e39b9bb8b5918a$var$__decorate([
    (0, $4TeKW.property)({
        type: Array
    }),
    $48e39b9bb8b5918a$var$__metadata("design:type", Array)
], $48e39b9bb8b5918a$var$PaginationComponent.prototype, "pages", void 0);
$48e39b9bb8b5918a$var$PaginationComponent = $48e39b9bb8b5918a$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-pagination',
        style: (0, $4TeKW.css)`
    .rx-pagination {
      display: flex;
      flex-wrap: wrap;
      margin: 0px;
      padding: 0;
      margin-left: -20px;
      list-style: none;
      user-select: none;
    }

    .rx-pagination > * {
      flex: none;
      padding-left: 20px;
      position: relative;
    }

    .rx-pagination > .rx-active > * {
      color: #5a5a5a;
    }

    a:active {
      color: #a3a3a3;
    }

    a:hover {
      color: #888888;
    }

    li a {
      cursor: pointer;
      font-size: 14px;
      color: #b9b9b9;
    }
    .rx-icon:not(.rx-preserve) [stroke*='#']:not(.rx-preserve) {
      stroke: currentcolor;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <ul class="rx-pagination">
        <li class="rx-first-column">
          <a
            ><span
              @click=${()=>this.prev()}
              class="rx-icon rx-pagination-previous"
              ><svg width="7" height="14" viewBox="0 0 7 12">
                <polyline
                  fill="none"
                  stroke="#000"
                  stroke-width="1.5"
                  points="6 1 1 6 6 11"
                ></polyline></svg></span
          ></a>
        </li>
        ${this.pages.map((v, index)=>(0, $4TeKW.html)`
            <li class=${(0, $4TeKW.classMap)({
                    'rx-active': v.active
                })}>
              <a @click=${()=>this.clicked(index)}>${v.value || index + 1}</a>
            </li>
          `)}
        <li>
          <a
            ><span
              @click=${()=>this.next()}
              class="rx-icon rx-pagination-next"
              ><svg width="7" height="14" viewBox="0 0 7 12">
                <polyline
                  fill="none"
                  stroke="#000"
                  stroke-width="1.5"
                  points="1 1 6 6 1 11"
                ></polyline></svg></span
          ></a>
        </li>
      </ul>
    `;
        }
    })
], $48e39b9bb8b5918a$var$PaginationComponent);
module.exports.PaginationComponent = $48e39b9bb8b5918a$var$PaginationComponent;

});


parcelRegister("gBsDl", function(module, exports) {
"use strict";
var $c166500d75d20918$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c166500d75d20918$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c166500d75d20918$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c166500d75d20918$var$__exportStar((parcelRequire("dtke3")), module.exports);

});
parcelRegister("dtke3", function(module, exports) {
"use strict";
var $9cedac2d2f3b0760$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9cedac2d2f3b0760$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProgressComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("9DBLY");

var $bvXIe = parcelRequire("bvXIe");
/**
 * @customElement rx-progress
 */ let $9cedac2d2f3b0760$var$ProgressComponent = class ProgressComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.palette = 'default';
        this.height = 8;
        this._value = 0;
        this.rounded = false;
        this.label = false;
        this.type = 'bar';
    }
    get value() {
        return this._value;
    }
    set value(value) {
        const oldValue = this._value;
        this._value = value > 100 ? 100 : value;
        this.requestUpdate('value', oldValue);
    }
};
$9cedac2d2f3b0760$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $9cedac2d2f3b0760$var$__metadata("design:type", String)
], $9cedac2d2f3b0760$var$ProgressComponent.prototype, "palette", void 0);
$9cedac2d2f3b0760$var$__decorate([
    (0, $4TeKW.property)({
        type: Number
    }),
    $9cedac2d2f3b0760$var$__metadata("design:type", Object)
], $9cedac2d2f3b0760$var$ProgressComponent.prototype, "height", void 0);
$9cedac2d2f3b0760$var$__decorate([
    (0, $4TeKW.property)({
        type: Number
    }),
    $9cedac2d2f3b0760$var$__metadata("design:type", Number),
    $9cedac2d2f3b0760$var$__metadata("design:paramtypes", [
        Number
    ])
], $9cedac2d2f3b0760$var$ProgressComponent.prototype, "value", null);
$9cedac2d2f3b0760$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $9cedac2d2f3b0760$var$__metadata("design:type", Object)
], $9cedac2d2f3b0760$var$ProgressComponent.prototype, "rounded", void 0);
$9cedac2d2f3b0760$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $9cedac2d2f3b0760$var$__metadata("design:type", Object)
], $9cedac2d2f3b0760$var$ProgressComponent.prototype, "label", void 0);
$9cedac2d2f3b0760$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $9cedac2d2f3b0760$var$__metadata("design:type", String)
], $9cedac2d2f3b0760$var$ProgressComponent.prototype, "type", void 0);
$9cedac2d2f3b0760$var$ProgressComponent = $9cedac2d2f3b0760$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-progress',
        template () {
            return (0, $4TeKW.html)`
      <style>
        :host {
          display: ${this.type === 'bar' ? 'block' : 'inline-block'};
        }
        .container {
          display: flex;
          height: ${this.type === 'circle' ? this.height <= 12 ? this.height * 10 + 20 : 140 : this.height}px;
          overflow: hidden;
          width: ${this.type === 'circle' ? this.height <= 12 ? this.height * 10 + 20 + 'px' : '140px' : '100%'};

          justify-content: ${this.type === 'bar' ? 'start' : 'center'};
          align-items: ${this.type === 'bar' ? 'flex-start' : 'center'};
        }
        .bar {
          width: ${this.value}%;
          height: 100%;
          background-color: var(--${this.palette}-bg-color);
          transition: width 0.4s ease;
          border-radius: ${this.rounded ? this.height / 2 + 'px' : '0px'};
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
        }
        .label {
          font-size: 0.5em;
          font-weight: bold;
        }

        ${this.type === 'circle' ? $bvXIe.progressCss : ''} .uikit.dark {
          background-color: #777777;
        }
        .uikit.dark .bar,
        .uikit.dark .fill {
          border-color: var(--${this.palette}-bg-color) !important;
        }
        .uikit.dark > span {
          color: var(--${this.palette}-color);
        }
        .uikit.dark:after {
          background-color: #666666;
        }
        .uikit.dark:hover > span {
          color: var(--${this.palette}-color);
        }

        .uikit {
          font-size: ${this.height <= 12 ? this.height * 10 : 120}px;
        }
      </style>
      <div class="container">
        ${this.type === 'bar' ? (0, $4TeKW.html)`
              <div class="bar">
                ${this.label && this.value > 5 ? (0, $4TeKW.html)`
                      <span class="label">${this.label ? this.value + '%' : ''}</span>
                    ` : ''}
              </div>
            ` : (0, $4TeKW.html)`
              <div class="uikit p${this.value} dark">
                <span>${this.value}%</span>
                <div class="slice">
                  <div class="bar"></div>
                  <div class="fill"></div>
                </div>
              </div>
            `}
      </div>
    `;
        }
    })
], $9cedac2d2f3b0760$var$ProgressComponent);
module.exports.ProgressComponent = $9cedac2d2f3b0760$var$ProgressComponent;

});
parcelRegister("bvXIe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.progressCss = void 0;

var $4TeKW = parcelRequire("4TeKW");
module.exports.progressCss = (0, $4TeKW.css)`
  .rect-auto,
  .uikit.p51 .slice,
  .uikit.p52 .slice,
  .uikit.p53 .slice,
  .uikit.p54 .slice,
  .uikit.p55 .slice,
  .uikit.p56 .slice,
  .uikit.p57 .slice,
  .uikit.p58 .slice,
  .uikit.p59 .slice,
  .uikit.p60 .slice,
  .uikit.p61 .slice,
  .uikit.p62 .slice,
  .uikit.p63 .slice,
  .uikit.p64 .slice,
  .uikit.p65 .slice,
  .uikit.p66 .slice,
  .uikit.p67 .slice,
  .uikit.p68 .slice,
  .uikit.p69 .slice,
  .uikit.p70 .slice,
  .uikit.p71 .slice,
  .uikit.p72 .slice,
  .uikit.p73 .slice,
  .uikit.p74 .slice,
  .uikit.p75 .slice,
  .uikit.p76 .slice,
  .uikit.p77 .slice,
  .uikit.p78 .slice,
  .uikit.p79 .slice,
  .uikit.p80 .slice,
  .uikit.p81 .slice,
  .uikit.p82 .slice,
  .uikit.p83 .slice,
  .uikit.p84 .slice,
  .uikit.p85 .slice,
  .uikit.p86 .slice,
  .uikit.p87 .slice,
  .uikit.p88 .slice,
  .uikit.p89 .slice,
  .uikit.p90 .slice,
  .uikit.p91 .slice,
  .uikit.p92 .slice,
  .uikit.p93 .slice,
  .uikit.p94 .slice,
  .uikit.p95 .slice,
  .uikit.p96 .slice,
  .uikit.p97 .slice,
  .uikit.p98 .slice,
  .uikit.p99 .slice,
  .uikit.p100 .slice {
    clip: rect(auto, auto, auto, auto);
  }

  .pie,
  .uikit .bar,
  .uikit.p51 .fill,
  .uikit.p52 .fill,
  .uikit.p53 .fill,
  .uikit.p54 .fill,
  .uikit.p55 .fill,
  .uikit.p56 .fill,
  .uikit.p57 .fill,
  .uikit.p58 .fill,
  .uikit.p59 .fill,
  .uikit.p60 .fill,
  .uikit.p61 .fill,
  .uikit.p62 .fill,
  .uikit.p63 .fill,
  .uikit.p64 .fill,
  .uikit.p65 .fill,
  .uikit.p66 .fill,
  .uikit.p67 .fill,
  .uikit.p68 .fill,
  .uikit.p69 .fill,
  .uikit.p70 .fill,
  .uikit.p71 .fill,
  .uikit.p72 .fill,
  .uikit.p73 .fill,
  .uikit.p74 .fill,
  .uikit.p75 .fill,
  .uikit.p76 .fill,
  .uikit.p77 .fill,
  .uikit.p78 .fill,
  .uikit.p79 .fill,
  .uikit.p80 .fill,
  .uikit.p81 .fill,
  .uikit.p82 .fill,
  .uikit.p83 .fill,
  .uikit.p84 .fill,
  .uikit.p85 .fill,
  .uikit.p86 .fill,
  .uikit.p87 .fill,
  .uikit.p88 .fill,
  .uikit.p89 .fill,
  .uikit.p90 .fill,
  .uikit.p91 .fill,
  .uikit.p92 .fill,
  .uikit.p93 .fill,
  .uikit.p94 .fill,
  .uikit.p95 .fill,
  .uikit.p96 .fill,
  .uikit.p97 .fill,
  .uikit.p98 .fill,
  .uikit.p99 .fill,
  .uikit.p100 .fill {
    position: absolute;
    border: 0.08em solid #307bbb;
    width: 0.84em;
    height: 0.84em;
    clip: rect(0em, 0.5em, 1em, 0em);
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  .pie-fill,
  .uikit.p51 .bar:after,
  .uikit.p51 .fill,
  .uikit.p52 .bar:after,
  .uikit.p52 .fill,
  .uikit.p53 .bar:after,
  .uikit.p53 .fill,
  .uikit.p54 .bar:after,
  .uikit.p54 .fill,
  .uikit.p55 .bar:after,
  .uikit.p55 .fill,
  .uikit.p56 .bar:after,
  .uikit.p56 .fill,
  .uikit.p57 .bar:after,
  .uikit.p57 .fill,
  .uikit.p58 .bar:after,
  .uikit.p58 .fill,
  .uikit.p59 .bar:after,
  .uikit.p59 .fill,
  .uikit.p60 .bar:after,
  .uikit.p60 .fill,
  .uikit.p61 .bar:after,
  .uikit.p61 .fill,
  .uikit.p62 .bar:after,
  .uikit.p62 .fill,
  .uikit.p63 .bar:after,
  .uikit.p63 .fill,
  .uikit.p64 .bar:after,
  .uikit.p64 .fill,
  .uikit.p65 .bar:after,
  .uikit.p65 .fill,
  .uikit.p66 .bar:after,
  .uikit.p66 .fill,
  .uikit.p67 .bar:after,
  .uikit.p67 .fill,
  .uikit.p68 .bar:after,
  .uikit.p68 .fill,
  .uikit.p69 .bar:after,
  .uikit.p69 .fill,
  .uikit.p70 .bar:after,
  .uikit.p70 .fill,
  .uikit.p71 .bar:after,
  .uikit.p71 .fill,
  .uikit.p72 .bar:after,
  .uikit.p72 .fill,
  .uikit.p73 .bar:after,
  .uikit.p73 .fill,
  .uikit.p74 .bar:after,
  .uikit.p74 .fill,
  .uikit.p75 .bar:after,
  .uikit.p75 .fill,
  .uikit.p76 .bar:after,
  .uikit.p76 .fill,
  .uikit.p77 .bar:after,
  .uikit.p77 .fill,
  .uikit.p78 .bar:after,
  .uikit.p78 .fill,
  .uikit.p79 .bar:after,
  .uikit.p79 .fill,
  .uikit.p80 .bar:after,
  .uikit.p80 .fill,
  .uikit.p81 .bar:after,
  .uikit.p81 .fill,
  .uikit.p82 .bar:after,
  .uikit.p82 .fill,
  .uikit.p83 .bar:after,
  .uikit.p83 .fill,
  .uikit.p84 .bar:after,
  .uikit.p84 .fill,
  .uikit.p85 .bar:after,
  .uikit.p85 .fill,
  .uikit.p86 .bar:after,
  .uikit.p86 .fill,
  .uikit.p87 .bar:after,
  .uikit.p87 .fill,
  .uikit.p88 .bar:after,
  .uikit.p88 .fill,
  .uikit.p89 .bar:after,
  .uikit.p89 .fill,
  .uikit.p90 .bar:after,
  .uikit.p90 .fill,
  .uikit.p91 .bar:after,
  .uikit.p91 .fill,
  .uikit.p92 .bar:after,
  .uikit.p92 .fill,
  .uikit.p93 .bar:after,
  .uikit.p93 .fill,
  .uikit.p94 .bar:after,
  .uikit.p94 .fill,
  .uikit.p95 .bar:after,
  .uikit.p95 .fill,
  .uikit.p96 .bar:after,
  .uikit.p96 .fill,
  .uikit.p97 .bar:after,
  .uikit.p97 .fill,
  .uikit.p98 .bar:after,
  .uikit.p98 .fill,
  .uikit.p99 .bar:after,
  .uikit.p99 .fill,
  .uikit.p100 .bar:after,
  .uikit.p100 .fill {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  .uikit {
    position: relative;
    font-size: 120px;
    width: 1em;
    height: 1em;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;
    float: left;
    margin: 0 0.1em 0.1em 0;
    background-color: #cccccc;
  }
  .uikit *,
  .uikit *:before,
  .uikit *:after {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }
  .uikit.center {
    float: none;
    margin: 0 auto;
  }
  .uikit.big {
    font-size: 240px;
  }
  .uikit.small {
    font-size: 80px;
  }
  .uikit > span {
    position: absolute;
    width: 100%;
    z-index: 1;
    left: 0;
    top: 0;
    width: 5em;
    line-height: 5em;
    font-size: 0.2em;
    color: #cccccc;
    display: block;
    text-align: center;
    white-space: nowrap;
    -webkit-transition-property: all;
    -moz-transition-property: all;
    -o-transition-property: all;
    transition-property: all;
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
    -webkit-transition-timing-function: ease-out;
    -moz-transition-timing-function: ease-out;
    -o-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
  }
  .uikit:after {
    position: absolute;
    top: 0.08em;
    left: 0.08em;
    display: block;
    content: ' ';
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;
    background-color: whitesmoke;
    width: 0.84em;
    height: 0.84em;
    -webkit-transition-property: all;
    -moz-transition-property: all;
    -o-transition-property: all;
    transition-property: all;
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
    -webkit-transition-timing-function: ease-in;
    -moz-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }
  .uikit .slice {
    position: absolute;
    width: 1em;
    height: 1em;
    clip: rect(0em, 1em, 1em, 0.5em);
  }
  .uikit.p1 .bar {
    -webkit-transform: rotate(3.6deg);
    -moz-transform: rotate(3.6deg);
    -ms-transform: rotate(3.6deg);
    -o-transform: rotate(3.6deg);
    transform: rotate(3.6deg);
  }
  .uikit.p2 .bar {
    -webkit-transform: rotate(7.2deg);
    -moz-transform: rotate(7.2deg);
    -ms-transform: rotate(7.2deg);
    -o-transform: rotate(7.2deg);
    transform: rotate(7.2deg);
  }
  .uikit.p3 .bar {
    -webkit-transform: rotate(10.8deg);
    -moz-transform: rotate(10.8deg);
    -ms-transform: rotate(10.8deg);
    -o-transform: rotate(10.8deg);
    transform: rotate(10.8deg);
  }
  .uikit.p4 .bar {
    -webkit-transform: rotate(14.4deg);
    -moz-transform: rotate(14.4deg);
    -ms-transform: rotate(14.4deg);
    -o-transform: rotate(14.4deg);
    transform: rotate(14.4deg);
  }
  .uikit.p5 .bar {
    -webkit-transform: rotate(18deg);
    -moz-transform: rotate(18deg);
    -ms-transform: rotate(18deg);
    -o-transform: rotate(18deg);
    transform: rotate(18deg);
  }
  .uikit.p6 .bar {
    -webkit-transform: rotate(21.6deg);
    -moz-transform: rotate(21.6deg);
    -ms-transform: rotate(21.6deg);
    -o-transform: rotate(21.6deg);
    transform: rotate(21.6deg);
  }
  .uikit.p7 .bar {
    -webkit-transform: rotate(25.2deg);
    -moz-transform: rotate(25.2deg);
    -ms-transform: rotate(25.2deg);
    -o-transform: rotate(25.2deg);
    transform: rotate(25.2deg);
  }
  .uikit.p8 .bar {
    -webkit-transform: rotate(28.8deg);
    -moz-transform: rotate(28.8deg);
    -ms-transform: rotate(28.8deg);
    -o-transform: rotate(28.8deg);
    transform: rotate(28.8deg);
  }
  .uikit.p9 .bar {
    -webkit-transform: rotate(32.4deg);
    -moz-transform: rotate(32.4deg);
    -ms-transform: rotate(32.4deg);
    -o-transform: rotate(32.4deg);
    transform: rotate(32.4deg);
  }
  .uikit.p10 .bar {
    -webkit-transform: rotate(36deg);
    -moz-transform: rotate(36deg);
    -ms-transform: rotate(36deg);
    -o-transform: rotate(36deg);
    transform: rotate(36deg);
  }
  .uikit.p11 .bar {
    -webkit-transform: rotate(39.6deg);
    -moz-transform: rotate(39.6deg);
    -ms-transform: rotate(39.6deg);
    -o-transform: rotate(39.6deg);
    transform: rotate(39.6deg);
  }
  .uikit.p12 .bar {
    -webkit-transform: rotate(43.2deg);
    -moz-transform: rotate(43.2deg);
    -ms-transform: rotate(43.2deg);
    -o-transform: rotate(43.2deg);
    transform: rotate(43.2deg);
  }
  .uikit.p13 .bar {
    -webkit-transform: rotate(46.8deg);
    -moz-transform: rotate(46.8deg);
    -ms-transform: rotate(46.8deg);
    -o-transform: rotate(46.8deg);
    transform: rotate(46.8deg);
  }
  .uikit.p14 .bar {
    -webkit-transform: rotate(50.4deg);
    -moz-transform: rotate(50.4deg);
    -ms-transform: rotate(50.4deg);
    -o-transform: rotate(50.4deg);
    transform: rotate(50.4deg);
  }
  .uikit.p15 .bar {
    -webkit-transform: rotate(54deg);
    -moz-transform: rotate(54deg);
    -ms-transform: rotate(54deg);
    -o-transform: rotate(54deg);
    transform: rotate(54deg);
  }
  .uikit.p16 .bar {
    -webkit-transform: rotate(57.6deg);
    -moz-transform: rotate(57.6deg);
    -ms-transform: rotate(57.6deg);
    -o-transform: rotate(57.6deg);
    transform: rotate(57.6deg);
  }
  .uikit.p17 .bar {
    -webkit-transform: rotate(61.2deg);
    -moz-transform: rotate(61.2deg);
    -ms-transform: rotate(61.2deg);
    -o-transform: rotate(61.2deg);
    transform: rotate(61.2deg);
  }
  .uikit.p18 .bar {
    -webkit-transform: rotate(64.8deg);
    -moz-transform: rotate(64.8deg);
    -ms-transform: rotate(64.8deg);
    -o-transform: rotate(64.8deg);
    transform: rotate(64.8deg);
  }
  .uikit.p19 .bar {
    -webkit-transform: rotate(68.4deg);
    -moz-transform: rotate(68.4deg);
    -ms-transform: rotate(68.4deg);
    -o-transform: rotate(68.4deg);
    transform: rotate(68.4deg);
  }
  .uikit.p20 .bar {
    -webkit-transform: rotate(72deg);
    -moz-transform: rotate(72deg);
    -ms-transform: rotate(72deg);
    -o-transform: rotate(72deg);
    transform: rotate(72deg);
  }
  .uikit.p21 .bar {
    -webkit-transform: rotate(75.6deg);
    -moz-transform: rotate(75.6deg);
    -ms-transform: rotate(75.6deg);
    -o-transform: rotate(75.6deg);
    transform: rotate(75.6deg);
  }
  .uikit.p22 .bar {
    -webkit-transform: rotate(79.2deg);
    -moz-transform: rotate(79.2deg);
    -ms-transform: rotate(79.2deg);
    -o-transform: rotate(79.2deg);
    transform: rotate(79.2deg);
  }
  .uikit.p23 .bar {
    -webkit-transform: rotate(82.8deg);
    -moz-transform: rotate(82.8deg);
    -ms-transform: rotate(82.8deg);
    -o-transform: rotate(82.8deg);
    transform: rotate(82.8deg);
  }
  .uikit.p24 .bar {
    -webkit-transform: rotate(86.4deg);
    -moz-transform: rotate(86.4deg);
    -ms-transform: rotate(86.4deg);
    -o-transform: rotate(86.4deg);
    transform: rotate(86.4deg);
  }
  .uikit.p25 .bar {
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  .uikit.p26 .bar {
    -webkit-transform: rotate(93.6deg);
    -moz-transform: rotate(93.6deg);
    -ms-transform: rotate(93.6deg);
    -o-transform: rotate(93.6deg);
    transform: rotate(93.6deg);
  }
  .uikit.p27 .bar {
    -webkit-transform: rotate(97.2deg);
    -moz-transform: rotate(97.2deg);
    -ms-transform: rotate(97.2deg);
    -o-transform: rotate(97.2deg);
    transform: rotate(97.2deg);
  }
  .uikit.p28 .bar {
    -webkit-transform: rotate(100.8deg);
    -moz-transform: rotate(100.8deg);
    -ms-transform: rotate(100.8deg);
    -o-transform: rotate(100.8deg);
    transform: rotate(100.8deg);
  }
  .uikit.p29 .bar {
    -webkit-transform: rotate(104.4deg);
    -moz-transform: rotate(104.4deg);
    -ms-transform: rotate(104.4deg);
    -o-transform: rotate(104.4deg);
    transform: rotate(104.4deg);
  }
  .uikit.p30 .bar {
    -webkit-transform: rotate(108deg);
    -moz-transform: rotate(108deg);
    -ms-transform: rotate(108deg);
    -o-transform: rotate(108deg);
    transform: rotate(108deg);
  }
  .uikit.p31 .bar {
    -webkit-transform: rotate(111.6deg);
    -moz-transform: rotate(111.6deg);
    -ms-transform: rotate(111.6deg);
    -o-transform: rotate(111.6deg);
    transform: rotate(111.6deg);
  }
  .uikit.p32 .bar {
    -webkit-transform: rotate(115.2deg);
    -moz-transform: rotate(115.2deg);
    -ms-transform: rotate(115.2deg);
    -o-transform: rotate(115.2deg);
    transform: rotate(115.2deg);
  }
  .uikit.p33 .bar {
    -webkit-transform: rotate(118.8deg);
    -moz-transform: rotate(118.8deg);
    -ms-transform: rotate(118.8deg);
    -o-transform: rotate(118.8deg);
    transform: rotate(118.8deg);
  }
  .uikit.p34 .bar {
    -webkit-transform: rotate(122.4deg);
    -moz-transform: rotate(122.4deg);
    -ms-transform: rotate(122.4deg);
    -o-transform: rotate(122.4deg);
    transform: rotate(122.4deg);
  }
  .uikit.p35 .bar {
    -webkit-transform: rotate(126deg);
    -moz-transform: rotate(126deg);
    -ms-transform: rotate(126deg);
    -o-transform: rotate(126deg);
    transform: rotate(126deg);
  }
  .uikit.p36 .bar {
    -webkit-transform: rotate(129.6deg);
    -moz-transform: rotate(129.6deg);
    -ms-transform: rotate(129.6deg);
    -o-transform: rotate(129.6deg);
    transform: rotate(129.6deg);
  }
  .uikit.p37 .bar {
    -webkit-transform: rotate(133.2deg);
    -moz-transform: rotate(133.2deg);
    -ms-transform: rotate(133.2deg);
    -o-transform: rotate(133.2deg);
    transform: rotate(133.2deg);
  }
  .uikit.p38 .bar {
    -webkit-transform: rotate(136.8deg);
    -moz-transform: rotate(136.8deg);
    -ms-transform: rotate(136.8deg);
    -o-transform: rotate(136.8deg);
    transform: rotate(136.8deg);
  }
  .uikit.p39 .bar {
    -webkit-transform: rotate(140.4deg);
    -moz-transform: rotate(140.4deg);
    -ms-transform: rotate(140.4deg);
    -o-transform: rotate(140.4deg);
    transform: rotate(140.4deg);
  }
  .uikit.p40 .bar {
    -webkit-transform: rotate(144deg);
    -moz-transform: rotate(144deg);
    -ms-transform: rotate(144deg);
    -o-transform: rotate(144deg);
    transform: rotate(144deg);
  }
  .uikit.p41 .bar {
    -webkit-transform: rotate(147.6deg);
    -moz-transform: rotate(147.6deg);
    -ms-transform: rotate(147.6deg);
    -o-transform: rotate(147.6deg);
    transform: rotate(147.6deg);
  }
  .uikit.p42 .bar {
    -webkit-transform: rotate(151.2deg);
    -moz-transform: rotate(151.2deg);
    -ms-transform: rotate(151.2deg);
    -o-transform: rotate(151.2deg);
    transform: rotate(151.2deg);
  }
  .uikit.p43 .bar {
    -webkit-transform: rotate(154.8deg);
    -moz-transform: rotate(154.8deg);
    -ms-transform: rotate(154.8deg);
    -o-transform: rotate(154.8deg);
    transform: rotate(154.8deg);
  }
  .uikit.p44 .bar {
    -webkit-transform: rotate(158.4deg);
    -moz-transform: rotate(158.4deg);
    -ms-transform: rotate(158.4deg);
    -o-transform: rotate(158.4deg);
    transform: rotate(158.4deg);
  }
  .uikit.p45 .bar {
    -webkit-transform: rotate(162deg);
    -moz-transform: rotate(162deg);
    -ms-transform: rotate(162deg);
    -o-transform: rotate(162deg);
    transform: rotate(162deg);
  }
  .uikit.p46 .bar {
    -webkit-transform: rotate(165.6deg);
    -moz-transform: rotate(165.6deg);
    -ms-transform: rotate(165.6deg);
    -o-transform: rotate(165.6deg);
    transform: rotate(165.6deg);
  }
  .uikit.p47 .bar {
    -webkit-transform: rotate(169.2deg);
    -moz-transform: rotate(169.2deg);
    -ms-transform: rotate(169.2deg);
    -o-transform: rotate(169.2deg);
    transform: rotate(169.2deg);
  }
  .uikit.p48 .bar {
    -webkit-transform: rotate(172.8deg);
    -moz-transform: rotate(172.8deg);
    -ms-transform: rotate(172.8deg);
    -o-transform: rotate(172.8deg);
    transform: rotate(172.8deg);
  }
  .uikit.p49 .bar {
    -webkit-transform: rotate(176.4deg);
    -moz-transform: rotate(176.4deg);
    -ms-transform: rotate(176.4deg);
    -o-transform: rotate(176.4deg);
    transform: rotate(176.4deg);
  }
  .uikit.p50 .bar {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  .uikit.p51 .bar {
    -webkit-transform: rotate(183.6deg);
    -moz-transform: rotate(183.6deg);
    -ms-transform: rotate(183.6deg);
    -o-transform: rotate(183.6deg);
    transform: rotate(183.6deg);
  }
  .uikit.p52 .bar {
    -webkit-transform: rotate(187.2deg);
    -moz-transform: rotate(187.2deg);
    -ms-transform: rotate(187.2deg);
    -o-transform: rotate(187.2deg);
    transform: rotate(187.2deg);
  }
  .uikit.p53 .bar {
    -webkit-transform: rotate(190.8deg);
    -moz-transform: rotate(190.8deg);
    -ms-transform: rotate(190.8deg);
    -o-transform: rotate(190.8deg);
    transform: rotate(190.8deg);
  }
  .uikit.p54 .bar {
    -webkit-transform: rotate(194.4deg);
    -moz-transform: rotate(194.4deg);
    -ms-transform: rotate(194.4deg);
    -o-transform: rotate(194.4deg);
    transform: rotate(194.4deg);
  }
  .uikit.p55 .bar {
    -webkit-transform: rotate(198deg);
    -moz-transform: rotate(198deg);
    -ms-transform: rotate(198deg);
    -o-transform: rotate(198deg);
    transform: rotate(198deg);
  }
  .uikit.p56 .bar {
    -webkit-transform: rotate(201.6deg);
    -moz-transform: rotate(201.6deg);
    -ms-transform: rotate(201.6deg);
    -o-transform: rotate(201.6deg);
    transform: rotate(201.6deg);
  }
  .uikit.p57 .bar {
    -webkit-transform: rotate(205.2deg);
    -moz-transform: rotate(205.2deg);
    -ms-transform: rotate(205.2deg);
    -o-transform: rotate(205.2deg);
    transform: rotate(205.2deg);
  }
  .uikit.p58 .bar {
    -webkit-transform: rotate(208.8deg);
    -moz-transform: rotate(208.8deg);
    -ms-transform: rotate(208.8deg);
    -o-transform: rotate(208.8deg);
    transform: rotate(208.8deg);
  }
  .uikit.p59 .bar {
    -webkit-transform: rotate(212.4deg);
    -moz-transform: rotate(212.4deg);
    -ms-transform: rotate(212.4deg);
    -o-transform: rotate(212.4deg);
    transform: rotate(212.4deg);
  }
  .uikit.p60 .bar {
    -webkit-transform: rotate(216deg);
    -moz-transform: rotate(216deg);
    -ms-transform: rotate(216deg);
    -o-transform: rotate(216deg);
    transform: rotate(216deg);
  }
  .uikit.p61 .bar {
    -webkit-transform: rotate(219.6deg);
    -moz-transform: rotate(219.6deg);
    -ms-transform: rotate(219.6deg);
    -o-transform: rotate(219.6deg);
    transform: rotate(219.6deg);
  }
  .uikit.p62 .bar {
    -webkit-transform: rotate(223.2deg);
    -moz-transform: rotate(223.2deg);
    -ms-transform: rotate(223.2deg);
    -o-transform: rotate(223.2deg);
    transform: rotate(223.2deg);
  }
  .uikit.p63 .bar {
    -webkit-transform: rotate(226.8deg);
    -moz-transform: rotate(226.8deg);
    -ms-transform: rotate(226.8deg);
    -o-transform: rotate(226.8deg);
    transform: rotate(226.8deg);
  }
  .uikit.p64 .bar {
    -webkit-transform: rotate(230.4deg);
    -moz-transform: rotate(230.4deg);
    -ms-transform: rotate(230.4deg);
    -o-transform: rotate(230.4deg);
    transform: rotate(230.4deg);
  }
  .uikit.p65 .bar {
    -webkit-transform: rotate(234deg);
    -moz-transform: rotate(234deg);
    -ms-transform: rotate(234deg);
    -o-transform: rotate(234deg);
    transform: rotate(234deg);
  }
  .uikit.p66 .bar {
    -webkit-transform: rotate(237.6deg);
    -moz-transform: rotate(237.6deg);
    -ms-transform: rotate(237.6deg);
    -o-transform: rotate(237.6deg);
    transform: rotate(237.6deg);
  }
  .uikit.p67 .bar {
    -webkit-transform: rotate(241.2deg);
    -moz-transform: rotate(241.2deg);
    -ms-transform: rotate(241.2deg);
    -o-transform: rotate(241.2deg);
    transform: rotate(241.2deg);
  }
  .uikit.p68 .bar {
    -webkit-transform: rotate(244.8deg);
    -moz-transform: rotate(244.8deg);
    -ms-transform: rotate(244.8deg);
    -o-transform: rotate(244.8deg);
    transform: rotate(244.8deg);
  }
  .uikit.p69 .bar {
    -webkit-transform: rotate(248.4deg);
    -moz-transform: rotate(248.4deg);
    -ms-transform: rotate(248.4deg);
    -o-transform: rotate(248.4deg);
    transform: rotate(248.4deg);
  }
  .uikit.p70 .bar {
    -webkit-transform: rotate(252deg);
    -moz-transform: rotate(252deg);
    -ms-transform: rotate(252deg);
    -o-transform: rotate(252deg);
    transform: rotate(252deg);
  }
  .uikit.p71 .bar {
    -webkit-transform: rotate(255.6deg);
    -moz-transform: rotate(255.6deg);
    -ms-transform: rotate(255.6deg);
    -o-transform: rotate(255.6deg);
    transform: rotate(255.6deg);
  }
  .uikit.p72 .bar {
    -webkit-transform: rotate(259.2deg);
    -moz-transform: rotate(259.2deg);
    -ms-transform: rotate(259.2deg);
    -o-transform: rotate(259.2deg);
    transform: rotate(259.2deg);
  }
  .uikit.p73 .bar {
    -webkit-transform: rotate(262.8deg);
    -moz-transform: rotate(262.8deg);
    -ms-transform: rotate(262.8deg);
    -o-transform: rotate(262.8deg);
    transform: rotate(262.8deg);
  }
  .uikit.p74 .bar {
    -webkit-transform: rotate(266.4deg);
    -moz-transform: rotate(266.4deg);
    -ms-transform: rotate(266.4deg);
    -o-transform: rotate(266.4deg);
    transform: rotate(266.4deg);
  }
  .uikit.p75 .bar {
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  .uikit.p76 .bar {
    -webkit-transform: rotate(273.6deg);
    -moz-transform: rotate(273.6deg);
    -ms-transform: rotate(273.6deg);
    -o-transform: rotate(273.6deg);
    transform: rotate(273.6deg);
  }
  .uikit.p77 .bar {
    -webkit-transform: rotate(277.2deg);
    -moz-transform: rotate(277.2deg);
    -ms-transform: rotate(277.2deg);
    -o-transform: rotate(277.2deg);
    transform: rotate(277.2deg);
  }
  .uikit.p78 .bar {
    -webkit-transform: rotate(280.8deg);
    -moz-transform: rotate(280.8deg);
    -ms-transform: rotate(280.8deg);
    -o-transform: rotate(280.8deg);
    transform: rotate(280.8deg);
  }
  .uikit.p79 .bar {
    -webkit-transform: rotate(284.4deg);
    -moz-transform: rotate(284.4deg);
    -ms-transform: rotate(284.4deg);
    -o-transform: rotate(284.4deg);
    transform: rotate(284.4deg);
  }
  .uikit.p80 .bar {
    -webkit-transform: rotate(288deg);
    -moz-transform: rotate(288deg);
    -ms-transform: rotate(288deg);
    -o-transform: rotate(288deg);
    transform: rotate(288deg);
  }
  .uikit.p81 .bar {
    -webkit-transform: rotate(291.6deg);
    -moz-transform: rotate(291.6deg);
    -ms-transform: rotate(291.6deg);
    -o-transform: rotate(291.6deg);
    transform: rotate(291.6deg);
  }
  .uikit.p82 .bar {
    -webkit-transform: rotate(295.2deg);
    -moz-transform: rotate(295.2deg);
    -ms-transform: rotate(295.2deg);
    -o-transform: rotate(295.2deg);
    transform: rotate(295.2deg);
  }
  .uikit.p83 .bar {
    -webkit-transform: rotate(298.8deg);
    -moz-transform: rotate(298.8deg);
    -ms-transform: rotate(298.8deg);
    -o-transform: rotate(298.8deg);
    transform: rotate(298.8deg);
  }
  .uikit.p84 .bar {
    -webkit-transform: rotate(302.4deg);
    -moz-transform: rotate(302.4deg);
    -ms-transform: rotate(302.4deg);
    -o-transform: rotate(302.4deg);
    transform: rotate(302.4deg);
  }
  .uikit.p85 .bar {
    -webkit-transform: rotate(306deg);
    -moz-transform: rotate(306deg);
    -ms-transform: rotate(306deg);
    -o-transform: rotate(306deg);
    transform: rotate(306deg);
  }
  .uikit.p86 .bar {
    -webkit-transform: rotate(309.6deg);
    -moz-transform: rotate(309.6deg);
    -ms-transform: rotate(309.6deg);
    -o-transform: rotate(309.6deg);
    transform: rotate(309.6deg);
  }
  .uikit.p87 .bar {
    -webkit-transform: rotate(313.2deg);
    -moz-transform: rotate(313.2deg);
    -ms-transform: rotate(313.2deg);
    -o-transform: rotate(313.2deg);
    transform: rotate(313.2deg);
  }
  .uikit.p88 .bar {
    -webkit-transform: rotate(316.8deg);
    -moz-transform: rotate(316.8deg);
    -ms-transform: rotate(316.8deg);
    -o-transform: rotate(316.8deg);
    transform: rotate(316.8deg);
  }
  .uikit.p89 .bar {
    -webkit-transform: rotate(320.4deg);
    -moz-transform: rotate(320.4deg);
    -ms-transform: rotate(320.4deg);
    -o-transform: rotate(320.4deg);
    transform: rotate(320.4deg);
  }
  .uikit.p90 .bar {
    -webkit-transform: rotate(324deg);
    -moz-transform: rotate(324deg);
    -ms-transform: rotate(324deg);
    -o-transform: rotate(324deg);
    transform: rotate(324deg);
  }
  .uikit.p91 .bar {
    -webkit-transform: rotate(327.6deg);
    -moz-transform: rotate(327.6deg);
    -ms-transform: rotate(327.6deg);
    -o-transform: rotate(327.6deg);
    transform: rotate(327.6deg);
  }
  .uikit.p92 .bar {
    -webkit-transform: rotate(331.2deg);
    -moz-transform: rotate(331.2deg);
    -ms-transform: rotate(331.2deg);
    -o-transform: rotate(331.2deg);
    transform: rotate(331.2deg);
  }
  .uikit.p93 .bar {
    -webkit-transform: rotate(334.8deg);
    -moz-transform: rotate(334.8deg);
    -ms-transform: rotate(334.8deg);
    -o-transform: rotate(334.8deg);
    transform: rotate(334.8deg);
  }
  .uikit.p94 .bar {
    -webkit-transform: rotate(338.4deg);
    -moz-transform: rotate(338.4deg);
    -ms-transform: rotate(338.4deg);
    -o-transform: rotate(338.4deg);
    transform: rotate(338.4deg);
  }
  .uikit.p95 .bar {
    -webkit-transform: rotate(342deg);
    -moz-transform: rotate(342deg);
    -ms-transform: rotate(342deg);
    -o-transform: rotate(342deg);
    transform: rotate(342deg);
  }
  .uikit.p96 .bar {
    -webkit-transform: rotate(345.6deg);
    -moz-transform: rotate(345.6deg);
    -ms-transform: rotate(345.6deg);
    -o-transform: rotate(345.6deg);
    transform: rotate(345.6deg);
  }
  .uikit.p97 .bar {
    -webkit-transform: rotate(349.2deg);
    -moz-transform: rotate(349.2deg);
    -ms-transform: rotate(349.2deg);
    -o-transform: rotate(349.2deg);
    transform: rotate(349.2deg);
  }
  .uikit.p98 .bar {
    -webkit-transform: rotate(352.8deg);
    -moz-transform: rotate(352.8deg);
    -ms-transform: rotate(352.8deg);
    -o-transform: rotate(352.8deg);
    transform: rotate(352.8deg);
  }
  .uikit.p99 .bar {
    -webkit-transform: rotate(356.4deg);
    -moz-transform: rotate(356.4deg);
    -ms-transform: rotate(356.4deg);
    -o-transform: rotate(356.4deg);
    transform: rotate(356.4deg);
  }
  .uikit.p100 .bar {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  .uikit:hover {
    cursor: default;
  }
  .uikit:hover > span {
    width: 3.33em;
    line-height: 3.33em;
    font-size: 0.3em;
    color: #307bbb;
  }
  .uikit:hover:after {
    top: 0.04em;
    left: 0.04em;
    width: 0.92em;
    height: 0.92em;
  }
`;

});



parcelRegister("2UPwk", function(module, exports) {
"use strict";
var $21f8c69c84c20ba0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21f8c69c84c20ba0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $21f8c69c84c20ba0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$21f8c69c84c20ba0$var$__exportStar((parcelRequire("5c2QN")), module.exports);

});
parcelRegister("5c2QN", function(module, exports) {
"use strict";
var $3c8048d2fc03497b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3c8048d2fc03497b$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TabsComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("9DBLY");
/**
 * @customElement rx-tabs
 */ let $3c8048d2fc03497b$var$TabsComponent = class TabsComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.palette = 'default';
        this.changeLocation = true;
        this.pages = [];
    }
};
$3c8048d2fc03497b$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $3c8048d2fc03497b$var$__metadata("design:type", String)
], $3c8048d2fc03497b$var$TabsComponent.prototype, "palette", void 0);
$3c8048d2fc03497b$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $3c8048d2fc03497b$var$__metadata("design:type", Object)
], $3c8048d2fc03497b$var$TabsComponent.prototype, "changeLocation", void 0);
$3c8048d2fc03497b$var$__decorate([
    (0, $4TeKW.property)({
        type: Array
    }),
    $3c8048d2fc03497b$var$__metadata("design:type", Array)
], $3c8048d2fc03497b$var$TabsComponent.prototype, "pages", void 0);
$3c8048d2fc03497b$var$TabsComponent = $3c8048d2fc03497b$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-tabs',
        style: (0, $4TeKW.css)`
    .tabs {
      display: flex;
      flex-wrap: wrap;
      /* margin-left: -20px; */
      margin-top: 0px;
      padding: 0;
      list-style: none;
      position: relative;
      user-select: none;
    }
    .switcher {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .tabs > * {
      flex: none;
      /* padding-left: 20px; */
      position: relative;
    }
    .tabs > .active > a {
      color: #222;
    }
    .tabs > * > a {
      display: block;
      text-align: center;
      padding: 9px 20px;
      color: #999;
      border-bottom: 2px solid transparent;
      font-size: 12px;
      text-transform: uppercase;
      transition: color 0.1s ease-in-out;
      line-height: 20px;
    }

    a {
      text-decoration: none;
      cursor: pointer;
    }
    .hover:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    li {
      color: #666;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <style>
        .tabs > .active > a {
          border-color: var(--${this.palette}-bg-color);
        }
      </style>
      <ul part="tabs" class="tabs">
        ${this.pages.map((tab, index)=>(0, $4TeKW.html)`
            ${tab.settingsElement ? (0, $4TeKW.html)`<span style="flex: 1 3 auto;"></span>` : (0, $4TeKW.html)``}
            <li part="li" class=${(0, $4TeKW.classMap)({
                    active: tab.active
                })}>
              <a
                part="a"
                class=${(0, $4TeKW.classMap)({
                    hover: tab.hoverable
                })}
                style=${(0, $4TeKW.styleMap)(tab.hoverable ? {
                    background: tab.active ? 'rgba(255, 255, 255, 0.1)' : ''
                } : {})}
                @click=${()=>{
                    if (!tab.disableOnChangeEvent) {
                        this.pages = this.pages.map((p)=>{
                            p.active = false;
                            return p;
                        });
                        tab.active = true;
                        this.pages = [
                            ...this.pages
                        ];
                        if (this.changeLocation) {
                            const newLocation = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/') + 1);
                            window.history.pushState({}, null, `${newLocation}${index}`);
                        }
                        this.dispatchEvent(new CustomEvent('change', {
                            detail: {
                                tab: tab,
                                index: index
                            }
                        }));
                    }
                }}
                >${tab.name}</a
              >
            </li>
          `)}
      </ul>

      <ul class="switcher">
        ${this.pages.filter((a)=>a.active).map((v)=>(0, $4TeKW.html)` <li>${v.view}</li> `)}
      </ul>
    `;
        }
    })
], $3c8048d2fc03497b$var$TabsComponent);
module.exports.TabsComponent = $3c8048d2fc03497b$var$TabsComponent;

});


parcelRegister("kSI5T", function(module, exports) {
$parcel$export(module.exports, "RadioGroup", () => (parcelRequire("1SiTW")).RadioGroup);
parcelRequire("e4JCV");
parcelRequire("1SiTW");

});
parcelRegister("e4JCV", function(module, exports) {
parcelRequire("kYWqb");
parcelRequire("c7Fn3");
parcelRequire("1SiTW");

});
parcelRegister("kYWqb", function(module, exports) {
parcelRequire("9eDdK");
parcelRequire("jfKYS");

});
parcelRegister("9eDdK", function(module, exports) {
parcelRequire("bpTdN");
parcelRequire("6Yt1B");
parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
(0, $2vXFS.registerStyles)('vaadin-radio-button', (0, $aOvNQ.css)`
    :host {
      color: var(--lumo-body-text-color);
      font-size: var(--lumo-font-size-m);
      font-family: var(--lumo-font-family);
      line-height: var(--lumo-line-height-s);
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-tap-highlight-color: transparent;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
      cursor: default;
      outline: none;
      --_radio-button-size: var(--vaadin-radio-button-size, calc(var(--lumo-size-m) / 2));
    }

    :host([has-label]) ::slotted(label) {
      padding-block: var(--lumo-space-xs);
      padding-inline: var(--lumo-space-xs) var(--lumo-space-s);
    }

    [part='radio'] {
      width: var(--_radio-button-size);
      height: var(--_radio-button-size);
      margin: var(--lumo-space-xs);
      position: relative;
      border-radius: 50%;
      background-color: var(--lumo-contrast-20pct);
      transition: transform 0.2s cubic-bezier(0.12, 0.32, 0.54, 2), background-color 0.15s;
      will-change: transform;
      cursor: var(--lumo-clickable-cursor);
    }

    /* Used for activation "halo" */
    [part='radio']::before {
      pointer-events: none;
      color: transparent;
      width: 100%;
      height: 100%;
      line-height: var(--_radio-button-size);
      border-radius: inherit;
      background-color: inherit;
      transform: scale(1.4);
      opacity: 0;
      transition: transform 0.1s, opacity 0.8s;
      will-change: transform, opacity;
    }

    /* Used for the dot */
    [part='radio']::after {
      content: '';
      pointer-events: none;
      width: 0;
      height: 0;
      border: 3px solid var(--lumo-primary-contrast-color);
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);
      transition: 0.25s transform;
      will-change: transform;
      background-clip: content-box;
    }

    :host([checked]) [part='radio'] {
      background-color: var(--lumo-primary-color);
    }

    :host([checked]) [part='radio']::after {
      transform: translate(-50%, -50%) scale(1);
    }

    :host(:not([checked]):not([disabled]):hover) [part='radio'] {
      background-color: var(--lumo-contrast-30pct);
    }

    :host([active]) [part='radio'] {
      transform: scale(0.9);
      transition-duration: 0.05s;
    }

    :host([active][checked]) [part='radio'] {
      transform: scale(1.1);
    }

    :host([active]:not([checked])) [part='radio']::before {
      transition-duration: 0.01s, 0.01s;
      transform: scale(0);
      opacity: 0.4;
    }

    :host([focus-ring]) [part='radio'] {
      box-shadow: 0 0 0 1px var(--lumo-base-color), 0 0 0 3px var(--lumo-primary-color-50pct);
    }

    :host([disabled]) {
      pointer-events: none;
      color: var(--lumo-disabled-text-color);
    }

    :host([disabled]) ::slotted(label) {
      color: inherit;
    }

    :host([disabled]) [part='radio'] {
      background-color: var(--lumo-contrast-10pct);
    }

    :host([disabled]) [part='radio']::after {
      border-color: var(--lumo-contrast-30pct);
    }

    /* RTL specific styles */
    :host([dir='rtl'][has-label]) ::slotted(label) {
      padding: var(--lumo-space-xs) var(--lumo-space-xs) var(--lumo-space-xs) var(--lumo-space-s);
    }
  `, {
    moduleId: 'lumo-radio-button'
});

});
parcelRegister("bpTdN", function(module, exports) {
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("pFadI");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $84fcdd54eec42467$export$1776f2a5a00ce750 = (0, $aOvNQ.css)`
  :host {
    /* Base (background) */
    --lumo-base-color: #fff;

    /* Tint */
    --lumo-tint-5pct: hsla(0, 0%, 100%, 0.3);
    --lumo-tint-10pct: hsla(0, 0%, 100%, 0.37);
    --lumo-tint-20pct: hsla(0, 0%, 100%, 0.44);
    --lumo-tint-30pct: hsla(0, 0%, 100%, 0.5);
    --lumo-tint-40pct: hsla(0, 0%, 100%, 0.57);
    --lumo-tint-50pct: hsla(0, 0%, 100%, 0.64);
    --lumo-tint-60pct: hsla(0, 0%, 100%, 0.7);
    --lumo-tint-70pct: hsla(0, 0%, 100%, 0.77);
    --lumo-tint-80pct: hsla(0, 0%, 100%, 0.84);
    --lumo-tint-90pct: hsla(0, 0%, 100%, 0.9);
    --lumo-tint: #fff;

    /* Shade */
    --lumo-shade-5pct: hsla(214, 61%, 25%, 0.05);
    --lumo-shade-10pct: hsla(214, 57%, 24%, 0.1);
    --lumo-shade-20pct: hsla(214, 53%, 23%, 0.16);
    --lumo-shade-30pct: hsla(214, 50%, 22%, 0.26);
    --lumo-shade-40pct: hsla(214, 47%, 21%, 0.38);
    --lumo-shade-50pct: hsla(214, 45%, 20%, 0.52);
    --lumo-shade-60pct: hsla(214, 43%, 19%, 0.6);
    --lumo-shade-70pct: hsla(214, 42%, 18%, 0.69);
    --lumo-shade-80pct: hsla(214, 41%, 17%, 0.83);
    --lumo-shade-90pct: hsla(214, 40%, 16%, 0.94);
    --lumo-shade: hsl(214, 35%, 15%);

    /* Contrast */
    --lumo-contrast-5pct: var(--lumo-shade-5pct);
    --lumo-contrast-10pct: var(--lumo-shade-10pct);
    --lumo-contrast-20pct: var(--lumo-shade-20pct);
    --lumo-contrast-30pct: var(--lumo-shade-30pct);
    --lumo-contrast-40pct: var(--lumo-shade-40pct);
    --lumo-contrast-50pct: var(--lumo-shade-50pct);
    --lumo-contrast-60pct: var(--lumo-shade-60pct);
    --lumo-contrast-70pct: var(--lumo-shade-70pct);
    --lumo-contrast-80pct: var(--lumo-shade-80pct);
    --lumo-contrast-90pct: var(--lumo-shade-90pct);
    --lumo-contrast: var(--lumo-shade);

    /* Text */
    --lumo-header-text-color: var(--lumo-contrast);
    --lumo-body-text-color: var(--lumo-contrast-90pct);
    --lumo-secondary-text-color: var(--lumo-contrast-70pct);
    --lumo-tertiary-text-color: var(--lumo-contrast-50pct);
    --lumo-disabled-text-color: var(--lumo-contrast-30pct);

    /* Primary */
    --lumo-primary-color: hsl(214, 100%, 48%);
    --lumo-primary-color-50pct: hsla(214, 100%, 49%, 0.76);
    --lumo-primary-color-10pct: hsla(214, 100%, 60%, 0.13);
    --lumo-primary-text-color: hsl(214, 100%, 43%);
    --lumo-primary-contrast-color: #fff;

    /* Error */
    --lumo-error-color: hsl(3, 85%, 48%);
    --lumo-error-color-50pct: hsla(3, 85%, 49%, 0.5);
    --lumo-error-color-10pct: hsla(3, 85%, 49%, 0.1);
    --lumo-error-text-color: hsl(3, 89%, 42%);
    --lumo-error-contrast-color: #fff;

    /* Success */
    --lumo-success-color: hsl(145, 72%, 30%);
    --lumo-success-color-50pct: hsla(145, 72%, 31%, 0.5);
    --lumo-success-color-10pct: hsla(145, 72%, 31%, 0.1);
    --lumo-success-text-color: hsl(145, 85%, 25%);
    --lumo-success-contrast-color: #fff;
  }
`;
const $84fcdd54eec42467$var$$tpl = document.createElement('template');
$84fcdd54eec42467$var$$tpl.innerHTML = `<style>${$84fcdd54eec42467$export$1776f2a5a00ce750.toString().replace(':host', 'html')}</style>`;
document.head.appendChild($84fcdd54eec42467$var$$tpl.content);
const $84fcdd54eec42467$export$35e9368ef982300f = (0, $aOvNQ.css)`
  [theme~='dark'] {
    /* Base (background) */
    --lumo-base-color: hsl(214, 35%, 21%);

    /* Tint */
    --lumo-tint-5pct: hsla(214, 65%, 85%, 0.06);
    --lumo-tint-10pct: hsla(214, 60%, 80%, 0.14);
    --lumo-tint-20pct: hsla(214, 64%, 82%, 0.23);
    --lumo-tint-30pct: hsla(214, 69%, 84%, 0.32);
    --lumo-tint-40pct: hsla(214, 73%, 86%, 0.41);
    --lumo-tint-50pct: hsla(214, 78%, 88%, 0.5);
    --lumo-tint-60pct: hsla(214, 82%, 90%, 0.58);
    --lumo-tint-70pct: hsla(214, 87%, 92%, 0.69);
    --lumo-tint-80pct: hsla(214, 91%, 94%, 0.8);
    --lumo-tint-90pct: hsla(214, 96%, 96%, 0.9);
    --lumo-tint: hsl(214, 100%, 98%);

    /* Shade */
    --lumo-shade-5pct: hsla(214, 0%, 0%, 0.07);
    --lumo-shade-10pct: hsla(214, 4%, 2%, 0.15);
    --lumo-shade-20pct: hsla(214, 8%, 4%, 0.23);
    --lumo-shade-30pct: hsla(214, 12%, 6%, 0.32);
    --lumo-shade-40pct: hsla(214, 16%, 8%, 0.41);
    --lumo-shade-50pct: hsla(214, 20%, 10%, 0.5);
    --lumo-shade-60pct: hsla(214, 24%, 12%, 0.6);
    --lumo-shade-70pct: hsla(214, 28%, 13%, 0.7);
    --lumo-shade-80pct: hsla(214, 32%, 13%, 0.8);
    --lumo-shade-90pct: hsla(214, 33%, 13%, 0.9);
    --lumo-shade: hsl(214, 33%, 13%);

    /* Contrast */
    --lumo-contrast-5pct: var(--lumo-tint-5pct);
    --lumo-contrast-10pct: var(--lumo-tint-10pct);
    --lumo-contrast-20pct: var(--lumo-tint-20pct);
    --lumo-contrast-30pct: var(--lumo-tint-30pct);
    --lumo-contrast-40pct: var(--lumo-tint-40pct);
    --lumo-contrast-50pct: var(--lumo-tint-50pct);
    --lumo-contrast-60pct: var(--lumo-tint-60pct);
    --lumo-contrast-70pct: var(--lumo-tint-70pct);
    --lumo-contrast-80pct: var(--lumo-tint-80pct);
    --lumo-contrast-90pct: var(--lumo-tint-90pct);
    --lumo-contrast: var(--lumo-tint);

    /* Text */
    --lumo-header-text-color: var(--lumo-contrast);
    --lumo-body-text-color: var(--lumo-contrast-90pct);
    --lumo-secondary-text-color: var(--lumo-contrast-70pct);
    --lumo-tertiary-text-color: var(--lumo-contrast-50pct);
    --lumo-disabled-text-color: var(--lumo-contrast-30pct);

    /* Primary */
    --lumo-primary-color: hsl(214, 90%, 48%);
    --lumo-primary-color-50pct: hsla(214, 90%, 70%, 0.69);
    --lumo-primary-color-10pct: hsla(214, 90%, 55%, 0.13);
    --lumo-primary-text-color: hsl(214, 90%, 77%);
    --lumo-primary-contrast-color: #fff;

    /* Error */
    --lumo-error-color: hsl(3, 79%, 49%);
    --lumo-error-color-50pct: hsla(3, 75%, 62%, 0.5);
    --lumo-error-color-10pct: hsla(3, 75%, 62%, 0.14);
    --lumo-error-text-color: hsl(3, 100%, 80%);

    /* Success */
    --lumo-success-color: hsl(145, 72%, 30%);
    --lumo-success-color-50pct: hsla(145, 92%, 51%, 0.5);
    --lumo-success-color-10pct: hsla(145, 92%, 51%, 0.1);
    --lumo-success-text-color: hsl(145, 85%, 46%);
  }

  html {
    color: var(--lumo-body-text-color);
    background-color: var(--lumo-base-color);
    color-scheme: light;
  }

  [theme~='dark'] {
    color: var(--lumo-body-text-color);
    background-color: var(--lumo-base-color);
    color-scheme: dark;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--lumo-header-text-color);
  }

  a:where(:any-link) {
    color: var(--lumo-primary-text-color);
  }

  a:not(:any-link) {
    color: var(--lumo-disabled-text-color);
  }

  blockquote {
    color: var(--lumo-secondary-text-color);
  }

  code,
  pre {
    background-color: var(--lumo-contrast-10pct);
    border-radius: var(--lumo-border-radius-m);
  }
`;
(0, $2vXFS.registerStyles)('', $84fcdd54eec42467$export$35e9368ef982300f, {
    moduleId: 'lumo-color'
});
const $84fcdd54eec42467$export$22acdedd90195cef = (0, $aOvNQ.css)`
  :host {
    color: var(--lumo-body-text-color) !important;
    background-color: var(--lumo-base-color) !important;
  }
`;
(0, $2vXFS.registerStyles)('', [
    $84fcdd54eec42467$export$35e9368ef982300f,
    $84fcdd54eec42467$export$22acdedd90195cef
], {
    moduleId: 'lumo-color-legacy'
});

});
parcelRegister("pFadI", function(module, exports) {
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /**
 * Dummy custom element used for collecting
 * development time usage statistics.
 *
 * @private
 */ class $04d244321210710b$export$1d6f124376bbe71c extends HTMLElement {
    static get version() {
        return '23.3.8';
    }
}
customElements.define('vaadin-lumo-styles', $04d244321210710b$export$1d6f124376bbe71c);

});

parcelRegister("2vXFS", function(module, exports) {

$parcel$export(module.exports, "registerStyles", () => $1d4cc424a0d0c4e2$export$580009a5da2a8b4b);
$parcel$export(module.exports, "ThemableMixin", () => $1d4cc424a0d0c4e2$export$f9c8d21ce997ce61);
$parcel$export(module.exports, "css", () => (parcelRequire("aOvNQ")).css);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("eQwuB");
var $aOvNQ = parcelRequire("aOvNQ");

var $aOuNF = parcelRequire("aOuNF");
/**
 * @typedef {Object} Theme
 * @property {string} themeFor
 * @property {CSSResult[]} styles
 * @property {string | string[]} [include]
 * @property {string} [moduleId]
 *
 * @typedef {CSSResult[] | CSSResult} CSSResultGroup
 */ /**
 * @type {Theme[]}
 */ const $1d4cc424a0d0c4e2$export$a5046162de2df159 = [];
function $1d4cc424a0d0c4e2$export$580009a5da2a8b4b(themeFor, styles, options = {}) {
    if (themeFor) {
        if ($1d4cc424a0d0c4e2$var$hasThemes(themeFor)) console.warn(`The custom element definition for "${themeFor}"
      was finalized before a style module was registered.
      Make sure to add component specific style modules before
      importing the corresponding custom element.`);
    }
    styles = $1d4cc424a0d0c4e2$var$flattenStyles(styles);
    if (window.Vaadin && window.Vaadin.styleModules) window.Vaadin.styleModules.registerStyles(themeFor, styles, options);
    else $1d4cc424a0d0c4e2$export$a5046162de2df159.push({
        themeFor: themeFor,
        styles: styles,
        include: options.include,
        moduleId: options.moduleId
    });
}
/**
 * Returns all registered themes. By default the themeRegistry is returned as is.
 * In case the style-modules adapter is imported, the themes are obtained from there instead
 * @returns {Theme[]}
 */ function $1d4cc424a0d0c4e2$var$getAllThemes() {
    if (window.Vaadin && window.Vaadin.styleModules) return window.Vaadin.styleModules.getAllThemes();
    return $1d4cc424a0d0c4e2$export$a5046162de2df159;
}
/**
 * Returns true if the themeFor string matches the tag name
 * @param {string} themeFor
 * @param {string} tagName
 * @returns {boolean}
 */ function $1d4cc424a0d0c4e2$var$matchesThemeFor(themeFor, tagName) {
    return (themeFor || '').split(' ').some((themeForToken)=>{
        return new RegExp(`^${themeForToken.split('*').join('.*')}$`).test(tagName);
    });
}
/**
 * Maps the moduleName to an include priority number which is used for
 * determining the order in which styles are applied.
 * @param {string} moduleName
 * @returns {number}
 */ function $1d4cc424a0d0c4e2$var$getIncludePriority(moduleName = '') {
    let includePriority = 0;
    if (moduleName.startsWith('lumo-') || moduleName.startsWith('material-')) includePriority = 1;
    else if (moduleName.startsWith('vaadin-')) includePriority = 2;
    return includePriority;
}
/**
 * Flattens the styles into a single array of styles.
 * @param {CSSResultGroup} styles
 * @param {CSSResult[]} result
 * @returns {CSSResult[]}
 */ function $1d4cc424a0d0c4e2$var$flattenStyles(styles = []) {
    return [
        styles
    ].flat(Infinity).filter((style)=>{
        if (style instanceof (0, $aOvNQ.CSSResult)) return true;
        console.warn('An item in styles is not of type CSSResult. Use `unsafeCSS` or `css`.');
        return false;
    });
}
/**
 * Gets an array of CSSResults matching the include property of the theme.
 * @param {Theme} theme
 * @returns {CSSResult[]}
 */ function $1d4cc424a0d0c4e2$var$getIncludedStyles(theme) {
    const includedStyles = [];
    if (theme.include) [].concat(theme.include).forEach((includeModuleId)=>{
        const includedTheme = $1d4cc424a0d0c4e2$var$getAllThemes().find((s)=>s.moduleId === includeModuleId);
        if (includedTheme) includedStyles.push(...$1d4cc424a0d0c4e2$var$getIncludedStyles(includedTheme), ...includedTheme.styles);
        else console.warn(`Included moduleId ${includeModuleId} not found in style registry`);
    }, theme.styles);
    return includedStyles;
}
/**
 * Includes the styles to the template.
 * @param {CSSResult[]} styles
 * @param {HTMLTemplateElement} template
 */ function $1d4cc424a0d0c4e2$var$addStylesToTemplate(styles, template) {
    const styleEl = document.createElement('style');
    styleEl.innerHTML = styles.map((style)=>style.cssText).join('\n');
    template.content.appendChild(styleEl);
}
/**
 * Returns an array of themes that should be used for styling a component matching
 * the tag name. The array is sorted by the include order.
 * @param {string} tagName
 * @returns {Theme[]}
 */ function $1d4cc424a0d0c4e2$var$getThemes(tagName) {
    const defaultModuleName = `${tagName}-default-theme`;
    const themes = $1d4cc424a0d0c4e2$var$getAllThemes()// Filter by matching themeFor properties
    .filter((theme)=>theme.moduleId !== defaultModuleName && $1d4cc424a0d0c4e2$var$matchesThemeFor(theme.themeFor, tagName)).map((theme)=>({
            ...theme,
            // Prepend styles from included themes
            styles: [
                ...$1d4cc424a0d0c4e2$var$getIncludedStyles(theme),
                ...theme.styles
            ],
            // Map moduleId to includePriority
            includePriority: $1d4cc424a0d0c4e2$var$getIncludePriority(theme.moduleId)
        }))// Sort by includePriority
    .sort((themeA, themeB)=>themeB.includePriority - themeA.includePriority);
    if (themes.length > 0) return themes;
    // No theme modules found, return the default module if it exists
    return $1d4cc424a0d0c4e2$var$getAllThemes().filter((theme)=>theme.moduleId === defaultModuleName);
}
/**
 * Check if the custom element type has themes applied.
 * @param {string} tagName
 * @returns {boolean}
 */ function $1d4cc424a0d0c4e2$var$hasThemes(tagName) {
    return $1d4cc424a0d0c4e2$var$classHasThemes(customElements.get(tagName));
}
/**
 * Check if the custom element type has themes applied.
 * @param {Function} elementClass
 * @returns {boolean}
 */ function $1d4cc424a0d0c4e2$var$classHasThemes(elementClass) {
    return elementClass && Object.prototype.hasOwnProperty.call(elementClass, '__themes');
}
const $1d4cc424a0d0c4e2$export$f9c8d21ce997ce61 = (superClass)=>class VaadinThemableMixin extends (0, $aOuNF.ThemePropertyMixin)(superClass) {
        /**
     * Covers PolymerElement based component styling
     * @protected
     */ static finalize() {
            super.finalize();
            // Make sure not to run the logic intended for PolymerElement when LitElement is used.
            if (this.elementStyles) return;
            const template = this.prototype._template;
            if (!template || $1d4cc424a0d0c4e2$var$classHasThemes(this)) return;
            $1d4cc424a0d0c4e2$var$addStylesToTemplate(this.getStylesForThis(), template);
        }
        /**
     * Covers LitElement based component styling
     *
     * @protected
     */ static finalizeStyles(styles) {
            // The "styles" object originates from the "static get styles()" function of
            // a LitElement based component. The theme styles are added after it
            // so that they can override the component styles.
            const themeStyles = this.getStylesForThis();
            return styles ? [
                ...super.finalizeStyles(styles),
                ...themeStyles
            ] : themeStyles;
        }
        /**
     * Get styles for the component type
     *
     * @private
     */ static getStylesForThis() {
            const parent = Object.getPrototypeOf(this.prototype);
            const inheritedThemes = (parent ? parent.constructor.__themes : []) || [];
            this.__themes = [
                ...inheritedThemes,
                ...$1d4cc424a0d0c4e2$var$getThemes(this.is)
            ];
            const themeStyles = this.__themes.flatMap((theme)=>theme.styles);
            // Remove duplicates
            return themeStyles.filter((style, index)=>index === themeStyles.lastIndexOf(style));
        }
    };

});
parcelRegister("eQwuB", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("aOvNQ")).css);
$parcel$export(module.exports, "CSSResult", () => (parcelRequire("aOvNQ")).CSSResult);
$parcel$export(module.exports, "nothing", () => (parcelRequire("625KE")).nothing);
$parcel$export(module.exports, "render", () => (parcelRequire("625KE")).render);
$parcel$export(module.exports, "svg", () => (parcelRequire("625KE")).svg);
parcelRequire("4oh2w");
parcelRequire("625KE");
parcelRequire("4NwK8");
parcelRequire("4TvFe");

});
parcelRegister("4oh2w", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $33269f0d54cf9917$export$c7c07a37856565d);
$parcel$export(module.exports, "CSSResult", () => (parcelRequire("aOvNQ")).CSSResult);
$parcel$export(module.exports, "css", () => (parcelRequire("aOvNQ")).css);

var $aOvNQ = parcelRequire("aOvNQ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $33269f0d54cf9917$var$s;
const $33269f0d54cf9917$var$e = window, $33269f0d54cf9917$var$r = $33269f0d54cf9917$var$e.trustedTypes, $33269f0d54cf9917$var$h = $33269f0d54cf9917$var$r ? $33269f0d54cf9917$var$r.emptyScript : "", $33269f0d54cf9917$var$o = $33269f0d54cf9917$var$e.reactiveElementPolyfillSupport, $33269f0d54cf9917$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $33269f0d54cf9917$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $33269f0d54cf9917$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $33269f0d54cf9917$var$l = {
    attribute: !0,
    type: String,
    converter: $33269f0d54cf9917$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $33269f0d54cf9917$export$53a6892c50694894
};
class $33269f0d54cf9917$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $33269f0d54cf9917$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $33269f0d54cf9917$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return !1;
        this.finalized = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $aOvNQ.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $aOvNQ.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    u() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $aOvNQ.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $33269f0d54cf9917$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $33269f0d54cf9917$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $33269f0d54cf9917$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $33269f0d54cf9917$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$33269f0d54cf9917$export$c7c07a37856565d.finalized = !0, $33269f0d54cf9917$export$c7c07a37856565d.elementProperties = new Map, $33269f0d54cf9917$export$c7c07a37856565d.elementStyles = [], $33269f0d54cf9917$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $33269f0d54cf9917$var$o || $33269f0d54cf9917$var$o({
    ReactiveElement: $33269f0d54cf9917$export$c7c07a37856565d
}), (null !== ($33269f0d54cf9917$var$s = $33269f0d54cf9917$var$e.reactiveElementVersions) && void 0 !== $33269f0d54cf9917$var$s ? $33269f0d54cf9917$var$s : $33269f0d54cf9917$var$e.reactiveElementVersions = []).push("1.6.1");

});
parcelRegister("aOvNQ", function(module, exports) {

$parcel$export(module.exports, "CSSResult", () => $7df73e4c1a79e8a5$export$505d1e8739bad805);
$parcel$export(module.exports, "css", () => $7df73e4c1a79e8a5$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $7df73e4c1a79e8a5$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $7df73e4c1a79e8a5$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7df73e4c1a79e8a5$var$t = window, $7df73e4c1a79e8a5$export$b4d10f6001c083c2 = $7df73e4c1a79e8a5$var$t.ShadowRoot && (void 0 === $7df73e4c1a79e8a5$var$t.ShadyCSS || $7df73e4c1a79e8a5$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $7df73e4c1a79e8a5$var$s = Symbol(), $7df73e4c1a79e8a5$var$n = new WeakMap;
class $7df73e4c1a79e8a5$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $7df73e4c1a79e8a5$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($7df73e4c1a79e8a5$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $7df73e4c1a79e8a5$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $7df73e4c1a79e8a5$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $7df73e4c1a79e8a5$export$8d80f9cac07cdb3 = (t)=>new $7df73e4c1a79e8a5$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $7df73e4c1a79e8a5$var$s), $7df73e4c1a79e8a5$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $7df73e4c1a79e8a5$export$505d1e8739bad805(n, t, $7df73e4c1a79e8a5$var$s);
}, $7df73e4c1a79e8a5$export$2ca4a66ec4cecb90 = (s, n)=>{
    $7df73e4c1a79e8a5$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $7df73e4c1a79e8a5$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $7df73e4c1a79e8a5$export$ee69dfd951e24778 = $7df73e4c1a79e8a5$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $7df73e4c1a79e8a5$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("625KE", function(module, exports) {

$parcel$export(module.exports, "svg", () => $4647641830de15a1$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "noChange", () => $4647641830de15a1$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $4647641830de15a1$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $4647641830de15a1$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $4647641830de15a1$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $4647641830de15a1$var$t;
const $4647641830de15a1$var$i = window, $4647641830de15a1$var$s = $4647641830de15a1$var$i.trustedTypes, $4647641830de15a1$var$e = $4647641830de15a1$var$s ? $4647641830de15a1$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $4647641830de15a1$var$o = `lit$${(Math.random() + "").slice(9)}$`, $4647641830de15a1$var$n = "?" + $4647641830de15a1$var$o, $4647641830de15a1$var$l = `<${$4647641830de15a1$var$n}>`, $4647641830de15a1$var$h = document, $4647641830de15a1$var$r = (t = "")=>$4647641830de15a1$var$h.createComment(t), $4647641830de15a1$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $4647641830de15a1$var$u = Array.isArray, $4647641830de15a1$var$c = (t)=>$4647641830de15a1$var$u(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $4647641830de15a1$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $4647641830de15a1$var$a = /-->/g, $4647641830de15a1$var$f = />/g, $4647641830de15a1$var$_ = RegExp(">|[ \t\n\f\r](?:([^\\s\"'>=/]+)([ \t\n\f\r]*=[ \t\n\f\r]*(?:[^ \t\n\f\r\"'`<>=]|(\"|')|))|$)", "g"), $4647641830de15a1$var$m = /'/g, $4647641830de15a1$var$p = /"/g, $4647641830de15a1$var$$ = /^(?:script|style|textarea|title)$/i, $4647641830de15a1$var$g = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $4647641830de15a1$export$c0bb0b647f701bb5 = $4647641830de15a1$var$g(1), $4647641830de15a1$export$7ed1367e7fa1ad68 = $4647641830de15a1$var$g(2), $4647641830de15a1$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $4647641830de15a1$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $4647641830de15a1$var$T = new WeakMap, $4647641830de15a1$var$A = $4647641830de15a1$var$h.createTreeWalker($4647641830de15a1$var$h, 129, null, !1), $4647641830de15a1$var$E = (t, i)=>{
    const s = t.length - 1, n = [];
    let h, r = 2 === i ? "<svg>" : "", d = $4647641830de15a1$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let e, u, c = -1, g = 0;
        for(; g < s.length && (d.lastIndex = g, u = d.exec(s), null !== u);)g = d.lastIndex, d === $4647641830de15a1$var$v ? "!--" === u[1] ? d = $4647641830de15a1$var$a : void 0 !== u[1] ? d = $4647641830de15a1$var$f : void 0 !== u[2] ? ($4647641830de15a1$var$$.test(u[2]) && (h = RegExp("</" + u[2], "g")), d = $4647641830de15a1$var$_) : void 0 !== u[3] && (d = $4647641830de15a1$var$_) : d === $4647641830de15a1$var$_ ? ">" === u[0] ? (d = null != h ? h : $4647641830de15a1$var$v, c = -1) : void 0 === u[1] ? c = -2 : (c = d.lastIndex - u[2].length, e = u[1], d = void 0 === u[3] ? $4647641830de15a1$var$_ : '"' === u[3] ? $4647641830de15a1$var$p : $4647641830de15a1$var$m) : d === $4647641830de15a1$var$p || d === $4647641830de15a1$var$m ? d = $4647641830de15a1$var$_ : d === $4647641830de15a1$var$a || d === $4647641830de15a1$var$f ? d = $4647641830de15a1$var$v : (d = $4647641830de15a1$var$_, h = void 0);
        const y = d === $4647641830de15a1$var$_ && t[i + 1].startsWith("/>") ? " " : "";
        r += d === $4647641830de15a1$var$v ? s + $4647641830de15a1$var$l : c >= 0 ? (n.push(e), s.slice(0, c) + "$lit$" + s.slice(c) + $4647641830de15a1$var$o + y) : s + $4647641830de15a1$var$o + (-2 === c ? (n.push(void 0), i) : y);
    }
    const u = r + (t[s] || "<?>") + (2 === i ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== $4647641830de15a1$var$e ? $4647641830de15a1$var$e.createHTML(u) : u,
        n
    ];
};
class $4647641830de15a1$var$C {
    constructor({ strings: t, _$litType$: i }, e){
        let l;
        this.parts = [];
        let h = 0, d = 0;
        const u = t.length - 1, c = this.parts, [v, a] = $4647641830de15a1$var$E(t, i);
        if (this.el = $4647641830de15a1$var$C.createElement(v, e), $4647641830de15a1$var$A.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (l = $4647641830de15a1$var$A.nextNode()) && c.length < u;){
            if (1 === l.nodeType) {
                if (l.hasAttributes()) {
                    const t = [];
                    for (const i of l.getAttributeNames())if (i.endsWith("$lit$") || i.startsWith($4647641830de15a1$var$o)) {
                        const s = a[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = l.getAttribute(s.toLowerCase() + "$lit$").split($4647641830de15a1$var$o), i = /([.?@])?(.*)/.exec(s);
                            c.push({
                                type: 1,
                                index: h,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $4647641830de15a1$var$M : "?" === i[1] ? $4647641830de15a1$var$k : "@" === i[1] ? $4647641830de15a1$var$H : $4647641830de15a1$var$S
                            });
                        } else c.push({
                            type: 6,
                            index: h
                        });
                    }
                    for (const i of t)l.removeAttribute(i);
                }
                if ($4647641830de15a1$var$$.test(l.tagName)) {
                    const t = l.textContent.split($4647641830de15a1$var$o), i = t.length - 1;
                    if (i > 0) {
                        l.textContent = $4647641830de15a1$var$s ? $4647641830de15a1$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)l.append(t[s], $4647641830de15a1$var$r()), $4647641830de15a1$var$A.nextNode(), c.push({
                            type: 2,
                            index: ++h
                        });
                        l.append(t[i], $4647641830de15a1$var$r());
                    }
                }
            } else if (8 === l.nodeType) {
                if (l.data === $4647641830de15a1$var$n) c.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = l.data.indexOf($4647641830de15a1$var$o, t + 1));)c.push({
                        type: 7,
                        index: h
                    }), t += $4647641830de15a1$var$o.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $4647641830de15a1$var$h.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $4647641830de15a1$var$P(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $4647641830de15a1$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $4647641830de15a1$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $4647641830de15a1$var$P(t, r._$AS(t, i.values), r, e)), i;
}
class $4647641830de15a1$var$V {
    constructor(t, i){
        this.u = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    v(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $4647641830de15a1$var$h).importNode(s, !0);
        $4647641830de15a1$var$A.currentNode = o;
        let n = $4647641830de15a1$var$A.nextNode(), l = 0, r = 0, d = e[0];
        for(; void 0 !== d;){
            if (l === d.index) {
                let i;
                2 === d.type ? i = new $4647641830de15a1$var$N(n, n.nextSibling, this, t) : 1 === d.type ? i = new d.ctor(n, d.name, d.strings, this, t) : 6 === d.type && (i = new $4647641830de15a1$var$I(n, this, t)), this.u.push(i), d = e[++r];
            }
            l !== (null == d ? void 0 : d.index) && (n = $4647641830de15a1$var$A.nextNode(), l++);
        }
        return o;
    }
    p(t) {
        let i = 0;
        for (const s of this.u)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $4647641830de15a1$var$N {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $4647641830de15a1$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cm = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cm;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $4647641830de15a1$var$P(this, t, i), $4647641830de15a1$var$d(t) ? t === $4647641830de15a1$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $4647641830de15a1$export$45b790e32b2810ee && this._$AR(), this._$AH = $4647641830de15a1$export$45b790e32b2810ee) : t !== this._$AH && t !== $4647641830de15a1$export$9c068ae9cc5db4e8 && this.g(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $4647641830de15a1$var$c(t) ? this.k(t) : this.g(t);
    }
    O(t, i = this._$AB) {
        return this._$AA.parentNode.insertBefore(t, i);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    g(t) {
        this._$AH !== $4647641830de15a1$export$45b790e32b2810ee && $4647641830de15a1$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.T($4647641830de15a1$var$h.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $4647641830de15a1$var$C.createElement(e.h, this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.p(s);
        else {
            const t = new $4647641830de15a1$var$V(o, this), i = t.v(this.options);
            t.p(s), this.T(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $4647641830de15a1$var$T.get(t.strings);
        return void 0 === i && $4647641830de15a1$var$T.set(t.strings, i = new $4647641830de15a1$var$C(t)), i;
    }
    k(t) {
        $4647641830de15a1$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $4647641830de15a1$var$N(this.O($4647641830de15a1$var$r()), this.O($4647641830de15a1$var$r()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cm = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $4647641830de15a1$var$S {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $4647641830de15a1$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $4647641830de15a1$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $4647641830de15a1$var$P(this, t, i, 0), n = !$4647641830de15a1$var$d(t) || t !== this._$AH && t !== $4647641830de15a1$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $4647641830de15a1$var$P(this, e[s + l], i, l), h === $4647641830de15a1$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$4647641830de15a1$var$d(h) || h !== this._$AH[l]), h === $4647641830de15a1$export$45b790e32b2810ee ? t = $4647641830de15a1$export$45b790e32b2810ee : t !== $4647641830de15a1$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $4647641830de15a1$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $4647641830de15a1$var$M extends $4647641830de15a1$var$S {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $4647641830de15a1$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $4647641830de15a1$var$R = $4647641830de15a1$var$s ? $4647641830de15a1$var$s.emptyScript : "";
class $4647641830de15a1$var$k extends $4647641830de15a1$var$S {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $4647641830de15a1$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $4647641830de15a1$var$R) : this.element.removeAttribute(this.name);
    }
}
class $4647641830de15a1$var$H extends $4647641830de15a1$var$S {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $4647641830de15a1$var$P(this, t, i, 0)) && void 0 !== s ? s : $4647641830de15a1$export$45b790e32b2810ee) === $4647641830de15a1$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $4647641830de15a1$export$45b790e32b2810ee && e !== $4647641830de15a1$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $4647641830de15a1$export$45b790e32b2810ee && (e === $4647641830de15a1$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $4647641830de15a1$var$I {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $4647641830de15a1$var$P(this, t);
    }
}
const $4647641830de15a1$export$8613d1ca9052b22e = {
    P: "$lit$",
    A: $4647641830de15a1$var$o,
    M: $4647641830de15a1$var$n,
    C: 1,
    L: $4647641830de15a1$var$E,
    R: $4647641830de15a1$var$V,
    D: $4647641830de15a1$var$c,
    V: $4647641830de15a1$var$P,
    I: $4647641830de15a1$var$N,
    H: $4647641830de15a1$var$S,
    N: $4647641830de15a1$var$k,
    U: $4647641830de15a1$var$H,
    B: $4647641830de15a1$var$M,
    F: $4647641830de15a1$var$I
}, $4647641830de15a1$var$z = $4647641830de15a1$var$i.litHtmlPolyfillSupport;
null == $4647641830de15a1$var$z || $4647641830de15a1$var$z($4647641830de15a1$var$C, $4647641830de15a1$var$N), (null !== ($4647641830de15a1$var$t = $4647641830de15a1$var$i.litHtmlVersions) && void 0 !== $4647641830de15a1$var$t ? $4647641830de15a1$var$t : $4647641830de15a1$var$i.litHtmlVersions = []).push("2.6.1");
const $4647641830de15a1$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $4647641830de15a1$var$N(i.insertBefore($4647641830de15a1$var$r(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("4NwK8", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("aOvNQ")).css);
$parcel$export(module.exports, "CSSResult", () => (parcelRequire("aOvNQ")).CSSResult);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("4oh2w")).ReactiveElement);
$parcel$export(module.exports, "noChange", () => (parcelRequire("625KE")).noChange);
$parcel$export(module.exports, "nothing", () => (parcelRequire("625KE")).nothing);
$parcel$export(module.exports, "render", () => (parcelRequire("625KE")).render);
$parcel$export(module.exports, "svg", () => (parcelRequire("625KE")).svg);

var $4oh2w = parcelRequire("4oh2w");

var $625KE = parcelRequire("625KE");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $37e523229708d8e1$var$l, $37e523229708d8e1$var$o;
const $37e523229708d8e1$export$8bf27daf9e8907c9 = (0, $4oh2w.ReactiveElement);
class $37e523229708d8e1$export$3f2f9f5909897157 extends (0, $4oh2w.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $625KE.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $625KE.noChange;
    }
}
$37e523229708d8e1$export$3f2f9f5909897157.finalized = !0, $37e523229708d8e1$export$3f2f9f5909897157._$litElement$ = !0, null === ($37e523229708d8e1$var$l = globalThis.litElementHydrateSupport) || void 0 === $37e523229708d8e1$var$l || $37e523229708d8e1$var$l.call(globalThis, {
    LitElement: $37e523229708d8e1$export$3f2f9f5909897157
});
const $37e523229708d8e1$var$n = globalThis.litElementPolyfillSupport;
null == $37e523229708d8e1$var$n || $37e523229708d8e1$var$n({
    LitElement: $37e523229708d8e1$export$3f2f9f5909897157
});
const $37e523229708d8e1$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($37e523229708d8e1$var$o = globalThis.litElementVersions) && void 0 !== $37e523229708d8e1$var$o ? $37e523229708d8e1$var$o : globalThis.litElementVersions = []).push("3.2.2");

});

parcelRegister("4TvFe", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3904dc4ccc7144b4$export$6acf61af03e62db = !1;

});


parcelRegister("aOuNF", function(module, exports) {

$parcel$export(module.exports, "ThemePropertyMixin", () => $7df6772ac3d6fd6a$export$9aaba893a776d386);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /**
 * @polymerMixin
 */ const $7df6772ac3d6fd6a$export$9aaba893a776d386 = (superClass)=>class VaadinThemePropertyMixin extends superClass {
        static get properties() {
            return {
                /**
         * Helper property with theme attribute value facilitating propagation
         * in shadow DOM.
         *
         * Enables the component implementation to propagate the `theme`
         * attribute value to the sub-components in Shadow DOM by binding
         * the sub-component’s "theme" attribute to the `theme` property of
         * the host.
         *
         * **NOTE:** Extending the mixin only provides the property for binding,
         * and does not make the propagation alone.
         *
         * See [Styling Components: Sub-components](https://vaadin.com/docs/latest/styling/custom-theme/styling-components/#sub-components).
         * page for more information.
         *
         * @deprecated The `theme` property is not supposed for public use and will be dropped in Vaadin 24.
         * Please, use the `theme` attribute instead.
         * @protected
         */ theme: {
                    type: String,
                    reflectToAttribute: true,
                    observer: '__deprecatedThemePropertyChanged'
                },
                /**
         * Helper property with theme attribute value facilitating propagation
         * in shadow DOM.
         *
         * Enables the component implementation to propagate the `theme`
         * attribute value to the sub-components in Shadow DOM by binding
         * the sub-component’s "theme" attribute to the `theme` property of
         * the host.
         *
         * **NOTE:** Extending the mixin only provides the property for binding,
         * and does not make the propagation alone.
         *
         * See [Styling Components: Sub-components](https://vaadin.com/docs/latest/styling/custom-theme/styling-components/#sub-components).
         * page for more information.
         *
         * @protected
         */ _theme: {
                    type: String,
                    readOnly: true
                }
            };
        }
        /** @private */ __deprecatedThemePropertyChanged(theme) {
            this._set_theme(theme);
        }
    };

});



parcelRegister("6Yt1B", function(module, exports) {
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("pFadI");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
const $513edc6a748eda38$export$9758cac25f26dd85 = (0, $aOvNQ.css)`
  :host {
    --lumo-size-xs: 1.625rem;
    --lumo-size-s: 1.875rem;
    --lumo-size-m: 2.25rem;
    --lumo-size-l: 2.75rem;
    --lumo-size-xl: 3.5rem;

    /* Icons */
    --lumo-icon-size-s: 1.25em;
    --lumo-icon-size-m: 1.5em;
    --lumo-icon-size-l: 2.25em;
    /* For backwards compatibility */
    --lumo-icon-size: var(--lumo-icon-size-m);
  }
`;
const $513edc6a748eda38$var$$tpl = document.createElement('template');
$513edc6a748eda38$var$$tpl.innerHTML = `<style>${$513edc6a748eda38$export$9758cac25f26dd85.toString().replace(':host', 'html')}</style>`;
document.head.appendChild($513edc6a748eda38$var$$tpl.content);

});

parcelRegister("gettf", function(module, exports) {
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("pFadI");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
const $bd14d06aa212b55e$export$5458b64234d1333c = (0, $aOvNQ.css)`
  :host {
    /* Square */
    --lumo-space-xs: 0.25rem;
    --lumo-space-s: 0.5rem;
    --lumo-space-m: 1rem;
    --lumo-space-l: 1.5rem;
    --lumo-space-xl: 2.5rem;

    /* Wide */
    --lumo-space-wide-xs: calc(var(--lumo-space-xs) / 2) var(--lumo-space-xs);
    --lumo-space-wide-s: calc(var(--lumo-space-s) / 2) var(--lumo-space-s);
    --lumo-space-wide-m: calc(var(--lumo-space-m) / 2) var(--lumo-space-m);
    --lumo-space-wide-l: calc(var(--lumo-space-l) / 2) var(--lumo-space-l);
    --lumo-space-wide-xl: calc(var(--lumo-space-xl) / 2) var(--lumo-space-xl);

    /* Tall */
    --lumo-space-tall-xs: var(--lumo-space-xs) calc(var(--lumo-space-xs) / 2);
    --lumo-space-tall-s: var(--lumo-space-s) calc(var(--lumo-space-s) / 2);
    --lumo-space-tall-m: var(--lumo-space-m) calc(var(--lumo-space-m) / 2);
    --lumo-space-tall-l: var(--lumo-space-l) calc(var(--lumo-space-l) / 2);
    --lumo-space-tall-xl: var(--lumo-space-xl) calc(var(--lumo-space-xl) / 2);
  }
`;
const $bd14d06aa212b55e$var$$tpl = document.createElement('template');
$bd14d06aa212b55e$var$$tpl.innerHTML = `<style>${$bd14d06aa212b55e$export$5458b64234d1333c.toString().replace(':host', 'html')}</style>`;
document.head.appendChild($bd14d06aa212b55e$var$$tpl.content);

});

parcelRegister("8Fvjg", function(module, exports) {
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("pFadI");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
const $64fa70889a689e4b$export$1d567c320f4763bc = (0, $aOvNQ.css)`
  :host {
    /* Border radius */
    --lumo-border-radius-s: 0.25em; /* Checkbox, badge, date-picker year indicator, etc */
    --lumo-border-radius-m: var(--lumo-border-radius, 0.25em); /* Button, text field, menu overlay, etc */
    --lumo-border-radius-l: 0.5em; /* Dialog, notification, etc */
    --lumo-border-radius: 0.25em; /* Deprecated */

    /* Shadow */
    --lumo-box-shadow-xs: 0 1px 4px -1px var(--lumo-shade-50pct);
    --lumo-box-shadow-s: 0 2px 4px -1px var(--lumo-shade-20pct), 0 3px 12px -1px var(--lumo-shade-30pct);
    --lumo-box-shadow-m: 0 2px 6px -1px var(--lumo-shade-20pct), 0 8px 24px -4px var(--lumo-shade-40pct);
    --lumo-box-shadow-l: 0 3px 18px -2px var(--lumo-shade-20pct), 0 12px 48px -6px var(--lumo-shade-40pct);
    --lumo-box-shadow-xl: 0 4px 24px -3px var(--lumo-shade-20pct), 0 18px 64px -8px var(--lumo-shade-40pct);

    /* Clickable element cursor */
    --lumo-clickable-cursor: default;
  }
`;
/**
 * Default values for component-specific custom properties.
 */ const $64fa70889a689e4b$export$816be348776d53c1 = (0, $aOvNQ.css)`
  html {
    --vaadin-checkbox-size: calc(var(--lumo-size-m) / 2);
    --vaadin-radio-button-size: calc(var(--lumo-size-m) / 2);
  }
`;
const $64fa70889a689e4b$var$$tpl = document.createElement('template');
$64fa70889a689e4b$var$$tpl.innerHTML = `<style>${$64fa70889a689e4b$export$1d567c320f4763bc.toString().replace(':host', 'html')}$</style>`;
document.head.appendChild($64fa70889a689e4b$var$$tpl.content);

});

parcelRegister("7Aef7", function(module, exports) {
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("pFadI");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $5856f1880bae75d4$export$a74e2025f5286b02 = (0, $aOvNQ.css)`
  :host {
    /* prettier-ignore */
    --lumo-font-family: -apple-system, BlinkMacSystemFont, 'Roboto', 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

    /* Font sizes */
    --lumo-font-size-xxs: 0.75rem;
    --lumo-font-size-xs: 0.8125rem;
    --lumo-font-size-s: 0.875rem;
    --lumo-font-size-m: 1rem;
    --lumo-font-size-l: 1.125rem;
    --lumo-font-size-xl: 1.375rem;
    --lumo-font-size-xxl: 1.75rem;
    --lumo-font-size-xxxl: 2.5rem;

    /* Line heights */
    --lumo-line-height-xs: 1.25;
    --lumo-line-height-s: 1.375;
    --lumo-line-height-m: 1.625;
  }
`;
const $5856f1880bae75d4$export$d846a084e680d8e = (0, $aOvNQ.css)`
  html,
  :host {
    font-family: var(--lumo-font-family);
    font-size: var(--lumo-font-size, var(--lumo-font-size-m));
    line-height: var(--lumo-line-height-m);
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  small,
  [theme~='font-size-s'] {
    font-size: var(--lumo-font-size-s);
    line-height: var(--lumo-line-height-s);
  }

  [theme~='font-size-xs'] {
    font-size: var(--lumo-font-size-xs);
    line-height: var(--lumo-line-height-xs);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    line-height: var(--lumo-line-height-xs);
    margin-top: 1.25em;
  }

  h1 {
    font-size: var(--lumo-font-size-xxxl);
    margin-bottom: 0.75em;
  }

  h2 {
    font-size: var(--lumo-font-size-xxl);
    margin-bottom: 0.5em;
  }

  h3 {
    font-size: var(--lumo-font-size-xl);
    margin-bottom: 0.5em;
  }

  h4 {
    font-size: var(--lumo-font-size-l);
    margin-bottom: 0.5em;
  }

  h5 {
    font-size: var(--lumo-font-size-m);
    margin-bottom: 0.25em;
  }

  h6 {
    font-size: var(--lumo-font-size-xs);
    margin-bottom: 0;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  p,
  blockquote {
    margin-top: 0.5em;
    margin-bottom: 0.75em;
  }

  a {
    text-decoration: none;
  }

  a:where(:any-link):hover {
    text-decoration: underline;
  }

  hr {
    display: block;
    align-self: stretch;
    height: 1px;
    border: 0;
    padding: 0;
    margin: var(--lumo-space-s) calc(var(--lumo-border-radius-m) / 2);
    background-color: var(--lumo-contrast-10pct);
  }

  blockquote {
    border-left: 2px solid var(--lumo-contrast-30pct);
  }

  b,
  strong {
    font-weight: 600;
  }

  /* RTL specific styles */
  blockquote[dir='rtl'] {
    border-left: none;
    border-right: 2px solid var(--lumo-contrast-30pct);
  }
`;
(0, $2vXFS.registerStyles)('', $5856f1880bae75d4$export$d846a084e680d8e, {
    moduleId: 'lumo-typography'
});
const $5856f1880bae75d4$var$$tpl = document.createElement('template');
$5856f1880bae75d4$var$$tpl.innerHTML = `<style>${$5856f1880bae75d4$export$a74e2025f5286b02.toString().replace(':host', 'html')}</style>`;
document.head.appendChild($5856f1880bae75d4$var$$tpl.content);

});


parcelRegister("jfKYS", function(module, exports) {

$parcel$export(module.exports, "RadioButton", () => $e043dc7c3b0d67b6$export$f4422ae58352e179);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $is1HS = parcelRequire("is1HS");

var $bthO9 = parcelRequire("bthO9");

var $9Q7uu = parcelRequire("9Q7uu");

var $kRmfJ = parcelRequire("kRmfJ");

var $dbTLX = parcelRequire("dbTLX");

var $1wMVk = parcelRequire("1wMVk");

var $bwrUf = parcelRequire("bwrUf");

var $jqW2B = parcelRequire("jqW2B");

var $aGZym = parcelRequire("aGZym");

var $2vXFS = parcelRequire("2vXFS");
/**
 * `<vaadin-radio-button>` is a web component representing a choice in a radio group.
 * Only one radio button in the group can be selected at the same time.
 *
 * ```html
 * <vaadin-radio-group label="Travel class">
 *   <vaadin-radio-button value="economy" label="Economy"></vaadin-radio-button>
 *   <vaadin-radio-button value="business" label="Business"></vaadin-radio-button>
 *   <vaadin-radio-button value="firstClass" label="First Class"></vaadin-radio-button>
 * </vaadin-radio-group>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name   | Description
 * ------------|----------------
 * `radio`     | The wrapper element that contains slotted `<input type="radio">`.
 *
 * The following state attributes are available for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|------------
 * `active`     | Set when the radio button is pressed down, either with a pointer or the keyboard. | `:host`
 * `disabled`   | Set when the radio button is disabled. | `:host`
 * `focus-ring` | Set when the radio button is focused using the keyboard. | `:host`
 * `focused`    | Set when the radio button is focused. | `:host`
 * `checked`    | Set when the radio button is checked. | `:host`
 * `has-label`  | Set when the radio button has a label. | `:host`
 *
 * See [Styling Components](https://vaadin.com/docs/latest/styling/custom-theme/styling-components) documentation.
 *
 * @fires {CustomEvent} checked-changed - Fired when the `checked` property changes.
 *
 * @extends HTMLElement
 * @mixes ControllerMixin
 * @mixes ThemableMixin
 * @mixes ElementMixin
 * @mixes ActiveMixin
 * @mixes CheckedMixin
 * @mixes LabelMixin
 */ class $e043dc7c3b0d67b6$export$f4422ae58352e179 extends (0, $bwrUf.LabelMixin)((0, $kRmfJ.CheckedMixin)((0, $dbTLX.DelegateFocusMixin)((0, $is1HS.ActiveMixin)((0, $9Q7uu.ElementMixin)((0, $2vXFS.ThemableMixin)((0, $bthO9.ControllerMixin)((0, $5QhZ5.PolymerElement)))))))) {
    static get is() {
        return 'vaadin-radio-button';
    }
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host {
          display: inline-block;
        }

        :host([hidden]) {
          display: none !important;
        }

        :host([disabled]) {
          -webkit-tap-highlight-color: transparent;
        }

        .vaadin-radio-button-container {
          display: grid;
          grid-template-columns: auto 1fr;
          align-items: baseline;
        }

        [part='radio'],
        ::slotted(input),
        ::slotted(label) {
          grid-row: 1;
        }

        [part='radio'],
        ::slotted(input) {
          grid-column: 1;
        }

        [part='radio'] {
          width: var(--vaadin-radio-button-size, 1em);
          height: var(--vaadin-radio-button-size, 1em);
        }

        [part='radio']::before {
          display: block;
          content: '\\202F';
          line-height: var(--vaadin-radio-button-size, 1em);
          contain: paint;
        }

        /* visually hidden */
        ::slotted(input) {
          opacity: 0;
          cursor: inherit;
          margin: 0;
          align-self: stretch;
          -webkit-appearance: none;
        }
      </style>
      <div class="vaadin-radio-button-container">
        <div part="radio"></div>
        <slot name="input"></slot>
        <slot name="label"></slot>

        <div style="display: none !important">
          <slot id="noop"></slot>
        </div>
      </div>
    `;
    }
    static get properties() {
        return {
            /**
       * The name of the radio button.
       *
       * @type {string}
       */ name: {
                type: String,
                value: ''
            }
        };
    }
    /** @override */ static get delegateAttrs() {
        return [
            ...super.delegateAttrs,
            'name'
        ];
    }
    constructor(){
        super();
        this._setType('radio');
        // Set the string "on" as the default value for the radio button following the HTML specification:
        // https://html.spec.whatwg.org/multipage/input.html#dom-input-value-default-on
        this.value = 'on';
    }
    /** @protected */ ready() {
        super.ready();
        this.addController(new (0, $1wMVk.InputController)(this, (input)=>{
            this._setInputElement(input);
            this._setFocusElement(input);
            this.stateTarget = input;
            this.ariaTarget = input;
        }));
        this.addController(new (0, $jqW2B.LabelledInputController)(this.inputElement, this._labelController));
        this.addController(new (0, $aGZym.SlotTargetController)(this.$.noop, ()=>this._labelController.node, ()=>this.__warnDeprecated()));
    }
    /** @private */ __warnDeprecated() {
        console.warn(`WARNING: Since Vaadin 22, placing the label as a direct child of a <vaadin-radio-button> is deprecated.
  Please use <label slot="label"> wrapper or the label property instead.`);
    }
}
customElements.define($e043dc7c3b0d67b6$export$f4422ae58352e179.is, $e043dc7c3b0d67b6$export$f4422ae58352e179);

});
parcelRegister("5QhZ5", function(module, exports) {

$parcel$export(module.exports, "PolymerElement", () => $440fc264bf407b24$export$792c5fa268ce93ea);
$parcel$export(module.exports, "html", () => (parcelRequire("76MHV")).html);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ 
var $b3T1I = parcelRequire("b3T1I");

var $76MHV = parcelRequire("76MHV");
const $440fc264bf407b24$export$792c5fa268ce93ea = (0, $b3T1I.ElementMixin)(HTMLElement);

});
parcelRegister("b3T1I", function(module, exports) {

$parcel$export(module.exports, "ElementMixin", () => $80daa8b146d9e8ec$export$6154786385672f5d);
/**
 * @fileoverview
 * @suppress {checkPrototypalTypes}
 * @license Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */ parcelRequire("dMwQI");

var $8bEdR = parcelRequire("8bEdR");

var $gLdkK = parcelRequire("gLdkK");

var $4RizA = parcelRequire("4RizA");

var $j19O3 = parcelRequire("j19O3");

var $c9zuV = parcelRequire("c9zuV");

var $2njbg = parcelRequire("2njbg");

var $drPJO = parcelRequire("drPJO");

var $a2HIe = parcelRequire("a2HIe");
const $80daa8b146d9e8ec$export$83d89fbfd8236492 = '3.5.1';
const $80daa8b146d9e8ec$export$fc7755cfd5e297e6 = window.ShadyCSS && window.ShadyCSS['cssBuild'];
const $80daa8b146d9e8ec$export$6154786385672f5d = (0, $gLdkK.dedupingMixin)((base)=>{
    /**
   * @constructor
   * @implements {Polymer_PropertyEffects}
   * @implements {Polymer_PropertiesMixin}
   * @extends {HTMLElement}
   * @private
   */ const polymerElementBase = (0, $drPJO.PropertiesMixin)((0, $2njbg.PropertyEffects)(base));
    /**
   * Returns a list of properties with default values.
   * This list is created as an optimization since it is a subset of
   * the list returned from `_properties`.
   * This list is used in `_initializeProperties` to set property defaults.
   *
   * @param {PolymerElementConstructor} constructor Element class
   * @return {PolymerElementProperties} Flattened properties for this class
   *   that have default values
   * @private
   */ function propertyDefaults(constructor) {
        if (!constructor.hasOwnProperty(JSCompiler_renameProperty('__propertyDefaults', constructor))) {
            constructor.__propertyDefaults = null;
            let props = constructor._properties;
            for(let p in props){
                let info = props[p];
                if ('value' in info) {
                    constructor.__propertyDefaults = constructor.__propertyDefaults || {};
                    constructor.__propertyDefaults[p] = info;
                }
            }
        }
        return constructor.__propertyDefaults;
    }
    /**
   * Returns a memoized version of the `observers` array.
   * @param {PolymerElementConstructor} constructor Element class
   * @return {Array} Array containing own observers for the given class
   * @protected
   */ function ownObservers(constructor) {
        if (!constructor.hasOwnProperty(JSCompiler_renameProperty('__ownObservers', constructor))) constructor.__ownObservers = constructor.hasOwnProperty(JSCompiler_renameProperty('observers', constructor)) ? /** @type {PolymerElementConstructor} */ constructor.observers : null;
        return constructor.__ownObservers;
    }
    /**
   * Creates effects for a property.
   *
   * Note, once a property has been set to
   * `readOnly`, `computed`, `reflectToAttribute`, or `notify`
   * these values may not be changed. For example, a subclass cannot
   * alter these settings. However, additional `observers` may be added
   * by subclasses.
   *
   * The info object should contain property metadata as follows:
   *
   * * `type`: {function} type to which an attribute matching the property
   * is deserialized. Note the property is camel-cased from a dash-cased
   * attribute. For example, 'foo-bar' attribute is deserialized to a
   * property named 'fooBar'.
   *
   * * `readOnly`: {boolean} creates a readOnly property and
   * makes a private setter for the private of the form '_setFoo' for a
   * property 'foo',
   *
   * * `computed`: {string} creates a computed property. A computed property
   * is also automatically set to `readOnly: true`. The value is calculated
   * by running a method and arguments parsed from the given string. For
   * example 'compute(foo)' will compute a given property when the
   * 'foo' property changes by executing the 'compute' method. This method
   * must return the computed value.
   *
   * * `reflectToAttribute`: {boolean} If true, the property value is reflected
   * to an attribute of the same name. Note, the attribute is dash-cased
   * so a property named 'fooBar' is reflected as 'foo-bar'.
   *
   * * `notify`: {boolean} sends a non-bubbling notification event when
   * the property changes. For example, a property named 'foo' sends an
   * event named 'foo-changed' with `event.detail` set to the value of
   * the property.
   *
   * * observer: {string} name of a method that runs when the property
   * changes. The arguments of the method are (value, previousValue).
   *
   * Note: Users may want control over modifying property
   * effects via subclassing. For example, a user might want to make a
   * reflectToAttribute property not do so in a subclass. We've chosen to
   * disable this because it leads to additional complication.
   * For example, a readOnly effect generates a special setter. If a subclass
   * disables the effect, the setter would fail unexpectedly.
   * Based on feedback, we may want to try to make effects more malleable
   * and/or provide an advanced api for manipulating them.
   *
   * @param {!PolymerElement} proto Element class prototype to add accessors
   *   and effects to
   * @param {string} name Name of the property.
   * @param {Object} info Info object from which to create property effects.
   * Supported keys:
   * @param {Object} allProps Flattened map of all properties defined in this
   *   element (including inherited properties)
   * @return {void}
   * @private
   */ function createPropertyFromConfig(proto, name, info, allProps) {
        // computed forces readOnly...
        if (info.computed) info.readOnly = true;
        // Note, since all computed properties are readOnly, this prevents
        // adding additional computed property effects (which leads to a confusing
        // setup where multiple triggers for setting a property)
        // While we do have `hasComputedEffect` this is set on the property's
        // dependencies rather than itself.
        if (info.computed) {
            if (proto._hasReadOnlyEffect(name)) console.warn(`Cannot redefine computed property '${name}'.`);
            else proto._createComputedProperty(name, info.computed, allProps);
        }
        if (info.readOnly && !proto._hasReadOnlyEffect(name)) proto._createReadOnlyProperty(name, !info.computed);
        else if (info.readOnly === false && proto._hasReadOnlyEffect(name)) console.warn(`Cannot make readOnly property '${name}' non-readOnly.`);
        if (info.reflectToAttribute && !proto._hasReflectEffect(name)) proto._createReflectedProperty(name);
        else if (info.reflectToAttribute === false && proto._hasReflectEffect(name)) console.warn(`Cannot make reflected property '${name}' non-reflected.`);
        if (info.notify && !proto._hasNotifyEffect(name)) proto._createNotifyingProperty(name);
        else if (info.notify === false && proto._hasNotifyEffect(name)) console.warn(`Cannot make notify property '${name}' non-notify.`);
        // always add observer
        if (info.observer) proto._createPropertyObserver(name, info.observer, allProps[info.observer]);
        // always create the mapping from attribute back to property for deserialization.
        proto._addPropertyToAttributeMap(name);
    }
    /**
   * Process all style elements in the element template. Styles with the
   * `include` attribute are processed such that any styles in
   * the associated "style modules" are included in the element template.
   * @param {PolymerElementConstructor} klass Element class
   * @param {!HTMLTemplateElement} template Template to process
   * @param {string} is Name of element
   * @param {string} baseURI Base URI for element
   * @private
   */ function processElementStyles(klass, template, is, baseURI) {
        if (!$80daa8b146d9e8ec$export$fc7755cfd5e297e6) {
            const templateStyles = template.content.querySelectorAll('style');
            const stylesWithImports = (0, $4RizA.stylesFromTemplate)(template);
            // insert styles from <link rel="import" type="css"> at the top of the template
            const linkedStyles = (0, $4RizA.stylesFromModuleImports)(is);
            const firstTemplateChild = template.content.firstElementChild;
            for(let idx = 0; idx < linkedStyles.length; idx++){
                let s = linkedStyles[idx];
                s.textContent = klass._processStyleText(s.textContent, baseURI);
                template.content.insertBefore(s, firstTemplateChild);
            }
            // keep track of the last "concrete" style in the template we have encountered
            let templateStyleIndex = 0;
            // ensure all gathered styles are actually in this template.
            for(let i = 0; i < stylesWithImports.length; i++){
                let s = stylesWithImports[i];
                let templateStyle = templateStyles[templateStyleIndex];
                // if the style is not in this template, it's been "included" and
                // we put a clone of it in the template before the style that included it
                if (templateStyle !== s) {
                    s = s.cloneNode(true);
                    templateStyle.parentNode.insertBefore(s, templateStyle);
                } else templateStyleIndex++;
                s.textContent = klass._processStyleText(s.textContent, baseURI);
            }
        }
        if (window.ShadyCSS) window.ShadyCSS.prepareTemplate(template, is);
        // Support for `adoptedStylesheets` relies on using native Shadow DOM
        // and built CSS. Built CSS is required because runtime transformation of
        // `@apply` is not supported. This is because ShadyCSS relies on being able
        // to update a `style` element in the element template and this is
        // removed when using `adoptedStyleSheets`.
        // Note, it would be more efficient to allow style includes to become
        // separate stylesheets; however, because of `@apply` these are
        // potentially not shareable and sharing the ones that could be shared
        // would require some coordination. To keep it simple, all the includes
        // and styles are collapsed into a single shareable stylesheet.
        if ((0, $8bEdR.useAdoptedStyleSheetsWithBuiltCSS) && $80daa8b146d9e8ec$export$fc7755cfd5e297e6 && (0, $8bEdR.supportsAdoptingStyleSheets)) {
            // Remove styles in template and make a shareable stylesheet
            const styles = template.content.querySelectorAll('style');
            if (styles) {
                let css = '';
                Array.from(styles).forEach((s)=>{
                    css += s.textContent;
                    s.parentNode.removeChild(s);
                });
                klass._styleSheet = new CSSStyleSheet();
                klass._styleSheet.replaceSync(css);
            }
        }
    }
    /**
   * Look up template from dom-module for element
   *
   * @param {string} is Element name to look up
   * @return {?HTMLTemplateElement|undefined} Template found in dom module, or
   *   undefined if not found
   * @protected
   */ function getTemplateFromDomModule(is) {
        let template = null;
        // Under strictTemplatePolicy in 3.x+, dom-module lookup is only allowed
        // when opted-in via allowTemplateFromDomModule
        if (is && (!(0, $8bEdR.strictTemplatePolicy) || (0, $8bEdR.allowTemplateFromDomModule))) {
            template = /** @type {?HTMLTemplateElement} */ (0, $c9zuV.DomModule).import(is, 'template');
            // Under strictTemplatePolicy, require any element with an `is`
            // specified to have a dom-module
            if ((0, $8bEdR.strictTemplatePolicy) && !template) throw new Error(`strictTemplatePolicy: expecting dom-module or null template for ${is}`);
        }
        return template;
    }
    /**
   * @polymer
   * @mixinClass
   * @unrestricted
   * @implements {Polymer_ElementMixin}
   * @extends {polymerElementBase}
   */ class PolymerElement extends polymerElementBase {
        /**
     * Current Polymer version in Semver notation.
     * @type {string} Semver notation of the current version of Polymer.
     * @nocollapse
     */ static get polymerElementVersion() {
            return $80daa8b146d9e8ec$export$83d89fbfd8236492;
        }
        /**
     * Override of PropertiesMixin _finalizeClass to create observers and
     * find the template.
     * @return {void}
     * @protected
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */ static _finalizeClass() {
            // TODO(https://github.com/google/closure-compiler/issues/3240):
            //     Change back to just super.methodCall()
            polymerElementBase._finalizeClass.call(this);
            const observers = ownObservers(this);
            if (observers) this.createObservers(observers, this._properties);
            this._prepareTemplate();
        }
        /** @nocollapse */ static _prepareTemplate() {
            // note: create "working" template that is finalized at instance time
            let template = /** @type {PolymerElementConstructor} */ this.template;
            if (template) {
                if (typeof template === 'string') {
                    console.error('template getter must return HTMLTemplateElement');
                    template = null;
                } else if (!(0, $8bEdR.legacyOptimizations)) template = template.cloneNode(true);
            }
            /** @override */ this.prototype._template = template;
        }
        /**
     * Override of PropertiesChanged createProperties to create accessors
     * and property effects for all of the properties.
     * @param {!Object} props .
     * @return {void}
     * @protected
     * @nocollapse
     */ static createProperties(props) {
            for(let p in props)createPropertyFromConfig(/** @type {?} */ this.prototype, p, props[p], props);
        }
        /**
     * Creates observers for the given `observers` array.
     * Leverages `PropertyEffects` to create observers.
     * @param {Object} observers Array of observer descriptors for
     *   this class
     * @param {Object} dynamicFns Object containing keys for any properties
     *   that are functions and should trigger the effect when the function
     *   reference is changed
     * @return {void}
     * @protected
     * @nocollapse
     */ static createObservers(observers, dynamicFns) {
            const proto = this.prototype;
            for(let i = 0; i < observers.length; i++)proto._createMethodObserver(observers[i], dynamicFns);
        }
        /**
     * Returns the template that will be stamped into this element's shadow root.
     *
     * If a `static get is()` getter is defined, the default implementation will
     * return the first `<template>` in a `dom-module` whose `id` matches this
     * element's `is` (note that a `_template` property on the class prototype
     * takes precedence over the `dom-module` template, to maintain legacy
     * element semantics; a subclass will subsequently fall back to its super
     * class template if neither a `prototype._template` or a `dom-module` for
     * the class's `is` was found).
     *
     * Users may override this getter to return an arbitrary template
     * (in which case the `is` getter is unnecessary). The template returned
     * must be an `HTMLTemplateElement`.
     *
     * Note that when subclassing, if the super class overrode the default
     * implementation and the subclass would like to provide an alternate
     * template via a `dom-module`, it should override this getter and
     * return `DomModule.import(this.is, 'template')`.
     *
     * If a subclass would like to modify the super class template, it should
     * clone it rather than modify it in place.  If the getter does expensive
     * work such as cloning/modifying a template, it should memoize the
     * template for maximum performance:
     *
     *   let memoizedTemplate;
     *   class MySubClass extends MySuperClass {
     *     static get template() {
     *       if (!memoizedTemplate) {
     *         memoizedTemplate = super.template.cloneNode(true);
     *         let subContent = document.createElement('div');
     *         subContent.textContent = 'This came from MySubClass';
     *         memoizedTemplate.content.appendChild(subContent);
     *       }
     *       return memoizedTemplate;
     *     }
     *   }
     *
     * @return {!HTMLTemplateElement|string} Template to be stamped
     * @nocollapse
     */ static get template() {
            // Explanation of template-related properties:
            // - constructor.template (this getter): the template for the class.
            //     This can come from the prototype (for legacy elements), from a
            //     dom-module, or from the super class's template (or can be overridden
            //     altogether by the user)
            // - constructor._template: memoized version of constructor.template
            // - prototype._template: working template for the element, which will be
            //     parsed and modified in place. It is a cloned version of
            //     constructor.template, saved in _finalizeClass(). Note that before
            //     this getter is called, for legacy elements this could be from a
            //     _template field on the info object passed to Polymer(), a behavior,
            //     or set in registered(); once the static getter runs, a clone of it
            //     will overwrite it on the prototype as the working template.
            if (!this.hasOwnProperty(JSCompiler_renameProperty('_template', this))) {
                let protoTemplate = this.prototype.hasOwnProperty(JSCompiler_renameProperty('_template', this.prototype)) ? this.prototype._template : undefined;
                // Accept a function for the legacy Polymer({_template:...}) field for
                // lazy parsing
                if (typeof protoTemplate === 'function') protoTemplate = protoTemplate();
                this._template = // If user has put template on prototype (e.g. in legacy via registered
                // callback or info object), prefer that first. Note that `null` is
                // used as a sentinel to indicate "no template" and can be used to
                // override a super template, whereas `undefined` is used as a
                // sentinel to mean "fall-back to default template lookup" via
                // dom-module and/or super.template.
                protoTemplate !== undefined ? protoTemplate : // Look in dom-module associated with this element's is
                this.hasOwnProperty(JSCompiler_renameProperty('is', this)) && getTemplateFromDomModule(/** @type {PolymerElementConstructor}*/ this.is) || // Next look for superclass template (call the super impl this
                // way so that `this` points to the superclass)
                Object.getPrototypeOf(/** @type {PolymerElementConstructor}*/ this.prototype).constructor.template;
            }
            return this._template;
        }
        /**
     * Set the template.
     *
     * @param {!HTMLTemplateElement|string} value Template to set.
     * @nocollapse
     */ static set template(value) {
            this._template = value;
        }
        /**
     * Path matching the url from which the element was imported.
     *
     * This path is used to resolve url's in template style cssText.
     * The `importPath` property is also set on element instances and can be
     * used to create bindings relative to the import path.
     *
     * For elements defined in ES modules, users should implement
     * `static get importMeta() { return import.meta; }`, and the default
     * implementation of `importPath` will  return `import.meta.url`'s path.
     * For elements defined in HTML imports, this getter will return the path
     * to the document containing a `dom-module` element matching this
     * element's static `is` property.
     *
     * Note, this path should contain a trailing `/`.
     *
     * @return {string} The import path for this element class
     * @suppress {missingProperties}
     * @nocollapse
     */ static get importPath() {
            if (!this.hasOwnProperty(JSCompiler_renameProperty('_importPath', this))) {
                const meta = this.importMeta;
                if (meta) this._importPath = (0, $j19O3.pathFromUrl)(meta.url);
                else {
                    const module = (0, $c9zuV.DomModule).import(/** @type {PolymerElementConstructor} */ this.is);
                    this._importPath = module && module.assetpath || Object.getPrototypeOf(/** @type {PolymerElementConstructor}*/ this.prototype).constructor.importPath;
                }
            }
            return this._importPath;
        }
        constructor(){
            super();
            /** @type {HTMLTemplateElement} */ this._template;
            /** @type {string} */ this._importPath;
            /** @type {string} */ this.rootPath;
            /** @type {string} */ this.importPath;
            /** @type {StampedTemplate | HTMLElement | ShadowRoot} */ this.root;
            /** @type {!Object<string, !Element>} */ this.$;
        }
        /**
     * Overrides the default `PropertyAccessors` to ensure class
     * metaprogramming related to property accessors and effects has
     * completed (calls `finalize`).
     *
     * It also initializes any property defaults provided via `value` in
     * `properties` metadata.
     *
     * @return {void}
     * @override
     * @suppress {invalidCasts,missingProperties} go/missingfnprops
     */ _initializeProperties() {
            this.constructor.finalize();
            // note: finalize template when we have access to `localName` to
            // avoid dependence on `is` for polyfilling styling.
            this.constructor._finalizeTemplate(/** @type {!HTMLElement} */ this.localName);
            super._initializeProperties();
            // set path defaults
            this.rootPath = (0, $8bEdR.rootPath);
            this.importPath = this.constructor.importPath;
            // apply property defaults...
            let p$ = propertyDefaults(this.constructor);
            if (!p$) return;
            for(let p in p$){
                let info = p$[p];
                if (this._canApplyPropertyDefault(p)) {
                    let value = typeof info.value == 'function' ? info.value.call(this) : info.value;
                    // Set via `_setProperty` if there is an accessor, to enable
                    // initializing readOnly property defaults
                    if (this._hasAccessor(p)) this._setPendingProperty(p, value, true);
                    else this[p] = value;
                }
            }
        }
        /**
     * Determines if a property dfeault can be applied. For example, this
     * prevents a default from being applied when a property that has no
     * accessor is overridden by its host before upgrade (e.g. via a binding).
     * @override
     * @param {string} property Name of the property
     * @return {boolean} Returns true if the property default can be applied.
     */ _canApplyPropertyDefault(property) {
            return !this.hasOwnProperty(property);
        }
        /**
     * Gather style text for a style element in the template.
     *
     * @param {string} cssText Text containing styling to process
     * @param {string} baseURI Base URI to rebase CSS paths against
     * @return {string} The processed CSS text
     * @protected
     * @nocollapse
     */ static _processStyleText(cssText, baseURI) {
            return (0, $j19O3.resolveCss)(cssText, baseURI);
        }
        /**
    * Configures an element `proto` to function with a given `template`.
    * The element name `is` and extends `ext` must be specified for ShadyCSS
    * style scoping.
    *
    * @param {string} is Tag name (or type extension name) for this element
    * @return {void}
    * @protected
    * @nocollapse
    */ static _finalizeTemplate(is) {
            /** @const {HTMLTemplateElement} */ const template = this.prototype._template;
            if (template && !template.__polymerFinalized) {
                template.__polymerFinalized = true;
                const importPath = this.importPath;
                const baseURI = importPath ? (0, $j19O3.resolveUrl)(importPath) : '';
                // e.g. support `include="module-name"`, and ShadyCSS
                processElementStyles(this, template, is, baseURI);
                this.prototype._bindTemplate(template);
            }
        }
        /**
     * Provides a default implementation of the standard Custom Elements
     * `connectedCallback`.
     *
     * The default implementation enables the property effects system and
     * flushes any pending properties, and updates shimmed CSS properties
     * when using the ShadyCSS scoping/custom properties polyfill.
     *
     * @override
     * @suppress {missingProperties, invalidCasts} Super may or may not
     *     implement the callback
     * @return {void}
     */ connectedCallback() {
            if (window.ShadyCSS && this._template) window.ShadyCSS.styleElement(/** @type {!HTMLElement} */ this);
            super.connectedCallback();
        }
        /**
     * Stamps the element template.
     *
     * @return {void}
     * @override
     */ ready() {
            if (this._template) {
                this.root = this._stampTemplate(this._template);
                this.$ = this.root.$;
            }
            super.ready();
        }
        /**
     * Implements `PropertyEffects`'s `_readyClients` call. Attaches
     * element dom by calling `_attachDom` with the dom stamped from the
     * element's template via `_stampTemplate`. Note that this allows
     * client dom to be attached to the element prior to any observers
     * running.
     *
     * @return {void}
     * @override
     */ _readyClients() {
            if (this._template) this.root = this._attachDom(/** @type {StampedTemplate} */ this.root);
            // The super._readyClients here sets the clients initialized flag.
            // We must wait to do this until after client dom is created/attached
            // so that this flag can be checked to prevent notifications fired
            // during this process from being handled before clients are ready.
            super._readyClients();
        }
        /**
     * Attaches an element's stamped dom to itself. By default,
     * this method creates a `shadowRoot` and adds the dom to it.
     * However, this method may be overridden to allow an element
     * to put its dom in another location.
     *
     * @override
     * @throws {Error}
     * @suppress {missingReturn}
     * @param {StampedTemplate} dom to attach to the element.
     * @return {ShadowRoot} node to which the dom has been attached.
     */ _attachDom(dom) {
            const n = (0, $a2HIe.wrap)(this);
            if (n.attachShadow) {
                if (dom) {
                    if (!n.shadowRoot) {
                        n.attachShadow({
                            mode: 'open',
                            shadyUpgradeFragment: dom
                        });
                        n.shadowRoot.appendChild(dom);
                        // When `adoptedStyleSheets` is supported a stylesheet is made
                        // available on the element constructor.
                        if (this.constructor._styleSheet) n.shadowRoot.adoptedStyleSheets = [
                            this.constructor._styleSheet
                        ];
                    }
                    if ((0, $8bEdR.syncInitialRender) && window.ShadyDOM) window.ShadyDOM.flushInitial(n.shadowRoot);
                    return n.shadowRoot;
                }
                return null;
            } else throw new Error("ShadowDOM not available. PolymerElement can create dom as children instead of in ShadowDOM by setting `this.root = this;` before `ready`.");
        }
        /**
     * When using the ShadyCSS scoping and custom property shim, causes all
     * shimmed styles in this element (and its subtree) to be updated
     * based on current custom property values.
     *
     * The optional parameter overrides inline custom property styles with an
     * object of properties where the keys are CSS properties, and the values
     * are strings.
     *
     * Example: `this.updateStyles({'--color': 'blue'})`
     *
     * These properties are retained unless a value of `null` is set.
     *
     * Note: This function does not support updating CSS mixins.
     * You can not dynamically change the value of an `@apply`.
     *
     * @override
     * @param {Object=} properties Bag of custom property key/values to
     *   apply to this element.
     * @return {void}
     * @suppress {invalidCasts}
     */ updateStyles(properties) {
            if (window.ShadyCSS) window.ShadyCSS.styleSubtree(/** @type {!HTMLElement} */ this, properties);
        }
        /**
     * Rewrites a given URL relative to a base URL. The base URL defaults to
     * the original location of the document containing the `dom-module` for
     * this element. This method will return the same URL before and after
     * bundling.
     *
     * Note that this function performs no resolution for URLs that start
     * with `/` (absolute URLs) or `#` (hash identifiers).  For general purpose
     * URL resolution, use `window.URL`.
     *
     * @override
     * @param {string} url URL to resolve.
     * @param {string=} base Optional base URL to resolve against, defaults
     * to the element's `importPath`
     * @return {string} Rewritten URL relative to base
     */ resolveUrl(url, base) {
            if (!base && this.importPath) base = (0, $j19O3.resolveUrl)(this.importPath);
            return (0, $j19O3.resolveUrl)(url, base);
        }
        /**
     * Overrides `PropertyEffects` to add map of dynamic functions on
     * template info, for consumption by `PropertyEffects` template binding
     * code. This map determines which method templates should have accessors
     * created for them.
     *
     * @param {!HTMLTemplateElement} template Template
     * @param {!TemplateInfo} templateInfo Template metadata for current template
     * @param {!NodeInfo} nodeInfo Node metadata for current template.
     * @return {boolean} .
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */ static _parseTemplateContent(template, templateInfo, nodeInfo) {
            templateInfo.dynamicFns = templateInfo.dynamicFns || this._properties;
            // TODO(https://github.com/google/closure-compiler/issues/3240):
            //     Change back to just super.methodCall()
            return polymerElementBase._parseTemplateContent.call(this, template, templateInfo, nodeInfo);
        }
        /**
     * Overrides `PropertyEffects` to warn on use of undeclared properties in
     * template.
     *
     * @param {Object} templateInfo Template metadata to add effect to
     * @param {string} prop Property that should trigger the effect
     * @param {Object=} effect Effect metadata object
     * @return {void}
     * @protected
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */ static _addTemplatePropertyEffect(templateInfo, prop, effect) {
            // Warn if properties are used in template without being declared.
            // Properties must be listed in `properties` to be included in
            // `observedAttributes` since CE V1 reads that at registration time, and
            // since we want to keep template parsing lazy, we can't automatically
            // add undeclared properties used in templates to `observedAttributes`.
            // The warning is only enabled in `legacyOptimizations` mode, since
            // we don't want to spam existing users who might have adopted the
            // shorthand when attribute deserialization is not important.
            if ((0, $8bEdR.legacyWarnings) && !(prop in this._properties) && // Methods used in templates with no dependencies (or only literal
            // dependencies) become accessors with template effects; ignore these
            !(effect.info.part.signature && effect.info.part.signature.static) && // Warnings for bindings added to nested templates are handled by
            // templatizer so ignore both the host-to-template bindings
            // (`hostProp`) and TemplateInstance-to-child bindings
            // (`nestedTemplate`)
            !effect.info.part.hostProp && !templateInfo.nestedTemplate) console.warn(`Property '${prop}' used in template but not declared in 'properties'; ` + `attribute will not be observed.`);
            // TODO(https://github.com/google/closure-compiler/issues/3240):
            //     Change back to just super.methodCall()
            return polymerElementBase._addTemplatePropertyEffect.call(this, templateInfo, prop, effect);
        }
    }
    return PolymerElement;
});
const $80daa8b146d9e8ec$export$89536f00708fe921 = function(props) {
    if (window.ShadyCSS) window.ShadyCSS.styleDocument(props);
};

});
parcelRegister("dMwQI", function(module, exports) {
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /* eslint-disable no-unused-vars */ /**
 * When using Closure Compiler, JSCompiler_renameProperty(property, object) is replaced by the munged name for object[property]
 * We cannot alias this function, so we have to use a small shim that has the same behavior when not compiling.
 *
 * @param {?} prop Property name
 * @param {*} obj Reference object
 * @return {string} Potentially renamed property name
 */ window.JSCompiler_renameProperty = function(prop, obj) {
    return prop;
};

});

parcelRegister("8bEdR", function(module, exports) {

$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => $0189c8785d78b0c8$export$b4d10f6001c083c2);
$parcel$export(module.exports, "rootPath", () => $0189c8785d78b0c8$export$2c2b629ee110b0c4);
$parcel$export(module.exports, "sanitizeDOMValue", () => $0189c8785d78b0c8$export$933597516e05b6ba);
$parcel$export(module.exports, "strictTemplatePolicy", () => $0189c8785d78b0c8$export$acf5a474bddac04e);
$parcel$export(module.exports, "allowTemplateFromDomModule", () => $0189c8785d78b0c8$export$5ae065bca0989b14);
$parcel$export(module.exports, "legacyOptimizations", () => $0189c8785d78b0c8$export$3c94433b141a5935);
$parcel$export(module.exports, "legacyWarnings", () => $0189c8785d78b0c8$export$72c298ba1c0d71ac);
$parcel$export(module.exports, "syncInitialRender", () => $0189c8785d78b0c8$export$2dab853be0f46432);
$parcel$export(module.exports, "legacyUndefined", () => $0189c8785d78b0c8$export$1b6b9baa82f69fe4);
$parcel$export(module.exports, "orderedComputed", () => $0189c8785d78b0c8$export$f1157f27ba4ba240);
$parcel$export(module.exports, "setCancelSyntheticClickEvents", () => $0189c8785d78b0c8$export$218251f5c49f5698);
$parcel$export(module.exports, "removeNestedTemplates", () => $0189c8785d78b0c8$export$c522adfce8f3fd9f);
$parcel$export(module.exports, "fastDomIf", () => $0189c8785d78b0c8$export$29626a1dca9972f1);
$parcel$export(module.exports, "useAdoptedStyleSheetsWithBuiltCSS", () => $0189c8785d78b0c8$export$6b47557ba90d0c2c);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");

var $j19O3 = parcelRequire("j19O3");
const $0189c8785d78b0c8$export$9406b7fb9400ca6b = !window.ShadyDOM || !window.ShadyDOM.inUse;
const $0189c8785d78b0c8$export$a525d1c7f940d4a8 = Boolean(!window.ShadyCSS || window.ShadyCSS.nativeCss);
const $0189c8785d78b0c8$export$880c7e3550ba9df8 = !window.customElements.polyfillWrapFlushCallback;
const $0189c8785d78b0c8$export$b4d10f6001c083c2 = $0189c8785d78b0c8$export$9406b7fb9400ca6b && 'adoptedStyleSheets' in Document.prototype && 'replaceSync' in CSSStyleSheet.prototype && // Since spec may change, feature detect exact API we need
(()=>{
    try {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync('');
        const host = document.createElement('div');
        host.attachShadow({
            mode: 'open'
        });
        host.shadowRoot.adoptedStyleSheets = [
            sheet
        ];
        return host.shadowRoot.adoptedStyleSheets[0] === sheet;
    } catch (e) {
        return false;
    }
})();
let $0189c8785d78b0c8$export$2c2b629ee110b0c4 = window.Polymer && window.Polymer.rootPath || (0, $j19O3.pathFromUrl)(document.baseURI || window.location.href);
const $0189c8785d78b0c8$export$876f10a8c665d610 = function(path) {
    $0189c8785d78b0c8$export$2c2b629ee110b0c4 = path;
};
let $0189c8785d78b0c8$export$933597516e05b6ba = window.Polymer && window.Polymer.sanitizeDOMValue || undefined;
const $0189c8785d78b0c8$export$e0b7b0fbc8e01ba3 = function(newSanitizeDOMValue) {
    $0189c8785d78b0c8$export$933597516e05b6ba = newSanitizeDOMValue;
};
const $0189c8785d78b0c8$export$2e4daf56b1130fc5 = function() {
    return $0189c8785d78b0c8$export$933597516e05b6ba;
};
let $0189c8785d78b0c8$export$5e78708f712c4732 = window.Polymer && window.Polymer.setPassiveTouchGestures || false;
const $0189c8785d78b0c8$export$11916ac00f4f2cd1 = function(usePassive) {
    $0189c8785d78b0c8$export$5e78708f712c4732 = usePassive;
};
let $0189c8785d78b0c8$export$acf5a474bddac04e = window.Polymer && window.Polymer.strictTemplatePolicy || false;
const $0189c8785d78b0c8$export$349e1001b1305d1 = function(useStrictPolicy) {
    $0189c8785d78b0c8$export$acf5a474bddac04e = useStrictPolicy;
};
let $0189c8785d78b0c8$export$5ae065bca0989b14 = window.Polymer && window.Polymer.allowTemplateFromDomModule || false;
const $0189c8785d78b0c8$export$f0e74a0bd7a9f3c9 = function(allowDomModule) {
    $0189c8785d78b0c8$export$5ae065bca0989b14 = allowDomModule;
};
let $0189c8785d78b0c8$export$3c94433b141a5935 = window.Polymer && window.Polymer.legacyOptimizations || false;
const $0189c8785d78b0c8$export$ddeb80a4a9797c3b = function(useLegacyOptimizations) {
    $0189c8785d78b0c8$export$3c94433b141a5935 = useLegacyOptimizations;
};
let $0189c8785d78b0c8$export$72c298ba1c0d71ac = window.Polymer && window.Polymer.legacyWarnings || false;
const $0189c8785d78b0c8$export$8e8d227228b39835 = function(useLegacyWarnings) {
    $0189c8785d78b0c8$export$72c298ba1c0d71ac = useLegacyWarnings;
};
let $0189c8785d78b0c8$export$2dab853be0f46432 = window.Polymer && window.Polymer.syncInitialRender || false;
const $0189c8785d78b0c8$export$117f8256c4dc7277 = function(useSyncInitialRender) {
    $0189c8785d78b0c8$export$2dab853be0f46432 = useSyncInitialRender;
};
let $0189c8785d78b0c8$export$1b6b9baa82f69fe4 = window.Polymer && window.Polymer.legacyUndefined || false;
const $0189c8785d78b0c8$export$a06ae90fe5689c64 = function(useLegacyUndefined) {
    $0189c8785d78b0c8$export$1b6b9baa82f69fe4 = useLegacyUndefined;
};
let $0189c8785d78b0c8$export$f1157f27ba4ba240 = window.Polymer && window.Polymer.orderedComputed || false;
const $0189c8785d78b0c8$export$e7baba7bf813b172 = function(useOrderedComputed) {
    $0189c8785d78b0c8$export$f1157f27ba4ba240 = useOrderedComputed;
};
let $0189c8785d78b0c8$export$6f67f821d5faaed9 = true;
const $0189c8785d78b0c8$export$218251f5c49f5698 = function(useCancelSyntheticClickEvents) {
    $0189c8785d78b0c8$export$6f67f821d5faaed9 = useCancelSyntheticClickEvents;
};
let $0189c8785d78b0c8$export$c522adfce8f3fd9f = window.Polymer && window.Polymer.removeNestedTemplates || false;
const $0189c8785d78b0c8$export$c1bccd3a173f234b = function(useRemoveNestedTemplates) {
    $0189c8785d78b0c8$export$c522adfce8f3fd9f = useRemoveNestedTemplates;
};
let $0189c8785d78b0c8$export$29626a1dca9972f1 = window.Polymer && window.Polymer.fastDomIf || false;
const $0189c8785d78b0c8$export$133363100881ae53 = function(useFastDomIf) {
    $0189c8785d78b0c8$export$29626a1dca9972f1 = useFastDomIf;
};
let $0189c8785d78b0c8$export$a11cf105d91e2102 = window.Polymer && window.Polymer.suppressTemplateNotifications || false;
const $0189c8785d78b0c8$export$a68efaab17e3616d = function(suppress) {
    $0189c8785d78b0c8$export$a11cf105d91e2102 = suppress;
};
let $0189c8785d78b0c8$export$ffb029c44872e9db = window.Polymer && window.Polymer.legacyNoObservedAttributes || false;
const $0189c8785d78b0c8$export$2eca7935474be6cd = function(noObservedAttributes) {
    $0189c8785d78b0c8$export$ffb029c44872e9db = noObservedAttributes;
};
let $0189c8785d78b0c8$export$6b47557ba90d0c2c = window.Polymer && window.Polymer.useAdoptedStyleSheetsWithBuiltCSS || false;
const $0189c8785d78b0c8$export$d4145db4e54c8f75 = function(value) {
    $0189c8785d78b0c8$export$6b47557ba90d0c2c = value;
};

});
parcelRegister("j19O3", function(module, exports) {

$parcel$export(module.exports, "resolveUrl", () => $dd85b7a06a300b9d$export$f85c16a6d62f7d63);
$parcel$export(module.exports, "resolveCss", () => $dd85b7a06a300b9d$export$5e4a7063f4fe5655);
$parcel$export(module.exports, "pathFromUrl", () => $dd85b7a06a300b9d$export$4deb3fcda9bf83bf);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");
let $dd85b7a06a300b9d$var$CSS_URL_RX = /(url\()([^)]*)(\))/g;
let $dd85b7a06a300b9d$var$ABS_URL = /(^\/[^\/])|(^#)|(^[\w-\d]*:)/;
let $dd85b7a06a300b9d$var$workingURL;
let $dd85b7a06a300b9d$var$resolveDoc;
function $dd85b7a06a300b9d$export$f85c16a6d62f7d63(url, baseURI) {
    if (url && $dd85b7a06a300b9d$var$ABS_URL.test(url)) return url;
    if (url === '//') return url;
    // Lazy feature detection.
    if ($dd85b7a06a300b9d$var$workingURL === undefined) {
        $dd85b7a06a300b9d$var$workingURL = false;
        try {
            const u = new URL('b', 'http://a');
            u.pathname = 'c%20d';
            $dd85b7a06a300b9d$var$workingURL = u.href === 'http://a/c%20d';
        } catch (e) {
        // silently fail
        }
    }
    if (!baseURI) baseURI = document.baseURI || window.location.href;
    if ($dd85b7a06a300b9d$var$workingURL) try {
        return new URL(url, baseURI).href;
    } catch (e) {
        // Bad url or baseURI structure. Do not attempt to resolve.
        return url;
    }
    // Fallback to creating an anchor into a disconnected document.
    if (!$dd85b7a06a300b9d$var$resolveDoc) {
        $dd85b7a06a300b9d$var$resolveDoc = document.implementation.createHTMLDocument('temp');
        $dd85b7a06a300b9d$var$resolveDoc.base = $dd85b7a06a300b9d$var$resolveDoc.createElement('base');
        $dd85b7a06a300b9d$var$resolveDoc.head.appendChild($dd85b7a06a300b9d$var$resolveDoc.base);
        $dd85b7a06a300b9d$var$resolveDoc.anchor = $dd85b7a06a300b9d$var$resolveDoc.createElement('a');
        $dd85b7a06a300b9d$var$resolveDoc.body.appendChild($dd85b7a06a300b9d$var$resolveDoc.anchor);
    }
    $dd85b7a06a300b9d$var$resolveDoc.base.href = baseURI;
    $dd85b7a06a300b9d$var$resolveDoc.anchor.href = url;
    return $dd85b7a06a300b9d$var$resolveDoc.anchor.href || url;
}
function $dd85b7a06a300b9d$export$5e4a7063f4fe5655(cssText, baseURI) {
    return cssText.replace($dd85b7a06a300b9d$var$CSS_URL_RX, function(m, pre, url, post) {
        return pre + '\'' + $dd85b7a06a300b9d$export$f85c16a6d62f7d63(url.replace(/["']/g, ''), baseURI) + '\'' + post;
    });
}
function $dd85b7a06a300b9d$export$4deb3fcda9bf83bf(url) {
    return url.substring(0, url.lastIndexOf('/') + 1);
}

});


parcelRegister("gLdkK", function(module, exports) {

$parcel$export(module.exports, "dedupingMixin", () => $c33b60e92659e9e7$export$70650a0591802500);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");
// unique global id for deduping mixins.
let $c33b60e92659e9e7$var$dedupeId = 0;
/**
 * @constructor
 * @extends {Function}
 * @private
 */ function $c33b60e92659e9e7$var$MixinFunction() {}
/** @type {(WeakMap | undefined)} */ $c33b60e92659e9e7$var$MixinFunction.prototype.__mixinApplications;
/** @type {(Object | undefined)} */ $c33b60e92659e9e7$var$MixinFunction.prototype.__mixinSet;
const $c33b60e92659e9e7$export$70650a0591802500 = function(mixin) {
    let mixinApplications = /** @type {!MixinFunction} */ mixin.__mixinApplications;
    if (!mixinApplications) {
        mixinApplications = new WeakMap();
        /** @type {!MixinFunction} */ mixin.__mixinApplications = mixinApplications;
    }
    // maintain a unique id for each mixin
    let mixinDedupeId = $c33b60e92659e9e7$var$dedupeId++;
    function dedupingMixin(base) {
        let baseSet = /** @type {!MixinFunction} */ base.__mixinSet;
        if (baseSet && baseSet[mixinDedupeId]) return base;
        let map = mixinApplications;
        let extended = map.get(base);
        if (!extended) {
            extended = /** @type {!Function} */ mixin(base);
            map.set(base, extended);
            // copy inherited mixin set from the extended class, or the base class
            // NOTE: we avoid use of Set here because some browser (IE11)
            // cannot extend a base Set via the constructor.
            let mixinSet = Object.create(/** @type {!MixinFunction} */ extended.__mixinSet || baseSet || null);
            mixinSet[mixinDedupeId] = true;
            /** @type {!MixinFunction} */ extended.__mixinSet = mixinSet;
        }
        return extended;
    }
    return dedupingMixin;
}; /* eslint-enable valid-jsdoc */ 

});

parcelRegister("4RizA", function(module, exports) {

$parcel$export(module.exports, "stylesFromTemplate", () => $389a84d81e43804b$export$ef04dd434219bd72);
$parcel$export(module.exports, "stylesFromModuleImports", () => $389a84d81e43804b$export$6d26d522fc319ace);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /**
 * Module with utilities for collection CSS text from `<templates>`, external
 * stylesheets, and `dom-module`s.
 *
 * @summary Module with utilities for collection CSS text from various sources.
 */ 
var $c9zuV = parcelRequire("c9zuV");

var $j19O3 = parcelRequire("j19O3");
const $389a84d81e43804b$var$MODULE_STYLE_LINK_SELECTOR = 'link[rel=import][type~=css]';
const $389a84d81e43804b$var$INCLUDE_ATTR = 'include';
const $389a84d81e43804b$var$SHADY_UNSCOPED_ATTR = 'shady-unscoped';
/**
 * @param {string} moduleId .
 * @return {?DomModule} .
 */ function $389a84d81e43804b$var$importModule(moduleId) {
    return /** @type {?DomModule} */ (0, $c9zuV.DomModule).import(moduleId);
}
function $389a84d81e43804b$var$styleForImport(importDoc) {
    // NOTE: polyfill affordance.
    // under the HTMLImports polyfill, there will be no 'body',
    // but the import pseudo-doc can be used directly.
    let container = importDoc.body ? importDoc.body : importDoc;
    const importCss = (0, $j19O3.resolveCss)(container.textContent, importDoc.baseURI);
    const style = document.createElement('style');
    style.textContent = importCss;
    return style;
}
/** @typedef {{assetpath: string}} */ let $389a84d81e43804b$var$templateWithAssetPath; // eslint-disable-line no-unused-vars
function $389a84d81e43804b$export$7892cca1f4661ba5(moduleIds) {
    const modules = moduleIds.trim().split(/\s+/);
    const styles = [];
    for(let i = 0; i < modules.length; i++)styles.push(...$389a84d81e43804b$export$322040fecb2f2d65(modules[i]));
    return styles;
}
function $389a84d81e43804b$export$322040fecb2f2d65(moduleId) {
    const m = $389a84d81e43804b$var$importModule(moduleId);
    if (!m) {
        console.warn('Could not find style data in module named', moduleId);
        return [];
    }
    if (m._styles === undefined) {
        const styles = [];
        // module imports: <link rel="import" type="css">
        styles.push(...$389a84d81e43804b$var$_stylesFromModuleImports(m));
        // include css from the first template in the module
        const template = /** @type {?HTMLTemplateElement} */ m.querySelector('template');
        if (template) styles.push(...$389a84d81e43804b$export$ef04dd434219bd72(template, /** @type {templateWithAssetPath} */ m.assetpath));
        m._styles = styles;
    }
    return m._styles;
}
function $389a84d81e43804b$export$ef04dd434219bd72(template, baseURI) {
    if (!template._styles) {
        const styles = [];
        // if element is a template, get content from its .content
        const e$ = template.content.querySelectorAll('style');
        for(let i = 0; i < e$.length; i++){
            let e = e$[i];
            // support style sharing by allowing styles to "include"
            // other dom-modules that contain styling
            let include = e.getAttribute($389a84d81e43804b$var$INCLUDE_ATTR);
            if (include) styles.push(...$389a84d81e43804b$export$7892cca1f4661ba5(include).filter(function(item, index, self) {
                return self.indexOf(item) === index;
            }));
            if (baseURI) e.textContent = (0, $j19O3.resolveCss)(e.textContent, /** @type {string} */ baseURI);
            styles.push(e);
        }
        template._styles = styles;
    }
    return template._styles;
}
function $389a84d81e43804b$export$6d26d522fc319ace(moduleId) {
    let m = $389a84d81e43804b$var$importModule(moduleId);
    return m ? $389a84d81e43804b$var$_stylesFromModuleImports(m) : [];
}
/**
 * @param {!HTMLElement} module dom-module element that could contain `<link rel="import" type="css">` styles
 * @return {!Array<!HTMLStyleElement>} Array of contained styles
 */ function $389a84d81e43804b$var$_stylesFromModuleImports(module) {
    const styles = [];
    const p$ = module.querySelectorAll($389a84d81e43804b$var$MODULE_STYLE_LINK_SELECTOR);
    for(let i = 0; i < p$.length; i++){
        let p = p$[i];
        if (p.import) {
            const importDoc = p.import;
            const unscoped = p.hasAttribute($389a84d81e43804b$var$SHADY_UNSCOPED_ATTR);
            if (unscoped && !importDoc._unscopedStyle) {
                const style = $389a84d81e43804b$var$styleForImport(importDoc);
                style.setAttribute($389a84d81e43804b$var$SHADY_UNSCOPED_ATTR, '');
                importDoc._unscopedStyle = style;
            } else if (!importDoc._style) importDoc._style = $389a84d81e43804b$var$styleForImport(importDoc);
            styles.push(unscoped ? importDoc._unscopedStyle : importDoc._style);
        }
    }
    return styles;
}
function $389a84d81e43804b$export$f46bccbc9bbcbdb1(moduleIds) {
    let modules = moduleIds.trim().split(/\s+/);
    let cssText = '';
    for(let i = 0; i < modules.length; i++)cssText += $389a84d81e43804b$export$4f022a189641ad2d(modules[i]);
    return cssText;
}
function $389a84d81e43804b$export$4f022a189641ad2d(moduleId) {
    let m = $389a84d81e43804b$var$importModule(moduleId);
    if (m && m._cssText === undefined) {
        // module imports: <link rel="import" type="css">
        let cssText = $389a84d81e43804b$var$_cssFromModuleImports(m);
        // include css from the first template in the module
        let t = /** @type {?HTMLTemplateElement} */ m.querySelector('template');
        if (t) cssText += $389a84d81e43804b$export$e50c8e9c31fcb971(t, /** @type {templateWithAssetPath} */ m.assetpath);
        m._cssText = cssText || null;
    }
    if (!m) console.warn('Could not find style data in module named', moduleId);
    return m && m._cssText || '';
}
function $389a84d81e43804b$export$e50c8e9c31fcb971(template, baseURI) {
    let cssText = '';
    const e$ = $389a84d81e43804b$export$ef04dd434219bd72(template, baseURI);
    // if element is a template, get content from its .content
    for(let i = 0; i < e$.length; i++){
        let e = e$[i];
        if (e.parentNode) e.parentNode.removeChild(e);
        cssText += e.textContent;
    }
    return cssText;
}
function $389a84d81e43804b$export$6ab17f8ff3688e4a(moduleId) {
    let m = $389a84d81e43804b$var$importModule(moduleId);
    return m ? $389a84d81e43804b$var$_cssFromModuleImports(m) : '';
}
/**
 * @deprecated
 * @param {!HTMLElement} module dom-module element that could contain `<link rel="import" type="css">` styles
 * @return {string} Concatenated CSS content from links in the dom-module
 */ function $389a84d81e43804b$var$_cssFromModuleImports(module) {
    let cssText = '';
    let styles = $389a84d81e43804b$var$_stylesFromModuleImports(module);
    for(let i = 0; i < styles.length; i++)cssText += styles[i].textContent;
    return cssText;
}

});
parcelRegister("c9zuV", function(module, exports) {

$parcel$export(module.exports, "DomModule", () => $8d91dc70d4c48f7f$export$12f99acfce271a06);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");

var $j19O3 = parcelRequire("j19O3");

var $8bEdR = parcelRequire("8bEdR");
let $8d91dc70d4c48f7f$var$modules = {};
let $8d91dc70d4c48f7f$var$lcModules = {};
/**
 * Sets a dom-module into the global registry by id.
 *
 * @param {string} id dom-module id
 * @param {DomModule} module dom-module instance
 * @return {void}
 */ function $8d91dc70d4c48f7f$var$setModule(id, module) {
    // store id separate from lowercased id so that
    // in all cases mixedCase id will stored distinctly
    // and lowercase version is a fallback
    $8d91dc70d4c48f7f$var$modules[id] = $8d91dc70d4c48f7f$var$lcModules[id.toLowerCase()] = module;
}
/**
 * Retrieves a dom-module from the global registry by id.
 *
 * @param {string} id dom-module id
 * @return {DomModule!} dom-module instance
 */ function $8d91dc70d4c48f7f$var$findModule(id) {
    return $8d91dc70d4c48f7f$var$modules[id] || $8d91dc70d4c48f7f$var$lcModules[id.toLowerCase()];
}
function $8d91dc70d4c48f7f$var$styleOutsideTemplateCheck(inst) {
    if (inst.querySelector('style')) console.warn('dom-module %s has style outside template', inst.id);
}
class $8d91dc70d4c48f7f$export$12f99acfce271a06 extends HTMLElement {
    /** @override */ static get observedAttributes() {
        return [
            'id'
        ];
    }
    /**
   * Retrieves the element specified by the css `selector` in the module
   * registered by `id`. For example, this.import('foo', 'img');
   * @param {string} id The id of the dom-module in which to search.
   * @param {string=} selector The css selector by which to find the element.
   * @return {Element} Returns the element which matches `selector` in the
   * module registered at the specified `id`.
   *
   * @export
   * @nocollapse Referred to indirectly in style-gather.js
   */ static import(id, selector) {
        if (id) {
            let m = $8d91dc70d4c48f7f$var$findModule(id);
            if (m && selector) return m.querySelector(selector);
            return m;
        }
        return null;
    }
    /* eslint-disable no-unused-vars */ /**
   * @param {string} name Name of attribute.
   * @param {?string} old Old value of attribute.
   * @param {?string} value Current value of attribute.
   * @param {?string} namespace Attribute namespace.
   * @return {void}
   * @override
   */ attributeChangedCallback(name, old, value, namespace) {
        if (old !== value) this.register();
    }
    /* eslint-enable no-unused-args */ /**
   * The absolute URL of the original location of this `dom-module`.
   *
   * This value will differ from this element's `ownerDocument` in the
   * following ways:
   * - Takes into account any `assetpath` attribute added during bundling
   *   to indicate the original location relative to the bundled location
   * - Uses the HTMLImports polyfill's `importForElement` API to ensure
   *   the path is relative to the import document's location since
   *   `ownerDocument` is not currently polyfilled
   */ get assetpath() {
        // Don't override existing assetpath.
        if (!this.__assetpath) {
            // note: assetpath set via an attribute must be relative to this
            // element's location; accommodate polyfilled HTMLImports
            const owner = window.HTMLImports && HTMLImports.importForElement ? HTMLImports.importForElement(this) || document : this.ownerDocument;
            const url = (0, $j19O3.resolveUrl)(this.getAttribute('assetpath') || '', owner.baseURI);
            this.__assetpath = (0, $j19O3.pathFromUrl)(url);
        }
        return this.__assetpath;
    }
    /**
   * Registers the dom-module at a given id. This method should only be called
   * when a dom-module is imperatively created. For
   * example, `document.createElement('dom-module').register('foo')`.
   * @param {string=} id The id at which to register the dom-module.
   * @return {void}
   */ register(id) {
        id = id || this.id;
        if (id) {
            // Under strictTemplatePolicy, reject and null out any re-registered
            // dom-module since it is ambiguous whether first-in or last-in is trusted
            if ((0, $8bEdR.strictTemplatePolicy) && $8d91dc70d4c48f7f$var$findModule(id) !== undefined) {
                $8d91dc70d4c48f7f$var$setModule(id, null);
                throw new Error(`strictTemplatePolicy: dom-module ${id} re-registered`);
            }
            this.id = id;
            $8d91dc70d4c48f7f$var$setModule(id, this);
            $8d91dc70d4c48f7f$var$styleOutsideTemplateCheck(this);
        }
    }
}
$8d91dc70d4c48f7f$export$12f99acfce271a06.prototype['modules'] = $8d91dc70d4c48f7f$var$modules;
customElements.define('dom-module', $8d91dc70d4c48f7f$export$12f99acfce271a06);

});


parcelRegister("2njbg", function(module, exports) {

$parcel$export(module.exports, "PropertyEffects", () => $1bac9b9e38435dd2$export$5bc04800afa346a0);
/**
 * @fileoverview
 * @suppress {checkPrototypalTypes}
 * @license Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */ parcelRequire("dMwQI");

var $a2HIe = parcelRequire("a2HIe");

var $gLdkK = parcelRequire("gLdkK");

var $kt4XD = parcelRequire("kt4XD");

var $dMJbi = parcelRequire("dMJbi");

var $4Oamu = parcelRequire("4Oamu");

var $jBFgP = parcelRequire("jBFgP");

var $8bEdR = parcelRequire("8bEdR");
// Monotonically increasing unique ID used for de-duping effects triggered
// from multiple properties in the same turn
let $1bac9b9e38435dd2$var$dedupeId = 0;
const $1bac9b9e38435dd2$var$NOOP = [];
/**
 * Property effect types; effects are stored on the prototype using these keys
 * @enum {string}
 */ const $1bac9b9e38435dd2$var$TYPES = {
    COMPUTE: '__computeEffects',
    REFLECT: '__reflectEffects',
    NOTIFY: '__notifyEffects',
    PROPAGATE: '__propagateEffects',
    OBSERVE: '__observeEffects',
    READ_ONLY: '__readOnly'
};
const $1bac9b9e38435dd2$var$COMPUTE_INFO = '__computeInfo';
/** @const {!RegExp} */ const $1bac9b9e38435dd2$var$capitalAttributeRegex = /[A-Z]/;
/**
 * @typedef {{
 * name: (string | undefined),
 * structured: (boolean | undefined),
 * wildcard: (boolean | undefined)
 * }}
 */ let $1bac9b9e38435dd2$var$DataTrigger; //eslint-disable-line no-unused-vars
/**
 * @typedef {{
 * info: ?,
 * trigger: (!DataTrigger | undefined),
 * fn: (!Function | undefined)
 * }}
 */ let $1bac9b9e38435dd2$var$DataEffect; //eslint-disable-line no-unused-vars
/**
 * Ensures that the model has an own-property map of effects for the given type.
 * The model may be a prototype or an instance.
 *
 * Property effects are stored as arrays of effects by property in a map,
 * by named type on the model. e.g.
 *
 *   __computeEffects: {
 *     foo: [ ... ],
 *     bar: [ ... ]
 *   }
 *
 * If the model does not yet have an effect map for the type, one is created
 * and returned.  If it does, but it is not an own property (i.e. the
 * prototype had effects), the the map is deeply cloned and the copy is
 * set on the model and returned, ready for new effects to be added.
 *
 * @param {Object} model Prototype or instance
 * @param {string} type Property effect type
 * @param {boolean=} cloneArrays Clone any arrays assigned to the map when
 *   extending a superclass map onto this subclass
 * @return {Object} The own-property map of effects for the given type
 * @private
 */ function $1bac9b9e38435dd2$var$ensureOwnEffectMap(model, type, cloneArrays) {
    let effects = model[type];
    if (!effects) effects = model[type] = {};
    else if (!model.hasOwnProperty(type)) {
        effects = model[type] = Object.create(model[type]);
        if (cloneArrays) for(let p in effects){
            let protoFx = effects[p];
            // Perf optimization over Array.slice
            let instFx = effects[p] = Array(protoFx.length);
            for(let i = 0; i < protoFx.length; i++)instFx[i] = protoFx[i];
        }
    }
    return effects;
}
// -- effects ----------------------------------------------
/**
 * Runs all effects of a given type for the given set of property changes
 * on an instance.
 *
 * @param {!Polymer_PropertyEffects} inst The instance with effects to run
 * @param {?Object} effects Object map of property-to-Array of effects
 * @param {?Object} props Bag of current property changes
 * @param {?Object=} oldProps Bag of previous values for changed properties
 * @param {boolean=} hasPaths True with `props` contains one or more paths
 * @param {*=} extraArgs Additional metadata to pass to effect function
 * @return {boolean} True if an effect ran for this property
 * @private
 */ function $1bac9b9e38435dd2$var$runEffects(inst, effects, props, oldProps, hasPaths, extraArgs) {
    if (effects) {
        let ran = false;
        const id = $1bac9b9e38435dd2$var$dedupeId++;
        for(let prop in props){
            // Inline `runEffectsForProperty` for perf.
            let rootProperty = hasPaths ? (0, $kt4XD.root)(prop) : prop;
            let fxs = effects[rootProperty];
            if (fxs) {
                for(let i = 0, l = fxs.length, fx; i < l && (fx = fxs[i]); i++)if ((!fx.info || fx.info.lastRun !== id) && (!hasPaths || $1bac9b9e38435dd2$var$pathMatchesTrigger(prop, fx.trigger))) {
                    if (fx.info) fx.info.lastRun = id;
                    fx.fn(inst, prop, props, oldProps, fx.info, hasPaths, extraArgs);
                    ran = true;
                }
            }
        }
        return ran;
    }
    return false;
}
/**
 * Runs a list of effects for a given property.
 *
 * @param {!Polymer_PropertyEffects} inst The instance with effects to run
 * @param {!Object} effects Object map of property-to-Array of effects
 * @param {number} dedupeId Counter used for de-duping effects
 * @param {string} prop Name of changed property
 * @param {*} props Changed properties
 * @param {*} oldProps Old properties
 * @param {boolean=} hasPaths True with `props` contains one or more paths
 * @param {*=} extraArgs Additional metadata to pass to effect function
 * @return {boolean} True if an effect ran for this property
 * @private
 */ function $1bac9b9e38435dd2$var$runEffectsForProperty(inst, effects, dedupeId, prop, props, oldProps, hasPaths, extraArgs) {
    let ran = false;
    let rootProperty = hasPaths ? (0, $kt4XD.root)(prop) : prop;
    let fxs = effects[rootProperty];
    if (fxs) {
        for(let i = 0, l = fxs.length, fx; i < l && (fx = fxs[i]); i++)if ((!fx.info || fx.info.lastRun !== dedupeId) && (!hasPaths || $1bac9b9e38435dd2$var$pathMatchesTrigger(prop, fx.trigger))) {
            if (fx.info) fx.info.lastRun = dedupeId;
            fx.fn(inst, prop, props, oldProps, fx.info, hasPaths, extraArgs);
            ran = true;
        }
    }
    return ran;
}
/**
 * Determines whether a property/path that has changed matches the trigger
 * criteria for an effect.  A trigger is a descriptor with the following
 * structure, which matches the descriptors returned from `parseArg`.
 * e.g. for `foo.bar.*`:
 * ```
 * trigger: {
 *   name: 'a.b',
 *   structured: true,
 *   wildcard: true
 * }
 * ```
 * If no trigger is given, the path is deemed to match.
 *
 * @param {string} path Path or property that changed
 * @param {?DataTrigger} trigger Descriptor
 * @return {boolean} Whether the path matched the trigger
 */ function $1bac9b9e38435dd2$var$pathMatchesTrigger(path, trigger) {
    if (trigger) {
        let triggerPath = /** @type {string} */ trigger.name;
        return triggerPath == path || !!(trigger.structured && (0, $kt4XD.isAncestor)(triggerPath, path)) || !!(trigger.wildcard && (0, $kt4XD.isDescendant)(triggerPath, path));
    } else return true;
}
/**
 * Implements the "observer" effect.
 *
 * Calls the method with `info.methodName` on the instance, passing the
 * new and old values.
 *
 * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
 * @param {string} property Name of property
 * @param {Object} props Bag of current property changes
 * @param {Object} oldProps Bag of previous values for changed properties
 * @param {?} info Effect metadata
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$runObserverEffect(inst, property, props, oldProps, info) {
    let fn = typeof info.method === "string" ? inst[info.method] : info.method;
    let changedProp = info.property;
    if (fn) fn.call(inst, inst.__data[changedProp], oldProps[changedProp]);
    else if (!info.dynamicFn) console.warn('observer method `' + info.method + '` not defined');
}
/**
 * Runs "notify" effects for a set of changed properties.
 *
 * This method differs from the generic `runEffects` method in that it
 * will dispatch path notification events in the case that the property
 * changed was a path and the root property for that path didn't have a
 * "notify" effect.  This is to maintain 1.0 behavior that did not require
 * `notify: true` to ensure object sub-property notifications were
 * sent.
 *
 * @param {!Polymer_PropertyEffects} inst The instance with effects to run
 * @param {Object} notifyProps Bag of properties to notify
 * @param {Object} props Bag of current property changes
 * @param {Object} oldProps Bag of previous values for changed properties
 * @param {boolean} hasPaths True with `props` contains one or more paths
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$runNotifyEffects(inst, notifyProps, props, oldProps, hasPaths) {
    // Notify
    let fxs = inst[$1bac9b9e38435dd2$var$TYPES.NOTIFY];
    let notified;
    let id = $1bac9b9e38435dd2$var$dedupeId++;
    // Try normal notify effects; if none, fall back to try path notification
    for(let prop in notifyProps)if (notifyProps[prop]) {
        if (fxs && $1bac9b9e38435dd2$var$runEffectsForProperty(inst, fxs, id, prop, props, oldProps, hasPaths)) notified = true;
        else if (hasPaths && $1bac9b9e38435dd2$var$notifyPath(inst, prop, props)) notified = true;
    }
    // Flush host if we actually notified and host was batching
    // And the host has already initialized clients; this prevents
    // an issue with a host observing data changes before clients are ready.
    let host;
    if (notified && (host = inst.__dataHost) && host._invalidateProperties) host._invalidateProperties();
}
/**
 * Dispatches {property}-changed events with path information in the detail
 * object to indicate a sub-path of the property was changed.
 *
 * @param {!Polymer_PropertyEffects} inst The element from which to fire the
 *     event
 * @param {string} path The path that was changed
 * @param {Object} props Bag of current property changes
 * @return {boolean} Returns true if the path was notified
 * @private
 */ function $1bac9b9e38435dd2$var$notifyPath(inst, path, props) {
    let rootProperty = (0, $kt4XD.root)(path);
    if (rootProperty !== path) {
        let eventName = (0, $dMJbi.camelToDashCase)(rootProperty) + '-changed';
        $1bac9b9e38435dd2$var$dispatchNotifyEvent(inst, eventName, props[path], path);
        return true;
    }
    return false;
}
/**
 * Dispatches {property}-changed events to indicate a property (or path)
 * changed.
 *
 * @param {!Polymer_PropertyEffects} inst The element from which to fire the
 *     event
 * @param {string} eventName The name of the event to send
 *     ('{property}-changed')
 * @param {*} value The value of the changed property
 * @param {string | null | undefined} path If a sub-path of this property
 *     changed, the path that changed (optional).
 * @return {void}
 * @private
 * @suppress {invalidCasts}
 */ function $1bac9b9e38435dd2$var$dispatchNotifyEvent(inst, eventName, value, path) {
    let detail = {
        value: value,
        queueProperty: true
    };
    if (path) detail.path = path;
    // As a performance optimization, we could elide the wrap here since notifying
    // events are non-bubbling and shouldn't need retargeting. However, a very
    // small number of internal tests failed in obscure ways, which may indicate
    // user code relied on timing differences resulting from ShadyDOM flushing
    // as a result of the wrapped `dispatchEvent`.
    (0, $a2HIe.wrap)(/** @type {!HTMLElement} */ inst).dispatchEvent(new CustomEvent(eventName, {
        detail: detail
    }));
}
/**
 * Implements the "notify" effect.
 *
 * Dispatches a non-bubbling event named `info.eventName` on the instance
 * with a detail object containing the new `value`.
 *
 * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
 * @param {string} property Name of property
 * @param {Object} props Bag of current property changes
 * @param {Object} oldProps Bag of previous values for changed properties
 * @param {?} info Effect metadata
 * @param {boolean} hasPaths True with `props` contains one or more paths
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$runNotifyEffect(inst, property, props, oldProps, info, hasPaths) {
    let rootProperty = hasPaths ? (0, $kt4XD.root)(property) : property;
    let path = rootProperty != property ? property : null;
    let value = path ? (0, $kt4XD.get)(inst, path) : inst.__data[property];
    if (path && value === undefined) value = props[property]; // specifically for .splices
    $1bac9b9e38435dd2$var$dispatchNotifyEvent(inst, info.eventName, value, path);
}
/**
 * Handler function for 2-way notification events. Receives context
 * information captured in the `addNotifyListener` closure from the
 * `__notifyListeners` metadata.
 *
 * Sets the value of the notified property to the host property or path.  If
 * the event contained path information, translate that path to the host
 * scope's name for that path first.
 *
 * @param {CustomEvent} event Notification event (e.g. '<property>-changed')
 * @param {!Polymer_PropertyEffects} inst Host element instance handling the
 *     notification event
 * @param {string} fromProp Child element property that was bound
 * @param {string} toPath Host property/path that was bound
 * @param {boolean} negate Whether the binding was negated
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$handleNotification(event, inst, fromProp, toPath, negate) {
    let value;
    let detail = /** @type {Object} */ event.detail;
    let fromPath = detail && detail.path;
    if (fromPath) {
        toPath = (0, $kt4XD.translate)(fromProp, toPath, fromPath);
        value = detail && detail.value;
    } else value = event.currentTarget[fromProp];
    value = negate ? !value : value;
    if (!inst[$1bac9b9e38435dd2$var$TYPES.READ_ONLY] || !inst[$1bac9b9e38435dd2$var$TYPES.READ_ONLY][toPath]) {
        if (inst._setPendingPropertyOrPath(toPath, value, true, Boolean(fromPath)) && (!detail || !detail.queueProperty)) inst._invalidateProperties();
    }
}
/**
 * Implements the "reflect" effect.
 *
 * Sets the attribute named `info.attrName` to the given property value.
 *
 * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
 * @param {string} property Name of property
 * @param {Object} props Bag of current property changes
 * @param {Object} oldProps Bag of previous values for changed properties
 * @param {?} info Effect metadata
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$runReflectEffect(inst, property, props, oldProps, info) {
    let value = inst.__data[property];
    if (0, $8bEdR.sanitizeDOMValue) value = (0, $8bEdR.sanitizeDOMValue)(value, info.attrName, 'attribute', /** @type {Node} */ inst);
    inst._propertyToAttribute(property, info.attrName, value);
}
/**
 * Runs "computed" effects for a set of changed properties.
 *
 * This method differs from the generic `runEffects` method in that it
 * continues to run computed effects based on the output of each pass until
 * there are no more newly computed properties.  This ensures that all
 * properties that will be computed by the initial set of changes are
 * computed before other effects (binding propagation, observers, and notify)
 * run.
 *
 * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
 * @param {?Object} changedProps Bag of changed properties
 * @param {?Object} oldProps Bag of previous values for changed properties
 * @param {boolean} hasPaths True with `props` contains one or more paths
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$runComputedEffects(inst, changedProps, oldProps, hasPaths) {
    let computeEffects = inst[$1bac9b9e38435dd2$var$TYPES.COMPUTE];
    if (computeEffects) {
        if (0, $8bEdR.orderedComputed) {
            // Runs computed effects in efficient order by keeping a topologically-
            // sorted queue of compute effects to run, and inserting subsequently
            // invalidated effects as they are run
            $1bac9b9e38435dd2$var$dedupeId++;
            const order = $1bac9b9e38435dd2$var$getComputedOrder(inst);
            const queue = [];
            for(let p in changedProps)$1bac9b9e38435dd2$var$enqueueEffectsFor(p, computeEffects, queue, order, hasPaths);
            let info;
            while(info = queue.shift())if ($1bac9b9e38435dd2$var$runComputedEffect(inst, '', changedProps, oldProps, info)) $1bac9b9e38435dd2$var$enqueueEffectsFor(info.methodInfo, computeEffects, queue, order, hasPaths);
            Object.assign(/** @type {!Object} */ oldProps, inst.__dataOld);
            Object.assign(/** @type {!Object} */ changedProps, inst.__dataPending);
            inst.__dataPending = null;
        } else {
            // Original Polymer 2.x computed effects order, which continues running
            // effects until no further computed properties have been invalidated
            let inputProps = changedProps;
            while($1bac9b9e38435dd2$var$runEffects(inst, computeEffects, inputProps, oldProps, hasPaths)){
                Object.assign(/** @type {!Object} */ oldProps, inst.__dataOld);
                Object.assign(/** @type {!Object} */ changedProps, inst.__dataPending);
                inputProps = inst.__dataPending;
                inst.__dataPending = null;
            }
        }
    }
}
/**
 * Inserts a computed effect into a queue, given the specified order. Performs
 * the insert using a binary search.
 *
 * Used by `orderedComputed: true` computed property algorithm.
 *
 * @param {Object} info Property effects metadata
 * @param {Array<Object>} queue Ordered queue of effects
 * @param {Map<string,number>} order Map of computed property name->topological
 *   sort order
 */ const $1bac9b9e38435dd2$var$insertEffect = (info, queue, order)=>{
    let start = 0;
    let end = queue.length - 1;
    let idx = -1;
    while(start <= end){
        const mid = start + end >> 1;
        // Note `methodInfo` is where the computed property name is stored in
        // the effect metadata
        const cmp = order.get(queue[mid].methodInfo) - order.get(info.methodInfo);
        if (cmp < 0) start = mid + 1;
        else if (cmp > 0) end = mid - 1;
        else {
            idx = mid;
            break;
        }
    }
    if (idx < 0) idx = end + 1;
    queue.splice(idx, 0, info);
};
/**
 * Inserts all downstream computed effects invalidated by the specified property
 * into the topologically-sorted queue of effects to be run.
 *
 * Used by `orderedComputed: true` computed property algorithm.
 *
 * @param {string} prop Property name
 * @param {Object} computeEffects Computed effects for this element
 * @param {Array<Object>} queue Topologically-sorted queue of computed effects
 *   to be run
 * @param {Map<string,number>} order Map of computed property name->topological
 *   sort order
 * @param {boolean} hasPaths True with `changedProps` contains one or more paths
 */ const $1bac9b9e38435dd2$var$enqueueEffectsFor = (prop, computeEffects, queue, order, hasPaths)=>{
    const rootProperty = hasPaths ? (0, $kt4XD.root)(prop) : prop;
    const fxs = computeEffects[rootProperty];
    if (fxs) for(let i = 0; i < fxs.length; i++){
        const fx = fxs[i];
        if (fx.info.lastRun !== $1bac9b9e38435dd2$var$dedupeId && (!hasPaths || $1bac9b9e38435dd2$var$pathMatchesTrigger(prop, fx.trigger))) {
            fx.info.lastRun = $1bac9b9e38435dd2$var$dedupeId;
            $1bac9b9e38435dd2$var$insertEffect(fx.info, queue, order);
        }
    }
};
/**
 * Generates and retrieves a memoized map of computed property name to its
 * topologically-sorted order.
 *
 * The map is generated by first assigning a "dependency count" to each property
 * (defined as number properties it depends on, including its method for
 * "dynamic functions"). Any properties that have no dependencies are added to
 * the `ready` queue, which are properties whose order can be added to the final
 * order map. Properties are popped off the `ready` queue one by one and a.) added as
 * the next property in the order map, and b.) each property that it is a
 * dependency for has its dep count decremented (and if that property's dep
 * count goes to zero, it is added to the `ready` queue), until all properties
 * have been visited and ordered.
 *
 * Used by `orderedComputed: true` computed property algorithm.
 *
 * @param {!Polymer_PropertyEffects} inst The instance to retrieve the computed
 *   effect order for.
 * @return {Map<string,number>} Map of computed property name->topological sort
 *   order
 */ function $1bac9b9e38435dd2$var$getComputedOrder(inst) {
    let ordered = inst.constructor.__orderedComputedDeps;
    if (!ordered) {
        ordered = new Map();
        const effects = inst[$1bac9b9e38435dd2$var$TYPES.COMPUTE];
        let { counts: counts, ready: ready, total: total } = $1bac9b9e38435dd2$var$dependencyCounts(inst);
        let curr;
        while(curr = ready.shift()){
            ordered.set(curr, ordered.size);
            const computedByCurr = effects[curr];
            if (computedByCurr) computedByCurr.forEach((fx)=>{
                // Note `methodInfo` is where the computed property name is stored
                const computedProp = fx.info.methodInfo;
                --total;
                if (--counts[computedProp] === 0) ready.push(computedProp);
            });
        }
        if (total !== 0) {
            const el = /** @type {HTMLElement} */ inst;
            console.warn(`Computed graph for ${el.localName} incomplete; circular?`);
        }
        inst.constructor.__orderedComputedDeps = ordered;
    }
    return ordered;
}
/**
 * Generates a map of property-to-dependency count (`counts`, where "dependency
 * count" is the number of dependencies a given property has assuming it is a
 * computed property, otherwise 0).  It also returns a pre-populated list of
 * `ready` properties that have no dependencies and a `total` count, which is
 * used for error-checking the graph.
 *
 * Used by `orderedComputed: true` computed property algorithm.
 *
 * @param {!Polymer_PropertyEffects} inst The instance to generate dependency
 *   counts for.
 * @return {!Object} Object containing `counts` map (property-to-dependency
 *   count) and pre-populated `ready` array of properties that had zero
 *   dependencies.
 */ function $1bac9b9e38435dd2$var$dependencyCounts(inst) {
    const infoForComputed = inst[$1bac9b9e38435dd2$var$COMPUTE_INFO];
    const counts = {};
    const computedDeps = inst[$1bac9b9e38435dd2$var$TYPES.COMPUTE];
    const ready = [];
    let total = 0;
    // Count dependencies for each computed property
    for(let p in infoForComputed){
        const info = infoForComputed[p];
        // Be sure to add the method name itself in case of "dynamic functions"
        total += counts[p] = info.args.filter((a)=>!a.literal).length + (info.dynamicFn ? 1 : 0);
    }
    // Build list of ready properties (that aren't themselves computed)
    for(let p in computedDeps)if (!infoForComputed[p]) ready.push(p);
    return {
        counts: counts,
        ready: ready,
        total: total
    };
}
/**
 * Implements the "computed property" effect by running the method with the
 * values of the arguments specified in the `info` object and setting the
 * return value to the computed property specified.
 *
 * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
 * @param {string} property Name of property
 * @param {?Object} changedProps Bag of current property changes
 * @param {?Object} oldProps Bag of previous values for changed properties
 * @param {?} info Effect metadata
 * @return {boolean} True when the property being computed changed
 * @private
 */ function $1bac9b9e38435dd2$var$runComputedEffect(inst, property, changedProps, oldProps, info) {
    // Dirty check dependencies and run if any invalid
    let result = $1bac9b9e38435dd2$var$runMethodEffect(inst, property, changedProps, oldProps, info);
    // Abort if method returns a no-op result
    if (result === $1bac9b9e38435dd2$var$NOOP) return false;
    let computedProp = info.methodInfo;
    if (inst.__dataHasAccessor && inst.__dataHasAccessor[computedProp]) return inst._setPendingProperty(computedProp, result, true);
    else {
        inst[computedProp] = result;
        return false;
    }
}
/**
 * Computes path changes based on path links set up using the `linkPaths`
 * API.
 *
 * @param {!Polymer_PropertyEffects} inst The instance whose props are changing
 * @param {string} path Path that has changed
 * @param {*} value Value of changed path
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$computeLinkedPaths(inst, path, value) {
    let links = inst.__dataLinkedPaths;
    if (links) {
        let link;
        for(let a in links){
            let b = links[a];
            if ((0, $kt4XD.isDescendant)(a, path)) {
                link = (0, $kt4XD.translate)(a, b, path);
                inst._setPendingPropertyOrPath(link, value, true, true);
            } else if ((0, $kt4XD.isDescendant)(b, path)) {
                link = (0, $kt4XD.translate)(b, a, path);
                inst._setPendingPropertyOrPath(link, value, true, true);
            }
        }
    }
}
// -- bindings ----------------------------------------------
/**
 * Adds binding metadata to the current `nodeInfo`, and binding effects
 * for all part dependencies to `templateInfo`.
 *
 * @param {Function} constructor Class that `_parseTemplate` is currently
 *   running on
 * @param {TemplateInfo} templateInfo Template metadata for current template
 * @param {NodeInfo} nodeInfo Node metadata for current template node
 * @param {string} kind Binding kind, either 'property', 'attribute', or 'text'
 * @param {string} target Target property name
 * @param {!Array<!BindingPart>} parts Array of binding part metadata
 * @param {string=} literal Literal text surrounding binding parts (specified
 *   only for 'property' bindings, since these must be initialized as part
 *   of boot-up)
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$addBinding(constructor, templateInfo, nodeInfo, kind, target, parts, literal) {
    // Create binding metadata and add to nodeInfo
    nodeInfo.bindings = nodeInfo.bindings || [];
    let /** Binding */ binding = {
        kind: kind,
        target: target,
        parts: parts,
        literal: literal,
        isCompound: parts.length !== 1
    };
    nodeInfo.bindings.push(binding);
    // Add listener info to binding metadata
    if ($1bac9b9e38435dd2$var$shouldAddListener(binding)) {
        let { event: event, negate: negate } = binding.parts[0];
        binding.listenerEvent = event || (0, $dMJbi.camelToDashCase)(target) + '-changed';
        binding.listenerNegate = negate;
    }
    // Add "propagate" property effects to templateInfo
    let index = templateInfo.nodeInfoList.length;
    for(let i = 0; i < binding.parts.length; i++){
        let part = binding.parts[i];
        part.compoundIndex = i;
        $1bac9b9e38435dd2$var$addEffectForBindingPart(constructor, templateInfo, binding, part, index);
    }
}
/**
 * Adds property effects to the given `templateInfo` for the given binding
 * part.
 *
 * @param {Function} constructor Class that `_parseTemplate` is currently
 *   running on
 * @param {TemplateInfo} templateInfo Template metadata for current template
 * @param {!Binding} binding Binding metadata
 * @param {!BindingPart} part Binding part metadata
 * @param {number} index Index into `nodeInfoList` for this node
 * @return {void}
 */ function $1bac9b9e38435dd2$var$addEffectForBindingPart(constructor, templateInfo, binding, part, index) {
    if (!part.literal) {
        if (binding.kind === 'attribute' && binding.target[0] === '-') console.warn('Cannot set attribute ' + binding.target + ' because "-" is not a valid attribute starting character');
        else {
            let dependencies = part.dependencies;
            let info = {
                index: index,
                binding: binding,
                part: part,
                evaluator: constructor
            };
            for(let j = 0; j < dependencies.length; j++){
                let trigger = dependencies[j];
                if (typeof trigger == 'string') {
                    trigger = $1bac9b9e38435dd2$var$parseArg(trigger);
                    trigger.wildcard = true;
                }
                constructor._addTemplatePropertyEffect(templateInfo, trigger.rootProperty, {
                    fn: $1bac9b9e38435dd2$var$runBindingEffect,
                    info: info,
                    trigger: trigger
                });
            }
        }
    }
}
/**
 * Implements the "binding" (property/path binding) effect.
 *
 * Note that binding syntax is overridable via `_parseBindings` and
 * `_evaluateBinding`.  This method will call `_evaluateBinding` for any
 * non-literal parts returned from `_parseBindings`.  However,
 * there is no support for _path_ bindings via custom binding parts,
 * as this is specific to Polymer's path binding syntax.
 *
 * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
 * @param {string} path Name of property
 * @param {Object} props Bag of current property changes
 * @param {Object} oldProps Bag of previous values for changed properties
 * @param {?} info Effect metadata
 * @param {boolean} hasPaths True with `props` contains one or more paths
 * @param {Array} nodeList List of nodes associated with `nodeInfoList` template
 *   metadata
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$runBindingEffect(inst, path, props, oldProps, info, hasPaths, nodeList) {
    let node = nodeList[info.index];
    let binding = info.binding;
    let part = info.part;
    // Subpath notification: transform path and set to client
    // e.g.: foo="{{obj.sub}}", path: 'obj.sub.prop', set 'foo.prop'=obj.sub.prop
    if (hasPaths && part.source && path.length > part.source.length && binding.kind == 'property' && !binding.isCompound && node.__isPropertyEffectsClient && node.__dataHasAccessor && node.__dataHasAccessor[binding.target]) {
        let value = props[path];
        path = (0, $kt4XD.translate)(part.source, binding.target, path);
        if (node._setPendingPropertyOrPath(path, value, false, true)) inst._enqueueClient(node);
    } else {
        let value = info.evaluator._evaluateBinding(inst, part, path, props, oldProps, hasPaths);
        // Propagate value to child
        // Abort if value is a no-op result
        if (value !== $1bac9b9e38435dd2$var$NOOP) $1bac9b9e38435dd2$var$applyBindingValue(inst, node, binding, part, value);
    }
}
/**
 * Sets the value for an "binding" (binding) effect to a node,
 * either as a property or attribute.
 *
 * @param {!Polymer_PropertyEffects} inst The instance owning the binding effect
 * @param {Node} node Target node for binding
 * @param {!Binding} binding Binding metadata
 * @param {!BindingPart} part Binding part metadata
 * @param {*} value Value to set
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$applyBindingValue(inst, node, binding, part, value) {
    value = $1bac9b9e38435dd2$var$computeBindingValue(node, value, binding, part);
    if (0, $8bEdR.sanitizeDOMValue) value = (0, $8bEdR.sanitizeDOMValue)(value, binding.target, binding.kind, node);
    if (binding.kind == 'attribute') // Attribute binding
    inst._valueToNodeAttribute(/** @type {Element} */ node, value, binding.target);
    else {
        // Property binding
        let prop = binding.target;
        if (node.__isPropertyEffectsClient && node.__dataHasAccessor && node.__dataHasAccessor[prop]) {
            if (!node[$1bac9b9e38435dd2$var$TYPES.READ_ONLY] || !node[$1bac9b9e38435dd2$var$TYPES.READ_ONLY][prop]) {
                if (node._setPendingProperty(prop, value)) inst._enqueueClient(node);
            }
        } else // In legacy no-batching mode, bindings applied before dataReady are
        // equivalent to the "apply config" phase, which only set managed props
        inst._setUnmanagedPropertyToNode(node, prop, value);
    }
}
/**
 * Transforms an "binding" effect value based on compound & negation
 * effect metadata, as well as handling for special-case properties
 *
 * @param {Node} node Node the value will be set to
 * @param {*} value Value to set
 * @param {!Binding} binding Binding metadata
 * @param {!BindingPart} part Binding part metadata
 * @return {*} Transformed value to set
 * @private
 */ function $1bac9b9e38435dd2$var$computeBindingValue(node, value, binding, part) {
    if (binding.isCompound) {
        let storage = node.__dataCompoundStorage[binding.target];
        storage[part.compoundIndex] = value;
        value = storage.join('');
    }
    if (binding.kind !== 'attribute') // Some browsers serialize `undefined` to `"undefined"`
    {
        if (binding.target === 'textContent' || binding.target === 'value' && (node.localName === 'input' || node.localName === 'textarea')) value = value == undefined ? '' : value;
    }
    return value;
}
/**
 * Returns true if a binding's metadata meets all the requirements to allow
 * 2-way binding, and therefore a `<property>-changed` event listener should be
 * added:
 * - used curly braces
 * - is a property (not attribute) binding
 * - is not a textContent binding
 * - is not compound
 *
 * @param {!Binding} binding Binding metadata
 * @return {boolean} True if 2-way listener should be added
 * @private
 */ function $1bac9b9e38435dd2$var$shouldAddListener(binding) {
    return Boolean(binding.target) && binding.kind != 'attribute' && binding.kind != 'text' && !binding.isCompound && binding.parts[0].mode === '{';
}
/**
 * Setup compound binding storage structures, notify listeners, and dataHost
 * references onto the bound nodeList.
 *
 * @param {!Polymer_PropertyEffects} inst Instance that bas been previously
 *     bound
 * @param {TemplateInfo} templateInfo Template metadata
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$setupBindings(inst, templateInfo) {
    // Setup compound storage, dataHost, and notify listeners
    let { nodeList: nodeList, nodeInfoList: nodeInfoList } = templateInfo;
    if (nodeInfoList.length) for(let i = 0; i < nodeInfoList.length; i++){
        let info = nodeInfoList[i];
        let node = nodeList[i];
        let bindings = info.bindings;
        if (bindings) for(let i = 0; i < bindings.length; i++){
            let binding = bindings[i];
            $1bac9b9e38435dd2$var$setupCompoundStorage(node, binding);
            $1bac9b9e38435dd2$var$addNotifyListener(node, inst, binding);
        }
        // This ensures all bound elements have a host set, regardless
        // of whether they upgrade synchronous to creation
        node.__dataHost = inst;
    }
}
/**
 * Initializes `__dataCompoundStorage` local storage on a bound node with
 * initial literal data for compound bindings, and sets the joined
 * literal parts to the bound property.
 *
 * When changes to compound parts occur, they are first set into the compound
 * storage array for that property, and then the array is joined to result in
 * the final value set to the property/attribute.
 *
 * @param {Node} node Bound node to initialize
 * @param {Binding} binding Binding metadata
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$setupCompoundStorage(node, binding) {
    if (binding.isCompound) {
        // Create compound storage map
        let storage = node.__dataCompoundStorage || (node.__dataCompoundStorage = {});
        let parts = binding.parts;
        // Copy literals from parts into storage for this binding
        let literals = new Array(parts.length);
        for(let j = 0; j < parts.length; j++)literals[j] = parts[j].literal;
        let target = binding.target;
        storage[target] = literals;
        // Configure properties with their literal parts
        if (binding.literal && binding.kind == 'property') {
            // Note, className needs style scoping so this needs wrapping.
            // We may also want to consider doing this for `textContent` and
            // `innerHTML`.
            if (target === 'className') node = (0, $a2HIe.wrap)(node);
            node[target] = binding.literal;
        }
    }
}
/**
 * Adds a 2-way binding notification event listener to the node specified
 *
 * @param {Object} node Child element to add listener to
 * @param {!Polymer_PropertyEffects} inst Host element instance to handle
 *     notification event
 * @param {Binding} binding Binding metadata
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$addNotifyListener(node, inst, binding) {
    if (binding.listenerEvent) {
        let part = binding.parts[0];
        node.addEventListener(binding.listenerEvent, function(e) {
            $1bac9b9e38435dd2$var$handleNotification(e, inst, binding.target, part.source, part.negate);
        });
    }
}
// -- for method-based effects (complexObserver & computed) --------------
/**
 * Adds property effects for each argument in the method signature (and
 * optionally, for the method name if `dynamic` is true) that calls the
 * provided effect function.
 *
 * @param {Element | Object} model Prototype or instance
 * @param {!MethodSignature} sig Method signature metadata
 * @param {string} type Type of property effect to add
 * @param {Function} effectFn Function to run when arguments change
 * @param {*=} methodInfo Effect-specific information to be included in
 *   method effect metadata
 * @param {boolean|Object=} dynamicFn Boolean or object map indicating whether
 *   method names should be included as a dependency to the effect. Note,
 *   defaults to true if the signature is static (sig.static is true).
 * @return {!Object} Effect metadata for this method effect
 * @private
 */ function $1bac9b9e38435dd2$var$createMethodEffect(model, sig, type, effectFn, methodInfo, dynamicFn) {
    dynamicFn = sig.static || dynamicFn && (typeof dynamicFn !== 'object' || dynamicFn[sig.methodName]);
    let info = {
        methodName: sig.methodName,
        args: sig.args,
        methodInfo: methodInfo,
        dynamicFn: dynamicFn
    };
    for(let i = 0, arg; i < sig.args.length && (arg = sig.args[i]); i++)if (!arg.literal) model._addPropertyEffect(arg.rootProperty, type, {
        fn: effectFn,
        info: info,
        trigger: arg
    });
    if (dynamicFn) model._addPropertyEffect(sig.methodName, type, {
        fn: effectFn,
        info: info
    });
    return info;
}
/**
 * Calls a method with arguments marshaled from properties on the instance
 * based on the method signature contained in the effect metadata.
 *
 * Multi-property observers, computed properties, and inline computing
 * functions call this function to invoke the method, then use the return
 * value accordingly.
 *
 * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
 * @param {string} property Name of property
 * @param {Object} props Bag of current property changes
 * @param {Object} oldProps Bag of previous values for changed properties
 * @param {?} info Effect metadata
 * @return {*} Returns the return value from the method invocation
 * @private
 */ function $1bac9b9e38435dd2$var$runMethodEffect(inst, property, props, oldProps, info) {
    // Instances can optionally have a _methodHost which allows redirecting where
    // to find methods. Currently used by `templatize`.
    let context = inst._methodHost || inst;
    let fn = context[info.methodName];
    if (fn) {
        let args = inst._marshalArgs(info.args, property, props);
        return args === $1bac9b9e38435dd2$var$NOOP ? $1bac9b9e38435dd2$var$NOOP : fn.apply(context, args);
    } else if (!info.dynamicFn) console.warn('method `' + info.methodName + '` not defined');
}
const $1bac9b9e38435dd2$var$emptyArray = [];
// Regular expressions used for binding
const $1bac9b9e38435dd2$var$IDENT = "(?:[a-zA-Z_$][\\w.:$\\-*]*)";
const $1bac9b9e38435dd2$var$NUMBER = "(?:[-+]?[0-9]*\\.?[0-9]+(?:[eE][-+]?[0-9]+)?)";
const $1bac9b9e38435dd2$var$SQUOTE_STRING = "(?:'(?:[^'\\\\]|\\\\.)*')";
const $1bac9b9e38435dd2$var$DQUOTE_STRING = '(?:"(?:[^"\\\\]|\\\\.)*")';
const $1bac9b9e38435dd2$var$STRING = '(?:' + $1bac9b9e38435dd2$var$SQUOTE_STRING + '|' + $1bac9b9e38435dd2$var$DQUOTE_STRING + ')';
const $1bac9b9e38435dd2$var$ARGUMENT = '(?:(' + $1bac9b9e38435dd2$var$IDENT + '|' + $1bac9b9e38435dd2$var$NUMBER + '|' + $1bac9b9e38435dd2$var$STRING + ')\\s*' + ')';
const $1bac9b9e38435dd2$var$ARGUMENTS = '(?:' + $1bac9b9e38435dd2$var$ARGUMENT + '(?:,\\s*' + $1bac9b9e38435dd2$var$ARGUMENT + ')*' + ')';
const $1bac9b9e38435dd2$var$ARGUMENT_LIST = "(?:\\(\\s*(?:" + $1bac9b9e38435dd2$var$ARGUMENTS + '?' + ')' + '\\)\\s*' + ')';
const $1bac9b9e38435dd2$var$BINDING = '(' + $1bac9b9e38435dd2$var$IDENT + '\\s*' + $1bac9b9e38435dd2$var$ARGUMENT_LIST + '?' + ')'; // Group 3
const $1bac9b9e38435dd2$var$OPEN_BRACKET = "(\\[\\[|{{)\\s*";
const $1bac9b9e38435dd2$var$CLOSE_BRACKET = '(?:]]|}})';
const $1bac9b9e38435dd2$var$NEGATE = '(?:(!)\\s*)?'; // Group 2
const $1bac9b9e38435dd2$var$EXPRESSION = $1bac9b9e38435dd2$var$OPEN_BRACKET + $1bac9b9e38435dd2$var$NEGATE + $1bac9b9e38435dd2$var$BINDING + $1bac9b9e38435dd2$var$CLOSE_BRACKET;
const $1bac9b9e38435dd2$var$bindingRegex = new RegExp($1bac9b9e38435dd2$var$EXPRESSION, "g");
/**
 * Create a string from binding parts of all the literal parts
 *
 * @param {!Array<BindingPart>} parts All parts to stringify
 * @return {string} String made from the literal parts
 */ function $1bac9b9e38435dd2$var$literalFromParts(parts) {
    let s = '';
    for(let i = 0; i < parts.length; i++){
        let literal = parts[i].literal;
        s += literal || '';
    }
    return s;
}
/**
 * Parses an expression string for a method signature, and returns a metadata
 * describing the method in terms of `methodName`, `static` (whether all the
 * arguments are literals), and an array of `args`
 *
 * @param {string} expression The expression to parse
 * @return {?MethodSignature} The method metadata object if a method expression was
 *   found, otherwise `undefined`
 * @private
 */ function $1bac9b9e38435dd2$var$parseMethod(expression) {
    // tries to match valid javascript property names
    let m = expression.match(/([^\s]+?)\(([\s\S]*)\)/);
    if (m) {
        let methodName = m[1];
        let sig = {
            methodName: methodName,
            static: true,
            args: $1bac9b9e38435dd2$var$emptyArray
        };
        if (m[2].trim()) {
            // replace escaped commas with comma entity, split on un-escaped commas
            let args = m[2].replace(/\\,/g, '&comma;').split(',');
            return $1bac9b9e38435dd2$var$parseArgs(args, sig);
        } else return sig;
    }
    return null;
}
/**
 * Parses an array of arguments and sets the `args` property of the supplied
 * signature metadata object. Sets the `static` property to false if any
 * argument is a non-literal.
 *
 * @param {!Array<string>} argList Array of argument names
 * @param {!MethodSignature} sig Method signature metadata object
 * @return {!MethodSignature} The updated signature metadata object
 * @private
 */ function $1bac9b9e38435dd2$var$parseArgs(argList, sig) {
    sig.args = argList.map(function(rawArg) {
        let arg = $1bac9b9e38435dd2$var$parseArg(rawArg);
        if (!arg.literal) sig.static = false;
        return arg;
    }, this);
    return sig;
}
/**
 * Parses an individual argument, and returns an argument metadata object
 * with the following fields:
 *
 *   {
 *     value: 'prop',        // property/path or literal value
 *     literal: false,       // whether argument is a literal
 *     structured: false,    // whether the property is a path
 *     rootProperty: 'prop', // the root property of the path
 *     wildcard: false       // whether the argument was a wildcard '.*' path
 *   }
 *
 * @param {string} rawArg The string value of the argument
 * @return {!MethodArg} Argument metadata object
 * @private
 */ function $1bac9b9e38435dd2$var$parseArg(rawArg) {
    // clean up whitespace
    let arg = rawArg.trim()// replace comma entity with comma
    .replace(/&comma;/g, ',')// repair extra escape sequences; note only commas strictly need
    // escaping, but we allow any other char to be escaped since its
    // likely users will do this
    .replace(/\\(.)/g, '$1');
    // basic argument descriptor
    let a = {
        name: arg,
        value: '',
        literal: false
    };
    // detect literal value (must be String or Number)
    let fc = arg[0];
    if (fc === '-') fc = arg[1];
    if (fc >= '0' && fc <= '9') fc = '#';
    switch(fc){
        case "'":
        case '"':
            a.value = arg.slice(1, -1);
            a.literal = true;
            break;
        case '#':
            a.value = Number(arg);
            a.literal = true;
            break;
    }
    // if not literal, look for structured path
    if (!a.literal) {
        a.rootProperty = (0, $kt4XD.root)(arg);
        // detect structured path (has dots)
        a.structured = (0, $kt4XD.isPath)(arg);
        if (a.structured) {
            a.wildcard = arg.slice(-2) == '.*';
            if (a.wildcard) a.name = arg.slice(0, -2);
        }
    }
    return a;
}
function $1bac9b9e38435dd2$var$getArgValue(data, props, path) {
    let value = (0, $kt4XD.get)(data, path);
    // when data is not stored e.g. `splices`, get the value from changedProps
    // TODO(kschaaf): Note, this can cause a rare issue where the wildcard
    // info.value could pull a stale value out of changedProps during a reentrant
    // change that sets the value back to undefined.
    // https://github.com/Polymer/polymer/issues/5479
    if (value === undefined) value = props[path];
    return value;
}
// data api
/**
 * Sends array splice notifications (`.splices` and `.length`)
 *
 * Note: this implementation only accepts normalized paths
 *
 * @param {!Polymer_PropertyEffects} inst Instance to send notifications to
 * @param {Array} array The array the mutations occurred on
 * @param {string} path The path to the array that was mutated
 * @param {Array} splices Array of splice records
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$notifySplices(inst, array, path, splices) {
    const splicesData = {
        indexSplices: splices
    };
    // Legacy behavior stored splices in `__data__` so it was *not* ephemeral.
    // To match this behavior, we store splices directly on the array.
    if ((0, $8bEdR.legacyUndefined) && !inst._overrideLegacyUndefined) array.splices = splicesData;
    inst.notifyPath(path + '.splices', splicesData);
    inst.notifyPath(path + '.length', array.length);
    // Clear splice data only when it's stored on the array.
    if ((0, $8bEdR.legacyUndefined) && !inst._overrideLegacyUndefined) splicesData.indexSplices = [];
}
/**
 * Creates a splice record and sends an array splice notification for
 * the described mutation
 *
 * Note: this implementation only accepts normalized paths
 *
 * @param {!Polymer_PropertyEffects} inst Instance to send notifications to
 * @param {Array} array The array the mutations occurred on
 * @param {string} path The path to the array that was mutated
 * @param {number} index Index at which the array mutation occurred
 * @param {number} addedCount Number of added items
 * @param {Array} removed Array of removed items
 * @return {void}
 * @private
 */ function $1bac9b9e38435dd2$var$notifySplice(inst, array, path, index, addedCount, removed) {
    $1bac9b9e38435dd2$var$notifySplices(inst, array, path, [
        {
            index: index,
            addedCount: addedCount,
            removed: removed,
            object: array,
            type: 'splice'
        }
    ]);
}
/**
 * Returns an upper-cased version of the string.
 *
 * @param {string} name String to uppercase
 * @return {string} Uppercased string
 * @private
 */ function $1bac9b9e38435dd2$var$upper(name) {
    return name[0].toUpperCase() + name.substring(1);
}
const $1bac9b9e38435dd2$export$5bc04800afa346a0 = (0, $gLdkK.dedupingMixin)((superClass)=>{
    /**
   * @constructor
   * @implements {Polymer_PropertyAccessors}
   * @implements {Polymer_TemplateStamp}
   * @unrestricted
   * @private
   */ const propertyEffectsBase = (0, $jBFgP.TemplateStamp)((0, $4Oamu.PropertyAccessors)(superClass));
    /**
   * @polymer
   * @mixinClass
   * @implements {Polymer_PropertyEffects}
   * @extends {propertyEffectsBase}
   * @unrestricted
   */ class PropertyEffects extends propertyEffectsBase {
        constructor(){
            super();
            /** @type {boolean} */ // Used to identify users of this mixin, ala instanceof
            this.__isPropertyEffectsClient = true;
            /** @type {boolean} */ this.__dataClientsReady;
            /** @type {Array} */ this.__dataPendingClients;
            /** @type {Object} */ this.__dataToNotify;
            /** @type {Object} */ this.__dataLinkedPaths;
            /** @type {boolean} */ this.__dataHasPaths;
            /** @type {Object} */ this.__dataCompoundStorage;
            /** @type {Polymer_PropertyEffects} */ this.__dataHost;
            /** @type {!Object} */ this.__dataTemp;
            /** @type {boolean} */ this.__dataClientsInitialized;
            /** @type {!Object} */ this.__data;
            /** @type {!Object|null} */ this.__dataPending;
            /** @type {!Object} */ this.__dataOld;
            /** @type {Object} */ this.__computeEffects;
            /** @type {Object} */ this.__computeInfo;
            /** @type {Object} */ this.__reflectEffects;
            /** @type {Object} */ this.__notifyEffects;
            /** @type {Object} */ this.__propagateEffects;
            /** @type {Object} */ this.__observeEffects;
            /** @type {Object} */ this.__readOnly;
            /** @type {!TemplateInfo} */ this.__templateInfo;
            /** @type {boolean} */ this._overrideLegacyUndefined;
        }
        get PROPERTY_EFFECT_TYPES() {
            return $1bac9b9e38435dd2$var$TYPES;
        }
        /**
     * @override
     * @return {void}
     */ _initializeProperties() {
            super._initializeProperties();
            this._registerHost();
            this.__dataClientsReady = false;
            this.__dataPendingClients = null;
            this.__dataToNotify = null;
            this.__dataLinkedPaths = null;
            this.__dataHasPaths = false;
            // May be set on instance prior to upgrade
            this.__dataCompoundStorage = this.__dataCompoundStorage || null;
            this.__dataHost = this.__dataHost || null;
            this.__dataTemp = {};
            this.__dataClientsInitialized = false;
        }
        _registerHost() {
            if ($1bac9b9e38435dd2$var$hostStack.length) {
                let host = $1bac9b9e38435dd2$var$hostStack[$1bac9b9e38435dd2$var$hostStack.length - 1];
                host._enqueueClient(this);
                // This ensures even non-bound elements have a host set, as
                // long as they upgrade synchronously
                this.__dataHost = host;
            }
        }
        /**
     * Overrides `PropertyAccessors` implementation to provide a
     * more efficient implementation of initializing properties from
     * the prototype on the instance.
     *
     * @override
     * @param {Object} props Properties to initialize on the prototype
     * @return {void}
     */ _initializeProtoProperties(props) {
            this.__data = Object.create(props);
            this.__dataPending = Object.create(props);
            this.__dataOld = {};
        }
        /**
     * Overrides `PropertyAccessors` implementation to avoid setting
     * `_setProperty`'s `shouldNotify: true`.
     *
     * @override
     * @param {Object} props Properties to initialize on the instance
     * @return {void}
     */ _initializeInstanceProperties(props) {
            let readOnly = this[$1bac9b9e38435dd2$var$TYPES.READ_ONLY];
            for(let prop in props)if (!readOnly || !readOnly[prop]) {
                this.__dataPending = this.__dataPending || {};
                this.__dataOld = this.__dataOld || {};
                this.__data[prop] = this.__dataPending[prop] = props[prop];
            }
        }
        // Prototype setup ----------------------------------------
        /**
     * Equivalent to static `addPropertyEffect` API but can be called on
     * an instance to add effects at runtime.  See that method for
     * full API docs.
     *
     * @override
     * @param {string} property Property that should trigger the effect
     * @param {string} type Effect type, from this.PROPERTY_EFFECT_TYPES
     * @param {Object=} effect Effect metadata object
     * @return {void}
     * @protected
     */ _addPropertyEffect(property, type, effect) {
            this._createPropertyAccessor(property, type == $1bac9b9e38435dd2$var$TYPES.READ_ONLY);
            // effects are accumulated into arrays per property based on type
            let effects = $1bac9b9e38435dd2$var$ensureOwnEffectMap(this, type, true)[property];
            if (!effects) effects = this[type][property] = [];
            effects.push(effect);
        }
        /**
     * Removes the given property effect.
     *
     * @override
     * @param {string} property Property the effect was associated with
     * @param {string} type Effect type, from this.PROPERTY_EFFECT_TYPES
     * @param {Object=} effect Effect metadata object to remove
     * @return {void}
     */ _removePropertyEffect(property, type, effect) {
            let effects = $1bac9b9e38435dd2$var$ensureOwnEffectMap(this, type, true)[property];
            let idx = effects.indexOf(effect);
            if (idx >= 0) effects.splice(idx, 1);
        }
        /**
     * Returns whether the current prototype/instance has a property effect
     * of a certain type.
     *
     * @override
     * @param {string} property Property name
     * @param {string=} type Effect type, from this.PROPERTY_EFFECT_TYPES
     * @return {boolean} True if the prototype/instance has an effect of this
     *     type
     * @protected
     */ _hasPropertyEffect(property, type) {
            let effects = this[type];
            return Boolean(effects && effects[property]);
        }
        /**
     * Returns whether the current prototype/instance has a "read only"
     * accessor for the given property.
     *
     * @override
     * @param {string} property Property name
     * @return {boolean} True if the prototype/instance has an effect of this
     *     type
     * @protected
     */ _hasReadOnlyEffect(property) {
            return this._hasPropertyEffect(property, $1bac9b9e38435dd2$var$TYPES.READ_ONLY);
        }
        /**
     * Returns whether the current prototype/instance has a "notify"
     * property effect for the given property.
     *
     * @override
     * @param {string} property Property name
     * @return {boolean} True if the prototype/instance has an effect of this
     *     type
     * @protected
     */ _hasNotifyEffect(property) {
            return this._hasPropertyEffect(property, $1bac9b9e38435dd2$var$TYPES.NOTIFY);
        }
        /**
     * Returns whether the current prototype/instance has a "reflect to
     * attribute" property effect for the given property.
     *
     * @override
     * @param {string} property Property name
     * @return {boolean} True if the prototype/instance has an effect of this
     *     type
     * @protected
     */ _hasReflectEffect(property) {
            return this._hasPropertyEffect(property, $1bac9b9e38435dd2$var$TYPES.REFLECT);
        }
        /**
     * Returns whether the current prototype/instance has a "computed"
     * property effect for the given property.
     *
     * @override
     * @param {string} property Property name
     * @return {boolean} True if the prototype/instance has an effect of this
     *     type
     * @protected
     */ _hasComputedEffect(property) {
            return this._hasPropertyEffect(property, $1bac9b9e38435dd2$var$TYPES.COMPUTE);
        }
        // Runtime ----------------------------------------
        /**
     * Sets a pending property or path.  If the root property of the path in
     * question had no accessor, the path is set, otherwise it is enqueued
     * via `_setPendingProperty`.
     *
     * This function isolates relatively expensive functionality necessary
     * for the public API (`set`, `setProperties`, `notifyPath`, and property
     * change listeners via {{...}} bindings), such that it is only done
     * when paths enter the system, and not at every propagation step.  It
     * also sets a `__dataHasPaths` flag on the instance which is used to
     * fast-path slower path-matching code in the property effects host paths.
     *
     * `path` can be a path string or array of path parts as accepted by the
     * public API.
     *
     * @override
     * @param {string | !Array<number|string>} path Path to set
     * @param {*} value Value to set
     * @param {boolean=} shouldNotify Set to true if this change should
     *  cause a property notification event dispatch
     * @param {boolean=} isPathNotification If the path being set is a path
     *   notification of an already changed value, as opposed to a request
     *   to set and notify the change.  In the latter `false` case, a dirty
     *   check is performed and then the value is set to the path before
     *   enqueuing the pending property change.
     * @return {boolean} Returns true if the property/path was enqueued in
     *   the pending changes bag.
     * @protected
     */ _setPendingPropertyOrPath(path, value, shouldNotify, isPathNotification) {
            if (isPathNotification || (0, $kt4XD.root)(Array.isArray(path) ? path[0] : path) !== path) {
                // Dirty check changes being set to a path against the actual object,
                // since this is the entry point for paths into the system; from here
                // the only dirty checks are against the `__dataTemp` cache to prevent
                // duplicate work in the same turn only. Note, if this was a notification
                // of a change already set to a path (isPathNotification: true),
                // we always let the change through and skip the `set` since it was
                // already dirty checked at the point of entry and the underlying
                // object has already been updated
                if (!isPathNotification) {
                    let old = (0, $kt4XD.get)(this, path);
                    path = /** @type {string} */ (0, $kt4XD.set)(this, path, value);
                    // Use property-accessor's simpler dirty check
                    if (!path || !super._shouldPropertyChange(path, value, old)) return false;
                }
                this.__dataHasPaths = true;
                if (this._setPendingProperty(/**@type{string}*/ path, value, shouldNotify)) {
                    $1bac9b9e38435dd2$var$computeLinkedPaths(this, /**@type{string}*/ path, value);
                    return true;
                }
            } else {
                if (this.__dataHasAccessor && this.__dataHasAccessor[path]) return this._setPendingProperty(/**@type{string}*/ path, value, shouldNotify);
                else this[path] = value;
            }
            return false;
        }
        /**
     * Applies a value to a non-Polymer element/node's property.
     *
     * The implementation makes a best-effort at binding interop:
     * Some native element properties have side-effects when
     * re-setting the same value (e.g. setting `<input>.value` resets the
     * cursor position), so we do a dirty-check before setting the value.
     * However, for better interop with non-Polymer custom elements that
     * accept objects, we explicitly re-set object changes coming from the
     * Polymer world (which may include deep object changes without the
     * top reference changing), erring on the side of providing more
     * information.
     *
     * Users may override this method to provide alternate approaches.
     *
     * @override
     * @param {!Node} node The node to set a property on
     * @param {string} prop The property to set
     * @param {*} value The value to set
     * @return {void}
     * @protected
     */ _setUnmanagedPropertyToNode(node, prop, value) {
            // It is a judgment call that resetting primitives is
            // "bad" and resettings objects is also "good"; alternatively we could
            // implement a whitelist of tag & property values that should never
            // be reset (e.g. <input>.value && <select>.value)
            if (value !== node[prop] || typeof value == 'object') {
                // Note, className needs style scoping so this needs wrapping.
                if (prop === 'className') node = /** @type {!Node} */ (0, $a2HIe.wrap)(node);
                node[prop] = value;
            }
        }
        /**
     * Overrides the `PropertiesChanged` implementation to introduce special
     * dirty check logic depending on the property & value being set:
     *
     * 1. Any value set to a path (e.g. 'obj.prop': 42 or 'obj.prop': {...})
     *    Stored in `__dataTemp`, dirty checked against `__dataTemp`
     * 2. Object set to simple property (e.g. 'prop': {...})
     *    Stored in `__dataTemp` and `__data`, dirty checked against
     *    `__dataTemp` by default implementation of `_shouldPropertyChange`
     * 3. Primitive value set to simple property (e.g. 'prop': 42)
     *    Stored in `__data`, dirty checked against `__data`
     *
     * The dirty-check is important to prevent cycles due to two-way
     * notification, but paths and objects are only dirty checked against any
     * previous value set during this turn via a "temporary cache" that is
     * cleared when the last `_propertiesChanged` exits. This is so:
     * a. any cached array paths (e.g. 'array.3.prop') may be invalidated
     *    due to array mutations like shift/unshift/splice; this is fine
     *    since path changes are dirty-checked at user entry points like `set`
     * b. dirty-checking for objects only lasts one turn to allow the user
     *    to mutate the object in-place and re-set it with the same identity
     *    and have all sub-properties re-propagated in a subsequent turn.
     *
     * The temp cache is not necessarily sufficient to prevent invalid array
     * paths, since a splice can happen during the same turn (with pathological
     * user code); we could introduce a "fixup" for temporarily cached array
     * paths if needed: https://github.com/Polymer/polymer/issues/4227
     *
     * @override
     * @param {string} property Name of the property
     * @param {*} value Value to set
     * @param {boolean=} shouldNotify True if property should fire notification
     *   event (applies only for `notify: true` properties)
     * @return {boolean} Returns true if the property changed
     */ _setPendingProperty(property, value, shouldNotify) {
            let propIsPath = this.__dataHasPaths && (0, $kt4XD.isPath)(property);
            let prevProps = propIsPath ? this.__dataTemp : this.__data;
            if (this._shouldPropertyChange(property, value, prevProps[property])) {
                if (!this.__dataPending) {
                    this.__dataPending = {};
                    this.__dataOld = {};
                }
                // Ensure old is captured from the last turn
                if (!(property in this.__dataOld)) this.__dataOld[property] = this.__data[property];
                // Paths are stored in temporary cache (cleared at end of turn),
                // which is used for dirty-checking, all others stored in __data
                if (propIsPath) this.__dataTemp[property] = value;
                else this.__data[property] = value;
                // All changes go into pending property bag, passed to _propertiesChanged
                this.__dataPending[property] = value;
                // Track properties that should notify separately
                if (propIsPath || this[$1bac9b9e38435dd2$var$TYPES.NOTIFY] && this[$1bac9b9e38435dd2$var$TYPES.NOTIFY][property]) {
                    this.__dataToNotify = this.__dataToNotify || {};
                    this.__dataToNotify[property] = shouldNotify;
                }
                return true;
            }
            return false;
        }
        /**
     * Overrides base implementation to ensure all accessors set `shouldNotify`
     * to true, for per-property notification tracking.
     *
     * @override
     * @param {string} property Name of the property
     * @param {*} value Value to set
     * @return {void}
     */ _setProperty(property, value) {
            if (this._setPendingProperty(property, value, true)) this._invalidateProperties();
        }
        /**
     * Overrides `PropertyAccessor`'s default async queuing of
     * `_propertiesChanged`: if `__dataReady` is false (has not yet been
     * manually flushed), the function no-ops; otherwise flushes
     * `_propertiesChanged` synchronously.
     *
     * @override
     * @return {void}
     */ _invalidateProperties() {
            if (this.__dataReady) this._flushProperties();
        }
        /**
     * Enqueues the given client on a list of pending clients, whose
     * pending property changes can later be flushed via a call to
     * `_flushClients`.
     *
     * @override
     * @param {Object} client PropertyEffects client to enqueue
     * @return {void}
     * @protected
     */ _enqueueClient(client) {
            this.__dataPendingClients = this.__dataPendingClients || [];
            if (client !== this) this.__dataPendingClients.push(client);
        }
        /**
     * Flushes any clients previously enqueued via `_enqueueClient`, causing
     * their `_flushProperties` method to run.
     *
     * @override
     * @return {void}
     * @protected
     */ _flushClients() {
            if (!this.__dataClientsReady) {
                this.__dataClientsReady = true;
                this._readyClients();
                // Override point where accessors are turned on; importantly,
                // this is after clients have fully readied, providing a guarantee
                // that any property effects occur only after all clients are ready.
                this.__dataReady = true;
            } else this.__enableOrFlushClients();
        }
        // NOTE: We ensure clients either enable or flush as appropriate. This
        // handles two corner cases:
        // (1) clients flush properly when connected/enabled before the host
        // enables; e.g.
        //   (a) Templatize stamps with no properties and does not flush and
        //   (b) the instance is inserted into dom and
        //   (c) then the instance flushes.
        // (2) clients enable properly when not connected/enabled when the host
        // flushes; e.g.
        //   (a) a template is runtime stamped and not yet connected/enabled
        //   (b) a host sets a property, causing stamped dom to flush
        //   (c) the stamped dom enables.
        __enableOrFlushClients() {
            let clients = this.__dataPendingClients;
            if (clients) {
                this.__dataPendingClients = null;
                for(let i = 0; i < clients.length; i++){
                    let client = clients[i];
                    if (!client.__dataEnabled) client._enableProperties();
                    else if (client.__dataPending) client._flushProperties();
                }
            }
        }
        /**
     * Perform any initial setup on client dom. Called before the first
     * `_flushProperties` call on client dom and before any element
     * observers are called.
     *
     * @override
     * @return {void}
     * @protected
     */ _readyClients() {
            this.__enableOrFlushClients();
        }
        /**
     * Sets a bag of property changes to this instance, and
     * synchronously processes all effects of the properties as a batch.
     *
     * Property names must be simple properties, not paths.  Batched
     * path propagation is not supported.
     *
     * @override
     * @param {Object} props Bag of one or more key-value pairs whose key is
     *   a property and value is the new value to set for that property.
     * @param {boolean=} setReadOnly When true, any private values set in
     *   `props` will be set. By default, `setProperties` will not set
     *   `readOnly: true` root properties.
     * @return {void}
     * @public
     */ setProperties(props, setReadOnly) {
            for(let path in props)if (setReadOnly || !this[$1bac9b9e38435dd2$var$TYPES.READ_ONLY] || !this[$1bac9b9e38435dd2$var$TYPES.READ_ONLY][path]) //TODO(kschaaf): explicitly disallow paths in setProperty?
            // wildcard observers currently only pass the first changed path
            // in the `info` object, and you could do some odd things batching
            // paths, e.g. {'foo.bar': {...}, 'foo': null}
            this._setPendingPropertyOrPath(path, props[path], true);
            this._invalidateProperties();
        }
        /**
     * Overrides `PropertyAccessors` so that property accessor
     * side effects are not enabled until after client dom is fully ready.
     * Also calls `_flushClients` callback to ensure client dom is enabled
     * that was not enabled as a result of flushing properties.
     *
     * @override
     * @return {void}
     */ ready() {
            // It is important that `super.ready()` is not called here as it
            // immediately turns on accessors. Instead, we wait until `readyClients`
            // to enable accessors to provide a guarantee that clients are ready
            // before processing any accessors side effects.
            this._flushProperties();
            // If no data was pending, `_flushProperties` will not `flushClients`
            // so ensure this is done.
            if (!this.__dataClientsReady) this._flushClients();
            // Before ready, client notifications do not trigger _flushProperties.
            // Therefore a flush is necessary here if data has been set.
            if (this.__dataPending) this._flushProperties();
        }
        /**
     * Implements `PropertyAccessors`'s properties changed callback.
     *
     * Runs each class of effects for the batch of changed properties in
     * a specific order (compute, propagate, reflect, observe, notify).
     *
     * @override
     * @param {!Object} currentProps Bag of all current accessor values
     * @param {?Object} changedProps Bag of properties changed since the last
     *   call to `_propertiesChanged`
     * @param {?Object} oldProps Bag of previous values for each property
     *   in `changedProps`
     * @return {void}
     */ _propertiesChanged(currentProps, changedProps, oldProps) {
            // ----------------------------
            // let c = Object.getOwnPropertyNames(changedProps || {});
            // window.debug && console.group(this.localName + '#' + this.id + ': ' + c);
            // if (window.debug) { debugger; }
            // ----------------------------
            let hasPaths = this.__dataHasPaths;
            this.__dataHasPaths = false;
            let notifyProps;
            // Compute properties
            $1bac9b9e38435dd2$var$runComputedEffects(this, changedProps, oldProps, hasPaths);
            // Clear notify properties prior to possible reentry (propagate, observe),
            // but after computing effects have a chance to add to them
            notifyProps = this.__dataToNotify;
            this.__dataToNotify = null;
            // Propagate properties to clients
            this._propagatePropertyChanges(changedProps, oldProps, hasPaths);
            // Flush clients
            this._flushClients();
            // Reflect properties
            $1bac9b9e38435dd2$var$runEffects(this, this[$1bac9b9e38435dd2$var$TYPES.REFLECT], changedProps, oldProps, hasPaths);
            // Observe properties
            $1bac9b9e38435dd2$var$runEffects(this, this[$1bac9b9e38435dd2$var$TYPES.OBSERVE], changedProps, oldProps, hasPaths);
            // Notify properties to host
            if (notifyProps) $1bac9b9e38435dd2$var$runNotifyEffects(this, notifyProps, changedProps, oldProps, hasPaths);
            // Clear temporary cache at end of turn
            if (this.__dataCounter == 1) this.__dataTemp = {};
        // ----------------------------
        // window.debug && console.groupEnd(this.localName + '#' + this.id + ': ' + c);
        // ----------------------------
        }
        /**
     * Called to propagate any property changes to stamped template nodes
     * managed by this element.
     *
     * @override
     * @param {Object} changedProps Bag of changed properties
     * @param {Object} oldProps Bag of previous values for changed properties
     * @param {boolean} hasPaths True with `props` contains one or more paths
     * @return {void}
     * @protected
     */ _propagatePropertyChanges(changedProps, oldProps, hasPaths) {
            if (this[$1bac9b9e38435dd2$var$TYPES.PROPAGATE]) $1bac9b9e38435dd2$var$runEffects(this, this[$1bac9b9e38435dd2$var$TYPES.PROPAGATE], changedProps, oldProps, hasPaths);
            if (this.__templateInfo) this._runEffectsForTemplate(this.__templateInfo, changedProps, oldProps, hasPaths);
        }
        _runEffectsForTemplate(templateInfo, changedProps, oldProps, hasPaths) {
            const baseRunEffects = (changedProps, hasPaths)=>{
                $1bac9b9e38435dd2$var$runEffects(this, templateInfo.propertyEffects, changedProps, oldProps, hasPaths, templateInfo.nodeList);
                for(let info = templateInfo.firstChild; info; info = info.nextSibling)this._runEffectsForTemplate(info, changedProps, oldProps, hasPaths);
            };
            if (templateInfo.runEffects) templateInfo.runEffects(baseRunEffects, changedProps, hasPaths);
            else baseRunEffects(changedProps, hasPaths);
        }
        /**
     * Aliases one data path as another, such that path notifications from one
     * are routed to the other.
     *
     * @override
     * @param {string | !Array<string|number>} to Target path to link.
     * @param {string | !Array<string|number>} from Source path to link.
     * @return {void}
     * @public
     */ linkPaths(to, from) {
            to = (0, $kt4XD.normalize)(to);
            from = (0, $kt4XD.normalize)(from);
            this.__dataLinkedPaths = this.__dataLinkedPaths || {};
            this.__dataLinkedPaths[to] = from;
        }
        /**
     * Removes a data path alias previously established with `_linkPaths`.
     *
     * Note, the path to unlink should be the target (`to`) used when
     * linking the paths.
     *
     * @override
     * @param {string | !Array<string|number>} path Target path to unlink.
     * @return {void}
     * @public
     */ unlinkPaths(path) {
            path = (0, $kt4XD.normalize)(path);
            if (this.__dataLinkedPaths) delete this.__dataLinkedPaths[path];
        }
        /**
     * Notify that an array has changed.
     *
     * Example:
     *
     *     this.items = [ {name: 'Jim'}, {name: 'Todd'}, {name: 'Bill'} ];
     *     ...
     *     this.items.splice(1, 1, {name: 'Sam'});
     *     this.items.push({name: 'Bob'});
     *     this.notifySplices('items', [
     *       { index: 1, removed: [{name: 'Todd'}], addedCount: 1,
     *         object: this.items, type: 'splice' },
     *       { index: 3, removed: [], addedCount: 1,
     *         object: this.items, type: 'splice'}
     *     ]);
     *
     * @param {string} path Path that should be notified.
     * @param {Array} splices Array of splice records indicating ordered
     *   changes that occurred to the array. Each record should have the
     *   following fields:
     *    * index: index at which the change occurred
     *    * removed: array of items that were removed from this index
     *    * addedCount: number of new items added at this index
     *    * object: a reference to the array in question
     *    * type: the string literal 'splice'
     *
     *   Note that splice records _must_ be normalized such that they are
     *   reported in index order (raw results from `Object.observe` are not
     *   ordered and must be normalized/merged before notifying).
     *
     * @override
     * @return {void}
     * @public
     */ notifySplices(path, splices) {
            let info = {
                path: ''
            };
            let array = /** @type {Array} */ (0, $kt4XD.get)(this, path, info);
            $1bac9b9e38435dd2$var$notifySplices(this, array, info.path, splices);
        }
        /**
     * Convenience method for reading a value from a path.
     *
     * Note, if any part in the path is undefined, this method returns
     * `undefined` (this method does not throw when dereferencing undefined
     * paths).
     *
     * @override
     * @param {(string|!Array<(string|number)>)} path Path to the value
     *   to read.  The path may be specified as a string (e.g. `foo.bar.baz`)
     *   or an array of path parts (e.g. `['foo.bar', 'baz']`).  Note that
     *   bracketed expressions are not supported; string-based path parts
     *   *must* be separated by dots.  Note that when dereferencing array
     *   indices, the index may be used as a dotted part directly
     *   (e.g. `users.12.name` or `['users', 12, 'name']`).
     * @param {Object=} root Root object from which the path is evaluated.
     * @return {*} Value at the path, or `undefined` if any part of the path
     *   is undefined.
     * @public
     */ get(path, root) {
            return (0, $kt4XD.get)(root || this, path);
        }
        /**
     * Convenience method for setting a value to a path and notifying any
     * elements bound to the same path.
     *
     * Note, if any part in the path except for the last is undefined,
     * this method does nothing (this method does not throw when
     * dereferencing undefined paths).
     *
     * @override
     * @param {(string|!Array<(string|number)>)} path Path to the value
     *   to write.  The path may be specified as a string (e.g. `'foo.bar.baz'`)
     *   or an array of path parts (e.g. `['foo.bar', 'baz']`).  Note that
     *   bracketed expressions are not supported; string-based path parts
     *   *must* be separated by dots.  Note that when dereferencing array
     *   indices, the index may be used as a dotted part directly
     *   (e.g. `'users.12.name'` or `['users', 12, 'name']`).
     * @param {*} value Value to set at the specified path.
     * @param {Object=} root Root object from which the path is evaluated.
     *   When specified, no notification will occur.
     * @return {void}
     * @public
     */ set(path, value, root) {
            if (root) (0, $kt4XD.set)(root, path, value);
            else {
                if (!this[$1bac9b9e38435dd2$var$TYPES.READ_ONLY] || !this[$1bac9b9e38435dd2$var$TYPES.READ_ONLY][/** @type {string} */ path]) {
                    if (this._setPendingPropertyOrPath(path, value, true)) this._invalidateProperties();
                }
            }
        }
        /**
     * Adds items onto the end of the array at the path specified.
     *
     * The arguments after `path` and return value match that of
     * `Array.prototype.push`.
     *
     * This method notifies other paths to the same array that a
     * splice occurred to the array.
     *
     * @override
     * @param {string | !Array<string|number>} path Path to array.
     * @param {...*} items Items to push onto array
     * @return {number} New length of the array.
     * @public
     */ push(path, ...items) {
            let info = {
                path: ''
            };
            let array = /** @type {Array}*/ (0, $kt4XD.get)(this, path, info);
            let len = array.length;
            let ret = array.push(...items);
            if (items.length) $1bac9b9e38435dd2$var$notifySplice(this, array, info.path, len, items.length, []);
            return ret;
        }
        /**
     * Removes an item from the end of array at the path specified.
     *
     * The arguments after `path` and return value match that of
     * `Array.prototype.pop`.
     *
     * This method notifies other paths to the same array that a
     * splice occurred to the array.
     *
     * @override
     * @param {string | !Array<string|number>} path Path to array.
     * @return {*} Item that was removed.
     * @public
     */ pop(path) {
            let info = {
                path: ''
            };
            let array = /** @type {Array} */ (0, $kt4XD.get)(this, path, info);
            let hadLength = Boolean(array.length);
            let ret = array.pop();
            if (hadLength) $1bac9b9e38435dd2$var$notifySplice(this, array, info.path, array.length, 0, [
                ret
            ]);
            return ret;
        }
        /**
     * Starting from the start index specified, removes 0 or more items
     * from the array and inserts 0 or more new items in their place.
     *
     * The arguments after `path` and return value match that of
     * `Array.prototype.splice`.
     *
     * This method notifies other paths to the same array that a
     * splice occurred to the array.
     *
     * @override
     * @param {string | !Array<string|number>} path Path to array.
     * @param {number} start Index from which to start removing/inserting.
     * @param {number=} deleteCount Number of items to remove.
     * @param {...*} items Items to insert into array.
     * @return {!Array} Array of removed items.
     * @public
     */ splice(path, start, deleteCount, ...items) {
            let info = {
                path: ''
            };
            let array = /** @type {Array} */ (0, $kt4XD.get)(this, path, info);
            // Normalize fancy native splice handling of crazy start values
            if (start < 0) start = array.length - Math.floor(-start);
            else if (start) start = Math.floor(start);
            // array.splice does different things based on the number of arguments
            // you pass in. Therefore, array.splice(0) and array.splice(0, undefined)
            // do different things. In the former, the whole array is cleared. In the
            // latter, no items are removed.
            // This means that we need to detect whether 1. one of the arguments
            // is actually passed in and then 2. determine how many arguments
            // we should pass on to the native array.splice
            //
            let ret;
            // Omit any additional arguments if they were not passed in
            if (arguments.length === 2) ret = array.splice(start);
            else ret = array.splice(start, deleteCount, ...items);
            // At the end, check whether any items were passed in (e.g. insertions)
            // or if the return array contains items (e.g. deletions).
            // Only notify if items were added or deleted.
            if (items.length || ret.length) $1bac9b9e38435dd2$var$notifySplice(this, array, info.path, start, items.length, ret);
            return ret;
        }
        /**
     * Removes an item from the beginning of array at the path specified.
     *
     * The arguments after `path` and return value match that of
     * `Array.prototype.pop`.
     *
     * This method notifies other paths to the same array that a
     * splice occurred to the array.
     *
     * @override
     * @param {string | !Array<string|number>} path Path to array.
     * @return {*} Item that was removed.
     * @public
     */ shift(path) {
            let info = {
                path: ''
            };
            let array = /** @type {Array} */ (0, $kt4XD.get)(this, path, info);
            let hadLength = Boolean(array.length);
            let ret = array.shift();
            if (hadLength) $1bac9b9e38435dd2$var$notifySplice(this, array, info.path, 0, 0, [
                ret
            ]);
            return ret;
        }
        /**
     * Adds items onto the beginning of the array at the path specified.
     *
     * The arguments after `path` and return value match that of
     * `Array.prototype.push`.
     *
     * This method notifies other paths to the same array that a
     * splice occurred to the array.
     *
     * @override
     * @param {string | !Array<string|number>} path Path to array.
     * @param {...*} items Items to insert info array
     * @return {number} New length of the array.
     * @public
     */ unshift(path, ...items) {
            let info = {
                path: ''
            };
            let array = /** @type {Array} */ (0, $kt4XD.get)(this, path, info);
            let ret = array.unshift(...items);
            if (items.length) $1bac9b9e38435dd2$var$notifySplice(this, array, info.path, 0, items.length, []);
            return ret;
        }
        /**
     * Notify that a path has changed.
     *
     * Example:
     *
     *     this.item.user.name = 'Bob';
     *     this.notifyPath('item.user.name');
     *
     * @override
     * @param {string} path Path that should be notified.
     * @param {*=} value Value at the path (optional).
     * @return {void}
     * @public
     */ notifyPath(path, value) {
            /** @type {string} */ let propPath;
            if (arguments.length == 1) {
                // Get value if not supplied
                let info = {
                    path: ''
                };
                value = (0, $kt4XD.get)(this, path, info);
                propPath = info.path;
            } else if (Array.isArray(path)) // Normalize path if needed
            propPath = (0, $kt4XD.normalize)(path);
            else propPath = /** @type{string} */ path;
            if (this._setPendingPropertyOrPath(propPath, value, true, true)) this._invalidateProperties();
        }
        /**
     * Equivalent to static `createReadOnlyProperty` API but can be called on
     * an instance to add effects at runtime.  See that method for
     * full API docs.
     *
     * @override
     * @param {string} property Property name
     * @param {boolean=} protectedSetter Creates a custom protected setter
     *   when `true`.
     * @return {void}
     * @protected
     */ _createReadOnlyProperty(property, protectedSetter) {
            this._addPropertyEffect(property, $1bac9b9e38435dd2$var$TYPES.READ_ONLY);
            if (protectedSetter) this['_set' + $1bac9b9e38435dd2$var$upper(property)] = /** @this {PropertyEffects} */ function(value) {
                this._setProperty(property, value);
            };
        }
        /**
     * Equivalent to static `createPropertyObserver` API but can be called on
     * an instance to add effects at runtime.  See that method for
     * full API docs.
     *
     * @override
     * @param {string} property Property name
     * @param {string|function(*,*)} method Function or name of observer method
     *     to call
     * @param {boolean=} dynamicFn Whether the method name should be included as
     *   a dependency to the effect.
     * @return {void}
     * @protected
     */ _createPropertyObserver(property, method, dynamicFn) {
            let info = {
                property: property,
                method: method,
                dynamicFn: Boolean(dynamicFn)
            };
            this._addPropertyEffect(property, $1bac9b9e38435dd2$var$TYPES.OBSERVE, {
                fn: $1bac9b9e38435dd2$var$runObserverEffect,
                info: info,
                trigger: {
                    name: property
                }
            });
            if (dynamicFn) this._addPropertyEffect(/** @type {string} */ method, $1bac9b9e38435dd2$var$TYPES.OBSERVE, {
                fn: $1bac9b9e38435dd2$var$runObserverEffect,
                info: info,
                trigger: {
                    name: method
                }
            });
        }
        /**
     * Equivalent to static `createMethodObserver` API but can be called on
     * an instance to add effects at runtime.  See that method for
     * full API docs.
     *
     * @override
     * @param {string} expression Method expression
     * @param {boolean|Object=} dynamicFn Boolean or object map indicating
     *   whether method names should be included as a dependency to the effect.
     * @return {void}
     * @protected
     */ _createMethodObserver(expression, dynamicFn) {
            let sig = $1bac9b9e38435dd2$var$parseMethod(expression);
            if (!sig) throw new Error("Malformed observer expression '" + expression + "'");
            $1bac9b9e38435dd2$var$createMethodEffect(this, sig, $1bac9b9e38435dd2$var$TYPES.OBSERVE, $1bac9b9e38435dd2$var$runMethodEffect, null, dynamicFn);
        }
        /**
     * Equivalent to static `createNotifyingProperty` API but can be called on
     * an instance to add effects at runtime.  See that method for
     * full API docs.
     *
     * @override
     * @param {string} property Property name
     * @return {void}
     * @protected
     */ _createNotifyingProperty(property) {
            this._addPropertyEffect(property, $1bac9b9e38435dd2$var$TYPES.NOTIFY, {
                fn: $1bac9b9e38435dd2$var$runNotifyEffect,
                info: {
                    eventName: (0, $dMJbi.camelToDashCase)(property) + '-changed',
                    property: property
                }
            });
        }
        /**
     * Equivalent to static `createReflectedProperty` API but can be called on
     * an instance to add effects at runtime.  See that method for
     * full API docs.
     *
     * @override
     * @param {string} property Property name
     * @return {void}
     * @protected
     * @suppress {missingProperties} go/missingfnprops
     */ _createReflectedProperty(property) {
            let attr = this.constructor.attributeNameForProperty(property);
            if (attr[0] === '-') console.warn('Property ' + property + ' cannot be reflected to attribute ' + attr + ' because "-" is not a valid starting attribute name. Use a lowercase first letter for the property instead.');
            else this._addPropertyEffect(property, $1bac9b9e38435dd2$var$TYPES.REFLECT, {
                fn: $1bac9b9e38435dd2$var$runReflectEffect,
                info: {
                    attrName: attr
                }
            });
        }
        /**
     * Equivalent to static `createComputedProperty` API but can be called on
     * an instance to add effects at runtime.  See that method for
     * full API docs.
     *
     * @override
     * @param {string} property Name of computed property to set
     * @param {string} expression Method expression
     * @param {boolean|Object=} dynamicFn Boolean or object map indicating
     *   whether method names should be included as a dependency to the effect.
     * @return {void}
     * @protected
     */ _createComputedProperty(property, expression, dynamicFn) {
            let sig = $1bac9b9e38435dd2$var$parseMethod(expression);
            if (!sig) throw new Error("Malformed computed expression '" + expression + "'");
            const info = $1bac9b9e38435dd2$var$createMethodEffect(this, sig, $1bac9b9e38435dd2$var$TYPES.COMPUTE, $1bac9b9e38435dd2$var$runComputedEffect, property, dynamicFn);
            // Effects are normally stored as map of dependency->effect, but for
            // ordered computation, we also need tree of computedProp->dependencies
            $1bac9b9e38435dd2$var$ensureOwnEffectMap(this, $1bac9b9e38435dd2$var$COMPUTE_INFO)[property] = info;
        }
        /**
     * Gather the argument values for a method specified in the provided array
     * of argument metadata.
     *
     * The `path` and `value` arguments are used to fill in wildcard descriptor
     * when the method is being called as a result of a path notification.
     *
     * @param {!Array<!MethodArg>} args Array of argument metadata
     * @param {string} path Property/path name that triggered the method effect
     * @param {Object} props Bag of current property changes
     * @return {!Array<*>} Array of argument values
     * @private
     */ _marshalArgs(args, path, props) {
            const data = this.__data;
            const values = [];
            for(let i = 0, l = args.length; i < l; i++){
                let { name: name, structured: structured, wildcard: wildcard, value: value, literal: literal } = args[i];
                if (!literal) {
                    if (wildcard) {
                        const matches = (0, $kt4XD.isDescendant)(name, path);
                        const pathValue = $1bac9b9e38435dd2$var$getArgValue(data, props, matches ? path : name);
                        value = {
                            path: matches ? path : name,
                            value: pathValue,
                            base: matches ? (0, $kt4XD.get)(data, name) : pathValue
                        };
                    } else value = structured ? $1bac9b9e38435dd2$var$getArgValue(data, props, name) : data[name];
                }
                // When the `legacyUndefined` flag is enabled, pass a no-op value
                // so that the observer, computed property, or compound binding is aborted.
                if ((0, $8bEdR.legacyUndefined) && !this._overrideLegacyUndefined && value === undefined && args.length > 1) return $1bac9b9e38435dd2$var$NOOP;
                values[i] = value;
            }
            return values;
        }
        // -- static class methods ------------
        /**
     * Ensures an accessor exists for the specified property, and adds
     * to a list of "property effects" that will run when the accessor for
     * the specified property is set.  Effects are grouped by "type", which
     * roughly corresponds to a phase in effect processing.  The effect
     * metadata should be in the following form:
     *
     *     {
     *       fn: effectFunction, // Reference to function to call to perform effect
     *       info: { ... }       // Effect metadata passed to function
     *       trigger: {          // Optional triggering metadata; if not provided
     *         name: string      // the property is treated as a wildcard
     *         structured: boolean
     *         wildcard: boolean
     *       }
     *     }
     *
     * Effects are called from `_propertiesChanged` in the following order by
     * type:
     *
     * 1. COMPUTE
     * 2. PROPAGATE
     * 3. REFLECT
     * 4. OBSERVE
     * 5. NOTIFY
     *
     * Effect functions are called with the following signature:
     *
     *     effectFunction(inst, path, props, oldProps, info, hasPaths)
     *
     * @param {string} property Property that should trigger the effect
     * @param {string} type Effect type, from this.PROPERTY_EFFECT_TYPES
     * @param {Object=} effect Effect metadata object
     * @return {void}
     * @protected
     * @nocollapse
     */ static addPropertyEffect(property, type, effect) {
            this.prototype._addPropertyEffect(property, type, effect);
        }
        /**
     * Creates a single-property observer for the given property.
     *
     * @param {string} property Property name
     * @param {string|function(*,*)} method Function or name of observer method to call
     * @param {boolean=} dynamicFn Whether the method name should be included as
     *   a dependency to the effect.
     * @return {void}
     * @protected
     * @nocollapse
     */ static createPropertyObserver(property, method, dynamicFn) {
            this.prototype._createPropertyObserver(property, method, dynamicFn);
        }
        /**
     * Creates a multi-property "method observer" based on the provided
     * expression, which should be a string in the form of a normal JavaScript
     * function signature: `'methodName(arg1, [..., argn])'`.  Each argument
     * should correspond to a property or path in the context of this
     * prototype (or instance), or may be a literal string or number.
     *
     * @param {string} expression Method expression
     * @param {boolean|Object=} dynamicFn Boolean or object map indicating
     * @return {void}
     *   whether method names should be included as a dependency to the effect.
     * @protected
     * @nocollapse
     */ static createMethodObserver(expression, dynamicFn) {
            this.prototype._createMethodObserver(expression, dynamicFn);
        }
        /**
     * Causes the setter for the given property to dispatch `<property>-changed`
     * events to notify of changes to the property.
     *
     * @param {string} property Property name
     * @return {void}
     * @protected
     * @nocollapse
     */ static createNotifyingProperty(property) {
            this.prototype._createNotifyingProperty(property);
        }
        /**
     * Creates a read-only accessor for the given property.
     *
     * To set the property, use the protected `_setProperty` API.
     * To create a custom protected setter (e.g. `_setMyProp()` for
     * property `myProp`), pass `true` for `protectedSetter`.
     *
     * Note, if the property will have other property effects, this method
     * should be called first, before adding other effects.
     *
     * @param {string} property Property name
     * @param {boolean=} protectedSetter Creates a custom protected setter
     *   when `true`.
     * @return {void}
     * @protected
     * @nocollapse
     */ static createReadOnlyProperty(property, protectedSetter) {
            this.prototype._createReadOnlyProperty(property, protectedSetter);
        }
        /**
     * Causes the setter for the given property to reflect the property value
     * to a (dash-cased) attribute of the same name.
     *
     * @param {string} property Property name
     * @return {void}
     * @protected
     * @nocollapse
     */ static createReflectedProperty(property) {
            this.prototype._createReflectedProperty(property);
        }
        /**
     * Creates a computed property whose value is set to the result of the
     * method described by the given `expression` each time one or more
     * arguments to the method changes.  The expression should be a string
     * in the form of a normal JavaScript function signature:
     * `'methodName(arg1, [..., argn])'`
     *
     * @param {string} property Name of computed property to set
     * @param {string} expression Method expression
     * @param {boolean|Object=} dynamicFn Boolean or object map indicating whether
     *   method names should be included as a dependency to the effect.
     * @return {void}
     * @protected
     * @nocollapse
     */ static createComputedProperty(property, expression, dynamicFn) {
            this.prototype._createComputedProperty(property, expression, dynamicFn);
        }
        /**
     * Parses the provided template to ensure binding effects are created
     * for them, and then ensures property accessors are created for any
     * dependent properties in the template.  Binding effects for bound
     * templates are stored in a linked list on the instance so that
     * templates can be efficiently stamped and unstamped.
     *
     * @param {!HTMLTemplateElement} template Template containing binding
     *   bindings
     * @return {!TemplateInfo} Template metadata object
     * @protected
     * @nocollapse
     */ static bindTemplate(template) {
            return this.prototype._bindTemplate(template);
        }
        // -- binding ----------------------------------------------
        /*
     * Overview of binding flow:
     *
     * During finalization (`instanceBinding==false`, `wasPreBound==false`):
     *  `_bindTemplate(t, false)` called directly during finalization - parses
     *  the template (for the first time), and then assigns that _prototypical_
     *  template info to `__preboundTemplateInfo` _on the prototype_; note in
     *  this case `wasPreBound` is false; this is the first time we're binding
     *  it, thus we create accessors.
     *
     * During first stamping (`instanceBinding==true`, `wasPreBound==true`):
     *   `_stampTemplate` calls `_bindTemplate(t, true)`: the `templateInfo`
     *   returned matches the prebound one, and so this is `wasPreBound == true`
     *   state; thus we _skip_ creating accessors, but _do_ create an instance
     *   of the template info to serve as the start of our linked list (needs to
     *   be an instance, not the prototypical one, so that we can add `nodeList`
     *   to it to contain the `nodeInfo`-ordered list of instance nodes for
     *   bindings, and so we can chain runtime-stamped template infos off of
     *   it). At this point, the call to `_stampTemplate` calls
     *   `applyTemplateInfo` for each nested `<template>` found during parsing
     *   to hand prototypical `_templateInfo` to them; we also pass the _parent_
     *   `templateInfo` to the `<template>` so that we have the instance-time
     *   parent to link the `templateInfo` under in the case it was
     *   runtime-stamped.
     *
     * During subsequent runtime stamping (`instanceBinding==true`,
     *   `wasPreBound==false`): `_stampTemplate` calls `_bindTemplate(t, true)`
     *   - here `templateInfo` is guaranteed to _not_ match the prebound one,
     *   because it was either a different template altogether, or even if it
     *   was the same template, the step above created a instance of the info;
     *   in this case `wasPreBound == false`, so we _do_ create accessors, _and_
     *   link a instance into the linked list.
     */ /**
     * Equivalent to static `bindTemplate` API but can be called on an instance
     * to add effects at runtime.  See that method for full API docs.
     *
     * This method may be called on the prototype (for prototypical template
     * binding, to avoid creating accessors every instance) once per prototype,
     * and will be called with `runtimeBinding: true` by `_stampTemplate` to
     * create and link an instance of the template metadata associated with a
     * particular stamping.
     *
     * @override
     * @param {!HTMLTemplateElement} template Template containing binding
     * bindings
     * @param {boolean=} instanceBinding When false (default), performs
     * "prototypical" binding of the template and overwrites any previously
     * bound template for the class. When true (as passed from
     * `_stampTemplate`), the template info is instanced and linked into the
     * list of bound templates.
     * @return {!TemplateInfo} Template metadata object; for `runtimeBinding`,
     * this is an instance of the prototypical template info
     * @protected
     * @suppress {missingProperties} go/missingfnprops
     */ _bindTemplate(template, instanceBinding) {
            let templateInfo = this.constructor._parseTemplate(template);
            let wasPreBound = this.__preBoundTemplateInfo == templateInfo;
            // Optimization: since this is called twice for proto-bound templates,
            // don't attempt to recreate accessors if this template was pre-bound
            if (!wasPreBound) for(let prop in templateInfo.propertyEffects)this._createPropertyAccessor(prop);
            if (instanceBinding) {
                // For instance-time binding, create instance of template metadata
                // and link into tree of templates if necessary
                templateInfo = /** @type {!TemplateInfo} */ Object.create(templateInfo);
                templateInfo.wasPreBound = wasPreBound;
                if (!this.__templateInfo) // Set the info to the root of the tree
                this.__templateInfo = templateInfo;
                else {
                    // Append this template info onto the end of its parent template's
                    // list, which will determine the tree structure via which property
                    // effects are run; if this template was not nested in another
                    // template, use the root template (the first stamped one) as the
                    // parent. Note, `parent` is the `templateInfo` instance for this
                    // template's parent (containing) template, which was set up in
                    // `applyTemplateInfo`.  While a given template's `parent` is set
                    // apriori, it is only added to the parent's child list at the point
                    // that it is being bound, since a template may or may not ever be
                    // stamped, and may be stamped more than once (in which case instances
                    // of the template info will be in the tree under its parent more than
                    // once).
                    const parent = template._parentTemplateInfo || this.__templateInfo;
                    const previous = parent.lastChild;
                    templateInfo.parent = parent;
                    parent.lastChild = templateInfo;
                    templateInfo.previousSibling = previous;
                    if (previous) previous.nextSibling = templateInfo;
                    else parent.firstChild = templateInfo;
                }
            } else this.__preBoundTemplateInfo = templateInfo;
            return templateInfo;
        }
        /**
     * Adds a property effect to the given template metadata, which is run
     * at the "propagate" stage of `_propertiesChanged` when the template
     * has been bound to the element via `_bindTemplate`.
     *
     * The `effect` object should match the format in `_addPropertyEffect`.
     *
     * @param {Object} templateInfo Template metadata to add effect to
     * @param {string} prop Property that should trigger the effect
     * @param {Object=} effect Effect metadata object
     * @return {void}
     * @protected
     * @nocollapse
     */ static _addTemplatePropertyEffect(templateInfo, prop, effect) {
            let hostProps = templateInfo.hostProps = templateInfo.hostProps || {};
            hostProps[prop] = true;
            let effects = templateInfo.propertyEffects = templateInfo.propertyEffects || {};
            let propEffects = effects[prop] = effects[prop] || [];
            propEffects.push(effect);
        }
        /**
     * Stamps the provided template and performs instance-time setup for
     * Polymer template features, including data bindings, declarative event
     * listeners, and the `this.$` map of `id`'s to nodes.  A document fragment
     * is returned containing the stamped DOM, ready for insertion into the
     * DOM.
     *
     * This method may be called more than once; however note that due to
     * `shadycss` polyfill limitations, only styles from templates prepared
     * using `ShadyCSS.prepareTemplate` will be correctly polyfilled (scoped
     * to the shadow root and support CSS custom properties), and note that
     * `ShadyCSS.prepareTemplate` may only be called once per element. As such,
     * any styles required by in runtime-stamped templates must be included
     * in the main element template.
     *
     * @param {!HTMLTemplateElement} template Template to stamp
     * @param {TemplateInfo=} templateInfo Optional bound template info associated
     *   with the template to be stamped; if omitted the template will be
     *   automatically bound.
     * @return {!StampedTemplate} Cloned template content
     * @override
     * @protected
     */ _stampTemplate(template, templateInfo) {
            templateInfo = templateInfo || /** @type {!TemplateInfo} */ this._bindTemplate(template, true);
            // Ensures that created dom is `_enqueueClient`'d to this element so
            // that it can be flushed on next call to `_flushProperties`
            $1bac9b9e38435dd2$var$hostStack.push(this);
            let dom = super._stampTemplate(template, templateInfo);
            $1bac9b9e38435dd2$var$hostStack.pop();
            // Add template-instance-specific data to instanced templateInfo
            templateInfo.nodeList = dom.nodeList;
            // Capture child nodes to allow unstamping of non-prototypical templates
            if (!templateInfo.wasPreBound) {
                let nodes = templateInfo.childNodes = [];
                for(let n = dom.firstChild; n; n = n.nextSibling)nodes.push(n);
            }
            dom.templateInfo = templateInfo;
            // Setup compound storage, 2-way listeners, and dataHost for bindings
            $1bac9b9e38435dd2$var$setupBindings(this, templateInfo);
            // Flush properties into template nodes; the check on `__dataClientsReady`
            // ensures we don't needlessly run effects for an element's initial
            // prototypical template stamping since they will happen as a part of the
            // first call to `_propertiesChanged`. This flag is set to true
            // after running the initial propagate effects, and immediately before
            // flushing clients. Since downstream clients could cause stamping on
            // this host (e.g. a fastDomIf `dom-if` being forced to render
            // synchronously), this flag ensures effects for runtime-stamped templates
            // are run at this point during the initial element boot-up.
            if (this.__dataClientsReady) {
                this._runEffectsForTemplate(templateInfo, this.__data, null, false);
                this._flushClients();
            }
            return dom;
        }
        /**
     * Removes and unbinds the nodes previously contained in the provided
     * DocumentFragment returned from `_stampTemplate`.
     *
     * @override
     * @param {!StampedTemplate} dom DocumentFragment previously returned
     *   from `_stampTemplate` associated with the nodes to be removed
     * @return {void}
     * @protected
     */ _removeBoundDom(dom) {
            // Unlink template info; Note that while the child is unlinked from its
            // parent list, a template's `parent` reference is never removed, since
            // this is is determined by the tree structure and applied at
            // `applyTemplateInfo` time.
            const templateInfo = dom.templateInfo;
            const { previousSibling: previousSibling, nextSibling: nextSibling, parent: parent } = templateInfo;
            if (previousSibling) previousSibling.nextSibling = nextSibling;
            else if (parent) parent.firstChild = nextSibling;
            if (nextSibling) nextSibling.previousSibling = previousSibling;
            else if (parent) parent.lastChild = previousSibling;
            templateInfo.nextSibling = templateInfo.previousSibling = null;
            // Remove stamped nodes
            let nodes = templateInfo.childNodes;
            for(let i = 0; i < nodes.length; i++){
                let node = nodes[i];
                (0, $a2HIe.wrap)((0, $a2HIe.wrap)(node).parentNode).removeChild(node);
            }
        }
        /**
     * Overrides default `TemplateStamp` implementation to add support for
     * parsing bindings from `TextNode`'s' `textContent`.  A `bindings`
     * array is added to `nodeInfo` and populated with binding metadata
     * with information capturing the binding target, and a `parts` array
     * with one or more metadata objects capturing the source(s) of the
     * binding.
     *
     * @param {Node} node Node to parse
     * @param {TemplateInfo} templateInfo Template metadata for current template
     * @param {NodeInfo} nodeInfo Node metadata for current template node
     * @return {boolean} `true` if the visited node added node-specific
     *   metadata to `nodeInfo`
     * @protected
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */ static _parseTemplateNode(node, templateInfo, nodeInfo) {
            // TODO(https://github.com/google/closure-compiler/issues/3240):
            //     Change back to just super.methodCall()
            let noted = propertyEffectsBase._parseTemplateNode.call(this, node, templateInfo, nodeInfo);
            if (node.nodeType === Node.TEXT_NODE) {
                let parts = this._parseBindings(node.textContent, templateInfo);
                if (parts) {
                    // Initialize the textContent with any literal parts
                    // NOTE: default to a space here so the textNode remains; some browsers
                    // (IE) omit an empty textNode following cloneNode/importNode.
                    node.textContent = $1bac9b9e38435dd2$var$literalFromParts(parts) || ' ';
                    $1bac9b9e38435dd2$var$addBinding(this, templateInfo, nodeInfo, 'text', 'textContent', parts);
                    noted = true;
                }
            }
            return noted;
        }
        /**
     * Overrides default `TemplateStamp` implementation to add support for
     * parsing bindings from attributes.  A `bindings`
     * array is added to `nodeInfo` and populated with binding metadata
     * with information capturing the binding target, and a `parts` array
     * with one or more metadata objects capturing the source(s) of the
     * binding.
     *
     * @param {Element} node Node to parse
     * @param {TemplateInfo} templateInfo Template metadata for current template
     * @param {NodeInfo} nodeInfo Node metadata for current template node
     * @param {string} name Attribute name
     * @param {string} value Attribute value
     * @return {boolean} `true` if the visited node added node-specific
     *   metadata to `nodeInfo`
     * @protected
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */ static _parseTemplateNodeAttribute(node, templateInfo, nodeInfo, name, value) {
            let parts = this._parseBindings(value, templateInfo);
            if (parts) {
                // Attribute or property
                let origName = name;
                let kind = 'property';
                // The only way we see a capital letter here is if the attr has
                // a capital letter in it per spec. In this case, to make sure
                // this binding works, we go ahead and make the binding to the attribute.
                if ($1bac9b9e38435dd2$var$capitalAttributeRegex.test(name)) kind = 'attribute';
                else if (name[name.length - 1] == '$') {
                    name = name.slice(0, -1);
                    kind = 'attribute';
                }
                // Initialize attribute bindings with any literal parts
                let literal = $1bac9b9e38435dd2$var$literalFromParts(parts);
                if (literal && kind == 'attribute') {
                    // Ensure a ShadyCSS template scoped style is not removed
                    // when a class$ binding's initial literal value is set.
                    if (name == 'class' && node.hasAttribute('class')) literal += ' ' + node.getAttribute(name);
                    node.setAttribute(name, literal);
                }
                // support disable-upgrade
                if (kind == 'attribute' && origName == 'disable-upgrade$') node.setAttribute(name, '');
                // Clear attribute before removing, since IE won't allow removing
                // `value` attribute if it previously had a value (can't
                // unconditionally set '' before removing since attributes with `$`
                // can't be set using setAttribute)
                if (node.localName === 'input' && origName === 'value') node.setAttribute(origName, '');
                // Remove annotation
                node.removeAttribute(origName);
                // Case hackery: attributes are lower-case, but bind targets
                // (properties) are case sensitive. Gambit is to map dash-case to
                // camel-case: `foo-bar` becomes `fooBar`.
                // Attribute bindings are excepted.
                if (kind === 'property') name = (0, $dMJbi.dashToCamelCase)(name);
                $1bac9b9e38435dd2$var$addBinding(this, templateInfo, nodeInfo, kind, name, parts, literal);
                return true;
            } else // TODO(https://github.com/google/closure-compiler/issues/3240):
            //     Change back to just super.methodCall()
            return propertyEffectsBase._parseTemplateNodeAttribute.call(this, node, templateInfo, nodeInfo, name, value);
        }
        /**
     * Overrides default `TemplateStamp` implementation to add support for
     * binding the properties that a nested template depends on to the template
     * as `_host_<property>`.
     *
     * @param {Node} node Node to parse
     * @param {TemplateInfo} templateInfo Template metadata for current template
     * @param {NodeInfo} nodeInfo Node metadata for current template node
     * @return {boolean} `true` if the visited node added node-specific
     *   metadata to `nodeInfo`
     * @protected
     * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
     * @nocollapse
     */ static _parseTemplateNestedTemplate(node, templateInfo, nodeInfo) {
            // TODO(https://github.com/google/closure-compiler/issues/3240):
            //     Change back to just super.methodCall()
            let noted = propertyEffectsBase._parseTemplateNestedTemplate.call(this, node, templateInfo, nodeInfo);
            const parent = node.parentNode;
            const nestedTemplateInfo = nodeInfo.templateInfo;
            const isDomIf = parent.localName === 'dom-if';
            const isDomRepeat = parent.localName === 'dom-repeat';
            // Remove nested template and redirect its host bindings & templateInfo
            // onto the parent (dom-if/repeat element)'s nodeInfo
            if ((0, $8bEdR.removeNestedTemplates) && (isDomIf || isDomRepeat)) {
                parent.removeChild(node);
                // Use the parent's nodeInfo (for the dom-if/repeat) to record the
                // templateInfo, and use that for any host property bindings below
                nodeInfo = nodeInfo.parentInfo;
                nodeInfo.templateInfo = nestedTemplateInfo;
                // Ensure the parent dom-if/repeat is noted since it now may have host
                // bindings; it may not have been if it did not have its own bindings
                nodeInfo.noted = true;
                noted = false;
            }
            // Merge host props into outer template and add bindings
            let hostProps = nestedTemplateInfo.hostProps;
            if ((0, $8bEdR.fastDomIf) && isDomIf) // `fastDomIf` mode uses runtime-template stamping to add accessors/
            // effects to properties used in its template; as such we don't need to
            // tax the host element with `_host_` bindings for the `dom-if`.
            // However, in the event it is nested in a `dom-repeat`, it is still
            // important that its host properties are added to the
            // TemplateInstance's `hostProps` so that they are forwarded to the
            // TemplateInstance.
            {
                if (hostProps) {
                    templateInfo.hostProps = Object.assign(templateInfo.hostProps || {}, hostProps);
                    // Ensure the dom-if is noted so that it has a __dataHost, since
                    // `fastDomIf` uses the host for runtime template stamping; note this
                    // was already ensured above in the `removeNestedTemplates` case
                    if (!(0, $8bEdR.removeNestedTemplates)) nodeInfo.parentInfo.noted = true;
                }
            } else {
                let mode = '{';
                for(let source in hostProps){
                    let parts = [
                        {
                            mode: mode,
                            source: source,
                            dependencies: [
                                source
                            ],
                            hostProp: true
                        }
                    ];
                    $1bac9b9e38435dd2$var$addBinding(this, templateInfo, nodeInfo, 'property', '_host_' + source, parts);
                }
            }
            return noted;
        }
        /**
     * Called to parse text in a template (either attribute values or
     * textContent) into binding metadata.
     *
     * Any overrides of this method should return an array of binding part
     * metadata  representing one or more bindings found in the provided text
     * and any "literal" text in between.  Any non-literal parts will be passed
     * to `_evaluateBinding` when any dependencies change.  The only required
     * fields of each "part" in the returned array are as follows:
     *
     * - `dependencies` - Array containing trigger metadata for each property
     *   that should trigger the binding to update
     * - `literal` - String containing text if the part represents a literal;
     *   in this case no `dependencies` are needed
     *
     * Additional metadata for use by `_evaluateBinding` may be provided in
     * each part object as needed.
     *
     * The default implementation handles the following types of bindings
     * (one or more may be intermixed with literal strings):
     * - Property binding: `[[prop]]`
     * - Path binding: `[[object.prop]]`
     * - Negated property or path bindings: `[[!prop]]` or `[[!object.prop]]`
     * - Two-way property or path bindings (supports negation):
     *   `{{prop}}`, `{{object.prop}}`, `{{!prop}}` or `{{!object.prop}}`
     * - Inline computed method (supports negation):
     *   `[[compute(a, 'literal', b)]]`, `[[!compute(a, 'literal', b)]]`
     *
     * The default implementation uses a regular expression for best
     * performance. However, the regular expression uses a white-list of
     * allowed characters in a data-binding, which causes problems for
     * data-bindings that do use characters not in this white-list.
     *
     * Instead of updating the white-list with all allowed characters,
     * there is a StrictBindingParser (see lib/mixins/strict-binding-parser)
     * that uses a state machine instead. This state machine is able to handle
     * all characters. However, it is slightly less performant, therefore we
     * extracted it into a separate optional mixin.
     *
     * @param {string} text Text to parse from attribute or textContent
     * @param {Object} templateInfo Current template metadata
     * @return {Array<!BindingPart>} Array of binding part metadata
     * @protected
     * @nocollapse
     */ static _parseBindings(text, templateInfo) {
            let parts = [];
            let lastIndex = 0;
            let m;
            // Example: "literal1{{prop}}literal2[[!compute(foo,bar)]]final"
            // Regex matches:
            //        Iteration 1:  Iteration 2:
            // m[1]: '{{'          '[['
            // m[2]: ''            '!'
            // m[3]: 'prop'        'compute(foo,bar)'
            while((m = $1bac9b9e38435dd2$var$bindingRegex.exec(text)) !== null){
                // Add literal part
                if (m.index > lastIndex) parts.push({
                    literal: text.slice(lastIndex, m.index)
                });
                // Add binding part
                let mode = m[1][0];
                let negate = Boolean(m[2]);
                let source = m[3].trim();
                let customEvent = false, notifyEvent = '', colon = -1;
                if (mode == '{' && (colon = source.indexOf('::')) > 0) {
                    notifyEvent = source.substring(colon + 2);
                    source = source.substring(0, colon);
                    customEvent = true;
                }
                let signature = $1bac9b9e38435dd2$var$parseMethod(source);
                let dependencies = [];
                if (signature) {
                    // Inline computed function
                    let { args: args, methodName: methodName } = signature;
                    for(let i = 0; i < args.length; i++){
                        let arg = args[i];
                        if (!arg.literal) dependencies.push(arg);
                    }
                    let dynamicFns = templateInfo.dynamicFns;
                    if (dynamicFns && dynamicFns[methodName] || signature.static) {
                        dependencies.push(methodName);
                        signature.dynamicFn = true;
                    }
                } else // Property or path
                dependencies.push(source);
                parts.push({
                    source: source,
                    mode: mode,
                    negate: negate,
                    customEvent: customEvent,
                    signature: signature,
                    dependencies: dependencies,
                    event: notifyEvent
                });
                lastIndex = $1bac9b9e38435dd2$var$bindingRegex.lastIndex;
            }
            // Add a final literal part
            if (lastIndex && lastIndex < text.length) {
                let literal = text.substring(lastIndex);
                if (literal) parts.push({
                    literal: literal
                });
            }
            if (parts.length) return parts;
            else return null;
        }
        /**
     * Called to evaluate a previously parsed binding part based on a set of
     * one or more changed dependencies.
     *
     * @param {!Polymer_PropertyEffects} inst Element that should be used as
     *     scope for binding dependencies
     * @param {BindingPart} part Binding part metadata
     * @param {string} path Property/path that triggered this effect
     * @param {Object} props Bag of current property changes
     * @param {Object} oldProps Bag of previous values for changed properties
     * @param {boolean} hasPaths True with `props` contains one or more paths
     * @return {*} Value the binding part evaluated to
     * @protected
     * @nocollapse
     */ static _evaluateBinding(inst, part, path, props, oldProps, hasPaths) {
            let value;
            if (part.signature) value = $1bac9b9e38435dd2$var$runMethodEffect(inst, path, props, oldProps, part.signature);
            else if (path != part.source) value = (0, $kt4XD.get)(inst, part.source);
            else if (hasPaths && (0, $kt4XD.isPath)(path)) value = (0, $kt4XD.get)(inst, path);
            else value = inst.__data[path];
            if (part.negate) value = !value;
            return value;
        }
    }
    return PropertyEffects;
});
/**
 * Stack for enqueuing client dom created by a host element.
 *
 * By default elements are flushed via `_flushProperties` when
 * `connectedCallback` is called. Elements attach their client dom to
 * themselves at `ready` time which results from this first flush.
 * This provides an ordering guarantee that the client dom an element
 * creates is flushed before the element itself (i.e. client `ready`
 * fires before host `ready`).
 *
 * However, if `_flushProperties` is called *before* an element is connected,
 * as for example `Templatize` does, this ordering guarantee cannot be
 * satisfied because no elements are connected. (Note: Bound elements that
 * receive data do become enqueued clients and are properly ordered but
 * unbound elements are not.)
 *
 * To maintain the desired "client before host" ordering guarantee for this
 * case we rely on the "host stack. Client nodes registers themselves with
 * the creating host element when created. This ensures that all client dom
 * is readied in the proper order, maintaining the desired guarantee.
 *
 * @private
 */ const $1bac9b9e38435dd2$var$hostStack = [];

});
parcelRegister("a2HIe", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $74fbffa7bf3e6197$export$4997ffc0176396a6);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /* eslint-disable valid-jsdoc */ /**
 * Node wrapper to ensure ShadowDOM safe operation regardless of polyfill
 * presence or mode. Note that with the introduction of `ShadyDOM.noPatch`,
 * a node wrapper must be used to access ShadowDOM API.
 * This is similar to using `Polymer.dom` but relies exclusively
 * on the presence of the ShadyDOM polyfill rather than requiring the loading
 * of legacy (Polymer.dom) API.
 * @type {function(Node):Node}
 */ const $74fbffa7bf3e6197$export$4997ffc0176396a6 = window['ShadyDOM'] && window['ShadyDOM']['noPatch'] && window['ShadyDOM']['wrap'] ? window['ShadyDOM']['wrap'] : window['ShadyDOM'] ? (n)=>ShadyDOM['patch'](n) : (n)=>n;

});

parcelRegister("kt4XD", function(module, exports) {

$parcel$export(module.exports, "isPath", () => $ee6a5d2e4eff8625$export$50ae7fb6f87de989);
$parcel$export(module.exports, "root", () => $ee6a5d2e4eff8625$export$e8e78c978b129247);
$parcel$export(module.exports, "isAncestor", () => $ee6a5d2e4eff8625$export$efcd07cb4d32b055);
$parcel$export(module.exports, "isDescendant", () => $ee6a5d2e4eff8625$export$8503f9d2928f9a64);
$parcel$export(module.exports, "translate", () => $ee6a5d2e4eff8625$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "normalize", () => $ee6a5d2e4eff8625$export$a3295358bff77e);
$parcel$export(module.exports, "get", () => $ee6a5d2e4eff8625$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $ee6a5d2e4eff8625$export$adaa4cf7ef1b65be);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");
function $ee6a5d2e4eff8625$export$50ae7fb6f87de989(path) {
    return path.indexOf('.') >= 0;
}
function $ee6a5d2e4eff8625$export$e8e78c978b129247(path) {
    let dotIndex = path.indexOf('.');
    if (dotIndex === -1) return path;
    return path.slice(0, dotIndex);
}
function $ee6a5d2e4eff8625$export$efcd07cb4d32b055(base, path) {
    //     base.startsWith(path + '.');
    return base.indexOf(path + '.') === 0;
}
function $ee6a5d2e4eff8625$export$8503f9d2928f9a64(base, path) {
    //     path.startsWith(base + '.');
    return path.indexOf(base + '.') === 0;
}
function $ee6a5d2e4eff8625$export$d73ee8ef04f5226a(base, newBase, path) {
    return newBase + path.slice(base.length);
}
function $ee6a5d2e4eff8625$export$de994efd351b291c(base, path) {
    return base === path || $ee6a5d2e4eff8625$export$efcd07cb4d32b055(base, path) || $ee6a5d2e4eff8625$export$8503f9d2928f9a64(base, path);
}
function $ee6a5d2e4eff8625$export$a3295358bff77e(path) {
    if (Array.isArray(path)) {
        let parts = [];
        for(let i = 0; i < path.length; i++){
            let args = path[i].toString().split('.');
            for(let j = 0; j < args.length; j++)parts.push(args[j]);
        }
        return parts.join('.');
    } else return path;
}
function $ee6a5d2e4eff8625$export$65980d18b75784e2(path) {
    if (Array.isArray(path)) return $ee6a5d2e4eff8625$export$a3295358bff77e(path).split('.');
    return path.toString().split('.');
}
function $ee6a5d2e4eff8625$export$3988ae62b71be9a3(root, path, info) {
    let prop = root;
    let parts = $ee6a5d2e4eff8625$export$65980d18b75784e2(path);
    // Loop over path parts[0..n-1] and dereference
    for(let i = 0; i < parts.length; i++){
        if (!prop) return;
        let part = parts[i];
        prop = prop[part];
    }
    if (info) info.path = parts.join('.');
    return prop;
}
function $ee6a5d2e4eff8625$export$adaa4cf7ef1b65be(root, path, value) {
    let prop = root;
    let parts = $ee6a5d2e4eff8625$export$65980d18b75784e2(path);
    let last = parts[parts.length - 1];
    if (parts.length > 1) {
        // Loop over path parts[0..n-2] and dereference
        for(let i = 0; i < parts.length - 1; i++){
            let part = parts[i];
            prop = prop[part];
            if (!prop) return;
        }
        // Set value to object at end of path
        prop[last] = value;
    } else // Simple property set
    prop[path] = value;
    return parts.join('.');
}
const $ee6a5d2e4eff8625$export$3cbd53503d368157 = $ee6a5d2e4eff8625$export$50ae7fb6f87de989;

});

parcelRegister("dMJbi", function(module, exports) {

$parcel$export(module.exports, "dashToCamelCase", () => $a092ce15e85edd69$export$138f9917dd6248b4);
$parcel$export(module.exports, "camelToDashCase", () => $a092ce15e85edd69$export$6e116da553d9a4d8);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");
const $a092ce15e85edd69$var$caseMap = {};
const $a092ce15e85edd69$var$DASH_TO_CAMEL = /-[a-z]/g;
const $a092ce15e85edd69$var$CAMEL_TO_DASH = /([A-Z])/g;
function $a092ce15e85edd69$export$138f9917dd6248b4(dash) {
    return $a092ce15e85edd69$var$caseMap[dash] || ($a092ce15e85edd69$var$caseMap[dash] = dash.indexOf('-') < 0 ? dash : dash.replace($a092ce15e85edd69$var$DASH_TO_CAMEL, (m)=>m[1].toUpperCase()));
}
function $a092ce15e85edd69$export$6e116da553d9a4d8(camel) {
    return $a092ce15e85edd69$var$caseMap[camel] || ($a092ce15e85edd69$var$caseMap[camel] = camel.replace($a092ce15e85edd69$var$CAMEL_TO_DASH, '-$1').toLowerCase());
}

});

parcelRegister("4Oamu", function(module, exports) {

$parcel$export(module.exports, "PropertyAccessors", () => $3803de924db27048$export$46dc615e1ccbcbdc);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");

var $gLdkK = parcelRequire("gLdkK");

var $dMJbi = parcelRequire("dMJbi");

var $jwir5 = parcelRequire("jwir5");
// Save map of native properties; this forms a blacklist or properties
// that won't have their values "saved" by `saveAccessorValue`, since
// reading from an HTMLElement accessor from the context of a prototype throws
const $3803de924db27048$var$nativeProperties = {};
let $3803de924db27048$var$proto = HTMLElement.prototype;
while($3803de924db27048$var$proto){
    let props = Object.getOwnPropertyNames($3803de924db27048$var$proto);
    for(let i = 0; i < props.length; i++)$3803de924db27048$var$nativeProperties[props[i]] = true;
    $3803de924db27048$var$proto = Object.getPrototypeOf($3803de924db27048$var$proto);
}
const $3803de924db27048$var$isTrustedType = (()=>{
    if (!window.trustedTypes) return ()=>false;
    return (val)=>trustedTypes.isHTML(val) || trustedTypes.isScript(val) || trustedTypes.isScriptURL(val);
})();
/**
 * Used to save the value of a property that will be overridden with
 * an accessor. If the `model` is a prototype, the values will be saved
 * in `__dataProto`, and it's up to the user (or downstream mixin) to
 * decide how/when to set these values back into the accessors.
 * If `model` is already an instance (it has a `__data` property), then
 * the value will be set as a pending property, meaning the user should
 * call `_invalidateProperties` or `_flushProperties` to take effect
 *
 * @param {Object} model Prototype or instance
 * @param {string} property Name of property
 * @return {void}
 * @private
 */ function $3803de924db27048$var$saveAccessorValue(model, property) {
    // Don't read/store value for any native properties since they could throw
    if (!$3803de924db27048$var$nativeProperties[property]) {
        let value = model[property];
        if (value !== undefined) {
            if (model.__data) // Adding accessor to instance; update the property
            // It is the user's responsibility to call _flushProperties
            model._setPendingProperty(property, value);
            else {
                // Adding accessor to proto; save proto's value for instance-time use
                if (!model.__dataProto) model.__dataProto = {};
                else if (!model.hasOwnProperty(JSCompiler_renameProperty('__dataProto', model))) model.__dataProto = Object.create(model.__dataProto);
                model.__dataProto[property] = value;
            }
        }
    }
}
const $3803de924db27048$export$46dc615e1ccbcbdc = (0, $gLdkK.dedupingMixin)((superClass)=>{
    /**
   * @constructor
   * @implements {Polymer_PropertiesChanged}
   * @unrestricted
   * @private
   */ const base = (0, $jwir5.PropertiesChanged)(superClass);
    /**
   * @polymer
   * @mixinClass
   * @implements {Polymer_PropertyAccessors}
   * @extends {base}
   * @unrestricted
   */ class PropertyAccessors extends base {
        /**
     * Generates property accessors for all attributes in the standard
     * static `observedAttributes` array.
     *
     * Attribute names are mapped to property names using the `dash-case` to
     * `camelCase` convention
     *
     * @return {void}
     * @nocollapse
     */ static createPropertiesForAttributes() {
            let a$ = /** @type {?} */ this.observedAttributes;
            for(let i = 0; i < a$.length; i++)this.prototype._createPropertyAccessor((0, $dMJbi.dashToCamelCase)(a$[i]));
        }
        /**
     * Returns an attribute name that corresponds to the given property.
     * By default, converts camel to dash case, e.g. `fooBar` to `foo-bar`.
     * @param {string} property Property to convert
     * @return {string} Attribute name corresponding to the given property.
     *
     * @protected
     * @nocollapse
     */ static attributeNameForProperty(property) {
            return (0, $dMJbi.camelToDashCase)(property);
        }
        /**
     * Overrides PropertiesChanged implementation to initialize values for
     * accessors created for values that already existed on the element
     * prototype.
     *
     * @return {void}
     * @protected
     * @override
     */ _initializeProperties() {
            if (this.__dataProto) {
                this._initializeProtoProperties(this.__dataProto);
                this.__dataProto = null;
            }
            super._initializeProperties();
        }
        /**
     * Called at instance time with bag of properties that were overwritten
     * by accessors on the prototype when accessors were created.
     *
     * The default implementation sets these properties back into the
     * setter at instance time.  This method is provided as an override
     * point for customizing or providing more efficient initialization.
     *
     * @param {Object} props Bag of property values that were overwritten
     *   when creating property accessors.
     * @return {void}
     * @protected
     * @override
     */ _initializeProtoProperties(props) {
            for(let p in props)this._setProperty(p, props[p]);
        }
        /**
     * Ensures the element has the given attribute. If it does not,
     * assigns the given value to the attribute.
     *
     * @suppress {invalidCasts} Closure can't figure out `this` is infact an
     *     element
     *
     * @param {string} attribute Name of attribute to ensure is set.
     * @param {string} value of the attribute.
     * @return {void}
     * @override
     */ _ensureAttribute(attribute, value) {
            const el = /** @type {!HTMLElement} */ this;
            if (!el.hasAttribute(attribute)) this._valueToNodeAttribute(el, value, attribute);
        }
        /**
     * Overrides PropertiesChanged implemention to serialize objects as JSON.
     *
     * @param {*} value Property value to serialize.
     * @return {string | undefined} String serialized from the provided property
     *     value.
     * @override
     */ _serializeValue(value) {
            /* eslint-disable no-fallthrough */ switch(typeof value){
                case 'object':
                    if (value instanceof Date) return value.toString();
                    else if (value) {
                        if ($3803de924db27048$var$isTrustedType(value)) /**
               * Here `value` isn't actually a string, but it should be
               * passed into APIs that normally expect a string, like
               * elem.setAttribute.
               */ return /** @type {?} */ value;
                        try {
                            return JSON.stringify(value);
                        } catch (x) {
                            return '';
                        }
                    }
                default:
                    return super._serializeValue(value);
            }
        }
        /**
     * Converts a string to a typed JavaScript value.
     *
     * This method is called by Polymer when reading HTML attribute values to
     * JS properties.  Users may override this method on Polymer element
     * prototypes to provide deserialization for custom `type`s.  Note,
     * the `type` argument is the value of the `type` field provided in the
     * `properties` configuration object for a given property, and is
     * by convention the constructor for the type to deserialize.
     *
     *
     * @param {?string} value Attribute value to deserialize.
     * @param {*=} type Type to deserialize the string to.
     * @return {*} Typed value deserialized from the provided string.
     * @override
     */ _deserializeValue(value, type) {
            /**
       * @type {*}
       */ let outValue;
            switch(type){
                case Object:
                    try {
                        outValue = JSON.parse(/** @type {string} */ value);
                    } catch (x) {
                        // allow non-JSON literals like Strings and Numbers
                        outValue = value;
                    }
                    break;
                case Array:
                    try {
                        outValue = JSON.parse(/** @type {string} */ value);
                    } catch (x) {
                        outValue = null;
                        console.warn(`Polymer::Attributes: couldn't decode Array as JSON: ${value}`);
                    }
                    break;
                case Date:
                    outValue = isNaN(value) ? String(value) : Number(value);
                    outValue = new Date(outValue);
                    break;
                default:
                    outValue = super._deserializeValue(value, type);
                    break;
            }
            return outValue;
        }
        /* eslint-enable no-fallthrough */ /**
     * Overrides PropertiesChanged implementation to save existing prototype
     * property value so that it can be reset.
     * @param {string} property Name of the property
     * @param {boolean=} readOnly When true, no setter is created
     *
     * When calling on a prototype, any overwritten values are saved in
     * `__dataProto`, and it is up to the subclasser to decide how/when
     * to set those properties back into the accessor.  When calling on an
     * instance, the overwritten value is set via `_setPendingProperty`,
     * and the user should call `_invalidateProperties` or `_flushProperties`
     * for the values to take effect.
     * @protected
     * @return {void}
     * @override
     */ _definePropertyAccessor(property, readOnly) {
            $3803de924db27048$var$saveAccessorValue(this, property);
            super._definePropertyAccessor(property, readOnly);
        }
        /**
     * Returns true if this library created an accessor for the given property.
     *
     * @param {string} property Property name
     * @return {boolean} True if an accessor was created
     * @override
     */ _hasAccessor(property) {
            return this.__dataHasAccessor && this.__dataHasAccessor[property];
        }
        /**
     * Returns true if the specified property has a pending change.
     *
     * @param {string} prop Property name
     * @return {boolean} True if property has a pending change
     * @protected
     * @override
     */ _isPropertyPending(prop) {
            return Boolean(this.__dataPending && prop in this.__dataPending);
        }
    }
    return PropertyAccessors;
});

});
parcelRegister("jwir5", function(module, exports) {

$parcel$export(module.exports, "PropertiesChanged", () => $e35f4e7c763817f1$export$56259f45ca2fb97a);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");

var $gLdkK = parcelRequire("gLdkK");

var $e1Pzu = parcelRequire("e1Pzu");

var $a2HIe = parcelRequire("a2HIe");
/** @const {!AsyncInterface} */ const $e35f4e7c763817f1$var$microtask = (0, $e1Pzu.microTask);
const $e35f4e7c763817f1$export$56259f45ca2fb97a = (0, $gLdkK.dedupingMixin)(/**
     * @template T
     * @param {function(new:T)} superClass Class to apply mixin to.
     * @return {function(new:T)} superClass with mixin applied.
     */ (superClass)=>{
    /**
   * @polymer
   * @mixinClass
   * @implements {Polymer_PropertiesChanged}
   * @unrestricted
   */ class PropertiesChanged extends superClass {
        /**
     * Creates property accessors for the given property names.
     * @param {!Object} props Object whose keys are names of accessors.
     * @return {void}
     * @protected
     * @nocollapse
     */ static createProperties(props) {
            const proto = this.prototype;
            for(let prop in props)// don't stomp an existing accessor
            if (!(prop in proto)) proto._createPropertyAccessor(prop);
        }
        /**
     * Returns an attribute name that corresponds to the given property.
     * The attribute name is the lowercased property name. Override to
     * customize this mapping.
     * @param {string} property Property to convert
     * @return {string} Attribute name corresponding to the given property.
     *
     * @protected
     * @nocollapse
     */ static attributeNameForProperty(property) {
            return property.toLowerCase();
        }
        /**
     * Override point to provide a type to which to deserialize a value to
     * a given property.
     * @param {string} name Name of property
     *
     * @protected
     * @nocollapse
     */ static typeForProperty(name) {}
        /**
     * Creates a setter/getter pair for the named property with its own
     * local storage.  The getter returns the value in the local storage,
     * and the setter calls `_setProperty`, which updates the local storage
     * for the property and enqueues a `_propertiesChanged` callback.
     *
     * This method may be called on a prototype or an instance.  Calling
     * this method may overwrite a property value that already exists on
     * the prototype/instance by creating the accessor.
     *
     * @param {string} property Name of the property
     * @param {boolean=} readOnly When true, no setter is created; the
     *   protected `_setProperty` function must be used to set the property
     * @return {void}
     * @protected
     * @override
     */ _createPropertyAccessor(property, readOnly) {
            this._addPropertyToAttributeMap(property);
            if (!this.hasOwnProperty(JSCompiler_renameProperty('__dataHasAccessor', this))) this.__dataHasAccessor = Object.assign({}, this.__dataHasAccessor);
            if (!this.__dataHasAccessor[property]) {
                this.__dataHasAccessor[property] = true;
                this._definePropertyAccessor(property, readOnly);
            }
        }
        /**
     * Adds the given `property` to a map matching attribute names
     * to property names, using `attributeNameForProperty`. This map is
     * used when deserializing attribute values to properties.
     *
     * @param {string} property Name of the property
     * @override
     */ _addPropertyToAttributeMap(property) {
            if (!this.hasOwnProperty(JSCompiler_renameProperty('__dataAttributes', this))) this.__dataAttributes = Object.assign({}, this.__dataAttributes);
            // This check is technically not correct; it's an optimization that
            // assumes that if a _property_ name is already in the map (note this is
            // an attr->property map), the property mapped directly to the attribute
            // and it has already been mapped.  This would fail if
            // `attributeNameForProperty` were overridden such that this was not the
            // case.
            let attr = this.__dataAttributes[property];
            if (!attr) {
                attr = this.constructor.attributeNameForProperty(property);
                this.__dataAttributes[attr] = property;
            }
            return attr;
        }
        /**
     * Defines a property accessor for the given property.
     * @param {string} property Name of the property
     * @param {boolean=} readOnly When true, no setter is created
     * @return {void}
     * @override
     */ _definePropertyAccessor(property, readOnly) {
            Object.defineProperty(this, property, {
                /* eslint-disable valid-jsdoc */ /** @this {PropertiesChanged} */ get () {
                    // Inline for perf instead of using `_getProperty`
                    return this.__data[property];
                },
                /** @this {PropertiesChanged} */ set: readOnly ? function() {} : function(value) {
                    // Inline for perf instead of using `_setProperty`
                    if (this._setPendingProperty(property, value, true)) this._invalidateProperties();
                }
            });
        }
        constructor(){
            super();
            /** @type {boolean} */ this.__dataEnabled = false;
            this.__dataReady = false;
            this.__dataInvalid = false;
            this.__data = {};
            this.__dataPending = null;
            this.__dataOld = null;
            this.__dataInstanceProps = null;
            /** @type {number} */ // NOTE: used to track re-entrant calls to `_flushProperties`
            this.__dataCounter = 0;
            this.__serializing = false;
            this._initializeProperties();
        }
        /**
     * Lifecycle callback called when properties are enabled via
     * `_enableProperties`.
     *
     * Users may override this function to implement behavior that is
     * dependent on the element having its property data initialized, e.g.
     * from defaults (initialized from `constructor`, `_initializeProperties`),
     * `attributeChangedCallback`, or values propagated from host e.g. via
     * bindings.  `super.ready()` must be called to ensure the data system
     * becomes enabled.
     *
     * @return {void}
     * @public
     * @override
     */ ready() {
            this.__dataReady = true;
            this._flushProperties();
        }
        /**
     * Initializes the local storage for property accessors.
     *
     * Provided as an override point for performing any setup work prior
     * to initializing the property accessor system.
     *
     * @return {void}
     * @protected
     * @override
     */ _initializeProperties() {
            // Capture instance properties; these will be set into accessors
            // during first flush. Don't set them here, since we want
            // these to overwrite defaults/constructor assignments
            for(let p in this.__dataHasAccessor)if (this.hasOwnProperty(p)) {
                this.__dataInstanceProps = this.__dataInstanceProps || {};
                this.__dataInstanceProps[p] = this[p];
                delete this[p];
            }
        }
        /**
     * Called at ready time with bag of instance properties that overwrote
     * accessors when the element upgraded.
     *
     * The default implementation sets these properties back into the
     * setter at ready time.  This method is provided as an override
     * point for customizing or providing more efficient initialization.
     *
     * @param {Object} props Bag of property values that were overwritten
     *   when creating property accessors.
     * @return {void}
     * @protected
     * @override
     */ _initializeInstanceProperties(props) {
            Object.assign(this, props);
        }
        /**
     * Updates the local storage for a property (via `_setPendingProperty`)
     * and enqueues a `_proeprtiesChanged` callback.
     *
     * @param {string} property Name of the property
     * @param {*} value Value to set
     * @return {void}
     * @protected
     * @override
     */ _setProperty(property, value) {
            if (this._setPendingProperty(property, value)) this._invalidateProperties();
        }
        /**
     * Returns the value for the given property.
     * @param {string} property Name of property
     * @return {*} Value for the given property
     * @protected
     * @override
     */ _getProperty(property) {
            return this.__data[property];
        }
        /* eslint-disable no-unused-vars */ /**
     * Updates the local storage for a property, records the previous value,
     * and adds it to the set of "pending changes" that will be passed to the
     * `_propertiesChanged` callback.  This method does not enqueue the
     * `_propertiesChanged` callback.
     *
     * @param {string} property Name of the property
     * @param {*} value Value to set
     * @param {boolean=} ext Not used here; affordance for closure
     * @return {boolean} Returns true if the property changed
     * @protected
     * @override
     */ _setPendingProperty(property, value, ext) {
            let old = this.__data[property];
            let changed = this._shouldPropertyChange(property, value, old);
            if (changed) {
                if (!this.__dataPending) {
                    this.__dataPending = {};
                    this.__dataOld = {};
                }
                // Ensure old is captured from the last turn
                if (this.__dataOld && !(property in this.__dataOld)) this.__dataOld[property] = old;
                this.__data[property] = value;
                this.__dataPending[property] = value;
            }
            return changed;
        }
        /* eslint-enable */ /**
     * @param {string} property Name of the property
     * @return {boolean} Returns true if the property is pending.
     */ _isPropertyPending(property) {
            return !!(this.__dataPending && this.__dataPending.hasOwnProperty(property));
        }
        /**
     * Marks the properties as invalid, and enqueues an async
     * `_propertiesChanged` callback.
     *
     * @return {void}
     * @protected
     * @override
     */ _invalidateProperties() {
            if (!this.__dataInvalid && this.__dataReady) {
                this.__dataInvalid = true;
                $e35f4e7c763817f1$var$microtask.run(()=>{
                    if (this.__dataInvalid) {
                        this.__dataInvalid = false;
                        this._flushProperties();
                    }
                });
            }
        }
        /**
     * Call to enable property accessor processing. Before this method is
     * called accessor values will be set but side effects are
     * queued. When called, any pending side effects occur immediately.
     * For elements, generally `connectedCallback` is a normal spot to do so.
     * It is safe to call this method multiple times as it only turns on
     * property accessors once.
     *
     * @return {void}
     * @protected
     * @override
     */ _enableProperties() {
            if (!this.__dataEnabled) {
                this.__dataEnabled = true;
                if (this.__dataInstanceProps) {
                    this._initializeInstanceProperties(this.__dataInstanceProps);
                    this.__dataInstanceProps = null;
                }
                this.ready();
            }
        }
        /**
     * Calls the `_propertiesChanged` callback with the current set of
     * pending changes (and old values recorded when pending changes were
     * set), and resets the pending set of changes. Generally, this method
     * should not be called in user code.
     *
     * @return {void}
     * @protected
     * @override
     */ _flushProperties() {
            this.__dataCounter++;
            const props = this.__data;
            const changedProps = this.__dataPending;
            const old = this.__dataOld;
            if (this._shouldPropertiesChange(props, changedProps, old)) {
                this.__dataPending = null;
                this.__dataOld = null;
                this._propertiesChanged(props, changedProps, old);
            }
            this.__dataCounter--;
        }
        /**
     * Called in `_flushProperties` to determine if `_propertiesChanged`
     * should be called. The default implementation returns true if
     * properties are pending. Override to customize when
     * `_propertiesChanged` is called.
     * @param {!Object} currentProps Bag of all current accessor values
     * @param {?Object} changedProps Bag of properties changed since the last
     *   call to `_propertiesChanged`
     * @param {?Object} oldProps Bag of previous values for each property
     *   in `changedProps`
     * @return {boolean} true if changedProps is truthy
     * @override
     */ _shouldPropertiesChange(currentProps, changedProps, oldProps) {
            return Boolean(changedProps);
        }
        /**
     * Callback called when any properties with accessors created via
     * `_createPropertyAccessor` have been set.
     *
     * @param {!Object} currentProps Bag of all current accessor values
     * @param {?Object} changedProps Bag of properties changed since the last
     *   call to `_propertiesChanged`
     * @param {?Object} oldProps Bag of previous values for each property
     *   in `changedProps`
     * @return {void}
     * @protected
     * @override
     */ _propertiesChanged(currentProps, changedProps, oldProps) {}
        /**
     * Method called to determine whether a property value should be
     * considered as a change and cause the `_propertiesChanged` callback
     * to be enqueued.
     *
     * The default implementation returns `true` if a strict equality
     * check fails. The method always returns false for `NaN`.
     *
     * Override this method to e.g. provide stricter checking for
     * Objects/Arrays when using immutable patterns.
     *
     * @param {string} property Property name
     * @param {*} value New property value
     * @param {*} old Previous property value
     * @return {boolean} Whether the property should be considered a change
     *   and enqueue a `_proeprtiesChanged` callback
     * @protected
     * @override
     */ _shouldPropertyChange(property, value, old) {
            return(// Strict equality check
            old !== value && // This ensures (old==NaN, value==NaN) always returns false
            (old === old || value === value));
        }
        /**
     * Implements native Custom Elements `attributeChangedCallback` to
     * set an attribute value to a property via `_attributeToProperty`.
     *
     * @param {string} name Name of attribute that changed
     * @param {?string} old Old attribute value
     * @param {?string} value New attribute value
     * @param {?string} namespace Attribute namespace.
     * @return {void}
     * @suppress {missingProperties} Super may or may not implement the callback
     * @override
     */ attributeChangedCallback(name, old, value, namespace) {
            if (old !== value) this._attributeToProperty(name, value);
            if (super.attributeChangedCallback) super.attributeChangedCallback(name, old, value, namespace);
        }
        /**
     * Deserializes an attribute to its associated property.
     *
     * This method calls the `_deserializeValue` method to convert the string to
     * a typed value.
     *
     * @param {string} attribute Name of attribute to deserialize.
     * @param {?string} value of the attribute.
     * @param {*=} type type to deserialize to, defaults to the value
     * returned from `typeForProperty`
     * @return {void}
     * @override
     */ _attributeToProperty(attribute, value, type) {
            if (!this.__serializing) {
                const map = this.__dataAttributes;
                const property = map && map[attribute] || attribute;
                this[property] = this._deserializeValue(value, type || this.constructor.typeForProperty(property));
            }
        }
        /**
     * Serializes a property to its associated attribute.
     *
     * @suppress {invalidCasts} Closure can't figure out `this` is an element.
     *
     * @param {string} property Property name to reflect.
     * @param {string=} attribute Attribute name to reflect to.
     * @param {*=} value Property value to refect.
     * @return {void}
     * @override
     */ _propertyToAttribute(property, attribute, value) {
            this.__serializing = true;
            value = arguments.length < 3 ? this[property] : value;
            this._valueToNodeAttribute(/** @type {!HTMLElement} */ this, value, attribute || this.constructor.attributeNameForProperty(property));
            this.__serializing = false;
        }
        /**
     * Sets a typed value to an HTML attribute on a node.
     *
     * This method calls the `_serializeValue` method to convert the typed
     * value to a string.  If the `_serializeValue` method returns `undefined`,
     * the attribute will be removed (this is the default for boolean
     * type `false`).
     *
     * @param {Element} node Element to set attribute to.
     * @param {*} value Value to serialize.
     * @param {string} attribute Attribute name to serialize to.
     * @return {void}
     * @override
     */ _valueToNodeAttribute(node, value, attribute) {
            const str = this._serializeValue(value);
            if (attribute === 'class' || attribute === 'name' || attribute === 'slot') node = /** @type {?Element} */ (0, $a2HIe.wrap)(node);
            if (str === undefined) node.removeAttribute(attribute);
            else node.setAttribute(attribute, // Closure's type for `setAttribute`'s second parameter incorrectly
            // excludes `TrustedScript`.
            str === '' && window.trustedTypes ? /** @type {?} */ window.trustedTypes.emptyScript : str);
        }
        /**
     * Converts a typed JavaScript value to a string.
     *
     * This method is called when setting JS property values to
     * HTML attributes.  Users may override this method to provide
     * serialization for custom types.
     *
     * @param {*} value Property value to serialize.
     * @return {string | undefined} String serialized from the provided
     * property  value.
     * @override
     */ _serializeValue(value) {
            switch(typeof value){
                case 'boolean':
                    return value ? '' : undefined;
                default:
                    return value != null ? value.toString() : undefined;
            }
        }
        /**
     * Converts a string to a typed JavaScript value.
     *
     * This method is called when reading HTML attribute values to
     * JS properties.  Users may override this method to provide
     * deserialization for custom `type`s. Types for `Boolean`, `String`,
     * and `Number` convert attributes to the expected types.
     *
     * @param {?string} value Value to deserialize.
     * @param {*=} type Type to deserialize the string to.
     * @return {*} Typed value deserialized from the provided string.
     * @override
     */ _deserializeValue(value, type) {
            switch(type){
                case Boolean:
                    return value !== null;
                case Number:
                    return Number(value);
                default:
                    return value;
            }
        }
    }
    return PropertiesChanged;
});

});
parcelRegister("e1Pzu", function(module, exports) {

$parcel$export(module.exports, "microTask", () => $a36929b47f0d167c$export$a5ff0d6a738703ca);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /**
 * @fileoverview
 *
 * This module provides a number of strategies for enqueuing asynchronous
 * tasks. Each sub-module provides a standard `run(fn)` interface that returns a
 * handle, and a `cancel(handle)` interface for canceling async tasks before
 * they run.
 *
 * @summary Module that provides a number of strategies for enqueuing
 * asynchronous tasks.
 */ parcelRequire("dMwQI");
// Microtask implemented using Mutation Observer
let $a36929b47f0d167c$var$microtaskCurrHandle = 0;
let $a36929b47f0d167c$var$microtaskLastHandle = 0;
let $a36929b47f0d167c$var$microtaskCallbacks = [];
let $a36929b47f0d167c$var$microtaskNodeContent = 0;
let $a36929b47f0d167c$var$microtaskScheduled = false;
let $a36929b47f0d167c$var$microtaskNode = document.createTextNode('');
new window.MutationObserver($a36929b47f0d167c$var$microtaskFlush).observe($a36929b47f0d167c$var$microtaskNode, {
    characterData: true
});
function $a36929b47f0d167c$var$microtaskFlush() {
    $a36929b47f0d167c$var$microtaskScheduled = false;
    const len = $a36929b47f0d167c$var$microtaskCallbacks.length;
    for(let i = 0; i < len; i++){
        let cb = $a36929b47f0d167c$var$microtaskCallbacks[i];
        if (cb) try {
            cb();
        } catch (e) {
            setTimeout(()=>{
                throw e;
            });
        }
    }
    $a36929b47f0d167c$var$microtaskCallbacks.splice(0, len);
    $a36929b47f0d167c$var$microtaskLastHandle += len;
}
/**
 * Async interface wrapper around `setTimeout`.
 *
 * @namespace
 * @summary Async interface wrapper around `setTimeout`.
 */ const $a36929b47f0d167c$export$7af46e4bd307f4ab = {
    /**
   * Returns a sub-module with the async interface providing the provided
   * delay.
   *
   * @memberof timeOut
   * @param {number=} delay Time to wait before calling callbacks in ms
   * @return {!AsyncInterface} An async timeout interface
   */ after (delay) {
        return {
            run (fn) {
                return window.setTimeout(fn, delay);
            },
            cancel (handle) {
                window.clearTimeout(handle);
            }
        };
    },
    /**
   * Enqueues a function called in the next task.
   *
   * @memberof timeOut
   * @param {!Function} fn Callback to run
   * @param {number=} delay Delay in milliseconds
   * @return {number} Handle used for canceling task
   */ run (fn, delay) {
        return window.setTimeout(fn, delay);
    },
    /**
   * Cancels a previously enqueued `timeOut` callback.
   *
   * @memberof timeOut
   * @param {number} handle Handle returned from `run` of callback to cancel
   * @return {void}
   */ cancel (handle) {
        window.clearTimeout(handle);
    }
};
/**
 * Async interface wrapper around `requestAnimationFrame`.
 *
 * @namespace
 * @summary Async interface wrapper around `requestAnimationFrame`.
 */ const $a36929b47f0d167c$export$1402cba6a733f33a = {
    /**
   * Enqueues a function called at `requestAnimationFrame` timing.
   *
   * @memberof animationFrame
   * @param {function(number):void} fn Callback to run
   * @return {number} Handle used for canceling task
   */ run (fn) {
        return window.requestAnimationFrame(fn);
    },
    /**
   * Cancels a previously enqueued `animationFrame` callback.
   *
   * @memberof animationFrame
   * @param {number} handle Handle returned from `run` of callback to cancel
   * @return {void}
   */ cancel (handle) {
        window.cancelAnimationFrame(handle);
    }
};
/**
 * Async interface wrapper around `requestIdleCallback`.  Falls back to
 * `setTimeout` on browsers that do not support `requestIdleCallback`.
 *
 * @namespace
 * @summary Async interface wrapper around `requestIdleCallback`.
 */ const $a36929b47f0d167c$export$d113fed51d2d0fbd = {
    /**
   * Enqueues a function called at `requestIdleCallback` timing.
   *
   * @memberof idlePeriod
   * @param {function(!IdleDeadline):void} fn Callback to run
   * @return {number} Handle used for canceling task
   */ run (fn) {
        return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.setTimeout(fn, 16);
    },
    /**
   * Cancels a previously enqueued `idlePeriod` callback.
   *
   * @memberof idlePeriod
   * @param {number} handle Handle returned from `run` of callback to cancel
   * @return {void}
   */ cancel (handle) {
        window.cancelIdleCallback ? window.cancelIdleCallback(handle) : window.clearTimeout(handle);
    }
};
/**
 * Async interface for enqueuing callbacks that run at microtask timing.
 *
 * Note that microtask timing is achieved via a single `MutationObserver`,
 * and thus callbacks enqueued with this API will all run in a single
 * batch, and not interleaved with other microtasks such as promises.
 * Promises are avoided as an implementation choice for the time being
 * due to Safari bugs that cause Promises to lack microtask guarantees.
 *
 * @namespace
 * @summary Async interface for enqueuing callbacks that run at microtask
 *   timing.
 */ const $a36929b47f0d167c$export$a5ff0d6a738703ca = {
    /**
   * Enqueues a function called at microtask timing.
   *
   * @memberof microTask
   * @param {!Function=} callback Callback to run
   * @return {number} Handle used for canceling task
   */ run (callback) {
        if (!$a36929b47f0d167c$var$microtaskScheduled) {
            $a36929b47f0d167c$var$microtaskScheduled = true;
            $a36929b47f0d167c$var$microtaskNode.textContent = $a36929b47f0d167c$var$microtaskNodeContent++;
        }
        $a36929b47f0d167c$var$microtaskCallbacks.push(callback);
        return $a36929b47f0d167c$var$microtaskCurrHandle++;
    },
    /**
   * Cancels a previously enqueued `microTask` callback.
   *
   * @memberof microTask
   * @param {number} handle Handle returned from `run` of callback to cancel
   * @return {void}
   */ cancel (handle) {
        const idx = handle - $a36929b47f0d167c$var$microtaskLastHandle;
        if (idx >= 0) {
            if (!$a36929b47f0d167c$var$microtaskCallbacks[idx]) throw new Error('invalid async handle: ' + handle);
            $a36929b47f0d167c$var$microtaskCallbacks[idx] = null;
        }
    }
};

});



parcelRegister("jBFgP", function(module, exports) {

$parcel$export(module.exports, "TemplateStamp", () => $e4617c7af6a059f2$export$85889746a726e3b2);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");

var $gLdkK = parcelRequire("gLdkK");
// 1.x backwards-compatible auto-wrapper for template type extensions
// This is a clear layering violation and gives favored-nation status to
// dom-if and dom-repeat templates.  This is a conceit we're choosing to keep
// a.) to ease 1.x backwards-compatibility due to loss of `is`, and
// b.) to maintain if/repeat capability in parser-constrained elements
//     (e.g. table, select) in lieu of native CE type extensions without
//     massive new invention in this space (e.g. directive system)
const $e4617c7af6a059f2$var$templateExtensions = {
    'dom-if': true,
    'dom-repeat': true
};
let $e4617c7af6a059f2$var$placeholderBugDetect = false;
let $e4617c7af6a059f2$var$placeholderBug = false;
function $e4617c7af6a059f2$var$hasPlaceholderBug() {
    if (!$e4617c7af6a059f2$var$placeholderBugDetect) {
        $e4617c7af6a059f2$var$placeholderBugDetect = true;
        const t = document.createElement('textarea');
        t.placeholder = 'a';
        $e4617c7af6a059f2$var$placeholderBug = t.placeholder === t.textContent;
    }
    return $e4617c7af6a059f2$var$placeholderBug;
}
/**
 * Some browsers have a bug with textarea, where placeholder text is copied as
 * a textnode child of the textarea.
 *
 * If the placeholder is a binding, this can break template stamping in two
 * ways.
 *
 * One issue is that when the `placeholder` attribute is removed when the
 * binding is processed, the textnode child of the textarea is deleted, and the
 * template info tries to bind into that node.
 *
 * With `legacyOptimizations` in use, when the template is stamped and the
 * `textarea.textContent` binding is processed, no corresponding node is found
 * because it was removed during parsing. An exception is generated when this
 * binding is updated.
 *
 * With `legacyOptimizations` not in use, the template is cloned before
 * processing and this changes the above behavior. The cloned template also has
 * a value property set to the placeholder and textContent. This prevents the
 * removal of the textContent when the placeholder attribute is removed.
 * Therefore the exception does not occur. However, there is an extra
 * unnecessary binding.
 *
 * @param {!Node} node Check node for placeholder bug
 * @return {void}
 */ function $e4617c7af6a059f2$var$fixPlaceholder(node) {
    if ($e4617c7af6a059f2$var$hasPlaceholderBug() && node.localName === 'textarea' && node.placeholder && node.placeholder === node.textContent) node.textContent = null;
}
/**
 * Copies an attribute from one element to another, converting the value to a
 * `TrustedScript` if it is named like a Polymer template event listener.
 *
 * @param {!Element} dest The element to set the attribute on
 * @param {!Element} src The element to read the attribute from
 * @param {string} name The name of the attribute
 */ const $e4617c7af6a059f2$var$copyAttributeWithTemplateEventPolicy = (()=>{
    /**
   * This `TrustedTypePolicy` is used to work around a Chrome bug in the Trusted
   * Types API where any attribute that starts with `on` may only be set to a
   * `TrustedScript` value, even if that attribute would not cause an event
   * listener to be created. (See https://crbug.com/993268 for details.)
   *
   * Polymer's template system allows `<dom-if>` and `<dom-repeat>` to be
   * written using the `<template is="...">` syntax, even if there is no UA
   * support for custom element extensions of built-in elements. In doing so, it
   * copies attributes from the original `<template>` to a newly created
   * `<dom-if>` or `<dom-repeat>`, which can trigger the bug mentioned above if
   * any of those attributes uses Polymer's `on-` syntax for event listeners.
   * (Note, the value of these `on-` listeners is not evaluated as script: it is
   * the name of a member function of a component that will be used as the event
   * listener.)
   *
   * @type {!TrustedTypePolicy|undefined}
   */ const polymerTemplateEventAttributePolicy = window.trustedTypes && window.trustedTypes.createPolicy('polymer-template-event-attribute-policy', {
        createScript: (x)=>x
    });
    return (dest, src, name)=>{
        const value = src.getAttribute(name);
        if (polymerTemplateEventAttributePolicy && name.startsWith('on-')) {
            dest.setAttribute(name, polymerTemplateEventAttributePolicy.createScript(value, name));
            return;
        }
        dest.setAttribute(name, value);
    };
})();
function $e4617c7af6a059f2$var$wrapTemplateExtension(node) {
    let is = node.getAttribute('is');
    if (is && $e4617c7af6a059f2$var$templateExtensions[is]) {
        let t = node;
        t.removeAttribute('is');
        node = t.ownerDocument.createElement(is);
        t.parentNode.replaceChild(node, t);
        node.appendChild(t);
        while(t.attributes.length){
            const { name: name } = t.attributes[0];
            $e4617c7af6a059f2$var$copyAttributeWithTemplateEventPolicy(node, t, name);
            t.removeAttribute(name);
        }
    }
    return node;
}
function $e4617c7af6a059f2$var$findTemplateNode(root, nodeInfo) {
    // recursively ascend tree until we hit root
    let parent = nodeInfo.parentInfo && $e4617c7af6a059f2$var$findTemplateNode(root, nodeInfo.parentInfo);
    // unwind the stack, returning the indexed node at each level
    if (parent) // note: marginally faster than indexing via childNodes
    // (http://jsperf.com/childnodes-lookup)
    for(let n = parent.firstChild, i = 0; n; n = n.nextSibling){
        if (nodeInfo.parentIndex === i++) return n;
    }
    else return root;
}
// construct `$` map (from id annotations)
function $e4617c7af6a059f2$var$applyIdToMap(inst, map, node, nodeInfo) {
    if (nodeInfo.id) map[nodeInfo.id] = node;
}
// install event listeners (from event annotations)
function $e4617c7af6a059f2$var$applyEventListener(inst, node, nodeInfo) {
    if (nodeInfo.events && nodeInfo.events.length) for(let j = 0, e$ = nodeInfo.events, e; j < e$.length && (e = e$[j]); j++)inst._addMethodEventListenerToNode(node, e.name, e.value, inst);
}
// push configuration references at configure time
function $e4617c7af6a059f2$var$applyTemplateInfo(inst, node, nodeInfo, parentTemplateInfo) {
    if (nodeInfo.templateInfo) {
        // Give the node an instance of this templateInfo and set its parent
        node._templateInfo = nodeInfo.templateInfo;
        node._parentTemplateInfo = parentTemplateInfo;
    }
}
function $e4617c7af6a059f2$var$createNodeEventHandler(context, eventName, methodName) {
    // Instances can optionally have a _methodHost which allows redirecting where
    // to find methods. Currently used by `templatize`.
    context = context._methodHost || context;
    let handler = function(e) {
        if (context[methodName]) context[methodName](e, e.detail);
        else console.warn('listener method `' + methodName + '` not defined');
    };
    return handler;
}
const $e4617c7af6a059f2$export$85889746a726e3b2 = (0, $gLdkK.dedupingMixin)(/**
     * @template T
     * @param {function(new:T)} superClass Class to apply mixin to.
     * @return {function(new:T)} superClass with mixin applied.
     */ (superClass)=>{
    /**
   * @polymer
   * @mixinClass
   * @implements {Polymer_TemplateStamp}
   */ class TemplateStamp extends superClass {
        /**
     * Scans a template to produce template metadata.
     *
     * Template-specific metadata are stored in the object returned, and node-
     * specific metadata are stored in objects in its flattened `nodeInfoList`
     * array.  Only nodes in the template that were parsed as nodes of
     * interest contain an object in `nodeInfoList`.  Each `nodeInfo` object
     * contains an `index` (`childNodes` index in parent) and optionally
     * `parent`, which points to node info of its parent (including its index).
     *
     * The template metadata object returned from this method has the following
     * structure (many fields optional):
     *
     * ```js
     *   {
     *     // Flattened list of node metadata (for nodes that generated metadata)
     *     nodeInfoList: [
     *       {
     *         // `id` attribute for any nodes with id's for generating `$` map
     *         id: {string},
     *         // `on-event="handler"` metadata
     *         events: [
     *           {
     *             name: {string},   // event name
     *             value: {string},  // handler method name
     *           }, ...
     *         ],
     *         // Notes when the template contained a `<slot>` for shady DOM
     *         // optimization purposes
     *         hasInsertionPoint: {boolean},
     *         // For nested `<template>`` nodes, nested template metadata
     *         templateInfo: {object}, // nested template metadata
     *         // Metadata to allow efficient retrieval of instanced node
     *         // corresponding to this metadata
     *         parentInfo: {number},   // reference to parent nodeInfo>
     *         parentIndex: {number},  // index in parent's `childNodes` collection
     *         infoIndex: {number},    // index of this `nodeInfo` in `templateInfo.nodeInfoList`
     *       },
     *       ...
     *     ],
     *     // When true, the template had the `strip-whitespace` attribute
     *     // or was nested in a template with that setting
     *     stripWhitespace: {boolean},
     *     // For nested templates, nested template content is moved into
     *     // a document fragment stored here; this is an optimization to
     *     // avoid the cost of nested template cloning
     *     content: {DocumentFragment}
     *   }
     * ```
     *
     * This method kicks off a recursive treewalk as follows:
     *
     * ```
     *    _parseTemplate <---------------------+
     *      _parseTemplateContent              |
     *        _parseTemplateNode  <------------|--+
     *          _parseTemplateNestedTemplate --+  |
     *          _parseTemplateChildNodes ---------+
     *          _parseTemplateNodeAttributes
     *            _parseTemplateNodeAttribute
     *
     * ```
     *
     * These methods may be overridden to add custom metadata about templates
     * to either `templateInfo` or `nodeInfo`.
     *
     * Note that this method may be destructive to the template, in that
     * e.g. event annotations may be removed after being noted in the
     * template metadata.
     *
     * @param {!HTMLTemplateElement} template Template to parse
     * @param {TemplateInfo=} outerTemplateInfo Template metadata from the outer
     *   template, for parsing nested templates
     * @return {!TemplateInfo} Parsed template metadata
     * @nocollapse
     */ static _parseTemplate(template, outerTemplateInfo) {
            // since a template may be re-used, memo-ize metadata
            if (!template._templateInfo) {
                // TODO(rictic): fix typing
                let /** ? */ templateInfo = template._templateInfo = {};
                templateInfo.nodeInfoList = [];
                templateInfo.nestedTemplate = Boolean(outerTemplateInfo);
                templateInfo.stripWhiteSpace = outerTemplateInfo && outerTemplateInfo.stripWhiteSpace || template.hasAttribute && template.hasAttribute('strip-whitespace');
                // TODO(rictic): fix typing
                this._parseTemplateContent(template, templateInfo, /** @type {?} */ {
                    parent: null
                });
            }
            return template._templateInfo;
        }
        /**
     * See docs for _parseTemplateNode.
     *
     * @param {!HTMLTemplateElement} template .
     * @param {!TemplateInfo} templateInfo .
     * @param {!NodeInfo} nodeInfo .
     * @return {boolean} .
     * @nocollapse
     */ static _parseTemplateContent(template, templateInfo, nodeInfo) {
            return this._parseTemplateNode(template.content, templateInfo, nodeInfo);
        }
        /**
     * Parses template node and adds template and node metadata based on
     * the current node, and its `childNodes` and `attributes`.
     *
     * This method may be overridden to add custom node or template specific
     * metadata based on this node.
     *
     * @param {Node} node Node to parse
     * @param {!TemplateInfo} templateInfo Template metadata for current template
     * @param {!NodeInfo} nodeInfo Node metadata for current template.
     * @return {boolean} `true` if the visited node added node-specific
     *   metadata to `nodeInfo`
     * @nocollapse
     */ static _parseTemplateNode(node, templateInfo, nodeInfo) {
            let noted = false;
            let element = /** @type {!HTMLTemplateElement} */ node;
            if (element.localName == 'template' && !element.hasAttribute('preserve-content')) noted = this._parseTemplateNestedTemplate(element, templateInfo, nodeInfo) || noted;
            else if (element.localName === 'slot') // For ShadyDom optimization, indicating there is an insertion point
            templateInfo.hasInsertionPoint = true;
            $e4617c7af6a059f2$var$fixPlaceholder(element);
            if (element.firstChild) this._parseTemplateChildNodes(element, templateInfo, nodeInfo);
            if (element.hasAttributes && element.hasAttributes()) noted = this._parseTemplateNodeAttributes(element, templateInfo, nodeInfo) || noted;
            // Checking `nodeInfo.noted` allows a child node of this node (who gets
            // access to `parentInfo`) to cause the parent to be noted, which
            // otherwise has no return path via `_parseTemplateChildNodes` (used by
            // some optimizations)
            return noted || nodeInfo.noted;
        }
        /**
     * Parses template child nodes for the given root node.
     *
     * This method also wraps whitelisted legacy template extensions
     * (`is="dom-if"` and `is="dom-repeat"`) with their equivalent element
     * wrappers, collapses text nodes, and strips whitespace from the template
     * if the `templateInfo.stripWhitespace` setting was provided.
     *
     * @param {Node} root Root node whose `childNodes` will be parsed
     * @param {!TemplateInfo} templateInfo Template metadata for current template
     * @param {!NodeInfo} nodeInfo Node metadata for current template.
     * @return {void}
     */ static _parseTemplateChildNodes(root, templateInfo, nodeInfo) {
            if (root.localName === 'script' || root.localName === 'style') return;
            for(let node = root.firstChild, parentIndex = 0, next; node; node = next){
                // Wrap templates
                if (node.localName == 'template') node = $e4617c7af6a059f2$var$wrapTemplateExtension(node);
                // collapse adjacent textNodes: fixes an IE issue that can cause
                // text nodes to be inexplicably split =(
                // note that root.normalize() should work but does not so we do this
                // manually.
                next = node.nextSibling;
                if (node.nodeType === Node.TEXT_NODE) {
                    let /** Node */ n = next;
                    while(n && n.nodeType === Node.TEXT_NODE){
                        node.textContent += n.textContent;
                        next = n.nextSibling;
                        root.removeChild(n);
                        n = next;
                    }
                    // optionally strip whitespace
                    if (templateInfo.stripWhiteSpace && !node.textContent.trim()) {
                        root.removeChild(node);
                        continue;
                    }
                }
                let childInfo = /** @type {!NodeInfo} */ {
                    parentIndex: parentIndex,
                    parentInfo: nodeInfo
                };
                if (this._parseTemplateNode(node, templateInfo, childInfo)) childInfo.infoIndex = templateInfo.nodeInfoList.push(childInfo) - 1;
                // Increment if not removed
                if (node.parentNode) parentIndex++;
            }
        }
        /**
     * Parses template content for the given nested `<template>`.
     *
     * Nested template info is stored as `templateInfo` in the current node's
     * `nodeInfo`. `template.content` is removed and stored in `templateInfo`.
     * It will then be the responsibility of the host to set it back to the
     * template and for users stamping nested templates to use the
     * `_contentForTemplate` method to retrieve the content for this template
     * (an optimization to avoid the cost of cloning nested template content).
     *
     * @param {HTMLTemplateElement} node Node to parse (a <template>)
     * @param {TemplateInfo} outerTemplateInfo Template metadata for current template
     *   that includes the template `node`
     * @param {!NodeInfo} nodeInfo Node metadata for current template.
     * @return {boolean} `true` if the visited node added node-specific
     *   metadata to `nodeInfo`
     * @nocollapse
     */ static _parseTemplateNestedTemplate(node, outerTemplateInfo, nodeInfo) {
            // TODO(rictic): the type of node should be non-null
            let element = /** @type {!HTMLTemplateElement} */ node;
            let templateInfo = this._parseTemplate(element, outerTemplateInfo);
            let content = templateInfo.content = element.content.ownerDocument.createDocumentFragment();
            content.appendChild(element.content);
            nodeInfo.templateInfo = templateInfo;
            return true;
        }
        /**
     * Parses template node attributes and adds node metadata to `nodeInfo`
     * for nodes of interest.
     *
     * @param {Element} node Node to parse
     * @param {!TemplateInfo} templateInfo Template metadata for current
     *     template
     * @param {!NodeInfo} nodeInfo Node metadata for current template.
     * @return {boolean} `true` if the visited node added node-specific
     *   metadata to `nodeInfo`
     * @nocollapse
     */ static _parseTemplateNodeAttributes(node, templateInfo, nodeInfo) {
            // Make copy of original attribute list, since the order may change
            // as attributes are added and removed
            let noted = false;
            let attrs = Array.from(node.attributes);
            for(let i = attrs.length - 1, a; a = attrs[i]; i--)noted = this._parseTemplateNodeAttribute(node, templateInfo, nodeInfo, a.name, a.value) || noted;
            return noted;
        }
        /**
     * Parses a single template node attribute and adds node metadata to
     * `nodeInfo` for attributes of interest.
     *
     * This implementation adds metadata for `on-event="handler"` attributes
     * and `id` attributes.
     *
     * @param {Element} node Node to parse
     * @param {!TemplateInfo} templateInfo Template metadata for current template
     * @param {!NodeInfo} nodeInfo Node metadata for current template.
     * @param {string} name Attribute name
     * @param {string} value Attribute value
     * @return {boolean} `true` if the visited node added node-specific
     *   metadata to `nodeInfo`
     * @nocollapse
     */ static _parseTemplateNodeAttribute(node, templateInfo, nodeInfo, name, value) {
            // events (on-*)
            if (name.slice(0, 3) === 'on-') {
                node.removeAttribute(name);
                nodeInfo.events = nodeInfo.events || [];
                nodeInfo.events.push({
                    name: name.slice(3),
                    value: value
                });
                return true;
            } else if (name === 'id') {
                nodeInfo.id = value;
                return true;
            }
            return false;
        }
        /**
     * Returns the `content` document fragment for a given template.
     *
     * For nested templates, Polymer performs an optimization to cache nested
     * template content to avoid the cost of cloning deeply nested templates.
     * This method retrieves the cached content for a given template.
     *
     * @param {HTMLTemplateElement} template Template to retrieve `content` for
     * @return {DocumentFragment} Content fragment
     * @nocollapse
     */ static _contentForTemplate(template) {
            let templateInfo = /** @type {HTMLTemplateElementWithInfo} */ template._templateInfo;
            return templateInfo && templateInfo.content || template.content;
        }
        /**
     * Clones the provided template content and returns a document fragment
     * containing the cloned dom.
     *
     * The template is parsed (once and memoized) using this library's
     * template parsing features, and provides the following value-added
     * features:
     * * Adds declarative event listeners for `on-event="handler"` attributes
     * * Generates an "id map" for all nodes with id's under `$` on returned
     *   document fragment
     * * Passes template info including `content` back to templates as
     *   `_templateInfo` (a performance optimization to avoid deep template
     *   cloning)
     *
     * Note that the memoized template parsing process is destructive to the
     * template: attributes for bindings and declarative event listeners are
     * removed after being noted in notes, and any nested `<template>.content`
     * is removed and stored in notes as well.
     *
     * @param {!HTMLTemplateElement} template Template to stamp
     * @param {TemplateInfo=} templateInfo Optional template info associated
     *   with the template to be stamped; if omitted the template will be
     *   automatically parsed.
     * @return {!StampedTemplate} Cloned template content
     * @override
     */ _stampTemplate(template, templateInfo) {
            // Polyfill support: bootstrap the template if it has not already been
            if (template && !template.content && window.HTMLTemplateElement && HTMLTemplateElement.decorate) HTMLTemplateElement.decorate(template);
            // Accepting the `templateInfo` via an argument allows for creating
            // instances of the `templateInfo` by the caller, useful for adding
            // instance-time information to the prototypical data
            templateInfo = templateInfo || this.constructor._parseTemplate(template);
            let nodeInfo = templateInfo.nodeInfoList;
            let content = templateInfo.content || template.content;
            let dom = /** @type {DocumentFragment} */ document.importNode(content, true);
            // NOTE: ShadyDom optimization indicating there is an insertion point
            dom.__noInsertionPoint = !templateInfo.hasInsertionPoint;
            let nodes = dom.nodeList = new Array(nodeInfo.length);
            dom.$ = {};
            for(let i = 0, l = nodeInfo.length, info; i < l && (info = nodeInfo[i]); i++){
                let node = nodes[i] = $e4617c7af6a059f2$var$findTemplateNode(dom, info);
                $e4617c7af6a059f2$var$applyIdToMap(this, dom.$, node, info);
                $e4617c7af6a059f2$var$applyTemplateInfo(this, node, info, templateInfo);
                $e4617c7af6a059f2$var$applyEventListener(this, node, info);
            }
            /** @type {!StampedTemplate} */ dom; // eslint-disable-line no-self-assign
            return dom;
        }
        /**
     * Adds an event listener by method name for the event provided.
     *
     * This method generates a handler function that looks up the method
     * name at handling time.
     *
     * @param {!EventTarget} node Node to add listener on
     * @param {string} eventName Name of event
     * @param {string} methodName Name of method
     * @param {*=} context Context the method will be called on (defaults
     *   to `node`)
     * @return {Function} Generated handler function
     * @override
     */ _addMethodEventListenerToNode(node, eventName, methodName, context) {
            context = context || node;
            let handler = $e4617c7af6a059f2$var$createNodeEventHandler(context, eventName, methodName);
            this._addEventListenerToNode(node, eventName, handler);
            return handler;
        }
        /**
     * Override point for adding custom or simulated event handling.
     *
     * @param {!EventTarget} node Node to add event listener to
     * @param {string} eventName Name of event
     * @param {function(!Event):void} handler Listener function to add
     * @return {void}
     * @override
     */ _addEventListenerToNode(node, eventName, handler) {
            node.addEventListener(eventName, handler);
        }
        /**
     * Override point for adding custom or simulated event handling.
     *
     * @param {!EventTarget} node Node to remove event listener from
     * @param {string} eventName Name of event
     * @param {function(!Event):void} handler Listener function to remove
     * @return {void}
     * @override
     */ _removeEventListenerFromNode(node, eventName, handler) {
            node.removeEventListener(eventName, handler);
        }
    }
    return TemplateStamp;
});

});


parcelRegister("drPJO", function(module, exports) {

$parcel$export(module.exports, "PropertiesMixin", () => $9ca5ee09beb7034d$export$dbe246a3e2979375);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");

var $gLdkK = parcelRequire("gLdkK");

var $ifvit = parcelRequire("ifvit");

var $jwir5 = parcelRequire("jwir5");
/**
 * Creates a copy of `props` with each property normalized such that
 * upgraded it is an object with at least a type property { type: Type}.
 *
 * @param {!Object} props Properties to normalize
 * @return {!Object} Copy of input `props` with normalized properties that
 * are in the form {type: Type}
 * @private
 */ function $9ca5ee09beb7034d$var$normalizeProperties(props) {
    const output = {};
    for(let p in props){
        const o = props[p];
        output[p] = typeof o === 'function' ? {
            type: o
        } : o;
    }
    return output;
}
const $9ca5ee09beb7034d$export$dbe246a3e2979375 = (0, $gLdkK.dedupingMixin)((superClass)=>{
    /**
  * @constructor
  * @implements {Polymer_PropertiesChanged}
  * @private
  */ const base = (0, $jwir5.PropertiesChanged)(superClass);
    /**
  * Returns the super class constructor for the given class, if it is an
  * instance of the PropertiesMixin.
  *
  * @param {!PropertiesMixinConstructor} constructor PropertiesMixin constructor
  * @return {?PropertiesMixinConstructor} Super class constructor
  */ function superPropertiesClass(constructor) {
        const superCtor = Object.getPrototypeOf(constructor);
        // Note, the `PropertiesMixin` class below only refers to the class
        // generated by this call to the mixin; the instanceof test only works
        // because the mixin is deduped and guaranteed only to apply once, hence
        // all constructors in a proto chain will see the same `PropertiesMixin`
        return superCtor.prototype instanceof PropertiesMixin ? /** @type {!PropertiesMixinConstructor} */ superCtor : null;
    }
    /**
  * Returns a memoized version of the `properties` object for the
  * given class. Properties not in object format are converted to at
  * least {type}.
  *
  * @param {PropertiesMixinConstructor} constructor PropertiesMixin constructor
  * @return {Object} Memoized properties object
  */ function ownProperties(constructor) {
        if (!constructor.hasOwnProperty(JSCompiler_renameProperty('__ownProperties', constructor))) {
            let props = null;
            if (constructor.hasOwnProperty(JSCompiler_renameProperty('properties', constructor))) {
                const properties = constructor.properties;
                if (properties) props = $9ca5ee09beb7034d$var$normalizeProperties(properties);
            }
            constructor.__ownProperties = props;
        }
        return constructor.__ownProperties;
    }
    /**
  * @polymer
  * @mixinClass
  * @extends {base}
  * @implements {Polymer_PropertiesMixin}
  * @unrestricted
  */ class PropertiesMixin extends base {
        /**
    * Implements standard custom elements getter to observes the attributes
    * listed in `properties`.
    * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
    * @nocollapse
    */ static get observedAttributes() {
            if (!this.hasOwnProperty(JSCompiler_renameProperty('__observedAttributes', this))) {
                (0, $ifvit.register)(this.prototype);
                const props = this._properties;
                this.__observedAttributes = props ? Object.keys(props).map((p)=>this.prototype._addPropertyToAttributeMap(p)) : [];
            }
            return this.__observedAttributes;
        }
        /**
    * Finalizes an element definition, including ensuring any super classes
    * are also finalized. This includes ensuring property
    * accessors exist on the element prototype. This method calls
    * `_finalizeClass` to finalize each constructor in the prototype chain.
    * @return {void}
    * @nocollapse
    */ static finalize() {
            if (!this.hasOwnProperty(JSCompiler_renameProperty('__finalized', this))) {
                const superCtor = superPropertiesClass(/** @type {!PropertiesMixinConstructor} */ this);
                if (superCtor) superCtor.finalize();
                this.__finalized = true;
                this._finalizeClass();
            }
        }
        /**
    * Finalize an element class. This includes ensuring property
    * accessors exist on the element prototype. This method is called by
    * `finalize` and finalizes the class constructor.
    *
    * @protected
    * @nocollapse
    */ static _finalizeClass() {
            const props = ownProperties(/** @type {!PropertiesMixinConstructor} */ this);
            if (props) /** @type {?} */ this.createProperties(props);
        }
        /**
    * Returns a memoized version of all properties, including those inherited
    * from super classes. Properties not in object format are converted to
    * at least {type}.
    *
    * @return {Object} Object containing properties for this class
    * @protected
    * @nocollapse
    */ static get _properties() {
            if (!this.hasOwnProperty(JSCompiler_renameProperty('__properties', this))) {
                const superCtor = superPropertiesClass(/** @type {!PropertiesMixinConstructor} */ this);
                this.__properties = Object.assign({}, superCtor && superCtor._properties, ownProperties(/** @type {PropertiesMixinConstructor} */ this));
            }
            return this.__properties;
        }
        /**
    * Overrides `PropertiesChanged` method to return type specified in the
    * static `properties` object for the given property.
    * @param {string} name Name of property
    * @return {*} Type to which to deserialize attribute
    *
    * @protected
    * @nocollapse
    */ static typeForProperty(name) {
            const info = this._properties[name];
            return info && info.type;
        }
        /**
    * Overrides `PropertiesChanged` method and adds a call to
    * `finalize` which lazily configures the element's property accessors.
    * @override
    * @return {void}
    */ _initializeProperties() {
            (0, $ifvit.incrementInstanceCount)();
            this.constructor.finalize();
            super._initializeProperties();
        }
        /**
    * Called when the element is added to a document.
    * Calls `_enableProperties` to turn on property system from
    * `PropertiesChanged`.
    * @suppress {missingProperties} Super may or may not implement the callback
    * @return {void}
    * @override
    */ connectedCallback() {
            if (super.connectedCallback) super.connectedCallback();
            this._enableProperties();
        }
        /**
    * Called when the element is removed from a document
    * @suppress {missingProperties} Super may or may not implement the callback
    * @return {void}
    * @override
    */ disconnectedCallback() {
            if (super.disconnectedCallback) super.disconnectedCallback();
        }
    }
    return PropertiesMixin;
});

});
parcelRegister("ifvit", function(module, exports) {

$parcel$export(module.exports, "incrementInstanceCount", () => $d491e7a3e55c903f$export$9c049c8cca352360);
$parcel$export(module.exports, "register", () => $d491e7a3e55c903f$export$6503ec6e8aabbaf);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /**
 * Total number of Polymer element instances created.
 * @type {number}
 */ let $d491e7a3e55c903f$export$e810b950dd9f323b = 0;
function $d491e7a3e55c903f$export$9c049c8cca352360() {
    $d491e7a3e55c903f$export$e810b950dd9f323b++;
}
const $d491e7a3e55c903f$export$15a84f6b51e9d53e = [];
/**
 * @param {!PolymerElementConstructor} prototype Element prototype to log
 * @private
 */ function $d491e7a3e55c903f$var$_regLog(prototype) {
    console.log('[' + /** @type {?} */ prototype.is + ']: registered');
}
function $d491e7a3e55c903f$export$6503ec6e8aabbaf(prototype) {
    $d491e7a3e55c903f$export$15a84f6b51e9d53e.push(prototype);
}
function $d491e7a3e55c903f$export$13ec63b43a178734() {
    $d491e7a3e55c903f$export$15a84f6b51e9d53e.forEach($d491e7a3e55c903f$var$_regLog);
}

});



parcelRegister("76MHV", function(module, exports) {

$parcel$export(module.exports, "html", () => $52cee038c51ad986$export$c0bb0b647f701bb5);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");
/**
 * Our TrustedTypePolicy for HTML which is declared using the Polymer html
 * template tag function.
 *
 * That HTML is a developer-authored constant, and is parsed with innerHTML
 * before any untrusted expressions have been mixed in. Therefor it is
 * considered safe by construction.
 *
 * @type {!TrustedTypePolicy|undefined}
 */ const $52cee038c51ad986$var$policy = window.trustedTypes && trustedTypes.createPolicy('polymer-html-literal', {
    createHTML: (s)=>s
});
/**
 * Class representing a static string value which can be used to filter
 * strings by asseting that they have been created via this class. The
 * `value` property returns the string passed to the constructor.
 */ class $52cee038c51ad986$var$LiteralString {
    /**
   * @param {!ITemplateArray} strings Constant parts of tagged template literal
   * @param {!Array<*>} values Variable parts of tagged template literal
   */ constructor(strings, values){
        $52cee038c51ad986$var$assertValidTemplateStringParameters(strings, values);
        const string = values.reduce((acc, v, idx)=>acc + $52cee038c51ad986$var$literalValue(v) + strings[idx + 1], strings[0]);
        /** @type {string} */ this.value = string.toString();
    }
    /**
   * @return {string} LiteralString string value
   * @override
   */ toString() {
        return this.value;
    }
}
/**
 * @param {*} value Object to stringify into HTML
 * @return {string} HTML stringified form of `obj`
 */ function $52cee038c51ad986$var$literalValue(value) {
    if (value instanceof $52cee038c51ad986$var$LiteralString) return /** @type {!LiteralString} */ value.value;
    else throw new Error(`non-literal value passed to Polymer's htmlLiteral function: ${value}`);
}
/**
 * @param {*} value Object to stringify into HTML
 * @return {string} HTML stringified form of `obj`
 */ function $52cee038c51ad986$var$htmlValue(value) {
    if (value instanceof HTMLTemplateElement) // This might be an mXSS risk – mainly in the case where this template
    // contains untrusted content that was believed to be sanitized.
    // However we can't just use the XMLSerializer here because it misencodes
    // `>` characters inside style tags.
    // For an example of an actual case that hit this encoding issue,
    // see b/198592167
    return /** @type {!HTMLTemplateElement } */ value.innerHTML;
    else if (value instanceof $52cee038c51ad986$var$LiteralString) return $52cee038c51ad986$var$literalValue(value);
    else throw new Error(`non-template value passed to Polymer's html function: ${value}`);
}
const $52cee038c51ad986$export$c0bb0b647f701bb5 = function html(strings, ...values) {
    $52cee038c51ad986$var$assertValidTemplateStringParameters(strings, values);
    const template = /** @type {!HTMLTemplateElement} */ document.createElement('template');
    let value = values.reduce((acc, v, idx)=>acc + $52cee038c51ad986$var$htmlValue(v) + strings[idx + 1], strings[0]);
    if ($52cee038c51ad986$var$policy) value = $52cee038c51ad986$var$policy.createHTML(value);
    template.innerHTML = value;
    return template;
};
/**
 * @param {!ITemplateArray} strings Constant parts of tagged template literal
 * @param {!Array<*>} values Array of values from quasis
 */ const $52cee038c51ad986$var$assertValidTemplateStringParameters = (strings, values)=>{
    // Note: if/when https://github.com/tc39/proposal-array-is-template-object
    // is standardized, use that instead when available, as it can perform an
    // unforgable check (though of course, the function itself can be forged).
    if (!Array.isArray(strings) || !Array.isArray(strings.raw) || values.length !== strings.length - 1) // This is either caused by a browser bug, a compiler bug, or someone
    // calling the html template tag function as a regular function.
    //
    throw new TypeError('Invalid call to the html template tag');
};
const $52cee038c51ad986$export$7d4708dae82fef3d = function(strings, ...values) {
    return new $52cee038c51ad986$var$LiteralString(strings, values);
};

});


parcelRegister("is1HS", function(module, exports) {

$parcel$export(module.exports, "ActiveMixin", () => $d6ec2a6d478b4909$export$f2a2e4c8eff6418f);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $jf0Pl = parcelRequire("jf0Pl");

var $2cV7t = parcelRequire("2cV7t");

var $j2V0r = parcelRequire("j2V0r");
const $d6ec2a6d478b4909$export$f2a2e4c8eff6418f = (superclass)=>class ActiveMixinClass extends (0, $jf0Pl.DisabledMixin)((0, $j2V0r.KeyboardMixin)(superclass)) {
        /**
     * An array of activation keys.
     *
     * See possible values here:
     * https://developer.mozilla.org/ru/docs/Web/API/KeyboardEvent/key/Key_Values
     *
     * @protected
     * @return {!Array<!string>}
     */ get _activeKeys() {
            return [
                ' '
            ];
        }
        /** @protected */ ready() {
            super.ready();
            (0, $2cV7t.addListener)(this, 'down', (event)=>{
                if (this._shouldSetActive(event)) this._setActive(true);
            });
            (0, $2cV7t.addListener)(this, 'up', ()=>{
                this._setActive(false);
            });
        }
        /** @protected */ disconnectedCallback() {
            super.disconnectedCallback();
            // When the element is disconnecting from the DOM at the moment being active,
            // the `active` attribute needs to be manually removed from the element.
            // Otherwise, it will preserve on the element until the element is activated once again.
            // The case reproduces for `<vaadin-date-picker>` when closing on `Cancel` or `Today` click.
            this._setActive(false);
        }
        /**
     * @param {KeyboardEvent | MouseEvent} _event
     * @protected
     */ _shouldSetActive(_event) {
            return !this.disabled;
        }
        /**
     * Sets the `active` attribute on the element if an activation key is pressed.
     *
     * @param {KeyboardEvent} event
     * @protected
     * @override
     */ _onKeyDown(event) {
            super._onKeyDown(event);
            if (this._shouldSetActive(event) && this._activeKeys.includes(event.key)) {
                this._setActive(true);
                // Element can become hidden before the `keyup` event, e.g. on button click.
                // Use document listener to ensure `active` attribute is removed correctly.
                document.addEventListener('keyup', (e)=>{
                    if (this._activeKeys.includes(e.key)) this._setActive(false);
                }, {
                    once: true
                });
            }
        }
        /**
     * Toggles the `active` attribute on the element.
     *
     * @param {boolean} active
     * @protected
     */ _setActive(active) {
            this.toggleAttribute('active', active);
        }
    };

});
parcelRegister("jf0Pl", function(module, exports) {

$parcel$export(module.exports, "DisabledMixin", () => $e0200f4c70d5ff45$export$83c7154d706cc8d1);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");
const $e0200f4c70d5ff45$export$83c7154d706cc8d1 = (0, $gLdkK.dedupingMixin)((superclass)=>class DisabledMixinClass extends superclass {
        static get properties() {
            return {
                /**
           * If true, the user cannot interact with this element.
           */ disabled: {
                    type: Boolean,
                    value: false,
                    observer: '_disabledChanged',
                    reflectToAttribute: true
                }
            };
        }
        /**
       * @param {boolean} disabled
       * @protected
       */ _disabledChanged(disabled) {
            this._setAriaDisabled(disabled);
        }
        /**
       * @param {boolean} disabled
       * @protected
       */ _setAriaDisabled(disabled) {
            if (disabled) this.setAttribute('aria-disabled', 'true');
            else this.removeAttribute('aria-disabled');
        }
        /**
       * Overrides the default element `click` method in order to prevent
       * firing the `click` event when the element is disabled.
       * @protected
       * @override
       */ click() {
            if (!this.disabled) super.click();
        }
    });

});

parcelRegister("2cV7t", function(module, exports) {

$parcel$export(module.exports, "addListener", () => $19b9027cad025284$export$f03a6b845d3fb58b);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /**
 * @fileoverview
 *
 * Module for adding listeners to a node for the following normalized
 * cross-platform "gesture" events:
 * - `down` - mouse or touch went down
 * - `up` - mouse or touch went up
 * - `tap` - mouse click or finger tap
 * - `track` - mouse drag or touch move
 *
 * @summary Module for adding cross-platform gesture event listeners.
 */ 
var $cxRfu = parcelRequire("cxRfu");
const $19b9027cad025284$var$passiveTouchGestures = false;
const $19b9027cad025284$var$wrap = (node)=>node;
// Detect native touch action support
const $19b9027cad025284$var$HAS_NATIVE_TA = typeof document.head.style.touchAction === 'string';
const $19b9027cad025284$var$GESTURE_KEY = '__polymerGestures';
const $19b9027cad025284$var$HANDLED_OBJ = '__polymerGesturesHandled';
const $19b9027cad025284$var$TOUCH_ACTION = '__polymerGesturesTouchAction';
// Radius for tap and track
const $19b9027cad025284$var$TAP_DISTANCE = 25;
const $19b9027cad025284$var$TRACK_DISTANCE = 5;
// Number of last N track positions to keep
const $19b9027cad025284$var$TRACK_LENGTH = 2;
const $19b9027cad025284$var$MOUSE_EVENTS = [
    'mousedown',
    'mousemove',
    'mouseup',
    'click'
];
// An array of bitmask values for mapping MouseEvent.which to MouseEvent.buttons
const $19b9027cad025284$var$MOUSE_WHICH_TO_BUTTONS = [
    0,
    1,
    4,
    2
];
const $19b9027cad025284$var$MOUSE_HAS_BUTTONS = function() {
    try {
        return new MouseEvent('test', {
            buttons: 1
        }).buttons === 1;
    } catch (e) {
        return false;
    }
}();
/**
 * @param {string} name Possible mouse event name
 * @return {boolean} true if mouse event, false if not
 */ function $19b9027cad025284$var$isMouseEvent(name) {
    return $19b9027cad025284$var$MOUSE_EVENTS.indexOf(name) > -1;
}
/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */ // check for passive event listeners
let $19b9027cad025284$var$supportsPassive = false;
(function() {
    try {
        const opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line getter-return
            get () {
                $19b9027cad025284$var$supportsPassive = true;
            }
        });
        window.addEventListener('test', null, opts);
        window.removeEventListener('test', null, opts);
    } catch (e) {}
})();
/**
 * Generate settings for event listeners, dependant on `passiveTouchGestures`
 *
 * @param {string} eventName Event name to determine if `{passive}` option is
 *   needed
 * @return {{passive: boolean} | undefined} Options to use for addEventListener
 *   and removeEventListener
 */ function $19b9027cad025284$var$PASSIVE_TOUCH(eventName) {
    if ($19b9027cad025284$var$isMouseEvent(eventName) || eventName === 'touchend') return;
    if ($19b9027cad025284$var$HAS_NATIVE_TA && $19b9027cad025284$var$supportsPassive && $19b9027cad025284$var$passiveTouchGestures) return {
        passive: true
    };
}
// Check for touch-only devices
const $19b9027cad025284$var$IS_TOUCH_ONLY = navigator.userAgent.match(/iP(?:[oa]d|hone)|Android/);
// Defined at https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#enabling-and-disabling-form-controls:-the-disabled-attribute
/** @type {!Object<boolean>} */ const $19b9027cad025284$var$canBeDisabled = {
    button: true,
    command: true,
    fieldset: true,
    input: true,
    keygen: true,
    optgroup: true,
    option: true,
    select: true,
    textarea: true
};
/**
 * @param {MouseEvent} ev event to test for left mouse button down
 * @return {boolean} has left mouse button down
 */ function $19b9027cad025284$var$hasLeftMouseButton(ev) {
    const type = ev.type;
    // Exit early if the event is not a mouse event
    if (!$19b9027cad025284$var$isMouseEvent(type)) return false;
    // Ev.button is not reliable for mousemove (0 is overloaded as both left button and no buttons)
    // instead we use ev.buttons (bitmask of buttons) or fall back to ev.which (deprecated, 0 for no buttons, 1 for left button)
    if (type === 'mousemove') {
        // Allow undefined for testing events
        let buttons = ev.buttons === undefined ? 1 : ev.buttons;
        if (ev instanceof window.MouseEvent && !$19b9027cad025284$var$MOUSE_HAS_BUTTONS) buttons = $19b9027cad025284$var$MOUSE_WHICH_TO_BUTTONS[ev.which] || 0;
        // Buttons is a bitmask, check that the left button bit is set (1)
        return Boolean(buttons & 1);
    }
    // Allow undefined for testing events
    const button = ev.button === undefined ? 0 : ev.button;
    // Ev.button is 0 in mousedown/mouseup/click for left button activation
    return button === 0;
}
function $19b9027cad025284$var$isSyntheticClick(ev) {
    if (ev.type === 'click') {
        // Ev.detail is 0 for HTMLElement.click in most browsers
        if (ev.detail === 0) return true;
        // In the worst case, check that the x/y position of the click is within
        // the bounding box of the target of the event
        // Thanks IE 10 >:(
        const t = $19b9027cad025284$var$_findOriginalTarget(ev);
        // Make sure the target of the event is an element so we can use getBoundingClientRect,
        // if not, just assume it is a synthetic click
        if (!t.nodeType || /** @type {Element} */ t.nodeType !== Node.ELEMENT_NODE) return true;
        const bcr = /** @type {Element} */ t.getBoundingClientRect();
        // Use page x/y to account for scrolling
        const x = ev.pageX, y = ev.pageY;
        // Ev is a synthetic click if the position is outside the bounding box of the target
        return !(x >= bcr.left && x <= bcr.right && y >= bcr.top && y <= bcr.bottom);
    }
    return false;
}
const $19b9027cad025284$var$POINTERSTATE = {
    mouse: {
        target: null,
        mouseIgnoreJob: null
    },
    touch: {
        x: 0,
        y: 0,
        id: -1,
        scrollDecided: false
    }
};
function $19b9027cad025284$var$firstTouchAction(ev) {
    let ta = 'auto';
    const path = $19b9027cad025284$var$getComposedPath(ev);
    for(let i = 0, n; i < path.length; i++){
        n = path[i];
        if (n[$19b9027cad025284$var$TOUCH_ACTION]) {
            ta = n[$19b9027cad025284$var$TOUCH_ACTION];
            break;
        }
    }
    return ta;
}
function $19b9027cad025284$var$trackDocument(stateObj, movefn, upfn) {
    stateObj.movefn = movefn;
    stateObj.upfn = upfn;
    document.addEventListener('mousemove', movefn);
    document.addEventListener('mouseup', upfn);
}
function $19b9027cad025284$var$untrackDocument(stateObj) {
    document.removeEventListener('mousemove', stateObj.movefn);
    document.removeEventListener('mouseup', stateObj.upfn);
    stateObj.movefn = null;
    stateObj.upfn = null;
}
/**
 * Returns the composedPath for the given event.
 * @param {Event} event to process
 * @return {!Array<!EventTarget>} Path of the event
 */ const $19b9027cad025284$var$getComposedPath = window.ShadyDOM && window.ShadyDOM.noPatch ? window.ShadyDOM.composedPath : (event)=>event.composedPath && event.composedPath() || [];
const $19b9027cad025284$export$f3d9d3cca4871e8f = {};
const $19b9027cad025284$export$b69882218eff453f = [];
function $19b9027cad025284$export$fbb82389c3d3d990(x, y) {
    let node = document.elementFromPoint(x, y);
    let next = node;
    // This code path is only taken when native ShadowDOM is used
    // if there is a shadowroot, it may have a node at x/y
    // if there is not a shadowroot, exit the loop
    while(next && next.shadowRoot && !window.ShadyDOM){
        // If there is a node at x/y in the shadowroot, look deeper
        const oldNext = next;
        next = next.shadowRoot.elementFromPoint(x, y);
        // On Safari, elementFromPoint may return the shadowRoot host
        if (oldNext === next) break;
        if (next) node = next;
    }
    return node;
}
/**
 * A cheaper check than ev.composedPath()[0];
 *
 * @private
 * @param {Event|Touch} ev Event.
 * @return {EventTarget} Returns the event target.
 */ function $19b9027cad025284$var$_findOriginalTarget(ev) {
    const path = $19b9027cad025284$var$getComposedPath(/** @type {?Event} */ ev);
    // It shouldn't be, but sometimes path is empty (window on Safari).
    return path.length > 0 ? path[0] : ev.target;
}
/**
 * @private
 * @param {Event} ev Event.
 * @return {void}
 */ function $19b9027cad025284$var$_handleNative(ev) {
    const type = ev.type;
    const node = ev.currentTarget;
    const gobj = node[$19b9027cad025284$var$GESTURE_KEY];
    if (!gobj) return;
    const gs = gobj[type];
    if (!gs) return;
    if (!ev[$19b9027cad025284$var$HANDLED_OBJ]) {
        ev[$19b9027cad025284$var$HANDLED_OBJ] = {};
        if (type.startsWith('touch')) {
            const t = ev.changedTouches[0];
            if (type === 'touchstart') // Only handle the first finger
            {
                if (ev.touches.length === 1) $19b9027cad025284$var$POINTERSTATE.touch.id = t.identifier;
            }
            if ($19b9027cad025284$var$POINTERSTATE.touch.id !== t.identifier) return;
            if (!$19b9027cad025284$var$HAS_NATIVE_TA) {
                if (type === 'touchstart' || type === 'touchmove') $19b9027cad025284$var$_handleTouchAction(ev);
            }
        }
    }
    const handled = ev[$19b9027cad025284$var$HANDLED_OBJ];
    // Used to ignore synthetic mouse events
    if (handled.skip) return;
    // Reset recognizer state
    for(let i = 0, r; i < $19b9027cad025284$export$b69882218eff453f.length; i++){
        r = $19b9027cad025284$export$b69882218eff453f[i];
        if (gs[r.name] && !handled[r.name]) {
            if (r.flow && r.flow.start.indexOf(ev.type) > -1 && r.reset) r.reset();
        }
    }
    // Enforce gesture recognizer order
    for(let i = 0, r; i < $19b9027cad025284$export$b69882218eff453f.length; i++){
        r = $19b9027cad025284$export$b69882218eff453f[i];
        if (gs[r.name] && !handled[r.name]) {
            handled[r.name] = true;
            r[type](ev);
        }
    }
}
/**
 * @private
 * @param {TouchEvent} ev Event.
 * @return {void}
 */ function $19b9027cad025284$var$_handleTouchAction(ev) {
    const t = ev.changedTouches[0];
    const type = ev.type;
    if (type === 'touchstart') {
        $19b9027cad025284$var$POINTERSTATE.touch.x = t.clientX;
        $19b9027cad025284$var$POINTERSTATE.touch.y = t.clientY;
        $19b9027cad025284$var$POINTERSTATE.touch.scrollDecided = false;
    } else if (type === 'touchmove') {
        if ($19b9027cad025284$var$POINTERSTATE.touch.scrollDecided) return;
        $19b9027cad025284$var$POINTERSTATE.touch.scrollDecided = true;
        const ta = $19b9027cad025284$var$firstTouchAction(ev);
        let shouldPrevent = false;
        const dx = Math.abs($19b9027cad025284$var$POINTERSTATE.touch.x - t.clientX);
        const dy = Math.abs($19b9027cad025284$var$POINTERSTATE.touch.y - t.clientY);
        if (!ev.cancelable) ;
        else if (ta === 'none') shouldPrevent = true;
        else if (ta === 'pan-x') shouldPrevent = dy > dx;
        else if (ta === 'pan-y') shouldPrevent = dx > dy;
        if (shouldPrevent) ev.preventDefault();
        else $19b9027cad025284$export$7a90f3902ad9011('track');
    }
}
function $19b9027cad025284$export$f03a6b845d3fb58b(node, evType, handler) {
    if ($19b9027cad025284$export$f3d9d3cca4871e8f[evType]) {
        $19b9027cad025284$var$_add(node, evType, handler);
        return true;
    }
    return false;
}
function $19b9027cad025284$export$b03e9483f936dccb(node, evType, handler) {
    if ($19b9027cad025284$export$f3d9d3cca4871e8f[evType]) {
        $19b9027cad025284$var$_remove(node, evType, handler);
        return true;
    }
    return false;
}
/**
 * Automate the event listeners for the native events
 *
 * @private
 * @param {!EventTarget} node Node on which to add the event.
 * @param {string} evType Event type to add.
 * @param {function(!Event)} handler Event handler function.
 * @return {void}
 */ function $19b9027cad025284$var$_add(node, evType, handler) {
    const recognizer = $19b9027cad025284$export$f3d9d3cca4871e8f[evType];
    const deps = recognizer.deps;
    const name = recognizer.name;
    let gobj = node[$19b9027cad025284$var$GESTURE_KEY];
    if (!gobj) node[$19b9027cad025284$var$GESTURE_KEY] = gobj = {};
    for(let i = 0, dep, gd; i < deps.length; i++){
        dep = deps[i];
        // Don't add mouse handlers on iOS because they cause gray selection overlays
        if ($19b9027cad025284$var$IS_TOUCH_ONLY && $19b9027cad025284$var$isMouseEvent(dep) && dep !== 'click') continue;
        gd = gobj[dep];
        if (!gd) gobj[dep] = gd = {
            _count: 0
        };
        if (gd._count === 0) node.addEventListener(dep, $19b9027cad025284$var$_handleNative, $19b9027cad025284$var$PASSIVE_TOUCH(dep));
        gd[name] = (gd[name] || 0) + 1;
        gd._count = (gd._count || 0) + 1;
    }
    node.addEventListener(evType, handler);
    if (recognizer.touchAction) $19b9027cad025284$export$b9a326c8b85a6ce(node, recognizer.touchAction);
}
/**
 * Automate event listener removal for native events
 *
 * @private
 * @param {!EventTarget} node Node on which to remove the event.
 * @param {string} evType Event type to remove.
 * @param {function(!Event): void} handler Event handler function.
 * @return {void}
 */ function $19b9027cad025284$var$_remove(node, evType, handler) {
    const recognizer = $19b9027cad025284$export$f3d9d3cca4871e8f[evType];
    const deps = recognizer.deps;
    const name = recognizer.name;
    const gobj = node[$19b9027cad025284$var$GESTURE_KEY];
    if (gobj) for(let i = 0, dep, gd; i < deps.length; i++){
        dep = deps[i];
        gd = gobj[dep];
        if (gd && gd[name]) {
            gd[name] = (gd[name] || 1) - 1;
            gd._count = (gd._count || 1) - 1;
            if (gd._count === 0) node.removeEventListener(dep, $19b9027cad025284$var$_handleNative, $19b9027cad025284$var$PASSIVE_TOUCH(dep));
        }
    }
    node.removeEventListener(evType, handler);
}
function $19b9027cad025284$export$6503ec6e8aabbaf(recog) {
    $19b9027cad025284$export$b69882218eff453f.push(recog);
    for(let i = 0; i < recog.emits.length; i++)$19b9027cad025284$export$f3d9d3cca4871e8f[recog.emits[i]] = recog;
}
/**
 * @private
 * @param {string} evName Event name.
 * @return {Object} Returns the gesture for the given event name.
 */ function $19b9027cad025284$var$_findRecognizerByEvent(evName) {
    for(let i = 0, r; i < $19b9027cad025284$export$b69882218eff453f.length; i++){
        r = $19b9027cad025284$export$b69882218eff453f[i];
        for(let j = 0, n; j < r.emits.length; j++){
            n = r.emits[j];
            if (n === evName) return r;
        }
    }
    return null;
}
function $19b9027cad025284$export$b9a326c8b85a6ce(node, value) {
    if ($19b9027cad025284$var$HAS_NATIVE_TA && node instanceof HTMLElement) // NOTE: add touchAction async so that events can be added in
    // custom element constructors. Otherwise we run afoul of custom
    // elements restriction against settings attributes (style) in the
    // constructor.
    (0, $cxRfu.microTask).run(()=>{
        node.style.touchAction = value;
    });
    node[$19b9027cad025284$var$TOUCH_ACTION] = value;
}
/**
 * Dispatches an event on the `target` element of `type` with the given
 * `detail`.
 * @private
 * @param {!EventTarget} target The element on which to fire an event.
 * @param {string} type The type of event to fire.
 * @param {!Object=} detail The detail object to populate on the event.
 * @return {void}
 */ function $19b9027cad025284$var$_fire(target, type, detail) {
    const ev = new Event(type, {
        bubbles: true,
        cancelable: true,
        composed: true
    });
    ev.detail = detail;
    $19b9027cad025284$var$wrap(/** @type {!Node} */ target).dispatchEvent(ev);
    // Forward `preventDefault` in a clean way
    if (ev.defaultPrevented) {
        const preventer = detail.preventer || detail.sourceEvent;
        if (preventer && preventer.preventDefault) preventer.preventDefault();
    }
}
function $19b9027cad025284$export$7a90f3902ad9011(evName) {
    const recognizer = $19b9027cad025284$var$_findRecognizerByEvent(evName);
    if (recognizer.info) recognizer.info.prevent = true;
}
$19b9027cad025284$export$6503ec6e8aabbaf({
    name: 'downup',
    deps: [
        'mousedown',
        'touchstart',
        'touchend'
    ],
    flow: {
        start: [
            'mousedown',
            'touchstart'
        ],
        end: [
            'mouseup',
            'touchend'
        ]
    },
    emits: [
        'down',
        'up'
    ],
    info: {
        movefn: null,
        upfn: null
    },
    /**
   * @this {GestureRecognizer}
   * @return {void}
   */ reset () {
        $19b9027cad025284$var$untrackDocument(this.info);
    },
    /**
   * @this {GestureRecognizer}
   * @param {MouseEvent} e
   * @return {void}
   */ mousedown (e) {
        if (!$19b9027cad025284$var$hasLeftMouseButton(e)) return;
        const t = $19b9027cad025284$var$_findOriginalTarget(e);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const movefn = (e)=>{
            if (!$19b9027cad025284$var$hasLeftMouseButton(e)) {
                $19b9027cad025284$var$downupFire('up', t, e);
                $19b9027cad025284$var$untrackDocument(self.info);
            }
        };
        const upfn = (e)=>{
            if ($19b9027cad025284$var$hasLeftMouseButton(e)) $19b9027cad025284$var$downupFire('up', t, e);
            $19b9027cad025284$var$untrackDocument(self.info);
        };
        $19b9027cad025284$var$trackDocument(this.info, movefn, upfn);
        $19b9027cad025284$var$downupFire('down', t, e);
    },
    /**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */ touchstart (e) {
        $19b9027cad025284$var$downupFire('down', $19b9027cad025284$var$_findOriginalTarget(e), e.changedTouches[0], e);
    },
    /**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */ touchend (e) {
        $19b9027cad025284$var$downupFire('up', $19b9027cad025284$var$_findOriginalTarget(e), e.changedTouches[0], e);
    }
});
/**
 * @param {string} type
 * @param {EventTarget} target
 * @param {Event|Touch} event
 * @param {Event=} preventer
 * @return {void}
 */ function $19b9027cad025284$var$downupFire(type, target, event, preventer) {
    if (!target) return;
    $19b9027cad025284$var$_fire(target, type, {
        x: event.clientX,
        y: event.clientY,
        sourceEvent: event,
        preventer: preventer,
        prevent (e) {
            return $19b9027cad025284$export$7a90f3902ad9011(e);
        }
    });
}
$19b9027cad025284$export$6503ec6e8aabbaf({
    name: 'track',
    touchAction: 'none',
    deps: [
        'mousedown',
        'touchstart',
        'touchmove',
        'touchend'
    ],
    flow: {
        start: [
            'mousedown',
            'touchstart'
        ],
        end: [
            'mouseup',
            'touchend'
        ]
    },
    emits: [
        'track'
    ],
    info: {
        x: 0,
        y: 0,
        state: 'start',
        started: false,
        moves: [],
        /** @this {GestureInfo} */ addMove (move) {
            if (this.moves.length > $19b9027cad025284$var$TRACK_LENGTH) this.moves.shift();
            this.moves.push(move);
        },
        movefn: null,
        upfn: null,
        prevent: false
    },
    /**
   * @this {GestureRecognizer}
   * @return {void}
   */ reset () {
        this.info.state = 'start';
        this.info.started = false;
        this.info.moves = [];
        this.info.x = 0;
        this.info.y = 0;
        this.info.prevent = false;
        $19b9027cad025284$var$untrackDocument(this.info);
    },
    /**
   * @this {GestureRecognizer}
   * @param {MouseEvent} e
   * @return {void}
   */ mousedown (e) {
        if (!$19b9027cad025284$var$hasLeftMouseButton(e)) return;
        const t = $19b9027cad025284$var$_findOriginalTarget(e);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const movefn = (e)=>{
            const x = e.clientX, y = e.clientY;
            if ($19b9027cad025284$var$trackHasMovedEnough(self.info, x, y)) {
                // First move is 'start', subsequent moves are 'move', mouseup is 'end'
                self.info.state = self.info.started ? e.type === 'mouseup' ? 'end' : 'track' : 'start';
                if (self.info.state === 'start') // If and only if tracking, always prevent tap
                $19b9027cad025284$export$7a90f3902ad9011('tap');
                self.info.addMove({
                    x: x,
                    y: y
                });
                if (!$19b9027cad025284$var$hasLeftMouseButton(e)) {
                    // Always fire "end"
                    self.info.state = 'end';
                    $19b9027cad025284$var$untrackDocument(self.info);
                }
                if (t) $19b9027cad025284$var$trackFire(self.info, t, e);
                self.info.started = true;
            }
        };
        const upfn = (e)=>{
            if (self.info.started) movefn(e);
            // Remove the temporary listeners
            $19b9027cad025284$var$untrackDocument(self.info);
        };
        // Add temporary document listeners as mouse retargets
        $19b9027cad025284$var$trackDocument(this.info, movefn, upfn);
        this.info.x = e.clientX;
        this.info.y = e.clientY;
    },
    /**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */ touchstart (e) {
        const ct = e.changedTouches[0];
        this.info.x = ct.clientX;
        this.info.y = ct.clientY;
    },
    /**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */ touchmove (e) {
        const t = $19b9027cad025284$var$_findOriginalTarget(e);
        const ct = e.changedTouches[0];
        const x = ct.clientX, y = ct.clientY;
        if ($19b9027cad025284$var$trackHasMovedEnough(this.info, x, y)) {
            if (this.info.state === 'start') // If and only if tracking, always prevent tap
            $19b9027cad025284$export$7a90f3902ad9011('tap');
            this.info.addMove({
                x: x,
                y: y
            });
            $19b9027cad025284$var$trackFire(this.info, t, ct);
            this.info.state = 'track';
            this.info.started = true;
        }
    },
    /**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */ touchend (e) {
        const t = $19b9027cad025284$var$_findOriginalTarget(e);
        const ct = e.changedTouches[0];
        // Only trackend if track was started and not aborted
        if (this.info.started) {
            // Reset started state on up
            this.info.state = 'end';
            this.info.addMove({
                x: ct.clientX,
                y: ct.clientY
            });
            $19b9027cad025284$var$trackFire(this.info, t, ct);
        }
    }
});
/**
 * @param {!GestureInfo} info
 * @param {number} x
 * @param {number} y
 * @return {boolean}
 */ function $19b9027cad025284$var$trackHasMovedEnough(info, x, y) {
    if (info.prevent) return false;
    if (info.started) return true;
    const dx = Math.abs(info.x - x);
    const dy = Math.abs(info.y - y);
    return dx >= $19b9027cad025284$var$TRACK_DISTANCE || dy >= $19b9027cad025284$var$TRACK_DISTANCE;
}
/**
 * @param {!GestureInfo} info
 * @param {?EventTarget} target
 * @param {Touch} touch
 * @return {void}
 */ function $19b9027cad025284$var$trackFire(info, target, touch) {
    if (!target) return;
    const secondlast = info.moves[info.moves.length - 2];
    const lastmove = info.moves[info.moves.length - 1];
    const dx = lastmove.x - info.x;
    const dy = lastmove.y - info.y;
    let ddx, ddy = 0;
    if (secondlast) {
        ddx = lastmove.x - secondlast.x;
        ddy = lastmove.y - secondlast.y;
    }
    $19b9027cad025284$var$_fire(target, 'track', {
        state: info.state,
        x: touch.clientX,
        y: touch.clientY,
        dx: dx,
        dy: dy,
        ddx: ddx,
        ddy: ddy,
        sourceEvent: touch,
        hover () {
            return $19b9027cad025284$export$fbb82389c3d3d990(touch.clientX, touch.clientY);
        }
    });
}
$19b9027cad025284$export$6503ec6e8aabbaf({
    name: 'tap',
    deps: [
        'mousedown',
        'click',
        'touchstart',
        'touchend'
    ],
    flow: {
        start: [
            'mousedown',
            'touchstart'
        ],
        end: [
            'click',
            'touchend'
        ]
    },
    emits: [
        'tap'
    ],
    info: {
        x: NaN,
        y: NaN,
        prevent: false
    },
    /**
   * @this {GestureRecognizer}
   * @return {void}
   */ reset () {
        this.info.x = NaN;
        this.info.y = NaN;
        this.info.prevent = false;
    },
    /**
   * @this {GestureRecognizer}
   * @param {MouseEvent} e
   * @return {void}
   */ mousedown (e) {
        if ($19b9027cad025284$var$hasLeftMouseButton(e)) {
            this.info.x = e.clientX;
            this.info.y = e.clientY;
        }
    },
    /**
   * @this {GestureRecognizer}
   * @param {MouseEvent} e
   * @return {void}
   */ click (e) {
        if ($19b9027cad025284$var$hasLeftMouseButton(e)) $19b9027cad025284$var$trackForward(this.info, e);
    },
    /**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */ touchstart (e) {
        const touch = e.changedTouches[0];
        this.info.x = touch.clientX;
        this.info.y = touch.clientY;
    },
    /**
   * @this {GestureRecognizer}
   * @param {TouchEvent} e
   * @return {void}
   */ touchend (e) {
        $19b9027cad025284$var$trackForward(this.info, e.changedTouches[0], e);
    }
});
/**
 * @param {!GestureInfo} info
 * @param {Event | Touch} e
 * @param {Event=} preventer
 * @return {void}
 */ function $19b9027cad025284$var$trackForward(info, e, preventer) {
    const dx = Math.abs(e.clientX - info.x);
    const dy = Math.abs(e.clientY - info.y);
    // Find original target from `preventer` for TouchEvents, or `e` for MouseEvents
    const t = $19b9027cad025284$var$_findOriginalTarget(preventer || e);
    if (!t || $19b9027cad025284$var$canBeDisabled[/** @type {!HTMLElement} */ t.localName] && t.hasAttribute('disabled')) return;
    // Dx,dy can be NaN if `click` has been simulated and there was no `down` for `start`
    if (isNaN(dx) || isNaN(dy) || dx <= $19b9027cad025284$var$TAP_DISTANCE && dy <= $19b9027cad025284$var$TAP_DISTANCE || $19b9027cad025284$var$isSyntheticClick(e)) // Prevent taps from being generated if an event has canceled them
    {
        if (!info.prevent) $19b9027cad025284$var$_fire(t, 'tap', {
            x: e.clientX,
            y: e.clientY,
            sourceEvent: e,
            preventer: preventer
        });
    }
}

});
parcelRegister("cxRfu", function(module, exports) {

$parcel$export(module.exports, "timeOut", () => $9221df3900932205$export$7af46e4bd307f4ab);
$parcel$export(module.exports, "animationFrame", () => $9221df3900932205$export$1402cba6a733f33a);
$parcel$export(module.exports, "idlePeriod", () => $9221df3900932205$export$d113fed51d2d0fbd);
$parcel$export(module.exports, "microTask", () => $9221df3900932205$export$a5ff0d6a738703ca);
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */ /**
 * @fileoverview
 *
 * This module provides a number of strategies for enqueuing asynchronous
 * tasks. Each sub-module provides a standard `run(fn)` interface that returns a
 * handle, and a `cancel(handle)` interface for canceling async tasks before
 * they run.
 *
 * @summary Module that provides a number of strategies for enqueuing
 * asynchronous tasks.
 */ // Microtask implemented using Mutation Observer
let $9221df3900932205$var$microtaskCurrHandle = 0;
let $9221df3900932205$var$microtaskLastHandle = 0;
const $9221df3900932205$var$microtaskCallbacks = [];
let $9221df3900932205$var$microtaskNodeContent = 0;
let $9221df3900932205$var$microtaskScheduled = false;
const $9221df3900932205$var$microtaskNode = document.createTextNode('');
new window.MutationObserver($9221df3900932205$var$microtaskFlush).observe($9221df3900932205$var$microtaskNode, {
    characterData: true
});
function $9221df3900932205$var$microtaskFlush() {
    $9221df3900932205$var$microtaskScheduled = false;
    const len = $9221df3900932205$var$microtaskCallbacks.length;
    for(let i = 0; i < len; i++){
        const cb = $9221df3900932205$var$microtaskCallbacks[i];
        if (cb) try {
            cb();
        } catch (e) {
            setTimeout(()=>{
                throw e;
            });
        }
    }
    $9221df3900932205$var$microtaskCallbacks.splice(0, len);
    $9221df3900932205$var$microtaskLastHandle += len;
}
/**
 * Async interface wrapper around `setTimeout`.
 *
 * @namespace
 * @summary Async interface wrapper around `setTimeout`.
 */ const $9221df3900932205$export$7af46e4bd307f4ab = {
    /**
   * Returns a sub-module with the async interface providing the provided
   * delay.
   *
   * @memberof timeOut
   * @param {number=} delay Time to wait before calling callbacks in ms
   * @return {!AsyncInterface} An async timeout interface
   */ after (delay) {
        return {
            run (fn) {
                return window.setTimeout(fn, delay);
            },
            cancel (handle) {
                window.clearTimeout(handle);
            }
        };
    },
    /**
   * Enqueues a function called in the next task.
   *
   * @memberof timeOut
   * @param {!Function} fn Callback to run
   * @param {number=} delay Delay in milliseconds
   * @return {number} Handle used for canceling task
   */ run (fn, delay) {
        return window.setTimeout(fn, delay);
    },
    /**
   * Cancels a previously enqueued `timeOut` callback.
   *
   * @memberof timeOut
   * @param {number} handle Handle returned from `run` of callback to cancel
   * @return {void}
   */ cancel (handle) {
        window.clearTimeout(handle);
    }
};
/**
 * Async interface wrapper around `requestAnimationFrame`.
 *
 * @namespace
 * @summary Async interface wrapper around `requestAnimationFrame`.
 */ const $9221df3900932205$export$1402cba6a733f33a = {
    /**
   * Enqueues a function called at `requestAnimationFrame` timing.
   *
   * @memberof animationFrame
   * @param {function(number):void} fn Callback to run
   * @return {number} Handle used for canceling task
   */ run (fn) {
        return window.requestAnimationFrame(fn);
    },
    /**
   * Cancels a previously enqueued `animationFrame` callback.
   *
   * @memberof animationFrame
   * @param {number} handle Handle returned from `run` of callback to cancel
   * @return {void}
   */ cancel (handle) {
        window.cancelAnimationFrame(handle);
    }
};
/**
 * Async interface wrapper around `requestIdleCallback`.  Falls back to
 * `setTimeout` on browsers that do not support `requestIdleCallback`.
 *
 * @namespace
 * @summary Async interface wrapper around `requestIdleCallback`.
 */ const $9221df3900932205$export$d113fed51d2d0fbd = {
    /**
   * Enqueues a function called at `requestIdleCallback` timing.
   *
   * @memberof idlePeriod
   * @param {function(!IdleDeadline):void} fn Callback to run
   * @return {number} Handle used for canceling task
   */ run (fn) {
        return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.setTimeout(fn, 16);
    },
    /**
   * Cancels a previously enqueued `idlePeriod` callback.
   *
   * @memberof idlePeriod
   * @param {number} handle Handle returned from `run` of callback to cancel
   * @return {void}
   */ cancel (handle) {
        if (window.cancelIdleCallback) window.cancelIdleCallback(handle);
        else window.clearTimeout(handle);
    }
};
/**
 * Async interface for enqueuing callbacks that run at microtask timing.
 *
 * Note that microtask timing is achieved via a single `MutationObserver`,
 * and thus callbacks enqueued with this API will all run in a single
 * batch, and not interleaved with other microtasks such as promises.
 * Promises are avoided as an implementation choice for the time being
 * due to Safari bugs that cause Promises to lack microtask guarantees.
 *
 * @namespace
 * @summary Async interface for enqueuing callbacks that run at microtask
 *   timing.
 */ const $9221df3900932205$export$a5ff0d6a738703ca = {
    /**
   * Enqueues a function called at microtask timing.
   *
   * @memberof microTask
   * @param {!Function=} callback Callback to run
   * @return {number} Handle used for canceling task
   */ run (callback) {
        if (!$9221df3900932205$var$microtaskScheduled) {
            $9221df3900932205$var$microtaskScheduled = true;
            $9221df3900932205$var$microtaskNode.textContent = $9221df3900932205$var$microtaskNodeContent;
            $9221df3900932205$var$microtaskNodeContent += 1;
        }
        $9221df3900932205$var$microtaskCallbacks.push(callback);
        const result = $9221df3900932205$var$microtaskCurrHandle;
        $9221df3900932205$var$microtaskCurrHandle += 1;
        return result;
    },
    /**
   * Cancels a previously enqueued `microTask` callback.
   *
   * @memberof microTask
   * @param {number} handle Handle returned from `run` of callback to cancel
   * @return {void}
   */ cancel (handle) {
        const idx = handle - $9221df3900932205$var$microtaskLastHandle;
        if (idx >= 0) {
            if (!$9221df3900932205$var$microtaskCallbacks[idx]) throw new Error(`invalid async handle: ${handle}`);
            $9221df3900932205$var$microtaskCallbacks[idx] = null;
        }
    }
};

});


parcelRegister("j2V0r", function(module, exports) {

$parcel$export(module.exports, "KeyboardMixin", () => $ddda6c70a7aff6f9$export$cd590db40e972a72);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");
const $ddda6c70a7aff6f9$export$cd590db40e972a72 = (0, $gLdkK.dedupingMixin)((superclass)=>class KeyboardMixinClass extends superclass {
        /** @protected */ ready() {
            super.ready();
            this.addEventListener('keydown', (event)=>{
                this._onKeyDown(event);
            });
            this.addEventListener('keyup', (event)=>{
                this._onKeyUp(event);
            });
        }
        /**
       * A handler for the `keydown` event. By default, it calls
       * separate methods for handling "Enter" and "Escape" keys.
       * Override the method to implement your own behavior.
       *
       * @param {KeyboardEvent} event
       * @protected
       */ _onKeyDown(event) {
            switch(event.key){
                case 'Enter':
                    this._onEnter(event);
                    break;
                case 'Escape':
                    this._onEscape(event);
                    break;
                default:
                    break;
            }
        }
        /**
       * A handler for the `keyup` event. By default, it does nothing.
       * Override the method to implement your own behavior.
       *
       * @param {KeyboardEvent} _event
       * @protected
       */ _onKeyUp(_event) {
        // To be implemented.
        }
        /**
       * A handler for the "Enter" key. By default, it does nothing.
       * Override the method to implement your own behavior.
       *
       * @param {KeyboardEvent} _event
       * @protected
       */ _onEnter(_event) {
        // To be implemented.
        }
        /**
       * A handler for the "Escape" key. By default, it does nothing.
       * Override the method to implement your own behavior.
       *
       * @param {KeyboardEvent} _event
       * @protected
       */ _onEscape(_event) {
        // To be implemented.
        }
    });

});


parcelRegister("bthO9", function(module, exports) {

$parcel$export(module.exports, "ControllerMixin", () => $85a037674e161f7e$export$4e79e6459bae3ad);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");
const $85a037674e161f7e$export$4e79e6459bae3ad = (0, $gLdkK.dedupingMixin)((superClass)=>class ControllerMixinClass extends superClass {
        constructor(){
            super();
            /**
         * @type {Set<ReactiveController>}
         */ this.__controllers = new Set();
        }
        /** @protected */ connectedCallback() {
            super.connectedCallback();
            this.__controllers.forEach((c)=>{
                if (c.hostConnected) c.hostConnected();
            });
        }
        /** @protected */ disconnectedCallback() {
            super.disconnectedCallback();
            this.__controllers.forEach((c)=>{
                if (c.hostDisconnected) c.hostDisconnected();
            });
        }
        /**
       * Registers a controller to participate in the element update cycle.
       *
       * @param {ReactiveController} controller
       * @protected
       */ addController(controller) {
            this.__controllers.add(controller);
            // Call hostConnected if a controller is added after the element is attached.
            if (this.$ !== undefined && this.isConnected && controller.hostConnected) controller.hostConnected();
        }
        /**
       * Removes a controller from the element.
       *
       * @param {ReactiveController} controller
       * @protected
       */ removeController(controller) {
            this.__controllers.delete(controller);
        }
    });

});

parcelRegister("9Q7uu", function(module, exports) {

$parcel$export(module.exports, "ElementMixin", () => $729ec7eabd45574a$export$6154786385672f5d);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $8bEdR = parcelRequire("8bEdR");
parcelRequire("91NOX");
var $jCoGi = parcelRequire("jCoGi");

var $cxRfu = parcelRequire("cxRfu");

var $jlr9D = parcelRequire("jlr9D");

var $5ncN0 = parcelRequire("5ncN0");
// This setting affects the legacy Polymer gestures which get activated
// once you import any iron component e.g iron-icon.
// It has to be explicitly disabled to prevent click issues in iOS + VoiceOver
// for buttons that are based on `[role=button]` e.g vaadin-button.
(0, $8bEdR.setCancelSyntheticClickEvents)(false);
window.Vaadin = window.Vaadin || {};
/**
 * Array of Vaadin custom element classes that have been finalized.
 */ window.Vaadin.registrations = window.Vaadin.registrations || [];
window.Vaadin.developmentModeCallback = window.Vaadin.developmentModeCallback || {};
window.Vaadin.developmentModeCallback['vaadin-usage-statistics'] = function() {
    (0, $jCoGi.usageStatistics)();
};
let $729ec7eabd45574a$var$statsJob;
const $729ec7eabd45574a$var$registered = new Set();
const $729ec7eabd45574a$export$6154786385672f5d = (superClass)=>class VaadinElementMixin extends (0, $5ncN0.DirMixin)(superClass) {
        static get version() {
            return '23.3.8';
        }
        /** @protected */ static finalize() {
            super.finalize();
            const { is: is } = this;
            // Registers a class prototype for telemetry purposes.
            if (is && !$729ec7eabd45574a$var$registered.has(is)) {
                window.Vaadin.registrations.push(this);
                $729ec7eabd45574a$var$registered.add(is);
                if (window.Vaadin.developmentModeCallback) {
                    $729ec7eabd45574a$var$statsJob = (0, $jlr9D.Debouncer).debounce($729ec7eabd45574a$var$statsJob, (0, $cxRfu.idlePeriod), ()=>{
                        window.Vaadin.developmentModeCallback['vaadin-usage-statistics']();
                    });
                    (0, $jlr9D.enqueueDebouncer)($729ec7eabd45574a$var$statsJob);
                }
            }
        }
        constructor(){
            super();
            if (document.doctype === null) console.warn('Vaadin components require the "standards mode" declaration. Please add <!DOCTYPE html> to the HTML document.');
        }
    };

});
parcelRegister("91NOX", function(module, exports) {
$parcel$export(module.exports, "usageStatistics", () => (parcelRequire("jCoGi")).usageStatistics);
parcelRequire("jCoGi");

});
parcelRegister("jCoGi", function(module, exports) {

$parcel$export(module.exports, "usageStatistics", () => $e484b6184280f288$export$32d884d7346a67c0);
/* This file is autogenerated from src/vaadin-usage-statistics.tpl.html */ /*

This script gathers usage statistics from the application running in development mode.

Statistics gathering is automatically disabled and excluded from production builds.

For details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.

*/ /*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/ 
var $cj8N6 = parcelRequire("cj8N6");
function $e484b6184280f288$var$maybeGatherAndSendStats() {
/** vaadin-dev-mode:start
  (function () {
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var getPolymerVersion = function getPolymerVersion() {
  return window.Polymer && window.Polymer.version;
};

var StatisticsGatherer = function () {
  function StatisticsGatherer(logger) {
    classCallCheck(this, StatisticsGatherer);

    this.now = new Date().getTime();
    this.logger = logger;
  }

  createClass(StatisticsGatherer, [{
    key: 'frameworkVersionDetectors',
    value: function frameworkVersionDetectors() {
      return {
        'Flow': function Flow() {
          if (window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients) {
            var flowVersions = Object.keys(window.Vaadin.Flow.clients).map(function (key) {
              return window.Vaadin.Flow.clients[key];
            }).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().flow;
            });
            if (flowVersions.length > 0) {
              return flowVersions[0];
            }
          }
        },
        'Vaadin Framework': function VaadinFramework() {
          if (window.vaadin && window.vaadin.clients) {
            var frameworkVersions = Object.values(window.vaadin.clients).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().vaadinVersion;
            });
            if (frameworkVersions.length > 0) {
              return frameworkVersions[0];
            }
          }
        },
        'AngularJs': function AngularJs() {
          if (window.angular && window.angular.version && window.angular.version) {
            return window.angular.version.full;
          }
        },
        'Angular': function Angular() {
          if (window.ng) {
            var tags = document.querySelectorAll("[ng-version]");
            if (tags.length > 0) {
              return tags[0].getAttribute("ng-version");
            }
            return "Unknown";
          }
        },
        'Backbone.js': function BackboneJs() {
          if (window.Backbone) {
            return window.Backbone.VERSION;
          }
        },
        'React': function React() {
          var reactSelector = '[data-reactroot], [data-reactid]';
          if (!!document.querySelector(reactSelector)) {
            // React does not publish the version by default
            return "unknown";
          }
        },
        'Ember': function Ember() {
          if (window.Em && window.Em.VERSION) {
            return window.Em.VERSION;
          } else if (window.Ember && window.Ember.VERSION) {
            return window.Ember.VERSION;
          }
        },
        'jQuery': function (_jQuery) {
          function jQuery() {
            return _jQuery.apply(this, arguments);
          }

          jQuery.toString = function () {
            return _jQuery.toString();
          };

          return jQuery;
        }(function () {
          if (typeof jQuery === 'function' && jQuery.prototype.jquery !== undefined) {
            return jQuery.prototype.jquery;
          }
        }),
        'Polymer': function Polymer() {
          var version = getPolymerVersion();
          if (version) {
            return version;
          }
        },
        'LitElement': function LitElement() {
          var version = window.litElementVersions && window.litElementVersions[0];
          if (version) {
            return version;
          }
        },
        'LitHtml': function LitHtml() {
          var version = window.litHtmlVersions && window.litHtmlVersions[0];
          if (version) {
            return version;
          }
        },
        'Vue.js': function VueJs() {
          if (window.Vue) {
            return window.Vue.version;
          }
        }
      };
    }
  }, {
    key: 'getUsedVaadinElements',
    value: function getUsedVaadinElements(elements) {
      var version = getPolymerVersion();
      var elementClasses = void 0;
      // NOTE: In case you edit the code here, YOU MUST UPDATE any statistics reporting code in Flow.
      // Check all locations calling the method getEntries() in
      // https://github.com/vaadin/flow/blob/master/flow-server/src/main/java/com/vaadin/flow/internal/UsageStatistics.java#L106
      // Currently it is only used by BootstrapHandler.
      if (version && version.indexOf('2') === 0) {
        // Polymer 2: components classes are stored in window.Vaadin
        elementClasses = Object.keys(window.Vaadin).map(function (c) {
          return window.Vaadin[c];
        }).filter(function (c) {
          return c.is;
        });
      } else {
        // Polymer 3: components classes are stored in window.Vaadin.registrations
        elementClasses = window.Vaadin.registrations || [];
      }
      elementClasses.forEach(function (klass) {
        var version = klass.version ? klass.version : "0.0.0";
        elements[klass.is] = { version: version };
      });
    }
  }, {
    key: 'getUsedVaadinThemes',
    value: function getUsedVaadinThemes(themes) {
      ['Lumo', 'Material'].forEach(function (themeName) {
        var theme;
        var version = getPolymerVersion();
        if (version && version.indexOf('2') === 0) {
          // Polymer 2: themes are stored in window.Vaadin
          theme = window.Vaadin[themeName];
        } else {
          // Polymer 3: themes are stored in custom element registry
          theme = customElements.get('vaadin-' + themeName.toLowerCase() + '-styles');
        }
        if (theme && theme.version) {
          themes[themeName] = { version: theme.version };
        }
      });
    }
  }, {
    key: 'getFrameworks',
    value: function getFrameworks(frameworks) {
      var detectors = this.frameworkVersionDetectors();
      Object.keys(detectors).forEach(function (framework) {
        var detector = detectors[framework];
        try {
          var version = detector();
          if (version) {
            frameworks[framework] = { version: version };
          }
        } catch (e) {}
      });
    }
  }, {
    key: 'gather',
    value: function gather(storage) {
      var storedStats = storage.read();
      var gatheredStats = {};
      var types = ["elements", "frameworks", "themes"];

      types.forEach(function (type) {
        gatheredStats[type] = {};
        if (!storedStats[type]) {
          storedStats[type] = {};
        }
      });

      var previousStats = JSON.stringify(storedStats);

      this.getUsedVaadinElements(gatheredStats.elements);
      this.getFrameworks(gatheredStats.frameworks);
      this.getUsedVaadinThemes(gatheredStats.themes);

      var now = this.now;
      types.forEach(function (type) {
        var keys = Object.keys(gatheredStats[type]);
        keys.forEach(function (key) {
          if (!storedStats[type][key] || _typeof(storedStats[type][key]) != _typeof({})) {
            storedStats[type][key] = { firstUsed: now };
          }
          // Discards any previously logged version number
          storedStats[type][key].version = gatheredStats[type][key].version;
          storedStats[type][key].lastUsed = now;
        });
      });

      var newStats = JSON.stringify(storedStats);
      storage.write(newStats);
      if (newStats != previousStats && Object.keys(storedStats).length > 0) {
        this.logger.debug("New stats: " + newStats);
      }
    }
  }]);
  return StatisticsGatherer;
}();

var StatisticsStorage = function () {
  function StatisticsStorage(key) {
    classCallCheck(this, StatisticsStorage);

    this.key = key;
  }

  createClass(StatisticsStorage, [{
    key: 'read',
    value: function read() {
      var localStorageStatsString = localStorage.getItem(this.key);
      try {
        return JSON.parse(localStorageStatsString ? localStorageStatsString : '{}');
      } catch (e) {
        return {};
      }
    }
  }, {
    key: 'write',
    value: function write(data) {
      localStorage.setItem(this.key, data);
    }
  }, {
    key: 'clear',
    value: function clear() {
      localStorage.removeItem(this.key);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      var storedStats = this.read();
      var empty = true;
      Object.keys(storedStats).forEach(function (key) {
        if (Object.keys(storedStats[key]).length > 0) {
          empty = false;
        }
      });

      return empty;
    }
  }]);
  return StatisticsStorage;
}();

var StatisticsSender = function () {
  function StatisticsSender(url, logger) {
    classCallCheck(this, StatisticsSender);

    this.url = url;
    this.logger = logger;
  }

  createClass(StatisticsSender, [{
    key: 'send',
    value: function send(data, errorHandler) {
      var logger = this.logger;

      if (navigator.onLine === false) {
        logger.debug("Offline, can't send");
        errorHandler();
        return;
      }
      logger.debug("Sending data to " + this.url);

      var req = new XMLHttpRequest();
      req.withCredentials = true;
      req.addEventListener("load", function () {
        // Stats sent, nothing more to do
        logger.debug("Response: " + req.responseText);
      });
      req.addEventListener("error", function () {
        logger.debug("Send failed");
        errorHandler();
      });
      req.addEventListener("abort", function () {
        logger.debug("Send aborted");
        errorHandler();
      });
      req.open("POST", this.url);
      req.setRequestHeader("Content-Type", "application/json");
      req.send(data);
    }
  }]);
  return StatisticsSender;
}();

var StatisticsLogger = function () {
  function StatisticsLogger(id) {
    classCallCheck(this, StatisticsLogger);

    this.id = id;
  }

  createClass(StatisticsLogger, [{
    key: '_isDebug',
    value: function _isDebug() {
      return localStorage.getItem("vaadin." + this.id + ".debug");
    }
  }, {
    key: 'debug',
    value: function debug(msg) {
      if (this._isDebug()) {
        console.info(this.id + ": " + msg);
      }
    }
  }]);
  return StatisticsLogger;
}();

var UsageStatistics = function () {
  function UsageStatistics() {
    classCallCheck(this, UsageStatistics);

    this.now = new Date();
    this.timeNow = this.now.getTime();
    this.gatherDelay = 10; // Delay between loading this file and gathering stats
    this.initialDelay = 24 * 60 * 60;

    this.logger = new StatisticsLogger("statistics");
    this.storage = new StatisticsStorage("vaadin.statistics.basket");
    this.gatherer = new StatisticsGatherer(this.logger);
    this.sender = new StatisticsSender("https://tools.vaadin.com/usage-stats/submit", this.logger);
  }

  createClass(UsageStatistics, [{
    key: 'maybeGatherAndSend',
    value: function maybeGatherAndSend() {
      var _this = this;

      if (localStorage.getItem(UsageStatistics.optOutKey)) {
        return;
      }
      this.gatherer.gather(this.storage);
      setTimeout(function () {
        _this.maybeSend();
      }, this.gatherDelay * 1000);
    }
  }, {
    key: 'lottery',
    value: function lottery() {
      return true;
    }
  }, {
    key: 'currentMonth',
    value: function currentMonth() {
      return this.now.getYear() * 12 + this.now.getMonth();
    }
  }, {
    key: 'maybeSend',
    value: function maybeSend() {
      var firstUse = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      var monthProcessed = Number(localStorage.getItem(UsageStatistics.monthProcessedKey));

      if (!firstUse) {
        // Use a grace period to avoid interfering with tests, incognito mode etc
        firstUse = this.timeNow;
        localStorage.setItem(UsageStatistics.firstUseKey, firstUse);
      }

      if (this.timeNow < firstUse + this.initialDelay * 1000) {
        this.logger.debug("No statistics will be sent until the initial delay of " + this.initialDelay + "s has passed");
        return;
      }
      if (this.currentMonth() <= monthProcessed) {
        this.logger.debug("This month has already been processed");
        return;
      }
      localStorage.setItem(UsageStatistics.monthProcessedKey, this.currentMonth());
      // Use random sampling
      if (this.lottery()) {
        this.logger.debug("Congratulations, we have a winner!");
      } else {
        this.logger.debug("Sorry, no stats from you this time");
        return;
      }

      this.send();
    }
  }, {
    key: 'send',
    value: function send() {
      // Ensure we have the latest data
      this.gatherer.gather(this.storage);

      // Read, send and clean up
      var data = this.storage.read();
      data["firstUse"] = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      data["usageStatisticsVersion"] = UsageStatistics.version;
      var info = 'This request contains usage statistics gathered from the application running in development mode. \n\nStatistics gathering is automatically disabled and excluded from production builds.\n\nFor details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.\n\n\n\n';
      var self = this;
      this.sender.send(info + JSON.stringify(data), function () {
        // Revert the 'month processed' flag
        localStorage.setItem(UsageStatistics.monthProcessedKey, self.currentMonth() - 1);
      });
    }
  }], [{
    key: 'version',
    get: function get$1() {
      return '2.1.2';
    }
  }, {
    key: 'firstUseKey',
    get: function get$1() {
      return 'vaadin.statistics.firstuse';
    }
  }, {
    key: 'monthProcessedKey',
    get: function get$1() {
      return 'vaadin.statistics.monthProcessed';
    }
  }, {
    key: 'optOutKey',
    get: function get$1() {
      return 'vaadin.statistics.optout';
    }
  }]);
  return UsageStatistics;
}();

try {
  window.Vaadin = window.Vaadin || {};
  window.Vaadin.usageStatsChecker = window.Vaadin.usageStatsChecker || new UsageStatistics();
  window.Vaadin.usageStatsChecker.maybeGatherAndSend();
} catch (e) {
  // Intentionally ignored as this is not a problem in the app being developed
}

}());

  vaadin-dev-mode:end **/ }
const $e484b6184280f288$export$32d884d7346a67c0 = function() {
    if (typeof (0, $cj8N6.runIfDevelopmentMode) === 'function') return (0, $cj8N6.runIfDevelopmentMode)($e484b6184280f288$var$maybeGatherAndSendStats);
};

});
parcelRegister("cj8N6", function(module, exports) {

$parcel$export(module.exports, "runIfDevelopmentMode", () => $8f5e14165893700e$export$75b841fa655dc08);
const $8f5e14165893700e$var$DEV_MODE_CODE_REGEXP = /\/\*\*\s+vaadin-dev-mode:start([\s\S]*)vaadin-dev-mode:end\s+\*\*\//i;
const $8f5e14165893700e$var$FlowClients = window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients;
function $8f5e14165893700e$var$isMinified() {
    function test() {
        /** vaadin-dev-mode:start
    return false;
    vaadin-dev-mode:end **/ return true;
    }
    return $8f5e14165893700e$var$uncommentAndRun(test);
}
function $8f5e14165893700e$var$isDevelopmentMode() {
    try {
        if ($8f5e14165893700e$var$isForcedDevelopmentMode()) return true;
        if (!$8f5e14165893700e$var$isLocalhost()) return false;
        if ($8f5e14165893700e$var$FlowClients) return !$8f5e14165893700e$var$isFlowProductionMode();
        return !$8f5e14165893700e$var$isMinified();
    } catch (e) {
        // Some error in this code, assume production so no further actions will be taken
        return false;
    }
}
function $8f5e14165893700e$var$isForcedDevelopmentMode() {
    return localStorage.getItem("vaadin.developmentmode.force");
}
function $8f5e14165893700e$var$isLocalhost() {
    return [
        "localhost",
        "127.0.0.1"
    ].indexOf(window.location.hostname) >= 0;
}
function $8f5e14165893700e$var$isFlowProductionMode() {
    if ($8f5e14165893700e$var$FlowClients) {
        const productionModeApps = Object.keys($8f5e14165893700e$var$FlowClients).map((key)=>$8f5e14165893700e$var$FlowClients[key]).filter((client)=>client.productionMode);
        if (productionModeApps.length > 0) return true;
    }
    return false;
}
function $8f5e14165893700e$var$uncommentAndRun(callback, args) {
    if (typeof callback !== 'function') return;
    const match = $8f5e14165893700e$var$DEV_MODE_CODE_REGEXP.exec(callback.toString());
    if (match) try {
        // requires CSP: script-src 'unsafe-eval'
        callback = new Function(match[1]);
    } catch (e) {
        // eat the exception
        console.log('vaadin-development-mode-detector: uncommentAndRun() failed', e);
    }
    return callback(args);
}
// A guard against polymer-modulizer removing the window.Vaadin
// initialization above.
window['Vaadin'] = window['Vaadin'] || {};
const $8f5e14165893700e$export$75b841fa655dc08 = function(callback, args) {
    if (window.Vaadin.developmentMode) return $8f5e14165893700e$var$uncommentAndRun(callback, args);
};
if (window.Vaadin.developmentMode === undefined) window.Vaadin.developmentMode = $8f5e14165893700e$var$isDevelopmentMode();

});



parcelRegister("jlr9D", function(module, exports) {

$parcel$export(module.exports, "Debouncer", () => $e1550ace5abdc710$export$6714332a76d13d42);
$parcel$export(module.exports, "enqueueDebouncer", () => $e1550ace5abdc710$export$587cf0fefffc9700);
$parcel$export(module.exports, "flush", () => $e1550ace5abdc710$export$4909b86c8034bf73);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /**
 * @summary Collapse multiple callbacks into one invocation after a timer.
 */ class $e1550ace5abdc710$export$6714332a76d13d42 {
    /**
   * Creates a debouncer if no debouncer is passed as a parameter
   * or it cancels an active debouncer otherwise. The following
   * example shows how a debouncer can be called multiple times within a
   * microtask and "debounced" such that the provided callback function is
   * called once. Add this method to a custom element:
   *
   * ```js
   * import {microTask} from '@vaadin/component-base/src/async.js';
   * import {Debouncer} from '@vaadin/component-base/src/debounce.js';
   * // ...
   *
   * _debounceWork() {
   *   this._debounceJob = Debouncer.debounce(this._debounceJob,
   *       microTask, () => this._doWork());
   * }
   * ```
   *
   * If the `_debounceWork` method is called multiple times within the same
   * microtask, the `_doWork` function will be called only once at the next
   * microtask checkpoint.
   *
   * Note: In testing it is often convenient to avoid asynchrony. To accomplish
   * this with a debouncer, you can use `enqueueDebouncer` and
   * `flush`. For example, extend the above example by adding
   * `enqueueDebouncer(this._debounceJob)` at the end of the
   * `_debounceWork` method. Then in a test, call `flush` to ensure
   * the debouncer has completed.
   *
   * @param {Debouncer?} debouncer Debouncer object.
   * @param {!AsyncInterface} asyncModule Object with Async interface
   * @param {function()} callback Callback to run.
   * @return {!Debouncer} Returns a debouncer object.
   */ static debounce(debouncer, asyncModule, callback) {
        if (debouncer instanceof $e1550ace5abdc710$export$6714332a76d13d42) // Cancel the async callback, but leave in debouncerQueue if it was
        // enqueued, to maintain 1.x flush order
        debouncer._cancelAsync();
        else debouncer = new $e1550ace5abdc710$export$6714332a76d13d42();
        debouncer.setConfig(asyncModule, callback);
        return debouncer;
    }
    constructor(){
        this._asyncModule = null;
        this._callback = null;
        this._timer = null;
    }
    /**
   * Sets the scheduler; that is, a module with the Async interface,
   * a callback and optional arguments to be passed to the run function
   * from the async module.
   *
   * @param {!AsyncInterface} asyncModule Object with Async interface.
   * @param {function()} callback Callback to run.
   * @return {void}
   */ setConfig(asyncModule, callback) {
        this._asyncModule = asyncModule;
        this._callback = callback;
        this._timer = this._asyncModule.run(()=>{
            this._timer = null;
            $e1550ace5abdc710$var$debouncerQueue.delete(this);
            this._callback();
        });
    }
    /**
   * Cancels an active debouncer and returns a reference to itself.
   *
   * @return {void}
   */ cancel() {
        if (this.isActive()) {
            this._cancelAsync();
            // Canceling a debouncer removes its spot from the flush queue,
            // so if a debouncer is manually canceled and re-debounced, it
            // will reset its flush order (this is a very minor difference from 1.x)
            // Re-debouncing via the `debounce` API retains the 1.x FIFO flush order
            $e1550ace5abdc710$var$debouncerQueue.delete(this);
        }
    }
    /**
   * Cancels a debouncer's async callback.
   *
   * @return {void}
   */ _cancelAsync() {
        if (this.isActive()) {
            this._asyncModule.cancel(/** @type {number} */ this._timer);
            this._timer = null;
        }
    }
    /**
   * Flushes an active debouncer and returns a reference to itself.
   *
   * @return {void}
   */ flush() {
        if (this.isActive()) {
            this.cancel();
            this._callback();
        }
    }
    /**
   * Returns true if the debouncer is active.
   *
   * @return {boolean} True if active.
   */ isActive() {
        return this._timer != null;
    }
}
let $e1550ace5abdc710$var$debouncerQueue = new Set();
function $e1550ace5abdc710$export$587cf0fefffc9700(debouncer) {
    $e1550ace5abdc710$var$debouncerQueue.add(debouncer);
}
function $e1550ace5abdc710$export$d2808eee61d0a316() {
    const didFlush = Boolean($e1550ace5abdc710$var$debouncerQueue.size);
    // If new debouncers are added while flushing, Set.forEach will ensure
    // newly added ones are also flushed
    $e1550ace5abdc710$var$debouncerQueue.forEach((debouncer)=>{
        try {
            debouncer.flush();
        } catch (e) {
            setTimeout(()=>{
                throw e;
            });
        }
    });
    return didFlush;
}
const $e1550ace5abdc710$export$4909b86c8034bf73 = ()=>{
    let debouncers;
    do debouncers = $e1550ace5abdc710$export$d2808eee61d0a316();
    while (debouncers);
};

});

parcelRegister("5ncN0", function(module, exports) {

$parcel$export(module.exports, "DirMixin", () => $3e9905724b15dadc$export$3a742f608ed5193b);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $ktvUU = parcelRequire("ktvUU");
/**
 * Array of Vaadin custom element classes that have been subscribed to the dir changes.
 */ const $3e9905724b15dadc$var$directionSubscribers = [];
function $3e9905724b15dadc$var$directionUpdater() {
    const documentDir = $3e9905724b15dadc$var$getDocumentDir();
    $3e9905724b15dadc$var$directionSubscribers.forEach((element)=>{
        $3e9905724b15dadc$var$alignDirs(element, documentDir);
    });
}
let $3e9905724b15dadc$var$scrollType;
const $3e9905724b15dadc$var$directionObserver = new MutationObserver($3e9905724b15dadc$var$directionUpdater);
$3e9905724b15dadc$var$directionObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [
        'dir'
    ]
});
function $3e9905724b15dadc$var$alignDirs(element, documentDir, elementDir = element.getAttribute('dir')) {
    if (documentDir) element.setAttribute('dir', documentDir);
    else if (elementDir != null) element.removeAttribute('dir');
}
function $3e9905724b15dadc$var$getDocumentDir() {
    return document.documentElement.getAttribute('dir');
}
const $3e9905724b15dadc$export$3a742f608ed5193b = (superClass)=>class VaadinDirMixin extends superClass {
        static get properties() {
            return {
                /**
         * @protected
         */ dir: {
                    type: String,
                    value: '',
                    reflectToAttribute: true,
                    converter: {
                        fromAttribute: (attr)=>{
                            return !attr ? '' : attr;
                        },
                        toAttribute: (prop)=>{
                            return prop === '' ? null : prop;
                        }
                    }
                }
            };
        }
        /** @protected */ static finalize() {
            super.finalize();
            if (!$3e9905724b15dadc$var$scrollType) $3e9905724b15dadc$var$scrollType = (0, $ktvUU.DirHelper).detectScrollType();
        }
        /** @protected */ connectedCallback() {
            super.connectedCallback();
            if (!this.hasAttribute('dir') || this.__restoreSubscription) {
                this.__subscribe();
                $3e9905724b15dadc$var$alignDirs(this, $3e9905724b15dadc$var$getDocumentDir(), null);
            }
        }
        /** @protected */ attributeChangedCallback(name, oldValue, newValue) {
            super.attributeChangedCallback(name, oldValue, newValue);
            if (name !== 'dir') return;
            const documentDir = $3e9905724b15dadc$var$getDocumentDir();
            // New value equals to the document direction and the element is not subscribed to the changes
            const newValueEqlDocDir = newValue === documentDir && $3e9905724b15dadc$var$directionSubscribers.indexOf(this) === -1;
            // Value was emptied and the element is not subscribed to the changes
            const newValueEmptied = !newValue && oldValue && $3e9905724b15dadc$var$directionSubscribers.indexOf(this) === -1;
            // New value is different and the old equals to document direction and the element is not subscribed to the changes
            const newDiffValue = newValue !== documentDir && oldValue === documentDir;
            if (newValueEqlDocDir || newValueEmptied) {
                this.__subscribe();
                $3e9905724b15dadc$var$alignDirs(this, documentDir, newValue);
            } else if (newDiffValue) this.__unsubscribe();
        }
        /** @protected */ disconnectedCallback() {
            super.disconnectedCallback();
            this.__restoreSubscription = $3e9905724b15dadc$var$directionSubscribers.includes(this);
            this.__unsubscribe();
        }
        /** @protected */ _valueToNodeAttribute(node, value, attribute) {
            // Override default Polymer attribute reflection to match native behavior of HTMLElement.dir property
            // If the property contains an empty string then it should not create an empty attribute
            if (attribute === 'dir' && value === '' && !node.hasAttribute('dir')) return;
            super._valueToNodeAttribute(node, value, attribute);
        }
        /** @protected */ _attributeToProperty(attribute, value, type) {
            // Override default Polymer attribute reflection to match native behavior of HTMLElement.dir property
            // If the attribute is removed, then the dir property should contain an empty string instead of null
            if (attribute === 'dir' && !value) this.dir = '';
            else super._attributeToProperty(attribute, value, type);
        }
        /** @private */ __subscribe() {
            if (!$3e9905724b15dadc$var$directionSubscribers.includes(this)) $3e9905724b15dadc$var$directionSubscribers.push(this);
        }
        /** @private */ __unsubscribe() {
            if ($3e9905724b15dadc$var$directionSubscribers.includes(this)) $3e9905724b15dadc$var$directionSubscribers.splice($3e9905724b15dadc$var$directionSubscribers.indexOf(this), 1);
        }
        /**
     * @param {Element} element
     * @return {number}
     * @protected
     */ __getNormalizedScrollLeft(element) {
            return (0, $ktvUU.DirHelper).getNormalizedScrollLeft($3e9905724b15dadc$var$scrollType, this.getAttribute('dir') || 'ltr', element);
        }
        /**
     * @param {Element} element
     * @param {number} scrollLeft
     * @protected
     */ __setNormalizedScrollLeft(element, scrollLeft) {
            return (0, $ktvUU.DirHelper).setNormalizedScrollLeft($3e9905724b15dadc$var$scrollType, this.getAttribute('dir') || 'ltr', element, scrollLeft);
        }
    };

});
parcelRegister("ktvUU", function(module, exports) {

$parcel$export(module.exports, "DirHelper", () => $ee7f461a01a9097b$export$ed99fb0d26dd4ec3);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /**
 * Helper that provides a set of functions for RTL.
 */ class $ee7f461a01a9097b$export$ed99fb0d26dd4ec3 {
    /**
   * Get the scroll type in the current browser view.
   *
   * @return {string} the scroll type. Possible values are `default|reverse|negative`
   */ static detectScrollType() {
        const dummy = document.createElement('div');
        dummy.textContent = 'ABCD';
        dummy.dir = 'rtl';
        dummy.style.fontSize = '14px';
        dummy.style.width = '4px';
        dummy.style.height = '1px';
        dummy.style.position = 'absolute';
        dummy.style.top = '-1000px';
        dummy.style.overflow = 'scroll';
        document.body.appendChild(dummy);
        let cachedType = 'reverse';
        if (dummy.scrollLeft > 0) cachedType = 'default';
        else {
            dummy.scrollLeft = 2;
            if (dummy.scrollLeft < 2) cachedType = 'negative';
        }
        document.body.removeChild(dummy);
        return cachedType;
    }
    /**
   * Get the scrollLeft value of the element relative to the direction
   *
   * @param {string} scrollType type of the scroll detected with `detectScrollType`
   * @param {string} direction current direction of the element
   * @param {Element} element
   * @return {number} the scrollLeft value.
   */ static getNormalizedScrollLeft(scrollType, direction, element) {
        const { scrollLeft: scrollLeft } = element;
        if (direction !== 'rtl' || !scrollType) return scrollLeft;
        switch(scrollType){
            case 'negative':
                return element.scrollWidth - element.clientWidth + scrollLeft;
            case 'reverse':
                return element.scrollWidth - element.clientWidth - scrollLeft;
            default:
                return scrollLeft;
        }
    }
    /**
   * Set the scrollLeft value of the element relative to the direction
   *
   * @param {string} scrollType type of the scroll detected with `detectScrollType`
   * @param {string} direction current direction of the element
   * @param {Element} element
   * @param {number} scrollLeft the scrollLeft value to be set
   */ static setNormalizedScrollLeft(scrollType, direction, element, scrollLeft) {
        if (direction !== 'rtl' || !scrollType) {
            element.scrollLeft = scrollLeft;
            return;
        }
        switch(scrollType){
            case 'negative':
                element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
                break;
            case 'reverse':
                element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
                break;
            default:
                element.scrollLeft = scrollLeft;
                break;
        }
    }
}

});



parcelRegister("kRmfJ", function(module, exports) {

$parcel$export(module.exports, "CheckedMixin", () => $f2fa04d572b27be0$export$c5048e37f6715d08);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");

var $jf0Pl = parcelRequire("jf0Pl");

var $IaWw6 = parcelRequire("IaWw6");

var $eDhIo = parcelRequire("eDhIo");

var $hGDlz = parcelRequire("hGDlz");
const $f2fa04d572b27be0$export$c5048e37f6715d08 = (0, $gLdkK.dedupingMixin)((superclass)=>class CheckedMixinClass extends (0, $eDhIo.DelegateStateMixin)((0, $jf0Pl.DisabledMixin)((0, $hGDlz.InputMixin)(superclass))) {
        static get properties() {
            return {
                /**
           * True if the element is checked.
           * @type {boolean}
           */ checked: {
                    type: Boolean,
                    value: false,
                    notify: true,
                    reflectToAttribute: true
                }
            };
        }
        static get delegateProps() {
            return [
                ...super.delegateProps,
                'checked'
            ];
        }
        /**
       * @param {Event} event
       * @protected
       * @override
       */ _onChange(event) {
            const input = event.target;
            this._toggleChecked(input.checked);
            // Clicking the checkbox or radio-button in Safari
            // does not make it focused, so we do it manually.
            if (!(0, $IaWw6.isElementFocused)(input)) input.focus();
        }
        /** @protected */ _toggleChecked(checked) {
            this.checked = checked;
        }
    });

});
parcelRegister("IaWw6", function(module, exports) {

$parcel$export(module.exports, "isKeyboardActive", () => $084c993107dc4c49$export$8104cf4822079216);
$parcel$export(module.exports, "isElementFocused", () => $084c993107dc4c49$export$6bf448be6c5277a6);
$parcel$export(module.exports, "getFocusableElements", () => $084c993107dc4c49$export$433aaa1f216cf32d);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ // We consider the keyboard to be active if the window has received a keydown
// event since the last mousedown event.
let $084c993107dc4c49$var$keyboardActive = false;
// Listen for top-level keydown and mousedown events.
// Use capture phase so we detect events even if they're handled.
window.addEventListener('keydown', ()=>{
    $084c993107dc4c49$var$keyboardActive = true;
}, {
    capture: true
});
window.addEventListener('mousedown', ()=>{
    $084c993107dc4c49$var$keyboardActive = false;
}, {
    capture: true
});
function $084c993107dc4c49$export$8104cf4822079216() {
    return $084c993107dc4c49$var$keyboardActive;
}
/**
 * Returns true if the element is hidden directly with `display: none` or `visibility: hidden`,
 * false otherwise.
 *
 * The method doesn't traverse the element's ancestors, it only checks for the CSS properties
 * set directly to or inherited by the element.
 *
 * @param {HTMLElement} element
 * @return {boolean}
 */ function $084c993107dc4c49$var$isElementHiddenDirectly(element) {
    // Check inline style first to save a re-flow.
    const style = element.style;
    if (style.visibility === 'hidden' || style.display === 'none') return true;
    const computedStyle = window.getComputedStyle(element);
    if (computedStyle.visibility === 'hidden' || computedStyle.display === 'none') return true;
    return false;
}
/**
 * Returns the normalized element tabindex. If not focusable, returns -1.
 * It checks for the attribute "tabindex" instead of the element property
 * `tabIndex` since browsers assign different values to it.
 * e.g. in Firefox `<div contenteditable>` has `tabIndex = -1`
 *
 * @param {HTMLElement} element
 * @return {number}
 */ function $084c993107dc4c49$var$normalizeTabIndex(element) {
    if (!$084c993107dc4c49$export$6c97834b71ba3dae(element)) return -1;
    const tabIndex = element.getAttribute('tabindex') || 0;
    return Number(tabIndex);
}
/**
 * Returns if element `a` has lower tab order compared to element `b`
 * (both elements are assumed to be focusable and tabbable).
 * Elements with tabindex = 0 have lower tab order compared to elements
 * with tabindex > 0.
 * If both have same tabindex, it returns false.
 *
 * @param {HTMLElement} a
 * @param {HTMLElement} b
 * @return {boolean}
 */ function $084c993107dc4c49$var$hasLowerTabOrder(a, b) {
    // Normalize tabIndexes
    // e.g. in Firefox `<div contenteditable>` has `tabIndex = -1`
    const ati = Math.max(a.tabIndex, 0);
    const bti = Math.max(b.tabIndex, 0);
    return ati === 0 || bti === 0 ? bti > ati : ati > bti;
}
/**
 * Merge sort iterator, merges the two arrays into one, sorted by tabindex.
 *
 * @param {HTMLElement[]} left
 * @param {HTMLElement[]} right
 * @return {HTMLElement[]}
 */ function $084c993107dc4c49$var$mergeSortByTabIndex(left, right) {
    const result = [];
    while(left.length > 0 && right.length > 0)if ($084c993107dc4c49$var$hasLowerTabOrder(left[0], right[0])) result.push(right.shift());
    else result.push(left.shift());
    return result.concat(left, right);
}
/**
 * Sorts an array of elements by tabindex. Returns a new array.
 *
 * @param {HTMLElement[]} elements
 * @return {HTMLElement[]}
 */ function $084c993107dc4c49$var$sortElementsByTabIndex(elements) {
    // Implement a merge sort as Array.prototype.sort does a non-stable sort
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
    const len = elements.length;
    if (len < 2) return elements;
    const pivot = Math.ceil(len / 2);
    const left = $084c993107dc4c49$var$sortElementsByTabIndex(elements.slice(0, pivot));
    const right = $084c993107dc4c49$var$sortElementsByTabIndex(elements.slice(pivot));
    return $084c993107dc4c49$var$mergeSortByTabIndex(left, right);
}
/**
 * Searches for nodes that are tabbable and adds them to the `result` array.
 * Returns if the `result` array needs to be sorted by tabindex.
 *
 * @param {Node} node The starting point for the search; added to `result` if tabbable.
 * @param {HTMLElement[]} result
 * @return {boolean}
 * @private
 */ function $084c993107dc4c49$var$collectFocusableNodes(node, result) {
    if (node.nodeType !== Node.ELEMENT_NODE || $084c993107dc4c49$var$isElementHiddenDirectly(node)) // Don't traverse children if the node is not an HTML element or not visible.
    return false;
    const element = /** @type {HTMLElement} */ node;
    const tabIndex = $084c993107dc4c49$var$normalizeTabIndex(element);
    let needsSort = tabIndex > 0;
    if (tabIndex >= 0) result.push(element);
    let children = [];
    if (element.localName === 'slot') children = element.assignedNodes({
        flatten: true
    });
    else // Use shadow root if possible, will check for distributed nodes.
    children = (element.shadowRoot || element).children;
    [
        ...children
    ].forEach((child)=>{
        // Ensure method is always invoked to collect focusable children.
        needsSort = $084c993107dc4c49$var$collectFocusableNodes(child, result) || needsSort;
    });
    return needsSort;
}
function $084c993107dc4c49$export$a58b62c2890d782d(element) {
    // `offsetParent` is `null` when the element itself
    // or one of its ancestors is hidden with `display: none`.
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    if (element.offsetParent === null) return true;
    return $084c993107dc4c49$var$isElementHiddenDirectly(element);
}
function $084c993107dc4c49$export$6c97834b71ba3dae(element) {
    // The element cannot be focused if its `tabindex` attribute is set to `-1`.
    if (element.matches('[tabindex="-1"]')) return false;
    // Elements that cannot be focused if they have a `disabled` attribute.
    if (element.matches('input, select, textarea, button, object')) return element.matches(':not([disabled])');
    // Elements that can be focused even if they have a `disabled` attribute.
    return element.matches('a[href], area[href], iframe, [tabindex], [contentEditable]');
}
function $084c993107dc4c49$export$6bf448be6c5277a6(element) {
    return element.getRootNode().activeElement === element;
}
function $084c993107dc4c49$export$433aaa1f216cf32d(element) {
    const focusableElements = [];
    const needsSortByTabIndex = $084c993107dc4c49$var$collectFocusableNodes(element, focusableElements);
    // If there is at least one element with tabindex > 0, we need to sort
    // the final array by tabindex.≈
    if (needsSortByTabIndex) return $084c993107dc4c49$var$sortElementsByTabIndex(focusableElements);
    return focusableElements;
}

});

parcelRegister("eDhIo", function(module, exports) {

$parcel$export(module.exports, "DelegateStateMixin", () => $aa72730b2151c10a$export$c9c46f77e8a4f05b);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");
const $aa72730b2151c10a$export$c9c46f77e8a4f05b = (0, $gLdkK.dedupingMixin)((superclass)=>class DelegateStateMixinClass extends superclass {
        static get properties() {
            return {
                /**
           * A target element to which attributes and properties are delegated.
           * @protected
           */ stateTarget: {
                    type: Object,
                    observer: '_stateTargetChanged'
                }
            };
        }
        /**
       * An array of the host attributes to delegate to the target element.
       */ static get delegateAttrs() {
            return [];
        }
        /**
       * An array of the host properties to delegate to the target element.
       */ static get delegateProps() {
            return [];
        }
        /** @protected */ ready() {
            super.ready();
            this._createDelegateAttrsObserver();
            this._createDelegatePropsObserver();
        }
        /** @protected */ _stateTargetChanged(target) {
            if (target) {
                this._ensureAttrsDelegated();
                this._ensurePropsDelegated();
            }
        }
        /** @protected */ _createDelegateAttrsObserver() {
            this._createMethodObserver(`_delegateAttrsChanged(${this.constructor.delegateAttrs.join(', ')})`);
        }
        /** @protected */ _createDelegatePropsObserver() {
            this._createMethodObserver(`_delegatePropsChanged(${this.constructor.delegateProps.join(', ')})`);
        }
        /** @protected */ _ensureAttrsDelegated() {
            this.constructor.delegateAttrs.forEach((name)=>{
                this._delegateAttribute(name, this[name]);
            });
        }
        /** @protected */ _ensurePropsDelegated() {
            this.constructor.delegateProps.forEach((name)=>{
                this._delegateProperty(name, this[name]);
            });
        }
        /** @protected */ _delegateAttrsChanged(...values) {
            this.constructor.delegateAttrs.forEach((name, index)=>{
                this._delegateAttribute(name, values[index]);
            });
        }
        /** @protected */ _delegatePropsChanged(...values) {
            this.constructor.delegateProps.forEach((name, index)=>{
                this._delegateProperty(name, values[index]);
            });
        }
        /** @protected */ _delegateAttribute(name, value) {
            if (!this.stateTarget) return;
            if (name === 'invalid') this._delegateAttribute('aria-invalid', value ? 'true' : false);
            if (typeof value === 'boolean') this.stateTarget.toggleAttribute(name, value);
            else if (value) this.stateTarget.setAttribute(name, value);
            else this.stateTarget.removeAttribute(name);
        }
        /** @protected */ _delegateProperty(name, value) {
            if (!this.stateTarget) return;
            this.stateTarget[name] = value;
        }
    });

});

parcelRegister("hGDlz", function(module, exports) {

$parcel$export(module.exports, "InputMixin", () => $ce04e1675a2d84fa$export$6fe6306576253df9);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");
const $ce04e1675a2d84fa$export$6fe6306576253df9 = (0, $gLdkK.dedupingMixin)((superclass)=>class InputMixinClass extends superclass {
        static get properties() {
            return {
                /**
           * A reference to the input element controlled by the mixin.
           * Any component implementing this mixin is expected to provide it
           * by using `this._setInputElement(input)` Polymer API.
           *
           * A typical case is using `InputController` that does this automatically.
           * However, the input element does not have to always be native <input>:
           * as an example, <vaadin-combo-box-light> accepts other components.
           *
           * @protected
           * @type {!HTMLElement}
           */ inputElement: {
                    type: Object,
                    readOnly: true,
                    observer: '_inputElementChanged'
                },
                /**
           * String used to define input type.
           * @protected
           */ type: {
                    type: String,
                    readOnly: true
                },
                /**
           * The value of the field.
           */ value: {
                    type: String,
                    value: '',
                    observer: '_valueChanged',
                    notify: true
                },
                /**
           * When true, the input element has a non-empty value entered by the user.
           * @protected
           */ _hasInputValue: {
                    type: Boolean,
                    value: false,
                    observer: '_hasInputValueChanged'
                }
            };
        }
        constructor(){
            super();
            this._boundOnInput = this.__onInput.bind(this);
            this._boundOnChange = this._onChange.bind(this);
        }
        /**
       * Clear the value of the field.
       */ clear() {
            this.value = '';
        }
        /**
       * Add event listeners to the input element instance.
       * Override this method to add custom listeners.
       * @param {!HTMLElement} input
       * @protected
       */ _addInputListeners(input) {
            input.addEventListener('input', this._boundOnInput);
            input.addEventListener('change', this._boundOnChange);
        }
        /**
       * Remove event listeners from the input element instance.
       * @param {!HTMLElement} input
       * @protected
       */ _removeInputListeners(input) {
            input.removeEventListener('input', this._boundOnInput);
            input.removeEventListener('change', this._boundOnChange);
        }
        /**
       * A method to forward the value property set on the field
       * programmatically back to the input element value.
       * Override this method to perform additional checks,
       * for example to skip this in certain conditions.
       * @param {string} value
       * @protected
       */ _forwardInputValue(value) {
            // Value might be set before an input element is initialized.
            // This case should be handled separately by a component that
            // implements this mixin, for example in `connectedCallback`.
            if (!this.inputElement) return;
            if (value != null) this.inputElement.value = value;
            else this.inputElement.value = '';
        }
        /**
       * @param {HTMLElement | undefined} input
       * @param {HTMLElement | undefined} oldInput
       * @protected
       */ _inputElementChanged(input, oldInput) {
            if (input) this._addInputListeners(input);
            else if (oldInput) this._removeInputListeners(oldInput);
        }
        /**
       * Observer to notify about the change of private property.
       *
       * @private
       */ _hasInputValueChanged(hasValue, oldHasValue) {
            if (hasValue || oldHasValue) this.dispatchEvent(new CustomEvent('has-input-value-changed'));
        }
        /**
       * An input event listener used to update `_hasInputValue` property.
       * Do not override this method.
       *
       * @param {Event} event
       * @private
       */ __onInput(event) {
            this._setHasInputValue(event);
            this._onInput(event);
        }
        /**
       * An input event listener used to update the field value.
       *
       * @param {Event} event
       * @protected
       */ _onInput(event) {
            // In the case a custom web component is passed as `inputElement`,
            // the actual native input element, on which the event occurred,
            // can be inside shadow trees.
            const target = event.composedPath()[0];
            // Ignore fake input events e.g. used by clear button.
            this.__userInput = event.isTrusted;
            this.value = target.value;
            this.__userInput = false;
        }
        /**
       * A change event listener.
       * Override this method with an actual implementation.
       * @param {Event} _event
       * @protected
       */ _onChange(_event) {}
        /**
       * Toggle the has-value attribute based on the value property.
       *
       * @param {boolean} hasValue
       * @protected
       */ _toggleHasValue(hasValue) {
            this.toggleAttribute('has-value', hasValue);
        }
        /**
       * Observer called when a value property changes.
       * @param {string | undefined} newVal
       * @param {string | undefined} oldVal
       * @protected
       */ _valueChanged(newVal, oldVal) {
            this._toggleHasValue(this._hasValue);
            // Setting initial value to empty string, do nothing.
            if (newVal === '' && oldVal === undefined) return;
            // Value is set by the user, no need to sync it back to input.
            if (this.__userInput) return;
            // Setting a value programmatically, sync it to input element.
            this._forwardInputValue(newVal);
        }
        /**
       * Indicates whether the value is different from the default one.
       * Override if the `value` property has a type other than `string`.
       *
       * @protected
       */ get _hasValue() {
            return this.value != null && this.value !== '';
        }
        /**
       * Sets the `_hasInputValue` property based on the `input` event.
       *
       * @param {InputEvent} event
       * @protected
       */ _setHasInputValue(event) {
            // In the case a custom web component is passed as `inputElement`,
            // the actual native input element, on which the event occurred,
            // can be inside shadow trees.
            const target = event.composedPath()[0];
            this._hasInputValue = target.value.length > 0;
        }
    });

});


parcelRegister("dbTLX", function(module, exports) {

$parcel$export(module.exports, "DelegateFocusMixin", () => $99a790b266c7960c$export$bfd52848c59c7c40);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");

var $4fPbK = parcelRequire("4fPbK");

var $bId1k = parcelRequire("bId1k");
const $99a790b266c7960c$export$bfd52848c59c7c40 = (0, $gLdkK.dedupingMixin)((superclass)=>class DelegateFocusMixinClass extends (0, $4fPbK.FocusMixin)((0, $bId1k.TabindexMixin)(superclass)) {
        static get properties() {
            return {
                /**
           * Specify that this control should have input focus when the page loads.
           */ autofocus: {
                    type: Boolean
                },
                /**
           * A reference to the focusable element controlled by the mixin.
           * It can be an input, textarea, button or any element with tabindex > -1.
           *
           * Any component implementing this mixin is expected to provide it
           * by using `this._setFocusElement(input)` Polymer API.
           *
           * Toggling `tabindex` attribute on the host element propagates its value to `focusElement`.
           *
           * @protected
           * @type {!HTMLElement}
           */ focusElement: {
                    type: Object,
                    readOnly: true,
                    observer: '_focusElementChanged'
                },
                /**
           * Override the property from `TabIndexMixin`
           * to ensure the `tabindex` attribute of the focus element
           * will be restored to `0` after re-enabling the element.
           *
           * @protected
           * @override
           */ _lastTabIndex: {
                    value: 0
                }
            };
        }
        constructor(){
            super();
            this._boundOnBlur = this._onBlur.bind(this);
            this._boundOnFocus = this._onFocus.bind(this);
        }
        /** @protected */ ready() {
            super.ready();
            if (this.autofocus && !this.disabled) requestAnimationFrame(()=>{
                this.focus();
                this.setAttribute('focus-ring', '');
            });
        }
        /**
       * @protected
       * @override
       */ focus() {
            if (!this.focusElement || this.disabled) return;
            this.focusElement.focus();
            this._setFocused(true);
        }
        /**
       * @protected
       * @override
       */ blur() {
            if (!this.focusElement) return;
            this.focusElement.blur();
            this._setFocused(false);
        }
        /**
       * @protected
       * @override
       */ click() {
            if (this.focusElement && !this.disabled) this.focusElement.click();
        }
        /** @protected */ _focusElementChanged(element, oldElement) {
            if (element) {
                element.disabled = this.disabled;
                this._addFocusListeners(element);
                this.__forwardTabIndex(this.tabindex);
            } else if (oldElement) this._removeFocusListeners(oldElement);
        }
        /**
       * @param {HTMLElement} element
       * @protected
       */ _addFocusListeners(element) {
            element.addEventListener('blur', this._boundOnBlur);
            element.addEventListener('focus', this._boundOnFocus);
        }
        /**
       * @param {HTMLElement} element
       * @protected
       */ _removeFocusListeners(element) {
            element.removeEventListener('blur', this._boundOnBlur);
            element.removeEventListener('focus', this._boundOnFocus);
        }
        /**
       * Focus event does not bubble, so we dispatch it manually
       * on the host element to support adding focus listeners
       * when the focusable element is placed in light DOM.
       * @param {FocusEvent} event
       * @protected
       */ _onFocus(event) {
            event.stopPropagation();
            this.dispatchEvent(new Event('focus'));
        }
        /**
       * Blur event does not bubble, so we dispatch it manually
       * on the host element to support adding blur listeners
       * when the focusable element is placed in light DOM.
       * @param {FocusEvent} event
       * @protected
       */ _onBlur(event) {
            event.stopPropagation();
            this.dispatchEvent(new Event('blur'));
        }
        /**
       * @param {Event} event
       * @return {boolean}
       * @protected
       * @override
       */ _shouldSetFocus(event) {
            return event.target === this.focusElement;
        }
        /**
       * @param {boolean} disabled
       * @param {boolean} oldDisabled
       * @protected
       * @override
       */ _disabledChanged(disabled, oldDisabled) {
            super._disabledChanged(disabled, oldDisabled);
            if (this.focusElement) this.focusElement.disabled = disabled;
            if (disabled) this.blur();
        }
        /**
       * Override an observer from `TabindexMixin`.
       * Do not call super to remove tabindex attribute
       * from the host after it has been forwarded.
       * @param {string} tabindex
       * @protected
       * @override
       */ _tabindexChanged(tabindex) {
            this.__forwardTabIndex(tabindex);
        }
        /** @private */ __forwardTabIndex(tabindex) {
            if (tabindex !== undefined && this.focusElement) {
                this.focusElement.tabIndex = tabindex;
                // Preserve tabindex="-1" on the host element
                if (tabindex !== -1) this.tabindex = undefined;
            }
            if (this.disabled && tabindex) {
                // If tabindex attribute was changed while component was disabled
                if (tabindex !== -1) this._lastTabIndex = tabindex;
                this.tabindex = undefined;
            }
        }
    });

});
parcelRegister("4fPbK", function(module, exports) {

$parcel$export(module.exports, "FocusMixin", () => $319045194d4ebd9f$export$de7a35655c549487);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");

var $IaWw6 = parcelRequire("IaWw6");
const $319045194d4ebd9f$export$de7a35655c549487 = (0, $gLdkK.dedupingMixin)((superclass)=>class FocusMixinClass extends superclass {
        /**
       * @protected
       * @return {boolean}
       */ get _keyboardActive() {
            return (0, $IaWw6.isKeyboardActive)();
        }
        /** @protected */ ready() {
            this.addEventListener('focusin', (e)=>{
                if (this._shouldSetFocus(e)) this._setFocused(true);
            });
            this.addEventListener('focusout', (e)=>{
                if (this._shouldRemoveFocus(e)) this._setFocused(false);
            });
            // In super.ready() other 'focusin' and 'focusout' listeners might be
            // added, so we call it after our own ones to ensure they execute first.
            // Issue to watch out: when incorrect, <vaadin-combo-box> refocuses the
            // input field on iOS after “Done” is pressed.
            super.ready();
        }
        /** @protected */ disconnectedCallback() {
            super.disconnectedCallback();
            // In non-Chrome browsers, blur does not fire on the element when it is disconnected.
            // reproducible in `<vaadin-date-picker>` when closing on `Cancel` or `Today` click.
            if (this.hasAttribute('focused')) this._setFocused(false);
        }
        /**
       * Override to change how focused and focus-ring attributes are set.
       *
       * @param {boolean} focused
       * @protected
       */ _setFocused(focused) {
            this.toggleAttribute('focused', focused);
            // Focus-ring is true when the element was focused from the keyboard.
            // Focus Ring [A11ycasts]: https://youtu.be/ilj2P5-5CjI
            this.toggleAttribute('focus-ring', focused && this._keyboardActive);
        }
        /**
       * Override to define if the field receives focus based on the event.
       *
       * @param {FocusEvent} _event
       * @return {boolean}
       * @protected
       */ _shouldSetFocus(_event) {
            return true;
        }
        /**
       * Override to define if the field loses focus based on the event.
       *
       * @param {FocusEvent} _event
       * @return {boolean}
       * @protected
       */ _shouldRemoveFocus(_event) {
            return true;
        }
    });

});

parcelRegister("bId1k", function(module, exports) {

$parcel$export(module.exports, "TabindexMixin", () => $886de7559905ae1a$export$2009ba7cef8b35e3);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $jf0Pl = parcelRequire("jf0Pl");
const $886de7559905ae1a$export$2009ba7cef8b35e3 = (superclass)=>class TabindexMixinClass extends (0, $jf0Pl.DisabledMixin)(superclass) {
        static get properties() {
            return {
                /**
         * Indicates whether the element can be focused and where it participates in sequential keyboard navigation.
         *
         * @protected
         */ tabindex: {
                    type: Number,
                    reflectToAttribute: true,
                    observer: '_tabindexChanged'
                },
                /**
         * Stores the last known tabindex since the element has been disabled.
         *
         * @protected
         */ _lastTabIndex: {
                    type: Number
                }
            };
        }
        /**
     * When the element gets disabled, the observer saves the last known tabindex
     * and makes the element not focusable by setting tabindex to -1.
     * As soon as the element gets enabled, the observer restores the last known tabindex
     * so that the element can be focusable again.
     *
     * @protected
     * @override
     */ _disabledChanged(disabled, oldDisabled) {
            super._disabledChanged(disabled, oldDisabled);
            if (disabled) {
                if (this.tabindex !== undefined) this._lastTabIndex = this.tabindex;
                this.tabindex = -1;
            } else if (oldDisabled) this.tabindex = this._lastTabIndex;
        }
        /**
     * When the user has changed tabindex while the element is disabled,
     * the observer reverts tabindex to -1 and rather saves the new tabindex value to apply it later.
     * The new value will be applied as soon as the element becomes enabled.
     *
     * @protected
     */ _tabindexChanged(tabindex) {
            if (this.disabled && tabindex !== -1) {
                this._lastTabIndex = tabindex;
                this.tabindex = -1;
            }
        }
    };

});


parcelRegister("1wMVk", function(module, exports) {

$parcel$export(module.exports, "InputController", () => $11cebacf2c5d2538$export$279fd706a2034fec);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $2FSxb = parcelRequire("2FSxb");
class $11cebacf2c5d2538$export$279fd706a2034fec extends (0, $2FSxb.SlotController) {
    constructor(host, callback){
        super(host, 'input', ()=>document.createElement('input'), (host, node)=>{
            if (host.value) node.setAttribute('value', host.value);
            if (host.type) node.setAttribute('type', host.type);
            // Ensure every instance has unique ID
            node.id = this.defaultId;
            if (typeof callback === 'function') callback(node);
        }, true);
    }
}

});
parcelRegister("2FSxb", function(module, exports) {

$parcel$export(module.exports, "SlotController", () => $1f29b676ee01f55b$export$d99e5f9960a2fc4f);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $bmThs = parcelRequire("bmThs");

var $kKcje = parcelRequire("kKcje");
class $1f29b676ee01f55b$export$d99e5f9960a2fc4f extends EventTarget {
    /**
   * Ensure that every instance has unique ID.
   *
   * @param {string} slotName
   * @param {HTMLElement} host
   * @return {string}
   * @protected
   */ static generateId(slotName, host) {
        const prefix = slotName || 'default';
        return `${prefix}-${host.localName}-${(0, $kKcje.generateUniqueId)()}`;
    }
    constructor(host, slotName, slotFactory, slotInitializer, useUniqueId){
        super();
        this.host = host;
        this.slotName = slotName;
        this.slotFactory = slotFactory;
        this.slotInitializer = slotInitializer;
        // Only generate the default ID if requested by the controller.
        if (useUniqueId) this.defaultId = $1f29b676ee01f55b$export$d99e5f9960a2fc4f.generateId(slotName, host);
    }
    hostConnected() {
        if (!this.initialized) {
            let node = this.getSlotChild();
            if (!node) node = this.attachDefaultNode();
            else {
                this.node = node;
                this.initCustomNode(node);
            }
            this.initNode(node);
            // TODO: Consider making this behavior opt-in to improve performance.
            this.observe();
            this.initialized = true;
        }
    }
    /**
   * Create and attach default node using the slot factory.
   * @return {Node | undefined}
   * @protected
   */ attachDefaultNode() {
        const { host: host, slotName: slotName, slotFactory: slotFactory } = this;
        // Check if the node was created previously and if so, reuse it.
        let node = this.defaultNode;
        // Slot factory is optional, some slots don't have default content.
        if (!node && slotFactory) {
            node = slotFactory(host);
            if (node instanceof Element) {
                if (slotName !== '') node.setAttribute('slot', slotName);
                this.node = node;
                this.defaultNode = node;
            }
        }
        if (node) host.appendChild(node);
        return node;
    }
    /**
   * Return a reference to the node managed by the controller.
   * @return {Node}
   */ getSlotChild() {
        const { slotName: slotName } = this;
        return Array.from(this.host.childNodes).find((node)=>{
            // Either an element (any slot) or a text node (only un-named slot).
            return node.nodeType === Node.ELEMENT_NODE && node.slot === slotName || node.nodeType === Node.TEXT_NODE && node.textContent.trim() && slotName === '';
        });
    }
    /**
   * @param {Node} node
   * @protected
   */ initNode(node) {
        const { slotInitializer: slotInitializer } = this;
        // Don't try to bind `this` to initializer (normally it's arrow function).
        // Instead, pass the host as a first argument to access component's state.
        if (slotInitializer) slotInitializer(this.host, node);
    }
    /**
   * Override to initialize the newly added custom node.
   *
   * @param {Node} _node
   * @protected
   */ initCustomNode(_node) {}
    /**
   * Override to teardown slotted node when it's removed.
   *
   * @param {Node} _node
   * @protected
   */ teardownNode(_node) {}
    /**
   * Setup the observer to manage slot content changes.
   * @protected
   */ observe() {
        const { slotName: slotName } = this;
        const selector = slotName === '' ? 'slot:not([name])' : `slot[name=${slotName}]`;
        const slot = this.host.shadowRoot.querySelector(selector);
        this.__slotObserver = new (0, $bmThs.FlattenedNodesObserver)(slot, (info)=>{
            // TODO: support default slot with multiple nodes (e.g. confirm-dialog)
            const current = this.node;
            const newNode = info.addedNodes.find((node)=>node !== current);
            if (info.removedNodes.length) info.removedNodes.forEach((node)=>{
                this.teardownNode(node);
            });
            if (newNode) {
                // Custom node is added, remove the current one.
                if (current && current.isConnected) this.host.removeChild(current);
                this.node = newNode;
                if (newNode !== this.defaultNode) {
                    this.initCustomNode(newNode);
                    this.initNode(newNode);
                }
            }
        });
    }
}

});
parcelRegister("bmThs", function(module, exports) {

$parcel$export(module.exports, "FlattenedNodesObserver", () => $846ca15af216b047$export$74371724d098aa78);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");

var $j8Ssg = parcelRequire("j8Ssg");

var $e1Pzu = parcelRequire("e1Pzu");

var $a2HIe = parcelRequire("a2HIe");
/**
 * Returns true if `node` is a slot element
 * @param {!Node} node Node to test.
 * @return {boolean} Returns true if the given `node` is a slot
 * @private
 */ function $846ca15af216b047$var$isSlot(node) {
    return node.localName === 'slot';
}
let $846ca15af216b047$export$74371724d098aa78 = class {
    /**
   * Returns the list of flattened nodes for the given `node`.
   * This list consists of a node's children and, for any children
   * that are `<slot>` elements, the expanded flattened list of `assignedNodes`.
   * For example, if the observed node has children `<a></a><slot></slot><b></b>`
   * and the `<slot>` has one `<div>` assigned to it, then the flattened
   * nodes list is `<a></a><div></div><b></b>`. If the `<slot>` has other
   * `<slot>` elements assigned to it, these are flattened as well.
   *
   * @param {!HTMLElement|!HTMLSlotElement} node The node for which to
   *      return the list of flattened nodes.
   * @return {!Array<!Node>} The list of flattened nodes for the given `node`.
   * @nocollapse See https://github.com/google/closure-compiler/issues/2763
   */ // eslint-disable-next-line
    static getFlattenedNodes(node) {
        const wrapped = (0, $a2HIe.wrap)(node);
        if ($846ca15af216b047$var$isSlot(node)) {
            /** @type {!HTMLSlotElement} */ node; // eslint-disable-line no-self-assign
            return wrapped.assignedNodes({
                flatten: true
            });
        } else return Array.from(wrapped.childNodes).map((node)=>{
            if ($846ca15af216b047$var$isSlot(node)) {
                /** @type {!HTMLSlotElement} */ node; // eslint-disable-line no-self-assign
                return (0, $a2HIe.wrap)(node).assignedNodes({
                    flatten: true
                });
            } else return [
                node
            ];
        }).reduce((a, b)=>a.concat(b), []);
    }
    /**
   * @param {!HTMLElement} target Node on which to listen for changes.
   * @param {?function(this: Element, { target: !HTMLElement, addedNodes: !Array<!Element>, removedNodes: !Array<!Element> }):void} callback Function called when there are additions
   * or removals from the target's list of flattened nodes.
   */ // eslint-disable-next-line
    constructor(target, callback){
        /**
     * @type {MutationObserver}
     * @private
     */ this._shadyChildrenObserver = null;
        /**
     * @type {MutationObserver}
     * @private
     */ this._nativeChildrenObserver = null;
        this._connected = false;
        /**
     * @type {!HTMLElement}
     * @private
     */ this._target = target;
        this.callback = callback;
        this._effectiveNodes = [];
        this._observer = null;
        this._scheduled = false;
        /**
     * @type {function()}
     * @private
     */ this._boundSchedule = ()=>{
            this._schedule();
        };
        this.connect();
        this._schedule();
    }
    /**
   * Activates an observer. This method is automatically called when
   * a `FlattenedNodesObserver` is created. It should only be called to
   * re-activate an observer that has been deactivated via the `disconnect` method.
   *
   * @return {void}
   */ connect() {
        if ($846ca15af216b047$var$isSlot(this._target)) this._listenSlots([
            this._target
        ]);
        else if ((0, $a2HIe.wrap)(this._target).children) {
            this._listenSlots(/** @type {!NodeList<!Node>} */ (0, $a2HIe.wrap)(this._target).children);
            if (window.ShadyDOM) this._shadyChildrenObserver = window.ShadyDOM.observeChildren(this._target, (mutations)=>{
                this._processMutations(mutations);
            });
            else {
                this._nativeChildrenObserver = new MutationObserver((mutations)=>{
                    this._processMutations(mutations);
                });
                this._nativeChildrenObserver.observe(this._target, {
                    childList: true
                });
            }
        }
        this._connected = true;
    }
    /**
   * Deactivates the flattened nodes observer. After calling this method
   * the observer callback will not be called when changes to flattened nodes
   * occur. The `connect` method may be subsequently called to reactivate
   * the observer.
   *
   * @return {void}
   * @override
   */ disconnect() {
        if ($846ca15af216b047$var$isSlot(this._target)) this._unlistenSlots([
            this._target
        ]);
        else if ((0, $a2HIe.wrap)(this._target).children) {
            this._unlistenSlots(/** @type {!NodeList<!Node>} */ (0, $a2HIe.wrap)(this._target).children);
            if (window.ShadyDOM && this._shadyChildrenObserver) {
                window.ShadyDOM.unobserveChildren(this._shadyChildrenObserver);
                this._shadyChildrenObserver = null;
            } else if (this._nativeChildrenObserver) {
                this._nativeChildrenObserver.disconnect();
                this._nativeChildrenObserver = null;
            }
        }
        this._connected = false;
    }
    /**
   * @return {void}
   * @private
   */ _schedule() {
        if (!this._scheduled) {
            this._scheduled = true;
            (0, $e1Pzu.microTask).run(()=>this.flush());
        }
    }
    /**
   * @param {Array<MutationRecord>} mutations Mutations signaled by the mutation observer
   * @return {void}
   * @private
   */ _processMutations(mutations) {
        this._processSlotMutations(mutations);
        this.flush();
    }
    /**
   * @param {Array<MutationRecord>} mutations Mutations signaled by the mutation observer
   * @return {void}
   * @private
   */ _processSlotMutations(mutations) {
        if (mutations) for(let i = 0; i < mutations.length; i++){
            let mutation = mutations[i];
            if (mutation.addedNodes) this._listenSlots(mutation.addedNodes);
            if (mutation.removedNodes) this._unlistenSlots(mutation.removedNodes);
        }
    }
    /**
   * Flushes the observer causing any pending changes to be immediately
   * delivered the observer callback. By default these changes are delivered
   * asynchronously at the next microtask checkpoint.
   *
   * @return {boolean} Returns true if any pending changes caused the observer
   * callback to run.
   */ flush() {
        if (!this._connected) return false;
        if (window.ShadyDOM) ShadyDOM.flush();
        if (this._nativeChildrenObserver) this._processSlotMutations(this._nativeChildrenObserver.takeRecords());
        else if (this._shadyChildrenObserver) this._processSlotMutations(this._shadyChildrenObserver.takeRecords());
        this._scheduled = false;
        let info = {
            target: this._target,
            addedNodes: [],
            removedNodes: []
        };
        let newNodes = this.constructor.getFlattenedNodes(this._target);
        let splices = (0, $j8Ssg.calculateSplices)(newNodes, this._effectiveNodes);
        // process removals
        for(let i = 0, s; i < splices.length && (s = splices[i]); i++)for(let j = 0, n; j < s.removed.length && (n = s.removed[j]); j++)info.removedNodes.push(n);
        // process adds
        for(let i = 0, s; i < splices.length && (s = splices[i]); i++)for(let j = s.index; j < s.index + s.addedCount; j++)info.addedNodes.push(newNodes[j]);
        // update cache
        this._effectiveNodes = newNodes;
        let didFlush = false;
        if (info.addedNodes.length || info.removedNodes.length) {
            didFlush = true;
            this.callback.call(this._target, info);
        }
        return didFlush;
    }
    /**
   * @param {!Array<!Node>|!NodeList<!Node>} nodeList Nodes that could change
   * @return {void}
   * @private
   */ _listenSlots(nodeList) {
        for(let i = 0; i < nodeList.length; i++){
            let n = nodeList[i];
            if ($846ca15af216b047$var$isSlot(n)) n.addEventListener('slotchange', this._boundSchedule);
        }
    }
    /**
   * @param {!Array<!Node>|!NodeList<!Node>} nodeList Nodes that could change
   * @return {void}
   * @private
   */ _unlistenSlots(nodeList) {
        for(let i = 0; i < nodeList.length; i++){
            let n = nodeList[i];
            if ($846ca15af216b047$var$isSlot(n)) n.removeEventListener('slotchange', this._boundSchedule);
        }
    }
};

});
parcelRegister("j8Ssg", function(module, exports) {

$parcel$export(module.exports, "calculateSplices", () => $def901473317a1d0$export$481c2b35e25e79f3);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ parcelRequire("dMwQI");
function $def901473317a1d0$var$newSplice(index, removed, addedCount) {
    return {
        index: index,
        removed: removed,
        addedCount: addedCount
    };
}
const $def901473317a1d0$var$EDIT_LEAVE = 0;
const $def901473317a1d0$var$EDIT_UPDATE = 1;
const $def901473317a1d0$var$EDIT_ADD = 2;
const $def901473317a1d0$var$EDIT_DELETE = 3;
// Note: This function is *based* on the computation of the Levenshtein
// "edit" distance. The one change is that "updates" are treated as two
// edits - not one. With Array splices, an update is really a delete
// followed by an add. By retaining this, we optimize for "keeping" the
// maximum array items in the original array. For example:
//
//   'xxxx123' -> '123yyyy'
//
// With 1-edit updates, the shortest path would be just to update all seven
// characters. With 2-edit updates, we delete 4, leave 3, and add 4. This
// leaves the substring '123' intact.
function $def901473317a1d0$var$calcEditDistances(current, currentStart, currentEnd, old, oldStart, oldEnd) {
    // "Deletion" columns
    let rowCount = oldEnd - oldStart + 1;
    let columnCount = currentEnd - currentStart + 1;
    let distances = new Array(rowCount);
    // "Addition" rows. Initialize null column.
    for(let i = 0; i < rowCount; i++){
        distances[i] = new Array(columnCount);
        distances[i][0] = i;
    }
    // Initialize null row
    for(let j = 0; j < columnCount; j++)distances[0][j] = j;
    for(let i = 1; i < rowCount; i++){
        for(let j = 1; j < columnCount; j++)if ($def901473317a1d0$var$equals(current[currentStart + j - 1], old[oldStart + i - 1])) distances[i][j] = distances[i - 1][j - 1];
        else {
            let north = distances[i - 1][j] + 1;
            let west = distances[i][j - 1] + 1;
            distances[i][j] = north < west ? north : west;
        }
    }
    return distances;
}
// This starts at the final weight, and walks "backward" by finding
// the minimum previous weight recursively until the origin of the weight
// matrix.
function $def901473317a1d0$var$spliceOperationsFromEditDistances(distances) {
    let i = distances.length - 1;
    let j = distances[0].length - 1;
    let current = distances[i][j];
    let edits = [];
    while(i > 0 || j > 0){
        if (i == 0) {
            edits.push($def901473317a1d0$var$EDIT_ADD);
            j--;
            continue;
        }
        if (j == 0) {
            edits.push($def901473317a1d0$var$EDIT_DELETE);
            i--;
            continue;
        }
        let northWest = distances[i - 1][j - 1];
        let west = distances[i - 1][j];
        let north = distances[i][j - 1];
        let min;
        if (west < north) min = west < northWest ? west : northWest;
        else min = north < northWest ? north : northWest;
        if (min == northWest) {
            if (northWest == current) edits.push($def901473317a1d0$var$EDIT_LEAVE);
            else {
                edits.push($def901473317a1d0$var$EDIT_UPDATE);
                current = northWest;
            }
            i--;
            j--;
        } else if (min == west) {
            edits.push($def901473317a1d0$var$EDIT_DELETE);
            i--;
            current = west;
        } else {
            edits.push($def901473317a1d0$var$EDIT_ADD);
            j--;
            current = north;
        }
    }
    edits.reverse();
    return edits;
}
/**
 * Splice Projection functions:
 *
 * A splice map is a representation of how a previous array of items
 * was transformed into a new array of items. Conceptually it is a list of
 * tuples of
 *
 *   <index, removed, addedCount>
 *
 * which are kept in ascending index order of. The tuple represents that at
 * the |index|, |removed| sequence of items were removed, and counting forward
 * from |index|, |addedCount| items were added.
 */ /**
 * Lacking individual splice mutation information, the minimal set of
 * splices can be synthesized given the previous state and final state of an
 * array. The basic approach is to calculate the edit distance matrix and
 * choose the shortest path through it.
 *
 * Complexity: O(l * p)
 *   l: The length of the current array
 *   p: The length of the old array
 *
 * @param {!Array} current The current "changed" array for which to
 * calculate splices.
 * @param {number} currentStart Starting index in the `current` array for
 * which splices are calculated.
 * @param {number} currentEnd Ending index in the `current` array for
 * which splices are calculated.
 * @param {!Array} old The original "unchanged" array to compare `current`
 * against to determine splices.
 * @param {number} oldStart Starting index in the `old` array for
 * which splices are calculated.
 * @param {number} oldEnd Ending index in the `old` array for
 * which splices are calculated.
 * @return {!Array} Returns an array of splice record objects. Each of these
 * contains: `index` the location where the splice occurred; `removed`
 * the array of removed items from this location; `addedCount` the number
 * of items added at this location.
 */ function $def901473317a1d0$var$calcSplices(current, currentStart, currentEnd, old, oldStart, oldEnd) {
    let prefixCount = 0;
    let suffixCount = 0;
    let splice;
    let minLength = Math.min(currentEnd - currentStart, oldEnd - oldStart);
    if (currentStart == 0 && oldStart == 0) prefixCount = $def901473317a1d0$var$sharedPrefix(current, old, minLength);
    if (currentEnd == current.length && oldEnd == old.length) suffixCount = $def901473317a1d0$var$sharedSuffix(current, old, minLength - prefixCount);
    currentStart += prefixCount;
    oldStart += prefixCount;
    currentEnd -= suffixCount;
    oldEnd -= suffixCount;
    if (currentEnd - currentStart == 0 && oldEnd - oldStart == 0) return [];
    if (currentStart == currentEnd) {
        splice = $def901473317a1d0$var$newSplice(currentStart, [], 0);
        while(oldStart < oldEnd)splice.removed.push(old[oldStart++]);
        return [
            splice
        ];
    } else if (oldStart == oldEnd) return [
        $def901473317a1d0$var$newSplice(currentStart, [], currentEnd - currentStart)
    ];
    let ops = $def901473317a1d0$var$spliceOperationsFromEditDistances($def901473317a1d0$var$calcEditDistances(current, currentStart, currentEnd, old, oldStart, oldEnd));
    splice = undefined;
    let splices = [];
    let index = currentStart;
    let oldIndex = oldStart;
    for(let i = 0; i < ops.length; i++)switch(ops[i]){
        case $def901473317a1d0$var$EDIT_LEAVE:
            if (splice) {
                splices.push(splice);
                splice = undefined;
            }
            index++;
            oldIndex++;
            break;
        case $def901473317a1d0$var$EDIT_UPDATE:
            if (!splice) splice = $def901473317a1d0$var$newSplice(index, [], 0);
            splice.addedCount++;
            index++;
            splice.removed.push(old[oldIndex]);
            oldIndex++;
            break;
        case $def901473317a1d0$var$EDIT_ADD:
            if (!splice) splice = $def901473317a1d0$var$newSplice(index, [], 0);
            splice.addedCount++;
            index++;
            break;
        case $def901473317a1d0$var$EDIT_DELETE:
            if (!splice) splice = $def901473317a1d0$var$newSplice(index, [], 0);
            splice.removed.push(old[oldIndex]);
            oldIndex++;
            break;
    }
    if (splice) splices.push(splice);
    return splices;
}
function $def901473317a1d0$var$sharedPrefix(current, old, searchLength) {
    for(let i = 0; i < searchLength; i++)if (!$def901473317a1d0$var$equals(current[i], old[i])) return i;
    return searchLength;
}
function $def901473317a1d0$var$sharedSuffix(current, old, searchLength) {
    let index1 = current.length;
    let index2 = old.length;
    let count = 0;
    while(count < searchLength && $def901473317a1d0$var$equals(current[--index1], old[--index2]))count++;
    return count;
}
function $def901473317a1d0$export$481c2b35e25e79f3(current, previous) {
    return $def901473317a1d0$var$calcSplices(current, 0, current.length, previous, 0, previous.length);
}
function $def901473317a1d0$var$equals(currentValue, previousValue) {
    return currentValue === previousValue;
}

});


parcelRegister("kKcje", function(module, exports) {

$parcel$export(module.exports, "generateUniqueId", () => $f1a1a6da2789f736$export$48da330df5248c4c);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ let $f1a1a6da2789f736$var$uniqueId = 0;
function $f1a1a6da2789f736$export$dcddc765718ba168() {
    $f1a1a6da2789f736$var$uniqueId = 0;
}
function $f1a1a6da2789f736$export$48da330df5248c4c() {
    // eslint-disable-next-line no-plusplus
    return $f1a1a6da2789f736$var$uniqueId++;
}

});



parcelRegister("bwrUf", function(module, exports) {

$parcel$export(module.exports, "LabelMixin", () => $86385470817ffe40$export$cbcd29e611f64d3f);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");

var $bthO9 = parcelRequire("bthO9");

var $dyNMU = parcelRequire("dyNMU");
const $86385470817ffe40$export$cbcd29e611f64d3f = (0, $gLdkK.dedupingMixin)((superclass)=>class LabelMixinClass extends (0, $bthO9.ControllerMixin)(superclass) {
        static get properties() {
            return {
                /**
           * The label text for the input node.
           * When no light dom defined via [slot=label], this value will be used.
           */ label: {
                    type: String,
                    observer: '_labelChanged'
                }
            };
        }
        /** @protected */ get _labelId() {
            return this._labelController.labelId;
        }
        /** @protected */ get _labelNode() {
            return this._labelController.node;
        }
        constructor(){
            super();
            this._labelController = new (0, $dyNMU.LabelController)(this);
        }
        /** @protected */ ready() {
            super.ready();
            this.addController(this._labelController);
        }
        /** @protected */ _labelChanged(label) {
            this._labelController.setLabel(label);
        }
    });

});
parcelRegister("dyNMU", function(module, exports) {

$parcel$export(module.exports, "LabelController", () => $9df51227b2c9ac7c$export$6263e1ddeb9de3f);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $2FSxb = parcelRequire("2FSxb");
class $9df51227b2c9ac7c$export$6263e1ddeb9de3f extends (0, $2FSxb.SlotController) {
    constructor(host){
        super(host, 'label', ()=>document.createElement('label'), (_host, node)=>{
            // Set ID attribute or use the existing one.
            this.__updateLabelId(node);
            // Set text content for the default label.
            this.__updateDefaultLabel(this.label);
            this.__observeLabel(node);
        }, true);
    }
    /**
   * @return {string}
   */ get labelId() {
        return this.node.id;
    }
    /**
   * Override to initialize the newly added custom label.
   *
   * @param {Node} labelNode
   * @protected
   * @override
   */ initCustomNode(labelNode) {
        this.__updateLabelId(labelNode);
        const hasLabel = this.__hasLabel(labelNode);
        this.__toggleHasLabel(hasLabel);
    }
    /**
   * Override to cleanup label node when it's removed.
   *
   * @param {Node} node
   * @protected
   * @override
   */ teardownNode(node) {
        if (this.__labelObserver) this.__labelObserver.disconnect();
        let labelNode = this.getSlotChild();
        // If custom label was removed, restore the default one.
        if (!labelNode && node !== this.defaultNode) {
            labelNode = this.attachDefaultNode();
            // Run initializer to update default label and ID.
            this.initNode(labelNode);
        }
        const hasLabel = this.__hasLabel(labelNode);
        this.__toggleHasLabel(hasLabel);
    }
    /**
   * Set label based on corresponding host property.
   *
   * @param {string} label
   */ setLabel(label) {
        this.label = label;
        this.__updateDefaultLabel(label);
    }
    /**
   * @param {HTMLElement} labelNode
   * @return {boolean}
   * @private
   */ __hasLabel(labelNode) {
        if (!labelNode) return false;
        return labelNode.children.length > 0 || this.__isNotEmpty(labelNode.textContent);
    }
    /**
   * @param {string} label
   * @private
   */ __isNotEmpty(label) {
        return Boolean(label && label.trim() !== '');
    }
    /**
   * @param {HTMLElement} labelNode
   * @private
   */ __observeLabel(labelNode) {
        this.__labelObserver = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                const target = mutation.target;
                // Ensure the mutation target is the currently connected label
                // to ignore async mutations dispatched for removed element.
                const isLabelMutation = target === this.node;
                if (mutation.type === 'attributes') // We use attributeFilter to only observe ID mutation,
                // no need to check for attribute name separately.
                {
                    if (isLabelMutation && target.id !== this.defaultId) this.__updateLabelId(target);
                } else if (isLabelMutation || target.parentElement === this.node) {
                    // Update has-label when textContent changes
                    const hasLabel = this.__hasLabel(this.node);
                    this.__toggleHasLabel(hasLabel);
                }
            });
        });
        // Observe changes to label ID attribute, text content and children.
        this.__labelObserver.observe(labelNode, {
            attributes: true,
            attributeFilter: [
                'id'
            ],
            childList: true,
            subtree: true,
            characterData: true
        });
    }
    /**
   * @param {boolean} hasLabel
   * @private
   */ __toggleHasLabel(hasLabel) {
        this.host.toggleAttribute('has-label', hasLabel);
        // Make it possible for other mixins to observe change
        this.dispatchEvent(new CustomEvent('label-changed', {
            detail: {
                hasLabel: hasLabel,
                node: this.node
            }
        }));
    }
    /**
   * @param {string} label
   * @private
   */ __updateDefaultLabel(label) {
        if (this.defaultNode) {
            this.defaultNode.textContent = label;
            // Update has-label if default label is used
            if (this.defaultNode === this.node) {
                const hasLabel = this.__isNotEmpty(label);
                this.__toggleHasLabel(hasLabel);
            }
        }
    }
    /**
   * @param {HTMLElement} labelNode
   * @private
   */ __updateLabelId(labelNode) {
        if (!labelNode.id) labelNode.id = this.defaultId;
    }
}

});


parcelRegister("jqW2B", function(module, exports) {

$parcel$export(module.exports, "LabelledInputController", () => $e25d77bfc378390e$export$c0f474a50b9c72b8);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /**
 * A controller for linking a `<label>` element with an `<input>` element.
 */ class $e25d77bfc378390e$export$c0f474a50b9c72b8 {
    constructor(input, labelController){
        this.input = input;
        this.__preventDuplicateLabelClick = this.__preventDuplicateLabelClick.bind(this);
        labelController.addEventListener('label-changed', (event)=>{
            this.__initLabel(event.detail.node);
        });
        // Initialize the default label element
        this.__initLabel(labelController.node);
    }
    /**
   * @param {HTMLElement} label
   * @private
   */ __initLabel(label) {
        if (label) {
            label.addEventListener('click', this.__preventDuplicateLabelClick);
            if (this.input) label.setAttribute('for', this.input.id);
        }
    }
    /**
   * The native platform fires an event for both the click on the label, and also
   * the subsequent click on the native input element caused by label click.
   * This results in two click events arriving at the host, but we only want one.
   * This method prevents the duplicate click and ensures the correct isTrusted event
   * with the correct event.target arrives at the host.
   * @private
   */ __preventDuplicateLabelClick() {
        const inputClickHandler = (e)=>{
            e.stopImmediatePropagation();
            this.input.removeEventListener('click', inputClickHandler);
        };
        this.input.addEventListener('click', inputClickHandler);
    }
}

});

parcelRegister("aGZym", function(module, exports) {

$parcel$export(module.exports, "SlotTargetController", () => $7c8d92d0598c30fa$export$2f8705fc71168c07);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /**
 * A controller to copy the content from a source slot to a target element.
 */ class $7c8d92d0598c30fa$export$2f8705fc71168c07 {
    constructor(sourceSlot, targetFactory, callback){
        /**
     * The source `<slot>` element to copy nodes from.
     */ this.sourceSlot = sourceSlot;
        /**
     * Function used to get a reference to slot target.
     */ this.targetFactory = targetFactory;
        /**
     * Function called after copying nodes to target.
     */ this.copyCallback = callback;
        if (sourceSlot) sourceSlot.addEventListener('slotchange', ()=>{
            // Copy in progress, ignore this event.
            if (this.__copying) this.__copying = false;
            else this.__checkAndCopyNodesToSlotTarget();
        });
    }
    hostConnected() {
        this.__sourceSlotObserver = new MutationObserver(()=>this.__checkAndCopyNodesToSlotTarget());
        // Ensure the content is up to date when host is connected
        // to handle e.g. mutating text content while disconnected.
        // Note, `hostConnected()` is called twice if the controller
        // is initialized in `ready()` when using `ControllerMixin`.
        if (!this.__copying) this.__checkAndCopyNodesToSlotTarget();
    }
    /**
   * Copies every node from the source slot to the target element
   * once the source slot' content is changed.
   *
   * @private
   */ __checkAndCopyNodesToSlotTarget() {
        this.__sourceSlotObserver.disconnect();
        // Ensure slot target element is up to date.
        const slotTarget = this.targetFactory();
        if (!slotTarget) return;
        // Remove any existing clones from the slot target
        if (this.__slotTargetClones) {
            this.__slotTargetClones.forEach((node)=>{
                if (node.parentElement === slotTarget) slotTarget.removeChild(node);
            });
            delete this.__slotTargetClones;
        }
        // Exclude whitespace text nodes
        const nodes = this.sourceSlot.assignedNodes({
            flatten: true
        }).filter((node)=>!(node.nodeType === Node.TEXT_NODE && node.textContent.trim() === ''));
        if (nodes.length > 0) {
            slotTarget.innerHTML = '';
            // Ignore next slotchange
            this.__copying = true;
            this.__copyNodesToSlotTarget(nodes, slotTarget);
        }
    }
    /**
   * Copies the nodes to the target element.
   *
   * @param {!Array<!Node>} nodes
   * @param {HTMLElement} slotTarget
   * @private
   */ __copyNodesToSlotTarget(nodes, slotTarget) {
        this.__slotTargetClones = this.__slotTargetClones || [];
        nodes.forEach((node)=>{
            // Clone the nodes and append the clones to the target
            const clone = node.cloneNode(true);
            this.__slotTargetClones.push(clone);
            slotTarget.appendChild(clone);
            // Observe all changes to the source node to have the clones updated
            this.__sourceSlotObserver.observe(node, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });
        });
        // Run callback e.g. to show a deprecation warning
        if (typeof this.copyCallback === 'function') this.copyCallback(nodes);
    }
}

});



parcelRegister("c7Fn3", function(module, exports) {
parcelRequire("bpTdN");
parcelRequire("6Yt1B");
parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");

var $dfakg = parcelRequire("dfakg");

var $cNhTY = parcelRequire("cNhTY");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $8d363ae4cbce4db8$var$radioGroup = (0, $aOvNQ.css)`
  :host {
    color: var(--lumo-body-text-color);
    font-size: var(--lumo-font-size-m);
    font-family: var(--lumo-font-family);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    padding: var(--lumo-space-xs) 0;
  }

  :host::before {
    /* Effective height of vaadin-radio-button */
    height: var(--lumo-size-s);
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
  }

  :host([theme~='vertical']) [part='group-field'] {
    display: flex;
    flex-direction: column;
  }

  :host([focused]:not([readonly])) [part='label'] {
    color: var(--lumo-primary-text-color);
  }

  :host(:hover:not([readonly]):not([focused])) [part='label'],
  :host(:hover:not([readonly])) [part='helper-text'] {
    color: var(--lumo-body-text-color);
  }

  /* Touch device adjustment */
  @media (pointer: coarse) {
    :host(:hover:not([readonly]):not([focused])) [part='label'] {
      color: var(--lumo-secondary-text-color);
    }
  }
`;
(0, $2vXFS.registerStyles)('vaadin-radio-group', [
    (0, $cNhTY.requiredField),
    (0, $dfakg.helper),
    $8d363ae4cbce4db8$var$radioGroup
], {
    moduleId: 'lumo-radio-group'
});

});
parcelRegister("dfakg", function(module, exports) {

$parcel$export(module.exports, "helper", () => $9a44af97d9e94cfa$export$4bbbbc0a0e57a7f);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("bpTdN");
parcelRequire("6Yt1B");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
const $9a44af97d9e94cfa$export$4bbbbc0a0e57a7f = (0, $aOvNQ.css)`
  :host([has-helper]) [part='helper-text']::before {
    content: '';
    display: block;
    height: 0.4em;
  }

  [part='helper-text'] {
    display: block;
    color: var(--lumo-secondary-text-color);
    font-size: var(--lumo-font-size-xs);
    line-height: var(--lumo-line-height-xs);
    margin-left: calc(var(--lumo-border-radius-m) / 4);
    transition: color 0.2s;
  }

  :host(:hover:not([readonly])) [part='helper-text'] {
    color: var(--lumo-body-text-color);
  }

  :host([disabled]) [part='helper-text'] {
    color: var(--lumo-disabled-text-color);
    -webkit-text-fill-color: var(--lumo-disabled-text-color);
  }

  :host([has-helper][theme~='helper-above-field']) [part='helper-text']::before {
    display: none;
  }

  :host([has-helper][theme~='helper-above-field']) [part='helper-text']::after {
    content: '';
    display: block;
    height: 0.4em;
  }

  :host([has-helper][theme~='helper-above-field']) [part='label'] {
    order: 0;
    padding-bottom: 0.4em;
  }

  :host([has-helper][theme~='helper-above-field']) [part='helper-text'] {
    order: 1;
  }

  :host([has-helper][theme~='helper-above-field']) [part='label'] + * {
    order: 2;
  }

  :host([has-helper][theme~='helper-above-field']) [part='error-message'] {
    order: 3;
  }
`;

});

parcelRegister("cNhTY", function(module, exports) {

$parcel$export(module.exports, "requiredField", () => $9507f28bdc9dde2f$export$caa603400c5f2880);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("bpTdN");
parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $9507f28bdc9dde2f$export$caa603400c5f2880 = (0, $aOvNQ.css)`
  [part='label'] {
    align-self: flex-start;
    color: var(--lumo-secondary-text-color);
    font-weight: 500;
    font-size: var(--lumo-font-size-s);
    margin-left: calc(var(--lumo-border-radius-m) / 4);
    transition: color 0.2s;
    line-height: 1;
    padding-right: 1em;
    padding-bottom: 0.5em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: relative;
    max-width: 100%;
    box-sizing: border-box;
  }

  :host([has-label])::before {
    margin-top: calc(var(--lumo-font-size-s) * 1.5);
  }

  :host([has-label][theme~='small'])::before {
    margin-top: calc(var(--lumo-font-size-xs) * 1.5);
  }

  :host([has-label]) {
    padding-top: var(--lumo-space-m);
  }

  :host([has-label]) ::slotted([slot='tooltip']) {
    --vaadin-tooltip-offset-bottom: calc((var(--lumo-space-m) - var(--lumo-space-xs)) * -1);
  }

  :host([required]) [part='required-indicator']::after {
    content: var(--lumo-required-field-indicator, '•');
    transition: opacity 0.2s;
    color: var(--lumo-required-field-indicator-color, var(--lumo-primary-text-color));
    position: absolute;
    right: 0;
    width: 1em;
    text-align: center;
  }

  :host([invalid]) [part='required-indicator']::after {
    color: var(--lumo-required-field-indicator-color, var(--lumo-error-text-color));
  }

  [part='error-message'] {
    margin-left: calc(var(--lumo-border-radius-m) / 4);
    font-size: var(--lumo-font-size-xs);
    line-height: var(--lumo-line-height-xs);
    color: var(--lumo-error-text-color);
    will-change: max-height;
    transition: 0.4s max-height;
    max-height: 5em;
  }

  :host([has-error-message]) [part='error-message']::before,
  :host([has-error-message]) [part='error-message']::after {
    content: '';
    display: block;
    height: 0.4em;
  }

  :host(:not([invalid])) [part='error-message'] {
    max-height: 0;
    overflow: hidden;
  }

  /* RTL specific styles */

  :host([dir='rtl']) [part='label'] {
    margin-left: 0;
    margin-right: calc(var(--lumo-border-radius-m) / 4);
  }

  :host([dir='rtl']) [part='label'] {
    padding-left: 1em;
    padding-right: 0;
  }

  :host([dir='rtl']) [part='required-indicator']::after {
    right: auto;
    left: 0;
  }

  :host([dir='rtl']) [part='error-message'] {
    margin-left: 0;
    margin-right: calc(var(--lumo-border-radius-m) / 4);
  }
`;
(0, $2vXFS.registerStyles)('', $9507f28bdc9dde2f$export$caa603400c5f2880, {
    moduleId: 'lumo-required-field'
});

});


parcelRegister("1SiTW", function(module, exports) {

$parcel$export(module.exports, "RadioGroup", () => $15d97efe325828b6$export$a98f0dcb43a68a25);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $bmThs = parcelRequire("bmThs");
parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $jf0Pl = parcelRequire("jf0Pl");

var $9Q7uu = parcelRequire("9Q7uu");

var $4fPbK = parcelRequire("4fPbK");

var $j2V0r = parcelRequire("j2V0r");

var $6hU3M = parcelRequire("6hU3M");

var $kKcje = parcelRequire("kKcje");

var $h6L7N = parcelRequire("h6L7N");

var $2vXFS = parcelRequire("2vXFS");

var $jfKYS = parcelRequire("jfKYS");
/**
 * `<vaadin-radio-group>` is a web component that allows the user to choose one item from a group of choices.
 *
 * ```html
 * <vaadin-radio-group label="Travel class">
 *   <vaadin-radio-button value="economy" label="Economy"></vaadin-radio-button>
 *   <vaadin-radio-button value="business" label="Business"></vaadin-radio-button>
 *   <vaadin-radio-button value="firstClass" label="First Class"></vaadin-radio-button>
 * </vaadin-radio-group>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name            | Description
 * ---------------------|----------------
 * `label`              | The slotted label element wrapper
 * `group-field`        | The radio button elements wrapper
 * `helper-text`        | The slotted helper text element wrapper
 * `error-message`      | The slotted error message element wrapper
 * `required-indicator` | The `required` state indicator element
 *
 * The following state attributes are available for styling:
 *
 * Attribute           | Description                               | Part name
 * --------------------|-------------------------------------------|------------
 * `disabled`          | Set when the element is disabled          | :host
 * `readonly`          | Set when the element is readonly          | :host
 * `invalid`           | Set when the element is invalid           | :host
 * `focused`           | Set when the element is focused           | :host
 * `has-label`         | Set when the element has a label          | :host
 * `has-value`         | Set when the element has a value          | :host
 * `has-helper`        | Set when the element has helper text      | :host
 * `has-error-message` | Set when the element has an error message | :host
 *
 * See [Styling Components](https://vaadin.com/docs/latest/styling/custom-theme/styling-components) documentation.
 *
 * @fires {CustomEvent} invalid-changed - Fired when the `invalid` property changes.
 * @fires {CustomEvent} value-changed - Fired when the `value` property changes.
 * @fires {CustomEvent} validated - Fired whenever the field is validated.
 *
 * @extends HTMLElement
 * @mixes ThemableMixin
 * @mixes DisabledMixin
 * @mixes ElementMixin
 * @mixes FocusMixin
 * @mixes FieldMixin
 * @mixes KeyboardMixin
 */ class $15d97efe325828b6$export$a98f0dcb43a68a25 extends (0, $h6L7N.FieldMixin)((0, $4fPbK.FocusMixin)((0, $jf0Pl.DisabledMixin)((0, $j2V0r.KeyboardMixin)((0, $9Q7uu.ElementMixin)((0, $2vXFS.ThemableMixin)((0, $5QhZ5.PolymerElement))))))) {
    static get is() {
        return 'vaadin-radio-group';
    }
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host {
          display: inline-flex;
        }

        :host::before {
          content: '\\2003';
          width: 0;
          display: inline-block;
        }

        :host([hidden]) {
          display: none !important;
        }

        .vaadin-group-field-container {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        :host(:not([has-label])) [part='label'] {
          display: none;
        }
      </style>
      <div class="vaadin-group-field-container">
        <div part="label">
          <slot name="label"></slot>
          <span part="required-indicator" aria-hidden="true"></span>
        </div>

        <div part="group-field">
          <slot></slot>
        </div>

        <div part="helper-text">
          <slot name="helper"></slot>
        </div>

        <div part="error-message">
          <slot name="error-message"></slot>
        </div>
      </div>

      <slot name="tooltip"></slot>
    `;
    }
    static get properties() {
        return {
            /**
       * The value of the radio group.
       *
       * @type {string}
       */ value: {
                type: String,
                notify: true,
                value: '',
                observer: '__valueChanged'
            },
            /**
       * When present, the user cannot modify the value of the radio group.
       * The property works similarly to the `disabled` property.
       * While the `disabled` property disables all radio buttons inside the group,
       * the `readonly` property disables only unchecked ones.
       *
       * @type {boolean}
       */ readonly: {
                type: Boolean,
                value: false,
                reflectToAttribute: true,
                observer: '__readonlyChanged'
            },
            /**
       * @type {string}
       * @private
       */ _fieldName: {
                type: String
            }
        };
    }
    constructor(){
        super();
        this.__registerRadioButton = this.__registerRadioButton.bind(this);
        this.__unregisterRadioButton = this.__unregisterRadioButton.bind(this);
        this.__onRadioButtonCheckedChange = this.__onRadioButtonCheckedChange.bind(this);
    }
    /** @protected */ ready() {
        super.ready();
        this.ariaTarget = this;
        // See https://github.com/vaadin/vaadin-web-components/issues/94
        this.setAttribute('role', 'radiogroup');
        this._fieldName = `${this.localName}-${(0, $kKcje.generateUniqueId)()}`;
        this._observer = new (0, $bmThs.FlattenedNodesObserver)(this, ({ addedNodes: addedNodes, removedNodes: removedNodes })=>{
            // Registers the added radio buttons in the reverse order
            // in order for the group to take the value of the most recent button.
            this.__filterRadioButtons(addedNodes).reverse().forEach(this.__registerRadioButton);
            // Unregisters the removed radio buttons.
            this.__filterRadioButtons(removedNodes).forEach(this.__unregisterRadioButton);
        });
        this._tooltipController = new (0, $6hU3M.TooltipController)(this);
        this.addController(this._tooltipController);
    }
    /**
   * @param {!Array<!Node>} nodes
   * @return {!Array<!RadioButton>}
   * @private
   */ __filterRadioButtons(nodes) {
        return nodes.filter((child)=>child instanceof (0, $jfKYS.RadioButton));
    }
    /**
   * A collection of the group's radio buttons.
   *
   * @return {!Array<!RadioButton>}
   * @private
   */ get __radioButtons() {
        return this.__filterRadioButtons([
            ...this.children
        ]);
    }
    /**
   * A currently selected radio button.
   *
   * @return {!RadioButton | undefined}
   * @private
   */ get __selectedRadioButton() {
        return this.__radioButtons.find((radioButton)=>radioButton.checked);
    }
    /**
   * @return {boolean}
   * @private
   */ get isHorizontalRTL() {
        return this.getAttribute('dir') === 'rtl' && this._theme !== 'vertical';
    }
    /**
   * Override method inherited from `KeyboardMixin`
   * to implement the custom keyboard navigation as a replacement for the native one
   * in order for the navigation to work the same way across different browsers.
   *
   * @param {!KeyboardEvent} event
   * @override
   * @protected
   */ _onKeyDown(event) {
        super._onKeyDown(event);
        const radioButton = event.composedPath().find((node)=>node instanceof (0, $jfKYS.RadioButton));
        if ([
            'ArrowLeft',
            'ArrowUp'
        ].includes(event.key)) {
            event.preventDefault();
            this.__selectNextRadioButton(radioButton);
        }
        if ([
            'ArrowRight',
            'ArrowDown'
        ].includes(event.key)) {
            event.preventDefault();
            this.__selectPrevRadioButton(radioButton);
        }
    }
    /**
   * Override an observer from `FieldMixin`.
   *
   * @param {boolean} invalid
   * @protected
   * @override
   */ _invalidChanged(invalid) {
        super._invalidChanged(invalid);
        if (invalid) this.setAttribute('aria-invalid', 'true');
        else this.removeAttribute('aria-invalid');
    }
    /**
   * @param {number} index
   * @private
   */ __selectNextRadioButton(radioButton) {
        const index = this.__radioButtons.indexOf(radioButton);
        this.__selectIncRadioButton(index, this.isHorizontalRTL ? 1 : -1);
    }
    /**
   * @param {number} index
   * @private
   */ __selectPrevRadioButton(radioButton) {
        const index = this.__radioButtons.indexOf(radioButton);
        this.__selectIncRadioButton(index, this.isHorizontalRTL ? -1 : 1);
    }
    /**
   * @param {number} index
   * @param {number} step
   * @private
   */ __selectIncRadioButton(index, step) {
        const newIndex = (this.__radioButtons.length + index + step) % this.__radioButtons.length;
        const newRadioButton = this.__radioButtons[newIndex];
        if (newRadioButton.disabled) this.__selectIncRadioButton(newIndex, step);
        else {
            newRadioButton.focusElement.focus();
            newRadioButton.focusElement.click();
        }
    }
    /**
   * Registers the radio button after adding it to the group.
   *
   * @param {!RadioButton} radioButton
   * @private
   */ __registerRadioButton(radioButton) {
        radioButton.name = this._fieldName;
        radioButton.addEventListener('checked-changed', this.__onRadioButtonCheckedChange);
        if (this.disabled || this.readonly) radioButton.disabled = true;
        if (radioButton.checked) this.__selectRadioButton(radioButton);
    }
    /**
   * Unregisters the radio button before removing it from the group.
   *
   * @param {!RadioButton} radioButton
   * @private
   */ __unregisterRadioButton(radioButton) {
        radioButton.removeEventListener('checked-changed', this.__onRadioButtonCheckedChange);
        if (radioButton.value === this.value) this.__selectRadioButton(null);
    }
    /**
   * @param {!CustomEvent} event
   * @private
   */ __onRadioButtonCheckedChange(event) {
        if (event.target.checked) this.__selectRadioButton(event.target);
    }
    /**
   * Whenever the user sets a non-empty value,
   * the method tries to select the radio button with that value
   * showing a warning if no radio button was found with the given value.
   * If the new value is empty, the method deselects the currently selected radio button.
   * At last, the method toggles the `has-value` attribute considering the new value.
   *
   * @param {string | null | undefined} newValue
   * @param {string | null | undefined} oldValue
   * @private
   */ __valueChanged(newValue, oldValue) {
        if (oldValue === undefined && newValue === '') return;
        if (newValue) {
            const newSelectedRadioButton = this.__radioButtons.find((radioButton)=>{
                return radioButton.value === newValue;
            });
            if (newSelectedRadioButton) {
                this.__selectRadioButton(newSelectedRadioButton);
                this.toggleAttribute('has-value', true);
            } else console.warn(`The radio button with the value "${newValue}" was not found.`);
        } else {
            this.__selectRadioButton(null);
            this.removeAttribute('has-value');
        }
        if (oldValue !== undefined) this.validate();
    }
    /**
   * Whenever `readonly` property changes on the group element,
   * the method updates the `disabled` property for the radio buttons.
   *
   * @param {boolean} newValue
   * @param {boolean} oldValue
   * @private
   */ __readonlyChanged(newValue, oldValue) {
        // Prevent updating the `disabled` property for the radio buttons at initialization.
        // Otherwise, the group's radio buttons may end up enabled regardless
        // an intentionally added `disabled` attribute on some of them.
        if (!newValue && oldValue === undefined) return;
        if (oldValue !== newValue) this.__updateRadioButtonsDisabledProperty();
    }
    /**
   * Override method inherited from `DisabledMixin`
   * to update the `disabled` property for the radio buttons
   * whenever the property changes on the group element.
   *
   * @param {boolean} newValue
   * @param {boolean} oldValue
   * @override
   * @protected
   */ _disabledChanged(newValue, oldValue) {
        super._disabledChanged(newValue, oldValue);
        // Prevent updating the `disabled` property for the radio buttons at initialization.
        // Otherwise, the group's radio buttons may end up enabled regardless
        // an intentionally added `disabled` attribute on some of them.
        if (!newValue && oldValue === undefined) return;
        if (oldValue !== newValue) this.__updateRadioButtonsDisabledProperty();
    }
    /**
   * Override method inherited from `FocusMixin`
   * to prevent removing the `focused` attribute
   * when focus moves between radio buttons inside the group.
   *
   * @param {!FocusEvent} event
   * @return {boolean}
   * @protected
   */ _shouldRemoveFocus(event) {
        return !this.contains(event.relatedTarget);
    }
    /**
   * Override method inherited from `FocusMixin`
   * to run validation when the group loses focus.
   *
   * @param {boolean} focused
   * @override
   * @protected
   */ _setFocused(focused) {
        super._setFocused(focused);
        if (!focused) this.validate();
    }
    /**
   * @param {RadioButton} radioButton
   * @private
   */ __selectRadioButton(radioButton) {
        if (radioButton) this.value = radioButton.value;
        else this.value = '';
        this.__radioButtons.forEach((button)=>{
            button.checked = button === radioButton;
        });
        if (this.readonly) this.__updateRadioButtonsDisabledProperty();
    }
    /**
   * If the group is read-only, the method disables the unchecked radio buttons.
   * Otherwise, the method propagates the group's `disabled` property to the radio buttons.
   *
   * @private
   */ __updateRadioButtonsDisabledProperty() {
        this.__radioButtons.forEach((button)=>{
            if (this.readonly) // The native radio button doesn't support the `readonly` attribute
            // so the state can be only imitated, by disabling unchecked radio buttons.
            button.disabled = button !== this.__selectedRadioButton;
            else button.disabled = this.disabled;
        });
    }
}
customElements.define($15d97efe325828b6$export$a98f0dcb43a68a25.is, $15d97efe325828b6$export$a98f0dcb43a68a25);

});
parcelRegister("6hU3M", function(module, exports) {

$parcel$export(module.exports, "TooltipController", () => $493fd0f49e402870$export$ad76ea7b944b0d8);
/**
 * @license
 * Copyright (c) 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $2FSxb = parcelRequire("2FSxb");
class $493fd0f49e402870$export$ad76ea7b944b0d8 extends (0, $2FSxb.SlotController) {
    constructor(host){
        // Do not provide slot factory to create tooltip lazily.
        super(host, 'tooltip');
        this.setTarget(host);
    }
    /**
   * Override to initialize the newly added custom tooltip.
   *
   * @param {Node} tooltipNode
   * @protected
   * @override
   */ initCustomNode(tooltipNode) {
        tooltipNode.target = this.target;
        if (this.context !== undefined) tooltipNode.context = this.context;
        if (this.manual !== undefined) tooltipNode.manual = this.manual;
        if (this.opened !== undefined) tooltipNode.opened = this.opened;
        if (this.position !== undefined) tooltipNode._position = this.position;
        if (this.shouldShow !== undefined) tooltipNode.shouldShow = this.shouldShow;
    }
    /**
   * Set a context object to be used by generator.
   * @param {object} context
   */ setContext(context) {
        this.context = context;
        const tooltipNode = this.node;
        if (tooltipNode) tooltipNode.context = context;
    }
    /**
   * Toggle manual state on the slotted tooltip.
   * @param {boolean} manual
   */ setManual(manual) {
        this.manual = manual;
        const tooltipNode = this.node;
        if (tooltipNode) tooltipNode.manual = manual;
    }
    /**
   * Toggle opened state on the slotted tooltip.
   * @param {boolean} opened
   */ setOpened(opened) {
        this.opened = opened;
        const tooltipNode = this.node;
        if (tooltipNode) tooltipNode.opened = opened;
    }
    /**
   * Set default position for the slotted tooltip.
   * This can be overridden by setting the position
   * using corresponding property or attribute.
   * @param {string} position
   */ setPosition(position) {
        this.position = position;
        const tooltipNode = this.node;
        if (tooltipNode) tooltipNode._position = position;
    }
    /**
   * Set function used to detect whether to show
   * the tooltip based on a condition.
   * @param {Function} shouldShow
   */ setShouldShow(shouldShow) {
        this.shouldShow = shouldShow;
        const tooltipNode = this.node;
        if (tooltipNode) tooltipNode.shouldShow = shouldShow;
    }
    /**
   * Set an HTML element to attach the tooltip to.
   * @param {HTMLElement} target
   */ setTarget(target) {
        this.target = target;
        const tooltipNode = this.node;
        if (tooltipNode) tooltipNode.target = target;
    }
}

});

parcelRegister("h6L7N", function(module, exports) {

$parcel$export(module.exports, "FieldMixin", () => $c7478d3155bd2568$export$a1c6019e2d4681a);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $bthO9 = parcelRequire("bthO9");

var $5uz4A = parcelRequire("5uz4A");

var $4AyE9 = parcelRequire("4AyE9");

var $fjyOi = parcelRequire("fjyOi");

var $bwrUf = parcelRequire("bwrUf");

var $19qDG = parcelRequire("19qDG");
const $c7478d3155bd2568$export$a1c6019e2d4681a = (superclass)=>class FieldMixinClass extends (0, $19qDG.ValidateMixin)((0, $bwrUf.LabelMixin)((0, $bthO9.ControllerMixin)(superclass))) {
        static get properties() {
            return {
                /**
         * A target element to which ARIA attributes are set.
         * @protected
         */ ariaTarget: {
                    type: Object,
                    observer: '_ariaTargetChanged'
                },
                /**
         * Error to show when the field is invalid.
         *
         * @attr {string} error-message
         */ errorMessage: {
                    type: String,
                    observer: '_errorMessageChanged'
                },
                /**
         * String used for the helper text.
         * @attr {string} helper-text
         */ helperText: {
                    type: String,
                    observer: '_helperTextChanged'
                }
            };
        }
        static get observers() {
            return [
                '_invalidChanged(invalid)',
                '_requiredChanged(required)'
            ];
        }
        /** @protected */ get _errorId() {
            return this._errorController.errorId;
        }
        /**
     * @protected
     * @return {HTMLElement}
     */ get _errorNode() {
            return this._errorController.node;
        }
        /** @protected */ get _helperId() {
            return this._helperController.helperId;
        }
        /**
     * @protected
     * @return {HTMLElement}
     */ get _helperNode() {
            return this._helperController.node;
        }
        constructor(){
            super();
            this._fieldAriaController = new (0, $4AyE9.FieldAriaController)(this);
            this._helperController = new (0, $fjyOi.HelperController)(this);
            this._errorController = new (0, $5uz4A.ErrorController)(this);
            this._labelController.addEventListener('label-changed', (event)=>{
                const { hasLabel: hasLabel, node: node } = event.detail;
                this.__labelChanged(hasLabel, node);
            });
            this._helperController.addEventListener('helper-changed', (event)=>{
                const { hasHelper: hasHelper, node: node } = event.detail;
                this.__helperChanged(hasHelper, node);
            });
        }
        /** @protected */ ready() {
            super.ready();
            this.addController(this._fieldAriaController);
            this.addController(this._helperController);
            this.addController(this._errorController);
        }
        /** @private */ __helperChanged(hasHelper, helperNode) {
            if (hasHelper) this._fieldAriaController.setHelperId(helperNode.id);
            else this._fieldAriaController.setHelperId(null);
        }
        /** @private */ __labelChanged(hasLabel, labelNode) {
            // Label ID should be only added when the label content is present.
            // Otherwise, it may conflict with an `aria-label` attribute possibly added by the user.
            if (hasLabel) this._fieldAriaController.setLabelId(labelNode.id);
            else this._fieldAriaController.setLabelId(null);
        }
        /**
     * @param {string | null | undefined} errorMessage
     * @protected
     */ _errorMessageChanged(errorMessage) {
            this._errorController.setErrorMessage(errorMessage);
        }
        /**
     * @param {string} helperText
     * @protected
     */ _helperTextChanged(helperText) {
            this._helperController.setHelperText(helperText);
        }
        /**
     * @param {HTMLElement | null | undefined} target
     * @protected
     */ _ariaTargetChanged(target) {
            if (target) this._fieldAriaController.setTarget(target);
        }
        /**
     * @param {boolean} required
     * @protected
     */ _requiredChanged(required) {
            this._fieldAriaController.setRequired(required);
        }
        /**
     * @param {boolean} invalid
     * @protected
     */ _invalidChanged(invalid) {
            this._errorController.setInvalid(invalid);
            // This timeout is needed to prevent NVDA from announcing the error message twice:
            // 1. Once adding the `[role=alert]` attribute when updating `has-error-message` (OK).
            // 2. Once linking the error ID with the ARIA target here (unwanted).
            // Related issue: https://github.com/vaadin/web-components/issues/3061.
            setTimeout(()=>{
                // Error message ID needs to be dynamically added / removed based on the validity
                // Otherwise assistive technologies would announce the error, even if we hide it.
                if (invalid) this._fieldAriaController.setErrorId(this._errorController.errorId);
                else this._fieldAriaController.setErrorId(null);
            });
        }
    };

});
parcelRegister("5uz4A", function(module, exports) {

$parcel$export(module.exports, "ErrorController", () => $3ffaf5d643748e5a$export$2f5b22783539ff2);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $2FSxb = parcelRequire("2FSxb");
class $3ffaf5d643748e5a$export$2f5b22783539ff2 extends (0, $2FSxb.SlotController) {
    constructor(host){
        super(host, 'error-message', ()=>document.createElement('div'), (_host, node)=>{
            this.__updateErrorId(node);
            this.__updateHasError();
        }, true);
    }
    /**
   * ID attribute value set on the error message element.
   *
   * @return {string}
   */ get errorId() {
        return this.node && this.node.id;
    }
    /**
   * Set the error message element text content.
   *
   * @param {string} errorMessage
   */ setErrorMessage(errorMessage) {
        this.errorMessage = errorMessage;
        this.__updateHasError();
    }
    /**
   * Set invalid state for detecting whether to show error message.
   *
   * @param {boolean} invalid
   */ setInvalid(invalid) {
        this.invalid = invalid;
        this.__updateHasError();
    }
    /**
   * Override to initialize the newly added custom error message.
   *
   * @param {Node} errorNode
   * @protected
   * @override
   */ initCustomNode(errorNode) {
        this.__updateErrorId(errorNode);
        // Save the custom error message content on the host.
        if (errorNode.textContent && !this.errorMessage) this.errorMessage = errorNode.textContent.trim();
        this.__updateHasError();
    }
    /**
   * Override to cleanup error message node when it's removed.
   *
   * @param {Node} node
   * @protected
   * @override
   */ teardownNode(node) {
        let errorNode = this.getSlotChild();
        // If custom error was removed, restore the default one.
        if (!errorNode && node !== this.defaultNode) {
            errorNode = this.attachDefaultNode();
            // Run initializer to update default error message ID.
            this.initNode(errorNode);
        }
        this.__updateHasError();
    }
    /**
   * @param {string} error
   * @private
   */ __isNotEmpty(error) {
        return Boolean(error && error.trim() !== '');
    }
    /** @private */ __updateHasError() {
        const errorNode = this.node;
        const hasError = Boolean(this.invalid && this.__isNotEmpty(this.errorMessage));
        // Update both default and custom error message node.
        if (errorNode) {
            errorNode.textContent = hasError ? this.errorMessage : '';
            errorNode.hidden = !hasError;
            // Role alert will make the error message announce immediately
            // as the field becomes invalid
            if (hasError) errorNode.setAttribute('role', 'alert');
            else errorNode.removeAttribute('role');
        }
        this.host.toggleAttribute('has-error-message', hasError);
    }
    /**
   * @param {HTMLElement} errorNode
   * @private
   */ __updateErrorId(errorNode) {
        if (!errorNode.id) errorNode.id = this.defaultId;
    }
}

});

parcelRegister("4AyE9", function(module, exports) {

$parcel$export(module.exports, "FieldAriaController", () => $35756652ecc31b4e$export$3470bc9033706270);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $1hZF6 = parcelRequire("1hZF6");
class $35756652ecc31b4e$export$3470bc9033706270 {
    constructor(host){
        this.host = host;
        this.__required = false;
    }
    /**
   * Sets a target element to which ARIA attributes are added.
   *
   * @param {HTMLElement} target
   */ setTarget(target) {
        this.__target = target;
        this.__setAriaRequiredAttribute(this.__required);
        this.__setLabelIdToAriaAttribute(this.__labelId);
        this.__setErrorIdToAriaAttribute(this.__errorId);
        this.__setHelperIdToAriaAttribute(this.__helperId);
    }
    /**
   * Toggles the `aria-required` attribute on the target element
   * if the target is the host component (e.g. a field group).
   * Otherwise, it does nothing.
   *
   * @param {boolean} required
   */ setRequired(required) {
        this.__setAriaRequiredAttribute(required);
        this.__required = required;
    }
    /**
   * Links the target element with a slotted label element
   * via the target's attribute `aria-labelledby`.
   *
   * To unlink the previous slotted label element, pass `null` as `labelId`.
   *
   * @param {string | null} labelId
   */ setLabelId(labelId) {
        this.__setLabelIdToAriaAttribute(labelId, this.__labelId);
        this.__labelId = labelId;
    }
    /**
   * Links the target element with a slotted error element via the target's attribute:
   * - `aria-labelledby` if the target is the host component (e.g a field group).
   * - `aria-describedby` otherwise.
   *
   * To unlink the previous slotted error element, pass `null` as `errorId`.
   *
   * @param {string | null} errorId
   */ setErrorId(errorId) {
        this.__setErrorIdToAriaAttribute(errorId, this.__errorId);
        this.__errorId = errorId;
    }
    /**
   * Links the target element with a slotted helper element via the target's attribute:
   * - `aria-labelledby` if the target is the host component (e.g a field group).
   * - `aria-describedby` otherwise.
   *
   * To unlink the previous slotted helper element, pass `null` as `helperId`.
   *
   * @param {string | null} helperId
   */ setHelperId(helperId) {
        this.__setHelperIdToAriaAttribute(helperId, this.__helperId);
        this.__helperId = helperId;
    }
    /**
   * `true` if the target element is the host component itself, `false` otherwise.
   *
   * @return {boolean}
   * @private
   */ get __isGroupField() {
        return this.__target === this.host;
    }
    /**
   * @param {string | null | undefined} labelId
   * @param {string | null | undefined} oldLabelId
   * @private
   */ __setLabelIdToAriaAttribute(labelId, oldLabelId) {
        this.__setAriaAttributeId('aria-labelledby', labelId, oldLabelId);
    }
    /**
   * @param {string | null | undefined} errorId
   * @param {string | null | undefined} oldErrorId
   * @private
   */ __setErrorIdToAriaAttribute(errorId, oldErrorId) {
        // For groups, add all IDs to aria-labelledby rather than aria-describedby -
        // that should guarantee that it's announced when the group is entered.
        if (this.__isGroupField) this.__setAriaAttributeId('aria-labelledby', errorId, oldErrorId);
        else this.__setAriaAttributeId('aria-describedby', errorId, oldErrorId);
    }
    /**
   * @param {string | null | undefined} helperId
   * @param {string | null | undefined} oldHelperId
   * @private
   */ __setHelperIdToAriaAttribute(helperId, oldHelperId) {
        // For groups, add all IDs to aria-labelledby rather than aria-describedby -
        // that should guarantee that it's announced when the group is entered.
        if (this.__isGroupField) this.__setAriaAttributeId('aria-labelledby', helperId, oldHelperId);
        else this.__setAriaAttributeId('aria-describedby', helperId, oldHelperId);
    }
    /**
   * @param {boolean} required
   * @private
   */ __setAriaRequiredAttribute(required) {
        if (!this.__target) return;
        if ([
            'input',
            'textarea'
        ].includes(this.__target.localName)) // Native <input> or <textarea>, required is enough
        return;
        if (required) this.__target.setAttribute('aria-required', 'true');
        else this.__target.removeAttribute('aria-required');
    }
    /**
   * @param {string | null | undefined} newId
   * @param {string | null | undefined} oldId
   * @private
   */ __setAriaAttributeId(attr, newId, oldId) {
        if (!this.__target) return;
        if (oldId) (0, $1hZF6.removeValueFromAttribute)(this.__target, attr, oldId);
        if (newId) (0, $1hZF6.addValueToAttribute)(this.__target, attr, newId);
    }
}

});
parcelRegister("1hZF6", function(module, exports) {

$parcel$export(module.exports, "getAncestorRootNodes", () => $0f0735bbb48e1326$export$f468768a14585a00);
$parcel$export(module.exports, "addValueToAttribute", () => $0f0735bbb48e1326$export$dd5fdeca6c2771d2);
$parcel$export(module.exports, "removeValueFromAttribute", () => $0f0735bbb48e1326$export$944bbb5e8d729ef5);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /**
 * Returns an array of ancestor root nodes for the given node.
 *
 * A root node is either a document node or a document fragment node (Shadow Root).
 * The array is collected by a bottom-up DOM traversing that starts with the given node
 * and involves both the light DOM and ancestor shadow DOM trees.
 *
 * @param {Node} node
 * @return {Node[]}
 */ function $0f0735bbb48e1326$export$f468768a14585a00(node) {
    const result = [];
    while(node){
        if (node.nodeType === Node.DOCUMENT_NODE) {
            result.push(node);
            break;
        }
        if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            result.push(node);
            node = node.host;
            continue;
        }
        if (node.assignedSlot) {
            node = node.assignedSlot;
            continue;
        }
        node = node.parentNode;
    }
    return result;
}
/**
 * @param {string} value
 * @return {Set<string>}
 */ function $0f0735bbb48e1326$var$deserializeAttributeValue(value) {
    if (!value) return new Set();
    return new Set(value.split(' '));
}
/**
 * @param {Set<string>} values
 * @return {string}
 */ function $0f0735bbb48e1326$var$serializeAttributeValue(values) {
    return [
        ...values
    ].join(' ');
}
function $0f0735bbb48e1326$export$dd5fdeca6c2771d2(element, attr, value) {
    const values = $0f0735bbb48e1326$var$deserializeAttributeValue(element.getAttribute(attr));
    values.add(value);
    element.setAttribute(attr, $0f0735bbb48e1326$var$serializeAttributeValue(values));
}
function $0f0735bbb48e1326$export$944bbb5e8d729ef5(element, attr, value) {
    const values = $0f0735bbb48e1326$var$deserializeAttributeValue(element.getAttribute(attr));
    values.delete(value);
    if (values.size === 0) {
        element.removeAttribute(attr);
        return;
    }
    element.setAttribute(attr, $0f0735bbb48e1326$var$serializeAttributeValue(values));
}
function $0f0735bbb48e1326$export$9a3952b0c60ec2e8(node) {
    return node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '';
}

});


parcelRegister("fjyOi", function(module, exports) {

$parcel$export(module.exports, "HelperController", () => $b263a1edf3a98d56$export$591b08e240d4ee6f);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $2FSxb = parcelRequire("2FSxb");
class $b263a1edf3a98d56$export$591b08e240d4ee6f extends (0, $2FSxb.SlotController) {
    constructor(host){
        // Do not provide slot factory, as only create helper lazily.
        super(host, 'helper', null, null, true);
    }
    get helperId() {
        return this.node && this.node.id;
    }
    /**
   * Override to initialize the newly added custom helper.
   *
   * @param {Node} helperNode
   * @protected
   * @override
   */ initCustomNode(helperNode) {
        this.__updateHelperId(helperNode);
        this.__observeHelper(helperNode);
        const hasHelper = this.__hasHelper(helperNode);
        this.__toggleHasHelper(hasHelper);
    }
    /**
   * Override to cleanup helper node when it's removed.
   *
   * @param {Node} _node
   * @protected
   * @override
   */ teardownNode(_node) {
        // The observer does not exist when the default helper is removed.
        if (this.__helperIdObserver) this.__helperIdObserver.disconnect();
        const helperNode = this.getSlotChild();
        // Custom node is added to helper slot
        if (helperNode && helperNode !== this.defaultNode) {
            const hasHelper = this.__hasHelper(helperNode);
            this.__toggleHasHelper(hasHelper);
        } else // Restore default helper if needed
        this.__applyDefaultHelper(this.helperText, helperNode);
    }
    /**
   * Set helper text based on corresponding host property.
   * @param {string} helperText
   */ setHelperText(helperText) {
        this.helperText = helperText;
        const helperNode = this.getSlotChild();
        if (!helperNode || helperNode === this.defaultNode) this.__applyDefaultHelper(helperText, helperNode);
    }
    /**
   * @param {HTMLElement} helperNode
   * @return {boolean}
   * @private
   */ __hasHelper(helperNode) {
        if (!helperNode) return false;
        return helperNode.children.length > 0 || helperNode.nodeType === Node.ELEMENT_NODE && customElements.get(helperNode.localName) || this.__isNotEmpty(helperNode.textContent);
    }
    /**
   * @param {string} helperText
   * @private
   */ __isNotEmpty(helperText) {
        return helperText && helperText.trim() !== '';
    }
    /**
   * @param {string} helperText
   * @param {Node} helperNode
   * @private
   */ __applyDefaultHelper(helperText, helperNode) {
        const hasHelperText = this.__isNotEmpty(helperText);
        if (hasHelperText && !helperNode) {
            // Set slot factory lazily to only create helper node when needed.
            this.slotFactory = ()=>document.createElement('div');
            helperNode = this.attachDefaultNode();
            this.__updateHelperId(helperNode);
            this.__observeHelper(helperNode);
        }
        if (helperNode) helperNode.textContent = helperText;
        this.__toggleHasHelper(hasHelperText);
    }
    /**
   * @param {HTMLElement} helperNode
   * @private
   */ __observeHelper(helperNode) {
        this.__helperObserver = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                const target = mutation.target;
                // Ensure the mutation target is the currently connected helper
                // to ignore async mutations dispatched for removed element.
                const isHelperMutation = target === this.node;
                if (mutation.type === 'attributes') // We use attributeFilter to only observe ID mutation,
                // no need to check for attribute name separately.
                {
                    if (isHelperMutation && target.id !== this.defaultId) this.__updateHelperId(target);
                } else if (isHelperMutation || target.parentElement === this.node) {
                    // Update has-helper when textContent changes
                    const hasHelper = this.__hasHelper(this.node);
                    this.__toggleHasHelper(hasHelper);
                }
            });
        });
        // Observe changes to helper ID attribute, text content and children.
        this.__helperObserver.observe(helperNode, {
            attributes: true,
            attributeFilter: [
                'id'
            ],
            childList: true,
            subtree: true,
            characterData: true
        });
    }
    /**
   * @param {boolean} hasHelper
   * @private
   */ __toggleHasHelper(hasHelper) {
        this.host.toggleAttribute('has-helper', hasHelper);
        // Make it possible for other mixins to observe change
        this.dispatchEvent(new CustomEvent('helper-changed', {
            detail: {
                hasHelper: hasHelper,
                node: this.node
            }
        }));
    }
    /**
   * @param {HTMLElement} helperNode
   * @private
   */ __updateHelperId(helperNode) {
        if (!helperNode.id) helperNode.id = this.defaultId;
    }
}

});

parcelRegister("19qDG", function(module, exports) {

$parcel$export(module.exports, "ValidateMixin", () => $0d6b4ba71ec6e211$export$e9e8a342b9615b67);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");
const $0d6b4ba71ec6e211$export$e9e8a342b9615b67 = (0, $gLdkK.dedupingMixin)((superclass)=>class ValidateMixinClass extends superclass {
        static get properties() {
            return {
                /**
           * Set to true when the field is invalid.
           */ invalid: {
                    type: Boolean,
                    reflectToAttribute: true,
                    notify: true,
                    value: false
                },
                /**
           * Specifies that the user must fill in a value.
           */ required: {
                    type: Boolean,
                    reflectToAttribute: true
                }
            };
        }
        /**
       * Validates the field and sets the `invalid` property based on the result.
       *
       * The method fires a `validated` event with the result of the validation.
       *
       * @return {boolean} True if the value is valid.
       */ validate() {
            const isValid = this.checkValidity();
            this._setInvalid(!isValid);
            this.dispatchEvent(new CustomEvent('validated', {
                detail: {
                    valid: isValid
                }
            }));
            return isValid;
        }
        /**
       * Returns true if the field value satisfies all constraints (if any).
       *
       * @return {boolean}
       */ checkValidity() {
            return !this.required || !!this.value;
        }
        /**
       * @param {boolean} invalid
       * @protected
       */ _setInvalid(invalid) {
            if (this._shouldSetInvalid(invalid)) this.invalid = invalid;
        }
        /**
       * Override this method to define whether the given `invalid` state should be set.
       *
       * @param {boolean} _invalid
       * @return {boolean}
       * @protected
       */ _shouldSetInvalid(_invalid) {
            return true;
        }
    });

});





parcelRegister("giEjU", function(module, exports) {
$parcel$export(module.exports, "RadioButton", () => (parcelRequire("jfKYS")).RadioButton);
parcelRequire("kYWqb");
parcelRequire("jfKYS");

});

parcelRegister("l79he", function(module, exports) {

$parcel$export(module.exports, "ReactRevealComponent", () => $2ca3cc53ed9b0898$export$5735f0c87672cc75);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $1jYF4 = parcelRequire("1jYF4");
class $2ca3cc53ed9b0898$export$5735f0c87672cc75 extends (0, $4TeKW.LitElement) {
    OnUpdateFirst() {
        setTimeout(()=>this.template = (0, $4TeKW.html)`<div class="container"><slot></slot></div>`, this.delay);
    }
    constructor(...args){
        super(...args), this.template = (0, $4TeKW.html)``, this.delay = 300;
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $2ca3cc53ed9b0898$export$5735f0c87672cc75.prototype, "template", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $2ca3cc53ed9b0898$export$5735f0c87672cc75.prototype, "delay", void 0);
$2ca3cc53ed9b0898$export$5735f0c87672cc75 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'react-reveal',
        style: (0, $4TeKW.css)`
    ${(0, $1jYF4.ReactRevealAnimation)}
    .container {
      animation-name: react-reveal;
      animation-duration: 700ms;
      animation-delay: 0ms;
    }
  `,
        template () {
            return (0, $4TeKW.html)`${this.template}`;
        }
    })
], $2ca3cc53ed9b0898$export$5735f0c87672cc75);

});

parcelRegister("kSPmD", function(module, exports) {

$parcel$export(module.exports, "BootstrapComponent", () => $858b46198033c31f$export$3ea30aac1b6a504);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");
class $858b46198033c31f$export$3ea30aac1b6a504 extends HTMLElement {
}
$858b46198033c31f$export$3ea30aac1b6a504 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'bootstrap-component',
        template () {
            return (0, $4TeKW.html)`
      <link href="//maxcdn.bootstrapcdn.com/bootstrap/3.3.0/css/bootstrap.min.css" rel="stylesheet" />
      <script src="//maxcdn.bootstrapcdn.com/bootstrap/3.3.0/js/bootstrap.min.js"></script>
    `;
        }
    })
], $858b46198033c31f$export$3ea30aac1b6a504);

});

parcelRegister("fnUZ8", function(module, exports) {

$parcel$export(module.exports, "CardComponent", () => $1ed70c54dc35e409$export$e506ae60b6852702);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $7n7fg = parcelRequire("7n7fg");
class $1ed70c54dc35e409$export$e506ae60b6852702 extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.shadow = 'card-1';
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $1ed70c54dc35e409$export$e506ae60b6852702.prototype, "shadow", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $1ed70c54dc35e409$export$e506ae60b6852702.prototype, "invert", void 0);
$1ed70c54dc35e409$export$e506ae60b6852702 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'card-component',
        style: (0, $4TeKW.css)`
    ${(0, $7n7fg.MaterialBoxCSS)}
  `,
        template () {
            return (0, $4TeKW.html)`
      <div class="card ${this.shadow}${this.invert ? ' black' : ''}">
        <slot></slot>
      </div>
    `;
        }
    })
], $1ed70c54dc35e409$export$e506ae60b6852702);

});
parcelRegister("7n7fg", function(module, exports) {

$parcel$export(module.exports, "MaterialBoxCSS", () => $21a7f67c7c5866ab$export$d717dba7d3b525fc);

var $4TeKW = parcelRequire("4TeKW");
const $21a7f67c7c5866ab$export$d717dba7d3b525fc = (0, $4TeKW.css)`
  body {
    background: #e2e1e0;
    text-align: center;
  }

  .card {
    color: #91999a;
    background-color: #fff;
    border-radius: 8px;
    margin: 0px;
  }

  .card-1 {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.14);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .card-1:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.08), 0 10px 10px rgba(0, 0, 0, 0.08);
  }

  .black {
    box-shadow: 0 14px 28px rgba(233, 233, 233, 0.2), 0 10px 10px rgba(232, 232, 232, 0.18);
  }

  .card-2 {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }

  .card-3 {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  }

  .card-4 {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  .card-5 {
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  }
`;

});


parcelRegister("6Dl1J", function(module, exports) {
$parcel$export(module.exports, "DiffComponent", () => (parcelRequire("b3n0V")).DiffComponent);
parcelRequire("b3n0V");

});
parcelRegister("b3n0V", function(module, exports) {

$parcel$export(module.exports, "DiffComponent", () => $1815b5b0de79c0fc$export$dfc60bfa971ae2d7);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $20KDD = parcelRequire("20KDD");
class $1815b5b0de79c0fc$export$dfc60bfa971ae2d7 extends (0, $4TeKW.LitElement) {
    OnUpdate() {
        this.createDiffElements();
    }
    createDiffElements() {
        this.display.innerHTML = '';
        if (!this.display) return;
        this.new = this.new ?? '';
        this.old = this.old ?? '';
        const versions = {
            chars: (0, $20KDD.diffChars)(this.new, this.old),
            sentences: (0, $20KDD.diffSentences)(this.new, this.old),
            words: (0, $20KDD.diffCss)(this.new, this.old),
            json: (0, $20KDD.diffJson)(this.new, this.old)
        };
        const diff = versions[this.version] ?? (0, $20KDD.diffCss)(this.new, this.old);
        const fragment = document.createDocumentFragment();
        const elements = {
            default: 'span',
            added: 'ins',
            removed: 'del'
        };
        const spans = diff.map((part)=>{
            const element = part.added ? elements.added : part.removed ? elements.removed : elements.default;
            const span = document.createElement(element);
            span.appendChild(document.createTextNode(part.value));
            return span;
        });
        for (const span of spans)fragment.appendChild(span);
        this.display.appendChild(fragment);
    }
    constructor(...args){
        super(...args), this.version = 'words';
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $1815b5b0de79c0fc$export$dfc60bfa971ae2d7.prototype, "new", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $1815b5b0de79c0fc$export$dfc60bfa971ae2d7.prototype, "old", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.query)('#display')
], $1815b5b0de79c0fc$export$dfc60bfa971ae2d7.prototype, "display", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $1815b5b0de79c0fc$export$dfc60bfa971ae2d7.prototype, "version", void 0);
$1815b5b0de79c0fc$export$dfc60bfa971ae2d7 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'rx-diff',
        style: (0, $4TeKW.css)`
    span {
      color: 'gray';
      background: 'transparent';
    }
    ins {
      background: #eaf2c2;
      color: #406619;
      text-decoration: none;
    }

    del {
      color: #b30000;
      background: #fadad7;
      text-decoration: 'line-through';
    }

    #display {
      white-space: pre-wrap;
      display: contents;
    }
  `,
        template () {
            return (0, $4TeKW.html)`<div id="display"></div>`;
        }
    })
], $1815b5b0de79c0fc$export$dfc60bfa971ae2d7);

});
parcelRegister("20KDD", function(module, exports) {
/*!

 diff v5.1.0

Software License Agreement (BSD License)

Copyright (c) 2009-2015, Kevin Decker <kpdecker@gmail.com>

All rights reserved.

Redistribution and use of this software in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above
  copyright notice, this list of conditions and the
  following disclaimer.

* Redistributions in binary form must reproduce the above
  copyright notice, this list of conditions and the
  following disclaimer in the documentation and/or other
  materials provided with the distribution.

* Neither the name of Kevin Decker nor the names of its
  contributors may be used to endorse or promote products
  derived from this software without specific prior
  written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR
CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER
IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
@license
*/ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    function Diff() {}
    Diff.prototype = {
        diff: function diff(oldString, newString) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var callback = options.callback;
            if (typeof options === 'function') {
                callback = options;
                options = {};
            }
            this.options = options;
            var self = this;
            function done(value) {
                if (callback) {
                    setTimeout(function() {
                        callback(undefined, value);
                    }, 0);
                    return true;
                } else return value;
            } // Allow subclasses to massage the input prior to running
            oldString = this.castInput(oldString);
            newString = this.castInput(newString);
            oldString = this.removeEmpty(this.tokenize(oldString));
            newString = this.removeEmpty(this.tokenize(newString));
            var newLen = newString.length, oldLen = oldString.length;
            var editLength = 1;
            var maxEditLength = newLen + oldLen;
            if (options.maxEditLength) maxEditLength = Math.min(maxEditLength, options.maxEditLength);
            var bestPath = [
                {
                    newPos: -1,
                    components: []
                }
            ]; // Seed editLength = 0, i.e. the content starts with the same values
            var oldPos = this.extractCommon(bestPath[0], newString, oldString, 0);
            if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) // Identity per the equality and tokenizer
            return done([
                {
                    value: this.join(newString),
                    count: newString.length
                }
            ]);
             // Main worker method. checks all permutations of a given edit length for acceptance.
            function execEditLength() {
                for(var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2){
                    var basePath = void 0;
                    var addPath = bestPath[diagonalPath - 1], removePath = bestPath[diagonalPath + 1], _oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
                    if (addPath) // No one else is going to attempt to use this value, clear it
                    bestPath[diagonalPath - 1] = undefined;
                    var canAdd = addPath && addPath.newPos + 1 < newLen, canRemove = removePath && 0 <= _oldPos && _oldPos < oldLen;
                    if (!canAdd && !canRemove) {
                        // If this path is a terminal then prune
                        bestPath[diagonalPath] = undefined;
                        continue;
                    } // Select the diagonal that we want to branch from. We select the prior
                    // path whose position in the new string is the farthest from the origin
                    // and does not pass the bounds of the diff graph
                    if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
                        basePath = clonePath(removePath);
                        self.pushComponent(basePath.components, undefined, true);
                    } else {
                        basePath = addPath; // No need to clone, we've pulled it from the list
                        basePath.newPos++;
                        self.pushComponent(basePath.components, true, undefined);
                    }
                    _oldPos = self.extractCommon(basePath, newString, oldString, diagonalPath); // If we have hit the end of both strings, then we are done
                    if (basePath.newPos + 1 >= newLen && _oldPos + 1 >= oldLen) return done(buildValues(self, basePath.components, newString, oldString, self.useLongestToken));
                    else // Otherwise track this path as a potential candidate and continue.
                    bestPath[diagonalPath] = basePath;
                }
                editLength++;
            } // Performs the length of edit iteration. Is a bit fugly as this has to support the
            // sync and async mode which is never fun. Loops over execEditLength until a value
            // is produced, or until the edit length exceeds options.maxEditLength (if given),
            // in which case it will return undefined.
            if (callback) (function exec() {
                setTimeout(function() {
                    if (editLength > maxEditLength) return callback();
                    if (!execEditLength()) exec();
                }, 0);
            })();
            else while(editLength <= maxEditLength){
                var ret = execEditLength();
                if (ret) return ret;
            }
        },
        pushComponent: function pushComponent(components, added, removed) {
            var last = components[components.length - 1];
            if (last && last.added === added && last.removed === removed) // We need to clone here as the component clone operation is just
            // as shallow array clone
            components[components.length - 1] = {
                count: last.count + 1,
                added: added,
                removed: removed
            };
            else components.push({
                count: 1,
                added: added,
                removed: removed
            });
        },
        extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath) {
            var newLen = newString.length, oldLen = oldString.length, newPos = basePath.newPos, oldPos = newPos - diagonalPath, commonCount = 0;
            while(newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])){
                newPos++;
                oldPos++;
                commonCount++;
            }
            if (commonCount) basePath.components.push({
                count: commonCount
            });
            basePath.newPos = newPos;
            return oldPos;
        },
        equals: function equals(left, right) {
            if (this.options.comparator) return this.options.comparator(left, right);
            else return left === right || this.options.ignoreCase && left.toLowerCase() === right.toLowerCase();
        },
        removeEmpty: function removeEmpty(array) {
            var ret = [];
            for(var i = 0; i < array.length; i++)if (array[i]) ret.push(array[i]);
            return ret;
        },
        castInput: function castInput(value) {
            return value;
        },
        tokenize: function tokenize(value) {
            return value.split('');
        },
        join: function join(chars) {
            return chars.join('');
        }
    };
    function buildValues(diff, components, newString, oldString, useLongestToken) {
        var componentPos = 0, componentLen = components.length, newPos = 0, oldPos = 0;
        for(; componentPos < componentLen; componentPos++){
            var component = components[componentPos];
            if (!component.removed) {
                if (!component.added && useLongestToken) {
                    var value = newString.slice(newPos, newPos + component.count);
                    value = value.map(function(value, i) {
                        var oldValue = oldString[oldPos + i];
                        return oldValue.length > value.length ? oldValue : value;
                    });
                    component.value = diff.join(value);
                } else component.value = diff.join(newString.slice(newPos, newPos + component.count));
                newPos += component.count; // Common case
                if (!component.added) oldPos += component.count;
            } else {
                component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
                oldPos += component.count; // Reverse add and remove so removes are output first to match common convention
                // The diffing algorithm is tied to add then remove output and this is the simplest
                // route to get the desired output with minimal overhead.
                if (componentPos && components[componentPos - 1].added) {
                    var tmp = components[componentPos - 1];
                    components[componentPos - 1] = components[componentPos];
                    components[componentPos] = tmp;
                }
            }
        } // Special case handle for when one terminal is ignored (i.e. whitespace).
        // For this case we merge the terminal into the prior string and drop the change.
        // This is only available for string mode.
        var lastComponent = components[componentLen - 1];
        if (componentLen > 1 && typeof lastComponent.value === 'string' && (lastComponent.added || lastComponent.removed) && diff.equals('', lastComponent.value)) {
            components[componentLen - 2].value += lastComponent.value;
            components.pop();
        }
        return components;
    }
    function clonePath(path) {
        return {
            newPos: path.newPos,
            components: path.components.slice(0)
        };
    }
    var characterDiff = new Diff();
    function diffChars(oldStr, newStr, options) {
        return characterDiff.diff(oldStr, newStr, options);
    }
    function generateOptions(options, defaults) {
        if (typeof options === 'function') defaults.callback = options;
        else if (options) {
            for(var name in options)/* istanbul ignore else */ if (options.hasOwnProperty(name)) defaults[name] = options[name];
        }
        return defaults;
    }
    //
    // Ranges and exceptions:
    // Latin-1 Supplement, 0080–00FF
    //  - U+00D7  × Multiplication sign
    //  - U+00F7  ÷ Division sign
    // Latin Extended-A, 0100–017F
    // Latin Extended-B, 0180–024F
    // IPA Extensions, 0250–02AF
    // Spacing Modifier Letters, 02B0–02FF
    //  - U+02C7  ˇ &#711;  Caron
    //  - U+02D8  ˘ &#728;  Breve
    //  - U+02D9  ˙ &#729;  Dot Above
    //  - U+02DA  ˚ &#730;  Ring Above
    //  - U+02DB  ˛ &#731;  Ogonek
    //  - U+02DC  ˜ &#732;  Small Tilde
    //  - U+02DD  ˝ &#733;  Double Acute Accent
    // Latin Extended Additional, 1E00–1EFF
    var extendedWordChars = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/;
    var reWhitespace = /\S/;
    var wordDiff = new Diff();
    wordDiff.equals = function(left, right) {
        if (this.options.ignoreCase) {
            left = left.toLowerCase();
            right = right.toLowerCase();
        }
        return left === right || this.options.ignoreWhitespace && !reWhitespace.test(left) && !reWhitespace.test(right);
    };
    wordDiff.tokenize = function(value) {
        // All whitespace symbols except newline group into one token, each newline - in separate token
        var tokens = value.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/); // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.
        for(var i = 0; i < tokens.length - 1; i++)// If we have an empty string in the next field and we have only word chars before and after, merge
        if (!tokens[i + 1] && tokens[i + 2] && extendedWordChars.test(tokens[i]) && extendedWordChars.test(tokens[i + 2])) {
            tokens[i] += tokens[i + 2];
            tokens.splice(i + 1, 2);
            i--;
        }
        return tokens;
    };
    function diffWords(oldStr, newStr, options) {
        options = generateOptions(options, {
            ignoreWhitespace: true
        });
        return wordDiff.diff(oldStr, newStr, options);
    }
    function diffWordsWithSpace(oldStr, newStr, options) {
        return wordDiff.diff(oldStr, newStr, options);
    }
    var lineDiff = new Diff();
    lineDiff.tokenize = function(value) {
        var retLines = [], linesAndNewlines = value.split(/(\n|\r\n)/); // Ignore the final empty token that occurs if the string ends with a new line
        if (!linesAndNewlines[linesAndNewlines.length - 1]) linesAndNewlines.pop();
         // Merge the content and line separators into single tokens
        for(var i = 0; i < linesAndNewlines.length; i++){
            var line = linesAndNewlines[i];
            if (i % 2 && !this.options.newlineIsToken) retLines[retLines.length - 1] += line;
            else {
                if (this.options.ignoreWhitespace) line = line.trim();
                retLines.push(line);
            }
        }
        return retLines;
    };
    function diffLines(oldStr, newStr, callback) {
        return lineDiff.diff(oldStr, newStr, callback);
    }
    function diffTrimmedLines(oldStr, newStr, callback) {
        var options = generateOptions(callback, {
            ignoreWhitespace: true
        });
        return lineDiff.diff(oldStr, newStr, options);
    }
    var sentenceDiff = new Diff();
    sentenceDiff.tokenize = function(value) {
        return value.split(/(\S.+?[.!?])(?=\s+|$)/);
    };
    function diffSentences(oldStr, newStr, callback) {
        return sentenceDiff.diff(oldStr, newStr, callback);
    }
    var cssDiff = new Diff();
    cssDiff.tokenize = function(value) {
        return value.split(/([{}:;,]|\s+)/);
    };
    function diffCss(oldStr, newStr, callback) {
        return cssDiff.diff(oldStr, newStr, callback);
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var objectPrototypeToString = Object.prototype.toString;
    var jsonDiff = new Diff(); // Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
    // dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
    jsonDiff.useLongestToken = true;
    jsonDiff.tokenize = lineDiff.tokenize;
    jsonDiff.castInput = function(value) {
        var _this$options = this.options, undefinedReplacement = _this$options.undefinedReplacement, _this$options$stringi = _this$options.stringifyReplacer, stringifyReplacer = _this$options$stringi === void 0 ? function(k, v) {
            return typeof v === 'undefined' ? undefinedReplacement : v;
        } : _this$options$stringi;
        return typeof value === 'string' ? value : JSON.stringify(canonicalize(value, null, null, stringifyReplacer), stringifyReplacer, '  ');
    };
    jsonDiff.equals = function(left, right) {
        return Diff.prototype.equals.call(jsonDiff, left.replace(/,([\r\n])/g, '$1'), right.replace(/,([\r\n])/g, '$1'));
    };
    function diffJson(oldObj, newObj, options) {
        return jsonDiff.diff(oldObj, newObj, options);
    } // This function handles the presence of circular references by bailing out when encountering an
    // object that is already on the "stack" of items being processed. Accepts an optional replacer
    function canonicalize(obj, stack, replacementStack, replacer, key) {
        stack = stack || [];
        replacementStack = replacementStack || [];
        if (replacer) obj = replacer(key, obj);
        var i;
        for(i = 0; i < stack.length; i += 1){
            if (stack[i] === obj) return replacementStack[i];
        }
        var canonicalizedObj;
        if ('[object Array]' === objectPrototypeToString.call(obj)) {
            stack.push(obj);
            canonicalizedObj = new Array(obj.length);
            replacementStack.push(canonicalizedObj);
            for(i = 0; i < obj.length; i += 1)canonicalizedObj[i] = canonicalize(obj[i], stack, replacementStack, replacer, key);
            stack.pop();
            replacementStack.pop();
            return canonicalizedObj;
        }
        if (obj && obj.toJSON) obj = obj.toJSON();
        if (_typeof(obj) === 'object' && obj !== null) {
            stack.push(obj);
            canonicalizedObj = {};
            replacementStack.push(canonicalizedObj);
            var sortedKeys = [], _key;
            for(_key in obj)/* istanbul ignore else */ if (obj.hasOwnProperty(_key)) sortedKeys.push(_key);
            sortedKeys.sort();
            for(i = 0; i < sortedKeys.length; i += 1){
                _key = sortedKeys[i];
                canonicalizedObj[_key] = canonicalize(obj[_key], stack, replacementStack, replacer, _key);
            }
            stack.pop();
            replacementStack.pop();
        } else canonicalizedObj = obj;
        return canonicalizedObj;
    }
    var arrayDiff = new Diff();
    arrayDiff.tokenize = function(value) {
        return value.slice();
    };
    arrayDiff.join = arrayDiff.removeEmpty = function(value) {
        return value;
    };
    function diffArrays(oldArr, newArr, callback) {
        return arrayDiff.diff(oldArr, newArr, callback);
    }
    function parsePatch(uniDiff) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var diffstr = uniDiff.split(/\r\n|[\n\v\f\r\x85]/), delimiters = uniDiff.match(/\r\n|[\n\v\f\r\x85]/g) || [], list = [], i = 0;
        function parseIndex() {
            var index = {};
            list.push(index); // Parse diff metadata
            while(i < diffstr.length){
                var line = diffstr[i]; // File header found, end parsing diff metadata
                if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) break;
                 // Diff index
                var header = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(line);
                if (header) index.index = header[1];
                i++;
            } // Parse file headers if they are defined. Unified diff requires them, but
            // there's no technical issues to have an isolated hunk without file header
            parseFileHeader(index);
            parseFileHeader(index); // Parse hunks
            index.hunks = [];
            while(i < diffstr.length){
                var _line = diffstr[i];
                if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(_line)) break;
                else if (/^@@/.test(_line)) index.hunks.push(parseHunk());
                else if (_line && options.strict) // Ignore unexpected content unless in strict mode
                throw new Error('Unknown line ' + (i + 1) + ' ' + JSON.stringify(_line));
                else i++;
            }
        } // Parses the --- and +++ headers, if none are found, no lines
        // are consumed.
        function parseFileHeader(index) {
            var fileHeader = /^(---|\+\+\+)\s+(.*)$/.exec(diffstr[i]);
            if (fileHeader) {
                var keyPrefix = fileHeader[1] === '---' ? 'old' : 'new';
                var data = fileHeader[2].split('\t', 2);
                var fileName = data[0].replace(/\\\\/g, '\\');
                if (/^".*"$/.test(fileName)) fileName = fileName.substr(1, fileName.length - 2);
                index[keyPrefix + 'FileName'] = fileName;
                index[keyPrefix + 'Header'] = (data[1] || '').trim();
                i++;
            }
        } // Parses a hunk
        // This assumes that we are at the start of a hunk.
        function parseHunk() {
            var chunkHeaderIndex = i, chunkHeaderLine = diffstr[i++], chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);
            var hunk = {
                oldStart: +chunkHeader[1],
                oldLines: typeof chunkHeader[2] === 'undefined' ? 1 : +chunkHeader[2],
                newStart: +chunkHeader[3],
                newLines: typeof chunkHeader[4] === 'undefined' ? 1 : +chunkHeader[4],
                lines: [],
                linedelimiters: []
            }; // Unified Diff Format quirk: If the chunk size is 0,
            // the first number is one lower than one would expect.
            // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
            if (hunk.oldLines === 0) hunk.oldStart += 1;
            if (hunk.newLines === 0) hunk.newStart += 1;
            var addCount = 0, removeCount = 0;
            for(; i < diffstr.length; i++){
                // Lines starting with '---' could be mistaken for the "remove line" operation
                // But they could be the header for the next file. Therefore prune such cases out.
                if (diffstr[i].indexOf('--- ') === 0 && i + 2 < diffstr.length && diffstr[i + 1].indexOf('+++ ') === 0 && diffstr[i + 2].indexOf('@@') === 0) break;
                var operation = diffstr[i].length == 0 && i != diffstr.length - 1 ? ' ' : diffstr[i][0];
                if (operation === '+' || operation === '-' || operation === ' ' || operation === '\\') {
                    hunk.lines.push(diffstr[i]);
                    hunk.linedelimiters.push(delimiters[i] || '\n');
                    if (operation === '+') addCount++;
                    else if (operation === '-') removeCount++;
                    else if (operation === ' ') {
                        addCount++;
                        removeCount++;
                    }
                } else break;
            } // Handle the empty block count case
            if (!addCount && hunk.newLines === 1) hunk.newLines = 0;
            if (!removeCount && hunk.oldLines === 1) hunk.oldLines = 0;
             // Perform optional sanity checking
            if (options.strict) {
                if (addCount !== hunk.newLines) throw new Error('Added line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
                if (removeCount !== hunk.oldLines) throw new Error('Removed line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
            }
            return hunk;
        }
        while(i < diffstr.length)parseIndex();
        return list;
    }
    // Iterator that traverses in the range of [min, max], stepping
    // by distance from a given start position. I.e. for [0, 4], with
    // start of 2, this will iterate 2, 3, 1, 4, 0.
    function distanceIterator(start, minLine, maxLine) {
        var wantForward = true, backwardExhausted = false, forwardExhausted = false, localOffset = 1;
        return function iterator() {
            if (wantForward && !forwardExhausted) {
                if (backwardExhausted) localOffset++;
                else wantForward = false;
                 // Check if trying to fit beyond text length, and if not, check it fits
                // after offset location (or desired location on first iteration)
                if (start + localOffset <= maxLine) return localOffset;
                forwardExhausted = true;
            }
            if (!backwardExhausted) {
                if (!forwardExhausted) wantForward = true;
                 // Check if trying to fit before text beginning, and if not, check it fits
                // before offset location
                if (minLine <= start - localOffset) return -localOffset++;
                backwardExhausted = true;
                return iterator();
            } // We tried to fit hunk before text beginning and beyond text length, then
        // hunk can't fit on the text. Return undefined
        };
    }
    function applyPatch(source, uniDiff) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (typeof uniDiff === 'string') uniDiff = parsePatch(uniDiff);
        if (Array.isArray(uniDiff)) {
            if (uniDiff.length > 1) throw new Error('applyPatch only works with a single input.');
            uniDiff = uniDiff[0];
        } // Apply the diff to the input
        var lines = source.split(/\r\n|[\n\v\f\r\x85]/), delimiters = source.match(/\r\n|[\n\v\f\r\x85]/g) || [], hunks = uniDiff.hunks, compareLine = options.compareLine || function(lineNumber, line, operation, patchContent) {
            return line === patchContent;
        }, errorCount = 0, fuzzFactor = options.fuzzFactor || 0, minLine = 0, offset = 0, removeEOFNL, addEOFNL;
        /**
     * Checks if the hunk exactly fits on the provided location
     */ function hunkFits(hunk, toPos) {
            for(var j = 0; j < hunk.lines.length; j++){
                var line = hunk.lines[j], operation = line.length > 0 ? line[0] : ' ', content = line.length > 0 ? line.substr(1) : line;
                if (operation === ' ' || operation === '-') {
                    // Context sanity check
                    if (!compareLine(toPos + 1, lines[toPos], operation, content)) {
                        errorCount++;
                        if (errorCount > fuzzFactor) return false;
                    }
                    toPos++;
                }
            }
            return true;
        } // Search best fit offsets for each hunk based on the previous ones
        for(var i = 0; i < hunks.length; i++){
            var hunk = hunks[i], maxLine = lines.length - hunk.oldLines, localOffset = 0, toPos = offset + hunk.oldStart - 1;
            var iterator = distanceIterator(toPos, minLine, maxLine);
            for(; localOffset !== undefined; localOffset = iterator())if (hunkFits(hunk, toPos + localOffset)) {
                hunk.offset = offset += localOffset;
                break;
            }
            if (localOffset === undefined) return false;
             // Set lower text limit to end of the current hunk, so next ones don't try
            // to fit over already patched text
            minLine = hunk.offset + hunk.oldStart + hunk.oldLines;
        } // Apply patch hunks
        var diffOffset = 0;
        for(var _i = 0; _i < hunks.length; _i++){
            var _hunk = hunks[_i], _toPos = _hunk.oldStart + _hunk.offset + diffOffset - 1;
            diffOffset += _hunk.newLines - _hunk.oldLines;
            for(var j = 0; j < _hunk.lines.length; j++){
                var line = _hunk.lines[j], operation = line.length > 0 ? line[0] : ' ', content = line.length > 0 ? line.substr(1) : line, delimiter = _hunk.linedelimiters[j];
                if (operation === ' ') _toPos++;
                else if (operation === '-') {
                    lines.splice(_toPos, 1);
                    delimiters.splice(_toPos, 1);
                /* istanbul ignore else */ } else if (operation === '+') {
                    lines.splice(_toPos, 0, content);
                    delimiters.splice(_toPos, 0, delimiter);
                    _toPos++;
                } else if (operation === '\\') {
                    var previousOperation = _hunk.lines[j - 1] ? _hunk.lines[j - 1][0] : null;
                    if (previousOperation === '+') removeEOFNL = true;
                    else if (previousOperation === '-') addEOFNL = true;
                }
            }
        } // Handle EOFNL insertion/removal
        if (removeEOFNL) while(!lines[lines.length - 1]){
            lines.pop();
            delimiters.pop();
        }
        else if (addEOFNL) {
            lines.push('');
            delimiters.push('\n');
        }
        for(var _k = 0; _k < lines.length - 1; _k++)lines[_k] = lines[_k] + delimiters[_k];
        return lines.join('');
    } // Wrapper that supports multiple file patches via callbacks.
    function applyPatches(uniDiff, options) {
        if (typeof uniDiff === 'string') uniDiff = parsePatch(uniDiff);
        var currentIndex = 0;
        function processIndex() {
            var index = uniDiff[currentIndex++];
            if (!index) return options.complete();
            options.loadFile(index, function(err, data) {
                if (err) return options.complete(err);
                var updatedContent = applyPatch(data, index, options);
                options.patched(index, updatedContent, function(err) {
                    if (err) return options.complete(err);
                    processIndex();
                });
            });
        }
        processIndex();
    }
    function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
        if (!options) options = {};
        if (typeof options.context === 'undefined') options.context = 4;
        var diff = diffLines(oldStr, newStr, options);
        if (!diff) return;
        diff.push({
            value: '',
            lines: []
        }); // Append an empty value to make cleanup easier
        function contextLines(lines) {
            return lines.map(function(entry) {
                return ' ' + entry;
            });
        }
        var hunks = [];
        var oldRangeStart = 0, newRangeStart = 0, curRange = [], oldLine = 1, newLine = 1;
        var _loop = function _loop(i) {
            var current = diff[i], lines = current.lines || current.value.replace(/\n$/, '').split('\n');
            current.lines = lines;
            if (current.added || current.removed) {
                var _curRange;
                // If we have previous context, start with that
                if (!oldRangeStart) {
                    var prev = diff[i - 1];
                    oldRangeStart = oldLine;
                    newRangeStart = newLine;
                    if (prev) {
                        curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
                        oldRangeStart -= curRange.length;
                        newRangeStart -= curRange.length;
                    }
                } // Output our changes
                (_curRange = curRange).push.apply(_curRange, _toConsumableArray(lines.map(function(entry) {
                    return (current.added ? '+' : '-') + entry;
                }))); // Track the updated file position
                if (current.added) newLine += lines.length;
                else oldLine += lines.length;
            } else {
                // Identical context lines. Track line changes
                if (oldRangeStart) {
                    // Close out any changes that have been output (or join overlapping)
                    if (lines.length <= options.context * 2 && i < diff.length - 2) {
                        var _curRange2;
                        // Overlapping
                        (_curRange2 = curRange).push.apply(_curRange2, _toConsumableArray(contextLines(lines)));
                    } else {
                        var _curRange3;
                        // end the range and output
                        var contextSize = Math.min(lines.length, options.context);
                        (_curRange3 = curRange).push.apply(_curRange3, _toConsumableArray(contextLines(lines.slice(0, contextSize))));
                        var hunk = {
                            oldStart: oldRangeStart,
                            oldLines: oldLine - oldRangeStart + contextSize,
                            newStart: newRangeStart,
                            newLines: newLine - newRangeStart + contextSize,
                            lines: curRange
                        };
                        if (i >= diff.length - 2 && lines.length <= options.context) {
                            // EOF is inside this hunk
                            var oldEOFNewline = /\n$/.test(oldStr);
                            var newEOFNewline = /\n$/.test(newStr);
                            var noNlBeforeAdds = lines.length == 0 && curRange.length > hunk.oldLines;
                            if (!oldEOFNewline && noNlBeforeAdds && oldStr.length > 0) // special case: old has no eol and no trailing context; no-nl can end up before adds
                            // however, if the old file is empty, do not output the no-nl line
                            curRange.splice(hunk.oldLines, 0, '\\ No newline at end of file');
                            if (!oldEOFNewline && !noNlBeforeAdds || !newEOFNewline) curRange.push('\\ No newline at end of file');
                        }
                        hunks.push(hunk);
                        oldRangeStart = 0;
                        newRangeStart = 0;
                        curRange = [];
                    }
                }
                oldLine += lines.length;
                newLine += lines.length;
            }
        };
        for(var i = 0; i < diff.length; i++)_loop(i);
        return {
            oldFileName: oldFileName,
            newFileName: newFileName,
            oldHeader: oldHeader,
            newHeader: newHeader,
            hunks: hunks
        };
    }
    function formatPatch(diff) {
        var ret = [];
        if (diff.oldFileName == diff.newFileName) ret.push('Index: ' + diff.oldFileName);
        ret.push('===================================================================');
        ret.push('--- ' + diff.oldFileName + (typeof diff.oldHeader === 'undefined' ? '' : '\t' + diff.oldHeader));
        ret.push('+++ ' + diff.newFileName + (typeof diff.newHeader === 'undefined' ? '' : '\t' + diff.newHeader));
        for(var i = 0; i < diff.hunks.length; i++){
            var hunk = diff.hunks[i]; // Unified Diff Format quirk: If the chunk size is 0,
            // the first number is one lower than one would expect.
            // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
            if (hunk.oldLines === 0) hunk.oldStart -= 1;
            if (hunk.newLines === 0) hunk.newStart -= 1;
            ret.push('@@ -' + hunk.oldStart + ',' + hunk.oldLines + ' +' + hunk.newStart + ',' + hunk.newLines + ' @@');
            ret.push.apply(ret, hunk.lines);
        }
        return ret.join('\n') + '\n';
    }
    function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
        return formatPatch(structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options));
    }
    function createPatch(fileName, oldStr, newStr, oldHeader, newHeader, options) {
        return createTwoFilesPatch(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
    }
    function arrayEqual(a, b) {
        if (a.length !== b.length) return false;
        return arrayStartsWith(a, b);
    }
    function arrayStartsWith(array, start) {
        if (start.length > array.length) return false;
        for(var i = 0; i < start.length; i++){
            if (start[i] !== array[i]) return false;
        }
        return true;
    }
    function calcLineCount(hunk) {
        var _calcOldNewLineCount = calcOldNewLineCount(hunk.lines), oldLines = _calcOldNewLineCount.oldLines, newLines = _calcOldNewLineCount.newLines;
        if (oldLines !== undefined) hunk.oldLines = oldLines;
        else delete hunk.oldLines;
        if (newLines !== undefined) hunk.newLines = newLines;
        else delete hunk.newLines;
    }
    function merge(mine, theirs, base) {
        mine = loadPatch(mine, base);
        theirs = loadPatch(theirs, base);
        var ret = {}; // For index we just let it pass through as it doesn't have any necessary meaning.
        // Leaving sanity checks on this to the API consumer that may know more about the
        // meaning in their own context.
        if (mine.index || theirs.index) ret.index = mine.index || theirs.index;
        if (mine.newFileName || theirs.newFileName) {
            if (!fileNameChanged(mine)) {
                // No header or no change in ours, use theirs (and ours if theirs does not exist)
                ret.oldFileName = theirs.oldFileName || mine.oldFileName;
                ret.newFileName = theirs.newFileName || mine.newFileName;
                ret.oldHeader = theirs.oldHeader || mine.oldHeader;
                ret.newHeader = theirs.newHeader || mine.newHeader;
            } else if (!fileNameChanged(theirs)) {
                // No header or no change in theirs, use ours
                ret.oldFileName = mine.oldFileName;
                ret.newFileName = mine.newFileName;
                ret.oldHeader = mine.oldHeader;
                ret.newHeader = mine.newHeader;
            } else {
                // Both changed... figure it out
                ret.oldFileName = selectField(ret, mine.oldFileName, theirs.oldFileName);
                ret.newFileName = selectField(ret, mine.newFileName, theirs.newFileName);
                ret.oldHeader = selectField(ret, mine.oldHeader, theirs.oldHeader);
                ret.newHeader = selectField(ret, mine.newHeader, theirs.newHeader);
            }
        }
        ret.hunks = [];
        var mineIndex = 0, theirsIndex = 0, mineOffset = 0, theirsOffset = 0;
        while(mineIndex < mine.hunks.length || theirsIndex < theirs.hunks.length){
            var mineCurrent = mine.hunks[mineIndex] || {
                oldStart: Infinity
            }, theirsCurrent = theirs.hunks[theirsIndex] || {
                oldStart: Infinity
            };
            if (hunkBefore(mineCurrent, theirsCurrent)) {
                // This patch does not overlap with any of the others, yay.
                ret.hunks.push(cloneHunk(mineCurrent, mineOffset));
                mineIndex++;
                theirsOffset += mineCurrent.newLines - mineCurrent.oldLines;
            } else if (hunkBefore(theirsCurrent, mineCurrent)) {
                // This patch does not overlap with any of the others, yay.
                ret.hunks.push(cloneHunk(theirsCurrent, theirsOffset));
                theirsIndex++;
                mineOffset += theirsCurrent.newLines - theirsCurrent.oldLines;
            } else {
                // Overlap, merge as best we can
                var mergedHunk = {
                    oldStart: Math.min(mineCurrent.oldStart, theirsCurrent.oldStart),
                    oldLines: 0,
                    newStart: Math.min(mineCurrent.newStart + mineOffset, theirsCurrent.oldStart + theirsOffset),
                    newLines: 0,
                    lines: []
                };
                mergeLines(mergedHunk, mineCurrent.oldStart, mineCurrent.lines, theirsCurrent.oldStart, theirsCurrent.lines);
                theirsIndex++;
                mineIndex++;
                ret.hunks.push(mergedHunk);
            }
        }
        return ret;
    }
    function loadPatch(param, base) {
        if (typeof param === 'string') {
            if (/^@@/m.test(param) || /^Index:/m.test(param)) return parsePatch(param)[0];
            if (!base) throw new Error('Must provide a base reference or pass in a patch');
            return structuredPatch(undefined, undefined, base, param);
        }
        return param;
    }
    function fileNameChanged(patch) {
        return patch.newFileName && patch.newFileName !== patch.oldFileName;
    }
    function selectField(index, mine, theirs) {
        if (mine === theirs) return mine;
        else {
            index.conflict = true;
            return {
                mine: mine,
                theirs: theirs
            };
        }
    }
    function hunkBefore(test, check) {
        return test.oldStart < check.oldStart && test.oldStart + test.oldLines < check.oldStart;
    }
    function cloneHunk(hunk, offset) {
        return {
            oldStart: hunk.oldStart,
            oldLines: hunk.oldLines,
            newStart: hunk.newStart + offset,
            newLines: hunk.newLines,
            lines: hunk.lines
        };
    }
    function mergeLines(hunk, mineOffset, mineLines, theirOffset, theirLines) {
        // This will generally result in a conflicted hunk, but there are cases where the context
        // is the only overlap where we can successfully merge the content here.
        var mine = {
            offset: mineOffset,
            lines: mineLines,
            index: 0
        }, their = {
            offset: theirOffset,
            lines: theirLines,
            index: 0
        }; // Handle any leading content
        insertLeading(hunk, mine, their);
        insertLeading(hunk, their, mine); // Now in the overlap content. Scan through and select the best changes from each.
        while(mine.index < mine.lines.length && their.index < their.lines.length){
            var mineCurrent = mine.lines[mine.index], theirCurrent = their.lines[their.index];
            if ((mineCurrent[0] === '-' || mineCurrent[0] === '+') && (theirCurrent[0] === '-' || theirCurrent[0] === '+')) // Both modified ...
            mutualChange(hunk, mine, their);
            else if (mineCurrent[0] === '+' && theirCurrent[0] === ' ') {
                var _hunk$lines;
                // Mine inserted
                (_hunk$lines = hunk.lines).push.apply(_hunk$lines, _toConsumableArray(collectChange(mine)));
            } else if (theirCurrent[0] === '+' && mineCurrent[0] === ' ') {
                var _hunk$lines2;
                // Theirs inserted
                (_hunk$lines2 = hunk.lines).push.apply(_hunk$lines2, _toConsumableArray(collectChange(their)));
            } else if (mineCurrent[0] === '-' && theirCurrent[0] === ' ') // Mine removed or edited
            removal(hunk, mine, their);
            else if (theirCurrent[0] === '-' && mineCurrent[0] === ' ') // Their removed or edited
            removal(hunk, their, mine, true);
            else if (mineCurrent === theirCurrent) {
                // Context identity
                hunk.lines.push(mineCurrent);
                mine.index++;
                their.index++;
            } else // Context mismatch
            conflict(hunk, collectChange(mine), collectChange(their));
        } // Now push anything that may be remaining
        insertTrailing(hunk, mine);
        insertTrailing(hunk, their);
        calcLineCount(hunk);
    }
    function mutualChange(hunk, mine, their) {
        var myChanges = collectChange(mine), theirChanges = collectChange(their);
        if (allRemoves(myChanges) && allRemoves(theirChanges)) {
            // Special case for remove changes that are supersets of one another
            if (arrayStartsWith(myChanges, theirChanges) && skipRemoveSuperset(their, myChanges, myChanges.length - theirChanges.length)) {
                var _hunk$lines3;
                (_hunk$lines3 = hunk.lines).push.apply(_hunk$lines3, _toConsumableArray(myChanges));
                return;
            } else if (arrayStartsWith(theirChanges, myChanges) && skipRemoveSuperset(mine, theirChanges, theirChanges.length - myChanges.length)) {
                var _hunk$lines4;
                (_hunk$lines4 = hunk.lines).push.apply(_hunk$lines4, _toConsumableArray(theirChanges));
                return;
            }
        } else if (arrayEqual(myChanges, theirChanges)) {
            var _hunk$lines5;
            (_hunk$lines5 = hunk.lines).push.apply(_hunk$lines5, _toConsumableArray(myChanges));
            return;
        }
        conflict(hunk, myChanges, theirChanges);
    }
    function removal(hunk, mine, their, swap) {
        var myChanges = collectChange(mine), theirChanges = collectContext(their, myChanges);
        if (theirChanges.merged) {
            var _hunk$lines6;
            (_hunk$lines6 = hunk.lines).push.apply(_hunk$lines6, _toConsumableArray(theirChanges.merged));
        } else conflict(hunk, swap ? theirChanges : myChanges, swap ? myChanges : theirChanges);
    }
    function conflict(hunk, mine, their) {
        hunk.conflict = true;
        hunk.lines.push({
            conflict: true,
            mine: mine,
            theirs: their
        });
    }
    function insertLeading(hunk, insert, their) {
        while(insert.offset < their.offset && insert.index < insert.lines.length){
            var line = insert.lines[insert.index++];
            hunk.lines.push(line);
            insert.offset++;
        }
    }
    function insertTrailing(hunk, insert) {
        while(insert.index < insert.lines.length){
            var line = insert.lines[insert.index++];
            hunk.lines.push(line);
        }
    }
    function collectChange(state) {
        var ret = [], operation = state.lines[state.index][0];
        while(state.index < state.lines.length){
            var line = state.lines[state.index]; // Group additions that are immediately after subtractions and treat them as one "atomic" modify change.
            if (operation === '-' && line[0] === '+') operation = '+';
            if (operation === line[0]) {
                ret.push(line);
                state.index++;
            } else break;
        }
        return ret;
    }
    function collectContext(state, matchChanges) {
        var changes = [], merged = [], matchIndex = 0, contextChanges = false, conflicted = false;
        while(matchIndex < matchChanges.length && state.index < state.lines.length){
            var change = state.lines[state.index], match = matchChanges[matchIndex]; // Once we've hit our add, then we are done
            if (match[0] === '+') break;
            contextChanges = contextChanges || change[0] !== ' ';
            merged.push(match);
            matchIndex++; // Consume any additions in the other block as a conflict to attempt
            // to pull in the remaining context after this
            if (change[0] === '+') {
                conflicted = true;
                while(change[0] === '+'){
                    changes.push(change);
                    change = state.lines[++state.index];
                }
            }
            if (match.substr(1) === change.substr(1)) {
                changes.push(change);
                state.index++;
            } else conflicted = true;
        }
        if ((matchChanges[matchIndex] || '')[0] === '+' && contextChanges) conflicted = true;
        if (conflicted) return changes;
        while(matchIndex < matchChanges.length)merged.push(matchChanges[matchIndex++]);
        return {
            merged: merged,
            changes: changes
        };
    }
    function allRemoves(changes) {
        return changes.reduce(function(prev, change) {
            return prev && change[0] === '-';
        }, true);
    }
    function skipRemoveSuperset(state, removeChanges, delta) {
        for(var i = 0; i < delta; i++){
            var changeContent = removeChanges[removeChanges.length - delta + i].substr(1);
            if (state.lines[state.index + i] !== ' ' + changeContent) return false;
        }
        state.index += delta;
        return true;
    }
    function calcOldNewLineCount(lines) {
        var oldLines = 0;
        var newLines = 0;
        lines.forEach(function(line) {
            if (typeof line !== 'string') {
                var myCount = calcOldNewLineCount(line.mine);
                var theirCount = calcOldNewLineCount(line.theirs);
                if (oldLines !== undefined) {
                    if (myCount.oldLines === theirCount.oldLines) oldLines += myCount.oldLines;
                    else oldLines = undefined;
                }
                if (newLines !== undefined) {
                    if (myCount.newLines === theirCount.newLines) newLines += myCount.newLines;
                    else newLines = undefined;
                }
            } else {
                if (newLines !== undefined && (line[0] === '+' || line[0] === ' ')) newLines++;
                if (oldLines !== undefined && (line[0] === '-' || line[0] === ' ')) oldLines++;
            }
        });
        return {
            oldLines: oldLines,
            newLines: newLines
        };
    }
    // See: http://code.google.com/p/google-diff-match-patch/wiki/API
    function convertChangesToDMP(changes) {
        var ret = [], change, operation;
        for(var i = 0; i < changes.length; i++){
            change = changes[i];
            if (change.added) operation = 1;
            else if (change.removed) operation = -1;
            else operation = 0;
            ret.push([
                operation,
                change.value
            ]);
        }
        return ret;
    }
    function convertChangesToXML(changes) {
        var ret = [];
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            if (change.added) ret.push('<ins>');
            else if (change.removed) ret.push('<del>');
            ret.push(escapeHTML(change.value));
            if (change.added) ret.push('</ins>');
            else if (change.removed) ret.push('</del>');
        }
        return ret.join('');
    }
    function escapeHTML(s) {
        var n = s;
        n = n.replace(/&/g, '&amp;');
        n = n.replace(/</g, '&lt;');
        n = n.replace(/>/g, '&gt;');
        n = n.replace(/"/g, '&quot;');
        return n;
    }
    exports1.Diff = Diff;
    exports1.applyPatch = applyPatch;
    exports1.applyPatches = applyPatches;
    exports1.canonicalize = canonicalize;
    exports1.convertChangesToDMP = convertChangesToDMP;
    exports1.convertChangesToXML = convertChangesToXML;
    exports1.createPatch = createPatch;
    exports1.createTwoFilesPatch = createTwoFilesPatch;
    exports1.diffArrays = diffArrays;
    exports1.diffChars = diffChars;
    exports1.diffCss = diffCss;
    exports1.diffJson = diffJson;
    exports1.diffLines = diffLines;
    exports1.diffSentences = diffSentences;
    exports1.diffTrimmedLines = diffTrimmedLines;
    exports1.diffWords = diffWords;
    exports1.diffWordsWithSpace = diffWordsWithSpace;
    exports1.merge = merge;
    exports1.parsePatch = parsePatch;
    exports1.structuredPatch = structuredPatch;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});



parcelRegister("ggpzp", function(module, exports) {

$parcel$export(module.exports, "DropdownComponent", () => $5c804fe4a73e1ea1$export$9e0c52f570a16ac0);

var $deWeK = parcelRequire("deWeK");

var $6ppqI = parcelRequire("6ppqI");

var $4TeKW = parcelRequire("4TeKW");

var $jIao5 = parcelRequire("jIao5");

var $6Rz6W = parcelRequire("6Rz6W");
class $5c804fe4a73e1ea1$export$9e0c52f570a16ac0 extends (0, $4TeKW.LitElement) {
    OnInit() {
        (0, $jIao5.fromEvent)(document, 'click').pipe((0, $6Rz6W.filter)(()=>!this.entered)).subscribe(()=>this.isOpened = false);
    }
    onDropdownClicked() {
        this.isOpened = !this.isOpened;
        this.dispatchEvent(new CustomEvent('buttonClicked'));
    }
    constructor(...args){
        super(...args), this.isOpened = false, this.menuItems = [], this.$style = '', this.itemCss = true, this.paddingCss = true, this.defaultTemplate = (0, $4TeKW.html)` <button class="dropbtn">Dropdown</button> `;
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "isOpened", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "staysOpenOnClick", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "menuItems", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "left", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "marginLeft", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "$style", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "itemCss", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "paddingCss", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "border", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "height", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "width", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "minWidth", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0.prototype, "defaultTemplate", void 0);
$5c804fe4a73e1ea1$export$9e0c52f570a16ac0 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'dropdown-component',
        modifiers: [
            ...(0, $6ppqI.TranslateModifiers)
        ],
        style: (0, $4TeKW.css)`
    .dropbtn {
      background-color: #3498db;
      color: white;
      padding: 16px;
      font-size: 16px;
      border: none;
      cursor: pointer;
    }

    .dropbtn:hover,
    .dropbtn:focus {
      background-color: #2980b9;
    }

    .dropdown {
      position: relative;
      display: inline-block;
      transition: all 0.5s ease;
    }

    .dropdown-content {
      display: none;
      position: absolute;
      background-color: var(--global-dropdown-menu-bg, #edf2fa);
      overflow: auto;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      z-index: 10;
    }

    .dropdown-content .item {
      color: black;

      text-decoration: none;
      display: block;
      cursor: pointer;
    }

    .padding {
      padding: 12px 16px;
    }

    .border {
      border-bottom: 1px solid #d4d4d4;
    }

    .dropdown .item:hover {
      background-color: #e5eaf2;
    }

    .show {
      display: block;
    }
    .left {
      margin-left: -320px;
      margin-top: -5px;
    }
    .hover {
      background-color: white;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <div
        class="dropdown"
        style=${this.$style}
        @mouseenter=${()=>this.entered = true}
        @mouseleave=${()=>this.entered = false}
      >
        <div style="cursor: pointer;" @click=${this.onDropdownClicked}>
          <slot></slot>
        </div>
        ${this.isOpened ? (0, $4TeKW.html)`
              <div
                class=${(0, $4TeKW.classMap)({
                'dropdown-content': true,
                show: true
            })}
                style=${(0, $4TeKW.styleMap)({
                position: 'fixed',
                'min-width': this.minWidth ? `${this.minWidth}px` : '250px',
                width: this.width ? `${this.width}px` : 'auto',
                height: this.height ? `${this.height}px` : 'auto',
                ...this.marginLeft ? {
                    'margin-left': this.marginLeft
                } : {
                    'margin-left': this.left ? '-375px' : '-220px'
                },
                'margin-top': this.left ? '-5px' : ''
            })}
              >
                <slot name="first-item"></slot>
                ${this.menuItems.map((i)=>(0, $4TeKW.html)`
                      <div
                        class=${(0, $4TeKW.classMap)({
                    item: this.itemCss,
                    padding: this.paddingCss,
                    border: this.border,
                    hover: i.read
                })}
                        @click=${()=>{
                    this.dispatchEvent(new CustomEvent('itemClicked', {
                        detail: i
                    }));
                    if (!this.staysOpenOnClick) this.isOpened = false;
                }}
                      >
                        ${i.html ? i.html : (0, $6ppqI.translate)(i)}
                      </div>
                    `)}
                <slot name="last-item"></slot>
              </div>
            ` : ''}
      </div>
    `;
        }
    })
], $5c804fe4a73e1ea1$export$9e0c52f570a16ac0);

});

parcelRegister("cwDM8", function(module, exports) {

$parcel$export(module.exports, "CodeMirrorComponent", () => $0a30e2e2d8a38c2a$export$57a359245eed84be);

var $deWeK = parcelRequire("deWeK");
parcelRequire("bQXfE");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $fFrk7 = parcelRequire("fFrk7");

var $8id0M = parcelRequire("8id0M");

var $7LRrZ = parcelRequire("7LRrZ");
var $dXBar = parcelRequire("dXBar");

var $6dHeM = parcelRequire("6dHeM");

var $iEzNh = parcelRequire("iEzNh");

var $9o45I = parcelRequire("9o45I");
class $0a30e2e2d8a38c2a$export$57a359245eed84be extends (0, $4TeKW.LitElement) {
    OnUpdateFirst() {
        this.editorProvider.setInstance((0, (/*@__PURE__*/$parcel$interopDefault($fFrk7)))(this.shadowRoot.querySelector('.container'), {
            lineNumbers: true,
            value: this.value,
            mode: 'javascript',
            autocorrect: true,
            theme: 'material'
        }));
        this.subscription = this.change().pipe((0, $7LRrZ.debounceTime)(300), (0, $dXBar.distinctUntilChanged)()).subscribe((detail)=>this.dispatchEvent(new CustomEvent('changed', {
                detail: detail
            })));
    }
    OnUpdate() {
        const instance = this.editorProvider.getInstance();
        if (instance) instance.setValue(this.value);
    }
    change() {
        return new (0, $8id0M.Observable)((observer)=>{
            const doc = this.editorProvider.getInstance().getDoc();
            doc.on('change', ()=>{
                observer.next(doc.getValue());
            });
            return ()=>observer.complete();
        });
    }
    OnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $0a30e2e2d8a38c2a$export$57a359245eed84be.prototype, "value", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $iEzNh.EditorProvider))
], $0a30e2e2d8a38c2a$export$57a359245eed84be.prototype, "editorProvider", void 0);
$0a30e2e2d8a38c2a$export$57a359245eed84be = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'code-mirror',
        styles: [
            (0, $6dHeM.EditorCss),
            (0, $9o45I.MaterialTheme)
        ],
        template () {
            return (0, $4TeKW.html)` <div class="container"></div>`;
        }
    })
], $0a30e2e2d8a38c2a$export$57a359245eed84be);

});
parcelRegister("bQXfE", function(module, exports) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
(function(mod) {
    mod((parcelRequire("fFrk7")));
})(function(CodeMirror) {
    "use strict";
    CodeMirror.defineMode("javascript", function(config, parserConfig) {
        var indentUnit = config.indentUnit;
        var statementIndent = parserConfig.statementIndent;
        var jsonldMode = parserConfig.jsonld;
        var jsonMode = parserConfig.json || jsonldMode;
        var trackScope = parserConfig.trackScope !== false;
        var isTS = parserConfig.typescript;
        var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
        // Tokenizer
        var keywords = function() {
            function kw(type) {
                return {
                    type: type,
                    style: "keyword"
                };
            }
            var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
            var operator = kw("operator"), atom = {
                type: "atom",
                style: "atom"
            };
            return {
                "if": kw("if"),
                "while": A,
                "with": A,
                "else": B,
                "do": B,
                "try": B,
                "finally": B,
                "return": D,
                "break": D,
                "continue": D,
                "new": kw("new"),
                "delete": C,
                "void": C,
                "throw": C,
                "debugger": kw("debugger"),
                "var": kw("var"),
                "const": kw("var"),
                "let": kw("var"),
                "function": kw("function"),
                "catch": kw("catch"),
                "for": kw("for"),
                "switch": kw("switch"),
                "case": kw("case"),
                "default": kw("default"),
                "in": operator,
                "typeof": operator,
                "instanceof": operator,
                "true": atom,
                "false": atom,
                "null": atom,
                "undefined": atom,
                "NaN": atom,
                "Infinity": atom,
                "this": kw("this"),
                "class": kw("class"),
                "super": kw("atom"),
                "yield": C,
                "export": kw("export"),
                "import": kw("import"),
                "extends": C,
                "await": C
            };
        }();
        var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
        var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
        function readRegexp(stream) {
            var escaped = false, next, inSet = false;
            while((next = stream.next()) != null){
                if (!escaped) {
                    if (next == "/" && !inSet) return;
                    if (next == "[") inSet = true;
                    else if (inSet && next == "]") inSet = false;
                }
                escaped = !escaped && next == "\\";
            }
        }
        // Used as scratch variables to communicate multiple values without
        // consing up tons of objects.
        var type, content;
        function ret(tp, style, cont) {
            type = tp;
            content = cont;
            return style;
        }
        function tokenBase(stream, state) {
            var ch = stream.next();
            if (ch == '"' || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) return ret("number", "number");
            else if (ch == "." && stream.match("..")) return ret("spread", "meta");
            else if (/[\[\]{}\(\),;\:\.]/.test(ch)) return ret(ch);
            else if (ch == "=" && stream.eat(">")) return ret("=>", "operator");
            else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) return ret("number", "number");
            else if (/\d/.test(ch)) {
                stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
                return ret("number", "number");
            } else if (ch == "/") {
                if (stream.eat("*")) {
                    state.tokenize = tokenComment;
                    return tokenComment(stream, state);
                } else if (stream.eat("/")) {
                    stream.skipToEnd();
                    return ret("comment", "comment");
                } else if (expressionAllowed(stream, state, 1)) {
                    readRegexp(stream);
                    stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
                    return ret("regexp", "string-2");
                } else {
                    stream.eat("=");
                    return ret("operator", "operator", stream.current());
                }
            } else if (ch == "`") {
                state.tokenize = tokenQuasi;
                return tokenQuasi(stream, state);
            } else if (ch == "#" && stream.peek() == "!") {
                stream.skipToEnd();
                return ret("meta", "meta");
            } else if (ch == "#" && stream.eatWhile(wordRE)) return ret("variable", "property");
            else if (ch == "<" && stream.match("!--") || ch == "-" && stream.match("->") && !/\S/.test(stream.string.slice(0, stream.start))) {
                stream.skipToEnd();
                return ret("comment", "comment");
            } else if (isOperatorChar.test(ch)) {
                if (ch != ">" || !state.lexical || state.lexical.type != ">") {
                    if (stream.eat("=")) {
                        if (ch == "!" || ch == "=") stream.eat("=");
                    } else if (/[<>*+\-|&?]/.test(ch)) {
                        stream.eat(ch);
                        if (ch == ">") stream.eat(ch);
                    }
                }
                if (ch == "?" && stream.eat(".")) return ret(".");
                return ret("operator", "operator", stream.current());
            } else if (wordRE.test(ch)) {
                stream.eatWhile(wordRE);
                var word = stream.current();
                if (state.lastType != ".") {
                    if (keywords.propertyIsEnumerable(word)) {
                        var kw = keywords[word];
                        return ret(kw.type, kw.style, word);
                    }
                    if (word == "async" && stream.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, false)) return ret("async", "keyword", word);
                }
                return ret("variable", "variable", word);
            }
        }
        function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, next;
                if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)) {
                    state.tokenize = tokenBase;
                    return ret("jsonld-keyword", "meta");
                }
                while((next = stream.next()) != null){
                    if (next == quote && !escaped) break;
                    escaped = !escaped && next == "\\";
                }
                if (!escaped) state.tokenize = tokenBase;
                return ret("string", "string");
            };
        }
        function tokenComment(stream, state) {
            var maybeEnd = false, ch;
            while(ch = stream.next()){
                if (ch == "/" && maybeEnd) {
                    state.tokenize = tokenBase;
                    break;
                }
                maybeEnd = ch == "*";
            }
            return ret("comment", "comment");
        }
        function tokenQuasi(stream, state) {
            var escaped = false, next;
            while((next = stream.next()) != null){
                if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
                    state.tokenize = tokenBase;
                    break;
                }
                escaped = !escaped && next == "\\";
            }
            return ret("quasi", "string-2", stream.current());
        }
        var brackets = "([{}])";
        // This is a crude lookahead trick to try and notice that we're
        // parsing the argument patterns for a fat-arrow function before we
        // actually hit the arrow token. It only works if the arrow is on
        // the same line as the arguments and there's no strange noise
        // (comments) in between. Fallback is to only notice when we hit the
        // arrow, and not declare the arguments as locals for the arrow
        // body.
        function findFatArrow(stream, state) {
            if (state.fatArrowAt) state.fatArrowAt = null;
            var arrow = stream.string.indexOf("=>", stream.start);
            if (arrow < 0) return;
            if (isTS) {
                var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow));
                if (m) arrow = m.index;
            }
            var depth = 0, sawSomething = false;
            for(var pos = arrow - 1; pos >= 0; --pos){
                var ch = stream.string.charAt(pos);
                var bracket = brackets.indexOf(ch);
                if (bracket >= 0 && bracket < 3) {
                    if (!depth) {
                        ++pos;
                        break;
                    }
                    if (--depth == 0) {
                        if (ch == "(") sawSomething = true;
                        break;
                    }
                } else if (bracket >= 3 && bracket < 6) ++depth;
                else if (wordRE.test(ch)) sawSomething = true;
                else if (/["'\/`]/.test(ch)) for(;; --pos){
                    if (pos == 0) return;
                    var next = stream.string.charAt(pos - 1);
                    if (next == ch && stream.string.charAt(pos - 2) != "\\") {
                        pos--;
                        break;
                    }
                }
                else if (sawSomething && !depth) {
                    ++pos;
                    break;
                }
            }
            if (sawSomething && !depth) state.fatArrowAt = pos;
        }
        // Parser
        var atomicTypes = {
            "atom": true,
            "number": true,
            "variable": true,
            "string": true,
            "regexp": true,
            "this": true,
            "import": true,
            "jsonld-keyword": true
        };
        function JSLexical(indented, column, type, align, prev, info) {
            this.indented = indented;
            this.column = column;
            this.type = type;
            this.prev = prev;
            this.info = info;
            if (align != null) this.align = align;
        }
        function inScope(state, varname) {
            if (!trackScope) return false;
            for(var v = state.localVars; v; v = v.next)if (v.name == varname) return true;
            for(var cx = state.context; cx; cx = cx.prev){
                for(var v = cx.vars; v; v = v.next)if (v.name == varname) return true;
            }
        }
        function parseJS(state, style, type, content, stream) {
            var cc = state.cc;
            // Communicate our context to the combinators.
            // (Less wasteful than consing up a hundred closures on every call.)
            cx.state = state;
            cx.stream = stream;
            cx.marked = null, cx.cc = cc;
            cx.style = style;
            if (!state.lexical.hasOwnProperty("align")) state.lexical.align = true;
            while(true){
                var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
                if (combinator(type, content)) {
                    while(cc.length && cc[cc.length - 1].lex)cc.pop()();
                    if (cx.marked) return cx.marked;
                    if (type == "variable" && inScope(state, content)) return "variable-2";
                    return style;
                }
            }
        }
        // Combinator utils
        var cx = {
            state: null,
            column: null,
            marked: null,
            cc: null
        };
        function pass() {
            for(var i = arguments.length - 1; i >= 0; i--)cx.cc.push(arguments[i]);
        }
        function cont() {
            pass.apply(null, arguments);
            return true;
        }
        function inList(name, list) {
            for(var v = list; v; v = v.next)if (v.name == name) return true;
            return false;
        }
        function register(varname) {
            var state = cx.state;
            cx.marked = "def";
            if (!trackScope) return;
            if (state.context) {
                if (state.lexical.info == "var" && state.context && state.context.block) {
                    // FIXME function decls are also not block scoped
                    var newContext = registerVarScoped(varname, state.context);
                    if (newContext != null) {
                        state.context = newContext;
                        return;
                    }
                } else if (!inList(varname, state.localVars)) {
                    state.localVars = new Var(varname, state.localVars);
                    return;
                }
            }
            // Fall through means this is global
            if (parserConfig.globalVars && !inList(varname, state.globalVars)) state.globalVars = new Var(varname, state.globalVars);
        }
        function registerVarScoped(varname, context) {
            if (!context) return null;
            else if (context.block) {
                var inner = registerVarScoped(varname, context.prev);
                if (!inner) return null;
                if (inner == context.prev) return context;
                return new Context(inner, context.vars, true);
            } else if (inList(varname, context.vars)) return context;
            else return new Context(context.prev, new Var(varname, context.vars), false);
        }
        function isModifier(name) {
            return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly";
        }
        // Combinators
        function Context(prev, vars, block) {
            this.prev = prev;
            this.vars = vars;
            this.block = block;
        }
        function Var(name, next) {
            this.name = name;
            this.next = next;
        }
        var defaultVars = new Var("this", new Var("arguments", null));
        function pushcontext() {
            cx.state.context = new Context(cx.state.context, cx.state.localVars, false);
            cx.state.localVars = defaultVars;
        }
        function pushblockcontext() {
            cx.state.context = new Context(cx.state.context, cx.state.localVars, true);
            cx.state.localVars = null;
        }
        pushcontext.lex = pushblockcontext.lex = true;
        function popcontext() {
            cx.state.localVars = cx.state.context.vars;
            cx.state.context = cx.state.context.prev;
        }
        popcontext.lex = true;
        function pushlex(type, info) {
            var result = function() {
                var state = cx.state, indent = state.indented;
                if (state.lexical.type == "stat") indent = state.lexical.indented;
                else for(var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)indent = outer.indented;
                state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
            };
            result.lex = true;
            return result;
        }
        function poplex() {
            var state = cx.state;
            if (state.lexical.prev) {
                if (state.lexical.type == ")") state.indented = state.lexical.indented;
                state.lexical = state.lexical.prev;
            }
        }
        poplex.lex = true;
        function expect(wanted) {
            function exp(type) {
                if (type == wanted) return cont();
                else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();
                else return cont(exp);
            }
            return exp;
        }
        function statement(type, value) {
            if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
            if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
            if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
            if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
            if (type == "debugger") return cont(expect(";"));
            if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
            if (type == ";") return cont();
            if (type == "if") {
                if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex) cx.state.cc.pop()();
                return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
            }
            if (type == "function") return cont(functiondef);
            if (type == "for") return cont(pushlex("form"), pushblockcontext, forspec, statement, popcontext, poplex);
            if (type == "class" || isTS && value == "interface") {
                cx.marked = "keyword";
                return cont(pushlex("form", type == "class" ? type : value), className, poplex);
            }
            if (type == "variable") {
                if (isTS && value == "declare") {
                    cx.marked = "keyword";
                    return cont(statement);
                } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
                    cx.marked = "keyword";
                    if (value == "enum") return cont(enumdef);
                    else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));
                    else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex);
                } else if (isTS && value == "namespace") {
                    cx.marked = "keyword";
                    return cont(pushlex("form"), expression, statement, poplex);
                } else if (isTS && value == "abstract") {
                    cx.marked = "keyword";
                    return cont(statement);
                } else return cont(pushlex("stat"), maybelabel);
            }
            if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext, block, poplex, poplex, popcontext);
            if (type == "case") return cont(expression, expect(":"));
            if (type == "default") return cont(expect(":"));
            if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
            if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
            if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
            if (type == "async") return cont(statement);
            if (value == "@") return cont(expression, statement);
            return pass(pushlex("stat"), expression, expect(";"), poplex);
        }
        function maybeCatchBinding(type) {
            if (type == "(") return cont(funarg, expect(")"));
        }
        function expression(type, value) {
            return expressionInner(type, value, false);
        }
        function expressionNoComma(type, value) {
            return expressionInner(type, value, true);
        }
        function parenExpr(type) {
            if (type != "(") return pass();
            return cont(pushlex(")"), maybeexpression, expect(")"), poplex);
        }
        function expressionInner(type, value, noComma) {
            if (cx.state.fatArrowAt == cx.stream.start) {
                var body = noComma ? arrowBodyNoComma : arrowBody;
                if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
                else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
            }
            var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
            if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
            if (type == "function") return cont(functiondef, maybeop);
            if (type == "class" || isTS && value == "interface") {
                cx.marked = "keyword";
                return cont(pushlex("form"), classExpression, poplex);
            }
            if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
            if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
            if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
            if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
            if (type == "{") return contCommasep(objprop, "}", null, maybeop);
            if (type == "quasi") return pass(quasi, maybeop);
            if (type == "new") return cont(maybeTarget(noComma));
            return cont();
        }
        function maybeexpression(type) {
            if (type.match(/[;\}\)\],]/)) return pass();
            return pass(expression);
        }
        function maybeoperatorComma(type, value) {
            if (type == ",") return cont(maybeexpression);
            return maybeoperatorNoComma(type, value, false);
        }
        function maybeoperatorNoComma(type, value, noComma) {
            var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
            var expr = noComma == false ? expression : expressionNoComma;
            if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
            if (type == "operator") {
                if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
                if (isTS && value == "<" && cx.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, false)) return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
                if (value == "?") return cont(expression, expect(":"), expr);
                return cont(expr);
            }
            if (type == "quasi") return pass(quasi, me);
            if (type == ";") return;
            if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
            if (type == ".") return cont(property, me);
            if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
            if (isTS && value == "as") {
                cx.marked = "keyword";
                return cont(typeexpr, me);
            }
            if (type == "regexp") {
                cx.state.lastType = cx.marked = "operator";
                cx.stream.backUp(cx.stream.pos - cx.stream.start - 1);
                return cont(expr);
            }
        }
        function quasi(type, value) {
            if (type != "quasi") return pass();
            if (value.slice(value.length - 2) != "${") return cont(quasi);
            return cont(maybeexpression, continueQuasi);
        }
        function continueQuasi(type) {
            if (type == "}") {
                cx.marked = "string-2";
                cx.state.tokenize = tokenQuasi;
                return cont(quasi);
            }
        }
        function arrowBody(type) {
            findFatArrow(cx.stream, cx.state);
            return pass(type == "{" ? statement : expression);
        }
        function arrowBodyNoComma(type) {
            findFatArrow(cx.stream, cx.state);
            return pass(type == "{" ? statement : expressionNoComma);
        }
        function maybeTarget(noComma) {
            return function(type) {
                if (type == ".") return cont(noComma ? targetNoComma : target);
                else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma);
                else return pass(noComma ? expressionNoComma : expression);
            };
        }
        function target(_, value) {
            if (value == "target") {
                cx.marked = "keyword";
                return cont(maybeoperatorComma);
            }
        }
        function targetNoComma(_, value) {
            if (value == "target") {
                cx.marked = "keyword";
                return cont(maybeoperatorNoComma);
            }
        }
        function maybelabel(type) {
            if (type == ":") return cont(poplex, statement);
            return pass(maybeoperatorComma, expect(";"), poplex);
        }
        function property(type) {
            if (type == "variable") {
                cx.marked = "property";
                return cont();
            }
        }
        function objprop(type, value) {
            if (type == "async") {
                cx.marked = "property";
                return cont(objprop);
            } else if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                if (value == "get" || value == "set") return cont(getterSetter);
                var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
                ;
                if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false))) cx.state.fatArrowAt = cx.stream.pos + m[0].length;
                return cont(afterprop);
            } else if (type == "number" || type == "string") {
                cx.marked = jsonldMode ? "property" : cx.style + " property";
                return cont(afterprop);
            } else if (type == "jsonld-keyword") return cont(afterprop);
            else if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(objprop);
            } else if (type == "[") return cont(expression, maybetype, expect("]"), afterprop);
            else if (type == "spread") return cont(expressionNoComma, afterprop);
            else if (value == "*") {
                cx.marked = "keyword";
                return cont(objprop);
            } else if (type == ":") return pass(afterprop);
        }
        function getterSetter(type) {
            if (type != "variable") return pass(afterprop);
            cx.marked = "property";
            return cont(functiondef);
        }
        function afterprop(type) {
            if (type == ":") return cont(expressionNoComma);
            if (type == "(") return pass(functiondef);
        }
        function commasep(what, end, sep) {
            function proceed(type, value) {
                if (sep ? sep.indexOf(type) > -1 : type == ",") {
                    var lex = cx.state.lexical;
                    if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
                    return cont(function(type, value) {
                        if (type == end || value == end) return pass();
                        return pass(what);
                    }, proceed);
                }
                if (type == end || value == end) return cont();
                if (sep && sep.indexOf(";") > -1) return pass(what);
                return cont(expect(end));
            }
            return function(type, value) {
                if (type == end || value == end) return cont();
                return pass(what, proceed);
            };
        }
        function contCommasep(what, end, info) {
            for(var i = 3; i < arguments.length; i++)cx.cc.push(arguments[i]);
            return cont(pushlex(end, info), commasep(what, end), poplex);
        }
        function block(type) {
            if (type == "}") return cont();
            return pass(statement, block);
        }
        function maybetype(type, value) {
            if (isTS) {
                if (type == ":") return cont(typeexpr);
                if (value == "?") return cont(maybetype);
            }
        }
        function maybetypeOrIn(type, value) {
            if (isTS && (type == ":" || value == "in")) return cont(typeexpr);
        }
        function mayberettype(type) {
            if (isTS && type == ":") {
                if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr);
                else return cont(typeexpr);
            }
        }
        function isKW(_, value) {
            if (value == "is") {
                cx.marked = "keyword";
                return cont();
            }
        }
        function typeexpr(type, value) {
            if (value == "keyof" || value == "typeof" || value == "infer" || value == "readonly") {
                cx.marked = "keyword";
                return cont(value == "typeof" ? expressionNoComma : typeexpr);
            }
            if (type == "variable" || value == "void") {
                cx.marked = "type";
                return cont(afterType);
            }
            if (value == "|" || value == "&") return cont(typeexpr);
            if (type == "string" || type == "number" || type == "atom") return cont(afterType);
            if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType);
            if (type == "{") return cont(pushlex("}"), typeprops, poplex, afterType);
            if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType);
            if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr);
            if (type == "quasi") return pass(quasiType, afterType);
        }
        function maybeReturnType(type) {
            if (type == "=>") return cont(typeexpr);
        }
        function typeprops(type) {
            if (type.match(/[\}\)\]]/)) return cont();
            if (type == "," || type == ";") return cont(typeprops);
            return pass(typeprop, typeprops);
        }
        function typeprop(type, value) {
            if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                return cont(typeprop);
            } else if (value == "?" || type == "number" || type == "string") return cont(typeprop);
            else if (type == ":") return cont(typeexpr);
            else if (type == "[") return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop);
            else if (type == "(") return pass(functiondecl, typeprop);
            else if (!type.match(/[;\}\)\],]/)) return cont();
        }
        function quasiType(type, value) {
            if (type != "quasi") return pass();
            if (value.slice(value.length - 2) != "${") return cont(quasiType);
            return cont(typeexpr, continueQuasiType);
        }
        function continueQuasiType(type) {
            if (type == "}") {
                cx.marked = "string-2";
                cx.state.tokenize = tokenQuasi;
                return cont(quasiType);
            }
        }
        function typearg(type, value) {
            if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg);
            if (type == ":") return cont(typeexpr);
            if (type == "spread") return cont(typearg);
            return pass(typeexpr);
        }
        function afterType(type, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
            if (value == "|" || type == "." || value == "&") return cont(typeexpr);
            if (type == "[") return cont(typeexpr, expect("]"), afterType);
            if (value == "extends" || value == "implements") {
                cx.marked = "keyword";
                return cont(typeexpr);
            }
            if (value == "?") return cont(typeexpr, expect(":"), typeexpr);
        }
        function maybeTypeArgs(_, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
        }
        function typeparam() {
            return pass(typeexpr, maybeTypeDefault);
        }
        function maybeTypeDefault(_, value) {
            if (value == "=") return cont(typeexpr);
        }
        function vardef(_, value) {
            if (value == "enum") {
                cx.marked = "keyword";
                return cont(enumdef);
            }
            return pass(pattern, maybetype, maybeAssign, vardefCont);
        }
        function pattern(type, value) {
            if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(pattern);
            }
            if (type == "variable") {
                register(value);
                return cont();
            }
            if (type == "spread") return cont(pattern);
            if (type == "[") return contCommasep(eltpattern, "]");
            if (type == "{") return contCommasep(proppattern, "}");
        }
        function proppattern(type, value) {
            if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
                register(value);
                return cont(maybeAssign);
            }
            if (type == "variable") cx.marked = "property";
            if (type == "spread") return cont(pattern);
            if (type == "}") return pass();
            if (type == "[") return cont(expression, expect(']'), expect(':'), proppattern);
            return cont(expect(":"), pattern, maybeAssign);
        }
        function eltpattern() {
            return pass(pattern, maybeAssign);
        }
        function maybeAssign(_type, value) {
            if (value == "=") return cont(expressionNoComma);
        }
        function vardefCont(type) {
            if (type == ",") return cont(vardef);
        }
        function maybeelse(type, value) {
            if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
        }
        function forspec(type, value) {
            if (value == "await") return cont(forspec);
            if (type == "(") return cont(pushlex(")"), forspec1, poplex);
        }
        function forspec1(type) {
            if (type == "var") return cont(vardef, forspec2);
            if (type == "variable") return cont(forspec2);
            return pass(forspec2);
        }
        function forspec2(type, value) {
            if (type == ")") return cont();
            if (type == ";") return cont(forspec2);
            if (value == "in" || value == "of") {
                cx.marked = "keyword";
                return cont(expression, forspec2);
            }
            return pass(expression, forspec2);
        }
        function functiondef(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(functiondef);
            }
            if (type == "variable") {
                register(value);
                return cont(functiondef);
            }
            if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
            if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef);
        }
        function functiondecl(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(functiondecl);
            }
            if (type == "variable") {
                register(value);
                return cont(functiondecl);
            }
            if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
            if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl);
        }
        function typename(type, value) {
            if (type == "keyword" || type == "variable") {
                cx.marked = "type";
                return cont(typename);
            } else if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex);
        }
        function funarg(type, value) {
            if (value == "@") cont(expression, funarg);
            if (type == "spread") return cont(funarg);
            if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(funarg);
            }
            if (isTS && type == "this") return cont(maybetype, maybeAssign);
            return pass(pattern, maybetype, maybeAssign);
        }
        function classExpression(type, value) {
            // Class expressions may have an optional name.
            if (type == "variable") return className(type, value);
            return classNameAfter(type, value);
        }
        function className(type, value) {
            if (type == "variable") {
                register(value);
                return cont(classNameAfter);
            }
        }
        function classNameAfter(type, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter);
            if (value == "extends" || value == "implements" || isTS && type == ",") {
                if (value == "implements") cx.marked = "keyword";
                return cont(isTS ? typeexpr : expression, classNameAfter);
            }
            if (type == "{") return cont(pushlex("}"), classBody, poplex);
        }
        function classBody(type, value) {
            if (type == "async" || type == "variable" && (value == "static" || value == "get" || value == "set" || isTS && isModifier(value)) && cx.stream.match(/^\s+#?[\w$\xa1-\uffff]/, false)) {
                cx.marked = "keyword";
                return cont(classBody);
            }
            if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                return cont(classfield, classBody);
            }
            if (type == "number" || type == "string") return cont(classfield, classBody);
            if (type == "[") return cont(expression, maybetype, expect("]"), classfield, classBody);
            if (value == "*") {
                cx.marked = "keyword";
                return cont(classBody);
            }
            if (isTS && type == "(") return pass(functiondecl, classBody);
            if (type == ";" || type == ",") return cont(classBody);
            if (type == "}") return cont();
            if (value == "@") return cont(expression, classBody);
        }
        function classfield(type, value) {
            if (value == "!") return cont(classfield);
            if (value == "?") return cont(classfield);
            if (type == ":") return cont(typeexpr, maybeAssign);
            if (value == "=") return cont(expressionNoComma);
            var context = cx.state.lexical.prev, isInterface = context && context.info == "interface";
            return pass(isInterface ? functiondecl : functiondef);
        }
        function afterExport(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(maybeFrom, expect(";"));
            }
            if (value == "default") {
                cx.marked = "keyword";
                return cont(expression, expect(";"));
            }
            if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
            return pass(statement);
        }
        function exportField(type, value) {
            if (value == "as") {
                cx.marked = "keyword";
                return cont(expect("variable"));
            }
            if (type == "variable") return pass(expressionNoComma, exportField);
        }
        function afterImport(type) {
            if (type == "string") return cont();
            if (type == "(") return pass(expression);
            if (type == ".") return pass(maybeoperatorComma);
            return pass(importSpec, maybeMoreImports, maybeFrom);
        }
        function importSpec(type, value) {
            if (type == "{") return contCommasep(importSpec, "}");
            if (type == "variable") register(value);
            if (value == "*") cx.marked = "keyword";
            return cont(maybeAs);
        }
        function maybeMoreImports(type) {
            if (type == ",") return cont(importSpec, maybeMoreImports);
        }
        function maybeAs(_type, value) {
            if (value == "as") {
                cx.marked = "keyword";
                return cont(importSpec);
            }
        }
        function maybeFrom(_type, value) {
            if (value == "from") {
                cx.marked = "keyword";
                return cont(expression);
            }
        }
        function arrayLiteral(type) {
            if (type == "]") return cont();
            return pass(commasep(expressionNoComma, "]"));
        }
        function enumdef() {
            return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex);
        }
        function enummember() {
            return pass(pattern, maybeAssign);
        }
        function isContinuedStatement(state, textAfter) {
            return state.lastType == "operator" || state.lastType == "," || isOperatorChar.test(textAfter.charAt(0)) || /[,.]/.test(textAfter.charAt(0));
        }
        function expressionAllowed(stream, state, backUp) {
            return state.tokenize == tokenBase && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) || state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0)));
        }
        // Interface
        return {
            startState: function(basecolumn) {
                var state = {
                    tokenize: tokenBase,
                    lastType: "sof",
                    cc: [],
                    lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
                    localVars: parserConfig.localVars,
                    context: parserConfig.localVars && new Context(null, null, false),
                    indented: basecolumn || 0
                };
                if (parserConfig.globalVars && typeof parserConfig.globalVars == "object") state.globalVars = parserConfig.globalVars;
                return state;
            },
            token: function(stream, state) {
                if (stream.sol()) {
                    if (!state.lexical.hasOwnProperty("align")) state.lexical.align = false;
                    state.indented = stream.indentation();
                    findFatArrow(stream, state);
                }
                if (state.tokenize != tokenComment && stream.eatSpace()) return null;
                var style = state.tokenize(stream, state);
                if (type == "comment") return style;
                state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
                return parseJS(state, style, type, content, stream);
            },
            indent: function(state, textAfter) {
                if (state.tokenize == tokenComment || state.tokenize == tokenQuasi) return CodeMirror.Pass;
                if (state.tokenize != tokenBase) return 0;
                var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top;
                // Kludge to prevent 'maybelse' from blocking lexical scope pops
                if (!/^\s*else\b/.test(textAfter)) for(var i = state.cc.length - 1; i >= 0; --i){
                    var c = state.cc[i];
                    if (c == poplex) lexical = lexical.prev;
                    else if (c != maybeelse && c != popcontext) break;
                }
                while((lexical.type == "stat" || lexical.type == "form") && (firstChar == "}" || (top = state.cc[state.cc.length - 1]) && (top == maybeoperatorComma || top == maybeoperatorNoComma) && !/^[,\.=+\-*:?[\(]/.test(textAfter)))lexical = lexical.prev;
                if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat") lexical = lexical.prev;
                var type = lexical.type, closing = firstChar == type;
                if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
                else if (type == "form" && firstChar == "{") return lexical.indented;
                else if (type == "form") return lexical.indented + indentUnit;
                else if (type == "stat") return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
                else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false) return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
                else if (lexical.align) return lexical.column + (closing ? 0 : 1);
                else return lexical.indented + (closing ? 0 : indentUnit);
            },
            electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
            blockCommentStart: jsonMode ? null : "/*",
            blockCommentEnd: jsonMode ? null : "*/",
            blockCommentContinue: jsonMode ? null : " * ",
            lineComment: jsonMode ? null : "//",
            fold: "brace",
            closeBrackets: "()[]{}''\"\"``",
            helperType: jsonMode ? "json" : "javascript",
            jsonldMode: jsonldMode,
            jsonMode: jsonMode,
            expressionAllowed: expressionAllowed,
            skipExpression: function(state) {
                parseJS(state, "atom", "atom", "true", new CodeMirror.StringStream("", 2, null));
            }
        };
    });
    CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
    CodeMirror.defineMIME("text/javascript", "javascript");
    CodeMirror.defineMIME("text/ecmascript", "javascript");
    CodeMirror.defineMIME("application/javascript", "javascript");
    CodeMirror.defineMIME("application/x-javascript", "javascript");
    CodeMirror.defineMIME("application/ecmascript", "javascript");
    CodeMirror.defineMIME("application/json", {
        name: "javascript",
        json: true
    });
    CodeMirror.defineMIME("application/x-json", {
        name: "javascript",
        json: true
    });
    CodeMirror.defineMIME("application/manifest+json", {
        name: "javascript",
        json: true
    });
    CodeMirror.defineMIME("application/ld+json", {
        name: "javascript",
        jsonld: true
    });
    CodeMirror.defineMIME("text/typescript", {
        name: "javascript",
        typescript: true
    });
    CodeMirror.defineMIME("application/typescript", {
        name: "javascript",
        typescript: true
    });
});

});
parcelRegister("fFrk7", function(module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE
// This is CodeMirror (https://codemirror.net/5), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    // Kludges for bugs and behavior differences that can't be feature
    // detected are enabled based on userAgent etc sniffing.
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;
    var gecko = /gecko\/\d/i.test(userAgent);
    var ie_upto10 = /MSIE \d/.test(userAgent);
    var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
    var edge = /Edge\/(\d+)/.exec(userAgent);
    var ie = ie_upto10 || ie_11up || edge;
    var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
    var webkit = !edge && /WebKit\//.test(userAgent);
    var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
    var chrome = !edge && /Chrome\/(\d+)/.exec(userAgent);
    var chrome_version = chrome && +chrome[1];
    var presto = /Opera\//.test(userAgent);
    var safari = /Apple Computer/.test(navigator.vendor);
    var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
    var phantom = /PhantomJS/.test(userAgent);
    var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
    var android = /Android/.test(userAgent);
    // This is woefully incomplete. Suggestions for alternative methods welcome.
    var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
    var mac = ios || /Mac/.test(platform);
    var chromeOS = /\bCrOS\b/.test(userAgent);
    var windows = /win/i.test(platform);
    var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
    if (presto_version) presto_version = Number(presto_version[1]);
    if (presto_version && presto_version >= 15) {
        presto = false;
        webkit = true;
    }
    // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
    var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
    var captureRightClick = gecko || ie && ie_version >= 9;
    function classTest(cls) {
        return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
    }
    var rmClass = function(node, cls) {
        var current = node.className;
        var match = classTest(cls).exec(current);
        if (match) {
            var after = current.slice(match.index + match[0].length);
            node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
        }
    };
    function removeChildren(e) {
        for(var count = e.childNodes.length; count > 0; --count)e.removeChild(e.firstChild);
        return e;
    }
    function removeChildrenAndAdd(parent, e) {
        return removeChildren(parent).appendChild(e);
    }
    function elt(tag, content, className, style) {
        var e = document.createElement(tag);
        if (className) e.className = className;
        if (style) e.style.cssText = style;
        if (typeof content == "string") e.appendChild(document.createTextNode(content));
        else if (content) for(var i = 0; i < content.length; ++i)e.appendChild(content[i]);
        return e;
    }
    // wrapper for elt, which removes the elt from the accessibility tree
    function eltP(tag, content, className, style) {
        var e = elt(tag, content, className, style);
        e.setAttribute("role", "presentation");
        return e;
    }
    var range;
    if (document.createRange) range = function(node, start, end, endNode) {
        var r = document.createRange();
        r.setEnd(endNode || node, end);
        r.setStart(node, start);
        return r;
    };
    else range = function(node, start, end) {
        var r = document.body.createTextRange();
        try {
            r.moveToElementText(node.parentNode);
        } catch (e) {
            return r;
        }
        r.collapse(true);
        r.moveEnd("character", end);
        r.moveStart("character", start);
        return r;
    };
    function contains(parent, child) {
        if (child.nodeType == 3) child = child.parentNode;
        if (parent.contains) return parent.contains(child);
        do {
            if (child.nodeType == 11) child = child.host;
            if (child == parent) return true;
        }while (child = child.parentNode);
    }
    function activeElt(doc) {
        // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
        // IE < 10 will throw when accessed while the page is loading or in an iframe.
        // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
        var activeElement;
        try {
            activeElement = doc.activeElement;
        } catch (e) {
            activeElement = doc.body || null;
        }
        while(activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)activeElement = activeElement.shadowRoot.activeElement;
        return activeElement;
    }
    function addClass(node, cls) {
        var current = node.className;
        if (!classTest(cls).test(current)) node.className += (current ? " " : "") + cls;
    }
    function joinClasses(a, b) {
        var as = a.split(" ");
        for(var i = 0; i < as.length; i++)if (as[i] && !classTest(as[i]).test(b)) b += " " + as[i];
        return b;
    }
    var selectInput = function(node) {
        node.select();
    };
    if (ios) selectInput = function(node) {
        node.selectionStart = 0;
        node.selectionEnd = node.value.length;
    };
    else if (ie) selectInput = function(node) {
        try {
            node.select();
        } catch (_e) {}
    };
    function doc(cm) {
        return cm.display.wrapper.ownerDocument;
    }
    function win(cm) {
        return doc(cm).defaultView;
    }
    function bind(f) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function() {
            return f.apply(null, args);
        };
    }
    function copyObj(obj, target, overwrite) {
        if (!target) target = {};
        for(var prop in obj)if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) target[prop] = obj[prop];
        return target;
    }
    // Counts the column offset in a string, taking tabs into account.
    // Used mostly to find indentation.
    function countColumn(string, end, tabSize, startIndex, startValue) {
        if (end == null) {
            end = string.search(/[^\s\u00a0]/);
            if (end == -1) end = string.length;
        }
        for(var i = startIndex || 0, n = startValue || 0;;){
            var nextTab = string.indexOf("\t", i);
            if (nextTab < 0 || nextTab >= end) return n + (end - i);
            n += nextTab - i;
            n += tabSize - n % tabSize;
            i = nextTab + 1;
        }
    }
    var Delayed = function() {
        this.id = null;
        this.f = null;
        this.time = 0;
        this.handler = bind(this.onTimeout, this);
    };
    Delayed.prototype.onTimeout = function(self) {
        self.id = 0;
        if (self.time <= +new Date) self.f();
        else setTimeout(self.handler, self.time - +new Date);
    };
    Delayed.prototype.set = function(ms, f) {
        this.f = f;
        var time = +new Date + ms;
        if (!this.id || time < this.time) {
            clearTimeout(this.id);
            this.id = setTimeout(this.handler, ms);
            this.time = time;
        }
    };
    function indexOf(array, elt) {
        for(var i = 0; i < array.length; ++i){
            if (array[i] == elt) return i;
        }
        return -1;
    }
    // Number of pixels added to scroller and sizer to hide scrollbar
    var scrollerGap = 50;
    // Returned or thrown by various protocols to signal 'I'm not
    // handling this'.
    var Pass = {
        toString: function() {
            return "CodeMirror.Pass";
        }
    };
    // Reused option objects for setSelection & friends
    var sel_dontScroll = {
        scroll: false
    }, sel_mouse = {
        origin: "*mouse"
    }, sel_move = {
        origin: "+move"
    };
    // The inverse of countColumn -- find the offset that corresponds to
    // a particular column.
    function findColumn(string, goal, tabSize) {
        for(var pos = 0, col = 0;;){
            var nextTab = string.indexOf("\t", pos);
            if (nextTab == -1) nextTab = string.length;
            var skipped = nextTab - pos;
            if (nextTab == string.length || col + skipped >= goal) return pos + Math.min(skipped, goal - col);
            col += nextTab - pos;
            col += tabSize - col % tabSize;
            pos = nextTab + 1;
            if (col >= goal) return pos;
        }
    }
    var spaceStrs = [
        ""
    ];
    function spaceStr(n) {
        while(spaceStrs.length <= n)spaceStrs.push(lst(spaceStrs) + " ");
        return spaceStrs[n];
    }
    function lst(arr) {
        return arr[arr.length - 1];
    }
    function map(array, f) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = f(array[i], i);
        return out;
    }
    function insertSorted(array, value, score) {
        var pos = 0, priority = score(value);
        while(pos < array.length && score(array[pos]) <= priority)pos++;
        array.splice(pos, 0, value);
    }
    function nothing() {}
    function createObj(base, props) {
        var inst;
        if (Object.create) inst = Object.create(base);
        else {
            nothing.prototype = base;
            inst = new nothing();
        }
        if (props) copyObj(props, inst);
        return inst;
    }
    var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
    function isWordCharBasic(ch) {
        return /\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch));
    }
    function isWordChar(ch, helper) {
        if (!helper) return isWordCharBasic(ch);
        if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) return true;
        return helper.test(ch);
    }
    function isEmpty(obj) {
        for(var n in obj){
            if (obj.hasOwnProperty(n) && obj[n]) return false;
        }
        return true;
    }
    // Extending unicode characters. A series of a non-extending char +
    // any number of extending chars is treated as a single unit as far
    // as editing and measuring is concerned. This is not fully correct,
    // since some scripts/fonts/browsers also treat other configurations
    // of code points as a group.
    var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
    function isExtendingChar(ch) {
        return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
    }
    // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
    function skipExtendingChars(str, pos, dir) {
        while((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos)))pos += dir;
        return pos;
    }
    // Returns the value from the range [`from`; `to`] that satisfies
    // `pred` and is closest to `from`. Assumes that at least `to`
    // satisfies `pred`. Supports `from` being greater than `to`.
    function findFirst(pred, from, to) {
        // At any point we are certain `to` satisfies `pred`, don't know
        // whether `from` does.
        var dir = from > to ? -1 : 1;
        for(;;){
            if (from == to) return from;
            var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
            if (mid == from) return pred(mid) ? from : to;
            if (pred(mid)) to = mid;
            else from = mid + dir;
        }
    }
    // BIDI HELPERS
    function iterateBidiSections(order, from, to, f) {
        if (!order) return f(from, to, "ltr", 0);
        var found = false;
        for(var i = 0; i < order.length; ++i){
            var part = order[i];
            if (part.from < to && part.to > from || from == to && part.to == from) {
                f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
                found = true;
            }
        }
        if (!found) f(from, to, "ltr");
    }
    var bidiOther = null;
    function getBidiPartAt(order, ch, sticky) {
        var found;
        bidiOther = null;
        for(var i = 0; i < order.length; ++i){
            var cur = order[i];
            if (cur.from < ch && cur.to > ch) return i;
            if (cur.to == ch) {
                if (cur.from != cur.to && sticky == "before") found = i;
                else bidiOther = i;
            }
            if (cur.from == ch) {
                if (cur.from != cur.to && sticky != "before") found = i;
                else bidiOther = i;
            }
        }
        return found != null ? found : bidiOther;
    }
    // Bidirectional ordering algorithm
    // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
    // that this (partially) implements.
    // One-char codes used for character types:
    // L (L):   Left-to-Right
    // R (R):   Right-to-Left
    // r (AL):  Right-to-Left Arabic
    // 1 (EN):  European Number
    // + (ES):  European Number Separator
    // % (ET):  European Number Terminator
    // n (AN):  Arabic Number
    // , (CS):  Common Number Separator
    // m (NSM): Non-Spacing Mark
    // b (BN):  Boundary Neutral
    // s (B):   Paragraph Separator
    // t (S):   Segment Separator
    // w (WS):  Whitespace
    // N (ON):  Other Neutrals
    // Returns null if characters are ordered as they appear
    // (left-to-right), or an array of sections ({from, to, level}
    // objects) in the order in which they occur visually.
    var bidiOrdering = function() {
        // Character types for codepoints 0 to 0xff
        var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
        // Character types for codepoints 0x600 to 0x6f9
        var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
        function charType(code) {
            if (code <= 0xf7) return lowTypes.charAt(code);
            else if (0x590 <= code && code <= 0x5f4) return "R";
            else if (0x600 <= code && code <= 0x6f9) return arabicTypes.charAt(code - 0x600);
            else if (0x6ee <= code && code <= 0x8ac) return "r";
            else if (0x2000 <= code && code <= 0x200b) return "w";
            else if (code == 0x200c) return "b";
            else return "L";
        }
        var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
        var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
        function BidiSpan(level, from, to) {
            this.level = level;
            this.from = from;
            this.to = to;
        }
        return function(str, direction) {
            var outerType = direction == "ltr" ? "L" : "R";
            if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) return false;
            var len = str.length, types = [];
            for(var i = 0; i < len; ++i)types.push(charType(str.charCodeAt(i)));
            // W1. Examine each non-spacing mark (NSM) in the level run, and
            // change the type of the NSM to the type of the previous
            // character. If the NSM is at the start of the level run, it will
            // get the type of sor.
            for(var i$1 = 0, prev = outerType; i$1 < len; ++i$1){
                var type = types[i$1];
                if (type == "m") types[i$1] = prev;
                else prev = type;
            }
            // W2. Search backwards from each instance of a European number
            // until the first strong type (R, L, AL, or sor) is found. If an
            // AL is found, change the type of the European number to Arabic
            // number.
            // W3. Change all ALs to R.
            for(var i$2 = 0, cur = outerType; i$2 < len; ++i$2){
                var type$1 = types[i$2];
                if (type$1 == "1" && cur == "r") types[i$2] = "n";
                else if (isStrong.test(type$1)) {
                    cur = type$1;
                    if (type$1 == "r") types[i$2] = "R";
                }
            }
            // W4. A single European separator between two European numbers
            // changes to a European number. A single common separator between
            // two numbers of the same type changes to that type.
            for(var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3){
                var type$2 = types[i$3];
                if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") types[i$3] = "1";
                else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) types[i$3] = prev$1;
                prev$1 = type$2;
            }
            // W5. A sequence of European terminators adjacent to European
            // numbers changes to all European numbers.
            // W6. Otherwise, separators and terminators change to Other
            // Neutral.
            for(var i$4 = 0; i$4 < len; ++i$4){
                var type$3 = types[i$4];
                if (type$3 == ",") types[i$4] = "N";
                else if (type$3 == "%") {
                    var end = void 0;
                    for(end = i$4 + 1; end < len && types[end] == "%"; ++end);
                    var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
                    for(var j = i$4; j < end; ++j)types[j] = replace;
                    i$4 = end - 1;
                }
            }
            // W7. Search backwards from each instance of a European number
            // until the first strong type (R, L, or sor) is found. If an L is
            // found, then change the type of the European number to L.
            for(var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5){
                var type$4 = types[i$5];
                if (cur$1 == "L" && type$4 == "1") types[i$5] = "L";
                else if (isStrong.test(type$4)) cur$1 = type$4;
            }
            // N1. A sequence of neutrals takes the direction of the
            // surrounding strong text if the text on both sides has the same
            // direction. European and Arabic numbers act as if they were R in
            // terms of their influence on neutrals. Start-of-level-run (sor)
            // and end-of-level-run (eor) are used at level run boundaries.
            // N2. Any remaining neutrals take the embedding direction.
            for(var i$6 = 0; i$6 < len; ++i$6)if (isNeutral.test(types[i$6])) {
                var end$1 = void 0;
                for(end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1);
                var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
                var after = (end$1 < len ? types[end$1] : outerType) == "L";
                var replace$1 = before == after ? before ? "L" : "R" : outerType;
                for(var j$1 = i$6; j$1 < end$1; ++j$1)types[j$1] = replace$1;
                i$6 = end$1 - 1;
            }
            // Here we depart from the documented algorithm, in order to avoid
            // building up an actual levels array. Since there are only three
            // levels (0, 1, 2) in an implementation that doesn't take
            // explicit embedding into account, we can build up the order on
            // the fly, without following the level-based algorithm.
            var order = [], m;
            for(var i$7 = 0; i$7 < len;)if (countsAsLeft.test(types[i$7])) {
                var start = i$7;
                for(++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7);
                order.push(new BidiSpan(0, start, i$7));
            } else {
                var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
                for(++i$7; i$7 < len && types[i$7] != "L"; ++i$7);
                for(var j$2 = pos; j$2 < i$7;)if (countsAsNum.test(types[j$2])) {
                    if (pos < j$2) {
                        order.splice(at, 0, new BidiSpan(1, pos, j$2));
                        at += isRTL;
                    }
                    var nstart = j$2;
                    for(++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2);
                    order.splice(at, 0, new BidiSpan(2, nstart, j$2));
                    at += isRTL;
                    pos = j$2;
                } else ++j$2;
                if (pos < i$7) order.splice(at, 0, new BidiSpan(1, pos, i$7));
            }
            if (direction == "ltr") {
                if (order[0].level == 1 && (m = str.match(/^\s+/))) {
                    order[0].from = m[0].length;
                    order.unshift(new BidiSpan(0, 0, m[0].length));
                }
                if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
                    lst(order).to -= m[0].length;
                    order.push(new BidiSpan(0, len - m[0].length, len));
                }
            }
            return direction == "rtl" ? order.reverse() : order;
        };
    }();
    // Get the bidi ordering for the given line (and cache it). Returns
    // false for lines that are fully left-to-right, and an array of
    // BidiSpan objects otherwise.
    function getOrder(line, direction) {
        var order = line.order;
        if (order == null) order = line.order = bidiOrdering(line.text, direction);
        return order;
    }
    // EVENT HANDLING
    // Lightweight event framework. on/off also work on DOM nodes,
    // registering native DOM handlers.
    var noHandlers = [];
    var on = function(emitter, type, f) {
        if (emitter.addEventListener) emitter.addEventListener(type, f, false);
        else if (emitter.attachEvent) emitter.attachEvent("on" + type, f);
        else {
            var map = emitter._handlers || (emitter._handlers = {});
            map[type] = (map[type] || noHandlers).concat(f);
        }
    };
    function getHandlers(emitter, type) {
        return emitter._handlers && emitter._handlers[type] || noHandlers;
    }
    function off(emitter, type, f) {
        if (emitter.removeEventListener) emitter.removeEventListener(type, f, false);
        else if (emitter.detachEvent) emitter.detachEvent("on" + type, f);
        else {
            var map = emitter._handlers, arr = map && map[type];
            if (arr) {
                var index = indexOf(arr, f);
                if (index > -1) map[type] = arr.slice(0, index).concat(arr.slice(index + 1));
            }
        }
    }
    function signal(emitter, type /*, values...*/ ) {
        var handlers = getHandlers(emitter, type);
        if (!handlers.length) return;
        var args = Array.prototype.slice.call(arguments, 2);
        for(var i = 0; i < handlers.length; ++i)handlers[i].apply(null, args);
    }
    // The DOM events that CodeMirror handles can be overridden by
    // registering a (non-DOM) handler on the editor for the event name,
    // and preventDefault-ing the event in that handler.
    function signalDOMEvent(cm, e, override) {
        if (typeof e == "string") e = {
            type: e,
            preventDefault: function() {
                this.defaultPrevented = true;
            }
        };
        signal(cm, override || e.type, cm, e);
        return e_defaultPrevented(e) || e.codemirrorIgnore;
    }
    function signalCursorActivity(cm) {
        var arr = cm._handlers && cm._handlers.cursorActivity;
        if (!arr) return;
        var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
        for(var i = 0; i < arr.length; ++i)if (indexOf(set, arr[i]) == -1) set.push(arr[i]);
    }
    function hasHandler(emitter, type) {
        return getHandlers(emitter, type).length > 0;
    }
    // Add on and off methods to a constructor's prototype, to make
    // registering events on such objects more convenient.
    function eventMixin(ctor) {
        ctor.prototype.on = function(type, f) {
            on(this, type, f);
        };
        ctor.prototype.off = function(type, f) {
            off(this, type, f);
        };
    }
    // Due to the fact that we still support jurassic IE versions, some
    // compatibility wrappers are needed.
    function e_preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
    }
    function e_stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else e.cancelBubble = true;
    }
    function e_defaultPrevented(e) {
        return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
    }
    function e_stop(e) {
        e_preventDefault(e);
        e_stopPropagation(e);
    }
    function e_target(e) {
        return e.target || e.srcElement;
    }
    function e_button(e) {
        var b = e.which;
        if (b == null) {
            if (e.button & 1) b = 1;
            else if (e.button & 2) b = 3;
            else if (e.button & 4) b = 2;
        }
        if (mac && e.ctrlKey && b == 1) b = 3;
        return b;
    }
    // Detect drag-and-drop
    var dragAndDrop = function() {
        // There is *some* kind of drag-and-drop support in IE6-8, but I
        // couldn't get it to work yet.
        if (ie && ie_version < 9) return false;
        var div = elt('div');
        return "draggable" in div || "dragDrop" in div;
    }();
    var zwspSupported;
    function zeroWidthElement(measure) {
        if (zwspSupported == null) {
            var test = elt("span", "\u200b");
            removeChildrenAndAdd(measure, elt("span", [
                test,
                document.createTextNode("x")
            ]));
            if (measure.firstChild.offsetHeight != 0) zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
        }
        var node = zwspSupported ? elt("span", "\u200b") : elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
        node.setAttribute("cm-text", "");
        return node;
    }
    // Feature-detect IE's crummy client rect reporting for bidi text
    var badBidiRects;
    function hasBadBidiRects(measure) {
        if (badBidiRects != null) return badBidiRects;
        var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
        var r0 = range(txt, 0, 1).getBoundingClientRect();
        var r1 = range(txt, 1, 2).getBoundingClientRect();
        removeChildren(measure);
        if (!r0 || r0.left == r0.right) return false;
         // Safari returns null in some cases (#2780)
        return badBidiRects = r1.right - r0.right < 3;
    }
    // See if "".split is the broken IE version, if so, provide an
    // alternative way to split lines.
    var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function(string) {
        var pos = 0, result = [], l = string.length;
        while(pos <= l){
            var nl = string.indexOf("\n", pos);
            if (nl == -1) nl = string.length;
            var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
            var rt = line.indexOf("\r");
            if (rt != -1) {
                result.push(line.slice(0, rt));
                pos += rt + 1;
            } else {
                result.push(line);
                pos = nl + 1;
            }
        }
        return result;
    } : function(string) {
        return string.split(/\r\n?|\n/);
    };
    var hasSelection = window.getSelection ? function(te) {
        try {
            return te.selectionStart != te.selectionEnd;
        } catch (e) {
            return false;
        }
    } : function(te) {
        var range;
        try {
            range = te.ownerDocument.selection.createRange();
        } catch (e) {}
        if (!range || range.parentElement() != te) return false;
        return range.compareEndPoints("StartToEnd", range) != 0;
    };
    var hasCopyEvent = function() {
        var e = elt("div");
        if ("oncopy" in e) return true;
        e.setAttribute("oncopy", "return;");
        return typeof e.oncopy == "function";
    }();
    var badZoomedRects = null;
    function hasBadZoomedRects(measure) {
        if (badZoomedRects != null) return badZoomedRects;
        var node = removeChildrenAndAdd(measure, elt("span", "x"));
        var normal = node.getBoundingClientRect();
        var fromRange = range(node, 0, 1).getBoundingClientRect();
        return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
    }
    // Known modes, by name and by MIME
    var modes = {}, mimeModes = {};
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    function defineMode(name, mode) {
        if (arguments.length > 2) mode.dependencies = Array.prototype.slice.call(arguments, 2);
        modes[name] = mode;
    }
    function defineMIME(mime, spec) {
        mimeModes[mime] = spec;
    }
    // Given a MIME type, a {name, ...options} config object, or a name
    // string, return a mode config object.
    function resolveMode(spec) {
        if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) spec = mimeModes[spec];
        else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
            var found = mimeModes[spec.name];
            if (typeof found == "string") found = {
                name: found
            };
            spec = createObj(found, spec);
            spec.name = found.name;
        } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) return resolveMode("application/xml");
        else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) return resolveMode("application/json");
        if (typeof spec == "string") return {
            name: spec
        };
        else return spec || {
            name: "null"
        };
    }
    // Given a mode spec (anything that resolveMode accepts), find and
    // initialize an actual mode object.
    function getMode(options, spec) {
        spec = resolveMode(spec);
        var mfactory = modes[spec.name];
        if (!mfactory) return getMode(options, "text/plain");
        var modeObj = mfactory(options, spec);
        if (modeExtensions.hasOwnProperty(spec.name)) {
            var exts = modeExtensions[spec.name];
            for(var prop in exts){
                if (!exts.hasOwnProperty(prop)) continue;
                if (modeObj.hasOwnProperty(prop)) modeObj["_" + prop] = modeObj[prop];
                modeObj[prop] = exts[prop];
            }
        }
        modeObj.name = spec.name;
        if (spec.helperType) modeObj.helperType = spec.helperType;
        if (spec.modeProps) for(var prop$1 in spec.modeProps)modeObj[prop$1] = spec.modeProps[prop$1];
        return modeObj;
    }
    // This can be used to attach properties to mode objects from
    // outside the actual mode definition.
    var modeExtensions = {};
    function extendMode(mode, properties) {
        var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
        copyObj(properties, exts);
    }
    function copyState(mode, state) {
        if (state === true) return state;
        if (mode.copyState) return mode.copyState(state);
        var nstate = {};
        for(var n in state){
            var val = state[n];
            if (val instanceof Array) val = val.concat([]);
            nstate[n] = val;
        }
        return nstate;
    }
    // Given a mode and a state (for that mode), find the inner mode and
    // state at the position that the state refers to.
    function innerMode(mode, state) {
        var info;
        while(mode.innerMode){
            info = mode.innerMode(state);
            if (!info || info.mode == mode) break;
            state = info.state;
            mode = info.mode;
        }
        return info || {
            mode: mode,
            state: state
        };
    }
    function startState(mode, a1, a2) {
        return mode.startState ? mode.startState(a1, a2) : true;
    }
    // STRING STREAM
    // Fed to the mode parsers, provides helper functions to make
    // parsers more succinct.
    var StringStream = function(string, tabSize, lineOracle) {
        this.pos = this.start = 0;
        this.string = string;
        this.tabSize = tabSize || 8;
        this.lastColumnPos = this.lastColumnValue = 0;
        this.lineStart = 0;
        this.lineOracle = lineOracle;
    };
    StringStream.prototype.eol = function() {
        return this.pos >= this.string.length;
    };
    StringStream.prototype.sol = function() {
        return this.pos == this.lineStart;
    };
    StringStream.prototype.peek = function() {
        return this.string.charAt(this.pos) || undefined;
    };
    StringStream.prototype.next = function() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    };
    StringStream.prototype.eat = function(match) {
        var ch = this.string.charAt(this.pos);
        var ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match.test ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    };
    StringStream.prototype.eatWhile = function(match) {
        var start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    };
    StringStream.prototype.eatSpace = function() {
        var start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    };
    StringStream.prototype.skipToEnd = function() {
        this.pos = this.string.length;
    };
    StringStream.prototype.skipTo = function(ch) {
        var found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    };
    StringStream.prototype.backUp = function(n) {
        this.pos -= n;
    };
    StringStream.prototype.column = function() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.indentation = function() {
        return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.match = function(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            var cased = function(str) {
                return caseInsensitive ? str.toLowerCase() : str;
            };
            var substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            }
        } else {
            var match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    };
    StringStream.prototype.current = function() {
        return this.string.slice(this.start, this.pos);
    };
    StringStream.prototype.hideFirstChars = function(n, inner) {
        this.lineStart += n;
        try {
            return inner();
        } finally{
            this.lineStart -= n;
        }
    };
    StringStream.prototype.lookAhead = function(n) {
        var oracle = this.lineOracle;
        return oracle && oracle.lookAhead(n);
    };
    StringStream.prototype.baseToken = function() {
        var oracle = this.lineOracle;
        return oracle && oracle.baseToken(this.pos);
    };
    // Find the line object corresponding to the given line number.
    function getLine(doc, n) {
        n -= doc.first;
        if (n < 0 || n >= doc.size) throw new Error("There is no line " + (n + doc.first) + " in the document.");
        var chunk = doc;
        while(!chunk.lines)for(var i = 0;; ++i){
            var child = chunk.children[i], sz = child.chunkSize();
            if (n < sz) {
                chunk = child;
                break;
            }
            n -= sz;
        }
        return chunk.lines[n];
    }
    // Get the part of a document between two positions, as an array of
    // strings.
    function getBetween(doc, start, end) {
        var out = [], n = start.line;
        doc.iter(start.line, end.line + 1, function(line) {
            var text = line.text;
            if (n == end.line) text = text.slice(0, end.ch);
            if (n == start.line) text = text.slice(start.ch);
            out.push(text);
            ++n;
        });
        return out;
    }
    // Get the lines between from and to, as array of strings.
    function getLines(doc, from, to) {
        var out = [];
        doc.iter(from, to, function(line) {
            out.push(line.text);
        }); // iter aborts when callback returns truthy value
        return out;
    }
    // Update the height of a line, propagating the height change
    // upwards to parent nodes.
    function updateLineHeight(line, height) {
        var diff = height - line.height;
        if (diff) for(var n = line; n; n = n.parent)n.height += diff;
    }
    // Given a line object, find its line number by walking up through
    // its parent links.
    function lineNo(line) {
        if (line.parent == null) return null;
        var cur = line.parent, no = indexOf(cur.lines, line);
        for(var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent)for(var i = 0;; ++i){
            if (chunk.children[i] == cur) break;
            no += chunk.children[i].chunkSize();
        }
        return no + cur.first;
    }
    // Find the line at the given vertical position, using the height
    // information in the document tree.
    function lineAtHeight(chunk, h) {
        var n = chunk.first;
        outer: do {
            for(var i$1 = 0; i$1 < chunk.children.length; ++i$1){
                var child = chunk.children[i$1], ch = child.height;
                if (h < ch) {
                    chunk = child;
                    continue outer;
                }
                h -= ch;
                n += child.chunkSize();
            }
            return n;
        }while (!chunk.lines);
        var i = 0;
        for(; i < chunk.lines.length; ++i){
            var line = chunk.lines[i], lh = line.height;
            if (h < lh) break;
            h -= lh;
        }
        return n + i;
    }
    function isLine(doc, l) {
        return l >= doc.first && l < doc.first + doc.size;
    }
    function lineNumberFor(options, i) {
        return String(options.lineNumberFormatter(i + options.firstLineNumber));
    }
    // A Pos instance represents a position within the text.
    function Pos(line, ch, sticky) {
        if (sticky === void 0) sticky = null;
        if (!(this instanceof Pos)) return new Pos(line, ch, sticky);
        this.line = line;
        this.ch = ch;
        this.sticky = sticky;
    }
    // Compare two positions, return 0 if they are the same, a negative
    // number when a is less, and a positive number otherwise.
    function cmp(a, b) {
        return a.line - b.line || a.ch - b.ch;
    }
    function equalCursorPos(a, b) {
        return a.sticky == b.sticky && cmp(a, b) == 0;
    }
    function copyPos(x) {
        return Pos(x.line, x.ch);
    }
    function maxPos(a, b) {
        return cmp(a, b) < 0 ? b : a;
    }
    function minPos(a, b) {
        return cmp(a, b) < 0 ? a : b;
    }
    // Most of the external API clips given positions to make sure they
    // actually exist within the document.
    function clipLine(doc, n) {
        return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
    }
    function clipPos(doc, pos) {
        if (pos.line < doc.first) return Pos(doc.first, 0);
        var last = doc.first + doc.size - 1;
        if (pos.line > last) return Pos(last, getLine(doc, last).text.length);
        return clipToLen(pos, getLine(doc, pos.line).text.length);
    }
    function clipToLen(pos, linelen) {
        var ch = pos.ch;
        if (ch == null || ch > linelen) return Pos(pos.line, linelen);
        else if (ch < 0) return Pos(pos.line, 0);
        else return pos;
    }
    function clipPosArray(doc, array) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = clipPos(doc, array[i]);
        return out;
    }
    var SavedContext = function(state, lookAhead) {
        this.state = state;
        this.lookAhead = lookAhead;
    };
    var Context = function(doc, state, line, lookAhead) {
        this.state = state;
        this.doc = doc;
        this.line = line;
        this.maxLookAhead = lookAhead || 0;
        this.baseTokens = null;
        this.baseTokenPos = 1;
    };
    Context.prototype.lookAhead = function(n) {
        var line = this.doc.getLine(this.line + n);
        if (line != null && n > this.maxLookAhead) this.maxLookAhead = n;
        return line;
    };
    Context.prototype.baseToken = function(n) {
        if (!this.baseTokens) return null;
        while(this.baseTokens[this.baseTokenPos] <= n)this.baseTokenPos += 2;
        var type = this.baseTokens[this.baseTokenPos + 1];
        return {
            type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n
        };
    };
    Context.prototype.nextLine = function() {
        this.line++;
        if (this.maxLookAhead > 0) this.maxLookAhead--;
    };
    Context.fromSaved = function(doc, saved, line) {
        if (saved instanceof SavedContext) return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
        else return new Context(doc, copyState(doc.mode, saved), line);
    };
    Context.prototype.save = function(copy) {
        var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
        return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
    };
    // Compute a style array (an array starting with a mode generation
    // -- for invalidation -- followed by pairs of end positions and
    // style strings), which is used to highlight the tokens on the
    // line.
    function highlightLine(cm, line, context, forceToEnd) {
        // A styles array always starts with a number identifying the
        // mode/overlays that it is based on (for easy invalidation).
        var st = [
            cm.state.modeGen
        ], lineClasses = {};
        // Compute the base array of styles
        runMode(cm, line.text, cm.doc.mode, context, function(end, style) {
            return st.push(end, style);
        }, lineClasses, forceToEnd);
        var state = context.state;
        // Run overlays, adjust style array.
        var loop = function(o) {
            context.baseTokens = st;
            var overlay = cm.state.overlays[o], i = 1, at = 0;
            context.state = true;
            runMode(cm, line.text, overlay.mode, context, function(end, style) {
                var start = i;
                // Ensure there's a token end at the current position, and that i points at it
                while(at < end){
                    var i_end = st[i];
                    if (i_end > end) st.splice(i, 1, end, st[i + 1], i_end);
                    i += 2;
                    at = Math.min(end, i_end);
                }
                if (!style) return;
                if (overlay.opaque) {
                    st.splice(start, i - start, end, "overlay " + style);
                    i = start + 2;
                } else for(; start < i; start += 2){
                    var cur = st[start + 1];
                    st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
                }
            }, lineClasses);
            context.state = state;
            context.baseTokens = null;
            context.baseTokenPos = 1;
        };
        for(var o = 0; o < cm.state.overlays.length; ++o)loop(o);
        return {
            styles: st,
            classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null
        };
    }
    function getLineStyles(cm, line, updateFrontier) {
        if (!line.styles || line.styles[0] != cm.state.modeGen) {
            var context = getContextBefore(cm, lineNo(line));
            var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
            var result = highlightLine(cm, line, context);
            if (resetState) context.state = resetState;
            line.stateAfter = context.save(!resetState);
            line.styles = result.styles;
            if (result.classes) line.styleClasses = result.classes;
            else if (line.styleClasses) line.styleClasses = null;
            if (updateFrontier === cm.doc.highlightFrontier) cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
        }
        return line.styles;
    }
    function getContextBefore(cm, n, precise) {
        var doc = cm.doc, display = cm.display;
        if (!doc.mode.startState) return new Context(doc, true, n);
        var start = findStartLine(cm, n, precise);
        var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
        var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
        doc.iter(start, n, function(line) {
            processLine(cm, line.text, context);
            var pos = context.line;
            line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
            context.nextLine();
        });
        if (precise) doc.modeFrontier = context.line;
        return context;
    }
    // Lightweight form of highlight -- proceed over this line and
    // update state, but don't save a style array. Used for lines that
    // aren't currently visible.
    function processLine(cm, text, context, startAt) {
        var mode = cm.doc.mode;
        var stream = new StringStream(text, cm.options.tabSize, context);
        stream.start = stream.pos = startAt || 0;
        if (text == "") callBlankLine(mode, context.state);
        while(!stream.eol()){
            readToken(mode, stream, context.state);
            stream.start = stream.pos;
        }
    }
    function callBlankLine(mode, state) {
        if (mode.blankLine) return mode.blankLine(state);
        if (!mode.innerMode) return;
        var inner = innerMode(mode, state);
        if (inner.mode.blankLine) return inner.mode.blankLine(inner.state);
    }
    function readToken(mode, stream, state, inner) {
        for(var i = 0; i < 10; i++){
            if (inner) inner[0] = innerMode(mode, state).mode;
            var style = mode.token(stream, state);
            if (stream.pos > stream.start) return style;
        }
        throw new Error("Mode " + mode.name + " failed to advance stream.");
    }
    var Token = function(stream, type, state) {
        this.start = stream.start;
        this.end = stream.pos;
        this.string = stream.current();
        this.type = type || null;
        this.state = state;
    };
    // Utility for getTokenAt and getLineTokens
    function takeToken(cm, pos, precise, asArray) {
        var doc = cm.doc, mode = doc.mode, style;
        pos = clipPos(doc, pos);
        var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
        var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
        if (asArray) tokens = [];
        while((asArray || stream.pos < pos.ch) && !stream.eol()){
            stream.start = stream.pos;
            style = readToken(mode, stream, context.state);
            if (asArray) tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
        }
        return asArray ? tokens : new Token(stream, style, context.state);
    }
    function extractLineClasses(type, output) {
        if (type) for(;;){
            var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
            if (!lineClass) break;
            type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
            var prop = lineClass[1] ? "bgClass" : "textClass";
            if (output[prop] == null) output[prop] = lineClass[2];
            else if (!new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)").test(output[prop])) output[prop] += " " + lineClass[2];
        }
        return type;
    }
    // Run the given mode's parser over a line, calling f for each token.
    function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
        var flattenSpans = mode.flattenSpans;
        if (flattenSpans == null) flattenSpans = cm.options.flattenSpans;
        var curStart = 0, curStyle = null;
        var stream = new StringStream(text, cm.options.tabSize, context), style;
        var inner = cm.options.addModeClass && [
            null
        ];
        if (text == "") extractLineClasses(callBlankLine(mode, context.state), lineClasses);
        while(!stream.eol()){
            if (stream.pos > cm.options.maxHighlightLength) {
                flattenSpans = false;
                if (forceToEnd) processLine(cm, text, context, stream.pos);
                stream.pos = text.length;
                style = null;
            } else style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
            if (inner) {
                var mName = inner[0].name;
                if (mName) style = "m-" + (style ? mName + " " + style : mName);
            }
            if (!flattenSpans || curStyle != style) {
                while(curStart < stream.start){
                    curStart = Math.min(stream.start, curStart + 5000);
                    f(curStart, curStyle);
                }
                curStyle = style;
            }
            stream.start = stream.pos;
        }
        while(curStart < stream.pos){
            // Webkit seems to refuse to render text nodes longer than 57444
            // characters, and returns inaccurate measurements in nodes
            // starting around 5000 chars.
            var pos = Math.min(stream.pos, curStart + 5000);
            f(pos, curStyle);
            curStart = pos;
        }
    }
    // Finds the line to start with when starting a parse. Tries to
    // find a line with a stateAfter, so that it can start with a
    // valid state. If that fails, it returns the line with the
    // smallest indentation, which tends to need the least context to
    // parse correctly.
    function findStartLine(cm, n, precise) {
        var minindent, minline, doc = cm.doc;
        var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
        for(var search = n; search > lim; --search){
            if (search <= doc.first) return doc.first;
            var line = getLine(doc, search - 1), after = line.stateAfter;
            if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier)) return search;
            var indented = countColumn(line.text, null, cm.options.tabSize);
            if (minline == null || minindent > indented) {
                minline = search - 1;
                minindent = indented;
            }
        }
        return minline;
    }
    function retreatFrontier(doc, n) {
        doc.modeFrontier = Math.min(doc.modeFrontier, n);
        if (doc.highlightFrontier < n - 10) return;
        var start = doc.first;
        for(var line = n - 1; line > start; line--){
            var saved = getLine(doc, line).stateAfter;
            // change is on 3
            // state on line 1 looked ahead 2 -- so saw 3
            // test 1 + 2 < 3 should cover this
            if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
                start = line + 1;
                break;
            }
        }
        doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
    }
    // Optimize some code when these features are not used.
    var sawReadOnlySpans = false, sawCollapsedSpans = false;
    function seeReadOnlySpans() {
        sawReadOnlySpans = true;
    }
    function seeCollapsedSpans() {
        sawCollapsedSpans = true;
    }
    // TEXTMARKER SPANS
    function MarkedSpan(marker, from, to) {
        this.marker = marker;
        this.from = from;
        this.to = to;
    }
    // Search an array of spans for a span matching the given marker.
    function getMarkedSpanFor(spans, marker) {
        if (spans) for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.marker == marker) return span;
        }
    }
    // Remove a span from an array, returning undefined if no spans are
    // left (we don't store arrays for lines without spans).
    function removeMarkedSpan(spans, span) {
        var r;
        for(var i = 0; i < spans.length; ++i)if (spans[i] != span) (r || (r = [])).push(spans[i]);
        return r;
    }
    // Add a span to a line.
    function addMarkedSpan(line, span, op) {
        var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
        if (inThisOp && line.markedSpans && inThisOp.has(line.markedSpans)) line.markedSpans.push(span);
        else {
            line.markedSpans = line.markedSpans ? line.markedSpans.concat([
                span
            ]) : [
                span
            ];
            if (inThisOp) inThisOp.add(line.markedSpans);
        }
        span.marker.attachLine(line);
    }
    // Used for the algorithm that adjusts markers for a change in the
    // document. These functions cut an array of spans at a given
    // character position, returning an array of remaining chunks (or
    // undefined if nothing remains).
    function markedSpansBefore(old, startCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
            if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
                var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
            }
        }
        return nw;
    }
    function markedSpansAfter(old, endCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
            if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
                var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
            }
        }
        return nw;
    }
    // Given a change object, compute the new set of marker spans that
    // cover the line in which the change took place. Removes spans
    // entirely within the change, reconnects spans belonging to the
    // same marker that appear on both sides of the change, and cuts off
    // spans partially within the change. Returns an array of span
    // arrays with one element for each line in (after) the change.
    function stretchSpansOverChange(doc, change) {
        if (change.full) return null;
        var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
        var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
        if (!oldFirst && !oldLast) return null;
        var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
        // Get the spans that 'stick out' on both sides
        var first = markedSpansBefore(oldFirst, startCh, isInsert);
        var last = markedSpansAfter(oldLast, endCh, isInsert);
        // Next, merge those two ends
        var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
        if (first) // Fix up .to properties of first
        for(var i = 0; i < first.length; ++i){
            var span = first[i];
            if (span.to == null) {
                var found = getMarkedSpanFor(last, span.marker);
                if (!found) span.to = startCh;
                else if (sameLine) span.to = found.to == null ? null : found.to + offset;
            }
        }
        if (last) // Fix up .from in last (or move them into first in case of sameLine)
        for(var i$1 = 0; i$1 < last.length; ++i$1){
            var span$1 = last[i$1];
            if (span$1.to != null) span$1.to += offset;
            if (span$1.from == null) {
                var found$1 = getMarkedSpanFor(first, span$1.marker);
                if (!found$1) {
                    span$1.from = offset;
                    if (sameLine) (first || (first = [])).push(span$1);
                }
            } else {
                span$1.from += offset;
                if (sameLine) (first || (first = [])).push(span$1);
            }
        }
        // Make sure we didn't create any zero-length spans
        if (first) first = clearEmptySpans(first);
        if (last && last != first) last = clearEmptySpans(last);
        var newMarkers = [
            first
        ];
        if (!sameLine) {
            // Fill gap with whole-line-spans
            var gap = change.text.length - 2, gapMarkers;
            if (gap > 0 && first) {
                for(var i$2 = 0; i$2 < first.length; ++i$2)if (first[i$2].to == null) (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
            }
            for(var i$3 = 0; i$3 < gap; ++i$3)newMarkers.push(gapMarkers);
            newMarkers.push(last);
        }
        return newMarkers;
    }
    // Remove spans that are empty and don't have a clearWhenEmpty
    // option of false.
    function clearEmptySpans(spans) {
        for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) spans.splice(i--, 1);
        }
        if (!spans.length) return null;
        return spans;
    }
    // Used to 'clip' out readOnly ranges when making a change.
    function removeReadOnlyRanges(doc, from, to) {
        var markers = null;
        doc.iter(from.line, to.line + 1, function(line) {
            if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
                var mark = line.markedSpans[i].marker;
                if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) (markers || (markers = [])).push(mark);
            }
        });
        if (!markers) return null;
        var parts = [
            {
                from: from,
                to: to
            }
        ];
        for(var i = 0; i < markers.length; ++i){
            var mk = markers[i], m = mk.find(0);
            for(var j = 0; j < parts.length; ++j){
                var p = parts[j];
                if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) continue;
                var newParts = [
                    j,
                    1
                ], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
                if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) newParts.push({
                    from: p.from,
                    to: m.from
                });
                if (dto > 0 || !mk.inclusiveRight && !dto) newParts.push({
                    from: m.to,
                    to: p.to
                });
                parts.splice.apply(parts, newParts);
                j += newParts.length - 3;
            }
        }
        return parts;
    }
    // Connect or disconnect spans from a line.
    function detachMarkedSpans(line) {
        var spans = line.markedSpans;
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.detachLine(line);
        line.markedSpans = null;
    }
    function attachMarkedSpans(line, spans) {
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.attachLine(line);
        line.markedSpans = spans;
    }
    // Helpers used when computing which overlapping collapsed span
    // counts as the larger one.
    function extraLeft(marker) {
        return marker.inclusiveLeft ? -1 : 0;
    }
    function extraRight(marker) {
        return marker.inclusiveRight ? 1 : 0;
    }
    // Returns a number indicating which of two overlapping collapsed
    // spans is larger (and thus includes the other). Falls back to
    // comparing ids when the spans cover exactly the same range.
    function compareCollapsedMarkers(a, b) {
        var lenDiff = a.lines.length - b.lines.length;
        if (lenDiff != 0) return lenDiff;
        var aPos = a.find(), bPos = b.find();
        var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
        if (fromCmp) return -fromCmp;
        var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
        if (toCmp) return toCmp;
        return b.id - a.id;
    }
    // Find out whether a line ends or starts in a collapsed span. If
    // so, return the marker for that span.
    function collapsedSpanAtSide(line, start) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    function collapsedSpanAtStart(line) {
        return collapsedSpanAtSide(line, true);
    }
    function collapsedSpanAtEnd(line) {
        return collapsedSpanAtSide(line, false);
    }
    function collapsedSpanAround(line, ch) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    // Test whether there exists a collapsed span that partially
    // overlaps (covers the start or end, but not both) of a new span.
    // Such overlap is not allowed.
    function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
        var line = getLine(doc, lineNo);
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (!sp.marker.collapsed) continue;
            var found = sp.marker.find(0);
            var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
            var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
            if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) continue;
            if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) return true;
        }
    }
    // A visual line is a line as drawn on the screen. Folding, for
    // example, can cause multiple logical lines to appear on the same
    // visual line. This finds the start of the visual line that the
    // given line is part of (usually that is the line itself).
    function visualLine(line) {
        var merged;
        while(merged = collapsedSpanAtStart(line))line = merged.find(-1, true).line;
        return line;
    }
    function visualLineEnd(line) {
        var merged;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return line;
    }
    // Returns an array of logical lines that continue the visual line
    // started by the argument, or undefined if there are no such lines.
    function visualLineContinued(line) {
        var merged, lines;
        while(merged = collapsedSpanAtEnd(line)){
            line = merged.find(1, true).line;
            (lines || (lines = [])).push(line);
        }
        return lines;
    }
    // Get the line number of the start of the visual line that the
    // given line number is part of.
    function visualLineNo(doc, lineN) {
        var line = getLine(doc, lineN), vis = visualLine(line);
        if (line == vis) return lineN;
        return lineNo(vis);
    }
    // Get the line number of the start of the next visual line after
    // the given line.
    function visualLineEndNo(doc, lineN) {
        if (lineN > doc.lastLine()) return lineN;
        var line = getLine(doc, lineN), merged;
        if (!lineIsHidden(doc, line)) return lineN;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return lineNo(line) + 1;
    }
    // Compute whether a line is hidden. Lines count as hidden when they
    // are part of a visual line that starts with another line, or when
    // they are entirely covered by collapsed, non-widget span.
    function lineIsHidden(doc, line) {
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (!sp.marker.collapsed) continue;
            if (sp.from == null) return true;
            if (sp.marker.widgetNode) continue;
            if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    function lineIsHiddenInner(doc, line, span) {
        if (span.to == null) {
            var end = span.marker.find(1, true);
            return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
        }
        if (span.marker.inclusiveRight && span.to == line.text.length) return true;
        for(var sp = void 0, i = 0; i < line.markedSpans.length; ++i){
            sp = line.markedSpans[i];
            if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    // Find the height above the given line.
    function heightAtLine(lineObj) {
        lineObj = visualLine(lineObj);
        var h = 0, chunk = lineObj.parent;
        for(var i = 0; i < chunk.lines.length; ++i){
            var line = chunk.lines[i];
            if (line == lineObj) break;
            else h += line.height;
        }
        for(var p = chunk.parent; p; chunk = p, p = chunk.parent)for(var i$1 = 0; i$1 < p.children.length; ++i$1){
            var cur = p.children[i$1];
            if (cur == chunk) break;
            else h += cur.height;
        }
        return h;
    }
    // Compute the character length of a line, taking into account
    // collapsed ranges (see markText) that might hide parts, and join
    // other lines onto it.
    function lineLength(line) {
        if (line.height == 0) return 0;
        var len = line.text.length, merged, cur = line;
        while(merged = collapsedSpanAtStart(cur)){
            var found = merged.find(0, true);
            cur = found.from.line;
            len += found.from.ch - found.to.ch;
        }
        cur = line;
        while(merged = collapsedSpanAtEnd(cur)){
            var found$1 = merged.find(0, true);
            len -= cur.text.length - found$1.from.ch;
            cur = found$1.to.line;
            len += cur.text.length - found$1.to.ch;
        }
        return len;
    }
    // Find the longest line in the document.
    function findMaxLine(cm) {
        var d = cm.display, doc = cm.doc;
        d.maxLine = getLine(doc, doc.first);
        d.maxLineLength = lineLength(d.maxLine);
        d.maxLineChanged = true;
        doc.iter(function(line) {
            var len = lineLength(line);
            if (len > d.maxLineLength) {
                d.maxLineLength = len;
                d.maxLine = line;
            }
        });
    }
    // LINE DATA STRUCTURE
    // Line objects. These hold state related to a line, including
    // highlighting info (the styles array).
    var Line = function(text, markedSpans, estimateHeight) {
        this.text = text;
        attachMarkedSpans(this, markedSpans);
        this.height = estimateHeight ? estimateHeight(this) : 1;
    };
    Line.prototype.lineNo = function() {
        return lineNo(this);
    };
    eventMixin(Line);
    // Change the content (text, markers) of a line. Automatically
    // invalidates cached information and tries to re-estimate the
    // line's height.
    function updateLine(line, text, markedSpans, estimateHeight) {
        line.text = text;
        if (line.stateAfter) line.stateAfter = null;
        if (line.styles) line.styles = null;
        if (line.order != null) line.order = null;
        detachMarkedSpans(line);
        attachMarkedSpans(line, markedSpans);
        var estHeight = estimateHeight ? estimateHeight(line) : 1;
        if (estHeight != line.height) updateLineHeight(line, estHeight);
    }
    // Detach a line from the document tree and its markers.
    function cleanUpLine(line) {
        line.parent = null;
        detachMarkedSpans(line);
    }
    // Convert a style as returned by a mode (either null, or a string
    // containing one or more styles) to a CSS style. This is cached,
    // and also looks for line-wide styles.
    var styleToClassCache = {}, styleToClassCacheWithMode = {};
    function interpretTokenStyle(style, options) {
        if (!style || /^\s*$/.test(style)) return null;
        var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
        return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
    }
    // Render the DOM representation of the text of a line. Also builds
    // up a 'line map', which points at the DOM nodes that represent
    // specific stretches of text, and is used by the measuring code.
    // The returned object contains the DOM node, this map, and
    // information about line-wide styles that were set by the mode.
    function buildLineContent(cm, lineView) {
        // The padding-right forces the element to have a 'border', which
        // is needed on Webkit to be able to get line-level bounding
        // rectangles for it (in measureChar).
        var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
        var builder = {
            pre: eltP("pre", [
                content
            ], "CodeMirror-line"),
            content: content,
            col: 0,
            pos: 0,
            cm: cm,
            trailingSpace: false,
            splitSpaces: cm.getOption("lineWrapping")
        };
        lineView.measure = {};
        // Iterate over the logical lines that make up this visual line.
        for(var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++){
            var line = i ? lineView.rest[i - 1] : lineView.line, order = void 0;
            builder.pos = 0;
            builder.addToken = buildToken;
            // Optionally wire in some hacks into the token-rendering
            // algorithm, to deal with browser quirks.
            if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) builder.addToken = buildTokenBadBidi(builder.addToken, order);
            builder.map = [];
            var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
            insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
            if (line.styleClasses) {
                if (line.styleClasses.bgClass) builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
                if (line.styleClasses.textClass) builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
            }
            // Ensure at least a single node is present, for measuring.
            if (builder.map.length == 0) builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
            // Store the map and a cache object for the current logical line
            if (i == 0) {
                lineView.measure.map = builder.map;
                lineView.measure.cache = {};
            } else {
                (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);
                (lineView.measure.caches || (lineView.measure.caches = [])).push({});
            }
        }
        // See issue #2901
        if (webkit) {
            var last = builder.content.lastChild;
            if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) builder.content.className = "cm-tab-wrap-hack";
        }
        signal(cm, "renderLine", cm, lineView.line, builder.pre);
        if (builder.pre.className) builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
        return builder;
    }
    function defaultSpecialCharPlaceholder(ch) {
        var token = elt("span", "\u2022", "cm-invalidchar");
        token.title = "\\u" + ch.charCodeAt(0).toString(16);
        token.setAttribute("aria-label", token.title);
        return token;
    }
    // Build up the DOM representation for a single token, and add it to
    // the line map. Takes care to render special characters separately.
    function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
        if (!text) return;
        var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
        var special = builder.cm.state.specialChars, mustWrap = false;
        var content;
        if (!special.test(text)) {
            builder.col += text.length;
            content = document.createTextNode(displayText);
            builder.map.push(builder.pos, builder.pos + text.length, content);
            if (ie && ie_version < 9) mustWrap = true;
            builder.pos += text.length;
        } else {
            content = document.createDocumentFragment();
            var pos = 0;
            while(true){
                special.lastIndex = pos;
                var m = special.exec(text);
                var skipped = m ? m.index - pos : text.length - pos;
                if (skipped) {
                    var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt
                    ]));
                    else content.appendChild(txt);
                    builder.map.push(builder.pos, builder.pos + skipped, txt);
                    builder.col += skipped;
                    builder.pos += skipped;
                }
                if (!m) break;
                pos += skipped + 1;
                var txt$1 = void 0;
                if (m[0] == "\t") {
                    var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
                    txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
                    txt$1.setAttribute("role", "presentation");
                    txt$1.setAttribute("cm-text", "\t");
                    builder.col += tabWidth;
                } else if (m[0] == "\r" || m[0] == "\n") {
                    txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
                    txt$1.setAttribute("cm-text", m[0]);
                    builder.col += 1;
                } else {
                    txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
                    txt$1.setAttribute("cm-text", m[0]);
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt$1
                    ]));
                    else content.appendChild(txt$1);
                    builder.col += 1;
                }
                builder.map.push(builder.pos, builder.pos + 1, txt$1);
                builder.pos++;
            }
        }
        builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
        if (style || startStyle || endStyle || mustWrap || css || attributes) {
            var fullStyle = style || "";
            if (startStyle) fullStyle += startStyle;
            if (endStyle) fullStyle += endStyle;
            var token = elt("span", [
                content
            ], fullStyle, css);
            if (attributes) {
                for(var attr in attributes)if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") token.setAttribute(attr, attributes[attr]);
            }
            return builder.content.appendChild(token);
        }
        builder.content.appendChild(content);
    }
    // Change some spaces to NBSP to prevent the browser from collapsing
    // trailing spaces at the end of a line when rendering text (issue #1362).
    function splitSpaces(text, trailingBefore) {
        if (text.length > 1 && !/  /.test(text)) return text;
        var spaceBefore = trailingBefore, result = "";
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) ch = "\u00a0";
            result += ch;
            spaceBefore = ch == " ";
        }
        return result;
    }
    // Work around nonsense dimensions being reported for stretches of
    // right-to-left text.
    function buildTokenBadBidi(inner, order) {
        return function(builder, text, style, startStyle, endStyle, css, attributes) {
            style = style ? style + " cm-force-border" : "cm-force-border";
            var start = builder.pos, end = start + text.length;
            for(;;){
                // Find the part that overlaps with the start of this text
                var part = void 0;
                for(var i = 0; i < order.length; i++){
                    part = order[i];
                    if (part.to > start && part.from <= start) break;
                }
                if (part.to >= end) return inner(builder, text, style, startStyle, endStyle, css, attributes);
                inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
                startStyle = null;
                text = text.slice(part.to - start);
                start = part.to;
            }
        };
    }
    function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
        var widget = !ignoreWidget && marker.widgetNode;
        if (widget) builder.map.push(builder.pos, builder.pos + size, widget);
        if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
            if (!widget) widget = builder.content.appendChild(document.createElement("span"));
            widget.setAttribute("cm-marker", marker.id);
        }
        if (widget) {
            builder.cm.display.input.setUneditable(widget);
            builder.content.appendChild(widget);
        }
        builder.pos += size;
        builder.trailingSpace = false;
    }
    // Outputs a number of spans to make up a line, taking highlighting
    // and marked text into account.
    function insertLineContent(line, builder, styles) {
        var spans = line.markedSpans, allText = line.text, at = 0;
        if (!spans) {
            for(var i$1 = 1; i$1 < styles.length; i$1 += 2)builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
            return;
        }
        var len = allText.length, pos = 0, i = 1, text = "", style, css;
        var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
        for(;;){
            if (nextChange == pos) {
                spanStyle = spanEndStyle = spanStartStyle = css = "";
                attributes = null;
                collapsed = null;
                nextChange = Infinity;
                var foundBookmarks = [], endStyles = void 0;
                for(var j = 0; j < spans.length; ++j){
                    var sp = spans[j], m = sp.marker;
                    if (m.type == "bookmark" && sp.from == pos && m.widgetNode) foundBookmarks.push(m);
                    else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
                        if (sp.to != null && sp.to != pos && nextChange > sp.to) {
                            nextChange = sp.to;
                            spanEndStyle = "";
                        }
                        if (m.className) spanStyle += " " + m.className;
                        if (m.css) css = (css ? css + ";" : "") + m.css;
                        if (m.startStyle && sp.from == pos) spanStartStyle += " " + m.startStyle;
                        if (m.endStyle && sp.to == nextChange) (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
                        // support for the old title property
                        // https://github.com/codemirror/CodeMirror/pull/5673
                        if (m.title) (attributes || (attributes = {})).title = m.title;
                        if (m.attributes) for(var attr in m.attributes)(attributes || (attributes = {}))[attr] = m.attributes[attr];
                        if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) collapsed = sp;
                    } else if (sp.from > pos && nextChange > sp.from) nextChange = sp.from;
                }
                if (endStyles) {
                    for(var j$1 = 0; j$1 < endStyles.length; j$1 += 2)if (endStyles[j$1 + 1] == nextChange) spanEndStyle += " " + endStyles[j$1];
                }
                if (!collapsed || collapsed.from == pos) for(var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
                if (collapsed && (collapsed.from || 0) == pos) {
                    buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
                    if (collapsed.to == null) return;
                    if (collapsed.to == pos) collapsed = false;
                }
            }
            if (pos >= len) break;
            var upto = Math.min(len, nextChange);
            while(true){
                if (text) {
                    var end = pos + text.length;
                    if (!collapsed) {
                        var tokenText = end > upto ? text.slice(0, upto - pos) : text;
                        builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
                    }
                    if (end >= upto) {
                        text = text.slice(upto - pos);
                        pos = upto;
                        break;
                    }
                    pos = end;
                    spanStartStyle = "";
                }
                text = allText.slice(at, at = styles[i++]);
                style = interpretTokenStyle(styles[i++], builder.cm.options);
            }
        }
    }
    // These objects are used to represent the visible (currently drawn)
    // part of the document. A LineView may correspond to multiple
    // logical lines, if those are connected by collapsed ranges.
    function LineView(doc, line, lineN) {
        // The starting line
        this.line = line;
        // Continuing lines, if any
        this.rest = visualLineContinued(line);
        // Number of logical lines in this visual line
        this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
        this.node = this.text = null;
        this.hidden = lineIsHidden(doc, line);
    }
    // Create a range of LineView objects for the given lines.
    function buildViewArray(cm, from, to) {
        var array = [], nextPos;
        for(var pos = from; pos < to; pos = nextPos){
            var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
            nextPos = pos + view.size;
            array.push(view);
        }
        return array;
    }
    var operationGroup = null;
    function pushOperation(op) {
        if (operationGroup) operationGroup.ops.push(op);
        else op.ownsGroup = operationGroup = {
            ops: [
                op
            ],
            delayedCallbacks: []
        };
    }
    function fireCallbacksForOps(group) {
        // Calls delayed callbacks and cursorActivity handlers until no
        // new ones appear
        var callbacks = group.delayedCallbacks, i = 0;
        do {
            for(; i < callbacks.length; i++)callbacks[i].call(null);
            for(var j = 0; j < group.ops.length; j++){
                var op = group.ops[j];
                if (op.cursorActivityHandlers) while(op.cursorActivityCalled < op.cursorActivityHandlers.length)op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
            }
        }while (i < callbacks.length);
    }
    function finishOperation(op, endCb) {
        var group = op.ownsGroup;
        if (!group) return;
        try {
            fireCallbacksForOps(group);
        } finally{
            operationGroup = null;
            endCb(group);
        }
    }
    var orphanDelayedCallbacks = null;
    // Often, we want to signal events at a point where we are in the
    // middle of some work, but don't want the handler to start calling
    // other methods on the editor, which might be in an inconsistent
    // state or simply not expect any other events to happen.
    // signalLater looks whether there are any handlers, and schedules
    // them to be executed when the last operation ends, or, if no
    // operation is active, when a timeout fires.
    function signalLater(emitter, type /*, values...*/ ) {
        var arr = getHandlers(emitter, type);
        if (!arr.length) return;
        var args = Array.prototype.slice.call(arguments, 2), list;
        if (operationGroup) list = operationGroup.delayedCallbacks;
        else if (orphanDelayedCallbacks) list = orphanDelayedCallbacks;
        else {
            list = orphanDelayedCallbacks = [];
            setTimeout(fireOrphanDelayed, 0);
        }
        var loop = function(i) {
            list.push(function() {
                return arr[i].apply(null, args);
            });
        };
        for(var i = 0; i < arr.length; ++i)loop(i);
    }
    function fireOrphanDelayed() {
        var delayed = orphanDelayedCallbacks;
        orphanDelayedCallbacks = null;
        for(var i = 0; i < delayed.length; ++i)delayed[i]();
    }
    // When an aspect of a line changes, a string is added to
    // lineView.changes. This updates the relevant part of the line's
    // DOM structure.
    function updateLineForChanges(cm, lineView, lineN, dims) {
        for(var j = 0; j < lineView.changes.length; j++){
            var type = lineView.changes[j];
            if (type == "text") updateLineText(cm, lineView);
            else if (type == "gutter") updateLineGutter(cm, lineView, lineN, dims);
            else if (type == "class") updateLineClasses(cm, lineView);
            else if (type == "widget") updateLineWidgets(cm, lineView, dims);
        }
        lineView.changes = null;
    }
    // Lines with gutter elements, widgets or a background class need to
    // be wrapped, and have the extra elements added to the wrapper div
    function ensureLineWrapped(lineView) {
        if (lineView.node == lineView.text) {
            lineView.node = elt("div", null, null, "position: relative");
            if (lineView.text.parentNode) lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
            lineView.node.appendChild(lineView.text);
            if (ie && ie_version < 8) lineView.node.style.zIndex = 2;
        }
        return lineView.node;
    }
    function updateLineBackground(cm, lineView) {
        var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
        if (cls) cls += " CodeMirror-linebackground";
        if (lineView.background) {
            if (cls) lineView.background.className = cls;
            else {
                lineView.background.parentNode.removeChild(lineView.background);
                lineView.background = null;
            }
        } else if (cls) {
            var wrap = ensureLineWrapped(lineView);
            lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
            cm.display.input.setUneditable(lineView.background);
        }
    }
    // Wrapper around buildLineContent which will reuse the structure
    // in display.externalMeasured when possible.
    function getLineContent(cm, lineView) {
        var ext = cm.display.externalMeasured;
        if (ext && ext.line == lineView.line) {
            cm.display.externalMeasured = null;
            lineView.measure = ext.measure;
            return ext.built;
        }
        return buildLineContent(cm, lineView);
    }
    // Redraw the line's text. Interacts with the background and text
    // classes because the mode may output tokens that influence these
    // classes.
    function updateLineText(cm, lineView) {
        var cls = lineView.text.className;
        var built = getLineContent(cm, lineView);
        if (lineView.text == lineView.node) lineView.node = built.pre;
        lineView.text.parentNode.replaceChild(built.pre, lineView.text);
        lineView.text = built.pre;
        if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
            lineView.bgClass = built.bgClass;
            lineView.textClass = built.textClass;
            updateLineClasses(cm, lineView);
        } else if (cls) lineView.text.className = cls;
    }
    function updateLineClasses(cm, lineView) {
        updateLineBackground(cm, lineView);
        if (lineView.line.wrapClass) ensureLineWrapped(lineView).className = lineView.line.wrapClass;
        else if (lineView.node != lineView.text) lineView.node.className = "";
        var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
        lineView.text.className = textClass || "";
    }
    function updateLineGutter(cm, lineView, lineN, dims) {
        if (lineView.gutter) {
            lineView.node.removeChild(lineView.gutter);
            lineView.gutter = null;
        }
        if (lineView.gutterBackground) {
            lineView.node.removeChild(lineView.gutterBackground);
            lineView.gutterBackground = null;
        }
        if (lineView.line.gutterClass) {
            var wrap = ensureLineWrapped(lineView);
            lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
            cm.display.input.setUneditable(lineView.gutterBackground);
            wrap.insertBefore(lineView.gutterBackground, lineView.text);
        }
        var markers = lineView.line.gutterMarkers;
        if (cm.options.lineNumbers || markers) {
            var wrap$1 = ensureLineWrapped(lineView);
            var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
            gutterWrap.setAttribute("aria-hidden", "true");
            cm.display.input.setUneditable(gutterWrap);
            wrap$1.insertBefore(gutterWrap, lineView.text);
            if (lineView.line.gutterClass) gutterWrap.className += " " + lineView.line.gutterClass;
            if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
            if (markers) for(var k = 0; k < cm.display.gutterSpecs.length; ++k){
                var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
                if (found) gutterWrap.appendChild(elt("div", [
                    found
                ], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
            }
        }
    }
    function updateLineWidgets(cm, lineView, dims) {
        if (lineView.alignable) lineView.alignable = null;
        var isWidget = classTest("CodeMirror-linewidget");
        for(var node = lineView.node.firstChild, next = void 0; node; node = next){
            next = node.nextSibling;
            if (isWidget.test(node.className)) lineView.node.removeChild(node);
        }
        insertLineWidgets(cm, lineView, dims);
    }
    // Build a line's DOM representation from scratch
    function buildLineElement(cm, lineView, lineN, dims) {
        var built = getLineContent(cm, lineView);
        lineView.text = lineView.node = built.pre;
        if (built.bgClass) lineView.bgClass = built.bgClass;
        if (built.textClass) lineView.textClass = built.textClass;
        updateLineClasses(cm, lineView);
        updateLineGutter(cm, lineView, lineN, dims);
        insertLineWidgets(cm, lineView, dims);
        return lineView.node;
    }
    // A lineView may contain multiple logical lines (when merged by
    // collapsed spans). The widgets for all of them need to be drawn.
    function insertLineWidgets(cm, lineView, dims) {
        insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
        if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
    }
    function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
        if (!line.widgets) return;
        var wrap = ensureLineWrapped(lineView);
        for(var i = 0, ws = line.widgets; i < ws.length; ++i){
            var widget = ws[i], node = elt("div", [
                widget.node
            ], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
            if (!widget.handleMouseEvents) node.setAttribute("cm-ignore-events", "true");
            positionLineWidget(widget, node, lineView, dims);
            cm.display.input.setUneditable(node);
            if (allowAbove && widget.above) wrap.insertBefore(node, lineView.gutter || lineView.text);
            else wrap.appendChild(node);
            signalLater(widget, "redraw");
        }
    }
    function positionLineWidget(widget, node, lineView, dims) {
        if (widget.noHScroll) {
            (lineView.alignable || (lineView.alignable = [])).push(node);
            var width = dims.wrapperWidth;
            node.style.left = dims.fixedPos + "px";
            if (!widget.coverGutter) {
                width -= dims.gutterTotalWidth;
                node.style.paddingLeft = dims.gutterTotalWidth + "px";
            }
            node.style.width = width + "px";
        }
        if (widget.coverGutter) {
            node.style.zIndex = 5;
            node.style.position = "relative";
            if (!widget.noHScroll) node.style.marginLeft = -dims.gutterTotalWidth + "px";
        }
    }
    function widgetHeight(widget) {
        if (widget.height != null) return widget.height;
        var cm = widget.doc.cm;
        if (!cm) return 0;
        if (!contains(document.body, widget.node)) {
            var parentStyle = "position: relative;";
            if (widget.coverGutter) parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
            if (widget.noHScroll) parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
            removeChildrenAndAdd(cm.display.measure, elt("div", [
                widget.node
            ], null, parentStyle));
        }
        return widget.height = widget.node.parentNode.offsetHeight;
    }
    // Return true when the given mouse event happened in a widget
    function eventInWidget(display, e) {
        for(var n = e_target(e); n != display.wrapper; n = n.parentNode){
            if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) return true;
        }
    }
    // POSITION MEASUREMENT
    function paddingTop(display) {
        return display.lineSpace.offsetTop;
    }
    function paddingVert(display) {
        return display.mover.offsetHeight - display.lineSpace.offsetHeight;
    }
    function paddingH(display) {
        if (display.cachedPaddingH) return display.cachedPaddingH;
        var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
        var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
        var data = {
            left: parseInt(style.paddingLeft),
            right: parseInt(style.paddingRight)
        };
        if (!isNaN(data.left) && !isNaN(data.right)) display.cachedPaddingH = data;
        return data;
    }
    function scrollGap(cm) {
        return scrollerGap - cm.display.nativeBarWidth;
    }
    function displayWidth(cm) {
        return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
    }
    function displayHeight(cm) {
        return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
    }
    // Ensure the lineView.wrapping.heights array is populated. This is
    // an array of bottom offsets for the lines that make up a drawn
    // line. When lineWrapping is on, there might be more than one
    // height.
    function ensureLineHeights(cm, lineView, rect) {
        var wrapping = cm.options.lineWrapping;
        var curWidth = wrapping && displayWidth(cm);
        if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
            var heights = lineView.measure.heights = [];
            if (wrapping) {
                lineView.measure.width = curWidth;
                var rects = lineView.text.firstChild.getClientRects();
                for(var i = 0; i < rects.length - 1; i++){
                    var cur = rects[i], next = rects[i + 1];
                    if (Math.abs(cur.bottom - next.bottom) > 2) heights.push((cur.bottom + next.top) / 2 - rect.top);
                }
            }
            heights.push(rect.bottom - rect.top);
        }
    }
    // Find a line map (mapping character offsets to text nodes) and a
    // measurement cache for the given line number. (A line view might
    // contain multiple lines when collapsed ranges are present.)
    function mapFromLineView(lineView, line, lineN) {
        if (lineView.line == line) return {
            map: lineView.measure.map,
            cache: lineView.measure.cache
        };
        if (lineView.rest) {
            for(var i = 0; i < lineView.rest.length; i++){
                if (lineView.rest[i] == line) return {
                    map: lineView.measure.maps[i],
                    cache: lineView.measure.caches[i]
                };
            }
            for(var i$1 = 0; i$1 < lineView.rest.length; i$1++){
                if (lineNo(lineView.rest[i$1]) > lineN) return {
                    map: lineView.measure.maps[i$1],
                    cache: lineView.measure.caches[i$1],
                    before: true
                };
            }
        }
    }
    // Render a line into the hidden node display.externalMeasured. Used
    // when measurement is needed for a line that's not in the viewport.
    function updateExternalMeasurement(cm, line) {
        line = visualLine(line);
        var lineN = lineNo(line);
        var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
        view.lineN = lineN;
        var built = view.built = buildLineContent(cm, view);
        view.text = built.pre;
        removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
        return view;
    }
    // Get a {top, bottom, left, right} box (in line-local coordinates)
    // for a given character.
    function measureChar(cm, line, ch, bias) {
        return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
    }
    // Find a line view that corresponds to the given line number.
    function findViewForLine(cm, lineN) {
        if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) return cm.display.view[findViewIndex(cm, lineN)];
        var ext = cm.display.externalMeasured;
        if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) return ext;
    }
    // Measurement can be split in two steps, the set-up work that
    // applies to the whole line, and the measurement of the actual
    // character. Functions like coordsChar, that need to do a lot of
    // measurements in a row, can thus ensure that the set-up work is
    // only done once.
    function prepareMeasureForLine(cm, line) {
        var lineN = lineNo(line);
        var view = findViewForLine(cm, lineN);
        if (view && !view.text) view = null;
        else if (view && view.changes) {
            updateLineForChanges(cm, view, lineN, getDimensions(cm));
            cm.curOp.forceUpdate = true;
        }
        if (!view) view = updateExternalMeasurement(cm, line);
        var info = mapFromLineView(view, line, lineN);
        return {
            line: line,
            view: view,
            rect: null,
            map: info.map,
            cache: info.cache,
            before: info.before,
            hasHeights: false
        };
    }
    // Given a prepared measurement object, measures the position of an
    // actual character (or fetches it from the cache).
    function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
        if (prepared.before) ch = -1;
        var key = ch + (bias || ""), found;
        if (prepared.cache.hasOwnProperty(key)) found = prepared.cache[key];
        else {
            if (!prepared.rect) prepared.rect = prepared.view.text.getBoundingClientRect();
            if (!prepared.hasHeights) {
                ensureLineHeights(cm, prepared.view, prepared.rect);
                prepared.hasHeights = true;
            }
            found = measureCharInner(cm, prepared, ch, bias);
            if (!found.bogus) prepared.cache[key] = found;
        }
        return {
            left: found.left,
            right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom
        };
    }
    var nullRect = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    function nodeAndOffsetInLineMap(map, ch, bias) {
        var node, start, end, collapse, mStart, mEnd;
        // First, search the line map for the text node corresponding to,
        // or closest to, the target character.
        for(var i = 0; i < map.length; i += 3){
            mStart = map[i];
            mEnd = map[i + 1];
            if (ch < mStart) {
                start = 0;
                end = 1;
                collapse = "left";
            } else if (ch < mEnd) {
                start = ch - mStart;
                end = start + 1;
            } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
                end = mEnd - mStart;
                start = end - 1;
                if (ch >= mEnd) collapse = "right";
            }
            if (start != null) {
                node = map[i + 2];
                if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) collapse = bias;
                if (bias == "left" && start == 0) while(i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft){
                    node = map[(i -= 3) + 2];
                    collapse = "left";
                }
                if (bias == "right" && start == mEnd - mStart) while(i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft){
                    node = map[(i += 3) + 2];
                    collapse = "right";
                }
                break;
            }
        }
        return {
            node: node,
            start: start,
            end: end,
            collapse: collapse,
            coverStart: mStart,
            coverEnd: mEnd
        };
    }
    function getUsefulRect(rects, bias) {
        var rect = nullRect;
        if (bias == "left") for(var i = 0; i < rects.length; i++){
            if ((rect = rects[i]).left != rect.right) break;
        }
        else for(var i$1 = rects.length - 1; i$1 >= 0; i$1--){
            if ((rect = rects[i$1]).left != rect.right) break;
        }
        return rect;
    }
    function measureCharInner(cm, prepared, ch, bias) {
        var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
        var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
        var rect;
        if (node.nodeType == 3) {
            for(var i$1 = 0; i$1 < 4; i$1++){
                while(start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start)))--start;
                while(place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end)))++end;
                if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) rect = node.parentNode.getBoundingClientRect();
                else rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
                if (rect.left || rect.right || start == 0) break;
                end = start;
                start = start - 1;
                collapse = "right";
            }
            if (ie && ie_version < 11) rect = maybeUpdateRectForZooming(cm.display.measure, rect);
        } else {
            if (start > 0) collapse = bias = "right";
            var rects;
            if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) rect = rects[bias == "right" ? rects.length - 1 : 0];
            else rect = node.getBoundingClientRect();
        }
        if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
            var rSpan = node.parentNode.getClientRects()[0];
            if (rSpan) rect = {
                left: rSpan.left,
                right: rSpan.left + charWidth(cm.display),
                top: rSpan.top,
                bottom: rSpan.bottom
            };
            else rect = nullRect;
        }
        var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
        var mid = (rtop + rbot) / 2;
        var heights = prepared.view.measure.heights;
        var i = 0;
        for(; i < heights.length - 1; i++){
            if (mid < heights[i]) break;
        }
        var top = i ? heights[i - 1] : 0, bot = heights[i];
        var result = {
            left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
            right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
            top: top,
            bottom: bot
        };
        if (!rect.left && !rect.right) result.bogus = true;
        if (!cm.options.singleCursorHeightPerLine) {
            result.rtop = rtop;
            result.rbottom = rbot;
        }
        return result;
    }
    // Work around problem with bounding client rects on ranges being
    // returned incorrectly when zoomed on IE10 and below.
    function maybeUpdateRectForZooming(measure, rect) {
        if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) return rect;
        var scaleX = screen.logicalXDPI / screen.deviceXDPI;
        var scaleY = screen.logicalYDPI / screen.deviceYDPI;
        return {
            left: rect.left * scaleX,
            right: rect.right * scaleX,
            top: rect.top * scaleY,
            bottom: rect.bottom * scaleY
        };
    }
    function clearLineMeasurementCacheFor(lineView) {
        if (lineView.measure) {
            lineView.measure.cache = {};
            lineView.measure.heights = null;
            if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)lineView.measure.caches[i] = {};
        }
    }
    function clearLineMeasurementCache(cm) {
        cm.display.externalMeasure = null;
        removeChildren(cm.display.lineMeasure);
        for(var i = 0; i < cm.display.view.length; i++)clearLineMeasurementCacheFor(cm.display.view[i]);
    }
    function clearCaches(cm) {
        clearLineMeasurementCache(cm);
        cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
        if (!cm.options.lineWrapping) cm.display.maxLineChanged = true;
        cm.display.lineNumChars = null;
    }
    function pageScrollX(doc) {
        // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
        // which causes page_Offset and bounding client rects to use
        // different reference viewports and invalidate our calculations.
        if (chrome && android) return -(doc.body.getBoundingClientRect().left - parseInt(getComputedStyle(doc.body).marginLeft));
        return doc.defaultView.pageXOffset || (doc.documentElement || doc.body).scrollLeft;
    }
    function pageScrollY(doc) {
        if (chrome && android) return -(doc.body.getBoundingClientRect().top - parseInt(getComputedStyle(doc.body).marginTop));
        return doc.defaultView.pageYOffset || (doc.documentElement || doc.body).scrollTop;
    }
    function widgetTopHeight(lineObj) {
        var ref = visualLine(lineObj);
        var widgets = ref.widgets;
        var height = 0;
        if (widgets) {
            for(var i = 0; i < widgets.length; ++i)if (widgets[i].above) height += widgetHeight(widgets[i]);
        }
        return height;
    }
    // Converts a {top, bottom, left, right} box from line-local
    // coordinates into another coordinate system. Context may be one of
    // "line", "div" (display.lineDiv), "local"./null (editor), "window",
    // or "page".
    function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
        if (!includeWidgets) {
            var height = widgetTopHeight(lineObj);
            rect.top += height;
            rect.bottom += height;
        }
        if (context == "line") return rect;
        if (!context) context = "local";
        var yOff = heightAtLine(lineObj);
        if (context == "local") yOff += paddingTop(cm.display);
        else yOff -= cm.display.viewOffset;
        if (context == "page" || context == "window") {
            var lOff = cm.display.lineSpace.getBoundingClientRect();
            yOff += lOff.top + (context == "window" ? 0 : pageScrollY(doc(cm)));
            var xOff = lOff.left + (context == "window" ? 0 : pageScrollX(doc(cm)));
            rect.left += xOff;
            rect.right += xOff;
        }
        rect.top += yOff;
        rect.bottom += yOff;
        return rect;
    }
    // Coverts a box from "div" coords to another coordinate system.
    // Context may be "window", "page", "div", or "local"./null.
    function fromCoordSystem(cm, coords, context) {
        if (context == "div") return coords;
        var left = coords.left, top = coords.top;
        // First move into "page" coordinate system
        if (context == "page") {
            left -= pageScrollX(doc(cm));
            top -= pageScrollY(doc(cm));
        } else if (context == "local" || !context) {
            var localBox = cm.display.sizer.getBoundingClientRect();
            left += localBox.left;
            top += localBox.top;
        }
        var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
        return {
            left: left - lineSpaceBox.left,
            top: top - lineSpaceBox.top
        };
    }
    function charCoords(cm, pos, context, lineObj, bias) {
        if (!lineObj) lineObj = getLine(cm.doc, pos.line);
        return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
    }
    // Returns a box for a given cursor position, which may have an
    // 'other' property containing the position of the secondary cursor
    // on a bidi boundary.
    // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
    // and after `char - 1` in writing order of `char - 1`
    // A cursor Pos(line, char, "after") is on the same visual line as `char`
    // and before `char` in writing order of `char`
    // Examples (upper-case letters are RTL, lower-case are LTR):
    //     Pos(0, 1, ...)
    //     before   after
    // ab     a|b     a|b
    // aB     a|B     aB|
    // Ab     |Ab     A|b
    // AB     B|A     B|A
    // Every position after the last character on a line is considered to stick
    // to the last character on the line.
    function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
        lineObj = lineObj || getLine(cm.doc, pos.line);
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        function get(ch, right) {
            var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
            if (right) m.left = m.right;
            else m.right = m.left;
            return intoCoordSystem(cm, lineObj, m, context);
        }
        var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
        if (ch >= lineObj.text.length) {
            ch = lineObj.text.length;
            sticky = "before";
        } else if (ch <= 0) {
            ch = 0;
            sticky = "after";
        }
        if (!order) return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
        function getBidi(ch, partPos, invert) {
            var part = order[partPos], right = part.level == 1;
            return get(invert ? ch - 1 : ch, right != invert);
        }
        var partPos = getBidiPartAt(order, ch, sticky);
        var other = bidiOther;
        var val = getBidi(ch, partPos, sticky == "before");
        if (other != null) val.other = getBidi(ch, other, sticky != "before");
        return val;
    }
    // Used to cheaply estimate the coordinates for a position. Used for
    // intermediate scroll updates.
    function estimateCoords(cm, pos) {
        var left = 0;
        pos = clipPos(cm.doc, pos);
        if (!cm.options.lineWrapping) left = charWidth(cm.display) * pos.ch;
        var lineObj = getLine(cm.doc, pos.line);
        var top = heightAtLine(lineObj) + paddingTop(cm.display);
        return {
            left: left,
            right: left,
            top: top,
            bottom: top + lineObj.height
        };
    }
    // Positions returned by coordsChar contain some extra information.
    // xRel is the relative x position of the input coordinates compared
    // to the found position (so xRel > 0 means the coordinates are to
    // the right of the character position, for example). When outside
    // is true, that means the coordinates lie outside the line's
    // vertical range.
    function PosWithInfo(line, ch, sticky, outside, xRel) {
        var pos = Pos(line, ch, sticky);
        pos.xRel = xRel;
        if (outside) pos.outside = outside;
        return pos;
    }
    // Compute the character position closest to the given coordinates.
    // Input must be lineSpace-local ("div" coordinate system).
    function coordsChar(cm, x, y) {
        var doc = cm.doc;
        y += cm.display.viewOffset;
        if (y < 0) return PosWithInfo(doc.first, 0, null, -1, -1);
        var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
        if (lineN > last) return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1);
        if (x < 0) x = 0;
        var lineObj = getLine(doc, lineN);
        for(;;){
            var found = coordsCharInner(cm, lineObj, lineN, x, y);
            var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
            if (!collapsed) return found;
            var rangeEnd = collapsed.find(1);
            if (rangeEnd.line == lineN) return rangeEnd;
            lineObj = getLine(doc, lineN = rangeEnd.line);
        }
    }
    function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
        y -= widgetTopHeight(lineObj);
        var end = lineObj.text.length;
        var begin = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
        }, end, 0);
        end = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch).top > y;
        }, begin, end);
        return {
            begin: begin,
            end: end
        };
    }
    function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
        return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
    }
    // Returns true if the given side of a box is after the given
    // coordinates, in top-to-bottom, left-to-right order.
    function boxIsAfter(box, x, y, left) {
        return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
    }
    function coordsCharInner(cm, lineObj, lineNo, x, y) {
        // Move y into line-local coordinate space
        y -= heightAtLine(lineObj);
        var preparedMeasure = prepareMeasureForLine(cm, lineObj);
        // When directly calling `measureCharPrepared`, we have to adjust
        // for the widgets at this line.
        var widgetHeight = widgetTopHeight(lineObj);
        var begin = 0, end = lineObj.text.length, ltr = true;
        var order = getOrder(lineObj, cm.doc.direction);
        // If the line isn't plain left-to-right text, first figure out
        // which bidi section the coordinates fall into.
        if (order) {
            var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo, preparedMeasure, order, x, y);
            ltr = part.level != 1;
            // The awkward -1 offsets are needed because findFirst (called
            // on these below) will treat its first bound as inclusive,
            // second as exclusive, but we want to actually address the
            // characters in the part's range
            begin = ltr ? part.from : part.to - 1;
            end = ltr ? part.to : part.from - 1;
        }
        // A binary search to find the first character whose bounding box
        // starts after the coordinates. If we run across any whose box wrap
        // the coordinates, store that.
        var chAround = null, boxAround = null;
        var ch = findFirst(function(ch) {
            var box = measureCharPrepared(cm, preparedMeasure, ch);
            box.top += widgetHeight;
            box.bottom += widgetHeight;
            if (!boxIsAfter(box, x, y, false)) return false;
            if (box.top <= y && box.left <= x) {
                chAround = ch;
                boxAround = box;
            }
            return true;
        }, begin, end);
        var baseX, sticky, outside = false;
        // If a box around the coordinates was found, use that
        if (boxAround) {
            // Distinguish coordinates nearer to the left or right side of the box
            var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
            ch = chAround + (atStart ? 0 : 1);
            sticky = atStart ? "after" : "before";
            baseX = atLeft ? boxAround.left : boxAround.right;
        } else {
            // (Adjust for extended bound, if necessary.)
            if (!ltr && (ch == end || ch == begin)) ch++;
            // To determine which side to associate with, get the box to the
            // left of the character and compare it's vertical position to the
            // coordinates
            sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y == ltr ? "after" : "before";
            // Now get accurate coordinates for this place, in order to get a
            // base X position
            var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
            baseX = coords.left;
            outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
        }
        ch = skipExtendingChars(lineObj.text, ch, 1);
        return PosWithInfo(lineNo, ch, sticky, outside, x - baseX);
    }
    function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
        // Bidi parts are sorted left-to-right, and in a non-line-wrapping
        // situation, we can take this ordering to correspond to the visual
        // ordering. This finds the first part whose end is after the given
        // coordinates.
        var index = findFirst(function(i) {
            var part = order[i], ltr = part.level != 1;
            return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
        }, 0, order.length - 1);
        var part = order[index];
        // If this isn't the first part, the part's start is also after
        // the coordinates, and the coordinates aren't on the same line as
        // that start, move one part back.
        if (index > 0) {
            var ltr = part.level != 1;
            var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
            if (boxIsAfter(start, x, y, true) && start.top > y) part = order[index - 1];
        }
        return part;
    }
    function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
        // In a wrapped line, rtl text on wrapping boundaries can do things
        // that don't correspond to the ordering in our `order` array at
        // all, so a binary search doesn't work, and we want to return a
        // part that only spans one line so that the binary search in
        // coordsCharInner is safe. As such, we first find the extent of the
        // wrapped line, and then do a flat search in which we discard any
        // spans that aren't on the line.
        var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
        var begin = ref.begin;
        var end = ref.end;
        if (/\s/.test(lineObj.text.charAt(end - 1))) end--;
        var part = null, closestDist = null;
        for(var i = 0; i < order.length; i++){
            var p = order[i];
            if (p.from >= end || p.to <= begin) continue;
            var ltr = p.level != 1;
            var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
            // Weigh against spans ending before this, so that they are only
            // picked if nothing ends after
            var dist = endX < x ? x - endX + 1e9 : endX - x;
            if (!part || closestDist > dist) {
                part = p;
                closestDist = dist;
            }
        }
        if (!part) part = order[order.length - 1];
        // Clip the part to the wrapped line.
        if (part.from < begin) part = {
            from: begin,
            to: part.to,
            level: part.level
        };
        if (part.to > end) part = {
            from: part.from,
            to: end,
            level: part.level
        };
        return part;
    }
    var measureText;
    // Compute the default text height.
    function textHeight(display) {
        if (display.cachedTextHeight != null) return display.cachedTextHeight;
        if (measureText == null) {
            measureText = elt("pre", null, "CodeMirror-line-like");
            // Measure a bunch of lines, for browsers that compute
            // fractional heights.
            for(var i = 0; i < 49; ++i){
                measureText.appendChild(document.createTextNode("x"));
                measureText.appendChild(elt("br"));
            }
            measureText.appendChild(document.createTextNode("x"));
        }
        removeChildrenAndAdd(display.measure, measureText);
        var height = measureText.offsetHeight / 50;
        if (height > 3) display.cachedTextHeight = height;
        removeChildren(display.measure);
        return height || 1;
    }
    // Compute the default character width.
    function charWidth(display) {
        if (display.cachedCharWidth != null) return display.cachedCharWidth;
        var anchor = elt("span", "xxxxxxxxxx");
        var pre = elt("pre", [
            anchor
        ], "CodeMirror-line-like");
        removeChildrenAndAdd(display.measure, pre);
        var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
        if (width > 2) display.cachedCharWidth = width;
        return width || 10;
    }
    // Do a bulk-read of the DOM positions and sizes needed to draw the
    // view, so that we don't interleave reading and writing to the DOM.
    function getDimensions(cm) {
        var d = cm.display, left = {}, width = {};
        var gutterLeft = d.gutters.clientLeft;
        for(var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i){
            var id = cm.display.gutterSpecs[i].className;
            left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
            width[id] = n.clientWidth;
        }
        return {
            fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth
        };
    }
    // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
    // but using getBoundingClientRect to get a sub-pixel-accurate
    // result.
    function compensateForHScroll(display) {
        return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
    }
    // Returns a function that estimates the height of a line, to use as
    // first approximation until the line becomes visible (and is thus
    // properly measurable).
    function estimateHeight(cm) {
        var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
        var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
        return function(line) {
            if (lineIsHidden(cm.doc, line)) return 0;
            var widgetsHeight = 0;
            if (line.widgets) {
                for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].height) widgetsHeight += line.widgets[i].height;
            }
            if (wrapping) return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
            else return widgetsHeight + th;
        };
    }
    function estimateLineHeights(cm) {
        var doc = cm.doc, est = estimateHeight(cm);
        doc.iter(function(line) {
            var estHeight = est(line);
            if (estHeight != line.height) updateLineHeight(line, estHeight);
        });
    }
    // Given a mouse event, find the corresponding position. If liberal
    // is false, it checks whether a gutter or scrollbar was clicked,
    // and returns null if it was. forRect is used by rectangular
    // selections, and tries to estimate a character position even for
    // coordinates beyond the right of the text.
    function posFromMouse(cm, e, liberal, forRect) {
        var display = cm.display;
        if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") return null;
        var x, y, space = display.lineSpace.getBoundingClientRect();
        // Fails unpredictably on IE[67] when mouse is dragged around quickly.
        try {
            x = e.clientX - space.left;
            y = e.clientY - space.top;
        } catch (e$1) {
            return null;
        }
        var coords = coordsChar(cm, x, y), line;
        if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
            var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
            coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
        }
        return coords;
    }
    // Find the view element corresponding to a given line. Return null
    // when the line isn't visible.
    function findViewIndex(cm, n) {
        if (n >= cm.display.viewTo) return null;
        n -= cm.display.viewFrom;
        if (n < 0) return null;
        var view = cm.display.view;
        for(var i = 0; i < view.length; i++){
            n -= view[i].size;
            if (n < 0) return i;
        }
    }
    // Updates the display.view data structure for a given change to the
    // document. From and to are in pre-change coordinates. Lendiff is
    // the amount of lines added or subtracted by the change. This is
    // used for changes that span multiple lines, or change the way
    // lines are divided into visual lines. regLineChange (below)
    // registers single-line changes.
    function regChange(cm, from, to, lendiff) {
        if (from == null) from = cm.doc.first;
        if (to == null) to = cm.doc.first + cm.doc.size;
        if (!lendiff) lendiff = 0;
        var display = cm.display;
        if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) display.updateLineNumbers = from;
        cm.curOp.viewChanged = true;
        if (from >= display.viewTo) {
            if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) resetView(cm);
        } else if (to <= display.viewFrom) {
            if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) resetView(cm);
            else {
                display.viewFrom += lendiff;
                display.viewTo += lendiff;
            }
        } else if (from <= display.viewFrom && to >= display.viewTo) resetView(cm);
        else if (from <= display.viewFrom) {
            var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cut) {
                display.view = display.view.slice(cut.index);
                display.viewFrom = cut.lineN;
                display.viewTo += lendiff;
            } else resetView(cm);
        } else if (to >= display.viewTo) {
            var cut$1 = viewCuttingPoint(cm, from, from, -1);
            if (cut$1) {
                display.view = display.view.slice(0, cut$1.index);
                display.viewTo = cut$1.lineN;
            } else resetView(cm);
        } else {
            var cutTop = viewCuttingPoint(cm, from, from, -1);
            var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cutTop && cutBot) {
                display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
                display.viewTo += lendiff;
            } else resetView(cm);
        }
        var ext = display.externalMeasured;
        if (ext) {
            if (to < ext.lineN) ext.lineN += lendiff;
            else if (from < ext.lineN + ext.size) display.externalMeasured = null;
        }
    }
    // Register a change to a single line. Type must be one of "text",
    // "gutter", "class", "widget"
    function regLineChange(cm, line, type) {
        cm.curOp.viewChanged = true;
        var display = cm.display, ext = cm.display.externalMeasured;
        if (ext && line >= ext.lineN && line < ext.lineN + ext.size) display.externalMeasured = null;
        if (line < display.viewFrom || line >= display.viewTo) return;
        var lineView = display.view[findViewIndex(cm, line)];
        if (lineView.node == null) return;
        var arr = lineView.changes || (lineView.changes = []);
        if (indexOf(arr, type) == -1) arr.push(type);
    }
    // Clear the view.
    function resetView(cm) {
        cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
        cm.display.view = [];
        cm.display.viewOffset = 0;
    }
    function viewCuttingPoint(cm, oldN, newN, dir) {
        var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
        if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) return {
            index: index,
            lineN: newN
        };
        var n = cm.display.viewFrom;
        for(var i = 0; i < index; i++)n += view[i].size;
        if (n != oldN) {
            if (dir > 0) {
                if (index == view.length - 1) return null;
                diff = n + view[index].size - oldN;
                index++;
            } else diff = n - oldN;
            oldN += diff;
            newN += diff;
        }
        while(visualLineNo(cm.doc, newN) != newN){
            if (index == (dir < 0 ? 0 : view.length - 1)) return null;
            newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
            index += dir;
        }
        return {
            index: index,
            lineN: newN
        };
    }
    // Force the view to cover a given range, adding empty view element
    // or clipping off existing ones as needed.
    function adjustView(cm, from, to) {
        var display = cm.display, view = display.view;
        if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
            display.view = buildViewArray(cm, from, to);
            display.viewFrom = from;
        } else {
            if (display.viewFrom > from) display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
            else if (display.viewFrom < from) display.view = display.view.slice(findViewIndex(cm, from));
            display.viewFrom = from;
            if (display.viewTo < to) display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
            else if (display.viewTo > to) display.view = display.view.slice(0, findViewIndex(cm, to));
        }
        display.viewTo = to;
    }
    // Count the number of lines in the view whose DOM representation is
    // out of date (or nonexistent).
    function countDirtyView(cm) {
        var view = cm.display.view, dirty = 0;
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (!lineView.hidden && (!lineView.node || lineView.changes)) ++dirty;
        }
        return dirty;
    }
    function updateSelection(cm) {
        cm.display.input.showSelection(cm.display.input.prepareSelection());
    }
    function prepareSelection(cm, primary) {
        if (primary === void 0) primary = true;
        var doc = cm.doc, result = {};
        var curFragment = result.cursors = document.createDocumentFragment();
        var selFragment = result.selection = document.createDocumentFragment();
        var customCursor = cm.options.$customCursor;
        if (customCursor) primary = true;
        for(var i = 0; i < doc.sel.ranges.length; i++){
            if (!primary && i == doc.sel.primIndex) continue;
            var range = doc.sel.ranges[i];
            if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) continue;
            var collapsed = range.empty();
            if (customCursor) {
                var head = customCursor(cm, range);
                if (head) drawSelectionCursor(cm, head, curFragment);
            } else if (collapsed || cm.options.showCursorWhenSelecting) drawSelectionCursor(cm, range.head, curFragment);
            if (!collapsed) drawSelectionRange(cm, range, selFragment);
        }
        return result;
    }
    // Draws a cursor for the given range
    function drawSelectionCursor(cm, head, output) {
        var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
        var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
        cursor.style.left = pos.left + "px";
        cursor.style.top = pos.top + "px";
        cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
        if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
            var charPos = charCoords(cm, head, "div", null, null);
            var width = charPos.right - charPos.left;
            cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
        }
        if (pos.other) {
            // Secondary cursor, shown when on a 'jump' in bi-directional text
            var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
            otherCursor.style.display = "";
            otherCursor.style.left = pos.other.left + "px";
            otherCursor.style.top = pos.other.top + "px";
            otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
        }
    }
    function cmpCoords(a, b) {
        return a.top - b.top || a.left - b.left;
    }
    // Draws the given range as a highlighted selection
    function drawSelectionRange(cm, range, output) {
        var display = cm.display, doc = cm.doc;
        var fragment = document.createDocumentFragment();
        var padding = paddingH(cm.display), leftSide = padding.left;
        var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
        var docLTR = doc.direction == "ltr";
        function add(left, top, width, bottom) {
            if (top < 0) top = 0;
            top = Math.round(top);
            bottom = Math.round(bottom);
            fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
        }
        function drawForLine(line, fromArg, toArg) {
            var lineObj = getLine(doc, line);
            var lineLen = lineObj.text.length;
            var start, end;
            function coords(ch, bias) {
                return charCoords(cm, Pos(line, ch), "div", lineObj, bias);
            }
            function wrapX(pos, dir, side) {
                var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
                var prop = dir == "ltr" == (side == "after") ? "left" : "right";
                var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
                return coords(ch, prop)[prop];
            }
            var order = getOrder(lineObj, doc.direction);
            iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function(from, to, dir, i) {
                var ltr = dir == "ltr";
                var fromPos = coords(from, ltr ? "left" : "right");
                var toPos = coords(to - 1, ltr ? "right" : "left");
                var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
                var first = i == 0, last = !order || i == order.length - 1;
                if (toPos.top - fromPos.top <= 3) {
                    var openLeft = (docLTR ? openStart : openEnd) && first;
                    var openRight = (docLTR ? openEnd : openStart) && last;
                    var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
                    var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
                    add(left, fromPos.top, right - left, fromPos.bottom);
                } else {
                    var topLeft, topRight, botLeft, botRight;
                    if (ltr) {
                        topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
                        topRight = docLTR ? rightSide : wrapX(from, dir, "before");
                        botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
                        botRight = docLTR && openEnd && last ? rightSide : toPos.right;
                    } else {
                        topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
                        topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
                        botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
                        botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
                    }
                    add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
                    if (fromPos.bottom < toPos.top) add(leftSide, fromPos.bottom, null, toPos.top);
                    add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
                }
                if (!start || cmpCoords(fromPos, start) < 0) start = fromPos;
                if (cmpCoords(toPos, start) < 0) start = toPos;
                if (!end || cmpCoords(fromPos, end) < 0) end = fromPos;
                if (cmpCoords(toPos, end) < 0) end = toPos;
            });
            return {
                start: start,
                end: end
            };
        }
        var sFrom = range.from(), sTo = range.to();
        if (sFrom.line == sTo.line) drawForLine(sFrom.line, sFrom.ch, sTo.ch);
        else {
            var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
            var singleVLine = visualLine(fromLine) == visualLine(toLine);
            var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
            var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
            if (singleVLine) {
                if (leftEnd.top < rightStart.top - 2) {
                    add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
                    add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
                } else add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
            }
            if (leftEnd.bottom < rightStart.top) add(leftSide, leftEnd.bottom, null, rightStart.top);
        }
        output.appendChild(fragment);
    }
    // Cursor-blinking
    function restartBlink(cm) {
        if (!cm.state.focused) return;
        var display = cm.display;
        clearInterval(display.blinker);
        var on = true;
        display.cursorDiv.style.visibility = "";
        if (cm.options.cursorBlinkRate > 0) display.blinker = setInterval(function() {
            if (!cm.hasFocus()) onBlur(cm);
            display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
        }, cm.options.cursorBlinkRate);
        else if (cm.options.cursorBlinkRate < 0) display.cursorDiv.style.visibility = "hidden";
    }
    function ensureFocus(cm) {
        if (!cm.hasFocus()) {
            cm.display.input.focus();
            if (!cm.state.focused) onFocus(cm);
        }
    }
    function delayBlurEvent(cm) {
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            if (cm.state.delayingBlurEvent) {
                cm.state.delayingBlurEvent = false;
                if (cm.state.focused) onBlur(cm);
            }
        }, 100);
    }
    function onFocus(cm, e) {
        if (cm.state.delayingBlurEvent && !cm.state.draggingText) cm.state.delayingBlurEvent = false;
        if (cm.options.readOnly == "nocursor") return;
        if (!cm.state.focused) {
            signal(cm, "focus", cm, e);
            cm.state.focused = true;
            addClass(cm.display.wrapper, "CodeMirror-focused");
            // This test prevents this from firing when a context
            // menu is closed (since the input reset would kill the
            // select-all detection hack)
            if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
                cm.display.input.reset();
                if (webkit) setTimeout(function() {
                    return cm.display.input.reset(true);
                }, 20);
                 // Issue #1730
            }
            cm.display.input.receivedFocus();
        }
        restartBlink(cm);
    }
    function onBlur(cm, e) {
        if (cm.state.delayingBlurEvent) return;
        if (cm.state.focused) {
            signal(cm, "blur", cm, e);
            cm.state.focused = false;
            rmClass(cm.display.wrapper, "CodeMirror-focused");
        }
        clearInterval(cm.display.blinker);
        setTimeout(function() {
            if (!cm.state.focused) cm.display.shift = false;
        }, 150);
    }
    // Read the actual heights of the rendered lines, and update their
    // stored heights to match.
    function updateHeightsInViewport(cm) {
        var display = cm.display;
        var prevBottom = display.lineDiv.offsetTop;
        var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
        var oldHeight = display.lineDiv.getBoundingClientRect().top;
        var mustScroll = 0;
        for(var i = 0; i < display.view.length; i++){
            var cur = display.view[i], wrapping = cm.options.lineWrapping;
            var height = void 0, width = 0;
            if (cur.hidden) continue;
            oldHeight += cur.line.height;
            if (ie && ie_version < 8) {
                var bot = cur.node.offsetTop + cur.node.offsetHeight;
                height = bot - prevBottom;
                prevBottom = bot;
            } else {
                var box = cur.node.getBoundingClientRect();
                height = box.bottom - box.top;
                // Check that lines don't extend past the right of the current
                // editor width
                if (!wrapping && cur.text.firstChild) width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
            }
            var diff = cur.line.height - height;
            if (diff > .005 || diff < -0.005) {
                if (oldHeight < viewTop) mustScroll -= diff;
                updateLineHeight(cur.line, height);
                updateWidgetHeight(cur.line);
                if (cur.rest) for(var j = 0; j < cur.rest.length; j++)updateWidgetHeight(cur.rest[j]);
            }
            if (width > cm.display.sizerWidth) {
                var chWidth = Math.ceil(width / charWidth(cm.display));
                if (chWidth > cm.display.maxLineLength) {
                    cm.display.maxLineLength = chWidth;
                    cm.display.maxLine = cur.line;
                    cm.display.maxLineChanged = true;
                }
            }
        }
        if (Math.abs(mustScroll) > 2) display.scroller.scrollTop += mustScroll;
    }
    // Read and store the height of line widgets associated with the
    // given line.
    function updateWidgetHeight(line) {
        if (line.widgets) for(var i = 0; i < line.widgets.length; ++i){
            var w = line.widgets[i], parent = w.node.parentNode;
            if (parent) w.height = parent.offsetHeight;
        }
    }
    // Compute the lines that are visible in a given viewport (defaults
    // the the current scroll position). viewport may contain top,
    // height, and ensure (see op.scrollToPos) properties.
    function visibleLines(display, doc, viewport) {
        var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
        top = Math.floor(top - paddingTop(display));
        var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
        var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
        // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
        // forces those lines into the viewport (if possible).
        if (viewport && viewport.ensure) {
            var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
            if (ensureFrom < from) {
                from = ensureFrom;
                to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
            } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
                from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
                to = ensureTo;
            }
        }
        return {
            from: from,
            to: Math.max(to, from + 1)
        };
    }
    // SCROLLING THINGS INTO VIEW
    // If an editor sits on the top or bottom of the window, partially
    // scrolled out of view, this ensures that the cursor is visible.
    function maybeScrollWindow(cm, rect) {
        if (signalDOMEvent(cm, "scrollCursorIntoView")) return;
        var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
        var doc = display.wrapper.ownerDocument;
        if (rect.top + box.top < 0) doScroll = true;
        else if (rect.bottom + box.top > (doc.defaultView.innerHeight || doc.documentElement.clientHeight)) doScroll = false;
        if (doScroll != null && !phantom) {
            var scrollNode = elt("div", "\u200b", null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
            cm.display.lineSpace.appendChild(scrollNode);
            scrollNode.scrollIntoView(doScroll);
            cm.display.lineSpace.removeChild(scrollNode);
        }
    }
    // Scroll a given position into view (immediately), verifying that
    // it actually became visible (as line heights are accurately
    // measured, the position of something may 'drift' during drawing).
    function scrollPosIntoView(cm, pos, end, margin) {
        if (margin == null) margin = 0;
        var rect;
        if (!cm.options.lineWrapping && pos == end) {
            // Set pos and end to the cursor positions around the character pos sticks to
            // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
            // If pos == Pos(_, 0, "before"), pos and end are unchanged
            end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
            pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
        }
        for(var limit = 0; limit < 5; limit++){
            var changed = false;
            var coords = cursorCoords(cm, pos);
            var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
            rect = {
                left: Math.min(coords.left, endCoords.left),
                top: Math.min(coords.top, endCoords.top) - margin,
                right: Math.max(coords.left, endCoords.left),
                bottom: Math.max(coords.bottom, endCoords.bottom) + margin
            };
            var scrollPos = calculateScrollPos(cm, rect);
            var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
            if (scrollPos.scrollTop != null) {
                updateScrollTop(cm, scrollPos.scrollTop);
                if (Math.abs(cm.doc.scrollTop - startTop) > 1) changed = true;
            }
            if (scrollPos.scrollLeft != null) {
                setScrollLeft(cm, scrollPos.scrollLeft);
                if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) changed = true;
            }
            if (!changed) break;
        }
        return rect;
    }
    // Scroll a given set of coordinates into view (immediately).
    function scrollIntoView(cm, rect) {
        var scrollPos = calculateScrollPos(cm, rect);
        if (scrollPos.scrollTop != null) updateScrollTop(cm, scrollPos.scrollTop);
        if (scrollPos.scrollLeft != null) setScrollLeft(cm, scrollPos.scrollLeft);
    }
    // Calculate a new scroll position needed to scroll the given
    // rectangle into view. Returns an object with scrollTop and
    // scrollLeft properties. When these are undefined, the
    // vertical/horizontal position does not need to be adjusted.
    function calculateScrollPos(cm, rect) {
        var display = cm.display, snapMargin = textHeight(cm.display);
        if (rect.top < 0) rect.top = 0;
        var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
        var screen1 = displayHeight(cm), result = {};
        if (rect.bottom - rect.top > screen1) rect.bottom = rect.top + screen1;
        var docBottom = cm.doc.height + paddingVert(display);
        var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
        if (rect.top < screentop) result.scrollTop = atTop ? 0 : rect.top;
        else if (rect.bottom > screentop + screen1) {
            var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen1);
            if (newTop != screentop) result.scrollTop = newTop;
        }
        var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
        var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
        var screenw = displayWidth(cm) - display.gutters.offsetWidth;
        var tooWide = rect.right - rect.left > screenw;
        if (tooWide) rect.right = rect.left + screenw;
        if (rect.left < 10) result.scrollLeft = 0;
        else if (rect.left < screenleft) result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10));
        else if (rect.right > screenw + screenleft - 3) result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
        return result;
    }
    // Store a relative adjustment to the scroll position in the current
    // operation (to be applied when the operation finishes).
    function addToScrollTop(cm, top) {
        if (top == null) return;
        resolveScrollToPos(cm);
        cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
    }
    // Make sure that at the end of the operation the current cursor is
    // shown.
    function ensureCursorVisible(cm) {
        resolveScrollToPos(cm);
        var cur = cm.getCursor();
        cm.curOp.scrollToPos = {
            from: cur,
            to: cur,
            margin: cm.options.cursorScrollMargin
        };
    }
    function scrollToCoords(cm, x, y) {
        if (x != null || y != null) resolveScrollToPos(cm);
        if (x != null) cm.curOp.scrollLeft = x;
        if (y != null) cm.curOp.scrollTop = y;
    }
    function scrollToRange(cm, range) {
        resolveScrollToPos(cm);
        cm.curOp.scrollToPos = range;
    }
    // When an operation has its scrollToPos property set, and another
    // scroll action is applied before the end of the operation, this
    // 'simulates' scrolling that position into view in a cheap way, so
    // that the effect of intermediate scroll commands is not ignored.
    function resolveScrollToPos(cm) {
        var range = cm.curOp.scrollToPos;
        if (range) {
            cm.curOp.scrollToPos = null;
            var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
            scrollToCoordsRange(cm, from, to, range.margin);
        }
    }
    function scrollToCoordsRange(cm, from, to, margin) {
        var sPos = calculateScrollPos(cm, {
            left: Math.min(from.left, to.left),
            top: Math.min(from.top, to.top) - margin,
            right: Math.max(from.right, to.right),
            bottom: Math.max(from.bottom, to.bottom) + margin
        });
        scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
    }
    // Sync the scrollable area and scrollbars, ensure the viewport
    // covers the visible area.
    function updateScrollTop(cm, val) {
        if (Math.abs(cm.doc.scrollTop - val) < 2) return;
        if (!gecko) updateDisplaySimple(cm, {
            top: val
        });
        setScrollTop(cm, val, true);
        if (gecko) updateDisplaySimple(cm);
        startWorker(cm, 100);
    }
    function setScrollTop(cm, val, forceScroll) {
        val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
        if (cm.display.scroller.scrollTop == val && !forceScroll) return;
        cm.doc.scrollTop = val;
        cm.display.scrollbars.setScrollTop(val);
        if (cm.display.scroller.scrollTop != val) cm.display.scroller.scrollTop = val;
    }
    // Sync scroller and scrollbar, ensure the gutter elements are
    // aligned.
    function setScrollLeft(cm, val, isScroller, forceScroll) {
        val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
        if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) return;
        cm.doc.scrollLeft = val;
        alignHorizontally(cm);
        if (cm.display.scroller.scrollLeft != val) cm.display.scroller.scrollLeft = val;
        cm.display.scrollbars.setScrollLeft(val);
    }
    // SCROLLBARS
    // Prepare DOM reads needed to update the scrollbars. Done in one
    // shot to minimize update/measure roundtrips.
    function measureForScrollbars(cm) {
        var d = cm.display, gutterW = d.gutters.offsetWidth;
        var docH = Math.round(cm.doc.height + paddingVert(cm.display));
        return {
            clientHeight: d.scroller.clientHeight,
            viewHeight: d.wrapper.clientHeight,
            scrollWidth: d.scroller.scrollWidth,
            clientWidth: d.scroller.clientWidth,
            viewWidth: d.wrapper.clientWidth,
            barLeft: cm.options.fixedGutter ? gutterW : 0,
            docHeight: docH,
            scrollHeight: docH + scrollGap(cm) + d.barHeight,
            nativeBarWidth: d.nativeBarWidth,
            gutterWidth: gutterW
        };
    }
    var NativeScrollbars = function(place, scroll, cm) {
        this.cm = cm;
        var vert = this.vert = elt("div", [
            elt("div", null, null, "min-width: 1px")
        ], "CodeMirror-vscrollbar");
        var horiz = this.horiz = elt("div", [
            elt("div", null, null, "height: 100%; min-height: 1px")
        ], "CodeMirror-hscrollbar");
        vert.tabIndex = horiz.tabIndex = -1;
        place(vert);
        place(horiz);
        on(vert, "scroll", function() {
            if (vert.clientHeight) scroll(vert.scrollTop, "vertical");
        });
        on(horiz, "scroll", function() {
            if (horiz.clientWidth) scroll(horiz.scrollLeft, "horizontal");
        });
        this.checkedZeroWidth = false;
        // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
        if (ie && ie_version < 8) this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
    };
    NativeScrollbars.prototype.update = function(measure) {
        var needsH = measure.scrollWidth > measure.clientWidth + 1;
        var needsV = measure.scrollHeight > measure.clientHeight + 1;
        var sWidth = measure.nativeBarWidth;
        if (needsV) {
            this.vert.style.display = "block";
            this.vert.style.bottom = needsH ? sWidth + "px" : "0";
            var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
            // A bug in IE8 can cause this value to be negative, so guard it.
            this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
        } else {
            this.vert.scrollTop = 0;
            this.vert.style.display = "";
            this.vert.firstChild.style.height = "0";
        }
        if (needsH) {
            this.horiz.style.display = "block";
            this.horiz.style.right = needsV ? sWidth + "px" : "0";
            this.horiz.style.left = measure.barLeft + "px";
            var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
            this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
        } else {
            this.horiz.style.display = "";
            this.horiz.firstChild.style.width = "0";
        }
        if (!this.checkedZeroWidth && measure.clientHeight > 0) {
            if (sWidth == 0) this.zeroWidthHack();
            this.checkedZeroWidth = true;
        }
        return {
            right: needsV ? sWidth : 0,
            bottom: needsH ? sWidth : 0
        };
    };
    NativeScrollbars.prototype.setScrollLeft = function(pos) {
        if (this.horiz.scrollLeft != pos) this.horiz.scrollLeft = pos;
        if (this.disableHoriz) this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
    };
    NativeScrollbars.prototype.setScrollTop = function(pos) {
        if (this.vert.scrollTop != pos) this.vert.scrollTop = pos;
        if (this.disableVert) this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
    };
    NativeScrollbars.prototype.zeroWidthHack = function() {
        var w = mac && !mac_geMountainLion ? "12px" : "18px";
        this.horiz.style.height = this.vert.style.width = w;
        this.horiz.style.visibility = this.vert.style.visibility = "hidden";
        this.disableHoriz = new Delayed;
        this.disableVert = new Delayed;
    };
    NativeScrollbars.prototype.enableZeroWidthBar = function(bar, delay, type) {
        bar.style.visibility = "";
        function maybeDisable() {
            // To find out whether the scrollbar is still visible, we
            // check whether the element under the pixel in the bottom
            // right corner of the scrollbar box is the scrollbar box
            // itself (when the bar is still visible) or its filler child
            // (when the bar is hidden). If it is still visible, we keep
            // it enabled, if it's hidden, we disable pointer events.
            var box = bar.getBoundingClientRect();
            var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
            if (elt != bar) bar.style.visibility = "hidden";
            else delay.set(1000, maybeDisable);
        }
        delay.set(1000, maybeDisable);
    };
    NativeScrollbars.prototype.clear = function() {
        var parent = this.horiz.parentNode;
        parent.removeChild(this.horiz);
        parent.removeChild(this.vert);
    };
    var NullScrollbars = function() {};
    NullScrollbars.prototype.update = function() {
        return {
            bottom: 0,
            right: 0
        };
    };
    NullScrollbars.prototype.setScrollLeft = function() {};
    NullScrollbars.prototype.setScrollTop = function() {};
    NullScrollbars.prototype.clear = function() {};
    function updateScrollbars(cm, measure) {
        if (!measure) measure = measureForScrollbars(cm);
        var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
        updateScrollbarsInner(cm, measure);
        for(var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++){
            if (startWidth != cm.display.barWidth && cm.options.lineWrapping) updateHeightsInViewport(cm);
            updateScrollbarsInner(cm, measureForScrollbars(cm));
            startWidth = cm.display.barWidth;
            startHeight = cm.display.barHeight;
        }
    }
    // Re-synchronize the fake scrollbars with the actual size of the
    // content.
    function updateScrollbarsInner(cm, measure) {
        var d = cm.display;
        var sizes = d.scrollbars.update(measure);
        d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
        d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
        d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
        if (sizes.right && sizes.bottom) {
            d.scrollbarFiller.style.display = "block";
            d.scrollbarFiller.style.height = sizes.bottom + "px";
            d.scrollbarFiller.style.width = sizes.right + "px";
        } else d.scrollbarFiller.style.display = "";
        if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
            d.gutterFiller.style.display = "block";
            d.gutterFiller.style.height = sizes.bottom + "px";
            d.gutterFiller.style.width = measure.gutterWidth + "px";
        } else d.gutterFiller.style.display = "";
    }
    var scrollbarModel = {
        "native": NativeScrollbars,
        "null": NullScrollbars
    };
    function initScrollbars(cm) {
        if (cm.display.scrollbars) {
            cm.display.scrollbars.clear();
            if (cm.display.scrollbars.addClass) rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
        }
        cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function(node) {
            cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
            // Prevent clicks in the scrollbars from killing focus
            on(node, "mousedown", function() {
                if (cm.state.focused) setTimeout(function() {
                    return cm.display.input.focus();
                }, 0);
            });
            node.setAttribute("cm-not-content", "true");
        }, function(pos, axis) {
            if (axis == "horizontal") setScrollLeft(cm, pos);
            else updateScrollTop(cm, pos);
        }, cm);
        if (cm.display.scrollbars.addClass) addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
    }
    // Operations are used to wrap a series of changes to the editor
    // state in such a way that each change won't have to update the
    // cursor and display (which would be awkward, slow, and
    // error-prone). Instead, display updates are batched and then all
    // combined and executed at once.
    var nextOpId = 0;
    // Start a new operation.
    function startOperation(cm) {
        cm.curOp = {
            cm: cm,
            viewChanged: false,
            startHeight: cm.doc.height,
            forceUpdate: false,
            updateInput: 0,
            typing: false,
            changeObjs: null,
            cursorActivityHandlers: null,
            cursorActivityCalled: 0,
            selectionChanged: false,
            updateMaxLine: false,
            scrollLeft: null,
            scrollTop: null,
            scrollToPos: null,
            focus: false,
            id: ++nextOpId,
            markArrays: null // Used by addMarkedSpan
        };
        pushOperation(cm.curOp);
    }
    // Finish an operation, updating the display and signalling delayed events
    function endOperation(cm) {
        var op = cm.curOp;
        if (op) finishOperation(op, function(group) {
            for(var i = 0; i < group.ops.length; i++)group.ops[i].cm.curOp = null;
            endOperations(group);
        });
    }
    // The DOM updates done when an operation finishes are batched so
    // that the minimum number of relayouts are required.
    function endOperations(group) {
        var ops = group.ops;
        for(var i = 0; i < ops.length; i++)endOperation_R1(ops[i]);
        for(var i$1 = 0; i$1 < ops.length; i$1++)endOperation_W1(ops[i$1]);
        for(var i$2 = 0; i$2 < ops.length; i$2++)endOperation_R2(ops[i$2]);
        for(var i$3 = 0; i$3 < ops.length; i$3++)endOperation_W2(ops[i$3]);
        for(var i$4 = 0; i$4 < ops.length; i$4++)endOperation_finish(ops[i$4]);
    }
    function endOperation_R1(op) {
        var cm = op.cm, display = cm.display;
        maybeClipScrollbars(cm);
        if (op.updateMaxLine) findMaxLine(cm);
        op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
        op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && {
            top: op.scrollTop,
            ensure: op.scrollToPos
        }, op.forceUpdate);
    }
    function endOperation_W1(op) {
        op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
    }
    function endOperation_R2(op) {
        var cm = op.cm, display = cm.display;
        if (op.updatedDisplay) updateHeightsInViewport(cm);
        op.barMeasure = measureForScrollbars(cm);
        // If the max line changed since it was last measured, measure it,
        // and ensure the document's width matches it.
        // updateDisplay_W2 will use these properties to do the actual resizing
        if (display.maxLineChanged && !cm.options.lineWrapping) {
            op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
            cm.display.sizerWidth = op.adjustWidthTo;
            op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
            op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
        }
        if (op.updatedDisplay || op.selectionChanged) op.preparedSelection = display.input.prepareSelection();
    }
    function endOperation_W2(op) {
        var cm = op.cm;
        if (op.adjustWidthTo != null) {
            cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
            if (op.maxScrollLeft < cm.doc.scrollLeft) setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
            cm.display.maxLineChanged = false;
        }
        var takeFocus = op.focus && op.focus == activeElt(doc(cm));
        if (op.preparedSelection) cm.display.input.showSelection(op.preparedSelection, takeFocus);
        if (op.updatedDisplay || op.startHeight != cm.doc.height) updateScrollbars(cm, op.barMeasure);
        if (op.updatedDisplay) setDocumentHeight(cm, op.barMeasure);
        if (op.selectionChanged) restartBlink(cm);
        if (cm.state.focused && op.updateInput) cm.display.input.reset(op.typing);
        if (takeFocus) ensureFocus(op.cm);
    }
    function endOperation_finish(op) {
        var cm = op.cm, display = cm.display, doc = cm.doc;
        if (op.updatedDisplay) postUpdateDisplay(cm, op.update);
        // Abort mouse wheel delta measurement, when scrolling explicitly
        if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) display.wheelStartX = display.wheelStartY = null;
        // Propagate the scroll position to the actual DOM scroller
        if (op.scrollTop != null) setScrollTop(cm, op.scrollTop, op.forceScroll);
        if (op.scrollLeft != null) setScrollLeft(cm, op.scrollLeft, true, true);
        // If we need to scroll a specific position into view, do so.
        if (op.scrollToPos) {
            var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from), clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
            maybeScrollWindow(cm, rect);
        }
        // Fire events for markers that are hidden/unidden by editing or
        // undoing
        var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
        if (hidden) {
            for(var i = 0; i < hidden.length; ++i)if (!hidden[i].lines.length) signal(hidden[i], "hide");
        }
        if (unhidden) {
            for(var i$1 = 0; i$1 < unhidden.length; ++i$1)if (unhidden[i$1].lines.length) signal(unhidden[i$1], "unhide");
        }
        if (display.wrapper.offsetHeight) doc.scrollTop = cm.display.scroller.scrollTop;
        // Fire change events, and delayed event handlers
        if (op.changeObjs) signal(cm, "changes", cm, op.changeObjs);
        if (op.update) op.update.finish();
    }
    // Run the given function in an operation
    function runInOp(cm, f) {
        if (cm.curOp) return f();
        startOperation(cm);
        try {
            return f();
        } finally{
            endOperation(cm);
        }
    }
    // Wraps a function in an operation. Returns the wrapped function.
    function operation(cm, f) {
        return function() {
            if (cm.curOp) return f.apply(cm, arguments);
            startOperation(cm);
            try {
                return f.apply(cm, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // Used to add methods to editor and doc instances, wrapping them in
    // operations.
    function methodOp(f) {
        return function() {
            if (this.curOp) return f.apply(this, arguments);
            startOperation(this);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(this);
            }
        };
    }
    function docMethodOp(f) {
        return function() {
            var cm = this.cm;
            if (!cm || cm.curOp) return f.apply(this, arguments);
            startOperation(cm);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // HIGHLIGHT WORKER
    function startWorker(cm, time) {
        if (cm.doc.highlightFrontier < cm.display.viewTo) cm.state.highlight.set(time, bind(highlightWorker, cm));
    }
    function highlightWorker(cm) {
        var doc = cm.doc;
        if (doc.highlightFrontier >= cm.display.viewTo) return;
        var end = +new Date + cm.options.workTime;
        var context = getContextBefore(cm, doc.highlightFrontier);
        var changedLines = [];
        doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function(line) {
            if (context.line >= cm.display.viewFrom) {
                var oldStyles = line.styles;
                var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
                var highlighted = highlightLine(cm, line, context, true);
                if (resetState) context.state = resetState;
                line.styles = highlighted.styles;
                var oldCls = line.styleClasses, newCls = highlighted.classes;
                if (newCls) line.styleClasses = newCls;
                else if (oldCls) line.styleClasses = null;
                var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
                for(var i = 0; !ischange && i < oldStyles.length; ++i)ischange = oldStyles[i] != line.styles[i];
                if (ischange) changedLines.push(context.line);
                line.stateAfter = context.save();
                context.nextLine();
            } else {
                if (line.text.length <= cm.options.maxHighlightLength) processLine(cm, line.text, context);
                line.stateAfter = context.line % 5 == 0 ? context.save() : null;
                context.nextLine();
            }
            if (+new Date > end) {
                startWorker(cm, cm.options.workDelay);
                return true;
            }
        });
        doc.highlightFrontier = context.line;
        doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
        if (changedLines.length) runInOp(cm, function() {
            for(var i = 0; i < changedLines.length; i++)regLineChange(cm, changedLines[i], "text");
        });
    }
    // DISPLAY DRAWING
    var DisplayUpdate = function(cm, viewport, force) {
        var display = cm.display;
        this.viewport = viewport;
        // Store some values that we'll need later (but don't want to force a relayout for)
        this.visible = visibleLines(display, cm.doc, viewport);
        this.editorIsHidden = !display.wrapper.offsetWidth;
        this.wrapperHeight = display.wrapper.clientHeight;
        this.wrapperWidth = display.wrapper.clientWidth;
        this.oldDisplayWidth = displayWidth(cm);
        this.force = force;
        this.dims = getDimensions(cm);
        this.events = [];
    };
    DisplayUpdate.prototype.signal = function(emitter, type) {
        if (hasHandler(emitter, type)) this.events.push(arguments);
    };
    DisplayUpdate.prototype.finish = function() {
        for(var i = 0; i < this.events.length; i++)signal.apply(null, this.events[i]);
    };
    function maybeClipScrollbars(cm) {
        var display = cm.display;
        if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
            display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
            display.heightForcer.style.height = scrollGap(cm) + "px";
            display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
            display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
            display.scrollbarsClipped = true;
        }
    }
    function selectionSnapshot(cm) {
        if (cm.hasFocus()) return null;
        var active = activeElt(doc(cm));
        if (!active || !contains(cm.display.lineDiv, active)) return null;
        var result = {
            activeElt: active
        };
        if (window.getSelection) {
            var sel = win(cm).getSelection();
            if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
                result.anchorNode = sel.anchorNode;
                result.anchorOffset = sel.anchorOffset;
                result.focusNode = sel.focusNode;
                result.focusOffset = sel.focusOffset;
            }
        }
        return result;
    }
    function restoreSelection(snapshot) {
        if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt(snapshot.activeElt.ownerDocument)) return;
        snapshot.activeElt.focus();
        if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) && snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
            var doc = snapshot.activeElt.ownerDocument;
            var sel = doc.defaultView.getSelection(), range = doc.createRange();
            range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
            sel.extend(snapshot.focusNode, snapshot.focusOffset);
        }
    }
    // Does the actual updating of the line display. Bails out
    // (returning false) when there is nothing to be done and forced is
    // false.
    function updateDisplayIfNeeded(cm, update) {
        var display = cm.display, doc = cm.doc;
        if (update.editorIsHidden) {
            resetView(cm);
            return false;
        }
        // Bail out if the visible area is already rendered and nothing changed.
        if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) return false;
        if (maybeUpdateLineNumberWidth(cm)) {
            resetView(cm);
            update.dims = getDimensions(cm);
        }
        // Compute a suitable new viewport (from & to)
        var end = doc.first + doc.size;
        var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
        var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
        if (display.viewFrom < from && from - display.viewFrom < 20) from = Math.max(doc.first, display.viewFrom);
        if (display.viewTo > to && display.viewTo - to < 20) to = Math.min(end, display.viewTo);
        if (sawCollapsedSpans) {
            from = visualLineNo(cm.doc, from);
            to = visualLineEndNo(cm.doc, to);
        }
        var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
        adjustView(cm, from, to);
        display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
        // Position the mover div to align with the current scroll position
        cm.display.mover.style.top = display.viewOffset + "px";
        var toUpdate = countDirtyView(cm);
        if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) return false;
        // For big changes, we hide the enclosing element during the
        // update, since that speeds up the operations on most browsers.
        var selSnapshot = selectionSnapshot(cm);
        if (toUpdate > 4) display.lineDiv.style.display = "none";
        patchDisplay(cm, display.updateLineNumbers, update.dims);
        if (toUpdate > 4) display.lineDiv.style.display = "";
        display.renderedView = display.view;
        // There might have been a widget with a focused element that got
        // hidden or updated, if so re-focus it.
        restoreSelection(selSnapshot);
        // Prevent selection and cursors from interfering with the scroll
        // width and height.
        removeChildren(display.cursorDiv);
        removeChildren(display.selectionDiv);
        display.gutters.style.height = display.sizer.style.minHeight = 0;
        if (different) {
            display.lastWrapHeight = update.wrapperHeight;
            display.lastWrapWidth = update.wrapperWidth;
            startWorker(cm, 400);
        }
        display.updateLineNumbers = null;
        return true;
    }
    function postUpdateDisplay(cm, update) {
        var viewport = update.viewport;
        for(var first = true;; first = false){
            if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
                // Clip forced viewport to actual scrollable area.
                if (viewport && viewport.top != null) viewport = {
                    top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)
                };
                // Updated line heights might result in the drawn area not
                // actually covering the viewport. Keep looping until it does.
                update.visible = visibleLines(cm.display, cm.doc, viewport);
                if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) break;
            } else if (first) update.visible = visibleLines(cm.display, cm.doc, viewport);
            if (!updateDisplayIfNeeded(cm, update)) break;
            updateHeightsInViewport(cm);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.force = false;
        }
        update.signal(cm, "update", cm);
        if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
            update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
            cm.display.reportedViewFrom = cm.display.viewFrom;
            cm.display.reportedViewTo = cm.display.viewTo;
        }
    }
    function updateDisplaySimple(cm, viewport) {
        var update = new DisplayUpdate(cm, viewport);
        if (updateDisplayIfNeeded(cm, update)) {
            updateHeightsInViewport(cm);
            postUpdateDisplay(cm, update);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.finish();
        }
    }
    // Sync the actual display DOM structure with display.view, removing
    // nodes for lines that are no longer in view, and creating the ones
    // that are not there yet, and updating the ones that are out of
    // date.
    function patchDisplay(cm, updateNumbersFrom, dims) {
        var display = cm.display, lineNumbers = cm.options.lineNumbers;
        var container = display.lineDiv, cur = container.firstChild;
        function rm(node) {
            var next = node.nextSibling;
            // Works around a throw-scroll bug in OS X Webkit
            if (webkit && mac && cm.display.currentWheelTarget == node) node.style.display = "none";
            else node.parentNode.removeChild(node);
            return next;
        }
        var view = display.view, lineN = display.viewFrom;
        // Loop over the elements in the view, syncing cur (the DOM nodes
        // in display.lineDiv) with the view as we go.
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (lineView.hidden) ;
            else if (!lineView.node || lineView.node.parentNode != container) {
                var node = buildLineElement(cm, lineView, lineN, dims);
                container.insertBefore(node, cur);
            } else {
                while(cur != lineView.node)cur = rm(cur);
                var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
                if (lineView.changes) {
                    if (indexOf(lineView.changes, "gutter") > -1) updateNumber = false;
                    updateLineForChanges(cm, lineView, lineN, dims);
                }
                if (updateNumber) {
                    removeChildren(lineView.lineNumber);
                    lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
                }
                cur = lineView.node.nextSibling;
            }
            lineN += lineView.size;
        }
        while(cur)cur = rm(cur);
    }
    function updateGutterSpace(display) {
        var width = display.gutters.offsetWidth;
        display.sizer.style.marginLeft = width + "px";
        // Send an event to consumers responding to changes in gutter width.
        signalLater(display, "gutterChanged", display);
    }
    function setDocumentHeight(cm, measure) {
        cm.display.sizer.style.minHeight = measure.docHeight + "px";
        cm.display.heightForcer.style.top = measure.docHeight + "px";
        cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
    }
    // Re-align line numbers and gutter marks to compensate for
    // horizontal scrolling.
    function alignHorizontally(cm) {
        var display = cm.display, view = display.view;
        if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) return;
        var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
        var gutterW = display.gutters.offsetWidth, left = comp + "px";
        for(var i = 0; i < view.length; i++)if (!view[i].hidden) {
            if (cm.options.fixedGutter) {
                if (view[i].gutter) view[i].gutter.style.left = left;
                if (view[i].gutterBackground) view[i].gutterBackground.style.left = left;
            }
            var align = view[i].alignable;
            if (align) for(var j = 0; j < align.length; j++)align[j].style.left = left;
        }
        if (cm.options.fixedGutter) display.gutters.style.left = comp + gutterW + "px";
    }
    // Used to ensure that the line number gutter is still the right
    // size for the current document size. Returns true when an update
    // is needed.
    function maybeUpdateLineNumberWidth(cm) {
        if (!cm.options.lineNumbers) return false;
        var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
        if (last.length != display.lineNumChars) {
            var test = display.measure.appendChild(elt("div", [
                elt("div", last)
            ], "CodeMirror-linenumber CodeMirror-gutter-elt"));
            var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
            display.lineGutter.style.width = "";
            display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
            display.lineNumWidth = display.lineNumInnerWidth + padding;
            display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
            display.lineGutter.style.width = display.lineNumWidth + "px";
            updateGutterSpace(cm.display);
            return true;
        }
        return false;
    }
    function getGutters(gutters, lineNumbers) {
        var result = [], sawLineNumbers = false;
        for(var i = 0; i < gutters.length; i++){
            var name = gutters[i], style = null;
            if (typeof name != "string") {
                style = name.style;
                name = name.className;
            }
            if (name == "CodeMirror-linenumbers") {
                if (!lineNumbers) continue;
                else sawLineNumbers = true;
            }
            result.push({
                className: name,
                style: style
            });
        }
        if (lineNumbers && !sawLineNumbers) result.push({
            className: "CodeMirror-linenumbers",
            style: null
        });
        return result;
    }
    // Rebuild the gutter elements, ensure the margin to the left of the
    // code matches their width.
    function renderGutters(display) {
        var gutters = display.gutters, specs = display.gutterSpecs;
        removeChildren(gutters);
        display.lineGutter = null;
        for(var i = 0; i < specs.length; ++i){
            var ref = specs[i];
            var className = ref.className;
            var style = ref.style;
            var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
            if (style) gElt.style.cssText = style;
            if (className == "CodeMirror-linenumbers") {
                display.lineGutter = gElt;
                gElt.style.width = (display.lineNumWidth || 1) + "px";
            }
        }
        gutters.style.display = specs.length ? "" : "none";
        updateGutterSpace(display);
    }
    function updateGutters(cm) {
        renderGutters(cm.display);
        regChange(cm);
        alignHorizontally(cm);
    }
    // The display handles the DOM integration, both for input reading
    // and content drawing. It holds references to DOM nodes and
    // display-related state.
    function Display(place, doc, input, options) {
        var d = this;
        this.input = input;
        // Covers bottom-right square when both scrollbars are present.
        d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
        d.scrollbarFiller.setAttribute("cm-not-content", "true");
        // Covers bottom of gutter when coverGutterNextToScrollbar is on
        // and h scrollbar is present.
        d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
        d.gutterFiller.setAttribute("cm-not-content", "true");
        // Will contain the actual code, positioned to cover the viewport.
        d.lineDiv = eltP("div", null, "CodeMirror-code");
        // Elements are added to these to represent selection and cursors.
        d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
        d.cursorDiv = elt("div", null, "CodeMirror-cursors");
        // A visibility: hidden element used to find the size of things.
        d.measure = elt("div", null, "CodeMirror-measure");
        // When lines outside of the viewport are measured, they are drawn in this.
        d.lineMeasure = elt("div", null, "CodeMirror-measure");
        // Wraps everything that needs to exist inside the vertically-padded coordinate system
        d.lineSpace = eltP("div", [
            d.measure,
            d.lineMeasure,
            d.selectionDiv,
            d.cursorDiv,
            d.lineDiv
        ], null, "position: relative; outline: none");
        var lines = eltP("div", [
            d.lineSpace
        ], "CodeMirror-lines");
        // Moved around its parent to cover visible view.
        d.mover = elt("div", [
            lines
        ], null, "position: relative");
        // Set to the height of the document, allowing scrolling.
        d.sizer = elt("div", [
            d.mover
        ], "CodeMirror-sizer");
        d.sizerWidth = null;
        // Behavior of elts with overflow: auto and padding is
        // inconsistent across browsers. This is used to ensure the
        // scrollable area is big enough.
        d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
        // Will contain the gutters, if any.
        d.gutters = elt("div", null, "CodeMirror-gutters");
        d.lineGutter = null;
        // Actual scrollable element.
        d.scroller = elt("div", [
            d.sizer,
            d.heightForcer,
            d.gutters
        ], "CodeMirror-scroll");
        d.scroller.setAttribute("tabIndex", "-1");
        // The element in which the editor lives.
        d.wrapper = elt("div", [
            d.scrollbarFiller,
            d.gutterFiller,
            d.scroller
        ], "CodeMirror");
        // See #6982. FIXME remove when this has been fixed for a while in Chrome
        if (chrome && chrome_version >= 105) d.wrapper.style.clipPath = "inset(0px)";
        // This attribute is respected by automatic translation systems such as Google Translate,
        // and may also be respected by tools used by human translators.
        d.wrapper.setAttribute('translate', 'no');
        // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
        if (ie && ie_version < 8) {
            d.gutters.style.zIndex = -1;
            d.scroller.style.paddingRight = 0;
        }
        if (!webkit && !(gecko && mobile)) d.scroller.draggable = true;
        if (place) {
            if (place.appendChild) place.appendChild(d.wrapper);
            else place(d.wrapper);
        }
        // Current rendered range (may be bigger than the view window).
        d.viewFrom = d.viewTo = doc.first;
        d.reportedViewFrom = d.reportedViewTo = doc.first;
        // Information about the rendered lines.
        d.view = [];
        d.renderedView = null;
        // Holds info about a single rendered line when it was rendered
        // for measurement, while not in view.
        d.externalMeasured = null;
        // Empty space (in pixels) above the view
        d.viewOffset = 0;
        d.lastWrapHeight = d.lastWrapWidth = 0;
        d.updateLineNumbers = null;
        d.nativeBarWidth = d.barHeight = d.barWidth = 0;
        d.scrollbarsClipped = false;
        // Used to only resize the line number gutter when necessary (when
        // the amount of lines crosses a boundary that makes its width change)
        d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
        // Set to true when a non-horizontal-scrolling line widget is
        // added. As an optimization, line widget aligning is skipped when
        // this is false.
        d.alignWidgets = false;
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        // Tracks the maximum line length so that the horizontal scrollbar
        // can be kept static when scrolling.
        d.maxLine = null;
        d.maxLineLength = 0;
        d.maxLineChanged = false;
        // Used for measuring wheel scrolling granularity
        d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
        // True when shift is held down.
        d.shift = false;
        // Used to track whether anything happened since the context menu
        // was opened.
        d.selForContextMenu = null;
        d.activeTouch = null;
        d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
        renderGutters(d);
        input.init(d);
    }
    // Since the delta values reported on mouse wheel events are
    // unstandardized between browsers and even browser versions, and
    // generally horribly unpredictable, this code starts by measuring
    // the scroll effect that the first few mouse wheel events have,
    // and, from that, detects the way it can convert deltas to pixel
    // offsets afterwards.
    //
    // The reason we want to know the amount a wheel event will scroll
    // is that it gives us a chance to update the display before the
    // actual scrolling happens, reducing flickering.
    var wheelSamples = 0, wheelPixelsPerUnit = null;
    // Fill in a browser-detected starting value on browsers where we
    // know one. These don't have to be accurate -- the result of them
    // being wrong would just be a slight flicker on the first wheel
    // scroll (if it is large enough).
    if (ie) wheelPixelsPerUnit = -0.53;
    else if (gecko) wheelPixelsPerUnit = 15;
    else if (chrome) wheelPixelsPerUnit = -0.7;
    else if (safari) wheelPixelsPerUnit = -1 / 3;
    function wheelEventDelta(e) {
        var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
        if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) dx = e.detail;
        if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) dy = e.detail;
        else if (dy == null) dy = e.wheelDelta;
        return {
            x: dx,
            y: dy
        };
    }
    function wheelEventPixels(e) {
        var delta = wheelEventDelta(e);
        delta.x *= wheelPixelsPerUnit;
        delta.y *= wheelPixelsPerUnit;
        return delta;
    }
    function onScrollWheel(cm, e) {
        // On Chrome 102, viewport updates somehow stop wheel-based
        // scrolling. Turning off pointer events during the scroll seems
        // to avoid the issue.
        if (chrome && chrome_version == 102) {
            if (cm.display.chromeScrollHack == null) cm.display.sizer.style.pointerEvents = "none";
            else clearTimeout(cm.display.chromeScrollHack);
            cm.display.chromeScrollHack = setTimeout(function() {
                cm.display.chromeScrollHack = null;
                cm.display.sizer.style.pointerEvents = "";
            }, 100);
        }
        var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
        var pixelsPerUnit = wheelPixelsPerUnit;
        if (e.deltaMode === 0) {
            dx = e.deltaX;
            dy = e.deltaY;
            pixelsPerUnit = 1;
        }
        var display = cm.display, scroll = display.scroller;
        // Quit if there's nothing to scroll here
        var canScrollX = scroll.scrollWidth > scroll.clientWidth;
        var canScrollY = scroll.scrollHeight > scroll.clientHeight;
        if (!(dx && canScrollX || dy && canScrollY)) return;
        // Webkit browsers on OS X abort momentum scrolls when the target
        // of the scroll event is removed from the scrollable element.
        // This hack (see related code in patchDisplay) makes sure the
        // element is kept around.
        if (dy && mac && webkit) outer: for(var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode){
            for(var i = 0; i < view.length; i++)if (view[i].node == cur) {
                cm.display.currentWheelTarget = cur;
                break outer;
            }
        }
        // On some browsers, horizontal scrolling will cause redraws to
        // happen before the gutter has been realigned, causing it to
        // wriggle around in a most unseemly way. When we have an
        // estimated pixels/delta value, we just handle horizontal
        // scrolling entirely here. It'll be slightly off from native, but
        // better than glitching out.
        if (dx && !gecko && !presto && pixelsPerUnit != null) {
            if (dy && canScrollY) updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit));
            setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
            // Only prevent default scrolling if vertical scrolling is
            // actually possible. Otherwise, it causes vertical scroll
            // jitter on OSX trackpads when deltaX is small and deltaY
            // is large (issue #3579)
            if (!dy || dy && canScrollY) e_preventDefault(e);
            display.wheelStartX = null; // Abort measurement, if in progress
            return;
        }
        // 'Project' the visible viewport to cover the area that is being
        // scrolled into view (if we know enough to estimate it).
        if (dy && pixelsPerUnit != null) {
            var pixels = dy * pixelsPerUnit;
            var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
            if (pixels < 0) top = Math.max(0, top + pixels - 50);
            else bot = Math.min(cm.doc.height, bot + pixels + 50);
            updateDisplaySimple(cm, {
                top: top,
                bottom: bot
            });
        }
        if (wheelSamples < 20 && e.deltaMode !== 0) {
            if (display.wheelStartX == null) {
                display.wheelStartX = scroll.scrollLeft;
                display.wheelStartY = scroll.scrollTop;
                display.wheelDX = dx;
                display.wheelDY = dy;
                setTimeout(function() {
                    if (display.wheelStartX == null) return;
                    var movedX = scroll.scrollLeft - display.wheelStartX;
                    var movedY = scroll.scrollTop - display.wheelStartY;
                    var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
                    display.wheelStartX = display.wheelStartY = null;
                    if (!sample) return;
                    wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
                    ++wheelSamples;
                }, 200);
            } else {
                display.wheelDX += dx;
                display.wheelDY += dy;
            }
        }
    }
    // Selection objects are immutable. A new one is created every time
    // the selection changes. A selection is one or more non-overlapping
    // (and non-touching) ranges, sorted, and an integer that indicates
    // which one is the primary selection (the one that's scrolled into
    // view, that getCursor returns, etc).
    var Selection = function(ranges, primIndex) {
        this.ranges = ranges;
        this.primIndex = primIndex;
    };
    Selection.prototype.primary = function() {
        return this.ranges[this.primIndex];
    };
    Selection.prototype.equals = function(other) {
        if (other == this) return true;
        if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) return false;
        for(var i = 0; i < this.ranges.length; i++){
            var here = this.ranges[i], there = other.ranges[i];
            if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) return false;
        }
        return true;
    };
    Selection.prototype.deepCopy = function() {
        var out = [];
        for(var i = 0; i < this.ranges.length; i++)out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head));
        return new Selection(out, this.primIndex);
    };
    Selection.prototype.somethingSelected = function() {
        for(var i = 0; i < this.ranges.length; i++){
            if (!this.ranges[i].empty()) return true;
        }
        return false;
    };
    Selection.prototype.contains = function(pos, end) {
        if (!end) end = pos;
        for(var i = 0; i < this.ranges.length; i++){
            var range = this.ranges[i];
            if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) return i;
        }
        return -1;
    };
    var Range = function(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    };
    Range.prototype.from = function() {
        return minPos(this.anchor, this.head);
    };
    Range.prototype.to = function() {
        return maxPos(this.anchor, this.head);
    };
    Range.prototype.empty = function() {
        return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
    };
    // Take an unsorted, potentially overlapping set of ranges, and
    // build a selection out of it. 'Consumes' ranges array (modifying
    // it).
    function normalizeSelection(cm, ranges, primIndex) {
        var mayTouch = cm && cm.options.selectionsMayTouch;
        var prim = ranges[primIndex];
        ranges.sort(function(a, b) {
            return cmp(a.from(), b.from());
        });
        primIndex = indexOf(ranges, prim);
        for(var i = 1; i < ranges.length; i++){
            var cur = ranges[i], prev = ranges[i - 1];
            var diff = cmp(prev.to(), cur.from());
            if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
                var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
                var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
                if (i <= primIndex) --primIndex;
                ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
            }
        }
        return new Selection(ranges, primIndex);
    }
    function simpleSelection(anchor, head) {
        return new Selection([
            new Range(anchor, head || anchor)
        ], 0);
    }
    // Compute the position of the end of a change (its 'to' property
    // refers to the pre-change end).
    function changeEnd(change) {
        if (!change.text) return change.to;
        return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
    }
    // Adjust a position to refer to the post-change position of the
    // same text, or the end of the change if the change covers it.
    function adjustForChange(pos, change) {
        if (cmp(pos, change.from) < 0) return pos;
        if (cmp(pos, change.to) <= 0) return changeEnd(change);
        var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
        if (pos.line == change.to.line) ch += changeEnd(change).ch - change.to.ch;
        return Pos(line, ch);
    }
    function computeSelAfterChange(doc, change) {
        var out = [];
        for(var i = 0; i < doc.sel.ranges.length; i++){
            var range = doc.sel.ranges[i];
            out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
        }
        return normalizeSelection(doc.cm, out, doc.sel.primIndex);
    }
    function offsetPos(pos, old, nw) {
        if (pos.line == old.line) return Pos(nw.line, pos.ch - old.ch + nw.ch);
        else return Pos(nw.line + (pos.line - old.line), pos.ch);
    }
    // Used by replaceSelections to allow moving the selection to the
    // start or around the replaced test. Hint may be "start" or "around".
    function computeReplacedSel(doc, changes, hint) {
        var out = [];
        var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var from = offsetPos(change.from, oldPrev, newPrev);
            var to = offsetPos(changeEnd(change), oldPrev, newPrev);
            oldPrev = change.to;
            newPrev = to;
            if (hint == "around") {
                var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
                out[i] = new Range(inv ? to : from, inv ? from : to);
            } else out[i] = new Range(from, from);
        }
        return new Selection(out, doc.sel.primIndex);
    }
    // Used to get the editor into a consistent state again when options change.
    function loadMode(cm) {
        cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
        resetModeState(cm);
    }
    function resetModeState(cm) {
        cm.doc.iter(function(line) {
            if (line.stateAfter) line.stateAfter = null;
            if (line.styles) line.styles = null;
        });
        cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
        startWorker(cm, 100);
        cm.state.modeGen++;
        if (cm.curOp) regChange(cm);
    }
    // DOCUMENT DATA STRUCTURE
    // By default, updates that start and end at the beginning of a line
    // are treated specially, in order to make the association of line
    // widgets and marker elements with the text behave more intuitive.
    function isWholeLineUpdate(doc, change) {
        return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
    }
    // Perform a change on the document data structure.
    function updateDoc(doc, change, markedSpans, estimateHeight) {
        function spansFor(n) {
            return markedSpans ? markedSpans[n] : null;
        }
        function update(line, text, spans) {
            updateLine(line, text, spans, estimateHeight);
            signalLater(line, "change", line, change);
        }
        function linesFor(start, end) {
            var result = [];
            for(var i = start; i < end; ++i)result.push(new Line(text[i], spansFor(i), estimateHeight));
            return result;
        }
        var from = change.from, to = change.to, text = change.text;
        var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
        var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
        // Adjust the line structure
        if (change.full) {
            doc.insert(0, linesFor(0, text.length));
            doc.remove(text.length, doc.size - text.length);
        } else if (isWholeLineUpdate(doc, change)) {
            // This is a whole-line replace. Treated specially to make
            // sure line objects move the way they are supposed to.
            var added = linesFor(0, text.length - 1);
            update(lastLine, lastLine.text, lastSpans);
            if (nlines) doc.remove(from.line, nlines);
            if (added.length) doc.insert(from.line, added);
        } else if (firstLine == lastLine) {
            if (text.length == 1) update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
            else {
                var added$1 = linesFor(1, text.length - 1);
                added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
                update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
                doc.insert(from.line + 1, added$1);
            }
        } else if (text.length == 1) {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
            doc.remove(from.line + 1, nlines);
        } else {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
            update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
            var added$2 = linesFor(1, text.length - 1);
            if (nlines > 1) doc.remove(from.line + 1, nlines - 1);
            doc.insert(from.line + 1, added$2);
        }
        signalLater(doc, "change", doc, change);
    }
    // Call f for all linked documents.
    function linkedDocs(doc, f, sharedHistOnly) {
        function propagate(doc, skip, sharedHist) {
            if (doc.linked) for(var i = 0; i < doc.linked.length; ++i){
                var rel = doc.linked[i];
                if (rel.doc == skip) continue;
                var shared = sharedHist && rel.sharedHist;
                if (sharedHistOnly && !shared) continue;
                f(rel.doc, shared);
                propagate(rel.doc, doc, shared);
            }
        }
        propagate(doc, null, true);
    }
    // Attach a document to an editor.
    function attachDoc(cm, doc) {
        if (doc.cm) throw new Error("This document is already in use.");
        cm.doc = doc;
        doc.cm = cm;
        estimateLineHeights(cm);
        loadMode(cm);
        setDirectionClass(cm);
        cm.options.direction = doc.direction;
        if (!cm.options.lineWrapping) findMaxLine(cm);
        cm.options.mode = doc.modeOption;
        regChange(cm);
    }
    function setDirectionClass(cm) {
        (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
    }
    function directionChanged(cm) {
        runInOp(cm, function() {
            setDirectionClass(cm);
            regChange(cm);
        });
    }
    function History(prev) {
        // Arrays of change events and selections. Doing something adds an
        // event to done and clears undo. Undoing moves events from done
        // to undone, redoing moves them in the other direction.
        this.done = [];
        this.undone = [];
        this.undoDepth = prev ? prev.undoDepth : Infinity;
        // Used to track when changes can be merged into a single undo
        // event
        this.lastModTime = this.lastSelTime = 0;
        this.lastOp = this.lastSelOp = null;
        this.lastOrigin = this.lastSelOrigin = null;
        // Used by the isClean() method
        this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
    }
    // Create a history change event from an updateDoc-style change
    // object.
    function historyChangeFromChange(doc, change) {
        var histChange = {
            from: copyPos(change.from),
            to: changeEnd(change),
            text: getBetween(doc, change.from, change.to)
        };
        attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        linkedDocs(doc, function(doc) {
            return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        }, true);
        return histChange;
    }
    // Pop all selection events off the end of a history array. Stop at
    // a change event.
    function clearSelectionEvents(array) {
        while(array.length){
            var last = lst(array);
            if (last.ranges) array.pop();
            else break;
        }
    }
    // Find the top change event in the history. Pop off selection
    // events that are in the way.
    function lastChangeEvent(hist, force) {
        if (force) {
            clearSelectionEvents(hist.done);
            return lst(hist.done);
        } else if (hist.done.length && !lst(hist.done).ranges) return lst(hist.done);
        else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
            hist.done.pop();
            return lst(hist.done);
        }
    }
    // Register a change in the history. Merges changes that are within
    // a single operation, or are close together with an origin that
    // allows merging (starting with "+") into a single event.
    function addChangeToHistory(doc, change, selAfter, opId) {
        var hist = doc.history;
        hist.undone.length = 0;
        var time = +new Date, cur;
        var last;
        if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
            // Merge this change into the last event
            last = lst(cur.changes);
            if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) // Optimized case for simple insertion -- don't want to add
            // new changesets for every character typed
            last.to = changeEnd(change);
            else // Add new sub-event
            cur.changes.push(historyChangeFromChange(doc, change));
        } else {
            // Can not be merged, start a new event.
            var before = lst(hist.done);
            if (!before || !before.ranges) pushSelectionToHistory(doc.sel, hist.done);
            cur = {
                changes: [
                    historyChangeFromChange(doc, change)
                ],
                generation: hist.generation
            };
            hist.done.push(cur);
            while(hist.done.length > hist.undoDepth){
                hist.done.shift();
                if (!hist.done[0].ranges) hist.done.shift();
            }
        }
        hist.done.push(selAfter);
        hist.generation = ++hist.maxGeneration;
        hist.lastModTime = hist.lastSelTime = time;
        hist.lastOp = hist.lastSelOp = opId;
        hist.lastOrigin = hist.lastSelOrigin = change.origin;
        if (!last) signal(doc, "historyAdded");
    }
    function selectionEventCanBeMerged(doc, origin, prev, sel) {
        var ch = origin.charAt(0);
        return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
    }
    // Called whenever the selection changes, sets the new selection as
    // the pending selection in the history, and pushes the old pending
    // selection into the 'done' array when it was significantly
    // different (in number of selected ranges, emptiness, or time).
    function addSelectionToHistory(doc, sel, opId, options) {
        var hist = doc.history, origin = options && options.origin;
        // A new event is started when the previous origin does not match
        // the current, or the origins don't allow matching. Origins
        // starting with * are always merged, those starting with + are
        // merged when similar and close together in time.
        if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) hist.done[hist.done.length - 1] = sel;
        else pushSelectionToHistory(sel, hist.done);
        hist.lastSelTime = +new Date;
        hist.lastSelOrigin = origin;
        hist.lastSelOp = opId;
        if (options && options.clearRedo !== false) clearSelectionEvents(hist.undone);
    }
    function pushSelectionToHistory(sel, dest) {
        var top = lst(dest);
        if (!(top && top.ranges && top.equals(sel))) dest.push(sel);
    }
    // Used to store marked span information in the history.
    function attachLocalSpans(doc, change, from, to) {
        var existing = change["spans_" + doc.id], n = 0;
        doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function(line) {
            if (line.markedSpans) (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
            ++n;
        });
    }
    // When un/re-doing restores text containing marked spans, those
    // that have been explicitly cleared should not be restored.
    function removeClearedSpans(spans) {
        if (!spans) return null;
        var out;
        for(var i = 0; i < spans.length; ++i){
            if (spans[i].marker.explicitlyCleared) {
                if (!out) out = spans.slice(0, i);
            } else if (out) out.push(spans[i]);
        }
        return !out ? spans : out.length ? out : null;
    }
    // Retrieve and filter the old marked spans stored in a change event.
    function getOldSpans(doc, change) {
        var found = change["spans_" + doc.id];
        if (!found) return null;
        var nw = [];
        for(var i = 0; i < change.text.length; ++i)nw.push(removeClearedSpans(found[i]));
        return nw;
    }
    // Used for un/re-doing changes from the history. Combines the
    // result of computing the existing spans with the set of spans that
    // existed in the history (so that deleting around a span and then
    // undoing brings back the span).
    function mergeOldSpans(doc, change) {
        var old = getOldSpans(doc, change);
        var stretched = stretchSpansOverChange(doc, change);
        if (!old) return stretched;
        if (!stretched) return old;
        for(var i = 0; i < old.length; ++i){
            var oldCur = old[i], stretchCur = stretched[i];
            if (oldCur && stretchCur) spans: for(var j = 0; j < stretchCur.length; ++j){
                var span = stretchCur[j];
                for(var k = 0; k < oldCur.length; ++k){
                    if (oldCur[k].marker == span.marker) continue spans;
                }
                oldCur.push(span);
            }
            else if (stretchCur) old[i] = stretchCur;
        }
        return old;
    }
    // Used both to provide a JSON-safe object in .getHistory, and, when
    // detaching a document, to split the history in two
    function copyHistoryArray(events, newGroup, instantiateSel) {
        var copy = [];
        for(var i = 0; i < events.length; ++i){
            var event = events[i];
            if (event.ranges) {
                copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
                continue;
            }
            var changes = event.changes, newChanges = [];
            copy.push({
                changes: newChanges
            });
            for(var j = 0; j < changes.length; ++j){
                var change = changes[j], m = void 0;
                newChanges.push({
                    from: change.from,
                    to: change.to,
                    text: change.text
                });
                if (newGroup) for(var prop in change){
                    if (m = prop.match(/^spans_(\d+)$/)) {
                        if (indexOf(newGroup, Number(m[1])) > -1) {
                            lst(newChanges)[prop] = change[prop];
                            delete change[prop];
                        }
                    }
                }
            }
        }
        return copy;
    }
    // The 'scroll' parameter given to many of these indicated whether
    // the new cursor position should be scrolled into view after
    // modifying the selection.
    // If shift is held or the extend flag is set, extends a range to
    // include a given position (and optionally a second position).
    // Otherwise, simply returns the range between the given positions.
    // Used for cursor motion and such.
    function extendRange(range, head, other, extend) {
        if (extend) {
            var anchor = range.anchor;
            if (other) {
                var posBefore = cmp(head, anchor) < 0;
                if (posBefore != cmp(other, anchor) < 0) {
                    anchor = head;
                    head = other;
                } else if (posBefore != cmp(head, other) < 0) head = other;
            }
            return new Range(anchor, head);
        } else return new Range(other || head, head);
    }
    // Extend the primary selection range, discard the rest.
    function extendSelection(doc, head, other, options, extend) {
        if (extend == null) extend = doc.cm && (doc.cm.display.shift || doc.extend);
        setSelection(doc, new Selection([
            extendRange(doc.sel.primary(), head, other, extend)
        ], 0), options);
    }
    // Extend all selections (pos is an array of selections with length
    // equal the number of selections)
    function extendSelections(doc, heads, options) {
        var out = [];
        var extend = doc.cm && (doc.cm.display.shift || doc.extend);
        for(var i = 0; i < doc.sel.ranges.length; i++)out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
        var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
        setSelection(doc, newSel, options);
    }
    // Updates a single range in the selection.
    function replaceOneSelection(doc, i, range, options) {
        var ranges = doc.sel.ranges.slice(0);
        ranges[i] = range;
        setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
    }
    // Reset the selection to a single range.
    function setSimpleSelection(doc, anchor, head, options) {
        setSelection(doc, simpleSelection(anchor, head), options);
    }
    // Give beforeSelectionChange handlers a change to influence a
    // selection update.
    function filterSelectionChange(doc, sel, options) {
        var obj = {
            ranges: sel.ranges,
            update: function(ranges) {
                this.ranges = [];
                for(var i = 0; i < ranges.length; i++)this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor), clipPos(doc, ranges[i].head));
            },
            origin: options && options.origin
        };
        signal(doc, "beforeSelectionChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
        if (obj.ranges != sel.ranges) return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1);
        else return sel;
    }
    function setSelectionReplaceHistory(doc, sel, options) {
        var done = doc.history.done, last = lst(done);
        if (last && last.ranges) {
            done[done.length - 1] = sel;
            setSelectionNoUndo(doc, sel, options);
        } else setSelection(doc, sel, options);
    }
    // Set a new selection.
    function setSelection(doc, sel, options) {
        setSelectionNoUndo(doc, sel, options);
        addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
    }
    function setSelectionNoUndo(doc, sel, options) {
        if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) sel = filterSelectionChange(doc, sel, options);
        var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
        setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
        if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor") ensureCursorVisible(doc.cm);
    }
    function setSelectionInner(doc, sel) {
        if (sel.equals(doc.sel)) return;
        doc.sel = sel;
        if (doc.cm) {
            doc.cm.curOp.updateInput = 1;
            doc.cm.curOp.selectionChanged = true;
            signalCursorActivity(doc.cm);
        }
        signalLater(doc, "cursorActivity", doc);
    }
    // Verify that the selection does not partially select any atomic
    // marked ranges.
    function reCheckSelection(doc) {
        setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
    }
    // Return a selection that does not partially select any atomic
    // ranges.
    function skipAtomicInSelection(doc, sel, bias, mayClear) {
        var out;
        for(var i = 0; i < sel.ranges.length; i++){
            var range = sel.ranges[i];
            var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
            var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
            var newHead = range.head == range.anchor ? newAnchor : skipAtomic(doc, range.head, old && old.head, bias, mayClear);
            if (out || newAnchor != range.anchor || newHead != range.head) {
                if (!out) out = sel.ranges.slice(0, i);
                out[i] = new Range(newAnchor, newHead);
            }
        }
        return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel;
    }
    function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
        var line = getLine(doc, pos.line);
        if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
            var sp = line.markedSpans[i], m = sp.marker;
            // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
            // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
            // is with selectLeft/Right
            var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
            var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
            if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
                if (mayClear) {
                    signal(m, "beforeCursorEnter");
                    if (m.explicitlyCleared) {
                        if (!line.markedSpans) break;
                        else {
                            --i;
                            continue;
                        }
                    }
                }
                if (!m.atomic) continue;
                if (oldPos) {
                    var near = m.find(dir < 0 ? 1 : -1), diff = void 0;
                    if (dir < 0 ? preventCursorRight : preventCursorLeft) near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
                    if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) return skipAtomicInner(doc, near, pos, dir, mayClear);
                }
                var far = m.find(dir < 0 ? -1 : 1);
                if (dir < 0 ? preventCursorLeft : preventCursorRight) far = movePos(doc, far, dir, far.line == pos.line ? line : null);
                return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
            }
        }
        return pos;
    }
    // Ensure a given position is not inside an atomic range.
    function skipAtomic(doc, pos, oldPos, bias, mayClear) {
        var dir = bias || 1;
        var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
        if (!found) {
            doc.cantEdit = true;
            return Pos(doc.first, 0);
        }
        return found;
    }
    function movePos(doc, pos, dir, line) {
        if (dir < 0 && pos.ch == 0) {
            if (pos.line > doc.first) return clipPos(doc, Pos(pos.line - 1));
            else return null;
        } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
            if (pos.line < doc.first + doc.size - 1) return Pos(pos.line + 1, 0);
            else return null;
        } else return new Pos(pos.line, pos.ch + dir);
    }
    function selectAll(cm) {
        cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
    }
    // UPDATING
    // Allow "beforeChange" event handlers to influence a change
    function filterChange(doc, change, update) {
        var obj = {
            canceled: false,
            from: change.from,
            to: change.to,
            text: change.text,
            origin: change.origin,
            cancel: function() {
                return obj.canceled = true;
            }
        };
        if (update) obj.update = function(from, to, text, origin) {
            if (from) obj.from = clipPos(doc, from);
            if (to) obj.to = clipPos(doc, to);
            if (text) obj.text = text;
            if (origin !== undefined) obj.origin = origin;
        };
        signal(doc, "beforeChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeChange", doc.cm, obj);
        if (obj.canceled) {
            if (doc.cm) doc.cm.curOp.updateInput = 2;
            return null;
        }
        return {
            from: obj.from,
            to: obj.to,
            text: obj.text,
            origin: obj.origin
        };
    }
    // Apply a change to a document, and add it to the document's
    // history, and propagating it to all linked documents.
    function makeChange(doc, change, ignoreReadOnly) {
        if (doc.cm) {
            if (!doc.cm.curOp) return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
            if (doc.cm.state.suppressEdits) return;
        }
        if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
            change = filterChange(doc, change, true);
            if (!change) return;
        }
        // Possibly split or suppress the update based on the presence
        // of read-only spans in its range.
        var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
        if (split) for(var i = split.length - 1; i >= 0; --i)makeChangeInner(doc, {
            from: split[i].from,
            to: split[i].to,
            text: i ? [
                ""
            ] : change.text,
            origin: change.origin
        });
        else makeChangeInner(doc, change);
    }
    function makeChangeInner(doc, change) {
        if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) return;
        var selAfter = computeSelAfterChange(doc, change);
        addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
        makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
        var rebased = [];
        linkedDocs(doc, function(doc, sharedHist) {
            if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                rebaseHist(doc.history, change);
                rebased.push(doc.history);
            }
            makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
        });
    }
    // Revert a change stored in a document's history.
    function makeChangeFromHistory(doc, type, allowSelectionOnly) {
        var suppress = doc.cm && doc.cm.state.suppressEdits;
        if (suppress && !allowSelectionOnly) return;
        var hist = doc.history, event, selAfter = doc.sel;
        var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
        // Verify that there is a useable event (so that ctrl-z won't
        // needlessly clear selection events)
        var i = 0;
        for(; i < source.length; i++){
            event = source[i];
            if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) break;
        }
        if (i == source.length) return;
        hist.lastOrigin = hist.lastSelOrigin = null;
        for(;;){
            event = source.pop();
            if (event.ranges) {
                pushSelectionToHistory(event, dest);
                if (allowSelectionOnly && !event.equals(doc.sel)) {
                    setSelection(doc, event, {
                        clearRedo: false
                    });
                    return;
                }
                selAfter = event;
            } else if (suppress) {
                source.push(event);
                return;
            } else break;
        }
        // Build up a reverse change object to add to the opposite history
        // stack (redo when undoing, and vice versa).
        var antiChanges = [];
        pushSelectionToHistory(selAfter, dest);
        dest.push({
            changes: antiChanges,
            generation: hist.generation
        });
        hist.generation = event.generation || ++hist.maxGeneration;
        var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
        var loop = function(i) {
            var change = event.changes[i];
            change.origin = type;
            if (filter && !filterChange(doc, change, false)) {
                source.length = 0;
                return {};
            }
            antiChanges.push(historyChangeFromChange(doc, change));
            var after = i ? computeSelAfterChange(doc, change) : lst(source);
            makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
            if (!i && doc.cm) doc.cm.scrollIntoView({
                from: change.from,
                to: changeEnd(change)
            });
            var rebased = [];
            // Propagate to the linked documents
            linkedDocs(doc, function(doc, sharedHist) {
                if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                    rebaseHist(doc.history, change);
                    rebased.push(doc.history);
                }
                makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
            });
        };
        for(var i$1 = event.changes.length - 1; i$1 >= 0; --i$1){
            var returned = loop(i$1);
            if (returned) return returned.v;
        }
    }
    // Sub-views need their line numbers shifted when text is added
    // above or below them in the parent document.
    function shiftDoc(doc, distance) {
        if (distance == 0) return;
        doc.first += distance;
        doc.sel = new Selection(map(doc.sel.ranges, function(range) {
            return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
        }), doc.sel.primIndex);
        if (doc.cm) {
            regChange(doc.cm, doc.first, doc.first - distance, distance);
            for(var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)regLineChange(doc.cm, l, "gutter");
        }
    }
    // More lower-level change function, handling only a single document
    // (not linked ones).
    function makeChangeSingleDoc(doc, change, selAfter, spans) {
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
        if (change.to.line < doc.first) {
            shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
            return;
        }
        if (change.from.line > doc.lastLine()) return;
        // Clip the change to the size of this doc
        if (change.from.line < doc.first) {
            var shift = change.text.length - 1 - (doc.first - change.from.line);
            shiftDoc(doc, shift);
            change = {
                from: Pos(doc.first, 0),
                to: Pos(change.to.line + shift, change.to.ch),
                text: [
                    lst(change.text)
                ],
                origin: change.origin
            };
        }
        var last = doc.lastLine();
        if (change.to.line > last) change = {
            from: change.from,
            to: Pos(last, getLine(doc, last).text.length),
            text: [
                change.text[0]
            ],
            origin: change.origin
        };
        change.removed = getBetween(doc, change.from, change.to);
        if (!selAfter) selAfter = computeSelAfterChange(doc, change);
        if (doc.cm) makeChangeSingleDocInEditor(doc.cm, change, spans);
        else updateDoc(doc, change, spans);
        setSelectionNoUndo(doc, selAfter, sel_dontScroll);
        if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0))) doc.cantEdit = false;
    }
    // Handle the interaction of a change to a document with the editor
    // that this document is part of.
    function makeChangeSingleDocInEditor(cm, change, spans) {
        var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
        var recomputeMaxLength = false, checkWidthStart = from.line;
        if (!cm.options.lineWrapping) {
            checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
            doc.iter(checkWidthStart, to.line + 1, function(line) {
                if (line == display.maxLine) {
                    recomputeMaxLength = true;
                    return true;
                }
            });
        }
        if (doc.sel.contains(change.from, change.to) > -1) signalCursorActivity(cm);
        updateDoc(doc, change, spans, estimateHeight(cm));
        if (!cm.options.lineWrapping) {
            doc.iter(checkWidthStart, from.line + change.text.length, function(line) {
                var len = lineLength(line);
                if (len > display.maxLineLength) {
                    display.maxLine = line;
                    display.maxLineLength = len;
                    display.maxLineChanged = true;
                    recomputeMaxLength = false;
                }
            });
            if (recomputeMaxLength) cm.curOp.updateMaxLine = true;
        }
        retreatFrontier(doc, from.line);
        startWorker(cm, 400);
        var lendiff = change.text.length - (to.line - from.line) - 1;
        // Remember that these lines changed, for updating the display
        if (change.full) regChange(cm);
        else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) regLineChange(cm, from.line, "text");
        else regChange(cm, from.line, to.line + 1, lendiff);
        var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
        if (changeHandler || changesHandler) {
            var obj = {
                from: from,
                to: to,
                text: change.text,
                removed: change.removed,
                origin: change.origin
            };
            if (changeHandler) signalLater(cm, "change", cm, obj);
            if (changesHandler) (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
        }
        cm.display.selForContextMenu = null;
    }
    function replaceRange(doc, code, from, to, origin) {
        var assign;
        if (!to) to = from;
        if (cmp(to, from) < 0) assign = [
            to,
            from
        ], from = assign[0], to = assign[1];
        if (typeof code == "string") code = doc.splitLines(code);
        makeChange(doc, {
            from: from,
            to: to,
            text: code,
            origin: origin
        });
    }
    // Rebasing/resetting history to deal with externally-sourced changes
    function rebaseHistSelSingle(pos, from, to, diff) {
        if (to < pos.line) pos.line += diff;
        else if (from < pos.line) {
            pos.line = from;
            pos.ch = 0;
        }
    }
    // Tries to rebase an array of history events given a change in the
    // document. If the change touches the same lines as the event, the
    // event, and everything 'behind' it, is discarded. If the change is
    // before the event, the event's positions are updated. Uses a
    // copy-on-write scheme for the positions, to avoid having to
    // reallocate them all on every rebase, but also avoid problems with
    // shared position objects being unsafely updated.
    function rebaseHistArray(array, from, to, diff) {
        for(var i = 0; i < array.length; ++i){
            var sub = array[i], ok = true;
            if (sub.ranges) {
                if (!sub.copied) {
                    sub = array[i] = sub.deepCopy();
                    sub.copied = true;
                }
                for(var j = 0; j < sub.ranges.length; j++){
                    rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
                    rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
                }
                continue;
            }
            for(var j$1 = 0; j$1 < sub.changes.length; ++j$1){
                var cur = sub.changes[j$1];
                if (to < cur.from.line) {
                    cur.from = Pos(cur.from.line + diff, cur.from.ch);
                    cur.to = Pos(cur.to.line + diff, cur.to.ch);
                } else if (from <= cur.to.line) {
                    ok = false;
                    break;
                }
            }
            if (!ok) {
                array.splice(0, i + 1);
                i = 0;
            }
        }
    }
    function rebaseHist(hist, change) {
        var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
        rebaseHistArray(hist.done, from, to, diff);
        rebaseHistArray(hist.undone, from, to, diff);
    }
    // Utility for applying a change to a line by handle or number,
    // returning the number and optionally registering the line as
    // changed.
    function changeLine(doc, handle, changeType, op) {
        var no = handle, line = handle;
        if (typeof handle == "number") line = getLine(doc, clipLine(doc, handle));
        else no = lineNo(handle);
        if (no == null) return null;
        if (op(line, no) && doc.cm) regLineChange(doc.cm, no, changeType);
        return line;
    }
    // The document is represented as a BTree consisting of leaves, with
    // chunk of lines in them, and branches, with up to ten leaves or
    // other branch nodes below them. The top node is always a branch
    // node, and is the document object itself (meaning it has
    // additional methods and properties).
    //
    // All nodes have parent links. The tree is used both to go from
    // line numbers to line objects, and to go from objects to numbers.
    // It also indexes by height, and is used to convert between height
    // and line object, and to find the total height of the document.
    //
    // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
    function LeafChunk(lines) {
        this.lines = lines;
        this.parent = null;
        var height = 0;
        for(var i = 0; i < lines.length; ++i){
            lines[i].parent = this;
            height += lines[i].height;
        }
        this.height = height;
    }
    LeafChunk.prototype = {
        chunkSize: function() {
            return this.lines.length;
        },
        // Remove the n lines at offset 'at'.
        removeInner: function(at, n) {
            for(var i = at, e = at + n; i < e; ++i){
                var line = this.lines[i];
                this.height -= line.height;
                cleanUpLine(line);
                signalLater(line, "delete");
            }
            this.lines.splice(at, n);
        },
        // Helper used to collapse a small branch into a single leaf.
        collapse: function(lines) {
            lines.push.apply(lines, this.lines);
        },
        // Insert the given array of lines at offset 'at', count them as
        // having the given height.
        insertInner: function(at, lines, height) {
            this.height += height;
            this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
            for(var i = 0; i < lines.length; ++i)lines[i].parent = this;
        },
        // Used to iterate over a part of the tree.
        iterN: function(at, n, op) {
            for(var e = at + n; at < e; ++at){
                if (op(this.lines[at])) return true;
            }
        }
    };
    function BranchChunk(children) {
        this.children = children;
        var size = 0, height = 0;
        for(var i = 0; i < children.length; ++i){
            var ch = children[i];
            size += ch.chunkSize();
            height += ch.height;
            ch.parent = this;
        }
        this.size = size;
        this.height = height;
        this.parent = null;
    }
    BranchChunk.prototype = {
        chunkSize: function() {
            return this.size;
        },
        removeInner: function(at, n) {
            this.size -= n;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var rm = Math.min(n, sz - at), oldHeight = child.height;
                    child.removeInner(at, rm);
                    this.height -= oldHeight - child.height;
                    if (sz == rm) {
                        this.children.splice(i--, 1);
                        child.parent = null;
                    }
                    if ((n -= rm) == 0) break;
                    at = 0;
                } else at -= sz;
            }
            // If the result is smaller than 25 lines, ensure that it is a
            // single leaf node.
            if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
                var lines = [];
                this.collapse(lines);
                this.children = [
                    new LeafChunk(lines)
                ];
                this.children[0].parent = this;
            }
        },
        collapse: function(lines) {
            for(var i = 0; i < this.children.length; ++i)this.children[i].collapse(lines);
        },
        insertInner: function(at, lines, height) {
            this.size += lines.length;
            this.height += height;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at <= sz) {
                    child.insertInner(at, lines, height);
                    if (child.lines && child.lines.length > 50) {
                        // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
                        // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
                        var remaining = child.lines.length % 25 + 25;
                        for(var pos = remaining; pos < child.lines.length;){
                            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
                            child.height -= leaf.height;
                            this.children.splice(++i, 0, leaf);
                            leaf.parent = this;
                        }
                        child.lines = child.lines.slice(0, remaining);
                        this.maybeSpill();
                    }
                    break;
                }
                at -= sz;
            }
        },
        // When a node has grown, check whether it should be split.
        maybeSpill: function() {
            if (this.children.length <= 10) return;
            var me = this;
            do {
                var spilled = me.children.splice(me.children.length - 5, 5);
                var sibling = new BranchChunk(spilled);
                if (!me.parent) {
                    var copy = new BranchChunk(me.children);
                    copy.parent = me;
                    me.children = [
                        copy,
                        sibling
                    ];
                    me = copy;
                } else {
                    me.size -= sibling.size;
                    me.height -= sibling.height;
                    var myIndex = indexOf(me.parent.children, me);
                    me.parent.children.splice(myIndex + 1, 0, sibling);
                }
                sibling.parent = me.parent;
            }while (me.children.length > 10);
            me.parent.maybeSpill();
        },
        iterN: function(at, n, op) {
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var used = Math.min(n, sz - at);
                    if (child.iterN(at, used, op)) return true;
                    if ((n -= used) == 0) break;
                    at = 0;
                } else at -= sz;
            }
        }
    };
    // Line widgets are block elements displayed above or below a line.
    var LineWidget = function(doc, node, options) {
        if (options) {
            for(var opt in options)if (options.hasOwnProperty(opt)) this[opt] = options[opt];
        }
        this.doc = doc;
        this.node = node;
    };
    LineWidget.prototype.clear = function() {
        var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
        if (no == null || !ws) return;
        for(var i = 0; i < ws.length; ++i)if (ws[i] == this) ws.splice(i--, 1);
        if (!ws.length) line.widgets = null;
        var height = widgetHeight(this);
        updateLineHeight(line, Math.max(0, line.height - height));
        if (cm) {
            runInOp(cm, function() {
                adjustScrollWhenAboveVisible(cm, line, -height);
                regLineChange(cm, no, "widget");
            });
            signalLater(cm, "lineWidgetCleared", cm, this, no);
        }
    };
    LineWidget.prototype.changed = function() {
        var this$1 = this;
        var oldH = this.height, cm = this.doc.cm, line = this.line;
        this.height = null;
        var diff = widgetHeight(this) - oldH;
        if (!diff) return;
        if (!lineIsHidden(this.doc, line)) updateLineHeight(line, line.height + diff);
        if (cm) runInOp(cm, function() {
            cm.curOp.forceUpdate = true;
            adjustScrollWhenAboveVisible(cm, line, diff);
            signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
        });
    };
    eventMixin(LineWidget);
    function adjustScrollWhenAboveVisible(cm, line, diff) {
        if (heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) addToScrollTop(cm, diff);
    }
    function addLineWidget(doc, handle, node, options) {
        var widget = new LineWidget(doc, node, options);
        var cm = doc.cm;
        if (cm && widget.noHScroll) cm.display.alignWidgets = true;
        changeLine(doc, handle, "widget", function(line) {
            var widgets = line.widgets || (line.widgets = []);
            if (widget.insertAt == null) widgets.push(widget);
            else widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget);
            widget.line = line;
            if (cm && !lineIsHidden(doc, line)) {
                var aboveVisible = heightAtLine(line) < doc.scrollTop;
                updateLineHeight(line, line.height + widgetHeight(widget));
                if (aboveVisible) addToScrollTop(cm, widget.height);
                cm.curOp.forceUpdate = true;
            }
            return true;
        });
        if (cm) signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
        return widget;
    }
    // TEXTMARKERS
    // Created with markText and setBookmark methods. A TextMarker is a
    // handle that can be used to clear or find a marked position in the
    // document. Line objects hold arrays (markedSpans) containing
    // {from, to, marker} object pointing to such marker objects, and
    // indicating that such a marker is present on that line. Multiple
    // lines may point to the same marker when it spans across lines.
    // The spans will have null for their from/to properties when the
    // marker continues beyond the start/end of the line. Markers have
    // links back to the lines they currently touch.
    // Collapsed markers have unique ids, in order to be able to order
    // them, which is needed for uniquely determining an outer marker
    // when they overlap (they may nest, but not partially overlap).
    var nextMarkerId = 0;
    var TextMarker = function(doc, type) {
        this.lines = [];
        this.type = type;
        this.doc = doc;
        this.id = ++nextMarkerId;
    };
    // Clear the marker.
    TextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) return;
        var cm = this.doc.cm, withOp = cm && !cm.curOp;
        if (withOp) startOperation(cm);
        if (hasHandler(this, "clear")) {
            var found = this.find();
            if (found) signalLater(this, "clear", found.from, found.to);
        }
        var min = null, max = null;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (cm && !this.collapsed) regLineChange(cm, lineNo(line), "text");
            else if (cm) {
                if (span.to != null) max = lineNo(line);
                if (span.from != null) min = lineNo(line);
            }
            line.markedSpans = removeMarkedSpan(line.markedSpans, span);
            if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm) updateLineHeight(line, textHeight(cm.display));
        }
        if (cm && this.collapsed && !cm.options.lineWrapping) for(var i$1 = 0; i$1 < this.lines.length; ++i$1){
            var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
            if (len > cm.display.maxLineLength) {
                cm.display.maxLine = visual;
                cm.display.maxLineLength = len;
                cm.display.maxLineChanged = true;
            }
        }
        if (min != null && cm && this.collapsed) regChange(cm, min, max + 1);
        this.lines.length = 0;
        this.explicitlyCleared = true;
        if (this.atomic && this.doc.cantEdit) {
            this.doc.cantEdit = false;
            if (cm) reCheckSelection(cm.doc);
        }
        if (cm) signalLater(cm, "markerCleared", cm, this, min, max);
        if (withOp) endOperation(cm);
        if (this.parent) this.parent.clear();
    };
    // Find the position of the marker in the document. Returns a {from,
    // to} object by default. Side can be passed to get a specific side
    // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
    // Pos objects returned contain a line object, rather than a line
    // number (used to prevent looking up the same line twice).
    TextMarker.prototype.find = function(side, lineObj) {
        if (side == null && this.type == "bookmark") side = 1;
        var from, to;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (span.from != null) {
                from = Pos(lineObj ? line : lineNo(line), span.from);
                if (side == -1) return from;
            }
            if (span.to != null) {
                to = Pos(lineObj ? line : lineNo(line), span.to);
                if (side == 1) return to;
            }
        }
        return from && {
            from: from,
            to: to
        };
    };
    // Signals that the marker's widget changed, and surrounding layout
    // should be recomputed.
    TextMarker.prototype.changed = function() {
        var this$1 = this;
        var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
        if (!pos || !cm) return;
        runInOp(cm, function() {
            var line = pos.line, lineN = lineNo(pos.line);
            var view = findViewForLine(cm, lineN);
            if (view) {
                clearLineMeasurementCacheFor(view);
                cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
            }
            cm.curOp.updateMaxLine = true;
            if (!lineIsHidden(widget.doc, line) && widget.height != null) {
                var oldHeight = widget.height;
                widget.height = null;
                var dHeight = widgetHeight(widget) - oldHeight;
                if (dHeight) updateLineHeight(line, line.height + dHeight);
            }
            signalLater(cm, "markerChanged", cm, this$1);
        });
    };
    TextMarker.prototype.attachLine = function(line) {
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
        }
        this.lines.push(line);
    };
    TextMarker.prototype.detachLine = function(line) {
        this.lines.splice(indexOf(this.lines, line), 1);
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            (op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
        }
    };
    eventMixin(TextMarker);
    // Create a marker, wire it up to the right lines, and
    function markText(doc, from, to, options, type) {
        // Shared markers (across linked documents) are handled separately
        // (markTextShared will call out to this again, once per
        // document).
        if (options && options.shared) return markTextShared(doc, from, to, options, type);
        // Ensure we are in an operation.
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, markText)(doc, from, to, options, type);
        var marker = new TextMarker(doc, type), diff = cmp(from, to);
        if (options) copyObj(options, marker, false);
        // Don't connect empty markers unless clearWhenEmpty is false
        if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) return marker;
        if (marker.replacedWith) {
            // Showing up as a widget implies collapsed (widget replaces text)
            marker.collapsed = true;
            marker.widgetNode = eltP("span", [
                marker.replacedWith
            ], "CodeMirror-widget");
            if (!options.handleMouseEvents) marker.widgetNode.setAttribute("cm-ignore-events", "true");
            if (options.insertLeft) marker.widgetNode.insertLeft = true;
        }
        if (marker.collapsed) {
            if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
            seeCollapsedSpans();
        }
        if (marker.addToHistory) addChangeToHistory(doc, {
            from: from,
            to: to,
            origin: "markText"
        }, doc.sel, NaN);
        var curLine = from.line, cm = doc.cm, updateMaxLine;
        doc.iter(curLine, to.line + 1, function(line) {
            if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) updateMaxLine = true;
            if (marker.collapsed && curLine != from.line) updateLineHeight(line, 0);
            addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
            ++curLine;
        });
        // lineIsHidden depends on the presence of the spans, so needs a second pass
        if (marker.collapsed) doc.iter(from.line, to.line + 1, function(line) {
            if (lineIsHidden(doc, line)) updateLineHeight(line, 0);
        });
        if (marker.clearOnEnter) on(marker, "beforeCursorEnter", function() {
            return marker.clear();
        });
        if (marker.readOnly) {
            seeReadOnlySpans();
            if (doc.history.done.length || doc.history.undone.length) doc.clearHistory();
        }
        if (marker.collapsed) {
            marker.id = ++nextMarkerId;
            marker.atomic = true;
        }
        if (cm) {
            // Sync editor state
            if (updateMaxLine) cm.curOp.updateMaxLine = true;
            if (marker.collapsed) regChange(cm, from.line, to.line + 1);
            else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) for(var i = from.line; i <= to.line; i++)regLineChange(cm, i, "text");
            if (marker.atomic) reCheckSelection(cm.doc);
            signalLater(cm, "markerAdded", cm, marker);
        }
        return marker;
    }
    // SHARED TEXTMARKERS
    // A shared marker spans multiple linked documents. It is
    // implemented as a meta-marker-object controlling multiple normal
    // markers.
    var SharedTextMarker = function(markers, primary) {
        this.markers = markers;
        this.primary = primary;
        for(var i = 0; i < markers.length; ++i)markers[i].parent = this;
    };
    SharedTextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) return;
        this.explicitlyCleared = true;
        for(var i = 0; i < this.markers.length; ++i)this.markers[i].clear();
        signalLater(this, "clear");
    };
    SharedTextMarker.prototype.find = function(side, lineObj) {
        return this.primary.find(side, lineObj);
    };
    eventMixin(SharedTextMarker);
    function markTextShared(doc, from, to, options, type) {
        options = copyObj(options);
        options.shared = false;
        var markers = [
            markText(doc, from, to, options, type)
        ], primary = markers[0];
        var widget = options.widgetNode;
        linkedDocs(doc, function(doc) {
            if (widget) options.widgetNode = widget.cloneNode(true);
            markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
            for(var i = 0; i < doc.linked.length; ++i){
                if (doc.linked[i].isParent) return;
            }
            primary = lst(markers);
        });
        return new SharedTextMarker(markers, primary);
    }
    function findSharedMarkers(doc) {
        return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function(m) {
            return m.parent;
        });
    }
    function copySharedMarkers(doc, markers) {
        for(var i = 0; i < markers.length; i++){
            var marker = markers[i], pos = marker.find();
            var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
            if (cmp(mFrom, mTo)) {
                var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
                marker.markers.push(subMark);
                subMark.parent = marker;
            }
        }
    }
    function detachSharedMarkers(markers) {
        var loop = function(i) {
            var marker = markers[i], linked = [
                marker.primary.doc
            ];
            linkedDocs(marker.primary.doc, function(d) {
                return linked.push(d);
            });
            for(var j = 0; j < marker.markers.length; j++){
                var subMarker = marker.markers[j];
                if (indexOf(linked, subMarker.doc) == -1) {
                    subMarker.parent = null;
                    marker.markers.splice(j--, 1);
                }
            }
        };
        for(var i = 0; i < markers.length; i++)loop(i);
    }
    var nextDocId = 0;
    var Doc = function(text, mode, firstLine, lineSep, direction) {
        if (!(this instanceof Doc)) return new Doc(text, mode, firstLine, lineSep, direction);
        if (firstLine == null) firstLine = 0;
        BranchChunk.call(this, [
            new LeafChunk([
                new Line("", null)
            ])
        ]);
        this.first = firstLine;
        this.scrollTop = this.scrollLeft = 0;
        this.cantEdit = false;
        this.cleanGeneration = 1;
        this.modeFrontier = this.highlightFrontier = firstLine;
        var start = Pos(firstLine, 0);
        this.sel = simpleSelection(start);
        this.history = new History(null);
        this.id = ++nextDocId;
        this.modeOption = mode;
        this.lineSep = lineSep;
        this.direction = direction == "rtl" ? "rtl" : "ltr";
        this.extend = false;
        if (typeof text == "string") text = this.splitLines(text);
        updateDoc(this, {
            from: start,
            to: start,
            text: text
        });
        setSelection(this, simpleSelection(start), sel_dontScroll);
    };
    Doc.prototype = createObj(BranchChunk.prototype, {
        constructor: Doc,
        // Iterate over the document. Supports two forms -- with only one
        // argument, it calls that for each line in the document. With
        // three, it iterates over the range given by the first two (with
        // the second being non-inclusive).
        iter: function(from, to, op) {
            if (op) this.iterN(from - this.first, to - from, op);
            else this.iterN(this.first, this.first + this.size, from);
        },
        // Non-public interface for adding and removing lines.
        insert: function(at, lines) {
            var height = 0;
            for(var i = 0; i < lines.length; ++i)height += lines[i].height;
            this.insertInner(at - this.first, lines, height);
        },
        remove: function(at, n) {
            this.removeInner(at - this.first, n);
        },
        // From here, the methods are part of the public interface. Most
        // are also available from CodeMirror (editor) instances.
        getValue: function(lineSep) {
            var lines = getLines(this, this.first, this.first + this.size);
            if (lineSep === false) return lines;
            return lines.join(lineSep || this.lineSeparator());
        },
        setValue: docMethodOp(function(code) {
            var top = Pos(this.first, 0), last = this.first + this.size - 1;
            makeChange(this, {
                from: top,
                to: Pos(last, getLine(this, last).text.length),
                text: this.splitLines(code),
                origin: "setValue",
                full: true
            }, true);
            if (this.cm) scrollToCoords(this.cm, 0, 0);
            setSelection(this, simpleSelection(top), sel_dontScroll);
        }),
        replaceRange: function(code, from, to, origin) {
            from = clipPos(this, from);
            to = to ? clipPos(this, to) : from;
            replaceRange(this, code, from, to, origin);
        },
        getRange: function(from, to, lineSep) {
            var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
            if (lineSep === false) return lines;
            if (lineSep === '') return lines.join('');
            return lines.join(lineSep || this.lineSeparator());
        },
        getLine: function(line) {
            var l = this.getLineHandle(line);
            return l && l.text;
        },
        getLineHandle: function(line) {
            if (isLine(this, line)) return getLine(this, line);
        },
        getLineNumber: function(line) {
            return lineNo(line);
        },
        getLineHandleVisualStart: function(line) {
            if (typeof line == "number") line = getLine(this, line);
            return visualLine(line);
        },
        lineCount: function() {
            return this.size;
        },
        firstLine: function() {
            return this.first;
        },
        lastLine: function() {
            return this.first + this.size - 1;
        },
        clipPos: function(pos) {
            return clipPos(this, pos);
        },
        getCursor: function(start) {
            var range = this.sel.primary(), pos;
            if (start == null || start == "head") pos = range.head;
            else if (start == "anchor") pos = range.anchor;
            else if (start == "end" || start == "to" || start === false) pos = range.to();
            else pos = range.from();
            return pos;
        },
        listSelections: function() {
            return this.sel.ranges;
        },
        somethingSelected: function() {
            return this.sel.somethingSelected();
        },
        setCursor: docMethodOp(function(line, ch, options) {
            setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
        }),
        setSelection: docMethodOp(function(anchor, head, options) {
            setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
        }),
        extendSelection: docMethodOp(function(head, other, options) {
            extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
        }),
        extendSelections: docMethodOp(function(heads, options) {
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        extendSelectionsBy: docMethodOp(function(f, options) {
            var heads = map(this.sel.ranges, f);
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        setSelections: docMethodOp(function(ranges, primary, options) {
            if (!ranges.length) return;
            var out = [];
            for(var i = 0; i < ranges.length; i++)out[i] = new Range(clipPos(this, ranges[i].anchor), clipPos(this, ranges[i].head || ranges[i].anchor));
            if (primary == null) primary = Math.min(ranges.length - 1, this.sel.primIndex);
            setSelection(this, normalizeSelection(this.cm, out, primary), options);
        }),
        addSelection: docMethodOp(function(anchor, head, options) {
            var ranges = this.sel.ranges.slice(0);
            ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
            setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
        }),
        getSelection: function(lineSep) {
            var ranges = this.sel.ranges, lines;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                lines = lines ? lines.concat(sel) : sel;
            }
            if (lineSep === false) return lines;
            else return lines.join(lineSep || this.lineSeparator());
        },
        getSelections: function(lineSep) {
            var parts = [], ranges = this.sel.ranges;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                if (lineSep !== false) sel = sel.join(lineSep || this.lineSeparator());
                parts[i] = sel;
            }
            return parts;
        },
        replaceSelection: function(code, collapse, origin) {
            var dup = [];
            for(var i = 0; i < this.sel.ranges.length; i++)dup[i] = code;
            this.replaceSelections(dup, collapse, origin || "+input");
        },
        replaceSelections: docMethodOp(function(code, collapse, origin) {
            var changes = [], sel = this.sel;
            for(var i = 0; i < sel.ranges.length; i++){
                var range = sel.ranges[i];
                changes[i] = {
                    from: range.from(),
                    to: range.to(),
                    text: this.splitLines(code[i]),
                    origin: origin
                };
            }
            var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
            for(var i$1 = changes.length - 1; i$1 >= 0; i$1--)makeChange(this, changes[i$1]);
            if (newSel) setSelectionReplaceHistory(this, newSel);
            else if (this.cm) ensureCursorVisible(this.cm);
        }),
        undo: docMethodOp(function() {
            makeChangeFromHistory(this, "undo");
        }),
        redo: docMethodOp(function() {
            makeChangeFromHistory(this, "redo");
        }),
        undoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "undo", true);
        }),
        redoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "redo", true);
        }),
        setExtending: function(val) {
            this.extend = val;
        },
        getExtending: function() {
            return this.extend;
        },
        historySize: function() {
            var hist = this.history, done = 0, undone = 0;
            for(var i = 0; i < hist.done.length; i++)if (!hist.done[i].ranges) ++done;
            for(var i$1 = 0; i$1 < hist.undone.length; i$1++)if (!hist.undone[i$1].ranges) ++undone;
            return {
                undo: done,
                redo: undone
            };
        },
        clearHistory: function() {
            var this$1 = this;
            this.history = new History(this.history);
            linkedDocs(this, function(doc) {
                return doc.history = this$1.history;
            }, true);
        },
        markClean: function() {
            this.cleanGeneration = this.changeGeneration(true);
        },
        changeGeneration: function(forceSplit) {
            if (forceSplit) this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
            return this.history.generation;
        },
        isClean: function(gen) {
            return this.history.generation == (gen || this.cleanGeneration);
        },
        getHistory: function() {
            return {
                done: copyHistoryArray(this.history.done),
                undone: copyHistoryArray(this.history.undone)
            };
        },
        setHistory: function(histData) {
            var hist = this.history = new History(this.history);
            hist.done = copyHistoryArray(histData.done.slice(0), null, true);
            hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
        },
        setGutterMarker: docMethodOp(function(line, gutterID, value) {
            return changeLine(this, line, "gutter", function(line) {
                var markers = line.gutterMarkers || (line.gutterMarkers = {});
                markers[gutterID] = value;
                if (!value && isEmpty(markers)) line.gutterMarkers = null;
                return true;
            });
        }),
        clearGutter: docMethodOp(function(gutterID) {
            var this$1 = this;
            this.iter(function(line) {
                if (line.gutterMarkers && line.gutterMarkers[gutterID]) changeLine(this$1, line, "gutter", function() {
                    line.gutterMarkers[gutterID] = null;
                    if (isEmpty(line.gutterMarkers)) line.gutterMarkers = null;
                    return true;
                });
            });
        }),
        lineInfo: function(line) {
            var n;
            if (typeof line == "number") {
                if (!isLine(this, line)) return null;
                n = line;
                line = getLine(this, line);
                if (!line) return null;
            } else {
                n = lineNo(line);
                if (n == null) return null;
            }
            return {
                line: n,
                handle: line,
                text: line.text,
                gutterMarkers: line.gutterMarkers,
                textClass: line.textClass,
                bgClass: line.bgClass,
                wrapClass: line.wrapClass,
                widgets: line.widgets
            };
        },
        addLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                if (!line[prop]) line[prop] = cls;
                else if (classTest(cls).test(line[prop])) return false;
                else line[prop] += " " + cls;
                return true;
            });
        }),
        removeLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                var cur = line[prop];
                if (!cur) return false;
                else if (cls == null) line[prop] = null;
                else {
                    var found = cur.match(classTest(cls));
                    if (!found) return false;
                    var end = found.index + found[0].length;
                    line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
                }
                return true;
            });
        }),
        addLineWidget: docMethodOp(function(handle, node, options) {
            return addLineWidget(this, handle, node, options);
        }),
        removeLineWidget: function(widget) {
            widget.clear();
        },
        markText: function(from, to, options) {
            return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range");
        },
        setBookmark: function(pos, options) {
            var realOpts = {
                replacedWith: options && (options.nodeType == null ? options.widget : options),
                insertLeft: options && options.insertLeft,
                clearWhenEmpty: false,
                shared: options && options.shared,
                handleMouseEvents: options && options.handleMouseEvents
            };
            pos = clipPos(this, pos);
            return markText(this, pos, pos, realOpts, "bookmark");
        },
        findMarksAt: function(pos) {
            pos = clipPos(this, pos);
            var markers = [], spans = getLine(this, pos.line).markedSpans;
            if (spans) for(var i = 0; i < spans.length; ++i){
                var span = spans[i];
                if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) markers.push(span.marker.parent || span.marker);
            }
            return markers;
        },
        findMarks: function(from, to, filter) {
            from = clipPos(this, from);
            to = clipPos(this, to);
            var found = [], lineNo = from.line;
            this.iter(from.line, to.line + 1, function(line) {
                var spans = line.markedSpans;
                if (spans) for(var i = 0; i < spans.length; i++){
                    var span = spans[i];
                    if (!(span.to != null && lineNo == from.line && from.ch >= span.to || span.from == null && lineNo != from.line || span.from != null && lineNo == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) found.push(span.marker.parent || span.marker);
                }
                ++lineNo;
            });
            return found;
        },
        getAllMarks: function() {
            var markers = [];
            this.iter(function(line) {
                var sps = line.markedSpans;
                if (sps) {
                    for(var i = 0; i < sps.length; ++i)if (sps[i].from != null) markers.push(sps[i].marker);
                }
            });
            return markers;
        },
        posFromIndex: function(off) {
            var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
            this.iter(function(line) {
                var sz = line.text.length + sepSize;
                if (sz > off) {
                    ch = off;
                    return true;
                }
                off -= sz;
                ++lineNo;
            });
            return clipPos(this, Pos(lineNo, ch));
        },
        indexFromPos: function(coords) {
            coords = clipPos(this, coords);
            var index = coords.ch;
            if (coords.line < this.first || coords.ch < 0) return 0;
            var sepSize = this.lineSeparator().length;
            this.iter(this.first, coords.line, function(line) {
                index += line.text.length + sepSize;
            });
            return index;
        },
        copy: function(copyHistory) {
            var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
            doc.scrollTop = this.scrollTop;
            doc.scrollLeft = this.scrollLeft;
            doc.sel = this.sel;
            doc.extend = false;
            if (copyHistory) {
                doc.history.undoDepth = this.history.undoDepth;
                doc.setHistory(this.getHistory());
            }
            return doc;
        },
        linkedDoc: function(options) {
            if (!options) options = {};
            var from = this.first, to = this.first + this.size;
            if (options.from != null && options.from > from) from = options.from;
            if (options.to != null && options.to < to) to = options.to;
            var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
            if (options.sharedHist) copy.history = this.history;
            (this.linked || (this.linked = [])).push({
                doc: copy,
                sharedHist: options.sharedHist
            });
            copy.linked = [
                {
                    doc: this,
                    isParent: true,
                    sharedHist: options.sharedHist
                }
            ];
            copySharedMarkers(copy, findSharedMarkers(this));
            return copy;
        },
        unlinkDoc: function(other) {
            if (other instanceof CodeMirror) other = other.doc;
            if (this.linked) for(var i = 0; i < this.linked.length; ++i){
                var link = this.linked[i];
                if (link.doc != other) continue;
                this.linked.splice(i, 1);
                other.unlinkDoc(this);
                detachSharedMarkers(findSharedMarkers(this));
                break;
            }
            // If the histories were shared, split them again
            if (other.history == this.history) {
                var splitIds = [
                    other.id
                ];
                linkedDocs(other, function(doc) {
                    return splitIds.push(doc.id);
                }, true);
                other.history = new History(null);
                other.history.done = copyHistoryArray(this.history.done, splitIds);
                other.history.undone = copyHistoryArray(this.history.undone, splitIds);
            }
        },
        iterLinkedDocs: function(f) {
            linkedDocs(this, f);
        },
        getMode: function() {
            return this.mode;
        },
        getEditor: function() {
            return this.cm;
        },
        splitLines: function(str) {
            if (this.lineSep) return str.split(this.lineSep);
            return splitLinesAuto(str);
        },
        lineSeparator: function() {
            return this.lineSep || "\n";
        },
        setDirection: docMethodOp(function(dir) {
            if (dir != "rtl") dir = "ltr";
            if (dir == this.direction) return;
            this.direction = dir;
            this.iter(function(line) {
                return line.order = null;
            });
            if (this.cm) directionChanged(this.cm);
        })
    });
    // Public alias.
    Doc.prototype.eachLine = Doc.prototype.iter;
    // Kludge to work around strange IE behavior where it'll sometimes
    // re-fire a series of drag-related events right after the drop (#1551)
    var lastDrop = 0;
    function onDrop(e) {
        var cm = this;
        clearDragCursor(cm);
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e_preventDefault(e);
        if (ie) lastDrop = +new Date;
        var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
        if (!pos || cm.isReadOnly()) return;
        // Might be a file drop, in which case we simply extract the text
        // and insert it.
        if (files && files.length && window.FileReader && window.File) {
            var n = files.length, text = Array(n), read = 0;
            var markAsReadAndPasteIfAllFilesAreRead = function() {
                if (++read == n) operation(cm, function() {
                    pos = clipPos(cm.doc, pos);
                    var change = {
                        from: pos,
                        to: pos,
                        text: cm.doc.splitLines(text.filter(function(t) {
                            return t != null;
                        }).join(cm.doc.lineSeparator())),
                        origin: "paste"
                    };
                    makeChange(cm.doc, change);
                    setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
                })();
            };
            var readTextFromFile = function(file, i) {
                if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
                    markAsReadAndPasteIfAllFilesAreRead();
                    return;
                }
                var reader = new FileReader;
                reader.onerror = function() {
                    return markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.onload = function() {
                    var content = reader.result;
                    if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
                        markAsReadAndPasteIfAllFilesAreRead();
                        return;
                    }
                    text[i] = content;
                    markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.readAsText(file);
            };
            for(var i = 0; i < files.length; i++)readTextFromFile(files[i], i);
        } else {
            // Don't do a replace if the drop happened inside of the selected text.
            if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
                cm.state.draggingText(e);
                // Ensure the editor is re-focused
                setTimeout(function() {
                    return cm.display.input.focus();
                }, 20);
                return;
            }
            try {
                var text$1 = e.dataTransfer.getData("Text");
                if (text$1) {
                    var selected;
                    if (cm.state.draggingText && !cm.state.draggingText.copy) selected = cm.listSelections();
                    setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
                    if (selected) for(var i$1 = 0; i$1 < selected.length; ++i$1)replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
                    cm.replaceSelection(text$1, "around", "paste");
                    cm.display.input.focus();
                }
            } catch (e$1) {}
        }
    }
    function onDragStart(cm, e) {
        if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) {
            e_stop(e);
            return;
        }
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e.dataTransfer.setData("Text", cm.getSelection());
        e.dataTransfer.effectAllowed = "copyMove";
        // Use dummy image instead of default browsers image.
        // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
        if (e.dataTransfer.setDragImage && !safari) {
            var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
            img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
            if (presto) {
                img.width = img.height = 1;
                cm.display.wrapper.appendChild(img);
                // Force a relayout, or Opera won't use our image for some obscure reason
                img._top = img.offsetTop;
            }
            e.dataTransfer.setDragImage(img, 0, 0);
            if (presto) img.parentNode.removeChild(img);
        }
    }
    function onDragOver(cm, e) {
        var pos = posFromMouse(cm, e);
        if (!pos) return;
        var frag = document.createDocumentFragment();
        drawSelectionCursor(cm, pos, frag);
        if (!cm.display.dragCursor) {
            cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
            cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
        }
        removeChildrenAndAdd(cm.display.dragCursor, frag);
    }
    function clearDragCursor(cm) {
        if (cm.display.dragCursor) {
            cm.display.lineSpace.removeChild(cm.display.dragCursor);
            cm.display.dragCursor = null;
        }
    }
    // These must be handled carefully, because naively registering a
    // handler for each editor will cause the editors to never be
    // garbage collected.
    function forEachCodeMirror(f) {
        if (!document.getElementsByClassName) return;
        var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
        for(var i = 0; i < byClass.length; i++){
            var cm = byClass[i].CodeMirror;
            if (cm) editors.push(cm);
        }
        if (editors.length) editors[0].operation(function() {
            for(var i = 0; i < editors.length; i++)f(editors[i]);
        });
    }
    var globalsRegistered = false;
    function ensureGlobalHandlers() {
        if (globalsRegistered) return;
        registerGlobalHandlers();
        globalsRegistered = true;
    }
    function registerGlobalHandlers() {
        // When the window resizes, we need to refresh active editors.
        var resizeTimer;
        on(window, "resize", function() {
            if (resizeTimer == null) resizeTimer = setTimeout(function() {
                resizeTimer = null;
                forEachCodeMirror(onResize);
            }, 100);
        });
        // When the window loses focus, we want to show the editor as blurred
        on(window, "blur", function() {
            return forEachCodeMirror(onBlur);
        });
    }
    // Called when the window resizes
    function onResize(cm) {
        var d = cm.display;
        // Might be a text scaling operation, clear size caches.
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        d.scrollbarsClipped = false;
        cm.setSize();
    }
    var keyNames = {
        3: "Pause",
        8: "Backspace",
        9: "Tab",
        13: "Enter",
        16: "Shift",
        17: "Ctrl",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Esc",
        32: "Space",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        44: "PrintScrn",
        45: "Insert",
        46: "Delete",
        59: ";",
        61: "=",
        91: "Mod",
        92: "Mod",
        93: "Mod",
        106: "*",
        107: "=",
        109: "-",
        110: ".",
        111: "/",
        145: "ScrollLock",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'",
        224: "Mod",
        63232: "Up",
        63233: "Down",
        63234: "Left",
        63235: "Right",
        63272: "Delete",
        63273: "Home",
        63275: "End",
        63276: "PageUp",
        63277: "PageDown",
        63302: "Insert"
    };
    // Number keys
    for(var i = 0; i < 10; i++)keyNames[i + 48] = keyNames[i + 96] = String(i);
    // Alphabetic keys
    for(var i$1 = 65; i$1 <= 90; i$1++)keyNames[i$1] = String.fromCharCode(i$1);
    // Function keys
    for(var i$2 = 1; i$2 <= 12; i$2++)keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
    var keyMap = {};
    keyMap.basic = {
        "Left": "goCharLeft",
        "Right": "goCharRight",
        "Up": "goLineUp",
        "Down": "goLineDown",
        "End": "goLineEnd",
        "Home": "goLineStartSmart",
        "PageUp": "goPageUp",
        "PageDown": "goPageDown",
        "Delete": "delCharAfter",
        "Backspace": "delCharBefore",
        "Shift-Backspace": "delCharBefore",
        "Tab": "defaultTab",
        "Shift-Tab": "indentAuto",
        "Enter": "newlineAndIndent",
        "Insert": "toggleOverwrite",
        "Esc": "singleSelection"
    };
    // Note that the save and find-related commands aren't defined by
    // default. User code or addons can define them. Unknown commands
    // are simply ignored.
    keyMap.pcDefault = {
        "Ctrl-A": "selectAll",
        "Ctrl-D": "deleteLine",
        "Ctrl-Z": "undo",
        "Shift-Ctrl-Z": "redo",
        "Ctrl-Y": "redo",
        "Ctrl-Home": "goDocStart",
        "Ctrl-End": "goDocEnd",
        "Ctrl-Up": "goLineUp",
        "Ctrl-Down": "goLineDown",
        "Ctrl-Left": "goGroupLeft",
        "Ctrl-Right": "goGroupRight",
        "Alt-Left": "goLineStart",
        "Alt-Right": "goLineEnd",
        "Ctrl-Backspace": "delGroupBefore",
        "Ctrl-Delete": "delGroupAfter",
        "Ctrl-S": "save",
        "Ctrl-F": "find",
        "Ctrl-G": "findNext",
        "Shift-Ctrl-G": "findPrev",
        "Shift-Ctrl-F": "replace",
        "Shift-Ctrl-R": "replaceAll",
        "Ctrl-[": "indentLess",
        "Ctrl-]": "indentMore",
        "Ctrl-U": "undoSelection",
        "Shift-Ctrl-U": "redoSelection",
        "Alt-U": "redoSelection",
        "fallthrough": "basic"
    };
    // Very basic readline/emacs-style bindings, which are standard on Mac.
    keyMap.emacsy = {
        "Ctrl-F": "goCharRight",
        "Ctrl-B": "goCharLeft",
        "Ctrl-P": "goLineUp",
        "Ctrl-N": "goLineDown",
        "Ctrl-A": "goLineStart",
        "Ctrl-E": "goLineEnd",
        "Ctrl-V": "goPageDown",
        "Shift-Ctrl-V": "goPageUp",
        "Ctrl-D": "delCharAfter",
        "Ctrl-H": "delCharBefore",
        "Alt-Backspace": "delWordBefore",
        "Ctrl-K": "killLine",
        "Ctrl-T": "transposeChars",
        "Ctrl-O": "openLine"
    };
    keyMap.macDefault = {
        "Cmd-A": "selectAll",
        "Cmd-D": "deleteLine",
        "Cmd-Z": "undo",
        "Shift-Cmd-Z": "redo",
        "Cmd-Y": "redo",
        "Cmd-Home": "goDocStart",
        "Cmd-Up": "goDocStart",
        "Cmd-End": "goDocEnd",
        "Cmd-Down": "goDocEnd",
        "Alt-Left": "goGroupLeft",
        "Alt-Right": "goGroupRight",
        "Cmd-Left": "goLineLeft",
        "Cmd-Right": "goLineRight",
        "Alt-Backspace": "delGroupBefore",
        "Ctrl-Alt-Backspace": "delGroupAfter",
        "Alt-Delete": "delGroupAfter",
        "Cmd-S": "save",
        "Cmd-F": "find",
        "Cmd-G": "findNext",
        "Shift-Cmd-G": "findPrev",
        "Cmd-Alt-F": "replace",
        "Shift-Cmd-Alt-F": "replaceAll",
        "Cmd-[": "indentLess",
        "Cmd-]": "indentMore",
        "Cmd-Backspace": "delWrappedLineLeft",
        "Cmd-Delete": "delWrappedLineRight",
        "Cmd-U": "undoSelection",
        "Shift-Cmd-U": "redoSelection",
        "Ctrl-Up": "goDocStart",
        "Ctrl-Down": "goDocEnd",
        "fallthrough": [
            "basic",
            "emacsy"
        ]
    };
    keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
    // KEYMAP DISPATCH
    function normalizeKeyName(name) {
        var parts = name.split(/-(?!$)/);
        name = parts[parts.length - 1];
        var alt, ctrl, shift, cmd;
        for(var i = 0; i < parts.length - 1; i++){
            var mod = parts[i];
            if (/^(cmd|meta|m)$/i.test(mod)) cmd = true;
            else if (/^a(lt)?$/i.test(mod)) alt = true;
            else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
            else if (/^s(hift)?$/i.test(mod)) shift = true;
            else throw new Error("Unrecognized modifier name: " + mod);
        }
        if (alt) name = "Alt-" + name;
        if (ctrl) name = "Ctrl-" + name;
        if (cmd) name = "Cmd-" + name;
        if (shift) name = "Shift-" + name;
        return name;
    }
    // This is a kludge to keep keymaps mostly working as raw objects
    // (backwards compatibility) while at the same time support features
    // like normalization and multi-stroke key bindings. It compiles a
    // new normalized keymap, and then updates the old object to reflect
    // this.
    function normalizeKeyMap(keymap) {
        var copy = {};
        for(var keyname in keymap)if (keymap.hasOwnProperty(keyname)) {
            var value = keymap[keyname];
            if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) continue;
            if (value == "...") {
                delete keymap[keyname];
                continue;
            }
            var keys = map(keyname.split(" "), normalizeKeyName);
            for(var i = 0; i < keys.length; i++){
                var val = void 0, name = void 0;
                if (i == keys.length - 1) {
                    name = keys.join(" ");
                    val = value;
                } else {
                    name = keys.slice(0, i + 1).join(" ");
                    val = "...";
                }
                var prev = copy[name];
                if (!prev) copy[name] = val;
                else if (prev != val) throw new Error("Inconsistent bindings for " + name);
            }
            delete keymap[keyname];
        }
        for(var prop in copy)keymap[prop] = copy[prop];
        return keymap;
    }
    function lookupKey(key, map, handle, context) {
        map = getKeyMap(map);
        var found = map.call ? map.call(key, context) : map[key];
        if (found === false) return "nothing";
        if (found === "...") return "multi";
        if (found != null && handle(found)) return "handled";
        if (map.fallthrough) {
            if (Object.prototype.toString.call(map.fallthrough) != "[object Array]") return lookupKey(key, map.fallthrough, handle, context);
            for(var i = 0; i < map.fallthrough.length; i++){
                var result = lookupKey(key, map.fallthrough[i], handle, context);
                if (result) return result;
            }
        }
    }
    // Modifier key presses don't count as 'real' key presses for the
    // purpose of keymap fallthrough.
    function isModifierKey(value) {
        var name = typeof value == "string" ? value : keyNames[value.keyCode];
        return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
    }
    function addModifierNames(name, event, noShift) {
        var base = name;
        if (event.altKey && base != "Alt") name = "Alt-" + name;
        if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") name = "Ctrl-" + name;
        if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") name = "Cmd-" + name;
        if (!noShift && event.shiftKey && base != "Shift") name = "Shift-" + name;
        return name;
    }
    // Look up the name of a key as indicated by an event object.
    function keyName(event, noShift) {
        if (presto && event.keyCode == 34 && event["char"]) return false;
        var name = keyNames[event.keyCode];
        if (name == null || event.altGraphKey) return false;
        // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
        // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
        if (event.keyCode == 3 && event.code) name = event.code;
        return addModifierNames(name, event, noShift);
    }
    function getKeyMap(val) {
        return typeof val == "string" ? keyMap[val] : val;
    }
    // Helper for deleting text near the selection(s), used to implement
    // backspace, delete, and similar functionality.
    function deleteNearSelection(cm, compute) {
        var ranges = cm.doc.sel.ranges, kill = [];
        // Build up a set of ranges to kill first, merging overlapping
        // ranges.
        for(var i = 0; i < ranges.length; i++){
            var toKill = compute(ranges[i]);
            while(kill.length && cmp(toKill.from, lst(kill).to) <= 0){
                var replaced = kill.pop();
                if (cmp(replaced.from, toKill.from) < 0) {
                    toKill.from = replaced.from;
                    break;
                }
            }
            kill.push(toKill);
        }
        // Next, remove those actual ranges.
        runInOp(cm, function() {
            for(var i = kill.length - 1; i >= 0; i--)replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
            ensureCursorVisible(cm);
        });
    }
    function moveCharLogically(line, ch, dir) {
        var target = skipExtendingChars(line.text, ch + dir, dir);
        return target < 0 || target > line.text.length ? null : target;
    }
    function moveLogically(line, start, dir) {
        var ch = moveCharLogically(line, start.ch, dir);
        return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
    }
    function endOfLine(visually, cm, lineObj, lineNo, dir) {
        if (visually) {
            if (cm.doc.direction == "rtl") dir = -dir;
            var order = getOrder(lineObj, cm.doc.direction);
            if (order) {
                var part = dir < 0 ? lst(order) : order[0];
                var moveInStorageOrder = dir < 0 == (part.level == 1);
                var sticky = moveInStorageOrder ? "after" : "before";
                var ch;
                // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
                // it could be that the last bidi part is not on the last visual line,
                // since visual lines contain content order-consecutive chunks.
                // Thus, in rtl, we are looking for the first (content-order) character
                // in the rtl chunk that is on the last line (that is, the same line
                // as the last (content-order) character).
                if (part.level > 0 || cm.doc.direction == "rtl") {
                    var prep = prepareMeasureForLine(cm, lineObj);
                    ch = dir < 0 ? lineObj.text.length - 1 : 0;
                    var targetTop = measureCharPrepared(cm, prep, ch).top;
                    ch = findFirst(function(ch) {
                        return measureCharPrepared(cm, prep, ch).top == targetTop;
                    }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
                    if (sticky == "before") ch = moveCharLogically(lineObj, ch, 1);
                } else ch = dir < 0 ? part.to : part.from;
                return new Pos(lineNo, ch, sticky);
            }
        }
        return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
    }
    function moveVisually(cm, line, start, dir) {
        var bidi = getOrder(line, cm.doc.direction);
        if (!bidi) return moveLogically(line, start, dir);
        if (start.ch >= line.text.length) {
            start.ch = line.text.length;
            start.sticky = "before";
        } else if (start.ch <= 0) {
            start.ch = 0;
            start.sticky = "after";
        }
        var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
        if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
        // nothing interesting happens.
        return moveLogically(line, start, dir);
        var mv = function(pos, dir) {
            return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir);
        };
        var prep;
        var getWrappedLineExtent = function(ch) {
            if (!cm.options.lineWrapping) return {
                begin: 0,
                end: line.text.length
            };
            prep = prep || prepareMeasureForLine(cm, line);
            return wrappedLineExtentChar(cm, line, prep, ch);
        };
        var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
        if (cm.doc.direction == "rtl" || part.level == 1) {
            var moveInStorageOrder = part.level == 1 == dir < 0;
            var ch = mv(start, moveInStorageOrder ? 1 : -1);
            if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
                // Case 2: We move within an rtl part or in an rtl editor on the same visual line
                var sticky = moveInStorageOrder ? "before" : "after";
                return new Pos(start.line, ch, sticky);
            }
        }
        // Case 3: Could not move within this bidi part in this visual line, so leave
        // the current bidi part
        var searchInVisualLine = function(partPos, dir, wrappedLineExtent) {
            var getRes = function(ch, moveInStorageOrder) {
                return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
            };
            for(; partPos >= 0 && partPos < bidi.length; partPos += dir){
                var part = bidi[partPos];
                var moveInStorageOrder = dir > 0 == (part.level != 1);
                var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
                if (part.from <= ch && ch < part.to) return getRes(ch, moveInStorageOrder);
                ch = moveInStorageOrder ? part.from : mv(part.to, -1);
                if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) return getRes(ch, moveInStorageOrder);
            }
        };
        // Case 3a: Look for other bidi parts on the same visual line
        var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
        if (res) return res;
        // Case 3b: Look for other bidi parts on the next visual line
        var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
        if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
            res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
            if (res) return res;
        }
        // Case 4: Nowhere to move
        return null;
    }
    // Commands are parameter-less actions that can be performed on an
    // editor, mostly used for keybindings.
    var commands = {
        selectAll: selectAll,
        singleSelection: function(cm) {
            return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
        },
        killLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                if (range.empty()) {
                    var len = getLine(cm.doc, range.head.line).text.length;
                    if (range.head.ch == len && range.head.line < cm.lastLine()) return {
                        from: range.head,
                        to: Pos(range.head.line + 1, 0)
                    };
                    else return {
                        from: range.head,
                        to: Pos(range.head.line, len)
                    };
                } else return {
                    from: range.from(),
                    to: range.to()
                };
            });
        },
        deleteLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
                };
            });
        },
        delLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: range.from()
                };
            });
        },
        delWrappedLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var leftPos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                return {
                    from: leftPos,
                    to: range.from()
                };
            });
        },
        delWrappedLineRight: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var rightPos = cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
                return {
                    from: range.from(),
                    to: rightPos
                };
            });
        },
        undo: function(cm) {
            return cm.undo();
        },
        redo: function(cm) {
            return cm.redo();
        },
        undoSelection: function(cm) {
            return cm.undoSelection();
        },
        redoSelection: function(cm) {
            return cm.redoSelection();
        },
        goDocStart: function(cm) {
            return cm.extendSelection(Pos(cm.firstLine(), 0));
        },
        goDocEnd: function(cm) {
            return cm.extendSelection(Pos(cm.lastLine()));
        },
        goLineStart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStart(cm, range.head.line);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineStartSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStartSmart(cm, range.head);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineEnd: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineEnd(cm, range.head.line);
            }, {
                origin: "+move",
                bias: -1
            });
        },
        goLineRight: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeft: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeftSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                var pos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                if (pos.ch < cm.getLine(pos.line).search(/\S/)) return lineStartSmart(cm, range.head);
                return pos;
            }, sel_move);
        },
        goLineUp: function(cm) {
            return cm.moveV(-1, "line");
        },
        goLineDown: function(cm) {
            return cm.moveV(1, "line");
        },
        goPageUp: function(cm) {
            return cm.moveV(-1, "page");
        },
        goPageDown: function(cm) {
            return cm.moveV(1, "page");
        },
        goCharLeft: function(cm) {
            return cm.moveH(-1, "char");
        },
        goCharRight: function(cm) {
            return cm.moveH(1, "char");
        },
        goColumnLeft: function(cm) {
            return cm.moveH(-1, "column");
        },
        goColumnRight: function(cm) {
            return cm.moveH(1, "column");
        },
        goWordLeft: function(cm) {
            return cm.moveH(-1, "word");
        },
        goGroupRight: function(cm) {
            return cm.moveH(1, "group");
        },
        goGroupLeft: function(cm) {
            return cm.moveH(-1, "group");
        },
        goWordRight: function(cm) {
            return cm.moveH(1, "word");
        },
        delCharBefore: function(cm) {
            return cm.deleteH(-1, "codepoint");
        },
        delCharAfter: function(cm) {
            return cm.deleteH(1, "char");
        },
        delWordBefore: function(cm) {
            return cm.deleteH(-1, "word");
        },
        delWordAfter: function(cm) {
            return cm.deleteH(1, "word");
        },
        delGroupBefore: function(cm) {
            return cm.deleteH(-1, "group");
        },
        delGroupAfter: function(cm) {
            return cm.deleteH(1, "group");
        },
        indentAuto: function(cm) {
            return cm.indentSelection("smart");
        },
        indentMore: function(cm) {
            return cm.indentSelection("add");
        },
        indentLess: function(cm) {
            return cm.indentSelection("subtract");
        },
        insertTab: function(cm) {
            return cm.replaceSelection("\t");
        },
        insertSoftTab: function(cm) {
            var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
            for(var i = 0; i < ranges.length; i++){
                var pos = ranges[i].from();
                var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
                spaces.push(spaceStr(tabSize - col % tabSize));
            }
            cm.replaceSelections(spaces);
        },
        defaultTab: function(cm) {
            if (cm.somethingSelected()) cm.indentSelection("add");
            else cm.execCommand("insertTab");
        },
        // Swap the two chars left and right of each selection's head.
        // Move cursor behind the two swapped characters afterwards.
        //
        // Doesn't consider line feeds a character.
        // Doesn't scan more than one line above to find a character.
        // Doesn't do anything on an empty line.
        // Doesn't do anything with non-empty selections.
        transposeChars: function(cm) {
            return runInOp(cm, function() {
                var ranges = cm.listSelections(), newSel = [];
                for(var i = 0; i < ranges.length; i++){
                    if (!ranges[i].empty()) continue;
                    var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
                    if (line) {
                        if (cur.ch == line.length) cur = new Pos(cur.line, cur.ch - 1);
                        if (cur.ch > 0) {
                            cur = new Pos(cur.line, cur.ch + 1);
                            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
                        } else if (cur.line > cm.doc.first) {
                            var prev = getLine(cm.doc, cur.line - 1).text;
                            if (prev) {
                                cur = new Pos(cur.line, 1);
                                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
                            }
                        }
                    }
                    newSel.push(new Range(cur, cur));
                }
                cm.setSelections(newSel);
            });
        },
        newlineAndIndent: function(cm) {
            return runInOp(cm, function() {
                var sels = cm.listSelections();
                for(var i = sels.length - 1; i >= 0; i--)cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
                sels = cm.listSelections();
                for(var i$1 = 0; i$1 < sels.length; i$1++)cm.indentLine(sels[i$1].from().line, null, true);
                ensureCursorVisible(cm);
            });
        },
        openLine: function(cm) {
            return cm.replaceSelection("\n", "start");
        },
        toggleOverwrite: function(cm) {
            return cm.toggleOverwrite();
        }
    };
    function lineStart(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLine(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, visual, lineN, 1);
    }
    function lineEnd(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLineEnd(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, line, lineN, -1);
    }
    function lineStartSmart(cm, pos) {
        var start = lineStart(cm, pos.line);
        var line = getLine(cm.doc, start.line);
        var order = getOrder(line, cm.doc.direction);
        if (!order || order[0].level == 0) {
            var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
            var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
            return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
        }
        return start;
    }
    // Run a handler that was bound to a key.
    function doHandleBinding(cm, bound, dropShift) {
        if (typeof bound == "string") {
            bound = commands[bound];
            if (!bound) return false;
        }
        // Ensure previous input has been read, so that the handler sees a
        // consistent view of the document
        cm.display.input.ensurePolled();
        var prevShift = cm.display.shift, done = false;
        try {
            if (cm.isReadOnly()) cm.state.suppressEdits = true;
            if (dropShift) cm.display.shift = false;
            done = bound(cm) != Pass;
        } finally{
            cm.display.shift = prevShift;
            cm.state.suppressEdits = false;
        }
        return done;
    }
    function lookupKeyForEditor(cm, name, handle) {
        for(var i = 0; i < cm.state.keyMaps.length; i++){
            var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
            if (result) return result;
        }
        return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
    }
    // Note that, despite the name, this function is also used to check
    // for bound mouse clicks.
    var stopSeq = new Delayed;
    function dispatchKey(cm, name, e, handle) {
        var seq = cm.state.keySeq;
        if (seq) {
            if (isModifierKey(name)) return "handled";
            if (/\'$/.test(name)) cm.state.keySeq = null;
            else stopSeq.set(50, function() {
                if (cm.state.keySeq == seq) {
                    cm.state.keySeq = null;
                    cm.display.input.reset();
                }
            });
            if (dispatchKeyInner(cm, seq + " " + name, e, handle)) return true;
        }
        return dispatchKeyInner(cm, name, e, handle);
    }
    function dispatchKeyInner(cm, name, e, handle) {
        var result = lookupKeyForEditor(cm, name, handle);
        if (result == "multi") cm.state.keySeq = name;
        if (result == "handled") signalLater(cm, "keyHandled", cm, name, e);
        if (result == "handled" || result == "multi") {
            e_preventDefault(e);
            restartBlink(cm);
        }
        return !!result;
    }
    // Handle a key from the keydown event.
    function handleKeyBinding(cm, e) {
        var name = keyName(e, true);
        if (!name) return false;
        if (e.shiftKey && !cm.state.keySeq) // First try to resolve full name (including 'Shift-'). Failing
        // that, see if there is a cursor-motion command (starting with
        // 'go') bound to the keyname without 'Shift-'.
        return dispatchKey(cm, "Shift-" + name, e, function(b) {
            return doHandleBinding(cm, b, true);
        }) || dispatchKey(cm, name, e, function(b) {
            if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) return doHandleBinding(cm, b);
        });
        else return dispatchKey(cm, name, e, function(b) {
            return doHandleBinding(cm, b);
        });
    }
    // Handle a key from the keypress event
    function handleCharBinding(cm, e, ch) {
        return dispatchKey(cm, "'" + ch + "'", e, function(b) {
            return doHandleBinding(cm, b, true);
        });
    }
    var lastStoppedKey = null;
    function onKeyDown(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) return;
        cm.curOp.focus = activeElt(doc(cm));
        if (signalDOMEvent(cm, e)) return;
        // IE does strange things with escape.
        if (ie && ie_version < 11 && e.keyCode == 27) e.returnValue = false;
        var code = e.keyCode;
        cm.display.shift = code == 16 || e.shiftKey;
        var handled = handleKeyBinding(cm, e);
        if (presto) {
            lastStoppedKey = handled ? code : null;
            // Opera has no cut event... we try to at least catch the key combo
            if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) cm.replaceSelection("", null, "cut");
        }
        if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand) document.execCommand("cut");
        // Turn mouse into crosshair when Alt is held on Mac.
        if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) showCrossHair(cm);
    }
    function showCrossHair(cm) {
        var lineDiv = cm.display.lineDiv;
        addClass(lineDiv, "CodeMirror-crosshair");
        function up(e) {
            if (e.keyCode == 18 || !e.altKey) {
                rmClass(lineDiv, "CodeMirror-crosshair");
                off(document, "keyup", up);
                off(document, "mouseover", up);
            }
        }
        on(document, "keyup", up);
        on(document, "mouseover", up);
    }
    function onKeyUp(e) {
        if (e.keyCode == 16) this.doc.sel.shift = false;
        signalDOMEvent(this, e);
    }
    function onKeyPress(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) return;
        if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) return;
        var keyCode = e.keyCode, charCode = e.charCode;
        if (presto && keyCode == lastStoppedKey) {
            lastStoppedKey = null;
            e_preventDefault(e);
            return;
        }
        if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) return;
        var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
        // Some browsers fire keypress events for backspace
        if (ch == "\x08") return;
        if (handleCharBinding(cm, e, ch)) return;
        cm.display.input.onKeyPress(e);
    }
    var DOUBLECLICK_DELAY = 400;
    var PastClick = function(time, pos, button) {
        this.time = time;
        this.pos = pos;
        this.button = button;
    };
    PastClick.prototype.compare = function(time, pos, button) {
        return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
    };
    var lastClick, lastDoubleClick;
    function clickRepeat(pos, button) {
        var now = +new Date;
        if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
            lastClick = lastDoubleClick = null;
            return "triple";
        } else if (lastClick && lastClick.compare(now, pos, button)) {
            lastDoubleClick = new PastClick(now, pos, button);
            lastClick = null;
            return "double";
        } else {
            lastClick = new PastClick(now, pos, button);
            lastDoubleClick = null;
            return "single";
        }
    }
    // A mouse down can be a single click, double click, triple click,
    // start of selection drag, start of text drag, new cursor
    // (ctrl-click), rectangle drag (alt-drag), or xwin
    // middle-click-paste. Or it might be a click on something we should
    // not interfere with, such as a scrollbar or widget.
    function onMouseDown(e) {
        var cm = this, display = cm.display;
        if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) return;
        display.input.ensurePolled();
        display.shift = e.shiftKey;
        if (eventInWidget(display, e)) {
            if (!webkit) {
                // Briefly turn off draggability, to allow widgets to do
                // normal dragging things.
                display.scroller.draggable = false;
                setTimeout(function() {
                    return display.scroller.draggable = true;
                }, 100);
            }
            return;
        }
        if (clickInGutter(cm, e)) return;
        var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
        win(cm).focus();
        // #3261: make sure, that we're not starting a second selection
        if (button == 1 && cm.state.selectingText) cm.state.selectingText(e);
        if (pos && handleMappedButton(cm, button, pos, repeat, e)) return;
        if (button == 1) {
            if (pos) leftButtonDown(cm, pos, repeat, e);
            else if (e_target(e) == display.scroller) e_preventDefault(e);
        } else if (button == 2) {
            if (pos) extendSelection(cm.doc, pos);
            setTimeout(function() {
                return display.input.focus();
            }, 20);
        } else if (button == 3) {
            if (captureRightClick) cm.display.input.onContextMenu(e);
            else delayBlurEvent(cm);
        }
    }
    function handleMappedButton(cm, button, pos, repeat, event) {
        var name = "Click";
        if (repeat == "double") name = "Double" + name;
        else if (repeat == "triple") name = "Triple" + name;
        name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
        return dispatchKey(cm, addModifierNames(name, event), event, function(bound) {
            if (typeof bound == "string") bound = commands[bound];
            if (!bound) return false;
            var done = false;
            try {
                if (cm.isReadOnly()) cm.state.suppressEdits = true;
                done = bound(cm, pos) != Pass;
            } finally{
                cm.state.suppressEdits = false;
            }
            return done;
        });
    }
    function configureMouse(cm, repeat, event) {
        var option = cm.getOption("configureMouse");
        var value = option ? option(cm, repeat, event) : {};
        if (value.unit == null) {
            var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
            value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
        }
        if (value.extend == null || cm.doc.extend) value.extend = cm.doc.extend || event.shiftKey;
        if (value.addNew == null) value.addNew = mac ? event.metaKey : event.ctrlKey;
        if (value.moveOnDrag == null) value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
        return value;
    }
    function leftButtonDown(cm, pos, repeat, event) {
        if (ie) setTimeout(bind(ensureFocus, cm), 0);
        else cm.curOp.focus = activeElt(doc(cm));
        var behavior = configureMouse(cm, repeat, event);
        var sel = cm.doc.sel, contained;
        if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) leftButtonStartDrag(cm, event, pos, behavior);
        else leftButtonSelect(cm, event, pos, behavior);
    }
    // Start a text drag. When it ends, see if any dragging actually
    // happen, and treat as a click if it didn't.
    function leftButtonStartDrag(cm, event, pos, behavior) {
        var display = cm.display, moved = false;
        var dragEnd = operation(cm, function(e) {
            if (webkit) display.scroller.draggable = false;
            cm.state.draggingText = false;
            if (cm.state.delayingBlurEvent) {
                if (cm.hasFocus()) cm.state.delayingBlurEvent = false;
                else delayBlurEvent(cm);
            }
            off(display.wrapper.ownerDocument, "mouseup", dragEnd);
            off(display.wrapper.ownerDocument, "mousemove", mouseMove);
            off(display.scroller, "dragstart", dragStart);
            off(display.scroller, "drop", dragEnd);
            if (!moved) {
                e_preventDefault(e);
                if (!behavior.addNew) extendSelection(cm.doc, pos, null, null, behavior.extend);
                // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
                if (webkit && !safari || ie && ie_version == 9) setTimeout(function() {
                    display.wrapper.ownerDocument.body.focus({
                        preventScroll: true
                    });
                    display.input.focus();
                }, 20);
                else display.input.focus();
            }
        });
        var mouseMove = function(e2) {
            moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
        };
        var dragStart = function() {
            return moved = true;
        };
        // Let the drag handler handle this.
        if (webkit) display.scroller.draggable = true;
        cm.state.draggingText = dragEnd;
        dragEnd.copy = !behavior.moveOnDrag;
        on(display.wrapper.ownerDocument, "mouseup", dragEnd);
        on(display.wrapper.ownerDocument, "mousemove", mouseMove);
        on(display.scroller, "dragstart", dragStart);
        on(display.scroller, "drop", dragEnd);
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            return display.input.focus();
        }, 20);
        // IE's approach to draggable
        if (display.scroller.dragDrop) display.scroller.dragDrop();
    }
    function rangeForUnit(cm, pos, unit) {
        if (unit == "char") return new Range(pos, pos);
        if (unit == "word") return cm.findWordAt(pos);
        if (unit == "line") return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
        var result = unit(cm, pos);
        return new Range(result.from, result.to);
    }
    // Normal selection, as opposed to text dragging.
    function leftButtonSelect(cm, event, start, behavior) {
        if (ie) delayBlurEvent(cm);
        var display = cm.display, doc$1 = cm.doc;
        e_preventDefault(event);
        var ourRange, ourIndex, startSel = doc$1.sel, ranges = startSel.ranges;
        if (behavior.addNew && !behavior.extend) {
            ourIndex = doc$1.sel.contains(start);
            if (ourIndex > -1) ourRange = ranges[ourIndex];
            else ourRange = new Range(start, start);
        } else {
            ourRange = doc$1.sel.primary();
            ourIndex = doc$1.sel.primIndex;
        }
        if (behavior.unit == "rectangle") {
            if (!behavior.addNew) ourRange = new Range(start, start);
            start = posFromMouse(cm, event, true, true);
            ourIndex = -1;
        } else {
            var range = rangeForUnit(cm, start, behavior.unit);
            if (behavior.extend) ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend);
            else ourRange = range;
        }
        if (!behavior.addNew) {
            ourIndex = 0;
            setSelection(doc$1, new Selection([
                ourRange
            ], 0), sel_mouse);
            startSel = doc$1.sel;
        } else if (ourIndex == -1) {
            ourIndex = ranges.length;
            setSelection(doc$1, normalizeSelection(cm, ranges.concat([
                ourRange
            ]), ourIndex), {
                scroll: false,
                origin: "*mouse"
            });
        } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
            setSelection(doc$1, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), {
                scroll: false,
                origin: "*mouse"
            });
            startSel = doc$1.sel;
        } else replaceOneSelection(doc$1, ourIndex, ourRange, sel_mouse);
        var lastPos = start;
        function extendTo(pos) {
            if (cmp(lastPos, pos) == 0) return;
            lastPos = pos;
            if (behavior.unit == "rectangle") {
                var ranges = [], tabSize = cm.options.tabSize;
                var startCol = countColumn(getLine(doc$1, start.line).text, start.ch, tabSize);
                var posCol = countColumn(getLine(doc$1, pos.line).text, pos.ch, tabSize);
                var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
                for(var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++){
                    var text = getLine(doc$1, line).text, leftPos = findColumn(text, left, tabSize);
                    if (left == right) ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
                    else if (text.length > leftPos) ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
                }
                if (!ranges.length) ranges.push(new Range(start, start));
                setSelection(doc$1, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), {
                    origin: "*mouse",
                    scroll: false
                });
                cm.scrollIntoView(pos);
            } else {
                var oldRange = ourRange;
                var range = rangeForUnit(cm, pos, behavior.unit);
                var anchor = oldRange.anchor, head;
                if (cmp(range.anchor, anchor) > 0) {
                    head = range.head;
                    anchor = minPos(oldRange.from(), range.anchor);
                } else {
                    head = range.anchor;
                    anchor = maxPos(oldRange.to(), range.head);
                }
                var ranges$1 = startSel.ranges.slice(0);
                ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc$1, anchor), head));
                setSelection(doc$1, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
            }
        }
        var editorSize = display.wrapper.getBoundingClientRect();
        // Used to ensure timeout re-tries don't fire when another extend
        // happened in the meantime (clearTimeout isn't reliable -- at
        // least on Chrome, the timeouts still happen even when cleared,
        // if the clear happens after their scheduled firing time).
        var counter = 0;
        function extend(e) {
            var curCount = ++counter;
            var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
            if (!cur) return;
            if (cmp(cur, lastPos) != 0) {
                cm.curOp.focus = activeElt(doc(cm));
                extendTo(cur);
                var visible = visibleLines(display, doc$1);
                if (cur.line >= visible.to || cur.line < visible.from) setTimeout(operation(cm, function() {
                    if (counter == curCount) extend(e);
                }), 150);
            } else {
                var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
                if (outside) setTimeout(operation(cm, function() {
                    if (counter != curCount) return;
                    display.scroller.scrollTop += outside;
                    extend(e);
                }), 50);
            }
        }
        function done(e) {
            cm.state.selectingText = false;
            counter = Infinity;
            // If e is null or undefined we interpret this as someone trying
            // to explicitly cancel the selection rather than the user
            // letting go of the mouse button.
            if (e) {
                e_preventDefault(e);
                display.input.focus();
            }
            off(display.wrapper.ownerDocument, "mousemove", move);
            off(display.wrapper.ownerDocument, "mouseup", up);
            doc$1.history.lastSelOrigin = null;
        }
        var move = operation(cm, function(e) {
            if (e.buttons === 0 || !e_button(e)) done(e);
            else extend(e);
        });
        var up = operation(cm, done);
        cm.state.selectingText = up;
        on(display.wrapper.ownerDocument, "mousemove", move);
        on(display.wrapper.ownerDocument, "mouseup", up);
    }
    // Used when mouse-selecting to adjust the anchor to the proper side
    // of a bidi jump depending on the visual position of the head.
    function bidiSimplify(cm, range) {
        var anchor = range.anchor;
        var head = range.head;
        var anchorLine = getLine(cm.doc, anchor.line);
        if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) return range;
        var order = getOrder(anchorLine);
        if (!order) return range;
        var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
        if (part.from != anchor.ch && part.to != anchor.ch) return range;
        var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
        if (boundary == 0 || boundary == order.length) return range;
        // Compute the relative visual position of the head compared to the
        // anchor (<0 is to the left, >0 to the right)
        var leftSide;
        if (head.line != anchor.line) leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
        else {
            var headIndex = getBidiPartAt(order, head.ch, head.sticky);
            var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
            if (headIndex == boundary - 1 || headIndex == boundary) leftSide = dir < 0;
            else leftSide = dir > 0;
        }
        var usePart = order[boundary + (leftSide ? -1 : 0)];
        var from = leftSide == (usePart.level == 1);
        var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
        return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head);
    }
    // Determines whether an event happened in the gutter, and fires the
    // handlers for the corresponding event.
    function gutterEvent(cm, e, type, prevent) {
        var mX, mY;
        if (e.touches) {
            mX = e.touches[0].clientX;
            mY = e.touches[0].clientY;
        } else try {
            mX = e.clientX;
            mY = e.clientY;
        } catch (e$1) {
            return false;
        }
        if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) return false;
        if (prevent) e_preventDefault(e);
        var display = cm.display;
        var lineBox = display.lineDiv.getBoundingClientRect();
        if (mY > lineBox.bottom || !hasHandler(cm, type)) return e_defaultPrevented(e);
        mY -= lineBox.top - display.viewOffset;
        for(var i = 0; i < cm.display.gutterSpecs.length; ++i){
            var g = display.gutters.childNodes[i];
            if (g && g.getBoundingClientRect().right >= mX) {
                var line = lineAtHeight(cm.doc, mY);
                var gutter = cm.display.gutterSpecs[i];
                signal(cm, type, cm, line, gutter.className, e);
                return e_defaultPrevented(e);
            }
        }
    }
    function clickInGutter(cm, e) {
        return gutterEvent(cm, e, "gutterClick", true);
    }
    // CONTEXT MENU HANDLING
    // To make the context menu work, we need to briefly unhide the
    // textarea (making it as unobtrusive as possible) to let the
    // right-click take effect on it.
    function onContextMenu(cm, e) {
        if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) return;
        if (signalDOMEvent(cm, e, "contextmenu")) return;
        if (!captureRightClick) cm.display.input.onContextMenu(e);
    }
    function contextMenuInGutter(cm, e) {
        if (!hasHandler(cm, "gutterContextMenu")) return false;
        return gutterEvent(cm, e, "gutterContextMenu", false);
    }
    function themeChanged(cm) {
        cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
        clearCaches(cm);
    }
    var Init = {
        toString: function() {
            return "CodeMirror.Init";
        }
    };
    var defaults = {};
    var optionHandlers = {};
    function defineOptions(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        function option(name, deflt, handle, notOnInit) {
            CodeMirror.defaults[name] = deflt;
            if (handle) optionHandlers[name] = notOnInit ? function(cm, val, old) {
                if (old != Init) handle(cm, val, old);
            } : handle;
        }
        CodeMirror.defineOption = option;
        // Passed to option handlers when there is no old value.
        CodeMirror.Init = Init;
        // These two are, on init, called from the constructor because they
        // have to be initialized before the editor can start at all.
        option("value", "", function(cm, val) {
            return cm.setValue(val);
        }, true);
        option("mode", null, function(cm, val) {
            cm.doc.modeOption = val;
            loadMode(cm);
        }, true);
        option("indentUnit", 2, loadMode, true);
        option("indentWithTabs", false);
        option("smartIndent", true);
        option("tabSize", 4, function(cm) {
            resetModeState(cm);
            clearCaches(cm);
            regChange(cm);
        }, true);
        option("lineSeparator", null, function(cm, val) {
            cm.doc.lineSep = val;
            if (!val) return;
            var newBreaks = [], lineNo = cm.doc.first;
            cm.doc.iter(function(line) {
                for(var pos = 0;;){
                    var found = line.text.indexOf(val, pos);
                    if (found == -1) break;
                    pos = found + val.length;
                    newBreaks.push(Pos(lineNo, found));
                }
                lineNo++;
            });
            for(var i = newBreaks.length - 1; i >= 0; i--)replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
        });
        option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function(cm, val, old) {
            cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
            if (old != Init) cm.refresh();
        });
        option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function(cm) {
            return cm.refresh();
        }, true);
        option("electricChars", true);
        option("inputStyle", mobile ? "contenteditable" : "textarea", function() {
            throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
            ;
        }, true);
        option("spellcheck", false, function(cm, val) {
            return cm.getInputField().spellcheck = val;
        }, true);
        option("autocorrect", false, function(cm, val) {
            return cm.getInputField().autocorrect = val;
        }, true);
        option("autocapitalize", false, function(cm, val) {
            return cm.getInputField().autocapitalize = val;
        }, true);
        option("rtlMoveVisually", !windows);
        option("wholeLineUpdateBefore", true);
        option("theme", "default", function(cm) {
            themeChanged(cm);
            updateGutters(cm);
        }, true);
        option("keyMap", "default", function(cm, val, old) {
            var next = getKeyMap(val);
            var prev = old != Init && getKeyMap(old);
            if (prev && prev.detach) prev.detach(cm, next);
            if (next.attach) next.attach(cm, prev || null);
        });
        option("extraKeys", null);
        option("configureMouse", null);
        option("lineWrapping", false, wrappingChanged, true);
        option("gutters", [], function(cm, val) {
            cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
            updateGutters(cm);
        }, true);
        option("fixedGutter", true, function(cm, val) {
            cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
            cm.refresh();
        }, true);
        option("coverGutterNextToScrollbar", false, function(cm) {
            return updateScrollbars(cm);
        }, true);
        option("scrollbarStyle", "native", function(cm) {
            initScrollbars(cm);
            updateScrollbars(cm);
            cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
            cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
        }, true);
        option("lineNumbers", false, function(cm, val) {
            cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
            updateGutters(cm);
        }, true);
        option("firstLineNumber", 1, updateGutters, true);
        option("lineNumberFormatter", function(integer) {
            return integer;
        }, updateGutters, true);
        option("showCursorWhenSelecting", false, updateSelection, true);
        option("resetSelectionOnContextMenu", true);
        option("lineWiseCopyCut", true);
        option("pasteLinesPerSelection", true);
        option("selectionsMayTouch", false);
        option("readOnly", false, function(cm, val) {
            if (val == "nocursor") {
                onBlur(cm);
                cm.display.input.blur();
            }
            cm.display.input.readOnlyChanged(val);
        });
        option("screenReaderLabel", null, function(cm, val) {
            val = val === '' ? null : val;
            cm.display.input.screenReaderLabelChanged(val);
        });
        option("disableInput", false, function(cm, val) {
            if (!val) cm.display.input.reset();
        }, true);
        option("dragDrop", true, dragDropChanged);
        option("allowDropFileTypes", null);
        option("cursorBlinkRate", 530);
        option("cursorScrollMargin", 0);
        option("cursorHeight", 1, updateSelection, true);
        option("singleCursorHeightPerLine", true, updateSelection, true);
        option("workTime", 100);
        option("workDelay", 100);
        option("flattenSpans", true, resetModeState, true);
        option("addModeClass", false, resetModeState, true);
        option("pollInterval", 100);
        option("undoDepth", 200, function(cm, val) {
            return cm.doc.history.undoDepth = val;
        });
        option("historyEventDelay", 1250);
        option("viewportMargin", 10, function(cm) {
            return cm.refresh();
        }, true);
        option("maxHighlightLength", 10000, resetModeState, true);
        option("moveInputWithCursor", true, function(cm, val) {
            if (!val) cm.display.input.resetPosition();
        });
        option("tabindex", null, function(cm, val) {
            return cm.display.input.getField().tabIndex = val || "";
        });
        option("autofocus", null);
        option("direction", "ltr", function(cm, val) {
            return cm.doc.setDirection(val);
        }, true);
        option("phrases", null);
    }
    function dragDropChanged(cm, value, old) {
        var wasOn = old && old != Init;
        if (!value != !wasOn) {
            var funcs = cm.display.dragFunctions;
            var toggle = value ? on : off;
            toggle(cm.display.scroller, "dragstart", funcs.start);
            toggle(cm.display.scroller, "dragenter", funcs.enter);
            toggle(cm.display.scroller, "dragover", funcs.over);
            toggle(cm.display.scroller, "dragleave", funcs.leave);
            toggle(cm.display.scroller, "drop", funcs.drop);
        }
    }
    function wrappingChanged(cm) {
        if (cm.options.lineWrapping) {
            addClass(cm.display.wrapper, "CodeMirror-wrap");
            cm.display.sizer.style.minWidth = "";
            cm.display.sizerWidth = null;
        } else {
            rmClass(cm.display.wrapper, "CodeMirror-wrap");
            findMaxLine(cm);
        }
        estimateLineHeights(cm);
        regChange(cm);
        clearCaches(cm);
        setTimeout(function() {
            return updateScrollbars(cm);
        }, 100);
    }
    // A CodeMirror instance represents an editor. This is the object
    // that user code is usually dealing with.
    function CodeMirror(place, options) {
        var this$1 = this;
        if (!(this instanceof CodeMirror)) return new CodeMirror(place, options);
        this.options = options = options ? copyObj(options) : {};
        // Determine effective options based on given values and defaults.
        copyObj(defaults, options, false);
        var doc = options.value;
        if (typeof doc == "string") doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
        else if (options.mode) doc.modeOption = options.mode;
        this.doc = doc;
        var input = new CodeMirror.inputStyles[options.inputStyle](this);
        var display = this.display = new Display(place, doc, input, options);
        display.wrapper.CodeMirror = this;
        themeChanged(this);
        if (options.lineWrapping) this.display.wrapper.className += " CodeMirror-wrap";
        initScrollbars(this);
        this.state = {
            keyMaps: [],
            overlays: [],
            modeGen: 0,
            overwrite: false,
            delayingBlurEvent: false,
            focused: false,
            suppressEdits: false,
            pasteIncoming: -1,
            cutIncoming: -1,
            selectingText: false,
            draggingText: false,
            highlight: new Delayed(),
            keySeq: null,
            specialChars: null
        };
        if (options.autofocus && !mobile) display.input.focus();
        // Override magic textarea content restore that IE sometimes does
        // on our hidden textarea on reload
        if (ie && ie_version < 11) setTimeout(function() {
            return this$1.display.input.reset(true);
        }, 20);
        registerEventHandlers(this);
        ensureGlobalHandlers();
        startOperation(this);
        this.curOp.forceUpdate = true;
        attachDoc(this, doc);
        if (options.autofocus && !mobile || this.hasFocus()) setTimeout(function() {
            if (this$1.hasFocus() && !this$1.state.focused) onFocus(this$1);
        }, 20);
        else onBlur(this);
        for(var opt in optionHandlers)if (optionHandlers.hasOwnProperty(opt)) optionHandlers[opt](this, options[opt], Init);
        maybeUpdateLineNumberWidth(this);
        if (options.finishInit) options.finishInit(this);
        for(var i = 0; i < initHooks.length; ++i)initHooks[i](this);
        endOperation(this);
        // Suppress optimizelegibility in Webkit, since it breaks text
        // measuring on line wrapping boundaries.
        if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") display.lineDiv.style.textRendering = "auto";
    }
    // The default configuration options.
    CodeMirror.defaults = defaults;
    // Functions to run when options are changed.
    CodeMirror.optionHandlers = optionHandlers;
    // Attach the necessary event handlers when initializing the editor
    function registerEventHandlers(cm) {
        var d = cm.display;
        on(d.scroller, "mousedown", operation(cm, onMouseDown));
        // Older IE's will not fire a second mousedown for a double click
        if (ie && ie_version < 11) on(d.scroller, "dblclick", operation(cm, function(e) {
            if (signalDOMEvent(cm, e)) return;
            var pos = posFromMouse(cm, e);
            if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) return;
            e_preventDefault(e);
            var word = cm.findWordAt(pos);
            extendSelection(cm.doc, word.anchor, word.head);
        }));
        else on(d.scroller, "dblclick", function(e) {
            return signalDOMEvent(cm, e) || e_preventDefault(e);
        });
        // Some browsers fire contextmenu *after* opening the menu, at
        // which point we can't mess with it anymore. Context menu is
        // handled in onMouseDown for these browsers.
        on(d.scroller, "contextmenu", function(e) {
            return onContextMenu(cm, e);
        });
        on(d.input.getField(), "contextmenu", function(e) {
            if (!d.scroller.contains(e.target)) onContextMenu(cm, e);
        });
        // Used to suppress mouse event handling when a touch happens
        var touchFinished, prevTouch = {
            end: 0
        };
        function finishTouch() {
            if (d.activeTouch) {
                touchFinished = setTimeout(function() {
                    return d.activeTouch = null;
                }, 1000);
                prevTouch = d.activeTouch;
                prevTouch.end = +new Date;
            }
        }
        function isMouseLikeTouchEvent(e) {
            if (e.touches.length != 1) return false;
            var touch = e.touches[0];
            return touch.radiusX <= 1 && touch.radiusY <= 1;
        }
        function farAway(touch, other) {
            if (other.left == null) return true;
            var dx = other.left - touch.left, dy = other.top - touch.top;
            return dx * dx + dy * dy > 400;
        }
        on(d.scroller, "touchstart", function(e) {
            if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
                d.input.ensurePolled();
                clearTimeout(touchFinished);
                var now = +new Date;
                d.activeTouch = {
                    start: now,
                    moved: false,
                    prev: now - prevTouch.end <= 300 ? prevTouch : null
                };
                if (e.touches.length == 1) {
                    d.activeTouch.left = e.touches[0].pageX;
                    d.activeTouch.top = e.touches[0].pageY;
                }
            }
        });
        on(d.scroller, "touchmove", function() {
            if (d.activeTouch) d.activeTouch.moved = true;
        });
        on(d.scroller, "touchend", function(e) {
            var touch = d.activeTouch;
            if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date - touch.start < 300) {
                var pos = cm.coordsChar(d.activeTouch, "page"), range;
                if (!touch.prev || farAway(touch, touch.prev)) range = new Range(pos, pos);
                else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) range = cm.findWordAt(pos);
                else range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
                cm.setSelection(range.anchor, range.head);
                cm.focus();
                e_preventDefault(e);
            }
            finishTouch();
        });
        on(d.scroller, "touchcancel", finishTouch);
        // Sync scrolling between fake scrollbars and real scrollable
        // area, ensure viewport is updated when scrolling.
        on(d.scroller, "scroll", function() {
            if (d.scroller.clientHeight) {
                updateScrollTop(cm, d.scroller.scrollTop);
                setScrollLeft(cm, d.scroller.scrollLeft, true);
                signal(cm, "scroll", cm);
            }
        });
        // Listen to wheel events in order to try and update the viewport on time.
        on(d.scroller, "mousewheel", function(e) {
            return onScrollWheel(cm, e);
        });
        on(d.scroller, "DOMMouseScroll", function(e) {
            return onScrollWheel(cm, e);
        });
        // Prevent wrapper from ever scrolling
        on(d.wrapper, "scroll", function() {
            return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
        });
        d.dragFunctions = {
            enter: function(e) {
                if (!signalDOMEvent(cm, e)) e_stop(e);
            },
            over: function(e) {
                if (!signalDOMEvent(cm, e)) {
                    onDragOver(cm, e);
                    e_stop(e);
                }
            },
            start: function(e) {
                return onDragStart(cm, e);
            },
            drop: operation(cm, onDrop),
            leave: function(e) {
                if (!signalDOMEvent(cm, e)) clearDragCursor(cm);
            }
        };
        var inp = d.input.getField();
        on(inp, "keyup", function(e) {
            return onKeyUp.call(cm, e);
        });
        on(inp, "keydown", operation(cm, onKeyDown));
        on(inp, "keypress", operation(cm, onKeyPress));
        on(inp, "focus", function(e) {
            return onFocus(cm, e);
        });
        on(inp, "blur", function(e) {
            return onBlur(cm, e);
        });
    }
    var initHooks = [];
    CodeMirror.defineInitHook = function(f) {
        return initHooks.push(f);
    };
    // Indent the given line. The how parameter can be "smart",
    // "add"/null, "subtract", or "prev". When aggressive is false
    // (typically set to true for forced single-line indents), empty
    // lines are not indented, and places where the mode returns Pass
    // are left alone.
    function indentLine(cm, n, how, aggressive) {
        var doc = cm.doc, state;
        if (how == null) how = "add";
        if (how == "smart") {
            // Fall back to "prev" when the mode doesn't have an indentation
            // method.
            if (!doc.mode.indent) how = "prev";
            else state = getContextBefore(cm, n).state;
        }
        var tabSize = cm.options.tabSize;
        var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
        if (line.stateAfter) line.stateAfter = null;
        var curSpaceString = line.text.match(/^\s*/)[0], indentation;
        if (!aggressive && !/\S/.test(line.text)) {
            indentation = 0;
            how = "not";
        } else if (how == "smart") {
            indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
            if (indentation == Pass || indentation > 150) {
                if (!aggressive) return;
                how = "prev";
            }
        }
        if (how == "prev") {
            if (n > doc.first) indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
            else indentation = 0;
        } else if (how == "add") indentation = curSpace + cm.options.indentUnit;
        else if (how == "subtract") indentation = curSpace - cm.options.indentUnit;
        else if (typeof how == "number") indentation = curSpace + how;
        indentation = Math.max(0, indentation);
        var indentString = "", pos = 0;
        if (cm.options.indentWithTabs) for(var i = Math.floor(indentation / tabSize); i; --i){
            pos += tabSize;
            indentString += "\t";
        }
        if (pos < indentation) indentString += spaceStr(indentation - pos);
        if (indentString != curSpaceString) {
            replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
            line.stateAfter = null;
            return true;
        } else // Ensure that, if the cursor was in the whitespace at the start
        // of the line, it is moved to the end of that space.
        for(var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++){
            var range = doc.sel.ranges[i$1];
            if (range.head.line == n && range.head.ch < curSpaceString.length) {
                var pos$1 = Pos(n, curSpaceString.length);
                replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
                break;
            }
        }
    }
    // This will be set to a {lineWise: bool, text: [string]} object, so
    // that, when pasting, we know what kind of selections the copied
    // text was made out of.
    var lastCopied = null;
    function setLastCopied(newLastCopied) {
        lastCopied = newLastCopied;
    }
    function applyTextInput(cm, inserted, deleted, sel, origin) {
        var doc = cm.doc;
        cm.display.shift = false;
        if (!sel) sel = doc.sel;
        var recent = +new Date - 200;
        var paste = origin == "paste" || cm.state.pasteIncoming > recent;
        var textLines = splitLinesAuto(inserted), multiPaste = null;
        // When pasting N lines into N selections, insert one line per selection
        if (paste && sel.ranges.length > 1) {
            if (lastCopied && lastCopied.text.join("\n") == inserted) {
                if (sel.ranges.length % lastCopied.text.length == 0) {
                    multiPaste = [];
                    for(var i = 0; i < lastCopied.text.length; i++)multiPaste.push(doc.splitLines(lastCopied.text[i]));
                }
            } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) multiPaste = map(textLines, function(l) {
                return [
                    l
                ];
            });
        }
        var updateInput = cm.curOp.updateInput;
        // Normal behavior is to insert the new text into every selection
        for(var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--){
            var range = sel.ranges[i$1];
            var from = range.from(), to = range.to();
            if (range.empty()) {
                if (deleted && deleted > 0) from = Pos(from.line, from.ch - deleted);
                else if (cm.state.overwrite && !paste) to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
                else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n")) from = to = Pos(from.line, 0);
            }
            var changeEvent = {
                from: from,
                to: to,
                text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")
            };
            makeChange(cm.doc, changeEvent);
            signalLater(cm, "inputRead", cm, changeEvent);
        }
        if (inserted && !paste) triggerElectric(cm, inserted);
        ensureCursorVisible(cm);
        if (cm.curOp.updateInput < 2) cm.curOp.updateInput = updateInput;
        cm.curOp.typing = true;
        cm.state.pasteIncoming = cm.state.cutIncoming = -1;
    }
    function handlePaste(e, cm) {
        var pasted = e.clipboardData && e.clipboardData.getData("Text");
        if (pasted) {
            e.preventDefault();
            if (!cm.isReadOnly() && !cm.options.disableInput && cm.hasFocus()) runInOp(cm, function() {
                return applyTextInput(cm, pasted, 0, null, "paste");
            });
            return true;
        }
    }
    function triggerElectric(cm, inserted) {
        // When an 'electric' character is inserted, immediately trigger a reindent
        if (!cm.options.electricChars || !cm.options.smartIndent) return;
        var sel = cm.doc.sel;
        for(var i = sel.ranges.length - 1; i >= 0; i--){
            var range = sel.ranges[i];
            if (range.head.ch > 100 || i && sel.ranges[i - 1].head.line == range.head.line) continue;
            var mode = cm.getModeAt(range.head);
            var indented = false;
            if (mode.electricChars) {
                for(var j = 0; j < mode.electricChars.length; j++)if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
                    indented = indentLine(cm, range.head.line, "smart");
                    break;
                }
            } else if (mode.electricInput) {
                if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch))) indented = indentLine(cm, range.head.line, "smart");
            }
            if (indented) signalLater(cm, "electricInput", cm, range.head.line);
        }
    }
    function copyableRanges(cm) {
        var text = [], ranges = [];
        for(var i = 0; i < cm.doc.sel.ranges.length; i++){
            var line = cm.doc.sel.ranges[i].head.line;
            var lineRange = {
                anchor: Pos(line, 0),
                head: Pos(line + 1, 0)
            };
            ranges.push(lineRange);
            text.push(cm.getRange(lineRange.anchor, lineRange.head));
        }
        return {
            text: text,
            ranges: ranges
        };
    }
    function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
        field.setAttribute("autocorrect", autocorrect ? "on" : "off");
        field.setAttribute("autocapitalize", autocapitalize ? "on" : "off");
        field.setAttribute("spellcheck", !!spellcheck);
    }
    function hiddenTextarea() {
        var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
        var div = elt("div", [
            te
        ], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
        // The textarea is kept positioned near the cursor to prevent the
        // fact that it'll be scrolled into view on input from scrolling
        // our fake cursor out of view. On webkit, when wrap=off, paste is
        // very slow. So make the area wide instead.
        if (webkit) te.style.width = "1000px";
        else te.setAttribute("wrap", "off");
        // If border: 0; -- iOS fails to open keyboard (issue #1287)
        if (ios) te.style.border = "1px solid black";
        return div;
    }
    // The publicly visible API. Note that methodOp(f) means
    // 'wrap f in an operation, performed on its `this` parameter'.
    // This is not the complete set of editor methods. Most of the
    // methods defined on the Doc type are also injected into
    // CodeMirror.prototype, for backwards compatibility and
    // convenience.
    function addEditorMethods(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        var helpers = CodeMirror.helpers = {};
        CodeMirror.prototype = {
            constructor: CodeMirror,
            focus: function() {
                win(this).focus();
                this.display.input.focus();
            },
            setOption: function(option, value) {
                var options = this.options, old = options[option];
                if (options[option] == value && option != "mode") return;
                options[option] = value;
                if (optionHandlers.hasOwnProperty(option)) operation(this, optionHandlers[option])(this, value, old);
                signal(this, "optionChange", this, option);
            },
            getOption: function(option) {
                return this.options[option];
            },
            getDoc: function() {
                return this.doc;
            },
            addKeyMap: function(map, bottom) {
                this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
            },
            removeKeyMap: function(map) {
                var maps = this.state.keyMaps;
                for(var i = 0; i < maps.length; ++i)if (maps[i] == map || maps[i].name == map) {
                    maps.splice(i, 1);
                    return true;
                }
            },
            addOverlay: methodOp(function(spec, options) {
                var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
                if (mode.startState) throw new Error("Overlays may not be stateful.");
                insertSorted(this.state.overlays, {
                    mode: mode,
                    modeSpec: spec,
                    opaque: options && options.opaque,
                    priority: options && options.priority || 0
                }, function(overlay) {
                    return overlay.priority;
                });
                this.state.modeGen++;
                regChange(this);
            }),
            removeOverlay: methodOp(function(spec) {
                var overlays = this.state.overlays;
                for(var i = 0; i < overlays.length; ++i){
                    var cur = overlays[i].modeSpec;
                    if (cur == spec || typeof spec == "string" && cur.name == spec) {
                        overlays.splice(i, 1);
                        this.state.modeGen++;
                        regChange(this);
                        return;
                    }
                }
            }),
            indentLine: methodOp(function(n, dir, aggressive) {
                if (typeof dir != "string" && typeof dir != "number") {
                    if (dir == null) dir = this.options.smartIndent ? "smart" : "prev";
                    else dir = dir ? "add" : "subtract";
                }
                if (isLine(this.doc, n)) indentLine(this, n, dir, aggressive);
            }),
            indentSelection: methodOp(function(how) {
                var ranges = this.doc.sel.ranges, end = -1;
                for(var i = 0; i < ranges.length; i++){
                    var range = ranges[i];
                    if (!range.empty()) {
                        var from = range.from(), to = range.to();
                        var start = Math.max(end, from.line);
                        end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
                        for(var j = start; j < end; ++j)indentLine(this, j, how);
                        var newRanges = this.doc.sel.ranges;
                        if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
                    } else if (range.head.line > end) {
                        indentLine(this, range.head.line, how, true);
                        end = range.head.line;
                        if (i == this.doc.sel.primIndex) ensureCursorVisible(this);
                    }
                }
            }),
            // Fetch the parser token for a given character. Useful for hacks
            // that want to inspect the mode state (say, for completion).
            getTokenAt: function(pos, precise) {
                return takeToken(this, pos, precise);
            },
            getLineTokens: function(line, precise) {
                return takeToken(this, Pos(line), precise, true);
            },
            getTokenTypeAt: function(pos) {
                pos = clipPos(this.doc, pos);
                var styles = getLineStyles(this, getLine(this.doc, pos.line));
                var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
                var type;
                if (ch == 0) type = styles[2];
                else for(;;){
                    var mid = before + after >> 1;
                    if ((mid ? styles[mid * 2 - 1] : 0) >= ch) after = mid;
                    else if (styles[mid * 2 + 1] < ch) before = mid + 1;
                    else {
                        type = styles[mid * 2 + 2];
                        break;
                    }
                }
                var cut = type ? type.indexOf("overlay ") : -1;
                return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
            },
            getModeAt: function(pos) {
                var mode = this.doc.mode;
                if (!mode.innerMode) return mode;
                return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
            },
            getHelper: function(pos, type) {
                return this.getHelpers(pos, type)[0];
            },
            getHelpers: function(pos, type) {
                var found = [];
                if (!helpers.hasOwnProperty(type)) return found;
                var help = helpers[type], mode = this.getModeAt(pos);
                if (typeof mode[type] == "string") {
                    if (help[mode[type]]) found.push(help[mode[type]]);
                } else if (mode[type]) for(var i = 0; i < mode[type].length; i++){
                    var val = help[mode[type][i]];
                    if (val) found.push(val);
                }
                else if (mode.helperType && help[mode.helperType]) found.push(help[mode.helperType]);
                else if (help[mode.name]) found.push(help[mode.name]);
                for(var i$1 = 0; i$1 < help._global.length; i$1++){
                    var cur = help._global[i$1];
                    if (cur.pred(mode, this) && indexOf(found, cur.val) == -1) found.push(cur.val);
                }
                return found;
            },
            getStateAfter: function(line, precise) {
                var doc = this.doc;
                line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
                return getContextBefore(this, line + 1, precise).state;
            },
            cursorCoords: function(start, mode) {
                var pos, range = this.doc.sel.primary();
                if (start == null) pos = range.head;
                else if (typeof start == "object") pos = clipPos(this.doc, start);
                else pos = start ? range.from() : range.to();
                return cursorCoords(this, pos, mode || "page");
            },
            charCoords: function(pos, mode) {
                return charCoords(this, clipPos(this.doc, pos), mode || "page");
            },
            coordsChar: function(coords, mode) {
                coords = fromCoordSystem(this, coords, mode || "page");
                return coordsChar(this, coords.left, coords.top);
            },
            lineAtHeight: function(height, mode) {
                height = fromCoordSystem(this, {
                    top: height,
                    left: 0
                }, mode || "page").top;
                return lineAtHeight(this.doc, height + this.display.viewOffset);
            },
            heightAtLine: function(line, mode, includeWidgets) {
                var end = false, lineObj;
                if (typeof line == "number") {
                    var last = this.doc.first + this.doc.size - 1;
                    if (line < this.doc.first) line = this.doc.first;
                    else if (line > last) {
                        line = last;
                        end = true;
                    }
                    lineObj = getLine(this.doc, line);
                } else lineObj = line;
                return intoCoordSystem(this, lineObj, {
                    top: 0,
                    left: 0
                }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - heightAtLine(lineObj) : 0);
            },
            defaultTextHeight: function() {
                return textHeight(this.display);
            },
            defaultCharWidth: function() {
                return charWidth(this.display);
            },
            getViewport: function() {
                return {
                    from: this.display.viewFrom,
                    to: this.display.viewTo
                };
            },
            addWidget: function(pos, node, scroll, vert, horiz) {
                var display = this.display;
                pos = cursorCoords(this, clipPos(this.doc, pos));
                var top = pos.bottom, left = pos.left;
                node.style.position = "absolute";
                node.setAttribute("cm-ignore-events", "true");
                this.display.input.setUneditable(node);
                display.sizer.appendChild(node);
                if (vert == "over") top = pos.top;
                else if (vert == "above" || vert == "near") {
                    var vspace = Math.max(display.wrapper.clientHeight, this.doc.height), hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
                    // Default to positioning above (if specified and possible); otherwise default to positioning below
                    if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) top = pos.top - node.offsetHeight;
                    else if (pos.bottom + node.offsetHeight <= vspace) top = pos.bottom;
                    if (left + node.offsetWidth > hspace) left = hspace - node.offsetWidth;
                }
                node.style.top = top + "px";
                node.style.left = node.style.right = "";
                if (horiz == "right") {
                    left = display.sizer.clientWidth - node.offsetWidth;
                    node.style.right = "0px";
                } else {
                    if (horiz == "left") left = 0;
                    else if (horiz == "middle") left = (display.sizer.clientWidth - node.offsetWidth) / 2;
                    node.style.left = left + "px";
                }
                if (scroll) scrollIntoView(this, {
                    left: left,
                    top: top,
                    right: left + node.offsetWidth,
                    bottom: top + node.offsetHeight
                });
            },
            triggerOnKeyDown: methodOp(onKeyDown),
            triggerOnKeyPress: methodOp(onKeyPress),
            triggerOnKeyUp: onKeyUp,
            triggerOnMouseDown: methodOp(onMouseDown),
            execCommand: function(cmd) {
                if (commands.hasOwnProperty(cmd)) return commands[cmd].call(null, this);
            },
            triggerElectric: methodOp(function(text) {
                triggerElectric(this, text);
            }),
            findPosH: function(from, amount, unit, visually) {
                var dir = 1;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    cur = findPosH(this.doc, cur, dir, unit, visually);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveH: methodOp(function(dir, unit) {
                var this$1 = this;
                this.extendSelectionsBy(function(range) {
                    if (this$1.display.shift || this$1.doc.extend || range.empty()) return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually);
                    else return dir < 0 ? range.from() : range.to();
                }, sel_move);
            }),
            deleteH: methodOp(function(dir, unit) {
                var sel = this.doc.sel, doc = this.doc;
                if (sel.somethingSelected()) doc.replaceSelection("", null, "+delete");
                else deleteNearSelection(this, function(range) {
                    var other = findPosH(doc, range.head, dir, unit, false);
                    return dir < 0 ? {
                        from: other,
                        to: range.head
                    } : {
                        from: range.head,
                        to: other
                    };
                });
            }),
            findPosV: function(from, amount, unit, goalColumn) {
                var dir = 1, x = goalColumn;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    var coords = cursorCoords(this, cur, "div");
                    if (x == null) x = coords.left;
                    else coords.left = x;
                    cur = findPosV(this, coords, dir, unit);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveV: methodOp(function(dir, unit) {
                var this$1 = this;
                var doc = this.doc, goals = [];
                var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
                doc.extendSelectionsBy(function(range) {
                    if (collapse) return dir < 0 ? range.from() : range.to();
                    var headPos = cursorCoords(this$1, range.head, "div");
                    if (range.goalColumn != null) headPos.left = range.goalColumn;
                    goals.push(headPos.left);
                    var pos = findPosV(this$1, headPos, dir, unit);
                    if (unit == "page" && range == doc.sel.primary()) addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top);
                    return pos;
                }, sel_move);
                if (goals.length) for(var i = 0; i < doc.sel.ranges.length; i++)doc.sel.ranges[i].goalColumn = goals[i];
            }),
            // Find the word at the given position (as returned by coordsChar).
            findWordAt: function(pos) {
                var doc = this.doc, line = getLine(doc, pos.line).text;
                var start = pos.ch, end = pos.ch;
                if (line) {
                    var helper = this.getHelper(pos, "wordChars");
                    if ((pos.sticky == "before" || end == line.length) && start) --start;
                    else ++end;
                    var startChar = line.charAt(start);
                    var check = isWordChar(startChar, helper) ? function(ch) {
                        return isWordChar(ch, helper);
                    } : /\s/.test(startChar) ? function(ch) {
                        return /\s/.test(ch);
                    } : function(ch) {
                        return !/\s/.test(ch) && !isWordChar(ch);
                    };
                    while(start > 0 && check(line.charAt(start - 1)))--start;
                    while(end < line.length && check(line.charAt(end)))++end;
                }
                return new Range(Pos(pos.line, start), Pos(pos.line, end));
            },
            toggleOverwrite: function(value) {
                if (value != null && value == this.state.overwrite) return;
                if (this.state.overwrite = !this.state.overwrite) addClass(this.display.cursorDiv, "CodeMirror-overwrite");
                else rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
                signal(this, "overwriteToggle", this, this.state.overwrite);
            },
            hasFocus: function() {
                return this.display.input.getField() == activeElt(doc(this));
            },
            isReadOnly: function() {
                return !!(this.options.readOnly || this.doc.cantEdit);
            },
            scrollTo: methodOp(function(x, y) {
                scrollToCoords(this, x, y);
            }),
            getScrollInfo: function() {
                var scroller = this.display.scroller;
                return {
                    left: scroller.scrollLeft,
                    top: scroller.scrollTop,
                    height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                    width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                    clientHeight: displayHeight(this),
                    clientWidth: displayWidth(this)
                };
            },
            scrollIntoView: methodOp(function(range, margin) {
                if (range == null) {
                    range = {
                        from: this.doc.sel.primary().head,
                        to: null
                    };
                    if (margin == null) margin = this.options.cursorScrollMargin;
                } else if (typeof range == "number") range = {
                    from: Pos(range, 0),
                    to: null
                };
                else if (range.from == null) range = {
                    from: range,
                    to: null
                };
                if (!range.to) range.to = range.from;
                range.margin = margin || 0;
                if (range.from.line != null) scrollToRange(this, range);
                else scrollToCoordsRange(this, range.from, range.to, range.margin);
            }),
            setSize: methodOp(function(width, height) {
                var this$1 = this;
                var interpret = function(val) {
                    return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
                };
                if (width != null) this.display.wrapper.style.width = interpret(width);
                if (height != null) this.display.wrapper.style.height = interpret(height);
                if (this.options.lineWrapping) clearLineMeasurementCache(this);
                var lineNo = this.display.viewFrom;
                this.doc.iter(lineNo, this.display.viewTo, function(line) {
                    if (line.widgets) {
                        for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].noHScroll) {
                            regLineChange(this$1, lineNo, "widget");
                            break;
                        }
                    }
                    ++lineNo;
                });
                this.curOp.forceUpdate = true;
                signal(this, "refresh", this);
            }),
            operation: function(f) {
                return runInOp(this, f);
            },
            startOperation: function() {
                return startOperation(this);
            },
            endOperation: function() {
                return endOperation(this);
            },
            refresh: methodOp(function() {
                var oldHeight = this.display.cachedTextHeight;
                regChange(this);
                this.curOp.forceUpdate = true;
                clearCaches(this);
                scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
                updateGutterSpace(this.display);
                if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping) estimateLineHeights(this);
                signal(this, "refresh", this);
            }),
            swapDoc: methodOp(function(doc) {
                var old = this.doc;
                old.cm = null;
                // Cancel the current text selection if any (#5821)
                if (this.state.selectingText) this.state.selectingText();
                attachDoc(this, doc);
                clearCaches(this);
                this.display.input.reset();
                scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
                this.curOp.forceScroll = true;
                signalLater(this, "swapDoc", this, old);
                return old;
            }),
            phrase: function(phraseText) {
                var phrases = this.options.phrases;
                return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
            },
            getInputField: function() {
                return this.display.input.getField();
            },
            getWrapperElement: function() {
                return this.display.wrapper;
            },
            getScrollerElement: function() {
                return this.display.scroller;
            },
            getGutterElement: function() {
                return this.display.gutters;
            }
        };
        eventMixin(CodeMirror);
        CodeMirror.registerHelper = function(type, name, value) {
            if (!helpers.hasOwnProperty(type)) helpers[type] = CodeMirror[type] = {
                _global: []
            };
            helpers[type][name] = value;
        };
        CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
            CodeMirror.registerHelper(type, name, value);
            helpers[type]._global.push({
                pred: predicate,
                val: value
            });
        };
    }
    // Used for horizontal relative motion. Dir is -1 or 1 (left or
    // right), unit can be "codepoint", "char", "column" (like char, but
    // doesn't cross line boundaries), "word" (across next word), or
    // "group" (to the start of next group of word or
    // non-word-non-whitespace chars). The visually param controls
    // whether, in right-to-left text, direction 1 means to move towards
    // the next index in the string, or towards the character to the right
    // of the current position. The resulting position will have a
    // hitSide=true property if it reached the end of the document.
    function findPosH(doc, pos, dir, unit, visually) {
        var oldPos = pos;
        var origDir = dir;
        var lineObj = getLine(doc, pos.line);
        var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
        function findNextLine() {
            var l = pos.line + lineDir;
            if (l < doc.first || l >= doc.first + doc.size) return false;
            pos = new Pos(l, pos.ch, pos.sticky);
            return lineObj = getLine(doc, l);
        }
        function moveOnce(boundToLine) {
            var next;
            if (unit == "codepoint") {
                var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
                if (isNaN(ch)) next = null;
                else {
                    var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
                    next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
                }
            } else if (visually) next = moveVisually(doc.cm, lineObj, pos, dir);
            else next = moveLogically(lineObj, pos, dir);
            if (next == null) {
                if (!boundToLine && findNextLine()) pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir);
                else return false;
            } else pos = next;
            return true;
        }
        if (unit == "char" || unit == "codepoint") moveOnce();
        else if (unit == "column") moveOnce(true);
        else if (unit == "word" || unit == "group") {
            var sawType = null, group = unit == "group";
            var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
            for(var first = true;; first = false){
                if (dir < 0 && !moveOnce(!first)) break;
                var cur = lineObj.text.charAt(pos.ch) || "\n";
                var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
                if (group && !first && !type) type = "s";
                if (sawType && sawType != type) {
                    if (dir < 0) {
                        dir = 1;
                        moveOnce();
                        pos.sticky = "after";
                    }
                    break;
                }
                if (type) sawType = type;
                if (dir > 0 && !moveOnce(!first)) break;
            }
        }
        var result = skipAtomic(doc, pos, oldPos, origDir, true);
        if (equalCursorPos(oldPos, result)) result.hitSide = true;
        return result;
    }
    // For relative vertical movement. Dir may be -1 or 1. Unit can be
    // "page" or "line". The resulting position will have a hitSide=true
    // property if it reached the end of the document.
    function findPosV(cm, pos, dir, unit) {
        var doc = cm.doc, x = pos.left, y;
        if (unit == "page") {
            var pageSize = Math.min(cm.display.wrapper.clientHeight, win(cm).innerHeight || doc(cm).documentElement.clientHeight);
            var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
            y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
        } else if (unit == "line") y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
        var target;
        for(;;){
            target = coordsChar(cm, x, y);
            if (!target.outside) break;
            if (dir < 0 ? y <= 0 : y >= doc.height) {
                target.hitSide = true;
                break;
            }
            y += dir * 5;
        }
        return target;
    }
    // CONTENTEDITABLE INPUT STYLE
    var ContentEditableInput = function(cm) {
        this.cm = cm;
        this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
        this.polling = new Delayed();
        this.composing = null;
        this.gracePeriod = false;
        this.readDOMTimeout = null;
    };
    ContentEditableInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = input.cm;
        var div = input.div = display.lineDiv;
        div.contentEditable = true;
        disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
        function belongsToInput(e) {
            for(var t = e.target; t; t = t.parentNode){
                if (t == div) return true;
                if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) break;
            }
            return false;
        }
        on(div, "paste", function(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            // IE doesn't fire input events, so we schedule a read for the pasted content in this way
            if (ie_version <= 11) setTimeout(operation(cm, function() {
                return this$1.updateFromDOM();
            }), 20);
        });
        on(div, "compositionstart", function(e) {
            this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionupdate", function(e) {
            if (!this$1.composing) this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionend", function(e) {
            if (this$1.composing) {
                if (e.data != this$1.composing.data) this$1.readFromDOMSoon();
                this$1.composing.done = true;
            }
        });
        on(div, "touchstart", function() {
            return input.forceCompositionEnd();
        });
        on(div, "input", function() {
            if (!this$1.composing) this$1.readFromDOMSoon();
        });
        function onCopyCut(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) {
                setLastCopied({
                    lineWise: false,
                    text: cm.getSelections()
                });
                if (e.type == "cut") cm.replaceSelection("", null, "cut");
            } else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.operation(function() {
                    cm.setSelections(ranges.ranges, 0, sel_dontScroll);
                    cm.replaceSelection("", null, "cut");
                });
            }
            if (e.clipboardData) {
                e.clipboardData.clearData();
                var content = lastCopied.text.join("\n");
                // iOS exposes the clipboard API, but seems to discard content inserted into it
                e.clipboardData.setData("Text", content);
                if (e.clipboardData.getData("Text") == content) {
                    e.preventDefault();
                    return;
                }
            }
            // Old-fashioned briefly-focus-a-textarea hack
            var kludge = hiddenTextarea(), te = kludge.firstChild;
            disableBrowserMagic(te);
            cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
            te.value = lastCopied.text.join("\n");
            var hadFocus = activeElt(div.ownerDocument);
            selectInput(te);
            setTimeout(function() {
                cm.display.lineSpace.removeChild(kludge);
                hadFocus.focus();
                if (hadFocus == div) input.showPrimarySelection();
            }, 50);
        }
        on(div, "copy", onCopyCut);
        on(div, "cut", onCopyCut);
    };
    ContentEditableInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) this.div.setAttribute('aria-label', label);
        else this.div.removeAttribute('aria-label');
    };
    ContentEditableInput.prototype.prepareSelection = function() {
        var result = prepareSelection(this.cm, false);
        result.focus = activeElt(this.div.ownerDocument) == this.div;
        return result;
    };
    ContentEditableInput.prototype.showSelection = function(info, takeFocus) {
        if (!info || !this.cm.display.view.length) return;
        if (info.focus || takeFocus) this.showPrimarySelection();
        this.showMultipleSelections(info);
    };
    ContentEditableInput.prototype.getSelection = function() {
        return this.cm.display.wrapper.ownerDocument.getSelection();
    };
    ContentEditableInput.prototype.showPrimarySelection = function() {
        var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
        var from = prim.from(), to = prim.to();
        if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
            sel.removeAllRanges();
            return;
        }
        var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) return;
        var view = cm.display.view;
        var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || {
            node: view[0].measure.map[2],
            offset: 0
        };
        var end = to.line < cm.display.viewTo && posToDOM(cm, to);
        if (!end) {
            var measure = view[view.length - 1].measure;
            var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
            end = {
                node: map[map.length - 1],
                offset: map[map.length - 2] - map[map.length - 3]
            };
        }
        if (!start || !end) {
            sel.removeAllRanges();
            return;
        }
        var old = sel.rangeCount && sel.getRangeAt(0), rng;
        try {
            rng = range(start.node, start.offset, end.offset, end.node);
        } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
        if (rng) {
            if (!gecko && cm.state.focused) {
                sel.collapse(start.node, start.offset);
                if (!rng.collapsed) {
                    sel.removeAllRanges();
                    sel.addRange(rng);
                }
            } else {
                sel.removeAllRanges();
                sel.addRange(rng);
            }
            if (old && sel.anchorNode == null) sel.addRange(old);
            else if (gecko) this.startGracePeriod();
        }
        this.rememberSelection();
    };
    ContentEditableInput.prototype.startGracePeriod = function() {
        var this$1 = this;
        clearTimeout(this.gracePeriod);
        this.gracePeriod = setTimeout(function() {
            this$1.gracePeriod = false;
            if (this$1.selectionChanged()) this$1.cm.operation(function() {
                return this$1.cm.curOp.selectionChanged = true;
            });
        }, 20);
    };
    ContentEditableInput.prototype.showMultipleSelections = function(info) {
        removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
        removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
    };
    ContentEditableInput.prototype.rememberSelection = function() {
        var sel = this.getSelection();
        this.lastAnchorNode = sel.anchorNode;
        this.lastAnchorOffset = sel.anchorOffset;
        this.lastFocusNode = sel.focusNode;
        this.lastFocusOffset = sel.focusOffset;
    };
    ContentEditableInput.prototype.selectionInEditor = function() {
        var sel = this.getSelection();
        if (!sel.rangeCount) return false;
        var node = sel.getRangeAt(0).commonAncestorContainer;
        return contains(this.div, node);
    };
    ContentEditableInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor") {
            if (!this.selectionInEditor() || activeElt(this.div.ownerDocument) != this.div) this.showSelection(this.prepareSelection(), true);
            this.div.focus();
        }
    };
    ContentEditableInput.prototype.blur = function() {
        this.div.blur();
    };
    ContentEditableInput.prototype.getField = function() {
        return this.div;
    };
    ContentEditableInput.prototype.supportsTouch = function() {
        return true;
    };
    ContentEditableInput.prototype.receivedFocus = function() {
        var this$1 = this;
        var input = this;
        if (this.selectionInEditor()) setTimeout(function() {
            return this$1.pollSelection();
        }, 20);
        else runInOp(this.cm, function() {
            return input.cm.curOp.selectionChanged = true;
        });
        function poll() {
            if (input.cm.state.focused) {
                input.pollSelection();
                input.polling.set(input.cm.options.pollInterval, poll);
            }
        }
        this.polling.set(this.cm.options.pollInterval, poll);
    };
    ContentEditableInput.prototype.selectionChanged = function() {
        var sel = this.getSelection();
        return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
    };
    ContentEditableInput.prototype.pollSelection = function() {
        if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) return;
        var sel = this.getSelection(), cm = this.cm;
        // On Android Chrome (version 56, at least), backspacing into an
        // uneditable block element will put the cursor in that element,
        // and then, because it's not editable, hide the virtual keyboard.
        // Because Android doesn't allow us to actually detect backspace
        // presses in a sane way, this code checks for when that happens
        // and simulates a backspace press in this case.
        if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
            this.cm.triggerOnKeyDown({
                type: "keydown",
                keyCode: 8,
                preventDefault: Math.abs
            });
            this.blur();
            this.focus();
            return;
        }
        if (this.composing) return;
        this.rememberSelection();
        var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var head = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (anchor && head) runInOp(cm, function() {
            setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
            if (anchor.bad || head.bad) cm.curOp.selectionChanged = true;
        });
    };
    ContentEditableInput.prototype.pollContent = function() {
        if (this.readDOMTimeout != null) {
            clearTimeout(this.readDOMTimeout);
            this.readDOMTimeout = null;
        }
        var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
        var from = sel.from(), to = sel.to();
        if (from.ch == 0 && from.line > cm.firstLine()) from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
        if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) to = Pos(to.line + 1, 0);
        if (from.line < display.viewFrom || to.line > display.viewTo - 1) return false;
        var fromIndex, fromLine, fromNode;
        if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
            fromLine = lineNo(display.view[0].line);
            fromNode = display.view[0].node;
        } else {
            fromLine = lineNo(display.view[fromIndex].line);
            fromNode = display.view[fromIndex - 1].node.nextSibling;
        }
        var toIndex = findViewIndex(cm, to.line);
        var toLine, toNode;
        if (toIndex == display.view.length - 1) {
            toLine = display.viewTo - 1;
            toNode = display.lineDiv.lastChild;
        } else {
            toLine = lineNo(display.view[toIndex + 1].line) - 1;
            toNode = display.view[toIndex + 1].node.previousSibling;
        }
        if (!fromNode) return false;
        var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
        var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
        while(newText.length > 1 && oldText.length > 1){
            if (lst(newText) == lst(oldText)) {
                newText.pop();
                oldText.pop();
                toLine--;
            } else if (newText[0] == oldText[0]) {
                newText.shift();
                oldText.shift();
                fromLine++;
            } else break;
        }
        var cutFront = 0, cutEnd = 0;
        var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
        while(cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))++cutFront;
        var newBot = lst(newText), oldBot = lst(oldText);
        var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
        while(cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))++cutEnd;
        // Try to move start of change to start of selection if ambiguous
        if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) while(cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)){
            cutFront--;
            cutEnd++;
        }
        newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
        newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
        var chFrom = Pos(fromLine, cutFront);
        var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
        if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
            replaceRange(cm.doc, newText, chFrom, chTo, "+input");
            return true;
        }
    };
    ContentEditableInput.prototype.ensurePolled = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.reset = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.forceCompositionEnd = function() {
        if (!this.composing) return;
        clearTimeout(this.readDOMTimeout);
        this.composing = null;
        this.updateFromDOM();
        this.div.blur();
        this.div.focus();
    };
    ContentEditableInput.prototype.readFromDOMSoon = function() {
        var this$1 = this;
        if (this.readDOMTimeout != null) return;
        this.readDOMTimeout = setTimeout(function() {
            this$1.readDOMTimeout = null;
            if (this$1.composing) {
                if (this$1.composing.done) this$1.composing = null;
                else return;
            }
            this$1.updateFromDOM();
        }, 80);
    };
    ContentEditableInput.prototype.updateFromDOM = function() {
        var this$1 = this;
        if (this.cm.isReadOnly() || !this.pollContent()) runInOp(this.cm, function() {
            return regChange(this$1.cm);
        });
    };
    ContentEditableInput.prototype.setUneditable = function(node) {
        node.contentEditable = "false";
    };
    ContentEditableInput.prototype.onKeyPress = function(e) {
        if (e.charCode == 0 || this.composing) return;
        e.preventDefault();
        if (!this.cm.isReadOnly()) operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
    };
    ContentEditableInput.prototype.readOnlyChanged = function(val) {
        this.div.contentEditable = String(val != "nocursor");
    };
    ContentEditableInput.prototype.onContextMenu = function() {};
    ContentEditableInput.prototype.resetPosition = function() {};
    ContentEditableInput.prototype.needsContentAttribute = true;
    function posToDOM(cm, pos) {
        var view = findViewForLine(cm, pos.line);
        if (!view || view.hidden) return null;
        var line = getLine(cm.doc, pos.line);
        var info = mapFromLineView(view, line, pos.line);
        var order = getOrder(line, cm.doc.direction), side = "left";
        if (order) {
            var partPos = getBidiPartAt(order, pos.ch);
            side = partPos % 2 ? "right" : "left";
        }
        var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
        result.offset = result.collapse == "right" ? result.end : result.start;
        return result;
    }
    function isInGutter(node) {
        for(var scan = node; scan; scan = scan.parentNode){
            if (/CodeMirror-gutter-wrapper/.test(scan.className)) return true;
        }
        return false;
    }
    function badPos(pos, bad) {
        if (bad) pos.bad = true;
        return pos;
    }
    function domTextBetween(cm, from, to, fromLine, toLine) {
        var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
        function recognizeMarker(id) {
            return function(marker) {
                return marker.id == id;
            };
        }
        function close() {
            if (closing) {
                text += lineSep;
                if (extraLinebreak) text += lineSep;
                closing = extraLinebreak = false;
            }
        }
        function addText(str) {
            if (str) {
                close();
                text += str;
            }
        }
        function walk(node) {
            if (node.nodeType == 1) {
                var cmText = node.getAttribute("cm-text");
                if (cmText) {
                    addText(cmText);
                    return;
                }
                var markerID = node.getAttribute("cm-marker"), range;
                if (markerID) {
                    var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
                    if (found.length && (range = found[0].find(0))) addText(getBetween(cm.doc, range.from, range.to).join(lineSep));
                    return;
                }
                if (node.getAttribute("contenteditable") == "false") return;
                var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
                if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) return;
                if (isBlock) close();
                for(var i = 0; i < node.childNodes.length; i++)walk(node.childNodes[i]);
                if (/^(pre|p)$/i.test(node.nodeName)) extraLinebreak = true;
                if (isBlock) closing = true;
            } else if (node.nodeType == 3) addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
        }
        for(;;){
            walk(from);
            if (from == to) break;
            from = from.nextSibling;
            extraLinebreak = false;
        }
        return text;
    }
    function domToPos(cm, node, offset) {
        var lineNode;
        if (node == cm.display.lineDiv) {
            lineNode = cm.display.lineDiv.childNodes[offset];
            if (!lineNode) return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
            node = null;
            offset = 0;
        } else for(lineNode = node;; lineNode = lineNode.parentNode){
            if (!lineNode || lineNode == cm.display.lineDiv) return null;
            if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) break;
        }
        for(var i = 0; i < cm.display.view.length; i++){
            var lineView = cm.display.view[i];
            if (lineView.node == lineNode) return locateNodeInLineView(lineView, node, offset);
        }
    }
    function locateNodeInLineView(lineView, node, offset) {
        var wrapper = lineView.text.firstChild, bad = false;
        if (!node || !contains(wrapper, node)) return badPos(Pos(lineNo(lineView.line), 0), true);
        if (node == wrapper) {
            bad = true;
            node = wrapper.childNodes[offset];
            offset = 0;
            if (!node) {
                var line = lineView.rest ? lst(lineView.rest) : lineView.line;
                return badPos(Pos(lineNo(line), line.text.length), bad);
            }
        }
        var textNode = node.nodeType == 3 ? node : null, topNode = node;
        if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
            textNode = node.firstChild;
            if (offset) offset = textNode.nodeValue.length;
        }
        while(topNode.parentNode != wrapper)topNode = topNode.parentNode;
        var measure = lineView.measure, maps = measure.maps;
        function find(textNode, topNode, offset) {
            for(var i = -1; i < (maps ? maps.length : 0); i++){
                var map = i < 0 ? measure.map : maps[i];
                for(var j = 0; j < map.length; j += 3){
                    var curNode = map[j + 2];
                    if (curNode == textNode || curNode == topNode) {
                        var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
                        var ch = map[j] + offset;
                        if (offset < 0 || curNode != textNode) ch = map[j + (offset ? 1 : 0)];
                        return Pos(line, ch);
                    }
                }
            }
        }
        var found = find(textNode, topNode, offset);
        if (found) return badPos(found, bad);
        // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
        for(var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling){
            found = find(after, after.firstChild, 0);
            if (found) return badPos(Pos(found.line, found.ch - dist), bad);
            else dist += after.textContent.length;
        }
        for(var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling){
            found = find(before, before.firstChild, -1);
            if (found) return badPos(Pos(found.line, found.ch + dist$1), bad);
            else dist$1 += before.textContent.length;
        }
    }
    // TEXTAREA INPUT STYLE
    var TextareaInput = function(cm) {
        this.cm = cm;
        // See input.poll and input.reset
        this.prevInput = "";
        // Flag that indicates whether we expect input to appear real soon
        // now (after some event like 'keypress' or 'input') and are
        // polling intensively.
        this.pollingFast = false;
        // Self-resetting timeout for the poller
        this.polling = new Delayed();
        // Used to work around IE issue with selection being forgotten when focus moves away from textarea
        this.hasSelection = false;
        this.composing = null;
        this.resetting = false;
    };
    TextareaInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = this.cm;
        this.createField(display);
        var te = this.textarea;
        display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
        // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
        if (ios) te.style.width = "0px";
        on(te, "input", function() {
            if (ie && ie_version >= 9 && this$1.hasSelection) this$1.hasSelection = null;
            input.poll();
        });
        on(te, "paste", function(e) {
            if (signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            cm.state.pasteIncoming = +new Date;
            input.fastPoll();
        });
        function prepareCopyCut(e) {
            if (signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) setLastCopied({
                lineWise: false,
                text: cm.getSelections()
            });
            else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.setSelections(ranges.ranges, null, sel_dontScroll);
                else {
                    input.prevInput = "";
                    te.value = ranges.text.join("\n");
                    selectInput(te);
                }
            }
            if (e.type == "cut") cm.state.cutIncoming = +new Date;
        }
        on(te, "cut", prepareCopyCut);
        on(te, "copy", prepareCopyCut);
        on(display.scroller, "paste", function(e) {
            if (eventInWidget(display, e) || signalDOMEvent(cm, e)) return;
            if (!te.dispatchEvent) {
                cm.state.pasteIncoming = +new Date;
                input.focus();
                return;
            }
            // Pass the `paste` event to the textarea so it's handled by its event listener.
            var event = new Event("paste");
            event.clipboardData = e.clipboardData;
            te.dispatchEvent(event);
        });
        // Prevent normal selection in the editor (we handle our own)
        on(display.lineSpace, "selectstart", function(e) {
            if (!eventInWidget(display, e)) e_preventDefault(e);
        });
        on(te, "compositionstart", function() {
            var start = cm.getCursor("from");
            if (input.composing) input.composing.range.clear();
            input.composing = {
                start: start,
                range: cm.markText(start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                })
            };
        });
        on(te, "compositionend", function() {
            if (input.composing) {
                input.poll();
                input.composing.range.clear();
                input.composing = null;
            }
        });
    };
    TextareaInput.prototype.createField = function(_display) {
        // Wraps and hides input textarea
        this.wrapper = hiddenTextarea();
        // The semihidden textarea that is focused when the editor is
        // focused, and receives input.
        this.textarea = this.wrapper.firstChild;
        var opts = this.cm.options;
        disableBrowserMagic(this.textarea, opts.spellcheck, opts.autocorrect, opts.autocapitalize);
    };
    TextareaInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) this.textarea.setAttribute('aria-label', label);
        else this.textarea.removeAttribute('aria-label');
    };
    TextareaInput.prototype.prepareSelection = function() {
        // Redraw the selection and/or cursor
        var cm = this.cm, display = cm.display, doc = cm.doc;
        var result = prepareSelection(cm);
        // Move the hidden textarea near the cursor to prevent scrolling artifacts
        if (cm.options.moveInputWithCursor) {
            var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
            var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
            result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
            result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
        }
        return result;
    };
    TextareaInput.prototype.showSelection = function(drawn) {
        var cm = this.cm, display = cm.display;
        removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
        removeChildrenAndAdd(display.selectionDiv, drawn.selection);
        if (drawn.teTop != null) {
            this.wrapper.style.top = drawn.teTop + "px";
            this.wrapper.style.left = drawn.teLeft + "px";
        }
    };
    // Reset the input to correspond to the selection (or to be empty,
    // when not typing and nothing is selected)
    TextareaInput.prototype.reset = function(typing) {
        if (this.contextMenuPending || this.composing && typing) return;
        var cm = this.cm;
        this.resetting = true;
        if (cm.somethingSelected()) {
            this.prevInput = "";
            var content = cm.getSelection();
            this.textarea.value = content;
            if (cm.state.focused) selectInput(this.textarea);
            if (ie && ie_version >= 9) this.hasSelection = content;
        } else if (!typing) {
            this.prevInput = this.textarea.value = "";
            if (ie && ie_version >= 9) this.hasSelection = null;
        }
        this.resetting = false;
    };
    TextareaInput.prototype.getField = function() {
        return this.textarea;
    };
    TextareaInput.prototype.supportsTouch = function() {
        return false;
    };
    TextareaInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt(this.textarea.ownerDocument) != this.textarea)) try {
            this.textarea.focus();
        } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    };
    TextareaInput.prototype.blur = function() {
        this.textarea.blur();
    };
    TextareaInput.prototype.resetPosition = function() {
        this.wrapper.style.top = this.wrapper.style.left = 0;
    };
    TextareaInput.prototype.receivedFocus = function() {
        this.slowPoll();
    };
    // Poll for input changes, using the normal rate of polling. This
    // runs as long as the editor is focused.
    TextareaInput.prototype.slowPoll = function() {
        var this$1 = this;
        if (this.pollingFast) return;
        this.polling.set(this.cm.options.pollInterval, function() {
            this$1.poll();
            if (this$1.cm.state.focused) this$1.slowPoll();
        });
    };
    // When an event has just come in that is likely to add or change
    // something in the input textarea, we poll faster, to ensure that
    // the change appears on the screen quickly.
    TextareaInput.prototype.fastPoll = function() {
        var missed = false, input = this;
        input.pollingFast = true;
        function p() {
            var changed = input.poll();
            if (!changed && !missed) {
                missed = true;
                input.polling.set(60, p);
            } else {
                input.pollingFast = false;
                input.slowPoll();
            }
        }
        input.polling.set(20, p);
    };
    // Read input from the textarea, and update the document to match.
    // When something is selected, it is present in the textarea, and
    // selected (unless it is huge, in which case a placeholder is
    // used). When nothing is selected, the cursor sits after previously
    // seen text (can be empty), which is stored in prevInput (we must
    // not reset the textarea when typing, because that breaks IME).
    TextareaInput.prototype.poll = function() {
        var this$1 = this;
        var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
        // Since this is called a *lot*, try to bail out as cheaply as
        // possible when it is clear that nothing happened. hasSelection
        // will be the case when there is a lot of text in the textarea,
        // in which case reading its value would be expensive.
        if (this.contextMenuPending || this.resetting || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) return false;
        var text = input.value;
        // If nothing changed, bail.
        if (text == prevInput && !cm.somethingSelected()) return false;
        // Work around nonsensical selection resetting in IE9/10, and
        // inexplicable appearance of private area unicode characters on
        // some key combos in Mac (#2689).
        if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
            cm.display.input.reset();
            return false;
        }
        if (cm.doc.sel == cm.display.selForContextMenu) {
            var first = text.charCodeAt(0);
            if (first == 0x200b && !prevInput) prevInput = "\u200b";
            if (first == 0x21da) {
                this.reset();
                return this.cm.execCommand("undo");
            }
        }
        // Find the part of the input that is actually new
        var same = 0, l = Math.min(prevInput.length, text.length);
        while(same < l && prevInput.charCodeAt(same) == text.charCodeAt(same))++same;
        runInOp(cm, function() {
            applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
            // Don't leave long text in the textarea, since it makes further polling slow
            if (text.length > 1000 || text.indexOf("\n") > -1) input.value = this$1.prevInput = "";
            else this$1.prevInput = text;
            if (this$1.composing) {
                this$1.composing.range.clear();
                this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                });
            }
        });
        return true;
    };
    TextareaInput.prototype.ensurePolled = function() {
        if (this.pollingFast && this.poll()) this.pollingFast = false;
    };
    TextareaInput.prototype.onKeyPress = function() {
        if (ie && ie_version >= 9) this.hasSelection = null;
        this.fastPoll();
    };
    TextareaInput.prototype.onContextMenu = function(e) {
        var input = this, cm = input.cm, display = cm.display, te = input.textarea;
        if (input.contextMenuPending) input.contextMenuPending();
        var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
        if (!pos || presto) return;
         // Opera is difficult.
        // Reset the current text selection only if the click is done outside of the selection
        // and 'resetSelectionOnContextMenu' option is true.
        var reset = cm.options.resetSelectionOnContextMenu;
        if (reset && cm.doc.sel.contains(pos) == -1) operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
        var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
        var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
        input.wrapper.style.cssText = "position: static";
        te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
        var oldScrollY;
        if (webkit) oldScrollY = te.ownerDocument.defaultView.scrollY;
         // Work around Chrome issue (#2712)
        display.input.focus();
        if (webkit) te.ownerDocument.defaultView.scrollTo(null, oldScrollY);
        display.input.reset();
        // Adds "Select all" to context menu in FF
        if (!cm.somethingSelected()) te.value = input.prevInput = " ";
        input.contextMenuPending = rehide;
        display.selForContextMenu = cm.doc.sel;
        clearTimeout(display.detectingSelectAll);
        // Select-all will be greyed out if there's nothing to select, so
        // this adds a zero-width space so that we can later check whether
        // it got selected.
        function prepareSelectAllHack() {
            if (te.selectionStart != null) {
                var selected = cm.somethingSelected();
                var extval = "\u200b" + (selected ? te.value : "");
                te.value = "\u21da"; // Used to catch context-menu undo
                te.value = extval;
                input.prevInput = selected ? "" : "\u200b";
                te.selectionStart = 1;
                te.selectionEnd = extval.length;
                // Re-set this, in case some other handler touched the
                // selection in the meantime.
                display.selForContextMenu = cm.doc.sel;
            }
        }
        function rehide() {
            if (input.contextMenuPending != rehide) return;
            input.contextMenuPending = false;
            input.wrapper.style.cssText = oldWrapperCSS;
            te.style.cssText = oldCSS;
            if (ie && ie_version < 9) display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
            // Try to detect the user choosing select-all
            if (te.selectionStart != null) {
                if (!ie || ie && ie_version < 9) prepareSelectAllHack();
                var i = 0, poll = function() {
                    if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == "\u200b") operation(cm, selectAll)(cm);
                    else if (i++ < 10) display.detectingSelectAll = setTimeout(poll, 500);
                    else {
                        display.selForContextMenu = null;
                        display.input.reset();
                    }
                };
                display.detectingSelectAll = setTimeout(poll, 200);
            }
        }
        if (ie && ie_version >= 9) prepareSelectAllHack();
        if (captureRightClick) {
            e_stop(e);
            var mouseup = function() {
                off(window, "mouseup", mouseup);
                setTimeout(rehide, 20);
            };
            on(window, "mouseup", mouseup);
        } else setTimeout(rehide, 50);
    };
    TextareaInput.prototype.readOnlyChanged = function(val) {
        if (!val) this.reset();
        this.textarea.disabled = val == "nocursor";
        this.textarea.readOnly = !!val;
    };
    TextareaInput.prototype.setUneditable = function() {};
    TextareaInput.prototype.needsContentAttribute = false;
    function fromTextArea(textarea, options) {
        options = options ? copyObj(options) : {};
        options.value = textarea.value;
        if (!options.tabindex && textarea.tabIndex) options.tabindex = textarea.tabIndex;
        if (!options.placeholder && textarea.placeholder) options.placeholder = textarea.placeholder;
        // Set autofocus to true if this textarea is focused, or if it has
        // autofocus and no other element is focused.
        if (options.autofocus == null) {
            var hasFocus = activeElt(textarea.ownerDocument);
            options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
        }
        function save() {
            textarea.value = cm.getValue();
        }
        var realSubmit;
        if (textarea.form) {
            on(textarea.form, "submit", save);
            // Deplorable hack to make the submit method do the right thing.
            if (!options.leaveSubmitMethodAlone) {
                var form = textarea.form;
                realSubmit = form.submit;
                try {
                    var wrappedSubmit = form.submit = function() {
                        save();
                        form.submit = realSubmit;
                        form.submit();
                        form.submit = wrappedSubmit;
                    };
                } catch (e) {}
            }
        }
        options.finishInit = function(cm) {
            cm.save = save;
            cm.getTextArea = function() {
                return textarea;
            };
            cm.toTextArea = function() {
                cm.toTextArea = isNaN; // Prevent this from being ran twice
                save();
                textarea.parentNode.removeChild(cm.getWrapperElement());
                textarea.style.display = "";
                if (textarea.form) {
                    off(textarea.form, "submit", save);
                    if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function") textarea.form.submit = realSubmit;
                }
            };
        };
        textarea.style.display = "none";
        var cm = CodeMirror(function(node) {
            return textarea.parentNode.insertBefore(node, textarea.nextSibling);
        }, options);
        return cm;
    }
    function addLegacyProps(CodeMirror) {
        CodeMirror.off = off;
        CodeMirror.on = on;
        CodeMirror.wheelEventPixels = wheelEventPixels;
        CodeMirror.Doc = Doc;
        CodeMirror.splitLines = splitLinesAuto;
        CodeMirror.countColumn = countColumn;
        CodeMirror.findColumn = findColumn;
        CodeMirror.isWordChar = isWordCharBasic;
        CodeMirror.Pass = Pass;
        CodeMirror.signal = signal;
        CodeMirror.Line = Line;
        CodeMirror.changeEnd = changeEnd;
        CodeMirror.scrollbarModel = scrollbarModel;
        CodeMirror.Pos = Pos;
        CodeMirror.cmpPos = cmp;
        CodeMirror.modes = modes;
        CodeMirror.mimeModes = mimeModes;
        CodeMirror.resolveMode = resolveMode;
        CodeMirror.getMode = getMode;
        CodeMirror.modeExtensions = modeExtensions;
        CodeMirror.extendMode = extendMode;
        CodeMirror.copyState = copyState;
        CodeMirror.startState = startState;
        CodeMirror.innerMode = innerMode;
        CodeMirror.commands = commands;
        CodeMirror.keyMap = keyMap;
        CodeMirror.keyName = keyName;
        CodeMirror.isModifierKey = isModifierKey;
        CodeMirror.lookupKey = lookupKey;
        CodeMirror.normalizeKeyMap = normalizeKeyMap;
        CodeMirror.StringStream = StringStream;
        CodeMirror.SharedTextMarker = SharedTextMarker;
        CodeMirror.TextMarker = TextMarker;
        CodeMirror.LineWidget = LineWidget;
        CodeMirror.e_preventDefault = e_preventDefault;
        CodeMirror.e_stopPropagation = e_stopPropagation;
        CodeMirror.e_stop = e_stop;
        CodeMirror.addClass = addClass;
        CodeMirror.contains = contains;
        CodeMirror.rmClass = rmClass;
        CodeMirror.keyNames = keyNames;
    }
    // EDITOR CONSTRUCTOR
    defineOptions(CodeMirror);
    addEditorMethods(CodeMirror);
    // Set up methods on CodeMirror's prototype to redirect to the editor's document.
    var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
    for(var prop in Doc.prototype)if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) CodeMirror.prototype[prop] = function(method) {
        return function() {
            return method.apply(this.doc, arguments);
        };
    }(Doc.prototype[prop]);
    eventMixin(Doc);
    CodeMirror.inputStyles = {
        "textarea": TextareaInput,
        "contenteditable": ContentEditableInput
    };
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    CodeMirror.defineMode = function(name /*, mode, …*/ ) {
        if (!CodeMirror.defaults.mode && name != "null") CodeMirror.defaults.mode = name;
        defineMode.apply(this, arguments);
    };
    CodeMirror.defineMIME = defineMIME;
    // Minimal default mode.
    CodeMirror.defineMode("null", function() {
        return {
            token: function(stream) {
                return stream.skipToEnd();
            }
        };
    });
    CodeMirror.defineMIME("text/plain", "null");
    // EXTENSIONS
    CodeMirror.defineExtension = function(name, func) {
        CodeMirror.prototype[name] = func;
    };
    CodeMirror.defineDocExtension = function(name, func) {
        Doc.prototype[name] = func;
    };
    CodeMirror.fromTextArea = fromTextArea;
    addLegacyProps(CodeMirror);
    CodeMirror.version = "5.65.12";
    return CodeMirror;
});

});


parcelRegister("6dHeM", function(module, exports) {

$parcel$export(module.exports, "EditorCss", () => $4b401574d66225da$export$e1d51e478fe1adbb);

var $4TeKW = parcelRequire("4TeKW");
const $4b401574d66225da$export$e1d51e478fe1adbb = (0, $4TeKW.css)`
  /* BASICS */

  .CodeMirror {
    /* Set height, width, borders, and global font properties here */
    font-family: monospace;
    height: 300px;
    color: black;
    direction: ltr;
  }

  /* PADDING */

  .CodeMirror-lines {
    padding: 4px 0; /* Vertical padding around content */
  }
  .CodeMirror pre.CodeMirror-line,
  .CodeMirror pre.CodeMirror-line-like {
    padding: 0 4px; /* Horizontal padding of content */
  }

  .CodeMirror-scrollbar-filler,
  .CodeMirror-gutter-filler {
    background-color: white; /* The little square between H and V scrollbars */
  }

  /* GUTTER */

  .CodeMirror-gutters {
    border-right: 1px solid #ddd;
    background-color: #f7f7f7;
    white-space: nowrap;
  }
  .CodeMirror-linenumbers {
  }
  .CodeMirror-linenumber {
    padding: 0 3px 0 5px;
    min-width: 20px;
    text-align: right;
    color: #999;
    white-space: nowrap;
  }

  .CodeMirror-guttermarker {
    color: black;
  }
  .CodeMirror-guttermarker-subtle {
    color: #999;
  }

  /* CURSOR */

  .CodeMirror-cursor {
    border-left: 1px solid black;
    border-right: none;
    width: 0;
  }
  /* Shown when moving in bi-directional text */
  .CodeMirror div.CodeMirror-secondarycursor {
    border-left: 1px solid silver;
  }
  .cm-fat-cursor .CodeMirror-cursor {
    width: auto;
    border: 0 !important;
    background: #7e7;
  }
  .cm-fat-cursor div.CodeMirror-cursors {
    z-index: 1;
  }
  .cm-fat-cursor-mark {
    background-color: rgba(20, 255, 20, 0.5);
    -webkit-animation: blink 1.06s steps(1) infinite;
    -moz-animation: blink 1.06s steps(1) infinite;
    animation: blink 1.06s steps(1) infinite;
  }
  .cm-animate-fat-cursor {
    width: auto;
    border: 0;
    -webkit-animation: blink 1.06s steps(1) infinite;
    -moz-animation: blink 1.06s steps(1) infinite;
    animation: blink 1.06s steps(1) infinite;
    background-color: #7e7;
  }
  @-moz-keyframes blink {
    0% {
    }
    50% {
      background-color: transparent;
    }
    100% {
    }
  }
  @-webkit-keyframes blink {
    0% {
    }
    50% {
      background-color: transparent;
    }
    100% {
    }
  }
  @keyframes blink {
    0% {
    }
    50% {
      background-color: transparent;
    }
    100% {
    }
  }

  /* Can style cursor different in overwrite (non-insert) mode */
  .CodeMirror-overwrite .CodeMirror-cursor {
  }

  .cm-tab {
    display: inline-block;
    text-decoration: inherit;
  }

  .CodeMirror-rulers {
    position: absolute;
    left: 0;
    right: 0;
    top: -50px;
    bottom: 0;
    overflow: hidden;
  }
  .CodeMirror-ruler {
    border-left: 1px solid #ccc;
    top: 0;
    bottom: 0;
    position: absolute;
  }

  /* DEFAULT THEME */

  .cm-s-default .cm-header {
    color: blue;
  }
  .cm-s-default .cm-quote {
    color: #090;
  }
  .cm-negative {
    color: #d44;
  }
  .cm-positive {
    color: #292;
  }
  .cm-header,
  .cm-strong {
    font-weight: bold;
  }
  .cm-em {
    font-style: italic;
  }
  .cm-link {
    text-decoration: underline;
  }
  .cm-strikethrough {
    text-decoration: line-through;
  }

  .cm-s-default .cm-keyword {
    color: #708;
  }
  .cm-s-default .cm-atom {
    color: #219;
  }
  .cm-s-default .cm-number {
    color: #164;
  }
  .cm-s-default .cm-def {
    color: #00f;
  }
  .cm-s-default .cm-variable,
  .cm-s-default .cm-punctuation,
  .cm-s-default .cm-property,
  .cm-s-default .cm-operator {
  }
  .cm-s-default .cm-variable-2 {
    color: #05a;
  }
  .cm-s-default .cm-variable-3,
  .cm-s-default .cm-type {
    color: #085;
  }
  .cm-s-default .cm-comment {
    color: #a50;
  }
  .cm-s-default .cm-string {
    color: #a11;
  }
  .cm-s-default .cm-string-2 {
    color: #f50;
  }
  .cm-s-default .cm-meta {
    color: #555;
  }
  .cm-s-default .cm-qualifier {
    color: #555;
  }
  .cm-s-default .cm-builtin {
    color: #30a;
  }
  .cm-s-default .cm-bracket {
    color: #997;
  }
  .cm-s-default .cm-tag {
    color: #170;
  }
  .cm-s-default .cm-attribute {
    color: #00c;
  }
  .cm-s-default .cm-hr {
    color: #999;
  }
  .cm-s-default .cm-link {
    color: #00c;
  }

  .cm-s-default .cm-error {
    color: #f00;
  }
  .cm-invalidchar {
    color: #f00;
  }

  .CodeMirror-composing {
    border-bottom: 2px solid;
  }

  /* Default styles for common addons */

  div.CodeMirror span.CodeMirror-matchingbracket {
    color: #0b0;
  }
  div.CodeMirror span.CodeMirror-nonmatchingbracket {
    color: #a22;
  }
  .CodeMirror-matchingtag {
    background: rgba(255, 150, 0, 0.3);
  }
  .CodeMirror-activeline-background {
    background: #e8f2ff;
  }

  /* STOP */

  /* The rest of this file contains styles related to the mechanics of
   the editor. You probably shouldn't touch them. */

  .CodeMirror {
    position: relative;
    overflow: hidden;
    background: white;
  }

  .CodeMirror-scroll {
    overflow: scroll !important; /* Things will break if this is overridden */
    /* 50px is the magic margin used to hide the element's real scrollbars */
    /* See overflow: hidden in .CodeMirror */
    margin-bottom: -50px;
    margin-right: -50px;
    padding-bottom: 50px;
    height: 100%;
    outline: none; /* Prevent dragging from highlighting the element */
    position: relative;
  }
  .CodeMirror-sizer {
    position: relative;
    border-right: 50px solid transparent;
  }

  /* The fake, visible scrollbars. Used to force redraw during scrolling
   before actual scrolling happens, thus preventing shaking and
   flickering artifacts. */
  .CodeMirror-vscrollbar,
  .CodeMirror-hscrollbar,
  .CodeMirror-scrollbar-filler,
  .CodeMirror-gutter-filler {
    position: absolute;
    z-index: 6;
    display: none;
    outline: none;
  }
  .CodeMirror-vscrollbar {
    right: 0;
    top: 0;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .CodeMirror-hscrollbar {
    bottom: 0;
    left: 0;
    overflow-y: hidden;
    overflow-x: scroll;
  }
  .CodeMirror-scrollbar-filler {
    right: 0;
    bottom: 0;
  }
  .CodeMirror-gutter-filler {
    left: 0;
    bottom: 0;
  }

  .CodeMirror-gutters {
    position: absolute;
    left: 0;
    top: 0;
    min-height: 100%;
    z-index: 3;
  }
  .CodeMirror-gutter {
    white-space: normal;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    margin-bottom: -50px;
  }
  .CodeMirror-gutter-wrapper {
    position: absolute;
    z-index: 4;
    background: none !important;
    border: none !important;
  }
  .CodeMirror-gutter-background {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 4;
  }
  .CodeMirror-gutter-elt {
    position: absolute;
    cursor: default;
    z-index: 4;
  }
  .CodeMirror-gutter-wrapper ::selection {
    background-color: transparent;
  }
  .CodeMirror-gutter-wrapper ::-moz-selection {
    background-color: transparent;
  }

  .CodeMirror-lines {
    cursor: text;
    min-height: 1px; /* prevents collapsing before first draw */
  }
  .CodeMirror pre.CodeMirror-line,
  .CodeMirror pre.CodeMirror-line-like {
    /* Reset some styles that the rest of the page might have set */
    -moz-border-radius: 0;
    -webkit-border-radius: 0;
    border-radius: 0;
    border-width: 0;
    background: transparent;
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    white-space: pre;
    word-wrap: normal;
    line-height: inherit;
    color: inherit;
    z-index: 2;
    position: relative;
    overflow: visible;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-variant-ligatures: contextual;
    font-variant-ligatures: contextual;
  }
  .CodeMirror-wrap pre.CodeMirror-line,
  .CodeMirror-wrap pre.CodeMirror-line-like {
    word-wrap: break-word;
    white-space: pre-wrap;
    word-break: normal;
  }

  .CodeMirror-linebackground {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
  }

  .CodeMirror-linewidget {
    position: relative;
    z-index: 2;
    padding: 0.1px; /* Force widget margins to stay inside of the container */
  }

  .CodeMirror-widget {
  }

  .CodeMirror-rtl pre {
    direction: rtl;
  }

  .CodeMirror-code {
    outline: none;
  }

  /* Force content-box sizing for the elements where we expect it */
  .CodeMirror-scroll,
  .CodeMirror-sizer,
  .CodeMirror-gutter,
  .CodeMirror-gutters,
  .CodeMirror-linenumber {
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }

  .CodeMirror-measure {
    position: absolute;
    width: 100%;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }

  .CodeMirror-cursor {
    position: absolute;
    pointer-events: none;
  }
  .CodeMirror-measure pre {
    position: static;
  }

  div.CodeMirror-cursors {
    visibility: hidden;
    position: relative;
    z-index: 3;
  }
  div.CodeMirror-dragcursors {
    visibility: visible;
  }

  .CodeMirror-focused div.CodeMirror-cursors {
    visibility: visible;
  }

  .CodeMirror-selected {
    background: #d9d9d9;
  }
  .CodeMirror-focused .CodeMirror-selected {
    background: #d7d4f0;
  }
  .CodeMirror-crosshair {
    cursor: crosshair;
  }
  .CodeMirror-line::selection,
  .CodeMirror-line > span::selection,
  .CodeMirror-line > span > span::selection {
    background: #d7d4f0;
  }
  .CodeMirror-line::-moz-selection,
  .CodeMirror-line > span::-moz-selection,
  .CodeMirror-line > span > span::-moz-selection {
    background: #d7d4f0;
  }

  .cm-searching {
    background-color: #ffa;
    background-color: rgba(255, 255, 0, 0.4);
  }

  /* Used to force a border model for a node */
  .cm-force-border {
    padding-right: 0.1px;
  }

  @media print {
    /* Hide the cursor when printing */
    .CodeMirror div.CodeMirror-cursors {
      visibility: hidden;
    }
  }

  /* See issue #2901 */
  .cm-tab-wrap-hack:after {
    content: '';
  }

  /* Help users use markselection to safely style text background */
  span.CodeMirror-selectedtext {
    background: none;
  }
`;

});

parcelRegister("iEzNh", function(module, exports) {

$parcel$export(module.exports, "EditorProvider", () => $de47e74d02528893$export$b0c14a64ec1678d5);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");
class $de47e74d02528893$export$b0c14a64ec1678d5 {
    getInstance() {
        return this.codeMirror;
    }
    setInstance(mirror) {
        this.codeMirror = mirror;
    }
}
$de47e74d02528893$export$b0c14a64ec1678d5 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $de47e74d02528893$export$b0c14a64ec1678d5);

});

parcelRegister("9o45I", function(module, exports) {

$parcel$export(module.exports, "MaterialTheme", () => $2025fbda671c5754$export$e7f37c4b024bcb35);

var $4TeKW = parcelRequire("4TeKW");
const $2025fbda671c5754$export$e7f37c4b024bcb35 = (0, $4TeKW.css)`
  /*
  Name:       material
  Author:     Mattia Astorino (http://github.com/equinusocio)
  Website:    https://material-theme.site/
*/

  .cm-s-material.CodeMirror {
    background-color: #263238;
    color: #eeffff;
  }

  .cm-s-material .CodeMirror-gutters {
    background: #263238;
    color: #546e7a;
    border: none;
  }

  .cm-s-material .CodeMirror-guttermarker,
  .cm-s-material .CodeMirror-guttermarker-subtle,
  .cm-s-material .CodeMirror-linenumber {
    color: #546e7a;
  }

  .cm-s-material .CodeMirror-cursor {
    border-left: 1px solid #ffcc00;
  }
  .cm-s-material.cm-fat-cursor .CodeMirror-cursor {
    background-color: #5d6d5c80 !important;
  }
  .cm-s-material .cm-animate-fat-cursor {
    background-color: #5d6d5c80 !important;
  }

  .cm-s-material div.CodeMirror-selected {
    background: rgba(128, 203, 196, 0.2);
  }

  .cm-s-material.CodeMirror-focused div.CodeMirror-selected {
    background: rgba(128, 203, 196, 0.2);
  }

  .cm-s-material .CodeMirror-line::selection,
  .cm-s-material .CodeMirror-line > span::selection,
  .cm-s-material .CodeMirror-line > span > span::selection {
    background: rgba(128, 203, 196, 0.2);
  }

  .cm-s-material .CodeMirror-line::-moz-selection,
  .cm-s-material .CodeMirror-line > span::-moz-selection,
  .cm-s-material .CodeMirror-line > span > span::-moz-selection {
    background: rgba(128, 203, 196, 0.2);
  }

  .cm-s-material .CodeMirror-activeline-background {
    background: rgba(0, 0, 0, 0.5);
  }

  .cm-s-material .cm-keyword {
    color: #c792ea;
  }

  .cm-s-material .cm-operator {
    color: #89ddff;
  }

  .cm-s-material .cm-variable-2 {
    color: #eeffff;
  }

  .cm-s-material .cm-variable-3,
  .cm-s-material .cm-type {
    color: #f07178;
  }

  .cm-s-material .cm-builtin {
    color: #ffcb6b;
  }

  .cm-s-material .cm-atom {
    color: #f78c6c;
  }

  .cm-s-material .cm-number {
    color: #ff5370;
  }

  .cm-s-material .cm-def {
    color: #82aaff;
  }

  .cm-s-material .cm-string {
    color: #c3e88d;
  }

  .cm-s-material .cm-string-2 {
    color: #f07178;
  }

  .cm-s-material .cm-comment {
    color: #546e7a;
  }

  .cm-s-material .cm-variable {
    color: #f07178;
  }

  .cm-s-material .cm-tag {
    color: #ff5370;
  }

  .cm-s-material .cm-meta {
    color: #ffcb6b;
  }

  .cm-s-material .cm-attribute {
    color: #c792ea;
  }

  .cm-s-material .cm-property {
    color: #c792ea;
  }

  .cm-s-material .cm-qualifier {
    color: #decb6b;
  }

  .cm-s-material .cm-variable-3,
  .cm-s-material .cm-type {
    color: #decb6b;
  }

  .cm-s-material .cm-error {
    color: rgba(255, 255, 255, 1);
    background-color: #ff5370;
  }

  .cm-s-material .CodeMirror-matchingbracket {
    text-decoration: underline;
    color: white !important;
  }
`;

});


parcelRegister("9B4nF", function(module, exports) {

$parcel$export(module.exports, "FileUploaderComponent", () => $dc1f9bd1d419e5b2$export$124a27dabf233814);

var $deWeK = parcelRequire("deWeK");

var $613YX = parcelRequire("613YX");

var $4TeKW = parcelRequire("4TeKW");

var $j1Rhz = parcelRequire("j1Rhz");

var $8id0M = parcelRequire("8id0M");

var $9wU3T = parcelRequire("9wU3T");
class $dc1f9bd1d419e5b2$export$124a27dabf233814 extends (0, $4TeKW.LitElement) {
    OnUpdateFirst() {
        this.droppable = new (0, $j1Rhz.default)({
            element: this,
            acceptsMultipleFiles: this.acceptsMultipleFiles,
            isClickable: this.isClickable
        });
    }
    onFilesDropped() {
        return new (0, $8id0M.Observable)((observer)=>{
            const listener = this.droppable.onFilesDropped((detail)=>{
                this.dispatchEvent(new CustomEvent('filesDropped', {
                    detail: detail
                }));
                observer.next(detail);
            });
            return ()=>{
                observer.complete();
                listener();
            };
        });
    }
    OnDestroy() {
        this.droppable.destroy();
    }
    constructor(...args){
        super(...args), this.acceptsMultipleFiles = true;
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $dc1f9bd1d419e5b2$export$124a27dabf233814.prototype, "isClickable", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $dc1f9bd1d419e5b2$export$124a27dabf233814.prototype, "acceptsMultipleFiles", void 0);
$dc1f9bd1d419e5b2$export$124a27dabf233814 = (0, $deWeK.__decorate)([
    (0, $613YX.Component)({
        Settings: {
            selector: 'file-uploader',
            styles: [
                (0, $4TeKW.css)`
        :host {
          outline: none;
          user-select: none;
        }
      `
            ]
        },
        State: function() {
            return this.onFilesDropped().pipe((0, $9wU3T.startWith)([]));
        },
        Render: ()=>function() {
                return (0, $4TeKW.html)`<slot></slot>`;
            }
    })
], $dc1f9bd1d419e5b2$export$124a27dabf233814);

});
parcelRegister("j1Rhz", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda77112bf7316e4$export$2e2bcd8739ae039);
// Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
// import "core-js/fn/array.find"
// ...}
/**
 * @author Joel Hernandez <lifenautjoe@gmail.com>
 */ var $dda77112bf7316e4$var$Droppable = /** @class */ function() {
    function Droppable(config) {
        this.onFilesDroppedEventListeners = [];
        config = config || {};
        if (!config.element) throw new Error('config.element: HTMLElement is required');
        // This must be called before calling setAcceptsMultipleFiles
        this.virtualInputElement = Droppable.makeVirtualInputElement();
        var isClickable = typeof config.isClickable === 'boolean' ? config.isClickable : true;
        var acceptsMultipleFiles = typeof config.acceptsMultipleFiles === 'boolean' ? config.acceptsMultipleFiles : true;
        var appendStatusClasses = typeof config.appendStatusClasses === 'boolean' ? config.appendStatusClasses : true;
        this.dragOverClass = typeof config.dragOverClass === 'string' ? config.dragOverClass : 'dragover';
        this.setIsClickable(isClickable);
        this.setAcceptsMultipleFiles(acceptsMultipleFiles);
        this.setAppendStatusClasses(appendStatusClasses);
        this.element = config.element;
        this.elementEventsRemover = this.registerElementEvents();
        Droppable.addAccessibilityAttributesToDroppableElement(this.element);
        this.virtualInputElementEventsRemover = this.registerVirtualInputElementEvents();
    }
    Droppable.makeVirtualInputElement = function() {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.style.display = 'none';
        return input;
    };
    Droppable.addAccessibilityAttributesToDroppableElement = function(element) {
        element.tabIndex = 0;
        element.role = 'button';
    };
    Droppable.removeAccessibilityAttributesToDroppableElement = function(element) {
        delete element.role;
        element.removeAttribute('tabIndex');
    };
    Droppable.prototype.onFilesDropped = function(listener) {
        var _this = this;
        this.onFilesDroppedEventListeners.push(listener);
        return function() {
            var listenerIndex = _this.onFilesDroppedEventListeners.indexOf(listener);
            _this.onFilesDroppedEventListeners.splice(listenerIndex, 1);
        };
    };
    Droppable.prototype.destroy = function() {
        this.elementEventsRemover();
        this.virtualInputElementEventsRemover();
        this.onFilesDroppedEventListeners = [];
        Droppable.removeAccessibilityAttributesToDroppableElement(this.element);
    };
    Droppable.prototype.getLatestDroppedFiles = function() {
        if (this.latestDroppedFiles) return this.latestDroppedFiles;
        return [];
    };
    Droppable.prototype.promptForFiles = function() {
        this.virtualInputElement.click();
    };
    Droppable.prototype.setIsClickable = function(clickable) {
        this.isClickable = clickable;
    };
    Droppable.prototype.setAcceptsMultipleFiles = function(acceptsMultipleFiles) {
        this.virtualInputElement.setAttribute('multiple', acceptsMultipleFiles.toString());
    };
    Droppable.prototype.setAppendStatusClasses = function(appendStatusClasses) {
        this.appendStatusClasses = appendStatusClasses;
    };
    Droppable.prototype.registerElementEvents = function() {
        var eventNameToEventListenerDictionary = this.getElementEventsDictionary();
        return this.registerElementEventsWithDictionary(this.element, eventNameToEventListenerDictionary);
    };
    Droppable.prototype.registerVirtualInputElementEvents = function() {
        var eventNameToEventListenerDictionary = this.getVirtualInputElementEventsDictionary();
        return this.registerElementEventsWithDictionary(this.virtualInputElement, eventNameToEventListenerDictionary);
    };
    Droppable.prototype.getVirtualInputElementEventsDictionary = function() {
        return {
            change: this.onVirtualInputElementChange
        };
    };
    Droppable.prototype.getElementEventsDictionary = function() {
        return {
            dragover: this.onElementDragOver,
            dragleave: this.onElementDragLeave,
            drop: this.onElementDrop,
            click: this.onElementClick,
            focus: this.onElementFocus,
            focusout: this.onElementFocusOut
        };
    };
    Droppable.prototype.onElementDragOver = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.appendStatusClasses) this.element.classList.add(this.dragOverClass);
    };
    Droppable.prototype.onElementDragLeave = function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.element.classList.remove(this.dragOverClass);
    };
    Droppable.prototype.onElementDrop = function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.element.classList.remove(this.dragOverClass);
        this.onDroppableElementChange(e);
    };
    Droppable.prototype.onElementClick = function() {
        if (this.isClickable) this.promptForFiles();
    };
    Droppable.prototype.onElementKeyDown = function(e) {
        if (e['keyCode'] === Droppable.ENTER_KEY_CODE) {
            this.promptForFiles();
            this.element.blur();
        }
    };
    Droppable.prototype.onElementFocus = function() {
        this.elementKeyDownEventRemover = this.registerElementEventsWithDictionary(this.element, {
            keydown: this.onElementKeyDown
        });
    };
    Droppable.prototype.onElementFocusOut = function() {
        if (this.elementKeyDownEventRemover) this.elementKeyDownEventRemover();
    };
    Droppable.prototype.onVirtualInputElementChange = function(e) {
        this.onDroppableElementChange(e);
        this.virtualInputElement.value = '';
    };
    Droppable.prototype.onDroppableElementChange = function(event) {
        var files;
        if (event['dataTransfer']) files = event['dataTransfer'].files;
        else if (event['target']) files = event['target'].files;
        else throw Error('Fired event contains no files');
        // Files is FileList, we convert to array
        var filesArray = Array.from(files);
        this.setLatestDrop(filesArray);
    };
    Droppable.prototype.setLatestDrop = function(files) {
        this.latestDroppedFiles = files;
        this.emitFilesWereDropped(files);
    };
    Droppable.prototype.emitFilesWereDropped = function(files) {
        this.onFilesDroppedEventListeners.forEach(function(listener) {
            listener(files);
        });
    };
    Droppable.prototype.registerElementEventsWithDictionary = function(element, eventNameToEventListenerDictionary) {
        var _this = this;
        var eventRemovers = [];
        Object.keys(eventNameToEventListenerDictionary).forEach(function(eventName) {
            var eventListener = eventNameToEventListenerDictionary[eventName];
            var boundEventListener = eventListener.bind(_this);
            element.addEventListener(eventName, boundEventListener);
            eventRemovers.push(function() {
                return element.removeEventListener(eventName, boundEventListener);
            });
        });
        return function() {
            return eventRemovers.forEach(function(eventRemover) {
                return eventRemover();
            });
        };
    };
    Droppable.ENTER_KEY_CODE = 13;
    return Droppable;
}();
var $dda77112bf7316e4$export$2e2bcd8739ae039 = $dda77112bf7316e4$var$Droppable;

});


parcelRegister("ibuOs", function(module, exports) {

$parcel$export(module.exports, "GenericNavbarComponent", () => $e2c12ce8313eb2b6$export$771f7171388ff23);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $5JMLH = parcelRequire("5JMLH");
const $e2c12ce8313eb2b6$var$style = (0, $4TeKW.css)`
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    cursor: pointer;
  }

  li {
    float: left;
  }

  li a {
    display: block;
    color: #6b7873;
    text-align: center;
    padding: 16px;
    text-decoration: none;
  }

  li a:hover {
    color: white;
  }

  .white {
    color: white;
  }
`;
class $e2c12ce8313eb2b6$export$771f7171388ff23 extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.items = [];
    }
}
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $e2c12ce8313eb2b6$export$771f7171388ff23.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $e2c12ce8313eb2b6$export$771f7171388ff23.prototype, "items", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $e2c12ce8313eb2b6$export$771f7171388ff23.prototype, "includes", void 0);
$e2c12ce8313eb2b6$export$771f7171388ff23 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'generic-navbar-component',
        style: $e2c12ce8313eb2b6$var$style,
        template () {
            return (0, $4TeKW.html)`
      <div style="padding: 10px;">
        <ul>
          <rx-graph
            .options=${{
                style: $e2c12ce8313eb2b6$var$style,
                state: (0, $5JMLH.from)(this.items),
                render: (items)=>(0, $4TeKW.html)`
                ${items.map((i)=>(0, $4TeKW.html)`
                    <li @click=${()=>this.router.go(i.value)}>
                      <a
                        class=${(0, $4TeKW.classMap)({
                            white: this.includes ? i.value.includes(this.includes) : this.router.activePath === i.value
                        })}
                        >${i.key}</a
                      >
                    </li>
                  `)}
              `
            }}
          ></rx-graph>
        </ul>
      </div>
    `;
        }
    })
], $e2c12ce8313eb2b6$export$771f7171388ff23);

});

parcelRegister("qje1A", function(module, exports) {

$parcel$export(module.exports, "GridComponent", () => $d10b633ea4d12535$export$439a99b941ac57a6);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $2d0B8 = parcelRequire("2d0B8");

var $cdTWx = parcelRequire("cdTWx");
var $5JMLH = parcelRequire("5JMLH");
var $8MKp4 = parcelRequire("8MKp4");
var $g5fNy = parcelRequire("g5fNy");

var $gawXH = parcelRequire("gawXH");
var $lNnaw = parcelRequire("lNnaw");
class $d10b633ea4d12535$export$439a99b941ac57a6 extends (0, $4TeKW.LitElement) {
    calculateColumns(width) {
        let columns;
        if (this.columns) return this.columns;
        if (width < 700) columns = 1;
        else if (width < 1000) columns = 2;
        else if (width < 1450) columns = 3;
        else if (width > 1450) columns = 4;
        return columns;
    }
    calculateRows(itemsLength, columns) {
        if (this.rows) return this.rows;
        else return Math.round(itemsLength / columns) + 2;
    }
    calculateTemplateColumns(items, index, columns) {
        const calculated = index * columns;
        const offset = calculated - columns;
        return (0, $4TeKW.html)`
      <div class=${(0, $4TeKW.classMap)({
            flex: true,
            center: this.center
        })}>
        ${items.length ? (0, $4TeKW.html)` ${items.slice(offset, calculated).map((item)=>this.getTemplate(item))} ` : 'No components found'}
      </div>
    `;
    }
    getTemplate(item) {
        if (!item) return (0, $4TeKW.html)``;
        return (0, $4TeKW.html)`
      ${this.template ? this.template(item) : (0, $4TeKW.html)` ${item} `}
      <span class="spacer"></span>
    `;
    }
    constructor(...args){
        super(...args), this.$items = (0, $g5fNy.of)([]), this.center = true;
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $2d0B8.ResponsiveService))
], $d10b633ea4d12535$export$439a99b941ac57a6.prototype, "responsive", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $d10b633ea4d12535$export$439a99b941ac57a6.prototype, "fill", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        attribute: false
    })
], $d10b633ea4d12535$export$439a99b941ac57a6.prototype, "$items", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        attribute: false
    })
], $d10b633ea4d12535$export$439a99b941ac57a6.prototype, "template", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $d10b633ea4d12535$export$439a99b941ac57a6.prototype, "columns", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $d10b633ea4d12535$export$439a99b941ac57a6.prototype, "customStyle", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $d10b633ea4d12535$export$439a99b941ac57a6.prototype, "rows", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $d10b633ea4d12535$export$439a99b941ac57a6.prototype, "center", void 0);
$d10b633ea4d12535$export$439a99b941ac57a6 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'flex-grid',
        style: (0, $4TeKW.css)`
    .flex {
      display: flex;
    }
    .spacer {
      flex: 1 3 auto;
    }
    .center {
      margin: 0 auto;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      ${(0, $4TeKW.async)((0, $5JMLH.from)((0, $8MKp4.isObservable)(this.$items) ? this.$items : (0, $g5fNy.of)(this.$items)).pipe((0, $gawXH.map)((items)=>items && items.length ? items : Array.from(Array(this.fill).keys())), (0, $lNnaw.switchMap)((c)=>(0, $cdTWx.combineLatest)((0, $g5fNy.of)(c), this.responsive.width.pipe((0, $gawXH.map)((width)=>this.calculateColumns(width))))), (0, $lNnaw.switchMap)(([c, columns])=>(0, $cdTWx.combineLatest)([
                    (0, $g5fNy.of)(c),
                    (0, $g5fNy.of)(this.calculateRows(c.length, columns)),
                    (0, $g5fNy.of)(columns)
                ]))).pipe((0, $gawXH.map)(([components, rows, columns])=>(0, $4TeKW.html)`
                ${Array.from(Array(rows).keys()).map((i)=>(0, $4TeKW.html)` <div class="flex">${this.calculateTemplateColumns(components, i, columns)}</div> `)}
              `)))}
    `;
        }
    })
], $d10b633ea4d12535$export$439a99b941ac57a6);

});

parcelRegister("jpOXL", function(module, exports) {

$parcel$export(module.exports, "HamburgerComponent", () => $f64ec027ee6f0753$export$1c05e92590e3dbe);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $fP6xa = parcelRequire("fP6xa");
class $f64ec027ee6f0753$export$1c05e92590e3dbe extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.type = '3dx';
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $f64ec027ee6f0753$export$1c05e92590e3dbe.prototype, "active", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $f64ec027ee6f0753$export$1c05e92590e3dbe.prototype, "type", void 0);
$f64ec027ee6f0753$export$1c05e92590e3dbe = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'hamburger-component',
        style: $fP6xa.style,
        template () {
            return (0, $4TeKW.html)`
      <div
        @click=${()=>this.active = !this.active}
        class="hamburger hamburger--${this.type} ${this.active ? 'is-active' : ''}"
      >
        <div class="hamburger-box">
          <div class="hamburger-inner"></div>
        </div>
      </div>
    `;
        }
    })
], $f64ec027ee6f0753$export$1c05e92590e3dbe);

});
parcelRegister("fP6xa", function(module, exports) {

$parcel$export(module.exports, "style", () => $445d10b2a7b0d28c$export$1d567c320f4763bc);

var $4TeKW = parcelRequire("4TeKW");
const $445d10b2a7b0d28c$export$1d567c320f4763bc = (0, $4TeKW.css)`
  .hamburger {
    padding: 15px 15px;
    display: inline-block;
    cursor: pointer;
    transition-property: opacity, filter;
    transition-duration: 0.15s;
    transition-timing-function: linear;
    font: inherit;
    color: inherit;
    text-transform: none;
    background-color: transparent;
    border: 0;
    margin: 0;
    overflow: visible;
  }
  .hamburger:hover {
    opacity: 0.7;
  }
  .hamburger.is-active:hover {
    opacity: 0.7;
  }
  .hamburger.is-active .hamburger-inner,
  .hamburger.is-active .hamburger-inner::before,
  .hamburger.is-active .hamburger-inner::after {
    background-color: #fff;
  }

  .hamburger-box {
    width: 40px;
    height: 24px;
    display: inline-block;
    position: relative;
  }

  .hamburger-inner {
    display: block;
    top: 50%;
    margin-top: -2px;
  }
  .hamburger-inner,
  .hamburger-inner::before,
  .hamburger-inner::after {
    width: 40px;
    height: 4px;
    background-color: #fff;
    border-radius: 4px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }
  .hamburger-inner::before,
  .hamburger-inner::after {
    content: '';
    display: block;
  }
  .hamburger-inner::before {
    top: -10px;
  }
  .hamburger-inner::after {
    bottom: -10px;
  }

  /*
   * 3DX
   */
  .hamburger--3dx .hamburger-box {
    perspective: 80px;
  }

  .hamburger--3dx .hamburger-inner {
    transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),
      background-color 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .hamburger--3dx .hamburger-inner::before,
  .hamburger--3dx .hamburger-inner::after {
    transition: transform 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .hamburger--3dx.is-active .hamburger-inner {
    background-color: transparent !important;
    transform: rotateY(180deg);
  }
  .hamburger--3dx.is-active .hamburger-inner::before {
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  .hamburger--3dx.is-active .hamburger-inner::after {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
  }

  /*
   * 3DX Reverse
   */
  .hamburger--3dx-r .hamburger-box {
    perspective: 80px;
  }

  .hamburger--3dx-r .hamburger-inner {
    transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),
      background-color 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .hamburger--3dx-r .hamburger-inner::before,
  .hamburger--3dx-r .hamburger-inner::after {
    transition: transform 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .hamburger--3dx-r.is-active .hamburger-inner {
    background-color: transparent !important;
    transform: rotateY(-180deg);
  }
  .hamburger--3dx-r.is-active .hamburger-inner::before {
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  .hamburger--3dx-r.is-active .hamburger-inner::after {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
  }

  /*
   * 3DY
   */
  .hamburger--3dy .hamburger-box {
    perspective: 80px;
  }

  .hamburger--3dy .hamburger-inner {
    transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),
      background-color 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .hamburger--3dy .hamburger-inner::before,
  .hamburger--3dy .hamburger-inner::after {
    transition: transform 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .hamburger--3dy.is-active .hamburger-inner {
    background-color: transparent !important;
    transform: rotateX(-180deg);
  }
  .hamburger--3dy.is-active .hamburger-inner::before {
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  .hamburger--3dy.is-active .hamburger-inner::after {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
  }

  /*
   * 3DY Reverse
   */
  .hamburger--3dy-r .hamburger-box {
    perspective: 80px;
  }

  .hamburger--3dy-r .hamburger-inner {
    transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),
      background-color 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .hamburger--3dy-r .hamburger-inner::before,
  .hamburger--3dy-r .hamburger-inner::after {
    transition: transform 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .hamburger--3dy-r.is-active .hamburger-inner {
    background-color: transparent !important;
    transform: rotateX(180deg);
  }
  .hamburger--3dy-r.is-active .hamburger-inner::before {
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  .hamburger--3dy-r.is-active .hamburger-inner::after {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
  }

  /*
   * 3DXY
   */
  .hamburger--3dxy .hamburger-box {
    perspective: 80px;
  }

  .hamburger--3dxy .hamburger-inner {
    transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),
      background-color 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .hamburger--3dxy .hamburger-inner::before,
  .hamburger--3dxy .hamburger-inner::after {
    transition: transform 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .hamburger--3dxy.is-active .hamburger-inner {
    background-color: transparent !important;
    transform: rotateX(180deg) rotateY(180deg);
  }
  .hamburger--3dxy.is-active .hamburger-inner::before {
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  .hamburger--3dxy.is-active .hamburger-inner::after {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
  }

  /*
   * 3DXY Reverse
   */
  .hamburger--3dxy-r .hamburger-box {
    perspective: 80px;
  }

  .hamburger--3dxy-r .hamburger-inner {
    transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),
      background-color 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .hamburger--3dxy-r .hamburger-inner::before,
  .hamburger--3dxy-r .hamburger-inner::after {
    transition: transform 0s 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .hamburger--3dxy-r.is-active .hamburger-inner {
    background-color: transparent !important;
    transform: rotateX(180deg) rotateY(180deg) rotateZ(-180deg);
  }
  .hamburger--3dxy-r.is-active .hamburger-inner::before {
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  .hamburger--3dxy-r.is-active .hamburger-inner::after {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
  }

  /*
   * Arrow
   */
  .hamburger--arrow.is-active .hamburger-inner::before {
    transform: translate3d(-8px, 0, 0) rotate(-45deg) scale(0.7, 1);
  }

  .hamburger--arrow.is-active .hamburger-inner::after {
    transform: translate3d(-8px, 0, 0) rotate(45deg) scale(0.7, 1);
  }

  /*
   * Arrow Right
   */
  .hamburger--arrow-r.is-active .hamburger-inner::before {
    transform: translate3d(8px, 0, 0) rotate(45deg) scale(0.7, 1);
  }

  .hamburger--arrow-r.is-active .hamburger-inner::after {
    transform: translate3d(8px, 0, 0) rotate(-45deg) scale(0.7, 1);
  }

  /*
   * Arrow Alt
   */
  .hamburger--arrowalt .hamburger-inner::before {
    transition: top 0.1s 0.1s ease, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  .hamburger--arrowalt .hamburger-inner::after {
    transition: bottom 0.1s 0.1s ease, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  .hamburger--arrowalt.is-active .hamburger-inner::before {
    top: 0;
    transform: translate3d(-8px, -10px, 0) rotate(-45deg) scale(0.7, 1);
    transition: top 0.1s ease, transform 0.1s 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22);
  }

  .hamburger--arrowalt.is-active .hamburger-inner::after {
    bottom: 0;
    transform: translate3d(-8px, 10px, 0) rotate(45deg) scale(0.7, 1);
    transition: bottom 0.1s ease, transform 0.1s 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22);
  }

  /*
   * Arrow Alt Right
   */
  .hamburger--arrowalt-r .hamburger-inner::before {
    transition: top 0.1s 0.1s ease, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  .hamburger--arrowalt-r .hamburger-inner::after {
    transition: bottom 0.1s 0.1s ease, transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  .hamburger--arrowalt-r.is-active .hamburger-inner::before {
    top: 0;
    transform: translate3d(8px, -10px, 0) rotate(45deg) scale(0.7, 1);
    transition: top 0.1s ease, transform 0.1s 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22);
  }

  .hamburger--arrowalt-r.is-active .hamburger-inner::after {
    bottom: 0;
    transform: translate3d(8px, 10px, 0) rotate(-45deg) scale(0.7, 1);
    transition: bottom 0.1s ease, transform 0.1s 0.1s cubic-bezier(0.895, 0.03, 0.685, 0.22);
  }

  /*
   * Arrow Turn
   */
  .hamburger--arrowturn.is-active .hamburger-inner {
    transform: rotate(-180deg);
  }
  .hamburger--arrowturn.is-active .hamburger-inner::before {
    transform: translate3d(8px, 0, 0) rotate(45deg) scale(0.7, 1);
  }
  .hamburger--arrowturn.is-active .hamburger-inner::after {
    transform: translate3d(8px, 0, 0) rotate(-45deg) scale(0.7, 1);
  }

  /*
   * Arrow Turn Right
   */
  .hamburger--arrowturn-r.is-active .hamburger-inner {
    transform: rotate(-180deg);
  }
  .hamburger--arrowturn-r.is-active .hamburger-inner::before {
    transform: translate3d(-8px, 0, 0) rotate(-45deg) scale(0.7, 1);
  }
  .hamburger--arrowturn-r.is-active .hamburger-inner::after {
    transform: translate3d(-8px, 0, 0) rotate(45deg) scale(0.7, 1);
  }

  /*
   * Boring
   */
  .hamburger--boring .hamburger-inner,
  .hamburger--boring .hamburger-inner::before,
  .hamburger--boring .hamburger-inner::after {
    transition-property: none;
  }

  .hamburger--boring.is-active .hamburger-inner {
    transform: rotate(45deg);
  }
  .hamburger--boring.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
  }
  .hamburger--boring.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(-90deg);
  }

  /*
   * Collapse
   */
  .hamburger--collapse .hamburger-inner {
    top: auto;
    bottom: 0;
    transition-duration: 0.13s;
    transition-delay: 0.13s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--collapse .hamburger-inner::after {
    top: -20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s linear;
  }
  .hamburger--collapse .hamburger-inner::before {
    transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
      transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--collapse.is-active .hamburger-inner {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
    transition-delay: 0.22s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .hamburger--collapse.is-active .hamburger-inner::after {
    top: 0;
    opacity: 0;
    transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s 0.22s linear;
  }
  .hamburger--collapse.is-active .hamburger-inner::before {
    top: 0;
    transform: rotate(-90deg);
    transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
      transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /*
   * Collapse Reverse
   */
  .hamburger--collapse-r .hamburger-inner {
    top: auto;
    bottom: 0;
    transition-duration: 0.13s;
    transition-delay: 0.13s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--collapse-r .hamburger-inner::after {
    top: -20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s linear;
  }
  .hamburger--collapse-r .hamburger-inner::before {
    transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
      transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--collapse-r.is-active .hamburger-inner {
    transform: translate3d(0, -10px, 0) rotate(45deg);
    transition-delay: 0.22s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .hamburger--collapse-r.is-active .hamburger-inner::after {
    top: 0;
    opacity: 0;
    transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s 0.22s linear;
  }
  .hamburger--collapse-r.is-active .hamburger-inner::before {
    top: 0;
    transform: rotate(90deg);
    transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
      transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /*
   * Elastic
   */
  .hamburger--elastic .hamburger-inner {
    top: 2px;
    transition-duration: 0.275s;
    transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .hamburger--elastic .hamburger-inner::before {
    top: 10px;
    transition: opacity 0.125s 0.275s ease;
  }
  .hamburger--elastic .hamburger-inner::after {
    top: 20px;
    transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .hamburger--elastic.is-active .hamburger-inner {
    transform: translate3d(0, 10px, 0) rotate(135deg);
    transition-delay: 0.075s;
  }
  .hamburger--elastic.is-active .hamburger-inner::before {
    transition-delay: 0s;
    opacity: 0;
  }
  .hamburger--elastic.is-active .hamburger-inner::after {
    transform: translate3d(0, -20px, 0) rotate(-270deg);
    transition-delay: 0.075s;
  }

  /*
   * Elastic Reverse
   */
  .hamburger--elastic-r .hamburger-inner {
    top: 2px;
    transition-duration: 0.275s;
    transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .hamburger--elastic-r .hamburger-inner::before {
    top: 10px;
    transition: opacity 0.125s 0.275s ease;
  }
  .hamburger--elastic-r .hamburger-inner::after {
    top: 20px;
    transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .hamburger--elastic-r.is-active .hamburger-inner {
    transform: translate3d(0, 10px, 0) rotate(-135deg);
    transition-delay: 0.075s;
  }
  .hamburger--elastic-r.is-active .hamburger-inner::before {
    transition-delay: 0s;
    opacity: 0;
  }
  .hamburger--elastic-r.is-active .hamburger-inner::after {
    transform: translate3d(0, -20px, 0) rotate(270deg);
    transition-delay: 0.075s;
  }

  /*
   * Emphatic
   */
  .hamburger--emphatic {
    overflow: hidden;
  }
  .hamburger--emphatic .hamburger-inner {
    transition: background-color 0.125s 0.175s ease-in;
  }
  .hamburger--emphatic .hamburger-inner::before {
    left: 0;
    transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s 0.125s linear,
      left 0.125s 0.175s ease-in;
  }
  .hamburger--emphatic .hamburger-inner::after {
    top: 10px;
    right: 0;
    transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s 0.125s linear,
      right 0.125s 0.175s ease-in;
  }
  .hamburger--emphatic.is-active .hamburger-inner {
    transition-delay: 0s;
    transition-timing-function: ease-out;
    background-color: transparent !important;
  }
  .hamburger--emphatic.is-active .hamburger-inner::before {
    left: -80px;
    top: -80px;
    transform: translate3d(80px, 80px, 0) rotate(45deg);
    transition: left 0.125s ease-out, top 0.05s 0.125s linear,
      transform 0.125s 0.175s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .hamburger--emphatic.is-active .hamburger-inner::after {
    right: -80px;
    top: -80px;
    transform: translate3d(-80px, 80px, 0) rotate(-45deg);
    transition: right 0.125s ease-out, top 0.05s 0.125s linear,
      transform 0.125s 0.175s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  /*
   * Emphatic Reverse
   */
  .hamburger--emphatic-r {
    overflow: hidden;
  }
  .hamburger--emphatic-r .hamburger-inner {
    transition: background-color 0.125s 0.175s ease-in;
  }
  .hamburger--emphatic-r .hamburger-inner::before {
    left: 0;
    transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s 0.125s linear,
      left 0.125s 0.175s ease-in;
  }
  .hamburger--emphatic-r .hamburger-inner::after {
    top: 10px;
    right: 0;
    transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s 0.125s linear,
      right 0.125s 0.175s ease-in;
  }
  .hamburger--emphatic-r.is-active .hamburger-inner {
    transition-delay: 0s;
    transition-timing-function: ease-out;
    background-color: transparent !important;
  }
  .hamburger--emphatic-r.is-active .hamburger-inner::before {
    left: -80px;
    top: 80px;
    transform: translate3d(80px, -80px, 0) rotate(-45deg);
    transition: left 0.125s ease-out, top 0.05s 0.125s linear,
      transform 0.125s 0.175s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .hamburger--emphatic-r.is-active .hamburger-inner::after {
    right: -80px;
    top: 80px;
    transform: translate3d(-80px, -80px, 0) rotate(45deg);
    transition: right 0.125s ease-out, top 0.05s 0.125s linear,
      transform 0.125s 0.175s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  /*
   * Minus
   */
  .hamburger--minus .hamburger-inner::before,
  .hamburger--minus .hamburger-inner::after {
    transition: bottom 0.08s 0s ease-out, top 0.08s 0s ease-out, opacity 0s linear;
  }

  .hamburger--minus.is-active .hamburger-inner::before,
  .hamburger--minus.is-active .hamburger-inner::after {
    opacity: 0;
    transition: bottom 0.08s ease-out, top 0.08s ease-out, opacity 0s 0.08s linear;
  }

  .hamburger--minus.is-active .hamburger-inner::before {
    top: 0;
  }

  .hamburger--minus.is-active .hamburger-inner::after {
    bottom: 0;
  }

  /*
   * Slider
   */
  .hamburger--slider .hamburger-inner {
    top: 2px;
  }
  .hamburger--slider .hamburger-inner::before {
    top: 10px;
    transition-property: transform, opacity;
    transition-timing-function: ease;
    transition-duration: 0.15s;
  }
  .hamburger--slider .hamburger-inner::after {
    top: 20px;
  }

  .hamburger--slider.is-active .hamburger-inner {
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  .hamburger--slider.is-active .hamburger-inner::before {
    transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);
    opacity: 0;
  }
  .hamburger--slider.is-active .hamburger-inner::after {
    transform: translate3d(0, -20px, 0) rotate(-90deg);
  }

  /*
   * Slider Reverse
   */
  .hamburger--slider-r .hamburger-inner {
    top: 2px;
  }
  .hamburger--slider-r .hamburger-inner::before {
    top: 10px;
    transition-property: transform, opacity;
    transition-timing-function: ease;
    transition-duration: 0.15s;
  }
  .hamburger--slider-r .hamburger-inner::after {
    top: 20px;
  }

  .hamburger--slider-r.is-active .hamburger-inner {
    transform: translate3d(0, 10px, 0) rotate(-45deg);
  }
  .hamburger--slider-r.is-active .hamburger-inner::before {
    transform: rotate(45deg) translate3d(5.71429px, -6px, 0);
    opacity: 0;
  }
  .hamburger--slider-r.is-active .hamburger-inner::after {
    transform: translate3d(0, -20px, 0) rotate(90deg);
  }

  /*
   * Spin
   */
  .hamburger--spin .hamburger-inner {
    transition-duration: 0.22s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--spin .hamburger-inner::before {
    transition: top 0.1s 0.25s ease-in, opacity 0.1s ease-in;
  }
  .hamburger--spin .hamburger-inner::after {
    transition: bottom 0.1s 0.25s ease-in, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--spin.is-active .hamburger-inner {
    transform: rotate(225deg);
    transition-delay: 0.12s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .hamburger--spin.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
    transition: top 0.1s ease-out, opacity 0.1s 0.12s ease-out;
  }
  .hamburger--spin.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(-90deg);
    transition: bottom 0.1s ease-out, transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /*
   * Spin Reverse
   */
  .hamburger--spin-r .hamburger-inner {
    transition-duration: 0.22s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--spin-r .hamburger-inner::before {
    transition: top 0.1s 0.25s ease-in, opacity 0.1s ease-in;
  }
  .hamburger--spin-r .hamburger-inner::after {
    transition: bottom 0.1s 0.25s ease-in, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--spin-r.is-active .hamburger-inner {
    transform: rotate(-225deg);
    transition-delay: 0.12s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .hamburger--spin-r.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
    transition: top 0.1s ease-out, opacity 0.1s 0.12s ease-out;
  }
  .hamburger--spin-r.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(90deg);
    transition: bottom 0.1s ease-out, transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /*
   * Spring
   */
  .hamburger--spring .hamburger-inner {
    top: 2px;
    transition: background-color 0s 0.13s linear;
  }
  .hamburger--spring .hamburger-inner::before {
    top: 10px;
    transition: top 0.1s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
      transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--spring .hamburger-inner::after {
    top: 20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
      transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--spring.is-active .hamburger-inner {
    transition-delay: 0.22s;
    background-color: transparent !important;
  }
  .hamburger--spring.is-active .hamburger-inner::before {
    top: 0;
    transition: top 0.1s 0.15s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
      transform 0.13s 0.22s cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  .hamburger--spring.is-active .hamburger-inner::after {
    top: 0;
    transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
      transform 0.13s 0.22s cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 10px, 0) rotate(-45deg);
  }

  /*
   * Spring Reverse
   */
  .hamburger--spring-r .hamburger-inner {
    top: auto;
    bottom: 0;
    transition-duration: 0.13s;
    transition-delay: 0s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--spring-r .hamburger-inner::after {
    top: -20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0s linear;
  }
  .hamburger--spring-r .hamburger-inner::before {
    transition: top 0.1s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
      transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--spring-r.is-active .hamburger-inner {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
    transition-delay: 0.22s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .hamburger--spring-r.is-active .hamburger-inner::after {
    top: 0;
    opacity: 0;
    transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0s 0.22s linear;
  }
  .hamburger--spring-r.is-active .hamburger-inner::before {
    top: 0;
    transform: rotate(90deg);
    transition: top 0.1s 0.15s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
      transform 0.13s 0.22s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /*
   * Stand
   */
  .hamburger--stand .hamburger-inner {
    transition: transform 0.075s 0.15s cubic-bezier(0.55, 0.055, 0.675, 0.19), background-color 0s 0.075s linear;
  }
  .hamburger--stand .hamburger-inner::before {
    transition: top 0.075s 0.075s ease-in, transform 0.075s 0s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--stand .hamburger-inner::after {
    transition: bottom 0.075s 0.075s ease-in, transform 0.075s 0s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--stand.is-active .hamburger-inner {
    transform: rotate(90deg);
    background-color: transparent !important;
    transition: transform 0.075s 0s cubic-bezier(0.215, 0.61, 0.355, 1), background-color 0s 0.15s linear;
  }
  .hamburger--stand.is-active .hamburger-inner::before {
    top: 0;
    transform: rotate(-45deg);
    transition: top 0.075s 0.1s ease-out, transform 0.075s 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .hamburger--stand.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(45deg);
    transition: bottom 0.075s 0.1s ease-out, transform 0.075s 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /*
   * Stand Reverse
   */
  .hamburger--stand-r .hamburger-inner {
    transition: transform 0.075s 0.15s cubic-bezier(0.55, 0.055, 0.675, 0.19), background-color 0s 0.075s linear;
  }
  .hamburger--stand-r .hamburger-inner::before {
    transition: top 0.075s 0.075s ease-in, transform 0.075s 0s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--stand-r .hamburger-inner::after {
    transition: bottom 0.075s 0.075s ease-in, transform 0.075s 0s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--stand-r.is-active .hamburger-inner {
    transform: rotate(-90deg);
    background-color: transparent !important;
    transition: transform 0.075s 0s cubic-bezier(0.215, 0.61, 0.355, 1), background-color 0s 0.15s linear;
  }
  .hamburger--stand-r.is-active .hamburger-inner::before {
    top: 0;
    transform: rotate(-45deg);
    transition: top 0.075s 0.1s ease-out, transform 0.075s 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .hamburger--stand-r.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(45deg);
    transition: bottom 0.075s 0.1s ease-out, transform 0.075s 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /*
   * Squeeze
   */
  .hamburger--squeeze .hamburger-inner {
    transition-duration: 0.075s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  .hamburger--squeeze .hamburger-inner::before {
    transition: top 0.075s 0.12s ease, opacity 0.075s ease;
  }
  .hamburger--squeeze .hamburger-inner::after {
    transition: bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  .hamburger--squeeze.is-active .hamburger-inner {
    transform: rotate(45deg);
    transition-delay: 0.12s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .hamburger--squeeze.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
    transition: top 0.075s ease, opacity 0.075s 0.12s ease;
  }
  .hamburger--squeeze.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(-90deg);
    transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /*
   * Vortex
   */
  .hamburger--vortex .hamburger-inner {
    transition-duration: 0.2s;
    transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
  }
  .hamburger--vortex .hamburger-inner::before,
  .hamburger--vortex .hamburger-inner::after {
    transition-duration: 0s;
    transition-delay: 0.1s;
    transition-timing-function: linear;
  }
  .hamburger--vortex .hamburger-inner::before {
    transition-property: top, opacity;
  }
  .hamburger--vortex .hamburger-inner::after {
    transition-property: bottom, transform;
  }

  .hamburger--vortex.is-active .hamburger-inner {
    transform: rotate(765deg);
    transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
  }
  .hamburger--vortex.is-active .hamburger-inner::before,
  .hamburger--vortex.is-active .hamburger-inner::after {
    transition-delay: 0s;
  }
  .hamburger--vortex.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
  }
  .hamburger--vortex.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(90deg);
  }

  /*
   * Vortex Reverse
   */
  .hamburger--vortex-r .hamburger-inner {
    transition-duration: 0.2s;
    transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
  }
  .hamburger--vortex-r .hamburger-inner::before,
  .hamburger--vortex-r .hamburger-inner::after {
    transition-duration: 0s;
    transition-delay: 0.1s;
    transition-timing-function: linear;
  }
  .hamburger--vortex-r .hamburger-inner::before {
    transition-property: top, opacity;
  }
  .hamburger--vortex-r .hamburger-inner::after {
    transition-property: bottom, transform;
  }

  .hamburger--vortex-r.is-active .hamburger-inner {
    transform: rotate(-765deg);
    transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
  }
  .hamburger--vortex-r.is-active .hamburger-inner::before,
  .hamburger--vortex-r.is-active .hamburger-inner::after {
    transition-delay: 0s;
  }
  .hamburger--vortex-r.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
  }
  .hamburger--vortex-r.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(-90deg);
  }
`;

});


parcelRegister("ktE4W", function(module, exports) {

$parcel$export(module.exports, "IconComponent", () => $40d81590c8603f04$export$f508444e7933c2b1);

var $deWeK = parcelRequire("deWeK");
parcelRequire("8HCK1");
parcelRequire("eUnHz");
parcelRequire("8nByP");

var $4TeKW = parcelRequire("4TeKW");
class $40d81590c8603f04$export$f508444e7933c2b1 extends (0, $4TeKW.LitElement) {
    OnUpdate() {
        const [icon] = this.iconSlot.assignedNodes();
        this.icon = icon?.nodeValue ?? this.icon;
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $40d81590c8603f04$export$f508444e7933c2b1.prototype, "icon", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.query)('slot')
], $40d81590c8603f04$export$f508444e7933c2b1.prototype, "iconSlot", void 0);
$40d81590c8603f04$export$f508444e7933c2b1 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'rx-icon',
        template () {
            return (0, $4TeKW.html)`
      <vaadin-icon .icon=${this.icon}>
        <slot></slot>
      </vaadin-icon>
    `;
        }
    })
], $40d81590c8603f04$export$f508444e7933c2b1);

});
parcelRegister("8HCK1", function(module, exports) {
parcelRequire("dW1hQ");
parcelRequire("dNadP");
parcelRequire("b4dHi");

});
parcelRegister("dW1hQ", function(module, exports) {
parcelRequire("eeElu");
parcelRequire("b4dHi");

});
parcelRegister("eeElu", function(module, exports) {
parcelRequire("6Yt1B");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
(0, $2vXFS.registerStyles)('vaadin-icon', (0, $aOvNQ.css)`
    :host {
      width: var(--lumo-icon-size-m);
      height: var(--lumo-icon-size-m);
    }
  `, {
    moduleId: 'lumo-icon'
});

});

parcelRegister("b4dHi", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $bthO9 = parcelRequire("bthO9");

var $9Q7uu = parcelRequire("9Q7uu");

var $6hU3M = parcelRequire("6hU3M");

var $2vXFS = parcelRequire("2vXFS");

var $dNadP = parcelRequire("dNadP");

var $aQbUy = parcelRequire("aQbUy");
const $80eab16a16a89128$var$DEFAULT_ICONSET = 'vaadin';
/**
 * `<vaadin-icon>` is a Web Component for displaying SVG icons.
 *
 * ### Icon property
 *
 * The `<vaadin-icon>` component is designed to be used as a drop-in replacement for `<iron-icon>`.
 * For example, you can use it with `vaadin-icons` like this:
 *
 * ```html
 * <vaadin-icon icon="vaadin:angle-down"></vaadin-icon>
 * ```
 *
 * Alternatively, you can also pick one of the Lumo icons:
 *
 * ```html
 * <vaadin-icon icon="lumo:user"></vaadin-icon>
 * ```
 *
 * ### Custom SVG icon
 *
 * Alternatively, instead of selecting an icon from an iconset by name, you can pass any custom `svg`
 * literal using the [`svg`](#/elements/vaadin-icon#property-svg) property. In this case you can also
 * define the size of the SVG `viewBox` using the [`size`](#/elements/vaadin-icon#property-size) property:
 *
 * ```js
 * import { html, svg } from 'lit';
 *
 * // in your component
 * render() {
 *   const svgIcon = svg`<path d="M13 4v2l-5 5-5-5v-2l5 5z"></path>`;
 *   return html`
 *     <vaadin-icon
 *       .svg="${svgIcon}"
 *       size="16"
 *     ></vaadin-icon>
 *   `;
 * }
 * ```
 *
 * @extends HTMLElement
 * @mixes ControllerMixin
 * @mixes ThemableMixin
 * @mixes ElementMixin
 */ class $80eab16a16a89128$export$f04a61298a47a40f extends (0, $2vXFS.ThemableMixin)((0, $9Q7uu.ElementMixin)((0, $bthO9.ControllerMixin)((0, $5QhZ5.PolymerElement)))) {
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          vertical-align: middle;
          width: 24px;
          height: 24px;
          fill: currentColor;
        }

        :host([hidden]) {
          display: none !important;
        }

        svg {
          display: block;
          width: 100%;
          height: 100%;
        }
      </style>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="[[__computeViewBox(size, __viewBox)]]"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden="true"
      ></svg>

      <slot name="tooltip"></slot>
    `;
    }
    static get is() {
        return 'vaadin-icon';
    }
    static get properties() {
        return {
            /**
       * The name of the icon to use. The name should be of the form:
       * `iconset_name:icon_name`. When using `vaadin-icons` it is possible
       * to omit the first part and only use `icon_name` as a value.
       *
       * Setting the `icon` property updates the `svg` and `size` based on the
       * values provided by the corresponding `vaadin-iconset` element.
       *
       * See also [`name`](#/elements/vaadin-iconset#property-name) property of `vaadin-iconset`.
       */ icon: {
                type: String,
                observer: '__iconChanged'
            },
            /**
       * The SVG icon wrapped in a Lit template literal.
       */ svg: {
                type: Object
            },
            /**
       * The size of an icon, used to set the `viewBox` attribute.
       */ size: {
                type: Number,
                value: 24
            },
            /** @private */ __svgElement: Object,
            /** @private */ __viewBox: String
        };
    }
    static get observers() {
        return [
            '__svgChanged(svg, __svgElement)'
        ];
    }
    constructor(){
        super();
        this.__onIconsetRegistered = this.__onIconsetRegistered.bind(this);
    }
    /** @protected */ ready() {
        super.ready();
        this.__svgElement = this.shadowRoot.querySelector('svg');
        this._tooltipController = new (0, $6hU3M.TooltipController)(this);
        this.addController(this._tooltipController);
    }
    /** @private */ __getIconsetName(icon) {
        if (!icon) return;
        const parts = icon.split(':');
        return parts[0] || $80eab16a16a89128$var$DEFAULT_ICONSET;
    }
    /** @private */ __onIconsetRegistered(e) {
        if (e.detail === this.__getIconsetName(this.icon)) this.__iconChanged(this.icon);
    }
    /** @protected */ connectedCallback() {
        super.connectedCallback();
        document.addEventListener('vaadin-iconset-registered', this.__onIconsetRegistered);
    }
    /** @protected */ disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('vaadin-iconset-registered', this.__onIconsetRegistered);
    }
    /** @private */ __iconChanged(icon) {
        if (icon) {
            this.__checkDeprecatedIcon(icon);
            const iconsetName = this.__getIconsetName(icon);
            const iconset = (0, $aQbUy.Iconset).getIconset(iconsetName);
            const { svg: svg, size: size, viewBox: viewBox } = iconset.applyIcon(icon);
            if (viewBox) this.__viewBox = viewBox;
            if (size !== this.size) this.size = size;
            this.svg = svg;
        } else this.svg = (0, $dNadP.ensureSvgLiteral)(null);
    }
    /** @private */ __checkDeprecatedIcon(icon) {
        const deprecatedIcons = {
            'vaadin:buss': 'vaadin:bus',
            'vaadin:funcion': 'vaadin:function',
            'vaadin:megafone': 'vaadin:megaphone',
            'vaadin:palete': 'vaadin:palette',
            'vaadin:trendind-down': 'vaadin:trending-down'
        };
        if (icon in deprecatedIcons) console.warn(`WARNING: The icon "${icon}" is deprecated. Use "${deprecatedIcons[icon]}" instead`);
    }
    /** @private */ __svgChanged(svg, svgElement) {
        if (!svgElement) return;
        (0, $dNadP.renderSvg)(svg, svgElement);
    }
    /** @private */ __computeViewBox(size, viewBox) {
        return viewBox || `0 0 ${size} ${size}`;
    }
}
customElements.define($80eab16a16a89128$export$f04a61298a47a40f.is, $80eab16a16a89128$export$f04a61298a47a40f);

});
parcelRegister("dNadP", function(module, exports) {

$parcel$export(module.exports, "cloneSvgNode", () => $a0a7c7de1a9a365f$export$840b3afc02e0c88d);
$parcel$export(module.exports, "ensureSvgLiteral", () => $a0a7c7de1a9a365f$export$ce5001734d992ada);
$parcel$export(module.exports, "renderSvg", () => $a0a7c7de1a9a365f$export$fb80b1b7d7777ee5);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("eQwuB");
var $625KE = parcelRequire("625KE");
parcelRequire("aaKdM");
var $87Nuv = parcelRequire("87Nuv");
parcelRequire("N0oUd");
var $dqRl6 = parcelRequire("dqRl6");
function $a0a7c7de1a9a365f$export$840b3afc02e0c88d(source) {
    let result = (0, $625KE.nothing);
    if (source) {
        const content = source.cloneNode(true);
        content.removeAttribute('id');
        result = (0, $625KE.svg)`${(0, $dqRl6.unsafeSVG)(content.outerHTML)}`;
    }
    return result;
}
function $a0a7c7de1a9a365f$export$d673a9445babfbef(source) {
    return (0, $87Nuv.isTemplateResult)(source, (0, $87Nuv.TemplateResultType).SVG) || source === (0, $625KE.nothing);
}
function $a0a7c7de1a9a365f$export$ce5001734d992ada(source) {
    let result = source == null || source === '' ? (0, $625KE.nothing) : source;
    if (!$a0a7c7de1a9a365f$export$d673a9445babfbef(result)) {
        console.error('[vaadin-icon] Invalid svg passed, please use Lit svg literal.');
        result = (0, $625KE.nothing);
    }
    return result;
}
function $a0a7c7de1a9a365f$export$fb80b1b7d7777ee5(source, container) {
    const result = $a0a7c7de1a9a365f$export$ce5001734d992ada(source);
    (0, $625KE.render)(result, container);
}
function $a0a7c7de1a9a365f$export$31dc807d6b05f94c(source) {
    return (0, $625KE.svg)`${(0, $dqRl6.unsafeSVG)(source)}`;
}

});
parcelRegister("aaKdM", function(module, exports) {
$parcel$export(module.exports, "isTemplateResult", () => (parcelRequire("87Nuv")).isTemplateResult);
$parcel$export(module.exports, "TemplateResultType", () => (parcelRequire("87Nuv")).TemplateResultType);
parcelRequire("87Nuv");

});
parcelRegister("87Nuv", function(module, exports) {

$parcel$export(module.exports, "TemplateResultType", () => $5ea55e0ef13d8dcd$export$80c36ae3cab9881d);
$parcel$export(module.exports, "isTemplateResult", () => $5ea55e0ef13d8dcd$export$6b6d145ec2a44ca9);

var $625KE = parcelRequire("625KE");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $5ea55e0ef13d8dcd$var$l } = (0, $625KE._$LH), $5ea55e0ef13d8dcd$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $5ea55e0ef13d8dcd$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $5ea55e0ef13d8dcd$export$6b6d145ec2a44ca9 = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, $5ea55e0ef13d8dcd$export$2f448fec17d50a3e = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), $5ea55e0ef13d8dcd$export$f28e31de6a6eaf32 = (o)=>null == o ? void 0 : o._$litDirective$, $5ea55e0ef13d8dcd$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $5ea55e0ef13d8dcd$var$c = ()=>document.createComment(""), $5ea55e0ef13d8dcd$export$291b2338ad9b0b30 = (o, t, i)=>{
    var n;
    const d = o._$AA.parentNode, v = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = d.insertBefore($5ea55e0ef13d8dcd$var$c(), v), n = d.insertBefore($5ea55e0ef13d8dcd$var$c(), v);
        i = new $5ea55e0ef13d8dcd$var$l(t, n, o, o.options);
    } else {
        const l = i._$AB.nextSibling, t = i._$AM, e = t !== o;
        if (e) {
            let l;
            null === (n = i._$AQ) || void 0 === n || n.call(i, o), i._$AM = o, void 0 !== i._$AP && (l = o._$AU) !== t._$AU && i._$AP(l);
        }
        if (l !== v || e) {
            let o = i._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                d.insertBefore(o, v), o = l;
            }
        }
    }
    return i;
}, $5ea55e0ef13d8dcd$export$cb8bf9562088e9f4 = (o, l, t = o)=>(o._$AI(l, t), o), $5ea55e0ef13d8dcd$var$f = {}, $5ea55e0ef13d8dcd$export$ea70d9dd5965b1c8 = (o, l = $5ea55e0ef13d8dcd$var$f)=>o._$AH = l, $5ea55e0ef13d8dcd$export$59e9bce518cde500 = (o)=>o._$AH, $5ea55e0ef13d8dcd$export$3133b3144bbba267 = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $5ea55e0ef13d8dcd$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});


parcelRegister("N0oUd", function(module, exports) {
$parcel$export(module.exports, "unsafeSVG", () => (parcelRequire("dqRl6")).unsafeSVG);
parcelRequire("dqRl6");

});
parcelRegister("dqRl6", function(module, exports) {

$parcel$export(module.exports, "unsafeSVG", () => $9c771424abb72590$export$1cb98903879b8bf5);

var $15lp0 = parcelRequire("15lp0");

var $9T0pC = parcelRequire("9T0pC");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $9c771424abb72590$var$t extends (0, $9T0pC.UnsafeHTMLDirective) {
}
$9c771424abb72590$var$t.directiveName = "unsafeSVG", $9c771424abb72590$var$t.resultType = 2;
const $9c771424abb72590$export$1cb98903879b8bf5 = (0, $15lp0.directive)($9c771424abb72590$var$t);

});
parcelRegister("15lp0", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $0ca6dc26373667a1$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $0ca6dc26373667a1$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $0ca6dc26373667a1$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0ca6dc26373667a1$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $0ca6dc26373667a1$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $0ca6dc26373667a1$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});

parcelRegister("9T0pC", function(module, exports) {

$parcel$export(module.exports, "UnsafeHTMLDirective", () => $732991fd40a56f2d$export$3bebd1f0e3943985);

var $625KE = parcelRequire("625KE");

var $15lp0 = parcelRequire("15lp0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $732991fd40a56f2d$export$3bebd1f0e3943985 extends (0, $15lp0.Directive) {
    constructor(i){
        if (super(i), this.it = (0, $625KE.nothing), i.type !== (0, $15lp0.PartType).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $625KE.nothing) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $625KE.noChange)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$732991fd40a56f2d$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $732991fd40a56f2d$export$3bebd1f0e3943985.resultType = 1;
const $732991fd40a56f2d$export$b6e69390c23686fb = (0, $15lp0.directive)($732991fd40a56f2d$export$3bebd1f0e3943985);

});




parcelRegister("aQbUy", function(module, exports) {

$parcel$export(module.exports, "Iconset", () => $7e480005320c6184$export$b498583ee10b6200);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $5QhZ5 = parcelRequire("5QhZ5");

var $9Q7uu = parcelRequire("9Q7uu");

var $dNadP = parcelRequire("dNadP");
const $7e480005320c6184$var$iconRegistry = {};
/**
 * `<vaadin-iconset>` is a Web Component for creating SVG icon collections.
 *
 * @extends HTMLElement
 * @mixes ElementMixin
 */ class $7e480005320c6184$export$b498583ee10b6200 extends (0, $9Q7uu.ElementMixin)((0, $5QhZ5.PolymerElement)) {
    static get template() {
        return null;
    }
    static get is() {
        return 'vaadin-iconset';
    }
    static get properties() {
        return {
            /**
       * The name of the iconset. Every iconset is required to have its own unique name.
       * All the SVG icons in the iconset must have IDs conforming to its name.
       *
       * See also [`name`](#/elements/vaadin-icon#property-name) property of `vaadin-icon`.
       */ name: {
                type: String,
                observer: '__nameChanged'
            },
            /**
       * The size of an individual icon. Note that icons must be square.
       *
       * When using `vaadin-icon`, the size of the iconset will take precedence
       * over the size defined by the user to ensure correct appearance.
       */ size: {
                type: Number,
                value: 24
            }
        };
    }
    /**
   * Create an instance of the iconset.
   *
   * @param {string} name
   */ static getIconset(name) {
        let iconset = $7e480005320c6184$var$iconRegistry[name];
        if (!iconset) {
            iconset = document.createElement('vaadin-iconset');
            iconset.name = name;
            $7e480005320c6184$var$iconRegistry[name] = iconset;
        }
        return iconset;
    }
    /** @protected */ connectedCallback() {
        super.connectedCallback();
        this.style.display = 'none';
    }
    /**
   * Produce SVGTemplateResult for the element matching `name` in this
   * iconset, or `undefined` if there is no matching element.
   *
   * @param {string} name
   */ applyIcon(name) {
        // Create the icon map on-demand, since the iconset itself has no discrete
        // signal to know when it's children are fully parsed
        this._icons = this._icons || this.__createIconMap();
        const icon = this._icons[this.__getIconId(name)];
        return {
            svg: (0, $dNadP.cloneSvgNode)(icon),
            size: this.size,
            viewBox: icon ? icon.getAttribute('viewBox') : null
        };
    }
    /**
   * Create a map of child SVG elements by id.
   */ __createIconMap() {
        const icons = {};
        this.querySelectorAll('[id]').forEach((icon)=>{
            icons[this.__getIconId(icon.id)] = icon;
        });
        return icons;
    }
    /** @private */ __getIconId(id) {
        return (id || '').replace(`${this.name}:`, '');
    }
    /** @private */ __nameChanged(name, oldName) {
        if (oldName) {
            $7e480005320c6184$var$iconRegistry[name] = $7e480005320c6184$export$b498583ee10b6200.getIconset(oldName);
            delete $7e480005320c6184$var$iconRegistry[oldName];
        }
        if (name) {
            $7e480005320c6184$var$iconRegistry[name] = this;
            document.dispatchEvent(new CustomEvent('vaadin-iconset-registered', {
                detail: name
            }));
        }
    }
}
customElements.define($7e480005320c6184$export$b498583ee10b6200.is, $7e480005320c6184$export$b498583ee10b6200);

});




parcelRegister("eUnHz", function(module, exports) {
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("5Gsvk");
parcelRequire("pFadI");
const $ada8ae54ac9e10f2$var$template = document.createElement('template');
$ada8ae54ac9e10f2$var$template.innerHTML = `<vaadin-iconset name="lumo" size="1000">
<svg xmlns="http://www.w3.org/2000/svg">
<defs>
<g id="lumo:align-center"><path d="M167 217c0-18 17-33 38-34H795c21 0 38 15 38 34 0 18-17 33-38 33H205C184 250 167 235 167 217z m83 191c0-18 13-33 29-33H721c16 0 29 15 29 33 0 18-13 33-29 34H279C263 442 250 427 250 408zM250 792c0-18 13-33 29-34H721c16 0 29 15 29 34s-13 33-29 33H279C263 825 250 810 250 792z m-83-192c0-18 17-33 38-33H795c21 0 38 15 38 33s-17 33-38 33H205C184 633 167 618 167 600z" fill-rule="evenodd" clip-rule="evenodd"></path></g>
<g id="lumo:align-left"><path d="M167 217c0-18 17-33 38-34H795c21 0 38 15 38 34 0 18-17 33-38 33H205C184 250 167 235 167 217z m0 191c0-18 13-33 28-33H638c16 0 29 15 29 33 0 18-13 33-29 34H195C179 442 167 427 167 408zM167 792c0-18 13-33 28-34H638c16 0 29 15 29 34s-13 33-29 33H195C179 825 167 810 167 792z m0-192c0-18 17-33 38-33H795c21 0 38 15 38 33s-17 33-38 33H205C184 633 167 618 167 600z" fill-rule="evenodd" clip-rule="evenodd"></path></g>
<g id="lumo:align-right"><path d="M167 217c0-18 17-33 38-34H795c21 0 38 15 38 34 0 18-17 33-38 33H205C184 250 167 235 167 217z m166 191c0-18 13-33 29-33H805c16 0 29 15 28 33 0 18-13 33-28 34H362C346 442 333 427 333 408zM333 792c0-18 13-33 29-34H805c16 0 29 15 28 34s-13 33-28 33H362C346 825 333 810 333 792z m-166-192c0-18 17-33 38-33H795c21 0 38 15 38 33s-17 33-38 33H205C184 633 167 618 167 600z" fill-rule="evenodd" clip-rule="evenodd"></path></g>
<g id="lumo:angle-down"><path d="M283 391c-18-16-46-15-63 4-16 18-15 46 3 63l244 224c17 15 43 15 60 0l250-229c18-16 20-45 3-63-16-18-45-20-63-4l-220 203-214-198z"></path></g>
<g id="lumo:angle-left"><path d="M601 710c16 18 15 46-3 63-18 16-46 15-63-4l-224-244c-15-17-15-43 0-59l229-250c16-18 45-20 63-4 18 16 20 45 3 63l-203 220 198 215z"></path></g>
<g id="lumo:angle-right"><path d="M399 275c-16-18-15-46 3-63 18-16 46-15 63 4l224 244c15 17 15 43 0 59l-229 250c-16 18-45 20-63 4-18-16-20-45-3-63l203-220-198-215z"></path></g>
<g id="lumo:angle-up"><path d="M283 635c-18 16-46 15-63-3-16-18-15-46 3-63l244-224c17-15 43-15 60 0l250 229c18 16 20 45 3 63-16 18-45 20-63 3l-220-202L283 635z"></path></g>
<g id="lumo:arrow-down"><path d="M538 646l125-112c15-14 39-12 53 4 14 15 12 39-4 53l-187 166c0 0 0 0 0 0-14 13-36 12-50 0l-187-166c-15-14-17-37-4-53 14-15 37-17 53-4L462 646V312c0-21 17-38 38-37s38 17 37 37v334z"></path></g>
<g id="lumo:arrow-left"><path d="M375 538l111 125c14 15 12 39-3 53-15 14-39 12-53-4l-166-187c0 0 0 0 0 0-13-14-12-36 0-50l166-187c14-15 37-17 53-4 15 14 17 37 3 53L375 463h333c21 0 38 17 38 37 0 21-17 38-38 38h-333z"></path></g>
<g id="lumo:arrow-right"><path d="M625 538h-333c-21 0-38-17-38-38 0-21 17-38 38-37h333l-111-126c-14-15-12-39 3-53 15-14 39-12 53 4l166 187c13 14 13 36 0 50 0 0 0 0 0 0l-166 187c-14 15-37 17-53 4-15-14-17-37-3-53l111-125z"></path></g>
<g id="lumo:arrow-up"><path d="M538 354V688c0 21-17 38-38 37s-38-17-38-38V354l-125 112c-15 14-39 12-53-4-14-15-12-39 4-53l187-166c14-13 36-13 50 0 0 0 0 0 0 0l187 166c15 14 17 37 4 53-14 15-37 17-53 4L538 354z"></path></g>
<g id="lumo:bar-chart"><path d="M175 500h108c28 0 50 22 50 50v233c0 28-22 50-50 50H175c-28 0-50-22-50-50v-233c0-28 22-50 50-50z m33 67c-9 0-17 7-16 16v167c0 9 7 17 16 17h42c9 0 17-7 17-17v-167c0-9-7-17-17-16H208zM446 167h108c28 0 50 22 50 50v566c0 28-22 50-50 50h-108c-28 0-50-22-50-50V217c0-28 22-50 50-50z m33 66c-9 0-17 7-17 17v500c0 9 7 17 17 17h42c9 0 17-7 16-17V250c0-9-7-17-16-17h-42zM717 333h108c28 0 50 22 50 50v400c0 28-22 50-50 50h-108c-28 0-50-22-50-50V383c0-28 22-50 50-50z m33 67c-9 0-17 7-17 17v333c0 9 7 17 17 17h42c9 0 17-7 16-17v-333c0-9-7-17-16-17h-42z"></path></g>
<g id="lumo:bell"><path d="M367 675H292v-258C292 325 366 250 459 250H458V208c0-23 18-42 42-41 23 0 42 18 42 41v42h-1C634 250 708 325 708 417V675h-75v-258c0-51-41-92-91-92h-84C408 325 367 366 367 417V675z m-159 37c0-21 17-38 38-37h508c21 0 37 17 38 37 0 21-17 38-38 38H246C225 750 208 733 208 713z m230 71h125v32c0 17-14 31-32 31h-62c-17 0-32-14-31-31v-32z"></path></g>
<g id="lumo:calendar"><path d="M375 208h250v-20C625 176 634 167 646 167h41C699 167 708 176 708 188V208h74c23 0 41 19 41 42v42C823 315 804 333 782 333H218C196 333 177 315 177 292V250C177 227 196 208 218 208H292v-20C292 176 301 167 313 167h41C366 167 375 176 375 188V208zM229 375h42C283 375 292 384 292 396v41C292 449 282 458 271 458h-42C217 458 208 449 208 437v-41C208 384 218 375 229 375z m125 0h42C408 375 417 384 417 396v41C417 449 407 458 396 458h-42C342 458 333 449 333 437v-41C333 384 343 375 354 375z m125 0h42C533 375 542 384 542 396v41C542 449 532 458 521 458h-42C467 458 458 449 458 437v-41C458 384 468 375 479 375z m-250 125h42C283 500 292 509 292 521v41C292 574 282 583 271 583h-42C217 583 208 574 208 562v-41C208 509 218 500 229 500z m125 0h42C408 500 417 509 417 521v41C417 574 407 583 396 583h-42C342 583 333 574 333 562v-41C333 509 343 500 354 500z m125 0h42c12 0 21 9 21 21v41C542 574 532 583 521 583h-42C467 583 458 574 458 562v-41C458 509 468 500 479 500z m-250 125h42C283 625 292 634 292 646v41C292 699 282 708 271 708h-42C217 708 208 699 208 687v-41C208 634 218 625 229 625z m125 0h42C408 625 417 634 417 646v41C417 699 407 708 396 708h-42C342 708 333 699 333 687v-41C333 634 343 625 354 625z m125 0h42c12 0 21 9 21 21v41C542 699 532 708 521 708h-42C467 708 458 699 458 687v-41C458 634 468 625 479 625z m125-250h42C658 375 667 384 667 396v41C667 449 657 458 646 458h-42C592 458 583 449 583 437v-41C583 384 593 375 604 375z m0 125h42c12 0 21 9 21 21v41C667 574 657 583 646 583h-42C592 583 583 574 583 562v-41C583 509 593 500 604 500z m0 125h42c12 0 21 9 21 21v41C667 699 657 708 646 708h-42C592 708 583 699 583 687v-41C583 634 593 625 604 625z m125 0h42c12 0 21 9 21 21v41C792 699 782 708 771 708h-42C717 708 708 699 708 687v-41C708 634 718 625 729 625z m-500 125h42C283 750 292 759 292 771v41C292 824 282 833 271 833h-42C217 833 208 824 208 812v-41C208 759 218 750 229 750z m125 0h42C408 750 417 759 417 771v41C417 824 407 833 396 833h-42C342 833 333 824 333 812v-41C333 759 343 750 354 750z m125 0h42c12 0 21 9 21 21v41C542 824 532 833 521 833h-42C467 833 458 824 458 812v-41C458 759 468 750 479 750z m125 0h42c12 0 21 9 21 21v41C667 824 657 833 646 833h-42C592 833 583 824 583 812v-41C583 759 593 750 604 750z m125 0h42c12 0 21 9 21 21v41C792 824 782 833 771 833h-42C717 833 708 824 708 812v-41C708 759 718 750 729 750z m0-250h42c12 0 21 9 21 21v41C792 574 782 583 771 583h-42C717 583 708 574 708 562v-41C708 509 718 500 729 500z m0-125h42C783 375 792 384 792 396v41C792 449 782 458 771 458h-42C717 458 708 449 708 437v-41C708 384 718 375 729 375z"></path></g>
<g id="lumo:checkmark"><path d="M318 493c-15-15-38-15-53 0-15 15-15 38 0 53l136 136c15 15 38 15 53 0l323-322c15-15 15-38 0-53-15-15-38-15-54 0l-295 296-110-110z"></path></g>
<g id="lumo:chevron-down"><path d="M533 654l210-199c9-9 9-23 0-32C739 419 733 417 726 417H274C261 417 250 427 250 439c0 6 2 12 7 16l210 199c18 17 48 17 66 0z"></path></g>
<g id="lumo:chevron-left"><path d="M346 533l199 210c9 9 23 9 32 0 4-4 7-10 6-17V274C583 261 573 250 561 250c-6 0-12 2-16 7l-199 210c-17 18-17 48 0 66z"></path></g>
<g id="lumo:chevron-right"><path d="M654 533L455 743c-9 9-23 9-32 0C419 739 417 733 417 726V274C417 261 427 250 439 250c6 0 12 2 16 7l199 210c17 18 17 48 0 66z"></path></g>
<g id="lumo:chevron-up"><path d="M533 346l210 199c9 9 9 23 0 32-4 4-10 7-17 6H274C261 583 250 573 250 561c0-6 2-12 7-16l210-199c18-17 48-17 66 0z"></path></g>
<g id="lumo:clock"><path d="M538 489l85 85c15 15 15 38 0 53-15 15-38 15-53 0l-93-93a38 38 0 0 1-2-2C467 525 462 515 462 504V308c0-21 17-38 38-37 21 0 38 17 37 37v181zM500 833c-184 0-333-149-333-333s149-333 333-333 333 149 333 333-149 333-333 333z m0-68c146 0 265-118 265-265 0-146-118-265-265-265-146 0-265 118-265 265 0 146 118 265 265 265z"></path></g>
<g id="lumo:cog"><path d="M833 458l-81-18c-8-25-17-50-29-75L767 292 708 233l-72 49c-21-12-46-25-75-30L542 167h-84l-19 79c-25 8-50 17-71 30L296 233 233 296l47 69c-12 21-21 46-29 71L167 458v84l84 25c8 25 17 50 29 75L233 708 292 767l76-44c21 12 46 25 75 29L458 833h84l19-81c25-8 50-17 75-29L708 767l59-59-44-66c12-21 25-46 29-75L833 542v-84z m-333 217c-96 0-175-79-175-175 0-96 79-175 175-175 96 0 175 79 175 175 0 96-79 175-175 175z"></path></g>
<g id="lumo:cross"><path d="M445 500l-142-141c-15-15-15-40 0-56 15-15 40-15 56 0L500 445l141-142c15-15 40-15 56 0 15 15 15 40 0 56L555 500l142 141c15 15 15 40 0 56-15 15-40 15-56 0L500 555l-141 142c-15 15-40 15-56 0-15-15-15-40 0-56L445 500z"></path></g>
<g id="lumo:download"><path d="M538 521l125-112c15-14 39-12 53 4 14 15 12 39-4 53l-187 166a38 38 0 0 1 0 0c-14 13-36 12-50 0l-187-166c-15-14-17-37-4-53 14-15 37-17 53-4L462 521V188c0-21 17-38 38-38s38 17 37 38v333zM758 704c0-21 17-38 38-37 21 0 38 17 37 37v92c0 21-17 38-37 37H204c-21 0-38-17-37-37v-92c0-21 17-38 37-37s38 17 38 37v54h516v-54z"></path></g>
<g id="lumo:dropdown"><path d="M317 393c-15-14-39-13-53 3-14 15-13 39 3 53l206 189c14 13 36 13 50 0l210-193c15-14 17-38 3-53-14-15-38-17-53-3l-185 171L317 393z"></path></g>
<g id="lumo:edit"><path d="M673 281l62 56-205 233c-9 10-38 24-85 39a8 8 0 0 1-5 0c-4-1-7-6-6-10l0 0c14-47 25-76 35-86l204-232z m37-42l52-59c15-17 41-18 58-2 17 16 18 42 3 59L772 295l-62-56zM626 208l-67 75h-226C305 283 283 306 283 333v334C283 695 306 717 333 717h334c28 0 50-22 50-50v-185L792 398v269C792 736 736 792 667 792H333C264 792 208 736 208 667V333C208 264 264 208 333 208h293z"></path></g>
<g id="lumo:error"><path d="M500 833c-184 0-333-149-333-333s149-333 333-333 333 149 333 333-149 333-333 333z m0-68c146 0 265-118 265-265 0-146-118-265-265-265-146 0-265 118-265 265 0 146 118 265 265 265zM479 292h42c12 0 21 9 20 20l-11 217c0 8-6 13-13 13h-34c-7 0-13-6-13-13l-11-217C459 301 468 292 479 292zM483 608h34c12 0 21 9 20 21v33c0 12-9 21-20 21h-34c-12 0-21-9-21-21v-33c0-12 9-21 21-21z"></path></g>
<g id="lumo:eye"><path d="M500 750c-187 0-417-163-417-250s230-250 417-250 417 163 417 250-230 250-417 250z m-336-231c20 22 47 46 78 69C322 644 411 678 500 678s178-34 258-90c31-22 59-46 78-69 6-7 12-14 16-19-4-6-9-12-16-19-20-22-47-46-78-69C678 356 589 322 500 322s-178 34-258 90c-31 22-59 46-78 69-6 7-12 14-16 19 4 6 9 12 16 19zM500 646c-81 0-146-65-146-146s65-146 146-146 146 65 146 146-65 146-146 146z m0-75c39 0 71-32 71-71 0-39-32-71-71-71-39 0-71 32-71 71 0 39 32 71 71 71z"></path></g>
<g id="lumo:eye-disabled"><path d="M396 735l60-60c15 2 30 3 44 3 89 0 178-34 258-90 31-22 59-46 78-69 6-7 12-14 16-19-4-6-9-12-16-19-20-22-47-46-78-69-8-5-15-11-23-15l50-51C862 397 917 458 917 500c0 87-230 250-417 250-34 0-69-5-104-15zM215 654C138 603 83 542 83 500c0-87 230-250 417-250 34 0 69 5 104 15l-59 60c-15-2-30-3-45-3-89 0-178 34-258 90-31 22-59 46-78 69-6 7-12 14-16 19 4 6 9 12 16 19 20 22 47 46 78 69 8 5 16 11 24 16L215 654z m271-9l159-159c0 5 1 9 1 14 0 81-65 146-146 146-5 0-9 0-14-1z m-131-131C354 510 354 505 354 500c0-81 65-146 146-146 5 0 10 0 14 1l-159 159z m-167 257L780 179c12-12 32-12 44 0 12 12 12 32 0 44L232 815c-12 12-32 12-44 0s-12-32 0-44z"></path></g>
<g id="lumo:menu"><path d="M167 292c0-23 19-42 41-42h584C815 250 833 268 833 292c0 23-19 42-41 41H208C185 333 167 315 167 292z m0 208c0-23 19-42 41-42h584C815 458 833 477 833 500c0 23-19 42-41 42H208C185 542 167 523 167 500z m0 208c0-23 19-42 41-41h584C815 667 833 685 833 708c0 23-19 42-41 42H208C185 750 167 732 167 708z"></path></g>
<g id="lumo:minus"><path d="M261 461c-22 0-39 18-39 39 0 22 18 39 39 39h478c22 0 39-18 39-39 0-22-18-39-39-39H261z"></path></g>
<g id="lumo:ordered-list"><path d="M138 333V198H136l-43 28v-38l45-31h45V333H138z m-61 128c0-35 27-59 68-59 39 0 66 21 66 53 0 20-11 37-43 64l-29 27v2h74V583H80v-30l55-52c26-24 32-33 33-43 0-13-10-22-24-22-15 0-26 10-26 25v1h-41v-1zM123 759v-31h21c15 0 25-8 25-21 0-13-10-21-25-21-15 0-26 9-26 23h-41c1-34 27-56 68-57 39 0 66 20 66 49 0 20-14 36-33 39v3c24 3 40 19 39 41 0 32-30 54-73 54-41 0-69-22-70-57h43c1 13 11 22 28 22 16 0 27-9 27-22 0-14-10-22-28-22h-21zM333 258c0-18 15-33 34-33h516c18 0 33 15 34 33 0 18-15 33-34 34H367c-18 0-33-15-34-34z m0 250c0-18 15-33 34-33h516c18 0 33 15 34 33s-15 33-34 34H367c-18 0-33-15-34-34z m0 250c0-18 15-33 34-33h516c18 0 33 15 34 33s-15 33-34 34H367c-18 0-33-15-34-34z"></path></g>
<g id="lumo:phone"><path d="M296 208l42-37c17-15 44-13 58 4a42 42 0 0 1 5 7L459 282c12 20 5 45-15 57l-7 4c-17 10-25 30-19 48l20 66a420 420 0 0 0 93 157l41 45c13 14 35 17 51 8l7-5c20-12 45-5 57 16L745 777c12 20 5 45-15 57a42 42 0 0 1-8 4l-52 17c-61 21-129 4-174-43l-50-52c-81-85-141-189-175-302l-24-78c-19-62 0-129 49-172z"></path></g>
<g id="lumo:photo"><path d="M208 167h584c69 0 125 56 125 125v416c0 69-56 125-125 125H208c-69 0-125-56-125-125V292c0-69 56-125 125-125z m584 75H208c-28 0-50 22-50 50v416c0 28 22 50 50 50h584c28 0 50-22 50-50V292c0-28-22-50-50-50zM239 740l167-167c12-12 31-14 45-6l73 43 172-201c13-15 34-18 50-7l95 67v92l-111-78-169 199c-12 14-32 17-47 8l-76-43-111 111H229c2-7 5-13 10-18zM458 427C458 490 407 542 344 542S229 490 229 427c0-63 51-115 115-115S458 364 458 427z m-62 0C396 398 373 375 344 375S292 398 292 427c0 29 23 52 52 52s52-23 52-52z"></path></g>
<g id="lumo:play"><path d="M689 528l-298 175c-13 8-34 8-48 0-6-4-10-9-10-14V311C333 300 348 292 367 292c9 0 17 2 24 5l298 175c26 15 26 40 0 56z"></path></g>
<g id="lumo:plus"><path d="M461 461H261c-22 0-39 18-39 39 0 22 18 39 39 39h200v200c0 22 18 39 39 39 22 0 39-18 39-39v-200h200c22 0 39-18 39-39 0-22-18-39-39-39h-200V261c0-22-18-39-39-39-22 0-39 18-39 39v200z"></path></g>
<g id="lumo:redo"><path d="M290 614C312 523 393 458 491 458c55 0 106 22 144 57l-88 88c-3 3-5 7-5 11 0 8 6 15 15 15l193-5c17 0 31-15 31-32l5-192c0-4-1-8-4-11-6-6-16-6-22 0l-66 67C641 406 570 375 491 375c-136 0-248 90-281 215-1 2-1 5-1 8-8 44 45 68 73 32 4-5 7-11 8-16z"></path></g>
<g id="lumo:reload"><path d="M500 233V137c0-9 7-16 15-16 4 0 8 2 10 4l133 140c12 12 12 32 0 45l-133 140c-6 6-15 6-21 0C502 447 500 443 500 438V308c-117 0-212 95-212 213 0 117 95 212 212 212 117 0 212-95 212-212 0-21 17-38 38-38s38 17 37 38c0 159-129 288-287 287-159 0-288-129-288-287 0-159 129-288 288-288z"></path></g>
<g id="lumo:search"><path d="M662 603l131 131c16 16 16 42 0 59-16 16-43 16-59 0l-131-131C562 691 512 708 458 708c-138 0-250-112-250-250 0-138 112-250 250-250 138 0 250 112 250 250 0 54-17 104-46 145zM458 646c104 0 188-84 188-188S562 271 458 271 271 355 271 458s84 188 187 188z"></path></g>
<g id="lumo:undo"><path d="M710 614C688 523 607 458 509 458c-55 0-106 22-144 57l88 88c3 3 5 7 5 11 0 8-6 15-15 15l-193-5c-17 0-31-15-31-32L214 400c0-4 1-8 4-11 6-6 16-6 22 0l66 67C359 406 430 375 509 375c136 0 248 90 281 215 1 2 1 5 1 8 8 44-45 68-73 32-4-5-7-11-8-16z"></path></g>
<g id="lumo:unordered-list"><path d="M146 325c-42 0-67-26-67-63 0-37 25-63 67-63 42 0 67 26 67 63 0 37-25 63-67 63z m0 250c-42 0-67-26-67-63 0-37 25-63 67-63 42 0 67 26 67 63 0 37-25 63-67 63z m0 250c-42 0-67-26-67-63 0-37 25-63 67-63 42 0 67 26 67 63 0 37-25 63-67 63zM333 258c0-18 15-33 34-33h516c18 0 33 15 34 33 0 18-15 33-34 34H367c-18 0-33-15-34-34z m0 250c0-18 15-33 34-33h516c18 0 33 15 34 33s-15 33-34 34H367c-18 0-33-15-34-34z m0 250c0-18 15-33 34-33h516c18 0 33 15 34 33s-15 33-34 34H367c-18 0-33-15-34-34z"></path></g>
<g id="lumo:upload"><path d="M454 271V604c0 21-17 38-37 38s-38-17-38-38V271L254 382c-15 14-39 12-53-3-14-15-12-39 3-53L391 160c14-13 36-13 51-1 0 0 0 0 0 1l187 166c15 14 17 37 3 53-14 15-37 17-53 3L454 271zM675 704c0-21 17-38 37-37 21 0 38 17 38 37v92c0 21-17 38-38 37H121c-21 0-38-17-38-37v-92c0-21 17-38 38-37s38 17 37 37v54h517v-54z"></path></g>
<g id="lumo:user"><path d="M500 500c-69 0-125-56-125-125s56-125 125-125 125 56 125 125-56 125-125 125z m-292 292c0-115 131-208 292-209s292 93 292 209H208z"></path></g>
</defs>
</svg>
</vaadin-iconset>`;
document.head.appendChild($ada8ae54ac9e10f2$var$template.content);

});
parcelRegister("5Gsvk", function(module, exports) {
parcelRequire("aQbUy");
parcelRequire("dNadP");

});


parcelRegister("8nByP", function(module, exports) {
/**
 * @license
 * Copyright (c) 2015 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("5Gsvk");
parcelRequire("8HCK1");
const $619d9b84df729be9$var$template = document.createElement('template');
$619d9b84df729be9$var$template.innerHTML = `<vaadin-iconset name="vaadin" size="16">
<svg><defs>
<g id="vaadin:abacus"><path d="M0 0v16h16v-16h-16zM14 2v3h-0.1c-0.2-0.6-0.8-1-1.4-1s-1.2 0.4-1.4 1h-3.2c-0.2-0.6-0.7-1-1.4-1s-1.2 0.4-1.4 1h-0.2c-0.2-0.6-0.7-1-1.4-1s-1.2 0.4-1.4 1h-0.1v-3h12zM13.9 10c-0.2-0.6-0.8-1-1.4-1s-1.2 0.4-1.4 1h-0.2c-0.2-0.6-0.8-1-1.4-1s-1.2 0.4-1.4 1h-3.2c-0.2-0.6-0.7-1-1.4-1s-1.2 0.4-1.4 1h-0.1v-4h0.1c0.2 0.6 0.8 1 1.4 1s1.2-0.4 1.4-1h0.2c0.2 0.6 0.8 1 1.4 1s1.2-0.4 1.4-1h3.2c0.2 0.6 0.8 1 1.4 1s1.2-0.4 1.4-1h0.1l-0.1 4zM2 14v-3h0.1c0.2 0.6 0.8 1 1.4 1s1.2-0.4 1.4-1h3.2c0.2 0.6 0.8 1 1.4 1s1.2-0.4 1.4-1h0.2c0.2 0.6 0.8 1 1.4 1s1.2-0.4 1.4-1h0.1v3h-12z"></path></g>
<g id="vaadin:absolute-position"><path d="M0 0v16h16v-16h-16zM15 15h-14v-6h3v1l3-2-3-2v1h-3v-6h6v3h-1l2 3 2-3h-1v-3h6v14z"></path></g>
<g id="vaadin:academy-cap"><path d="M15.090 12.79c0.235-0.185 0.385-0.469 0.385-0.789 0-0.358-0.188-0.672-0.471-0.849l-0.004-5.822-1 0.67v5.15c-0.283 0.18-0.468 0.492-0.468 0.847 0 0.316 0.147 0.598 0.376 0.782l-0.378 0.502c-0.323 0.41-0.521 0.931-0.53 1.498l-0 1.222h0.81c0.002 0 0.004 0 0.005 0 0.411 0 0.757-0.282 0.853-0.664l0.331-1.336v2h1v-1.21c-0.009-0.569-0.207-1.090-0.534-1.505z"></path><path d="M8 0l-8 4 8 5 8-5-8-4z"></path><path d="M8 10l-5-3.33v1.71c0 0.91 2.94 3.62 5 3.62s5-2.71 5-3.62v-1.71z"></path></g>
<g id="vaadin:accessibility"><path d="M10.4 10h-0.5c0.1 0.3 0.1 0.7 0.1 1 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-2.1 1.6-3.8 3.7-4l-0.2-1c-2.6 0.4-4.5 2.4-4.5 5 0 2.8 2.2 5 5 5 2.4 0 4.4-1.7 4.9-3.9l-0.5-2.1z"></path><path d="M13.1 13l-1.1-5h-4.1l-0.2-1h3.3v-1h-3.5l-0.6-2.5c0.9-0.1 1.6-0.8 1.6-1.7 0-1-0.8-1.8-1.8-1.8s-1.7 0.8-1.7 1.8c0 0.6 0.3 1.2 0.8 1.5l1.3 5.7h4.1l1.2 5h2.6v-1h-1.9z"></path></g>
<g id="vaadin:accordion-menu"><path d="M0 4v8h16v-8h-16zM15 11h-14v-4h14v4z"></path><path d="M0 0h16v3h-16v-3z"></path><path d="M0 13h16v3h-16v-3z"></path></g>
<g id="vaadin:add-dock"><path d="M0 11v5h16v-5h-16zM12 15h-3v-3h3v3z"></path><path d="M12 7v-2c0-5-8-5-8-5s5 0 5 5v2h-2l3.5 3 3.5-3h-2z"></path></g>
<g id="vaadin:adjust"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM2 8c0-3.3 2.7-6 6-6v12c-3.3 0-6-2.7-6-6z"></path></g>
<g id="vaadin:adobe-flash"><path d="M0 0v16h16v-16h-16zM13 4.4c-3 0-3.3 2.6-3.3 2.6h1.3v2h-2.4c-1.8 5.8-5.6 5-5.6 5v-2.5c0 0 2.5 0.6 3.9-4 1.8-6.1 6.1-5.5 6.1-5.5v2.4z"></path></g>
<g id="vaadin:airplane"><path d="M12.3 6.5c0.5-0.5 0.9-0.8 1.2-1.1 1.6-1.6 3.2-4.1 2.2-5.1s-3.4 0.6-5 2.2c-0.3 0.3-0.6 0.7-1.1 1.2l-7-3.2c-0.7-0.3-1.5-0.2-2 0.3l-0.6 0.5 6.6 5.7c-1.3 1.6-2.7 3.1-3.4 4l-1.1-0.6c-0.5-0.3-1.2-0.3-1.6 0.2l-0.3 0.3 2.8 2.1 2 2.8 0.3-0.3c0.4-0.4 0.5-1.1 0.2-1.6l-0.5-1.1c0.9-0.7 2.4-2.1 4-3.4l5.7 6.6 0.5-0.5c0.5-0.5 0.6-1.3 0.3-2l-3.2-7z"></path></g>
<g id="vaadin:alarm"><path d="M8 5h-1v5h4v-1l-2.93 0.070-0.070-4.070z"></path><path d="M5.46 0.87c-0.387-0.522-1-0.856-1.692-0.856-0.41 0-0.793 0.118-1.117 0.321l-0.991 0.765c-0.41 0.384-0.666 0.929-0.666 1.534 0 0.496 0.172 0.951 0.459 1.31z"></path><path d="M14.34 1.1l-1-0.77c-0.315-0.198-0.698-0.316-1.108-0.316-0.692 0-1.305 0.334-1.688 0.85l3.996 3.076c0.287-0.356 0.46-0.813 0.46-1.312 0-0.602-0.253-1.145-0.659-1.528z"></path><path d="M12.87 14c1.308-1.268 2.122-3.038 2.13-4.998-0.028-3.856-3.145-6.973-6.997-7.002-3.857 0.028-6.975 3.145-7.003 6.997 0.008 1.965 0.822 3.735 2.128 5.001l-0.938 0.942c-0.075 0.102-0.12 0.231-0.12 0.37 0 0.348 0.282 0.63 0.63 0.63 0.139 0 0.268-0.045 0.372-0.122l0.998-0.999c1.092 0.758 2.446 1.211 3.905 1.211s2.813-0.453 3.928-1.226l0.977 1.015c0.102 0.075 0.231 0.12 0.37 0.12 0.348 0 0.63-0.282 0.63-0.63 0-0.139-0.045-0.268-0.122-0.372zM2.87 9c0.028-2.822 2.308-5.102 5.127-5.13 2.825 0.028 5.105 2.308 5.133 5.127-0.028 2.825-2.308 5.105-5.127 5.133-2.825-0.028-5.105-2.308-5.133-5.127z"></path></g>
<g id="vaadin:align-center"><path d="M5 0h6v3h-6v-3z"></path><path d="M1 4h14v3h-14v-3z"></path><path d="M3 8h10v3h-10v-3z"></path><path d="M0 12h16v3h-16v-3z"></path></g>
<g id="vaadin:align-justify"><path d="M0 0h16v3h-16v-3z"></path><path d="M0 4h16v3h-16v-3z"></path><path d="M0 12h16v3h-16v-3z"></path><path d="M0 8h16v3h-16v-3z"></path></g>
<g id="vaadin:align-left"><path d="M0 0h11v3h-11v-3z"></path><path d="M0 4h15v3h-15v-3z"></path><path d="M0 8h13v3h-13v-3z"></path><path d="M0 12h16v3h-16v-3z"></path></g>
<g id="vaadin:align-right"><path d="M5 0h11v3h-11v-3z"></path><path d="M1 4h15v3h-15v-3z"></path><path d="M3 8h13v3h-13v-3z"></path><path d="M0 12h16v3h-16v-3z"></path></g>
<g id="vaadin:alt-a"><path d="M14 7v-1h-1v-1h-1v1h-0.5v1h0.5v3.56c0 1 0.56 1.44 2 1.44v-1c-0.055 0.012-0.119 0.019-0.185 0.019-0.359 0-0.669-0.21-0.813-0.514l-0.002-3.505h1z"></path><path d="M9 3h1v9h-1v-9z"></path><path d="M3 12l0.57-2h2.82l0.61 2h1l-2.27-8h-1.46l-2.27 8h1zM5 5.1l1.11 3.9h-2.22z"></path></g>
<g id="vaadin:alt"><path d="M3.89 9h2.22l-1.11-3.9-1.11 3.9z"></path><path d="M0 0v16h16v-16h-16zM7 12l-0.61-2h-2.78l-0.61 2h-1l2.27-8h1.46l2.27 8h-1zM10 12h-1v-9h1v9zM14 7h-1v3.5s0 0.5 1 0.5v1c-1 0-2-0.44-2-1.44v-3.56h-0.5v-1h0.5v-1h1v1h1v1z"></path></g>
<g id="vaadin:ambulance"><path d="M6.18 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M14 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M5 6h-1v1h-1v1h1v1h1v-1h1v-1h-1v-1z"></path><path d="M15.76 8.64l-3-4.53c-0.455-0.673-1.215-1.11-2.078-1.11-0.008 0-0.015 0-0.023 0l-2.659-0v-1c0-0.552-0.448-1-1-1s-1 0.448-1 1v1h-4.5c-0.828 0-1.5 0.672-1.5 1.5v8.5h1.37c0.474-1.135 1.546-1.931 2.812-2 1.278 0.072 2.345 0.868 2.81 1.978l2.188 0.021c0.474-1.135 1.546-1.931 2.812-2 1.303 0.003 2.405 0.827 2.822 1.979l1.187 0.021v-3.57c-0.001-0.294-0.090-0.568-0.243-0.795zM6.92 8.12c-0.266 1.117-1.255 1.935-2.435 1.935-1.381 0-2.5-1.119-2.5-2.5 0-1.18 0.818-2.17 1.918-2.432 0.195-0.049 0.399-0.075 0.609-0.075 1.37 0 2.48 1.11 2.48 2.48 0 0.21-0.026 0.414-0.075 0.609zM10 8v-3h0.85c0.003-0 0.006-0 0.009-0 0.777 0 1.461 0.394 1.866 0.992l1.325 2.008z"></path></g>
<g id="vaadin:anchor"><path d="M13 9v2c0 0-0.8 1.7-4 1.9v-6.9h2.2c0.2 0.3 0.5 0.5 0.8 0.5 0.6 0 1-0.4 1-1s-0.4-1-1-1c-0.4 0-0.7 0.2-0.8 0.5h-2.2v-1.3c0.6-0.3 1-1 1-1.7 0-1.1-0.9-2-2-2s-2 0.9-2 2c0 0.7 0.4 1.4 1 1.7v1.3h-2.2c-0.1-0.3-0.4-0.5-0.8-0.5-0.6 0-1 0.4-1 1s0.4 1 1 1c0.4 0 0.7-0.2 0.8-0.5h2.2v7c-3.3-0.3-4-2-4-2v-2h-3c0 0 2.8 7 8 7 5 0 8-7 8-7h-3zM8 1c0.6 0 1 0.4 1 1s-0.4 1-1 1-1-0.4-1-1 0.4-1 1-1z"></path></g>
<g id="vaadin:angle-double-down"><path d="M3 2v2l5 5 5-5v-2l-5 5z"></path><path d="M3 7v2l5 5 5-5v-2l-5 5z"></path></g>
<g id="vaadin:angle-double-left"><path d="M14 3h-2l-5 5 5 5h2l-5-5z"></path><path d="M9 3h-2l-5 5 5 5h2l-5-5z"></path></g>
<g id="vaadin:angle-double-right"><path d="M2 13h2l5-5-5-5h-2l5 5z"></path><path d="M7 13h2l5-5-5-5h-2l5 5z"></path></g>
<g id="vaadin:angle-double-up"><path d="M13 14v-2l-5-5-5 5v2l5-5z"></path><path d="M13 9v-2l-5-5-5 5v2l5-5z"></path></g>
<g id="vaadin:angle-down"><path d="M13 4v2l-5 5-5-5v-2l5 5z"></path></g>
<g id="vaadin:angle-left"><path d="M12 13h-2l-5-5 5-5h2l-5 5z"></path></g>
<g id="vaadin:angle-right"><path d="M4 13h2l5-5-5-5h-2l5 5z"></path></g>
<g id="vaadin:angle-up"><path d="M3 12v-2l5-5 5 5v2l-5-5z"></path></g>
<g id="vaadin:archive"><path d="M0 1h16v3h-16v-3z"></path><path d="M1 5v11h14v-11h-14zM11 9h-6v-2h6v2z"></path></g>
<g id="vaadin:archives"><path d="M11 2h-6v4h6v-4zM9 4h-2v-1h2v1z"></path><path d="M3 0v16h2v-1h6v1h2v-16h-10zM12 14h-8v-6h8v6zM12 7h-8v-6h8v6z"></path><path d="M11 9h-6v4h6v-4zM9 11h-2v-1h2v1z"></path></g>
<g id="vaadin:area-select"><path d="M7.9 7.9l2.1 7.5 1.7-2.6 3.2 3.2 1.1-1.1-3.3-3.2 2.7-1.6z"></path><path d="M8 12h-7v-9h12v5.4l1 0.2v-6.6h-14v11h8.2z"></path></g>
<g id="vaadin:arrow-backward"><path d="M0 7.9l6-4.9v3c0 0 1.1 0 2 0 8 0 8 8 8 8s-1-4-7.8-4c-1.1 0-1.8 0-2.2 0v2.9l-6-5z"></path></g>
<g id="vaadin:arrow-circle-down-o"><path d="M1 8c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7-7-3.1-7-7zM0 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8v0z"></path><path d="M9 9.6l1.8-1.8 1.4 1.4-4.2 4.2-4.2-4.2 1.4-1.4 1.8 1.8v-6.6h2v6.6z"></path></g>
<g id="vaadin:arrow-circle-down"><path d="M0 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8c-4.4 0-8 3.6-8 8zM9 9.6l1.8-1.8 1.4 1.4-4.2 4.2-4.2-4.2 1.4-1.4 1.8 1.8v-6.6h2v6.6z"></path></g>
<g id="vaadin:arrow-circle-left-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M6.4 9l1.8 1.8-1.4 1.4-4.2-4.2 4.2-4.2 1.4 1.4-1.8 1.8h6.6v2h-6.6z"></path></g>
<g id="vaadin:arrow-circle-left"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM6.4 9l1.8 1.8-1.4 1.4-4.2-4.2 4.2-4.2 1.4 1.4-1.8 1.8h6.6v2h-6.6z"></path></g>
<g id="vaadin:arrow-circle-right-o"><path d="M8 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zM8 16c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8v0z"></path><path d="M9.6 7l-1.8-1.8 1.4-1.4 4.2 4.2-4.2 4.2-1.4-1.4 1.8-1.8h-6.6v-2h6.6z"></path></g>
<g id="vaadin:arrow-circle-right"><path d="M8 16c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8zM9.6 7l-1.8-1.8 1.4-1.4 4.2 4.2-4.2 4.2-1.4-1.4 1.8-1.8h-6.6v-2h6.6z"></path></g>
<g id="vaadin:arrow-circle-up-o"><path d="M15 8c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7zM16 8c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 4.4 3.6 8 8 8s8-3.6 8-8v0z"></path><path d="M7 6.4l-1.8 1.8-1.4-1.4 4.2-4.2 4.2 4.2-1.4 1.4-1.8-1.8v6.6h-2v-6.6z"></path></g>
<g id="vaadin:arrow-circle-up"><path d="M16 8c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8zM7 6.4l-1.8 1.8-1.4-1.4 4.2-4.2 4.2 4.2-1.4 1.4-1.8-1.8v6.6h-2v-6.6z"></path></g>
<g id="vaadin:arrow-down"><path d="M12.5 8.6l-3.5 3.6v-12.2h-2v12.2l-3.5-3.6-1.4 1.5 5.9 5.9 5.9-5.9z"></path></g>
<g id="vaadin:arrow-forward"><path d="M16 7.9l-6-4.9v3c-0.5 0-1.1 0-2 0-8 0-8 8-8 8s1-4 7.8-4c1.1 0 1.8 0 2.2 0v2.9l6-5z"></path></g>
<g id="vaadin:arrow-left"><path d="M7.4 12.5l-3.6-3.5h12.2v-2h-12.2l3.6-3.5-1.5-1.4-5.9 5.9 5.9 5.9z"></path></g>
<g id="vaadin:arrow-long-down"><path d="M7 1h2v11h2l-3 3-3-3h2z"></path></g>
<g id="vaadin:arrow-long-left"><path d="M15 7v2h-11v2l-3-3 3-3v2z"></path></g>
<g id="vaadin:arrow-right"><path d="M8.6 3.5l3.5 3.5h-12.1v2h12.1l-3.5 3.5 1.4 1.4 6-5.9-6-5.9z"></path></g>
<g id="vaadin:arrow-up"><path d="M3.4 7.4l3.6-3.6v12.2h2v-12.2l3.5 3.6 1.4-1.5-5.9-5.9-6 5.9z"></path></g>
<g id="vaadin:arrows-cross"><path d="M15 5v-4h-4l1.3 1.3-4.3 4.3-4.3-4.3 1.3-1.3h-4v4l1.3-1.3 4.3 4.3-4.3 4.3-1.3-1.3v4h4l-1.3-1.3 4.3-4.3 4.3 4.3-1.3 1.3h4v-4l-1.3 1.3-4.3-4.3 4.3-4.3z"></path></g>
<g id="vaadin:arrows-long-h"><path d="M16 8l-3-3v2h-10v-2l-3 3 3 3v-2h10v2z"></path></g>
<g id="vaadin:arrows-long-right"><path d="M1 9v-2h11v-2l3 3-3 3v-2z"></path></g>
<g id="vaadin:arrows-long-up"><path d="M9 15h-2v-11h-2l3-3 3 3h-2z"></path></g>
<g id="vaadin:arrows-long-v"><path d="M9 3h2l-3-3-3 3h2v10h-2l3 3 3-3h-2z"></path></g>
<g id="vaadin:arrows"><path d="M16 8l-3-3v2h-4v-4h2l-3-3-3 3h2v4h-4v-2l-3 3 3 3v-2h4v4h-2l3 3 3-3h-2v-4h4v2z"></path></g>
<g id="vaadin:asterisk"><path d="M15.9 5.7l-2-3.4-3.9 2.2v-4.5h-4v4.5l-4-2.2-2 3.4 3.9 2.3-3.9 2.3 2 3.4 4-2.2v4.5h4v-4.5l3.9 2.2 2-3.4-4-2.3z"></path></g>
<g id="vaadin:at"><path d="M7.5 12.2c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2 4.2 1.9 4.2 4.2c0.1 2.3-1.9 4.2-4.2 4.2zM7.5 5.2c-1.5 0-2.7 1.3-2.7 2.8s1.2 2.8 2.8 2.8 2.8-1.2 2.8-2.8-1.4-2.8-2.9-2.8z"></path><path d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8c0 1.5-0.4 3-1.2 4.2-0.3 0.5-1.1 1.2-2.3 1.2-0.8 0-1.3-0.3-1.6-0.6-0.7-0.7-0.6-1.8-0.6-1.9v-6.9h1.5v7c0 0.2 0 0.6 0.2 0.8 0 0 0.2 0.2 0.5 0.2 0.7 0 1.1-0.5 1.1-0.5 0.6-1 1-2.2 1-3.4 0-3.6-2.9-6.5-6.5-6.5s-6.6 2.8-6.6 6.4 2.9 6.5 6.5 6.5c0.7 0 1.3-0.1 1.9-0.3l0.4 1.4c-0.7 0.3-1.5 0.4-2.3 0.4z"></path></g>
<g id="vaadin:automation"><path d="M14 12c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M11.7 16v0c-0.8 0-1.6-0.2-2.3-0.7l-6.2-3.3c-0.5-0.4-0.9-0.6-1.3-1-1.2-1.2-1.9-2.9-1.9-4.6s0.7-3.3 1.9-4.5c1.2-1.2 2.8-1.9 4.5-1.9s3.3 0.7 4.6 1.9c0.4 0.4 0.6 0.7 1 1.2l3.5 6.4c1 1.7 0.7 3.8-0.7 5.2-0.9 0.9-1.9 1.3-3.1 1.3zM6.4 1c-1.4 0-2.8 0.6-3.8 1.6s-1.6 2.4-1.6 3.8c0 1.5 0.6 2.8 1.6 3.8 0.3 0.3 0.6 0.5 1.1 0.8l6.3 3.4c0.6 0.4 1.2 0.5 1.8 0.5v0c0.9 0 1.7-0.3 2.3-1 1.1-1.1 1.3-2.7 0.5-4l-3.5-6.4c-0.3-0.4-0.5-0.7-0.8-1-1.1-0.9-2.4-1.5-3.9-1.5z"></path><path d="M11 7v-1l-1.4-0.5c-0.1-0.2-0.1-0.3-0.2-0.5l0.6-1.3-0.7-0.7-1.3 0.6c-0.2-0.1-0.3-0.1-0.5-0.2l-0.5-1.4h-1l-0.5 1.4c-0.2 0.1-0.3 0.1-0.5 0.2l-1.3-0.6-0.7 0.7 0.6 1.3c-0.1 0.2-0.1 0.3-0.2 0.5l-1.4 0.5v1l1.4 0.5c0.1 0.2 0.1 0.3 0.2 0.5l-0.6 1.3 0.7 0.7 1.3-0.6c0.2 0.1 0.3 0.2 0.5 0.2l0.5 1.4h1l0.5-1.4c0.2-0.1 0.3-0.1 0.5-0.2l1.3 0.6 0.7-0.7-0.6-1.3c0.1-0.2 0.2-0.3 0.2-0.5l1.4-0.5zM6.5 8c-0.8 0-1.5-0.7-1.5-1.5s0.7-1.5 1.5-1.5 1.5 0.7 1.5 1.5-0.7 1.5-1.5 1.5z"></path></g>
<g id="vaadin:backspace-a"><path d="M5 12l-5-4 5-4v2h11v4h-11v2z"></path></g>
<g id="vaadin:backspace"><path d="M0 2v12h16v-12h-16zM13 9h-7v2l-3-3 3-3v2h7v2z"></path></g>
<g id="vaadin:backwards"><path d="M16 15v-14l-8 7z"></path><path d="M8 15v-14l-8 7z"></path></g>
<g id="vaadin:ban"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM8 2c1.3 0 2.5 0.4 3.5 1.1l-8.4 8.4c-0.7-1-1.1-2.2-1.1-3.5 0-3.3 2.7-6 6-6zM8 14c-1.3 0-2.5-0.4-3.5-1.1l8.4-8.4c0.7 1 1.1 2.2 1.1 3.5 0 3.3-2.7 6-6 6z"></path></g>
<g id="vaadin:bar-chart-h"><path d="M1 15v-15h-1v16h16v-1h-15z"></path><path d="M2 8h4v6h-4v-6z"></path><path d="M7 2h4v12h-4v-12z"></path><path d="M12 6h4v8h-4v-8z"></path></g>
<g id="vaadin:bar-chart-v"><path d="M1 15v-15h-1v16h16v-1h-15z"></path><path d="M8 0v4h-6v-4h6z"></path><path d="M14 5v4h-12v-4h12z"></path><path d="M10 10v4h-8v-4h8z"></path></g>
<g id="vaadin:bar-chart"><path d="M0 15h15v1h-15v-1z"></path><path d="M0 11h3v3h-3v-3z"></path><path d="M4 9h3v5h-3v-5z"></path><path d="M8 5h3v9h-3v-9z"></path><path d="M12 0h3v14h-3v-14z"></path></g>
<g id="vaadin:barcode"><path d="M0 3h1v10h-1v-10z"></path><path d="M8 3h2v10h-2v-10z"></path><path d="M11 3h1v10h-1v-10z"></path><path d="M13 3h1v10h-1v-10z"></path><path d="M15 3h1v10h-1v-10z"></path><path d="M2 3h3v10h-3v-10z"></path><path d="M6 3h1v10h-1v-10z"></path></g>
<g id="vaadin:bed"><path d="M4.28 7h2.72l-1.15-1.68c-0.542-0.725-1.36-1.216-2.295-1.319l-0.555-0.001v1.54c-0.011 0.063-0.018 0.136-0.018 0.211 0 0.69 0.56 1.25 1.25 1.25 0.017 0 0.034-0 0.050-0.001z"></path><path d="M13 7v-0.28c0-0.003 0-0.007 0-0.010 0-0.934-0.749-1.693-1.678-1.71l-4.692-0c0.5 0.62 1.37 2 1.37 2h5z"></path><path d="M15 5.1c-0.552 0-1 0.448-1 1v1.9h-12v-4c0-0.552-0.448-1-1-1s-1 0.448-1 1v9h2v-2h12v2h2v-6.9c0-0.552-0.448-1-1-1z"></path></g>
<g id="vaadin:bell-o"><path d="M12.7 11.4c-0.5-0.2-0.7-0.7-0.7-1.2v-5.2c0 0 0-2.4-3-2.9v-1.1c0 0 0.1-1-1-1s-1 1-1 1v1.1c-3 0.5-3 2.9-3 2.9v5.2c0 0.5-0.3 1-0.7 1.2l-1.3 0.6v2h4c0 0-0.1 2 2 2s2-2 2-2h4v-2l-1.3-0.6zM13 13h-10v-0.4l0.7-0.4c0.8-0.3 1.3-1.1 1.3-2v-5.2c0-0.1 0-1.6 2.2-1.9l0.8-0.2 0.8 0.1c2 0.4 2.2 1.7 2.2 2v5.2c0 0.9 0.5 1.7 1.3 2.1l0.7 0.4v0.3z"></path></g>
<g id="vaadin:bell-slash-o"><path d="M15.2 0l-3.6 3.6c-0.4-0.6-1.2-1.3-2.6-1.5v-1.1c0 0 0.1-1-1-1s-1 1-1 1v1.1c-3 0.5-3 2.9-3 2.9v5.2c0 0.5-0.3 1-0.7 1.2l-1.3 0.6v1.3l-2 2v0.7h0.7l15.3-15.4v-0.6h-0.8zM5 10.3c0-0.1 0-0.1 0 0v-5.3c0-0.1 0.1-1.6 2.2-1.9l0.8-0.2 0.8 0.1c1.2 0.2 1.8 0.8 2 1.3l-5.8 6z"></path><path d="M12 10.2v-4.6l-1 1v3.5c0 0.9 0.5 1.7 1.3 2.1l0.7 0.4v0.4h-8.3l-1 1h2.4c0 0-0.1 2 2 2s2-2 2-2h3.9v-2l-1.3-0.6c-0.4-0.3-0.7-0.7-0.7-1.2z"></path></g>
<g id="vaadin:bell-slash"><path d="M15.2 0l-3.6 3.6c-0.5-0.6-1.2-1.3-2.6-1.5v-1.1c0 0 0.1-1-1-1s-1 1-1 1v1.1c-2.8 0.5-3 2.9-3 2.9v5.2c0 0.5-0.3 1-0.7 1.2l-1.3 0.6v1h0.3l-2.3 2.3v0.7h0.7l15.3-15.4v-0.6h-0.8zM6 4.8v4.5l-1 1v-5.3c0 0 0-0.8 0.7-1.4 0.7-0.7 1.3-0.6 1.3-0.6s-1 0.7-1 1.8z"></path><path d="M8 16c2.1 0 2-2 2-2h-4c0 0-0.1 2 2 2z"></path><path d="M12 10.2v-4.6l-6 6-0.3 0.4-1 1h9.3v-1l-1.3-0.6c-0.4-0.3-0.7-0.7-0.7-1.2z"></path></g>
<g id="vaadin:bell"><path d="M6 14h4c0 0 0.1 2-2 2s-2-2-2-2z"></path><path d="M12.7 11.4c-0.5-0.2-0.7-0.7-0.7-1.2v-5.2c0 0-0.2-2.4-3-2.9v-1.1c0 0 0.1-1-1-1s-1 1-1 1v1.1c-2.8 0.5-3 2.9-3 2.9v5.2c0 0.5-0.3 1-0.7 1.2l-1.3 0.6v1h12v-1l-1.3-0.6zM6 4.8v7.2h-2c0.8 0 1-1 1-1v-6c0 0 0-0.8 0.7-1.4 0.7-0.7 1.3-0.6 1.3-0.6s-1 0.7-1 1.8z"></path></g>
<g id="vaadin:boat"><path d="M1.5 9.6c1.1 0.7 2.5 1.9 2.5 3.3 0 0.4 0 0.7 0 1.1 0 0 0.1 0 0.1 0s0.9 0 2-1c1 1 2 1 2 1s1 0 2-1c1 1 1.9 1 1.9 1s0.1 0 0.1 0c0-0.3 0-0.7 0-1.1 0-1.4 1.4-2.6 2.5-3.3 0.6-0.4 0.5-1.2-0.2-1.4l-1.4-0.4v-3.8h-1v-1h-3v-2h-2v2h-3v1h-1v3.8l-1.3 0.4c-0.8 0.2-0.8 1-0.2 1.4zM4 5h1v-1h6v1h1v2.5l-3.3-1c-0.5-0.1-1-0.1-1.5 0l-3.2 1v-2.5z"></path><path d="M14 14c-1 1-2 1-2 1s-1 0-2-1c-1 1-2 1-2 1s-1 0-2-1c-1 1-2 1-2 1s-1 0-2-1c-1 1-2 1-2 1v1h16v-1c0 0-1 0-2-1z"></path></g>
<g id="vaadin:bold"><path d="M11 7.5c0 0 2-0.8 2-3.6 0-4.1-5.1-3.9-7-3.9h-4v16h4c3.7 0 8 0 8-4.4 0-3.8-3-4.1-3-4.1zM9 4.4c0 1.8-1.5 1.6-3 1.6v-3c1.8 0 3 0.1 3 1.4zM6 13v-4c1.8 0 4-0.3 4 2.2 0 1.9-2.5 1.8-4 1.8z"></path></g>
<g id="vaadin:bolt"><path d="M7.99 0l-7.010 9.38 6.020-0.42-4.96 7.040 12.96-10-7.010 0.47 7.010-6.47h-7.010z"></path></g>
<g id="vaadin:bomb"><path d="M12 1h1v1h-1v-1z"></path><path d="M12 5h1v1h-1v-1z"></path><path d="M14 3h1v1h-1v-1z"></path><path d="M10 3h1v1h-1v-1z"></path><path d="M14.6 2.1l0.7-0.7-0.7-0.7-1.4 1.4 0.7 0.7z"></path><path d="M13.9 4.2l-0.7 0.7 1.4 1.4 0.7-0.7-0.7-0.7z"></path><path d="M11.1 2.8l0.7-0.7-1.4-1.4-0.7 0.7 0.7 0.7z"></path><path d="M10.4 6.4l2-2-0.7-0.7-2 2-0.7-0.7-0.7 0.8c-0.8-0.5-1.8-0.8-2.8-0.8-3 0-5.5 2.5-5.5 5.5s2.5 5.5 5.5 5.5 5.5-2.5 5.5-5.5c0-1-0.3-1.9-0.7-2.8l0.7-0.7-0.6-0.6zM6 7.2c-2 0-3.4 1.8-3.4 2.8h-1c0-2 2.4-3.8 4.4-3.8v1z"></path></g>
<g id="vaadin:book-dollar"><path d="M12.9 2.5c-1.6-1.2-1.4-2.5-1.4-2.5h-9.5v12.5c0 1.9 2.1 3.5 4 3.5h8v-13c0 0-0.8-0.2-1.1-0.5zM7 6.3c-0.9-0.3-2.3-0.8-2.3-1.9 0.1-0.8 1.3-1.4 1.3-1.6v-0.8h1v0.7c1 0.1 1.8 0.4 1.9 0.4l-0.3 0.9c0 0-0.7-0.3-1.5-0.3-0.7 0-1.1 0.3-1.2 0.8 0 0.3 0.5 0.6 1.3 0.9 1.5 0.5 1.9 1.1 1.9 1.9 0 0.7-0.1 1.6-2.1 1.8v0.9h-1v-0.8c0-0.1-1.4-0.5-1.5-0.5l0.5-0.9c0 0 1.1 0.5 2 0.4s1.3-0.6 1.3-1c0.1-0.3-0.4-0.6-1.3-0.9zM13 15h-7c-1 0-1.8-0.6-2-1.3-0.1-0.3 0-0.7 0.4-0.7h6.6v-10.3c1 0.6 2 1.1 2 1.3v11z"></path></g>
<g id="vaadin:book-percent"><path d="M12.6 2.5c-1.6-1.2-1.6-2.5-1.6-2.5h-9v12.5c0 1.9 1.6 3.5 3.5 3.5h8.5v-13c0 0-1-0.2-1.4-0.5zM5.5 3.2c0.8 0 1.5 0.7 1.5 1.6s-0.7 1.4-1.5 1.4-1.5-0.6-1.5-1.4 0.7-1.6 1.5-1.6zM9 3h1l-5 7h-1l5-7zM10 8.5c0 0.8-0.7 1.5-1.5 1.5s-1.5-0.7-1.5-1.5 0.7-1.5 1.5-1.5 1.5 0.7 1.5 1.5zM13 15h-7.5c-1 0-1.8-0.6-2-1.3-0.1-0.4 0-0.7 0.4-0.7h7.1v-10.3c0 0.6 1 1.1 2 1.3v11z"></path><path d="M9 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path><path d="M6 4.8c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path></g>
<g id="vaadin:book"><path d="M12.6 2.5c-1.6-1.2-1.6-2.5-1.6-2.5h-9v12.5c0 1.9 1.6 3.5 3.5 3.5h8.5v-13c0 0-1-0.2-1.4-0.5zM4 2h5v2h-5v-2zM13 15h-7.5c-1 0-1.8-0.6-2-1.3-0.1-0.4 0-0.7 0.4-0.7h7.1v-10.3c0.4 0.6 1.2 1.1 2 1.3v11z"></path></g>
<g id="vaadin:bookmark-o"><path d="M3 0v16l5-5 5 5v-16h-10zM12 13.7l-4-3.9-4 3.9v-10.7h8v10.7zM12 2h-8v-1h8v1z"></path></g>
<g id="vaadin:bookmark"><path d="M3 0v0 1h10l0.1-1z"></path><path d="M3 2h10v14l-5-5-5 5z"></path></g>
<g id="vaadin:briefcase"><path d="M11 3v-2h-6v2h-5v12h16v-12h-5zM10 3h-4v-1h4v1z"></path></g>
<g id="vaadin:browser"><path d="M15 1v-1h-15v15h1v1h15v-15h-1zM3 1h9v1h-9v-1zM1 1h1v1h-1v-1zM1 3h13v11h-13v-11z"></path></g>
<g id="vaadin:bug-o"><path d="M13 8v-1c1.216-1.124 1.981-2.721 2-4.497 0-0.28-0.224-0.503-0.5-0.503s-0.5 0.224-0.5 0.5c-0.018 1.112-0.431 2.125-1.105 2.906-0.876 0.978-2.15 1.594-3.569 1.594-0.020 0-0.040-0-0.059-0l-2.537 0c-0.022 0-0.049 0.001-0.075 0.001-1.414 0-2.684-0.612-3.561-1.586-0.669-0.781-1.079-1.793-1.094-2.901-0-0.279-0.224-0.503-0.5-0.503s-0.5 0.224-0.5 0.5c0.022 1.776 0.786 3.368 1.996 4.486l0.004 1.004c-3 0.060-3 1.42-3 3.47 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-1.72 0-2.4 2-2.47 0.031 1.11 0.245 2.161 0.612 3.136-0.383 0.006-0.696 0.176-0.942 0.414-0.445 0.624-0.711 1.402-0.711 2.242 0 0.2 0.015 0.397 0.044 0.589l-0.003 0.118c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.14c-0.022-0.144-0.035-0.311-0.035-0.48 0-0.587 0.154-1.139 0.424-1.616 0.165-0.152 0.401-0.257 0.66-0.264 0.681 1.007 1.714 1.731 2.92 1.994l0.031-0.994h2v1c1.237-0.269 2.271-0.993 2.939-1.983 0.013-0.017 0.016-0.017 0.019-0.017 0.254 0 0.486 0.095 0.663 0.251 0.262 0.462 0.418 1.015 0.418 1.605 0 0.178-0.014 0.352-0.041 0.522l0.002 0.121c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.14c0.025-0.165 0.039-0.356 0.039-0.551 0-0.839-0.266-1.616-0.717-2.251-0.238-0.226-0.551-0.396-0.9-0.466 0.336-0.917 0.55-1.975 0.578-3.080 2-0.012 2 0.708 2 2.458 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-2.030 0-3.39-3-3.47zM6 13.5c-0.44-0.253-0.805-0.589-1.083-0.989l-0.247-0.411-0.15-0.39c-0.302-0.802-0.49-1.73-0.52-2.697l-0-0.013v-1.65c0.578 0.326 1.254 0.556 1.973 0.647l0.027 5.573zM9 13h-2v-1h2v1zM9 11h-2v-1h2v1zM9 9h-2v-1h2v1zM12 9c-0.030 0.98-0.218 1.908-0.54 2.77l-0.13 0.33-0.24 0.4c-0.285 0.411-0.65 0.747-1.074 0.992l-0.016-5.492c0.743-0.081 1.421-0.297 2.029-0.624l-0.029 1.624z"></path><path d="M8 6.2c1.433-0.018 2.767-0.429 3.903-1.129 0.046-0.036 0.098-0.126 0.098-0.229 0-0.008-0-0.016-0.001-0.023-0.066-1.142-0.781-2.103-1.781-2.522-0.137-0.050-0.219-0.16-0.219-0.29 0-0.002 0-0.005 0-0.008v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.2c0 0.166-0.134 0.3-0.3 0.3 0 0 0 0 0 0h-1.4c-0.166 0-0.3-0.134-0.3-0.3v-1.2c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5c-0.006 0.125-0.086 0.229-0.198 0.269-1.026 0.43-1.744 1.4-1.802 2.544-0.001 0.014-0.001 0.021-0.001 0.029 0 0.102 0.051 0.193 0.13 0.247 0.959 0.703 2.161 1.125 3.462 1.125 0.144 0 0.287-0.005 0.428-0.015zM10 3c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM6 3c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1z"></path></g>
<g id="vaadin:bug"><path d="M8 6.2c1.433-0.018 2.767-0.429 3.903-1.129 0.046-0.036 0.098-0.126 0.098-0.229 0-0.008-0-0.016-0.001-0.023-0.066-1.142-0.781-2.103-1.781-2.522-0.137-0.050-0.219-0.16-0.219-0.29 0-0.002 0-0.005 0-0.008v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.2c0 0.166-0.134 0.3-0.3 0.3 0 0 0 0 0 0h-1.4c-0.166 0-0.3-0.134-0.3-0.3v-1.2c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5c-0.006 0.125-0.086 0.229-0.198 0.269-1.026 0.43-1.744 1.4-1.802 2.544-0.001 0.014-0.001 0.021-0.001 0.029 0 0.102 0.051 0.193 0.13 0.247 0.959 0.703 2.161 1.125 3.462 1.125 0.144 0 0.287-0.005 0.428-0.015zM10 3c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM6 3c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1z"></path><path d="M13 8v-1c1.216-1.124 1.981-2.721 2-4.497 0-0.28-0.224-0.503-0.5-0.503s-0.5 0.224-0.5 0.5c-0.018 1.112-0.431 2.125-1.105 2.906-0.876 0.978-2.15 1.594-3.569 1.594-0.020 0-0.040-0-0.059-0l-2.537 0c-0.022 0-0.049 0.001-0.075 0.001-1.414 0-2.684-0.612-3.561-1.586-0.669-0.781-1.079-1.793-1.094-2.901-0-0.279-0.224-0.503-0.5-0.503s-0.5 0.224-0.5 0.5c0.022 1.776 0.786 3.368 1.996 4.486l0.004 1.004c-3 0.060-3 1.42-3 3.47 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-1.72 0-2.4 2-2.47 0.031 1.11 0.245 2.161 0.612 3.136-0.383 0.006-0.696 0.176-0.942 0.414-0.445 0.624-0.711 1.402-0.711 2.242 0 0.2 0.015 0.397 0.044 0.589l-0.003 0.118c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.14c-0.022-0.144-0.035-0.311-0.035-0.48 0-0.587 0.154-1.139 0.424-1.616 0.165-0.152 0.401-0.257 0.66-0.264 0.588 1.095 1.667 1.859 2.934 1.998l0.017-0.998h2v1c1.284-0.141 2.364-0.905 2.94-1.98 0.012-0.020 0.015-0.020 0.018-0.020 0.254 0 0.486 0.095 0.663 0.251 0.262 0.462 0.418 1.015 0.418 1.605 0 0.178-0.014 0.352-0.041 0.522l0.002 0.121c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.14c0.025-0.165 0.039-0.356 0.039-0.551 0-0.839-0.266-1.616-0.717-2.251-0.238-0.226-0.551-0.396-0.9-0.466 0.336-0.917 0.55-1.975 0.578-3.080 2-0.012 2 0.708 2 2.458 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-2.030 0-3.39-3-3.47zM9 13h-2v-1h2v1zM9 11h-2v-1h2v1zM9 9h-2v-1h2v1z"></path></g>
<g id="vaadin:building-o"><path d="M2 0v16h12v-16h-12zM13 15h-4v-3h-2v3h-4v-14h10v14z"></path><path d="M4 9h2v2h-2v-2z"></path><path d="M7 9h2v2h-2v-2z"></path><path d="M10 9h2v2h-2v-2z"></path><path d="M4 6h2v2h-2v-2z"></path><path d="M7 6h2v2h-2v-2z"></path><path d="M10 6h2v2h-2v-2z"></path><path d="M4 3h2v2h-2v-2z"></path><path d="M7 3h2v2h-2v-2z"></path><path d="M10 3h2v2h-2v-2z"></path></g>
<g id="vaadin:building"><path d="M3 0v16h4v-3h2v3h4v-16h-10zM6 12h-2v-2h2v2zM6 9h-2v-2h2v2zM6 6h-2v-2h2v2zM6 3h-2v-2h2v2zM9 12h-2v-2h2v2zM9 9h-2v-2h2v2zM9 6h-2v-2h2v2zM9 3h-2v-2h2v2zM12 12h-2v-2h2v2zM12 9h-2v-2h2v2zM12 6h-2v-2h2v2zM12 3h-2v-2h2v2z"></path></g>
<g id="vaadin:bullets"><path d="M0 2.5v0c0 0.8 0.7 1.5 1.5 1.5v0c0.8 0 1.5-0.7 1.5-1.5v0c0-0.8-0.7-1.5-1.5-1.5v0c-0.8 0-1.5 0.7-1.5 1.5z"></path><path d="M0 7.5v0c0 0.8 0.7 1.5 1.5 1.5v0c0.8 0 1.5-0.7 1.5-1.5v0c0-0.8-0.7-1.5-1.5-1.5v0c-0.8 0-1.5 0.7-1.5 1.5z"></path><path d="M0 12.5v0c0 0.8 0.7 1.5 1.5 1.5v0c0.8 0 1.5-0.7 1.5-1.5v0c0-0.8-0.7-1.5-1.5-1.5v0c-0.8 0-1.5 0.7-1.5 1.5z"></path><path d="M5 1h11v3h-11v-3z"></path><path d="M5 6h11v3h-11v-3z"></path><path d="M5 11h11v3h-11v-3z"></path></g>
<g id="vaadin:bullseye"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM8 14.9c-3.8 0-6.9-3.1-6.9-6.9s3.1-6.9 6.9-6.9 6.9 3.1 6.9 6.9-3.1 6.9-6.9 6.9z"></path><path d="M8 2.3c-3.2 0-5.7 2.5-5.7 5.7s2.6 5.7 5.7 5.7 5.7-2.6 5.7-5.7-2.5-5.7-5.7-5.7zM8 12.6c-2.5 0-4.6-2.1-4.6-4.6s2.1-4.6 4.6-4.6 4.6 2.1 4.6 4.6c0 2.5-2.1 4.6-4.6 4.6z"></path><path d="M8 4.6c-1.9 0-3.4 1.5-3.4 3.4s1.5 3.4 3.4 3.4c1.9 0 3.4-1.5 3.4-3.4s-1.5-3.4-3.4-3.4z"></path></g>
<g id="vaadin:bus"><path d="M14.67 4h-0.67v-2c0-1.105-0.895-2-2-2h-8c-1.105 0-2 0.895-2 2v2h-0.68c-0 0-0 0-0 0-0.177 0-0.32 0.143-0.32 0.32 0 0.004 0 0.007 0 0.011l-0 2.339c-0 0.003-0 0.006-0 0.010 0 0.177 0.143 0.32 0.32 0.32 0 0 0 0 0 0h0.68v6c0 0.55 0 1 1 1v1.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-1.5h4v1.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-1.5c1 0 1-0.45 1-1v-6h0.67c0.182 0 0.33-0.148 0.33-0.33s-0.148-0.33-0.33-0.33c-0.182 0-0.33 0.148-0.33 0.33s0.148 0.33 0.33 0.33c0.182 0 0.33-0.148 0.33-0.33v-2.34c0-0.182-0.148-0.33-0.33-0.33 0 0 0 0 0 0zM6 1h4v1h-4v-1zM4 12c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM3 8v-5h10v5h-10zM12 12c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z"></path></g>
<g id="vaadin:buss"><path d="M14.67 4h-0.67v-2c0-1.105-0.895-2-2-2h-8c-1.105 0-2 0.895-2 2v2h-0.68c-0 0-0 0-0 0-0.177 0-0.32 0.143-0.32 0.32 0 0.004 0 0.007 0 0.011l-0 2.339c-0 0.003-0 0.006-0 0.010 0 0.177 0.143 0.32 0.32 0.32 0 0 0 0 0 0h0.68v6c0 0.55 0 1 1 1v1.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-1.5h4v1.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-1.5c1 0 1-0.45 1-1v-6h0.67c0.182 0 0.33-0.148 0.33-0.33s-0.148-0.33-0.33-0.33c-0.182 0-0.33 0.148-0.33 0.33s0.148 0.33 0.33 0.33c0.182 0 0.33-0.148 0.33-0.33v-2.34c0-0.182-0.148-0.33-0.33-0.33 0 0 0 0 0 0zM6 1h4v1h-4v-1zM4 12c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM3 8v-5h10v5h-10zM12 12c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z"></path></g>
<g id="vaadin:button"><path d="M15.7 5.3l-1-1c-0.2-0.2-0.4-0.3-0.7-0.3h-13c-0.6 0-1 0.4-1 1v5c0 0.3 0.1 0.6 0.3 0.7l1 1c0.2 0.2 0.4 0.3 0.7 0.3h13c0.6 0 1-0.4 1-1v-5c0-0.3-0.1-0.5-0.3-0.7zM14 10h-13v-5h13v5z"></path></g>
<g id="vaadin:calc-book"><path d="M11.9 0c-1.3 0-2 0.4-2.4 0.8-0.4-0.4-1.1-0.8-2.5-0.8-3.4 0-4 2-4 2v0 0 4h-3v10h7v-4.6l1.5-0.2c0 0 0.2-0.3 0.3 0.7h1.3c0.1-1 0.4-0.7 0.4-0.7l5.5 0.7v-9.8c0 0-0.6-2.1-4.1-2.1zM1 7h5v2h-5v-2zM6 10v1h-1v-1h1zM4 10v1h-1v-1h1zM2 15h-1v-1h1v1zM2 13h-1v-1h1v1zM2 11h-1v-1h1v1zM4 15h-1v-1h1v1zM4 13h-1v-1h1v1zM6 15h-1v-1h1v1zM6 13h-1v-1h1v1zM9 9.5c-0.9-0.1-1.3-0.3-2-0.3v-3.2h-3v-3.9c0-0.4 0.8-1.5 3-1.5 1.8 0 1.9 0.8 1.9 1 0 0 0 0 0 0v7.9zM15 9.9c-1-0.4-1.1-0.7-2.5-0.7-0.1 0-0.2 0-0.2 0-1 0-1.3 0.2-2.3 0.4v-7.6c0 0 0-0.1 0-0.1s0-0.1 0-0.1c0-0.2 0.2-1.1 1.9-1.1 2.3 0 3.1 0.9 3.1 1.4v7.8z"></path></g>
<g id="vaadin:calc"><path d="M9 3h6v2h-6v-2z"></path><path d="M9 11h6v2h-6v-2z"></path><path d="M5 1h-2v2h-2v2h2v2h2v-2h2v-2h-2z"></path><path d="M7 10.4l-1.4-1.4-1.6 1.6-1.6-1.6-1.4 1.4 1.6 1.6-1.6 1.6 1.4 1.4 1.6-1.6 1.6 1.6 1.4-1.4-1.6-1.6z"></path><path d="M13 14.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M13 9.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path></g>
<g id="vaadin:calendar-briefcase"><path d="M3 0h1v3h-1v-3z"></path><path d="M11 0h1v3h-1v-3z"></path><path d="M13 1v3h-3v-3h-5v3h-3v-3h-2v14h5v-1h-4v-8h13v3h1v-8z"></path><path d="M13 10v-2h-4v2h-3v6h10v-6h-3zM10 9h2v1h-2v-1z"></path></g>
<g id="vaadin:calendar-clock"><path d="M3 0h1v3h-1v-3z"></path><path d="M11 0h1v3h-1v-3z"></path><path d="M6.6 14h-5.6v-8h13v0.6c0.4 0.2 0.7 0.4 1 0.7v-6.3h-2v3h-3v-3h-5v3h-3v-3h-2v14h7.3c-0.3-0.3-0.5-0.6-0.7-1z"></path><path d="M14 12h-3v-3h1v2h2z"></path><path d="M11.5 8c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5-3.5-1.6-3.5-3.5 1.6-3.5 3.5-3.5zM11.5 7c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2-4.5-4.5-4.5v0z"></path></g>
<g id="vaadin:calendar-envelope"><path d="M3 0h1v2h-1v-2z"></path><path d="M9 0h1v2h-1v-2z"></path><path d="M13 7v-6h-2v2h-3v-2h-3v2h-3v-2h-2v12h4v3h12v-9h-3zM4 12h-3v-7h11v2h-8v5zM5 10.2l2.6 1.5-2.6 2.6v-4.1zM5.7 15l2.8-2.8 1.5 0.9 1.5-0.8 2.8 2.8h-8.6zM15 14.3l-2.6-2.6 2.6-1.4v4zM15 9.2l-5 2.7-5-2.9v-1h10v1.2zM15.4 9.6v0 0 0z"></path></g>
<g id="vaadin:calendar-o"><path d="M14 1v3h-3v-3h-6v3h-3v-3h-2v15h16v-15h-2zM15 15h-14v-9h14v9z"></path><path d="M3 0h1v3h-1v-3z"></path><path d="M12 0h1v3h-1v-3z"></path></g>
<g id="vaadin:calendar-user"><path d="M3 0h1v3h-1v-3z"></path><path d="M11 0h1v3h-1v-3z"></path><path d="M9 14.1c0-0.1 0-0.1 0 0l-8-0.1v-8h13v1.2c0.4 0.1 0.7 0.3 1 0.6v-6.8h-2v3h-3v-3h-5v3h-3v-3h-2v14h9v-0.9z"></path><path d="M15 10c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M13.9 12h-1.8c-1.1 0-2.1 0.9-2.1 2.1v1.9h6v-1.9c0-1.2-0.9-2.1-2.1-2.1z"></path></g>
<g id="vaadin:calendar"><path d="M14 1v3h-3v-3h-6v3h-3v-3h-2v15h16v-15h-2zM3 15h-2v-2h2v2zM3 12h-2v-2h2v2zM3 9h-2v-2h2v2zM6 15h-2v-2h2v2zM6 12h-2v-2h2v2zM6 9h-2v-2h2v2zM9 15h-2v-2h2v2zM9 12h-2v-2h2v2zM9 9h-2v-2h2v2zM12 15h-2v-2h2v2zM12 12h-2v-2h2v2zM12 9h-2v-2h2v2zM15 15h-2v-2h2v2zM15 12h-2v-2h2v2zM15 9h-2v-2h2v2z"></path><path d="M3 0h1v3h-1v-3z"></path><path d="M12 0h1v3h-1v-3z"></path></g>
<g id="vaadin:camera"><path d="M11 9c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path><path d="M11 4v-3h-6v3h-5v9h5c0.8 0.6 1.9 1 3 1s2.2-0.4 3-1h5v-9h-5zM6 2h4v2h-4v-2zM8 13c-2.2 0-4-1.8-4-4s1.8-4 4-4c2.2 0 4 1.8 4 4s-1.8 4-4 4zM15 6h-2v-1h2v1z"></path></g>
<g id="vaadin:car"><path d="M15 6.1l-1.4-2.9c-0.4-0.7-1.1-1.2-1.9-1.2h-7.4c-0.8 0-1.5 0.5-1.9 1.2l-1.4 2.9c-0.6 0.1-1 0.6-1 1.1v3.5c0 0.6 0.4 1.1 1 1.2v2c0 0.6 0.5 1.1 1.1 1.1h0.9c0.5 0 1-0.5 1-1.1v-1.9h8v1.9c0 0.6 0.5 1.1 1.1 1.1h0.9c0.6 0 1.1-0.5 1.1-1.1v-2c0.6-0.1 1-0.6 1-1.2v-3.5c-0.1-0.5-0.5-1-1.1-1.1zM4 8.4c0 0.3-0.3 0.6-0.6 0.6h-1.8c-0.3 0-0.6-0.3-0.6-0.6v-0.8c0-0.3 0.3-0.6 0.6-0.6h1.8c0.3 0 0.6 0.3 0.6 0.6v0.8zM10 11h-4v-1h4v1zM2.1 6l1.2-2.4c0.2-0.4 0.6-0.6 1-0.6h7.4c0.4 0 0.8 0.2 1 0.6l1.2 2.4h-11.8zM15 8.4c0 0.3-0.3 0.6-0.6 0.6h-1.8c-0.3 0-0.6-0.3-0.6-0.6v-0.8c0-0.3 0.3-0.6 0.6-0.6h1.8c0.3 0 0.6 0.3 0.6 0.6v0.8z"></path></g>
<g id="vaadin:caret-down"><path d="M3 4h10l-5 7z"></path></g>
<g id="vaadin:caret-left"><path d="M11 3v10l-7-5z"></path></g>
<g id="vaadin:caret-right"><path d="M5 13v-10l7 5z"></path></g>
<g id="vaadin:caret-square-down-o"><path d="M15 1h-14v14h14v-14zM14 14h-12v-12h12v12z"></path><path d="M4 6h8l-4 5z"></path></g>
<g id="vaadin:caret-square-left-o"><path d="M15 1h-14v14h14v-14zM14 14h-12v-12h12v12z"></path><path d="M10 4v8l-5-4z"></path></g>
<g id="vaadin:caret-square-right-o"><path d="M15 1h-14v14h14v-14zM14 14h-12v-12h12v12z"></path><path d="M5.9 12v-8l5 4z"></path></g>
<g id="vaadin:caret-square-up-o"><path d="M15 1h-14v14h14v-14zM14 14h-12v-12h12v12z"></path><path d="M12 10h-8l4-5z"></path></g>
<g id="vaadin:caret-up"><path d="M13 12h-10l5-7z"></path></g>
<g id="vaadin:cart-o"><path d="M14 13.1v-1.1h-9.4l0.6-1.1 9.2-0.9 1.6-6h-12.3l-0.7-3h-3v1h2.2l2.1 8.4-1.3 2.6v1.5c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5-0.7-1.5-1.5-1.5h7.5v1.5c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5c0-0.7-0.4-1.2-1-1.4zM4 5h10.7l-1.1 4-8.4 0.9-1.2-4.9z"></path></g>
<g id="vaadin:cart"><path d="M14 13.1v-1.1h-9.4l0.6-1.1 9.2-0.9 1.6-6h-12.3l-0.7-3h-3v1h2.2l2.1 8.4-1.3 2.6v1.5c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5-0.7-1.5-1.5-1.5h7.5v1.5c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5c0-0.7-0.4-1.2-1-1.4z"></path></g>
<g id="vaadin:cash"><path d="M16 14h-14v-1h13v-7h1v8z"></path><path d="M13 4v7h-12v-7h12zM14 3h-14v9h14v-9z"></path><path d="M3 6h-1v3h1v1h4c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5h-4v1z"></path><path d="M11 6v-1h-4c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5h4v-1h1v-3h-1z"></path></g>
<g id="vaadin:chart-3d"><path d="M12 4v-2l-4-2-4 2v1l-4 2v5l12 6 4-2v-8zM4 10.88l-3-1.5v-3.3l3 1.53v3.27zM4 6.49l-2.34-1.2 2.34-1.17v2.37zM8 12.88l-3-1.5v-8.31l3 1.54v8.27zM5.66 2.29l2.34-1.17 2.34 1.17-2.34 1.2zM12 14.88l-3-1.5v-6.31l3 1.54v6.27zM12 7.49l-2.34-1.2 2.34-1.17 2.34 1.17z"></path></g>
<g id="vaadin:chart-grid"><path d="M0 9v7h16v-7h-16zM5 15h-4v-1h4v1zM5 13h-4v-1h4v1zM5 11h-4v-1h4v1zM10 15h-4v-1h4v1zM10 13h-4v-1h4v1zM10 11h-4v-1h4v1zM15 15h-4v-1h4v1zM15 13h-4v-1h4v1zM15 11h-4v-1h4v1z"></path><path d="M16 8h-16v-8h1v7h15v1z"></path><path d="M15 1.57l-5.020 2.86-3.96-1.98-4.020 1.61v1.080l3.98-1.59 4.040 2.020 4.98-2.85v-1.15z"></path></g>
<g id="vaadin:chart-line"><path d="M0 16h16v-16h-1v2.6l-4 3.4v-6h-1v6.4l-4-0.9v-5.5h-1v5.7l-4 2.9v-8.6h-1zM5 14h-4v-1.7l4-2.9v4.6zM10 14h-4v-5.3l0.1-0.1 3.9 0.9v4.5zM15 14h-4v-4.3h0.1l3.9-3.2v7.5z"></path></g>
<g id="vaadin:chart-timeline"><path d="M16 13v-1h-15v-12h-1v13h5v2h-5v1h16v-1h-5v-2h5z"></path><path d="M9 7l-3-3-4 4v3h14v-11l-7 7z"></path></g>
<g id="vaadin:chart"><path d="M0 15h16v1h-16v-1z"></path><path d="M0 0h1v16h-1v-16z"></path><path d="M9 8l-2.9-3-4.1 4v5h14v-13.1z"></path></g>
<g id="vaadin:chat"><path d="M14 14.2c0 0 0 0 0 0 0-0.6 2-1.8 2-3.1 0-1.5-1.4-2.7-3.1-3.2 0.7-0.8 1.1-1.7 1.1-2.8 0-2.8-2.9-5.1-6.6-5.1-3.5 0-7.4 2.1-7.4 5.1 0 2.1 1.6 3.6 2.3 4.2-0.1 1.2-0.6 1.7-0.6 1.7l-1.2 1h1.5c1.6 0 2.9-0.5 3.7-1.1 0 0.1 0 0.1 0 0.2 0 2 2.2 3.6 5 3.6 0.2 0 0.4 0 0.6 0 0.4 0.5 1.7 1.4 3.4 1.4 0.1-0.1-0.7-0.5-0.7-1.9zM7.4 1c3.1 0 5.6 1.9 5.6 4.1s-2.6 4.1-5.8 4.1c-0.2 0-0.6 0-0.8 0h-0.3l-0.1 0.2c-0.3 0.4-1.5 1.2-3.1 1.5 0.1-0.4 0.1-1 0.1-1.8v-0.3c-1-0.8-2.1-2.2-2.1-3.6 0-2.2 3.2-4.2 6.5-4.2z"></path></g>
<g id="vaadin:check-circle-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M7.1 11.7l-4.2-4.1 1.4-1.4 2.8 2.7 4.9-4.9 1.4 1.4z"></path></g>
<g id="vaadin:check-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7.1 11.7l-4.2-4.1 1.4-1.4 2.7 2.7 5-4.9 1.4 1.4-6.3 6.3z"></path></g>
<g id="vaadin:check-square-o"><path d="M14 6.2v7.8h-12v-12h10.5l1-1h-12.5v14h14v-9.8z"></path><path d="M7.9 10.9l-4.2-4.2 1.5-1.4 2.7 2.8 6.7-6.7 1.4 1.4z"></path></g>
<g id="vaadin:check-square"><path d="M13 0.9l-1 1.1h-12v14h14v-10.5l1.7-2-2.7-2.6zM6.5 11.7l-4.2-4.2 1.4-1.4 2.7 2.7 6.6-6.6 1.4 1.4-7.9 8.1z"></path></g>
<g id="vaadin:check"><path d="M7.3 14.2l-7.1-5.2 1.7-2.4 4.8 3.5 6.6-8.5 2.3 1.8z"></path></g>
<g id="vaadin:chevron-circle-down-o"><path d="M13 6.6l-5 5-5-5 1.4-1.4 3.6 3.6 3.6-3.6z"></path><path d="M1 8c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7-7-3.1-7-7zM0 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8v0z"></path></g>
<g id="vaadin:chevron-circle-down"><path d="M0 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8zM11.6 5.2l1.4 1.4-5 5-5-5 1.4-1.4 3.6 3.6 3.6-3.6z"></path></g>
<g id="vaadin:chevron-circle-left-o"><path d="M9.4 13l-5-5 5-5 1.4 1.4-3.6 3.6 3.6 3.6z"></path><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path></g>
<g id="vaadin:chevron-circle-left"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM10.8 11.6l-1.4 1.4-5-5 5-5 1.4 1.4-3.6 3.6 3.6 3.6z"></path></g>
<g id="vaadin:chevron-circle-right-o"><path d="M6.6 13l5-5-5-5-1.4 1.4 3.6 3.6-3.6 3.6z"></path><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path></g>
<g id="vaadin:chevron-circle-right"><path d="M8 16c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8zM5.2 4.4l1.4-1.4 5 5-5 5-1.4-1.4 3.6-3.6-3.6-3.6z"></path></g>
<g id="vaadin:chevron-circle-up-o"><path d="M3 9.4l5-5 5 5-1.4 1.4-3.6-3.6-3.6 3.6z"></path><path d="M15 8c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7zM16 8c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8v0z"></path></g>
<g id="vaadin:chevron-circle-up"><path d="M16 8c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8zM4.4 10.8l-1.4-1.4 5-5 5 5-1.4 1.4-3.6-3.6-3.6 3.6z"></path></g>
<g id="vaadin:chevron-down-small"><path d="M8 12l-6.32-6.32 1.67-1.68 4.65 4.65 4.65-4.65 1.67 1.68-6.32 6.32z"></path></g>
<g id="vaadin:chevron-down"><path d="M8 13.1l-8-8 2.1-2.2 5.9 5.9 5.9-5.9 2.1 2.2z"></path></g>
<g id="vaadin:chevron-left-small"><path d="M4 8l6.32-6.32 1.68 1.67-4.65 4.65 4.65 4.65-1.68 1.67-6.32-6.32z"></path></g>
<g id="vaadin:chevron-left"><path d="M2.9 8l8-8 2.2 2.1-5.9 5.9 5.9 5.9-2.2 2.1z"></path></g>
<g id="vaadin:chevron-right-small"><path d="M12 8l-6.32-6.32-1.68 1.67 4.65 4.65-4.65 4.65 1.68 1.67 6.32-6.32z"></path></g>
<g id="vaadin:chevron-right"><path d="M13.1 8l-8 8-2.2-2.1 5.9-5.9-5.9-5.9 2.2-2.1z"></path></g>
<g id="vaadin:chevron-up-small"><path d="M8 4l-6.32 6.32 1.67 1.68 4.65-4.65 4.65 4.65 1.67-1.68-6.32-6.32z"></path></g>
<g id="vaadin:chevron-up"><path d="M8 2.9l8 8-2.1 2.2-5.9-5.9-5.9 5.9-2.1-2.2z"></path></g>
<g id="vaadin:child"><path d="M10 5c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M12.79 10.32l-2.6-2.63c-0.421-0.426-1.004-0.69-1.65-0.69h-1.070c-0 0-0 0-0.001 0-0.648 0-1.235 0.264-1.659 0.69l-2.6 2.63c-0.216 0.129-0.358 0.362-0.358 0.628 0 0.403 0.327 0.73 0.73 0.73 0.266 0 0.499-0.142 0.626-0.355l1.792-1.793v6.47h1.5v-4h1v4h1.5v-6.47l1.75 1.8c0.135 0.175 0.344 0.287 0.58 0.287 0.403 0 0.73-0.327 0.73-0.73 0-0.228-0.105-0.432-0.269-0.566z"></path></g>
<g id="vaadin:circle-thin"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path></g>
<g id="vaadin:circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"></path></g>
<g id="vaadin:clipboard-check"><path d="M11 1v-1h-6v1h-2v1h-1v14h12v-1h1v-14h-4zM6 1h4v2h-4v-2zM13 15h-10v-12h2v1h6v-1h2v12z"></path><path d="M7.39 12.47l-3-2.73 1.35-1.48 1.58 1.44 2.87-2.9 1.42 1.4-4.22 4.27z"></path></g>
<g id="vaadin:clipboard-cross"><path d="M11 1v-1h-6v1h-2v1h-1v14h12v-1h1v-14h-4zM6 1h4v2h-4v-2zM13 15h-10v-12h2v1h6v-1h2v12z"></path><path d="M11 8h-2v-2h-2v2h-2v2h2v2h2v-2h2z"></path></g>
<g id="vaadin:clipboard-heart"><path d="M9.5 7c0 0 0 0 0 0-0.6 0-1.1 0.6-1.5 1-0.4-0.4-0.9-1-1.5-1 0 0 0 0 0 0-1.5 0-2.1 1.9-1 2.9l2.5 2.1 2.5-2.1c1.1-1 0.5-2.9-1-2.9z"></path><path d="M11 1v-1h-6v1h-2v1h-1v14h12v-1h1v-14h-4zM6 1h4v2h-4v-2zM13 15h-10v-12h2v1h6v-1h2v12z"></path></g>
<g id="vaadin:clipboard-pulse"><path d="M11 1v-1h-6v1h-2v1h-1v14h12v-1h1v-14h-4zM6 1h4v2h-4v-2zM13 15h-10v-12h2v1h6v-1h2v12z"></path><path d="M9.3 13c0 0 0 0 0 0-0.2 0-0.3-0.1-0.4-0.3l-0.8-4.8-0.7 3.1c0 0.1-0.1 0.2-0.3 0.3-0.1 0-0.3 0-0.4-0.1l-1-1.3h-1.3c-0.2 0-0.4-0.2-0.4-0.4s0.2-0.4 0.4-0.4h1.6c0.1 0 0.2 0.1 0.3 0.1l0.6 0.8 0.9-4.3c0-0.2 0.2-0.3 0.4-0.3 0 0 0 0 0 0 0.2 0 0.3 0.2 0.3 0.4l0.9 5.3 0.6-1.7c0.1-0.1 0.2-0.2 0.3-0.2h1.3c0.2 0 0.4 0.2 0.4 0.4s-0.2 0.4-0.4 0.4h-1l-1 2.9c0 0-0.2 0.1-0.3 0.1z"></path></g>
<g id="vaadin:clipboard-text"><path d="M4 6h8v1h-8v-1z"></path><path d="M4 8h8v1h-8v-1z"></path><path d="M4 10h5v1h-5v-1z"></path><path d="M11 1v-1h-6v1h-2v1h-1v14h12v-1h1v-14h-4zM6 1h4v2h-4v-2zM13 15h-10v-12h2v1h6v-1h2v12z"></path></g>
<g id="vaadin:clipboard-user"><path d="M11 1v-1h-6v1h-2v1h-1v14h12v-1h1v-14h-4zM6 1h4v2h-4v-2zM13 15h-10v-12h2v1h6v-1h2v12z"></path><path d="M8 6c-2.5 0-1.3 3.2-1.3 3.2 0.3 0.4 0.7 0.4 0.7 0.6 0 0.3-0.3 0.3-0.6 0.4-0.5 0.1-0.9-0.1-1.4 0.8-0.3 0.4-0.4 2-0.4 2h6c0 0-0.1-1.6-0.4-2-0.4-0.8-0.9-0.7-1.4-0.8-0.3 0-0.6-0.1-0.6-0.4s0.3-0.2 0.6-0.6c0.1 0 1.3-3.2-1.2-3.2z"></path></g>
<g id="vaadin:clipboard"><path d="M11 1v-1h-6v1h-2v1h-1v14h12v-1h1v-14h-4zM6 1h4v2h-4v-2zM13 15h-10v-12h2v1h6v-1h2v12z"></path></g>
<g id="vaadin:clock"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM8 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"></path><path d="M8 3h-1v6h5v-1h-4z"></path></g>
<g id="vaadin:close-big"><path d="M16 0l-1 0.010-7 6.99-7-6.99-1-0.010v1l7 7-7 7v1h1l7-7 7 7h1v-1l-7-7 7-7v-1z"></path></g>
<g id="vaadin:close-circle-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M12.2 10.8l-2.8-2.8 2.8-2.8-1.4-1.4-2.8 2.8-2.8-2.8-1.4 1.4 2.8 2.8-2.8 2.8 1.4 1.4 2.8-2.8 2.8 2.8z"></path></g>
<g id="vaadin:close-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM12.2 10.8l-1.4 1.4-2.8-2.8-2.8 2.8-1.4-1.4 2.8-2.8-2.8-2.8 1.4-1.4 2.8 2.8 2.8-2.8 1.4 1.4-2.8 2.8 2.8 2.8z"></path></g>
<g id="vaadin:close-small"><path d="M12.96 4.46l-1.42-1.42-3.54 3.55-3.54-3.55-1.42 1.42 3.55 3.54-3.55 3.54 1.42 1.42 3.54-3.55 3.54 3.55 1.42-1.42-3.55-3.54 3.55-3.54z"></path></g>
<g id="vaadin:close"><path d="M15.1 3.1l-2.2-2.2-4.9 5-4.9-5-2.2 2.2 5 4.9-5 4.9 2.2 2.2 4.9-5 4.9 5 2.2-2.2-5-4.9z"></path></g>
<g id="vaadin:cloud-download-o"><path d="M14.1 9.8c0-0.2 0-0.4 0-0.6 0-2.4-1.9-4.3-4.2-4.3-0.3 0.1-0.6 0.1-0.9 0.1v-3h-2v2.4c-0.4-0.3-0.9-0.4-1.3-0.4-1.6 0-2.9 1.3-2.9 2.9 0 0.3 0.1 0.6 0.2 0.9-1.6 0.2-3 1.8-3 3.6 0 1.9 1.5 3.6 3.3 3.6h10.3c1.4 0 2.4-1.5 2.4-2.7s-0.8-2.3-1.9-2.5zM13.6 14h-10.3c-1.2 0-2.3-1.3-2.3-2.6s1.1-2.6 2.3-2.6c0.1 0 0.3 0 0.4 0l1.4 0.2-0.9-1c-0.2-0.3-0.4-0.7-0.4-1.2 0-1 0.8-1.8 1.8-1.8 0.5 0 1 0.2 1.3 0.6v2.4h-1.9l3 4 3-4h-2v-1.9c0.3-0.1 0.6-0.1 0.9-0.1 1.8 0 3.2 1.5 3.2 3.3 0 0.3 0 0.6-0.1 0.9l-0.2 0.6 0.8 0.1c0.7 0 1.4 0.7 1.4 1.5 0 0.7-0.6 1.6-1.4 1.6z"></path></g>
<g id="vaadin:cloud-download"><path d="M14 10c0 0-0.1 0-0.1 0 0-0.3 0.1-0.6 0.1-1 0-2.2-1.8-4-4-4v-4h-4v3.1c-0.2-0.1-0.3-0.1-0.5-0.1-1.4 0-2.5 1.1-2.5 2.5 0 0.6 0.2 1.1 0.6 1.6-0.2-0.1-0.4-0.1-0.6-0.1-1.7 0-3 1.3-3 3s1.3 3 3 3h11c1.1 0 2-0.9 2-2s-0.9-2-2-2zM8 11.4l-2.9-3.4h1.9v-6h2v6h1.9l-2.9 3.4z"></path></g>
<g id="vaadin:cloud-o"><path d="M14.1 8.9c0-0.2 0-0.4 0-0.6 0-2.4-1.9-4.3-4.2-4.3-0.6 0-1.2 0.1-1.8 0.4-0.5-0.7-1.5-1.2-2.4-1.2-1.6 0-2.9 1.2-2.9 2.8 0 0.3 0.1 0.6 0.2 0.9-1.6 0.2-3 1.8-3 3.5 0 1.9 1.5 3.6 3.3 3.6h10.3c1.4 0 2.4-1.4 2.4-2.6s-0.8-2.2-1.9-2.5zM13.6 13h-10.3c-1.2 0-2.3-1.2-2.3-2.5s1.1-2.5 2.3-2.5c0.1 0 0.3 0 0.4 0l1.3 0.3-0.8-1.2c-0.2-0.3-0.4-0.7-0.4-1.1 0-1 0.8-1.8 1.8-1.8 0.8 0 1.5 0.5 1.7 1.2l0.3 0.6 0.5-0.3c0.5-0.3 1.1-0.5 1.8-0.5 1.8 0 3.2 1.5 3.2 3.3 0 0.3 0 0.6-0.1 0.9l-0.2 0.6h0.8c0.7 0 1.4 0.7 1.4 1.5 0 0.6-0.6 1.5-1.4 1.5z"></path></g>
<g id="vaadin:cloud-upload-o"><path d="M14.1 10.9c0-0.2 0-0.4 0-0.6 0-2.4-1.9-4.3-4.2-4.3-0.3 0-0.6 0-0.9 0.1v-2.1h2l-3-4-3 4h2v1.5c-0.4-0.2-0.9-0.3-1.3-0.3-1.6 0-2.9 1.2-2.9 2.8 0 0.3 0.1 0.6 0.2 0.9-1.6 0.2-3 1.8-3 3.5 0 1.9 1.5 3.6 3.3 3.6h10.3c1.4 0 2.4-1.4 2.4-2.6s-0.8-2.2-1.9-2.5zM13.6 15h-10.3c-1.2 0-2.3-1.2-2.3-2.5s1.1-2.5 2.3-2.5c0.1 0 0.3 0 0.4 0l1.3 0.3-0.8-1.2c-0.2-0.3-0.4-0.7-0.4-1.1 0-1 0.8-1.8 1.8-1.8 0.5 0 1 0.2 1.3 0.6v3.2h2v-2.8c0.3-0.1 0.6-0.1 0.9-0.1 1.8 0 3.2 1.5 3.2 3.3 0 0.3 0 0.6-0.1 0.9l-0.2 0.6h0.8c0.7 0 1.4 0.7 1.4 1.5 0.1 0.7-0.5 1.6-1.3 1.6z"></path></g>
<g id="vaadin:cloud-upload"><path d="M14 10c0 0-0.1 0-0.1 0 0-0.3 0.1-0.6 0.1-1 0-1.6-1-3-2.4-3.6l-3.6-4.4-2.5 3c-1.4 0-2.5 1.1-2.5 2.5 0 0.6 0.2 1.1 0.6 1.6-0.2-0.1-0.4-0.1-0.6-0.1-1.7 0-3 1.3-3 3s1.3 3 3 3h11c1.1 0 2-0.9 2-2s-0.9-2-2-2zM9 6v6h-2v-6h-1.9l2.9-3.4 2.9 3.4h-1.9z"></path></g>
<g id="vaadin:cloud"><path d="M14 13c1.1 0 2-0.9 2-2s-0.9-2-2-2c0 0-0.1 0-0.1 0 0-0.3 0.1-0.6 0.1-1 0-2.2-1.8-4-4-4-0.8 0-1.5 0.2-2.2 0.6-0.3-0.9-1.2-1.6-2.3-1.6-1.4 0-2.5 1.1-2.5 2.5 0 0.6 0.2 1.1 0.6 1.6-0.2-0.1-0.4-0.1-0.6-0.1-1.7 0-3 1.3-3 3s1.3 3 3 3h11z"></path></g>
<g id="vaadin:cluster"><path d="M14 12c-0.372 0.011-0.716 0.121-1.008 0.305l-2.212-2.155c0.434-0.547 0.708-1.239 0.74-1.993l1.57-0.157c0.225 0.556 0.76 0.941 1.385 0.941 0.823 0 1.49-0.667 1.49-1.49s-0.667-1.49-1.49-1.49c-0.749 0-1.368 0.552-1.474 1.271l-1.591 0.128c-0.224-1.136-0.973-2.060-1.978-2.521l0.308-0.839h0.26c1.099-0.008 1.986-0.9 1.986-2 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.742 0.404 1.39 1.004 1.735l-0.27 0.855c-0.227-0.054-0.487-0.084-0.754-0.084-0.83 0-1.59 0.296-2.181 0.789l-2.994-3.004c0.141-0.224 0.225-0.497 0.225-0.79 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.823 0.663 1.492 1.484 1.5 0.281-0.001 0.544-0.079 0.767-0.214l2.993 3.004c-0.474 0.588-0.76 1.344-0.76 2.168 0 0.015 0 0.030 0 0.045-0 0.058-0 0.108-0 0.158l-0.66 0.11c-0.313-0.72-1.019-1.214-1.839-1.214-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2 0-0.020-0-0.039-0.001-0.059l0.63-0.097c0.242 0.843 0.768 1.538 1.466 1.992l-0.556 1.188c-0.161-0.049-0.347-0.078-0.539-0.080-0.006-0-0.012-0-0.017-0-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2 0-0.64-0.301-1.211-0.769-1.577l0.566-1.153c0.364 0.146 0.787 0.231 1.229 0.231 0.847 0 1.621-0.311 2.216-0.824l2.176 2.124c-0.25 0.33-0.4 0.748-0.4 1.2 0 1.105 0.895 2 2 2s2-0.895 2-2c0-1.105-0.895-2-2-2 0 0 0 0 0 0zM5 15c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM8 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5z"></path></g>
<g id="vaadin:code"><path d="M5.2 14l4.5-12h1.1l-4.5 12z"></path><path d="M11.1 13h1.2l3.7-5-3.7-5h-1.3l3.8 5z"></path><path d="M4.9 13h-1.2l-3.7-5 3.7-5h1.3l-3.8 5z"></path></g>
<g id="vaadin:coffee"><path d="M14 13l-4 1h-6l-4-1v-1h14z"></path><path d="M14.7 3h-1.7v-1h-12v5c0 1.5 0.8 2.8 2 3.4v0.6h8v-0.6c0.9-0.5 1.6-1.4 1.9-2.4 0 0 0.1 0 0.1 0 2.3 0 2.9-2 3-3.5 0.1-0.8-0.5-1.5-1.3-1.5zM13 7v-3h1.7c0.1 0 0.2 0.1 0.2 0.1s0.1 0.1 0.1 0.3c-0.2 2.6-1.6 2.6-2 2.6z"></path></g>
<g id="vaadin:cog-o"><path d="M15.2 6l-1.1-0.2c-0.1-0.2-0.1-0.4-0.2-0.6l0.6-0.9 0.5-0.7-2.6-2.6-0.7 0.5-0.9 0.6c-0.2-0.1-0.4-0.1-0.6-0.2l-0.2-1.1-0.2-0.8h-3.6l-0.2 0.8-0.2 1.1c-0.2 0.1-0.4 0.1-0.6 0.2l-0.9-0.6-0.7-0.4-2.5 2.5 0.5 0.7 0.6 0.9c-0.2 0.2-0.2 0.4-0.3 0.6l-1.1 0.2-0.8 0.2v3.6l0.8 0.2 1.1 0.2c0.1 0.2 0.1 0.4 0.2 0.6l-0.6 0.9-0.5 0.7 2.6 2.6 0.7-0.5 0.9-0.6c0.2 0.1 0.4 0.1 0.6 0.2l0.2 1.1 0.2 0.8h3.6l0.2-0.8 0.2-1.1c0.2-0.1 0.4-0.1 0.6-0.2l0.9 0.6 0.7 0.5 2.6-2.6-0.5-0.7-0.6-0.9c0.1-0.2 0.2-0.4 0.2-0.6l1.1-0.2 0.8-0.2v-3.6l-0.8-0.2zM15 9l-1.7 0.3c-0.1 0.5-0.3 1-0.6 1.5l0.9 1.4-1.4 1.4-1.4-0.9c-0.5 0.3-1 0.5-1.5 0.6l-0.3 1.7h-2l-0.3-1.7c-0.5-0.1-1-0.3-1.5-0.6l-1.4 0.9-1.4-1.4 0.9-1.4c-0.3-0.5-0.5-1-0.6-1.5l-1.7-0.3v-2l1.7-0.3c0.1-0.5 0.3-1 0.6-1.5l-1-1.4 1.4-1.4 1.4 0.9c0.5-0.3 1-0.5 1.5-0.6l0.4-1.7h2l0.3 1.7c0.5 0.1 1 0.3 1.5 0.6l1.4-0.9 1.4 1.4-0.9 1.4c0.3 0.5 0.5 1 0.6 1.5l1.7 0.3v2z"></path><path d="M8 4.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5c0-1.9-1.6-3.5-3.5-3.5zM8 10.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5z"></path></g>
<g id="vaadin:cog"><path d="M16 9v-2l-1.7-0.6c-0.2-0.6-0.4-1.2-0.7-1.8l0.8-1.6-1.4-1.4-1.6 0.8c-0.5-0.3-1.1-0.6-1.8-0.7l-0.6-1.7h-2l-0.6 1.7c-0.6 0.2-1.2 0.4-1.7 0.7l-1.6-0.8-1.5 1.5 0.8 1.6c-0.3 0.5-0.5 1.1-0.7 1.7l-1.7 0.6v2l1.7 0.6c0.2 0.6 0.4 1.2 0.7 1.8l-0.8 1.6 1.4 1.4 1.6-0.8c0.5 0.3 1.1 0.6 1.8 0.7l0.6 1.7h2l0.6-1.7c0.6-0.2 1.2-0.4 1.8-0.7l1.6 0.8 1.4-1.4-0.8-1.6c0.3-0.5 0.6-1.1 0.7-1.8l1.7-0.6zM8 12c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"></path><path d="M10.6 7.9c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5z"></path></g>
<g id="vaadin:cogs"><path d="M12 7v-2l-1.2-0.4c-0.1-0.3-0.2-0.7-0.4-1l0.6-1.2-1.5-1.3-1.1 0.5c-0.3-0.2-0.6-0.3-1-0.4l-0.4-1.2h-2l-0.4 1.2c-0.3 0.1-0.7 0.2-1 0.4l-1.1-0.5-1.4 1.4 0.6 1.2c-0.2 0.3-0.3 0.6-0.4 1l-1.3 0.3v2l1.2 0.4c0.1 0.3 0.2 0.7 0.4 1l-0.5 1.1 1.4 1.4 1.2-0.6c0.3 0.2 0.6 0.3 1 0.4l0.3 1.3h2l0.4-1.2c0.3-0.1 0.7-0.2 1-0.4l1.2 0.6 1.4-1.4-0.6-1.2c0.2-0.3 0.3-0.6 0.4-1l1.2-0.4zM3 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.7-1.3 3-3 3s-3-1.3-3-3z"></path><path d="M7.5 6c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path><path d="M16 3v-1h-0.6c0-0.2-0.1-0.4-0.2-0.5l0.4-0.4-0.7-0.7-0.4 0.4c-0.2-0.1-0.3-0.2-0.5-0.2v-0.6h-1v0.6c-0.2 0-0.4 0.1-0.5 0.2l-0.4-0.4-0.7 0.7 0.4 0.4c-0.1 0.2-0.2 0.3-0.2 0.5h-0.6v1h0.6c0 0.2 0.1 0.4 0.2 0.5l-0.4 0.4 0.7 0.7 0.4-0.4c0.2 0.1 0.3 0.2 0.5 0.2v0.6h1v-0.6c0.2 0 0.4-0.1 0.5-0.2l0.4 0.4 0.7-0.7-0.4-0.4c0.1-0.2 0.2-0.3 0.2-0.5h0.6zM13.5 3.5c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1c0 0.6-0.4 1-1 1z"></path><path d="M15.4 11.8c-0.1-0.3-0.2-0.6-0.4-0.9l0.3-0.6-0.7-0.7-0.5 0.4c-0.3-0.2-0.6-0.3-0.9-0.4l-0.2-0.6h-1l-0.2 0.6c-0.3 0.1-0.6 0.2-0.9 0.4l-0.6-0.3-0.7 0.7 0.3 0.6c-0.2 0.3-0.3 0.6-0.4 0.9l-0.5 0.1v1l0.6 0.2c0.1 0.3 0.2 0.6 0.4 0.9l-0.3 0.6 0.7 0.7 0.6-0.3c0.3 0.2 0.6 0.3 0.9 0.4l0.1 0.5h1l0.2-0.6c0.3-0.1 0.6-0.2 0.9-0.4l0.6 0.3 0.7-0.7-0.4-0.5c0.2-0.3 0.3-0.6 0.4-0.9l0.6-0.2v-1l-0.6-0.2zM12.5 14c-0.8 0-1.5-0.7-1.5-1.5s0.7-1.5 1.5-1.5 1.5 0.7 1.5 1.5-0.7 1.5-1.5 1.5z"></path></g>
<g id="vaadin:coin-piles"><path d="M10.5 0c-3.040 0-5.5 0.88-5.5 2 0 0 0 0 0 0v2c-3 0.1-5 0.94-5 2 0 0 0 0 0 0v2s0 0 0 0v2s0 0 0 0v2c0 1.090 2.46 2 5.5 2 0.020 0 0.043 0 0.067 0 0.732 0 1.45-0.055 2.153-0.16 0.698 1.305 2.094 2.158 3.69 2.158 2.017 0 3.715-1.363 4.224-3.217 0.209-0.199 0.344-0.442 0.367-0.717l0-2.064v-8c0-1.12-2.46-2-5.5-2zM5.5 5c2.5 0 4.5 0.45 4.5 1s-2 1-4.5 1-4.5-0.45-4.5-1 2-1 4.5-1zM5.5 13c-2.71 0-4.25-0.71-4.5-1v-0.8c1.199 0.512 2.595 0.809 4.060 0.809 0.155 0 0.309-0.003 0.462-0.010 0.508-0.001 1.030-0.030 1.544-0.085-0.043 0.371 0.022 0.712 0.123 1.037-0.452 0.021-0.967 0.051-1.488 0.051-0.070 0-0.141-0.001-0.211-0.002zM7.070 10.91c-0.467 0.057-1.008 0.090-1.556 0.090-0.005 0-0.010 0-0.014 0-2.709 0-4.249-0.71-4.499-1v-0.84c1.223 0.535 2.649 0.846 4.147 0.846 0.124 0 0.248-0.002 0.371-0.006 0.632-0.001 1.271-0.044 1.897-0.128-0.197 0.306-0.291 0.654-0.342 1.015zM5.5 9c-2.71 0-4.25-0.71-4.5-1v-0.9c1.223 0.535 2.649 0.846 4.147 0.846 0.124 0 0.248-0.002 0.371-0.006 0.088 0.004 0.212 0.006 0.337 0.006 1.498 0 2.923-0.311 4.214-0.872l-0.068 0.366c-0.777 0.265-1.432 0.717-1.935 1.304-0.752 0.165-1.611 0.256-2.491 0.256-0.026 0-0.052-0-0.077-0zM11.41 15c-1.883 0-3.41-1.527-3.41-3.41s1.527-3.41 3.41-3.41c1.883 0 3.41 1.527 3.41 3.41s-1.527 3.41-3.41 3.41zM15 8c-0.175 0.167-0.385 0.3-0.617 0.386-0.288-0.244-0.6-0.46-0.938-0.634 0.575-0.153 1.101-0.352 1.593-0.61l-0.038 0.858zM15 6c-0.24 0.31-1.61 0.94-4 1v-1c0.003 0 0.007 0 0.011 0 1.443 0 2.814-0.305 4.053-0.855l-0.064 0.855zM15 4c-0.25 0.33-1.79 1-4.5 1h-0.23c-1.213-0.63-2.648-1-4.169-1-0.014 0-0.029 0-0.043 0l-0.058-0v-0.9c1.223 0.535 2.649 0.846 4.147 0.846 0.124 0 0.248-0.002 0.371-0.006 0.088 0.004 0.212 0.006 0.337 0.006 1.498 0 2.923-0.311 4.214-0.872l-0.068 0.926zM10.5 3c-2.5 0-4.5-0.45-4.5-1s2-1 4.5-1 4.5 0.45 4.5 1-2 1-4.5 1z"></path><path d="M10.5 11h0.5v3h1v-5h-0.5l-1 2z"></path></g>
<g id="vaadin:coins"><path d="M11.5 0c-2.485 0-4.5 2.015-4.5 4.5 0.004 0.261 0.029 0.513 0.074 0.758-0.479-0.176-1.025-0.261-1.591-0.261-3.043 0-5.51 2.467-5.51 5.51s2.467 5.51 5.51 5.51c3.043 0 5.51-2.467 5.51-5.51 0-0.566-0.085-1.112-0.244-1.626 0.23 0.077 0.484 0.099 0.742 0.099 2.48 0 4.49-2.010 4.49-4.49 0-2.477-2.005-4.485-4.481-4.49zM10 10.5c0 2.485-2.015 4.5-4.5 4.5s-4.5-2.015-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5 2.483 0.006 4.494 2.017 4.5 4.499zM12.5 7h-2v-0.5h0.5v-3h-0.5l1-1.5h0.5v4.5h0.5v0.5z"></path><path d="M5.63 8c0.033-0.003 0.072-0.005 0.111-0.005 0.696 0 1.26 0.564 1.26 1.26 0 0.016-0 0.031-0.001 0.047 0 1.698-1.86 2.698-1.86 2.698h1.37v-0.5h0.49v1.5h-3v-1s2-1.27 2-2.33c0-0.37 0-0.67-0.42-0.67-0.69 0-0.65 1-0.65 1h-0.93s-0.23-2 1.63-2z"></path></g>
<g id="vaadin:combobox"><path d="M15 4h-14c-0.6 0-1 0.4-1 1v6c0 0.6 0.4 1 1 1h14c0.6 0 1-0.4 1-1v-6c0-0.6-0.4-1-1-1zM10 11h-9v-6h9v6zM13 8.4l-2-1.4h4l-2 1.4z"></path><path d="M2 6h1v4h-1v-4z"></path></g>
<g id="vaadin:comment-ellipsis-o"><path d="M3 11.2c0 0.1 0 0.1 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0z"></path><path d="M8.3 1c-4.4 0-8.3 2.6-8.3 5.6 0 2 1.1 3.7 3 4.7 0 0 0 0 0 0s0 0.1 0 0.1c-0.1 1.3-0.9 1.7-0.9 1.7l-1.8 0.9h2c2.5 0 4.3-1.1 5.1-1.9 0.3 0 0.6 0 0.8 0 4.3 0 7.8-2.5 7.8-5.6s-3.4-5.5-7.7-5.5zM8.2 11.1c-0.3 0-0.7 0-0.9 0h-0.2l-0.2 0.2c-0.5 0.5-1.6 1.4-3.3 1.7 0.3-0.5 0.5-1.1 0.5-2v-0.3l-0.3-0.1c-1.8-0.9-2.8-2.3-2.8-4 0-2.4 3.5-4.6 7.3-4.6 3.7 0 6.7 2 6.7 4.6 0 2.4-3.1 4.5-6.8 4.5z"></path><path d="M6 7c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M9 7c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M12 7c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path></g>
<g id="vaadin:comment-ellipsis"><path d="M8 1c-4.4 0-8 2.5-8 5.5 0 2 2 3.8 4 4.8 0 0 0 0 0 0 0 2.1-2 2.8-2 2.8 2.8 0 4.4-1.3 5.1-2.1 0.3 0 0.6 0 0.9 0 4.4 0 8-2.5 8-5.5s-3.6-5.5-8-5.5zM5 8c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1c0 0.6-0.4 1-1 1zM8 8c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1c0 0.6-0.4 1-1 1zM11 8c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1c0 0.6-0.4 1-1 1z"></path></g>
<g id="vaadin:comment-o"><path d="M3 11.2c0 0.1 0 0.1 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0z"></path><path d="M8.3 1c-4.4 0-8.3 2.6-8.3 5.6 0 2 1.1 3.7 3 4.7 0 0 0 0 0 0s0 0.1 0 0.1c-0.1 1.3-0.9 1.7-0.9 1.7l-1.8 0.9h2c2.5 0 4.3-1.1 5.1-1.9 0.3 0 0.5 0 0.8 0 4.3 0 7.8-2.5 7.8-5.6s-3.4-5.5-7.7-5.5zM8.2 11.1c-0.3 0-0.7 0-0.9 0h-0.3l-0.2 0.2c-0.5 0.5-1.6 1.4-3.3 1.7 0.3-0.5 0.5-1.1 0.5-2v-0.3l-0.3-0.1c-1.8-0.9-2.7-2.3-2.7-4 0-2.4 3.5-4.6 7.3-4.6 3.7 0 6.7 2 6.7 4.6 0 2.4-3.1 4.5-6.8 4.5z"></path></g>
<g id="vaadin:comment"><path d="M8 1c-4.4 0-8 2.5-8 5.5 0 2 2 3.8 4 4.8 0 0 0 0 0 0 0 2.1-2 2.8-2 2.8 2.8 0 4.4-1.3 5.1-2.1 0.3 0 0.6 0 0.9 0 4.4 0 8-2.5 8-5.5s-3.6-5.5-8-5.5z"></path></g>
<g id="vaadin:comments-o"><path d="M14.2 14c0.6-0.5 1.8-1.6 1.8-3.2 0-1.4-1.2-2.6-2.8-3.3 0.5-0.6 0.8-1.5 0.8-2.4 0-2.8-2.9-5.1-6.6-5.1-3.5 0-7.4 2.1-7.4 5.1 0 2.1 1.6 3.6 2.3 4.2-0.1 1.2-0.6 1.7-0.6 1.7l-1.2 1h1.5c1.2 0 2.2-0.3 3-0.7 0.3 1.9 2.5 3.4 5.3 3.4 0.1 0 0.3 0 0.5 0 0.6 0.5 1.8 1.3 3.5 1.3h1.4l-1.1-0.9c0 0-0.3-0.3-0.4-1.1zM10.3 13.7c-2.3 0-4.3-1.3-4.3-2.8 0-0.1 0-0.1 0-0.2 0.2-0.2 0.4-0.3 0.5-0.5 0.2 0 0.5 0 0.7 0 2.1 0 4-0.7 5.2-1.9 1.5 0.5 2.6 1.5 2.6 2.5s-0.9 2-1.7 2.5l-0.3 0.2v0.3c0 0.5 0.2 0.8 0.3 1.1-1-0.2-1.7-0.7-1.9-1l-0.1-0.2h-0.2c-0.3 0-0.6 0-0.8 0zM7.4 1c3.1 0 5.6 1.9 5.6 4.1s-2.6 4.1-5.8 4.1c-0.2 0-0.6 0-0.8 0h-0.3l-0.1 0.2c-0.3 0.4-1.5 1.2-3.1 1.5 0.1-0.4 0.1-1 0.1-1.8v-0.3c-1-0.8-2.1-2.2-2.1-3.6 0-2.2 3.2-4.2 6.5-4.2z"></path></g>
<g id="vaadin:comments"><path d="M16 11.1c0-1.5-1.5-2.8-3.2-3.3-1.3 1.5-3.9 2.4-6.4 2.4-0.1 0-0.3 0-0.4 0 0 0 0 0-0.1 0-0.1 0.3-0.1 0.5-0.1 0.8 0 2 2.2 3.6 5 3.6 0.2 0 0.4 0 0.6 0 0.4 0.5 1.7 1.4 3.4 1.4 0 0-0.8-0.4-0.8-1.8 0 0 0 0 0 0 0-0.6 2-1.8 2-3.1z"></path><path d="M13 4.6c0-2.5-2.8-4.6-6.4-4.6s-6.6 2.1-6.6 4.6c0 1.7 2 3.2 3 4 0 0 0 0 0 0 0 1.8-1.4 2.4-1.4 2.4 2.3 0 3.6-1.1 4.2-1.8 0.2 0 0.5 0 0.8 0 3.5 0.1 6.4-2 6.4-4.6z"></path></g>
<g id="vaadin:compile"><path d="M1 12h4v4h-4v-4z"></path><path d="M6 12h4v4h-4v-4z"></path><path d="M11 12h4v4h-4v-4z"></path><path d="M1 7h4v4h-4v-4z"></path><path d="M1 2h4v4h-4v-4z"></path><path d="M6 7h4v4h-4v-4z"></path><path d="M7 1h4v4h-4v-4z"></path><path d="M11 7h4v4h-4v-4z"></path><path d="M13 0h3v3h-3v-3z"></path></g>
<g id="vaadin:compress-square"><path d="M12 0h-12v12l1-1v-10h10z"></path><path d="M4 16h12v-12l-1 1v10h-10z"></path><path d="M7 9h-5l1.8 1.8-3.8 3.8 1.4 1.4 3.8-3.8 1.8 1.8z"></path><path d="M16 1.4l-1.4-1.4-3.8 3.8-1.8-1.8v5h5l-1.8-1.8z"></path></g>
<g id="vaadin:compress"><path d="M5.3 9.3l-5 5 1.4 1.4 5-5 1.3 1.3v-4h-4z"></path><path d="M15.7 1.7l-1.4-1.4-4 4-1.3-1.3v4h4l-1.3-1.3z"></path></g>
<g id="vaadin:connect-o"><path d="M12.5 9c-1 0-1.8 0.4-2.4 1l-3.2-1.7c0.1-0.3 0.1-0.5 0.1-0.8 0-0.2 0-0.3 0-0.4l2.9-1.3c0.6 0.7 1.5 1.2 2.6 1.2 1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5c0 0.2 0 0.3 0 0.4l-2.9 1.3c-0.6-0.7-1.5-1.2-2.6-1.2-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5c1 0 1.8-0.4 2.4-1l3.1 1.7c0 0.3 0 0.5 0 0.8 0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zM12.5 1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5c0-1.4 1.1-2.5 2.5-2.5zM3.5 10c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5zM12.5 15c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5z"></path></g>
<g id="vaadin:connect"><path d="M12 10c-0.8 0-1.4 0.3-2 0.8l-3.2-1.8c0.1-0.3 0.2-0.7 0.2-1s-0.1-0.7-0.2-1l3.2-1.8c0.6 0.5 1.2 0.8 2 0.8 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3c0 0.2 0 0.3 0 0.5l-3.5 1.9c-0.4-0.2-0.9-0.4-1.5-0.4-1.6 0-3 1.3-3 3v0c0 1.6 1.4 3 3 3 0.6 0 1.1-0.2 1.5-0.4l3.5 1.9c0 0.2 0 0.3 0 0.5 0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3z"></path></g>
<g id="vaadin:controller"><path d="M5.951 0.249l0.981-0.195 0.195 0.981-0.981 0.195-0.195-0.981z"></path><path d="M8.877 14.966l0.981-0.195 0.195 0.981-0.981 0.195-0.195-0.981z"></path><path d="M0.055 9.071l0.981-0.195 0.195 0.981-0.981 0.195-0.195-0.981z"></path><path d="M14.773 6.145l0.981-0.195 0.195 0.981-0.981 0.195-0.195-0.981z"></path><path d="M11.471 1.897l0.556-0.831 0.831 0.556-0.556 0.831-0.831-0.556z"></path><path d="M3.139 14.441l0.56-0.83 0.83 0.56-0.56 0.83-0.83-0.56z"></path><path d="M1.069 3.989l0.56-0.83 0.83 0.56-0.56 0.83-0.83-0.56z"></path><path d="M13.547 12.299l0.556-0.831 0.831 0.556-0.556 0.831-0.831-0.556z"></path><path d="M8.875 1.039l0.195-0.981 0.981 0.195-0.195 0.981-0.981-0.195z"></path><path d="M5.953 15.745l0.195-0.981 0.981 0.195-0.195 0.981-0.981-0.195z"></path><path d="M0.061 6.931l0.195-0.981 0.981 0.195-0.195 0.981-0.981-0.195z"></path><path d="M14.767 9.854l0.195-0.981 0.981 0.195-0.195 0.981-0.981-0.195z"></path><path d="M3.139 1.628l0.831-0.556 0.556 0.831-0.831 0.556-0.556-0.831z"></path><path d="M11.477 14.101l0.831-0.556 0.556 0.831-0.831 0.556-0.556-0.831z"></path><path d="M1.071 12.033l0.831-0.556 0.556 0.831-0.831 0.556-0.556-0.831z"></path><path d="M13.539 3.63l0.83-0.56 0.56 0.83-0.83 0.56-0.56-0.83z"></path><path d="M14 8c-0.003-1.895-0.884-3.583-2.258-4.681l-3.322 4.991-0.84-0.59 3.32-5c-0.836-0.47-1.836-0.747-2.9-0.747-3.314 0-6 2.686-6 6s2.686 6 6 6c3.304 0 5.984-2.671 6-5.971z"></path></g>
<g id="vaadin:copy-o"><path d="M13 3h-3l-3-3h-7v13h6v3h10v-10l-3-3zM7 1l2 2h-2v-2zM1 12v-11h5v3h3v8h-8zM15 15h-8v-2h3v-9h2v3h3v8zM13 6v-2l2 2h-2z"></path></g>
<g id="vaadin:copy"><path d="M6 0v3h3z"></path><path d="M9 4h-4v-4h-5v12h9z"></path><path d="M13 4v3h3z"></path><path d="M12 4h-2v9h-3v3h9v-8h-4z"></path></g>
<g id="vaadin:copyright"><path d="M8 1.5c3.6 0 6.5 2.9 6.5 6.5s-2.9 6.5-6.5 6.5-6.5-2.9-6.5-6.5 2.9-6.5 6.5-6.5zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M9.9 10.3c-0.5 0.4-1.2 0.7-1.9 0.7-1.7 0-3-1.3-3-3s1.3-3 3-3c0.8 0 1.6 0.3 2.1 0.9l1.1-1.1c-0.8-0.8-2-1.3-3.2-1.3-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5c1.1 0 2-0.4 2.8-1l-0.9-1.2z"></path></g>
<g id="vaadin:corner-lower-left"><path d="M16 16l-16-16v16z"></path></g>
<g id="vaadin:corner-lower-right"><path d="M16 16h-16l16-16z"></path></g>
<g id="vaadin:corner-upper-left"><path d="M0 16l16-16h-16z"></path></g>
<g id="vaadin:corner-upper-right"><path d="M16 16l-16-16h16z"></path></g>
<g id="vaadin:credit-card"><path d="M0 2v12h16v-12h-16zM15 13h-14v-5h14v5zM15 5h-14v-2h14v2z"></path><path d="M10 11h3v1h-3v-1z"></path><path d="M2 11h6v1h-6v-1z"></path></g>
<g id="vaadin:crop"><path d="M16 0.7v-0.7h-0.7l-3 3h-7.3v-3h-2v3h-3v2h3v8h8v3h2v-3h3v-2h-3v-7.3l3-3zM5 5h5.3l-5.3 5.3v-5.3zM11 11h-5.3l5.3-5.3v5.3z"></path></g>
<g id="vaadin:cross-cutlery"><path d="M10.9 8.6c0 0 0 0 0 0 0.6-0.1 1.2-0.4 1.6-0.9l3.1-3.1c0.4-0.4 0.4-1 0-1.4l-0.1-0.2-3 3c-0.2 0.2-0.6 0.2-0.9 0s-0.2-0.6 0-0.9l2.6-2.6c0.2-0.2 0.2-0.6 0-0.9-0.2-0.2-0.6-0.2-0.9 0l-2.6 2.6c-0.2 0.2-0.6 0.2-0.9 0-0.2-0.2-0.2-0.6 0-0.9l3-3-0.1-0.1c-0.4-0.4-1-0.4-1.4 0l-3.1 3.3c-0.4 0.4-0.7 1-0.8 1.6l-4.9-4.8c-0.4-0.4-1-0.3-1.3 0l-0.2 0.2c-1.4 1.4-0.9 4.2 1.5 6.6l0.8 0.8c0.4 0.4 0.9 0.7 1.5 0.8-0.5 0.4-0.8 0.8-0.8 0.8l-3.4 3.4c-0.7 0.7-0.7 1.9 0 2.6s1.9 0.7 2.6 0l3.3-3.5c0.2-0.2 0.7-0.8 1.3-1.5 0.3 0.4 0.5 0.6 0.5 0.6l4.3 4.3c0.7 0.7 1.9 0.7 2.6 0s0.7-1.9 0-2.6l-4.3-4.2z"></path></g>
<g id="vaadin:crosshairs"><path d="M7.5 0h1v4l-0.5 2-0.5-2v-4z"></path><path d="M8.5 16h-1v-4l0.5-2 0.5 2v4z"></path><path d="M16 7.5v1h-4l-2-0.5 2-0.5h4z"></path><path d="M0 8.5v-1h4l2 0.5-2 0.5h-4z"></path><path d="M8 2.5c3.038 0 5.5 2.462 5.5 5.5s-2.462 5.5-5.5 5.5c-3.038 0-5.5-2.462-5.5-5.5 0.006-3.035 2.465-5.494 5.499-5.5zM8 1c-3.866 0-7 3.134-7 7s3.134 7 7 7c3.866 0 7-3.134 7-7s-3.134-7-7-7v0z"></path></g>
<g id="vaadin:css"><path d="M4.1 11c1.4 0 1.9-1 1.9-1l-0.8-0.5c0 0-0.3 0.5-1 0.5s-1.2-0.9-1.2-2.2c0-1.2 0.6-1.8 1.2-1.8 0.5 0 0.9 0.4 0.9 0.4l0.8-0.6c0 0-0.7-0.8-1.7-0.8-1.1 0-2.2 0.9-2.2 2.8s0.9 3.2 2.1 3.2zM8.7 9.9c-0.3 0.1-0.7 0-1-0.4l-0.8 0.5c0.4 0.6 1 1 1.6 1 0.1 0 0.3 0 0.4-0.1 0.7-0.2 1.1-0.8 1.1-1.6 0-1.2-0.8-1.6-1.3-1.8-0.5-0.3-0.7-0.4-0.7-0.8s0.1-0.7 0.6-0.7c0.3 0 0.6 0.4 0.6 0.4l0.8-0.6c-0.2-0.3-0.7-0.8-1.4-0.8-0.9 0-1.6 0.6-1.6 1.6 0 1.1 0.7 1.5 1.2 1.8 0.6 0.2 0.8 0.4 0.8 0.9 0 0.3 0 0.6-0.3 0.6zM12.7 9.9c-0.3 0.1-0.7 0-1-0.4l-0.8 0.5c0.4 0.6 1 1 1.6 1 0.1 0 0.3 0 0.4-0.1 0.7-0.2 1.1-0.8 1.1-1.6 0-1.2-0.8-1.6-1.3-1.8-0.5-0.3-0.7-0.4-0.7-0.8s0.1-0.7 0.6-0.7c0.3 0 0.6 0.4 0.6 0.4l0.8-0.6c-0.2-0.3-0.7-0.8-1.4-0.8-0.9 0-1.6 0.6-1.6 1.6 0 1.1 0.7 1.5 1.2 1.8 0.6 0.2 0.8 0.4 0.8 0.9 0 0.3 0 0.6-0.3 0.6zM0 0v16h16v-16h-16zM15 15h-14v-14h14v14z"></path></g>
<g id="vaadin:ctrl-a"><path d="M9 7v-1h-1v-1h-1v1h-0.5v1h0.5v3.56c0.176 0.835 0.907 1.453 1.783 1.453 0.077 0 0.152-0.005 0.226-0.014l-0.009-0.999c-0.055 0.012-0.119 0.019-0.185 0.019-0.359 0-0.669-0.21-0.813-0.514l-0.002-3.505h1z"></path><path d="M14 3h1v9h-1v-9z"></path><path d="M13 6c-0.025-0.001-0.055-0.001-0.085-0.001-0.773 0-1.462 0.358-1.911 0.917l-0.004-0.915h-1v6h1v-3c-0.003-0.037-0.004-0.080-0.004-0.124 0-1.038 0.842-1.88 1.88-1.88 0.044 0 0.087 0.001 0.13 0.004l-0.006-1z"></path><path d="M4.19 12c-2.030 0-3.19-1.46-3.19-4s1.16-4 3.19-4c0.009-0 0.019-0 0.029-0 0.539 0 1.052 0.114 1.515 0.32l-0.424 0.901c-0.319-0.139-0.69-0.22-1.080-0.22-0.014 0-0.028 0-0.042 0-1.808-0-2.188 1.63-2.188 3s0.38 3 2.19 3c0.497-0.013 0.96-0.145 1.366-0.368l0.444 0.898c-0.524 0.285-1.146 0.458-1.806 0.47z"></path></g>
<g id="vaadin:ctrl"><path d="M0 0v16h16v-16h-16zM4.19 12c-2.030 0-3.19-1.46-3.19-4s1.16-4 3.19-4c0.009-0 0.019-0 0.029-0 0.539 0 1.052 0.114 1.515 0.32l-0.424 0.901c-0.319-0.139-0.69-0.22-1.080-0.22-0.014 0-0.028 0-0.042 0-1.808-0-2.188 1.63-2.188 3s0.38 3 2.19 3c0.497-0.013 0.96-0.145 1.366-0.368l0.444 0.898c-0.524 0.285-1.146 0.458-1.806 0.47zM9 7h-1v3.5c0.147 0.309 0.457 0.519 0.815 0.519 0.065 0 0.129-0.007 0.19-0.020l-0.006 1.001c-0.065 0.008-0.141 0.013-0.217 0.013-0.875 0-1.606-0.618-1.781-1.441l-0.002-3.572h-0.51v-1h0.51v-1h1v1h1v1zM11 9v3h-1v-6h1v0.92c0.453-0.564 1.142-0.921 1.915-0.921 0.030 0 0.060 0.001 0.090 0.002l-0.004 1c-0.037-0.003-0.080-0.004-0.124-0.004-1.038 0-1.88 0.842-1.88 1.88 0 0.044 0.001 0.087 0.004 0.13zM15 12h-1v-9h1v9z"></path></g>
<g id="vaadin:cube"><path d="M8 0l-8 2v10l8 4 8-4v-10l-8-2zM14.4 2.6l-5.9 2.2-6.6-2.2 6.1-1.6 6.4 1.6zM1 11.4v-8.1l7 2.4v9.2l-7-3.5z"></path></g>
<g id="vaadin:cubes"><path d="M12 6v-4l-4-2-4 2v4l-4 2v5l4 2 4-2 4 2 4-2v-5zM8.090 1.12l2.91 1.44-2.6 1.3-2.91-1.44zM5 2.78l3 1.5v3.6l-3-1.5v-3.6zM4 13.88l-3-1.5v-3.6l3 1.5v3.6zM4.28 9.88l-2.88-1.46 2.6-1.3 2.88 1.44zM12 13.88l-3-1.5v-3.6l3 1.5v3.6zM12.28 9.88l-2.88-1.46 2.6-1.3 2.88 1.44z"></path></g>
<g id="vaadin:curly-brackets"><path d="M2.1 3.1c0.2 1.3 0.4 1.6 0.4 2.9 0 0.8-1.5 1.5-1.5 1.5v1c0 0 1.5 0.7 1.5 1.5 0 1.3-0.2 1.6-0.4 2.9-0.3 2.1 0.8 3.1 1.8 3.1s2.1 0 2.1 0v-2c0 0-1.8 0.2-1.8-1 0-0.9 0.2-0.9 0.4-2.9 0.1-0.9-0.5-1.6-1.1-2.1 0.6-0.5 1.2-1.1 1.1-2-0.3-2-0.4-2-0.4-2.9 0-1.2 1.8-1.1 1.8-1.1v-2c0 0-1 0-2.1 0s-2.1 1-1.8 3.1z"></path><path d="M13.9 3.1c-0.2 1.3-0.4 1.6-0.4 2.9 0 0.8 1.5 1.5 1.5 1.5v1c0 0-1.5 0.7-1.5 1.5 0 1.3 0.2 1.6 0.4 2.9 0.3 2.1-0.8 3.1-1.8 3.1s-2.1 0-2.1 0v-2c0 0 1.8 0.2 1.8-1 0-0.9-0.2-0.9-0.4-2.9-0.1-0.9 0.5-1.6 1.1-2.1-0.6-0.5-1.2-1.1-1.1-2 0.2-2 0.4-2 0.4-2.9 0-1.2-1.8-1.1-1.8-1.1v-2c0 0 1 0 2.1 0s2.1 1 1.8 3.1z"></path></g>
<g id="vaadin:cursor-o"><path d="M5 2.6l5.75 6.4h-2.46l0.63 1.41 1.8 4-0.91 0.34-1.88-4.3-0.5-1.11-1 0.71-1.43 1.020v-8.47zM4 0v13l3-2.14 2.26 5.14 2.8-1-2.23-5h3.17l-9-10z"></path></g>
<g id="vaadin:cursor"><path d="M4 0v13l3.31-3.47 2.69 6.47 1.37-0.63-2.72-6.37h4.35l-9-9z"></path></g>
<g id="vaadin:cutlery"><path d="M13 0.8c0-0.5-0.4-0.8-0.8-0.8h-0.2c-1.7 0-3 1.9-3 4.7v0.9c0 1 0.5 1.9 1.4 2.4-0.3 1.2-0.4 2.5-0.4 2.5v4c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5v-4c0-0.4-0.1-1.4-0.3-2.3 0.2-0.2 0.3-0.4 0.3-0.7v-6.7z"></path><path d="M7.2 0h-0.2v3.5c0 0.3-0.2 0.5-0.5 0.5s-0.5-0.2-0.5-0.5v-3c0-0.3-0.2-0.5-0.5-0.5s-0.5 0.2-0.5 0.5v3c0 0.3-0.2 0.5-0.5 0.5s-0.5-0.2-0.5-0.5v-3.5h-0.2c-0.4 0-0.8 0.4-0.8 0.8v3.7c0 1 0.6 1.9 1.5 2.3-0.4 1.6-0.5 3.7-0.5 3.7v4c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5v-4c0-0.5-0.1-2.3-0.4-3.7 0.8-0.4 1.4-1.3 1.4-2.3v-3.7c0-0.4-0.4-0.8-0.8-0.8z"></path></g>
<g id="vaadin:dashboard"><path d="M16 10.1c0-4.4-3.6-8.1-8-8.1s-8 3.7-8 8.1c0 1.4 0.3 2.9 0.9 3.9h4.9c0.5 0.6 1.3 1 2.2 1s1.7-0.4 2.2-1h4.9c0.6-1 0.9-2.5 0.9-3.9zM14 7v1l-4.1 3.5c0 0.1 0.1 0.3 0.1 0.5 0 1.1-0.9 2-2 2s-2-0.9-2-2 0.9-2 2-2c0.3 0 0.6 0.1 0.8 0.2l4.2-3.2h1zM10 4h1v1h-1v-1zM5 4h1v1h-1v-1zM2 12h-1v-1h1v1zM3 8h-1v-1h1v1zM15 12h-1v-1h1v1z"></path><path d="M9 12c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path></g>
<g id="vaadin:database"><path d="M14 2.5c0 0.828-2.686 1.5-6 1.5s-6-0.672-6-1.5c0-0.828 2.686-1.5 6-1.5s6 0.672 6 1.5z"></path><path d="M8 5c-3.3 0-6-0.7-6-1.5v3c0 0.8 2.7 1.5 6 1.5s6-0.7 6-1.5v-3c0 0.8-2.7 1.5-6 1.5z"></path><path d="M8 9c-3.3 0-6-0.7-6-1.5v3c0 0.8 2.7 1.5 6 1.5s6-0.7 6-1.5v-3c0 0.8-2.7 1.5-6 1.5z"></path><path d="M8 13c-3.3 0-6-0.7-6-1.5v3c0 0.8 2.7 1.5 6 1.5s6-0.7 6-1.5v-3c0 0.8-2.7 1.5-6 1.5z"></path></g>
<g id="vaadin:date-input"><path d="M14 1v3h-3v-3h-6v3h-3v-3h-2v15h16v-15h-2zM15 15h-14v-9h14v9z"></path><path d="M3 0h1v3h-1v-3z"></path><path d="M12 0h1v3h-1v-3z"></path><path d="M3 8h1v5h-1v-5z"></path></g>
<g id="vaadin:deindent"><path d="M4 10.5v-6l-4 3z"></path><path d="M0 0h16v3h-16v-3z"></path><path d="M6 4h10v3h-10v-3z"></path><path d="M6 8h10v3h-10v-3z"></path><path d="M0 12h16v3h-16v-3z"></path></g>
<g id="vaadin:del-a"><path d="M14 3h1v9h-1v-9z"></path><path d="M3 12h-2v-9h2c2.23 0.051 4.019 1.871 4.019 4.109 0 0.138-0.007 0.274-0.020 0.408 0.013 0.1 0.020 0.236 0.020 0.374 0 2.238-1.788 4.058-4.014 4.109zM2 11h1c0.31 0 3-0.12 3-3.5s-2.88-3.5-3-3.5h-1v7z"></path><path d="M13 9v-0.5c-0.017-0.77-0.31-1.468-0.783-2.003-0.419-0.412-0.999-0.668-1.638-0.668-0.031 0-0.063 0.001-0.094 0.002-0.013-0.001-0.034-0.001-0.054-0.001-0.594 0-1.132 0.241-1.521 0.631-0.566 0.685-0.91 1.572-0.91 2.54 0 0.003-0 0.006-0 0.009 0 0.881 0.322 1.686 0.854 2.306 0.43 0.429 1.030 0.697 1.692 0.697 0.030 0 0.059-0.001 0.089-0.002 0.861-0.026 1.642-0.372 2.228-0.922l-0.712-0.708c-0.401 0.368-0.931 0.603-1.515 0.63-0.026 0.001-0.051 0.002-0.076 0.002-0.385 0-0.734-0.153-0.99-0.402-0.355-0.435-0.57-0.997-0.57-1.61l4-0zM10.5 6.8c0.020-0.001 0.043-0.002 0.066-0.002 0.362 0 0.691 0.141 0.935 0.372 0.209 0.224 0.361 0.505 0.427 0.818l-2.778 0.011c0.11-0.661 0.661-1.165 1.337-1.2z"></path></g>
<g id="vaadin:del"><path d="M0 0v16h16v-16h-16zM3 12h-2v-9h2c2.23 0.051 4.019 1.871 4.019 4.109 0 0.138-0.007 0.274-0.020 0.408 0.013 0.1 0.020 0.236 0.020 0.374 0 2.238-1.788 4.058-4.014 4.109zM13 9h-4c-0 0.004-0 0.008-0 0.012 0 0.607 0.211 1.164 0.564 1.603 0.252 0.244 0.601 0.397 0.986 0.397 0.025 0 0.049-0.001 0.074-0.002 0.586-0.027 1.115-0.261 1.518-0.631l0.708 0.712c-0.584 0.548-1.364 0.893-2.225 0.92-0.030 0.001-0.060 0.002-0.090 0.002-0.662 0-1.261-0.268-1.696-0.702-0.522-0.613-0.84-1.414-0.84-2.289 0-0.007 0-0.014 0-0.022-0-0.005-0-0.012-0-0.019 0-0.968 0.344-1.855 0.915-2.547 0.384-0.383 0.922-0.624 1.516-0.624 0.021 0 0.041 0 0.062 0.001 0.024-0.001 0.055-0.002 0.086-0.002 0.639 0 1.219 0.256 1.641 0.672 0.47 0.532 0.762 1.23 0.78 1.996l0 0.524zM15 12h-1v-9h1v9z"></path><path d="M3 4h-1v7h1c0.31 0 3-0.12 3-3.5s-2.88-3.5-3-3.5z"></path><path d="M10.49 6.8c-0.679 0.035-1.23 0.539-1.339 1.192l2.779 0.008c-0.069-0.324-0.22-0.606-0.431-0.831-0.242-0.229-0.571-0.371-0.934-0.371-0.027 0-0.053 0.001-0.079 0.002z"></path></g>
<g id="vaadin:dental-chair"><path d="M11.5 8.2c-0.3-0.1-0.6-0.2-0.8-0.2h-2.7v-1h3c0-0.6-0.4-1-1-1h-4c0 0.6 0.4 1 1 1v1c-0.5 0-1-0.2-1.2-0.6l-1.1-1.8c-0.3-0.4-0.7-0.6-1.1-0.6h-0.6v-0.7c0-0.3-0.1-0.5-0.2-0.8l-0.3-0.7c-0.3-0.5-0.9-0.8-1.5-0.8h-1l5 7c0.4 0.6 1.1 1 1.8 1h1.2v1h-1v2h-0.6c-0.9 0-1.8 0.4-2.4 1v0h-1v1h11v-1h-1c-0.6-0.6-1.5-1-2.4-1h-0.6v-2h-1v-1h1.6c0.2 0 0.5 0.1 0.7 0.2l1.7 0.9c0.9 0.5 2 0.5 2.9 0h0.1l-4.5-2.9z"></path></g>
<g id="vaadin:desktop"><path d="M16 0h-16v13h6v2h-2v1h8v-1h-2v-2h6v-13zM9 12h-2v-1h2v1zM15 10h-14v-8.9c0-0.1 0-0.1 0-0.1h14c0 0 0 0 0 0.1v8.9z"></path></g>
<g id="vaadin:diamond-o"><path d="M13 2h-10l-3 3.5 8 9.5 8-9.5zM4.64 5h-2.89l1.52-1.78zM6.42 5l1.58-1.84 1.58 1.84h-3.16zM10 6l-2 6.68-2-6.68h4zM5.26 6l1.89 6.44-5.42-6.44h3.53zM10.75 6h3.53l-5.43 6.44zM11.37 5l1.37-1.78 1.51 1.78h-2.9zM12 3l-1.44 1.81-1.46-1.81h2.9zM5.43 4.83l-1.43-1.83h2.9z"></path></g>
<g id="vaadin:diamond"><path d="M0 6h4l3 8.6-7-8.6z"></path><path d="M16 6h-4l-3 8.6 7-8.6z"></path><path d="M8 15l-3-9h6l-3 9z"></path><path d="M4 5h-4l2-3 2 3z"></path><path d="M16 5h-4l2-3 2 3z"></path><path d="M10 5h-4l2-3 2 3z"></path><path d="M3.34 2h3.66l-2 3-1.66-3z"></path><path d="M9 2h4l-2 3-2-3z"></path></g>
<g id="vaadin:diploma-scroll"><path d="M12.61 8.41c-0.53-0.079-1.008-0.223-1.454-0.424 2.104-1.876 4.424-3.536 4.454-3.556l0.1-0.070 0.060-0.11c0.177-0.367 0.281-0.797 0.281-1.252 0-0.901-0.407-1.707-1.046-2.244-0.523-0.482-1.219-0.776-1.983-0.776-0.538 0-1.043 0.146-1.476 0.4l-0.126 0.133c-1.578 2.181-3.182 4.099-4.908 5.899-1.836 1.638-3.87 3.195-6.018 4.592l-0.394 0.248v0.23c-0.077 0.314-0.122 0.675-0.122 1.046 0 0.97 0.304 1.87 0.822 2.609 0.507 0.53 1.237 0.87 2.045 0.87 0.055 0 0.109-0.002 0.162-0.005 0.026 0.002 0.065 0.003 0.104 0.003 0.701 0 1.317-0.36 1.674-0.905 0.245-0.308 2.065-2.608 4.005-4.708 0.268 0.464 0.476 1.003 0.594 1.575 0.032 0.249 0.046 0.496 0.046 0.747 0 0.823-0.158 1.61-0.445 2.331l1.685-2.043 1.33 1c-0.041-1.174-0.243-2.286-0.584-3.336-0.227-0.416-0.542-0.845-0.915-1.214 0.406 0.346 0.871 0.643 1.372 0.874 0.94 0.338 1.989 0.572 3.076 0.672l-0.949-1.266 2-1.73c-0.83 0.273-1.785 0.431-2.777 0.431-0.216 0-0.43-0.007-0.642-0.022zM12.16 1.18c0.246-0.123 0.536-0.194 0.842-0.194 0.506 0 0.966 0.196 1.309 0.516 0.441 0.356 0.721 0.897 0.721 1.504 0 0.242-0.045 0.474-0.126 0.688-0.486 0.307-2.346 1.717-4.146 3.307-0.055-0.521-0.302-0.975-0.668-1.298-0.28-0.239-0.643-0.384-1.039-0.384-0.068 0-0.135 0.004-0.201 0.012 1.568-1.771 2.978-3.691 3.308-4.151zM2.7 11.81c0.073-0.051 0.164-0.082 0.262-0.082 0.014 0 0.027 0.001 0.040 0.002l0.068-0c0.179 0.052 0.334 0.142 0.461 0.261l-0.871 0.719c-0.081-0.165-0.128-0.358-0.128-0.563 0-0.052 0.003-0.103 0.009-0.153 0.027-0.077 0.084-0.144 0.158-0.183zM4 14.5c-0.175 0.306-0.499 0.508-0.871 0.508-0.046 0-0.090-0.003-0.134-0.009-0.046 0.006-0.106 0.008-0.167 0.008-0.515 0-0.981-0.209-1.318-0.548-0.365-0.54-0.583-1.206-0.583-1.922 0-0.251 0.027-0.495 0.077-0.73l0.706-0.457c-0.094 0.14-0.164 0.304-0.199 0.481-0.007 0.076-0.010 0.154-0.010 0.234 0 0.642 0.202 1.237 0.545 1.724l0.354 0.44 1.7-1.4c0.066 0.209 0.104 0.45 0.104 0.7 0 0.351-0.075 0.685-0.21 0.985zM4.86 12.050c-0.345-0.6-0.889-1.053-1.54-1.274-0.071-0.012-0.13-0.016-0.19-0.016s-0.119 0.004-0.177 0.010c-0.046-0.007-0.106-0.011-0.168-0.011s-0.122 0.004-0.182 0.011c1.489-1.018 2.766-2.003 3.988-3.052 0.398 0.071 0.812 0.25 1.131 0.533 0.297 0.313 0.48 0.739 0.48 1.209 0 0.032-0.001 0.063-0.002 0.094-1.14 1.226-2.25 2.536-3 3.506-0.054-0.379-0.177-0.719-0.357-1.023z"></path></g>
<g id="vaadin:diploma"><path d="M14 10.58c0.024-0.048 0.038-0.105 0.038-0.165s-0.014-0.117-0.039-0.167l-0.479-0.698c-0.009-0.013-0.014-0.028-0.014-0.045s0.005-0.032 0.014-0.045l0.48-0.7c0.024-0.048 0.038-0.105 0.038-0.165s-0.014-0.117-0.039-0.167c-0.040-0.11-0.127-0.196-0.236-0.237l-0.823-0.301c-0.031-0.011-0.054-0.037-0.060-0.069l-0-0.841c-0.007-0.125-0.072-0.233-0.169-0.299-0.066-0.045-0.145-0.071-0.231-0.071-0.004 0-0.007 0-0.011 0l-0.159-0-0.85 0.22c-0.010 0.004-0.022 0.007-0.035 0.007s-0.025-0.003-0.036-0.007l-0.549-0.65c-0.079-0.085-0.191-0.137-0.315-0.137s-0.236 0.053-0.315 0.137l-0.55 0.65c-0.010 0.004-0.022 0.007-0.035 0.007s-0.025-0.003-0.036-0.007l0.001 0-0.9-0.23h-0.1c-0.002-0-0.005-0-0.008-0-0.087 0-0.167 0.026-0.234 0.071-0.096 0.066-0.161 0.174-0.168 0.298l-0 0.841c-0.006 0.033-0.029 0.059-0.059 0.070l-0.821 0.3c-0.134 0.023-0.245 0.11-0.299 0.228-0.025 0.051-0.039 0.107-0.039 0.167s0.014 0.117 0.039 0.167l0.479 0.698c0.009 0.013 0.014 0.028 0.014 0.045s-0.005 0.032-0.014 0.045l-0.48 0.7c-0.024 0.048-0.038 0.105-0.038 0.165s0.014 0.117 0.039 0.167c0.040 0.11 0.127 0.196 0.236 0.237l0.823 0.301c0.031 0.011 0.054 0.037 0.060 0.069l0 0.841c0.007 0.125 0.072 0.233 0.169 0.299 0.067 0.045 0.147 0.071 0.234 0.071 0.003 0 0.005-0 0.008-0h0.16l0.31-0.070v3.69l1.53-2 1.47 2v-3.69l0.31 0.080h0.11c0.002 0 0.005 0 0.008 0 0.087 0 0.167-0.026 0.234-0.071 0.096-0.066 0.161-0.174 0.168-0.298l0-0.841c0.006-0.033 0.029-0.059 0.059-0.070l0.821-0.3c0.13-0.026 0.236-0.112 0.289-0.227z"></path><path d="M0 1v12h8l-0.11-0.050c-0.282-0.195-0.469-0.508-0.49-0.867l-0-0.083h-6.4v-10h14v10h-1.43v0.080c-0.021 0.361-0.208 0.675-0.486 0.868l-0.084 0.052h3v-12h-16z"></path><path d="M7.43 6.91c0.007-0.377 0.198-0.708 0.486-0.908 0.016-0.005 0.030-0.006 0.044-0.006s0.028 0.001 0.041 0.004l-5.001-0v1h4.43v-0.090z"></path><path d="M6.42 8h-3.42v1h3.36c-0.074-0.136-0.117-0.298-0.117-0.47 0-0.13 0.025-0.253 0.070-0.367 0.014-0.063 0.054-0.122 0.107-0.163z"></path><path d="M3 4h10v1h-10v-1z"></path></g>
<g id="vaadin:disc"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM15 8c0 1.1-0.2 2.1-0.7 3l-2.7-1.2c0.2-0.6 0.4-1.2 0.4-1.8 0-2.2-1.8-4-4-4-0.5 0-0.9 0.1-1.4 0.3l-1.2-2.8c0.6-0.2 1.2-0.4 1.8-0.5l0.3 3h0.5v-3c3.9 0 7 3.1 7 7zM8 5c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zM1 8c0-1.1 0.2-2.1 0.7-3l2.7 1.2c-0.2 0.6-0.4 1.2-0.4 1.8 0 2.2 1.8 4 4 4 0.5 0 0.9-0.1 1.4-0.3l1.2 2.8c-0.6 0.2-1.2 0.4-1.8 0.5l-0.3-3h-0.5v3c-3.9 0-7-3.1-7-7z"></path><path d="M10 8c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:doctor-briefcase"><path d="M16 12l-1.4-6.7c-0.2-0.7-0.9-1.3-1.7-1.3h-1.9v-1.2c0-1-0.8-1.8-1.8-1.8h-2.4c-1 0-1.8 0.8-1.8 1.8v1.2h-1.9c-0.8 0-1.5 0.6-1.7 1.3l-1.4 6.7c-0.2 1 0.6 2 1.7 2h12.5c1.2 0 2-1 1.8-2zM6 2.8c0-0.4 0.4-0.8 0.8-0.8h2.4c0.4 0 0.8 0.4 0.8 0.8v1.2h-4v-1.2zM11 10h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z"></path></g>
<g id="vaadin:doctor"><path d="M14 11.3c-1-1.9-2-1.6-3.1-1.7 0.1 0.3 0.1 0.6 0.1 1 1.6 0.4 2 2.3 2 3.4v1h-2v-1h1c0 0 0-2.5-1.5-2.5s-1.5 2.4-1.5 2.5h1v1h-2v-1c0-1.1 0.4-3.1 2-3.4 0-0.6-0.1-1.1-0.2-1.3-0.2-0.1-0.4-0.3-0.4-0.6 0-0.6 0.8-0.4 1.4-1.5 0 0 0.9-2.3 0.6-4.3h-1c0-0.2 0.1-0.3 0.1-0.5s0-0.3-0.1-0.5h0.8c-0.3-1-1.3-1.9-3.2-1.9 0 0 0 0 0 0s0 0 0 0 0 0 0 0c-1.9 0-2.9 0.9-3.3 2h0.8c0 0.2-0.1 0.3-0.1 0.5s0 0.3 0.1 0.5h-1c-0.2 2 0.6 4.3 0.6 4.3 0.6 1 1.4 0.8 1.4 1.5 0 0.5-0.5 0.7-1.1 0.8-0.2 0.2-0.4 0.6-0.4 1.4 0 0.4 0 0.8 0 1.2 0.6 0.2 1 0.8 1 1.4 0 0.7-0.7 1.4-1.5 1.4s-1.5-0.7-1.5-1.5c0-0.7 0.4-1.2 1-1.4 0-0.3 0-0.7 0-1.2s0.1-0.9 0.2-1.3c-0.7 0.1-1.5 0.4-2.2 1.7-0.6 1.1-0.9 4.7-0.9 4.7h13.7c0.1 0-0.2-3.6-0.8-4.7zM6.5 2.5c0-0.8 0.7-1.5 1.5-1.5s1.5 0.7 1.5 1.5-0.7 1.5-1.5 1.5-1.5-0.7-1.5-1.5z"></path><path d="M5 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"></path></g>
<g id="vaadin:dollar"><path d="M8.2 6.8c-0.1 0-0.1-0.1-0.2-0.1v-3.1c1.2 0.1 2.2 0.6 2.2 0.6l0.9-1.8c-0.1 0-1.5-0.8-3.1-0.8v-1.6h-1v1.6c-0.8 0.2-1.4 0.5-2 0.9-0.6 0.6-1 1.4-1 2.3 0 0.7 0.2 2.3 3 3.6v3.9c-0.9-0.2-2-0.7-2.4-0.9l-1 1.7c0.2 0.1 1.8 1 3.4 1.2v1.7h1v-1.7c0 0 0 0 0 0 2.3-0.3 3.6-2.1 3.6-3.8 0-1.5-1-2.7-3.4-3.7zM7 6.2c-0.8-0.5-1-1-1-1.3 0-0.4 0.1-0.7 0.4-0.9 0.2-0.1 0.4-0.2 0.6-0.3v2.5zM8 12.3v-3.4c1.1 0.5 1.6 1.1 1.6 1.6 0 0.6-0.3 1.6-1.6 1.8z"></path></g>
<g id="vaadin:dot-circle"><path d="M8 4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"></path><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path></g>
<g id="vaadin:download-alt"><path d="M0 14h16v2h-16v-2z"></path><path d="M8 13l5-5h-3v-8h-4v8h-3z"></path></g>
<g id="vaadin:download"><path d="M16 10h-5.5l-2.5 2.5-2.5-2.5h-5.5v6h16v-6zM4 14h-2v-2h2v2z"></path><path d="M10 6v-6h-4v6h-3l5 5 5-5z"></path></g>
<g id="vaadin:drop"><path d="M8 0c0 0-5 8.2-5 11s2.2 5 5 5 5-2.2 5-5-5-11-5-11zM8.9 14.9l-0.2-1c1.4-0.3 2.4-1.7 2.4-3.2 0-0.3-0.1-1.1-0.8-2.6l0.9-0.4c0.6 1.4 0.8 2.4 0.8 3 0 2-1.3 3.8-3.1 4.2z"></path></g>
<g id="vaadin:edit"><path d="M16 4c0 0 0-1-1-2s-1.9-1-1.9-1l-1.1 1.1v-2.1h-12v16h12v-8l4-4zM6.3 11.4l-0.6-0.6 0.3-1.1 1.5 1.5-1.2 0.2zM7.2 9.5l-0.6-0.6 5.2-5.2c0.2 0.1 0.4 0.3 0.6 0.5zM14.1 2.5l-0.9 1c-0.2-0.2-0.4-0.3-0.6-0.5l0.9-0.9c0.1 0.1 0.3 0.2 0.6 0.4zM11 15h-10v-14h10v2.1l-5.9 5.9-1.1 4.1 4.1-1.1 2.9-3v6z"></path></g>
<g id="vaadin:eject"><path d="M1 11h14l-7-10z"></path><path d="M1 12h14v3h-14v-3z"></path></g>
<g id="vaadin:elastic"><path d="M4.7 16v0c-1.7 0-3.1-0.8-4-2.1-1.1-1.7-0.9-4 0.4-5.8 0.9-1.3 2.1-2.1 3.6-2.4 1.2-0.3 2.2-1.1 2.5-2.2 0.2-0.8 0.7-1.5 1.3-2 0.9-1 2.2-1.5 3.5-1.5 1.1 0 2.2 0.4 2.9 1.2 1.5 1.6 1.5 4.2-0.1 6-0.5 0.6-1.2 1.1-2 1.4-1.2 0.5-2.2 1.6-2.6 3-0.3 1-0.8 1.9-1.5 2.6-1.1 1.2-2.6 1.8-4 1.8zM12 1c-1 0-2 0.4-2.8 1.2-0.5 0.5-0.8 1-1 1.6-0.5 1.5-1.8 2.5-3.3 2.9-1.2 0.2-2.2 0.9-3 2-1.1 1.5-1.2 3.3-0.3 4.7 0.6 1 1.8 1.6 3.1 1.6v0c1.2 0 2.4-0.5 3.3-1.4 0.6-0.6 1.1-1.4 1.3-2.2 0.4-1.7 1.6-3 3.2-3.6 0.6-0.2 1.2-0.7 1.6-1.2 1.2-1.4 1.3-3.5 0.1-4.7-0.6-0.6-1.4-0.9-2.2-0.9z"></path></g>
<g id="vaadin:ellipsis-circle-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M4 7h2v2h-2v-2z"></path><path d="M7 7h2v2h-2v-2z"></path><path d="M10 7h2v2h-2v-2z"></path></g>
<g id="vaadin:ellipsis-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM6 9h-2v-2h2v2zM9 9h-2v-2h2v2zM12 9h-2v-2h2v2z"></path></g>
<g id="vaadin:ellipsis-dots-h"><path d="M4 8c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M10 8c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M16 8c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:ellipsis-dots-v"><path d="M10 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M10 8c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M10 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:ellipsis-h"><path d="M0 6h4v4h-4v-4z"></path><path d="M6 6h4v4h-4v-4z"></path><path d="M12 6h4v4h-4v-4z"></path></g>
<g id="vaadin:ellipsis-v"><path d="M6 0h4v4h-4v-4z"></path><path d="M6 6h4v4h-4v-4z"></path><path d="M6 12h4v4h-4v-4z"></path></g>
<g id="vaadin:enter-arrow"><path d="M0 9l7 4v-3h9v-7l-3 2v2h-6v-3l-7 5z"></path></g>
<g id="vaadin:enter"><path d="M4 0v6h-3v10h14v-16h-11zM12 11h-5v2l-3-2.5 3-2.5v2h4v-3h1v4z"></path></g>
<g id="vaadin:envelope-o"><path d="M0 3v11h16v-11h-16zM1 7.1l3.9 2-3.9 3.4v-5.4zM1.9 13l4-3.5 2.1 1.1 2.1-1.1 4 3.5h-12.2zM15 12.5l-3.9-3.5 3.9-2v5.5zM15 5.9l-7 3.5-7-3.5v-1.9h14v1.9z"></path></g>
<g id="vaadin:envelope-open-o"><path d="M14 3.7v-0.7h-1.5l-4.5-3-4.6 3h-1.4v0.7l-2 1.3v11h16v-10.9l-2-1.4zM8 1.2l2.7 1.8h-5.5l2.8-1.8zM3 4h10v3.7l-3.5 1.7-1.5-1.3-1.5 1.4-3.5-1.7v-3.8zM1 5.5l1-0.7v2.4l-1-0.4v-1.3zM1 7.9l4.6 2.3-4.6 4v-6.3zM1.9 15l6.1-5.3 6.1 5.3h-12.2zM15 14.2l-4.7-4.1 4.7-2.3v6.4zM15 6.7l-1 0.5v-2.3l1 0.7v1.1z"></path></g>
<g id="vaadin:envelope-open"><path d="M14 3.7v3.7l2-1v-1.4z"></path><path d="M2 3.8l-2 1.2v1.5l2 1z"></path><path d="M11.2 2l-3.2-2-3.2 2z"></path><path d="M13 3h-10v4.9l3.4 1.7 1.6-1.2 1.6 1.2 3.4-1.7z"></path><path d="M16 7.6l-5.5 2.7 5.5 4.4z"></path><path d="M8 9.6l-8 6.4h16z"></path><path d="M5.5 10.3l-5.5-2.7v7.1z"></path></g>
<g id="vaadin:envelope"><path d="M0 3h16v2.4l-8 4-8-4z"></path><path d="M0 14l5.5-4.8 2.5 1.4 2.5-1.4 5.5 4.8z"></path><path d="M4.6 8.8l-4.6-2.3v6.5z"></path><path d="M11.4 8.8l4.6-2.3v6.5z"></path></g>
<g id="vaadin:envelopes-o"><path d="M14 2h-14v10h14v-10zM5.71 8l1.29 0.55 1.29-0.55 4.71 3h-12zM1 9.83v-4l3.64 1.63zM9.36 7.46l3.64-1.68v4zM13 3v1.68l-6 2.77-6-2.77v-1.68h12z"></path><path d="M15 4v9h-13v1h14v-10h-1z"></path></g>
<g id="vaadin:envelopes"><path d="M16 14h-14v-1h13v-9h1v10z"></path><path d="M14 10.77v-5.48l-4.68 2.18 4.68 3.3z"></path><path d="M8.28 7.96l-1.28 0.59-1.28-0.59-5.72 4.030v0.010l14-0.010-5.72-4.030z"></path><path d="M7 7.45l7-3.27v-2.18h-14v2.18l7 3.27z"></path><path d="M4.68 7.47l-4.68-2.18v5.48l4.68-3.3z"></path></g>
<g id="vaadin:eraser"><path d="M8.1 14l6.4-7.2c0.6-0.7 0.6-1.8-0.1-2.5l-2.7-2.7c-0.3-0.4-0.8-0.6-1.3-0.6h-1.8c-0.5 0-1 0.2-1.4 0.6l-6.7 7.6c-0.6 0.7-0.6 1.9 0.1 2.5l2.7 2.7c0.3 0.4 0.8 0.6 1.3 0.6h11.4v-1h-7.9zM6.8 13.9c0 0 0-0.1 0 0l-2.7-2.7c-0.4-0.4-0.4-0.9 0-1.3l3.4-3.9h-1l-3 3.3c-0.6 0.7-0.6 1.7 0.1 2.4l2.3 2.3h-1.3c-0.2 0-0.4-0.1-0.6-0.2l-2.8-2.8c-0.3-0.3-0.3-0.8 0-1.1l3.5-3.9h1.8l3.5-4h1l-3.5 4 3.1 3.7-3.5 4c-0.1 0.1-0.2 0.1-0.3 0.2z"></path></g>
<g id="vaadin:esc-a"><path d="M8 12c-0.726-0.029-1.409-0.177-2.043-0.425l0.403-0.915c0.435 0.202 0.945 0.319 1.482 0.319 0.326 0 0.643-0.043 0.943-0.125 0.121-0.109 0.215-0.285 0.215-0.484 0-0 0-0 0-0 0.070-0.43-0.22-0.62-1.17-1-0.83-0.29-2.040-0.76-1.83-2.080 0.072-0.594 0.46-1.082 0.989-1.296 0.223-0.053 0.466-0.081 0.715-0.081 0.724 0 1.393 0.235 1.934 0.633l-0.569 0.754c-0.366-0.248-0.817-0.396-1.302-0.396-0.123 0-0.243 0.009-0.361 0.028-0.215 0.084-0.377 0.296-0.387 0.547-0.080 0.401 0.14 0.581 1.15 1.001 0.85 0.33 2 0.77 1.8 2.080-0.067 0.511-0.364 0.94-0.782 1.186-0.323 0.163-0.696 0.256-1.090 0.256-0.034 0-0.069-0.001-0.103-0.002z"></path><path d="M13.71 12c-0.027 0.001-0.058 0.001-0.089 0.001-0.583 0-1.124-0.18-1.57-0.488-0.646-0.548-1.059-1.37-1.059-2.289 0-0.079 0.003-0.157 0.009-0.235-0.011-0.079-0.016-0.183-0.016-0.288 0-0.899 0.413-1.701 1.060-2.228 0.5-0.282 1.091-0.446 1.72-0.446 0.443 0 0.868 0.081 1.259 0.23l-0.374 0.922c-0.276-0.111-0.595-0.176-0.93-0.176-0.388 0-0.756 0.087-1.086 0.242-0.395 0.361-0.652 0.893-0.652 1.485 0 0.095 0.007 0.188 0.019 0.279-0.010 0.063-0.016 0.148-0.016 0.234 0 0.599 0.255 1.138 0.663 1.514 0.346 0.177 0.754 0.28 1.185 0.28 0.292 0 0.573-0.047 0.835-0.134l0.331 0.905c-0.383 0.121-0.823 0.19-1.279 0.19-0.004 0-0.008 0-0.012-0z"></path><path d="M5 4v-1h-4v9h4v-1h-3v-3h3v-1h-3v-3h3z"></path></g>
<g id="vaadin:esc"><path d="M0 0v16h16v-16h-16zM5 4h-3v3h3v1h-3v3h3v1h-4v-9h4v1zM10 10.54c-0.067 0.511-0.364 0.94-0.782 1.186-0.333 0.175-0.719 0.276-1.129 0.276-0.031 0-0.062-0.001-0.093-0.002-0.722-0.029-1.405-0.177-2.038-0.425l0.403-0.915c0.435 0.202 0.945 0.319 1.482 0.319 0.326 0 0.643-0.043 0.943-0.125 0.121-0.109 0.215-0.285 0.215-0.484 0-0 0-0 0-0 0.070-0.43-0.22-0.62-1.17-1-0.83-0.29-2.040-0.76-1.83-2.080 0.072-0.594 0.46-1.082 0.989-1.296 0.223-0.053 0.466-0.081 0.715-0.081 0.724 0 1.393 0.235 1.934 0.633l-0.569 0.754c-0.366-0.248-0.817-0.396-1.302-0.396-0.123 0-0.243 0.009-0.361 0.028-0.215 0.084-0.377 0.296-0.387 0.547-0.080 0.401 0.14 0.581 1.15 1.001 0.83 0.3 2.020 0.75 1.83 2.060zM12.67 10.72c0.345 0.176 0.752 0.279 1.183 0.279 0.292 0 0.573-0.047 0.835-0.134l0.311 0.945c-0.383 0.121-0.823 0.19-1.279 0.19-0 0-0.001 0-0.001 0-0.027 0.001-0.058 0.001-0.089 0.001-0.583 0-1.124-0.18-1.57-0.488-0.651-0.548-1.069-1.374-1.069-2.297 0-0.076 0.003-0.152 0.008-0.227-0.010-0.079-0.016-0.183-0.016-0.288 0-0.899 0.413-1.701 1.060-2.228 0.5-0.282 1.091-0.446 1.72-0.446 0.443 0 0.868 0.081 1.259 0.23l-0.374 0.922c-0.276-0.111-0.595-0.176-0.93-0.176-0.388 0-0.756 0.087-1.086 0.242-0.395 0.361-0.652 0.893-0.652 1.485 0 0.095 0.007 0.188 0.019 0.279-0.008 0.055-0.013 0.13-0.013 0.206 0 0.592 0.25 1.126 0.65 1.502z"></path></g>
<g id="vaadin:euro"><path d="M10.89 3c1.166 0.009 2.244 0.383 3.127 1.011l-0.017-2.321c-0.918-0.433-1.994-0.686-3.129-0.686-3.606 0-6.616 2.551-7.323 5.947l-1.548 0.049v1h1.41c0 0.17 0 0.33 0 0.5-0.005 0.075-0.008 0.162-0.008 0.25s0.003 0.175 0.008 0.262l-1.411-0.012v1h1.54c0.882 3.353 3.805 5.818 7.331 5.999 1.149-0.002 2.218-0.256 3.175-0.708l-0.045-2.291c-0.866 0.617-1.944 0.991-3.108 1-2.461-0.128-4.512-1.744-5.28-3.959l6.388-0.041v-1h-6.59c-0.006-0.075-0.009-0.162-0.009-0.25s0.003-0.175 0.010-0.261c-0.001-0.159-0.001-0.319-0.001-0.489h6.59v-1h-6.4c0.678-2.325 2.788-3.996 5.29-4z"></path></g>
<g id="vaadin:exchange"><path d="M16 5v2h-13v2l-3-3 3-3v2z"></path><path d="M0 12v-2h13v-2l3 3-3 3v-2z"></path></g>
<g id="vaadin:exclamation-circle-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M7 3h2v7h-2v-7z"></path><path d="M7 11h2v2h-2v-2z"></path></g>
<g id="vaadin:exclamation-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM9 13h-2v-2h2v2zM9 10h-2v-7h2v7z"></path></g>
<g id="vaadin:exclamation"><path d="M6 0h4v4l-1 7h-2l-1-7z"></path><path d="M10 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:exit-o"><path d="M10 0c1.1 0 2 0.9 2 2 0 0.9-0.6 1.7-1.5 1.9 0 0 0 0.1 0 0.1 0.4 0 0.7 0.2 1 0.5l1.3 1.3c0.1 0.1 0.3 0.2 0.5 0.2h1.7v-6h-5z"></path><path d="M11.8 14.5l-3.8-4.5v2.5c0 0.8-0.7 1.5-1.5 1.5h-3.5c-0.6 0-1-0.4-1-1s0.4-1 1-1h2.5c0.3 0 0.5-0.2 0.5-0.5v-2c0-0.7 0.1-1.3 0.4-2l0.7-1.5h-0.8c-0.5 0-0.9 0.2-1.2 0.6l-0.5 0.7c-0.2 0.4-0.7 0.5-1.2 0.3-0.4-0.3-0.6-0.9-0.2-1.3l0.6-0.8c0.7-1 1.9-1.5 3.1-1.5h2l0.1-0.3c-0.6-0.3-1-1-1-1.7 0-1.1 0.9-2 2-2h-7v4.9l-0.6 0.8c-0.3 0.4-0.5 0.9-0.4 1.5 0.1 0.5 0.4 1 0.9 1.3 0 0 0 0 0 0v2.5c-1.1 0-2 0.9-2 2s0.9 2 2 2v1h11.6c-1.1 0-2.1-0.6-2.7-1.5z"></path><path d="M11.4 7.3l-0.7-0.8-0.6 1.5c-0.2 0.5-0.3 0.9 0 1.3l4.9 6.1v-7.4h-2.1c-0.6 0-1.1-0.2-1.5-0.7z"></path></g>
<g id="vaadin:exit"><path d="M14 6h-1.7c-0.2 0-0.4-0.1-0.6-0.2l-1.3-1.3c-0.2-0.3-0.6-0.5-1.1-0.5h-0.3c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2c0 0.7 0.4 1.4 1 1.7l-0.2 0.3h-2c-1.1 0-2.3 0.5-3 1.5l-0.6 0.8c-0.4 0.4-0.2 1 0.2 1.3 0.4 0.2 0.9 0.1 1.2-0.3l0.5-0.7c0.3-0.4 0.7-0.6 1.2-0.6h0.8l-0.7 1.6c-0.3 0.6-0.4 1.2-0.4 1.9v2c0 0.3-0.2 0.5-0.5 0.5h-2.5c-0.6 0-1 0.4-1 1s0.4 1 1 1h3.5c0.8 0 1.5-0.7 1.5-1.5v-2.5l3.8 4.5c0.6 0.9 1.7 1.5 2.8 1.5h0.9l-5.4-6.7c-0.3-0.4-0.2-0.8 0-1.3l0.6-1.5 0.7 0.8c0.4 0.4 1 0.7 1.6 0.7h2c0.6 0 1-0.4 1-1s-0.4-1-1-1z"></path></g>
<g id="vaadin:expand-full"><path d="M5.3 6.7l1.4-1.4-3-3 1.3-1.3h-4v4l1.3-1.3z"></path><path d="M6.7 10.7l-1.4-1.4-3 3-1.3-1.3v4h4l-1.3-1.3z"></path><path d="M10.7 9.3l-1.4 1.4 3 3-1.3 1.3h4v-4l-1.3 1.3z"></path><path d="M11 1l1.3 1.3-3 3 1.4 1.4 3-3 1.3 1.3v-4z"></path></g>
<g id="vaadin:expand-square"><path d="M11 2h-9v9l1-1v-7h7z"></path><path d="M5 14h9v-9l-1 1v7h-7z"></path><path d="M16 0h-5l1.8 1.8-4.5 4.5 1.4 1.4 4.5-4.5 1.8 1.8z"></path><path d="M7.7 9.7l-1.4-1.4-4.5 4.5-1.8-1.8v5h5l-1.8-1.8z"></path></g>
<g id="vaadin:expand"><path d="M15 1h-4l1.3 1.3-4.5 4.5 1.4 1.4 4.5-4.5 1.3 1.3z"></path><path d="M6.8 7.8l-4.5 4.5-1.3-1.3v4h4l-1.3-1.3 4.5-4.5z"></path></g>
<g id="vaadin:external-browser"><path d="M11 10l-2.9-3.2-3.3 3.2h2.2v1.8c0 1.7-0.9 4.2-4 4.2 4.8 0 6-1.4 6-4.3v-1.7h2z"></path><path d="M0 0v13h6v-1h-5v-9h14v9h-5v1h6v-13h-16zM2 2h-1v-1h1v1zM13 2h-10v-1h10v1z"></path></g>
<g id="vaadin:external-link"><path d="M14 16v-11l-1 1v9h-12v-12h9l1-1h-11v14z"></path><path d="M16 0h-5l1.8 1.8-6.8 6.8 1.4 1.4 6.8-6.8 1.8 1.8z"></path></g>
<g id="vaadin:eye-slash"><path d="M12.9 5.2l-0.8 0.8c1.7 0.9 2.5 2.3 2.8 3-0.7 0.9-2.8 3.1-7 3.1-0.7 0-1.2-0.1-1.8-0.2l-0.8 0.8c0.8 0.3 1.7 0.4 2.6 0.4 5.7 0 8.1-4 8.1-4s-0.6-2.4-3.1-3.9z"></path><path d="M12 7.1c0-0.3 0-0.6-0.1-0.8l-4.8 4.7c0.3 0 0.6 0.1 0.9 0.1 2.2 0 4-1.8 4-4z"></path><path d="M15.3 0l-4.4 4.4c-0.8-0.2-1.8-0.4-2.9-0.4-6.7 0-8 5.1-8 5.1s1 1.8 3.3 3l-3.3 3.2v0.7h0.7l15.3-15.3v-0.7h-0.7zM4 11.3c-1.6-0.7-2.5-1.8-2.9-2.3 0.3-0.7 1.1-2.2 3.1-3.2-0.1 0.4-0.2 0.8-0.2 1.3 0 1.1 0.5 2.2 1.3 2.9l-1.3 1.3zM6.2 7.9l-1 0.2c0 0-0.3-0.5-0.3-1.2 0-0.8 0.4-1.5 0.4-1.5 0.5-0.3 1.3-0.3 1.3-0.3s-0.5 0.9-0.5 1.7c-0.1 0.7 0.1 1.1 0.1 1.1z"></path></g>
<g id="vaadin:eye"><path d="M8 3.9c-6.7 0-8 5.1-8 5.1s2.2 4.1 7.9 4.1 8.1-4 8.1-4-1.3-5.2-8-5.2zM5.3 5.4c0.5-0.3 1.3-0.3 1.3-0.3s-0.5 0.9-0.5 1.6c0 0.7 0.2 1.1 0.2 1.1l-1.1 0.2c0 0-0.3-0.5-0.3-1.2 0-0.8 0.4-1.4 0.4-1.4zM7.9 12.1c-4.1 0-6.2-2.3-6.8-3.2 0.3-0.7 1.1-2.2 3.1-3.2-0.1 0.4-0.2 0.8-0.2 1.3 0 2.2 1.8 4 4 4s4-1.8 4-4c0-0.5-0.1-0.9-0.2-1.3 2 0.9 2.8 2.5 3.1 3.2-0.7 0.9-2.8 3.2-7 3.2z"></path></g>
<g id="vaadin:eyedropper"><path d="M15 1c-1.8-1.8-3.7-0.7-4.6 0.1-0.4 0.4-0.7 0.9-0.7 1.5v0c0 1.1-1.1 1.8-2.1 1.5l-0.1-0.1-0.7 0.8 0.7 0.7-6 6-0.8 2.3-0.7 0.7 1.5 1.5 0.8-0.8 2.3-0.8 6-6 0.7 0.7 0.7-0.6-0.1-0.2c-0.3-1 0.4-2.1 1.5-2.1v0c0.6 0 1.1-0.2 1.4-0.6 0.9-0.9 2-2.8 0.2-4.6zM3.9 13.6l-2 0.7-0.2 0.1 0.1-0.2 0.7-2 5.8-5.8 1.5 1.5-5.9 5.7z"></path></g>
<g id="vaadin:facebook-square"><path d="M0 0v16h16v-16h-16zM12.9 8.4h-2.1v5.6h-2.1v-5.6h-1.5v-2h1.5c0 0 0-0.8 0-1.7 0-1.5 0.9-2.7 2.9-2.7 0.8 0 1.4 0.1 1.4 0.1v1.9c0 0-0.6 0-1.3 0s-0.8 0.3-0.8 0.9c0 0.1 0 0.1 0 0.1 0 0.2 0 0.5 0 1.4h2.1l-0.1 2z"></path></g>
<g id="vaadin:facebook"><path d="M7.2 16v-7.5h-2v-2.7h2c0 0 0-1.1 0-2.3 0-1.8 1.2-3.5 3.9-3.5 1.1 0 1.9 0.1 1.9 0.1l-0.1 2.5c0 0-0.8 0-1.7 0-1 0-1.1 0.4-1.1 1.2 0 0.6 0-1.3 0 2h2.9l-0.1 2.7h-2.8v7.5h-2.9z"></path></g>
<g id="vaadin:factory"><path d="M4.4 1.3c-0.6 0.3-0.8 1.1-0.4 1.5 0.5-0.9 1.3-0.6 2.5 0.4 0.8 0.7 1.9 0.1 1.9 0.1s0.2 1.2 1.7 1.4c1.7 0.2 2.3-0.8 2.3-0.8s0.4 1 1.9 0.4c1.1-0.4 0.7-1.1 0.7-1.1s1 0 1-0.7c0-0.9-1.1-0.8-1.1-0.8s0.2-1-0.9-1.1c-1-0.1-1.3 0.5-1.3 0.5s-0.3-1.1-1.8-1.1c-1.4 0-1.9 1.3-1.9 1.3s-0.4-0.6-1.6-0.6c-0.9 0-1.3 0.7-1.3 0.7s-1.1-0.5-1.7-0.1z"></path><path d="M12 12.1v-2.1l-4 2.1v-2.1h-2.4l-0.6-7h-2l-0.6 7h-2.4v6h16v-6l-4 2.1zM6 14h-4v-2h4v2z"></path></g>
<g id="vaadin:family"><path d="M9.5 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path><path d="M14.27 4h-2.54c0 0 0 0 0 0-0.955 0-1.73 0.775-1.73 1.73v3.27c0 0.552 0.448 1 1 1v6h4v-6c0.552 0 1-0.448 1-1v-3.27c0-0.955-0.775-1.73-1.73-1.73 0 0 0 0 0 0z"></path><path d="M15 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M4.27 5h-2.54c-0.955 0-1.73 0.775-1.73 1.73s0.775 1.73 1.73 1.73c0.955 0 1.73-0.775 1.73-1.73s-0.775-1.73-1.73-1.73c-0.955 0-1.73 0.775-1.73 1.73v2.27c0 0.552 0.448 1 1 1l-1 3h1v3h4v-3h1l-1-3c0.552 0 1-0.448 1-1v-2.27c0-0.955-0.775-1.73-1.73-1.73 0 0 0 0 0 0z"></path><path d="M5 3c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M7 13v3h2v-3c0.552 0 1-0.448 1-1v-1.54c0-0.806-0.654-1.46-1.46-1.46 0 0 0 0 0 0h-1.080c-0.806 0-1.46 0.654-1.46 1.46 0 0 0 0 0 0v1.54c0 0.552 0.448 1 1 1z"></path></g>
<g id="vaadin:fast-backward"><path d="M16 15v-14l-7 7z"></path><path d="M9 15v-14l-7 7z"></path><path d="M0 1h2v14h-2v-14z"></path></g>
<g id="vaadin:fast-forward"><path d="M0 1v14l7-7z"></path><path d="M7 1v14l7-7z"></path><path d="M14 1h2v14h-2v-14z"></path></g>
<g id="vaadin:female"><path d="M10 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M10 8v-1.5l1.8 1.8c0.3 0.3 0.7 0.3 1 0s0.3-0.8 0-1l-2.6-2.6c-0.4-0.5-1-0.7-1.7-0.7h-1c-0.7 0-1.3 0.2-1.7 0.7l-2.6 2.6c-0.3 0.3-0.3 0.8 0 1 0.3 0.3 0.7 0.3 1 0l1.8-1.8v1.5l-4 5h4v3h4v-3h4l-4-5z"></path></g>
<g id="vaadin:file-add"><path d="M12 15h-10v-14h6v4h4v1h1v-2l-4-4h-8v16h12v-2h-1v1zM9 1l3 3h-3v-3z"></path><path d="M13 7h-2v2h-2v2h2v2h2v-2h2v-2h-2v-2z"></path></g>
<g id="vaadin:file-code"><path d="M10 0h-8v16h12v-12l-4-4zM9 5h4v10h-10v-14h6v4zM10 4v-3l3 3h-3z"></path><path d="M6.2 13h-0.7l-2-2.5 2-2.5h0.7l-2 2.5z"></path><path d="M9.8 13h0.7l2-2.5-2-2.5h-0.7l2 2.5z"></path><path d="M6.7 14h0.6l2.1-7h-0.8z"></path></g>
<g id="vaadin:file-font"><path d="M10 0h-8v16h12v-12l-4-4zM9 5h4v10h-10v-14h6v4zM10 4v-3l3 3h-3z"></path><path d="M5 7v2h2v5h2v-5h2v-2z"></path></g>
<g id="vaadin:file-movie"><path d="M10 0h-8v16h12v-12l-4-4zM9 5h4v10h-10v-14h6v4zM10 4v-3l3 3h-3z"></path><path d="M10 10v-2h-6v5h6v-2l2 2v-5z"></path></g>
<g id="vaadin:file-o"><path d="M10 0h-8v16h12v-12l-4-4zM9 5h4v10h-10v-14h6v4zM10 4v-3l3 3h-3z"></path></g>
<g id="vaadin:file-picture"><path d="M10 0h-8v16h12v-12l-4-4zM9 5h4v10h-10v-14h6v4zM10 4v-3l3 3h-3z"></path><path d="M4 11.5v2.5h8v-1.7c0 0 0.1-1.3-1.3-1.5-1.3-0.2-1.5 0.4-2.5 0.5-0.8 0-0.6-1.3-2.2-1.3-1.2 0-2 1.5-2 1.5z"></path><path d="M12 8.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path></g>
<g id="vaadin:file-presentation"><path d="M10 0h-8v16h12v-12l-4-4zM13 15h-10v-14h6v4h4v10zM10 4v-3l3 3h-3z"></path><path d="M9 6h-2v1h-3v6h2v1h1v-1h2v1h1v-1h2v-6h-3v-1zM11 8v4h-6v-4h6z"></path><path d="M7 9v2l2-1z"></path></g>
<g id="vaadin:file-process"><path d="M12 0h-7v6h0.7l0.2 0.7 0.1 0.1v-5.8h5v4h4v9h-6l0.3 0.5-0.5 0.5h7.2v-11l-4-4zM12 4v-3l3 3h-3z"></path><path d="M5.5 11.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M7.9 12.4l1.1-0.4v-1l-1.1-0.4c-0.1-0.3-0.2-0.6-0.4-0.9l0.5-1-0.7-0.7-1 0.5c-0.3-0.2-0.6-0.3-0.9-0.4l-0.4-1.1h-1l-0.4 1.1c-0.3 0.1-0.6 0.2-0.9 0.4l-1-0.5-0.7 0.7 0.5 1.1c-0.2 0.3-0.3 0.6-0.4 0.9l-1.1 0.3v1l1.1 0.4c0.1 0.3 0.2 0.6 0.4 0.9l-0.5 1 0.7 0.7 1.1-0.5c0.3 0.2 0.6 0.3 0.9 0.4l0.3 1.1h1l0.4-1.1c0.3-0.1 0.6-0.2 0.9-0.4l1 0.5 0.7-0.7-0.5-1.1c0.2-0.2 0.3-0.5 0.4-0.8zM4.5 13.5c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2c0 1.1-0.9 2-2 2z"></path></g>
<g id="vaadin:file-refresh"><path d="M10 0h-8v16h12v-12l-4-4zM13 15h-10v-14h6v4h4v10zM10 4v-3l3 3h-3z"></path><path d="M4.7 7.7l-0.7-0.7v3h3l-1.2-1.2c0.4-0.8 1.3-1.3 2.2-1.3 1.4 0 2.5 1.1 2.5 2.5h1.5c0-2.2-1.8-4-4-4-1.3 0-2.5 0.7-3.3 1.7z"></path><path d="M9.8 11.8c-0.5 0.5-1.1 0.8-1.8 0.7-1 0-1.9-0.6-2.3-1.5h-1.6c0.4 1.7 2 3 3.8 3 1.1 0 2.1-0.5 2.8-1.2l1.3 1.2v-3h-3l0.8 0.8z"></path></g>
<g id="vaadin:file-remove"><path d="M12 15h-10v-14h6v4h4v2.59l1-1v-2.59l-4-4h-8v16h12v-2.59l-1-1v2.59zM9 1l3 3h-3v-3z"></path><path d="M15 8l-1-1-2 2-2-2-1 1 2 2-2 2 1 1 2-2 2 2 1-1-2-2 2-2z"></path></g>
<g id="vaadin:file-search"><path d="M12 13.47v1.53h-10v-14h6v4h4v0.56c0.386 0.229 0.716 0.504 0.996 0.825l0.004-2.385-4-4h-8v16h12v-1.53zM9 1l3 3h-3v-3z"></path><path d="M14.78 12.72l-1.92-1.92c-0.089-0.085-0.201-0.148-0.325-0.179 0.292-0.458 0.468-1.018 0.468-1.618 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 1.657 1.343 3 3 3 0.6 0 1.16-0.176 1.629-0.48 0.020 0.136 0.083 0.248 0.169 0.337l1.92 1.92c0.134 0.125 0.313 0.201 0.511 0.201 0.414 0 0.75-0.336 0.75-0.75 0-0.198-0.077-0.378-0.202-0.512zM10 11c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z"></path></g>
<g id="vaadin:file-sound"><path d="M11.4 10.5c0 1.2-0.4 2.2-1 3l0.4 0.5c0.7-0.9 1.2-2.1 1.2-3.5s-0.5-2.6-1.2-3.5l-0.4 0.5c0.6 0.8 1 1.9 1 3z"></path><path d="M9.9 8l-0.4 0.5c0.4 0.5 0.7 1.2 0.7 2s-0.3 1.5-0.7 2l0.4 0.5c0.5-0.6 0.8-1.5 0.8-2.5s-0.3-1.8-0.8-2.5z"></path><path d="M9.1 9l-0.4 0.5c0.2 0.3 0.3 0.6 0.3 1s-0.1 0.7-0.3 1l0.4 0.5c0.3-0.4 0.5-0.9 0.5-1.5s-0.2-1.1-0.5-1.5z"></path><path d="M10 0h-8v16h12v-12l-4-4zM9 5h4v10h-10v-14h6v4zM10 4v-3l3 3h-3z"></path><path d="M6 9h-2v3h2l2 2v-7z"></path></g>
<g id="vaadin:file-start"><path d="M10 0h-8v16h12v-12l-4-4zM13 15h-10v-14h6v4h4v10zM10 4v-3l3 3h-3z"></path><path d="M5 6v6l6-3z"></path></g>
<g id="vaadin:file-table"><path d="M10 0h-8v16h12v-12l-4-4zM9 5h4v10h-10v-14h6v4zM10 4v-3l3 3h-3z"></path><path d="M4 7v6h8v-6h-8zM6 12h-1v-1h1v1zM6 10h-1v-1h1v1zM9 12h-2v-1h2v1zM9 10h-2v-1h2v1zM11 12h-1v-1h1v1zM11 10h-1v-1h1v1z"></path></g>
<g id="vaadin:file-text-o"><path d="M10 0h-8v16h12v-12l-4-4zM9 5h4v10h-10v-14h6v4zM10 4v-3l3 3h-3z"></path><path d="M4 7h8v1h-8v-1z"></path><path d="M4 9h8v1h-8v-1z"></path><path d="M4 11h8v1h-8v-1z"></path></g>
<g id="vaadin:file-text"><path d="M10 0v4h4z"></path><path d="M9 0h-7v16h12v-11h-5v-5zM12 12h-8v-1h8v1zM12 10h-8v-1h8v1zM12 7v1h-8v-1h8z"></path></g>
<g id="vaadin:file-tree-small"><path d="M5 12v2h11v-5h-11v2h-2v-4h9v-5h-12v5h2v5z"></path></g>
<g id="vaadin:file-tree-sub"><path d="M8 11v1h-1v-2h5v-4h-8v1h-1v-2h6v-4h-9v4h2v3h2v2h2v3h2v2h8v-4z"></path></g>
<g id="vaadin:file-tree"><path d="M16 10v-4h-11v1h-2v-3h9v-4h-12v4h2v10h3v2h11v-4h-11v1h-2v-5h2v2z"></path></g>
<g id="vaadin:file-zip"><path d="M10 0h-8v16h12v-12l-4-4zM9 15h-4v-2.8l0.7-2.2h2.4l0.9 2.2v2.8zM13 15h-3v-3l-1-3h-2v-1h-2v1l-1 3v3h-1v-14h4v1h2v1h-2v1h2v1h4v10zM10 4v-3l3 3h-3z"></path><path d="M5 6h2v1h-2v-1z"></path><path d="M5 2h2v1h-2v-1z"></path><path d="M5 4h2v1h-2v-1z"></path><path d="M7 5h2v1h-2v-1z"></path><path d="M7 7h2v1h-2v-1z"></path><path d="M6 12h2v2h-2v-2z"></path></g>
<g id="vaadin:file"><path d="M9 5h5v11h-12v-16h7v5zM10 4v-4l4 4h-4z"></path></g>
<g id="vaadin:fill"><path d="M13 14.5c0.468-2.207 0.985-4.050 1.604-5.846 0.411 1.796 0.928 3.638 1.337 5.521 0.059 1.153-0.612 1.825-1.441 1.825s-1.5-0.672-1.5-1.5z"></path><path d="M8 1l-1.44 1.44-2-2c-0.276-0.262-0.649-0.423-1.060-0.423s-0.784 0.161-1.061 0.423c-0.27 0.271-0.438 0.645-0.438 1.059s0.168 0.789 0.439 1.060l2 2-4.44 4.44 7 7 8-8zM8 2.41l5.59 5.59h-11.18l2.75-2.75c0.071 0.042 0.156 0.067 0.247 0.067 0.271 0 0.49-0.219 0.49-0.49 0-0.091-0.025-0.176-0.068-0.249l0.721-0.718 1.54 1.53c0.091 0.091 0.216 0.147 0.355 0.147 0.277 0 0.502-0.225 0.502-0.502 0-0.139-0.056-0.264-0.147-0.355l-1.53-1.53zM3.15 1.85c-0.091-0.091-0.148-0.216-0.148-0.355s0.057-0.264 0.148-0.355c0.092-0.089 0.217-0.144 0.355-0.144s0.263 0.055 0.355 0.144l2 2-0.71 0.71z"></path></g>
<g id="vaadin:film"><path d="M0 0v16h1v-1h1v1h12v-1h1v1h1v-16h-16zM2 14h-1v-1h1v1zM2 12h-1v-1h1v1zM2 10h-1v-1h1v1zM2 8h-1v-1h1v1zM2 6h-1v-1h1v1zM2 4h-1v-1h1v1zM2 2h-1v-1h1v1zM13 15h-10v-6h10v6zM13 7h-10v-6h10v6zM15 14h-1v-1h1v1zM15 12h-1v-1h1v1zM15 10h-1v-1h1v1zM15 8h-1v-1h1v1zM15 6h-1v-1h1v1zM15 4h-1v-1h1v1zM15 2h-1v-1h1v1z"></path></g>
<g id="vaadin:filter"><path d="M1 2h14v2l-6 5v7l-2-2v-5l-6-5v-2z"></path><path d="M1 0h14v1h-14v-1z"></path></g>
<g id="vaadin:fire"><path d="M4.9 15.8c0 0-3.9-0.4-3.9-5.7 0-4.1 3.1-6.5 3.1-6.5s1.3 1.4 2.3 1.9c1 0.6 1.4-5.5 1.4-5.5s7.2 3.9 7.2 9.8c0 6.1-4 5.9-4 5.9s1.8-2.4 1.8-5.2c0-3-3.9-6.7-3.9-6.7s-0.5 4.4-2.1 5c-1.6-0.9-2.5-2.3-2.5-2.3s-3.7 5.8 0.6 9.3z"></path><path d="M8.2 16.1c-2-0.1-3.7-1.4-3.7-3.2s0.7-2.6 0.7-2.6 0.5 1 1.1 1.5 1.8 0.8 2.4 0.1c0.6-0.6 0.8-2.3 0.8-2.3s1.4 1.1 1.2 3c-0.1 2-0.9 3.5-2.5 3.5z"></path></g>
<g id="vaadin:flag-checkered"><path d="M2 0c-1.1 0-2 0.9-2 2 0 0.7 0.4 1.4 1 1.7v12.3h2v-12.3c0.6-0.3 1-1 1-1.7 0-1.1-0.9-2-2-2z"></path><path d="M12 2c-2.1 0-1.8-1-4.4-1s-3.6 3-3.6 3v8c0 0 0.7-2 3-2 2.7 0 2.8 1 5 1 3.3 0 4-2 4-2v-8c0 0-1.6 1-4 1zM15 4.5c-0.2 0.2-0.8 0.4-2 0.6v-2.2c0.8-0.1 1.5-0.2 2-0.4v2zM5 7.9v-2.6c0.4-0.6 1.1-1.1 2-1.1v-2.1c0.2-0.1 0.4-0.1 0.6-0.1 1.2 0 1.6 0.2 2.1 0.4 0.1 0.1 0.2 0.2 0.3 0.2v2.2c0.5 0.2 1.1 0.4 2 0.4 0.4 0 0.7 0 1-0.1v2.6c-0.3 0-0.6 0.1-1 0.1-1.1 0-1.5-0.2-2-0.5v2.3c-0.7-0.3-1.5-0.6-3-0.6v-2.2c-0.9 0.2-1.5 0.6-2 1.1zM13 9.9v-2.2c1.1-0.2 1.7-0.6 2-0.8v1.8c-0.2 0.3-0.7 1-2 1.2z"></path><path d="M10 7.2v-2.4c0 0-1.2-0.6-3-0.6v2.6c1.7-0.4 3 0.4 3 0.4z"></path></g>
<g id="vaadin:flag-o"><path d="M4 2c0-1.1-0.9-2-2-2s-2 0.9-2 2c0 0.7 0.4 1.4 1 1.7v12.3h2v-12.3c0.6-0.3 1-1 1-1.7z"></path><path d="M7.6 2c1.2 0 1.6 0.2 2.1 0.4 0.5 0.3 1.1 0.6 2.3 0.6s2.2-0.2 3-0.5v6.3c-0.2 0.3-0.9 1.2-3 1.2-0.9 0-1.3-0.2-1.9-0.4-0.7-0.3-1.5-0.6-3.1-0.6-0.8 0-1.5 0.2-2 0.5v-5.3c0.2-0.5 1-2.2 2.6-2.2zM16 1c0 0-1.6 1-4 1-2.1 0-1.8-1-4.4-1s-3.6 3-3.6 3v8c0 0 0.7-2 3-2 2.7 0 2.8 1 5 1 3.3 0 4-2 4-2v-8z"></path></g>
<g id="vaadin:flag"><path d="M4 2c0-1.1-0.9-2-2-2s-2 0.9-2 2c0 0.7 0.4 1.4 1 1.7v12.3h2v-12.3c0.6-0.3 1-1 1-1.7z"></path><path d="M4 4c0 0 1-3 3.6-3 2.7 0 2.3 1 4.4 1 2.4 0 4-1 4-1v8c0 0-0.7 2-4 2-2.2 0-2.3-1-5-1-2.3 0-3 2-3 2v-8z"></path></g>
<g id="vaadin:flash"><path d="M16 8l-2.2-1.6 1.1-2.4-2.7-0.2-0.2-2.7-2.4 1.1-1.6-2.2-1.6 2.2-2.4-1.1-0.2 2.7-2.7 0.2 1.1 2.4-2.2 1.6 2.2 1.6-1.1 2.4 2.7 0.2 0.2 2.7 2.4-1.1 1.6 2.2 1.6-2.2 2.4 1.1 0.2-2.7 2.7-0.2-1.1-2.4 2.2-1.6z"></path></g>
<g id="vaadin:flask"><path d="M2 16h12l-4-8v-7h1v-1h-6v1h1v7l-4 8zM9 1v7.2l1.9 3.8h-5.8l1.9-3.8v-7.2h2z"></path></g>
<g id="vaadin:flight-landing"><path d="M13.64 7c-0.71-0.2-1.89-0.43-3.23-0.67l-3.82-4.24c-0.209-0.23-0.462-0.416-0.746-0.544l-1.194-0.546c-0.090 0-0.15 0-0.1 0.11s1.45 2.89 2.29 4.59c-1.84-0.29-3.5-0.53-4.23-0.63-0.258-0.047-0.474-0.198-0.608-0.406l-0.722-1.074c-0.115-0.168-0.28-0.294-0.474-0.358l-0.806-0.232 0.61 3.26c0.067 0.34 0.318 0.609 0.644 0.699 1.326 0.381 4.816 1.341 7.526 1.921 6 1.28 6.8 1.28 7.12 0.91s-0.67-2.38-2.26-2.79z"></path><path d="M0 13h16v1h-16v-1z"></path></g>
<g id="vaadin:flight-takeoff"><path d="M12.57 2.26c-0.65 0.29-1.66 0.85-2.8 1.5l-5.46-0.76c-0.093-0.014-0.2-0.022-0.309-0.022-0.211 0-0.414 0.030-0.607 0.086l-1.185 0.336c-0.1 0-0.1 0.1 0 0.14l4.56 2c-1.54 0.92-2.91 1.76-3.51 2.14-0.13 0.082-0.288 0.13-0.458 0.13-0.094 0-0.184-0.015-0.268-0.042l-1.194-0.378c-0.086-0.031-0.186-0.049-0.29-0.049s-0.204 0.018-0.296 0.051l-0.754 0.308 2.52 2.1c0.152 0.127 0.349 0.205 0.565 0.205 0.129 0 0.251-0.028 0.361-0.077 1.204-0.538 4.374-1.998 6.734-3.228 5.24-2.78 5.82-3.26 5.82-3.7 0-0.69-2-1.4-3.43-0.74z"></path><path d="M0 13h16v1h-16v-1z"></path></g>
<g id="vaadin:flip-h"><path d="M0 15l6-5-6-4.9z"></path><path d="M9 10.1l6 4.9v-10l-6 5.1zM14 12.9l-3.4-2.8 3.4-3v5.8z"></path><path d="M7 5h1v1h-1v-1z"></path><path d="M7 3h1v1h-1v-1z"></path><path d="M7 7h1v1h-1v-1z"></path><path d="M7 9h1v1h-1v-1z"></path><path d="M7 11h1v1h-1v-1z"></path><path d="M7 13h1v1h-1v-1z"></path><path d="M7 15h1v1h-1v-1z"></path><path d="M7.5 1v0c1.3 0 2.6 0.7 3.6 1.9l-1.1 1.1h3v-3l-1.2 1.2c-1.2-1.4-2.7-2.2-4.3-2.2 0 0 0 0 0 0-1.9 0-3.6 1-4.9 2.9l0.8 0.6c1.1-1.6 2.5-2.5 4.1-2.5z"></path></g>
<g id="vaadin:flip-v"><path d="M1 1l5 6 4.94-6h-9.94z"></path><path d="M5.94 10l-4.94 6h10zM3.12 15l2.83-3.44 3 3.44h-5.83z"></path><path d="M10 8h1v1h-1v-1z"></path><path d="M12 8h1v1h-1v-1z"></path><path d="M8 8h1v1h-1v-1z"></path><path d="M6 8h1v1h-1v-1z"></path><path d="M4 8h1v1h-1v-1z"></path><path d="M2 8h1v1h-1v-1z"></path><path d="M0 8h1v1h-1v-1z"></path><path d="M15 8.47v0c-0.059 1.485-0.782 2.789-1.879 3.632l-1.121-1.102v3h3l-1.18-1.18c1.293-1.031 2.128-2.588 2.18-4.342l0-0.008c-0.092-2.083-1.223-3.883-2.884-4.905l-0.596 0.805c1.423 0.857 2.383 2.357 2.479 4.087z"></path></g>
<g id="vaadin:folder-add"><path d="M14 6v-2h-7l-1-2h-4l-1 2h-1v11h14v-1h-13v-9h0.62l1-2h2.57l1.19 2h6.62v1h1z"></path><path d="M14 7h-2v2h-2v2h2v2h2v-2h2v-2h-2v-2z"></path></g>
<g id="vaadin:folder-o"><path d="M7 4l-1-2h-4l-1 2h-1v11h16v-11h-9zM15 14h-14v-9h0.6l1-2h2.6l1.2 2h8.6v9z"></path></g>
<g id="vaadin:folder-open-o"><path d="M14 6v-2h-7l-1-2h-4l-1 2h-1v11h14l2-9h-2zM14.9 7l-1.6 7-11.9-0.1 2.3-6.9h11.2zM1 5h0.6l1-2h2.6l1.2 2h6.6v1h-10l-2 5.9v-6.9z"></path></g>
<g id="vaadin:folder-open"><path d="M14 6v-2h-7l-1-2h-4l-1 2h-1v9.5l3-7.5z"></path><path d="M3.7 7l-3.2 8h12.8l2.5-8z"></path></g>
<g id="vaadin:folder-remove"><path d="M13 12.41v1.59h-12v-9h0.62l1-2h2.57l1.19 2h6.62v2.59l1-1v-2.59h-7l-1-2h-4l-1 2h-1v11h14v-1.59l-1-1z"></path><path d="M16 8l-1-1-2 2-2-2-1 1 2 2-2 2 1 1 2-2 2 2 1-1-2-2 2-2z"></path></g>
<g id="vaadin:folder-search"><path d="M13 13.47v0.53h-12v-9h0.62l1-2h2.57l1.19 2h6.62v0.91c0.385 0.179 0.716 0.407 1.001 0.681l-0.001-2.591h-7l-1-2h-4l-1 2h-1v11h14v-0.53z"></path><path d="M15.78 12.72l-1.92-1.92c-0.089-0.085-0.201-0.148-0.325-0.179 0.292-0.458 0.468-1.018 0.468-1.618 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 1.657 1.343 3 3 3 0.6 0 1.16-0.176 1.629-0.48 0.020 0.136 0.083 0.248 0.169 0.337l1.92 1.92c0.134 0.125 0.313 0.201 0.511 0.201 0.414 0 0.75-0.336 0.75-0.75 0-0.198-0.077-0.378-0.202-0.512zM11 11c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z"></path></g>
<g id="vaadin:folder"><path d="M16 15h-16v-11h1l1-2h4l1 2h9z"></path></g>
<g id="vaadin:font"><path d="M12 16h3l-6-16h-2l-6 16h3l1.9-5h4.2l1.9 5zM6.7 9l1.3-3.6 1.3 3.6h-2.6z"></path></g>
<g id="vaadin:form"><path d="M15 2v2h-9v-2h9zM16 1h-11v4h11v-4z"></path><path d="M0 1h4v4h-4v-4z"></path><path d="M15 7v2h-9v-2h9zM16 6h-11v4h11v-4z"></path><path d="M0 6h4v4h-4v-4z"></path><path d="M15 12v2h-9v-2h9zM16 11h-11v4h11v-4z"></path><path d="M0 11h4v4h-4v-4z"></path></g>
<g id="vaadin:forward"><path d="M0 1v14l8-7z"></path><path d="M8 1v14l8-7z"></path></g>
<g id="vaadin:frown-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M7 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M11 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M11.3 12.3c-0.7-1.1-2-1.8-3.3-1.8s-2.6 0.7-3.3 1.8l-0.8-0.6c0.9-1.4 2.4-2.2 4.1-2.2s3.2 0.8 4.1 2.2l-0.8 0.6z"></path></g>
<g id="vaadin:funcion"><path d="M10 0c0 0-2.1 0-2.7 3l-0.4 2h-1.9l-0.5 1h2.2l-1.4 7c-0.4 2-1.9 2-1.9 2h-1l-0.4 1h3c0 0 2.1 0 2.7-3l1.4-7h2.4l0.5-1h-2.7l0.4-2c0.4-2 1.8-2 1.8-2h1l0.5-1h-3z"></path></g>
<g id="vaadin:function"><path d="M10 0c0 0-2.1 0-2.7 3l-0.4 2h-1.9l-0.5 1h2.2l-1.4 7c-0.4 2-1.9 2-1.9 2h-1l-0.4 1h3c0 0 2.1 0 2.7-3l1.4-7h2.4l0.5-1h-2.7l0.4-2c0.4-2 1.8-2 1.8-2h1l0.5-1h-3z"></path></g>
<g id="vaadin:funnel"><path d="M6 11h4v4h-4v-4z"></path><path d="M13.6 5l2.4-4h-16l2.4 4h11.2z"></path><path d="M3 6l2.4 4h5.2l2.4-4h-10z"></path></g>
<g id="vaadin:gamepad"><path d="M12.16 2c-1.215 0.603-2.641 0.968-4.149 1-1.53-0.032-2.956-0.397-4.229-1.026-2.611 0.026-3.781 1.196-3.781 3.866v6c0.017 1.197 0.991 2.16 2.19 2.16 0 0 0 0 0 0h0.23c0 0 0.001 0 0.002 0 0.963 0 1.78-0.621 2.074-1.485 0.305-0.915 1.145-2.515 2.085-2.515h2.84c0.94 0 1.78 1.6 2.080 2.5 0.298 0.879 1.116 1.5 2.078 1.5 0.001 0 0.001 0 0.002 0h0.23c1.21 0 2.19-0.98 2.19-2.19v-6c0-2.64-1.17-3.81-3.84-3.81zM5 7h-1v1h-1v-1h-1v-1h1v-1h1v1h1v1zM10.060 8.11c-0.585 0-1.060-0.475-1.060-1.060s0.475-1.060 1.060-1.060c0.585 0 1.060 0.475 1.060 1.060s-0.475 1.060-1.060 1.060zM13 8c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z"></path></g>
<g id="vaadin:gavel"><path d="M6.4 4.1v0c-0.4-0.4-0.4-0.9-0.1-1.2l2.6-2.6c0.3-0.3 0.8-0.3 1.2 0l0.1 0.1c0.3 0.3 0.3 0.8 0 1.2l-2.6 2.5c-0.3 0.3-0.9 0.3-1.2 0z"></path><path d="M12 9.7v0c-0.4-0.4-0.4-0.9-0.1-1.3l2.6-2.6c0.3-0.3 0.8-0.3 1.2 0l0.1 0.1c0.3 0.3 0.3 0.8 0 1.2l-2.6 2.6c-0.4 0.3-0.9 0.3-1.2 0z"></path><path d="M10 7.7l-1.7-1.7c-0.4-0.4-0.4-1 0-1.4l2.3-2.3c0.4-0.4 1-0.4 1.4 0l1.7 1.7c0.4 0.4 0.4 1 0 1.4l-2.3 2.3c-0.4 0.4-1 0.4-1.4 0z"></path><path d="M4 14.2c0.6-0.6 4-5.6 4.5-5.3 0.4 0.2 1-0.5 1-0.5l-1.9-1.9c0 0-0.7 0.6-0.5 1 0.3 0.5-4.7 3.9-5.3 4.5 0 0-2.8 2.2-1.4 3.6s3.6-1.4 3.6-1.4z"></path></g>
<g id="vaadin:gift"><path d="M10.1 5c2-0.3 3.9-1.1 2.2-3.6-0.7-1-1.4-1.4-2-1.4-1 0-1.7 1.1-2.3 2.2-0.6-1.1-1.3-2.2-2.3-2.2-0.6 0-1.3 0.4-2 1.4-1.8 2.5 0.2 3.3 2.2 3.6h-5.9v3h16v-3h-5.9zM10.3 1c0.1 0 0.5 0.1 1.2 1 0.5 0.7 0.6 1.1 0.5 1.3-0.2 0.3-1.3 0.7-3.3 0.8 0-0.2-0.1-0.4-0.2-0.6 0.6-1.4 1.3-2.5 1.8-2.5zM4 3.3c-0.1-0.2 0-0.6 0.5-1.3 0.7-0.9 1.1-1 1.2-1 0.5 0 1.2 1.1 1.8 2.5-0.1 0.2-0.2 0.4-0.2 0.6-2-0.1-3.1-0.5-3.3-0.8zM7 7v-2h2v2h-2z"></path><path d="M9 15h-2v-6h-6v7h14v-7h-6z"></path></g>
<g id="vaadin:glass"><path d="M11 15h-2v-8l6-7h-15l6 7v8h-2c-2 0-2 1-2 1h11c0 0 0-1-2-1zM12.9 1l-1.8 2h-7.2l-1.7-2h10.7zM7 15v-8h1v8h-1z"></path></g>
<g id="vaadin:glasses"><path d="M15.5 7h-0.5c-0.1 0-0.1 0-0.2 0-0.4-1.2-1.5-2-2.8-2s-2.4 0.9-2.8 2.1c-0.3-0.4-0.7-0.6-1.2-0.6s-0.9 0.2-1.2 0.6c-0.4-1.2-1.5-2.1-2.8-2.1s-2.4 0.9-2.8 2c-0.1 0-0.1 0-0.2 0h-0.5c-0.3 0-0.5 0.2-0.5 0.5s0.2 0.5 0.5 0.5h0.5c0 1.7 1.3 3 3 3 1.5 0 2.7-1.1 3-2.5 0 0 0 0 0 0 0.3 0 0.5-0.2 0.5-0.5s0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5c0 0.3 0.2 0.5 0.5 0.5 0 0 0 0 0 0 0.2 1.4 1.5 2.5 3 2.5 1.7 0 3-1.3 3-3h0.5c0.3 0 0.5-0.2 0.5-0.5s-0.2-0.5-0.5-0.5zM4 10c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2-0.9 2-2 2zM12 10c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2-0.9 2-2 2z"></path></g>
<g id="vaadin:globe-wire"><path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM14.8 9.5c0 0.5-0.7 0.66-2 1 0.124-0.589 0.206-1.277 0.229-1.98l2.001-0.020c0 0.36-0.080 0.5-0.16 1v0zM1.2 9.5v0c-0.1-0.5-0.15-0.64-0.2-1h2c0.024 0.723 0.106 1.411 0.244 2.079-1.344-0.419-2.044-0.579-2.044-1.079zM1.2 6.5c0-0.5 0.7-0.66 2-1-0.115 0.594-0.187 1.284-0.2 1.989l-2 0.011c0-0.36 0.080-0.5 0.16-1v0zM8.5 5c1.13 0.013 2.226 0.107 3.298 0.277 0.047 0.643 0.165 1.41 0.201 2.199l-3.499 0.025v-2.5zM8.5 4v-2.94c1.17 0.27 2.2 1.47 2.84 3.15-0.836-0.116-1.819-0.192-2.817-0.21zM7.5 1.060v2.94c-1.017 0.015-2.001 0.087-2.968 0.214 0.768-1.684 1.798-2.884 2.968-3.154zM7.5 5v2.5h-3.5c0.031-0.806 0.142-1.571 0.326-2.307 0.932-0.080 2.035-0.177 3.158-0.193zM4 8.5h3.5v2.5c-1.13-0.013-2.226-0.107-3.298-0.277-0.047-0.643-0.165-1.41-0.201-2.199zM7.5 12v2.94c-1.17-0.27-2.2-1.47-2.84-3.15 0.836 0.116 1.819 0.192 2.817 0.21zM8.5 14.94v-2.94c1.017-0.015 2.001-0.087 2.968-0.214-0.768 1.684-1.798 2.884-2.968 3.154zM8.5 11v-2.5h3.5c-0.031 0.806-0.142 1.571-0.326 2.307-0.932 0.080-2.035 0.177-3.158 0.193zM15 7.5h-2c-0.024-0.723-0.106-1.411-0.244-2.079 1.354 0.399 2.014 0.559 2.014 1.079v0c0.13 0.5 0.18 0.64 0.23 1zM14.3 4.91c-0.506-0.204-1.106-0.38-1.726-0.5-0.361-1.019-0.809-1.898-1.389-2.672 1.355 0.726 2.413 1.811 3.067 3.131zM4.84 1.76c-0.568 0.752-1.019 1.631-1.305 2.581-0.699 0.189-1.299 0.365-1.874 0.593 0.751-1.39 1.823-2.475 3.139-3.156zM1.73 11.090c0.506 0.204 1.106 0.38 1.726 0.5 0.361 1.019 0.809 1.898 1.389 2.672-1.367-0.722-2.436-1.807-3.097-3.131zM11.17 14.24c0.564-0.753 1.012-1.631 1.295-2.581 0.699-0.189 1.299-0.365 1.874-0.593-0.751 1.39-1.823 2.475-3.139 3.156z"></path></g>
<g id="vaadin:globe"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM13.2 5.3c0.4 0 0.7 0.3 1.1 0.3-0.3 0.4-1.6 0.4-2-0.1 0.3-0.1 0.5-0.2 0.9-0.2zM1 8c0-0.4 0-0.8 0.1-1.3 0.1 0 0.2 0.1 0.3 0.1 0 0 0.1 0.1 0.1 0.2 0 0.3 0.3 0.5 0.5 0.5 0.8 0.1 1.1 0.8 1.8 1 0.2 0.1 0.1 0.3 0 0.5-0.6 0.8-0.1 1.4 0.4 1.9 0.5 0.4 0.5 0.8 0.6 1.4 0 0.7 0.1 1.5 0.4 2.2-2.5-1.2-4.2-3.6-4.2-6.5zM8 15c-0.7 0-1.5-0.1-2.1-0.3-0.1-0.2-0.1-0.4 0-0.6 0.4-0.8 0.8-1.5 1.3-2.2 0.2-0.2 0.4-0.4 0.4-0.7 0-0.2 0.1-0.5 0.2-0.7 0.3-0.5 0.2-0.8-0.2-0.9-0.8-0.2-1.2-0.9-1.8-1.2s-1.2-0.5-1.7-0.2c-0.2 0.1-0.5 0.2-0.5-0.1 0-0.4-0.5-0.7-0.4-1.1-0.1 0-0.2 0-0.3 0.1s-0.2 0.2-0.4 0.1c-0.2-0.2-0.1-0.4-0.1-0.6 0.1-0.2 0.2-0.3 0.4-0.4 0.4-0.1 0.8-0.1 1 0.4 0.3-0.9 0.9-1.4 1.5-1.8 0 0 0.8-0.7 0.9-0.7s0.2 0.2 0.4 0.3c0.2 0 0.3 0 0.3-0.2 0.1-0.5-0.2-1.1-0.6-1.2 0-0.1 0.1-0.1 0.1-0.1 0.3-0.1 0.7-0.3 0.6-0.6 0-0.4-0.4-0.6-0.8-0.6-0.2 0-0.4 0-0.6 0.1-0.4 0.2-0.9 0.4-1.5 0.4 1.1-0.8 2.5-1.2 3.9-1.2 0.3 0 0.5 0 0.8 0-0.6 0.1-1.2 0.3-1.6 0.5 0.6 0.1 0.7 0.4 0.5 0.9-0.1 0.2 0 0.4 0.2 0.5s0.4 0.1 0.5-0.1c0.2-0.3 0.6-0.4 0.9-0.5 0.4-0.1 0.7-0.3 1-0.7 0-0.1 0.1-0.1 0.2-0.2 0.6 0.2 1.2 0.6 1.8 1-0.1 0-0.1 0.1-0.2 0.1-0.2 0.2-0.5 0.3-0.2 0.7 0.1 0.2 0 0.3-0.1 0.4-0.2 0.1-0.3 0-0.4-0.1s-0.1-0.3-0.4-0.3c-0.1 0.2-0.4 0.3-0.4 0.6 0.5 0 0.4 0.4 0.5 0.7-0.6 0.1-0.8 0.4-0.5 0.9 0.1 0.2-0.1 0.3-0.2 0.4-0.4 0.6-0.8 1-0.8 1.7s0.5 1.4 1.3 1.3c0.9-0.1 0.9-0.1 1.2 0.7 0 0.1 0.1 0.2 0.1 0.3 0.1 0.2 0.2 0.4 0.1 0.6-0.3 0.8 0.1 1.4 0.4 2 0.1 0.2 0.2 0.3 0.3 0.4-1.3 1.4-3 2.2-5 2.2z"></path></g>
<g id="vaadin:golf"><path d="M7 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M9.8 1.8c-0.2-0.5-1.7-0.1-2 0.5-0.2 0.3-0.2 1.2-1.2 1.9-0.8 0.5-1.6 0.5-1.6 0.5-0.3 0.6-0.1 1.1 0.2 1.6 0.5 0.9 0.6 1.8 0.7 2.8 0.1 1.3-0.5 2.4-2.3 3.2-0.8 0.3-1.3 0.9-1 1.9 0 0 2-0.3 3.1-1.2 1.5-1.2 1.8-2.3 1.8-2.3s0.1 0.7 0 1.9c-0.1 1-0.2 1.5-0.4 2.2s0.3 1.2 0.9 1.2 1-0.4 1-1l0.3-1.9c0.3-2.1 0-4.3-0.8-6.3 0-0.1-0.1-0.1-0.1-0.2-0.6-1.6 0.2-2.6 0.6-3 0.3-0.4 1.2-1.2 0.8-1.8z"></path><path d="M12 0v10h1v-6l3-2z"></path><path d="M16 10c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M1 8.4l3.7-3.7-0.7-0.3-3.8 3.6c0 0-0.4 0.7 0.1 1.7s1.6 0.3 1.6 0.3c0.4-0.2 0.2-0.4 0-0.6s-0.9-1-0.9-1z"></path></g>
<g id="vaadin:google-plus-square"><path d="M5 3.4c-0.8 0-1.3 0.8-1.2 1.8 0.1 1.1 0.9 1.9 1.7 2 0.8 0 1.3-0.8 1.2-1.9-0.1-1-0.9-1.9-1.7-1.9z"></path><path d="M5.4 9.3c-1.2 0-2.3 0.7-2.3 1.6s0.9 1.7 2.1 1.7c1.7 0 2.3-0.7 2.3-1.6 0-0.1 0-0.2 0-0.3-0.1-0.5-0.6-0.8-1.3-1.2-0.2-0.2-0.5-0.2-0.8-0.2z"></path><path d="M0 0v16h16v-16h-16zM7.9 5.3c0 0.7-0.4 1.2-0.9 1.6s-0.6 0.6-0.6 0.9c0 0.3 0.5 0.8 0.8 1 0.8 0.6 1.1 1.1 1.1 2 0 1.1-1.1 2.3-3.1 2.3-1.7 0-3.2-0.7-3.2-1.8 0-1.2 1.3-2.3 3.1-2.3 0.2 0 0.4 0 0.5 0-0.2-0.3-0.4-0.6-0.4-0.9 0-0.2 0.1-0.4 0.2-0.6-0.1 0-0.2 0-0.3 0-1.4 0-2.4-1-2.4-2.3 0-1.2 1.3-2.3 2.7-2.3 0.8 0 3.1 0 3.1 0l-0.7 0.6h-1c0.7 0.2 1.1 1 1.1 1.8zM14 5.5h-2.1v2h-0.5v-2h-2v-0.5h2v-2h0.5v2h2.1v0.5z"></path></g>
<g id="vaadin:google-plus"><path d="M16 3.9h-2.8v-2.6h-0.6v2.6h-2.7v0.8h2.7v2.6h0.6v-2.6h2.8z"></path><path d="M6.9 9c-0.4-0.2-1.1-0.9-1.1-1.3s0.1-0.7 0.8-1.2c0.7-0.5 1.2-1.2 1.2-2.1 0-1.1-0.5-2.1-1.3-2.4h1.3l0.9-0.7c0 0-3.1 0-4.2 0-1.9 0-3.6 1.4-3.6 3.1s1.3 3 3.2 3c0.1 0 0.3 0 0.4 0-0.2 0.2-0.2 0.4-0.2 0.7 0 0.5 0.3 0.8 0.6 1.2-0.2 0-0.5 0-0.7 0-2.3 0-4.1 1.5-4.1 3s2 2.5 4.3 2.5c2.6 0 4.1-1.5 4.1-3-0.1-1.3-0.5-2-1.6-2.8zM4.7 6.9c-1.1 0-2.1-1.2-2.3-2.6s0.5-2.5 1.6-2.5c1.1 0 2.1 1.2 2.3 2.6s-0.5 2.6-1.6 2.5zM4.3 14.1c-1.6 0-2.8-1-2.8-2.2s1.4-2.2 3-2.2c0.4 0 0.7 0.1 1 0.2 0.9 0.6 1.5 0.9 1.7 1.6 0 0.1 0.1 0.3 0.1 0.4 0 1.2-0.8 2.2-3 2.2z"></path></g>
<g id="vaadin:grab"><path d="M12.6 4c-0.2 0-0.4 0-0.6 0 0-0.2-0.2-0.6-0.4-0.8s-0.5-0.4-1.1-0.4c-0.2 0-0.4 0-0.6 0.1-0.1-0.2-0.2-0.3-0.3-0.5-0.2-0.2-0.5-0.4-1.1-0.4-0.8 0-1.2 0.5-1.4 1-0.1 0-0.3-0.1-0.5-0.1-0.5 0-0.8 0.2-1.1 0.4-0.5 0.6-0.5 1.4-0.5 1.5v0.4c-0.6 0-1.1 0.2-1.4 0.5-0.6 0.7-0.6 1.6-0.6 2.8 0 0.2 0 0.5 0 0.7 0 1.4 0.7 2.1 1.4 2.8l0.3 0.4c1.3 1.2 2.5 1.6 5.1 1.6 2.9 0 4.2-1.6 4.2-5.1v-2.5c0-0.7-0.2-2.1-1.4-2.4zM10.5 3.8c0.4 0 0.5 0.4 0.5 0.6v0.8c0 0.3 0.2 0.5 0.4 0.5 0.3 0 0.5-0.1 0.5-0.4 0 0 0-0.4 0.4-0.3 0.6 0.2 0.7 1.1 0.7 1.3 0 0 0 0 0 0v2.6c0 3.4-1.3 4.1-3.2 4.1-2.4 0-3.3-0.3-4.3-1.3-0.1-0.1-0.2-0.2-0.4-0.4-0.7-0.7-1.1-1.1-1.1-2.1 0-0.2 0-0.3 0-0.6 0-1 0-1.8 0.3-2.1 0.1-0.2 0.4-0.3 0.7-0.3v0.8l-0.3 1.2c0 0.1 0 0.1 0.1 0.1 0.1 0.1 0.2 0 0.2 0l1-1.2c0 0 0-0.1 0-0.1v-2c0-0.1 0-0.6 0.2-0.8 0.1-0.1 0.2-0.2 0.4-0.2 0.3 0 0.4 0.2 0.4 0.4v0.4c0 0.2 0.2 0.5 0.5 0.5s0.5-0.3 0.5-0.5v-1.3c0-0.1 0-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5v1.2c0 0.3 0.2 0.6 0.5 0.6s0.5-0.3 0.5-0.5v-0.5c0-0.3 0.2-0.5 0.5-0.5z"></path></g>
<g id="vaadin:grid-bevel"><path d="M14 2v-1h-13v13h1v1h13v-13h-1zM5 13h-3v-3h3v3zM5 9h-3v-3h3v3zM5 5h-3v-3h3v3zM9 13h-3v-3h3v3zM9 9h-3v-3h3v3zM9 5h-3v-3h3v3zM13 13h-3v-3h3v3zM13 9h-3v-3h3v3zM13 5h-3v-3h3v3z"></path></g>
<g id="vaadin:grid-big-o"><path d="M0 7h7v-7h-7v7zM1 1h5v5h-5v-5z"></path><path d="M9 0v7h7v-7h-7zM15 6h-5v-5h5v5z"></path><path d="M0 16h7v-7h-7v7zM1 10h5v5h-5v-5z"></path><path d="M9 16h7v-7h-7v7zM10 10h5v5h-5v-5z"></path></g>
<g id="vaadin:grid-big"><path d="M0 0h7v7h-7v-7z"></path><path d="M9 0h7v7h-7v-7z"></path><path d="M0 9h7v7h-7v-7z"></path><path d="M9 9h7v7h-7v-7z"></path></g>
<g id="vaadin:grid-h"><path d="M0 0v16h16v-16h-16zM5 15h-4v-14h4v14zM10 15h-4v-14h4v14zM15 15h-4v-14h4v14z"></path></g>
<g id="vaadin:grid-small-o"><path d="M0 4h4v-4h-4v4zM1 1h2v2h-2v-2z"></path><path d="M0 10h4v-4h-4v4zM1 7h2v2h-2v-2z"></path><path d="M0 16h4v-4h-4v4zM1 13h2v2h-2v-2z"></path><path d="M6 4h4v-4h-4v4zM7 1h2v2h-2v-2z"></path><path d="M6 10h4v-4h-4v4zM7 7h2v2h-2v-2z"></path><path d="M6 16h4v-4h-4v4zM7 13h2v2h-2v-2z"></path><path d="M12 0v4h4v-4h-4zM15 3h-2v-2h2v2z"></path><path d="M12 10h4v-4h-4v4zM13 7h2v2h-2v-2z"></path><path d="M12 16h4v-4h-4v4zM13 13h2v2h-2v-2z"></path></g>
<g id="vaadin:grid-small"><path d="M0 0h4v4h-4v-4z"></path><path d="M0 6h4v4h-4v-4z"></path><path d="M0 12h4v4h-4v-4z"></path><path d="M6 0h4v4h-4v-4z"></path><path d="M6 6h4v4h-4v-4z"></path><path d="M6 12h4v4h-4v-4z"></path><path d="M12 0h4v4h-4v-4z"></path><path d="M12 6h4v4h-4v-4z"></path><path d="M12 12h4v4h-4v-4z"></path></g>
<g id="vaadin:grid-v"><path d="M16 0h-16v16h16v-16zM1 5v-4h14v4h-14zM1 10v-4h14v4h-14zM1 15v-4h14v4h-14z"></path></g>
<g id="vaadin:grid"><path d="M0 0v16h16v-16h-16zM5 15h-4v-4h4v4zM5 10h-4v-4h4v4zM5 5h-4v-4h4v4zM10 15h-4v-4h4v4zM10 10h-4v-4h4v4zM10 5h-4v-4h4v4zM15 15h-4v-4h4v4zM15 10h-4v-4h4v4zM15 5h-4v-4h4v4z"></path></g>
<g id="vaadin:group"><path d="M5 16v-5.3c-0.6-0.3-1-1-1-1.7v-4c0-0.7 0.4-1.3 1-1.7 0-0.1 0-0.2 0-0.3 0-1.1-0.9-2-2-2s-2 0.9-2 2c0 1.1 0.9 2 2 2h-2c-0.5 0-1 0.5-1 1v4c0 0.5 0.5 1 1 1v5h4z"></path><path d="M15 5h-2c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2c0 0.1 0 0.2 0 0.3 0.6 0.4 1 1 1 1.7v4c0 0.7-0.4 1.4-1 1.7v5.3h4v-5c0.5 0 1-0.5 1-1v-4c0-0.5-0.5-1-1-1z"></path><path d="M10 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M10 4h-4c-0.5 0-1 0.5-1 1v4c0 0.5 0.5 1 1 1v6h4v-6c0.5 0 1-0.5 1-1v-4c0-0.5-0.5-1-1-1z"></path></g>
<g id="vaadin:hammer"><path d="M6 2l7 7 3-3-4.48-4.48s-2.97 1.030-4.52-0.52z"></path><path d="M8.8 5.79l-8.53 8.52c-0.165 0.178-0.267 0.417-0.267 0.68s0.101 0.502 0.267 0.681c0.181 0.183 0.433 0.297 0.711 0.297 0.253 0 0.484-0.094 0.66-0.248l8.569-8.519z"></path></g>
<g id="vaadin:hand"><path d="M13.5 2.4c-0.4-0.4-1-0.5-1.5-0.3 0-0.3-0.1-0.6-0.4-0.9-0.2-0.2-0.6-0.4-1.1-0.4-0.3 0-0.5 0.1-0.7 0.1 0-0.2-0.1-0.3-0.2-0.5-0.5-0.6-1.5-0.6-2 0-0.2 0.2-0.4 0.4-0.4 0.6-0.2 0-0.4-0.1-0.6-0.1-0.5 0-0.8 0.2-1.1 0.5-0.5 0.5-0.5 1.3-0.5 1.3v3.8c-0.3-0.3-0.8-0.8-1.5-0.8-0.2 0-0.5 0.1-0.7 0.2-0.4 0.2-0.6 0.5-0.7 0.9-0.3 1 0.6 2.4 0.6 2.5 0.1 0.1 1.2 2.7 2.2 3.8 1 1.2 2.1 1.9 4.9 1.9 2.9 0 4.2-1.6 4.2-5.1v-5.5c0-0.1 0.1-1.3-0.5-2zM8 2c0-0.3-0.1-1 0.5-1 0.5 0 0.5 0.5 0.5 1v4c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5v-3.8c0 0 0-0.4 0.5-0.4 0.6 0 0.5 0.9 0.5 0.9v3.3c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5v-2.4c0-0.1 0-0.6 0.5-0.6s0.5 1 0.5 1v5.9c0 3.4-1.3 4.1-3.2 4.1-2.4 0-3.3-0.5-4.1-1.6-0.9-1-2.1-3.6-2.1-3.7-0.3-0.3-0.7-1.2-0.6-1.6 0-0.1 0.1-0.2 0.2-0.3 0.1 0 0.2-0.1 0.2-0.1 0.4 0 0.8 0.5 0.9 0.7l0.6 0.9c0.1 0.2 0.4 0.3 0.6 0.2 0.4 0 0.5-0.2 0.5-0.4v-5.2c0-0.4 0-1 0.5-1 0.4 0 0.5 0.3 0.5 0.8v3.3c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5z"></path></g>
<g id="vaadin:handle-corner"><path d="M6.7 16l9.3-9.3v-1.4l-10.7 10.7z"></path><path d="M9.7 16l6.3-6.3v-1.4l-7.7 7.7z"></path><path d="M12.7 16l3.3-3.3v-1.4l-4.7 4.7z"></path><path d="M15.7 16l0.3-0.3v-1.4l-1.7 1.7z"></path></g>
<g id="vaadin:hands-up"><path d="M10 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M6 16h1.5v-5h1v5h1.5v-9c-0-0.016-0.001-0.034-0.001-0.052 0-0.521 0.194-0.997 0.513-1.36l3.278-3.318c0.216-0.129 0.358-0.362 0.358-0.628 0-0.403-0.327-0.73-0.73-0.73-0.266 0-0.499 0.142-0.626 0.355l-2.362 2.383c-0.212 0.216-0.508 0.35-0.835 0.35-0.002 0-0.004 0-0.006-0h-3.18c-0.002 0-0.004 0-0.005 0-0.327 0-0.622-0.134-0.834-0.35l-2.32-2.39c-0.129-0.216-0.362-0.358-0.628-0.358-0.403 0-0.73 0.327-0.73 0.73 0 0.266 0.142 0.499 0.355 0.626l3.243 3.332c0.317 0.361 0.511 0.836 0.511 1.358 0 0.018-0 0.037-0.001 0.055l0 8.997z"></path></g>
<g id="vaadin:handshake"><path d="M13 3c-0.538 0.515-1.185 0.92-1.902 1.178-0.748 0.132-2.818-0.828-3.838 0.152-0.17 0.17-0.38 0.34-0.6 0.51-0.48-0.21-1.22-0.53-1.76-0.84s-1.9-1-1.9-1l-3 3.5s0.74 1 1.2 1.66c0.3 0.44 0.67 1.11 0.91 1.56l-0.34 0.4c-0.058 0.115-0.093 0.25-0.093 0.393 0 0.235 0.092 0.449 0.243 0.607 0.138 0.103 0.311 0.165 0.5 0.165s0.362-0.062 0.502-0.167c-0.094 0.109-0.149 0.249-0.149 0.402 0 0.193 0.088 0.365 0.226 0.479 0.144 0.085 0.317 0.135 0.501 0.135s0.357-0.050 0.505-0.137c-0.112 0.139-0.177 0.313-0.177 0.503s0.065 0.364 0.174 0.502c0.099 0.035 0.214 0.056 0.334 0.056 0.207 0 0.399-0.063 0.558-0.17-0.043 0.095-0.065 0.203-0.065 0.317 0 0.234 0.096 0.445 0.252 0.595 0.13 0.059 0.283 0.093 0.443 0.093 0.226 0 0.437-0.068 0.611-0.185l0.516-0.467c0.472 0.47 1.123 0.761 1.842 0.761 0.020 0 0.041-0 0.061-0.001 0.494-0.042 0.908-0.356 1.094-0.791 0.146 0.056 0.312 0.094 0.488 0.094 0.236 0 0.455-0.068 0.64-0.185 0.585-0.387 0.445-0.687 0.445-0.687 0.125 0.055 0.27 0.087 0.423 0.087 0.321 0 0.61-0.142 0.806-0.366 0.176-0.181 0.283-0.427 0.283-0.697 0-0.19-0.053-0.367-0.145-0.518 0.008 0.005 0.015 0.005 0.021 0.005 0.421 0 0.787-0.232 0.978-0.574 0.068-0.171 0.105-0.363 0.105-0.563 0-0.342-0.11-0.659-0.296-0.917l0.003 0.005c0.82-0.16 0.79-0.57 1.19-1.17 0.384-0.494 0.852-0.902 1.387-1.208zM12.95 10.060c-0.44 0.44-0.78 0.25-1.53-0.32s-2.24-1.64-2.24-1.64c0.061 0.305 0.202 0.57 0.401 0.781 0.319 0.359 1.269 1.179 1.719 1.599 0.28 0.26 1 0.78 0.58 1.18s-0.75 0-1.44-0.56-2.23-1.94-2.23-1.94c-0.001 0.018-0.002 0.038-0.002 0.059 0 0.258 0.104 0.491 0.272 0.661 0.17 0.2 1.12 1.12 1.52 1.54s0.75 0.67 0.41 1-1.030-0.19-1.41-0.58c-0.59-0.57-1.76-1.63-1.76-1.63-0.001 0.016-0.001 0.034-0.001 0.053 0 0.284 0.098 0.544 0.263 0.75 0.288 0.378 0.848 0.868 1.188 1.248s0.54 0.7 0 1-1.34-0.44-1.69-0.8c0-0.001 0-0.001 0-0.002 0-0.103-0.038-0.197-0.1-0.269-0.159-0.147-0.374-0.238-0.609-0.238-0.104 0-0.204 0.018-0.297 0.050 0.128-0.114 0.204-0.274 0.204-0.452s-0.076-0.338-0.198-0.45c-0.126-0.095-0.284-0.152-0.455-0.152s-0.33 0.057-0.457 0.153c0.117-0.113 0.189-0.268 0.189-0.441 0-0.213-0.109-0.4-0.274-0.509-0.153-0.097-0.336-0.153-0.532-0.153-0.244 0-0.468 0.088-0.642 0.233 0.095-0.114 0.151-0.26 0.151-0.42 0-0.195-0.085-0.37-0.219-0.491-0.178-0.165-0.417-0.266-0.679-0.266-0.185 0-0.358 0.050-0.507 0.138l-0.665-1.123c-0.46-0.73-1-1.49-1-1.49l2.28-2.77s0.81 0.5 1.48 0.88c0.33 0.19 0.9 0.44 1.33 0.64-0.68 0.51-1.25 1-1.080 1.34 0.297 0.214 0.668 0.343 1.069 0.343 0.376 0 0.726-0.113 1.018-0.307 0.373-0.251 0.84-0.403 1.343-0.403 0.347 0 0.677 0.072 0.976 0.203 0.554 0.374 1.574 1.294 2.504 1.874v0c1.17 0.85 1.4 1.4 1.12 1.68z"></path></g>
<g id="vaadin:harddrive-o"><path d="M2 12h1v1h-1v-1z"></path><path d="M4 12h3v1h-3v-1z"></path><path d="M13 1h-10l-3 9v5h16v-5l-3-9zM3.7 2h8.6l2.7 8h-13.9l2.6-8zM1 14v-3h14v3h-14z"></path></g>
<g id="vaadin:harddrive"><path d="M13 1h-10l-2.7 8h15.4z"></path><path d="M0 10v5h16v-5h-16zM3 13h-1v-1h1v1zM7 13h-3v-1h3v1z"></path></g>
<g id="vaadin:hash"><path d="M15 6v-2h-2.6l0.6-2.8-2-0.4-0.7 3.2h-3l0.7-2.8-2-0.4-0.7 3.2h-3.3v2h2.9l-0.9 4h-3v2h2.6l-0.6 2.8 2 0.4 0.7-3.2h3l-0.7 2.8 2 0.4 0.7-3.2h3.3v-2h-2.9l0.9-4h3zM9 10h-3l1-4h3l-1 4z"></path></g>
<g id="vaadin:header"><path d="M11 0v7h-6v-7h-3v16h3v-7h6v7h3v-16z"></path></g>
<g id="vaadin:headphones"><path d="M14 8.3v-2.3c0-3.3-2.7-6-6-6s-6 2.7-6 6v2.3c-1.2 0.5-2 1.7-2 3.1v1.2c0 1.8 1.3 3.2 3 3.4h2v-8h-1v-2c0-2.2 1.8-4 4-4s4 1.8 4 4v2h-1v8h2c1.7-0.2 3-1.7 3-3.4v-1.2c0-1.4-0.8-2.6-2-3.1zM4 15h-1v-6h1v6zM13 15h-1v-6h1v6z"></path></g>
<g id="vaadin:headset"><path d="M14.82 8c-0.309-0.851-0.969-1.511-1.799-1.813l-0.021-1.687c0-2.5-2.47-4.5-5.5-4.5s-5.5 2-5.5 4.5v1.68c-1.173 0.423-1.996 1.525-2 2.82v1c0 1.657 1.343 3 3 3h1v-7h-1v-1.5c0-1.93 2-3.5 4.5-3.5s4.5 1.57 4.5 3.5v1.5h-1v7h1c1.657 0 3-1.343 3-3v1.73c0 1.806-1.464 3.27-3.27 3.27h-1.73c0-0.552-0.448-1-1-1h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h3.73c2.358 0 4.27-1.912 4.27-4.27v-3.73h-1.18z"></path></g>
<g id="vaadin:health-card"><path d="M15 3v10h-14v-10h14zM16 2h-16v12h16v-12z"></path><path d="M9 5h5v1h-5v-1z"></path><path d="M9 7h5v1h-5v-1z"></path><path d="M9 9h2v1h-2v-1z"></path><path d="M6.5 5c0 0 0 0 0 0-0.6 0-1.1 0.6-1.5 1-0.4-0.4-0.9-1-1.5-1 0 0 0 0 0 0-1.5 0-2.1 1.9-1 2.9l2.5 2.1 2.5-2.1c1.1-1 0.5-2.9-1-2.9z"></path></g>
<g id="vaadin:heart-o"><path d="M11.7 2c-0.9 0-2.7 0.5-3.7 2.1-1-1.6-2.8-2.1-3.8-2.1-2.3 0-4.2 1.9-4.2 4.2 0 4 7.4 8.5 7.7 8.7l0.3 0.2 0.3-0.2c0.3-0.2 7.7-4.8 7.7-8.7 0-2.3-1.9-4.2-4.3-4.2zM8 13.9c-2.2-1.4-7-5-7-7.7 0-1.8 1.5-3.2 3.2-3.2 0.1 0 2.5 0.1 3.3 2.4l0.5 1.4 0.5-1.4c0.8-2.3 3.2-2.4 3.3-2.4 1.7 0 3.2 1.4 3.2 3.2 0 2.7-4.8 6.3-7 7.7z"></path></g>
<g id="vaadin:heart"><path d="M12 2c0 0-3 0-4 3-1-3-4-3-4-3-2.2 0-4 1.8-4 4 0 4.1 8 9 8 9s8-5 8-9c0-2.2-1.8-4-4-4z"></path></g>
<g id="vaadin:home-o"><path d="M16 6.6l-8-5.2-2 1.3v-1.7h-2v3l-4 2.6 1.9 2.7 0.1-0.1v5.8h5v-4h2v4h5v-5.8l0.1 0.1 1.9-2.7zM1.4 6.9l6.6-4.3 6.6 4.3-0.7 1-5.9-3.9-5.9 3.9-0.7-1zM13 14h-3v-4h-4v4h-3v-5.4l5-3.3 5 3.3v5.4z"></path></g>
<g id="vaadin:home"><path d="M8 1.4l-2 1.3v-1.7h-2v3l-4 2.6 0.6 0.8 7.4-4.8 7.4 4.8 0.6-0.8z"></path><path d="M8 4l-6 4v7h5v-3h2v3h5v-7z"></path></g>
<g id="vaadin:hospital"><path d="M15 4v-4h-7v4h-8v12h6v-3h4v3h6v-12h-1zM4 11h-2v-2h2v2zM4 8h-2v-2h2v2zM7 11h-2v-2h2v2zM7 8h-2v-2h2v2zM10 3v-1h1v-1h1v1h1v1h-1v1h-1v-1h-1zM11 11h-2v-2h2v2zM11 8h-2v-2h2v2zM14 11h-2v-2h2v2zM14 8h-2v-2h2v2z"></path></g>
<g id="vaadin:hourglass-empty"><path d="M11.18 6.060c1.107-0.808 1.819-2.101 1.82-3.56v-0.5h1v-2h-12v2h1v0.5c0.001 1.459 0.713 2.752 1.808 3.551 0.672 0.43 1.121 1.13 1.192 1.939-0.093 0.848-0.551 1.564-1.209 2.003-1.081 0.814-1.772 2.078-1.79 3.503l-0 0.503h-1v2h12v-2h-1v-0.5c-0.018-1.429-0.709-2.692-1.769-3.492-0.68-0.454-1.138-1.169-1.23-1.996 0.071-0.831 0.52-1.532 1.169-1.946zM9 8c0.072 1.142 0.655 2.136 1.519 2.763 0.877 0.623 1.445 1.61 1.481 2.732l0 0.505h-8v-0.5c0.036-1.127 0.604-2.114 1.459-2.723 0.886-0.642 1.468-1.635 1.54-2.766-0.063-1.124-0.641-2.091-1.498-2.683-0.914-0.633-1.499-1.662-1.502-2.827v-0.5h8v0.5c-0.003 1.166-0.587 2.195-1.479 2.813-0.88 0.607-1.458 1.574-1.521 2.678z"></path></g>
<g id="vaadin:hourglass-end"><path d="M11.18 6.060c1.107-0.808 1.819-2.101 1.82-3.56v-0.5h1v-2h-12v2h1v0.5c0.001 1.459 0.713 2.752 1.808 3.551 0.672 0.43 1.121 1.13 1.192 1.939-0.093 0.848-0.551 1.564-1.209 2.003-1.081 0.814-1.772 2.078-1.79 3.503l-0 0.503h-1v2h12v-2h-1v-0.5c-0.018-1.429-0.709-2.692-1.769-3.492-0.68-0.454-1.138-1.169-1.23-1.996 0.071-0.831 0.52-1.532 1.169-1.946zM9 8c0.072 1.142 0.655 2.136 1.519 2.763 0.877 0.623 1.445 1.61 1.481 2.732l0 0.505h-1s-1.62-3.5-3-3.5-3 3.5-3 3.5h-1v-0.5c0.036-1.127 0.604-2.114 1.459-2.723 0.886-0.642 1.468-1.635 1.54-2.766-0.063-1.124-0.641-2.091-1.498-2.683-0.914-0.633-1.499-1.662-1.502-2.827v-0.5h8v0.5c-0.003 1.166-0.587 2.195-1.479 2.813-0.88 0.607-1.458 1.574-1.521 2.678z"></path></g>
<g id="vaadin:hourglass-start"><path d="M6.16 4.6c1.114 0.734 1.84 1.979 1.84 3.394 0 0.002 0 0.004 0 0.006v-0c0-0.002 0-0.004 0-0.006 0-1.415 0.726-2.66 1.825-3.384 0.573-0.385 0.984-0.939 1.17-1.589l-5.995-0.020c0.191 0.67 0.603 1.225 1.15 1.594z"></path><path d="M11.18 6.060c1.107-0.808 1.819-2.101 1.82-3.56v-0.5h1v-2h-12v2h1v0.5c0.001 1.459 0.713 2.752 1.808 3.551 0.672 0.43 1.121 1.13 1.192 1.939-0.093 0.848-0.551 1.564-1.209 2.003-1.081 0.814-1.772 2.078-1.79 3.503l-0 0.503h-1v2h12v-2h-1v-0.5c-0.018-1.429-0.709-2.692-1.769-3.492-0.68-0.454-1.138-1.169-1.23-1.996 0.071-0.831 0.52-1.532 1.169-1.946zM9 8c0.072 1.142 0.655 2.136 1.519 2.763 0.877 0.623 1.445 1.61 1.481 2.732l0 0.505h-8v-0.5c0.036-1.127 0.604-2.114 1.459-2.723 0.886-0.642 1.468-1.635 1.54-2.766-0.063-1.124-0.641-2.091-1.498-2.683-0.914-0.633-1.499-1.662-1.502-2.827v-0.5h8v0.5c-0.003 1.166-0.587 2.195-1.479 2.813-0.88 0.607-1.458 1.574-1.521 2.678z"></path></g>
<g id="vaadin:hourglass"><path d="M6.16 4.6c1.114 0.734 1.84 1.979 1.84 3.394 0 0.002 0 0.004 0 0.006v-0c0-0.002 0-0.004 0-0.006 0-1.415 0.726-2.66 1.825-3.384 0.23-0.199 0.426-0.395 0.609-0.602l-4.874-0.007c0.19 0.214 0.386 0.41 0.593 0.594z"></path><path d="M11.18 6.060c1.107-0.808 1.819-2.101 1.82-3.56v-0.5h1v-2h-12v2h1v0.5c0.001 1.459 0.713 2.752 1.808 3.551 0.672 0.43 1.121 1.13 1.192 1.939-0.093 0.848-0.551 1.564-1.209 2.003-1.081 0.814-1.772 2.078-1.79 3.503l-0 0.503h-1v2h12v-2h-1v-0.5c-0.018-1.429-0.709-2.692-1.769-3.492-0.68-0.454-1.138-1.169-1.23-1.996 0.071-0.831 0.52-1.532 1.169-1.946zM9 8c0.072 1.142 0.655 2.136 1.519 2.763 0.877 0.623 1.445 1.61 1.481 2.732l0 0.505h-1.77c-0.7-0.87-1.71-2-2.23-2s-1.53 1.13-2.23 2h-1.77v-0.5c0.036-1.127 0.604-2.114 1.459-2.723 0.886-0.642 1.468-1.635 1.54-2.766-0.063-1.124-0.641-2.091-1.498-2.683-0.914-0.633-1.499-1.662-1.502-2.827v-0.5h8v0.5c-0.003 1.166-0.587 2.195-1.479 2.813-0.88 0.607-1.458 1.574-1.521 2.678z"></path></g>
<g id="vaadin:inbox"><path d="M10 6v-6h-4v6h-2l4 5 4-5z"></path><path d="M13 1h-2v1h1.3l2.6 8h-3.9v2h-6v-2h-3.9l2.6-8h1.3v-1h-2l-3 9v5h16v-5z"></path></g>
<g id="vaadin:indent"><path d="M0 0h16v3h-16v-3z"></path><path d="M6 4h10v3h-10v-3z"></path><path d="M6 8h10v3h-10v-3z"></path><path d="M0 12h16v3h-16v-3z"></path><path d="M0 4.5v6l4-3z"></path></g>
<g id="vaadin:info-circle-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M7 6h2v7h-2v-7z"></path><path d="M7 3h2v2h-2v-2z"></path></g>
<g id="vaadin:info-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM9 13h-2v-7h2v7zM9 5h-2v-2h2v2z"></path></g>
<g id="vaadin:info"><path d="M6 5h4v11h-4v-11z"></path><path d="M10 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:input"><path d="M16 5c0-0.6-0.4-1-1-1h-14c-0.6 0-1 0.4-1 1v6c0 0.6 0.4 1 1 1h14c0.6 0 1-0.4 1-1v-6zM15 11h-14v-6h14v6z"></path><path d="M2 6h1v4h-1v-4z"></path></g>
<g id="vaadin:insert"><path d="M14 16v-11l-1 1v9h-12v-12h9l1-1h-11v14z"></path><path d="M16 1.4l-1.4-1.4-6.8 6.8-1.8-1.8v5h5l-1.8-1.8z"></path></g>
<g id="vaadin:institution"><path d="M8 0l-8 3v2h16v-2z"></path><path d="M0 14h16v2h-16v-2z"></path><path d="M16 7v-1h-16v1h1v5h-1v1h16v-1h-1v-5h1zM4 12h-1v-5h1v5zM7 12h-1v-5h1v5zM10 12h-1v-5h1v5zM13 12h-1v-5h1v5z"></path></g>
<g id="vaadin:invoice"><path d="M4.4 10.2c-0.6 0.1-1.4-0.3-1.7-0.4l-0.5 0.9c0 0 0.9 0.4 1.7 0.5v0.8h1v-0.9c0.9-0.3 1.4-1.1 1.5-1.8 0-0.8-0.6-1.4-1.9-1.9-0.4-0.2-1.1-0.5-1.1-0.9 0-0.5 0.4-0.8 1-0.8 0.7 0 1.4 0.3 1.4 0.3l0.4-0.9c0 0-0.5-0.2-1.2-0.4v-0.7h-1v0.7c-0.9 0.2-1.5 0.8-1.6 1.7 0 1.2 1.3 1.7 1.8 1.9 0.6 0.2 1.3 0.6 1.3 0.9 0 0.4-0.4 0.9-1.1 1z"></path><path d="M0 2v12h16v-12h-16zM15 13h-14v-10h14v10z"></path><path d="M8 5h6v1h-6v-1z"></path><path d="M8 7h6v1h-6v-1z"></path><path d="M8 9h3v1h-3v-1z"></path></g>
<g id="vaadin:italic"><path d="M8 0h3l-3 16h-3z"></path></g>
<g id="vaadin:key-o"><path d="M13 0l-7 6.1c-0.3-0.1-0.6-0.1-1-0.1-2.8 0-5 2.2-5 5s2.3 5 5 5 5-2.2 5-5c0-0.3 0-0.6-0.1-0.9l1.1-1.1v-2h2v-2h2l1-1v-4h-3zM12 6h-1.7l1.7-1.4v1.4zM15 3.6l-0.4 0.4h-1.9l2.3-2v1.6zM7.3 7.6l0.7 0.4 2-1.7v2.3l-0.8 0.8-0.3 0.4 0.1 0.5c0 0.2 0.1 0.5 0.1 0.7 0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4c0.3 0 0.5 0 0.8 0.1l0.5 0.1 0.4-0.3 6.6-5.9h1.6l-7.7 6.6z"></path><path d="M6 11.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path></g>
<g id="vaadin:key"><path d="M8.1 7c-0.2-0.1-0.4-0.2-0.6-0.3l7.5-6.7h-2l-7 6.1c-0.3-0.1-0.6-0.1-1-0.1-2.8 0-5 2.2-5 5s2.3 5 5 5 5-2.2 5-5c0-0.6-0.1-1.2-0.3-1.7l1.3-1.3v-2h2v-2h2l1-1v-3l-7.9 7zM4 13.2c-0.7 0-1.2-0.6-1.2-1.2s0.6-1.2 1.2-1.2 1.2 0.6 1.2 1.2-0.5 1.2-1.2 1.2z"></path></g>
<g id="vaadin:keyboard-o"><path d="M15 5v7h-14v-7h14zM16 4h-16v9h16v-9z"></path><path d="M4 10h8v1h-8v-1z"></path><path d="M2 10h1v1h-1v-1z"></path><path d="M13 10h1v1h-1v-1z"></path><path d="M11 8h1v1h-1v-1z"></path><path d="M9 8h1v1h-1v-1z"></path><path d="M7 8h1v1h-1v-1z"></path><path d="M5 8h1v1h-1v-1z"></path><path d="M3 8h1v1h-1v-1z"></path><path d="M10 6h1v1h-1v-1z"></path><path d="M12 6v1h1v2h1v-3z"></path><path d="M8 6h1v1h-1v-1z"></path><path d="M6 6h1v1h-1v-1z"></path><path d="M4 6h1v1h-1v-1z"></path><path d="M2 6h1v1h-1v-1z"></path></g>
<g id="vaadin:keyboard"><path d="M0 4v9h16v-9h-16zM10 6h1v1h-1v-1zM8 6h1v1h-1v-1zM10 8v1h-1v-1h1zM6 6h1v1h-1v-1zM8 8v1h-1v-1h1zM4 6h1v1h-1v-1zM6 8v1h-1v-1h1zM2 6h1v1h-1v-1zM3 11h-1v-1h1v1zM3 8h1v1h-1v-1zM12 11h-8v-1h8v1zM12 9h-1v-1h1v1zM14 11h-1v-1h1v1zM14 9h-1v-2h-1v-1h2v3z"></path></g>
<g id="vaadin:laptop"><path d="M14 11v-9h-12v9h-2v2h16v-2h-2zM10 12h-4v-1h4v1zM13 10h-10v-7h10v7z"></path></g>
<g id="vaadin:layout"><path d="M0 0v16h16v-16h-16zM1 3h4v12h-4v-12zM15 15h-9v-12h9v12z"></path></g>
<g id="vaadin:level-down-bold"><path d="M9 16l4-7h-3v-9h-7l2 3h2v6h-3z"></path></g>
<g id="vaadin:level-down"><path d="M5 1h6v11h2l-3 3-3-3h2v-9h-6z"></path></g>
<g id="vaadin:level-left-bold"><path d="M0 7l7-4v3h9v7l-3-2v-2h-6v3z"></path></g>
<g id="vaadin:level-left"><path d="M15 12v-6h-11v-2l-3 3 3 3v-2h9v6z"></path></g>
<g id="vaadin:level-right-bold"><path d="M16 7l-7-4v3h-9v7l3-2v-2h6v3z"></path></g>
<g id="vaadin:level-right"><path d="M1 12v-6h11v-2l3 3-3 3v-2h-9v6z"></path></g>
<g id="vaadin:level-up-bold"><path d="M9 0l4 7h-3v9h-7l2-3h2v-6h-3z"></path></g>
<g id="vaadin:level-up"><path d="M11 15h-6v-11h-2l3-3 3 3h-2v9h6z"></path></g>
<g id="vaadin:lifebuoy"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM4 8c0-2.2 1.8-4 4-4s4 1.8 4 4c0 2.2-1.8 4-4 4s-4-1.8-4-4zM12.6 9.8c0.3-0.5 0.4-1.2 0.4-1.8s-0.1-1.3-0.4-1.8l1.5-1.5c0.6 1 0.9 2.1 0.9 3.3s-0.3 2.3-0.8 3.3l-1.6-1.5zM11.3 1.8l-1.5 1.6c-0.5-0.3-1.2-0.4-1.8-0.4s-1.3 0.1-1.8 0.4l-1.5-1.6c1-0.5 2.1-0.8 3.3-0.8s2.3 0.3 3.3 0.8zM1.8 4.7l1.5 1.5c-0.2 0.5-0.3 1.2-0.3 1.8s0.1 1.3 0.4 1.8l-1.5 1.5c-0.6-1-0.9-2.1-0.9-3.3s0.3-2.3 0.8-3.3zM4.7 14.2l1.5-1.5c0.5 0.2 1.2 0.3 1.8 0.3s1.3-0.1 1.8-0.4l1.5 1.5c-1 0.6-2.1 0.9-3.3 0.9s-2.3-0.3-3.3-0.8z"></path></g>
<g id="vaadin:lightbulb"><path d="M8 0c-2.761 0-5 2.239-5 5 0.013 1.672 0.878 3.138 2.182 3.989l0.818 2.011c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.41c0.342 0.55 0.915 0.929 1.581 0.999 0.684-0.071 1.258-0.449 1.594-0.99l0.415-0.009c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5l0.8-2c1.322-0.862 2.187-2.328 2.2-3.998 0-2.763-2.239-5.002-5-5.002zM10.25 8.21l-0.25 0.17-0.11 0.29-0.89 2.14c-0.042 0.111-0.147 0.189-0.27 0.19h-1.51c-0.103-0.020-0.186-0.093-0.219-0.188l-0.871-2.142-0.13-0.29-0.25-0.18c-1.045-0.7-1.729-1.868-1.75-3.197-0-2.212 1.791-4.003 4-4.003s4 1.791 4 4c-0.017 1.336-0.702 2.509-1.736 3.201z"></path><path d="M10.29 3c-0.574-0.612-1.387-0.995-2.289-1l-0.001 1c0.585 0.002 1.115 0.238 1.5 0.62 0.278 0.386 0.459 0.858 0.499 1.37l1.001 0.009c-0.045-0.756-0.305-1.443-0.718-2.011z"></path></g>
<g id="vaadin:line-bar-chart"><path d="M5 11h3v5h-3v-5z"></path><path d="M1 14h3v2h-3v-2z"></path><path d="M13 12h3v4h-3v-4z"></path><path d="M9 9h3v7h-3v-7z"></path><path d="M16 0.070l-5.68 4.97-5.47-1.7-4.85 3.76v1.9l5.15-4 5.53 1.72 5.32-4.66v-1.99z"></path></g>
<g id="vaadin:line-chart"><path d="M1 15v-15h-1v16h16v-1h-15z"></path><path d="M9 8l-3-3-4 4v2l4-4 3 3 7-7v-2z"></path></g>
<g id="vaadin:line-h"><path d="M0 7h16v1h-16v-1z"></path></g>
<g id="vaadin:line-v"><path d="M8 0h1v16h-1v-16z"></path></g>
<g id="vaadin:lines-list"><path d="M0 1h3v2h-3v-2z"></path><path d="M0 5h3v2h-3v-2z"></path><path d="M0 9h3v2h-3v-2z"></path><path d="M0 13h3v2h-3v-2z"></path><path d="M4 1h12v2h-12v-2z"></path><path d="M4 5h12v2h-12v-2z"></path><path d="M4 9h12v2h-12v-2z"></path><path d="M4 13h12v2h-12v-2z"></path></g>
<g id="vaadin:lines"><path d="M0 1h16v2h-16v-2z"></path><path d="M0 5h16v2h-16v-2z"></path><path d="M0 9h16v2h-16v-2z"></path><path d="M0 13h16v2h-16v-2z"></path></g>
<g id="vaadin:link"><path d="M14.9 1.1c-1.4-1.4-3.7-1.4-5.1 0l-4.4 4.3c-1.4 1.5-1.4 3.7 0 5.2 0.1 0.1 0.3 0.2 0.4 0.3l1.5-1.5c-0.1-0.1-0.3-0.2-0.4-0.3-0.6-0.6-0.6-1.6 0-2.2l4.4-4.4c0.6-0.6 1.6-0.6 2.2 0s0.6 1.6 0 2.2l-1.3 1.3c0.4 0.8 0.5 1.7 0.4 2.5l2.3-2.3c1.5-1.4 1.5-3.7 0-5.1z"></path><path d="M10.2 5.1l-1.5 1.5c0 0 0.3 0.2 0.4 0.3 0.6 0.6 0.6 1.6 0 2.2l-4.4 4.4c-0.6 0.6-1.6 0.6-2.2 0s-0.6-1.6 0-2.2l1.3-1.3c-0.4-0.8-0.1-1.3-0.4-2.5l-2.3 2.3c-1.4 1.4-1.4 3.7 0 5.1s3.7 1.4 5.1 0l4.4-4.4c1.4-1.4 1.4-3.7 0-5.1-0.2-0.1-0.4-0.3-0.4-0.3z"></path></g>
<g id="vaadin:list-ol"><path d="M4 0h12v4h-12v-4z"></path><path d="M4 6h12v4h-12v-4z"></path><path d="M4 12h12v4h-12v-4z"></path><path d="M1 0l-0.9 0.5 0.2 0.7 0.7-0.3v3.1h1v-4z"></path><path d="M2.2 13.9c0.3-0.2 0.5-0.5 0.5-0.8 0-0.5-0.4-1-1.3-1-0.5 0-1 0.1-1.2 0.3h-0.1l0.2 0.8 0.1-0.1c0.1-0.1 0.4-0.2 0.7-0.2s0.4 0.1 0.4 0.3c0 0.4-0.5 0.4-0.6 0.4h-0.4v0.7h0.4c0.3 0 0.6 0.1 0.6 0.4 0 0.2-0.2 0.4-0.6 0.4s-0.7-0.2-0.8-0.2l-0.1-0.1v0.9h0.1c0.2 0.2 0.6 0.3 1.1 0.3 1 0 1.6-0.5 1.6-1.2 0-0.4-0.2-0.8-0.6-0.9z"></path><path d="M0.1 6.4l0.3 1c0 0 0.7-0.6 1.2-0.3 1.1 0.8-1.6 2.4-1.6 2.4v0.5h3v-1h-1.2c0.6-0.5 1.2-1.2 1-1.9-0.5-1.9-2.7-0.7-2.7-0.7z"></path></g>
<g id="vaadin:list-select"><path d="M1 0h12v2h-12v-2z"></path><path d="M1 8h13v2h-13v-2z"></path><path d="M1 11h11v2h-11v-2z"></path><path d="M1 14h14v2h-14v-2z"></path><path d="M0 3v4h16v-4h-16zM11 6h-10v-2h10v2z"></path></g>
<g id="vaadin:list-ul"><path d="M0 1h3v3h-3v-3z"></path><path d="M0 6h3v3h-3v-3z"></path><path d="M0 11h3v3h-3v-3z"></path><path d="M5 1h11v3h-11v-3z"></path><path d="M5 6h11v3h-11v-3z"></path><path d="M5 11h11v3h-11v-3z"></path></g>
<g id="vaadin:list"><path d="M0 0h4v3h-4v-3z"></path><path d="M0 4h4v3h-4v-3z"></path><path d="M0 12h4v3h-4v-3z"></path><path d="M0 8h4v3h-4v-3z"></path><path d="M5 0h11v3h-11v-3z"></path><path d="M5 4h11v3h-11v-3z"></path><path d="M5 12h11v3h-11v-3z"></path><path d="M5 8h11v3h-11v-3z"></path></g>
<g id="vaadin:location-arrow-circle-o"><path d="M1 8c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7-7-3.1-7-7zM0 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8v0z"></path><path d="M2 9l10-5-5 10v-5z"></path></g>
<g id="vaadin:location-arrow-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 14v-5h-5l10-5-5 10z"></path></g>
<g id="vaadin:location-arrow"><path d="M0 9l16-9-9 16v-7z"></path></g>
<g id="vaadin:lock"><path d="M12 8v-3.1c0-2.2-1.6-3.9-3.8-3.9h-0.3c-2.1 0-3.9 1.7-3.9 3.9v3.1h-1l0.1 5c0 0-0.1 3 4.9 3s5-3 5-3v-5h-1zM9 14h-1v-2c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1v3zM10 8h-4v-3.1c0-1.1 0.9-1.9 1.9-1.9h0.3c1 0 1.8 0.8 1.8 1.9v3.1z"></path></g>
<g id="vaadin:magic"><path d="M0 5h3v1h-3v-1z"></path><path d="M5 0h1v3h-1v-3z"></path><path d="M6 11h-1v-2.5l1 1z"></path><path d="M11 6h-1.5l-1-1h2.5z"></path><path d="M3.131 7.161l0.707 0.707-2.97 2.97-0.707-0.707 2.97-2.97z"></path><path d="M10.131 0.161l0.707 0.707-2.97 2.97-0.707-0.707 2.97-2.97z"></path><path d="M0.836 0.199l3.465 3.465-0.707 0.707-3.465-3.465 0.707-0.707z"></path><path d="M6.1 4.1l-2.1 2 9.8 9.9 2.2-2.1-9.9-9.8zM6.1 5.5l2.4 2.5-0.6 0.6-2.5-2.5 0.7-0.6z"></path></g>
<g id="vaadin:magnet"><path d="M11 0h5v4h-5v-4z"></path><path d="M11 5v3c0 1.6-1.4 3-3 3s-3-1.4-3-3v-3h-5v3c0 4.4 3.6 8 8 8s8-3.6 8-8v-3h-5z"></path><path d="M0 0h5v4h-5v-4z"></path></g>
<g id="vaadin:mailbox"><path d="M13 1h-10l-3 9v5h16v-5l-3-9zM11 10v2h-6v-2h-3.9l2.7-8h8.6l2.7 8h-4.1z"></path></g>
<g id="vaadin:male"><path d="M10 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M12.79 7.32l-2.6-2.63c-0.421-0.426-1.004-0.69-1.65-0.69h-1.070c-0 0-0 0-0.001 0-0.648 0-1.235 0.264-1.659 0.69l-2.6 2.63c-0.216 0.129-0.358 0.362-0.358 0.628 0 0.403 0.327 0.73 0.73 0.73 0.266 0 0.499-0.142 0.626-0.355l1.792-1.793v9.47h1.5v-5h1v5h1.5v-9.47l1.75 1.8c0.135 0.175 0.344 0.287 0.58 0.287 0.403 0 0.73-0.327 0.73-0.73 0-0.228-0.105-0.432-0.269-0.566z"></path></g>
<g id="vaadin:map-marker"><path d="M8 0c-2.8 0-5 2.2-5 5s4 11 5 11c1 0 5-8.2 5-11s-2.2-5-5-5zM8 8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"></path></g>
<g id="vaadin:margin-bottom"><path d="M0 0v14h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v-13h-16zM15 12h-14v-11h14v11z"></path><path d="M0 15h1v1h-1v-1z"></path><path d="M1 14h1v1h-1v-1z"></path><path d="M2 15h1v1h-1v-1z"></path><path d="M3 14h1v1h-1v-1z"></path><path d="M4 15h1v1h-1v-1z"></path><path d="M5 14h1v1h-1v-1z"></path><path d="M6 15h1v1h-1v-1z"></path><path d="M7 14h1v1h-1v-1z"></path><path d="M8 15h1v1h-1v-1z"></path><path d="M9 14h1v1h-1v-1z"></path><path d="M10 15h1v1h-1v-1z"></path><path d="M11 14h1v1h-1v-1z"></path><path d="M12 15h1v1h-1v-1z"></path><path d="M13 14h1v1h-1v-1z"></path><path d="M14 15h1v1h-1v-1z"></path><path d="M15 14h1v1h-1v-1z"></path></g>
<g id="vaadin:margin-left"><path d="M2 0v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h13v-16h-14zM15 15h-11v-14h11v14z"></path><path d="M0 0h1v1h-1v-1z"></path><path d="M1 1h1v1h-1v-1z"></path><path d="M0 2h1v1h-1v-1z"></path><path d="M1 3h1v1h-1v-1z"></path><path d="M0 4h1v1h-1v-1z"></path><path d="M1 5h1v1h-1v-1z"></path><path d="M0 6h1v1h-1v-1z"></path><path d="M1 7h1v1h-1v-1z"></path><path d="M0 8h1v1h-1v-1z"></path><path d="M1 9h1v1h-1v-1z"></path><path d="M0 10h1v1h-1v-1z"></path><path d="M1 11h1v1h-1v-1z"></path><path d="M0 12h1v1h-1v-1z"></path><path d="M1 13h1v1h-1v-1z"></path><path d="M0 14h1v1h-1v-1z"></path><path d="M1 15h1v1h-1v-1z"></path></g>
<g id="vaadin:margin-right"><path d="M14 2v-1h-1v-1h-13v16h14v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1zM12 15h-11v-14h11v14z"></path><path d="M15 15h1v1h-1v-1z"></path><path d="M14 14h1v1h-1v-1z"></path><path d="M15 13h1v1h-1v-1z"></path><path d="M14 12h1v1h-1v-1z"></path><path d="M15 11h1v1h-1v-1z"></path><path d="M14 10h1v1h-1v-1z"></path><path d="M15 9h1v1h-1v-1z"></path><path d="M14 8h1v1h-1v-1z"></path><path d="M15 7h1v1h-1v-1z"></path><path d="M14 6h1v1h-1v-1z"></path><path d="M15 5h1v1h-1v-1z"></path><path d="M14 4h1v1h-1v-1z"></path><path d="M15 3h1v1h-1v-1z"></path><path d="M14 2h1v1h-1v-1z"></path><path d="M15 1h1v1h-1v-1z"></path><path d="M14 0h1v1h-1v-1z"></path></g>
<g id="vaadin:margin-top"><path d="M15 2v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v13h16v-14h-1zM15 15h-14v-11h14v11z"></path><path d="M15 0h1v1h-1v-1z"></path><path d="M14 1h1v1h-1v-1z"></path><path d="M13 0h1v1h-1v-1z"></path><path d="M12 1h1v1h-1v-1z"></path><path d="M11 0h1v1h-1v-1z"></path><path d="M10 1h1v1h-1v-1z"></path><path d="M9 0h1v1h-1v-1z"></path><path d="M8 1h1v1h-1v-1z"></path><path d="M7 0h1v1h-1v-1z"></path><path d="M6 1h1v1h-1v-1z"></path><path d="M5 0h1v1h-1v-1z"></path><path d="M4 1h1v1h-1v-1z"></path><path d="M3 0h1v1h-1v-1z"></path><path d="M2 1h1v1h-1v-1z"></path><path d="M1 0h1v1h-1v-1z"></path><path d="M0 1h1v1h-1v-1z"></path></g>
<g id="vaadin:margin"><path d="M0 0h1v1h-1v-1z"></path><path d="M2 0h1v1h-1v-1z"></path><path d="M1 1h1v1h-1v-1z"></path><path d="M0 2h1v1h-1v-1z"></path><path d="M2 2h1v1h-1v-1z"></path><path d="M1 3h1v1h-1v-1z"></path><path d="M0 4h1v1h-1v-1z"></path><path d="M1 5h1v1h-1v-1z"></path><path d="M0 6h1v1h-1v-1z"></path><path d="M1 7h1v1h-1v-1z"></path><path d="M0 8h1v1h-1v-1z"></path><path d="M1 9h1v1h-1v-1z"></path><path d="M0 10h1v1h-1v-1z"></path><path d="M1 11h1v1h-1v-1z"></path><path d="M0 12h1v1h-1v-1z"></path><path d="M1 13h1v1h-1v-1z"></path><path d="M0 14h1v1h-1v-1z"></path><path d="M2 14h1v1h-1v-1z"></path><path d="M1 15h1v1h-1v-1z"></path><path d="M3 15h1v1h-1v-1z"></path><path d="M5 15h1v1h-1v-1z"></path><path d="M4 0h1v1h-1v-1z"></path><path d="M3 1h1v1h-1v-1z"></path><path d="M5 1h1v1h-1v-1z"></path><path d="M4 14h1v1h-1v-1z"></path><path d="M6 0h1v1h-1v-1z"></path><path d="M8 0h1v1h-1v-1z"></path><path d="M7 1h1v1h-1v-1z"></path><path d="M6 14h1v1h-1v-1z"></path><path d="M8 14h1v1h-1v-1z"></path><path d="M7 15h1v1h-1v-1z"></path><path d="M9 15h1v1h-1v-1z"></path><path d="M11 15h1v1h-1v-1z"></path><path d="M10 0h1v1h-1v-1z"></path><path d="M9 1h1v1h-1v-1z"></path><path d="M11 1h1v1h-1v-1z"></path><path d="M10 14h1v1h-1v-1z"></path><path d="M12 0h1v1h-1v-1z"></path><path d="M14 0h1v1h-1v-1z"></path><path d="M13 1h1v1h-1v-1z"></path><path d="M13 2h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1zM12 12h-8v-8h8v8z"></path><path d="M14 2h1v1h-1v-1z"></path><path d="M14 4h1v1h-1v-1z"></path><path d="M14 6h1v1h-1v-1z"></path><path d="M14 8h1v1h-1v-1z"></path><path d="M14 10h1v1h-1v-1z"></path><path d="M14 12h1v1h-1v-1z"></path><path d="M13 13h1v1h-1v-1z"></path><path d="M12 14h1v1h-1v-1z"></path><path d="M14 14h1v1h-1v-1z"></path><path d="M13 15h1v1h-1v-1z"></path><path d="M15 15h1v1h-1v-1z"></path><path d="M15 1h1v1h-1v-1z"></path><path d="M15 3h1v1h-1v-1z"></path><path d="M15 5h1v1h-1v-1z"></path><path d="M15 7h1v1h-1v-1z"></path><path d="M15 9h1v1h-1v-1z"></path><path d="M15 11h1v1h-1v-1z"></path><path d="M15 13h1v1h-1v-1z"></path></g>
<g id="vaadin:medal"><path d="M10 12.2c-0.3 0-0.5-0.1-0.8-0.2l-1.2-0.5-1.2 0.5c-0.2 0.1-0.5 0.2-0.8 0.2-0.2 0-0.3 0-0.5-0.1l-0.5 3.9 3-2 3 2-0.6-3.9c-0.1 0.1-0.3 0.1-0.4 0.1z"></path><path d="M12.9 5.9c-0.1-0.2-0.1-0.5 0-0.7l0.6-1.2c0.2-0.4 0-0.9-0.5-1.1l-1.3-0.5c-0.2-0.1-0.4-0.3-0.5-0.5l-0.5-1.3c-0.1-0.4-0.4-0.6-0.7-0.6-0.1 0-0.3 0-0.4 0.1l-1.3 0.6c-0.1 0-0.2 0-0.3 0s-0.2 0-0.3-0.1l-1.3-0.5c-0.1-0.1-0.3-0.1-0.4-0.1-0.3 0-0.6 0.2-0.8 0.5l-0.5 1.4c0 0.2-0.2 0.4-0.4 0.5l-1.4 0.5c-0.4 0.1-0.6 0.6-0.4 1.1l0.6 1.3c0.1 0.2 0.1 0.5 0 0.7l-0.6 1.2c-0.2 0.4 0 0.9 0.5 1.1l1.3 0.5c0.2 0.1 0.4 0.3 0.5 0.5l0.5 1.3c0.1 0.4 0.4 0.6 0.7 0.6 0.1 0 0.2 0 0.3-0.1l1.3-0.6c0.1 0 0.2-0.1 0.3-0.1s0.2 0 0.3 0.1l1.3 0.6c0.1 0.1 0.2 0.1 0.3 0.1 0.3 0 0.6-0.2 0.8-0.5l0.5-1.3c0.1-0.2 0.3-0.4 0.5-0.5l1.3-0.5c0.4-0.2 0.7-0.7 0.5-1.1l-0.5-1.4zM8 9.6c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4c0 2.2-1.8 4-4 4z"></path><path d="M11 5.6c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path></g>
<g id="vaadin:megafone"><path d="M15.5 5.4l-0.5-0.4v-4c0-0.6-0.4-1-1-1s-1 0.4-1 1v0.5c-2 0.9-5 2.5-8 2.5h-2.5c-1.4 0-2.5 1.2-2.5 2.5 0 0.9 0.5 1.7 1.2 2.1l1.1 5.9c0 0.3 0.3 0.5 0.7 0.5 0.1 0 0.1 0 0.2 0l3.6-0.7c0.4-0.1 0.6-0.4 0.5-0.7-0.3-0.6-0.8-1.5-1.2-1.8-0.2-0.1-0.5-0.9-0.7-1.8h0.6v-0.9c2.7 0.3 6 1.6 7 2.4v0.5c0 0.6 0.4 1 1 1s1-0.4 1-1v-4l0.4-0.3c0.4-0.3 0.6-0.7 0.6-1.1v-0.2c0-0.4-0.2-0.7-0.5-1zM2 5h3v1h-3v-1zM5.6 12.6c0.1 0 0.3 0.3 0.5 0.7l-2.8 0.7-1-5h1.9c0.2 1.3 0.6 3.2 1.4 3.6zM13 10.3c-1.6-0.8-4.4-2-7-2.3v-3c2.6-0.3 5.4-1.4 7-2.3v7.6z"></path></g>
<g id="vaadin:megaphone"><path d="M15.5 5.4l-0.5-0.4v-4c0-0.6-0.4-1-1-1s-1 0.4-1 1v0.5c-2 0.9-5 2.5-8 2.5h-2.5c-1.4 0-2.5 1.2-2.5 2.5 0 0.9 0.5 1.7 1.2 2.1l1.1 5.9c0 0.3 0.3 0.5 0.7 0.5 0.1 0 0.1 0 0.2 0l3.6-0.7c0.4-0.1 0.6-0.4 0.5-0.7-0.3-0.6-0.8-1.5-1.2-1.8-0.2-0.1-0.5-0.9-0.7-1.8h0.6v-0.9c2.7 0.3 6 1.6 7 2.4v0.5c0 0.6 0.4 1 1 1s1-0.4 1-1v-4l0.4-0.3c0.4-0.3 0.6-0.7 0.6-1.1v-0.2c0-0.4-0.2-0.7-0.5-1zM2 5h3v1h-3v-1zM5.6 12.6c0.1 0 0.3 0.3 0.5 0.7l-2.8 0.7-1-5h1.9c0.2 1.3 0.6 3.2 1.4 3.6zM13 10.3c-1.6-0.8-4.4-2-7-2.3v-3c2.6-0.3 5.4-1.4 7-2.3v7.6z"></path></g>
<g id="vaadin:meh-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M7 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M11 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M4 10h8v1h-8v-1z"></path></g>
<g id="vaadin:menu"><path d="M0 1h16v3h-16v-3z"></path><path d="M0 6h16v3h-16v-3z"></path><path d="M0 11h16v3h-16v-3z"></path></g>
<g id="vaadin:microphone"><path d="M8 10v0c-1.7 0-3-1.3-3-3v-4c0-1.6 1.3-3 3-3v0c1.6 0 3 1.3 3 3v4c0 1.6-1.4 3-3 3z"></path><path d="M12 5v2.5c0 1.9-1.8 3.5-3.8 3.5h-0.4c-2 0-3.8-1.6-3.8-3.5v-2.5c-0.6 0-1 0.4-1 1v1.5c0 2.2 1.8 4.1 4 4.4v2.1c-3 0-2.5 2-2.5 2h7c0 0 0.5-2-2.5-2v-2.1c2.2-0.4 4-2.2 4-4.4v-1.5c0-0.6-0.4-1-1-1z"></path></g>
<g id="vaadin:minus-circle-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M3 7h10v2h-10v-2z"></path></g>
<g id="vaadin:minus-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM13 9h-10v-2h10v2z"></path></g>
<g id="vaadin:minus-square-o"><path d="M4 7h8v2h-8v-2z"></path><path d="M15 1h-14v14h14v-14zM14 14h-12v-12h12v12z"></path></g>
<g id="vaadin:minus"><path d="M2 7h12v2h-12v-2z"></path></g>
<g id="vaadin:mobile-browser"><path d="M16 0h-13v5h-3v11h7v-3h9v-13zM6 1h9v1h-9v-1zM4 1h1v1h-1v-1zM4 15h-1v-1h1v1zM6 13h-5v-7h5v7zM15 12h-8v-7h-3v-2h11v9z"></path></g>
<g id="vaadin:mobile-retro"><path d="M11 0h-1v2h-6v14h7v-16zM6 14h-1v-1h1v1zM6 12h-1v-1h1v1zM6 10h-1v-1h1v1zM8 14h-1v-1h1v1zM8 12h-1v-1h1v1zM8 10h-1v-1h1v1zM10 14h-1v-1h1v1zM10 12h-1v-1h1v1zM10 10h-1v-1h1v1zM10 8h-5v-4h5v4z"></path></g>
<g id="vaadin:mobile"><path d="M4 1v14h8v-14h-8zM9 14h-2v-1h2v1zM11 12h-6v-9h6v9z"></path></g>
<g id="vaadin:modal-list"><path d="M3 6h2v1h-2v-1z"></path><path d="M6 6h7v1h-7v-1z"></path><path d="M3 8h2v1h-2v-1z"></path><path d="M6 8h7v1h-7v-1z"></path><path d="M3 10h2v1h-2v-1z"></path><path d="M6 10h7v1h-7v-1z"></path><path d="M0 1v14h16v-14h-16zM15 14h-14v-10h14v10zM15 3h-1v-1h1v1z"></path></g>
<g id="vaadin:modal"><path d="M0 1v14h16v-14h-16zM15 14h-14v-10h14v10zM15 3h-1v-1h1v1z"></path></g>
<g id="vaadin:money-deposit"><path d="M8 16l-2-3h1v-2h2v2h1l-2 3z"></path><path d="M15 1v8h-14v-8h14zM16 0h-16v10h16v-10z"></path><path d="M8 2c1.657 0 3 1.343 3 3s-1.343 3-3 3h5v-1h1v-4h-1v-1h-5z"></path><path d="M5 5c0-1.657 1.343-3 3-3h-5v1h-1v4h1v1h5c-1.657 0-3-1.343-3-3z"></path></g>
<g id="vaadin:money-exchange"><path d="M16 14l-3 2v-1h-4.75l2-2h2.75v-1l3 2z"></path><path d="M0 2l3-2v1h4.75l-2 2h-2.75v1l-3-2z"></path><path d="M9.74 0l-9.74 9.74 6.26 6.26 9.74-9.74zM1.39 9.74l8.35-8.35 4.87 4.87-8.35 8.35z"></path><path d="M4.17 9.74l-0.7 0.7 2.090 2.090 0.7-0.7 0.74 0.69 2.74-2.78c-0.445 0.445-1.060 0.721-1.74 0.721-1.359 0-2.461-1.102-2.461-2.461 0-0.68 0.275-1.295 0.721-1.74l-2.78 2.74z"></path><path d="M12.52 5.57l-2.090-2.090-0.7 0.7-0.73-0.7-2.74 2.78c0.445-0.445 1.060-0.721 1.74-0.721 1.359 0 2.461 1.102 2.461 2.461 0 0.68-0.275 1.295-0.721 1.74l2.78-2.74-0.7-0.7z"></path></g>
<g id="vaadin:money-withdraw"><path d="M8 0l2 3h-1v2h-2v-2h-1l2-3z"></path><path d="M15 7v8h-14v-8h14zM16 6h-16v10h16v-10z"></path><path d="M8 8c1.657 0 3 1.343 3 3s-1.343 3-3 3h5v-1h1v-4h-1v-1h-5z"></path><path d="M5 11c0-1.657 1.343-3 3-3h-5v1h-1v4h1v1h5c-1.657 0-3-1.343-3-3z"></path></g>
<g id="vaadin:money"><path d="M15 4v8h-14v-8h14zM16 3h-16v10h16v-10z"></path><path d="M8 5c1.7 0 3 1.3 3 3s-1.3 3-3 3h5v-1h1v-4h-1v-1h-5z"></path><path d="M5 8c0-1.7 1.3-3 3-3h-5v1h-1v4h1v1h5c-1.7 0-3-1.3-3-3z"></path></g>
<g id="vaadin:moon-o"><path d="M13.2 11.9c-4.5 0-8.1-3.6-8.1-8.1 0-1.4 0.3-2.7 0.9-3.8-3.4 0.9-6 4.1-6 7.9 0 4.5 3.6 8.1 8.1 8.1 3.1 0 5.8-1.8 7.2-4.4-0.6 0.2-1.3 0.3-2.1 0.3zM8.1 15c-3.9 0-7.1-3.2-7.1-7.1 0-2.5 1.3-4.7 3.3-6-0.2 0.6-0.2 1.2-0.2 1.9 0 5 4.1 9.1 9.1 9.2-1.4 1.2-3.2 2-5.1 2z"></path></g>
<g id="vaadin:moon"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM8 15c-3.9 0-7-3.1-7-7 0-2.4 1.2-4.6 3.2-5.9-0.1 0.6-0.2 1.3-0.2 1.9 0 4.9 4 8.9 8.9 9-1.3 1.3-3 2-4.9 2z"></path></g>
<g id="vaadin:morning"><path d="M14 10l-1.58-1.18 0.78-1.82-2-0.23-0.2-1.97-1.82 0.78-1.18-1.58-1.18 1.58-1.82-0.78-0.23 2-1.97 0.2 0.78 1.82-1.58 1.18h-2v1h16v-1h-2zM4 10c0.075-2.178 1.822-3.925 3.993-4 2.185 0.075 3.932 1.821 4.007 3.993l-8 0.007z"></path></g>
<g id="vaadin:movie"><path d="M12 7v-3h-12v9h12v-3l4 2v-7l-4 2zM9 11h-7v-5h7v5z"></path><path d="M5 8.4c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M8 8.4c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path></g>
<g id="vaadin:music"><path d="M4 3v9.4c-0.4-0.2-0.9-0.4-1.5-0.4-1.4 0-2.5 0.9-2.5 2s1.1 2 2.5 2 2.5-0.9 2.5-2v-7.3l7-2.3v5.1c-0.4-0.3-0.9-0.5-1.5-0.5-1.4 0-2.5 0.9-2.5 2s1.1 2 2.5 2 2.5-0.9 2.5-2v-11l-9 3z"></path></g>
<g id="vaadin:mute"><path d="M15.2 0l-4.2 4.2v-1.2c0-1.7-1.3-3-3-3s-3 1.3-3 3v4c0 0.9 0.4 1.7 1 2.2l-0.8 0.8c-0.7-0.6-1.2-1.5-1.2-2.5v-2.5c-0.6 0-1 0.4-1 1v1.5c0 1.3 0.6 2.4 1.5 3.2l-4.5 4.6v0.7h0.7l15.3-15.4v-0.6h-0.8z"></path><path d="M12.5 5.1l-0.5 0.5v1.9c0 1.9-1.8 3.5-3.8 3.5h-0.4c-0.3 0-0.6-0.1-0.9-0.1l-0.9 0.7c0.3 0.1 0.6 0.2 1 0.3v2.1c-3 0-2.5 2-2.5 2h7c0 0 0.5-2-2.5-2v-2.1c2.2-0.4 4-2.2 4-4.4v-1.5c0-0.4-0.2-0.7-0.5-0.9z"></path><path d="M11 7v-0.4l-3.3 3.4c0.1 0 0.2 0 0.3 0 1.7 0 3-1.4 3-3z"></path></g>
<g id="vaadin:native-button"><path d="M15 12h-14c-0.6 0-1-0.4-1-1v-6c0-0.6 0.4-1 1-1h14c0.6 0 1 0.4 1 1v6c0 0.6-0.4 1-1 1z"></path></g>
<g id="vaadin:newspaper"><path d="M2 4h11v4h-11v-4z"></path><path d="M2 2h11v1h-11v-1z"></path><path d="M8 13h3v1h-3v-1z"></path><path d="M8 11h5v1h-5v-1z"></path><path d="M8 9h5v1h-5v-1z"></path><path d="M2 13h5v1h-5v-1z"></path><path d="M2 11h5v1h-5v-1z"></path><path d="M2 9h5v1h-5v-1z"></path><path d="M15 2v-2h-15v14.5c0 0.828 0.672 1.5 1.5 1.5h13c0.828 0 1.5-0.672 1.5-1.5v-12.5h-1zM1.5 15c-0.276 0-0.5-0.224-0.5-0.5v-13.5h13v12.5c0 1.5 1 1.5 1 1.5h-13.5z"></path></g>
<g id="vaadin:notebook"><path d="M2 0v1h-0.52c-0.265 0-0.48 0.215-0.48 0.48v0c-0.001 0.012-0.002 0.026-0.002 0.040 0 0.265 0.215 0.48 0.48 0.48 0.001 0 0.001 0 0.002 0h0.52v1h-0.52c-0.265 0-0.48 0.215-0.48 0.48v0c-0.001 0.012-0.002 0.026-0.002 0.040 0 0.265 0.215 0.48 0.48 0.48 0.001 0 0.001 0 0.002 0h0.52v1h-0.52c-0.265 0-0.48 0.215-0.48 0.48 0 0 0 0 0 0v0c-0.001 0.012-0.002 0.026-0.002 0.040 0 0.265 0.215 0.48 0.48 0.48 0.001 0 0.001 0 0.002 0h0.52v1h-0.52c-0.265 0-0.48 0.215-0.48 0.48 0 0 0 0 0 0v0c-0.001 0.012-0.002 0.026-0.002 0.040 0 0.265 0.215 0.48 0.48 0.48 0.001 0 0.001 0 0.002 0h0.52v1h-0.52c-0.265 0-0.48 0.215-0.48 0.48 0 0 0 0 0 0v0c0 0.265 0.215 0.48 0.48 0.48 0 0 0 0 0 0h0.52v1h-0.52c-0.265 0-0.48 0.215-0.48 0.48 0 0 0 0 0 0v0c0 0.265 0.215 0.48 0.48 0.48 0 0 0 0 0 0h0.52v1h-0.52c-0.265 0-0.48 0.215-0.48 0.48 0 0 0 0 0 0v0c0 0.265 0.215 0.48 0.48 0.48 0 0 0 0 0 0h0.52v2h12v-15.88h-12zM3.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM3.5 12c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM3.5 10c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM3.5 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM3.5 6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM3.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM3.5 2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM12 6h-6v-3h6v3z"></path></g>
<g id="vaadin:nurse"><path d="M15.2 12c-0.658-1.414-2.067-2.376-3.701-2.376-0.077 0-0.154 0.002-0.23 0.006l-3.269 3.9-3.28-3.9c-0.049-0.002-0.106-0.003-0.163-0.003-1.648 0-3.072 0.958-3.746 2.348-0.422 0.9-0.707 1.917-0.808 2.988l1.997 0.037v1h12v-1h2c-0.104-1.107-0.388-2.124-0.824-3.057z"></path><path d="M6.57 8.73c-0.038 0.374-0.322 0.671-0.685 0.729l2.115 2.541 2.12-2.52c-0.368-0.059-0.652-0.356-0.69-0.727-0-0.613 0.8-0.413 1.43-1.453 0-0.030 2.88-7.3-2.86-7.3s-2.86 7.27-2.86 7.27c0.63 1.050 1.44 0.85 1.43 1.46z"></path></g>
<g id="vaadin:office"><path d="M14 15v-11h-3v-3h-9v14h-2v1h7v-3h2v3h7v-1h-2zM6 11h-2v-2h2v2zM6 8h-2v-2h2v2zM6 5h-2v-2h2v2zM9 11h-2v-2h2v2zM9 8h-2v-2h2v2zM9 5h-2v-2h2v2zM13 11h-2v-2h2v2zM13 8h-2v-2h2v2z"></path></g>
<g id="vaadin:open-book"><path d="M15 4.7v-0.7c-1.159-1.163-2.734-1.91-4.484-1.999-0.112-0.012-0.222-0.018-0.334-0.018-0.874 0-1.657 0.394-2.179 1.013-0.556-0.617-1.357-1.007-2.249-1.007-0.090 0-0.178 0.004-0.266 0.012-1.754 0.089-3.33 0.836-4.488 1.999l-0 0.7-1 0.3v10l6.7-1.4 0.3 0.4h2l0.3-0.4 6.7 1.4v-10zM5.48 11.31c-1.275 0.037-2.467 0.358-3.526 0.902l0.046-7.792c0.885-0.835 2.066-1.365 3.369-1.42 0.806 0.054 1.534 0.303 2.159 0.701l-0.019 7.869c-0.555-0.166-1.193-0.262-1.854-0.262-0.062 0-0.124 0.001-0.185 0.003zM14 12.19c-1.013-0.522-2.205-0.843-3.468-0.88-0.056-0.001-0.108-0.002-0.161-0.002-0.66 0-1.297 0.096-1.899 0.274l0.047-7.902c0.601-0.381 1.322-0.627 2.096-0.679 1.324 0.055 2.501 0.586 3.386 1.422l-0.003 7.768z"></path></g>
<g id="vaadin:option-a"><path d="M12.5 10h-1.5v-4h1.5c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5c-1.381 0-2.5 1.119-2.5 2.5v1.5h-4v-1.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5c0 1.381 1.119 2.5 2.5 2.5h1.5v4h-1.5c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5c1.381 0 2.5-1.119 2.5-2.5v-1.5h4v1.5c0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5c0-1.381-1.119-2.5-2.5-2.5zM11 3.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5h-1.5v-1.5zM5 12.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5h1.5v1.5zM5 5h-1.5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v1.5zM10 10h-4v-4h4v4zM12.5 14c-0.828 0-1.5-0.672-1.5-1.5v-1.5h1.5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5z"></path></g>
<g id="vaadin:option"><path d="M4 11c0 0.552 0.448 1 1 1s1-0.448 1-1v-1h-1c-0.552 0-1 0.448-1 1z"></path><path d="M0 0v16h16v-16h-16zM11 9c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2v-1h-2v1c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2h1v-2h-1c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v1h2v-1c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2h-1v2h1z"></path><path d="M12 5c0-0.552-0.448-1-1-1s-1 0.448-1 1v1h1c0.552 0 1-0.448 1-1z"></path><path d="M5 4c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v-1c0-0.552-0.448-1-1-1z"></path><path d="M7 7h2v2h-2v-2z"></path><path d="M10 11c0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.552-0.448-1-1-1h-1v1z"></path></g>
<g id="vaadin:options"><path d="M5 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path><path d="M3.5 0c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zM3.5 6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5z"></path><path d="M3.5 8c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5c0-1.9-1.6-3.5-3.5-3.5zM3.5 14c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5z"></path><path d="M8 2h8v3h-8v-3z"></path><path d="M8 10h8v3h-8v-3z"></path></g>
<g id="vaadin:orientation"><path d="M11 2.1c2 0 3 1.3 3 2.9h-1l1.5 2 1.5-2h-1c0-2.2-2-3.9-4-3.9v-1.1l-2 1.5 2 1.5v-0.9z"></path><path d="M9 9h6v6h-7v-15h-8v16h16v-8h-7v1zM7 8h-1v1h1v6h-6v-14h6v7z"></path><path d="M2 8h1v1h-1v-1z"></path><path d="M4 8h1v1h-1v-1z"></path></g>
<g id="vaadin:out"><path d="M3.5 8c0.3 0 0.5 0.2 0.5 0.5v2c0 0.3-0.2 0.5-0.5 0.5s-0.5-0.2-0.5-0.5v-2c0-0.3 0.2-0.5 0.5-0.5v0zM3.5 7v0c-0.8 0-1.5 0.7-1.5 1.5v2c0 0.8 0.7 1.5 1.5 1.5v0c0.8 0 1.5-0.7 1.5-1.5v-2c0-0.8-0.7-1.5-1.5-1.5v0z"></path><path d="M8 7v3.5c0 0.3-0.2 0.5-0.5 0.5s-0.5-0.2-0.5-0.5v-3.5h-1v3.5c0 0.8 0.7 1.5 1.5 1.5v0c0.8 0 1.5-0.7 1.5-1.5v-3.5h-1z"></path><path d="M13 7h-3v1h1v4h1v-4h1z"></path><path d="M15 6v-1h-2.4l-3.7-3c0.1-0.2 0.1-0.3 0.1-0.5 0-0.8-0.7-1.5-1.5-1.5s-1.5 0.7-1.5 1.5c0 0.2 0 0.3 0.1 0.5l-3.7 3h-2.4v9h1v1h15v-9h-1zM6.7 2.8c0.3 0.1 0.5 0.2 0.8 0.2s0.5-0.1 0.8-0.2l2.7 2.2h-7l2.7-2.2zM14 13h-13v-7h13v7z"></path></g>
<g id="vaadin:outbox"><path d="M6 5v6h4v-6h2l-4-5-4 5z"></path><path d="M13 2h-2l0.9 1h0.4l2.6 8h-3.9v2h-6v-2h-3.9l2.6-8h0.4l0.9-1h-2l-3 9v5h16v-5z"></path></g>
<g id="vaadin:package"><path d="M8 0l-8 2v10l8 4 8-4v-10l-8-2zM8 1l2.1 0.5-5.9 1.9-2.3-0.8 6.1-1.6zM8 14.9l-7-3.5v-8.1l3 1v3.4l1 0.3v-3.3l3 1v9.2zM8.5 4.8l-2.7-0.9 6.2-1.9 2.4 0.6-5.9 2.2z"></path></g>
<g id="vaadin:padding-bottom"><path d="M16 16v-16h-16v16h16zM1 13h1v-1h-1v-11h14v12h-1v1h1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v-1z"></path><path d="M12 13h1v1h-1v-1z"></path><path d="M13 12h1v1h-1v-1z"></path><path d="M11 12h1v1h-1v-1z"></path><path d="M9 12h1v1h-1v-1z"></path><path d="M10 13h1v1h-1v-1z"></path><path d="M8 13h1v1h-1v-1z"></path><path d="M6 13h1v1h-1v-1z"></path><path d="M7 12h1v1h-1v-1z"></path><path d="M5 12h1v1h-1v-1z"></path><path d="M3 12h1v1h-1v-1z"></path><path d="M4 13h1v1h-1v-1z"></path><path d="M2 13h1v1h-1v-1z"></path></g>
<g id="vaadin:padding-left"><path d="M0 16h16v-16h-16v16zM3 1v1h1v-1h11v14h-12v-1h-1v1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h1z"></path><path d="M2 12h1v1h-1v-1z"></path><path d="M3 13h1v1h-1v-1z"></path><path d="M3 11h1v1h-1v-1z"></path><path d="M3 9h1v1h-1v-1z"></path><path d="M2 10h1v1h-1v-1z"></path><path d="M2 8h1v1h-1v-1z"></path><path d="M2 6h1v1h-1v-1z"></path><path d="M3 7h1v1h-1v-1z"></path><path d="M3 5h1v1h-1v-1z"></path><path d="M3 3h1v1h-1v-1z"></path><path d="M2 4h1v1h-1v-1z"></path><path d="M2 2h1v1h-1v-1z"></path></g>
<g id="vaadin:padding-right"><path d="M16 0h-16v16h16v-16zM13 15v-1h-1v1h-11v-14h12v1h1v-1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h-1z"></path><path d="M13 3h1v1h-1v-1z"></path><path d="M12 2h1v1h-1v-1z"></path><path d="M12 4h1v1h-1v-1z"></path><path d="M12 6h1v1h-1v-1z"></path><path d="M13 5h1v1h-1v-1z"></path><path d="M13 7h1v1h-1v-1z"></path><path d="M13 9h1v1h-1v-1z"></path><path d="M12 8h1v1h-1v-1z"></path><path d="M12 10h1v1h-1v-1z"></path><path d="M12 12h1v1h-1v-1z"></path><path d="M13 11h1v1h-1v-1z"></path><path d="M13 13h1v1h-1v-1z"></path></g>
<g id="vaadin:padding-top"><path d="M0 0v16h16v-16h-16zM15 3h-1v1h1v11h-14v-12h1v-1h-1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v1z"></path><path d="M3 2h1v1h-1v-1z"></path><path d="M2 3h1v1h-1v-1z"></path><path d="M4 3h1v1h-1v-1z"></path><path d="M6 3h1v1h-1v-1z"></path><path d="M5 2h1v1h-1v-1z"></path><path d="M7 2h1v1h-1v-1z"></path><path d="M9 2h1v1h-1v-1z"></path><path d="M8 3h1v1h-1v-1z"></path><path d="M10 3h1v1h-1v-1z"></path><path d="M12 3h1v1h-1v-1z"></path><path d="M11 2h1v1h-1v-1z"></path><path d="M13 2h1v1h-1v-1z"></path></g>
<g id="vaadin:padding"><path d="M0 0v16h16v-16h-16zM15 3h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v1z"></path><path d="M3 2h1v1h-1v-1z"></path><path d="M4 3h1v1h-1v-1z"></path><path d="M6 3h1v1h-1v-1z"></path><path d="M5 2h1v1h-1v-1z"></path><path d="M7 2h1v1h-1v-1z"></path><path d="M9 2h1v1h-1v-1z"></path><path d="M8 3h1v1h-1v-1z"></path><path d="M10 3h1v1h-1v-1z"></path><path d="M12 3h1v1h-1v-1z"></path><path d="M11 2h1v1h-1v-1z"></path><path d="M13 2h1v1h-1v-1z"></path><path d="M12 5h1v1h-1v-1z"></path><path d="M13 4h1v1h-1v-1z"></path><path d="M12 7h1v1h-1v-1z"></path><path d="M13 6h1v1h-1v-1z"></path><path d="M12 9h1v1h-1v-1z"></path><path d="M13 8h1v1h-1v-1z"></path><path d="M12 11h1v1h-1v-1z"></path><path d="M13 10h1v1h-1v-1z"></path><path d="M12 13h1v1h-1v-1z"></path><path d="M13 12h1v1h-1v-1z"></path><path d="M2 3h1v1h-1v-1z"></path><path d="M3 4h1v1h-1v-1z"></path><path d="M2 5h1v1h-1v-1z"></path><path d="M3 6h1v1h-1v-1z"></path><path d="M2 7h1v1h-1v-1z"></path><path d="M3 8h1v1h-1v-1z"></path><path d="M2 9h1v1h-1v-1z"></path><path d="M3 10h1v1h-1v-1z"></path><path d="M2 11h1v1h-1v-1z"></path><path d="M2 13h1v1h-1v-1z"></path><path d="M3 12h1v1h-1v-1z"></path><path d="M4 11h1v1h-1v-1z"></path><path d="M4 13h1v1h-1v-1z"></path><path d="M5 12h1v1h-1v-1z"></path><path d="M6 13h1v1h-1v-1z"></path><path d="M7 12h1v1h-1v-1z"></path><path d="M9 12h1v1h-1v-1z"></path><path d="M8 13h1v1h-1v-1z"></path><path d="M11 12h1v1h-1v-1z"></path><path d="M10 13h1v1h-1v-1z"></path></g>
<g id="vaadin:paint-roll"><path d="M16 6.9v-4.9h-2v-2h-13v1h-1v3h1v1h13v-2h1v3.1l-8 1v1.9h-1v0.9c0 0 0.5 0 0.5 0.9s-0.5 0.6-0.5 1.5v2.8c0 0 0 0.9 1.5 0.9s1.5-0.9 1.5-0.9v-2.8c0-0.9-0.5-0.7-0.5-1.5s0.5-0.9 0.5-0.9v-0.9h-1v-1.1l8-1z"></path></g>
<g id="vaadin:paintbrush"><path d="M5.6 11.6l-1.2-1.2c-0.8-0.2-2-0.1-2.7 1-0.8 1.1-0.3 2.8-1.7 4.6 0 0 3.5 0 4.8-1.3 1.2-1.2 1.2-2.2 1-3l-0.2-0.1z"></path><path d="M5.8 8.1c-0.2 0.3-0.5 0.7-0.7 1 0 0.2-0.1 0.3-0.2 0.4l1.5 1.5c0.1-0.1 0.3-0.2 0.4-0.3 0.3-0.2 0.7-0.4 1-0.7 0.4 0 0.6-0.2 0.8-0.4l-2.2-2.2c-0.2 0.2-0.4 0.4-0.6 0.7z"></path><path d="M15.8 0.2c-0.3-0.3-0.7-0.3-1-0.1 0 0-3 2.5-5.9 5.1-0.4 0.4-0.7 0.7-1.1 1-0.2 0.2-0.4 0.4-0.6 0.5l2.1 2.1c0.2-0.2 0.4-0.4 0.5-0.7 0.3-0.4 0.6-0.7 0.9-1.1 2.5-3 5.1-5.9 5.1-5.9 0.3-0.2 0.3-0.6 0-0.9z"></path></g>
<g id="vaadin:palete"><path d="M8.25 0c-6.38 0-9.11 7.38-8.010 9.92 0.82 1.89 2.62 0.080 3.34 1 1.88 2.46-2.11 3.81 0.090 4.68 2.59 1.060 12.33 0.4 12.33-8.53 0-2.69-1.34-7.070-7.75-7.070zM4.47 9c-0.815-0.017-1.47-0.682-1.47-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5-0.011 0-0.021-0-0.032-0zM6 3.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c-0.011 0-0.021-0-0.032-0-0.814-0.017-1.468-0.682-1.468-1.5 0-0 0-0 0-0zM8.47 14c-0.815-0.017-1.47-0.682-1.47-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5-0.011 0-0.021-0-0.032-0zM12.47 11c-0.815-0.017-1.47-0.682-1.47-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5-0.011 0-0.021-0-0.032-0zM12.47 6c-0.815-0.017-1.47-0.682-1.47-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5-0.011 0-0.021-0-0.032-0z"></path></g>
<g id="vaadin:palette"><path d="M8.25 0c-6.38 0-9.11 7.38-8.010 9.92 0.82 1.89 2.62 0.080 3.34 1 1.88 2.46-2.11 3.81 0.090 4.68 2.59 1.060 12.33 0.4 12.33-8.53 0-2.69-1.34-7.070-7.75-7.070zM4.47 9c-0.815-0.017-1.47-0.682-1.47-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5-0.011 0-0.021-0-0.032-0zM6 3.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c-0.011 0-0.021-0-0.032-0-0.814-0.017-1.468-0.682-1.468-1.5 0-0 0-0 0-0zM8.47 14c-0.815-0.017-1.47-0.682-1.47-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5-0.011 0-0.021-0-0.032-0zM12.47 11c-0.815-0.017-1.47-0.682-1.47-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5-0.011 0-0.021-0-0.032-0zM12.47 6c-0.815-0.017-1.47-0.682-1.47-1.5 0-0.828 0.672-1.5 1.5-1.5s1.5 0.671 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5-0.011 0-0.021-0-0.032-0z"></path></g>
<g id="vaadin:panel"><path d="M0 0v16h16v-16h-16zM13 15h-12v-12h12v12zM15 15h-1v-1h1v1zM15 13h-1v-8h1v8zM15 4h-1v-1h1v1z"></path></g>
<g id="vaadin:paperclip"><path d="M2.7 15.3c-0.7 0-1.4-0.3-1.9-0.8-0.9-0.9-1.2-2.5 0-3.7l8.9-8.9c1.4-1.4 3.8-1.4 5.2 0s1.4 3.8 0 5.2l-7.4 7.4c-0.2 0.2-0.5 0.2-0.7 0s-0.2-0.5 0-0.7l7.4-7.4c1-1 1-2.7 0-3.7s-2.7-1-3.7 0l-8.9 8.9c-0.8 0.8-0.6 1.7 0 2.2 0.6 0.6 1.5 0.8 2.2 0l8.9-8.9c0.2-0.2 0.2-0.5 0-0.7s-0.5-0.2-0.7 0l-7.4 7.4c-0.2 0.2-0.5 0.2-0.7 0s-0.2-0.5 0-0.7l7.4-7.4c0.6-0.6 1.6-0.6 2.2 0s0.6 1.6 0 2.2l-8.9 8.9c-0.6 0.4-1.3 0.7-1.9 0.7z"></path></g>
<g id="vaadin:paperplane-o"><path d="M16 0l-16 8 4.7 1.6 0.3 5.4 2.5-2.8 2.5 3.8 6-16zM7.5 10.4l4.3-5.9-6.2 4.3-3-1 11.6-5.8-4.5 11.8-2.2-3.4z"></path></g>
<g id="vaadin:paperplane"><path d="M0 8l4.9 1.4h0.1v-0.1l7.1-5.3-1.1 1.2-6.2 6.6 0.2 3.2 2.9-3.2 2.1 4.2 6-16z"></path></g>
<g id="vaadin:paragraph"><path d="M5.5 0c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5h2.5v7h2v-14h1v14h2v-14h2v-2h-9.5z"></path></g>
<g id="vaadin:password"><path d="M16 5c0-0.6-0.4-1-1-1h-14c-0.6 0-1 0.4-1 1v6c0 0.6 0.4 1 1 1h14c0.6 0 1-0.4 1-1v-6zM15 11h-14v-6h14v6z"></path><path d="M6 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M9 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M12 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path></g>
<g id="vaadin:paste"><path d="M13 4h-3v-4h-10v14h6v2h10v-9l-3-3zM3 1h4v1h-4v-1zM15 15h-8v-10h5v3h3v7zM13 7v-2l2 2h-2z"></path></g>
<g id="vaadin:pause"><path d="M0 1h7v14h-7v-14z"></path><path d="M9 1h7v14h-7v-14z"></path></g>
<g id="vaadin:pencil"><path d="M1 11.9l-1 4.1 4.1-1 9.2-9.2-3.1-3.1-9.2 9.2zM1.5 15l-0.4-0.5 0.4-2 2 2-2 0.5zM10.9 4.4l-8.1 8-0.6-0.6 8.1-8 0.6 0.6z"></path><path d="M15.3 0.7c-1.1-1.1-2.6-0.5-2.6-0.5l-1.5 1.5 3.1 3.1 1.5-1.5c0-0.1 0.6-1.5-0.5-2.6zM13.4 1.6l-0.5-0.5c0.6-0.6 1.1-0.1 1.1-0.1l-0.6 0.6z"></path></g>
<g id="vaadin:phone-landline"><path d="M15.88 3.86l-0.61-1.31c-0.155-0.326-0.443-0.568-0.792-0.658-1.938-0.528-4.161-0.851-6.453-0.891-2.342 0.041-4.565 0.363-6.687 0.934-0.165 0.048-0.453 0.29-0.605 0.609l-0.613 1.317c-0.075 0.152-0.119 0.331-0.12 0.52v0.87c-0.001 0.012-0.001 0.026-0.001 0.041 0 0.392 0.318 0.71 0.71 0.71 0.011 0 0.022-0 0.033-0.001l2.518 0c0.412-0.010 0.742-0.346 0.742-0.76 0-0.018-0.001-0.035-0.002-0.053l0-0.838c-0-0.004-0-0.008-0-0.012 0-0.229 0.119-0.43 0.298-0.546 0.947-0.508 2.069-0.806 3.26-0.806 0.156 0 0.31 0.005 0.464 0.015 0.122-0.011 0.288-0.017 0.456-0.017 1.178 0 2.287 0.291 3.261 0.805 0.143 0.099 0.262 0.3 0.262 0.529 0 0.004-0 0.009-0 0.013l0 0.859c-0.001 0.015-0.002 0.033-0.002 0.050 0 0.413 0.33 0.75 0.741 0.76l2.521 0c0.009 0 0.020 0.001 0.031 0.001 0.392 0 0.71-0.318 0.71-0.71 0-0.014-0-0.029-0.001-0.043l0-0.868c-0.001-0.189-0.045-0.368-0.123-0.527z"></path><path d="M12 8.3c-0.624-0.797-1.001-1.815-1.001-2.92 0-0.028 0-0.056 0.001-0.084l-0-0.296h-1v1h-4v-1h-1v0.33c0 0.024 0.001 0.052 0.001 0.080 0 1.105-0.377 2.122-1.009 2.93l-2.992 3.66v3h14v-3zM8 13c-1.657 0-3-1.343-3-3s1.343-3 3-3c1.657 0 3 1.343 3 3s-1.343 3-3 3z"></path><path d="M10 10c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:phone"><path d="M12.2 10c-1.1-0.1-1.7 1.4-2.5 1.8-1.3 0.7-3.7-1.8-3.7-1.8s-2.5-2.4-1.9-3.7c0.5-0.8 2-1.4 1.9-2.5-0.1-1-2.3-4.6-3.4-3.6-2.4 2.2-2.6 3.1-2.6 4.9-0.1 3.1 3.9 7 3.9 7 0.4 0.4 3.9 4 7 3.9 1.8 0 2.7-0.2 4.9-2.6 1-1.1-2.5-3.3-3.6-3.4z"></path></g>
<g id="vaadin:picture"><path d="M16 14h-16v-12h16v12zM1 13h14v-10h-14v10z"></path><path d="M2 10v2h12v-1c0 0 0.2-1.7-2-2-1.9-0.3-2.2 0.6-3.8 0.6-1.1 0-0.9-1.6-3.2-1.6-1.7 0-3 2-3 2z"></path><path d="M13 6c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:pie-bar-chart"><path d="M5 11h3v5h-3v-5z"></path><path d="M1 14h3v2h-3v-2z"></path><path d="M13 12h3v4h-3v-4z"></path><path d="M9 9h3v7h-3v-7z"></path><path d="M5 0c-2.761 0-5 2.239-5 5s2.239 5 5 5c2.761 0 5-2.239 5-5s-2.239-5-5-5zM5 9c-2.209 0-4-1.791-4-4s1.791-4 4-4v4h4c0 2.209-1.791 4-4 4z"></path></g>
<g id="vaadin:pie-chart"><path d="M9 1c3.2 0.2 5.7 2.8 6 6h-6v-6zM8.5 0c-0.2 0-0.3 0-0.5 0v8h8c0-0.2 0-0.3 0-0.5 0-4.1-3.4-7.5-7.5-7.5v0z"></path><path d="M7 9v-8c-3.9 0.3-7 3.5-7 7.5 0 4.1 3.4 7.5 7.5 7.5 4 0 7.2-3.1 7.5-7h-8z"></path></g>
<g id="vaadin:piggy-bank-coin"><path d="M15.93 7.75c-0.061-0.2-0.165-0.371-0.3-0.51-0.105-0.113-0.241-0.197-0.394-0.238 0.074 0.117 0.141 0.252 0.191 0.396 0.056 0.147 0.092 0.304 0.103 0.467 0.008 0.067 0.012 0.138 0.012 0.21s-0.004 0.143-0.012 0.214c-0.035-0.115-0.083-0.208-0.142-0.292-0.123-0.166-0.288-0.299-0.48-0.383-0.119-0.053-0.248-0.082-0.384-0.082-0.346 0-0.648 0.186-0.811 0.464-0.050 0.082-0.090 0.171-0.12 0.266-1.182-1.968-3.309-3.271-5.741-3.271-0.124 0-0.247 0.003-0.369 0.010-0.763 0.001-1.517 0.11-2.231 0.313-0.062-0.434-0.632-1.314-3.252-1.314l0.8 2.51c-0.507 0.411-0.927 0.905-1.247 1.465l-1.553 0.025s-0.17 4 1 4h0.54c0.379 0.638 0.868 1.171 1.445 1.589l0.015 2.411h1.080c1.31 0 1.92 0 1.92-0.75v-0.39c0.451 0.088 0.97 0.139 1.5 0.139s1.049-0.051 1.551-0.147l-0.051 0.398c0 0.75 0.62 0.75 1.94 0.75h1.060v-2.39c0.932-0.651 1.613-1.605 1.903-2.717 0.057-0.027 0.114-0.024 0.172-0.024s0.115-0.003 0.172-0.010c0.251-0.046 0.48-0.144 0.679-0.283 0.266-0.188 0.474-0.454 0.591-0.765 0.028-0.093 0.049-0.191 0.063-0.292l0.001-0.010c0.221-0.262 0.372-0.59 0.419-0.951 0.012-0.084 0.019-0.171 0.019-0.259 0-0.197-0.032-0.386-0.091-0.563zM3.51 7.75c0.414 0 0.75 0.336 0.75 0.75s-0.336 0.75-0.75 0.75c-0.414 0-0.75-0.336-0.75-0.75s0.336-0.75 0.75-0.75zM5.88 7c-0.046 0.015-0.099 0.024-0.154 0.024-0.194 0-0.362-0.11-0.445-0.271-0.013-0.038-0.019-0.078-0.019-0.12 0-0.19 0.136-0.348 0.315-0.383 0.571-0.141 1.224-0.221 1.896-0.221 0.038 0 0.075 0 0.113 0.001 0.026-0 0.064-0.001 0.101-0.001 0.672 0 1.324 0.080 1.949 0.232 0.126 0.024 0.262 0.182 0.262 0.372 0 0.042-0.007 0.082-0.019 0.119-0.070 0.129-0.197 0.223-0.346 0.247l-0.153 0c-0.512-0.127-1.101-0.2-1.706-0.2-0.016 0-0.031 0-0.047 0-0.011-0-0.026-0-0.042-0-0.605 0-1.193 0.073-1.756 0.211zM14.58 9.93c-0.13 0.095-0.285 0.165-0.453 0.199l-0.127 0.001s0-0.13 0-0.13 0-0.21 0-0.31c0.165 0.125 0.374 0.2 0.6 0.2 0.007 0 0.014-0 0.021-0zM14.66 9.25c-0.018 0.003-0.040 0.004-0.061 0.004-0.176 0-0.327-0.103-0.398-0.252-0.044-0.084-0.069-0.18-0.069-0.283s0.025-0.199 0.070-0.283c0.059-0.082 0.157-0.138 0.269-0.138 0.059 0 0.113 0.015 0.161 0.042 0.181 0.070 0.308 0.244 0.308 0.448 0 0 0 0.001 0 0.001 0.009 0.062 0.014 0.133 0.014 0.205s-0.005 0.143-0.015 0.213c-0.066 0.012-0.144 0.024-0.224 0.024-0.019 0-0.039-0.001-0.058-0.002z"></path><path d="M8 3h-1v-0.17h0.25v-1.090h-0.25l0.55-0.55h0.2v1.64h0.25v0.17z"></path><path d="M7.5 0.75c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5zM7.5 0c-1.243 0-2.25 1.007-2.25 2.25s1.007 2.25 2.25 2.25c1.243 0 2.25-1.007 2.25-2.25s-1.007-2.25-2.25-2.25v0z"></path></g>
<g id="vaadin:piggy-bank"><path d="M15.93 5.75c-0.061-0.2-0.165-0.371-0.3-0.51-0.105-0.113-0.241-0.197-0.394-0.238 0.074 0.117 0.141 0.252 0.191 0.396 0.056 0.147 0.092 0.304 0.103 0.467 0.008 0.067 0.012 0.138 0.012 0.21s-0.004 0.143-0.012 0.214c-0.035-0.115-0.083-0.208-0.142-0.292-0.123-0.166-0.288-0.299-0.48-0.383-0.119-0.053-0.248-0.082-0.384-0.082-0.346 0-0.648 0.186-0.811 0.464-0.050 0.082-0.090 0.171-0.12 0.266-1.182-1.968-3.309-3.271-5.741-3.271-0.124 0-0.247 0.003-0.369 0.010-0.763 0.001-1.517 0.11-2.231 0.313-0.062-0.434-0.632-1.314-3.252-1.314l0.8 2.51c-0.507 0.411-0.927 0.905-1.247 1.465l-1.553 0.025s-0.17 4 1 4h0.54c0.379 0.638 0.868 1.171 1.445 1.589l0.015 2.41h1.080c1.31 0 1.92 0 1.92-0.75v-0.39c0.451 0.088 0.97 0.139 1.5 0.139s1.049-0.051 1.551-0.147l-0.051 0.398c0 0.75 0.62 0.75 1.94 0.75h1.060v-2.39c0.932-0.651 1.613-1.605 1.903-2.717 0.057-0.027 0.114-0.024 0.172-0.024s0.115-0.003 0.172-0.010c0.251-0.046 0.48-0.144 0.679-0.283 0.266-0.188 0.474-0.454 0.591-0.765 0.028-0.093 0.049-0.191 0.063-0.292l0.001-0.010c0.221-0.262 0.372-0.59 0.419-0.951 0.012-0.084 0.019-0.171 0.019-0.259 0-0.197-0.032-0.386-0.091-0.563zM3.51 5.75c0.414 0 0.75 0.336 0.75 0.75s-0.336 0.75-0.75 0.75c-0.414 0-0.75-0.336-0.75-0.75s0.336-0.75 0.75-0.75zM5.88 5c-0.046 0.015-0.099 0.024-0.154 0.024-0.194 0-0.362-0.11-0.445-0.271-0.013-0.038-0.019-0.078-0.019-0.12 0-0.19 0.136-0.348 0.315-0.383 0.571-0.141 1.224-0.221 1.896-0.221 0.038 0 0.075 0 0.113 0.001 0.026-0 0.064-0.001 0.101-0.001 0.672 0 1.324 0.080 1.949 0.232 0.126 0.024 0.262 0.182 0.262 0.372 0 0.042-0.007 0.082-0.019 0.119-0.070 0.129-0.197 0.223-0.346 0.247l-0.153 0c-0.512-0.127-1.101-0.2-1.706-0.2-0.016 0-0.031 0-0.047 0-0.011-0-0.026-0-0.042-0-0.605 0-1.193 0.073-1.756 0.211zM14.58 7.93c-0.13 0.095-0.285 0.165-0.453 0.199l-0.127 0.011s0-0.14 0-0.14 0-0.21 0-0.31c0.165 0.125 0.374 0.2 0.6 0.2 0.007 0 0.014-0 0.021-0zM14.66 7.25c-0.018 0.003-0.040 0.004-0.061 0.004-0.176 0-0.327-0.103-0.398-0.252-0.044-0.084-0.069-0.18-0.069-0.283s0.025-0.199 0.070-0.283c0.059-0.082 0.157-0.138 0.269-0.138 0.059 0 0.113 0.015 0.161 0.042 0.181 0.070 0.308 0.244 0.308 0.448 0 0 0 0.001 0 0.001 0.009 0.062 0.014 0.133 0.014 0.205s-0.005 0.143-0.015 0.213c-0.066 0.012-0.144 0.024-0.224 0.024-0.019 0-0.039-0.001-0.058-0.002z"></path></g>
<g id="vaadin:pill"><path d="M14.8 1.4l-0.2-0.2c-0.7-0.8-1.8-1.2-2.8-1.2s-2.1 0.4-2.9 1.2l-7.7 7.7c-1.6 1.6-1.6 4.1 0 5.7l0.2 0.2c0.7 0.8 1.8 1.2 2.8 1.2s2.1-0.4 2.9-1.2l7.8-7.8c1.5-1.5 1.5-4.1-0.1-5.6zM14.1 6.4l-3.9 3.9-3.5-3.6-3.8 3.8c-1.1 1.1-1.1 2.5-1 3.5v0c-1.2-1.2-1.2-3.1 0-4.3l7.8-7.8c0.5-0.6 1.3-0.9 2.1-0.9s1.6 0.3 2.2 0.9l0.2 0.2c0.5 0.5 0.8 1.3 0.8 2.1s-0.3 1.6-0.9 2.2z"></path></g>
<g id="vaadin:pills"><path d="M3.5 8l6.3-6.3c0.4-0.4 1-0.7 1.7-0.7s1.3 0.3 1.8 0.7c1 1 1 2.6 0 3.5l-2.8 2.8h1.4l2-2c1.4-1.4 1.4-3.6 0-4.9-0.7-0.7-1.6-1-2.5-1s-1.7 0.2-2.4 0.9l-6.3 6.4c-0.3 0.2-0.5 0.5-0.7 0.9 0.5-0.2 1-0.3 1.5-0.3z"></path><path d="M7.3 5.6l-2.4 2.4h4.7z"></path><path d="M12.5 9h-9c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h9c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5zM12.5 15h-4.5v-4h-4.5c-1.1 0-2 0.6-2.5 1.2 0.2-1.2 1.2-2.2 2.5-2.2h9c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5z"></path></g>
<g id="vaadin:pin-post"><path d="M15 4v-1h-6c0-1.69 1-2 1-2v-1h-5v1s1 0.31 1 2h-6v12h2v1h14v-12h-1zM14 14h-13v-10h4v1h2v2h1v-2h2v-1h4v10z"></path></g>
<g id="vaadin:pin"><path d="M11 6.5v-5.5h1v-1h-8v1h1v5.5c0 0-2 1.5-2 3.5 0 0.5 1.9 0.7 4 0.7v2.2c0 0.7 0.2 1.4 0.5 2.1l0.5 1 0.5-1c0.3-0.6 0.5-1.3 0.5-2.1v-2.2c2.1 0 4-0.3 4-0.7 0-2-2-3.5-2-3.5zM7 6.6c0 0-0.5 0.3-1.6 1.4-1 1-1.5 1.9-1.5 1.9s0.1-1 0.8-1.9c0.9-1.1 1.3-1.4 1.3-1.4v-5.6h1v5.6z"></path></g>
<g id="vaadin:play-circle-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M6 4v8l6-4z"></path></g>
<g id="vaadin:play-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM6 12v-8l6 4-6 4z"></path></g>
<g id="vaadin:play"><path d="M2 1v14l12-7z"></path></g>
<g id="vaadin:plug"><path d="M14.7 3.1c-0.4-0.4-1-0.4-1.4 0l-2.8 2.8-1.5-1.4 2.8-2.8c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0l-2.8 2.8-1.4-1.4-1.4 1.4 0.7 0.7-1.4 1.4c-1.4 1.4-1.5 3.5-0.5 5.1-1.7 1.5-2.6 3.8-2.6 5.7h2c0-1.3 0.4-3.2 2.1-4.4 1.5 0.8 3.4 0.5 4.6-0.7l1.4-1.4 0.7 0.7 1.4-1.4-1.4-1.4 2.8-2.8c0.5-0.5 0.5-1.1 0.1-1.5z"></path></g>
<g id="vaadin:plus-circle-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M13 7h-4v-4h-2v4h-4v2h4v4h2v-4h4z"></path></g>
<g id="vaadin:plus-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM13 9h-4v4h-2v-4h-4v-2h4v-4h2v4h4v2z"></path></g>
<g id="vaadin:plus-minus"><path d="M10 7h6v2h-6v-2z"></path><path d="M4 5h-2v2h-2v2h2v2h2v-2h2v-2h-2z"></path><path d="M6 2l3 12h1l-3-12z"></path></g>
<g id="vaadin:plus-square-o"><path d="M12 7h-3v-3h-2v3h-3v2h3v3h2v-3h3z"></path><path d="M15 1h-14v14h14v-14zM14 14h-12v-12h12v12z"></path></g>
<g id="vaadin:plus"><path d="M14 7h-5v-5h-2v5h-5v2h5v5h2v-5h5v-2z"></path></g>
<g id="vaadin:pointer"><path d="M12.6 5c-0.2 0-0.5 0-0.6 0 0-0.2-0.2-0.6-0.4-0.8s-0.6-0.4-1.1-0.4c-0.2 0-0.4 0-0.6 0.1-0.1-0.2-0.2-0.3-0.3-0.5-0.2-0.2-0.5-0.4-1.1-0.4-0.2 0-0.4 0-0.5 0.1v-1.7c0-0.6-0.4-1.4-1.4-1.4-0.4 0-0.8 0.2-1.1 0.4-0.5 0.6-0.5 1.4-0.5 1.4v4.3c-0.6 0.1-1.1 0.3-1.4 0.6-0.6 0.7-0.6 1.6-0.6 2.8 0 0.2 0 0.5 0 0.7 0 1.4 0.7 2.1 1.4 2.8l0.3 0.4c1.3 1.2 2.4 1.6 5.1 1.6 2.9 0 4.2-1.6 4.2-5.1v-2.5c0-0.7-0.2-2.1-1.4-2.4zM13 7.4v2.6c0 3.4-1.3 4.1-3.2 4.1-2.4 0-3.3-0.3-4.3-1.3-0.1-0.1-0.2-0.2-0.4-0.4-0.7-0.8-1.1-1.2-1.1-2.2 0-0.2 0-0.5 0-0.7 0-1 0-1.7 0.3-2.1 0.1-0.1 0.4-0.2 0.7-0.2v0.5l-0.3 1.5c0 0.1 0 0.1 0.1 0.2s0.2 0 0.2 0l1-1.2c0-0.1 0-0.2 0-0.2v-6.2c0-0.1 0-0.5 0.2-0.7 0.1 0 0.2-0.1 0.4-0.1 0.3 0 0.4 0.3 0.4 0.4v3.1c0 0 0 0 0 0v1.2c0 0.3 0.2 0.6 0.5 0.6s0.5-0.3 0.5-0.5v-1.3c0 0 0 0 0 0 0-0.1 0.1-0.5 0.5-0.5 0.3 0 0.5 0.1 0.5 0.4v1.3c0 0.3 0.2 0.6 0.5 0.6s0.5-0.3 0.5-0.5v-0.7c0-0.1 0.1-0.3 0.5-0.3 0.2 0 0.3 0.1 0.3 0.1 0.2 0.1 0.2 0.4 0.2 0.4v0.8c0 0.3 0.2 0.5 0.4 0.5 0.3 0 0.5-0.1 0.5-0.4 0-0.1 0.1-0.2 0.2-0.3 0 0 0.1 0 0.2 0 0.6 0.2 0.7 1.2 0.7 1.5 0-0.1 0-0.1 0 0z"></path></g>
<g id="vaadin:power-off"><path d="M10 2.3v3.3c1.2 0.7 2 2 2 3.4 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-1.5 0.8-2.8 2-3.4v-3.3c-2.9 0.9-5 3.5-5 6.7 0 3.9 3.1 7 7 7s7-3.1 7-7c0-3.2-2.1-5.8-5-6.7z"></path><path d="M7 1h2v7h-2v-7z"></path></g>
<g id="vaadin:presentation"><path d="M16 1h-7v-1h-2v1h-7v11h5l-2 4h2.2l2-4h1.5l2 4h2.3l-2-4h5v-11zM15 11h-14v-9h14v9z"></path><path d="M6 4v5l4-2.5z"></path></g>
<g id="vaadin:print"><path d="M0 10v4h2v2h12v-2h2v-4h-16zM13 15h-10v-3h10v3z"></path><path d="M12 6v-4l-2.7-2h-5.3v6h-4v3h16v-3h-4zM9 1l1.3 1h-1.3v-1zM11 7h-6v-6h3v2h3v4zM15 8h-1v-1h1v1z"></path></g>
<g id="vaadin:progressbar"><path d="M0 5v6h16v-6h-16zM15 10h-14v-4h14v4z"></path><path d="M2 7h7v2h-7v-2z"></path></g>
<g id="vaadin:puzzle-piece"><path d="M14.9 0.9c-1.1-1-2.5-1.3-3.1-0.4-0.7 1.1 0.5 1.7-0.3 2.5-0.5 0.6-2-0.8-2-0.8l-0.8-0.8-1.4 1.4c-0.6 0.7-2.1 1.5-2.6 1.1-0.7-0.6 0.1-1.8-0.5-2.6-0.7-1-2.1-0.8-3 0.3-1 1.1-1.4 2.4-0.5 3 1.1 0.7 1.9-0.3 2.7 0.5 0.4 0.4-0.2 1.7-0.5 2.1l-2.3 2.3 6.5 6.5 1.7-1.7c0.7-0.7 1.5-2 1.1-2.4-0.6-0.7-1.7 0.1-2.5-0.4-1-0.7-0.8-2 0.3-3s2.5-1.3 3.1-0.4c0.7 1.1-0.4 1.8 0.4 2.6 0.4 0.4 1.6-0.2 2-0.6l2.1-2.1-1.1-1.1c-0.6-0.6-1.9-2-1.4-2.5 0.6-0.7 1.7 0.2 2.5-0.4 0.9-0.8 0.6-2.1-0.4-3.1z"></path></g>
<g id="vaadin:pyramid-chart"><path d="M10.29 5l-2.29-4-2.29 4h4.58z"></path><path d="M2.29 11l-2.29 4h16l-2.29-4h-11.42z"></path><path d="M13.14 10l-2.28-4h-5.72l-2.28 4h10.28z"></path></g>
<g id="vaadin:qrcode"><path d="M6 0h-6v6h6v-6zM5 5h-4v-4h4v4z"></path><path d="M2 2h2v2h-2v-2z"></path><path d="M0 16h6v-6h-6v6zM1 11h4v4h-4v-4z"></path><path d="M2 12h2v2h-2v-2z"></path><path d="M10 0v6h6v-6h-6zM15 5h-4v-4h4v4z"></path><path d="M12 2h2v2h-2v-2z"></path><path d="M2 7h-2v2h3v-1h-1z"></path><path d="M7 9h2v2h-2v-2z"></path><path d="M3 7h2v1h-2v-1z"></path><path d="M9 12h-2v1h1v1h1v-1z"></path><path d="M6 7v1h-1v1h2v-2z"></path><path d="M8 4h1v2h-1v-2z"></path><path d="M9 8v1h2v-2h-3v1z"></path><path d="M7 6h1v1h-1v-1z"></path><path d="M9 14h2v2h-2v-2z"></path><path d="M7 14h1v2h-1v-2z"></path><path d="M9 11h1v1h-1v-1z"></path><path d="M9 3v-2h-1v-1h-1v4h1v-1z"></path><path d="M12 14h1v2h-1v-2z"></path><path d="M12 12h2v1h-2v-1z"></path><path d="M11 13h1v1h-1v-1z"></path><path d="M10 12h1v1h-1v-1z"></path><path d="M14 10v1h1v1h1v-2h-1z"></path><path d="M15 13h-1v3h2v-2h-1z"></path><path d="M10 10v1h3v-2h-2v1z"></path><path d="M12 7v1h2v1h2v-2h-2z"></path></g>
<g id="vaadin:question-circle-o"><path d="M9 10h-2c0-2 1.2-2.6 2-3 0.3-0.1 0.5-0.2 0.7-0.4 0.1-0.1 0.3-0.3 0.1-0.7-0.2-0.5-0.8-1-1.7-1-1.4 0-1.6 1.2-1.7 1.5l-2-0.3c0.1-1.1 1-3.2 3.6-3.2 1.6 0 3 0.9 3.6 2.2 0.4 1.1 0.2 2.2-0.6 3-0.4 0.4-0.8 0.6-1.2 0.7-0.6 0.4-0.8 0.2-0.8 1.2z"></path><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M6.9 11h2v2h-2v-2z"></path></g>
<g id="vaadin:question-circle"><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM8.9 13h-2v-2h2v2zM11 8.1c-0.4 0.4-0.8 0.6-1.2 0.7-0.6 0.4-0.8 0.2-0.8 1.2h-2c0-2 1.2-2.6 2-3 0.3-0.1 0.5-0.2 0.7-0.4 0.1-0.1 0.3-0.3 0.1-0.7-0.2-0.5-0.8-1-1.7-1-1.4 0-1.6 1.2-1.7 1.5l-2-0.3c0.1-1.1 1-3.2 3.6-3.2 1.6 0 3 0.9 3.6 2.2 0.4 1.1 0.2 2.2-0.6 3z"></path></g>
<g id="vaadin:question"><path d="M9 11h-3c0-3 1.6-4 2.7-4.6 0.4-0.2 0.7-0.4 0.9-0.6 0.5-0.5 0.3-1.2 0.2-1.4-0.3-0.7-1-1.4-2.3-1.4-2.1 0-2.5 1.9-2.5 2.3l-3-0.4c0.2-1.7 1.7-4.9 5.5-4.9 2.3 0 4.3 1.3 5.1 3.2 0.7 1.7 0.4 3.5-0.8 4.7-0.5 0.5-1.1 0.8-1.6 1.1-0.9 0.5-1.2 1-1.2 2z"></path><path d="M9.5 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:quote-left"><path d="M7 7v7h-7v-7.1c0-4.8 4.5-5.4 4.5-5.4l0.6 1.4c0 0-2 0.3-2.4 1.9-0.4 1.2 0.4 2.2 0.4 2.2h3.9z"></path><path d="M16 7v7h-7v-7.1c0-4.8 4.5-5.4 4.5-5.4l0.6 1.4c0 0-2 0.3-2.4 1.9-0.4 1.2 0.4 2.2 0.4 2.2h3.9z"></path></g>
<g id="vaadin:quote-right"><path d="M9 9v-7h7v7.1c0 4.8-4.5 5.4-4.5 5.4l-0.6-1.4c0 0 2-0.3 2.4-1.9 0.4-1.2-0.4-2.2-0.4-2.2h-3.9z"></path><path d="M0 9v-7h7v7.1c0 4.8-4.5 5.4-4.5 5.4l-0.6-1.4c0 0 2-0.3 2.4-1.9 0.4-1.2-0.4-2.2-0.4-2.2h-3.9z"></path></g>
<g id="vaadin:random"><path d="M13 12h-2c-1 0-1.7-1.2-2.4-2.7-0.3 0.7-0.6 1.5-1 2.3 0.8 1.4 1.8 2.4 3.4 2.4h2v2l3-3-3-3v2z"></path><path d="M5.4 6.6c0.3-0.7 0.6-1.5 1-2.2-0.8-1.4-1.9-2.4-3.4-2.4h-3v2h3c1 0 1.7 1.2 2.4 2.6z"></path><path d="M16 3l-3-3v2h-2c-2.7 0-3.9 3-5 5.7-0.8 2.1-1.7 4.3-3 4.3h-3v2h3c2.6 0 3.8-2.8 4.9-5.6 0.9-2.2 1.8-4.4 3.1-4.4h2v2l3-3z"></path></g>
<g id="vaadin:raster-lower-left"><path d="M15 7h1v1h-1v-1z"></path><path d="M13 7h1v1h-1v-1z"></path><path d="M11 7h1v1h-1v-1z"></path><path d="M9 7h1v1h-1v-1z"></path><path d="M14 6h1v1h-1v-1z"></path><path d="M12 6h1v1h-1v-1z"></path><path d="M10 6h1v1h-1v-1z"></path><path d="M15 5h1v1h-1v-1z"></path><path d="M13 5h1v1h-1v-1z"></path><path d="M11 5h1v1h-1v-1z"></path><path d="M14 4h1v1h-1v-1z"></path><path d="M12 4h1v1h-1v-1z"></path><path d="M15 3h1v1h-1v-1z"></path><path d="M13 3h1v1h-1v-1z"></path><path d="M14 2h1v1h-1v-1z"></path><path d="M15 1h1v1h-1v-1z"></path><path d="M7 15h1v1h-1v-1z"></path><path d="M5 15h1v1h-1v-1z"></path><path d="M3 15h1v1h-1v-1z"></path><path d="M1 15h1v1h-1v-1z"></path><path d="M6 14h1v1h-1v-1z"></path><path d="M4 14h1v1h-1v-1z"></path><path d="M2 14h1v1h-1v-1z"></path><path d="M7 13h1v1h-1v-1z"></path><path d="M5 13h1v1h-1v-1z"></path><path d="M3 13h1v1h-1v-1z"></path><path d="M6 12h1v1h-1v-1z"></path><path d="M4 12h1v1h-1v-1z"></path><path d="M7 11h1v1h-1v-1z"></path><path d="M5 11h1v1h-1v-1z"></path><path d="M6 10h1v1h-1v-1z"></path><path d="M7 9h1v1h-1v-1z"></path><path d="M15 15h1v1h-1v-1z"></path><path d="M13 15h1v1h-1v-1z"></path><path d="M11 15h1v1h-1v-1z"></path><path d="M9 15h1v1h-1v-1z"></path><path d="M14 14h1v1h-1v-1z"></path><path d="M12 14h1v1h-1v-1z"></path><path d="M10 14h1v1h-1v-1z"></path><path d="M8 14h1v1h-1v-1z"></path><path d="M15 13h1v1h-1v-1z"></path><path d="M13 13h1v1h-1v-1z"></path><path d="M11 13h1v1h-1v-1z"></path><path d="M9 13h1v1h-1v-1z"></path><path d="M14 12h1v1h-1v-1z"></path><path d="M12 12h1v1h-1v-1z"></path><path d="M10 12h1v1h-1v-1z"></path><path d="M8 12h1v1h-1v-1z"></path><path d="M15 11h1v1h-1v-1z"></path><path d="M13 11h1v1h-1v-1z"></path><path d="M11 11h1v1h-1v-1z"></path><path d="M9 11h1v1h-1v-1z"></path><path d="M14 10h1v1h-1v-1z"></path><path d="M12 10h1v1h-1v-1z"></path><path d="M10 10h1v1h-1v-1z"></path><path d="M8 10h1v1h-1v-1z"></path><path d="M15 9h1v1h-1v-1z"></path><path d="M13 9h1v1h-1v-1z"></path><path d="M11 9h1v1h-1v-1z"></path><path d="M9 9h1v1h-1v-1z"></path><path d="M14 8h1v1h-1v-1z"></path><path d="M12 8h1v1h-1v-1z"></path><path d="M10 8h1v1h-1v-1z"></path><path d="M8 8h1v1h-1v-1z"></path></g>
<g id="vaadin:raster"><path d="M7 7h1v1h-1v-1z"></path><path d="M5 7h1v1h-1v-1z"></path><path d="M3 7h1v1h-1v-1z"></path><path d="M1 7h1v1h-1v-1z"></path><path d="M6 6h1v1h-1v-1z"></path><path d="M4 6h1v1h-1v-1z"></path><path d="M2 6h1v1h-1v-1z"></path><path d="M0 6h1v1h-1v-1z"></path><path d="M7 5h1v1h-1v-1z"></path><path d="M5 5h1v1h-1v-1z"></path><path d="M3 5h1v1h-1v-1z"></path><path d="M1 5h1v1h-1v-1z"></path><path d="M6 4h1v1h-1v-1z"></path><path d="M4 4h1v1h-1v-1z"></path><path d="M2 4h1v1h-1v-1z"></path><path d="M0 4h1v1h-1v-1z"></path><path d="M7 3h1v1h-1v-1z"></path><path d="M5 3h1v1h-1v-1z"></path><path d="M3 3h1v1h-1v-1z"></path><path d="M1 3h1v1h-1v-1z"></path><path d="M6 2h1v1h-1v-1z"></path><path d="M4 2h1v1h-1v-1z"></path><path d="M2 2h1v1h-1v-1z"></path><path d="M0 2h1v1h-1v-1z"></path><path d="M7 1h1v1h-1v-1z"></path><path d="M5 1h1v1h-1v-1z"></path><path d="M3 1h1v1h-1v-1z"></path><path d="M1 1h1v1h-1v-1z"></path><path d="M6 0h1v1h-1v-1z"></path><path d="M4 0h1v1h-1v-1z"></path><path d="M2 0h1v1h-1v-1z"></path><path d="M0 0h1v1h-1v-1z"></path><path d="M15 7h1v1h-1v-1z"></path><path d="M13 7h1v1h-1v-1z"></path><path d="M11 7h1v1h-1v-1z"></path><path d="M9 7h1v1h-1v-1z"></path><path d="M14 6h1v1h-1v-1z"></path><path d="M12 6h1v1h-1v-1z"></path><path d="M10 6h1v1h-1v-1z"></path><path d="M8 6h1v1h-1v-1z"></path><path d="M15 5h1v1h-1v-1z"></path><path d="M13 5h1v1h-1v-1z"></path><path d="M11 5h1v1h-1v-1z"></path><path d="M9 5h1v1h-1v-1z"></path><path d="M14 4h1v1h-1v-1z"></path><path d="M12 4h1v1h-1v-1z"></path><path d="M10 4h1v1h-1v-1z"></path><path d="M8 4h1v1h-1v-1z"></path><path d="M15 3h1v1h-1v-1z"></path><path d="M13 3h1v1h-1v-1z"></path><path d="M11 3h1v1h-1v-1z"></path><path d="M9 3h1v1h-1v-1z"></path><path d="M14 2h1v1h-1v-1z"></path><path d="M12 2h1v1h-1v-1z"></path><path d="M10 2h1v1h-1v-1z"></path><path d="M8 2h1v1h-1v-1z"></path><path d="M15 1h1v1h-1v-1z"></path><path d="M13 1h1v1h-1v-1z"></path><path d="M11 1h1v1h-1v-1z"></path><path d="M9 1h1v1h-1v-1z"></path><path d="M14 0h1v1h-1v-1z"></path><path d="M12 0h1v1h-1v-1z"></path><path d="M10 0h1v1h-1v-1z"></path><path d="M8 0h1v1h-1v-1z"></path><path d="M7 15h1v1h-1v-1z"></path><path d="M5 15h1v1h-1v-1z"></path><path d="M3 15h1v1h-1v-1z"></path><path d="M1 15h1v1h-1v-1z"></path><path d="M6 14h1v1h-1v-1z"></path><path d="M4 14h1v1h-1v-1z"></path><path d="M2 14h1v1h-1v-1z"></path><path d="M0 14h1v1h-1v-1z"></path><path d="M7 13h1v1h-1v-1z"></path><path d="M5 13h1v1h-1v-1z"></path><path d="M3 13h1v1h-1v-1z"></path><path d="M1 13h1v1h-1v-1z"></path><path d="M6 12h1v1h-1v-1z"></path><path d="M4 12h1v1h-1v-1z"></path><path d="M2 12h1v1h-1v-1z"></path><path d="M0 12h1v1h-1v-1z"></path><path d="M7 11h1v1h-1v-1z"></path><path d="M5 11h1v1h-1v-1z"></path><path d="M3 11h1v1h-1v-1z"></path><path d="M1 11h1v1h-1v-1z"></path><path d="M6 10h1v1h-1v-1z"></path><path d="M4 10h1v1h-1v-1z"></path><path d="M2 10h1v1h-1v-1z"></path><path d="M0 10h1v1h-1v-1z"></path><path d="M7 9h1v1h-1v-1z"></path><path d="M5 9h1v1h-1v-1z"></path><path d="M3 9h1v1h-1v-1z"></path><path d="M1 9h1v1h-1v-1z"></path><path d="M6 8h1v1h-1v-1z"></path><path d="M4 8h1v1h-1v-1z"></path><path d="M2 8h1v1h-1v-1z"></path><path d="M0 8h1v1h-1v-1z"></path><path d="M15 15h1v1h-1v-1z"></path><path d="M13 15h1v1h-1v-1z"></path><path d="M11 15h1v1h-1v-1z"></path><path d="M9 15h1v1h-1v-1z"></path><path d="M14 14h1v1h-1v-1z"></path><path d="M12 14h1v1h-1v-1z"></path><path d="M10 14h1v1h-1v-1z"></path><path d="M8 14h1v1h-1v-1z"></path><path d="M15 13h1v1h-1v-1z"></path><path d="M13 13h1v1h-1v-1z"></path><path d="M11 13h1v1h-1v-1z"></path><path d="M9 13h1v1h-1v-1z"></path><path d="M14 12h1v1h-1v-1z"></path><path d="M12 12h1v1h-1v-1z"></path><path d="M10 12h1v1h-1v-1z"></path><path d="M8 12h1v1h-1v-1z"></path><path d="M15 11h1v1h-1v-1z"></path><path d="M13 11h1v1h-1v-1z"></path><path d="M11 11h1v1h-1v-1z"></path><path d="M9 11h1v1h-1v-1z"></path><path d="M14 10h1v1h-1v-1z"></path><path d="M12 10h1v1h-1v-1z"></path><path d="M10 10h1v1h-1v-1z"></path><path d="M8 10h1v1h-1v-1z"></path><path d="M15 9h1v1h-1v-1z"></path><path d="M13 9h1v1h-1v-1z"></path><path d="M11 9h1v1h-1v-1z"></path><path d="M9 9h1v1h-1v-1z"></path><path d="M14 8h1v1h-1v-1z"></path><path d="M12 8h1v1h-1v-1z"></path><path d="M10 8h1v1h-1v-1z"></path><path d="M8 8h1v1h-1v-1z"></path></g>
<g id="vaadin:records"><path d="M4 9h4v2h-4v-2z"></path><path d="M16 2h-1v-2h-10v2h-2v1.25l-0.6 0.75h-1.4v1.75l-1 1.25v9h12l4-5v-9zM2 5h8v2h-8v-2zM11 15h-10v-7h10v7zM12 7h-1v-3h-7v-1h8v4zM14 4.5l-1 1.25v-3.75h-7v-1h8v3.5z"></path></g>
<g id="vaadin:recycle"><path d="M8 3.1l1.4 2.2-1.6 1.1 1.3 0.3 2.8 0.6 0.6-2.7 0.4-1.4-1.8 1.1-2-3.3h-2.2l-2.6 4.3 1.7 1z"></path><path d="M16 12l-2.7-4.3-1.7 1 2 3.3h-2.6v-2l-3 3 3 3v-2h3.7z"></path><path d="M2.4 12v0l1.4-2.3 1.7 1.1-0.9-4.2-2.8 0.7-1.3 0.3 1.6 1-2.1 3.4 1.3 2h5.7v-2z"></path></g>
<g id="vaadin:refresh"><path d="M2.6 5.6c0.9-2.1 3-3.6 5.4-3.6 3 0 5.4 2.2 5.9 5h2c-0.5-3.9-3.8-7-7.9-7-3 0-5.6 1.6-6.9 4.1l-1.1-1.1v4h4l-1.4-1.4z"></path><path d="M16 9h-4.1l1.5 1.4c-0.9 2.1-3 3.6-5.5 3.6-2.9 0-5.4-2.2-5.9-5h-2c0.5 3.9 3.9 7 7.9 7 3 0 5.6-1.7 7-4.1l1.1 1.1v-4z"></path></g>
<g id="vaadin:reply-all"><path d="M16 8c0-5-4.9-5-4.9-5h-2.1v-3l-6 6 6 6v-3h2.2c3.5 0 1.8 7 1.8 7s3-4.1 3-8z"></path><path d="M0 6l6 6v-1.5l-4.5-4.5 4.5-4.5v-1.5z"></path></g>
<g id="vaadin:reply"><path d="M16 8c0-5-4.9-5-4.9-5h-5.1v-3l-6 6 6 6v-3h5.2c3.5 0 1.8 7 1.8 7s3-4.1 3-8z"></path></g>
<g id="vaadin:resize-h"><path d="M0 7h16v2h-16v-2z"></path><path d="M7 6h2v-3h2l-3-3-3 3h2z"></path><path d="M9 10h-2v3h-2l3 3 3-3h-2z"></path></g>
<g id="vaadin:resize-v"><path d="M7 0h2v16h-2v-16z"></path><path d="M3 5l-3 3 3 3v-2h3v-2h-3z"></path><path d="M16 8l-3-3v2h-3v2h3v2z"></path></g>
<g id="vaadin:retweet"><path d="M2 1h12v5h2l-3 3-3-3h2v-3h-8v2h-2z"></path><path d="M14 14h-12v-5h-2l3-3 3 3h-2v3h8v-2h2z"></path></g>
<g id="vaadin:rhombus"><path d="M8 0l-8 8 8 8 8-8-8-8zM2 8l6-6 6 6-6 6-6-6z"></path></g>
<g id="vaadin:road-branch"><path d="M16 4h-16v3h3.2l3.8 3.6c1.6 1.5 3.6 2.4 5.8 2.4h3.2v-3h-3.2c-1.4 0-2.7-0.5-3.7-1.5l-1.6-1.5h8.5v-3z"></path></g>
<g id="vaadin:road-branches"><path d="M16 4v-3h-16v3h1.7l7.7 9.5c1.3 1.6 3.1 2.5 5 2.5h1.6v-3h-1.5c-1 0-1.9-0.5-2.7-1.4l-1.3-1.6h5.5v-3h-8l-2.4-3h10.4z"></path></g>
<g id="vaadin:road-split"><path d="M14 13v-1c0-0.2 0-4.1-2.8-5.4-2.2-1-2.2-3.5-2.2-3.6v-3h-2v3c0 0.1 0 2.6-2.2 3.6-2.8 1.3-2.8 5.2-2.8 5.4v1h-2l3 3 3-3h-2v-1c0 0 0-2.8 1.7-3.6 1.1-0.5 1.8-1.3 2.3-2 0.5 0.8 1.2 1.5 2.3 2 1.7 0.8 1.7 3.6 1.7 3.6v1h-2l3 3 3-3h-2z"></path></g>
<g id="vaadin:road"><path d="M9 11v4h7l-4-14h-3v3h-2v-3h-3l-4 14h7v-4h2zM7 6h2v3h-2v-3z"></path></g>
<g id="vaadin:rocket"><path d="M16 0c0 0-3.5-0.4-6.7 2.8-1.6 1.5-2.9 3.5-3.9 5.3l-2.5-0.6-1.6 1.6 2.8 1.4c-0.3 0.6-0.4 1-0.4 1l0.8 0.8c0 0 0.4-0.2 1-0.4l1.4 2.8 1.6-1.6-0.5-2.5c1.7-1 3.8-2.3 5.3-3.8 3.1-3.2 2.7-6.8 2.7-6.8zM12.8 4.8c-0.4 0.4-1.1 0.4-1.6 0-0.4-0.4-0.4-1.1 0-1.6 0.4-0.4 1.1-0.4 1.6 0 0.4 0.4 0.4 1.1 0 1.6z"></path><path d="M4 14.2c-0.8 0.8-2.6 0.4-2.6 0.4s-0.4-1.8 0.4-2.6c0.8-0.8 1.5-0.9 1.5-0.9s-1.3-0.3-2.1 0.6c-1.6 1.6-1 4.2-1 4.2s2.6 0.6 4.2-1c0.9-0.9 0.6-2.2 0.6-2.2s-0.2 0.7-1 1.5z"></path></g>
<g id="vaadin:rotate-left"><path d="M8 0c-3 0-5.6 1.6-6.9 4.1l-1.1-1.1v4h4l-1.5-1.5c1-2 3.1-3.5 5.5-3.5 3.3 0 6 2.7 6 6s-2.7 6-6 6c-1.8 0-3.4-0.8-4.5-2.1l-1.5 1.3c1.4 1.7 3.6 2.8 6 2.8 4.4 0 8-3.6 8-8s-3.6-8-8-8z"></path></g>
<g id="vaadin:rotate-right"><path d="M16 7v-4l-1.1 1.1c-1.3-2.5-3.9-4.1-6.9-4.1-4.4 0-8 3.6-8 8s3.6 8 8 8c2.4 0 4.6-1.1 6-2.8l-1.5-1.3c-1.1 1.3-2.7 2.1-4.5 2.1-3.3 0-6-2.7-6-6s2.7-6 6-6c2.4 0 4.5 1.5 5.5 3.5l-1.5 1.5h4z"></path></g>
<g id="vaadin:rss-square"><path d="M0 0v16h16v-16h-16zM3.6 14c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.6 1.6-1.6 1.6 0.7 1.6 1.6-0.6 1.6-1.6 1.6zM7.6 14c0-3.1-2.5-5.6-5.6-5.6v-2.4c4.4 0 8 3.6 8 8h-2.4zM11.6 14c0-5.3-4.3-9.6-9.6-9.6v-2.4c6.6 0 12 5.4 12 12h-2.4z"></path></g>
<g id="vaadin:rss"><path d="M4.4 13.8c0 1.215-0.985 2.2-2.2 2.2s-2.2-0.985-2.2-2.2c0-1.215 0.985-2.2 2.2-2.2s2.2 0.985 2.2 2.2z"></path><path d="M10.6 16h-3.1c0-4.1-3.4-7.5-7.5-7.5v0-3.1c5.9 0 10.6 4.7 10.6 10.6z"></path><path d="M12.8 16c0-7.1-5.7-12.8-12.8-12.8v-3.2c8.8 0 16 7.2 16 16h-3.2z"></path></g>
<g id="vaadin:safe-lock"><path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11.13 14.25l-0.37-0.9-0.92 0.38 0.37 0.9c-0.659 0.23-1.419 0.363-2.21 0.363s-1.551-0.133-2.259-0.378l0.419-0.885-0.92-0.38-0.37 0.9c-1.355-0.69-2.43-1.765-3.102-3.080l0.882-0.41-0.38-0.93-0.9 0.37c-0.23-0.659-0.363-1.419-0.363-2.21s0.133-1.551 0.378-2.259l0.885 0.419 0.38-0.92-0.9-0.37c0.691-1.351 1.766-2.423 3.080-3.092l0.41 0.882 0.92-0.38-0.37-0.9c0.659-0.23 1.419-0.363 2.21-0.363s1.551 0.133 2.259 0.378l-0.419 0.885 0.92 0.38 0.37-0.9c1.355 0.69 2.43 1.765 3.102 3.080l-0.882 0.41 0.38 0.92 0.9-0.37c0.23 0.659 0.363 1.419 0.363 2.21s-0.133 1.551-0.378 2.259l-0.885-0.419-0.38 0.92 0.9 0.37c-0.69 1.355-1.765 2.43-3.080 3.102z"></path><path d="M10.36 3.62l-1.16 2.79c-0.329-0.253-0.746-0.407-1.199-0.41h0.279l1.15-2.77c-0.426-0.14-0.917-0.223-1.427-0.23-0.023-0-0.047-0-0.071-0-2.795 0-5.060 2.265-5.060 5.060s2.265 5.060 5.060 5.060c2.795 0 5.060-2.265 5.060-5.060 0-1.904-1.052-3.563-2.606-4.426z"></path></g>
<g id="vaadin:safe"><path d="M1 0v16h3v-1h8v1h3v-16h-14zM14 10h-1v-5h1v5zM14 3h-1v-1h-10v11h10v-1h1v2h-12v-13h12v2zM8.5 7.5c0 1.1-0.9 2-2 2s-2-0.9-2-2 0.9-2 2-2 2 0.9 2 2z"></path><path d="M7.5 7.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path></g>
<g id="vaadin:scale-unbalance"><path d="M15.81 9l-2.47-4.93 0.83-0.15c0.239-0.044 0.418-0.251 0.418-0.5 0-0.281-0.227-0.508-0.508-0.508-0.032 0-0.063 0.003-0.093 0.009l-0.777 0.14c-0.993-0.755-2.25-1.21-3.613-1.21-0.21 0-0.418 0.011-0.623 0.032-0.036-0.5-0.457-0.882-0.967-0.882-0.003 0-0.005 0-0.008 0-0.552 0-1 0.448-1 1v0.2c-1.714 0.336-3.151 1.327-4.066 2.697l-0.754 0.153c-0.257 0.024-0.457 0.239-0.457 0.5 0 0.277 0.225 0.502 0.502 0.502 0.016 0 0.032-0.001 0.047-0.002l0.088 0 0.35-0.050-2.52 5h-0.19c0 1.1 1.34 2 3 2s3-0.9 3-2h-0.19l-2.56-5.12h0.1c0.172-0.031 0.311-0.144 0.379-0.297 0.021-0.093 0.701-1.583 3.271-2.363v10.78h-1v1h-2v1h8v-1h-2v-1h-1v-11.12c0.201-0.031 0.434-0.049 0.67-0.049 1.152 0 2.205 0.419 3.016 1.114l-0.006-0.005-2.49 5.060h-0.19c0 1.1 1.34 2 3 2s3-0.9 3-2h-0.19zM5 11h-4l2-3.94zM11 9l2-3.94 2 3.94h-4z"></path></g>
<g id="vaadin:scale"><path d="M15.81 10l-2.5-5h0.69c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.79c-1.056-1.145-2.541-1.881-4.198-1.95l-0.012-0.050c0-0.552-0.448-1-1-1s-1 0.448-1 1v0.050c-1.681 0.073-3.178 0.807-4.247 1.947l-0.753 0.003c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.69l-2.5 5h-0.19c0 1.1 1.34 2 3 2s3-0.9 3-2h-0.19l-2.55-5.090c0.064-0.039 0.118-0.089 0.159-0.148 0.873-1.019 2.148-1.669 3.575-1.702l0.006 10.94h-1v1h-2v1h8v-1h-2v-1h-1v-10.94c1.418 0.030 2.679 0.682 3.524 1.693 0.053 0.084 0.117 0.145 0.193 0.186l-2.527 5.061h-0.19c0 1.1 1.34 2 3 2s3-0.9 3-2h-0.19zM5 10h-4l2-3.94zM11 10l2-3.94 2 3.94h-4z"></path></g>
<g id="vaadin:scatter-chart"><path d="M1 15v-15h-1v16h16v-1h-15z"></path><path d="M5 11c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M8 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M14 5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M11 10c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path></g>
<g id="vaadin:scissors"><path d="M16 3.1c0 0-2.1-1.1-3.5-1-0.3 0-0.5 0.1-0.7 0.2l-4.3 3.4-1.8-1.5c0.1-0.3 0.2-0.6 0.3-1 0.1-1.8-1.4-3.4-3.3-3.2-1.2 0.1-2.3 1-2.6 2.2-0.3 1.3 0.2 2.5 1.2 3.2l3.3 2.6-3.3 2.6c-1 0.7-1.5 1.9-1.2 3.2 0.3 1.2 1.4 2 2.6 2.2 1.9 0.2 3.4-1.4 3.2-3.2 0-0.3-0.1-0.7-0.3-1l1.8-1.5 4.3 3.4c0.2 0.1 0.4 0.2 0.7 0.2 1.4 0.1 3.5-1 3.5-1l-5.7-4.9 5.8-4.9zM2.8 4.6c-0.9-0.1-1.6-0.9-1.5-1.8s0.9-1.6 1.8-1.5c0.9 0.1 1.6 0.9 1.5 1.8 0 0.9-0.9 1.6-1.8 1.5zM3.1 14.7c-0.9 0.1-1.7-0.6-1.8-1.5s0.6-1.7 1.5-1.8c0.9-0.1 1.7 0.6 1.8 1.5s-0.6 1.7-1.5 1.8zM12.4 3.2c0 0 0.1 0 0.2 0 0.4 0 0.9 0.1 1.4 0.2l-6.8 5.7-0.9-1.1 6.1-4.8zM14 12.6c-0.5 0.2-1 0.3-1.4 0.2-0.1 0-0.2 0-0.2 0l-4-3.2 1-0.9 4.6 3.9z"></path></g>
<g id="vaadin:screwdriver"><path d="M8 10.8l0.9-0.8-0.9-0.9 5.7-5.7 1.2-0.4 1.1-2.2-0.7-0.7-2.3 1-0.5 1.2-5.6 5.7-0.9-0.9-0.8 0.9c0 0 0.8 0.6-0.1 1.5-0.5 0.5-1.3-0.1-2.8 1.4-0.5 0.5-2.1 2.1-2.1 2.1s-0.6 1 0.6 2.2 2.2 0.6 2.2 0.6 1.6-1.6 2.1-2.1c1.4-1.4 0.9-2.3 1.3-2.7 0.9-0.9 1.6-0.2 1.6-0.2zM4.9 10.4l0.7 0.7-3.8 3.8-0.7-0.7z"></path></g>
<g id="vaadin:search-minus"><path d="M15.7 14.3l-4.2-4.2c-0.2-0.2-0.5-0.3-0.8-0.3 0.8-1 1.3-2.4 1.3-3.8 0-3.3-2.7-6-6-6s-6 2.7-6 6 2.7 6 6 6c1.4 0 2.8-0.5 3.8-1.4 0 0.3 0 0.6 0.3 0.8l4.2 4.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.3 0.4-0.9 0-1.3zM6 10.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5z"></path><path d="M3 5h6v2h-6v-2z"></path></g>
<g id="vaadin:search-plus"><path d="M15.7 14.3l-4.2-4.2c-0.2-0.2-0.5-0.3-0.8-0.3 0.8-1 1.3-2.4 1.3-3.8 0-3.3-2.7-6-6-6s-6 2.7-6 6 2.7 6 6 6c1.4 0 2.8-0.5 3.8-1.4 0 0.3 0 0.6 0.3 0.8l4.2 4.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.3 0.4-0.9 0-1.3zM6 10.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5z"></path><path d="M7 3h-2v2h-2v2h2v2h2v-2h2v-2h-2z"></path></g>
<g id="vaadin:search"><path d="M15.7 14.3l-4.2-4.2c-0.2-0.2-0.5-0.3-0.8-0.3 0.8-1 1.3-2.4 1.3-3.8 0-3.3-2.7-6-6-6s-6 2.7-6 6 2.7 6 6 6c1.4 0 2.8-0.5 3.8-1.4 0 0.3 0 0.6 0.3 0.8l4.2 4.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.3 0.4-0.9 0-1.3zM6 10.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5z"></path></g>
<g id="vaadin:select"><path d="M15 4h-14c-0.6 0-1 0.4-1 1v6c0 0.6 0.4 1 1 1h14c0.6 0 1-0.4 1-1v-6c0-0.6-0.4-1-1-1zM12 9l-2-2h4l-2 2z"></path></g>
<g id="vaadin:server"><path d="M3 5v3h10v-3h-10zM7 7h-3v-1h3v1z"></path><path d="M3 4h10l-2-4h-6z"></path><path d="M3 12h10v-3h-10v3zM11 10h1v1h-1v-1zM9 10h1v1h-1v-1z"></path><path d="M3 16h10v-3h-10v3zM4 14h3v1h-3v-1z"></path></g>
<g id="vaadin:share-square"><path d="M11 3h-3.6c0 0-4.4-0.2-4.4 4.3 0 3.5 2 6.7 2 6.7s-0.4-7 2.3-7h3.7v3l5-5-5-5v3z"></path><path d="M14 9v6h-13v-13h9v-1h-10v15h15v-8z"></path></g>
<g id="vaadin:share"><path d="M10 3h-5.1c0 0-4.9 0-4.9 5 0 3.9 3 8 3 8s-1.7-7 1.8-7h5.2v3l6-6-6-6v3z"></path></g>
<g id="vaadin:shield"><path d="M1 0c0 0 0 3.2 0 7 0 5.6 7 9 7 9s7-3.4 7-9c0-3.8 0-7 0-7h-14zM14 7c0 4.2-4.6 7.1-6 7.9v-13.9h6v6z"></path></g>
<g id="vaadin:shift-arrow"><path d="M8 2l-7 7h4v5h6v-5h4zM10 8v5h-4v-5h-2.5l4.5-4.58 4.5 4.58h-2.5z"></path></g>
<g id="vaadin:shift"><path d="M0 2v12h16v-12h-16zM6 8v3h-2v-3h-2l3-3 3 3h-2z"></path></g>
<g id="vaadin:shop"><path d="M0 15h16v1h-16v-1z"></path><path d="M0 0v6c0.005 0.732 0.401 1.37 0.991 1.715l0.009 6.285h9v-5h3v5h2v-6.28c0.599-0.35 0.995-0.988 1-1.719v-6.001h-16zM4 2h2v4c0 0.552-0.448 1-1 1s-1-0.448-1-1v-4zM2 7c-0.552 0-1-0.448-1-1v-4h2v4c0 0.552-0.448 1-1 1zM8 12h-5v-3h5v3zM9 6c0 0.552-0.448 1-1 1s-1-0.448-1-1v-4h2v4zM12 6c0 0.552-0.448 1-1 1s-1-0.448-1-1v-4h2v4zM15 6c0 0.552-0.448 1-1 1s-1-0.448-1-1v-4h2v4z"></path></g>
<g id="vaadin:sign-in-alt"><path d="M0 0h2v16h-2v-16z"></path><path d="M3 10h8v3l5-5-5-5v3h-8z"></path></g>
<g id="vaadin:sign-in"><path d="M7 1v2l1 1v-2h7v12h-7v-2l-1 1v2h9v-14z"></path><path d="M10 8l-5-4v2h-5v4h5v2z"></path></g>
<g id="vaadin:sign-out-alt"><path d="M14 0h2v16h-2v-16z"></path><path d="M8 6h-8v4h8v3l5-5-5-5z"></path></g>
<g id="vaadin:sign-out"><path d="M9 4v-3h-9v14h9v-3h-1v2h-7v-12h7v2z"></path><path d="M16 8l-5-4v2h-5v4h5v2z"></path></g>
<g id="vaadin:signal"><path d="M6.9 13.2l1.1 1.1 1.1-1.1c-0.3-0.3-0.7-0.5-1.1-0.5s-0.9 0.2-1.1 0.5z"></path><path d="M8 4.6c2.7 0 5.1 1.1 6.9 2.8l1.1-1.1c-2-2-4.9-3.3-8-3.3s-6 1.3-8 3.3l1.1 1.1c1.8-1.7 4.2-2.8 6.9-2.8z"></path><path d="M2.3 8.6l1.1 1.1c1.2-1.1 2.8-1.8 4.6-1.8s3.4 0.7 4.6 1.9l1.1-1.1c-1.4-1.6-3.5-2.5-5.7-2.5s-4.3 0.9-5.7 2.4z"></path><path d="M4.6 10.9l1.1 1.1c0.6-0.6 1.4-0.9 2.3-0.9s1.7 0.4 2.3 0.9l1.1-1.1c-0.8-0.9-2.1-1.4-3.4-1.4s-2.6 0.5-3.4 1.4z"></path></g>
<g id="vaadin:sitemap"><path d="M14.5 12v-4.5h-6v-3.5h1.5v-4h-4v4h1.5v3.5h-6v4.5h-1.5v4h4v-4h-1.5v-3.5h5v3.5h-1.5v4h4v-4h-1.5v-3.5h5v3.5h-1.5v4h4v-4z"></path></g>
<g id="vaadin:slider"><path d="M16 6h-3.6c-0.7-1.2-2-2-3.4-2s-2.8 0.8-3.4 2h-5.6v4h5.6c0.7 1.2 2 2 3.4 2s2.8-0.8 3.4-2h3.6v-4zM1 9v-2h4.1c0 0.3-0.1 0.7-0.1 1s0.1 0.7 0.1 1h-4.1zM9 11c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3c0 1.7-1.3 3-3 3z"></path></g>
<g id="vaadin:sliders"><path d="M7 0h2v3h-2v-3z"></path><path d="M6 4v3h1v9h2v-9h1v-3z"></path><path d="M2 0h2v8h-2v-8z"></path><path d="M1 9v3h1v4h2v-4h1v-3z"></path><path d="M12 0h2v10h-2v-10z"></path><path d="M11 11v3h1v2h2v-2h1v-3z"></path></g>
<g id="vaadin:smiley-o"><path d="M8 1c3.9 0 7 3.1 7 7s-3.1 7-7 7-7-3.1-7-7 3.1-7 7-7zM8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8v0z"></path><path d="M8 13.2c-2 0-3.8-1.2-4.6-3.1l0.9-0.4c0.6 1.5 2.1 2.4 3.7 2.4s3.1-1 3.7-2.4l0.9 0.4c-0.8 2-2.6 3.1-4.6 3.1z"></path><path d="M7 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M11 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path></g>
<g id="vaadin:sort"><path d="M11 7h-6l3-4z"></path><path d="M5 9h6l-3 4z"></path></g>
<g id="vaadin:sound-disable"><path d="M4 5h-4v6h4l5 4v-14z"></path><path d="M15.9 5.6l-0.8-0.7-2.3 2.4-2.4-2.4-0.8 0.7 2.4 2.4-2.4 2.4 0.8 0.7 2.4-2.4 2.3 2.4 0.8-0.7-2.4-2.4z"></path></g>
<g id="vaadin:spark-line"><path d="M14 6c-1.105 0-2 0.895-2 2 0 0.060 0 0.11 0 0.16l-0.81 0.25-2.3-3.48-1.73 4.32-1.16-5.81-2.3 4.78-1.64-1.31-2.060 1.090v1.080l1.94-1 2.11 1.7 1.56-3.22 1.23 6.19 2.27-5.68 1.68 2.52 1.55-0.48c0.364 0.54 0.973 0.89 1.664 0.89 1.105 0 2-0.895 2-2s-0.895-2-2-2c-0.001 0-0.003 0-0.004 0zM14 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z"></path></g>
<g id="vaadin:specialist"><path d="M4.1 8c0.2 0.6 0.3 1.1 0.3 1.1 0.8 1.3 1.8 1.1 1.8 1.8 0 0.3-0.2 0.6-0.5 0.7l2.3 1.8 2.3-1.7c-0.3-0.2-0.5-0.4-0.5-0.7 0-0.8 1-0.5 1.8-1.8 0 0 0.2-0.4 0.3-1.1v0c0.3-1.1 0.6-3.1 0.5-4.1h-1.5c0-0.3 0.1-0.6 0.1-1h1.1c-0.3-1.4-1-2-2.2-2.3-0.5-0.4-1.2-0.7-1.9-0.7s-1.4 0.3-1.9 0.7c-1.2 0.3-1.8 0.9-2.2 2.3h1.1c0 0.4 0.1 0.7 0.2 1h-1.6c-0.1 1 0.2 3 0.5 4v0zM11.2 8.5c-0.1 0.1-0.2 0.2-0.3 0.3l-0.5 0.6c-0.4 0.5-0.8 0.8-1.4 0.9l-0.4 0.1c-0.4 0.1-0.9 0.1-1.4 0l-0.4-0.1c-0.6-0.2-1.1-0.5-1.5-1.1l-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.3l-0.7-0.5 3.1-0.9c0.5-0.1 1-0.2 1.5 0l3.2 0.9-0.7 0.5zM6 3c0-1.1 0.9-2 2-2s2 0.9 2 2c0 1.1-0.9 2-2 2s-2-0.9-2-2z"></path><path d="M15.5 14.2c-1.3-2.4-2.6-2-3.9-2.2 0 0 0 0-0.1 0l-3.5 2.6-3.5-2.6c0 0 0 0-0.1 0-1.4 0.1-2.6-0.2-3.9 2.2-0.2 0.4-0.4 1.1-0.5 1.8h16c-0.1-0.7-0.3-1.4-0.5-1.8z"></path></g>
<g id="vaadin:spinner-arc"><path d="M15 8c0 3.9-3.1 7-7 7s-7-3-7-7h-1c0 4 3.6 8 8 8s8-3.6 8-8h-1z"></path></g>
<g id="vaadin:spinner-third"><path d="M12.9 3.1c1.3 1.2 2.1 3 2.1 4.9 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-1.9 0.8-3.7 2.1-4.9l-0.8-0.8c-1.4 1.5-2.3 3.5-2.3 5.7 0 4.4 3.6 8 8 8s8-3.6 8-8c0-2.2-0.9-4.2-2.3-5.7l-0.8 0.8z"></path></g>
<g id="vaadin:spinner"><path d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path></g>
<g id="vaadin:spline-area-chart"><path d="M1 15v-15h-1v16h16v-1h-15z"></path><path d="M10 7c-2 0-2.080-1-4-1-2.34 0-4 3-4 3v5h14v-12c-2 0-3.86 5-6 5z"></path></g>
<g id="vaadin:spline-chart"><path d="M1 15v-15h-1v16h16v-1h-15z"></path><path d="M12 5c-0.69 1-1.41 2-2 2-0.026 0.001-0.056 0.001-0.087 0.001-0.601 0-1.164-0.16-1.65-0.44-0.623-0.35-1.387-0.562-2.2-0.562-0.022 0-0.045 0-0.067 0-1.6 0.116-3.009 0.864-3.991 1.993l-0.006 2.347c0.77-1.12 2.32-2.84 4-2.84 0.014-0 0.031-0 0.048-0 0.579 0 1.121 0.156 1.587 0.428 0.643 0.358 1.429 0.573 2.264 0.573 0.035 0 0.071-0 0.106-0.001 1.395 0 2.335-1.32 3.245-2.6s1.75-2.4 2.75-2.4v-1.5c-1.81 0-3 1.61-4 3z"></path></g>
<g id="vaadin:split-h"><path d="M0 1v14h16v-14h-16zM1 4h6.5v10h-6.5v-10zM15 14h-6.5v-10h6.5v10zM15 3h-1v-1h1v1z"></path></g>
<g id="vaadin:split-v"><path d="M0 1v14h16v-14h-16zM14 2h1v1h-1v-1zM15 4v4.5h-14v-4.5h14zM1 14v-4.5h14v4.5h-14z"></path></g>
<g id="vaadin:split"><path d="M0 11h6v5h-6v-5z"></path><path d="M11 10v-2l-0.64 0.64c-0.851-0.81-1.38-1.952-1.38-3.217 0-0.149 0.007-0.296 0.022-0.441l1.999 0.018v-5h-6v5h2c0.013 0.127 0.020 0.274 0.020 0.423 0 1.265-0.529 2.407-1.378 3.216l-0.642-0.638v2h2l-0.65-0.65c1.028-0.991 1.667-2.38 1.667-3.919 0-0.152-0.006-0.302-0.018-0.45-0.010 0.149-0.016 0.299-0.016 0.45 0 1.539 0.639 2.928 1.665 3.917l-0.648 0.652h2z"></path><path d="M10 11h6v5h-6v-5z"></path></g>
<g id="vaadin:spoon"><path d="M10.5 4.8c0-1.8-0.9-4.8-3-4.8s-3 3-3 4.8c0 1.5 0.8 2.8 2.2 3.1-0.5 1.6-0.7 4.6-0.7 4.6v2c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5v-2c0-0.6-0.2-3.2-0.7-4.6 1.4-0.3 2.2-1.6 2.2-3.1z"></path></g>
<g id="vaadin:square-shadow"><path d="M14 2v-2h-14v14h2v2h14v-14h-2zM13 13h-12v-12h12v12z"></path></g>
<g id="vaadin:star-half-left-o"><path d="M15.9 6.2l-5.5-0.8-2.4-5-2.4 5-5.5 0.8 3.9 3.8-0.9 5.4 4.9-2.5 4.9 2.6-0.9-5.5 3.9-3.8zM8 11.8v-9.1l1.8 3.6 4 0.6-2.9 2.8 0.7 4-3.6-1.9z"></path></g>
<g id="vaadin:star-half-left"><path d="M5.6 5.4l-5.5 0.8 3.9 3.8-0.9 5.5 4.9-2.6v-12.5z"></path></g>
<g id="vaadin:star-half-right-o"><path d="M15.9 6.2l-5.5-0.8-2.4-5-2.4 5-5.5 0.8 3.9 3.8-0.9 5.4 4.9-2.5 4.9 2.6-0.9-5.5 3.9-3.8zM4.4 13.7l0.7-4-2.9-2.8 4-0.6 1.8-3.6v9.1l-3.6 1.9z"></path></g>
<g id="vaadin:star-half-right"><path d="M10.5 5.4l5.5 0.8-4 3.8 0.9 5.5-4.9-2.6v-12.5z"></path></g>
<g id="vaadin:star-o"><path d="M15.9 6.2l-5.5-0.8-2.4-5-2.4 5-5.5 0.8 3.9 3.8-0.9 5.4 4.9-2.5 4.9 2.6-0.9-5.5 3.9-3.8zM8 11.8l-3.6 1.9 0.7-4-2.9-2.8 4-0.6 1.8-3.6 1.8 3.6 4 0.6-2.9 2.8 0.7 4-3.6-1.9z"></path></g>
<g id="vaadin:star"><path d="M12.9 15.4l-4.9-2.6-4.9 2.6 0.9-5.4-4-3.9 5.5-0.8 2.4-5 2.4 5 5.5 0.8-3.8 3.9 0.9 5.4z"></path></g>
<g id="vaadin:start-cog"><path d="M4 0v6h1.7l0.2 0.7 0.2 0.6c0 0 0.1 0 0.1 0l1.2-0.6 1.8 1.8-0.6 1.2c0 0 0 0.1 0 0.1l0.6 0.2 0.7 0.2v0.2l6.1-3.4-12-7z"></path><path d="M4.5 10.5c-0.2 0-0.4 0.1-0.5 0.2-0.3 0.2-0.5 0.5-0.5 0.8s0.2 0.7 0.5 0.8c0.1 0.1 0.3 0.2 0.5 0.2 0.6 0 1-0.4 1-1s-0.4-1-1-1z"></path><path d="M9 12v-1l-1.1-0.4c-0.1-0.3-0.2-0.6-0.4-0.9l0.5-1-0.7-0.7-1 0.5c-0.3-0.2-0.6-0.3-0.9-0.4l-0.4-1.1h-1l-0.4 1.1c-0.3 0.1-0.6 0.2-0.9 0.4l-1-0.5-0.7 0.7 0.5 1.1c-0.2 0.3-0.3 0.6-0.4 0.9l-1.1 0.3v1l1.1 0.4c0.1 0.3 0.2 0.6 0.4 0.9l-0.5 1 0.7 0.7 1.1-0.5c0.3 0.2 0.6 0.3 0.9 0.4l0.3 1.1h1l0.4-1.1c0.3-0.1 0.6-0.2 0.9-0.4l1 0.5 0.7-0.7-0.5-1.1c0.2-0.3 0.3-0.6 0.4-0.9l1.1-0.3zM4.5 13.5c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2c0 1.1-0.9 2-2 2z"></path></g>
<g id="vaadin:step-backward"><path d="M14 15v-14l-10 7z"></path><path d="M2 1h2v14h-2v-14z"></path></g>
<g id="vaadin:step-forward"><path d="M2 1v14l10-7z"></path><path d="M12 1h2v14h-2v-14z"></path></g>
<g id="vaadin:stethoscope"><path d="M5.7 15.2c0.3 0.3 1 0.8 1.8 0.8 2.7 0 3.3-2 3.4-3.6 0.2-2.3 0.8-2.2 1.1-2.2 0.7 0 0.9 0.4 0.9 1.1-0.6 0.4-1 1-1 1.7 0 1.1 0.9 2 2 2s2-0.9 2-2-0.9-2-2-2c-0.1 0-0.1 0-0.2 0-0.2-0.9-0.7-1.8-1.8-1.8-1.6 0-2 1.4-2.1 2.9-0.1 2.1-0.8 2.9-2.3 2.9-0.4 0-0.8-0.2-1-0.4-0.6-0.5-0.5-2.3-0.5-2.3 2 0 4-1.8 4.7-4.8l-0.2-0.1c0.3-1.2 0.5-2.6 0.5-3.6 0-1.1-0.3-1.9-1-2.5s-1.5-0.8-2.1-0.8c-0.2-0.3-0.5-0.5-0.9-0.5-0.5 0-1 0.4-1 1s0.4 1 1 1c0.4 0 0.7-0.2 0.8-0.5 0.5 0 1 0.2 1.5 0.6s0.7 0.9 0.7 1.7c0 0.9-0.2 2.2-0.5 3.5l-0.2-0.1c-0.3 1.1-1.3 3.6-3.3 3.6h-1c-2 0-3-2.5-3.3-3.6l-0.2 0.1c-0.3-1.3-0.5-2.6-0.5-3.5 0-0.8 0.2-1.3 0.7-1.7 0.4-0.4 1-0.5 1.5-0.6 0.1 0.3 0.4 0.5 0.8 0.5 0.6 0 1-0.4 1-1s-0.4-1-1-1c-0.4 0-0.7 0.2-0.9 0.5-0.6 0-1.4 0.2-2.1 0.8s-1 1.4-1 2.5c0 1 0.2 2.4 0.5 3.7l-0.2 0.1c0.7 2.9 2.7 4.7 4.7 4.7 0 0-0.1 2.2 0.7 2.9zM14 14c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1-0.5 1-1 1z"></path></g>
<g id="vaadin:stock"><path d="M12 6v-6h-8v6h-4v7h16v-7h-4zM7 12h-6v-5h2v1h2v-1h2v5zM5 6v-5h2v1h2v-1h2v5h-6zM15 12h-6v-5h2v1h2v-1h2v5z"></path><path d="M0 16h3v-1h10v1h3v-2h-16v2z"></path></g>
<g id="vaadin:stop-cog"><path d="M1 0v7.2l0.5-0.5 1.2 0.6c0 0 0.1 0 0.1 0l0.2-0.6 0.3-0.7h2.4l0.2 0.7 0.2 0.6c0 0 0.1 0 0.1 0l1.2-0.6 1.8 1.8-0.6 1.2c0 0 0 0.1 0 0.1l0.6 0.2 0.7 0.2v2.4l-0.7 0.2-0.6 0.2c0 0 0 0.1 0 0.1l0.6 1.2-0.4 0.7h7.2v-15h-15z"></path><path d="M5.5 11.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path><path d="M7.9 12.4l1.1-0.4v-1l-1.1-0.4c-0.1-0.3-0.2-0.6-0.4-0.9l0.5-1-0.7-0.7-1 0.5c-0.3-0.2-0.6-0.3-0.9-0.4l-0.4-1.1h-1l-0.4 1.1c-0.3 0.1-0.6 0.2-0.9 0.4l-1-0.5-0.7 0.7 0.5 1.1c-0.2 0.3-0.3 0.6-0.4 0.9l-1.1 0.3v1l1.1 0.4c0.1 0.3 0.2 0.6 0.4 0.9l-0.5 1 0.7 0.7 1.1-0.5c0.3 0.2 0.6 0.3 0.9 0.4l0.3 1.1h1l0.4-1.1c0.3-0.1 0.6-0.2 0.9-0.4l1 0.5 0.7-0.7-0.5-1.1c0.2-0.2 0.3-0.5 0.4-0.8zM4.5 13.5c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2c0 1.1-0.9 2-2 2z"></path></g>
<g id="vaadin:stop"><path d="M1 1h14v14h-14v-14z"></path></g>
<g id="vaadin:stopwatch"><path d="M8.5 8.14v-3.64h-1v3.64c-0.301 0.176-0.5 0.498-0.5 0.866 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.368-0.199-0.69-0.495-0.863z"></path><path d="M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7c3.866 0 7-3.134 7-7s-3.134-7-7-7zM8 14.5c-3.038 0-5.5-2.462-5.5-5.5s2.462-5.5 5.5-5.5c3.038 0 5.5 2.462 5.5 5.5-0.006 3.035-2.465 5.494-5.499 5.5z"></path><path d="M6 0h4v1.5h-4v-1.5z"></path><path d="M0.005 4.438l2.713-2.939 1.102 1.017-2.713 2.939-1.102-1.017z"></path><path d="M12.186 2.519l1.102-1.017 2.713 2.939-1.102 1.017-2.713-2.939z"></path></g>
<g id="vaadin:storage"><path d="M16 4l-8.060-4-7.94 4v1h1v11h2v-9h10v9h2v-11h1v-1zM4 6v-1h2v1h-2zM7 6v-1h2v1h-2zM10 6v-1h2v1h-2z"></path><path d="M6 9h-1v-1h-1v3h3v-3h-1v1z"></path><path d="M6 13h-1v-1h-1v3h3v-3h-1v1z"></path><path d="M10 13h-1v-1h-1v3h3v-3h-1v1z"></path></g>
<g id="vaadin:strikethrough"><path d="M10.5 7c-0.5-0.3-1-0.5-1.4-0.7-2-0.9-2.1-1.1-2-1.9s0.4-1 0.6-1.2c0.9-0.5 2.8-0.1 3.5 0.2l1.1-2.8c-0.4-0.2-3.7-1.4-6.1 0-0.8 0.5-1.9 1.5-2.1 3.4-0.2 1.3 0.1 2.3 0.7 3h-4.8v1h16v-1h-5.5z"></path><path d="M7.7 9c0 0 0.1 0 0.1 0.1 2 0.9 2.4 1.2 2.2 2.5-0.2 0.9-0.5 1.1-0.8 1.3-1.1 0.6-3.3 0-4.4-0.5l-1.2 2.6c0.3 0.1 2.3 1 4.5 1 0.9 0 1.8-0.2 2.6-0.6 0.9-0.5 2-1.4 2.4-3.4 0.2-1.3 0-2.3-0.4-3.1h-5z"></path></g>
<g id="vaadin:subscript"><path d="M16 15v1h-4v-1c0 0 3.3-1.6 2.6-3.2-0.5-1.1-2-0.2-2-0.2l-0.5-0.9c0 0 1.9-1.4 3.1-0.2 2.4 2.3-1.4 4.5-1.4 4.5h2.2z"></path><path d="M12 3h-3.4l-2.6 3-2.6-3h-3.4l4.3 5-4.3 5h3.4l2.6-3 2.6 3h3.4l-4.3-5z"></path></g>
<g id="vaadin:suitcase"><path d="M11 3v-2h-6v2h-5v12h16v-12h-5zM4 14h-1v-10h1v10zM10 3h-4v-1h4v1zM13 14h-1v-10h1v10z"></path></g>
<g id="vaadin:sun-down"><path d="M10 3h-1v-2h-2v2h-1l2 3 2-3z"></path><path d="M14 13l-1.58-1.18 0.78-1.82-2-0.23-0.2-1.97-1.82 0.78-1.18-1.58-1.18 1.58-1.82-0.78-0.23 2-1.97 0.2 0.78 1.82-1.58 1.18h-2v1h16v-1h-2zM4 13c0.075-2.178 1.822-3.925 3.993-4 2.185 0.075 3.932 1.821 4.007 3.993l-8 0.007z"></path></g>
<g id="vaadin:sun-o"><path d="M16 8l-2.2-1.6 1.1-2.4-2.7-0.2-0.2-2.7-2.4 1.1-1.6-2.2-1.6 2.2-2.4-1.1-0.2 2.7-2.7 0.2 1.1 2.4-2.2 1.6 2.2 1.6-1.1 2.4 2.7 0.2 0.2 2.7 2.4-1.1 1.6 2.2 1.6-2.2 2.4 1.1 0.2-2.7 2.7-0.2-1.1-2.4 2.2-1.6zM8 13c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"></path></g>
<g id="vaadin:sun-rise"><path d="M6 4h1v2h2v-2h1l-2-3-2 3z"></path><path d="M12.42 11.82l0.78-1.82-2-0.23-0.2-1.97-1.82 0.78-1.18-1.58-1.18 1.58-1.82-0.78-0.23 2-1.97 0.2 0.78 1.82-1.58 1.18h-2v1h16v-1h-2zM4 13c0.075-2.178 1.822-3.925 3.993-4 2.185 0.075 3.932 1.821 4.007 3.993l-8 0.007z"></path></g>
<g id="vaadin:superscript"><path d="M16 5v1h-4v-1c0 0 3.3-1.6 2.6-3.2-0.5-1.1-2-0.2-2-0.2l-0.5-0.9c0 0 1.9-1.4 3.1-0.2 2.4 2.3-1.4 4.5-1.4 4.5h2.2z"></path><path d="M12 3h-3.4l-2.6 3-2.6-3h-3.4l4.3 5-4.3 5h3.4l2.6-3 2.6 3h3.4l-4.3-5z"></path></g>
<g id="vaadin:sword"><path d="M15.8 0.5l-0.1-0.2-0.2-0.1c-0.1 0-2.5-0.8-4.2 0.9l-6.7 6.6c-0.9-0.6-1.7-1.2-1.8-1l-0.4 0.3c-0.2 0.2 0.9 1.7 1.8 2.7l-2.5 3.4c-0.3-0.3-0.8-0.3-1.1 0l-0.3 0.3c-0.3 0.3-0.3 0.8 0 1.1l1 1c0.3 0.3 0.8 0.3 1.1 0l0.3-0.3c0.3-0.3 0.3-0.8 0-1.1v0l3.5-2.5c1 0.9 2.5 2 2.7 1.8l0.4-0.4c0.1-0.1-0.4-1-1.1-1.8l6.7-6.7c1.7-1.5 0.9-3.9 0.9-4zM7.7 10.5l-0.8-0.8 6.2-6.9-6.9 6.2-0.7-0.7 6.5-6.5c1-1 2.3-0.8 2.9-0.7 0.1 0.6 0.3 1.9-0.7 2.8l-6.5 6.6z"></path></g>
<g id="vaadin:tab-a"><path d="M9 10h-9v-4h9v-2l5 4-5 4v-2z"></path><path d="M14 4h2v8h-2v-8z"></path></g>
<g id="vaadin:tab"><path d="M0 2v12h16v-12h-16zM13 11h-1v-3l-3 3v-2h-6v-2h6v-2l3 3v-3h1v6z"></path></g>
<g id="vaadin:table"><path d="M0 1v15h16v-15h-16zM5 15h-4v-2h4v2zM5 12h-4v-2h4v2zM5 9h-4v-2h4v2zM5 6h-4v-2h4v2zM10 15h-4v-2h4v2zM10 12h-4v-2h4v2zM10 9h-4v-2h4v2zM10 6h-4v-2h4v2zM15 15h-4v-2h4v2zM15 12h-4v-2h4v2zM15 9h-4v-2h4v2zM15 6h-4v-2h4v2z"></path></g>
<g id="vaadin:tablet"><path d="M0 2v12h16v-12h-16zM13 13h-11v-10h11v10zM15 9h-1v-2h1v2z"></path></g>
<g id="vaadin:tabs"><path d="M14 4v-2h-14v12h16v-10h-2zM10 3h3v1h-3v-1zM6 3h3v1h-3v-1zM15 13h-14v-10h4v2h10v8z"></path></g>
<g id="vaadin:tag"><path d="M8 1h-7v7l7 7 7-7zM3.75 5c-0.69 0-1.25-0.56-1.25-1.25s0.56-1.25 1.25-1.25c0.69 0 1.25 0.56 1.25 1.25s-0.56 1.25-1.25 1.25z"></path></g>
<g id="vaadin:tags"><path d="M9 2h-1.5l7 7-5.3 5.2 0.8 0.8 6-6z"></path><path d="M6 2h-6v6l7 7 6-6-7-7zM2.8 6c-0.7 0-1.3-0.6-1.3-1.2s0.6-1.2 1.2-1.2 1.3 0.5 1.3 1.2-0.6 1.2-1.2 1.2z"></path></g>
<g id="vaadin:tasks"><path d="M6 0h10v4h-10v-4z"></path><path d="M6 6h10v4h-10v-4z"></path><path d="M6 12h10v4h-10v-4z"></path><path d="M3 1v2h-2v-2h2zM4 0h-4v4h4v-4z"></path><path d="M3 13v2h-2v-2h2zM4 12h-4v4h4v-4z"></path><path d="M5.3 5.9l-0.6-0.8-0.9 0.9h-3.8v4h4v-2.8l1.3-1.3zM2.7 7l-0.7 0.7-0.8-0.7h1.5zM1 8.2l0.9 0.8h-0.9v-0.8zM3 9h-0.9l0.9-0.9v0.9z"></path></g>
<g id="vaadin:taxi"><path d="M15 6.1l-1.4-2.9c-0.4-0.7-1.1-1.2-2-1.2h-0.6v-1.3c0-0.4-0.3-0.7-0.7-0.7h-4.6c-0.4 0-0.7 0.3-0.7 0.7v1.3h-0.7c-0.8 0-1.6 0.5-1.9 1.2l-1.4 2.9c-0.6 0.1-1 0.6-1 1.1v3.5c0 0.6 0 1.1 1 1.2v2c0 0.6 0.4 1.1 1 1.1h0.9c0.6 0 1.1-0.5 1.1-1.1v-1.9h8v1.9c0 0.6 0.4 1.1 1 1.1h0.9c0.6 0 1.1-0.5 1.1-1.1v-2c1-0.1 1-0.6 1-1.2v-3.5c0-0.5-0.4-1-1-1.1zM4 8.4c0 0.3-0.3 0.6-0.6 0.6h-1.8c-0.3 0-0.6-0.3-0.6-0.6v-0.8c0-0.3 0.3-0.6 0.6-0.6h1.8c0.3 0 0.6 0.3 0.6 0.6v0.8zM10 11h-4v-1h4v1zM2.1 6l1.2-2.4c0.2-0.4 0.6-0.6 1-0.6h7.4c0.4 0 0.8 0.2 1 0.6l1.2 2.4h-11.8zM15 8.4c0 0.3-0.3 0.6-0.6 0.6h-1.8c-0.3 0-0.6-0.3-0.6-0.6v-0.8c0-0.3 0.3-0.6 0.6-0.6h1.8c0.3 0 0.6 0.3 0.6 0.6v0.8z"></path></g>
<g id="vaadin:teeth"><path d="M4.6 7.6c-0.1 0.1-0.5 0.4-1.6 0.4 1.1 0 1.5 0.3 1.6 0.4 0.2-0.2 0.6-0.4 1.5-0.4-0.9 0-1.3-0.2-1.5-0.4z"></path><path d="M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8c4.4 0 8-3.6 8-8s-3.6-8-8-8zM13.1 11.6c-1 0-1.4-0.8-1.6-1.6-0.2 0.9-0.6 2-1.8 2-1.1 0-1.5-1.1-1.7-2-0.2 1-0.6 2-1.7 2s-1.6-1.1-1.8-2c-0.2 0.8-0.6 1.6-1.6 1.6-2 0-1.9-3-1.9-3s0.2-0.6 1.7-0.6c-1.5 0-1.7-0.5-1.7-0.5s-0.1-3 1.9-3c1 0 1.4 0.8 1.6 1.6 0.2-0.9 0.6-2 1.8-2 1.1-0.1 1.5 1 1.7 1.9 0.2-1 0.6-2 1.7-2s1.6 1.1 1.8 2c0.2-0.8 0.6-1.6 1.6-1.6 2 0 1.9 3 1.9 3s-0.3 0.6-1.8 0.6c-1.2 0-1.6-0.3-1.8-0.4-0.2 0.2-0.7 0.4-1.6 0.4-1.2 0-1.6-0.2-1.8-0.4-0.1 0.1-0.6 0.4-1.6 0.4 1 0 1.4 0.3 1.6 0.4 0.2-0.2 0.6-0.4 1.8-0.4 1 0 1.4 0.2 1.7 0.4 0-0.1 0.5-0.4 1.7-0.4 1.5 0 1.8 0.6 1.8 0.6s0.1 3-1.9 3z"></path></g>
<g id="vaadin:terminal"><path d="M6 12h9v1h-9v-1z"></path><path d="M1.1 13h1.2l3.7-5-3.7-5h-1.3l3.8 5z"></path></g>
<g id="vaadin:text-height"><path d="M15 3h1l-1.5-3-1.5 3h1v10h-1l1.5 3 1.5-3h-1z"></path><path d="M1 0v3h4v13h3v-13h4v-3z"></path></g>
<g id="vaadin:text-input"><path d="M2 2h1v4h-1v-4z"></path><path d="M1 0c-0.6 0-1 0.4-1 1v14c0 0.6 0.4 1 1 1h15v-16h-15zM13 15h-12v-14h12v14zM15 15v0h-1v-1h1v1zM15 13h-1v-10h1v10zM15 2h-1v-1h1v1z"></path></g>
<g id="vaadin:text-label"><path d="M12.5 4.9c-1.4 0-2.5 0.8-2.6 0.9l1.2 1.6c0 0 0.7-0.5 1.4-0.5 1.4 0 1.5 1.2 1.5 1.6-0.4-0.1-1.1-0.3-2-0.1-1.4 0.3-2.8 2-2.1 3.9 0.7 1.8 3.1 2.1 4.1 0.6v1h2v-5.3c0-2.7-1.9-3.7-3.5-3.7zM11.5 11.4c-0.1-1.9 1.5-1.9 2.5-1.8v1c0 1.2-2.3 2.3-2.5 0.8z"></path><path d="M6.9 14h2.1l-3.2-12h-2.7l-3.1 12h2.1l1-4h2.7l1.1 4zM3.6 8l0.8-3.2 0.9 3.2h-1.7z"></path></g>
<g id="vaadin:text-width"><path d="M15 14.5l-3-1.5v1h-9v-1l-3 1.5 3 1.5v-1h9v1z"></path><path d="M0 0v3h6v9h3v-9h6v-3z"></path></g>
<g id="vaadin:thin-square"><path d="M15 1h-14v14h14v-14zM14 14h-12v-12h12v12z"></path></g>
<g id="vaadin:thumbs-down-o"><path d="M15.6 7.3c0.1-0.3 0.3-0.7 0.2-1.2 0-0.6-0.3-1.1-0.5-1.3 0.1-0.3 0.1-0.6 0-1.1s-0.4-0.8-0.6-1c0.1-0.3 0.1-0.8-0.3-1.4-0.4-1-1.2-1.3-3.6-1.3-1.7 0-3.3 0.8-4.6 1.5-0.4 0.2-1 0.5-1.2 0.5v0h-5v9h5v-0.9l2.7 2.7 1 2.8c0.2 0.2 0.4 0.4 0.8 0.4h0.1c0 0 0 0 0 0 0.5 0 2-0.1 2.4-1.9 0.2-0.9-0.1-2.2-0.5-3.1h2.3c0.7-0.1 2.1-0.6 2.2-2.1 0-0.7-0.2-1.3-0.4-1.6zM2.5 7.5c0.6 0 1 0.4 1 1s-0.4 1-1 1-1-0.4-1-1c0-0.6 0.4-1 1-1zM13.8 10h-2.5c-0.3 0-0.5 0.1-0.7 0.4-0.2 0.2-0.2 0.5-0.1 0.8 0.5 1.2 0.7 2.2 0.6 2.8-0.2 0.9-0.9 1.1-1.4 1.1l-1-2.7c0-0.1-0.1-0.2-0.2-0.3l-2.9-2.9c-0.1-0.1-0.3-0.2-0.5-0.2h-0.1v-6c0.4 0 0.8-0.2 1.7-0.6 1.1-0.6 2.7-1.4 4.1-1.4 2.5 0 2.7 0.4 2.9 0.7 0.3 0.5 0.1 0.9 0.1 0.9l-0.2 0.4 0.4 0.3c0 0 0.4 0.2 0.5 0.7 0.1 0.4 0 0.7 0 0.7l-0.3 0.3 0.3 0.3c0 0 0.4 0.3 0.4 0.9 0 0.5-0.2 0.7-0.2 0.7l-0.4 0.3 0.4 0.4c0 0 0.4 0.4 0.3 1.2 0 1.1-1.1 1.2-1.2 1.2z"></path></g>
<g id="vaadin:thumbs-down"><path d="M15.6 7.8c0 0 0.5 0.5 0.4 1.6 0 1.5-1.6 1.6-1.6 1.6h-2.4c-0.2 0-0.3 0.2-0.3 0.4 0.3 0.7 0.8 2.1 0.6 3.1-0.3 1.4-1.5 1.5-1.9 1.5-0.1 0-0.2-0.1-0.2-0.2l-1-2.8c0 0 0-0.1-0.1-0.1l-2.6-2.8c-0.1-0.1-0.2-0.1-0.3-0.1h-0.2v-7h0.2c0.7 0 3.2-2 5.4-2s2.7 0.3 3.1 1c0.4 0.7 0.1 1.3 0.1 1.3s0.5 0.3 0.6 1c0.1 0.7-0.1 1.1-0.1 1.1s0.5 0.4 0.5 1.2c0.1 0.9-0.2 1.2-0.2 1.2z"></path><path d="M0 11h5v-8h-5v8zM2.5 7.5c0.6 0 1 0.4 1 1s-0.4 1-1 1-1-0.4-1-1c0-0.6 0.4-1 1-1z"></path></g>
<g id="vaadin:thumbs-up-o"><path d="M16 7.1c0-1.5-1.4-2.1-2.2-2.1h-2.2c0.4-1 0.7-2.2 0.5-3.1-0.5-1.8-2-1.9-2.5-1.9h-0.1c-0.4 0-0.6 0.2-0.8 0.5l-1 2.8-2.7 2.7h-5v9h5v-1c0.2 0 0.7 0.3 1.2 0.6 1.2 0.6 2.9 1.5 4.5 1.5 2.4 0 3.2-0.3 3.8-1.3 0.3-0.6 0.3-1.1 0.3-1.4 0.2-0.2 0.5-0.5 0.6-1s0.1-0.8 0-1.1c0.2-0.3 0.4-0.7 0.5-1.3 0-0.5-0.1-0.9-0.2-1.2 0.1-0.4 0.3-0.9 0.3-1.7zM2.5 13.5c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1c0 0.6-0.4 1-1 1zM14.7 9.1c0 0 0.2 0.2 0.2 0.7 0 0.6-0.4 0.9-0.4 0.9l-0.3 0.3 0.2 0.3c0 0 0.2 0.3 0 0.7-0.1 0.4-0.5 0.7-0.5 0.7l-0.3 0.3 0.2 0.4c0 0 0.2 0.4-0.1 0.9-0.2 0.4-0.4 0.7-2.9 0.7-1.4 0-3-0.8-4.1-1.4-0.8-0.4-1.3-0.6-1.7-0.6v0-6h0.1c0.2 0 0.4-0.1 0.6-0.2l2.8-2.8c0.1-0.1 0.1-0.2 0.2-0.3l1-2.7c0.5 0 1.2 0.2 1.4 1.1 0.1 0.6-0.1 1.6-0.6 2.8-0.1 0.3-0.1 0.5 0.1 0.8 0.1 0.2 0.4 0.3 0.7 0.3h2.5c0.1 0 1.2 0.2 1.2 1.1 0 0.8-0.3 1.2-0.3 1.2l-0.3 0.4 0.3 0.4z"></path></g>
<g id="vaadin:thumbs-up"><path d="M15.6 8.2c0 0 0.5-0.5 0.4-1.6 0-1.5-1.6-1.6-1.6-1.6h-2.4c-0.2 0-0.3-0.2-0.3-0.4 0.3-0.7 0.8-2.1 0.6-3.1-0.3-1.4-1.5-1.5-1.9-1.5-0.1 0-0.2 0.1-0.2 0.2l-1 2.8c0 0 0 0.1-0.1 0.1l-2.6 2.8c-0.1 0.1-0.2 0.1-0.3 0.1h-0.2v7h0.2c0.7 0 3.2 2 5.4 2s2.7-0.3 3.1-1c0.4-0.7 0.1-1.3 0.1-1.3s0.5-0.3 0.6-1c0.1-0.7-0.1-1.1-0.1-1.1s0.5-0.4 0.5-1.2c0.1-0.9-0.2-1.2-0.2-1.2z"></path><path d="M0 14h5v-8h-5v8zM2.5 10.5c0.6 0 1 0.4 1 1s-0.4 1-1 1-1-0.4-1-1c0-0.6 0.4-1 1-1z"></path></g>
<g id="vaadin:ticket"><path d="M14 3h-12c0 1.1-0.9 2-2 2v6c1.1 0 2 0.9 2 2h12c0-1.1 0.9-2 2-2v0-6c-1.1 0-2-0.9-2-2zM13 12h-10v-8h10v8z"></path><path d="M4 5h8v6h-8v-6z"></path></g>
<g id="vaadin:time-backward"><path d="M8 4h-1v5h4v-1h-3z"></path><path d="M8 0c-3 0-5.6 1.6-6.9 4.1l-1.1-1.1v4h4l-1.5-1.5c1-2 3.1-3.5 5.5-3.5 3.3 0 6 2.7 6 6s-2.7 6-6 6c-1.8 0-3.4-0.8-4.5-2.1l-1.5 1.3c1.4 1.7 3.6 2.8 6 2.8 4.4 0 8-3.6 8-8s-3.6-8-8-8z"></path></g>
<g id="vaadin:time-forward"><path d="M8 4h-1v5h4v-1h-3z"></path><path d="M16 7v-4l-1.1 1.1c-1.3-2.5-3.9-4.1-6.9-4.1-4.4 0-8 3.6-8 8s3.6 8 8 8c2.4 0 4.6-1.1 6-2.8l-1.5-1.3c-1.1 1.3-2.7 2.1-4.5 2.1-3.3 0-6-2.7-6-6s2.7-6 6-6c2.4 0 4.5 1.5 5.5 3.5l-1.5 1.5h4z"></path></g>
<g id="vaadin:timer"><path d="M9.060 9.060c0.271-0.271 0.439-0.646 0.439-1.060s-0.168-0.789-0.439-1.060c-0.59-0.59-6.72-4.6-6.72-4.6s4 6.13 4.59 6.72c0.272 0.274 0.649 0.444 1.065 0.444s0.793-0.17 1.065-0.444z"></path><path d="M8 0v3h1v-1.41c3.153 0.495 5.536 3.192 5.536 6.445 0 3.601-2.919 6.52-6.52 6.52s-6.52-2.919-6.52-6.52c0-1.256 0.355-2.428 0.97-3.423l-0.916-1.322c-0.958 1.303-1.533 2.939-1.533 4.71 0 4.418 3.582 8 8 8s8-3.582 8-8c0-4.418-3.582-8-8-8-0.006 0-0.012 0-0.017 0z"></path></g>
<g id="vaadin:toolbox"><path d="M0 8h6v2h4v-2h6v6h-16z"></path><path d="M7 7h2v2h-2v-2z"></path><path d="M11 4v-2h-6v2h-5v3h6v-1h4v1h6v-3h-5zM6 4v-1h4v1h-4z"></path></g>
<g id="vaadin:tools"><path d="M10.3 8.2l-0.9 0.9 0.9 0.9-1.2 1.2 4.3 4.3c0.6 0.6 1.5 0.6 2.1 0s0.6-1.5 0-2.1l-5.2-5.2zM14.2 15c-0.4 0-0.8-0.3-0.8-0.8 0-0.4 0.3-0.8 0.8-0.8s0.8 0.3 0.8 0.8c0 0.5-0.3 0.8-0.8 0.8z"></path><path d="M3.6 8l0.9-0.6 1.5-1.7 0.9 0.9 0.9-0.9-0.1-0.1c0.2-0.5 0.3-1 0.3-1.6 0-2.2-1.8-4-4-4-0.6 0-1.1 0.1-1.6 0.3l2.9 2.9-2.1 2.1-2.9-2.9c-0.2 0.5-0.3 1-0.3 1.6 0 2.1 1.6 3.7 3.6 4z"></path><path d="M8 10.8l0.9-0.8-0.9-0.9 5.7-5.7 1.2-0.4 1.1-2.2-0.7-0.7-2.3 1-0.5 1.2-5.6 5.7-0.9-0.9-0.8 0.9c0 0 0.8 0.6-0.1 1.5-0.5 0.5-1.3-0.1-2.8 1.4-0.5 0.5-2.1 2.1-2.1 2.1s-0.6 1 0.6 2.2 2.2 0.6 2.2 0.6 1.6-1.6 2.1-2.1c1.4-1.4 0.9-2.3 1.3-2.7 0.9-0.9 1.6-0.2 1.6-0.2zM4.9 10.4l0.7 0.7-3.8 3.8-0.7-0.7z"></path></g>
<g id="vaadin:tooth"><path d="M11.3 16c-1.2 0-1.7-3.9-1.7-4.1-0.1-1.3-1-2.1-1.6-2.2-0.6 0-1.4 0.9-1.6 2.2 0 0.2-0.5 4.1-1.7 4.1s-1.8-4.4-1.9-4.4c-0.2-1.4 0.1-3.4 0.2-4-0.4-1.2-1.8-5.6-0.5-7 0.5-0.4 1.1-0.6 1.9-0.6 0.6 0 1.3 0.1 2 0.3 0.6 0.1 1.1 0.2 1.6 0.2s1-0.1 1.6-0.2c0.7-0.2 1.4-0.3 2-0.3 0.8 0 1.4 0.2 1.8 0.7 1.3 1.4-0.1 5.8-0.5 7 0.1 0.5 0.4 2.5 0.2 3.9 0.1 0-0.5 4.4-1.8 4.4zM8 8.7c1.3 0.1 2.4 1.4 2.6 3.1 0.1 1.2 0.5 2.4 0.7 2.9 0.3-0.6 0.7-2.1 0.9-3.3 0.2-1.4-0.2-3.7-0.2-3.7v-0.2c0.7-2.1 1.4-5.3 0.8-6.1-0.3-0.3-0.7-0.4-1.2-0.4s-1.2 0.1-1.8 0.3c-0.6 0.1-1.2 0.2-1.8 0.2s-1.2-0.1-1.8-0.2c-0.6-0.2-1.3-0.3-1.8-0.3s-0.9 0.1-1.1 0.4c-0.7 0.7 0 4 0.8 6.1v0.2c0 0-0.4 2.3-0.2 3.7 0.2 1.2 0.6 2.7 0.9 3.3 0.2-0.6 0.6-1.7 0.7-2.9 0.1-1.6 1.2-3 2.5-3.1z"></path></g>
<g id="vaadin:touch"><path d="M12.62 6c-0.093-0.023-0.2-0.036-0.31-0.036s-0.217 0.013-0.319 0.038c-0.045-0.33-0.192-0.616-0.402-0.843-0.257-0.259-0.614-0.42-1.008-0.42-0.018 0-0.036 0-0.053 0.001-0-0-0.004-0-0.007-0-0.22 0-0.43 0.044-0.621 0.124-0.062-0.183-0.163-0.336-0.29-0.464-0.261-0.25-0.617-0.403-1.008-0.403-0.036 0-0.072 0.001-0.107 0.004l0.005-0c0.315-0.414 0.505-0.938 0.505-1.506 0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5c0 0.813 0.388 1.535 0.989 1.992l0.006 2.664c-0.554 0.015-1.054 0.233-1.432 0.581-0.568 0.619-0.568 1.579-0.568 2.779 0 0.23 0 0.47 0 0.72 0.032 1.127 0.573 2.121 1.402 2.764l0.358 0.356c1.24 1.27 2.38 1.65 5.020 1.65 2.88 0 4.22-1.61 4.22-5.060v-2.51c0-0.77-0.22-2.12-1.38-2.43zM13 8.35v2.59c0 3.37-1.29 4.060-3.22 4.060-2.6 0-3.4-0.39-4.3-1.33l-0.36-0.37c-0.657-0.468-1.088-1.215-1.12-2.065-0-0.265-0-0.505-0-0.735-0.033-0.178-0.053-0.383-0.053-0.592 0-0.538 0.126-1.047 0.351-1.498 0.186-0.132 0.431-0.228 0.698-0.24l0.003 0.7v-0.22l-0.34 1.5c-0.010 0.022-0.016 0.048-0.016 0.075 0 0.103 0.083 0.186 0.186 0.186 0.075 0 0.14-0.045 0.17-0.11l1-1.211c0.003-0.014 0.005-0.029 0.005-0.045s-0.002-0.031-0.005-0.046l0-5.609c-0-0.012-0.001-0.026-0.001-0.039 0-0.256 0.083-0.492 0.223-0.684 0.091-0.096 0.223-0.158 0.369-0.158 0.010 0 0.020 0 0.030 0.001-0.001-0-0.001-0-0.001-0 0.21 0 0.38 0.17 0.38 0.38 0 0.004-0 0.007-0 0.011l0 3.869c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.32c0.010-0.251 0.217-0.451 0.47-0.451 0.011 0 0.021 0 0.032 0.001 0.023-0.005 0.051-0.008 0.079-0.008 0.232 0 0.42 0.188 0.42 0.42 0 0.010-0 0.020-0.001 0.029l0 1.329c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.64c0.034-0.218 0.22-0.383 0.445-0.383 0.019 0 0.038 0.001 0.057 0.004 0.013-0.002 0.030-0.003 0.047-0.003 0.112 0 0.214 0.043 0.291 0.113 0.1 0.129 0.16 0.294 0.16 0.473 0 0.006-0 0.012-0 0.017l0 0.819c0.003 0.252 0.193 0.459 0.438 0.49 0.021 0.003 0.043 0.004 0.066 0.004 0.241 0 0.442-0.166 0.496-0.39 0.026-0.112 0.082-0.204 0.16-0.273 0.033-0.015 0.071-0.024 0.111-0.024s0.078 0.009 0.112 0.024c0.38 0.249 0.628 0.674 0.628 1.157 0 0.057-0.003 0.113-0.010 0.169l0.001-0.007z"></path></g>
<g id="vaadin:train"><path d="M13 11.2v-7.4c0-1-0.8-1.8-1.8-1.8h-2.2v-1h2v-1h-6v1h2v1h-2.2c-1 0-1.8 0.8-1.8 1.8v7.4c0 1 0.8 1.8 1.8 1.8h0.2l-0.7 1h-1.3v1h0.7l-0.7 1h2l0.6-1h4.9l0.6 1h2l-0.7-1h0.6v-1h-1.3l-0.7-1h0.2c1 0 1.8-0.8 1.8-1.8zM4 3.9c0-0.5 0.4-0.9 0.9-0.9h6.1c0.6 0 1 0.4 1 0.9v2.1c0 0.6-0.4 1-0.9 1h-6.2c-0.5 0-0.9-0.4-0.9-0.9v-2.2zM4 11c0-0.6 0.4-1 1-1s1 0.4 1 1c0 0.6-0.4 1-1 1s-1-0.4-1-1zM9.9 14h-3.8l0.6-1h2.6l0.6 1zM10 11c0-0.6 0.4-1 1-1s1 0.4 1 1c0 0.6-0.4 1-1 1s-1-0.4-1-1z"></path></g>
<g id="vaadin:trash"><path d="M13 3s0-0.51-2-0.8v-0.7c-0.017-0.832-0.695-1.5-1.53-1.5-0 0-0 0-0 0h-3c-0.815 0.017-1.47 0.682-1.47 1.5 0 0 0 0 0 0v0.7c-0.765 0.068-1.452 0.359-2.007 0.806l-0.993-0.006v1h12v-1h-1zM6 1.5c0.005-0.274 0.226-0.495 0.499-0.5l3.001-0c0 0 0.001 0 0.001 0 0.282 0 0.513 0.22 0.529 0.499l0 0.561c-0.353-0.042-0.763-0.065-1.178-0.065-0.117 0-0.233 0.002-0.349 0.006-0.553-0-2.063-0-2.503 0.070v-0.57z"></path><path d="M2 5v1h1v9c1.234 0.631 2.692 1 4.236 1 0.002 0 0.003 0 0.005 0h1.52c0.001 0 0.003 0 0.004 0 1.544 0 3.002-0.369 4.289-1.025l-0.054-8.975h1v-1h-12zM6 13.92q-0.51-0.060-1-0.17v-6.75h1v6.92zM9 14h-2v-7h2v7zM11 13.72c-0.267 0.070-0.606 0.136-0.95 0.184l-0.050-6.904h1v6.72z"></path></g>
<g id="vaadin:tree-table"><path d="M6 10v-2h-2v-1h1v-2h-3v2h1v6h3v-2h-2v-1z"></path><path d="M0 0v16h16v-16h-16zM7 15h-6v-12h6v12zM11 15h-3v-12h3v12zM15 15h-3v-12h3v12z"></path></g>
<g id="vaadin:trendind-down"><path d="M16 14h-4l1.29-1.29-4.29-4.3-3 3-6-6v-2.82l6 6 3-3 5.71 5.7 1.28-1.29 0.010 4z"></path></g>
<g id="vaadin:trending-down"><path d="M16 14h-4l1.29-1.29-4.29-4.3-3 3-6-6v-2.82l6 6 3-3 5.71 5.7 1.28-1.29 0.010 4z"></path></g>
<g id="vaadin:trending-up"><path d="M16 2h-4l1.29 1.29-4.29 4.3-3-3-6 6v2.82l6-6 3 3 5.71-5.7 1.28 1.29 0.010-4z"></path></g>
<g id="vaadin:trophy"><path d="M11.7 8c4.2-0.3 4.3-2.7 4.3-5h-3v-3h-10v3h-3c0 2.3 0.1 4.7 4.3 5 0.9 1.4 2.1 2 2.7 2v4c-3 0-3 2-3 2h8c0 0 0-2-3-2v-4c0.6 0 1.8-0.6 2.7-2zM13 4h2c-0.1 1.6-0.4 2.7-2.7 2.9 0.3-0.8 0.6-1.7 0.7-2.9zM1 4h2c0.1 1.2 0.4 2.1 0.7 2.9-2.2-0.2-2.6-1.3-2.7-2.9zM4.5 6.1c-0.5-1.7-0.5-3.1-0.5-3.1v-2h1v2c0 0 0 1.7 0.4 3.1 0.5 1.7 1.6 2.9 1.6 2.9s-1.8-0.2-2.5-2.9z"></path></g>
<g id="vaadin:truck"><path d="M6 3h10v7h-10v-7z"></path><path d="M15 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path><path d="M13 11c1.3 0 2.4 0.8 2.8 2h0.2v-2h-3z"></path><path d="M5 5h-4l-1 4v4h1.2c0.4-1.2 1.5-2 2.8-2s2.4 0.8 2.8 2h3.4c0.4-1.2 1.5-2 2.8-2h-8v-6zM4 9h-3l0.8-3h2.2v3z"></path><path d="M6 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path></g>
<g id="vaadin:twin-col-select"><path d="M0 2v12h16v-12h-16zM7 13h-6v-10h6v10zM15 13h-6v-10h6v10z"></path><path d="M10 4h4v1h-4v-1z"></path><path d="M2 4h4v1h-4v-1z"></path><path d="M2 6h4v1h-4v-1z"></path><path d="M2 8h4v1h-4v-1z"></path></g>
<g id="vaadin:twitter-square"><path d="M0 0v16h16v-16h-16zM12.8 5.6c0 0.1 0 0.2 0 0.3 0 3.3-2.5 7-7 7-1.4 0-2.7-0.4-3.8-1.1 0.2 0 0.4 0 0.6 0 1.2 0 2.2-0.4 3.1-1.1-1.1 0-2-0.7-2.3-1.7 0.2 0 0.3 0 0.5 0s0.4 0 0.6-0.1c-1.1-0.2-2-1.2-2-2.4 0 0 0 0 0 0 0.3 0.2 0.7 0.3 1.1 0.3-0.7-0.4-1.1-1.2-1.1-2 0-0.5 0.1-0.9 0.3-1.2 1.2 1.5 3.1 2.4 5.1 2.5 0-0.2-0.1-0.4-0.1-0.6 0-1.4 1.1-2.5 2.5-2.5 0.7 0 1.3 0.3 1.8 0.8 0.6-0.1 1.1-0.3 1.6-0.6-0.2 0.6-0.6 1.1-1.1 1.4 0.5-0.1 1-0.2 1.4-0.4-0.3 0.6-0.7 1-1.2 1.4z"></path></g>
<g id="vaadin:twitter"><path d="M16 3c-0.6 0.3-1.2 0.4-1.9 0.5 0.7-0.4 1.2-1 1.4-1.8-0.6 0.4-1.3 0.6-2.1 0.8-0.6-0.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 0.3 0 0.5 0.1 0.7-2.7-0.1-5.2-1.4-6.8-3.4-0.3 0.5-0.4 1-0.4 1.7 0 1.1 0.6 2.1 1.5 2.7-0.5 0-1-0.2-1.5-0.4 0 0 0 0 0 0 0 1.6 1.1 2.9 2.6 3.2-0.3 0.1-0.6 0.1-0.9 0.1-0.2 0-0.4 0-0.6-0.1 0.4 1.3 1.6 2.3 3.1 2.3-1.1 0.9-2.5 1.4-4.1 1.4-0.3 0-0.5 0-0.8 0 1.5 0.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3 0-0.1 0-0.3 0-0.4 0.7-0.5 1.3-1.1 1.7-1.8z"></path></g>
<g id="vaadin:umbrella"><path d="M5.36 0.9l-0.27-0.57c-0.083-0.197-0.275-0.333-0.499-0.333-0.1 0-0.193 0.027-0.274 0.074-0.217 0.074-0.372 0.279-0.372 0.52 0 0.087 0.020 0.169 0.056 0.242l0.319 0.577c-6.2 3.49-3.9 10.59-3.9 10.59h0.060c0.25-0.12 0.8-1.64 2.050-2.25s2.78-0.090 3-0.21l0.12-0.060c0.477-0.742 0.998-1.387 1.58-1.97l3.37 7.070c0.246 0.619 0.729 1.098 1.334 1.335 0.168 0.053 0.343 0.080 0.524 0.080 0.254 0 0.495-0.053 0.713-0.149l0.359-0.176c0.263-0.145 0.462-0.38 0.558-0.662 0.117-0.276 0.183-0.586 0.183-0.913 0-0.401-0.1-0.778-0.277-1.108-0.102-0.189-0.311-0.324-0.551-0.324-0.076 0-0.149 0.014-0.217 0.038-0.182 0.089-0.308 0.277-0.308 0.495 0 0.093 0.023 0.18 0.064 0.257s0.529 1.067-0.101 1.337-1.19-0.73-1.19-0.73l-3.42-7.060c0.372-0.043 0.803-0.067 1.24-0.067s0.868 0.024 1.292 0.072l0.068-0.065c0.25-0.12 0.8-1.64 2.050-2.25s2.78-0.090 3-0.21h0.060s-3.98-6.41-10.62-3.58zM7.36 6.36c-1.034 0.399-1.834 1.209-2.211 2.224-0.55-1.082-0.909-2.375-1.007-3.74-0.142-2.244 0.608-2.924 0.608-2.924l0.77-0.32c1.084 0.101 2.052 0.534 2.816 1.195 0.976 0.895 1.747 2.009 2.233 3.265-0.339-0.021-0.752-0.067-1.175-0.067-0.724 0-1.417 0.134-2.054 0.379z"></path></g>
<g id="vaadin:underline"><path d="M2 15h12v1h-12v-1z"></path><path d="M11 0v8.4c0 1.5-1.1 2.6-2.6 2.6h-0.8c-1.5 0-2.6-1.1-2.6-2.6v-8.4h-3v8.4c0 3.1 2.5 5.6 5.6 5.6h0.9c3.1 0 5.6-2.5 5.6-5.6v-8.4h-3.1z"></path></g>
<g id="vaadin:unlink"><path d="M8 0h1v4h-1v-4z"></path><path d="M8 12h1v4h-1v-4z"></path><path d="M7 9h-4c-0.552 0-1-0.448-1-1s0.448-1 1-1h4v-2h-4c-1.657 0-3 1.343-3 3s1.343 3 3 3h4v-2z"></path><path d="M13 5h-4v2h4c0.552 0 1 0.448 1 1s-0.448 1-1 1h-4v2h4c1.657 0 3-1.343 3-3s-1.343-3-3-3z"></path><path d="M4.51 15.44l2.49-3.44h-1.23l-2.080 2.88 0.82 0.56z"></path><path d="M12.49 15.44l-2.49-3.44h1.23l2.080 2.88-0.82 0.56z"></path><path d="M12.49 0.99l-2.49 3.010h1.23l2.080-2.66-0.82-0.35z"></path><path d="M4.51 0.99l2.49 3.010h-1.23l-2.080-2.66 0.82-0.35z"></path></g>
<g id="vaadin:unlock"><path d="M8 8v-3.1c0-2.2-1.8-3.9-3.9-3.9h-0.3c-2.2 0-3.8 1.7-3.8 3.9v2.1h2v-2.1c0-1.1 0.7-1.9 1.8-1.9h0.3c1 0 1.9 0.8 1.9 1.9v3.1h-1l0.1 5c0 0-0.1 3 4.9 3s5-3 5-3v-5h-7zM11 14h-1v-1.8c-0.6 0-1-0.6-1-1.1 0-0.6 0.4-1.1 1-1.1s1 0.4 1 0.9v3.1z"></path></g>
<g id="vaadin:upload-alt"><path d="M0 14h16v2h-16v-2z"></path><path d="M8 0l-5 5h3v8h4v-8h3z"></path></g>
<g id="vaadin:upload"><path d="M11 10v2h-6v-2h-5v6h16v-6h-5zM4 14h-2v-2h2v2z"></path><path d="M13 5l-5-5-5 5h3v6h4v-6z"></path></g>
<g id="vaadin:user-card"><path d="M15 3v10h-14v-10h14zM16 2h-16v12h16v-12z"></path><path d="M8 5h6v1h-6v-1z"></path><path d="M8 7h6v1h-6v-1z"></path><path d="M8 9h3v1h-3v-1z"></path><path d="M5.4 7h-0.4v-0.1c0.6-0.2 1-0.8 1-1.4 0-0.8-0.7-1.5-1.5-1.5s-1.5 0.7-1.5 1.5c0 0.7 0.4 1.2 1 1.4v0.1h-0.4c-0.9 0-1.6 0.7-1.6 1.6v2.4h5v-2.4c0-0.9-0.7-1.6-1.6-1.6z"></path></g>
<g id="vaadin:user-check"><path d="M7.5 14.4c-0.8-0.8-0.8-2 0-2.8s2-0.8 2.8 0l0.6 0.6 1.9-2.1c-0.7-0.4-1.3-0.4-2-0.4-0.7-0.1-1.4-0.3-1.4-0.9s0.8-0.4 1.4-1.5c0 0 2.7-7.3-2.9-7.3-5.5 0-2.8 7.3-2.8 7.3 0.6 1 1.4 0.8 1.4 1.5s-0.7 0.7-1.4 0.8c-1.1 0.1-2.1-0.1-3.1 1.7-0.6 1.1-0.9 4.7-0.9 4.7h8l-1.6-1.6z"></path><path d="M12.8 16h2.1c0 0-0.1-0.9-0.2-2l-1.9 2z"></path><path d="M11 16c-0.3 0-0.5-0.1-0.7-0.3l-2-2c-0.4-0.4-0.4-1 0-1.4s1-0.4 1.4 0l1.3 1.3 3.3-3.6c0.4-0.4 1-0.4 1.4-0.1 0.4 0.4 0.4 1 0.1 1.4l-4 4.3c-0.3 0.3-0.5 0.4-0.8 0.4 0 0 0 0 0 0z"></path></g>
<g id="vaadin:user-clock"><path d="M14 13h-3v-3h1v2h2z"></path><path d="M16 12.5c0-2.5-2-4.5-4.5-4.5-0.7 0-1.4 0.2-2 0.5 0.2-0.3 0.8-0.3 1.4-1.2 0 0 2.7-7.3-2.9-7.3s-2.9 7.3-2.9 7.3c0.6 1 1.4 0.8 1.4 1.5s-0.7 0.7-1.4 0.8c-1.1 0.1-2.1-0.1-3.1 1.7-0.6 1.1-0.9 4.7-0.9 4.7h10.4c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5c0 1.9-1.6 3.5-3.5 3.5h3.4c0 0 0-0.2 0-0.5 0.6-0.8 1.1-1.8 1.1-3z"></path></g>
<g id="vaadin:user-heart"><path d="M14.2 16h0.6c0 0 0-0.2 0-0.6l-0.6 0.6z"></path><path d="M8.6 13.9c-0.7-0.7-1-1.8-0.8-2.8s0.8-1.8 1.7-2.1c0-0.1-0.1-0.2-0.1-0.2 0-0.6 0.8-0.4 1.4-1.5 0 0 2.7-7.3-2.9-7.3-5.5 0-2.8 7.3-2.8 7.3 0.6 1 1.4 0.8 1.4 1.5s-0.7 0.7-1.4 0.8c-1.1 0.1-2.1-0.1-3.1 1.7-0.6 1.1-0.9 4.7-0.9 4.7h9.6l-2.1-2.1z"></path><path d="M14.9 10.1c-0.2-0.1-0.5-0.1-0.7-0.1-0.7 0-1.3 0.6-1.7 1.1-0.4-0.5-1-1.1-1.7-1.1-0.3 0-0.5 0-0.7 0.1-1.2 0.4-1.4 2-0.5 2.9l3 2.9 3-2.9c0.8-0.9 0.5-2.5-0.7-2.9z"></path></g>
<g id="vaadin:user-star"><path d="M8.92 13.67l-1.61-1.53-1.5-1.42 2-0.29 2.25-0.32 0.29-0.57c-0.006 0-0.013 0-0.020 0-0.482 0-0.884-0.34-0.979-0.794-0.001-0.617 0.799-0.417 1.429-1.457 0.080-0.020 2.82-7.29-2.78-7.29s-2.86 7.27-2.86 7.27c0.63 1 1.44 0.85 1.43 1.45s-0.74 0.8-1.43 0.87c-1.14 0.13-2.14-0.13-3.14 1.76-0.6 1.090-0.85 4.65-0.85 4.65h7.36v-0.17z"></path><path d="M11.72 16h0.56l-0.28-0.14-0.28 0.14z"></path><path d="M12 14.73l2.47 1.27-0.47-2.69 2-1.9-2.76-0.39-1.24-2.45-1.24 2.45-2.76 0.39 2 1.9-0.47 2.69 2.47-1.27z"></path></g>
<g id="vaadin:user"><path d="M8 0c-5.6 0-2.9 7.3-2.9 7.3 0.6 1 1.4 0.8 1.4 1.5 0 0.6-0.7 0.8-1.4 0.9-1.1 0-2.1-0.2-3.1 1.6-0.6 1.1-0.9 4.7-0.9 4.7h13.7c0 0-0.3-3.6-0.8-4.7-1-1.9-2-1.6-3.1-1.7-0.7-0.1-1.4-0.3-1.4-0.9s0.8-0.4 1.4-1.5c0 0.1 2.7-7.2-2.9-7.2z"></path></g>
<g id="vaadin:users"><path d="M5.3 9.7c-0.4 0-0.9-0.2-0.9-0.6s0.5-0.3 0.9-1c0 0 1.8-4.9-1.8-4.9s-1.8 4.9-1.8 4.9c0.4 0.7 0.9 0.6 0.9 1s-0.5 0.6-0.9 0.6c-0.6 0.1-1.1 0-1.7 0.6v5.7h5c0.2-1.7 0.7-5.2 1.1-6.1 0 0 0.1-0.1 0.1-0.1-0.2-0.1-0.5-0.1-0.9-0.1z"></path><path d="M16 9.5c-0.7-0.8-1.3-0.7-2-0.8-0.5-0.1-1.1-0.2-1.1-0.7s0.6-0.3 1.1-1.2c0 0 2.1-5.9-2.2-5.9-4.4 0.1-2.3 6-2.3 6 0.5 0.8 1.1 0.7 1.1 1.1 0 0.5-0.6 0.6-1.1 0.7-0.9 0.1-1.7 0-2.5 1.5-0.4 0.9-1 5.8-1 5.8h10v-6.5z"></path></g>
<g id="vaadin:vaadin-h"><path d="M15.21 0.35c-0.436 0-0.79 0.354-0.79 0.79v0 0.46c0 0.5-0.32 0.85-1.070 0.85h-3.55c-1.61 0-1.73 1.19-1.8 1.83v0c-0.060-0.64-0.18-1.83-1.79-1.83h-3.57c-0.75 0-1.090-0.37-1.090-0.86v-0.45c0-0.006 0-0.013 0-0.020 0-0.425-0.345-0.77-0.77-0.77-0 0-0 0-0 0h0c-0 0-0 0-0 0-0.431 0-0.78 0.349-0.78 0.78 0 0.004 0 0.007 0 0.011v-0.001 1.32c0 1.54 0.7 2.31 2.34 2.31h3.66c1.090 0 1.19 0.46 1.19 0.9 0 0 0 0.090 0 0.13 0.048 0.428 0.408 0.758 0.845 0.758s0.797-0.33 0.845-0.754l0-0.004s0-0.080 0-0.13c0-0.44 0.1-0.9 1.19-0.9h3.61c1.61 0 2.32-0.77 2.32-2.31v-1.32c0-0.436-0.354-0.79-0.79-0.79v0z"></path><path d="M11.21 7.38c-0.012-0-0.026-0.001-0.040-0.001-0.453 0-0.835 0.301-0.958 0.714l-0.002 0.007-2.21 4.21-2.3-4.2c-0.122-0.425-0.507-0.731-0.963-0.731-0.013 0-0.026 0-0.039 0.001l0.002-0c-0.012-0-0.025-0.001-0.039-0.001-0.58 0-1.050 0.47-1.050 1.050 0 0.212 0.063 0.41 0.171 0.575l-0.002-0.004 3.29 6.1c0.15 0.333 0.478 0.561 0.86 0.561s0.71-0.228 0.858-0.555l0.002-0.006 3.34-6.1c0.090-0.152 0.144-0.335 0.144-0.53 0-0.58-0.47-1.050-1.050-1.050-0.005 0-0.010 0-0.014 0h0.001z"></path></g>
<g id="vaadin:vaadin-v"><path d="M5.8 7.16h-0.13c-0.44 0-0.9-0.1-0.9-1.19v-3.62c0-1.64-0.77-2.35-2.31-2.35h-1.32c-0.436 0-0.79 0.354-0.79 0.79v0c0 0.436 0.354 0.79 0.79 0.79v0h0.46c0.5 0 0.85 0.32 0.85 1.070v3.55c0 1.61 1.19 1.73 1.83 1.8v0c-0.64 0.060-1.83 0.18-1.83 1.79v3.55c0 0.75-0.37 1.090-0.86 1.090h-0.45c-0.006-0-0.013-0-0.020-0-0.425 0-0.77 0.345-0.77 0.77 0 0 0 0 0 0v-0c0 0 0 0 0 0 0 0.431 0.349 0.78 0.78 0.78 0.004 0 0.007-0 0.011-0h1.319c1.54 0 2.31-0.7 2.31-2.34v-3.59c0-1.090 0.46-1.19 0.9-1.19h0.13c0.428-0.048 0.758-0.408 0.758-0.845s-0.33-0.797-0.754-0.845l-0.004-0z"></path><path d="M15.1 7.19v0l-6.1-3.32c-0.152-0.090-0.335-0.144-0.53-0.144-0.58 0-1.050 0.47-1.050 1.050 0 0.005 0 0.010 0 0.014v-0.001c-0 0.012-0.001 0.026-0.001 0.040 0 0.453 0.301 0.835 0.714 0.958l0.007 0.002 4.21 2.26-4.24 2.25c-0.425 0.122-0.731 0.507-0.731 0.963 0 0.013 0 0.026 0.001 0.039l-0-0.002c-0 0.012-0.001 0.025-0.001 0.039 0 0.58 0.47 1.050 1.050 1.050 0.212 0 0.41-0.063 0.575-0.171l-0.004 0.002 6.1-3.29c0.333-0.15 0.561-0.478 0.561-0.86s-0.228-0.71-0.555-0.858l-0.006-0.002z"></path></g>
<g id="vaadin:viewport"><path d="M1 4h-1v-4h4v1h-3z"></path><path d="M12 1v-1h4v4h-1v-3z"></path><path d="M15 12h1v4h-4v-1h3z"></path><path d="M4 15v1h-4v-4h1v3z"></path><path d="M13 3v10h-10v-10h10zM14 2h-12v12h12v-12z"></path></g>
<g id="vaadin:vimeo-square"><path d="M0 0v16h16v-16h-16zM13.9 5.3c-0.7 3.8-4.4 7-5.5 7.7s-2.2-0.3-2.5-1.1c-0.4-0.9-1.7-5.7-2-6.1-0.4-0.3-1.4 0.5-1.4 0.5l-0.5-0.7c0 0 2-2.4 3.6-2.7s1.6 2.5 2 4.1c0.4 1.5 0.6 2.4 1 2.4 0.3 0 1-0.9 1.7-2.2s0-2.5-1.4-1.6c0.5-3.3 5.7-4.1 5-0.3z"></path></g>
<g id="vaadin:vimeo"><path d="M15.9 4.4c-0.9 5-5.9 9.3-7.4 10.3s-2.9-0.4-3.4-1.4c-0.5-1.3-2.2-7.6-2.7-8.2-0.4-0.5-1.8 0.6-1.8 0.6l-0.6-0.9c0 0 2.7-3.3 4.8-3.7 2.2-0.4 2.2 3.4 2.7 5.5 0.5 2 0.9 3.2 1.3 3.2s1.3-1.1 2.2-2.9c0.9-1.7 0-3.3-1.9-2.2 0.8-4.3 7.7-5.4 6.8-0.3z"></path></g>
<g id="vaadin:volume-down"><path d="M10.8 4.4l-0.5 1.1c0.5 0.9 0.8 1.9 0.8 3 0 1-0.3 2-0.7 2.9l0.7 0.9c0.6-1.1 1-2.4 1-3.7-0.1-1.6-0.5-3-1.3-4.2z"></path><path d="M4 5h-4v6h4l5 4v-14z"></path></g>
<g id="vaadin:volume-off"><path d="M4 5h-4v6h4l5 4v-14z"></path></g>
<g id="vaadin:volume-up"><path d="M15 8.5c0 2.3-0.8 4.5-2 6.2l0.7 0.8c1.5-1.9 2.4-4.4 2.4-7 0-3.1-1.2-5.9-3.2-8l-0.5 1c1.6 1.8 2.6 4.3 2.6 7z"></path><path d="M11.8 2.4l-0.5 1c1.1 1.4 1.7 3.2 1.7 5.1 0 1.7-0.5 3.2-1.3 4.6l0.7 0.8c1.1-1.5 1.7-3.4 1.7-5.4-0.1-2.3-0.9-4.4-2.3-6.1z"></path><path d="M10.8 4.4l-0.5 1.1c0.5 0.9 0.8 1.9 0.8 3 0 1-0.3 2-0.7 2.9l0.7 0.9c0.6-1.1 1-2.4 1-3.7-0.1-1.6-0.5-3-1.3-4.2z"></path><path d="M4 5h-4v6h4l5 4v-14z"></path></g>
<g id="vaadin:volume"><path d="M11.8 2.4l-0.5 1c1.1 1.4 1.7 3.2 1.7 5.1 0 1.7-0.5 3.2-1.3 4.6l0.7 0.8c1.1-1.5 1.7-3.4 1.7-5.4-0.1-2.3-0.9-4.4-2.3-6.1z"></path><path d="M10.8 4.4l-0.5 1.1c0.5 0.9 0.8 1.9 0.8 3 0 1-0.3 2-0.7 2.9l0.7 0.9c0.6-1.1 1-2.4 1-3.7-0.1-1.6-0.5-3-1.3-4.2z"></path><path d="M4 5h-4v6h4l5 4v-14z"></path></g>
<g id="vaadin:wallet"><path d="M14.5 4h-12.12c-0.057 0.012-0.123 0.018-0.19 0.018-0.552 0-1-0.448-1-1 0-0.006 0-0.013 0-0.019l12.81-0.499v-1.19c0.005-0.041 0.008-0.089 0.008-0.138 0-0.652-0.528-1.18-1.18-1.18-0.049 0-0.097 0.003-0.144 0.009l-11.374 1.849c-0.771 0.289-1.31 1.020-1.31 1.877 0 0.011 0 0.023 0 0.034l-0 10.728c-0 0.003-0 0.006-0 0.010 0 0.828 0.672 1.5 1.5 1.5 0 0 0 0 0 0h13c0 0 0 0 0 0 0.828 0 1.5-0.672 1.5-1.5 0-0.004-0-0.007-0-0.011v-8.999c0-0.012 0.001-0.027 0.001-0.041 0-0.801-0.649-1.45-1.45-1.45-0.018 0-0.036 0-0.053 0.001zM13 11c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5z"></path></g>
<g id="vaadin:warning"><path d="M8 1l-8 14h16l-8-14zM8 13c-0.6 0-1-0.4-1-1s0.4-1 1-1 1 0.4 1 1c0 0.6-0.4 1-1 1zM7 10v-4h2v4h-2z"></path></g>
<g id="vaadin:workplace"><path d="M11,3 L11,0 L2,0 L2,14 L0,14 L0,15 L7,15 L7,10 L9,10 L9,8 L14,8 L14,3 L11,3 Z M6,10 L4,10 L4,8 L6,8 L6,10 Z M6,7 L4,7 L4,5 L6,5 L6,7 Z M6,4 L4,4 L4,2 L6,2 L6,4 Z M9,7 L7,7 L7,5 L9,5 L9,7 Z M9,4 L7,4 L7,2 L9,2 L9,4 Z M13,7 L11,7 L11,5 L13,5 L13,7 Z M14,11 L16,11 L16,16 L8,16 L8,11 L10,11 L10,9 L14,9 L14,11 Z" fill-rule="nonzero"></path></g>
<g id="vaadin:wrench"><path d="M15.5 13.4l-7.8-7.8c0.2-0.5 0.3-1 0.3-1.6 0-2.2-1.8-4-4-4-0.6 0-1.1 0.1-1.6 0.3l2.9 2.9-2.1 2.1-2.9-2.9c-0.2 0.5-0.3 1-0.3 1.6 0 2.2 1.8 4 4 4 0.6 0 1.1-0.1 1.6-0.3l7.8 7.8c0.6 0.6 1.5 0.6 2.1 0s0.6-1.5 0-2.1zM6.8 7.6l-1.4-1.4 0.9-0.9 1.4 1.4-0.9 0.9zM14.2 15c-0.4 0-0.8-0.3-0.8-0.8 0-0.4 0.3-0.8 0.8-0.8s0.8 0.3 0.8 0.8c0 0.5-0.3 0.8-0.8 0.8z"></path></g>
<g id="vaadin:youtube-square"><path d="M7.9 6c0.2 0 0.3-0.2 0.3-0.5v-1.4c0-0.3-0.1-0.5-0.3-0.5s-0.3 0.2-0.3 0.5v1.4c0 0.3 0.1 0.5 0.3 0.5z"></path><path d="M7.1 11.9c-0.1 0.2-0.3 0.3-0.4 0.3s-0.1 0-0.1-0.1c0 0 0-0.1 0-0.2v-2.5h-0.6v2.6c0 0.2 0 0.4 0.1 0.5 0.1 0.2 0.2 0.2 0.4 0.2s0.4-0.1 0.7-0.4v0.4h0.6v-3.3h-0.7v2.5z"></path><path d="M3.8 8.9h0.7v3.8h0.7v-3.8h0.7v-0.7h-2.1z"></path><path d="M9.4 9.3c-0.2 0-0.4 0.2-0.6 0.4v-1.5h-0.6v4.4h0.6v-0.3c0.2 0.2 0.4 0.4 0.6 0.4s0.4-0.1 0.5-0.4c0-0.1 0.1-0.4 0.1-0.7v-1.3c0-0.3 0-0.5-0.1-0.7-0.1-0.1-0.2-0.3-0.5-0.3zM9.4 11.7c0 0.3-0.1 0.4-0.3 0.4-0.1 0-0.2 0-0.3-0.1v-2c0.1-0.1 0.2-0.1 0.3-0.1 0.2 0 0.3 0.2 0.3 0.5v1.3z"></path><path d="M11.3 9.3c-0.3 0-0.5 0.1-0.7 0.3-0.1 0.2-0.2 0.4-0.2 0.8v1.2c0 0.4 0.1 0.6 0.2 0.8 0.2 0.2 0.4 0.3 0.7 0.3s0.6-0.1 0.7-0.4c0.1-0.1 0.1-0.2 0.1-0.4 0-0.1 0-0.2 0-0.4v-0.1h-0.6c0 0.2 0 0.4 0 0.4 0 0.2-0.1 0.2-0.3 0.2s-0.3-0.2-0.3-0.5v-0.6h1.2v-0.7c0-0.4-0.1-0.6-0.2-0.8 0 0.1-0.3-0.1-0.6-0.1zM11.6 10.6h-0.6v-0.3c0-0.3 0.1-0.5 0.3-0.5s0.3 0.2 0.3 0.5v0.3z"></path><path d="M0 0v16h16v-16h-16zM9.3 3.1h0.6v2.5c0 0.1 0 0.2 0 0.2 0 0.1 0 0.2 0.1 0.2s0.2-0.1 0.4-0.3v-2.6h0.6v3.3h-0.6v-0.3c-0.2 0.3-0.5 0.4-0.7 0.4s-0.3-0.1-0.4-0.2c0-0.1-0.1-0.3-0.1-0.5v-2.7zM7 4.2c0-0.3 0-0.6 0.2-0.8s0.4-0.3 0.7-0.3c0.3 0 0.5 0.1 0.7 0.3 0.1 0.2 0.2 0.4 0.2 0.8v1.2c0 0.4-0.1 0.6-0.2 0.8-0.2 0.2-0.4 0.3-0.7 0.3s-0.5-0.1-0.7-0.3c-0.2-0.2-0.2-0.4-0.2-0.8v-1.2zM5.3 2l0.5 1.8 0.5-1.8h0.7l-0.8 2.7v1.8h-0.7v-1.8c-0.1-0.4-0.2-0.8-0.4-1.5-0.2-0.4-0.3-0.8-0.5-1.2h0.7zM12.8 12.9c-0.1 0.5-0.6 0.9-1.1 1-1.2 0.1-2.5 0.1-3.7 0.1s-2.5 0-3.7-0.1c-0.5-0.1-1-0.4-1.1-1-0.2-0.8-0.2-1.6-0.2-2.4 0-0.7 0-1.5 0.2-2.3 0.1-0.5 0.6-0.9 1.1-1 1.2-0.1 2.5-0.1 3.7-0.1s2.5 0 3.7 0.1c0.5 0.1 1 0.4 1.1 1 0.2 0.8 0.2 1.6 0.2 2.3 0 0.8 0 1.6-0.2 2.4z"></path></g>
<g id="vaadin:youtube"><path d="M6.6 0h-0.9l-0.6 2.3-0.6-2.3h-1c0.2 0.6 0.4 1.1 0.6 1.7 0.3 0.8 0.5 1.5 0.5 1.9v2.4h0.9v-2.4l1.1-3.6zM9 4.5v-1.5c0-0.5-0.1-0.8-0.3-1.1s-0.5-0.4-0.9-0.4c-0.4 0-0.7 0.2-0.9 0.5-0.2 0.2-0.3 0.5-0.3 1v1.6c0 0.5 0.1 0.8 0.3 1 0.2 0.3 0.5 0.4 0.9 0.4s0.7-0.2 0.9-0.5c0.2-0.1 0.3-0.5 0.3-1zM8.2 4.7c0 0.4-0.1 0.6-0.4 0.6s-0.4-0.2-0.4-0.6v-1.9c0-0.4 0.1-0.6 0.4-0.6s0.4 0.2 0.4 0.6v1.9zM12 6v-4.5h-0.8v3.4c-0.2 0.3-0.3 0.4-0.5 0.4-0.1 0-0.2-0.1-0.2-0.2 0 0 0-0.1 0-0.3v-3.3h-0.8v3.5c0 0.3 0 0.5 0.1 0.7 0 0.2 0.2 0.3 0.5 0.3s0.6-0.2 0.9-0.5v0.5h0.8z"></path><path d="M12.4 10.5c-0.3 0-0.4 0.2-0.4 0.6v0.4h0.8v-0.4c0-0.4-0.1-0.6-0.4-0.6z"></path><path d="M9.5 10.5c-0.1 0-0.3 0.1-0.4 0.2v2.7c0.1 0.1 0.3 0.2 0.4 0.2 0.2 0 0.3-0.2 0.3-0.6v-1.9c0-0.4-0.1-0.6-0.3-0.6z"></path><path d="M14.4 8.3c-0.2-0.7-0.8-1.3-1.4-1.3-1.6-0.2-3.3-0.2-5-0.2s-3.3 0-5 0.2c-0.6 0-1.2 0.6-1.4 1.3-0.2 1-0.2 2.1-0.2 3.1s0 2.1 0.2 3.1c0.2 0.7 0.7 1.2 1.4 1.3 1.7 0.2 3.3 0.2 5 0.2s3.3 0 5-0.2c0.7-0.1 1.3-0.6 1.4-1.3 0.2-1 0.2-2.1 0.2-3.1s0-2.1-0.2-3.1zM5.2 9.2h-1v5.1h-0.9v-5.1h-0.9v-0.9h2.8v0.9zM7.6 14.3h-0.8v-0.5c-0.3 0.4-0.6 0.5-0.9 0.5s-0.4-0.1-0.5-0.3c0-0.1-0.1-0.3-0.1-0.7v-3.5h0.8v3.2c0 0.2 0 0.3 0 0.3 0 0.1 0.1 0.2 0.2 0.2 0.2 0 0.3-0.1 0.5-0.4v-3.3h0.8v4.5zM10.6 12.9c0 0.4 0 0.7-0.1 0.9-0.1 0.3-0.3 0.5-0.6 0.5s-0.6-0.2-0.8-0.5v0.4h-0.8v-5.9h0.8v1.9c0.3-0.3 0.5-0.5 0.8-0.5s0.5 0.2 0.6 0.5c0.1 0.2 0.1 0.5 0.1 0.9v1.8zM13.6 12.2h-1.6v0.8c0 0.4 0.1 0.6 0.4 0.6 0.2 0 0.3-0.1 0.4-0.3 0 0 0-0.2 0-0.5h0.8v0.1c0 0.3 0 0.4 0 0.5 0 0.2-0.1 0.3-0.2 0.5-0.2 0.3-0.5 0.5-1 0.5-0.4 0-0.7-0.2-1-0.5-0.2-0.2-0.3-0.6-0.3-1v-1.5c0-0.5 0.1-0.8 0.2-1 0.2-0.3 0.5-0.5 1-0.5 0.4 0 0.7 0.2 0.9 0.5 0.2 0.2 0.2 0.6 0.2 1v0.8z"></path></g>
</defs></svg>
</vaadin-iconset>`;
document.head.appendChild($619d9b84df729be9$var$template.content);

});


parcelRegister("f2F8e", function(module, exports) {

$parcel$export(module.exports, "InfoCardComponent", () => $b7ff95d0aa8e2e8f$export$cee3e21998f2e50e);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $deWeK = parcelRequire("deWeK");

var $a7yas = parcelRequire("a7yas");

var $6ppqI = parcelRequire("6ppqI");

var $4TeKW = parcelRequire("4TeKW");

var $g5fNy = parcelRequire("g5fNy");

var $7n7fg = parcelRequire("7n7fg");
const $b7ff95d0aa8e2e8f$var$style = (0, $4TeKW.css)`
  ${(0, $a7yas.projectSharedCss)}
  ${(0, $7n7fg.MaterialBoxCSS)}

p {
    margin-top: 0px;
    margin-bottom: 5px;
  }
  p.size-13 {
    font-size: 13px;
  }

  .profile-information {
    font-size: 13px;
    color: #0e0e0e;
    font-weight: bold;
    margin-left: 10px;
  }

  .profile-information-container {
    width: auto;
    color: #0e0e0e;
    font-size: 14px;
  }
`;
class $b7ff95d0aa8e2e8f$export$cee3e21998f2e50e extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.infoItems = (0, $g5fNy.of)([]);
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        attribute: false
    })
], $b7ff95d0aa8e2e8f$export$cee3e21998f2e50e.prototype, "infoItems", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $b7ff95d0aa8e2e8f$export$cee3e21998f2e50e.prototype, "title", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $b7ff95d0aa8e2e8f$export$cee3e21998f2e50e.prototype, "text", void 0);
$b7ff95d0aa8e2e8f$export$cee3e21998f2e50e = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'info-card-component',
        style: $b7ff95d0aa8e2e8f$var$style,
        modifiers: [
            ...(0, $6ppqI.TranslateModifiers)
        ],
        template () {
            return (0, $4TeKW.html)`
      <card-component>
        <div style="padding: 20px;margin-bottom: 20px;">
          <span style="color: #32435d; font-weight: bold" translate>${this.text ? this.text : this.title}</span>
          <spacer-component></spacer-component>
          <rx-monad>
            <rx-state .value=${this.infoItems}></rx-state>
            <rx-style .value=${$b7ff95d0aa8e2e8f$var$style}></rx-style>
            <rx-render
              .state=${(infoItems)=>(0, $4TeKW.html)`
                <bootstrap-component></bootstrap-component>
                ${infoItems.map((i)=>(0, $4TeKW.html)`
                    <div class="size-13" style="margin-top: 10px;">
                      <div class="flex">
                        <div class="profile-information-container">${i.key}</div>
                        <div class="profile-information">${i.value}</div>
                        <span class="spacer"></span>
                      </div>
                    </div>
                  `)}
              `}
            ></rx-render>
          </rx-monad>
          <slot></slot>
        </div>
      </card-component>
    `;
        }
    })
], $b7ff95d0aa8e2e8f$export$cee3e21998f2e50e);

});

parcelRegister("kTORu", function(module, exports) {

$parcel$export(module.exports, "InfoMenuComponent", () => $6a46ec7c2e7df528$export$6fc9ae62ca0c80b8);

var $deWeK = parcelRequire("deWeK");

var $6ppqI = parcelRequire("6ppqI");

var $613YX = parcelRequire("613YX");

var $4TeKW = parcelRequire("4TeKW");

var $cdTWx = parcelRequire("cdTWx");

var $a6joW = parcelRequire("a6joW");
class $6a46ec7c2e7df528$export$6fc9ae62ca0c80b8 extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.menus = [];
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $6a46ec7c2e7df528$export$6fc9ae62ca0c80b8.prototype, "menus", void 0);
$6a46ec7c2e7df528$export$6fc9ae62ca0c80b8 = (0, $deWeK.__decorate)([
    (0, $613YX.Component)({
        Settings: {
            selector: 'info-menu',
            modifiers: [
                ...(0, $6ppqI.TranslateModifiers)
            ],
            style: (0, $4TeKW.css)`
      .container {
        width: 100%;
      }
      h3 {
        color: hsl(0deg 0% 80%);
        text-align: left;
        font-weight: 100;
      }
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        text-align: left;
      }

      li {
        /* padding: 20px; */
        padding-left: 0px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.03);
        font-weight: 100;
      }
      .flex {
        display: flex;
      }
      .spacer {
        flex: 1 3 auto;
      }

      .arrow {
        border: solid black;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 6px;
      }

      .absolute {
        position: absolute;
      }

      .down {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }

      .options {
        cursor: pointer;
        user-select: none;
        padding: 15px;
      }

      .options:hover {
        background: rgba(0, 0, 0, 0.03);
      }

      .title {
        padding: 15px 15px 15px 0px;
      }

      .arrow-container {
        padding-right: 15px;
      }
      ${(0, $a6joW.DropdownCSS)}
    `
        },
        State () {
            return (0, $cdTWx.combineLatest)([
                ...this.menus.map((m)=>m())
            ]);
        },
        Render: ()=>(state)=>{
                return (0, $4TeKW.html)`
      <ul class="container">
        ${state?.map((template)=>(0, $4TeKW.html)`
            <li>
              <div class="flex">${template}</div>
            </li>
          `)}
      </ul>
    `;
            }
    })
], $6a46ec7c2e7df528$export$6fc9ae62ca0c80b8);

});
parcelRegister("a6joW", function(module, exports) {

$parcel$export(module.exports, "DropdownCSS", () => $144c084c43915027$export$1fd6e39e81c43591);

var $4TeKW = parcelRequire("4TeKW");
const $144c084c43915027$export$1fd6e39e81c43591 = (0, $4TeKW.css)`
  /* The container <div> - needed to position the dropdown content */
  .dropdown {
    position: relative;
    display: inline-block;
  }

  /* Dropdown Content (Hidden by Default) */
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  /* Links inside the dropdown */
  .dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }

  /* Change color of dropdown links on hover */
  .dropdown-content a:hover {
    background-color: #f1f1f1;
  }

  /* Show the dropdown menu on hover */
  .dropdown:hover .dropdown-content {
    display: block;
  }

  /* Change the background color of the dropdown button when the dropdown content is shown */
  .dropdown:hover .dropbtn {
    background-color: #3e8e41;
  }
`;

});


parcelRegister("1Vpee", function(module, exports) {

$parcel$export(module.exports, "InfoHeaderCardComponent", () => $2fc37af1e180dee6$export$b889d47a8c0e9fa4);

var $deWeK = parcelRequire("deWeK");

var $a7yas = parcelRequire("a7yas");

var $be29e = parcelRequire("be29e");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $1MQ4j = parcelRequire("1MQ4j");

var $aNZtz = parcelRequire("aNZtz");

var $3Hrul = parcelRequire("3Hrul");

var $2nhTq = parcelRequire("2nhTq");

var $7n7fg = parcelRequire("7n7fg");
function $2fc37af1e180dee6$var$dataURLtoBlob(dataurl) {
    const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while(n--)u8arr[n] = bstr.charCodeAt(n);
    return new Blob([
        u8arr
    ], {
        type: mime
    });
}
function $2fc37af1e180dee6$var$blobToDataURL(blob, callback) {
    const a = new FileReader();
    a.onload = function(e) {
        callback(e.target.result);
    };
    a.readAsDataURL(blob);
}
class $2fc37af1e180dee6$export$b889d47a8c0e9fa4 extends (0, $4TeKW.LitElement) {
    OnInit() {
    // const user = firebase.auth().currentUser;
    // const storageRef = firebase.storage().ref(user.email + '/profile/' + 'file.name');
    // debugger;
    // storageRef.put(new Blob());
    }
    constructor(...args){
        super(...args), this.infoItems = [], this.photoWidth = '100px', this.photoRadius = '85px', this.styleContainer = '';
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $2fc37af1e180dee6$export$b889d47a8c0e9fa4.prototype, "headerTitle", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $2fc37af1e180dee6$export$b889d47a8c0e9fa4.prototype, "infoItems", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $2fc37af1e180dee6$export$b889d47a8c0e9fa4.prototype, "photoURL", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $2fc37af1e180dee6$export$b889d47a8c0e9fa4.prototype, "photoWidth", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $2fc37af1e180dee6$export$b889d47a8c0e9fa4.prototype, "photoRadius", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $2fc37af1e180dee6$export$b889d47a8c0e9fa4.prototype, "styleContainer", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $be29e.UserService))
], $2fc37af1e180dee6$export$b889d47a8c0e9fa4.prototype, "userService", void 0);
$2fc37af1e180dee6$export$b889d47a8c0e9fa4 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'info-header-card-component',
        style: (0, $4TeKW.css)`
    ${(0, $a7yas.projectSharedCss)}
    ${(0, $7n7fg.MaterialBoxCSS)}

    p {
      margin-top: 0px;
      margin-bottom: 5px;
    }
    p.size-13 {
      font-size: 13px;
    }

    .profile-information {
      font-size: 13px;
      color: #0e0e0e;
      font-weight: bold;
    }

    .profile-information-container {
      width: 100px;
      color: #0e0e0e;
      font-size: 14px;
    }
    .info-header-container {
      padding: 20px;
      margin-top: 0px;
    }

    .info-header-container .title {
      font-size: 22px;
      font-weight: bold;
      color: #324044;
    }

    .image {
      cursor: pointer;
    }
    .image:hover {
      opacity: 0.7;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <card-component>
        <div class="flex">
          <label class="image">
            <file-uploader
              .acceptsMultipleFiles=${false}
              @filesDropped=${async (e)=>{
                if (e.detail.length > 1) (0, $2nhTq.error)('Please select only one image');
                const imageResize = new (0, $aNZtz.default)({
                    format: 'png',
                    width: 100,
                    height: 100
                });
                const file = await imageResize.play(e.detail[0]);
                const user = $1MQ4j.auth().currentUser;
                const storageRef = $1MQ4j.storage().ref(`/profile/${user.uid}.${e.detail[0].name.split('.')[1]}`);
                storageRef.put($2fc37af1e180dee6$var$dataURLtoBlob(file));
                const photoURL = await storageRef.getDownloadURL();
                await user.updateProfile({
                    photoURL: photoURL
                });
                await (0, $3Hrul.firstValueFrom)(this.userService.updateProfile({
                    photoURL: photoURL
                }));
                this.photoURL = photoURL;
            }}
            >
              ${this.photoURL ? (0, $4TeKW.html)`
                    <div>
                      <img
                        style=${(0, $4TeKW.styleMap)({
                'border-radius': this.photoRadius,
                width: this.photoWidth,
                height: this.photoWidth,
                padding: '15px'
            })}
                        src=${this.photoURL}
                      />
                    </div>
                  ` : (0, $4TeKW.html)` <slot></slot> `}
            </file-uploader>
          </label>
          <div class="info-header-container" style=${this.styleContainer}>
            <p class="title">${this.headerTitle}</p>
            ${this.infoItems.length ? (0, $4TeKW.html)` ${this.infoItems.map((i)=>(0, $4TeKW.html)` <p class="size-13">${i}</p> `)} ` : (0, $4TeKW.html)` <slot name="items"></slot> `}
          </div>
        </div>
      </card-component>
    `;
        }
    })
], $2fc37af1e180dee6$export$b889d47a8c0e9fa4);

});
parcelRegister("aNZtz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dde2ad555c88f02$export$2e2bcd8739ae039);
const $7dde2ad555c88f02$var$D = {
    quality: 0.75,
    format: "jpg",
    // png,jpg,webp
    outputType: "base64",
    // base64,canvas,blob
    width: 320,
    height: null,
    reSample: 2,
    bgColor: "#ffffff",
    sharpen: 0
};
function $7dde2ad555c88f02$var$b(a = 320, t = 240, e = "#ffffff") {
    this.el = document.createElement("canvas"), this.ctx = this.el.getContext("2d"), this.el.width = a, this.el.height = t, this.ctx.fillStyle = e, this.ctx.fillRect(0, 0, a, t);
}
const $7dde2ad555c88f02$var$M = {
    canvas: null,
    reSample: 2,
    width: 320,
    height: 240,
    cx: 0,
    cy: 0,
    cw: 0,
    ch: 0,
    dx: 0,
    dy: 0,
    dw: 0,
    dh: 0,
    bgColor: "#ffffff"
};
function $7dde2ad555c88f02$var$q(a, t, e) {
    return new Promise((r)=>{
        function n(i, c) {
            const l = Math.pow(2, i);
            let h = new $7dde2ad555c88f02$var$b(a.width * l, a.height * l, a.bgColor);
            h.ctx.drawImage(c, 0, 0, c.width * 0.5, c.height * 0.5), i > 0 ? n(i - 1, h.el) : r(h.el);
        }
        n(t - 1, e);
    });
}
function $7dde2ad555c88f02$var$P(a) {
    a = Object.assign({}, $7dde2ad555c88f02$var$M, a), a.reSample = Math.min(4, a.reSample), a.reSample = Math.max(0, a.reSample);
    const t = Math.pow(2, a.reSample);
    return new Promise(function(e, r) {
        try {
            const n = new $7dde2ad555c88f02$var$b(a.width * t, a.height * t, a.bgColor);
            n.ctx.drawImage(a.canvas, a.cx, a.cy, a.cw, a.ch, a.dx * t, a.dy * t, a.dw * t, a.dh * t), a.reSample > 0 ? $7dde2ad555c88f02$var$q(a, a.reSample, n.el).then(e) : e(n.el);
        } catch (n) {
            r(n);
        }
    });
}
function $7dde2ad555c88f02$var$A(a, t = "image/jpeg", e = 0.75) {
    return t = $7dde2ad555c88f02$var$j(t), new Promise(function(r, n) {
        try {
            const i = a.toDataURL(t, e);
            r(i);
        } catch (i) {
            n(i);
        }
    });
}
function $7dde2ad555c88f02$var$B(a, t = "image/jpeg", e = 0.75) {
    return t = $7dde2ad555c88f02$var$j(t), new Promise(function(r, n) {
        try {
            const i = a.toDataURL(t, e), c = $7dde2ad555c88f02$var$L(i);
            r(c);
        } catch (i) {
            n(i);
        }
    });
}
function $7dde2ad555c88f02$var$j(a) {
    let t;
    switch(a){
        case "jpg":
        case "jpeg":
            t = "image/jpeg";
            break;
        case "png":
            t = "image/png";
            break;
        case "webp":
            t = "image/webp";
            break;
        default:
            t = a;
            break;
    }
    return t;
}
function $7dde2ad555c88f02$var$L(a) {
    const t = atob(a.split(",")[1]), e = a.split(",")[0].split(":")[1].split(";")[0], r = new ArrayBuffer(t.length);
    let n = new Uint8Array(r);
    for(let c = 0; c < t.length; c++)n[c] = t.charCodeAt(c);
    const i = new DataView(r);
    return new Blob([
        i
    ], {
        type: e
    });
}
function $7dde2ad555c88f02$var$k(a, t, e) {
    const r = a.data, n = t.data, i = a.width, c = a.height, l = Math.round(Math.sqrt(e.length)), h = Math.floor(l / 2), p = i, R = c;
    for(let u = 0; u < R; u++)for(let f = 0; f < p; f++){
        let S = 0, C = 0, I = 0, N = 0;
        for(let o = 0; o < l; o++)for(let d = 0; d < l; d++){
            const y = u + o - h, x = f + d - h;
            if (y >= 0 && y < c && x >= 0 && x < i) {
                let g = (y * i + x) * 4, m = e[o * l + d];
                S += r[g] * m, C += r[g + 1] * m, I += r[g + 2] * m, N += r[g + 3] * m;
            }
        }
        const w = (u * p + f) * 4;
        n[w] = S, n[w + 1] = C, n[w + 2] = I, n[w + 3] = N;
    }
    return t;
}
function $7dde2ad555c88f02$var$E(a, t = 0) {
    if (t <= 0) return a;
    const e = document.createElement("canvas");
    e.width = a.width, e.height = a.height;
    const r = e.getContext("2d");
    r.drawImage(a, 0, 0);
    const n = r.getImageData(0, 0, e.width, e.height), i = r.createImageData(e.width, e.height), c = $7dde2ad555c88f02$var$k(n, i, [
        0,
        -1,
        0,
        -1,
        5,
        -1,
        0,
        -1,
        0
    ]);
    r.putImageData(c, 0, 0);
    const l = a.getContext("2d");
    return l.globalAlpha = t || 1, l.drawImage(e, 0, 0), a;
}
function $7dde2ad555c88f02$var$F(a) {
    return new Promise((t, e)=>{
        const r = new FileReader();
        r.onload = (n)=>{
            var i;
            return t((i = n.target) == null ? void 0 : i.result);
        }, r.onerror = e, r.readAsDataURL(a);
    });
}
function $7dde2ad555c88f02$var$z(a) {
    return new Promise((t, e)=>{
        const r = new Image();
        r.onload = ()=>t(r), r.onerror = e, r.src = a, r.crossOrigin = "anonymous", r.alt = "";
    });
}
function $7dde2ad555c88f02$var$s(a = {}, t = {}) {
    let e = {};
    return Object.keys(a).forEach((r)=>{
        e[r] = t[r] || a[r];
    }), e.width = Number(e.width), e.height = Number(e.height), e.quality = Number(e.quality), e.reSample = Number(e.reSample), e;
}
async function $7dde2ad555c88f02$var$T(a, t) {
    let e;
    const r = await $7dde2ad555c88f02$var$z(a);
    return e = new $7dde2ad555c88f02$var$b(r.width, r.height, t.bgColor), e.ctx.drawImage(r, 0, 0), e.el;
}
async function $7dde2ad555c88f02$var$O(a, t) {
    const e = await $7dde2ad555c88f02$var$F(a), r = await $7dde2ad555c88f02$var$z(e);
    let n = new $7dde2ad555c88f02$var$b(r.width, r.height, t.bgColor);
    return n.ctx.drawImage(r, 0, 0), n.el;
}
function $7dde2ad555c88f02$var$U(a, t, e, r) {
    let n = a, i = t;
    return e && r && (e > r ? r = void 0 : e = void 0), e ? (n = e, i = t * (e / a)) : r && (n = a * (r / t), i = r), {
        width: Number(n),
        height: Number(i)
    };
}
class $7dde2ad555c88f02$export$2e2bcd8739ae039 {
    /**
   * constructor
   *
   * @param {object} getOptions
   */ constructor(t = {}){
        this.options = $7dde2ad555c88f02$var$s($7dde2ad555c88f02$var$D, t);
    }
    /**
   * Play convert
   * 이미지 변환 실행
   * 이미지 주소로 캔버스로 변환 -> 캔버스를 리사이즈 -> 이미지로 컨버트
   *
   * @param {string|HTMLInputElement|File|Blob} src
   * @return {Promise<string>}
   */ async play(t) {
        let e = await this.get(t);
        return e = await this.resize(e), e = await this.sharpen(e), e = await this.output(e), e;
    }
    /**
   * Get source
   *
   * @param {string|HTMLInputElement|File|Blob} src
   * @param {object} options
   * @return {Promise<HTMLCanvasElement>}
   */ async get(t, e) {
        var r;
        if (e = e ? $7dde2ad555c88f02$var$s(this.options, e) : this.options, typeof t == "string") return await $7dde2ad555c88f02$var$T(t, e);
        if (t instanceof File || t instanceof Blob) return await $7dde2ad555c88f02$var$O(t, e);
        if (((r = t.tagName) == null ? void 0 : r.toLowerCase()) === "input" && t.type === "file") return await $7dde2ad555c88f02$var$O(t.files[0], e);
        throw new Error("Not found source");
    }
    /**
   * Resize canvas
   *
   * @param {HTMLCanvasElement} canvas
   * @param {object} options
   * @return {Promise<HTMLCanvasElement>}
   */ async resize(t, e) {
        e = e ? $7dde2ad555c88f02$var$s(this.options, e) : this.options;
        let r = $7dde2ad555c88f02$var$U(t.width, t.height, e.width, e.height);
        return await $7dde2ad555c88f02$var$P({
            canvas: t,
            reSample: e.reSample,
            width: r.width,
            height: r.height,
            cx: 0,
            cy: 0,
            cw: t.width,
            ch: t.height,
            dx: 0,
            dy: 0,
            dw: r.width,
            dh: r.height,
            bgColor: e.bgColor
        });
    }
    sharpen(t, e) {
        return e = isNaN(e) ? this.options.sharpen : e, $7dde2ad555c88f02$var$E(t, e);
    }
    /**
   * Output data
   *
   * @param {HTMLCanvasElement} canvas
   * @param {object} options
   * @return {Promise}
   */ async output(t, e) {
        switch(e = e ? $7dde2ad555c88f02$var$s(this.options, e) : this.options, e.outputType){
            case "base64":
                return await $7dde2ad555c88f02$var$A(t, e.format, e.quality);
            case "blob":
                return await $7dde2ad555c88f02$var$B(t, e.format, e.quality);
            case "canvas":
            default:
                return t;
        }
    }
    /**
   * Update options
   *
   * @param {object} value
   * @return {ImageResize}
   */ updateOptions(t) {
        return this.options = $7dde2ad555c88f02$var$s(this.options, t), this;
    }
}

});


parcelRegister("59th2", function(module, exports) {

$parcel$export(module.exports, "InformationComponent", () => $536a9adbaf42b298$export$62b63df9cd10b947);

var $deWeK = parcelRequire("deWeK");

var $c7gF1 = parcelRequire("c7gF1");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");
class $536a9adbaf42b298$export$62b63df9cd10b947 extends (0, $4TeKW.LitElement) {
    OnUpdate() {
        const slot = this.shadowRoot.querySelector('slot');
        if (!this.text) {
            const nodes = slot.assignedNodes();
            this.text = nodes[0].textContent;
        }
        if (slot) slot.remove();
    }
    openPortal() {
        const rect = this.getBoundingClientRect();
        this.portal.attach((0, $4TeKW.html)`<div
        style="font-size: 12px; line-height: 18px; color: black; background: rgb(255, 255, 255); box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 2px 1px -1px; max-height: 384px; max-width: 384px; overflow-y: auto; padding: 16px;"
      >
        ${this.text}
      </div>`, {
            left: rect.x + window.scrollX + 10,
            top: rect.y + window.scrollY + 10
        });
    }
    closePortal() {
        this.portal.dettach();
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $c7gF1.PortalProvider))
], $536a9adbaf42b298$export$62b63df9cd10b947.prototype, "portal", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $536a9adbaf42b298$export$62b63df9cd10b947.prototype, "text", void 0);
$536a9adbaf42b298$export$62b63df9cd10b947 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'rx-info',
        template () {
            return (0, $4TeKW.html)`
      <slot></slot>
      <svg
        @mouseover=${()=>{
                this.openPortal();
            }}
        @mouseout=${()=>{
                this.closePortal();
            }}
        width="1.5em"
        height="1.5em"
        viewBox="0 0 18 18"
        fit=""
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        sandboxuid="0"
      >
        <path
          d="M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm2.47-7.587a5.15 5.15 0 0 1-.548.61c-.206.195-.42.387-.64.578-.25.22-.418.37-.503.62-.09.26-.13.78-.14.78H8.08s.02-.48.06-.71a2.09 2.09 0 0 1 .19-.57c.09-.18.207-.34.348-.5A6.1 6.1 0 0 1 9.2 8.7c.156-.14.3-.268.436-.393s.253-.25.356-.382c.103-.13.184-.27.244-.42.06-.147.09-.312.09-.493 0-.4-.106-.702-.32-.913-.21-.21-.524-.32-.936-.32-.165 0-.93-.04-1.2.49-.075.142-.187.49-.187.68H6c.072-.598.178-.91.33-1.21.155-.308.366-.49.633-.7.267-.206.58-.33.94-.43.36-.105.75-.14 1.172-.14.463 0 .874.06 1.236.172.37.11.67.275.92.487.26.21.45.474.58.78.13.305.2.652.2 1.04 0 .28-.042.54-.14.78a2.81 2.81 0 0 1-.383.68zM8.997 14c-.32 0-.565-.094-.738-.284a1.006 1.006 0 0 1-.26-.704c0-.143.02-.276.06-.4a.923.923 0 0 1 .19-.32.868.868 0 0 1 .31-.215A1.11 1.11 0 0 1 8.99 12c.16 0 .3.026.426.077a.83.83 0 0 1 .312.215c.084.09.15.198.196.32.046.124.07.256.07.4 0 .28-.087.516-.26.704-.175.19-.42.284-.74.284z"
          fill-rule="evenodd"
          sandboxuid="0"
        ></path>
      </svg>
    `;
        }
    })
], $536a9adbaf42b298$export$62b63df9cd10b947);

});

parcelRegister("3v6ni", function(module, exports) {

$parcel$export(module.exports, "ModalDialogComponent", () => $e3a6214e2cf0bb28$export$7d025d716a74fac);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $3dOhR = parcelRequire("3dOhR");

var $g5zfD = parcelRequire("g5zfD");
class $e3a6214e2cf0bb28$export$7d025d716a74fac extends (0, $4TeKW.LitElement) {
    OnInit() {
        this.modalObservable.subscribe();
    }
    onClose() {
        this.showModal = false;
    }
    constructor(...args){
        super(...args), this.showModal = false, this.width = '50%', this.marginTop = '10%', this.closeOnOutsideClick = false, this.modalObservable = this.modalService.modalOpened.pipe((0, $3dOhR.tap)((opened)=>{
            if (opened) this.showModal = true;
            else this.showModal = false;
        })), this.modalTemplate = this.modalService.template;
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $e3a6214e2cf0bb28$export$7d025d716a74fac.prototype, "showModal", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $e3a6214e2cf0bb28$export$7d025d716a74fac.prototype, "width", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $e3a6214e2cf0bb28$export$7d025d716a74fac.prototype, "marginTop", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $e3a6214e2cf0bb28$export$7d025d716a74fac.prototype, "closeOnOutsideClick", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $g5zfD.ModalService))
], $e3a6214e2cf0bb28$export$7d025d716a74fac.prototype, "modalService", void 0);
$e3a6214e2cf0bb28$export$7d025d716a74fac = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'modal-dialog-component',
        style: (0, $4TeKW.css)`
    /* The Modal (background) */
    .modal {
      position: fixed; /* Stay in place */
      z-index: 1000; /* Sit on top */
      left: 0;
      top: 0;
      width: 100%; /* Full width */
      height: 100%; /* Full height */
      overflow: auto; /* Enable scroll if needed */
      background-color: rgb(0, 0, 0); /* Fallback color */
      background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

    /* Modal Content/Box */
    .modal-content {
      background-color: #fefefe;
      margin: 0 auto; /* 15% from the top and centered */
      padding: 20px;
      color: black;
      border: 1px solid #888;
      width: 80%; /* Could be more or less, depending on screen size */
    }

    /* The Close Button */
    .close {
      color: #aaa;
      float: right;
      font-size: 28px;
      font-weight: bold;
    }

    .close:hover,
    .close:focus {
      color: black;
      text-decoration: none;
      cursor: pointer;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      ${this.showModal ? (0, $4TeKW.html)`
            <div @click=${()=>this.closeOnOutsideClick ? this.showModal = false : ''} class="modal">
              <!-- Modal content -->
              <div
                class="modal-content"
                style=${(0, $4TeKW.styleMap)({
                width: this.width,
                'margin-top': this.marginTop
            })}
              >
                <span @click=${this.onClose} class="close">&times;</span>
                <div>${(0, $4TeKW.async)(this.modalTemplate)}</div>
                <slot></slot>
              </div>
            </div>
          ` : ''}
    `;
        }
    })
], $e3a6214e2cf0bb28$export$7d025d716a74fac);

});
parcelRegister("g5zfD", function(module, exports) {

$parcel$export(module.exports, "ModalService", () => $0bd5222438a666c0$export$de3e1d2ea3b4fd9b);

var $deWeK = parcelRequire("deWeK");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $bq6Hs = parcelRequire("bq6Hs");
var $4DDzB = parcelRequire("4DDzB");
var $g5fNy = parcelRequire("g5fNy");
var $f16OP = parcelRequire("f16OP");

var $gD6ig = parcelRequire("gD6ig");
class $0bd5222438a666c0$export$de3e1d2ea3b4fd9b {
    showModal(template) {
        if (template) this.template.next(template.getHTML());
        this.modalOpened.next(true);
    }
    closeModal() {
        this.modalOpened.next(false);
    }
    getModalTemplate(template) {
        return (0, $4TeKW.async)(this.modalOpened.pipe((0, $gD6ig.mergeMap)((v)=>(0, $4DDzB.iif)(()=>v, (0, $g5fNy.of)(template), (0, $g5fNy.of)('')))));
    }
    constructor(){
        this.modalOpened = new (0, $f16OP.Subject)();
        this.template = new (0, $bq6Hs.BehaviorSubject)('');
    }
}
$0bd5222438a666c0$export$de3e1d2ea3b4fd9b = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $0bd5222438a666c0$export$de3e1d2ea3b4fd9b);

});


parcelRegister("fUVdo", function(module, exports) {

$parcel$export(module.exports, "MultiSelectComponent", () => $a41f812bdcb905a6$export$da42d82ac5d706);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $deWeK = parcelRequire("deWeK");
parcelRequire("d5ckx");

var $4TeKW = parcelRequire("4TeKW");

var $6LOZI = parcelRequire("6LOZI");
class $a41f812bdcb905a6$export$da42d82ac5d706 extends (0, $4TeKW.LitElement) {
    selectedItemsChanged(e) {
        this.dispatchEvent(new CustomEvent('selectedItemsChanged', {
            detail: e.detail
        }));
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $a41f812bdcb905a6$export$da42d82ac5d706.prototype, "items", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $a41f812bdcb905a6$export$da42d82ac5d706.prototype, "itemLabelPath", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $a41f812bdcb905a6$export$da42d82ac5d706.prototype, "itemIdPath", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $a41f812bdcb905a6$export$da42d82ac5d706.prototype, "label", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $a41f812bdcb905a6$export$da42d82ac5d706.prototype, "name", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $a41f812bdcb905a6$export$da42d82ac5d706.prototype, "selectedItems", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $a41f812bdcb905a6$export$da42d82ac5d706.prototype, "template", void 0);
$a41f812bdcb905a6$export$da42d82ac5d706 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'multi-select-box',
        styles: [
            (0, $4TeKW.css)`
      vaadin-multi-select-combo-box {
        width: 100%;
      }
    `
        ],
        template () {
            return (0, $4TeKW.html)`
      <vaadin-multi-select-combo-box
        name=${this.name}
        label=${this.label}
        .itemLabelPath=${this.itemLabelPath}
        .itemIdPath=${this.itemIdPath}
        @selected-items-changed=${this.selectedItemsChanged}
        .selectedItems=${this.selectedItems}
        .items=${this.items}
        ${(0, $6LOZI.comboBoxRenderer)(this.template)}
      >
      </vaadin-multi-select-combo-box>
    `;
        }
    })
], $a41f812bdcb905a6$export$da42d82ac5d706);

});
parcelRegister("d5ckx", function(module, exports) {
parcelRequire("batHm");
parcelRequire("dMEIK");

});
parcelRegister("batHm", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("fZqXl");
parcelRequire("8WJFj");
parcelRequire("9zdvw");
parcelRequire("4ycUj");
parcelRequire("kse9V");
parcelRequire("dMEIK");

});
parcelRegister("fZqXl", function(module, exports) {
parcelRequire("bpTdN");
parcelRequire("gettf");
parcelRequire("8Fvjg");

var $ceJlW = parcelRequire("ceJlW");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $ba41767240f0341c$var$comboBoxItem = (0, $aOvNQ.css)`
  :host {
    transition: background-color 100ms;
    overflow: hidden;
    --_lumo-item-selected-icon-display: block;
  }

  @media (any-hover: hover) {
    :host([focused]:not([disabled])) {
      box-shadow: inset 0 0 0 2px var(--lumo-primary-color-50pct);
    }
  }
`;
(0, $2vXFS.registerStyles)('vaadin-combo-box-item', [
    (0, $ceJlW.item),
    $ba41767240f0341c$var$comboBoxItem
], {
    moduleId: 'lumo-combo-box-item'
});

});
parcelRegister("ceJlW", function(module, exports) {

$parcel$export(module.exports, "item", () => $8e89f8f80fc5bcd0$export$7061c75fc5af8b7e);
parcelRequire("1IFGF");
parcelRequire("6Yt1B");
parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $8e89f8f80fc5bcd0$export$7061c75fc5af8b7e = (0, $aOvNQ.css)`
  :host {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    font-family: var(--lumo-font-family);
    font-size: var(--lumo-font-size-m);
    line-height: var(--lumo-line-height-xs);
    padding: 0.5em calc(var(--lumo-space-l) + var(--lumo-border-radius-m) / 4) 0.5em
      var(--_lumo-list-box-item-padding-left, calc(var(--lumo-border-radius-m) / 4));
    min-height: var(--lumo-size-m);
    outline: none;
    border-radius: var(--lumo-border-radius-m);
    cursor: var(--lumo-clickable-cursor);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: var(--lumo-primary-color-10pct);
  }

  /* Checkmark */
  [part='checkmark']::before {
    display: var(--_lumo-item-selected-icon-display, none);
    content: var(--lumo-icons-checkmark);
    font-family: lumo-icons;
    font-size: var(--lumo-icon-size-m);
    line-height: 1;
    font-weight: normal;
    width: 1em;
    height: 1em;
    margin: calc((1 - var(--lumo-line-height-xs)) * var(--lumo-font-size-m) / 2) 0;
    color: var(--lumo-primary-text-color);
    flex: none;
    opacity: 0;
    transition: transform 0.2s cubic-bezier(0.12, 0.32, 0.54, 2), opacity 0.1s;
  }

  :host([selected]) [part='checkmark']::before {
    opacity: 1;
  }

  :host([active]:not([selected])) [part='checkmark']::before {
    transform: scale(0.8);
    opacity: 0;
    transition-duration: 0s;
  }

  [part='content'] {
    flex: auto;
  }

  /* Disabled */
  :host([disabled]) {
    color: var(--lumo-disabled-text-color);
    cursor: default;
    pointer-events: none;
  }

  /* TODO a workaround until we have "focus-follows-mouse". After that, use the hover style for focus-ring as well */
  @media (any-hover: hover) {
    :host(:hover:not([disabled])) {
      background-color: var(--lumo-primary-color-10pct);
    }

    :host([focus-ring]:not([disabled])) {
      box-shadow: inset 0 0 0 2px var(--lumo-primary-color-50pct);
    }
  }

  /* RTL specific styles */
  :host([dir='rtl']) {
    padding-left: calc(var(--lumo-space-l) + var(--lumo-border-radius-m) / 4);
    padding-right: var(--_lumo-list-box-item-padding-left, calc(var(--lumo-border-radius-m) / 4));
  }

  /* Slotted icons */
  :host ::slotted(vaadin-icon),
  :host ::slotted(iron-icon) {
    width: var(--lumo-icon-size-m);
    height: var(--lumo-icon-size-m);
  }
`;
(0, $2vXFS.registerStyles)('vaadin-item', $8e89f8f80fc5bcd0$export$7061c75fc5af8b7e, {
    moduleId: 'lumo-item'
});

});
parcelRegister("1IFGF", function(module, exports) {
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("pFadI");
const $140a3cb18f593fb7$var$template = document.createElement('template');
$140a3cb18f593fb7$var$template.innerHTML = `
  <style>
    @font-face {
      font-family: 'lumo-icons';
      src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAABEgAAsAAAAAIjQAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABHU1VCAAABCAAAADsAAABUIIslek9TLzIAAAFEAAAAQwAAAFZAIUuKY21hcAAAAYgAAAD4AAADrsCU8d5nbHlmAAACgAAAC2cAABeAWri7U2hlYWQAAA3oAAAAMAAAADZa/6SsaGhlYQAADhgAAAAdAAAAJAbpA35obXR4AAAOOAAAABAAAACspBAAAGxvY2EAAA5IAAAAWAAAAFh57oA4bWF4cAAADqAAAAAfAAAAIAFKAXBuYW1lAAAOwAAAATEAAAIuUUJZCHBvc3QAAA/0AAABKwAAAelm8SzVeJxjYGRgYOBiMGCwY2BycfMJYeDLSSzJY5BiYGGAAJA8MpsxJzM9kYEDxgPKsYBpDiBmg4gCACY7BUgAeJxjYGS+yDiBgZWBgamKaQ8DA0MPhGZ8wGDIyAQUZWBlZsAKAtJcUxgcXjG+0mIO+p/FEMUcxDANKMwIkgMABn8MLQB4nO3SWW6DMABF0UtwCEnIPM/zhLK8LqhfXRybSP14XUYtHV9hGYQwQBNIo3cUIPkhQeM7rib1ekqnXg981XuC1qvy84lzojleh3puxL0hPjGjRU473teloEefAUNGjJkwZcacBUtWrNmwZceeA0dOnLlw5cadB09elPGhGf+j0NTI/65KfXerT6JhqKnpRKtgOpuqaTrtKjPUlqHmhto21I7pL6i6hlqY3q7qGWrfUAeGOjTUkaGODXViqFNDnRnq3FAXhro01JWhrg11Y6hbQ90Z6t5QD4Z6NNSToZ4N9WKoV0O9GerdUB+G+jTUl6GWRvkL24BkEXictVh9bFvVFb/nxvbz+7Rf/N6zHcd2bCfP+Wic1Z9N0jpNHCD9SNqqoVBgbQoMjY+pjA4hNnWa2pV1rHSIif0DGkyT2k10Kmu1Cag6huj4ZpqYBHSqJsTEJgZCG3TaVBFv595nO3ZIv4RIrPPuvefe884599zzO/cRF8G/tgn6CFFImNgkR0ggX8wlspbhSSWSdrC5ozd30s2dw5afzvgtyz9/zG9t1hV4RtF1pXolowvtzc2z6L2aYUQM45jKH9WDTvd1LRDoDASYWhfTzTyvboXz6uZX4ARX5wrF39y+HM2+CJ8d0pkyqBIqoze3D12ez4DrFoYzxI8dWwMrDlZ2DMqQAR9AROsJU+2smlTPaTTco52BVxXa2a2+I8vvqd2dVHm1LoPeTn/AZPRYGthDYOeZjBjKoFsVGulR3lGU95SeCK44oHU7MhWUGUKZDT3oSUcG2GWuh+EDDfUYA/jhIhl0TOsJNYSEu7mQmi3UzfXwZKA4BsVsHLXQYGgJW95qEtpJ1VcW9HiTriZBlFEqxsDjA09yCNUoQxxwd7KWSTt2y3GTKifkqHRCoWZc3m11Wa/dKdFgXD4kSYfkeJBKd8KMz7J8dZn/cGRCcLGDnA2Ge3bKzcvlnTDNthFWLH7Xt80ua5FMjA4WKelWv5Xo16vHuYzpRbJhhdVlftuRK0VlR27D9lu5TF0DPBi60OrHNO0AfP/uRWvhn/U3LXICE+nh+3IHPUJ8JE6GyBjZQLbjGchlrSgYngF8zyrIF4NJD3atUcgWsWunGN/UHX5B5/yg7uF87Nqp4Gf52F3gH73DjEZNRoqCKAr9giQJp5rGJABpiVE2htNhW9R8nw0jqYjCYcY4LIjwYNScf4WN06IZnZCEqsI4cFaQbo4Z1TsZBx40YhXkHOecaYE5oY37IIQ+iJJ+UsDYSun5MuRSBRZRUUhlY2DqOGajOR6zrSU/5My6l2DnusH1GQgnw5BZP7iuYM/ahcfQ7Z8y51ddfutvuwNqWQ0cBYr8fj0U0vsHpwerVaB2sWhXT2NExi2r1KUE2tUuVMnkepVQrxTmpQrZTG4iu8he8iPyM3KcPE/+RP5KPoE2CEAKclCBzXATxkYOtUY/o961PWRqsj0chRrHFBbtrjP9/P0ven5pcbRdpL94vfsy33e5+izuwz3nFLFPVNayPZx/jdG1fOChflFRvYzsW6L18efgLrSWIgvcqnGJYi4skO4xREURjbDuxKke5v0T3Mrzkt2fi31uyZlLLrqIpEuXXsMlgw442Jb0GAxjS1DM20kBoCzHLXm/jEm0IltdcvU0fEW24jgiwwRjVd9u4NJHcIyoHJcwvyVqgqj5hqBJ1ZWSJryh9p56UWhX1XbhRbW2ZopuZWsQd5y8mEQ8M+C6xjRYxZbDKWf5AgY+Qq/l6wSPk16zDFjowYuu+wjx13mfkxbyDDxadYT/LijZyI0THB+6yfLaWsRcO82zo9mWTNtpO18qlorZoIVMwSN40tky5DOQ1MCIAe24mvlsuwIIxPb10+uXDQ4uWz/9m3rj+ql7p6bufZARuPVq5tXtsn6KwfP8Jy0TeWOyNhUJN6mhX5rkUTtUppQWEMNTqEdaCGKFYKJaQrCE4JtDLYOlNEKmO5kBTPGY2A0N2sY3+dVlo1N9ycBsIGtOjQ2p/tlZvzo0ur4v6cOh8NTospB7U/X40KahoU3bGIH97dnwmtHlYffVG3R1YOwKM2vNhrPhCT5zk64sG53oS4b31aYjqe/B7+kQiXBN+b6h21hNUPMq29B8CU4elINdygMPKF1B+WBTG7Z9ZshpN/xwEuuDQZR+nuoo4CDaAiiwXmLpmukMQyPf/JMclqgL1ixZQ/nnP2VbdUODFGt2fgBvL123rlLYu/6A9ckb7F3K0/CyBMEu6aQoPscroCcacVehvyQyCZAsizsWWBkoLC+WAiWnOksLKaeuQDzGuqSk42aiYTiJ4zf9afl17SrqaTO1f+XlZAfIuYcq7/IqYMaMrksOJ6vHkOCPDq943xcCnHqVD9pHFRpMqSPXrIua1WNs+tOz1U+ciTCDpPk+c4QYJIHnYhxP/kVPAq+ahFpVhPcHp8qyarhiF+HsBU9Hrl+UZa876fbKipL0KqB6OdUveErgtOI97fZ63ae9SvWU6k2w1JfwqnUbHsYcFCJFrC/W12zIMMirWYEHxMPs6LGYSdkSZ5TsNP9PCpwnWC3HKZ1lydNjWHC2Mn3l6vL0dHn1ldP3LTSrX+vKrBqv7KmMr8p0SR6P1NqF63or6XRlIyO90f7+kf7+myOhvt4tq7f09oUiTc2/dycGgqFQcCDRLYmi1NL7fk0CknVMxEg/cdfs/TnpJMNkgqwj17B8beVazSrVbU4lG67IZYOCnWrYy3yBR9cyWcChywos3LJBEdhhFoAdYjiw0rLGm0xU5OzoGm5/ZfmHjVZpNNg6SznzGKDdwv2cCtVn6Eaxo12cfxLprpVtTcZ6hVx6dow7Yq7e8LXO8PY9Jgjoze9yCtU5FNbegcKkQMdCbt9au/te4Ebe0jkc0ukUL32eYnTpNs20h0KpUOhZPYwVcfhZnfdqeCvDfXiuCbAoYWcXERPc/mDQD3/hdF+wK4i/xv3kYfprIpAuMkk2kW3kdtS0kBIKpZwp8KxmsCyfM1MFzAss9LBkDxRyThiaqTLwKYKJVTwmWTudMyz+yks09346MDh4m72yOxCKrt1XMlQ1qPVlTEVVQ1ofdK/sCWjtZu9qGwZ8YZ9PPWlo1IV3eW3+U0aXblP39zrt+JPf6UhEQ1rUjNBULN+utyuaDNW34kpAVuSOeMTyWbSNWnooFu+QFNWQ4d/Ox4IPWx41fP/fB/Rjeoz08ezPA9TysMtmnOXfGN7Ui3xIYLDALrlDLOP09qtJuY2OeL0+QZXdRnR1nxRVBF/SOyKKPpcrn9mWzH4rH9IidE+PTNU2182+hOgSItrE1slByS24vaLvJpxOqe4Pduf3HJkZ+jLqUz9rRzB7p8gKcgWZwV1L8JtUS5Z2JxZSOCuBoMTQihMzLbCPA0KqGMAljRQjONklW/wjnXKy8vxT/Elvm3/KiMUMOoV0/vnDYlhec0SMKtt3/kKMyOt33tj2bqxQLsTjSGLl+EAsNhCnTyRGktW55EgCn/A4PlnWn+Mg8bgZrWqHxTbPwMuyy1u5YeZF2SUM7JRhddwRgiRuxpmgJmxn9ZW7XpcF3ViX/ar6ptRpGJ0S9Adg4qhb9sI3vbL7qNJV/y4i07t5TZBiho1imFoMz3gED+CtjYUxvP4SOxov4bFoNPg5aR1e+G4UgDPoedJTpogyCJ7oYvRqoVS0MQAy+CoNEdTDUjok5ZHZL/WtjV7rFj3PKQE3iKp7ou+rIxN3b9LB1dGjeT4cvKo3FrnWpYpuaFd/h3dtV8UeKN1Y9hpR3dt4p0H/zKuPQq0kZQUIIpuDfoiETsnIk+gCWMJZUXHtE8V9LkUc2TE8vOMbO4ax/MACabzyaGXc7u3FBr11ThBdB8SIeMAlCntG2KThHSPsaj2Dc9KNyY2a0KZ7ODaTHoRiFkeYz+shZBpCS4X6471KKKnuHd84edfk5F37d1XO5bbkcltu2ZLNbvnPXiUVAnVvprJrP+NObryjxrllS65md6Tm6wzFHRR4dY3QUUjb7MgxaIixU8hspi98fl/Xc+IB4iU66eCVL9YfAfahiSUt4TONS8x0D8W7u8vd3fGWx6OXlM/U1IoU/s61PGhpyXRFa3eReq2qG56lvmYtXavCC1iN7lbiBpWxXHU+cSlztVLVz0tVN600fVsLxaVDknhYioeoXP3t4lqV1r79MAw0GCI1FTL1YIGzPL1MMlJ9ZsN9P7lvA2yr9ZFUzwzPrVgxN/x/SS+chwB4nGNgZGBgAOLPrYdY4vltvjJwM78AijDUqG5oRND/XzNPZboF5HIwMIFEAU/lC+J4nGNgZGBgDvqfBSRfMAAB81QGRgZUoA0AVvYDbwAAAHicY2BgYGB+MTQwAM8EJo8AAAAAAE4AmgDoAQoBLAFOAXABmgHEAe4CGgKcAugEmgS8BNYE8gUOBSoFegXQBf4GRAZmBrYHGAeQCBgIUghqCP4JRgm+CdoKBAo+CoQKugr0C1QLmgvAeJxjYGRgYNBmTGEQZQABJiDmAkIGhv9gPgMAGJQBvAB4nG2RPU7DMBiG3/QP0UoIBGJh8QILavozdmRo9w7d09RpUzlx5LgVvQMn4BAcgoEzcAgOwVvzSZVQbcnf48fvFysJgGt8IcJxROiG9TgauODuj5ukG+EW+UG4jR4ehTv0Q+EunjER7uEWmk+IWpc0d3gVbuAKb8JN+nfhFvlDuI17fAp36L+Fu1jgR7iHp+jF7Arbz1Nb1nO93pnEncSJFtrVuS3VKB6e5EyX2iVer9TyoOr9eux9pjJnCzW1pdfGWFU5u9WpjzfeV5PBIBMfp7aAwQ4FLPrIkbKWqDHn+67pDRK4s4lzbsEux5qHvcIIMb/nueSMyTKkE3jWFdNLHLjW2PPmMa1Hxn3GjGW/wjT0HtOG09JU4WxLk9LH2ISuiv9twJn9y8fh9uIXI+BknAAAAHicbY7ZboMwEEW5CVBCSLrv+76kfJRjTwHFsdGAG+Xvy5JUfehIHp0rnxmNN/D6ir3/a4YBhvARIMQOIowQY4wEE0yxiz3s4wCHOMIxTnCKM5zjApe4wjVucIs73OMBj3jCM17wije84wMzfHqJ0EVmUkmmJo77oOmrHvfIRZbXsTCZplTZldlgb3TYGVHProwFs11t1A57tcON2rErR3PBqcwF1/6ctI6k0GSU4JHMSS6WghdJQ99sTbfuN7QLJ9vQ37dNrgyktnIxlDYLJNuqitpRbYWKFNuyDT6pog6oOYKHtKakeakqKjHXpPwlGRcsC+OqxLIiJpXqoqqDMreG2l5bv9Ri3TRX+c23DZna9WFFgmXuO6Ps1Jm/w6ErW8N3FbHn/QC444j0AA==) format('woff');
      font-weight: normal;
      font-style: normal;
    }

    html {
      --lumo-icons-align-center: "\\ea01";
      --lumo-icons-align-left: "\\ea02";
      --lumo-icons-align-right: "\\ea03";
      --lumo-icons-angle-down: "\\ea04";
      --lumo-icons-angle-left: "\\ea05";
      --lumo-icons-angle-right: "\\ea06";
      --lumo-icons-angle-up: "\\ea07";
      --lumo-icons-arrow-down: "\\ea08";
      --lumo-icons-arrow-left: "\\ea09";
      --lumo-icons-arrow-right: "\\ea0a";
      --lumo-icons-arrow-up: "\\ea0b";
      --lumo-icons-bar-chart: "\\ea0c";
      --lumo-icons-bell: "\\ea0d";
      --lumo-icons-calendar: "\\ea0e";
      --lumo-icons-checkmark: "\\ea0f";
      --lumo-icons-chevron-down: "\\ea10";
      --lumo-icons-chevron-left: "\\ea11";
      --lumo-icons-chevron-right: "\\ea12";
      --lumo-icons-chevron-up: "\\ea13";
      --lumo-icons-clock: "\\ea14";
      --lumo-icons-cog: "\\ea15";
      --lumo-icons-cross: "\\ea16";
      --lumo-icons-download: "\\ea17";
      --lumo-icons-dropdown: "\\ea18";
      --lumo-icons-edit: "\\ea19";
      --lumo-icons-error: "\\ea1a";
      --lumo-icons-eye: "\\ea1b";
      --lumo-icons-eye-disabled: "\\ea1c";
      --lumo-icons-menu: "\\ea1d";
      --lumo-icons-minus: "\\ea1e";
      --lumo-icons-ordered-list: "\\ea1f";
      --lumo-icons-phone: "\\ea20";
      --lumo-icons-photo: "\\ea21";
      --lumo-icons-play: "\\ea22";
      --lumo-icons-plus: "\\ea23";
      --lumo-icons-redo: "\\ea24";
      --lumo-icons-reload: "\\ea25";
      --lumo-icons-search: "\\ea26";
      --lumo-icons-undo: "\\ea27";
      --lumo-icons-unordered-list: "\\ea28";
      --lumo-icons-upload: "\\ea29";
      --lumo-icons-user: "\\ea2a";
    }
  </style>
`;
document.head.appendChild($140a3cb18f593fb7$var$template.content);

});



parcelRegister("8WJFj", function(module, exports) {
parcelRequire("bpTdN");
parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("2yujD");

var $hOjIW = parcelRequire("hOjIW");

var $7FnXH = parcelRequire("7FnXH");

var $bVfjI = parcelRequire("bVfjI");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $683729b1d1a192d4$var$comboBoxOverlay = (0, $aOvNQ.css)`
  [part='content'] {
    padding: 0;
  }

  :host {
    --_vaadin-combo-box-items-container-border-width: var(--lumo-space-xs);
    --_vaadin-combo-box-items-container-border-style: solid;
    --_vaadin-combo-box-items-container-border-color: transparent;
  }

  /* Loading state */

  /* When items are empty, the spinner needs some room */
  :host(:not([closing])) [part~='content'] {
    min-height: calc(2 * var(--lumo-space-s) + var(--lumo-icon-size-s));
  }

  [part~='overlay'] {
    position: relative;
  }

  :host([top-aligned]) [part~='overlay'] {
    margin-top: var(--lumo-space-xs);
  }

  :host([bottom-aligned]) [part~='overlay'] {
    margin-bottom: var(--lumo-space-xs);
  }

  [part~='loader'] {
    position: absolute;
    z-index: 1;
    left: var(--lumo-space-s);
    right: var(--lumo-space-s);
    top: var(--lumo-space-s);
    margin-left: auto;
    margin-inline-start: auto;
    margin-inline-end: 0;
  }

  /* RTL specific styles */

  :host([dir='rtl']) [part~='loader'] {
    left: auto;
    margin-left: 0;
    margin-right: auto;
    margin-inline-start: 0;
    margin-inline-end: auto;
  }
`;
(0, $2vXFS.registerStyles)('vaadin-combo-box-overlay', [
    (0, $bVfjI.overlay),
    (0, $7FnXH.menuOverlayCore),
    $683729b1d1a192d4$var$comboBoxOverlay,
    (0, $hOjIW.loader)
], {
    moduleId: 'lumo-combo-box-overlay'
});

});
parcelRegister("2yujD", function(module, exports) {
parcelRequire("8ntRD");
parcelRequire("1G1tO");

});
parcelRegister("8ntRD", function(module, exports) {

var $bVfjI = parcelRequire("bVfjI");

var $2vXFS = parcelRequire("2vXFS");
(0, $2vXFS.registerStyles)('vaadin-overlay', (0, $bVfjI.overlay), {
    moduleId: 'lumo-vaadin-overlay'
});

});
parcelRegister("bVfjI", function(module, exports) {

$parcel$export(module.exports, "overlay", () => $8ae0e630f8218da5$export$29dd17c7f3c81c36);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("bpTdN");
parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $8ae0e630f8218da5$export$29dd17c7f3c81c36 = (0, $aOvNQ.css)`
  :host {
    top: var(--lumo-space-m);
    right: var(--lumo-space-m);
    bottom: var(--lumo-space-m);
    left: var(--lumo-space-m);
    /* Workaround for Edge issue (only on Surface), where an overflowing vaadin-list-box inside vaadin-select-overlay makes the overlay transparent */
    /* stylelint-disable-next-line */
    outline: 0px solid transparent;
  }

  [part='overlay'] {
    background-color: var(--lumo-base-color);
    background-image: linear-gradient(var(--lumo-tint-5pct), var(--lumo-tint-5pct));
    border-radius: var(--lumo-border-radius-m);
    box-shadow: 0 0 0 1px var(--lumo-shade-5pct), var(--lumo-box-shadow-m);
    color: var(--lumo-body-text-color);
    font-family: var(--lumo-font-family);
    font-size: var(--lumo-font-size-m);
    font-weight: 400;
    line-height: var(--lumo-line-height-m);
    letter-spacing: 0;
    text-transform: none;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  [part='content'] {
    padding: var(--lumo-space-xs);
  }

  [part='backdrop'] {
    background-color: var(--lumo-shade-20pct);
    animation: 0.2s lumo-overlay-backdrop-enter both;
    will-change: opacity;
  }

  @keyframes lumo-overlay-backdrop-enter {
    0% {
      opacity: 0;
    }
  }

  :host([closing]) [part='backdrop'] {
    animation: 0.2s lumo-overlay-backdrop-exit both;
  }

  @keyframes lumo-overlay-backdrop-exit {
    100% {
      opacity: 0;
    }
  }

  @keyframes lumo-overlay-dummy-animation {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 1;
    }
  }
`;
(0, $2vXFS.registerStyles)('', $8ae0e630f8218da5$export$29dd17c7f3c81c36, {
    moduleId: 'lumo-overlay'
});

});


parcelRegister("1G1tO", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $138adc8883a10626$export$c6fdb837b070b4ff);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $bmThs = parcelRequire("bmThs");

var $g4z4A = parcelRequire("g4z4A");

var $kxLDR = parcelRequire("kxLDR");
parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $aC4kq = parcelRequire("aC4kq");

var $bthO9 = parcelRequire("bthO9");

var $5ncN0 = parcelRequire("5ncN0");

var $dieQ2 = parcelRequire("dieQ2");

var $2vXFS = parcelRequire("2vXFS");
/**
 *
 * `<vaadin-overlay>` is a Web Component for creating overlays. The content of the overlay
 * can be populated in two ways: imperatively by using renderer callback function and
 * declaratively by using Polymer's Templates.
 *
 * ### Rendering
 *
 * By default, the overlay uses the content provided by using the renderer callback function.
 *
 * The renderer function provides `root`, `owner`, `model` arguments when applicable.
 * Generate DOM content by using `model` object properties if needed, append it to the `root`
 * element and control the state of the host element by accessing `owner`. Before generating new
 * content, users are able to check if there is already content in `root` for reusing it.
 *
 * ```html
 * <vaadin-overlay id="overlay"></vaadin-overlay>
 * ```
 * ```js
 * const overlay = document.querySelector('#overlay');
 * overlay.renderer = function(root) {
 *  root.textContent = "Overlay content";
 * };
 * ```
 *
 * Renderer is called on the opening of the overlay and each time the related model is updated.
 * DOM generated during the renderer call can be reused
 * in the next renderer call and will be provided with the `root` argument.
 * On first call it will be empty.
 *
 * **NOTE:** when the renderer property is defined, the `<template>` content is not used.
 *
 * ### Templating
 *
 * Alternatively, the content can be provided with Polymer Template.
 * Overlay finds the first child template and uses that in case renderer callback function
 * is not provided. You can also set a custom template using the `template` property.
 *
 * After the content from the template is stamped, the `content` property
 * points to the content container.
 *
 * The overlay provides `forwardHostProp` when calling
 * `Polymer.Templatize.templatize` for the template, so that the bindings
 * from the parent scope propagate to the content.
 *
 * ### Styling
 *
 * To style the overlay content, use styles in the parent scope:
 *
 * - If the overlay is used in a component, then the component styles
 *   apply the overlay content.
 * - If the overlay is used in the global DOM scope, then global styles
 *   apply to the overlay content.
 *
 * See examples for styling the overlay content in the live demos.
 *
 * The following Shadow DOM parts are available for styling the overlay component itself:
 *
 * Part name  | Description
 * -----------|---------------------------------------------------------|
 * `backdrop` | Backdrop of the overlay
 * `overlay`  | Container for position/sizing/alignment of the content
 * `content`  | Content of the overlay
 *
 * The following state attributes are available for styling:
 *
 * Attribute | Description | Part
 * ---|---|---
 * `opening` | Applied just after the overlay is attached to the DOM. You can apply a CSS @keyframe animation for this state. | `:host`
 * `closing` | Applied just before the overlay is detached from the DOM. You can apply a CSS @keyframe animation for this state. | `:host`
 *
 * The following custom CSS properties are available for styling:
 *
 * Custom CSS property | Description | Default value
 * ---|---|---
 * `--vaadin-overlay-viewport-bottom` | Bottom offset of the visible viewport area | `0` or detected offset
 *
 * See [Styling Components](https://vaadin.com/docs/latest/styling/custom-theme/styling-components) documentation.
 *
 * @fires {CustomEvent} opened-changed - Fired when the `opened` property changes.
 * @fires {CustomEvent} vaadin-overlay-open - Fired after the overlay is opened.
 * @fires {CustomEvent} vaadin-overlay-close - Fired before the overlay will be closed. If canceled the closing of the overlay is canceled as well.
 * @fires {CustomEvent} vaadin-overlay-closing - Fired when the overlay will be closed.
 * @fires {CustomEvent} vaadin-overlay-outside-click - Fired before the overlay will be closed on outside click. If canceled the closing of the overlay is canceled as well.
 * @fires {CustomEvent} vaadin-overlay-escape-press - Fired before the overlay will be closed on ESC button press. If canceled the closing of the overlay is canceled as well.
 *
 * @extends HTMLElement
 * @mixes ThemableMixin
 * @mixes DirMixin
 * @mixes ControllerMixin
 */ class $138adc8883a10626$export$c6fdb837b070b4ff extends (0, $2vXFS.ThemableMixin)((0, $5ncN0.DirMixin)((0, $bthO9.ControllerMixin)((0, $5QhZ5.PolymerElement)))) {
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host {
          z-index: 200;
          position: fixed;

          /* Despite of what the names say, <vaadin-overlay> is just a container
          for position/sizing/alignment. The actual overlay is the overlay part. */

          /* Default position constraints: the entire viewport. Note: themes can
          override this to introduce gaps between the overlay and the viewport. */
          top: 0;
          right: 0;
          bottom: var(--vaadin-overlay-viewport-bottom);
          left: 0;

          /* Use flexbox alignment for the overlay part. */
          display: flex;
          flex-direction: column; /* makes dropdowns sizing easier */
          /* Align to center by default. */
          align-items: center;
          justify-content: center;

          /* Allow centering when max-width/max-height applies. */
          margin: auto;

          /* The host is not clickable, only the overlay part is. */
          pointer-events: none;

          /* Remove tap highlight on touch devices. */
          -webkit-tap-highlight-color: transparent;

          /* CSS API for host */
          --vaadin-overlay-viewport-bottom: 0;
        }

        :host([hidden]),
        :host(:not([opened]):not([closing])) {
          display: none !important;
        }

        [part='overlay'] {
          -webkit-overflow-scrolling: touch;
          overflow: auto;
          pointer-events: auto;

          /* Prevent overflowing the host in MSIE 11 */
          max-width: 100%;
          box-sizing: border-box;

          -webkit-tap-highlight-color: initial; /* reenable tap highlight inside */
        }

        [part='backdrop'] {
          z-index: -1;
          content: '';
          background: rgba(0, 0, 0, 0.5);
          position: fixed;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          pointer-events: auto;
        }
      </style>

      <div id="backdrop" part="backdrop" hidden$="[[!withBackdrop]]"></div>
      <div part="overlay" id="overlay" tabindex="0">
        <div part="content" id="content">
          <slot></slot>
        </div>
      </div>
    `;
    }
    static get is() {
        return 'vaadin-overlay';
    }
    static get properties() {
        return {
            /**
       * When true, the overlay is visible and attached to body.
       */ opened: {
                type: Boolean,
                notify: true,
                observer: '_openedChanged',
                reflectToAttribute: true
            },
            /**
       * Owner element passed with renderer function
       * @type {HTMLElement}
       */ owner: Element,
            /**
       * Custom function for rendering the content of the overlay.
       * Receives three arguments:
       *
       * - `root` The root container DOM element. Append your content to it.
       * - `owner` The host element of the renderer function.
       * - `model` The object with the properties related with rendering.
       * @type {OverlayRenderer | null | undefined}
       */ renderer: Function,
            /**
       * The template of the overlay content.
       * @type {HTMLTemplateElement | null | undefined}
       */ template: {
                type: Object,
                notify: true
            },
            /**
       * References the content container after the template is stamped.
       * @type {!HTMLElement | undefined}
       */ content: {
                type: Object,
                notify: true
            },
            /**
       * When true the overlay has backdrop on top of content when opened.
       * @type {boolean}
       */ withBackdrop: {
                type: Boolean,
                value: false,
                reflectToAttribute: true
            },
            /**
       * Object with properties that is passed to `renderer` function
       */ model: Object,
            /**
       * When true the overlay won't disable the main content, showing
       * it doesn’t change the functionality of the user interface.
       * @type {boolean}
       */ modeless: {
                type: Boolean,
                value: false,
                reflectToAttribute: true,
                observer: '_modelessChanged'
            },
            /**
       * When set to true, the overlay is hidden. This also closes the overlay
       * immediately in case there is a closing animation in progress.
       * @type {boolean}
       */ hidden: {
                type: Boolean,
                reflectToAttribute: true,
                observer: '_hiddenChanged'
            },
            /**
       * When true move focus to the first focusable element in the overlay,
       * or to the overlay if there are no focusable elements.
       * @type {boolean}
       */ focusTrap: {
                type: Boolean,
                value: false
            },
            /**
       * Set to true to enable restoring of focus when overlay is closed.
       * @type {boolean}
       */ restoreFocusOnClose: {
                type: Boolean,
                value: false
            },
            /**
       * Set to specify the element which should be focused on overlay close,
       * if `restoreFocusOnClose` is set to true.
       * @type {HTMLElement}
       */ restoreFocusNode: {
                type: HTMLElement
            },
            /** @private */ _mouseDownInside: {
                type: Boolean
            },
            /** @private */ _mouseUpInside: {
                type: Boolean
            },
            /** @private */ _instance: {
                type: Object
            },
            /** @private */ _originalContentPart: Object,
            /** @private */ _contentNodes: Array,
            /** @private */ _oldOwner: Element,
            /** @private */ _oldModel: Object,
            /** @private */ _oldTemplate: Object,
            /** @private */ _oldRenderer: Object,
            /** @private */ _oldOpened: Boolean
        };
    }
    static get observers() {
        return [
            '_templateOrRendererChanged(template, renderer, owner, model, opened)'
        ];
    }
    constructor(){
        super();
        this._boundMouseDownListener = this._mouseDownListener.bind(this);
        this._boundMouseUpListener = this._mouseUpListener.bind(this);
        this._boundOutsideClickListener = this._outsideClickListener.bind(this);
        this._boundKeydownListener = this._keydownListener.bind(this);
        this._observer = new (0, $bmThs.FlattenedNodesObserver)(this, (info)=>{
            this._setTemplateFromNodes(info.addedNodes);
        });
        // Listener for preventing closing of the paper-dialog and all components extending `iron-overlay-behavior`.
        this._boundIronOverlayCanceledListener = this._ironOverlayCanceled.bind(this);
        /* c8 ignore next 3 */ if (0, $aC4kq.isIOS) this._boundIosResizeListener = ()=>this._detectIosNavbar();
        this.__focusTrapController = new (0, $dieQ2.FocusTrapController)(this);
    }
    /** @protected */ ready() {
        super.ready();
        this._observer.flush();
        // Need to add dummy click listeners to this and the backdrop or else
        // the document click event listener (_outsideClickListener) may never
        // get invoked on iOS Safari (reproducible in <vaadin-dialog>
        // and <vaadin-context-menu>).
        this.addEventListener('click', ()=>{});
        this.$.backdrop.addEventListener('click', ()=>{});
        this.addController(this.__focusTrapController);
    }
    /** @private */ _detectIosNavbar() {
        /* c8 ignore next 15 */ if (!this.opened) return;
        const innerHeight = window.innerHeight;
        const innerWidth = window.innerWidth;
        const landscape = innerWidth > innerHeight;
        const clientHeight = document.documentElement.clientHeight;
        if (landscape && clientHeight > innerHeight) this.style.setProperty('--vaadin-overlay-viewport-bottom', `${clientHeight - innerHeight}px`);
        else this.style.setProperty('--vaadin-overlay-viewport-bottom', '0');
    }
    /**
   * @param {!Array<!Element>} nodes
   * @protected
   */ _setTemplateFromNodes(nodes) {
        this.template = nodes.find((node)=>node.localName && node.localName === 'template') || this.template;
    }
    /**
   * @param {Event=} sourceEvent
   * @event vaadin-overlay-close
   * fired before the `vaadin-overlay` will be closed. If canceled the closing of the overlay is canceled as well.
   */ close(sourceEvent) {
        const evt = new CustomEvent('vaadin-overlay-close', {
            bubbles: true,
            cancelable: true,
            detail: {
                sourceEvent: sourceEvent
            }
        });
        this.dispatchEvent(evt);
        if (!evt.defaultPrevented) this.opened = false;
    }
    /** @protected */ connectedCallback() {
        super.connectedCallback();
        /* c8 ignore next 3 */ if (this._boundIosResizeListener) {
            this._detectIosNavbar();
            window.addEventListener('resize', this._boundIosResizeListener);
        }
    }
    /** @protected */ disconnectedCallback() {
        super.disconnectedCallback();
        /* c8 ignore next 3 */ if (this._boundIosResizeListener) window.removeEventListener('resize', this._boundIosResizeListener);
    }
    /**
   * Requests an update for the content of the overlay.
   * While performing the update, it invokes the renderer passed in the `renderer` property.
   *
   * It is not guaranteed that the update happens immediately (synchronously) after it is requested.
   */ requestContentUpdate() {
        if (this.renderer) this.renderer.call(this.owner, this.content, this.owner, this.model);
    }
    /** @private */ _ironOverlayCanceled(event) {
        event.preventDefault();
    }
    /** @private */ _mouseDownListener(event) {
        this._mouseDownInside = event.composedPath().indexOf(this.$.overlay) >= 0;
    }
    /** @private */ _mouseUpListener(event) {
        this._mouseUpInside = event.composedPath().indexOf(this.$.overlay) >= 0;
    }
    /**
   * We need to listen on 'click' / 'tap' event and capture it and close the overlay before
   * propagating the event to the listener in the button. Otherwise, if the clicked button would call
   * open(), this would happen: https://www.youtube.com/watch?v=Z86V_ICUCD4
   *
   * @event vaadin-overlay-outside-click
   * fired before the `vaadin-overlay` will be closed on outside click. If canceled the closing of the overlay is canceled as well.
   *
   * @private
   */ _outsideClickListener(event) {
        if (event.composedPath().includes(this.$.overlay) || this._mouseDownInside || this._mouseUpInside) {
            this._mouseDownInside = false;
            this._mouseUpInside = false;
            return;
        }
        if (!this._last) return;
        const evt = new CustomEvent('vaadin-overlay-outside-click', {
            bubbles: true,
            cancelable: true,
            detail: {
                sourceEvent: event
            }
        });
        this.dispatchEvent(evt);
        if (this.opened && !evt.defaultPrevented) this.close(event);
    }
    /**
   * @event vaadin-overlay-escape-press
   * fired before the `vaadin-overlay` will be closed on ESC button press. If canceled the closing of the overlay is canceled as well.
   *
   * @private
   */ _keydownListener(event) {
        if (!this._last) return;
        // Only close modeless overlay on Esc press when it contains focus
        if (this.modeless && !event.composedPath().includes(this.$.overlay)) return;
        if (event.key === 'Escape') {
            const evt = new CustomEvent('vaadin-overlay-escape-press', {
                bubbles: true,
                cancelable: true,
                detail: {
                    sourceEvent: event
                }
            });
            this.dispatchEvent(evt);
            if (this.opened && !evt.defaultPrevented) this.close(event);
        }
    }
    /** @protected */ _ensureTemplatized() {
        this._setTemplateFromNodes(Array.from(this.children));
    }
    /**
   * @event vaadin-overlay-open
   * fired after the `vaadin-overlay` is opened.
   *
   * @private
   */ _openedChanged(opened, wasOpened) {
        if (!this._instance) this._ensureTemplatized();
        if (opened) {
            // Store focused node.
            this.__restoreFocusNode = this._getActiveElement();
            this._animatedOpening();
            (0, $g4z4A.afterNextRender)(this, ()=>{
                if (this.focusTrap) this.__focusTrapController.trapFocus(this.$.overlay);
                const evt = new CustomEvent('vaadin-overlay-open', {
                    bubbles: true
                });
                this.dispatchEvent(evt);
            });
            document.addEventListener('keydown', this._boundKeydownListener);
            if (!this.modeless) this._addGlobalListeners();
        } else if (wasOpened) {
            if (this.focusTrap) this.__focusTrapController.releaseFocus();
            this._animatedClosing();
            document.removeEventListener('keydown', this._boundKeydownListener);
            if (!this.modeless) this._removeGlobalListeners();
        }
    }
    /** @private */ _hiddenChanged(hidden) {
        if (hidden && this.hasAttribute('closing')) this._flushAnimation('closing');
    }
    /**
   * @return {boolean}
   * @protected
   */ _shouldAnimate() {
        const name = getComputedStyle(this).getPropertyValue('animation-name');
        const hidden = getComputedStyle(this).getPropertyValue('display') === 'none';
        return !hidden && name && name !== 'none';
    }
    /**
   * @param {string} type
   * @param {Function} callback
   * @protected
   */ _enqueueAnimation(type, callback) {
        const handler = `__${type}Handler`;
        const listener = (event)=>{
            if (event && event.target !== this) return;
            callback();
            this.removeEventListener('animationend', listener);
            delete this[handler];
        };
        this[handler] = listener;
        this.addEventListener('animationend', listener);
    }
    /**
   * @param {string} type
   * @protected
   */ _flushAnimation(type) {
        const handler = `__${type}Handler`;
        if (typeof this[handler] === 'function') this[handler]();
    }
    /** @protected */ _animatedOpening() {
        if (this.parentNode === document.body && this.hasAttribute('closing')) this._flushAnimation('closing');
        this._attachOverlay();
        if (!this.modeless) this._enterModalState();
        this.setAttribute('opening', '');
        if (this._shouldAnimate()) this._enqueueAnimation('opening', ()=>{
            this._finishOpening();
        });
        else this._finishOpening();
    }
    /** @protected */ _attachOverlay() {
        this._placeholder = document.createComment('vaadin-overlay-placeholder');
        this.parentNode.insertBefore(this._placeholder, this);
        document.body.appendChild(this);
        this.bringToFront();
    }
    /** @protected */ _finishOpening() {
        document.addEventListener('iron-overlay-canceled', this._boundIronOverlayCanceledListener);
        this.removeAttribute('opening');
    }
    /** @protected */ _finishClosing() {
        document.removeEventListener('iron-overlay-canceled', this._boundIronOverlayCanceledListener);
        this._detachOverlay();
        this.$.overlay.style.removeProperty('pointer-events');
        this.removeAttribute('closing');
    }
    /**
   * @event vaadin-overlay-closing
   * Fired when the overlay will be closed.
   *
   * @protected
   */ _animatedClosing() {
        if (this.hasAttribute('opening')) this._flushAnimation('opening');
        if (this._placeholder) {
            this._exitModalState();
            // Use this.restoreFocusNode if specified, otherwise fallback to the node
            // which was focused before opening the overlay.
            const restoreFocusNode = this.restoreFocusNode || this.__restoreFocusNode;
            if (this.restoreFocusOnClose && restoreFocusNode) {
                // If the activeElement is `<body>` or inside the overlay,
                // we are allowed to restore the focus. In all the other
                // cases focus might have been moved elsewhere by another
                // component or by the user interaction (e.g. click on a
                // button outside the overlay).
                const activeElement = this._getActiveElement();
                if (activeElement === document.body || this._deepContains(activeElement)) // Focusing the restoreFocusNode doesn't always work synchronously on Firefox and Safari
                // (e.g. combo-box overlay close on outside click).
                setTimeout(()=>restoreFocusNode.focus());
                this.__restoreFocusNode = null;
            }
            this.setAttribute('closing', '');
            this.dispatchEvent(new CustomEvent('vaadin-overlay-closing'));
            if (this._shouldAnimate()) this._enqueueAnimation('closing', ()=>{
                this._finishClosing();
            });
            else this._finishClosing();
        }
    }
    /** @protected */ _detachOverlay() {
        this._placeholder.parentNode.insertBefore(this, this._placeholder);
        this._placeholder.parentNode.removeChild(this._placeholder);
    }
    /**
   * Returns all attached overlays in visual stacking order.
   * @private
   */ static get __attachedInstances() {
        return Array.from(document.body.children).filter((el)=>el instanceof $138adc8883a10626$export$c6fdb837b070b4ff && !el.hasAttribute('closing')).sort((a, b)=>a.__zIndex - b.__zIndex || 0);
    }
    /**
   * Returns true if this is the last one in the opened overlays stack
   * @return {boolean}
   * @protected
   */ get _last() {
        return this === $138adc8883a10626$export$c6fdb837b070b4ff.__attachedInstances.pop();
    }
    /** @private */ _modelessChanged(modeless) {
        if (!modeless) {
            if (this.opened) {
                this._addGlobalListeners();
                this._enterModalState();
            }
        } else {
            this._removeGlobalListeners();
            this._exitModalState();
        }
    }
    /** @protected */ _addGlobalListeners() {
        document.addEventListener('mousedown', this._boundMouseDownListener);
        document.addEventListener('mouseup', this._boundMouseUpListener);
        // Firefox leaks click to document on contextmenu even if prevented
        // https://bugzilla.mozilla.org/show_bug.cgi?id=990614
        document.documentElement.addEventListener('click', this._boundOutsideClickListener, true);
    }
    /** @protected */ _enterModalState() {
        if (document.body.style.pointerEvents !== 'none') {
            // Set body pointer-events to 'none' to disable mouse interactions with
            // other document nodes.
            this._previousDocumentPointerEvents = document.body.style.pointerEvents;
            document.body.style.pointerEvents = 'none';
        }
        // Disable pointer events in other attached overlays
        $138adc8883a10626$export$c6fdb837b070b4ff.__attachedInstances.forEach((el)=>{
            if (el !== this) el.shadowRoot.querySelector('[part="overlay"]').style.pointerEvents = 'none';
        });
    }
    /** @protected */ _removeGlobalListeners() {
        document.removeEventListener('mousedown', this._boundMouseDownListener);
        document.removeEventListener('mouseup', this._boundMouseUpListener);
        document.documentElement.removeEventListener('click', this._boundOutsideClickListener, true);
    }
    /** @protected */ _exitModalState() {
        if (this._previousDocumentPointerEvents !== undefined) {
            // Restore body pointer-events
            document.body.style.pointerEvents = this._previousDocumentPointerEvents;
            delete this._previousDocumentPointerEvents;
        }
        // Restore pointer events in the previous overlay(s)
        const instances = $138adc8883a10626$export$c6fdb837b070b4ff.__attachedInstances;
        let el;
        // Use instances.pop() to ensure the reverse order
        while(el = instances.pop()){
            if (el === this) continue;
            el.shadowRoot.querySelector('[part="overlay"]').style.removeProperty('pointer-events');
            if (!el.modeless) break;
        }
    }
    /** @protected */ _removeOldContent() {
        if (!this.content || !this._contentNodes) return;
        this._observer.disconnect();
        this._contentNodes.forEach((node)=>{
            if (node.parentNode === this.content) this.content.removeChild(node);
        });
        if (this._originalContentPart) {
            // Restore the original <div part="content">
            this.$.content.parentNode.replaceChild(this._originalContentPart, this.$.content);
            this.$.content = this._originalContentPart;
            this._originalContentPart = undefined;
        }
        this._observer.connect();
        this._contentNodes = undefined;
        this.content = undefined;
    }
    /**
   * @param {!HTMLTemplateElement} template
   * @protected
   */ _stampOverlayTemplate(template) {
        this._removeOldContent();
        if (!template._Templatizer) template._Templatizer = (0, $kxLDR.templatize)(template, this, {
            forwardHostProp (prop, value) {
                if (this._instance) this._instance.forwardHostProp(prop, value);
            }
        });
        this._instance = new template._Templatizer({});
        this._contentNodes = Array.from(this._instance.root.childNodes);
        const templateRoot = template._templateRoot || (template._templateRoot = template.getRootNode());
        if (templateRoot !== document) {
            if (!this.$.content.shadowRoot) this.$.content.attachShadow({
                mode: 'open'
            });
            let scopeCssText = Array.from(templateRoot.querySelectorAll('style')).reduce((result, style)=>result + style.textContent, '');
            // The overlay root’s :host styles should not apply inside the overlay
            scopeCssText = scopeCssText.replace(/:host/g, ':host-nomatch');
            if (scopeCssText) {
                // Append a style to the content shadowRoot
                const style = document.createElement('style');
                style.textContent = scopeCssText;
                this.$.content.shadowRoot.appendChild(style);
                this._contentNodes.unshift(style);
            }
            this.$.content.shadowRoot.appendChild(this._instance.root);
            this.content = this.$.content.shadowRoot;
        } else {
            this.appendChild(this._instance.root);
            this.content = this;
        }
    }
    /** @private */ _removeNewRendererOrTemplate(template, oldTemplate, renderer, oldRenderer) {
        if (template !== oldTemplate) this.template = undefined;
        else if (renderer !== oldRenderer) this.renderer = undefined;
    }
    /** @private */ // eslint-disable-next-line max-params
    _templateOrRendererChanged(template, renderer, owner, model, opened) {
        if (template && renderer) {
            this._removeNewRendererOrTemplate(template, this._oldTemplate, renderer, this._oldRenderer);
            throw new Error('You should only use either a renderer or a template for overlay content');
        }
        const ownerOrModelChanged = this._oldOwner !== owner || this._oldModel !== model;
        this._oldModel = model;
        this._oldOwner = owner;
        const templateChanged = this._oldTemplate !== template;
        this._oldTemplate = template;
        const rendererChanged = this._oldRenderer !== renderer;
        this._oldRenderer = renderer;
        const openedChanged = this._oldOpened !== opened;
        this._oldOpened = opened;
        if (rendererChanged) {
            this.content = this;
            this.content.innerHTML = '';
            // Whenever a Lit-based renderer is used, it assigns a Lit part to the node it was rendered into.
            // When clearing the rendered content, this part needs to be manually disposed of.
            // Otherwise, using a Lit-based renderer on the same node will throw an exception or render nothing afterward.
            delete this.content._$litPart$;
        }
        if (template && templateChanged) this._stampOverlayTemplate(template);
        else if (renderer && (rendererChanged || openedChanged || ownerOrModelChanged)) {
            if (opened) this.requestContentUpdate();
        }
    }
    /**
   * @return {!Element}
   * @protected
   */ _getActiveElement() {
        // Document.activeElement can be null
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/activeElement
        let active = document.activeElement || document.body;
        while(active.shadowRoot && active.shadowRoot.activeElement)active = active.shadowRoot.activeElement;
        return active;
    }
    /**
   * @param {!Node} node
   * @return {boolean}
   * @protected
   */ _deepContains(node) {
        if (this.contains(node)) return true;
        let n = node;
        const doc = node.ownerDocument;
        // Walk from node to `this` or `document`
        while(n && n !== doc && n !== this)n = n.parentNode || n.host;
        return n === this;
    }
    /**
   * Brings the overlay as visually the frontmost one
   */ bringToFront() {
        let zIndex = '';
        const frontmost = $138adc8883a10626$export$c6fdb837b070b4ff.__attachedInstances.filter((o)=>o !== this).pop();
        if (frontmost) {
            const frontmostZIndex = frontmost.__zIndex;
            zIndex = frontmostZIndex + 1;
        }
        this.style.zIndex = zIndex;
        this.__zIndex = zIndex || parseFloat(getComputedStyle(this).zIndex);
    }
}
customElements.define($138adc8883a10626$export$c6fdb837b070b4ff.is, $138adc8883a10626$export$c6fdb837b070b4ff);

});
parcelRegister("g4z4A", function(module, exports) {

$parcel$export(module.exports, "afterNextRender", () => $bb3839d90687d5f9$export$51222768c1296ef5);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /**
 * Module for scheduling flushable pre-render and post-render tasks.
 *
 * @summary Module for scheduling flushable pre-render and post-render tasks.
 */ parcelRequire("dMwQI");
let $bb3839d90687d5f9$var$scheduled = false;
let $bb3839d90687d5f9$var$beforeRenderQueue = [];
let $bb3839d90687d5f9$var$afterRenderQueue = [];
function $bb3839d90687d5f9$var$schedule() {
    $bb3839d90687d5f9$var$scheduled = true;
    // before next render
    requestAnimationFrame(function() {
        $bb3839d90687d5f9$var$scheduled = false;
        $bb3839d90687d5f9$var$flushQueue($bb3839d90687d5f9$var$beforeRenderQueue);
        // after the render
        setTimeout(function() {
            $bb3839d90687d5f9$var$runQueue($bb3839d90687d5f9$var$afterRenderQueue);
        });
    });
}
function $bb3839d90687d5f9$var$flushQueue(queue) {
    while(queue.length)$bb3839d90687d5f9$var$callMethod(queue.shift());
}
function $bb3839d90687d5f9$var$runQueue(queue) {
    for(let i = 0, l = queue.length; i < l; i++)$bb3839d90687d5f9$var$callMethod(queue.shift());
}
function $bb3839d90687d5f9$var$callMethod(info) {
    const context = info[0];
    const callback = info[1];
    const args = info[2];
    try {
        callback.apply(context, args);
    } catch (e) {
        setTimeout(()=>{
            throw e;
        });
    }
}
function $bb3839d90687d5f9$export$4909b86c8034bf73() {
    while($bb3839d90687d5f9$var$beforeRenderQueue.length || $bb3839d90687d5f9$var$afterRenderQueue.length){
        $bb3839d90687d5f9$var$flushQueue($bb3839d90687d5f9$var$beforeRenderQueue);
        $bb3839d90687d5f9$var$flushQueue($bb3839d90687d5f9$var$afterRenderQueue);
    }
    $bb3839d90687d5f9$var$scheduled = false;
}
function $bb3839d90687d5f9$export$5d60bc3398f88d67(context, callback, args) {
    if (!$bb3839d90687d5f9$var$scheduled) $bb3839d90687d5f9$var$schedule();
    $bb3839d90687d5f9$var$beforeRenderQueue.push([
        context,
        callback,
        args
    ]);
}
function $bb3839d90687d5f9$export$51222768c1296ef5(context, callback, args) {
    if (!$bb3839d90687d5f9$var$scheduled) $bb3839d90687d5f9$var$schedule();
    $bb3839d90687d5f9$var$afterRenderQueue.push([
        context,
        callback,
        args
    ]);
}

});

parcelRegister("kxLDR", function(module, exports) {

$parcel$export(module.exports, "templatize", () => $ef4bd86dedad51a0$export$528486d340f30adf);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ /**
 * Module for preparing and stamping instances of templates that utilize
 * Polymer's data-binding and declarative event listener features.
 *
 * Example:
 *
 *     // Get a template from somewhere, e.g. light DOM
 *     let template = this.querySelector('template');
 *     // Prepare the template
 *     let TemplateClass = Templatize.templatize(template);
 *     // Instance the template with an initial data model
 *     let instance = new TemplateClass({myProp: 'initial'});
 *     // Insert the instance's DOM somewhere, e.g. element's shadow DOM
 *     this.shadowRoot.appendChild(instance.root);
 *     // Changing a property on the instance will propagate to bindings
 *     // in the template
 *     instance.myProp = 'new value';
 *
 * The `options` dictionary passed to `templatize` allows for customizing
 * features of the generated template class, including how outer-scope host
 * properties should be forwarded into template instances, how any instance
 * properties added into the template's scope should be notified out to
 * the host, and whether the instance should be decorated as a "parent model"
 * of any event handlers.
 *
 *     // Customize property forwarding and event model decoration
 *     let TemplateClass = Templatize.templatize(template, this, {
 *       parentModel: true,
 *       forwardHostProp(property, value) {...},
 *       instanceProps: {...},
 *       notifyInstanceProp(instance, property, value) {...},
 *     });
 *
 * @summary Module for preparing and stamping instances of templates
 *   utilizing Polymer templating features.
 */ parcelRequire("dMwQI");

var $2njbg = parcelRequire("2njbg");

var $adT3u = parcelRequire("adT3u");

var $8bEdR = parcelRequire("8bEdR");

var $a2HIe = parcelRequire("a2HIe");
// Base class for HTMLTemplateElement extension that has property effects
// machinery for propagating host properties to children. This is an ES5
// class only because Babel (incorrectly) requires super() in the class
// constructor even though no `this` is used and it returns an instance.
let $ef4bd86dedad51a0$var$newInstance = null;
/**
 * @constructor
 * @extends {HTMLTemplateElement}
 * @private
 */ function $ef4bd86dedad51a0$var$HTMLTemplateElementExtension() {
    return $ef4bd86dedad51a0$var$newInstance;
}
$ef4bd86dedad51a0$var$HTMLTemplateElementExtension.prototype = Object.create(HTMLTemplateElement.prototype, {
    constructor: {
        value: $ef4bd86dedad51a0$var$HTMLTemplateElementExtension,
        writable: true
    }
});
/**
 * @constructor
 * @implements {Polymer_PropertyEffects}
 * @extends {HTMLTemplateElementExtension}
 * @private
 */ const $ef4bd86dedad51a0$var$DataTemplate = (0, $2njbg.PropertyEffects)($ef4bd86dedad51a0$var$HTMLTemplateElementExtension);
/**
 * @constructor
 * @implements {Polymer_MutableData}
 * @extends {DataTemplate}
 * @private
 */ const $ef4bd86dedad51a0$var$MutableDataTemplate = (0, $adT3u.MutableData)($ef4bd86dedad51a0$var$DataTemplate);
// Applies a DataTemplate subclass to a <template> instance
function $ef4bd86dedad51a0$var$upgradeTemplate(template, constructor) {
    $ef4bd86dedad51a0$var$newInstance = template;
    Object.setPrototypeOf(template, constructor.prototype);
    new constructor();
    $ef4bd86dedad51a0$var$newInstance = null;
}
/**
 * Base class for TemplateInstance.
 * @constructor
 * @extends {HTMLElement}
 * @implements {Polymer_PropertyEffects}
 * @private
 */ const $ef4bd86dedad51a0$var$templateInstanceBase = (0, $2njbg.PropertyEffects)(class {
});
function $ef4bd86dedad51a0$export$2f680825468947ff(hide, children) {
    for(let i = 0; i < children.length; i++){
        let n = children[i];
        // Ignore non-changes
        if (Boolean(hide) != Boolean(n.__hideTemplateChildren__)) {
            // clear and restore text
            if (n.nodeType === Node.TEXT_NODE) {
                if (hide) {
                    n.__polymerTextContent__ = n.textContent;
                    n.textContent = '';
                } else n.textContent = n.__polymerTextContent__;
            } else if (n.localName === 'slot') {
                if (hide) {
                    n.__polymerReplaced__ = document.createComment('hidden-slot');
                    (0, $a2HIe.wrap)((0, $a2HIe.wrap)(n).parentNode).replaceChild(n.__polymerReplaced__, n);
                } else {
                    const replace = n.__polymerReplaced__;
                    if (replace) (0, $a2HIe.wrap)((0, $a2HIe.wrap)(replace).parentNode).replaceChild(n, replace);
                }
            } else if (n.style) {
                if (hide) {
                    n.__polymerDisplay__ = n.style.display;
                    n.style.display = 'none';
                } else n.style.display = n.__polymerDisplay__;
            }
        }
        n.__hideTemplateChildren__ = hide;
        if (n._showHideChildren) n._showHideChildren(hide);
    }
}
/**
 * @polymer
 * @customElement
 * @appliesMixin PropertyEffects
 * @unrestricted
 */ class $ef4bd86dedad51a0$export$d325f89c810f68ec extends $ef4bd86dedad51a0$var$templateInstanceBase {
    constructor(props){
        super();
        this._configureProperties(props);
        /** @type {!StampedTemplate} */ this.root = this._stampTemplate(this.__dataHost);
        // Save list of stamped children
        let children = [];
        /** @suppress {invalidCasts} */ this.children = /** @type {!NodeList} */ children;
        // Polymer 1.x did not use `Polymer.dom` here so not bothering.
        for(let n = this.root.firstChild; n; n = n.nextSibling){
            children.push(n);
            n.__templatizeInstance = this;
        }
        if (this.__templatizeOwner && this.__templatizeOwner.__hideTemplateChildren__) this._showHideChildren(true);
        // Flush props only when props are passed if instance props exist
        // or when there isn't instance props.
        let options = this.__templatizeOptions;
        if (props && options.instanceProps || !options.instanceProps) this._enableProperties();
    }
    /**
   * Configure the given `props` by calling `_setPendingProperty`. Also
   * sets any properties stored in `__hostProps`.
   * @private
   * @param {Object} props Object of property name-value pairs to set.
   * @return {void}
   */ _configureProperties(props) {
        let options = this.__templatizeOptions;
        if (options.forwardHostProp) for(let hprop in this.__hostProps)this._setPendingProperty(hprop, this.__dataHost['_host_' + hprop]);
        // Any instance props passed in the constructor will overwrite host props;
        // normally this would be a user error but we don't specifically filter them
        for(let iprop in props)this._setPendingProperty(iprop, props[iprop]);
    }
    /**
   * Forwards a host property to this instance.  This method should be
   * called on instances from the `options.forwardHostProp` callback
   * to propagate changes of host properties to each instance.
   *
   * Note this method enqueues the change, which are flushed as a batch.
   *
   * @param {string} prop Property or path name
   * @param {*} value Value of the property to forward
   * @return {void}
   */ forwardHostProp(prop, value) {
        if (this._setPendingPropertyOrPath(prop, value, false, true)) this.__dataHost._enqueueClient(this);
    }
    /**
   * Override point for adding custom or simulated event handling.
   *
   * @override
   * @param {!Node} node Node to add event listener to
   * @param {string} eventName Name of event
   * @param {function(!Event):void} handler Listener function to add
   * @return {void}
   */ _addEventListenerToNode(node, eventName, handler) {
        if (this._methodHost && this.__templatizeOptions.parentModel) // If this instance should be considered a parent model, decorate
        // events this template instance as `model`
        this._methodHost._addEventListenerToNode(node, eventName, (e)=>{
            e.model = this;
            handler(e);
        });
        else {
            // Otherwise delegate to the template's host (which could be)
            // another template instance
            let templateHost = this.__dataHost.__dataHost;
            if (templateHost) templateHost._addEventListenerToNode(node, eventName, handler);
        }
    }
    /**
   * Shows or hides the template instance top level child elements. For
   * text nodes, `textContent` is removed while "hidden" and replaced when
   * "shown."
   * @param {boolean} hide Set to true to hide the children;
   * set to false to show them.
   * @return {void}
   * @protected
   */ _showHideChildren(hide) {
        $ef4bd86dedad51a0$export$2f680825468947ff(hide, this.children);
    }
    /**
   * Overrides default property-effects implementation to intercept
   * textContent bindings while children are "hidden" and cache in
   * private storage for later retrieval.
   *
   * @override
   * @param {!Node} node The node to set a property on
   * @param {string} prop The property to set
   * @param {*} value The value to set
   * @return {void}
   * @protected
   */ _setUnmanagedPropertyToNode(node, prop, value) {
        if (node.__hideTemplateChildren__ && node.nodeType == Node.TEXT_NODE && prop == 'textContent') node.__polymerTextContent__ = value;
        else super._setUnmanagedPropertyToNode(node, prop, value);
    }
    /**
   * Find the parent model of this template instance.  The parent model
   * is either another templatize instance that had option `parentModel: true`,
   * or else the host element.
   *
   * @return {!Polymer_PropertyEffects} The parent model of this instance
   */ get parentModel() {
        let model = this.__parentModel;
        if (!model) {
            let options;
            model = this;
            do // A template instance's `__dataHost` is a <template>
            // `model.__dataHost.__dataHost` is the template's host
            model = model.__dataHost.__dataHost;
            while ((options = model.__templatizeOptions) && !options.parentModel);
            this.__parentModel = model;
        }
        return model;
    }
    /**
   * Stub of HTMLElement's `dispatchEvent`, so that effects that may
   * dispatch events safely no-op.
   *
   * @param {Event} event Event to dispatch
   * @return {boolean} Always true.
   * @override
   */ dispatchEvent(event) {
        return true;
    }
}
/** @type {!DataTemplate} */ $ef4bd86dedad51a0$export$d325f89c810f68ec.prototype.__dataHost;
/** @type {!TemplatizeOptions} */ $ef4bd86dedad51a0$export$d325f89c810f68ec.prototype.__templatizeOptions;
/** @type {!Polymer_PropertyEffects} */ $ef4bd86dedad51a0$export$d325f89c810f68ec.prototype._methodHost;
/** @type {!Object} */ $ef4bd86dedad51a0$export$d325f89c810f68ec.prototype.__templatizeOwner;
/** @type {!Object} */ $ef4bd86dedad51a0$export$d325f89c810f68ec.prototype.__hostProps;
/**
 * @constructor
 * @extends {TemplateInstanceBase}
 * @implements {Polymer_MutableData}
 * @private
 */ const $ef4bd86dedad51a0$var$MutableTemplateInstanceBase = (0, $adT3u.MutableData)(// This cast shouldn't be neccessary, but Closure doesn't understand that
// TemplateInstanceBase is a constructor function.
/** @type {function(new:TemplateInstanceBase)} */ $ef4bd86dedad51a0$export$d325f89c810f68ec);
function $ef4bd86dedad51a0$var$findMethodHost(template) {
    // Technically this should be the owner of the outermost template.
    // In shadow dom, this is always getRootNode().host, but we can
    // approximate this via cooperation with our dataHost always setting
    // `_methodHost` as long as there were bindings (or id's) on this
    // instance causing it to get a dataHost.
    let templateHost = template.__dataHost;
    return templateHost && templateHost._methodHost || templateHost;
}
/* eslint-disable valid-jsdoc */ /**
 * @suppress {missingProperties} class.prototype is not defined for some reason
 */ function $ef4bd86dedad51a0$var$createTemplatizerClass(template, templateInfo, options) {
    /**
   * @constructor
   * @extends {TemplateInstanceBase}
   */ let templatizerBase = options.mutableData ? $ef4bd86dedad51a0$var$MutableTemplateInstanceBase : $ef4bd86dedad51a0$export$d325f89c810f68ec;
    // Affordance for global mixins onto TemplatizeInstance
    if ($ef4bd86dedad51a0$export$528486d340f30adf.mixin) templatizerBase = $ef4bd86dedad51a0$export$528486d340f30adf.mixin(templatizerBase);
    /**
   * Anonymous class created by the templatize
   * @constructor
   * @private
   */ let klass = class extends templatizerBase {
    };
    /** @override */ klass.prototype.__templatizeOptions = options;
    klass.prototype._bindTemplate(template);
    $ef4bd86dedad51a0$var$addNotifyEffects(klass, template, templateInfo, options);
    return klass;
}
/**
 * Adds propagate effects from the template to the template instance for
 * properties that the host binds to the template using the `_host_` prefix.
 *
 * @suppress {missingProperties} class.prototype is not defined for some reason
 */ function $ef4bd86dedad51a0$var$addPropagateEffects(target, templateInfo, options, methodHost) {
    let userForwardHostProp = options.forwardHostProp;
    if (userForwardHostProp && templateInfo.hasHostProps) {
        // Under the `removeNestedTemplates` optimization, a custom element like
        // `dom-if` or `dom-repeat` can itself be treated as the "template"; this
        // flag is used to switch between upgrading a `<template>` to be a property
        // effects client vs. adding the effects directly to the custom element
        const isTemplate = target.localName == 'template';
        // Provide data API and property effects on memoized template class
        let klass = templateInfo.templatizeTemplateClass;
        if (!klass) {
            if (isTemplate) {
                /**
         * @constructor
         * @extends {DataTemplate}
         */ let templatizedBase = options.mutableData ? $ef4bd86dedad51a0$var$MutableDataTemplate : $ef4bd86dedad51a0$var$DataTemplate;
                // NOTE: due to https://github.com/google/closure-compiler/issues/2928,
                // combining the next two lines into one assignment causes a spurious
                // type error.
                /** @private */ class TemplatizedTemplate extends templatizedBase {
                }
                klass = templateInfo.templatizeTemplateClass = TemplatizedTemplate;
            } else {
                /**
         * @constructor
         * @extends {PolymerElement}
         */ const templatizedBase = target.constructor;
                // Create a cached subclass of the base custom element class onto which
                // to put the template-specific propagate effects
                // NOTE: due to https://github.com/google/closure-compiler/issues/2928,
                // combining the next two lines into one assignment causes a spurious
                // type error.
                /** @private */ class TemplatizedTemplateExtension extends templatizedBase {
                }
                klass = templateInfo.templatizeTemplateClass = TemplatizedTemplateExtension;
            }
            // Add template - >instances effects
            // and host <- template effects
            let hostProps = templateInfo.hostProps;
            for(let prop in hostProps){
                klass.prototype._addPropertyEffect('_host_' + prop, klass.prototype.PROPERTY_EFFECT_TYPES.PROPAGATE, {
                    fn: $ef4bd86dedad51a0$var$createForwardHostPropEffect(prop, userForwardHostProp)
                });
                klass.prototype._createNotifyingProperty('_host_' + prop);
            }
            if ((0, $8bEdR.legacyWarnings) && methodHost) $ef4bd86dedad51a0$var$warnOnUndeclaredProperties(templateInfo, options, methodHost);
        }
        // Mix any pre-bound data into __data; no need to flush this to
        // instances since they pull from the template at instance-time
        if (target.__dataProto) // Note, generally `__dataProto` could be chained, but it's guaranteed
        // to not be since this is a vanilla template we just added effects to
        Object.assign(target.__data, target.__dataProto);
        if (isTemplate) {
            $ef4bd86dedad51a0$var$upgradeTemplate(target, klass);
            // Clear any pending data for performance
            target.__dataTemp = {};
            target.__dataPending = null;
            target.__dataOld = null;
            target._enableProperties();
        } else {
            // Swizzle the cached subclass prototype onto the custom element
            Object.setPrototypeOf(target, klass.prototype);
            // Check for any pre-bound instance host properties, and do the
            // instance property delete/assign dance for those (directly into data;
            // not need to go through accessor since they are pulled at instance time)
            const hostProps = templateInfo.hostProps;
            for(let prop in hostProps){
                prop = '_host_' + prop;
                if (prop in target) {
                    const val = target[prop];
                    delete target[prop];
                    target.__data[prop] = val;
                }
            }
        }
    }
}
/* eslint-enable valid-jsdoc */ function $ef4bd86dedad51a0$var$createForwardHostPropEffect(hostProp, userForwardHostProp) {
    return function forwardHostProp(template, prop, props) {
        userForwardHostProp.call(template.__templatizeOwner, prop.substring(6), props[prop]);
    };
}
function $ef4bd86dedad51a0$var$addNotifyEffects(klass, template, templateInfo, options) {
    let hostProps = templateInfo.hostProps || {};
    for(let iprop in options.instanceProps){
        delete hostProps[iprop];
        let userNotifyInstanceProp = options.notifyInstanceProp;
        if (userNotifyInstanceProp) klass.prototype._addPropertyEffect(iprop, klass.prototype.PROPERTY_EFFECT_TYPES.NOTIFY, {
            fn: $ef4bd86dedad51a0$var$createNotifyInstancePropEffect(iprop, userNotifyInstanceProp)
        });
    }
    if (options.forwardHostProp && template.__dataHost) for(let hprop in hostProps){
        // As we're iterating hostProps in this function, note whether
        // there were any, for an optimization in addPropagateEffects
        if (!templateInfo.hasHostProps) templateInfo.hasHostProps = true;
        klass.prototype._addPropertyEffect(hprop, klass.prototype.PROPERTY_EFFECT_TYPES.NOTIFY, {
            fn: $ef4bd86dedad51a0$var$createNotifyHostPropEffect()
        });
    }
}
function $ef4bd86dedad51a0$var$createNotifyInstancePropEffect(instProp, userNotifyInstanceProp) {
    return function notifyInstanceProp(inst, prop, props) {
        userNotifyInstanceProp.call(inst.__templatizeOwner, inst, prop, props[prop]);
    };
}
function $ef4bd86dedad51a0$var$createNotifyHostPropEffect() {
    return function notifyHostProp(inst, prop, props) {
        inst.__dataHost._setPendingPropertyOrPath('_host_' + prop, props[prop], true, true);
    };
}
function $ef4bd86dedad51a0$export$528486d340f30adf(template, owner, options) {
    // Under strictTemplatePolicy, the templatized element must be owned
    // by a (trusted) Polymer element, indicated by existence of _methodHost;
    // e.g. for dom-if & dom-repeat in main document, _methodHost is null
    if ((0, $8bEdR.strictTemplatePolicy) && !$ef4bd86dedad51a0$var$findMethodHost(template)) throw new Error('strictTemplatePolicy: template owner not trusted');
    options = /** @type {!TemplatizeOptions} */ options || {};
    if (template.__templatizeOwner) throw new Error('A <template> can only be templatized once');
    template.__templatizeOwner = owner;
    const ctor = owner ? owner.constructor : $ef4bd86dedad51a0$export$d325f89c810f68ec;
    let templateInfo = ctor._parseTemplate(template);
    // Get memoized base class for the prototypical template, which
    // includes property effects for binding template & forwarding
    /**
   * @constructor
   * @extends {TemplateInstanceBase}
   */ let baseClass = templateInfo.templatizeInstanceClass;
    if (!baseClass) {
        baseClass = $ef4bd86dedad51a0$var$createTemplatizerClass(template, templateInfo, options);
        templateInfo.templatizeInstanceClass = baseClass;
    }
    const methodHost = $ef4bd86dedad51a0$var$findMethodHost(template);
    // Host property forwarding must be installed onto template instance
    $ef4bd86dedad51a0$var$addPropagateEffects(template, templateInfo, options, methodHost);
    // Subclass base class and add reference for this specific template
    /** @private */ let klass = class TemplateInstance extends baseClass {
    };
    /** @override */ klass.prototype._methodHost = methodHost;
    /** @override */ klass.prototype.__dataHost = /** @type {!DataTemplate} */ template;
    /** @override */ klass.prototype.__templatizeOwner = /** @type {!Object} */ owner;
    /** @override */ klass.prototype.__hostProps = templateInfo.hostProps;
    /** @type {function(new:TemplateInstanceBase)} */ klass; //eslint-disable-line no-self-assign
    return klass;
}
function $ef4bd86dedad51a0$var$warnOnUndeclaredProperties(templateInfo, options, methodHost) {
    const declaredProps = methodHost.constructor._properties;
    const { propertyEffects: propertyEffects } = templateInfo;
    const { instanceProps: instanceProps } = options;
    for(let prop in propertyEffects)// Ensure properties with template effects are declared on the outermost
    // host (`methodHost`), unless they are instance props or static functions
    if (!declaredProps[prop] && !(instanceProps && instanceProps[prop])) {
        const effects = propertyEffects[prop];
        for(let i = 0; i < effects.length; i++){
            const { part: part } = effects[i].info;
            if (!(part.signature && part.signature.static)) {
                console.warn(`Property '${prop}' used in template but not ` + `declared in 'properties'; attribute will not be observed.`);
                break;
            }
        }
    }
}
function $ef4bd86dedad51a0$export$e8eeae76eca81f5(template, node) {
    let model;
    while(node)// An element with a __templatizeInstance marks the top boundary
    // of a scope; walk up until we find one, and then ensure that
    // its __dataHost matches `this`, meaning this dom-repeat stamped it
    if (model = node.__dataHost ? node : node.__templatizeInstance) {
        // Found an element stamped by another template; keep walking up
        // from its __dataHost
        if (model.__dataHost != template) node = model.__dataHost;
        else return model;
    } else // Still in a template scope, keep going up until
    // a __templatizeInstance is found
    node = (0, $a2HIe.wrap)(node).parentNode;
    return null;
}

});
parcelRegister("adT3u", function(module, exports) {

$parcel$export(module.exports, "MutableData", () => $7715d3215c37dead$export$7a02473fcc50534a);
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/ 
var $gLdkK = parcelRequire("gLdkK");
// Common implementation for mixin & behavior
function $7715d3215c37dead$var$mutablePropertyChange(inst, property, value, old, mutableData) {
    let isObject;
    if (mutableData) {
        isObject = typeof value === 'object' && value !== null;
        // Pull `old` for Objects from temp cache, but treat `null` as a primitive
        if (isObject) old = inst.__dataTemp[property];
    }
    // Strict equality check, but return false for NaN===NaN
    let shouldChange = old !== value && (old === old || value === value);
    // Objects are stored in temporary cache (cleared at end of
    // turn), which is used for dirty-checking
    if (isObject && shouldChange) inst.__dataTemp[property] = value;
    return shouldChange;
}
const $7715d3215c37dead$export$7a02473fcc50534a = (0, $gLdkK.dedupingMixin)((superClass)=>{
    /**
   * @polymer
   * @mixinClass
   * @implements {Polymer_MutableData}
   */ class MutableData extends superClass {
        /**
     * Overrides `PropertyEffects` to provide option for skipping
     * strict equality checking for Objects and Arrays.
     *
     * This method pulls the value to dirty check against from the `__dataTemp`
     * cache (rather than the normal `__data` cache) for Objects.  Since the temp
     * cache is cleared at the end of a turn, this implementation allows
     * side-effects of deep object changes to be processed by re-setting the
     * same object (using the temp cache as an in-turn backstop to prevent
     * cycles due to 2-way notification).
     *
     * @param {string} property Property name
     * @param {*} value New property value
     * @param {*} old Previous property value
     * @return {boolean} Whether the property should be considered a change
     * @protected
     */ _shouldPropertyChange(property, value, old) {
            return $7715d3215c37dead$var$mutablePropertyChange(this, property, value, old, true);
        }
    }
    return MutableData;
});
const $7715d3215c37dead$export$14b453e344e4d0b7 = (0, $gLdkK.dedupingMixin)((superClass)=>{
    /**
   * @mixinClass
   * @polymer
   * @implements {Polymer_OptionalMutableData}
   */ class OptionalMutableData extends superClass {
        /** @nocollapse */ static get properties() {
            return {
                /**
         * Instance-level flag for configuring the dirty-checking strategy
         * for this element.  When true, Objects and Arrays will skip dirty
         * checking, otherwise strict equality checking will be used.
         */ mutableData: Boolean
            };
        }
        /**
     * Overrides `PropertyEffects` to provide option for skipping
     * strict equality checking for Objects and Arrays.
     *
     * When `this.mutableData` is true on this instance, this method
     * pulls the value to dirty check against from the `__dataTemp` cache
     * (rather than the normal `__data` cache) for Objects.  Since the temp
     * cache is cleared at the end of a turn, this implementation allows
     * side-effects of deep object changes to be processed by re-setting the
     * same object (using the temp cache as an in-turn backstop to prevent
     * cycles due to 2-way notification).
     *
     * @param {string} property Property name
     * @param {*} value New property value
     * @param {*} old Previous property value
     * @return {boolean} Whether the property should be considered a change
     * @protected
     */ _shouldPropertyChange(property, value, old) {
            return $7715d3215c37dead$var$mutablePropertyChange(this, property, value, old, this.mutableData);
        }
    }
    return OptionalMutableData;
});
// Export for use by legacy behavior
$7715d3215c37dead$export$7a02473fcc50534a._mutablePropertyChange = $7715d3215c37dead$var$mutablePropertyChange;

});


parcelRegister("aC4kq", function(module, exports) {

$parcel$export(module.exports, "isIOS", () => $7ba0cf8201c34837$export$fedb369cb70207f1);
$parcel$export(module.exports, "isSafari", () => $7ba0cf8201c34837$export$95df08bae54cb4df);
$parcel$export(module.exports, "isTouch", () => $7ba0cf8201c34837$export$971e5333ff27c622);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ const $7ba0cf8201c34837$var$testUserAgent = (regexp)=>regexp.test(navigator.userAgent);
const $7ba0cf8201c34837$var$testPlatform = (regexp)=>regexp.test(navigator.platform);
const $7ba0cf8201c34837$var$testVendor = (regexp)=>regexp.test(navigator.vendor);
const $7ba0cf8201c34837$export$a11b0059900ceec8 = $7ba0cf8201c34837$var$testUserAgent(/Android/);
const $7ba0cf8201c34837$export$6446a186d09e379e = $7ba0cf8201c34837$var$testUserAgent(/Chrome/) && $7ba0cf8201c34837$var$testVendor(/Google Inc/);
const $7ba0cf8201c34837$export$b7d78993b74f766d = $7ba0cf8201c34837$var$testUserAgent(/Firefox/);
const $7ba0cf8201c34837$export$7bef049ce92e4224 = $7ba0cf8201c34837$var$testPlatform(/^iPad/) || $7ba0cf8201c34837$var$testPlatform(/^Mac/) && navigator.maxTouchPoints > 1;
const $7ba0cf8201c34837$export$186c6964ca17d99 = $7ba0cf8201c34837$var$testPlatform(/^iPhone/);
const $7ba0cf8201c34837$export$fedb369cb70207f1 = $7ba0cf8201c34837$export$186c6964ca17d99 || $7ba0cf8201c34837$export$7bef049ce92e4224;
const $7ba0cf8201c34837$export$95df08bae54cb4df = $7ba0cf8201c34837$var$testUserAgent(/^((?!chrome|android).)*safari/i);
const $7ba0cf8201c34837$export$971e5333ff27c622 = (()=>{
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
})();

});

parcelRegister("dieQ2", function(module, exports) {

$parcel$export(module.exports, "FocusTrapController", () => $9ad87765abbfc00e$export$65cd13c6aab87559);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $IaWw6 = parcelRequire("IaWw6");
const $9ad87765abbfc00e$var$instances = [];
class $9ad87765abbfc00e$export$65cd13c6aab87559 {
    /**
   * @param {HTMLElement} host
   */ constructor(host){
        /**
     * The controller host element.
     *
     * @type {HTMLElement}
     */ this.host = host;
        /**
     * A node for trapping focus in.
     *
     * @type {HTMLElement | null}
     * @private
     */ this.__trapNode = null;
        this.__onKeyDown = this.__onKeyDown.bind(this);
    }
    hostConnected() {
        document.addEventListener('keydown', this.__onKeyDown);
    }
    hostDisconnected() {
        document.removeEventListener('keydown', this.__onKeyDown);
    }
    /**
   * Activates a focus trap for a DOM node that will prevent focus from escaping the node.
   * The trap can be deactivated with the `.releaseFocus()` method.
   *
   * If focus is initially outside the trap, the method will move focus inside,
   * on the first focusable element of the trap in the tab order.
   * The first focusable element can be the trap node itself if it is focusable
   * and comes first in the tab order.
   *
   * If there are no focusable elements, the method will throw an exception
   * and the trap will not be set.
   *
   * @param {HTMLElement} trapNode
   */ trapFocus(trapNode) {
        this.__trapNode = trapNode;
        if (this.__focusableElements.length === 0) {
            this.__trapNode = null;
            throw new Error('The trap node should have at least one focusable descendant or be focusable itself.');
        }
        $9ad87765abbfc00e$var$instances.push(this);
        if (this.__focusedElementIndex === -1) this.__focusableElements[0].focus();
    }
    /**
   * Deactivates the focus trap set with the `.trapFocus()` method
   * so that it becomes possible to tab outside the trap node.
   */ releaseFocus() {
        this.__trapNode = null;
        $9ad87765abbfc00e$var$instances.pop();
    }
    /**
   * A `keydown` event handler that manages tabbing navigation when the trap is enabled.
   *
   * - Moves focus to the next focusable element of the trap on `Tab` press.
   * When no next element to focus, the method moves focus to the first focusable element.
   * - Moves focus to the prev focusable element of the trap on `Shift+Tab` press.
   * When no prev element to focus, the method moves focus to the last focusable element.
   *
   * @param {KeyboardEvent} event
   * @private
   */ __onKeyDown(event) {
        if (!this.__trapNode) return;
        // Only handle events for the last instance
        if (this !== Array.from($9ad87765abbfc00e$var$instances).pop()) return;
        if (event.key === 'Tab') {
            event.preventDefault();
            const backward = event.shiftKey;
            this.__focusNextElement(backward);
        }
    }
    /**
   * - Moves focus to the next focusable element if `backward === false`.
   * When no next element to focus, the method moves focus to the first focusable element.
   * - Moves focus to the prev focusable element if `backward === true`.
   * When no prev element to focus the method moves focus to the last focusable element.
   *
   * If no focusable elements, the method returns immediately.
   *
   * @param {boolean} backward
   * @private
   */ __focusNextElement(backward = false) {
        const focusableElements = this.__focusableElements;
        const step = backward ? -1 : 1;
        const currentIndex = this.__focusedElementIndex;
        const nextIndex = (focusableElements.length + currentIndex + step) % focusableElements.length;
        const element = focusableElements[nextIndex];
        element.focus();
        if (element.localName === 'input') element.select();
    }
    /**
   * An array of tab-ordered focusable elements inside the trap node.
   *
   * @return {HTMLElement[]}
   * @private
   */ get __focusableElements() {
        return (0, $IaWw6.getFocusableElements)(this.__trapNode);
    }
    /**
   * The index of the element inside the trap node that currently has focus.
   *
   * @return {HTMLElement | undefined}
   * @private
   */ get __focusedElementIndex() {
        const focusableElements = this.__focusableElements;
        return focusableElements.indexOf(focusableElements.filter((0, $IaWw6.isElementFocused)).pop());
    }
}

});



parcelRegister("hOjIW", function(module, exports) {

$parcel$export(module.exports, "loader", () => $cf7667ebb0c42fc9$export$f4c5de44377d2946);
/**
 * @license
 * Copyright (c) 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("bpTdN");
parcelRequire("6Yt1B");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
const $cf7667ebb0c42fc9$export$f4c5de44377d2946 = (0, $aOvNQ.css)`
  [part~='loader'] {
    box-sizing: border-box;
    width: var(--lumo-icon-size-s);
    height: var(--lumo-icon-size-s);
    border: 2px solid transparent;
    border-color: var(--lumo-primary-color-10pct) var(--lumo-primary-color-10pct) var(--lumo-primary-color)
      var(--lumo-primary-color);
    border-radius: calc(0.5 * var(--lumo-icon-size-s));
    opacity: 0;
    pointer-events: none;
  }

  :host(:not([loading])) [part~='loader'] {
    display: none;
  }

  :host([loading]) [part~='loader'] {
    animation: 1s linear infinite lumo-loader-rotate, 0.3s 0.1s lumo-loader-fade-in both;
  }

  @keyframes lumo-loader-fade-in {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes lumo-loader-rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;

});

parcelRegister("7FnXH", function(module, exports) {

$parcel$export(module.exports, "menuOverlayCore", () => $594ef318c599efbc$export$8f84a32fcf1a67e9);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");

var $bVfjI = parcelRequire("bVfjI");
const $594ef318c599efbc$export$8f84a32fcf1a67e9 = (0, $aOvNQ.css)`
  :host([opening]),
  :host([closing]) {
    animation: 0.14s lumo-overlay-dummy-animation;
  }

  [part='overlay'] {
    will-change: opacity, transform;
  }

  :host([opening]) [part='overlay'] {
    animation: 0.1s lumo-menu-overlay-enter ease-out both;
  }

  @keyframes lumo-menu-overlay-enter {
    0% {
      opacity: 0;
      transform: translateY(-4px);
    }
  }

  :host([closing]) [part='overlay'] {
    animation: 0.1s lumo-menu-overlay-exit both;
  }

  @keyframes lumo-menu-overlay-exit {
    100% {
      opacity: 0;
    }
  }
`;
(0, $2vXFS.registerStyles)('', $594ef318c599efbc$export$8f84a32fcf1a67e9, {
    moduleId: 'lumo-menu-overlay-core'
});
const $594ef318c599efbc$var$menuOverlayExt = (0, $aOvNQ.css)`
  /* Small viewport (bottom sheet) styles */
  /* Use direct media queries instead of the state attributes ([phone] and [fullscreen]) provided by the elements */
  @media (max-width: 420px), (max-height: 420px) {
    :host {
      top: 0 !important;
      right: 0 !important;
      bottom: var(--vaadin-overlay-viewport-bottom, 0) !important;
      left: 0 !important;
      align-items: stretch !important;
      justify-content: flex-end !important;
    }

    [part='overlay'] {
      max-height: 50vh;
      width: 100vw;
      border-radius: 0;
      box-shadow: var(--lumo-box-shadow-xl);
    }

    /* The content part scrolls instead of the overlay part, because of the gradient fade-out */
    [part='content'] {
      padding: 30px var(--lumo-space-m);
      max-height: inherit;
      box-sizing: border-box;
      -webkit-overflow-scrolling: touch;
      overflow: auto;
      -webkit-mask-image: linear-gradient(transparent, #000 40px, #000 calc(100% - 40px), transparent);
      mask-image: linear-gradient(transparent, #000 40px, #000 calc(100% - 40px), transparent);
    }

    [part='backdrop'] {
      display: block;
    }

    /* Animations */

    :host([opening]) [part='overlay'] {
      animation: 0.2s lumo-mobile-menu-overlay-enter cubic-bezier(0.215, 0.61, 0.355, 1) both;
    }

    :host([closing]),
    :host([closing]) [part='backdrop'] {
      animation-delay: 0.14s;
    }

    :host([closing]) [part='overlay'] {
      animation: 0.14s 0.14s lumo-mobile-menu-overlay-exit cubic-bezier(0.55, 0.055, 0.675, 0.19) both;
    }
  }

  @keyframes lumo-mobile-menu-overlay-enter {
    0% {
      transform: translateY(150%);
    }
  }

  @keyframes lumo-mobile-menu-overlay-exit {
    100% {
      transform: translateY(150%);
    }
  }
`;
const $594ef318c599efbc$export$97ec961ec34517c5 = [
    (0, $bVfjI.overlay),
    $594ef318c599efbc$export$8f84a32fcf1a67e9,
    $594ef318c599efbc$var$menuOverlayExt
];
(0, $2vXFS.registerStyles)('', $594ef318c599efbc$export$97ec961ec34517c5, {
    moduleId: 'lumo-menu-overlay'
});

});


parcelRegister("9zdvw", function(module, exports) {
parcelRequire("cX2A4");
parcelRequire("dTmEW");

});
parcelRegister("cX2A4", function(module, exports) {
parcelRequire("bpTdN");
parcelRequire("6Yt1B");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
(0, $2vXFS.registerStyles)('vaadin-input-container', (0, $aOvNQ.css)`
    :host {
      border-radius: var(--lumo-border-radius-m);
      background-color: var(--lumo-contrast-10pct);
      padding: 0 calc(0.375em + var(--lumo-border-radius-m) / 4 - 1px);
      font-weight: 500;
      line-height: 1;
      position: relative;
      cursor: text;
      box-sizing: border-box;
    }

    /* Used for hover and activation effects */
    :host::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: inherit;
      pointer-events: none;
      background-color: var(--lumo-contrast-50pct);
      opacity: 0;
      transition: transform 0.15s, opacity 0.2s;
      transform-origin: 100% 0;
    }

    ::slotted(:not([slot$='fix'])) {
      cursor: inherit;
      min-height: var(--lumo-text-field-size, var(--lumo-size-m));
      padding: 0 0.25em;
      --_lumo-text-field-overflow-mask-image: linear-gradient(to left, transparent, #000 1.25em);
      -webkit-mask-image: var(--_lumo-text-field-overflow-mask-image);
      mask-image: var(--_lumo-text-field-overflow-mask-image);
    }

    /* Read-only */
    :host([readonly]) {
      color: var(--lumo-secondary-text-color);
      background-color: transparent;
      cursor: default;
    }

    :host([readonly])::after {
      background-color: transparent;
      opacity: 1;
      border: 1px dashed var(--lumo-contrast-30pct);
    }

    /* Disabled */
    :host([disabled]) {
      background-color: var(--lumo-contrast-5pct);
    }

    :host([disabled]) ::slotted(*) {
      color: var(--lumo-disabled-text-color);
      -webkit-text-fill-color: var(--lumo-disabled-text-color);
    }

    /* Invalid */
    :host([invalid]) {
      background-color: var(--lumo-error-color-10pct);
    }

    :host([invalid])::after {
      background-color: var(--lumo-error-color-50pct);
    }

    /* Slotted icons */
    ::slotted(iron-icon),
    ::slotted(vaadin-icon) {
      color: var(--lumo-contrast-60pct);
      width: var(--lumo-icon-size-m);
      height: var(--lumo-icon-size-m);
    }

    /* Vaadin icons are based on a 16x16 grid (unlike Lumo and Material icons with 24x24), so they look too big by default */
    ::slotted(iron-icon[icon^='vaadin:']),
    ::slotted(vaadin-icon[icon^='vaadin:']) {
      padding: 0.25em;
      box-sizing: border-box !important;
    }

    /* Text align */
    :host([dir='rtl']) ::slotted(:not([slot$='fix'])) {
      --_lumo-text-field-overflow-mask-image: linear-gradient(to right, transparent, #000 1.25em);
    }

    @-moz-document url-prefix() {
      :host([dir='rtl']) ::slotted(:not([slot$='fix'])) {
        mask-image: var(--_lumo-text-field-overflow-mask-image);
      }
    }

    :host([theme~='align-left']) ::slotted(:not([slot$='fix'])) {
      text-align: start;
      --_lumo-text-field-overflow-mask-image: none;
    }

    :host([theme~='align-center']) ::slotted(:not([slot$='fix'])) {
      text-align: center;
      --_lumo-text-field-overflow-mask-image: none;
    }

    :host([theme~='align-right']) ::slotted(:not([slot$='fix'])) {
      text-align: end;
      --_lumo-text-field-overflow-mask-image: none;
    }

    @-moz-document url-prefix() {
      /* Firefox is smart enough to align overflowing text to right */
      :host([theme~='align-right']) ::slotted(:not([slot$='fix'])) {
        --_lumo-text-field-overflow-mask-image: linear-gradient(to right, transparent 0.25em, #000 1.5em);
      }
    }

    @-moz-document url-prefix() {
      /* Firefox is smart enough to align overflowing text to right */
      :host([theme~='align-left']) ::slotted(:not([slot$='fix'])) {
        --_lumo-text-field-overflow-mask-image: linear-gradient(to left, transparent 0.25em, #000 1.5em);
      }
    }

    /* RTL specific styles */
    :host([dir='rtl'])::after {
      transform-origin: 0% 0;
    }

    :host([theme~='align-left'][dir='rtl']) ::slotted(:not([slot$='fix'])) {
      --_lumo-text-field-overflow-mask-image: none;
    }

    :host([theme~='align-center'][dir='rtl']) ::slotted(:not([slot$='fix'])) {
      --_lumo-text-field-overflow-mask-image: none;
    }

    :host([theme~='align-right'][dir='rtl']) ::slotted(:not([slot$='fix'])) {
      --_lumo-text-field-overflow-mask-image: none;
    }

    @-moz-document url-prefix() {
      /* Firefox is smart enough to align overflowing text to right */
      :host([theme~='align-right'][dir='rtl']) ::slotted(:not([slot$='fix'])) {
        --_lumo-text-field-overflow-mask-image: linear-gradient(to right, transparent 0.25em, #000 1.5em);
      }
    }

    @-moz-document url-prefix() {
      /* Firefox is smart enough to align overflowing text to right */
      :host([theme~='align-left'][dir='rtl']) ::slotted(:not([slot$='fix'])) {
        --_lumo-text-field-overflow-mask-image: linear-gradient(to left, transparent 0.25em, #000 1.5em);
      }
    }
  `, {
    moduleId: 'lumo-input-container'
});

});

parcelRegister("dTmEW", function(module, exports) {

$parcel$export(module.exports, "InputContainer", () => $a1d1fd1802dc6930$export$b821cb5d358838ed);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $5ncN0 = parcelRequire("5ncN0");

var $2vXFS = parcelRequire("2vXFS");
class $a1d1fd1802dc6930$export$b821cb5d358838ed extends (0, $2vXFS.ThemableMixin)((0, $5ncN0.DirMixin)((0, $5QhZ5.PolymerElement))) {
    static get is() {
        return 'vaadin-input-container';
    }
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host {
          display: flex;
          align-items: center;
          flex: 0 1 auto;
        }

        :host([hidden]) {
          display: none !important;
        }

        /* Reset the native input styles */
        ::slotted(input) {
          -webkit-appearance: none;
          -moz-appearance: none;
          flex: auto;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          height: 100%;
          outline: none;
          margin: 0;
          padding: 0;
          border: 0;
          border-radius: 0;
          min-width: 0;
          font: inherit;
          line-height: normal;
          color: inherit;
          background-color: transparent;
          /* Disable default invalid style in Firefox */
          box-shadow: none;
        }

        ::slotted(*) {
          flex: none;
        }

        ::slotted(:is(input, textarea))::placeholder {
          /* Use ::slotted(input:placeholder-shown) in themes to style the placeholder. */
          /* because ::slotted(...)::placeholder does not work in Safari. */
          font: inherit;
          color: inherit;
          /* Override default opacity in Firefox */
          opacity: 1;
        }
      </style>
      <slot name="prefix"></slot>
      <slot></slot>
      <slot name="suffix"></slot>
    `;
    }
    static get properties() {
        return {
            /**
       * If true, the user cannot interact with this element.
       */ disabled: {
                type: Boolean,
                reflectToAttribute: true
            },
            /**
       * Set to true to make this element read-only.
       */ readonly: {
                type: Boolean,
                reflectToAttribute: true
            },
            /**
       * Set to true when the element is invalid.
       */ invalid: {
                type: Boolean,
                reflectToAttribute: true
            }
        };
    }
    /** @protected */ ready() {
        super.ready();
        this.addEventListener('pointerdown', (event)=>{
            if (event.target === this) // Prevent direct clicks to the input container from blurring the input
            event.preventDefault();
        });
        this.addEventListener('click', (event)=>{
            if (event.target === this) // The vaadin-input-container element was directly clicked,
            // focus any focusable child element from the default slot
            this.shadowRoot.querySelector('slot:not([name])').assignedNodes({
                flatten: true
            }).forEach((node)=>node.focus && node.focus());
        });
    }
}
customElements.define($a1d1fd1802dc6930$export$b821cb5d358838ed.is, $a1d1fd1802dc6930$export$b821cb5d358838ed);

});


parcelRegister("4ycUj", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("bpTdN");
parcelRequire("1IFGF");
parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");

var $bcBsR = parcelRequire("bcBsR");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $35045988b4aedf8a$var$chip = (0, $aOvNQ.css)`
  :host {
    font-size: var(--lumo-font-size-xxs);
    line-height: 1;
    padding: 0.3125em calc(0.5em + var(--lumo-border-radius-s) / 4);
    color: var(--lumo-body-text-color);
    border-radius: var(--lumo-border-radius-s);
    background-color: var(--lumo-contrast-20pct);
    cursor: var(--lumo-clickable-cursor);
  }

  :host([focused]) {
    background-color: var(--lumo-primary-color);
    color: var(--lumo-primary-contrast-color);
  }

  :host([focused]) [part='remove-button'] {
    color: inherit;
  }

  :host(:not([part~='overflow']):not([readonly]):not([disabled])) {
    padding-inline-end: 0;
  }

  :host([part~='overflow']) {
    position: relative;
    min-width: var(--lumo-size-xxs);
    margin-inline-start: var(--lumo-space-s);
  }

  :host([part~='overflow'])::before,
  :host([part~='overflow'])::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    border-left: calc(var(--lumo-space-s) / 4) solid;
    border-radius: var(--lumo-border-radius-s);
    border-color: var(--lumo-contrast-30pct);
  }

  :host([part~='overflow'])::before {
    left: calc(-1 * var(--lumo-space-s) / 2);
  }

  :host([part~='overflow'])::after {
    left: calc(-1 * var(--lumo-space-s));
  }

  :host([part~='overflow-two']) {
    margin-inline-start: calc(var(--lumo-space-s) / 2);
  }

  :host([part~='overflow-two'])::after {
    display: none;
  }

  :host([part~='overflow-one']) {
    margin-inline-start: 0;
  }

  :host([part~='overflow-one'])::before,
  :host([part~='overflow-one'])::after {
    display: none;
  }

  [part='label'] {
    font-weight: 500;
    line-height: 1.25;
  }

  [part='remove-button'] {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -0.3125em;
    margin-bottom: -0.3125em;
    margin-inline-start: auto;
    width: 1.25em;
    height: 1.25em;
    font-size: 1.5em;
    transition: none;
  }

  [part='remove-button']::before {
    content: var(--lumo-icons-cross);
  }

  :host([disabled]) [part='label'] {
    color: var(--lumo-disabled-text-color);
    -webkit-text-fill-color: var(--lumo-disabled-text-color);
    pointer-events: none;
  }
`;
(0, $2vXFS.registerStyles)('vaadin-multi-select-combo-box-chip', [
    (0, $bcBsR.fieldButton),
    $35045988b4aedf8a$var$chip
], {
    moduleId: 'lumo-multi-select-combo-box-chip'
});

});
parcelRegister("bcBsR", function(module, exports) {

$parcel$export(module.exports, "fieldButton", () => $827de05fd11ed050$export$a2f81f0e973500f1);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("bpTdN");
parcelRequire("1IFGF");
parcelRequire("6Yt1B");
parcelRequire("8Fvjg");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $827de05fd11ed050$export$a2f81f0e973500f1 = (0, $aOvNQ.css)`
  [part$='button'] {
    flex: none;
    width: 1em;
    height: 1em;
    line-height: 1;
    font-size: var(--lumo-icon-size-m);
    text-align: center;
    color: var(--lumo-contrast-60pct);
    transition: 0.2s color;
    cursor: var(--lumo-clickable-cursor);
  }

  [part$='button']:hover {
    color: var(--lumo-contrast-90pct);
  }

  :host([disabled]) [part$='button'],
  :host([readonly]) [part$='button'] {
    color: var(--lumo-contrast-20pct);
    cursor: default;
  }

  [part$='button']::before {
    font-family: 'lumo-icons';
    display: block;
  }
`;
(0, $2vXFS.registerStyles)('', $827de05fd11ed050$export$a2f81f0e973500f1, {
    moduleId: 'lumo-field-button'
});

});


parcelRegister("kse9V", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("bpTdN");
parcelRequire("1IFGF");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");

var $lJSN4 = parcelRequire("lJSN4");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
(0, $2vXFS.registerStyles)('vaadin-multi-select-combo-box-item', (0, $aOvNQ.css)`
    @media (any-hover: hover) {
      :host(:hover[readonly]) {
        background-color: transparent;
        cursor: default;
      }
    }
  `, {
    moduleId: 'lumo-multi-select-combo-box-item'
});
const $ee4167dd80834789$var$multiSelectComboBox = (0, $aOvNQ.css)`
  :host([has-value]) {
    padding-inline-start: 0;
  }

  :host([has-value]) ::slotted(input:placeholder-shown) {
    caret-color: var(--lumo-body-text-color) !important;
  }

  [part~='chip']:not(:last-of-type) {
    margin-inline-end: var(--lumo-space-xs);
  }

  [part~='overflow']:not([hidden]) + :not(:empty) {
    margin-inline-start: var(--lumo-space-xs);
  }

  [part='toggle-button']::before {
    content: var(--lumo-icons-dropdown);
  }

  :host([readonly][has-value]) [part='toggle-button'] {
    color: var(--lumo-contrast-60pct);
    cursor: var(--lumo-clickable-cursor);
  }
`;
(0, $2vXFS.registerStyles)('vaadin-multi-select-combo-box', [
    (0, $lJSN4.inputFieldShared),
    $ee4167dd80834789$var$multiSelectComboBox
], {
    moduleId: 'lumo-multi-select-combo-box'
});

});
parcelRegister("lJSN4", function(module, exports) {

$parcel$export(module.exports, "inputFieldShared", () => $fd384d31b517b888$export$bb4a547bb907939b);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("bpTdN");
parcelRequire("1IFGF");
parcelRequire("6Yt1B");
parcelRequire("gettf");
parcelRequire("8Fvjg");
parcelRequire("7Aef7");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");

var $bcBsR = parcelRequire("bcBsR");

var $dfakg = parcelRequire("dfakg");

var $cNhTY = parcelRequire("cNhTY");
const $fd384d31b517b888$export$6f2f4d5c38fc8e55 = (0, $aOvNQ.css)`
  :host {
    --lumo-text-field-size: var(--lumo-size-m);
    color: var(--lumo-body-text-color);
    font-size: var(--lumo-font-size-m);
    font-family: var(--lumo-font-family);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    padding: var(--lumo-space-xs) 0;
  }

  :host::before {
    height: var(--lumo-text-field-size);
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
  }

  :host([focused]:not([readonly])) [part='label'] {
    color: var(--lumo-primary-text-color);
  }

  :host([focused]) [part='input-field'] ::slotted(:is(input, textarea)) {
    -webkit-mask-image: none;
    mask-image: none;
  }

  ::slotted(:is(input, textarea):placeholder-shown) {
    color: var(--lumo-secondary-text-color);
  }

  /* Hover */
  :host(:hover:not([readonly]):not([focused])) [part='label'] {
    color: var(--lumo-body-text-color);
  }

  :host(:hover:not([readonly]):not([focused])) [part='input-field']::after {
    opacity: 0.1;
  }

  /* Touch device adjustment */
  @media (pointer: coarse) {
    :host(:hover:not([readonly]):not([focused])) [part='label'] {
      color: var(--lumo-secondary-text-color);
    }

    :host(:hover:not([readonly]):not([focused])) [part='input-field']::after {
      opacity: 0;
    }

    :host(:active:not([readonly]):not([focused])) [part='input-field']::after {
      opacity: 0.2;
    }
  }

  /* Trigger when not focusing using the keyboard */
  :host([focused]:not([focus-ring]):not([readonly])) [part='input-field']::after {
    transform: scaleX(0);
    transition-duration: 0.15s, 1s;
  }

  /* Focus-ring */
  :host([focus-ring]) [part='input-field'] {
    box-shadow: 0 0 0 2px var(--lumo-primary-color-50pct);
  }

  /* Read-only and disabled */
  :host(:is([readonly], [disabled])) ::slotted(:is(input, textarea):placeholder-shown) {
    opacity: 0;
  }

  /* Disabled style */
  :host([disabled]) {
    pointer-events: none;
  }

  :host([disabled]) [part='label'],
  :host([disabled]) [part='input-field'] ::slotted(*) {
    color: var(--lumo-disabled-text-color);
    -webkit-text-fill-color: var(--lumo-disabled-text-color);
  }

  /* Invalid style */
  :host([invalid][focus-ring]) [part='input-field'] {
    box-shadow: 0 0 0 2px var(--lumo-error-color-50pct);
  }

  :host([input-prevented]) [part='input-field'] {
    animation: shake 0.15s infinite;
  }

  @keyframes shake {
    25% {
      transform: translateX(4px);
    }
    75% {
      transform: translateX(-4px);
    }
  }

  /* Small theme */
  :host([theme~='small']) {
    font-size: var(--lumo-font-size-s);
    --lumo-text-field-size: var(--lumo-size-s);
  }

  :host([theme~='small']) [part='label'] {
    font-size: var(--lumo-font-size-xs);
  }

  :host([theme~='small']) [part='error-message'] {
    font-size: var(--lumo-font-size-xxs);
  }

  /* Slotted content */
  [part='input-field'] ::slotted(:not(iron-icon):not(vaadin-icon):not(input):not(textarea)) {
    color: var(--lumo-secondary-text-color);
    font-weight: 400;
  }

  [part='clear-button']::before {
    content: var(--lumo-icons-cross);
  }
`;
const $fd384d31b517b888$export$bb4a547bb907939b = [
    (0, $cNhTY.requiredField),
    (0, $bcBsR.fieldButton),
    (0, $dfakg.helper),
    $fd384d31b517b888$export$6f2f4d5c38fc8e55
];
(0, $2vXFS.registerStyles)('', $fd384d31b517b888$export$bb4a547bb907939b, {
    moduleId: 'lumo-input-field-shared-styles'
});

});


parcelRegister("dMEIK", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("gwhhH");
parcelRequire("j8ZKQ");
parcelRequire("78Uli");
parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $6eFtW = parcelRequire("6eFtW");

var $9Q7uu = parcelRequire("9Q7uu");

var $aOqV9 = parcelRequire("aOqV9");

var $gD7RT = parcelRequire("gD7RT");

var $6hU3M = parcelRequire("6hU3M");

var $3k8Wo = parcelRequire("3k8Wo");

var $1wMVk = parcelRequire("1wMVk");

var $jqW2B = parcelRequire("jqW2B");

var $aZ57t = parcelRequire("aZ57t");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
const $a08f585c67c0c0f4$var$multiSelectComboBox = (0, $aOvNQ.css)`
  :host {
    --input-min-width: var(--vaadin-multi-select-combo-box-input-min-width, 4em);
  }

  [hidden] {
    display: none !important;
  }

  #chips {
    display: flex;
    align-items: center;
  }

  ::slotted(input) {
    box-sizing: border-box;
    flex: 1 0 var(--input-min-width);
  }

  [part='chip'] {
    flex: 0 1 auto;
  }

  :host(:is([readonly], [disabled])) ::slotted(input) {
    flex-grow: 0;
    flex-basis: 0;
    padding: 0;
  }
`;
(0, $2vXFS.registerStyles)('vaadin-multi-select-combo-box', [
    (0, $aZ57t.inputFieldShared),
    $a08f585c67c0c0f4$var$multiSelectComboBox
], {
    moduleId: 'vaadin-multi-select-combo-box-styles'
});
/**
 * `<vaadin-multi-select-combo-box>` is a web component that wraps `<vaadin-combo-box>` and extends
 * its functionality to allow selecting multiple items, in addition to basic features.
 *
 * ```html
 * <vaadin-multi-select-combo-box id="comboBox"></vaadin-multi-select-combo-box>
 * ```
 *
 * ```js
 * const comboBox = document.querySelector('#comboBox');
 * comboBox.items = ['apple', 'banana', 'lemon', 'orange'];
 * comboBox.selectedItems = ['lemon', 'orange'];
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name              | Description
 * -----------------------|----------------
 * `chips`                | The element that wraps chips for selected items
 * `chip`                 | Chip shown for every selected item
 * `label`                | The label element
 * `input-field`          | The element that wraps prefix, value and suffix
 * `clear-button`         | The clear button
 * `error-message`        | The error message element
 * `helper-text`          | The helper text element wrapper
 * `required-indicator`   | The `required` state indicator element
 * `overflow`             | The chip shown when component width is not enough to fit all chips
 * `overflow-one`         | Set on the overflow chip when only one chip does not fit
 * `overflow-two`         | Set on the overflow chip when two chips do not fit
 * `toggle-button`        | The toggle button
 *
 * The following state attributes are available for styling:
 *
 * Attribute              | Description
 * -----------------------|-----------------
 * `disabled`             | Set to a disabled element
 * `has-value`            | Set when the element has a value
 * `has-label`            | Set when the element has a label
 * `has-helper`           | Set when the element has helper text or slot
 * `has-error-message`    | Set when the element has an error message
 * `invalid`              | Set when the element is invalid
 * `focused`              | Set when the element is focused
 * `focus-ring`           | Set when the element is keyboard focused
 * `loading`              | Set when loading items from the data provider
 * `opened`               | Set when the dropdown is open
 * `readonly`             | Set to a readonly element
 *
 * The following custom CSS properties are available for styling:
 *
 * Custom property                                      | Description                | Default
 * -----------------------------------------------------|----------------------------|--------
 * `--vaadin-field-default-width`                       | Default width of the field | `12em`
 * `--vaadin-multi-select-combo-box-overlay-width`      | Width of the overlay       | `auto`
 * `--vaadin-multi-select-combo-box-overlay-max-height` | Max height of the overlay  | `65vh`
 * `--vaadin-multi-select-combo-box-input-min-width`    | Min width of the input     | `4em`
 *
 * ### Internal components
 *
 * In addition to `<vaadin-multi-select-combo-box>` itself, the following internal
 * components are themable:
 *
 * - `<vaadin-multi-select-combo-box-overlay>` - has the same API as `<vaadin-overlay>`.
 * - `<vaadin-multi-select-combo-box-item>` - has the same API as `<vaadin-item>`.
 * - `<vaadin-multi-select-combo-box-container>` - has the same API as `<vaadin-input-container>`.
 *
 * Note: the `theme` attribute value set on `<vaadin-multi-select-combo-box>` is
 * propagated to these components.
 *
 * See [Styling Components](https://vaadin.com/docs/latest/styling/custom-theme/styling-components) documentation.
 *
 * @fires {Event} change - Fired when the user commits a value change.
 * @fires {CustomEvent} custom-value-set - Fired when the user sets a custom value.
 * @fires {CustomEvent} filter-changed - Fired when the `filter` property changes.
 * @fires {CustomEvent} invalid-changed - Fired when the `invalid` property changes.
 * @fires {CustomEvent} selected-items-changed - Fired when the `selectedItems` property changes.
 * @fires {CustomEvent} validated - Fired whenever the field is validated.
 *
 * @extends HTMLElement
 * @mixes ElementMixin
 * @mixes ThemableMixin
 * @mixes InputControlMixin
 * @mixes ResizeMixin
 */ class $a08f585c67c0c0f4$export$6c93596987a5515f extends (0, $aOqV9.ResizeMixin)((0, $3k8Wo.InputControlMixin)((0, $2vXFS.ThemableMixin)((0, $9Q7uu.ElementMixin)((0, $5QhZ5.PolymerElement))))) {
    static get is() {
        return 'vaadin-multi-select-combo-box';
    }
    static get template() {
        return (0, $76MHV.html)`
      <div class="vaadin-multi-select-combo-box-container">
        <div part="label">
          <slot name="label"></slot>
          <span part="required-indicator" aria-hidden="true" on-click="focus"></span>
        </div>

        <vaadin-multi-select-combo-box-internal
          id="comboBox"
          items="[[__effectiveItems]]"
          item-id-path="[[itemIdPath]]"
          item-label-path="[[itemLabelPath]]"
          item-value-path="[[itemValuePath]]"
          disabled="[[disabled]]"
          readonly="[[readonly]]"
          auto-open-disabled="[[autoOpenDisabled]]"
          allow-custom-value="[[allowCustomValue]]"
          data-provider="[[dataProvider]]"
          filter="{{filter}}"
          last-filter="{{_lastFilter}}"
          loading="{{loading}}"
          size="{{size}}"
          filtered-items="[[__effectiveFilteredItems]]"
          selected-items="[[selectedItems]]"
          opened="{{opened}}"
          renderer="[[renderer]]"
          theme$="[[_theme]]"
          on-combo-box-item-selected="_onComboBoxItemSelected"
          on-change="_onComboBoxChange"
          on-custom-value-set="_onCustomValueSet"
          on-filtered-items-changed="_onFilteredItemsChanged"
        >
          <vaadin-multi-select-combo-box-container
            part="input-field"
            readonly="[[readonly]]"
            disabled="[[disabled]]"
            invalid="[[invalid]]"
            theme$="[[_theme]]"
          >
            <vaadin-multi-select-combo-box-chip
              id="overflow"
              slot="prefix"
              part$="[[_getOverflowPart(_overflowItems.length)]]"
              disabled="[[disabled]]"
              readonly="[[readonly]]"
              label="[[_getOverflowLabel(_overflowItems.length)]]"
              title$="[[_getOverflowTitle(_overflowItems)]]"
              hidden$="[[_isOverflowHidden(_overflowItems.length)]]"
              on-mousedown="_preventBlur"
            ></vaadin-multi-select-combo-box-chip>
            <div id="chips" part="chips" slot="prefix"></div>
            <slot name="input"></slot>
            <div
              id="clearButton"
              part="clear-button"
              slot="suffix"
              on-touchend="_onClearButtonTouchend"
              aria-hidden="true"
            ></div>
            <div id="toggleButton" class="toggle-button" part="toggle-button" slot="suffix" aria-hidden="true"></div>
          </vaadin-multi-select-combo-box-container>
        </vaadin-multi-select-combo-box-internal>

        <div part="helper-text">
          <slot name="helper"></slot>
        </div>

        <div part="error-message">
          <slot name="error-message"></slot>
        </div>
      </div>

      <slot name="tooltip"></slot>
    `;
    }
    static get properties() {
        return {
            /**
       * Set true to prevent the overlay from opening automatically.
       * @attr {boolean} auto-open-disabled
       */ autoOpenDisabled: Boolean,
            /**
       * Set to true to display the clear icon which clears the input.
       * @attr {boolean} clear-button-visible
       */ clearButtonVisible: {
                type: Boolean,
                reflectToAttribute: true,
                observer: '_clearButtonVisibleChanged',
                value: false
            },
            /**
       * A full set of items to filter the visible options from.
       * The items can be of either `String` or `Object` type.
       */ items: {
                type: Array
            },
            /**
       * The item property used for a visual representation of the item.
       * @attr {string} item-label-path
       */ itemLabelPath: {
                type: String,
                value: 'label'
            },
            /**
       * Path for the value of the item. If `items` is an array of objects,
       * this property is used as a string value for the selected item.
       * @attr {string} item-value-path
       */ itemValuePath: {
                type: String,
                value: 'value'
            },
            /**
       * Path for the id of the item, used to detect whether the item is selected.
       * @attr {string} item-id-path
       */ itemIdPath: {
                type: String
            },
            /**
       * The object used to localize this component.
       * To change the default localization, replace the entire
       * _i18n_ object or just the property you want to modify.
       *
       * The object has the following JSON structure and default values:
       * ```
       * {
       *   // Screen reader announcement on clear button click.
       *   cleared: 'Selection cleared',
       *   // Screen reader announcement when a chip is focused.
       *   focused: ' focused. Press Backspace to remove',
       *   // Screen reader announcement when item is selected.
       *   selected: 'added to selection',
       *   // Screen reader announcement when item is deselected.
       *   deselected: 'removed from selection',
       *   // Screen reader announcement of the selected items count.
       *   // {count} is replaced with the actual count of items.
       *   total: '{count} items selected',
       * }
       * ```
       * @type {!MultiSelectComboBoxI18n}
       * @default {English/US}
       */ i18n: {
                type: Object,
                value: ()=>{
                    return {
                        cleared: 'Selection cleared',
                        focused: 'focused. Press Backspace to remove',
                        selected: 'added to selection',
                        deselected: 'removed from selection',
                        total: '{count} items selected'
                    };
                }
            },
            /**
       * True when loading items from the data provider, false otherwise.
       */ loading: {
                type: Boolean,
                value: false,
                reflectToAttribute: true
            },
            /**
       * When present, it specifies that the field is read-only.
       */ readonly: {
                type: Boolean,
                value: false,
                observer: '_readonlyChanged',
                reflectToAttribute: true
            },
            /**
       * The list of selected items.
       * Note: modifying the selected items creates a new array each time.
       */ selectedItems: {
                type: Array,
                value: ()=>[],
                notify: true
            },
            /**
       * True if the dropdown is open, false otherwise.
       */ opened: {
                type: Boolean,
                notify: true,
                value: false,
                reflectToAttribute: true
            },
            /**
       * Total number of items.
       */ size: {
                type: Number
            },
            /**
       * Number of items fetched at a time from the data provider.
       * @attr {number} page-size
       */ pageSize: {
                type: Number,
                value: 50,
                observer: '_pageSizeChanged'
            },
            /**
       * Function that provides items lazily. Receives two arguments:
       *
       * - `params` - Object with the following properties:
       *   - `params.page` Requested page index
       *   - `params.pageSize` Current page size
       *   - `params.filter` Currently applied filter
       *
       * - `callback(items, size)` - Callback function with arguments:
       *   - `items` Current page of items
       *   - `size` Total number of items.
       */ dataProvider: {
                type: Object
            },
            /**
       * When true, the user can input a value that is not present in the items list.
       * @attr {boolean} allow-custom-value
       */ allowCustomValue: {
                type: Boolean,
                value: false
            },
            /**
       * A hint to the user of what can be entered in the control.
       * The placeholder will be only displayed in the case when
       * there is no item selected.
       */ placeholder: {
                type: String,
                value: '',
                observer: '_placeholderChanged'
            },
            /**
       * Custom function for rendering the content of every item.
       * Receives three arguments:
       *
       * - `root` The `<vaadin-multi-select-combo-box-item>` internal container DOM element.
       * - `comboBox` The reference to the `<vaadin-multi-select-combo-box>` element.
       * - `model` The object with the properties related with the rendered
       *   item, contains:
       *   - `model.index` The index of the rendered item.
       *   - `model.item` The item.
       */ renderer: Function,
            /**
       * Filtering string the user has typed into the input field.
       */ filter: {
                type: String,
                value: '',
                notify: true
            },
            /**
       * A subset of items, filtered based on the user input. Filtered items
       * can be assigned directly to omit the internal filtering functionality.
       * The items can be of either `String` or `Object` type.
       */ filteredItems: Array,
            /** @private */ value: {
                type: String
            },
            /** @private */ __effectiveItems: {
                type: Array,
                computed: '__computeEffectiveItems(items, selectedItems, readonly)'
            },
            /** @private */ __effectiveFilteredItems: {
                type: Array,
                computed: '__computeEffectiveFilteredItems(items, filteredItems, selectedItems, readonly)'
            },
            /** @private */ _overflowItems: {
                type: Array,
                value: ()=>[]
            },
            /** @private */ _focusedChipIndex: {
                type: Number,
                value: -1,
                observer: '_focusedChipIndexChanged'
            },
            /** @private */ _lastFilter: {
                type: String
            }
        };
    }
    static get observers() {
        return [
            '_selectedItemsChanged(selectedItems, selectedItems.*)'
        ];
    }
    /** @protected */ get slotStyles() {
        const tag = this.localName;
        return [
            ...super.slotStyles,
            `
        ${tag}[has-value] input::placeholder {
          color: transparent !important;
        }
      `
        ];
    }
    /**
   * Used by `InputControlMixin` as a reference to the clear button element.
   * @protected
   * @return {!HTMLElement}
   */ get clearElement() {
        return this.$.clearButton;
    }
    /** @protected */ get _chips() {
        return this.shadowRoot.querySelectorAll('[part~="chip"]');
    }
    /** @protected */ ready() {
        super.ready();
        this.addController(new (0, $1wMVk.InputController)(this, (input)=>{
            this._setInputElement(input);
            this._setFocusElement(input);
            this.stateTarget = input;
            this.ariaTarget = input;
        }));
        this.addController(new (0, $jqW2B.LabelledInputController)(this.inputElement, this._labelController));
        this._tooltipController = new (0, $6hU3M.TooltipController)(this);
        this.addController(this._tooltipController);
        this._tooltipController.setPosition('top');
        this._tooltipController.setShouldShow((target)=>!target.opened);
        this._inputField = this.shadowRoot.querySelector('[part="input-field"]');
        this.__updateChips();
        (0, $gD7RT.processTemplates)(this);
    }
    /**
   * Returns true if the current input value satisfies all constraints (if any).
   * @return {boolean}
   */ checkValidity() {
        return this.required && !this.readonly ? this._hasValue : true;
    }
    /**
   * Clears the selected items.
   */ clear() {
        this.__updateSelection([]);
        (0, $6eFtW.announce)(this.i18n.cleared);
    }
    /**
   * Clears the cached pages and reloads data from data provider when needed.
   */ clearCache() {
        if (this.$ && this.$.comboBox) this.$.comboBox.clearCache();
    }
    /**
   * Requests an update for the content of items.
   * While performing the update, it invokes the renderer (passed in the `renderer` property) once an item.
   *
   * It is not guaranteed that the update happens immediately (synchronously) after it is requested.
   */ requestContentUpdate() {
        if (this.$ && this.$.comboBox) this.$.comboBox.requestContentUpdate();
    }
    /**
   * Override method inherited from `DisabledMixin` to forward disabled to chips.
   * @protected
   * @override
   */ _disabledChanged(disabled, oldDisabled) {
        super._disabledChanged(disabled, oldDisabled);
        if (disabled || oldDisabled) this.__updateChips();
    }
    /**
   * Override method inherited from `InputMixin` to forward the input to combo-box.
   * @protected
   * @override
   */ _inputElementChanged(input) {
        super._inputElementChanged(input);
        if (input) this.$.comboBox._setInputElement(input);
    }
    /**
   * Override method inherited from `FocusMixin` to validate on blur.
   * @param {boolean} focused
   * @protected
   */ _setFocused(focused) {
        super._setFocused(focused);
        if (!focused) {
            this._focusedChipIndex = -1;
            this.validate();
        }
    }
    /**
   * Implement callback from `ResizeMixin` to update chips.
   * @protected
   * @override
   */ _onResize() {
        this.__updateChips();
    }
    /**
   * Override method from `DelegateStateMixin` to set required state
   * using `aria-required` attribute instead of `required`, in order
   * to prevent screen readers from announcing "invalid entry".
   * @protected
   * @override
   */ _delegateAttribute(name, value) {
        if (!this.stateTarget) return;
        if (name === 'required') {
            this._delegateAttribute('aria-required', value ? 'true' : false);
            return;
        }
        super._delegateAttribute(name, value);
    }
    /**
   * Setting clear button visible reduces total space available
   * for rendering chips, and making it hidden increases it.
   * @private
   */ _clearButtonVisibleChanged(visible, oldVisible) {
        if (visible || oldVisible) this.__updateChips();
    }
    /**
   * Implement two-way binding for the `filteredItems` property
   * that can be set on the internal combo-box element.
   *
   * @param {CustomEvent} event
   * @private
   */ _onFilteredItemsChanged(event) {
        const { value: value } = event.detail;
        if (Array.isArray(value) || value == null) this.filteredItems = value;
    }
    /** @private */ _readonlyChanged(readonly, oldReadonly) {
        if (readonly || oldReadonly) this.__updateChips();
        if (this.dataProvider) this.clearCache();
    }
    /** @private */ _pageSizeChanged(pageSize, oldPageSize) {
        if (Math.floor(pageSize) !== pageSize || pageSize <= 0) {
            this.pageSize = oldPageSize;
            console.error('"pageSize" value must be an integer > 0');
        }
        this.$.comboBox.pageSize = this.pageSize;
    }
    /** @private */ _placeholderChanged(placeholder) {
        const tmpPlaceholder = this.__tmpA11yPlaceholder;
        // Do not store temporary placeholder
        if (tmpPlaceholder !== placeholder) {
            this.__savedPlaceholder = placeholder;
            if (tmpPlaceholder) this.placeholder = tmpPlaceholder;
        }
    }
    /** @private */ _selectedItemsChanged(selectedItems) {
        this._toggleHasValue(this._hasValue);
        // Use placeholder for announcing items
        if (this._hasValue) {
            const tmpPlaceholder = this._mergeItemLabels(selectedItems);
            this.__tmpA11yPlaceholder = tmpPlaceholder;
            this.placeholder = tmpPlaceholder;
        } else {
            delete this.__tmpA11yPlaceholder;
            this.placeholder = this.__savedPlaceholder;
        }
        // Re-render chips
        this.__updateChips();
        // Update selected for dropdown items
        this.requestContentUpdate();
    }
    /** @private */ _getItemLabel(item) {
        return this.$.comboBox._getItemLabel(item);
    }
    /** @private */ _getOverflowLabel(length) {
        return length;
    }
    /** @private */ _getOverflowPart(length) {
        let part = `chip overflow`;
        if (length === 1) part += ' overflow-one';
        else if (length === 2) part += ' overflow-two';
        return part;
    }
    /** @private */ _getOverflowTitle(items) {
        return this._mergeItemLabels(items);
    }
    /** @private */ _isOverflowHidden(length) {
        return length === 0;
    }
    /** @private */ _mergeItemLabels(items) {
        return items.map((item)=>this._getItemLabel(item)).join(', ');
    }
    /** @private */ _findIndex(item, selectedItems, itemIdPath) {
        if (itemIdPath && item) {
            for(let index = 0; index < selectedItems.length; index++){
                if (selectedItems[index] && selectedItems[index][itemIdPath] === item[itemIdPath]) return index;
            }
            return -1;
        }
        return selectedItems.indexOf(item);
    }
    /** @private */ __clearFilter() {
        this.filter = '';
        this.$.comboBox.clear();
    }
    /** @private */ __announceItem(itemLabel, isSelected, itemCount) {
        const state = isSelected ? 'selected' : 'deselected';
        const total = this.i18n.total.replace('{count}', itemCount || 0);
        (0, $6eFtW.announce)(`${itemLabel} ${this.i18n[state]} ${total}`);
    }
    /** @private */ __removeItem(item) {
        const itemsCopy = [
            ...this.selectedItems
        ];
        itemsCopy.splice(itemsCopy.indexOf(item), 1);
        this.__updateSelection(itemsCopy);
        const itemLabel = this._getItemLabel(item);
        this.__announceItem(itemLabel, false, itemsCopy.length);
    }
    /** @private */ __selectItem(item) {
        const itemsCopy = [
            ...this.selectedItems
        ];
        const index = this._findIndex(item, itemsCopy, this.itemIdPath);
        const itemLabel = this._getItemLabel(item);
        let isSelected = false;
        if (index !== -1) {
            const lastFilter = this._lastFilter;
            // Do not unselect when manually typing and committing an already selected item.
            if (lastFilter && lastFilter.toLowerCase() === itemLabel.toLowerCase()) {
                this.__clearFilter();
                return;
            }
            itemsCopy.splice(index, 1);
        } else {
            itemsCopy.push(item);
            isSelected = true;
        }
        this.__updateSelection(itemsCopy);
        // Suppress `value-changed` event.
        this.__clearFilter();
        this.__announceItem(itemLabel, isSelected, itemsCopy.length);
    }
    /** @private */ __updateSelection(selectedItems) {
        this.selectedItems = selectedItems;
        this.validate();
        this.dispatchEvent(new CustomEvent('change', {
            bubbles: true
        }));
    }
    /** @private */ __createChip(item) {
        const chip = document.createElement('vaadin-multi-select-combo-box-chip');
        chip.setAttribute('part', 'chip');
        chip.setAttribute('slot', 'prefix');
        chip.item = item;
        chip.disabled = this.disabled;
        chip.readonly = this.readonly;
        const label = this._getItemLabel(item);
        chip.label = label;
        chip.setAttribute('title', label);
        chip.addEventListener('item-removed', (e)=>this._onItemRemoved(e));
        chip.addEventListener('mousedown', (e)=>this._preventBlur(e));
        return chip;
    }
    /** @private */ __getOverflowWidth() {
        const chip = this.$.overflow;
        chip.style.visibility = 'hidden';
        chip.removeAttribute('hidden');
        // Detect max possible width of the overflow chip
        chip.setAttribute('part', 'chip overflow');
        const overflowStyle = getComputedStyle(chip);
        const overflowWidth = chip.clientWidth + parseInt(overflowStyle.marginInlineStart);
        chip.setAttribute('hidden', '');
        chip.style.visibility = '';
        return overflowWidth;
    }
    /** @private */ __updateChips() {
        if (!this._inputField || !this.inputElement) return;
        // Clear all chips except the overflow
        Array.from(this._chips).forEach((chip)=>{
            if (chip !== this.$.overflow) chip.remove();
        });
        const items = [
            ...this.selectedItems
        ];
        // Detect available remaining width for chips
        const totalWidth = this._inputField.$.wrapper.clientWidth;
        const inputWidth = parseInt(getComputedStyle(this.inputElement).flexBasis);
        let remainingWidth = totalWidth - inputWidth;
        if (items.length > 1) remainingWidth -= this.__getOverflowWidth();
        // Add chips until remaining width is exceeded
        for(let i = items.length - 1, refNode = null; i >= 0; i--){
            const chip = this.__createChip(items[i]);
            this.$.chips.insertBefore(chip, refNode);
            if (this.$.chips.clientWidth > remainingWidth) {
                chip.remove();
                break;
            }
            items.pop();
            refNode = chip;
        }
        this._overflowItems = items;
    }
    /** @private */ _onClearButtonTouchend(event) {
        // Cancel the following click and focus events
        event.preventDefault();
        this.clear();
    }
    /**
   * Override method inherited from `InputControlMixin` and clear items.
   * @protected
   * @override
   */ _onClearButtonClick(event) {
        event.stopPropagation();
        this.clear();
    }
    /**
   * Override an event listener from `InputControlMixin` to
   * stop the change event re-targeted from the input.
   *
   * @param {!Event} event
   * @protected
   * @override
   */ _onChange(event) {
        event.stopPropagation();
    }
    /**
   * Override an event listener from `KeyboardMixin`.
   * Do not call `super` in order to override clear
   * button logic defined in `InputControlMixin`.
   *
   * @param {!KeyboardEvent} event
   * @protected
   * @override
   */ _onEscape(event) {
        if (this.clearButtonVisible && this.selectedItems && this.selectedItems.length) {
            event.stopPropagation();
            this.selectedItems = [];
        }
    }
    /**
   * Override an event listener from `KeyboardMixin`.
   * @param {KeyboardEvent} event
   * @protected
   * @override
   */ _onKeyDown(event) {
        super._onKeyDown(event);
        const chips = Array.from(this._chips).slice(1);
        if (!this.readonly && chips.length > 0) switch(event.key){
            case 'Backspace':
                this._onBackSpace(chips);
                break;
            case 'ArrowLeft':
                this._onArrowLeft(chips, event);
                break;
            case 'ArrowRight':
                this._onArrowRight(chips, event);
                break;
            default:
                this._focusedChipIndex = -1;
                break;
        }
    }
    /** @private */ _onArrowLeft(chips, event) {
        if (this.inputElement.selectionStart !== 0) return;
        const idx = this._focusedChipIndex;
        if (idx !== -1) event.preventDefault();
        let newIdx;
        if (this.getAttribute('dir') !== 'rtl') {
            if (idx === -1) // Focus last chip
            newIdx = chips.length - 1;
            else if (idx > 0) // Focus prev chip
            newIdx = idx - 1;
        } else if (idx === chips.length - 1) // Blur last chip
        newIdx = -1;
        else if (idx > -1) // Focus next chip
        newIdx = idx + 1;
        if (newIdx !== undefined) this._focusedChipIndex = newIdx;
    }
    /** @private */ _onArrowRight(chips, event) {
        if (this.inputElement.selectionStart !== 0) return;
        const idx = this._focusedChipIndex;
        if (idx !== -1) event.preventDefault();
        let newIdx;
        if (this.getAttribute('dir') === 'rtl') {
            if (idx === -1) // Focus last chip
            newIdx = chips.length - 1;
            else if (idx > 0) // Focus prev chip
            newIdx = idx - 1;
        } else if (idx === chips.length - 1) // Blur last chip
        newIdx = -1;
        else if (idx > -1) // Focus next chip
        newIdx = idx + 1;
        if (newIdx !== undefined) this._focusedChipIndex = newIdx;
    }
    /** @private */ _onBackSpace(chips) {
        if (this.inputElement.selectionStart !== 0) return;
        const idx = this._focusedChipIndex;
        if (idx === -1) this._focusedChipIndex = chips.length - 1;
        else {
            this.__removeItem(chips[idx].item);
            this._focusedChipIndex = -1;
        }
    }
    /** @private */ _focusedChipIndexChanged(focusedIndex, oldFocusedIndex) {
        if (focusedIndex > -1 || oldFocusedIndex > -1) {
            const chips = Array.from(this._chips).slice(1);
            chips.forEach((chip, index)=>{
                chip.toggleAttribute('focused', index === focusedIndex);
            });
            // Announce focused chip
            if (focusedIndex > -1) {
                const item = chips[focusedIndex].item;
                const itemLabel = this._getItemLabel(item);
                (0, $6eFtW.announce)(`${itemLabel} ${this.i18n.focused}`);
            }
        }
    }
    /** @private */ _onComboBoxChange() {
        const item = this.$.comboBox.selectedItem;
        if (item) this.__selectItem(item);
    }
    /** @private */ _onComboBoxItemSelected(event) {
        this.__selectItem(event.detail.item);
    }
    /** @private */ _onCustomValueSet(event) {
        // Do not set combo-box value
        event.preventDefault();
        // Stop the original event
        event.stopPropagation();
        this.__clearFilter();
        this.dispatchEvent(new CustomEvent('custom-value-set', {
            detail: event.detail,
            composed: true,
            bubbles: true
        }));
    }
    /** @private */ _onItemRemoved(event) {
        this.__removeItem(event.detail.item);
    }
    /** @private */ _preventBlur(event) {
        // Prevent mousedown event to keep the input focused
        // and keep the overlay opened when clicking a chip.
        event.preventDefault();
    }
    /** @private */ __computeEffectiveItems(items, selectedItems, readonly) {
        return items && readonly ? selectedItems : items;
    }
    /** @private */ __computeEffectiveFilteredItems(items, filteredItems, selectedItems, readonly) {
        return !items && readonly ? selectedItems : filteredItems;
    }
    /**
   * Override a method from `InputMixin` to
   * compute the presence of value based on `selectedItems`.
   *
   * @protected
   * @override
   */ get _hasValue() {
        return this.selectedItems && this.selectedItems.length > 0;
    }
}
customElements.define($a08f585c67c0c0f4$export$6c93596987a5515f.is, $a08f585c67c0c0f4$export$6c93596987a5515f);

});
parcelRegister("gwhhH", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $2vXFS = parcelRequire("2vXFS");
/**
 * An element used by `<vaadin-multi-select-combo-box>` to display selected items.
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name        | Description
 * -----------------|-------------
 * `label`          | Element containing the label
 * `remove-button`  | Remove button
 *
 * See [Styling Components](https://vaadin.com/docs/latest/styling/custom-theme/styling-components) documentation.
 *
 * @extends HTMLElement
 * @private
 */ class $c06d0ad5ee876d5a$var$MultiSelectComboBoxChip extends (0, $2vXFS.ThemableMixin)((0, $5QhZ5.PolymerElement)) {
    static get is() {
        return 'vaadin-multi-select-combo-box-chip';
    }
    static get properties() {
        return {
            disabled: {
                type: Boolean,
                reflectToAttribute: true
            },
            readonly: {
                type: Boolean,
                reflectToAttribute: true
            },
            label: {
                type: String
            },
            item: {
                type: Object
            }
        };
    }
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host {
          display: inline-flex;
          align-items: center;
          align-self: center;
          white-space: nowrap;
          box-sizing: border-box;
        }

        [part='label'] {
          overflow: hidden;
          text-overflow: ellipsis;
        }

        :host(:is([readonly], [disabled], [part~='overflow'])) [part='remove-button'] {
          display: none !important;
        }
      </style>
      <div part="label">[[label]]</div>
      <div part="remove-button" role="button" on-click="_onRemoveClick"></div>
    `;
    }
    /** @private */ _onRemoveClick(event) {
        event.stopPropagation();
        this.dispatchEvent(new CustomEvent('item-removed', {
            detail: {
                item: this.item
            },
            bubbles: true,
            composed: true
        }));
    }
}
customElements.define($c06d0ad5ee876d5a$var$MultiSelectComboBoxChip.is, $c06d0ad5ee876d5a$var$MultiSelectComboBoxChip);

});

parcelRegister("j8ZKQ", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $dTmEW = parcelRequire("dTmEW");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
(0, $2vXFS.registerStyles)('vaadin-multi-select-combo-box-container', (0, $aOvNQ.css)`
    #wrapper {
      display: flex;
      width: 100%;
    }
  `, {
    moduleId: 'vaadin-multi-select-combo-box-container-styles'
});
let $defeaad747fdc9f2$var$memoizedTemplate;
/**
 * An element used internally by `<vaadin-multi-select-combo-box>`. Not intended to be used separately.
 *
 * @extends InputContainer
 * @private
 */ class $defeaad747fdc9f2$var$MultiSelectComboBoxContainer extends (0, $dTmEW.InputContainer) {
    static get is() {
        return 'vaadin-multi-select-combo-box-container';
    }
    static get template() {
        if (!$defeaad747fdc9f2$var$memoizedTemplate) {
            $defeaad747fdc9f2$var$memoizedTemplate = super.template.cloneNode(true);
            const content = $defeaad747fdc9f2$var$memoizedTemplate.content;
            const slots = content.querySelectorAll('slot');
            const wrapper = document.createElement('div');
            wrapper.setAttribute('id', 'wrapper');
            content.insertBefore(wrapper, slots[2]);
            wrapper.appendChild(slots[0]);
            wrapper.appendChild(slots[1]);
        }
        return $defeaad747fdc9f2$var$memoizedTemplate;
    }
}
customElements.define($defeaad747fdc9f2$var$MultiSelectComboBoxContainer.is, $defeaad747fdc9f2$var$MultiSelectComboBoxContainer);

});

parcelRegister("78Uli", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("eATdP");
parcelRequire("2Ra6y");
parcelRequire("cHjQp");
parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $hX2nQ = parcelRequire("hX2nQ");

var $3tdkf = parcelRequire("3tdkf");

var $2XUc1 = parcelRequire("2XUc1");

var $2vXFS = parcelRequire("2vXFS");
/**
 * An element used internally by `<vaadin-multi-select-combo-box>`. Not intended to be used separately.
 *
 * @extends HTMLElement
 * @mixes ComboBoxDataProviderMixin
 * @mixes ComboBoxMixin
 * @mixes ThemableMixin
 * @private
 */ class $5334fc3006ccdc4f$var$MultiSelectComboBoxInternal extends (0, $hX2nQ.ComboBoxDataProviderMixin)((0, $3tdkf.ComboBoxMixin)((0, $2vXFS.ThemableMixin)((0, $5QhZ5.PolymerElement)))) {
    static get is() {
        return 'vaadin-multi-select-combo-box-internal';
    }
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host([opened]) {
          pointer-events: auto;
        }
      </style>

      <slot></slot>

      <vaadin-multi-select-combo-box-overlay
        id="overlay"
        opened="[[_overlayOpened]]"
        loading$="[[loading]]"
        theme$="[[_theme]]"
        position-target="[[_target]]"
        no-vertical-overlap
        restore-focus-node="[[inputElement]]"
      ></vaadin-multi-select-combo-box-overlay>
    `;
    }
    static get properties() {
        return {
            /**
       * A subset of items, filtered based on the user input.
       */ filteredItems: {
                type: Array,
                notify: true
            },
            /**
       * When set to `true`, "loading" attribute is set
       * on the host and the overlay element.
       * @type {boolean}
       */ loading: {
                type: Boolean,
                notify: true
            },
            /**
       * Total number of items.
       * @type {number | undefined}
       */ size: {
                type: Number,
                notify: true
            },
            /**
       * Selected items to render in the dropdown
       * when the component is read-only.
       */ selectedItems: {
                type: Array,
                value: ()=>[]
            },
            /**
       * Last input value entered by the user before value is updated.
       * Used to store `filter` property value before clearing it.
       */ lastFilter: {
                type: String,
                notify: true
            },
            _target: {
                type: Object
            }
        };
    }
    /**
   * Reference to the clear button element.
   * @protected
   * @return {!HTMLElement}
   */ get clearElement() {
        return this.querySelector('[part="clear-button"]');
    }
    /**
   * Tag name prefix used by scroller and items.
   * @protected
   * @return {string}
   */ get _tagNamePrefix() {
        return 'vaadin-multi-select-combo-box';
    }
    /**
   * Override method inherited from the combo-box
   * to allow opening dropdown when readonly.
   * @override
   */ open() {
        if (!this.disabled && !(this.readonly && this.selectedItems.length === 0)) this.opened = true;
    }
    /** @protected */ ready() {
        super.ready();
        this._target = this;
        this._toggleElement = this.querySelector('.toggle-button');
    }
    /**
   * Override combo-box method to set correct owner for using by item renderers.
   * This needs to be done before the scroller gets added to the DOM to ensure
   * Lit directive works in case when combo-box is opened using attribute.
   *
   * @protected
   * @override
   */ _initScroller() {
        const comboBox = this.getRootNode().host;
        super._initScroller(comboBox);
    }
    /**
   * Override method from `InputMixin`.
   *
   * @protected
   * @override
   */ clear() {
        super.clear();
        if (this.inputElement) this.inputElement.value = '';
    }
    /**
   * Override Enter handler to keep overlay open
   * when item is selected or unselected.
   * @param {!Event} event
   * @protected
   * @override
   */ _onEnter(event) {
        this.__enterPressed = true;
        super._onEnter(event);
    }
    /**
   * @protected
   * @override
   */ _closeOrCommit() {
        if (this.readonly) {
            this.close();
            return;
        }
        if (this.__enterPressed) {
            this.__enterPressed = null;
            // Keep selected item focused after committing on Enter.
            const focusedItem = this.filteredItems[this._focusedIndex];
            this._commitValue();
            this._focusedIndex = this.filteredItems.indexOf(focusedItem);
            return;
        }
        super._closeOrCommit();
    }
    /**
   * @protected
   * @override
   */ _commitValue() {
        // Store filter value for checking if user input is matching
        // an item which is already selected, to not un-select it.
        this.lastFilter = this.filter;
        super._commitValue();
    }
    /**
   * Override method inherited from the combo-box
   * to not update focused item when readonly.
   * @protected
   * @override
   */ _onArrowDown() {
        if (!this.readonly) super._onArrowDown();
        else if (!this.opened) this.open();
    }
    /**
   * Override method inherited from the combo-box
   * to not update focused item when readonly.
   * @protected
   * @override
   */ _onArrowUp() {
        if (!this.readonly) super._onArrowUp();
        else if (!this.opened) this.open();
    }
    /**
   * Override method inherited from the combo-box
   * to close dropdown on blur when readonly.
   * @param {FocusEvent} event
   * @protected
   * @override
   */ _onFocusout(event) {
        // Disable combo-box logic that updates selectedItem
        // based on the overlay focused index on input blur
        this._ignoreCommitValue = true;
        super._onFocusout(event);
        if (this.readonly && !this._closeOnBlurIsPrevented) this.close();
    }
    /**
   * Override method inherited from the combo-box
   * to not commit an already selected item again
   * on blur, which would result in un-selecting.
   * @protected
   * @override
   */ _detectAndDispatchChange() {
        if (this._ignoreCommitValue) {
            this._ignoreCommitValue = false;
            // Reset internal combo-box state
            this.selectedItem = null;
            this._inputElementValue = '';
            return;
        }
        super._detectAndDispatchChange();
    }
    /**
   * @param {CustomEvent} event
   * @protected
   * @override
   */ _overlaySelectedItemChanged(event) {
        event.stopPropagation();
        // Do not un-select on click when readonly
        if (this.readonly) return;
        if (event.detail.item instanceof (0, $2XUc1.ComboBoxPlaceholder)) return;
        if (this.opened) this.dispatchEvent(new CustomEvent('combo-box-item-selected', {
            detail: {
                item: event.detail.item
            }
        }));
    }
    /**
   * Override method inherited from the combo-box
   * to not request data provider when read-only.
   *
   * @param {number}
   * @return {boolean}
   * @protected
   * @override
   */ _shouldLoadPage(page) {
        if (this.readonly) return false;
        return super._shouldLoadPage(page);
    }
    /**
   * Override method inherited from the combo-box
   * to not clear the data provider cache when read-only.
   *
   * @protected
   * @override
   */ clearCache() {
        if (this.readonly) return;
        super.clearCache();
    }
}
customElements.define($5334fc3006ccdc4f$var$MultiSelectComboBoxInternal.is, $5334fc3006ccdc4f$var$MultiSelectComboBoxInternal);

});
parcelRegister("eATdP", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $3RBqN = parcelRequire("3RBqN");
/**
 * An element used for items in `<vaadin-multi-select-combo-box>`.
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ----------|-------------
 * `content` | The element that wraps the item content
 *
 * The following state attributes are exposed for styling:
 *
 * Attribute  | Description                   | Part name
 * -----------|-------------------------------|-----------
 * `selected` | Set when the item is selected | :host
 * `focused`  | Set when the item is focused  | :host
 *
 * See [Styling Components](https://vaadin.com/docs/latest/styling/custom-theme/styling-components) documentation.
 *
 * @extends ComboBoxItem
 * @private
 */ class $a9ff437038f30c39$var$MultiSelectComboBoxItem extends (0, $3RBqN.ComboBoxItem) {
    static get is() {
        return 'vaadin-multi-select-combo-box-item';
    }
}
customElements.define($a9ff437038f30c39$var$MultiSelectComboBoxItem.is, $a9ff437038f30c39$var$MultiSelectComboBoxItem);

});
parcelRegister("3RBqN", function(module, exports) {

$parcel$export(module.exports, "ComboBoxItem", () => $2d035b68d896b268$export$b674b8ff01584ab1);
/**
 * @license
 * Copyright (c) 2015 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $5ncN0 = parcelRequire("5ncN0");

var $2vXFS = parcelRequire("2vXFS");
class $2d035b68d896b268$export$b674b8ff01584ab1 extends (0, $2vXFS.ThemableMixin)((0, $5ncN0.DirMixin)((0, $5QhZ5.PolymerElement))) {
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host {
          display: block;
        }

        :host([hidden]) {
          display: none;
        }
      </style>
      <span part="checkmark" aria-hidden="true"></span>
      <div part="content">
        <slot></slot>
      </div>
    `;
    }
    static get is() {
        return 'vaadin-combo-box-item';
    }
    static get properties() {
        return {
            /**
       * The index of the item
       */ index: Number,
            /**
       * The item to render
       * @type {(String|Object)}
       */ item: Object,
            /**
       * The text label corresponding to the item
       */ label: String,
            /**
       * True when item is selected
       */ selected: {
                type: Boolean,
                value: false,
                reflectToAttribute: true
            },
            /**
       * True when item is focused
       */ focused: {
                type: Boolean,
                value: false,
                reflectToAttribute: true
            },
            /**
       * Custom function for rendering the content of the `<vaadin-combo-box-item>` propagated from the combo box element.
       */ renderer: Function,
            /**
       * Saved instance of a custom renderer function.
       */ _oldRenderer: Function
        };
    }
    static get observers() {
        return [
            '__rendererOrItemChanged(renderer, index, item.*, selected, focused)',
            '__updateLabel(label, renderer)'
        ];
    }
    connectedCallback() {
        super.connectedCallback();
        this._comboBox = this.parentNode.comboBox;
        const hostDir = this._comboBox.getAttribute('dir');
        if (hostDir) this.setAttribute('dir', hostDir);
    }
    /**
   * Requests an update for the content of the item.
   * While performing the update, it invokes the renderer passed in the `renderer` property.
   *
   * It is not guaranteed that the update happens immediately (synchronously) after it is requested.
   */ requestContentUpdate() {
        if (!this.renderer) return;
        const model = {
            index: this.index,
            item: this.item,
            focused: this.focused,
            selected: this.selected
        };
        this.renderer(this, this._comboBox, model);
    }
    /** @private */ __rendererOrItemChanged(renderer, index, item) {
        if (item === undefined || index === undefined) return;
        if (this._oldRenderer !== renderer) {
            this.innerHTML = '';
            // Whenever a Lit-based renderer is used, it assigns a Lit part to the node it was rendered into.
            // When clearing the rendered content, this part needs to be manually disposed of.
            // Otherwise, using a Lit-based renderer on the same node will throw an exception or render nothing afterward.
            delete this._$litPart$;
        }
        if (renderer) {
            this._oldRenderer = renderer;
            this.requestContentUpdate();
        }
    }
    /** @private */ __updateLabel(label, renderer) {
        if (renderer) return;
        this.textContent = label;
    }
}
customElements.define($2d035b68d896b268$export$b674b8ff01584ab1.is, $2d035b68d896b268$export$b674b8ff01584ab1);

});


parcelRegister("2Ra6y", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $9FHeo = parcelRequire("9FHeo");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
(0, $2vXFS.registerStyles)('vaadin-multi-select-combo-box-overlay', (0, $aOvNQ.css)`
    #overlay {
      width: var(
        --vaadin-multi-select-combo-box-overlay-width,
        var(--_vaadin-multi-select-combo-box-overlay-default-width, auto)
      );
    }
  `, {
    moduleId: 'vaadin-multi-select-combo-box-overlay-styles'
});
/**
 * An element used internally by `<vaadin-multi-select-combo-box>`. Not intended to be used separately.
 *
 * @extends ComboBoxOverlay
 * @private
 */ class $21485e97e318d791$var$MultiSelectComboBoxOverlay extends (0, $9FHeo.ComboBoxOverlay) {
    static get is() {
        return 'vaadin-multi-select-combo-box-overlay';
    }
}
customElements.define($21485e97e318d791$var$MultiSelectComboBoxOverlay.is, $21485e97e318d791$var$MultiSelectComboBoxOverlay);

});
parcelRegister("9FHeo", function(module, exports) {

$parcel$export(module.exports, "ComboBoxOverlay", () => $70a97a33f54c7e90$export$8be4a7dba820c42c);
/**
 * @license
 * Copyright (c) 2015 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $1G1tO = parcelRequire("1G1tO");

var $iJd0K = parcelRequire("iJd0K");
parcelRequire("2vXFS");
var $aOvNQ = parcelRequire("aOvNQ");
var $2vXFS = parcelRequire("2vXFS");
(0, $2vXFS.registerStyles)('vaadin-combo-box-overlay', (0, $aOvNQ.css)`
    #overlay {
      width: var(--vaadin-combo-box-overlay-width, var(--_vaadin-combo-box-overlay-default-width, auto));
    }

    [part='content'] {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  `, {
    moduleId: 'vaadin-combo-box-overlay-styles'
});
let $70a97a33f54c7e90$var$memoizedTemplate;
class $70a97a33f54c7e90$export$8be4a7dba820c42c extends (0, $iJd0K.PositionMixin)((0, $1G1tO.Overlay)) {
    static get is() {
        return 'vaadin-combo-box-overlay';
    }
    static get template() {
        if (!$70a97a33f54c7e90$var$memoizedTemplate) {
            $70a97a33f54c7e90$var$memoizedTemplate = super.template.cloneNode(true);
            $70a97a33f54c7e90$var$memoizedTemplate.content.querySelector('[part~="overlay"]').removeAttribute('tabindex');
        }
        return $70a97a33f54c7e90$var$memoizedTemplate;
    }
    static get observers() {
        return [
            '_setOverlayWidth(positionTarget, opened)'
        ];
    }
    connectedCallback() {
        super.connectedCallback();
        const comboBox = this._comboBox;
        const hostDir = comboBox && comboBox.getAttribute('dir');
        if (hostDir) this.setAttribute('dir', hostDir);
    }
    ready() {
        super.ready();
        const loader = document.createElement('div');
        loader.setAttribute('part', 'loader');
        const content = this.shadowRoot.querySelector('[part~="content"]');
        content.parentNode.insertBefore(loader, content);
        this.requiredVerticalSpace = 200;
    }
    _outsideClickListener(event) {
        const eventPath = event.composedPath();
        if (!eventPath.includes(this.positionTarget) && !eventPath.includes(this)) this.close();
    }
    _setOverlayWidth(positionTarget, opened) {
        if (positionTarget && opened) {
            const propPrefix = this.localName;
            this.style.setProperty(`--_${propPrefix}-default-width`, `${positionTarget.clientWidth}px`);
            const customWidth = getComputedStyle(this._comboBox).getPropertyValue(`--${propPrefix}-width`);
            if (customWidth === '') this.style.removeProperty(`--${propPrefix}-width`);
            else this.style.setProperty(`--${propPrefix}-width`, customWidth);
            this._updatePosition();
        }
    }
}
customElements.define($70a97a33f54c7e90$export$8be4a7dba820c42c.is, $70a97a33f54c7e90$export$8be4a7dba820c42c);

});
parcelRegister("iJd0K", function(module, exports) {

$parcel$export(module.exports, "PositionMixin", () => $da2685acaf31ac66$export$71e21fd4f1429244);
/**
 * @license
 * Copyright (c) 2017 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $1hZF6 = parcelRequire("1hZF6");
const $da2685acaf31ac66$var$PROP_NAMES_VERTICAL = {
    start: 'top',
    end: 'bottom'
};
const $da2685acaf31ac66$var$PROP_NAMES_HORIZONTAL = {
    start: 'left',
    end: 'right'
};
const $da2685acaf31ac66$var$targetResizeObserver = new ResizeObserver((entries)=>{
    setTimeout(()=>{
        entries.forEach((entry)=>{
            if (entry.target.__overlay) entry.target.__overlay._updatePosition();
        });
    });
});
const $da2685acaf31ac66$export$71e21fd4f1429244 = (superClass)=>class PositionMixin extends superClass {
        static get properties() {
            return {
                /**
         * The element next to which this overlay should be aligned.
         * The position of the overlay relative to the positionTarget can be adjusted
         * with properties `horizontalAlign`, `verticalAlign`, `noHorizontalOverlap`
         * and `noVerticalOverlap`.
         */ positionTarget: {
                    type: Object,
                    value: null
                },
                /**
         * When `positionTarget` is set, this property defines whether to align the overlay's
         * left or right side to the target element by default.
         * Possible values are `start` and `end`.
         * RTL is taken into account when interpreting the value.
         * The overlay is automatically flipped to the opposite side when it doesn't fit into
         * the default side defined by this property.
         *
         * @attr {start|end} horizontal-align
         */ horizontalAlign: {
                    type: String,
                    value: 'start'
                },
                /**
         * When `positionTarget` is set, this property defines whether to align the overlay's
         * top or bottom side to the target element by default.
         * Possible values are `top` and `bottom`.
         * The overlay is automatically flipped to the opposite side when it doesn't fit into
         * the default side defined by this property.
         *
         * @attr {top|bottom} vertical-align
         */ verticalAlign: {
                    type: String,
                    value: 'top'
                },
                /**
         * When `positionTarget` is set, this property defines whether the overlay should overlap
         * the target element in the x-axis, or be positioned right next to it.
         *
         * @attr {boolean} no-horizontal-overlap
         */ noHorizontalOverlap: {
                    type: Boolean,
                    value: false
                },
                /**
         * When `positionTarget` is set, this property defines whether the overlay should overlap
         * the target element in the y-axis, or be positioned right above/below it.
         *
         * @attr {boolean} no-vertical-overlap
         */ noVerticalOverlap: {
                    type: Boolean,
                    value: false
                },
                /**
         * If the overlay content has no intrinsic height, this property can be used to set
         * the minimum vertical space (in pixels) required by the overlay. Setting a value to
         * the property effectively disables the content measurement in favor of using this
         * fixed value for determining the open direction.
         *
         * @attr {number} required-vertical-space
         */ requiredVerticalSpace: {
                    type: Number,
                    value: 0
                }
            };
        }
        static get observers() {
            return [
                '__positionSettingsChanged(horizontalAlign, verticalAlign, noHorizontalOverlap, noVerticalOverlap, requiredVerticalSpace)',
                '__overlayOpenedChanged(opened, positionTarget)'
            ];
        }
        constructor(){
            super();
            this.__onScroll = this.__onScroll.bind(this);
            this._updatePosition = this._updatePosition.bind(this);
        }
        /** @protected */ connectedCallback() {
            super.connectedCallback();
            if (this.opened) this.__addUpdatePositionEventListeners();
        }
        /** @protected */ disconnectedCallback() {
            super.disconnectedCallback();
            this.__removeUpdatePositionEventListeners();
        }
        /** @private */ __addUpdatePositionEventListeners() {
            window.addEventListener('resize', this._updatePosition);
            this.__positionTargetAncestorRootNodes = (0, $1hZF6.getAncestorRootNodes)(this.positionTarget);
            this.__positionTargetAncestorRootNodes.forEach((node)=>{
                node.addEventListener('scroll', this.__onScroll, true);
            });
        }
        /** @private */ __removeUpdatePositionEventListeners() {
            window.removeEventListener('resize', this._updatePosition);
            if (this.__positionTargetAncestorRootNodes) {
                this.__positionTargetAncestorRootNodes.forEach((node)=>{
                    node.removeEventListener('scroll', this.__onScroll, true);
                });
                this.__positionTargetAncestorRootNodes = null;
            }
        }
        /** @private */ __overlayOpenedChanged(opened, positionTarget) {
            this.__removeUpdatePositionEventListeners();
            if (positionTarget) {
                positionTarget.__overlay = null;
                $da2685acaf31ac66$var$targetResizeObserver.unobserve(positionTarget);
                if (opened) {
                    this.__addUpdatePositionEventListeners();
                    positionTarget.__overlay = this;
                    $da2685acaf31ac66$var$targetResizeObserver.observe(positionTarget);
                }
            }
            if (opened) {
                const computedStyle = getComputedStyle(this);
                if (!this.__margins) {
                    this.__margins = {};
                    [
                        'top',
                        'bottom',
                        'left',
                        'right'
                    ].forEach((propName)=>{
                        this.__margins[propName] = parseInt(computedStyle[propName], 10);
                    });
                }
                this.setAttribute('dir', computedStyle.direction);
                this._updatePosition();
                // Schedule another position update (to cover virtual keyboard opening for example)
                requestAnimationFrame(()=>this._updatePosition());
            }
        }
        get __isRTL() {
            return this.getAttribute('dir') === 'rtl';
        }
        __positionSettingsChanged() {
            this._updatePosition();
        }
        /** @private */ __onScroll(e) {
            // If the scroll event occurred inside the overlay, ignore it.
            if (!this.contains(e.target)) this._updatePosition();
        }
        _updatePosition() {
            if (!this.positionTarget || !this.opened) return;
            const targetRect = this.positionTarget.getBoundingClientRect();
            // Detect the desired alignment and update the layout accordingly
            const shouldAlignStartVertically = this.__shouldAlignStartVertically(targetRect);
            this.style.justifyContent = shouldAlignStartVertically ? 'flex-start' : 'flex-end';
            const shouldAlignStartHorizontally = this.__shouldAlignStartHorizontally(targetRect, this.__isRTL);
            const flexStart = !this.__isRTL && shouldAlignStartHorizontally || this.__isRTL && !shouldAlignStartHorizontally;
            this.style.alignItems = flexStart ? 'flex-start' : 'flex-end';
            // Get the overlay rect after possible overlay alignment changes
            const overlayRect = this.getBoundingClientRect();
            // Obtain vertical positioning properties
            const verticalProps = this.__calculatePositionInOneDimension(targetRect, overlayRect, this.noVerticalOverlap, $da2685acaf31ac66$var$PROP_NAMES_VERTICAL, this, shouldAlignStartVertically);
            // Obtain horizontal positioning properties
            const horizontalProps = this.__calculatePositionInOneDimension(targetRect, overlayRect, this.noHorizontalOverlap, $da2685acaf31ac66$var$PROP_NAMES_HORIZONTAL, this, shouldAlignStartHorizontally);
            // Apply the positioning properties to the overlay
            Object.assign(this.style, verticalProps, horizontalProps);
            this.toggleAttribute('bottom-aligned', !shouldAlignStartVertically);
            this.toggleAttribute('top-aligned', shouldAlignStartVertically);
            this.toggleAttribute('end-aligned', !flexStart);
            this.toggleAttribute('start-aligned', flexStart);
        }
        __shouldAlignStartHorizontally(targetRect, rtl) {
            // Using previous size to fix a case where window resize may cause the overlay to be squeezed
            // smaller than its current space before the fit-calculations.
            const contentWidth = Math.max(this.__oldContentWidth || 0, this.$.overlay.offsetWidth);
            this.__oldContentWidth = this.$.overlay.offsetWidth;
            const viewportWidth = Math.min(window.innerWidth, document.documentElement.clientWidth);
            const defaultAlignLeft = !rtl && this.horizontalAlign === 'start' || rtl && this.horizontalAlign === 'end';
            return this.__shouldAlignStart(targetRect, contentWidth, viewportWidth, this.__margins, defaultAlignLeft, this.noHorizontalOverlap, $da2685acaf31ac66$var$PROP_NAMES_HORIZONTAL);
        }
        __shouldAlignStartVertically(targetRect) {
            // Using previous size to fix a case where window resize may cause the overlay to be squeezed
            // smaller than its current space before the fit-calculations.
            const contentHeight = this.requiredVerticalSpace || Math.max(this.__oldContentHeight || 0, this.$.overlay.offsetHeight);
            this.__oldContentHeight = this.$.overlay.offsetHeight;
            const viewportHeight = Math.min(window.innerHeight, document.documentElement.clientHeight);
            const defaultAlignTop = this.verticalAlign === 'top';
            return this.__shouldAlignStart(targetRect, contentHeight, viewportHeight, this.__margins, defaultAlignTop, this.noVerticalOverlap, $da2685acaf31ac66$var$PROP_NAMES_VERTICAL);
        }
        // eslint-disable-next-line max-params
        __shouldAlignStart(targetRect, contentSize, viewportSize, margins, defaultAlignStart, noOverlap, propNames) {
            const spaceForStartAlignment = viewportSize - targetRect[noOverlap ? propNames.end : propNames.start] - margins[propNames.end];
            const spaceForEndAlignment = targetRect[noOverlap ? propNames.start : propNames.end] - margins[propNames.start];
            const spaceForDefaultAlignment = defaultAlignStart ? spaceForStartAlignment : spaceForEndAlignment;
            const spaceForOtherAlignment = defaultAlignStart ? spaceForEndAlignment : spaceForStartAlignment;
            const shouldGoToDefaultSide = spaceForDefaultAlignment > spaceForOtherAlignment || spaceForDefaultAlignment > contentSize;
            return defaultAlignStart === shouldGoToDefaultSide;
        }
        /**
     * Returns an adjusted value after resizing the browser window,
     * to avoid wrong calculations when e.g. previously set `bottom`
     * CSS property value is larger than the updated viewport height.
     * See https://github.com/vaadin/web-components/issues/4604
     */ __adjustBottomProperty(cssPropNameToSet, propNames, currentValue) {
            let adjustedProp;
            if (cssPropNameToSet === propNames.end) {
                // Adjust horizontally
                if (propNames.end === $da2685acaf31ac66$var$PROP_NAMES_VERTICAL.end) {
                    const viewportHeight = Math.min(window.innerHeight, document.documentElement.clientHeight);
                    if (currentValue > viewportHeight && this.__oldViewportHeight) {
                        const heightDiff = this.__oldViewportHeight - viewportHeight;
                        adjustedProp = currentValue - heightDiff;
                    }
                    this.__oldViewportHeight = viewportHeight;
                }
                // Adjust vertically
                if (propNames.end === $da2685acaf31ac66$var$PROP_NAMES_HORIZONTAL.end) {
                    const viewportWidth = Math.min(window.innerWidth, document.documentElement.clientWidth);
                    if (currentValue > viewportWidth && this.__oldViewportWidth) {
                        const widthDiff = this.__oldViewportWidth - viewportWidth;
                        adjustedProp = currentValue - widthDiff;
                    }
                    this.__oldViewportWidth = viewportWidth;
                }
            }
            return adjustedProp;
        }
        /**
     * Returns an object with CSS position properties to set,
     * e.g. { top: "100px" }
     */ // eslint-disable-next-line max-params
        __calculatePositionInOneDimension(targetRect, overlayRect, noOverlap, propNames, overlay, shouldAlignStart) {
            const cssPropNameToSet = shouldAlignStart ? propNames.start : propNames.end;
            const cssPropNameToClear = shouldAlignStart ? propNames.end : propNames.start;
            const currentValue = parseFloat(overlay.style[cssPropNameToSet] || getComputedStyle(overlay)[cssPropNameToSet]);
            const adjustedValue = this.__adjustBottomProperty(cssPropNameToSet, propNames, currentValue);
            const diff = overlayRect[shouldAlignStart ? propNames.start : propNames.end] - targetRect[noOverlap === shouldAlignStart ? propNames.end : propNames.start];
            const valueToSet = adjustedValue ? `${adjustedValue}px` : `${currentValue + diff * (shouldAlignStart ? -1 : 1)}px`;
            return {
                [cssPropNameToSet]: valueToSet,
                [cssPropNameToClear]: ''
            };
        }
    };

});



parcelRegister("cHjQp", function(module, exports) {
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $2XUc1 = parcelRequire("2XUc1");

var $8ULzu = parcelRequire("8ULzu");
/**
 * An element used internally by `<vaadin-multi-select-combo-box>`. Not intended to be used separately.
 *
 * @extends ComboBoxScroller
 * @private
 */ class $93e8e4dc0621fb29$var$MultiSelectComboBoxScroller extends (0, $8ULzu.ComboBoxScroller) {
    static get is() {
        return 'vaadin-multi-select-combo-box-scroller';
    }
    /** @protected */ ready() {
        super.ready();
        this.setAttribute('aria-multiselectable', 'true');
    }
    /**
   * @protected
   * @override
   */ _isItemSelected(item, _selectedItem, itemIdPath) {
        if (item instanceof (0, $2XUc1.ComboBoxPlaceholder)) return false;
        if (this.comboBox.readonly) return false;
        return this.comboBox._findIndex(item, this.comboBox.selectedItems, itemIdPath) > -1;
    }
    /** @private */ __updateElement(el, index) {
        super.__updateElement(el, index);
        el.toggleAttribute('readonly', this.comboBox.readonly);
    }
}
customElements.define($93e8e4dc0621fb29$var$MultiSelectComboBoxScroller.is, $93e8e4dc0621fb29$var$MultiSelectComboBoxScroller);

});
parcelRegister("2XUc1", function(module, exports) {

$parcel$export(module.exports, "ComboBoxPlaceholder", () => $228cae359fa8d776$export$8c68053c18cf99c1);
/**
 * @license
 * Copyright (c) 2015 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /*
 * Placeholder object class representing items being loaded.
 *
 * @private
 */ const $228cae359fa8d776$export$8c68053c18cf99c1 = class ComboBoxPlaceholder {
    toString() {
        return '';
    }
};

});

parcelRegister("8ULzu", function(module, exports) {

$parcel$export(module.exports, "ComboBoxScroller", () => $67d874649b924041$export$958214f820964f7);
/**
 * @license
 * Copyright (c) 2015 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("5QhZ5");
var $76MHV = parcelRequire("76MHV");
var $5QhZ5 = parcelRequire("5QhZ5");

var $kKcje = parcelRequire("kKcje");

var $2Ir6N = parcelRequire("2Ir6N");

var $2XUc1 = parcelRequire("2XUc1");
class $67d874649b924041$export$958214f820964f7 extends (0, $5QhZ5.PolymerElement) {
    static get is() {
        return 'vaadin-combo-box-scroller';
    }
    static get template() {
        return (0, $76MHV.html)`
      <style>
        :host {
          display: block;
          min-height: 1px;
          overflow: auto;

          /* Fixes item background from getting on top of scrollbars on Safari */
          transform: translate3d(0, 0, 0);

          /* Enable momentum scrolling on iOS */
          -webkit-overflow-scrolling: touch;

          /* Fixes scrollbar disappearing when 'Show scroll bars: Always' enabled in Safari */
          box-shadow: 0 0 0 white;
        }

        #selector {
          border-width: var(--_vaadin-combo-box-items-container-border-width);
          border-style: var(--_vaadin-combo-box-items-container-border-style);
          border-color: var(--_vaadin-combo-box-items-container-border-color);
        }
      </style>
      <div id="selector">
        <slot></slot>
      </div>
    `;
    }
    static get properties() {
        return {
            /**
       * A full set of items to filter the visible options from.
       * Set to an empty array when combo-box is not opened.
       */ items: {
                type: Array,
                observer: '__itemsChanged'
            },
            /**
       * Index of an item that has focus outline and is scrolled into view.
       * The actual focus still remains in the input field.
       */ focusedIndex: {
                type: Number,
                observer: '__focusedIndexChanged'
            },
            /**
       * Set to true while combo-box fetches new page from the data provider.
       */ loading: {
                type: Boolean,
                observer: '__loadingChanged'
            },
            /**
       * Whether the combo-box is currently opened or not. If set to false,
       * calling `scrollIntoView` does not have any effect.
       */ opened: {
                type: Boolean,
                observer: '__openedChanged'
            },
            /**
       * The selected item from the `items` array.
       */ selectedItem: {
                type: Object,
                observer: '__selectedItemChanged'
            },
            /**
       * Path for the id of the item, used to detect whether the item is selected.
       */ itemIdPath: {
                type: String
            },
            /**
       * Reference to the combo-box, used by the item elements.
       */ comboBox: {
                type: Object
            },
            /**
       * Function used to set a label for every combo-box item.
       */ getItemLabel: {
                type: Object
            },
            /**
       * Function used to render the content of every combo-box item.
       */ renderer: {
                type: Object,
                observer: '__rendererChanged'
            },
            /**
       * Used to propagate the `theme` attribute from the host element.
       */ theme: {
                type: String
            }
        };
    }
    constructor(){
        super();
        this.__boundOnItemClick = this.__onItemClick.bind(this);
    }
    __openedChanged(opened) {
        if (opened) this.requestContentUpdate();
    }
    /** @protected */ ready() {
        super.ready();
        // Ensure every instance has unique ID
        this.id = `${this.localName}-${(0, $kKcje.generateUniqueId)()}`;
        // Allow extensions to customize tag name for the items
        this.__hostTagName = this.constructor.is.replace('-scroller', '');
        this.setAttribute('role', 'listbox');
        this.addEventListener('click', (e)=>e.stopPropagation());
        this.__patchWheelOverScrolling();
        this.__virtualizer = new (0, $2Ir6N.Virtualizer)({
            createElements: this.__createElements.bind(this),
            updateElement: this.__updateElement.bind(this),
            elementsContainer: this,
            scrollTarget: this,
            scrollContainer: this.$.selector
        });
    }
    requestContentUpdate() {
        if (this.__virtualizer) this.__virtualizer.update();
    }
    scrollIntoView(index) {
        if (!(this.opened && index >= 0)) return;
        const visibleItemsCount = this._visibleItemsCount();
        let targetIndex = index;
        if (index > this.__virtualizer.lastVisibleIndex - 1) {
            // Index is below the bottom, scrolling down. Make the item appear at the bottom.
            // First scroll to target (will be at the top of the scroller) to make sure it's rendered.
            this.__virtualizer.scrollToIndex(index);
            // Then calculate the index for the following scroll (to get the target to bottom of the scroller).
            targetIndex = index - visibleItemsCount + 1;
        } else if (index > this.__virtualizer.firstVisibleIndex) // The item is already visible, scrolling is unnecessary per se. But we need to trigger iron-list to set
        // the correct scrollTop on the scrollTarget. Scrolling to firstVisibleIndex.
        targetIndex = this.__virtualizer.firstVisibleIndex;
        this.__virtualizer.scrollToIndex(Math.max(0, targetIndex));
        // Sometimes the item is partly below the bottom edge, detect and adjust.
        const lastPhysicalItem = [
            ...this.children
        ].find((el)=>!el.hidden && el.index === this.__virtualizer.lastVisibleIndex);
        if (!lastPhysicalItem || index !== lastPhysicalItem.index) return;
        const lastPhysicalItemRect = lastPhysicalItem.getBoundingClientRect();
        const scrollerRect = this.getBoundingClientRect();
        const scrollTopAdjust = lastPhysicalItemRect.bottom - scrollerRect.bottom + this._viewportTotalPaddingBottom;
        if (scrollTopAdjust > 0) this.scrollTop += scrollTopAdjust;
    }
    /** @private */ __getAriaRole(itemIndex) {
        return itemIndex !== undefined ? 'option' : false;
    }
    /** @private */ __isItemFocused(focusedIndex, itemIndex) {
        return !this.loading && focusedIndex === itemIndex;
    }
    /** @protected */ _isItemSelected(item, selectedItem, itemIdPath) {
        if (item instanceof (0, $2XUc1.ComboBoxPlaceholder)) return false;
        else if (itemIdPath && item !== undefined && selectedItem !== undefined) return this.get(itemIdPath, item) === this.get(itemIdPath, selectedItem);
        return item === selectedItem;
    }
    /** @private */ __itemsChanged(items) {
        if (this.__virtualizer && items) {
            this.__virtualizer.size = items.length;
            this.__virtualizer.flush();
            this.requestContentUpdate();
        }
    }
    /** @private */ __loadingChanged() {
        this.requestContentUpdate();
    }
    /** @private */ __selectedItemChanged() {
        this.requestContentUpdate();
    }
    /** @private */ __focusedIndexChanged(index, oldIndex) {
        if (index !== oldIndex) this.requestContentUpdate();
        // Do not jump back to the previously focused item while loading
        // when requesting next page from the data provider on scroll.
        if (index >= 0 && !this.loading) this.scrollIntoView(index);
    }
    /** @private */ __rendererChanged(renderer, oldRenderer) {
        if (renderer || oldRenderer) this.requestContentUpdate();
    }
    /** @private */ __createElements(count) {
        return [
            ...Array(count)
        ].map(()=>{
            const item = document.createElement(`${this.__hostTagName}-item`);
            item.addEventListener('click', this.__boundOnItemClick);
            // Negative tabindex prevents the item content from being focused.
            item.tabIndex = '-1';
            item.style.width = '100%';
            return item;
        });
    }
    /** @private */ __updateElement(el, index) {
        const item = this.items[index];
        const focusedIndex = this.focusedIndex;
        const selected = this._isItemSelected(item, this.selectedItem, this.itemIdPath);
        el.setProperties({
            item: item,
            index: index,
            label: this.getItemLabel(item),
            selected: selected,
            renderer: this.renderer,
            focused: this.__isItemFocused(focusedIndex, index)
        });
        el.id = `${this.__hostTagName}-item-${index}`;
        el.setAttribute('role', this.__getAriaRole(index));
        el.setAttribute('aria-selected', selected.toString());
        el.setAttribute('aria-posinset', index + 1);
        el.setAttribute('aria-setsize', this.items.length);
        if (this.theme) el.setAttribute('theme', this.theme);
        else el.removeAttribute('theme');
        if (item instanceof (0, $2XUc1.ComboBoxPlaceholder)) this.__requestItemByIndex(index);
    }
    /** @private */ __onItemClick(e) {
        this.dispatchEvent(new CustomEvent('selection-changed', {
            detail: {
                item: e.currentTarget.item
            }
        }));
    }
    /**
   * We want to prevent the kinetic scrolling energy from being transferred from the overlay contents over to the parent.
   * Further improvement ideas: after the contents have been scrolled to the top or bottom and scrolling has stopped, it could allow
   * scrolling the parent similarly to touch scrolling.
   */ __patchWheelOverScrolling() {
        this.$.selector.addEventListener('wheel', (e)=>{
            const scrolledToTop = this.scrollTop === 0;
            const scrolledToBottom = this.scrollHeight - this.scrollTop - this.clientHeight <= 1;
            if (scrolledToTop && e.deltaY < 0) e.preventDefault();
            else if (scrolledToBottom && e.deltaY > 0) e.preventDefault();
        });
    }
    get _viewportTotalPaddingBottom() {
        if (this._cachedViewportTotalPaddingBottom === undefined) {
            const itemsStyle = window.getComputedStyle(this.$.selector);
            this._cachedViewportTotalPaddingBottom = [
                itemsStyle.paddingBottom,
                itemsStyle.borderBottomWidth
            ].map((v)=>{
                return parseInt(v, 10);
            }).reduce((sum, v)=>{
                return sum + v;
            });
        }
        return this._cachedViewportTotalPaddingBottom;
    }
    /**
   * Dispatches an `index-requested` event for the given index to notify
   * the data provider that it should start loading the page containing the requested index.
   *
   * The event is dispatched asynchronously to prevent an immediate page request and therefore
   * a possible infinite recursion in case the data provider implements page request cancelation logic
   * by invoking data provider page callbacks with an empty array.
   * The infinite recursion may occur otherwise since invoking a data provider page callback with an empty array
   * triggers a synchronous scroller update and, if the callback corresponds to the currently visible page,
   * the scroller will synchronously request the page again which may lead to looping in the end.
   * That was the case for the Flow counterpart:
   * https://github.com/vaadin/flow-components/issues/3553#issuecomment-1239344828
   */ __requestItemByIndex(index) {
        requestAnimationFrame(()=>{
            this.dispatchEvent(new CustomEvent('index-requested', {
                detail: {
                    index: index,
                    currentScrollerPos: this._oldScrollerPosition
                }
            }));
        });
    }
    /** @private */ _visibleItemsCount() {
        // Ensure items are positioned
        this.__virtualizer.scrollToIndex(this.__virtualizer.firstVisibleIndex);
        const hasItems = this.__virtualizer.size > 0;
        return hasItems ? this.__virtualizer.lastVisibleIndex - this.__virtualizer.firstVisibleIndex + 1 : 0;
    }
}
customElements.define($67d874649b924041$export$958214f820964f7.is, $67d874649b924041$export$958214f820964f7);

});
parcelRegister("2Ir6N", function(module, exports) {

$parcel$export(module.exports, "Virtualizer", () => $1fa4b807b850d988$export$89be5a243e59c4b2);

var $b7Fx8 = parcelRequire("b7Fx8");
class $1fa4b807b850d988$export$89be5a243e59c4b2 {
    /**
   * @typedef {Object} VirtualizerConfig
   * @property {Function} createElements Function that returns the given number of new elements
   * @property {Function} updateElement Function that updates the element at a specific index
   * @property {HTMLElement} scrollTarget Reference to the scrolling element
   * @property {HTMLElement} scrollContainer Reference to a wrapper for the item elements (or a slot) inside the scrollTarget
   * @property {HTMLElement | undefined} elementsContainer Reference to the container in which the item elements are placed, defaults to scrollContainer
   * @property {boolean | undefined} reorderElements Determines whether the physical item elements should be kept in order in the DOM
   * @param {VirtualizerConfig} config Configuration for the virtualizer
   */ constructor(config){
        this.__adapter = new (0, $b7Fx8.IronListAdapter)(config);
    }
    /**
   * The size of the virtualizer
   * @return {number | undefined} The size of the virtualizer
   */ get size() {
        return this.__adapter.size;
    }
    /**
   * The size of the virtualizer
   * @param {number} size The size of the virtualizer
   */ set size(size) {
        this.__adapter.size = size;
    }
    /**
   * Scroll to a specific index in the virtual list
   *
   * @method scrollToIndex
   * @param {number} index The index of the item
   */ scrollToIndex(index) {
        this.__adapter.scrollToIndex(index);
    }
    /**
   * Requests the virtualizer to re-render the item elements on an index range, if currently in the DOM
   *
   * @method update
   * @param {number | undefined} startIndex The start index of the range
   * @param {number | undefined} endIndex The end index of the range
   */ update(startIndex = 0, endIndex = this.size - 1) {
        this.__adapter.update(startIndex, endIndex);
    }
    /**
   * Flushes active asynchronous tasks so that the component and the DOM end up in a stable state
   *
   * @method update
   * @param {number | undefined} startIndex The start index of the range
   * @param {number | undefined} endIndex The end index of the range
   */ flush() {
        this.__adapter.flush();
    }
    /**
   * Gets the index of the first visible item in the viewport.
   *
   * @return {number}
   */ get firstVisibleIndex() {
        return this.__adapter.adjustedFirstVisibleIndex;
    }
    /**
   * Gets the index of the last visible item in the viewport.
   *
   * @return {number}
   */ get lastVisibleIndex() {
        return this.__adapter.adjustedLastVisibleIndex;
    }
}

});
parcelRegister("b7Fx8", function(module, exports) {

$parcel$export(module.exports, "IronListAdapter", () => $819090d1ddade0aa$export$678740519b8b5f3);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $cxRfu = parcelRequire("cxRfu");

var $aC4kq = parcelRequire("aC4kq");

var $jlr9D = parcelRequire("jlr9D");

var $1Q51K = parcelRequire("1Q51K");
// Iron-list can by default handle sizes up to around 100000.
// When the size is larger than MAX_VIRTUAL_COUNT _vidxOffset is used
const $819090d1ddade0aa$var$MAX_VIRTUAL_COUNT = 100000;
const $819090d1ddade0aa$var$OFFSET_ADJUST_MIN_THRESHOLD = 1000;
class $819090d1ddade0aa$export$678740519b8b5f3 {
    constructor({ createElements: createElements, updateElement: updateElement, scrollTarget: scrollTarget, scrollContainer: scrollContainer, elementsContainer: elementsContainer, reorderElements: reorderElements }){
        this.isAttached = true;
        this._vidxOffset = 0;
        this.createElements = createElements;
        this.updateElement = updateElement;
        this.scrollTarget = scrollTarget;
        this.scrollContainer = scrollContainer;
        this.elementsContainer = elementsContainer || scrollContainer;
        this.reorderElements = reorderElements;
        // Iron-list uses this value to determine how many pages of elements to render
        this._maxPages = 1.3;
        // Placeholder height (used for sizing elements that have intrinsic 0 height after update)
        this.__placeholderHeight = 200;
        // A queue of 10 previous element heights
        this.__elementHeightQueue = Array(10);
        this.timeouts = {
            SCROLL_REORDER: 500,
            IGNORE_WHEEL: 500,
            FIX_INVALID_ITEM_POSITIONING: 100
        };
        this.__resizeObserver = new ResizeObserver(()=>this._resizeHandler());
        if (getComputedStyle(this.scrollTarget).overflow === 'visible') this.scrollTarget.style.overflow = 'auto';
        if (getComputedStyle(this.scrollContainer).position === 'static') this.scrollContainer.style.position = 'relative';
        this.__resizeObserver.observe(this.scrollTarget);
        this.scrollTarget.addEventListener('scroll', ()=>this._scrollHandler());
        this._scrollLineHeight = this._getScrollLineHeight();
        this.scrollTarget.addEventListener('wheel', (e)=>this.__onWheel(e));
        if (this.reorderElements) {
            // Reordering the physical elements cancels the user's grab of the scroll bar handle on Safari.
            // Need to defer reordering until the user lets go of the scroll bar handle.
            this.scrollTarget.addEventListener('mousedown', ()=>{
                this.__mouseDown = true;
            });
            this.scrollTarget.addEventListener('mouseup', ()=>{
                this.__mouseDown = false;
                if (this.__pendingReorder) this.__reorderElements();
            });
        }
    }
    get scrollOffset() {
        return 0;
    }
    get adjustedFirstVisibleIndex() {
        return this.firstVisibleIndex + this._vidxOffset;
    }
    get adjustedLastVisibleIndex() {
        return this.lastVisibleIndex + this._vidxOffset;
    }
    scrollToIndex(index) {
        if (typeof index !== 'number' || isNaN(index) || this.size === 0 || !this.scrollTarget.offsetHeight) return;
        index = this._clamp(index, 0, this.size - 1);
        const visibleElementCount = this.__getVisibleElements().length;
        let targetVirtualIndex = Math.floor(index / this.size * this._virtualCount);
        if (this._virtualCount - targetVirtualIndex < visibleElementCount) {
            targetVirtualIndex = this._virtualCount - (this.size - index);
            this._vidxOffset = this.size - this._virtualCount;
        } else if (targetVirtualIndex < visibleElementCount) {
            if (index < $819090d1ddade0aa$var$OFFSET_ADJUST_MIN_THRESHOLD) {
                targetVirtualIndex = index;
                this._vidxOffset = 0;
            } else {
                targetVirtualIndex = $819090d1ddade0aa$var$OFFSET_ADJUST_MIN_THRESHOLD;
                this._vidxOffset = index - targetVirtualIndex;
            }
        } else this._vidxOffset = index - targetVirtualIndex;
        this.__skipNextVirtualIndexAdjust = true;
        super.scrollToIndex(targetVirtualIndex);
        if (this.adjustedFirstVisibleIndex !== index && this._scrollTop < this._maxScrollTop && !this.grid) // Workaround an iron-list issue by manually adjusting the scroll position
        this._scrollTop -= this.__getIndexScrollOffset(index) || 0;
        this._scrollHandler();
    }
    flush() {
        // The scroll target is hidden.
        if (this.scrollTarget.offsetHeight === 0) return;
        this._resizeHandler();
        (0, $jlr9D.flush)();
        this._scrollHandler();
        if (this.__fixInvalidItemPositioningDebouncer) this.__fixInvalidItemPositioningDebouncer.flush();
        if (this.__scrollReorderDebouncer) this.__scrollReorderDebouncer.flush();
        if (this.__debouncerWheelAnimationFrame) this.__debouncerWheelAnimationFrame.flush();
    }
    update(startIndex = 0, endIndex = this.size - 1) {
        this.__getVisibleElements().forEach((el)=>{
            if (el.__virtualIndex >= startIndex && el.__virtualIndex <= endIndex) this.__updateElement(el, el.__virtualIndex, true);
        });
    }
    /**
   * Updates the height for a given set of items.
   *
   * @param {!Array<number>=} itemSet
   */ _updateMetrics(itemSet) {
        // Make sure we distributed all the physical items
        // so we can measure them.
        (0, $jlr9D.flush)();
        let newPhysicalSize = 0;
        let oldPhysicalSize = 0;
        const prevAvgCount = this._physicalAverageCount;
        const prevPhysicalAvg = this._physicalAverage;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._iterateItems((pidx, vidx)=>{
            oldPhysicalSize += this._physicalSizes[pidx];
            this._physicalSizes[pidx] = Math.ceil(this.__getBorderBoxHeight(this._physicalItems[pidx]));
            newPhysicalSize += this._physicalSizes[pidx];
            this._physicalAverageCount += this._physicalSizes[pidx] ? 1 : 0;
        }, itemSet);
        this._physicalSize = this._physicalSize + newPhysicalSize - oldPhysicalSize;
        // Update the average if it measured something.
        if (this._physicalAverageCount !== prevAvgCount) this._physicalAverage = Math.round((prevPhysicalAvg * prevAvgCount + newPhysicalSize) / this._physicalAverageCount);
    }
    __getBorderBoxHeight(el) {
        const style = getComputedStyle(el);
        const itemHeight = parseFloat(style.height) || 0;
        if (style.boxSizing === 'border-box') return itemHeight;
        const paddingBottom = parseFloat(style.paddingBottom) || 0;
        const paddingTop = parseFloat(style.paddingTop) || 0;
        const borderBottomWidth = parseFloat(style.borderBottomWidth) || 0;
        const borderTopWidth = parseFloat(style.borderTopWidth) || 0;
        return itemHeight + paddingBottom + paddingTop + borderBottomWidth + borderTopWidth;
    }
    __updateElement(el, index, forceSameIndexUpdates) {
        // Clean up temporary placeholder sizing
        if (el.style.paddingTop) el.style.paddingTop = '';
        if (!this.__preventElementUpdates && (el.__lastUpdatedIndex !== index || forceSameIndexUpdates)) {
            this.updateElement(el, index);
            el.__lastUpdatedIndex = index;
        }
        const elementHeight = el.offsetHeight;
        if (elementHeight === 0) {
            // If the elements have 0 height after update (for example due to lazy rendering),
            // it results in iron-list requesting to create an unlimited count of elements.
            // Assign a temporary placeholder sizing to elements that would otherwise end up having
            // no height.
            el.style.paddingTop = `${this.__placeholderHeight}px`;
            // Manually schedule the resize handler to make sure the placeholder padding is
            // cleared in case the resize observer never triggers.
            requestAnimationFrame(()=>this._resizeHandler());
        } else {
            // Add element height to the queue
            this.__elementHeightQueue.push(elementHeight);
            this.__elementHeightQueue.shift();
            // Calcualte new placeholder height based on the average of the defined values in the
            // element height queue
            const filteredHeights = this.__elementHeightQueue.filter((h)=>h !== undefined);
            this.__placeholderHeight = Math.round(filteredHeights.reduce((a, b)=>a + b, 0) / filteredHeights.length);
        }
    }
    __getIndexScrollOffset(index) {
        const element = this.__getVisibleElements().find((el)=>el.__virtualIndex === index);
        return element ? this.scrollTarget.getBoundingClientRect().top - element.getBoundingClientRect().top : undefined;
    }
    get size() {
        return this.__size;
    }
    set size(size) {
        if (size === this.size) return;
        // Cancel active debouncers
        if (this.__fixInvalidItemPositioningDebouncer) this.__fixInvalidItemPositioningDebouncer.cancel();
        if (this._debouncers && this._debouncers._increasePoolIfNeeded) // Avoid creating unnecessary elements on the following flush()
        this._debouncers._increasePoolIfNeeded.cancel();
        // Prevent element update while the scroll position is being restored
        this.__preventElementUpdates = true;
        // Record the scroll position before changing the size
        let fvi; // First visible index
        let fviOffsetBefore; // Scroll offset of the first visible index
        if (size > 0) {
            fvi = this.adjustedFirstVisibleIndex;
            fviOffsetBefore = this.__getIndexScrollOffset(fvi);
        }
        // Change the size
        this.__size = size;
        this._itemsChanged({
            path: 'items'
        });
        (0, $jlr9D.flush)();
        // Try to restore the scroll position if the new size is larger than 0
        if (size > 0) {
            fvi = Math.min(fvi, size - 1);
            this.scrollToIndex(fvi);
            const fviOffsetAfter = this.__getIndexScrollOffset(fvi);
            if (fviOffsetBefore !== undefined && fviOffsetAfter !== undefined) this._scrollTop += fviOffsetBefore - fviOffsetAfter;
        }
        if (!this.elementsContainer.children.length) requestAnimationFrame(()=>this._resizeHandler());
        this.__preventElementUpdates = false;
        // Schedule and flush a resize handler
        this._resizeHandler();
        (0, $jlr9D.flush)();
    }
    /** @private */ get _scrollTop() {
        return this.scrollTarget.scrollTop;
    }
    /** @private */ set _scrollTop(top) {
        this.scrollTarget.scrollTop = top;
    }
    /** @private */ get items() {
        return {
            length: Math.min(this.size, $819090d1ddade0aa$var$MAX_VIRTUAL_COUNT)
        };
    }
    /** @private */ get offsetHeight() {
        return this.scrollTarget.offsetHeight;
    }
    /** @private */ get $() {
        return {
            items: this.scrollContainer
        };
    }
    /** @private */ updateViewportBoundaries() {
        const styles = window.getComputedStyle(this.scrollTarget);
        this._scrollerPaddingTop = this.scrollTarget === this ? 0 : parseInt(styles['padding-top'], 10);
        this._isRTL = Boolean(styles.direction === 'rtl');
        this._viewportWidth = this.elementsContainer.offsetWidth;
        this._viewportHeight = this.scrollTarget.offsetHeight;
        this._scrollPageHeight = this._viewportHeight - this._scrollLineHeight;
        if (this.grid) this._updateGridMetrics();
    }
    /** @private */ setAttribute() {}
    /** @private */ _createPool(size) {
        const physicalItems = this.createElements(size);
        const fragment = document.createDocumentFragment();
        physicalItems.forEach((el)=>{
            el.style.position = 'absolute';
            fragment.appendChild(el);
            this.__resizeObserver.observe(el);
        });
        this.elementsContainer.appendChild(fragment);
        return physicalItems;
    }
    /** @private */ _assignModels(itemSet) {
        this._iterateItems((pidx, vidx)=>{
            const el = this._physicalItems[pidx];
            el.hidden = vidx >= this.size;
            if (!el.hidden) {
                el.__virtualIndex = vidx + (this._vidxOffset || 0);
                this.__updateElement(el, el.__virtualIndex);
            } else delete el.__lastUpdatedIndex;
        }, itemSet);
    }
    /** @private */ _isClientFull() {
        // Workaround an issue in iron-list that can cause it to freeze on fast scroll
        setTimeout(()=>{
            this.__clientFull = true;
        });
        return this.__clientFull || super._isClientFull();
    }
    /** @private */ translate3d(_x, y, _z, el) {
        el.style.transform = `translateY(${y})`;
    }
    /** @private */ toggleScrollListener() {}
    _scrollHandler() {
        this._adjustVirtualIndexOffset(this._scrollTop - (this.__previousScrollTop || 0));
        const delta = this.scrollTarget.scrollTop - this._scrollPosition;
        super._scrollHandler();
        if (this._physicalCount !== 0) {
            const isScrollingDown = delta >= 0;
            const reusables = this._getReusables(!isScrollingDown);
            if (reusables.indexes.length) {
                // After running super._scrollHandler, fix internal properties to workaround an iron-list issue.
                // See https://github.com/vaadin/web-components/issues/1691
                this._physicalTop = reusables.physicalTop;
                if (isScrollingDown) {
                    this._virtualStart -= reusables.indexes.length;
                    this._physicalStart -= reusables.indexes.length;
                } else {
                    this._virtualStart += reusables.indexes.length;
                    this._physicalStart += reusables.indexes.length;
                }
                this._resizeHandler();
            }
        }
        if (delta) // There was a change in scroll top. Schedule a check for invalid item positioning.
        this.__fixInvalidItemPositioningDebouncer = (0, $jlr9D.Debouncer).debounce(this.__fixInvalidItemPositioningDebouncer, (0, $cxRfu.timeOut).after(this.timeouts.FIX_INVALID_ITEM_POSITIONING), ()=>this.__fixInvalidItemPositioning());
        if (this.reorderElements) this.__scrollReorderDebouncer = (0, $jlr9D.Debouncer).debounce(this.__scrollReorderDebouncer, (0, $cxRfu.timeOut).after(this.timeouts.SCROLL_REORDER), ()=>this.__reorderElements());
        this.__previousScrollTop = this._scrollTop;
        // If the first visible index is not 0 when scrolled to the top,
        // scroll to index 0 to fix the issue.
        if (this._scrollTop === 0 && this.firstVisibleIndex !== 0 && Math.abs(delta) > 0) this.scrollToIndex(0);
    }
    /**
   * Work around an iron-list issue with invalid item positioning.
   * See https://github.com/vaadin/flow-components/issues/4306
   * @private
   */ __fixInvalidItemPositioning() {
        if (!this.scrollTarget.isConnected) return;
        // Check if the first physical item element is below the top of the viewport
        const physicalTopBelowTop = this._physicalTop > this._scrollTop;
        // Check if the last physical item element is above the bottom of the viewport
        const physicalBottomAboveBottom = this._physicalBottom < this._scrollBottom;
        // Check if the first index is visible
        const firstIndexVisible = this.adjustedFirstVisibleIndex === 0;
        // Check if the last index is visible
        const lastIndexVisible = this.adjustedLastVisibleIndex === this.size - 1;
        if (physicalTopBelowTop && !firstIndexVisible || physicalBottomAboveBottom && !lastIndexVisible) {
            // Invalid state! Try to recover.
            const isScrollingDown = physicalBottomAboveBottom;
            // Set the "_ratio" property temporarily to 0 to make iron-list's _getReusables
            // place all the free physical items on one side of the viewport.
            const originalRatio = this._ratio;
            this._ratio = 0;
            // Fake a scroll change to make _scrollHandler place the physical items
            // on the desired side.
            this._scrollPosition = this._scrollTop + (isScrollingDown ? -1 : 1);
            this._scrollHandler();
            // Restore the original "_ratio" value.
            this._ratio = originalRatio;
        }
    }
    /** @private */ __onWheel(e) {
        if (e.ctrlKey || this._hasScrolledAncestor(e.target, e.deltaX, e.deltaY)) return;
        let deltaY = e.deltaY;
        if (e.deltaMode === WheelEvent.DOM_DELTA_LINE) // Scrolling by "lines of text" instead of pixels
        deltaY *= this._scrollLineHeight;
        else if (e.deltaMode === WheelEvent.DOM_DELTA_PAGE) // Scrolling by "pages" instead of pixels
        deltaY *= this._scrollPageHeight;
        this._deltaYAcc = this._deltaYAcc || 0;
        if (this._wheelAnimationFrame) {
            // Accumulate wheel delta while a frame is being processed
            this._deltaYAcc += deltaY;
            e.preventDefault();
            return;
        }
        deltaY += this._deltaYAcc;
        this._deltaYAcc = 0;
        this._wheelAnimationFrame = true;
        this.__debouncerWheelAnimationFrame = (0, $jlr9D.Debouncer).debounce(this.__debouncerWheelAnimationFrame, (0, $cxRfu.animationFrame), ()=>{
            this._wheelAnimationFrame = false;
        });
        const momentum = Math.abs(e.deltaX) + Math.abs(deltaY);
        if (this._canScroll(this.scrollTarget, e.deltaX, deltaY)) {
            e.preventDefault();
            this.scrollTarget.scrollTop += deltaY;
            this.scrollTarget.scrollLeft += e.deltaX;
            this._hasResidualMomentum = true;
            this._ignoreNewWheel = true;
            this._debouncerIgnoreNewWheel = (0, $jlr9D.Debouncer).debounce(this._debouncerIgnoreNewWheel, (0, $cxRfu.timeOut).after(this.timeouts.IGNORE_WHEEL), ()=>{
                this._ignoreNewWheel = false;
            });
        } else if (this._hasResidualMomentum && momentum <= this._previousMomentum || this._ignoreNewWheel) e.preventDefault();
        else if (momentum > this._previousMomentum) this._hasResidualMomentum = false;
        this._previousMomentum = momentum;
    }
    /**
   * Determines if the element has an ancestor that handles the scroll delta prior to this
   *
   * @private
   */ _hasScrolledAncestor(el, deltaX, deltaY) {
        if (el === this.scrollTarget || el === this.scrollTarget.getRootNode().host) return false;
        else if (this._canScroll(el, deltaX, deltaY) && [
            'auto',
            'scroll'
        ].indexOf(getComputedStyle(el).overflow) !== -1) return true;
        else if (el !== this && el.parentElement) return this._hasScrolledAncestor(el.parentElement, deltaX, deltaY);
    }
    _canScroll(el, deltaX, deltaY) {
        return deltaY > 0 && el.scrollTop < el.scrollHeight - el.offsetHeight || deltaY < 0 && el.scrollTop > 0 || deltaX > 0 && el.scrollLeft < el.scrollWidth - el.offsetWidth || deltaX < 0 && el.scrollLeft > 0;
    }
    /**
   * @returns {Number|undefined} - The browser's default font-size in pixels
   * @private
   */ _getScrollLineHeight() {
        const el = document.createElement('div');
        el.style.fontSize = 'initial';
        el.style.display = 'none';
        document.body.appendChild(el);
        const fontSize = window.getComputedStyle(el).fontSize;
        document.body.removeChild(el);
        return fontSize ? window.parseInt(fontSize) : undefined;
    }
    __getVisibleElements() {
        return Array.from(this.elementsContainer.children).filter((element)=>!element.hidden);
    }
    /** @private */ __reorderElements() {
        if (this.__mouseDown) {
            this.__pendingReorder = true;
            return;
        }
        this.__pendingReorder = false;
        const adjustedVirtualStart = this._virtualStart + (this._vidxOffset || 0);
        // Which row to use as a target?
        const visibleElements = this.__getVisibleElements();
        const elementWithFocus = visibleElements.find((element)=>element.contains(this.elementsContainer.getRootNode().activeElement) || element.contains(this.scrollTarget.getRootNode().activeElement));
        const targetElement = elementWithFocus || visibleElements[0];
        if (!targetElement) // All elements are hidden, don't reorder
        return;
        // Where the target row should be?
        const targetPhysicalIndex = targetElement.__virtualIndex - adjustedVirtualStart;
        // Reodrer the DOM elements to keep the target row at the target physical index
        const delta = visibleElements.indexOf(targetElement) - targetPhysicalIndex;
        if (delta > 0) for(let i = 0; i < delta; i++)this.elementsContainer.appendChild(visibleElements[i]);
        else if (delta < 0) for(let i = visibleElements.length + delta; i < visibleElements.length; i++)this.elementsContainer.insertBefore(visibleElements[i], visibleElements[0]);
        // Due to a rendering bug, reordering the rows can make parts of the scroll target disappear
        // on Safari when using sticky positioning in case the scroll target is inside a flexbox.
        // This issue manifests with grid (the header can disappear if grid is used inside a flexbox)
        if (0, $aC4kq.isSafari) {
            const { transform: transform } = this.scrollTarget.style;
            this.scrollTarget.style.transform = 'translateZ(0)';
            setTimeout(()=>{
                this.scrollTarget.style.transform = transform;
            });
        }
    }
    /** @private */ _adjustVirtualIndexOffset(delta) {
        if (this._virtualCount >= this.size) this._vidxOffset = 0;
        else if (this.__skipNextVirtualIndexAdjust) this.__skipNextVirtualIndexAdjust = false;
        else if (Math.abs(delta) > 10000) {
            // Process a large scroll position change
            const scale = this._scrollTop / (this.scrollTarget.scrollHeight - this.scrollTarget.offsetHeight);
            const offset = scale * this.size;
            this._vidxOffset = Math.round(offset - scale * this._virtualCount);
        } else {
            // Make sure user can always swipe/wheel scroll to the start and end
            const oldOffset = this._vidxOffset;
            const threshold = $819090d1ddade0aa$var$OFFSET_ADJUST_MIN_THRESHOLD;
            const maxShift = 100;
            // Near start
            if (this._scrollTop === 0) {
                this._vidxOffset = 0;
                if (oldOffset !== this._vidxOffset) super.scrollToIndex(0);
            } else if (this.firstVisibleIndex < threshold && this._vidxOffset > 0) {
                this._vidxOffset -= Math.min(this._vidxOffset, maxShift);
                super.scrollToIndex(this.firstVisibleIndex + (oldOffset - this._vidxOffset));
            }
            // Near end
            const maxOffset = this.size - this._virtualCount;
            if (this._scrollTop >= this._maxScrollTop && this._maxScrollTop > 0) {
                this._vidxOffset = maxOffset;
                if (oldOffset !== this._vidxOffset) super.scrollToIndex(this._virtualCount - 1);
            } else if (this.firstVisibleIndex > this._virtualCount - threshold && this._vidxOffset < maxOffset) {
                this._vidxOffset += Math.min(maxOffset - this._vidxOffset, maxShift);
                super.scrollToIndex(this.firstVisibleIndex - (this._vidxOffset - oldOffset));
            }
        }
    }
}
Object.setPrototypeOf($819090d1ddade0aa$export$678740519b8b5f3.prototype, (0, $1Q51K.ironList));

});
parcelRegister("1Q51K", function(module, exports) {

$parcel$export(module.exports, "ironList", () => $156e8c106beb0b1d$export$ec0e32fd950ee2df);
/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */ 
var $cxRfu = parcelRequire("cxRfu");

var $jlr9D = parcelRequire("jlr9D");
const $156e8c106beb0b1d$var$IOS = navigator.userAgent.match(/iP(?:hone|ad;(?: U;)? CPU) OS (\d+)/);
const $156e8c106beb0b1d$var$IOS_TOUCH_SCROLLING = $156e8c106beb0b1d$var$IOS && $156e8c106beb0b1d$var$IOS[1] >= 8;
const $156e8c106beb0b1d$var$DEFAULT_PHYSICAL_COUNT = 3;
const $156e8c106beb0b1d$export$ec0e32fd950ee2df = {
    /**
   * The ratio of hidden tiles that should remain in the scroll direction.
   * Recommended value ~0.5, so it will distribute tiles evenly in both
   * directions.
   */ _ratio: 0.5,
    /**
   * The padding-top value for the list.
   */ _scrollerPaddingTop: 0,
    /**
   * This value is a cached value of `scrollTop` from the last `scroll` event.
   */ _scrollPosition: 0,
    /**
   * The sum of the heights of all the tiles in the DOM.
   */ _physicalSize: 0,
    /**
   * The average `offsetHeight` of the tiles observed till now.
   */ _physicalAverage: 0,
    /**
   * The number of tiles which `offsetHeight` > 0 observed until now.
   */ _physicalAverageCount: 0,
    /**
   * The Y position of the item rendered in the `_physicalStart`
   * tile relative to the scrolling list.
   */ _physicalTop: 0,
    /**
   * The number of items in the list.
   */ _virtualCount: 0,
    /**
   * The estimated scroll height based on `_physicalAverage`
   */ _estScrollHeight: 0,
    /**
   * The scroll height of the dom node
   */ _scrollHeight: 0,
    /**
   * The height of the list. This is referred as the viewport in the context of
   * list.
   */ _viewportHeight: 0,
    /**
   * The width of the list. This is referred as the viewport in the context of
   * list.
   */ _viewportWidth: 0,
    /**
   * An array of DOM nodes that are currently in the tree
   * @type {?Array<!HTMLElement>}
   */ _physicalItems: null,
    /**
   * An array of heights for each item in `_physicalItems`
   * @type {?Array<number>}
   */ _physicalSizes: null,
    /**
   * A cached value for the first visible index.
   * See `firstVisibleIndex`
   * @type {?number}
   */ _firstVisibleIndexVal: null,
    /**
   * A cached value for the last visible index.
   * See `lastVisibleIndex`
   * @type {?number}
   */ _lastVisibleIndexVal: null,
    /**
   * The max number of pages to render. One page is equivalent to the height of
   * the list.
   */ _maxPages: 2,
    /**
   * The cost of stamping a template in ms.
   */ _templateCost: 0,
    /**
   * The bottom of the physical content.
   */ get _physicalBottom () {
        return this._physicalTop + this._physicalSize;
    },
    /**
   * The bottom of the scroll.
   */ get _scrollBottom () {
        return this._scrollPosition + this._viewportHeight;
    },
    /**
   * The n-th item rendered in the last physical item.
   */ get _virtualEnd () {
        return this._virtualStart + this._physicalCount - 1;
    },
    /**
   * The height of the physical content that isn't on the screen.
   */ get _hiddenContentSize () {
        return this._physicalSize - this._viewportHeight;
    },
    /**
   * The maximum scroll top value.
   */ get _maxScrollTop () {
        return this._estScrollHeight - this._viewportHeight + this._scrollOffset;
    },
    /**
   * The largest n-th value for an item such that it can be rendered in
   * `_physicalStart`.
   */ get _maxVirtualStart () {
        const virtualCount = this._virtualCount;
        return Math.max(0, virtualCount - this._physicalCount);
    },
    get _virtualStart () {
        return this._virtualStartVal || 0;
    },
    set _virtualStart (val){
        val = this._clamp(val, 0, this._maxVirtualStart);
        this._virtualStartVal = val;
    },
    get _physicalStart () {
        return this._physicalStartVal || 0;
    },
    /**
   * The k-th tile that is at the top of the scrolling list.
   */ set _physicalStart (val){
        val %= this._physicalCount;
        if (val < 0) val = this._physicalCount + val;
        this._physicalStartVal = val;
    },
    /**
   * The k-th tile that is at the bottom of the scrolling list.
   */ get _physicalEnd () {
        return (this._physicalStart + this._physicalCount - 1) % this._physicalCount;
    },
    get _physicalCount () {
        return this._physicalCountVal || 0;
    },
    set _physicalCount (val){
        this._physicalCountVal = val;
    },
    /**
   * An optimal physical size such that we will have enough physical items
   * to fill up the viewport and recycle when the user scrolls.
   *
   * This default value assumes that we will at least have the equivalent
   * to a viewport of physical items above and below the user's viewport.
   */ get _optPhysicalSize () {
        return this._viewportHeight === 0 ? Infinity : this._viewportHeight * this._maxPages;
    },
    /**
   * True if the current list is visible.
   */ get _isVisible () {
        return Boolean(this.offsetWidth || this.offsetHeight);
    },
    /**
   * Gets the index of the first visible item in the viewport.
   *
   * @type {number}
   */ get firstVisibleIndex () {
        let idx = this._firstVisibleIndexVal;
        if (idx == null) {
            let physicalOffset = this._physicalTop + this._scrollOffset;
            idx = this._iterateItems((pidx, vidx)=>{
                physicalOffset += this._getPhysicalSizeIncrement(pidx);
                if (physicalOffset > this._scrollPosition) return vidx;
            }) || 0;
            this._firstVisibleIndexVal = idx;
        }
        return idx;
    },
    /**
   * Gets the index of the last visible item in the viewport.
   *
   * @type {number}
   */ get lastVisibleIndex () {
        let idx = this._lastVisibleIndexVal;
        if (idx == null) {
            let physicalOffset = this._physicalTop + this._scrollOffset;
            this._iterateItems((pidx, vidx)=>{
                if (physicalOffset < this._scrollBottom) idx = vidx;
                physicalOffset += this._getPhysicalSizeIncrement(pidx);
            });
            this._lastVisibleIndexVal = idx;
        }
        return idx;
    },
    get _scrollOffset () {
        return this._scrollerPaddingTop + this.scrollOffset;
    },
    /**
   * Recycles the physical items when needed.
   */ _scrollHandler () {
        const scrollTop = Math.max(0, Math.min(this._maxScrollTop, this._scrollTop));
        let delta = scrollTop - this._scrollPosition;
        const isScrollingDown = delta >= 0;
        // Track the current scroll position.
        this._scrollPosition = scrollTop;
        // Clear indexes for first and last visible indexes.
        this._firstVisibleIndexVal = null;
        this._lastVisibleIndexVal = null;
        // Random access.
        if (Math.abs(delta) > this._physicalSize && this._physicalSize > 0) {
            delta -= this._scrollOffset;
            const idxAdjustment = Math.round(delta / this._physicalAverage);
            this._virtualStart += idxAdjustment;
            this._physicalStart += idxAdjustment;
            // Estimate new physical offset based on the virtual start index.
            // adjusts the physical start position to stay in sync with the clamped
            // virtual start index. It's critical not to let this value be
            // more than the scroll position however, since that would result in
            // the physical items not covering the viewport, and leading to
            // _increasePoolIfNeeded to run away creating items to try to fill it.
            this._physicalTop = Math.min(Math.floor(this._virtualStart) * this._physicalAverage, this._scrollPosition);
            this._update();
        } else if (this._physicalCount > 0) {
            const reusables = this._getReusables(isScrollingDown);
            if (isScrollingDown) {
                this._physicalTop = reusables.physicalTop;
                this._virtualStart += reusables.indexes.length;
                this._physicalStart += reusables.indexes.length;
            } else {
                this._virtualStart -= reusables.indexes.length;
                this._physicalStart -= reusables.indexes.length;
            }
            this._update(reusables.indexes, isScrollingDown ? null : reusables.indexes);
            this._debounce('_increasePoolIfNeeded', this._increasePoolIfNeeded.bind(this, 0), (0, $cxRfu.microTask));
        }
    },
    /**
   * Returns an object that contains the indexes of the physical items
   * that might be reused and the physicalTop.
   *
   * @param {boolean} fromTop If the potential reusable items are above the scrolling region.
   */ _getReusables (fromTop) {
        let ith, offsetContent, physicalItemHeight;
        const idxs = [];
        const protectedOffsetContent = this._hiddenContentSize * this._ratio;
        const virtualStart = this._virtualStart;
        const virtualEnd = this._virtualEnd;
        const physicalCount = this._physicalCount;
        let top = this._physicalTop + this._scrollOffset;
        const bottom = this._physicalBottom + this._scrollOffset;
        // This may be called outside of a scrollHandler, so use last cached position
        const scrollTop = this._scrollPosition;
        const scrollBottom = this._scrollBottom;
        if (fromTop) {
            ith = this._physicalStart;
            offsetContent = scrollTop - top;
        } else {
            ith = this._physicalEnd;
            offsetContent = bottom - scrollBottom;
        }
        // eslint-disable-next-line no-constant-condition
        while(true){
            physicalItemHeight = this._getPhysicalSizeIncrement(ith);
            offsetContent -= physicalItemHeight;
            if (idxs.length >= physicalCount || offsetContent <= protectedOffsetContent) break;
            if (fromTop) {
                // Check that index is within the valid range.
                if (virtualEnd + idxs.length + 1 >= this._virtualCount) break;
                // Check that the index is not visible.
                if (top + physicalItemHeight >= scrollTop - this._scrollOffset) break;
                idxs.push(ith);
                top += physicalItemHeight;
                ith = (ith + 1) % physicalCount;
            } else {
                // Check that index is within the valid range.
                if (virtualStart - idxs.length <= 0) break;
                // Check that the index is not visible.
                if (top + this._physicalSize - physicalItemHeight <= scrollBottom) break;
                idxs.push(ith);
                top -= physicalItemHeight;
                ith = ith === 0 ? physicalCount - 1 : ith - 1;
            }
        }
        return {
            indexes: idxs,
            physicalTop: top - this._scrollOffset
        };
    },
    /**
   * Update the list of items, starting from the `_virtualStart` item.
   * @param {!Array<number>=} itemSet
   * @param {!Array<number>=} movingUp
   */ _update (itemSet, movingUp) {
        if (itemSet && itemSet.length === 0 || this._physicalCount === 0) return;
        this._assignModels(itemSet);
        this._updateMetrics(itemSet);
        // Adjust offset after measuring.
        if (movingUp) while(movingUp.length){
            const idx = movingUp.pop();
            this._physicalTop -= this._getPhysicalSizeIncrement(idx);
        }
        this._positionItems();
        this._updateScrollerSize();
    },
    _isClientFull () {
        return this._scrollBottom !== 0 && this._physicalBottom - 1 >= this._scrollBottom && this._physicalTop <= this._scrollPosition;
    },
    /**
   * Increases the pool size.
   */ _increasePoolIfNeeded (count) {
        const nextPhysicalCount = this._clamp(this._physicalCount + count, $156e8c106beb0b1d$var$DEFAULT_PHYSICAL_COUNT, this._virtualCount - this._virtualStart);
        const delta = nextPhysicalCount - this._physicalCount;
        let nextIncrease = Math.round(this._physicalCount * 0.5);
        if (delta < 0) return;
        if (delta > 0) {
            const ts = window.performance.now();
            // Concat arrays in place.
            [].push.apply(this._physicalItems, this._createPool(delta));
            // Push 0s into physicalSizes. Can't use Array.fill because IE11 doesn't
            // support it.
            for(let i = 0; i < delta; i++)this._physicalSizes.push(0);
            this._physicalCount += delta;
            // Update the physical start if it needs to preserve the model of the
            // focused item. In this situation, the focused item is currently rendered
            // and its model would have changed after increasing the pool if the
            // physical start remained unchanged.
            if (this._physicalStart > this._physicalEnd && this._isIndexRendered(this._focusedVirtualIndex) && this._getPhysicalIndex(this._focusedVirtualIndex) < this._physicalEnd) this._physicalStart += delta;
            this._update();
            this._templateCost = (window.performance.now() - ts) / delta;
            nextIncrease = Math.round(this._physicalCount * 0.5);
        }
        if (this._virtualEnd >= this._virtualCount - 1 || nextIncrease === 0) ;
        else if (!this._isClientFull()) this._debounce('_increasePoolIfNeeded', this._increasePoolIfNeeded.bind(this, nextIncrease), (0, $cxRfu.microTask));
        else if (this._physicalSize < this._optPhysicalSize) // Yield and increase the pool during idle time until the physical size is
        // optimal.
        this._debounce('_increasePoolIfNeeded', this._increasePoolIfNeeded.bind(this, this._clamp(Math.round(50 / this._templateCost), 1, nextIncrease)), (0, $cxRfu.idlePeriod));
    },
    /**
   * Renders the a new list.
   */ _render () {
        if (!this.isAttached || !this._isVisible) return;
        if (this._physicalCount !== 0) {
            const reusables = this._getReusables(true);
            this._physicalTop = reusables.physicalTop;
            this._virtualStart += reusables.indexes.length;
            this._physicalStart += reusables.indexes.length;
            this._update(reusables.indexes);
            this._update();
            this._increasePoolIfNeeded(0);
        } else if (this._virtualCount > 0) {
            // Initial render
            this.updateViewportBoundaries();
            this._increasePoolIfNeeded($156e8c106beb0b1d$var$DEFAULT_PHYSICAL_COUNT);
        }
    },
    /**
   * Called when the items have changed. That is, reassignments
   * to `items`, splices or updates to a single item.
   */ _itemsChanged (change) {
        if (change.path === 'items') {
            this._virtualStart = 0;
            this._physicalTop = 0;
            this._virtualCount = this.items ? this.items.length : 0;
            this._physicalIndexForKey = {};
            this._firstVisibleIndexVal = null;
            this._lastVisibleIndexVal = null;
            this._physicalCount = this._physicalCount || 0;
            this._physicalItems = this._physicalItems || [];
            this._physicalSizes = this._physicalSizes || [];
            this._physicalStart = 0;
            if (this._scrollTop > this._scrollOffset) this._resetScrollPosition(0);
            this._debounce('_render', this._render, (0, $cxRfu.animationFrame));
        }
    },
    /**
   * Executes a provided function per every physical index in `itemSet`
   * `itemSet` default value is equivalent to the entire set of physical
   * indexes.
   *
   * @param {!function(number, number)} fn
   * @param {!Array<number>=} itemSet
   */ _iterateItems (fn, itemSet) {
        let pidx, vidx, rtn, i;
        if (arguments.length === 2 && itemSet) for(i = 0; i < itemSet.length; i++){
            pidx = itemSet[i];
            vidx = this._computeVidx(pidx);
            if ((rtn = fn.call(this, pidx, vidx)) != null) return rtn;
        }
        else {
            pidx = this._physicalStart;
            vidx = this._virtualStart;
            for(; pidx < this._physicalCount; pidx++, vidx++){
                if ((rtn = fn.call(this, pidx, vidx)) != null) return rtn;
            }
            for(pidx = 0; pidx < this._physicalStart; pidx++, vidx++){
                if ((rtn = fn.call(this, pidx, vidx)) != null) return rtn;
            }
        }
    },
    /**
   * Returns the virtual index for a given physical index
   *
   * @param {number} pidx Physical index
   * @return {number}
   */ _computeVidx (pidx) {
        if (pidx >= this._physicalStart) return this._virtualStart + (pidx - this._physicalStart);
        return this._virtualStart + (this._physicalCount - this._physicalStart) + pidx;
    },
    /**
   * Updates the position of the physical items.
   */ _positionItems () {
        this._adjustScrollPosition();
        let y = this._physicalTop;
        this._iterateItems((pidx)=>{
            this.translate3d(0, `${y}px`, 0, this._physicalItems[pidx]);
            y += this._physicalSizes[pidx];
        });
    },
    _getPhysicalSizeIncrement (pidx) {
        return this._physicalSizes[pidx];
    },
    /**
   * Adjusts the scroll position when it was overestimated.
   */ _adjustScrollPosition () {
        const deltaHeight = this._virtualStart === 0 ? this._physicalTop : Math.min(this._scrollPosition + this._physicalTop, 0);
        // Note: the delta can be positive or negative.
        if (deltaHeight !== 0) {
            this._physicalTop -= deltaHeight;
            // This may be called outside of a scrollHandler, so use last cached position
            const scrollTop = this._scrollPosition;
            // Juking scroll position during interial scrolling on iOS is no bueno
            if (!$156e8c106beb0b1d$var$IOS_TOUCH_SCROLLING && scrollTop > 0) this._resetScrollPosition(scrollTop - deltaHeight);
        }
    },
    /**
   * Sets the position of the scroll.
   */ _resetScrollPosition (pos) {
        if (this.scrollTarget && pos >= 0) {
            this._scrollTop = pos;
            this._scrollPosition = this._scrollTop;
        }
    },
    /**
   * Sets the scroll height, that's the height of the content,
   *
   * @param {boolean=} forceUpdate If true, updates the height no matter what.
   */ _updateScrollerSize (forceUpdate) {
        this._estScrollHeight = this._physicalBottom + Math.max(this._virtualCount - this._physicalCount - this._virtualStart, 0) * this._physicalAverage;
        forceUpdate = forceUpdate || this._scrollHeight === 0;
        forceUpdate = forceUpdate || this._scrollPosition >= this._estScrollHeight - this._physicalSize;
        // Amortize height adjustment, so it won't trigger large repaints too often.
        if (forceUpdate || Math.abs(this._estScrollHeight - this._scrollHeight) >= this._viewportHeight) {
            this.$.items.style.height = `${this._estScrollHeight}px`;
            this._scrollHeight = this._estScrollHeight;
        }
    },
    /**
   * Scroll to a specific index in the virtual list regardless
   * of the physical items in the DOM tree.
   *
   * @method scrollToIndex
   * @param {number} idx The index of the item
   */ scrollToIndex (idx) {
        if (typeof idx !== 'number' || idx < 0 || idx > this.items.length - 1) return;
        (0, $jlr9D.flush)();
        // Items should have been rendered prior scrolling to an index.
        if (this._physicalCount === 0) return;
        idx = this._clamp(idx, 0, this._virtualCount - 1);
        // Update the virtual start only when needed.
        if (!this._isIndexRendered(idx) || idx >= this._maxVirtualStart) this._virtualStart = idx - 1;
        this._assignModels();
        this._updateMetrics();
        // Estimate new physical offset.
        this._physicalTop = this._virtualStart * this._physicalAverage;
        let currentTopItem = this._physicalStart;
        let currentVirtualItem = this._virtualStart;
        let targetOffsetTop = 0;
        const hiddenContentSize = this._hiddenContentSize;
        // Scroll to the item as much as we can.
        while(currentVirtualItem < idx && targetOffsetTop <= hiddenContentSize){
            targetOffsetTop += this._getPhysicalSizeIncrement(currentTopItem);
            currentTopItem = (currentTopItem + 1) % this._physicalCount;
            currentVirtualItem += 1;
        }
        this._updateScrollerSize(true);
        this._positionItems();
        this._resetScrollPosition(this._physicalTop + this._scrollOffset + targetOffsetTop);
        this._increasePoolIfNeeded(0);
        // Clear cached visible index.
        this._firstVisibleIndexVal = null;
        this._lastVisibleIndexVal = null;
    },
    /**
   * Reset the physical average and the average count.
   */ _resetAverage () {
        this._physicalAverage = 0;
        this._physicalAverageCount = 0;
    },
    /**
   * A handler for the `iron-resize` event triggered by `IronResizableBehavior`
   * when the element is resized.
   */ _resizeHandler () {
        this._debounce('_render', ()=>{
            // Clear cached visible index.
            this._firstVisibleIndexVal = null;
            this._lastVisibleIndexVal = null;
            if (this._isVisible) {
                this.updateViewportBoundaries();
                // Reinstall the scroll event listener.
                this.toggleScrollListener(true);
                this._resetAverage();
                this._render();
            } else // Uninstall the scroll event listener.
            this.toggleScrollListener(false);
        }, (0, $cxRfu.animationFrame));
    },
    _isIndexRendered (idx) {
        return idx >= this._virtualStart && idx <= this._virtualEnd;
    },
    _getPhysicalIndex (vidx) {
        return (this._physicalStart + (vidx - this._virtualStart)) % this._physicalCount;
    },
    _clamp (v, min, max) {
        return Math.min(max, Math.max(min, v));
    },
    _debounce (name, cb, asyncModule) {
        this._debouncers = this._debouncers || {};
        this._debouncers[name] = (0, $jlr9D.Debouncer).debounce(this._debouncers[name], asyncModule, cb.bind(this));
        (0, $jlr9D.enqueueDebouncer)(this._debouncers[name]);
    }
};

});





parcelRegister("hX2nQ", function(module, exports) {

$parcel$export(module.exports, "ComboBoxDataProviderMixin", () => $d119cbaf9e835099$export$ff11b2ac5803ce7);
/**
 * @license
 * Copyright (c) 2015 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $2XUc1 = parcelRequire("2XUc1");
const $d119cbaf9e835099$export$ff11b2ac5803ce7 = (superClass)=>class DataProviderMixin extends superClass {
        static get properties() {
            return {
                /**
         * Number of items fetched at a time from the dataprovider.
         * @attr {number} page-size
         * @type {number}
         */ pageSize: {
                    type: Number,
                    value: 50,
                    observer: '_pageSizeChanged'
                },
                /**
         * Total number of items.
         * @type {number | undefined}
         */ size: {
                    type: Number,
                    observer: '_sizeChanged'
                },
                /**
         * Function that provides items lazily. Receives arguments `params`, `callback`
         *
         * `params.page` Requested page index
         *
         * `params.pageSize` Current page size
         *
         * `params.filter` Currently applied filter
         *
         * `callback(items, size)` Callback function with arguments:
         *   - `items` Current page of items
         *   - `size` Total number of items.
         * @type {ComboBoxDataProvider | undefined}
         */ dataProvider: {
                    type: Object,
                    observer: '_dataProviderChanged'
                },
                /** @private */ _pendingRequests: {
                    value: ()=>{
                        return {};
                    }
                },
                /** @private */ __placeHolder: {
                    value: new (0, $2XUc1.ComboBoxPlaceholder)()
                },
                /** @private */ __previousDataProviderFilter: {
                    type: String
                }
            };
        }
        static get observers() {
            return [
                '_dataProviderFilterChanged(filter)',
                '_warnDataProviderValue(dataProvider, value)',
                '_ensureFirstPage(opened)'
            ];
        }
        /** @protected */ ready() {
            super.ready();
            this._scroller.addEventListener('index-requested', (e)=>{
                const index = e.detail.index;
                const currentScrollerPos = e.detail.currentScrollerPos;
                const allowedIndexRange = Math.floor(this.pageSize * 1.5);
                // Ignores the indexes, which are being re-sent during scrolling reset,
                // if the corresponding page is around the current scroller position.
                // Otherwise, there might be a last pages duplicates, which cause the
                // loading indicator hanging and blank items
                if (this._shouldSkipIndex(index, allowedIndexRange, currentScrollerPos)) return;
                if (index !== undefined) {
                    const page = this._getPageForIndex(index);
                    if (this._shouldLoadPage(page)) this._loadPage(page);
                }
            });
        }
        /** @private */ _dataProviderFilterChanged(filter) {
            if (this.__previousDataProviderFilter === undefined && filter === '') {
                this.__previousDataProviderFilter = filter;
                return;
            }
            if (this.__previousDataProviderFilter !== filter) {
                this.__previousDataProviderFilter = filter;
                this._pendingRequests = {};
                // Immediately mark as loading if this refresh leads to re-fetching pages
                // This prevents some issues with the properties below triggering
                // observers that also rely on the loading state
                this.loading = this._shouldFetchData();
                // Reset size and internal loading state
                this.size = undefined;
                this.clearCache();
            }
        }
        /** @private */ _shouldFetchData() {
            if (!this.dataProvider) return false;
            return this.opened || this.filter && this.filter.length;
        }
        /** @private */ _ensureFirstPage(opened) {
            if (opened && this._shouldLoadPage(0)) this._loadPage(0);
        }
        /** @private */ _shouldSkipIndex(index, allowedIndexRange, currentScrollerPos) {
            return currentScrollerPos !== 0 && index >= currentScrollerPos - allowedIndexRange && index <= currentScrollerPos + allowedIndexRange;
        }
        /** @private */ _shouldLoadPage(page) {
            if (!this.filteredItems || this._forceNextRequest) {
                this._forceNextRequest = false;
                return true;
            }
            const loadedItem = this.filteredItems[page * this.pageSize];
            if (loadedItem !== undefined) return loadedItem instanceof (0, $2XUc1.ComboBoxPlaceholder);
            return this.size === undefined;
        }
        /** @private */ _loadPage(page) {
            // Make sure same page isn't requested multiple times.
            if (this._pendingRequests[page] || !this.dataProvider) return;
            const params = {
                page: page,
                pageSize: this.pageSize,
                filter: this.filter
            };
            const callback = (items, size)=>{
                if (this._pendingRequests[page] !== callback) return;
                const filteredItems = this.filteredItems ? [
                    ...this.filteredItems
                ] : [];
                filteredItems.splice(params.page * params.pageSize, items.length, ...items);
                this.filteredItems = filteredItems;
                if (!this.opened && !this._isInputFocused()) this._commitValue();
                if (size !== undefined) this.size = size;
                delete this._pendingRequests[page];
                if (Object.keys(this._pendingRequests).length === 0) this.loading = false;
            };
            this._pendingRequests[page] = callback;
            // Set the `loading` flag only after marking the request as pending
            // to prevent the same page from getting requested multiple times
            // as a result of `__loadingChanged` in the scroller which requests
            // a virtualizer update which in turn may trigger a data provider page request.
            this.loading = true;
            this.dataProvider(params, callback);
        }
        /** @private */ _getPageForIndex(index) {
            return Math.floor(index / this.pageSize);
        }
        /**
     * Clears the cached pages and reloads data from dataprovider when needed.
     */ clearCache() {
            if (!this.dataProvider) return;
            this._pendingRequests = {};
            const filteredItems = [];
            for(let i = 0; i < (this.size || 0); i++)filteredItems.push(this.__placeHolder);
            this.filteredItems = filteredItems;
            if (this._shouldFetchData()) {
                this._forceNextRequest = false;
                this._loadPage(0);
            } else this._forceNextRequest = true;
        }
        /** @private */ _sizeChanged(size = 0) {
            const filteredItems = (this.filteredItems || []).slice(0, size);
            for(let i = 0; i < size; i++)filteredItems[i] = filteredItems[i] !== undefined ? filteredItems[i] : this.__placeHolder;
            this.filteredItems = filteredItems;
            // Cleans up the redundant pending requests for pages > size
            // Refers to https://github.com/vaadin/vaadin-flow-components/issues/229
            this._flushPendingRequests(size);
        }
        /** @private */ _pageSizeChanged(pageSize, oldPageSize) {
            if (Math.floor(pageSize) !== pageSize || pageSize < 1) {
                this.pageSize = oldPageSize;
                throw new Error('`pageSize` value must be an integer > 0');
            }
            this.clearCache();
        }
        /** @private */ _dataProviderChanged(dataProvider, oldDataProvider) {
            this._ensureItemsOrDataProvider(()=>{
                this.dataProvider = oldDataProvider;
            });
            this.clearCache();
        }
        /** @private */ _ensureItemsOrDataProvider(restoreOldValueCallback) {
            if (this.items !== undefined && this.dataProvider !== undefined) {
                restoreOldValueCallback();
                throw new Error('Using `items` and `dataProvider` together is not supported');
            } else if (this.dataProvider && !this.filteredItems) this.filteredItems = [];
        }
        /** @private */ _warnDataProviderValue(dataProvider, value) {
            if (dataProvider && value !== '' && (this.selectedItem === undefined || this.selectedItem === null)) {
                const valueIndex = this.__getItemIndexByValue(this.filteredItems, value);
                if (valueIndex < 0 || !this._getItemLabel(this.filteredItems[valueIndex])) console.warn("Warning: unable to determine the label for the provided `value`. Nothing to display in the text field. This usually happens when setting an initial `value` before any items are returned from the `dataProvider` callback. Consider setting `selectedItem` instead of `value`");
            }
        }
        /**
     * This method cleans up the page callbacks which refers to the
     * non-existing pages, i.e. which item indexes are greater than the
     * changed size.
     * This case is basically happens when:
     * 1. Users scroll fast to the bottom and combo box generates the
     * redundant page request/callback
     * 2. Server side uses undefined size lazy loading and suddenly reaches
     * the exact size which is on the range edge
     * (for default page size = 50, it will be 100, 200, 300, ...).
     * @param size the new size of items
     * @private
     */ _flushPendingRequests(size) {
            if (this._pendingRequests) {
                const lastPage = Math.ceil(size / this.pageSize);
                const pendingRequestsKeys = Object.keys(this._pendingRequests);
                for(let reqIdx = 0; reqIdx < pendingRequestsKeys.length; reqIdx++){
                    const page = parseInt(pendingRequestsKeys[reqIdx]);
                    if (page >= lastPage) this._pendingRequests[page]([], size);
                }
            }
        }
    };

});

parcelRegister("3tdkf", function(module, exports) {

$parcel$export(module.exports, "ComboBoxMixin", () => $286e6abade75a309$export$17ddddd1531348d0);
/**
 * @license
 * Copyright (c) 2015 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $aC4kq = parcelRequire("aC4kq");

var $bthO9 = parcelRequire("bthO9");

var $jf0Pl = parcelRequire("jf0Pl");

var $IaWw6 = parcelRequire("IaWw6");

var $j2V0r = parcelRequire("j2V0r");

var $gD7RT = parcelRequire("gD7RT");

var $hGDlz = parcelRequire("hGDlz");

var $6UHjX = parcelRequire("6UHjX");

var $2XUc1 = parcelRequire("2XUc1");
/**
 * Checks if the value is supported as an item value in this control.
 *
 * @param {unknown} value
 * @return {boolean}
 */ function $286e6abade75a309$var$isValidValue(value) {
    return value !== undefined && value !== null;
}
/**
 * Returns the index of the first item that satisfies the provided testing function
 * ignoring placeholder items.
 *
 * @param {Array<ComboBoxItem | string>} items
 * @param {Function} callback
 * @return {number}
 */ function $286e6abade75a309$var$findItemIndex(items, callback) {
    return items.findIndex((item)=>{
        if (item instanceof (0, $2XUc1.ComboBoxPlaceholder)) return false;
        return callback(item);
    });
}
const $286e6abade75a309$export$17ddddd1531348d0 = (subclass)=>class VaadinComboBoxMixinElement extends (0, $bthO9.ControllerMixin)((0, $j2V0r.KeyboardMixin)((0, $hGDlz.InputMixin)((0, $jf0Pl.DisabledMixin)(subclass)))) {
        static get properties() {
            return {
                /**
         * True if the dropdown is open, false otherwise.
         * @type {boolean}
         */ opened: {
                    type: Boolean,
                    notify: true,
                    value: false,
                    reflectToAttribute: true,
                    observer: '_openedChanged'
                },
                /**
         * Set true to prevent the overlay from opening automatically.
         * @attr {boolean} auto-open-disabled
         */ autoOpenDisabled: {
                    type: Boolean
                },
                /**
         * When present, it specifies that the field is read-only.
         * @type {boolean}
         */ readonly: {
                    type: Boolean,
                    value: false,
                    reflectToAttribute: true
                },
                /**
         * Custom function for rendering the content of every item.
         * Receives three arguments:
         *
         * - `root` The `<vaadin-combo-box-item>` internal container DOM element.
         * - `comboBox` The reference to the `<vaadin-combo-box>` element.
         * - `model` The object with the properties related with the rendered
         *   item, contains:
         *   - `model.index` The index of the rendered item.
         *   - `model.item` The item.
         * @type {ComboBoxRenderer | undefined}
         */ renderer: Function,
                /**
         * A full set of items to filter the visible options from.
         * The items can be of either `String` or `Object` type.
         * @type {!Array<!ComboBoxItem | string> | undefined}
         */ items: {
                    type: Array,
                    observer: '_itemsChanged'
                },
                /**
         * If `true`, the user can input a value that is not present in the items list.
         * `value` property will be set to the input value in this case.
         * Also, when `value` is set programmatically, the input value will be set
         * to reflect that value.
         * @attr {boolean} allow-custom-value
         * @type {boolean}
         */ allowCustomValue: {
                    type: Boolean,
                    value: false
                },
                /**
         * A subset of items, filtered based on the user input. Filtered items
         * can be assigned directly to omit the internal filtering functionality.
         * The items can be of either `String` or `Object` type.
         * @type {!Array<!ComboBoxItem | string> | undefined}
         */ filteredItems: {
                    type: Array,
                    observer: '_filteredItemsChanged'
                },
                /**
         * Used to detect user value changes and fire `change` events.
         * @private
         */ _lastCommittedValue: String,
                /**
         * When set to `true`, "loading" attribute is added to host and the overlay element.
         * @type {boolean}
         */ loading: {
                    type: Boolean,
                    value: false,
                    reflectToAttribute: true
                },
                /**
         * @type {number}
         * @protected
         */ _focusedIndex: {
                    type: Number,
                    observer: '_focusedIndexChanged',
                    value: -1
                },
                /**
         * Filtering string the user has typed into the input field.
         * @type {string}
         */ filter: {
                    type: String,
                    value: '',
                    notify: true
                },
                /**
         * The selected item from the `items` array.
         * @type {ComboBoxItem | string | undefined}
         */ selectedItem: {
                    type: Object,
                    notify: true
                },
                /**
         * Path for label of the item. If `items` is an array of objects, the
         * `itemLabelPath` is used to fetch the displayed string label for each
         * item.
         *
         * The item label is also used for matching items when processing user
         * input, i.e., for filtering and selecting items.
         * @attr {string} item-label-path
         * @type {string}
         */ itemLabelPath: {
                    type: String,
                    value: 'label',
                    observer: '_itemLabelPathChanged'
                },
                /**
         * Path for the value of the item. If `items` is an array of objects, the
         * `itemValuePath:` is used to fetch the string value for the selected
         * item.
         *
         * The item value is used in the `value` property of the combo box,
         * to provide the form value.
         * @attr {string} item-value-path
         * @type {string}
         */ itemValuePath: {
                    type: String,
                    value: 'value'
                },
                /**
         * Path for the id of the item. If `items` is an array of objects,
         * the `itemIdPath` is used to compare and identify the same item
         * in `selectedItem` and `filteredItems` (items given by the
         * `dataProvider` callback).
         * @attr {string} item-id-path
         */ itemIdPath: String,
                /**
         * @type {!HTMLElement | undefined}
         * @protected
         */ _toggleElement: {
                    type: Object,
                    observer: '_toggleElementChanged'
                },
                /** @private */ _closeOnBlurIsPrevented: Boolean,
                /** @private */ _scroller: Object,
                /** @private */ _overlayOpened: {
                    type: Boolean,
                    observer: '_overlayOpenedChanged'
                }
            };
        }
        static get observers() {
            return [
                '_selectedItemChanged(selectedItem, itemValuePath, itemLabelPath)',
                '_openedOrItemsChanged(opened, filteredItems, loading)',
                '_updateScroller(_scroller, filteredItems, opened, loading, selectedItem, itemIdPath, _focusedIndex, renderer, theme)'
            ];
        }
        constructor(){
            super();
            this._boundOnFocusout = this._onFocusout.bind(this);
            this._boundOverlaySelectedItemChanged = this._overlaySelectedItemChanged.bind(this);
            this._boundOnClearButtonMouseDown = this.__onClearButtonMouseDown.bind(this);
            this._boundOnClick = this._onClick.bind(this);
            this._boundOnOverlayTouchAction = this._onOverlayTouchAction.bind(this);
            this._boundOnTouchend = this._onTouchend.bind(this);
        }
        /**
     * Tag name prefix used by scroller and items.
     * @protected
     * @return {string}
     */ get _tagNamePrefix() {
            return 'vaadin-combo-box';
        }
        /**
     * @return {string | undefined}
     * @protected
     */ get _inputElementValue() {
            return this.inputElement ? this.inputElement[this._propertyForValue] : undefined;
        }
        /**
     * @param {string} value
     * @protected
     */ set _inputElementValue(value) {
            if (this.inputElement) this.inputElement[this._propertyForValue] = value;
        }
        /**
     * Get a reference to the native `<input>` element.
     * Override to provide a custom input.
     * @protected
     * @return {HTMLInputElement | undefined}
     */ get _nativeInput() {
            return this.inputElement;
        }
        /**
     * Override method inherited from `InputMixin`
     * to customize the input element.
     * @protected
     * @override
     */ _inputElementChanged(inputElement) {
            super._inputElementChanged(inputElement);
            const input = this._nativeInput;
            if (input) {
                input.autocomplete = 'off';
                input.autocapitalize = 'off';
                input.setAttribute('role', 'combobox');
                input.setAttribute('aria-autocomplete', 'list');
                input.setAttribute('aria-expanded', !!this.opened);
                // Disable the macOS Safari spell check auto corrections.
                input.setAttribute('spellcheck', 'false');
                // Disable iOS autocorrect suggestions.
                input.setAttribute('autocorrect', 'off');
                this._revertInputValueToValue();
                if (this.clearElement) this.clearElement.addEventListener('mousedown', this._boundOnClearButtonMouseDown);
            }
        }
        /** @protected */ ready() {
            super.ready();
            this._initOverlay();
            this._initScroller();
            this.addEventListener('focusout', this._boundOnFocusout);
            this._lastCommittedValue = this.value;
            this.addEventListener('click', this._boundOnClick);
            this.addEventListener('touchend', this._boundOnTouchend);
            const bringToFrontListener = ()=>{
                requestAnimationFrame(()=>{
                    this.$.overlay.bringToFront();
                });
            };
            this.addEventListener('mousedown', bringToFrontListener);
            this.addEventListener('touchstart', bringToFrontListener);
            (0, $gD7RT.processTemplates)(this);
            this.addController(new (0, $6UHjX.VirtualKeyboardController)(this));
        }
        /** @protected */ disconnectedCallback() {
            super.disconnectedCallback();
            // Close the overlay on detach
            this.close();
        }
        /**
     * Requests an update for the content of items.
     * While performing the update, it invokes the renderer (passed in the `renderer` property) once an item.
     *
     * It is not guaranteed that the update happens immediately (synchronously) after it is requested.
     */ requestContentUpdate() {
            if (!this._scroller) return;
            this._scroller.requestContentUpdate();
            this._getItemElements().forEach((item)=>{
                item.requestContentUpdate();
            });
        }
        /**
     * Opens the dropdown list.
     */ open() {
            // Prevent _open() being called when input is disabled or read-only
            if (!this.disabled && !this.readonly) this.opened = true;
        }
        /**
     * Closes the dropdown list.
     */ close() {
            this.opened = false;
        }
        /**
     * Override Polymer lifecycle callback to handle `filter` property change after
     * the observer for `opened` property is triggered. This is needed when opening
     * combo-box on user input to ensure the focused index is set correctly.
     *
     * @param {!Object} currentProps Current accessor values
     * @param {?Object} changedProps Properties changed since the last call
     * @param {?Object} oldProps Previous values for each changed property
     * @protected
     * @override
     */ _propertiesChanged(currentProps, changedProps, oldProps) {
            super._propertiesChanged(currentProps, changedProps, oldProps);
            if (changedProps.filter !== undefined) this._filterChanged(changedProps.filter);
        }
        /** @private */ _initOverlay() {
            const overlay = this.$.overlay;
            // Store instance for detecting "dir" attribute on opening
            overlay._comboBox = this;
            overlay.addEventListener('touchend', this._boundOnOverlayTouchAction);
            overlay.addEventListener('touchmove', this._boundOnOverlayTouchAction);
            // Prevent blurring the input when clicking inside the overlay
            overlay.addEventListener('mousedown', (e)=>e.preventDefault());
            // Manual two-way binding for the overlay "opened" property
            overlay.addEventListener('opened-changed', (e)=>{
                this._overlayOpened = e.detail.value;
            });
        }
        /**
     * Create and initialize the scroller element.
     * Override to provide custom host reference.
     *
     * @protected
     */ _initScroller(host) {
            const scrollerTag = `${this._tagNamePrefix}-scroller`;
            const overlay = this.$.overlay;
            overlay.renderer = (root)=>{
                if (!root.firstChild) root.appendChild(document.createElement(scrollerTag));
            };
            // Ensure the scroller is rendered
            overlay.requestContentUpdate();
            const scroller = overlay.querySelector(scrollerTag);
            scroller.comboBox = host || this;
            scroller.getItemLabel = this._getItemLabel.bind(this);
            scroller.addEventListener('selection-changed', this._boundOverlaySelectedItemChanged);
            // Trigger the observer to set properties
            this._scroller = scroller;
        }
        /** @private */ // eslint-disable-next-line max-params
        _updateScroller(scroller, items, opened, loading, selectedItem, itemIdPath, focusedIndex, renderer, theme) {
            if (scroller) {
                if (opened) scroller.style.maxHeight = getComputedStyle(this).getPropertyValue(`--${this._tagNamePrefix}-overlay-max-height`) || '65vh';
                scroller.setProperties({
                    items: opened ? items : [],
                    opened: opened,
                    loading: loading,
                    selectedItem: selectedItem,
                    itemIdPath: itemIdPath,
                    focusedIndex: focusedIndex,
                    renderer: renderer,
                    theme: theme
                });
            }
        }
        /** @private */ _openedOrItemsChanged(opened, items, loading) {
            // Close the overlay if there are no items to display.
            // See https://github.com/vaadin/vaadin-combo-box/pull/964
            this._overlayOpened = !!(opened && (loading || items && items.length));
        }
        /** @private */ _overlayOpenedChanged(opened, wasOpened) {
            if (opened) {
                this.dispatchEvent(new CustomEvent('vaadin-combo-box-dropdown-opened', {
                    bubbles: true,
                    composed: true
                }));
                this._onOpened();
            } else if (wasOpened && this.filteredItems && this.filteredItems.length) {
                this.close();
                this.dispatchEvent(new CustomEvent('vaadin-combo-box-dropdown-closed', {
                    bubbles: true,
                    composed: true
                }));
            }
        }
        /** @private */ _focusedIndexChanged(index, oldIndex) {
            if (oldIndex === undefined) return;
            this._updateActiveDescendant(index);
        }
        /** @protected */ _isInputFocused() {
            return this.inputElement && (0, $IaWw6.isElementFocused)(this.inputElement);
        }
        /** @private */ _updateActiveDescendant(index) {
            const input = this._nativeInput;
            if (!input) return;
            const item = this._getItemElements().find((el)=>el.index === index);
            if (item) input.setAttribute('aria-activedescendant', item.id);
            else input.removeAttribute('aria-activedescendant');
        }
        /** @private */ _openedChanged(opened, wasOpened) {
            // Prevent _close() being called when opened is set to its default value (false).
            if (wasOpened === undefined) return;
            if (opened) {
                this._openedWithFocusRing = this.hasAttribute('focus-ring');
                // For touch devices, we don't want to popup virtual keyboard
                // unless input element is explicitly focused by the user.
                if (!this._isInputFocused() && !(0, $aC4kq.isTouch)) this.focus();
                this.$.overlay.restoreFocusOnClose = true;
            } else {
                this._onClosed();
                if (this._openedWithFocusRing && this._isInputFocused()) this.setAttribute('focus-ring', '');
            }
            const input = this._nativeInput;
            if (input) {
                input.setAttribute('aria-expanded', !!opened);
                if (opened) input.setAttribute('aria-controls', this._scroller.id);
                else input.removeAttribute('aria-controls');
            }
        }
        /** @private */ _onOverlayTouchAction() {
            // On touch devices, blur the input on touch start inside the overlay, in order to hide
            // the virtual keyboard. But don't close the overlay on this blur.
            this._closeOnBlurIsPrevented = true;
            this.inputElement.blur();
            this._closeOnBlurIsPrevented = false;
        }
        /** @protected */ _isClearButton(event) {
            return event.composedPath()[0] === this.clearElement;
        }
        /**
     * @param {Event} event
     * @protected
     */ _handleClearButtonClick(event) {
            event.preventDefault();
            this._clear();
            // De-select dropdown item
            if (this.opened) this.requestContentUpdate();
        }
        /**
     * @param {Event} event
     * @private
     */ _onToggleButtonClick(event) {
            // Prevent parent components such as `vaadin-grid`
            // from handling the click event after it bubbles.
            event.preventDefault();
            if (this.opened) this.close();
            else this.open();
        }
        /**
     * @param {Event} event
     * @protected
     */ _onHostClick(event) {
            if (!this.autoOpenDisabled) {
                event.preventDefault();
                this.open();
            }
        }
        /** @private */ _onClick(e) {
            const path = e.composedPath();
            if (this._isClearButton(e)) this._handleClearButtonClick(e);
            else if (path.indexOf(this._toggleElement) > -1) this._onToggleButtonClick(e);
            else this._onHostClick(e);
        }
        /**
     * Override an event listener from `KeyboardMixin`.
     *
     * @param {KeyboardEvent} e
     * @protected
     * @override
     */ _onKeyDown(e) {
            super._onKeyDown(e);
            if (e.key === 'Tab') this.$.overlay.restoreFocusOnClose = false;
            else if (e.key === 'ArrowDown') {
                this._onArrowDown();
                // Prevent caret from moving
                e.preventDefault();
            } else if (e.key === 'ArrowUp') {
                this._onArrowUp();
                // Prevent caret from moving
                e.preventDefault();
            }
        }
        /** @private */ _getItemLabel(item) {
            let label = item && this.itemLabelPath ? this.get(this.itemLabelPath, item) : undefined;
            if (label === undefined || label === null) label = item ? item.toString() : '';
            return label;
        }
        /** @private */ _getItemValue(item) {
            let value = item && this.itemValuePath ? this.get(this.itemValuePath, item) : undefined;
            if (value === undefined) value = item ? item.toString() : '';
            return value;
        }
        /** @private */ _onArrowDown() {
            if (this.opened) {
                const items = this.filteredItems;
                if (items) {
                    this._focusedIndex = Math.min(items.length - 1, this._focusedIndex + 1);
                    this._prefillFocusedItemLabel();
                }
            } else this.open();
        }
        /** @private */ _onArrowUp() {
            if (this.opened) {
                if (this._focusedIndex > -1) this._focusedIndex = Math.max(0, this._focusedIndex - 1);
                else {
                    const items = this.filteredItems;
                    if (items) this._focusedIndex = items.length - 1;
                }
                this._prefillFocusedItemLabel();
            } else this.open();
        }
        /** @private */ _prefillFocusedItemLabel() {
            if (this._focusedIndex > -1) {
                const focusedItem = this.filteredItems[this._focusedIndex];
                this._inputElementValue = this._getItemLabel(focusedItem);
                this._markAllSelectionRange();
            }
        }
        /** @private */ _setSelectionRange(start, end) {
            // Setting selection range focuses and/or moves the caret in some browsers,
            // and there's no need to modify the selection range if the input isn't focused anyway.
            // This affects Safari. When the overlay is open, and then hitting tab, browser should focus
            // the next focusable element instead of the combo-box itself.
            if (this._isInputFocused() && this.inputElement.setSelectionRange) this.inputElement.setSelectionRange(start, end);
        }
        /** @private */ _markAllSelectionRange() {
            if (this._inputElementValue !== undefined) this._setSelectionRange(0, this._inputElementValue.length);
        }
        /** @private */ _clearSelectionRange() {
            if (this._inputElementValue !== undefined) {
                const pos = this._inputElementValue ? this._inputElementValue.length : 0;
                this._setSelectionRange(pos, pos);
            }
        }
        /** @private */ _closeOrCommit() {
            if (!this.opened && !this.loading) this._commitValue();
            else this.close();
        }
        /**
     * Override an event listener from `KeyboardMixin`.
     *
     * @param {KeyboardEvent} e
     * @protected
     * @override
     */ _onEnter(e) {
            // Do not commit value when custom values are disallowed and input value is not a valid option
            // also stop propagation of the event, otherwise the user could submit a form while the input
            // still contains an invalid value
            const hasInvalidOption = this._focusedIndex < 0 && this._inputElementValue !== '' && this._getItemLabel(this.selectedItem) !== this._inputElementValue;
            if (!this.allowCustomValue && hasInvalidOption) {
                // Do not submit the surrounding form.
                e.preventDefault();
                // Do not trigger global listeners
                e.stopPropagation();
                return;
            }
            // Stop propagation of the enter event only if the dropdown is opened, this
            // "consumes" the enter event for the action of closing the dropdown
            if (this.opened) {
                // Do not submit the surrounding form.
                e.preventDefault();
                // Do not trigger global listeners
                e.stopPropagation();
            }
            this._closeOrCommit();
        }
        /**
     * Override an event listener from `KeyboardMixin`.
     * Do not call `super` in order to override clear
     * button logic defined in `InputControlMixin`.
     *
     * @param {!KeyboardEvent} e
     * @protected
     * @override
     */ _onEscape(e) {
            if (this.autoOpenDisabled) {
                // Auto-open is disabled
                if (this.opened || this.value !== this._inputElementValue && this._inputElementValue.length > 0) {
                    // The overlay is open or
                    // The input value has changed but the change hasn't been committed, so cancel it.
                    e.stopPropagation();
                    this._focusedIndex = -1;
                    this.cancel();
                } else if (this.clearButtonVisible && !this.opened && !!this.value) {
                    e.stopPropagation();
                    // The clear button is visible and the overlay is closed, so clear the value.
                    this._clear();
                }
            } else if (this.opened) {
                // Auto-open is enabled
                // The overlay is open
                e.stopPropagation();
                if (this._focusedIndex > -1) {
                    // An item is focused, revert the input to the filtered value
                    this._focusedIndex = -1;
                    this._revertInputValue();
                } else // No item is focused, cancel the change and close the overlay
                this.cancel();
            } else if (this.clearButtonVisible && !!this.value) {
                e.stopPropagation();
                // The clear button is visible and the overlay is closed, so clear the value.
                this._clear();
            }
        }
        /** @private */ _toggleElementChanged(toggleElement) {
            if (toggleElement) {
                // Don't blur the input on toggle mousedown
                toggleElement.addEventListener('mousedown', (e)=>e.preventDefault());
                // Unfocus previously focused element if focus is not inside combo box (on touch devices)
                toggleElement.addEventListener('click', ()=>{
                    if ((0, $aC4kq.isTouch) && !this._isInputFocused()) document.activeElement.blur();
                });
            }
        }
        /**
     * Clears the current value.
     * @protected
     */ _clear() {
            this.selectedItem = null;
            if (this.allowCustomValue) this.value = '';
            this._detectAndDispatchChange();
        }
        /**
     * Reverts back to original value.
     */ cancel() {
            this._revertInputValueToValue();
            // In the next _detectAndDispatchChange() call, the change detection should not pass
            this._lastCommittedValue = this.value;
            this._closeOrCommit();
        }
        /** @private */ _onOpened() {
            // Defer scroll position adjustment to improve performance.
            requestAnimationFrame(()=>{
                this._scrollIntoView(this._focusedIndex);
                // Set attribute after the items are rendered when overlay is opened for the first time.
                this._updateActiveDescendant(this._focusedIndex);
            });
            // _detectAndDispatchChange() should not consider value changes done before opening
            this._lastCommittedValue = this.value;
        }
        /** @private */ _onClosed() {
            if (!this.loading || this.allowCustomValue) this._commitValue();
        }
        /** @private */ _commitValue() {
            if (this._focusedIndex > -1) {
                const focusedItem = this.filteredItems[this._focusedIndex];
                if (this.selectedItem !== focusedItem) this.selectedItem = focusedItem;
                // Make sure input field is updated in case value doesn't change (i.e. FOO -> foo)
                this._inputElementValue = this._getItemLabel(this.selectedItem);
            } else if (this._inputElementValue === '' || this._inputElementValue === undefined) {
                this.selectedItem = null;
                if (this.allowCustomValue) this.value = '';
            } else {
                // Try to find an item which label matches the input value.
                const items = [
                    ...this.filteredItems || [],
                    this.selectedItem
                ];
                const itemMatchingInputValue = items[this.__getItemIndexByLabel(items, this._inputElementValue)];
                if (this.allowCustomValue && // To prevent a repetitive input value being saved after pressing ESC and Tab.
                !itemMatchingInputValue) {
                    const customValue = this._inputElementValue;
                    // Store reference to the last custom value for checking it on focusout.
                    this._lastCustomValue = customValue;
                    // An item matching by label was not found, but custom values are allowed.
                    // Dispatch a custom-value-set event with the input value.
                    const e = new CustomEvent('custom-value-set', {
                        detail: customValue,
                        composed: true,
                        cancelable: true,
                        bubbles: true
                    });
                    this.dispatchEvent(e);
                    if (!e.defaultPrevented) this.value = customValue;
                } else if (!this.allowCustomValue && !this.opened && itemMatchingInputValue) // An item matching by label was found, select it.
                this.value = this._getItemValue(itemMatchingInputValue);
                else // Revert the input value
                this._inputElementValue = this.selectedItem ? this._getItemLabel(this.selectedItem) : this.value || '';
            }
            this._detectAndDispatchChange();
            this._clearSelectionRange();
            this.filter = '';
        }
        /**
     * @return {string}
     * @protected
     */ get _propertyForValue() {
            return 'value';
        }
        /**
     * Override an event listener from `InputMixin`.
     * @param {!Event} event
     * @protected
     * @override
     */ _onInput(event) {
            const filter = this._inputElementValue;
            // When opening dropdown on user input, both `opened` and `filter` properties are set.
            // Perform a batched property update instead of relying on sync property observers.
            // This is necessary to avoid an extra data-provider request for loading first page.
            const props = {};
            if (this.filter === filter) // Filter and input value might get out of sync, while keyboard navigating for example.
            // Afterwards, input value might be changed to the same value as used in filtering.
            // In situation like these, we need to make sure all the filter changes handlers are run.
            this._filterChanged(this.filter);
            else props.filter = filter;
            if (!this.opened && !this._isClearButton(event) && !this.autoOpenDisabled) props.opened = true;
            this.setProperties(props);
        }
        /**
     * Override an event listener from `InputMixin`.
     * @param {!Event} event
     * @protected
     * @override
     */ _onChange(event) {
            // Suppress the native change event fired on the native input.
            // We use `_detectAndDispatchChange` to fire a custom event.
            event.stopPropagation();
        }
        /** @private */ _itemLabelPathChanged(itemLabelPath) {
            if (typeof itemLabelPath !== 'string') console.error('You should set itemLabelPath to a valid string');
        }
        /** @private */ _filterChanged(filter) {
            // Scroll to the top of the list whenever the filter changes.
            this._scrollIntoView(0);
            this._focusedIndex = -1;
            if (this.items) this.filteredItems = this._filterItems(this.items, filter);
            else // With certain use cases (e. g., external filtering), `items` are
            // undefined. Filtering is unnecessary per se, but the filteredItems
            // observer should still be invoked to update focused item.
            this._filteredItemsChanged(this.filteredItems);
        }
        /** @protected */ _revertInputValue() {
            if (this.filter !== '') this._inputElementValue = this.filter;
            else this._revertInputValueToValue();
            this._clearSelectionRange();
        }
        /** @private */ _revertInputValueToValue() {
            if (this.allowCustomValue && !this.selectedItem) this._inputElementValue = this.value;
            else this._inputElementValue = this._getItemLabel(this.selectedItem);
        }
        /** @private */ _selectedItemChanged(selectedItem) {
            if (selectedItem === null || selectedItem === undefined) {
                if (this.filteredItems) {
                    if (!this.allowCustomValue) this.value = '';
                    this._toggleHasValue(this._hasValue);
                    this._inputElementValue = this.value;
                }
            } else {
                const value = this._getItemValue(selectedItem);
                if (this.value !== value) {
                    this.value = value;
                    if (this.value !== value) // The value was changed to something else in value-changed listener,
                    // so prevent from resetting it to the previous value.
                    return;
                }
                this._toggleHasValue(true);
                this._inputElementValue = this._getItemLabel(selectedItem);
            }
            if (this.filteredItems) this._focusedIndex = this.filteredItems.indexOf(selectedItem);
        }
        /**
     * Override an observer from `InputMixin`.
     * @protected
     * @override
     */ _valueChanged(value, oldVal) {
            if (value === '' && oldVal === undefined) // Initializing, no need to do anything
            // See https://github.com/vaadin/vaadin-combo-box/issues/554
            return;
            if ($286e6abade75a309$var$isValidValue(value)) {
                if (this._getItemValue(this.selectedItem) !== value) this._selectItemForValue(value);
                if (!this.selectedItem && this.allowCustomValue) this._inputElementValue = value;
                this._toggleHasValue(this._hasValue);
            } else this.selectedItem = null;
            this.filter = '';
            // In the next _detectAndDispatchChange() call, the change detection should pass
            this._lastCommittedValue = undefined;
        }
        /** @private */ _detectAndDispatchChange() {
            if (this.value !== this._lastCommittedValue) {
                this.dispatchEvent(new CustomEvent('change', {
                    bubbles: true
                }));
                this._lastCommittedValue = this.value;
            }
        }
        /** @private */ _itemsChanged(items, oldItems) {
            this._ensureItemsOrDataProvider(()=>{
                this.items = oldItems;
            });
            if (items) this.filteredItems = items.slice(0);
            else if (oldItems) // Only clear filteredItems if the component had items previously but got cleared
            this.filteredItems = null;
        }
        /** @private */ _filteredItemsChanged(filteredItems, oldFilteredItems) {
            // Store the currently focused item if any. The focused index preserves
            // in the case when more filtered items are loading but it is reset
            // when the user types in a filter query.
            const focusedItem = oldFilteredItems ? oldFilteredItems[this._focusedIndex] : null;
            // Try to sync `selectedItem` based on `value` once a new set of `filteredItems` is available
            // (as a result of external filtering or when they have been loaded by the data provider).
            // When `value` is specified but `selectedItem` is not, it means that there was no item
            // matching `value` at the moment `value` was set, so `selectedItem` has remained unsynced.
            const valueIndex = this.__getItemIndexByValue(filteredItems, this.value);
            if ((this.selectedItem === null || this.selectedItem === undefined) && valueIndex >= 0) this.selectedItem = filteredItems[valueIndex];
            // Try to first set focus on the item that had been focused before `filteredItems` were updated
            // if it is still present in the `filteredItems` array. Otherwise, set the focused index
            // depending on the selected item or the filter query.
            const focusedItemIndex = this.__getItemIndexByValue(filteredItems, this._getItemValue(focusedItem));
            if (focusedItemIndex > -1) this._focusedIndex = focusedItemIndex;
            else this.__setInitialFocusedIndex();
        }
        /** @private */ __setInitialFocusedIndex() {
            const inputValue = this._inputElementValue;
            if (inputValue === undefined || inputValue === this._getItemLabel(this.selectedItem)) // When the input element value is the same as the current value or not defined,
            // set the focused index to the item that matches the value.
            this._focusedIndex = this.__getItemIndexByLabel(this.filteredItems, this._getItemLabel(this.selectedItem));
            else // When the user filled in something that is different from the current value = filtering is enabled,
            // set the focused index to the item that matches the filter query.
            this._focusedIndex = this.__getItemIndexByLabel(this.filteredItems, this.filter);
        }
        /** @private */ _filterItems(arr, filter) {
            if (!arr) return arr;
            const filteredItems = arr.filter((item)=>{
                filter = filter ? filter.toString().toLowerCase() : '';
                // Check if item contains input value.
                return this._getItemLabel(item).toString().toLowerCase().indexOf(filter) > -1;
            });
            return filteredItems;
        }
        /** @private */ _selectItemForValue(value) {
            const valueIndex = this.__getItemIndexByValue(this.filteredItems, value);
            const previouslySelectedItem = this.selectedItem;
            if (valueIndex >= 0) this.selectedItem = this.filteredItems[valueIndex];
            else if (this.dataProvider && this.selectedItem === undefined) this.selectedItem = undefined;
            else this.selectedItem = null;
            if (this.selectedItem === null && previouslySelectedItem === null) this._selectedItemChanged(this.selectedItem);
        }
        /** @private */ _getItemElements() {
            return Array.from(this._scroller.querySelectorAll(`${this._tagNamePrefix}-item`));
        }
        /** @private */ _scrollIntoView(index) {
            if (!this._scroller) return;
            this._scroller.scrollIntoView(index);
        }
        /**
     * Returns the first item that matches the provided value.
     *
     * @private
     */ __getItemIndexByValue(items, value) {
            if (!items || !$286e6abade75a309$var$isValidValue(value)) return -1;
            return $286e6abade75a309$var$findItemIndex(items, (item)=>{
                return this._getItemValue(item) === value;
            });
        }
        /**
     * Returns the first item that matches the provided label.
     * Labels are matched against each other case insensitively.
     *
     * @private
     */ __getItemIndexByLabel(items, label) {
            if (!items || !label) return -1;
            return $286e6abade75a309$var$findItemIndex(items, (item)=>{
                return this._getItemLabel(item).toString().toLowerCase() === label.toString().toLowerCase();
            });
        }
        /** @private */ _overlaySelectedItemChanged(e) {
            // Stop this private event from leaking outside.
            e.stopPropagation();
            if (e.detail.item instanceof (0, $2XUc1.ComboBoxPlaceholder)) // Placeholder items should not be selectable.
            return;
            if (this.opened) {
                this._focusedIndex = this.filteredItems.indexOf(e.detail.item);
                this.close();
            }
        }
        /** @private */ __onClearButtonMouseDown(event) {
            event.preventDefault(); // Prevent native focusout event
            this.inputElement.focus();
        }
        /** @private */ _onFocusout(event) {
            // VoiceOver on iOS fires `focusout` event when moving focus to the item in the dropdown.
            // Do not focus the input in this case, because it would break announcement for the item.
            if (event.relatedTarget && event.relatedTarget.localName === `${this._tagNamePrefix}-item`) return;
            // Fixes the problem with `focusout` happening when clicking on the scroll bar on Edge
            if (event.relatedTarget === this.$.overlay) {
                event.composedPath()[0].focus();
                return;
            }
            if (!this.readonly && !this._closeOnBlurIsPrevented) {
                // User's logic in `custom-value-set` event listener might cause input to blur,
                // which will result in attempting to commit the same custom value once again.
                if (!this.opened && this.allowCustomValue && this._inputElementValue === this._lastCustomValue) {
                    delete this._lastCustomValue;
                    return;
                }
                this._closeOrCommit();
            }
        }
        /** @private */ _onTouchend(event) {
            if (!this.clearElement || event.composedPath()[0] !== this.clearElement) return;
            event.preventDefault();
            this._clear();
        }
    };

});
parcelRegister("gD7RT", function(module, exports) {

$parcel$export(module.exports, "processTemplates", () => $c1b6645843b92b3b$export$7b70192285428d22);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /**
 * Passes the component to the template renderer callback if the template renderer is imported.
 * Otherwise, if there is a template, it warns that the template renderer needs to be imported.
 *
 * @param {HTMLElement} component
 */ function $c1b6645843b92b3b$export$7b70192285428d22(component) {
    if (window.Vaadin && window.Vaadin.templateRendererCallback) {
        window.Vaadin.templateRendererCallback(component);
        return;
    }
    if (component.querySelector('template')) console.warn(`WARNING: <template> inside <${component.localName}> is no longer supported. Import @vaadin/polymer-legacy-adapter/template-renderer.js to enable compatibility.`);
}

});

parcelRegister("6UHjX", function(module, exports) {

$parcel$export(module.exports, "VirtualKeyboardController", () => $508993ac5820729a$export$b3ada0d664bd9329);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ /**
 * A controller which prevents the virtual keyboard from showing up on mobile devices
 * when the field's overlay is closed.
 */ class $508993ac5820729a$export$b3ada0d664bd9329 {
    /**
   * @param {{ inputElement?: HTMLElement; opened: boolean } & HTMLElement} host
   */ constructor(host){
        this.host = host;
        host.addEventListener('opened-changed', ()=>{
            if (!host.opened) // Prevent opening the virtual keyboard when the input gets re-focused on dropdown close
            this.__setVirtualKeyboardEnabled(false);
        });
        // Re-enable virtual keyboard on blur, so it gets opened when the field is focused again
        host.addEventListener('blur', ()=>this.__setVirtualKeyboardEnabled(true));
        // Re-enable the virtual keyboard whenever the field is touched
        host.addEventListener('touchstart', ()=>this.__setVirtualKeyboardEnabled(true));
    }
    /** @private */ __setVirtualKeyboardEnabled(value) {
        if (this.host.inputElement) this.host.inputElement.inputMode = value ? '' : 'none';
    }
}

});



parcelRegister("6eFtW", function(module, exports) {

$parcel$export(module.exports, "announce", () => $48a43a5ab470bc97$export$a9b970dcc4ae71a9);
/**
 * @license
 * Copyright (c) 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $cxRfu = parcelRequire("cxRfu");

var $jlr9D = parcelRequire("jlr9D");
const $48a43a5ab470bc97$var$region = document.createElement('div');
$48a43a5ab470bc97$var$region.style.position = 'fixed';
$48a43a5ab470bc97$var$region.style.clip = 'rect(0px, 0px, 0px, 0px)';
$48a43a5ab470bc97$var$region.setAttribute('aria-live', 'polite');
document.body.appendChild($48a43a5ab470bc97$var$region);
let $48a43a5ab470bc97$var$alertDebouncer;
function $48a43a5ab470bc97$export$a9b970dcc4ae71a9(text, options = {}) {
    const mode = options.mode || 'polite';
    const timeout = options.timeout === undefined ? 150 : options.timeout;
    if (mode === 'alert') {
        $48a43a5ab470bc97$var$region.removeAttribute('aria-live');
        $48a43a5ab470bc97$var$region.removeAttribute('role');
        $48a43a5ab470bc97$var$alertDebouncer = (0, $jlr9D.Debouncer).debounce($48a43a5ab470bc97$var$alertDebouncer, (0, $cxRfu.animationFrame), ()=>{
            $48a43a5ab470bc97$var$region.setAttribute('role', 'alert');
        });
    } else {
        if ($48a43a5ab470bc97$var$alertDebouncer) $48a43a5ab470bc97$var$alertDebouncer.cancel();
        $48a43a5ab470bc97$var$region.removeAttribute('role');
        $48a43a5ab470bc97$var$region.setAttribute('aria-live', mode);
    }
    $48a43a5ab470bc97$var$region.textContent = '';
    setTimeout(()=>{
        $48a43a5ab470bc97$var$region.textContent = text;
    }, timeout);
}

});

parcelRegister("aOqV9", function(module, exports) {

$parcel$export(module.exports, "ResizeMixin", () => $7df374c8da37512d$export$e8f9c767cd5b9ece);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");
const $7df374c8da37512d$var$observer = new ResizeObserver((entries)=>{
    setTimeout(()=>{
        entries.forEach((entry)=>{
            // Notify child resizables, if any
            if (entry.target.resizables) entry.target.resizables.forEach((resizable)=>{
                resizable._onResize(entry.contentRect);
            });
            else entry.target._onResize(entry.contentRect);
        });
    });
});
const $7df374c8da37512d$export$e8f9c767cd5b9ece = (0, $gLdkK.dedupingMixin)((superclass)=>class ResizeMixinClass extends superclass {
        /** @protected */ connectedCallback() {
            super.connectedCallback();
            $7df374c8da37512d$var$observer.observe(this);
            if (this._observeParent) {
                const parent = this.parentNode instanceof ShadowRoot ? this.parentNode.host : this.parentNode;
                if (!parent.resizables) {
                    parent.resizables = new Set();
                    $7df374c8da37512d$var$observer.observe(parent);
                }
                parent.resizables.add(this);
                this.__parent = parent;
            }
        }
        /** @protected */ disconnectedCallback() {
            super.disconnectedCallback();
            $7df374c8da37512d$var$observer.unobserve(this);
            const parent = this.__parent;
            if (this._observeParent && parent) {
                const resizables = parent.resizables;
                if (resizables) {
                    resizables.delete(this);
                    if (resizables.size === 0) $7df374c8da37512d$var$observer.unobserve(parent);
                }
                this.__parent = null;
            }
        }
        /**
       * When true, the parent element resize will be also observed.
       * Override this getter and return `true` to enable this.
       *
       * @protected
       */ get _observeParent() {
            return false;
        }
        /**
       * A handler invoked on host resize. By default, it does nothing.
       * Override the method to implement your own behavior.
       *
       * @protected
       */ _onResize(_contentRect) {
        // To be implemented.
        }
        /**
       * @deprecated Since Vaadin 23, `notifyResize()` is deprecated. The component uses a
       * ResizeObserver internally and doesn't need to be explicitly notified of resizes.
       */ notifyResize() {
            console.warn(`WARNING: Since Vaadin 23, notifyResize() is deprecated. The component uses a ResizeObserver internally and doesn't need to be explicitly notified of resizes.`);
        }
    });

});

parcelRegister("3k8Wo", function(module, exports) {

$parcel$export(module.exports, "InputControlMixin", () => $26ba2cd44e6385bc$export$48943dce8e72dc2b);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $cxRfu = parcelRequire("cxRfu");

var $jlr9D = parcelRequire("jlr9D");

var $j2V0r = parcelRequire("j2V0r");

var $dbTLX = parcelRequire("dbTLX");

var $h6L7N = parcelRequire("h6L7N");

var $bjJLP = parcelRequire("bjJLP");

var $GHWfA = parcelRequire("GHWfA");
const $26ba2cd44e6385bc$export$48943dce8e72dc2b = (superclass)=>class InputControlMixinClass extends (0, $GHWfA.SlotStylesMixin)((0, $dbTLX.DelegateFocusMixin)((0, $bjJLP.InputConstraintsMixin)((0, $h6L7N.FieldMixin)((0, $j2V0r.KeyboardMixin)(superclass))))) {
        static get properties() {
            return {
                /**
         * A pattern matched against individual characters the user inputs.
         *
         * When set, the field will prevent:
         * - `keydown` events if the entered key doesn't match `/^allowedCharPattern$/`
         * - `paste` events if the pasted text doesn't match `/^allowedCharPattern*$/`
         * - `drop` events if the dropped text doesn't match `/^allowedCharPattern*$/`
         *
         * For example, to allow entering only numbers and minus signs, use:
         * `allowedCharPattern = "[\\d-]"`
         * @attr {string} allowed-char-pattern
         */ allowedCharPattern: {
                    type: String,
                    observer: '_allowedCharPatternChanged'
                },
                /**
         * If true, the input text gets fully selected when the field is focused using click or touch / tap.
         */ autoselect: {
                    type: Boolean,
                    value: false
                },
                /**
         * Set to true to display the clear icon which clears the input.
         * @attr {boolean} clear-button-visible
         */ clearButtonVisible: {
                    type: Boolean,
                    reflectToAttribute: true,
                    value: false
                },
                /**
         * The name of this field.
         */ name: {
                    type: String,
                    reflectToAttribute: true
                },
                /**
         * A hint to the user of what can be entered in the field.
         */ placeholder: {
                    type: String,
                    reflectToAttribute: true
                },
                /**
         * When present, it specifies that the field is read-only.
         */ readonly: {
                    type: Boolean,
                    value: false,
                    reflectToAttribute: true
                },
                /**
         * The text usually displayed in a tooltip popup when the mouse is over the field.
         */ title: {
                    type: String,
                    reflectToAttribute: true
                }
            };
        }
        static get delegateAttrs() {
            return [
                ...super.delegateAttrs,
                'name',
                'type',
                'placeholder',
                'readonly',
                'invalid',
                'title'
            ];
        }
        constructor(){
            super();
            this._boundOnPaste = this._onPaste.bind(this);
            this._boundOnDrop = this._onDrop.bind(this);
            this._boundOnBeforeInput = this._onBeforeInput.bind(this);
        }
        /**
     * Any element extending this mixin is required to implement this getter.
     * It returns the reference to the clear button element.
     * @protected
     * @return {Element | null | undefined}
     */ get clearElement() {
            console.warn(`Please implement the 'clearElement' property in <${this.localName}>`);
            return null;
        }
        /** @protected */ get slotStyles() {
            // Needed for Safari, where ::slotted(...)::placeholder does not work
            return [
                `
          :is(input[slot='input'], textarea[slot='textarea'])::placeholder {
            font: inherit;
            color: inherit;
          }
        `
            ];
        }
        /** @protected */ ready() {
            super.ready();
            if (this.clearElement) this.clearElement.addEventListener('click', (e)=>this._onClearButtonClick(e));
        }
        /**
     * @param {Event} event
     * @protected
     */ _onClearButtonClick(event) {
            event.preventDefault();
            this.inputElement.focus();
            this.__clear();
        }
        /**
     * Override an event listener from `DelegateFocusMixin`.
     * @param {FocusEvent} event
     * @protected
     * @override
     */ _onFocus(event) {
            super._onFocus(event);
            if (this.autoselect && this.inputElement) this.inputElement.select();
        }
        /**
     * Override an event listener inherited from `KeydownMixin` to clear on Esc.
     * Components that extend this mixin can prevent this behavior by overriding
     * this method without calling `super._onEscape` to provide custom logic.
     * @param {KeyboardEvent} event
     * @protected
     * @override
     */ _onEscape(event) {
            super._onEscape(event);
            if (this.clearButtonVisible && !!this.value) {
                event.stopPropagation();
                this.__clear();
            }
        }
        /**
     * Override an event listener inherited from `InputMixin`
     * to capture native `change` event and make sure that
     * a new one is dispatched after validation runs.
     * @param {Event} event
     * @protected
     * @override
     */ _onChange(event) {
            event.stopPropagation();
            this.validate();
            this.dispatchEvent(new CustomEvent('change', {
                detail: {
                    sourceEvent: event
                },
                bubbles: event.bubbles,
                cancelable: event.cancelable
            }));
        }
        /** @private */ __clear() {
            this.clear();
            this.inputElement.dispatchEvent(new Event('input', {
                bubbles: true,
                composed: true
            }));
            this.inputElement.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
        /**
     * Override a method from `InputMixin`.
     * @param {!HTMLElement} input
     * @protected
     * @override
     */ _addInputListeners(input) {
            super._addInputListeners(input);
            input.addEventListener('paste', this._boundOnPaste);
            input.addEventListener('drop', this._boundOnDrop);
            input.addEventListener('beforeinput', this._boundOnBeforeInput);
        }
        /**
     * Override a method from `InputMixin`.
     * @param {!HTMLElement} input
     * @protected
     * @override
     */ _removeInputListeners(input) {
            super._removeInputListeners(input);
            input.removeEventListener('paste', this._boundOnPaste);
            input.removeEventListener('drop', this._boundOnDrop);
            input.removeEventListener('beforeinput', this._boundOnBeforeInput);
        }
        /**
     * Override an event listener from `KeyboardMixin`.
     * @param {!KeyboardEvent} event
     * @protected
     * @override
     */ _onKeyDown(event) {
            super._onKeyDown(event);
            if (this.allowedCharPattern && !this.__shouldAcceptKey(event)) {
                event.preventDefault();
                this._markInputPrevented();
            }
        }
        /** @protected */ _markInputPrevented() {
            // Add input-prevented attribute for 200ms
            this.setAttribute('input-prevented', '');
            this._preventInputDebouncer = (0, $jlr9D.Debouncer).debounce(this._preventInputDebouncer, (0, $cxRfu.timeOut).after(200), ()=>{
                this.removeAttribute('input-prevented');
            });
        }
        /** @private */ __shouldAcceptKey(event) {
            return event.metaKey || event.ctrlKey || !event.key || // Allow typing anything if event.key is not supported
            event.key.length !== 1 || // Allow "Backspace", "ArrowLeft" etc.
            this.__allowedCharRegExp.test(event.key);
        }
        /** @private */ _onPaste(e) {
            if (this.allowedCharPattern) {
                const pastedText = e.clipboardData.getData('text');
                if (!this.__allowedTextRegExp.test(pastedText)) {
                    e.preventDefault();
                    this._markInputPrevented();
                }
            }
        }
        /** @private */ _onDrop(e) {
            if (this.allowedCharPattern) {
                const draggedText = e.dataTransfer.getData('text');
                if (!this.__allowedTextRegExp.test(draggedText)) {
                    e.preventDefault();
                    this._markInputPrevented();
                }
            }
        }
        /** @private */ _onBeforeInput(e) {
            // The `beforeinput` event covers all the cases for `allowedCharPattern`: keyboard, pasting and dropping,
            // but it is still experimental technology so we can't rely on it. It's used here just as an additional check,
            // because it seems to be the only way to detect and prevent specific keys on mobile devices.
            // See https://github.com/vaadin/vaadin-text-field/issues/429
            if (this.allowedCharPattern && e.data && !this.__allowedTextRegExp.test(e.data)) {
                e.preventDefault();
                this._markInputPrevented();
            }
        }
        /** @private */ _allowedCharPatternChanged(charPattern) {
            if (charPattern) try {
                this.__allowedCharRegExp = new RegExp(`^${charPattern}$`);
                this.__allowedTextRegExp = new RegExp(`^${charPattern}*$`);
            } catch (e) {
                console.error(e);
            }
        }
    };

});
parcelRegister("bjJLP", function(module, exports) {

$parcel$export(module.exports, "InputConstraintsMixin", () => $83d4f9179b927f82$export$836a8961c2ba9a1a);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");

var $eDhIo = parcelRequire("eDhIo");

var $hGDlz = parcelRequire("hGDlz");

var $19qDG = parcelRequire("19qDG");
const $83d4f9179b927f82$export$836a8961c2ba9a1a = (0, $gLdkK.dedupingMixin)((superclass)=>class InputConstraintsMixinClass extends (0, $eDhIo.DelegateStateMixin)((0, $19qDG.ValidateMixin)((0, $hGDlz.InputMixin)(superclass))) {
        /**
       * An array of attributes which participate in the input validation.
       * Changing these attributes will cause the input to re-validate.
       *
       * IMPORTANT: The attributes should be properly delegated to the input element
       * from the host using `delegateAttrs` getter (see `DelegateStateMixin`).
       * The `required` attribute is already delegated.
       */ static get constraints() {
            return [
                'required'
            ];
        }
        static get delegateAttrs() {
            return [
                ...super.delegateAttrs,
                'required'
            ];
        }
        /** @protected */ ready() {
            super.ready();
            this._createConstraintsObserver();
        }
        /**
       * Returns true if the current input value satisfies all constraints (if any).
       * @return {boolean}
       */ checkValidity() {
            if (this.inputElement && this._hasValidConstraints(this.constructor.constraints.map((c)=>this[c]))) return this.inputElement.checkValidity();
            return !this.invalid;
        }
        /**
       * Returns true if some of the provided set of constraints are valid.
       * @param {Array} constraints
       * @return {boolean}
       * @protected
       */ _hasValidConstraints(constraints) {
            return constraints.some((c)=>this.__isValidConstraint(c));
        }
        /**
       * Override this method to customize setting up constraints observer.
       * @protected
       */ _createConstraintsObserver() {
            // This complex observer needs to be added dynamically instead of using `static get observers()`
            // to make it possible to tweak this behavior in classes that apply this mixin.
            this._createMethodObserver(`_constraintsChanged(stateTarget, ${this.constructor.constraints.join(', ')})`);
        }
        /**
       * Override this method to implement custom validation constraints.
       * @param {HTMLElement | undefined} stateTarget
       * @param {unknown[]} constraints
       * @protected
       */ _constraintsChanged(stateTarget, ...constraints) {
            // The input element's validity cannot be determined until
            // all the necessary constraint attributes aren't set on it.
            if (!stateTarget) return;
            const hasConstraints = this._hasValidConstraints(constraints);
            const isLastConstraintRemoved = this.__previousHasConstraints && !hasConstraints;
            if ((this._hasValue || this.invalid) && hasConstraints) this.validate();
            else if (isLastConstraintRemoved) this._setInvalid(false);
            this.__previousHasConstraints = hasConstraints;
        }
        /**
       * Override an event listener inherited from `InputMixin`
       * to capture native `change` event and make sure that
       * a new one is dispatched after validation runs.
       * @param {Event} event
       * @protected
       * @override
       */ _onChange(event) {
            event.stopPropagation();
            this.validate();
            this.dispatchEvent(new CustomEvent('change', {
                detail: {
                    sourceEvent: event
                },
                bubbles: event.bubbles,
                cancelable: event.cancelable
            }));
        }
        /** @private */ __isValidConstraint(constraint) {
            // 0 is valid for `minlength` and `maxlength`
            return Boolean(constraint) || constraint === 0;
        }
    });

});

parcelRegister("GHWfA", function(module, exports) {

$parcel$export(module.exports, "SlotStylesMixin", () => $080601a22f4c6665$export$f70f6e29ab25a329);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $gLdkK = parcelRequire("gLdkK");
const $080601a22f4c6665$var$stylesMap = new WeakMap();
/**
 * Get all the styles inserted into root.
 * @param {DocumentOrShadowRoot} root
 * @return {Set<string>}
 */ function $080601a22f4c6665$var$getRootStyles(root) {
    if (!$080601a22f4c6665$var$stylesMap.has(root)) $080601a22f4c6665$var$stylesMap.set(root, new Set());
    return $080601a22f4c6665$var$stylesMap.get(root);
}
/**
 * Insert styles into the root.
 * @param {string} styles
 * @param {DocumentOrShadowRoot} root
 */ function $080601a22f4c6665$var$insertStyles(styles, root) {
    const style = document.createElement('style');
    style.textContent = styles;
    if (root === document) document.head.appendChild(style);
    else root.insertBefore(style, root.firstChild);
}
const $080601a22f4c6665$export$f70f6e29ab25a329 = (0, $gLdkK.dedupingMixin)((superclass)=>class SlotStylesMixinClass extends superclass {
        /**
       * List of styles to insert into root.
       * @protected
       */ get slotStyles() {
            return {};
        }
        /** @protected */ connectedCallback() {
            super.connectedCallback();
            this.__applySlotStyles();
        }
        /** @private */ __applySlotStyles() {
            const root = this.getRootNode();
            const rootStyles = $080601a22f4c6665$var$getRootStyles(root);
            this.slotStyles.forEach((styles)=>{
                if (!rootStyles.has(styles)) {
                    $080601a22f4c6665$var$insertStyles(styles, root);
                    rootStyles.add(styles);
                }
            });
        }
    });

});


parcelRegister("aZ57t", function(module, exports) {

$parcel$export(module.exports, "inputFieldShared", () => $7ff392806bed3e25$export$bb4a547bb907939b);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd..
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ 
var $6pmpB = parcelRequire("6pmpB");

var $ddlwn = parcelRequire("ddlwn");

var $fwsFa = parcelRequire("fwsFa");
const $7ff392806bed3e25$export$bb4a547bb907939b = [
    (0, $ddlwn.fieldShared),
    (0, $fwsFa.inputFieldContainer),
    (0, $6pmpB.clearButton)
];

});
parcelRegister("6pmpB", function(module, exports) {

$parcel$export(module.exports, "clearButton", () => $4aa676682debfea5$export$52aab205873de00);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd..
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("eQwuB");
var $aOvNQ = parcelRequire("aOvNQ");
const $4aa676682debfea5$export$52aab205873de00 = (0, $aOvNQ.css)`
  [part='clear-button'] {
    display: none;
    cursor: default;
  }

  [part='clear-button']::before {
    content: '✕';
  }

  :host([clear-button-visible][has-value]:not([disabled]):not([readonly])) [part='clear-button'] {
    display: block;
  }
`;

});

parcelRegister("ddlwn", function(module, exports) {

$parcel$export(module.exports, "fieldShared", () => $99ed2ef06cb80712$export$560439d24e47afce);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd..
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("eQwuB");
var $aOvNQ = parcelRequire("aOvNQ");
const $99ed2ef06cb80712$export$560439d24e47afce = (0, $aOvNQ.css)`
  :host {
    display: inline-flex;
    outline: none;
  }

  :host::before {
    content: '\\2003';
    width: 0;
    display: inline-block;
    /* Size and position this element on the same vertical position as the input-field element
          to make vertical align for the host element work as expected */
  }

  :host([hidden]) {
    display: none !important;
  }

  :host(:not([has-label])) [part='label'] {
    display: none;
  }
`;

});

parcelRegister("fwsFa", function(module, exports) {

$parcel$export(module.exports, "inputFieldContainer", () => $b4d0140978b42898$export$e9969d8fd3e66300);
/**
 * @license
 * Copyright (c) 2021 - 2022 Vaadin Ltd..
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */ parcelRequire("eQwuB");
var $aOvNQ = parcelRequire("aOvNQ");
const $b4d0140978b42898$export$e9969d8fd3e66300 = (0, $aOvNQ.css)`
  [class$='container'] {
    display: flex;
    flex-direction: column;
    min-width: 100%;
    max-width: 100%;
    width: var(--vaadin-field-default-width, 12em);
  }
`;

});





parcelRegister("6LOZI", function(module, exports) {

$parcel$export(module.exports, "comboBoxRenderer", () => $38629a40b9c81c95$export$9196c4ea0e7287aa);

var $4TeKW = parcelRequire("4TeKW");

var $cg87N = parcelRequire("cg87N");
class $38629a40b9c81c95$export$21e1514f460d0baa extends (0, $cg87N.LitRendererDirective) {
    /**
   * Adds the renderer callback to the combo-box.
   */ addRenderer() {
        this.element.renderer = (root, comboBox, model)=>{
            this.renderRenderer(root, model.item, model, comboBox);
        };
    }
    /**
   * Runs the renderer callback on the combo-box.
   */ runRenderer() {
        this.element.requestContentUpdate();
    }
    /**
   * Removes the renderer callback from the combo-box.
   */ removeRenderer() {
        this.element.renderer = null;
    }
}
const $38629a40b9c81c95$export$9196c4ea0e7287aa = (renderer, dependencies = [])=>(0, $4TeKW.directive)($38629a40b9c81c95$export$21e1514f460d0baa)(renderer, dependencies);

});
parcelRegister("cg87N", function(module, exports) {

$parcel$export(module.exports, "LitRendererDirective", () => $4f020a35577a934f$export$98aa82541c213c46);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $4TeKW = parcelRequire("4TeKW");
const $4f020a35577a934f$var$VALUE_NOT_INITIALIZED = Symbol('valueNotInitialized');
class $4f020a35577a934f$export$98aa82541c213c46 extends (0, $4TeKW.AsyncDirective) {
    constructor(part){
        super(part), this.prevValue = $4f020a35577a934f$var$VALUE_NOT_INITIALIZED;
        if (part.type !== (0, $4TeKW.PartType).ELEMENT) throw new Error(`\`${this.constructor.name}\` must be bound to an element.`);
    }
    render(_renderer, _value) {
        return 0, $4TeKW.nothing;
    }
    update(part, [renderer, value]) {
        if (!this.hasChanged(value)) return 0, $4TeKW.nothing;
        this.host = part.options?.host;
        this.element = part['element'];
        this.renderer = renderer;
        const firstRender = this.prevValue === $4f020a35577a934f$var$VALUE_NOT_INITIALIZED;
        if (firstRender) this.addRenderer();
        else this.runRenderer();
        this.prevValue = Array.isArray(value) ? [
            ...value
        ] : value;
        return 0, $4TeKW.nothing;
    }
    reconnected() {
        this.addRenderer();
    }
    disconnected() {
        this.removeRenderer();
    }
    addRenderer() {
        throw new Error('The `addRenderer` method must be implemented.');
    }
    runRenderer() {
        throw new Error('The `runRenderer` method must be implemented.');
    }
    removeRenderer() {
        throw new Error('The `removeRenderer` method must be implemented.');
    }
    renderRenderer(container, ...args) {
        const templateResult = this.renderer.call(this.host, ...args);
        (0, $4TeKW.render)(templateResult, container, {
            host: this.host
        });
    }
    hasChanged(value) {
        if (Array.isArray(value)) {
            if (!Array.isArray(this.prevValue)) return true;
            if (this.prevValue.length !== value.length) return true;
            // For arrays, perform shallow dirty checking for each element.
            return value.some((v, i)=>v !== this.prevValue[i]);
        }
        return this.prevValue !== value;
    }
}

});



parcelRegister("eJjFv", function(module, exports) {

$parcel$export(module.exports, "NotificationIconComponent", () => $9b8acd4ada57f8ed$export$eff7b7b7653455ce);

var $deWeK = parcelRequire("deWeK");

var $ikIwA = parcelRequire("ikIwA");
parcelRequire("cflMN");
var $9mzCZ = parcelRequire("9mzCZ");
var $38rxE = parcelRequire("38rxE");
var $185cP = parcelRequire("185cP");
var $5xHv4 = parcelRequire("5xHv4");
var $htpni = parcelRequire("htpni");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $2d0B8 = parcelRequire("2d0B8");

var $cdTWx = parcelRequire("cdTWx");

var $gawXH = parcelRequire("gawXH");

var $leA2n = parcelRequire("leA2n");
const $9b8acd4ada57f8ed$var$style = (0, $4TeKW.css)`
  .notifications {
    color: white;
    font-weight: 500;
    font-size: 11px;
    padding: 1px 5px 1px 5px;
    border-radius: 5px;
    background: red;
    position: absolute;
    left: 15px;
    top: -5px;
  }
`;
class $9b8acd4ada57f8ed$export$eff7b7b7653455ce extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $9b8acd4ada57f8ed$export$eff7b7b7653455ce.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $ikIwA.NotificationsService))
], $9b8acd4ada57f8ed$export$eff7b7b7653455ce.prototype, "notificationService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $2d0B8.ResponsiveService))
], $9b8acd4ada57f8ed$export$eff7b7b7653455ce.prototype, "responsive", void 0);
$9b8acd4ada57f8ed$export$eff7b7b7653455ce = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'notifications-feed',
        template () {
            return (0, $4TeKW.html)`
      <rx-monad>
        <rx-state
          .value=${(0, $cdTWx.combineLatest)([
                this.notificationService.subscribeToNotifications(),
                this.responsive.width
            ]).pipe((0, $gawXH.map)(([user, width])=>[
                    user,
                    width < 600
                ]))}
        ></rx-state>
        <rx-style .value=${$9b8acd4ada57f8ed$var$style}></rx-style>
        <rx-render
          .state=${([notifications, mobile])=>(0, $4TeKW.html)`
            <dropdown-component
              .border=${true}
              .left=${!!notifications.length}
              .marginLeft=${mobile ? '0px' : '-380px'}
              .menuItems=${[
                    ...notifications.map((n)=>{
                        if ((0, $9mzCZ.isProjectInviteNotification)(n)) return (0, $9mzCZ.InviteNotificationTemplate)(n)([
                            this.notificationService,
                            this.router
                        ]);
                        if ((0, $htpni.isProjectRemoveNotification)(n)) return {
                            read: n.read,
                            html: (0, $4TeKW.html)`
                          <div style="width: 355px">
                            <project-remove-template-notifications
                              @click=${()=>{
                                if (!n.read) this.notificationService.readNotification(n.id).subscribe();
                            }}
                              .notification=${n}
                            ></project-remove-template-notifications>
                          </div>
                        `
                        };
                        if ((0, $5xHv4.isProjectMentionNotification)(n)) return {
                            read: n.read,
                            html: (0, $4TeKW.html)`
                          <div style="width: 355px">
                            <project-card-mention-template
                              @click=${()=>{
                                if (!n.read) this.notificationService.readNotification(n.id).subscribe();
                                const message = n.data.message;
                                this.router.go(`/cards/${message.comment.card.id}`);
                            }}
                              .notification=${n}
                            ></project-card-mention-template>
                          </div>
                        `
                        };
                        if ((0, $38rxE.isMachineStartedNotification)(n)) return {
                            read: n.read,
                            html: (0, $4TeKW.html)`
                          <div style="width: 355px">
                            <machine-started-template-notifications
                              @click=${()=>{
                                if (!n.read) this.notificationService.readNotification(n.id).subscribe();
                            }}
                              .notification=${n}
                            ></machine-started-template-notifications>
                          </div>
                        `
                        };
                        if ((0, $185cP.isMachineStoppedNotification)(n)) return {
                            read: n.read,
                            html: (0, $4TeKW.html)`
                          <div style="width: 355px">
                            <machine-stopped-template-notifications
                              @click=${()=>{
                                if (!n.read) this.notificationService.readNotification(n.id).subscribe();
                            }}
                              .notification=${n}
                            ></machine-stopped-template-notifications>
                          </div>
                        `
                        };
                        return (0, $4TeKW.html)` Unknown template `;
                    }).reverse().slice(0, 7),
                    (0, $4TeKW.html)`
                  <div
                    @click=${()=>this.router.go('/profile/settings/notifications')}
                    style="text-align: center; font-size: 12px;"
                  >
                    view more
                  </div>
                `
                ]}
            >
              <div style="margin-right: 10px;margin-top: 3px;">
                ${0, $leA2n.notification}
                <r-if .exp=${notifications.length > 0}>
                  <span class="notifications">${notifications.filter((n)=>!n.read).length}</span>
                </r-if>
              </div>
            </dropdown-component>
          `}
        ></rx-render>
      </rx-monad>
    `;
        }
    })
], $9b8acd4ada57f8ed$export$eff7b7b7653455ce);

});
parcelRegister("leA2n", function(module, exports) {

$parcel$export(module.exports, "notification", () => $c67970995eadd910$export$2adf6238a2d0dafa);

var $4TeKW = parcelRequire("4TeKW");
const $c67970995eadd910$export$2adf6238a2d0dafa = (0, $4TeKW.html)` <style>
    .notification-icon {
      fill: var(--notification-icon-fill, #44a7ef);
    }
  </style>
  ${(0, $4TeKW.svg)`

 <svg viewBox="0 0 300 300" width="28" height="28" class="notification-icon"><path d="M149.996 0C67.157 0 .001 67.161.001 149.997S67.157 300 149.996 300s150.003-67.163 150.003-150.003S232.835 0 149.996 0zm.003 232.951c-10.766 0-19.499-8.725-19.499-19.499h38.995c.002 10.774-8.73 19.499-19.496 19.499zm65.89-39.051h-.005v-.001c0 7.21-5.843 7.685-13.048 7.685H97.16c-7.208 0-13.046-.475-13.046-7.685v-1.242c0-5.185 3.045-9.625 7.42-11.731l4.142-35.753c0-26.174 18.51-48.02 43.152-53.174v-13.88c0-6.17 5.003-11.173 11.176-11.173 6.17 0 11.173 5.003 11.173 11.173V92c24.642 5.153 43.152 26.997 43.152 53.174l4.142 35.758c4.375 2.109 7.418 6.541 7.418 11.726v1.242z"></path></svg>
 `}`;

});


parcelRegister("K0wwI", function(module, exports) {

$parcel$export(module.exports, "OriginalStyle", () => $39959fd1f9d91c25$export$2b1c5d2c88312762);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $gKTML = parcelRequire("gKTML");
class $39959fd1f9d91c25$export$2b1c5d2c88312762 extends HTMLElement {
}
$39959fd1f9d91c25$export$2b1c5d2c88312762 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'original-style-graphql',
        style: $gKTML.style
    })
], $39959fd1f9d91c25$export$2b1c5d2c88312762);

});
parcelRegister("gKTML", function(module, exports) {

$parcel$export(module.exports, "style", () => $f437ac727aed382a$export$1d567c320f4763bc);

var $4TeKW = parcelRequire("4TeKW");
const $f437ac727aed382a$export$1d567c320f4763bc = (0, $4TeKW.css)`
  .filename {
    background: #151515;
    color: #fff;
    padding: 12px 30px;
    margin: 35px 0 -35px;
    display: block;
    min-height: 25px;
    position: relative;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
    font-size: 15px;
  }
  .filename + pre[class*='language-'],
  .hide + pre[class*='language-'],
  .filename + div + pre[class*='language-'],
  .hide + div + pre[class*='language-'] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  code {
    font-family: Inconsolata, Consolas, 'Courier New', monospace;
    padding: 2px 6px;
    color: #2876d2;
    border-radius: 4px;
    font-size: 15px;
    white-space: pre-wrap;
    background: #f0f2f3;
  }
  pre {
    box-shadow: 0 5px 55px rgba(162, 162, 162, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }
  code[class*='language-'],
  pre[class*='language-'] {
    letter-spacing: normal;
    color: #1c1f24;
    background: none;
    font-family: Inconsolata, Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 25px;
    font-size: 16px;
    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;
    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }
  @media print {
    code[class*='language-'],
    pre[class*='language-'] {
      text-shadow: none;
    }
  }
  pre[class*='language-'],
  :not(pre) > code[class*='language-'] {
    background: #f5f5f5;
    border-radius: 6px;
  }
  /* Code blocks */
  pre[class*='language-'] {
    padding: 0 30px 26px;
    margin: 35px 0;
    overflow: auto;
    border: 0;
  }
  /* Inline code */
  :not(pre) > code[class*='language-'] {
    padding: 0.15em 0.2em 0.05em;
    border-radius: 0.3em;
    border: 0.13em solid #7a6652;
    white-space: normal;
  }
  .token.comment,
  .token.prolog,
  .token.doctype,
  .token.cdata {
    color: #7a8186;
  }
  .token.punctuation {
    opacity: 0.7;
  }
  .namespace {
    opacity: 0.7;
  }
  .token.property,
  .token.tag,
  .token.boolean,
  .token.number,
  .token.constant,
  .token.symbol {
    color: #ffc093;
  }
  .language-html .tag {
    color: #93d7f1;
  }
  .language-html .punctuation {
    color: white;
  }
  .token.selector,
  .token.attr-name,
  .token.string,
  .token.char,
  .token.builtin,
  .token.inserted {
    color: #3594e2;
  }
  .token.entity,
  .token.url,
  .language-css .token.string,
  .style .token.string,
  .token.variable {
    color: #caffa8;
  }
  .token.function,
  .token.operator {
    color: #36a3b9;
  }
  .token.atrule,
  .token.attr-value,
  .token.keyword {
    color: #b32f82;
  }
  .token.regex,
  .token.important {
    color: #e90;
  }
  .token.important,
  .token.bold {
    font-weight: bold;
  }
  .token.italic {
    font-style: italic;
  }
  .token.entity {
    cursor: help;
  }
  .token.deleted {
    color: red;
  }
  div.prism-show-language {
    position: relative;
  }
  div.prism-show-language > div.prism-show-language-label {
    display: none;
  }
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .transition {
    -webkit-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 200ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-fast {
    -webkit-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 100ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  .transition-slow {
    -webkit-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -moz-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -ms-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    -o-transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
    transition: all 520ms cubic-bezier(0.7, 0, 0.3, 1);
  }
  /* CLEARFIX */
  .clearfix {
    *zoom: 1;
  }
  .clearfix:before,
  .clearfix:after {
    content: ' ';
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .center-element {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
  .center-left {
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  .center-top {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .box-sizing {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  html,
  body {
    width: 100%;
  }
  a {
    text-decoration: none;
  }
  *:focus {
    outline: none;
  }
  /* Main Layout */
  .bg {
    background-image: linear-gradient(#1c1f24, #24292f);
  }
  .bg.context {
    background-color: #21262c;
  }
  .version-labels {
    background-color: #6f42be;
  }
  .version-labels.new {
    background-color: #33a743;
  }
  .version-labels.new {
    background-color: #2767d7;
  }
  .version-labels .sha {
    background-color: #554888;
  }
  ul {
    border-left: 1px solid #303539;
    list-style-type: none;
  }
  li {
    padding-bottom: 5px;
    list-style-type: none;
  }
  li p {
    margin: 10px;
  }
  .suggestion-label {
    background-color: #2766d6;
  }
  .flex {
    display: flex;
  }
  .spacer {
    flex: 1 3 auto;
  }
  .pointer {
    cursor: pointer;
  }
  .center {
    text-align: center;
  }
  a {
    text-decoration: none;
    color: #0894e2;
  }
  strong {
    font-weight: 600;
  }
  hr {
    width: 40px;
    height: 4px;
    background: #37a5bc;
    border: 0;
    margin: 50px 0;
  }
  h4 {
    font-size: 20px;
  }
  blockquote {
    line-height: 1.6;
    position: relative;
    margin: 35px 0;
    background: #f9eff1;
    padding: 20px;
  }
  blockquote::before {
    height: 100%;
    width: 5px;
    content: '';
    background: #37a5bc;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
  }
  blockquote strong {
    color: #37a5bc;
  }
  blockquote strong:first-of-type {
    display: block;
    text-transform: uppercase;
    font-size: 15px;
    font-weight: bold;
  }
  blockquote.warning {
    background: #3e3d3a;
  }
  blockquote.warning::before {
    background: #ffb36f;
  }
  blockquote.warning strong,
  blockquote.warning a {
    color: #ed8529;
  }
  blockquote.info {
    background: rgba(8, 148, 226, 0.038);
  }
  blockquote.info::before {
    background: #0894e2;
  }
  blockquote.info strong,
  blockquote.info a {
    color: #0894e2;
  }
  figure {
    margin: 60px 30px;
    text-align: center;
  }
  @media only screen and (max-width: 767px) {
    figure {
      margin: 60px 0;
    }
  }
  figure img {
    max-width: 100%;
    height: auto;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.08);
  }
  figcaption {
    color: rgba(243, 245, 247, 0.9);
    font-size: 16px;
    margin: 20px 0;
  }
  figcaption p {
    font-size: 16px;
  }
  table {
    width: 100%;
    margin: 40px 0;
  }
  @media only screen and (max-width: 767px) {
    tr {
      margin-bottom: 20px;
      display: block;
    }
    tr:last-of-type {
      margin-bottom: 0;
    }
  }
  th {
    padding: 20px;
    background: #efefef;
  }
  tr:nth-of-type(even) td {
    background: #f7f7f7;
  }
  tr:nth-of-type(odd) td:first-of-type {
    border-right: 1px solid #f0f2f3;
  }
  @media only screen and (max-width: 767px) {
    tr:nth-of-type(odd) td:first-of-type {
      border-right: 0;
      border-bottom: 1px solid #f0f2f3;
    }
  }
  tr:nth-of-type(even) td:first-of-type {
    border-right: 1px solid #fff;
  }
  @media only screen and (max-width: 767px) {
    tr:nth-of-type(even) td:first-of-type {
      border-right: 0;
      border-bottom: 1px solid #fff;
    }
  }
  tr td {
    padding: 20px 30px;
    vertical-align: top;
  }
  @media only screen and (max-width: 767px) {
    tr td {
      display: block;
      padding: 20px;
    }
  }
  .file-tree {
    background: #f9f9f9;
    border: 4px solid #f5f5f5;
    margin: 40px 0;
    padding: 16px 32px;
  }
  .file-tree .item {
    display: block;
    line-height: 32px;
    font-size: 15px;
    color: #5a5a5a;
  }
  .file-tree .children {
    padding-left: 30px;
    position: relative;
    overflow: hidden;
  }
  .file-tree .children .item {
    position: relative;
  }
  .file-tree .children .item:before {
    content: '';
    left: -18px;
    bottom: 16px;
    width: 16px;
    height: 9999px;
    position: absolute;
    border-width: 0 0 1px 1px;
    border-style: solid;
    border-color: #dbdbdb;
    border-radius: 0 0 0 3px;
  }
  .external {
    background: #f7f7f7;
  }
  .external::before {
    background: #e8e8e8;
  }
  .ps > .ps__scrollbar-y-rail {
    width: 10px;
  }
  .ps:hover > .ps__scrollbar-y-rail > .ps__scrollbar-y,
  .ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y,
  .ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y {
    width: 6px !important;
    background: #151515;
  }
  .ps > .ps__scrollbar-y-rail > .ps__scrollbar-y {
    border-radius: 0;
    -webkit-border-radius: 0;
  }
  .hide {
    display: none !important;
  }
  /*
   * Container style
   */
  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
  }
  /*
   * Scrollbar rail styles
   */
  .ps__rail-x {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    height: 15px;
    /* there must be 'bottom' or 'top' for ps__rail-x */
    bottom: 0px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__rail-y {
    display: none;
    opacity: 0;
    transition: background-color 0.2s linear, opacity 0.2s linear;
    -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
    width: 15px;
    /* there must be 'right' or 'left' for ps__rail-y */
    right: 0;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps--active-x > .ps__rail-x,
  .ps--active-y > .ps__rail-y {
    display: block;
    background-color: transparent;
  }
  .ps:hover > .ps__rail-x,
  .ps:hover > .ps__rail-y,
  .ps--focus > .ps__rail-x,
  .ps--focus > .ps__rail-y,
  .ps--scrolling-x > .ps__rail-x,
  .ps--scrolling-y > .ps__rail-y {
    opacity: 0.6;
  }
  .ps__rail-x:hover,
  .ps__rail-y:hover,
  .ps__rail-x:focus,
  .ps__rail-y:focus {
    background-color: #eee;
    opacity: 0.9;
  }
  /*
   * Scrollbar thumb styles
   */
  .ps__thumb-x {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, height 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
    height: 6px;
    /* there must be 'bottom' for ps__thumb-x */
    bottom: 2px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__thumb-y {
    background-color: #aaa;
    border-radius: 6px;
    transition: background-color 0.2s linear, width 0.2s ease-in-out;
    -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
    width: 6px;
    /* there must be 'right' for ps__thumb-y */
    right: 2px;
    /* please don't change 'position' */
    position: absolute;
  }
  .ps__rail-x:hover > .ps__thumb-x,
  .ps__rail-x:focus > .ps__thumb-x {
    background-color: #999;
    height: 11px;
  }
  .ps__rail-y:hover > .ps__thumb-y,
  .ps__rail-y:focus > .ps__thumb-y {
    background-color: #999;
    width: 11px;
  }
  /* MS supports */
  @supports (-ms-overflow-style: none) {
    .ps {
      overflow: auto !important;
    }
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .ps {
      overflow: auto !important;
    }
  }
  /*
   TODO: Remove important flags after this bug if fixed:
   https://github.com/angular/flex-layout/issues/381
   */
  perfect-scrollbar {
    position: relative;
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    /* stylelint-disable */
    /* stylelint-enable */
  }
  perfect-scrollbar[hidden] {
    display: none;
  }
  perfect-scrollbar[fxflex] {
    display: flex;
    flex-direction: column;
    -webkit-box-orient: column;
    -webkit-box-direction: column;
    height: auto;
    min-width: 0;
    min-height: 0;
  }
  perfect-scrollbar[fxflex] > .ps {
    flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    -webkit-box-flex: 1;
    width: auto;
    height: auto;
    min-width: 0;
    min-height: 0;
  }
  perfect-scrollbar[fxlayout] > .ps,
  perfect-scrollbar[fxlayout] > .ps > .ps-content {
    display: flex;
    flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    -webkit-box-flex: 1;
    align-item: inherit;
    place-content: inherit;
    -webkit-box-pack: inherit;
    -webkit-box-align: inherit;
    flex-direction: inherit;
    -webkit-box-orient: inherit;
    -webkit-box-direction: inherit;
    width: 100%;
    height: 100%;
  }
  perfect-scrollbar[fxlayout='row'] > .ps,
  perfect-scrollbar[fxlayout='row'] > .ps > .ps-content {
    flex-direction: row !important;
    -webkit-box-orient: row !important;
    -webkit-box-direction: row !important;
  }
  perfect-scrollbar[fxlayout='column'] > .ps,
  perfect-scrollbar[fxlayout='column'] > .ps > .ps-content {
    flex-direction: column !important;
    -webkit-box-orient: column !important;
    -webkit-box-direction: column !important;
  }
  perfect-scrollbar > .ps {
    position: static;
    display: block;
    width: inherit;
    height: inherit;
    max-width: inherit;
    max-height: inherit;
  }
  perfect-scrollbar > .ps > .ps-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    overflow: hidden;
    pointer-events: none;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    position: absolute;
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    left: 0;
    min-width: 100%;
    min-height: 24px;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left,
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right {
    top: 0;
    min-width: 24px;
    min-height: 100%;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-top {
    top: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-left {
    left: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-right {
    right: 0;
  }
  perfect-scrollbar > .ps > .ps-overlay .ps-indicator-bottom {
    bottom: 0;
  }
  perfect-scrollbar > .ps.ps--active-y > .ps__rail-y {
    top: 0 !important;
    right: 0 !important;
    width: 10px;
    cursor: default;
    transition: width 200ms linear, opacity 200ms linear, background-color 200ms linear;
  }
  perfect-scrollbar > .ps.ps--active-y > .ps__rail-y:hover {
    width: 15px;
  }
  perfect-scrollbar > .ps.ps--active-x > .ps__rail-x {
    bottom: 0 !important;
    left: 0 !important;
    height: 10px;
    cursor: default;
    transition: height 200ms linear, opacity 200ms linear, background-color 200ms linear;
  }
  perfect-scrollbar > .ps.ps--active-x > .ps__rail-x:hover {
    height: 15px;
  }
  perfect-scrollbar > .ps.ps--active-x.ps--active-y > .ps__rail-y {
    margin: 0 0 10px;
  }
  perfect-scrollbar > .ps.ps--active-x.ps--active-y > .ps__rail-x {
    margin: 0 10px 0 0;
  }
  perfect-scrollbar > .ps.ps--scrolling-y > .ps__rail-y {
    opacity: 0.9;
    background-color: #eee;
  }
  perfect-scrollbar > .ps.ps--scrolling-x > .ps__rail-x {
    opacity: 0.9;
    background-color: #eee;
  }
  perfect-scrollbar.ps-show-always > .ps.ps--active-y > .ps__rail-y {
    opacity: 0.6;
  }
  perfect-scrollbar.ps-show-always > .ps.ps--active-x > .ps__rail-x {
    opacity: 0.6;
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-y > .ps-overlay:not(.ps-at-top) .ps-indicator-top {
    opacity: 1;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-y > .ps-overlay:not(.ps-at-bottom) .ps-indicator-bottom {
    opacity: 1;
    background: linear-gradient(to top, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-x > .ps-overlay:not(.ps-at-left) .ps-indicator-left {
    opacity: 1;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active > .ps.ps--active-x > .ps-overlay:not(.ps-at-right) .ps-indicator-right {
    opacity: 1;
    background: linear-gradient(to left, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-y > .ps-overlay.ps-at-top .ps-indicator-top {
    background: linear-gradient(to bottom, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-y
    > .ps-overlay.ps-at-top
    .ps-indicator-top.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-y > .ps-overlay.ps-at-bottom .ps-indicator-bottom {
    background: linear-gradient(to top, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-y
    > .ps-overlay.ps-at-bottom
    .ps-indicator-bottom.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-x > .ps-overlay.ps-at-left .ps-indicator-left {
    background: linear-gradient(to right, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-x
    > .ps-overlay.ps-at-left
    .ps-indicator-left.ps-indicator-show {
    opacity: 1;
  }
  perfect-scrollbar.ps-show-active.ps-show-limits > .ps.ps--active-x > .ps-overlay.ps-at-right .ps-indicator-right {
    background: linear-gradient(to left, rgba(170, 170, 170, 0.5) 0%, rgba(170, 170, 170, 0) 100%);
  }
  perfect-scrollbar.ps-show-active.ps-show-limits
    > .ps.ps--active-x
    > .ps-overlay.ps-at-right
    .ps-indicator-right.ps-indicator-show {
    opacity: 1;
  }
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 27px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 6px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 6px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 26px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 45px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(19px, 0);
    }
  }
`;

});


parcelRegister("9580H", function(module, exports) {

$parcel$export(module.exports, "ProfileIconComponent", () => $0fd663b329cbbfa6$export$903af172578d58e1);

var $deWeK = parcelRequire("deWeK");

var $613YX = parcelRequire("613YX");

var $4TeKW = parcelRequire("4TeKW");

const $0fd663b329cbbfa6$var$profilePicture = new URL((parcelRequire("775dD"))).href;
class $0fd663b329cbbfa6$export$903af172578d58e1 extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $0fd663b329cbbfa6$export$903af172578d58e1.prototype, "src", void 0);
$0fd663b329cbbfa6$export$903af172578d58e1 = (0, $deWeK.__decorate)([
    (0, $613YX.Component)({
        Settings: {
            selector: 'profile-icon',
            styles: [
                (0, $4TeKW.css)`
        .image {
          border-radius: 50%;
          width: 30px;
          height: 30px;
          border: 2px solid var(--menu-profile-border-color, #949494);
        }
      `
            ]
        },
        Render: ()=>function() {
                return (0, $4TeKW.html)`
        ${this.src ? (0, $4TeKW.html)`
              <div style="display: flex">
                <div>
                  <span class="flex: 1 3 auto;"></span>
                  <div>
                    <img class="image" src=${this.src} />
                  </div>
                </div>
              </div>
            ` : (0, $4TeKW.html)` <img class="image" src="${$0fd663b329cbbfa6$var$profilePicture}" /> `}
      `;
            }
    })
], $0fd663b329cbbfa6$export$903af172578d58e1);

});

parcelRegister("cYJAl", function(module, exports) {

$parcel$export(module.exports, "RouterLinkComponent", () => $50da566144f0efce$export$587256666be75e12);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");
class $50da566144f0efce$export$587256666be75e12 extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $50da566144f0efce$export$587256666be75e12.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $50da566144f0efce$export$587256666be75e12.prototype, "path", void 0);
$50da566144f0efce$export$587256666be75e12 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'router-link2',
        template () {
            return (0, $4TeKW.html)` <slot @click=${()=>this.path && this.router.go(this.path)}></slot> `;
        }
    })
], $50da566144f0efce$export$587256666be75e12);

});

parcelRegister("biEGl", function(module, exports) {

$parcel$export(module.exports, "SearchComponent", () => $ab761a122394be0e$export$4c7a03676454bcb7);

var $deWeK = parcelRequire("deWeK");

var $facKu = parcelRequire("facKu");

var $4TeKW = parcelRequire("4TeKW");

var $f18Kf = parcelRequire("f18Kf");

var $8iMxq = parcelRequire("8iMxq");

var $7LRrZ = parcelRequire("7LRrZ");
var $dXBar = parcelRequire("dXBar");
var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");
var $9wU3T = parcelRequire("9wU3T");
const $ab761a122394be0e$var$style = (0, $4TeKW.css)`
  ${(0, $f18Kf.InputStyle)}

  .option {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 48px;
    height: 48px;
    padding: 0 16px;
    text-align: left;
    text-decoration: none;
    position: relative;
    cursor: pointer;
    outline: none;
    display: flex;
    flex-direction: row;
    max-width: 100%;
    box-sizing: border-box;
    align-items: center;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  .option:focus {
    background: rgba(0, 0, 0, 0.04);
  }

  .option:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  .panel {
    min-width: 112px;
    max-width: 280px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    visibility: hidden;
    max-width: none;
    max-height: 256px;
    position: relative;
    width: 100%;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);

    position: absolute;
    background: white;
    z-index: 1000;
  }
  .visible {
    visibility: visible;
  }
`;
class $ab761a122394be0e$export$4c7a03676454bcb7 extends (0, $4TeKW.LitElement) {
    constructor(...args){
        super(...args), this.form = new (0, $facKu.FormGroup)({
            text: ''
        }), this.template = ()=>(0, $4TeKW.html)``, this.width = '100%', this.options = {
            includeScore: true,
            keys: []
        }, this.debounce = 300, this.collection = [];
    }
}
(0, $deWeK.__decorate)([
    (0, $facKu.Form)({
        name: 'my-form',
        strategy: 'input'
    })
], $ab761a122394be0e$export$4c7a03676454bcb7.prototype, "form", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $ab761a122394be0e$export$4c7a03676454bcb7.prototype, "template", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $ab761a122394be0e$export$4c7a03676454bcb7.prototype, "width", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $ab761a122394be0e$export$4c7a03676454bcb7.prototype, "options", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $ab761a122394be0e$export$4c7a03676454bcb7.prototype, "debounce", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $ab761a122394be0e$export$4c7a03676454bcb7.prototype, "collection", void 0);
$ab761a122394be0e$export$4c7a03676454bcb7 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'gql-autocomplete',
        style: $ab761a122394be0e$var$style,
        template () {
            return (0, $4TeKW.html)`
      <form name="my-form" novalidate>
        <input name="text" autocomplete="off" class="rx-input" type="text" placeholder="Search" required autofocus />
        <rx-graph
          .options=${{
                style: $ab761a122394be0e$var$style,
                loading: ()=>(0, $4TeKW.html)``,
                state: this.form.valueChanges.pipe((0, $7LRrZ.debounceTime)(this.debounce), (0, $gawXH.map)((values)=>values.text), (0, $dXBar.distinctUntilChanged)(), (0, $6Rz6W.filter)((v)=>v.length > 3), (0, $9wU3T.startWith)(''), (0, $gawXH.map)((detail)=>{
                    return new (0, $8iMxq.default)(this.collection, this.options, (0, $8iMxq.default).createIndex(this.options.keys, this.collection)).search(detail);
                })),
                render: (v)=>(0, $4TeKW.html)`
              <div style=${(0, $4TeKW.styleMap)({
                        width: this.width
                    })} class=${(0, $4TeKW.classMap)({
                        panel: true,
                        visible: v.length
                    })}>
                ${v.map((i)=>(0, $4TeKW.html)`
                    <rx-animation
                      .options=${({ stagger: stagger })=>({
                                delay: stagger(300),
                                translateY: 0,
                                easing: 'spring(0, 30, 10, 0)'
                            })}
                    >
                      <div style="transform: translateY(-100%);" class="option">${this.template(i)}</div>
                    </rx-animation>
                  `)}
              </div>
            `
            }}
        ></rx-graph>
      </form>
    `;
        }
    })
], $ab761a122394be0e$export$4c7a03676454bcb7);

});
parcelRegister("8iMxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $60b5a7d8afe50fca$export$2e2bcd8739ae039);
/**
 * Fuse.js v5.2.3 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2020 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ const $60b5a7d8afe50fca$var$INFINITY = 1 / 0;
const $60b5a7d8afe50fca$var$isArray = (value)=>!Array.isArray ? Object.prototype.toString.call(value) === '[object Array]' : Array.isArray(value);
// Adapted from:
// https://github.com/lodash/lodash/blob/f4ca396a796435422bd4fd41fadbd225edddf175/.internal/baseToString.js
const $60b5a7d8afe50fca$var$baseToString = (value)=>{
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$60b5a7d8afe50fca$var$INFINITY ? '-0' : result;
};
const $60b5a7d8afe50fca$var$toString = (value)=>value == null ? '' : $60b5a7d8afe50fca$var$baseToString(value);
const $60b5a7d8afe50fca$var$isString = (value)=>typeof value === 'string';
const $60b5a7d8afe50fca$var$isNumber = (value)=>typeof value === 'number';
const $60b5a7d8afe50fca$var$isDefined = (value)=>value !== undefined && value !== null;
const $60b5a7d8afe50fca$var$isBlank = (value)=>!value.trim().length;
function $60b5a7d8afe50fca$var$get(obj, path) {
    let list = [];
    let arr = false;
    const _get = (obj, path)=>{
        if (!path) // If there's no path left, we've gotten to the object we care about.
        list.push(obj);
        else {
            const dotIndex = path.indexOf('.');
            let key = path;
            let remaining = null;
            if (dotIndex !== -1) {
                key = path.slice(0, dotIndex);
                remaining = path.slice(dotIndex + 1);
            }
            const value = obj[key];
            if ($60b5a7d8afe50fca$var$isDefined(value)) {
                if (!remaining && ($60b5a7d8afe50fca$var$isString(value) || $60b5a7d8afe50fca$var$isNumber(value))) list.push($60b5a7d8afe50fca$var$toString(value));
                else if ($60b5a7d8afe50fca$var$isArray(value)) {
                    arr = true;
                    // Search each item in the array.
                    for(let i = 0, len = value.length; i < len; i += 1)_get(value[i], remaining);
                } else if (remaining) // An object. Recurse further.
                _get(value, remaining);
            }
        }
    };
    _get(obj, path);
    if (arr) return list;
    return list[0];
}
const $60b5a7d8afe50fca$var$MatchOptions = {
    // Whether the matches should be included in the result set. When true, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When true, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $60b5a7d8afe50fca$var$BasicOptions = {
    // When true, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $60b5a7d8afe50fca$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $60b5a7d8afe50fca$var$AdvancedOptions = {
    // When true, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $60b5a7d8afe50fca$var$get
};
var $60b5a7d8afe50fca$var$Config = {
    ...$60b5a7d8afe50fca$var$BasicOptions,
    ...$60b5a7d8afe50fca$var$MatchOptions,
    ...$60b5a7d8afe50fca$var$FuzzyOptions,
    ...$60b5a7d8afe50fca$var$AdvancedOptions
};
function $60b5a7d8afe50fca$var$computeScore(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $60b5a7d8afe50fca$var$Config.distance } = {}) {
    const accuracy = errors / pattern.length;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $60b5a7d8afe50fca$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $60b5a7d8afe50fca$var$Config.minMatchCharLength) {
    let matchedIndices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) matchedIndices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) matchedIndices.push([
        start,
        i - 1
    ]);
    return matchedIndices;
}
// Machine word size
const $60b5a7d8afe50fca$var$MAX_BITS = 32;
function $60b5a7d8afe50fca$var$search(text, pattern, patternAlphabet, { location: location = $60b5a7d8afe50fca$var$Config.location, distance: distance = $60b5a7d8afe50fca$var$Config.distance, threshold: threshold = $60b5a7d8afe50fca$var$Config.threshold, findAllMatches: findAllMatches = $60b5a7d8afe50fca$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $60b5a7d8afe50fca$var$Config.minMatchCharLength, includeMatches: includeMatches = $60b5a7d8afe50fca$var$Config.includeMatches } = {}) {
    if (pattern.length > $60b5a7d8afe50fca$var$MAX_BITS) throw new Error(`Pattern length exceeds max of ${$60b5a7d8afe50fca$var$MAX_BITS}.`);
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // A mask of the matches, used for building the indices
    const matchMask = [];
    if (includeMatches) for(let i = 0; i < textLen; i += 1)matchMask[i] = 0;
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $60b5a7d8afe50fca$var$computeScore(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (includeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << (patternLen <= $60b5a7d8afe50fca$var$MAX_BITS - 1 ? patternLen - 1 : $60b5a7d8afe50fca$var$MAX_BITS - 2);
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $60b5a7d8afe50fca$var$computeScore(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (charMatch && includeMatches) matchMask[currentLocation] = 1;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i !== 0) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $60b5a7d8afe50fca$var$computeScore(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $60b5a7d8afe50fca$var$computeScore(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    let result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: !finalScore ? 0.001 : finalScore
    };
    if (includeMatches) result.matchedIndices = $60b5a7d8afe50fca$var$convertMaskToIndices(matchMask, minMatchCharLength);
    return result;
}
function $60b5a7d8afe50fca$var$createPatternAlphabet(pattern) {
    let mask = {};
    let len = pattern.length;
    for(let i = 0; i < len; i += 1)mask[pattern.charAt(i)] = 0;
    for(let i = 0; i < len; i += 1)mask[pattern.charAt(i)] |= 1 << len - i - 1;
    return mask;
}
class $60b5a7d8afe50fca$var$BitapSearch {
    constructor(pattern, { location: location = $60b5a7d8afe50fca$var$Config.location, threshold: threshold = $60b5a7d8afe50fca$var$Config.threshold, distance: distance = $60b5a7d8afe50fca$var$Config.distance, includeMatches: includeMatches = $60b5a7d8afe50fca$var$Config.includeMatches, findAllMatches: findAllMatches = $60b5a7d8afe50fca$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $60b5a7d8afe50fca$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $60b5a7d8afe50fca$var$Config.isCaseSensitive } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        let index = 0;
        while(index < this.pattern.length){
            let pattern = this.pattern.substring(index, index + $60b5a7d8afe50fca$var$MAX_BITS);
            this.chunks.push({
                pattern: pattern,
                alphabet: $60b5a7d8afe50fca$var$createPatternAlphabet(pattern)
            });
            index += $60b5a7d8afe50fca$var$MAX_BITS;
        }
    }
    searchIn(value) {
        let text = value.$;
        return this.searchInString(text);
    }
    searchInString(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.matchedIndices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength } = this.options;
        let allMatchedIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        for(let i = 0, len = this.chunks.length; i < len; i += 1){
            let { pattern: pattern, alphabet: alphabet } = this.chunks[i];
            let result = $60b5a7d8afe50fca$var$search(text, pattern, alphabet, {
                location: location + $60b5a7d8afe50fca$var$MAX_BITS * i,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches
            });
            const { isMatch: isMatch, score: score, matchedIndices: matchedIndices } = result;
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && matchedIndices) allMatchedIndices = [
                ...allMatchedIndices,
                ...matchedIndices
            ];
        }
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.matchedIndices = allMatchedIndices;
        return result;
    }
}
class $60b5a7d8afe50fca$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $60b5a7d8afe50fca$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $60b5a7d8afe50fca$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $60b5a7d8afe50fca$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $60b5a7d8afe50fca$var$ExactMatch extends $60b5a7d8afe50fca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const matchedIndices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            matchedIndices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!matchedIndices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 1 : 0,
            matchedIndices: matchedIndices
        };
    }
}
// Token: !fire
class $60b5a7d8afe50fca$var$InverseExactMatch extends $60b5a7d8afe50fca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $60b5a7d8afe50fca$var$PrefixExactMatch extends $60b5a7d8afe50fca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $60b5a7d8afe50fca$var$InversePrefixExactMatch extends $60b5a7d8afe50fca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $60b5a7d8afe50fca$var$SuffixExactMatch extends $60b5a7d8afe50fca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $60b5a7d8afe50fca$var$InverseSuffixExactMatch extends $60b5a7d8afe50fca$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            matchedIndices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $60b5a7d8afe50fca$var$FuzzyMatch extends $60b5a7d8afe50fca$var$BaseMatch {
    constructor(pattern, { location: location = $60b5a7d8afe50fca$var$Config.location, threshold: threshold = $60b5a7d8afe50fca$var$Config.threshold, distance: distance = $60b5a7d8afe50fca$var$Config.distance, includeMatches: includeMatches = $60b5a7d8afe50fca$var$Config.includeMatches, findAllMatches: findAllMatches = $60b5a7d8afe50fca$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $60b5a7d8afe50fca$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $60b5a7d8afe50fca$var$Config.isCaseSensitive } = {}){
        super(pattern);
        this._bitapSearch = new $60b5a7d8afe50fca$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchInString(text);
    }
}
// ❗Order is important. DO NOT CHANGE.
const $60b5a7d8afe50fca$var$searchers = [
    $60b5a7d8afe50fca$var$ExactMatch,
    $60b5a7d8afe50fca$var$PrefixExactMatch,
    $60b5a7d8afe50fca$var$InversePrefixExactMatch,
    $60b5a7d8afe50fca$var$InverseSuffixExactMatch,
    $60b5a7d8afe50fca$var$SuffixExactMatch,
    $60b5a7d8afe50fca$var$InverseExactMatch,
    $60b5a7d8afe50fca$var$FuzzyMatch
];
const $60b5a7d8afe50fca$var$searchersLen = $60b5a7d8afe50fca$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $60b5a7d8afe50fca$var$SPACE_RE = / +(?=([^\"]*\"[^\"]*\")*[^\"]*$)/;
const $60b5a7d8afe50fca$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $60b5a7d8afe50fca$var$parseQuery(pattern, options = {}) {
    return pattern.split($60b5a7d8afe50fca$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($60b5a7d8afe50fca$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $60b5a7d8afe50fca$var$searchersLen){
                const searcher = $60b5a7d8afe50fca$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $60b5a7d8afe50fca$var$searchersLen){
                const searcher = $60b5a7d8afe50fca$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $60b5a7d8afe50fca$var$MultiMatchSet = new Set([
    $60b5a7d8afe50fca$var$FuzzyMatch.type,
    $60b5a7d8afe50fca$var$ExactMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that match `jscript`             |
 * | `'python`   | exact-match                | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $60b5a7d8afe50fca$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $60b5a7d8afe50fca$var$Config.isCaseSensitive, includeMatches: includeMatches = $60b5a7d8afe50fca$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $60b5a7d8afe50fca$var$Config.minMatchCharLength, findAllMatches: findAllMatches = $60b5a7d8afe50fca$var$Config.findAllMatches, location: location = $60b5a7d8afe50fca$var$Config.location, threshold: threshold = $60b5a7d8afe50fca$var$Config.threshold, distance: distance = $60b5a7d8afe50fca$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $60b5a7d8afe50fca$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(value) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        let text = value.$;
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let indices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            indices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, matchedIndices: matchedIndices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($60b5a7d8afe50fca$var$MultiMatchSet.has(type)) indices = [
                            ...indices,
                            ...matchedIndices
                        ];
                        else indices.push(matchedIndices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    indices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.matchedIndices = indices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $60b5a7d8afe50fca$var$SPACE = /[^ ]+/g;
function $60b5a7d8afe50fca$var$createIndex(keys, list, { getFn: getFn = $60b5a7d8afe50fca$var$Config.getFn } = {}) {
    let indexedList = [];
    // List is Array<String>
    if ($60b5a7d8afe50fca$var$isString(list[0])) // Iterate over every string in the list
    for(let i = 0, len = list.length; i < len; i += 1){
        const value = list[i];
        if ($60b5a7d8afe50fca$var$isDefined(value) && !$60b5a7d8afe50fca$var$isBlank(value)) {
            let record = {
                $: value,
                idx: i,
                t: value.match($60b5a7d8afe50fca$var$SPACE).length
            };
            indexedList.push(record);
        }
    }
    else {
        // List is Array<Object>
        const keysLen = keys.length;
        for(let i = 0, len = list.length; i < len; i += 1){
            let item = list[i];
            let record = {
                idx: i,
                $: {}
            };
            // Iterate over every key (i.e, path), and fetch the value at that key
            for(let j = 0; j < keysLen; j += 1){
                let key = keys[j];
                let value = getFn(item, key);
                if (!$60b5a7d8afe50fca$var$isDefined(value)) continue;
                if ($60b5a7d8afe50fca$var$isArray(value)) {
                    let subRecords = [];
                    const stack = [
                        {
                            arrayIndex: -1,
                            value: value
                        }
                    ];
                    while(stack.length){
                        const { arrayIndex: arrayIndex, value: value } = stack.pop();
                        if (!$60b5a7d8afe50fca$var$isDefined(value)) continue;
                        if ($60b5a7d8afe50fca$var$isString(value) && !$60b5a7d8afe50fca$var$isBlank(value)) {
                            let subRecord = {
                                $: value,
                                idx: arrayIndex,
                                t: value.match($60b5a7d8afe50fca$var$SPACE).length
                            };
                            subRecords.push(subRecord);
                        } else if ($60b5a7d8afe50fca$var$isArray(value)) for(let k = 0, arrLen = value.length; k < arrLen; k += 1)stack.push({
                            arrayIndex: k,
                            value: value[k]
                        });
                    }
                    record.$[key] = subRecords;
                } else if (!$60b5a7d8afe50fca$var$isBlank(value)) {
                    let subRecord = {
                        $: value,
                        t: value.match($60b5a7d8afe50fca$var$SPACE).length
                    };
                    record.$[key] = subRecord;
                }
            }
            indexedList.push(record);
        }
    }
    return indexedList;
}
class $60b5a7d8afe50fca$var$KeyStore {
    constructor(keys){
        this._keys = {};
        this._keyNames = [];
        this._length = keys.length;
        // Iterate over every key
        if (keys.length && $60b5a7d8afe50fca$var$isString(keys[0])) for(let i = 0; i < this._length; i += 1){
            const key = keys[i];
            this._keys[key] = {
                weight: 1
            };
            this._keyNames.push(key);
        }
        else {
            let totalWeight = 0;
            for(let i = 0; i < this._length; i += 1){
                const key = keys[i];
                if (!Object.prototype.hasOwnProperty.call(key, 'name')) throw new Error('Missing "name" property in key object');
                const keyName = key.name;
                this._keyNames.push(keyName);
                if (!Object.prototype.hasOwnProperty.call(key, 'weight')) throw new Error('Missing "weight" property in key object');
                const weight = key.weight;
                if (weight <= 0 || weight >= 1) throw new Error('"weight" property in key must be in the range of (0, 1)');
                this._keys[keyName] = {
                    weight: weight
                };
                totalWeight += weight;
            }
            // Normalize weights so that their sum is equal to 1
            for(let i = 0; i < this._length; i += 1){
                const keyName = this._keyNames[i];
                const keyWeight = this._keys[keyName].weight;
                this._keys[keyName].weight = keyWeight / totalWeight;
            }
        }
    }
    get(key, name) {
        return this._keys[key] ? this._keys[key][name] : -1;
    }
    keys() {
        return this._keyNames;
    }
    count() {
        return this._length;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $60b5a7d8afe50fca$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$60b5a7d8afe50fca$var$isDefined(matches)) return;
    for(let i = 0, len = matches.length; i < len; i += 1){
        let match = matches[i];
        if (!$60b5a7d8afe50fca$var$isDefined(match.indices) || match.indices.length === 0) continue;
        let obj = {
            indices: match.indices,
            value: match.value
        };
        if (match.key) obj.key = match.key;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    }
}
function $60b5a7d8afe50fca$var$transformScore(result, data) {
    data.score = result.score;
}
const $60b5a7d8afe50fca$var$registeredSearchers = [];
function $60b5a7d8afe50fca$var$register(...args) {
    $60b5a7d8afe50fca$var$registeredSearchers.push(...args);
}
class $60b5a7d8afe50fca$var$Fuse {
    constructor(list, options = {}, index = null){
        this.options = {
            ...$60b5a7d8afe50fca$var$Config,
            ...options
        };
        this._processKeys(this.options.keys);
        this.setCollection(list, index);
    }
    setCollection(list, index = null) {
        this.list = list;
        this.listIsStringArray = $60b5a7d8afe50fca$var$isString(list[0]);
        if (index) this.setIndex(index);
        else this.setIndex(this._createIndex());
    }
    setIndex(listIndex) {
        this._indexedList = listIndex;
    }
    _processKeys(keys) {
        this._keyStore = new $60b5a7d8afe50fca$var$KeyStore(keys);
    }
    _createIndex() {
        return $60b5a7d8afe50fca$var$createIndex(this._keyStore.keys(), this.list, {
            getFn: this.options.getFn
        });
    }
    search(pattern, opts = {
        limit: false
    }) {
        pattern = pattern.trim();
        if (!pattern.length) return [];
        const { shouldSort: shouldSort } = this.options;
        let searcher = null;
        for(let i = 0, len = $60b5a7d8afe50fca$var$registeredSearchers.length; i < len; i += 1){
            let searcherClass = $60b5a7d8afe50fca$var$registeredSearchers[i];
            if (searcherClass.condition(pattern, this.options)) {
                searcher = new searcherClass(pattern, this.options);
                break;
            }
        }
        if (!searcher) searcher = new $60b5a7d8afe50fca$var$BitapSearch(pattern, this.options);
        let results = this._searchUsing(searcher);
        this._computeScore(results);
        if (shouldSort) this._sort(results);
        if (opts.limit && $60b5a7d8afe50fca$var$isNumber(opts.limit)) results = results.slice(0, opts.limit);
        return this._format(results);
    }
    _searchUsing(searcher) {
        const list = this._indexedList;
        const results = [];
        const { includeMatches: includeMatches } = this.options;
        // List is Array<String>
        if (this.listIsStringArray) // Iterate over every string in the list
        for(let i = 0, len = list.length; i < len; i += 1){
            let value = list[i];
            let { $: text, idx: idx, t: t } = value;
            if (!$60b5a7d8afe50fca$var$isDefined(text)) continue;
            let searchResult = searcher.searchIn(value);
            const { isMatch: isMatch, score: score } = searchResult;
            if (!isMatch) continue;
            let match = {
                score: score,
                value: text,
                t: t
            };
            if (includeMatches) match.indices = searchResult.matchedIndices;
            results.push({
                item: text,
                idx: idx,
                matches: [
                    match
                ]
            });
        }
        else {
            // List is Array<Object>
            const keyNames = this._keyStore.keys();
            const keysLen = this._keyStore.count();
            for(let i = 0, len = list.length; i < len; i += 1){
                let { $: item, idx: idx } = list[i];
                if (!$60b5a7d8afe50fca$var$isDefined(item)) continue;
                let matches = [];
                // Iterate over every key (i.e, path), and fetch the value at that key
                for(let j = 0; j < keysLen; j += 1){
                    let key = keyNames[j];
                    let value = item[key];
                    if (!$60b5a7d8afe50fca$var$isDefined(value)) continue;
                    if ($60b5a7d8afe50fca$var$isArray(value)) for(let k = 0, len = value.length; k < len; k += 1){
                        let arrItem = value[k];
                        const { $: text, idx: idx, t: t } = arrItem;
                        if (!$60b5a7d8afe50fca$var$isDefined(text)) continue;
                        let searchResult = searcher.searchIn(arrItem);
                        const { isMatch: isMatch, score: score } = searchResult;
                        if (!isMatch) continue;
                        let match = {
                            score: score,
                            key: key,
                            value: text,
                            idx: idx,
                            t: t
                        };
                        if (includeMatches) match.indices = searchResult.matchedIndices;
                        matches.push(match);
                    }
                    else {
                        const { $: text, t: t } = value;
                        let searchResult = searcher.searchIn(value);
                        const { isMatch: isMatch, score: score } = searchResult;
                        if (!isMatch) continue;
                        let match = {
                            score: score,
                            key: key,
                            value: text,
                            t: t
                        };
                        if (includeMatches) match.indices = searchResult.matchedIndices;
                        matches.push(match);
                    }
                }
                if (matches.length) results.push({
                    idx: idx,
                    item: item,
                    matches: matches
                });
            }
        }
        return results;
    }
    // Practical scoring function
    _computeScore(results) {
        const resultsLen = results.length;
        for(let i = 0; i < resultsLen; i += 1){
            const result = results[i];
            const matches = result.matches;
            const numMatches = matches.length;
            let totalScore = 1;
            for(let j = 0; j < numMatches; j += 1){
                const match = matches[j];
                const { key: key, t: t } = match;
                const keyWeight = this._keyStore.get(key, 'weight');
                const weight = keyWeight > -1 ? keyWeight : 1;
                const score = match.score === 0 && keyWeight > -1 ? Number.EPSILON : match.score;
                // Field-length norm: the shorter the field, the higher the weight.
                const norm = 1 / Math.sqrt(t);
                totalScore *= Math.pow(score, weight * norm);
            }
            result.score = totalScore;
        }
    }
    _sort(results) {
        results.sort(this.options.sortFn);
    }
    _format(results) {
        const finalOutput = [];
        const { includeMatches: includeMatches, includeScore: includeScore } = this.options;
        let transformers = [];
        if (includeMatches) transformers.push($60b5a7d8afe50fca$var$transformMatches);
        if (includeScore) transformers.push($60b5a7d8afe50fca$var$transformScore);
        for(let i = 0, len = results.length; i < len; i += 1){
            const result = results[i];
            const { idx: idx } = result;
            const data = {
                item: this.list[idx],
                refIndex: idx
            };
            if (transformers.length) for(let j = 0, len = transformers.length; j < len; j += 1)transformers[j](result, data);
            finalOutput.push(data);
        }
        return finalOutput;
    }
}
$60b5a7d8afe50fca$var$register($60b5a7d8afe50fca$var$ExtendedSearch);
$60b5a7d8afe50fca$var$Fuse.version = '5.2.3';
$60b5a7d8afe50fca$var$Fuse.createIndex = $60b5a7d8afe50fca$var$createIndex;
$60b5a7d8afe50fca$var$Fuse.config = $60b5a7d8afe50fca$var$Config;
var $60b5a7d8afe50fca$export$2e2bcd8739ae039 = $60b5a7d8afe50fca$var$Fuse;

});


parcelRegister("4Dlh5", function(module, exports) {

$parcel$export(module.exports, "ShoelaceModule", () => $69c6d7c8bd460e04$export$5c72981948cf123f);

var $deWeK = parcelRequire("deWeK");


var $1t8Wn = parcelRequire("1t8Wn");
parcelRequire("8n1un");
var $bgSaA = parcelRequire("bgSaA");
parcelRequire("kT4IK");
var $lxgjN = parcelRequire("lxgjN");
parcelRequire("1znxk");
var $i7Sym = parcelRequire("i7Sym");
parcelRequire("1vjwo");
var $aMmFT = parcelRequire("aMmFT");
parcelRequire("cb04B");
var $6UXx3 = parcelRequire("6UXx3");
parcelRequire("291bb");
var $kAVxJ = parcelRequire("kAVxJ");
parcelRequire("aZDzm");
var $18J84 = parcelRequire("18J84");
parcelRequire("1TMOi");
var $g7yRi = parcelRequire("g7yRi");
parcelRequire("8KIfg");
var $4dgiN = parcelRequire("4dgiN");
parcelRequire("aD5U1");
var $99gLn = parcelRequire("99gLn");
(0, $99gLn.registerIconLibrary)('default', {
    resolver: (name)=>`https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.0.0/dist/assets/icons/${name}.svg`
});
class $69c6d7c8bd460e04$export$5c72981948cf123f {
}
$69c6d7c8bd460e04$export$5c72981948cf123f = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Module)({
        components: [
            (0, $lxgjN.SlCard),
            (0, $6UXx3.SlIconButton),
            (0, $aMmFT.SlIcon),
            (0, $g7yRi.SlSelect),
            (0, $kAVxJ.SlOption),
            (0, $i7Sym.SlDetails),
            (0, $bgSaA.SlButton),
            (0, $4dgiN.SlSwitch),
            (0, $18J84.SlProgressBar)
        ]
    })
], $69c6d7c8bd460e04$export$5c72981948cf123f);

});
parcelRegister("8n1un", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("bgSaA")).SlButton);

var $bgSaA = parcelRequire("bgSaA");
parcelRequire("k9Ywk");
parcelRequire("fsRoR");
parcelRequire("I1TGB");
parcelRequire("cjg3i");
parcelRequire("9UUPL");
parcelRequire("eIzsp");
parcelRequire("c8fQa");
parcelRequire("aHRmB");
parcelRequire("4Yt64");
parcelRequire("aMmFT");
parcelRequire("99gLn");
parcelRequire("jCb68");
parcelRequire("5xjpF");
parcelRequire("dk295");
parcelRequire("iZtXQ");
parcelRequire("hkKxA");
parcelRequire("6Q7Kl");
parcelRequire("eeMXI");
parcelRequire("gGDeJ");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});
parcelRegister("bgSaA", function(module, exports) {

$parcel$export(module.exports, "SlButton", () => $834b354e491f2405$export$e56d306ebf763f31);

var $I1TGB = parcelRequire("I1TGB");

var $cjg3i = parcelRequire("cjg3i");

var $9UUPL = parcelRequire("9UUPL");

var $eIzsp = parcelRequire("eIzsp");

var $aHRmB = parcelRequire("aHRmB");

var $4Yt64 = parcelRequire("4Yt64");

var $eeMXI = parcelRequire("eeMXI");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $30uP6 = parcelRequire("30uP6");
// src/components/button/button.ts
var $834b354e491f2405$export$e56d306ebf763f31 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $I1TGB.FormControlController)(this, {
            form: (input)=>{
                if (input.hasAttribute("form")) {
                    const doc = input.getRootNode();
                    const formId = input.getAttribute("form");
                    return doc.getElementById(formId);
                }
                return input.closest("form");
            },
            assumeInteractionOn: [
                "click"
            ]
        });
        this.hasSlotController = new (0, $4Yt64.HasSlotController)(this, "[default]", "prefix", "suffix");
        this.localize = new (0, $eIzsp.LocalizeController)(this);
        this.hasFocus = false;
        this.invalid = false;
        this.title = "";
        this.variant = "default";
        this.size = "medium";
        this.caret = false;
        this.disabled = false;
        this.loading = false;
        this.outline = false;
        this.pill = false;
        this.circle = false;
        this.type = "button";
        this.name = "";
        this.value = "";
        this.href = "";
        this.rel = "noreferrer noopener";
    }
    /** Gets the validity state object */ get validity() {
        if (this.isButton()) return this.button.validity;
        return 0, $I1TGB.validValidityState;
    }
    /** Gets the validation message */ get validationMessage() {
        if (this.isButton()) return this.button.validationMessage;
        return "";
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleHostClick = this.handleHostClick.bind(this);
        this.addEventListener("click", this.handleHostClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("click", this.handleHostClick);
    }
    firstUpdated() {
        if (this.isButton()) this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick() {
        if (this.type === "submit") this.formControlController.submit(this);
        if (this.type === "reset") this.formControlController.reset(this);
    }
    handleHostClick(event) {
        if (this.disabled || this.loading) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    isButton() {
        return this.href ? false : true;
    }
    isLink() {
        return this.href ? true : false;
    }
    handleDisabledChange() {
        if (this.isButton()) this.formControlController.setValidity(this.disabled);
    }
    /** Simulates a click on the button. */ click() {
        this.button.click();
    }
    /** Sets focus on the button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the button. */ blur() {
        this.button.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        if (this.isButton()) return this.button.checkValidity();
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        if (this.isButton()) return this.button.reportValidity();
        return true;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        if (this.isButton()) {
            this.button.setCustomValidity(message);
            this.formControlController.updateValidity();
        }
    }
    render() {
        const isLink = this.isLink();
        const tag = isLink ? (0, $9UUPL.i)`a` : (0, $9UUPL.i)`button`;
        return (0, $9UUPL.n)`
      <${tag}
        part="base"
        class=${(0, $gGDeJ.o)({
            button: true,
            "button--default": this.variant === "default",
            "button--primary": this.variant === "primary",
            "button--success": this.variant === "success",
            "button--neutral": this.variant === "neutral",
            "button--warning": this.variant === "warning",
            "button--danger": this.variant === "danger",
            "button--text": this.variant === "text",
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--caret": this.caret,
            "button--circle": this.circle,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--loading": this.loading,
            "button--standard": !this.outline,
            "button--outline": this.outline,
            "button--pill": this.pill,
            "button--rtl": this.localize.dir() === "rtl",
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
        ?disabled=${(0, $aHRmB.l)(isLink ? void 0 : this.disabled)}
        type=${(0, $aHRmB.l)(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${(0, $aHRmB.l)(isLink ? void 0 : this.name)}
        value=${(0, $aHRmB.l)(isLink ? void 0 : this.value)}
        href=${(0, $aHRmB.l)(isLink ? this.href : void 0)}
        target=${(0, $aHRmB.l)(isLink ? this.target : void 0)}
        download=${(0, $aHRmB.l)(isLink ? this.download : void 0)}
        rel=${(0, $aHRmB.l)(isLink ? this.rel : void 0)}
        role=${(0, $aHRmB.l)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? (0, $9UUPL.n)` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? (0, $9UUPL.n)`<sl-spinner></sl-spinner>` : ""}
      </${tag}>
    `;
    }
};
$834b354e491f2405$export$e56d306ebf763f31.styles = (0, $cjg3i.button_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".button")
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "button", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "hasFocus", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "invalid", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "title", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "variant", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "size", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "caret", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "disabled", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "loading", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "outline", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "pill", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "circle", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "type", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "name", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "value", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "href", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "target", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "rel", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "download", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "form", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "formaction"
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "formAction", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "formenctype"
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "formEnctype", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "formmethod"
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "formMethod", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "formnovalidate",
        type: Boolean
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "formNoValidate", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "formtarget"
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "formTarget", 2);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("disabled", {
        waitUntilFirstUpdate: true
    })
], $834b354e491f2405$export$e56d306ebf763f31.prototype, "handleDisabledChange", 1);
$834b354e491f2405$export$e56d306ebf763f31 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-button")
], $834b354e491f2405$export$e56d306ebf763f31);

});
parcelRegister("I1TGB", function(module, exports) {

$parcel$export(module.exports, "FormControlController", () => $084594e99d7332c9$export$43da334182d34ab4);
$parcel$export(module.exports, "validValidityState", () => $084594e99d7332c9$export$6c5960ddf0f5ff89);

var $30uP6 = parcelRequire("30uP6");
// src/internal/form.ts
var $084594e99d7332c9$export$61a522b559454891 = /* @__PURE__ */ new WeakMap();
var $084594e99d7332c9$var$reportValidityOverloads = /* @__PURE__ */ new WeakMap();
var $084594e99d7332c9$var$userInteractedControls = /* @__PURE__ */ new Set();
var $084594e99d7332c9$var$interactions = /* @__PURE__ */ new WeakMap();
var $084594e99d7332c9$export$43da334182d34ab4 = class {
    constructor(host, options){
        (this.host = host).addController(this);
        this.options = (0, $30uP6.__spreadValues)({
            form: (input)=>{
                if (input.hasAttribute("form") && input.getAttribute("form") !== "") {
                    const root = input.getRootNode();
                    const formId = input.getAttribute("form");
                    if (formId) return root.getElementById(formId);
                }
                return input.closest("form");
            },
            name: (input)=>input.name,
            value: (input)=>input.value,
            defaultValue: (input)=>input.defaultValue,
            disabled: (input)=>{
                var _a;
                return (_a = input.disabled) != null ? _a : false;
            },
            reportValidity: (input)=>typeof input.reportValidity === "function" ? input.reportValidity() : true,
            setValue: (input, value)=>input.value = value,
            assumeInteractionOn: [
                "sl-input"
            ]
        }, options);
        this.handleFormData = this.handleFormData.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleFormReset = this.handleFormReset.bind(this);
        this.reportFormValidity = this.reportFormValidity.bind(this);
        this.handleInteraction = this.handleInteraction.bind(this);
    }
    hostConnected() {
        const form = this.options.form(this.host);
        if (form) this.attachForm(form);
        $084594e99d7332c9$var$interactions.set(this.host, []);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.addEventListener(event, this.handleInteraction);
        });
    }
    hostDisconnected() {
        this.detachForm();
        $084594e99d7332c9$var$interactions.delete(this.host);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.removeEventListener(event, this.handleInteraction);
        });
    }
    hostUpdated() {
        const form = this.options.form(this.host);
        if (!form) this.detachForm();
        if (form && this.form !== form) {
            this.detachForm();
            this.attachForm(form);
        }
        if (this.host.hasUpdated) this.setValidity(this.host.validity.valid);
    }
    attachForm(form) {
        if (form) {
            this.form = form;
            if ($084594e99d7332c9$export$61a522b559454891.has(this.form)) $084594e99d7332c9$export$61a522b559454891.get(this.form).add(this.host);
            else $084594e99d7332c9$export$61a522b559454891.set(this.form, /* @__PURE__ */ new Set([
                this.host
            ]));
            this.form.addEventListener("formdata", this.handleFormData);
            this.form.addEventListener("submit", this.handleFormSubmit);
            this.form.addEventListener("reset", this.handleFormReset);
            if (!$084594e99d7332c9$var$reportValidityOverloads.has(this.form)) {
                $084594e99d7332c9$var$reportValidityOverloads.set(this.form, this.form.reportValidity);
                this.form.reportValidity = ()=>this.reportFormValidity();
            }
        } else this.form = void 0;
    }
    detachForm() {
        var _a;
        if (this.form) {
            (_a = $084594e99d7332c9$export$61a522b559454891.get(this.form)) == null || _a.delete(this.host);
            this.form.removeEventListener("formdata", this.handleFormData);
            this.form.removeEventListener("submit", this.handleFormSubmit);
            this.form.removeEventListener("reset", this.handleFormReset);
            if ($084594e99d7332c9$var$reportValidityOverloads.has(this.form)) {
                this.form.reportValidity = $084594e99d7332c9$var$reportValidityOverloads.get(this.form);
                $084594e99d7332c9$var$reportValidityOverloads.delete(this.form);
            }
        }
        this.form = void 0;
    }
    handleFormData(event) {
        const disabled = this.options.disabled(this.host);
        const name = this.options.name(this.host);
        const value = this.options.value(this.host);
        const isButton = this.host.tagName.toLowerCase() === "sl-button";
        if (!disabled && !isButton && typeof name === "string" && name.length > 0 && typeof value !== "undefined") {
            if (Array.isArray(value)) value.forEach((val)=>{
                event.formData.append(name, val.toString());
            });
            else event.formData.append(name, value.toString());
        }
    }
    handleFormSubmit(event) {
        var _a;
        const disabled = this.options.disabled(this.host);
        const reportValidity = this.options.reportValidity;
        if (this.form && !this.form.noValidate) (_a = $084594e99d7332c9$export$61a522b559454891.get(this.form)) == null || _a.forEach((control)=>{
            this.setUserInteracted(control, true);
        });
        if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    handleFormReset() {
        this.options.setValue(this.host, this.options.defaultValue(this.host));
        this.setUserInteracted(this.host, false);
        $084594e99d7332c9$var$interactions.set(this.host, []);
    }
    handleInteraction(event) {
        const emittedEvents = $084594e99d7332c9$var$interactions.get(this.host);
        if (!emittedEvents.includes(event.type)) emittedEvents.push(event.type);
        if (emittedEvents.length === this.options.assumeInteractionOn.length) this.setUserInteracted(this.host, true);
    }
    reportFormValidity() {
        if (this.form && !this.form.noValidate) {
            const elements = this.form.querySelectorAll("*");
            for (const element of elements)if (typeof element.reportValidity === "function") {
                if (!element.reportValidity()) return false;
            }
        }
        return true;
    }
    setUserInteracted(el, hasInteracted) {
        if (hasInteracted) $084594e99d7332c9$var$userInteractedControls.add(el);
        else $084594e99d7332c9$var$userInteractedControls.delete(el);
        el.requestUpdate();
    }
    doAction(type, invoker) {
        if (this.form) {
            const button = document.createElement("button");
            button.type = type;
            button.style.position = "absolute";
            button.style.width = "0";
            button.style.height = "0";
            button.style.clipPath = "inset(50%)";
            button.style.overflow = "hidden";
            button.style.whiteSpace = "nowrap";
            if (invoker) {
                button.name = invoker.name;
                button.value = invoker.value;
                [
                    "formaction",
                    "formenctype",
                    "formmethod",
                    "formnovalidate",
                    "formtarget"
                ].forEach((attr)=>{
                    if (invoker.hasAttribute(attr)) button.setAttribute(attr, invoker.getAttribute(attr));
                });
            }
            this.form.append(button);
            button.click();
            button.remove();
        }
    }
    /** Returns the associated `<form>` element, if one exists. */ getForm() {
        var _a;
        return (_a = this.form) != null ? _a : null;
    }
    /** Resets the form, restoring all the control to their default value */ reset(invoker) {
        this.doAction("reset", invoker);
    }
    /** Submits the form, triggering validation and form data injection. */ submit(invoker) {
        this.doAction("submit", invoker);
    }
    /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */ setValidity(isValid) {
        const host = this.host;
        const hasInteracted = Boolean($084594e99d7332c9$var$userInteractedControls.has(host));
        const required = Boolean(host.required);
        host.toggleAttribute("data-required", required);
        host.toggleAttribute("data-optional", !required);
        host.toggleAttribute("data-invalid", !isValid);
        host.toggleAttribute("data-valid", isValid);
        host.toggleAttribute("data-user-invalid", !isValid && hasInteracted);
        host.toggleAttribute("data-user-valid", isValid && hasInteracted);
    }
    /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */ updateValidity() {
        const host = this.host;
        this.setValidity(host.validity.valid);
    }
    /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */ emitInvalidEvent(originalInvalidEvent) {
        const slInvalidEvent = new CustomEvent("sl-invalid", {
            bubbles: false,
            composed: false,
            cancelable: true,
            detail: {}
        });
        if (!originalInvalidEvent) slInvalidEvent.preventDefault();
        if (!this.host.dispatchEvent(slInvalidEvent)) originalInvalidEvent == null || originalInvalidEvent.preventDefault();
    }
};
var $084594e99d7332c9$export$6c5960ddf0f5ff89 = Object.freeze({
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: true,
    valueMissing: false
});
var $084594e99d7332c9$export$bd584164a4d1886c = Object.freeze((0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, $084594e99d7332c9$export$6c5960ddf0f5ff89), {
    valid: false,
    valueMissing: true
}));
var $084594e99d7332c9$export$d17679f2bc5863d4 = Object.freeze((0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, $084594e99d7332c9$export$6c5960ddf0f5ff89), {
    valid: false,
    customError: true
}));

});
parcelRegister("30uP6", function(module, exports) {

$parcel$export(module.exports, "__spreadValues", () => $23094805371fd985$export$7de063a7aa429f6c);
$parcel$export(module.exports, "__spreadProps", () => $23094805371fd985$export$f4da8f157c1253f7);
$parcel$export(module.exports, "__objRest", () => $23094805371fd985$export$f65b024d04874a6);
$parcel$export(module.exports, "__decorateClass", () => $23094805371fd985$export$85c93885f16e8446);
var $23094805371fd985$var$__defProp = Object.defineProperty;
var $23094805371fd985$var$__defProps = Object.defineProperties;
var $23094805371fd985$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $23094805371fd985$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $23094805371fd985$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $23094805371fd985$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $23094805371fd985$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $23094805371fd985$var$__defNormalProp = (obj, key, value)=>key in obj ? $23094805371fd985$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $23094805371fd985$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($23094805371fd985$var$__hasOwnProp.call(b, prop)) $23094805371fd985$var$__defNormalProp(a, prop, b[prop]);
    if ($23094805371fd985$var$__getOwnPropSymbols) {
        for (var prop of $23094805371fd985$var$__getOwnPropSymbols(b))if ($23094805371fd985$var$__propIsEnum.call(b, prop)) $23094805371fd985$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $23094805371fd985$export$f4da8f157c1253f7 = (a, b)=>$23094805371fd985$var$__defProps(a, $23094805371fd985$var$__getOwnPropDescs(b));
var $23094805371fd985$export$f65b024d04874a6 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($23094805371fd985$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $23094805371fd985$var$__getOwnPropSymbols) {
        for (var prop of $23094805371fd985$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $23094805371fd985$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $23094805371fd985$export$cd3da3bb63c78796 = (target, all)=>{
    for(var name in all)$23094805371fd985$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $23094805371fd985$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $23094805371fd985$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $23094805371fd985$var$__defProp(target, key, result);
    return result;
};

});


parcelRegister("cjg3i", function(module, exports) {

$parcel$export(module.exports, "button_styles_default", () => $8f63b606040f789f$export$172eea9c07ee1ffd);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/button/button.styles.ts
var $8f63b606040f789f$export$172eea9c07ee1ffd = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition: var(--sl-transition-x-fast) background-color, var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border, var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-300);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-color-neutral-300);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    font-size: var(--sl-button-font-size-small);
    height: var(--sl-input-height-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    font-size: var(--sl-button-font-size-medium);
    height: var(--sl-input-height-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    font-size: var(--sl-button-font-size-large);
    height: var(--sl-input-height-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host(.sl-button-group__button--first:not(.sl-button-group__button--last)) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host(.sl-button-group__button--inner) .button {
    border-radius: 0;
  }

  :host(.sl-button-group__button--last:not(.sl-button-group__button--first)) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host(.sl-button-group__button:not(.sl-button-group__button--first)) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      .sl-button-group__button:not(
          .sl-button-group__button--first,
          .sl-button-group__button--radio,
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host(.sl-button-group__button--hover) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host(.sl-button-group__button--focus),
  :host(.sl-button-group__button[checked]) {
    z-index: 2;
  }
`;

});
parcelRegister("hkyWs", function(module, exports) {

$parcel$export(module.exports, "component_styles_default", () => $c9df68a66d98d1ed$export$e1ac0a3ec62d1269);

var $22pPT = parcelRequire("22pPT");
// src/styles/component.styles.ts
var $c9df68a66d98d1ed$export$e1ac0a3ec62d1269 = (0, $22pPT.i)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;

});
parcelRegister("22pPT", function(module, exports) {

$parcel$export(module.exports, "i", () => $17bfcf2c9e79a8af$export$23f2a1d2818174ef);
$parcel$export(module.exports, "n", () => $17bfcf2c9e79a8af$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "y", () => $17bfcf2c9e79a8af$export$4a5767248b18ef41);
$parcel$export(module.exports, "w", () => $17bfcf2c9e79a8af$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $17bfcf2c9e79a8af$export$d141bba7fdc215a3);
$parcel$export(module.exports, "b", () => $17bfcf2c9e79a8af$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "L", () => $17bfcf2c9e79a8af$export$61196ced6d74a310);
$parcel$export(module.exports, "s", () => $17bfcf2c9e79a8af$export$2408f22a0fab9ae5);
// node_modules/@lit/reactive-element/css-tag.js
var $17bfcf2c9e79a8af$var$t = window;
var $17bfcf2c9e79a8af$var$e = $17bfcf2c9e79a8af$var$t.ShadowRoot && (void 0 === $17bfcf2c9e79a8af$var$t.ShadyCSS || $17bfcf2c9e79a8af$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
var $17bfcf2c9e79a8af$var$s = Symbol();
var $17bfcf2c9e79a8af$var$n = /* @__PURE__ */ new WeakMap();
var $17bfcf2c9e79a8af$var$o = class {
    constructor(t3, e4, n5){
        if (this._$cssResult$ = true, n5 !== $17bfcf2c9e79a8af$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t3, this.t = e4;
    }
    get styleSheet() {
        let t3 = this.o;
        const s5 = this.t;
        if ($17bfcf2c9e79a8af$var$e && void 0 === t3) {
            const e4 = void 0 !== s5 && 1 === s5.length;
            e4 && (t3 = $17bfcf2c9e79a8af$var$n.get(s5)), void 0 === t3 && ((this.o = t3 = new CSSStyleSheet()).replaceSync(this.cssText), e4 && $17bfcf2c9e79a8af$var$n.set(s5, t3));
        }
        return t3;
    }
    toString() {
        return this.cssText;
    }
};
var $17bfcf2c9e79a8af$var$r = (t3)=>new $17bfcf2c9e79a8af$var$o("string" == typeof t3 ? t3 : t3 + "", void 0, $17bfcf2c9e79a8af$var$s);
var $17bfcf2c9e79a8af$export$23f2a1d2818174ef = (t3, ...e4)=>{
    const n5 = 1 === t3.length ? t3[0] : e4.reduce((e5, s5, n6)=>e5 + ((t4)=>{
            if (true === t4._$cssResult$) return t4.cssText;
            if ("number" == typeof t4) return t4;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t4 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s5) + t3[n6 + 1], t3[0]);
    return new $17bfcf2c9e79a8af$var$o(n5, t3, $17bfcf2c9e79a8af$var$s);
};
var $17bfcf2c9e79a8af$var$S = (s5, n5)=>{
    $17bfcf2c9e79a8af$var$e ? s5.adoptedStyleSheets = n5.map((t3)=>t3 instanceof CSSStyleSheet ? t3 : t3.styleSheet) : n5.forEach((e4)=>{
        const n6 = document.createElement("style"), o5 = $17bfcf2c9e79a8af$var$t.litNonce;
        void 0 !== o5 && n6.setAttribute("nonce", o5), n6.textContent = e4.cssText, s5.appendChild(n6);
    });
};
var $17bfcf2c9e79a8af$var$c = $17bfcf2c9e79a8af$var$e ? (t3)=>t3 : (t3)=>t3 instanceof CSSStyleSheet ? ((t4)=>{
        let e4 = "";
        for (const s5 of t4.cssRules)e4 += s5.cssText;
        return $17bfcf2c9e79a8af$var$r(e4);
    })(t3) : t3;
// node_modules/@lit/reactive-element/reactive-element.js
var $17bfcf2c9e79a8af$var$s2;
var $17bfcf2c9e79a8af$var$e2 = window;
var $17bfcf2c9e79a8af$var$r2 = $17bfcf2c9e79a8af$var$e2.trustedTypes;
var $17bfcf2c9e79a8af$var$h = $17bfcf2c9e79a8af$var$r2 ? $17bfcf2c9e79a8af$var$r2.emptyScript : "";
var $17bfcf2c9e79a8af$var$o2 = $17bfcf2c9e79a8af$var$e2.reactiveElementPolyfillSupport;
var $17bfcf2c9e79a8af$export$7ccc53e8f1e7dfc5 = {
    toAttribute (t3, i3) {
        switch(i3){
            case Boolean:
                t3 = t3 ? $17bfcf2c9e79a8af$var$h : null;
                break;
            case Object:
            case Array:
                t3 = null == t3 ? t3 : JSON.stringify(t3);
        }
        return t3;
    },
    fromAttribute (t3, i3) {
        let s5 = t3;
        switch(i3){
            case Boolean:
                s5 = null !== t3;
                break;
            case Number:
                s5 = null === t3 ? null : Number(t3);
                break;
            case Object:
            case Array:
                try {
                    s5 = JSON.parse(t3);
                } catch (t4) {
                    s5 = null;
                }
        }
        return s5;
    }
};
var $17bfcf2c9e79a8af$var$a = (t3, i3)=>i3 !== t3 && (i3 == i3 || t3 == t3);
var $17bfcf2c9e79a8af$var$l = {
    attribute: true,
    type: String,
    converter: $17bfcf2c9e79a8af$export$7ccc53e8f1e7dfc5,
    reflect: false,
    hasChanged: $17bfcf2c9e79a8af$var$a
};
var $17bfcf2c9e79a8af$var$d = class extends HTMLElement {
    constructor(){
        super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = false, this.hasUpdated = false, this._$El = null, this.u();
    }
    static addInitializer(t3) {
        var i3;
        this.finalize(), (null !== (i3 = this.h) && void 0 !== i3 ? i3 : this.h = []).push(t3);
    }
    static get observedAttributes() {
        this.finalize();
        const t3 = [];
        return this.elementProperties.forEach((i3, s5)=>{
            const e4 = this._$Ep(s5, i3);
            void 0 !== e4 && (this._$Ev.set(e4, s5), t3.push(e4));
        }), t3;
    }
    static createProperty(t3, i3 = $17bfcf2c9e79a8af$var$l) {
        if (i3.state && (i3.attribute = false), this.finalize(), this.elementProperties.set(t3, i3), !i3.noAccessor && !this.prototype.hasOwnProperty(t3)) {
            const s5 = "symbol" == typeof t3 ? Symbol() : "__" + t3, e4 = this.getPropertyDescriptor(t3, s5, i3);
            void 0 !== e4 && Object.defineProperty(this.prototype, t3, e4);
        }
    }
    static getPropertyDescriptor(t3, i3, s5) {
        return {
            get () {
                return this[i3];
            },
            set (e4) {
                const r4 = this[t3];
                this[i3] = e4, this.requestUpdate(t3, r4, s5);
            },
            configurable: true,
            enumerable: true
        };
    }
    static getPropertyOptions(t3) {
        return this.elementProperties.get(t3) || $17bfcf2c9e79a8af$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return false;
        this.finalized = true;
        const t3 = Object.getPrototypeOf(this);
        if (t3.finalize(), void 0 !== t3.h && (this.h = [
            ...t3.h
        ]), this.elementProperties = new Map(t3.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
            const t4 = this.properties, i3 = [
                ...Object.getOwnPropertyNames(t4),
                ...Object.getOwnPropertySymbols(t4)
            ];
            for (const s5 of i3)this.createProperty(s5, t4[s5]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), true;
    }
    static finalizeStyles(i3) {
        const s5 = [];
        if (Array.isArray(i3)) {
            const e4 = new Set(i3.flat(1 / 0).reverse());
            for (const i4 of e4)s5.unshift($17bfcf2c9e79a8af$var$c(i4));
        } else void 0 !== i3 && s5.push($17bfcf2c9e79a8af$var$c(i3));
        return s5;
    }
    static _$Ep(t3, i3) {
        const s5 = i3.attribute;
        return false === s5 ? void 0 : "string" == typeof s5 ? s5 : "string" == typeof t3 ? t3.toLowerCase() : void 0;
    }
    u() {
        var t3;
        this._$E_ = new Promise((t4)=>this.enableUpdating = t4), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), null === (t3 = this.constructor.h) || void 0 === t3 || t3.forEach((t4)=>t4(this));
    }
    addController(t3) {
        var i3, s5;
        (null !== (i3 = this._$ES) && void 0 !== i3 ? i3 : this._$ES = []).push(t3), void 0 !== this.renderRoot && this.isConnected && (null === (s5 = t3.hostConnected) || void 0 === s5 || s5.call(t3));
    }
    removeController(t3) {
        var i3;
        null === (i3 = this._$ES) || void 0 === i3 || i3.splice(this._$ES.indexOf(t3) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t3, i3)=>{
            this.hasOwnProperty(i3) && (this._$Ei.set(i3, this[i3]), delete this[i3]);
        });
    }
    createRenderRoot() {
        var t3;
        const s5 = null !== (t3 = this.shadowRoot) && void 0 !== t3 ? t3 : this.attachShadow(this.constructor.shadowRootOptions);
        return $17bfcf2c9e79a8af$var$S(s5, this.constructor.elementStyles), s5;
    }
    connectedCallback() {
        var t3;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(true), null === (t3 = this._$ES) || void 0 === t3 || t3.forEach((t4)=>{
            var i3;
            return null === (i3 = t4.hostConnected) || void 0 === i3 ? void 0 : i3.call(t4);
        });
    }
    enableUpdating(t3) {}
    disconnectedCallback() {
        var t3;
        null === (t3 = this._$ES) || void 0 === t3 || t3.forEach((t4)=>{
            var i3;
            return null === (i3 = t4.hostDisconnected) || void 0 === i3 ? void 0 : i3.call(t4);
        });
    }
    attributeChangedCallback(t3, i3, s5) {
        this._$AK(t3, s5);
    }
    _$EO(t3, i3, s5 = $17bfcf2c9e79a8af$var$l) {
        var e4;
        const r4 = this.constructor._$Ep(t3, s5);
        if (void 0 !== r4 && true === s5.reflect) {
            const h3 = (void 0 !== (null === (e4 = s5.converter) || void 0 === e4 ? void 0 : e4.toAttribute) ? s5.converter : $17bfcf2c9e79a8af$export$7ccc53e8f1e7dfc5).toAttribute(i3, s5.type);
            this._$El = t3, null == h3 ? this.removeAttribute(r4) : this.setAttribute(r4, h3), this._$El = null;
        }
    }
    _$AK(t3, i3) {
        var s5;
        const e4 = this.constructor, r4 = e4._$Ev.get(t3);
        if (void 0 !== r4 && this._$El !== r4) {
            const t4 = e4.getPropertyOptions(r4), h3 = "function" == typeof t4.converter ? {
                fromAttribute: t4.converter
            } : void 0 !== (null === (s5 = t4.converter) || void 0 === s5 ? void 0 : s5.fromAttribute) ? t4.converter : $17bfcf2c9e79a8af$export$7ccc53e8f1e7dfc5;
            this._$El = r4, this[r4] = h3.fromAttribute(i3, t4.type), this._$El = null;
        }
    }
    requestUpdate(t3, i3, s5) {
        let e4 = true;
        void 0 !== t3 && (((s5 = s5 || this.constructor.getPropertyOptions(t3)).hasChanged || $17bfcf2c9e79a8af$var$a)(this[t3], i3) ? (this._$AL.has(t3) || this._$AL.set(t3, i3), true === s5.reflect && this._$El !== t3 && (void 0 === this._$EC && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(t3, s5))) : e4 = false), !this.isUpdatePending && e4 && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = true;
        try {
            await this._$E_;
        } catch (t4) {
            Promise.reject(t4);
        }
        const t3 = this.scheduleUpdate();
        return null != t3 && await t3, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t3;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t4, i4)=>this[i4] = t4), this._$Ei = void 0);
        let i3 = false;
        const s5 = this._$AL;
        try {
            i3 = this.shouldUpdate(s5), i3 ? (this.willUpdate(s5), null === (t3 = this._$ES) || void 0 === t3 || t3.forEach((t4)=>{
                var i4;
                return null === (i4 = t4.hostUpdate) || void 0 === i4 ? void 0 : i4.call(t4);
            }), this.update(s5)) : this._$Ek();
        } catch (t4) {
            throw i3 = false, this._$Ek(), t4;
        }
        i3 && this._$AE(s5);
    }
    willUpdate(t3) {}
    _$AE(t3) {
        var i3;
        null === (i3 = this._$ES) || void 0 === i3 || i3.forEach((t4)=>{
            var i4;
            return null === (i4 = t4.hostUpdated) || void 0 === i4 ? void 0 : i4.call(t4);
        }), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t3)), this.updated(t3);
    }
    _$Ek() {
        this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t3) {
        return true;
    }
    update(t3) {
        void 0 !== this._$EC && (this._$EC.forEach((t4, i3)=>this._$EO(i3, this[i3], t4)), this._$EC = void 0), this._$Ek();
    }
    updated(t3) {}
    firstUpdated(t3) {}
};
$17bfcf2c9e79a8af$var$d.finalized = true, $17bfcf2c9e79a8af$var$d.elementProperties = /* @__PURE__ */ new Map(), $17bfcf2c9e79a8af$var$d.elementStyles = [], $17bfcf2c9e79a8af$var$d.shadowRootOptions = {
    mode: "open"
}, null == $17bfcf2c9e79a8af$var$o2 || $17bfcf2c9e79a8af$var$o2({
    ReactiveElement: $17bfcf2c9e79a8af$var$d
}), (null !== ($17bfcf2c9e79a8af$var$s2 = $17bfcf2c9e79a8af$var$e2.reactiveElementVersions) && void 0 !== $17bfcf2c9e79a8af$var$s2 ? $17bfcf2c9e79a8af$var$s2 : $17bfcf2c9e79a8af$var$e2.reactiveElementVersions = []).push("1.6.1");
// node_modules/lit-html/lit-html.js
var $17bfcf2c9e79a8af$var$t2;
var $17bfcf2c9e79a8af$var$i2 = window;
var $17bfcf2c9e79a8af$var$s3 = $17bfcf2c9e79a8af$var$i2.trustedTypes;
var $17bfcf2c9e79a8af$var$e3 = $17bfcf2c9e79a8af$var$s3 ? $17bfcf2c9e79a8af$var$s3.createPolicy("lit-html", {
    createHTML: (t3)=>t3
}) : void 0;
var $17bfcf2c9e79a8af$var$o3 = `lit$${(Math.random() + "").slice(9)}$`;
var $17bfcf2c9e79a8af$var$n3 = "?" + $17bfcf2c9e79a8af$var$o3;
var $17bfcf2c9e79a8af$var$l2 = `<${$17bfcf2c9e79a8af$var$n3}>`;
var $17bfcf2c9e79a8af$var$h2 = document;
var $17bfcf2c9e79a8af$var$r3 = (t3 = "")=>$17bfcf2c9e79a8af$var$h2.createComment(t3);
var $17bfcf2c9e79a8af$var$d2 = (t3)=>null === t3 || "object" != typeof t3 && "function" != typeof t3;
var $17bfcf2c9e79a8af$var$u = Array.isArray;
var $17bfcf2c9e79a8af$var$c2 = (t3)=>$17bfcf2c9e79a8af$var$u(t3) || "function" == typeof (null == t3 ? void 0 : t3[Symbol.iterator]);
var $17bfcf2c9e79a8af$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g;
var $17bfcf2c9e79a8af$var$a2 = /-->/g;
var $17bfcf2c9e79a8af$var$f = />/g;
var $17bfcf2c9e79a8af$var$_ = RegExp(`>|[ 	
\f\r](?:([^\\s"'>=/]+)([ 	
\f\r]*=[ 	
\f\r]*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g");
var $17bfcf2c9e79a8af$var$m = /'/g;
var $17bfcf2c9e79a8af$var$p = /"/g;
var $17bfcf2c9e79a8af$var$$ = /^(?:script|style|textarea|title)$/i;
var $17bfcf2c9e79a8af$var$g = (t3)=>(i3, ...s5)=>({
            _$litType$: t3,
            strings: i3,
            values: s5
        });
var $17bfcf2c9e79a8af$export$4a5767248b18ef41 = $17bfcf2c9e79a8af$var$g(1);
var $17bfcf2c9e79a8af$export$efccba1c4a2ef57b = $17bfcf2c9e79a8af$var$g(2);
var $17bfcf2c9e79a8af$export$d141bba7fdc215a3 = Symbol.for("lit-noChange");
var $17bfcf2c9e79a8af$export$8b22cf2602fb60ce = Symbol.for("lit-nothing");
var $17bfcf2c9e79a8af$var$T = /* @__PURE__ */ new WeakMap();
var $17bfcf2c9e79a8af$var$A = $17bfcf2c9e79a8af$var$h2.createTreeWalker($17bfcf2c9e79a8af$var$h2, 129, null, false);
var $17bfcf2c9e79a8af$var$E = (t3, i3)=>{
    const s5 = t3.length - 1, n5 = [];
    let h3, r4 = 2 === i3 ? "<svg>" : "", d3 = $17bfcf2c9e79a8af$var$v;
    for(let i4 = 0; i4 < s5; i4++){
        const s6 = t3[i4];
        let e4, u3, c3 = -1, g2 = 0;
        for(; g2 < s6.length && (d3.lastIndex = g2, u3 = d3.exec(s6), null !== u3);)g2 = d3.lastIndex, d3 === $17bfcf2c9e79a8af$var$v ? "!--" === u3[1] ? d3 = $17bfcf2c9e79a8af$var$a2 : void 0 !== u3[1] ? d3 = $17bfcf2c9e79a8af$var$f : void 0 !== u3[2] ? ($17bfcf2c9e79a8af$var$$.test(u3[2]) && (h3 = RegExp("</" + u3[2], "g")), d3 = $17bfcf2c9e79a8af$var$_) : void 0 !== u3[3] && (d3 = $17bfcf2c9e79a8af$var$_) : d3 === $17bfcf2c9e79a8af$var$_ ? ">" === u3[0] ? (d3 = null != h3 ? h3 : $17bfcf2c9e79a8af$var$v, c3 = -1) : void 0 === u3[1] ? c3 = -2 : (c3 = d3.lastIndex - u3[2].length, e4 = u3[1], d3 = void 0 === u3[3] ? $17bfcf2c9e79a8af$var$_ : '"' === u3[3] ? $17bfcf2c9e79a8af$var$p : $17bfcf2c9e79a8af$var$m) : d3 === $17bfcf2c9e79a8af$var$p || d3 === $17bfcf2c9e79a8af$var$m ? d3 = $17bfcf2c9e79a8af$var$_ : d3 === $17bfcf2c9e79a8af$var$a2 || d3 === $17bfcf2c9e79a8af$var$f ? d3 = $17bfcf2c9e79a8af$var$v : (d3 = $17bfcf2c9e79a8af$var$_, h3 = void 0);
        const y2 = d3 === $17bfcf2c9e79a8af$var$_ && t3[i4 + 1].startsWith("/>") ? " " : "";
        r4 += d3 === $17bfcf2c9e79a8af$var$v ? s6 + $17bfcf2c9e79a8af$var$l2 : c3 >= 0 ? (n5.push(e4), s6.slice(0, c3) + "$lit$" + s6.slice(c3) + $17bfcf2c9e79a8af$var$o3 + y2) : s6 + $17bfcf2c9e79a8af$var$o3 + (-2 === c3 ? (n5.push(void 0), i4) : y2);
    }
    const u2 = r4 + (t3[s5] || "<?>") + (2 === i3 ? "</svg>" : "");
    if (!Array.isArray(t3) || !t3.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== $17bfcf2c9e79a8af$var$e3 ? $17bfcf2c9e79a8af$var$e3.createHTML(u2) : u2,
        n5
    ];
};
var $17bfcf2c9e79a8af$var$C = class {
    constructor({ strings: t3, _$litType$: i3 }, e4){
        let l4;
        this.parts = [];
        let h3 = 0, d3 = 0;
        const u2 = t3.length - 1, c3 = this.parts, [v2, a3] = $17bfcf2c9e79a8af$var$E(t3, i3);
        if (this.el = $17bfcf2c9e79a8af$var$C.createElement(v2, e4), $17bfcf2c9e79a8af$var$A.currentNode = this.el.content, 2 === i3) {
            const t4 = this.el.content, i4 = t4.firstChild;
            i4.remove(), t4.append(...i4.childNodes);
        }
        for(; null !== (l4 = $17bfcf2c9e79a8af$var$A.nextNode()) && c3.length < u2;){
            if (1 === l4.nodeType) {
                if (l4.hasAttributes()) {
                    const t4 = [];
                    for (const i4 of l4.getAttributeNames())if (i4.endsWith("$lit$") || i4.startsWith($17bfcf2c9e79a8af$var$o3)) {
                        const s5 = a3[d3++];
                        if (t4.push(i4), void 0 !== s5) {
                            const t5 = l4.getAttribute(s5.toLowerCase() + "$lit$").split($17bfcf2c9e79a8af$var$o3), i5 = /([.?@])?(.*)/.exec(s5);
                            c3.push({
                                type: 1,
                                index: h3,
                                name: i5[2],
                                strings: t5,
                                ctor: "." === i5[1] ? $17bfcf2c9e79a8af$var$M : "?" === i5[1] ? $17bfcf2c9e79a8af$var$k : "@" === i5[1] ? $17bfcf2c9e79a8af$var$H : $17bfcf2c9e79a8af$var$S2
                            });
                        } else c3.push({
                            type: 6,
                            index: h3
                        });
                    }
                    for (const i4 of t4)l4.removeAttribute(i4);
                }
                if ($17bfcf2c9e79a8af$var$$.test(l4.tagName)) {
                    const t4 = l4.textContent.split($17bfcf2c9e79a8af$var$o3), i4 = t4.length - 1;
                    if (i4 > 0) {
                        l4.textContent = $17bfcf2c9e79a8af$var$s3 ? $17bfcf2c9e79a8af$var$s3.emptyScript : "";
                        for(let s5 = 0; s5 < i4; s5++)l4.append(t4[s5], $17bfcf2c9e79a8af$var$r3()), $17bfcf2c9e79a8af$var$A.nextNode(), c3.push({
                            type: 2,
                            index: ++h3
                        });
                        l4.append(t4[i4], $17bfcf2c9e79a8af$var$r3());
                    }
                }
            } else if (8 === l4.nodeType) {
                if (l4.data === $17bfcf2c9e79a8af$var$n3) c3.push({
                    type: 2,
                    index: h3
                });
                else {
                    let t4 = -1;
                    for(; -1 !== (t4 = l4.data.indexOf($17bfcf2c9e79a8af$var$o3, t4 + 1));)c3.push({
                        type: 7,
                        index: h3
                    }), t4 += $17bfcf2c9e79a8af$var$o3.length - 1;
                }
            }
            h3++;
        }
    }
    static createElement(t3, i3) {
        const s5 = $17bfcf2c9e79a8af$var$h2.createElement("template");
        return s5.innerHTML = t3, s5;
    }
};
function $17bfcf2c9e79a8af$var$P(t3, i3, s5 = t3, e4) {
    var o5, n5, l4, h3;
    if (i3 === $17bfcf2c9e79a8af$export$d141bba7fdc215a3) return i3;
    let r4 = void 0 !== e4 ? null === (o5 = s5._$Co) || void 0 === o5 ? void 0 : o5[e4] : s5._$Cl;
    const u2 = $17bfcf2c9e79a8af$var$d2(i3) ? void 0 : i3._$litDirective$;
    return (null == r4 ? void 0 : r4.constructor) !== u2 && (null === (n5 = null == r4 ? void 0 : r4._$AO) || void 0 === n5 || n5.call(r4, false), void 0 === u2 ? r4 = void 0 : (r4 = new u2(t3), r4._$AT(t3, s5, e4)), void 0 !== e4 ? (null !== (l4 = (h3 = s5)._$Co) && void 0 !== l4 ? l4 : h3._$Co = [])[e4] = r4 : s5._$Cl = r4), void 0 !== r4 && (i3 = $17bfcf2c9e79a8af$var$P(t3, r4._$AS(t3, i3.values), r4, e4)), i3;
}
var $17bfcf2c9e79a8af$var$V = class {
    constructor(t3, i3){
        this.u = [], this._$AN = void 0, this._$AD = t3, this._$AM = i3;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    v(t3) {
        var i3;
        const { el: { content: s5 }, parts: e4 } = this._$AD, o5 = (null !== (i3 = null == t3 ? void 0 : t3.creationScope) && void 0 !== i3 ? i3 : $17bfcf2c9e79a8af$var$h2).importNode(s5, true);
        $17bfcf2c9e79a8af$var$A.currentNode = o5;
        let n5 = $17bfcf2c9e79a8af$var$A.nextNode(), l4 = 0, r4 = 0, d3 = e4[0];
        for(; void 0 !== d3;){
            if (l4 === d3.index) {
                let i4;
                2 === d3.type ? i4 = new $17bfcf2c9e79a8af$var$N(n5, n5.nextSibling, this, t3) : 1 === d3.type ? i4 = new d3.ctor(n5, d3.name, d3.strings, this, t3) : 6 === d3.type && (i4 = new $17bfcf2c9e79a8af$var$I(n5, this, t3)), this.u.push(i4), d3 = e4[++r4];
            }
            l4 !== (null == d3 ? void 0 : d3.index) && (n5 = $17bfcf2c9e79a8af$var$A.nextNode(), l4++);
        }
        return o5;
    }
    p(t3) {
        let i3 = 0;
        for (const s5 of this.u)void 0 !== s5 && (void 0 !== s5.strings ? (s5._$AI(t3, s5, i3), i3 += s5.strings.length - 2) : s5._$AI(t3[i3])), i3++;
    }
};
var $17bfcf2c9e79a8af$var$N = class {
    constructor(t3, i3, s5, e4){
        var o5;
        this.type = 2, this._$AH = $17bfcf2c9e79a8af$export$8b22cf2602fb60ce, this._$AN = void 0, this._$AA = t3, this._$AB = i3, this._$AM = s5, this.options = e4, this._$Cm = null === (o5 = null == e4 ? void 0 : e4.isConnected) || void 0 === o5 || o5;
    }
    get _$AU() {
        var t3, i3;
        return null !== (i3 = null === (t3 = this._$AM) || void 0 === t3 ? void 0 : t3._$AU) && void 0 !== i3 ? i3 : this._$Cm;
    }
    get parentNode() {
        let t3 = this._$AA.parentNode;
        const i3 = this._$AM;
        return void 0 !== i3 && 11 === t3.nodeType && (t3 = i3.parentNode), t3;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t3, i3 = this) {
        t3 = $17bfcf2c9e79a8af$var$P(this, t3, i3), $17bfcf2c9e79a8af$var$d2(t3) ? t3 === $17bfcf2c9e79a8af$export$8b22cf2602fb60ce || null == t3 || "" === t3 ? (this._$AH !== $17bfcf2c9e79a8af$export$8b22cf2602fb60ce && this._$AR(), this._$AH = $17bfcf2c9e79a8af$export$8b22cf2602fb60ce) : t3 !== this._$AH && t3 !== $17bfcf2c9e79a8af$export$d141bba7fdc215a3 && this.g(t3) : void 0 !== t3._$litType$ ? this.$(t3) : void 0 !== t3.nodeType ? this.T(t3) : $17bfcf2c9e79a8af$var$c2(t3) ? this.k(t3) : this.g(t3);
    }
    O(t3, i3 = this._$AB) {
        return this._$AA.parentNode.insertBefore(t3, i3);
    }
    T(t3) {
        this._$AH !== t3 && (this._$AR(), this._$AH = this.O(t3));
    }
    g(t3) {
        this._$AH !== $17bfcf2c9e79a8af$export$8b22cf2602fb60ce && $17bfcf2c9e79a8af$var$d2(this._$AH) ? this._$AA.nextSibling.data = t3 : this.T($17bfcf2c9e79a8af$var$h2.createTextNode(t3)), this._$AH = t3;
    }
    $(t3) {
        var i3;
        const { values: s5, _$litType$: e4 } = t3, o5 = "number" == typeof e4 ? this._$AC(t3) : (void 0 === e4.el && (e4.el = $17bfcf2c9e79a8af$var$C.createElement(e4.h, this.options)), e4);
        if ((null === (i3 = this._$AH) || void 0 === i3 ? void 0 : i3._$AD) === o5) this._$AH.p(s5);
        else {
            const t4 = new $17bfcf2c9e79a8af$var$V(o5, this), i4 = t4.v(this.options);
            t4.p(s5), this.T(i4), this._$AH = t4;
        }
    }
    _$AC(t3) {
        let i3 = $17bfcf2c9e79a8af$var$T.get(t3.strings);
        return void 0 === i3 && $17bfcf2c9e79a8af$var$T.set(t3.strings, i3 = new $17bfcf2c9e79a8af$var$C(t3)), i3;
    }
    k(t3) {
        $17bfcf2c9e79a8af$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i3 = this._$AH;
        let s5, e4 = 0;
        for (const o5 of t3)e4 === i3.length ? i3.push(s5 = new $17bfcf2c9e79a8af$var$N(this.O($17bfcf2c9e79a8af$var$r3()), this.O($17bfcf2c9e79a8af$var$r3()), this, this.options)) : s5 = i3[e4], s5._$AI(o5), e4++;
        e4 < i3.length && (this._$AR(s5 && s5._$AB.nextSibling, e4), i3.length = e4);
    }
    _$AR(t3 = this._$AA.nextSibling, i3) {
        var s5;
        for(null === (s5 = this._$AP) || void 0 === s5 || s5.call(this, false, true, i3); t3 && t3 !== this._$AB;){
            const i4 = t3.nextSibling;
            t3.remove(), t3 = i4;
        }
    }
    setConnected(t3) {
        var i3;
        void 0 === this._$AM && (this._$Cm = t3, null === (i3 = this._$AP) || void 0 === i3 || i3.call(this, t3));
    }
};
var $17bfcf2c9e79a8af$var$S2 = class {
    constructor(t3, i3, s5, e4, o5){
        this.type = 1, this._$AH = $17bfcf2c9e79a8af$export$8b22cf2602fb60ce, this._$AN = void 0, this.element = t3, this.name = i3, this._$AM = e4, this.options = o5, s5.length > 2 || "" !== s5[0] || "" !== s5[1] ? (this._$AH = Array(s5.length - 1).fill(new String()), this.strings = s5) : this._$AH = $17bfcf2c9e79a8af$export$8b22cf2602fb60ce;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t3, i3 = this, s5, e4) {
        const o5 = this.strings;
        let n5 = false;
        if (void 0 === o5) t3 = $17bfcf2c9e79a8af$var$P(this, t3, i3, 0), n5 = !$17bfcf2c9e79a8af$var$d2(t3) || t3 !== this._$AH && t3 !== $17bfcf2c9e79a8af$export$d141bba7fdc215a3, n5 && (this._$AH = t3);
        else {
            const e5 = t3;
            let l4, h3;
            for(t3 = o5[0], l4 = 0; l4 < o5.length - 1; l4++)h3 = $17bfcf2c9e79a8af$var$P(this, e5[s5 + l4], i3, l4), h3 === $17bfcf2c9e79a8af$export$d141bba7fdc215a3 && (h3 = this._$AH[l4]), n5 || (n5 = !$17bfcf2c9e79a8af$var$d2(h3) || h3 !== this._$AH[l4]), h3 === $17bfcf2c9e79a8af$export$8b22cf2602fb60ce ? t3 = $17bfcf2c9e79a8af$export$8b22cf2602fb60ce : t3 !== $17bfcf2c9e79a8af$export$8b22cf2602fb60ce && (t3 += (null != h3 ? h3 : "") + o5[l4 + 1]), this._$AH[l4] = h3;
        }
        n5 && !e4 && this.j(t3);
    }
    j(t3) {
        t3 === $17bfcf2c9e79a8af$export$8b22cf2602fb60ce ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t3 ? t3 : "");
    }
};
var $17bfcf2c9e79a8af$var$M = class extends $17bfcf2c9e79a8af$var$S2 {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t3) {
        this.element[this.name] = t3 === $17bfcf2c9e79a8af$export$8b22cf2602fb60ce ? void 0 : t3;
    }
};
var $17bfcf2c9e79a8af$var$R = $17bfcf2c9e79a8af$var$s3 ? $17bfcf2c9e79a8af$var$s3.emptyScript : "";
var $17bfcf2c9e79a8af$var$k = class extends $17bfcf2c9e79a8af$var$S2 {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t3) {
        t3 && t3 !== $17bfcf2c9e79a8af$export$8b22cf2602fb60ce ? this.element.setAttribute(this.name, $17bfcf2c9e79a8af$var$R) : this.element.removeAttribute(this.name);
    }
};
var $17bfcf2c9e79a8af$var$H = class extends $17bfcf2c9e79a8af$var$S2 {
    constructor(t3, i3, s5, e4, o5){
        super(t3, i3, s5, e4, o5), this.type = 5;
    }
    _$AI(t3, i3 = this) {
        var s5;
        if ((t3 = null !== (s5 = $17bfcf2c9e79a8af$var$P(this, t3, i3, 0)) && void 0 !== s5 ? s5 : $17bfcf2c9e79a8af$export$8b22cf2602fb60ce) === $17bfcf2c9e79a8af$export$d141bba7fdc215a3) return;
        const e4 = this._$AH, o5 = t3 === $17bfcf2c9e79a8af$export$8b22cf2602fb60ce && e4 !== $17bfcf2c9e79a8af$export$8b22cf2602fb60ce || t3.capture !== e4.capture || t3.once !== e4.once || t3.passive !== e4.passive, n5 = t3 !== $17bfcf2c9e79a8af$export$8b22cf2602fb60ce && (e4 === $17bfcf2c9e79a8af$export$8b22cf2602fb60ce || o5);
        o5 && this.element.removeEventListener(this.name, this, e4), n5 && this.element.addEventListener(this.name, this, t3), this._$AH = t3;
    }
    handleEvent(t3) {
        var i3, s5;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s5 = null === (i3 = this.options) || void 0 === i3 ? void 0 : i3.host) && void 0 !== s5 ? s5 : this.element, t3) : this._$AH.handleEvent(t3);
    }
};
var $17bfcf2c9e79a8af$var$I = class {
    constructor(t3, i3, s5){
        this.element = t3, this.type = 6, this._$AN = void 0, this._$AM = i3, this.options = s5;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t3) {
        $17bfcf2c9e79a8af$var$P(this, t3);
    }
};
var $17bfcf2c9e79a8af$export$61196ced6d74a310 = {
    P: "$lit$",
    A: $17bfcf2c9e79a8af$var$o3,
    M: $17bfcf2c9e79a8af$var$n3,
    C: 1,
    L: $17bfcf2c9e79a8af$var$E,
    R: $17bfcf2c9e79a8af$var$V,
    D: $17bfcf2c9e79a8af$var$c2,
    V: $17bfcf2c9e79a8af$var$P,
    I: $17bfcf2c9e79a8af$var$N,
    H: $17bfcf2c9e79a8af$var$S2,
    N: $17bfcf2c9e79a8af$var$k,
    U: $17bfcf2c9e79a8af$var$H,
    B: $17bfcf2c9e79a8af$var$M,
    F: $17bfcf2c9e79a8af$var$I
};
var $17bfcf2c9e79a8af$var$z = $17bfcf2c9e79a8af$var$i2.litHtmlPolyfillSupport;
null == $17bfcf2c9e79a8af$var$z || $17bfcf2c9e79a8af$var$z($17bfcf2c9e79a8af$var$C, $17bfcf2c9e79a8af$var$N), (null !== ($17bfcf2c9e79a8af$var$t2 = $17bfcf2c9e79a8af$var$i2.litHtmlVersions) && void 0 !== $17bfcf2c9e79a8af$var$t2 ? $17bfcf2c9e79a8af$var$t2 : $17bfcf2c9e79a8af$var$i2.litHtmlVersions = []).push("2.6.1");
var $17bfcf2c9e79a8af$var$Z = (t3, i3, s5)=>{
    var e4, o5;
    const n5 = null !== (e4 = null == s5 ? void 0 : s5.renderBefore) && void 0 !== e4 ? e4 : i3;
    let l4 = n5._$litPart$;
    if (void 0 === l4) {
        const t4 = null !== (o5 = null == s5 ? void 0 : s5.renderBefore) && void 0 !== o5 ? o5 : null;
        n5._$litPart$ = l4 = new $17bfcf2c9e79a8af$var$N(i3.insertBefore($17bfcf2c9e79a8af$var$r3(), t4), t4, void 0, null != s5 ? s5 : {});
    }
    return l4._$AI(t3), l4;
};
// node_modules/lit-element/lit-element.js
var $17bfcf2c9e79a8af$var$l3;
var $17bfcf2c9e79a8af$var$o4;
var $17bfcf2c9e79a8af$export$2408f22a0fab9ae5 = class extends $17bfcf2c9e79a8af$var$d {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Dt = void 0;
    }
    createRenderRoot() {
        var t3, e4;
        const i3 = super.createRenderRoot();
        return null !== (t3 = (e4 = this.renderOptions).renderBefore) && void 0 !== t3 || (e4.renderBefore = i3.firstChild), i3;
    }
    update(t3) {
        const i3 = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t3), this._$Dt = $17bfcf2c9e79a8af$var$Z(i3, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t3;
        super.connectedCallback(), null === (t3 = this._$Dt) || void 0 === t3 || t3.setConnected(true);
    }
    disconnectedCallback() {
        var t3;
        super.disconnectedCallback(), null === (t3 = this._$Dt) || void 0 === t3 || t3.setConnected(false);
    }
    render() {
        return $17bfcf2c9e79a8af$export$d141bba7fdc215a3;
    }
};
$17bfcf2c9e79a8af$export$2408f22a0fab9ae5.finalized = true, $17bfcf2c9e79a8af$export$2408f22a0fab9ae5._$litElement$ = true, null === ($17bfcf2c9e79a8af$var$l3 = globalThis.litElementHydrateSupport) || void 0 === $17bfcf2c9e79a8af$var$l3 || $17bfcf2c9e79a8af$var$l3.call(globalThis, {
    LitElement: $17bfcf2c9e79a8af$export$2408f22a0fab9ae5
});
var $17bfcf2c9e79a8af$var$n4 = globalThis.litElementPolyfillSupport;
null == $17bfcf2c9e79a8af$var$n4 || $17bfcf2c9e79a8af$var$n4({
    LitElement: $17bfcf2c9e79a8af$export$2408f22a0fab9ae5
});
(null !== ($17bfcf2c9e79a8af$var$o4 = globalThis.litElementVersions) && void 0 !== $17bfcf2c9e79a8af$var$o4 ? $17bfcf2c9e79a8af$var$o4 : globalThis.litElementVersions = []).push("3.2.0");
 /*! Bundled license information:

@lit/reactive-element/css-tag.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/reactive-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/lit-html.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-element/lit-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/is-server.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});



parcelRegister("9UUPL", function(module, exports) {

$parcel$export(module.exports, "i", () => $73856e0bbe479fd5$export$23f2a1d2818174ef);
$parcel$export(module.exports, "n", () => $73856e0bbe479fd5$export$7ccc53e8f1e7dfc5);

var $22pPT = parcelRequire("22pPT");
// node_modules/lit-html/static.js
var $73856e0bbe479fd5$var$e = Symbol.for("");
var $73856e0bbe479fd5$var$l = (t)=>{
    if ((null == t ? void 0 : t.r) === $73856e0bbe479fd5$var$e) return null == t ? void 0 : t._$litStatic$;
};
var $73856e0bbe479fd5$export$23f2a1d2818174ef = (t, ...r)=>({
        _$litStatic$: r.reduce((r2, e2, l2)=>r2 + ((t2)=>{
                if (void 0 !== t2._$litStatic$) return t2._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t2}. Use 'unsafeStatic' to pass non-literal values, but
            take care to ensure page security.`);
            })(e2) + t[l2 + 1], t[0]),
        r: $73856e0bbe479fd5$var$e
    });
var $73856e0bbe479fd5$var$s = /* @__PURE__ */ new Map();
var $73856e0bbe479fd5$var$a = (t)=>(r, ...e2)=>{
        const o = e2.length;
        let i2, a2;
        const n2 = [], u2 = [];
        let c, $ = 0, f = false;
        for(; $ < o;){
            for(c = r[$]; $ < o && void 0 !== (a2 = e2[$], i2 = $73856e0bbe479fd5$var$l(a2));)c += i2 + r[++$], f = true;
            u2.push(a2), n2.push(c), $++;
        }
        if ($ === o && n2.push(r[o]), f) {
            const t2 = n2.join("$$lit$$");
            void 0 === (r = $73856e0bbe479fd5$var$s.get(t2)) && (n2.raw = n2, $73856e0bbe479fd5$var$s.set(t2, r = n2)), e2 = u2;
        }
        return t(r, ...e2);
    };
var $73856e0bbe479fd5$export$7ccc53e8f1e7dfc5 = $73856e0bbe479fd5$var$a((0, $22pPT.y));
var $73856e0bbe479fd5$var$u = $73856e0bbe479fd5$var$a((0, $22pPT.w));
 /*! Bundled license information:

lit-html/static.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});

parcelRegister("eIzsp", function(module, exports) {

$parcel$export(module.exports, "LocalizeController", () => $ab70adcbdcb847e9$export$b1a2fed5bb41b893);

var $c8fQa = parcelRequire("c8fQa");
// src/utilities/localize.ts
var $ab70adcbdcb847e9$export$b1a2fed5bb41b893 = class extends (0, $c8fQa.LocalizeController) {
};
// src/translations/en.ts
var $ab70adcbdcb847e9$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    clearEntry: "Clear entry",
    close: "Close",
    copy: "Copy",
    currentValue: "Current value",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    toggleColorFormat: "Toggle color format"
};
(0, $c8fQa.registerTranslation)($ab70adcbdcb847e9$var$translation);
var $ab70adcbdcb847e9$export$802b895dc4aecf21 = $ab70adcbdcb847e9$var$translation;

});
parcelRegister("c8fQa", function(module, exports) {

$parcel$export(module.exports, "registerTranslation", () => $8d5284f09f7432be$export$2332cb3ce32cc839);
$parcel$export(module.exports, "LocalizeController", () => $8d5284f09f7432be$export$b1a2fed5bb41b893);
// node_modules/@shoelace-style/localize/dist/index.js
var $8d5284f09f7432be$var$connectedElements = /* @__PURE__ */ new Set();
var $8d5284f09f7432be$var$documentElementObserver = new MutationObserver($8d5284f09f7432be$var$update);
var $8d5284f09f7432be$var$translations = /* @__PURE__ */ new Map();
var $8d5284f09f7432be$var$documentDirection = document.documentElement.dir || "ltr";
var $8d5284f09f7432be$var$documentLanguage = document.documentElement.lang || navigator.language;
var $8d5284f09f7432be$var$fallback;
$8d5284f09f7432be$var$documentElementObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [
        "dir",
        "lang"
    ]
});
function $8d5284f09f7432be$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($8d5284f09f7432be$var$translations.has(code)) $8d5284f09f7432be$var$translations.set(code, Object.assign(Object.assign({}, $8d5284f09f7432be$var$translations.get(code)), t));
        else $8d5284f09f7432be$var$translations.set(code, t);
        if (!$8d5284f09f7432be$var$fallback) $8d5284f09f7432be$var$fallback = t;
    });
    $8d5284f09f7432be$var$update();
}
function $8d5284f09f7432be$var$update() {
    $8d5284f09f7432be$var$documentDirection = document.documentElement.dir || "ltr";
    $8d5284f09f7432be$var$documentLanguage = document.documentElement.lang || navigator.language;
    [
        ...$8d5284f09f7432be$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === "function") el.requestUpdate();
    });
}
var $8d5284f09f7432be$export$b1a2fed5bb41b893 = class {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $8d5284f09f7432be$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $8d5284f09f7432be$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $8d5284f09f7432be$var$documentDirection}`.toLowerCase();
    }
    lang() {
        return `${this.host.lang || $8d5284f09f7432be$var$documentLanguage}`.toLowerCase();
    }
    getTranslationData(lang) {
        var _a, _b;
        const locale = new Intl.Locale(lang);
        const language = locale === null || locale === void 0 ? void 0 : locale.language.toLowerCase();
        const region = (_b = (_a = locale === null || locale === void 0 ? void 0 : locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
        const primary = $8d5284f09f7432be$var$translations.get(`${language}-${region}`);
        const secondary = $8d5284f09f7432be$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $8d5284f09f7432be$var$fallback && $8d5284f09f7432be$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($8d5284f09f7432be$var$fallback && $8d5284f09f7432be$var$fallback[key]) term = $8d5284f09f7432be$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === "function") return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? "" : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
};

});


parcelRegister("aHRmB", function(module, exports) {

$parcel$export(module.exports, "l", () => $7cb7506fa5ab701b$export$882b5998b3b9117c);

var $22pPT = parcelRequire("22pPT");
// node_modules/lit-html/directives/if-defined.js
var $7cb7506fa5ab701b$export$882b5998b3b9117c = (l2)=>null != l2 ? l2 : (0, $22pPT.b);
 /*! Bundled license information:

lit-html/directives/if-defined.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});

parcelRegister("4Yt64", function(module, exports) {

$parcel$export(module.exports, "HasSlotController", () => $39f3561463d19df3$export$34f6a5ffaa663541);
// src/internal/slot.ts
var $39f3561463d19df3$export$34f6a5ffaa663541 = class {
    constructor(host, ...slotNames){
        this.slotNames = [];
        (this.host = host).addController(this);
        this.slotNames = slotNames;
        this.handleSlotChange = this.handleSlotChange.bind(this);
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") return true;
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                const tagName = el.tagName.toLowerCase();
                if (tagName === "sl-visually-hidden") return false;
                if (!el.hasAttribute("slot")) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    test(slotName) {
        return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    }
    handleSlotChange(event) {
        const slot = event.target;
        if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
    }
};
function $39f3561463d19df3$export$132e79e4118a78e0(slot) {
    if (!slot) return "";
    const nodes = slot.assignedNodes({
        flatten: true
    });
    let text = "";
    [
        ...nodes
    ].forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return text;
}

});

parcelRegister("eeMXI", function(module, exports) {

$parcel$export(module.exports, "watch", () => $a5d85a5ca503f67d$export$3db5d71bdb2d5499);

var $30uP6 = parcelRequire("30uP6");
// src/internal/watch.ts
function $a5d85a5ca503f67d$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = (0, $30uP6.__spreadValues)({
        waitUntilFirstUpdate: false
    }, options);
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}

});

parcelRegister("gGDeJ", function(module, exports) {

$parcel$export(module.exports, "o", () => $c25f012af62ad9be$export$ae1af26003f05816);

var $fPMPh = parcelRequire("fPMPh");

var $22pPT = parcelRequire("22pPT");
// node_modules/lit-html/directives/class-map.js
var $c25f012af62ad9be$export$ae1af26003f05816 = (0, $fPMPh.e)(class extends (0, $fPMPh.i) {
    constructor(t2){
        var i2;
        if (super(t2), t2.type !== (0, $fPMPh.t).ATTRIBUTE || "class" !== t2.name || (null === (i2 = t2.strings) || void 0 === i2 ? void 0 : i2.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t2) {
        return " " + Object.keys(t2).filter((i2)=>t2[i2]).join(" ") + " ";
    }
    update(i2, [s]) {
        var r, o2;
        if (void 0 === this.nt) {
            this.nt = /* @__PURE__ */ new Set(), void 0 !== i2.strings && (this.st = new Set(i2.strings.join(" ").split(/\s/).filter((t2)=>"" !== t2)));
            for(const t2 in s)s[t2] && !(null === (r = this.st) || void 0 === r ? void 0 : r.has(t2)) && this.nt.add(t2);
            return this.render(s);
        }
        const e2 = i2.element.classList;
        this.nt.forEach((t2)=>{
            t2 in s || (e2.remove(t2), this.nt.delete(t2));
        });
        for(const t2 in s){
            const i3 = !!s[t2];
            i3 === this.nt.has(t2) || (null === (o2 = this.st) || void 0 === o2 ? void 0 : o2.has(t2)) || (i3 ? (e2.add(t2), this.nt.add(t2)) : (e2.remove(t2), this.nt.delete(t2)));
        }
        return 0, $22pPT.x;
    }
});
 /*! Bundled license information:

lit-html/directives/class-map.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});
parcelRegister("fPMPh", function(module, exports) {

$parcel$export(module.exports, "t", () => $b8717e464dc278bd$export$625550452a3fa3ec);
$parcel$export(module.exports, "e", () => $b8717e464dc278bd$export$f1e1789686576879);
$parcel$export(module.exports, "i", () => $b8717e464dc278bd$export$23f2a1d2818174ef);
// node_modules/lit-html/directive.js
var $b8717e464dc278bd$export$625550452a3fa3ec = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
};
var $b8717e464dc278bd$export$f1e1789686576879 = (t2)=>(...e2)=>({
            _$litDirective$: t2,
            values: e2
        });
var $b8717e464dc278bd$export$23f2a1d2818174ef = class {
    constructor(t2){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t2, e2, i2) {
        this._$Ct = t2, this._$AM = e2, this._$Ci = i2;
    }
    _$AS(t2, e2) {
        return this.update(t2, e2);
    }
    update(t2, e2) {
        return this.render(...e2);
    }
};
 /*! Bundled license information:

lit-html/directive.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});


parcelRegister("6SxKb", function(module, exports) {

$parcel$export(module.exports, "e", () => $5021f61191157861$export$f1e1789686576879);
$parcel$export(module.exports, "e2", () => $5021f61191157861$export$5c585649956053b);
$parcel$export(module.exports, "t", () => $5021f61191157861$export$625550452a3fa3ec);
$parcel$export(module.exports, "i", () => $5021f61191157861$export$23f2a1d2818174ef);
$parcel$export(module.exports, "ShoelaceElement", () => $5021f61191157861$export$6f25236e887097b);

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// node_modules/@lit/reactive-element/decorators/custom-element.js
var $5021f61191157861$export$f1e1789686576879 = (e5)=>(n2)=>"function" == typeof n2 ? ((e6, n3)=>(customElements.define(e6, n3), n3))(e5, n2) : ((e6, n3)=>{
            const { kind: t2, elements: s2 } = n3;
            return {
                kind: t2,
                elements: s2,
                finisher (n4) {
                    customElements.define(e6, n4);
                }
            };
        })(e5, n2);
// node_modules/@lit/reactive-element/decorators/property.js
var $5021f61191157861$var$i = (i3, e5)=>"method" === e5.kind && e5.descriptor && !("value" in e5.descriptor) ? (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, e5), {
        finisher (n2) {
            n2.createProperty(e5.key, i3);
        }
    }) : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e5.key,
        initializer () {
            "function" == typeof e5.initializer && (this[e5.key] = e5.initializer.call(this));
        },
        finisher (n2) {
            n2.createProperty(e5.key, i3);
        }
    };
function $5021f61191157861$export$5c585649956053b(e5) {
    return (n2, t2)=>void 0 !== t2 ? ((i3, e6, n3)=>{
            e6.constructor.createProperty(n3, i3);
        })(e5, n2, t2) : $5021f61191157861$var$i(e5, n2);
}
// node_modules/@lit/reactive-element/decorators/state.js
function $5021f61191157861$export$625550452a3fa3ec(t2) {
    return $5021f61191157861$export$5c585649956053b((0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, t2), {
        state: true
    }));
}
// node_modules/@lit/reactive-element/decorators/base.js
var $5021f61191157861$var$o = ({ finisher: e5, descriptor: t2 })=>(o2, n2)=>{
        var r;
        if (void 0 === n2) {
            const n3 = null !== (r = o2.originalKey) && void 0 !== r ? r : o2.key, i3 = null != t2 ? {
                kind: "method",
                placement: "prototype",
                key: n3,
                descriptor: t2(o2.key)
            } : (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, o2), {
                key: n3
            });
            return null != e5 && (i3.finisher = function(t3) {
                e5(t3, n3);
            }), i3;
        }
        {
            const r2 = o2.constructor;
            void 0 !== t2 && Object.defineProperty(o2, n2, t2(n2)), null == e5 || e5(r2, n2);
        }
    };
// node_modules/@lit/reactive-element/decorators/query.js
function $5021f61191157861$export$23f2a1d2818174ef(i3, n2) {
    return $5021f61191157861$var$o({
        descriptor: (o2)=>{
            const t2 = {
                get () {
                    var o3, n3;
                    return null !== (n3 = null === (o3 = this.renderRoot) || void 0 === o3 ? void 0 : o3.querySelector(i3)) && void 0 !== n3 ? n3 : null;
                },
                enumerable: true,
                configurable: true
            };
            if (n2) {
                const n3 = "symbol" == typeof o2 ? Symbol() : "__" + o2;
                t2.get = function() {
                    var o3, t3;
                    return void 0 === this[n3] && (this[n3] = null !== (t3 = null === (o3 = this.renderRoot) || void 0 === o3 ? void 0 : o3.querySelector(i3)) && void 0 !== t3 ? t3 : null), this[n3];
                };
            }
            return t2;
        }
    });
}
// node_modules/@lit/reactive-element/decorators/query-async.js
function $5021f61191157861$export$e6142e6054105de8(e5) {
    return $5021f61191157861$var$o({
        descriptor: (r)=>({
                async get () {
                    var r2;
                    return await this.updateComplete, null === (r2 = this.renderRoot) || void 0 === r2 ? void 0 : r2.querySelector(e5);
                },
                enumerable: true,
                configurable: true
            })
    });
}
// node_modules/@lit/reactive-element/decorators/query-assigned-elements.js
var $5021f61191157861$var$n;
var $5021f61191157861$var$e4 = null != (null === ($5021f61191157861$var$n = window.HTMLSlotElement) || void 0 === $5021f61191157861$var$n ? void 0 : $5021f61191157861$var$n.prototype.assignedElements) ? (o2, n2)=>o2.assignedElements(n2) : (o2, n2)=>o2.assignedNodes(n2).filter((o3)=>o3.nodeType === Node.ELEMENT_NODE);
// src/internal/shoelace-element.ts
var $5021f61191157861$export$6f25236e887097b = class extends (0, $22pPT.s) {
    emit(name, options) {
        const event = new CustomEvent(name, (0, $30uP6.__spreadValues)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
};
(0, $30uP6.__decorateClass)([
    $5021f61191157861$export$5c585649956053b()
], $5021f61191157861$export$6f25236e887097b.prototype, "dir", 2);
(0, $30uP6.__decorateClass)([
    $5021f61191157861$export$5c585649956053b()
], $5021f61191157861$export$6f25236e887097b.prototype, "lang", 2);
 /*! Bundled license information:

@lit/reactive-element/decorators/custom-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/property.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/state.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/base.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-async.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/event-options.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-all.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});


parcelRegister("k9Ywk", function(module, exports) {

var $fsRoR = parcelRequire("fsRoR");

var $eIzsp = parcelRequire("eIzsp");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// src/components/spinner/spinner.ts
var $ead398048ec36a46$export$4e45ce56e46d2b00 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $eIzsp.LocalizeController)(this);
    }
    render() {
        return (0, $22pPT.y)`
      <svg part="base" class="spinner" role="progressbar" aria-valuetext=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
    }
};
$ead398048ec36a46$export$4e45ce56e46d2b00.styles = (0, $fsRoR.spinner_styles_default);
$ead398048ec36a46$export$4e45ce56e46d2b00 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-spinner")
], $ead398048ec36a46$export$4e45ce56e46d2b00);

});
parcelRegister("fsRoR", function(module, exports) {

$parcel$export(module.exports, "spinner_styles_default", () => $b422e4ad9be287f7$export$6a9ed4d91972acb3);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/spinner/spinner.styles.ts
var $b422e4ad9be287f7$export$6a9ed4d91972acb3 = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.01em, 2.75em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.01em, 2.75em;
    }
  }
`;

});


parcelRegister("aMmFT", function(module, exports) {

$parcel$export(module.exports, "SlIcon", () => $7d8ff9cbc219faf7$export$ef62a86bf282441);

var $99gLn = parcelRequire("99gLn");

var $5xjpF = parcelRequire("5xjpF");

var $iZtXQ = parcelRequire("iZtXQ");

var $eeMXI = parcelRequire("eeMXI");

var $fPMPh = parcelRequire("fPMPh");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// node_modules/lit-html/directives/unsafe-html.js
var $7d8ff9cbc219faf7$var$e4 = class extends (0, $fPMPh.i) {
    constructor(i2){
        if (super(i2), this.it = (0, $22pPT.b), i2.type !== (0, $fPMPh.t).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $22pPT.b) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $22pPT.x)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
};
$7d8ff9cbc219faf7$var$e4.directiveName = "unsafeHTML", $7d8ff9cbc219faf7$var$e4.resultType = 1;
var $7d8ff9cbc219faf7$export$ae1af26003f05816 = (0, $fPMPh.e)($7d8ff9cbc219faf7$var$e4);
// node_modules/lit-html/directives/unsafe-svg.js
var $7d8ff9cbc219faf7$var$t3 = class extends $7d8ff9cbc219faf7$var$e4 {
};
$7d8ff9cbc219faf7$var$t3.directiveName = "unsafeSVG", $7d8ff9cbc219faf7$var$t3.resultType = 2;
var $7d8ff9cbc219faf7$var$o2 = (0, $fPMPh.e)($7d8ff9cbc219faf7$var$t3);
// src/components/icon/icon.ts
var $7d8ff9cbc219faf7$var$parser;
var $7d8ff9cbc219faf7$export$ef62a86bf282441 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.svg = "";
        this.label = "";
        this.library = "default";
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $99gLn.watchIcon)(this);
    }
    firstUpdated() {
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $99gLn.unwatchIcon)(this);
    }
    getUrl() {
        const library = (0, $99gLn.getIconLibrary)(this.library);
        if (this.name && library) return library.resolver(this.name);
        return this.src;
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        var _a;
        const library = (0, $99gLn.getIconLibrary)(this.library);
        const url = this.getUrl();
        if (!$7d8ff9cbc219faf7$var$parser) $7d8ff9cbc219faf7$var$parser = new DOMParser();
        if (url) try {
            const file = await (0, $5xjpF.requestIcon)(url);
            if (url !== this.getUrl()) return;
            else if (file.ok) {
                const doc = $7d8ff9cbc219faf7$var$parser.parseFromString(file.svg, "text/html");
                const svgEl = doc.body.querySelector("svg");
                if (svgEl !== null) {
                    svgEl.part.add("svg");
                    (_a = library == null ? void 0 : library.mutator) == null || _a.call(library, svgEl);
                    this.svg = svgEl.outerHTML;
                    this.emit("sl-load");
                } else {
                    this.svg = "";
                    this.emit("sl-error");
                }
            } else {
                this.svg = "";
                this.emit("sl-error");
            }
        } catch (e5) {
            this.emit("sl-error");
        }
        else if (this.svg.length > 0) this.svg = "";
    }
    render() {
        return (0, $22pPT.y)` ${$7d8ff9cbc219faf7$var$o2(this.svg)} `;
    }
};
$7d8ff9cbc219faf7$export$ef62a86bf282441.styles = (0, $iZtXQ.icon_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $7d8ff9cbc219faf7$export$ef62a86bf282441.prototype, "svg", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $7d8ff9cbc219faf7$export$ef62a86bf282441.prototype, "name", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $7d8ff9cbc219faf7$export$ef62a86bf282441.prototype, "src", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $7d8ff9cbc219faf7$export$ef62a86bf282441.prototype, "label", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $7d8ff9cbc219faf7$export$ef62a86bf282441.prototype, "library", 2);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("label")
], $7d8ff9cbc219faf7$export$ef62a86bf282441.prototype, "handleLabelChange", 1);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)([
        "name",
        "src",
        "library"
    ])
], $7d8ff9cbc219faf7$export$ef62a86bf282441.prototype, "setIcon", 1);
$7d8ff9cbc219faf7$export$ef62a86bf282441 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-icon")
], $7d8ff9cbc219faf7$export$ef62a86bf282441);
 /*! Bundled license information:

lit-html/directives/unsafe-html.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/directives/unsafe-svg.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});
parcelRegister("99gLn", function(module, exports) {

$parcel$export(module.exports, "watchIcon", () => $6a91f522b3f0746d$export$da63f424a7208010);
$parcel$export(module.exports, "unwatchIcon", () => $6a91f522b3f0746d$export$9e46b25ecab82f0b);
$parcel$export(module.exports, "getIconLibrary", () => $6a91f522b3f0746d$export$be026de5111f322b);
$parcel$export(module.exports, "registerIconLibrary", () => $6a91f522b3f0746d$export$a482e04ad60c9b11);

var $jCb68 = parcelRequire("jCb68");

var $hkKxA = parcelRequire("hkKxA");
// src/components/icon/library.ts
var $6a91f522b3f0746d$var$registry = [
    (0, $hkKxA.library_default_default),
    (0, $jCb68.library_system_default)
];
var $6a91f522b3f0746d$var$watchedIcons = [];
function $6a91f522b3f0746d$export$da63f424a7208010(icon) {
    $6a91f522b3f0746d$var$watchedIcons.push(icon);
}
function $6a91f522b3f0746d$export$9e46b25ecab82f0b(icon) {
    $6a91f522b3f0746d$var$watchedIcons = $6a91f522b3f0746d$var$watchedIcons.filter((el)=>el !== icon);
}
function $6a91f522b3f0746d$export$be026de5111f322b(name) {
    return $6a91f522b3f0746d$var$registry.find((lib)=>lib.name === name);
}
function $6a91f522b3f0746d$export$a482e04ad60c9b11(name, options) {
    $6a91f522b3f0746d$export$8faa256e94012669(name);
    $6a91f522b3f0746d$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator
    });
    $6a91f522b3f0746d$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $6a91f522b3f0746d$export$8faa256e94012669(name) {
    $6a91f522b3f0746d$var$registry = $6a91f522b3f0746d$var$registry.filter((lib)=>lib.name !== name);
}

});
parcelRegister("jCb68", function(module, exports) {

$parcel$export(module.exports, "library_system_default", () => $e47a2cc4a85165d9$export$3139252f9828970f);
// src/components/icon/library.system.ts
var $e47a2cc4a85165d9$var$icons = {
    caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
    check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
    "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
    "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
    eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
    "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
    indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
    "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
    "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
    radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
    "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
    "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
    "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
};
var $e47a2cc4a85165d9$var$systemLibrary = {
    name: "system",
    resolver: (name)=>{
        if (name in $e47a2cc4a85165d9$var$icons) return `data:image/svg+xml,${encodeURIComponent($e47a2cc4a85165d9$var$icons[name])}`;
        return "";
    }
};
var $e47a2cc4a85165d9$export$3139252f9828970f = $e47a2cc4a85165d9$var$systemLibrary;

});

parcelRegister("hkKxA", function(module, exports) {

$parcel$export(module.exports, "library_default_default", () => $c9e867f27172beb6$export$761783e099ce3526);

var $6Q7Kl = parcelRequire("6Q7Kl");
// src/components/icon/library.default.ts
var $c9e867f27172beb6$var$library = {
    name: "default",
    resolver: (name)=>`${(0, $6Q7Kl.getBasePath)()}/assets/icons/${name}.svg`
};
var $c9e867f27172beb6$export$761783e099ce3526 = $c9e867f27172beb6$var$library;

});
parcelRegister("6Q7Kl", function(module, exports) {

$parcel$export(module.exports, "getBasePath", () => $4fad9bb919a8b452$export$9099264ed9b1c55a);
// src/utilities/base-path.ts
var $4fad9bb919a8b452$var$basePath = "";
function $4fad9bb919a8b452$export$784ad41d332938c6(path) {
    $4fad9bb919a8b452$var$basePath = path;
}
function $4fad9bb919a8b452$export$9099264ed9b1c55a() {
    if (!$4fad9bb919a8b452$var$basePath) {
        const scripts = [
            ...document.getElementsByTagName("script")
        ];
        const configScript = scripts.find((script)=>script.hasAttribute("data-shoelace"));
        if (configScript) $4fad9bb919a8b452$export$784ad41d332938c6(configScript.getAttribute("data-shoelace"));
        else {
            const fallbackScript = scripts.find((s)=>/shoelace(\.min)?\.js($|\?)/.test(s.src));
            let path = "";
            if (fallbackScript) path = fallbackScript.getAttribute("src");
            $4fad9bb919a8b452$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
        }
    }
    return $4fad9bb919a8b452$var$basePath.replace(/\/$/, "");
}

});



parcelRegister("5xjpF", function(module, exports) {

$parcel$export(module.exports, "requestIcon", () => $407f17d4e476f13b$export$148cf4d96f62d603);

var $dk295 = parcelRequire("dk295");
// src/components/icon/request.ts
var $407f17d4e476f13b$var$iconFiles = /* @__PURE__ */ new Map();
async function $407f17d4e476f13b$export$148cf4d96f62d603(url) {
    if ($407f17d4e476f13b$var$iconFiles.has(url)) return $407f17d4e476f13b$var$iconFiles.get(url);
    const fileData = await (0, $dk295.requestInclude)(url);
    const iconFileData = {
        ok: fileData.ok,
        status: fileData.status,
        svg: null
    };
    if (fileData.ok) {
        const div = document.createElement("div");
        div.innerHTML = fileData.html;
        const svg = div.firstElementChild;
        iconFileData.svg = (svg == null ? void 0 : svg.tagName.toLowerCase()) === "svg" ? svg.outerHTML : "";
    }
    $407f17d4e476f13b$var$iconFiles.set(url, iconFileData);
    return iconFileData;
}

});
parcelRegister("dk295", function(module, exports) {

$parcel$export(module.exports, "requestInclude", () => $9b2ecea8ec5e740d$export$9ffa5ba4f9903370);
// src/components/include/request.ts
var $9b2ecea8ec5e740d$var$includeFiles = /* @__PURE__ */ new Map();
function $9b2ecea8ec5e740d$export$9ffa5ba4f9903370(src, mode = "cors") {
    if ($9b2ecea8ec5e740d$var$includeFiles.has(src)) return $9b2ecea8ec5e740d$var$includeFiles.get(src);
    const fileDataPromise = fetch(src, {
        mode: mode
    }).then(async (response)=>{
        return {
            ok: response.ok,
            status: response.status,
            html: await response.text()
        };
    });
    $9b2ecea8ec5e740d$var$includeFiles.set(src, fileDataPromise);
    return fileDataPromise;
}

});


parcelRegister("iZtXQ", function(module, exports) {

$parcel$export(module.exports, "icon_styles_default", () => $dd352acc5b056c5d$export$f0b0874d64866432);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/icon/icon.styles.ts
var $dd352acc5b056c5d$export$f0b0874d64866432 = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;

});



parcelRegister("kT4IK", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("lxgjN")).SlCard);

var $lxgjN = parcelRequire("lxgjN");
parcelRequire("37c3y");
parcelRequire("4Yt64");
parcelRequire("gGDeJ");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});
parcelRegister("lxgjN", function(module, exports) {

$parcel$export(module.exports, "SlCard", () => $fad95681d8d639c9$export$a93c76cb301d0cc8);

var $37c3y = parcelRequire("37c3y");

var $4Yt64 = parcelRequire("4Yt64");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// src/components/card/card.ts
var $fad95681d8d639c9$export$a93c76cb301d0cc8 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $4Yt64.HasSlotController)(this, "footer", "header", "image");
    }
    render() {
        return (0, $22pPT.y)`
      <div
        part="base"
        class=${(0, $gGDeJ.o)({
            card: true,
            "card--has-footer": this.hasSlotController.test("footer"),
            "card--has-image": this.hasSlotController.test("image"),
            "card--has-header": this.hasSlotController.test("header")
        })}
      >
        <slot name="image" part="image" class="card__image"></slot>
        <slot name="header" part="header" class="card__header"></slot>
        <slot part="body" class="card__body"></slot>
        <slot name="footer" part="footer" class="card__footer"></slot>
      </div>
    `;
    }
};
$fad95681d8d639c9$export$a93c76cb301d0cc8.styles = (0, $37c3y.card_styles_default);
$fad95681d8d639c9$export$a93c76cb301d0cc8 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-card")
], $fad95681d8d639c9$export$a93c76cb301d0cc8);

});
parcelRegister("37c3y", function(module, exports) {

$parcel$export(module.exports, "card_styles_default", () => $244b60b04acb75d0$export$eceb153d0f9bbd93);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/card/card.styles.ts
var $244b60b04acb75d0$export$eceb153d0f9bbd93 = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    --border-color: var(--sl-color-neutral-200);
    --border-radius: var(--sl-border-radius-medium);
    --border-width: 1px;
    --padding: var(--sl-spacing-large);

    display: inline-block;
  }

  .card {
    display: flex;
    flex-direction: column;
    background-color: var(--sl-panel-background-color);
    box-shadow: var(--sl-shadow-x-small);
    border: solid var(--border-width) var(--border-color);
    border-radius: var(--border-radius);
  }

  .card__image {
    display: flex;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
    margin: calc(-1 * var(--border-width));
    overflow: hidden;
  }

  .card__image::slotted(img) {
    display: block;
    width: 100%;
  }

  .card:not(.card--has-image) .card__image {
    display: none;
  }

  .card__header {
    display: block;
    border-bottom: solid var(--border-width) var(--border-color);
    padding: calc(var(--padding) / 2) var(--padding);
  }

  .card:not(.card--has-header) .card__header {
    display: none;
  }

  .card:not(.card--has-image) .card__header {
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
  }

  .card__body {
    display: block;
    padding: var(--padding);
  }

  .card--has-footer .card__footer {
    display: block;
    border-top: solid var(--border-width) var(--border-color);
    padding: var(--padding);
  }

  .card:not(.card--has-footer) .card__footer {
    display: none;
  }
`;

});



parcelRegister("1znxk", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("i7Sym")).SlDetails);

var $i7Sym = parcelRequire("i7Sym");
parcelRequire("lx1uL");
parcelRequire("3cUze");
parcelRequire("6rIOV");
parcelRequire("bV71f");
parcelRequire("eIzsp");
parcelRequire("c8fQa");
parcelRequire("aMmFT");
parcelRequire("99gLn");
parcelRequire("jCb68");
parcelRequire("5xjpF");
parcelRequire("dk295");
parcelRequire("iZtXQ");
parcelRequire("hkKxA");
parcelRequire("6Q7Kl");
parcelRequire("eeMXI");
parcelRequire("gGDeJ");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});
parcelRegister("i7Sym", function(module, exports) {

$parcel$export(module.exports, "SlDetails", () => $d32332968e992de8$export$ada524cc60438dd5);

var $lx1uL = parcelRequire("lx1uL");

var $3cUze = parcelRequire("3cUze");

var $6rIOV = parcelRequire("6rIOV");

var $bV71f = parcelRequire("bV71f");

var $eIzsp = parcelRequire("eIzsp");

var $eeMXI = parcelRequire("eeMXI");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// src/components/details/details.ts
var $d32332968e992de8$export$ada524cc60438dd5 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $eIzsp.LocalizeController)(this);
        this.open = false;
        this.disabled = false;
    }
    firstUpdated() {
        this.body.hidden = !this.open;
        this.body.style.height = this.open ? "auto" : "0";
    }
    handleSummaryClick() {
        if (!this.disabled) {
            if (this.open) this.hide();
            else this.show();
            this.header.focus();
        }
    }
    handleSummaryKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            if (this.open) this.hide();
            else this.show();
        }
        if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
            event.preventDefault();
            this.hide();
        }
        if (event.key === "ArrowDown" || event.key === "ArrowRight") {
            event.preventDefault();
            this.show();
        }
    }
    async handleOpenChange() {
        if (this.open) {
            const slShow = this.emit("sl-show", {
                cancelable: true
            });
            if (slShow.defaultPrevented) {
                this.open = false;
                return;
            }
            await (0, $bV71f.stopAnimations)(this.body);
            this.body.hidden = false;
            const { keyframes: keyframes, options: options } = (0, $3cUze.getAnimation)(this, "details.show", {
                dir: this.localize.dir()
            });
            await (0, $bV71f.animateTo)(this.body, (0, $bV71f.shimKeyframesHeightAuto)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.emit("sl-after-show");
        } else {
            const slHide = this.emit("sl-hide", {
                cancelable: true
            });
            if (slHide.defaultPrevented) {
                this.open = true;
                return;
            }
            await (0, $bV71f.stopAnimations)(this.body);
            const { keyframes: keyframes, options: options } = (0, $3cUze.getAnimation)(this, "details.hide", {
                dir: this.localize.dir()
            });
            await (0, $bV71f.animateTo)(this.body, (0, $bV71f.shimKeyframesHeightAuto)(keyframes, this.body.scrollHeight), options);
            this.body.hidden = true;
            this.body.style.height = "auto";
            this.emit("sl-after-hide");
        }
    }
    /** Shows the details. */ async show() {
        if (this.open || this.disabled) return void 0;
        this.open = true;
        return (0, $6rIOV.waitForEvent)(this, "sl-after-show");
    }
    /** Hides the details */ async hide() {
        if (!this.open || this.disabled) return void 0;
        this.open = false;
        return (0, $6rIOV.waitForEvent)(this, "sl-after-hide");
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        return (0, $22pPT.y)`
      <div
        part="base"
        class=${(0, $gGDeJ.o)({
            details: true,
            "details--open": this.open,
            "details--disabled": this.disabled,
            "details--rtl": isRtl
        })}
      >
        <header
          part="header"
          id="header"
          class="details__header"
          role="button"
          aria-expanded=${this.open ? "true" : "false"}
          aria-controls="content"
          aria-disabled=${this.disabled ? "true" : "false"}
          tabindex=${this.disabled ? "-1" : "0"}
          @click=${this.handleSummaryClick}
          @keydown=${this.handleSummaryKeyDown}
        >
          <slot name="summary" part="summary" class="details__summary">${this.summary}</slot>

          <span part="summary-icon" class="details__summary-icon">
            <slot name="expand-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
            <slot name="collapse-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
          </span>
        </header>

        <div class="details__body">
          <slot part="content" id="content" class="details__content" role="region" aria-labelledby="header"></slot>
        </div>
      </div>
    `;
    }
};
$d32332968e992de8$export$ada524cc60438dd5.styles = (0, $lx1uL.details_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".details")
], $d32332968e992de8$export$ada524cc60438dd5.prototype, "details", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".details__header")
], $d32332968e992de8$export$ada524cc60438dd5.prototype, "header", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".details__body")
], $d32332968e992de8$export$ada524cc60438dd5.prototype, "body", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".details__expand-icon-slot")
], $d32332968e992de8$export$ada524cc60438dd5.prototype, "expandIconSlot", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $d32332968e992de8$export$ada524cc60438dd5.prototype, "open", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $d32332968e992de8$export$ada524cc60438dd5.prototype, "summary", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $d32332968e992de8$export$ada524cc60438dd5.prototype, "disabled", 2);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("open", {
        waitUntilFirstUpdate: true
    })
], $d32332968e992de8$export$ada524cc60438dd5.prototype, "handleOpenChange", 1);
$d32332968e992de8$export$ada524cc60438dd5 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-details")
], $d32332968e992de8$export$ada524cc60438dd5);
(0, $3cUze.setDefaultAnimation)("details.show", {
    keyframes: [
        {
            height: "0",
            opacity: "0"
        },
        {
            height: "auto",
            opacity: "1"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});
(0, $3cUze.setDefaultAnimation)("details.hide", {
    keyframes: [
        {
            height: "auto",
            opacity: "1"
        },
        {
            height: "0",
            opacity: "0"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});

});
parcelRegister("lx1uL", function(module, exports) {

$parcel$export(module.exports, "details_styles_default", () => $facdd6fabd345b8a$export$e0460a263d3b7bef);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/details/details.styles.ts
var $facdd6fabd345b8a$export$e0460a263d3b7bef = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    display: block;
  }

  .details {
    border: solid 1px var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-medium);
    background-color: var(--sl-color-neutral-0);
    overflow-anchor: none;
  }

  .details--disabled {
    opacity: 0.5;
  }

  .details__header {
    display: flex;
    align-items: center;
    border-radius: inherit;
    padding: var(--sl-spacing-medium);
    user-select: none;
    cursor: pointer;
  }

  .details__header:focus {
    outline: none;
  }

  .details__header:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: calc(1px + var(--sl-focus-ring-offset));
  }

  .details--disabled .details__header {
    cursor: not-allowed;
  }

  .details--disabled .details__header:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .details__summary {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }

  .details__summary-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: var(--sl-transition-medium) rotate ease;
  }

  .details--open .details__summary-icon {
    rotate: 90deg;
  }

  .details--open.details--rtl .details__summary-icon {
    rotate: -90deg;
  }

  .details--open slot[name='expand-icon'],
  .details:not(.details--open) slot[name='collapse-icon'] {
    display: none;
  }

  .details__body {
    overflow: hidden;
  }

  .details__content {
    display: block;
    padding: var(--sl-spacing-medium);
  }
`;

});

parcelRegister("3cUze", function(module, exports) {

$parcel$export(module.exports, "setDefaultAnimation", () => $255e5f27fb8386f1$export$6e92ecdbe15fda0b);
$parcel$export(module.exports, "getAnimation", () => $255e5f27fb8386f1$export$b1aed5dec0c2d368);

var $30uP6 = parcelRequire("30uP6");
// src/utilities/animation-registry.ts
var $255e5f27fb8386f1$var$defaultAnimationRegistry = /* @__PURE__ */ new Map();
var $255e5f27fb8386f1$var$customAnimationRegistry = /* @__PURE__ */ new WeakMap();
function $255e5f27fb8386f1$var$ensureAnimation(animation) {
    return animation != null ? animation : {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}
function $255e5f27fb8386f1$var$getLogicalAnimation(animation, dir) {
    if (dir.toLowerCase() === "rtl") return {
        keyframes: animation.rtlKeyframes || animation.keyframes,
        options: animation.options
    };
    return animation;
}
function $255e5f27fb8386f1$export$6e92ecdbe15fda0b(animationName, animation) {
    $255e5f27fb8386f1$var$defaultAnimationRegistry.set(animationName, $255e5f27fb8386f1$var$ensureAnimation(animation));
}
function $255e5f27fb8386f1$export$ea45326d94a48a31(el, animationName, animation) {
    $255e5f27fb8386f1$var$customAnimationRegistry.set(el, (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, $255e5f27fb8386f1$var$customAnimationRegistry.get(el)), {
        [animationName]: $255e5f27fb8386f1$var$ensureAnimation(animation)
    }));
}
function $255e5f27fb8386f1$export$b1aed5dec0c2d368(el, animationName, options) {
    const customAnimation = $255e5f27fb8386f1$var$customAnimationRegistry.get(el);
    if (customAnimation == null ? void 0 : customAnimation[animationName]) return $255e5f27fb8386f1$var$getLogicalAnimation(customAnimation[animationName], options.dir);
    const defaultAnimation = $255e5f27fb8386f1$var$defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) return $255e5f27fb8386f1$var$getLogicalAnimation(defaultAnimation, options.dir);
    return {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}

});

parcelRegister("6rIOV", function(module, exports) {

$parcel$export(module.exports, "waitForEvent", () => $4b180815ca3a4f1f$export$6608ab6fe9313967);
// src/internal/event.ts
function $4b180815ca3a4f1f$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}

});

parcelRegister("bV71f", function(module, exports) {

$parcel$export(module.exports, "animateTo", () => $023d547d956a90f3$export$3b755839a54e1bb0);
$parcel$export(module.exports, "stopAnimations", () => $023d547d956a90f3$export$ad12f740028ccbea);
$parcel$export(module.exports, "shimKeyframesHeightAuto", () => $023d547d956a90f3$export$783a9b5bf095072a);

var $30uP6 = parcelRequire("30uP6");
// src/internal/animate.ts
function $023d547d956a90f3$export$3b755839a54e1bb0(el, keyframes, options) {
    return new Promise((resolve)=>{
        if ((options == null ? void 0 : options.duration) === Infinity) throw new Error("Promise-based animations must be finite.");
        const animation = el.animate(keyframes, (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, options), {
            duration: $023d547d956a90f3$export$ff7706047246b98b() ? 0 : options.duration
        }));
        animation.addEventListener("cancel", resolve, {
            once: true
        });
        animation.addEventListener("finish", resolve, {
            once: true
        });
    });
}
function $023d547d956a90f3$export$ecae829bb3747ea6(delay) {
    delay = delay.toString().toLowerCase();
    if (delay.indexOf("ms") > -1) return parseFloat(delay);
    if (delay.indexOf("s") > -1) return parseFloat(delay) * 1e3;
    return parseFloat(delay);
}
function $023d547d956a90f3$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}
function $023d547d956a90f3$export$ad12f740028ccbea(el) {
    return Promise.all(el.getAnimations().map((animation)=>{
        return new Promise((resolve)=>{
            const handleAnimationEvent = requestAnimationFrame(resolve);
            animation.addEventListener("cancel", ()=>handleAnimationEvent, {
                once: true
            });
            animation.addEventListener("finish", ()=>handleAnimationEvent, {
                once: true
            });
            animation.cancel();
        });
    }));
}
function $023d547d956a90f3$export$783a9b5bf095072a(keyframes, calculatedHeight) {
    return keyframes.map((keyframe)=>(0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, keyframe), {
            height: keyframe.height === "auto" ? `${calculatedHeight}px` : keyframe.height
        }));
}

});



parcelRegister("1vjwo", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("aMmFT")).SlIcon);

var $aMmFT = parcelRequire("aMmFT");
parcelRequire("99gLn");
parcelRequire("jCb68");
parcelRequire("5xjpF");
parcelRequire("dk295");
parcelRequire("iZtXQ");
parcelRequire("hkKxA");
parcelRequire("6Q7Kl");
parcelRequire("eeMXI");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});

parcelRegister("cb04B", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("6UXx3")).SlIconButton);

var $6UXx3 = parcelRequire("6UXx3");
parcelRequire("k4sxW");
parcelRequire("9UUPL");
parcelRequire("aHRmB");
parcelRequire("aMmFT");
parcelRequire("99gLn");
parcelRequire("jCb68");
parcelRequire("5xjpF");
parcelRequire("dk295");
parcelRequire("iZtXQ");
parcelRequire("hkKxA");
parcelRequire("6Q7Kl");
parcelRequire("eeMXI");
parcelRequire("gGDeJ");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});
parcelRegister("6UXx3", function(module, exports) {

$parcel$export(module.exports, "SlIconButton", () => $509626e7f0e00335$export$302c9d29315a4659);

var $k4sxW = parcelRequire("k4sxW");

var $9UUPL = parcelRequire("9UUPL");

var $aHRmB = parcelRequire("aHRmB");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $30uP6 = parcelRequire("30uP6");
// src/components/icon-button/icon-button.ts
var $509626e7f0e00335$export$302c9d29315a4659 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.hasFocus = false;
        this.label = "";
        this.disabled = false;
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /** Simulates a click on the icon button. */ click() {
        this.button.click();
    }
    /** Sets focus on the icon button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the icon button. */ blur() {
        this.button.blur();
    }
    render() {
        const isLink = this.href ? true : false;
        const tag = isLink ? (0, $9UUPL.i)`a` : (0, $9UUPL.i)`button`;
        return (0, $9UUPL.n)`
      <${tag}
        part="base"
        class=${(0, $gGDeJ.o)({
            "icon-button": true,
            "icon-button--disabled": !isLink && this.disabled,
            "icon-button--focused": this.hasFocus
        })}
        ?disabled=${(0, $aHRmB.l)(isLink ? void 0 : this.disabled)}
        type=${(0, $aHRmB.l)(isLink ? void 0 : "button")}
        href=${(0, $aHRmB.l)(isLink ? this.href : void 0)}
        target=${(0, $aHRmB.l)(isLink ? this.target : void 0)}
        download=${(0, $aHRmB.l)(isLink ? this.download : void 0)}
        rel=${(0, $aHRmB.l)(isLink && this.target ? "noreferrer noopener" : void 0)}
        role=${(0, $aHRmB.l)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${(0, $aHRmB.l)(this.name)}
          library=${(0, $aHRmB.l)(this.library)}
          src=${(0, $aHRmB.l)(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${tag}>
    `;
    }
};
$509626e7f0e00335$export$302c9d29315a4659.styles = (0, $k4sxW.icon_button_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".icon-button")
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "button", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "hasFocus", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "name", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "library", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "src", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "href", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "target", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "download", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "label", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $509626e7f0e00335$export$302c9d29315a4659.prototype, "disabled", 2);
$509626e7f0e00335$export$302c9d29315a4659 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-icon-button")
], $509626e7f0e00335$export$302c9d29315a4659);

});
parcelRegister("k4sxW", function(module, exports) {

$parcel$export(module.exports, "icon_button_styles_default", () => $e9ca531e24445643$export$e7174f10cedebf49);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/icon-button/icon-button.styles.ts
var $e9ca531e24445643$export$e7174f10cedebf49 = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;

});



parcelRegister("291bb", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("kAVxJ")).SlOption);

var $kAVxJ = parcelRequire("kAVxJ");
parcelRequire("Qy4tw");
parcelRequire("eIzsp");
parcelRequire("c8fQa");
parcelRequire("aMmFT");
parcelRequire("99gLn");
parcelRequire("jCb68");
parcelRequire("5xjpF");
parcelRequire("dk295");
parcelRequire("iZtXQ");
parcelRequire("hkKxA");
parcelRequire("6Q7Kl");
parcelRequire("eeMXI");
parcelRequire("gGDeJ");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});
parcelRegister("kAVxJ", function(module, exports) {

$parcel$export(module.exports, "SlOption", () => $efe3ce491d8b705d$export$529a8b79340189ba);

var $Qy4tw = parcelRequire("Qy4tw");

var $eIzsp = parcelRequire("eIzsp");

var $eeMXI = parcelRequire("eeMXI");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// src/components/option/option.ts
var $efe3ce491d8b705d$export$529a8b79340189ba = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        // @ts-expect-error - Controller is currently unused
        this.localize = new (0, $eIzsp.LocalizeController)(this);
        this.current = false;
        this.selected = false;
        this.hasHover = false;
        this.value = "";
        this.disabled = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "option");
        this.setAttribute("aria-selected", "false");
    }
    handleDefaultSlotChange() {
        const textLabel = this.getTextLabel();
        if (typeof this.cachedTextLabel === "undefined") {
            this.cachedTextLabel = textLabel;
            return;
        }
        if (textLabel !== this.cachedTextLabel) {
            this.cachedTextLabel = textLabel;
            this.emit("slotchange", {
                bubbles: true,
                composed: false,
                cancelable: false
            });
        }
    }
    handleMouseEnter() {
        this.hasHover = true;
    }
    handleMouseLeave() {
        this.hasHover = false;
    }
    handleDisabledChange() {
        this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
    }
    handleSelectedChange() {
        this.setAttribute("aria-selected", this.selected ? "true" : "false");
    }
    handleValueChange() {
        if (this.value.includes(" ")) {
            console.error(`Option values cannot include a space. All spaces have been replaced with underscores.`, this);
            this.value = this.value.replace(/ /g, "_");
        }
    }
    /** Returns a plain text label based on the option's content. */ getTextLabel() {
        var _a;
        return ((_a = this.textContent) != null ? _a : "").trim();
    }
    render() {
        return (0, $22pPT.y)`
      <div
        part="base"
        class=${(0, $gGDeJ.o)({
            option: true,
            "option--current": this.current,
            "option--disabled": this.disabled,
            "option--selected": this.selected,
            "option--hover": this.hasHover
        })}
        @mouseenter=${this.handleMouseEnter}
        @mouseleave=${this.handleMouseLeave}
      >
        <sl-icon part="checked-icon" class="option__check" name="check" library="system" aria-hidden="true"></sl-icon>
        <slot part="prefix" name="prefix" class="option__prefix"></slot>
        <slot part="label" class="option__label" @slotchange=${this.handleDefaultSlotChange}></slot>
        <slot part="suffix" name="suffix" class="option__suffix"></slot>
      </div>
    `;
    }
};
$efe3ce491d8b705d$export$529a8b79340189ba.styles = (0, $Qy4tw.option_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".option__label")
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "defaultSlot", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "current", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "selected", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "hasHover", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "value", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "disabled", 2);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("disabled")
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "handleDisabledChange", 1);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("selected")
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "handleSelectedChange", 1);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("value")
], $efe3ce491d8b705d$export$529a8b79340189ba.prototype, "handleValueChange", 1);
$efe3ce491d8b705d$export$529a8b79340189ba = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-option")
], $efe3ce491d8b705d$export$529a8b79340189ba);

});
parcelRegister("Qy4tw", function(module, exports) {

$parcel$export(module.exports, "option_styles_default", () => $09df4945274cf99a$export$e4e447453ad69781);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/option/option.styles.ts
var $09df4945274cf99a$export$e4e447453ad69781 = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    display: block;
    user-select: none;
  }

  :host(:focus) {
    outline: none;
  }

  .option {
    position: relative;
    display: flex;
    align-items: center;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    line-height: var(--sl-line-height-normal);
    letter-spacing: var(--sl-letter-spacing-normal);
    color: var(--sl-color-neutral-700);
    padding: var(--sl-spacing-x-small) var(--sl-spacing-medium) var(--sl-spacing-x-small) var(--sl-spacing-x-small);
    transition: var(--sl-transition-fast) fill;
    cursor: pointer;
  }

  .option--hover:not(.option--current):not(.option--disabled) {
    background-color: var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-1000);
  }

  .option--current,
  .option--current.option--disabled {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
    opacity: 1;
  }

  .option--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .option__label {
    flex: 1 1 auto;
    display: inline-block;
    line-height: var(--sl-line-height-dense);
  }

  .option .option__check {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
    padding-inline-end: var(--sl-spacing-2x-small);
  }

  .option--selected .option__check {
    visibility: visible;
  }

  .option__prefix,
  .option__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .option__prefix::slotted(*) {
    margin-inline-end: var(--sl-spacing-x-small);
  }

  .option__suffix::slotted(*) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .option {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }
`;

});



parcelRegister("aZDzm", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("18J84")).SlProgressBar);

var $18J84 = parcelRequire("18J84");
parcelRequire("bgE4u");
parcelRequire("2ypB3");
parcelRequire("eIzsp");
parcelRequire("c8fQa");
parcelRequire("aHRmB");
parcelRequire("gGDeJ");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});
parcelRegister("18J84", function(module, exports) {

$parcel$export(module.exports, "SlProgressBar", () => $0d498b880cbbd801$export$9ad52f56f9678108);

var $bgE4u = parcelRequire("bgE4u");

var $2ypB3 = parcelRequire("2ypB3");

var $eIzsp = parcelRequire("eIzsp");

var $aHRmB = parcelRequire("aHRmB");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// src/components/progress-bar/progress-bar.ts
var $0d498b880cbbd801$export$9ad52f56f9678108 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $eIzsp.LocalizeController)(this);
        this.value = 0;
        this.indeterminate = false;
        this.label = "";
    }
    render() {
        return (0, $22pPT.y)`
      <div
        part="base"
        class=${(0, $gGDeJ.o)({
            "progress-bar": true,
            "progress-bar--indeterminate": this.indeterminate,
            "progress-bar--rtl": this.localize.dir() === "rtl"
        })}
        role="progressbar"
        title=${(0, $aHRmB.l)(this.title)}
        aria-label=${this.label.length > 0 ? this.label : this.localize.term("progress")}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow=${this.indeterminate ? 0 : this.value}
      >
        <div part="indicator" class="progress-bar__indicator" style=${(0, $2ypB3.i)({
            width: `${this.value}%`
        })}>
          ${!this.indeterminate ? (0, $22pPT.y)` <slot part="label" class="progress-bar__label"></slot> ` : ""}
        </div>
      </div>
    `;
    }
};
$0d498b880cbbd801$export$9ad52f56f9678108.styles = (0, $bgE4u.progress_bar_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Number,
        reflect: true
    })
], $0d498b880cbbd801$export$9ad52f56f9678108.prototype, "value", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $0d498b880cbbd801$export$9ad52f56f9678108.prototype, "indeterminate", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $0d498b880cbbd801$export$9ad52f56f9678108.prototype, "label", 2);
$0d498b880cbbd801$export$9ad52f56f9678108 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-progress-bar")
], $0d498b880cbbd801$export$9ad52f56f9678108);

});
parcelRegister("bgE4u", function(module, exports) {

$parcel$export(module.exports, "progress_bar_styles_default", () => $834045a970625be3$export$a9562eff442e810d);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/progress-bar/progress-bar.styles.ts
var $834045a970625be3$export$a9562eff442e810d = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    --height: 1rem;
    --track-color: var(--sl-color-neutral-200);
    --indicator-color: var(--sl-color-primary-600);
    --label-color: var(--sl-color-neutral-0);

    display: block;
  }

  .progress-bar {
    position: relative;
    background-color: var(--track-color);
    height: var(--height);
    border-radius: var(--sl-border-radius-pill);
    box-shadow: inset var(--sl-shadow-small);
    overflow: hidden;
  }

  .progress-bar__indicator {
    height: 100%;
    font-family: var(--sl-font-sans);
    font-size: 12px;
    font-weight: var(--sl-font-weight-normal);
    background-color: var(--indicator-color);
    color: var(--label-color);
    text-align: center;
    line-height: var(--height);
    white-space: nowrap;
    overflow: hidden;
    transition: 400ms width, 400ms background-color;
    user-select: none;
  }

  /* Indeterminate */
  .progress-bar--indeterminate .progress-bar__indicator {
    position: absolute;
    animation: indeterminate 2.5s infinite cubic-bezier(0.37, 0, 0.63, 1);
  }

  .progress-bar--indeterminate.progress-bar--rtl .progress-bar__indicator {
    animation-name: indeterminate-rtl;
  }

  @media (forced-colors: active) {
    .progress-bar {
      outline: solid 1px SelectedItem;
      background-color: var(--sl-color-neutral-0);
    }

    .progress-bar__indicator {
      outline: solid 1px SelectedItem;
      background-color: SelectedItem;
    }
  }

  @keyframes indeterminate {
    0% {
      left: -50%;
      width: 50%;
    }
    75%,
    100% {
      left: 100%;
      width: 50%;
    }
  }

  @keyframes indeterminate-rtl {
    0% {
      right: -50%;
      width: 50%;
    }
    75%,
    100% {
      right: 100%;
      width: 50%;
    }
  }
`;

});

parcelRegister("2ypB3", function(module, exports) {

$parcel$export(module.exports, "i", () => $1dc29cb5d8458fab$export$23f2a1d2818174ef);

var $fPMPh = parcelRequire("fPMPh");

var $22pPT = parcelRequire("22pPT");
// node_modules/lit-html/directives/style-map.js
var $1dc29cb5d8458fab$export$23f2a1d2818174ef = (0, $fPMPh.e)(class extends (0, $fPMPh.i) {
    constructor(t2){
        var e2;
        if (super(t2), t2.type !== (0, $fPMPh.t).ATTRIBUTE || "style" !== t2.name || (null === (e2 = t2.strings) || void 0 === e2 ? void 0 : e2.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t2) {
        return Object.keys(t2).reduce((e2, r)=>{
            const s = t2[r];
            return null == s ? e2 : e2 + `${r = r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e2, [r]) {
        const { style: s } = e2.element;
        if (void 0 === this.vt) {
            this.vt = /* @__PURE__ */ new Set();
            for(const t2 in r)this.vt.add(t2);
            return this.render(r);
        }
        this.vt.forEach((t2)=>{
            null == r[t2] && (this.vt.delete(t2), t2.includes("-") ? s.removeProperty(t2) : s[t2] = "");
        });
        for(const t2 in r){
            const e3 = r[t2];
            null != e3 && (this.vt.add(t2), t2.includes("-") ? s.setProperty(t2, e3) : s[t2] = e3);
        }
        return 0, $22pPT.x;
    }
});
 /*! Bundled license information:

lit-html/directives/style-map.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});



parcelRegister("1TMOi", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("g7yRi")).SlSelect);

var $g7yRi = parcelRequire("g7yRi");
parcelRequire("9hQ6x");
parcelRequire("kizuZ");
parcelRequire("lXoUK");
parcelRequire("f0ZAY");
parcelRequire("2g6MT");
parcelRequire("erWPa");
parcelRequire("c3pDw");
parcelRequire("5heAb");
parcelRequire("I1TGB");
parcelRequire("6UXx3");
parcelRequire("k4sxW");
parcelRequire("3cUze");
parcelRequire("6rIOV");
parcelRequire("bV71f");
parcelRequire("9UUPL");
parcelRequire("eIzsp");
parcelRequire("c8fQa");
parcelRequire("aHRmB");
parcelRequire("4Yt64");
parcelRequire("aMmFT");
parcelRequire("99gLn");
parcelRequire("jCb68");
parcelRequire("5xjpF");
parcelRequire("dk295");
parcelRequire("iZtXQ");
parcelRequire("hkKxA");
parcelRequire("6Q7Kl");
parcelRequire("eeMXI");
parcelRequire("gGDeJ");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});
parcelRegister("g7yRi", function(module, exports) {

$parcel$export(module.exports, "SlSelect", () => $bbc856f6576abfbd$export$87fe1b79ce9ed4ba);

var $lXoUK = parcelRequire("lXoUK");

var $f0ZAY = parcelRequire("f0ZAY");

var $5heAb = parcelRequire("5heAb");

var $I1TGB = parcelRequire("I1TGB");

var $3cUze = parcelRequire("3cUze");

var $6rIOV = parcelRequire("6rIOV");

var $bV71f = parcelRequire("bV71f");

var $eIzsp = parcelRequire("eIzsp");

var $4Yt64 = parcelRequire("4Yt64");

var $eeMXI = parcelRequire("eeMXI");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// src/components/select/select.ts
var $bbc856f6576abfbd$export$87fe1b79ce9ed4ba = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $I1TGB.FormControlController)(this, {
            assumeInteractionOn: [
                "sl-blur",
                "sl-input"
            ]
        });
        this.hasSlotController = new (0, $4Yt64.HasSlotController)(this, "help-text", "label");
        this.localize = new (0, $eIzsp.LocalizeController)(this);
        this.typeToSelectString = "";
        this.hasFocus = false;
        this.displayLabel = "";
        this.selectedOptions = [];
        this.name = "";
        this.value = "";
        this.defaultValue = "";
        this.size = "medium";
        this.placeholder = "";
        this.multiple = false;
        this.maxOptionsVisible = 3;
        this.disabled = false;
        this.clearable = false;
        this.open = false;
        this.hoist = false;
        this.filled = false;
        this.pill = false;
        this.label = "";
        this.placement = "bottom";
        this.helpText = "";
        this.form = "";
        this.required = false;
    }
    /** Gets the validity state object */ get validity() {
        return this.valueInput.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.valueInput.validationMessage;
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleDocumentFocusIn = this.handleDocumentFocusIn.bind(this);
        this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
        this.handleDocumentMouseDown = this.handleDocumentMouseDown.bind(this);
        this.open = false;
    }
    addOpenListeners() {
        document.addEventListener("focusin", this.handleDocumentFocusIn);
        document.addEventListener("keydown", this.handleDocumentKeyDown);
        document.addEventListener("mousedown", this.handleDocumentMouseDown);
    }
    removeOpenListeners() {
        document.removeEventListener("focusin", this.handleDocumentFocusIn);
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
        document.removeEventListener("mousedown", this.handleDocumentMouseDown);
    }
    handleFocus() {
        this.hasFocus = true;
        this.displayInput.setSelectionRange(0, 0);
        this.emit("sl-focus");
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleDocumentFocusIn(event) {
        const path = event.composedPath();
        if (this && !path.includes(this)) this.hide();
    }
    handleDocumentKeyDown(event) {
        const target = event.target;
        const isClearButton = target.closest(".select__clear") !== null;
        const isIconButton = target.closest("sl-icon-button") !== null;
        if (isClearButton || isIconButton) return;
        if (event.key === "Escape" && this.open) {
            event.preventDefault();
            event.stopPropagation();
            this.hide();
            this.displayInput.focus({
                preventScroll: true
            });
        }
        if (event.key === "Enter" || event.key === " " && this.typeToSelectString === "") {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!this.open) {
                this.show();
                return;
            }
            if (this.currentOption && !this.currentOption.disabled) {
                if (this.multiple) this.toggleOptionSelection(this.currentOption);
                else this.setSelectedOptions(this.currentOption);
                this.updateComplete.then(()=>{
                    this.emit("sl-input");
                    this.emit("sl-change");
                });
                if (!this.multiple) {
                    this.hide();
                    this.displayInput.focus({
                        preventScroll: true
                    });
                }
            }
            return;
        }
        if ([
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End"
        ].includes(event.key)) {
            const allOptions = this.getAllOptions();
            const currentIndex = allOptions.indexOf(this.currentOption);
            let newIndex = Math.max(0, currentIndex);
            event.preventDefault();
            if (!this.open) {
                this.show();
                if (this.currentOption) return;
            }
            if (event.key === "ArrowDown") {
                newIndex = currentIndex + 1;
                if (newIndex > allOptions.length - 1) newIndex = 0;
            } else if (event.key === "ArrowUp") {
                newIndex = currentIndex - 1;
                if (newIndex < 0) newIndex = allOptions.length - 1;
            } else if (event.key === "Home") newIndex = 0;
            else if (event.key === "End") newIndex = allOptions.length - 1;
            this.setCurrentOption(allOptions[newIndex]);
        }
        if (event.key.length === 1 || event.key === "Backspace") {
            const allOptions = this.getAllOptions();
            if (event.metaKey || event.ctrlKey || event.altKey) return;
            if (!this.open) {
                if (event.key === "Backspace") return;
                this.show();
            }
            event.stopPropagation();
            event.preventDefault();
            clearTimeout(this.typeToSelectTimeout);
            this.typeToSelectTimeout = window.setTimeout(()=>this.typeToSelectString = "", 1e3);
            if (event.key === "Backspace") this.typeToSelectString = this.typeToSelectString.slice(0, -1);
            else this.typeToSelectString += event.key.toLowerCase();
            for (const option of allOptions){
                const label = option.getTextLabel().toLowerCase();
                if (label.startsWith(this.typeToSelectString)) {
                    this.setCurrentOption(option);
                    break;
                }
            }
        }
    }
    handleDocumentMouseDown(event) {
        const path = event.composedPath();
        if (this && !path.includes(this)) this.hide();
    }
    handleLabelClick() {
        this.displayInput.focus();
    }
    handleComboboxMouseDown(event) {
        const path = event.composedPath();
        const isIconButton = path.some((el)=>el instanceof Element && el.tagName.toLowerCase() === "sl-icon-button");
        if (this.disabled || isIconButton) return;
        event.preventDefault();
        this.displayInput.focus({
            preventScroll: true
        });
        this.open = !this.open;
    }
    handleComboboxKeyDown(event) {
        event.stopPropagation();
        this.handleDocumentKeyDown(event);
    }
    handleClearClick(event) {
        event.stopPropagation();
        if (this.value !== "") {
            this.setSelectedOptions([]);
            this.displayInput.focus({
                preventScroll: true
            });
            this.updateComplete.then(()=>{
                this.emit("sl-clear");
                this.emit("sl-input");
                this.emit("sl-change");
            });
        }
    }
    handleClearMouseDown(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    handleOptionClick(event) {
        const target = event.target;
        const option = target.closest("sl-option");
        const oldValue = this.value;
        if (option && !option.disabled) {
            if (this.multiple) this.toggleOptionSelection(option);
            else this.setSelectedOptions(option);
            this.updateComplete.then(()=>this.displayInput.focus({
                    preventScroll: true
                }));
            if (this.value !== oldValue) this.updateComplete.then(()=>{
                this.emit("sl-input");
                this.emit("sl-change");
            });
            if (!this.multiple) {
                this.hide();
                this.displayInput.focus({
                    preventScroll: true
                });
            }
        }
    }
    handleDefaultSlotChange() {
        const allOptions = this.getAllOptions();
        const value = Array.isArray(this.value) ? this.value : [
            this.value
        ];
        const values = [];
        allOptions.forEach((option)=>{
            if (values.includes(option.value)) console.error(`An option with a duplicate value of "${option.value}" has been found in <sl-select>. All options must have unique values.`, option);
            values.push(option.value);
        });
        this.setSelectedOptions(allOptions.filter((el)=>value.includes(el.value)));
    }
    handleTagRemove(event, option) {
        event.stopPropagation();
        if (!this.disabled) {
            this.toggleOptionSelection(option, false);
            this.updateComplete.then(()=>{
                this.emit("sl-input");
                this.emit("sl-change");
            });
        }
    }
    // Gets an array of all <sl-option> elements
    getAllOptions() {
        return [
            ...this.querySelectorAll("sl-option")
        ];
    }
    // Gets the first <sl-option> element
    getFirstOption() {
        return this.querySelector("sl-option");
    }
    // Sets the current option, which is the option the user is currently interacting with (e.g. via keyboard). Only one
    // option may be "current" at a time.
    setCurrentOption(option) {
        const allOptions = this.getAllOptions();
        allOptions.forEach((el)=>{
            el.current = false;
            el.tabIndex = -1;
        });
        if (option) {
            this.currentOption = option;
            option.current = true;
            option.tabIndex = 0;
            option.focus();
        }
    }
    // Sets the selected option(s)
    setSelectedOptions(option) {
        const allOptions = this.getAllOptions();
        const newSelectedOptions = Array.isArray(option) ? option : [
            option
        ];
        allOptions.forEach((el)=>el.selected = false);
        if (newSelectedOptions.length) newSelectedOptions.forEach((el)=>el.selected = true);
        this.selectionChanged();
    }
    // Toggles an option's selected state
    toggleOptionSelection(option, force) {
        if (force === true || force === false) option.selected = force;
        else option.selected = !option.selected;
        this.selectionChanged();
    }
    // This method must be called whenever the selection changes. It will update the selected options cache, the current
    // value, and the display value
    selectionChanged() {
        var _a, _b, _c, _d;
        this.selectedOptions = this.getAllOptions().filter((el)=>el.selected);
        if (this.multiple) {
            this.value = this.selectedOptions.map((el)=>el.value);
            if (this.placeholder && this.value.length === 0) this.displayLabel = "";
            else this.displayLabel = this.localize.term("numOptionsSelected", this.selectedOptions.length);
        } else {
            this.value = (_b = (_a = this.selectedOptions[0]) == null ? void 0 : _a.value) != null ? _b : "";
            this.displayLabel = (_d = (_c = this.selectedOptions[0]) == null ? void 0 : _c.getTextLabel()) != null ? _d : "";
        }
        this.updateComplete.then(()=>{
            this.formControlController.updateValidity();
        });
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleDisabledChange() {
        if (this.disabled) {
            this.open = false;
            this.handleOpenChange();
        }
    }
    handleValueChange() {
        const allOptions = this.getAllOptions();
        const value = Array.isArray(this.value) ? this.value : [
            this.value
        ];
        this.setSelectedOptions(allOptions.filter((el)=>value.includes(el.value)));
    }
    async handleOpenChange() {
        if (this.open && !this.disabled) {
            this.setCurrentOption(this.selectedOptions[0] || this.getFirstOption());
            this.emit("sl-show");
            this.addOpenListeners();
            await (0, $bV71f.stopAnimations)(this);
            this.listbox.hidden = false;
            this.popup.active = true;
            requestAnimationFrame(()=>{
                this.setCurrentOption(this.currentOption);
            });
            const { keyframes: keyframes, options: options } = (0, $3cUze.getAnimation)(this, "select.show", {
                dir: this.localize.dir()
            });
            await (0, $bV71f.animateTo)(this.popup.popup, keyframes, options);
            if (this.currentOption) (0, $f0ZAY.scrollIntoView)(this.currentOption, this.listbox, "vertical", "auto");
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            this.removeOpenListeners();
            await (0, $bV71f.stopAnimations)(this);
            const { keyframes: keyframes, options: options } = (0, $3cUze.getAnimation)(this, "select.hide", {
                dir: this.localize.dir()
            });
            await (0, $bV71f.animateTo)(this.popup.popup, keyframes, options);
            this.listbox.hidden = true;
            this.popup.active = false;
            this.emit("sl-after-hide");
        }
    }
    /** Shows the listbox. */ async show() {
        if (this.open || this.disabled) {
            this.open = false;
            return void 0;
        }
        this.open = true;
        return (0, $6rIOV.waitForEvent)(this, "sl-after-show");
    }
    /** Hides the listbox. */ async hide() {
        if (!this.open || this.disabled) {
            this.open = false;
            return void 0;
        }
        this.open = false;
        return (0, $6rIOV.waitForEvent)(this, "sl-after-hide");
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.valueInput.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.valueInput.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.valueInput.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    /** Sets focus on the control. */ focus(options) {
        this.displayInput.focus(options);
    }
    /** Removes focus from the control. */ blur() {
        this.displayInput.blur();
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        const hasClearIcon = this.clearable && !this.disabled && this.value.length > 0;
        const isPlaceholderVisible = this.placeholder && this.value.length === 0;
        return (0, $22pPT.y)`
      <div
        part="form-control"
        class=${(0, $gGDeJ.o)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          id="label"
          part="form-control-label"
          class="form-control__label"
          aria-hidden=${hasLabel ? "false" : "true"}
          @click=${this.handleLabelClick}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <sl-popup
            class=${(0, $gGDeJ.o)({
            select: true,
            "select--standard": true,
            "select--filled": this.filled,
            "select--pill": this.pill,
            "select--open": this.open,
            "select--disabled": this.disabled,
            "select--multiple": this.multiple,
            "select--focused": this.hasFocus,
            "select--placeholder-visible": isPlaceholderVisible,
            "select--top": this.placement === "top",
            "select--bottom": this.placement === "bottom",
            "select--small": this.size === "small",
            "select--medium": this.size === "medium",
            "select--large": this.size === "large"
        })}
            placement=${this.placement}
            strategy=${this.hoist ? "fixed" : "absolute"}
            flip
            shift
            sync="width"
            auto-size="vertical"
            auto-size-padding="10"
          >
            <div
              part="combobox"
              class="select__combobox"
              slot="anchor"
              @keydown=${this.handleComboboxKeyDown}
              @mousedown=${this.handleComboboxMouseDown}
            >
              <slot part="prefix" name="prefix" class="select__prefix"></slot>

              <input
                part="display-input"
                class="select__display-input"
                type="text"
                placeholder=${this.placeholder}
                .disabled=${this.disabled}
                .value=${this.displayLabel}
                autocomplete="off"
                spellcheck="false"
                autocapitalize="off"
                readonly
                aria-controls="listbox"
                aria-expanded=${this.open ? "true" : "false"}
                aria-haspopup="listbox"
                aria-labelledby="label"
                aria-disabled=${this.disabled ? "true" : "false"}
                aria-describedby="help-text"
                role="combobox"
                tabindex="0"
                @focus=${this.handleFocus}
                @blur=${this.handleBlur}
              />

              ${this.multiple ? (0, $22pPT.y)`
                    <div part="tags" class="select__tags">
                      ${this.selectedOptions.map((option, index)=>{
            if (index < this.maxOptionsVisible || this.maxOptionsVisible <= 0) return (0, $22pPT.y)`
                            <sl-tag
                              part="tag"
                              ?pill=${this.pill}
                              size=${this.size}
                              removable
                              @sl-remove=${(event)=>this.handleTagRemove(event, option)}
                            >
                              ${option.getTextLabel()}
                            </sl-tag>
                          `;
            else if (index === this.maxOptionsVisible) return (0, $22pPT.y)` <sl-tag size=${this.size}> +${this.selectedOptions.length - index} </sl-tag> `;
            else return null;
        })}
                    </div>
                  ` : ""}

              <input
                class="select__value-input"
                type="text"
                ?disabled=${this.disabled}
                ?required=${this.required}
                .value=${Array.isArray(this.value) ? this.value.join(", ") : this.value}
                tabindex="-1"
                aria-hidden="true"
                @focus=${()=>this.focus()}
                @invalid=${this.handleInvalid}
              />

              ${hasClearIcon ? (0, $22pPT.y)`
                    <button
                      part="clear-button"
                      class="select__clear"
                      type="button"
                      aria-label=${this.localize.term("clearEntry")}
                      @mousedown=${this.handleClearMouseDown}
                      @click=${this.handleClearClick}
                      tabindex="-1"
                    >
                      <slot name="clear-icon">
                        <sl-icon name="x-circle-fill" library="system"></sl-icon>
                      </slot>
                    </button>
                  ` : ""}

              <slot name="expand-icon" part="expand-icon" class="select__expand-icon">
                <sl-icon library="system" name="chevron-down"></sl-icon>
              </slot>
            </div>

            <slot
              id="listbox"
              role="listbox"
              aria-expanded=${this.open ? "true" : "false"}
              aria-multiselectable=${this.multiple ? "true" : "false"}
              aria-labelledby="label"
              part="listbox"
              class="select__listbox"
              tabindex="-1"
              @mouseup=${this.handleOptionClick}
              @slotchange=${this.handleDefaultSlotChange}
            ></slot>
          </sl-popup>
        </div>

        <slot
          name="help-text"
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          ${this.helpText}
        </slot>
      </div>
    `;
    }
};
$bbc856f6576abfbd$export$87fe1b79ce9ed4ba.styles = (0, $lXoUK.select_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".select")
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "popup", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".select__combobox")
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "combobox", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".select__display-input")
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "displayInput", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".select__value-input")
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "valueInput", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".select__listbox")
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "listbox", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "hasFocus", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "displayLabel", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "currentOption", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "selectedOptions", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "name", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        converter: {
            fromAttribute: (value)=>value.split(" "),
            toAttribute: (value)=>value.join(" ")
        }
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "value", 2);
(0, $30uP6.__decorateClass)([
    (0, $5heAb.defaultValue)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "defaultValue", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "size", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "placeholder", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "multiple", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "max-options-visible",
        type: Number
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "maxOptionsVisible", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "disabled", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "clearable", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "open", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "hoist", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "filled", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "pill", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "label", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "placement", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "help-text"
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "helpText", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "form", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "required", 2);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("disabled", {
        waitUntilFirstUpdate: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "handleDisabledChange", 1);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("value", {
        waitUntilFirstUpdate: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "handleValueChange", 1);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("open", {
        waitUntilFirstUpdate: true
    })
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba.prototype, "handleOpenChange", 1);
$bbc856f6576abfbd$export$87fe1b79ce9ed4ba = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-select")
], $bbc856f6576abfbd$export$87fe1b79ce9ed4ba);
(0, $3cUze.setDefaultAnimation)("select.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.9
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 100,
        easing: "ease"
    }
});
(0, $3cUze.setDefaultAnimation)("select.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.9
        }
    ],
    options: {
        duration: 100,
        easing: "ease"
    }
});

});
parcelRegister("lXoUK", function(module, exports) {

$parcel$export(module.exports, "select_styles_default", () => $ffc26f1ac684c28b$export$274f1404b977345b);

var $2g6MT = parcelRequire("2g6MT");

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/select/select.styles.ts
var $ffc26f1ac684c28b$export$274f1404b977345b = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}
  ${(0, $2g6MT.form_control_styles_default)}

  :host {
    display: block;
  }

  /** The popup */
  .select {
    flex: 1 1 auto;
    display: inline-flex;
    width: 100%;
    position: relative;
    vertical-align: middle;
  }

  .select::part(popup) {
    z-index: var(--sl-z-index-dropdown);
  }

  .select[data-current-placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .select[data-current-placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  /* Combobox */
  .select__combobox {
    flex: 1;
    display: flex;
    width: 100%;
    min-width: 0;
    position: relative;
    align-items: center;
    justify-content: start;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: pointer;
    transition: var(--sl-transition-fast) color, var(--sl-transition-fast) border, var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  .select__display-input {
    position: relative;
    width: 100%;
    font: inherit;
    border: none;
    background: none;
    color: var(--sl-input-color);
    cursor: inherit;
    overflow: hidden;
    padding: 0;
    margin: 0;
    -webkit-appearance: none;
  }

  .select:not(.select--disabled):hover .select__display-input {
    color: var(--sl-input-color-hover);
  }

  .select__display-input:focus {
    outline: none;
  }

  /* Visually hide the display input when multiple is enabled */
  .select--multiple:not(.select--placeholder-visible) .select__display-input {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .select__value-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    z-index: -1;
  }

  .select__tags {
    display: flex;
    flex: 1;
    align-items: center;
    flex-wrap: wrap;
    margin-inline-start: var(--sl-spacing-2x-small);
  }

  .select__tags::slotted(sl-tag) {
    cursor: pointer !important;
  }

  .select--disabled .select__tags,
  .select--disabled .select__tags::slotted(sl-tag) {
    cursor: not-allowed !important;
  }

  /* Standard selects */
  .select--standard .select__combobox {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .select--standard.select--disabled .select__combobox {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    color: var(--sl-input-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
    outline: none;
  }

  .select--standard:not(.select--disabled).select--open .select__combobox,
  .select--standard:not(.select--disabled).select--focused .select__combobox {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  /* Filled selects */
  .select--filled .select__combobox {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .select--filled:hover:not(.select--disabled) .select__combobox {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .select--filled.select--disabled .select__combobox {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .select--filled:not(.select--disabled).select--open .select__combobox,
  .select--filled:not(.select--disabled).select--focused .select__combobox {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
  }

  /* Sizes */
  .select--small .select__combobox {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    min-height: var(--sl-input-height-small);
    padding-block: 0;
    padding-inline: var(--sl-input-spacing-small);
  }

  .select--small .select__clear {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .select--small .select__prefix::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .select--small.select--multiple:not(.select--placeholder-visible) .select__combobox {
    padding-block: 2px;
    padding-inline-start: 0;
  }

  .select--small .select__tags {
    gap: 2px;
  }

  .select--medium .select__combobox {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    min-height: var(--sl-input-height-medium);
    padding-block: 0;
    padding-inline: var(--sl-input-spacing-medium);
  }

  .select--medium .select__clear {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .select--medium .select__prefix::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .select--medium.select--multiple:not(.select--placeholder-visible) .select__combobox {
    padding-inline-start: 0;
    padding-block: 3px;
  }

  .select--medium .select__tags {
    gap: 3px;
  }

  .select--large .select__combobox {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    min-height: var(--sl-input-height-large);
    padding-block: 0;
    padding-inline: var(--sl-input-spacing-large);
  }

  .select--large .select__clear {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .select--large .select__prefix::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  .select--large.select--multiple:not(.select--placeholder-visible) .select__combobox {
    padding-inline-start: 0;
    padding-block: 4px;
  }

  .select--large .select__tags {
    gap: 4px;
  }

  /* Pills */
  .select--pill.select--small .select__combobox {
    border-radius: var(--sl-input-height-small);
  }

  .select--pill.select--medium .select__combobox {
    border-radius: var(--sl-input-height-medium);
  }

  .select--pill.select--large .select__combobox {
    border-radius: var(--sl-input-height-large);
  }

  /* Prefix */
  .select__prefix {
    flex: 0;
    display: inline-flex;
    align-items: center;
    color: var(--sl-input-placeholder-color);
  }

  /* Clear button */
  .select__clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .select__clear:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .select__clear:focus {
    outline: none;
  }

  /* Expand icon */
  .select__expand-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: var(--sl-transition-medium) rotate ease;
    rotate: 0;
    margin-inline-start: var(--sl-spacing-small);
  }

  .select--open .select__expand-icon {
    rotate: -180deg;
  }

  /* Listbox */
  .select__listbox {
    display: block;
    position: relative;
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    box-shadow: var(--sl-shadow-large);
    background: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    padding-block: var(--sl-spacing-x-small);
    padding-inline: 0;
    overflow: auto;
    overscroll-behavior: none;

    /* Make sure it adheres to the popup's auto size */
    max-width: var(--auto-size-available-width);
    max-height: var(--auto-size-available-height);
  }

  .select__listbox::slotted(sl-divider) {
    --spacing: var(--sl-spacing-x-small);
  }

  .select__listbox::slotted(small) {
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-semibold);
    color: var(--sl-color-neutral-500);
    padding-block: var(--sl-spacing-x-small);
    padding-inline: var(--sl-spacing-x-large);
  }
`;

});
parcelRegister("2g6MT", function(module, exports) {

$parcel$export(module.exports, "form_control_styles_default", () => $1a525746a9d81b50$export$e7c8528c268605e9);

var $22pPT = parcelRequire("22pPT");
// src/styles/form-control.styles.ts
var $1a525746a9d81b50$export$e7c8528c268605e9 = (0, $22pPT.i)`
  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    margin-bottom: var(--sl-spacing-3x-small);
  }

  .form-control--has-label.form-control--small .form-control__label {
    font-size: var(--sl-input-label-font-size-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--sl-input-label-font-size-medium);
  }

  .form-control--has-label.form-control--large .form-control__label {
    font-size: var(--sl-input-label-font-size-large);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    display: block;
    color: var(--sl-input-help-text-color);
    margin-top: var(--sl-spacing-3x-small);
  }

  .form-control--has-help-text.form-control--small .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-small);
  }

  .form-control--has-help-text.form-control--medium .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-medium);
  }

  .form-control--has-help-text.form-control--large .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-large);
  }

  .form-control--has-help-text.form-control--radio-group .form-control__help-text {
    margin-top: var(--sl-spacing-2x-small);
  }
`;

});


parcelRegister("f0ZAY", function(module, exports) {

$parcel$export(module.exports, "scrollIntoView", () => $aee6a2a23436a9d5$export$53a0910f038337bd);
// src/internal/offset.ts
function $aee6a2a23436a9d5$var$getOffset(element, parent) {
    return {
        top: Math.round(element.getBoundingClientRect().top - parent.getBoundingClientRect().top),
        left: Math.round(element.getBoundingClientRect().left - parent.getBoundingClientRect().left)
    };
}
// src/internal/scroll.ts
var $aee6a2a23436a9d5$var$locks = /* @__PURE__ */ new Set();
function $aee6a2a23436a9d5$var$getScrollbarWidth() {
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}
function $aee6a2a23436a9d5$export$5f4bd35c67f2403d(lockingEl) {
    $aee6a2a23436a9d5$var$locks.add(lockingEl);
    if (!document.body.classList.contains("sl-scroll-lock")) {
        const scrollbarWidth = $aee6a2a23436a9d5$var$getScrollbarWidth();
        document.body.classList.add("sl-scroll-lock");
        document.body.style.setProperty("--sl-scroll-lock-size", `${scrollbarWidth}px`);
    }
}
function $aee6a2a23436a9d5$export$7475b4759872c980(lockingEl) {
    $aee6a2a23436a9d5$var$locks.delete(lockingEl);
    if ($aee6a2a23436a9d5$var$locks.size === 0) {
        document.body.classList.remove("sl-scroll-lock");
        document.body.style.removeProperty("--sl-scrollbar-width");
    }
}
function $aee6a2a23436a9d5$export$53a0910f038337bd(element, container, direction = "vertical", behavior = "smooth") {
    const offset = $aee6a2a23436a9d5$var$getOffset(element, container);
    const offsetTop = offset.top + container.scrollTop;
    const offsetLeft = offset.left + container.scrollLeft;
    const minX = container.scrollLeft;
    const maxX = container.scrollLeft + container.offsetWidth;
    const minY = container.scrollTop;
    const maxY = container.scrollTop + container.offsetHeight;
    if (direction === "horizontal" || direction === "both") {
        if (offsetLeft < minX) container.scrollTo({
            left: offsetLeft,
            behavior: behavior
        });
        else if (offsetLeft + element.clientWidth > maxX) container.scrollTo({
            left: offsetLeft - container.offsetWidth + element.clientWidth,
            behavior: behavior
        });
    }
    if (direction === "vertical" || direction === "both") {
        if (offsetTop < minY) container.scrollTo({
            top: offsetTop,
            behavior: behavior
        });
        else if (offsetTop + element.clientHeight > maxY) container.scrollTo({
            top: offsetTop - container.offsetHeight + element.clientHeight,
            behavior: behavior
        });
    }
}

});

parcelRegister("5heAb", function(module, exports) {

$parcel$export(module.exports, "defaultValue", () => $3d79da1121b39a38$export$1a01ae0705bafd37);

var $22pPT = parcelRequire("22pPT");
// src/internal/default-value.ts
var $3d79da1121b39a38$export$1a01ae0705bafd37 = (propertyName = "value")=>(proto, key)=>{
        const ctor = proto.constructor;
        const attributeChangedCallback = ctor.prototype.attributeChangedCallback;
        ctor.prototype.attributeChangedCallback = function(name, old, value) {
            var _a;
            const options = ctor.getPropertyOptions(propertyName);
            const attributeName = typeof options.attribute === "string" ? options.attribute : propertyName;
            if (name === attributeName) {
                const converter = options.converter || (0, $22pPT.n);
                const fromAttribute = typeof converter === "function" ? converter : (_a = converter == null ? void 0 : converter.fromAttribute) != null ? _a : (0, $22pPT.n).fromAttribute;
                const newValue = fromAttribute(value, options.type);
                if (this[propertyName] !== newValue) this[key] = newValue;
            }
            attributeChangedCallback.call(this, name, old, value);
        };
    };

});


parcelRegister("9hQ6x", function(module, exports) {

var $kizuZ = parcelRequire("kizuZ");

var $eIzsp = parcelRequire("eIzsp");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// src/components/tag/tag.ts
var $6c2e1e72106057db$export$357f67db97e5a412 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $eIzsp.LocalizeController)(this);
        this.variant = "neutral";
        this.size = "medium";
        this.pill = false;
        this.removable = false;
    }
    handleRemoveClick() {
        this.emit("sl-remove");
    }
    render() {
        return (0, $22pPT.y)`
      <span
        part="base"
        class=${(0, $gGDeJ.o)({
            tag: true,
            // Types
            "tag--primary": this.variant === "primary",
            "tag--success": this.variant === "success",
            "tag--neutral": this.variant === "neutral",
            "tag--warning": this.variant === "warning",
            "tag--danger": this.variant === "danger",
            "tag--text": this.variant === "text",
            // Sizes
            "tag--small": this.size === "small",
            "tag--medium": this.size === "medium",
            "tag--large": this.size === "large",
            // Modifiers
            "tag--pill": this.pill,
            "tag--removable": this.removable
        })}
      >
        <slot part="content" class="tag__content"></slot>

        ${this.removable ? (0, $22pPT.y)`
              <sl-icon-button
                part="remove-button"
                exportparts="base:remove-button__base"
                name="x-lg"
                library="system"
                label=${this.localize.term("remove")}
                class="tag__remove"
                @click=${this.handleRemoveClick}
                tabindex="-1"
              ></sl-icon-button>
            ` : ""}
      </span>
    `;
    }
};
$6c2e1e72106057db$export$357f67db97e5a412.styles = (0, $kizuZ.tag_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $6c2e1e72106057db$export$357f67db97e5a412.prototype, "variant", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $6c2e1e72106057db$export$357f67db97e5a412.prototype, "size", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $6c2e1e72106057db$export$357f67db97e5a412.prototype, "pill", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean
    })
], $6c2e1e72106057db$export$357f67db97e5a412.prototype, "removable", 2);
$6c2e1e72106057db$export$357f67db97e5a412 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-tag")
], $6c2e1e72106057db$export$357f67db97e5a412);

});
parcelRegister("kizuZ", function(module, exports) {

$parcel$export(module.exports, "tag_styles_default", () => $ec71066688bcab46$export$1e578902aad5c585);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/tag/tag.styles.ts
var $ec71066688bcab46$export$1e578902aad5c585 = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    display: inline-block;
  }

  .tag {
    display: flex;
    align-items: center;
    border: solid 1px;
    line-height: 1;
    white-space: nowrap;
    user-select: none;
  }

  .tag__remove::part(base) {
    color: inherit;
    padding: 0;
  }

  /*
   * Variant modifiers
   */

  .tag--primary {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-200);
    color: var(--sl-color-primary-800);
  }

  .tag--primary:active > sl-icon-button {
    color: var(--sl-color-primary-600);
  }

  .tag--success {
    background-color: var(--sl-color-success-50);
    border-color: var(--sl-color-success-200);
    color: var(--sl-color-success-800);
  }

  .tag--success:active > sl-icon-button {
    color: var(--sl-color-success-600);
  }

  .tag--neutral {
    background-color: var(--sl-color-neutral-50);
    border-color: var(--sl-color-neutral-200);
    color: var(--sl-color-neutral-800);
  }

  .tag--neutral:active > sl-icon-button {
    color: var(--sl-color-neutral-600);
  }

  .tag--warning {
    background-color: var(--sl-color-warning-50);
    border-color: var(--sl-color-warning-200);
    color: var(--sl-color-warning-800);
  }

  .tag--warning:active > sl-icon-button {
    color: var(--sl-color-warning-600);
  }

  .tag--danger {
    background-color: var(--sl-color-danger-50);
    border-color: var(--sl-color-danger-200);
    color: var(--sl-color-danger-800);
  }

  .tag--danger:active > sl-icon-button {
    color: var(--sl-color-danger-600);
  }

  /*
   * Size modifiers
   */

  .tag--small {
    font-size: var(--sl-button-font-size-small);
    height: calc(var(--sl-input-height-small) * 0.8);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
    padding: 0 var(--sl-spacing-x-small);
  }

  .tag--medium {
    font-size: var(--sl-button-font-size-medium);
    height: calc(var(--sl-input-height-medium) * 0.8);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
    padding: 0 var(--sl-spacing-small);
  }

  .tag--large {
    font-size: var(--sl-button-font-size-large);
    height: calc(var(--sl-input-height-large) * 0.8);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
    padding: 0 var(--sl-spacing-medium);
  }

  .tag__remove {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  /*
   * Pill modifier
   */

  .tag--pill {
    border-radius: var(--sl-border-radius-pill);
  }
`;

});


parcelRegister("erWPa", function(module, exports) {

var $c3pDw = parcelRequire("c3pDw");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function $a8513797e840ee0d$var$t(t3) {
    return t3.split("-")[1];
}
function $a8513797e840ee0d$var$e3(t3) {
    return "y" === t3 ? "height" : "width";
}
function $a8513797e840ee0d$var$n(t3) {
    return t3.split("-")[0];
}
function $a8513797e840ee0d$var$o2(t3) {
    return [
        "top",
        "bottom"
    ].includes($a8513797e840ee0d$var$n(t3)) ? "x" : "y";
}
function $a8513797e840ee0d$var$r(r4, i4, a3) {
    let { reference: l3, floating: s3 } = r4;
    const c3 = l3.x + l3.width / 2 - s3.width / 2, f3 = l3.y + l3.height / 2 - s3.height / 2, u3 = $a8513797e840ee0d$var$o2(i4), m3 = $a8513797e840ee0d$var$e3(u3), g3 = l3[m3] / 2 - s3[m3] / 2, d3 = "x" === u3;
    let p3;
    switch($a8513797e840ee0d$var$n(i4)){
        case "top":
            p3 = {
                x: c3,
                y: l3.y - s3.height
            };
            break;
        case "bottom":
            p3 = {
                x: c3,
                y: l3.y + l3.height
            };
            break;
        case "right":
            p3 = {
                x: l3.x + l3.width,
                y: f3
            };
            break;
        case "left":
            p3 = {
                x: l3.x - s3.width,
                y: f3
            };
            break;
        default:
            p3 = {
                x: l3.x,
                y: l3.y
            };
    }
    switch($a8513797e840ee0d$var$t(i4)){
        case "start":
            p3[u3] -= g3 * (a3 && d3 ? -1 : 1);
            break;
        case "end":
            p3[u3] += g3 * (a3 && d3 ? -1 : 1);
    }
    return p3;
}
var $a8513797e840ee0d$var$i2 = async (t3, e4, n3)=>{
    const { placement: o5 = "bottom", strategy: i4 = "absolute", middleware: a3 = [], platform: l3 } = n3, s3 = a3.filter(Boolean), c3 = await (null == l3.isRTL ? void 0 : l3.isRTL(e4));
    let f3 = await l3.getElementRects({
        reference: t3,
        floating: e4,
        strategy: i4
    }), { x: u3, y: m3 } = $a8513797e840ee0d$var$r(f3, o5, c3), g3 = o5, d3 = {}, p3 = 0;
    for(let n4 = 0; n4 < s3.length; n4++){
        const { name: a4, fn: h3 } = s3[n4], { x: y4, y: x3, data: w3, reset: v3 } = await h3({
            x: u3,
            y: m3,
            initialPlacement: o5,
            placement: g3,
            strategy: i4,
            middlewareData: d3,
            rects: f3,
            platform: l3,
            elements: {
                reference: t3,
                floating: e4
            }
        });
        u3 = null != y4 ? y4 : u3, m3 = null != x3 ? x3 : m3, d3 = (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, d3), {
            [a4]: (0, $30uP6.__spreadValues)((0, $30uP6.__spreadValues)({}, d3[a4]), w3)
        }), v3 && p3 <= 50 && (p3++, "object" == typeof v3 && (v3.placement && (g3 = v3.placement), v3.rects && (f3 = true === v3.rects ? await l3.getElementRects({
            reference: t3,
            floating: e4,
            strategy: i4
        }) : v3.rects), { x: u3, y: m3 } = $a8513797e840ee0d$var$r(f3, g3, c3)), n4 = -1);
    }
    return {
        x: u3,
        y: m3,
        placement: g3,
        strategy: i4,
        middlewareData: d3
    };
};
function $a8513797e840ee0d$var$a(t3) {
    return "number" != typeof t3 ? function(t4) {
        return (0, $30uP6.__spreadValues)({
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, t4);
    }(t3) : {
        top: t3,
        right: t3,
        bottom: t3,
        left: t3
    };
}
function $a8513797e840ee0d$var$l(t3) {
    return (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, t3), {
        top: t3.y,
        left: t3.x,
        right: t3.x + t3.width,
        bottom: t3.y + t3.height
    });
}
async function $a8513797e840ee0d$var$s(t3, e4) {
    var n3;
    void 0 === e4 && (e4 = {});
    const { x: o5, y: r4, platform: i4, rects: s3, elements: c3, strategy: f3 } = t3, { boundary: u3 = "clippingAncestors", rootBoundary: m3 = "viewport", elementContext: g3 = "floating", altBoundary: d3 = false, padding: p3 = 0 } = e4, h3 = $a8513797e840ee0d$var$a(p3), y4 = c3[d3 ? "floating" === g3 ? "reference" : "floating" : g3], x3 = $a8513797e840ee0d$var$l(await i4.getClippingRect({
        element: null == (n3 = await (null == i4.isElement ? void 0 : i4.isElement(y4))) || n3 ? y4 : y4.contextElement || await (null == i4.getDocumentElement ? void 0 : i4.getDocumentElement(c3.floating)),
        boundary: u3,
        rootBoundary: m3,
        strategy: f3
    })), w3 = "floating" === g3 ? (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, s3.floating), {
        x: o5,
        y: r4
    }) : s3.reference, v3 = await (null == i4.getOffsetParent ? void 0 : i4.getOffsetParent(c3.floating)), b3 = await (null == i4.isElement ? void 0 : i4.isElement(v3)) && await (null == i4.getScale ? void 0 : i4.getScale(v3)) || {
        x: 1,
        y: 1
    }, R2 = $a8513797e840ee0d$var$l(i4.convertOffsetParentRelativeRectToViewportRelativeRect ? await i4.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w3,
        offsetParent: v3,
        strategy: f3
    }) : w3);
    return {
        top: (x3.top - R2.top + h3.top) / b3.y,
        bottom: (R2.bottom - x3.bottom + h3.bottom) / b3.y,
        left: (x3.left - R2.left + h3.left) / b3.x,
        right: (R2.right - x3.right + h3.right) / b3.x
    };
}
var $a8513797e840ee0d$var$c = Math.min;
var $a8513797e840ee0d$var$f = Math.max;
function $a8513797e840ee0d$var$u(t3, e4, n3) {
    return $a8513797e840ee0d$var$f(t3, $a8513797e840ee0d$var$c(e4, n3));
}
var $a8513797e840ee0d$var$m = (n3)=>({
        name: "arrow",
        options: n3,
        async fn (r4) {
            const { element: i4, padding: l3 = 0 } = n3 || {}, { x: s3, y: c3, placement: f3, rects: m3, platform: g3 } = r4;
            if (null == i4) return {};
            const d3 = $a8513797e840ee0d$var$a(l3), p3 = {
                x: s3,
                y: c3
            }, h3 = $a8513797e840ee0d$var$o2(f3), y4 = $a8513797e840ee0d$var$e3(h3), x3 = await g3.getDimensions(i4), w3 = "y" === h3 ? "top" : "left", v3 = "y" === h3 ? "bottom" : "right", b3 = m3.reference[y4] + m3.reference[h3] - p3[h3] - m3.floating[y4], R2 = p3[h3] - m3.reference[h3], A2 = await (null == g3.getOffsetParent ? void 0 : g3.getOffsetParent(i4));
            let P3 = A2 ? "y" === h3 ? A2.clientHeight || 0 : A2.clientWidth || 0 : 0;
            0 === P3 && (P3 = m3.floating[y4]);
            const T3 = b3 / 2 - R2 / 2, O3 = d3[w3], D3 = P3 - x3[y4] - d3[v3], E3 = P3 / 2 - x3[y4] / 2 + T3, L3 = $a8513797e840ee0d$var$u(O3, E3, D3), k2 = null != $a8513797e840ee0d$var$t(f3) && E3 != L3 && m3.reference[y4] / 2 - (E3 < O3 ? d3[w3] : d3[v3]) - x3[y4] / 2 < 0;
            return {
                [h3]: p3[h3] - (k2 ? E3 < O3 ? O3 - E3 : D3 - E3 : 0),
                data: {
                    [h3]: L3,
                    centerOffset: E3 - L3
                }
            };
        }
    });
var $a8513797e840ee0d$var$g = [
    "top",
    "right",
    "bottom",
    "left"
];
var $a8513797e840ee0d$var$d = $a8513797e840ee0d$var$g.reduce((t3, e4)=>t3.concat(e4, e4 + "-start", e4 + "-end"), []);
var $a8513797e840ee0d$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $a8513797e840ee0d$var$h(t3) {
    return t3.replace(/left|right|bottom|top/g, (t4)=>$a8513797e840ee0d$var$p[t4]);
}
function $a8513797e840ee0d$var$y2(n3, r4, i4) {
    void 0 === i4 && (i4 = false);
    const a3 = $a8513797e840ee0d$var$t(n3), l3 = $a8513797e840ee0d$var$o2(n3), s3 = $a8513797e840ee0d$var$e3(l3);
    let c3 = "x" === l3 ? a3 === (i4 ? "end" : "start") ? "right" : "left" : "start" === a3 ? "bottom" : "top";
    return r4.reference[s3] > r4.floating[s3] && (c3 = $a8513797e840ee0d$var$h(c3)), {
        main: c3,
        cross: $a8513797e840ee0d$var$h(c3)
    };
}
var $a8513797e840ee0d$var$x = {
    start: "end",
    end: "start"
};
function $a8513797e840ee0d$var$w(t3) {
    return t3.replace(/start|end/g, (t4)=>$a8513797e840ee0d$var$x[t4]);
}
var $a8513797e840ee0d$var$b = function(e4) {
    return void 0 === e4 && (e4 = {}), {
        name: "flip",
        options: e4,
        async fn (o5) {
            var r4;
            const { placement: i4, middlewareData: a3, rects: l3, initialPlacement: c3, platform: f3, elements: u3 } = o5, _a = e4, { mainAxis: m3 = true, crossAxis: g3 = true, fallbackPlacements: d3, fallbackStrategy: p3 = "bestFit", fallbackAxisSideDirection: x3 = "none", flipAlignment: v3 = true } = _a, b3 = (0, $30uP6.__objRest)(_a, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]), R2 = $a8513797e840ee0d$var$n(i4), A2 = $a8513797e840ee0d$var$n(c3) === c3, P3 = await (null == f3.isRTL ? void 0 : f3.isRTL(u3.floating)), T3 = d3 || (A2 || !v3 ? [
                $a8513797e840ee0d$var$h(c3)
            ] : function(t3) {
                const e5 = $a8513797e840ee0d$var$h(t3);
                return [
                    $a8513797e840ee0d$var$w(t3),
                    e5,
                    $a8513797e840ee0d$var$w(e5)
                ];
            }(c3));
            d3 || "none" === x3 || T3.push(...function(e5, o6, r5, i5) {
                const a4 = $a8513797e840ee0d$var$t(e5);
                let l4 = function(t3, e6, n3) {
                    const o7 = [
                        "left",
                        "right"
                    ], r6 = [
                        "right",
                        "left"
                    ], i6 = [
                        "top",
                        "bottom"
                    ], a5 = [
                        "bottom",
                        "top"
                    ];
                    switch(t3){
                        case "top":
                        case "bottom":
                            return n3 ? e6 ? r6 : o7 : e6 ? o7 : r6;
                        case "left":
                        case "right":
                            return e6 ? i6 : a5;
                        default:
                            return [];
                    }
                }($a8513797e840ee0d$var$n(e5), "start" === r5, i5);
                return a4 && (l4 = l4.map((t3)=>t3 + "-" + a4), o6 && (l4 = l4.concat(l4.map($a8513797e840ee0d$var$w)))), l4;
            }(c3, v3, x3, P3));
            const O3 = [
                c3,
                ...T3
            ], D3 = await $a8513797e840ee0d$var$s(o5, b3), E3 = [];
            let L3 = (null == (r4 = a3.flip) ? void 0 : r4.overflows) || [];
            if (m3 && E3.push(D3[R2]), g3) {
                const { main: t3, cross: e5 } = $a8513797e840ee0d$var$y2(i4, l3, P3);
                E3.push(D3[t3], D3[e5]);
            }
            if (L3 = [
                ...L3,
                {
                    placement: i4,
                    overflows: E3
                }
            ], !E3.every((t3)=>t3 <= 0)) {
                var k2, B;
                const t3 = ((null == (k2 = a3.flip) ? void 0 : k2.index) || 0) + 1, e5 = O3[t3];
                if (e5) return {
                    data: {
                        index: t3,
                        overflows: L3
                    },
                    reset: {
                        placement: e5
                    }
                };
                let n3 = null == (B = L3.filter((t4)=>t4.overflows[0] <= 0).sort((t4, e6)=>t4.overflows[1] - e6.overflows[1])[0]) ? void 0 : B.placement;
                if (!n3) switch(p3){
                    case "bestFit":
                        {
                            var C2;
                            const t4 = null == (C2 = L3.map((t5)=>[
                                    t5.placement,
                                    t5.overflows.filter((t6)=>t6 > 0).reduce((t6, e6)=>t6 + e6, 0)
                                ]).sort((t5, e6)=>t5[1] - e6[1])[0]) ? void 0 : C2[0];
                            t4 && (n3 = t4);
                            break;
                        }
                    case "initialPlacement":
                        n3 = c3;
                }
                if (i4 !== n3) return {
                    reset: {
                        placement: n3
                    }
                };
            }
            return {};
        }
    };
};
var $a8513797e840ee0d$var$O = function(e4) {
    return void 0 === e4 && (e4 = 0), {
        name: "offset",
        options: e4,
        async fn (r4) {
            const { x: i4, y: a3 } = r4, l3 = await async function(e5, r5) {
                const { placement: i5, platform: a4, elements: l4 } = e5, s3 = await (null == a4.isRTL ? void 0 : a4.isRTL(l4.floating)), c3 = $a8513797e840ee0d$var$n(i5), f3 = $a8513797e840ee0d$var$t(i5), u3 = "x" === $a8513797e840ee0d$var$o2(i5), m3 = [
                    "left",
                    "top"
                ].includes(c3) ? -1 : 1, g3 = s3 && u3 ? -1 : 1, d3 = "function" == typeof r5 ? r5(e5) : r5;
                let { mainAxis: p3, crossAxis: h3, alignmentAxis: y4 } = "number" == typeof d3 ? {
                    mainAxis: d3,
                    crossAxis: 0,
                    alignmentAxis: null
                } : (0, $30uP6.__spreadValues)({
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null
                }, d3);
                return f3 && "number" == typeof y4 && (h3 = "end" === f3 ? -1 * y4 : y4), u3 ? {
                    x: h3 * g3,
                    y: p3 * m3
                } : {
                    x: p3 * m3,
                    y: h3 * g3
                };
            }(r4, e4);
            return {
                x: i4 + l3.x,
                y: a3 + l3.y,
                data: l3
            };
        }
    };
};
function $a8513797e840ee0d$var$D(t3) {
    return "x" === t3 ? "y" : "x";
}
var $a8513797e840ee0d$var$E = function(t3) {
    return void 0 === t3 && (t3 = {}), {
        name: "shift",
        options: t3,
        async fn (e4) {
            const { x: r4, y: i4, placement: a3 } = e4, _a = t3, { mainAxis: l3 = true, crossAxis: c3 = false, limiter: f3 = {
                fn: (t4)=>{
                    let { x: e5, y: n3 } = t4;
                    return {
                        x: e5,
                        y: n3
                    };
                }
            } } = _a, m3 = (0, $30uP6.__objRest)(_a, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]), g3 = {
                x: r4,
                y: i4
            }, d3 = await $a8513797e840ee0d$var$s(e4, m3), p3 = $a8513797e840ee0d$var$o2($a8513797e840ee0d$var$n(a3)), h3 = $a8513797e840ee0d$var$D(p3);
            let y4 = g3[p3], x3 = g3[h3];
            if (l3) {
                const t4 = "y" === p3 ? "bottom" : "right";
                y4 = $a8513797e840ee0d$var$u(y4 + d3["y" === p3 ? "top" : "left"], y4, y4 - d3[t4]);
            }
            if (c3) {
                const t4 = "y" === h3 ? "bottom" : "right";
                x3 = $a8513797e840ee0d$var$u(x3 + d3["y" === h3 ? "top" : "left"], x3, x3 - d3[t4]);
            }
            const w3 = f3.fn((0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, e4), {
                [p3]: y4,
                [h3]: x3
            }));
            return (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, w3), {
                data: {
                    x: w3.x - r4,
                    y: w3.y - i4
                }
            });
        }
    };
};
var $a8513797e840ee0d$var$k = function(e4) {
    return void 0 === e4 && (e4 = {}), {
        name: "size",
        options: e4,
        async fn (r4) {
            const { placement: i4, rects: a3, platform: l3, elements: u3 } = r4, _a = e4, { apply: m3 = ()=>{} } = _a, g3 = (0, $30uP6.__objRest)(_a, [
                "apply"
            ]), d3 = await $a8513797e840ee0d$var$s(r4, g3), p3 = $a8513797e840ee0d$var$n(i4), h3 = $a8513797e840ee0d$var$t(i4), y4 = "x" === $a8513797e840ee0d$var$o2(i4), { width: x3, height: w3 } = a3.floating;
            let v3, b3;
            "top" === p3 || "bottom" === p3 ? (v3 = p3, b3 = h3 === (await (null == l3.isRTL ? void 0 : l3.isRTL(u3.floating)) ? "start" : "end") ? "left" : "right") : (b3 = p3, v3 = "end" === h3 ? "top" : "bottom");
            const R2 = w3 - d3[v3], A2 = x3 - d3[b3];
            let P3 = R2, T3 = A2;
            if (y4 ? T3 = $a8513797e840ee0d$var$c(x3 - d3.right - d3.left, A2) : P3 = $a8513797e840ee0d$var$c(w3 - d3.bottom - d3.top, R2), !r4.middlewareData.shift && !h3) {
                const t3 = $a8513797e840ee0d$var$f(d3.left, 0), e5 = $a8513797e840ee0d$var$f(d3.right, 0), n3 = $a8513797e840ee0d$var$f(d3.top, 0), o5 = $a8513797e840ee0d$var$f(d3.bottom, 0);
                y4 ? T3 = x3 - 2 * (0 !== t3 || 0 !== e5 ? t3 + e5 : $a8513797e840ee0d$var$f(d3.left, d3.right)) : P3 = w3 - 2 * (0 !== n3 || 0 !== o5 ? n3 + o5 : $a8513797e840ee0d$var$f(d3.top, d3.bottom));
            }
            await m3((0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, r4), {
                availableWidth: T3,
                availableHeight: P3
            }));
            const O3 = await l3.getDimensions(u3.floating);
            return x3 !== O3.width || w3 !== O3.height ? {
                reset: {
                    rects: true
                }
            } : {};
        }
    };
};
// node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function $a8513797e840ee0d$var$n2(t3) {
    var e4;
    return (null == (e4 = t3.ownerDocument) ? void 0 : e4.defaultView) || window;
}
function $a8513797e840ee0d$var$o3(t3) {
    return $a8513797e840ee0d$var$n2(t3).getComputedStyle(t3);
}
var $a8513797e840ee0d$var$i3 = Math.min;
var $a8513797e840ee0d$var$r2 = Math.max;
var $a8513797e840ee0d$var$l2 = Math.round;
function $a8513797e840ee0d$var$c2(t3) {
    const e4 = $a8513797e840ee0d$var$o3(t3);
    let n3 = parseFloat(e4.width), i4 = parseFloat(e4.height);
    const r4 = t3.offsetWidth, c3 = t3.offsetHeight, s3 = $a8513797e840ee0d$var$l2(n3) !== r4 || $a8513797e840ee0d$var$l2(i4) !== c3;
    return s3 && (n3 = r4, i4 = c3), {
        width: n3,
        height: i4,
        fallback: s3
    };
}
function $a8513797e840ee0d$var$s2(t3) {
    return $a8513797e840ee0d$var$h2(t3) ? (t3.nodeName || "").toLowerCase() : "";
}
var $a8513797e840ee0d$var$f2;
function $a8513797e840ee0d$var$u2() {
    if ($a8513797e840ee0d$var$f2) return $a8513797e840ee0d$var$f2;
    const t3 = navigator.userAgentData;
    return t3 && Array.isArray(t3.brands) ? ($a8513797e840ee0d$var$f2 = t3.brands.map((t4)=>t4.brand + "/" + t4.version).join(" "), $a8513797e840ee0d$var$f2) : navigator.userAgent;
}
function $a8513797e840ee0d$var$a2(t3) {
    return t3 instanceof $a8513797e840ee0d$var$n2(t3).HTMLElement;
}
function $a8513797e840ee0d$var$d2(t3) {
    return t3 instanceof $a8513797e840ee0d$var$n2(t3).Element;
}
function $a8513797e840ee0d$var$h2(t3) {
    return t3 instanceof $a8513797e840ee0d$var$n2(t3).Node;
}
function $a8513797e840ee0d$var$p2(t3) {
    if ("undefined" == typeof ShadowRoot) return false;
    return t3 instanceof $a8513797e840ee0d$var$n2(t3).ShadowRoot || t3 instanceof ShadowRoot;
}
function $a8513797e840ee0d$var$g2(t3) {
    const { overflow: e4, overflowX: n3, overflowY: i4, display: r4 } = $a8513797e840ee0d$var$o3(t3);
    return /auto|scroll|overlay|hidden|clip/.test(e4 + i4 + n3) && ![
        "inline",
        "contents"
    ].includes(r4);
}
function $a8513797e840ee0d$var$m2(t3) {
    return [
        "table",
        "td",
        "th"
    ].includes($a8513797e840ee0d$var$s2(t3));
}
function $a8513797e840ee0d$var$y3(t3) {
    const e4 = /firefox/i.test($a8513797e840ee0d$var$u2()), n3 = $a8513797e840ee0d$var$o3(t3), i4 = n3.backdropFilter || n3.WebkitBackdropFilter;
    return "none" !== n3.transform || "none" !== n3.perspective || !!i4 && "none" !== i4 || e4 && "filter" === n3.willChange || e4 && !!n3.filter && "none" !== n3.filter || [
        "transform",
        "perspective"
    ].some((t4)=>n3.willChange.includes(t4)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t4)=>{
        const e5 = n3.contain;
        return null != e5 && e5.includes(t4);
    });
}
function $a8513797e840ee0d$var$x2() {
    return /^((?!chrome|android).)*safari/i.test($a8513797e840ee0d$var$u2());
}
function $a8513797e840ee0d$var$w2(t3) {
    return [
        "html",
        "body",
        "#document"
    ].includes($a8513797e840ee0d$var$s2(t3));
}
function $a8513797e840ee0d$var$v2(t3) {
    return $a8513797e840ee0d$var$d2(t3) ? t3 : t3.contextElement;
}
var $a8513797e840ee0d$var$b2 = {
    x: 1,
    y: 1
};
function $a8513797e840ee0d$var$L2(t3) {
    const e4 = $a8513797e840ee0d$var$v2(t3);
    if (!$a8513797e840ee0d$var$a2(e4)) return $a8513797e840ee0d$var$b2;
    const n3 = e4.getBoundingClientRect(), { width: o5, height: i4, fallback: r4 } = $a8513797e840ee0d$var$c2(e4);
    let s3 = (r4 ? $a8513797e840ee0d$var$l2(n3.width) : n3.width) / o5, f3 = (r4 ? $a8513797e840ee0d$var$l2(n3.height) : n3.height) / i4;
    return s3 && Number.isFinite(s3) || (s3 = 1), f3 && Number.isFinite(f3) || (f3 = 1), {
        x: s3,
        y: f3
    };
}
function $a8513797e840ee0d$var$E2(t3, e4, o5, i4) {
    var r4, l3;
    void 0 === e4 && (e4 = false), void 0 === o5 && (o5 = false);
    const c3 = t3.getBoundingClientRect(), s3 = $a8513797e840ee0d$var$v2(t3);
    let f3 = $a8513797e840ee0d$var$b2;
    e4 && (i4 ? $a8513797e840ee0d$var$d2(i4) && (f3 = $a8513797e840ee0d$var$L2(i4)) : f3 = $a8513797e840ee0d$var$L2(t3));
    const u3 = s3 ? $a8513797e840ee0d$var$n2(s3) : window, a3 = $a8513797e840ee0d$var$x2() && o5;
    let h3 = (c3.left + (a3 && (null == (r4 = u3.visualViewport) ? void 0 : r4.offsetLeft) || 0)) / f3.x, p3 = (c3.top + (a3 && (null == (l3 = u3.visualViewport) ? void 0 : l3.offsetTop) || 0)) / f3.y, g3 = c3.width / f3.x, m3 = c3.height / f3.y;
    if (s3) {
        const t4 = $a8513797e840ee0d$var$n2(s3), e5 = i4 && $a8513797e840ee0d$var$d2(i4) ? $a8513797e840ee0d$var$n2(i4) : i4;
        let o6 = t4.frameElement;
        for(; o6 && i4 && e5 !== t4;){
            const t5 = $a8513797e840ee0d$var$L2(o6), e6 = o6.getBoundingClientRect(), i5 = getComputedStyle(o6);
            e6.x += (o6.clientLeft + parseFloat(i5.paddingLeft)) * t5.x, e6.y += (o6.clientTop + parseFloat(i5.paddingTop)) * t5.y, h3 *= t5.x, p3 *= t5.y, g3 *= t5.x, m3 *= t5.y, h3 += e6.x, p3 += e6.y, o6 = $a8513797e840ee0d$var$n2(o6).frameElement;
        }
    }
    return {
        width: g3,
        height: m3,
        top: p3,
        right: h3 + g3,
        bottom: p3 + m3,
        left: h3,
        x: h3,
        y: p3
    };
}
function $a8513797e840ee0d$var$R(t3) {
    return (($a8513797e840ee0d$var$h2(t3) ? t3.ownerDocument : t3.document) || window.document).documentElement;
}
function $a8513797e840ee0d$var$T2(t3) {
    return $a8513797e840ee0d$var$d2(t3) ? {
        scrollLeft: t3.scrollLeft,
        scrollTop: t3.scrollTop
    } : {
        scrollLeft: t3.pageXOffset,
        scrollTop: t3.pageYOffset
    };
}
function $a8513797e840ee0d$var$C(t3) {
    return $a8513797e840ee0d$var$E2($a8513797e840ee0d$var$R(t3)).left + $a8513797e840ee0d$var$T2(t3).scrollLeft;
}
function $a8513797e840ee0d$var$F(t3) {
    if ("html" === $a8513797e840ee0d$var$s2(t3)) return t3;
    const e4 = t3.assignedSlot || t3.parentNode || $a8513797e840ee0d$var$p2(t3) && t3.host || $a8513797e840ee0d$var$R(t3);
    return $a8513797e840ee0d$var$p2(e4) ? e4.host : e4;
}
function $a8513797e840ee0d$var$W(t3) {
    const e4 = $a8513797e840ee0d$var$F(t3);
    return $a8513797e840ee0d$var$w2(e4) ? e4.ownerDocument.body : $a8513797e840ee0d$var$a2(e4) && $a8513797e840ee0d$var$g2(e4) ? e4 : $a8513797e840ee0d$var$W(e4);
}
function $a8513797e840ee0d$var$D2(t3, e4) {
    var o5;
    void 0 === e4 && (e4 = []);
    const i4 = $a8513797e840ee0d$var$W(t3), r4 = i4 === (null == (o5 = t3.ownerDocument) ? void 0 : o5.body), l3 = $a8513797e840ee0d$var$n2(i4);
    return r4 ? e4.concat(l3, l3.visualViewport || [], $a8513797e840ee0d$var$g2(i4) ? i4 : []) : e4.concat(i4, $a8513797e840ee0d$var$D2(i4));
}
function $a8513797e840ee0d$var$S(e4, i4, l3) {
    let c3;
    if ("viewport" === i4) c3 = function(t3, e5) {
        const o5 = $a8513797e840ee0d$var$n2(t3), i5 = $a8513797e840ee0d$var$R(t3), r4 = o5.visualViewport;
        let l4 = i5.clientWidth, c4 = i5.clientHeight, s4 = 0, f4 = 0;
        if (r4) {
            l4 = r4.width, c4 = r4.height;
            const t4 = $a8513797e840ee0d$var$x2();
            (!t4 || t4 && "fixed" === e5) && (s4 = r4.offsetLeft, f4 = r4.offsetTop);
        }
        return {
            width: l4,
            height: c4,
            x: s4,
            y: f4
        };
    }(e4, l3);
    else if ("document" === i4) c3 = function(t3) {
        const e5 = $a8513797e840ee0d$var$R(t3), n3 = $a8513797e840ee0d$var$T2(t3), i5 = t3.ownerDocument.body, l4 = $a8513797e840ee0d$var$r2(e5.scrollWidth, e5.clientWidth, i5.scrollWidth, i5.clientWidth), c4 = $a8513797e840ee0d$var$r2(e5.scrollHeight, e5.clientHeight, i5.scrollHeight, i5.clientHeight);
        let s4 = -n3.scrollLeft + $a8513797e840ee0d$var$C(t3);
        const f4 = -n3.scrollTop;
        return "rtl" === $a8513797e840ee0d$var$o3(i5).direction && (s4 += $a8513797e840ee0d$var$r2(e5.clientWidth, i5.clientWidth) - l4), {
            width: l4,
            height: c4,
            x: s4,
            y: f4
        };
    }($a8513797e840ee0d$var$R(e4));
    else if ($a8513797e840ee0d$var$d2(i4)) c3 = function(t3, e5) {
        const n3 = $a8513797e840ee0d$var$E2(t3, true, "fixed" === e5), o5 = n3.top + t3.clientTop, i5 = n3.left + t3.clientLeft, r4 = $a8513797e840ee0d$var$a2(t3) ? $a8513797e840ee0d$var$L2(t3) : {
            x: 1,
            y: 1
        };
        return {
            width: t3.clientWidth * r4.x,
            height: t3.clientHeight * r4.y,
            x: i5 * r4.x,
            y: o5 * r4.y
        };
    }(i4, l3);
    else {
        const t3 = (0, $30uP6.__spreadValues)({}, i4);
        if ($a8513797e840ee0d$var$x2()) {
            var s3, f3;
            const o5 = $a8513797e840ee0d$var$n2(e4);
            t3.x -= (null == (s3 = o5.visualViewport) ? void 0 : s3.offsetLeft) || 0, t3.y -= (null == (f3 = o5.visualViewport) ? void 0 : f3.offsetTop) || 0;
        }
        c3 = t3;
    }
    return $a8513797e840ee0d$var$l(c3);
}
function $a8513797e840ee0d$var$A(t3, e4) {
    return $a8513797e840ee0d$var$a2(t3) && "fixed" !== $a8513797e840ee0d$var$o3(t3).position ? e4 ? e4(t3) : t3.offsetParent : null;
}
function $a8513797e840ee0d$var$H(t3, e4) {
    const i4 = $a8513797e840ee0d$var$n2(t3);
    let r4 = $a8513797e840ee0d$var$A(t3, e4);
    for(; r4 && $a8513797e840ee0d$var$m2(r4) && "static" === $a8513797e840ee0d$var$o3(r4).position;)r4 = $a8513797e840ee0d$var$A(r4, e4);
    return r4 && ("html" === $a8513797e840ee0d$var$s2(r4) || "body" === $a8513797e840ee0d$var$s2(r4) && "static" === $a8513797e840ee0d$var$o3(r4).position && !$a8513797e840ee0d$var$y3(r4)) ? i4 : r4 || function(t4) {
        let e5 = $a8513797e840ee0d$var$F(t4);
        for(; $a8513797e840ee0d$var$a2(e5) && !$a8513797e840ee0d$var$w2(e5);){
            if ($a8513797e840ee0d$var$y3(e5)) return e5;
            e5 = $a8513797e840ee0d$var$F(e5);
        }
        return null;
    }(t3) || i4;
}
function $a8513797e840ee0d$var$V(t3, e4, n3) {
    const o5 = $a8513797e840ee0d$var$a2(e4), i4 = $a8513797e840ee0d$var$R(e4), r4 = $a8513797e840ee0d$var$E2(t3, true, "fixed" === n3, e4);
    let l3 = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const c3 = {
        x: 0,
        y: 0
    };
    if (o5 || !o5 && "fixed" !== n3) {
        if (("body" !== $a8513797e840ee0d$var$s2(e4) || $a8513797e840ee0d$var$g2(i4)) && (l3 = $a8513797e840ee0d$var$T2(e4)), $a8513797e840ee0d$var$a2(e4)) {
            const t4 = $a8513797e840ee0d$var$E2(e4, true);
            c3.x = t4.x + e4.clientLeft, c3.y = t4.y + e4.clientTop;
        } else i4 && (c3.x = $a8513797e840ee0d$var$C(i4));
    }
    return {
        x: r4.left + l3.scrollLeft - c3.x,
        y: r4.top + l3.scrollTop - c3.y,
        width: r4.width,
        height: r4.height
    };
}
var $a8513797e840ee0d$var$O2 = {
    getClippingRect: function(t3) {
        let { element: e4, boundary: n3, rootBoundary: l3, strategy: c3 } = t3;
        const f3 = "clippingAncestors" === n3 ? function(t4, e5) {
            const n4 = e5.get(t4);
            if (n4) return n4;
            let i4 = $a8513797e840ee0d$var$D2(t4).filter((t5)=>$a8513797e840ee0d$var$d2(t5) && "body" !== $a8513797e840ee0d$var$s2(t5)), r4 = null;
            const l4 = "fixed" === $a8513797e840ee0d$var$o3(t4).position;
            let c4 = l4 ? $a8513797e840ee0d$var$F(t4) : t4;
            for(; $a8513797e840ee0d$var$d2(c4) && !$a8513797e840ee0d$var$w2(c4);){
                const t5 = $a8513797e840ee0d$var$o3(c4), e6 = $a8513797e840ee0d$var$y3(c4);
                "fixed" === t5.position ? r4 = null : (l4 ? e6 || r4 : e6 || "static" !== t5.position || !r4 || ![
                    "absolute",
                    "fixed"
                ].includes(r4.position)) ? r4 = t5 : i4 = i4.filter((t6)=>t6 !== c4), c4 = $a8513797e840ee0d$var$F(c4);
            }
            return e5.set(t4, i4), i4;
        }(e4, this._c) : [].concat(n3), u3 = [
            ...f3,
            l3
        ], a3 = u3[0], h3 = u3.reduce((t4, n4)=>{
            const o5 = $a8513797e840ee0d$var$S(e4, n4, c3);
            return t4.top = $a8513797e840ee0d$var$r2(o5.top, t4.top), t4.right = $a8513797e840ee0d$var$i3(o5.right, t4.right), t4.bottom = $a8513797e840ee0d$var$i3(o5.bottom, t4.bottom), t4.left = $a8513797e840ee0d$var$r2(o5.left, t4.left), t4;
        }, $a8513797e840ee0d$var$S(e4, a3, c3));
        return {
            width: h3.right - h3.left,
            height: h3.bottom - h3.top,
            x: h3.left,
            y: h3.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t3) {
        let { rect: e4, offsetParent: n3, strategy: o5 } = t3;
        const i4 = $a8513797e840ee0d$var$a2(n3), r4 = $a8513797e840ee0d$var$R(n3);
        if (n3 === r4) return e4;
        let l3 = {
            scrollLeft: 0,
            scrollTop: 0
        }, c3 = {
            x: 1,
            y: 1
        };
        const f3 = {
            x: 0,
            y: 0
        };
        if ((i4 || !i4 && "fixed" !== o5) && (("body" !== $a8513797e840ee0d$var$s2(n3) || $a8513797e840ee0d$var$g2(r4)) && (l3 = $a8513797e840ee0d$var$T2(n3)), $a8513797e840ee0d$var$a2(n3))) {
            const t4 = $a8513797e840ee0d$var$E2(n3);
            c3 = $a8513797e840ee0d$var$L2(n3), f3.x = t4.x + n3.clientLeft, f3.y = t4.y + n3.clientTop;
        }
        return {
            width: e4.width * c3.x,
            height: e4.height * c3.y,
            x: e4.x * c3.x - l3.scrollLeft * c3.x + f3.x,
            y: e4.y * c3.y - l3.scrollTop * c3.y + f3.y
        };
    },
    isElement: $a8513797e840ee0d$var$d2,
    getDimensions: function(t3) {
        return $a8513797e840ee0d$var$a2(t3) ? $a8513797e840ee0d$var$c2(t3) : t3.getBoundingClientRect();
    },
    getOffsetParent: $a8513797e840ee0d$var$H,
    getDocumentElement: $a8513797e840ee0d$var$R,
    getScale: $a8513797e840ee0d$var$L2,
    async getElementRects (t3) {
        let { reference: e4, floating: n3, strategy: o5 } = t3;
        const i4 = this.getOffsetParent || $a8513797e840ee0d$var$H, r4 = this.getDimensions;
        return {
            reference: $a8513797e840ee0d$var$V(e4, await i4(n3), o5),
            floating: (0, $30uP6.__spreadValues)({
                x: 0,
                y: 0
            }, await r4(n3))
        };
    },
    getClientRects: (t3)=>Array.from(t3.getClientRects()),
    isRTL: (t3)=>"rtl" === $a8513797e840ee0d$var$o3(t3).direction
};
function $a8513797e840ee0d$var$P2(t3, e4, n3, o5) {
    void 0 === o5 && (o5 = {});
    const { ancestorScroll: i4 = true, ancestorResize: r4 = true, elementResize: l3 = true, animationFrame: c3 = false } = o5, s3 = i4 && !c3, f3 = s3 || r4 ? [
        ...$a8513797e840ee0d$var$d2(t3) ? $a8513797e840ee0d$var$D2(t3) : t3.contextElement ? $a8513797e840ee0d$var$D2(t3.contextElement) : [],
        ...$a8513797e840ee0d$var$D2(e4)
    ] : [];
    f3.forEach((t4)=>{
        s3 && t4.addEventListener("scroll", n3, {
            passive: true
        }), r4 && t4.addEventListener("resize", n3);
    });
    let u3, a3 = null;
    if (l3) {
        let o6 = true;
        a3 = new ResizeObserver(()=>{
            o6 || n3(), o6 = false;
        }), $a8513797e840ee0d$var$d2(t3) && !c3 && a3.observe(t3), $a8513797e840ee0d$var$d2(t3) || !t3.contextElement || c3 || a3.observe(t3.contextElement), a3.observe(e4);
    }
    let h3 = c3 ? $a8513797e840ee0d$var$E2(t3) : null;
    return c3 && function e5() {
        const o6 = $a8513797e840ee0d$var$E2(t3);
        !h3 || o6.x === h3.x && o6.y === h3.y && o6.width === h3.width && o6.height === h3.height || n3();
        h3 = o6, u3 = requestAnimationFrame(e5);
    }(), n3(), ()=>{
        var t4;
        f3.forEach((t5)=>{
            s3 && t5.removeEventListener("scroll", n3), r4 && t5.removeEventListener("resize", n3);
        }), null == (t4 = a3) || t4.disconnect(), a3 = null, c3 && cancelAnimationFrame(u3);
    };
}
var $a8513797e840ee0d$var$z = (t3, n3, o5)=>{
    const i4 = /* @__PURE__ */ new Map(), r4 = (0, $30uP6.__spreadValues)({
        platform: $a8513797e840ee0d$var$O2
    }, o5), l3 = (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, r4.platform), {
        _c: i4
    });
    return $a8513797e840ee0d$var$i2(t3, n3, (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, r4), {
        platform: l3
    }));
};
// node_modules/composed-offset-position/dist/composed-offset-position.browser.min.mjs
function $a8513797e840ee0d$var$t2(t3) {
    return $a8513797e840ee0d$var$r3(t3);
}
function $a8513797e840ee0d$var$o4(t3) {
    return t3.assignedSlot ? t3.assignedSlot : t3.parentNode instanceof ShadowRoot ? t3.parentNode.host : t3.parentNode;
}
function $a8513797e840ee0d$var$r3(t3) {
    for(let e4 = t3; e4; e4 = $a8513797e840ee0d$var$o4(e4))if (e4 instanceof Element && "none" === getComputedStyle(e4).display) return null;
    for(let e4 = $a8513797e840ee0d$var$o4(t3); e4; e4 = $a8513797e840ee0d$var$o4(e4)){
        if (!(e4 instanceof Element)) continue;
        const t4 = getComputedStyle(e4);
        if ("contents" !== t4.display) {
            if ("static" !== t4.position || "none" !== t4.filter) return e4;
            if ("BODY" === e4.tagName) return e4;
        }
    }
    return null;
}
// src/components/popup/popup.ts
var $a8513797e840ee0d$export$6fe469f0a31d1d6e = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.active = false;
        this.placement = "top";
        this.strategy = "absolute";
        this.distance = 0;
        this.skidding = 0;
        this.arrow = false;
        this.arrowPlacement = "anchor";
        this.arrowPadding = 10;
        this.flip = false;
        this.flipFallbackPlacements = "";
        this.flipFallbackStrategy = "best-fit";
        this.flipPadding = 0;
        this.shift = false;
        this.shiftPadding = 0;
        this.autoSizePadding = 0;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.updateComplete;
        this.start();
    }
    disconnectedCallback() {
        this.stop();
    }
    async updated(changedProps) {
        super.updated(changedProps);
        if (changedProps.has("active")) {
            if (this.active) this.start();
            else this.stop();
        }
        if (changedProps.has("anchor")) this.handleAnchorChange();
        if (this.active) {
            await this.updateComplete;
            this.reposition();
        }
    }
    async handleAnchorChange() {
        await this.stop();
        if (this.anchor && typeof this.anchor === "string") {
            const root = this.getRootNode();
            this.anchorEl = root.getElementById(this.anchor);
        } else if (this.anchor instanceof Element) this.anchorEl = this.anchor;
        else this.anchorEl = this.querySelector('[slot="anchor"]');
        if (this.anchorEl instanceof HTMLSlotElement) this.anchorEl = this.anchorEl.assignedElements({
            flatten: true
        })[0];
        if (!this.anchorEl) throw new Error("Invalid anchor element: no anchor could be found using the anchor slot or the anchor attribute.");
        this.start();
    }
    start() {
        if (!this.anchorEl) return;
        this.cleanup = $a8513797e840ee0d$var$P2(this.anchorEl, this.popup, ()=>{
            this.reposition();
        });
    }
    async stop() {
        return new Promise((resolve)=>{
            if (this.cleanup) {
                this.cleanup();
                this.cleanup = void 0;
                this.removeAttribute("data-current-placement");
                this.style.removeProperty("--auto-size-available-width");
                this.style.removeProperty("--auto-size-available-height");
                requestAnimationFrame(()=>resolve());
            } else resolve();
        });
    }
    /** Forces the popup to recalculate and reposition itself. */ reposition() {
        if (!this.active || !this.anchorEl) return;
        const middleware = [
            // The offset middleware goes first
            $a8513797e840ee0d$var$O({
                mainAxis: this.distance,
                crossAxis: this.skidding
            })
        ];
        if (this.sync) middleware.push($a8513797e840ee0d$var$k({
            apply: ({ rects: rects })=>{
                const syncWidth = this.sync === "width" || this.sync === "both";
                const syncHeight = this.sync === "height" || this.sync === "both";
                this.popup.style.width = syncWidth ? `${rects.reference.width}px` : "";
                this.popup.style.height = syncHeight ? `${rects.reference.height}px` : "";
            }
        }));
        else {
            this.popup.style.width = "";
            this.popup.style.height = "";
        }
        if (this.flip) middleware.push($a8513797e840ee0d$var$b({
            boundary: this.flipBoundary,
            // @ts-expect-error - We're converting a string attribute to an array here
            fallbackPlacements: this.flipFallbackPlacements,
            fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
            padding: this.flipPadding
        }));
        if (this.shift) middleware.push($a8513797e840ee0d$var$E({
            boundary: this.shiftBoundary,
            padding: this.shiftPadding
        }));
        if (this.autoSize) middleware.push($a8513797e840ee0d$var$k({
            boundary: this.autoSizeBoundary,
            padding: this.autoSizePadding,
            apply: ({ availableWidth: availableWidth, availableHeight: availableHeight })=>{
                if (this.autoSize === "vertical" || this.autoSize === "both") this.style.setProperty("--auto-size-available-height", `${availableHeight}px`);
                else this.style.removeProperty("--auto-size-available-height");
                if (this.autoSize === "horizontal" || this.autoSize === "both") this.style.setProperty("--auto-size-available-width", `${availableWidth}px`);
                else this.style.removeProperty("--auto-size-available-width");
            }
        }));
        else {
            this.style.removeProperty("--auto-size-available-width");
            this.style.removeProperty("--auto-size-available-height");
        }
        if (this.arrow) middleware.push($a8513797e840ee0d$var$m({
            element: this.arrowEl,
            padding: this.arrowPadding
        }));
        const getOffsetParent = this.strategy === "absolute" ? (element)=>$a8513797e840ee0d$var$O2.getOffsetParent(element, $a8513797e840ee0d$var$t2) : $a8513797e840ee0d$var$O2.getOffsetParent;
        $a8513797e840ee0d$var$z(this.anchorEl, this.popup, {
            placement: this.placement,
            middleware: middleware,
            strategy: this.strategy,
            platform: (0, $30uP6.__spreadProps)((0, $30uP6.__spreadValues)({}, $a8513797e840ee0d$var$O2), {
                getOffsetParent: getOffsetParent
            })
        }).then(({ x: x3, y: y4, middlewareData: middlewareData, placement: placement })=>{
            const isRtl = getComputedStyle(this).direction === "rtl";
            const staticSide = {
                top: "bottom",
                right: "left",
                bottom: "top",
                left: "right"
            }[placement.split("-")[0]];
            this.setAttribute("data-current-placement", placement);
            Object.assign(this.popup.style, {
                left: `${x3}px`,
                top: `${y4}px`
            });
            if (this.arrow) {
                const arrowX = middlewareData.arrow.x;
                const arrowY = middlewareData.arrow.y;
                let top = "";
                let right = "";
                let bottom = "";
                let left = "";
                if (this.arrowPlacement === "start") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    top = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? value : "";
                    left = isRtl ? "" : value;
                } else if (this.arrowPlacement === "end") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? "" : value;
                    left = isRtl ? value : "";
                    bottom = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                } else if (this.arrowPlacement === "center") {
                    left = typeof arrowX === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                    top = typeof arrowY === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                } else {
                    left = typeof arrowX === "number" ? `${arrowX}px` : "";
                    top = typeof arrowY === "number" ? `${arrowY}px` : "";
                }
                Object.assign(this.arrowEl.style, {
                    top: top,
                    right: right,
                    bottom: bottom,
                    left: left,
                    [staticSide]: "calc(var(--arrow-size-diagonal) * -1)"
                });
            }
        });
        this.emit("sl-reposition");
    }
    render() {
        return (0, $22pPT.y)`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <div
        part="popup"
        class=${(0, $gGDeJ.o)({
            popup: true,
            "popup--active": this.active,
            "popup--fixed": this.strategy === "fixed",
            "popup--has-arrow": this.arrow
        })}
      >
        <slot></slot>
        ${this.arrow ? (0, $22pPT.y)`<div part="arrow" class="popup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
    }
};
$a8513797e840ee0d$export$6fe469f0a31d1d6e.styles = (0, $c3pDw.popup_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".popup")
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "popup", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)(".popup__arrow")
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "arrowEl", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "anchor", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "active", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "placement", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "strategy", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Number
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "distance", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Number
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "skidding", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "arrow", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "arrow-placement"
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "arrowPlacement", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "arrow-padding",
        type: Number
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "arrowPadding", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "flip", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "flip-fallback-placements",
        converter: {
            fromAttribute: (value)=>{
                return value.split(" ").map((p3)=>p3.trim()).filter((p3)=>p3 !== "");
            },
            toAttribute: (value)=>{
                return value.join(" ");
            }
        }
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "flipFallbackPlacements", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "flip-fallback-strategy"
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "flipFallbackStrategy", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Object
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "flipBoundary", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "flip-padding",
        type: Number
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "flipPadding", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "shift", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Object
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "shiftBoundary", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "shift-padding",
        type: Number
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "shiftPadding", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "auto-size"
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "autoSize", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "sync", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Object
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "autoSizeBoundary", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        attribute: "auto-size-padding",
        type: Number
    })
], $a8513797e840ee0d$export$6fe469f0a31d1d6e.prototype, "autoSizePadding", 2);
$a8513797e840ee0d$export$6fe469f0a31d1d6e = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-popup")
], $a8513797e840ee0d$export$6fe469f0a31d1d6e);

});
parcelRegister("c3pDw", function(module, exports) {

$parcel$export(module.exports, "popup_styles_default", () => $8c69a6b4d65d4bbd$export$51897b955cb6c203);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/popup/popup.styles.ts
var $8c69a6b4d65d4bbd$export$51897b955cb6c203 = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    --arrow-color: var(--sl-color-neutral-1000);
    --arrow-size: 6px;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);
  }

  .popup--fixed {
    position: fixed;
  }

  .popup:not(.popup--active) {
    display: none;
  }

  .popup__arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: -1;
  }
`;

});



parcelRegister("8KIfg", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("4dgiN")).SlSwitch);

var $4dgiN = parcelRequire("4dgiN");
parcelRequire("dXVGc");
parcelRequire("9pwh4");
parcelRequire("5heAb");
parcelRequire("I1TGB");
parcelRequire("aHRmB");
parcelRequire("eeMXI");
parcelRequire("gGDeJ");
parcelRequire("fPMPh");
parcelRequire("6SxKb");
parcelRequire("hkyWs");
parcelRequire("22pPT");
parcelRequire("30uP6");

});
parcelRegister("4dgiN", function(module, exports) {

$parcel$export(module.exports, "SlSwitch", () => $31150594c5d10219$export$8d28b91bbbe13ef5);

var $dXVGc = parcelRequire("dXVGc");

var $9pwh4 = parcelRequire("9pwh4");

var $5heAb = parcelRequire("5heAb");

var $I1TGB = parcelRequire("I1TGB");

var $aHRmB = parcelRequire("aHRmB");

var $eeMXI = parcelRequire("eeMXI");

var $gGDeJ = parcelRequire("gGDeJ");

var $6SxKb = parcelRequire("6SxKb");

var $22pPT = parcelRequire("22pPT");

var $30uP6 = parcelRequire("30uP6");
// src/components/switch/switch.ts
var $31150594c5d10219$export$8d28b91bbbe13ef5 = class extends (0, $6SxKb.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $I1TGB.FormControlController)(this, {
            value: (control)=>control.checked ? control.value || "on" : void 0,
            defaultValue: (control)=>control.defaultChecked,
            setValue: (control, checked)=>control.checked = checked
        });
        this.hasFocus = false;
        this.title = "";
        this.name = "";
        this.size = "medium";
        this.disabled = false;
        this.checked = false;
        this.defaultChecked = false;
        this.form = "";
        this.required = false;
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleInput() {
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleClick() {
        this.checked = !this.checked;
        this.emit("sl-change");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleKeyDown(event) {
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.checked = false;
            this.emit("sl-change");
            this.emit("sl-input");
        }
        if (event.key === "ArrowRight") {
            event.preventDefault();
            this.checked = true;
            this.emit("sl-change");
            this.emit("sl-input");
        }
    }
    handleCheckedChange() {
        this.input.checked = this.checked;
        this.formControlController.updateValidity();
    }
    handleDisabledChange() {
        this.formControlController.setValidity(true);
    }
    /** Simulates a click on the switch. */ click() {
        this.input.click();
    }
    /** Sets focus on the switch. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the switch. */ blur() {
        this.input.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        return (0, $22pPT.y)`
      <label
        part="base"
        class=${(0, $gGDeJ.o)({
            switch: true,
            "switch--checked": this.checked,
            "switch--disabled": this.disabled,
            "switch--focused": this.hasFocus,
            "switch--small": this.size === "small",
            "switch--medium": this.size === "medium",
            "switch--large": this.size === "large"
        })}
      >
        <input
          class="switch__input"
          type="checkbox"
          title=${this.title}
          name=${this.name}
          value=${(0, $aHRmB.l)(this.value)}
          .checked=${(0, $9pwh4.l)(this.checked)}
          .disabled=${this.disabled}
          .required=${this.required}
          role="switch"
          aria-checked=${this.checked ? "true" : "false"}
          @click=${this.handleClick}
          @input=${this.handleInput}
          @invalid=${this.handleInvalid}
          @blur=${this.handleBlur}
          @focus=${this.handleFocus}
          @keydown=${this.handleKeyDown}
        />

        <span part="control" class="switch__control">
          <span part="thumb" class="switch__thumb"></span>
        </span>

        <slot part="label" class="switch__label"></slot>
      </label>
    `;
    }
};
$31150594c5d10219$export$8d28b91bbbe13ef5.styles = (0, $dXVGc.switch_styles_default);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.i)('input[type="checkbox"]')
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "input", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.t)()
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "hasFocus", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "title", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "name", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)()
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "value", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "size", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "disabled", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "checked", 2);
(0, $30uP6.__decorateClass)([
    (0, $5heAb.defaultValue)("checked")
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "defaultChecked", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        reflect: true
    })
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "form", 2);
(0, $30uP6.__decorateClass)([
    (0, $6SxKb.e2)({
        type: Boolean,
        reflect: true
    })
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "required", 2);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("checked", {
        waitUntilFirstUpdate: true
    })
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "handleCheckedChange", 1);
(0, $30uP6.__decorateClass)([
    (0, $eeMXI.watch)("disabled", {
        waitUntilFirstUpdate: true
    })
], $31150594c5d10219$export$8d28b91bbbe13ef5.prototype, "handleDisabledChange", 1);
$31150594c5d10219$export$8d28b91bbbe13ef5 = (0, $30uP6.__decorateClass)([
    (0, $6SxKb.e)("sl-switch")
], $31150594c5d10219$export$8d28b91bbbe13ef5);

});
parcelRegister("dXVGc", function(module, exports) {

$parcel$export(module.exports, "switch_styles_default", () => $a2ad870c3f7c7b9e$export$14e2900f6ef79e2b);

var $hkyWs = parcelRequire("hkyWs");

var $22pPT = parcelRequire("22pPT");
// src/components/switch/switch.styles.ts
var $a2ad870c3f7c7b9e$export$14e2900f6ef79e2b = (0, $22pPT.i)`
  ${(0, $hkyWs.component_styles_default)}

  :host {
    display: inline-block;
  }

  :host([size='small']) {
    --height: var(--sl-toggle-size-small);
    --thumb-size: calc(var(--sl-toggle-size-small) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-small);
  }

  :host([size='medium']) {
    --height: var(--sl-toggle-size-medium);
    --thumb-size: calc(var(--sl-toggle-size-medium) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-medium);
  }

  :host([size='large']) {
    --height: var(--sl-toggle-size-large);
    --thumb-size: calc(var(--sl-toggle-size-large) + 4px);
    --width: calc(var(--height) * 2);

    font-size: var(--sl-input-font-size-large);
  }

  .switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-family: var(--sl-input-font-family);
    font-size: inherit;
    font-weight: var(--sl-input-font-weight);
    color: var(--sl-input-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .switch__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--width);
    height: var(--height);
    background-color: var(--sl-color-neutral-400);
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    border-radius: var(--height);
    transition: var(--sl-transition-fast) border-color, var(--sl-transition-fast) background-color;
  }

  .switch__control .switch__thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    background-color: var(--sl-color-neutral-0);
    border-radius: 50%;
    border: solid var(--sl-input-border-width) var(--sl-color-neutral-400);
    translate: calc((var(--width) - var(--height)) / -2);
    transition: var(--sl-transition-fast) translate ease, var(--sl-transition-fast) background-color,
      var(--sl-transition-fast) border-color, var(--sl-transition-fast) box-shadow;
  }

  .switch__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  /* Hover */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-400);
  }

  /* Focus */
  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-neutral-400);
    border-color: var(--sl-color-neutral-400);
  }

  .switch:not(.switch--checked):not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Checked */
  .switch--checked .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch--checked .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    translate: calc((var(--width) - var(--height)) / 2);
  }

  /* Checked + hover */
  .switch.switch--checked:not(.switch--disabled) .switch__control:hover {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
  }

  /* Checked + focus */
  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }

  .switch.switch--checked:not(.switch--disabled) .switch__input:focus-visible ~ .switch__control .switch__thumb {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-primary-600);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  /* Disabled */
  .switch--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .switch__label {
    display: inline-block;
    line-height: var(--height);
    margin-inline-start: 0.5em;
    user-select: none;
  }

  :host([required]) .switch__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
  }

  @media (forced-colors: active) {
    .switch.switch--checked:not(.switch--disabled) .switch__control:hover .switch__thumb,
    .switch--checked .switch__control .switch__thumb {
      background-color: ButtonText;
    }
  }
`;

});

parcelRegister("9pwh4", function(module, exports) {

$parcel$export(module.exports, "l", () => $6d9f7be0b98b1cd9$export$882b5998b3b9117c);

var $fPMPh = parcelRequire("fPMPh");

var $22pPT = parcelRequire("22pPT");
// node_modules/lit-html/directive-helpers.js
var { I: $6d9f7be0b98b1cd9$var$l } = (0, $22pPT.L);
var $6d9f7be0b98b1cd9$var$e2 = (o)=>void 0 === o.strings;
var $6d9f7be0b98b1cd9$var$f = {};
var $6d9f7be0b98b1cd9$var$s = (o, l3 = $6d9f7be0b98b1cd9$var$f)=>o._$AH = l3;
// node_modules/lit-html/directives/live.js
var $6d9f7be0b98b1cd9$export$882b5998b3b9117c = (0, $fPMPh.e)(class extends (0, $fPMPh.i) {
    constructor(r){
        if (super(r), r.type !== (0, $fPMPh.t).PROPERTY && r.type !== (0, $fPMPh.t).ATTRIBUTE && r.type !== (0, $fPMPh.t).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!$6d9f7be0b98b1cd9$var$e2(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i2, [t2]) {
        if (t2 === (0, $22pPT.x) || t2 === (0, $22pPT.b)) return t2;
        const o = i2.element, l3 = i2.name;
        if (i2.type === (0, $fPMPh.t).PROPERTY) {
            if (t2 === o[l3]) return 0, $22pPT.x;
        } else if (i2.type === (0, $fPMPh.t).BOOLEAN_ATTRIBUTE) {
            if (!!t2 === o.hasAttribute(l3)) return 0, $22pPT.x;
        } else if (i2.type === (0, $fPMPh.t).ATTRIBUTE && o.getAttribute(l3) === t2 + "") return 0, $22pPT.x;
        return $6d9f7be0b98b1cd9$var$s(i2), t2;
    }
});
 /*! Bundled license information:

lit-html/directive-helpers.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/directives/live.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
});



parcelRegister("aD5U1", function(module, exports) {

$parcel$export(module.exports, "registerIconLibrary", () => (parcelRequire("99gLn")).registerIconLibrary);
parcelRequire("asdmQ");

var $99gLn = parcelRequire("99gLn");
parcelRequire("jCb68");
parcelRequire("hkKxA");
parcelRequire("6Q7Kl");
parcelRequire("30uP6");

});
parcelRegister("asdmQ", function(module, exports) {

});



parcelRegister("9s87d", function(module, exports) {

$parcel$export(module.exports, "SpacerComponent", () => $b866bd971baafa89$export$fb53b73d1ab3527b);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");
class $b866bd971baafa89$export$fb53b73d1ab3527b extends (0, $4TeKW.LitElement) {
}
$b866bd971baafa89$export$fb53b73d1ab3527b = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'spacer-component',
        template () {
            return (0, $4TeKW.html)` <div style="margin-top: 10px;border-bottom: 1px solid #f4f7f9; text-align: left"></div> `;
        }
    })
], $b866bd971baafa89$export$fb53b73d1ab3527b);

});

parcelRegister("3kgi7", function(module, exports) {

$parcel$export(module.exports, "DefaultSpinnerComponent", () => $e6970a622fe4360e$export$8383d5026ebb10ed);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");
class $e6970a622fe4360e$export$8383d5026ebb10ed extends HTMLElement {
}
$e6970a622fe4360e$export$8383d5026ebb10ed = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'spinner-default',
        style: (0, $4TeKW.css)`
    .lds-ellipsis {
      display: inline-block;
      position: relative;
      width: 64px;
      height: 64px;
    }
    .lds-ellipsis div {
      position: absolute;
      top: 27px;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background: #fff;
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
      left: 6px;
      animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
      left: 6px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
      left: 26px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
      left: 45px;
      animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }
    @keyframes lds-ellipsis3 {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(0);
      }
    }
    @keyframes lds-ellipsis2 {
      0% {
        transform: translate(0, 0);
      }
      100% {
        transform: translate(19px, 0);
      }
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    `;
        }
    })
], $e6970a622fe4360e$export$8383d5026ebb10ed);

});

parcelRegister("2PwCZ", function(module, exports) {

$parcel$export(module.exports, "SvgRepoComponent", () => $c70333bddaea5410$export$d2202bc52a5ac576);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");
class $c70333bddaea5410$export$d2202bc52a5ac576 extends (0, $4TeKW.LitElement) {
    load(detail) {
        this.dispatchEvent(new CustomEvent('load', {
            detail: detail
        }));
    }
    constructor(...args){
        super(...args), this.width = 30, this.height = 30;
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $c70333bddaea5410$export$d2202bc52a5ac576.prototype, "src", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $c70333bddaea5410$export$d2202bc52a5ac576.prototype, "width", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)()
], $c70333bddaea5410$export$d2202bc52a5ac576.prototype, "height", void 0);
$c70333bddaea5410$export$d2202bc52a5ac576 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'svg-repo',
        template () {
            const src = `https://www.svgrepo.com/download/${this.src}.svg`;
            return (0, $4TeKW.html)` <img part="image" src=${src} width=${this.width} height=${this.height} @load=${this.load} /> `;
        }
    })
], $c70333bddaea5410$export$d2202bc52a5ac576);

});

parcelRegister("eb1lT", function(module, exports) {

$parcel$export(module.exports, "TableComponent", () => $14b2e450e9bb5a10$export$73903224e3a9e478);
/* eslint-disable lit/binding-positions */ 
var $deWeK = parcelRequire("deWeK");

var $2O1GU = parcelRequire("2O1GU");

var $4TeKW = parcelRequire("4TeKW");
const $14b2e450e9bb5a10$var$Arrow = (0, $4TeKW.svg)`<svg width="16" height="16" viewBox="0 0 16 16" class="MuiTableSortLabel-icon MuiTableSortLabel-iconDirectionAsc"><path fill="currentColor" d="M11 7H5l3-4z"></path></svg>`;
const $14b2e450e9bb5a10$var$DoubleArrow = (0, $4TeKW.svg)`<svg width="16" height="16" viewBox="0 0 16 16" class="jss572"><path fill="currentColor" d="M11 7H5l3-4zM5 9h6l-3 4z"></path></svg>`;
class $14b2e450e9bb5a10$export$73903224e3a9e478 extends (0, $4TeKW.LitElement) {
    OnUpdateFirst() {
        this.state = {
            titles: this.setDefaultLabels()
        };
    }
    setDefaultLabels() {
        return this.headers.reduce((prev, curr)=>{
            prev[curr.title] = {
                sort: 'none'
            };
            return prev;
        }, {});
    }
    onHeaderColumnClicked(header) {
        const currentLabel = {
            sort: this.state.titles[header.title].sort === 'asc' ? 'desc' : 'asc'
        };
        this.state.titles = this.setDefaultLabels();
        this.state.titles[header.title] = currentLabel;
        this.columnClicked({
            title: header.title,
            sort: currentLabel.sort,
            template: header.template
        });
        this.setState(this.state);
    }
    columnClicked(detail) {
        this.dispatchEvent(new CustomEvent('columnClicked', {
            detail: detail
        }));
    }
    setState(state) {
        this.state = (0, $2O1GU.deepCopy)(state);
    }
    getState() {
        return this.state;
    }
    nextPage() {
        if ((this.pageIndex + 1) * this.pageSize < this.rows.length) this.pageIndex++;
    }
    prevPage() {
        if (this.pageIndex > 0) this.pageIndex--;
    }
    constructor(...args){
        super(...args), this.caption = '', this.headers = [], this.rows = [
            []
        ], this.pageIndex = 0, this.state = {};
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "caption", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "disableHeader", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "pointerOnHover", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "autosort", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "headers", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "rows", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "pageSize", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Number
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "pageIndex", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Object
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478.prototype, "state", void 0);
$14b2e450e9bb5a10$export$73903224e3a9e478 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'rx-datatable',
        style: (0, $4TeKW.css)`
    :host() {
      display: block;

      --neutral200: #f7f5f9;
      --neutral300: #ece9f1;

      --accent600: #248da1;
    }

    caption {
      font-weight: 600;
      margin-bottom: 1rem;
      font-style: normal;
      text-align: left;
    }

    table {
      border-collapse: collapse;
      width: 100%;
      font-size: 0.8rem;
    }

    th {
      font-weight: 500;
      background: var(--neutral200, #fbfbfb);
      color: var(--accent600, #75777a);
    }

    th > .table-header-container {
      justify-content: space-between;
      display: flex;
    }

    svg {
      width: 1rem;
    }

    th,
    td {
      border-bottom: 1px solid var(--neutral300, #f4f4f4);
      border-top: 1px solid var(--neutral300, #f4f4f4);
      border-collapse: collapse;
      padding: 1rem;
      text-align: left;
    }

    .relative {
      position: relative;
    }

    .hover {
      user-select: none;
    }

    .hover:hover {
      color: #359ec0;
      cursor: pointer;
    }

    .rotateUp {
      transform: rotate(0deg);
    }

    .rotateDown {
      transform: rotate(180deg);
    }

    .sorting-arrows {
      transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    .pagination {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 10px;
      gap: 10px;
    }

    .pagination-btn {
      padding: 5px 10px;
      cursor: pointer;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 4px;
    }

    .pagination-btn:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <style>
        .row:hover {
          background: whitesmoke;
          cursor: ${this.pointerOnHover ? 'pointer' : 'auto'};
        }
      </style>
      <table>
        ${this.caption ? (0, $4TeKW.html)`
              <caption>
                ${this.caption}
              </caption>
            ` : ''}
        ${this.disableHeader ? '' : (0, $4TeKW.html)`
              <thead>
                <tr>
                  ${this.headers.map((header, index)=>(0, $4TeKW.html)`
                        <th class="hover" @click=${()=>this.onHeaderColumnClicked(header)} scope="col" key=${index}>
                          <div style="display: flex">
                            <div>${header?.template || header?.title}</div>
                            <div class="relative">
                              ${header.title ? (0, $4TeKW.html)`
                                    ${this.state?.titles?.[header.title].sort === 'none' ? $14b2e450e9bb5a10$var$DoubleArrow : (0, $4TeKW.html)` <div
                                          class=${(0, $4TeKW.classMap)({
                    'sorting-arrows': true,
                    rotateUp: this.state?.titles?.[header?.title].sort === 'asc',
                    rotateDown: this.state?.titles?.[header?.title].sort === 'desc'
                })}
                                        >
                                          ${$14b2e450e9bb5a10$var$Arrow}
                                        </div>`}
                                  ` : (0, $4TeKW.html)``}
                            </div>
                          </div>
                        </th>
                      `)}
                </tr>
              </thead>
            `}
        <tbody>
          ${(this.pageSize ? this.rows.slice(this.pageIndex * this.pageSize, (this.pageIndex + 1) * this.pageSize) : this.rows).map((row, index)=>(0, $4TeKW.html)`
              <tr
                @click=${()=>{
                    row['index'] = index;
                    this.dispatchEvent(new CustomEvent('rowClicked', {
                        detail: row
                    }));
                }}
                class="row"
                key=${index}
              >
                ${row.map((cell, index)=>(0, $4TeKW.html)` <td part="td" key=${index}>${cell}</td> `)}
              </tr>
            `)}
        </tbody>
      </table>
      ${this.pageSize ? (0, $4TeKW.html)`
            <div class="pagination">
              <button @click=${()=>this.prevPage()} ?disabled=${this.pageIndex === 0} class="pagination-btn">
                Prev
              </button>
              <span> Page ${this.pageIndex + 1} of ${Math.ceil(this.rows.length / this.pageSize)} </span>
              <button
                @click=${()=>this.nextPage()}
                ?disabled=${(this.pageIndex + 1) * this.pageSize >= this.rows.length}
                class="pagination-btn"
              >
                Next
              </button>
            </div>
          ` : ''}
    `;
        }
    })
], $14b2e450e9bb5a10$export$73903224e3a9e478);

});

parcelRegister("5LvTH", function(module, exports) {

$parcel$export(module.exports, "TabsComponent", () => $3b8847598e7cf353$export$fb3aab15d866de8f);
/* eslint-disable lit/binding-positions */ 
var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");
class $3b8847598e7cf353$export$fb3aab15d866de8f extends (0, $4TeKW.LitElement) {
    toggleMenu(menu) {
        menu.active = !menu.active;
        this.menus = [
            ...this.menus
        ];
    }
    constructor(...args){
        super(...args), this.menus = [], this.bgColor = '#fff';
    }
}
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $3b8847598e7cf353$export$fb3aab15d866de8f.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Array
    })
], $3b8847598e7cf353$export$fb3aab15d866de8f.prototype, "menus", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: String
    })
], $3b8847598e7cf353$export$fb3aab15d866de8f.prototype, "bgColor", void 0);
$3b8847598e7cf353$export$fb3aab15d866de8f = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'tabs-component',
        style: (0, $4TeKW.css)`
    li.list-items {
      background-color: transparent;
      width: 100%;
      font-size: 13px;
      font-weight: bold;
      list-style: none;
      user-select: none;
    }

    li:hover a {
      color: black;
      /* background-color: var(--primary-bg-color); */

      background-color: var(--tabs-menu-hover-color, rgba(255, 255, 255, 1));
    }
    li a {
      padding: 14px 20px 13px 16px;
      line-height: 20px;
      height: 22px;
      text-decoration: none;
      display: block;
    }

    a.arrow {
      transform: rotate(180deg);
    }
    ul {
      margin: 0px;
      padding-left: 0px;
      border-bottom: 1px solid #e8e8e8;
      user-select: none;
    }

    li.list-items-inactive {
      background-color: #fff;

      color: #868f91;
      list-style: none;
    }
    li.list-items:hover {
      cursor: pointer;
      color: #868f91;
    }
    li.list-items-inactive:hover {
      color: black;
      cursor: pointer;
    }
    .active {
      color: black;
      cursor: pointer;
    }
    .flex {
      display: flex;
    }
    .spacer {
      flex: 1 3 auto;
    }
    .container {
      box-shadow: rgb(0 0 0 / 8%) 0px 14px 28px, rgb(0 0 0 / 8%) 0px 10px 10px;
    }

    .arrow-container {
      transition: transform 70ms cubic-bezier(0.2, 0, 0.38, 0.9) 0s,
        -webkit-transform 70ms cubic-bezier(0.2, 0, 0.38, 0.9) 0s;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <div class="container" style=${(0, $4TeKW.styleMap)({
                background: this.bgColor
            })}>
        <!-- ${!this.menus.length ? (0, $4TeKW.html)`
              <ul style="width: 10.5em;">
                <li class="list-items">
                  <div class="flex">
                    <a class="spacer"></a>
                    <div style="margin-top: 8px;">
                      <rx-spinner></rx-spinner>
                    </div>
                    <a class="spacer"></a>
                  </div>
                </li>
              </ul>
            ` : (0, $4TeKW.html)``} -->
        ${this.menus.map((menu)=>(0, $4TeKW.html)`
            <span @click=${()=>menu.link && this.router.go(menu.link)}>
              <ul @click=${()=>this.toggleMenu(menu)}>
                <li class="list-items">
                  <div class="flex">
                    <div><a>${menu.title}</a></div>
                    <a class="spacer"></a>
                    <div>
                      ${menu.ruler ? (0, $4TeKW.html)`
                            <a
                              ><div
                                class="arrow-container"
                                style=${(0, $4TeKW.styleMap)({
                    transform: menu.active ? 'rotate(45deg)' : 'rotate(0deg)'
                })}
                              >
                                ${(0, $4TeKW.svg)`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><!----><path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"></path></svg>`}
                              </div></a
                            >
                          ` : ''}
                    </div>
                  </div>
                </li>
              </ul>

              ${menu.active ? (0, $4TeKW.html)`
                    ${menu.sub ? menu.sub.filter((i)=>!!i).map((subMenu)=>(0, $4TeKW.html)`
                              <ul>
                                <li
                                  @click=${()=>subMenu.link && this.router.go(subMenu.link)}
                                  class=${(0, $4TeKW.classMap)({
                        'list-items-inactive': true,
                        active: subMenu.active
                    })}
                                >
                                  <a style="font-size: 13px;"
                                    ><div style="display: flex">
                                      ${subMenu.icon ? subMenu.icon : (0, $4TeKW.html)``}
                                      <div style="width:10px;">&nbsp;</div>
                                      <div>${subMenu.title}</div>
                                    </div></a
                                  >
                                </li>
                              </ul>
                            `) : ''}
                  ` : ''}
            </span>
          `)}
      </div>
    `;
        }
    })
], $3b8847598e7cf353$export$fb3aab15d866de8f);

});

parcelRegister("3PK7V", function(module, exports) {

$parcel$export(module.exports, "TailWindComponent", () => $46b67ec840c98446$export$53741275fa0105ab);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");
class $46b67ec840c98446$export$53741275fa0105ab extends HTMLElement {
}
$46b67ec840c98446$export$53741275fa0105ab = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'inject-tailwind',
        template: ()=>(0, $4TeKW.html)` <link href="https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css" rel="stylesheet" /> `
    })
], $46b67ec840c98446$export$53741275fa0105ab);

});

parcelRegister("imRSa", function(module, exports) {

$parcel$export(module.exports, "WebCli", () => $fba20dc446992855$export$9013ff80b82cf8b9);
/* eslint-disable lit/binding-positions */ /* eslint-disable prettier/prettier */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $4TeKW = parcelRequire("4TeKW");
class $fba20dc446992855$export$9013ff80b82cf8b9 extends (0, $4TeKW.LitElement) {
    static get styles() {
        return (0, $4TeKW.css)`
      :host {
        --web-cli-text-color: #f0f0f0;
        --web-cli-bg-color: #333;
        --web-cli-font-family: monospace;
        --web-cli-radius: 3px;
        color: var(--web-cli-text-color);
        background-color: var(--web-cli-text-color);
        font-family: var(--web-cli-font-family), monospace;
        font-size: 13px;
        display: block;
        padding: 0.5em;
      }
      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .console-output {
        height: 15em;
        overflow-y: auto;
        word-break: break-all;
        white-space: pre-wrap;
        background-color: var(--web-cli-bg-color);
        border-radius: var(--web-cli-radius);
      }
      .input-form {
        position: relative;
        display: flex;
        align-items: center;
        padding: 0;
        margin: 0;
        margin-top: 0.5em;
        flex-wrap: nowrap;
      }
      input,
      button {
        font-family: inherit;
        font-size: inherit;
      }
      .control {
        display: flex;
        align-items: center;
        flex-grow: 1;
        margin-right: 0.5em;
        background-color: var(--web-cli-bg-color);
        box-shadow: 0 4px 8px rgba(10, 10, 10, 0.15);
        padding: 0;
        border-radius: var(--web-cli-radius);
      }
      .prompt {
        display: block;
        padding: 4px;
        padding-right: calc(0.5em - 4px);
        color: #999;
      }
      input {
        flex-grow: 1;
        border: 0;
        padding: 4px;
        margin: 0;
        color: inherit;
        background-color: transparent;
      }
      button {
        box-shadow: inset 0px 1px 0px 0px #ffffff;
        background: linear-gradient(to bottom, #ededed 5%, #dfdfdf 100%);
        background-color: #ffffff;
        border-radius: var(--web-cli-radius);
        border: 1px solid #dbdbdb;
        display: inline-block;
        color: #666666;
        padding: 3px 10px;
        text-decoration: none;
        text-shadow: 0px 1px 0px #ffffff;
      }
      button:hover {
        background: linear-gradient(to bottom, #dfdfdf 5%, #ededed 100%);
        background-color: #f6f6f6;
      }
      button:active {
        transform: translateY(1px);
      }
      .line {
        padding: 0 0.5em;
        line-height: 1.2;
      }
      .line:first-child {
        padding-top: 0.5em;
      }
      .line:last-child {
        padding-bottom: 0.5em;
      }
      .line.in {
        color: #999;
      }
      @media (max-width: 540px) {
        .input-form {
          flex-wrap: wrap;
        }
        .control {
          margin-right: 0;
          margin-bottom: 0.5em;
        }
        button {
          width: 100%;
        }
      }
    `;
    }
    static get properties() {
        return {
            prompt: {
                type: String
            },
            lines: {
                type: Array
            },
            savedInput: {
                type: String
            },
            commands: {
                type: Array
            },
            commandIndex: {
                type: Number
            }
        };
    }
    constructor(){
        super();
        this.prompt = '>';
        this.lines = [];
        this.savedInput = '';
        this.commands = [];
        this.commandIndex = -1;
    }
    updated(changedProps) {
        super.updated(changedProps);
        if (changedProps.has('lines')) {
            const $output = this.shadowRoot.getElementById('stdout');
            $output.scrollTop = $output.scrollHeight;
        }
    }
    __onKeydown(event) {
        if (!this.commands.length) return;
        const $input = this.shadowRoot.getElementById('stdin');
        if (event.key === 'ArrowUp') {
            if (this.commandIndex === -1) this.savedInput = $input.value;
            this.commandIndex += 1;
        } else if (event.key === 'ArrowDown') this.commandIndex -= 1;
        else return;
        event.preventDefault();
        this.commandIndex = Math.min(this.commandIndex, this.commands.length - 1);
        this.commandIndex = Math.max(this.commandIndex, -1);
        if (this.commandIndex === -1) $input.value = this.savedInput;
        else $input.value = this.commands[this.commandIndex];
    }
    __onSubmit(event) {
        event.preventDefault();
        const $input = this.shadowRoot.getElementById('stdin');
        const value = $input.value.trim();
        if (value) {
            const line = {
                isInput: true,
                text: `${this.prompt} ${value}`
            };
            this.lines = this.lines.concat([
                line
            ]);
            $input.value = '';
            $input.focus();
            this.commands = [
                value
            ].concat(this.commands);
            this.savedInput = '';
            this.commandIndex = -1;
            this.dispatchEvent(new CustomEvent('cli-input', {
                detail: value
            }));
        }
    }
    addLine(line = '') {
        this.lines = this.lines.concat([
            {
                isInput: false,
                text: line
            }
        ]);
    }
    render() {
        return (0, $4TeKW.html)`
      <div class="console">
        <div part="console" id="stdout" class="console-output">
          ${this.lines.map((line)=>(0, $4TeKW.html)`<div class="line ${line.isInput ? 'in' : ''}">${line.text}</div>`)}
        </div>
        <form
          class="input-form"
          autocomplete="off"
          @submit="${this.__onSubmit}"
        >
          <!-- <div class="control">
      <label for="stdin" class="prompt">${this.prompt}</label>
      <input id="stdin" @keydown="${this.__onKeydown}" />
     </div> -->
          <!-- <button type="submit">⏎</button> -->
        </form>
      </div>
    `;
    }
}
customElements.define('iot-terminal', $fba20dc446992855$export$9013ff80b82cf8b9);

});

parcelRegister("hU4FT", function(module, exports) {

$parcel$export(module.exports, "InputToggleComponent", () => $73317f3761b910f2$export$9bf3c39391c454ad);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $f18Kf = parcelRequire("f18Kf");
class $73317f3761b910f2$export$9bf3c39391c454ad extends (0, $4TeKW.LitElement) {
    OnUpdate() {
        if (this.input) this.input.checked = this.checked;
    }
    OnChange() {
        this.dispatchEvent(new CustomEvent('toggled', {
            detail: this.input
        }));
    }
}
(0, $deWeK.__decorate)([
    (0, $4TeKW.query)('input')
], $73317f3761b910f2$export$9bf3c39391c454ad.prototype, "input", void 0);
(0, $deWeK.__decorate)([
    (0, $4TeKW.property)({
        type: Boolean
    })
], $73317f3761b910f2$export$9bf3c39391c454ad.prototype, "checked", void 0);
$73317f3761b910f2$export$9bf3c39391c454ad = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'input-toggle',
        style: (0, $f18Kf.InputStyle),
        template () {
            return (0, $4TeKW.html)`
      <label class="rx-switch">
        <input
          @change=${(e)=>{
                e.preventDefault();
                this.OnChange();
            }}
          type="checkbox"
        />
        <span class="rx-slider"></span>
      </label>
    `;
        }
    })
], $73317f3761b910f2$export$9bf3c39391c454ad);

});


parcelRegister("1tJTL", function(module, exports) {

$parcel$export(module.exports, "AppComponent", () => $81ae97aeab3a4ea1$export$1eefa63ea41131fe);

var $deWeK = parcelRequire("deWeK");
parcelRequire("5YwZE");
var $7HQg9 = parcelRequire("7HQg9");

var $fG5CU = parcelRequire("fG5CU");

var $jG5LR = parcelRequire("jG5LR");

var $1t8Wn = parcelRequire("1t8Wn");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");

var $89nwV = parcelRequire("89nwV");

var $cDzby = parcelRequire("cDzby");

var $1MQ4j = parcelRequire("1MQ4j");

var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");
var $d5Aat = parcelRequire("d5Aat");

var $2nhTq = parcelRequire("2nhTq");

var $7lFX5 = parcelRequire("7lFX5");
class $81ae97aeab3a4ea1$export$1eefa63ea41131fe extends (0, $4TeKW.LitElement) {
    OnUpdateFirst() {
        this.socialService.isLoggedIn.pipe((0, $6Rz6W.filter)((isLoggedIn)=>!!isLoggedIn), (0, $6Rz6W.filter)(()=>!!localStorage.getItem('redirectUrl')), (0, $d5Aat.take)(1)).subscribe(()=>{
            this.router.go(localStorage.getItem('redirectUrl'));
            localStorage.removeItem('redirectUrl');
        });
        setTimeout(()=>{
            const loader = document.querySelector('#loader');
            loader?.remove();
        }, 0);
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $89nwV.Nav))
], $81ae97aeab3a4ea1$export$1eefa63ea41131fe.prototype, "nav", void 0);
(0, $deWeK.__decorate)([
    (0, $8kgMp.Router)()
], $81ae97aeab3a4ea1$export$1eefa63ea41131fe.prototype, "router", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $cDzby.SocialService))
], $81ae97aeab3a4ea1$export$1eefa63ea41131fe.prototype, "socialService", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $7HQg9.GlobalProjectsMenuService))
], $81ae97aeab3a4ea1$export$1eefa63ea41131fe.prototype, "globalProjectsMenu", void 0);
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Inject)((0, $fG5CU.NavbarItemsProvider))
], $81ae97aeab3a4ea1$export$1eefa63ea41131fe.prototype, "navbarItemsProvider", void 0);
$81ae97aeab3a4ea1$export$1eefa63ea41131fe = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'app-component',
        modifiers: [
            ...(0, $jG5LR.AngularLayout)
        ],
        style: (0, $4TeKW.css)`
    navbar-component {
      position: fixed;
      top: 0px;
      background: var(--global-background, '#24292f');
      width: 100%;
      z-index: 11;
    }
    .container {
      transition: 0.5s;
      width: 100%;
    }

    .sidebar {
      width: 100px;
    }
    .sidebar-button {
      padding: 5px;
      text-align: left;
      cursor: pointer;
      user-select: none;
      text-align: center;
      border-top: 1px solid rgba(255, 255, 255, 0.2);
    }
    .sidebar-button:hover {
      background: white;
      color: black;
    }
    @media (min-width: 1280px) {
      .sidebar {
        width: 150px;
      }

      .sidebar-button:hover {
        background: rgba(255, 255, 255, 0.5);
      }
    }
    .flex {
      display: flex;
    }

    @media (max-width: 740px) {
      .flex {
        display: block;
      }

      .menus {
        margin-bottom: 30px;
      }
    }

    .menus {
      color: black;
    }
  `,
        template () {
            return (0, $4TeKW.html)`
      <div
        style=${(0, $4TeKW.styleMap)({
                //  'min-height': `${window.innerHeight}px`,
                'margin-top': '66px'
            })}
      >
        <div class="container">
          <navbar-component slot="header"></navbar-component>
          <div class="flex ">
            ${(0, $4TeKW.async)(this.navbarItemsProvider.getMenus().pipe((0, $gawXH.map)((menus)=>(0, $4TeKW.html)`
                    <div class="menus">
                      <tabs-component
                        .bgColor=${'#f8fcff'}
                        .menus=${menus.map((menu)=>({
                        ...menu,
                        active: true
                    }))}
                      ></tabs-component>
                    </div>
                  `)))}

            <div style="width: 100%;">
              <router-outlet
                @onRouterLoaded=${(e)=>{
                this.router.onSnapshotChange().subscribe(()=>{
                    if (window.location.href.includes('/projects/')) this.globalProjectsMenu.openMenu();
                    else this.globalProjectsMenu.closeMenu();
                    this.navbarItemsProvider.setMenus([]);
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                });
            }}
              >
              </router-outlet>
            </div>
          </div>

          <footer-component slot="footer"></footer-component>
        </div>
        <div ngIf=${(0, $7lFX5.isDevelopment)()}>
          <a
            @click=${async ()=>{
                const el = document.createElement('input');
                const user = $1MQ4j.auth().currentUser;
                el.value = JSON.stringify({
                    Authorization: await user.getIdToken()
                });
                this.shadowRoot.appendChild(el);
                await this.requestUpdate();
                el.select();
                document.execCommand('copy');
                this.shadowRoot.removeChild(el);
                (0, $2nhTq.success)(`CLI Token copied to clipboard`);
            }}
            style="position: fixed; left: 0; bottom: 0; background-color: green; padding: 10px; cursor: pointer; z-index: 10000"
          >
            Copy Token
          </a>
        </div>
      </div>
    `;
        }
    })
], $81ae97aeab3a4ea1$export$1eefa63ea41131fe);

});
parcelRegister("5YwZE", function(module, exports) {
$parcel$export(module.exports, "GlobalProjectsMenuService", () => (parcelRequire("7HQg9")).GlobalProjectsMenuService);
parcelRequire("7HQg9");

});

parcelRegister("jG5LR", function(module, exports) {
"use strict";
var $e5366a889befd3c1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e5366a889befd3c1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e5366a889befd3c1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e5366a889befd3c1$var$__exportStar((parcelRequire("1VxcP")), module.exports);

$e5366a889befd3c1$var$__exportStar((parcelRequire("byB9q")), module.exports);

$e5366a889befd3c1$var$__exportStar((parcelRequire("g7H1r")), module.exports);

});
parcelRegister("1VxcP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AngularLayout = void 0;

var $csQRl = parcelRequire("csQRl");

var $kqcse = parcelRequire("kqcse");

var $7P6dv = parcelRequire("7P6dv");
module.exports.AngularLayout = [
    $kqcse.Registry,
    $csQRl.IfOperator,
    $7P6dv.RouterLink
];

});
parcelRegister("csQRl", function(module, exports) {
"use strict";
var $91311a5669874ab0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IfOperator = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $91311a5669874ab0$var$IfOperator = class IfOperator extends $5kDLo.Attribute {
    OnInit() {
        this.modify();
    }
    OnDestroy() {
        this.element.style.display = null;
    }
    OnUpdate() {
        this.modify();
    }
    modify() {
        if (!this.value || this.value === 'undefined' || this.value === '0' || this.value === 'null' || this.value === 'false') this.setStyles({
            display: 'none'
        })(this.element);
        else this.setStyles({
            display: null
        })(this.element);
    }
};
module.exports.IfOperator = $91311a5669874ab0$var$IfOperator;
module.exports.IfOperator = $91311a5669874ab0$var$IfOperator = $91311a5669874ab0$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'ngIf'
    })
], $91311a5669874ab0$var$IfOperator);

});

parcelRegister("kqcse", function(module, exports) {
"use strict";
var $eddfe585d3899c27$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Registry = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $eddfe585d3899c27$var$Registry = class Registry extends $5kDLo.Attribute {
};
module.exports.Registry = $eddfe585d3899c27$var$Registry;
module.exports.Registry = $eddfe585d3899c27$var$Registry = $eddfe585d3899c27$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'angular-layout-registry',
        registry () {
            return new $5kDLo.CustomAttributeRegistry(this);
        }
    })
], $eddfe585d3899c27$var$Registry);

});

parcelRegister("7P6dv", function(module, exports) {
"use strict";
var $5b221e5c18134a6f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5b221e5c18134a6f$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getQueryParams = module.exports.stringify = module.exports.RouterLink = void 0;

var $5kDLo = parcelRequire("5kDLo");

var $bgT5G = parcelRequire("bgT5G");
/**
 * @customAttribute routerLink
 */ let $5b221e5c18134a6f$var$RouterLink = class RouterLink extends $5kDLo.Attribute {
    onClick() {
        const { pathname: pathname, search: search, hash: hash } = this.getFullRoute();
        window.dispatchEvent(new CustomEvent(`router-go`, {
            cancelable: true,
            detail: {
                pathname: pathname,
                search: search || '',
                hash: hash || ''
            }
        }));
    }
    get queryParams() {
        return this.element.getAttribute('queryParams');
    }
    get hasParams() {
        return this.element.hasAttribute('queryParams');
    }
    getFullRoute() {
        if (this.hasParams) {
            const params = new URLSearchParams(this.parseParams());
            return this.getUrl([
                this.value,
                '?',
                params.toString()
            ].join(''));
        }
        return this.getUrl(this.value);
    }
    getUrl(path) {
        return new URL(path, 'http://a');
    }
    parseParams() {
        var _a;
        return JSON.parse((_a = this.queryParams) !== null && _a !== void 0 ? _a : '{}');
    }
};
module.exports.RouterLink = $5b221e5c18134a6f$var$RouterLink;
$5b221e5c18134a6f$var$__decorate([
    (0, $bgT5G.HostListener)('click'),
    $5b221e5c18134a6f$var$__metadata("design:type", Function),
    $5b221e5c18134a6f$var$__metadata("design:paramtypes", []),
    $5b221e5c18134a6f$var$__metadata("design:returntype", void 0)
], $5b221e5c18134a6f$var$RouterLink.prototype, "onClick", null);
module.exports.RouterLink = $5b221e5c18134a6f$var$RouterLink = $5b221e5c18134a6f$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'routerLink'
    })
], $5b221e5c18134a6f$var$RouterLink);
/**
 * Method helper for stringifying data so we can pass it to `queryParams` attribute
 * Without helper: `<div routerLink=${'/projects'} queryParams='{"tracingId": 123}'>CLICK</div>`
 * With helper: `<div routerLink=${'/projects'} queryParams=${stringify({ tracingId: 123 })}>CLICK</div>`
 */ const $5b221e5c18134a6f$var$stringify = (data)=>JSON.stringify(data);
module.exports.stringify = $5b221e5c18134a6f$var$stringify;
/**
 * Additionally for extracting query parameters we could use this method directly from the router @rhtml/router itself
 * const params = this.router.getQueryParams<{ tracingId: string }>();
 * console.log(params.tracingId);
 */ const $5b221e5c18134a6f$var$getQueryParams = ()=>[
        ...new URLSearchParams(location.search)
    ].reduce((prev, [key, value])=>Object.assign(Object.assign({}, prev), {
            [key]: value
        }), {});
module.exports.getQueryParams = $5b221e5c18134a6f$var$getQueryParams;

});
parcelRegister("bgT5G", function(module, exports) {
"use strict";
var $834bec2fb2af7a83$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $834bec2fb2af7a83$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $834bec2fb2af7a83$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$834bec2fb2af7a83$var$__exportStar((parcelRequire("89tTh")), module.exports);

$834bec2fb2af7a83$var$__exportStar((parcelRequire("j7oYi")), module.exports);

});
parcelRegister("89tTh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostListener = void 0;
const $5ef659a00872383b$var$HostListener = (event)=>(target, key, propertyDescriptor)=>{
        const [type, eventName] = event.split(':');
        const wrapper = function(...args) {
            return propertyDescriptor.value.apply(this, args);
        };
        const OnInit = target['OnInit'] || function() {
        /*  */ };
        const OnDestroy = target['OnDestroy'] || function() {
        /*  */ };
        Object.defineProperty(target, 'OnInit', {
            value: function(...args) {
                var _a;
                const element = type === 'window' ? window : (_a = this.element) !== null && _a !== void 0 ? _a : this;
                const e = type === 'window' ? eventName : event;
                element.addEventListener(e, (...args)=>wrapper.apply(this, args));
                return OnInit.apply(this, args);
            },
            configurable: true,
            writable: true
        });
        Object.defineProperty(target, 'OnDestroy', {
            value: function(...args) {
                var _a;
                const element = type === 'window' ? window : (_a = this.element) !== null && _a !== void 0 ? _a : this;
                const e = type === 'window' ? eventName : event;
                element.removeEventListener(e, (...args)=>wrapper.apply(this, args));
                return OnDestroy.apply(this, args);
            },
            configurable: true,
            writable: true
        });
        return {
            get: ()=>wrapper
        };
    };
module.exports.HostListener = $5ef659a00872383b$var$HostListener;

});

parcelRegister("j7oYi", function(module, exports) {
"use strict";
// type Class = 'class';
// type Style = 'style';
// type Type = Style | Class;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HostBinding = void 0;
// type Styles = keyof CSSStyleDeclaration;
// type Binding<T = Type> = T extends Style ? `${T}.${Styles}` : `${Class}.${string}`;
const $deb20a98b1862457$var$HostBinding = (binding /* Binding<T> */ )=>(target, memberName)=>{
        const [type, key] = binding.split('.');
        const OnInit = target['OnInit'] || function() {
        /*  */ };
        const apply = (value)=>(element)=>{
                if (type === 'style') {
                    if (!value) element.style[key] = null;
                    else element.style[key] = value;
                }
                if (type === 'class') {
                    if (!value) element.classList.remove(key);
                    else element.classList.add(key);
                }
            };
        Object.defineProperty(target, 'OnInit', {
            value: function(...args) {
                var _a;
                let currentValue = this[memberName];
                const element = (_a = this.element) !== null && _a !== void 0 ? _a : this;
                Object.defineProperty(target, memberName, {
                    get: function() {
                        return currentValue;
                    },
                    set: function(value) {
                        apply(value)(element);
                        currentValue = value;
                    },
                    configurable: true
                });
                if (currentValue) apply(currentValue)(element);
                return OnInit.apply(this, args);
            },
            configurable: true,
            writable: true
        });
    };
module.exports.HostBinding = $deb20a98b1862457$var$HostBinding;

});




parcelRegister("byB9q", function(module, exports) {
"use strict";
var $869fb01ebc7208bb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $869fb01ebc7208bb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $869fb01ebc7208bb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexLayout = void 0;

var $b8Srx = parcelRequire("b8Srx");

var $awV78 = parcelRequire("awV78");

var $gxUvX = parcelRequire("gxUvX");

var $dKhHI = parcelRequire("dKhHI");

var $1ntJ3 = parcelRequire("1ntJ3");


var $9N9LI = parcelRequire("9N9LI");

var $1bTSn = parcelRequire("1bTSn");

var $hFJwM = parcelRequire("hFJwM");

$869fb01ebc7208bb$var$__exportStar((parcelRequire("kWgCa")), module.exports);
module.exports.FlexLayout = [
    $hFJwM.Registry,
    (parcelRequire("kWgCa")).Layout,
    $9N9LI.LayoutAlign,
    $1bTSn.LayoutGap,
    $gxUvX.FlexFill,
    $b8Srx.Flex,
    $awV78.FlexAlign,
    $dKhHI.FlexOffset,
    $1ntJ3.FlexOrder
];

});
parcelRegister("b8Srx", function(module, exports) {
"use strict";
var $81caac55aca49149$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Flex = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $81caac55aca49149$var$Flex = class Flex extends $5kDLo.MediaQueryAttribute {
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        this.setStyles({
            boxSizing: null,
            maxWidth: null,
            flex: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            boxSizing: 'border-box',
            maxWidth: this.value || null,
            flex: '1 1 100%'
        })(this.element);
    }
};
module.exports.Flex = $81caac55aca49149$var$Flex;
module.exports.Flex = $81caac55aca49149$var$Flex = $81caac55aca49149$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'fxFlex'
    })
], $81caac55aca49149$var$Flex);

});

parcelRegister("awV78", function(module, exports) {
"use strict";
var $7aa93233d3131590$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexAlign = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $7aa93233d3131590$var$FlexAlign = class FlexAlign extends $5kDLo.MediaQueryAttribute {
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        this.setStyles({
            alignSelf: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            alignSelf: this.value || null
        })(this.element);
    }
};
module.exports.FlexAlign = $7aa93233d3131590$var$FlexAlign;
module.exports.FlexAlign = $7aa93233d3131590$var$FlexAlign = $7aa93233d3131590$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'fxFlexAlign'
    })
], $7aa93233d3131590$var$FlexAlign);

});

parcelRegister("gxUvX", function(module, exports) {
"use strict";
var $c0bb9100e059d78b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexFill = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $c0bb9100e059d78b$var$FlexFill = class FlexFill extends $5kDLo.Attribute {
    constructor(){
        super(...arguments);
        this.value = '100%';
    }
    OnInit() {
        this.modify();
    }
    OnDestroy() {
        this.clean();
    }
    OnUpdate() {
        this.modify();
    }
    clean() {
        this.setStyles({
            height: null,
            margin: null,
            minHeight: null,
            minWidth: null,
            width: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            margin: '0',
            height: this.value,
            minHeight: this.value,
            minWidth: this.value,
            width: this.value
        })(this.element);
    }
};
module.exports.FlexFill = $c0bb9100e059d78b$var$FlexFill;
module.exports.FlexFill = $c0bb9100e059d78b$var$FlexFill = $c0bb9100e059d78b$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'fxFlexFill'
    })
], $c0bb9100e059d78b$var$FlexFill);

});

parcelRegister("dKhHI", function(module, exports) {
"use strict";
var $a01d4dea7d002f8c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexOffset = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $a01d4dea7d002f8c$var$FlexOffset = class FlexOffset extends $5kDLo.Attribute {
    OnInit() {
        this.modify();
    }
    OnDestroy() {
        this.clean();
    }
    OnUpdate() {
        this.modify();
    }
    clean() {
        this.setStyles({
            marginLeft: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            marginLeft: this.value || null
        })(this.element);
    }
};
module.exports.FlexOffset = $a01d4dea7d002f8c$var$FlexOffset;
module.exports.FlexOffset = $a01d4dea7d002f8c$var$FlexOffset = $a01d4dea7d002f8c$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'fxFlexOffset'
    })
], $a01d4dea7d002f8c$var$FlexOffset);

});

parcelRegister("1ntJ3", function(module, exports) {
"use strict";
var $100eff5692e30b99$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlexOrder = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $100eff5692e30b99$var$FlexOrder = class FlexOrder extends $5kDLo.Attribute {
    OnInit() {
        this.modify();
    }
    OnDestroy() {
        this.clean();
    }
    OnUpdate() {
        this.modify();
    }
    clean() {
        this.setStyles({
            order: null
        })(this.element);
    }
    modify() {
        this.setStyles({
            order: this.value || null
        })(this.element);
    }
};
module.exports.FlexOrder = $100eff5692e30b99$var$FlexOrder;
module.exports.FlexOrder = $100eff5692e30b99$var$FlexOrder = $100eff5692e30b99$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'fxFlexOrder'
    })
], $100eff5692e30b99$var$FlexOrder);

});

parcelRegister("kWgCa", function(module, exports) {
"use strict";
var $f3e61cbd17e8d6ec$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Layout = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $f3e61cbd17e8d6ec$var$Layout = class Layout extends $5kDLo.MediaQueryAttribute {
    constructor(){
        super(...arguments);
        this.value = 'row';
    }
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        this.setStyles({
            boxSizing: null,
            flexFlow: null,
            display: null
        })(this.element);
    }
    modify() {
        if (!this.value) return;
        this.element.setAttribute(this.selector, this.value);
        const splitted = this.value.split(' ');
        const [mainAxis, crossAxis] = splitted;
        this.setStyles({
            boxSizing: 'flex',
            flexFlow: splitted.length > 1 ? `${mainAxis} ${crossAxis}` : mainAxis,
            display: 'flex'
        })(this.element);
    }
};
module.exports.Layout = $f3e61cbd17e8d6ec$var$Layout;
module.exports.Layout = $f3e61cbd17e8d6ec$var$Layout = $f3e61cbd17e8d6ec$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'fxLayout'
    })
], $f3e61cbd17e8d6ec$var$Layout);

});

parcelRegister("9N9LI", function(module, exports) {
"use strict";
var $721044825bfef344$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LayoutAlign = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $721044825bfef344$var$LayoutAlign = class LayoutAlign extends $5kDLo.MediaQueryAttribute {
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        this.setStyles({
            alignItems: null,
            placeContent: null,
            display: null
        })(this.element);
    }
    modify() {
        const [mainAxis, crossAxis] = this.value.split(' ');
        this.setStyles({
            alignItems: crossAxis ? crossAxis : mainAxis,
            placeContent: crossAxis ? `${crossAxis} ${mainAxis}` : `${mainAxis} ${mainAxis}`,
            display: 'flex'
        })(this.element);
    }
};
module.exports.LayoutAlign = $721044825bfef344$var$LayoutAlign;
module.exports.LayoutAlign = $721044825bfef344$var$LayoutAlign = $721044825bfef344$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'fxLayoutAlign'
    })
], $721044825bfef344$var$LayoutAlign);

});

parcelRegister("1bTSn", function(module, exports) {
"use strict";
var $0de22953959d3f11$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LayoutGap = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $0de22953959d3f11$var$LayoutGap = class LayoutGap extends $5kDLo.MediaQueryAttribute {
    OnInit() {
        this.modify();
        super.OnInit();
    }
    OnDestroy() {
        this.clean();
        super.OnDestroy();
    }
    OnUpdate() {
        this.modify();
    }
    OnChange() {
        this.modify();
    }
    OnEnterMediaQuery([, attribute]) {
        var _a;
        this.prevValue = this.value;
        this.value = (_a = attribute.value) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    OnExitMediaQuery() {
        var _a;
        this.value = (_a = this.prevValue) !== null && _a !== void 0 ? _a : this.value;
        this.modify();
    }
    clean() {
        const divs = [
            ...this.element.children
        ];
        for (const div of divs)this.setStyles({
            flex: null,
            margin: null
        })(div);
    }
    modify() {
        const layout = this.element.getAttribute('fxlayout');
        const isRow = layout === 'row';
        const isColumn = layout === 'column';
        let margin = [
            this.value
        ];
        if (isRow) margin = [
            0,
            this.value,
            0,
            0
        ];
        if (isColumn) margin = [
            0,
            0,
            this.value,
            0
        ];
        const divs = this.element.children;
        for (const div of divs)this.setStyles({
            flex: '1 1 25%',
            margin: margin.join(' ')
        })(div);
        const lastElement = this.element.children[this.element.children.length - 1];
        if (lastElement && isRow) this.setStyles({
            margin: null
        })(lastElement);
    }
};
module.exports.LayoutGap = $0de22953959d3f11$var$LayoutGap;
module.exports.LayoutGap = $0de22953959d3f11$var$LayoutGap = $0de22953959d3f11$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'fxLayoutGap',
        observe: {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: (0, $5kDLo.createFiltersFromSelector)('fxlayout')
        }
    })
], $0de22953959d3f11$var$LayoutGap);

});

parcelRegister("hFJwM", function(module, exports) {
"use strict";
var $cdd994e0577d93bc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Registry = void 0;

var $5kDLo = parcelRequire("5kDLo");
let $cdd994e0577d93bc$var$Registry = class Registry extends $5kDLo.Attribute {
};
module.exports.Registry = $cdd994e0577d93bc$var$Registry;
module.exports.Registry = $cdd994e0577d93bc$var$Registry = $cdd994e0577d93bc$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'flex-layout-registry',
        registry () {
            return new $5kDLo.CustomAttributeRegistry(this);
        }
    })
], $cdd994e0577d93bc$var$Registry);

});


parcelRegister("g7H1r", function(module, exports) {
"use strict";
var $bbceac1e65804e16$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bbceac1e65804e16$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bbceac1e65804e16$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bbceac1e65804e16$var$__exportStar((parcelRequire("6Njj8")), module.exports);

$bbceac1e65804e16$var$__exportStar((parcelRequire("jaff6")), module.exports);

$bbceac1e65804e16$var$__exportStar((parcelRequire("hZjBw")), module.exports);

});
parcelRegister("6Njj8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Animations = void 0;
module.exports.Animations = `
@charset "UTF-8";

/*!
 * animate.css -https://daneden.github.io/animate.css/
 * Version - 3.7.2
 * Licensed under the MIT license - http://opensource.org/licenses/MIT
 *
 * Copyright (c) 2019 Daniel Eden
 */

@-webkit-keyframes bounce {
	0%,
	20%,
	53%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	40%,
	43% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -30px, 0);
		transform: translate3d(0, -30px, 0)
	}
	70% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -15px, 0);
		transform: translate3d(0, -15px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -4px, 0);
		transform: translate3d(0, -4px, 0)
	}
}

@keyframes bounce {
	0%,
	20%,
	53%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	40%,
	43% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -30px, 0);
		transform: translate3d(0, -30px, 0)
	}
	70% {
		-webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		animation-timing-function: cubic-bezier(.755, .05, .855, .06);
		-webkit-transform: translate3d(0, -15px, 0);
		transform: translate3d(0, -15px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -4px, 0);
		transform: translate3d(0, -4px, 0)
	}
}

.bounce {
	-webkit-animation-name: bounce;
	animation-name: bounce;
	-webkit-transform-origin: center bottom;
	transform-origin: center bottom
}

@-webkit-keyframes flash {
	0%,
	50%,
	to {
		opacity: 1
	}
	25%,
	75% {
		opacity: 0
	}
}

@keyframes flash {
	0%,
	50%,
	to {
		opacity: 1
	}
	25%,
	75% {
		opacity: 0
	}
}

.flash {
	-webkit-animation-name: flash;
	animation-name: flash
}

@-webkit-keyframes pulse {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes pulse {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	50% {
		-webkit-transform: scale3d(1.05, 1.05, 1.05);
		transform: scale3d(1.05, 1.05, 1.05)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.pulse {
	-webkit-animation-name: pulse;
	animation-name: pulse
}

@-webkit-keyframes rubberBand {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	30% {
		-webkit-transform: scale3d(1.25, .75, 1);
		transform: scale3d(1.25, .75, 1)
	}
	40% {
		-webkit-transform: scale3d(.75, 1.25, 1);
		transform: scale3d(.75, 1.25, 1)
	}
	50% {
		-webkit-transform: scale3d(1.15, .85, 1);
		transform: scale3d(1.15, .85, 1)
	}
	65% {
		-webkit-transform: scale3d(.95, 1.05, 1);
		transform: scale3d(.95, 1.05, 1)
	}
	75% {
		-webkit-transform: scale3d(1.05, .95, 1);
		transform: scale3d(1.05, .95, 1)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes rubberBand {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	30% {
		-webkit-transform: scale3d(1.25, .75, 1);
		transform: scale3d(1.25, .75, 1)
	}
	40% {
		-webkit-transform: scale3d(.75, 1.25, 1);
		transform: scale3d(.75, 1.25, 1)
	}
	50% {
		-webkit-transform: scale3d(1.15, .85, 1);
		transform: scale3d(1.15, .85, 1)
	}
	65% {
		-webkit-transform: scale3d(.95, 1.05, 1);
		transform: scale3d(.95, 1.05, 1)
	}
	75% {
		-webkit-transform: scale3d(1.05, .95, 1);
		transform: scale3d(1.05, .95, 1)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.rubberBand {
	-webkit-animation-name: rubberBand;
	animation-name: rubberBand
}

@-webkit-keyframes shake {
	0%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	20%,
	40%,
	60%,
	80% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
}

@keyframes shake {
	0%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	10%,
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	20%,
	40%,
	60%,
	80% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
}

.shake {
	-webkit-animation-name: shake;
	animation-name: shake
}

@-webkit-keyframes headShake {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
	6.5% {
		-webkit-transform: translateX(-6px) rotateY(-9deg);
		transform: translateX(-6px) rotateY(-9deg)
	}
	18.5% {
		-webkit-transform: translateX(5px) rotateY(7deg);
		transform: translateX(5px) rotateY(7deg)
	}
	31.5% {
		-webkit-transform: translateX(-3px) rotateY(-5deg);
		transform: translateX(-3px) rotateY(-5deg)
	}
	43.5% {
		-webkit-transform: translateX(2px) rotateY(3deg);
		transform: translateX(2px) rotateY(3deg)
	}
	50% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

@keyframes headShake {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
	6.5% {
		-webkit-transform: translateX(-6px) rotateY(-9deg);
		transform: translateX(-6px) rotateY(-9deg)
	}
	18.5% {
		-webkit-transform: translateX(5px) rotateY(7deg);
		transform: translateX(5px) rotateY(7deg)
	}
	31.5% {
		-webkit-transform: translateX(-3px) rotateY(-5deg);
		transform: translateX(-3px) rotateY(-5deg)
	}
	43.5% {
		-webkit-transform: translateX(2px) rotateY(3deg);
		transform: translateX(2px) rotateY(3deg)
	}
	50% {
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

.headShake {
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out;
	-webkit-animation-name: headShake;
	animation-name: headShake
}

@-webkit-keyframes swing {
	20% {
		-webkit-transform: rotate(15deg);
		transform: rotate(15deg)
	}
	40% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	60% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg)
	}
	80% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg)
	}
	to {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg)
	}
}

@keyframes swing {
	20% {
		-webkit-transform: rotate(15deg);
		transform: rotate(15deg)
	}
	40% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	60% {
		-webkit-transform: rotate(5deg);
		transform: rotate(5deg)
	}
	80% {
		-webkit-transform: rotate(-5deg);
		transform: rotate(-5deg)
	}
	to {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg)
	}
}

.swing {
	-webkit-transform-origin: top center;
	transform-origin: top center;
	-webkit-animation-name: swing;
	animation-name: swing
}

@-webkit-keyframes tada {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	10%,
	20% {
		-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
		transform: scale3d(.9, .9, .9) rotate(-3deg)
	}
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
	}
	40%,
	60%,
	80% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes tada {
	0% {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
	10%,
	20% {
		-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
		transform: scale3d(.9, .9, .9) rotate(-3deg)
	}
	30%,
	50%,
	70%,
	90% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
	}
	40%,
	60%,
	80% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
		transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
	}
	to {
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.tada {
	-webkit-animation-name: tada;
	animation-name: tada
}

@-webkit-keyframes wobble {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	15% {
		-webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
		transform: translate3d(-25%, 0, 0) rotate(-5deg)
	}
	30% {
		-webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
		transform: translate3d(20%, 0, 0) rotate(3deg)
	}
	45% {
		-webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
		transform: translate3d(-15%, 0, 0) rotate(-3deg)
	}
	60% {
		-webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
		transform: translate3d(10%, 0, 0) rotate(2deg)
	}
	75% {
		-webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
		transform: translate3d(-5%, 0, 0) rotate(-1deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes wobble {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	15% {
		-webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
		transform: translate3d(-25%, 0, 0) rotate(-5deg)
	}
	30% {
		-webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
		transform: translate3d(20%, 0, 0) rotate(3deg)
	}
	45% {
		-webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
		transform: translate3d(-15%, 0, 0) rotate(-3deg)
	}
	60% {
		-webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
		transform: translate3d(10%, 0, 0) rotate(2deg)
	}
	75% {
		-webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
		transform: translate3d(-5%, 0, 0) rotate(-1deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.wobble {
	-webkit-animation-name: wobble;
	animation-name: wobble
}

@-webkit-keyframes jello {
	0%,
	11.1%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	22.2% {
		-webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
		transform: skewX(-12.5deg) skewY(-12.5deg)
	}
	33.3% {
		-webkit-transform: skewX(6.25deg) skewY(6.25deg);
		transform: skewX(6.25deg) skewY(6.25deg)
	}
	44.4% {
		-webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
		transform: skewX(-3.125deg) skewY(-3.125deg)
	}
	55.5% {
		-webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
		transform: skewX(1.5625deg) skewY(1.5625deg)
	}
	66.6% {
		-webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
		transform: skewX(-.78125deg) skewY(-.78125deg)
	}
	77.7% {
		-webkit-transform: skewX(.390625deg) skewY(.390625deg);
		transform: skewX(.390625deg) skewY(.390625deg)
	}
	88.8% {
		-webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
		transform: skewX(-.1953125deg) skewY(-.1953125deg)
	}
}

@keyframes jello {
	0%,
	11.1%,
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	22.2% {
		-webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
		transform: skewX(-12.5deg) skewY(-12.5deg)
	}
	33.3% {
		-webkit-transform: skewX(6.25deg) skewY(6.25deg);
		transform: skewX(6.25deg) skewY(6.25deg)
	}
	44.4% {
		-webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
		transform: skewX(-3.125deg) skewY(-3.125deg)
	}
	55.5% {
		-webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
		transform: skewX(1.5625deg) skewY(1.5625deg)
	}
	66.6% {
		-webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
		transform: skewX(-.78125deg) skewY(-.78125deg)
	}
	77.7% {
		-webkit-transform: skewX(.390625deg) skewY(.390625deg);
		transform: skewX(.390625deg) skewY(.390625deg)
	}
	88.8% {
		-webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
		transform: skewX(-.1953125deg) skewY(-.1953125deg)
	}
}

.jello {
	-webkit-animation-name: jello;
	animation-name: jello;
	-webkit-transform-origin: center;
	transform-origin: center
}

@-webkit-keyframes heartBeat {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	14% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	28% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	42% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	70% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes heartBeat {
	0% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	14% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	28% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
	42% {
		-webkit-transform: scale(1.3);
		transform: scale(1.3)
	}
	70% {
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

.heartBeat {
	-webkit-animation-name: heartBeat;
	animation-name: heartBeat;
	-webkit-animation-duration: 1.3s;
	animation-duration: 1.3s;
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out
}

@-webkit-keyframes bounceIn {
	0%,
	20%,
	40%,
	60%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03)
	}
	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97)
	}
	to {
		opacity: 1;
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

@keyframes bounceIn {
	0%,
	20%,
	40%,
	60%,
	80%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03)
	}
	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97)
	}
	to {
		opacity: 1;
		-webkit-transform: scaleX(1);
		transform: scaleX(1)
	}
}

.bounceIn {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: bounceIn;
	animation-name: bounceIn
}

@-webkit-keyframes bounceInDown {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -3000px, 0);
		transform: translate3d(0, -3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, 25px, 0);
		transform: translate3d(0, 25px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, 5px, 0);
		transform: translate3d(0, 5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInDown {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -3000px, 0);
		transform: translate3d(0, -3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, 25px, 0);
		transform: translate3d(0, 25px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, 5px, 0);
		transform: translate3d(0, 5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInDown {
	-webkit-animation-name: bounceInDown;
	animation-name: bounceInDown
}

@-webkit-keyframes bounceInLeft {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-3000px, 0, 0);
		transform: translate3d(-3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(25px, 0, 0);
		transform: translate3d(25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(5px, 0, 0);
		transform: translate3d(5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInLeft {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-3000px, 0, 0);
		transform: translate3d(-3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(25px, 0, 0);
		transform: translate3d(25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(-10px, 0, 0);
		transform: translate3d(-10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(5px, 0, 0);
		transform: translate3d(5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInLeft {
	-webkit-animation-name: bounceInLeft;
	animation-name: bounceInLeft
}

@-webkit-keyframes bounceInRight {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(3000px, 0, 0);
		transform: translate3d(3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(-25px, 0, 0);
		transform: translate3d(-25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(-5px, 0, 0);
		transform: translate3d(-5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInRight {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(3000px, 0, 0);
		transform: translate3d(3000px, 0, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(-25px, 0, 0);
		transform: translate3d(-25px, 0, 0)
	}
	75% {
		-webkit-transform: translate3d(10px, 0, 0);
		transform: translate3d(10px, 0, 0)
	}
	90% {
		-webkit-transform: translate3d(-5px, 0, 0);
		transform: translate3d(-5px, 0, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInRight {
	-webkit-animation-name: bounceInRight;
	animation-name: bounceInRight
}

@-webkit-keyframes bounceInUp {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 3000px, 0);
		transform: translate3d(0, 3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -5px, 0);
		transform: translate3d(0, -5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes bounceInUp {
	0%,
	60%,
	75%,
	90%,
	to {
		-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
		animation-timing-function: cubic-bezier(.215, .61, .355, 1)
	}
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 3000px, 0);
		transform: translate3d(0, 3000px, 0)
	}
	60% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	75% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	90% {
		-webkit-transform: translate3d(0, -5px, 0);
		transform: translate3d(0, -5px, 0)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.bounceInUp {
	-webkit-animation-name: bounceInUp;
	animation-name: bounceInUp
}

@-webkit-keyframes bounceOut {
	20% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	50%,
	55% {
		opacity: 1;
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
}

@keyframes bounceOut {
	20% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9)
	}
	50%,
	55% {
		opacity: 1;
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
}

.bounceOut {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: bounceOut;
	animation-name: bounceOut
}

@-webkit-keyframes bounceOutDown {
	20% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

@keyframes bounceOutDown {
	20% {
		-webkit-transform: translate3d(0, 10px, 0);
		transform: translate3d(0, 10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, -20px, 0);
		transform: translate3d(0, -20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

.bounceOutDown {
	-webkit-animation-name: bounceOutDown;
	animation-name: bounceOutDown
}

@-webkit-keyframes bounceOutLeft {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(20px, 0, 0);
		transform: translate3d(20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

@keyframes bounceOutLeft {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(20px, 0, 0);
		transform: translate3d(20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

.bounceOutLeft {
	-webkit-animation-name: bounceOutLeft;
	animation-name: bounceOutLeft
}

@-webkit-keyframes bounceOutRight {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(-20px, 0, 0);
		transform: translate3d(-20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

@keyframes bounceOutRight {
	20% {
		opacity: 1;
		-webkit-transform: translate3d(-20px, 0, 0);
		transform: translate3d(-20px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

.bounceOutRight {
	-webkit-animation-name: bounceOutRight;
	animation-name: bounceOutRight
}

@-webkit-keyframes bounceOutUp {
	20% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, 20px, 0);
		transform: translate3d(0, 20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

@keyframes bounceOutUp {
	20% {
		-webkit-transform: translate3d(0, -10px, 0);
		transform: translate3d(0, -10px, 0)
	}
	40%,
	45% {
		opacity: 1;
		-webkit-transform: translate3d(0, 20px, 0);
		transform: translate3d(0, 20px, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

.bounceOutUp {
	-webkit-animation-name: bounceOutUp;
	animation-name: bounceOutUp
}

@-webkit-keyframes fadeIn {
	0% {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

@keyframes fadeIn {
	0% {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

.fadeIn {
	-webkit-animation-name: fadeIn;
	animation-name: fadeIn
}

@-webkit-keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInDown {
	-webkit-animation-name: fadeInDown;
	animation-name: fadeInDown
}

@-webkit-keyframes fadeInDownBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInDownBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInDownBig {
	-webkit-animation-name: fadeInDownBig;
	animation-name: fadeInDownBig
}

@-webkit-keyframes fadeInLeft {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInLeft {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInLeft {
	-webkit-animation-name: fadeInLeft;
	animation-name: fadeInLeft
}

@-webkit-keyframes fadeInLeftBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInLeftBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInLeftBig {
	-webkit-animation-name: fadeInLeftBig;
	animation-name: fadeInLeftBig
}

@-webkit-keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInRight {
	-webkit-animation-name: fadeInRight;
	animation-name: fadeInRight
}

@-webkit-keyframes fadeInRightBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInRightBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInRightBig {
	-webkit-animation-name: fadeInRightBig;
	animation-name: fadeInRightBig
}

@-webkit-keyframes fadeInUp {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInUp {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInUp {
	-webkit-animation-name: fadeInUp;
	animation-name: fadeInUp
}

@-webkit-keyframes fadeInUpBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes fadeInUpBig {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.fadeInUpBig {
	-webkit-animation-name: fadeInUpBig;
	animation-name: fadeInUpBig
}

@-webkit-keyframes fadeOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0
	}
}

@keyframes fadeOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0
	}
}

.fadeOut {
	-webkit-animation-name: fadeOut;
	animation-name: fadeOut
}

@-webkit-keyframes fadeOutDown {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

@keyframes fadeOutDown {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

.fadeOutDown {
	-webkit-animation-name: fadeOutDown;
	animation-name: fadeOutDown
}

@-webkit-keyframes fadeOutDownBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

@keyframes fadeOutDownBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, 2000px, 0);
		transform: translate3d(0, 2000px, 0)
	}
}

.fadeOutDownBig {
	-webkit-animation-name: fadeOutDownBig;
	animation-name: fadeOutDownBig
}

@-webkit-keyframes fadeOutLeft {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

@keyframes fadeOutLeft {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

.fadeOutLeft {
	-webkit-animation-name: fadeOutLeft;
	animation-name: fadeOutLeft
}

@-webkit-keyframes fadeOutLeftBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

@keyframes fadeOutLeftBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(-2000px, 0, 0);
		transform: translate3d(-2000px, 0, 0)
	}
}

.fadeOutLeftBig {
	-webkit-animation-name: fadeOutLeftBig;
	animation-name: fadeOutLeftBig
}

@-webkit-keyframes fadeOutRight {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

@keyframes fadeOutRight {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

.fadeOutRight {
	-webkit-animation-name: fadeOutRight;
	animation-name: fadeOutRight
}

@-webkit-keyframes fadeOutRightBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

@keyframes fadeOutRightBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(2000px, 0, 0);
		transform: translate3d(2000px, 0, 0)
	}
}

.fadeOutRightBig {
	-webkit-animation-name: fadeOutRightBig;
	animation-name: fadeOutRightBig
}

@-webkit-keyframes fadeOutUp {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

@keyframes fadeOutUp {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

.fadeOutUp {
	-webkit-animation-name: fadeOutUp;
	animation-name: fadeOutUp
}

@-webkit-keyframes fadeOutUpBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

@keyframes fadeOutUpBig {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(0, -2000px, 0);
		transform: translate3d(0, -2000px, 0)
	}
}

.fadeOutUpBig {
	-webkit-animation-name: fadeOutUpBig;
	animation-name: fadeOutUpBig
}

@-webkit-keyframes flip {
	0% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	40% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	50% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	80% {
		-webkit-transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	to {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
}

@keyframes flip {
	0% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	40% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);
		-webkit-animation-timing-function: ease-out;
		animation-timing-function: ease-out
	}
	50% {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		transform: perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	80% {
		-webkit-transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scale3d(.95, .95, .95) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	to {
		-webkit-transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		transform: perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
}

.animated.flip {
	-webkit-backface-visibility: visible;
	backface-visibility: visible;
	-webkit-animation-name: flip;
	animation-name: flip
}

@-webkit-keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInX {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInX;
	animation-name: flipInX
}

@-webkit-keyframes flipInY {
	0% {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateY(-20deg);
		transform: perspective(400px) rotateY(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateY(10deg);
		transform: perspective(400px) rotateY(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateY(-5deg);
		transform: perspective(400px) rotateY(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInY {
	0% {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in;
		opacity: 0
	}
	40% {
		-webkit-transform: perspective(400px) rotateY(-20deg);
		transform: perspective(400px) rotateY(-20deg);
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}
	60% {
		-webkit-transform: perspective(400px) rotateY(10deg);
		transform: perspective(400px) rotateY(10deg);
		opacity: 1
	}
	80% {
		-webkit-transform: perspective(400px) rotateY(-5deg);
		transform: perspective(400px) rotateY(-5deg)
	}
	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInY {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInY;
	animation-name: flipInY
}

@-webkit-keyframes flipOutX {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}
}

@keyframes flipOutX {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}
}

.flipOutX {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-animation-name: flipOutX;
	animation-name: flipOutX;
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important
}

@-webkit-keyframes flipOutY {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateY(-15deg);
		transform: perspective(400px) rotateY(-15deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		opacity: 0
	}
}

@keyframes flipOutY {
	0% {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
	30% {
		-webkit-transform: perspective(400px) rotateY(-15deg);
		transform: perspective(400px) rotateY(-15deg);
		opacity: 1
	}
	to {
		-webkit-transform: perspective(400px) rotateY(90deg);
		transform: perspective(400px) rotateY(90deg);
		opacity: 0
	}
}

.flipOutY {
	-webkit-animation-duration: .75s;
	animation-duration: .75s;
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipOutY;
	animation-name: flipOutY
}

@-webkit-keyframes lightSpeedIn {
	0% {
		-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0
	}
	60% {
		-webkit-transform: skewX(20deg);
		transform: skewX(20deg);
		opacity: 1
	}
	80% {
		-webkit-transform: skewX(-5deg);
		transform: skewX(-5deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes lightSpeedIn {
	0% {
		-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
		transform: translate3d(100%, 0, 0) skewX(-30deg);
		opacity: 0
	}
	60% {
		-webkit-transform: skewX(20deg);
		transform: skewX(20deg);
		opacity: 1
	}
	80% {
		-webkit-transform: skewX(-5deg);
		transform: skewX(-5deg)
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.lightSpeedIn {
	-webkit-animation-name: lightSpeedIn;
	animation-name: lightSpeedIn;
	-webkit-animation-timing-function: ease-out;
	animation-timing-function: ease-out
}

@-webkit-keyframes lightSpeedOut {
	0% {
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
		transform: translate3d(100%, 0, 0) skewX(30deg);
		opacity: 0
	}
}

@keyframes lightSpeedOut {
	0% {
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
		transform: translate3d(100%, 0, 0) skewX(30deg);
		opacity: 0
	}
}

.lightSpeedOut {
	-webkit-animation-name: lightSpeedOut;
	animation-name: lightSpeedOut;
	-webkit-animation-timing-function: ease-in;
	animation-timing-function: ease-in
}

@-webkit-keyframes rotateIn {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(-200deg);
		transform: rotate(-200deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateIn {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(-200deg);
		transform: rotate(-200deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateIn {
	-webkit-animation-name: rotateIn;
	animation-name: rotateIn
}

@-webkit-keyframes rotateInDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInDownLeft {
	-webkit-animation-name: rotateInDownLeft;
	animation-name: rotateInDownLeft
}

@-webkit-keyframes rotateInDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInDownRight {
	-webkit-animation-name: rotateInDownRight;
	animation-name: rotateInDownRight
}

@-webkit-keyframes rotateInUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInUpLeft {
	-webkit-animation-name: rotateInUpLeft;
	animation-name: rotateInUpLeft
}

@-webkit-keyframes rotateInUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

@keyframes rotateInUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-90deg);
		transform: rotate(-90deg);
		opacity: 0
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		opacity: 1
	}
}

.rotateInUpRight {
	-webkit-animation-name: rotateInUpRight;
	animation-name: rotateInUpRight
}

@-webkit-keyframes rotateOut {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		opacity: 1
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(200deg);
		transform: rotate(200deg);
		opacity: 0
	}
}

@keyframes rotateOut {
	0% {
		-webkit-transform-origin: center;
		transform-origin: center;
		opacity: 1
	}
	to {
		-webkit-transform-origin: center;
		transform-origin: center;
		-webkit-transform: rotate(200deg);
		transform: rotate(200deg);
		opacity: 0
	}
}

.rotateOut {
	-webkit-animation-name: rotateOut;
	animation-name: rotateOut
}

@-webkit-keyframes rotateOutDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
}

@keyframes rotateOutDownLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		opacity: 0
	}
}

.rotateOutDownLeft {
	-webkit-animation-name: rotateOutDownLeft;
	animation-name: rotateOutDownLeft
}

@-webkit-keyframes rotateOutDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

@keyframes rotateOutDownRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

.rotateOutDownRight {
	-webkit-animation-name: rotateOutDownRight;
	animation-name: rotateOutDownRight
}

@-webkit-keyframes rotateOutUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

@keyframes rotateOutUpLeft {
	0% {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: left bottom;
		transform-origin: left bottom;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		opacity: 0
	}
}

.rotateOutUpLeft {
	-webkit-animation-name: rotateOutUpLeft;
	animation-name: rotateOutUpLeft
}

@-webkit-keyframes rotateOutUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
		opacity: 0
	}
}

@keyframes rotateOutUpRight {
	0% {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		opacity: 1
	}
	to {
		-webkit-transform-origin: right bottom;
		transform-origin: right bottom;
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
		opacity: 0
	}
}

.rotateOutUpRight {
	-webkit-animation-name: rotateOutUpRight;
	animation-name: rotateOutUpRight
}

@-webkit-keyframes hinge {
	0% {
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	20%,
	60% {
		-webkit-transform: rotate(80deg);
		transform: rotate(80deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	40%,
	80% {
		-webkit-transform: rotate(60deg);
		transform: rotate(60deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(0, 700px, 0);
		transform: translate3d(0, 700px, 0);
		opacity: 0
	}
}

@keyframes hinge {
	0% {
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	20%,
	60% {
		-webkit-transform: rotate(80deg);
		transform: rotate(80deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out
	}
	40%,
	80% {
		-webkit-transform: rotate(60deg);
		transform: rotate(60deg);
		-webkit-transform-origin: top left;
		transform-origin: top left;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
		opacity: 1
	}
	to {
		-webkit-transform: translate3d(0, 700px, 0);
		transform: translate3d(0, 700px, 0);
		opacity: 0
	}
}

.hinge {
	-webkit-animation-duration: 2s;
	animation-duration: 2s;
	-webkit-animation-name: hinge;
	animation-name: hinge
}

@-webkit-keyframes jackInTheBox {
	0% {
		opacity: 0;
		-webkit-transform: scale(.1) rotate(30deg);
		transform: scale(.1) rotate(30deg);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom
	}
	50% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	70% {
		-webkit-transform: rotate(3deg);
		transform: rotate(3deg)
	}
	to {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

@keyframes jackInTheBox {
	0% {
		opacity: 0;
		-webkit-transform: scale(.1) rotate(30deg);
		transform: scale(.1) rotate(30deg);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom
	}
	50% {
		-webkit-transform: rotate(-10deg);
		transform: rotate(-10deg)
	}
	70% {
		-webkit-transform: rotate(3deg);
		transform: rotate(3deg)
	}
	to {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1)
	}
}

.jackInTheBox {
	-webkit-animation-name: jackInTheBox;
	animation-name: jackInTheBox
}

@-webkit-keyframes rollIn {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
		transform: translate3d(-100%, 0, 0) rotate(-120deg)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes rollIn {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%, 0, 0) rotate(-120deg);
		transform: translate3d(-100%, 0, 0) rotate(-120deg)
	}
	to {
		opacity: 1;
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.rollIn {
	-webkit-animation-name: rollIn;
	animation-name: rollIn
}

@-webkit-keyframes rollOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
		transform: translate3d(100%, 0, 0) rotate(120deg)
	}
}

@keyframes rollOut {
	0% {
		opacity: 1
	}
	to {
		opacity: 0;
		-webkit-transform: translate3d(100%, 0, 0) rotate(120deg);
		transform: translate3d(100%, 0, 0) rotate(120deg)
	}
}

.rollOut {
	-webkit-animation-name: rollOut;
	animation-name: rollOut
}

@-webkit-keyframes zoomIn {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	50% {
		opacity: 1
	}
}

@keyframes zoomIn {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	50% {
		opacity: 1
	}
}

.zoomIn {
	-webkit-animation-name: zoomIn;
	animation-name: zoomIn
}

@-webkit-keyframes zoomInDown {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInDown {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInDown {
	-webkit-animation-name: zoomInDown;
	animation-name: zoomInDown
}

@-webkit-keyframes zoomInLeft {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInLeft {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInLeft {
	-webkit-animation-name: zoomInLeft;
	animation-name: zoomInLeft
}

@-webkit-keyframes zoomInRight {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInRight {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInRight {
	-webkit-animation-name: zoomInRight;
	animation-name: zoomInRight
}

@-webkit-keyframes zoomInUp {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomInUp {
	0% {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	60% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomInUp {
	-webkit-animation-name: zoomInUp;
	animation-name: zoomInUp
}

@-webkit-keyframes zoomOut {
	0% {
		opacity: 1
	}
	50% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	to {
		opacity: 0
	}
}

@keyframes zoomOut {
	0% {
		opacity: 1
	}
	50% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3)
	}
	to {
		opacity: 0
	}
}

.zoomOut {
	-webkit-animation-name: zoomOut;
	animation-name: zoomOut
}

@-webkit-keyframes zoomOutDown {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomOutDown {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomOutDown {
	-webkit-animation-name: zoomOutDown;
	animation-name: zoomOutDown
}

@-webkit-keyframes zoomOutLeft {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
		transform: scale(.1) translate3d(-2000px, 0, 0);
		-webkit-transform-origin: left center;
		transform-origin: left center
	}
}

@keyframes zoomOutLeft {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
		transform: scale(.1) translate3d(-2000px, 0, 0);
		-webkit-transform-origin: left center;
		transform-origin: left center
	}
}

.zoomOutLeft {
	-webkit-animation-name: zoomOutLeft;
	animation-name: zoomOutLeft
}

@-webkit-keyframes zoomOutRight {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(2000px, 0, 0);
		transform: scale(.1) translate3d(2000px, 0, 0);
		-webkit-transform-origin: right center;
		transform-origin: right center
	}
}

@keyframes zoomOutRight {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
		transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0)
	}
	to {
		opacity: 0;
		-webkit-transform: scale(.1) translate3d(2000px, 0, 0);
		transform: scale(.1) translate3d(2000px, 0, 0);
		-webkit-transform-origin: right center;
		transform-origin: right center
	}
}

.zoomOutRight {
	-webkit-animation-name: zoomOutRight;
	animation-name: zoomOutRight
}

@-webkit-keyframes zoomOutUp {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

@keyframes zoomOutUp {
	40% {
		opacity: 1;
		-webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(.55, .055, .675, .19);
		animation-timing-function: cubic-bezier(.55, .055, .675, .19)
	}
	to {
		opacity: 0;
		-webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
		-webkit-transform-origin: center bottom;
		transform-origin: center bottom;
		-webkit-animation-timing-function: cubic-bezier(.175, .885, .32, 1);
		animation-timing-function: cubic-bezier(.175, .885, .32, 1)
	}
}

.zoomOutUp {
	-webkit-animation-name: zoomOutUp;
	animation-name: zoomOutUp
}

@-webkit-keyframes slideInDown {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInDown {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInDown {
	-webkit-animation-name: slideInDown;
	animation-name: slideInDown
}

@-webkit-keyframes slideInLeft {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInLeft {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInLeft {
	-webkit-animation-name: slideInLeft;
	animation-name: slideInLeft
}

@-webkit-keyframes slideInRight {
	0% {
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInRight {
	0% {
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInRight {
	-webkit-animation-name: slideInRight;
	animation-name: slideInRight
}

@-webkit-keyframes slideInUp {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

@keyframes slideInUp {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
		visibility: visible
	}
	to {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
}

.slideInUp {
	-webkit-animation-name: slideInUp;
	animation-name: slideInUp
}

@-webkit-keyframes slideOutDown {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

@keyframes slideOutDown {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0)
	}
}

.slideOutDown {
	-webkit-animation-name: slideOutDown;
	animation-name: slideOutDown
}

@-webkit-keyframes slideOutLeft {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

@keyframes slideOutLeft {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0)
	}
}

.slideOutLeft {
	-webkit-animation-name: slideOutLeft;
	animation-name: slideOutLeft
}

@-webkit-keyframes slideOutRight {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

@keyframes slideOutRight {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(100%, 0, 0);
		transform: translate3d(100%, 0, 0)
	}
}

.slideOutRight {
	-webkit-animation-name: slideOutRight;
	animation-name: slideOutRight
}

@-webkit-keyframes slideOutUp {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

@keyframes slideOutUp {
	0% {
		-webkit-transform: translateZ(0);
		transform: translateZ(0)
	}
	to {
		visibility: hidden;
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0)
	}
}

.slideOutUp {
	-webkit-animation-name: slideOutUp;
	animation-name: slideOutUp
}

.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both
}

.animated.infinite {
	-webkit-animation-iteration-count: infinite;
	animation-iteration-count: infinite
}

.animated.delay-1s {
	-webkit-animation-delay: 1s;
	animation-delay: 1s
}

.animated.delay-2s {
	-webkit-animation-delay: 2s;
	animation-delay: 2s
}

.animated.delay-3s {
	-webkit-animation-delay: 3s;
	animation-delay: 3s
}

.animated.delay-4s {
	-webkit-animation-delay: 4s;
	animation-delay: 4s
}

.animated.delay-5s {
	-webkit-animation-delay: 5s;
	animation-delay: 5s
}

.animated.duration-0 {
	-webkit-animation-duration: 0ms;
	animation-duration: 0ms
}
.animated.duration-100 {
	-webkit-animation-duration: 100ms;
	animation-duration: 100ms
}
.animated.duration-200 {
	-webkit-animation-duration: 200ms;
	animation-duration: 200ms
}
.animated.duration-300 {
	-webkit-animation-duration: 300ms;
	animation-duration: 300ms
}
.animated.duration-400 {
	-webkit-animation-duration: 400ms;
	animation-duration: 400ms
}
.animated.duration-500 {
	-webkit-animation-duration: 500ms;
	animation-duration: 500ms
}

.animated.duration-600 {
	-webkit-animation-duration: 600ms;
	animation-duration: 600ms
}

.animated.duration-700 {
	-webkit-animation-duration: 700ms;
	animation-duration: 700ms
}

.animated.duration-800 {
	-webkit-animation-duration: 800ms;
	animation-duration: 800ms
}

.animated.duration-1000 {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
}

.animated.duration-2000 {
	-webkit-animation-duration: 2s;
	animation-duration: 2s;
}


.animated.duration-3000 {
	-webkit-animation-duration: 3s;
	animation-duration: 3s;
}

.animated.duration-4000 {
	-webkit-animation-duration: 4s;
	animation-duration: 4s;
}

.animated.duration-5000 {
	-webkit-animation-duration: 5s;
	animation-duration: 5s;
}


.animated.stop {
	-webkit-animation-duration: 0s;
	animation-duration: 0s
}

.animated.slow {
	-webkit-animation-duration: 2s;
	animation-duration: 2s
}

.animated.slower {
	-webkit-animation-duration: 3s;
	animation-duration: 3s
}
/*
@media (prefers-reduced-motion:reduce),
(print) {
	.animated {
		-webkit-animation-duration: 1ms!important;
		animation-duration: 1ms!important;
		-webkit-transition-duration: 1ms!important;
		transition-duration: 1ms!important;
		-webkit-animation-iteration-count: 1!important;
		animation-iteration-count: 1!important
	}
} */
`;

});

parcelRegister("jaff6", function(module, exports) {
"use strict";
var $df3ac6581e675956$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $df3ac6581e675956$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Animation = void 0;

var $5kDLo = parcelRequire("5kDLo");

var $6Njj8 = parcelRequire("6Njj8");
let $df3ac6581e675956$var$Animation = class Animation extends $5kDLo.Attribute {
    OnInit() {
        this.pushStylesToParent();
        this.modify();
    }
    OnDestroy() {
        this.element.classList.remove('animated', this.value);
        this.setStyles({
            animationDelay: null
        })(this.element);
    }
    OnUpdate() {
        this.modify();
    }
    OnUpdateAttribute() {
        this.modify();
    }
    modify() {
        this.element.classList.add('animated', this.value);
        this.setStyles({
            animationDelay: this.delay
        })(this.element);
    }
    pushStylesToParent() {
        var _a;
        const style = document.createElement('style');
        style.innerHTML = $6Njj8.Animations;
        const root = (_a = this.parent.shadowRoot) !== null && _a !== void 0 ? _a : this.parent;
        root.prepend(style);
    }
};
module.exports.Animation = $df3ac6581e675956$var$Animation;
$df3ac6581e675956$var$__decorate([
    (0, $5kDLo.Input)({
        observe: true
    }),
    $df3ac6581e675956$var$__metadata("design:type", String)
], $df3ac6581e675956$var$Animation.prototype, "delay", void 0);
module.exports.Animation = $df3ac6581e675956$var$Animation = $df3ac6581e675956$var$__decorate([
    (0, $5kDLo.Modifier)({
        selector: 'animated',
        registry () {
            return new $5kDLo.CustomAttributeRegistry(this);
        }
    })
], $df3ac6581e675956$var$Animation);

});

parcelRegister("hZjBw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("jh8ya", function(module, exports) {

$parcel$export(module.exports, "SuccessMagicLinkComponent", () => $ed9e78a1f2ae2cdc$export$26049b319cc70e60);

var $deWeK = parcelRequire("deWeK");

var $4TeKW = parcelRequire("4TeKW");

var $8kgMp = parcelRequire("8kgMp");
class $ed9e78a1f2ae2cdc$export$26049b319cc70e60 extends (0, $4TeKW.LitElement) {
}
(0, $deWeK.__decorate)([
    (0, $8kgMp.RouteParams)()
], $ed9e78a1f2ae2cdc$export$26049b319cc70e60.prototype, "params", void 0);
$ed9e78a1f2ae2cdc$export$26049b319cc70e60 = (0, $deWeK.__decorate)([
    (0, $4TeKW.Component)({
        selector: 'magic-link-success',
        template () {
            return (0, $4TeKW.html)`
      <div style=" margin-top: 140px;">
        <div style="text-align: center;">
          <p>Magic link was send to ${this.params.email}</p>
          <p>Please check your email</p>
        </div>
      </div>
    `;
        }
    })
], $ed9e78a1f2ae2cdc$export$26049b319cc70e60);

});

parcelRegister("etIhS", function(module, exports) {
module.exports = import("5KATP").then(()=>parcelRequire('5LAQM'));

});

parcelRegister("f5zfy", function(module, exports) {
module.exports = import("1YsrX").then(()=>parcelRequire('4NKYP'));

});

parcelRegister("aCPL8", function(module, exports) {
module.exports = import("3t2ep").then(()=>parcelRequire('2JE1r'));

});

parcelRegister("7o6LG", function(module, exports) {
module.exports = import("iaalP").then(()=>parcelRequire('4Rs6O'));

});

parcelRegister("7f9MX", function(module, exports) {
module.exports = import("29CCf").then(()=>parcelRequire('gAlVd'));

});

parcelRegister("7IlWR", function(module, exports) {
module.exports = import("jV9X5").then(()=>parcelRequire('fcYj4'));

});

parcelRegister("fWRpU", function(module, exports) {
module.exports = import("cYUGl").then(()=>parcelRequire('dvAly'));

});

parcelRegister("cJHQj", function(module, exports) {
module.exports = import("6ISsC").then(()=>parcelRequire('cXjhw'));

});

parcelRegister("cEgAf", function(module, exports) {
module.exports = Promise.all([
    import("dS2MF"),
    import("bxFXb")
]).then(()=>parcelRequire('hN0n6'));

});

parcelRegister("6ydSN", function(module, exports) {
module.exports = import("cqckF").then(()=>parcelRequire('j1F6P'));

});

parcelRegister("3WPCw", function(module, exports) {
module.exports = import("j56cF").then(()=>parcelRequire('iZ1uC'));

});

parcelRegister("9VDgZ", function(module, exports) {
module.exports = import("6d4iX").then(()=>parcelRequire('8IJ72'));

});



//# sourceMappingURL=app.module.877aad94.js.map
